"use strict";

CoreMhDatepickerV2Ctrl.$inject = ["$filter", "$scope"];
FormDataUtilsController.$inject = ["dateFilter"];
DownloadUtilsController.$inject = ["$filter"];
ContextualCallConfigCtrl.$inject = ["$scope"];
ContextualCallFormCtrl.$inject = ["$scope", "GroupUtils"];
ContextualCallListCtrl.$inject = ["$scope"];
ContextualCallEditorCtrl.$inject = ["$q", "$scope", "Feature", "FeatureUtils"];
ContextualCallRedirectCtrl.$inject = ["$filter", "$rootScope", "$stateParams", "Feature", "FeatureUtils"];
Controller.$inject = ["$rootScope", "$q", "$filter", "User", "GroupUtils", "MissionLetter", "MedFormsUtils", "MissionLetterTemplate"];
MedicalDbUtilsFactory.$inject = ["$q", "Medicaldb", "SiteVarsUtils"];
PatientNameCell.$inject = ["$rootScope", "$scope", "$timeout", "Alert", "alertUtils", "redirectUtils", "SiteVarsUtils"];
  docToValidateController.$inject = ["DocumentToValidate", "$filter", "$rootScope"];
drugSelectModalCtrl.$inject = ["$filter", "$window", "notify", "Medicaldb", "MedicalDbUtils", "SiteVarsUtils"];
highCostDrugIconCtrl.$inject = ["$filter"];
drugSelectorCtrl.$inject = ["$rootScope", "$uibModal", "MonographyModal"];
prescriptionIndicationSelectorCtrl.$inject = ["$q", "$scope", "MedicalDbUtils"];
HighCostDrugsUtilsFactory.$inject = ["$rootScope", "$uibModal", "Medicaldb"];
MonographyModalFactory.$inject = ["$rootScope", "$uibModal", "Medicaldb"];
PrescriptionDataMappersFactory.$inject = ["MedicalDbUtils"];
PunctualActivityRefusalConfirmationModalCtrl.$inject = ["$scope", "$uibModalInstance"];
taskPlannerTaskButtonController.$inject = ["$scope"];
PunctualActivityCareSelectorModalCtrl.$inject = ["$scope", "$uibModalInstance", "thesaurusCategories", "ThesaurusUtils"];
PunctualTaskValidationCtrl.$inject = ["$scope", "$filter", "$rootScope", "$uibModal", "$uibModalInstance", "user", "task", "ThesaurusUtils", "MissionLetter"];
PunctualActivityCreationCtrl.$inject = ["$rootScope", "$scope", "$uibModal", "$uibModalInstance", "sequences", "user", "MhConfig", "ThesaurusUtils"];
ThesaurusEntryCollapsableCtrl.$inject = ["$scope"];
hcdDrugsTableCtrl.$inject = ["$uibModal", "HighCostDrugApi", "HighCostDrugCache", "SortingService"];
hcdExportCsvRowTableCtrl.$inject = ["$filter", "$scope"];
hcdExportDrugsErrorHandlerCtrl.$inject = ["$filter"];
hcdExportDrugsModalCtrl.$inject = ["CSVUtils", "FichCompApi"];
hcdIndicatorsController.$inject = ["$scope"];
hcdMainCtrl.$inject = ["$filter", "$scope", "$state", "$timeout", "HighCostDrugsIndicators"];
hcdUpdateDrugsModalCtrl.$inject = ["$filter", "notify", "DownloadUtils", "HighCostDrugApi", "HighCostDrugsIndicators"];
FichCompApiFactory.$inject = ["$http", "$httpParamSerializer", "DownloadUtils"];
HighCostDrugApiFactory.$inject = ["$resource", "FormDataUtils", "HighCostDrugCache", "MhConfig"];
HighCostDrugCacheFactory.$inject = ["$cacheFactory"];
HighCostDrugsIndicatorsFactory.$inject = ["HighCostDrugApi"];
billingTaskCellController.$inject = ["$filter", "$scope"];
CSVUtilsController.$inject = ["DownloadUtils"];
 angular.module('config', [])

.constant('MhConfig', {package:{name:'mhclient',version:'0.0.0',dependencies:{'multiple-date-picker':'^2.0.2',ngclipboard:'^2.0.0','serve-index':'^1.8.0','serve-static':'^1.11.1'},repository:{},devDependencies:{'angular-moment':'~0.10.3',eventemitter3:'^0.1.6',grunt:'~1.0.1','grunt-autoprefixer':'^3.0.4','grunt-concurrent':'^2.3.1','grunt-connect-proxy':'~0.2.0','grunt-contrib-clean':'^1.0.0','grunt-contrib-coffee':'^1.0.0','grunt-contrib-concat':'^1.0.1','grunt-contrib-connect':'^1.0.2','grunt-contrib-copy':'^1.0.0','grunt-contrib-cssmin':'^1.0.2','grunt-contrib-htmlmin':'^2.0.0','grunt-contrib-imagemin':'^1.0.0','grunt-contrib-jshint':'^1.1.0','grunt-contrib-less':'^1.0.0','grunt-contrib-uglify':'^2.0.0','grunt-contrib-watch':'^1.0.0','grunt-filerev':'^2.1.2','grunt-google-cdn':'^0.4.3','grunt-karma':'^2.0.0','grunt-newer':'^1.1.0','grunt-ng-annotate':'^3.0.0','grunt-ng-constant':'~2.0.1','grunt-protractor-runner':'^4.0.0','grunt-svgmin':'^4.0.0','grunt-usemin':'^3.0.0','grunt-wiredep':'^3.0.1','http-backend-proxy':'^1.4.2','jshint-stylish':'^2.2.1',karma:'^1.4.0','karma-coffee-preprocessor':'~1.0.1','karma-jasmine':'~1.1.0','karma-junit-reporter':'^1.2.0','karma-ng-html2js-preprocessor':'^1.0.0','karma-ng-json2js-preprocessor':'^2.0.1','karma-phantomjs-launcher':'~1.0.2','load-grunt-tasks':'^3.1.0','protractor-http-mock':'^0.1.10','time-grunt':'^1.0.0'},engines:{node:'>=0.10.0'},scripts:{kiri:'grunt serve_mh_si --platform=mhsi',adock:'grunt serve_mh_si --platform=mhsi --proxy-host=172.17.0.9',sadock:'grunt serve_mh_si_no_concurrency --platform=mhsi --proxy-host=172.17.0.9',test:'grunt test'}},platform:'mhsi',baseAcceptHeader:'application/json; text/plain; */*',mode:'production'})

;
(function() {
  'use strict';

  /*
    * @ngdoc overview
    * @name mhclientApp
    * @description
    * # mhclientApp
    *
    * Main module of the application.
   */
  var appModule,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  moment.locale('fr');

  appModule = angular.module('mhclientApp', ['ngDragDrop', 'ngAnimate', 'ngCookies', 'ngResource', 'ngSanitize', 'ngTouch', 'ui.router', "ui.scroll", 'ui.bootstrap', "ui.router.tabs", 'pascalprecht.translate', 'config', 'cgNotify', 'ngStorage', 'ui.tree', 'ngFileUpload', 'omr.angularFileDnD', 'formly', 'formlyBootstrap', 'angular-flot', 'focus-if', 'rt.debounce', 'ngScrollbars', 'rzSlider', 'monospaced.elastic', "textAngular", "ngMessages", "angular-humanize-duration", "angularMoment", "infinite-scroll", "angular-virtual-keyboard", "angular-useragent-parser", "angularXRegExp", "ui.calendar", "ui.select", "ngAria", 'naturalSort', "multipleDatePicker", "wipImageZoom", "monospaced.elastic", "angular-bind-html-compile", "dndLists", "ui.sortable", "color.picker", "ngclipboard"], ["$rootScopeProvider", function($rootScopeProvider) {
    return $rootScopeProvider.digestTtl(20);
  }]);

  angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);

  appModule.run([
    "$rootScope", "$injector", "MhConfig", "$state", "$q", "$window", "formlyConfig", "formlyVersion", "taRegisterTool", "taTranslations", "alertUtils", "User", "MedFormsUtils", "FormTemplateUtils", "RzSliderOptions", function($rootScope, $injector, MhConfig, $state, $q, $window, formlyConfig, formlyVersion, taRegisterTool, taTranslations, alertUtils, User, MedFormsUtils, FormTemplateUtils, RzSliderOptions) {
      var isSameState, myCheck, returnState;
      $rootScope.mh_config = MhConfig;
      $state.statesStack = [];
      returnState = ["user.patient.stay.pread", "user.patient.stay.message.multi.tab", "user.patient.order.list", "user.patient.stay.agenda", "user.patient.stay.medication.current", "user.patient.stay.medication.cart", "user.multi.medication.cart"];
      RzSliderOptions.options({
        disableAnimation: true
      });
      $rootScope.stateBlocked = 0;
      if ($rootScope.mh_config.platform === "mgapp") {
        $window.go_to = function(state, args) {
          return $state.go(state, args);
        };
      }
      $rootScope.toggleShowAllStays = function(allStays) {
        var event;
        $rootScope.allStays = allStays;
        event = $rootScope.$broadcast('$toggleShowAllStays');
        if (event.togglePromises != null) {
          $rootScope.busy = true;
          if ($rootScope.mh_config.platform === "mgapp") {
            $window.mgapp.lock_menu(true);
          }
          return $q.all(event.togglePromises).then((function(data) {
            $rootScope.busy = false;
            if ($rootScope.mh_config.platform === "mgapp") {
              $window.mgapp.lock_menu(false);
            }
            return $state.reload("user.patient.stay");
          }), (function(e) {
            $rootScope.busy = false;
            $rootScope.allStays = !$rootScope.allStays;
            if ($rootScope.mh_config.platform === "mgapp") {
              $window.mgapp.lock_menu(false);
              return $window.mgapp.set_all_stays($rootScope.allStays);
            }
          }));
        } else {
          return $state.reload("user.patient.stay");
        }
      };
      if ($rootScope.mh_config.platform === "mgapp") {
        $window.toggleShowAllStays = $rootScope.toggleShowAllStays;
        $window.form_config_received = function() {
          FormTemplateUtils.resetCache();
          return MedFormsUtils.resetCache();
        };
      }
      isSameState = function(toState, toParams, stateString) {

        /*
        Checks whether the given UI-Router state and parameters match a target state reference.
        
        Parses a state reference string (which may include parameters) and compares it
        against the current `toState` and `toParams`. If the state names match and all
        provided parameters match as well, the function returns `true`.
        
        Args:
          toState (Object): The current UI-Router state object.
            - Must contain a `name` property with the state name.
          toParams (Object): The current state parameters.
          stateString (String): The target state reference string, e.g.:
            - "user.profile"
            - "user.profile({id: 123})"
            - "user.multi.message.hierarchic({'featureName': 'MHC_TRANSMISSION'})"
        
        Returns:
          Boolean: `true` if both the state name and parameters match, otherwise `false`.
        
        Example:
          isSameState(
            toState,
            toParams,
            "user.multi.message.hierarchic({'featureName': 'MHC_TRANSMISSION'})"
          )
           * => true if `toState.name` is "user.multi.message.hierarchic"
           *    and `toParams.featureName` equals "MHC_TRANSMISSION".
         */
        var matches, paramString, params, stateName;
        if (!stateString) {
          return false;
        }
        matches = stateString.match(/^([^\(]+)(\((.+)\))?$/);
        if (!matches) {
          return false;
        }
        stateName = matches[1];
        paramString = matches[3];
        if (toState.name !== stateName) {
          return false;
        }
        if (paramString == null) {
          return true;
        }
        params = {};
        paramString.replace(/^\{|\}$/g, '').split(',').forEach(function(pair) {
          var k, ref, v;
          ref = pair.split(':').map(function(s) {
            return s.trim().replace(/^['"]|['"]$/g, '');
          }), k = ref[0], v = ref[1];
          if ((k != null) && (v != null)) {
            return params[k] = v;
          }
        });
        return _.isMatch(toParams, params);
      };
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        if ($rootScope.busy || $rootScope.stateBlocked > 0) {
          return event.preventDefault();
        }
      });
      $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        var eventNames, feature, i, infoAlertIds, j, len, len1, params, ref, ref1, template, topFeature, viewedEvents, viewedInfoEvents;
        $rootScope.currentStateName = toState.name;
        if ($rootScope.currentStay) {
          if ($rootScope.currentStay.id === fromParams.idStay) {
            eventNames = _.map(_.filter($rootScope.alertTemplates || [], {
              route: fromState.name
            }), "event_name");
            viewedEvents = alertUtils.filterEvents($rootScope.patientNewEvents, $rootScope.currentStay.id, $rootScope.allStays, eventNames, fromParams);
            viewedInfoEvents = _.filter(viewedEvents, {
              "config": {
                "level": "INFO"
              }
            });
            if ($rootScope.menus.patient.groupedFeaturesByParent) {
              for (i = 0, len = viewedInfoEvents.length; i < len; i++) {
                event = viewedInfoEvents[i];
                template = _.find($rootScope.alertTemplates, {
                  event_name: event.config.event_name
                });
                ref = $rootScope.menus.patient.groupedFeaturesByParent;
                for (j = 0, len1 = ref.length; j < len1; j++) {
                  topFeature = ref[j];
                  feature = _.find(topFeature.childs, {
                    name: template.feature
                  });
                  if (feature) {
                    feature.alert_count -= 1;
                    topFeature.alert_count -= 1;
                    $rootScope.menus.patient.alertCount -= 1;
                    break;
                  }
                }
              }
            }
            $rootScope.patientNewEvents = _.differenceWith($rootScope.patientNewEvents, viewedInfoEvents);
          }
          if (toState.dontFilterEvents) {
            params = null;
            eventNames = null;
          } else {
            eventNames = _.map(_.filter($rootScope.alertTemplates || [], {
              route: toState.name
            }), "event_name");
            params = toParams;
          }
          $rootScope.stateEvents = alertUtils.filterEvents($rootScope.patientNewEvents, $rootScope.currentStay.id, $rootScope.allStays, eventNames, params);
          if (!toState.dontFilterEvents) {
            infoAlertIds = _.map(_.filter($rootScope.stateEvents, {
              "config": {
                "level": "INFO"
              }
            }), "id");
            if (infoAlertIds.length > 0) {
              User.confirmNotification({
                id: $rootScope.user.id
              }, {
                alerts: infoAlertIds
              });
            }
          }
          if (!toState.dontFilterEvents) {
            eventNames = _.map(_.filter($rootScope.alertTemplates || [], {
              route: toState.alertsExtraRoute
            }), "event_name");
            $rootScope.stateEvents = $rootScope.stateEvents.concat(alertUtils.filterEvents($rootScope.patientNewEvents, $rootScope.currentStay.id, $rootScope.allStays, eventNames));
          }
          $rootScope.formatedEvents = alertUtils.formatEvents($rootScope.stateEvents, $rootScope.currentStay, $rootScope.allStays);
        } else {
          $rootScope.stateEvents = [];
          $rootScope.formatedEvents = {};
        }
        $state.previous = null;
        if (ref1 = fromState.name, indexOf.call(returnState, ref1) >= 0) {
          $state.previous = fromState;
          $state.previous.toParams = toParams;
          $state.previous.fromParams = fromParams;
          $state.statesStack = $state.statesStack.filter(function(oldState) {
            var ref2;
            return ref2 = oldState.name, indexOf.call(returnState, ref2) < 0;
          });
        }
        document.title = _.uniq(_.compact(_.map($state.$current.path, function(path) {
          feature = _.find(($rootScope.user && $rootScope.user.userFeatures) || [], function(feature) {
            return (path.self.data && path.self.data.linkedFeature && path.self.data.linkedFeature === feature.name) || isSameState(path, toParams, feature.metadata.route);
          });
          if (feature) {
            return feature.label;
          } else {
            return path.self.data && path.self.data.title && $injector.invoke(path.self.data.title, null, $state.$current.locals.globals);
          }
        }))).join(" ");
        if (MhConfig.platform === 'mgapp') {
          window.mgapp.change_state(toState.name);
        }
        return $rootScope.busy = false;
      });
      taRegisterTool('bold-bs', {
        iconclass: 'glyphicon glyphicon-bold',
        tooltiptext: taTranslations.bold.tooltip,
        action: function() {
          return this.$editor().wrapSelection("bold", null);
        },
        activeState: function() {
          return this.$editor().queryCommandState('bold');
        },
        commandKeyCode: 98
      });
      taRegisterTool('italics-bs', {
        iconclass: 'glyphicon glyphicon-italic',
        tooltiptext: taTranslations.italic.tooltip,
        action: function() {
          return this.$editor().wrapSelection("italic", null);
        },
        activeState: function() {
          return this.$editor().queryCommandState('italic');
        },
        commandKeyCode: 105
      });
      taRegisterTool('underline-bs', {
        iconclass: 'glyphicon glyphicon-text-color',
        tooltiptext: taTranslations.underline.tooltip,
        action: function() {
          return this.$editor().wrapSelection("underline", null);
        },
        activeState: function() {
          return this.$editor().queryCommandState('underline');
        },
        commandKeyCode: 117
      });
      taRegisterTool('ul-bs', {
        iconclass: 'glyphicon glyphicon-list',
        tooltiptext: taTranslations.ul.tooltip,
        action: function() {
          return this.$editor().wrapSelection("insertUnorderedList", null);
        },
        activeState: function() {
          return this.$editor().queryCommandState('insertUnorderedList');
        }
      });
      myCheck = window.apiCheck({
        output: {
          prefix: 'my check'
        }
      });
      formlyConfig.extras.ngModelAttrsManipulatorPreferBound = true;
      formlyConfig.defaultHideDirective = 'ng-show';
      formlyConfig.extras.defaultHideDirective = 'ng-show';
      formlyConfig.setWrapper({
        name: 'horizontalBootstrapLabel',
        templateUrl: 'configtool/views/horizontalBootstrapLabel.html'
      });
      formlyConfig.setWrapper({
        name: 'horizontalBootstrapTextarea',
        templateUrl: 'configtool/views/horizontalBootstrapTextarea.html'
      });
      formlyConfig.setWrapper({
        name: 'horizontalBootstrapRadio',
        templateUrl: 'configtool/views/horizontalBootstrapRadio.html'
      });
      formlyConfig.setWrapper({
        name: 'horizontalBootstrapCheckbox',
        templateUrl: 'configtool/views/horizontalBootstrapCheckbox.html'
      });
      formlyConfig.setWrapper({
        name: 'legendBeforeField',
        templateUrl: 'configtool/views/legendBeforeField.html'
      });
      formlyConfig.setType({
        name: 'horizontalInput',
        "extends": 'input',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
      });
      formlyConfig.setType({
        name: 'horizontalSelect',
        "extends": 'select',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
      });
      formlyConfig.setType({
        name: 'horizontalCheckbox',
        "extends": 'checkbox',
        wrapper: ['horizontalBootstrapCheckbox', 'bootstrapHasError']
      });
      formlyConfig.setType({
        name: 'horizontalRadio',
        "extends": 'radio',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
      });
      formlyConfig.setType({
        name: 'horizontalTextarea',
        "extends": 'textarea',
        wrapper: ['horizontalBootstrapTextarea', 'bootstrapHasError']
      });
      formlyConfig.setType({
        name: 'horizontalInputWithLegend',
        "extends": 'input',
        wrapper: ['horizontalBootstrapLabel', 'legendBeforeField', 'bootstrapHasError']
      });
      formlyConfig.setType({
        name: 'horizontalCheckboxWithLegend',
        "extends": 'checkbox',
        wrapper: ['horizontalBootstrapCheckbox', 'legendBeforeField', 'bootstrapHasError']
      });
      formlyConfig.setType({
        name: 'horizontalSelectWithLegend',
        "extends": 'select',
        wrapper: ['horizontalBootstrapLabel', 'legendBeforeField', 'bootstrapHasError']
      });
      formlyConfig.setType({
        name: 'horizontalRadioWithLegend',
        "extends": 'radio',
        wrapper: ['horizontalBootstrapLabel', 'legendBeforeField', 'bootstrapHasError']
      });
      return formlyConfig.setType({
        name: 'horizontalTextareaWithLegend',
        "extends": 'textarea',
        wrapper: ['horizontalBootstrapTextarea', 'legendBeforeField', 'bootstrapHasError']
      });
    }
  ]);

  appModule.config([
    "$urlRouterProvider", "$stateProvider", "$httpProvider", "MhConfig", '$translateProvider', '$translatePartialLoaderProvider', "$provide", "$injector", "$compileProvider", "ScrollBarsProvider", "wipImageZoomConfigProvider", "VKI_CONFIG", function($urlRouterProvider, $stateProvider, $httpProvider, MhConfig, $translateProvider, $translatePartialLoaderProvider, $provide, $injector, $compileProvider, ScrollBarsProvider, wipImageZoomConfigProvider, VKI_CONFIG) {
      wipImageZoomConfigProvider.setDefaults({
        lens: false
      });
      VKI_CONFIG.layout['Fran\u00e7ais'] = {
        'name': "French",
        'keys': [[["\u00b2", "\u00b3"], ["&", "1"], ["\u00e9", "2", "~"], ['"', "3", "#"], ["'", "4", "{"], ["(", "5", "["], ["-", "6", "|"], ["\u00e8", "7", "`"], ["_", "8", "\\"], ["\u00e7", "9", "^"], ["\u00e0", "0", "@"], [")", "\u00b0", "]"], ["=", "+", "}"], ["Effacer", "Bksp"]], [["Tab", "Tab"], ["a", "A"], ["z", "Z"], ["e", "E", "\u20ac"], ["r", "R"], ["t", "T"], ["y", "Y"], ["u", "U"], ["i", "I"], ["o", "O"], ["p", "P"], ["^", "\u00a8"], ["$", "\u00a3", "\u00a4"], ["*", "\u03bc"]], [["Caps", "Caps"], ["q", "Q"], ["s", "S"], ["d", "D"], ["f", "F"], ["g", "G"], ["h", "H"], ["j", "J"], ["k", "K"], ["l", "L"], ["m", "M"], ["\u00f9", "%"], ["Entrée", "Enter"]], [["Shift", "Shift"], ["<", ">"], ["w", "W"], ["x", "X"], ["c", "C"], ["v", "V"], ["b", "B"], ["n", "N"], [",", "?"], [";", "."], [":", "/"], ["!", "\u00a7"], ["Shift", "Shift"]], [[" ", " ", " ", " "], ["AltGr", "AltGr"]]],
        'lang': ["fr"]
      };
      VKI_CONFIG.kt = "Fran\u00e7ais";
      VKI_CONFIG.size = 5;
      ScrollBarsProvider.defaults = {
        axis: 'y',
        theme: 'minimal',
        autoHideScrollbar: true,
        scrollInertia: 400,
        scrollButtons: {
          scrollAmount: 'auto',
          enable: true
        },
        advanced: {
          updateOnContentResize: true
        },
        setTop: 0,
        setHeight: '78%'
      };
      $translateProvider.useLoader('$translatePartialLoader', {
        urlTemplate: '{part}/i18n/{lang}.json'
      });
      $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
      $translatePartialLoaderProvider.addPart('core');
      $translatePartialLoaderProvider.addPart('sequences');
      $translatePartialLoaderProvider.addPart('user');
      $translatePartialLoaderProvider.addPart('dashboard');
      $translatePartialLoaderProvider.addPart('patient');
      $translatePartialLoaderProvider.addPart('admin');
      $translatePartialLoaderProvider.addPart('mhbox');
      $translatePartialLoaderProvider.addPart("medplan");
      $translatePartialLoaderProvider.addPart("pwdtk");
      $translatePartialLoaderProvider.addPart("medforms");
      $translatePartialLoaderProvider.addPart("customer");
      $translatePartialLoaderProvider.addPart("menu");
      $translatePartialLoaderProvider.addPart("mh_device");
      $translatePartialLoaderProvider.addPart("site");
      $translatePartialLoaderProvider.addPart("notification_center");
      $translatePartialLoaderProvider.addPart("medication");
      $translatePartialLoaderProvider.addPart("stay");
      $translatePartialLoaderProvider.addPart("catalog");
      $translatePartialLoaderProvider.addPart("thesaurus");
      $translatePartialLoaderProvider.addPart("message");
      $translatePartialLoaderProvider.addPart("equipment");
      $translatePartialLoaderProvider.addPart("export_pdf");
      $translatePartialLoaderProvider.addPart("stock");
      $translatePartialLoaderProvider.addPart("staff");
      $translatePartialLoaderProvider.addPart("taskplanner");
      $translatePartialLoaderProvider.addPart("agenda");
      $translatePartialLoaderProvider.addPart("preadmission");
      $translatePartialLoaderProvider.addPart("order");
      $translatePartialLoaderProvider.addPart("configtool");
      $translatePartialLoaderProvider.addPart("docviewer");
      $translatePartialLoaderProvider.addPart("stats");
      $translatePartialLoaderProvider.addPart("work-reports");
      $translatePartialLoaderProvider.addPart("medicaldb");
      $translatePartialLoaderProvider.addPart("transmissions");
      $translatePartialLoaderProvider.addPart("photo");
      $translatePartialLoaderProvider.addPart("psp");
      $translatePartialLoaderProvider.addPart("posos");
      $translatePartialLoaderProvider.addPart("therapeutic-programs");
      $translatePartialLoaderProvider.addPart("summary");
      $translatePartialLoaderProvider.addPart("pharmaceutical-analysis");
      $translatePartialLoaderProvider.addPart("support");
      $translatePartialLoaderProvider.addPart("high-cost-drugs");
      $translatePartialLoaderProvider.addPart("cda_documents");
      $translatePartialLoaderProvider.addPart("external_sync");
      $translatePartialLoaderProvider.addPart("billing");
      $translatePartialLoaderProvider.addPart("miniged");
      $translatePartialLoaderProvider.addPart("conflict");
      $translatePartialLoaderProvider.addPart("mission-letter");
      $translatePartialLoaderProvider.addPart("interface-interop");
      $translateProvider.preferredLanguage('fr');
      $provide.decorator("$exceptionHandler", ["$delegate", "$injector", function($delegate, $injector) {
        return function(exception, cause) {
          var exceptionLogging, notify, translate;
          if (exception.message.split(',')[0] !== 'Invalid dimensions for plot') {
            notify = $injector.get('notify');
            exceptionLogging = $injector.get('exceptionLogging');
            $delegate(exception, cause);
            exceptionLogging.send(exception, cause);
            translate = $injector.get("$filter")('translate');
            return notify({
              classes: ["alert-danger"],
              message: translate("GENERAL_ERROR_MSG")
            });
          }
        };
      }]);
      $provide.decorator('taOptions', [
        '$uibModal', 'taRegisterTool', '$delegate', function($uibModal, taRegisterTool, taOptions) {
          taRegisterTool('selectChoice', {
            buttontext: '${',
            action: function(deferred, restoreSelection) {
              var editor, modalInstance;
              editor = this;
              modalInstance = $uibModal.open({
                templateUrl: 'customer/medforms/views/select-choice-modal.html',
                controller: 'SelectChoiceModalCtrl',
                resolve: {
                  options: function() {
                    return editor.$parent.$parent.choices;
                  }
                },
                windowClass: 'nestedModal',
                animation: false
              });
              modalInstance.result.then(function(selectedChoice) {
                restoreSelection();
                editor.$editor().wrapSelection('insertHtml', "${" + selectedChoice + "}");
                return deferred.resolve();
              });
              return false;
            }
          });
          return taOptions;
        }
      ]);
      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|blob|chrome-extension|data|local):/);
      $compileProvider.debugInfoEnabled(!!window.__karma__);

      /*
      Requests configuration
       */
      $httpProvider.interceptors.push('AllInterceptors');
      $httpProvider.defaults.xsrfCookieName = 'csrftoken';
      $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

      /*
      Routes
       */
      $urlRouterProvider.otherwise(function($injector) {
        var $state, User;
        $state = $injector.get('$state');
        User = $injector.get('User');
        User.getConnectedUser().$promise.then(function(user) {
          if (user) {
            return $state.go('user.stay-list', {});
          } else {
            return $state.go('login', {});
          }
        });
        return true;
      });
      return $stateProvider.state("login", {
        url: "/login?next",
        controller: ["$rootScope", "$scope", "$location", "$http", "$state", "$stateParams", "User", "$uibModal", "$q", function($rootScope, $scope, $location, $http, $state, $stateParams, User, $uibModal, $q) {
          $rootScope.busy = true;
          $scope.loginDone = function() {
            if ($stateParams.next) {
              return $location.path(decodeURIComponent($stateParams.next));
            } else {
              return $state.go('user.stay-list');
            }
          };
          return User.getConnectedUser().$promise.then(function(user) {
            $rootScope.busy = false;
            $scope.loginDone();
            return $state.go('user.stay-list', {});
          }, function(error) {
            return $http.get("/ajax_site/").then(function(response) {
              $scope.logo = response.data.logo;
              $scope.siteName = response.data.name;
              $scope.publicSettings = response.data.public_settings || {};
              $scope.initDone = true;
              return $rootScope.busy = false;
            });
          });
        }],
        template: "<span class='login-page' ng-if='::initDone'> <div class='background'> <img class='login-bg' onerror=\"this.style.display = 'none'\" src='/st/mh/static/back.png' alt=' '> </div> <div class='padding-top-15 text-center'> <img class='img-logo' onerror=\"this.style.display = 'none'\" ng-src='{{::logo}}'/> </div> <div class='padding-top-15 text-center'> <span class='site-name'>{{ 'MHCare Server' | translate}} {{::siteName}}</span> </div> <login public-settings='publicSettings' callback='loginDone()'></login> </span>"
      }).state("default", {
        url: "/",
        template: "<ui-view/>"
      }).state("empty_box", {
        url: "/empty_box",
        templateUrl: "patient/views/empty_box.html"
      }).state("mhbox-login", {
        url: "/mhbox-login",
        templateUrl: "mhbox/views/login.html",
        controller: "MHBoxLogin"
      }).state("login-blocked", {
        url: "/login-lockout?lockout_time?fail_time?username?failed_logins?next",
        templateUrl: "pwdtk/views/login-blocked.html",
        controller: "LoginBlockedCtrl"
      }).state("menu", {
        url: "/menu",
        templateUrl: "menu/views/user_menu.html",
        controller: "MenuCtrl"
      }).state("visio", {
        url: "/visio?ipp?token?urgent",
        templateUrl: "visio/views/visio-box-view.html",
        controller: "BoxVisioCtrl"
      }).state("user", {
        url: "/user",
        templateUrl: "core/views/main.html",
        controller: "MainCtrl",
        resolve: {
          user: [
            'User', '$stateParams', function(User, $stateParams) {
              return User.getConnectedUser().$promise;
            }
          ],
          userFeatures: [
            'User', function(User) {
              return User.getConnectedUserFeatures().$promise;
            }
          ],
          alertConfigs: [
            'alertUtils', function(alertUtils) {
              return alertUtils.getAlertConfigs();
            }
          ],
          alertCategories: [
            'alertUtils', function(alertUtils) {
              return alertUtils.getAlertCategories();
            }
          ],
          alertTemplates: [
            'alertUtils', function(alertUtils) {
              return alertUtils.getEventTemplates();
            }
          ],
          showAllStaysData: [
            'SiteVarsUtils', function(SiteVarsUtils) {
              return SiteVarsUtils.showAllStaysData();
            }
          ],
          defaultMenu: [
            'SiteVarsUtils', function(SiteVarsUtils) {
              return SiteVarsUtils.getDefaultMenu();
            }
          ]
        },
        onEnter: ["$rootScope", "showAllStaysData", "alertConfigs", "alertCategories", "alertTemplates", "user", "userFeatures", "defaultMenu", "MenuUtils", function($rootScope, showAllStaysData, alertConfigs, alertCategories, alertTemplates, user, userFeatures, defaultMenu, MenuUtils) {
          var alertConfig, i, len, patientShortCuts, ref, userShortCuts;
          $rootScope.allStays = showAllStaysData;
          $rootScope.user = user;
          patientShortCuts = ["CUSTOM_STAY_LIST", "CUSTOM_ADM"];
          userShortCuts = ["CUSTOM_STAY_LIST", "CUSTOM_ADM"];
          userShortCuts = userShortCuts.concat(_.map(MenuUtils.getDefaultUserShortCuts(userFeatures), 'name'));
          if (user.config == null) {
            user.config = {
              menu_type: defaultMenu,
              patient_shortcuts: patientShortCuts,
              user_shorcuts: userShortCuts
            };
          } else {
            if (user.config.menu_type == null) {
              user.config.menu_type = defaultMenu;
              user.config.patient_shortcuts = patientShortCuts;
              user.config.user_shortcuts = userShortCuts;
            }
          }
          $rootScope.alertTemplates = alertTemplates;
          $rootScope.alertConfigs = _.filter(alertConfigs, function(alertConfig) {
            var ref;
            return ref = user.group.id, indexOf.call(alertConfig.groups, ref) >= 0;
          });
          $rootScope.alertCategories = _.filter(alertCategories, function(alertCategory) {
            return _.some($rootScope.alertConfigs, function(config) {
              return config.category === alertCategory.id;
            });
          });
          ref = $rootScope.alertConfigs;
          for (i = 0, len = ref.length; i < len; i++) {
            alertConfig = ref[i];
            alertConfig.category = _.find($rootScope.alertCategories, {
              id: alertConfig.category
            });
            alertConfig.baseEvent = _.find($rootScope.alertTemplates, {
              event_name: alertConfig.event_name
            });
          }
          $rootScope.menus = MenuUtils.computeMenus(user, userFeatures);
          return $rootScope.menu = $rootScope.menus.user;
        }],
        onExit: ["$rootScope", function($rootScope) {
          return $rootScope.user = null;
        }]
      }).state("user.cert-list", {
        url: "/cert-list",
        template: "<cert-list></cert-list>"
      }).state("user.pdf", {
        url: "/pdf",
        templateUrl: "pdf/views/main.html"
      }).state("user.new-account", {
        url: "/new-account",
        templateUrl: "user/views/account.html",
        controller: "UserAccountCtrl"
      }).state("user.support", {
        url: "/support",
        templateUrl: "support/views/main.html",
        controller: "SupportCtrl"
      }).state("user.high-cost-drugs", {
        url: "/high-cost-drugs",
        template: "<hcd-main/>"
      }).state("user.high-cost-drugs.les", {
        url: "/les",
        template: "<hcd-drugs-table type='les'/>"
      }).state("user.high-cost-drugs.aap-aac", {
        url: "/aap-aac",
        template: "<hcd-drugs-table type='aap_aac'/>"
      }).state("user.high-cost-drugs.excluding-les-and-aap-aac", {
        url: "/excluding-les-and-aap-aac",
        template: "<hcd-drugs-table type='excluding_les_and_aap_aac'/>"
      }).state("user.notifications", {
        url: "/notifications/{userId:int}",
        templateUrl: "user/views/user-notifications.html",
        controller: "UserNotificationsCtrl"
      }).state("user.doc-to-validate", {
        url: "/doc-to-validate",
        template: '<doc-to-validate></doc-to-validate>'
      }).state("user.account", {
        url: "/account/{userId:int}",
        templateUrl: "user/views/account.html",
        controller: "UserAccountCtrl"
      }).state("user.release-notes", {
        url: "/release-notes",
        template: '<release-notes></release-notes>'
      }).state("user.documents", {
        url: "/miniged",
        template: '<miniged></miniged>',
        params: {
          admin: false
        }
      }).state("user.bills", {
        url: "/bills",
        template: '<bills></bills>',
        params: {
          admin: false
        }
      }).state("user.my-missions", {
        url: "/my-missions",
        template: '<my-missions></my-missions>'
      }).state("user.customer", {
        url: "",
        abstract: true,
        template: '<ui-view/>'
      }).state("user.iqss", {
        url: "/iqss-config",
        template: '<iqss-config><iqss-config/>'
      }).state("user.interface-interop", {
        url: "/interface-interop",
        template: "<interface-interop></interface-interop>"
      }).state("user.customer.site-vars", {
        url: "/site-vars",
        template: '<site-vars></site-vars>'
      }).state("user.customer.medforms", {
        url: "",
        abstract: true,
        template: '<ui-view/>',
        controller: "MedFormsCtrl"
      }).state("user.mission-letter-editor", {
        url: "/mission-letter-editor",
        template: "<mission-letter-editor></mission-letter-editor>"
      }).state("user.conflict", {
        url: "/conflict-list",
        template: "<conflict-list></conflict-list>"
      }).state("user.customer.medforms.form-editor", {
        url: "/form-editor",
        template: "<medforms-generator></medforms-generator>",
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ],
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = true;
          }
        ]
      }).state("user.customer.medforms.test-form", {
        url: "/test-form/{versionId:int}",
        controller: ["$scope", "$stateParams", function($scope, $stateParams) {
          return $scope.versionId = $stateParams.versionId;
        }],
        template: '<medform-test-version version-id="versionId" class="main-top-padding" style="position: fixed; top: 0; bottom: 0; left: 0; right: 0;" ></medform-test-version>',
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ],
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = true;
          }
        ]
      }).state("user.customer.synthesis-editor", {
        url: "/synthesis",
        templateUrl: "customer/medforms/views/synthesis-editor.html",
        controller: "SynthesisCreationCtrl"
      }).state("user.admin.medication", {
        url: "/medication",
        templateUrl: "customer/medication/views/medication.html",
        controller: "CustomerMedicationCtrl"
      }).state("user.admin.cda-documents", {
        url: "/cda-documents",
        template: '<cda-documents></cda-documents>'
      }).state("user.admin.contextual-call-editor", {
        url: "/contextual-call-editor",
        template: '<contextual-call-editor></contextual-call-editor>'
      }).state("user.medplan", {
        url: "/medplan",
        controller: "MedplanCtrl",
        template: "<ui-view/>"
      }).state("user.medplan.create-event", {
        url: "/create-event",
        templateUrl: "medplan/views/medplan-event-creation.html",
        controller: "MedplanCreateEventCtrl"
      }).state("user.medplan.templates", {
        url: "/templates",
        controller: "MedplanTemplatesCtrl",
        templateUrl: "medplan/views/templates.html"
      }).state("user.medplan.events", {
        url: "/events",
        controller: "MedplanEventsCtrl",
        templateUrl: "medplan/views/medplan-events-thesaurus.html"
      }).state("user.cache-downloads-debug", {
        url: "/cache-downloads-debug",
        controller: "CacheDownloadDebugCtrl",
        templateUrl: "mobile/views/cache_downloads_debug.html"
      }).state("user.menu", {
        url: "/menu",
        controller: "MenuCtrl",
        templateUrl: "menu/views/user_menu.html"
      }).state("user.admin", {
        url: "/admin",
        data: {
          title: [
            '$rootScope', '$filter', function($rootScope, $filter) {
              return $filter("translate")("CONFIG_MENU");
            }
          ]
        },
        templateUrl: "admin/views/admin.html",
        controller: "AdminCtrl"
      }).state("user.admin.users", {
        url: "/users",
        templateUrl: "admin/views/users.html",
        controller: "UserAdminCtrl"
      }).state("user.admin.groups", {
        url: "/groups",
        template: '<iframe class="iframe-mhsi" iframe-syncronize full-height="true" ng-src="{{mhsiGroupUrl}}" frameborder="0"></iframe>'
      }).state("user.admin.devices", {
        url: "/devices",
        controller: "MHDeviceController",
        templateUrl: 'mh_device/views/mhdevices-list.html'
      }).state("user.admin.debug", {
        url: "/debug",
        template: '<iframe class="iframe-mhsi" iframe-syncronize full-height="true" ng-src="{{mhsiDebugxUrl}}" frameborder="0"></iframe>'
      }).state("user.admin.entities", {
        url: "/entities",
        controller: "EntityCtrl",
        templateUrl: 'site/views/entities.html'
      }).state("user.admin.django", {
        url: "/django",
        template: '<div ng-init="djangoAdmin()"></div>'
      }).state("user.notification-center", {
        url: "/notification-center",
        abstract: true,
        template: "<ui-view/>"
      }).state("user.notification-center.redirect", {
        url: "/redirect/{alertId:int}",
        controller: "NotificationRedirectCtrl",
        templateUrl: "notification_center/views/redirect.html"
      }).state("user.medication", {
        url: "/medication",
        template: '<ui-view/>',
        controller: 'MedicationCtrl',
        resolve: {
          prescCategories: [
            'PrescUtils', function(PrescUtils) {
              return PrescUtils.getCategories().promise;
            }
          ],
          timeSlots: [
            'PrescUtils', function(PrescUtils) {
              return PrescUtils.getTimeSlots().promise;
            }
          ]
        }
      }).state("user.medication.prescription-templates", {
        url: "/prescription-templates",
        templateUrl: "medication/views/prescription-templates-list.html",
        controller: "PrescriptionTemplatesCtrl"
      }).state("user.medication.prescription-new-template", {
        url: "/prescription-new-template/{templateCategory:int}?prescriptionTemplate?prescriptionGroupToModify",
        templateUrl: "medication/views/presc-new.html",
        controller: "PrescriptionNewTemplateCtrl"
      }).state("user.notification-center.config", {
        url: "/config",
        controller: "NotificationConfigCtrl",
        templateUrl: "notification_center/views/config.html"
      }).state("print", {
        url: "/print",
        templateUrl: "core/views/print.html",
        controller: "PrintCtrl"
      }).state("user.patient-create", {
        url: "/patient-create",
        controller: "PatientCreateCtrl",
        templateUrl: "patient/views/patient-create.html"
      }).state("user.stay-list", {
        url: "/stay-list",
        data: {
          title: [
            '$rootScope', '$filter', function($rootScope, $filter) {
              return $filter("translate")("PATIENT_LIST");
            }
          ]
        },
        controller: "StayListCtrl",
        templateUrl: "stay/views/stay-list.html"
      }).state("user.patient.stay.edit", {
        url: "/patient-edit",
        controller: "PatientEditInfosCtrl",
        templateUrl: "patient/views/patient-edit.html",
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ],
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = true;
          }
        ]
      }).state("user.patient.stay.PIMS", {
        url: "/PIMS",
        controller: ["$scope", "$rootScope", "$sce", "$window", "User", function($scope, $rootScope, $sce, $window, User) {
          return User.getPIMSWebsiteSession().$promise.then(function(response) {
            var params;
            params = new URLSearchParams({
              sys_mws_session_impersonified: response.sys_mws_session,
              sys_mws_session: response.sys_mws_session,
              mws_application: "PIMS",
              ipp: $rootScope.currentPatient.si_id,
              iep: $rootScope.currentStay.si_id
            }).toString();
            return $window.open("https://saas.web100t.fr/ws0011q1/mwsiissrv.dll/hal/interfaces/appelcontextuel/PIMS/viewresumefromexterieur?" + params, '_blank');
          });
        }],
        template: '',
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ],
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = true;
          }
        ]
      }).state("user.patient.stay.mss", {
        url: "/mss",
        template: '<mss-list stay="currentStay" patient="currentPatient"></mss-list>'
      }).state("user.stay-movements", {
        url: "/stay-movements",
        controller: "StayMovementsCtrl",
        templateUrl: "stay/views/stay-movements-list.html"
      }).state("user.config", {
        url: "/config",
        abstract: true,
        template: "<ui-view/>"
      }).state("user.config.mhdevices", {
        url: "/mhdevices",
        templateUrl: "mh_device/views/mhdevices-list.html",
        controller: "MHDeviceController"
      }).state("user.config.kit", {
        url: "/kit",
        abstract: true,
        template: "<ui-view/>",
        controller: "KitCtrl"
      }).state("user.config.kit.list", {
        url: "/list",
        templateUrl: "catalog/views/kit-list.html",
        controller: "KitListCtrl"
      }).state("user.config.kit.new", {
        url: "/new",
        templateUrl: "catalog/views/kit-edit.html",
        controller: "KitEditCtrl"
      }).state("user.config.kit.edit", {
        url: "/edit/{idKit:int}",
        templateUrl: "catalog/views/kit-edit.html",
        controller: "KitEditCtrl"
      }).state("user.config.kit.show", {
        url: "/show/{idKit:int}",
        templateUrl: "catalog/views/kit-edit.html",
        controller: "KitEditCtrl"
      }).state("user.config.thesaurus", {
        url: "/thesaurus",
        controller: "ThesaurusEditController",
        templateUrl: 'thesaurus/views/thesaurus-editor.html'
      }).state("user.multi", {
        url: "/all",
        abstract: true,
        template: "<ui-view/>",
        controller: "MultiPatientCtrl"
      }).state("user.multi.careplan", {
        url: "/careplan",
        controller: "MultiPatientCareplanCtrl",
        templateUrl: "multipatient/views/careplan.html"
      }).state("user.multi.visio", {
        url: "/visio",
        controller: "MultiVisioCtrl",
        templateUrl: "multivisio/views/multivisio.html"
      }).state("user.multi.message", {
        url: "/message/feed/:featureName",
        template: "<ui-view/>",
        controller: "MessageListCtrl",
        abstract: true
      }).state("user.transmissions", {
        url: "/target-transmissions",
        data: {
          linkedFeature: "MHC_MULTI_TRANSMISSION"
        },
        template: '<div transmission-list></div>'
      }).state("user.multi.message.hierarchic", {
        url: "/hierarchic?archived?important",
        templateUrl: "message/views/message_multi.html",
        controller: "MessageHierarchicCtrl"
      }).state("user.multi.message.chronologic", {
        url: "/chronologic",
        templateUrl: "message/views/chronologic-view_multi.html",
        controller: "MessageChronologicCtrl"
      }).state("user.multi.message.newThread", {
        url: "/new-thread?category",
        templateUrl: "message/views/message-create.html",
        controller: "MessageCreateCtrl"
      }).state("user.multi.equipment", {
        url: "/equipment",
        template: "<ui-view/>",
        abstract: true,
        controller: "EquipmentCtrl"
      }).state("user.multi.equipment.catalog", {
        url: "/catalog",
        templateUrl: "equipment/views/equipment-catalog.html",
        controller: "EquipmentCatalogCtrl"
      }).state("user.multi.equipment.suppliers", {
        url: "/suppliers",
        templateUrl: "equipment/views/suppliers-catalog.html",
        controller: "SuppliersCatalogCtrl"
      }).state("user.patient", {
        url: "/patient/{idPatient:int}",
        templateUrl: "patient/views/main.html",
        data: {
          title: [
            '$rootScope', '$filter', function($rootScope, $filter) {
              var ref;
              return (((ref = $rootScope.currentPatient) != null ? ref.last_name : void 0) || "").substring(0, 3);
            }
          ]
        },
        controller: "PatientCtrl",
        onExit: [
          '$rootScope', '$window', '$state', function($rootScope, $window, $state) {
            $rootScope.currentPatient = null;
            $rootScope.currentPatientStays = null;
            $rootScope.patientNewEvents = null;
            $rootScope.subscribed = null;
            $rootScope.menu = $rootScope.menus.user;
            if ($rootScope.mh_config.platform === "mgapp") {
              return $window.go_to = function(state, args) {
                return $state.go(state, args);
              };
            }
          }
        ],
        resolve: {
          closedStayAlterationDelay: [
            'SiteVarsUtils', function(SiteVarsUtils) {
              return SiteVarsUtils.getValue('CLOSED_STAY_ALTERATIONS_DELAY_IN_DAYS', 0);
            }
          ],
          patient: [
            'Patient', '$stateParams', function(Patient, $stateParams) {
              return Patient.get({
                id: $stateParams.idPatient
              }).$promise;
            }
          ],
          stays: [
            'Stay', '$stateParams', function(Stay, $stateParams) {
              return Stay.query({
                patient: $stateParams.idPatient,
                extra_fields: ["preadmission", "identitovigilance"]
              }).$promise;
            }
          ],
          patientAlerts: [
            'Patient', '$stateParams', function(Patient, $stateParams) {
              return Patient.getAlerts({
                id: $stateParams.idPatient
              }).$promise;
            }
          ]
        },
        onEnter: ["$rootScope", "patientAlerts", "stays", "patient", function($rootScope, patientAlerts, stays, patient) {
          var config, event, formatedPatientNewEvents, i, len, ref;
          $rootScope.currentPatient = patient;
          $rootScope.currentPatientStays = stays;
          formatedPatientNewEvents = [];
          ref = patientAlerts.alerts;
          for (i = 0, len = ref.length; i < len; i++) {
            event = ref[i];
            config = _.find($rootScope.alertConfigs, {
              id: event.config
            });
            if (config) {
              event.config = config;
              formatedPatientNewEvents.push(event);
            }
          }
          $rootScope.patientNewEvents = formatedPatientNewEvents;
          return $rootScope.menu = $rootScope.menus.patient;
        }]
      }).state("user.patient.stay", {
        url: "/stay/{idStay:int}",
        templateUrl: "stay/views/main.html",
        controller: "StayCtrl",
        data: {
          title: [
            '$rootScope', '$filter', function($rootScope, $filter) {
              var ref;
              return (((ref = $rootScope.currentStay) != null ? ref.si_id : void 0) || "").slice(-3);
            }
          ]
        },
        resolve: {
          currentStay: [
            'Stay', '$stateParams', function(Stay, $stateParams) {
              return Stay.get({
                id: $stateParams.idStay
              }).$promise;
            }
          ]
        },
        onEnter: ["$rootScope", "currentStay", function($rootScope, currentStay) {
          $rootScope.currentStay = currentStay;
          _.remove($rootScope.currentPatientStays, {
            id: currentStay.id
          });
          $rootScope.currentPatientStays.push(currentStay);
          $rootScope.hidePatientInfos = true;
          return $rootScope.busy = false;
        }],
        onExit: ["$rootScope", function($rootScope) {
          return $rootScope.currentStay = null;
        }]
      }).state("user.patient.stay.stock", {
        url: "/stock",
        controller: "StockController",
        abstract: true,
        template: "<ui-view/>"
      }).state("user.patient.stay.stock.list", {
        url: "/list",
        templateUrl: "stock/views/stock-list.html",
        controller: "StockListController"
      }).state("user.patient.stay.stock.new", {
        url: "/new",
        templateUrl: "stock/views/new-stock.html",
        controller: "StockNewController"
      }).state("user.patient.stay.dashboard", {
        url: "/dashboard",
        templateUrl: "stay/views/dashboard.html",
        controller: "StayDashBoardCtrl",
        dontFilterEvents: true,
        onEnter: ["$rootScope", "currentStay", function($rootScope, currentStay) {
          return $rootScope.hideHeaderAlerts = true;
        }],
        onExit: ["$rootScope", function($rootScope) {
          return $rootScope.hideHeaderAlerts = false;
        }]
      }).state("user.patient.stay.box-menu", {
        url: "/box-menu",
        controller: "MenuCtrl",
        templateUrl: "menu/views/features.html"
      }).state("user.patient.stay.menu", {
        url: "/menu",
        controller: "MenuCtrl",
        templateUrl: "menu/views/user_menu.html"
      }).state("user.patient.stay.staff", {
        url: "/staff",
        templateUrl: "staff/views/users.html",
        controller: "StaffCtrl"
      }).state("user.billing", {
        url: "/billing",
        template: '<billing></billing>'
      }).state("user.patient.stay.billing", {
        url: "/billing",
        template: '<billing></billing>'
      }).state("user.agenda", {
        url: "/agenda",
        template: '<agenda></agenda>'
      }).state("user.patient.stay.agenda", {
        url: "/agenda",
        params: {
          alertDetail: null
        },
        controller: ["$scope", "$stateParams", function($scope, $stateParams) {
          return $scope.alertDetail = $stateParams.alertDetail;
        }],
        template: '<agenda stay="currentStay" patient="currentPatient" alert-detail="alertDetail"></agenda>'
      }).state("user.patient.stay.message", {
        url: "/message/feed/:featureName",
        template: "<ui-view/>",
        controller: "MessageListCtrl",
        abstract: true
      }).state("user.patient.stay.transmissions", {
        url: "/transmissions",
        template: '<div transmission-list patient="currentPatient" stay="currentStay" all-stays="allStays"></div>',
        params: {
          featureName: "MHC_TRANSMISSION"
        }
      }).state("user.patient.stay.multi-work-reports", {
        url: "/multi-work-reports?view",
        template: '<div multi-work-reports patient="currentPatient" stay="currentStay" all-stays="allStays" default-view="{{::defaultView}}"></div>',
        controller: ["$scope", "$stateParams", function($scope, $stateParams) {
          $scope.defaultView = $stateParams.view;
          return $stateParams.view = null;
        }],
        params: {
          featureName: "MHC_WORK_REPORT"
        },
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ],
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = true;
          }
        ]
      }).state("user.work-reports-config", {
        url: "/work-reports-config",
        template: "<work-reports-config></work-reports-config>"
      }).state("user.patient.stay.message.multi", {
        url: "/multi?view"
      }).state("user.patient.stay.message.multi.tab", {
        url: "/tab/:tab"
      }).state("user.patient.stay.message.hierarchic", {
        url: "/hierarchic?archived?important",
        templateUrl: "message/views/message.html",
        controller: "MessageHierarchicCtrl"
      }).state("user.patient.stay.message.chronologic", {
        url: "/chronologic",
        templateUrl: "message/views/chronologic-view.html",
        controller: "MessageChronologicCtrl"
      }).state("user.patient.stay.message.newThread", {
        url: "/new-thread?category",
        templateUrl: "message/views/message-create.html",
        controller: "MessageCreateCtrl"
      }).state("user.patient.stay.details", {
        url: "/details?model",
        templateUrl: "patient/views/patient-details.html",
        params: {
          model: {
            value: "pread"
          }
        },
        controller: "PatientDetailCtrl"
      }).state("user.patient.stay.medicalinfo", {
        url: "/medicalinfo?model",
        params: {
          model: {
            value: "medical_data"
          }
        },
        templateUrl: "patient/views/patient-details.html",
        controller: "PatientDetailCtrl"
      }).state("user.patient.stay.medicaldata", {
        url: "/medicalinfo/:model",
        params: {
          model: {
            value: "medical_data"
          }
        },
        templateUrl: "patient/views/patient-details.html",
        controller: "PatientDetailCtrl"
      }).state("user.patient.stay.socialinfo", {
        url: "/socialinfo?model",
        params: {
          model: {
            value: "social_data"
          }
        },
        templateUrl: "patient/views/patient-details.html",
        controller: "PatientDetailCtrl"
      }).state("user.patient.stay.pread", {
        url: "/pread",
        templateUrl: "preadmission/views/checklist.html",
        controller: "PreadmissionCtrl"
      }).state("user.patient.stay.order", {
        url: "/order",
        abstract: true,
        template: '<ui-view/>'
      }).state("user.patient.stay.order.list", {
        url: "/list",
        template: '<order-list stay="currentStay" patient="currentPatient"></order-list>'
      }).state("user.patient.stay.care", {
        url: "/care",
        templateUrl: "preadmission/views/prescription-care-organisation.html",
        controller: "CareOrgaCtrl"
      }).state("user.patient.stay.photo", {
        url: "/photo",
        controller: "PhotoCtrl",
        templateUrl: "photo/views/photos.html"
      }).state("user.patient.stay.svg", {
        url: "/measures",
        controller: "SvgCtrl",
        templateUrl: "measures/views/measures-graph.html"
      }).state("user.patient.stay.take-measures", {
        url: "/take_measures",
        template: '<take-measures stay="currentStay" ></take-measures>'
      }).state("user.patient.stay.scan", {
        url: "/scan?uploadFile",
        controller: "ScanCtrl",
        templateUrl: "scan/views/scan.html",
        params: {
          featureName: "NUM"
        }
      }).state("user.patient.stay.picture", {
        url: "/picture",
        controller: "ScanCtrl",
        templateUrl: "scan/views/scan.html",
        params: {
          featureName: "WOUND_PICTURE"
        }
      }).state("user.patient.stay.lia", {
        url: "/lia",
        controller: "LiaCtrl",
        templateUrl: "diary/views/lia.html"
      }).state("user.patient.stay.rod", {
        url: "/rod",
        controller: "RodCtrl",
        templateUrl: "docviewer/views/rod.html"
      }).state("user.multi.medication", {
        url: "/medication/{mode:string}",
        template: '<ui-view/>',
        controller: 'MedicationCtrl',
        resolve: {
          prescCategories: [
            'PrescUtils', function(PrescUtils) {
              return PrescUtils.getCategories().promise;
            }
          ],
          timeSlots: [
            'PrescUtils', function(PrescUtils) {
              return PrescUtils.getTimeSlots().promise;
            }
          ]
        }
      }).state("user.multi.medication.cart", {
        url: "/cart",
        templateUrl: "medication/views/presccart.html",
        controller: "PrescCartCtrl"
      }).state("user.patient.stay.medication", {
        url: "/medication",
        template: '<ui-view/>',
        controller: 'MedicationCtrl',
        resolve: {
          prescCategories: [
            'PrescUtils', function(PrescUtils) {
              return PrescUtils.getCategories().promise;
            }
          ],
          timeSlots: [
            'PrescUtils', function(PrescUtils) {
              return PrescUtils.getTimeSlots().promise;
            }
          ]
        },
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.hidePatientInfos = false;
          }
        ],
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.hidePatientInfos = true;
          }
        ]
      }).state("user.patient.stay.posos", {
        url: "/posos/{documentId:int}?ordonnanceId?",
        template: '<posos document-id="{{documentId}}" ordonnance-id="{{ordonnanceId}}" patient="currentPatient" stay="currentStay" all-stays="allStays"></posos>',
        controller: ["$scope", "$stateParams", function($scope, $stateParams) {
          $scope.documentId = $stateParams.documentId;
          return $scope.ordonnanceId = $stateParams.ordonnanceId;
        }]
      }).state("user.patient.stay.medication.crop", {
        url: "/crop?documentID?",
        templateUrl: "medication/views/cutting.html",
        controller: 'CuttingCtrl'
      }).state("user.patient.stay.medication.print", {
        url: "/print",
        templateUrl: "medication/views/print.html",
        controller: 'MedicationPrintCtrl'
      }).state("user.patient.stay.medication.new_prescription", {
        url: "/new_prescription?prescriptionId?ordonnanceId?parentPrescriptionId?prescriptionGroupToModify?prescriptionGroupSequence?prescriptionGroupToEdit?",
        controller: "PrescNewCtrl",
        templateUrl: "medication/views/presc-new.html"
      }).state("user.patient.stay.medication.ordonnances", {
        url: "/ordonnances?ordonnanceId",
        controller: "OrdonnanceCtrl",
        templateUrl: "medication/views/ordonnances.html",
        resolve: {
          $uibModalInstance: [
            '$rootScope', function($rootScope) {
              return null;
            }
          ]
        }
      }).state("user.patient.stay.medication.dispensation", {
        url: "/dispensation?dispensationId",
        controller: "DispensationCtrl",
        templateUrl: "medication/views/dispensation.html"
      }).state("user.patient.stay.medication.administration", {
        url: "/administration",
        abstract: true,
        template: '<ui-view/>'
      }).state("user.patient.stay.medication.administration.simple", {
        url: "/simple",
        template: '<administration patient="currentPatient" stay="currentStay" all-stays="allStays" view="day"></administration>',
        alertsExtraRoute: "user.patient.stay.medication.administration.compact"
      }).state("user.patient.stay.medication.administration.compact", {
        url: "/compact",
        template: '<administration patient="currentPatient" stay="currentStay" all-stays="allStays"></administration>'
      }).state("user.patient.stay.medication.pap", {
        url: "/pap?prescriptionId?ordonnanceId?parentPrescriptionId",
        templateUrl: "medication/views/pap-creation-template.html",
        controller: "PAPCtrl"
      }).state("user.patient.stay.medication.prescription-templates", {
        url: "/prescription-templates",
        templateUrl: "medication/views/prescription-templates-list.html",
        controller: "PrescriptionTemplatesCtrl"
      }).state("user.patient.stay.medication.current", {
        url: "/current",
        templateUrl: "medication/views/presc-current.html",
        controller: "CurrentPrescriptionCtrl"
      }).state("user.patient.stay.medication.renew", {
        url: "/renew",
        templateUrl: "medication/views/renew-all-prescriptions.html",
        controller: "PrescRenewAllCtrl"
      }).state("user.patient.stay.medication.cart", {
        url: "/cart",
        templateUrl: "medication/views/presccart.html",
        controller: "PrescCartCtrl"
      }).state("user.patient.stay.preadsocialinfo", {
        url: "/preadsocialinfo",
        templateUrl: "preadmission/views/pread-social-info.html",
        controller: "PreadSocialInfoCtrl"
      }).state("user.patient.stay.form", {
        url: "",
        abstract: true,
        template: '<ui-view/>',
        controller: "MedFormsCtrl"
      }).state("user.patient.stay.form.crh", {
        url: "/crh",
        template: '<ui-view/>',
        controller: "MedFormsCrhCtrl"
      }).state("user.patient.stay.form.cr_entry", {
        url: "/cr_entry",
        template: '<ui-view/>',
        controller: "MedFormsCrEntryCtrl"
      }).state("user.patient.stay.form.redirect", {
        url: "/redirect/:templateUID:versionID?",
        template: "<ui-view/>",
        controller: "MedFormsRedirectCtrl"
      }).state("user.patient.stay.form.list", {
        url: "/forms",
        templateUrl: "medforms/views/medforms-template.html",
        alertsExtraRoute: "user.patient.stay.form.template",
        controller: "MedFormsTemplateCtrl"
      }).state("user.patient.stay.form.template", {
        url: "/forms/template/{idTemplate:int}/versions?versionID",
        template: '<div previous-state-name="previousStateName" version-id="versionID" class="main-top-padding" style="position: fixed; top: 0; bottom: 0; left: 0; right: 0;" medform-version stay="currentStay" template="formTemplate" patient="currentPatient" all-stays="allStays"></div>',
        controller: ["$scope", "$state", "$stateParams", "formTemplate", function($scope, $state, $stateParams, formTemplate) {
          $scope.formTemplate = formTemplate;
          $scope.versionID = $stateParams.versionID;
          return $scope.previousStateName = $state.previous ? $state.previous.name : "user.patient.stay.form.list";
        }],
        resolve: {
          formTemplate: [
            'FormTemplateUtils', '$stateParams', function(FormTemplateUtils, $stateParams) {
              return FormTemplateUtils.getTemplates({
                id: $stateParams.idTemplate
              });
            }
          ]
        },
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ],
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = true;
          }
        ]
      }).state("user.patient.stay.summary", {
        url: "/summary",
        controller: ["$scope", "$rootScope", function($scope, $rootScope) {
          $scope.stay = _.clone($rootScope.currentStay);
          $scope.patient = _.clone($rootScope.currentPatient);
          return "we have s race condition bug on summary on LNA prod,\nduring screen loading status of rootScope busy can be random,\nwhile loading summary if busy is set to false stateChangeStart is allowed\nand $rootScope.currentStay can become null, some summay component as messageHierarchicList\ncan be runned asumming that stay is None and askfor for all thread\napi call like this shall always include stay or patient ref/api_rest/threads?archived=false&feed=2&page_size=20\n(MHC_OBSERVATION feed)";
        }],
        template: '<summary-grid stay="stay" patient="patient" platform="mh_config.platform" user="user"></summary-grid>'
      }).state("user.configtool", {
        url: "/configtool",
        templateUrl: "configtool/views/configtool.html",
        controller: "configtoolMainCtrl",
        controllerAs: "confCtrl"
      }).state("user.patient.stay.teleconsultation", {
        url: "/teleconsultation",
        templateUrl: "teleconsultation/views/patient-teleconsultation-view.html",
        controller: "PatientTeleconsultationCtrl"
      }).state("user.patient.stay.medicalinfos", {
        url: "/medical-infos",
        templateUrl: "patient/views/patient-medical-infos.html"
      }).state("user.patient.stay.contacts", {
        url: "/contacts",
        abstract: true,
        template: '<ui-view/>'
      }).state("user.patient.stay.contacts.list", {
        url: "/list",
        template: '<patient-entourage patient="currentPatient"></patient-entourage>'
      }).state("user.patient.stay.taskplanner", {
        url: "/taskplanner",
        template: "<ui-view/>",
        controller: "TaskPlannerCtrl"
      }).state("user.patient.stay.taskplanner.mission_letter_create", {
        url: "/new_mission_letter",
        controller: "MissionLetterCtrl",
        templateUrl: "taskplanner/views/mission-letter-form.html"
      }).state("user.patient.stay.taskplanner.mission_letter_list", {
        url: "/mission_letter_list",
        controller: "MissionLetterListCtrl",
        templateUrl: "taskplanner/views/mission-letters-list.html"
      }).state("user.patient.stay.taskplanner.new_sequence", {
        url: "/new_sequence",
        controller: "SequenceCtrl",
        templateProvider: [
          '$templateRequest', 'newSequenceInterface', function($templateRequest, newSequenceInterface) {
            if (newSequenceInterface) {
              return '<div sequences-planification stay="currentStay" patient="currentPatient" all-stays="allStays"></div>';
            } else {
              return $templateRequest("taskplanner/views/sequence-list.html");
            }
          }
        ],
        controllerProvider: [
          'newSequenceInterface', function(newSequenceInterface) {
            if (newSequenceInterface) {
              return "";
            } else {
              return "SequenceCtrl";
            }
          }
        ],
        resolve: {
          newSequenceInterface: [
            'SiteVarsUtils', function(SiteVarsUtils) {
              return SiteVarsUtils.getValue('NEW_SEQUENCE_INTERFACE', false);
            }
          ]
        },
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ],
        onEnter: [
          '$rootScope', 'newSequenceInterface', function($rootScope, newSequenceInterface) {
            if (newSequenceInterface) {
              return $rootScope.fixedContent = true;
            }
          }
        ]
      }).state("user.patient.stay.taskplanner.new_activity", {
        url: "/new_activity",
        template: '<activity-create stay="currentStay" thesaurus-code="patient_agenda"></activity-create>'
      }).state("user.patient.stay.taskplanner.sequences", {
        url: "/sequences",
        templateUrl: "taskplanner/views/sequences-realization.html",
        controller: "TaskSequencesCtrl"
      }).state("user.patient.stay.sequences", {
        url: "/sequences",
        template: '<div sequences-planification stay="currentStay" patient="currentPatient" all-stays="allStays"></div>',
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ],
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = true;
          }
        ]
      }).state("user.patient.stay.taskplanner.medplan", {
        url: "/medplan",
        controller: "MedplanCtrl",
        template: '<div id="medplan"><ui-view/></div>'
      }).state("user.patient.stay.ppc", {
        url: "/ppc",
        template: '<ppc-data patient="currentPatient" stay="currentStay"></ppc-data>'
      }).state("user.patient.stay.taskplanner.medplan.list", {
        url: "/list",
        templateUrl: "medplan/views/medplan-list.html",
        controller: "MedplanListCtrl"
      }).state("user.patient.stay.taskplanner.medplan.create", {
        url: "/create",
        templateUrl: "medplan/views/medplan-association.html",
        controller: "MedplanCreateCtrl"
      }).state("user.patient.stay.taskplanner.medplan.create-event", {
        url: "/create-event",
        templateUrl: "medplan/views/medplan-event-creation.html",
        controller: "MedplanCreateEventCtrl"
      }).state("user.patient.stay.docviewer", {
        url: "/docviewer",
        templateUrl: "docviewer/views/docviewer.html",
        controller: "DocViewerCtrl"
      }).state("user.patient.stay.docviewer.detail", {
        url: "/detail",
        templateUrl: "docviewer/views/docviewer-detail.html"
      }).state("user.patient.stay.psp", {
        url: "/psp",
        templateUrl: "psp/views/psp.html",
        controller: "PspCtrl"
      }).state("user.patient.stay.tplist", {
        url: "/tplist",
        templateUrl: "therapeutic-programs/views/therapeutic-programs.html",
        controller: "TherapeuticProgramsCtrl"
      }).state("user.collection-plan-list", {
        url: "/collection-plan-list",
        template: '<collection-plan-list></collection-plan-list>'
      }).state("user.collection-plan-detail", {
        url: "/collection-plan-detail/:collectionId",
        template: '<collection-plan-detail collection-id="collectionId"></collection-plan-detail>',
        controller: ["$scope", "$stateParams", function($scope, $stateParams) {
          return $scope.collectionId = $stateParams.collectionId;
        }]
      }).state("user.collection-plan-new", {
        url: "/collection-plan-new/{startDate}/{endDate}/{state}/{entityId:int}",
        template: '<collection-plan-new class="top-position" start-date="startDate" end-date="endDate" state="state" entity-id="entityId"></collection-plan-new>',
        controller: ["$scope", "$stateParams", function($scope, $stateParams) {
          $scope.startDate = $stateParams.startDate;
          $scope.endDate = $stateParams.endDate;
          $scope.entityId = $stateParams.entityId;
          return $scope.state = $stateParams.state;
        }],
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = true;
          }
        ],
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ]
      }).state("user.patient.stay.collection-plan-list", {
        url: "/collection-plan-list",
        template: '<collection-plan-list stay="currentStay"></collection-plan-list>'
      }).state("user.patient.stay.collection-plan-detail", {
        url: "/collection-plan-detail/:collectionId",
        template: '<collection-plan-detail collection-id="collectionId"></collection-plan-detail>',
        controller: ["$scope", "$stateParams", function($scope, $stateParams) {
          return $scope.collectionId = $stateParams.collectionId;
        }]
      }).state("user.patient.stay.collection-plan-new", {
        url: "/collection-plan-new/{startDate}/{endDate}/{state}/{entityId:int}",
        template: '<collection-plan-new class="top-position" stay="currentStay" start-date="startDate" state="state" end-date="endDate" entity-id="entityId"></collection-plan-new>',
        controller: ["$scope", "$stateParams", function($scope, $stateParams) {
          $scope.startDate = $stateParams.startDate;
          $scope.endDate = $stateParams.endDate;
          $scope.entityId = $stateParams.entityId;
          return $scope.state = $stateParams.state;
        }],
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = true;
          }
        ],
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.fixedContent = false;
          }
        ]
      }).state("user.patient.stay.pharmaceutical-analysis", {
        url: "/pharmaceutical-analysis",
        template: '<pharmaceutical-analysis stay="currentStay" patient="currentPatient" platform="mh_config.platform" user="user"></pharmaceutical-analysis>',
        onEnter: [
          '$rootScope', function($rootScope) {
            return $rootScope.hidePatientInfos = false;
          }
        ],
        onExit: [
          '$rootScope', function($rootScope) {
            return $rootScope.hidePatientInfos = true;
          }
        ]
      }).state("user.faq", {
        url: "/faq",
        templateUrl: "docviewer/views/faq.html",
        controller: "FaqCtrl"
      }).state("faq", {
        url: "/faq",
        templateUrl: "docviewer/views/faq.html",
        controller: "FaqCtrl"
      }).state("user.mhcare-stats", {
        url: "/mhcare-stats",
        template: '<mhcare-stats></mhcare-stats>'
      }).state("user.stats", {
        url: "/stats",
        controller: "StatsCtrl",
        templateUrl: "stats/views/stats.html"
      }).state("user.seq-stats", {
        url: "/seq-stats",
        controller: "SeqStatsCtrl",
        templateUrl: "stats/views/seq-stats.html"
      }).state("user.usr-conn", {
        url: "/usr-conn",
        controller: "UsrConnCtrl",
        templateUrl: "stats/views/usr-conn.html"
      }).state("user.usr-conn-attempts", {
        url: "/usr-conn-attempts",
        controller: "UsrConnAttemptsCtrl",
        templateUrl: "stats/views/usr-conn-attempts.html"
      }).state("user.iqss-results", {
        url: "/iqss-results",
        controller: "IqssResultsCtrl",
        templateUrl: "stats/views/iqss-results.html"
      }).state("user.iqss-detailed", {
        url: "/iqss-detailed",
        controller: "IqssResultsCtrl",
        templateUrl: "stats/views/iqss-results-detailed.html"
      }).state("user.billing-config", {
        url: "/billing-config",
        template: '<billing-config></billing-config>'
      }).state("user.billing-config-category", {
        url: "/billing-category-config",
        controller: "BillingConfigCategoryCtrl",
        templateUrl: "billing/views/billing-config-category.html"
      }).state("user.export_pdf", {
        url: "/export_pdf",
        controller: "StayListCtrl",
        templateUrl: "stay/views/stay-list.html"
      }).state("user.patient.stay.equipment-renting", {
        url: "/equipment-renting",
        abstract: true,
        template: '<ui-view/>'
      }).state("user.patient.stay.equipment-renting.list", {
        url: "/list",
        template: '<equipment-renting-list stay="currentStay" ></equipment-renting-list>'
      }).state("user.patient.stay.equipment-renting.history", {
        url: "/history",
        controller: "EquipmentRentingHistoryCtrl",
        templateUrl: "equipment/views/equipment-renting-history.html"
      }).state("user.patient.stay.rental-invoices", {
        url: "/rental-invoices",
        abstract: true,
        template: '<ui-view/>'
      }).state("user.patient.stay.rental-invoices.list", {
        url: "/list",
        templateUrl: "equipment/views/rental-invoices-list.html",
        controller: "RentalInvoiceListCtrl"
      }).state("user.patient.stay.rental-invoices.create", {
        url: "/create/:slipType",
        templateUrl: "equipment/views/rental-invoices-create.html",
        controller: "RentalInvoiceCreateCtrl"
      }).state("user.contextual-call-redirect", {
        url: "/contextual-call-redirect?featureName&newTab",
        template: '<contextual-call-redirect></contextual-call-redirect>'
      }).state("user.patient.stay.contextual-call-redirect", {
        url: "/contextual-call-redirect?featureName&newTab",
        template: '<contextual-call-redirect></contextual-call-redirect>'
      });
    }
  ]);

  appModule.animation(".response-div", function() {
    return {
      enter: function(element, done1) {
        return element[0].scrollIntoView();
      }
    };
  });

  appModule.constant('MhliveService', window.MhliveService);

}).call(this);

//# sourceMappingURL=app.js.map

(function() {
  'use strict';
  angular.module('mhclientApp').directive('pdfEditor', function() {
    return {
      restrict: 'A',
      transclude: true,
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'pdf/views/pdf-editor.html';
        }
      },
      scope: {
        content: '=',
        readOnly: "="
      },
      controller: ["$rootScope", "$scope", "$q", "SiteVarsUtils", "Group", "Message", "Thread", "Upload", function($rootScope, $scope, $q, SiteVarsUtils, Group, Message, Thread, Upload) {
        $scope.pages = [
          {
            type: "page",
            items: [],
            style: {
              "width": "21cm",
              "height": "29.7cm",
              "padding-left": "1.9cm",
              "padding-right": "1.32cm",
              "padding-top": "2.54cm",
              "padding-bottom": "3.67cm"
            }
          }, {
            type: "page",
            items: [],
            style: {
              "width": "21cm",
              "height": "29.7cm",
              "padding-left": "1.9cm",
              "padding-right": "1.32cm",
              "padding-top": "2.54cm",
              "padding-bottom": "3.67cm"
            }
          }
        ];
        return $scope.currentPage = $scope.pages[0];
      }]
    };
  });

  angular.module('mhclientApp').directive('pdfPageEditor', function() {
    return {
      restrict: 'A',
      transclude: true,
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'pdf/views/pdf-page-editor.html';
        }
      },
      scope: {
        page: '='
      },
      controller: ["$rootScope", "$scope", "$q", "SiteVarsUtils", "Group", "Message", "Thread", "Upload", function($rootScope, $scope, $q, SiteVarsUtils, Group, Message, Thread, Upload) {
        return $scope.addItem = function() {
          return $scope.page.items.push({
            style: {
              top: "0cm",
              left: "0cm"
            }
          });
        };
      }]
    };
  });

  angular.module('mhclientApp').directive('pdfPage', function() {
    return {
      restrict: 'A',
      transclude: true,
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'pdf/views/pdf-page.html';
        }
      },
      scope: {
        page: '=',
        isActive: "="
      },
      controller: ["$rootScope", "$scope", "$q", "SiteVarsUtils", "Group", "Message", "Thread", "Upload", function($rootScope, $scope, $q, SiteVarsUtils, Group, Message, Thread, Upload) {}]
    };
  });

  angular.module('mhclientApp').directive('pageItem', function() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'pdf/views/pdf-page-item.html';
        }
      },
      scope: {
        container: '=',
        item: "="
      },
      controller: ["$rootScope", "$scope", "$q", "SiteVarsUtils", "Group", "Message", "Thread", "Upload", function($rootScope, $scope, $q, SiteVarsUtils, Group, Message, Thread, Upload) {}],
      link: function(scope, elem, attrs) {
        var action, containerElement, containerRect, getMousePos, previous_position, pxToCmRation;
        containerElement = elem.parent();
        containerRect = elem.parent()[0].getBoundingClientRect();
        action = null;
        previous_position = null;
        pxToCmRation = unitToPx("cm");
        getMousePos = function(evt) {
          return {
            x: evt.clientX - containerRect.left,
            y: evt.clientY - containerRect.top
          };
        };
        scope.mouseDown = function(event) {
          var position;
          position = getMousePos(event);
          if (false) {
            action = "RESIZING";
          }
          if (true) {
            action = "DEPLACE";
            return previous_position = position;
          }
        };
        scope.focusLost = function() {
          return action = null;
        };
        return scope.mouseMove = function(event) {
          var position;
          if (action) {
            position = getMousePos(event);
            if (action === "DEPLACE") {
              scope.item.style.top = (parseFloat(scope.item.style.top) - (previous_position.y - position.y) / pxToCmRation) + "cm";
              scope.item.style.left = (parseFloat(scope.item.style.left) - (previous_position.x - position.x) / pxToCmRation) + "cm";
              return previous_position = position;
            }
          }
        };
      }
    };
  });

}).call(this);

//# sourceMappingURL=pdf-directives.js.map

'use strict';

angular.module("mhclientApp").factory('Authentication', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
  // Set API's version
  var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
  return $resource(
    "/authentication/:route",
    {},
    {
      'login': {method: 'POST', params: {route:'2FA_login'}, headers: {'Accept': acceptHeader},},
      'code':{ method: 'POST', params: {route:'2FA_code'}, headers: {'Accept': acceptHeader},},
      'requestCode':{method: 'POST', params: {route:'2FA_request_code'}, headers: {'Accept': acceptHeader},},
      'changePassword':{method: 'POST', params: {route:'2FA_change_password'}, headers: {'Accept': acceptHeader},},
    });

}]);

angular.module("mhclientApp").component("login", {
  templateUrl: "login/views/login.html",
  bindings: {user: "<?", publicSettings: "<", callback:"&"},
  controller: ["$rootScope", "$http", "$uibModal", "$filter", "$timeout", "User", "Authentication", "cacheService", "notify", function loginCtrl($rootScope, $http, $uibModal, $filter, $timeout, User, Authentication, cacheService, notify) {

    // pwdtk
    // dj admin

    var ctrl;
    ctrl = this;
    ctrl.mode = "LOGIN"

    if (ctrl.publicSettings == null) {
      // If not set (expired session for example) reload public settings
      ctrl.busy = true
      $http.get("/ajax_site/").then(function (response) {
        ctrl.publicSettings = response.data.public_settings || {}
        ctrl.busy = false
      });
    }

    ctrl.requestCode = function() {
      ctrl.busy = true
      Authentication.requestCode({"ephemeral_token": ctrl.ephemeral_token, "method": ctrl.sendMethod.type}).$promise.then( function(){
        ctrl.mode = "2FA";
        ctrl.busy = false
        ctrl.warningText = false
      },
      function(response) {
        ctrl.busy = false
        ctrl.loginForm.$setPristine()
        ctrl.warningText = response.data.detail
        ctrl.mode = "LOGIN"
      })
    }

    ctrl.returnToLogin = function (){if (ctrl.timer){$timeout.cancel(ctrl.timer)}; ctrl.mode = "LOGIN";}

    ctrl.handlePwdtkLocked = function (pwdtkInfo) {
        ctrl.pwdtkInfo = pwdtkInfo
        ctrl.mode = "PWDTK_LOCKED";
        var handleCountDown = function() {
          var diff;
          diff = moment(moment.utc(ctrl.pwdtkInfo.fail_time)).add(ctrl.pwdtkInfo.lockout_time, 'seconds').diff(moment.utc());
          if (diff > 0) {
            ctrl.countDown = moment.utc(diff).format("HH[h]:mm[m]:ss[s]");
            ctrl.timer = $timeout(handleCountDown, 1000);
          } else {ctrl.countDown = '00h:00m:00s'; ctrl.mode = "LOGIN";}
        };
        handleCountDown()
    }

    var handleAuthenticationFail = function (response, username, password){
      ctrl.loginForm.$setPristine()
      ctrl.busy = false
      if (response.status == 403 && response.data.status == 'PWDTK_NEED_RENEW_PASSWORD'){
        ctrl.warningText = false
        ctrl.renewPassword(username, password)
      }
      else if (response.status == 403 && response.data.status == 'PWDTK_LOCKED'){
        ctrl.warningText = false
        ctrl.handlePwdtkLocked(response.data)
      }
      else if (response.status == 403 && response.data.detail == 'Change password failed'){
        notify({classes: ["alert-danger"], duration: 5000, message: $filter('translate')('RESET PASSWORD FAIL')});
      }
      else if (response.status == 422){
        ctrl.warningText = "No 2FA authentication method available, contact an administrator"
      }
      else if (response.status == 400 || response.status == 401){  // 400 can be removed when portail return 401 when mobile accept 401 ....
        ctrl.warningText = "Your username and password didn't match. Please try again"
      }
    }


    var handleAuthentication = function (response){
      ctrl.busy = false
      ctrl.warningText = false
      if (response.status == "LOGIN_DONE") {ctrl.busy = true; cacheService.resetCache(); ctrl.callback()}
      else if (response.status == "CODE_SENDED") { ctrl.mode = "2FA"; ctrl.sendMethod = response.send_method}
      else if (response.status == "METHOD_CHOICE") { ctrl.mode = "SELECT_METHOD"; ctrl.choices = response.choices; ctrl.sendMethod = ctrl.choices[0]}
      ctrl.ephemeral_token = response.ephemeral_token
    }

    ctrl.renewPassword = function (username, password) {
      $uibModal.open({
        templateUrl: 'admin/views/reset-password-template.html',
        controller: 'ResetPasswordModalCtrl',
        size: "lg",
        backdrop: 'static',
        keyboard: false,
        resolve: {
          username: function() {return username;},
          header: function() { return "Your current password has expired compared to Group Policy";},
          oldPassword: function() { return password;}
        }
      }).result.then(function(resetPasswordParams) {
        ctrl.busy = true;
        return Authentication.changePassword(_.assign(resetPasswordParams, {login_requested: true})).$promise.then(function(response) {
          notify({classes: ["alert-succes"], duration: 5000, message: $filter('translate')('RESET PASSWORD SUCCES')});
          handleAuthentication(response)
        }, function(response) {
          handleAuthenticationFail(response)
        });
      })
    }


    ctrl.submitLogin = function(username, password) {
      ctrl.busy = true
      Authentication.login({"username": username, "password": password}).$promise.then(
        handleAuthentication,
        function(response){ return handleAuthenticationFail(response, username, password)}
      );
    }

    ctrl.submit2FACode = function(code) {
      ctrl.busy = true
      Authentication.code({"ephemeral_token": ctrl.ephemeral_token, "code": code}).$promise.then(
        function(response) {
          ctrl.warningText = false
          cacheService.resetCache()
          ctrl.callback()
        },
        function(response) {
          ctrl.loginForm.$setPristine()
          ctrl.busy = false;
          ctrl.warningText = response.data.detail
          if (response.status == 498){
            ctrl.mode = "LOGIN"
          }
        }
      );
    }
  }]
});
'use strict';

angular.module("mhclientApp").component("certEditCertModal", {
  templateUrl: "certificate/views/cert-edit-modal.html",
  bindings: {resolve: '<', dismiss: '&', modalInstance: "<"},
  controller: ["$rootScope", "$http", "ExternalSync", function sendMailModalCtrl($rootScope, $http, ExternalSync){
    var ctrl = this;

    ctrl.certAlreadyExists =  function(cert) {
        return _.find(_.reject(ctrl.certificates, {id:cert.id}), {entity: cert.entity, sector: cert.sector, cert_type: cert.cert_type})
    }

    ctrl.$onInit = function () {
      ctrl.entities = ctrl.resolve.entities
      ctrl.sectors = ctrl.resolve.sectors
      ctrl.certificates = ctrl.resolve.certificates
      ctrl.certificate = ctrl.resolve.certificate || ctrl.resolve.query || {}
    };

    ctrl.saveCert = function (){
      var formData = new FormData();
      _.forOwn(ctrl.certificate, function(value, key) {
        if (!((key == "cert" || key == "key") && $rootScope.isString(value))){
          formData.append(key, (key == "metadata" || key == "cert_metadata") ? JSON.stringify(value) : (value === null ? "" : value))}
      }
      )
      ctrl.busy = true
      $http({
          url: "/api_rest/certificates" + (ctrl.certificate.id ? ("/"+ ctrl.certificate.id): ""),
          headers: {"Content-Type": undefined },
          data: formData,
          method: ctrl.certificate.id ? "PUT" : "POST"
      }).then (function(response){ ctrl.busy = false; ctrl.modalInstance.close(response.data)})
    }


  }],
});


angular.module("mhclientApp").component("certList", {
  templateUrl: "certificate/views/cert-list.html",
  bindings: {query: "<"},
  controller: ["Certificate", "Sector", "Entity", "$uibModal", function certListCtrl(Certificate, Sector, Entity, $uibModal){
    var ctrl = this;

    ctrl.editMedimailCert = function (certificate) {
        return $uibModal.open({
          animation  : true,
          component: 'certEditCertModal',
          backdrop: 'static',
          windowClass: 'modal-fullscreen',
          resolve: {
              certificate: function(){return _.cloneDeep(certificate)},
              entities: function(){return ctrl.entities},
              sectors: function(){return ctrl.sectors},
              certificates: function(){return ctrl.certificates},
              query: function(){return ctrl.query}
            }
        }).result.then(function (editedCertificate) {
          if (certificate) {_.remove(ctrl.certificates, certificate)}
          ctrl.certificates.push(editedCertificate)
          ctrl.certTypes = _.map(_.uniqBy(ctrl.certificates, "cert_type"), "cert_type")
        })

    }

    Sector.getSectors().then (function(sectors){
      Entity.getEntities().then  (function(entities){
        Certificate.query().$promise.then (function(certificates){
          ctrl.sectors = sectors
          ctrl.entities = entities
          ctrl.certificates = _.filter(certificates, ctrl.query)
          ctrl.certTypes = _.map(_.uniqBy(ctrl.certificates, "cert_type"), "cert_type")
          ctrl.selecteCertTypes = []
        })
      })
    })

  }],
});
'use strict';


angular.module("mhclientApp").component("conflictList", {
  templateUrl: "conflict/views/conflict-list.html",
  controller: ["Conflict", "ContentType", "$filter", function conflictListCtrl(Conflict, ContentType, $filter) {

    var ctrl = this;
    ctrl.nbShowItems = 80
    ctrl.incremental_items = 20
    ctrl.conflicts = []
    ctrl.addMoreItems = function(){if(ctrl.nbShowItems < ctrl.conflicts.length){ctrl.nbShowItems = ctrl.nbShowItems + ctrl.incremental_items}}

    ctrl.showDetails = function(conflict){
      conflict.deepDiff = conflict.deepDiff  || DeepDiff(conflict.old_data, conflict.new_data);
      conflict.showDetails = !conflict.showDetails
    }
    Conflict.query().$promise.then (function(conflicts){
      ContentType.query().$promise.then (function(contentTypes){
        var conflictsByContentTypeId = _.groupBy(conflicts, 'content_type')
        ctrl.availableContentTypes = _.map(_.uniq(_.map(conflicts, "content_type")), function(contentTypeId){
          var contentType = _.find(contentTypes, {id: parseInt(contentTypeId, 10)})
          contentType.label = $filter("translate")([contentType.app_label, contentType.model].join("."))
          return contentType
        })
        ctrl.availableStays = _.map(_.filter(_.uniqBy(conflicts, "stay"), "stay"), function(conflict){
          var meta = conflict.metadata
          return {"id": conflict.stay, "label": meta.patient_full_name + " (" + meta.patient_number + " - " + meta.stay_number + ")"}
        })

        var availableContentTypesById = _.keyBy(ctrl.availableContentTypes, 'id');
        ctrl.conflicts = _.orderBy(conflicts, ["created"], ["desc"])
        _.forEach(ctrl.conflicts, function(conflict) {conflict.content_type_label = availableContentTypesById[conflict.content_type].label})
      })
    })

  }],
  bindings: {},
});


angular.module("mhclientApp").component("conflictItem", {
  templateUrl: "conflict/views/conflict-item.html",
  controller: ["$rootScope", "Conflict", "ContentType", function conflictItemCtrl($rootScope, Conflict, ContentType) {

    var ctrl = this;
    ctrl.fetchDetails = function(){
      if (!ctrl.conflict.hasDetails){
        $rootScope.busy = true
        ctrl.conflict.deepDiff = DeepDiff(ctrl.conflict.old_data, ctrl.conflict.new_data)
        Conflict.getCurrentData({id: ctrl.conflict.id}).$promise.then(function(currentData){
          console.log(ctrl.conflict)
          if (ctrl.conflict.revision_number != currentData.revision_number){
            ctrl.currentConflict = DeepDiff(ctrl.conflict.old_data, currentData)
          }
          $rootScope.busy = false
          ctrl.conflict.hasDetails = true
        })
      }

    }


  }],
  bindings: {conflict: "<"},
});

angular.module("mhclientApp").component('diffWidget', {
  templateUrl: "conflict/views/diff-widget.html",
  bindings: {diff: '<'},
  controller: function() {}
});


angular.module("mhclientApp").factory("Conflict", ["$resource", "MhConfig", function ($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v2";
    return $resource('/api_rest/conflicts/:id/:route',
      {
        id : '@id'
      },
      {
        'get': {headers: {'Accept': acceptHeader}},
        'query': {headers: {'Accept': acceptHeader}, isArray: true},
        'save': {headers: {'Accept': acceptHeader}, method: 'POST'},
        'update': {headers: {'Accept': acceptHeader}, method:'PATCH'},
        'getCurrentData': {headers: {'Accept': acceptHeader}, params: {route:'get_current_data', id: '@id'}},


      }
    );
}]);

angular.module("mhclientApp").factory("ContentType", ["$resource", "MhConfig", function ($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v2";
    return $resource('/api_rest/content_types/:id/:route',
      {
        id : '@id'
      },
      {
        'get': {headers: {'Accept': acceptHeader}},
        'query': {headers: {'Accept': acceptHeader}, isArray: true},
      }
    );
}]);


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:PharmaceuticalAnalysis
* @description
* Component which displays the Pharmaceutical analysis
* **********************************************/


// TODO CHECK end_date
// allPrescsValid on pharma analysys for multi products
// collectionEndDate
// substitution after validation
// clean product.prepared_quantity
// No deliverys found ;)
// nothing to select info
// no stay related?? fix?? not found stay or patients?
// advertisement change  filter losse data
// PharmaDelivery.getMissing

angular.module("mhclientApp").component("dateTimeInput", {
  templateUrl: "core/components/views/date-time-input.html",
  bindings: { readonly: "<", required:"<"},
  controller: ["$rootScope", "Prescription", "Ordonnance", "Patient", "CollectionPlan", "Sector", "PrescUtils", "$q", "$filter", "$uibModal", function CollectionPlanStaysSelectionCtrl($rootScope, Prescription, Ordonnance, Patient, CollectionPlan, Sector, PrescUtils, $q, $filter, $uibModal) {
    var ctrl, handledDateMore1;
    ctrl = this;
    ctrl.date = new Date()
    // ctrl.changeDate =

  }]


});

angular.module("mhclientApp").component('textAngularMentions', {
  bindings: {
    ngModel: '=',
    mentionValues: '<',
    prefix: '@',
    trigger: '@',
    suffix: '@',
    taToolbar: '<?',
    onSelect: '&?'
  },
  template: '\
    <div class="mention-wrapper" style="position:relative;">\
      <text-angular\
        ng-model="$ctrl.ngModel"\
        class="ta-root"\
        ta-toolbar="[\
          [\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'p\', \'pre\', \'quote\'],\
          [\'bold\', \'italics\', \'underline\', \'strikeThrough\', \'ul\', \'ol\', \'redo\', \'undo\', \'clear\'],\
          [\'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'indent\', \'outdent\'],\
          [\'html\']\
        ]"\
      ></text-angular>\
      <div ng-if="$ctrl.showMenu"\
           class="mention-menu"\
           style="position: absolute; top: {{$ctrl.menuPosition.top}}px; left: {{$ctrl.menuPosition.left}}px;z-index: 1000;background: white;border: 1px solid #ccc;box-shadow: 0 2px 5px rgba(0,0,0,0.2);">\
          <div ng-repeat="item in $ctrl.filtered track by $index"\
              ng-click="$ctrl.insertMention(item)">\
            {{item.value}}\
          </div>\
      </div>\
    </div>\
  ',
  controller: ["$element", "$scope", "$timeout", function($element, $scope, $timeout) {
    var ctrl = this;
    ctrl.showMenu = false;
    ctrl.filtered = [];
    var savedRange = null;
    var editorEl = null;

    var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;

    ctrl.$onInit = function() {
      ctrl.taToolbar = ctrl.taToolbar || [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
        ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
        ['html']
      ];
    };

    function getCaretCoordinates(container) {
      var sel = window.getSelection();
      var node = sel.anchorNode;
      if (!node) return;
      if (node.nodeType === ELEMENT_NODE && node.tagName === "TEXTAREA") {
        return getCaretCoordinatesNew(node, node.selectionStart);
      } else {
        if (sel.rangeCount === 0) return null;
        var range = sel.getRangeAt(0).cloneRange();
        range.collapse(true);
        var rect = range.getClientRects()[0];
        if (!rect) {
          var editorRect = container.getBoundingClientRect();
          return { top: 0, left: 0 }; // fallback
        }
        var containerRect = container.getBoundingClientRect();
        return {
          top: rect.bottom - containerRect.top + container.scrollTop,
          left: rect.left - containerRect.left + container.scrollLeft
        };
      }
    }

    function getCaretCoordinatesNew(element, position, options) {
      if (typeof window === "undefined") {
        throw new Error('textarea-caret-position#getCaretCoordinates should only be called in a browser');
      }

      var debug = options && options.debug || false;

      if (debug) {
        var el = document.querySelector('#input-textarea-caret-position-mirror-div');
        if (el) {
          el.parentNode.removeChild(el);
        }
      }

      var div = document.createElement('div');
      div.id = 'input-textarea-caret-position-mirror-div';
      document.body.appendChild(div);

      var style = div.style;
      var computed = window.getComputedStyle ? window.getComputedStyle(element) : element.currentStyle;
      var isInput = element.nodeName === 'INPUT';

      style.whiteSpace = 'pre-wrap';
      if (!isInput) { style.wordWrap = 'break-word'; }
      style.position = 'absolute';
      if (!debug) { style.visibility = 'hidden'; }

      var properties = [
        "boxSizing", "width", "height", "overflowX", "overflowY",
        "borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth",
        "paddingTop", "paddingRight", "paddingBottom", "paddingLeft",
        "fontStyle", "fontVariant", "fontWeight", "fontStretch",
        "fontSize", "fontSizeAdjust", "lineHeight", "fontFamily",
        "textAlign", "textTransform", "textIndent", "letterSpacing", "wordSpacing"
      ];

      for (var i = 0; i < properties.length; i++) {
        var prop = properties[i];
        if (isInput && prop === 'lineHeight') {
          style.lineHeight = computed.height;
        } else {
          style[prop] = computed[prop];
        }
      }

      var isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
      if (isFirefox) {
        if (element.scrollHeight > parseInt(computed.height, 10)) {
          style.overflowY = 'scroll';
        }
      } else {
        style.overflow = 'hidden';
      }

      div.textContent = element.value.substring(0, position);
      if (isInput) {
        div.textContent = div.textContent.replace(/\s/g, ' ');
      }

      var span = document.createElement('span');
      span.textContent = element.value.substring(position) || '.';
      div.appendChild(span);

      var coordinates = {
        top: span.offsetTop + parseInt(computed['borderTopWidth'], 10),
        left: span.offsetLeft + parseInt(computed['borderLeftWidth'], 10),
        height: parseInt(computed['lineHeight'], 10)
      };
      if (debug) {
        span.style.backgroundColor = '#aaa';
      } else {
        document.body.removeChild(div);
      }

      return coordinates;
    }

    function saveSelection() {
      var sel = window.getSelection();
      if (sel.rangeCount > 0) {
        savedRange = sel.getRangeAt(0);
      }
    }

    function onEditorInput(e) {
      saveSelection();
      var sel = window.getSelection();
      var node = sel.anchorNode;
      if (!node) return;
      var text = "";
      var caretPos = 0;

      if (node.nodeType === TEXT_NODE) {
        text = node.textContent;
        caretPos = sel.anchorOffset;
      } else if (node.nodeType === ELEMENT_NODE && node.tagName === "TEXTAREA") {
        text = node.value;
        caretPos = node.selectionStart;
      } else if (node.nodeType === ELEMENT_NODE) {
        text = node.innerText || node.textContent;
        caretPos = sel.anchorOffset;
      }

      var before = text.substring(0, caretPos);
      var match = before.match(new RegExp(ctrl.trigger + '(\\w*)$'));
      if (match) {
        var term = match[1].toLowerCase();
        ctrl.filtered = ctrl.mentionValues.filter(function(v) {
          return v.value.toLowerCase().indexOf(term) === 0;
        });
        ctrl.showMenu = ctrl.filtered.length > 0;
        ctrl.menuPosition = getCaretCoordinates($element[0].querySelector('.mention-wrapper'));
        $scope.$applyAsync();
      } else {
        ctrl.showMenu = false;
        $scope.$applyAsync();
      }
    }

    function attachEditorListeners() {
      if (!editorEl) return;
      editorEl.addEventListener('keyup', onEditorInput);
      editorEl.addEventListener('mouseup', saveSelection);
    }

    function detachEditorListeners() {
      if (!editorEl) return;
      editorEl.removeEventListener('keyup', onEditorInput);
      editorEl.removeEventListener('mouseup', saveSelection);
    }

    function refreshEditorElement() {
      detachEditorListeners();
      var list = $element[0].querySelectorAll('.ta-text, .ta-editor');
      var arr = Array.prototype.slice.call(list);
      editorEl = null;
      for (var i = 0; i < arr.length; i++) {
        var el = arr[i];
        if (window.getComputedStyle(el).display !== 'none') {
          editorEl = el;
          break;
        }
      }
      attachEditorListeners();
    }

    ctrl.$postLink = function() {
      refreshEditorElement();
      var observer = new MutationObserver(function() {
        var list = $element[0].querySelectorAll('.ta-text, .ta-editor');
        var arr = Array.prototype.slice.call(list);
        var newEditor = null;
        for (var i = 0; i < arr.length; i++) {
          if (window.getComputedStyle(arr[i]).display !== 'none') {
            newEditor = arr[i];
            break;
          }
        }
        if (newEditor && newEditor !== editorEl) {
          refreshEditorElement();
        }
      });

      observer.observe($element[0], { childList: true, subtree: true });
    };

    ctrl.insertMention = function(item) {
      var mentionText = ctrl.prefix + item.value + ctrl.suffix;

      $timeout(function() {
        if (!editorEl) return;
        editorEl.focus();

        if (savedRange) {
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(savedRange);

          var text, caretPos;
          var node = sel.anchorNode;

          if (node.nodeType === ELEMENT_NODE && node.tagName === "TEXTAREA") {
            caretPos = node.selectionStart;
            text = node.value;
          } else {
            caretPos = sel.anchorOffset;
            text = node.textContent;
          }

          var before = text.substring(0, caretPos);
          var match = before.match(new RegExp(ctrl.trigger + '(\\w*)$'));
          if (match) {
            if (node.nodeType === ELEMENT_NODE && node.tagName === "TEXTAREA") {
              var prefixStart = caretPos - match[0].length;
              var after = node.value.substring(caretPos);
              node.value = node.value.substring(0, prefixStart) + "" + after;
              node.selectionStart = node.selectionEnd = prefixStart;
              node.focus();
            } else {
              var range = sel.getRangeAt(0);
              range.setStart(node, caretPos - match[0].length);
              range.deleteContents();
            }
          }
        }

        document.execCommand('insertText', false, mentionText);

        if (ctrl.onSelect) {
          ctrl.onSelect({ item: item });
        }

        ctrl.showMenu = false;
      });
    };
  }]
});

angular.module("mhclientApp").component("advancedFilterByProperty", {
  templateUrl: "core/components/views/advanced-filter-by-property.html",
  bindings: { showHasSelected: "<?", disabled:"<", displayLabel: "<", parenthesis: "<", label: "<", items: "<", property:"<", disableReset: "<?", selectedItemsByProperty: "=", appendToBody: "<", disableSearch: "<", callback: '&', allowNull: "<"},
  controller: ["$rootScope", "$timeout", "$filter", function advancedFilterByPropertyCtrl($rootScope, $timeout, $filter) {
    var ctrl, search;
    ctrl = this;

    var genNullItem = function(){
        var item = {}
        item[ctrl.displayLabel] = $filter("translate")("NONE")
        item[ctrl.property] = null
        item.isNone = true
        return item
    }

    var getItems = function() {
      if (ctrl.property)
        return _.uniqBy(ctrl.items, ctrl.property)
      return _.clone(ctrl.items)
    }

    ctrl.$onChanges = function(changes) {
      if (changes.items) {
        if (ctrl.items){

          ctrl.availableItems = getItems()
          if (ctrl.allowNull) {ctrl.availableItems = _.concat(ctrl.availableItems, ctrl.property ?  [genNullItem()] : [null])}
          if (ctrl.property){
            ctrl.selectedItemsByProperty = _.filter(ctrl.selectedItemsByProperty || [], function(value) {search = {}; search[ctrl.property] = value; return _.find(ctrl.availableItems, search)})
            ctrl.selectedItems = _.map(ctrl.selectedItemsByProperty, function(itemProperty) { search = {} ; search[ctrl.property] = itemProperty; return _.remove(ctrl.availableItems, search)[0]});
          }
          else{
            ctrl.selectedItems = _.filter(ctrl.selectedItemsByProperty || [], function(value) {_.indexOf(ctrl.availableItems, value) > -1})
            ctrl.availableItems = _.difference(ctrl.availableItems, ctrl.selectedItems);
            ctrl.selectedItemsByProperty = ctrl.selectedItems
          }
        }
      }
    }

    ctrl.searchText = "";
    ctrl.isOpen = false;
    ctrl.searchMinLength = ctrl.searchMinLength || 0;

    ctrl.toggled = function(isOpen){ctrl.isOpen = isOpen}
    ctrl.cleanSelection = function () {
      ctrl.selectedItems = []; ctrl.selectedItemsByProperty = []; ctrl.availableItems = getItems();
      if (ctrl.allowNull) {ctrl.availableItems = _.concat(ctrl.availableItems, ctrl.property ?  [genNullItem()] : [null])}
      if (ctrl.callback) { $timeout(function() {ctrl.callback({selectedItemsByProperty: ctrl.selectedItemsByProperty})})}
    }

    ctrl.selecItem = function(item) {
      if (ctrl.property){
        ctrl.selectedItems.push(_.remove(ctrl.availableItems, item)[0]); ctrl.selectedItemsByProperty.push(item[ctrl.property]);
      }
      else{
        ctrl.availableItems.splice(_.indexOf(ctrl.availableItems, item), 1);
        ctrl.selectedItems.push(item);
      }
      if (ctrl.callback) { ctrl.callback({selectedItemsByProperty: ctrl.selectedItemsByProperty})}
    }
    ctrl.unselectItem = function(item) {
      if (ctrl.property){
        ctrl.availableItems.push(_.remove(ctrl.selectedItems, item)[0]); ctrl.selectedItemsByProperty.splice(_.indexOf(ctrl.selectedItemsByProperty, item[ctrl.property]), 1);
      }
      else{
        ctrl.selectedItems.splice(_.indexOf(ctrl.selectedItems, item), 1);
        ctrl.availableItems.push(item);
      }
      if (ctrl.callback) { ctrl.callback({selectedItemsByProperty: ctrl.selectedItemsByProperty})}
    }
  }]

});

angular.module("mhclientApp").component("mhDatepickerV2", {
  templateUrl: "core/components/views/mh-datepicker-v2.html",
  controller: CoreMhDatepickerV2Ctrl,
  bindings: {
    // from lib
    altInputFormat: "@?",
    clearText: "@?",
    closeOnDateSelection: "<?",
    closeText: "@?",
    currentText: "@?",
    datepickerAppendToBody: "<?",
    // Check https://angular-ui.github.io/bootstrap/ Datepicker Popup for options
    datepickerOptions: "<?",
    datepickerTemplateUrl: "@?",
    ngModel: "<?",
    onOpenFocus: "<?",
    showButtonBar: "<?",
    type: "@?",
    popupPlacement: "@?",
    displayFormat: "@?",
    dNgrequired: "<?",
    // custom
    dNgReadonly: "<?",
    dNgDisabled: "<?",
    placeholder: "@?",
    minDate: "<?",
    maxDate: "<?",
  },
  require: { ngModelCtrl: "ngModel" },
});

// Made from: https://angular-ui.github.io/bootstrap/
function CoreMhDatepickerV2Ctrl($filter, $scope) {
  var ctrl = this;

  $scope.isModalOpen = false;

  $scope.handleClick = handleClick;
  $scope.handleOnChange = handleOnChange;

  ctrl.$onInit = initDefaultBindings;

  function initDefaultBindings() {
    ctrl.clearText = ctrl.clearText || $filter("translate")("DATEPICKER_CLEAR");
    ctrl.closeText = ctrl.closeText || $filter("translate")("DATEPICKER_CLOSE");
    ctrl.currentText =
      ctrl.currentText || $filter("translate")("DATEPICKER_TODAY");
    ctrl.altInputFormat = ctrl.altInputFormat || ["M!/d!/yyyy"];
    ctrl.closeOnDateSelection = ctrl.closeOnDateSelection || true;
    ctrl.datepickerAppendToBody = ctrl.datepickerAppendToBody || false;
    ctrl.datepickerOptions = ctrl.datepickerOptions || {
      minDate: ctrl.minDate,
      maxDate: ctrl.maxDate,
    };
    ctrl.displayFormat = ctrl.displayFormat || "dd/MM/yyyy";
    ctrl.onOpenFocus = ctrl.onOpenFocus || false;
    ctrl.showButtonBar = ctrl.showButtonBar || true;
    ctrl.type = ctrl.type || "text";
    ctrl.popupPlacement = ctrl.popupPlacement || "auto bottom-left";
    ctrl.dNgrequired = ctrl.dNgrequired || false;
    ctrl.dNgReadonly = ctrl.dNgReadonly || false;
    ctrl.dNgDisabled = ctrl.dNgDisabled || false;
    ctrl.placeholder = ctrl.placeholder || "dd/mm/yyyy";
  }

  function handleOnChange() {
    // Allow to change model
    // https://stackoverflow.com/questions/44594532/how-to-add-ng-model-functionality-to-a-component
    // https://docs.angularjs.org/guide/forms#implementing-custom-form-controls-using-ngmodel-
    ctrl.ngModelCtrl.$setViewValue(ctrl.ngModel);
  }

  function handleClick() {
    if (ctrl.dNgReadonly) return;

    openModal();
  }

  function openModal() {
    $scope.isModalOpen = true;
  }
}

angular.module("mhclientApp").component("coreSortingIcon", {
  templateUrl: "core/components/views/sorting-icon.html",
  controller: coreSortingIcon,
  bindings: {
    order: "@",
    sorting: "<",
  },
});

function coreSortingIcon() {}

"use strict";

angular.module("mhclientApp").factory("SortingService", SortingServiceFactory);

function SortingServiceFactory() {
  /**
   * Get the direction ('desc' or 'asc') from the ordering (Django based).
   * Can be used with the sortingIcon component.
   *
   * @param ordering: (Optional) Django based ordering like 'name' or '-name'
   * @returns 'desc' or 'asc' or null if no ordering given
   */
  function getSortingDirectionFromOrdering(ordering) {
    if (ordering == null) return null;

    if (ordering.startsWith("-")) return "desc";

    return "asc";
  }

  /**
   * Get Django based ordering for a sorting object (with an order and a direction)
   * @param sorting
   */
  function getOrderingFromSorting(sorting) {
    var ordering = sorting.order;

    if (sorting.direction === "desc") {
      ordering = "-" + ordering;
    }

    return ordering;
  }

  function getToggledSortingDirection(direction) {
    if (direction === "asc") {
      return "desc";
    }

    return "asc";
  }

  /**
   * Get a new sorting based on the current one and the order selected
   * @param currentSorting (ex: { order: 'name', direction: 'asc' })
   * @param order: name of the order selected (ex: 'name')
   * @param defaultDirection: (Optional) the default direction in case the order selected
   * is not the one of the current sorting
   */
  function getNewSorting(currentSorting, order, defaultDirection) {
    if (defaultDirection == null) {
      defaultDirection = "asc";
    }

    if (order !== currentSorting.order) {
      return {
        order: order,
        direction: defaultDirection,
      };
    }

    // Reset if descending
    if (order === currentSorting.order && currentSorting.direction === "desc") {
      return {
        order: undefined,
        direction: undefined,
      };
    }

    return {
      order: currentSorting.order,
      direction: getToggledSortingDirection(currentSorting.direction),
    };
  }

  return {
    getSortingDirectionFromOrdering: getSortingDirectionFromOrdering,
    getOrderingFromSorting: getOrderingFromSorting,
    getToggledSortingDirection: getToggledSortingDirection,
    getNewSorting: getNewSorting,
  };
}

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.filter:cleanUnicode
    * @description
    * # cleanUnicode
    * Sanitizes a string by escaping quotes and parsing to clean Unicode characters
   */
  angular.module('mhclientApp').filter('cleanUnicode', function() {
    return function(word) {
      var e, error;
      try {
        return JSON.parse('"' + word.replace(/"/g, '\\"') + '"');
      } catch (error) {
        e = error;
        return word;
      }
    };
  });

}).call(this);

//# sourceMappingURL=clean-unicode-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:age
    * @description
    * display age from date
   */
  angular.module('mhclientApp').filter('escapeHtml', ["$filter", function($filter) {
    return function(input) {
      return _.escape(input);
    };
  }]);

}).call(this);

//# sourceMappingURL=escape-html-filter.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:duplicate-input-validator
    * @description
    * # Draw
    * Directive to validate inputs
   */
  angular.module('mhclientApp').directive('checkDuplicate', function() {
    return {
      require: 'ngModel',
      link: function(scope, elem, attrs, ngModel) {
        var blacklist;
        blacklist = scope.$eval(attrs.checkDuplicate);
        ngModel.$parsers.unshift(function(value) {
          ngModel.$setValidity('blacklist', blacklist.indexOf(value) === -1);
          return value;
        });
        ngModel.$formatters.unshift(function(value) {
          ngModel.$setValidity('blacklist', blacklist.indexOf(value) === -1);
          return value;
        });
      }
    };
  });

}).call(this);

//# sourceMappingURL=duplicate-input-validator-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:autoCompleteText
    * @description
    * #
    * Directive for auto complete text
   */
  angular.module('mhclientApp').directive('singleChoiceDropdown', ["$filter", function($filter) {
    var link;
    link = function($scope, element, attrs, transclude) {
      $scope.searchMinLength = $scope.searchMinLength || 0;
      $scope.isOpen = false;
      return $scope.toggled = function(open) {
        return $scope.isOpen = open;
      };
    };
    return {
      link: link,
      transclude: true,
      scope: {
        displayLabel: "=?",
        items: "=?",
        selectedItem: "=?",
        callBack: "=?",
        label: "=?",
        searchMinLength: "=?",
        allowReverse: "=?",
        extraFilter: "=?",
        disableSearch: "=?",
        platform: "=?"
      },
      template: '<div uib-dropdown on-toggle="toggled(open)"> <button id="simple-dropdown" uib-dropdown-toggle type="button" class="btn btn-default filter-button"> <div class="pull-left filter-button-label">{{label | translate}}: {{displayLabel ? selectedItem[displayLabel] : selectedItem}}</div> <span class="caret"></span> </button> <ul class="dropdown-menu" aria-labelledby="simple-dropdown" uib-dropdown-menu ng-click="$event.stopPropagation()"> <span ng-if="isOpen"> <span ng-show="::!disableSearch"><label>{{"SEARCH" | translate}}</label><input focus-on=":: platform == \'mhsi\'" mgapp-keyboard type="text" ng-init="searchText=\'\'" ng-model="searchText"></span> <li ng-if="allowReverse"> <span class="dropdown-option"> <label for="REVERSE_ORDER">{{:: "REVERSE_ORDER" | translate }} </label> <input ng-value="item" ng-model="extraFilter.reverse" id="REVERSE_ORDER" class="pull-right" type="checkbox"/> </span> </li> <span ng-init="limitTo = 40" infinite-scroll-immediate-check="true" infinite-scroll="limitTo = limitTo + 40" infinite-scroll-distance="1" infinite-scroll-parent="true" ng-show="searchText.length >= searchMinLength"> <li ng-repeat="item in items | filterByProperty: searchText :displayLabel | orderBy:displayLabel | limitTo:limitTo"> <span class="dropdown-option"> <label for="{{:: label+\'_index_\'+$index}}">{{:: displayLabel ? item[displayLabel] : item}} </label> <input ng-value="item" ng-model="$parent.$parent.selectedItem" id="{{:: label+\'_index_\'+$index}}" class="pull-right" type="radio"/> </span> </li> </span> </ul> </span> </div>'
    };
  }]);

  angular.module('mhclientApp').directive('advancedFilter', ["$filter", function($filter) {
    var link;
    link = function($scope, element, attrs, transclude) {
      $scope.searchMinLength = $scope.searchMinLength || 0;
      $scope.isOpen = false;
      $scope.toggled = function(open) {
        return $scope.isOpen = open;
      };
      $scope.toggleObject = function(entry, list, callBack) {
        if (entry.checked) {
          list.push(entry);
        } else {
          _.remove(list, entry);
        }
        if (callBack) {
          return callBack();
        }
      };
      return $scope.cleanSelection = function(valuesList, callBack) {
        _.forEach(valuesList, function(obj) {
          return _.set(obj, 'checked', false);
        });
        valuesList.splice(0, valuesList.length);
        if (callBack) {
          return callBack();
        }
      };
    };
    return {
      link: link,
      transclude: true,
      scope: {
        displayLabel: "=?",
        items: "=?",
        selectedItems: "=?",
        callBack: "=?",
        appendToBody: "=?",
        label: "=?",
        searchMinLength: "=?",
        platform: "=?",
        disableSearch: "=?"
      },
      template: '<div uib-dropdown dropdown-append-to-body="appendToBody || false" on-toggle="toggled(open)"> <button id="simple-dropdown" ng-class="selectedItems.length > 0 ? \'btn-warning\' : \'btn-default\'"  uib-dropdown-toggle type="button" class="btn filter-button"> <div class="pull-left filter-button-label">{{label | translate}}</div> <span class="caret"></span> </button> <ul class="dropdown-menu"  ng-class="::{\'apenned-to-body\' : appendToBody}" aria-labelledby="simple-dropdown" uib-dropdown-menu ng-click="$event.stopPropagation()"> <span ng-if="isOpen"> <span ng-show="!disableSearch"> <label style="padding-right: 5px">{{"SEARCH" | translate}}</label><input style="margin-bottom: 5px;" focus-on="::platform == \'mhsi\'" mgapp-keyboard type="text" ng-init="searchText=\'\'" ng-model="searchText"> </span> <li ng-if="selectedItems.length > 0"> <span class="dropdown-option"> <input ng-click="cleanSelection(selectedItems, callBack)" class="pull-right" type="radio"/> <label ng-click="cleanSelection(selectedItems, callBack)">{{:: "ALL" | translate}}</label> </span> </li> <li ng-repeat="item in selectedItems | orderBy: displayLabel"> <span class="dropdown-option"> <label for="{{:: label+\'_selected_index_\'+$index}}">{{:: item[displayLabel] }}</label> <input ng-model="item.checked" id="{{:: label+\'_selected_index_\'+$index}}" ng-change="toggleObject(item, selectedItems, callBack)" class="pull-right" type="checkbox"/> </span> </li> <span ng-init="limitTo = 40" infinite-scroll-immediate-check="true" infinite-scroll="limitTo = limitTo + 40" infinite-scroll-distance="1" infinite-scroll-parent="true" ng-show="searchText.length >= searchMinLength"> <hr ng-if="selectedItems.length > 0"> <li ng-repeat="item in items | filter:{ checked: \'!true\'} | filterByProperty: searchText :displayLabel | orderBy:displayLabel | limitTo:limitTo"> <span class="dropdown-option"> <label for="{{:: label+\'_index_\'+$index}}">{{:: item[displayLabel] }}</label> <input ng-model="item.checked" id="{{:: label+\'_index_\'+$index}}" ng-change="toggleObject(item, selectedItems, callBack)" class="pull-right" type="checkbox"/> </span> </li> </span> </ul> </span> </div>'
    };
  }]);

  angular.module('mhclientApp').filter('filterDate', function() {
    return function(items, dFrom, dTo) {
      var _dFrom, _dTo;
      if (dFrom) {
        _dFrom = moment(dFrom).format("YYYY-MM-DD");
        items = _.filter(items, function(item) {
          return (item.original_timestamp || "").substring(0, 10) >= _dFrom;
        });
      }
      if (dTo) {
        _dTo = moment(dTo).format("YYYY-MM-DD");
        items = _.filter(items, function(item) {
          return (item.original_timestamp || "").substring(0, 10) <= _dTo;
        });
      }
      return items;
    };
  });

  angular.module('mhclientApp').filter('filterEmpty', function() {
    return function(items, viewValue, key) {
      if (!viewValue || viewValue === " " || viewValue === null) {
        return items;
      } else {
        return _.filter(items, function(item) {
          return (key ? item[key] : item).toLowerCase().indexOf(viewValue.toLowerCase()) >= 0;
        });
      }
    };
  });

  angular.module('mhclientApp').filter('orderObjectBy', function() {
    return function(items, field, reverse) {
      var filtered;
      filtered = [];
      angular.forEach(items, function(item) {
        filtered.push(item);
      });
      filtered.sort(function(a, b) {
        if (a[field] > b[field]) {
          return 1;
        } else {
          return -1;
        }
      });
      if (reverse) {
        filtered.reverse();
      }
      return filtered;
    };
  });

  angular.module('mhclientApp').filter('filterByProperty', function() {
    return function(items, searchText, property) {
      var filtered, i, item, len;
      if ((searchText == null) || searchText.length === 0 || searchText === ' ') {
        return items;
      }
      if (!items) {
        return;
      }
      filtered = [];
      for (i = 0, len = items.length; i < len; i++) {
        item = items[i];
        if (_.get(item, property).toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
          filtered.push(item);
        }
      }
      return filtered;
    };
  });

  angular.module('mhclientApp').filter('handleLineBreaks', function() {
    return function(text) {
      if (text !== void 0) {
        return text.replace(/\n/g, '<br>');
      }
    };
  });

}).call(this);

//# sourceMappingURL=advanced-filter-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:autoCompleteText
    * @description
    * #
    * Directive for auto complete text
   */
  angular.module('mhclientApp').directive('autoCompleteText', ["$filter", function($filter) {
    var link;
    link = function($scope, element, attrs) {
      var getCaretCoordinates, hideMenu, isBrowser, isFirefox, properties, searchRegexp, searchText, showMenu, textArea;
      $scope.menu = null;
      searchRegexp = /^\w*$/;
      searchText = "";
      $scope.triggerCharacter = $scope.triggerCharacter || "{";
      $scope.prefix = $scope.prefix || "{data.";
      textArea = element.find("textarea");
      $scope.availableChoices = $scope.choices;
      hideMenu = function() {
        searchText = "";
        return $scope.$evalAsync(function() {
          return $scope.menu = null;
        });
      };
      textArea.on('blur', function(key) {
        if ($scope.menu) {
          return $scope.menu.lastCaretPosition = textArea[0].selectionStart;
        }
      });
      textArea.on('keypress', function(event) {
        if (event.key === $scope.triggerCharacter) {
          return showMenu();
        }
      });
      textArea.on('input', function(event) {
        var cursor;
        if ($scope.menu) {
          if (event.target.value[$scope.menu.triggerCharacterPosition] !== $scope.triggerCharacter) {
            return hideMenu();
          } else {
            cursor = textArea[0].selectionStart;
            if (cursor < $scope.menu.triggerCharacterPosition) {
              return hideMenu();
            } else {
              searchText = event.target.value.slice($scope.menu.triggerCharacterPosition + 1, cursor);
              if (!searchText.match(searchRegexp)) {
                return hideMenu();
              } else {
                return $scope.$evalAsync(function() {
                  return $scope.menu.choices = $filter('filter')($scope.availableChoices, searchText);
                });
              }
            }
          }
        }
      });
      $scope.selectChoice = function(choice) {
        var caretPosition, end, label, setCursorAt, start, startIndex, textarea, value;
        label = $scope.prefix + (typeof choice === 'object' ? choice.key : choice) + "}";
        textarea = textArea[0];
        value = textarea.value;
        startIndex = $scope.menu.triggerCharacterPosition;
        start = value.slice(0, startIndex);
        caretPosition = $scope.menu.lastCaretPosition || textarea.selectionStart;
        end = value.slice(caretPosition);
        textarea.value = start + label + end;
        textarea.dispatchEvent(new Event('input'));
        hideMenu();
        setCursorAt = (start + label).length;
        textarea.setSelectionRange(setCursorAt, setCursorAt);
        return textarea.focus();
      };
      showMenu = function() {
        var left, lineHeight, ref, top;
        if (!$scope.menu) {
          $scope.menu = {
            triggerCharacterPosition: textArea[0].selectionStart
          };
          lineHeight = +getComputedStyle(textArea[0]).lineHeight.replace(/px$/, '');
          ref = getCaretCoordinates(textArea[0], textArea[0].selectionStart), top = ref.top, left = ref.left;
          return $scope.menu.position = {
            top: top + lineHeight,
            left: left
          };
        }
      };
      properties = ['direction', 'boxSizing', 'width', 'height', 'overflowX', 'overflowY', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderStyle', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize', 'fontSizeAdjust', 'lineHeight', 'fontFamily', 'textAlign', 'textTransform', 'textIndent', 'textDecoration', 'letterSpacing', 'wordSpacing', 'tabSize', 'MozTabSize'];
      isBrowser = typeof window !== 'undefined';
      isFirefox = isBrowser && window.mozInnerScreenX !== null;
      return getCaretCoordinates = function(element, position, options) {
        var computed, coordinates, debug, div, el, isInput, span, style;
        if (!isBrowser) {
          throw new Error('textarea-caret-position#getCaretCoordinates should only be called in a browser');
        }
        debug = options && options.debug || false;
        if (debug) {
          el = document.querySelector('#input-textarea-caret-position-mirror-div');
          if (el) {
            el.parentNode.removeChild(el);
          }
        }
        div = document.createElement('div');
        div.id = 'input-textarea-caret-position-mirror-div';
        document.body.appendChild(div);
        style = div.style;
        computed = window.getComputedStyle ? window.getComputedStyle(element) : element.currentStyle;
        isInput = element.nodeName === 'INPUT';
        style.whiteSpace = 'pre-wrap';
        if (!isInput) {
          style.wordWrap = 'break-word';
        }
        style.position = 'absolute';
        if (!debug) {
          style.visibility = 'hidden';
        }
        properties.forEach(function(prop) {
          if (isInput && prop === 'lineHeight') {
            style.lineHeight = computed.height;
          } else {
            style[prop] = computed[prop];
          }
        });
        if (isFirefox) {
          if (element.scrollHeight > parseInt(computed.height)) {
            style.overflowY = 'scroll';
          }
        } else {
          style.overflow = 'hidden';
        }
        div.textContent = element.value.substring(0, position);
        if (isInput) {
          div.textContent = div.textContent.replace(/\s/g, ' ');
        }
        span = document.createElement('span');
        span.textContent = element.value.substring(position) || '.';
        div.appendChild(span);
        coordinates = {
          top: span.offsetTop + parseInt(computed['borderTopWidth']),
          left: span.offsetLeft + parseInt(computed['borderLeftWidth']),
          height: parseInt(computed['lineHeight'])
        };
        if (debug) {
          span.style.backgroundColor = '#aaa';
        } else {
          document.body.removeChild(div);
        }
        return coordinates;
      };
    };
    return {
      link: link,
      transclude: true,
      scope: {
        data: "=?",
        prefix: "@?",
        choices: "=?"
      },
      template: '<textarea class="form-control" required type="text" ng-model="data"></textarea> <span class="open" style="display: block;"> <ul ng-if="menu && menu.choices.length > 0" class="dropdown-menu" ng-style="{left: menu.position.left + \'px\',  top: menu.position.top + \'px\'}"> <li ng-repeat="choice in menu.choices" ng-class="{active: activeChoice === choice}"> <a ng-click="selectChoice(choice)"> {{ choice.label || choice }} </a> </li> </ul> </span>'
    };
  }]);

  angular.module('mhclientApp').directive('autoCompleteRichText', ["$filter", function($filter) {
    var link;
    link = function($scope, element, attrs) {
      var getCaretCoordinates, hideMenu, isBrowser, isFirefox, properties, searchRegexp, searchText, showMenu, textAngular, textArea;
      $scope.menu = null;
      searchRegexp = /^\w*$/;
      searchText = "";
      $scope.triggerCharacter = $scope.triggerCharacter || "{";
      $scope.prefix = $scope.prefix || "{data.";
      textAngular = element.find("text-angular");
      textArea = textAngular.find("textarea");
      $scope.availableChoices = $scope.choices;
      hideMenu = function() {
        searchText = "";
        return $scope.$evalAsync(function() {
          return $scope.menu = null;
        });
      };
      textAngular.on('blur', function(key) {
        if ($scope.menu) {
          return $scope.menu.lastCaretPosition = textArea[0].selectionStart;
        }
      });
      textAngular.on('keypress', function(event) {
        if (event.key === $scope.triggerCharacter) {
          return showMenu();
        }
      });
      textAngular.on('input', function(event) {
        var cursor;
        if ($scope.menu) {
          if (event.target.value[$scope.menu.triggerCharacterPosition] !== $scope.triggerCharacter) {
            return hideMenu();
          } else {
            cursor = textArea[0].selectionStart;
            if (cursor < $scope.menu.triggerCharacterPosition) {
              return hideMenu();
            } else {
              searchText = event.target.value.slice($scope.menu.triggerCharacterPosition + 1, cursor);
              if (!searchText.match(searchRegexp)) {
                return hideMenu();
              } else {
                return $scope.$evalAsync(function() {
                  return $scope.menu.choices = $filter('filter')($scope.availableChoices, searchText);
                });
              }
            }
          }
        }
      });
      $scope.selectChoice = function(choice) {
        var caretPosition, end, label, setCursorAt, start, startIndex, textarea, value;
        label = $scope.prefix + (typeof choice === 'object' ? choice.key : choice) + "}";
        textarea = textArea[0];
        value = textarea.value;
        startIndex = $scope.menu.triggerCharacterPosition;
        start = value.slice(0, startIndex);
        caretPosition = $scope.menu.lastCaretPosition || textarea.selectionStart;
        end = value.slice(caretPosition);
        textarea.value = start + label + end;
        textarea.dispatchEvent(new Event('input'));
        hideMenu();
        setCursorAt = (start + label).length;
        textarea.setSelectionRange(setCursorAt, setCursorAt);
        return textarea.focus();
      };
      showMenu = function() {
        var left, lineHeight, ref, top;
        if (!$scope.menu) {
          $scope.menu = {
            triggerCharacterPosition: textArea[0].selectionStart
          };
          lineHeight = +getComputedStyle(textArea[0]).lineHeight.replace(/px$/, '');
          ref = getCaretCoordinates(textArea[0], textArea[0].selectionStart), top = ref.top, left = ref.left;
          return $scope.menu.position = {
            top: top + lineHeight,
            left: left
          };
        }
      };
      properties = ['direction', 'boxSizing', 'width', 'height', 'overflowX', 'overflowY', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderStyle', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize', 'fontSizeAdjust', 'lineHeight', 'fontFamily', 'textAlign', 'textTransform', 'textIndent', 'textDecoration', 'letterSpacing', 'wordSpacing', 'tabSize', 'MozTabSize'];
      isBrowser = typeof window !== 'undefined';
      isFirefox = isBrowser && window.mozInnerScreenX !== null;
      return getCaretCoordinates = function(element, position, options) {
        var computed, coordinates, debug, div, el, isInput, span, style;
        if (!isBrowser) {
          throw new Error('textarea-caret-position#getCaretCoordinates should only be called in a browser');
        }
        debug = options && options.debug || false;
        if (debug) {
          el = document.querySelector('#input-textarea-caret-position-mirror-div');
          if (el) {
            el.parentNode.removeChild(el);
          }
        }
        div = document.createElement('div');
        div.id = 'input-textarea-caret-position-mirror-div';
        document.body.appendChild(div);
        style = div.style;
        computed = window.getComputedStyle ? window.getComputedStyle(element) : element.currentStyle;
        isInput = element.nodeName === 'INPUT';
        style.whiteSpace = 'pre-wrap';
        if (!isInput) {
          style.wordWrap = 'break-word';
        }
        style.position = 'absolute';
        if (!debug) {
          style.visibility = 'hidden';
        }
        properties.forEach(function(prop) {
          if (isInput && prop === 'lineHeight') {
            style.lineHeight = computed.height;
          } else {
            style[prop] = computed[prop];
          }
        });
        if (isFirefox) {
          if (element.scrollHeight > parseInt(computed.height)) {
            style.overflowY = 'scroll';
          }
        } else {
          style.overflow = 'hidden';
        }
        div.textContent = element.value.substring(0, position);
        if (isInput) {
          div.textContent = div.textContent.replace(/\s/g, ' ');
        }
        span = document.createElement('span');
        span.textContent = element.value.substring(position) || '.';
        div.appendChild(span);
        coordinates = {
          top: span.offsetTop + parseInt(computed['borderTopWidth']),
          left: span.offsetLeft + parseInt(computed['borderLeftWidth']),
          height: parseInt(computed['lineHeight'])
        };
        if (debug) {
          span.style.backgroundColor = '#aaa';
        } else {
          document.body.removeChild(div);
        }
        return coordinates;
      };
    };
    return {
      link: link,
      transclude: true,
      scope: {
        data: "=?",
        prefix: "@?",
        choices: "=?",
        taToolbar: "@"
      },
      template: '<text-angular class="ta-root" class="ta-root" ta-toolbar="{{::taToolbar}}" required type="text" ng-model="data"></text-angular> <span class="open" style="display: block;"> <ul ng-if="menu && menu.choices.length > 0" class="dropdown-menu" ng-style="{left: menu.position.left + \'px\',  top: menu.position.top + \'px\'}"> <li ng-repeat="choice in menu.choices" ng-class="{active: activeChoice === choice}"> <a ng-click="selectChoice(choice)"> {{ choice.label || choice }} </a> </li> </ul> </span>'
    };
  }]);

}).call(this);

//# sourceMappingURL=auto-complete-text-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:logger
    * @description
    * # logger
    * Provider of logger
   */

  /*
    * python debug = console.debug
    * python info = console.log || console.info
    * python warning = console.warning || console.warn
    * python error = console.error
    * python exception = console.exception || console.trace # not working
   */
  var slice = [].slice;

  angular.module("mhclientApp").factory('Logger', ["MhConfig", "$injector", function(MhConfig, $injector) {
    var acceptHeader, api, dbgFunc, errorFunc, infoFunc, portailAPI, setupLogging, warnFunc;
    dbgFunc = console.debug || console.log;
    infoFunc = console.info;
    warnFunc = console.warn;
    errorFunc = console.error;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = function(error) {
      var cookies;
      cookies = $injector.get('$cookies');
      $.ajaxSetup({
        beforeSend: function(xhr, settings) {
          return xhr.setRequestHeader("X-CSRFToken", cookies['csrftoken']);
        }
      });
      return $.ajax({
        type: "POST",
        url: "/api_rest/logger",
        contentType: "application/json",
        data: error
      });
    };
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        api = window.mgapp.log;
        break;
      default:
        api = portailAPI;
    }
    api = {
      log: api
    };
    setupLogging = function() {
      console.debug = function() {
        var arg, args, i, len, log, message;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        dbgFunc.apply(this, args);
        message = "";
        for (i = 0, len = args.length; i < len; i++) {
          arg = args[i];
          if (arg != null) {
            message += arg.toString() + " ";
          } else {
            message += toString.call(arg) + " ";
          }
        }
        log = {
          url: window.location.href,
          type: "debug",
          message: message,
          stack: ""
        };
        return api.log(angular.toJson(log));
      };
      console.log = function() {
        var arg, args, i, len, log, message;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        infoFunc.apply(this, args);
        message = "";
        for (i = 0, len = args.length; i < len; i++) {
          arg = args[i];
          if (arg != null) {
            message += arg.toString() + " ";
          } else {
            message += toString.call(arg) + " ";
          }
        }
        log = {
          url: window.location.href,
          type: "info",
          message: message,
          stack: ""
        };
        return api.log(angular.toJson(log));
      };
      console.info = console.log;
      console.warning = function() {
        var arg, args, i, len, log, message;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        warnFunc.apply(this, args);
        message = "";
        for (i = 0, len = args.length; i < len; i++) {
          arg = args[i];
          if (arg != null) {
            message += arg.toString() + " ";
          } else {
            message += toString.call(arg) + " ";
          }
        }
        log = {
          url: window.location.href,
          type: "warning",
          message: message,
          stack: ""
        };
        return api.log(angular.toJson(log));
      };
      console.warn = console.warning;
      return console.error = function() {
        var arg, args, i, len, log, message;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        errorFunc.apply(this, args);
        message = "";
        for (i = 0, len = args.length; i < len; i++) {
          arg = args[i];
          if (arg != null) {
            message += arg.toString() + " ";
          } else {
            message += toString.call(arg) + " ";
          }
        }
        log = {
          url: window.location.href,
          type: "error",
          message: message,
          stack: ""
        };
        return api.log(angular.toJson(log));
      };
    };
    setupLogging();
    return api;
  }]);

}).call(this);

//# sourceMappingURL=logger-service.js.map

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.dndPageScroll = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports.default = function () {
    var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var defaults = {
      node: document.body,
      topId: 'dnd-page-scroll-top',
      bottomId: 'dnd-page-scroll-bottom',
      namespace: '',
      delay: 25,
      scrollBy: 50,
      height: '50px',
      listenGlobally: true
    };
    var options = _extends({}, defaults, _options);
    options.topId += options.namespace;
    options.bottomId += options.namespace;

    var eventDelegate = options.listenGlobally ? document : options.node;

    var topElement = document.getElementById(options.topId) || appendElementWithId(options.topId);
    var bottomElement = document.getElementById(options.bottomId) || appendElementWithId(options.bottomId);

    hide(topElement, bottomElement);

    css({
      // backgroundColor: 'yellow',
      position: 'fixed',
      left: 0,
      right: 0,
      height: options.height,
      zIndex: 999999
    }, topElement, bottomElement);
    topElement.style.top = 0;
    bottomElement.style.bottom = 0;

    // When DnD occurs over a scroll area - scroll the page!
    var triggerScroll = options.node === document.body ? function (amount) {
      return window.scrollBy(0, amount);
    } : function (amount) {
      options.node.scrollTop += amount;
    };

    var doScroll = null;

    var clearScrollInterval = function clearScrollInterval() {
      clearInterval(doScroll);
      doScroll = null;
    };[topElement, bottomElement].forEach(function (el) {
      return el.addEventListener('dragover', function (e) {
        if (doScroll == null) {
          doScroll = setInterval(function () {
            return triggerScroll(e.target === topElement ? -options.scrollBy : options.scrollBy);
          }, options.delay);
        }

        // Don't allow dropping on scroll areas
        e.dataTransfer.dropEffect = 'none';
        e.preventDefault();
      });
    });[topElement, bottomElement].forEach(function (el) {
      return el.addEventListener('dragleave', function () {
        return clearScrollInterval();
      });
    });

    // When a DND drag event starts, show the scroll areas
    eventDelegate.addEventListener('dragover', function (e) {
      return show(topElement, bottomElement);
    });

    // When DND ends, hide it.
    eventDelegate.addEventListener('dragend', function () {
      clearScrollInterval();
      hide(topElement, bottomElement);
    })

    // When dragging files from Explorer/Finder dragend is not triggered.
    // Work around this by hiding areas when the mouse enters one.
    ;[topElement, bottomElement].forEach(function (el) {
      return el.addEventListener('mouseover', function () {
        clearScrollInterval();
        hide(topElement, bottomElement);
      });
    });
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  // Forked from https://github.com/martindrapeau/jQueryDndPageScroll
  // - removed jQuery dependency
  // - added possibility to scroll multiple different elements

  // Add support scrolling of page durign drag and drop (DnD) when not supported by the browser.
  // Adds invisible scroll areas top and bottom the viewport.
  // When a dragged element enters either area, scroll programmatically.

  // small DOM helpers (poor man's jQuery/lodash)
  var appendElementWithId = function appendElementWithId(id) {
    var tagName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

    var element = document.createElement(tagName);
    element.setAttribute('id', id);
    document.body.appendChild(element);

    return element;
  };
  var hide = function hide() {
    for (var _len = arguments.length, elements = Array(_len), _key = 0; _key < _len; _key++) {
      elements[_key] = arguments[_key];
    }

    return elements.forEach(function (element) {
      element.style.display = 'none';
    });
  };
  var show = function show() {
    for (var _len2 = arguments.length, elements = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      elements[_key2] = arguments[_key2];
    }

    return elements.forEach(function (element) {
      element.style.display = 'block';
    });
  };
  var css = function css(styles) {
    for (var _len3 = arguments.length, elements = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      elements[_key3 - 1] = arguments[_key3];
    }

    var styleAttributes = Object.keys(styles);
    elements.forEach(function (element) {
      styleAttributes.forEach(function (attr) {
        element.style[attr] = styles[attr];
      });
    });
  };
});
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.unitToPx = factory());
}(this, (function () { 'use strict';

  // cache con, el for reused
  var con, el;
  // high sample will more accurate?
  var sample = 100;

  function initElements () {
    con = document.createElement('div');
    con.style.position = 'absolute';
    con.style.width = 0;
    con.style.height = 0;
    con.style.visibility = 'hidden';
    con.style.overflow = 'hidden';

    el = document.createElement('div');

    con.appendChild(el);
  }

  function pxPerUnit (unit, element) {
    if (!con) { initElements(); }
    el.style.width = sample + unit
    ;(element || document.body).appendChild(con);
    var dimension = el.getBoundingClientRect();
    con.parentNode.removeChild(con);
    return dimension.width / sample
  }

  function toPx (length, element) {
    var unitRe = /^\s*([+-]?[\d\.]*)\s*(.*)\s*$/i;
    var match = unitRe.exec(length);
    if (match!=null && match.length > 2) {
      var bare = match[1] === '';
      var val = bare ? 1 : Number(match[1]);
      var unit = match[2];
      var valid = !isNaN(val) && unit;
    }
    if (!valid) { throw new TypeError('Error parsing length') }
    return unit == 'px' ? val : pxPerUnit(unit, element) * val
  }

  var src = toPx;

  return src;

})));

/* global angular: false */

/*!
 * Copyright 2013 Phil DeJarnett - http://www.overzealous.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Create a module for naturalSorting
angular.module("naturalSort", [])

// The core natural service
.factory("naturalService", function() {
	"use strict";
		// amount of extra zeros to padd for sorting
    var padding = function(value) {
			return "00000000000000000000".slice(value.length);
		},

		// Converts a value to a string.  Null and undefined are converted to ''
		toString = function(value) {
			if(value === null || value === undefined) return '';
			return ''+value;
		},

		// Fix numbers to be correctly padded
        natValue = function(value) {
			// First, look for anything in the form of d.d or d.d.d...
            return toString(value).replace(/(\d+)((\.\d+)+)?/g, function ($0, integer, decimal, $3) {
				// If there's more than 2 sets of numbers...
                if (decimal !== $3) {
                    // treat as a series of integers, like versioning,
                    // rather than a decimal
                    return $0.replace(/(\d+)/g, function ($d) {
                        return padding($d) + $d;
                    });
                } else {
					// add a decimal if necessary to ensure decimal sorting
                    decimal = decimal || ".0";
                    return padding(integer) + integer + decimal + padding(decimal);
                }
            });
        };

	// The actual object used by this service
	return {
		naturalValue: natValue,
		naturalSort: function(a, b) {
			a = natValue(a);
			b = natValue(b);
			return (a < b) ? -1 : ((a > b) ? 1 : 0);
		}
	};
})

// Attach a function to the rootScope so it can be accessed by "orderBy"
.run(["$rootScope", "naturalService", function($rootScope, naturalService) {
	"use strict";
	$rootScope.natural = function (field) {
        return function (item) {
            return naturalService.naturalValue(item[field]);
        };
    };
}]);
/**
 * math.js
 * https://github.com/josdejong/mathjs
 *
 * Math.js is an extensive math library for JavaScript and Node.js,
 * It features real and complex numbers, units, matrices, a large set of
 * mathematical functions, and a flexible expression parser.
 *
 * @version 7.1.0
 * @date    2020-07-13
 *
 * @license
 * Copyright (C) 2013-2020 Jos de Jong <wjosdejong@gmail.com>
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy
 * of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.math=t():e.math=t()}(this,function(){return n={},i.m=r=[function(e,t,r){"use strict";r.d(t,"a",function(){return n}),r.d(t,"b",function(){return i}),r.d(t,"c",function(){return o});r(2);var a=r(3);function n(r,n,i,e){function t(e){var t=Object(a.j)(e,n.map(o));return function(e,t,r){if(!t.filter(function(e){return!((t=e)&&"?"===t[0]);var t}).every(function(e){return void 0!==r[e]})){var n=t.filter(function(e){return void 0===r[e]});throw new Error('Cannot create function "'.concat(e,'", ')+"some dependencies are missing: ".concat(n.map(function(e){return'"'.concat(e,'"')}).join(", "),"."))}}(r,n,e),i(t)}return t.isFactory=!0,t.fn=r,t.dependencies=n.slice().sort(),e&&(t.meta=e),t}function i(e){return"function"==typeof e&&"string"==typeof e.fn&&Array.isArray(e.dependencies)}function o(e){return e&&"?"===e[0]?e.slice(1):e}},function(e,t,r){"use strict";function n(e){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(e){return"number"==typeof e}function a(e){return e&&!0===e.constructor.prototype.isBigNumber||!1}function o(e){return e&&"object"===n(e)&&!0===Object.getPrototypeOf(e).isComplex||!1}function s(e){return e&&"object"===n(e)&&!0===Object.getPrototypeOf(e).isFraction||!1}function u(e){return e&&!0===e.constructor.prototype.isUnit||!1}function c(e){return"string"==typeof e}r.d(t,"y",function(){return i}),r.d(t,"e",function(){return a}),r.d(t,"j",function(){return o}),r.d(t,"o",function(){return s}),r.d(t,"L",function(){return u}),r.d(t,"I",function(){return c}),r.d(t,"b",function(){return f}),r.d(t,"v",function(){return l}),r.d(t,"i",function(){return p}),r.d(t,"n",function(){return m}),r.d(t,"H",function(){return h}),r.d(t,"D",function(){return d}),r.d(t,"t",function(){return y}),r.d(t,"g",function(){return g}),r.d(t,"G",function(){return v}),r.d(t,"s",function(){return b}),r.d(t,"p",function(){return x}),r.d(t,"m",function(){return w}),r.d(t,"F",function(){return N}),r.d(t,"z",function(){return O}),r.d(t,"x",function(){return M}),r.d(t,"K",function(){return j}),r.d(t,"a",function(){return E}),r.d(t,"c",function(){return S}),r.d(t,"d",function(){return A}),r.d(t,"f",function(){return C}),r.d(t,"k",function(){return T}),r.d(t,"l",function(){return _}),r.d(t,"q",function(){return q}),r.d(t,"r",function(){return I}),r.d(t,"u",function(){return k}),r.d(t,"w",function(){return B}),r.d(t,"A",function(){return z}),r.d(t,"B",function(){return D}),r.d(t,"C",function(){return R}),r.d(t,"E",function(){return P}),r.d(t,"J",function(){return U}),r.d(t,"h",function(){return F}),r.d(t,"M",function(){return L});var f=Array.isArray;function l(e){return e&&!0===e.constructor.prototype.isMatrix||!1}function p(e){return Array.isArray(e)||l(e)}function m(e){return e&&e.isDenseMatrix&&!0===e.constructor.prototype.isMatrix||!1}function h(e){return e&&e.isSparseMatrix&&!0===e.constructor.prototype.isMatrix||!1}function d(e){return e&&!0===e.constructor.prototype.isRange||!1}function y(e){return e&&!0===e.constructor.prototype.isIndex||!1}function g(e){return"boolean"==typeof e}function v(e){return e&&!0===e.constructor.prototype.isResultSet||!1}function b(e){return e&&!0===e.constructor.prototype.isHelp||!1}function x(e){return"function"==typeof e}function w(e){return e instanceof Date}function N(e){return e instanceof RegExp}function O(e){return!(!e||"object"!==n(e)||e.constructor!==Object||o(e)||s(e))}function M(e){return null===e}function j(e){return void 0===e}function E(e){return e&&!0===e.isAccessorNode&&!0===e.constructor.prototype.isNode||!1}function S(e){return e&&!0===e.isArrayNode&&!0===e.constructor.prototype.isNode||!1}function A(e){return e&&!0===e.isAssignmentNode&&!0===e.constructor.prototype.isNode||!1}function C(e){return e&&!0===e.isBlockNode&&!0===e.constructor.prototype.isNode||!1}function T(e){return e&&!0===e.isConditionalNode&&!0===e.constructor.prototype.isNode||!1}function _(e){return e&&!0===e.isConstantNode&&!0===e.constructor.prototype.isNode||!1}function q(e){return e&&!0===e.isFunctionAssignmentNode&&!0===e.constructor.prototype.isNode||!1}function I(e){return e&&!0===e.isFunctionNode&&!0===e.constructor.prototype.isNode||!1}function k(e){return e&&!0===e.isIndexNode&&!0===e.constructor.prototype.isNode||!1}function B(e){return e&&!0===e.isNode&&!0===e.constructor.prototype.isNode||!1}function z(e){return e&&!0===e.isObjectNode&&!0===e.constructor.prototype.isNode||!1}function D(e){return e&&!0===e.isOperatorNode&&!0===e.constructor.prototype.isNode||!1}function R(e){return e&&!0===e.isParenthesisNode&&!0===e.constructor.prototype.isNode||!1}function P(e){return e&&!0===e.isRangeNode&&!0===e.constructor.prototype.isNode||!1}function U(e){return e&&!0===e.isSymbolNode&&!0===e.constructor.prototype.isNode||!1}function F(e){return e&&!0===e.constructor.prototype.isChain||!1}function L(e){var t=n(e);return"object"===t?null===e?"null":Array.isArray(e)?"Array":e instanceof Date?"Date":e instanceof RegExp?"RegExp":a(e)?"BigNumber":o(e)?"Complex":s(e)?"Fraction":l(e)?"Matrix":u(e)?"Unit":y(e)?"Index":d(e)?"Range":v(e)?"ResultSet":B(e)?e.type:F(e)?"Chain":b(e)?"Help":"Object":"function"===t?"Function":t}},function(e,t,r){"use strict";r.d(t,"a",function(){return s}),r.d(t,"p",function(){return c}),r.d(t,"q",function(){return f}),r.d(t,"m",function(){return l}),r.d(t,"l",function(){return p}),r.d(t,"n",function(){return m}),r.d(t,"o",function(){return h}),r.d(t,"e",function(){return d}),r.d(t,"k",function(){return y}),r.d(t,"f",function(){return g}),r.d(t,"c",function(){return v}),r.d(t,"d",function(){return b}),r.d(t,"j",function(){return x}),r.d(t,"i",function(){return w}),r.d(t,"g",function(){return N}),r.d(t,"h",function(){return O}),r.d(t,"b",function(){return M});var n=r(4),i=r(1),a=r(5),u=r(6),o=r(9);function s(e){for(var t=[];Array.isArray(e);)t.push(e.length),e=e[0];return t}function c(e,t){if(0===t.length){if(Array.isArray(e))throw new u.a(e.length,0)}else!function e(t,r,n){var i=t.length;if(i!==r[n])throw new u.a(i,r[n]);if(n<r.length-1)for(var a=n+1,o=0;o<i;o++){var s=t[o];if(!Array.isArray(s))throw new u.a(r.length-1,r.length,"<");e(t[o],r,a)}else for(o=0;o<i;o++)if(Array.isArray(t[o]))throw new u.a(r.length+1,r.length,">")}(e,t,0)}function f(e,t){if(!Object(i.y)(e)||!Object(n.i)(e))throw new TypeError("Index must be an integer (value: "+e+")");if(e<0||"number"==typeof t&&t<=e)throw new o.a(e,t)}function l(e,t,r){if(!Array.isArray(e)||!Array.isArray(t))throw new TypeError("Array expected");if(0===t.length)throw new Error("Resizing to scalar is not supported");return t.forEach(function(e){if(!Object(i.y)(e)||!Object(n.i)(e)||e<0)throw new TypeError("Invalid size, must contain positive integers (size: "+Object(a.d)(t)+")")}),function e(t,r,n,i){var a;var o;var s=t.length;var u=r[n];var c=Math.min(s,u);t.length=u;if(n<r.length-1){var f=n+1;for(a=0;a<c;a++)o=t[a],Array.isArray(o)||(o=[o],t[a]=o),e(o,r,f,i);for(a=c;a<u;a++)o=[],t[a]=o,e(o,r,f,i)}else{for(a=0;a<c;a++)for(;Array.isArray(t[a]);)t[a]=t[a][0];for(a=c;a<u;a++)t[a]=i}}(e,t,0,void 0!==r?r:0),e}function p(t,r){var e,n=d(t);function i(e){return e.reduce(function(e,t){return e*t})}if(!Array.isArray(t)||!Array.isArray(r))throw new TypeError("Array expected");if(0===r.length)throw new u.a(0,i(s(t)),"!=");for(var a=1,o=0;o<r.length;o++)a*=r[o];if(n.length!==a)throw new u.a(i(r),i(s(t)),"!=");try{e=function(e,t){for(var r,n=e,i=t.length-1;0<i;i--){var a=t[i];r=[];for(var o=n.length/a,s=0;s<o;s++)r.push(n.slice(s*a,(s+1)*a));n=r}return n}(n,r)}catch(e){if(e instanceof u.a)throw new u.a(i(r),i(s(t)),"!=");throw e}return e}function m(e,t){for(var r=t||s(e);Array.isArray(e)&&1===e.length;)e=e[0],r.shift();for(var n=r.length;1===r[n-1];)n--;return n<r.length&&(e=function e(t,r,n){var i,a;if(n<r){var o=n+1;for(i=0,a=t.length;i<a;i++)t[i]=e(t[i],r,o)}else for(;Array.isArray(t);)t=t[0];return t}(e,n,0),r.length=n),e}function h(e,t,r,n){var i=n||s(e);if(r)for(var a=0;a<r;a++)e=[e],i.unshift(1);for(e=function e(t,r,n){var i,a;if(Array.isArray(t)){var o=n+1;for(i=0,a=t.length;i<a;i++)t[i]=e(t[i],r,o)}else for(var s=n;s<r;s++)t=[t];return t}(e,t,0);i.length<t;)i.push(1);return e}function d(e){if(!Array.isArray(e))return e;var r=[];return e.forEach(function e(t){Array.isArray(t)?t.forEach(e):r.push(t)}),r}function y(e,t){return Array.prototype.map.call(e,t)}function g(e,t){Array.prototype.forEach.call(e,t)}function v(e,t){if(1!==s(e).length)throw new Error("Only one dimensional matrices supported");return Array.prototype.filter.call(e,t)}function b(e,t){if(1!==s(e).length)throw new Error("Only one dimensional matrices supported");return Array.prototype.filter.call(e,function(e){return t.test(e)})}function x(e,t){return Array.prototype.join.call(e,t)}function w(e){if(!Array.isArray(e))throw new TypeError("Array input expected");if(0===e.length)return e;var t=[],r=0;t[0]={value:e[0],identifier:0};for(var n=1;n<e.length;n++)e[n]===e[n-1]?r++:r=0,t.push({value:e[n],identifier:r});return t}function N(e){if(!Array.isArray(e))throw new TypeError("Array input expected");if(0===e.length)return e;for(var t=[],r=0;r<e.length;r++)t.push(e[r].value);return t}function O(e,t){for(var r,n=0,i=0;i<e.length;i++){var a=e[i],o=Array.isArray(a);if(0===i&&o&&(n=a.length),o&&a.length!==n)return;var s=o?O(a,t):t(a);if(void 0===r)r=s;else if(r!==s)return"mixed"}return r}function M(e,t){return-1!==e.indexOf(t)}},function(e,t,r){"use strict";r.d(t,"a",function(){return i}),r.d(t,"i",function(){return o}),r.d(t,"e",function(){return s}),r.d(t,"b",function(){return u}),r.d(t,"d",function(){return c}),r.d(t,"c",function(){return f}),r.d(t,"h",function(){return l}),r.d(t,"f",function(){return p}),r.d(t,"g",function(){return m}),r.d(t,"j",function(){return h}),r.d(t,"k",function(){return d});var n=r(1);function a(e){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(e){var t=a(e);if("number"===t||"string"===t||"boolean"===t||null==e)return e;if("function"==typeof e.clone)return e.clone();if(Array.isArray(e))return e.map(i);if(e instanceof Date)return new Date(e.valueOf());if(Object(n.e)(e))return e;if(e instanceof RegExp)throw new TypeError("Cannot clone "+e);return o(e,i)}function o(e,t){var r={};for(var n in e)p(e,n)&&(r[n]=t(e[n]));return r}function s(e,t){for(var r in t)p(t,r)&&(e[r]=t[r]);return e}function u(e,t){if(Array.isArray(t))throw new TypeError("Arrays are not supported by deepExtend");for(var r in t)if(p(t,r))if(t[r]&&t[r].constructor===Object)void 0===e[r]&&(e[r]={}),e[r]&&e[r].constructor===Object?u(e[r],t[r]):e[r]=t[r];else{if(Array.isArray(t[r]))throw new TypeError("Arrays are not supported by deepExtend");e[r]=t[r]}return e}function c(e,t){var r,n,i;if(Array.isArray(e)){if(!Array.isArray(t))return!1;if(e.length!==t.length)return!1;for(n=0,i=e.length;n<i;n++)if(!c(e[n],t[n]))return!1;return!0}if("function"==typeof e)return e===t;if(e instanceof Object){if(Array.isArray(t)||!(t instanceof Object))return!1;for(r in e)if(!(r in t&&c(e[r],t[r])))return!1;for(r in t)if(!(r in e&&c(e[r],t[r])))return!1;return!0}return e===t}function f(e){var t={};return function e(t,r){for(var n in t){var i;p(t,n)&&("object"===a(i=t[n])&&null!==i?e(i,r):r[n]=i)}}(e,t),t}function l(e,t,r){var n,i=!0;Object.defineProperty(e,t,{get:function(){return i&&(n=r(),i=!1),n},set:function(e){n=e,i=!1},configurable:!0,enumerable:!0})}function p(e,t){return e&&Object.hasOwnProperty.call(e,t)}function m(e){return e&&"function"==typeof e.factory}function h(e,t){for(var r={},n=0;n<t.length;n++){var i=t[n],a=e[i];void 0!==a&&(r[i]=a)}return r}function d(t){return Object.keys(t).map(function(e){return t[e]})}},function(e,t,r){"use strict";r.d(t,"i",function(){return n}),r.d(t,"n",function(){return i}),r.d(t,"l",function(){return a}),r.d(t,"j",function(){return o}),r.d(t,"k",function(){return s}),r.d(t,"d",function(){return u}),r.d(t,"g",function(){return c}),r.d(t,"h",function(){return f}),r.d(t,"q",function(){return l}),r.d(t,"f",function(){return g}),r.d(t,"m",function(){return b}),r.d(t,"a",function(){return x}),r.d(t,"b",function(){return w}),r.d(t,"c",function(){return N}),r.d(t,"e",function(){return O}),r.d(t,"o",function(){return M}),r.d(t,"p",function(){return j});var m=r(1);function n(e){return"boolean"==typeof e||!!isFinite(e)&&e===Math.round(e)}var i=Math.sign||function(e){return 0<e?1:e<0?-1:0},a=Math.log2||function(e){return Math.log(e)/Math.LN2},o=Math.log10||function(e){return Math.log(e)/Math.LN10},s=Math.log1p||function(e){return Math.log(e+1)},u=Math.cbrt||function(e){if(0===e)return e;var t,r=e<0;return r&&(e=-e),t=isFinite(e)?(e/((t=Math.exp(Math.log(e)/3))*t)+2*t)/3:e,r?-t:t},c=Math.expm1||function(e){return 2e-4<=e||e<=-2e-4?Math.exp(e)-1:e+e*e/2+e*e*e/6};function f(e,t){if("function"==typeof t)return t(e);if(e===1/0)return"Infinity";if(e===-1/0)return"-Infinity";if(isNaN(e))return"NaN";var r,n="auto";switch(t&&(t.notation&&(n=t.notation),Object(m.y)(t)?r=t:Object(m.y)(t.precision)&&(r=t.precision)),n){case"fixed":return l(e,r);case"exponential":return p(e,r);case"engineering":return function(e,t){if(isNaN(e)||!isFinite(e))return String(e);var r=d(h(e),t),n=r.exponent,i=r.coefficients,a=n%3==0?n:n<0?n-3-n%3:n-n%3;if(Object(m.y)(t))for(;t>i.length||n-a+1>i.length;)i.push(0);else for(var o=Math.abs(n-a)-(i.length-1),s=0;s<o;s++)i.push(0);var u=Math.abs(n-a),c=1;for(;0<u;)c++,u--;var f=i.slice(c).join(""),l=Object(m.y)(t)&&f.length||f.match(/[1-9]/)?"."+f:"",p=i.slice(0,c).join("")+l+"e"+(0<=n?"+":"")+a.toString();return r.sign+p}(e,r);case"auto":return function(e,t,r){if(isNaN(e)||!isFinite(e))return String(e);var n=r&&void 0!==r.lowerExp?r.lowerExp:-3,i=r&&void 0!==r.upperExp?r.upperExp:5,a=h(e),o=t?d(a,t):a;{if(o.exponent<n||o.exponent>=i)return p(e,t);var s=o.coefficients,u=o.exponent;s.length<t&&(s=s.concat(y(t-s.length))),s=s.concat(y(u-s.length+1+(s.length<t?t-s.length:0))),s=y(-u).concat(s);var c=0<u?u:0;return c<s.length-1&&s.splice(c+1,0,"."),o.sign+s.join("")}}(e,r,t&&t).replace(/((\.\d*?)(0+))($|e)/,function(){var e=arguments[2],t=arguments[4];return"."!==e?e+t:t});default:throw new Error('Unknown notation "'+n+'". Choose "auto", "exponential", or "fixed".')}}function h(e){var t=String(e).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);if(!t)throw new SyntaxError("Invalid number "+e);var r=t[1],n=t[2],i=parseFloat(t[4]||"0"),a=n.indexOf(".");i+=-1!==a?a-1:n.length-1;var o=n.replace(".","").replace(/^0*/,function(e){return i-=e.length,""}).replace(/0*$/,"").split("").map(function(e){return parseInt(e)});return 0===o.length&&(o.push(0),i++),{sign:r,coefficients:o,exponent:i}}function l(e,t){if(isNaN(e)||!isFinite(e))return String(e);var r=h(e),n="number"==typeof t?d(r,r.exponent+1+t):r,i=n.coefficients,a=n.exponent+1,o=a+(t||0);return i.length<o&&(i=i.concat(y(o-i.length))),a<0&&(i=y(1-a).concat(i),a=1),a<i.length&&i.splice(a,0,0===a?"0.":"."),n.sign+i.join("")}function p(e,t){if(isNaN(e)||!isFinite(e))return String(e);var r=h(e),n=t?d(r,t):r,i=n.coefficients,a=n.exponent;i.length<t&&(i=i.concat(y(t-i.length)));var o=i.shift();return n.sign+o+(0<i.length?"."+i.join(""):"")+"e"+(0<=a?"+":"")+a}function d(e,t){for(var r={sign:e.sign,coefficients:e.coefficients,exponent:e.exponent},n=r.coefficients;t<=0;)n.unshift(0),r.exponent++,t++;if(n.length>t&&5<=n.splice(t,n.length-t)[0]){var i=t-1;for(n[i]++;10===n[i];)n.pop(),0===i&&(n.unshift(0),r.exponent++,i++),n[--i]++}return r}function y(e){for(var t=[],r=0;r<e;r++)t.push(0);return t}function g(e){return e.toExponential().replace(/e.*$/,"").replace(/^0\.?0*|\./,"").length}var v=Number.EPSILON||2220446049250313e-31;function b(e,t,r){if(null==r)return e===t;if(e===t)return!0;if(isNaN(e)||isNaN(t))return!1;if(isFinite(e)&&isFinite(t)){var n=Math.abs(e-t);return n<v||n<=Math.max(Math.abs(e),Math.abs(t))*r}return!1}var x=Math.acosh||function(e){return Math.log(Math.sqrt(e*e-1)+e)},w=Math.asinh||function(e){return Math.log(Math.sqrt(e*e+1)+e)},N=Math.atanh||function(e){return Math.log((1+e)/(1-e))/2},O=Math.cosh||function(e){return(Math.exp(e)+Math.exp(-e))/2},M=Math.sinh||function(e){return(Math.exp(e)-Math.exp(-e))/2},j=Math.tanh||function(e){var t=Math.exp(2*e);return(t-1)/(t+1)}},function(e,t,r){"use strict";r.d(t,"b",function(){return s}),r.d(t,"d",function(){return u}),r.d(t,"e",function(){return f}),r.d(t,"c",function(){return l}),r.d(t,"a",function(){return p});var n=r(1),i=r(4);function a(e,t){if("function"==typeof t)return t(e);if(!e.isFinite())return e.isNaN()?"NaN":e.gt(0)?"Infinity":"-Infinity";var r,n,i="auto";switch(void 0!==t&&(t.notation&&(i=t.notation),"number"==typeof t?r=t:t.precision&&(r=t.precision)),i){case"fixed":return n=r,e.toFixed(n);case"exponential":return c(e,r);case"engineering":return function(e,t){var r=e.e,n=r%3==0?r:r<0?r-3-r%3:r-r%3,i=e.mul(Math.pow(10,-n)),a=i.toPrecision(t);-1!==a.indexOf("e")&&(a=i.toString());return a+"e"+(0<=r?"+":"")+n.toString()}(e,r);case"auto":var a=t&&void 0!==t.lowerExp?t.lowerExp:-3,o=t&&void 0!==t.upperExp?t.upperExp:5;if(e.isZero())return"0";var s=e.toSignificantDigits(r),u=s.e;return(a<=u&&u<o?s.toFixed():c(e,r)).replace(/((\.\d*?)(0+))($|e)/,function(){var e=arguments[2],t=arguments[4];return"."!==e?e+t:t});default:throw new Error('Unknown notation "'+i+'". Choose "auto", "exponential", or "fixed".')}}function c(e,t){return void 0!==t?e.toExponential(t-1):e.toExponential()}function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function s(e,t){var r=e.length-t.length,n=e.length;return e.substring(r,n)===t}function u(t,r){return"number"==typeof t?Object(i.h)(t,r):Object(n.e)(t)?a(t,r):(e=t)&&"object"===o(e)&&"number"==typeof e.s&&"number"==typeof e.n&&"number"==typeof e.d?r&&"decimal"===r.fraction?t.toString():t.s*t.n+"/"+t.d:Array.isArray(t)?function e(t,r){{if(Array.isArray(t)){for(var n="[",i=t.length,a=0;a<i;a++)0!==a&&(n+=", "),n+=e(t[a],r);return n+="]"}return u(t,r)}}(t,r):Object(n.I)(t)?'"'+t+'"':"function"==typeof t?t.syntax?String(t.syntax):"function":t&&"object"===o(t)?"function"==typeof t.format?t.format(r):t&&t.toString(r)!=={}.toString()?t.toString(r):"{"+Object.keys(t).map(function(e){return'"'+e+'": '+u(t[e],r)}).join(", ")+"}":String(t);var e}function f(e){for(var t=String(e),r="",n=0;n<t.length;){var i=t.charAt(n);"\\"===i?(r+=i,n++,""!==(i=t.charAt(n))&&-1!=='"\\/bfnrtu'.indexOf(i)||(r+="\\"),r+=i):r+='"'===i?'\\"':i,n++}return'"'+r+'"'}function l(e){return String(e).replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/'/g,"&#39;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}function p(e,t){if(!Object(n.I)(e))throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: "+Object(n.M)(e)+", index: 0)");if(!Object(n.I)(t))throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: "+Object(n.M)(t)+", index: 1)");return e===t?0:t<e?1:-1}},function(e,t,r){"use strict";function n(e,t,r){if(!(this instanceof n))throw new SyntaxError("Constructor must be called with the new operator");this.actual=e,this.expected=t,this.relation=r,this.message="Dimension mismatch ("+(Array.isArray(e)?"["+e.join(", ")+"]":e)+" "+(this.relation||"!=")+" "+(Array.isArray(t)?"["+t.join(", ")+"]":t)+")",this.stack=(new Error).stack}r.d(t,"a",function(){return n}),(n.prototype=new RangeError).constructor=RangeError,n.prototype.name="DimensionError",n.prototype.isDimensionError=!0},,function(e,t,r){var o;
/**
 * @license Complex.js v2.0.11 11/02/2016
 *
 * Copyright (c) 2016, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
!function(){"use strict";function n(e){return.5*(Math.exp(e)+Math.exp(-e))}function i(e){return.5*(Math.exp(e)-Math.exp(-e))}function u(){throw SyntaxError("Invalid Param")}function c(e,t){var r=Math.abs(e),n=Math.abs(t);return 0===e?Math.log(n):0===t?Math.log(r):r<3e3&&n<3e3?.5*Math.log(e*e+t*t):Math.log(e/Math.cos(Math.atan2(t,e)))}var a=function(e,t){var r={re:0,im:0};if(null==e)r.re=r.im=0;else if(void 0!==t)r.re=e,r.im=t;else switch(typeof e){case"object":if("im"in e&&"re"in e)r.re=e.re,r.im=e.im;else if("abs"in e&&"arg"in e){if(!Number.isFinite(e.abs)&&Number.isFinite(e.arg))return f.INFINITY;r.re=e.abs*Math.cos(e.arg),r.im=e.abs*Math.sin(e.arg)}else if("r"in e&&"phi"in e){if(!Number.isFinite(e.r)&&Number.isFinite(e.phi))return f.INFINITY;r.re=e.r*Math.cos(e.phi),r.im=e.r*Math.sin(e.phi)}else 2===e.length?(r.re=e[0],r.im=e[1]):u();break;case"string":r.im=r.re=0;var n=e.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g),i=1,a=0;null===n&&u();for(var o=0;o<n.length;o++){var s=n[o];" "===s||"\t"===s||"\n"===s||("+"===s?i++:"-"===s?a++:i=a=("i"===s||"I"===s?(i+a===0&&u()," "===n[o+1]||isNaN(n[o+1])?r.im+=parseFloat((a%2?"-":"")+"1"):(r.im+=parseFloat((a%2?"-":"")+n[o+1]),o++)):(i+a!==0&&!isNaN(s)||u(),"i"===n[o+1]||"I"===n[o+1]?(r.im+=parseFloat((a%2?"-":"")+s),o++):r.re+=parseFloat((a%2?"-":"")+s)),0))}0<i+a&&u();break;case"number":r.im=0,r.re=e;break;default:u()}return isNaN(r.re)||isNaN(r.im),r};function f(e,t){if(!(this instanceof f))return new f(e,t);var r=a(e,t);this.re=r.re,this.im=r.im}f.prototype={re:0,im:0,sign:function(){var e=this.abs();return new f(this.re/e,this.im/e)},add:function(e,t){var r=new f(e,t);return this.isInfinite()&&r.isInfinite()?f.NAN:this.isInfinite()||r.isInfinite()?f.INFINITY:new f(this.re+r.re,this.im+r.im)},sub:function(e,t){var r=new f(e,t);return this.isInfinite()&&r.isInfinite()?f.NAN:this.isInfinite()||r.isInfinite()?f.INFINITY:new f(this.re-r.re,this.im-r.im)},mul:function(e,t){var r=new f(e,t);return this.isInfinite()&&r.isZero()||this.isZero()&&r.isInfinite()?f.NAN:this.isInfinite()||r.isInfinite()?f.INFINITY:0===r.im&&0===this.im?new f(this.re*r.re,0):new f(this.re*r.re-this.im*r.im,this.re*r.im+this.im*r.re)},div:function(e,t){var r=new f(e,t);if(this.isZero()&&r.isZero()||this.isInfinite()&&r.isInfinite())return f.NAN;if(this.isInfinite()||r.isZero())return f.INFINITY;if(this.isZero()||r.isInfinite())return f.ZERO;e=this.re,t=this.im;var n,i,a=r.re,o=r.im;return 0===o?new f(e/a,t/a):Math.abs(a)<Math.abs(o)?new f((e*(i=a/o)+t)/(n=a*i+o),(t*i-e)/n):new f((e+t*(i=o/a))/(n=o*i+a),(t-e*i)/n)},pow:function(e,t){var r=new f(e,t);if(e=this.re,t=this.im,r.isZero())return f.ONE;if(0===r.im){if(0===t&&0<=e)return new f(Math.pow(e,r.re),0);if(0===e)switch((r.re%4+4)%4){case 0:return new f(Math.pow(t,r.re),0);case 1:return new f(0,Math.pow(t,r.re));case 2:return new f(-Math.pow(t,r.re),0);case 3:return new f(0,-Math.pow(t,r.re))}}if(0===e&&0===t&&0<r.re&&0<=r.im)return f.ZERO;var n=Math.atan2(t,e),i=c(e,t);return e=Math.exp(r.re*i-r.im*n),t=r.im*i+r.re*n,new f(e*Math.cos(t),e*Math.sin(t))},sqrt:function(){var e,t,r=this.re,n=this.im,i=this.abs();if(0<=r){if(0===n)return new f(Math.sqrt(r),0);e=.5*Math.sqrt(2*(i+r))}else e=Math.abs(n)/Math.sqrt(2*(i-r));return t=r<=0?.5*Math.sqrt(2*(i-r)):Math.abs(n)/Math.sqrt(2*(i+r)),new f(e,n<0?-t:t)},exp:function(){var e=Math.exp(this.re);return this.im,new f(e*Math.cos(this.im),e*Math.sin(this.im))},expm1:function(){var e=this.re,t=this.im;return new f(Math.expm1(e)*Math.cos(t)+function(e){var t=Math.PI/4;if(e<-t||t<e)return Math.cos(e)-1;var r=e*e;return r*(r*(1/24+r*(-1/720+r*(1/40320+r*(-1/3628800+r*(1/4790014600+r*(-1/87178291200+1/20922789888e3*r))))))-.5)}(t),Math.exp(e)*Math.sin(t))},log:function(){var e=this.re,t=this.im;return new f(c(e,t),Math.atan2(t,e))},abs:function(){return e=this.re,t=this.im,r=Math.abs(e),n=Math.abs(t),r<3e3&&n<3e3?Math.sqrt(r*r+n*n):(n=r<n?(r=n,e/t):t/e,r*Math.sqrt(1+n*n));var e,t,r,n},arg:function(){return Math.atan2(this.im,this.re)},sin:function(){var e=this.re,t=this.im;return new f(Math.sin(e)*n(t),Math.cos(e)*i(t))},cos:function(){var e=this.re,t=this.im;return new f(Math.cos(e)*n(t),-Math.sin(e)*i(t))},tan:function(){var e=2*this.re,t=2*this.im,r=Math.cos(e)+n(t);return new f(Math.sin(e)/r,i(t)/r)},cot:function(){var e=2*this.re,t=2*this.im,r=Math.cos(e)-n(t);return new f(-Math.sin(e)/r,i(t)/r)},sec:function(){var e=this.re,t=this.im,r=.5*n(2*t)+.5*Math.cos(2*e);return new f(Math.cos(e)*n(t)/r,Math.sin(e)*i(t)/r)},csc:function(){var e=this.re,t=this.im,r=.5*n(2*t)-.5*Math.cos(2*e);return new f(Math.sin(e)*n(t)/r,-Math.cos(e)*i(t)/r)},asin:function(){var e=this.re,t=this.im,r=new f(t*t-e*e+1,-2*e*t).sqrt(),n=new f(r.re-t,r.im+e).log();return new f(n.im,-n.re)},acos:function(){var e=this.re,t=this.im,r=new f(t*t-e*e+1,-2*e*t).sqrt(),n=new f(r.re-t,r.im+e).log();return new f(Math.PI/2-n.im,n.re)},atan:function(){var e=this.re,t=this.im;if(0===e){if(1===t)return new f(0,1/0);if(-1===t)return new f(0,-1/0)}var r=e*e+(1-t)*(1-t),n=new f((1-t*t-e*e)/r,-2*e/r).log();return new f(-.5*n.im,.5*n.re)},acot:function(){var e=this.re,t=this.im;if(0===t)return new f(Math.atan2(1,e),0);var r=e*e+t*t;return 0!=r?new f(e/r,-t/r).atan():new f(0!==e?e/0:0,0!==t?-t/0:0).atan()},asec:function(){var e=this.re,t=this.im;if(0===e&&0===t)return new f(0,1/0);var r=e*e+t*t;return 0!=r?new f(e/r,-t/r).acos():new f(0!==e?e/0:0,0!==t?-t/0:0).acos()},acsc:function(){var e=this.re,t=this.im;if(0===e&&0===t)return new f(Math.PI/2,1/0);var r=e*e+t*t;return 0!=r?new f(e/r,-t/r).asin():new f(0!==e?e/0:0,0!==t?-t/0:0).asin()},sinh:function(){var e=this.re,t=this.im;return new f(i(e)*Math.cos(t),n(e)*Math.sin(t))},cosh:function(){var e=this.re,t=this.im;return new f(n(e)*Math.cos(t),i(e)*Math.sin(t))},tanh:function(){var e=2*this.re,t=2*this.im,r=n(e)+Math.cos(t);return new f(i(e)/r,Math.sin(t)/r)},coth:function(){var e=2*this.re,t=2*this.im,r=n(e)-Math.cos(t);return new f(i(e)/r,-Math.sin(t)/r)},csch:function(){var e=this.re,t=this.im,r=Math.cos(2*t)-n(2*e);return new f(-2*i(e)*Math.cos(t)/r,2*n(e)*Math.sin(t)/r)},sech:function(){var e=this.re,t=this.im,r=Math.cos(2*t)+n(2*e);return new f(2*n(e)*Math.cos(t)/r,-2*i(e)*Math.sin(t)/r)},asinh:function(){var e=this.im;this.im=-this.re,this.re=e;var t=this.asin();return this.re=-this.im,this.im=e,e=t.re,t.re=-t.im,t.im=e,t},acosh:function(){var e,t=this.acos();return t.im<=0?(e=t.re,t.re=-t.im,t.im=e):(e=t.im,t.im=-t.re,t.re=e),t},atanh:function(){var e=this.re,t=this.im,r=1<e&&0===t,n=1-e,i=1+e,a=n*n+t*t,o=0!=a?new f((i*n-t*t)/a,(t*n+i*t)/a):new f(-1!==e?e/0:0,0!==t?t/0:0),s=o.re;return o.re=c(o.re,o.im)/2,o.im=Math.atan2(o.im,s)/2,r&&(o.im=-o.im),o},acoth:function(){var e=this.re,t=this.im;if(0===e&&0===t)return new f(0,Math.PI/2);var r=e*e+t*t;return 0!=r?new f(e/r,-t/r).atanh():new f(0!==e?e/0:0,0!==t?-t/0:0).atanh()},acsch:function(){var e=this.re,t=this.im;if(0===t)return new f(0!==e?Math.log(e+Math.sqrt(e*e+1)):1/0,0);var r=e*e+t*t;return 0!=r?new f(e/r,-t/r).asinh():new f(0!==e?e/0:0,0!==t?-t/0:0).asinh()},asech:function(){var e=this.re,t=this.im;if(this.isZero())return f.INFINITY;var r=e*e+t*t;return 0!=r?new f(e/r,-t/r).acosh():new f(0!==e?e/0:0,0!==t?-t/0:0).acosh()},inverse:function(){if(this.isZero())return f.INFINITY;if(this.isInfinite())return f.ZERO;var e=this.re,t=this.im,r=e*e+t*t;return new f(e/r,-t/r)},conjugate:function(){return new f(this.re,-this.im)},neg:function(){return new f(-this.re,-this.im)},ceil:function(e){return e=Math.pow(10,e||0),new f(Math.ceil(this.re*e)/e,Math.ceil(this.im*e)/e)},floor:function(e){return e=Math.pow(10,e||0),new f(Math.floor(this.re*e)/e,Math.floor(this.im*e)/e)},round:function(e){return e=Math.pow(10,e||0),new f(Math.round(this.re*e)/e,Math.round(this.im*e)/e)},equals:function(e,t){var r=new f(e,t);return Math.abs(r.re-this.re)<=f.EPSILON&&Math.abs(r.im-this.im)<=f.EPSILON},clone:function(){return new f(this.re,this.im)},toString:function(){var e=this.re,t=this.im,r="";return this.isNaN()?"NaN":this.isZero()?"0":this.isInfinite()?"Infinity":(0!==e&&(r+=e),0!==t&&(0!==e?r+=t<0?" - ":" + ":t<0&&(r+="-"),1!==(t=Math.abs(t))&&(r+=t),r+="i"),r||"0")},toVector:function(){return[this.re,this.im]},valueOf:function(){return 0===this.im?this.re:null},isNaN:function(){return isNaN(this.re)||isNaN(this.im)},isZero:function(){return!(0!==this.re&&-0!==this.re||0!==this.im&&-0!==this.im)},isFinite:function(){return isFinite(this.re)&&isFinite(this.im)},isInfinite:function(){return!(this.isNaN()||this.isFinite())}},f.ZERO=new f(0,0),f.ONE=new f(1,0),f.I=new f(0,1),f.PI=new f(Math.PI,0),f.E=new f(Math.E,0),f.INFINITY=new f(1/0,1/0),f.NAN=new f(NaN,NaN),f.EPSILON=1e-16,void 0===(o=function(){return f}.apply(t,[]))||(e.exports=o)}()},function(e,t,r){"use strict";function n(e,t,r){if(!(this instanceof n))throw new SyntaxError("Constructor must be called with the new operator");this.index=e,arguments.length<3?(this.min=0,this.max=t):(this.min=t,this.max=r),void 0!==this.min&&this.index<this.min?this.message="Index out of range ("+this.index+" < "+this.min+")":void 0!==this.max&&this.index>=this.max?this.message="Index out of range ("+this.index+" > "+(this.max-1)+")":this.message="Index out of range ("+this.index+")",this.stack=(new Error).stack}r.d(t,"a",function(){return n}),(n.prototype=new RangeError).constructor=RangeError,n.prototype.name="IndexError",n.prototype.isIndexError=!0},function(r,i,e){var a;
/**
 * @license Fraction.js v4.0.12 09/09/2015
 * http://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2015, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
!function(){"use strict";var d={s:1,n:0,d:1};function e(t){function e(){var e=Error.apply(this,arguments);e.name=this.name=t,this.stack=e.stack,this.message=e.message}function r(){}return r.prototype=Error.prototype,e.prototype=new r,e}var y=f.DivisionByZero=e("DivisionByZero"),t=f.InvalidParameter=e("InvalidParameter");function g(e,t){return isNaN(e=parseInt(e,10))&&v(),e*t}function v(){throw new t}var n=function(e,t){var r,n=0,i=1,a=1,o=0,s=0,u=0,c=1,f=1,l=0,p=1,m=1,h=1;if(null!=e)if(void 0!==t)a=(n=e)*(i=t);else switch(typeof e){case"object":"d"in e&&"n"in e?(n=e.n,i=e.d,"s"in e&&(n*=e.s)):0 in e?(n=e[0],1 in e&&(i=e[1])):v(),a=n*i;break;case"number":if(e<0&&(e=-(a=e)),e%1==0)n=e;else if(0<e){for(1<=e&&(e/=f=Math.pow(10,Math.floor(1+Math.log(e)/Math.LN10)));p<=1e7&&h<=1e7;){if(e===(r=(l+m)/(p+h))){i=p+h<=1e7?(n=l+m,p+h):p<h?(n=m,h):(n=l,p);break}r<e?(l+=m,p+=h):(m+=l,h+=p),i=1e7<p?(n=m,h):(n=l,p)}n*=f}else(isNaN(e)||isNaN(t))&&(i=n=NaN);break;case"string":if(null===(p=e.match(/\d+|./g))&&v(),"-"===p[l]?(a=-1,l++):"+"===p[l]&&l++,p.length===l+1?s=g(p[l++],a):"."===p[l+1]||"."===p[l]?("."!==p[l]&&(o=g(p[l++],a)),(++l+1===p.length||"("===p[l+1]&&")"===p[l+3]||"'"===p[l+1]&&"'"===p[l+3])&&(s=g(p[l],a),c=Math.pow(10,p[l].length),l++),("("===p[l]&&")"===p[l+2]||"'"===p[l]&&"'"===p[l+2])&&(u=g(p[l+1],a),f=Math.pow(10,p[l+1].length)-1,l+=3)):"/"===p[l+1]||":"===p[l+1]?(s=g(p[l],a),c=g(p[l+2],1),l+=3):"/"===p[l+3]&&" "===p[l+1]&&(o=g(p[l],a),s=g(p[l+2],a),c=g(p[l+4],1),l+=5),p.length<=l){a=n=u+(i=c*f)*o+f*s;break}default:v()}if(0===i)throw new y;d.s=a<0?-1:1,d.n=Math.abs(n),d.d=Math.abs(i)};function u(e,t,r){for(var n=1,i=function(e,t,r){for(var n=1;0<t;e=e*e%r,t>>=1)1&t&&(n=n*e%r);return n}(10,r,t),a=0;a<300;a++){if(n===i)return a;n=10*n%t,i=10*i%t}return 0}function c(e,t){if(!e)return t;if(!t)return e;for(;;){if(!(e%=t))return t;if(!(t%=e))return e}}function f(e,t){if(!(this instanceof f))return new f(e,t);n(e,t),e=f.REDUCE?c(d.d,d.n):1,this.s=d.s,this.n=d.n/e,this.d=d.d/e}f.REDUCE=1,f.prototype={s:1,n:0,d:1,abs:function(){return new f(this.n,this.d)},neg:function(){return new f(-this.s*this.n,this.d)},add:function(e,t){return n(e,t),new f(this.s*this.n*d.d+d.s*this.d*d.n,this.d*d.d)},sub:function(e,t){return n(e,t),new f(this.s*this.n*d.d-d.s*this.d*d.n,this.d*d.d)},mul:function(e,t){return n(e,t),new f(this.s*d.s*this.n*d.n,this.d*d.d)},div:function(e,t){return n(e,t),new f(this.s*d.s*this.n*d.d,this.d*d.n)},clone:function(){return new f(this)},mod:function(e,t){return isNaN(this.n)||isNaN(this.d)?new f(NaN):void 0===e?new f(this.s*this.n%this.d,1):(n(e,t),0===d.n&&0===this.d&&f(0,0),new f(this.s*(d.d*this.n)%(d.n*this.d),d.d*this.d))},gcd:function(e,t){return n(e,t),new f(c(d.n,this.n)*c(d.d,this.d),d.d*this.d)},lcm:function(e,t){return n(e,t),0===d.n&&0===this.n?new f:new f(d.n*this.n,c(d.n,this.n)*c(d.d,this.d))},ceil:function(e){return e=Math.pow(10,e||0),isNaN(this.n)||isNaN(this.d)?new f(NaN):new f(Math.ceil(e*this.s*this.n/this.d),e)},floor:function(e){return e=Math.pow(10,e||0),isNaN(this.n)||isNaN(this.d)?new f(NaN):new f(Math.floor(e*this.s*this.n/this.d),e)},round:function(e){return e=Math.pow(10,e||0),isNaN(this.n)||isNaN(this.d)?new f(NaN):new f(Math.round(e*this.s*this.n/this.d),e)},inverse:function(){return new f(this.s*this.d,this.n)},pow:function(e){return e<0?new f(Math.pow(this.s*this.d,-e),Math.pow(this.n,-e)):new f(Math.pow(this.s*this.n,e),Math.pow(this.d,e))},equals:function(e,t){return n(e,t),this.s*this.n*d.d==d.s*d.n*this.d},compare:function(e,t){n(e,t);var r=this.s*this.n*d.d-d.s*d.n*this.d;return(0<r)-(r<0)},simplify:function(e){if(isNaN(this.n)||isNaN(this.d))return this;var t=this.abs().toContinued();e=e||.001;for(var r=0;r<t.length;r++){var n=function e(t){return 1===t.length?new f(t[0]):e(t.slice(1)).inverse().add(t[0])}(t.slice(0,r+1));if(n.sub(this.abs()).abs().valueOf()<e)return n.mul(this.s)}return this},divisible:function(e,t){return n(e,t),!(!(d.n*this.d)||this.n*d.d%(d.n*this.d))},valueOf:function(){return this.s*this.n/this.d},toFraction:function(e){var t,r="",n=this.n,i=this.d;return this.s<0&&(r+="-"),1===i?r+=n:(e&&0<(t=Math.floor(n/i))&&(r+=t,r+=" ",n%=i),r+=n,r+="/",r+=i),r},toLatex:function(e){var t,r="",n=this.n,i=this.d;return this.s<0&&(r+="-"),1===i?r+=n:(e&&0<(t=Math.floor(n/i))&&(r+=t,n%=i),r+="\\frac{",r+=n,r+="}{",r+=i,r+="}"),r},toContinued:function(){var e,t=this.n,r=this.d,n=[];if(isNaN(this.n)||isNaN(this.d))return n;for(;n.push(Math.floor(t/r)),e=t%r,t=r,r=e,1!==t;);return n},toString:function(e){var t,r=this.n,n=this.d;if(isNaN(r)||isNaN(n))return"NaN";f.REDUCE||(r/=t=c(r,n),n/=t),e=e||15;var i=function(e){for(;e%2==0;e/=2);for(;e%5==0;e/=5);if(1===e)return 0;for(var t=10%e,r=1;1!==t;r++)if(t=10*t%e,2e3<r)return 0;return r}(n),a=u(0,n,i),o=-1===this.s?"-":"";if(o+=r/n|0,r%=n,(r*=10)&&(o+="."),i){for(var s=a;s--;)o+=r/n|0,r%=n,r*=10;o+="(";for(s=i;s--;)o+=r/n|0,r%=n,r*=10;o+=")"}else for(s=e;r&&s--;)o+=r/n|0,r%=n,r*=10;return o}},void 0===(a=function(){return f}.apply(i,[]))||(r.exports=a)}()},function(e,t){e.exports=function t(e,r){"use strict";function n(e){return t.insensitive&&(""+e).toLowerCase()||""+e}var i,a,o=/(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,s=/(^[ ]*|[ ]*$)/g,u=/(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,c=/^0x[0-9a-f]+$/i,f=/^0/,l=n(e).replace(s,"")||"",p=n(r).replace(s,"")||"",m=l.replace(o,"\0$1\0").replace(/\0$/,"").replace(/^\0/,"").split("\0"),h=p.replace(o,"\0$1\0").replace(/\0$/,"").replace(/^\0/,"").split("\0"),d=parseInt(l.match(c),16)||1!==m.length&&l.match(u)&&Date.parse(l),y=parseInt(p.match(c),16)||d&&p.match(u)&&Date.parse(p)||null;if(y){if(d<y)return-1;if(y<d)return 1}for(var g=0,v=Math.max(m.length,h.length);g<v;g++){if(i=!(m[g]||"").match(f)&&parseFloat(m[g])||m[g]||0,a=!(h[g]||"").match(f)&&parseFloat(h[g])||h[g]||0,isNaN(i)!==isNaN(a))return isNaN(i)?1:-1;if(typeof i!=typeof a&&(i+="",a+=""),i<a)return-1;if(a<i)return 1}return 0}},function(e,t,r){"use strict";function i(e,t,r,n){if(!(this instanceof i))throw new SyntaxError("Constructor must be called with the new operator");this.fn=e,this.count=t,this.min=r,this.max=n,this.message="Wrong number of arguments in function "+e+" ("+t+" provided, "+r+(null!=n?"-"+n:"")+" expected)",this.stack=(new Error).stack}r.d(t,"a",function(){return i}),(i.prototype=new Error).constructor=Error,i.prototype.name="ArgumentsError",i.prototype.isArgumentsError=!0},function(e,t,r){"use strict";var n,i,a;i=[],void 0===(a="function"==typeof(n=function(){function k(){return true}function re(){return false}function ne(){return undefined}function B(){var e=[{name:"number",test:function(e){return typeof e==="number"}},{name:"string",test:function(e){return typeof e==="string"}},{name:"boolean",test:function(e){return typeof e==="boolean"}},{name:"Function",test:function(e){return typeof e==="function"}},{name:"Array",test:Array.isArray},{name:"Date",test:function(e){return e instanceof Date}},{name:"RegExp",test:function(e){return e instanceof RegExp}},{name:"Object",test:function(e){return typeof e==="object"&&e!==null&&e.constructor===Object}},{name:"null",test:function(e){return e===null}},{name:"undefined",test:function(e){return e===undefined}}];var n={name:"any",test:k};var t=[];var r=[];var F={types:e,conversions:r,ignore:t};function u(t){var e=ee(F.types,function(e){return e.name===t});if(e){return e}if(t==="any"){return n}var r=ee(F.types,function(e){return e.name.toLowerCase()===t.toLowerCase()});throw new TypeError('Unknown type "'+t+'"'+(r?'. Did you mean "'+r.name+'"?':""))}function c(e){if(e===n){return 999}return F.types.indexOf(e)}function p(t){var e=ee(F.types,function(e){return e.test(t)});if(e){return e.name}throw new TypeError("Value has unknown type. Value: "+t)}function i(e,t){if(!e.signatures){throw new TypeError("Function is no typed-function")}var r;if(typeof t==="string"){r=t.split(",");for(var n=0;n<r.length;n++){r[n]=r[n].trim()}}else if(Array.isArray(t)){r=t}else{throw new TypeError("String array or a comma separated string expected")}var i=r.join(",");var a=e.signatures[i];if(a){return a}throw new TypeError("Signature not found (signature: "+(e.name||"unnamed")+"("+r.join(", ")+"))")}function a(e,t){var r=p(e);if(t===r){return e}for(var n=0;n<F.conversions.length;n++){var i=F.conversions[n];if(i.from===r&&i.to===t){return i.convert(e)}}throw new Error("Cannot convert from "+r+" to "+t)}function L(e){return e.map(function(e){var t=e.types.map(l);return(e.restParam?"...":"")+t.join("|")}).join(",")}function o(e,r){var t=e.indexOf("...")===0;var n=!t?e:e.length>3?e.slice(3):"any";var i=n.split("|").map(O).filter(M).filter(N);var a=b(r,i);var o=i.map(function(e){var t=u(e);return{name:e,typeIndex:c(t),test:t.test,conversion:null,conversionIndex:-1}});var s=a.map(function(e){var t=u(e.from);return{name:e.from,typeIndex:c(t),test:t.test,conversion:e,conversionIndex:r.indexOf(e)}});return{types:o.concat(s),restParam:t}}function H(e,t,i){var r=[];if(e.trim()!==""){r=e.split(",").map(O).map(function(e,t,r){var n=o(e,i);if(n.restParam&&t!==r.length-1){throw new SyntaxError('Unexpected rest parameter "'+e+'": '+"only allowed for the last parameter")}return n})}if(r.some(j)){return null}return{params:r,fn:t}}function $(e){var t=S(e);return t?t.restParam:false}function s(e){return e.types.some(function(e){return e.conversion!=null})}function G(e){if(!e||e.types.length===0){return k}else if(e.types.length===1){return u(e.types[0].name).test}else if(e.types.length===2){var r=u(e.types[0].name).test;var n=u(e.types[1].name).test;return function e(t){return r(t)||n(t)}}else{var i=e.types.map(function(e){return u(e.name).test});return function e(t){for(var r=0;r<i.length;r++){if(i[r](t)){return true}}return false}}}function Z(e){var n,r,i;if($(e)){n=E(e).map(G);var a=n.length;var o=G(S(e));var s=function(e){for(var t=a;t<e.length;t++){if(!o(e[t])){return false}}return true};return function e(t){for(var r=0;r<n.length;r++){if(!n[r](t[r])){return false}}return s(t)&&t.length>=a+1}}else{if(e.length===0){return function e(t){return t.length===0}}else if(e.length===1){r=G(e[0]);return function e(t){return r(t[0])&&t.length===1}}else if(e.length===2){r=G(e[0]);i=G(e[1]);return function e(t){return r(t[0])&&i(t[1])&&t.length===2}}else{n=e.map(G);return function e(t){for(var r=0;r<n.length;r++){if(!n[r](t[r])){return false}}return t.length===n.length}}}}function m(e,t){return t<e.params.length?e.params[t]:$(e.params)?S(e.params):null}function f(e,t,r){var n=m(e,t);var i=n?r?n.types.filter(h):n.types:[];return i.map(l)}function l(e){return e.name}function h(e){return e.conversion===null||e.conversion===undefined}function d(e,t){var r=_(te(e,function(e){return f(e,t,false)}));return r.indexOf("any")!==-1?["any"]:r}function V(e,r,t){var n,i;var a=e||"unnamed";var o=t;var s;for(s=0;s<r.length;s++){var u=o.filter(function(e){var t=G(m(e,s));return(s<e.params.length||$(e.params))&&t(r[s])});if(u.length===0){i=d(o,s);if(i.length>0){var c=p(r[s]);n=new TypeError("Unexpected type of argument in function "+a+" (expected: "+i.join(" or ")+", actual: "+c+", index: "+s+")");n.data={category:"wrongType",fn:a,index:s,actual:c,expected:i};return n}}else{o=u}}var f=o.map(function(e){return $(e.params)?Infinity:e.params.length});if(r.length<Math.min.apply(null,f)){i=d(o,s);n=new TypeError("Too few arguments in function "+a+" (expected: "+i.join(" or ")+", index: "+r.length+")");n.data={category:"tooFewArgs",fn:a,index:r.length,expected:i};return n}var l=Math.max.apply(null,f);if(r.length>l){n=new TypeError("Too many arguments in function "+a+" (expected: "+l+", actual: "+r.length+")");n.data={category:"tooManyArgs",fn:a,index:r.length,expectedLength:l};return n}n=new TypeError('Arguments of type "'+r.join(", ")+'" do not match any of the defined signatures of function '+a+".");n.data={category:"mismatch",actual:r.map(p)};return n}function y(e){var t=999;for(var r=0;r<e.types.length;r++){if(h(e.types[r])){t=Math.min(t,e.types[r].typeIndex)}}return t}function g(e){var t=999;for(var r=0;r<e.types.length;r++){if(!h(e.types[r])){t=Math.min(t,e.types[r].conversionIndex)}}return t}function v(e,t){var r;r=e.restParam-t.restParam;if(r!==0){return r}r=s(e)-s(t);if(r!==0){return r}r=y(e)-y(t);if(r!==0){return r}return g(e)-g(t)}function J(e,t){var r=Math.min(e.params.length,t.params.length);var n;var i;i=e.params.some(s)-t.params.some(s);if(i!==0){return i}for(n=0;n<r;n++){i=s(e.params[n])-s(t.params[n]);if(i!==0){return i}}for(n=0;n<r;n++){i=v(e.params[n],t.params[n]);if(i!==0){return i}}return e.params.length-t.params.length}function b(e,t){var r={};e.forEach(function(e){if(t.indexOf(e.from)===-1&&t.indexOf(e.to)!==-1&&!r[e.from]){r[e.from]=e}});return Object.keys(r).map(function(e){return r[e]})}function W(e,i){var t=i;if(e.some(s)){var a=$(e);var o=e.map(x);t=function e(){var t=[];var r=a?arguments.length-1:arguments.length;for(var n=0;n<r;n++){t[n]=o[n](arguments[n])}if(a){t[r]=arguments[r].map(o[r])}return i.apply(this,t)}}var r=t;if($(e)){var n=e.length-1;r=function e(){return t.apply(this,A(arguments,0,n).concat([A(arguments,n)]))}}return r}function x(e){var r,n,i,a;var o=[];var s=[];e.types.forEach(function(e){if(e.conversion){o.push(u(e.conversion.from).test);s.push(e.conversion.convert)}});switch(s.length){case 0:return function e(t){return t};case 1:r=o[0];i=s[0];return function e(t){if(r(t)){return i(t)}return t};case 2:r=o[0];n=o[1];i=s[0];a=s[1];return function e(t){if(r(t)){return i(t)}if(n(t)){return a(t)}return t};default:return function e(t){for(var r=0;r<s.length;r++){if(o[r](t)){return s[r](t)}}return t}}}function Y(e){var r={};e.forEach(function(t){if(!t.params.some(s)){X(t.params,true).forEach(function(e){r[L(e)]=t.fn})}});return r}function X(e,u){function c(r,t,n){if(t<r.length){var e=r[t];var i=u?e.types.filter(h):e.types;var a;if(e.restParam){var o=i.filter(h);a=o.length<i.length?[o,i]:[i]}else{a=i.map(function(e){return[e]})}return te(a,function(e){return c(r,t+1,n.concat([e]))})}else{var s=n.map(function(e,t){return{types:e,restParam:t===r.length-1&&$(r)}});return[s]}}return c(e,0,[])}function Q(e,t){var r=Math.max(e.params.length,t.params.length);for(var n=0;n<r;n++){var i=f(e,n,true);var a=f(t,n,true);if(!T(i,a)){return false}}var o=e.params.length;var s=t.params.length;var u=$(e.params);var c=$(t.params);return u?c?o===s:s>=o:c?o>=s:o===s}function w(r,t){if(Object.keys(t).length===0){throw new SyntaxError("No signatures provided")}var n=[];Object.keys(t).map(function(e){return H(e,t[e],F.conversions)}).filter(K).forEach(function(t){var e=ee(n,function(e){return Q(e,t)});if(e){throw new TypeError('Conflicting signatures "'+L(e.params)+'" and "'+L(t.params)+'".')}n.push(t)});var i=te(n,function(t){var e=t?X(t.params,false):[];return e.map(function(e){return{params:e,fn:t.fn}})}).filter(K);i.sort(J);var e=i[0]&&i[0].params.length<=2&&!$(i[0].params);var a=i[1]&&i[1].params.length<=2&&!$(i[1].params);var o=i[2]&&i[2].params.length<=2&&!$(i[2].params);var s=i[3]&&i[3].params.length<=2&&!$(i[3].params);var u=i[4]&&i[4].params.length<=2&&!$(i[4].params);var c=i[5]&&i[5].params.length<=2&&!$(i[5].params);var f=e&&a&&o&&s&&u&&c;var l=i.map(function(e){return Z(e.params)});var p=e?G(i[0].params[0]):re;var m=a?G(i[1].params[0]):re;var h=o?G(i[2].params[0]):re;var d=s?G(i[3].params[0]):re;var y=u?G(i[4].params[0]):re;var g=c?G(i[5].params[0]):re;var v=e?G(i[0].params[1]):re;var b=a?G(i[1].params[1]):re;var x=o?G(i[2].params[1]):re;var w=s?G(i[3].params[1]):re;var N=u?G(i[4].params[1]):re;var O=c?G(i[5].params[1]):re;var M=i.map(function(e){return W(e.params,e.fn)});var j=e?M[0]:ne;var E=a?M[1]:ne;var S=o?M[2]:ne;var A=s?M[3]:ne;var C=u?M[4]:ne;var T=c?M[5]:ne;var _=e?i[0].params.length:-1;var q=a?i[1].params.length:-1;var I=o?i[2].params.length:-1;var k=s?i[3].params.length:-1;var B=u?i[4].params.length:-1;var z=c?i[5].params.length:-1;var D=f?6:0;var R=i.length;var P=function e(){"use strict";for(var t=D;t<R;t++){if(l[t](arguments)){return M[t].apply(this,arguments)}}throw V(r,arguments,i)};var U=function e(t,r){"use strict";if(arguments.length===_&&p(t)&&v(r)){return j.apply(e,arguments)}if(arguments.length===q&&m(t)&&b(r)){return E.apply(e,arguments)}if(arguments.length===I&&h(t)&&x(r)){return S.apply(e,arguments)}if(arguments.length===k&&d(t)&&w(r)){return A.apply(e,arguments)}if(arguments.length===B&&y(t)&&N(r)){return C.apply(e,arguments)}if(arguments.length===z&&g(t)&&O(r)){return T.apply(e,arguments)}return P.apply(e,arguments)};try{Object.defineProperty(U,"name",{value:r})}catch(e){}U.signatures=Y(i);return U}function N(e){return F.ignore.indexOf(e)===-1}function O(e){return e.trim()}function M(e){return!!e}function K(e){return e!==null}function j(e){return e.types.length===0}function E(e){return e.slice(0,e.length-1)}function S(e){return e[e.length-1]}function A(e,t,r){return Array.prototype.slice.call(e,t,r)}function C(e,t){return e.indexOf(t)!==-1}function T(e,t){for(var r=0;r<e.length;r++){if(C(t,e[r])){return true}}return false}function ee(e,t){for(var r=0;r<e.length;r++){if(t(e[r])){return e[r]}}return undefined}function _(e){var t={};for(var r=0;r<e.length;r++){t[e[r]]=true}return Object.keys(t)}function te(e,t){return Array.prototype.concat.apply([],e.map(t))}function q(e){var t="";for(var r=0;r<e.length;r++){var n=e[r];if((typeof n.signatures==="object"||typeof n.signature==="string")&&n.name!==""){if(t===""){t=n.name}else if(t!==n.name){var i=new Error("Function names do not match (expected: "+t+", actual: "+n.name+")");i.data={actual:n.name,expected:t};throw i}}}return t}function I(e){var r;var n={};function t(e,t){if(n.hasOwnProperty(e)&&t!==n[e]){r=new Error('Signature "'+e+'" is defined twice');r.data={signature:e};throw r}}for(var i=0;i<e.length;i++){var a=e[i];if(typeof a.signatures==="object"){for(var o in a.signatures){if(a.signatures.hasOwnProperty(o)){t(o,a.signatures[o]);n[o]=a.signatures[o]}}}else if(typeof a.signature==="string"){t(a.signature,a);n[a.signature]=a}else{r=new TypeError("Function is no typed-function (index: "+i+")");r.data={index:i};throw r}}return n}F=w("typed",{"string, Object":w,Object:function(e){var t=[];for(var r in e){if(e.hasOwnProperty(r)){t.push(e[r])}}var n=q(t);return w(n,e)},"...Function":function(e){return w(q(e),I(e))},"string, ...Function":function(e,t){return w(e,I(t))}});F.create=B;F.types=e;F.conversions=r;F.ignore=t;F.convert=a;F.find=i;F.addType=function(e,t){if(!e||typeof e.name!=="string"||typeof e.test!=="function"){throw new TypeError("Object with properties {name: string, test: function} expected")}if(t!==false){for(var r=0;r<F.types.length;r++){if(F.types[r].name==="Object"){F.types.splice(r,0,e);return}}}F.types.push(e)};F.addConversion=function(e){if(!e||typeof e.from!=="string"||typeof e.to!=="string"||typeof e.convert!=="function"){throw new TypeError("Object with properties {from: string, to: string, convert: function} expected")}F.conversions.push(e)};return F}return B()})?n.apply(t,i):n)||(e.exports=a)},function(m,e,t){"use strict";(function(e){var s=256,i=[],a=void 0===e?window:e,o=Math.pow(s,6),u=Math.pow(2,52),c=2*u,t=Math.random;function f(e){var t,r=e.length,o=this,n=0,i=o.i=o.j=0,a=o.S=[];for(r||(e=[r++]);n<s;)a[n]=n++;for(n=0;n<s;n++)a[n]=a[i=255&i+e[n%r]+(t=a[n])],a[i]=t;(o.g=function(e){for(var t,r=0,n=o.i,i=o.j,a=o.S;e--;)t=a[n=255&n+1],r=r*s+a[255&(a[n]=a[i=255&i+t])+(a[i]=t)];return o.i=n,o.j=i,r})(s)}function l(e,t){for(var r,n=e+"",i=0;i<n.length;)t[255&i]=255&(r^=19*t[255&i])+n.charCodeAt(i++);return p(t)}function p(e){return String.fromCharCode.apply(0,e)}m.exports=function(e,t){if(t&&!0===t.global)return t.global=!1,Math.random=m.exports(e,t),t.global=!0,Math.random;var r=[],n=(l(function e(t,r){var n,i=[],a=(typeof t)[0];if(r&&"o"==a)for(n in t)try{i.push(e(t[n],r-1))}catch(e){}return i.length?i:"s"==a?t:t+"\0"}(t&&t.entropy||!1?[e,p(i)]:0 in arguments?e:function(e){try{return a.crypto.getRandomValues(e=new Uint8Array(s)),p(e)}catch(e){return[+new Date,a,a.navigator&&a.navigator.plugins,a.screen,p(i)]}}(),3),r),new f(r));return l(p(n.S),i),function(){for(var e=n.g(6),t=o,r=0;e<u;)e=(e+r)*s,t*=s,r=n.g(1);for(;c<=e;)e/=2,t/=2,r>>>=1;return(e+r)/t}},m.exports.resetGlobal=function(){Math.random=t},l(Math.random(),i)}).call(this,t(19))},function(t,De,Re){var Pe;!function(){"use strict";var l,T,o,s=9e15,d=1e9,y="0123456789abcdef",n="2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058",i="3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789",u={precision:20,rounding:4,modulo:1,toExpNeg:-7,toExpPos:21,minE:-s,maxE:s,crypto:!1},b=!0,c="[DecimalError] ",g=c+"Invalid argument: ",a=c+"Precision limit exceeded",f=c+"crypto unavailable",_=Math.floor,v=Math.pow,p=/^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,m=/^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,h=/^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,x=/^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,q=1e7,I=7,w=n.length-1,N=i.length-1,O={name:"[object Decimal]"};function M(e){var t,r,n,i=e.length-1,a="",o=e[0];if(0<i){for(a+=o,t=1;t<i;t++)n=e[t]+"",(r=I-n.length)&&(a+=L(r)),a+=n;o=e[t],(r=I-(n=o+"").length)&&(a+=L(r))}else if(0===o)return"0";for(;o%10==0;)o/=10;return a+o}function j(e,t,r){if(e!==~~e||e<t||r<e)throw Error(g+e)}function E(e,t,r,n){for(var i,a,o=e[0];10<=o;o/=10)--t;return--t<0?(t+=I,i=0):(i=Math.ceil((t+1)/I),t%=I),o=v(10,I-t),a=e[i]%o|0,null==n?t<3?(0==t?a=a/100|0:1==t&&(a=a/10|0),r<4&&99999==a||3<r&&49999==a||5e4==a||0==a):(r<4&&a+1==o||3<r&&a+1==o/2)&&(e[i+1]/o/100|0)==v(10,t-2)-1||(a==o/2||0==a)&&0==(e[i+1]/o/100|0):t<4?(0==t?a=a/1e3|0:1==t?a=a/100|0:2==t&&(a=a/10|0),(n||r<4)&&9999==a||!n&&3<r&&4999==a):((n||r<4)&&a+1==o||!n&&3<r&&a+1==o/2)&&(e[i+1]/o/1e3|0)==v(10,t-3)-1}function S(e,t,r){for(var n,i,a=[0],o=0,s=e.length;o<s;){for(i=a.length;i--;)a[i]*=t;for(a[0]+=y.indexOf(e.charAt(o++)),n=0;n<a.length;n++)a[n]>r-1&&(void 0===a[n+1]&&(a[n+1]=0),a[n+1]+=a[n]/r|0,a[n]%=r)}return a.reverse()}O.absoluteValue=O.abs=function(){var e=new this.constructor(this);return e.s<0&&(e.s=1),D(e)},O.ceil=function(){return D(new this.constructor(this),this.e+1,2)},O.comparedTo=O.cmp=function(e){var t,r,n,i,a=this,o=a.d,s=(e=new a.constructor(e)).d,u=a.s,c=e.s;if(!o||!s)return u&&c?u!==c?u:o===s?0:!o^u<0?1:-1:NaN;if(!o[0]||!s[0])return o[0]?u:s[0]?-c:0;if(u!==c)return u;if(a.e!==e.e)return a.e>e.e^u<0?1:-1;for(t=0,r=(n=o.length)<(i=s.length)?n:i;t<r;++t)if(o[t]!==s[t])return o[t]>s[t]^u<0?1:-1;return n===i?0:i<n^u<0?1:-1},O.cosine=O.cos=function(){var e,t,r=this,n=r.constructor;return r.d?r.d[0]?(e=n.precision,t=n.rounding,n.precision=e+Math.max(r.e,r.sd())+I,n.rounding=1,r=function(e,t){var r,n,i=t.d.length;n=i<32?(r=Math.ceil(i/3),(1/Y(4,r)).toString()):(r=16,"2.3283064365386962890625e-10");e.precision+=r,t=W(e,1,t.times(n),new e(1));for(var a=r;a--;){var o=t.times(t);t=o.times(o).minus(o).times(8).plus(1)}return e.precision-=r,t}(n,X(n,r)),n.precision=e,n.rounding=t,D(2==o||3==o?r.neg():r,e,t,!0)):new n(1):new n(NaN)},O.cubeRoot=O.cbrt=function(){var e,t,r,n,i,a,o,s,u,c,f=this,l=f.constructor;if(!f.isFinite()||f.isZero())return new l(f);for(b=!1,(a=f.s*v(f.s*f,1/3))&&Math.abs(a)!=1/0?n=new l(a.toString()):(r=M(f.d),(a=((e=f.e)-r.length+1)%3)&&(r+=1==a||-2==a?"0":"00"),a=v(r,1/3),e=_((e+1)/3)-(e%3==(e<0?-1:2)),(n=new l(r=a==1/0?"5e"+e:(r=a.toExponential()).slice(0,r.indexOf("e")+1)+e)).s=f.s),o=(e=l.precision)+3;;)if(c=(u=(s=n).times(s).times(s)).plus(f),n=A(c.plus(f).times(s),c.plus(u),o+2,1),M(s.d).slice(0,o)===(r=M(n.d)).slice(0,o)){if("9999"!=(r=r.slice(o-3,o+1))&&(i||"4999"!=r)){+r&&(+r.slice(1)||"5"!=r.charAt(0))||(D(n,e+1,1),t=!n.times(n).times(n).eq(f));break}if(!i&&(D(s,e+1,0),s.times(s).times(s).eq(f))){n=s;break}o+=4,i=1}return b=!0,D(n,e,l.rounding,t)},O.decimalPlaces=O.dp=function(){var e,t=this.d,r=NaN;if(t){if(r=((e=t.length-1)-_(this.e/I))*I,e=t[e])for(;e%10==0;e/=10)r--;r<0&&(r=0)}return r},O.dividedBy=O.div=function(e){return A(this,new this.constructor(e))},O.dividedToIntegerBy=O.divToInt=function(e){var t=this.constructor;return D(A(this,new t(e),0,1,1),t.precision,t.rounding)},O.equals=O.eq=function(e){return 0===this.cmp(e)},O.floor=function(){return D(new this.constructor(this),this.e+1,3)},O.greaterThan=O.gt=function(e){return 0<this.cmp(e)},O.greaterThanOrEqualTo=O.gte=function(e){var t=this.cmp(e);return 1==t||0===t},O.hyperbolicCosine=O.cosh=function(){var e,t,r,n,i,a=this,o=a.constructor,s=new o(1);if(!a.isFinite())return new o(a.s?1/0:NaN);if(a.isZero())return s;r=o.precision,n=o.rounding,o.precision=r+Math.max(a.e,a.sd())+4,o.rounding=1,t=(i=a.d.length)<32?(1/Y(4,e=Math.ceil(i/3))).toString():(e=16,"2.3283064365386962890625e-10"),a=W(o,1,a.times(t),new o(1),!0);for(var u,c=e,f=new o(8);c--;)u=a.times(a),a=s.minus(u.times(f.minus(u.times(f))));return D(a,o.precision=r,o.rounding=n,!0)},O.hyperbolicSine=O.sinh=function(){var e,t,r,n,i=this,a=i.constructor;if(!i.isFinite()||i.isZero())return new a(i);if(t=a.precision,r=a.rounding,a.precision=t+Math.max(i.e,i.sd())+4,a.rounding=1,(n=i.d.length)<3)i=W(a,2,i,i,!0);else{e=16<(e=1.4*Math.sqrt(n))?16:0|e,i=W(a,2,i=i.times(1/Y(5,e)),i,!0);for(var o,s=new a(5),u=new a(16),c=new a(20);e--;)o=i.times(i),i=i.times(s.plus(o.times(u.times(o).plus(c))))}return D(i,a.precision=t,a.rounding=r,!0)},O.hyperbolicTangent=O.tanh=function(){var e,t,r=this,n=r.constructor;return r.isFinite()?r.isZero()?new n(r):(e=n.precision,t=n.rounding,n.precision=e+7,n.rounding=1,A(r.sinh(),r.cosh(),n.precision=e,n.rounding=t)):new n(r.s)},O.inverseCosine=O.acos=function(){var e,t=this,r=t.constructor,n=t.abs().cmp(1),i=r.precision,a=r.rounding;return-1!==n?0===n?t.isNeg()?U(r,i,a):new r(0):new r(NaN):t.isZero()?U(r,i+4,a).times(.5):(r.precision=i+6,r.rounding=1,t=t.asin(),e=U(r,i+4,a).times(.5),r.precision=i,r.rounding=a,e.minus(t))},O.inverseHyperbolicCosine=O.acosh=function(){var e,t,r=this,n=r.constructor;return r.lte(1)?new n(r.eq(1)?0:NaN):r.isFinite()?(e=n.precision,t=n.rounding,n.precision=e+Math.max(Math.abs(r.e),r.sd())+4,n.rounding=1,b=!1,r=r.times(r).minus(1).sqrt().plus(r),b=!0,n.precision=e,n.rounding=t,r.ln()):new n(r)},O.inverseHyperbolicSine=O.asinh=function(){var e,t,r=this,n=r.constructor;return!r.isFinite()||r.isZero()?new n(r):(e=n.precision,t=n.rounding,n.precision=e+2*Math.max(Math.abs(r.e),r.sd())+6,n.rounding=1,b=!1,r=r.times(r).plus(1).sqrt().plus(r),b=!0,n.precision=e,n.rounding=t,r.ln())},O.inverseHyperbolicTangent=O.atanh=function(){var e,t,r,n,i=this,a=i.constructor;return i.isFinite()?0<=i.e?new a(i.abs().eq(1)?i.s/0:i.isZero()?i:NaN):(e=a.precision,t=a.rounding,n=i.sd(),Math.max(n,e)<2*-i.e-1?D(new a(i),e,t,!0):(a.precision=r=n-i.e,i=A(i.plus(1),new a(1).minus(i),r+e,1),a.precision=e+4,a.rounding=1,i=i.ln(),a.precision=e,a.rounding=t,i.times(.5))):new a(NaN)},O.inverseSine=O.asin=function(){var e,t,r,n,i=this,a=i.constructor;return i.isZero()?new a(i):(t=i.abs().cmp(1),r=a.precision,n=a.rounding,-1!==t?0===t?((e=U(a,r+4,n).times(.5)).s=i.s,e):new a(NaN):(a.precision=r+6,a.rounding=1,i=i.div(new a(1).minus(i.times(i)).sqrt().plus(1)).atan(),a.precision=r,a.rounding=n,i.times(2)))},O.inverseTangent=O.atan=function(){var e,t,r,n,i,a,o,s,u,c=this,f=c.constructor,l=f.precision,p=f.rounding;if(c.isFinite()){if(c.isZero())return new f(c);if(c.abs().eq(1)&&l+4<=N)return(o=U(f,l+4,p).times(.25)).s=c.s,o}else{if(!c.s)return new f(NaN);if(l+4<=N)return(o=U(f,l+4,p).times(.5)).s=c.s,o}for(f.precision=s=l+10,f.rounding=1,e=r=Math.min(28,s/I+2|0);e;--e)c=c.div(c.times(c).plus(1).sqrt().plus(1));for(b=!1,t=Math.ceil(s/I),n=1,u=c.times(c),o=new f(c),i=c;-1!==e;)if(i=i.times(u),a=o.minus(i.div(n+=2)),i=i.times(u),void 0!==(o=a.plus(i.div(n+=2))).d[t])for(e=t;o.d[e]===a.d[e]&&e--;);return r&&(o=o.times(2<<r-1)),b=!0,D(o,f.precision=l,f.rounding=p,!0)},O.isFinite=function(){return!!this.d},O.isInteger=O.isInt=function(){return!!this.d&&_(this.e/I)>this.d.length-2},O.isNaN=function(){return!this.s},O.isNegative=O.isNeg=function(){return this.s<0},O.isPositive=O.isPos=function(){return 0<this.s},O.isZero=function(){return!!this.d&&0===this.d[0]},O.lessThan=O.lt=function(e){return this.cmp(e)<0},O.lessThanOrEqualTo=O.lte=function(e){return this.cmp(e)<1},O.logarithm=O.log=function(e){var t,r,n,i,a,o,s,u,c=this,f=c.constructor,l=f.precision,p=f.rounding;if(null==e)e=new f(10),t=!0;else{if(r=(e=new f(e)).d,e.s<0||!r||!r[0]||e.eq(1))return new f(NaN);t=e.eq(10)}if(r=c.d,c.s<0||!r||!r[0]||c.eq(1))return new f(r&&!r[0]?-1/0:1!=c.s?NaN:r?0:1/0);if(t)if(1<r.length)a=!0;else{for(i=r[0];i%10==0;)i/=10;a=1!==i}if(b=!1,o=Z(c,s=l+5),n=t?P(f,s+10):Z(e,s),E((u=A(o,n,s,1)).d,i=l,p))do{if(o=Z(c,s+=10),n=t?P(f,s+10):Z(e,s),u=A(o,n,s,1),!a){+M(u.d).slice(i+1,i+15)+1==1e14&&(u=D(u,l+1,0));break}}while(E(u.d,i+=10,p));return b=!0,D(u,l,p)},O.minus=O.sub=function(e){var t,r,n,i,a,o,s,u,c,f,l,p,m=this,h=m.constructor;if(e=new h(e),!m.d||!e.d)return m.s&&e.s?m.d?e.s=-e.s:e=new h(e.d||m.s!==e.s?m:NaN):e=new h(NaN),e;if(m.s!=e.s)return e.s=-e.s,m.plus(e);if(c=m.d,p=e.d,s=h.precision,u=h.rounding,!c[0]||!p[0]){if(p[0])e.s=-e.s;else{if(!c[0])return new h(3===u?-0:0);e=new h(m)}return b?D(e,s,u):e}if(r=_(e.e/I),f=_(m.e/I),c=c.slice(),a=f-r){for(o=(l=a<0)?(t=c,a=-a,p.length):(t=p,r=f,c.length),(n=Math.max(Math.ceil(s/I),o)+2)<a&&(a=n,t.length=1),t.reverse(),n=a;n--;)t.push(0);t.reverse()}else{for((l=(n=c.length)<(o=p.length))&&(o=n),n=0;n<o;n++)if(c[n]!=p[n]){l=c[n]<p[n];break}a=0}for(l&&(t=c,c=p,p=t,e.s=-e.s),o=c.length,n=p.length-o;0<n;--n)c[o++]=0;for(n=p.length;a<n;){if(c[--n]<p[n]){for(i=n;i&&0===c[--i];)c[i]=q-1;--c[i],c[n]+=q}c[n]-=p[n]}for(;0===c[--o];)c.pop();for(;0===c[0];c.shift())--r;return c[0]?(e.d=c,e.e=R(c,r),b?D(e,s,u):e):new h(3===u?-0:0)},O.modulo=O.mod=function(e){var t,r=this,n=r.constructor;return e=new n(e),!r.d||!e.s||e.d&&!e.d[0]?new n(NaN):!e.d||r.d&&!r.d[0]?D(new n(r),n.precision,n.rounding):(b=!1,9==n.modulo?(t=A(r,e.abs(),0,3,1)).s*=e.s:t=A(r,e,0,n.modulo,1),t=t.times(e),b=!0,r.minus(t))},O.naturalExponential=O.exp=function(){return G(this)},O.naturalLogarithm=O.ln=function(){return Z(this)},O.negated=O.neg=function(){var e=new this.constructor(this);return e.s=-e.s,D(e)},O.plus=O.add=function(e){var t,r,n,i,a,o,s,u,c,f,l=this,p=l.constructor;if(e=new p(e),!l.d||!e.d)return l.s&&e.s?l.d||(e=new p(e.d||l.s===e.s?l:NaN)):e=new p(NaN),e;if(l.s!=e.s)return e.s=-e.s,l.minus(e);if(c=l.d,f=e.d,s=p.precision,u=p.rounding,!c[0]||!f[0])return f[0]||(e=new p(l)),b?D(e,s,u):e;if(a=_(l.e/I),n=_(e.e/I),c=c.slice(),i=a-n){for((o=(o=i<0?(r=c,i=-i,f.length):(r=f,n=a,c.length))<(a=Math.ceil(s/I))?a+1:o+1)<i&&(i=o,r.length=1),r.reverse();i--;)r.push(0);r.reverse()}for((o=c.length)-(i=f.length)<0&&(i=o,r=f,f=c,c=r),t=0;i;)t=(c[--i]=c[i]+f[i]+t)/q|0,c[i]%=q;for(t&&(c.unshift(t),++n),o=c.length;0==c[--o];)c.pop();return e.d=c,e.e=R(c,n),b?D(e,s,u):e},O.precision=O.sd=function(e){var t;if(void 0!==e&&e!==!!e&&1!==e&&0!==e)throw Error(g+e);return this.d?(t=F(this.d),e&&this.e+1>t&&(t=this.e+1)):t=NaN,t},O.round=function(){var e=this.constructor;return D(new e(this),this.e+1,e.rounding)},O.sine=O.sin=function(){var e,t,r=this,n=r.constructor;return r.isFinite()?r.isZero()?new n(r):(e=n.precision,t=n.rounding,n.precision=e+Math.max(r.e,r.sd())+I,n.rounding=1,r=function(e,t){var r,n=t.d.length;if(n<3)return W(e,2,t,t);r=16<(r=1.4*Math.sqrt(n))?16:0|r,t=t.times(1/Y(5,r)),t=W(e,2,t,t);for(var i,a=new e(5),o=new e(16),s=new e(20);r--;)i=t.times(t),t=t.times(a.plus(i.times(o.times(i).minus(s))));return t}(n,X(n,r)),n.precision=e,n.rounding=t,D(2<o?r.neg():r,e,t,!0)):new n(NaN)},O.squareRoot=O.sqrt=function(){var e,t,r,n,i,a,o=this,s=o.d,u=o.e,c=o.s,f=o.constructor;if(1!==c||!s||!s[0])return new f(!c||c<0&&(!s||s[0])?NaN:s?o:1/0);for(b=!1,n=0==(c=Math.sqrt(+o))||c==1/0?(((t=M(s)).length+u)%2==0&&(t+="0"),c=Math.sqrt(t),u=_((u+1)/2)-(u<0||u%2),new f(t=c==1/0?"1e"+u:(t=c.toExponential()).slice(0,t.indexOf("e")+1)+u)):new f(c.toString()),r=(u=f.precision)+3;;)if(n=(a=n).plus(A(o,a,r+2,1)).times(.5),M(a.d).slice(0,r)===(t=M(n.d)).slice(0,r)){if("9999"!=(t=t.slice(r-3,r+1))&&(i||"4999"!=t)){+t&&(+t.slice(1)||"5"!=t.charAt(0))||(D(n,u+1,1),e=!n.times(n).eq(o));break}if(!i&&(D(a,u+1,0),a.times(a).eq(o))){n=a;break}r+=4,i=1}return b=!0,D(n,u,f.rounding,e)},O.tangent=O.tan=function(){var e,t,r=this,n=r.constructor;return r.isFinite()?r.isZero()?new n(r):(e=n.precision,t=n.rounding,n.precision=e+10,n.rounding=1,(r=r.sin()).s=1,r=A(r,new n(1).minus(r.times(r)).sqrt(),e+10,0),n.precision=e,n.rounding=t,D(2==o||4==o?r.neg():r,e,t,!0)):new n(NaN)},O.times=O.mul=function(e){var t,r,n,i,a,o,s,u,c,f=this.constructor,l=this.d,p=(e=new f(e)).d;if(e.s*=this.s,!(l&&l[0]&&p&&p[0]))return new f(!e.s||l&&!l[0]&&!p||p&&!p[0]&&!l?NaN:l&&p?0*e.s:e.s/0);for(r=_(this.e/I)+_(e.e/I),(u=l.length)<(c=p.length)&&(a=l,l=p,p=a,o=u,u=c,c=o),a=[],n=o=u+c;n--;)a.push(0);for(n=c;0<=--n;){for(t=0,i=u+n;n<i;)s=a[i]+p[n]*l[i-n-1]+t,a[i--]=s%q|0,t=s/q|0;a[i]=(a[i]+t)%q|0}for(;!a[--o];)a.pop();return t?++r:a.shift(),e.d=a,e.e=R(a,r),b?D(e,f.precision,f.rounding):e},O.toBinary=function(e,t){return r(this,2,e,t)},O.toDecimalPlaces=O.toDP=function(e,t){var r=this.constructor,n=new r(this);return void 0===e?n:(j(e,0,d),void 0===t?t=r.rounding:j(t,0,8),D(n,e+n.e+1,t))},O.toExponential=function(e,t){var r=this,n=r.constructor,i=void 0===e?C(r,!0):(j(e,0,d),void 0===t?t=n.rounding:j(t,0,8),C(r=D(new n(r),e+1,t),!0,e+1));return r.isNeg()&&!r.isZero()?"-"+i:i},O.toFixed=function(e,t){var r,n=this,i=n.constructor,a=void 0===e?C(n):(j(e,0,d),void 0===t?t=i.rounding:j(t,0,8),C(r=D(new i(n),e+n.e+1,t),!1,e+r.e+1));return n.isNeg()&&!n.isZero()?"-"+a:a},O.toFraction=function(e){var t,r,n,i,a,o,s,u,c,f,l,p,m=this,h=m.d,d=m.constructor;if(!h)return new d(m);if(c=r=new d(1),n=u=new d(0),o=(a=(t=new d(n)).e=F(h)-m.e-1)%I,t.d[0]=v(10,o<0?I+o:o),null==e)e=0<a?t:c;else{if(!(s=new d(e)).isInt()||s.lt(c))throw Error(g+s);e=s.gt(t)?0<a?t:c:s}for(b=!1,s=new d(M(h)),f=d.precision,d.precision=a=h.length*I*2;l=A(s,t,0,1,1),1!=(i=r.plus(l.times(n))).cmp(e);)r=n,n=i,i=c,c=u.plus(l.times(i)),u=i,i=t,t=s.minus(l.times(i)),s=i;return i=A(e.minus(r),n,0,1,1),u=u.plus(i.times(c)),r=r.plus(i.times(n)),u.s=c.s=m.s,p=A(c,n,a,1).minus(m).abs().cmp(A(u,r,a,1).minus(m).abs())<1?[c,n]:[u,r],d.precision=f,b=!0,p},O.toHexadecimal=O.toHex=function(e,t){return r(this,16,e,t)},O.toNearest=function(e,t){var r=(n=this).constructor,n=new r(n);if(null==e){if(!n.d)return n;e=new r(1),t=r.rounding}else{if(e=new r(e),void 0===t?t=r.rounding:j(t,0,8),!n.d)return e.s?n:e;if(!e.d)return e.s&&(e.s=n.s),e}return e.d[0]?(b=!1,n=A(n,e,0,t,1).times(e),b=!0,D(n)):(e.s=n.s,n=e),n},O.toNumber=function(){return+this},O.toOctal=function(e,t){return r(this,8,e,t)},O.toPower=O.pow=function(e){var t,r,n,i,a,o,s=this,u=s.constructor,c=+(e=new u(e));if(!(s.d&&e.d&&s.d[0]&&e.d[0]))return new u(v(+s,c));if((s=new u(s)).eq(1))return s;if(n=u.precision,a=u.rounding,e.eq(1))return D(s,n,a);if((t=_(e.e/I))>=e.d.length-1&&(r=c<0?-c:c)<=9007199254740991)return i=H(u,s,r,n),e.s<0?new u(1).div(i):D(i,n,a);if((o=s.s)<0){if(t<e.d.length-1)return new u(NaN);if(0==(1&e.d[t])&&(o=1),0==s.e&&1==s.d[0]&&1==s.d.length)return s.s=o,s}return(t=0!=(r=v(+s,c))&&isFinite(r)?new u(r+"").e:_(c*(Math.log("0."+M(s.d))/Math.LN10+s.e+1)))>u.maxE+1||t<u.minE-1?new u(0<t?o/0:0):(b=!1,u.rounding=s.s=1,r=Math.min(12,(t+"").length),(i=G(e.times(Z(s,n+r)),n)).d&&E((i=D(i,n+5,1)).d,n,a)&&(t=n+10,+M((i=D(G(e.times(Z(s,t+r)),t),t+5,1)).d).slice(n+1,n+15)+1==1e14&&(i=D(i,n+1,0))),i.s=o,b=!0,D(i,n,u.rounding=a))},O.toPrecision=function(e,t){var r=this,n=r.constructor,i=void 0===e?C(r,r.e<=n.toExpNeg||r.e>=n.toExpPos):(j(e,1,d),void 0===t?t=n.rounding:j(t,0,8),C(r=D(new n(r),e,t),e<=r.e||r.e<=n.toExpNeg,e));return r.isNeg()&&!r.isZero()?"-"+i:i},O.toSignificantDigits=O.toSD=function(e,t){var r=this.constructor;return void 0===e?(e=r.precision,t=r.rounding):(j(e,1,d),void 0===t?t=r.rounding:j(t,0,8)),D(new r(this),e,t)},O.toString=function(){var e=this,t=e.constructor,r=C(e,e.e<=t.toExpNeg||e.e>=t.toExpPos);return e.isNeg()&&!e.isZero()?"-"+r:r},O.truncated=O.trunc=function(){return D(new this.constructor(this),this.e+1,1)},O.valueOf=O.toJSON=function(){var e=this,t=e.constructor,r=C(e,e.e<=t.toExpNeg||e.e>=t.toExpPos);return e.isNeg()?"-"+r:r};var A=function(e,t,r,n,i,a){var o,s,u,c,f,l,p,m,h,d,y,g,v,b,x,w,N,O,M,j,E=e.constructor,S=e.s==t.s?1:-1,A=e.d,C=t.d;if(!(A&&A[0]&&C&&C[0]))return new E(e.s&&t.s&&(A?!C||A[0]!=C[0]:C)?A&&0==A[0]||!C?0*S:S/0:NaN);for(s=a?(f=1,e.e-t.e):(a=q,f=I,_(e.e/f)-_(t.e/f)),M=C.length,N=A.length,d=(h=new E(S)).d=[],u=0;C[u]==(A[u]||0);u++);if(C[u]>(A[u]||0)&&s--,null==r?(b=r=E.precision,n=E.rounding):b=i?r+(e.e-t.e)+1:r,b<0)d.push(1),l=!0;else{if(b=b/f+2|0,u=0,1==M){for(C=C[c=0],b++;(u<N||c)&&b--;u++)x=c*a+(A[u]||0),d[u]=x/C|0,c=x%C|0;l=c||u<N}else{for(1<(c=a/(C[0]+1)|0)&&(C=k(C,c,a),A=k(A,c,a),M=C.length,N=A.length),w=M,g=(y=A.slice(0,M)).length;g<M;)y[g++]=0;for((j=C.slice()).unshift(0),O=C[0],C[1]>=a/2&&++O;c=0,(o=B(C,y,M,g))<0?(v=y[0],M!=g&&(v=v*a+(y[1]||0)),1<(c=v/O|0)?(a<=c&&(c=a-1),1==(o=B(p=k(C,c,a),y,m=p.length,g=y.length))&&(c--,z(p,M<m?j:C,m,a))):(0==c&&(o=c=1),p=C.slice()),(m=p.length)<g&&p.unshift(0),z(y,p,g,a),-1==o&&(o=B(C,y,M,g=y.length))<1&&(c++,z(y,M<g?j:C,g,a)),g=y.length):0===o&&(c++,y=[0]),d[u++]=c,o&&y[0]?y[g++]=A[w]||0:(y=[A[w]],g=1),(w++<N||void 0!==y[0])&&b--;);l=void 0!==y[0]}d[0]||d.shift()}if(1==f)h.e=s,T=l;else{for(u=1,c=d[0];10<=c;c/=10)u++;h.e=u+s*f-1,D(h,i?r+h.e+1:r,n,l)}return h};function k(e,t,r){var n,i=0,a=e.length;for(e=e.slice();a--;)n=e[a]*t+i,e[a]=n%r|0,i=n/r|0;return i&&e.unshift(i),e}function B(e,t,r,n){var i,a;if(r!=n)a=n<r?1:-1;else for(i=a=0;i<r;i++)if(e[i]!=t[i]){a=e[i]>t[i]?1:-1;break}return a}function z(e,t,r,n){for(var i=0;r--;)e[r]-=i,i=e[r]<t[r]?1:0,e[r]=i*n+e[r]-t[r];for(;!e[0]&&1<e.length;)e.shift()}function D(e,t,r,n){var i,a,o,s,u,c,f,l,p,m=e.constructor;e:if(null!=t){if(!(l=e.d))return e;for(i=1,s=l[0];10<=s;s/=10)i++;if((a=t-i)<0)a+=I,o=t,u=(f=l[p=0])/v(10,i-o-1)%10|0;else if(p=Math.ceil((a+1)/I),(s=l.length)<=p){if(!n)break e;for(;s++<=p;)l.push(0);f=u=0,o=(a%=I)-I+(i=1)}else{for(f=s=l[p],i=1;10<=s;s/=10)i++;u=(o=(a%=I)-I+i)<0?0:f/v(10,i-o-1)%10|0}if(n=n||t<0||void 0!==l[p+1]||(o<0?f:f%v(10,i-o-1)),c=r<4?(u||n)&&(0==r||r==(e.s<0?3:2)):5<u||5==u&&(4==r||n||6==r&&(0<a?0<o?f/v(10,i-o):0:l[p-1])%10&1||r==(e.s<0?8:7)),t<1||!l[0])return l.length=0,c?(t-=e.e+1,l[0]=v(10,(I-t%I)%I),e.e=-t||0):l[0]=e.e=0,e;if(0==a?(l.length=p,s=1,p--):(l.length=p+1,s=v(10,I-a),l[p]=0<o?(f/v(10,i-o)%v(10,o)|0)*s:0),c)for(;;){if(0==p){for(a=1,o=l[0];10<=o;o/=10)a++;for(o=l[0]+=s,s=1;10<=o;o/=10)s++;a!=s&&(e.e++,l[0]==q&&(l[0]=1));break}if(l[p]+=s,l[p]!=q)break;l[p--]=0,s=1}for(a=l.length;0===l[--a];)l.pop()}return b&&(e.e>m.maxE?(e.d=null,e.e=NaN):e.e<m.minE&&(e.e=0,e.d=[0])),e}function C(e,t,r){if(!e.isFinite())return V(e);var n,i=e.e,a=M(e.d),o=a.length;return t?(r&&0<(n=r-o)?a=a.charAt(0)+"."+a.slice(1)+L(n):1<o&&(a=a.charAt(0)+"."+a.slice(1)),a=a+(e.e<0?"e":"e+")+e.e):i<0?(a="0."+L(-i-1)+a,r&&0<(n=r-o)&&(a+=L(n))):o<=i?(a+=L(i+1-o),r&&0<(n=r-i-1)&&(a=a+"."+L(n))):((n=i+1)<o&&(a=a.slice(0,n)+"."+a.slice(n)),r&&0<(n=r-o)&&(i+1===o&&(a+="."),a+=L(n))),a}function R(e,t){var r=e[0];for(t*=I;10<=r;r/=10)t++;return t}function P(e,t,r){if(w<t)throw b=!0,r&&(e.precision=r),Error(a);return D(new e(n),t,1,!0)}function U(e,t,r){if(N<t)throw Error(a);return D(new e(i),t,r,!0)}function F(e){var t=e.length-1,r=t*I+1;if(t=e[t]){for(;t%10==0;t/=10)r--;for(t=e[0];10<=t;t/=10)r++}return r}function L(e){for(var t="";e--;)t+="0";return t}function H(e,t,r,n){var i,a=new e(1),o=Math.ceil(n/I+4);for(b=!1;;){if(r%2&&Q((a=a.times(t)).d,o)&&(i=!0),0===(r=_(r/2))){r=a.d.length-1,i&&0===a.d[r]&&++a.d[r];break}Q((t=t.times(t)).d,o)}return b=!0,a}function $(e){return 1&e.d[e.d.length-1]}function e(e,t,r){for(var n,i=new e(t[0]),a=0;++a<t.length;){if(!(n=new e(t[a])).s){i=n;break}i[r](n)&&(i=n)}return i}function G(e,t){var r,n,i,a,o,s,u,c=0,f=0,l=0,p=e.constructor,m=p.rounding,h=p.precision;if(!e.d||!e.d[0]||17<e.e)return new p(e.d?e.d[0]?e.s<0?0:1/0:1:e.s?e.s<0?0:e:NaN);for(u=null==t?(b=!1,h):t,s=new p(.03125);-2<e.e;)e=e.times(s),l+=5;for(u+=n=Math.log(v(2,l))/Math.LN10*2+5|0,r=a=o=new p(1),p.precision=u;;){if(a=D(a.times(e),u,1),r=r.times(++f),M((s=o.plus(A(a,r,u,1))).d).slice(0,u)===M(o.d).slice(0,u)){for(i=l;i--;)o=D(o.times(o),u,1);if(null!=t)return p.precision=h,o;if(!(c<3&&E(o.d,u-n,m,c)))return D(o,p.precision=h,m,b=!0);p.precision=u+=10,r=a=s=new p(1),f=0,c++}o=s}}function Z(e,t){var r,n,i,a,o,s,u,c,f,l,p,m=1,h=e,d=h.d,y=h.constructor,g=y.rounding,v=y.precision;if(h.s<0||!d||!d[0]||!h.e&&1==d[0]&&1==d.length)return new y(d&&!d[0]?-1/0:1!=h.s?NaN:d?0:h);if(f=null==t?(b=!1,v):t,y.precision=f+=10,n=(r=M(d)).charAt(0),!(Math.abs(a=h.e)<15e14))return c=P(y,f+2,v).times(a+""),h=Z(new y(n+"."+r.slice(1)),f-10).plus(c),y.precision=v,null==t?D(h,v,g,b=!0):h;for(;n<7&&1!=n||1==n&&3<r.charAt(1);)n=(r=M((h=h.times(e)).d)).charAt(0),m++;for(a=h.e,1<n?(h=new y("0."+r),a++):h=new y(n+"."+r.slice(1)),u=o=h=A((l=h).minus(1),h.plus(1),f,1),p=D(h.times(h),f,1),i=3;;){if(o=D(o.times(p),f,1),M((c=u.plus(A(o,new y(i),f,1))).d).slice(0,f)===M(u.d).slice(0,f)){if(u=u.times(2),0!==a&&(u=u.plus(P(y,f+2,v).times(a+""))),u=A(u,new y(m),f,1),null!=t)return y.precision=v,u;if(!E(u.d,f-10,g,s))return D(u,y.precision=v,g,b=!0);y.precision=f+=10,c=o=h=A(l.minus(1),l.plus(1),f,1),p=D(h.times(h),f,1),i=s=1}u=c,i+=2}}function V(e){return String(e.s*e.s/0)}function J(e,t){var r,n,i;for(-1<(r=t.indexOf("."))&&(t=t.replace(".","")),0<(n=t.search(/e/i))?(r<0&&(r=n),r+=+t.slice(n+1),t=t.substring(0,n)):r<0&&(r=t.length),n=0;48===t.charCodeAt(n);n++);for(i=t.length;48===t.charCodeAt(i-1);--i);if(t=t.slice(n,i)){if(i-=n,e.e=r=r-n-1,e.d=[],n=(r+1)%I,r<0&&(n+=I),n<i){for(n&&e.d.push(+t.slice(0,n)),i-=I;n<i;)e.d.push(+t.slice(n,n+=I));t=t.slice(n),n=I-t.length}else n-=i;for(;n--;)t+="0";e.d.push(+t),b&&(e.e>e.constructor.maxE?(e.d=null,e.e=NaN):e.e<e.constructor.minE&&(e.e=0,e.d=[0]))}else e.e=0,e.d=[0];return e}function W(e,t,r,n,i){var a,o,s,u,c=e.precision,f=Math.ceil(c/I);for(b=!1,u=r.times(r),s=new e(n);;){if(o=A(s.times(u),new e(t++*t++),c,1),s=i?n.plus(o):n.minus(o),n=A(o.times(u),new e(t++*t++),c,1),void 0!==(o=s.plus(n)).d[f]){for(a=f;o.d[a]===s.d[a]&&a--;);if(-1==a)break}a=s,s=n,n=o,o=a,0}return b=!0,o.d.length=f+1,o}function Y(e,t){for(var r=e;--t;)r*=e;return r}function X(e,t){var r,n=t.s<0,i=U(e,e.precision,1),a=i.times(.5);if((t=t.abs()).lte(a))return o=n?4:1,t;if((r=t.divToInt(i)).isZero())o=n?3:2;else{if((t=t.minus(r.times(i))).lte(a))return o=$(r)?n?2:3:n?4:1,t;o=$(r)?n?1:4:n?3:2}return t.minus(i).abs()}function r(e,t,r,n){var i,a,o,s,u,c,f,l,p,m=e.constructor,h=void 0!==r;if(h?(j(r,1,d),void 0===n?n=m.rounding:j(n,0,8)):(r=m.precision,n=m.rounding),e.isFinite()){for(h?(i=2,16==t?r=4*r-3:8==t&&(r=3*r-2)):i=t,0<=(o=(f=C(e)).indexOf("."))&&(f=f.replace(".",""),(p=new m(1)).e=f.length-o,p.d=S(C(p),10,i),p.e=p.d.length),a=u=(l=S(f,10,i)).length;0==l[--u];)l.pop();if(l[0]){if(o<0?a--:((e=new m(e)).d=l,e.e=a,l=(e=A(e,p,r,n,0,i)).d,a=e.e,c=T),o=l[r],s=i/2,c=c||void 0!==l[r+1],c=n<4?(void 0!==o||c)&&(0===n||n===(e.s<0?3:2)):s<o||o===s&&(4===n||c||6===n&&1&l[r-1]||n===(e.s<0?8:7)),l.length=r,c)for(;++l[--r]>i-1;)l[r]=0,r||(++a,l.unshift(1));for(u=l.length;!l[u-1];--u);for(o=0,f="";o<u;o++)f+=y.charAt(l[o]);if(h){if(1<u)if(16==t||8==t){for(o=16==t?4:3,--u;u%o;u++)f+="0";for(u=(l=S(f,i,t)).length;!l[u-1];--u);for(o=1,f="1.";o<u;o++)f+=y.charAt(l[o])}else f=f.charAt(0)+"."+f.slice(1);f=f+(a<0?"p":"p+")+a}else if(a<0){for(;++a;)f="0"+f;f="0."+f}else if(++a>u)for(a-=u;a--;)f+="0";else a<u&&(f=f.slice(0,a)+"."+f.slice(a))}else f=h?"0p+0":"0";f=(16==t?"0x":2==t?"0b":8==t?"0o":"")+f}else f=V(e);return e.s<0?"-"+f:f}function Q(e,t){return e.length>t&&(e.length=t,1)}function K(e){return new this(e).abs()}function ee(e){return new this(e).acos()}function te(e){return new this(e).acosh()}function re(e,t){return new this(e).plus(t)}function ne(e){return new this(e).asin()}function ie(e){return new this(e).asinh()}function ae(e){return new this(e).atan()}function oe(e){return new this(e).atanh()}function se(e,t){e=new this(e),t=new this(t);var r,n=this.precision,i=this.rounding,a=n+4;return e.s&&t.s?e.d||t.d?!t.d||e.isZero()?(r=t.s<0?U(this,n,i):new this(0)).s=e.s:!e.d||t.isZero()?(r=U(this,a,1).times(.5)).s=e.s:r=t.s<0?(this.precision=a,this.rounding=1,r=this.atan(A(e,t,a,1)),t=U(this,a,1),this.precision=n,this.rounding=i,e.s<0?r.minus(t):r.plus(t)):this.atan(A(e,t,a,1)):(r=U(this,a,1).times(0<t.s?.25:.75)).s=e.s:r=new this(NaN),r}function ue(e){return new this(e).cbrt()}function ce(e){return D(e=new this(e),e.e+1,2)}function fe(e){if(!e||"object"!=typeof e)throw Error(c+"Object expected");for(var t,r,n=!0===e.defaults,i=["precision",1,d,"rounding",0,8,"toExpNeg",-s,0,"toExpPos",0,s,"maxE",0,s,"minE",-s,0,"modulo",0,9],a=0;a<i.length;a+=3)if(t=i[a],n&&(this[t]=u[t]),void 0!==(r=e[t])){if(!(_(r)===r&&i[a+1]<=r&&r<=i[a+2]))throw Error(g+t+": "+r);this[t]=r}if(t="crypto",n&&(this[t]=u[t]),void 0!==(r=e[t])){if(!0!==r&&!1!==r&&0!==r&&1!==r)throw Error(g+t+": "+r);if(r){if("undefined"==typeof crypto||!crypto||!crypto.getRandomValues&&!crypto.randomBytes)throw Error(f);this[t]=!0}else this[t]=!1}return this}function le(e){return new this(e).cos()}function pe(e){return new this(e).cosh()}function me(e,t){return new this(e).div(t)}function he(e){return new this(e).exp()}function de(e){return D(e=new this(e),e.e+1,3)}function ye(){var e,t,r=new this(0);for(b=!1,e=0;e<arguments.length;)if((t=new this(arguments[e++])).d)r.d&&(r=r.plus(t.times(t)));else{if(t.s)return b=!0,new this(1/0);r=t}return b=!0,r.sqrt()}function ge(e){return e instanceof l||e&&"[object Decimal]"===e.name||!1}function ve(e){return new this(e).ln()}function be(e,t){return new this(e).log(t)}function xe(e){return new this(e).log(2)}function we(e){return new this(e).log(10)}function Ne(){return e(this,arguments,"lt")}function Oe(){return e(this,arguments,"gt")}function Me(e,t){return new this(e).mod(t)}function je(e,t){return new this(e).mul(t)}function Ee(e,t){return new this(e).pow(t)}function Se(e){var t,r,n,i,a=0,o=new this(1),s=[];if(void 0===e?e=this.precision:j(e,1,d),n=Math.ceil(e/I),this.crypto)if(crypto.getRandomValues)for(t=crypto.getRandomValues(new Uint32Array(n));a<n;)429e7<=(i=t[a])?t[a]=crypto.getRandomValues(new Uint32Array(1))[0]:s[a++]=i%1e7;else{if(!crypto.randomBytes)throw Error(f);for(t=crypto.randomBytes(n*=4);a<n;)214e7<=(i=t[a]+(t[a+1]<<8)+(t[a+2]<<16)+((127&t[a+3])<<24))?crypto.randomBytes(4).copy(t,a):(s.push(i%1e7),a+=4);a=n/4}else for(;a<n;)s[a++]=1e7*Math.random()|0;for(n=s[--a],e%=I,n&&e&&(i=v(10,I-e),s[a]=(n/i|0)*i);0===s[a];a--)s.pop();if(a<0)s=[r=0];else{for(r=-1;0===s[0];r-=I)s.shift();for(n=1,i=s[0];10<=i;i/=10)n++;n<I&&(r-=I-n)}return o.e=r,o.d=s,o}function Ae(e){return D(e=new this(e),e.e+1,this.rounding)}function Ce(e){return(e=new this(e)).d?e.d[0]?e.s:0*e.s:e.s||NaN}function Te(e){return new this(e).sin()}function _e(e){return new this(e).sinh()}function qe(e){return new this(e).sqrt()}function Ie(e,t){return new this(e).sub(t)}function ke(e){return new this(e).tan()}function Be(e){return new this(e).tanh()}function ze(e){return D(e=new this(e),e.e+1,1)}(l=function e(t){var r,n,i;function a(e){var t,r,n,i=this;if(!(i instanceof a))return new a(e);if(e instanceof(i.constructor=a))return i.s=e.s,void(b?!e.d||e.e>a.maxE?(i.e=NaN,i.d=null):e.e<a.minE?(i.e=0,i.d=[0]):(i.e=e.e,i.d=e.d.slice()):(i.e=e.e,i.d=e.d?e.d.slice():e.d));if("number"==(n=typeof e)){if(0===e)return i.s=1/e<0?-1:1,i.e=0,void(i.d=[0]);if(e<0?(e=-e,i.s=-1):i.s=1,e===~~e&&e<1e7){for(t=0,r=e;10<=r;r/=10)t++;return void(b?a.maxE<t?(i.e=NaN,i.d=null):t<a.minE?(i.e=0,i.d=[0]):(i.e=t,i.d=[e]):(i.e=t,i.d=[e]))}return 0*e!=0?(e||(i.s=NaN),i.e=NaN,void(i.d=null)):J(i,e.toString())}if("string"!=n)throw Error(g+e);return 45===(r=e.charCodeAt(0))?(e=e.slice(1),i.s=-1):(43===r&&(e=e.slice(1)),i.s=1),(x.test(e)?J:function(e,t){var r,n,i,a,o,s,u,c,f;if("Infinity"===t||"NaN"===t)return+t||(e.s=NaN),e.e=NaN,e.d=null,e;if(m.test(t))r=16,t=t.toLowerCase();else if(p.test(t))r=2;else{if(!h.test(t))throw Error(g+t);r=8}for(o=0<=(a=(t=0<(a=t.search(/p/i))?(u=+t.slice(a+1),t.substring(2,a)):t.slice(2)).indexOf(".")),n=e.constructor,o&&(a=(s=(t=t.replace(".","")).length)-a,i=H(n,new n(r),a,2*a)),a=f=(c=S(t,r,q)).length-1;0===c[a];--a)c.pop();return a<0?new n(0*e.s):(e.e=R(c,f),e.d=c,b=!1,o&&(e=A(e,i,4*s)),u&&(e=e.times(Math.abs(u)<54?v(2,u):l.pow(2,u))),b=!0,e)})(i,e)}if(a.prototype=O,a.ROUND_UP=0,a.ROUND_DOWN=1,a.ROUND_CEIL=2,a.ROUND_FLOOR=3,a.ROUND_HALF_UP=4,a.ROUND_HALF_DOWN=5,a.ROUND_HALF_EVEN=6,a.ROUND_HALF_CEIL=7,a.ROUND_HALF_FLOOR=8,a.EUCLID=9,a.config=a.set=fe,a.clone=e,a.isDecimal=ge,a.abs=K,a.acos=ee,a.acosh=te,a.add=re,a.asin=ne,a.asinh=ie,a.atan=ae,a.atanh=oe,a.atan2=se,a.cbrt=ue,a.ceil=ce,a.cos=le,a.cosh=pe,a.div=me,a.exp=he,a.floor=de,a.hypot=ye,a.ln=ve,a.log=be,a.log10=we,a.log2=xe,a.max=Ne,a.min=Oe,a.mod=Me,a.mul=je,a.pow=Ee,a.random=Se,a.round=Ae,a.sign=Ce,a.sin=Te,a.sinh=_e,a.sqrt=qe,a.sub=Ie,a.tan=ke,a.tanh=Be,a.trunc=ze,void 0===t&&(t={}),t&&!0!==t.defaults)for(i=["precision","rounding","toExpNeg","toExpPos","maxE","minE","modulo","crypto"],r=0;r<i.length;)t.hasOwnProperty(n=i[r++])||(t[n]=this[n]);return a.config(t),a}(u)).default=l.Decimal=l,n=new l(n),i=new l(i),void 0===(Pe=function(){return l}.call(De,Re,De,t))||(t.exports=Pe)}()},function(e,t,r){"use strict";function f(e,t){return l({},e,t)}var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},p={"{":"\\{","}":"\\}","\\":"\\textbackslash{}","#":"\\#",$:"\\$","%":"\\%","&":"\\&","^":"\\textasciicircum{}",_:"\\_","~":"\\textasciitilde{}"},m={"–":"\\--","—":"\\---"," ":"~","\t":"\\qquad{}","\r\n":"\\newline{}","\n":"\\newline{}"};e.exports=function(e){for(var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},r=t.preserveFormatting,n=void 0!==r&&r,i=t.escapeMapFn,a=void 0===i?f:i,o=String(e),s="",u=a(l({},p),n?l({},m):{}),c=Object.keys(u);o;)!function(){var r=!1;c.forEach(function(e,t){r||o.length>=e.length&&o.slice(0,e.length)===e&&(s+=u[c[t]],o=o.slice(e.length,o.length),r=!0)}),r||(s+=o.slice(0,1),o=o.slice(1,o.length))}();return s}},function(e,t){function r(){}r.prototype={on:function(e,t,r){var n=this.e||(this.e={});return(n[e]||(n[e]=[])).push({fn:t,ctx:r}),this},once:function(e,t,r){var n=this;function i(){n.off(e,i),t.apply(r,arguments)}return i._=t,this.on(e,i,r)},emit:function(e){for(var t=[].slice.call(arguments,1),r=((this.e||(this.e={}))[e]||[]).slice(),n=0,i=r.length;n<i;n++)r[n].fn.apply(r[n].ctx,t);return this},off:function(e,t){var r=this.e||(this.e={}),n=r[e],i=[];if(n&&t)for(var a=0,o=n.length;a<o;a++)n[a].fn!==t&&n[a].fn._!==t&&i.push(n[a]);return i.length?r[e]=i:delete r[e],this}},e.exports=r,e.exports.TinyEmitter=r},function(e,t,r){var n=r(20),i=(0,r(21).create)(n);e.exports=i},function(e,t){var r=function(){return this}();try{r=r||new Function("return this")()}catch(e){"object"==typeof window&&(r=window)}e.exports=r},function(e,t,r){"use strict";r.r(t),r.d(t,"createTyped",function(){return u}),r.d(t,"createResultSet",function(){return m}),r.d(t,"createBigNumberClass",function(){return g}),r.d(t,"createComplexClass",function(){return N}),r.d(t,"createFractionClass",function(){return S}),r.d(t,"createRangeClass",function(){return C}),r.d(t,"createMatrixClass",function(){return _}),r.d(t,"createDenseMatrixClass",function(){return k}),r.d(t,"createClone",function(){return D}),r.d(t,"createIsInteger",function(){return Z}),r.d(t,"createIsNegative",function(){return te}),r.d(t,"createIsNumeric",function(){return se}),r.d(t,"createHasNumericValue",function(){return fe}),r.d(t,"createIsPositive",function(){return me}),r.d(t,"createIsZero",function(){return de}),r.d(t,"createIsNaN",function(){return ge}),r.d(t,"createTypeOf",function(){return be}),r.d(t,"createEqualScalar",function(){return Oe}),r.d(t,"createSparseMatrixClass",function(){return je}),r.d(t,"createNumber",function(){return Se}),r.d(t,"createString",function(){return Ce}),r.d(t,"createBoolean",function(){return qe}),r.d(t,"createBignumber",function(){return ke}),r.d(t,"createComplex",function(){return ze}),r.d(t,"createFraction",function(){return Re}),r.d(t,"createMatrix",function(){return Ue}),r.d(t,"createSplitUnit",function(){return He}),r.d(t,"createUnaryMinus",function(){return yt}),r.d(t,"createUnaryPlus",function(){return bt}),r.d(t,"createAbs",function(){return wt}),r.d(t,"createApply",function(){return Ot}),r.d(t,"createAddScalar",function(){return St}),r.d(t,"createCbrt",function(){return Ct}),r.d(t,"createCeil",function(){return _t}),r.d(t,"createCube",function(){return It}),r.d(t,"createExp",function(){return Bt}),r.d(t,"createExpm1",function(){return Dt}),r.d(t,"createFix",function(){return Pt}),r.d(t,"createFloor",function(){return Ft}),r.d(t,"createGcd",function(){return Kt}),r.d(t,"createLcm",function(){return sr}),r.d(t,"createLog10",function(){return cr}),r.d(t,"createLog2",function(){return lr}),r.d(t,"createMod",function(){return br}),r.d(t,"createMultiplyScalar",function(){return wr}),r.d(t,"createMultiply",function(){return Mr}),r.d(t,"createNthRoot",function(){return Sr}),r.d(t,"createSign",function(){return Cr}),r.d(t,"createSqrt",function(){return _r}),r.d(t,"createSquare",function(){return Ir}),r.d(t,"createSubtract",function(){return zr}),r.d(t,"createXgcd",function(){return Pr}),r.d(t,"createDotMultiply",function(){return $r}),r.d(t,"createBitAnd",function(){return cn}),r.d(t,"createBitNot",function(){return ln}),r.d(t,"createBitOr",function(){return mn}),r.d(t,"createBitXor",function(){return gn}),r.d(t,"createArg",function(){return bn}),r.d(t,"createConj",function(){return wn}),r.d(t,"createIm",function(){return On}),r.d(t,"createRe",function(){return jn}),r.d(t,"createNot",function(){return qn}),r.d(t,"createOr",function(){return kn}),r.d(t,"createXor",function(){return zn}),r.d(t,"createConcat",function(){return Rn}),r.d(t,"createColumn",function(){return Un}),r.d(t,"createCross",function(){return Ln}),r.d(t,"createDiag",function(){return $n}),r.d(t,"createFilter",function(){return Wn}),r.d(t,"createFlatten",function(){return Kn}),r.d(t,"createForEach",function(){return ri}),r.d(t,"createGetMatrixDataType",function(){return oi}),r.d(t,"createIdentity",function(){return ci}),r.d(t,"createKron",function(){return li}),r.d(t,"createMap",function(){return mi}),r.d(t,"createOnes",function(){return yi}),r.d(t,"createRange",function(){return wi}),r.d(t,"createReshape",function(){return Mi}),r.d(t,"createResize",function(){return Si}),r.d(t,"createRow",function(){return Ci}),r.d(t,"createSize",function(){return _i}),r.d(t,"createSqueeze",function(){return ki}),r.d(t,"createSubset",function(){return $i}),r.d(t,"createTranspose",function(){return Yi}),r.d(t,"createCtranspose",function(){return Ki}),r.d(t,"createZeros",function(){return ta}),r.d(t,"createErf",function(){return na}),r.d(t,"createMode",function(){return fa}),r.d(t,"createProd",function(){return ma}),r.d(t,"createFormat",function(){return da}),r.d(t,"createPrint",function(){return ga}),r.d(t,"createTo",function(){return xa}),r.d(t,"createIsPrime",function(){return Oa}),r.d(t,"createNumeric",function(){return ja}),r.d(t,"createDivideScalar",function(){return Aa}),r.d(t,"createPow",function(){return Ta}),r.d(t,"createRound",function(){return za}),r.d(t,"createLog",function(){return Pa}),r.d(t,"createLog1p",function(){return Fa}),r.d(t,"createNthRoots",function(){return $a}),r.d(t,"createDotPow",function(){return Za}),r.d(t,"createDotDivide",function(){return Wa}),r.d(t,"createLsolve",function(){return Qa}),r.d(t,"createUsolve",function(){return eo}),r.d(t,"createLeftShift",function(){return ao}),r.d(t,"createRightArithShift",function(){return uo}),r.d(t,"createRightLogShift",function(){return lo}),r.d(t,"createAnd",function(){return mo}),r.d(t,"createCompare",function(){return go}),r.d(t,"createCompareNatural",function(){return No}),r.d(t,"createCompareText",function(){return jo}),r.d(t,"createEqual",function(){return Ao}),r.d(t,"createEqualText",function(){return _o}),r.d(t,"createSmaller",function(){return ko}),r.d(t,"createSmallerEq",function(){return Do}),r.d(t,"createLarger",function(){return Uo}),r.d(t,"createLargerEq",function(){return Ho}),r.d(t,"createDeepEqual",function(){return Zo}),r.d(t,"createUnequal",function(){return Wo}),r.d(t,"createPartitionSelect",function(){return Qo}),r.d(t,"createSort",function(){return es}),r.d(t,"createMax",function(){return rs}),r.d(t,"createMin",function(){return is}),r.d(t,"createImmutableDenseMatrixClass",function(){return os}),r.d(t,"createIndexClass",function(){return us}),r.d(t,"createFibonacciHeapClass",function(){return fs}),r.d(t,"createSpaClass",function(){return ps}),r.d(t,"createUnitClass",function(){return Os}),r.d(t,"createUnitFunction",function(){return js}),r.d(t,"createSparse",function(){return Ss}),r.d(t,"createCreateUnit",function(){return Ts}),r.d(t,"createAcos",function(){return qs}),r.d(t,"createAcosh",function(){return Xs}),r.d(t,"createAcot",function(){return Ks}),r.d(t,"createAcoth",function(){return tu}),r.d(t,"createAcsc",function(){return nu}),r.d(t,"createAcsch",function(){return au}),r.d(t,"createAsec",function(){return su}),r.d(t,"createAsech",function(){return cu}),r.d(t,"createAsin",function(){return lu}),r.d(t,"createAsinh",function(){return mu}),r.d(t,"createAtan",function(){return du}),r.d(t,"createAtan2",function(){return gu}),r.d(t,"createAtanh",function(){return bu}),r.d(t,"createCos",function(){return wu}),r.d(t,"createCosh",function(){return Ou}),r.d(t,"createCot",function(){return ju}),r.d(t,"createCoth",function(){return Su}),r.d(t,"createCsc",function(){return Cu}),r.d(t,"createCsch",function(){return _u}),r.d(t,"createSec",function(){return Iu}),r.d(t,"createSech",function(){return Bu}),r.d(t,"createSin",function(){return Du}),r.d(t,"createSinh",function(){return Pu}),r.d(t,"createTan",function(){return Fu}),r.d(t,"createTanh",function(){return Hu}),r.d(t,"createSetCartesian",function(){return Zu}),r.d(t,"createSetDifference",function(){return Wu}),r.d(t,"createSetDistinct",function(){return Qu}),r.d(t,"createSetIntersect",function(){return tc}),r.d(t,"createSetIsSubset",function(){return ic}),r.d(t,"createSetMultiplicity",function(){return sc}),r.d(t,"createSetPowerset",function(){return fc}),r.d(t,"createSetSize",function(){return mc}),r.d(t,"createSetSymDifference",function(){return yc}),r.d(t,"createSetUnion",function(){return bc}),r.d(t,"createAdd",function(){return wc}),r.d(t,"createHypot",function(){return Oc}),r.d(t,"createNorm",function(){return jc}),r.d(t,"createDot",function(){return Sc}),r.d(t,"createTrace",function(){return Cc}),r.d(t,"createIndex",function(){return _c}),r.d(t,"createNode",function(){return Bc}),r.d(t,"createAccessorNode",function(){return Uc}),r.d(t,"createArrayNode",function(){return Lc}),r.d(t,"createAssignmentNode",function(){return Wc}),r.d(t,"createBlockNode",function(){return Xc}),r.d(t,"createConditionalNode",function(){return Kc}),r.d(t,"createConstantNode",function(){return ff}),r.d(t,"createFunctionAssignmentNode",function(){return pf}),r.d(t,"createIndexNode",function(){return yf}),r.d(t,"createObjectNode",function(){return bf}),r.d(t,"createOperatorNode",function(){return wf}),r.d(t,"createParenthesisNode",function(){return Of}),r.d(t,"createRangeNode",function(){return jf}),r.d(t,"createRelationalNode",function(){return Sf}),r.d(t,"createSymbolNode",function(){return Cf}),r.d(t,"createFunctionNode",function(){return If}),r.d(t,"createParse",function(){return zf}),r.d(t,"createCompile",function(){return Pf}),r.d(t,"createEvaluate",function(){return Lf}),r.d(t,"createParserClass",function(){return $f}),r.d(t,"createParser",function(){return Zf}),r.d(t,"createLup",function(){return Jf}),r.d(t,"createQr",function(){return Xf}),r.d(t,"createSlu",function(){return ml}),r.d(t,"createLusolve",function(){return gl}),r.d(t,"createHelpClass",function(){return bl}),r.d(t,"createChainClass",function(){return wl}),r.d(t,"createHelp",function(){return El}),r.d(t,"createChain",function(){return Al}),r.d(t,"createDet",function(){return Tl}),r.d(t,"createInv",function(){return ql}),r.d(t,"createEigs",function(){return kl}),r.d(t,"createExpm",function(){return zl}),r.d(t,"createSqrtm",function(){return Rl}),r.d(t,"createDivide",function(){return Ul}),r.d(t,"createDistance",function(){return Hl}),r.d(t,"createIntersect",function(){return Gl}),r.d(t,"createSum",function(){return Vl}),r.d(t,"createMean",function(){return Wl}),r.d(t,"createMedian",function(){return Xl}),r.d(t,"createMad",function(){return Kl}),r.d(t,"createVariance",function(){return np}),r.d(t,"createQuantileSeq",function(){return ap}),r.d(t,"createStd",function(){return sp}),r.d(t,"createCombinations",function(){return pp}),r.d(t,"createCombinationsWithRep",function(){return yp}),r.d(t,"createGamma",function(){return Np}),r.d(t,"createFactorial",function(){return jp}),r.d(t,"createKldivergence",function(){return Ap}),r.d(t,"createMultinomial",function(){return _p}),r.d(t,"createPermutations",function(){return kp}),r.d(t,"createPickRandom",function(){return Fp}),r.d(t,"createRandom",function(){return Gp}),r.d(t,"createRandomInt",function(){return Jp}),r.d(t,"createStirlingS2",function(){return Xp}),r.d(t,"createBellNumbers",function(){return em}),r.d(t,"createCatalan",function(){return nm}),r.d(t,"createComposition",function(){return om}),r.d(t,"createSimplify",function(){return gm}),r.d(t,"createDerivative",function(){return bm}),r.d(t,"createRationalize",function(){return Nm}),r.d(t,"createReviver",function(){return Mm}),r.d(t,"createReplacer",function(){return Em}),r.d(t,"createE",function(){return Dm}),r.d(t,"createUppercaseE",function(){return Vm}),r.d(t,"createFalse",function(){return _m}),r.d(t,"createI",function(){return Gm}),r.d(t,"createInfinity",function(){return Im}),r.d(t,"createLN10",function(){return Um}),r.d(t,"createLN2",function(){return Pm}),r.d(t,"createLOG10E",function(){return Lm}),r.d(t,"createLOG2E",function(){return Fm}),r.d(t,"createNaN",function(){return km}),r.d(t,"createNull",function(){return qm}),r.d(t,"createPhi",function(){return Rm}),r.d(t,"createPi",function(){return Bm}),r.d(t,"createUppercasePi",function(){return Zm}),r.d(t,"createSQRT1_2",function(){return Hm}),r.d(t,"createSQRT2",function(){return $m}),r.d(t,"createTau",function(){return zm}),r.d(t,"createTrue",function(){return Tm}),r.d(t,"createVersion",function(){return Jm}),r.d(t,"createAtomicMass",function(){return jh}),r.d(t,"createAvogadro",function(){return Eh}),r.d(t,"createBohrMagneton",function(){return ah}),r.d(t,"createBohrRadius",function(){return lh}),r.d(t,"createBoltzmann",function(){return Sh}),r.d(t,"createClassicalElectronRadius",function(){return ph}),r.d(t,"createConductanceQuantum",function(){return oh}),r.d(t,"createCoulomb",function(){return nh}),r.d(t,"createDeuteronMass",function(){return vh}),r.d(t,"createEfimovFactor",function(){return Mh}),r.d(t,"createElectricConstant",function(){return th}),r.d(t,"createElectronMass",function(){return mh}),r.d(t,"createElementaryCharge",function(){return ih}),r.d(t,"createFaraday",function(){return Ah}),r.d(t,"createFermiCoupling",function(){return hh}),r.d(t,"createFineStructure",function(){return dh}),r.d(t,"createFirstRadiation",function(){return Ch}),r.d(t,"createGasConstant",function(){return _h}),r.d(t,"createGravitationConstant",function(){return Xm}),r.d(t,"createGravity",function(){return Uh}),r.d(t,"createHartreeEnergy",function(){return yh}),r.d(t,"createInverseConductanceQuantum",function(){return sh}),r.d(t,"createKlitzing",function(){return fh}),r.d(t,"createLoschmidt",function(){return Th}),r.d(t,"createMagneticConstant",function(){return eh}),r.d(t,"createMagneticFluxQuantum",function(){return uh}),r.d(t,"createMolarMass",function(){return Rh}),r.d(t,"createMolarMassC12",function(){return Ph}),r.d(t,"createMolarPlanckConstant",function(){return qh}),r.d(t,"createMolarVolume",function(){return Ih}),r.d(t,"createNeutronMass",function(){return bh}),r.d(t,"createNuclearMagneton",function(){return ch}),r.d(t,"createPlanckCharge",function(){return $h}),r.d(t,"createPlanckConstant",function(){return Qm}),r.d(t,"createPlanckLength",function(){return Fh}),r.d(t,"createPlanckMass",function(){return Lh}),r.d(t,"createPlanckTemperature",function(){return Gh}),r.d(t,"createPlanckTime",function(){return Hh}),r.d(t,"createProtonMass",function(){return gh}),r.d(t,"createQuantumOfCirculation",function(){return xh}),r.d(t,"createReducedPlanckConstant",function(){return Km}),r.d(t,"createRydberg",function(){return wh}),r.d(t,"createSackurTetrode",function(){return kh}),r.d(t,"createSecondRadiation",function(){return Bh}),r.d(t,"createSpeedOfLight",function(){return Ym}),r.d(t,"createStefanBoltzmann",function(){return zh}),r.d(t,"createThomsonCrossSection",function(){return Nh}),r.d(t,"createVacuumImpedance",function(){return rh}),r.d(t,"createWeakMixingAngle",function(){return Oh}),r.d(t,"createWienDisplacement",function(){return Dh}),r.d(t,"createApplyTransform",function(){return Wh}),r.d(t,"createColumnTransform",function(){return Xh}),r.d(t,"createFilterTransform",function(){return ed}),r.d(t,"createForEachTransform",function(){return nd}),r.d(t,"createIndexTransform",function(){return ad}),r.d(t,"createMapTransform",function(){return sd}),r.d(t,"createMaxTransform",function(){return fd}),r.d(t,"createMeanTransform",function(){return pd}),r.d(t,"createMinTransform",function(){return hd}),r.d(t,"createRangeTransform",function(){return yd}),r.d(t,"createRowTransform",function(){return vd}),r.d(t,"createSubsetTransform",function(){return xd}),r.d(t,"createConcatTransform",function(){return Nd}),r.d(t,"createStdTransform",function(){return Md}),r.d(t,"createSumTransform",function(){return Ed}),r.d(t,"createVarianceTransform",function(){return Cd});var ie=r(1),n=r(13),i=r.n(n),E=r(4),s=r(0),o=function(){return o=i.a.create,i.a},a=["?BigNumber","?Complex","?DenseMatrix","?Fraction"],u=Object(s.a)("typed",a,function(e){var r=e.BigNumber,n=e.Complex,t=e.DenseMatrix,i=e.Fraction,a=o();return a.types=[{name:"number",test:ie.y},{name:"Complex",test:ie.j},{name:"BigNumber",test:ie.e},{name:"Fraction",test:ie.o},{name:"Unit",test:ie.L},{name:"string",test:ie.I},{name:"Chain",test:ie.h},{name:"Array",test:ie.b},{name:"Matrix",test:ie.v},{name:"DenseMatrix",test:ie.n},{name:"SparseMatrix",test:ie.H},{name:"Range",test:ie.D},{name:"Index",test:ie.t},{name:"boolean",test:ie.g},{name:"ResultSet",test:ie.G},{name:"Help",test:ie.s},{name:"function",test:ie.p},{name:"Date",test:ie.m},{name:"RegExp",test:ie.F},{name:"null",test:ie.x},{name:"undefined",test:ie.K},{name:"AccessorNode",test:ie.a},{name:"ArrayNode",test:ie.c},{name:"AssignmentNode",test:ie.d},{name:"BlockNode",test:ie.f},{name:"ConditionalNode",test:ie.k},{name:"ConstantNode",test:ie.l},{name:"FunctionNode",test:ie.r},{name:"FunctionAssignmentNode",test:ie.q},{name:"IndexNode",test:ie.u},{name:"Node",test:ie.w},{name:"ObjectNode",test:ie.A},{name:"OperatorNode",test:ie.B},{name:"ParenthesisNode",test:ie.C},{name:"RangeNode",test:ie.E},{name:"SymbolNode",test:ie.J},{name:"Object",test:ie.z}],a.conversions=[{from:"number",to:"BigNumber",convert:function(e){if(r||c(e),15<Object(E.f)(e))throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: "+e+"). Use function bignumber(x) to convert to BigNumber.");return new r(e)}},{from:"number",to:"Complex",convert:function(e){return n||f(e),new n(e,0)}},{from:"number",to:"string",convert:function(e){return e+""}},{from:"BigNumber",to:"Complex",convert:function(e){return n||f(e),new n(e.toNumber(),0)}},{from:"Fraction",to:"BigNumber",convert:function(){throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.")}},{from:"Fraction",to:"Complex",convert:function(e){return n||f(e),new n(e.valueOf(),0)}},{from:"number",to:"Fraction",convert:function(e){i||l(e);var t=new i(e);if(t.valueOf()!==e)throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: "+e+"). Use function fraction(x) to convert to Fraction.");return t}},{from:"string",to:"number",convert:function(e){var t=Number(e);if(isNaN(t))throw new Error('Cannot convert "'+e+'" to a number');return t}},{from:"string",to:"BigNumber",convert:function(t){r||c(t);try{return new r(t)}catch(e){throw new Error('Cannot convert "'+t+'" to BigNumber')}}},{from:"string",to:"Fraction",convert:function(t){i||l(t);try{return new i(t)}catch(e){throw new Error('Cannot convert "'+t+'" to Fraction')}}},{from:"string",to:"Complex",convert:function(t){n||f(t);try{return new n(t)}catch(e){throw new Error('Cannot convert "'+t+'" to Complex')}}},{from:"boolean",to:"number",convert:function(e){return+e}},{from:"boolean",to:"BigNumber",convert:function(e){return r||c(e),new r(+e)}},{from:"boolean",to:"Fraction",convert:function(e){return i||l(e),new i(+e)}},{from:"boolean",to:"string",convert:function(e){return String(e)}},{from:"Array",to:"Matrix",convert:function(e){return t||function(){throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided")}(),new t(e)}},{from:"Matrix",to:"Array",convert:function(e){return e.valueOf()}}],a});function c(e){throw new Error("Cannot convert value ".concat(e," into a BigNumber: no class 'BigNumber' provided"))}function f(e){throw new Error("Cannot convert value ".concat(e," into a Complex number: no class 'Complex' provided"))}function l(e){throw new Error("Cannot convert value ".concat(e," into a Fraction, no class 'Fraction' provided."))}var p=[],m=Object(s.a)("ResultSet",p,function(){function t(e){if(!(this instanceof t))throw new SyntaxError("Constructor must be called with the new operator");this.entries=e||[]}return t.prototype.type="ResultSet",t.prototype.isResultSet=!0,t.prototype.valueOf=function(){return this.entries},t.prototype.toString=function(){return"["+this.entries.join(", ")+"]"},t.prototype.toJSON=function(){return{mathjs:"ResultSet",entries:this.entries}},t.fromJSON=function(e){return new t(e.entries)},t},{isClass:!0}),h=r(15),d=r.n(h),y=["?on","config"],g=Object(s.a)("BigNumber",y,function(e){var t=e.on,r=e.config,n=d.a.clone({precision:r.precision});return n.prototype.type="BigNumber",n.prototype.isBigNumber=!0,n.prototype.toJSON=function(){return{mathjs:"BigNumber",value:this.toString()}},n.fromJSON=function(e){return new n(e.value)},t&&t("config",function(e,t){e.precision!==t.precision&&n.config({precision:e.precision})}),n},{isClass:!0}),v=r(8),b=r.n(v);function x(e){return(x="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var w=[],N=Object(s.a)("Complex",w,function(){return b.a.prototype.type="Complex",b.a.prototype.isComplex=!0,b.a.prototype.toJSON=function(){return{mathjs:"Complex",re:this.re,im:this.im}},b.a.prototype.toPolar=function(){return{r:this.abs(),phi:this.arg()}},b.a.prototype.format=function(e){var t,r=this.im,n=this.re,i=Object(E.h)(this.re,e),a=Object(E.h)(this.im,e),o=Object(ie.y)(e)?e:e?e.precision:null;return null!==o&&(t=Math.pow(10,-o),Math.abs(n/r)<t&&(n=0),Math.abs(r/n)<t&&(r=0)),0===r?i:0===n?1===r?"i":-1===r?"-i":a+"i":r<0?-1===r?i+" - i":i+" - "+a.substring(1)+"i":1===r?i+" + i":i+" + "+a+"i"},b.a.fromPolar=function(e){switch(arguments.length){case 1:var t=e;if("object"===x(t))return b()(t);throw new TypeError("Input has to be an object with r and phi keys.");case 2:var r=e,n=arguments[1];if(Object(ie.y)(r)){if(Object(ie.L)(n)&&n.hasBase("ANGLE")&&(n=n.toNumber("rad")),Object(ie.y)(n))return new b.a({r:r,phi:n});throw new TypeError("Phi is not a number nor an angle unit.")}throw new TypeError("Radius r is not a number.");default:throw new SyntaxError("Wrong number of arguments in function fromPolar")}},b.a.prototype.valueOf=b.a.prototype.toString,b.a.fromJSON=function(e){return new b.a(e)},b.a.compare=function(e,t){return e.re>t.re?1:e.re<t.re?-1:e.im>t.im?1:e.im<t.im?-1:0},b.a},{isClass:!0}),O=r(10),M=r.n(O),j=[],S=Object(s.a)("Fraction",j,function(){return M.a.prototype.type="Fraction",M.a.prototype.isFraction=!0,M.a.prototype.toJSON=function(){return{mathjs:"Fraction",n:this.s*this.n,d:this.d}},M.a.fromJSON=function(e){return new M.a(e)},M.a},{isClass:!0}),A=[],C=Object(s.a)("Range",A,function(){function o(e,t,r){if(!(this instanceof o))throw new SyntaxError("Constructor must be called with the new operator");var n=null!=e,i=null!=t,a=null!=r;if(n)if(Object(ie.e)(e))e=e.toNumber();else if("number"!=typeof e)throw new TypeError("Parameter start must be a number");if(i)if(Object(ie.e)(t))t=t.toNumber();else if("number"!=typeof t)throw new TypeError("Parameter end must be a number");if(a)if(Object(ie.e)(r))r=r.toNumber();else if("number"!=typeof r)throw new TypeError("Parameter step must be a number");this.start=n?parseFloat(e):0,this.end=i?parseFloat(t):0,this.step=a?parseFloat(r):1}return o.prototype.type="Range",o.prototype.isRange=!0,o.parse=function(e){if("string"!=typeof e)return null;var t=e.split(":").map(function(e){return parseFloat(e)});if(t.some(function(e){return isNaN(e)}))return null;switch(t.length){case 2:return new o(t[0],t[1]);case 3:return new o(t[0],t[2],t[1]);default:return null}},o.prototype.clone=function(){return new o(this.start,this.end,this.step)},o.prototype.size=function(){var e=0,t=this.start,r=this.step,n=this.end-t;return Object(E.n)(r)===Object(E.n)(n)?e=Math.ceil(n/r):0==n&&(e=0),isNaN(e)&&(e=0),[e]},o.prototype.min=function(){var e=this.size()[0];return 0<e?0<this.step?this.start:this.start+(e-1)*this.step:void 0},o.prototype.max=function(){var e=this.size()[0];return 0<e?0<this.step?this.start+(e-1)*this.step:this.start:void 0},o.prototype.forEach=function(e){var t=this.start,r=this.step,n=this.end,i=0;if(0<r)for(;t<n;)e(t,[i],this),t+=r,i++;else if(r<0)for(;n<t;)e(t,[i],this),t+=r,i++},o.prototype.map=function(n){var i=[];return this.forEach(function(e,t,r){i[t[0]]=n(e,t,r)}),i},o.prototype.toArray=function(){var r=[];return this.forEach(function(e,t){r[t[0]]=e}),r},o.prototype.valueOf=function(){return this.toArray()},o.prototype.format=function(e){var t=Object(E.h)(this.start,e);return 1!==this.step&&(t+=":"+Object(E.h)(this.step,e)),t+=":"+Object(E.h)(this.end,e)},o.prototype.toString=function(){return this.format()},o.prototype.toJSON=function(){return{mathjs:"Range",start:this.start,end:this.end,step:this.step}},o.fromJSON=function(e){return new o(e.start,e.end,e.step)},o},{isClass:!0}),T=[],_=Object(s.a)("Matrix",T,function(){function e(){if(!(this instanceof e))throw new SyntaxError("Constructor must be called with the new operator")}return e.prototype.type="Matrix",e.prototype.isMatrix=!0,e.prototype.storage=function(){throw new Error("Cannot invoke storage on a Matrix interface")},e.prototype.datatype=function(){throw new Error("Cannot invoke datatype on a Matrix interface")},e.prototype.create=function(e,t){throw new Error("Cannot invoke create on a Matrix interface")},e.prototype.subset=function(e,t,r){throw new Error("Cannot invoke subset on a Matrix interface")},e.prototype.get=function(e){throw new Error("Cannot invoke get on a Matrix interface")},e.prototype.set=function(e,t,r){throw new Error("Cannot invoke set on a Matrix interface")},e.prototype.resize=function(e,t){throw new Error("Cannot invoke resize on a Matrix interface")},e.prototype.reshape=function(e,t){throw new Error("Cannot invoke reshape on a Matrix interface")},e.prototype.clone=function(){throw new Error("Cannot invoke clone on a Matrix interface")},e.prototype.size=function(){throw new Error("Cannot invoke size on a Matrix interface")},e.prototype.map=function(e,t){throw new Error("Cannot invoke map on a Matrix interface")},e.prototype.forEach=function(e){throw new Error("Cannot invoke forEach on a Matrix interface")},e.prototype.toArray=function(){throw new Error("Cannot invoke toArray on a Matrix interface")},e.prototype.valueOf=function(){throw new Error("Cannot invoke valueOf on a Matrix interface")},e.prototype.format=function(e){throw new Error("Cannot invoke format on a Matrix interface")},e.prototype.toString=function(){throw new Error("Cannot invoke toString on a Matrix interface")},e},{isClass:!0}),q=r(2),V=r(5),ae=r(3),z=r(6),I=["Matrix"],k=Object(s.a)("DenseMatrix",I,function(e){var t=e.Matrix;function m(e,t){if(!(this instanceof m))throw new SyntaxError("Constructor must be called with the new operator");if(t&&!Object(ie.I)(t))throw new Error("Invalid datatype: "+t);if(Object(ie.v)(e))"DenseMatrix"===e.type?(this._data=Object(ae.a)(e._data),this._size=Object(ae.a)(e._size)):(this._data=e.toArray(),this._size=e.size()),this._datatype=t||e._datatype;else if(e&&Object(ie.b)(e.data)&&Object(ie.b)(e.size))this._data=e.data,this._size=e.size,Object(q.p)(this._data,this._size),this._datatype=t||e.datatype;else if(Object(ie.b)(e))this._data=function e(t){for(var r=0,n=t.length;r<n;r++){var i=t[r];Object(ie.b)(i)?t[r]=e(i):i&&!0===i.isMatrix&&(t[r]=e(i.valueOf()))}return t}(e),this._size=Object(q.a)(this._data),Object(q.p)(this._data,this._size),this._datatype=t;else{if(e)throw new TypeError("Unsupported type of data ("+Object(ie.M)(e)+")");this._data=[],this._size=[0],this._datatype=t}}function s(e,t,r){if(0!==t.length)return e._size=t.slice(0),e._data=Object(q.m)(e._data,e._size,r),e;for(var n=e._data;Object(ie.b)(n);)n=n[0];return n}function l(e,t,r){for(var n=e._size.slice(0),i=!1;n.length<t.length;)n.push(0),i=!0;for(var a=0,o=t.length;a<o;a++)t[a]>n[a]&&(n[a]=t[a],i=!0);i&&s(e,n,r)}return(m.prototype=new t).createDenseMatrix=function(e,t){return new m(e,t)},m.prototype.type="DenseMatrix",m.prototype.isDenseMatrix=!0,m.prototype.getDataType=function(){return Object(q.h)(this._data,ie.M)},m.prototype.storage=function(){return"dense"},m.prototype.datatype=function(){return this._datatype},m.prototype.create=function(e,t){return new m(e,t)},m.prototype.subset=function(e,t,r){switch(arguments.length){case 1:return function(e,t){if(!Object(ie.t)(t))throw new TypeError("Invalid index");{if(t.isScalar())return e.get(t.min());var r=t.size();if(r.length!==e._size.length)throw new z.a(r.length,e._size.length);for(var n=t.min(),i=t.max(),a=0,o=e._size.length;a<o;a++)Object(q.q)(n[a],e._size[a]),Object(q.q)(i[a],e._size[a]);return new m(function r(n,i,a,o){var e=o===a-1;var t=i.dimension(o);return e?t.map(function(e){return Object(q.q)(e,n.length),n[e]}).valueOf():t.map(function(e){Object(q.q)(e,n.length);var t=n[e];return r(t,i,a,o+1)}).valueOf()}(e._data,t,r.length,0),e._datatype)}}(this,e);case 2:case 3:return function(e,t,r,n){if(!t||!0!==t.isIndex)throw new TypeError("Invalid index");var i,a=t.size(),o=t.isScalar();Object(ie.v)(r)?(i=r.size(),r=r.valueOf()):i=Object(q.a)(r);if(o){if(0!==i.length)throw new TypeError("Scalar expected");e.set(t.min(),r,n)}else{if(a.length<e._size.length)throw new z.a(a.length,e._size.length,"<");if(i.length<a.length){for(var s=0,u=0;1===a[s]&&1===i[s];)s++;for(;1===a[s];)u++,s++;r=Object(q.o)(r,a.length,u,i)}if(!Object(ae.d)(a,i))throw new z.a(a,i,">");var c=t.max().map(function(e){return e+1});l(e,c,n);var f=a.length;!function r(n,i,a,o,s){var e=s===o-1;var t=i.dimension(s);e?t.forEach(function(e,t){Object(q.q)(e),n[e]=a[t[0]]}):t.forEach(function(e,t){Object(q.q)(e),r(n[e],i,a[t[0]],o,s+1)})}(e._data,t,r,f,0)}return e}(this,e,t,r);default:throw new SyntaxError("Wrong number of arguments")}},m.prototype.get=function(e){if(!Object(ie.b)(e))throw new TypeError("Array expected");if(e.length!==this._size.length)throw new z.a(e.length,this._size.length);for(var t=0;t<e.length;t++)Object(q.q)(e[t],this._size[t]);for(var r=this._data,n=0,i=e.length;n<i;n++){var a=e[n];Object(q.q)(a,r.length),r=r[a]}return r},m.prototype.set=function(e,t,r){if(!Object(ie.b)(e))throw new TypeError("Array expected");if(e.length<this._size.length)throw new z.a(e.length,this._size.length,"<");var n;l(this,e.map(function(e){return e+1}),r);for(var i=this._data,a=0,o=e.length-1;a<o;a++)n=e[a],Object(q.q)(n,i.length),i=i[n];return n=e[e.length-1],Object(q.q)(n,i.length),i[n]=t,this},m.prototype.resize=function(e,t,r){if(!Object(ie.i)(e))throw new TypeError("Array or Matrix expected");var n=e.valueOf().map(function(e){return Array.isArray(e)&&1===e.length?e[0]:e});return s(r?this.clone():this,n,t)},m.prototype.reshape=function(e,t){var r=t?this.clone():this;return r._data=Object(q.l)(r._data,e),r._size=e.slice(0),r},m.prototype.clone=function(){return new m({data:Object(ae.a)(this._data),size:Object(ae.a)(this._size),datatype:this._datatype})},m.prototype.size=function(){return this._size.slice(0)},m.prototype.map=function(t){var i=this,e=function r(e,n){return Object(ie.b)(e)?e.map(function(e,t){return r(e,n.concat(t))}):t(e,n,i)}(this._data,[]);return new m(e,void 0!==this._datatype?Object(q.h)(e,ie.M):void 0)},m.prototype.forEach=function(t){var i=this;!function r(e,n){Object(ie.b)(e)?e.forEach(function(e,t){r(e,n.concat(t))}):t(e,n,i)}(this._data,[])},m.prototype.toArray=function(){return Object(ae.a)(this._data)},m.prototype.valueOf=function(){return this._data},m.prototype.format=function(e){return Object(V.d)(this._data,e)},m.prototype.toString=function(){return Object(V.d)(this._data)},m.prototype.toJSON=function(){return{mathjs:"DenseMatrix",data:this._data,size:this._size,datatype:this._datatype}},m.prototype.diagonal=function(e){if(e){if(Object(ie.e)(e)&&(e=e.toNumber()),!Object(ie.y)(e)||!Object(E.i)(e))throw new TypeError("The parameter k must be an integer number")}else e=0;for(var t=0<e?e:0,r=e<0?-e:0,n=this._size[0],i=this._size[1],a=Math.min(n-r,i-t),o=[],s=0;s<a;s++)o[s]=this._data[s+r][s+t];return new m({data:o,size:[a],datatype:this._datatype})},m.diagonal=function(e,t,r,n){if(!Object(ie.b)(e))throw new TypeError("Array expected, size parameter");if(2!==e.length)throw new Error("Only two dimensions matrix are supported");if(e=e.map(function(e){if(Object(ie.e)(e)&&(e=e.toNumber()),!Object(ie.y)(e)||!Object(E.i)(e)||e<1)throw new Error("Size values must be positive integers");return e}),r){if(Object(ie.e)(r)&&(r=r.toNumber()),!Object(ie.y)(r)||!Object(E.i)(r))throw new TypeError("The parameter k must be an integer number")}else r=0;var i,a=0<r?r:0,o=r<0?-r:0,s=e[0],u=e[1],c=Math.min(s-o,u-a);if(Object(ie.b)(t)){if(t.length!==c)throw new Error("Invalid value array length");i=function(e){return t[e]}}else if(Object(ie.v)(t)){var f=t.size();if(1!==f.length||f[0]!==c)throw new Error("Invalid matrix length");i=function(e){return t.get([e])}}else i=function(){return t};n=n||(Object(ie.e)(i(0))?i(0).mul(0):0);var l=[];if(0<e.length){l=Object(q.m)(l,e,n);for(var p=0;p<c;p++)l[p+o][p+a]=i(p)}return new m({data:l,size:[s,u]})},m.fromJSON=function(e){return new m(e)},m.prototype.swapRows=function(e,t){if(!(Object(ie.y)(e)&&Object(E.i)(e)&&Object(ie.y)(t)&&Object(E.i)(t)))throw new Error("Row index must be positive integers");if(2!==this._size.length)throw new Error("Only two dimensional matrix is supported");return Object(q.q)(e,this._size[0]),Object(q.q)(t,this._size[0]),m._swapRows(e,t,this._data),this},m._swapRows=function(e,t,r){var n=r[e];r[e]=r[t],r[t]=n},m},{isClass:!0}),B=["typed"],D=Object(s.a)("clone",B,function(e){return(0,e.typed)("clone",{any:ae.a})}),R=r(9);function P(e){for(var t=0;t<e.length;t++)if(Object(ie.i)(e[t]))return 1}function U(e,t){Object(ie.v)(e)&&(e=e.valueOf());for(var r=0,n=e.length;r<n;r++){var i=e[r];Array.isArray(i)?U(i,t):t(i)}}function oe(e,t,r){return e&&"function"==typeof e.map?e.map(function(e){return oe(e,t,r)}):t(e)}function F(e,t,r){var n=Array.isArray(e)?Object(q.a)(e):e.size();if(t<0||t>=n.length)throw new R.a(t,n.length);return Object(ie.v)(e)?e.create(L(e.valueOf(),t,r)):L(e,t,r)}function L(e,t,r){var n,i,a,o;if(t<=0){if(Array.isArray(e[0])){for(o=function(e){var t,r,n=e.length,i=e[0].length,a=[];for(r=0;r<i;r++){var o=[];for(t=0;t<n;t++)o.push(e[t][r]);a.push(o)}return a}(e),i=[],n=0;n<o.length;n++)i[n]=L(o[n],t-1,r);return i}for(a=e[0],n=1;n<e.length;n++)a=r(a,e[n]);return a}for(i=[],n=0;n<e.length;n++)i[n]=L(e[n],t-1,r);return i}function H(e,t,r,n,i,a,o,s,u,c,f){var l,p,m,h,d=e._values,y=e._index,g=e._ptr;if(n)for(p=g[t],m=g[t+1],l=p;l<m;l++)r[h=y[l]]!==a?(r[h]=a,o.push(h),c?(n[h]=u?s(d[l],f):s(f,d[l]),i[h]=a):n[h]=d[l]):(n[h]=u?s(d[l],n[h]):s(n[h],d[l]),i[h]=a);else for(p=g[t],m=g[t+1],l=p;l<m;l++)r[h=y[l]]!==a?(r[h]=a,o.push(h)):i[h]=a}var $="isInteger",G=["typed"],Z=Object(s.a)($,G,function(e){return(0,e.typed)($,{number:E.i,BigNumber:function(e){return e.isInt()},Fraction:function(e){return 1===e.d&&isFinite(e.n)},"Array | Matrix":function(e){return oe(e,this)}})}),J="number";function W(e){return e<0}function Y(e){return 0<e}function X(e){return 0===e}function Q(e){return Number.isNaN(e)}Q.signature=X.signature=Y.signature=W.signature=J;var K="isNegative",ee=["typed"],te=Object(s.a)(K,ee,function(e){return(0,e.typed)(K,{number:W,BigNumber:function(e){return e.isNeg()&&!e.isZero()&&!e.isNaN()},Fraction:function(e){return e.s<0},Unit:function(e){return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),re="isNumeric",ne=["typed"],se=Object(s.a)(re,ne,function(e){return(0,e.typed)(re,{"number | BigNumber | Fraction | boolean":function(){return!0},"Complex | Unit | string | null | undefined | Node":function(){return!1},"Array | Matrix":function(e){return oe(e,this)}})}),ue="hasNumericValue",ce=["typed","isNumeric"],fe=Object(s.a)(ue,ce,function(e){var t=e.typed,r=e.isNumeric;return t(ue,{string:function(e){return 0<e.trim().length&&!isNaN(Number(e))},any:function(e){return r(e)}})}),le="isPositive",pe=["typed"],me=Object(s.a)(le,pe,function(e){return(0,e.typed)(le,{number:Y,BigNumber:function(e){return!e.isNeg()&&!e.isZero()&&!e.isNaN()},Fraction:function(e){return 0<e.s&&0<e.n},Unit:function(e){return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),he=["typed"],de=Object(s.a)("isZero",he,function(e){return(0,e.typed)("isZero",{number:X,BigNumber:function(e){return e.isZero()},Complex:function(e){return 0===e.re&&0===e.im},Fraction:function(e){return 1===e.d&&0===e.n},Unit:function(e){return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),ye=["typed"],ge=Object(s.a)("isNaN",ye,function(e){return(0,e.typed)("isNaN",{number:Q,BigNumber:function(e){return e.isNaN()},Fraction:function(){return!1},Complex:function(e){return e.isNaN()},Unit:function(e){return Number.isNaN(e.value)},"Array | Matrix":function(e){return oe(e,Number.isNaN)}})}),ve=["typed"],be=Object(s.a)("typeOf",ve,function(e){return(0,e.typed)("typeOf",{any:ie.M})});function xe(e,t,r){if(null==r)return e.eq(t);if(e.eq(t))return!0;if(e.isNaN()||t.isNaN())return!1;if(e.isFinite()&&t.isFinite()){var n=e.minus(t).abs();if(n.isZero())return!0;var i=e.constructor.max(e.abs(),t.abs());return n.lte(i.times(r))}return!1}var we="equalScalar",Ne=["typed","config"],Oe=Object(s.a)(we,Ne,function(e){var t=e.typed,a=e.config;return t(we,{"boolean, boolean":function(e,t){return e===t},"number, number":function(e,t){return Object(E.m)(e,t,a.epsilon)},"BigNumber, BigNumber":function(e,t){return e.eq(t)||xe(e,t,a.epsilon)},"Fraction, Fraction":function(e,t){return e.equals(t)},"Complex, Complex":function(e,t){return r=e,n=t,i=a.epsilon,Object(E.m)(r.re,n.re,i)&&Object(E.m)(r.im,n.im,i);var r,n,i},"Unit, Unit":function(e,t){if(!e.equalBase(t))throw new Error("Cannot compare units with different base");return this(e.value,t.value)}})}),Me=(Object(s.a)(we,["typed","config"],function(e){var t=e.typed,r=e.config;return t(we,{"number, number":function(e,t){return Object(E.m)(e,t,r.epsilon)}})}),["typed","equalScalar","Matrix"]),je=Object(s.a)("SparseMatrix",Me,function(e){var O=e.typed,M=e.equalScalar,t=e.Matrix;function j(e,t){if(!(this instanceof j))throw new SyntaxError("Constructor must be called with the new operator");if(t&&!Object(ie.I)(t))throw new Error("Invalid datatype: "+t);if(Object(ie.v)(e))r=this,i=t,"SparseMatrix"===(n=e).type?(r._values=n._values?Object(ae.a)(n._values):void 0,r._index=Object(ae.a)(n._index),r._ptr=Object(ae.a)(n._ptr),r._size=Object(ae.a)(n._size),r._datatype=i||n._datatype):a(r,n.valueOf(),i||n._datatype);else if(e&&Object(ie.b)(e.index)&&Object(ie.b)(e.ptr)&&Object(ie.b)(e.size))this._values=e.values,this._index=e.index,this._ptr=e.ptr,this._size=e.size,this._datatype=t||e.datatype;else if(Object(ie.b)(e))a(this,e,t);else{if(e)throw new TypeError("Unsupported type of data ("+Object(ie.M)(e)+")");this._values=[],this._index=[],this._ptr=[0],this._size=[0,0],this._datatype=t}var r,n,i}function a(e,t,r){e._values=[],e._index=[],e._ptr=[],e._datatype=r;var n=t.length,i=0,a=M,o=0;if(Object(ie.I)(r)&&(a=O.find(M,[r,r])||M,o=O.convert(0,r)),0<n){var s=0;do{e._ptr.push(e._index.length);for(var u=0;u<n;u++){var c,f=t[u];Object(ie.b)(f)?(0===s&&i<f.length&&(i=f.length),s<f.length&&(a(c=f[s],o)||(e._values.push(c),e._index.push(u)))):(0===s&&i<1&&(i=1),a(f,o)||(e._values.push(f),e._index.push(u)))}s++}while(s<i)}e._ptr.push(e._index.length),e._size=[n,i]}function g(e,t,r,n){if(r-t==0)return r;for(var i=t;i<r;i++)if(n[i]===e)return i;return t}function v(e,t,r,n,i,a,o){i.splice(e,0,n),a.splice(e,0,t);for(var s=r+1;s<o.length;s++)o[s]++}function f(e,t,r,n){var i=n||0,a=M,o=0;Object(ie.I)(e._datatype)&&(a=O.find(M,[e._datatype,e._datatype])||M,o=O.convert(0,e._datatype),i=O.convert(i,e._datatype));var s=!a(i,o),u=e._size[0],c=e._size[1];if(c<r){for(l=c;l<r;l++)if(e._ptr[l]=e._values.length,s)for(m=0;m<u;m++)e._values.push(i),e._index.push(m);e._ptr[r]=e._values.length}else r<c&&(e._ptr.splice(r+1,c-r),e._values.splice(e._ptr[r],e._values.length),e._index.splice(e._ptr[r],e._index.length));if(c=r,u<t){if(s){for(var f=0,l=0;l<c;l++){e._ptr[l]=e._ptr[l]+f,g=e._ptr[l+1]+f;for(var p=0,m=u;m<t;m++,p++)e._values.splice(g+p,0,i),e._index.splice(g+p,0,m),f++}e._ptr[c]=e._values.length}}else if(t<u){var h=0;for(l=0;l<c;l++){e._ptr[l]=e._ptr[l]-h;for(var d=e._ptr[l],y=e._ptr[l+1]-h,g=d;g<y;g++)t-1<(m=e._index[g])&&(e._values.splice(g,1),e._index.splice(g,1),h++)}e._ptr[l]=e._values.length}return e._size[0]=t,e._size[1]=r,e}function r(e,t,r,n,i){for(var a,o=n[0],s=n[1],u=[],c=0;c<o;c++)for(u[c]=[],a=0;a<s;a++)u[c][a]=0;for(a=0;a<s;a++)for(var f=r[a],l=r[a+1],p=f;p<l;p++)u[c=t[p]][a]=e?i?Object(ae.a)(e[p]):e[p]:1;return u}return(j.prototype=new t).createSparseMatrix=function(e,t){return new j(e,t)},j.prototype.type="SparseMatrix",j.prototype.isSparseMatrix=!0,j.prototype.getDataType=function(){return Object(q.h)(this._values,ie.M)},j.prototype.storage=function(){return"sparse"},j.prototype.datatype=function(){return this._datatype},j.prototype.create=function(e,t){return new j(e,t)},j.prototype.density=function(){var e=this._size[0],t=this._size[1];return 0!==e&&0!==t?this._index.length/(e*t):0},j.prototype.subset=function(e,t,r){if(!this._values)throw new Error("Cannot invoke subset on a Pattern only matrix");switch(arguments.length){case 1:return function(e,t){if(!Object(ie.t)(t))throw new TypeError("Invalid index");if(t.isScalar())return e.get(t.min());var r,n,i,a,o=t.size();if(o.length!==e._size.length)throw new z.a(o.length,e._size.length);var s=t.min(),u=t.max();for(r=0,n=e._size.length;r<n;r++)Object(q.q)(s[r],e._size[r]),Object(q.q)(u[r],e._size[r]);var c=e._values,f=e._index,l=e._ptr,p=t.dimension(0),m=t.dimension(1),h=[],d=[];p.forEach(function(e,t){d[e]=t[0],h[e]=!0});var y=c?[]:void 0,g=[],v=[];return m.forEach(function(e){for(v.push(g.length),i=l[e],a=l[e+1];i<a;i++)r=f[i],!0===h[r]&&(g.push(d[r]),y&&y.push(c[i]))}),v.push(g.length),new j({values:y,index:g,ptr:v,size:o,datatype:e._datatype})}(this,e);case 2:case 3:return function(e,t,r,n){if(!t||!0!==t.isIndex)throw new TypeError("Invalid index");var i,a=t.size(),o=t.isScalar();Object(ie.v)(r)?(i=r.size(),r=r.toArray()):i=Object(q.a)(r);if(o){if(0!==i.length)throw new TypeError("Scalar expected");e.set(t.min(),r,n)}else{if(1!==a.length&&2!==a.length)throw new z.a(a.length,e._size.length,"<");if(i.length<a.length){for(var s=0,u=0;1===a[s]&&1===i[s];)s++;for(;1===a[s];)u++,s++;r=Object(q.o)(r,a.length,u,i)}if(!Object(ae.d)(a,i))throw new z.a(a,i,">");for(var c=t.min()[0],f=t.min()[1],l=i[0],p=i[1],m=0;m<l;m++)for(var h=0;h<p;h++){var d=r[m][h];e.set([m+c,h+f],d,n)}}return e}(this,e,t,r);default:throw new SyntaxError("Wrong number of arguments")}},j.prototype.get=function(e){if(!Object(ie.b)(e))throw new TypeError("Array expected");if(e.length!==this._size.length)throw new z.a(e.length,this._size.length);if(!this._values)throw new Error("Cannot invoke get on a Pattern only matrix");var t=e[0],r=e[1];Object(q.q)(t,this._size[0]),Object(q.q)(r,this._size[1]);var n=g(t,this._ptr[r],this._ptr[r+1],this._index);return n<this._ptr[r+1]&&this._index[n]===t?this._values[n]:0},j.prototype.set=function(e,t,r){if(!Object(ie.b)(e))throw new TypeError("Array expected");if(e.length!==this._size.length)throw new z.a(e.length,this._size.length);if(!this._values)throw new Error("Cannot invoke set on a Pattern only matrix");var n=e[0],i=e[1],a=this._size[0],o=this._size[1],s=M,u=0;Object(ie.I)(this._datatype)&&(s=O.find(M,[this._datatype,this._datatype])||M,u=O.convert(0,this._datatype)),(a-1<n||o-1<i)&&(f(this,Math.max(n+1,a),Math.max(i+1,o),r),a=this._size[0],o=this._size[1]),Object(q.q)(n,a),Object(q.q)(i,o);var c=g(n,this._ptr[i],this._ptr[i+1],this._index);return c<this._ptr[i+1]&&this._index[c]===n?s(t,u)?function(e,t,r,n,i){r.splice(e,1),n.splice(e,1);for(var a=t+1;a<i.length;a++)i[a]--}(c,i,this._values,this._index,this._ptr):this._values[c]=t:v(c,n,i,t,this._values,this._index,this._ptr),this},j.prototype.resize=function(e,t,r){if(!Object(ie.i)(e))throw new TypeError("Array or Matrix expected");var n=e.valueOf().map(function(e){return Array.isArray(e)&&1===e.length?e[0]:e});if(2!==n.length)throw new Error("Only two dimensions matrix are supported");return n.forEach(function(e){if(!Object(ie.y)(e)||!Object(E.i)(e)||e<0)throw new TypeError("Invalid size, must contain positive integers (size: "+Object(V.d)(n)+")")}),f(r?this.clone():this,n[0],n[1],t)},j.prototype.reshape=function(t,e){if(!Object(ie.b)(t))throw new TypeError("Array expected");if(2!==t.length)throw new Error("Sparse matrices can only be reshaped in two dimensions");if(t.forEach(function(e){if(!Object(ie.y)(e)||!Object(E.i)(e)||e<0)throw new TypeError("Invalid size, must contain positive integers (size: "+Object(V.d)(t)+")")}),this._size[0]*this._size[1]!=t[0]*t[1])throw new Error("Reshaping sparse matrix will result in the wrong number of elements");var r=e?this.clone():this;if(this._size[0]===t[0]&&this._size[1]===t[1])return r;for(var n=[],i=0;i<r._ptr.length;i++)for(var a=0;a<r._ptr[i+1]-r._ptr[i];a++)n.push(i);for(var o=r._values.slice(),s=r._index.slice(),u=0;u<r._index.length;u++){var c=s[u],f=n[u],l=c*r._size[1]+f;n[u]=l%t[1],s[u]=Math.floor(l/t[1])}r._values.length=0,r._index.length=0,r._ptr.length=t[1]+1,r._size=t.slice();for(var p=0;p<r._ptr.length;p++)r._ptr[p]=0;for(var m=0;m<o.length;m++){var h=s[m],d=n[m],y=o[m];v(g(h,r._ptr[d],r._ptr[d+1],r._index),h,d,y,r._values,r._index,r._ptr)}return r},j.prototype.clone=function(){return new j({values:this._values?Object(ae.a)(this._values):void 0,index:Object(ae.a)(this._index),ptr:Object(ae.a)(this._ptr),size:Object(ae.a)(this._size),datatype:this._datatype})},j.prototype.size=function(){return this._size.slice(0)},j.prototype.map=function(n,e){if(!this._values)throw new Error("Cannot invoke map on a Pattern only matrix");var i=this;return function(e,t,r,n,i,a,o){var s=[],u=[],c=[],f=M,l=0;Object(ie.I)(e._datatype)&&(f=O.find(M,[e._datatype,e._datatype])||M,l=O.convert(0,e._datatype));for(var p=function(e,t,r){e=a(e,t,r),f(e,l)||(s.push(e),u.push(t))},m=n;m<=i;m++){c.push(s.length);var h=e._ptr[m],d=e._ptr[m+1];if(o)for(var y=h;y<d;y++){var g=e._index[y];t<=g&&g<=r&&p(e._values[y],g-t,m-n)}else{for(var v={},b=h;b<d;b++){var x=e._index[b];v[x]=e._values[b]}for(var w=t;w<=r;w++){var N=w in v?v[w]:0;p(N,w-t,m-n)}}}return c.push(s.length),new j({values:s,index:u,ptr:c,size:[r-t+1,i-n+1]})}(this,0,this._size[0]-1,0,this._size[1]-1,function(e,t,r){return n(e,[t,r],i)},e)},j.prototype.forEach=function(e,t){if(!this._values)throw new Error("Cannot invoke forEach on a Pattern only matrix");for(var r=this._size[0],n=this._size[1],i=0;i<n;i++){var a=this._ptr[i],o=this._ptr[i+1];if(t)for(var s=a;s<o;s++){var u=this._index[s];e(this._values[s],[u,i],this)}else{for(var c={},f=a;f<o;f++){c[this._index[f]]=this._values[f]}for(var l=0;l<r;l++){e(l in c?c[l]:0,[l,i],this)}}}},j.prototype.toArray=function(){return r(this._values,this._index,this._ptr,this._size,!0)},j.prototype.valueOf=function(){return r(this._values,this._index,this._ptr,this._size,!1)},j.prototype.format=function(e){for(var t=this._size[0],r=this._size[1],n=this.density(),i="Sparse Matrix ["+Object(V.d)(t,e)+" x "+Object(V.d)(r,e)+"] density: "+Object(V.d)(n,e)+"\n",a=0;a<r;a++)for(var o=this._ptr[a],s=this._ptr[a+1],u=o;u<s;u++){var c=this._index[u];i+="\n    ("+Object(V.d)(c,e)+", "+Object(V.d)(a,e)+") ==> "+(this._values?Object(V.d)(this._values[u],e):"X")}return i},j.prototype.toString=function(){return Object(V.d)(this.toArray())},j.prototype.toJSON=function(){return{mathjs:"SparseMatrix",values:this._values,index:this._index,ptr:this._ptr,size:this._size,datatype:this._datatype}},j.prototype.diagonal=function(e){if(e){if(Object(ie.e)(e)&&(e=e.toNumber()),!Object(ie.y)(e)||!Object(E.i)(e))throw new TypeError("The parameter k must be an integer number")}else e=0;var t=0<e?e:0,r=e<0?-e:0,n=this._size[0],i=this._size[1],a=Math.min(n-r,i-t),o=[],s=[],u=[];u[0]=0;for(var c=t;c<i&&o.length<a;c++)for(var f=this._ptr[c],l=this._ptr[c+1],p=f;p<l;p++){var m=this._index[p];if(m===c-t+r){o.push(this._values[p]),s[o.length-1]=m-r;break}}return u.push(o.length),new j({values:o,index:s,ptr:u,size:[a,1]})},j.fromJSON=function(e){return new j(e)},j.diagonal=function(e,t,r,n,i){if(!Object(ie.b)(e))throw new TypeError("Array expected, size parameter");if(2!==e.length)throw new Error("Only two dimensions matrix are supported");if(e=e.map(function(e){if(Object(ie.e)(e)&&(e=e.toNumber()),!Object(ie.y)(e)||!Object(E.i)(e)||e<1)throw new Error("Size values must be positive integers");return e}),r){if(Object(ie.e)(r)&&(r=r.toNumber()),!Object(ie.y)(r)||!Object(E.i)(r))throw new TypeError("The parameter k must be an integer number")}else r=0;var a=M,o=0;Object(ie.I)(i)&&(a=O.find(M,[i,i])||M,o=O.convert(0,i));var s,u=0<r?r:0,c=r<0?-r:0,f=e[0],l=e[1],p=Math.min(f-c,l-u);if(Object(ie.b)(t)){if(t.length!==p)throw new Error("Invalid value array length");s=function(e){return t[e]}}else if(Object(ie.v)(t)){var m=t.size();if(1!==m.length||m[0]!==p)throw new Error("Invalid matrix length");s=function(e){return t.get([e])}}else s=function(){return t};for(var h=[],d=[],y=[],g=0;g<l;g++){y.push(h.length);var v,b=g-u;0<=b&&b<p&&(a(v=s(b),o)||(d.push(b+c),h.push(v)))}return y.push(h.length),new j({values:h,index:d,ptr:y,size:[f,l]})},j.prototype.swapRows=function(e,t){if(!(Object(ie.y)(e)&&Object(E.i)(e)&&Object(ie.y)(t)&&Object(E.i)(t)))throw new Error("Row index must be positive integers");if(2!==this._size.length)throw new Error("Only two dimensional matrix is supported");return Object(q.q)(e,this._size[0]),Object(q.q)(t,this._size[0]),j._swapRows(e,t,this._size[1],this._values,this._index,this._ptr),this},j._forEachRow=function(e,t,r,n,i){for(var a=n[e],o=n[e+1],s=a;s<o;s++)i(r[s],t[s])},j._swapRows=function(e,t,r,n,i,a){for(var o=0;o<r;o++){var s,u,c,f=a[o],l=a[o+1],p=g(e,f,l,i),m=g(t,f,l,i);p<l&&m<l&&i[p]===e&&i[m]===t?n&&(s=n[p],n[p]=n[m],n[m]=s):p<l&&i[p]===e&&(l<=m||i[m]!==t)?(u=n?n[p]:void 0,i.splice(m,0,t),n&&n.splice(m,0,u),i.splice(m<=p?p+1:p,1),n&&n.splice(m<=p?p+1:p,1)):m<l&&i[m]===t&&(l<=p||i[p]!==e)&&(c=n?n[m]:void 0,i.splice(p,0,e),n&&n.splice(p,0,c),i.splice(p<=m?m+1:m,1),n&&n.splice(p<=m?m+1:m,1))}},j},{isClass:!0}),Ee=["typed"],Se=Object(s.a)("number",Ee,function(e){var t=(0,e.typed)("number",{"":function(){return 0},number:function(e){return e},string:function(e){if("NaN"===e)return NaN;var t=Number(e);if(isNaN(t))throw new SyntaxError('String "'+e+'" is no valid number');return t},BigNumber:function(e){return e.toNumber()},Fraction:function(e){return e.valueOf()},Unit:function(){throw new Error("Second argument with valueless unit expected")},null:function(){return 0},"Unit, string | Unit":function(e,t){return e.toNumber(t)},"Array | Matrix":function(e){return oe(e,this)}});return t.fromJSON=function(e){return parseFloat(e.value)},t}),Ae=["typed"],Ce=Object(s.a)("string",Ae,function(e){return(0,e.typed)("string",{"":function(){return""},number:E.h,null:function(){return"null"},boolean:function(e){return e+""},string:function(e){return e},"Array | Matrix":function(e){return oe(e,this)},any:function(e){return String(e)}})}),Te="boolean",_e=["typed"],qe=Object(s.a)(Te,_e,function(e){return(0,e.typed)(Te,{"":function(){return!1},boolean:function(e){return e},number:function(e){return!!e},null:function(){return!1},BigNumber:function(e){return!e.isZero()},string:function(e){var t=e.toLowerCase();if("true"===t)return!0;if("false"===t)return!1;var r=Number(e);if(""!==e&&!isNaN(r))return!!r;throw new Error('Cannot convert "'+e+'" to a boolean')},"Array | Matrix":function(e){return oe(e,this)}})}),Ie=["typed","BigNumber"],ke=Object(s.a)("bignumber",Ie,function(e){var t=e.typed,r=e.BigNumber;return t("bignumber",{"":function(){return new r(0)},number:function(e){return new r(e+"")},string:function(e){return new r(e)},BigNumber:function(e){return e},Fraction:function(e){return new r(e.n).div(e.d).times(e.s)},null:function(){return new r(0)},"Array | Matrix":function(e){return oe(e,this)}})}),Be=["typed","Complex"],ze=Object(s.a)("complex",Be,function(e){var t=e.typed,r=e.Complex;return t("complex",{"":function(){return r.ZERO},number:function(e){return new r(e,0)},"number, number":function(e,t){return new r(e,t)},"BigNumber, BigNumber":function(e,t){return new r(e.toNumber(),t.toNumber())},Fraction:function(e){return new r(e.valueOf(),0)},Complex:function(e){return e.clone()},string:function(e){return r(e)},null:function(){return r(0)},Object:function(e){if("re"in e&&"im"in e)return new r(e.re,e.im);if("r"in e&&"phi"in e||"abs"in e&&"arg"in e)return new r(e);throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)")},"Array | Matrix":function(e){return oe(e,this)}})}),De=["typed","Fraction"],Re=Object(s.a)("fraction",De,function(e){var t=e.typed,r=e.Fraction;return t("fraction",{number:function(e){if(!isFinite(e)||isNaN(e))throw new Error(e+" cannot be represented as a fraction");return new r(e)},string:function(e){return new r(e)},"number, number":function(e,t){return new r(e,t)},null:function(){return new r(0)},BigNumber:function(e){return new r(e.toString())},Fraction:function(e){return e},Object:function(e){return new r(e)},"Array | Matrix":function(e){return oe(e,this)}})}),Pe=["typed","Matrix","DenseMatrix","SparseMatrix"],Ue=Object(s.a)("matrix",Pe,function(e){var t=e.typed,n=(e.Matrix,e.DenseMatrix),i=e.SparseMatrix;return t("matrix",{"":function(){return r([])},string:function(e){return r([],e)},"string, string":function(e,t){return r([],e,t)},Array:function(e){return r(e)},Matrix:function(e){return r(e,e.storage())},"Array | Matrix, string":r,"Array | Matrix, string, string":r});function r(e,t,r){if("dense"===t||"default"===t||void 0===t)return new n(e,r);if("sparse"===t)return new i(e,r);throw new TypeError("Unknown matrix type "+JSON.stringify(t)+".")}}),Fe="splitUnit",Le=["typed"],He=Object(s.a)(Fe,Le,function(e){return(0,e.typed)(Fe,{"Unit, Array":function(e,t){return e.splitUnit(t)}})}),$e="number",Ge="number, number";function Ze(e){return Math.abs(e)}function Ve(e,t){return e+t}function Je(e,t){return e*t}function We(e){return-e}function Ye(e){return e}function Xe(e){return Object(E.d)(e)}function Qe(e){return Math.ceil(e)}function Ke(e){return e*e*e}function et(e){return Math.exp(e)}function tt(e){return Object(E.g)(e)}function rt(e,t){if(!Object(E.i)(e)||!Object(E.i)(t))throw new Error("Parameters in function gcd must be integer numbers");for(var r;0!==t;)r=e%t,e=t,t=r;return e<0?-e:e}function nt(e,t){if(!Object(E.i)(e)||!Object(E.i)(t))throw new Error("Parameters in function lcm must be integer numbers");if(0===e||0===t)return 0;for(var r,n=e*t;0!==t;)t=e%(r=t),e=r;return Math.abs(n/e)}function it(e){return Math.log(e)}function at(e){return Object(E.j)(e)}function ot(e){return Object(E.l)(e)}function st(e,t){if(0<t)return e-t*Math.floor(e/t);if(0===t)return e;throw new Error("Cannot calculate mod for a negative divisor")}function ut(e,t){var r=t<0;if(r&&(t=-t),0===t)throw new Error("Root must be non-zero");if(e<0&&Math.abs(t)%2!=1)throw new Error("Root must be odd when a is negative.");if(0===e)return r?1/0:0;if(!isFinite(e))return r?0:e;var n=Math.pow(Math.abs(e),1/t),n=e<0?-n:n;return r?1/n:n}function ct(e){return Object(E.n)(e)}function ft(e){return e*e}function lt(e,t){var r,n,i,a=0,o=1,s=1,u=0;if(!Object(E.i)(e)||!Object(E.i)(t))throw new Error("Parameters in function xgcd must be integer numbers");for(;t;)i=e-(n=Math.floor(e/t))*t,a=o-n*(r=a),o=r,s=u-n*(r=s),u=r,e=t,t=i;return e<0?[-e,-o,-u]:[e,e?o:0,u]}function pt(e,t){return e*e<1&&t===1/0||1<e*e&&t===-1/0?0:Math.pow(e,t)}function mt(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0;return parseFloat(Object(E.q)(e,t))}Ze.signature=$e,Je.signature=Ve.signature=Ge,tt.signature=et.signature=Ke.signature=Qe.signature=Xe.signature=Ye.signature=We.signature=$e,nt.signature=rt.signature=Ge,ot.signature=at.signature=it.signature=$e,ut.signature=st.signature=Ge,ft.signature=ct.signature=$e,mt.signature=pt.signature=lt.signature=Ge;var ht="unaryMinus",dt=["typed"],yt=Object(s.a)(ht,dt,function(e){return(0,e.typed)(ht,{number:We,Complex:function(e){return e.neg()},BigNumber:function(e){return e.neg()},Fraction:function(e){return e.neg()},Unit:function(e){var t=e.clone();return t.value=this(e.value),t},"Array | Matrix":function(e){return oe(e,this,!0)}})}),gt="unaryPlus",vt=["typed","config","BigNumber"],bt=Object(s.a)(gt,vt,function(e){var t=e.typed,r=e.config,n=e.BigNumber;return t(gt,{number:Ye,Complex:function(e){return e},BigNumber:function(e){return e},Fraction:function(e){return e},Unit:function(e){return e.clone()},"Array | Matrix":function(e){return oe(e,this,!0)},"boolean | string":function(e){return"BigNumber"===r.number?new n(+e):+e}})}),xt=["typed"],wt=Object(s.a)("abs",xt,function(e){return(0,e.typed)("abs",{number:Ze,Complex:function(e){return e.abs()},BigNumber:function(e){return e.abs()},Fraction:function(e){return e.abs()},"Array | Matrix":function(e){return oe(e,this,!0)},Unit:function(e){return e.abs()}})}),Nt=["typed","isInteger"],Ot=Object(s.a)("apply",Nt,function(e){var t=e.typed,i=e.isInteger;return t("apply",{"Array | Matrix, number | BigNumber, function":function(e,t,r){if(!i(t))throw new TypeError("Integer number expected for dimension");var n=Array.isArray(e)?Object(q.a)(e):e.size();if(t<0||t>=n.length)throw new R.a(t,n.length);return Object(ie.v)(e)?e.create(Mt(e.valueOf(),t,r)):Mt(e,t,r)}})});function Mt(e,t,r){var n,i,a;if(t<=0){if(Array.isArray(e[0])){for(a=function(e){var t,r,n=e.length,i=e[0].length,a=[];for(r=0;r<i;r++){var o=[];for(t=0;t<n;t++)o.push(e[t][r]);a.push(o)}return a}(e),i=[],n=0;n<a.length;n++)i[n]=Mt(a[n],t-1,r);return i}return r(e)}for(i=[],n=0;n<e.length;n++)i[n]=Mt(e[n],t-1,r);return i}var jt="addScalar",Et=["typed"],St=Object(s.a)(jt,Et,function(e){return(0,e.typed)(jt,{"number, number":Ve,"Complex, Complex":function(e,t){return e.add(t)},"BigNumber, BigNumber":function(e,t){return e.plus(t)},"Fraction, Fraction":function(e,t){return e.add(t)},"Unit, Unit":function(e,t){if(null===e.value||void 0===e.value)throw new Error("Parameter x contains a unit with undefined value");if(null===t.value||void 0===t.value)throw new Error("Parameter y contains a unit with undefined value");if(!e.equalBase(t))throw new Error("Units do not match");var r=e.clone();return r.value=this(r.value,t.value),r.fixPrefix=!1,r}})}),At=["config","typed","isNegative","unaryMinus","matrix","Complex","BigNumber","Fraction"],Ct=Object(s.a)("cbrt",At,function(e){var o=e.config,t=e.typed,a=e.isNegative,s=e.unaryMinus,u=e.matrix,c=e.Complex,f=e.BigNumber,l=e.Fraction;return t("cbrt",{number:Xe,Complex:p,"Complex, boolean":p,BigNumber:function(e){return e.cbrt()},Unit:function(e){{if(e.value&&Object(ie.j)(e.value)){var t=e.clone();return t.value=1,(t=t.pow(1/3)).value=p(e.value),t}var r,n=a(e.value);n&&(e.value=s(e.value)),r=Object(ie.e)(e.value)?new f(1).div(3):Object(ie.o)(e.value)?new l(1,3):1/3;var i=e.pow(r);return n&&(i.value=s(i.value)),i}},"Array | Matrix":function(e){return oe(e,this,!0)}});function p(e,t){var r=e.arg()/3,n=e.abs(),i=new c(Xe(n),0).mul(new c(0,r).exp());if(t){var a=[i,new c(Xe(n),0).mul(new c(0,r+2*Math.PI/3).exp()),new c(Xe(n),0).mul(new c(0,r-2*Math.PI/3).exp())];return"Array"===o.matrix?a:u(a)}return i}}),Tt=["typed","config","round"],_t=Object(s.a)("ceil",Tt,function(e){var t=e.typed,r=e.config,n=e.round;return t("ceil",{number:function(e){return(Object(E.m)(e,n(e),r.epsilon)?n:Qe)(e)},Complex:function(e){return e.ceil()},BigNumber:function(e){return xe(e,n(e),r.epsilon)?n(e):e.ceil()},Fraction:function(e){return e.ceil()},"Array | Matrix":function(e){return oe(e,this,!0)}})}),qt=["typed"],It=Object(s.a)("cube",qt,function(e){return(0,e.typed)("cube",{number:Ke,Complex:function(e){return e.mul(e).mul(e)},BigNumber:function(e){return e.times(e).times(e)},Fraction:function(e){return e.pow(3)},"Array | Matrix":function(e){return oe(e,this,!0)},Unit:function(e){return e.pow(3)}})}),kt=["typed"],Bt=Object(s.a)("exp",kt,function(e){return(0,e.typed)("exp",{number:et,Complex:function(e){return e.exp()},BigNumber:function(e){return e.exp()},"Array | Matrix":function(e){return oe(e,this)}})}),zt=["typed","Complex"],Dt=Object(s.a)("expm1",zt,function(e){var t=e.typed,r=e.Complex;return t("expm1",{number:tt,Complex:function(e){var t=Math.exp(e.re);return new r(t*Math.cos(e.im)-1,t*Math.sin(e.im))},BigNumber:function(e){return e.exp().minus(1)},"Array | Matrix":function(e){return oe(e,this)}})}),Rt=["typed","Complex","ceil","floor"],Pt=Object(s.a)("fix",Rt,function(e){var t=e.typed,r=e.Complex,n=e.ceil,i=e.floor;return t("fix",{number:function(e){return(0<e?i:n)(e)},Complex:function(e){return new r(0<e.re?Math.floor(e.re):Math.ceil(e.re),0<e.im?Math.floor(e.im):Math.ceil(e.im))},BigNumber:function(e){return(e.isNegative()?n:i)(e)},Fraction:function(e){return e.s<0?e.ceil():e.floor()},"Array | Matrix":function(e){return oe(e,this,!0)}})}),Ut=["typed","config","round"],Ft=Object(s.a)("floor",Ut,function(e){var t=e.typed,r=e.config,n=e.round;return t("floor",{number:function(e){return Object(E.m)(e,n(e),r.epsilon)?n(e):Math.floor(e)},Complex:function(e){return e.floor()},BigNumber:function(e){return xe(e,n(e),r.epsilon)?n(e):e.floor()},Fraction:function(e){return e.floor()},"Array | Matrix":function(e){return oe(e,this,!0)}})}),Lt=["typed"],Ht=Object(s.a)("algorithm01",Lt,function(e){var j=e.typed;return function(e,t,r,n){var i=e._data,a=e._size,o=e._datatype,s=t._values,u=t._index,c=t._ptr,f=t._size,l=t._datatype;if(a.length!==f.length)throw new z.a(a.length,f.length);if(a[0]!==f[0]||a[1]!==f[1])throw new RangeError("Dimension mismatch. Matrix A ("+a+") must match Matrix B ("+f+")");if(!s)throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");for(var p=a[0],m=a[1],h="string"==typeof o&&o===l?o:void 0,d=h?j.find(r,[h,h]):r,y=[],g=0;g<p;g++)y[g]=[];for(var v=[],b=[],x=0;x<m;x++){for(var w=x+1,N=c[x],O=c[x+1],M=N;M<O;M++)v[g=u[M]]=n?d(s[M],i[g][x]):d(i[g][x],s[M]),b[g]=w;for(g=0;g<p;g++)b[g]===w?y[g][x]=v[g]:y[g][x]=i[g][x]}return e.createDenseMatrix({data:y,size:[p,m],datatype:h})}}),$t=["typed","equalScalar"],Gt=Object(s.a)("algorithm04",$t,function(e){var I=e.typed,k=e.equalScalar;return function(e,t,r){var n=e._values,i=e._index,a=e._ptr,o=e._size,s=e._datatype,u=t._values,c=t._index,f=t._ptr,l=t._size,p=t._datatype;if(o.length!==l.length)throw new z.a(o.length,l.length);if(o[0]!==l[0]||o[1]!==l[1])throw new RangeError("Dimension mismatch. Matrix A ("+o+") must match Matrix B ("+l+")");var m,h=o[0],d=o[1],y=k,g=0,v=r;"string"==typeof s&&s===p&&(m=s,y=I.find(k,[m,m]),g=I.convert(0,m),v=I.find(r,[m,m]));for(var b=n&&u?[]:void 0,x=[],w=[],N=n&&u?[]:void 0,O=n&&u?[]:void 0,M=[],j=[],E=0;E<d;E++){w[E]=x.length;for(var S,A,C=E+1,T=a[E],_=a[E+1],q=T;q<_;q++)A=i[q],x.push(A),M[A]=C,N&&(N[A]=n[q]);for(T=f[E],_=f[E+1],q=T;q<_;q++){M[A=c[q]]===C?N&&(y(S=v(N[A],u[q]),g)?M[A]=null:N[A]=S):(x.push(A),j[A]=C,O&&(O[A]=u[q]))}if(N&&O)for(q=w[E];q<x.length;)M[A=x[q]]===C?(b[q]=N[A],q++):j[A]===C?(b[q]=O[A],q++):x.splice(q,1)}return w[d]=x.length,e.createSparseMatrix({values:b,index:x,ptr:w,size:[h,d],datatype:m})}}),Zt=["typed","DenseMatrix"],Vt=Object(s.a)("algorithm10",Zt,function(e){var O=e.typed,M=e.DenseMatrix;return function(e,t,r,n){var i=e._values,a=e._index,o=e._ptr,s=e._size,u=e._datatype;if(!i)throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");var c,f=s[0],l=s[1],p=r;"string"==typeof u&&(c=u,t=O.convert(t,c),p=O.find(r,[c,c]));for(var m=[],h=[],d=[],y=0;y<l;y++){for(var g=y+1,v=o[y],b=o[y+1],x=v;x<b;x++){var w=a[x];h[w]=i[x],d[w]=g}for(var N=0;N<f;N++)0===y&&(m[N]=[]),d[N]===g?m[N][y]=n?p(t,h[N]):p(h[N],t):m[N][y]=t}return new M({data:m,size:[f,l],datatype:c})}}),Jt=["typed"],Wt=Object(s.a)("algorithm13",Jt,function(e){var h=e.typed;return function(e,t,r){var n=e._data,i=e._size,a=e._datatype,o=t._data,s=t._size,u=t._datatype,c=[];if(i.length!==s.length)throw new z.a(i.length,s.length);for(var f,l=0;l<i.length;l++){if(i[l]!==s[l])throw new RangeError("Dimension mismatch. Matrix A ("+i+") must match Matrix B ("+s+")");c[l]=i[l]}var p=r;"string"==typeof a&&a===u&&(f=a,p=h.find(r,[f,f]));var m=0<c.length?function e(t,r,n,i,a,o){var s=[];if(r===n.length-1)for(var u=0;u<i;u++)s[u]=t(a[u],o[u]);else for(var c=0;c<i;c++)s[c]=e(t,r+1,n,n[r+1],a[c],o[c]);return s}(p,0,c,c[0],n,o):[];return e.createDenseMatrix({data:m,size:c,datatype:f})}}),Yt=["typed"],Xt=Object(s.a)("algorithm14",Yt,function(e){var f=e.typed;return function(e,t,r,n){var i,a=e._data,o=e._size,s=e._datatype,u=r;"string"==typeof s&&(i=s,t=f.convert(t,i),u=f.find(r,[i,i]));var c=0<o.length?function e(t,r,n,i,a,o,s){var u=[];if(r===n.length-1)for(var c=0;c<i;c++)u[c]=s?t(o,a[c]):t(a[c],o);else for(var f=0;f<i;f++)u[f]=e(t,r+1,n,n[r+1],a[f],o,s);return u}(u,0,o,o[0],a,t,n):[];return e.createDenseMatrix({data:c,size:Object(ae.a)(o),datatype:i})}}),Qt=["typed","matrix","equalScalar","BigNumber","DenseMatrix"],Kt=Object(s.a)("gcd",Qt,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.BigNumber,a=e.DenseMatrix,o=Ht({typed:t}),s=Gt({typed:t,equalScalar:n}),u=Vt({typed:t,DenseMatrix:a}),c=Wt({typed:t}),f=Xt({typed:t});return t("gcd",{"number, number":rt,"BigNumber, BigNumber":function(e,t){if(!e.isInt()||!t.isInt())throw new Error("Parameters in function gcd must be integer numbers");var r=new i(0);for(;!t.isZero();){var n=e.mod(t);e=t,t=n}return e.lt(r)?e.neg():e},"Fraction, Fraction":function(e,t){return e.gcd(t)},"SparseMatrix, SparseMatrix":function(e,t){return s(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return o(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return o(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return c(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, number | BigNumber":function(e,t){return u(e,t,this,!1)},"DenseMatrix, number | BigNumber":function(e,t){return f(e,t,this,!1)},"number | BigNumber, SparseMatrix":function(e,t){return u(t,e,this,!0)},"number | BigNumber, DenseMatrix":function(e,t){return f(t,e,this,!0)},"Array, number | BigNumber":function(e,t){return f(r(e),t,this,!1).valueOf()},"number | BigNumber, Array":function(e,t){return f(r(t),e,this,!0).valueOf()},"Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber":function(e,t,r){for(var n=this(e,t),i=0;i<r.length;i++)n=this(n,r[i]);return n}})}),er=["typed","equalScalar"],tr=Object(s.a)("algorithm02",er,function(e){var S=e.typed,A=e.equalScalar;return function(e,t,r,n){var i=e._data,a=e._size,o=e._datatype,s=t._values,u=t._index,c=t._ptr,f=t._size,l=t._datatype;if(a.length!==f.length)throw new z.a(a.length,f.length);if(a[0]!==f[0]||a[1]!==f[1])throw new RangeError("Dimension mismatch. Matrix A ("+a+") must match Matrix B ("+f+")");if(!s)throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");var p,m=a[0],h=a[1],d=A,y=0,g=r;"string"==typeof o&&o===l&&(p=o,d=S.find(A,[p,p]),y=S.convert(0,p),g=S.find(r,[p,p]));for(var v=[],b=[],x=[],w=0;w<h;w++){x[w]=b.length;for(var N=c[w],O=c[w+1],M=N;M<O;M++){var j=u[M],E=n?g(s[M],i[j][w]):g(i[j][w],s[M]);d(E,y)||(b.push(j),v.push(E))}}return x[h]=b.length,t.createSparseMatrix({values:v,index:b,ptr:x,size:[m,h],datatype:p})}}),rr=["typed","equalScalar"],nr=Object(s.a)("algorithm06",rr,function(e){var S=e.typed,A=e.equalScalar;return function(e,t,r){var n=e._values,i=e._size,a=e._datatype,o=t._values,s=t._size,u=t._datatype;if(i.length!==s.length)throw new z.a(i.length,s.length);if(i[0]!==s[0]||i[1]!==s[1])throw new RangeError("Dimension mismatch. Matrix A ("+i+") must match Matrix B ("+s+")");var c,f=i[0],l=i[1],p=A,m=0,h=r;"string"==typeof a&&a===u&&(c=a,p=S.find(A,[c,c]),m=S.convert(0,c),h=S.find(r,[c,c]));for(var d=n&&o?[]:void 0,y=[],g=[],v=d?[]:void 0,b=[],x=[],w=0;w<l;w++){g[w]=y.length;var N=w+1;if(H(e,w,b,v,x,N,y,h),H(t,w,b,v,x,N,y,h),v)for(var O=g[w];O<y.length;){var M,j=y[O];x[j]!==N||p(M=v[j],m)?y.splice(O,1):(d.push(M),O++)}else for(var E=g[w];E<y.length;){x[y[E]]!==N?y.splice(E,1):E++}}return g[l]=y.length,e.createSparseMatrix({values:d,index:y,ptr:g,size:[f,l],datatype:c})}}),ir=["typed","equalScalar"],ar=Object(s.a)("algorithm11",ir,function(e){var M=e.typed,j=e.equalScalar;return function(e,t,r,n){var i=e._values,a=e._index,o=e._ptr,s=e._size,u=e._datatype;if(!i)throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");var c,f=s[0],l=s[1],p=j,m=0,h=r;"string"==typeof u&&(c=u,p=M.find(j,[c,c]),m=M.convert(0,c),t=M.convert(t,c),h=M.find(r,[c,c]));for(var d=[],y=[],g=[],v=0;v<l;v++){g[v]=y.length;for(var b=o[v],x=o[v+1],w=b;w<x;w++){var N=a[w],O=n?h(t,i[w]):h(i[w],t);p(O,m)||(y.push(N),d.push(O))}}return g[l]=y.length,e.createSparseMatrix({values:d,index:y,ptr:g,size:[f,l],datatype:c})}}),or=["typed","matrix","equalScalar"],sr=Object(s.a)("lcm",or,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=tr({typed:t,equalScalar:n}),a=nr({typed:t,equalScalar:n}),o=ar({typed:t,equalScalar:n}),s=Wt({typed:t}),u=Xt({typed:t});return t("lcm",{"number, number":nt,"BigNumber, BigNumber":function(e,t){if(!e.isInt()||!t.isInt())throw new Error("Parameters in function lcm must be integer numbers");if(e.isZero())return e;if(t.isZero())return t;var r=e.times(t);for(;!t.isZero();){var n=t;t=e.mod(n),e=n}return r.div(e).abs()},"Fraction, Fraction":function(e,t){return e.lcm(t)},"SparseMatrix, SparseMatrix":function(e,t){return a(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return i(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return i(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return s(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, number | BigNumber":function(e,t){return o(e,t,this,!1)},"DenseMatrix, number | BigNumber":function(e,t){return u(e,t,this,!1)},"number | BigNumber, SparseMatrix":function(e,t){return o(t,e,this,!0)},"number | BigNumber, DenseMatrix":function(e,t){return u(t,e,this,!0)},"Array, number | BigNumber":function(e,t){return u(r(e),t,this,!1).valueOf()},"number | BigNumber, Array":function(e,t){return u(r(t),e,this,!0).valueOf()},"Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber":function(e,t,r){for(var n=this(e,t),i=0;i<r.length;i++)n=this(n,r[i]);return n}})}),ur=["typed","config","Complex"],cr=Object(s.a)("log10",ur,function(e){var t=e.typed,r=e.config,n=e.Complex;return t("log10",{number:function(e){return 0<=e||r.predictable?at(e):new n(e,0).log().div(Math.LN10)},Complex:function(e){return new n(e).log().div(Math.LN10)},BigNumber:function(e){return!e.isNegative()||r.predictable?e.log():new n(e.toNumber(),0).log().div(Math.LN10)},"Array | Matrix":function(e){return oe(e,this)}})}),fr=["typed","config","Complex"],lr=Object(s.a)("log2",fr,function(e){var t=e.typed,r=e.config,n=e.Complex;return t("log2",{number:function(e){return 0<=e||r.predictable?ot(e):i(new n(e,0))},Complex:i,BigNumber:function(e){return!e.isNegative()||r.predictable?e.log(2):i(new n(e.toNumber(),0))},"Array | Matrix":function(e){return oe(e,this)}});function i(e){var t=Math.sqrt(e.re*e.re+e.im*e.im);return new n(Math.log2?Math.log2(t):Math.log(t)/Math.LN2,Math.atan2(e.im,e.re)/Math.LN2)}}),pr=["typed"],mr=Object(s.a)("algorithm03",pr,function(e){var A=e.typed;return function(e,t,r,n){var i=e._data,a=e._size,o=e._datatype,s=t._values,u=t._index,c=t._ptr,f=t._size,l=t._datatype;if(a.length!==f.length)throw new z.a(a.length,f.length);if(a[0]!==f[0]||a[1]!==f[1])throw new RangeError("Dimension mismatch. Matrix A ("+a+") must match Matrix B ("+f+")");if(!s)throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");var p,m=a[0],h=a[1],d=0,y=r;"string"==typeof o&&o===l&&(p=o,d=A.convert(0,p),y=A.find(r,[p,p]));for(var g=[],v=0;v<m;v++)g[v]=[];for(var b=[],x=[],w=0;w<h;w++){for(var N=w+1,O=c[w],M=c[w+1],j=O;j<M;j++){var E=u[j];b[E]=n?y(s[j],i[E][w]):y(i[E][w],s[j]),x[E]=N}for(var S=0;S<m;S++)x[S]===N?g[S][w]=b[S]:g[S][w]=n?y(d,i[S][w]):y(i[S][w],d)}return e.createDenseMatrix({data:g,size:[m,h],datatype:p})}}),hr=["typed","equalScalar"],dr=Object(s.a)("algorithm05",hr,function(e){var k=e.typed,B=e.equalScalar;return function(e,t,r){var n=e._values,i=e._index,a=e._ptr,o=e._size,s=e._datatype,u=t._values,c=t._index,f=t._ptr,l=t._size,p=t._datatype;if(o.length!==l.length)throw new z.a(o.length,l.length);if(o[0]!==l[0]||o[1]!==l[1])throw new RangeError("Dimension mismatch. Matrix A ("+o+") must match Matrix B ("+l+")");var m,h=o[0],d=o[1],y=B,g=0,v=r;"string"==typeof s&&s===p&&(m=s,y=k.find(B,[m,m]),g=k.convert(0,m),v=k.find(r,[m,m]));for(var b,x=n&&u?[]:void 0,w=[],N=[],O=x?[]:void 0,M=x?[]:void 0,j=[],E=[],S=0;S<d;S++){N[S]=w.length;for(var A=S+1,C=a[S],T=a[S+1];C<T;C++)b=i[C],w.push(b),j[b]=A,O&&(O[b]=n[C]);for(C=f[S],T=f[S+1];C<T;C++)j[b=c[C]]!==A&&w.push(b),E[b]=A,M&&(M[b]=u[C]);if(x)for(C=N[S];C<w.length;){var _,q=j[b=w[C]],I=E[b];q!==A&&I!==A||(y(_=v(q===A?O[b]:g,I===A?M[b]:g),g)?w.splice(C,1):(x.push(_),C++))}}return N[d]=w.length,e.createSparseMatrix({values:x,index:w,ptr:N,size:[h,d],datatype:m})}}),yr=["typed","DenseMatrix"],gr=Object(s.a)("algorithm12",yr,function(e){var O=e.typed,M=e.DenseMatrix;return function(e,t,r,n){var i=e._values,a=e._index,o=e._ptr,s=e._size,u=e._datatype;if(!i)throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");var c,f=s[0],l=s[1],p=r;"string"==typeof u&&(c=u,t=O.convert(t,c),p=O.find(r,[c,c]));for(var m=[],h=[],d=[],y=0;y<l;y++){for(var g=y+1,v=o[y],b=o[y+1],x=v;x<b;x++){var w=a[x];h[w]=i[x],d[w]=g}for(var N=0;N<f;N++)0===y&&(m[N]=[]),d[N]===g?m[N][y]=n?p(t,h[N]):p(h[N],t):m[N][y]=n?p(t,0):p(0,t)}return new M({data:m,size:[f,l],datatype:c})}}),vr=["typed","matrix","equalScalar","DenseMatrix"],br=Object(s.a)("mod",vr,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.DenseMatrix,a=tr({typed:t,equalScalar:n}),o=mr({typed:t}),s=dr({typed:t,equalScalar:n}),u=ar({typed:t,equalScalar:n}),c=gr({typed:t,DenseMatrix:i}),f=Wt({typed:t}),l=Xt({typed:t});return t("mod",{"number, number":st,"BigNumber, BigNumber":function(e,t){return t.isZero()?e:e.mod(t)},"Fraction, Fraction":function(e,t){return e.mod(t)},"SparseMatrix, SparseMatrix":function(e,t){return s(e,t,this,!1)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return o(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return f(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return u(e,t,this,!1)},"DenseMatrix, any":function(e,t){return l(e,t,this,!1)},"any, SparseMatrix":function(e,t){return c(t,e,this,!0)},"any, DenseMatrix":function(e,t){return l(t,e,this,!0)},"Array, any":function(e,t){return l(r(e),t,this,!1).valueOf()},"any, Array":function(e,t){return l(r(t),e,this,!0).valueOf()}})}),xr=["typed"],wr=Object(s.a)("multiplyScalar",xr,function(e){return(0,e.typed)("multiplyScalar",{"number, number":Je,"Complex, Complex":function(e,t){return e.mul(t)},"BigNumber, BigNumber":function(e,t){return e.times(t)},"Fraction, Fraction":function(e,t){return e.mul(t)},"number | Fraction | BigNumber | Complex, Unit":function(e,t){var r=t.clone();return r.value=null===r.value?r._normalize(e):this(r.value,e),r},"Unit, number | Fraction | BigNumber | Complex":function(e,t){var r=e.clone();return r.value=null===r.value?r._normalize(t):this(r.value,t),r},"Unit, Unit":function(e,t){return e.multiply(t)}})}),Nr="multiply",Or=["typed","matrix","addScalar","multiplyScalar","equalScalar","dot"],Mr=Object(s.a)(Nr,Or,function(e){var z=e.typed,n=e.matrix,D=e.addScalar,R=e.multiplyScalar,k=e.equalScalar,i=e.dot,r=ar({typed:z,equalScalar:k}),a=Xt({typed:z});function o(e,t){switch(e.length){case 1:switch(t.length){case 1:if(e[0]!==t[0])throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");break;case 2:if(e[0]!==t[0])throw new RangeError("Dimension mismatch in multiplication. Vector length ("+e[0]+") must match Matrix rows ("+t[0]+")");break;default:throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has "+t.length+" dimensions)")}break;case 2:switch(t.length){case 1:if(e[1]!==t[0])throw new RangeError("Dimension mismatch in multiplication. Matrix columns ("+e[1]+") must match Vector length ("+t[0]+")");break;case 2:if(e[1]!==t[0])throw new RangeError("Dimension mismatch in multiplication. Matrix A columns ("+e[1]+") must match Matrix B rows ("+t[0]+")");break;default:throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has "+t.length+" dimensions)")}break;default:throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has "+e.length+" dimensions)")}}function s(e,t){if("dense"!==t.storage())throw new Error("Support for SparseMatrix not implemented");return function(e,t){var r,n=e._data,i=e._size,a=e._datatype,o=t._data,s=t._size,u=t._datatype,c=i[0],f=s[1],l=D,p=R;a&&u&&a===u&&"string"==typeof a&&(r=a,l=z.find(D,[r,r]),p=z.find(R,[r,r]));for(var m=[],h=0;h<f;h++){for(var d=p(n[0],o[0][h]),y=1;y<c;y++)d=l(d,p(n[y],o[y][h]));m[h]=d}return e.createDenseMatrix({data:m,size:[f],datatype:r})}(e,t)}var u=z("_multiplyMatrixVector",{"DenseMatrix, any":function(e,t){var r,n=e._data,i=e._size,a=e._datatype,o=t._data,s=t._datatype,u=i[0],c=i[1],f=D,l=R;a&&s&&a===s&&"string"==typeof a&&(r=a,f=z.find(D,[r,r]),l=z.find(R,[r,r]));for(var p=[],m=0;m<u;m++){for(var h=n[m],d=l(h[0],o[0]),y=1;y<c;y++)d=f(d,l(h[y],o[y]));p[m]=d}return e.createDenseMatrix({data:p,size:[u],datatype:r})},"SparseMatrix, any":function(e,t){var r=e._values,n=e._index,i=e._ptr,a=e._datatype;if(!r)throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");var o,s=t._data,u=t._datatype,c=e._size[0],f=t._size[0],l=[],p=[],m=[],h=D,d=R,y=k,g=0;a&&u&&a===u&&"string"==typeof a&&(o=a,h=z.find(D,[o,o]),d=z.find(R,[o,o]),y=z.find(k,[o,o]),g=z.convert(0,o));for(var v=[],b=[],x=m[0]=0;x<f;x++){var w=s[x];if(!y(w,g))for(var N=i[x],O=i[x+1],M=N;M<O;M++){var j=n[M];b[j]?v[j]=h(v[j],d(w,r[M])):(b[j]=!0,p.push(j),v[j]=d(w,r[M]))}}for(var E=p.length,S=0;S<E;S++){var A=p[S];l[S]=v[A]}return m[1]=p.length,e.createSparseMatrix({values:l,index:p,ptr:m,size:[c,1],datatype:o})}}),c=z("_multiplyMatrixMatrix",{"DenseMatrix, DenseMatrix":function(e,t){var r,n=e._data,i=e._size,a=e._datatype,o=t._data,s=t._size,u=t._datatype,c=i[0],f=i[1],l=s[1],p=D,m=R;a&&u&&a===u&&"string"==typeof a&&(r=a,p=z.find(D,[r,r]),m=z.find(R,[r,r]));for(var h=[],d=0;d<c;d++){var y=n[d];h[d]=[];for(var g=0;g<l;g++){for(var v=m(y[0],o[0][g]),b=1;b<f;b++)v=p(v,m(y[b],o[b][g]));h[d][g]=v}}return e.createDenseMatrix({data:h,size:[c,l],datatype:r})},"DenseMatrix, SparseMatrix":function(e,t){var r=e._data,n=e._size,i=e._datatype,a=t._values,o=t._index,s=t._ptr,u=t._size,c=t._datatype;if(!a)throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");var f,l=n[0],p=u[1],m=D,h=R,d=k,y=0;i&&c&&i===c&&"string"==typeof i&&(f=i,m=z.find(D,[f,f]),h=z.find(R,[f,f]),d=z.find(k,[f,f]),y=z.convert(0,f));for(var g=[],v=[],b=[],x=t.createSparseMatrix({values:g,index:v,ptr:b,size:[l,p],datatype:f}),w=0;w<p;w++){b[w]=v.length;var N=s[w],O=s[w+1];if(N<O)for(var M=0,j=0;j<l;j++){for(var E=j+1,S=void 0,A=N;A<O;A++){var C=o[A];M!==E?(S=h(r[j][C],a[A]),M=E):S=m(S,h(r[j][C],a[A]))}M!==E||d(S,y)||(v.push(j),g.push(S))}}return b[p]=v.length,x},"SparseMatrix, DenseMatrix":function(e,t){var r=e._values,n=e._index,i=e._ptr,a=e._datatype;if(!r)throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");var o,s=t._data,u=t._datatype,c=e._size[0],f=t._size[0],l=t._size[1],p=D,m=R,h=k,d=0;a&&u&&a===u&&"string"==typeof a&&(o=a,p=z.find(D,[o,o]),m=z.find(R,[o,o]),h=z.find(k,[o,o]),d=z.convert(0,o));for(var y=[],g=[],v=[],b=e.createSparseMatrix({values:y,index:g,ptr:v,size:[c,l],datatype:o}),x=[],w=[],N=0;N<l;N++){v[N]=g.length;for(var O=N+1,M=0;M<f;M++){var j=s[M][N];if(!h(j,d))for(var E=i[M],S=i[M+1],A=E;A<S;A++){var C=n[A];w[C]!==O?(w[C]=O,g.push(C),x[C]=m(j,r[A])):x[C]=p(x[C],m(j,r[A]))}}for(var T=v[N],_=g.length,q=T;q<_;q++){var I=g[q];y[q]=x[I]}}return v[l]=g.length,b},"SparseMatrix, SparseMatrix":function(e,t){var r,n=e._values,i=e._index,a=e._ptr,o=e._datatype,s=t._values,u=t._index,c=t._ptr,f=t._datatype,l=e._size[0],p=t._size[1],m=n&&s,h=D,d=R;o&&f&&o===f&&"string"==typeof o&&(r=o,h=z.find(D,[r,r]),d=z.find(R,[r,r]));for(var y,g,v,b,x,w,N,O,M=m?[]:void 0,j=[],E=[],S=e.createSparseMatrix({values:M,index:j,ptr:E,size:[l,p],datatype:r}),A=m?[]:void 0,C=[],T=0;T<p;T++){E[T]=j.length;var _=T+1;for(x=c[T],w=c[T+1],b=x;b<w;b++)if(O=u[b],m)for(g=a[O],v=a[O+1],y=g;y<v;y++)N=i[y],C[N]!==_?(C[N]=_,j.push(N),A[N]=d(s[b],n[y])):A[N]=h(A[N],d(s[b],n[y]));else for(g=a[O],v=a[O+1],y=g;y<v;y++)N=i[y],C[N]!==_&&(C[N]=_,j.push(N));if(m)for(var q=E[T],I=j.length,k=q;k<I;k++){var B=j[k];M[k]=A[B]}}return E[p]=j.length,S}});return z(Nr,Object(ae.e)({"Array, Array":function(e,t){o(Object(q.a)(e),Object(q.a)(t));var r=this(n(e),n(t));return Object(ie.v)(r)?r.valueOf():r},"Matrix, Matrix":function(e,t){var r=e.size(),n=t.size();return o(r,n),1===r.length?1===n.length?function(e,t,r){if(0===r)throw new Error("Cannot multiply two empty vectors");return i(e,t)}(e,t,r[0]):s(e,t):(1===n.length?u:c)(e,t)},"Matrix, Array":function(e,t){return this(e,n(t))},"Array, Matrix":function(e,t){return this(n(e,t.storage()),t)},"SparseMatrix, any":function(e,t){return r(e,t,R,!1)},"DenseMatrix, any":function(e,t){return a(e,t,R,!1)},"any, SparseMatrix":function(e,t){return r(t,e,R,!0)},"any, DenseMatrix":function(e,t){return a(t,e,R,!0)},"Array, any":function(e,t){return a(n(e),t,R,!1).valueOf()},"any, Array":function(e,t){return a(n(t),e,R,!0).valueOf()},"any, any":R,"any, any, ...any":function(e,t,r){for(var n=this(e,t),i=0;i<r.length;i++)n=this(n,r[i]);return n}},R.signatures))}),jr="nthRoot",Er=["typed","matrix","equalScalar","BigNumber"],Sr=Object(s.a)(jr,Er,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,u=e.BigNumber,i=Ht({typed:t}),a=tr({typed:t,equalScalar:n}),o=nr({typed:t,equalScalar:n}),s=ar({typed:t,equalScalar:n}),c=Wt({typed:t}),f=Xt({typed:t}),l="Complex number not supported in function nthRoot. Use nthRoots instead.";return t(jr,{number:function(e){return ut(e,2)},"number, number":ut,BigNumber:function(e){return p(e,new u(2))},Complex:function(){throw new Error(l)},"Complex, number":function(){throw new Error(l)},"BigNumber, BigNumber":p,"Array | Matrix":function(e){return this(e,2)},"SparseMatrix, SparseMatrix":function(e,t){if(1===t.density())return o(e,t,this);throw new Error("Root must be non-zero")},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){if(1===t.density())return i(e,t,this,!1);throw new Error("Root must be non-zero")},"DenseMatrix, DenseMatrix":function(e,t){return c(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, number | BigNumber":function(e,t){return s(e,t,this,!1)},"DenseMatrix, number | BigNumber":function(e,t){return f(e,t,this,!1)},"number | BigNumber, SparseMatrix":function(e,t){if(1===t.density())return s(t,e,this,!0);throw new Error("Root must be non-zero")},"number | BigNumber, DenseMatrix":function(e,t){return f(t,e,this,!0)},"Array, number | BigNumber":function(e,t){return this(r(e),t).valueOf()},"number | BigNumber, Array":function(e,t){return this(e,r(t)).valueOf()}});function p(e,t){var r=u.precision,n=u.clone({precision:r+2}),i=new u(0),a=new n(1),o=t.isNegative();if(o&&(t=t.neg()),t.isZero())throw new Error("Root must be non-zero");if(e.isNegative()&&!t.abs().mod(2).equals(1))throw new Error("Root must be odd when a is negative.");if(e.isZero())return o?new n(1/0):0;if(!e.isFinite())return o?i:e;var s=e.abs().pow(a.div(t)),s=e.isNeg()?s.neg():s;return new u((o?a.div(s):s).toPrecision(r))}}),Ar=["typed","BigNumber","Fraction","complex"],Cr=Object(s.a)("sign",Ar,function(e){var t=e.typed,r=e.BigNumber,n=e.complex,i=e.Fraction;return t("sign",{number:ct,Complex:function(e){return 0===e.im?n(ct(e.re)):e.sign()},BigNumber:function(e){return new r(e.cmp(0))},Fraction:function(e){return new i(e.s,1)},"Array | Matrix":function(e){return oe(e,this,!0)},Unit:function(e){return this(e.value)}})}),Tr=["config","typed","Complex"],_r=Object(s.a)("sqrt",Tr,function(e){var t=e.config,r=e.typed,n=e.Complex;return r("sqrt",{number:i,Complex:function(e){return e.sqrt()},BigNumber:function(e){return!e.isNegative()||t.predictable?e.sqrt():i(e.toNumber())},"Array | Matrix":function(e){return oe(e,this,!0)},Unit:function(e){return e.pow(.5)}});function i(e){return isNaN(e)?NaN:0<=e||t.predictable?Math.sqrt(e):new n(e,0).sqrt()}}),qr=["typed"],Ir=Object(s.a)("square",qr,function(e){return(0,e.typed)("square",{number:ft,Complex:function(e){return e.mul(e)},BigNumber:function(e){return e.times(e)},Fraction:function(e){return e.mul(e)},"Array | Matrix":function(e){return oe(e,this,!0)},Unit:function(e){return e.pow(2)}})}),kr="subtract",Br=["typed","matrix","equalScalar","addScalar","unaryMinus","DenseMatrix"],zr=Object(s.a)(kr,Br,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.addScalar,a=e.unaryMinus,o=e.DenseMatrix,s=Ht({typed:t}),u=mr({typed:t}),c=dr({typed:t,equalScalar:n}),f=Vt({typed:t,DenseMatrix:o}),l=Wt({typed:t}),p=Xt({typed:t});return t(kr,{"number, number":function(e,t){return e-t},"Complex, Complex":function(e,t){return e.sub(t)},"BigNumber, BigNumber":function(e,t){return e.minus(t)},"Fraction, Fraction":function(e,t){return e.sub(t)},"Unit, Unit":function(e,t){if(null===e.value)throw new Error("Parameter x contains a unit with undefined value");if(null===t.value)throw new Error("Parameter y contains a unit with undefined value");if(!e.equalBase(t))throw new Error("Units do not match");var r=e.clone();return r.value=this(r.value,t.value),r.fixPrefix=!1,r},"SparseMatrix, SparseMatrix":function(e,t){return Dr(e,t),c(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return Dr(e,t),u(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return Dr(e,t),s(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return Dr(e,t),l(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return f(e,a(t),i)},"DenseMatrix, any":function(e,t){return p(e,t,this)},"any, SparseMatrix":function(e,t){return f(t,e,this,!0)},"any, DenseMatrix":function(e,t){return p(t,e,this,!0)},"Array, any":function(e,t){return p(r(e),t,this,!1).valueOf()},"any, Array":function(e,t){return p(r(t),e,this,!0).valueOf()}})});function Dr(e,t){var r=e.size(),n=t.size();if(r.length!==n.length)throw new z.a(r.length,n.length)}var Rr=["typed","config","matrix","BigNumber"],Pr=Object(s.a)("xgcd",Rr,function(e){var t=e.typed,p=e.config,m=e.matrix,h=e.BigNumber;return t("xgcd",{"number, number":function(e,t){var r=lt(e,t);return"Array"===p.matrix?r:m(r)},"BigNumber, BigNumber":function(e,t){var r,n,i,a,o=new h(0),s=new h(1),u=o,c=s,f=s,l=o;if(!e.isInt()||!t.isInt())throw new Error("Parameters in function xgcd must be integer numbers");for(;!t.isZero();)n=e.div(t).floor(),i=e.mod(t),r=u,u=c.minus(n.times(u)),c=r,r=f,f=l.minus(n.times(f)),l=r,e=t,t=i;a=e.lt(o)?[e.neg(),c.neg(),l.neg()]:[e,e.isZero()?0:c,l];return"Array"===p.matrix?a:m(a)}})}),Ur=["typed","equalScalar"],Fr=Object(s.a)("algorithm09",Ur,function(e){var q=e.typed,I=e.equalScalar;return function(e,t,r){var n=e._values,i=e._index,a=e._ptr,o=e._size,s=e._datatype,u=t._values,c=t._index,f=t._ptr,l=t._size,p=t._datatype;if(o.length!==l.length)throw new z.a(o.length,l.length);if(o[0]!==l[0]||o[1]!==l[1])throw new RangeError("Dimension mismatch. Matrix A ("+o+") must match Matrix B ("+l+")");var m,h=o[0],d=o[1],y=I,g=0,v=r;"string"==typeof s&&s===p&&(m=s,y=q.find(I,[m,m]),g=q.convert(0,m),v=q.find(r,[m,m]));for(var b,x,w,N=n&&u?[]:void 0,O=[],M=[],j=N?[]:void 0,E=[],S=0;S<d;S++){M[S]=O.length;var A=S+1;if(j)for(x=f[S],w=f[S+1],b=x;b<w;b++)E[_=c[b]]=A,j[_]=u[b];for(x=a[S],w=a[S+1],b=x;b<w;b++){var C,T,_=i[b];j?(C=E[_]===A?j[_]:g,y(T=v(n[b],C),g)||(O.push(_),N.push(T))):O.push(_)}}return M[d]=O.length,e.createSparseMatrix({values:N,index:O,ptr:M,size:[h,d],datatype:m})}}),Lr="dotMultiply",Hr=["typed","matrix","equalScalar","multiplyScalar"],$r=Object(s.a)(Lr,Hr,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.multiplyScalar,a=tr({typed:t,equalScalar:n}),o=Fr({typed:t,equalScalar:n}),s=ar({typed:t,equalScalar:n}),u=Wt({typed:t}),c=Xt({typed:t});return t(Lr,{"any, any":i,"SparseMatrix, SparseMatrix":function(e,t){return o(e,t,i,!1)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,i,!0)},"DenseMatrix, SparseMatrix":function(e,t){return a(e,t,i,!1)},"DenseMatrix, DenseMatrix":function(e,t){return u(e,t,i)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return s(e,t,i,!1)},"DenseMatrix, any":function(e,t){return c(e,t,i,!1)},"any, SparseMatrix":function(e,t){return s(t,e,i,!0)},"any, DenseMatrix":function(e,t){return c(t,e,i,!0)},"Array, any":function(e,t){return c(r(e),t,i,!1).valueOf()},"any, Array":function(e,t){return c(r(t),e,i,!0).valueOf()}})});function Gr(e,t){if(e.isFinite()&&!e.isInteger()||t.isFinite()&&!t.isInteger())throw new Error("Integers expected in function bitAnd");var r=e.constructor;if(e.isNaN()||t.isNaN())return new r(NaN);if(e.isZero()||t.eq(-1)||e.eq(t))return e;if(t.isZero()||e.eq(-1))return t;if(!e.isFinite()||!t.isFinite()){if(!e.isFinite()&&!t.isFinite())return e.isNegative()===t.isNegative()?e:new r(0);if(!e.isFinite())return t.isNegative()?e:e.isNegative()?new r(0):t;if(!t.isFinite())return e.isNegative()?t:t.isNegative()?new r(0):e}return Jr(e,t,function(e,t){return e&t})}function Zr(e){if(e.isFinite()&&!e.isInteger())throw new Error("Integer expected in function bitNot");var t=e.constructor,r=t.precision;t.config({precision:1e9});var n=e.plus(new t(1));return n.s=-n.s||null,t.config({precision:r}),n}function Vr(e,t){if(e.isFinite()&&!e.isInteger()||t.isFinite()&&!t.isInteger())throw new Error("Integers expected in function bitOr");var r=e.constructor;if(e.isNaN()||t.isNaN())return new r(NaN);var n=new r(-1);return e.isZero()||t.eq(n)||e.eq(t)?t:t.isZero()||e.eq(n)?e:e.isFinite()&&t.isFinite()?Jr(e,t,function(e,t){return e|t}):!e.isFinite()&&!e.isNegative()&&t.isNegative()||e.isNegative()&&!t.isNegative()&&!t.isFinite()?n:e.isNegative()&&t.isNegative()?e.isFinite()?e:t:e.isFinite()?t:e}function Jr(e,t,r){var n,i,a,o,s,u=e.constructor,c=+(e.s<0),f=+(t.s<0);if(c){n=Wr(Zr(e));for(var l=0;l<n.length;++l)n[l]^=1}else n=Wr(e);if(f){i=Wr(Zr(t));for(var p=0;p<i.length;++p)i[p]^=1}else i=Wr(t);s=n.length<=i.length?(a=n,o=i,c):(a=i,o=n,f);var m=a.length,h=o.length,d=1^r(c,f),y=new u(1^d),g=new u(1),v=new u(2),b=u.precision;for(u.config({precision:1e9});0<m;)r(a[--m],o[--h])===d&&(y=y.plus(g)),g=g.times(v);for(;0<h;)r(s,o[--h])===d&&(y=y.plus(g)),g=g.times(v);return u.config({precision:b}),0==d&&(y.s=-y.s),y}function Wr(e){for(var t=e.d,r=t[0]+"",n=1;n<t.length;++n){for(var i=t[n]+"",a=7-i.length;a--;)i="0"+i;r+=i}for(var o=r.length;"0"===r.charAt(o);)o--;var s=e.e,u=r.slice(0,o+1||1),c=u.length;if(0<s)if(++s>c)for(s-=c;s--;)u+="0";else s<c&&(u=u.slice(0,s)+"."+u.slice(s));for(var f=[0],l=0;l<u.length;){for(var p=f.length;p--;)f[p]*=10;f[0]+=parseInt(u.charAt(l++));for(var m=0;m<f.length;++m)1<f[m]&&(null!==f[m+1]&&void 0!==f[m+1]||(f[m+1]=0),f[m+1]+=f[m]>>1,f[m]&=1)}return f.reverse()}function Yr(e,t){if(e.isFinite()&&!e.isInteger()||t.isFinite()&&!t.isInteger())throw new Error("Integers expected in function bitXor");var r=e.constructor;if(e.isNaN()||t.isNaN())return new r(NaN);if(e.isZero())return t;if(t.isZero())return e;if(e.eq(t))return new r(0);var n=new r(-1);return e.eq(n)?Zr(t):t.eq(n)?Zr(e):e.isFinite()&&t.isFinite()?Jr(e,t,function(e,t){return e^t}):e.isFinite()||t.isFinite()?new r(e.isNegative()===t.isNegative()?1/0:-1/0):n}function Xr(e,t){if(e.isFinite()&&!e.isInteger()||t.isFinite()&&!t.isInteger())throw new Error("Integers expected in function leftShift");var r=e.constructor;return e.isNaN()||t.isNaN()||t.isNegative()&&!t.isZero()?new r(NaN):e.isZero()||t.isZero()?e:e.isFinite()||t.isFinite()?t.lt(55)?e.times(Math.pow(2,t.toNumber())+""):e.times(new r(2).pow(t)):new r(NaN)}function Qr(e,t){if(e.isFinite()&&!e.isInteger()||t.isFinite()&&!t.isInteger())throw new Error("Integers expected in function rightArithShift");var r=e.constructor;return e.isNaN()||t.isNaN()||t.isNegative()&&!t.isZero()?new r(NaN):e.isZero()||t.isZero()?e:t.isFinite()?t.lt(55)?e.div(Math.pow(2,t.toNumber())+"").floor():e.div(new r(2).pow(t)).floor():e.isNegative()?new r(-1):e.isFinite()?new r(0):new r(NaN)}var Kr="number, number";function en(e,t){if(!Object(E.i)(e)||!Object(E.i)(t))throw new Error("Integers expected in function bitAnd");return e&t}function tn(e){if(!Object(E.i)(e))throw new Error("Integer expected in function bitNot");return~e}function rn(e,t){if(!Object(E.i)(e)||!Object(E.i)(t))throw new Error("Integers expected in function bitOr");return e|t}function nn(e,t){if(!Object(E.i)(e)||!Object(E.i)(t))throw new Error("Integers expected in function bitXor");return e^t}function an(e,t){if(!Object(E.i)(e)||!Object(E.i)(t))throw new Error("Integers expected in function leftShift");return e<<t}function on(e,t){if(!Object(E.i)(e)||!Object(E.i)(t))throw new Error("Integers expected in function rightArithShift");return e>>t}function sn(e,t){if(!Object(E.i)(e)||!Object(E.i)(t))throw new Error("Integers expected in function rightLogShift");return e>>>t}en.signature=Kr,tn.signature="number",sn.signature=on.signature=an.signature=nn.signature=rn.signature=Kr;var un=["typed","matrix","equalScalar"],cn=Object(s.a)("bitAnd",un,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=tr({typed:t,equalScalar:n}),a=nr({typed:t,equalScalar:n}),o=ar({typed:t,equalScalar:n}),s=Wt({typed:t}),u=Xt({typed:t});return t("bitAnd",{"number, number":en,"BigNumber, BigNumber":Gr,"SparseMatrix, SparseMatrix":function(e,t){return a(e,t,this,!1)},"SparseMatrix, DenseMatrix":function(e,t){return i(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return i(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return s(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return o(e,t,this,!1)},"DenseMatrix, any":function(e,t){return u(e,t,this,!1)},"any, SparseMatrix":function(e,t){return o(t,e,this,!0)},"any, DenseMatrix":function(e,t){return u(t,e,this,!0)},"Array, any":function(e,t){return u(r(e),t,this,!1).valueOf()},"any, Array":function(e,t){return u(r(t),e,this,!0).valueOf()}})}),fn=["typed"],ln=Object(s.a)("bitNot",fn,function(e){return(0,e.typed)("bitNot",{number:tn,BigNumber:Zr,"Array | Matrix":function(e){return oe(e,this)}})}),pn=["typed","matrix","equalScalar","DenseMatrix"],mn=Object(s.a)("bitOr",pn,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.DenseMatrix,a=Ht({typed:t}),o=Gt({typed:t,equalScalar:n}),s=Vt({typed:t,DenseMatrix:i}),u=Wt({typed:t}),c=Xt({typed:t});return t("bitOr",{"number, number":rn,"BigNumber, BigNumber":Vr,"SparseMatrix, SparseMatrix":function(e,t){return o(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return a(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return u(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return s(e,t,this,!1)},"DenseMatrix, any":function(e,t){return c(e,t,this,!1)},"any, SparseMatrix":function(e,t){return s(t,e,this,!0)},"any, DenseMatrix":function(e,t){return c(t,e,this,!0)},"Array, any":function(e,t){return c(r(e),t,this,!1).valueOf()},"any, Array":function(e,t){return c(r(t),e,this,!0).valueOf()}})}),hn=["typed","DenseMatrix"],dn=Object(s.a)("algorithm07",hn,function(e){var N=e.typed,O=e.DenseMatrix;return function(e,t,r){var n=e._size,i=e._datatype,a=t._size,o=t._datatype;if(n.length!==a.length)throw new z.a(n.length,a.length);if(n[0]!==a[0]||n[1]!==a[1])throw new RangeError("Dimension mismatch. Matrix A ("+n+") must match Matrix B ("+a+")");var s,u=n[0],c=n[1],f=0,l=r;"string"==typeof i&&i===o&&(s=i,f=N.convert(0,s),l=N.find(r,[s,s]));for(var p=[],m=0;m<u;m++)p[m]=[];for(var h=[],d=[],y=[],g=[],v=0;v<c;v++){var b=v+1;for(M(e,v,y,h,b),M(t,v,g,d,b),m=0;m<u;m++){var x=y[m]===b?h[m]:f,w=g[m]===b?d[m]:f;p[m][v]=l(x,w)}}return new O({data:p,size:[u,c],datatype:s})};function M(e,t,r,n,i){for(var a=e._values,o=e._index,s=e._ptr,u=s[t],c=s[t+1];u<c;u++){var f=o[u];r[f]=i,n[f]=a[u]}}}),yn=["typed","matrix","DenseMatrix"],gn=Object(s.a)("bitXor",yn,function(e){var t=e.typed,r=e.matrix,n=e.DenseMatrix,i=mr({typed:t}),a=dn({typed:t,DenseMatrix:n}),o=gr({typed:t,DenseMatrix:n}),s=Wt({typed:t}),u=Xt({typed:t});return t("bitXor",{"number, number":nn,"BigNumber, BigNumber":Yr,"SparseMatrix, SparseMatrix":function(e,t){return a(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return i(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return i(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return s(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return o(e,t,this,!1)},"DenseMatrix, any":function(e,t){return u(e,t,this,!1)},"any, SparseMatrix":function(e,t){return o(t,e,this,!0)},"any, DenseMatrix":function(e,t){return u(t,e,this,!0)},"Array, any":function(e,t){return u(r(e),t,this,!1).valueOf()},"any, Array":function(e,t){return u(r(t),e,this,!0).valueOf()}})}),vn=["typed"],bn=Object(s.a)("arg",vn,function(e){return(0,e.typed)("arg",{number:function(e){return Math.atan2(0,e)},BigNumber:function(e){return e.constructor.atan2(0,e)},Complex:function(e){return e.arg()},"Array | Matrix":function(e){return oe(e,this)}})}),xn=["typed"],wn=Object(s.a)("conj",xn,function(e){return(0,e.typed)("conj",{number:function(e){return e},BigNumber:function(e){return e},Complex:function(e){return e.conjugate()},"Array | Matrix":function(e){return oe(e,this)}})}),Nn=["typed"],On=Object(s.a)("im",Nn,function(e){return(0,e.typed)("im",{number:function(){return 0},BigNumber:function(e){return e.mul(0)},Complex:function(e){return e.im},"Array | Matrix":function(e){return oe(e,this)}})}),Mn=["typed"],jn=Object(s.a)("re",Mn,function(e){return(0,e.typed)("re",{number:function(e){return e},BigNumber:function(e){return e},Complex:function(e){return e.re},"Array | Matrix":function(e){return oe(e,this)}})}),En="number, number";function Sn(e){return!e}function An(e,t){return!(!e&&!t)}function Cn(e,t){return!!e!=!!t}function Tn(e,t){return!(!e||!t)}Sn.signature="number",Tn.signature=Cn.signature=An.signature=En;var _n=["typed"],qn=Object(s.a)("not",_n,function(e){return(0,e.typed)("not",{number:Sn,Complex:function(e){return 0===e.re&&0===e.im},BigNumber:function(e){return e.isZero()||e.isNaN()},Unit:function(e){return null===e.value||this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),In=["typed","matrix","equalScalar","DenseMatrix"],kn=Object(s.a)("or",In,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.DenseMatrix,a=mr({typed:t}),o=dr({typed:t,equalScalar:n}),s=gr({typed:t,DenseMatrix:i}),u=Wt({typed:t}),c=Xt({typed:t});return t("or",{"number, number":An,"Complex, Complex":function(e,t){return 0!==e.re||0!==e.im||0!==t.re||0!==t.im},"BigNumber, BigNumber":function(e,t){return!e.isZero()&&!e.isNaN()||!t.isZero()&&!t.isNaN()},"Unit, Unit":function(e,t){return this(e.value||0,t.value||0)},"SparseMatrix, SparseMatrix":function(e,t){return o(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return a(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return u(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return s(e,t,this,!1)},"DenseMatrix, any":function(e,t){return c(e,t,this,!1)},"any, SparseMatrix":function(e,t){return s(t,e,this,!0)},"any, DenseMatrix":function(e,t){return c(t,e,this,!0)},"Array, any":function(e,t){return c(r(e),t,this,!1).valueOf()},"any, Array":function(e,t){return c(r(t),e,this,!0).valueOf()}})}),Bn=["typed","matrix","DenseMatrix"],zn=Object(s.a)("xor",Bn,function(e){var t=e.typed,r=e.matrix,n=e.DenseMatrix,i=mr({typed:t}),a=dn({typed:t,DenseMatrix:n}),o=gr({typed:t,DenseMatrix:n}),s=Wt({typed:t}),u=Xt({typed:t});return t("xor",{"number, number":Cn,"Complex, Complex":function(e,t){return(0!==e.re||0!==e.im)!=(0!==t.re||0!==t.im)},"BigNumber, BigNumber":function(e,t){return(!e.isZero()&&!e.isNaN())!=(!t.isZero()&&!t.isNaN())},"Unit, Unit":function(e,t){return this(e.value||0,t.value||0)},"SparseMatrix, SparseMatrix":function(e,t){return a(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return i(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return i(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return s(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return o(e,t,this,!1)},"DenseMatrix, any":function(e,t){return u(e,t,this,!1)},"any, SparseMatrix":function(e,t){return o(t,e,this,!0)},"any, DenseMatrix":function(e,t){return u(t,e,this,!0)},"Array, any":function(e,t){return u(r(e),t,this,!1).valueOf()},"any, Array":function(e,t){return u(r(t),e,this,!0).valueOf()}})}),Dn=["typed","matrix","isInteger"],Rn=Object(s.a)("concat",Dn,function(e){var t=e.typed,l=e.matrix,p=e.isInteger;return t("concat",{"...Array | Matrix | number | BigNumber":function(e){for(var t,r=e.length,n=-1,i=!1,a=[],o=0;o<r;o++){var s=e[o];if(Object(ie.v)(s)&&(i=!0),Object(ie.y)(s)||Object(ie.e)(s)){if(o!==r-1)throw new Error("Dimension must be specified as last argument");if(t=n,n=s.valueOf(),!p(n))throw new TypeError("Integer number expected for dimension");if(n<0||0<o&&t<n)throw new R.a(n,t+1)}else{var u=Object(ae.a)(s).valueOf(),c=Object(q.a)(u);if(a[o]=u,t=n,n=c.length-1,0<o&&n!==t)throw new z.a(t+1,n+1)}}if(0===a.length)throw new SyntaxError("At least one matrix expected");for(var f=a.shift();a.length;)f=function e(t,r,n,i){{if(i<n){if(t.length!==r.length)throw new z.a(t.length,r.length);for(var a=[],o=0;o<t.length;o++)a[o]=e(t[o],r[o],n,i+1);return a}return t.concat(r)}}(f,a.shift(),n,0);return i?l(f):f},"...string":function(e){return e.join("")}})});var Pn=["typed","Index","matrix","range"],Un=Object(s.a)("column",Pn,function(e){var t=e.typed,i=e.Index,r=e.matrix,a=e.range;return t("column",{"Matrix, number":n,"Array, number":function(e,t){return n(r(Object(ae.a)(e)),t).valueOf()}});function n(e,t){if(2!==e.size().length)throw new Error("Only two dimensional matrix is supported");Object(q.q)(t,e.size()[1]);var r=a(0,e.size()[0]),n=new i(r,t);return e.subset(n)}}),Fn=["typed","matrix","subtract","multiply"],Ln=Object(s.a)("cross",Fn,function(e){var t=e.typed,r=e.matrix,o=e.subtract,s=e.multiply;return t("cross",{"Matrix, Matrix":function(e,t){return r(n(e.toArray(),t.toArray()))},"Matrix, Array":function(e,t){return r(n(e.toArray(),t))},"Array, Matrix":function(e,t){return r(n(e,t.toArray()))},"Array, Array":n});function n(e,t){var r=Math.max(Object(q.a)(e).length,Object(q.a)(t).length);e=Object(q.n)(e),t=Object(q.n)(t);var n=Object(q.a)(e),i=Object(q.a)(t);if(1!==n.length||1!==i.length||3!==n[0]||3!==i[0])throw new RangeError("Vectors with length 3 expected (Size A = ["+n.join(", ")+"], B = ["+i.join(", ")+"])");var a=[o(s(e[1],t[2]),s(e[2],t[1])),o(s(e[2],t[0]),s(e[0],t[2])),o(s(e[0],t[1]),s(e[1],t[0]))];return 1<r?[a]:a}}),Hn=["typed","matrix","DenseMatrix","SparseMatrix"],$n=Object(s.a)("diag",Hn,function(e){var t=e.typed,f=e.matrix,u=e.DenseMatrix,c=e.SparseMatrix;return t("diag",{Array:function(e){return n(e,0,Object(q.a)(e),null)},"Array, number":function(e,t){return n(e,t,Object(q.a)(e),null)},"Array, BigNumber":function(e,t){return n(e,t.toNumber(),Object(q.a)(e),null)},"Array, string":function(e,t){return n(e,0,Object(q.a)(e),t)},"Array, number, string":function(e,t,r){return n(e,t,Object(q.a)(e),r)},"Array, BigNumber, string":function(e,t,r){return n(e,t.toNumber(),Object(q.a)(e),r)},Matrix:function(e){return n(e,0,e.size(),e.storage())},"Matrix, number":function(e,t){return n(e,t,e.size(),e.storage())},"Matrix, BigNumber":function(e,t){return n(e,t.toNumber(),e.size(),e.storage())},"Matrix, string":function(e,t){return n(e,0,e.size(),t)},"Matrix, number, string":function(e,t,r){return n(e,t,e.size(),r)},"Matrix, BigNumber, string":function(e,t,r){return n(e,t.toNumber(),e.size(),r)}});function n(e,t,r,n){if(!Object(E.i)(t))throw new TypeError("Second parameter in function diag must be an integer");var i=0<t?t:0,a=t<0?-t:0;switch(r.length){case 1:return function(e,t,r,n,i,a){var o=[n+i,n+a];if(r&&"sparse"!==r&&"dense"!==r)throw new TypeError("Unknown matrix type ".concat(r,'"'));var s="sparse"===r?c.diagonal(o,e,t):u.diagonal(o,e,t);return null!==r?s:s.valueOf()}(e,t,n,r[0],a,i);case 2:return function(e,t,r,n,i,a){if(Object(ie.v)(e)){var o=e.diagonal(t);return null!==r?r!==o.storage()?f(o,r):o:o.valueOf()}for(var s=Math.min(n[0]-i,n[1]-a),u=[],c=0;c<s;c++)u[c]=e[c+i][c+a];return null!==r?f(u):u}(e,t,n,r,a,i)}throw new RangeError("Matrix for function diag must be 2 dimensional")}});function Gn(e){return(Gn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Zn(i,a){return function e(){"object"!==Gn(e.cache)&&(e.cache={});for(var t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];var n=a?a(t):JSON.stringify(t);return n in e.cache||(e.cache[n]=i.apply(i,t)),e.cache[n]}}function Vn(e){return Object.keys(e.signatures||{}).reduce(function(e,t){var r=(t.match(/,/g)||[]).length+1;return Math.max(e,r)},-1)}var Jn=["typed"],Wn=Object(s.a)("filter",Jn,function(e){return(0,e.typed)("filter",{"Array, function":Yn,"Matrix, function":function(e,t){return e.create(Yn(e.toArray(),t))},"Array, RegExp":q.d,"Matrix, RegExp":function(e,t){return e.create(Object(q.d)(e.toArray(),t))}})});function Yn(e,n){var i=Vn(n);return Object(q.c)(e,function(e,t,r){return 1===i?n(e):2===i?n(e,[t]):n(e,[t],r)})}var Xn="flatten",Qn=["typed","matrix"],Kn=Object(s.a)(Xn,Qn,function(e){var t=e.typed,r=e.matrix;return t(Xn,{Array:function(e){return Object(q.e)(Object(ae.a)(e))},Matrix:function(e){var t=Object(q.e)(Object(ae.a)(e.toArray()));return r(t)}})}),ei="forEach",ti=["typed"],ri=Object(s.a)(ei,ti,function(e){return(0,e.typed)(ei,{"Array, function":ni,"Matrix, function":function(e,t){return e.forEach(t)}})});function ni(t,i){var a=Vn(i);!function r(e,n){Array.isArray(e)?Object(q.f)(e,function(e,t){r(e,n.concat(t))}):1===a?i(e):2===a?i(e,n):i(e,n,t)}(t,[])}var ii="getMatrixDataType",ai=["typed"],oi=Object(s.a)(ii,ai,function(e){return(0,e.typed)(ii,{Array:function(e){return Object(q.h)(e,ie.M)},Matrix:function(e){return e.getDataType()}})}),si="identity",ui=["typed","config","matrix","BigNumber","DenseMatrix","SparseMatrix"],ci=Object(s.a)(si,ui,function(e){var t=e.typed,r=e.config,n=e.matrix,f=e.BigNumber,l=e.DenseMatrix,p=e.SparseMatrix;return t(si,{"":function(){return"Matrix"===r.matrix?n([]):[]},string:function(e){return n(e)},"number | BigNumber":function(e){return a(e,e,"Matrix"===r.matrix?"dense":void 0)},"number | BigNumber, string":function(e,t){return a(e,e,t)},"number | BigNumber, number | BigNumber":function(e,t){return a(e,t,"Matrix"===r.matrix?"dense":void 0)},"number | BigNumber, number | BigNumber, string":a,Array:function(e){return i(e)},"Array, string":i,Matrix:function(e){return i(e.valueOf(),e.storage())},"Matrix, string":function(e,t){return i(e.valueOf(),t)}});function i(e,t){switch(e.length){case 0:return t?n(t):[];case 1:return a(e[0],e[0],t);case 2:return a(e[0],e[1],t);default:throw new Error("Vector containing two values expected")}}function a(e,t,r){var n=Object(ie.e)(e)||Object(ie.e)(t)?f:null;if(Object(ie.e)(e)&&(e=e.toNumber()),Object(ie.e)(t)&&(t=t.toNumber()),!Object(E.i)(e)||e<1)throw new Error("Parameters in function identity must be positive integers");if(!Object(E.i)(t)||t<1)throw new Error("Parameters in function identity must be positive integers");var i=n?new f(1):1,a=n?new n(0):0,o=[e,t];if(r){if("sparse"===r)return p.diagonal(o,i,0,a);if("dense"===r)return l.diagonal(o,i,0,a);throw new TypeError('Unknown matrix type "'.concat(r,'"'))}for(var s=Object(q.m)([],o,a),u=e<t?e:t,c=0;c<u;c++)s[c][c]=i;return s}}),fi=["typed","matrix","multiplyScalar"],li=Object(s.a)("kron",fi,function(e){var t=e.typed,r=e.matrix,a=e.multiplyScalar;return t("kron",{"Matrix, Matrix":function(e,t){return r(n(e.toArray(),t.toArray()))},"Matrix, Array":function(e,t){return r(n(e.toArray(),t))},"Array, Matrix":function(e,t){return r(n(e,t.toArray()))},"Array, Array":n});function n(e,r){if(1===Object(q.a)(e).length&&(e=[e]),1===Object(q.a)(r).length&&(r=[r]),2<Object(q.a)(e).length||2<Object(q.a)(r).length)throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = "+JSON.stringify(e.length)+", y = "+JSON.stringify(r.length)+")");var n=[],i=[];return e.map(function(t){return r.map(function(e){return i=[],n.push(i),t.map(function(t){return e.map(function(e){return i.push(a(t,e))})})})})&&n}}),pi=["typed"],mi=Object(s.a)("map",pi,function(e){return(0,e.typed)("map",{"Array, function":hi,"Matrix, function":function(e,t){return e.map(t)}})});function hi(t,i){var a=Vn(i);return function r(e,n){return Array.isArray(e)?e.map(function(e,t){return r(e,n.concat(t))}):1===a?i(e):2===a?i(e,n):i(e,n,t)}(t,[])}var di=["typed","config","matrix","BigNumber"],yi=Object(s.a)("ones",di,function(e){var t=e.typed,r=e.config,o=e.matrix,s=e.BigNumber;return t("ones",{"":function(){return"Array"===r.matrix?n([]):n([],"default")},"...number | BigNumber | string":function(e){if("string"!=typeof e[e.length-1])return"Array"===r.matrix?n(e):n(e,"default");var t=e.pop();return n(e,t)},Array:n,Matrix:function(e){var t=e.storage();return n(e.valueOf(),t)},"Array | Matrix, string":function(e,t){return n(e.valueOf(),t)}});function n(e,t){var n,r=(n=!1,e.forEach(function(e,t,r){Object(ie.e)(e)&&(n=!0,r[t]=e.toNumber())}),n)?new s(1):1;if(e.forEach(function(e){if("number"!=typeof e||!Object(E.i)(e)||e<0)throw new Error("Parameters in function ones must be positive integers")}),t){var i=o(t);return 0<e.length?i.resize(e,r):i}var a=[];return 0<e.length?Object(q.m)(a,e,r):a}});function gi(){throw new Error('No "bignumber" implementation available')}function vi(){throw new Error('No "fraction" implementation available')}function bi(){throw new Error('No "matrix" implementation available')}var xi=["typed","config","?matrix","?bignumber","smaller","smallerEq","larger","largerEq"],wi=Object(s.a)("range",xi,function(e){var t=e.typed,n=e.config,r=e.matrix,o=e.bignumber,s=e.smaller,u=e.smallerEq,c=e.larger,f=e.largerEq;return t("range",{string:a,"string, boolean":a,"number, number":function(e,t){return i(l(e,t,1))},"number, number, number":function(e,t,r){return i(l(e,t,r))},"number, number, boolean":function(e,t,r){return i((r?p:l)(e,t,1))},"number, number, number, boolean":function(e,t,r,n){return i((n?p:l)(e,t,r))},"BigNumber, BigNumber":function(e,t){return i(m(e,t,new e.constructor(1)))},"BigNumber, BigNumber, BigNumber":function(e,t,r){return i(m(e,t,r))},"BigNumber, BigNumber, boolean":function(e,t,r){var n=e.constructor;return i((r?h:m)(e,t,new n(1)))},"BigNumber, BigNumber, BigNumber, boolean":function(e,t,r,n){return i((n?h:m)(e,t,r))}});function i(e){return"Matrix"===n.matrix?r?r(e):bi():e}function a(e,t){var r=function(e){var t=e.split(":").map(function(e){return Number(e)});if(t.some(function(e){return isNaN(e)}))return null;switch(t.length){case 2:return{start:t[0],end:t[1],step:1};case 3:return{start:t[0],end:t[2],step:t[1]};default:return null}}(e);if(!r)throw new SyntaxError('String "'+e+'" is no valid range');return"BigNumber"===n.number?(void 0===o&&gi(),i((t?h:m)(o(r.start),o(r.end),o(r.step)))):i((t?p:l)(r.start,r.end,r.step))}function l(e,t,r){var n=[],i=e;if(0<r)for(;s(i,t);)n.push(i),i+=r;else if(r<0)for(;c(i,t);)n.push(i),i+=r;return n}function p(e,t,r){var n=[],i=e;if(0<r)for(;u(i,t);)n.push(i),i+=r;else if(r<0)for(;f(i,t);)n.push(i),i+=r;return n}function m(e,t,r){var n=o(0),i=[],a=e;if(r.gt(n))for(;s(a,t);)i.push(a),a=a.plus(r);else if(r.lt(n))for(;c(a,t);)i.push(a),a=a.plus(r);return i}function h(e,t,r){var n=o(0),i=[],a=e;if(r.gt(n))for(;u(a,t);)i.push(a),a=a.plus(r);else if(r.lt(n))for(;f(a,t);)i.push(a),a=a.plus(r);return i}}),Ni="reshape",Oi=["typed","isInteger","matrix"],Mi=Object(s.a)(Ni,Oi,function(e){var t=e.typed,r=e.isInteger,n=e.matrix;return t(Ni,{"Matrix, Array":function(e,t){return e.reshape?e.reshape(t):n(Object(q.l)(e.valueOf(),t))},"Array, Array":function(e,t){return t.forEach(function(e){if(!r(e))throw new TypeError("Invalid size for dimension: "+e)}),Object(q.l)(e,t)}})}),ji=r(12),Ei=["config","matrix"],Si=Object(s.a)("resize",Ei,function(e){var a=e.config,o=e.matrix;return function(e,t,r){if(2!==arguments.length&&3!==arguments.length)throw new ji.a("resize",arguments.length,2,3);if(Object(ie.v)(t)&&(t=t.valueOf()),Object(ie.e)(t[0])&&(t=t.map(function(e){return Object(ie.e)(e)?e.toNumber():e})),Object(ie.v)(e))return e.resize(t,r,!0);if("string"==typeof e)return function(e,t,r){if(void 0!==r){if("string"!=typeof r||1!==r.length)throw new TypeError("Single character expected as defaultValue")}else r=" ";if(1!==t.length)throw new z.a(t.length,1);var n=t[0];if("number"!=typeof n||!Object(E.i)(n))throw new TypeError("Invalid size, must contain positive integers (size: "+Object(V.d)(t)+")");{if(e.length>n)return e.substring(0,n);if(e.length<n){for(var i=e,a=0,o=n-e.length;a<o;a++)i+=r;return i}return e}}(e,t,r);var n=!Array.isArray(e)&&"Array"!==a.matrix;if(0===t.length){for(;Array.isArray(e);)e=e[0];return Object(ae.a)(e)}Array.isArray(e)||(e=[e]),e=Object(ae.a)(e);var i=Object(q.m)(e,t,r);return n?o(i):i}}),Ai=["typed","Index","matrix","range"],Ci=Object(s.a)("row",Ai,function(e){var t=e.typed,i=e.Index,r=e.matrix,a=e.range;return t("row",{"Matrix, number":n,"Array, number":function(e,t){return n(r(Object(ae.a)(e)),t).valueOf()}});function n(e,t){if(2!==e.size().length)throw new Error("Only two dimensional matrix is supported");Object(q.q)(t,e.size()[0]);var r=a(0,e.size()[1]),n=new i(t,r);return e.subset(n)}}),Ti=["typed","config","?matrix"],_i=Object(s.a)("size",Ti,function(e){var t=e.typed,r=e.config,n=e.matrix;return t("size",{Matrix:function(e){return e.create(e.size())},Array:q.a,string:function(e){return"Array"===r.matrix?[e.length]:n([e.length])},"number | Complex | BigNumber | Unit | boolean | null":function(){return"Array"===r.matrix?[]:n?n([]):bi()}})}),qi="squeeze",Ii=["typed","matrix"],ki=Object(s.a)(qi,Ii,function(e){var t=e.typed,r=e.matrix;return t(qi,{Array:function(e){return Object(q.n)(Object(ae.a)(e))},Matrix:function(e){var t=Object(q.n)(e.toArray());return Array.isArray(t)?r(t):t},any:function(e){return Object(ae.a)(e)}})});function Bi(e){return(Bi="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function zi(e,t){if(Ui(e)&&Ri(e,t))return e[t];if("function"==typeof e[t]&&Pi(e,t))throw new Error('Cannot access method "'+t+'" as a property');throw new Error('No access to property "'+t+'"')}function Di(e,t,r){if(Ui(e)&&Ri(e,t))return e[t]=r;throw new Error('No access to property "'+t+'"')}function Ri(e,t){if(e&&"object"===Bi(e)){if(Object(ae.f)(Fi,t))return 1;if(!(t in Object.prototype||t in Function.prototype))return 1}}function Pi(e,t){if(null!=e&&"function"==typeof e[t]&&!(Object(ae.f)(e,t)&&Object.getPrototypeOf&&t in Object.getPrototypeOf(e))){if(Object(ae.f)(Li,t))return 1;if(!(t in Object.prototype||t in Function.prototype))return 1}}function Ui(e){return"object"===Bi(e)&&e&&e.constructor===Object}var Fi={length:!0,name:!0},Li={toString:!0,valueOf:!0,toLocaleString:!0},Hi=["typed","matrix"],$i=Object(s.a)("subset",Hi,function(e){var t=e.typed,i=e.matrix;return t("subset",{"Array, Index":function(e,t){var r=i(e).subset(t);return t.isScalar()?r:r.valueOf()},"Matrix, Index":function(e,t){return e.subset(t)},"Object, Index":Vi,"string, Index":Gi,"Array, Index, any":function(e,t,r){return i(Object(ae.a)(e)).subset(t,r,void 0).valueOf()},"Array, Index, any, any":function(e,t,r,n){return i(Object(ae.a)(e)).subset(t,r,n).valueOf()},"Matrix, Index, any":function(e,t,r){return e.clone().subset(t,r)},"Matrix, Index, any, any":function(e,t,r,n){return e.clone().subset(t,r,n)},"string, Index, string":Zi,"string, Index, string, string":Zi,"Object, Index, any":Ji})});function Gi(t,e){if(!Object(ie.t)(e))throw new TypeError("Index expected");if(1!==e.size().length)throw new z.a(e.size().length,1);var r=t.length;Object(q.q)(e.min()[0],r),Object(q.q)(e.max()[0],r);var n=e.dimension(0),i="";return n.forEach(function(e){i+=t.charAt(e)}),i}function Zi(e,t,r,n){if(!t||!0!==t.isIndex)throw new TypeError("Index expected");if(1!==t.size().length)throw new z.a(t.size().length,1);if(void 0!==n){if("string"!=typeof n||1!==n.length)throw new TypeError("Single character expected as defaultValue")}else n=" ";var i=t.dimension(0);if(i.size()[0]!==r.length)throw new z.a(i.size()[0],r.length);var a=e.length;Object(q.q)(t.min()[0]),Object(q.q)(t.max()[0]);for(var o=[],s=0;s<a;s++)o[s]=e.charAt(s);if(i.forEach(function(e,t){o[e]=r.charAt(t[0])}),o.length>a)for(var u=a-1,c=o.length;u<c;u++)o[u]||(o[u]=n);return o.join("")}function Vi(e,t){if(1!==t.size().length)throw new z.a(t.size(),1);var r=t.dimension(0);if("string"!=typeof r)throw new TypeError("String expected as index to retrieve an object property");return zi(e,r)}function Ji(e,t,r){if(1!==t.size().length)throw new z.a(t.size(),1);var n=t.dimension(0);if("string"!=typeof n)throw new TypeError("String expected as index to retrieve an object property");var i=Object(ae.a)(e);return Di(i,n,r),i}var Wi=["typed","matrix"],Yi=Object(s.a)("transpose",Wi,function(e){var t=e.typed,r=e.matrix;return t("transpose",{Array:function(e){return this(r(e)).valueOf()},Matrix:function(e){var t,r=e.size();switch(r.length){case 1:t=e.clone();break;case 2:var n=r[0],i=r[1];if(0===i)throw new RangeError("Cannot transpose a 2D matrix with no columns (size: "+Object(V.d)(r)+")");switch(e.storage()){case"dense":t=function(e,t,r){for(var n,i=e._data,a=[],o=0;o<r;o++){n=a[o]=[];for(var s=0;s<t;s++)n[s]=Object(ae.a)(i[s][o])}return e.createDenseMatrix({data:a,size:[r,t],datatype:e._datatype})}(e,n,i);break;case"sparse":t=function(e,t,r){for(var n,i,a,o=e._values,s=e._index,u=e._ptr,c=o?[]:void 0,f=[],l=[],p=[],m=0;m<t;m++)p[m]=0;for(n=0,i=s.length;n<i;n++)p[s[n]]++;for(var h=0,d=0;d<t;d++)l.push(h),h+=p[d],p[d]=l[d];for(l.push(h),a=0;a<r;a++)for(var y=u[a],g=u[a+1],v=y;v<g;v++){var b=p[s[v]]++;f[b]=a,o&&(c[b]=Object(ae.a)(o[v]))}return e.createSparseMatrix({values:c,index:f,ptr:l,size:[r,t],datatype:e._datatype})}(e,n,i)}break;default:throw new RangeError("Matrix must be a vector or two dimensional (size: "+Object(V.d)(this._size)+")")}return t},any:function(e){return Object(ae.a)(e)}})}),Xi="ctranspose",Qi=["typed","transpose","conj"],Ki=Object(s.a)(Xi,Qi,function(e){var t=e.typed,r=e.transpose,n=e.conj;return t(Xi,{any:function(e){return n(r(e))}})}),ea=["typed","config","matrix","BigNumber"],ta=Object(s.a)("zeros",ea,function(e){var t=e.typed,r=e.config,o=e.matrix,s=e.BigNumber;return t("zeros",{"":function(){return"Array"===r.matrix?n([]):n([],"default")},"...number | BigNumber | string":function(e){if("string"!=typeof e[e.length-1])return"Array"===r.matrix?n(e):n(e,"default");var t=e.pop();return n(e,t)},Array:n,Matrix:function(e){var t=e.storage();return n(e.valueOf(),t)},"Array | Matrix, string":function(e,t){return n(e.valueOf(),t)}});function n(e,t){var n,r=(n=!1,e.forEach(function(e,t,r){Object(ie.e)(e)&&(n=!0,r[t]=e.toNumber())}),n)?new s(0):0;if(e.forEach(function(e){if("number"!=typeof e||!Object(E.i)(e)||e<0)throw new Error("Parameters in function zeros must be positive integers")}),t){var i=o(t);return 0<e.length?i.resize(e,r):i}var a=[];return 0<e.length?Object(q.m)(a,e,r):a}}),ra=["typed"],na=Object(s.a)("erf",ra,function(e){return(0,e.typed)("name",{number:function(e){var t=Math.abs(e);return ua<=t?Object(E.n)(e):t<=ia?Object(E.n)(e)*function(e){var t,r=e*e,n=oa[0][4]*r,i=r;for(t=0;t<3;t+=1)n=(n+oa[0][t])*r,i=(i+sa[0][t])*r;return e*(n+oa[0][3])/(i+sa[0][3])}(t):t<=4?Object(E.n)(e)*(1-function(e){var t,r=oa[1][8]*e,n=e;for(t=0;t<7;t+=1)r=(r+oa[1][t])*e,n=(n+sa[1][t])*e;var i=(r+oa[1][7])/(n+sa[1][7]),a=parseInt(16*e)/16,o=(e-a)*(e+a);return Math.exp(-a*a)*Math.exp(-o)*i}(t)):Object(E.n)(e)*(1-function(e){var t,r=1/(e*e),n=oa[2][5]*r,i=r;for(t=0;t<4;t+=1)n=(n+oa[2][t])*r,i=(i+sa[2][t])*r;var a=r*(n+oa[2][4])/(i+sa[2][4]);a=(aa-a)/e,r=parseInt(16*e)/16;var o=(e-r)*(e+r);return Math.exp(-r*r)*Math.exp(-o)*a}(t))},"Array | Matrix":function(e){return oe(e,this)}})}),ia=.46875,aa=.5641895835477563,oa=[[3.1611237438705655,113.86415415105016,377.485237685302,3209.3775891384694,.18577770618460315],[.5641884969886701,8.883149794388377,66.11919063714163,298.6351381974001,881.952221241769,1712.0476126340707,2051.0783778260716,1230.3393547979972,2.1531153547440383e-8],[.30532663496123236,.36034489994980445,.12578172611122926,.016083785148742275,.0006587491615298378,.016315387137302097]],sa=[[23.601290952344122,244.02463793444417,1282.6165260773723,2844.236833439171],[15.744926110709835,117.6939508913125,537.1811018620099,1621.3895745666903,3290.7992357334597,4362.619090143247,3439.3676741437216,1230.3393548037495],[2.568520192289822,1.8729528499234604,.5279051029514285,.06051834131244132,.0023352049762686918]],ua=Math.pow(2,53),ca=["typed","isNaN","isNumeric"],fa=Object(s.a)("mode",ca,function(e){var t=e.typed,o=e.isNaN,s=e.isNumeric;return t("mode",{"Array | Matrix":r,"...":r});function r(e){if(0===(e=Object(q.e)(e.valueOf())).length)throw new Error("Cannot calculate mode of an empty array");for(var t={},r=[],n=0,i=0;i<e.length;i++){var a=e[i];if(s(a)&&o(a))throw new Error("Cannot calculate mode of an array containing NaN values");a in t||(t[a]=0),t[a]++,t[a]===n?r.push(a):t[a]>n&&(n=t[a],r=[a])}return r}});function la(e,t,r){var n;return-1!==String(e).indexOf("Unexpected type")?(n=2<arguments.length?" (type: "+Object(ie.M)(r)+", value: "+JSON.stringify(r)+")":" (type: "+e.data.actual+")",new TypeError("Cannot calculate "+t+", unexpected type of argument"+n)):-1!==String(e).indexOf("complex numbers")?(n=2<arguments.length?" (type: "+Object(ie.M)(r)+", value: "+JSON.stringify(r)+")":"",new TypeError("Cannot calculate "+t+", no ordering relation is defined for complex numbers"+n)):e}var pa=["typed","config","multiplyScalar","numeric"],ma=Object(s.a)("prod",pa,function(e){var t=e.typed,n=e.config,i=e.multiplyScalar,a=e.numeric;return t("prod",{"Array | Matrix":r,"Array | Matrix, number | BigNumber":function(){throw new Error("prod(A, dim) is not yet supported")},"...":r});function r(e){var r;if(U(e,function(t){try{r=void 0===r?t:i(r,t)}catch(e){throw la(e,"prod",t)}}),"string"==typeof r&&(r=a(r,n.number)),void 0===r)throw new Error("Cannot calculate prod of an empty array");return r}}),ha=["typed"],da=Object(s.a)("format",ha,function(e){return(0,e.typed)("format",{any:V.d,"any, Object | function | number":V.d})}),ya=["typed"],ga=Object(s.a)("print",ya,function(e){return(0,e.typed)("print",{"string, Object | Array":va,"string, Object | Array, number | Object":va})});function va(e,a,o){return e.replace(/\$([\w.]+)/g,function(e,t){for(var r=t.split("."),n=a[r.shift()];r.length&&void 0!==n;)var i=r.shift(),n=i?n[i]:n+".";return void 0!==n?Object(ie.I)(n)?n:Object(V.d)(n,o):e})}var ba=["typed","matrix"],xa=Object(s.a)("to",ba,function(e){var t=e.typed,r=e.matrix,n=Wt({typed:t}),i=Xt({typed:t});return t("to",{"Unit, Unit | string":function(e,t){return e.to(t)},"Matrix, Matrix":function(e,t){return n(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"Matrix, any":function(e,t){return i(e,t,this,!1)},"any, Matrix":function(e,t){return i(t,e,this,!0)},"Array, any":function(e,t){return i(r(e),t,this,!1).valueOf()},"any, Array":function(e,t){return i(r(t),e,this,!0).valueOf()}})}),wa="isPrime",Na=["typed"],Oa=Object(s.a)(wa,Na,function(e){return(0,e.typed)(wa,{number:function(e){if(0*e!=0)return!1;if(e<=3)return 1<e;if(e%2==0||e%3==0)return!1;for(var t=5;t*t<=e;t+=6)if(e%t==0||e%(t+2)==0)return!1;return!0},BigNumber:function(e){if(0*e.toNumber()!=0)return!1;if(e.lte(3))return e.gt(1);if(e.mod(2).eq(0)||e.mod(3).eq(0))return!1;for(var t=5;e.gte(t*t);t+=6)if(e.mod(t).eq(0)||e.mod(t+2).eq(0))return!1;return!0},"Array | Matrix":function(e){return oe(e,this)}})}),Ma=["number","?bignumber","?fraction"],ja=Object(s.a)("numeric",Ma,function(e){var t=e.number,r=e.bignumber,n=e.fraction,i={string:!0,number:!0,BigNumber:!0,Fraction:!0},a={number:function(e){return t(e)},BigNumber:r?function(e){return r(e)}:gi,Fraction:n?function(e){return n(e)}:vi};return function(e,t){var r=Object(ie.M)(e);if(!(r in i))throw new TypeError("Cannot convert "+e+' of type "'+r+'"; valid input types are '+Object.keys(i).join(", "));if(!(t in a))throw new TypeError("Cannot convert "+e+' to type "'+t+'"; valid output types are '+Object.keys(a).join(", "));return t===r?e:a[t](e)}}),Ea="divideScalar",Sa=["typed","numeric"],Aa=Object(s.a)(Ea,Sa,function(e){var t=e.typed,i=e.numeric;return t(Ea,{"number, number":function(e,t){return e/t},"Complex, Complex":function(e,t){return e.div(t)},"BigNumber, BigNumber":function(e,t){return e.div(t)},"Fraction, Fraction":function(e,t){return e.div(t)},"Unit, number | Fraction | BigNumber":function(e,t){var r=e.clone(),n=i(1,Object(ie.M)(t));return r.value=this(null===r.value?r._normalize(n):r.value,t),r},"number | Fraction | BigNumber, Unit":function(e,t){var r=(r=t.clone()).pow(-1),n=i(1,Object(ie.M)(e));return r.value=this(e,null===t.value?t._normalize(n):t.value),r},"Unit, Unit":function(e,t){return e.divide(t)}})}),Ca=["typed","config","identity","multiply","matrix","fraction","number","Complex"],Ta=Object(s.a)("pow",Ca,function(e){var t=e.typed,i=e.config,a=e.identity,o=e.multiply,r=e.matrix,s=e.number,u=e.fraction,c=e.Complex;return t("pow",{"number, number":n,"Complex, Complex":function(e,t){return e.pow(t)},"BigNumber, BigNumber":function(e,t){return t.isInteger()||0<=e||i.predictable?e.pow(t):new c(e.toNumber(),0).pow(t.toNumber(),0)},"Fraction, Fraction":function(e,t){if(1===t.d)return e.pow(t);if(i.predictable)throw new Error("Function pow does not support non-integer exponents for fractions.");return n(e.valueOf(),t.valueOf())},"Array, number":f,"Array, BigNumber":function(e,t){return f(e,t.toNumber())},"Matrix, number":l,"Matrix, BigNumber":function(e,t){return l(e,t.toNumber())},"Unit, number | BigNumber":function(e,t){return e.pow(t)}});function n(e,t){if(i.predictable&&!Object(E.i)(t)&&e<0)try{var r=u(t),n=s(r);if((t===n||Math.abs((t-n)/t)<1e-14)&&r.d%2==1)return(r.n%2==0?1:-1)*Math.pow(-e,t)}catch(e){}return i.predictable&&(e<-1&&t===1/0||-1<e&&e<0&&t===-1/0)?NaN:Object(E.i)(t)||0<=e||i.predictable?pt(e,t):e*e<1&&t===1/0||1<e*e&&t===-1/0?0:new c(e,0).pow(t,0)}function f(e,t){if(!Object(E.i)(t)||t<0)throw new TypeError("For A^b, b must be a positive integer (value is "+t+")");var r=Object(q.a)(e);if(2!==r.length)throw new Error("For A^b, A must be 2 dimensional (A has "+r.length+" dimensions)");if(r[0]!==r[1])throw new Error("For A^b, A must be square (size is "+r[0]+"x"+r[1]+")");for(var n=a(r[0]).valueOf(),i=e;1<=t;)1==(1&t)&&(n=o(i,n)),t>>=1,i=o(i,i);return n}function l(e,t){return r(f(e.valueOf(),t))}});function _a(t,e){var r,n=Object.keys(t);return Object.getOwnPropertySymbols&&(r=Object.getOwnPropertySymbols(t),e&&(r=r.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,r)),n}function qa(i){for(var e=1;e<arguments.length;e++){var a=null!=arguments[e]?arguments[e]:{};e%2?_a(Object(a),!0).forEach(function(e){var t,r,n;t=i,n=a[r=e],r in t?Object.defineProperty(t,r,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[r]=n}):Object.getOwnPropertyDescriptors?Object.defineProperties(i,Object.getOwnPropertyDescriptors(a)):_a(Object(a)).forEach(function(e){Object.defineProperty(i,e,Object.getOwnPropertyDescriptor(a,e))})}return i}var Ia="Number of decimals in function round must be an integer",ka="round",Ba=["typed","matrix","equalScalar","zeros","BigNumber","DenseMatrix"],za=Object(s.a)(ka,Ba,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.zeros,a=e.BigNumber,o=e.DenseMatrix,s=ar({typed:t,equalScalar:n}),u=gr({typed:t,DenseMatrix:o}),c=Xt({typed:t});return t(ka,qa(qa({},Da),{},{Complex:function(e){return e.round()},"Complex, number":function(e,t){if(t%1)throw new TypeError(Ia);return e.round(t)},"Complex, BigNumber":function(e,t){if(!t.isInteger())throw new TypeError(Ia);var r=t.toNumber();return e.round(r)},"number, BigNumber":function(e,t){if(!t.isInteger())throw new TypeError(Ia);return new a(e).toDecimalPlaces(t.toNumber())},BigNumber:function(e){return e.toDecimalPlaces(0)},"BigNumber, BigNumber":function(e,t){if(!t.isInteger())throw new TypeError(Ia);return e.toDecimalPlaces(t.toNumber())},Fraction:function(e){return e.round()},"Fraction, number":function(e,t){if(t%1)throw new TypeError(Ia);return e.round(t)},"Array | Matrix":function(e){return oe(e,this,!0)},"SparseMatrix, number | BigNumber":function(e,t){return s(e,t,this,!1)},"DenseMatrix, number | BigNumber":function(e,t){return c(e,t,this,!1)},"number | Complex | BigNumber, SparseMatrix":function(e,t){return n(e,0)?i(t.size(),t.storage()):u(t,e,this,!0)},"number | Complex | BigNumber, DenseMatrix":function(e,t){return n(e,0)?i(t.size(),t.storage()):c(t,e,this,!0)},"Array, number | BigNumber":function(e,t){return c(r(e),t,this,!1).valueOf()},"number | Complex | BigNumber, Array":function(e,t){return c(r(t),e,this,!0).valueOf()}}))}),Da={number:mt,"number, number":function(e,t){if(!Object(E.i)(t))throw new TypeError(Ia);if(t<0||15<t)throw new Error("Number of decimals in function round must be in te range of 0-15");return mt(e,t)}},Ra=["config","typed","divideScalar","Complex"],Pa=Object(s.a)("log",Ra,function(e){var t=e.typed,r=e.config,n=e.divideScalar,i=e.Complex;return t("log",{number:function(e){return 0<=e||r.predictable?it(e):new i(e,0).log()},Complex:function(e){return e.log()},BigNumber:function(e){return!e.isNegative()||r.predictable?e.ln():new i(e.toNumber(),0).log()},"Array | Matrix":function(e){return oe(e,this)},"any, any":function(e,t){return n(this(e),this(t))}})}),Ua=["typed","config","divideScalar","log","Complex"],Fa=Object(s.a)("log1p",Ua,function(e){var t=e.typed,r=e.config,n=e.divideScalar,i=e.log,a=e.Complex;return t("log1p",{number:function(e){return-1<=e||r.predictable?Object(E.k)(e):o(new a(e,0))},Complex:o,BigNumber:function(e){var t=e.plus(1);return!t.isNegative()||r.predictable?t.ln():o(new a(e.toNumber(),0))},"Array | Matrix":function(e){return oe(e,this)},"any, any":function(e,t){return n(this(e),i(t))}});function o(e){var t=e.re+1;return new a(Math.log(Math.sqrt(t*t+e.im*e.im)),Math.atan2(e.im,t))}}),La="nthRoots",Ha=["config","typed","divideScalar","Complex"],$a=Object(s.a)(La,Ha,function(e){var t=e.typed,f=(e.config,e.divideScalar,e.Complex),l=[function(e){return new f(e,0)},function(e){return new f(0,e)},function(e){return new f(-e,0)},function(e){return new f(0,-e)}];function r(e,t){if(t<0)throw new Error("Root must be greater than zero");if(0===t)throw new Error("Root must be non-zero");if(t%1!=0)throw new Error("Root must be an integer");if(0===e||0===e.abs())return[new f(0,0)];var r,n="number"==typeof e;!n&&0!==e.re&&0!==e.im||(r=n?2*(e<0):0===e.im?2*(e.re<0):2*(e.im<0)+1);for(var i=e.arg(),a=e.abs(),o=[],s=Math.pow(a,1/t),u=0;u<t;u++){var c=(r+4*u)/t;c!==Math.round(c)?o.push(new f({r:s,phi:(i+2*Math.PI*u)/t})):o.push(l[c%4](s))}return o}return t(La,{Complex:function(e){return r(e,2)},"Complex, number":r})}),Ga=["typed","equalScalar","matrix","pow","DenseMatrix"],Za=Object(s.a)("dotPow",Ga,function(e){var t=e.typed,r=e.equalScalar,n=e.matrix,i=e.pow,a=e.DenseMatrix,o=mr({typed:t}),s=dn({typed:t,DenseMatrix:a}),u=ar({typed:t,equalScalar:r}),c=gr({typed:t,DenseMatrix:a}),f=Wt({typed:t}),l=Xt({typed:t});return t("dotPow",{"any, any":i,"SparseMatrix, SparseMatrix":function(e,t){return s(e,t,i,!1)},"SparseMatrix, DenseMatrix":function(e,t){return o(t,e,i,!0)},"DenseMatrix, SparseMatrix":function(e,t){return o(e,t,i,!1)},"DenseMatrix, DenseMatrix":function(e,t){return f(e,t,i)},"Array, Array":function(e,t){return this(n(e),n(t)).valueOf()},"Array, Matrix":function(e,t){return this(n(e),t)},"Matrix, Array":function(e,t){return this(e,n(t))},"SparseMatrix, any":function(e,t){return u(e,t,this,!1)},"DenseMatrix, any":function(e,t){return l(e,t,this,!1)},"any, SparseMatrix":function(e,t){return c(t,e,this,!0)},"any, DenseMatrix":function(e,t){return l(t,e,this,!0)},"Array, any":function(e,t){return l(n(e),t,this,!1).valueOf()},"any, Array":function(e,t){return l(n(t),e,this,!0).valueOf()}})}),Va="dotDivide",Ja=["typed","matrix","equalScalar","divideScalar","DenseMatrix"],Wa=Object(s.a)(Va,Ja,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.divideScalar,a=e.DenseMatrix,o=tr({typed:t,equalScalar:n}),s=mr({typed:t}),u=dn({typed:t,DenseMatrix:a}),c=ar({typed:t,equalScalar:n}),f=gr({typed:t,DenseMatrix:a}),l=Wt({typed:t}),p=Xt({typed:t});return t(Va,{"any, any":i,"SparseMatrix, SparseMatrix":function(e,t){return u(e,t,i,!1)},"SparseMatrix, DenseMatrix":function(e,t){return o(t,e,i,!0)},"DenseMatrix, SparseMatrix":function(e,t){return s(e,t,i,!1)},"DenseMatrix, DenseMatrix":function(e,t){return l(e,t,i)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return c(e,t,i,!1)},"DenseMatrix, any":function(e,t){return p(e,t,i,!1)},"any, SparseMatrix":function(e,t){return f(t,e,i,!0)},"any, DenseMatrix":function(e,t){return p(t,e,i,!0)},"Array, any":function(e,t){return p(r(e),t,i,!1).valueOf()},"any, Array":function(e,t){return p(r(t),e,i,!0).valueOf()}})});function Ya(e){var d=e.DenseMatrix;return function(e,t,r){var n=e.size();if(2!==n.length)throw new RangeError("Matrix must be two dimensional (size: "+Object(V.d)(n)+")");var i,a,o,s=n[0];if(s!==n[1])throw new RangeError("Matrix must be square (size: "+Object(V.d)(n)+")");if(Object(ie.v)(t)){var u=t.size();if(1===u.length){if(u[0]!==s)throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");for(i=[],o=t._data,a=0;a<s;a++)i[a]=[o[a]];return new d({data:i,size:[s,1],datatype:t._datatype})}if(2!==u.length)throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");if(u[0]!==s||1!==u[1])throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");if(Object(ie.n)(t)){if(r){for(i=[],o=t._data,a=0;a<s;a++)i[a]=[o[a][0]];return new d({data:i,size:[s,1],datatype:t._datatype})}return t}for(i=[],a=0;a<s;a++)i[a]=[0];for(var c=t._values,f=t._index,l=t._ptr,p=l[1],m=l[0];m<p;m++)i[a=f[m]][0]=c[m];return new d({data:i,size:[s,1],datatype:t._datatype})}if(Object(ie.b)(t)){var h=Object(q.a)(t);if(1===h.length){if(h[0]!==s)throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");for(i=[],a=0;a<s;a++)i[a]=[t[a]];return new d({data:i,size:[s,1]})}if(2!==h.length)throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");if(h[0]!==s||1!==h[1])throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");for(i=[],a=0;a<s;a++)i[a]=[t[a][0]];return new d({data:i,size:[s,1]})}}}var Xa=["typed","matrix","divideScalar","multiplyScalar","subtract","equalScalar","DenseMatrix"],Qa=Object(s.a)("lsolve",Xa,function(e){var t=e.typed,r=e.matrix,v=e.divideScalar,b=e.multiplyScalar,x=e.subtract,w=e.equalScalar,N=e.DenseMatrix,O=Ya({DenseMatrix:N});return t("lsolve",{"SparseMatrix, Array | Matrix":function(e,t){for(var r,n,i=(t=O(e,t,!0))._data,a=e._size[0],o=e._size[1],s=e._values,u=e._index,c=e._ptr,f=[],l=0;l<o;l++){var p=i[l][0]||0;if(w(p,0))f[l]=[0];else{var m=0,h=[],d=[],y=c[l+1];for(n=c[l];n<y;n++)(r=u[n])===l?m=s[n]:l<r&&(h.push(s[n]),d.push(r));if(w(m,0))throw new Error("Linear system cannot be solved since matrix is singular");var g=v(p,m);for(n=0,y=d.length;n<y;n++)r=d[n],i[r]=[x(i[r][0]||0,b(g,h[n]))];f[l]=[g]}}return new N({data:f,size:[a,1]})},"DenseMatrix, Array | Matrix":n,"Array, Array | Matrix":function(e,t){return n(r(e),t).valueOf()}});function n(e,t){for(var r=(t=O(e,t,!0))._data,n=e._size[0],i=e._size[1],a=[],o=e._data,s=0;s<i;s++){var u=r[s][0]||0,c=void 0;if(w(u,0))c=0;else{var f=o[s][s];if(w(f,0))throw new Error("Linear system cannot be solved since matrix is singular");c=v(u,f);for(var l=s+1;l<n;l++)r[l]=[x(r[l][0]||0,b(c,o[l][s]))]}a[s]=[c]}return new N({data:a,size:[n,1]})}}),Ka=["typed","matrix","divideScalar","multiplyScalar","subtract","equalScalar","DenseMatrix"],eo=Object(s.a)("usolve",Ka,function(e){var t=e.typed,r=e.matrix,b=e.divideScalar,x=e.multiplyScalar,w=e.subtract,N=e.equalScalar,O=e.DenseMatrix,M=Ya({DenseMatrix:O});return t("usolve",{"SparseMatrix, Array | Matrix":function(e,t){for(var r,n,i=(t=M(e,t,!0))._data,a=e._size[0],o=e._size[1],s=e._values,u=e._index,c=e._ptr,f=[],l=o-1;0<=l;l--){var p=i[l][0]||0;if(N(p,0))f[l]=[0];else{var m=0,h=[],d=[],y=c[l],g=c[l+1];for(n=g-1;y<=n;n--)(r=u[n])===l?m=s[n]:r<l&&(h.push(s[n]),d.push(r));if(N(m,0))throw new Error("Linear system cannot be solved since matrix is singular");var v=b(p,m);for(n=0,g=d.length;n<g;n++)r=d[n],i[r]=[w(i[r][0],x(v,h[n]))];f[l]=[v]}}return new O({data:f,size:[a,1]})},"DenseMatrix, Array | Matrix":n,"Array, Array | Matrix":function(e,t){return n(r(e),t).valueOf()}});function n(e,t){for(var r=(t=M(e,t,!0))._data,n=e._size[0],i=e._size[1],a=[],o=e._data,s=i-1;0<=s;s--){var u=r[s][0]||0,c=void 0;if(N(u,0))c=0;else{var f=o[s][s];if(N(f,0))throw new Error("Linear system cannot be solved since matrix is singular");c=b(u,f);for(var l=s-1;0<=l;l--)r[l]=[w(r[l][0]||0,x(c,o[l][s]))]}a[s]=[c]}return new O({data:a,size:[n,1]})}}),to=["typed","equalScalar"],ro=Object(s.a)("algorithm08",to,function(e){var _=e.typed,q=e.equalScalar;return function(e,t,r){var n=e._values,i=e._index,a=e._ptr,o=e._size,s=e._datatype,u=t._values,c=t._index,f=t._ptr,l=t._size,p=t._datatype;if(o.length!==l.length)throw new z.a(o.length,l.length);if(o[0]!==l[0]||o[1]!==l[1])throw new RangeError("Dimension mismatch. Matrix A ("+o+") must match Matrix B ("+l+")");if(!n||!u)throw new Error("Cannot perform operation on Pattern Sparse Matrices");var m,h=o[0],d=o[1],y=q,g=0,v=r;"string"==typeof s&&s===p&&(m=s,y=_.find(q,[m,m]),g=_.convert(0,m),v=_.find(r,[m,m]));for(var b,x=[],w=[],N=[],O=[],M=[],j=0;j<d;j++){N[j]=w.length;for(var E=j+1,S=a[j],A=a[j+1],C=S;C<A;C++)M[b=i[C]]=E,O[b]=n[C],w.push(b);for(S=f[j],A=f[j+1],C=S;C<A;C++)M[b=c[C]]===E&&(O[b]=v(O[b],u[C]));for(C=N[j];C<w.length;){var T=O[b=w[C]];y(T,g)?w.splice(C,1):(x.push(T),C++)}}return N[d]=w.length,e.createSparseMatrix({values:x,index:w,ptr:N,size:[h,d],datatype:m})}}),no="leftShift",io=["typed","matrix","equalScalar","zeros","DenseMatrix"],ao=Object(s.a)(no,io,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.zeros,a=e.DenseMatrix,o=Ht({typed:t}),s=tr({typed:t,equalScalar:n}),u=ro({typed:t,equalScalar:n}),c=Vt({typed:t,DenseMatrix:a}),f=ar({typed:t,equalScalar:n}),l=Wt({typed:t}),p=Xt({typed:t});return t(no,{"number, number":an,"BigNumber, BigNumber":Xr,"SparseMatrix, SparseMatrix":function(e,t){return u(e,t,this,!1)},"SparseMatrix, DenseMatrix":function(e,t){return s(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return o(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return l(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, number | BigNumber":function(e,t){return n(t,0)?e.clone():f(e,t,this,!1)},"DenseMatrix, number | BigNumber":function(e,t){return n(t,0)?e.clone():p(e,t,this,!1)},"number | BigNumber, SparseMatrix":function(e,t){return n(e,0)?i(t.size(),t.storage()):c(t,e,this,!0)},"number | BigNumber, DenseMatrix":function(e,t){return n(e,0)?i(t.size(),t.storage()):p(t,e,this,!0)},"Array, number | BigNumber":function(e,t){return this(r(e),t).valueOf()},"number | BigNumber, Array":function(e,t){return this(e,r(t)).valueOf()}})}),oo="rightArithShift",so=["typed","matrix","equalScalar","zeros","DenseMatrix"],uo=Object(s.a)(oo,so,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.zeros,a=e.DenseMatrix,o=Ht({typed:t}),s=tr({typed:t,equalScalar:n}),u=ro({typed:t,equalScalar:n}),c=Vt({typed:t,DenseMatrix:a}),f=ar({typed:t,equalScalar:n}),l=Wt({typed:t}),p=Xt({typed:t});return t(oo,{"number, number":on,"BigNumber, BigNumber":Qr,"SparseMatrix, SparseMatrix":function(e,t){return u(e,t,this,!1)},"SparseMatrix, DenseMatrix":function(e,t){return s(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return o(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return l(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, number | BigNumber":function(e,t){return n(t,0)?e.clone():f(e,t,this,!1)},"DenseMatrix, number | BigNumber":function(e,t){return n(t,0)?e.clone():p(e,t,this,!1)},"number | BigNumber, SparseMatrix":function(e,t){return n(e,0)?i(t.size(),t.storage()):c(t,e,this,!0)},"number | BigNumber, DenseMatrix":function(e,t){return n(e,0)?i(t.size(),t.storage()):p(t,e,this,!0)},"Array, number | BigNumber":function(e,t){return this(r(e),t).valueOf()},"number | BigNumber, Array":function(e,t){return this(e,r(t)).valueOf()}})}),co="rightLogShift",fo=["typed","matrix","equalScalar","zeros","DenseMatrix"],lo=Object(s.a)(co,fo,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.zeros,a=e.DenseMatrix,o=Ht({typed:t}),s=tr({typed:t,equalScalar:n}),u=ro({typed:t,equalScalar:n}),c=Vt({typed:t,DenseMatrix:a}),f=ar({typed:t,equalScalar:n}),l=Wt({typed:t}),p=Xt({typed:t});return t(co,{"number, number":sn,"SparseMatrix, SparseMatrix":function(e,t){return u(e,t,this,!1)},"SparseMatrix, DenseMatrix":function(e,t){return s(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return o(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return l(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, number | BigNumber":function(e,t){return n(t,0)?e.clone():f(e,t,this,!1)},"DenseMatrix, number | BigNumber":function(e,t){return n(t,0)?e.clone():p(e,t,this,!1)},"number | BigNumber, SparseMatrix":function(e,t){return n(e,0)?i(t.size(),t.storage()):c(t,e,this,!0)},"number | BigNumber, DenseMatrix":function(e,t){return n(e,0)?i(t.size(),t.storage()):p(t,e,this,!0)},"Array, number | BigNumber":function(e,t){return this(r(e),t).valueOf()},"number | BigNumber, Array":function(e,t){return this(e,r(t)).valueOf()}})}),po=["typed","matrix","equalScalar","zeros","not"],mo=Object(s.a)("and",po,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.zeros,a=e.not,o=tr({typed:t,equalScalar:n}),s=nr({typed:t,equalScalar:n}),u=ar({typed:t,equalScalar:n}),c=Wt({typed:t}),f=Xt({typed:t});return t("and",{"number, number":Tn,"Complex, Complex":function(e,t){return!(0===e.re&&0===e.im||0===t.re&&0===t.im)},"BigNumber, BigNumber":function(e,t){return!(e.isZero()||t.isZero()||e.isNaN()||t.isNaN())},"Unit, Unit":function(e,t){return this(e.value||0,t.value||0)},"SparseMatrix, SparseMatrix":function(e,t){return s(e,t,this,!1)},"SparseMatrix, DenseMatrix":function(e,t){return o(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return o(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return c(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return a(t)?i(e.size(),e.storage()):u(e,t,this,!1)},"DenseMatrix, any":function(e,t){return a(t)?i(e.size(),e.storage()):f(e,t,this,!1)},"any, SparseMatrix":function(e,t){return a(e)?i(e.size(),e.storage()):u(t,e,this,!0)},"any, DenseMatrix":function(e,t){return a(e)?i(e.size(),e.storage()):f(t,e,this,!0)},"Array, any":function(e,t){return this(r(e),t).valueOf()},"any, Array":function(e,t){return this(e,r(t)).valueOf()}})}),ho="compare",yo=["typed","config","matrix","equalScalar","BigNumber","Fraction","DenseMatrix"],go=Object(s.a)(ho,yo,function(e){var t=e.typed,r=e.config,n=e.equalScalar,i=e.matrix,a=e.BigNumber,o=e.Fraction,s=e.DenseMatrix,u=mr({typed:t}),c=dr({typed:t,equalScalar:n}),f=gr({typed:t,DenseMatrix:s}),l=Wt({typed:t}),p=Xt({typed:t});return t(ho,{"boolean, boolean":function(e,t){return e===t?0:t<e?1:-1},"number, number":function(e,t){return Object(E.m)(e,t,r.epsilon)?0:t<e?1:-1},"BigNumber, BigNumber":function(e,t){return xe(e,t,r.epsilon)?new a(0):new a(e.cmp(t))},"Fraction, Fraction":function(e,t){return new o(e.compare(t))},"Complex, Complex":function(){throw new TypeError("No ordering relation is defined for complex numbers")},"Unit, Unit":function(e,t){if(!e.equalBase(t))throw new Error("Cannot compare units with different base");return this(e.value,t.value)},"SparseMatrix, SparseMatrix":function(e,t){return c(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return u(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return u(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return l(e,t,this)},"Array, Array":function(e,t){return this(i(e),i(t)).valueOf()},"Array, Matrix":function(e,t){return this(i(e),t)},"Matrix, Array":function(e,t){return this(e,i(t))},"SparseMatrix, any":function(e,t){return f(e,t,this,!1)},"DenseMatrix, any":function(e,t){return p(e,t,this,!1)},"any, SparseMatrix":function(e,t){return f(t,e,this,!0)},"any, DenseMatrix":function(e,t){return p(t,e,this,!0)},"Array, any":function(e,t){return p(i(e),t,this,!1).valueOf()},"any, Array":function(e,t){return p(i(t),e,this,!0).valueOf()}})}),vo=r(11),bo=r.n(vo),xo="compareNatural",wo=["typed","compare"],No=Object(s.a)(xo,wo,function(e){var t=e.typed,a=e.compare,o=a.signatures["boolean,boolean"];return t(xo,{"any, any":function(e,t){var r,n=Object(ie.M)(e),i=Object(ie.M)(t);if(!("number"!==n&&"BigNumber"!==n&&"Fraction"!==n||"number"!==i&&"BigNumber"!==i&&"Fraction"!==i))return"0"!==(r=a(e,t)).toString()?0<r?1:-1:bo()(n,i);if("Array"===n||"Matrix"===n||"Array"===i||"Matrix"===i)return 0!==(r=function e(t,r,n){if(Object(ie.H)(r)&&Object(ie.H)(n))return u(t,r.toJSON().values,n.toJSON().values);if(Object(ie.H)(r))return e(t,r.toArray(),n);if(Object(ie.H)(n))return e(t,r,n.toArray());if(Object(ie.n)(r))return e(t,r.toJSON().data,n);if(Object(ie.n)(n))return e(t,r,n.toJSON().data);if(!Array.isArray(r))return e(t,[r],n);if(!Array.isArray(n))return e(t,r,[n]);return u(t,r,n)}(this,e,t))?r:bo()(n,i);if(n!==i)return bo()(n,i);if("Complex"===n)return function(e,t){if(e.re>t.re)return 1;if(e.re<t.re)return-1;if(e.im>t.im)return 1;if(e.im<t.im)return-1;return 0}(e,t);if("Unit"===n)return e.equalBase(t)?this(e.value,t.value):u(this,e.formatUnits(),t.formatUnits());if("boolean"===n)return o(e,t);if("string"===n)return bo()(e,t);if("Object"===n)return function(e,t,r){var n=Object.keys(t),i=Object.keys(r);n.sort(bo.a),i.sort(bo.a);var a=u(e,n,i);if(0!==a)return a;for(var o=0;o<n.length;o++){var s=e(t[n[o]],r[i[o]]);if(0!==s)return s}return 0}(this,e,t);if("null"===n)return 0;if("undefined"===n)return 0;throw new TypeError('Unsupported type of value "'+n+'"')}});function u(e,t,r){for(var n=0,i=Math.min(t.length,r.length);n<i;n++){var a=e(t[n],r[n]);if(0!==a)return a}return t.length>r.length?1:t.length<r.length?-1:0}});var Oo="compareText",Mo=["typed","matrix"],jo=Object(s.a)(Oo,Mo,function(e){var t=e.typed,r=e.matrix,n=Wt({typed:t}),i=Xt({typed:t});return t(Oo,{"any, any":V.a,"DenseMatrix, DenseMatrix":function(e,t){return n(e,t,V.a)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"DenseMatrix, any":function(e,t){return i(e,t,V.a,!1)},"any, DenseMatrix":function(e,t){return i(t,e,V.a,!0)},"Array, any":function(e,t){return i(r(e),t,V.a,!1).valueOf()},"any, Array":function(e,t){return i(r(t),e,V.a,!0).valueOf()}})}),Eo="equal",So=["typed","matrix","equalScalar","DenseMatrix"],Ao=Object(s.a)(Eo,So,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.DenseMatrix,a=mr({typed:t}),o=dn({typed:t,DenseMatrix:i}),s=gr({typed:t,DenseMatrix:i}),u=Wt({typed:t}),c=Xt({typed:t});return t(Eo,{"any, any":function(e,t){return null===e?null===t:null===t?null===e:void 0===e?void 0===t:void 0===t?void 0===e:n(e,t)},"SparseMatrix, SparseMatrix":function(e,t){return o(e,t,n)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,n,!0)},"DenseMatrix, SparseMatrix":function(e,t){return a(e,t,n,!1)},"DenseMatrix, DenseMatrix":function(e,t){return u(e,t,n)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, any":function(e,t){return s(e,t,n,!1)},"DenseMatrix, any":function(e,t){return c(e,t,n,!1)},"any, SparseMatrix":function(e,t){return s(t,e,n,!0)},"any, DenseMatrix":function(e,t){return c(t,e,n,!0)},"Array, any":function(e,t){return c(r(e),t,n,!1).valueOf()},"any, Array":function(e,t){return c(r(t),e,n,!0).valueOf()}})}),Co=(Object(s.a)(Eo,["typed","equalScalar"],function(e){var t=e.typed,r=e.equalScalar;return t(Eo,{"any, any":function(e,t){return null===e?null===t:null===t?null===e:void 0===e?void 0===t:void 0===t?void 0===e:r(e,t)}})}),"equalText"),To=["typed","compareText","isZero"],_o=Object(s.a)(Co,To,function(e){var t=e.typed,r=e.compareText,n=e.isZero;return t(Co,{"any, any":function(e,t){return n(r(e,t))}})}),qo="smaller",Io=["typed","config","matrix","DenseMatrix"],ko=Object(s.a)(qo,Io,function(e){var t=e.typed,r=e.config,n=e.matrix,i=e.DenseMatrix,a=mr({typed:t}),o=dn({typed:t,DenseMatrix:i}),s=gr({typed:t,DenseMatrix:i}),u=Wt({typed:t}),c=Xt({typed:t});return t(qo,{"boolean, boolean":function(e,t){return e<t},"number, number":function(e,t){return e<t&&!Object(E.m)(e,t,r.epsilon)},"BigNumber, BigNumber":function(e,t){return e.lt(t)&&!xe(e,t,r.epsilon)},"Fraction, Fraction":function(e,t){return-1===e.compare(t)},"Complex, Complex":function(){throw new TypeError("No ordering relation is defined for complex numbers")},"Unit, Unit":function(e,t){if(!e.equalBase(t))throw new Error("Cannot compare units with different base");return this(e.value,t.value)},"SparseMatrix, SparseMatrix":function(e,t){return o(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return a(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return u(e,t,this)},"Array, Array":function(e,t){return this(n(e),n(t)).valueOf()},"Array, Matrix":function(e,t){return this(n(e),t)},"Matrix, Array":function(e,t){return this(e,n(t))},"SparseMatrix, any":function(e,t){return s(e,t,this,!1)},"DenseMatrix, any":function(e,t){return c(e,t,this,!1)},"any, SparseMatrix":function(e,t){return s(t,e,this,!0)},"any, DenseMatrix":function(e,t){return c(t,e,this,!0)},"Array, any":function(e,t){return c(n(e),t,this,!1).valueOf()},"any, Array":function(e,t){return c(n(t),e,this,!0).valueOf()}})}),Bo="smallerEq",zo=["typed","config","matrix","DenseMatrix"],Do=Object(s.a)(Bo,zo,function(e){var t=e.typed,r=e.config,n=e.matrix,i=e.DenseMatrix,a=mr({typed:t}),o=dn({typed:t,DenseMatrix:i}),s=gr({typed:t,DenseMatrix:i}),u=Wt({typed:t}),c=Xt({typed:t});return t(Bo,{"boolean, boolean":function(e,t){return e<=t},"number, number":function(e,t){return e<=t||Object(E.m)(e,t,r.epsilon)},"BigNumber, BigNumber":function(e,t){return e.lte(t)||xe(e,t,r.epsilon)},"Fraction, Fraction":function(e,t){return 1!==e.compare(t)},"Complex, Complex":function(){throw new TypeError("No ordering relation is defined for complex numbers")},"Unit, Unit":function(e,t){if(!e.equalBase(t))throw new Error("Cannot compare units with different base");return this(e.value,t.value)},"SparseMatrix, SparseMatrix":function(e,t){return o(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return a(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return u(e,t,this)},"Array, Array":function(e,t){return this(n(e),n(t)).valueOf()},"Array, Matrix":function(e,t){return this(n(e),t)},"Matrix, Array":function(e,t){return this(e,n(t))},"SparseMatrix, any":function(e,t){return s(e,t,this,!1)},"DenseMatrix, any":function(e,t){return c(e,t,this,!1)},"any, SparseMatrix":function(e,t){return s(t,e,this,!0)},"any, DenseMatrix":function(e,t){return c(t,e,this,!0)},"Array, any":function(e,t){return c(n(e),t,this,!1).valueOf()},"any, Array":function(e,t){return c(n(t),e,this,!0).valueOf()}})}),Ro="larger",Po=["typed","config","matrix","DenseMatrix"],Uo=Object(s.a)(Ro,Po,function(e){var t=e.typed,r=e.config,n=e.matrix,i=e.DenseMatrix,a=mr({typed:t}),o=dn({typed:t,DenseMatrix:i}),s=gr({typed:t,DenseMatrix:i}),u=Wt({typed:t}),c=Xt({typed:t});return t(Ro,{"boolean, boolean":function(e,t){return t<e},"number, number":function(e,t){return t<e&&!Object(E.m)(e,t,r.epsilon)},"BigNumber, BigNumber":function(e,t){return e.gt(t)&&!xe(e,t,r.epsilon)},"Fraction, Fraction":function(e,t){return 1===e.compare(t)},"Complex, Complex":function(){throw new TypeError("No ordering relation is defined for complex numbers")},"Unit, Unit":function(e,t){if(!e.equalBase(t))throw new Error("Cannot compare units with different base");return this(e.value,t.value)},"SparseMatrix, SparseMatrix":function(e,t){return o(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return a(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return u(e,t,this)},"Array, Array":function(e,t){return this(n(e),n(t)).valueOf()},"Array, Matrix":function(e,t){return this(n(e),t)},"Matrix, Array":function(e,t){return this(e,n(t))},"SparseMatrix, any":function(e,t){return s(e,t,this,!1)},"DenseMatrix, any":function(e,t){return c(e,t,this,!1)},"any, SparseMatrix":function(e,t){return s(t,e,this,!0)},"any, DenseMatrix":function(e,t){return c(t,e,this,!0)},"Array, any":function(e,t){return c(n(e),t,this,!1).valueOf()},"any, Array":function(e,t){return c(n(t),e,this,!0).valueOf()}})}),Fo="largerEq",Lo=["typed","config","matrix","DenseMatrix"],Ho=Object(s.a)(Fo,Lo,function(e){var t=e.typed,r=e.config,n=e.matrix,i=e.DenseMatrix,a=mr({typed:t}),o=dn({typed:t,DenseMatrix:i}),s=gr({typed:t,DenseMatrix:i}),u=Wt({typed:t}),c=Xt({typed:t});return t(Fo,{"boolean, boolean":function(e,t){return t<=e},"number, number":function(e,t){return t<=e||Object(E.m)(e,t,r.epsilon)},"BigNumber, BigNumber":function(e,t){return e.gte(t)||xe(e,t,r.epsilon)},"Fraction, Fraction":function(e,t){return-1!==e.compare(t)},"Complex, Complex":function(){throw new TypeError("No ordering relation is defined for complex numbers")},"Unit, Unit":function(e,t){if(!e.equalBase(t))throw new Error("Cannot compare units with different base");return this(e.value,t.value)},"SparseMatrix, SparseMatrix":function(e,t){return o(e,t,this)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return a(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return u(e,t,this)},"Array, Array":function(e,t){return this(n(e),n(t)).valueOf()},"Array, Matrix":function(e,t){return this(n(e),t)},"Matrix, Array":function(e,t){return this(e,n(t))},"SparseMatrix, any":function(e,t){return s(e,t,this,!1)},"DenseMatrix, any":function(e,t){return c(e,t,this,!1)},"any, SparseMatrix":function(e,t){return s(t,e,this,!0)},"any, DenseMatrix":function(e,t){return c(t,e,this,!0)},"Array, any":function(e,t){return c(n(e),t,this,!1).valueOf()},"any, Array":function(e,t){return c(n(t),e,this,!0).valueOf()}})}),$o="deepEqual",Go=["typed","equal"],Zo=Object(s.a)($o,Go,function(e){var t=e.typed,a=e.equal;return t($o,{"any, any":function(e,t){return function e(t,r){{if(Array.isArray(t)){if(Array.isArray(r)){var n=t.length;if(n!==r.length)return!1;for(var i=0;i<n;i++)if(!e(t[i],r[i]))return!1;return!0}return!1}return!Array.isArray(r)&&a(t,r)}}(e.valueOf(),t.valueOf())}})}),Vo="unequal",Jo=["typed","config","equalScalar","matrix","DenseMatrix"],Wo=Object(s.a)(Vo,Jo,function(e){var t=e.typed,r=(e.config,e.equalScalar),n=e.matrix,i=e.DenseMatrix,a=mr({typed:t}),o=dn({typed:t,DenseMatrix:i}),s=gr({typed:t,DenseMatrix:i}),u=Wt({typed:t}),c=Xt({typed:t});return t("unequal",{"any, any":function(e,t){return null===e?null!==t:null===t?null!==e:void 0===e?void 0!==t:void 0===t?void 0!==e:f(e,t)},"SparseMatrix, SparseMatrix":function(e,t){return o(e,t,f)},"SparseMatrix, DenseMatrix":function(e,t){return a(t,e,f,!0)},"DenseMatrix, SparseMatrix":function(e,t){return a(e,t,f,!1)},"DenseMatrix, DenseMatrix":function(e,t){return u(e,t,f)},"Array, Array":function(e,t){return this(n(e),n(t)).valueOf()},"Array, Matrix":function(e,t){return this(n(e),t)},"Matrix, Array":function(e,t){return this(e,n(t))},"SparseMatrix, any":function(e,t){return s(e,t,f,!1)},"DenseMatrix, any":function(e,t){return c(e,t,f,!1)},"any, SparseMatrix":function(e,t){return s(t,e,f,!0)},"any, DenseMatrix":function(e,t){return c(t,e,f,!0)},"Array, any":function(e,t){return c(n(e),t,f,!1).valueOf()},"any, Array":function(e,t){return c(n(t),e,f,!0).valueOf()}});function f(e,t){return!r(e,t)}}),Yo=(Object(s.a)(Vo,["typed","equalScalar"],function(e){var t=e.typed,r=e.equalScalar;return t(Vo,{"any, any":function(e,t){return null===e?null!==t:null===t?null!==e:void 0===e?void 0!==t:void 0===t?void 0!==e:!r(e,t)}})}),"partitionSelect"),Xo=["typed","isNumeric","isNaN","compare"],Qo=Object(s.a)(Yo,Xo,function(e){function n(e,t){return-r(e,t)}var t=e.typed,f=e.isNumeric,l=e.isNaN,r=e.compare,i=r;return t(Yo,{"Array | Matrix, number":function(e,t){return a(e,t,i)},"Array | Matrix, number, string":function(e,t,r){if("asc"===r)return a(e,t,i);if("desc"===r)return a(e,t,n);throw new Error('Compare string must be "asc" or "desc"')},"Array | Matrix, number, function":a});function a(e,t,r){if(!Object(E.i)(t)||t<0)throw new Error("k must be a non-negative integer");if(Object(ie.v)(e)){if(1<e.size().length)throw new Error("Only one dimensional matrices supported");return o(e.valueOf(),t,r)}if(Array.isArray(e))return o(e,t,r)}function o(e,t,r){if(t>=e.length)throw new Error("k out of bounds");for(var n=0;n<e.length;n++)if(f(e[n])&&l(e[n]))return e[n];for(var i=0,a=e.length-1;i<a;){for(var o,s=i,u=a,c=e[Math.floor(Math.random()*(a-i+1))+i];s<u;){0<=r(e[s],c)?(o=e[u],e[u]=e[s],e[s]=o,--u):++s}0<r(e[s],c)&&--s,t<=s?a=s:i=s+1}return e[t]}}),Ko=["typed","matrix","compare","compareNatural"],es=Object(s.a)("sort",Ko,function(e){function t(e,t){return-i(e,t)}var r=e.typed,n=e.matrix,i=e.compare,a=e.compareNatural,o=i;return r("sort",{Array:function(e){return u(e),e.sort(o)},Matrix:function(e){return c(e),n(e.toArray().sort(o),e.storage())},"Array, function":function(e,t){return u(e),e.sort(t)},"Matrix, function":function(e,t){return c(e),n(e.toArray().sort(t),e.storage())},"Array, string":function(e,t){return u(e),e.sort(s(t))},"Matrix, string":function(e,t){return c(e),n(e.toArray().sort(s(t)),e.storage())}});function s(e){if("asc"===e)return o;if("desc"===e)return t;if("natural"===e)return a;throw new Error('String "asc", "desc", or "natural" expected')}function u(e){if(1!==Object(q.a)(e).length)throw new Error("One dimensional array expected")}function c(e){if(1!==e.size().length)throw new Error("One dimensional matrix expected")}}),ts=["typed","config","numeric","larger"],rs=Object(s.a)("max",ts,function(e){var t=e.typed,n=e.config,i=e.numeric,a=e.larger;return t("max",{"Array | Matrix":o,"Array | Matrix, number | BigNumber":function(e,t){return F(e,t.valueOf(),r)},"...":function(e){if(P(e))throw new TypeError("Scalar values expected in function max");return o(e)}});function r(e,t){try{return a(e,t)?e:t}catch(e){throw la(e,"max",t)}}function o(e){var r;if(U(e,function(t){try{isNaN(t)&&"number"==typeof t?r=NaN:void 0!==r&&!a(t,r)||(r=t)}catch(e){throw la(e,"max",t)}}),void 0===r)throw new Error("Cannot calculate max of an empty array");return"string"==typeof r&&(r=i(r,n.number)),r}}),ns=["typed","config","numeric","smaller"],is=Object(s.a)("min",ns,function(e){var t=e.typed,n=e.config,i=e.numeric,a=e.smaller;return t("min",{"Array | Matrix":o,"Array | Matrix, number | BigNumber":function(e,t){return F(e,t.valueOf(),r)},"...":function(e){if(P(e))throw new TypeError("Scalar values expected in function min");return o(e)}});function r(e,t){try{return a(e,t)?e:t}catch(e){throw la(e,"min",t)}}function o(e){var r;if(U(e,function(t){try{isNaN(t)&&"number"==typeof t?r=NaN:void 0!==r&&!a(t,r)||(r=t)}catch(e){throw la(e,"min",t)}}),void 0===r)throw new Error("Cannot calculate min of an empty array");return"string"==typeof r&&(r=i(r,n.number)),r}}),as=["smaller","DenseMatrix"],os=Object(s.a)("ImmutableDenseMatrix",as,function(e){var r=e.smaller,n=e.DenseMatrix;function i(e,t){if(!(this instanceof i))throw new SyntaxError("Constructor must be called with the new operator");if(t&&!Object(ie.I)(t))throw new Error("Invalid datatype: "+t);if(Object(ie.v)(e)||Object(ie.b)(e)){var r=new n(e,t);this._data=r._data,this._size=r._size,this._datatype=r._datatype,this._min=null,this._max=null}else if(e&&Object(ie.b)(e.data)&&Object(ie.b)(e.size))this._data=e.data,this._size=e.size,this._datatype=e.datatype,this._min=void 0!==e.min?e.min:null,this._max=void 0!==e.max?e.max:null;else{if(e)throw new TypeError("Unsupported type of data ("+Object(ie.M)(e)+")");this._data=[],this._size=[0],this._datatype=t,this._min=null,this._max=null}}return(i.prototype=new n).type="ImmutableDenseMatrix",i.prototype.isImmutableDenseMatrix=!0,i.prototype.subset=function(e){switch(arguments.length){case 1:var t=n.prototype.subset.call(this,e);return Object(ie.v)(t)?new i({data:t._data,size:t._size,datatype:t._datatype}):t;case 2:case 3:throw new Error("Cannot invoke set subset on an Immutable Matrix instance");default:throw new SyntaxError("Wrong number of arguments")}},i.prototype.set=function(){throw new Error("Cannot invoke set on an Immutable Matrix instance")},i.prototype.resize=function(){throw new Error("Cannot invoke resize on an Immutable Matrix instance")},i.prototype.reshape=function(){throw new Error("Cannot invoke reshape on an Immutable Matrix instance")},i.prototype.clone=function(){return new i({data:Object(ae.a)(this._data),size:Object(ae.a)(this._size),datatype:this._datatype})},i.prototype.toJSON=function(){return{mathjs:"ImmutableDenseMatrix",data:this._data,size:this._size,datatype:this._datatype}},i.fromJSON=function(e){return new i(e)},i.prototype.swapRows=function(){throw new Error("Cannot invoke swapRows on an Immutable Matrix instance")},i.prototype.min=function(){var t;return null===this._min&&(t=null,this.forEach(function(e){null!==t&&!r(e,t)||(t=e)}),this._min=null!==t?t:void 0),this._min},i.prototype.max=function(){var t;return null===this._max&&(t=null,this.forEach(function(e){null!==t&&!r(t,e)||(t=e)}),this._max=null!==t?t:void 0),this._max},i},{isClass:!0}),ss=["ImmutableDenseMatrix"],us=Object(s.a)("Index",ss,function(e){var n=e.ImmutableDenseMatrix;function o(e){if(!(this instanceof o))throw new SyntaxError("Constructor must be called with the new operator");this._dimensions=[],this._isScalar=!0;for(var t=0,r=arguments.length;t<r;t++){var n=arguments[t];if(Object(ie.D)(n))this._dimensions.push(n),this._isScalar=!1;else if(Array.isArray(n)||Object(ie.v)(n)){var i=s(n.valueOf());this._dimensions.push(i);var a=i.size();1===a.length&&1===a[0]||(this._isScalar=!1)}else if("number"==typeof n)this._dimensions.push(s([n]));else{if("string"!=typeof n)throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");this._dimensions.push(n)}}}function s(e){for(var t=0,r=e.length;t<r;t++)if("number"!=typeof e[t]||!Object(E.i)(e[t]))throw new TypeError("Index parameters must be positive integer numbers");return new n(e)}return o.prototype.type="Index",o.prototype.isIndex=!0,o.prototype.clone=function(){var e=new o;return e._dimensions=Object(ae.a)(this._dimensions),e._isScalar=this._isScalar,e},o.create=function(e){var t=new o;return o.apply(t,e),t},o.prototype.size=function(){for(var e=[],t=0,r=this._dimensions.length;t<r;t++){var n=this._dimensions[t];e[t]="string"==typeof n?1:n.size()[0]}return e},o.prototype.max=function(){for(var e=[],t=0,r=this._dimensions.length;t<r;t++){var n=this._dimensions[t];e[t]="string"==typeof n?n:n.max()}return e},o.prototype.min=function(){for(var e=[],t=0,r=this._dimensions.length;t<r;t++){var n=this._dimensions[t];e[t]="string"==typeof n?n:n.min()}return e},o.prototype.forEach=function(e){for(var t=0,r=this._dimensions.length;t<r;t++)e(this._dimensions[t],t,this)},o.prototype.dimension=function(e){return this._dimensions[e]||null},o.prototype.isObjectProperty=function(){return 1===this._dimensions.length&&"string"==typeof this._dimensions[0]},o.prototype.getObjectProperty=function(){return this.isObjectProperty()?this._dimensions[0]:null},o.prototype.isScalar=function(){return this._isScalar},o.prototype.valueOf=o.prototype.toArray=function(){for(var e=[],t=0,r=this._dimensions.length;t<r;t++){var n=this._dimensions[t];e.push("string"==typeof n?n:n.toArray())}return e},o.prototype.toString=function(){for(var e=[],t=0,r=this._dimensions.length;t<r;t++){var n=this._dimensions[t];"string"==typeof n?e.push(JSON.stringify(n)):e.push(n.toString())}return"["+e.join(", ")+"]"},o.prototype.toJSON=function(){return{mathjs:"Index",dimensions:this._dimensions}},o.fromJSON=function(e){return o.create(e.dimensions)},o},{isClass:!0}),cs=["smaller","larger"],fs=Object(s.a)("FibonacciHeap",cs,function(e){var l=e.smaller,p=e.larger,m=1/Math.log((1+Math.sqrt(5))/2);function t(){if(!(this instanceof t))throw new SyntaxError("Constructor must be called with the new operator");this._minimum=null,this._size=0}function i(e,t,r){t.left.right=t.right,t.right.left=t.left,r.degree--,r.child===t&&(r.child=t.right),0===r.degree&&(r.child=null),t.left=e,t.right=e.right,((e.right=t).right.left=t).parent=null,t.mark=!1}t.prototype.type="FibonacciHeap",t.prototype.isFibonacciHeap=!0,t.prototype.insert=function(e,t){var r,n={key:e,value:t,degree:0};return this._minimum?(r=this._minimum,n.left=r,n.right=r.right,(r.right=n).right.left=n,l(e,r.key)&&(this._minimum=n)):((n.left=n).right=n,this._minimum=n),this._size++,n},t.prototype.size=function(){return this._size},t.prototype.clear=function(){this._minimum=null,this._size=0},t.prototype.isEmpty=function(){return 0===this._size},t.prototype.extractMinimum=function(){var e=this._minimum;if(null===e)return e;for(var t=this._minimum,r=e.degree,n=e.child;0<r;){var i=n.right;n.left.right=n.right,n.right.left=n.left,n.left=t,n.right=t.right,((t.right=n).right.left=n).parent=null,n=i,r--}return e.left.right=e.right,e.right.left=e.left,t=e===e.right?null:function(e,t){var r,n=Math.floor(Math.log(t)*m)+1,i=new Array(n),a=0,o=e;if(o)for(a++,o=o.right;o!==e;)a++,o=o.right;for(;0<a;){for(var s,u=o.degree,c=o.right;r=i[u];){p(o.key,r.key)&&(s=r,r=o,o=s),h(r,o),i[u]=null,u++}i[u]=o,o=c,a--}e=null;for(var f=0;f<n;f++)(r=i[f])&&(e?(r.left.right=r.right,r.right.left=r.left,r.left=e,r.right=e.right,(e.right=r).right.left=r,l(r.key,e.key)&&(e=r)):e=r);return e}(t=e.right,this._size),this._size--,this._minimum=t,e},t.prototype.remove=function(e){this._minimum=function(e,t,r){t.key=r;var n=t.parent;n&&l(t.key,n.key)&&(i(e,t,n),function e(t,r){var n=r.parent;if(!n)return;r.mark?(i(t,r,n),e(n)):r.mark=!0}(e,n));l(t.key,e.key)&&(e=t);return e}(this._minimum,e,-1),this.extractMinimum()};var h=function(e,t){e.left.right=e.right,e.right.left=e.left,(e.parent=t).child?(e.left=t.child,e.right=t.child.right,(t.child.right=e).right.left=e):((t.child=e).right=e).left=e,t.degree++,e.mark=!1};return t},{isClass:!0}),ls=["addScalar","equalScalar","FibonacciHeap"],ps=Object(s.a)("Spa",ls,function(e){var n=e.addScalar,c=e.equalScalar,t=e.FibonacciHeap;function r(){if(!(this instanceof r))throw new SyntaxError("Constructor must be called with the new operator");this._values=[],this._heap=new t}return r.prototype.type="Spa",r.prototype.isSpa=!0,r.prototype.set=function(e,t){var r;this._values[e]?this._values[e].value=t:(r=this._heap.insert(e,t),this._values[e]=r)},r.prototype.get=function(e){var t=this._values[e];return t?t.value:0},r.prototype.accumulate=function(e,t){var r=this._values[e];r?r.value=n(r.value,t):(r=this._heap.insert(e,t),this._values[e]=r)},r.prototype.forEach=function(e,t,r){var n=this._heap,i=this._values,a=[];for((s=n.extractMinimum())&&a.push(s);s&&s.key<=t;)s.key>=e&&(c(s.value,0)||r(s.key,s.value,this)),(s=n.extractMinimum())&&a.push(s);for(var o=0;o<a.length;o++){var s,u=a[o];i[(s=n.insert(u.key,u.value)).key]=s}},r.prototype.swap=function(e,t){var r,n=this._values[e],i=this._values[t];!n&&i?(n=this._heap.insert(e,i.value),this._heap.remove(i),this._values[e]=n,this._values[t]=void 0):n&&!i?(i=this._heap.insert(t,n.value),this._heap.remove(n),this._values[t]=i,this._values[e]=void 0):n&&i&&(r=n.value,n.value=i.value,i.value=r)},r},{isClass:!0}),ms=Zn(function(e){return new e(1).exp()},gs),hs=Zn(function(e){return new e(1).plus(new e(5).sqrt()).div(2)},gs),ds=Zn(function(e){return e.acos(-1)},gs),ys=Zn(function(e){return ds(e).times(2)},gs);function gs(e){return e[0].precision}function vs(e){return(vs="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function bs(){return(bs=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function xs(t,e){var r,n=Object.keys(t);return Object.getOwnPropertySymbols&&(r=Object.getOwnPropertySymbols(t),e&&(r=r.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,r)),n}function ws(i){for(var e=1;e<arguments.length;e++){var a=null!=arguments[e]?arguments[e]:{};e%2?xs(Object(a),!0).forEach(function(e){var t,r,n;t=i,n=a[r=e],r in t?Object.defineProperty(t,r,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[r]=n}):Object.getOwnPropertyDescriptors?Object.defineProperties(i,Object.getOwnPropertyDescriptors(a)):xs(Object(a)).forEach(function(e){Object.defineProperty(i,e,Object.getOwnPropertyDescriptor(a,e))})}return i}var Ns=["?on","config","addScalar","subtract","multiplyScalar","divideScalar","pow","abs","fix","round","equal","isNumeric","format","number","Complex","BigNumber","Fraction"],Os=Object(s.a)("Unit",Ns,function(e){var y,g,v,t=e.on,b=e.config,c=e.addScalar,f=e.subtract,l=e.multiplyScalar,p=e.divideScalar,m=e.pow,h=e.abs,d=e.fix,x=e.round,w=e.equal,i=e.isNumeric,s=e.format,r=e.number,n=e.Complex,N=e.BigNumber,O=e.Fraction,a=r;function M(e,t){if(!(this instanceof M))throw new Error("Constructor must be called with the new operator");if(null!=e&&!i(e)&&!Object(ie.j)(e))throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");if(void 0!==t&&("string"!=typeof t||""===t))throw new TypeError("Second parameter in Unit constructor must be a string");if(void 0!==t){var r=M.parse(t);this.units=r.units,this.dimensions=r.dimensions}else{this.units=[{unit:B,prefix:_.NONE,power:0}],this.dimensions=[];for(var n=0;n<q.length;n++)this.dimensions[n]=0}this.value=null!=e?this._normalize(e):null,this.fixPrefix=!1,this.skipAutomaticSimplification=!0}function j(){for(;" "===v||"\t"===v;)E()}function o(e){return"0"<=e&&e<="9"}function E(){g++,v=y.charAt(g)}function u(e){g=e,v=y.charAt(g)}function S(){var e,t="",r=g;if("+"===v?E():"-"===v&&(t+=v,E()),!("0"<=(e=v)&&e<="9"||"."===e))return u(r),null;if("."===v){if(t+=v,E(),!o(v))return u(r),null}else{for(;o(v);)t+=v,E();"."===v&&(t+=v,E())}for(;o(v);)t+=v,E();if("E"===v||"e"===v){var n="",i=g;if(n+=v,E(),"+"!==v&&"-"!==v||(n+=v,E()),!o(v))return u(i),t;for(t+=n;o(v);)t+=v,E()}return t}function A(e){return v===e&&(E(),e)}function C(e){if(Object(ae.f)(z,e)){var t=z[e];return{unit:t,prefix:t.prefixes[""]}}for(var r in z)if(Object(ae.f)(z,r)&&Object(V.b)(e,r)){var n=z[r],i=e.length-r.length,a=e.substring(0,i),o=Object(ae.f)(n.prefixes,a)?n.prefixes[a]:void 0;if(void 0!==o)return{unit:n,prefix:o}}return null}function T(e){return e.equalBase(I.NONE)&&null!==e.value&&!b.predictable?e.value:e}M.prototype.type="Unit",M.prototype.isUnit=!0,M.parse=function(e,t){if(t=t||{},g=-1,v="","string"!=typeof(y=e))throw new TypeError("Invalid argument in Unit.parse, string expected");var r=new M,n=1,i=!(r.units=[]);E(),j();var a=S(),o=null;if(a){if("BigNumber"===b.number)o=new N(a);else if("Fraction"===b.number)try{o=new O(a)}catch(e){o=parseFloat(a)}else o=parseFloat(a);j(),A("*")?(n=1,i=!0):A("/")&&(n=-1,i=!0)}for(var s=[],u=1;;){for(j();"("===v;)s.push(n),u*=n,n=1,E(),j();var c=void 0;if(!v)break;var f=v;if(null===(c=function(){for(var e="",t=y.charCodeAt(g);48<=t&&t<=57||65<=t&&t<=90||97<=t&&t<=122;)e+=v,E(),t=y.charCodeAt(g);return(65<=(t=e.charCodeAt(0))&&t<=90||97<=t&&t<=122)&&e||null}()))throw new SyntaxError('Unexpected "'+f+'" in "'+y+'" at index '+g.toString());var l=C(c);if(null===l)throw new SyntaxError('Unit "'+c+'" not found.');var p=n*u;if(j(),A("^")){j();var m=S();if(null===m)throw new SyntaxError('In "'+e+'", "^" must be followed by a floating-point number');p*=m}r.units.push({unit:l.unit,prefix:l.prefix,power:p});for(var h,d=0;d<q.length;d++)r.dimensions[d]+=(l.unit.dimensions[d]||0)*p;for(j();")"===v;){if(0===s.length)throw new SyntaxError('Unmatched ")" in "'+y+'" at index '+g.toString());u/=s.pop(),E(),j()}i=!1,A("*")?(n=1,i=!0):A("/")?(n=-1,i=!0):n=1,l.unit.base&&(h=l.unit.base.key,P.auto[h]={unit:l.unit,prefix:l.prefix})}if(j(),v)throw new SyntaxError('Could not parse: "'+e+'"');if(i)throw new SyntaxError('Trailing characters: "'+e+'"');if(0!==s.length)throw new SyntaxError('Unmatched "(" in "'+y+'"');if(0===r.units.length&&!t.allowNoUnits)throw new SyntaxError('"'+e+'" contains no units');return r.value=void 0!==o?r._normalize(o):null,r},M.prototype.clone=function(){var e=new M;e.fixPrefix=this.fixPrefix,e.skipAutomaticSimplification=this.skipAutomaticSimplification,e.value=Object(ae.a)(this.value),e.dimensions=this.dimensions.slice(0),e.units=[];for(var t=0;t<this.units.length;t++)for(var r in e.units[t]={},this.units[t])Object(ae.f)(this.units[t],r)&&(e.units[t][r]=this.units[t][r]);return e},M.prototype._isDerived=function(){return 0!==this.units.length&&(1<this.units.length||1e-15<Math.abs(this.units[0].power-1))},M.prototype._normalize=function(e){var t,r,n,i;if(null==e||0===this.units.length)return e;if(this._isDerived()){for(var a=e,o=M._getNumberConverter(Object(ie.M)(e)),s=0;s<this.units.length;s++)t=o(this.units[s].unit.value),i=o(this.units[s].prefix.value),n=o(this.units[s].power),a=l(a,m(l(t,i),n));return a}return t=(o=M._getNumberConverter(Object(ie.M)(e)))(this.units[0].unit.value),r=o(this.units[0].unit.offset),i=o(this.units[0].prefix.value),l(c(e,r),l(t,i))},M.prototype._denormalize=function(e,t){var r,n,i,a;if(null==e||0===this.units.length)return e;if(this._isDerived()){for(var o=e,s=M._getNumberConverter(Object(ie.M)(e)),u=0;u<this.units.length;u++)r=s(this.units[u].unit.value),a=s(this.units[u].prefix.value),i=s(this.units[u].power),o=p(o,m(l(r,a),i));return o}return r=(s=M._getNumberConverter(Object(ie.M)(e)))(this.units[0].unit.value),a=s(this.units[0].prefix.value),n=s(this.units[0].unit.offset),f(p(p(e,r),null==t?a:t),n)},M.isValuelessUnit=function(e){return null!==C(e)},M.prototype.hasBase=function(e){if("string"==typeof e&&(e=I[e]),!e)return!1;for(var t=0;t<q.length;t++)if(1e-12<Math.abs((this.dimensions[t]||0)-(e.dimensions[t]||0)))return!1;return!0},M.prototype.equalBase=function(e){for(var t=0;t<q.length;t++)if(1e-12<Math.abs((this.dimensions[t]||0)-(e.dimensions[t]||0)))return!1;return!0},M.prototype.equals=function(e){return this.equalBase(e)&&w(this.value,e.value)},M.prototype.multiply=function(e){for(var t=this.clone(),r=0;r<q.length;r++)t.dimensions[r]=(this.dimensions[r]||0)+(e.dimensions[r]||0);for(var n,i,a=0;a<e.units.length;a++){var o=ws({},e.units[a]);t.units.push(o)}return null!==this.value||null!==e.value?(n=null===this.value?this._normalize(1):this.value,i=null===e.value?e._normalize(1):e.value,t.value=l(n,i)):t.value=null,t.skipAutomaticSimplification=!1,T(t)},M.prototype.divide=function(e){for(var t=this.clone(),r=0;r<q.length;r++)t.dimensions[r]=(this.dimensions[r]||0)-(e.dimensions[r]||0);for(var n,i,a=0;a<e.units.length;a++){var o=ws(ws({},e.units[a]),{},{power:-e.units[a].power});t.units.push(o)}return null!==this.value||null!==e.value?(n=null===this.value?this._normalize(1):this.value,i=null===e.value?e._normalize(1):e.value,t.value=p(n,i)):t.value=null,t.skipAutomaticSimplification=!1,T(t)},M.prototype.pow=function(e){for(var t=this.clone(),r=0;r<q.length;r++)t.dimensions[r]=(this.dimensions[r]||0)*e;for(var n=0;n<t.units.length;n++)t.units[n].power*=e;return null!==t.value?t.value=m(t.value,e):t.value=null,t.skipAutomaticSimplification=!1,T(t)},M.prototype.abs=function(){var e=this.clone();for(var t in e.value=null!==e.value?h(e.value):null,e.units)"VA"!==e.units[t].unit.name&&"VAR"!==e.units[t].unit.name||(e.units[t].unit=z.W);return e},M.prototype.to=function(e){var t,r=null===this.value?this._normalize(1):this.value;if("string"==typeof e){if(t=M.parse(e),!this.equalBase(t))throw new Error("Units do not match ('".concat(t.toString(),"' != '").concat(this.toString(),"')"));if(null!==t.value)throw new Error("Cannot convert to a unit with a value");return t.value=Object(ae.a)(r),t.fixPrefix=!0,t.skipAutomaticSimplification=!0,t}if(Object(ie.L)(e)){if(!this.equalBase(e))throw new Error("Units do not match ('".concat(e.toString(),"' != '").concat(this.toString(),"')"));if(null!==e.value)throw new Error("Cannot convert to a unit with a value");return(t=e.clone()).value=Object(ae.a)(r),t.fixPrefix=!0,t.skipAutomaticSimplification=!0,t}throw new Error("String or Unit expected as parameter")},M.prototype.toNumber=function(e){return a(this.toNumeric(e))},M.prototype.toNumeric=function(e){var t=e?this.to(e):this.clone();return t._isDerived()||0===t.units.length?t._denormalize(t.value):t._denormalize(t.value,t.units[0].prefix.value)},M.prototype.toString=function(){return this.format()},M.prototype.toJSON=function(){return{mathjs:"Unit",value:this._denormalize(this.value),unit:this.formatUnits(),fixPrefix:this.fixPrefix}},M.fromJSON=function(e){var t=new M(e.value,e.unit);return t.fixPrefix=e.fixPrefix||!1,t},M.prototype.valueOf=M.prototype.toString,M.prototype.simplify=function(){var e,t,r=this.clone(),n=[];for(var i in F)if(Object(ae.f)(F,i)&&r.hasBase(I[i])){e=i;break}if("NONE"===e)r.units=[];else if(e&&Object(ae.f)(F,e)&&(t=F[e]),t)r.units=[{unit:t.unit,prefix:t.prefix,power:1}];else{for(var a=!1,o=0;o<q.length;o++){var s=q[o];1e-12<Math.abs(r.dimensions[o]||0)&&(Object(ae.f)(F,s)?n.push({unit:F[s].unit,prefix:F[s].prefix,power:r.dimensions[o]||0}):a=!0)}n.length<r.units.length&&!a&&(r.units=n)}return r},M.prototype.toSI=function(){for(var e=this.clone(),t=[],r=0;r<q.length;r++){var n=q[r];if(1e-12<Math.abs(e.dimensions[r]||0)){if(!Object(ae.f)(P.si,n))throw new Error("Cannot express custom unit "+n+" in SI units");t.push({unit:P.si[n].unit,prefix:P.si[n].prefix,power:e.dimensions[r]||0})}}return e.units=t,e.fixPrefix=!0,e.skipAutomaticSimplification=!0,e},M.prototype.formatUnits=function(){for(var e="",t="",r=0,n=0,i=0;i<this.units.length;i++)0<this.units[i].power?(r++,e+=" "+this.units[i].prefix.name+this.units[i].unit.name,1e-15<Math.abs(this.units[i].power-1)&&(e+="^"+this.units[i].power)):this.units[i].power<0&&n++;if(0<n)for(var a=0;a<this.units.length;a++)this.units[a].power<0&&(0<r?(t+=" "+this.units[a].prefix.name+this.units[a].unit.name,1e-15<Math.abs(this.units[a].power+1)&&(t+="^"+-this.units[a].power)):(t+=" "+this.units[a].prefix.name+this.units[a].unit.name,t+="^"+this.units[a].power));e=e.substr(1),t=t.substr(1),1<r&&0<n&&(e="("+e+")"),1<n&&0<r&&(t="("+t+")");var o=e;return 0<r&&0<n&&(o+=" / "),o+=t},M.prototype.format=function(e){var t=this.skipAutomaticSimplification||null===this.value?this.clone():this.simplify(),r=!1;for(var n in void 0!==t.value&&null!==t.value&&Object(ie.j)(t.value)&&(r=Math.abs(t.value.re)<1e-14),t.units)Object(ae.f)(t.units,n)&&t.units[n].unit&&("VA"===t.units[n].unit.name&&r?t.units[n].unit=z.VAR:"VAR"!==t.units[n].unit.name||r||(t.units[n].unit=z.VA));1!==t.units.length||t.fixPrefix||Math.abs(t.units[0].power-Math.round(t.units[0].power))<1e-14&&(t.units[0].prefix=t._bestPrefix());var i=t._denormalize(t.value),a=null!==t.value?s(i,e||{}):"",o=t.formatUnits();return t.value&&Object(ie.j)(t.value)&&(a="("+a+")"),0<o.length&&0<a.length&&(a+=" "),a+=o},M.prototype._bestPrefix=function(){if(1!==this.units.length)throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");if(1e-14<=Math.abs(this.units[0].power-Math.round(this.units[0].power)))throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");var e=null!==this.value?h(this.value):0,t=h(this.units[0].unit.value),r=this.units[0].prefix;if(0===e)return r;var n=this.units[0].power,i=Math.log(e/Math.pow(r.value*t,n))/Math.LN10-1.2;if(-2.200001<i&&i<1.800001)return r;i=Math.abs(i);var a,o,s=this.units[0].unit.prefixes;for(var u in s){Object(ae.f)(s,u)&&(!(a=s[u]).scientific||((o=Math.abs(Math.log(e/Math.pow(a.value*t,n))/Math.LN10-1.2))<i||o===i&&a.name.length<r.name.length)&&(r=a,i=o))}return r};var _={NONE:{"":{name:"",value:1,scientific:!0}},SHORT:{"":{name:"",value:1,scientific:!0},da:{name:"da",value:10,scientific:!(M.prototype.splitUnit=function(e){for(var t=this.clone(),r=[],n=0;n<e.length&&(t=t.to(e[n]),n!==e.length-1);n++){var i=t.toNumeric(),a=x(i),o=new M(w(a,i)?a:d(t.toNumeric()),e[n].toString());r.push(o),t=f(t,o)}for(var s=0,u=0;u<r.length;u++)s=c(s,r[u].value);return w(s,this.value)&&(t.value=0),r.push(t),r})},h:{name:"h",value:100,scientific:!1},k:{name:"k",value:1e3,scientific:!0},M:{name:"M",value:1e6,scientific:!0},G:{name:"G",value:1e9,scientific:!0},T:{name:"T",value:1e12,scientific:!0},P:{name:"P",value:1e15,scientific:!0},E:{name:"E",value:1e18,scientific:!0},Z:{name:"Z",value:1e21,scientific:!0},Y:{name:"Y",value:1e24,scientific:!0},d:{name:"d",value:.1,scientific:!1},c:{name:"c",value:.01,scientific:!1},m:{name:"m",value:.001,scientific:!0},u:{name:"u",value:1e-6,scientific:!0},n:{name:"n",value:1e-9,scientific:!0},p:{name:"p",value:1e-12,scientific:!0},f:{name:"f",value:1e-15,scientific:!0},a:{name:"a",value:1e-18,scientific:!0},z:{name:"z",value:1e-21,scientific:!0},y:{name:"y",value:1e-24,scientific:!0}},LONG:{"":{name:"",value:1,scientific:!0},deca:{name:"deca",value:10,scientific:!1},hecto:{name:"hecto",value:100,scientific:!1},kilo:{name:"kilo",value:1e3,scientific:!0},mega:{name:"mega",value:1e6,scientific:!0},giga:{name:"giga",value:1e9,scientific:!0},tera:{name:"tera",value:1e12,scientific:!0},peta:{name:"peta",value:1e15,scientific:!0},exa:{name:"exa",value:1e18,scientific:!0},zetta:{name:"zetta",value:1e21,scientific:!0},yotta:{name:"yotta",value:1e24,scientific:!0},deci:{name:"deci",value:.1,scientific:!1},centi:{name:"centi",value:.01,scientific:!1},milli:{name:"milli",value:.001,scientific:!0},micro:{name:"micro",value:1e-6,scientific:!0},nano:{name:"nano",value:1e-9,scientific:!0},pico:{name:"pico",value:1e-12,scientific:!0},femto:{name:"femto",value:1e-15,scientific:!0},atto:{name:"atto",value:1e-18,scientific:!0},zepto:{name:"zepto",value:1e-21,scientific:!0},yocto:{name:"yocto",value:1e-24,scientific:!0}},SQUARED:{"":{name:"",value:1,scientific:!0},da:{name:"da",value:100,scientific:!1},h:{name:"h",value:1e4,scientific:!1},k:{name:"k",value:1e6,scientific:!0},M:{name:"M",value:1e12,scientific:!0},G:{name:"G",value:1e18,scientific:!0},T:{name:"T",value:1e24,scientific:!0},P:{name:"P",value:1e30,scientific:!0},E:{name:"E",value:1e36,scientific:!0},Z:{name:"Z",value:1e42,scientific:!0},Y:{name:"Y",value:1e48,scientific:!0},d:{name:"d",value:.01,scientific:!1},c:{name:"c",value:1e-4,scientific:!1},m:{name:"m",value:1e-6,scientific:!0},u:{name:"u",value:1e-12,scientific:!0},n:{name:"n",value:1e-18,scientific:!0},p:{name:"p",value:1e-24,scientific:!0},f:{name:"f",value:1e-30,scientific:!0},a:{name:"a",value:1e-36,scientific:!0},z:{name:"z",value:1e-42,scientific:!0},y:{name:"y",value:1e-48,scientific:!0}},CUBIC:{"":{name:"",value:1,scientific:!0},da:{name:"da",value:1e3,scientific:!1},h:{name:"h",value:1e6,scientific:!1},k:{name:"k",value:1e9,scientific:!0},M:{name:"M",value:1e18,scientific:!0},G:{name:"G",value:1e27,scientific:!0},T:{name:"T",value:1e36,scientific:!0},P:{name:"P",value:1e45,scientific:!0},E:{name:"E",value:1e54,scientific:!0},Z:{name:"Z",value:1e63,scientific:!0},Y:{name:"Y",value:1e72,scientific:!0},d:{name:"d",value:.001,scientific:!1},c:{name:"c",value:1e-6,scientific:!1},m:{name:"m",value:1e-9,scientific:!0},u:{name:"u",value:1e-18,scientific:!0},n:{name:"n",value:1e-27,scientific:!0},p:{name:"p",value:1e-36,scientific:!0},f:{name:"f",value:1e-45,scientific:!0},a:{name:"a",value:1e-54,scientific:!0},z:{name:"z",value:1e-63,scientific:!0},y:{name:"y",value:1e-72,scientific:!0}},BINARY_SHORT_SI:{"":{name:"",value:1,scientific:!0},k:{name:"k",value:1e3,scientific:!0},M:{name:"M",value:1e6,scientific:!0},G:{name:"G",value:1e9,scientific:!0},T:{name:"T",value:1e12,scientific:!0},P:{name:"P",value:1e15,scientific:!0},E:{name:"E",value:1e18,scientific:!0},Z:{name:"Z",value:1e21,scientific:!0},Y:{name:"Y",value:1e24,scientific:!0}},BINARY_SHORT_IEC:{"":{name:"",value:1,scientific:!0},Ki:{name:"Ki",value:1024,scientific:!0},Mi:{name:"Mi",value:Math.pow(1024,2),scientific:!0},Gi:{name:"Gi",value:Math.pow(1024,3),scientific:!0},Ti:{name:"Ti",value:Math.pow(1024,4),scientific:!0},Pi:{name:"Pi",value:Math.pow(1024,5),scientific:!0},Ei:{name:"Ei",value:Math.pow(1024,6),scientific:!0},Zi:{name:"Zi",value:Math.pow(1024,7),scientific:!0},Yi:{name:"Yi",value:Math.pow(1024,8),scientific:!0}},BINARY_LONG_SI:{"":{name:"",value:1,scientific:!0},kilo:{name:"kilo",value:1e3,scientific:!0},mega:{name:"mega",value:1e6,scientific:!0},giga:{name:"giga",value:1e9,scientific:!0},tera:{name:"tera",value:1e12,scientific:!0},peta:{name:"peta",value:1e15,scientific:!0},exa:{name:"exa",value:1e18,scientific:!0},zetta:{name:"zetta",value:1e21,scientific:!0},yotta:{name:"yotta",value:1e24,scientific:!0}},BINARY_LONG_IEC:{"":{name:"",value:1,scientific:!0},kibi:{name:"kibi",value:1024,scientific:!0},mebi:{name:"mebi",value:Math.pow(1024,2),scientific:!0},gibi:{name:"gibi",value:Math.pow(1024,3),scientific:!0},tebi:{name:"tebi",value:Math.pow(1024,4),scientific:!0},pebi:{name:"pebi",value:Math.pow(1024,5),scientific:!0},exi:{name:"exi",value:Math.pow(1024,6),scientific:!0},zebi:{name:"zebi",value:Math.pow(1024,7),scientific:!0},yobi:{name:"yobi",value:Math.pow(1024,8),scientific:!0}},BTU:{"":{name:"",value:1,scientific:!0},MM:{name:"MM",value:1e6,scientific:!0}}};_.SHORTLONG=bs({},_.SHORT,_.LONG),_.BINARY_SHORT=bs({},_.BINARY_SHORT_SI,_.BINARY_SHORT_IEC),_.BINARY_LONG=bs({},_.BINARY_LONG_SI,_.BINARY_LONG_IEC);var q=["MASS","LENGTH","TIME","CURRENT","TEMPERATURE","LUMINOUS_INTENSITY","AMOUNT_OF_SUBSTANCE","ANGLE","BIT"],I={NONE:{dimensions:[0,0,0,0,0,0,0,0,0]},MASS:{dimensions:[1,0,0,0,0,0,0,0,0]},LENGTH:{dimensions:[0,1,0,0,0,0,0,0,0]},TIME:{dimensions:[0,0,1,0,0,0,0,0,0]},CURRENT:{dimensions:[0,0,0,1,0,0,0,0,0]},TEMPERATURE:{dimensions:[0,0,0,0,1,0,0,0,0]},LUMINOUS_INTENSITY:{dimensions:[0,0,0,0,0,1,0,0,0]},AMOUNT_OF_SUBSTANCE:{dimensions:[0,0,0,0,0,0,1,0,0]},FORCE:{dimensions:[1,1,-2,0,0,0,0,0,0]},SURFACE:{dimensions:[0,2,0,0,0,0,0,0,0]},VOLUME:{dimensions:[0,3,0,0,0,0,0,0,0]},ENERGY:{dimensions:[1,2,-2,0,0,0,0,0,0]},POWER:{dimensions:[1,2,-3,0,0,0,0,0,0]},PRESSURE:{dimensions:[1,-1,-2,0,0,0,0,0,0]},ELECTRIC_CHARGE:{dimensions:[0,0,1,1,0,0,0,0,0]},ELECTRIC_CAPACITANCE:{dimensions:[-1,-2,4,2,0,0,0,0,0]},ELECTRIC_POTENTIAL:{dimensions:[1,2,-3,-1,0,0,0,0,0]},ELECTRIC_RESISTANCE:{dimensions:[1,2,-3,-2,0,0,0,0,0]},ELECTRIC_INDUCTANCE:{dimensions:[1,2,-2,-2,0,0,0,0,0]},ELECTRIC_CONDUCTANCE:{dimensions:[-1,-2,3,2,0,0,0,0,0]},MAGNETIC_FLUX:{dimensions:[1,2,-2,-1,0,0,0,0,0]},MAGNETIC_FLUX_DENSITY:{dimensions:[1,0,-2,-1,0,0,0,0,0]},FREQUENCY:{dimensions:[0,0,-1,0,0,0,0,0,0]},ANGLE:{dimensions:[0,0,0,0,0,0,0,1,0]},BIT:{dimensions:[0,0,0,0,0,0,0,0,1]}};for(var k in I)Object(ae.f)(I,k)&&(I[k].key=k);var B={name:"",base:{},value:1,offset:0,dimensions:q.map(function(e){return 0})},z={meter:{name:"meter",base:I.LENGTH,prefixes:_.LONG,value:1,offset:0},inch:{name:"inch",base:I.LENGTH,prefixes:_.NONE,value:.0254,offset:0},foot:{name:"foot",base:I.LENGTH,prefixes:_.NONE,value:.3048,offset:0},yard:{name:"yard",base:I.LENGTH,prefixes:_.NONE,value:.9144,offset:0},mile:{name:"mile",base:I.LENGTH,prefixes:_.NONE,value:1609.344,offset:0},link:{name:"link",base:I.LENGTH,prefixes:_.NONE,value:.201168,offset:0},rod:{name:"rod",base:I.LENGTH,prefixes:_.NONE,value:5.0292,offset:0},chain:{name:"chain",base:I.LENGTH,prefixes:_.NONE,value:20.1168,offset:0},angstrom:{name:"angstrom",base:I.LENGTH,prefixes:_.NONE,value:1e-10,offset:0},m:{name:"m",base:I.LENGTH,prefixes:_.SHORT,value:1,offset:0},in:{name:"in",base:I.LENGTH,prefixes:_.NONE,value:.0254,offset:0},ft:{name:"ft",base:I.LENGTH,prefixes:_.NONE,value:.3048,offset:0},yd:{name:"yd",base:I.LENGTH,prefixes:_.NONE,value:.9144,offset:0},mi:{name:"mi",base:I.LENGTH,prefixes:_.NONE,value:1609.344,offset:0},li:{name:"li",base:I.LENGTH,prefixes:_.NONE,value:.201168,offset:0},rd:{name:"rd",base:I.LENGTH,prefixes:_.NONE,value:5.02921,offset:0},ch:{name:"ch",base:I.LENGTH,prefixes:_.NONE,value:20.1168,offset:0},mil:{name:"mil",base:I.LENGTH,prefixes:_.NONE,value:254e-7,offset:0},m2:{name:"m2",base:I.SURFACE,prefixes:_.SQUARED,value:1,offset:0},sqin:{name:"sqin",base:I.SURFACE,prefixes:_.NONE,value:64516e-8,offset:0},sqft:{name:"sqft",base:I.SURFACE,prefixes:_.NONE,value:.09290304,offset:0},sqyd:{name:"sqyd",base:I.SURFACE,prefixes:_.NONE,value:.83612736,offset:0},sqmi:{name:"sqmi",base:I.SURFACE,prefixes:_.NONE,value:2589988.110336,offset:0},sqrd:{name:"sqrd",base:I.SURFACE,prefixes:_.NONE,value:25.29295,offset:0},sqch:{name:"sqch",base:I.SURFACE,prefixes:_.NONE,value:404.6873,offset:0},sqmil:{name:"sqmil",base:I.SURFACE,prefixes:_.NONE,value:6.4516e-10,offset:0},acre:{name:"acre",base:I.SURFACE,prefixes:_.NONE,value:4046.86,offset:0},hectare:{name:"hectare",base:I.SURFACE,prefixes:_.NONE,value:1e4,offset:0},m3:{name:"m3",base:I.VOLUME,prefixes:_.CUBIC,value:1,offset:0},L:{name:"L",base:I.VOLUME,prefixes:_.SHORT,value:.001,offset:0},l:{name:"l",base:I.VOLUME,prefixes:_.SHORT,value:.001,offset:0},litre:{name:"litre",base:I.VOLUME,prefixes:_.LONG,value:.001,offset:0},cuin:{name:"cuin",base:I.VOLUME,prefixes:_.NONE,value:16387064e-12,offset:0},cuft:{name:"cuft",base:I.VOLUME,prefixes:_.NONE,value:.028316846592,offset:0},cuyd:{name:"cuyd",base:I.VOLUME,prefixes:_.NONE,value:.764554857984,offset:0},teaspoon:{name:"teaspoon",base:I.VOLUME,prefixes:_.NONE,value:5e-6,offset:0},tablespoon:{name:"tablespoon",base:I.VOLUME,prefixes:_.NONE,value:15e-6,offset:0},drop:{name:"drop",base:I.VOLUME,prefixes:_.NONE,value:5e-8,offset:0},gtt:{name:"gtt",base:I.VOLUME,prefixes:_.NONE,value:5e-8,offset:0},minim:{name:"minim",base:I.VOLUME,prefixes:_.NONE,value:6.161152e-8,offset:0},fluiddram:{name:"fluiddram",base:I.VOLUME,prefixes:_.NONE,value:36966911e-13,offset:0},fluidounce:{name:"fluidounce",base:I.VOLUME,prefixes:_.NONE,value:2957353e-11,offset:0},gill:{name:"gill",base:I.VOLUME,prefixes:_.NONE,value:.0001182941,offset:0},cc:{name:"cc",base:I.VOLUME,prefixes:_.NONE,value:1e-6,offset:0},cup:{name:"cup",base:I.VOLUME,prefixes:_.NONE,value:.0002365882,offset:0},pint:{name:"pint",base:I.VOLUME,prefixes:_.NONE,value:.0004731765,offset:0},quart:{name:"quart",base:I.VOLUME,prefixes:_.NONE,value:.0009463529,offset:0},gallon:{name:"gallon",base:I.VOLUME,prefixes:_.NONE,value:.003785412,offset:0},beerbarrel:{name:"beerbarrel",base:I.VOLUME,prefixes:_.NONE,value:.1173478,offset:0},oilbarrel:{name:"oilbarrel",base:I.VOLUME,prefixes:_.NONE,value:.1589873,offset:0},hogshead:{name:"hogshead",base:I.VOLUME,prefixes:_.NONE,value:.238481,offset:0},fldr:{name:"fldr",base:I.VOLUME,prefixes:_.NONE,value:36966911e-13,offset:0},floz:{name:"floz",base:I.VOLUME,prefixes:_.NONE,value:2957353e-11,offset:0},gi:{name:"gi",base:I.VOLUME,prefixes:_.NONE,value:.0001182941,offset:0},cp:{name:"cp",base:I.VOLUME,prefixes:_.NONE,value:.0002365882,offset:0},pt:{name:"pt",base:I.VOLUME,prefixes:_.NONE,value:.0004731765,offset:0},qt:{name:"qt",base:I.VOLUME,prefixes:_.NONE,value:.0009463529,offset:0},gal:{name:"gal",base:I.VOLUME,prefixes:_.NONE,value:.003785412,offset:0},bbl:{name:"bbl",base:I.VOLUME,prefixes:_.NONE,value:.1173478,offset:0},obl:{name:"obl",base:I.VOLUME,prefixes:_.NONE,value:.1589873,offset:0},g:{name:"g",base:I.MASS,prefixes:_.SHORT,value:.001,offset:0},gram:{name:"gram",base:I.MASS,prefixes:_.LONG,value:.001,offset:0},ton:{name:"ton",base:I.MASS,prefixes:_.SHORT,value:907.18474,offset:0},t:{name:"t",base:I.MASS,prefixes:_.SHORT,value:1e3,offset:0},tonne:{name:"tonne",base:I.MASS,prefixes:_.LONG,value:1e3,offset:0},grain:{name:"grain",base:I.MASS,prefixes:_.NONE,value:6479891e-11,offset:0},dram:{name:"dram",base:I.MASS,prefixes:_.NONE,value:.0017718451953125,offset:0},ounce:{name:"ounce",base:I.MASS,prefixes:_.NONE,value:.028349523125,offset:0},poundmass:{name:"poundmass",base:I.MASS,prefixes:_.NONE,value:.45359237,offset:0},hundredweight:{name:"hundredweight",base:I.MASS,prefixes:_.NONE,value:45.359237,offset:0},stick:{name:"stick",base:I.MASS,prefixes:_.NONE,value:.115,offset:0},stone:{name:"stone",base:I.MASS,prefixes:_.NONE,value:6.35029318,offset:0},gr:{name:"gr",base:I.MASS,prefixes:_.NONE,value:6479891e-11,offset:0},dr:{name:"dr",base:I.MASS,prefixes:_.NONE,value:.0017718451953125,offset:0},oz:{name:"oz",base:I.MASS,prefixes:_.NONE,value:.028349523125,offset:0},lbm:{name:"lbm",base:I.MASS,prefixes:_.NONE,value:.45359237,offset:0},cwt:{name:"cwt",base:I.MASS,prefixes:_.NONE,value:45.359237,offset:0},s:{name:"s",base:I.TIME,prefixes:_.SHORT,value:1,offset:0},min:{name:"min",base:I.TIME,prefixes:_.NONE,value:60,offset:0},h:{name:"h",base:I.TIME,prefixes:_.NONE,value:3600,offset:0},second:{name:"second",base:I.TIME,prefixes:_.LONG,value:1,offset:0},sec:{name:"sec",base:I.TIME,prefixes:_.LONG,value:1,offset:0},minute:{name:"minute",base:I.TIME,prefixes:_.NONE,value:60,offset:0},hour:{name:"hour",base:I.TIME,prefixes:_.NONE,value:3600,offset:0},day:{name:"day",base:I.TIME,prefixes:_.NONE,value:86400,offset:0},week:{name:"week",base:I.TIME,prefixes:_.NONE,value:604800,offset:0},month:{name:"month",base:I.TIME,prefixes:_.NONE,value:2629800,offset:0},year:{name:"year",base:I.TIME,prefixes:_.NONE,value:31557600,offset:0},decade:{name:"decade",base:I.TIME,prefixes:_.NONE,value:315576e3,offset:0},century:{name:"century",base:I.TIME,prefixes:_.NONE,value:315576e4,offset:0},millennium:{name:"millennium",base:I.TIME,prefixes:_.NONE,value:315576e5,offset:0},hertz:{name:"Hertz",base:I.FREQUENCY,prefixes:_.LONG,value:1,offset:0,reciprocal:!0},Hz:{name:"Hz",base:I.FREQUENCY,prefixes:_.SHORT,value:1,offset:0,reciprocal:!0},rad:{name:"rad",base:I.ANGLE,prefixes:_.SHORT,value:1,offset:0},radian:{name:"radian",base:I.ANGLE,prefixes:_.LONG,value:1,offset:0},deg:{name:"deg",base:I.ANGLE,prefixes:_.SHORT,value:null,offset:0},degree:{name:"degree",base:I.ANGLE,prefixes:_.LONG,value:null,offset:0},grad:{name:"grad",base:I.ANGLE,prefixes:_.SHORT,value:null,offset:0},gradian:{name:"gradian",base:I.ANGLE,prefixes:_.LONG,value:null,offset:0},cycle:{name:"cycle",base:I.ANGLE,prefixes:_.NONE,value:null,offset:0},arcsec:{name:"arcsec",base:I.ANGLE,prefixes:_.NONE,value:null,offset:0},arcmin:{name:"arcmin",base:I.ANGLE,prefixes:_.NONE,value:null,offset:0},A:{name:"A",base:I.CURRENT,prefixes:_.SHORT,value:1,offset:0},ampere:{name:"ampere",base:I.CURRENT,prefixes:_.LONG,value:1,offset:0},K:{name:"K",base:I.TEMPERATURE,prefixes:_.NONE,value:1,offset:0},degC:{name:"degC",base:I.TEMPERATURE,prefixes:_.NONE,value:1,offset:273.15},degF:{name:"degF",base:I.TEMPERATURE,prefixes:_.NONE,value:1/1.8,offset:459.67},degR:{name:"degR",base:I.TEMPERATURE,prefixes:_.NONE,value:1/1.8,offset:0},kelvin:{name:"kelvin",base:I.TEMPERATURE,prefixes:_.NONE,value:1,offset:0},celsius:{name:"celsius",base:I.TEMPERATURE,prefixes:_.NONE,value:1,offset:273.15},fahrenheit:{name:"fahrenheit",base:I.TEMPERATURE,prefixes:_.NONE,value:1/1.8,offset:459.67},rankine:{name:"rankine",base:I.TEMPERATURE,prefixes:_.NONE,value:1/1.8,offset:0},mol:{name:"mol",base:I.AMOUNT_OF_SUBSTANCE,prefixes:_.SHORT,value:1,offset:0},mole:{name:"mole",base:I.AMOUNT_OF_SUBSTANCE,prefixes:_.LONG,value:1,offset:0},cd:{name:"cd",base:I.LUMINOUS_INTENSITY,prefixes:_.SHORT,value:1,offset:0},candela:{name:"candela",base:I.LUMINOUS_INTENSITY,prefixes:_.LONG,value:1,offset:0},N:{name:"N",base:I.FORCE,prefixes:_.SHORT,value:1,offset:0},newton:{name:"newton",base:I.FORCE,prefixes:_.LONG,value:1,offset:0},dyn:{name:"dyn",base:I.FORCE,prefixes:_.SHORT,value:1e-5,offset:0},dyne:{name:"dyne",base:I.FORCE,prefixes:_.LONG,value:1e-5,offset:0},lbf:{name:"lbf",base:I.FORCE,prefixes:_.NONE,value:4.4482216152605,offset:0},poundforce:{name:"poundforce",base:I.FORCE,prefixes:_.NONE,value:4.4482216152605,offset:0},kip:{name:"kip",base:I.FORCE,prefixes:_.LONG,value:4448.2216,offset:0},J:{name:"J",base:I.ENERGY,prefixes:_.SHORT,value:1,offset:0},joule:{name:"joule",base:I.ENERGY,prefixes:_.SHORT,value:1,offset:0},erg:{name:"erg",base:I.ENERGY,prefixes:_.NONE,value:1e-7,offset:0},Wh:{name:"Wh",base:I.ENERGY,prefixes:_.SHORT,value:3600,offset:0},BTU:{name:"BTU",base:I.ENERGY,prefixes:_.BTU,value:1055.05585262,offset:0},eV:{name:"eV",base:I.ENERGY,prefixes:_.SHORT,value:1602176565e-28,offset:0},electronvolt:{name:"electronvolt",base:I.ENERGY,prefixes:_.LONG,value:1602176565e-28,offset:0},W:{name:"W",base:I.POWER,prefixes:_.SHORT,value:1,offset:0},watt:{name:"watt",base:I.POWER,prefixes:_.LONG,value:1,offset:0},hp:{name:"hp",base:I.POWER,prefixes:_.NONE,value:745.6998715386,offset:0},VAR:{name:"VAR",base:I.POWER,prefixes:_.SHORT,value:n.I,offset:0},VA:{name:"VA",base:I.POWER,prefixes:_.SHORT,value:1,offset:0},Pa:{name:"Pa",base:I.PRESSURE,prefixes:_.SHORT,value:1,offset:0},psi:{name:"psi",base:I.PRESSURE,prefixes:_.NONE,value:6894.75729276459,offset:0},atm:{name:"atm",base:I.PRESSURE,prefixes:_.NONE,value:101325,offset:0},bar:{name:"bar",base:I.PRESSURE,prefixes:_.SHORTLONG,value:1e5,offset:0},torr:{name:"torr",base:I.PRESSURE,prefixes:_.NONE,value:133.322,offset:0},mmHg:{name:"mmHg",base:I.PRESSURE,prefixes:_.NONE,value:133.322,offset:0},mmH2O:{name:"mmH2O",base:I.PRESSURE,prefixes:_.NONE,value:9.80665,offset:0},cmH2O:{name:"cmH2O",base:I.PRESSURE,prefixes:_.NONE,value:98.0665,offset:0},coulomb:{name:"coulomb",base:I.ELECTRIC_CHARGE,prefixes:_.LONG,value:1,offset:0},C:{name:"C",base:I.ELECTRIC_CHARGE,prefixes:_.SHORT,value:1,offset:0},farad:{name:"farad",base:I.ELECTRIC_CAPACITANCE,prefixes:_.LONG,value:1,offset:0},F:{name:"F",base:I.ELECTRIC_CAPACITANCE,prefixes:_.SHORT,value:1,offset:0},volt:{name:"volt",base:I.ELECTRIC_POTENTIAL,prefixes:_.LONG,value:1,offset:0},V:{name:"V",base:I.ELECTRIC_POTENTIAL,prefixes:_.SHORT,value:1,offset:0},ohm:{name:"ohm",base:I.ELECTRIC_RESISTANCE,prefixes:_.SHORTLONG,value:1,offset:0},henry:{name:"henry",base:I.ELECTRIC_INDUCTANCE,prefixes:_.LONG,value:1,offset:0},H:{name:"H",base:I.ELECTRIC_INDUCTANCE,prefixes:_.SHORT,value:1,offset:0},siemens:{name:"siemens",base:I.ELECTRIC_CONDUCTANCE,prefixes:_.LONG,value:1,offset:0},S:{name:"S",base:I.ELECTRIC_CONDUCTANCE,prefixes:_.SHORT,value:1,offset:0},weber:{name:"weber",base:I.MAGNETIC_FLUX,prefixes:_.LONG,value:1,offset:0},Wb:{name:"Wb",base:I.MAGNETIC_FLUX,prefixes:_.SHORT,value:1,offset:0},tesla:{name:"tesla",base:I.MAGNETIC_FLUX_DENSITY,prefixes:_.LONG,value:1,offset:0},T:{name:"T",base:I.MAGNETIC_FLUX_DENSITY,prefixes:_.SHORT,value:1,offset:0},b:{name:"b",base:I.BIT,prefixes:_.BINARY_SHORT,value:1,offset:0},bits:{name:"bits",base:I.BIT,prefixes:_.BINARY_LONG,value:1,offset:0},B:{name:"B",base:I.BIT,prefixes:_.BINARY_SHORT,value:8,offset:0},bytes:{name:"bytes",base:I.BIT,prefixes:_.BINARY_LONG,value:8,offset:0}},D={meters:"meter",inches:"inch",feet:"foot",yards:"yard",miles:"mile",links:"link",rods:"rod",chains:"chain",angstroms:"angstrom",lt:"l",litres:"litre",liter:"litre",liters:"litre",teaspoons:"teaspoon",tablespoons:"tablespoon",minims:"minim",fluiddrams:"fluiddram",fluidounces:"fluidounce",gills:"gill",cups:"cup",pints:"pint",quarts:"quart",gallons:"gallon",beerbarrels:"beerbarrel",oilbarrels:"oilbarrel",hogsheads:"hogshead",gtts:"gtt",grams:"gram",tons:"ton",tonnes:"tonne",grains:"grain",drams:"dram",ounces:"ounce",poundmasses:"poundmass",hundredweights:"hundredweight",sticks:"stick",lb:"lbm",lbs:"lbm",kips:"kip",acres:"acre",hectares:"hectare",sqfeet:"sqft",sqyard:"sqyd",sqmile:"sqmi",sqmiles:"sqmi",mmhg:"mmHg",mmh2o:"mmH2O",cmh2o:"cmH2O",seconds:"second",secs:"second",minutes:"minute",mins:"minute",hours:"hour",hr:"hour",hrs:"hour",days:"day",weeks:"week",months:"month",years:"year",decades:"decade",centuries:"century",millennia:"millennium",hertz:"hertz",radians:"radian",degrees:"degree",gradians:"gradian",cycles:"cycle",arcsecond:"arcsec",arcseconds:"arcsec",arcminute:"arcmin",arcminutes:"arcmin",BTUs:"BTU",watts:"watt",joules:"joule",amperes:"ampere",coulombs:"coulomb",volts:"volt",ohms:"ohm",farads:"farad",webers:"weber",teslas:"tesla",electronvolts:"electronvolt",moles:"mole",bit:"bits",byte:"bytes"};function R(e){var t;"BigNumber"===e.number?(t=ds(N),z.rad.value=new N(1),z.deg.value=t.div(180),z.grad.value=t.div(200),z.cycle.value=t.times(2),z.arcsec.value=t.div(648e3),z.arcmin.value=t.div(10800)):(z.rad.value=1,z.deg.value=Math.PI/180,z.grad.value=Math.PI/200,z.cycle.value=2*Math.PI,z.arcsec.value=Math.PI/648e3,z.arcmin.value=Math.PI/10800),z.radian.value=z.rad.value,z.degree.value=z.deg.value,z.gradian.value=z.grad.value}R(b),t&&t("config",function(e,t){e.number!==t.number&&R(e)});var P={si:{NONE:{unit:B,prefix:_.NONE[""]},LENGTH:{unit:z.m,prefix:_.SHORT[""]},MASS:{unit:z.g,prefix:_.SHORT.k},TIME:{unit:z.s,prefix:_.SHORT[""]},CURRENT:{unit:z.A,prefix:_.SHORT[""]},TEMPERATURE:{unit:z.K,prefix:_.SHORT[""]},LUMINOUS_INTENSITY:{unit:z.cd,prefix:_.SHORT[""]},AMOUNT_OF_SUBSTANCE:{unit:z.mol,prefix:_.SHORT[""]},ANGLE:{unit:z.rad,prefix:_.SHORT[""]},BIT:{unit:z.bits,prefix:_.SHORT[""]},FORCE:{unit:z.N,prefix:_.SHORT[""]},ENERGY:{unit:z.J,prefix:_.SHORT[""]},POWER:{unit:z.W,prefix:_.SHORT[""]},PRESSURE:{unit:z.Pa,prefix:_.SHORT[""]},ELECTRIC_CHARGE:{unit:z.C,prefix:_.SHORT[""]},ELECTRIC_CAPACITANCE:{unit:z.F,prefix:_.SHORT[""]},ELECTRIC_POTENTIAL:{unit:z.V,prefix:_.SHORT[""]},ELECTRIC_RESISTANCE:{unit:z.ohm,prefix:_.SHORT[""]},ELECTRIC_INDUCTANCE:{unit:z.H,prefix:_.SHORT[""]},ELECTRIC_CONDUCTANCE:{unit:z.S,prefix:_.SHORT[""]},MAGNETIC_FLUX:{unit:z.Wb,prefix:_.SHORT[""]},MAGNETIC_FLUX_DENSITY:{unit:z.T,prefix:_.SHORT[""]},FREQUENCY:{unit:z.Hz,prefix:_.SHORT[""]}}};P.cgs=JSON.parse(JSON.stringify(P.si)),P.cgs.LENGTH={unit:z.m,prefix:_.SHORT.c},P.cgs.MASS={unit:z.g,prefix:_.SHORT[""]},P.cgs.FORCE={unit:z.dyn,prefix:_.SHORT[""]},P.cgs.ENERGY={unit:z.erg,prefix:_.NONE[""]},P.us=JSON.parse(JSON.stringify(P.si)),P.us.LENGTH={unit:z.ft,prefix:_.NONE[""]},P.us.MASS={unit:z.lbm,prefix:_.NONE[""]},P.us.TEMPERATURE={unit:z.degF,prefix:_.NONE[""]},P.us.FORCE={unit:z.lbf,prefix:_.NONE[""]},P.us.ENERGY={unit:z.BTU,prefix:_.BTU[""]},P.us.POWER={unit:z.hp,prefix:_.NONE[""]},P.us.PRESSURE={unit:z.psi,prefix:_.NONE[""]},P.auto=JSON.parse(JSON.stringify(P.si));var U,F=P.auto;for(var L in M.setUnitSystem=function(e){if(!Object(ae.f)(P,e))throw new Error("Unit system "+e+" does not exist. Choices are: "+Object.keys(P).join(", "));F=P[e]},M.getUnitSystem=function(){for(var e in P)if(Object(ae.f)(P,e)&&P[e]===F)return e},M.typeConverters={BigNumber:function(e){return new N(e+"")},Fraction:function(e){return new O(e)},Complex:function(e){return e},number:function(e){return e}},M._getNumberConverter=function(e){if(!M.typeConverters[e])throw new TypeError('Unsupported type "'+e+'"');return M.typeConverters[e]},z){Object(ae.f)(z,L)&&((U=z[L]).dimensions=U.base.dimensions)}for(var H in D)if(Object(ae.f)(D,H)){var $=z[D[H]],G={};for(var Z in $)Object(ae.f)($,Z)&&(G[Z]=$[Z]);G.name=H,z[H]=G}return M.createUnit=function(e,t){if("object"!==vs(e))throw new TypeError("createUnit expects first parameter to be of type 'Object'");if(t&&t.override)for(var r in e)if(Object(ae.f)(e,r)&&M.deleteUnit(r),e[r].aliases)for(var n=0;n<e[r].aliases.length;n++)M.deleteUnit(e[r].aliases[n]);var i;for(var a in e)Object(ae.f)(e,a)&&(i=M.createUnitSingle(a,e[a]));return i},M.createUnitSingle=function(t,e,r){if(null==e&&(e={}),"string"!=typeof t)throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");if(Object(ae.f)(z,t))throw new Error('Cannot create unit "'+t+'": a unit with that name already exists');!function(e){for(var t,r=0;r<e.length;r++){var n=e.charAt(r),i=function(e){return/^[a-zA-Z]$/.test(e)};if(0===r&&!i(n))throw new Error('Invalid unit name (must begin with alpha character): "'+e+'"');if(0<r&&!(i(n)||"0"<=(t=n)&&t<="9"))throw new Error('Invalid unit name (only alphanumeric characters are allowed): "'+e+'"')}}(t);var n,i,a,o=null,s=[],u=0;if(e&&"Unit"===e.type)o=e.clone();else if("string"==typeof e)""!==e&&(n=e);else{if("object"!==vs(e))throw new TypeError('Cannot create unit "'+t+'" from "'+e.toString()+'": expecting "string" or "Unit" or "Object"');n=e.definition,i=e.prefixes,u=e.offset,a=e.baseName,e.aliases&&(s=e.aliases.valueOf())}if(s)for(var c=0;c<s.length;c++)if(Object(ae.f)(z,s[c]))throw new Error('Cannot create alias "'+s[c]+'": a unit with that name already exists');if(n&&"string"==typeof n&&!o)try{o=M.parse(n,{allowNoUnits:!0})}catch(e){throw e.message='Could not create unit "'+t+'" from "'+n+'": '+e.message,e}else n&&"Unit"===n.type&&(o=n.clone());s=s||[],u=u||0,i=i&&i.toUpperCase&&_[i.toUpperCase()]||_.NONE;var f={};if(o){var l,p=!(f={name:t,value:o.value,dimensions:o.dimensions.slice(0),prefixes:i,offset:u});for(var m in I)if(Object(ae.f)(I,m)){for(var h=!0,d=0;d<q.length;d++)if(1e-12<Math.abs((f.dimensions[d]||0)-(I[m].dimensions[d]||0))){h=!1;break}if(h){p=!0,f.base=I[m];break}}p||(a=a||t+"_STUFF",(l={dimensions:o.dimensions.slice(0)}).key=a,I[a]=l,F[a]={unit:f,prefix:_.NONE[""]},f.base=I[a])}else{if(a=a||t+"_STUFF",0<=q.indexOf(a))throw new Error('Cannot create new base unit "'+t+'": a base unit with that name already exists (and cannot be overridden)');for(var y in q.push(a),I)Object(ae.f)(I,y)&&(I[y].dimensions[q.length-1]=0);for(var g={dimensions:[]},v=0;v<q.length;v++)g.dimensions[v]=0;g.dimensions[q.length-1]=1,g.key=a,I[a]=g,f={name:t,value:1,dimensions:I[a].dimensions.slice(0),prefixes:i,offset:u,base:I[a]},F[a]={unit:f,prefix:_.NONE[""]}}M.UNITS[t]=f;for(var b=0;b<s.length;b++){var x=s[b],w={};for(var N in f)Object(ae.f)(f,N)&&(w[N]=f[N]);w.name=x,M.UNITS[x]=w}return new M(null,t)},M.deleteUnit=function(e){delete M.UNITS[e]},M.PREFIXES=_,M.BASE_DIMENSIONS=q,M.BASE_UNITS=I,M.UNIT_SYSTEMS=P,M.UNITS=z,M},{isClass:!0}),Ms=["typed","Unit"],js=Object(s.a)("unit",Ms,function(e){var t=e.typed,r=e.Unit;return t("unit",{Unit:function(e){return e.clone()},string:function(e){return r.isValuelessUnit(e)?new r(null,e):r.parse(e,{allowNoUnits:!0})},"number | BigNumber | Fraction | Complex, string":function(e,t){return new r(e,t)},"Array | Matrix":function(e){return oe(e,this)}})}),Es=["typed","SparseMatrix"],Ss=Object(s.a)("sparse",Es,function(e){var t=e.typed,r=e.SparseMatrix;return t("sparse",{"":function(){return new r([])},string:function(e){return new r([],e)},"Array | Matrix":function(e){return new r(e)},"Array | Matrix, string":function(e,t){return new r(e,t)}})}),As="createUnit",Cs=["typed","Unit"],Ts=Object(s.a)(As,Cs,function(e){var t=e.typed,i=e.Unit;return t(As,{"Object, Object":function(e,t){return i.createUnit(e,t)},Object:function(e){return i.createUnit(e,{})},"string, Unit | string | Object, Object":function(e,t,r){var n={};return n[e]=t,i.createUnit(n,r)},"string, Unit | string | Object":function(e,t){var r={};return r[e]=t,i.createUnit(r,{})},string:function(e){var t={};return t[e]={},i.createUnit(t,{})}})}),_s=["typed","config","Complex"],qs=Object(s.a)("acos",_s,function(e){var t=e.typed,r=e.config,n=e.Complex;return t("acos",{number:function(e){return-1<=e&&e<=1||r.predictable?Math.acos(e):new n(e,0).acos()},Complex:function(e){return e.acos()},BigNumber:function(e){return e.acos()},"Array | Matrix":function(e){return oe(e,this)}})}),Is="number";function ks(e){return Object(E.a)(e)}function Bs(e){return Math.atan(1/e)}function zs(e){return isFinite(e)?(Math.log((e+1)/e)+Math.log(e/(e-1)))/2:0}function Ds(e){return Math.asin(1/e)}function Rs(e){var t=1/e;return Math.log(t+Math.sqrt(t*t+1))}function Ps(e){return Math.acos(1/e)}function Us(e){var t=1/e,r=Math.sqrt(t*t-1);return Math.log(r+t)}function Fs(e){return Object(E.b)(e)}function Ls(e){return Object(E.c)(e)}function Hs(e){return 1/Math.tan(e)}function $s(e){var t=Math.exp(2*e);return(t+1)/(t-1)}function Gs(e){return 1/Math.sin(e)}function Zs(e){return 0===e?Number.POSITIVE_INFINITY:Math.abs(2/(Math.exp(e)-Math.exp(-e)))*Object(E.n)(e)}function Vs(e){return 1/Math.cos(e)}function Js(e){return 2/(Math.exp(e)+Math.exp(-e))}function Ws(e){return Object(E.o)(e)}Ws.signature=Js.signature=Vs.signature=Zs.signature=Gs.signature=$s.signature=Hs.signature=Ls.signature=Fs.signature=Us.signature=Ps.signature=Rs.signature=Ds.signature=zs.signature=Bs.signature=ks.signature=Is;var Ys=["typed","config","Complex"],Xs=Object(s.a)("acosh",Ys,function(e){var t=e.typed,r=e.config,n=e.Complex;return t("acosh",{number:function(e){return 1<=e||r.predictable?ks(e):e<=-1?new n(Math.log(Math.sqrt(e*e-1)-e),Math.PI):new n(e,0).acosh()},Complex:function(e){return e.acosh()},BigNumber:function(e){return e.acosh()},"Array | Matrix":function(e){return oe(e,this)}})}),Qs=["typed","BigNumber"],Ks=Object(s.a)("acot",Qs,function(e){var t=e.typed,r=e.BigNumber;return t("acot",{number:Bs,Complex:function(e){return e.acot()},BigNumber:function(e){return new r(1).div(e).atan()},"Array | Matrix":function(e){return oe(e,this)}})}),eu=["typed","config","Complex","BigNumber"],tu=Object(s.a)("acoth",eu,function(e){var t=e.typed,r=e.config,n=e.Complex,i=e.BigNumber;return t("acoth",{number:function(e){return 1<=e||e<=-1||r.predictable?zs(e):new n(e,0).acoth()},Complex:function(e){return e.acoth()},BigNumber:function(e){return new i(1).div(e).atanh()},"Array | Matrix":function(e){return oe(e,this)}})}),ru=["typed","config","Complex","BigNumber"],nu=Object(s.a)("acsc",ru,function(e){var t=e.typed,r=e.config,n=e.Complex,i=e.BigNumber;return t("acsc",{number:function(e){return e<=-1||1<=e||r.predictable?Ds(e):new n(e,0).acsc()},Complex:function(e){return e.acsc()},BigNumber:function(e){return new i(1).div(e).asin()},"Array | Matrix":function(e){return oe(e,this)}})}),iu=["typed","BigNumber"],au=Object(s.a)("acsch",iu,function(e){var t=e.typed,r=e.BigNumber;return t("acsch",{number:Rs,Complex:function(e){return e.acsch()},BigNumber:function(e){return new r(1).div(e).asinh()},"Array | Matrix":function(e){return oe(e,this)}})}),ou=["typed","config","Complex","BigNumber"],su=Object(s.a)("asec",ou,function(e){var t=e.typed,r=e.config,n=e.Complex,i=e.BigNumber;return t("asec",{number:function(e){return e<=-1||1<=e||r.predictable?Ps(e):new n(e,0).asec()},Complex:function(e){return e.asec()},BigNumber:function(e){return new i(1).div(e).acos()},"Array | Matrix":function(e){return oe(e,this)}})}),uu=["typed","config","Complex","BigNumber"],cu=Object(s.a)("asech",uu,function(e){var t=e.typed,n=e.config,i=e.Complex,r=e.BigNumber;return t("asech",{number:function(e){if(e<=1&&-1<=e||n.predictable){var t=1/e;if(0<t||n.predictable)return Us(e);var r=Math.sqrt(t*t-1);return new i(Math.log(r-t),Math.PI)}return new i(e,0).asech()},Complex:function(e){return e.asech()},BigNumber:function(e){return new r(1).div(e).acosh()},"Array | Matrix":function(e){return oe(e,this)}})}),fu=["typed","config","Complex"],lu=Object(s.a)("asin",fu,function(e){var t=e.typed,r=e.config,n=e.Complex;return t("asin",{number:function(e){return-1<=e&&e<=1||r.predictable?Math.asin(e):new n(e,0).asin()},Complex:function(e){return e.asin()},BigNumber:function(e){return e.asin()},"Array | Matrix":function(e){return oe(e,this,!0)}})}),pu=["typed"],mu=Object(s.a)("asinh",pu,function(e){return(0,e.typed)("asinh",{number:Fs,Complex:function(e){return e.asinh()},BigNumber:function(e){return e.asinh()},"Array | Matrix":function(e){return oe(e,this,!0)}})}),hu=["typed"],du=Object(s.a)("atan",hu,function(e){return(0,e.typed)("atan",{number:function(e){return Math.atan(e)},Complex:function(e){return e.atan()},BigNumber:function(e){return e.atan()},"Array | Matrix":function(e){return oe(e,this,!0)}})}),yu=["typed","matrix","equalScalar","BigNumber","DenseMatrix"],gu=Object(s.a)("atan2",yu,function(e){var t=e.typed,r=e.matrix,n=e.equalScalar,i=e.BigNumber,a=e.DenseMatrix,o=tr({typed:t,equalScalar:n}),s=mr({typed:t}),u=Fr({typed:t,equalScalar:n}),c=ar({typed:t,equalScalar:n}),f=gr({typed:t,DenseMatrix:a}),l=Wt({typed:t}),p=Xt({typed:t});return t("atan2",{"number, number":Math.atan2,"BigNumber, BigNumber":function(e,t){return i.atan2(e,t)},"SparseMatrix, SparseMatrix":function(e,t){return u(e,t,this,!1)},"SparseMatrix, DenseMatrix":function(e,t){return o(t,e,this,!0)},"DenseMatrix, SparseMatrix":function(e,t){return s(e,t,this,!1)},"DenseMatrix, DenseMatrix":function(e,t){return l(e,t,this)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"SparseMatrix, number | BigNumber":function(e,t){return c(e,t,this,!1)},"DenseMatrix, number | BigNumber":function(e,t){return p(e,t,this,!1)},"number | BigNumber, SparseMatrix":function(e,t){return f(t,e,this,!0)},"number | BigNumber, DenseMatrix":function(e,t){return p(t,e,this,!0)},"Array, number | BigNumber":function(e,t){return p(r(e),t,this,!1).valueOf()},"number | BigNumber, Array":function(e,t){return p(r(t),e,this,!0).valueOf()}})}),vu=["typed","config","Complex"],bu=Object(s.a)("atanh",vu,function(e){var t=e.typed,r=e.config,n=e.Complex;return t("atanh",{number:function(e){return e<=1&&-1<=e||r.predictable?Ls(e):new n(e,0).atanh()},Complex:function(e){return e.atanh()},BigNumber:function(e){return e.atanh()},"Array | Matrix":function(e){return oe(e,this,!0)}})}),xu=["typed"],wu=Object(s.a)("cos",xu,function(e){return(0,e.typed)("cos",{number:Math.cos,Complex:function(e){return e.cos()},BigNumber:function(e){return e.cos()},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function cos is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),Nu=["typed"],Ou=Object(s.a)("cosh",Nu,function(e){return(0,e.typed)("cosh",{number:E.e,Complex:function(e){return e.cosh()},BigNumber:function(e){return e.cosh()},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function cosh is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),Mu=["typed","BigNumber"],ju=Object(s.a)("cot",Mu,function(e){var t=e.typed,r=e.BigNumber;return t("cot",{number:Hs,Complex:function(e){return e.cot()},BigNumber:function(e){return new r(1).div(e.tan())},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function cot is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),Eu=["typed","BigNumber"],Su=Object(s.a)("coth",Eu,function(e){var t=e.typed,r=e.BigNumber;return t("coth",{number:$s,Complex:function(e){return e.coth()},BigNumber:function(e){return new r(1).div(e.tanh())},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function coth is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),Au=["typed","BigNumber"],Cu=Object(s.a)("csc",Au,function(e){var t=e.typed,r=e.BigNumber;return t("csc",{number:Gs,Complex:function(e){return e.csc()},BigNumber:function(e){return new r(1).div(e.sin())},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function csc is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),Tu=["typed","BigNumber"],_u=Object(s.a)("csch",Tu,function(e){var t=e.typed,r=e.BigNumber;return t("csch",{number:Zs,Complex:function(e){return e.csch()},BigNumber:function(e){return new r(1).div(e.sinh())},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function csch is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),qu=["typed","BigNumber"],Iu=Object(s.a)("sec",qu,function(e){var t=e.typed,r=e.BigNumber;return t("sec",{number:Vs,Complex:function(e){return e.sec()},BigNumber:function(e){return new r(1).div(e.cos())},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function sec is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),ku=["typed","BigNumber"],Bu=Object(s.a)("sech",ku,function(e){var t=e.typed,r=e.BigNumber;return t("sech",{number:Js,Complex:function(e){return e.sech()},BigNumber:function(e){return new r(1).div(e.cosh())},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function sech is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this)}})}),zu=["typed"],Du=Object(s.a)("sin",zu,function(e){return(0,e.typed)("sin",{number:Math.sin,Complex:function(e){return e.sin()},BigNumber:function(e){return e.sin()},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function sin is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this,!0)}})}),Ru=["typed"],Pu=Object(s.a)("sinh",Ru,function(e){return(0,e.typed)("sinh",{number:Ws,Complex:function(e){return e.sinh()},BigNumber:function(e){return e.sinh()},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function sinh is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this,!0)}})}),Uu=["typed"],Fu=Object(s.a)("tan",Uu,function(e){return(0,e.typed)("tan",{number:Math.tan,Complex:function(e){return e.tan()},BigNumber:function(e){return e.tan()},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function tan is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this,!0)}})}),Lu=["typed"],Hu=Object(s.a)("tanh",Lu,function(e){return(0,e.typed)("tanh",{number:E.p,Complex:function(e){return e.tanh()},BigNumber:function(e){return e.tanh()},Unit:function(e){if(!e.hasBase(e.constructor.BASE_UNITS.ANGLE))throw new TypeError("Unit in function tanh is no angle");return this(e.value)},"Array | Matrix":function(e){return oe(e,this,!0)}})}),$u="setCartesian",Gu=["typed","size","subset","compareNatural","Index","DenseMatrix"],Zu=Object(s.a)($u,Gu,function(e){var t=e.typed,s=e.size,u=e.subset,c=e.compareNatural,f=e.Index,l=e.DenseMatrix;return t($u,{"Array | Matrix, Array | Matrix":function(e,t){var r=[];if(0!==u(s(e),new f(0))&&0!==u(s(t),new f(0)))for(var n=Object(q.e)(Array.isArray(e)?e:e.toArray()).sort(c),i=Object(q.e)(Array.isArray(t)?t:t.toArray()).sort(c),r=[],a=0;a<n.length;a++)for(var o=0;o<i.length;o++)r.push([n[a],i[o]]);return Array.isArray(e)&&Array.isArray(t)?r:new l(r)}})}),Vu="setDifference",Ju=["typed","size","subset","compareNatural","Index","DenseMatrix"],Wu=Object(s.a)(Vu,Ju,function(e){var t=e.typed,u=e.size,c=e.subset,f=e.compareNatural,l=e.Index,p=e.DenseMatrix;return t(Vu,{"Array | Matrix, Array | Matrix":function(e,t){if(0===c(u(e),new l(0)))a=[];else{if(0===c(u(t),new l(0)))return Object(q.e)(e.toArray());for(var r,n=Object(q.i)(Object(q.e)(Array.isArray(e)?e:e.toArray()).sort(f)),i=Object(q.i)(Object(q.e)(Array.isArray(t)?t:t.toArray()).sort(f)),a=[],o=0;o<n.length;o++){r=!1;for(var s=0;s<i.length;s++)if(0===f(n[o].value,i[s].value)&&n[o].identifier===i[s].identifier){r=!0;break}r||a.push(n[o])}}return Array.isArray(e)&&Array.isArray(t)?Object(q.g)(a):new p(Object(q.g)(a))}})}),Yu="setDistinct",Xu=["typed","size","subset","compareNatural","Index","DenseMatrix"],Qu=Object(s.a)(Yu,Xu,function(e){var t=e.typed,i=e.size,a=e.subset,o=e.compareNatural,s=e.Index,u=e.DenseMatrix;return t(Yu,{"Array | Matrix":function(e){if(0===a(i(e),new s(0)))t=[];else{var t,r=Object(q.e)(Array.isArray(e)?e:e.toArray()).sort(o);(t=[]).push(r[0]);for(var n=1;n<r.length;n++)0!==o(r[n],r[n-1])&&t.push(r[n])}return Array.isArray(e)?t:new u(t)}})}),Ku="setIntersect",ec=["typed","size","subset","compareNatural","Index","DenseMatrix"],tc=Object(s.a)(Ku,ec,function(e){var t=e.typed,s=e.size,u=e.subset,c=e.compareNatural,f=e.Index,l=e.DenseMatrix;return t(Ku,{"Array | Matrix, Array | Matrix":function(e,t){if(0===u(s(e),new f(0))||0===u(s(t),new f(0)))i=[];else for(var r=Object(q.i)(Object(q.e)(Array.isArray(e)?e:e.toArray()).sort(c)),n=Object(q.i)(Object(q.e)(Array.isArray(t)?t:t.toArray()).sort(c)),i=[],a=0;a<r.length;a++)for(var o=0;o<n.length;o++)if(0===c(r[a].value,n[o].value)&&r[a].identifier===n[o].identifier){i.push(r[a]);break}return Array.isArray(e)&&Array.isArray(t)?Object(q.g)(i):new l(Object(q.g)(i))}})}),rc="setIsSubset",nc=["typed","size","subset","compareNatural","Index"],ic=Object(s.a)(rc,nc,function(e){var t=e.typed,s=e.size,u=e.subset,c=e.compareNatural,f=e.Index;return t(rc,{"Array | Matrix, Array | Matrix":function(e,t){if(0===u(s(e),new f(0)))return!0;if(0===u(s(t),new f(0)))return!1;for(var r,n=Object(q.i)(Object(q.e)(Array.isArray(e)?e:e.toArray()).sort(c)),i=Object(q.i)(Object(q.e)(Array.isArray(t)?t:t.toArray()).sort(c)),a=0;a<n.length;a++){r=!1;for(var o=0;o<i.length;o++)if(0===c(n[a].value,i[o].value)&&n[a].identifier===i[o].identifier){r=!0;break}if(!1===r)return!1}return!0}})}),ac="setMultiplicity",oc=["typed","size","subset","compareNatural","Index"],sc=Object(s.a)(ac,oc,function(e){var t=e.typed,a=e.size,o=e.subset,s=e.compareNatural,u=e.Index;return t(ac,{"number | BigNumber | Fraction | Complex, Array | Matrix":function(e,t){if(0===o(a(t),new u(0)))return 0;for(var r=Object(q.e)(Array.isArray(t)?t:t.toArray()),n=0,i=0;i<r.length;i++)0===s(r[i],e)&&n++;return n}})}),uc="setPowerset",cc=["typed","size","subset","compareNatural","Index"],fc=Object(s.a)(uc,cc,function(e){var t=e.typed,i=e.size,a=e.subset,o=e.compareNatural,s=e.Index;return t(uc,{"Array | Matrix":function(e){if(0===a(i(e),new s(0)))return[];for(var t=Object(q.e)(Array.isArray(e)?e:e.toArray()).sort(o),r=[],n=0;n.toString(2).length<=t.length;)r.push(function(e,t){for(var r=[],n=0;n<t.length;n++)"1"===t[n]&&r.push(e[n]);return r}(t,n.toString(2).split("").reverse())),n++;return function(e){for(var t=[],r=e.length-1;0<r;r--)for(var n=0;n<r;n++)e[n].length>e[n+1].length&&(t=e[n],e[n]=e[n+1],e[n+1]=t);return e}(r)}})}),lc="setSize",pc=["typed","compareNatural"],mc=Object(s.a)(lc,pc,function(e){var t=e.typed,a=e.compareNatural;return t(lc,{"Array | Matrix":function(e){return Array.isArray(e)?Object(q.e)(e).length:Object(q.e)(e.toArray()).length},"Array | Matrix, boolean":function(e,t){if(!1===t||0===e.length)return Array.isArray(e)?Object(q.e)(e).length:Object(q.e)(e.toArray()).length;for(var r=Object(q.e)(Array.isArray(e)?e:e.toArray()).sort(a),n=1,i=1;i<r.length;i++)0!==a(r[i],r[i-1])&&n++;return n}})}),hc="setSymDifference",dc=["typed","size","concat","subset","setDifference","Index"],yc=Object(s.a)(hc,dc,function(e){var t=e.typed,i=e.size,a=e.concat,o=e.subset,s=e.setDifference,u=e.Index;return t(hc,{"Array | Matrix, Array | Matrix":function(e,t){if(0===o(i(e),new u(0)))return Object(q.e)(t);if(0===o(i(t),new u(0)))return Object(q.e)(e);var r=Object(q.e)(e),n=Object(q.e)(t);return a(s(r,n),s(n,r))}})}),gc="setUnion",vc=["typed","size","concat","subset","setIntersect","setSymDifference","Index"],bc=Object(s.a)(gc,vc,function(e){var t=e.typed,i=e.size,a=e.concat,o=e.subset,s=e.setIntersect,u=e.setSymDifference,c=e.Index;return t(gc,{"Array | Matrix, Array | Matrix":function(e,t){if(0===o(i(e),new c(0)))return Object(q.e)(t);if(0===o(i(t),new c(0)))return Object(q.e)(e);var r=Object(q.e)(e),n=Object(q.e)(t);return a(u(r,n),s(r,n))}})}),xc=["typed","matrix","addScalar","equalScalar","DenseMatrix","SparseMatrix"],wc=Object(s.a)("add",xc,function(e){var t=e.typed,r=e.matrix,n=e.addScalar,i=e.equalScalar,a=e.DenseMatrix,o=(e.SparseMatrix,Ht({typed:t})),s=Gt({typed:t,equalScalar:i}),u=Vt({typed:t,DenseMatrix:a}),c=Wt({typed:t}),f=Xt({typed:t});return t("add",Object(ae.e)({"DenseMatrix, DenseMatrix":function(e,t){return c(e,t,n)},"DenseMatrix, SparseMatrix":function(e,t){return o(e,t,n,!1)},"SparseMatrix, DenseMatrix":function(e,t){return o(t,e,n,!0)},"SparseMatrix, SparseMatrix":function(e,t){return s(e,t,n)},"Array, Array":function(e,t){return this(r(e),r(t)).valueOf()},"Array, Matrix":function(e,t){return this(r(e),t)},"Matrix, Array":function(e,t){return this(e,r(t))},"DenseMatrix, any":function(e,t){return f(e,t,n,!1)},"SparseMatrix, any":function(e,t){return u(e,t,n,!1)},"any, DenseMatrix":function(e,t){return f(t,e,n,!0)},"any, SparseMatrix":function(e,t){return u(t,e,n,!0)},"Array, any":function(e,t){return f(r(e),t,n,!1).valueOf()},"any, Array":function(e,t){return f(r(t),e,n,!0).valueOf()},"any, any":n,"any, any, ...any":function(e,t,r){for(var n=this(e,t),i=0;i<r.length;i++)n=this(n,r[i]);return n}},n.signatures))}),Nc=["typed","abs","addScalar","divideScalar","multiplyScalar","sqrt","smaller","isPositive"],Oc=Object(s.a)("hypot",Nc,function(e){var t=e.typed,a=e.abs,o=e.addScalar,s=e.divideScalar,u=e.multiplyScalar,c=e.sqrt,f=e.smaller,l=e.isPositive;return t("hypot",{"... number | BigNumber":function(e){for(var t=0,r=0,n=0;n<e.length;n++){var i=a(e[n]);f(r,i)?(t=u(t,u(s(r,i),s(r,i))),t=o(t,1),r=i):t=o(t,l(i)?u(s(i,r),s(i,r)):i)}return u(r,c(t))},Array:function(e){return this.apply(this,Object(q.e)(e))},Matrix:function(e){return this.apply(this,Object(q.e)(e.toArray()))}})}),Mc=["typed","abs","add","pow","conj","sqrt","multiply","equalScalar","larger","smaller","matrix"],jc=Object(s.a)("norm",Mc,function(e){var t=e.typed,l=e.abs,p=e.add,m=e.pow,h=e.conj,d=e.sqrt,y=e.multiply,g=e.equalScalar,v=e.larger,b=e.smaller,r=e.matrix;return t("norm",{number:Math.abs,Complex:function(e){return e.abs()},BigNumber:function(e){return e.abs()},boolean:function(e){return Math.abs(e)},Array:function(e){return x(r(e),2)},Matrix:function(e){return x(e,2)},"number | Complex | BigNumber | boolean, number | BigNumber | string":function(e){return this(e)},"Array, number | BigNumber | string":function(e,t){return x(r(e),t)},"Matrix, number | BigNumber | string":x});function x(e,t){var r,n=e.size();if(1===n.length){if(t===Number.POSITIVE_INFINITY||"inf"===t){var i=0;return e.forEach(function(e){var t=l(e);v(t,i)&&(i=t)},!0),i}if(t===Number.NEGATIVE_INFINITY||"-inf"===t)return e.forEach(function(e){var t=l(e);r&&!b(t,r)||(r=t)},!0),r||0;if("fro"===t)return x(e,2);if("number"!=typeof t||isNaN(t))throw new Error("Unsupported parameter value");if(g(t,0))return Number.POSITIVE_INFINITY;var a=0;return e.forEach(function(e){a=p(m(l(e),t),a)},!0),m(a,1/t)}if(2===n.length){if(1===t){var o=[],s=0;return e.forEach(function(e,t){var r=t[1],n=p(o[r]||0,l(e));v(n,s)&&(s=n),o[r]=n},!0),s}if(t===Number.POSITIVE_INFINITY||"inf"===t){var u=[],c=0;return e.forEach(function(e,t){var r=t[0],n=p(u[r]||0,l(e));v(n,c)&&(c=n),u[r]=n},!0),c}if("fro"===t){var f=0;return e.forEach(function(e,t){f=p(f,y(e,h(e)))}),l(d(f))}if(2===t)throw new Error("Unsupported parameter value, missing implementation of matrix singular value decomposition");throw new Error("Unsupported parameter value")}}}),Ec=["typed","addScalar","multiplyScalar","conj","size"],Sc=Object(s.a)("dot",Ec,function(e){var x=e.typed,w=e.addScalar,N=e.multiplyScalar,O=e.conj,t=e.size;return x("dot",{"Array | DenseMatrix, Array | DenseMatrix":function(e,t){var r=M(e,t),n=Object(ie.v)(e)?e._data:e,i=Object(ie.v)(e)?e._datatype:void 0,a=Object(ie.v)(t)?t._data:t,o=Object(ie.v)(t)?t._datatype:void 0,s=2===j(e).length,u=2===j(t).length,c=w,f=N;{var l;i&&o&&i===o&&"string"==typeof i&&(l=i,c=x.find(w,[l,l]),f=x.find(N,[l,l]))}if(!s&&!u){for(var p=f(O(n[0]),a[0]),m=1;m<r;m++)p=c(p,f(O(n[m]),a[m]));return p}if(!s&&u){for(var h=f(O(n[0]),a[0][0]),d=1;d<r;d++)h=c(h,f(O(n[d]),a[d][0]));return h}if(s&&!u){for(var y=f(O(n[0][0]),a[0]),g=1;g<r;g++)y=c(y,f(O(n[g][0]),a[g]));return y}if(s&&u){for(var v=f(O(n[0][0]),a[0][0]),b=1;b<r;b++)v=c(v,f(O(n[b][0]),a[b][0]));return v}},"SparseMatrix, SparseMatrix":function(e,t){M(e,t);var r=e._index,n=e._values,i=t._index,a=t._values,o=0,s=w,u=N,c=0,f=0;for(;c<r.length&&f<i.length;){var l=r[c],p=i[f];l<p?c++:p<l?f++:l===p&&(o=s(o,u(n[c],a[f])),c++,f++)}return o}});function M(e,t){var r,n,i=j(e),a=j(t);if(1===i.length)r=i[0];else{if(2!==i.length||1!==i[1])throw new RangeError("Expected a column vector, instead got a matrix of size ("+i.join(", ")+")");r=i[0]}if(1===a.length)n=a[0];else{if(2!==a.length||1!==a[1])throw new RangeError("Expected a column vector, instead got a matrix of size ("+a.join(", ")+")");n=a[0]}if(r!==n)throw new RangeError("Vectors must have equal length ("+r+" != "+n+")");if(0===r)throw new RangeError("Cannot calculate the dot product of empty vectors");return r}function j(e){return Object(ie.v)(e)?e.size():t(e)}}),Ac=["typed","matrix","add"],Cc=Object(s.a)("trace",Ac,function(e){var t=e.typed,r=e.matrix,m=e.add;return t("trace",{Array:function(e){return n(r(e))},SparseMatrix:function(e){var t=e._values,r=e._index,n=e._ptr,i=e._size,a=i[0],o=i[1];if(a!==o)throw new RangeError("Matrix must be square (size: "+Object(V.d)(i)+")");var s=0;if(0<t.length)for(var u=0;u<o;u++)for(var c=n[u],f=n[u+1],l=c;l<f;l++){var p=r[l];if(p===u){s=m(s,t[l]);break}if(u<p)break}return s},DenseMatrix:n,any:ae.a});function n(e){var t=e._size,r=e._data;switch(t.length){case 1:if(1===t[0])return Object(ae.a)(r[0]);throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")");case 2:var n=t[0];if(n!==t[1])throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")");for(var i=0,a=0;a<n;a++)i=m(i,r[a][a]);return i;default:throw new RangeError("Matrix must be two dimensional (size: "+Object(V.d)(t)+")")}}}),Tc=["typed","Index"],_c=Object(s.a)("index",Tc,function(e){var t=e.typed,n=e.Index;return t("index",{"...number | string | BigNumber | Range | Array | Matrix":function(e){var t=e.map(function(e){return Object(ie.e)(e)?e.toNumber():Array.isArray(e)||Object(ie.v)(e)?e.map(function(e){return Object(ie.e)(e)?e.toNumber():e}):e}),r=new n;return n.apply(r,t),r}})}),qc={end:!0};function Ic(e){return(Ic="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var kc=["mathWithTransform"],Bc=Object(s.a)("Node",kc,function(e){var t=e.mathWithTransform;function r(){if(!(this instanceof r))throw new SyntaxError("Constructor must be called with the new operator")}return r.prototype.evaluate=function(e){return this.compile().evaluate(e)},r.prototype.type="Node",r.prototype.isNode=!0,r.prototype.comment="",r.prototype.compile=function(){var r=this._compile(t,{}),n={},i=null;return{evaluate:function(e){var t=e||{};return function(e){for(var t in e)if(Object(ae.f)(e,t)&&t in qc)throw new Error('Scope contains an illegal symbol, "'+t+'" is a reserved keyword')}(t),r(t,n,i)}}},r.prototype._compile=function(e,t){throw new Error("Method _compile should be implemented by type "+this.type)},r.prototype.forEach=function(e){throw new Error("Cannot run forEach on a Node interface")},r.prototype.map=function(e){throw new Error("Cannot run map on a Node interface")},r.prototype._ifNode=function(e){if(!Object(ie.w)(e))throw new TypeError("Callback function must return a Node");return e},r.prototype.traverse=function(e){e(this,null,null),function n(e,i){e.forEach(function(e,t,r){i(e,t,r),n(e,i)})}(this,e)},r.prototype.transform=function(a){return function e(t,r,n){var i=a(t,r,n);return i!==t?i:t.map(e)}(this,null,null)},r.prototype.filter=function(n){var i=[];return this.traverse(function(e,t,r){n(e,t,r)&&i.push(e)}),i},r.prototype.clone=function(){throw new Error("Cannot clone a Node interface")},r.prototype.cloneDeep=function(){return this.map(function(e){return e.cloneDeep()})},r.prototype.equals=function(e){return!!e&&Object(ae.d)(this,e)},r.prototype.toString=function(e){var t;if(e&&"object"===Ic(e))switch(Ic(e.handler)){case"object":case"undefined":break;case"function":t=e.handler(this,e);break;default:throw new TypeError("Object or function expected as callback")}return void 0!==t?t:this._toString(e)},r.prototype.toJSON=function(){throw new Error("Cannot serialize object: toJSON not implemented by "+this.type)},r.prototype.toHTML=function(e){var t;if(e&&"object"===Ic(e))switch(Ic(e.handler)){case"object":case"undefined":break;case"function":t=e.handler(this,e);break;default:throw new TypeError("Object or function expected as callback")}return void 0!==t?t:this.toHTML(e)},r.prototype._toString=function(){throw new Error("_toString not implemented for "+this.type)},r.prototype.toTex=function(e){var t;if(e&&"object"===Ic(e))switch(Ic(e.handler)){case"object":case"undefined":break;case"function":t=e.handler(this,e);break;default:throw new TypeError("Object or function expected as callback")}return void 0!==t?t:this._toTex(e)},r.prototype._toTex=function(e){throw new Error("_toTex not implemented for "+this.type)},r.prototype.getIdentifier=function(){return this.type},r.prototype.getContent=function(){return this},r},{isClass:!0,isNode:!0});function zc(e){return e&&e.isIndexError?new R.a(e.index+1,e.min+1,void 0!==e.max?e.max+1:void 0):e}function Dc(e){return(Dc="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Rc(e){var r=e.subset;return function(e,t){try{if(Array.isArray(e))return r(e,t);if(e&&"function"==typeof e.subset)return e.subset(t);if("string"==typeof e)return r(e,t);if("object"!==Dc(e))throw new TypeError("Cannot apply index: unsupported type of object");if(!t.isObjectProperty())throw new TypeError("Cannot apply a numeric index as object property");return zi(e,t.getObjectProperty())}catch(e){throw zc(e)}}}var Pc=["subset","Node"],Uc=Object(s.a)("AccessorNode",Pc,function(e){var t=e.subset,r=e.Node,s=Rc({subset:t});function n(e,t){if(!(this instanceof n))throw new SyntaxError("Constructor must be called with the new operator");if(!Object(ie.w)(e))throw new TypeError('Node expected for parameter "object"');if(!Object(ie.u)(t))throw new TypeError('IndexNode expected for parameter "index"');this.object=e||null,this.index=t,Object.defineProperty(this,"name",{get:function(){return this.index?this.index.isObjectProperty()?this.index.getObjectProperty():"":this.object.name||""}.bind(this),set:function(){throw new Error("Cannot assign a new name, name is read-only")}})}function i(e){return!(Object(ie.a)(e)||Object(ie.c)(e)||Object(ie.l)(e)||Object(ie.r)(e)||Object(ie.A)(e)||Object(ie.C)(e)||Object(ie.J)(e))}return(n.prototype=new r).type="AccessorNode",n.prototype.isAccessorNode=!0,n.prototype._compile=function(e,t){var a=this.object._compile(e,t),o=this.index._compile(e,t);if(this.index.isObjectProperty()){var n=this.index.getObjectProperty();return function(e,t,r){return zi(a(e,t,r),n)}}return function(e,t,r){var n=a(e,t,r),i=o(e,t,n);return s(n,i)}},n.prototype.forEach=function(e){e(this.object,"object",this),e(this.index,"index",this)},n.prototype.map=function(e){return new n(this._ifNode(e(this.object,"object",this)),this._ifNode(e(this.index,"index",this)))},n.prototype.clone=function(){return new n(this.object,this.index)},n.prototype._toString=function(e){var t=this.object.toString(e);return i(this.object)&&(t="("+t+")"),t+this.index.toString(e)},n.prototype.toHTML=function(e){var t=this.object.toHTML(e);return i(this.object)&&(t='<span class="math-parenthesis math-round-parenthesis">(</span>'+t+'<span class="math-parenthesis math-round-parenthesis">)</span>'),t+this.index.toHTML(e)},n.prototype._toTex=function(e){var t=this.object.toTex(e);return i(this.object)&&(t="\\left(' + object + '\\right)"),t+this.index.toTex(e)},n.prototype.toJSON=function(){return{mathjs:"AccessorNode",object:this.object,index:this.index}},n.fromJSON=function(e){return new n(e.object,e.index)},n},{isClass:!0,isNode:!0}),Fc=["Node"],Lc=Object(s.a)("ArrayNode",Fc,function(e){var t=e.Node;function n(e){if(!(this instanceof n))throw new SyntaxError("Constructor must be called with the new operator");if(this.items=e||[],!Array.isArray(this.items)||!this.items.every(ie.w))throw new TypeError("Array containing Nodes expected")}return(n.prototype=new t).type="ArrayNode",n.prototype.isArrayNode=!0,n.prototype._compile=function(t,r){var e=Object(q.k)(this.items,function(e){return e._compile(t,r)});if("Array"===t.config.matrix)return function(t,r,n){return Object(q.k)(e,function(e){return e(t,r,n)})};var i=t.matrix;return function(t,r,n){return i(Object(q.k)(e,function(e){return e(t,r,n)}))}},n.prototype.forEach=function(e){for(var t=0;t<this.items.length;t++){e(this.items[t],"items["+t+"]",this)}},n.prototype.map=function(e){for(var t=[],r=0;r<this.items.length;r++)t[r]=this._ifNode(e(this.items[r],"items["+r+"]",this));return new n(t)},n.prototype.clone=function(){return new n(this.items.slice(0))},n.prototype._toString=function(t){return"["+this.items.map(function(e){return e.toString(t)}).join(", ")+"]"},n.prototype.toJSON=function(){return{mathjs:"ArrayNode",items:this.items}},n.fromJSON=function(e){return new n(e.items)},n.prototype.toHTML=function(t){return'<span class="math-parenthesis math-square-parenthesis">[</span>'+this.items.map(function(e){return e.toHTML(t)}).join('<span class="math-separator">,</span>')+'<span class="math-parenthesis math-square-parenthesis">]</span>'},n.prototype._toTex=function(t){var r="\\begin{bmatrix}";return this.items.forEach(function(e){e.items?r+=e.items.map(function(e){return e.toTex(t)}).join("&"):r+=e.toTex(t),r+="\\\\"}),r+="\\end{bmatrix}"},n},{isClass:!0,isNode:!0});function Hc(e){return(Hc="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var $c=[{AssignmentNode:{},FunctionAssignmentNode:{}},{ConditionalNode:{latexLeftParens:!1,latexRightParens:!1,latexParens:!1}},{"OperatorNode:or":{associativity:"left",associativeWith:[]}},{"OperatorNode:xor":{associativity:"left",associativeWith:[]}},{"OperatorNode:and":{associativity:"left",associativeWith:[]}},{"OperatorNode:bitOr":{associativity:"left",associativeWith:[]}},{"OperatorNode:bitXor":{associativity:"left",associativeWith:[]}},{"OperatorNode:bitAnd":{associativity:"left",associativeWith:[]}},{"OperatorNode:equal":{associativity:"left",associativeWith:[]},"OperatorNode:unequal":{associativity:"left",associativeWith:[]},"OperatorNode:smaller":{associativity:"left",associativeWith:[]},"OperatorNode:larger":{associativity:"left",associativeWith:[]},"OperatorNode:smallerEq":{associativity:"left",associativeWith:[]},"OperatorNode:largerEq":{associativity:"left",associativeWith:[]},RelationalNode:{associativity:"left",associativeWith:[]}},{"OperatorNode:leftShift":{associativity:"left",associativeWith:[]},"OperatorNode:rightArithShift":{associativity:"left",associativeWith:[]},"OperatorNode:rightLogShift":{associativity:"left",associativeWith:[]}},{"OperatorNode:to":{associativity:"left",associativeWith:[]}},{RangeNode:{}},{"OperatorNode:add":{associativity:"left",associativeWith:["OperatorNode:add","OperatorNode:subtract"]},"OperatorNode:subtract":{associativity:"left",associativeWith:[]}},{"OperatorNode:multiply":{associativity:"left",associativeWith:["OperatorNode:multiply","OperatorNode:divide","Operator:dotMultiply","Operator:dotDivide"]},"OperatorNode:divide":{associativity:"left",associativeWith:[],latexLeftParens:!1,latexRightParens:!1,latexParens:!1},"OperatorNode:dotMultiply":{associativity:"left",associativeWith:["OperatorNode:multiply","OperatorNode:divide","OperatorNode:dotMultiply","OperatorNode:doDivide"]},"OperatorNode:dotDivide":{associativity:"left",associativeWith:[]},"OperatorNode:mod":{associativity:"left",associativeWith:[]}},{"OperatorNode:unaryPlus":{associativity:"right"},"OperatorNode:unaryMinus":{associativity:"right"},"OperatorNode:bitNot":{associativity:"right"},"OperatorNode:not":{associativity:"right"}},{"OperatorNode:pow":{associativity:"right",associativeWith:[],latexRightParens:!1},"OperatorNode:dotPow":{associativity:"right",associativeWith:[]}},{"OperatorNode:factorial":{associativity:"left"}},{"OperatorNode:transpose":{associativity:"left"}}];function Gc(e,t){var r=e;"keep"!==t&&(r=e.getContent());for(var n=r.getIdentifier(),i=0;i<$c.length;i++)if(n in $c[i])return i;return null}function Zc(e,t){var r=e;"keep"!==t&&(r=e.getContent());var n=r.getIdentifier(),i=Gc(r,t);if(null===i)return null;var a=$c[i][n];if(Object(ae.f)(a,"associativity")){if("left"===a.associativity)return"left";if("right"===a.associativity)return"right";throw Error("'"+n+"' has the invalid associativity '"+a.associativity+"'.")}return null}function Vc(e,t,r){var n="keep"!==r?e.getContent():e,i="keep"!==r?e.getContent():t,a=n.getIdentifier(),o=i.getIdentifier(),s=Gc(n,r);if(null===s)return null;var u=$c[s][a];if(Object(ae.f)(u,"associativeWith")&&u.associativeWith instanceof Array){for(var c=0;c<u.associativeWith.length;c++)if(u.associativeWith[c]===o)return!0;return!1}return null}var Jc=["subset","?matrix","Node"],Wc=Object(s.a)("AssignmentNode",Jc,function(e){var t,n,i,r=e.subset,a=e.matrix,o=e.Node,m=Rc({subset:r}),h=(n=(t={subset:r,matrix:a}).subset,i=t.matrix,function(e,t,r){try{if(Array.isArray(e))return i(e).subset(t,r).valueOf();if(e&&"function"==typeof e.subset)return e.subset(t,r);if("string"==typeof e)return n(e,t,r);if("object"!==Hc(e))throw new TypeError("Cannot apply index: unsupported type of object");if(!t.isObjectProperty())throw TypeError("Cannot apply a numeric index as object property");return Di(e,t.getObjectProperty(),r),e}catch(e){throw zc(e)}});function s(e,t,r){if(!(this instanceof s))throw new SyntaxError("Constructor must be called with the new operator");if(this.object=e,this.index=r?t:null,this.value=r||t,!Object(ie.J)(e)&&!Object(ie.a)(e))throw new TypeError('SymbolNode or AccessorNode expected as "object"');if(Object(ie.J)(e)&&"end"===e.name)throw new Error('Cannot assign to symbol "end"');if(this.index&&!Object(ie.u)(this.index))throw new TypeError('IndexNode expected as "index"');if(!Object(ie.w)(this.value))throw new TypeError('Node expected as "value"');Object.defineProperty(this,"name",{get:function(){return this.index?this.index.isObjectProperty()?this.index.getObjectProperty():"":this.object.name||""}.bind(this),set:function(){throw new Error("Cannot assign a new name, name is read-only")}})}function u(e,t){var r=Gc(e,t=t||"keep"),n=Gc(e.value,t);return"all"===t||null!==n&&n<=r}return(s.prototype=new o).type="AssignmentNode",s.prototype.isAssignmentNode=!0,s.prototype._compile=function(e,t){var o=this.object._compile(e,t),u=this.index?this.index._compile(e,t):null,c=this.value._compile(e,t),s=this.object.name;if(this.index){if(this.index.isObjectProperty()){var a=this.index.getObjectProperty();return function(e,t,r){var n=o(e,t,r),i=c(e,t,r);return Di(n,a,i)}}if(Object(ie.J)(this.object))return function(e,t,r){var n=o(e,t,r),i=c(e,t,r),a=u(e,t,n);return Di(e,s,h(n,a,i)),i};var f=this.object.object._compile(e,t);if(this.object.index.isObjectProperty()){var l=this.object.index.getObjectProperty();return function(e,t,r){var n=f(e,t,r),i=zi(n,l),a=u(e,t,i),o=c(e,t,r);return Di(n,l,h(i,a,o)),o}}var p=this.object.index._compile(e,t);return function(e,t,r){var n=f(e,t,r),i=p(e,t,n),a=m(n,i),o=u(e,t,a),s=c(e,t,r);return h(n,i,h(a,o,s)),s}}if(!Object(ie.J)(this.object))throw new TypeError("SymbolNode expected as object");return function(e,t,r){return Di(e,s,c(e,t,r))}},s.prototype.forEach=function(e){e(this.object,"object",this),this.index&&e(this.index,"index",this),e(this.value,"value",this)},s.prototype.map=function(e){return new s(this._ifNode(e(this.object,"object",this)),this.index?this._ifNode(e(this.index,"index",this)):null,this._ifNode(e(this.value,"value",this)))},s.prototype.clone=function(){return new s(this.object,this.index,this.value)},s.prototype._toString=function(e){var t=this.object.toString(e),r=this.index?this.index.toString(e):"",n=this.value.toString(e);return u(this,e&&e.parenthesis)&&(n="("+n+")"),t+r+" = "+n},s.prototype.toJSON=function(){return{mathjs:"AssignmentNode",object:this.object,index:this.index,value:this.value}},s.fromJSON=function(e){return new s(e.object,e.index,e.value)},s.prototype.toHTML=function(e){var t=this.object.toHTML(e),r=this.index?this.index.toHTML(e):"",n=this.value.toHTML(e);return u(this,e&&e.parenthesis)&&(n='<span class="math-paranthesis math-round-parenthesis">(</span>'+n+'<span class="math-paranthesis math-round-parenthesis">)</span>'),t+r+'<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>'+n},s.prototype._toTex=function(e){var t=this.object.toTex(e),r=this.index?this.index.toTex(e):"",n=this.value.toTex(e);return u(this,e&&e.parenthesis)&&(n="\\left(".concat(n,"\\right)")),t+r+":="+n},s},{isClass:!0,isNode:!0}),Yc=["ResultSet","Node"],Xc=Object(s.a)("BlockNode",Yc,function(e){var o=e.ResultSet,t=e.Node;function a(e){if(!(this instanceof a))throw new SyntaxError("Constructor must be called with the new operator");if(!Array.isArray(e))throw new Error("Array expected");this.blocks=e.map(function(e){var t=e&&e.node,r=!e||void 0===e.visible||e.visible;if(!Object(ie.w)(t))throw new TypeError('Property "node" must be a Node');if("boolean"!=typeof r)throw new TypeError('Property "visible" must be a boolean');return{node:t,visible:r}})}return(a.prototype=new t).type="BlockNode",a.prototype.isBlockNode=!0,a.prototype._compile=function(t,r){var e=Object(q.k)(this.blocks,function(e){return{evaluate:e.node._compile(t,r),visible:e.visible}});return function(r,n,i){var a=[];return Object(q.f)(e,function(e){var t=e.evaluate(r,n,i);e.visible&&a.push(t)}),new o(a)}},a.prototype.forEach=function(e){for(var t=0;t<this.blocks.length;t++)e(this.blocks[t].node,"blocks["+t+"].node",this)},a.prototype.map=function(e){for(var t=[],r=0;r<this.blocks.length;r++){var n=this.blocks[r],i=this._ifNode(e(n.node,"blocks["+r+"].node",this));t[r]={node:i,visible:n.visible}}return new a(t)},a.prototype.clone=function(){return new a(this.blocks.map(function(e){return{node:e.node,visible:e.visible}}))},a.prototype._toString=function(t){return this.blocks.map(function(e){return e.node.toString(t)+(e.visible?"":";")}).join("\n")},a.prototype.toJSON=function(){return{mathjs:"BlockNode",blocks:this.blocks}},a.fromJSON=function(e){return new a(e.blocks)},a.prototype.toHTML=function(t){return this.blocks.map(function(e){return e.node.toHTML(t)+(e.visible?"":'<span class="math-separator">;</span>')}).join('<span class="math-separator"><br /></span>')},a.prototype._toTex=function(t){return this.blocks.map(function(e){return e.node.toTex(t)+(e.visible?"":";")}).join("\\;\\;\n")},a},{isClass:!0,isNode:!0}),Qc=["Node"],Kc=Object(s.a)("ConditionalNode",Qc,function(e){var t=e.Node;function n(e,t,r){if(!(this instanceof n))throw new SyntaxError("Constructor must be called with the new operator");if(!Object(ie.w)(e))throw new TypeError("Parameter condition must be a Node");if(!Object(ie.w)(t))throw new TypeError("Parameter trueExpr must be a Node");if(!Object(ie.w)(r))throw new TypeError("Parameter falseExpr must be a Node");this.condition=e,this.trueExpr=t,this.falseExpr=r}return(n.prototype=new t).type="ConditionalNode",n.prototype.isConditionalNode=!0,n.prototype._compile=function(e,t){var n=this.condition._compile(e,t),i=this.trueExpr._compile(e,t),a=this.falseExpr._compile(e,t);return function(e,t,r){return(function(e){if("number"==typeof e||"boolean"==typeof e||"string"==typeof e)return!!e;if(e){if(Object(ie.e)(e))return!e.isZero();if(Object(ie.j)(e))return!(!e.re&&!e.im);if(Object(ie.L)(e))return!!e.value}if(null!=e)throw new TypeError('Unsupported type of condition "'+Object(ie.M)(e)+'"');return!1}(n(e,t,r))?i:a)(e,t,r)}},n.prototype.forEach=function(e){e(this.condition,"condition",this),e(this.trueExpr,"trueExpr",this),e(this.falseExpr,"falseExpr",this)},n.prototype.map=function(e){return new n(this._ifNode(e(this.condition,"condition",this)),this._ifNode(e(this.trueExpr,"trueExpr",this)),this._ifNode(e(this.falseExpr,"falseExpr",this)))},n.prototype.clone=function(){return new n(this.condition,this.trueExpr,this.falseExpr)},n.prototype._toString=function(e){var t=e&&e.parenthesis?e.parenthesis:"keep",r=Gc(this,t),n=this.condition.toString(e),i=Gc(this.condition,t);("all"===t||"OperatorNode"===this.condition.type||null!==i&&i<=r)&&(n="("+n+")");var a=this.trueExpr.toString(e),o=Gc(this.trueExpr,t);("all"===t||"OperatorNode"===this.trueExpr.type||null!==o&&o<=r)&&(a="("+a+")");var s=this.falseExpr.toString(e),u=Gc(this.falseExpr,t);return("all"===t||"OperatorNode"===this.falseExpr.type||null!==u&&u<=r)&&(s="("+s+")"),n+" ? "+a+" : "+s},n.prototype.toJSON=function(){return{mathjs:"ConditionalNode",condition:this.condition,trueExpr:this.trueExpr,falseExpr:this.falseExpr}},n.fromJSON=function(e){return new n(e.condition,e.trueExpr,e.falseExpr)},n.prototype.toHTML=function(e){var t=e&&e.parenthesis?e.parenthesis:"keep",r=Gc(this,t),n=this.condition.toHTML(e),i=Gc(this.condition,t);("all"===t||"OperatorNode"===this.condition.type||null!==i&&i<=r)&&(n='<span class="math-parenthesis math-round-parenthesis">(</span>'+n+'<span class="math-parenthesis math-round-parenthesis">)</span>');var a=this.trueExpr.toHTML(e),o=Gc(this.trueExpr,t);("all"===t||"OperatorNode"===this.trueExpr.type||null!==o&&o<=r)&&(a='<span class="math-parenthesis math-round-parenthesis">(</span>'+a+'<span class="math-parenthesis math-round-parenthesis">)</span>');var s=this.falseExpr.toHTML(e),u=Gc(this.falseExpr,t);return("all"===t||"OperatorNode"===this.falseExpr.type||null!==u&&u<=r)&&(s='<span class="math-parenthesis math-round-parenthesis">(</span>'+s+'<span class="math-parenthesis math-round-parenthesis">)</span>'),n+'<span class="math-operator math-conditional-operator">?</span>'+a+'<span class="math-operator math-conditional-operator">:</span>'+s},n.prototype._toTex=function(e){return"\\begin{cases} {"+this.trueExpr.toTex(e)+"}, &\\quad{\\text{if }\\;"+this.condition.toTex(e)+"}\\\\{"+this.falseExpr.toTex(e)+"}, &\\quad{\\text{otherwise}}\\end{cases}"},n},{isClass:!0,isNode:!0}),ef=r(16),tf=r.n(ef),rf={Alpha:"A",alpha:"\\alpha",Beta:"B",beta:"\\beta",Gamma:"\\Gamma",gamma:"\\gamma",Delta:"\\Delta",delta:"\\delta",Epsilon:"E",epsilon:"\\epsilon",varepsilon:"\\varepsilon",Zeta:"Z",zeta:"\\zeta",Eta:"H",eta:"\\eta",Theta:"\\Theta",theta:"\\theta",vartheta:"\\vartheta",Iota:"I",iota:"\\iota",Kappa:"K",kappa:"\\kappa",varkappa:"\\varkappa",Lambda:"\\Lambda",lambda:"\\lambda",Mu:"M",mu:"\\mu",Nu:"N",nu:"\\nu",Xi:"\\Xi",xi:"\\xi",Omicron:"O",omicron:"o",Pi:"\\Pi",pi:"\\pi",varpi:"\\varpi",Rho:"P",rho:"\\rho",varrho:"\\varrho",Sigma:"\\Sigma",sigma:"\\sigma",varsigma:"\\varsigma",Tau:"T",tau:"\\tau",Upsilon:"\\Upsilon",upsilon:"\\upsilon",Phi:"\\Phi",phi:"\\phi",varphi:"\\varphi",Chi:"X",chi:"\\chi",Psi:"\\Psi",psi:"\\psi",Omega:"\\Omega",omega:"\\omega",true:"\\mathrm{True}",false:"\\mathrm{False}",i:"i",inf:"\\infty",Inf:"\\infty",infinity:"\\infty",Infinity:"\\infty",oo:"\\infty",lim:"\\lim",undefined:"\\mathbf{?}"},nf={transpose:"^\\top",ctranspose:"^H",factorial:"!",pow:"^",dotPow:".^\\wedge",unaryPlus:"+",unaryMinus:"-",bitNot:"\\~",not:"\\neg",multiply:"\\cdot",divide:"\\frac",dotMultiply:".\\cdot",dotDivide:".:",mod:"\\mod",add:"+",subtract:"-",to:"\\rightarrow",leftShift:"<<",rightArithShift:">>",rightLogShift:">>>",equal:"=",unequal:"\\neq",smaller:"<",larger:">",smallerEq:"\\leq",largerEq:"\\geq",bitAnd:"\\&",bitXor:"\\underline{|}",bitOr:"|",and:"\\wedge",xor:"\\veebar",or:"\\vee"},af={abs:{1:"\\left|${args[0]}\\right|"},add:{2:"\\left(${args[0]}".concat(nf.add,"${args[1]}\\right)")},cbrt:{1:"\\sqrt[3]{${args[0]}}"},ceil:{1:"\\left\\lceil${args[0]}\\right\\rceil"},cube:{1:"\\left(${args[0]}\\right)^3"},divide:{2:"\\frac{${args[0]}}{${args[1]}}"},dotDivide:{2:"\\left(${args[0]}".concat(nf.dotDivide,"${args[1]}\\right)")},dotMultiply:{2:"\\left(${args[0]}".concat(nf.dotMultiply,"${args[1]}\\right)")},dotPow:{2:"\\left(${args[0]}".concat(nf.dotPow,"${args[1]}\\right)")},exp:{1:"\\exp\\left(${args[0]}\\right)"},expm1:"\\left(e".concat(nf.pow,"{${args[0]}}-1\\right)"),fix:{1:"\\mathrm{${name}}\\left(${args[0]}\\right)"},floor:{1:"\\left\\lfloor${args[0]}\\right\\rfloor"},gcd:"\\gcd\\left(${args}\\right)",hypot:"\\hypot\\left(${args}\\right)",log:{1:"\\ln\\left(${args[0]}\\right)",2:"\\log_{${args[1]}}\\left(${args[0]}\\right)"},log10:{1:"\\log_{10}\\left(${args[0]}\\right)"},log1p:{1:"\\ln\\left(${args[0]}+1\\right)",2:"\\log_{${args[1]}}\\left(${args[0]}+1\\right)"},log2:"\\log_{2}\\left(${args[0]}\\right)",mod:{2:"\\left(${args[0]}".concat(nf.mod,"${args[1]}\\right)")},multiply:{2:"\\left(${args[0]}".concat(nf.multiply,"${args[1]}\\right)")},norm:{1:"\\left\\|${args[0]}\\right\\|",2:void 0},nthRoot:{2:"\\sqrt[${args[1]}]{${args[0]}}"},nthRoots:{2:"\\{y : $y^{args[1]} = {${args[0]}}\\}"},pow:{2:"\\left(${args[0]}\\right)".concat(nf.pow,"{${args[1]}}")},round:{1:"\\left\\lfloor${args[0]}\\right\\rceil",2:void 0},sign:{1:"\\mathrm{${name}}\\left(${args[0]}\\right)"},sqrt:{1:"\\sqrt{${args[0]}}"},square:{1:"\\left(${args[0]}\\right)^2"},subtract:{2:"\\left(${args[0]}".concat(nf.subtract,"${args[1]}\\right)")},unaryMinus:{1:"".concat(nf.unaryMinus,"\\left(${args[0]}\\right)")},unaryPlus:{1:"".concat(nf.unaryPlus,"\\left(${args[0]}\\right)")},bitAnd:{2:"\\left(${args[0]}".concat(nf.bitAnd,"${args[1]}\\right)")},bitNot:{1:nf.bitNot+"\\left(${args[0]}\\right)"},bitOr:{2:"\\left(${args[0]}".concat(nf.bitOr,"${args[1]}\\right)")},bitXor:{2:"\\left(${args[0]}".concat(nf.bitXor,"${args[1]}\\right)")},leftShift:{2:"\\left(${args[0]}".concat(nf.leftShift,"${args[1]}\\right)")},rightArithShift:{2:"\\left(${args[0]}".concat(nf.rightArithShift,"${args[1]}\\right)")},rightLogShift:{2:"\\left(${args[0]}".concat(nf.rightLogShift,"${args[1]}\\right)")},bellNumbers:{1:"\\mathrm{B}_{${args[0]}}"},catalan:{1:"\\mathrm{C}_{${args[0]}}"},stirlingS2:{2:"\\mathrm{S}\\left(${args}\\right)"},arg:{1:"\\arg\\left(${args[0]}\\right)"},conj:{1:"\\left(${args[0]}\\right)^*"},im:{1:"\\Im\\left\\lbrace${args[0]}\\right\\rbrace"},re:{1:"\\Re\\left\\lbrace${args[0]}\\right\\rbrace"},and:{2:"\\left(${args[0]}".concat(nf.and,"${args[1]}\\right)")},not:{1:nf.not+"\\left(${args[0]}\\right)"},or:{2:"\\left(${args[0]}".concat(nf.or,"${args[1]}\\right)")},xor:{2:"\\left(${args[0]}".concat(nf.xor,"${args[1]}\\right)")},cross:{2:"\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"},ctranspose:{1:"\\left(${args[0]}\\right)".concat(nf.ctranspose)},det:{1:"\\det\\left(${args[0]}\\right)"},dot:{2:"\\left(${args[0]}\\cdot${args[1]}\\right)"},expm:{1:"\\exp\\left(${args[0]}\\right)"},inv:{1:"\\left(${args[0]}\\right)^{-1}"},sqrtm:{1:"{${args[0]}}".concat(nf.pow,"{\\frac{1}{2}}")},trace:{1:"\\mathrm{tr}\\left(${args[0]}\\right)"},transpose:{1:"\\left(${args[0]}\\right)".concat(nf.transpose)},combinations:{2:"\\binom{${args[0]}}{${args[1]}}"},combinationsWithRep:{2:"\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"},factorial:{1:"\\left(${args[0]}\\right)".concat(nf.factorial)},gamma:{1:"\\Gamma\\left(${args[0]}\\right)"},equal:{2:"\\left(${args[0]}".concat(nf.equal,"${args[1]}\\right)")},larger:{2:"\\left(${args[0]}".concat(nf.larger,"${args[1]}\\right)")},largerEq:{2:"\\left(${args[0]}".concat(nf.largerEq,"${args[1]}\\right)")},smaller:{2:"\\left(${args[0]}".concat(nf.smaller,"${args[1]}\\right)")},smallerEq:{2:"\\left(${args[0]}".concat(nf.smallerEq,"${args[1]}\\right)")},unequal:{2:"\\left(${args[0]}".concat(nf.unequal,"${args[1]}\\right)")},erf:{1:"erf\\left(${args[0]}\\right)"},max:"\\max\\left(${args}\\right)",min:"\\min\\left(${args}\\right)",variance:"\\mathrm{Var}\\left(${args}\\right)",acos:{1:"\\cos^{-1}\\left(${args[0]}\\right)"},acosh:{1:"\\cosh^{-1}\\left(${args[0]}\\right)"},acot:{1:"\\cot^{-1}\\left(${args[0]}\\right)"},acoth:{1:"\\coth^{-1}\\left(${args[0]}\\right)"},acsc:{1:"\\csc^{-1}\\left(${args[0]}\\right)"},acsch:{1:"\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"},asec:{1:"\\sec^{-1}\\left(${args[0]}\\right)"},asech:{1:"\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"},asin:{1:"\\sin^{-1}\\left(${args[0]}\\right)"},asinh:{1:"\\sinh^{-1}\\left(${args[0]}\\right)"},atan:{1:"\\tan^{-1}\\left(${args[0]}\\right)"},atan2:{2:"\\mathrm{atan2}\\left(${args}\\right)"},atanh:{1:"\\tanh^{-1}\\left(${args[0]}\\right)"},cos:{1:"\\cos\\left(${args[0]}\\right)"},cosh:{1:"\\cosh\\left(${args[0]}\\right)"},cot:{1:"\\cot\\left(${args[0]}\\right)"},coth:{1:"\\coth\\left(${args[0]}\\right)"},csc:{1:"\\csc\\left(${args[0]}\\right)"},csch:{1:"\\mathrm{csch}\\left(${args[0]}\\right)"},sec:{1:"\\sec\\left(${args[0]}\\right)"},sech:{1:"\\mathrm{sech}\\left(${args[0]}\\right)"},sin:{1:"\\sin\\left(${args[0]}\\right)"},sinh:{1:"\\sinh\\left(${args[0]}\\right)"},tan:{1:"\\tan\\left(${args[0]}\\right)"},tanh:{1:"\\tanh\\left(${args[0]}\\right)"},to:{2:"\\left(${args[0]}".concat(nf.to,"${args[1]}\\right)")},numeric:function(e){return e.args[0].toTex()},number:{0:"0",1:"\\left(${args[0]}\\right)",2:"\\left(\\left(${args[0]}\\right)${args[1]}\\right)"},string:{0:'\\mathtt{""}',1:"\\mathrm{string}\\left(${args[0]}\\right)"},bignumber:{0:"0",1:"\\left(${args[0]}\\right)"},complex:{0:"0",1:"\\left(${args[0]}\\right)",2:"\\left(\\left(${args[0]}\\right)+".concat(rf.i,"\\cdot\\left(${args[1]}\\right)\\right)")},matrix:{0:"\\begin{bmatrix}\\end{bmatrix}",1:"\\left(${args[0]}\\right)",2:"\\left(${args[0]}\\right)"},sparse:{0:"\\begin{bsparse}\\end{bsparse}",1:"\\left(${args[0]}\\right)"},unit:{1:"\\left(${args[0]}\\right)",2:"\\left(\\left(${args[0]}\\right)${args[1]}\\right)"}},of={deg:"^\\circ"};function sf(e){return tf()(e,{preserveFormatting:!0})}function uf(e,t){return(t=void 0!==t&&t)?Object(ae.f)(of,e)?of[e]:"\\mathrm{"+sf(e)+"}":Object(ae.f)(rf,e)?rf[e]:sf(e)}var cf=["Node"],ff=Object(s.a)("ConstantNode",cf,function(e){var t=e.Node;function r(e){if(!(this instanceof r))throw new SyntaxError("Constructor must be called with the new operator");this.value=e}return(r.prototype=new t).type="ConstantNode",r.prototype.isConstantNode=!0,r.prototype._compile=function(e,t){var r=this.value;return function(){return r}},r.prototype.forEach=function(e){},r.prototype.map=function(e){return this.clone()},r.prototype.clone=function(){return new r(this.value)},r.prototype._toString=function(e){return Object(V.d)(this.value,e)},r.prototype.toHTML=function(e){var t=this._toString(e);switch(Object(ie.M)(this.value)){case"number":case"BigNumber":case"Fraction":return'<span class="math-number">'+t+"</span>";case"string":return'<span class="math-string">'+t+"</span>";case"boolean":return'<span class="math-boolean">'+t+"</span>";case"null":return'<span class="math-null-symbol">'+t+"</span>";case"undefined":return'<span class="math-undefined">'+t+"</span>";default:return'<span class="math-symbol">'+t+"</span>"}},r.prototype.toJSON=function(){return{mathjs:"ConstantNode",value:this.value}},r.fromJSON=function(e){return new r(e.value)},r.prototype._toTex=function(e){var t=this._toString(e);switch(Object(ie.M)(this.value)){case"string":return"\\mathtt{"+sf(t)+"}";case"number":case"BigNumber":if(!isFinite(this.value))return this.value.valueOf()<0?"-\\infty":"\\infty";var r=t.toLowerCase().indexOf("e");return-1!==r?t.substring(0,r)+"\\cdot10^{"+t.substring(r+1)+"}":t;case"Fraction":return this.value.toLatex();default:return t}},r},{isClass:!0,isNode:!0}),lf=["typed","Node"],pf=Object(s.a)("FunctionAssignmentNode",lf,function(e){var f=e.typed,t=e.Node;function n(e,t,r){if(!(this instanceof n))throw new SyntaxError("Constructor must be called with the new operator");if("string"!=typeof e)throw new TypeError('String expected for parameter "name"');if(!Array.isArray(t))throw new TypeError('Array containing strings or objects expected for parameter "params"');if(!Object(ie.w)(r))throw new TypeError('Node expected for parameter "expr"');if(e in qc)throw new Error('Illegal function name, "'+e+'" is a reserved keyword');this.name=e,this.params=t.map(function(e){return e&&e.name||e}),this.types=t.map(function(e){return e&&e.type||"any"}),this.expr=r}function a(e,t){var r=Gc(e,t),n=Gc(e.expr,t);return"all"===t||null!==n&&n<=r}return(n.prototype=new t).type="FunctionAssignmentNode",n.prototype.isFunctionAssignmentNode=!0,n.prototype._compile=function(e,t){var r=Object.create(t);Object(q.f)(this.params,function(e){r[e]=!0});var a=this.expr._compile(e,r),o=this.name,s=this.params,u=Object(q.j)(this.types,","),c=o+"("+Object(q.j)(this.params,", ")+")";return function(r,n,i){var e={};e[u]=function(){for(var e=Object.create(n),t=0;t<s.length;t++)e[s[t]]=arguments[t];return a(r,e,i)};var t=f(o,e);return t.syntax=c,Di(r,o,t),t}},n.prototype.forEach=function(e){e(this.expr,"expr",this)},n.prototype.map=function(e){var t=this._ifNode(e(this.expr,"expr",this));return new n(this.name,this.params.slice(0),t)},n.prototype.clone=function(){return new n(this.name,this.params.slice(0),this.expr)},n.prototype._toString=function(e){var t=e&&e.parenthesis?e.parenthesis:"keep",r=this.expr.toString(e);return a(this,t)&&(r="("+r+")"),this.name+"("+this.params.join(", ")+") = "+r},n.prototype.toJSON=function(){var r=this.types;return{mathjs:"FunctionAssignmentNode",name:this.name,params:this.params.map(function(e,t){return{name:e,type:r[t]}}),expr:this.expr}},n.fromJSON=function(e){return new n(e.name,e.params,e.expr)},n.prototype.toHTML=function(e){for(var t=e&&e.parenthesis?e.parenthesis:"keep",r=[],n=0;n<this.params.length;n++)r.push('<span class="math-symbol math-parameter">'+Object(V.c)(this.params[n])+"</span>");var i=this.expr.toHTML(e);return a(this,t)&&(i='<span class="math-parenthesis math-round-parenthesis">(</span>'+i+'<span class="math-parenthesis math-round-parenthesis">)</span>'),'<span class="math-function">'+Object(V.c)(this.name)+'</span><span class="math-parenthesis math-round-parenthesis">(</span>'+r.join('<span class="math-separator">,</span>')+'<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>'+i},n.prototype._toTex=function(e){var t=e&&e.parenthesis?e.parenthesis:"keep",r=this.expr.toTex(e);return a(this,t)&&(r="\\left(".concat(r,"\\right)")),"\\mathrm{"+this.name+"}\\left("+this.params.map(uf).join(",")+"\\right):="+r},n},{isClass:!0,isNode:!0});function mf(e){return function(e){if(Array.isArray(e))return hf(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return hf(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return hf(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function hf(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}var df=["Range","Node","size"],yf=Object(s.a)("IndexNode",df,function(e){var n=e.Range,t=e.Node,h=e.size;function i(e,t){if(!(this instanceof i))throw new SyntaxError("Constructor must be called with the new operator");if(this.dimensions=e,this.dotNotation=t||!1,!Array.isArray(e)||!e.every(ie.w))throw new TypeError('Array containing Nodes expected for parameter "dimensions"');if(this.dotNotation&&!this.isObjectProperty())throw new Error("dotNotation only applicable for object properties")}function d(e,t,r){return new n(Object(ie.e)(e)?e.toNumber():e,Object(ie.e)(t)?t.toNumber():t,Object(ie.e)(r)?r.toNumber():r)}return(i.prototype=new t).type="IndexNode",i.prototype.isIndexNode=!0,i.prototype._compile=function(p,m){var i=Object(q.k)(this.dimensions,function(e,a){if(Object(ie.E)(e)){if(e.needsEnd()){var t=Object.create(m);t.end=!0;var o=e.start._compile(p,t),s=e.end._compile(p,t),u=e.step?e.step._compile(p,t):function(){return 1};return function(e,t,r){var n=h(r).valueOf(),i=Object.create(t);return i.end=n[a],d(o(e,i,r),s(e,i,r),u(e,i,r))}}var n=e.start._compile(p,m),i=e.end._compile(p,m),c=e.step?e.step._compile(p,m):function(){return 1};return function(e,t,r){return d(n(e,t,r),i(e,t,r),c(e,t,r))}}if(Object(ie.J)(e)&&"end"===e.name){var r=Object.create(m);r.end=!0;var f=e._compile(p,r);return function(e,t,r){var n=h(r).valueOf(),i=Object.create(t);return i.end=n[a],f(e,i,r)}}var l=e._compile(p,m);return function(e,t,r){return l(e,t,r)}}),a=zi(p,"index");return function(t,r,n){var e=Object(q.k)(i,function(e){return e(t,r,n)});return a.apply(void 0,mf(e))}},i.prototype.forEach=function(e){for(var t=0;t<this.dimensions.length;t++)e(this.dimensions[t],"dimensions["+t+"]",this)},i.prototype.map=function(e){for(var t=[],r=0;r<this.dimensions.length;r++)t[r]=this._ifNode(e(this.dimensions[r],"dimensions["+r+"]",this));return new i(t,this.dotNotation)},i.prototype.clone=function(){return new i(this.dimensions.slice(0),this.dotNotation)},i.prototype.isObjectProperty=function(){return 1===this.dimensions.length&&Object(ie.l)(this.dimensions[0])&&"string"==typeof this.dimensions[0].value},i.prototype.getObjectProperty=function(){return this.isObjectProperty()?this.dimensions[0].value:null},i.prototype._toString=function(e){return this.dotNotation?"."+this.getObjectProperty():"["+this.dimensions.join(", ")+"]"},i.prototype.toJSON=function(){return{mathjs:"IndexNode",dimensions:this.dimensions,dotNotation:this.dotNotation}},i.fromJSON=function(e){return new i(e.dimensions,e.dotNotation)},i.prototype.toHTML=function(e){for(var t=[],r=0;r<this.dimensions.length;r++)t[r]=this.dimensions[r].toHTML();return this.dotNotation?'<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">'+Object(V.c)(this.getObjectProperty())+"</span>":'<span class="math-parenthesis math-square-parenthesis">[</span>'+t.join('<span class="math-separator">,</span>')+'<span class="math-parenthesis math-square-parenthesis">]</span>'},i.prototype._toTex=function(t){var e=this.dimensions.map(function(e){return e.toTex(t)});return this.dotNotation?"."+this.getObjectProperty():"_{"+e.join(",")+"}"},i},{isClass:!0,isNode:!0});function gf(e){return(gf="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var vf=["Node"],bf=Object(s.a)("ObjectNode",vf,function(e){var t=e.Node;function n(t){if(!(this instanceof n))throw new SyntaxError("Constructor must be called with the new operator");if(this.properties=t||{},t&&("object"!==gf(t)||!Object.keys(t).every(function(e){return Object(ie.w)(t[e])})))throw new TypeError("Object containing Nodes expected")}return(n.prototype=new t).type="ObjectNode",n.prototype.isObjectNode=!0,n.prototype._compile=function(e,t){var a={};for(var r in this.properties)if(Object(ae.f)(this.properties,r)){var n=Object(V.e)(r),i=JSON.parse(n);if(!Ri(this.properties,i))throw new Error('No access to property "'+i+'"');a[i]=this.properties[r]._compile(e,t)}return function(e,t,r){var n={};for(var i in a)Object(ae.f)(a,i)&&(n[i]=a[i](e,t,r));return n}},n.prototype.forEach=function(e){for(var t in this.properties)Object(ae.f)(this.properties,t)&&e(this.properties[t],"properties["+Object(V.e)(t)+"]",this)},n.prototype.map=function(e){var t={};for(var r in this.properties)Object(ae.f)(this.properties,r)&&(t[r]=this._ifNode(e(this.properties[r],"properties["+Object(V.e)(r)+"]",this)));return new n(t)},n.prototype.clone=function(){var e={};for(var t in this.properties)Object(ae.f)(this.properties,t)&&(e[t]=this.properties[t]);return new n(e)},n.prototype._toString=function(e){var t=[];for(var r in this.properties)Object(ae.f)(this.properties,r)&&t.push(Object(V.e)(r)+": "+this.properties[r].toString(e));return"{"+t.join(", ")+"}"},n.prototype.toJSON=function(){return{mathjs:"ObjectNode",properties:this.properties}},n.fromJSON=function(e){return new n(e.properties)},n.prototype.toHTML=function(e){var t=[];for(var r in this.properties)Object(ae.f)(this.properties,r)&&t.push('<span class="math-symbol math-property">'+Object(V.c)(r)+'</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>'+this.properties[r].toHTML(e));return'<span class="math-parenthesis math-curly-parenthesis">{</span>'+t.join('<span class="math-separator">,</span>')+'<span class="math-parenthesis math-curly-parenthesis">}</span>'},n.prototype._toTex=function(e){var t=[];for(var r in this.properties)Object(ae.f)(this.properties,r)&&t.push("\\mathbf{"+r+":} & "+this.properties[r].toTex(e)+"\\\\");return"\\left\\{\\begin{array}{ll}".concat(t.join("\n"),"\\end{array}\\right\\}")},n},{isClass:!0,isNode:!0}),xf=["Node"],wf=Object(s.a)("OperatorNode",xf,function(e){var t=e.Node;function i(e,t,r,n){if(!(this instanceof i))throw new SyntaxError("Constructor must be called with the new operator");if("string"!=typeof e)throw new TypeError('string expected for parameter "op"');if("string"!=typeof t)throw new TypeError('string expected for parameter "fn"');if(!Array.isArray(r)||!r.every(ie.w))throw new TypeError('Array containing Nodes expected for parameter "args"');this.implicit=!0===n,this.op=e,this.fn=t,this.args=r||[]}function m(i,a,e,t,r){var n,o=Gc(i,a),s=Zc(i,a);if("all"===a||2<t.length&&"OperatorNode:add"!==i.getIdentifier()&&"OperatorNode:multiply"!==i.getIdentifier())return t.map(function(e){switch(e.getContent().type){case"ArrayNode":case"ConstantNode":case"SymbolNode":case"ParenthesisNode":return!1;default:return!0}});switch(t.length){case 0:n=[];break;case 1:var u=Gc(t[0],a);if(r&&null!==u){var c,f="keep"===a?(c=t[0].getIdentifier(),i.getIdentifier()):(c=t[0].getContent().getIdentifier(),i.getContent().getIdentifier());if(!1===$c[o][f].latexLeftParens){n=[!1];break}if(!1===$c[u][c].latexParens){n=[!1];break}}if(null===u){n=[!1];break}if(u<=o){n=[!0];break}n=[!1];break;case 2:var l,p,m,h=Gc(t[0],a),d=Vc(i,t[0],a),y=null!==h&&(h===o&&"right"===s&&!d||h<o),g=Gc(t[1],a),v=Vc(i,t[1],a),b=null!==g&&(g===o&&"left"===s&&!v||g<o);r&&(m="keep"===a?(l=i.getIdentifier(),p=i.args[0].getIdentifier(),i.args[1].getIdentifier()):(l=i.getContent().getIdentifier(),p=i.args[0].getContent().getIdentifier(),i.args[1].getContent().getIdentifier()),null!==h&&(!1===$c[o][l].latexLeftParens&&(y=!1),!1===$c[h][p].latexParens&&(y=!1)),null!==g&&(!1===$c[o][l].latexRightParens&&(b=!1),!1===$c[g][m].latexParens&&(b=!1))),n=[y,b];break;default:"OperatorNode:add"!==i.getIdentifier()&&"OperatorNode:multiply"!==i.getIdentifier()||(n=t.map(function(e){var t=Gc(e,a),r=Vc(i,e,a),n=Zc(e,a);return null!==t&&(o===t&&s===n&&!r||t<o)}))}return 2<=t.length&&"OperatorNode:multiply"===i.getIdentifier()&&i.implicit&&"auto"===a&&"hide"===e&&(n=t.map(function(e,t){var r="ParenthesisNode"===e.getIdentifier();return!(!n[t]&&!r)})),n}return(i.prototype=new t).type="OperatorNode",i.prototype.isOperatorNode=!0,i.prototype._compile=function(t,r){if("string"!=typeof this.fn||!Pi(t,this.fn))throw t[this.fn]?new Error('No access to function "'+this.fn+'"'):new Error("Function "+this.fn+' missing in provided namespace "math"');var i=zi(t,this.fn),e=Object(q.k)(this.args,function(e){return e._compile(t,r)});if(1===e.length){var n=e[0];return function(e,t,r){return i(n(e,t,r))}}if(2!==e.length)return function(t,r,n){return i.apply(null,Object(q.k)(e,function(e){return e(t,r,n)}))};var a=e[0],o=e[1];return function(e,t,r){return i(a(e,t,r),o(e,t,r))}},i.prototype.forEach=function(e){for(var t=0;t<this.args.length;t++)e(this.args[t],"args["+t+"]",this)},i.prototype.map=function(e){for(var t=[],r=0;r<this.args.length;r++)t[r]=this._ifNode(e(this.args[r],"args["+r+"]",this));return new i(this.op,this.fn,t,this.implicit)},i.prototype.clone=function(){return new i(this.op,this.fn,this.args.slice(0),this.implicit)},i.prototype.isUnary=function(){return 1===this.args.length},i.prototype.isBinary=function(){return 2===this.args.length},i.prototype._toString=function(r){var e=r&&r.parenthesis?r.parenthesis:"keep",t=r&&r.implicit?r.implicit:"hide",n=this.args,i=m(this,e,t,n,!1);if(1===n.length){var a=Zc(this,e),o=n[0].toString(r);i[0]&&(o="("+o+")");var s=/[a-zA-Z]+/.test(this.op);return"right"===a?this.op+(s?" ":"")+o:"left"===a?o+(s?" ":"")+this.op:o+this.op}if(2===n.length){var u=n[0].toString(r),c=n[1].toString(r);return i[0]&&(u="("+u+")"),i[1]&&(c="("+c+")"),this.implicit&&"OperatorNode:multiply"===this.getIdentifier()&&"hide"===t?u+" "+c:u+" "+this.op+" "+c}if(2<n.length&&("OperatorNode:add"===this.getIdentifier()||"OperatorNode:multiply"===this.getIdentifier())){var f=n.map(function(e,t){return e=e.toString(r),i[t]&&(e="("+e+")"),e});return this.implicit&&"OperatorNode:multiply"===this.getIdentifier()&&"hide"===t?f.join(" "):f.join(" "+this.op+" ")}return this.fn+"("+this.args.join(", ")+")"},i.prototype.toJSON=function(){return{mathjs:"OperatorNode",op:this.op,fn:this.fn,args:this.args,implicit:this.implicit}},i.fromJSON=function(e){return new i(e.op,e.fn,e.args,e.implicit)},i.prototype.toHTML=function(r){var e=r&&r.parenthesis?r.parenthesis:"keep",t=r&&r.implicit?r.implicit:"hide",n=this.args,i=m(this,e,t,n,!1);if(1===n.length){var a=Zc(this,e),o=n[0].toHTML(r);return i[0]&&(o='<span class="math-parenthesis math-round-parenthesis">(</span>'+o+'<span class="math-parenthesis math-round-parenthesis">)</span>'),"right"===a?'<span class="math-operator math-unary-operator math-lefthand-unary-operator">'+Object(V.c)(this.op)+"</span>"+o:o+'<span class="math-operator math-unary-operator math-righthand-unary-operator">'+Object(V.c)(this.op)+"</span>"}if(2===n.length){var s=n[0].toHTML(r),u=n[1].toHTML(r);return i[0]&&(s='<span class="math-parenthesis math-round-parenthesis">(</span>'+s+'<span class="math-parenthesis math-round-parenthesis">)</span>'),i[1]&&(u='<span class="math-parenthesis math-round-parenthesis">(</span>'+u+'<span class="math-parenthesis math-round-parenthesis">)</span>'),this.implicit&&"OperatorNode:multiply"===this.getIdentifier()&&"hide"===t?s+'<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>'+u:s+'<span class="math-operator math-binary-operator math-explicit-binary-operator">'+Object(V.c)(this.op)+"</span>"+u}var c=n.map(function(e,t){return e=e.toHTML(r),i[t]&&(e='<span class="math-parenthesis math-round-parenthesis">(</span>'+e+'<span class="math-parenthesis math-round-parenthesis">)</span>'),e});return 2<n.length&&("OperatorNode:add"===this.getIdentifier()||"OperatorNode:multiply"===this.getIdentifier())?this.implicit&&"OperatorNode:multiply"===this.getIdentifier()&&"hide"===t?c.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>'):c.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">'+Object(V.c)(this.op)+"</span>"):'<span class="math-function">'+Object(V.c)(this.fn)+'</span><span class="math-paranthesis math-round-parenthesis">(</span>'+c.join('<span class="math-separator">,</span>')+'<span class="math-paranthesis math-round-parenthesis">)</span>'},i.prototype._toTex=function(r){var e=r&&r.parenthesis?r.parenthesis:"keep",t=r&&r.implicit?r.implicit:"hide",n=this.args,i=m(this,e,t,n,!0),a=void 0===(a=nf[this.fn])?this.op:a;if(1===n.length){var o=Zc(this,e),s=n[0].toTex(r);return i[0]&&(s="\\left(".concat(s,"\\right)")),"right"===o?a+s:s+a}if(2===n.length){var u=n[0],c=u.toTex(r);i[0]&&(c="\\left(".concat(c,"\\right)"));var f,l=n[1].toTex(r);switch(i[1]&&(l="\\left(".concat(l,"\\right)")),f="keep"===e?u.getIdentifier():u.getContent().getIdentifier(),this.getIdentifier()){case"OperatorNode:divide":return a+"{"+c+"}{"+l+"}";case"OperatorNode:pow":switch(c="{"+c+"}",l="{"+l+"}",f){case"ConditionalNode":case"OperatorNode:divide":c="\\left(".concat(c,"\\right)")}break;case"OperatorNode:multiply":if(this.implicit&&"hide"===t)return c+"~"+l}return c+a+l}if(2<n.length&&("OperatorNode:add"===this.getIdentifier()||"OperatorNode:multiply"===this.getIdentifier())){var p=n.map(function(e,t){return e=e.toTex(r),i[t]&&(e="\\left(".concat(e,"\\right)")),e});return"OperatorNode:multiply"===this.getIdentifier()&&this.implicit?p.join("~"):p.join(a)}return"\\mathrm{"+this.fn+"}\\left("+n.map(function(e){return e.toTex(r)}).join(",")+"\\right)"},i.prototype.getIdentifier=function(){return this.type+":"+this.fn},i},{isClass:!0,isNode:!0}),Nf=["Node"],Of=Object(s.a)("ParenthesisNode",Nf,function(e){var t=e.Node;function r(e){if(!(this instanceof r))throw new SyntaxError("Constructor must be called with the new operator");if(!Object(ie.w)(e))throw new TypeError('Node expected for parameter "content"');this.content=e}return(r.prototype=new t).type="ParenthesisNode",r.prototype.isParenthesisNode=!0,r.prototype._compile=function(e,t){return this.content._compile(e,t)},r.prototype.getContent=function(){return this.content.getContent()},r.prototype.forEach=function(e){e(this.content,"content",this)},r.prototype.map=function(e){return new r(e(this.content,"content",this))},r.prototype.clone=function(){return new r(this.content)},r.prototype._toString=function(e){return!e||e&&!e.parenthesis||e&&"keep"===e.parenthesis?"("+this.content.toString(e)+")":this.content.toString(e)},r.prototype.toJSON=function(){return{mathjs:"ParenthesisNode",content:this.content}},r.fromJSON=function(e){return new r(e.content)},r.prototype.toHTML=function(e){return!e||e&&!e.parenthesis||e&&"keep"===e.parenthesis?'<span class="math-parenthesis math-round-parenthesis">(</span>'+this.content.toHTML(e)+'<span class="math-parenthesis math-round-parenthesis">)</span>':this.content.toHTML(e)},r.prototype._toTex=function(e){return!e||e&&!e.parenthesis||e&&"keep"===e.parenthesis?"\\left(".concat(this.content.toTex(e),"\\right)"):this.content.toTex(e)},r},{isClass:!0,isNode:!0}),Mf=["Node"],jf=Object(s.a)("RangeNode",Mf,function(e){var t=e.Node;function n(e,t,r){if(!(this instanceof n))throw new SyntaxError("Constructor must be called with the new operator");if(!Object(ie.w)(e))throw new TypeError("Node expected");if(!Object(ie.w)(t))throw new TypeError("Node expected");if(r&&!Object(ie.w)(r))throw new TypeError("Node expected");if(3<arguments.length)throw new Error("Too many arguments");this.start=e,this.end=t,this.step=r||null}function o(e,t){var r,n=Gc(e,t),i={},a=Gc(e.start,t);i.start=null!==a&&a<=n||"all"===t,e.step&&(r=Gc(e.step,t),i.step=null!==r&&r<=n||"all"===t);var o=Gc(e.end,t);return i.end=null!==o&&o<=n||"all"===t,i}return(n.prototype=new t).type="RangeNode",n.prototype.isRangeNode=!0,n.prototype.needsEnd=function(){return 0<this.filter(function(e){return Object(ie.J)(e)&&"end"===e.name}).length},n.prototype._compile=function(e,t){var n=e.range,i=this.start._compile(e,t),a=this.end._compile(e,t);if(this.step){var o=this.step._compile(e,t);return function(e,t,r){return n(i(e,t,r),a(e,t,r),o(e,t,r))}}return function(e,t,r){return n(i(e,t,r),a(e,t,r))}},n.prototype.forEach=function(e){e(this.start,"start",this),e(this.end,"end",this),this.step&&e(this.step,"step",this)},n.prototype.map=function(e){return new n(this._ifNode(e(this.start,"start",this)),this._ifNode(e(this.end,"end",this)),this.step&&this._ifNode(e(this.step,"step",this)))},n.prototype.clone=function(){return new n(this.start,this.end,this.step&&this.step)},n.prototype._toString=function(e){var t,r,n=o(this,e&&e.parenthesis?e.parenthesis:"keep"),i=this.start.toString(e);n.start&&(i="("+i+")"),t=i,this.step&&(r=this.step.toString(e),n.step&&(r="("+r+")"),t+=":"+r);var a=this.end.toString(e);return n.end&&(a="("+a+")"),t+=":"+a},n.prototype.toJSON=function(){return{mathjs:"RangeNode",start:this.start,end:this.end,step:this.step}},n.fromJSON=function(e){return new n(e.start,e.end,e.step)},n.prototype.toHTML=function(e){var t,r,n=o(this,e&&e.parenthesis?e.parenthesis:"keep"),i=this.start.toHTML(e);n.start&&(i='<span class="math-parenthesis math-round-parenthesis">(</span>'+i+'<span class="math-parenthesis math-round-parenthesis">)</span>'),t=i,this.step&&(r=this.step.toHTML(e),n.step&&(r='<span class="math-parenthesis math-round-parenthesis">(</span>'+r+'<span class="math-parenthesis math-round-parenthesis">)</span>'),t+='<span class="math-operator math-range-operator">:</span>'+r);var a=this.end.toHTML(e);return n.end&&(a='<span class="math-parenthesis math-round-parenthesis">(</span>'+a+'<span class="math-parenthesis math-round-parenthesis">)</span>'),t+='<span class="math-operator math-range-operator">:</span>'+a},n.prototype._toTex=function(e){var t,r=o(this,e&&e.parenthesis?e.parenthesis:"keep"),n=this.start.toTex(e);r.start&&(n="\\left(".concat(n,"\\right)")),this.step&&(t=this.step.toTex(e),r.step&&(t="\\left(".concat(t,"\\right)")),n+=":"+t);var i=this.end.toTex(e);return r.end&&(i="\\left(".concat(i,"\\right)")),n+=":"+i},n},{isClass:!0,isNode:!0}),Ef=["Node"],Sf=Object(s.a)("RelationalNode",Ef,function(e){var t=e.Node;function i(e,t){if(!(this instanceof i))throw new SyntaxError("Constructor must be called with the new operator");if(!Array.isArray(e))throw new TypeError("Parameter conditionals must be an array");if(!Array.isArray(t))throw new TypeError("Parameter params must be an array");if(e.length!==t.length-1)throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");this.conditionals=e,this.params=t}return(i.prototype=new t).type="RelationalNode",i.prototype.isRelationalNode=!0,i.prototype._compile=function(o,t){var s=this,u=this.params.map(function(e){return e._compile(o,t)});return function(e,t,r){for(var n=u[0](e,t,r),i=0;i<s.conditionals.length;i++){var a=n,n=u[i+1](e,t,r);if(!zi(o,s.conditionals[i])(a,n))return!1}return!0}},i.prototype.forEach=function(r){var n=this;this.params.forEach(function(e,t){return r(e,"params["+t+"]",n)},this)},i.prototype.map=function(r){var n=this;return new i(this.conditionals.slice(),this.params.map(function(e,t){return n._ifNode(r(e,"params["+t+"]",n))},this))},i.prototype.clone=function(){return new i(this.conditionals,this.params)},i.prototype._toString=function(n){for(var i=n&&n.parenthesis?n.parenthesis:"keep",a=Gc(this,i),e=this.params.map(function(e,t){var r=Gc(e,i);return"all"===i||null!==r&&r<=a?"("+e.toString(n)+")":e.toString(n)}),t={equal:"==",unequal:"!=",smaller:"<",larger:">",smallerEq:"<=",largerEq:">="},r=e[0],o=0;o<this.conditionals.length;o++)r+=" "+t[this.conditionals[o]]+" "+e[o+1];return r},i.prototype.toJSON=function(){return{mathjs:"RelationalNode",conditionals:this.conditionals,params:this.params}},i.fromJSON=function(e){return new i(e.conditionals,e.params)},i.prototype.toHTML=function(n){for(var i=n&&n.parenthesis?n.parenthesis:"keep",a=Gc(this,i),e=this.params.map(function(e,t){var r=Gc(e,i);return"all"===i||null!==r&&r<=a?'<span class="math-parenthesis math-round-parenthesis">(</span>'+e.toHTML(n)+'<span class="math-parenthesis math-round-parenthesis">)</span>':e.toHTML(n)}),t={equal:"==",unequal:"!=",smaller:"<",larger:">",smallerEq:"<=",largerEq:">="},r=e[0],o=0;o<this.conditionals.length;o++)r+='<span class="math-operator math-binary-operator math-explicit-binary-operator">'+Object(V.c)(t[this.conditionals[o]])+"</span>"+e[o+1];return r},i.prototype._toTex=function(n){for(var i=n&&n.parenthesis?n.parenthesis:"keep",a=Gc(this,i),e=this.params.map(function(e,t){var r=Gc(e,i);return"all"===i||null!==r&&r<=a?"\\left("+e.toTex(n)+"\right)":e.toTex(n)}),t=e[0],r=0;r<this.conditionals.length;r++)t+=nf[this.conditionals[r]]+e[r+1];return t},i},{isClass:!0,isNode:!0}),Af=["math","?Unit","Node"],Cf=Object(s.a)("SymbolNode",Af,function(e){var n=e.math,o=e.Unit,t=e.Node;function s(e){return!!o&&o.isValuelessUnit(e)}function r(e){if(!(this instanceof r))throw new SyntaxError("Constructor must be called with the new operator");if("string"!=typeof e)throw new TypeError('String expected for parameter "name"');this.name=e}return(r.prototype=new t).type="SymbolNode",r.prototype.isSymbolNode=!0,r.prototype._compile=function(n,e){var i=this.name;if(!0===e[i])return function(e,t,r){return t[i]};if(i in n)return function(e,t,r){return i in e?zi(e,i):zi(n,i)};var a=s(i);return function(e,t,r){return i in e?zi(e,i):a?new o(null,i):function(e){throw new Error("Undefined symbol "+e)}(i)}},r.prototype.forEach=function(e){},r.prototype.map=function(e){return this.clone()},r.prototype.clone=function(){return new r(this.name)},r.prototype._toString=function(e){return this.name},r.prototype.toHTML=function(e){var t=Object(V.c)(this.name);return"true"===t||"false"===t?'<span class="math-symbol math-boolean">'+t+"</span>":"i"===t?'<span class="math-symbol math-imaginary-symbol">'+t+"</span>":"Infinity"===t?'<span class="math-symbol math-infinity-symbol">'+t+"</span>":"NaN"===t?'<span class="math-symbol math-nan-symbol">'+t+"</span>":"null"===t?'<span class="math-symbol math-null-symbol">'+t+"</span>":"undefined"===t?'<span class="math-symbol math-undefined-symbol">'+t+"</span>":'<span class="math-symbol">'+t+"</span>"},r.prototype.toJSON=function(){return{mathjs:"SymbolNode",name:this.name}},r.fromJSON=function(e){return new r(e.name)},r.prototype._toTex=function(e){var t=!1;void 0===n[this.name]&&s(this.name)&&(t=!0);var r=uf(this.name,t);return"\\"===r[0]?r:" "+r},r},{isClass:!0,isNode:!0});function Tf(e){return(Tf="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _f(){return(_f=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}var qf=["math","Node","SymbolNode"],If=Object(s.a)("FunctionNode",qf,function(e){var i=e.math,t=e.Node,r=e.SymbolNode;function d(e,t){if(!(this instanceof d))throw new SyntaxError("Constructor must be called with the new operator");if("string"==typeof e&&(e=new r(e)),!Object(ie.w)(e))throw new TypeError('Node expected as parameter "fn"');if(!Array.isArray(t)||!t.every(ie.w))throw new TypeError('Array containing Nodes expected for parameter "args"');this.fn=e,this.args=t||[],Object.defineProperty(this,"name",{get:function(){return this.fn.name||""}.bind(this),set:function(){throw new Error("Cannot assign a new name, name is read-only")}})}(d.prototype=new t).type="FunctionNode",d.prototype.isFunctionNode=!0,d.prototype._compile=function(i,t){if(!(this instanceof d))throw new TypeError("No valid FunctionNode");var a=Object(q.k)(this.args,function(e){return e._compile(i,t)});if(Object(ie.J)(this.fn)){var o=this.fn.name,s=o in i?zi(i,o):void 0;if("function"==typeof s&&!0===s.rawArgs){var r=this.args;return function(e,t){return(o in e?zi(e,o):s)(r,i,_f({},e,t))}}if(1===a.length){var n=a[0];return function(e,t,r){return(o in e?zi(e,o):s)(n(e,t,r))}}if(2!==a.length)return function(t,r,n){return(o in t?zi(t,o):s).apply(null,Object(q.k)(a,function(e){return e(t,r,n)}))};var u=a[0],c=a[1];return function(e,t,r){return(o in e?zi(e,o):s)(u(e,t,r),c(e,t,r))}}if(Object(ie.a)(this.fn)&&Object(ie.u)(this.fn.index)&&this.fn.index.isObjectProperty()){var f=this.fn.object._compile(i,t),l=this.fn.index.getObjectProperty(),p=this.args;return function(t,r,n){var e=f(t,r,n);return function(e,t){if(!Pi(e,t))throw new Error('No access to method "'+t+'"')}(e,l),e[l]&&e[l].rawArgs?e[l](p,i,_f({},t,r)):e[l].apply(e,Object(q.k)(a,function(e){return e(t,r,n)}))}}var m=this.fn._compile(i,t),h=this.args;return function(t,r,n){var e=m(t,r,n);return e&&e.rawArgs?e(h,i,_f({},t,r)):e.apply(e,Object(q.k)(a,function(e){return e(t,r,n)}))}},d.prototype.forEach=function(e){e(this.fn,"fn",this);for(var t=0;t<this.args.length;t++)e(this.args[t],"args["+t+"]",this)},d.prototype.map=function(e){for(var t=this._ifNode(e(this.fn,"fn",this)),r=[],n=0;n<this.args.length;n++)r[n]=this._ifNode(e(this.args[n],"args["+n+"]",this));return new d(t,r)},d.prototype.clone=function(){return new d(this.fn,this.args.slice(0))};var n=d.prototype.toString;function a(e,t,r){for(var n,i="",a=new RegExp("\\$(?:\\{([a-z_][a-z_0-9]*)(?:\\[([0-9]+)\\])?\\}|\\$)","ig"),o=0;null!==(n=a.exec(e));)if(i+=e.substring(o,n.index),o=n.index,"$$"===n[0])i+="$",o++;else{o+=n[0].length;var s=t[n[1]];if(!s)throw new ReferenceError("Template: Property "+n[1]+" does not exist.");if(void 0===n[2])switch(Tf(s)){case"string":i+=s;break;case"object":if(Object(ie.w)(s))i+=s.toTex(r);else{if(!Array.isArray(s))throw new TypeError("Template: "+n[1]+" has to be a Node, String or array of Nodes");i+=s.map(function(e,t){if(Object(ie.w)(e))return e.toTex(r);throw new TypeError("Template: "+n[1]+"["+t+"] is not a Node.")}).join(",")}break;default:throw new TypeError("Template: "+n[1]+" has to be a Node, String or array of Nodes")}else{if(!Object(ie.w)(s[n[2]]&&s[n[2]]))throw new TypeError("Template: "+n[1]+"["+n[2]+"] is not a Node.");i+=s[n[2]].toTex(r)}}return i+=e.slice(o)}d.prototype.toString=function(e){var t,r=this.fn.toString(e);return e&&"object"===Tf(e.handler)&&Object(ae.f)(e.handler,r)&&(t=e.handler[r](this,e)),void 0!==t?t:n.call(this,e)},d.prototype._toString=function(t){var e=this.args.map(function(e){return e.toString(t)});return(Object(ie.q)(this.fn)?"("+this.fn.toString(t)+")":this.fn.toString(t))+"("+e.join(", ")+")"},d.prototype.toJSON=function(){return{mathjs:"FunctionNode",fn:this.fn,args:this.args}},d.fromJSON=function(e){return new d(e.fn,e.args)},d.prototype.toHTML=function(t){var e=this.args.map(function(e){return e.toHTML(t)});return'<span class="math-function">'+Object(V.c)(this.fn)+'</span><span class="math-paranthesis math-round-parenthesis">(</span>'+e.join('<span class="math-separator">,</span>')+'<span class="math-paranthesis math-round-parenthesis">)</span>'};var o=d.prototype.toTex;return d.prototype.toTex=function(e){var t;return e&&"object"===Tf(e.handler)&&Object(ae.f)(e.handler,this.name)&&(t=e.handler[this.name](this,e)),void 0!==t?t:o.call(this,e)},d.prototype._toTex=function(t){var e,r,n=this.args.map(function(e){return e.toTex(t)});switch(af[this.name]&&(e=af[this.name]),!i[this.name]||"function"!=typeof i[this.name].toTex&&"object"!==Tf(i[this.name].toTex)&&"string"!=typeof i[this.name].toTex||(e=i[this.name].toTex),Tf(e)){case"function":r=e(this,t);break;case"string":r=a(e,this,t);break;case"object":switch(Tf(e[n.length])){case"function":r=e[n.length](this,t);break;case"string":r=a(e[n.length],this,t)}}return void 0!==r?r:a("\\mathrm{${name}}\\left(${args}\\right)",this,t)},d.prototype.getIdentifier=function(){return this.type+":"+this.name},d},{isClass:!0,isNode:!0});function kf(){return(kf=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}var Bf=["typed","numeric","config","AccessorNode","ArrayNode","AssignmentNode","BlockNode","ConditionalNode","ConstantNode","FunctionAssignmentNode","FunctionNode","IndexNode","ObjectNode","OperatorNode","ParenthesisNode","RangeNode","RelationalNode","SymbolNode"],zf=Object(s.a)("parse",Bf,function(e){var t=e.typed,s=e.numeric,u=e.config,i=e.AccessorNode,c=e.ArrayNode,o=e.AssignmentNode,a=e.BlockNode,f=e.ConditionalNode,l=e.ConstantNode,p=e.FunctionAssignmentNode,m=e.FunctionNode,h=e.IndexNode,d=e.ObjectNode,y=e.OperatorNode,g=e.ParenthesisNode,n=e.RangeNode,v=e.RelationalNode,b=e.SymbolNode,x=t("parse",{string:function(e){return B(e,{})},"Array | Matrix":function(e){return r(e,{})},"string, Object":function(e,t){return B(e,void 0!==t.nodes?t.nodes:{})},"Array | Matrix, Object":r});function r(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},r=void 0!==t.nodes?t.nodes:{};return oe(e,function(e){if("string"!=typeof e)throw new TypeError("String expected");return B(e,r)})}var w={NULL:0,DELIMITER:1,NUMBER:2,SYMBOL:3,UNKNOWN:4},N={",":!0,"(":!0,")":!0,"[":!0,"]":!0,"{":!0,"}":!0,'"':!0,"'":!0,";":!0,"+":!0,"-":!0,"*":!0,".*":!0,"/":!0,"./":!0,"%":!0,"^":!0,".^":!0,"~":!0,"!":!0,"&":!0,"|":!0,"^|":!0,"=":!0,":":!0,"?":!0,"==":!0,"!=":!0,"<":!0,">":!0,"<=":!0,">=":!0,"<<":!0,">>":!0,">>>":!0},O={mod:!0,to:!0,in:!0,and:!0,xor:!0,or:!0,not:!0},M={true:!0,false:!1,null:null,undefined:void 0},j=["NaN","Infinity"];function E(e,t){return e.expression.substr(e.index,t)}function S(e){return E(e,1)}function A(e){e.index++}function C(e){return e.expression.charAt(e.index-1)}function T(e){return e.expression.charAt(e.index+1)}function _(e){for(e.tokenType=w.NULL,e.token="",e.comment="";x.isWhitespace(S(e),e.nestingLevel);)A(e);if("#"===S(e))for(;"\n"!==S(e)&&""!==S(e);)e.comment+=S(e),A(e);if(""!==S(e)){if("\n"===S(e)&&!e.nestingLevel)return e.tokenType=w.DELIMITER,e.token=S(e),void A(e);var t=S(e),r=E(e,2),n=E(e,3);if(3===n.length&&N[n])return e.tokenType=w.DELIMITER,e.token=n,A(e),A(e),void A(e);if(2===r.length&&N[r])return e.tokenType=w.DELIMITER,e.token=r,A(e),void A(e);if(N[t])return e.tokenType=w.DELIMITER,e.token=t,void A(e);if(x.isDigitDot(t)){if(e.tokenType=w.NUMBER,"."===S(e))e.token+=S(e),A(e),x.isDigit(S(e))||(e.tokenType=w.DELIMITER);else{for(;x.isDigit(S(e));)e.token+=S(e),A(e);x.isDecimalMark(S(e),T(e))&&(e.token+=S(e),A(e))}for(;x.isDigit(S(e));)e.token+=S(e),A(e);if("E"===S(e)||"e"===S(e))if(x.isDigit(T(e))||"-"===T(e)||"+"===T(e)){if(e.token+=S(e),A(e),"+"!==S(e)&&"-"!==S(e)||(e.token+=S(e),A(e)),!x.isDigit(S(e)))throw re(e,'Digit expected, got "'+S(e)+'"');for(;x.isDigit(S(e));)e.token+=S(e),A(e);if(x.isDecimalMark(S(e),T(e)))throw re(e,'Digit expected, got "'+S(e)+'"')}else if("."===T(e))throw A(e),re(e,'Digit expected, got "'+S(e)+'"')}else{if(!x.isAlpha(S(e),C(e),T(e))){for(e.tokenType=w.UNKNOWN;""!==S(e);)e.token+=S(e),A(e);throw re(e,'Syntax error in part "'+e.token+'"')}for(;x.isAlpha(S(e),C(e),T(e))||x.isDigit(S(e));)e.token+=S(e),A(e);Object(ae.f)(O,e.token)?e.tokenType=w.DELIMITER:e.tokenType=w.SYMBOL}}else e.tokenType=w.DELIMITER}function q(e){for(;_(e),"\n"===e.token;);}function I(e){e.nestingLevel++}function k(e){e.nestingLevel--}function B(e,t){var r={extraNodes:{},expression:"",comment:"",index:0,token:"",tokenType:w.NULL,nestingLevel:0,conditionalLevel:null};kf(r,{expression:e,extraNodes:t}),_(r);var n=function(e){var t,r,n=[];""!==e.token&&"\n"!==e.token&&";"!==e.token&&((t=z(e)).comment=e.comment);for(;"\n"===e.token||";"===e.token;)0===n.length&&t&&(r=";"!==e.token,n.push({node:t,visible:r})),_(e),"\n"!==e.token&&";"!==e.token&&""!==e.token&&((t=z(e)).comment=e.comment,r=";"!==e.token,n.push({node:t,visible:r}));return 0<n.length?new a(n):(t||((t=new l(void 0)).comment=e.comment),t)}(r);if(""!==r.token)throw r.tokenType===w.DELIMITER?ne(r,"Unexpected operator "+r.token):re(r,'Unexpected part "'+r.token+'"');return n}function z(e){var t,r,n,i,a=function(e){var t=function(e){var t=D(e);for(;"or"===e.token;)q(e),t=new y("or","or",[t,D(e)]);return t}(e);for(;"?"===e.token;){var r=e.conditionalLevel;e.conditionalLevel=e.nestingLevel,q(e);var n=t,i=z(e);if(":"!==e.token)throw re(e,"False part of conditional expression expected");e.conditionalLevel=null,q(e);var a=z(e);t=new f(n,i,a),e.conditionalLevel=r}return t}(e);if("="!==e.token)return a;if(Object(ie.J)(a))return t=a.name,q(e),n=z(e),new o(new b(t),n);if(Object(ie.a)(a))return q(e),n=z(e),new o(a.object,a.index,n);if(Object(ie.r)(a)&&Object(ie.J)(a.fn)&&(i=!0,r=[],t=a.name,a.args.forEach(function(e,t){Object(ie.J)(e)?r[t]=e.name:i=!1}),i))return q(e),n=z(e),new p(t,r,n);throw re(e,"Invalid left hand side of assignment operator =")}function D(e){for(var t=R(e);"xor"===e.token;)q(e),t=new y("xor","xor",[t,R(e)]);return t}function R(e){for(var t=P(e);"and"===e.token;)q(e),t=new y("and","and",[t,P(e)]);return t}function P(e){for(var t=U(e);"|"===e.token;)q(e),t=new y("|","bitOr",[t,U(e)]);return t}function U(e){for(var t=F(e);"^|"===e.token;)q(e),t=new y("^|","bitXor",[t,F(e)]);return t}function F(e){for(var t=L(e);"&"===e.token;)q(e),t=new y("&","bitAnd",[t,L(e)]);return t}function L(e){for(var t=[H(e)],r=[],n={"==":"equal","!=":"unequal","<":"smaller",">":"larger","<=":"smallerEq",">=":"largerEq"};Object(ae.f)(n,e.token);){var i={name:e.token,fn:n[e.token]};r.push(i),q(e),t.push(H(e))}return 1===t.length?t[0]:2===t.length?new y(r[0].name,r[0].fn,t):new v(r.map(function(e){return e.fn}),t)}function H(e){for(var t,r,n,i=$(e),a={"<<":"leftShift",">>":"rightArithShift",">>>":"rightLogShift"};Object(ae.f)(a,e.token);)r=a[t=e.token],q(e),n=[i,$(e)],i=new y(t,r,n);return i}function $(e){for(var t,r,n,i=G(e),a={to:"to",in:"to"};Object(ae.f)(a,e.token);)r=a[t=e.token],q(e),i="in"===t&&""===e.token?new y("*","multiply",[i,new b("in")],!0):(n=[i,G(e)],new y(t,r,n));return i}function G(e){var t=[],r=":"===e.token?new l(1):Z(e);if(":"===e.token&&e.conditionalLevel!==e.nestingLevel){for(t.push(r);":"===e.token&&t.length<3;)q(e),")"===e.token||"]"===e.token||","===e.token||""===e.token?t.push(new b("end")):t.push(Z(e));r=3===t.length?new n(t[0],t[2],t[1]):new n(t[0],t[1])}return r}function Z(e){for(var t,r,n,i=V(e),a={"+":"add","-":"subtract"};Object(ae.f)(a,e.token);)r=a[t=e.token],q(e),n=[i,V(e)],i=new y(t,r,n);return i}function V(e){for(var t,r,n,i=J(e),a={"*":"multiply",".*":"dotMultiply","/":"divide","./":"dotDivide","%":"mod",mod:"mod"};Object(ae.f)(a,e.token);)r=a[t=e.token],q(e),n=J(e),i=new y(t,r,[i,n]);return i}function J(e){for(var t=W(e),r=t;e.tokenType===w.SYMBOL||"in"===e.token&&Object(ie.l)(t)||!(e.tokenType!==w.NUMBER||Object(ie.l)(r)||Object(ie.B)(r)&&"!"!==r.op)||"("===e.token;)r=W(e),t=new y("*","multiply",[t,r],!0);return t}function W(e){for(var t=Y(e),r=t,n=[];"/"===e.token&&Object(ie.l)(r);){if(n.push(kf({},e)),q(e),e.tokenType!==w.NUMBER){kf(e,n.pop());break}if(n.push(kf({},e)),q(e),e.tokenType!==w.SYMBOL&&"("!==e.token){n.pop(),kf(e,n.pop());break}kf(e,n.pop()),n.pop(),r=Y(e),t=new y("/","divide",[t,r])}return t}function Y(e){var t,r,n,i={"-":"unaryMinus","+":"unaryPlus","~":"bitNot",not:"not"};return Object(ae.f)(i,e.token)?(n=i[e.token],t=e.token,q(e),r=[Y(e)],new y(t,n,r)):function(e){var t,r,n,i;t=function(e){var t,r,n;t=function(e){var t=[];if(e.tokenType===w.SYMBOL&&Object(ae.f)(e.extraNodes,e.token)){var r=e.extraNodes[e.token];if(_(e),"("===e.token){if(t=[],I(e),_(e),")"!==e.token)for(t.push(z(e));","===e.token;)_(e),t.push(z(e));if(")"!==e.token)throw re(e,"Parenthesis ) expected");k(e),_(e)}return new r(t)}return function(e){var t,r;if(e.tokenType===w.SYMBOL||e.tokenType===w.DELIMITER&&e.token in O)return r=e.token,_(e),t=Object(ae.f)(M,r)?new l(M[r]):-1!==j.indexOf(r)?new l(s(r,"number")):new b(r),t=X(e,t);return function(e){var t,r;return'"'!==e.token?function(e){var t,r;return"'"!==e.token?function(e){var t,r,n,i;if("["!==e.token)return function(e){if("{"!==e.token)return function(e){var t;return e.tokenType!==w.NUMBER?function(e){var t;if("("!==e.token)return function(e){throw""===e.token?re(e,"Unexpected end of expression"):re(e,"Value expected")}(e);if(I(e),_(e),t=z(e),")"===e.token)return k(e),_(e),t=new g(t),t=X(e,t);throw re(e,"Parenthesis ) expected")}(e):(t=e.token,_(e),new l(s(t,u.number)))}(e);var t;I(e);var r={};do{if(_(e),"}"!==e.token){if('"'===e.token)t=Q(e);else if("'"===e.token)t=K(e);else{if(!(e.tokenType===w.SYMBOL||e.tokenType===w.DELIMITER&&e.token in O))throw re(e,"Symbol or string expected as object key");t=e.token,_(e)}if(":"!==e.token)throw re(e,"Colon : expected after object key");_(e),r[t]=z(e)}}while(","===e.token);if("}"!==e.token)throw re(e,"Comma , or bracket } expected after object value");k(e),_(e);var n=new d(r);return n=X(e,n)}(e);if(I(e),_(e),"]"!==e.token){var a=ee(e);if(";"===e.token){for(n=1,r=[a];";"===e.token;)_(e),r[n]=ee(e),n++;if("]"!==e.token)throw re(e,"End of matrix ] expected");k(e),_(e),i=r[0].items.length;for(var o=1;o<n;o++)if(r[o].items.length!==i)throw ne(e,"Column dimensions mismatch ("+r[o].items.length+" !== "+i+")");t=new c(r)}else{if("]"!==e.token)throw re(e,"End of matrix ] expected");k(e),_(e),t=a}}else k(e),_(e),t=new c([]);return X(e,t)}(e):(r=K(e),t=new l(r),t=X(e,t))}(e):(r=Q(e),t=new l(r),t=X(e,t))}(e)}(e)}(e);var i={"!":"factorial","'":"ctranspose"};for(;Object(ae.f)(i,e.token);)r=e.token,n=i[r],_(e),t=new y(r,n,[t]),t=X(e,t);return t}(e),"^"!==e.token&&".^"!==e.token||(r=e.token,n="^"===r?"pow":"dotPow",q(e),i=[t,Y(e)],t=new y(r,n,i));return t}(e)}function X(e,t,r){for(var n;!("("!==e.token&&"["!==e.token&&"."!==e.token||r&&-1===r.indexOf(e.token));)if(n=[],"("===e.token){if(!Object(ie.J)(t)&&!Object(ie.a)(t))return t;if(I(e),_(e),")"!==e.token)for(n.push(z(e));","===e.token;)_(e),n.push(z(e));if(")"!==e.token)throw re(e,"Parenthesis ) expected");k(e),_(e),t=new m(t,n)}else if("["===e.token){if(I(e),_(e),"]"!==e.token)for(n.push(z(e));","===e.token;)_(e),n.push(z(e));if("]"!==e.token)throw re(e,"Parenthesis ] expected");k(e),_(e),t=new i(t,new h(n))}else{if(_(e),e.tokenType!==w.SYMBOL)throw re(e,"Property name expected after dot");n.push(new l(e.token)),_(e);t=new i(t,new h(n,!0))}return t}function Q(e){for(var t="";""!==S(e)&&'"'!==S(e);)"\\"===S(e)&&(t+=S(e),A(e)),t+=S(e),A(e);if(_(e),'"'!==e.token)throw re(e,'End of string " expected');return _(e),JSON.parse('"'+t+'"')}function K(e){for(var t="";""!==S(e)&&"'"!==S(e);)"\\"===S(e)&&(t+=S(e),A(e)),t+=S(e),A(e);if(_(e),"'"!==e.token)throw re(e,"End of string ' expected");return _(e),JSON.parse('"'+t+'"')}function ee(e){for(var t=[z(e)],r=1;","===e.token;)_(e),t[r]=z(e),r++;return new c(t)}function te(e){return e.index-e.token.length+1}function re(e,t){var r=te(e),n=new SyntaxError(t+" (char "+r+")");return n.char=r,n}function ne(e,t){var r=te(e),n=new SyntaxError(t+" (char "+r+")");return n.char=r,n}return x.isAlpha=function(e,t,r){return x.isValidLatinOrGreek(e)||x.isValidMathSymbol(e,r)||x.isValidMathSymbol(t,e)},x.isValidLatinOrGreek=function(e){return/^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(e)},x.isValidMathSymbol=function(e,t){return/^[\uD835]$/.test(e)&&/^[\uDC00-\uDFFF]$/.test(t)&&/^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(t)},x.isWhitespace=function(e,t){return" "===e||"\t"===e||"\n"===e&&0<t},x.isDecimalMark=function(e,t){return"."===e&&"/"!==t&&"*"!==t&&"^"!==t},x.isDigitDot=function(e){return"0"<=e&&e<="9"||"."===e},x.isDigit=function(e){return"0"<=e&&e<="9"},x}),Df="compile",Rf=["typed","parse"],Pf=Object(s.a)(Df,Rf,function(e){var t=e.typed,r=e.parse;return t(Df,{string:function(e){return r(e).compile()},"Array | Matrix":function(e){return oe(e,function(e){return r(e).compile()})}})}),Uf="evaluate",Ff=["typed","parse"],Lf=Object(s.a)(Uf,Ff,function(e){var t=e.typed,r=e.parse;return t(Uf,{string:function(e){return r(e).compile().evaluate({})},"string, Object":function(e,t){return r(e).compile().evaluate(t)},"Array | Matrix":function(e){var t={};return oe(e,function(e){return r(e).compile().evaluate(t)})},"Array | Matrix, Object":function(e,t){return oe(e,function(e){return r(e).compile().evaluate(t)})}})}),Hf=["parse"],$f=Object(s.a)("Parser",Hf,function(e){var t=e.parse;function r(){if(!(this instanceof r))throw new SyntaxError("Constructor must be called with the new operator");this.scope={}}return r.prototype.type="Parser",r.prototype.isParser=!0,r.prototype.evaluate=function(e){return t(e).compile().evaluate(this.scope)},r.prototype.get=function(e){return e in this.scope?zi(this.scope,e):void 0},r.prototype.getAll=function(){return Object(ae.e)({},this.scope)},r.prototype.set=function(e,t){return Di(this.scope,e,t)},r.prototype.remove=function(e){delete this.scope[e]},r.prototype.clear=function(){for(var e in this.scope)Object(ae.f)(this.scope,e)&&delete this.scope[e]},r},{isClass:!0}),Gf=["typed","Parser"],Zf=Object(s.a)("parser",Gf,function(e){var t=e.typed,r=e.Parser;return t("parser",{"":function(){return new r}})}),Vf=["typed","matrix","abs","addScalar","divideScalar","multiplyScalar","subtract","larger","equalScalar","unaryMinus","DenseMatrix","SparseMatrix","Spa"],Jf=Object(s.a)("lup",Vf,function(e){var t=e.typed,r=e.matrix,S=e.abs,M=e.addScalar,A=e.divideScalar,C=e.multiplyScalar,j=e.subtract,T=e.larger,_=e.equalScalar,q=e.unaryMinus,E=e.DenseMatrix,I=e.SparseMatrix,k=e.Spa;return t("lup",{DenseMatrix:n,SparseMatrix:function(e){var f,l,p,m=e._size[0],t=e._size[1],r=Math.min(m,t),h=e._values,d=e._index,y=e._ptr,g=[],v=[],b=[],x=[m,r],w=[],N=[],O=[],M=[r,t],j=[],E=[];for(f=0;f<m;f++)j[f]=f,E[f]=f;function n(){var i=new k;l<m&&(b.push(g.length),g.push(1),v.push(l)),O.push(w.length);var e=y[l],t=y[l+1];for(p=e;p<t;p++)f=d[p],i.set(j[f],h[p]);0<l&&i.forEach(0,l-1,function(r,n){I._forEachRow(r,g,v,b,function(e,t){r<e&&i.accumulate(e,q(C(t,n)))})});var r,n,a,o,s=l,u=i.get(l),c=S(u);i.forEach(l+1,m-1,function(e,t){var r=S(t);T(r,c)&&(s=e,c=r,u=t)}),l!==s&&(I._swapRows(l,s,x[1],g,v,b),I._swapRows(l,s,M[1],w,N,O),i.swap(l,s),n=s,a=E[r=l],o=E[n],j[a]=n,j[o]=r,E[r]=o,E[n]=a),i.forEach(0,m-1,function(e,t){e<=l?(w.push(t),N.push(e)):(t=A(t,u),_(t,0)||(g.push(t),v.push(e)))})}for(l=0;l<t;l++)n();return O.push(w.length),b.push(g.length),{L:new I({values:g,index:v,ptr:b,size:x}),U:new I({values:w,index:N,ptr:O,size:M}),p:j,toString:function(){return"L: "+this.L.toString()+"\nU: "+this.U.toString()+"\nP: "+this.p}}},Array:function(e){var t=n(r(e));return{L:t.L.valueOf(),U:t.U.valueOf(),p:t.p}}});function n(e){var t,r=e._size[0],n=e._size[1],i=Math.min(r,n),a=Object(ae.a)(e._data),o=[],s=[r,i],u=[],c=[i,n],f=[];for(g=0;g<r;g++)f[g]=g;for(t=0;t<n;t++){if(0<t)for(g=0;g<r;g++){for(var l=Math.min(g,t),p=0,m=0;m<l;m++)p=M(p,C(a[g][m],a[m][t]));a[g][t]=j(a[g][t],p)}for(var h=t,d=0,y=0,g=t;g<r;g++){var v=a[g][t],b=S(v);T(b,d)&&(h=g,d=b,y=v)}if(t!==h&&(f[t]=[f[h],f[h]=f[t]][0],E._swapRows(t,h,a)),t<r)for(g=t+1;g<r;g++){var x=a[g][t];_(x,0)||(a[g][t]=A(a[g][t],y))}}for(t=0;t<n;t++)for(g=0;g<r;g++)0===t&&(g<n&&(u[g]=[]),o[g]=[]),g<t?(g<n&&(u[g][t]=a[g][t]),t<r&&(o[g][t]=0)):g!==t?(g<n&&(u[g][t]=0),t<r&&(o[g][t]=a[g][t])):(g<n&&(u[g][t]=a[g][t]),t<r&&(o[g][t]=1));var w=new E({data:o,size:s}),N=new E({data:u,size:c}),O=[];for(g=0,i=f.length;g<i;g++)O[f[g]]=g;return{L:w,U:N,p:O,toString:function(){return"L: "+this.L.toString()+"\nU: "+this.U.toString()+"\nP: "+this.p}}}});function Wf(){return(Wf=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}var Yf=["typed","matrix","zeros","identity","isZero","equal","sign","sqrt","conj","unaryMinus","addScalar","divideScalar","multiplyScalar","subtract","complex"],Xf=Object(s.a)("qr",Yf,function(e){var t=e.typed,r=e.matrix,b=e.zeros,x=e.identity,w=e.isZero,N=e.equal,O=e.sign,M=e.sqrt,j=e.conj,E=e.unaryMinus,S=e.addScalar,A=e.divideScalar,C=e.multiplyScalar,T=e.subtract,o=e.complex;return Wf(t("qr",{DenseMatrix:n,SparseMatrix:function(){throw new Error("qr not implemented for sparse matrices yet")},Array:function(e){var t=n(r(e));return{Q:t.Q.valueOf(),R:t.R.valueOf()}}}),{_denseQRimpl:s});function s(e){for(var t=e._size[0],r=e._size[1],n=x([t],"dense"),i=n._data,a=e.clone(),o=a._data,s=b([t],""),u=0;u<Math.min(r,t);++u){var c=o[u][u],f=E(N(c,0)?1:O(c)),l=j(f),p=0;for(d=u;d<t;d++)p=S(p,C(o[d][u],j(o[d][u])));var m=C(f,M(p));if(!w(m)){for(var h=T(c,m),d=u+(s[u]=1);d<t;d++)s[d]=A(o[d][u],h);for(var y=E(j(A(h,m))),g=void 0,v=u;v<r;v++){for(g=0,d=u;d<t;d++)g=S(g,C(j(s[d]),o[d][v]));for(g=C(g,y),d=u;d<t;d++)o[d][v]=C(T(o[d][v],C(s[d],g)),l)}for(d=0;d<t;d++){for(g=0,v=u;v<t;v++)g=S(g,C(i[d][v],s[v]));for(g=C(g,y),v=u;v<t;++v)i[d][v]=A(T(i[d][v],C(g,j(s[v]))),l)}}}return{Q:n,R:a,toString:function(){return"Q: "+this.Q.toString()+"\nR: "+this.R.toString()}}}function n(e){var t=s(e),r=t.R._data;if(0<e._data.length)for(var n="Complex"===r[0][0].type?o(0):0,i=0;i<r.length;++i)for(var a=0;a<i&&a<(r[0]||[]).length;++a)r[i][a]=n;return t}});function Qf(e,t,r,n,i,a,o){var s=0;for(r[o]=e;0<=s;){var u=r[o+s],c=r[n+u];-1===c?(s--,a[t++]=u):(r[n+u]=r[i+c],r[o+ ++s]=c)}return t}var Kf=["add","multiply","transpose"],el=Object(s.a)("csAmd",Kf,function(e){var K=e.add,ee=e.multiply,te=e.transpose;return function(e,t){if(!t||e<=0||3<e)return null;var r=t._size,n=r[0],i=r[1],a=0,o=Math.max(16,10*Math.sqrt(i)),s=function(e,t,r,n,i){var a=te(t);if(1===e&&n===r)return K(t,a);if(2!==e)return ee(a,t);for(var o=a._index,s=a._ptr,u=0,c=0;c<r;c++){var f=s[c];if(s[c]=u,!(s[c+1]-f>i))for(var l=s[c+1];f<l;f++)o[u++]=o[f]}return s[r]=u,t=te(a),ee(a,t)}(e,t,n,i,o=Math.min(i-2,o));!function(e,t,r){for(var n=e._values,i=e._index,a=e._ptr,o=e._size[1],s=0,u=0;u<o;u++){var c=a[u];for(a[u]=s;c<a[u+1];c++)t(i[c],u,n?n[c]:1,r)&&(i[s]=i[c],n&&(n[s]=n[c]),s++)}a[o]=s,i.splice(s,i.length-s),n&&n.splice(s,n.length-s)}(s,ne,null);for(var u,c,f,l,p,m,h,d,y,g,v,b,x=s._index,w=s._ptr,N=w[i],O=[],M=[],j=i+1,E=2*(i+1),S=3*(i+1),A=4*(i+1),C=5*(i+1),T=6*(i+1),_=7*(i+1),q=O,I=function(e,t,r,n,i,a,o,s,u,c,f,l){for(var p=0;p<e;p++)r[n+p]=t[p+1]-t[p];for(var m=r[n+e]=0;m<=e;m++)r[i+m]=-1,a[m]=-1,r[o+m]=-1,r[s+m]=-1,r[u+m]=1,r[c+m]=1,r[f+m]=0,r[l+m]=r[n+m];var h=re(0,0,r,c,e);return r[f+e]=-2,t[e]=-1,r[c+e]=0,h}(i,w,M,0,S,q,E,_,j,T,A,C),k=function(e,t,r,n,i,a,o,s,u,c,f){for(var l=0,p=0;p<e;p++){var m,h=r[n+p];0===h?(r[i+p]=-2,l++,t[p]=-1,r[a+p]=0):o<h?(r[s+p]=0,r[i+p]=-1,l++,t[p]=-e-2,r[s+e]++):(-1!==(m=r[u+h])&&(c[m]=p),r[f+p]=r[u+h],r[u+h]=p)}return l}(i,w,M,C,A,T,o,j,S,q,E),B=0;k<i;){for(c=-1;B<i&&-1===(c=M[S+B]);B++);-1!==M[E+c]&&(q[M[E+c]]=-1),M[S+B]=M[E+c];var z=M[A+c],D=M[j+c];k+=D;var R=0;M[j+c]=-D;for(var P,U,F=w[c],L=0===z?F:N,H=L,$=1;$<=z+1;$++){for(p=z<$?(l=F,M[0+(U=c)]-z):(l=w[U=x[F++]],M[0+U]),f=1;f<=p;f++)(m=M[j+(u=x[l++])])<=0||(R+=m,M[j+u]=-m,-1!==M[E+(x[H++]=u)]&&(q[M[E+u]]=q[u]),-1!==q[u]?M[E+q[u]]=M[E+u]:M[S+M[C+u]]=M[E+u]);U!==c&&(w[U]=-c-2,M[T+U]=0)}for(0!==z&&(N=H),M[C+c]=R,w[c]=L,M[0+c]=H-L,M[A+c]=-2,I=re(I,a,M,T,i),h=L;h<H;h++)if(!((d=M[A+(u=x[h])])<=0))for(var G=I-(m=-M[j+u]),F=w[u],Z=w[u]+d-1;F<=Z;F++)M[T+(U=x[F])]>=I?M[T+U]-=m:0!==M[T+U]&&(M[T+U]=M[C+U]+G);for(h=L;h<H;h++){for(y=(Z=w[u=x[h]])+M[A+u]-1,b=v=0,F=g=Z;F<=y;F++){0!==M[T+(U=x[F])]&&(0<(P=M[T+U]-I)?(b+=P,v+=x[g++]=U):(w[U]=-c-2,M[T+U]=0))}M[A+u]=g-Z+1;var V=g,J=Z+M[0+u];for(F=1+y;F<J;F++){var W=M[j+(X=x[F])];W<=0||(b+=W,v+=x[g++]=X)}0===b?(w[u]=-c-2,R-=m=-M[j+u],D+=m,k+=m,M[j+u]=0,M[A+u]=-1):(M[C+u]=Math.min(M[C+u],b),x[g]=x[V],x[V]=x[Z],x[Z]=c,M[0+u]=g-Z+1,v=(v<0?-v:v)%i,M[E+u]=M[_+v],q[M[_+v]=u]=v)}for(M[C+c]=R,I=re(I+(a=Math.max(a,R)),a,M,T,i),h=L;h<H;h++)if(!(0<=M[j+(u=x[h])]))for(u=M[_+(v=q[u])],M[_+v]=-1;-1!==u&&-1!==M[E+u];u=M[E+u],I++){for(p=M[0+u],d=M[A+u],F=w[u]+1;F<=w[u]+p-1;F++)M[T+x[F]]=I;for(var Y=u,X=M[E+u];-1!==X;){var Q=M[0+X]===p&&M[A+X]===d;for(F=w[X]+1;Q&&F<=w[X]+p-1;F++)M[T+x[F]]!==I&&(Q=0);Q?(w[X]=-u-2,M[j+u]+=M[j+X],M[j+X]=0,M[A+X]=-1,X=M[E+X],M[E+Y]=X):X=M[E+(Y=X)]}}for(h=F=L;h<H;h++)(m=-M[j+(u=x[h])])<=0||(M[j+u]=m,b=M[C+u]+R-m,-1!==M[S+(b=Math.min(b,i-k-m))]&&(q[M[S+b]]=u),M[E+u]=M[S+b],q[u]=-1,M[S+b]=u,B=Math.min(B,b),M[C+u]=b,x[F++]=u);M[j+c]=D,0==(M[0+c]=F-L)&&(w[c]=-1,M[T+c]=0),0!==z&&(N=F)}for(u=0;u<i;u++)w[u]=-w[u]-2;for(X=0;X<=i;X++)M[S+X]=-1;for(X=i;0<=X;X--)0<M[j+X]||(M[E+X]=M[S+w[X]],M[S+w[X]]=X);for(U=i;0<=U;U--)M[j+U]<=0||-1!==w[U]&&(M[E+U]=M[S+w[U]],M[S+w[U]]=U);for(u=c=0;u<=i;u++)-1===w[u]&&(c=Qf(u,c,M,S,E,O,T));return O.splice(O.length-1,1),O};function re(e,t,r,n,i){if(e<2||e+t<0){for(var a=0;a<i;a++)0!==r[n+a]&&(r[n+a]=1);e=2}return e}function ne(e,t){return e!==t}});var tl=["transpose"],rl=Object(s.a)("csCounts",tl,function(e){var E=e.transpose;return function(e,t,r,n){if(!e||!t||!r)return null;for(var i,a,o,s,u,c,f=e._size,l=f[0],p=f[1],m=4*p+(n?p+l+1:0),h=[],d=p,y=2*p,g=3*p,v=4*p,b=5*p+1,x=0;x<m;x++)h[x]=-1;var w=[],N=E(e),O=N._index,M=N._ptr;for(x=0;x<p;x++)for(w[a=r[x]]=-1===h[g+a]?1:0;-1!==a&&-1===h[g+a];a=t[a])h[g+a]=x;if(n){for(x=0;x<p;x++)h[r[x]]=x;for(i=0;i<l;i++){for(x=p,u=M[i],c=M[i+1],s=u;s<c;s++)x=Math.min(x,h[O[s]]);h[b+i]=h[v+x],h[v+x]=i}}for(i=0;i<p;i++)h[0+i]=i;for(x=0;x<p;x++){for(-1!==t[a=r[x]]&&w[t[a]]--,o=n?h[v+x]:a;-1!==o;o=n?h[b+o]:-1)for(s=M[o];s<M[o+1];s++){var j=function(e,t,r,n,i,a,o){var s,u,c,f=0;if(e<=t||r[n+t]<=r[i+e])return-1;r[i+e]=r[n+t];var l=r[a+e];if(r[a+e]=t,-1===l)f=1,c=e;else{for(f=2,c=l;c!==r[o+c];c=r[o+c]);for(s=l;s!==c;s=u)u=r[o+s],r[o+s]=c}return{jleaf:f,q:c}}(i=O[s],a,h,g,d,y,0);1<=j.jleaf&&w[a]++,2===j.jleaf&&w[j.q]--}-1!==t[a]&&(h[0+a]=t[a])}for(a=0;a<p;a++)-1!==t[a]&&(w[t[a]]+=w[a]);return w}}),nl=["add","multiply","transpose"],il=Object(s.a)("csSqr",nl,function(e){var t=e.add,r=e.multiply,n=e.transpose,c=el({add:t,multiply:r,transpose:n}),f=rl({transpose:n});return function(e,t,r){var n,i=t._ptr,a=t._size[1],o={};if(o.q=c(e,t),e&&!o.q)return null;if(r){var s=e?function(e,t,r,n){for(var i=e._values,a=e._index,o=e._ptr,s=e._size,u=e._datatype,c=s[0],f=s[1],l=n&&e._values?[]:null,p=[],m=[],h=0,d=0;d<f;d++){m[d]=h;for(var y=r?r[d]:d,g=o[y],v=o[y+1],b=g;b<v;b++){var x=t?t[a[b]]:a[b];p[h]=x,l&&(l[h]=i[b]),h++}}return m[f]=h,e.createSparseMatrix({values:l,index:p,ptr:m,size:[c,f],datatype:u})}(t,null,o.q,0):t;o.parent=function(e,t){if(!e)return null;var r,n=e._index,i=e._ptr,a=e._size,o=a[0],s=a[1],u=[],c=[],f=s;if(t)for(y=0;y<o;y++)c[f+y]=-1;for(var l=0;l<s;l++){u[l]=-1,c[0+l]=-1;for(var p=i[l],m=i[l+1],h=p;h<m;h++){for(var d=n[h],y=t?c[f+d]:d;-1!==y&&y<l;y=r)r=c[0+y],c[0+y]=l,-1===r&&(u[y]=l);t&&(c[f+d]=l)}}return u}(s,1);var u=function(e,t){if(!e)return null;for(var r=0,n=[],i=[],a=t,o=2*t,s=0;s<t;s++)i[0+s]=-1;for(s=t-1;0<=s;s--)-1!==e[s]&&(i[a+s]=i[0+e[s]],i[0+e[s]]=s);for(s=0;s<t;s++)-1===e[s]&&(r=Qf(s,r,i,0,a,n,o));return n}(o.parent,a);if(o.cp=f(s,o.parent,u,1),s&&o.parent&&o.cp&&function(e,t){var r=e._ptr,n=e._index,i=e._size,a=i[0],o=i[1];t.pinv=[],t.leftmost=[];var s,u,c,f,l,p=t.parent,m=t.pinv,h=t.leftmost,d=[],y=a,g=a+o,v=a+2*o;for(u=0;u<o;u++)d[y+u]=-1,d[g+u]=-1,d[v+u]=0;for(s=0;s<a;s++)h[s]=-1;for(u=o-1;0<=u;u--)for(f=r[u],l=r[u+1],c=f;c<l;c++)h[n[c]]=u;for(s=a-1;0<=s;s--)(m[s]=-1)!==(u=h[s])&&(0==d[v+u]++&&(d[g+u]=s),d[0+s]=d[y+u],d[y+u]=s);for(t.lnz=0,t.m2=a,u=0;u<o;u++){var b;s=d[y+u],t.lnz++,s<0&&(s=t.m2++),m[s]=u,--v[u]<=0||(t.lnz+=d[v+u],-1!==(b=p[u])&&(0===d[v+b]&&(d[g+b]=d[g+u]),d[0+d[g+u]]=d[y+b],d[y+b]=d[0+s],d[v+b]+=d[v+u]))}for(s=0;s<a;s++)m[s]<0&&(m[s]=u++);return!0}(s,o))for(n=o.unz=0;n<a;n++)o.unz+=o.cp[n]}else o.unz=4*i[a]+a,o.lnz=o.unz;return o}});function al(e,t){e[t]=-e[t]-2}function ol(e){return e<0?-e-2:e}function sl(e,t,r,n,i){for(var a=e._ptr,o=e._size,s=t._index,u=t._ptr,c=o[1],f=c,l=u[r],p=u[r+1],m=l;m<p;m++){var h=s[m];a[h]<0||(f=function(e,t,r,n,i){var a,o=t._index,s=t._ptr,u=t._size[1],c=0;for(n[0]=e;0<=c;){e=n[c];var f=i?i[e]:e;s[e]<0||(al(s,e),n[u+c]=f<0?0:ol(s[f]));for(var l=1,p=n[u+c],m=f<0?0:ol(s[f+1]);p<m;p++)if(!(s[a=o[p]]<0)){n[u+c]=p,n[++c]=a,l=0;break}l&&(c--,n[--r]=e)}return r}(h,e,f,n,i))}for(m=f;m<c;m++)al(a,n[m]);return f}var ul=["divideScalar","multiply","subtract"],cl=Object(s.a)("csSpsolve",ul,function(e){var O=e.divideScalar,M=e.multiply,j=e.subtract;return function(e,t,r,n,i,a,o){for(var s,u,c,f=e._values,l=e._index,p=e._ptr,m=e._size[1],h=t._values,d=t._index,y=t._ptr,g=sl(e,t,r,n,a),v=g;v<m;v++)i[n[v]]=0;for(s=y[r],u=y[r+1],v=s;v<u;v++)i[d[v]]=h[v];for(var b=g;b<m;b++){var x=n[b],w=a?a[x]:x;if(!(w<0))for(s=p[w],u=p[w+1],i[x]=O(i[x],f[o?s:u-1]),v=o?s+1:s,c=o?u:u-1;v<c;v++){var N=l[v];i[N]=j(i[N],M(f[v],i[x]))}}return g}}),fl=["abs","divideScalar","multiply","subtract","larger","largerEq","SparseMatrix"],ll=Object(s.a)("csLu",fl,function(e){var S=e.abs,A=e.divideScalar,C=e.multiply,t=e.subtract,T=e.larger,_=e.largerEq,q=e.SparseMatrix,I=cl({divideScalar:A,multiply:C,subtract:t});return function(e,t,r){if(!e)return null;var n,i=e._size[1],a=100,o=100;t&&(n=t.q,a=t.lnz||a,o=t.unz||o);var s=[],u=[],c=[],f=new q({values:s,index:u,ptr:c,size:[i,i]}),l=[],p=[],m=[],h=new q({values:l,index:p,ptr:m,size:[i,i]}),d=[],y=[],g=[];for(x=0;x<i;x++)y[x]=0,d[x]=-1,c[x+1]=0;for(var v=o=a=0;v<i;v++){c[v]=a,m[v]=o;for(var b,x,w=n?n[v]:v,N=I(f,e,w,g,y,d,1),O=-1,M=-1,j=N;j<i;j++){d[x=g[j]]<0?(b=S(y[x]),T(b,M)&&(M=b,O=x)):(p[o]=d[x],l[o++]=y[x])}if(-1===O||M<=0)return null;d[w]<0&&_(S(y[w]),C(M,r))&&(O=w);var E=y[O];for(p[o]=v,l[o++]=E,d[O]=v,u[a]=O,s[a++]=1,j=N;j<i;j++)d[x=g[j]]<0&&(u[a]=x,s[a++]=A(y[x],E)),y[x]=0}for(c[i]=a,m[i]=o,j=0;j<a;j++)u[j]=d[u[j]];return s.splice(a,s.length-a),u.splice(a,u.length-a),l.splice(o,l.length-o),p.splice(o,p.length-o),{L:f,U:h,pinv:d}}}),pl=["typed","abs","add","multiply","transpose","divideScalar","subtract","larger","largerEq","SparseMatrix"],ml=Object(s.a)("slu",pl,function(e){var t=e.typed,r=e.abs,n=e.add,i=e.multiply,a=e.transpose,o=e.divideScalar,s=e.subtract,u=e.larger,c=e.largerEq,f=e.SparseMatrix,l=il({add:n,multiply:i,transpose:a}),p=ll({abs:r,divideScalar:o,multiply:i,subtract:s,larger:u,largerEq:c,SparseMatrix:f});return t("slu",{"SparseMatrix, number, number":function(e,t,r){if(!Object(E.i)(t)||t<0||3<t)throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");if(r<0||1<r)throw new Error("Partial pivoting threshold must be a number from 0 to 1");var n=l(t,e,!1),i=p(e,n,r);return{L:i.L,U:i.U,p:i.pinv,q:n.q,toString:function(){return"L: "+this.L.toString()+"\nU: "+this.U.toString()+"\np: "+this.p.toString()+(this.q?"\nq: "+this.q.toString():"")+"\n"}}}})});function hl(e,t){var r,n=t.length,i=[];if(e)for(r=0;r<n;r++)i[e[r]]=t[r];else for(r=0;r<n;r++)i[r]=t[r];return i}var dl="lusolve",yl=["typed","matrix","lup","slu","usolve","lsolve","DenseMatrix"],gl=Object(s.a)(dl,yl,function(e){var t=e.typed,n=e.matrix,i=e.lup,a=e.slu,s=e.usolve,u=e.lsolve,c=Ya({DenseMatrix:e.DenseMatrix});return t(dl,{"Array, Array | Matrix":function(e,t){e=n(e);var r=i(e);return o(r.L,r.U,r.p,null,t).valueOf()},"DenseMatrix, Array | Matrix":function(e,t){var r=i(e);return o(r.L,r.U,r.p,null,t)},"SparseMatrix, Array | Matrix":function(e,t){var r=i(e);return o(r.L,r.U,r.p,null,t)},"SparseMatrix, Array | Matrix, number, number":function(e,t,r,n){var i=a(e,r,n);return o(i.L,i.U,i.p,i.q,t)},"Object, Array | Matrix":function(e,t){return o(e.L,e.U,e.p,e.q,t)}});function f(e){if(Object(ie.v)(e))return e;if(Object(ie.b)(e))return n(e);throw new TypeError("Invalid Matrix LU decomposition")}function o(e,t,r,n,i){e=f(e),t=f(t),i=c(e,i,!1),r&&(i._data=hl(r,i._data));var a=u(e,i),o=s(t,a);return n&&(o._data=hl(n,o._data)),o}}),vl=["parse"],bl=Object(s.a)("Help",vl,function(e){var o=e.parse;function n(e){if(!(this instanceof n))throw new SyntaxError("Constructor must be called with the new operator");if(!e)throw new Error('Argument "doc" missing');this.doc=e}return n.prototype.type="Help",n.prototype.isHelp=!0,n.prototype.toString=function(){var e=this.doc||{},t="\n";if(e.name&&(t+="Name: "+e.name+"\n\n"),e.category&&(t+="Category: "+e.category+"\n\n"),e.description&&(t+="Description:\n    "+e.description+"\n\n"),e.syntax&&(t+="Syntax:\n    "+e.syntax.join("\n    ")+"\n\n"),e.examples){t+="Examples:\n";for(var r={},n=0;n<e.examples.length;n++){var i=e.examples[n];t+="    "+i+"\n";var a=void 0;try{a=o(i).compile().evaluate(r)}catch(e){a=e}void 0===a||Object(ie.s)(a)||(t+="        "+Object(V.d)(a,{precision:14})+"\n")}t+="\n"}return e.seealso&&e.seealso.length&&(t+="See also: "+e.seealso.join(", ")+"\n"),t},n.prototype.toJSON=function(){var e=Object(ae.a)(this.doc);return e.mathjs="Help",e},n.fromJSON=function(t){var r={};return Object.keys(t).filter(function(e){return"mathjs"!==e}).forEach(function(e){r[e]=t[e]}),new n(r)},n.prototype.valueOf=n.prototype.toString,n},{isClass:!0}),xl=["?on","math"],wl=Object(s.a)("Chain",xl,function(e){var t=e.on,r=e.math;function a(e){if(!(this instanceof a))throw new SyntaxError("Constructor must be called with the new operator");Object(ie.h)(e)?this.value=e.value:this.value=e}function o(e,t){Object(ae.h)(a.prototype,e,function(){var e=t();if("function"==typeof e)return s(e)})}function s(r){return function(){for(var e=[this.value],t=0;t<arguments.length;t++)e[t+1]=arguments[t];return new a(r.apply(r,e))}}a.prototype.type="Chain",a.prototype.isChain=!0,a.prototype.done=function(){return this.value},a.prototype.valueOf=function(){return this.value},a.prototype.toString=function(){return Object(V.d)(this.value)},a.prototype.toJSON=function(){return{mathjs:"Chain",value:this.value}},a.fromJSON=function(e){return new a(e.value)},a.createProxy=function(t,e){if("string"==typeof t)n=t,"function"==typeof(i=e)&&(a.prototype[n]=s(i));else{for(var r in t)!function(e){Object(ae.f)(t,e)&&void 0===u[e]&&o(e,function(){return t[e]})}(r)}var n,i};var u={expression:!0,docs:!0,type:!0,classes:!0,json:!0,error:!0,isChain:!0};return a.createProxy(r),t&&t("import",function(e,t,r){r||o(e,t)}),a},{isClass:!0}),Nl={name:"pi",category:"Constants",syntax:["pi"],description:"The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",examples:["pi","sin(pi/2)"],seealso:["tau"]},Ol={name:"e",category:"Constants",syntax:["e"],description:"Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",examples:["e","e ^ 2","exp(2)","log(e)"],seealso:["exp"]},Ml={bignumber:{name:"bignumber",category:"Construction",syntax:["bignumber(x)"],description:"Create a big number from a number or string.",examples:["0.1 + 0.2","bignumber(0.1) + bignumber(0.2)",'bignumber("7.2")','bignumber("7.2e500")',"bignumber([0.1, 0.2, 0.3])"],seealso:["boolean","complex","fraction","index","matrix","string","unit"]},boolean:{name:"boolean",category:"Construction",syntax:["x","boolean(x)"],description:"Convert a string or number into a boolean.",examples:["boolean(0)","boolean(1)","boolean(3)",'boolean("true")','boolean("false")',"boolean([1, 0, 1, 1])"],seealso:["bignumber","complex","index","matrix","number","string","unit"]},complex:{name:"complex",category:"Construction",syntax:["complex()","complex(re, im)","complex(string)"],description:"Create a complex number.",examples:["complex()","complex(2, 3)",'complex("7 - 2i")'],seealso:["bignumber","boolean","index","matrix","number","string","unit"]},createUnit:{name:"createUnit",category:"Construction",syntax:["createUnit(definitions)","createUnit(name, definition)"],description:"Create a user-defined unit and register it with the Unit type.",examples:['createUnit("foo")','createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})','createUnit("mph", "1 mile/hour")'],seealso:["unit","splitUnit"]},fraction:{name:"fraction",category:"Construction",syntax:["fraction(num)","fraction(num,den)"],description:"Create a fraction from a number or from a numerator and denominator.",examples:["fraction(0.125)","fraction(1, 3) + fraction(2, 5)"],seealso:["bignumber","boolean","complex","index","matrix","string","unit"]},index:{name:"index",category:"Construction",syntax:["[start]","[start:end]","[start:step:end]","[start1, start 2, ...]","[start1:end1, start2:end2, ...]","[start1:step1:end1, start2:step2:end2, ...]"],description:"Create an index to get or replace a subset of a matrix",examples:["[]","[1, 2, 3]","A = [1, 2, 3; 4, 5, 6]","A[1, :]","A[1, 2] = 50","A[0:2, 0:2] = ones(2, 2)"],seealso:["bignumber","boolean","complex","matrix,","number","range","string","unit"]},matrix:{name:"matrix",category:"Construction",syntax:["[]","[a1, b1, ...; a2, b2, ...]","matrix()",'matrix("dense")',"matrix([...])"],description:"Create a matrix.",examples:["[]","[1, 2, 3]","[1, 2, 3; 4, 5, 6]","matrix()","matrix([3, 4])",'matrix([3, 4; 5, 6], "sparse")','matrix([3, 4; 5, 6], "sparse", "number")'],seealso:["bignumber","boolean","complex","index","number","string","unit","sparse"]},number:{name:"number",category:"Construction",syntax:["x","number(x)","number(unit, valuelessUnit)"],description:"Create a number or convert a string or boolean into a number.",examples:["2","2e3","4.05","number(2)",'number("7.2")',"number(true)","number([true, false, true, true])",'number(unit("52cm"), "m")'],seealso:["bignumber","boolean","complex","fraction","index","matrix","string","unit"]},sparse:{name:"sparse",category:"Construction",syntax:["sparse()","sparse([a1, b1, ...; a1, b2, ...])",'sparse([a1, b1, ...; a1, b2, ...], "number")'],description:"Create a sparse matrix.",examples:["sparse()","sparse([3, 4; 5, 6])",'sparse([3, 0; 5, 0], "number")'],seealso:["bignumber","boolean","complex","index","number","string","unit","matrix"]},splitUnit:{name:"splitUnit",category:"Construction",syntax:["splitUnit(unit: Unit, parts: Unit[])"],description:"Split a unit in an array of units whose sum is equal to the original unit.",examples:['splitUnit(1 m, ["feet", "inch"])'],seealso:["unit","createUnit"]},string:{name:"string",category:"Construction",syntax:['"text"',"string(x)"],description:"Create a string or convert a value to a string",examples:['"Hello World!"',"string(4.2)","string(3 + 2i)"],seealso:["bignumber","boolean","complex","index","matrix","number","unit"]},unit:{name:"unit",category:"Construction",syntax:["value unit","unit(value, unit)","unit(string)"],description:"Create a unit.",examples:["5.5 mm","3 inch",'unit(7.1, "kilogram")','unit("23 deg")'],seealso:["bignumber","boolean","complex","index","matrix","number","string"]},e:Ol,E:Ol,false:{name:"false",category:"Constants",syntax:["false"],description:"Boolean value false",examples:["false"],seealso:["true"]},i:{name:"i",category:"Constants",syntax:["i"],description:"Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",examples:["i","i * i","sqrt(-1)"],seealso:[]},Infinity:{name:"Infinity",category:"Constants",syntax:["Infinity"],description:"Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",examples:["Infinity","1 / 0"],seealso:[]},LN2:{name:"LN2",category:"Constants",syntax:["LN2"],description:"Returns the natural logarithm of 2, approximately equal to 0.693",examples:["LN2","log(2)"],seealso:[]},LN10:{name:"LN10",category:"Constants",syntax:["LN10"],description:"Returns the natural logarithm of 10, approximately equal to 2.302",examples:["LN10","log(10)"],seealso:[]},LOG2E:{name:"LOG2E",category:"Constants",syntax:["LOG2E"],description:"Returns the base-2 logarithm of E, approximately equal to 1.442",examples:["LOG2E","log(e, 2)"],seealso:[]},LOG10E:{name:"LOG10E",category:"Constants",syntax:["LOG10E"],description:"Returns the base-10 logarithm of E, approximately equal to 0.434",examples:["LOG10E","log(e, 10)"],seealso:[]},NaN:{name:"NaN",category:"Constants",syntax:["NaN"],description:"Not a number",examples:["NaN","0 / 0"],seealso:[]},null:{name:"null",category:"Constants",syntax:["null"],description:"Value null",examples:["null"],seealso:["true","false"]},pi:Nl,PI:Nl,phi:{name:"phi",category:"Constants",syntax:["phi"],description:"Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",examples:["phi"],seealso:[]},SQRT1_2:{name:"SQRT1_2",category:"Constants",syntax:["SQRT1_2"],description:"Returns the square root of 1/2, approximately equal to 0.707",examples:["SQRT1_2","sqrt(1/2)"],seealso:[]},SQRT2:{name:"SQRT2",category:"Constants",syntax:["SQRT2"],description:"Returns the square root of 2, approximately equal to 1.414",examples:["SQRT2","sqrt(2)"],seealso:[]},tau:{name:"tau",category:"Constants",syntax:["tau"],description:"Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",examples:["tau","2 * pi"],seealso:["pi"]},true:{name:"true",category:"Constants",syntax:["true"],description:"Boolean value true",examples:["true"],seealso:["false"]},version:{name:"version",category:"Constants",syntax:["version"],description:"A string with the version number of math.js",examples:["version"],seealso:[]},speedOfLight:{description:"Speed of light in vacuum",examples:["speedOfLight"]},gravitationConstant:{description:"Newtonian constant of gravitation",examples:["gravitationConstant"]},planckConstant:{description:"Planck constant",examples:["planckConstant"]},reducedPlanckConstant:{description:"Reduced Planck constant",examples:["reducedPlanckConstant"]},magneticConstant:{description:"Magnetic constant (vacuum permeability)",examples:["magneticConstant"]},electricConstant:{description:"Electric constant (vacuum permeability)",examples:["electricConstant"]},vacuumImpedance:{description:"Characteristic impedance of vacuum",examples:["vacuumImpedance"]},coulomb:{description:"Coulomb's constant",examples:["coulomb"]},elementaryCharge:{description:"Elementary charge",examples:["elementaryCharge"]},bohrMagneton:{description:"Borh magneton",examples:["bohrMagneton"]},conductanceQuantum:{description:"Conductance quantum",examples:["conductanceQuantum"]},inverseConductanceQuantum:{description:"Inverse conductance quantum",examples:["inverseConductanceQuantum"]},magneticFluxQuantum:{description:"Magnetic flux quantum",examples:["magneticFluxQuantum"]},nuclearMagneton:{description:"Nuclear magneton",examples:["nuclearMagneton"]},klitzing:{description:"Von Klitzing constant",examples:["klitzing"]},bohrRadius:{description:"Borh radius",examples:["bohrRadius"]},classicalElectronRadius:{description:"Classical electron radius",examples:["classicalElectronRadius"]},electronMass:{description:"Electron mass",examples:["electronMass"]},fermiCoupling:{description:"Fermi coupling constant",examples:["fermiCoupling"]},fineStructure:{description:"Fine-structure constant",examples:["fineStructure"]},hartreeEnergy:{description:"Hartree energy",examples:["hartreeEnergy"]},protonMass:{description:"Proton mass",examples:["protonMass"]},deuteronMass:{description:"Deuteron Mass",examples:["deuteronMass"]},neutronMass:{description:"Neutron mass",examples:["neutronMass"]},quantumOfCirculation:{description:"Quantum of circulation",examples:["quantumOfCirculation"]},rydberg:{description:"Rydberg constant",examples:["rydberg"]},thomsonCrossSection:{description:"Thomson cross section",examples:["thomsonCrossSection"]},weakMixingAngle:{description:"Weak mixing angle",examples:["weakMixingAngle"]},efimovFactor:{description:"Efimov factor",examples:["efimovFactor"]},atomicMass:{description:"Atomic mass constant",examples:["atomicMass"]},avogadro:{description:"Avogadro's number",examples:["avogadro"]},boltzmann:{description:"Boltzmann constant",examples:["boltzmann"]},faraday:{description:"Faraday constant",examples:["faraday"]},firstRadiation:{description:"First radiation constant",examples:["firstRadiation"]},loschmidt:{description:"Loschmidt constant at T=273.15 K and p=101.325 kPa",examples:["loschmidt"]},gasConstant:{description:"Gas constant",examples:["gasConstant"]},molarPlanckConstant:{description:"Molar Planck constant",examples:["molarPlanckConstant"]},molarVolume:{description:"Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",examples:["molarVolume"]},sackurTetrode:{description:"Sackur-Tetrode constant at T=1 K and p=101.325 kPa",examples:["sackurTetrode"]},secondRadiation:{description:"Second radiation constant",examples:["secondRadiation"]},stefanBoltzmann:{description:"Stefan-Boltzmann constant",examples:["stefanBoltzmann"]},wienDisplacement:{description:"Wien displacement law constant",examples:["wienDisplacement"]},molarMass:{description:"Molar mass constant",examples:["molarMass"]},molarMassC12:{description:"Molar mass constant of carbon-12",examples:["molarMassC12"]},gravity:{description:"Standard acceleration of gravity (standard acceleration of free-fall on Earth)",examples:["gravity"]},planckLength:{description:"Planck length",examples:["planckLength"]},planckMass:{description:"Planck mass",examples:["planckMass"]},planckTime:{description:"Planck time",examples:["planckTime"]},planckCharge:{description:"Planck charge",examples:["planckCharge"]},planckTemperature:{description:"Planck temperature",examples:["planckTemperature"]},derivative:{name:"derivative",category:"Algebra",syntax:["derivative(expr, variable)","derivative(expr, variable, {simplify: boolean})"],description:"Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",examples:['derivative("2x^3", "x")','derivative("2x^3", "x", {simplify: false})','derivative("2x^2 + 3x + 4", "x")','derivative("sin(2x)", "x")','f = parse("x^2 + x")','x = parse("x")',"df = derivative(f, x)","df.evaluate({x: 3})"],seealso:["simplify","parse","evaluate"]},lsolve:{name:"lsolve",category:"Algebra",syntax:["x=lsolve(L, b)"],description:"Solves the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",examples:["a = [-2, 3; 2, 1]","b = [11, 9]","x = lsolve(a, b)"],seealso:["lup","lusolve","usolve","matrix","sparse"]},lup:{name:"lup",category:"Algebra",syntax:["lup(m)"],description:"Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",examples:["lup([[2, 1], [1, 4]])","lup(matrix([[2, 1], [1, 4]]))","lup(sparse([[2, 1], [1, 4]]))"],seealso:["lusolve","lsolve","usolve","matrix","sparse","slu","qr"]},lusolve:{name:"lusolve",category:"Algebra",syntax:["x=lusolve(A, b)","x=lusolve(lu, b)"],description:"Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",examples:["a = [-2, 3; 2, 1]","b = [11, 9]","x = lusolve(a, b)"],seealso:["lup","slu","lsolve","usolve","matrix","sparse"]},simplify:{name:"simplify",category:"Algebra",syntax:["simplify(expr)","simplify(expr, rules)"],description:"Simplify an expression tree.",examples:['simplify("3 + 2 / 4")','simplify("2x + x")','f = parse("x * (x + 2 + x)")',"simplified = simplify(f)","simplified.evaluate({x: 2})"],seealso:["derivative","parse","evaluate"]},rationalize:{name:"rationalize",category:"Algebra",syntax:["rationalize(expr)","rationalize(expr, scope)","rationalize(expr, scope, detailed)"],description:"Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",examples:['rationalize("2x/y - y/(x+1)")','rationalize("2x/y - y/(x+1)", true)'],seealso:["simplify"]},slu:{name:"slu",category:"Algebra",syntax:["slu(A, order, threshold)"],description:"Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",examples:["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"],seealso:["lusolve","lsolve","usolve","matrix","sparse","lup","qr"]},usolve:{name:"usolve",category:"Algebra",syntax:["x=usolve(U, b)"],description:"Solves the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",examples:["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],seealso:["lup","lusolve","lsolve","matrix","sparse"]},qr:{name:"qr",category:"Algebra",syntax:["qr(A)"],description:"Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",examples:["qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"],seealso:["lup","slu","matrix"]},abs:{name:"abs",category:"Arithmetic",syntax:["abs(x)"],description:"Compute the absolute value.",examples:["abs(3.5)","abs(-4.2)"],seealso:["sign"]},add:{name:"add",category:"Operators",syntax:["x + y","add(x, y)"],description:"Add two values.",examples:["a = 2.1 + 3.6","a - 3.6","3 + 2i","3 cm + 2 inch",'"2.3" + "4"'],seealso:["subtract"]},cbrt:{name:"cbrt",category:"Arithmetic",syntax:["cbrt(x)","cbrt(x, allRoots)"],description:"Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",examples:["cbrt(64)","cube(4)","cbrt(-8)","cbrt(2 + 3i)","cbrt(8i)","cbrt(8i, true)","cbrt(27 m^3)"],seealso:["square","sqrt","cube","multiply"]},ceil:{name:"ceil",category:"Arithmetic",syntax:["ceil(x)"],description:"Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",examples:["ceil(3.2)","ceil(3.8)","ceil(-4.2)"],seealso:["floor","fix","round"]},cube:{name:"cube",category:"Arithmetic",syntax:["cube(x)"],description:"Compute the cube of a value. The cube of x is x * x * x.",examples:["cube(2)","2^3","2 * 2 * 2"],seealso:["multiply","square","pow"]},divide:{name:"divide",category:"Operators",syntax:["x / y","divide(x, y)"],description:"Divide two values.",examples:["a = 2 / 3","a * 3","4.5 / 2","3 + 4 / 2","(3 + 4) / 2","18 km / 4.5"],seealso:["multiply"]},dotDivide:{name:"dotDivide",category:"Operators",syntax:["x ./ y","dotDivide(x, y)"],description:"Divide two values element wise.",examples:["a = [1, 2, 3; 4, 5, 6]","b = [2, 1, 1; 3, 2, 5]","a ./ b"],seealso:["multiply","dotMultiply","divide"]},dotMultiply:{name:"dotMultiply",category:"Operators",syntax:["x .* y","dotMultiply(x, y)"],description:"Multiply two values element wise.",examples:["a = [1, 2, 3; 4, 5, 6]","b = [2, 1, 1; 3, 2, 5]","a .* b"],seealso:["multiply","divide","dotDivide"]},dotPow:{name:"dotPow",category:"Operators",syntax:["x .^ y","dotPow(x, y)"],description:"Calculates the power of x to y element wise.",examples:["a = [1, 2, 3; 4, 5, 6]","a .^ 2"],seealso:["pow"]},exp:{name:"exp",category:"Arithmetic",syntax:["exp(x)"],description:"Calculate the exponent of a value.",examples:["exp(1.3)","e ^ 1.3","log(exp(1.3))","x = 2.4","(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"],seealso:["expm","expm1","pow","log"]},expm:{name:"expm",category:"Arithmetic",syntax:["exp(x)"],description:"Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",examples:["expm([[0,2],[0,0]])"],seealso:["exp"]},expm1:{name:"expm1",category:"Arithmetic",syntax:["expm1(x)"],description:"Calculate the value of subtracting 1 from the exponential value.",examples:["expm1(2)","pow(e, 2) - 1","log(expm1(2) + 1)"],seealso:["exp","pow","log"]},fix:{name:"fix",category:"Arithmetic",syntax:["fix(x)"],description:"Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",examples:["fix(3.2)","fix(3.8)","fix(-4.2)","fix(-4.8)"],seealso:["ceil","floor","round"]},floor:{name:"floor",category:"Arithmetic",syntax:["floor(x)"],description:"Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",examples:["floor(3.2)","floor(3.8)","floor(-4.2)"],seealso:["ceil","fix","round"]},gcd:{name:"gcd",category:"Arithmetic",syntax:["gcd(a, b)","gcd(a, b, c, ...)"],description:"Compute the greatest common divisor.",examples:["gcd(8, 12)","gcd(-4, 6)","gcd(25, 15, -10)"],seealso:["lcm","xgcd"]},hypot:{name:"hypot",category:"Arithmetic",syntax:["hypot(a, b, c, ...)","hypot([a, b, c, ...])"],description:"Calculate the hypotenusa of a list with values. ",examples:["hypot(3, 4)","sqrt(3^2 + 4^2)","hypot(-2)","hypot([3, 4, 5])"],seealso:["abs","norm"]},lcm:{name:"lcm",category:"Arithmetic",syntax:["lcm(x, y)"],description:"Compute the least common multiple.",examples:["lcm(4, 6)","lcm(6, 21)","lcm(6, 21, 5)"],seealso:["gcd"]},log:{name:"log",category:"Arithmetic",syntax:["log(x)","log(x, base)"],description:"Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",examples:["log(3.5)","a = log(2.4)","exp(a)","10 ^ 4","log(10000, 10)","log(10000) / log(10)","b = log(1024, 2)","2 ^ b"],seealso:["exp","log1p","log2","log10"]},log2:{name:"log2",category:"Arithmetic",syntax:["log2(x)"],description:"Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",examples:["log2(0.03125)","log2(16)","log2(16) / log2(2)","pow(2, 4)"],seealso:["exp","log1p","log","log10"]},log1p:{name:"log1p",category:"Arithmetic",syntax:["log1p(x)","log1p(x, base)"],description:"Calculate the logarithm of a `value+1`",examples:["log1p(2.5)","exp(log1p(1.4))","pow(10, 4)","log1p(9999, 10)","log1p(9999) / log(10)"],seealso:["exp","log","log2","log10"]},log10:{name:"log10",category:"Arithmetic",syntax:["log10(x)"],description:"Compute the 10-base logarithm of a value.",examples:["log10(0.00001)","log10(10000)","10 ^ 4","log(10000) / log(10)","log(10000, 10)"],seealso:["exp","log"]},mod:{name:"mod",category:"Operators",syntax:["x % y","x mod y","mod(x, y)"],description:"Calculates the modulus, the remainder of an integer division.",examples:["7 % 3","11 % 2","10 mod 4","isOdd(x) = x % 2","isOdd(2)","isOdd(3)"],seealso:["divide"]},multiply:{name:"multiply",category:"Operators",syntax:["x * y","multiply(x, y)"],description:"multiply two values.",examples:["a = 2.1 * 3.4","a / 3.4","2 * 3 + 4","2 * (3 + 4)","3 * 2.1 km"],seealso:["divide"]},norm:{name:"norm",category:"Arithmetic",syntax:["norm(x)","norm(x, p)"],description:"Calculate the norm of a number, vector or matrix.",examples:["abs(-3.5)","norm(-3.5)","norm(3 - 4i)","norm([1, 2, -3], Infinity)","norm([1, 2, -3], -Infinity)","norm([3, 4], 2)","norm([[1, 2], [3, 4]], 1)",'norm([[1, 2], [3, 4]], "inf")','norm([[1, 2], [3, 4]], "fro")']},nthRoot:{name:"nthRoot",category:"Arithmetic",syntax:["nthRoot(a)","nthRoot(a, root)"],description:'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',examples:["4 ^ 3","nthRoot(64, 3)","nthRoot(9, 2)","sqrt(9)"],seealso:["nthRoots","pow","sqrt"]},nthRoots:{name:"nthRoots",category:"Arithmetic",syntax:["nthRoots(A)","nthRoots(A, root)"],description:'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',examples:["nthRoots(1)","nthRoots(1, 3)"],seealso:["sqrt","pow","nthRoot"]},pow:{name:"pow",category:"Operators",syntax:["x ^ y","pow(x, y)"],description:"Calculates the power of x to y, x^y.",examples:["2^3","2*2*2","1 + e ^ (pi * i)"],seealso:["multiply","nthRoot","nthRoots","sqrt"]},round:{name:"round",category:"Arithmetic",syntax:["round(x)","round(x, n)"],description:"round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",examples:["round(3.2)","round(3.8)","round(-4.2)","round(-4.8)","round(pi, 3)","round(123.45678, 2)"],seealso:["ceil","floor","fix"]},sign:{name:"sign",category:"Arithmetic",syntax:["sign(x)"],description:"Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",examples:["sign(3.5)","sign(-4.2)","sign(0)"],seealso:["abs"]},sqrt:{name:"sqrt",category:"Arithmetic",syntax:["sqrt(x)"],description:"Compute the square root value. If x = y * y, then y is the square root of x.",examples:["sqrt(25)","5 * 5","sqrt(-1)"],seealso:["square","sqrtm","multiply","nthRoot","nthRoots","pow"]},sqrtm:{name:"sqrtm",category:"Arithmetic",syntax:["sqrtm(x)"],description:"Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",examples:["sqrtm([[1, 2], [3, 4]])"],seealso:["sqrt","abs","square","multiply"]},square:{name:"square",category:"Arithmetic",syntax:["square(x)"],description:"Compute the square of a value. The square of x is x * x.",examples:["square(3)","sqrt(9)","3^2","3 * 3"],seealso:["multiply","pow","sqrt","cube"]},subtract:{name:"subtract",category:"Operators",syntax:["x - y","subtract(x, y)"],description:"subtract two values.",examples:["a = 5.3 - 2","a + 2","2/3 - 1/6","2 * 3 - 3","2.1 km - 500m"],seealso:["add"]},unaryMinus:{name:"unaryMinus",category:"Operators",syntax:["-x","unaryMinus(x)"],description:"Inverse the sign of a value. Converts booleans and strings to numbers.",examples:["-4.5","-(-5.6)",'-"22"'],seealso:["add","subtract","unaryPlus"]},unaryPlus:{name:"unaryPlus",category:"Operators",syntax:["+x","unaryPlus(x)"],description:"Converts booleans and strings to numbers.",examples:["+true",'+"2"'],seealso:["add","subtract","unaryMinus"]},xgcd:{name:"xgcd",category:"Arithmetic",syntax:["xgcd(a, b)"],description:"Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",examples:["xgcd(8, 12)","gcd(8, 12)","xgcd(36163, 21199)"],seealso:["gcd","lcm"]},bitAnd:{name:"bitAnd",category:"Bitwise",syntax:["x & y","bitAnd(x, y)"],description:"Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",examples:["5 & 3","bitAnd(53, 131)","[1, 12, 31] & 42"],seealso:["bitNot","bitOr","bitXor","leftShift","rightArithShift","rightLogShift"]},bitNot:{name:"bitNot",category:"Bitwise",syntax:["~x","bitNot(x)"],description:"Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",examples:["~1","~2","bitNot([2, -3, 4])"],seealso:["bitAnd","bitOr","bitXor","leftShift","rightArithShift","rightLogShift"]},bitOr:{name:"bitOr",category:"Bitwise",syntax:["x | y","bitOr(x, y)"],description:"Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",examples:["5 | 3","bitOr([1, 2, 3], 4)"],seealso:["bitAnd","bitNot","bitXor","leftShift","rightArithShift","rightLogShift"]},bitXor:{name:"bitXor",category:"Bitwise",syntax:["bitXor(x, y)"],description:"Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",examples:["bitOr(1, 2)","bitXor([2, 3, 4], 4)"],seealso:["bitAnd","bitNot","bitOr","leftShift","rightArithShift","rightLogShift"]},leftShift:{name:"leftShift",category:"Bitwise",syntax:["x << y","leftShift(x, y)"],description:"Bitwise left logical shift of a value x by y number of bits.",examples:["4 << 1","8 >> 1"],seealso:["bitAnd","bitNot","bitOr","bitXor","rightArithShift","rightLogShift"]},rightArithShift:{name:"rightArithShift",category:"Bitwise",syntax:["x >> y","rightArithShift(x, y)"],description:"Bitwise right arithmetic shift of a value x by y number of bits.",examples:["8 >> 1","4 << 1","-12 >> 2"],seealso:["bitAnd","bitNot","bitOr","bitXor","leftShift","rightLogShift"]},rightLogShift:{name:"rightLogShift",category:"Bitwise",syntax:["x >>> y","rightLogShift(x, y)"],description:"Bitwise right logical shift of a value x by y number of bits.",examples:["8 >>> 1","4 << 1","-12 >>> 2"],seealso:["bitAnd","bitNot","bitOr","bitXor","leftShift","rightArithShift"]},bellNumbers:{name:"bellNumbers",category:"Combinatorics",syntax:["bellNumbers(n)"],description:"The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",examples:["bellNumbers(3)","bellNumbers(8)"],seealso:["stirlingS2"]},catalan:{name:"catalan",category:"Combinatorics",syntax:["catalan(n)"],description:"The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",examples:["catalan(3)","catalan(8)"],seealso:["bellNumbers"]},composition:{name:"composition",category:"Combinatorics",syntax:["composition(n, k)"],description:"The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",examples:["composition(5, 3)"],seealso:["combinations"]},stirlingS2:{name:"stirlingS2",category:"Combinatorics",syntax:["stirlingS2(n, k)"],description:"he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",examples:["stirlingS2(5, 3)"],seealso:["bellNumbers"]},config:{name:"config",category:"Core",syntax:["config()","config(options)"],description:"Get configuration or change configuration.",examples:["config()","1/3 + 1/4",'config({number: "Fraction"})',"1/3 + 1/4"],seealso:[]},import:{name:"import",category:"Core",syntax:["import(functions)","import(functions, options)"],description:"Import functions or constants from an object.",examples:["import({myFn: f(x)=x^2, myConstant: 32 })","myFn(2)","myConstant"],seealso:[]},typed:{name:"typed",category:"Core",syntax:["typed(signatures)","typed(name, signatures)"],description:"Create a typed function.",examples:['double = typed({ "number, number": f(x)=x+x })',"double(2)",'double("hello")'],seealso:[]},arg:{name:"arg",category:"Complex",syntax:["arg(x)"],description:"Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",examples:["arg(2 + 2i)","atan2(3, 2)","arg(2 + 3i)"],seealso:["re","im","conj","abs"]},conj:{name:"conj",category:"Complex",syntax:["conj(x)"],description:"Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",examples:["conj(2 + 3i)","conj(2 - 3i)","conj(-5.2i)"],seealso:["re","im","abs","arg"]},re:{name:"re",category:"Complex",syntax:["re(x)"],description:"Get the real part of a complex number.",examples:["re(2 + 3i)","im(2 + 3i)","re(-5.2i)","re(2.4)"],seealso:["im","conj","abs","arg"]},im:{name:"im",category:"Complex",syntax:["im(x)"],description:"Get the imaginary part of a complex number.",examples:["im(2 + 3i)","re(2 + 3i)","im(-5.2i)","im(2.4)"],seealso:["re","conj","abs","arg"]},evaluate:{name:"evaluate",category:"Expression",syntax:["evaluate(expression)","evaluate([expr1, expr2, expr3, ...])"],description:"Evaluate an expression or an array with expressions.",examples:['evaluate("2 + 3")','evaluate("sqrt(" + 4 + ")")'],seealso:[]},help:{name:"help",category:"Expression",syntax:["help(object)","help(string)"],description:"Display documentation on a function or data type.",examples:["help(sqrt)",'help("complex")'],seealso:[]},distance:{name:"distance",category:"Geometry",syntax:["distance([x1, y1], [x2, y2])","distance([[x1, y1], [x2, y2]])"],description:"Calculates the Euclidean distance between two points.",examples:["distance([0,0], [4,4])","distance([[0,0], [4,4]])"],seealso:[]},intersect:{name:"intersect",category:"Geometry",syntax:["intersect(expr1, expr2, expr3, expr4)","intersect(expr1, expr2, expr3)"],description:"Computes the intersection point of lines and/or planes.",examples:["intersect([0, 0], [10, 10], [10, 0], [0, 10])","intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"],seealso:[]},and:{name:"and",category:"Logical",syntax:["x and y","and(x, y)"],description:"Logical and. Test whether two values are both defined with a nonzero/nonempty value.",examples:["true and false","true and true","2 and 4"],seealso:["not","or","xor"]},not:{name:"not",category:"Logical",syntax:["not x","not(x)"],description:"Logical not. Flips the boolean value of given argument.",examples:["not true","not false","not 2","not 0"],seealso:["and","or","xor"]},or:{name:"or",category:"Logical",syntax:["x or y","or(x, y)"],description:"Logical or. Test if at least one value is defined with a nonzero/nonempty value.",examples:["true or false","false or false","0 or 4"],seealso:["not","and","xor"]},xor:{name:"xor",category:"Logical",syntax:["x xor y","xor(x, y)"],description:"Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",examples:["true xor false","false xor false","true xor true","0 xor 4"],seealso:["not","and","or"]},concat:{name:"concat",category:"Matrix",syntax:["concat(A, B, C, ...)","concat(A, B, C, ..., dim)"],description:"Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",examples:["A = [1, 2; 5, 6]","B = [3, 4; 7, 8]","concat(A, B)","concat(A, B, 1)","concat(A, B, 2)"],seealso:["det","diag","identity","inv","ones","range","size","squeeze","subset","trace","transpose","zeros"]},cross:{name:"cross",category:"Matrix",syntax:["cross(A, B)"],description:"Calculate the cross product for two vectors in three dimensional space.",examples:["cross([1, 1, 0],  [0, 1, 1])","cross([3, -3, 1], [4, 9, 2])","cross([2, 3, 4],  [5, 6, 7])"],seealso:["multiply","dot"]},column:{name:"column",category:"Matrix",syntax:["column(x, index)"],description:"Return a column from a matrix or array.",examples:["A = [[1, 2], [3, 4]]","column(A, 1)","column(A, 2)"],seealso:["row"]},ctranspose:{name:"ctranspose",category:"Matrix",syntax:["x'","ctranspose(x)"],description:"Complex Conjugate and Transpose a matrix",examples:["a = [1, 2, 3; 4, 5, 6]","a'","ctranspose(a)"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","subset","trace","zeros"]},det:{name:"det",category:"Matrix",syntax:["det(x)"],description:"Calculate the determinant of a matrix",examples:["det([1, 2; 3, 4])","det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"],seealso:["concat","diag","identity","inv","ones","range","size","squeeze","subset","trace","transpose","zeros"]},diag:{name:"diag",category:"Matrix",syntax:["diag(x)","diag(x, k)"],description:"Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",examples:["diag(1:3)","diag(1:3, 1)","a = [1, 2, 3; 4, 5, 6; 7, 8, 9]","diag(a)"],seealso:["concat","det","identity","inv","ones","range","size","squeeze","subset","trace","transpose","zeros"]},dot:{name:"dot",category:"Matrix",syntax:["dot(A, B)","A * B"],description:"Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",examples:["dot([2, 4, 1], [2, 2, 3])","[2, 4, 1] * [2, 2, 3]"],seealso:["multiply","cross"]},getMatrixDataType:{name:"getMatrixDataType",category:"Matrix",syntax:["getMatrixDataType(x)"],description:'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',examples:["getMatrixDataType([1, 2, 3])","getMatrixDataType([[5 cm], [2 inch]])",'getMatrixDataType([1, "text"])',"getMatrixDataType([1, bignumber(4)])"],seealso:["matrix","sparse","typeOf"]},identity:{name:"identity",category:"Matrix",syntax:["identity(n)","identity(m, n)","identity([m, n])"],description:"Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",examples:["identity(3)","identity(3, 5)","a = [1, 2, 3; 4, 5, 6]","identity(size(a))"],seealso:["concat","det","diag","inv","ones","range","size","squeeze","subset","trace","transpose","zeros"]},filter:{name:"filter",category:"Matrix",syntax:["filter(x, test)"],description:"Filter items in a matrix.",examples:["isPositive(x) = x > 0","filter([6, -2, -1, 4, 3], isPositive)","filter([6, -2, 0, 1, 0], x != 0)"],seealso:["sort","map","forEach"]},flatten:{name:"flatten",category:"Matrix",syntax:["flatten(x)"],description:"Flatten a multi dimensional matrix into a single dimensional matrix.",examples:["a = [1, 2, 3; 4, 5, 6]","size(a)","b = flatten(a)","size(b)"],seealso:["concat","resize","size","squeeze"]},forEach:{name:"forEach",category:"Matrix",syntax:["forEach(x, callback)"],description:"Iterates over all elements of a matrix/array, and executes the given callback function.",examples:["forEach([1, 2, 3], function(val) { console.log(val) })"],seealso:["map","sort","filter"]},inv:{name:"inv",category:"Matrix",syntax:["inv(x)"],description:"Calculate the inverse of a matrix",examples:["inv([1, 2; 3, 4])","inv(4)","1 / 4"],seealso:["concat","det","diag","identity","ones","range","size","squeeze","subset","trace","transpose","zeros"]},eigs:{name:"eigs",category:"Matrix",syntax:["eigs(x)"],description:"Calculate the eigenvalues and eigenvectors of a real symmetric matrix",examples:["eigs([[5, 2.3], [2.3, 1]])"],seealso:["inv"]},kron:{name:"kron",category:"Matrix",syntax:["kron(x, y)"],description:"Calculates the kronecker product of 2 matrices or vectors.",examples:["kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])","kron([1,1], [2,3,4])"],seealso:["multiply","dot","cross"]},map:{name:"map",category:"Matrix",syntax:["map(x, callback)"],description:"Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",examples:["map([1, 2, 3], square)"],seealso:["filter","forEach"]},ones:{name:"ones",category:"Matrix",syntax:["ones(m)","ones(m, n)","ones(m, n, p, ...)","ones([m])","ones([m, n])","ones([m, n, p, ...])"],description:"Create a matrix containing ones.",examples:["ones(3)","ones(3, 5)","ones([2,3]) * 4.5","a = [1, 2, 3; 4, 5, 6]","ones(size(a))"],seealso:["concat","det","diag","identity","inv","range","size","squeeze","subset","trace","transpose","zeros"]},partitionSelect:{name:"partitionSelect",category:"Matrix",syntax:["partitionSelect(x, k)","partitionSelect(x, k, compare)"],description:"Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",examples:["partitionSelect([5, 10, 1], 2)",'partitionSelect(["C", "B", "A", "D"], 1)'],seealso:["sort"]},range:{name:"range",category:"Type",syntax:["start:end","start:step:end","range(start, end)","range(start, end, step)","range(string)"],description:"Create a range. Lower bound of the range is included, upper bound is excluded.",examples:["1:5","3:-1:-3","range(3, 7)","range(0, 12, 2)",'range("4:10")',"a = [1, 2, 3, 4; 5, 6, 7, 8]","a[1:2, 1:2]"],seealso:["concat","det","diag","identity","inv","ones","size","squeeze","subset","trace","transpose","zeros"]},resize:{name:"resize",category:"Matrix",syntax:["resize(x, size)","resize(x, size, defaultValue)"],description:"Resize a matrix.",examples:["resize([1,2,3,4,5], [3])","resize([1,2,3], [5])","resize([1,2,3], [5], -1)","resize(2, [2, 3])",'resize("hello", [8], "!")'],seealso:["size","subset","squeeze","reshape"]},reshape:{name:"reshape",category:"Matrix",syntax:["reshape(x, sizes)"],description:"Reshape a multi dimensional array to fit the specified dimensions.",examples:["reshape([1, 2, 3, 4, 5, 6], [2, 3])","reshape([[1, 2], [3, 4]], [1, 4])","reshape([[1, 2], [3, 4]], [4])"],seealso:["size","squeeze","resize"]},row:{name:"row",category:"Matrix",syntax:["row(x, index)"],description:"Return a row from a matrix or array.",examples:["A = [[1, 2], [3, 4]]","row(A, 1)","row(A, 2)"],seealso:["column"]},size:{name:"size",category:"Matrix",syntax:["size(x)"],description:"Calculate the size of a matrix.",examples:["size(2.3)",'size("hello world")',"a = [1, 2; 3, 4; 5, 6]","size(a)","size(1:6)"],seealso:["concat","det","diag","identity","inv","ones","range","squeeze","subset","trace","transpose","zeros"]},sort:{name:"sort",category:"Matrix",syntax:["sort(x)","sort(x, compare)"],description:'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',examples:["sort([5, 10, 1])",'sort(["C", "B", "A", "D"])',"sortByLength(a, b) = size(a)[1] - size(b)[1]",'sort(["Langdon", "Tom", "Sara"], sortByLength)','sort(["10", "1", "2"], "natural")'],seealso:["map","filter","forEach"]},squeeze:{name:"squeeze",category:"Matrix",syntax:["squeeze(x)"],description:"Remove inner and outer singleton dimensions from a matrix.",examples:["a = zeros(3,2,1)","size(squeeze(a))","b = zeros(1,1,3)","size(squeeze(b))"],seealso:["concat","det","diag","identity","inv","ones","range","size","subset","trace","transpose","zeros"]},subset:{name:"subset",category:"Matrix",syntax:["value(index)","value(index) = replacement","subset(value, [index])","subset(value, [index], replacement)"],description:"Get or set a subset of a matrix or string. Indexes are one-based. Both the ranges lower-bound and upper-bound are included.",examples:["d = [1, 2; 3, 4]","e = []","e[1, 1:2] = [5, 6]","e[2, :] = [7, 8]","f = d * e","f[2, 1]","f[:, 1]"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","trace","transpose","zeros"]},trace:{name:"trace",category:"Matrix",syntax:["trace(A)"],description:"Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",examples:["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]","trace(A)"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","subset","transpose","zeros"]},transpose:{name:"transpose",category:"Matrix",syntax:["x'","transpose(x)"],description:"Transpose a matrix",examples:["a = [1, 2, 3; 4, 5, 6]","a'","transpose(a)"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","subset","trace","zeros"]},zeros:{name:"zeros",category:"Matrix",syntax:["zeros(m)","zeros(m, n)","zeros(m, n, p, ...)","zeros([m])","zeros([m, n])","zeros([m, n, p, ...])"],description:"Create a matrix containing zeros.",examples:["zeros(3)","zeros(3, 5)","a = [1, 2, 3; 4, 5, 6]","zeros(size(a))"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","subset","trace","transpose"]},combinations:{name:"combinations",category:"Probability",syntax:["combinations(n, k)"],description:"Compute the number of combinations of n items taken k at a time",examples:["combinations(7, 5)"],seealso:["combinationsWithRep","permutations","factorial"]},combinationsWithRep:{name:"combinationsWithRep",category:"Probability",syntax:["combinationsWithRep(n, k)"],description:"Compute the number of combinations of n items taken k at a time with replacements.",examples:["combinationsWithRep(7, 5)"],seealso:["combinations","permutations","factorial"]},factorial:{name:"factorial",category:"Probability",syntax:["n!","factorial(n)"],description:"Compute the factorial of a value",examples:["5!","5 * 4 * 3 * 2 * 1","3!"],seealso:["combinations","combinationsWithRep","permutations","gamma"]},gamma:{name:"gamma",category:"Probability",syntax:["gamma(n)"],description:"Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",examples:["gamma(4)","3!","gamma(1/2)","sqrt(pi)"],seealso:["factorial"]},kldivergence:{name:"kldivergence",category:"Probability",syntax:["kldivergence(x, y)"],description:"Calculate the Kullback-Leibler (KL) divergence  between two distributions.",examples:["kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"],seealso:[]},multinomial:{name:"multinomial",category:"Probability",syntax:["multinomial(A)"],description:"Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",examples:["multinomial([1, 2, 1])"],seealso:["combinations","factorial"]},permutations:{name:"permutations",category:"Probability",syntax:["permutations(n)","permutations(n, k)"],description:"Compute the number of permutations of n items taken k at a time",examples:["permutations(5)","permutations(5, 3)"],seealso:["combinations","combinationsWithRep","factorial"]},pickRandom:{name:"pickRandom",category:"Probability",syntax:["pickRandom(array)","pickRandom(array, number)","pickRandom(array, weights)","pickRandom(array, number, weights)","pickRandom(array, weights, number)"],description:"Pick a random entry from a given array.",examples:["pickRandom(0:10)","pickRandom([1, 3, 1, 6])","pickRandom([1, 3, 1, 6], 2)","pickRandom([1, 3, 1, 6], [2, 3, 2, 1])","pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])","pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"],seealso:["random","randomInt"]},random:{name:"random",category:"Probability",syntax:["random()","random(max)","random(min, max)","random(size)","random(size, max)","random(size, min, max)"],description:"Return a random number.",examples:["random()","random(10, 20)","random([2, 3])"],seealso:["pickRandom","randomInt"]},randomInt:{name:"randomInt",category:"Probability",syntax:["randomInt(max)","randomInt(min, max)","randomInt(size)","randomInt(size, max)","randomInt(size, min, max)"],description:"Return a random integer number",examples:["randomInt(10, 20)","randomInt([2, 3], 10)"],seealso:["pickRandom","random"]},compare:{name:"compare",category:"Relational",syntax:["compare(x, y)"],description:"Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",examples:["compare(2, 3)","compare(3, 2)","compare(2, 2)","compare(5cm, 40mm)","compare(2, [1, 2, 3])"],seealso:["equal","unequal","smaller","smallerEq","largerEq","compareNatural","compareText"]},compareNatural:{name:"compareNatural",category:"Relational",syntax:["compareNatural(x, y)"],description:"Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",examples:["compareNatural(2, 3)","compareNatural(3, 2)","compareNatural(2, 2)","compareNatural(5cm, 40mm)",'compareNatural("2", "10")',"compareNatural(2 + 3i, 2 + 4i)","compareNatural([1, 2, 4], [1, 2, 3])","compareNatural([1, 5], [1, 2, 3])","compareNatural([1, 2], [1, 2])","compareNatural({a: 2}, {a: 4})"],seealso:["equal","unequal","smaller","smallerEq","largerEq","compare","compareText"]},compareText:{name:"compareText",category:"Relational",syntax:["compareText(x, y)"],description:"Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",examples:['compareText("B", "A")','compareText("A", "B")','compareText("A", "A")','compareText("2", "10")','compare("2", "10")',"compare(2, 10)",'compareNatural("2", "10")','compareText("B", ["A", "B", "C"])'],seealso:["compare","compareNatural"]},deepEqual:{name:"deepEqual",category:"Relational",syntax:["deepEqual(x, y)"],description:"Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",examples:["deepEqual([1,3,4], [1,3,4])","deepEqual([1,3,4], [1,3])"],seealso:["equal","unequal","smaller","larger","smallerEq","largerEq","compare"]},equal:{name:"equal",category:"Relational",syntax:["x == y","equal(x, y)"],description:"Check equality of two values. Returns true if the values are equal, and false if not.",examples:["2+2 == 3","2+2 == 4","a = 3.2","b = 6-2.8","a == b","50cm == 0.5m"],seealso:["unequal","smaller","larger","smallerEq","largerEq","compare","deepEqual","equalText"]},equalText:{name:"equalText",category:"Relational",syntax:["equalText(x, y)"],description:"Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",examples:['equalText("Hello", "Hello")','equalText("a", "A")','equal("2e3", "2000")','equalText("2e3", "2000")','equalText("B", ["A", "B", "C"])'],seealso:["compare","compareNatural","compareText","equal"]},larger:{name:"larger",category:"Relational",syntax:["x > y","larger(x, y)"],description:"Check if value x is larger than y. Returns true if x is larger than y, and false if not.",examples:["2 > 3","5 > 2*2","a = 3.3","b = 6-2.8","(a > b)","(b < a)","5 cm > 2 inch"],seealso:["equal","unequal","smaller","smallerEq","largerEq","compare"]},largerEq:{name:"largerEq",category:"Relational",syntax:["x >= y","largerEq(x, y)"],description:"Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",examples:["2 >= 1+1","2 > 1+1","a = 3.2","b = 6-2.8","(a >= b)"],seealso:["equal","unequal","smallerEq","smaller","compare"]},smaller:{name:"smaller",category:"Relational",syntax:["x < y","smaller(x, y)"],description:"Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",examples:["2 < 3","5 < 2*2","a = 3.3","b = 6-2.8","(a < b)","5 cm < 2 inch"],seealso:["equal","unequal","larger","smallerEq","largerEq","compare"]},smallerEq:{name:"smallerEq",category:"Relational",syntax:["x <= y","smallerEq(x, y)"],description:"Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",examples:["2 <= 1+1","2 < 1+1","a = 3.2","b = 6-2.8","(a <= b)"],seealso:["equal","unequal","larger","smaller","largerEq","compare"]},unequal:{name:"unequal",category:"Relational",syntax:["x != y","unequal(x, y)"],description:"Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",examples:["2+2 != 3","2+2 != 4","a = 3.2","b = 6-2.8","a != b","50cm != 0.5m","5 cm != 2 inch"],seealso:["equal","smaller","larger","smallerEq","largerEq","compare","deepEqual"]},setCartesian:{name:"setCartesian",category:"Set",syntax:["setCartesian(set1, set2)"],description:"Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setCartesian([1, 2], [3, 4])"],seealso:["setUnion","setIntersect","setDifference","setPowerset"]},setDifference:{name:"setDifference",category:"Set",syntax:["setDifference(set1, set2)"],description:"Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setDifference([1, 2, 3, 4], [3, 4, 5, 6])","setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],seealso:["setUnion","setIntersect","setSymDifference"]},setDistinct:{name:"setDistinct",category:"Set",syntax:["setDistinct(set)"],description:"Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",examples:["setDistinct([1, 1, 1, 2, 2, 3])"],seealso:["setMultiplicity"]},setIntersect:{name:"setIntersect",category:"Set",syntax:["setIntersect(set1, set2)"],description:"Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setIntersect([1, 2, 3, 4], [3, 4, 5, 6])","setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],seealso:["setUnion","setDifference"]},setIsSubset:{name:"setIsSubset",category:"Set",syntax:["setIsSubset(set1, set2)"],description:"Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setIsSubset([1, 2], [3, 4, 5, 6])","setIsSubset([3, 4], [3, 4, 5, 6])"],seealso:["setUnion","setIntersect","setDifference"]},setMultiplicity:{name:"setMultiplicity",category:"Set",syntax:["setMultiplicity(element, set)"],description:"Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",examples:["setMultiplicity(1, [1, 2, 2, 4])","setMultiplicity(2, [1, 2, 2, 4])"],seealso:["setDistinct","setSize"]},setPowerset:{name:"setPowerset",category:"Set",syntax:["setPowerset(set)"],description:"Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",examples:["setPowerset([1, 2, 3])"],seealso:["setCartesian"]},setSize:{name:"setSize",category:"Set",syntax:["setSize(set)","setSize(set, unique)"],description:'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',examples:["setSize([1, 2, 2, 4])","setSize([1, 2, 2, 4], true)"],seealso:["setUnion","setIntersect","setDifference"]},setSymDifference:{name:"setSymDifference",category:"Set",syntax:["setSymDifference(set1, set2)"],description:"Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])","setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],seealso:["setUnion","setIntersect","setDifference"]},setUnion:{name:"setUnion",category:"Set",syntax:["setUnion(set1, set2)"],description:"Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setUnion([1, 2, 3, 4], [3, 4, 5, 6])","setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],seealso:["setIntersect","setDifference"]},erf:{name:"erf",category:"Special",syntax:["erf(x)"],description:"Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",examples:["erf(0.2)","erf(-0.5)","erf(4)"],seealso:[]},mad:{name:"mad",category:"Statistics",syntax:["mad(a, b, c, ...)","mad(A)"],description:"Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",examples:["mad(10, 20, 30)","mad([1, 2, 3])"],seealso:["mean","median","std","abs"]},max:{name:"max",category:"Statistics",syntax:["max(a, b, c, ...)","max(A)","max(A, dim)"],description:"Compute the maximum value of a list of values.",examples:["max(2, 3, 4, 1)","max([2, 3, 4, 1])","max([2, 5; 4, 3])","max([2, 5; 4, 3], 1)","max([2, 5; 4, 3], 2)","max(2.7, 7.1, -4.5, 2.0, 4.1)","min(2.7, 7.1, -4.5, 2.0, 4.1)"],seealso:["mean","median","min","prod","std","sum","variance"]},mean:{name:"mean",category:"Statistics",syntax:["mean(a, b, c, ...)","mean(A)","mean(A, dim)"],description:"Compute the arithmetic mean of a list of values.",examples:["mean(2, 3, 4, 1)","mean([2, 3, 4, 1])","mean([2, 5; 4, 3])","mean([2, 5; 4, 3], 1)","mean([2, 5; 4, 3], 2)","mean([1.0, 2.7, 3.2, 4.0])"],seealso:["max","median","min","prod","std","sum","variance"]},median:{name:"median",category:"Statistics",syntax:["median(a, b, c, ...)","median(A)"],description:"Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",examples:["median(5, 2, 7)","median([3, -1, 5, 7])"],seealso:["max","mean","min","prod","std","sum","variance","quantileSeq"]},min:{name:"min",category:"Statistics",syntax:["min(a, b, c, ...)","min(A)","min(A, dim)"],description:"Compute the minimum value of a list of values.",examples:["min(2, 3, 4, 1)","min([2, 3, 4, 1])","min([2, 5; 4, 3])","min([2, 5; 4, 3], 1)","min([2, 5; 4, 3], 2)","min(2.7, 7.1, -4.5, 2.0, 4.1)","max(2.7, 7.1, -4.5, 2.0, 4.1)"],seealso:["max","mean","median","prod","std","sum","variance"]},mode:{name:"mode",category:"Statistics",syntax:["mode(a, b, c, ...)","mode(A)","mode(A, a, b, B, c, ...)"],description:"Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",examples:["mode(2, 1, 4, 3, 1)","mode([1, 2.7, 3.2, 4, 2.7])","mode(1, 4, 6, 1, 6)"],seealso:["max","mean","min","median","prod","std","sum","variance"]},prod:{name:"prod",category:"Statistics",syntax:["prod(a, b, c, ...)","prod(A)"],description:"Compute the product of all values.",examples:["prod(2, 3, 4)","prod([2, 3, 4])","prod([2, 5; 4, 3])"],seealso:["max","mean","min","median","min","std","sum","variance"]},quantileSeq:{name:"quantileSeq",category:"Statistics",syntax:["quantileSeq(A, prob[, sorted])","quantileSeq(A, [prob1, prob2, ...][, sorted])","quantileSeq(A, N[, sorted])"],description:"Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.",examples:["quantileSeq([3, -1, 5, 7], 0.5)","quantileSeq([3, -1, 5, 7], [1/3, 2/3])","quantileSeq([3, -1, 5, 7], 2)","quantileSeq([-1, 3, 5, 7], 0.5, true)"],seealso:["mean","median","min","max","prod","std","sum","variance"]},std:{name:"std",category:"Statistics",syntax:["std(a, b, c, ...)","std(A)","std(A, normalization)"],description:'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',examples:["std(2, 4, 6)","std([2, 4, 6, 8])",'std([2, 4, 6, 8], "uncorrected")','std([2, 4, 6, 8], "biased")',"std([1, 2, 3; 4, 5, 6])"],seealso:["max","mean","min","median","prod","sum","variance"]},sum:{name:"sum",category:"Statistics",syntax:["sum(a, b, c, ...)","sum(A)"],description:"Compute the sum of all values.",examples:["sum(2, 3, 4, 1)","sum([2, 3, 4, 1])","sum([2, 5; 4, 3])"],seealso:["max","mean","median","min","prod","std","sum","variance"]},variance:{name:"variance",category:"Statistics",syntax:["variance(a, b, c, ...)","variance(A)","variance(A, normalization)"],description:'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',examples:["variance(2, 4, 6)","variance([2, 4, 6, 8])",'variance([2, 4, 6, 8], "uncorrected")','variance([2, 4, 6, 8], "biased")',"variance([1, 2, 3; 4, 5, 6])"],seealso:["max","mean","min","median","min","prod","std","sum"]},acos:{name:"acos",category:"Trigonometry",syntax:["acos(x)"],description:"Compute the inverse cosine of a value in radians.",examples:["acos(0.5)","acos(cos(2.3))"],seealso:["cos","atan","asin"]},acosh:{name:"acosh",category:"Trigonometry",syntax:["acosh(x)"],description:"Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",examples:["acosh(1.5)"],seealso:["cosh","asinh","atanh"]},acot:{name:"acot",category:"Trigonometry",syntax:["acot(x)"],description:"Calculate the inverse cotangent of a value.",examples:["acot(0.5)","acot(cot(0.5))","acot(2)"],seealso:["cot","atan"]},acoth:{name:"acoth",category:"Trigonometry",syntax:["acoth(x)"],description:"Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",examples:["acoth(2)","acoth(0.5)"],seealso:["acsch","asech"]},acsc:{name:"acsc",category:"Trigonometry",syntax:["acsc(x)"],description:"Calculate the inverse cotangent of a value.",examples:["acsc(2)","acsc(csc(0.5))","acsc(0.5)"],seealso:["csc","asin","asec"]},acsch:{name:"acsch",category:"Trigonometry",syntax:["acsch(x)"],description:"Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",examples:["acsch(0.5)"],seealso:["asech","acoth"]},asec:{name:"asec",category:"Trigonometry",syntax:["asec(x)"],description:"Calculate the inverse secant of a value.",examples:["asec(0.5)","asec(sec(0.5))","asec(2)"],seealso:["acos","acot","acsc"]},asech:{name:"asech",category:"Trigonometry",syntax:["asech(x)"],description:"Calculate the inverse secant of a value.",examples:["asech(0.5)"],seealso:["acsch","acoth"]},asin:{name:"asin",category:"Trigonometry",syntax:["asin(x)"],description:"Compute the inverse sine of a value in radians.",examples:["asin(0.5)","asin(sin(0.5))"],seealso:["sin","acos","atan"]},asinh:{name:"asinh",category:"Trigonometry",syntax:["asinh(x)"],description:"Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",examples:["asinh(0.5)"],seealso:["acosh","atanh"]},atan:{name:"atan",category:"Trigonometry",syntax:["atan(x)"],description:"Compute the inverse tangent of a value in radians.",examples:["atan(0.5)","atan(tan(0.5))"],seealso:["tan","acos","asin"]},atanh:{name:"atanh",category:"Trigonometry",syntax:["atanh(x)"],description:"Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",examples:["atanh(0.5)"],seealso:["acosh","asinh"]},atan2:{name:"atan2",category:"Trigonometry",syntax:["atan2(y, x)"],description:"Computes the principal value of the arc tangent of y/x in radians.",examples:["atan2(2, 2) / pi","angle = 60 deg in rad","x = cos(angle)","y = sin(angle)","atan2(y, x)"],seealso:["sin","cos","tan"]},cos:{name:"cos",category:"Trigonometry",syntax:["cos(x)"],description:"Compute the cosine of x in radians.",examples:["cos(2)","cos(pi / 4) ^ 2","cos(180 deg)","cos(60 deg)","sin(0.2)^2 + cos(0.2)^2"],seealso:["acos","sin","tan"]},cosh:{name:"cosh",category:"Trigonometry",syntax:["cosh(x)"],description:"Compute the hyperbolic cosine of x in radians.",examples:["cosh(0.5)"],seealso:["sinh","tanh","coth"]},cot:{name:"cot",category:"Trigonometry",syntax:["cot(x)"],description:"Compute the cotangent of x in radians. Defined as 1/tan(x)",examples:["cot(2)","1 / tan(2)"],seealso:["sec","csc","tan"]},coth:{name:"coth",category:"Trigonometry",syntax:["coth(x)"],description:"Compute the hyperbolic cotangent of x in radians.",examples:["coth(2)","1 / tanh(2)"],seealso:["sech","csch","tanh"]},csc:{name:"csc",category:"Trigonometry",syntax:["csc(x)"],description:"Compute the cosecant of x in radians. Defined as 1/sin(x)",examples:["csc(2)","1 / sin(2)"],seealso:["sec","cot","sin"]},csch:{name:"csch",category:"Trigonometry",syntax:["csch(x)"],description:"Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",examples:["csch(2)","1 / sinh(2)"],seealso:["sech","coth","sinh"]},sec:{name:"sec",category:"Trigonometry",syntax:["sec(x)"],description:"Compute the secant of x in radians. Defined as 1/cos(x)",examples:["sec(2)","1 / cos(2)"],seealso:["cot","csc","cos"]},sech:{name:"sech",category:"Trigonometry",syntax:["sech(x)"],description:"Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",examples:["sech(2)","1 / cosh(2)"],seealso:["coth","csch","cosh"]},sin:{name:"sin",category:"Trigonometry",syntax:["sin(x)"],description:"Compute the sine of x in radians.",examples:["sin(2)","sin(pi / 4) ^ 2","sin(90 deg)","sin(30 deg)","sin(0.2)^2 + cos(0.2)^2"],seealso:["asin","cos","tan"]},sinh:{name:"sinh",category:"Trigonometry",syntax:["sinh(x)"],description:"Compute the hyperbolic sine of x in radians.",examples:["sinh(0.5)"],seealso:["cosh","tanh"]},tan:{name:"tan",category:"Trigonometry",syntax:["tan(x)"],description:"Compute the tangent of x in radians.",examples:["tan(0.5)","sin(0.5) / cos(0.5)","tan(pi / 4)","tan(45 deg)"],seealso:["atan","sin","cos"]},tanh:{name:"tanh",category:"Trigonometry",syntax:["tanh(x)"],description:"Compute the hyperbolic tangent of x in radians.",examples:["tanh(0.5)","sinh(0.5) / cosh(0.5)"],seealso:["sinh","cosh"]},to:{name:"to",category:"Units",syntax:["x to unit","to(x, unit)"],description:"Change the unit of a value.",examples:["5 inch to cm","3.2kg to g","16 bytes in bits"],seealso:[]},clone:{name:"clone",category:"Utils",syntax:["clone(x)"],description:"Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",examples:["clone(3.5)","clone(2 - 4i)","clone(45 deg)","clone([1, 2; 3, 4])",'clone("hello world")'],seealso:[]},format:{name:"format",category:"Utils",syntax:["format(value)","format(value, precision)"],description:"Format a value of any type as string.",examples:["format(2.3)","format(3 - 4i)","format([])","format(pi, 3)"],seealso:["print"]},isNaN:{name:"isNaN",category:"Utils",syntax:["isNaN(x)"],description:"Test whether a value is NaN (not a number)",examples:["isNaN(2)","isNaN(0 / 0)","isNaN(NaN)","isNaN(Infinity)"],seealso:["isNegative","isNumeric","isPositive","isZero"]},isInteger:{name:"isInteger",category:"Utils",syntax:["isInteger(x)"],description:"Test whether a value is an integer number.",examples:["isInteger(2)","isInteger(3.5)","isInteger([3, 0.5, -2])"],seealso:["isNegative","isNumeric","isPositive","isZero"]},isNegative:{name:"isNegative",category:"Utils",syntax:["isNegative(x)"],description:"Test whether a value is negative: smaller than zero.",examples:["isNegative(2)","isNegative(0)","isNegative(-4)","isNegative([3, 0.5, -2])"],seealso:["isInteger","isNumeric","isPositive","isZero"]},isNumeric:{name:"isNumeric",category:"Utils",syntax:["isNumeric(x)"],description:"Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",examples:["isNumeric(2)",'isNumeric("2")','hasNumericValue("2")',"isNumeric(0)","isNumeric(bignumber(500))","isNumeric(fraction(0.125))","isNumeric(2 + 3i)",'isNumeric([2.3, "foo", false])'],seealso:["isInteger","isZero","isNegative","isPositive","isNaN","hasNumericValue"]},hasNumericValue:{name:"hasNumericValue",category:"Utils",syntax:["hasNumericValue(x)"],description:"Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",examples:["hasNumericValue(2)",'hasNumericValue("2")','isNumeric("2")',"hasNumericValue(0)","hasNumericValue(bignumber(500))","hasNumericValue(fraction(0.125))","hasNumericValue(2 + 3i)",'hasNumericValue([2.3, "foo", false])'],seealso:["isInteger","isZero","isNegative","isPositive","isNaN","isNumeric"]},isPositive:{name:"isPositive",category:"Utils",syntax:["isPositive(x)"],description:"Test whether a value is positive: larger than zero.",examples:["isPositive(2)","isPositive(0)","isPositive(-4)","isPositive([3, 0.5, -2])"],seealso:["isInteger","isNumeric","isNegative","isZero"]},isPrime:{name:"isPrime",category:"Utils",syntax:["isPrime(x)"],description:"Test whether a value is prime: has no divisors other than itself and one.",examples:["isPrime(3)","isPrime(-2)","isPrime([2, 17, 100])"],seealso:["isInteger","isNumeric","isNegative","isZero"]},isZero:{name:"isZero",category:"Utils",syntax:["isZero(x)"],description:"Test whether a value is zero.",examples:["isZero(2)","isZero(0)","isZero(-4)","isZero([3, 0, -2, 0])"],seealso:["isInteger","isNumeric","isNegative","isPositive"]},typeOf:{name:"typeOf",category:"Utils",syntax:["typeOf(x)"],description:"Get the type of a variable.",examples:["typeOf(3.5)","typeOf(2 - 4i)","typeOf(45 deg)",'typeOf("hello world")'],seealso:["getMatrixDataType"]},numeric:{name:"numeric",category:"Utils",syntax:["numeric(x)"],description:"Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.",examples:['numeric("4")','numeric("4", "number")','numeric("4", "BigNumber")','numeric("4", "Fraction)','numeric(4, "Fraction")','numeric(fraction(2, 5), "number)'],seealso:["number","fraction","bignumber","string","format"]}},jl=["typed","mathWithTransform","Help"],El=Object(s.a)("help",jl,function(e){var t=e.typed,a=e.mathWithTransform,o=e.Help;return t("help",{any:function(e){var t,r=e;if("string"!=typeof e)for(t in a)if(Object(ae.f)(a,t)&&e===a[t]){r=t;break}var n=zi(Ml,r);if(n)return new o(n);var i="function"==typeof r?r.name:r;throw new Error('No documentation found on "'+i+'"')}})}),Sl=["typed","Chain"],Al=Object(s.a)("chain",Sl,function(e){var t=e.typed,r=e.Chain;return t("chain",{"":function(){return new r},any:function(e){return new r(e)}})}),Cl=["typed","matrix","subtract","multiply","unaryMinus","lup"],Tl=Object(s.a)("det",Cl,function(e){var t=e.typed,n=e.matrix,f=e.subtract,l=e.multiply,p=e.unaryMinus,m=e.lup;return t("det",{any:function(e){return Object(ae.a)(e)},"Array | Matrix":function(e){var t=Object(ie.v)(e)?e.size():Array.isArray(e)?(e=n(e)).size():[];switch(t.length){case 0:return Object(ae.a)(e);case 1:if(1===t[0])return Object(ae.a)(e.valueOf()[0]);throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")");case 2:var r=t[0];if(r===t[1])return function(e,t){{if(1===t)return Object(ae.a)(e[0][0]);if(2===t)return f(l(e[0][0],e[1][1]),l(e[1][0],e[0][1]));for(var r=m(e),n=r.U[0][0],i=1;i<t;i++)n=l(n,r.U[i][i]);for(var a=0,o=0,s=[];;){for(;s[o];)o++;if(t<=o)break;for(var u=o,c=0;!s[r.p[u]];)s[r.p[u]]=!0,u=r.p[u],c++;c%2==0&&a++}return a%2==0?n:p(n)}}(e.clone().valueOf(),r);throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")");default:throw new RangeError("Matrix must be two dimensional (size: "+Object(V.d)(t)+")")}}})}),_l=["typed","matrix","divideScalar","addScalar","multiply","unaryMinus","det","identity","abs"],ql=Object(s.a)("inv",_l,function(e){var t=e.typed,i=e.matrix,v=e.divideScalar,b=e.addScalar,x=e.multiply,w=e.unaryMinus,N=e.det,O=e.identity,M=e.abs;return t("inv",{"Array | Matrix":function(e){var t=Object(ie.v)(e)?e.size():Object(q.a)(e);switch(t.length){case 1:if(1===t[0])return Object(ie.v)(e)?i([v(1,e.valueOf()[0])]):[v(1,e[0])];throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")");case 2:var r=t[0],n=t[1];if(r===n)return Object(ie.v)(e)?i(a(e.valueOf(),r,n),e.storage()):a(e,r,n);throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")");default:throw new RangeError("Matrix must be two dimensional (size: "+Object(V.d)(t)+")")}},any:function(e){return v(1,e)}});function a(e,t,r){var n,i,a,o;if(1===t){if(0===(a=e[0][0]))throw Error("Cannot calculate inverse, determinant is zero");return[[v(1,a)]]}if(2===t){var s=N(e);if(0===s)throw Error("Cannot calculate inverse, determinant is zero");return[[v(e[1][1],s),v(w(e[0][1]),s)],[v(w(e[1][0]),s),v(e[0][0],s)]]}var u=e.concat();for(m=0;m<t;m++)u[m]=u[m].concat();for(var c=O(t).valueOf(),f=0;f<r;f++){for(var l=M(u[f][f]),p=f,m=f+1;m<t;)M(u[m][f])>l&&(l=M(u[m][f]),p=m),m++;if(0===l)throw Error("Cannot calculate inverse, determinant is zero");(m=p)!==f&&(o=u[f],u[f]=u[m],u[m]=o,o=c[f],c[f]=c[m],c[m]=o);var h=u[f],d=c[f];for(m=0;m<t;m++){var y=u[m],g=c[m];if(m!==f){if(0!==y[f]){for(i=v(w(y[f]),h[f]),n=f;n<r;n++)y[n]=b(y[n],x(i,h[n]));for(n=0;n<r;n++)g[n]=b(g[n],x(i,d[n]))}}else{for(i=h[f],n=f;n<r;n++)y[n]=v(y[n],i);for(n=0;n<r;n++)g[n]=v(g[n],i)}}}return c}}),Il=["config","typed","matrix","addScalar","equal","subtract","abs","atan","cos","sin","multiplyScalar","inv","bignumber","multiply","add"],kl=Object(s.a)("eigs",Il,function(e){var d=e.config,t=e.typed,i=e.matrix,y=e.addScalar,g=e.subtract,o=e.equal,l=e.abs,p=e.atan,v=e.cos,b=e.sin,x=e.multiplyScalar,m=e.inv,w=e.bignumber,N=e.multiply,O=e.add;return t("eigs",{Array:function(e){var t=i(e),r=t.size();if(2!==r.length||r[0]!==r[1])throw new RangeError("Matrix must be square (size: "+Object(V.d)(r)+")");var n=a(t,r[0]);return{values:n[0],vectors:n[1]}},Matrix:function(e){var t=e.size();if(2!==t.length||t[0]!==t[1])throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")");var r=a(e,t[0]);return{values:i(r[0]),vectors:i(r[1])}}});function a(e,t){var r=e.datatype();if(void 0===r&&(r=e.getDataType()),"number"!==r&&"BigNumber"!==r&&"Fraction"!==r)throw"mixed"===r?new TypeError("Mixed matrix element type is not supported"):new TypeError("Matrix element type not supported ("+r+")");if(!function(e,t){for(var r=0;r<t;r++)for(var n=r;n<t;n++)if(!o(e[r][n],e[n][r]))throw new TypeError("Input matrix is not symmetric")}(e.toArray(),t),"number"===r)return s(e.toArray());if("Fraction"!==r)return"BigNumber"===r?function(e){for(var t,r=e.length,n=l(d.epsilon/r),i=new Array(r),a=0;a<r;a++)i[a]=E(r,0),i[a][a]=1;var o=h(e);for(;l(o[1])>=l(n);){var s=o[0][0],u=o[0][1];t=function(e,t,r){var n=g(t,e);return l(n)<=d.epsilon?w(-1).acos().div(4):x(.5,p(N(2,r,m(n))))}(e[s][s],e[u][u],e[s][u]),e=function(e,t,r,n){for(var i=e.length,a=w(v(t)),o=w(b(t)),s=x(a,a),u=x(o,o),c=E(i,w(0)),f=E(i,w(0)),l=N(w(2),a,o,e[r][n]),p=y(g(x(s,e[r][r]),l),x(u,e[n][n])),m=O(x(u,e[r][r]),l,x(s,e[n][n])),h=0;h<i;h++)c[h]=g(x(a,e[r][h]),x(o,e[n][h])),f[h]=y(x(o,e[r][h]),x(a,e[n][h]));e[r][r]=p,e[n][n]=m,e[r][n]=w(0),e[n][r]=w(0);for(var d=0;d<i;d++)d!==r&&d!==n&&(e[r][d]=c[d],e[d][r]=c[d],e[n][d]=f[d],e[d][n]=f[d]);return e}(e,t,s,u),i=function(e,t,r,n){for(var i=e.length,a=v(t),o=b(t),s=E(i,w(0)),u=E(i,w(0)),c=0;c<i;c++)s[c]=g(x(a,e[c][r]),x(o,e[c][n])),u[c]=y(x(o,e[c][r]),x(a,e[c][n]));for(var f=0;f<i;f++)e[f][r]=s[f],e[f][n]=u[f];return e}(i,t,s,u),o=h(e)}for(var c=E(r,0),f=0;f<r;f++)c[f]=e[f][f];return j(Object(ae.a)(c),Object(ae.a)(i))}(e.toArray()):void 0;for(var n=e.toArray(),i=0;i<t;i++)for(var a=i;a<t;a++)n[i][a]=n[i][a].valueOf(),n[a][i]=n[i][a];return s(e.toArray())}function s(e){for(var t,r=e.length,n=Math.abs(d.epsilon/r),i=new Array(r),a=0;a<r;a++)i[a]=E(r,0),i[a][a]=1;for(var o,s,u,c,f=M(e);Math.abs(f[1])>=Math.abs(n);){var l=f[0][0],p=f[0][1];o=e[l][l],s=e[p][p],u=e[l][p],c=void 0,c=s-o,e=function(e,t,r,n){for(var i=e.length,a=Math.cos(t),o=Math.sin(t),s=a*a,u=o*o,c=E(i,0),f=E(i,0),l=s*e[r][r]-2*a*o*e[r][n]+u*e[n][n],p=u*e[r][r]+2*a*o*e[r][n]+s*e[n][n],m=0;m<i;m++)c[m]=a*e[r][m]-o*e[n][m],f[m]=o*e[r][m]+a*e[n][m];e[r][r]=l,e[n][n]=p,e[r][n]=0;for(var h=e[n][r]=0;h<i;h++)h!==r&&h!==n&&(e[r][h]=c[h],e[h][r]=c[h],e[n][h]=f[h],e[h][n]=f[h]);return e}(e,t=Math.abs(c)<=d.epsilon?Math.PI/4:.5*Math.atan(2*u/(s-o)),l,p),i=function(e,t,r,n){for(var i=e.length,a=Math.cos(t),o=Math.sin(t),s=E(i,0),u=E(i,0),c=0;c<i;c++)s[c]=a*e[c][r]-o*e[c][n],u[c]=o*e[c][r]+a*e[c][n];for(var f=0;f<i;f++)e[f][r]=s[f],e[f][n]=u[f];return e}(i,t,l,p),f=M(e)}for(var m=E(r,0),h=0;h<r;h++)m[h]=e[h][h];return j(Object(ae.a)(m),Object(ae.a)(i))}function M(e){for(var t=e.length,r=0,n=[0,1],i=0;i<t;i++)for(var a=i+1;a<t;a++)Math.abs(r)<Math.abs(e[i][a])&&(r=Math.abs(e[i][a]),n=[i,a]);return[n,r]}function h(e){for(var t=e.length,r=0,n=[0,1],i=0;i<t;i++)for(var a=i+1;a<t;a++)l(r)<l(e[i][a])&&(r=l(e[i][a]),n=[i,a]);return[n,r]}function j(e,t){for(var r=e.length,n=Array(r),i=Array(r),a=0;a<r;a++)i[a]=Array(r);for(var o=0;o<r;o++){for(var s=0,u=e[0],c=0;c<e.length;c++)e[c]<u&&(u=e[s=c]);n[o]=e.splice(s,1)[0];for(var f=0;f<r;f++)i[f][o]=t[f][s],t[f].splice(s,1)}return[Object(ae.a)(n),Object(ae.a)(i)]}function E(e,t){for(var r=new Array(e),n=0;n<e;n++)r[n]=t;return r}}),Bl=["typed","abs","add","identity","inv","multiply"],zl=Object(s.a)("expm",Bl,function(e){var t=e.typed,d=e.abs,y=e.add,g=e.identity,v=e.inv,b=e.multiply;return t("expm",{Matrix:function(e){var t=e.size();if(2!==t.length||t[0]!==t[1])throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")");for(var r=t[0],n=function(e,t){for(var r=0;r<30;r++)for(var n=0;n<=r;n++){var i=r-n;if(function(e,t,r){for(var n=1,i=2;i<=t;i++)n*=i;for(var a=n,o=t+1;o<=2*t;o++)a*=o;var s=a*(2*t+1);return 8*Math.pow(e/Math.pow(2,r),2*t)*n*n/(a*s)}(e,n,i)<t)return{q:n,j:i}}throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)")}(function(e){for(var t=e.size()[0],r=0,n=0;n<t;n++){for(var i=0,a=0;a<t;a++)i+=d(e.get([n,a]));r=Math.max(i,r)}return r}(e),1e-15),i=n.q,a=n.j,o=b(e,Math.pow(2,-a)),s=g(r),u=g(r),c=1,f=o,l=-1,p=1;p<=i;p++)1<p&&(f=b(f,o),l=-l),s=y(s,b(c=c*(i-p+1)/((2*i-p+1)*p),f)),u=y(u,b(c*l,f));for(var m=b(v(u),s),h=0;h<a;h++)m=b(m,m);return Object(ie.H)(e)?e.createSparseMatrix(m):m}})}),Dl=["typed","abs","add","multiply","sqrt","subtract","inv","size","max","identity"],Rl=Object(s.a)("sqrtm",Dl,function(e){var t=e.typed,o=e.abs,s=e.add,u=e.multiply,r=e.sqrt,c=e.subtract,f=e.inv,l=e.size,p=e.max,m=e.identity;return t("sqrtm",{"Array | Matrix":function(e){var t=Object(ie.v)(e)?e.size():Object(q.a)(e);switch(t.length){case 1:if(1===t[0])return r(e);throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")");case 2:if(t[0]===t[1])return function(e){var t=0,r=e,n=m(l(e));do{var i,a=r,r=u(.5,s(a,f(n))),n=u(.5,s(n,f(a)));if(1e-6<(i=p(o(c(r,a))))&&1e3<++t)throw new Error("computing square root of matrix: iterative method could not converge")}while(1e-6<i);return r}(e);throw new RangeError("Matrix must be square (size: "+Object(V.d)(t)+")")}}})}),Pl=["typed","matrix","multiply","equalScalar","divideScalar","inv"],Ul=Object(s.a)("divide",Pl,function(e){var t=e.typed,r=e.matrix,n=e.multiply,i=e.equalScalar,a=e.divideScalar,o=e.inv,s=ar({typed:t,equalScalar:i}),u=Xt({typed:t});return t("divide",Object(ae.e)({"Array | Matrix, Array | Matrix":function(e,t){return n(e,o(t))},"DenseMatrix, any":function(e,t){return u(e,t,a,!1)},"SparseMatrix, any":function(e,t){return s(e,t,a,!1)},"Array, any":function(e,t){return u(r(e),t,a,!1).valueOf()},"any, Array | Matrix":function(e,t){return n(e,o(t))}},a.signatures))}),Fl="distance",Ll=["typed","addScalar","subtract","divideScalar","multiplyScalar","unaryMinus","sqrt","abs"],Hl=Object(s.a)(Fl,Ll,function(e){var t=e.typed,l=e.addScalar,p=e.subtract,m=e.multiplyScalar,h=e.divideScalar,s=e.unaryMinus,d=e.sqrt,u=e.abs;return t(Fl,{"Array, Array, Array":function(e,t,r){if(2!==e.length||2!==t.length||2!==r.length)throw new TypeError("Invalid Arguments: Try again");if(!c(e))throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");if(!c(t))throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");if(!c(r))throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");var n=h(p(r[1],r[0]),p(t[1],t[0])),i=m(m(n,n),t[0]),a=s(m(n,t[0])),o=e[1];return f(e[0],e[1],i,a,o)},"Object, Object, Object":function(e,t,r){if(2!==Object.keys(e).length||2!==Object.keys(t).length||2!==Object.keys(r).length)throw new TypeError("Invalid Arguments: Try again");if(!c(e))throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");if(!c(t))throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");if(!c(r))throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");if("pointX"in e&&"pointY"in e&&"lineOnePtX"in t&&"lineOnePtY"in t&&"lineTwoPtX"in r&&"lineTwoPtY"in r){var n=h(p(r.lineTwoPtY,r.lineTwoPtX),p(t.lineOnePtY,t.lineOnePtX)),i=m(m(n,n),t.lineOnePtX),a=s(m(n,t.lineOnePtX)),o=e.pointX;return f(e.pointX,e.pointY,i,a,o)}throw new TypeError("Key names do not match")},"Array, Array":function(e,t){if(2===e.length&&3===t.length){if(!c(e))throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");if(!n(t))throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");return f(e[0],e[1],t[0],t[1],t[2])}if(3===e.length&&6===t.length){if(!n(e))throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");if(!a(t))throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");return y(e[0],e[1],e[2],t[0],t[1],t[2],t[3],t[4],t[5])}if(e.length===t.length&&0<e.length){if(!i(e))throw new TypeError("All values of an array should be numbers or BigNumbers");if(!i(t))throw new TypeError("All values of an array should be numbers or BigNumbers");return g(e,t)}throw new TypeError("Invalid Arguments: Try again")},"Object, Object":function(e,t){if(2===Object.keys(e).length&&3===Object.keys(t).length){if(!c(e))throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");if(!n(t))throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");if("pointX"in e&&"pointY"in e&&"xCoeffLine"in t&&"yCoeffLine"in t&&"constant"in t)return f(e.pointX,e.pointY,t.xCoeffLine,t.yCoeffLine,t.constant);throw new TypeError("Key names do not match")}if(3===Object.keys(e).length&&6===Object.keys(t).length){if(!n(e))throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");if(!a(t))throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");if("pointX"in e&&"pointY"in e&&"x0"in t&&"y0"in t&&"z0"in t&&"a"in t&&"b"in t&&"c"in t)return y(e.pointX,e.pointY,e.pointZ,t.x0,t.y0,t.z0,t.a,t.b,t.c);throw new TypeError("Key names do not match")}if(2===Object.keys(e).length&&2===Object.keys(t).length){if(!c(e))throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");if(!c(t))throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");if("pointOneX"in e&&"pointOneY"in e&&"pointTwoX"in t&&"pointTwoY"in t)return g([e.pointOneX,e.pointOneY],[t.pointTwoX,t.pointTwoY]);throw new TypeError("Key names do not match")}if(3!==Object.keys(e).length||3!==Object.keys(t).length)throw new TypeError("Invalid Arguments: Try again");if(!n(e))throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");if(!n(t))throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");if("pointOneX"in e&&"pointOneY"in e&&"pointOneZ"in e&&"pointTwoX"in t&&"pointTwoY"in t&&"pointTwoZ"in t)return g([e.pointOneX,e.pointOneY,e.pointOneZ],[t.pointTwoX,t.pointTwoY,t.pointTwoZ]);throw new TypeError("Key names do not match")},Array:function(e){if(!function(e){if(2===e[0].length&&r(e[0][0])&&r(e[0][1])){if(e.some(function(e){return 2!==e.length||!r(e[0])||!r(e[1])}))return!1}else{if(!(3===e[0].length&&r(e[0][0])&&r(e[0][1])&&r(e[0][2])))return!1;if(e.some(function(e){return 3!==e.length||!r(e[0])||!r(e[1])||!r(e[2])}))return!1}return!0}(e))throw new TypeError("Incorrect array format entered for pairwise distance calculation");return function(e){for(var t=[],r=[],n=[],i=0;i<e.length-1;i++)for(var a=i+1;a<e.length;a++)2===e[0].length?(r=[e[i][0],e[i][1]],n=[e[a][0],e[a][1]]):3===e[0].length&&(r=[e[i][0],e[i][1],e[i][2]],n=[e[a][0],e[a][1],e[a][2]]),t.push(g(r,n));return t}(e)}});function r(e){return"number"==typeof e||Object(ie.e)(e)}function c(e){return e.constructor!==Array&&(e=o(e)),r(e[0])&&r(e[1])}function n(e){return e.constructor!==Array&&(e=o(e)),r(e[0])&&r(e[1])&&r(e[2])}function i(e){return Array.isArray(e)||(e=o(e)),e.every(r)}function a(e){return e.constructor!==Array&&(e=o(e)),r(e[0])&&r(e[1])&&r(e[2])&&r(e[3])&&r(e[4])&&r(e[5])}function o(e){for(var t=Object.keys(e),r=[],n=0;n<t.length;n++)r.push(e[t[n]]);return r}function f(e,t,r,n,i){var a=u(l(l(m(r,e),m(n,t)),i)),o=d(l(m(r,r),m(n,n)));return h(a,o)}function y(e,t,r,n,i,a,o,s,u){var c=[p(m(p(i,t),u),m(p(a,r),s)),p(m(p(a,r),o),m(p(n,e),u)),p(m(p(n,e),s),m(p(i,t),o))],c=d(l(l(m(c[0],c[0]),m(c[1],c[1])),m(c[2],c[2]))),f=d(l(l(m(o,o),m(s,s)),m(u,u)));return h(c,f)}function g(e,t){for(var r,n=e.length,i=0,a=0;a<n;a++)r=p(e[a],t[a]),i=l(m(r,r),i);return d(i)}}),$l=["typed","config","abs","add","addScalar","matrix","multiply","multiplyScalar","divideScalar","subtract","smaller","equalScalar"],Gl=Object(s.a)("intersect",$l,function(e){var t=e.typed,C=e.config,T=e.abs,_=e.add,q=e.addScalar,i=e.matrix,I=e.multiply,k=e.multiplyScalar,B=e.divideScalar,z=e.subtract,D=e.smaller,R=e.equalScalar;return t("intersect",{"Array, Array, Array":function(e,t,r){if(!U(e))throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");if(!U(t))throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");if(!(4===(n=r).length&&M(n[0])&&M(n[1])&&M(n[2])&&M(n[3])))throw new TypeError("Array with 4 numbers expected as third argument");var n,i,a,o,s,u,c,f,l,p,m,h,d,y,g,v,b,x,w,N,O;return i=e[0],a=e[1],o=e[2],s=t[0],u=t[1],c=t[2],f=r[0],l=r[1],p=r[2],m=r[3],h=k(i,f),d=k(s,f),y=k(a,l),g=k(u,l),v=k(o,p),b=k(c,p),x=B(z(z(z(m,h),y),v),z(z(z(q(q(d,g),b),h),y),v)),w=q(i,k(x,z(s,i))),N=q(a,k(x,z(u,a))),O=q(o,k(x,z(c,o))),[w,N,O]},"Array, Array, Array, Array":function(e,t,r,n){if(2===e.length){if(!P(e))throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");if(!P(t))throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");if(!P(r))throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");if(!P(n))throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");return function(e,t,r,n){var i=e,a=r,o=z(i,t),s=z(a,n),u=z(k(o[0],s[1]),k(s[0],o[1]));if(D(T(u),C.epsilon))return null;var c=k(s[0],i[1]),f=k(s[1],i[0]),l=k(s[0],a[1]),p=k(s[1],a[0]),m=B(q(z(z(c,f),l),p),u);return _(I(o,m),i)}(e,t,r,n)}if(3!==e.length)throw new TypeError("Arrays with two or thee dimensional points expected");if(!U(e))throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");if(!U(t))throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");if(!U(r))throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");if(!U(n))throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");return i=e[0],a=e[1],o=e[2],s=t[0],u=t[1],c=t[2],f=r[0],l=r[1],p=r[2],m=n[0],h=n[1],d=n[2],y=F(i,f,m,f,a,l,h,l,o,p,d,p),g=F(m,f,s,i,h,l,u,a,d,p,c,o),v=F(i,f,s,i,a,l,u,a,o,p,c,o),b=F(m,f,m,f,h,l,h,l,d,p,d,p),x=F(s,i,s,i,u,a,u,a,c,o,c,o),w=B(z(k(y,g),k(v,b)),z(k(x,b),k(g,g))),N=B(q(y,k(w,g)),b),O=q(i,k(w,z(s,i))),M=q(a,k(w,z(u,a))),j=q(o,k(w,z(c,o))),E=q(f,k(N,z(m,f))),S=q(l,k(N,z(h,l))),A=q(p,k(N,z(d,p))),R(O,E)&&R(M,S)&&R(j,A)?[O,M,j]:null;var i,a,o,s,u,c,f,l,p,m,h,d,y,g,v,b,x,w,N,O,M,j,E,S,A},"Matrix, Matrix, Matrix":function(e,t,r){return i(this(e.valueOf(),t.valueOf(),r.valueOf()))},"Matrix, Matrix, Matrix, Matrix":function(e,t,r,n){return i(this(e.valueOf(),t.valueOf(),r.valueOf(),n.valueOf()))}});function M(e){return"number"==typeof e||Object(ie.e)(e)}function P(e){return 2===e.length&&M(e[0])&&M(e[1])}function U(e){return 3===e.length&&M(e[0])&&M(e[1])&&M(e[2])}function F(e,t,r,n,i,a,o,s,u,c,f,l){var p=k(z(e,t),z(r,n)),m=k(z(i,a),z(o,s)),h=k(z(u,c),z(f,l));return q(q(p,m),h)}}),Zl=["typed","config","add","numeric"],Vl=Object(s.a)("sum",Zl,function(e){var t=e.typed,n=e.config,i=e.add,a=e.numeric;return t("sum",{"Array | Matrix":r,"Array | Matrix, number | BigNumber":function(e,t){try{return F(e,t,i)}catch(e){throw la(e,"sum")}},"...":function(e){if(P(e))throw new TypeError("Scalar values expected in function sum");return r(e)}});function r(e){var r;return U(e,function(t){try{r=void 0===r?t:i(r,t)}catch(e){throw la(e,"sum",t)}}),void 0===r&&(r=a(0,n.number)),"string"==typeof r&&(r=a(r,n.number)),r}}),Jl=["typed","add","divide"],Wl=Object(s.a)("mean",Jl,function(e){var t=e.typed,i=e.add,a=e.divide;return t("mean",{"Array | Matrix":r,"Array | Matrix, number | BigNumber":function(e,t){try{var r=F(e,t,i),n=Array.isArray(e)?Object(q.a)(e):e.size();return a(r,n[t])}catch(e){throw la(e,"mean")}},"...":function(e){if(P(e))throw new TypeError("Scalar values expected in function mean");return r(e)}});function r(e){var r,n=0;if(U(e,function(t){try{r=void 0===r?t:i(r,t),n++}catch(e){throw la(e,"mean",t)}}),0===n)throw new Error("Cannot calculate the mean of an empty array");return a(r,n)}}),Yl=["typed","add","divide","compare","partitionSelect"],Xl=Object(s.a)("median",Yl,function(e){var t=e.typed,r=e.add,n=e.divide,s=e.compare,u=e.partitionSelect;function i(e){try{var t=(e=Object(q.e)(e.valueOf())).length;if(0===t)throw new Error("Cannot calculate median of an empty array");if(t%2==0){for(var r=t/2-1,n=u(e,1+r),i=e[r],a=0;a<r;++a)0<s(e[a],i)&&(i=e[a]);return f(i,n)}var o=u(e,(t-1)/2);return c(o)}catch(e){throw la(e,"median")}}var c=t({"number | BigNumber | Complex | Unit":function(e){return e}}),f=t({"number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit":function(e,t){return n(r(e,t),2)}});return t("median",{"Array | Matrix":i,"Array | Matrix, number | BigNumber":function(){throw new Error("median(A, dim) is not yet supported")},"...":function(e){if(P(e))throw new TypeError("Scalar values expected in function median");return i(e)}})}),Ql=["typed","abs","map","median","subtract"],Kl=Object(s.a)("mad",Ql,function(e){var t=e.typed,r=e.abs,n=e.map,i=e.median,a=e.subtract;return t("mad",{"Array | Matrix":o,"...":o});function o(e){if(0===(e=Object(q.e)(e.valueOf())).length)throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");try{var t=i(e);return i(n(e,function(e){return r(a(e,t))}))}catch(e){throw e instanceof TypeError&&-1!==e.message.indexOf("median")?new TypeError(e.message.replace("median","mad")):la(e,"mad")}}}),ep="unbiased",tp="variance",rp=["typed","add","subtract","multiply","divide","apply","isNaN"],np=Object(s.a)(tp,rp,function(e){var t=e.typed,o=e.add,s=e.subtract,u=e.multiply,c=e.divide,n=e.apply,f=e.isNaN;return t(tp,{"Array | Matrix":function(e){return i(e,ep)},"Array | Matrix, string":i,"Array | Matrix, number | BigNumber":function(e,t){return r(e,t,ep)},"Array | Matrix, number | BigNumber, string":r,"...":function(e){return i(e,ep)}});function i(e,t){var r=0,n=0;if(0===e.length)throw new SyntaxError("Function variance requires one or more parameters (0 provided)");if(U(e,function(t){try{r=o(r,t),n++}catch(e){throw la(e,"variance",t)}}),0===n)throw new Error("Cannot calculate variance of an empty array");var i=c(r,n),r=0;if(U(e,function(e){var t=s(e,i);r=o(r,u(t,t))}),f(r))return r;switch(t){case"uncorrected":return c(r,n);case"biased":return c(r,n+1);case"unbiased":var a=Object(ie.e)(r)?r.mul(0):0;return 1===n?a:c(r,n-1);default:throw new Error('Unknown normalization "'+t+'". Choose "unbiased" (default), "uncorrected", or "biased".')}}function r(e,t,r){try{if(0===e.length)throw new SyntaxError("Function variance requires one or more parameters (0 provided)");return n(e,t,function(e){return i(e,r)})}catch(e){throw la(e,"variance")}}}),ip=["typed","add","multiply","partitionSelect","compare"],ap=Object(s.a)("quantileSeq",ip,function(e){var t=e.typed,w=e.add,N=e.multiply,O=e.partitionSelect,M=e.compare;function h(e,t,r){var n=Object(q.e)(e),i=n.length;if(0===i)throw new Error("Cannot calculate quantile of an empty sequence");if(Object(ie.y)(t)){var a=t*(i-1),o=a%1;if(0==o){var s=r?n[a]:O(n,a);return j(s),s}var u,c,f=Math.floor(a);if(r)u=n[f],c=n[f+1];else{c=O(n,f+1),u=n[f];for(var l=0;l<f;++l)0<M(n[l],u)&&(u=n[l])}return j(u),j(c),w(N(u,1-o),N(c,o))}var p=t.times(i-1);if(p.isInteger()){p=p.toNumber();var m=r?n[p]:O(n,p);return j(m),m}var h,d,y=p.floor(),g=p.minus(y),v=y.toNumber();if(r)h=n[v],d=n[v+1];else{d=O(n,v+1),h=n[v];for(var b=0;b<v;++b)0<M(n[b],h)&&(h=n[b])}j(h),j(d);var x=new g.constructor(1);return w(N(h,x.minus(g)),N(d,g))}var j=t({"number | BigNumber | Unit":function(e){return e}});return function(e,t,r){var n,i;if(arguments.length<2||3<arguments.length)throw new SyntaxError("Function quantileSeq requires two or three parameters");if(Object(ie.i)(e)){if("boolean"!=typeof(r=r||!1))throw new TypeError("Unexpected type of argument in function quantileSeq");if(n=e.valueOf(),Object(ie.y)(t)){if(t<0)throw new Error("N/prob must be non-negative");if(t<=1)return h(n,t,r);if(1<t){if(!Object(E.i)(t))throw new Error("N must be a positive integer");for(var a=t+1,o=new Array(t),s=0;s<t;)o[s]=h(n,++s/a,r);return o}}if(Object(ie.e)(t)){var u=t.constructor;if(t.isNegative())throw new Error("N/prob must be non-negative");if(i=new u(1),t.lte(i))return new u(h(n,t,r));if(t.gt(i)){if(!t.isInteger())throw new Error("N must be a positive integer");var c=t.toNumber();if(4294967295<c)throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");var f=new u(c+1);o=new Array(c);for(var l=0;l<c;)o[l]=new u(h(n,new u(++l).div(f),r));return o}}if(Array.isArray(t)){o=new Array(t.length);for(var p=0;p<o.length;++p){var m=t[p];if(Object(ie.y)(m)){if(m<0||1<m)throw new Error("Probability must be between 0 and 1, inclusive")}else{if(!Object(ie.e)(m))throw new TypeError("Unexpected type of argument in function quantileSeq");if(i=new m.constructor(1),m.isNegative()||m.gt(i))throw new Error("Probability must be between 0 and 1, inclusive")}o[p]=h(n,m,r)}return o}throw new TypeError("Unexpected type of argument in function quantileSeq")}throw new TypeError("Unexpected type of argument in function quantileSeq")}}),op=["typed","sqrt","variance"],sp=Object(s.a)("std",op,function(e){var t=e.typed,r=e.sqrt,n=e.variance;return t("std",{"Array | Matrix":i,"Array | Matrix, string":i,"Array | Matrix, number | BigNumber":i,"Array | Matrix, number | BigNumber, string":i,"...":function(e){return i(e)}});function i(e,t){if(0===e.length)throw new SyntaxError("Function std requires one or more parameters (0 provided)");try{return r(n.apply(null,arguments))}catch(e){throw e instanceof TypeError&&-1!==e.message.indexOf(" variance")?new TypeError(e.message.replace(" variance"," std")):e}}});function up(e,t){if(t<e)return 1;if(t===e)return t;var r=t+e>>1;return up(e,r)*up(1+r,t)}function cp(e,t){if(!Object(E.i)(e)||e<0)throw new TypeError("Positive integer value expected in function combinations");if(!Object(E.i)(t)||t<0)throw new TypeError("Positive integer value expected in function combinations");if(e<t)throw new TypeError("k must be less than or equal to n");var r=e-t;return t<r?up(1+r,e)/up(1,t):up(t+1,e)/up(1,r)}cp.signature="number, number";var fp="combinations",lp=["typed"],pp=Object(s.a)(fp,lp,function(e){return(0,e.typed)(fp,{"number, number":cp,"BigNumber, BigNumber":function(e,t){var r,n,i=e.constructor,a=e.minus(t),o=new i(1);if(!mp(e)||!mp(t))throw new TypeError("Positive integer value expected in function combinations");if(t.gt(e))throw new TypeError("k must be less than n in function combinations");if(r=o,t.lt(a))for(n=o;n.lte(a);n=n.plus(o))r=r.times(t.plus(n)).dividedBy(n);else for(n=o;n.lte(t);n=n.plus(o))r=r.times(a.plus(n)).dividedBy(n);return r}})});function mp(e){return e.isInteger()&&e.gte(0)}var hp="combinationsWithRep",dp=["typed"],yp=Object(s.a)(hp,dp,function(e){return(0,e.typed)(hp,{"number, number":function(e,t){if(!Object(E.i)(e)||e<0)throw new TypeError("Positive integer value expected in function combinationsWithRep");if(!Object(E.i)(t)||t<0)throw new TypeError("Positive integer value expected in function combinationsWithRep");if(e<1)throw new TypeError("k must be less than or equal to n + k - 1");return t<e-1?up(e,e+t-1)/up(1,t):up(t+1,e+t-1)/up(1,e-1)},"BigNumber, BigNumber":function(e,t){var r,n,i=new e.constructor(1),a=e.minus(i);if(!gp(e)||!gp(t))throw new TypeError("Positive integer value expected in function combinationsWithRep");if(e.lt(i))throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");if(r=i,t.lt(a))for(n=i;n.lte(a);n=n.plus(i))r=r.times(t.plus(n)).dividedBy(n);else for(n=i;n.lte(t);n=n.plus(i))r=r.times(a.plus(n)).dividedBy(n);return r}})});function gp(e){return e.isInteger()&&e.gte(0)}function vp(e){var t;if(Object(E.i)(e))return e<=0?isFinite(e)?1/0:NaN:171<e?1/0:up(1,e-1);if(e<.5)return Math.PI/(Math.sin(Math.PI*e)*vp(1-e));if(171.35<=e)return 1/0;if(85<e){var r=e*e,n=r*e,i=n*e,a=i*e;return Math.sqrt(2*Math.PI/e)*Math.pow(e/Math.E,e)*(1+1/(12*e)+1/(288*r)-139/(51840*n)-571/(2488320*i)+163879/(209018880*a)+5246819/(75246796800*a*e))}--e,t=xp[0];for(var o=1;o<xp.length;++o)t+=xp[o]/(e+o);var s=e+bp+.5;return Math.sqrt(2*Math.PI)*Math.pow(s,e+.5)*Math.exp(-s)*t}vp.signature="number";var bp=4.7421875,xp=[.9999999999999971,57.15623566586292,-59.59796035547549,14.136097974741746,-.4919138160976202,3399464998481189e-20,4652362892704858e-20,-9837447530487956e-20,.0001580887032249125,-.00021026444172410488,.00021743961811521265,-.0001643181065367639,8441822398385275e-20,-26190838401581408e-21,36899182659531625e-22],wp=["typed","config","multiplyScalar","pow","BigNumber","Complex"],Np=Object(s.a)("gamma",wp,function(e){var t=e.typed,s=e.config,c=e.multiplyScalar,f=e.pow,u=e.BigNumber,l=e.Complex;return t("gamma",{number:vp,Complex:function(e){if(0===e.im)return this(e.re);e=new l(e.re-1,e.im);for(var t=new l(xp[0],0),r=1;r<xp.length;++r){var n=e.re+r,i=n*n+e.im*e.im;0!=i?(t.re+=xp[r]*n/i,t.im+=-(xp[r]*e.im)/i):t.re=xp[r]<0?-1/0:1/0}var a=new l(e.re+bp+.5,e.im),o=Math.sqrt(2*Math.PI);e.re+=.5;var s=f(a,e);0===s.im?s.re*=o:(0===s.re||(s.re*=o),s.im*=o);var u=Math.exp(-a.re);return a.re=u*Math.cos(-a.im),a.im=u*Math.sin(-a.im),c(c(s,a),t)},BigNumber:function(e){if(e.isInteger())return e.isNegative()||e.isZero()?new u(1/0):function e(t){if(t<8)return new u([1,1,2,6,24,120,720,5040][t]);var r=s.precision+(0|Math.log(t.toNumber()));var n=u.clone({precision:r});if(t%2==1)return t.times(e(new u(t-1)));var i=t;var a=new n(t);var o=t.toNumber();for(;2<i;)o+=i-=2,a=a.times(o);return new u(a.toPrecision(u.precision))}(e.minus(1));if(!e.isFinite())return new u(e.isNegative()?NaN:1/0);throw new Error("Integer BigNumber expected")},"Array | Matrix":function(e){return oe(e,this)}})}),Op="factorial",Mp=["typed","gamma"],jp=Object(s.a)(Op,Mp,function(e){var t=e.typed,r=e.gamma;return t(Op,{number:function(e){if(e<0)throw new Error("Value must be non-negative");return r(e+1)},BigNumber:function(e){if(e.isNegative())throw new Error("Value must be non-negative");return r(e.plus(1))},"Array | Matrix":function(e){return oe(e,this)}})}),Ep="kldivergence",Sp=["typed","matrix","divide","sum","multiply","dotDivide","log","isNumeric"],Ap=Object(s.a)(Ep,Sp,function(e){var t=e.typed,r=e.matrix,s=e.divide,u=e.sum,c=e.multiply,f=e.dotDivide,l=e.log,p=e.isNumeric;return t(Ep,{"Array, Array":function(e,t){return n(r(e),r(t))},"Matrix, Array":function(e,t){return n(e,r(t))},"Array, Matrix":function(e,t){return n(r(e),t)},"Matrix, Matrix":n});function n(e,t){var r=t.size().length,n=e.size().length;if(1<r)throw new Error("first object must be one dimensional");if(1<n)throw new Error("second object must be one dimensional");if(r!==n)throw new Error("Length of two vectors must be equal");if(0===u(e))throw new Error("Sum of elements in first object must be non zero");if(0===u(t))throw new Error("Sum of elements in second object must be non zero");var i=s(e,u(e)),a=s(t,u(t)),o=u(c(i,l(f(i,a))));return p(o)?o:Number.NaN}}),Cp="multinomial",Tp=["typed","add","divide","multiply","factorial","isInteger","isPositive"],_p=Object(s.a)(Cp,Tp,function(e){var t=e.typed,n=e.add,i=e.divide,a=e.multiply,o=e.factorial,s=e.isInteger,u=e.isPositive;return t(Cp,{"Array | Matrix":function(e){var t=0,r=1;return U(e,function(e){if(!s(e)||!u(e))throw new TypeError("Positive integer value expected in function multinomial");t=n(t,e),r=a(r,o(e))}),i(o(t),r)}})}),qp="permutations",Ip=["typed","factorial"],kp=Object(s.a)(qp,Ip,function(e){var t=e.typed,r=e.factorial;return t(qp,{"number | BigNumber":r,"number, number":function(e,t){if(!Object(E.i)(e)||e<0)throw new TypeError("Positive integer value expected in function permutations");if(!Object(E.i)(t)||t<0)throw new TypeError("Positive integer value expected in function permutations");if(e<t)throw new TypeError("second argument k must be less than or equal to first argument n");return up(e-t+1,e)},"BigNumber, BigNumber":function(e,t){if(!Bp(e)||!Bp(t))throw new TypeError("Positive integer value expected in function permutations");if(t.gt(e))throw new TypeError("second argument k must be less than or equal to first argument n");for(var r=e.mul(0).add(1),n=e.minus(t).plus(1);n.lte(e);n=n.plus(1))r=r.times(n);return r}})});function Bp(e){return e.isInteger()&&e.gte(0)}var zp=r(14),Dp=r.n(zp),Rp=Dp()();function Pp(e){var t,r;return t=null===(r=e)?Rp:Dp()(String(r)),function(){return t()}}var Up=["typed","config","?on"],Fp=Object(s.a)("pickRandom",Up,function(e){var t=e.typed,r=e.config,n=e.on,m=Pp(r.randomSeed);return n&&n("config",function(e,t){e.randomSeed!==t.randomSeed&&(m=Pp(e.randomSeed))}),t({"Array | Matrix":function(e){return i(e)},"Array | Matrix, number":function(e,t){return i(e,t,void 0)},"Array | Matrix, Array":function(e,t){return i(e,void 0,t)},"Array | Matrix, Array | Matrix, number":function(e,t,r){return i(e,r,t)},"Array | Matrix, number, Array | Matrix":i});function i(e,t,r){var n=void 0===t;if(n&&(t=1),e=e.valueOf(),r=r&&r.valueOf(),1<Object(q.a)(e).length)throw new Error("Only one dimensional vectors supported");var i=0;if(void 0!==r){if(r.length!==e.length)throw new Error("Weights must have the same length as possibles");for(var a=0,o=r.length;a<o;a++){if(!Object(ie.y)(r[a])||r[a]<0)throw new Error("Weights must be an array of positive numbers");i+=r[a]}}var s=e.length;if(0===s)return[];if(s<=t)return 1<t?e:e[0];for(var u,c=[];c.length<t;){if(void 0===r)u=e[Math.floor(m()*s)];else for(var f=m()*i,l=0,p=e.length;l<p;l++)if((f-=r[l])<0){u=e[l];break}-1===c.indexOf(u)&&c.push(u)}return n?c[0]:c}});function Lp(e,t){var r=[];if(1<(e=e.slice(0)).length)for(var n=0,i=e.shift();n<i;n++)r.push(Lp(e,t));else for(var a=0,o=e.shift();a<o;a++)r.push(t());return r}var Hp="random",$p=["typed","config","?on"],Gp=Object(s.a)(Hp,$p,function(e){var t=e.typed,r=e.config,n=e.on,i=Pp(r.randomSeed);return n&&n("config",function(e,t){e.randomSeed!==t.randomSeed&&(i=Pp(e.randomSeed))}),t(Hp,{"":function(){return o(0,1)},number:function(e){return o(0,e)},"number, number":o,"Array | Matrix":function(e){return a(e,0,1)},"Array | Matrix, number":function(e,t){return a(e,0,t)},"Array | Matrix, number, number":a});function a(e,t,r){var n=Lp(e.valueOf(),function(){return o(t,r)});return Object(ie.v)(e)?e.create(n):n}function o(e,t){return e+i()*(t-e)}}),Zp="randomInt",Vp=["typed","config","?on"],Jp=Object(s.a)(Zp,Vp,function(e){var t=e.typed,r=e.config,n=e.on,i=Pp(r.randomSeed);return n&&n("config",function(e,t){e.randomSeed!==t.randomSeed&&(i=Pp(e.randomSeed))}),t(Zp,{"":function(){return o(0,1)},number:function(e){return o(0,e)},"number, number":o,"Array | Matrix":function(e){return a(e,0,1)},"Array | Matrix, number":function(e,t){return a(e,0,t)},"Array | Matrix, number, number":a});function a(e,t,r){var n=Lp(e.valueOf(),function(){return o(t,r)});return Object(ie.v)(e)?e.create(n):n}function o(e,t){return Math.floor(e+i()*(t-e))}}),Wp="stirlingS2",Yp=["typed","addScalar","subtract","multiplyScalar","divideScalar","pow","factorial","combinations","isNegative","isInteger","larger"],Xp=Object(s.a)(Wp,Yp,function(e){var t=e.typed,u=e.addScalar,c=e.subtract,f=e.multiplyScalar,l=e.divideScalar,p=e.pow,m=e.factorial,h=e.combinations,d=e.isNegative,y=e.isInteger,g=e.larger;return t(Wp,{"number | BigNumber, number | BigNumber":function(e,t){if(!y(e)||d(e)||!y(t)||d(t))throw new TypeError("Non-negative integer value expected in function stirlingS2");if(g(t,e))throw new TypeError("k must be less than or equal to n in function stirlingS2");for(var r=m(t),n=0,i=0;i<=t;i++)var a=p(-1,c(t,i)),o=h(t,i),s=p(i,e),n=u(n,f(f(o,s),a));return l(n,r)}})}),Qp="bellNumbers",Kp=["typed","addScalar","isNegative","isInteger","stirlingS2"],em=Object(s.a)(Qp,Kp,function(e){var t=e.typed,n=e.addScalar,i=e.isNegative,a=e.isInteger,o=e.stirlingS2;return t(Qp,{"number | BigNumber":function(e){if(!a(e)||i(e))throw new TypeError("Non-negative integer value expected in function bellNumbers");for(var t=0,r=0;r<=e;r++)t=n(t,o(e,r));return t}})}),tm="catalan",rm=["typed","addScalar","divideScalar","multiplyScalar","combinations","isNegative","isInteger"],nm=Object(s.a)(tm,rm,function(e){var t=e.typed,r=e.addScalar,n=e.divideScalar,i=e.multiplyScalar,a=e.combinations,o=e.isNegative,s=e.isInteger;return t(tm,{"number | BigNumber":function(e){if(!s(e)||o(e))throw new TypeError("Non-negative integer value expected in function catalan");return n(a(i(e,2),e),r(e,1))}})}),im="composition",am=["typed","addScalar","combinations","isNegative","isPositive","isInteger","larger"],om=Object(s.a)(im,am,function(e){var t=e.typed,r=e.addScalar,n=e.combinations,i=e.isPositive,a=(e.isNegative,e.isInteger),o=e.larger;return t(im,{"number | BigNumber, number | BigNumber":function(e,t){if(!(a(e)&&i(e)&&a(t)&&i(t)))throw new TypeError("Positive integer value expected in function composition");if(o(t,e))throw new TypeError("k must be less than or equal to n in function composition");return n(r(e,-1),r(t,-1))}})}),sm=["FunctionNode","OperatorNode","SymbolNode"],um=Object(s.a)("simplifyUtil",sm,function(e){var r=e.FunctionNode,n=e.OperatorNode,i=e.SymbolNode,a={add:!0,multiply:!0},o={add:!0,multiply:!0};function s(e,t){if(!Object(ie.B)(e))return!1;var r=e.fn.toString();return t&&Object(ae.f)(t,r)&&Object(ae.f)(t[r],"associative")?t[r].associative:o[r]||!1}function u(e){var i,a=[];return s(e)?(i=e.op,function e(t){for(var r=0;r<t.args.length;r++){var n=t.args[r];Object(ie.B)(n)&&i===n.op?e(n):a.push(n)}}(e),a):e.args}function c(t){return Object(ie.B)(t)?function(e){try{return new n(t.op,t.fn,e,t.implicit)}catch(e){return console.error(e),[]}}:function(e){return new r(new i(t.name),e)}}return{createMakeNodeFunction:c,isCommutative:function(e,t){if(!Object(ie.B)(e))return!0;var r=e.fn.toString();return t&&Object(ae.f)(t,r)&&Object(ae.f)(t[r],"commutative")?t[r].commutative:a[r]||!1},isAssociative:s,flatten:function e(t){if(!t.args||0===t.args.length)return t;t.args=u(t);for(var r=0;r<t.args.length;r++)e(t.args[r])},allChildren:u,unflattenr:function e(t){if(t.args&&0!==t.args.length){for(var r=c(t),n=t.args.length,i=0;i<n;i++)e(t.args[i]);if(2<n&&s(t)){for(var a=t.args.pop();0<t.args.length;)a=r([t.args.pop(),a]);t.args=a.args}}},unflattenl:function e(t){if(t.args&&0!==t.args.length){for(var r=c(t),n=t.args.length,i=0;i<n;i++)e(t.args[i]);if(2<n&&s(t)){for(var a=t.args.shift();0<t.args.length;)a=r([a,t.args.shift()]);t.args=a.args}}}}}),cm=["equal","isZero","add","subtract","multiply","divide","pow","ConstantNode","OperatorNode","FunctionNode","ParenthesisNode"],fm=Object(s.a)("simplifyCore",cm,function(e){var f=e.equal,l=e.isZero,p=e.add,m=e.subtract,h=e.multiply,d=e.divide,y=e.pow,g=e.ConstantNode,v=e.OperatorNode,b=e.FunctionNode,x=e.ParenthesisNode,w=new g(0),N=new g(1);return function e(t){if(Object(ie.B)(t)&&t.isUnary()){var r=e(t.args[0]);if("+"===t.op)return r;if("-"===t.op){if(Object(ie.B)(r)){if(r.isUnary()&&"-"===r.op)return r.args[0];if(r.isBinary()&&"subtract"===r.fn)return new v("-","subtract",[r.args[1],r.args[0]])}return new v(t.op,t.fn,[r])}}else if(Object(ie.B)(t)&&t.isBinary()){var n=e(t.args[0]),i=e(t.args[1]);if("+"===t.op){if(Object(ie.l)(n)){if(l(n.value))return i;if(Object(ie.l)(i))return new g(p(n.value,i.value))}return Object(ie.l)(i)&&l(i.value)?n:Object(ie.B)(i)&&i.isUnary()&&"-"===i.op?new v("-","subtract",[n,i.args[0]]):new v(t.op,t.fn,i?[n,i]:[n])}if("-"===t.op){if(Object(ie.l)(n)&&i){if(Object(ie.l)(i))return new g(m(n.value,i.value));if(l(n.value))return new v("-","unaryMinus",[i])}if("subtract"===t.fn)return Object(ie.l)(i)&&l(i.value)?n:Object(ie.B)(i)&&i.isUnary()&&"-"===i.op?e(new v("+","add",[n,i.args[0]])):new v(t.op,t.fn,[n,i])}else{if("*"===t.op){if(Object(ie.l)(n)){if(l(n.value))return w;if(f(n.value,1))return i;if(Object(ie.l)(i))return new g(h(n.value,i.value))}if(Object(ie.l)(i)){if(l(i.value))return w;if(f(i.value,1))return n;if(Object(ie.B)(n)&&n.isBinary()&&n.op===t.op){var a=n.args[0];if(Object(ie.l)(a)){var o=new g(h(a.value,i.value));return new v(t.op,t.fn,[o,n.args[1]],t.implicit)}}return new v(t.op,t.fn,[i,n],t.implicit)}return new v(t.op,t.fn,[n,i],t.implicit)}if("/"===t.op){if(Object(ie.l)(n)){if(l(n.value))return w;if(Object(ie.l)(i)&&(f(i.value,1)||f(i.value,2)||f(i.value,4)))return new g(d(n.value,i.value))}return new v(t.op,t.fn,[n,i])}if("^"===t.op){if(Object(ie.l)(i)){if(l(i.value))return N;if(f(i.value,1))return n;if(Object(ie.l)(n))return new g(y(n.value,i.value));if(Object(ie.B)(n)&&n.isBinary()&&"^"===n.op){var s=n.args[1];if(Object(ie.l)(s))return new v(t.op,t.fn,[n.args[0],new g(h(s.value,i.value))])}}return new v(t.op,t.fn,[n,i])}}}else{if(Object(ie.C)(t)){var u=e(t.content);return Object(ie.C)(u)||Object(ie.J)(u)||Object(ie.l)(u)?u:new x(u)}if(Object(ie.r)(t)){var c=t.args.map(e).map(function(e){return Object(ie.C)(e)?e.content:e});return new b(e(t.fn),c)}}return t}}),lm=["typed","config","mathWithTransform","?fraction","?bignumber","ConstantNode","OperatorNode","FunctionNode","SymbolNode"],pm=Object(s.a)("simplifyConstant",lm,function(e){var t=e.typed,r=e.config,p=e.mathWithTransform,n=e.fraction,i=e.bignumber,a=e.ConstantNode,o=e.OperatorNode,m=e.FunctionNode,s=e.SymbolNode,u=um({FunctionNode:m,OperatorNode:o,SymbolNode:s}),h=u.isCommutative,d=u.isAssociative,y=u.allChildren,g=u.createMakeNodeFunction;function v(t,r,n){try{return x(p[t].apply(null,r),n)}catch(e){return r=r.map(function(e){return Object(ie.o)(e)?e.valueOf():e}),x(p[t].apply(null,r),n)}}var b=t({Fraction:function(e){var t,r=e.s*e.n;t=r<0?new o("-","unaryMinus",[new a(-r)]):new a(r);return 1!==e.d?new o("/","divide",[t,new a(e.d)]):t},number:function(e){return e<0?f(new a(-e)):new a(e)},BigNumber:function(e){return e<0?f(new a(-e)):new a(e)},Complex:function(){throw new Error("Cannot convert Complex number to Node")}});function c(e,t){if(t&&!1!==t.exactFractions&&isFinite(e)&&n){var r=n(e);if(r.valueOf()===e)return r}return e}var x=t({"string, Object":function(e,t){return"BigNumber"===r.number?(void 0===i&&gi(),i(e)):"Fraction"===r.number?(void 0===n&&vi(),n(e)):c(parseFloat(e),t)},"Fraction, Object":function(e){return e},"BigNumber, Object":function(e){return e},"number, Object":c,"Complex, Object":function(e,t){return 0!==e.im?e:c(e.re,t)}});function f(e){return new o("-","unaryMinus",[e])}function w(r,e,n,i){return e.reduce(function(e,t){if(Object(ie.w)(e)||Object(ie.w)(t))Object(ie.w)(e)?Object(ie.w)(t)||(t=b(t)):e=b(e);else{try{return v(r,[e,t],i)}catch(e){}e=b(e),t=b(t)}return n([e,t])})}return function(e,t){var r=function t(e,r){switch(e.type){case"SymbolNode":return e;case"ConstantNode":return"number"!=typeof e.value&&isNaN(e.value)?e:x(e.value,r);case"FunctionNode":if(p[e.name]&&p[e.name].rawArgs)return e;var n=["add","multiply"];if(-1===n.indexOf(e.name)){var i=e.args.map(function(e){return t(e,r)});if(!i.some(ie.w))try{return v(e.name,i,r)}catch(e){}return i=i.map(function(e){return Object(ie.w)(e)?e:b(e)}),new m(e.name,i)}case"OperatorNode":var a,o,s=e.fn.toString(),u=g(e);if(Object(ie.B)(e)&&e.isUnary())a=[t(e.args[0],r)],o=Object(ie.w)(a[0])?u(a):v(s,a,r);else if(d(e))if(a=(a=y(e)).map(function(e){return t(e,r)}),h(s)){for(var c=[],f=[],l=0;l<a.length;l++)Object(ie.w)(a[l])?f.push(a[l]):c.push(a[l]);o=1<c.length?(o=w(s,c,u,r),f.unshift(o),w(s,f,u,r)):w(s,a,u,r)}else o=w(s,a,u,r);else a=e.args.map(function(e){return t(e,r)}),o=w(s,a,u,r);return o;case"ParenthesisNode":return t(e.content,r);case"AccessorNode":case"ArrayNode":case"AssignmentNode":case"BlockNode":case"FunctionAssignmentNode":case"IndexNode":case"ObjectNode":case"RangeNode":case"ConditionalNode":default:throw new Error("Unimplemented node type in simplifyConstant: ".concat(e.type))}}(e,t);return Object(ie.w)(r)?r:b(r)}}),mm=["parse","FunctionNode","OperatorNode","ParenthesisNode"],hm=Object(s.a)("resolve",mm,function(e){var o=e.parse,s=e.FunctionNode,u=e.OperatorNode,c=e.ParenthesisNode;return function t(e,r){if(!r)return e;if(Object(ie.J)(e)){var n=r[e.name];if(Object(ie.w)(n))return t(n,r);if("number"==typeof n)return o(String(n))}else{if(Object(ie.B)(e)){var i=e.args.map(function(e){return t(e,r)});return new u(e.op,e.fn,i,e.implicit)}if(Object(ie.C)(e))return new c(t(e.content,r));if(Object(ie.r)(e)){var a=e.args.map(function(e){return t(e,r)});return new s(e.name,a)}}return e}});function dm(e){return(dm="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var ym=["config","typed","parse","add","subtract","multiply","divide","pow","isZero","equal","?fraction","?bignumber","mathWithTransform","ConstantNode","FunctionNode","OperatorNode","ParenthesisNode","SymbolNode"],gm=Object(s.a)("simplify",ym,function(e){var t=e.config,r=e.typed,c=e.parse,n=e.add,i=e.subtract,a=e.multiply,o=e.divide,s=e.pow,u=e.isZero,l=e.equal,f=e.fraction,p=e.bignumber,m=e.mathWithTransform,h=e.ConstantNode,d=e.FunctionNode,y=e.OperatorNode,g=e.ParenthesisNode,v=e.SymbolNode,b=pm({typed:r,config:t,mathWithTransform:m,fraction:f,bignumber:p,ConstantNode:h,OperatorNode:y,FunctionNode:d,SymbolNode:v}),x=fm({equal:l,isZero:u,add:n,subtract:i,multiply:a,divide:o,pow:s,ConstantNode:h,OperatorNode:y,FunctionNode:d,ParenthesisNode:g}),w=hm({parse:c,FunctionNode:d,OperatorNode:y,ParenthesisNode:g}),N=um({FunctionNode:d,OperatorNode:y,SymbolNode:v}),O=N.isCommutative,M=N.isAssociative,j=N.flatten,E=N.unflattenr,S=N.unflattenl,A=N.createMakeNodeFunction,C=r("simplify",{string:function(e){return this(c(e),this.rules,{},{})},"string, Object":function(e,t){return this(c(e),this.rules,t,{})},"string, Object, Object":function(e,t,r){return this(c(e),this.rules,t,r)},"string, Array":function(e,t){return this(c(e),t,{},{})},"string, Array, Object":function(e,t,r){return this(c(e),t,r,{})},"string, Array, Object, Object":function(e,t,r,n){return this(c(e),t,r,n)},"Node, Object":function(e,t){return this(e,this.rules,t,{})},"Node, Object, Object":function(e,t,r){return this(e,this.rules,t,r)},Node:function(e){return this(e,this.rules,{},{})},"Node, Array":function(e,t){return this(e,t,{},{})},"Node, Array, Object":function(e,t,r){return this(e,t,r,{})},"Node, Array, Object, Object":function(e,t,r,n){t=function(e){for(var t=[],r=0;r<e.length;r++){var n,i,a=e[r],o=void 0,s=dm(a);switch(s){case"string":var u=a.split("->");if(2!==u.length)throw SyntaxError("Could not parse rule: "+a);a={l:u[0],r:u[1]};case"object":o={l:T(c(a.l)),r:T(c(a.r))},a.context&&(o.evaluate=a.context),a.evaluate&&(o.evaluate=c(a.evaluate)),M(o.l)&&(n=A(o.l),i=new v("_p"+q++),o.expanded={},o.expanded.l=n([o.l.clone(),i]),j(o.expanded.l),E(o.expanded.l),o.expanded.r=n([o.r,i]));break;case"function":o=a;break;default:throw TypeError("Unsupported type of rule: "+s)}t.push(o)}return t}(t);for(var i=w(e,r),a={},o=(i=T(i)).toString({parenthesis:"all"});!a[o];){a[o]=!0;for(var s=q=0;s<t.length;s++)i="function"==typeof t[s]?t[s](i,n):(j(i),I(i,t[s])),S(i);o=i.toString({parenthesis:"all"})}return i}});function T(e){return e.transform(function(e,t,r){return Object(ie.C)(e)?T(e.content):e})}C.simplifyCore=x,C.resolve=w;var _={true:!0,false:!0,e:!0,i:!0,Infinity:!0,LN2:!0,LN10:!0,LOG2E:!0,LOG10E:!0,NaN:!0,phi:!0,pi:!0,SQRT1_2:!0,SQRT2:!0,tau:!0};C.rules=[x,{l:"log(e)",r:"1"},{l:"n-n1",r:"n+-n1"},{l:"-(c*v)",r:"(-c) * v"},{l:"-v",r:"(-1) * v"},{l:"n/n1^n2",r:"n*n1^-n2"},{l:"n/n1",r:"n*n1^-1"},{l:"(n ^ n1) ^ n2",r:"n ^ (n1 * n2)"},{l:"n*n",r:"n^2"},{l:"n * n^n1",r:"n^(n1+1)"},{l:"n^n1 * n^n2",r:"n^(n1+n2)"},{l:"n+n",r:"2*n"},{l:"n+-n",r:"0"},{l:"n1*n2 + n2",r:"(n1+1)*n2"},{l:"n1*n3 + n2*n3",r:"(n1+n2)*n3"},{l:"n1 + -1 * (n2 + n3)",r:"n1 + -1 * n2 + -1 * n3"},b,{l:"(-n)*n1",r:"-(n*n1)"},{l:"c+v",r:"v+c",context:{add:{commutative:!1}}},{l:"v*c",r:"c*v",context:{multiply:{commutative:!1}}},{l:"n+-n1",r:"n-n1"},{l:"n*(n1^-1)",r:"n/n1"},{l:"n*n1^-n2",r:"n/n1^n2"},{l:"n1^-1",r:"1/n1"},{l:"n*(n1/n2)",r:"(n*n1)/n2"},{l:"n-(n1+n2)",r:"n-n1-n2"},{l:"1*n",r:"n"},{l:"n1/(n2/n3)",r:"(n1*n3)/n2"}];var q=0;var I=r("applyRule",{"Node, Object":function(e,t){var r=e;if(r instanceof y||r instanceof d){if(r.args)for(var n=0;n<r.args.length;n++)r.args[n]=I(r.args[n],t)}else r instanceof g&&r.content&&(r.content=I(r.content,t));var i,a=t.r,o=z(t.l,r)[0];return!o&&t.expanded&&(a=t.expanded.r,o=z(t.expanded.l,r)[0]),o&&(i=r.implicit,r=a.clone(),i&&"implicit"in a&&(r.implicit=!0),r=r.transform(function(e){return e.isSymbolNode&&Object(ae.f)(o.placeholders,e.name)?o.placeholders[e.name].clone():e})),r}});function k(e,t){var r={placeholders:{}};if(!e.placeholders&&!t.placeholders)return r;if(!e.placeholders)return t;if(!t.placeholders)return e;for(var n in e.placeholders)if(Object(ae.f)(e.placeholders,n)&&(r.placeholders[n]=e.placeholders[n],Object(ae.f)(t.placeholders,n)&&!function e(t,r){if(t instanceof h&&r instanceof h){if(!l(t.value,r.value))return!1}else if(t instanceof v&&r instanceof v){if(t.name!==r.name)return!1}else{if(!(t instanceof y&&r instanceof y||t instanceof d&&r instanceof d))return!1;if(t instanceof y){if(t.op!==r.op||t.fn!==r.fn)return!1}else if(t instanceof d&&t.name!==r.name)return!1;if(t.args.length!==r.args.length)return!1;for(var n=0;n<t.args.length;n++)if(!e(t.args[n],r.args[n]))return!1}return!0}(e.placeholders[n],t.placeholders[n])))return null;for(var i in t.placeholders)Object(ae.f)(t.placeholders,i)&&(r.placeholders[i]=t.placeholders[i]);return r}function B(e,t){var r,n=[];if(0===e.length||0===t.length)return n;for(var i=0;i<e.length;i++)for(var a=0;a<t.length;a++)(r=k(e[i],t[a]))&&n.push(r);return n}function z(e,t,r){var n=[{placeholders:{}}];if(e instanceof y&&t instanceof y||e instanceof d&&t instanceof d){if(e instanceof y){if(e.op!==t.op||e.fn!==t.fn)return[]}else if(e instanceof d&&e.name!==t.name)return[];if((1!==t.args.length||1!==e.args.length)&&M(t)&&!r){if(2<=t.args.length&&2===e.args.length){for(var i=function(e,t){var r,n,i=[],a=A(e);if(O(e,t))for(var o=0;o<e.args.length;o++)(n=e.args.slice(0)).splice(o,1),r=1===n.length?n[0]:a(n),i.push(a([e.args[o],r]));else r=1===(n=e.args.slice(1)).length?n[0]:a(n),i.push(a([e.args[0],r]));return i}(t,e.context),a=[],o=0;o<i.length;o++)var s=z(e,i[o],!0),a=a.concat(s);return a}if(2<e.args.length)throw Error("Unexpected non-binary associative function: "+e.toString());return[]}for(var u=[],c=0;c<e.args.length;c++){var f=z(e.args[c],t.args[c]);if(0===f.length)return[];u.push(f)}n=function(e){if(0===e.length)return e;for(var t=e.reduce(B),r=[],n={},i=0;i<t.length;i++){var a=JSON.stringify(t[i]);n[a]||(n[a]=!0,r.push(t[i]))}return r}(u)}else if(e instanceof v){if(0===e.name.length)throw new Error("Symbol in rule has 0 length...!?");if(_[e.name]){if(e.name!==t.name)return[]}else if("n"===e.name[0]||"_p"===e.name.substring(0,2))n[0].placeholders[e.name]=t;else if("v"===e.name[0]){if(Object(ie.l)(t))return[];n[0].placeholders[e.name]=t}else{if("c"!==e.name[0])throw new Error("Invalid symbol in rule: "+e.name);if(!(t instanceof h))return[];n[0].placeholders[e.name]=t}}else{if(!(e instanceof h))return[];if(!l(e.value,t.value))return[]}return n}return C}),vm=["typed","config","parse","simplify","equal","isZero","numeric","ConstantNode","FunctionNode","OperatorNode","ParenthesisNode","SymbolNode"],bm=Object(s.a)("derivative",vm,function(e){var t=e.typed,r=e.config,n=e.parse,a=e.simplify,l=e.equal,p=e.isZero,i=e.numeric,o=e.ConstantNode,m=e.FunctionNode,h=e.OperatorNode,s=e.ParenthesisNode,f=e.SymbolNode,u=t("derivative",{"Node, SymbolNode, Object":function(e,t,r){var n={};d(n,e,t.name);var i=y(e,n);return r.simplify?a(i):i},"Node, SymbolNode":function(e,t){return this(e,t,{simplify:!0})},"string, SymbolNode":function(e,t){return this(n(e),t)},"string, SymbolNode, Object":function(e,t,r){return this(n(e),t,r)},"string, string":function(e,t){return this(n(e),n(t))},"string, string, Object":function(e,t,r){return this(n(e),n(t),r)},"Node, string":function(e,t){return this(e,n(t))},"Node, string, Object":function(e,t,r){return this(e,n(t),r)}});u._simplify=!0,u.toTex=function(e){return c.apply(null,e.args)};var c=t("_derivTex",{"Node, SymbolNode":function(e,t){return Object(ie.l)(e)&&"string"===Object(ie.M)(e.value)?c(n(e.value).toString(),t.toString(),1):c(e.toString(),t.toString(),1)},"Node, ConstantNode":function(e,t){if("string"===Object(ie.M)(t.value))return c(e,n(t.value));throw new Error("The second parameter to 'derivative' is a non-string constant")},"Node, SymbolNode, ConstantNode":function(e,t,r){return c(e.toString(),t.name,r.value)},"string, string, number":function(e,t,r){var n=1===r?"{d\\over d"+t+"}":"{d^{"+r+"}\\over d"+t+"^{"+r+"}}";return n+"\\left[".concat(e,"\\right]")}}),d=t("constTag",{"Object, ConstantNode, string":function(e,t){return e[t]=!0},"Object, SymbolNode, string":function(e,t,r){return t.name!==r&&(e[t]=!0)},"Object, ParenthesisNode, string":function(e,t,r){return d(e,t.content,r)},"Object, FunctionAssignmentNode, string":function(e,t,r){return-1===t.params.indexOf(r)?e[t]=!0:d(e,t.expr,r)},"Object, FunctionNode | OperatorNode, string":function(e,t,r){if(0<t.args.length){for(var n=d(e,t.args[0],r),i=1;i<t.args.length;++i)n=d(e,t.args[i],r)&&n;if(n)return e[t]=!0}return!1}}),y=t("_derivative",{"ConstantNode, Object":function(){return g(0)},"SymbolNode, Object":function(e,t){return void 0!==t[e]?g(0):g(1)},"ParenthesisNode, Object":function(e,t){return new s(y(e.content,t))},"FunctionAssignmentNode, Object":function(e,t){return void 0!==t[e]?g(0):y(e.expr,t)},"FunctionNode, Object":function(e,t){if(1!==e.args.length&&function(e){if(("log"===e.name||"nthRoot"===e.name||"pow"===e.name)&&2===e.args.length)return;for(var t=0;t<e.args.length;++t)e.args[t]=g(0);throw e.compile().evaluate(),new Error("Expected TypeError, but none found")}(e),void 0!==t[e])return g(0);var r,n,i,a,o=e.args[0],s=!1,u=!1;switch(e.name){case"cbrt":s=!0,n=new h("*","multiply",[g(3),new h("^","pow",[o,new h("/","divide",[g(2),g(3)])])]);break;case"sqrt":case"nthRoot":if(1===e.args.length)s=!0,n=new h("*","multiply",[g(2),new m("sqrt",[o])]);else if(2===e.args.length)return t[r=new h("/","divide",[g(1),e.args[1]])]=t[e.args[1]],y(new h("^","pow",[o,r]),t);break;case"log10":r=g(10);case"log":if(r||1!==e.args.length){if(1===e.args.length&&r||2===e.args.length&&void 0!==t[e.args[1]])n=new h("*","multiply",[o.clone(),new m("log",[r||e.args[1]])]),s=!0;else if(2===e.args.length)return y(new h("/","divide",[new m("log",[o]),new m("log",[e.args[1]])]),t)}else n=o.clone(),s=!0;break;case"pow":return t[r]=t[e.args[1]],y(new h("^","pow",[o,e.args[1]]),t);case"exp":n=new m("exp",[o.clone()]);break;case"sin":n=new m("cos",[o.clone()]);break;case"cos":n=new h("-","unaryMinus",[new m("sin",[o.clone()])]);break;case"tan":n=new h("^","pow",[new m("sec",[o.clone()]),g(2)]);break;case"sec":n=new h("*","multiply",[e,new m("tan",[o.clone()])]);break;case"csc":u=!0,n=new h("*","multiply",[e,new m("cot",[o.clone()])]);break;case"cot":u=!0,n=new h("^","pow",[new m("csc",[o.clone()]),g(2)]);break;case"asin":s=!0,n=new m("sqrt",[new h("-","subtract",[g(1),new h("^","pow",[o.clone(),g(2)])])]);break;case"acos":u=s=!0,n=new m("sqrt",[new h("-","subtract",[g(1),new h("^","pow",[o.clone(),g(2)])])]);break;case"atan":s=!0,n=new h("+","add",[new h("^","pow",[o.clone(),g(2)]),g(1)]);break;case"asec":s=!0,n=new h("*","multiply",[new m("abs",[o.clone()]),new m("sqrt",[new h("-","subtract",[new h("^","pow",[o.clone(),g(2)]),g(1)])])]);break;case"acsc":u=s=!0,n=new h("*","multiply",[new m("abs",[o.clone()]),new m("sqrt",[new h("-","subtract",[new h("^","pow",[o.clone(),g(2)]),g(1)])])]);break;case"acot":u=s=!0,n=new h("+","add",[new h("^","pow",[o.clone(),g(2)]),g(1)]);break;case"sinh":n=new m("cosh",[o.clone()]);break;case"cosh":n=new m("sinh",[o.clone()]);break;case"tanh":n=new h("^","pow",[new m("sech",[o.clone()]),g(2)]);break;case"sech":u=!0,n=new h("*","multiply",[e,new m("tanh",[o.clone()])]);break;case"csch":u=!0,n=new h("*","multiply",[e,new m("coth",[o.clone()])]);break;case"coth":u=!0,n=new h("^","pow",[new m("csch",[o.clone()]),g(2)]);break;case"asinh":s=!0,n=new m("sqrt",[new h("+","add",[new h("^","pow",[o.clone(),g(2)]),g(1)])]);break;case"acosh":s=!0,n=new m("sqrt",[new h("-","subtract",[new h("^","pow",[o.clone(),g(2)]),g(1)])]);break;case"atanh":s=!0,n=new h("-","subtract",[g(1),new h("^","pow",[o.clone(),g(2)])]);break;case"asech":u=s=!0,n=new h("*","multiply",[o.clone(),new m("sqrt",[new h("-","subtract",[g(1),new h("^","pow",[o.clone(),g(2)])])])]);break;case"acsch":u=s=!0,n=new h("*","multiply",[new m("abs",[o.clone()]),new m("sqrt",[new h("+","add",[new h("^","pow",[o.clone(),g(2)]),g(1)])])]);break;case"acoth":u=s=!0,n=new h("-","subtract",[g(1),new h("^","pow",[o.clone(),g(2)])]);break;case"abs":n=new h("/","divide",[new m(new f("abs"),[o.clone()]),o.clone()]);break;case"gamma":default:throw new Error('Function "'+e.name+'" is not supported by derivative, or a wrong number of arguments is passed')}a=s?(i="/","divide"):(i="*","multiply");var c=y(o,t);return u&&(c=new h("-","unaryMinus",[c])),new h(i,a,[c,n])},"OperatorNode, Object":function(e,r){if(void 0!==r[e])return g(0);if("+"===e.op)return new h(e.op,e.fn,e.args.map(function(e){return y(e,r)}));if("-"===e.op){if(e.isUnary())return new h(e.op,e.fn,[y(e.args[0],r)]);if(e.isBinary())return new h(e.op,e.fn,[y(e.args[0],r),y(e.args[1],r)])}if("*"===e.op){var t=e.args.filter(function(e){return void 0!==r[e]});if(0<t.length){var n=e.args.filter(function(e){return void 0===r[e]}),i=1===n.length?n[0]:new h("*","multiply",n),a=t.concat(y(i,r));return new h("*","multiply",a)}return new h("+","add",e.args.map(function(t){return new h("*","multiply",e.args.map(function(e){return e===t?y(e,r):e.clone()}))}))}if("/"===e.op&&e.isBinary()){var o=e.args[0],s=e.args[1];return void 0!==r[s]?new h("/","divide",[y(o,r),s]):void 0!==r[o]?new h("*","multiply",[new h("-","unaryMinus",[o]),new h("/","divide",[y(s,r),new h("^","pow",[s.clone(),g(2)])])]):new h("/","divide",[new h("-","subtract",[new h("*","multiply",[y(o,r),s.clone()]),new h("*","multiply",[o.clone(),y(s,r)])]),new h("^","pow",[s.clone(),g(2)])])}if("^"===e.op&&e.isBinary()){var u=e.args[0],c=e.args[1];if(void 0!==r[u])return Object(ie.l)(u)&&(p(u.value)||l(u.value,1))?g(0):new h("*","multiply",[e,new h("*","multiply",[new m("log",[u.clone()]),y(c.clone(),r)])]);if(void 0===r[c])return new h("*","multiply",[new h("^","pow",[u.clone(),c.clone()]),new h("+","add",[new h("*","multiply",[y(u,r),new h("/","divide",[c.clone(),u.clone()])]),new h("*","multiply",[y(c,r),new m("log",[u.clone()])])])]);if(Object(ie.l)(c)){if(p(c.value))return g(0);if(l(c.value,1))return y(u,r)}var f=new h("^","pow",[u.clone(),new h("-","subtract",[c,g(1)])]);return new h("*","multiply",[c.clone(),new h("*","multiply",[y(u,r),f])])}throw new Error('Operator "'+e.op+'" is not supported by derivative, or a wrong number of arguments is passed')}});function g(e,t){return new o(i(e,t||r.number))}return u}),xm="rationalize",wm=["config","typed","equal","isZero","add","subtract","multiply","divide","pow","parse","simplify","?bignumber","?fraction","mathWithTransform","ConstantNode","OperatorNode","FunctionNode","SymbolNode","ParenthesisNode"],Nm=Object(s.a)(xm,wm,function(e){var t=e.config,r=e.typed,n=e.equal,i=e.isZero,a=e.add,o=e.subtract,s=e.multiply,u=e.divide,c=e.pow,f=e.parse,g=e.simplify,l=e.fraction,p=e.bignumber,m=e.mathWithTransform,v=e.ConstantNode,b=e.OperatorNode,h=e.FunctionNode,d=e.SymbolNode,y=e.ParenthesisNode,x=pm({typed:r,config:t,mathWithTransform:m,fraction:l,bignumber:p,ConstantNode:v,OperatorNode:b,FunctionNode:h,SymbolNode:d}),w=fm({equal:n,isZero:i,add:a,subtract:o,multiply:s,divide:u,pow:c,ConstantNode:v,OperatorNode:b,FunctionNode:h,ParenthesisNode:y});return r(xm,{string:function(e){return this(f(e),{},!1)},"string, boolean":function(e,t){return this(f(e),{},t)},"string, Object":function(e,t){return this(f(e),t,!1)},"string, Object, boolean":function(e,t,r){return this(f(e),t,r)},Node:function(e){return this(e,{},!1)},"Node, boolean":function(e,t){return this(e,{},t)},"Node, Object":function(e,t){return this(e,t,!1)},"Node, Object, boolean":function(e,t,r){var n,i,a,o,s,u,c=((o={}).firstRules=(n=[w,{l:"n+n",r:"2*n"},{l:"n+-n",r:"0"},x,{l:"n*(n1^-1)",r:"n/n1"},{l:"n*n1^-n2",r:"n/n1^n2"},{l:"n1^-1",r:"1/n1"},{l:"n*(n1/n2)",r:"(n*n1)/n2"},{l:"1*n",r:"n"}]).concat(i=[{l:"(-n1)/(-n2)",r:"n1/n2"},{l:"(-n1)*(-n2)",r:"n1*n2"},{l:"n1--n2",r:"n1+n2"},{l:"n1-n2",r:"n1+(-n2)"},{l:"(n1+n2)*n3",r:"(n1*n3 + n2*n3)"},{l:"n1*(n2+n3)",r:"(n1*n2+n1*n3)"},{l:"c1*n + c2*n",r:"(c1+c2)*n"},{l:"c1*n + n",r:"(c1+1)*n"},{l:"c1*n - c2*n",r:"(c1-c2)*n"},{l:"c1*n - n",r:"(c1-1)*n"},{l:"v/c",r:"(1/c)*v"},{l:"v/-c",r:"-(1/c)*v"},{l:"-v*-c",r:"c*v"},{l:"-v*c",r:"-c*v"},{l:"v*-c",r:"-c*v"},{l:"v*c",r:"c*v"},{l:"-(-n1*n2)",r:"(n1*n2)"},{l:"-(n1*n2)",r:"(-n1*n2)"},{l:"-(-n1+n2)",r:"(n1-n2)"},{l:"-(n1+n2)",r:"(-n1-n2)"},{l:"(n1^n2)^n3",r:"(n1^(n2*n3))"},{l:"-(-n1/n2)",r:"(n1/n2)"},{l:"-(n1/n2)",r:"(-n1/n2)"}],a=[{l:"(n1/(n2/n3))",r:"((n1*n3)/n2)"},{l:"(n1/n2/n3)",r:"(n1/(n2*n3))"}]),o.distrDivRules=[{l:"(n1/n2 + n3/n4)",r:"((n1*n4 + n3*n2)/(n2*n4))"},{l:"(n1/n2 + n3)",r:"((n1 + n3*n2)/n2)"},{l:"(n1 + n2/n3)",r:"((n1*n3 + n2)/n3)"}],o.sucDivRules=a,o.firstRulesAgain=n.concat(i),o.finalRules=[w,{l:"n*-n",r:"-n^2"},{l:"n*n",r:"n^2"},x,{l:"n*-n^n1",r:"-n^(n1+1)"},{l:"n*n^n1",r:"n^(n1+1)"},{l:"n^n1*-n^n2",r:"-n^(n1+n2)"},{l:"n^n1*n^n2",r:"n^(n1+n2)"},{l:"n^n1*-n",r:"-n^(n1+1)"},{l:"n^n1*n",r:"n^(n1+1)"},{l:"n^n1/-n",r:"-n^(n1-1)"},{l:"n^n1/n",r:"n^(n1-1)"},{l:"n/-n^n1",r:"-n^(1-n1)"},{l:"n/n^n1",r:"n^(1-n1)"},{l:"n^n1/-n^n2",r:"n^(n1-n2)"},{l:"n^n1/n^n2",r:"n^(n1-n2)"},{l:"n1+(-n2*n3)",r:"n1-n2*n3"},{l:"v*(-c)",r:"-c*v"},{l:"n1+-n2",r:"n1-n2"},{l:"v*c",r:"c*v"},{l:"(n1^n2)^n3",r:"(n1^(n2*n3))"}],o),f=function(e,t,r,n){var o=[],i=g(e,n,t,{exactFractions:!1}),s="+-*"+((r=!!r)?"/":"");!function e(t){var r=t.type;{if("FunctionNode"===r)throw new Error("There is an unsolved function call");if("OperatorNode"===r)if("^"===t.op){if("ConstantNode"!==t.args[1].type||!Object(E.i)(parseFloat(t.args[1].value)))throw new Error("There is a non-integer exponent");e(t.args[0])}else{if(-1===s.indexOf(t.op))throw new Error("Operator "+t.op+" invalid in polynomial expression");for(var n=0;n<t.args.length;n++)e(t.args[n])}else if("SymbolNode"===r){var i=t.name,a=o.indexOf(i);-1===a&&o.push(i)}else if("ParenthesisNode"===r)e(t.content);else if("ConstantNode"!==r)throw new Error("type "+r+" is not allowed in polynomial expression")}}(i);var a={};return a.expression=i,a.variables=o,a}(e,t,!0,c.firstRules),l=f.variables.length;if(e=f.expression,1<=l){e=function e(t,r,n){var i=t.type;var a=1<arguments.length;{var o,s,u,c;"OperatorNode"===i&&t.isBinary()&&(o=!1,"^"===t.op&&("ParenthesisNode"!==t.args[0].type&&"OperatorNode"!==t.args[0].type||"ConstantNode"!==t.args[1].type||(s=parseFloat(t.args[1].value),o=2<=s&&Object(E.i)(s))),o&&(t=2<s?(u=t.args[0],c=new b("^","pow",[t.args[0].cloneDeep(),new v(s-1)]),new b("*","multiply",[u,c])):new b("*","multiply",[t.args[0],t.args[0].cloneDeep()]),a&&("content"===n?r.content=t:r.args[n]=t)))}if("ParenthesisNode"===i)e(t.content,t,"content");else if("ConstantNode"!==i&&"SymbolNode"!==i)for(var f=0;f<t.args.length;f++)e(t.args[f],t,f);if(!a)return t}(e);var p,m=!0,h=!1;for(e=g(e,c.firstRules,{},{exactFractions:!1});u=m?c.distrDivRules:c.sucDivRules,m=!m,(p=(e=g(e,u)).toString())!==s;)h=!0,s=p;h&&(e=g(e,c.firstRulesAgain,{},{exactFractions:!1})),e=g(e,c.finalRules,{},{exactFractions:!1})}var d=[],y={};return"OperatorNode"===e.type&&e.isBinary()&&"/"===e.op?(1===l&&(e.args[0]=N(e.args[0],d),e.args[1]=N(e.args[1])),r&&(y.numerator=e.args[0],y.denominator=e.args[1])):(1===l&&(e=N(e,d)),r&&(y.numerator=e,y.denominator=null)),r?(y.coefficients=d,y.variables=f.variables,y.expression=e,y):e}});function N(e,u){void 0===u&&(u=[]);var t={cte:1,oper:"+",fire:""},c=u[0]=0,f="";!function e(t,r,n){var i=t.type;{if("FunctionNode"===i)throw new Error("There is an unsolved function call");if("OperatorNode"===i){if(-1==="+-*^".indexOf(t.op))throw new Error("Operator "+t.op+" invalid");if(null!==r){if(("unaryMinus"===t.fn||"pow"===t.fn)&&"add"!==r.fn&&"subtract"!==r.fn&&"multiply"!==r.fn)throw new Error("Invalid "+t.op+" placing");if(("subtract"===t.fn||"add"===t.fn||"multiply"===t.fn)&&"add"!==r.fn&&"subtract"!==r.fn)throw new Error("Invalid "+t.op+" placing");if(("subtract"===t.fn||"add"===t.fn||"unaryMinus"===t.fn)&&0!==n.noFil)throw new Error("Invalid "+t.op+" placing")}"^"!==t.op&&"*"!==t.op||(n.fire=t.op);for(var a=0;a<t.args.length;a++)"unaryMinus"===t.fn&&(n.oper="-"),"+"!==t.op&&"subtract"!==t.fn||(n.fire="",n.cte=1,n.oper=0===a?"+":t.op),n.noFil=a,e(t.args[a],t,n)}else if("SymbolNode"===i){if(t.name!==f&&""!==f)throw new Error("There is more than one variable");if(f=t.name,null===r)return void(u[1]=1);if("^"===r.op&&0!==n.noFil)throw new Error("In power the variable should be the first parameter");if("*"===r.op&&1!==n.noFil)throw new Error("In multiply the variable should be the second parameter");""!==n.fire&&"*"!==n.fire||(c<1&&(u[1]=0),u[1]+=n.cte*("+"===n.oper?1:-1),c=Math.max(1,c))}else{if("ConstantNode"!==i)throw new Error("Type "+i+" is not allowed");var o=parseFloat(t.value);if(null===r)return void(u[0]=o);if("^"===r.op){if(1!==n.noFil)throw new Error("Constant cannot be powered");if(!Object(E.i)(o)||o<=0)throw new Error("Non-integer exponent is not allowed");for(var s=c+1;s<o;s++)u[s]=0;return c<o&&(u[o]=0),u[o]+=n.cte*("+"===n.oper?1:-1),void(c=Math.max(o,c))}n.cte=o,""===n.fire&&(u[0]+=n.cte*("+"===n.oper?1:-1))}}}(e,null,t);for(var r,n,i,a,o,s=!0,l=c=u.length-1;0<=l;l--){0!==u[l]&&(n=new v(s?u[l]:Math.abs(u[l])),i=u[l]<0?"-":"+",0<l&&(o=new d(f),1<l&&(a=new v(l),o=new b("^","pow",[o,a])),n=-1===u[l]&&s?new b("-","unaryMinus",[o]):1===Math.abs(u[l])?o:new b("*","multiply",[n,o])),r=s?n:"+"==i?new b("+","add",[r,n]):new b("-","subtract",[r,n]),s=!1)}return s?new v(0):r}}),Om=["classes"],Mm=Object(s.a)("reviver",Om,function(e){var n=e.classes;return function(e,t){var r=n[t&&t.mathjs];return r&&"function"==typeof r.fromJSON?r.fromJSON(t):t}}),jm=[],Em=Object(s.a)("replacer",jm,function(){return function(e,t){return"number"!=typeof t||isFinite(t)&&!isNaN(t)?t:{mathjs:"number",value:String(t)}}}),Sm=Math.PI,Am=2*Math.PI,Cm=Math.E,Tm=Object(s.a)("true",[],function(){return!0}),_m=Object(s.a)("false",[],function(){return!1}),qm=Object(s.a)("null",[],function(){return null}),Im=Wm("Infinity",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?new r(1/0):1/0}),km=Wm("NaN",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?new r(NaN):NaN}),Bm=Wm("pi",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?ds(r):Sm}),zm=Wm("tau",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?ys(r):Am}),Dm=Wm("e",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?ms(r):Cm}),Rm=Wm("phi",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?hs(r):1.618033988749895}),Pm=Wm("LN2",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?new r(2).ln():Math.LN2}),Um=Wm("LN10",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?new r(10).ln():Math.LN10}),Fm=Wm("LOG2E",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?new r(1).div(new r(2).ln()):Math.LOG2E}),Lm=Wm("LOG10E",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?new r(1).div(new r(10).ln()):Math.LOG10E}),Hm=Wm("SQRT1_2",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?new r("0.5").sqrt():Math.SQRT1_2}),$m=Wm("SQRT2",["config","?BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?new r(2).sqrt():Math.SQRT2}),Gm=Wm("i",["Complex"],function(e){return e.Complex.I}),Zm=Object(s.a)("PI",["pi"],function(e){return e.pi}),Vm=Object(s.a)("E",["e"],function(e){return e.e}),Jm=Object(s.a)("version",[],function(){return"7.1.0"});function Wm(e,t,r){return Object(s.a)(e,t,r,{recreateOnConfigChange:!0})}var Ym=Zh("speedOfLight","299792458","m s^-1"),Xm=Zh("gravitationConstant","6.67430e-11","m^3 kg^-1 s^-2"),Qm=Zh("planckConstant","6.62607015e-34","J s"),Km=Zh("reducedPlanckConstant","1.0545718176461565e-34","J s"),eh=Zh("magneticConstant","1.25663706212e-6","N A^-2"),th=Zh("electricConstant","8.8541878128e-12","F m^-1"),rh=Zh("vacuumImpedance","376.730313667","ohm"),nh=Zh("coulomb","8.987551792261171e9","N m^2 C^-2"),ih=Zh("elementaryCharge","1.602176634e-19","C"),ah=Zh("bohrMagneton","9.2740100783e-24","J T^-1"),oh=Zh("conductanceQuantum","7.748091729863649e-5","S"),sh=Zh("inverseConductanceQuantum","12906.403729652257","ohm"),uh=Zh("magneticFluxQuantum","2.0678338484619295e-15","Wb"),ch=Zh("nuclearMagneton","5.0507837461e-27","J T^-1"),fh=Zh("klitzing","25812.807459304513","ohm"),lh=Zh("bohrRadius","5.29177210903e-11","m"),ph=Zh("classicalElectronRadius","2.8179403262e-15","m"),mh=Zh("electronMass","9.1093837015e-31","kg"),hh=Zh("fermiCoupling","1.1663787e-5","GeV^-2"),dh=Vh("fineStructure",.0072973525693),yh=Zh("hartreeEnergy","4.3597447222071e-18","J"),gh=Zh("protonMass","1.67262192369e-27","kg"),vh=Zh("deuteronMass","3.3435830926e-27","kg"),bh=Zh("neutronMass","1.6749271613e-27","kg"),xh=Zh("quantumOfCirculation","3.6369475516e-4","m^2 s^-1"),wh=Zh("rydberg","10973731.568160","m^-1"),Nh=Zh("thomsonCrossSection","6.6524587321e-29","m^2"),Oh=Vh("weakMixingAngle",.2229),Mh=Vh("efimovFactor",22.7),jh=Zh("atomicMass","1.66053906660e-27","kg"),Eh=Zh("avogadro","6.02214076e23","mol^-1"),Sh=Zh("boltzmann","1.380649e-23","J K^-1"),Ah=Zh("faraday","96485.33212331001","C mol^-1"),Ch=Zh("firstRadiation","3.7417718521927573e-16","W m^2"),Th=Zh("loschmidt","2.686780111798444e25","m^-3"),_h=Zh("gasConstant","8.31446261815324","J K^-1 mol^-1"),qh=Zh("molarPlanckConstant","3.990312712893431e-10","J s mol^-1"),Ih=Zh("molarVolume","0.022413969545014137","m^3 mol^-1"),kh=Vh("sackurTetrode",-1.16487052358),Bh=Zh("secondRadiation","0.014387768775039337","m K"),zh=Zh("stefanBoltzmann","5.67037441918443e-8","W m^-2 K^-4"),Dh=Zh("wienDisplacement","2.897771955e-3","m K"),Rh=Zh("molarMass","0.99999999965e-3","kg mol^-1"),Ph=Zh("molarMassC12","11.9999999958e-3","kg mol^-1"),Uh=Zh("gravity","9.80665","m s^-2"),Fh=Zh("planckLength","1.616255e-35","m"),Lh=Zh("planckMass","2.176435e-8","kg"),Hh=Zh("planckTime","5.391245e-44","s"),$h=Zh("planckCharge","1.87554603778e-18","C"),Gh=Zh("planckTemperature","1.416785e+32","K");function Zh(e,a,o){return Object(s.a)(e,["config","Unit","BigNumber"],function(e){var t=e.config,r=e.Unit,n=e.BigNumber,i=new r("BigNumber"===t.number?new n(a):parseFloat(a),o);return i.fixPrefix=!0,i})}function Vh(e,n){return Object(s.a)(e,["config","BigNumber"],function(e){var t=e.config,r=e.BigNumber;return"BigNumber"===t.number?new r(n):n})}var Jh=["typed","isInteger"],Wh=Object(s.a)("apply",Jh,function(e){var t=e.typed,r=e.isInteger,n=Ot({typed:t,isInteger:r});return t("apply",{"...any":function(e){var t=e[1];Object(ie.y)(t)?e[1]=t-1:Object(ie.e)(t)&&(e[1]=t.minus(1));try{return n.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0}),Yh=["typed","Index","matrix","range"],Xh=Object(s.a)("column",Yh,function(e){var t=e.typed,r=e.Index,n=e.matrix,i=e.range,a=Un({typed:t,Index:r,matrix:n,range:i});return t("column",{"...any":function(e){var t=e.length-1,r=e[t];Object(ie.y)(r)&&(e[t]=r-1);try{return a.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0});function Qh(e,t,r){var n=e.filter(function(e){return Object(ie.J)(e)&&!(e.name in t)&&!(e.name in r)})[0];if(!n)throw new Error('No undefined variable found in inline expression "'+e+'"');var i=n.name,a=Object.create(r),o=e.compile();return function(e){return a[i]=e,o.evaluate(a)}}var Kh=["typed"],ed=Object(s.a)("filter",Kh,function(e){var t=e.typed;function r(e,t,r){var n,i;return e[0]&&(n=e[0].compile().evaluate(r)),e[1]&&(i=Object(ie.J)(e[1])||Object(ie.q)(e[1])?e[1].compile().evaluate(r):Qh(e[1],t,r)),a(n,i)}r.rawArgs=!0;var a=t("filter",{"Array, function":td,"Matrix, function":function(e,t){return e.create(td(e.toArray(),t))},"Array, RegExp":q.d,"Matrix, RegExp":function(e,t){return e.create(Object(q.d)(e.toArray(),t))}});return r},{isTransformFunction:!0});function td(e,n){var i=Vn(n);return Object(q.c)(e,function(e,t,r){return 1===i?n(e):2===i?n(e,[t+1]):n(e,[t+1],r)})}var rd=["typed"],nd=Object(s.a)("forEach",rd,function(e){var t=e.typed;function r(e,t,r){var n,i;return e[0]&&(n=e[0].compile().evaluate(r)),e[1]&&(i=Object(ie.J)(e[1])||Object(ie.q)(e[1])?e[1].compile().evaluate(r):Qh(e[1],t,r)),a(n,i)}r.rawArgs=!0;var a=t("forEach",{"Array | Matrix, function":function(t,i){var a=Vn(i);!function r(e,n){Array.isArray(e)?Object(q.f)(e,function(e,t){r(e,n.concat(t+1))}):1===a?i(e):2===a?i(e,n):i(e,n,t)}(t.valueOf(),[])}});return r},{isTransformFunction:!0}),id=["Index"],ad=Object(s.a)("index",id,function(e){var a=e.Index;return function(){for(var e=[],t=0,r=arguments.length;t<r;t++){var n=arguments[t];if(Object(ie.D)(n))n.start--,n.end-=0<n.step?0:2;else if(n&&!0===n.isSet)n=n.map(function(e){return e-1});else if(Object(ie.b)(n)||Object(ie.v)(n))n=n.map(function(e){return e-1});else if(Object(ie.y)(n))n--;else if(Object(ie.e)(n))n=n.toNumber()-1;else if("string"!=typeof n)throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");e[t]=n}var i=new a;return a.apply(i,e),i}},{isTransformFunction:!0}),od=["typed"],sd=Object(s.a)("map",od,function(e){var t=e.typed;function r(e,t,r){var n,i;return e[0]&&(n=e[0].compile().evaluate(r)),e[1]&&(i=Object(ie.J)(e[1])||Object(ie.q)(e[1])?e[1].compile().evaluate(r):Qh(e[1],t,r)),a(n,i)}r.rawArgs=!0;var a=t("map",{"Array, function":function(e,t){return ud(e,t,e)},"Matrix, function":function(e,t){return e.create(ud(e.valueOf(),t,e))}});return r},{isTransformFunction:!0});function ud(e,t,i){var a=Vn(t);return function r(e,n){return Array.isArray(e)?Object(q.k)(e,function(e,t){return r(e,n.concat(t+1))}):1===a?t(e):2===a?t(e,n):t(e,n,i)}(e,[])}var cd=["typed","config","numeric","larger"],fd=Object(s.a)("max",cd,function(e){var t=e.typed,r=e.config,n=e.numeric,i=e.larger,a=rs({typed:t,config:r,numeric:n,larger:i});return t("max",{"...any":function(e){var t;2===e.length&&Object(ie.i)(e[0])&&(t=e[1],Object(ie.y)(t)?e[1]=t-1:Object(ie.e)(t)&&(e[1]=t.minus(1)));try{return a.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0}),ld=["typed","add","divide"],pd=Object(s.a)("mean",ld,function(e){var t=e.typed,r=e.add,n=e.divide,i=Wl({typed:t,add:r,divide:n});return t("mean",{"...any":function(e){var t;2===e.length&&Object(ie.i)(e[0])&&(t=e[1],Object(ie.y)(t)?e[1]=t-1:Object(ie.e)(t)&&(e[1]=t.minus(1)));try{return i.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0}),md=["typed","config","numeric","smaller"],hd=Object(s.a)("min",md,function(e){var t=e.typed,r=e.config,n=e.numeric,i=e.smaller,a=is({typed:t,config:r,numeric:n,smaller:i});return t("min",{"...any":function(e){var t;2===e.length&&Object(ie.i)(e[0])&&(t=e[1],Object(ie.y)(t)?e[1]=t-1:Object(ie.e)(t)&&(e[1]=t.minus(1)));try{return a.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0}),dd=["typed","config","?matrix","?bignumber","smaller","smallerEq","larger","largerEq"],yd=Object(s.a)("range",dd,function(e){var t=e.typed,r=e.config,n=e.matrix,i=e.bignumber,a=e.smaller,o=e.smallerEq,s=e.larger,u=e.largerEq,c=wi({typed:t,config:r,matrix:n,bignumber:i,smaller:a,smallerEq:o,larger:s,largerEq:u});return t("range",{"...any":function(e){return"boolean"!=typeof e[e.length-1]&&e.push(!0),c.apply(null,e)}})},{isTransformFunction:!0}),gd=["typed","Index","matrix","range"],vd=Object(s.a)("row",gd,function(e){var t=e.typed,r=e.Index,n=e.matrix,i=e.range,a=Ci({typed:t,Index:r,matrix:n,range:i});return t("row",{"...any":function(e){var t=e.length-1,r=e[t];Object(ie.y)(r)&&(e[t]=r-1);try{return a.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0}),bd=["typed","matrix"],xd=Object(s.a)("subset",bd,function(e){var t=e.typed,r=e.matrix,n=$i({typed:t,matrix:r});return t("subset",{"...any":function(e){try{return n.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0}),wd=["typed","matrix","isInteger"],Nd=Object(s.a)("concat",wd,function(e){var t=e.typed,r=e.matrix,n=e.isInteger,i=Rn({typed:t,matrix:r,isInteger:n});return t("concat",{"...any":function(e){var t=e.length-1,r=e[t];Object(ie.y)(r)?e[t]=r-1:Object(ie.e)(r)&&(e[t]=r.minus(1));try{return i.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0}),Od=["typed","sqrt","variance"],Md=Object(s.a)("std",Od,function(e){var t=e.typed,r=e.sqrt,n=e.variance,i=sp({typed:t,sqrt:r,variance:n});return t("std",{"...any":function(e){var t;2<=e.length&&Object(ie.i)(e[0])&&(t=e[1],Object(ie.y)(t)?e[1]=t-1:Object(ie.e)(t)&&(e[1]=t.minus(1)));try{return i.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0}),jd=["typed","config","add","numeric"],Ed=Object(s.a)("sum",jd,function(e){var t=e.typed,r=e.config,n=e.add,i=e.numeric,a=Vl({typed:t,config:r,add:n,numeric:i});return t("sum",{"...any":function(e){var t;2===e.length&&Object(ie.i)(e[0])&&(t=e[1],Object(ie.y)(t)?e[1]=t-1:Object(ie.e)(t)&&(e[1]=t.minus(1)));try{return a.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0}),Sd="variance",Ad=["typed","add","subtract","multiply","divide","apply","isNaN"],Cd=Object(s.a)(Sd,Ad,function(e){var t=e.typed,r=e.add,n=e.subtract,i=e.multiply,a=e.divide,o=e.apply,s=e.isNaN,u=np({typed:t,add:r,subtract:n,multiply:i,divide:a,apply:o,isNaN:s});return t(Sd,{"...any":function(e){var t;2<=e.length&&Object(ie.i)(e[0])&&(t=e[1],Object(ie.y)(t)?e[1]=t-1:Object(ie.e)(t)&&(e[1]=t.minus(1)));try{return u.apply(null,e)}catch(e){throw zc(e)}}})},{isTransformFunction:!0})},function(e,t,r){"use strict";r.r(t),r.d(t,"create",function(){return E});var d=r(3),n=r(17),l=r.n(n);var y=r(1),g=r(0),v=r(2),b=r(12);function x(e){return(x="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function p(s,e,u,c){function f(e,t){t&&"function"==typeof t.transform?(u.expression.transform[e]=t.transform,r(e)&&(u.expression.mathWithTransform[e]=t.transform)):(delete u.expression.transform[e],r(e)&&(u.expression.mathWithTransform[e]=t))}function l(e){delete u.expression.transform[e],r(e)?u.expression.mathWithTransform[e]=u[e]:delete u.expression.mathWithTransform[e]}function p(e){return"function"==typeof e&&"object"===x(e.signatures)}function r(e){return!Object(d.f)(t,e)}function m(e){return!(-1!==e.fn.indexOf(".")||Object(d.f)(t,e.fn)||e.meta&&e.meta.isClass)}function h(e){return void 0!==e&&void 0!==e.meta&&!0===e.meta.isTransformFunction}var t={expression:!0,type:!0,docs:!0,error:!0,json:!0,chain:!0};return function(e,o){var t=arguments.length;if(1!==t&&2!==t)throw new b.a("import",t,1,2);o=o||{};var r,n={};for(var i in!function t(r,e,n){if(Array.isArray(e))e.forEach(function(e){return t(r,e)});else if("object"===x(e))for(var i in e)Object(d.f)(e,i)&&t(r,e[i],i);else if(Object(g.b)(e)||void 0!==n){var a=Object(g.b)(e)?h(e)?e.fn+".transform":e.fn:n;if(Object(d.f)(r,a)&&r[a]!==e&&!o.silent)throw new Error('Cannot import "'+a+'" twice');r[a]=e}else if(!o.silent)throw new TypeError("Factory, Object, or Array expected")}(n,e),n)if(Object(d.f)(n,i)){var a=n[i];if(Object(g.b)(a))!function(r,n){var i=2<arguments.length&&void 0!==arguments[2]?arguments[2]:r.fn;if(Object(v.b)(i,"."))throw new Error("Factory name should not contain a nested path. Name: "+JSON.stringify(i));function e(){var t={};r.dependencies.map(g.c).forEach(function(e){if(Object(v.b)(e,"."))throw new Error("Factory dependency should not contain a nested path. Name: "+JSON.stringify(e));"math"===e?t.math=u:"mathWithTransform"===e?t.mathWithTransform=u.expression.mathWithTransform:"classes"===e?t.classes=u:t[e]=u[e]});var e=r(t);if(e&&"function"==typeof e.transform)throw new Error('Transforms cannot be attached to factory functions. Please create a separate function for it with exports.path="expression.transform"');if(void 0===o||n.override)return e;if(p(o)&&p(e))return s(o,e);if(n.silent)return o;throw new Error('Cannot import "'+i+'": already exists')}var t=h(r)?u.expression.transform:u,a=i in u.expression.transform,o=Object(d.f)(t,i)?t[i]:void 0;r.meta&&!1===r.meta.lazy?t[i]=e():Object(d.h)(t,i,e),o&&a?l(i):(h(r)||m(r))&&Object(d.h)(u.expression.mathWithTransform,i,function(){return t[i]});c[i]=r,u.emit("import",i,e)}(a,o);else if("function"==typeof(r=a)||"number"==typeof r||"string"==typeof r||"boolean"==typeof r||null===r||Object(y.L)(r)||Object(y.j)(r)||Object(y.e)(r)||Object(y.o)(r)||Object(y.v)(r)||Array.isArray(r))!function(e,t,r){r.wrap&&"function"==typeof t&&(t=function(i){function e(){for(var e=[],t=0,r=arguments.length;t<r;t++){var n=arguments[t];e[t]=n&&n.valueOf()}return i.apply(u,e)}i.transform&&(e.transform=i.transform);return e}(t));!function(e){return"function"==typeof e&&"string"==typeof e.signature}(t)||(t=s(e,function(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}({},t.signature,t)));if(p(u[e])&&p(t))return t=r.override?s(e,t.signatures):s(u[e],t),u[e]=t,delete c[e],f(e,t),u.emit("import",e,function(){return t});if(void 0===u[e]||r.override)return u[e]=t,delete c[e],f(e,t),u.emit("import",e,function(){return t});if(!r.silent)throw new Error('Cannot import "'+e+'": already exists')}(i,a,o);else if(!o.silent)throw new TypeError("Factory, Object, or Array expected")}}}var m={epsilon:1e-12,matrix:"Matrix",number:"number",precision:64,predictable:!1,randomSeed:null},h=["Matrix","Array"],w=["number","BigNumber","Fraction"];function N(e,t,r){var n,i;void 0!==e[t]&&(n=r,i=e[t],-1===n.indexOf(i))&&console.warn('Warning: Unknown value "'+e[t]+'" for configuration option "'+t+'". Available options: '+r.map(function(e){return JSON.stringify(e)}).join(", ")+".")}var O=r(6),M=r(9);function j(){return(j=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function E(e,t){var r=j({},m,t);if("function"!=typeof Object.create)throw new Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");var n,i,a,o,s=(n={isNumber:y.y,isComplex:y.j,isBigNumber:y.e,isFraction:y.o,isUnit:y.L,isString:y.I,isArray:y.b,isMatrix:y.v,isCollection:y.i,isDenseMatrix:y.n,isSparseMatrix:y.H,isRange:y.D,isIndex:y.t,isBoolean:y.g,isResultSet:y.G,isHelp:y.s,isFunction:y.p,isDate:y.m,isRegExp:y.F,isObject:y.z,isNull:y.x,isUndefined:y.K,isAccessorNode:y.a,isArrayNode:y.c,isAssignmentNode:y.d,isBlockNode:y.f,isConditionalNode:y.k,isConstantNode:y.l,isFunctionAssignmentNode:y.q,isFunctionNode:y.r,isIndexNode:y.u,isNode:y.w,isObjectNode:y.A,isOperatorNode:y.B,isParenthesisNode:y.C,isRangeNode:y.E,isSymbolNode:y.J,isChain:y.h},i=new l.a,n.on=i.on.bind(i),n.off=i.off.bind(i),n.once=i.once.bind(i),n.emit=i.emit.bind(i),n);function u(e){if(e){var t=Object(d.i)(a,d.a);N(e,"matrix",h),N(e,"number",w),Object(d.b)(a,e);var r=Object(d.i)(a,d.a),n=Object(d.i)(e,d.a);return o("config",r,t,n),r}return Object(d.i)(a,d.a)}s.config=(a=r,o=s.emit,u.MATRIX_OPTIONS=h,u.NUMBER_OPTIONS=w,Object.keys(m).forEach(function(e){Object.defineProperty(u,e,{get:function(){return a[e]},enumerable:!0,configurable:!0})}),u),s.expression={transform:{},mathWithTransform:{config:s.config}};var c={};var f=p(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return s.typed.apply(s.typed,t)},0,s,c);return s.import=f,s.on("config",function(){Object(d.k)(c).forEach(function(e){e&&e.meta&&e.meta.recreateOnConfigChange&&f(e,{override:!0})})}),s.create=E.bind(null,e),s.factory=g.a,s.import(Object(d.k)(Object(d.c)(e))),s.ArgumentsError=b.a,s.DimensionError=O.a,s.IndexError=M.a,s}}],i.c=n,i.d=function(e,t,r){i.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},i.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(i.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var n in t)i.d(r,n,function(e){return t[e]}.bind(null,n));return r},i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t),t},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.p="",i(i.s=18);function i(e){if(n[e])return n[e].exports;var t=n[e]={i:e,l:!1,exports:{}};return r[e].call(t.exports,t,t.exports,i),t.l=!0,t.exports}var r,n});
//# sourceMappingURL=math.min.map
/**
 * Swiper 4.5.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: October 16, 2019
 */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self).Swiper=t()}(this,function(){"use strict";var m="undefined"==typeof document?{body:{},addEventListener:function(){},removeEventListener:function(){},activeElement:{blur:function(){},nodeName:""},querySelector:function(){return null},querySelectorAll:function(){return[]},getElementById:function(){return null},createEvent:function(){return{initEvent:function(){}}},createElement:function(){return{children:[],childNodes:[],style:{},setAttribute:function(){},getElementsByTagName:function(){return[]}}},location:{hash:""}}:document,ee="undefined"==typeof window?{document:m,navigator:{userAgent:""},location:{},history:{},CustomEvent:function(){return this},addEventListener:function(){},removeEventListener:function(){},getComputedStyle:function(){return{getPropertyValue:function(){return""}}},Image:function(){},Date:function(){},screen:{},setTimeout:function(){},clearTimeout:function(){}}:window,l=function(e){for(var t=0;t<e.length;t+=1)this[t]=e[t];return this.length=e.length,this};function L(e,t){var a=[],i=0;if(e&&!t&&e instanceof l)return e;if(e)if("string"==typeof e){var s,r,n=e.trim();if(0<=n.indexOf("<")&&0<=n.indexOf(">")){var o="div";for(0===n.indexOf("<li")&&(o="ul"),0===n.indexOf("<tr")&&(o="tbody"),0!==n.indexOf("<td")&&0!==n.indexOf("<th")||(o="tr"),0===n.indexOf("<tbody")&&(o="table"),0===n.indexOf("<option")&&(o="select"),(r=m.createElement(o)).innerHTML=n,i=0;i<r.childNodes.length;i+=1)a.push(r.childNodes[i])}else for(s=t||"#"!==e[0]||e.match(/[ .<>:~]/)?(t||m).querySelectorAll(e.trim()):[m.getElementById(e.trim().split("#")[1])],i=0;i<s.length;i+=1)s[i]&&a.push(s[i])}else if(e.nodeType||e===ee||e===m)a.push(e);else if(0<e.length&&e[0].nodeType)for(i=0;i<e.length;i+=1)a.push(e[i]);return new l(a)}function r(e){for(var t=[],a=0;a<e.length;a+=1)-1===t.indexOf(e[a])&&t.push(e[a]);return t}L.fn=l.prototype,L.Class=l,L.Dom7=l;var t={addClass:function(e){if(void 0===e)return this;for(var t=e.split(" "),a=0;a<t.length;a+=1)for(var i=0;i<this.length;i+=1)void 0!==this[i]&&void 0!==this[i].classList&&this[i].classList.add(t[a]);return this},removeClass:function(e){for(var t=e.split(" "),a=0;a<t.length;a+=1)for(var i=0;i<this.length;i+=1)void 0!==this[i]&&void 0!==this[i].classList&&this[i].classList.remove(t[a]);return this},hasClass:function(e){return!!this[0]&&this[0].classList.contains(e)},toggleClass:function(e){for(var t=e.split(" "),a=0;a<t.length;a+=1)for(var i=0;i<this.length;i+=1)void 0!==this[i]&&void 0!==this[i].classList&&this[i].classList.toggle(t[a]);return this},attr:function(e,t){var a=arguments;if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(var i=0;i<this.length;i+=1)if(2===a.length)this[i].setAttribute(e,t);else for(var s in e)this[i][s]=e[s],this[i].setAttribute(s,e[s]);return this},removeAttr:function(e){for(var t=0;t<this.length;t+=1)this[t].removeAttribute(e);return this},data:function(e,t){var a;if(void 0!==t){for(var i=0;i<this.length;i+=1)(a=this[i]).dom7ElementDataStorage||(a.dom7ElementDataStorage={}),a.dom7ElementDataStorage[e]=t;return this}if(a=this[0]){if(a.dom7ElementDataStorage&&e in a.dom7ElementDataStorage)return a.dom7ElementDataStorage[e];var s=a.getAttribute("data-"+e);return s||void 0}},transform:function(e){for(var t=0;t<this.length;t+=1){var a=this[t].style;a.webkitTransform=e,a.transform=e}return this},transition:function(e){"string"!=typeof e&&(e+="ms");for(var t=0;t<this.length;t+=1){var a=this[t].style;a.webkitTransitionDuration=e,a.transitionDuration=e}return this},on:function(){for(var e,t=[],a=arguments.length;a--;)t[a]=arguments[a];var i=t[0],r=t[1],n=t[2],s=t[3];function o(e){var t=e.target;if(t){var a=e.target.dom7EventData||[];if(a.indexOf(e)<0&&a.unshift(e),L(t).is(r))n.apply(t,a);else for(var i=L(t).parents(),s=0;s<i.length;s+=1)L(i[s]).is(r)&&n.apply(i[s],a)}}function l(e){var t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),n.apply(this,t)}"function"==typeof t[1]&&(i=(e=t)[0],n=e[1],s=e[2],r=void 0),s=s||!1;for(var d,p=i.split(" "),c=0;c<this.length;c+=1){var u=this[c];if(r)for(d=0;d<p.length;d+=1){var h=p[d];u.dom7LiveListeners||(u.dom7LiveListeners={}),u.dom7LiveListeners[h]||(u.dom7LiveListeners[h]=[]),u.dom7LiveListeners[h].push({listener:n,proxyListener:o}),u.addEventListener(h,o,s)}else for(d=0;d<p.length;d+=1){var v=p[d];u.dom7Listeners||(u.dom7Listeners={}),u.dom7Listeners[v]||(u.dom7Listeners[v]=[]),u.dom7Listeners[v].push({listener:n,proxyListener:l}),u.addEventListener(v,l,s)}}return this},off:function(){for(var e,t=[],a=arguments.length;a--;)t[a]=arguments[a];var i=t[0],s=t[1],r=t[2],n=t[3];"function"==typeof t[1]&&(i=(e=t)[0],r=e[1],n=e[2],s=void 0),n=n||!1;for(var o=i.split(" "),l=0;l<o.length;l+=1)for(var d=o[l],p=0;p<this.length;p+=1){var c=this[p],u=void 0;if(!s&&c.dom7Listeners?u=c.dom7Listeners[d]:s&&c.dom7LiveListeners&&(u=c.dom7LiveListeners[d]),u&&u.length)for(var h=u.length-1;0<=h;h-=1){var v=u[h];r&&v.listener===r?(c.removeEventListener(d,v.proxyListener,n),u.splice(h,1)):r&&v.listener&&v.listener.dom7proxy&&v.listener.dom7proxy===r?(c.removeEventListener(d,v.proxyListener,n),u.splice(h,1)):r||(c.removeEventListener(d,v.proxyListener,n),u.splice(h,1))}}return this},trigger:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];for(var a=e[0].split(" "),i=e[1],s=0;s<a.length;s+=1)for(var r=a[s],n=0;n<this.length;n+=1){var o=this[n],l=void 0;try{l=new ee.CustomEvent(r,{detail:i,bubbles:!0,cancelable:!0})}catch(e){(l=m.createEvent("Event")).initEvent(r,!0,!0),l.detail=i}o.dom7EventData=e.filter(function(e,t){return 0<t}),o.dispatchEvent(l),o.dom7EventData=[],delete o.dom7EventData}return this},transitionEnd:function(t){var a,i=["webkitTransitionEnd","transitionend"],s=this;function r(e){if(e.target===this)for(t.call(this,e),a=0;a<i.length;a+=1)s.off(i[a],r)}if(t)for(a=0;a<i.length;a+=1)s.on(i[a],r);return this},outerWidth:function(e){if(0<this.length){if(e){var t=this.styles();return this[0].offsetWidth+parseFloat(t.getPropertyValue("margin-right"))+parseFloat(t.getPropertyValue("margin-left"))}return this[0].offsetWidth}return null},outerHeight:function(e){if(0<this.length){if(e){var t=this.styles();return this[0].offsetHeight+parseFloat(t.getPropertyValue("margin-top"))+parseFloat(t.getPropertyValue("margin-bottom"))}return this[0].offsetHeight}return null},offset:function(){if(0<this.length){var e=this[0],t=e.getBoundingClientRect(),a=m.body,i=e.clientTop||a.clientTop||0,s=e.clientLeft||a.clientLeft||0,r=e===ee?ee.scrollY:e.scrollTop,n=e===ee?ee.scrollX:e.scrollLeft;return{top:t.top+r-i,left:t.left+n-s}}return null},css:function(e,t){var a;if(1===arguments.length){if("string"!=typeof e){for(a=0;a<this.length;a+=1)for(var i in e)this[a].style[i]=e[i];return this}if(this[0])return ee.getComputedStyle(this[0],null).getPropertyValue(e)}if(2!==arguments.length||"string"!=typeof e)return this;for(a=0;a<this.length;a+=1)this[a].style[e]=t;return this},each:function(e){if(!e)return this;for(var t=0;t<this.length;t+=1)if(!1===e.call(this[t],t,this[t]))return this;return this},html:function(e){if(void 0===e)return this[0]?this[0].innerHTML:void 0;for(var t=0;t<this.length;t+=1)this[t].innerHTML=e;return this},text:function(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(var t=0;t<this.length;t+=1)this[t].textContent=e;return this},is:function(e){var t,a,i=this[0];if(!i||void 0===e)return!1;if("string"==typeof e){if(i.matches)return i.matches(e);if(i.webkitMatchesSelector)return i.webkitMatchesSelector(e);if(i.msMatchesSelector)return i.msMatchesSelector(e);for(t=L(e),a=0;a<t.length;a+=1)if(t[a]===i)return!0;return!1}if(e===m)return i===m;if(e===ee)return i===ee;if(e.nodeType||e instanceof l){for(t=e.nodeType?[e]:e,a=0;a<t.length;a+=1)if(t[a]===i)return!0;return!1}return!1},index:function(){var e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);)1===t.nodeType&&(e+=1);return e}},eq:function(e){if(void 0===e)return this;var t,a=this.length;return new l(a-1<e?[]:e<0?(t=a+e)<0?[]:[this[t]]:[this[e]])},append:function(){for(var e,t=[],a=arguments.length;a--;)t[a]=arguments[a];for(var i=0;i<t.length;i+=1){e=t[i];for(var s=0;s<this.length;s+=1)if("string"==typeof e){var r=m.createElement("div");for(r.innerHTML=e;r.firstChild;)this[s].appendChild(r.firstChild)}else if(e instanceof l)for(var n=0;n<e.length;n+=1)this[s].appendChild(e[n]);else this[s].appendChild(e)}return this},prepend:function(e){var t,a;for(t=0;t<this.length;t+=1)if("string"==typeof e){var i=m.createElement("div");for(i.innerHTML=e,a=i.childNodes.length-1;0<=a;a-=1)this[t].insertBefore(i.childNodes[a],this[t].childNodes[0])}else if(e instanceof l)for(a=0;a<e.length;a+=1)this[t].insertBefore(e[a],this[t].childNodes[0]);else this[t].insertBefore(e,this[t].childNodes[0]);return this},next:function(e){return 0<this.length?e?this[0].nextElementSibling&&L(this[0].nextElementSibling).is(e)?new l([this[0].nextElementSibling]):new l([]):this[0].nextElementSibling?new l([this[0].nextElementSibling]):new l([]):new l([])},nextAll:function(e){var t=[],a=this[0];if(!a)return new l([]);for(;a.nextElementSibling;){var i=a.nextElementSibling;e?L(i).is(e)&&t.push(i):t.push(i),a=i}return new l(t)},prev:function(e){if(0<this.length){var t=this[0];return e?t.previousElementSibling&&L(t.previousElementSibling).is(e)?new l([t.previousElementSibling]):new l([]):t.previousElementSibling?new l([t.previousElementSibling]):new l([])}return new l([])},prevAll:function(e){var t=[],a=this[0];if(!a)return new l([]);for(;a.previousElementSibling;){var i=a.previousElementSibling;e?L(i).is(e)&&t.push(i):t.push(i),a=i}return new l(t)},parent:function(e){for(var t=[],a=0;a<this.length;a+=1)null!==this[a].parentNode&&(e?L(this[a].parentNode).is(e)&&t.push(this[a].parentNode):t.push(this[a].parentNode));return L(r(t))},parents:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].parentNode;i;)e?L(i).is(e)&&t.push(i):t.push(i),i=i.parentNode;return L(r(t))},closest:function(e){var t=this;return void 0===e?new l([]):(t.is(e)||(t=t.parents(e).eq(0)),t)},find:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].querySelectorAll(e),s=0;s<i.length;s+=1)t.push(i[s]);return new l(t)},children:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].childNodes,s=0;s<i.length;s+=1)e?1===i[s].nodeType&&L(i[s]).is(e)&&t.push(i[s]):1===i[s].nodeType&&t.push(i[s]);return new l(r(t))},remove:function(){for(var e=0;e<this.length;e+=1)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this},add:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];var a,i;for(a=0;a<e.length;a+=1){var s=L(e[a]);for(i=0;i<s.length;i+=1)this[this.length]=s[i],this.length+=1}return this},styles:function(){return this[0]?ee.getComputedStyle(this[0],null):{}}};Object.keys(t).forEach(function(e){L.fn[e]=L.fn[e]||t[e]});function e(e){void 0===e&&(e={});var t=this;t.params=e,t.eventsListeners={},t.params&&t.params.on&&Object.keys(t.params.on).forEach(function(e){t.on(e,t.params.on[e])})}var a,i,s,n,te={deleteProps:function(e){var t=e;Object.keys(t).forEach(function(e){try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}})},nextTick:function(e,t){return void 0===t&&(t=0),setTimeout(e,t)},now:function(){return Date.now()},getTranslate:function(e,t){var a,i,s;void 0===t&&(t="x");var r=ee.getComputedStyle(e,null);return ee.WebKitCSSMatrix?(6<(i=r.transform||r.webkitTransform).split(",").length&&(i=i.split(", ").map(function(e){return e.replace(",",".")}).join(", ")),s=new ee.WebKitCSSMatrix("none"===i?"":i)):a=(s=r.MozTransform||r.OTransform||r.MsTransform||r.msTransform||r.transform||r.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,")).toString().split(","),"x"===t&&(i=ee.WebKitCSSMatrix?s.m41:16===a.length?parseFloat(a[12]):parseFloat(a[4])),"y"===t&&(i=ee.WebKitCSSMatrix?s.m42:16===a.length?parseFloat(a[13]):parseFloat(a[5])),i||0},parseUrlQuery:function(e){var t,a,i,s,r={},n=e||ee.location.href;if("string"==typeof n&&n.length)for(s=(a=(n=-1<n.indexOf("?")?n.replace(/\S*\?/,""):"").split("&").filter(function(e){return""!==e})).length,t=0;t<s;t+=1)i=a[t].replace(/#\S+/g,"").split("="),r[decodeURIComponent(i[0])]=void 0===i[1]?void 0:decodeURIComponent(i[1])||"";return r},isObject:function(e){return"object"==typeof e&&null!==e&&e.constructor&&e.constructor===Object},extend:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];for(var a=Object(e[0]),i=1;i<e.length;i+=1){var s=e[i];if(null!=s)for(var r=Object.keys(Object(s)),n=0,o=r.length;n<o;n+=1){var l=r[n],d=Object.getOwnPropertyDescriptor(s,l);void 0!==d&&d.enumerable&&(te.isObject(a[l])&&te.isObject(s[l])?te.extend(a[l],s[l]):!te.isObject(a[l])&&te.isObject(s[l])?(a[l]={},te.extend(a[l],s[l])):a[l]=s[l])}}return a}},ae=(s=m.createElement("div"),{touch:ee.Modernizr&&!0===ee.Modernizr.touch||!!(0<ee.navigator.maxTouchPoints||"ontouchstart"in ee||ee.DocumentTouch&&m instanceof ee.DocumentTouch),pointerEvents:!!(ee.navigator.pointerEnabled||ee.PointerEvent||"maxTouchPoints"in ee.navigator&&0<ee.navigator.maxTouchPoints),prefixedPointerEvents:!!ee.navigator.msPointerEnabled,transition:(i=s.style,"transition"in i||"webkitTransition"in i||"MozTransition"in i),transforms3d:ee.Modernizr&&!0===ee.Modernizr.csstransforms3d||(a=s.style,"webkitPerspective"in a||"MozPerspective"in a||"OPerspective"in a||"MsPerspective"in a||"perspective"in a),flexbox:function(){for(var e=s.style,t="alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "),a=0;a<t.length;a+=1)if(t[a]in e)return!0;return!1}(),observer:"MutationObserver"in ee||"WebkitMutationObserver"in ee,passiveListener:function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});ee.addEventListener("testPassiveListener",null,t)}catch(e){}return e}(),gestures:"ongesturestart"in ee}),ie={isIE:!!ee.navigator.userAgent.match(/Trident/g)||!!ee.navigator.userAgent.match(/MSIE/g),isEdge:!!ee.navigator.userAgent.match(/Edge/g),isSafari:(n=ee.navigator.userAgent.toLowerCase(),0<=n.indexOf("safari")&&n.indexOf("chrome")<0&&n.indexOf("android")<0),isUiWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ee.navigator.userAgent)},o={components:{configurable:!0}};e.prototype.on=function(e,t,a){var i=this;if("function"!=typeof t)return i;var s=a?"unshift":"push";return e.split(" ").forEach(function(e){i.eventsListeners[e]||(i.eventsListeners[e]=[]),i.eventsListeners[e][s](t)}),i},e.prototype.once=function(a,i,e){var s=this;if("function"!=typeof i)return s;function r(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];i.apply(s,e),s.off(a,r),r.f7proxy&&delete r.f7proxy}return r.f7proxy=i,s.on(a,r,e)},e.prototype.off=function(e,i){var s=this;return s.eventsListeners&&e.split(" ").forEach(function(a){void 0===i?s.eventsListeners[a]=[]:s.eventsListeners[a]&&s.eventsListeners[a].length&&s.eventsListeners[a].forEach(function(e,t){(e===i||e.f7proxy&&e.f7proxy===i)&&s.eventsListeners[a].splice(t,1)})}),s},e.prototype.emit=function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];var a,i,s,r=this;return r.eventsListeners&&(s="string"==typeof e[0]||Array.isArray(e[0])?(a=e[0],i=e.slice(1,e.length),r):(a=e[0].events,i=e[0].data,e[0].context||r),(Array.isArray(a)?a:a.split(" ")).forEach(function(e){if(r.eventsListeners&&r.eventsListeners[e]){var t=[];r.eventsListeners[e].forEach(function(e){t.push(e)}),t.forEach(function(e){e.apply(s,i)})}})),r},e.prototype.useModulesParams=function(a){var i=this;i.modules&&Object.keys(i.modules).forEach(function(e){var t=i.modules[e];t.params&&te.extend(a,t.params)})},e.prototype.useModules=function(i){void 0===i&&(i={});var s=this;s.modules&&Object.keys(s.modules).forEach(function(e){var a=s.modules[e],t=i[e]||{};a.instance&&Object.keys(a.instance).forEach(function(e){var t=a.instance[e];s[e]="function"==typeof t?t.bind(s):t}),a.on&&s.on&&Object.keys(a.on).forEach(function(e){s.on(e,a.on[e])}),a.create&&a.create.bind(s)(t)})},o.components.set=function(e){this.use&&this.use(e)},e.installModule=function(t){for(var e=[],a=arguments.length-1;0<a--;)e[a]=arguments[a+1];var i=this;i.prototype.modules||(i.prototype.modules={});var s=t.name||Object.keys(i.prototype.modules).length+"_"+te.now();return(i.prototype.modules[s]=t).proto&&Object.keys(t.proto).forEach(function(e){i.prototype[e]=t.proto[e]}),t.static&&Object.keys(t.static).forEach(function(e){i[e]=t.static[e]}),t.install&&t.install.apply(i,e),i},e.use=function(e){for(var t=[],a=arguments.length-1;0<a--;)t[a]=arguments[a+1];var i=this;return Array.isArray(e)?(e.forEach(function(e){return i.installModule(e)}),i):i.installModule.apply(i,[e].concat(t))},Object.defineProperties(e,o);var d={updateSize:function(){var e,t,a=this,i=a.$el;e=void 0!==a.params.width?a.params.width:i[0].clientWidth,t=void 0!==a.params.height?a.params.height:i[0].clientHeight,0===e&&a.isHorizontal()||0===t&&a.isVertical()||(e=e-parseInt(i.css("padding-left"),10)-parseInt(i.css("padding-right"),10),t=t-parseInt(i.css("padding-top"),10)-parseInt(i.css("padding-bottom"),10),te.extend(a,{width:e,height:t,size:a.isHorizontal()?e:t}))},updateSlides:function(){var e=this,t=e.params,a=e.$wrapperEl,i=e.size,s=e.rtlTranslate,r=e.wrongRTL,n=e.virtual&&t.virtual.enabled,o=n?e.virtual.slides.length:e.slides.length,l=a.children("."+e.params.slideClass),d=n?e.virtual.slides.length:l.length,p=[],c=[],u=[],h=t.slidesOffsetBefore;"function"==typeof h&&(h=t.slidesOffsetBefore.call(e));var v=t.slidesOffsetAfter;"function"==typeof v&&(v=t.slidesOffsetAfter.call(e));var f=e.snapGrid.length,m=e.snapGrid.length,g=t.spaceBetween,b=-h,w=0,y=0;if(void 0!==i){var x,T;"string"==typeof g&&0<=g.indexOf("%")&&(g=parseFloat(g.replace("%",""))/100*i),e.virtualSize=-g,s?l.css({marginLeft:"",marginTop:""}):l.css({marginRight:"",marginBottom:""}),1<t.slidesPerColumn&&(x=Math.floor(d/t.slidesPerColumn)===d/e.params.slidesPerColumn?d:Math.ceil(d/t.slidesPerColumn)*t.slidesPerColumn,"auto"!==t.slidesPerView&&"row"===t.slidesPerColumnFill&&(x=Math.max(x,t.slidesPerView*t.slidesPerColumn)));for(var E,S=t.slidesPerColumn,C=x/S,M=Math.floor(d/t.slidesPerColumn),P=0;P<d;P+=1){T=0;var k=l.eq(P);if(1<t.slidesPerColumn){var z=void 0,$=void 0,L=void 0;if("column"===t.slidesPerColumnFill||"row"===t.slidesPerColumnFill&&1<t.slidesPerGroup){if("column"===t.slidesPerColumnFill)L=P-($=Math.floor(P/S))*S,(M<$||$===M&&L===S-1)&&S<=(L+=1)&&(L=0,$+=1);else{var I=Math.floor(P/t.slidesPerGroup);$=P-(L=Math.floor(P/t.slidesPerView)-I*t.slidesPerColumn)*t.slidesPerView-I*t.slidesPerView}z=$+L*x/S,k.css({"-webkit-box-ordinal-group":z,"-moz-box-ordinal-group":z,"-ms-flex-order":z,"-webkit-order":z,order:z})}else $=P-(L=Math.floor(P/C))*C;k.css("margin-"+(e.isHorizontal()?"top":"left"),0!==L&&t.spaceBetween&&t.spaceBetween+"px").attr("data-swiper-column",$).attr("data-swiper-row",L)}if("none"!==k.css("display")){if("auto"===t.slidesPerView){var D=ee.getComputedStyle(k[0],null),O=k[0].style.transform,A=k[0].style.webkitTransform;if(O&&(k[0].style.transform="none"),A&&(k[0].style.webkitTransform="none"),t.roundLengths)T=e.isHorizontal()?k.outerWidth(!0):k.outerHeight(!0);else if(e.isHorizontal()){var H=parseFloat(D.getPropertyValue("width")),G=parseFloat(D.getPropertyValue("padding-left")),N=parseFloat(D.getPropertyValue("padding-right")),B=parseFloat(D.getPropertyValue("margin-left")),X=parseFloat(D.getPropertyValue("margin-right")),V=D.getPropertyValue("box-sizing");T=V&&"border-box"===V&&!ie.isIE?H+B+X:H+G+N+B+X}else{var Y=parseFloat(D.getPropertyValue("height")),F=parseFloat(D.getPropertyValue("padding-top")),R=parseFloat(D.getPropertyValue("padding-bottom")),q=parseFloat(D.getPropertyValue("margin-top")),W=parseFloat(D.getPropertyValue("margin-bottom")),j=D.getPropertyValue("box-sizing");T=j&&"border-box"===j&&!ie.isIE?Y+q+W:Y+F+R+q+W}O&&(k[0].style.transform=O),A&&(k[0].style.webkitTransform=A),t.roundLengths&&(T=Math.floor(T))}else T=(i-(t.slidesPerView-1)*g)/t.slidesPerView,t.roundLengths&&(T=Math.floor(T)),l[P]&&(e.isHorizontal()?l[P].style.width=T+"px":l[P].style.height=T+"px");l[P]&&(l[P].swiperSlideSize=T),u.push(T),t.centeredSlides?(b=b+T/2+w/2+g,0===w&&0!==P&&(b=b-i/2-g),0===P&&(b=b-i/2-g),Math.abs(b)<.001&&(b=0),t.roundLengths&&(b=Math.floor(b)),y%t.slidesPerGroup==0&&p.push(b),c.push(b)):(t.roundLengths&&(b=Math.floor(b)),y%t.slidesPerGroup==0&&p.push(b),c.push(b),b=b+T+g),e.virtualSize+=T+g,w=T,y+=1}}if(e.virtualSize=Math.max(e.virtualSize,i)+v,s&&r&&("slide"===t.effect||"coverflow"===t.effect)&&a.css({width:e.virtualSize+t.spaceBetween+"px"}),ae.flexbox&&!t.setWrapperSize||(e.isHorizontal()?a.css({width:e.virtualSize+t.spaceBetween+"px"}):a.css({height:e.virtualSize+t.spaceBetween+"px"})),1<t.slidesPerColumn&&(e.virtualSize=(T+t.spaceBetween)*x,e.virtualSize=Math.ceil(e.virtualSize/t.slidesPerColumn)-t.spaceBetween,e.isHorizontal()?a.css({width:e.virtualSize+t.spaceBetween+"px"}):a.css({height:e.virtualSize+t.spaceBetween+"px"}),t.centeredSlides)){E=[];for(var U=0;U<p.length;U+=1){var K=p[U];t.roundLengths&&(K=Math.floor(K)),p[U]<e.virtualSize+p[0]&&E.push(K)}p=E}if(!t.centeredSlides){E=[];for(var _=0;_<p.length;_+=1){var Z=p[_];t.roundLengths&&(Z=Math.floor(Z)),p[_]<=e.virtualSize-i&&E.push(Z)}p=E,1<Math.floor(e.virtualSize-i)-Math.floor(p[p.length-1])&&p.push(e.virtualSize-i)}if(0===p.length&&(p=[0]),0!==t.spaceBetween&&(e.isHorizontal()?s?l.css({marginLeft:g+"px"}):l.css({marginRight:g+"px"}):l.css({marginBottom:g+"px"})),t.centerInsufficientSlides){var Q=0;if(u.forEach(function(e){Q+=e+(t.spaceBetween?t.spaceBetween:0)}),(Q-=t.spaceBetween)<i){var J=(i-Q)/2;p.forEach(function(e,t){p[t]=e-J}),c.forEach(function(e,t){c[t]=e+J})}}te.extend(e,{slides:l,snapGrid:p,slidesGrid:c,slidesSizesGrid:u}),d!==o&&e.emit("slidesLengthChange"),p.length!==f&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),c.length!==m&&e.emit("slidesGridLengthChange"),(t.watchSlidesProgress||t.watchSlidesVisibility)&&e.updateSlidesOffset()}},updateAutoHeight:function(e){var t,a=this,i=[],s=0;if("number"==typeof e?a.setTransition(e):!0===e&&a.setTransition(a.params.speed),"auto"!==a.params.slidesPerView&&1<a.params.slidesPerView)for(t=0;t<Math.ceil(a.params.slidesPerView);t+=1){var r=a.activeIndex+t;if(r>a.slides.length)break;i.push(a.slides.eq(r)[0])}else i.push(a.slides.eq(a.activeIndex)[0]);for(t=0;t<i.length;t+=1)if(void 0!==i[t]){var n=i[t].offsetHeight;s=s<n?n:s}s&&a.$wrapperEl.css("height",s+"px")},updateSlidesOffset:function(){for(var e=this.slides,t=0;t<e.length;t+=1)e[t].swiperSlideOffset=this.isHorizontal()?e[t].offsetLeft:e[t].offsetTop},updateSlidesProgress:function(e){var t=this,a=t.params;void 0===e&&(e=t&&t.translate||0);var i=t.slides,s=t.rtlTranslate;if(0!==i.length){void 0===i[0].swiperSlideOffset&&t.updateSlidesOffset();var r=-e;s&&(r=e),i.removeClass(a.slideVisibleClass),t.visibleSlidesIndexes=[],t.visibleSlides=[];for(var n=0;n<i.length;n+=1){var o=i[n],l=(r+(a.centeredSlides?t.minTranslate():0)-o.swiperSlideOffset)/(o.swiperSlideSize+a.spaceBetween);if(a.watchSlidesVisibility){var d=-(r-o.swiperSlideOffset),p=d+t.slidesSizesGrid[n];(0<=d&&d<t.size-1||1<p&&p<=t.size||d<=0&&p>=t.size)&&(t.visibleSlides.push(o),t.visibleSlidesIndexes.push(n),i.eq(n).addClass(a.slideVisibleClass))}o.progress=s?-l:l}t.visibleSlides=L(t.visibleSlides)}},updateProgress:function(e){var t=this,a=t.params;if(void 0===e){var i=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*i||0}var s=t.maxTranslate()-t.minTranslate(),r=t.progress,n=t.isBeginning,o=t.isEnd,l=n,d=o;o=0==s?n=!(r=0):(n=(r=(e-t.minTranslate())/s)<=0,1<=r),te.extend(t,{progress:r,isBeginning:n,isEnd:o}),(a.watchSlidesProgress||a.watchSlidesVisibility)&&t.updateSlidesProgress(e),n&&!l&&t.emit("reachBeginning toEdge"),o&&!d&&t.emit("reachEnd toEdge"),(l&&!n||d&&!o)&&t.emit("fromEdge"),t.emit("progress",r)},updateSlidesClasses:function(){var e,t=this,a=t.slides,i=t.params,s=t.$wrapperEl,r=t.activeIndex,n=t.realIndex,o=t.virtual&&i.virtual.enabled;a.removeClass(i.slideActiveClass+" "+i.slideNextClass+" "+i.slidePrevClass+" "+i.slideDuplicateActiveClass+" "+i.slideDuplicateNextClass+" "+i.slideDuplicatePrevClass),(e=o?t.$wrapperEl.find("."+i.slideClass+'[data-swiper-slide-index="'+r+'"]'):a.eq(r)).addClass(i.slideActiveClass),i.loop&&(e.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+n+'"]').addClass(i.slideDuplicateActiveClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+n+'"]').addClass(i.slideDuplicateActiveClass));var l=e.nextAll("."+i.slideClass).eq(0).addClass(i.slideNextClass);i.loop&&0===l.length&&(l=a.eq(0)).addClass(i.slideNextClass);var d=e.prevAll("."+i.slideClass).eq(0).addClass(i.slidePrevClass);i.loop&&0===d.length&&(d=a.eq(-1)).addClass(i.slidePrevClass),i.loop&&(l.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+l.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+l.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass),d.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+d.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+d.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass))},updateActiveIndex:function(e){var t,a=this,i=a.rtlTranslate?a.translate:-a.translate,s=a.slidesGrid,r=a.snapGrid,n=a.params,o=a.activeIndex,l=a.realIndex,d=a.snapIndex,p=e;if(void 0===p){for(var c=0;c<s.length;c+=1)void 0!==s[c+1]?i>=s[c]&&i<s[c+1]-(s[c+1]-s[c])/2?p=c:i>=s[c]&&i<s[c+1]&&(p=c+1):i>=s[c]&&(p=c);n.normalizeSlideIndex&&(p<0||void 0===p)&&(p=0)}if((t=0<=r.indexOf(i)?r.indexOf(i):Math.floor(p/n.slidesPerGroup))>=r.length&&(t=r.length-1),p!==o){var u=parseInt(a.slides.eq(p).attr("data-swiper-slide-index")||p,10);te.extend(a,{snapIndex:t,realIndex:u,previousIndex:o,activeIndex:p}),a.emit("activeIndexChange"),a.emit("snapIndexChange"),l!==u&&a.emit("realIndexChange"),(a.initialized||a.runCallbacksOnInit)&&a.emit("slideChange")}else t!==d&&(a.snapIndex=t,a.emit("snapIndexChange"))},updateClickedSlide:function(e){var t=this,a=t.params,i=L(e.target).closest("."+a.slideClass)[0],s=!1;if(i)for(var r=0;r<t.slides.length;r+=1)t.slides[r]===i&&(s=!0);if(!i||!s)return t.clickedSlide=void 0,void(t.clickedIndex=void 0);t.clickedSlide=i,t.virtual&&t.params.virtual.enabled?t.clickedIndex=parseInt(L(i).attr("data-swiper-slide-index"),10):t.clickedIndex=L(i).index(),a.slideToClickedSlide&&void 0!==t.clickedIndex&&t.clickedIndex!==t.activeIndex&&t.slideToClickedSlide()}};var p={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");var t=this.params,a=this.rtlTranslate,i=this.translate,s=this.$wrapperEl;if(t.virtualTranslate)return a?-i:i;var r=te.getTranslate(s[0],e);return a&&(r=-r),r||0},setTranslate:function(e,t){var a=this,i=a.rtlTranslate,s=a.params,r=a.$wrapperEl,n=a.progress,o=0,l=0;a.isHorizontal()?o=i?-e:e:l=e,s.roundLengths&&(o=Math.floor(o),l=Math.floor(l)),s.virtualTranslate||(ae.transforms3d?r.transform("translate3d("+o+"px, "+l+"px, 0px)"):r.transform("translate("+o+"px, "+l+"px)")),a.previousTranslate=a.translate,a.translate=a.isHorizontal()?o:l;var d=a.maxTranslate()-a.minTranslate();(0==d?0:(e-a.minTranslate())/d)!==n&&a.updateProgress(e),a.emit("setTranslate",a.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]}};var c={setTransition:function(e,t){this.$wrapperEl.transition(e),this.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);var a=this,i=a.activeIndex,s=a.params,r=a.previousIndex;s.autoHeight&&a.updateAutoHeight();var n=t;if(n=n||(r<i?"next":i<r?"prev":"reset"),a.emit("transitionStart"),e&&i!==r){if("reset"===n)return void a.emit("slideResetTransitionStart");a.emit("slideChangeTransitionStart"),"next"===n?a.emit("slideNextTransitionStart"):a.emit("slidePrevTransitionStart")}},transitionEnd:function(e,t){void 0===e&&(e=!0);var a=this,i=a.activeIndex,s=a.previousIndex;a.animating=!1,a.setTransition(0);var r=t;if(r=r||(s<i?"next":i<s?"prev":"reset"),a.emit("transitionEnd"),e&&i!==s){if("reset"===r)return void a.emit("slideResetTransitionEnd");a.emit("slideChangeTransitionEnd"),"next"===r?a.emit("slideNextTransitionEnd"):a.emit("slidePrevTransitionEnd")}}};var u={slideTo:function(e,t,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0);var s=this,r=e;r<0&&(r=0);var n=s.params,o=s.snapGrid,l=s.slidesGrid,d=s.previousIndex,p=s.activeIndex,c=s.rtlTranslate;if(s.animating&&n.preventInteractionOnTransition)return!1;var u=Math.floor(r/n.slidesPerGroup);u>=o.length&&(u=o.length-1),(p||n.initialSlide||0)===(d||0)&&a&&s.emit("beforeSlideChangeStart");var h,v=-o[u];if(s.updateProgress(v),n.normalizeSlideIndex)for(var f=0;f<l.length;f+=1)-Math.floor(100*v)>=Math.floor(100*l[f])&&(r=f);if(s.initialized&&r!==p){if(!s.allowSlideNext&&v<s.translate&&v<s.minTranslate())return!1;if(!s.allowSlidePrev&&v>s.translate&&v>s.maxTranslate()&&(p||0)!==r)return!1}return h=p<r?"next":r<p?"prev":"reset",c&&-v===s.translate||!c&&v===s.translate?(s.updateActiveIndex(r),n.autoHeight&&s.updateAutoHeight(),s.updateSlidesClasses(),"slide"!==n.effect&&s.setTranslate(v),"reset"!==h&&(s.transitionStart(a,h),s.transitionEnd(a,h)),!1):(0!==t&&ae.transition?(s.setTransition(t),s.setTranslate(v),s.updateActiveIndex(r),s.updateSlidesClasses(),s.emit("beforeTransitionStart",t,i),s.transitionStart(a,h),s.animating||(s.animating=!0,s.onSlideToWrapperTransitionEnd||(s.onSlideToWrapperTransitionEnd=function(e){s&&!s.destroyed&&e.target===this&&(s.$wrapperEl[0].removeEventListener("transitionend",s.onSlideToWrapperTransitionEnd),s.$wrapperEl[0].removeEventListener("webkitTransitionEnd",s.onSlideToWrapperTransitionEnd),s.onSlideToWrapperTransitionEnd=null,delete s.onSlideToWrapperTransitionEnd,s.transitionEnd(a,h))}),s.$wrapperEl[0].addEventListener("transitionend",s.onSlideToWrapperTransitionEnd),s.$wrapperEl[0].addEventListener("webkitTransitionEnd",s.onSlideToWrapperTransitionEnd))):(s.setTransition(0),s.setTranslate(v),s.updateActiveIndex(r),s.updateSlidesClasses(),s.emit("beforeTransitionStart",t,i),s.transitionStart(a,h),s.transitionEnd(a,h)),!0)},slideToLoop:function(e,t,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0);var s=e;return this.params.loop&&(s+=this.loopedSlides),this.slideTo(s,t,a,i)},slideNext:function(e,t,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var i=this,s=i.params,r=i.animating;return s.loop?!r&&(i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft,i.slideTo(i.activeIndex+s.slidesPerGroup,e,t,a)):i.slideTo(i.activeIndex+s.slidesPerGroup,e,t,a)},slidePrev:function(e,t,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var i=this,s=i.params,r=i.animating,n=i.snapGrid,o=i.slidesGrid,l=i.rtlTranslate;if(s.loop){if(r)return!1;i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft}function d(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}var p,c=d(l?i.translate:-i.translate),u=n.map(function(e){return d(e)}),h=(o.map(function(e){return d(e)}),n[u.indexOf(c)],n[u.indexOf(c)-1]);return void 0!==h&&(p=o.indexOf(h))<0&&(p=i.activeIndex-1),i.slideTo(p,e,t,a)},slideReset:function(e,t,a){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,a)},slideToClosest:function(e,t,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var i=this,s=i.activeIndex,r=Math.floor(s/i.params.slidesPerGroup);if(r<i.snapGrid.length-1){var n=i.rtlTranslate?i.translate:-i.translate,o=i.snapGrid[r];(i.snapGrid[r+1]-o)/2<n-o&&(s=i.params.slidesPerGroup)}return i.slideTo(s,e,t,a)},slideToClickedSlide:function(){var e,t=this,a=t.params,i=t.$wrapperEl,s="auto"===a.slidesPerView?t.slidesPerViewDynamic():a.slidesPerView,r=t.clickedIndex;if(a.loop){if(t.animating)return;e=parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"),10),a.centeredSlides?r<t.loopedSlides-s/2||r>t.slides.length-t.loopedSlides+s/2?(t.loopFix(),r=i.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+a.slideDuplicateClass+")").eq(0).index(),te.nextTick(function(){t.slideTo(r)})):t.slideTo(r):r>t.slides.length-s?(t.loopFix(),r=i.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+a.slideDuplicateClass+")").eq(0).index(),te.nextTick(function(){t.slideTo(r)})):t.slideTo(r)}else t.slideTo(r)}};var h={loopCreate:function(){var i=this,e=i.params,t=i.$wrapperEl;t.children("."+e.slideClass+"."+e.slideDuplicateClass).remove();var s=t.children("."+e.slideClass);if(e.loopFillGroupWithBlank){var a=e.slidesPerGroup-s.length%e.slidesPerGroup;if(a!==e.slidesPerGroup){for(var r=0;r<a;r+=1){var n=L(m.createElement("div")).addClass(e.slideClass+" "+e.slideBlankClass);t.append(n)}s=t.children("."+e.slideClass)}}"auto"!==e.slidesPerView||e.loopedSlides||(e.loopedSlides=s.length),i.loopedSlides=parseInt(e.loopedSlides||e.slidesPerView,10),i.loopedSlides+=e.loopAdditionalSlides,i.loopedSlides>s.length&&(i.loopedSlides=s.length);var o=[],l=[];s.each(function(e,t){var a=L(t);e<i.loopedSlides&&l.push(t),e<s.length&&e>=s.length-i.loopedSlides&&o.push(t),a.attr("data-swiper-slide-index",e)});for(var d=0;d<l.length;d+=1)t.append(L(l[d].cloneNode(!0)).addClass(e.slideDuplicateClass));for(var p=o.length-1;0<=p;p-=1)t.prepend(L(o[p].cloneNode(!0)).addClass(e.slideDuplicateClass))},loopFix:function(){var e,t=this,a=t.params,i=t.activeIndex,s=t.slides,r=t.loopedSlides,n=t.allowSlidePrev,o=t.allowSlideNext,l=t.snapGrid,d=t.rtlTranslate;t.allowSlidePrev=!0,t.allowSlideNext=!0;var p=-l[i]-t.getTranslate();if(i<r)e=s.length-3*r+i,e+=r,t.slideTo(e,0,!1,!0)&&0!=p&&t.setTranslate((d?-t.translate:t.translate)-p);else if("auto"===a.slidesPerView&&2*r<=i||i>=s.length-r){e=-s.length+i+r,e+=r,t.slideTo(e,0,!1,!0)&&0!=p&&t.setTranslate((d?-t.translate:t.translate)-p)}t.allowSlidePrev=n,t.allowSlideNext=o},loopDestroy:function(){var e=this.$wrapperEl,t=this.params,a=this.slides;e.children("."+t.slideClass+"."+t.slideDuplicateClass+",."+t.slideClass+"."+t.slideBlankClass).remove(),a.removeAttr("data-swiper-slide-index")}};var v={setGrabCursor:function(e){if(!(ae.touch||!this.params.simulateTouch||this.params.watchOverflow&&this.isLocked)){var t=this.el;t.style.cursor="move",t.style.cursor=e?"-webkit-grabbing":"-webkit-grab",t.style.cursor=e?"-moz-grabbin":"-moz-grab",t.style.cursor=e?"grabbing":"grab"}},unsetGrabCursor:function(){ae.touch||this.params.watchOverflow&&this.isLocked||(this.el.style.cursor="")}};var f={appendSlide:function(e){var t=this,a=t.$wrapperEl,i=t.params;if(i.loop&&t.loopDestroy(),"object"==typeof e&&"length"in e)for(var s=0;s<e.length;s+=1)e[s]&&a.append(e[s]);else a.append(e);i.loop&&t.loopCreate(),i.observer&&ae.observer||t.update()},prependSlide:function(e){var t=this,a=t.params,i=t.$wrapperEl,s=t.activeIndex;a.loop&&t.loopDestroy();var r=s+1;if("object"==typeof e&&"length"in e){for(var n=0;n<e.length;n+=1)e[n]&&i.prepend(e[n]);r=s+e.length}else i.prepend(e);a.loop&&t.loopCreate(),a.observer&&ae.observer||t.update(),t.slideTo(r,0,!1)},addSlide:function(e,t){var a=this,i=a.$wrapperEl,s=a.params,r=a.activeIndex;s.loop&&(r-=a.loopedSlides,a.loopDestroy(),a.slides=i.children("."+s.slideClass));var n=a.slides.length;if(e<=0)a.prependSlide(t);else if(n<=e)a.appendSlide(t);else{for(var o=e<r?r+1:r,l=[],d=n-1;e<=d;d-=1){var p=a.slides.eq(d);p.remove(),l.unshift(p)}if("object"==typeof t&&"length"in t){for(var c=0;c<t.length;c+=1)t[c]&&i.append(t[c]);o=e<r?r+t.length:r}else i.append(t);for(var u=0;u<l.length;u+=1)i.append(l[u]);s.loop&&a.loopCreate(),s.observer&&ae.observer||a.update(),s.loop?a.slideTo(o+a.loopedSlides,0,!1):a.slideTo(o,0,!1)}},removeSlide:function(e){var t=this,a=t.params,i=t.$wrapperEl,s=t.activeIndex;a.loop&&(s-=t.loopedSlides,t.loopDestroy(),t.slides=i.children("."+a.slideClass));var r,n=s;if("object"==typeof e&&"length"in e){for(var o=0;o<e.length;o+=1)r=e[o],t.slides[r]&&t.slides.eq(r).remove(),r<n&&(n-=1);n=Math.max(n,0)}else r=e,t.slides[r]&&t.slides.eq(r).remove(),r<n&&(n-=1),n=Math.max(n,0);a.loop&&t.loopCreate(),a.observer&&ae.observer||t.update(),a.loop?t.slideTo(n+t.loopedSlides,0,!1):t.slideTo(n,0,!1)},removeAllSlides:function(){for(var e=[],t=0;t<this.slides.length;t+=1)e.push(t);this.removeSlide(e)}},g=function(){var e=ee.navigator.userAgent,t={ios:!1,android:!1,androidChrome:!1,desktop:!1,windows:!1,iphone:!1,ipod:!1,ipad:!1,cordova:ee.cordova||ee.phonegap,phonegap:ee.cordova||ee.phonegap},a=e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),i=e.match(/(Android);?[\s\/]+([\d.]+)?/),s=e.match(/(iPad).*OS\s([\d_]+)/),r=e.match(/(iPod)(.*OS\s([\d_]+))?/),n=!s&&e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);if(a&&(t.os="windows",t.osVersion=a[2],t.windows=!0),i&&!a&&(t.os="android",t.osVersion=i[2],t.android=!0,t.androidChrome=0<=e.toLowerCase().indexOf("chrome")),(s||n||r)&&(t.os="ios",t.ios=!0),n&&!r&&(t.osVersion=n[2].replace(/_/g,"."),t.iphone=!0),s&&(t.osVersion=s[2].replace(/_/g,"."),t.ipad=!0),r&&(t.osVersion=r[3]?r[3].replace(/_/g,"."):null,t.iphone=!0),t.ios&&t.osVersion&&0<=e.indexOf("Version/")&&"10"===t.osVersion.split(".")[0]&&(t.osVersion=e.toLowerCase().split("version/")[1].split(" ")[0]),t.desktop=!(t.os||t.android||t.webView),t.webView=(n||s||r)&&e.match(/.*AppleWebKit(?!.*Safari)/i),t.os&&"ios"===t.os){var o=t.osVersion.split("."),l=m.querySelector('meta[name="viewport"]');t.minimalUi=!t.webView&&(r||n)&&(1*o[0]==7?1<=1*o[1]:7<1*o[0])&&l&&0<=l.getAttribute("content").indexOf("minimal-ui")}return t.pixelRatio=ee.devicePixelRatio||1,t}();function b(){var e=this,t=e.params,a=e.el;if(!a||0!==a.offsetWidth){t.breakpoints&&e.setBreakpoint();var i=e.allowSlideNext,s=e.allowSlidePrev,r=e.snapGrid;if(e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),t.freeMode){var n=Math.min(Math.max(e.translate,e.maxTranslate()),e.minTranslate());e.setTranslate(n),e.updateActiveIndex(),e.updateSlidesClasses(),t.autoHeight&&e.updateAutoHeight()}else e.updateSlidesClasses(),("auto"===t.slidesPerView||1<t.slidesPerView)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0);e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.run(),e.allowSlidePrev=s,e.allowSlideNext=i,e.params.watchOverflow&&r!==e.snapGrid&&e.checkOverflow()}}var w=!1;function y(){}var x={init:!0,direction:"horizontal",touchEventsTarget:"container",initialSlide:0,speed:300,preventInteractionOnTransition:!1,edgeSwipeDetection:!1,edgeSwipeThreshold:20,freeMode:!1,freeModeMomentum:!0,freeModeMomentumRatio:1,freeModeMomentumBounce:!0,freeModeMomentumBounceRatio:1,freeModeMomentumVelocityRatio:1,freeModeSticky:!1,freeModeMinimumVelocity:.02,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsInverse:!1,spaceBetween:0,slidesPerView:1,slidesPerColumn:1,slidesPerColumnFill:"column",slidesPerGroup:1,centeredSlides:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!1,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!0,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,watchSlidesVisibility:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopFillGroupWithBlank:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,containerModifierClass:"swiper-container-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0},T={update:d,translate:p,transition:c,slide:u,loop:h,grabCursor:v,manipulation:f,events:{attachEvents:function(){var e=this,t=e.params,a=e.touchEvents,i=e.el,s=e.wrapperEl;e.onTouchStart=function(e){var t=this,a=t.touchEventsData,i=t.params,s=t.touches;if(!t.animating||!i.preventInteractionOnTransition){var r=e;if(r.originalEvent&&(r=r.originalEvent),a.isTouchEvent="touchstart"===r.type,(a.isTouchEvent||!("which"in r)||3!==r.which)&&!(!a.isTouchEvent&&"button"in r&&0<r.button||a.isTouched&&a.isMoved))if(i.noSwiping&&L(r.target).closest(i.noSwipingSelector?i.noSwipingSelector:"."+i.noSwipingClass)[0])t.allowClick=!0;else if(!i.swipeHandler||L(r).closest(i.swipeHandler)[0]){s.currentX="touchstart"===r.type?r.targetTouches[0].pageX:r.pageX,s.currentY="touchstart"===r.type?r.targetTouches[0].pageY:r.pageY;var n=s.currentX,o=s.currentY,l=i.edgeSwipeDetection||i.iOSEdgeSwipeDetection,d=i.edgeSwipeThreshold||i.iOSEdgeSwipeThreshold;if(!l||!(n<=d||n>=ee.screen.width-d)){if(te.extend(a,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),s.startX=n,s.startY=o,a.touchStartTime=te.now(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,0<i.threshold&&(a.allowThresholdMove=!1),"touchstart"!==r.type){var p=!0;L(r.target).is(a.formElements)&&(p=!1),m.activeElement&&L(m.activeElement).is(a.formElements)&&m.activeElement!==r.target&&m.activeElement.blur();var c=p&&t.allowTouchMove&&i.touchStartPreventDefault;(i.touchStartForcePreventDefault||c)&&r.preventDefault()}t.emit("touchStart",r)}}}}.bind(e),e.onTouchMove=function(e){var t=this,a=t.touchEventsData,i=t.params,s=t.touches,r=t.rtlTranslate,n=e;if(n.originalEvent&&(n=n.originalEvent),a.isTouched){if(!a.isTouchEvent||"mousemove"!==n.type){var o="touchmove"===n.type&&n.targetTouches&&(n.targetTouches[0]||n.changedTouches[0]),l="touchmove"===n.type?o.pageX:n.pageX,d="touchmove"===n.type?o.pageY:n.pageY;if(n.preventedByNestedSwiper)return s.startX=l,void(s.startY=d);if(!t.allowTouchMove)return t.allowClick=!1,void(a.isTouched&&(te.extend(s,{startX:l,startY:d,currentX:l,currentY:d}),a.touchStartTime=te.now()));if(a.isTouchEvent&&i.touchReleaseOnEdges&&!i.loop)if(t.isVertical()){if(d<s.startY&&t.translate<=t.maxTranslate()||d>s.startY&&t.translate>=t.minTranslate())return a.isTouched=!1,void(a.isMoved=!1)}else if(l<s.startX&&t.translate<=t.maxTranslate()||l>s.startX&&t.translate>=t.minTranslate())return;if(a.isTouchEvent&&m.activeElement&&n.target===m.activeElement&&L(n.target).is(a.formElements))return a.isMoved=!0,void(t.allowClick=!1);if(a.allowTouchCallbacks&&t.emit("touchMove",n),!(n.targetTouches&&1<n.targetTouches.length)){s.currentX=l,s.currentY=d;var p=s.currentX-s.startX,c=s.currentY-s.startY;if(!(t.params.threshold&&Math.sqrt(Math.pow(p,2)+Math.pow(c,2))<t.params.threshold)){var u;if(void 0===a.isScrolling)t.isHorizontal()&&s.currentY===s.startY||t.isVertical()&&s.currentX===s.startX?a.isScrolling=!1:25<=p*p+c*c&&(u=180*Math.atan2(Math.abs(c),Math.abs(p))/Math.PI,a.isScrolling=t.isHorizontal()?u>i.touchAngle:90-u>i.touchAngle);if(a.isScrolling&&t.emit("touchMoveOpposite",n),void 0===a.startMoving&&(s.currentX===s.startX&&s.currentY===s.startY||(a.startMoving=!0)),a.isScrolling)a.isTouched=!1;else if(a.startMoving){t.allowClick=!1,n.preventDefault(),i.touchMoveStopPropagation&&!i.nested&&n.stopPropagation(),a.isMoved||(i.loop&&t.loopFix(),a.startTranslate=t.getTranslate(),t.setTransition(0),t.animating&&t.$wrapperEl.trigger("webkitTransitionEnd transitionend"),a.allowMomentumBounce=!1,!i.grabCursor||!0!==t.allowSlideNext&&!0!==t.allowSlidePrev||t.setGrabCursor(!0),t.emit("sliderFirstMove",n)),t.emit("sliderMove",n),a.isMoved=!0;var h=t.isHorizontal()?p:c;s.diff=h,h*=i.touchRatio,r&&(h=-h),t.swipeDirection=0<h?"prev":"next",a.currentTranslate=h+a.startTranslate;var v=!0,f=i.resistanceRatio;if(i.touchReleaseOnEdges&&(f=0),0<h&&a.currentTranslate>t.minTranslate()?(v=!1,i.resistance&&(a.currentTranslate=t.minTranslate()-1+Math.pow(-t.minTranslate()+a.startTranslate+h,f))):h<0&&a.currentTranslate<t.maxTranslate()&&(v=!1,i.resistance&&(a.currentTranslate=t.maxTranslate()+1-Math.pow(t.maxTranslate()-a.startTranslate-h,f))),v&&(n.preventedByNestedSwiper=!0),!t.allowSlideNext&&"next"===t.swipeDirection&&a.currentTranslate<a.startTranslate&&(a.currentTranslate=a.startTranslate),!t.allowSlidePrev&&"prev"===t.swipeDirection&&a.currentTranslate>a.startTranslate&&(a.currentTranslate=a.startTranslate),0<i.threshold){if(!(Math.abs(h)>i.threshold||a.allowThresholdMove))return void(a.currentTranslate=a.startTranslate);if(!a.allowThresholdMove)return a.allowThresholdMove=!0,s.startX=s.currentX,s.startY=s.currentY,a.currentTranslate=a.startTranslate,void(s.diff=t.isHorizontal()?s.currentX-s.startX:s.currentY-s.startY)}i.followFinger&&((i.freeMode||i.watchSlidesProgress||i.watchSlidesVisibility)&&(t.updateActiveIndex(),t.updateSlidesClasses()),i.freeMode&&(0===a.velocities.length&&a.velocities.push({position:s[t.isHorizontal()?"startX":"startY"],time:a.touchStartTime}),a.velocities.push({position:s[t.isHorizontal()?"currentX":"currentY"],time:te.now()})),t.updateProgress(a.currentTranslate),t.setTranslate(a.currentTranslate))}}}}}else a.startMoving&&a.isScrolling&&t.emit("touchMoveOpposite",n)}.bind(e),e.onTouchEnd=function(e){var t=this,a=t.touchEventsData,i=t.params,s=t.touches,r=t.rtlTranslate,n=t.$wrapperEl,o=t.slidesGrid,l=t.snapGrid,d=e;if(d.originalEvent&&(d=d.originalEvent),a.allowTouchCallbacks&&t.emit("touchEnd",d),a.allowTouchCallbacks=!1,!a.isTouched)return a.isMoved&&i.grabCursor&&t.setGrabCursor(!1),a.isMoved=!1,void(a.startMoving=!1);i.grabCursor&&a.isMoved&&a.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);var p,c=te.now(),u=c-a.touchStartTime;if(t.allowClick&&(t.updateClickedSlide(d),t.emit("tap",d),u<300&&300<c-a.lastClickTime&&(a.clickTimeout&&clearTimeout(a.clickTimeout),a.clickTimeout=te.nextTick(function(){t&&!t.destroyed&&t.emit("click",d)},300)),u<300&&c-a.lastClickTime<300&&(a.clickTimeout&&clearTimeout(a.clickTimeout),t.emit("doubleTap",d))),a.lastClickTime=te.now(),te.nextTick(function(){t.destroyed||(t.allowClick=!0)}),!a.isTouched||!a.isMoved||!t.swipeDirection||0===s.diff||a.currentTranslate===a.startTranslate)return a.isTouched=!1,a.isMoved=!1,void(a.startMoving=!1);if(a.isTouched=!1,a.isMoved=!1,a.startMoving=!1,p=i.followFinger?r?t.translate:-t.translate:-a.currentTranslate,i.freeMode){if(p<-t.minTranslate())return void t.slideTo(t.activeIndex);if(p>-t.maxTranslate())return void(t.slides.length<l.length?t.slideTo(l.length-1):t.slideTo(t.slides.length-1));if(i.freeModeMomentum){if(1<a.velocities.length){var h=a.velocities.pop(),v=a.velocities.pop(),f=h.position-v.position,m=h.time-v.time;t.velocity=f/m,t.velocity/=2,Math.abs(t.velocity)<i.freeModeMinimumVelocity&&(t.velocity=0),(150<m||300<te.now()-h.time)&&(t.velocity=0)}else t.velocity=0;t.velocity*=i.freeModeMomentumVelocityRatio,a.velocities.length=0;var g=1e3*i.freeModeMomentumRatio,b=t.velocity*g,w=t.translate+b;r&&(w=-w);var y,x,T=!1,E=20*Math.abs(t.velocity)*i.freeModeMomentumBounceRatio;if(w<t.maxTranslate())i.freeModeMomentumBounce?(w+t.maxTranslate()<-E&&(w=t.maxTranslate()-E),y=t.maxTranslate(),T=!0,a.allowMomentumBounce=!0):w=t.maxTranslate(),i.loop&&i.centeredSlides&&(x=!0);else if(w>t.minTranslate())i.freeModeMomentumBounce?(w-t.minTranslate()>E&&(w=t.minTranslate()+E),y=t.minTranslate(),T=!0,a.allowMomentumBounce=!0):w=t.minTranslate(),i.loop&&i.centeredSlides&&(x=!0);else if(i.freeModeSticky){for(var S,C=0;C<l.length;C+=1)if(l[C]>-w){S=C;break}w=-(w=Math.abs(l[S]-w)<Math.abs(l[S-1]-w)||"next"===t.swipeDirection?l[S]:l[S-1])}if(x&&t.once("transitionEnd",function(){t.loopFix()}),0!==t.velocity)g=r?Math.abs((-w-t.translate)/t.velocity):Math.abs((w-t.translate)/t.velocity);else if(i.freeModeSticky)return void t.slideToClosest();i.freeModeMomentumBounce&&T?(t.updateProgress(y),t.setTransition(g),t.setTranslate(w),t.transitionStart(!0,t.swipeDirection),t.animating=!0,n.transitionEnd(function(){t&&!t.destroyed&&a.allowMomentumBounce&&(t.emit("momentumBounce"),t.setTransition(i.speed),t.setTranslate(y),n.transitionEnd(function(){t&&!t.destroyed&&t.transitionEnd()}))})):t.velocity?(t.updateProgress(w),t.setTransition(g),t.setTranslate(w),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,n.transitionEnd(function(){t&&!t.destroyed&&t.transitionEnd()}))):t.updateProgress(w),t.updateActiveIndex(),t.updateSlidesClasses()}else if(i.freeModeSticky)return void t.slideToClosest();(!i.freeModeMomentum||u>=i.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}else{for(var M=0,P=t.slidesSizesGrid[0],k=0;k<o.length;k+=i.slidesPerGroup)void 0!==o[k+i.slidesPerGroup]?p>=o[k]&&p<o[k+i.slidesPerGroup]&&(P=o[(M=k)+i.slidesPerGroup]-o[k]):p>=o[k]&&(M=k,P=o[o.length-1]-o[o.length-2]);var z=(p-o[M])/P;if(u>i.longSwipesMs){if(!i.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(z>=i.longSwipesRatio?t.slideTo(M+i.slidesPerGroup):t.slideTo(M)),"prev"===t.swipeDirection&&(z>1-i.longSwipesRatio?t.slideTo(M+i.slidesPerGroup):t.slideTo(M))}else{if(!i.shortSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&t.slideTo(M+i.slidesPerGroup),"prev"===t.swipeDirection&&t.slideTo(M)}}}.bind(e),e.onClick=function(e){this.allowClick||(this.params.preventClicks&&e.preventDefault(),this.params.preventClicksPropagation&&this.animating&&(e.stopPropagation(),e.stopImmediatePropagation()))}.bind(e);var r="container"===t.touchEventsTarget?i:s,n=!!t.nested;if(ae.touch||!ae.pointerEvents&&!ae.prefixedPointerEvents){if(ae.touch){var o=!("touchstart"!==a.start||!ae.passiveListener||!t.passiveListeners)&&{passive:!0,capture:!1};r.addEventListener(a.start,e.onTouchStart,o),r.addEventListener(a.move,e.onTouchMove,ae.passiveListener?{passive:!1,capture:n}:n),r.addEventListener(a.end,e.onTouchEnd,o),w||(m.addEventListener("touchstart",y),w=!0)}(t.simulateTouch&&!g.ios&&!g.android||t.simulateTouch&&!ae.touch&&g.ios)&&(r.addEventListener("mousedown",e.onTouchStart,!1),m.addEventListener("mousemove",e.onTouchMove,n),m.addEventListener("mouseup",e.onTouchEnd,!1))}else r.addEventListener(a.start,e.onTouchStart,!1),m.addEventListener(a.move,e.onTouchMove,n),m.addEventListener(a.end,e.onTouchEnd,!1);(t.preventClicks||t.preventClicksPropagation)&&r.addEventListener("click",e.onClick,!0),e.on(g.ios||g.android?"resize orientationchange observerUpdate":"resize observerUpdate",b,!0)},detachEvents:function(){var e=this,t=e.params,a=e.touchEvents,i=e.el,s=e.wrapperEl,r="container"===t.touchEventsTarget?i:s,n=!!t.nested;if(ae.touch||!ae.pointerEvents&&!ae.prefixedPointerEvents){if(ae.touch){var o=!("onTouchStart"!==a.start||!ae.passiveListener||!t.passiveListeners)&&{passive:!0,capture:!1};r.removeEventListener(a.start,e.onTouchStart,o),r.removeEventListener(a.move,e.onTouchMove,n),r.removeEventListener(a.end,e.onTouchEnd,o)}(t.simulateTouch&&!g.ios&&!g.android||t.simulateTouch&&!ae.touch&&g.ios)&&(r.removeEventListener("mousedown",e.onTouchStart,!1),m.removeEventListener("mousemove",e.onTouchMove,n),m.removeEventListener("mouseup",e.onTouchEnd,!1))}else r.removeEventListener(a.start,e.onTouchStart,!1),m.removeEventListener(a.move,e.onTouchMove,n),m.removeEventListener(a.end,e.onTouchEnd,!1);(t.preventClicks||t.preventClicksPropagation)&&r.removeEventListener("click",e.onClick,!0),e.off(g.ios||g.android?"resize orientationchange observerUpdate":"resize observerUpdate",b)}},breakpoints:{setBreakpoint:function(){var e=this,t=e.activeIndex,a=e.initialized,i=e.loopedSlides;void 0===i&&(i=0);var s=e.params,r=s.breakpoints;if(r&&(!r||0!==Object.keys(r).length)){var n=e.getBreakpoint(r);if(n&&e.currentBreakpoint!==n){var o=n in r?r[n]:void 0;o&&["slidesPerView","spaceBetween","slidesPerGroup"].forEach(function(e){var t=o[e];void 0!==t&&(o[e]="slidesPerView"!==e||"AUTO"!==t&&"auto"!==t?"slidesPerView"===e?parseFloat(t):parseInt(t,10):"auto")});var l=o||e.originalParams,d=l.direction&&l.direction!==s.direction,p=s.loop&&(l.slidesPerView!==s.slidesPerView||d);d&&a&&e.changeDirection(),te.extend(e.params,l),te.extend(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),e.currentBreakpoint=n,p&&a&&(e.loopDestroy(),e.loopCreate(),e.updateSlides(),e.slideTo(t-i+e.loopedSlides,0,!1)),e.emit("breakpoint",l)}}},getBreakpoint:function(e){if(e){var t=!1,a=[];Object.keys(e).forEach(function(e){a.push(e)}),a.sort(function(e,t){return parseInt(e,10)-parseInt(t,10)});for(var i=0;i<a.length;i+=1){var s=a[i];this.params.breakpointsInverse?s<=ee.innerWidth&&(t=s):s>=ee.innerWidth&&!t&&(t=s)}return t||"max"}}},checkOverflow:{checkOverflow:function(){var e=this,t=e.isLocked;e.isLocked=1===e.snapGrid.length,e.allowSlideNext=!e.isLocked,e.allowSlidePrev=!e.isLocked,t!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock"),t&&t!==e.isLocked&&(e.isEnd=!1,e.navigation.update())}},classes:{addClasses:function(){var t=this.classNames,a=this.params,e=this.rtl,i=this.$el,s=[];s.push("initialized"),s.push(a.direction),a.freeMode&&s.push("free-mode"),ae.flexbox||s.push("no-flexbox"),a.autoHeight&&s.push("autoheight"),e&&s.push("rtl"),1<a.slidesPerColumn&&s.push("multirow"),g.android&&s.push("android"),g.ios&&s.push("ios"),(ie.isIE||ie.isEdge)&&(ae.pointerEvents||ae.prefixedPointerEvents)&&s.push("wp8-"+a.direction),s.forEach(function(e){t.push(a.containerModifierClass+e)}),i.addClass(t.join(" "))},removeClasses:function(){var e=this.$el,t=this.classNames;e.removeClass(t.join(" "))}},images:{loadImage:function(e,t,a,i,s,r){var n;function o(){r&&r()}e.complete&&s?o():t?((n=new ee.Image).onload=o,n.onerror=o,i&&(n.sizes=i),a&&(n.srcset=a),t&&(n.src=t)):o()},preloadImages:function(){var e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")))}e.imagesToLoad=e.$el.find("img");for(var a=0;a<e.imagesToLoad.length;a+=1){var i=e.imagesToLoad[a];e.loadImage(i,i.currentSrc||i.getAttribute("src"),i.srcset||i.getAttribute("srcset"),i.sizes||i.getAttribute("sizes"),!0,t)}}}},E={},S=function(u){function h(){for(var e,t,s,a=[],i=arguments.length;i--;)a[i]=arguments[i];s=(s=1===a.length&&a[0].constructor&&a[0].constructor===Object?a[0]:(t=(e=a)[0],e[1]))||{},s=te.extend({},s),t&&!s.el&&(s.el=t),u.call(this,s),Object.keys(T).forEach(function(t){Object.keys(T[t]).forEach(function(e){h.prototype[e]||(h.prototype[e]=T[t][e])})});var r=this;void 0===r.modules&&(r.modules={}),Object.keys(r.modules).forEach(function(e){var t=r.modules[e];if(t.params){var a=Object.keys(t.params)[0],i=t.params[a];if("object"!=typeof i||null===i)return;if(!(a in s&&"enabled"in i))return;!0===s[a]&&(s[a]={enabled:!0}),"object"!=typeof s[a]||"enabled"in s[a]||(s[a].enabled=!0),s[a]||(s[a]={enabled:!1})}});var n=te.extend({},x);r.useModulesParams(n),r.params=te.extend({},n,E,s),r.originalParams=te.extend({},r.params),r.passedParams=te.extend({},s);var o=(r.$=L)(r.params.el);if(t=o[0]){if(1<o.length){var l=[];return o.each(function(e,t){var a=te.extend({},s,{el:t});l.push(new h(a))}),l}t.swiper=r,o.data("swiper",r);var d,p,c=o.children("."+r.params.wrapperClass);return te.extend(r,{$el:o,el:t,$wrapperEl:c,wrapperEl:c[0],classNames:[],slides:L(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:function(){return"horizontal"===r.params.direction},isVertical:function(){return"vertical"===r.params.direction},rtl:"rtl"===t.dir.toLowerCase()||"rtl"===o.css("direction"),rtlTranslate:"horizontal"===r.params.direction&&("rtl"===t.dir.toLowerCase()||"rtl"===o.css("direction")),wrongRTL:"-webkit-box"===c.css("display"),activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:r.params.allowSlideNext,allowSlidePrev:r.params.allowSlidePrev,touchEvents:(d=["touchstart","touchmove","touchend"],p=["mousedown","mousemove","mouseup"],ae.pointerEvents?p=["pointerdown","pointermove","pointerup"]:ae.prefixedPointerEvents&&(p=["MSPointerDown","MSPointerMove","MSPointerUp"]),r.touchEventsTouch={start:d[0],move:d[1],end:d[2]},r.touchEventsDesktop={start:p[0],move:p[1],end:p[2]},ae.touch||!r.params.simulateTouch?r.touchEventsTouch:r.touchEventsDesktop),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,formElements:"input, select, option, textarea, button, video",lastClickTime:te.now(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:r.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),r.useModules(),r.params.init&&r.init(),r}}u&&(h.__proto__=u);var e={extendedDefaults:{configurable:!0},defaults:{configurable:!0},Class:{configurable:!0},$:{configurable:!0}};return((h.prototype=Object.create(u&&u.prototype)).constructor=h).prototype.slidesPerViewDynamic=function(){var e=this,t=e.params,a=e.slides,i=e.slidesGrid,s=e.size,r=e.activeIndex,n=1;if(t.centeredSlides){for(var o,l=a[r].swiperSlideSize,d=r+1;d<a.length;d+=1)a[d]&&!o&&(n+=1,s<(l+=a[d].swiperSlideSize)&&(o=!0));for(var p=r-1;0<=p;p-=1)a[p]&&!o&&(n+=1,s<(l+=a[p].swiperSlideSize)&&(o=!0))}else for(var c=r+1;c<a.length;c+=1)i[c]-i[r]<s&&(n+=1);return n},h.prototype.update=function(){var a=this;if(a&&!a.destroyed){var e=a.snapGrid,t=a.params;t.breakpoints&&a.setBreakpoint(),a.updateSize(),a.updateSlides(),a.updateProgress(),a.updateSlidesClasses(),a.params.freeMode?(i(),a.params.autoHeight&&a.updateAutoHeight()):(("auto"===a.params.slidesPerView||1<a.params.slidesPerView)&&a.isEnd&&!a.params.centeredSlides?a.slideTo(a.slides.length-1,0,!1,!0):a.slideTo(a.activeIndex,0,!1,!0))||i(),t.watchOverflow&&e!==a.snapGrid&&a.checkOverflow(),a.emit("update")}function i(){var e=a.rtlTranslate?-1*a.translate:a.translate,t=Math.min(Math.max(e,a.maxTranslate()),a.minTranslate());a.setTranslate(t),a.updateActiveIndex(),a.updateSlidesClasses()}},h.prototype.changeDirection=function(a,e){void 0===e&&(e=!0);var t=this,i=t.params.direction;return(a=a||("horizontal"===i?"vertical":"horizontal"))===i||"horizontal"!==a&&"vertical"!==a||(t.$el.removeClass(""+t.params.containerModifierClass+i+" wp8-"+i).addClass(""+t.params.containerModifierClass+a),(ie.isIE||ie.isEdge)&&(ae.pointerEvents||ae.prefixedPointerEvents)&&t.$el.addClass(t.params.containerModifierClass+"wp8-"+a),t.params.direction=a,t.slides.each(function(e,t){"vertical"===a?t.style.width="":t.style.height=""}),t.emit("changeDirection"),e&&t.update()),t},h.prototype.init=function(){var e=this;e.initialized||(e.emit("beforeInit"),e.params.breakpoints&&e.setBreakpoint(),e.addClasses(),e.params.loop&&e.loopCreate(),e.updateSize(),e.updateSlides(),e.params.watchOverflow&&e.checkOverflow(),e.params.grabCursor&&e.setGrabCursor(),e.params.preloadImages&&e.preloadImages(),e.params.loop?e.slideTo(e.params.initialSlide+e.loopedSlides,0,e.params.runCallbacksOnInit):e.slideTo(e.params.initialSlide,0,e.params.runCallbacksOnInit),e.attachEvents(),e.initialized=!0,e.emit("init"))},h.prototype.destroy=function(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);var a=this,i=a.params,s=a.$el,r=a.$wrapperEl,n=a.slides;return void 0===a.params||a.destroyed||(a.emit("beforeDestroy"),a.initialized=!1,a.detachEvents(),i.loop&&a.loopDestroy(),t&&(a.removeClasses(),s.removeAttr("style"),r.removeAttr("style"),n&&n.length&&n.removeClass([i.slideVisibleClass,i.slideActiveClass,i.slideNextClass,i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row")),a.emit("destroy"),Object.keys(a.eventsListeners).forEach(function(e){a.off(e)}),!1!==e&&(a.$el[0].swiper=null,a.$el.data("swiper",null),te.deleteProps(a)),a.destroyed=!0),null},h.extendDefaults=function(e){te.extend(E,e)},e.extendedDefaults.get=function(){return E},e.defaults.get=function(){return x},e.Class.get=function(){return u},e.$.get=function(){return L},Object.defineProperties(h,e),h}(e),C={name:"device",proto:{device:g},static:{device:g}},M={name:"support",proto:{support:ae},static:{support:ae}},P={name:"browser",proto:{browser:ie},static:{browser:ie}},k={name:"resize",create:function(){var e=this;te.extend(e,{resize:{resizeHandler:function(){e&&!e.destroyed&&e.initialized&&(e.emit("beforeResize"),e.emit("resize"))},orientationChangeHandler:function(){e&&!e.destroyed&&e.initialized&&e.emit("orientationchange")}}})},on:{init:function(){ee.addEventListener("resize",this.resize.resizeHandler),ee.addEventListener("orientationchange",this.resize.orientationChangeHandler)},destroy:function(){ee.removeEventListener("resize",this.resize.resizeHandler),ee.removeEventListener("orientationchange",this.resize.orientationChangeHandler)}}},z={func:ee.MutationObserver||ee.WebkitMutationObserver,attach:function(e,t){void 0===t&&(t={});var a=this,i=new z.func(function(e){if(1!==e.length){var t=function(){a.emit("observerUpdate",e[0])};ee.requestAnimationFrame?ee.requestAnimationFrame(t):ee.setTimeout(t,0)}else a.emit("observerUpdate",e[0])});i.observe(e,{attributes:void 0===t.attributes||t.attributes,childList:void 0===t.childList||t.childList,characterData:void 0===t.characterData||t.characterData}),a.observer.observers.push(i)},init:function(){var e=this;if(ae.observer&&e.params.observer){if(e.params.observeParents)for(var t=e.$el.parents(),a=0;a<t.length;a+=1)e.observer.attach(t[a]);e.observer.attach(e.$el[0],{childList:e.params.observeSlideChildren}),e.observer.attach(e.$wrapperEl[0],{attributes:!1})}},destroy:function(){this.observer.observers.forEach(function(e){e.disconnect()}),this.observer.observers=[]}},$={name:"observer",params:{observer:!1,observeParents:!1,observeSlideChildren:!1},create:function(){te.extend(this,{observer:{init:z.init.bind(this),attach:z.attach.bind(this),destroy:z.destroy.bind(this),observers:[]}})},on:{init:function(){this.observer.init()},destroy:function(){this.observer.destroy()}}},I={update:function(e){var t=this,a=t.params,i=a.slidesPerView,s=a.slidesPerGroup,r=a.centeredSlides,n=t.params.virtual,o=n.addSlidesBefore,l=n.addSlidesAfter,d=t.virtual,p=d.from,c=d.to,u=d.slides,h=d.slidesGrid,v=d.renderSlide,f=d.offset;t.updateActiveIndex();var m,g,b,w=t.activeIndex||0;m=t.rtlTranslate?"right":t.isHorizontal()?"left":"top",b=r?(g=Math.floor(i/2)+s+o,Math.floor(i/2)+s+l):(g=i+(s-1)+o,s+l);var y=Math.max((w||0)-b,0),x=Math.min((w||0)+g,u.length-1),T=(t.slidesGrid[y]||0)-(t.slidesGrid[0]||0);function E(){t.updateSlides(),t.updateProgress(),t.updateSlidesClasses(),t.lazy&&t.params.lazy.enabled&&t.lazy.load()}if(te.extend(t.virtual,{from:y,to:x,offset:T,slidesGrid:t.slidesGrid}),p===y&&c===x&&!e)return t.slidesGrid!==h&&T!==f&&t.slides.css(m,T+"px"),void t.updateProgress();if(t.params.virtual.renderExternal)return t.params.virtual.renderExternal.call(t,{offset:T,from:y,to:x,slides:function(){for(var e=[],t=y;t<=x;t+=1)e.push(u[t]);return e}()}),void E();var S=[],C=[];if(e)t.$wrapperEl.find("."+t.params.slideClass).remove();else for(var M=p;M<=c;M+=1)(M<y||x<M)&&t.$wrapperEl.find("."+t.params.slideClass+'[data-swiper-slide-index="'+M+'"]').remove();for(var P=0;P<u.length;P+=1)y<=P&&P<=x&&(void 0===c||e?C.push(P):(c<P&&C.push(P),P<p&&S.push(P)));C.forEach(function(e){t.$wrapperEl.append(v(u[e],e))}),S.sort(function(e,t){return t-e}).forEach(function(e){t.$wrapperEl.prepend(v(u[e],e))}),t.$wrapperEl.children(".swiper-slide").css(m,T+"px"),E()},renderSlide:function(e,t){var a=this,i=a.params.virtual;if(i.cache&&a.virtual.cache[t])return a.virtual.cache[t];var s=i.renderSlide?L(i.renderSlide.call(a,e,t)):L('<div class="'+a.params.slideClass+'" data-swiper-slide-index="'+t+'">'+e+"</div>");return s.attr("data-swiper-slide-index")||s.attr("data-swiper-slide-index",t),i.cache&&(a.virtual.cache[t]=s),s},appendSlide:function(e){if("object"==typeof e&&"length"in e)for(var t=0;t<e.length;t+=1)e[t]&&this.virtual.slides.push(e[t]);else this.virtual.slides.push(e);this.virtual.update(!0)},prependSlide:function(e){var t=this,a=t.activeIndex,i=a+1,s=1;if(Array.isArray(e)){for(var r=0;r<e.length;r+=1)e[r]&&t.virtual.slides.unshift(e[r]);i=a+e.length,s=e.length}else t.virtual.slides.unshift(e);if(t.params.virtual.cache){var n=t.virtual.cache,o={};Object.keys(n).forEach(function(e){o[parseInt(e,10)+s]=n[e]}),t.virtual.cache=o}t.virtual.update(!0),t.slideTo(i,0)},removeSlide:function(e){var t=this;if(null!=e){var a=t.activeIndex;if(Array.isArray(e))for(var i=e.length-1;0<=i;i-=1)t.virtual.slides.splice(e[i],1),t.params.virtual.cache&&delete t.virtual.cache[e[i]],e[i]<a&&(a-=1),a=Math.max(a,0);else t.virtual.slides.splice(e,1),t.params.virtual.cache&&delete t.virtual.cache[e],e<a&&(a-=1),a=Math.max(a,0);t.virtual.update(!0),t.slideTo(a,0)}},removeAllSlides:function(){var e=this;e.virtual.slides=[],e.params.virtual.cache&&(e.virtual.cache={}),e.virtual.update(!0),e.slideTo(0,0)}},D={name:"virtual",params:{virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,addSlidesBefore:0,addSlidesAfter:0}},create:function(){var e=this;te.extend(e,{virtual:{update:I.update.bind(e),appendSlide:I.appendSlide.bind(e),prependSlide:I.prependSlide.bind(e),removeSlide:I.removeSlide.bind(e),removeAllSlides:I.removeAllSlides.bind(e),renderSlide:I.renderSlide.bind(e),slides:e.params.virtual.slides,cache:{}}})},on:{beforeInit:function(){var e=this;if(e.params.virtual.enabled){e.classNames.push(e.params.containerModifierClass+"virtual");var t={watchSlidesProgress:!0};te.extend(e.params,t),te.extend(e.originalParams,t),e.params.initialSlide||e.virtual.update()}},setTranslate:function(){this.params.virtual.enabled&&this.virtual.update()}}},O={handle:function(e){var t=this,a=t.rtlTranslate,i=e;i.originalEvent&&(i=i.originalEvent);var s=i.keyCode||i.charCode;if(!t.allowSlideNext&&(t.isHorizontal()&&39===s||t.isVertical()&&40===s||34===s))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&37===s||t.isVertical()&&38===s||33===s))return!1;if(!(i.shiftKey||i.altKey||i.ctrlKey||i.metaKey||m.activeElement&&m.activeElement.nodeName&&("input"===m.activeElement.nodeName.toLowerCase()||"textarea"===m.activeElement.nodeName.toLowerCase()))){if(t.params.keyboard.onlyInViewport&&(33===s||34===s||37===s||39===s||38===s||40===s)){var r=!1;if(0<t.$el.parents("."+t.params.slideClass).length&&0===t.$el.parents("."+t.params.slideActiveClass).length)return;var n=ee.innerWidth,o=ee.innerHeight,l=t.$el.offset();a&&(l.left-=t.$el[0].scrollLeft);for(var d=[[l.left,l.top],[l.left+t.width,l.top],[l.left,l.top+t.height],[l.left+t.width,l.top+t.height]],p=0;p<d.length;p+=1){var c=d[p];0<=c[0]&&c[0]<=n&&0<=c[1]&&c[1]<=o&&(r=!0)}if(!r)return}t.isHorizontal()?(33!==s&&34!==s&&37!==s&&39!==s||(i.preventDefault?i.preventDefault():i.returnValue=!1),(34!==s&&39!==s||a)&&(33!==s&&37!==s||!a)||t.slideNext(),(33!==s&&37!==s||a)&&(34!==s&&39!==s||!a)||t.slidePrev()):(33!==s&&34!==s&&38!==s&&40!==s||(i.preventDefault?i.preventDefault():i.returnValue=!1),34!==s&&40!==s||t.slideNext(),33!==s&&38!==s||t.slidePrev()),t.emit("keyPress",s)}},enable:function(){this.keyboard.enabled||(L(m).on("keydown",this.keyboard.handle),this.keyboard.enabled=!0)},disable:function(){this.keyboard.enabled&&(L(m).off("keydown",this.keyboard.handle),this.keyboard.enabled=!1)}},A={name:"keyboard",params:{keyboard:{enabled:!1,onlyInViewport:!0}},create:function(){te.extend(this,{keyboard:{enabled:!1,enable:O.enable.bind(this),disable:O.disable.bind(this),handle:O.handle.bind(this)}})},on:{init:function(){this.params.keyboard.enabled&&this.keyboard.enable()},destroy:function(){this.keyboard.enabled&&this.keyboard.disable()}}};var H={lastScrollTime:te.now(),event:-1<ee.navigator.userAgent.indexOf("firefox")?"DOMMouseScroll":function(){var e="onwheel",t=e in m;if(!t){var a=m.createElement("div");a.setAttribute(e,"return;"),t="function"==typeof a[e]}return!t&&m.implementation&&m.implementation.hasFeature&&!0!==m.implementation.hasFeature("","")&&(t=m.implementation.hasFeature("Events.wheel","3.0")),t}()?"wheel":"mousewheel",normalize:function(e){var t=0,a=0,i=0,s=0;return"detail"in e&&(a=e.detail),"wheelDelta"in e&&(a=-e.wheelDelta/120),"wheelDeltaY"in e&&(a=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=a,a=0),i=10*t,s=10*a,"deltaY"in e&&(s=e.deltaY),"deltaX"in e&&(i=e.deltaX),(i||s)&&e.deltaMode&&(1===e.deltaMode?(i*=40,s*=40):(i*=800,s*=800)),i&&!t&&(t=i<1?-1:1),s&&!a&&(a=s<1?-1:1),{spinX:t,spinY:a,pixelX:i,pixelY:s}},handleMouseEnter:function(){this.mouseEntered=!0},handleMouseLeave:function(){this.mouseEntered=!1},handle:function(e){var t=e,a=this,i=a.params.mousewheel;if(!a.mouseEntered&&!i.releaseOnEdges)return!0;t.originalEvent&&(t=t.originalEvent);var s=0,r=a.rtlTranslate?-1:1,n=H.normalize(t);if(i.forceToAxis)if(a.isHorizontal()){if(!(Math.abs(n.pixelX)>Math.abs(n.pixelY)))return!0;s=n.pixelX*r}else{if(!(Math.abs(n.pixelY)>Math.abs(n.pixelX)))return!0;s=n.pixelY}else s=Math.abs(n.pixelX)>Math.abs(n.pixelY)?-n.pixelX*r:-n.pixelY;if(0===s)return!0;if(i.invert&&(s=-s),a.params.freeMode){a.params.loop&&a.loopFix();var o=a.getTranslate()+s*i.sensitivity,l=a.isBeginning,d=a.isEnd;if(o>=a.minTranslate()&&(o=a.minTranslate()),o<=a.maxTranslate()&&(o=a.maxTranslate()),a.setTransition(0),a.setTranslate(o),a.updateProgress(),a.updateActiveIndex(),a.updateSlidesClasses(),(!l&&a.isBeginning||!d&&a.isEnd)&&a.updateSlidesClasses(),a.params.freeModeSticky&&(clearTimeout(a.mousewheel.timeout),a.mousewheel.timeout=te.nextTick(function(){a.slideToClosest()},300)),a.emit("scroll",t),a.params.autoplay&&a.params.autoplayDisableOnInteraction&&a.autoplay.stop(),o===a.minTranslate()||o===a.maxTranslate())return!0}else{if(60<te.now()-a.mousewheel.lastScrollTime)if(s<0)if(a.isEnd&&!a.params.loop||a.animating){if(i.releaseOnEdges)return!0}else a.slideNext(),a.emit("scroll",t);else if(a.isBeginning&&!a.params.loop||a.animating){if(i.releaseOnEdges)return!0}else a.slidePrev(),a.emit("scroll",t);a.mousewheel.lastScrollTime=(new ee.Date).getTime()}return t.preventDefault?t.preventDefault():t.returnValue=!1,!1},enable:function(){var e=this;if(!H.event)return!1;if(e.mousewheel.enabled)return!1;var t=e.$el;return"container"!==e.params.mousewheel.eventsTarged&&(t=L(e.params.mousewheel.eventsTarged)),t.on("mouseenter",e.mousewheel.handleMouseEnter),t.on("mouseleave",e.mousewheel.handleMouseLeave),t.on(H.event,e.mousewheel.handle),e.mousewheel.enabled=!0},disable:function(){var e=this;if(!H.event)return!1;if(!e.mousewheel.enabled)return!1;var t=e.$el;return"container"!==e.params.mousewheel.eventsTarged&&(t=L(e.params.mousewheel.eventsTarged)),t.off(H.event,e.mousewheel.handle),!(e.mousewheel.enabled=!1)}},G={update:function(){var e=this,t=e.params.navigation;if(!e.params.loop){var a=e.navigation,i=a.$nextEl,s=a.$prevEl;s&&0<s.length&&(e.isBeginning?s.addClass(t.disabledClass):s.removeClass(t.disabledClass),s[e.params.watchOverflow&&e.isLocked?"addClass":"removeClass"](t.lockClass)),i&&0<i.length&&(e.isEnd?i.addClass(t.disabledClass):i.removeClass(t.disabledClass),i[e.params.watchOverflow&&e.isLocked?"addClass":"removeClass"](t.lockClass))}},onPrevClick:function(e){e.preventDefault(),this.isBeginning&&!this.params.loop||this.slidePrev()},onNextClick:function(e){e.preventDefault(),this.isEnd&&!this.params.loop||this.slideNext()},init:function(){var e,t,a=this,i=a.params.navigation;(i.nextEl||i.prevEl)&&(i.nextEl&&(e=L(i.nextEl),a.params.uniqueNavElements&&"string"==typeof i.nextEl&&1<e.length&&1===a.$el.find(i.nextEl).length&&(e=a.$el.find(i.nextEl))),i.prevEl&&(t=L(i.prevEl),a.params.uniqueNavElements&&"string"==typeof i.prevEl&&1<t.length&&1===a.$el.find(i.prevEl).length&&(t=a.$el.find(i.prevEl))),e&&0<e.length&&e.on("click",a.navigation.onNextClick),t&&0<t.length&&t.on("click",a.navigation.onPrevClick),te.extend(a.navigation,{$nextEl:e,nextEl:e&&e[0],$prevEl:t,prevEl:t&&t[0]}))},destroy:function(){var e=this,t=e.navigation,a=t.$nextEl,i=t.$prevEl;a&&a.length&&(a.off("click",e.navigation.onNextClick),a.removeClass(e.params.navigation.disabledClass)),i&&i.length&&(i.off("click",e.navigation.onPrevClick),i.removeClass(e.params.navigation.disabledClass))}},N={update:function(){var e=this,t=e.rtl,s=e.params.pagination;if(s.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var r,a=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.slides.length,i=e.pagination.$el,n=e.params.loop?Math.ceil((a-2*e.loopedSlides)/e.params.slidesPerGroup):e.snapGrid.length;if(e.params.loop?((r=Math.ceil((e.activeIndex-e.loopedSlides)/e.params.slidesPerGroup))>a-1-2*e.loopedSlides&&(r-=a-2*e.loopedSlides),n-1<r&&(r-=n),r<0&&"bullets"!==e.params.paginationType&&(r=n+r)):r=void 0!==e.snapIndex?e.snapIndex:e.activeIndex||0,"bullets"===s.type&&e.pagination.bullets&&0<e.pagination.bullets.length){var o,l,d,p=e.pagination.bullets;if(s.dynamicBullets&&(e.pagination.bulletSize=p.eq(0)[e.isHorizontal()?"outerWidth":"outerHeight"](!0),i.css(e.isHorizontal()?"width":"height",e.pagination.bulletSize*(s.dynamicMainBullets+4)+"px"),1<s.dynamicMainBullets&&void 0!==e.previousIndex&&(e.pagination.dynamicBulletIndex+=r-e.previousIndex,e.pagination.dynamicBulletIndex>s.dynamicMainBullets-1?e.pagination.dynamicBulletIndex=s.dynamicMainBullets-1:e.pagination.dynamicBulletIndex<0&&(e.pagination.dynamicBulletIndex=0)),o=r-e.pagination.dynamicBulletIndex,d=((l=o+(Math.min(p.length,s.dynamicMainBullets)-1))+o)/2),p.removeClass(s.bulletActiveClass+" "+s.bulletActiveClass+"-next "+s.bulletActiveClass+"-next-next "+s.bulletActiveClass+"-prev "+s.bulletActiveClass+"-prev-prev "+s.bulletActiveClass+"-main"),1<i.length)p.each(function(e,t){var a=L(t),i=a.index();i===r&&a.addClass(s.bulletActiveClass),s.dynamicBullets&&(o<=i&&i<=l&&a.addClass(s.bulletActiveClass+"-main"),i===o&&a.prev().addClass(s.bulletActiveClass+"-prev").prev().addClass(s.bulletActiveClass+"-prev-prev"),i===l&&a.next().addClass(s.bulletActiveClass+"-next").next().addClass(s.bulletActiveClass+"-next-next"))});else if(p.eq(r).addClass(s.bulletActiveClass),s.dynamicBullets){for(var c=p.eq(o),u=p.eq(l),h=o;h<=l;h+=1)p.eq(h).addClass(s.bulletActiveClass+"-main");c.prev().addClass(s.bulletActiveClass+"-prev").prev().addClass(s.bulletActiveClass+"-prev-prev"),u.next().addClass(s.bulletActiveClass+"-next").next().addClass(s.bulletActiveClass+"-next-next")}if(s.dynamicBullets){var v=Math.min(p.length,s.dynamicMainBullets+4),f=(e.pagination.bulletSize*v-e.pagination.bulletSize)/2-d*e.pagination.bulletSize,m=t?"right":"left";p.css(e.isHorizontal()?m:"top",f+"px")}}if("fraction"===s.type&&(i.find("."+s.currentClass).text(s.formatFractionCurrent(r+1)),i.find("."+s.totalClass).text(s.formatFractionTotal(n))),"progressbar"===s.type){var g;g=s.progressbarOpposite?e.isHorizontal()?"vertical":"horizontal":e.isHorizontal()?"horizontal":"vertical";var b=(r+1)/n,w=1,y=1;"horizontal"===g?w=b:y=b,i.find("."+s.progressbarFillClass).transform("translate3d(0,0,0) scaleX("+w+") scaleY("+y+")").transition(e.params.speed)}"custom"===s.type&&s.renderCustom?(i.html(s.renderCustom(e,r+1,n)),e.emit("paginationRender",e,i[0])):e.emit("paginationUpdate",e,i[0]),i[e.params.watchOverflow&&e.isLocked?"addClass":"removeClass"](s.lockClass)}},render:function(){var e=this,t=e.params.pagination;if(t.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var a=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.slides.length,i=e.pagination.$el,s="";if("bullets"===t.type){for(var r=e.params.loop?Math.ceil((a-2*e.loopedSlides)/e.params.slidesPerGroup):e.snapGrid.length,n=0;n<r;n+=1)t.renderBullet?s+=t.renderBullet.call(e,n,t.bulletClass):s+="<"+t.bulletElement+' class="'+t.bulletClass+'"></'+t.bulletElement+">";i.html(s),e.pagination.bullets=i.find("."+t.bulletClass)}"fraction"===t.type&&(s=t.renderFraction?t.renderFraction.call(e,t.currentClass,t.totalClass):'<span class="'+t.currentClass+'"></span> / <span class="'+t.totalClass+'"></span>',i.html(s)),"progressbar"===t.type&&(s=t.renderProgressbar?t.renderProgressbar.call(e,t.progressbarFillClass):'<span class="'+t.progressbarFillClass+'"></span>',i.html(s)),"custom"!==t.type&&e.emit("paginationRender",e.pagination.$el[0])}},init:function(){var a=this,e=a.params.pagination;if(e.el){var t=L(e.el);0!==t.length&&(a.params.uniqueNavElements&&"string"==typeof e.el&&1<t.length&&1===a.$el.find(e.el).length&&(t=a.$el.find(e.el)),"bullets"===e.type&&e.clickable&&t.addClass(e.clickableClass),t.addClass(e.modifierClass+e.type),"bullets"===e.type&&e.dynamicBullets&&(t.addClass(""+e.modifierClass+e.type+"-dynamic"),a.pagination.dynamicBulletIndex=0,e.dynamicMainBullets<1&&(e.dynamicMainBullets=1)),"progressbar"===e.type&&e.progressbarOpposite&&t.addClass(e.progressbarOppositeClass),e.clickable&&t.on("click","."+e.bulletClass,function(e){e.preventDefault();var t=L(this).index()*a.params.slidesPerGroup;a.params.loop&&(t+=a.loopedSlides),a.slideTo(t)}),te.extend(a.pagination,{$el:t,el:t[0]}))}},destroy:function(){var e=this,t=e.params.pagination;if(t.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var a=e.pagination.$el;a.removeClass(t.hiddenClass),a.removeClass(t.modifierClass+t.type),e.pagination.bullets&&e.pagination.bullets.removeClass(t.bulletActiveClass),t.clickable&&a.off("click","."+t.bulletClass)}}},B={setTranslate:function(){var e=this;if(e.params.scrollbar.el&&e.scrollbar.el){var t=e.scrollbar,a=e.rtlTranslate,i=e.progress,s=t.dragSize,r=t.trackSize,n=t.$dragEl,o=t.$el,l=e.params.scrollbar,d=s,p=(r-s)*i;a?0<(p=-p)?(d=s-p,p=0):r<-p+s&&(d=r+p):p<0?(d=s+p,p=0):r<p+s&&(d=r-p),e.isHorizontal()?(ae.transforms3d?n.transform("translate3d("+p+"px, 0, 0)"):n.transform("translateX("+p+"px)"),n[0].style.width=d+"px"):(ae.transforms3d?n.transform("translate3d(0px, "+p+"px, 0)"):n.transform("translateY("+p+"px)"),n[0].style.height=d+"px"),l.hide&&(clearTimeout(e.scrollbar.timeout),o[0].style.opacity=1,e.scrollbar.timeout=setTimeout(function(){o[0].style.opacity=0,o.transition(400)},1e3))}},setTransition:function(e){this.params.scrollbar.el&&this.scrollbar.el&&this.scrollbar.$dragEl.transition(e)},updateSize:function(){var e=this;if(e.params.scrollbar.el&&e.scrollbar.el){var t=e.scrollbar,a=t.$dragEl,i=t.$el;a[0].style.width="",a[0].style.height="";var s,r=e.isHorizontal()?i[0].offsetWidth:i[0].offsetHeight,n=e.size/e.virtualSize,o=n*(r/e.size);s="auto"===e.params.scrollbar.dragSize?r*n:parseInt(e.params.scrollbar.dragSize,10),e.isHorizontal()?a[0].style.width=s+"px":a[0].style.height=s+"px",i[0].style.display=1<=n?"none":"",e.params.scrollbar.hide&&(i[0].style.opacity=0),te.extend(t,{trackSize:r,divider:n,moveDivider:o,dragSize:s}),t.$el[e.params.watchOverflow&&e.isLocked?"addClass":"removeClass"](e.params.scrollbar.lockClass)}},getPointerPosition:function(e){return this.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].pageX:e.pageX||e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].pageY:e.pageY||e.clientY},setDragPosition:function(e){var t,a=this,i=a.scrollbar,s=a.rtlTranslate,r=i.$el,n=i.dragSize,o=i.trackSize,l=i.dragStartPos;t=(i.getPointerPosition(e)-r.offset()[a.isHorizontal()?"left":"top"]-(null!==l?l:n/2))/(o-n),t=Math.max(Math.min(t,1),0),s&&(t=1-t);var d=a.minTranslate()+(a.maxTranslate()-a.minTranslate())*t;a.updateProgress(d),a.setTranslate(d),a.updateActiveIndex(),a.updateSlidesClasses()},onDragStart:function(e){var t=this,a=t.params.scrollbar,i=t.scrollbar,s=t.$wrapperEl,r=i.$el,n=i.$dragEl;t.scrollbar.isTouched=!0,t.scrollbar.dragStartPos=e.target===n[0]||e.target===n?i.getPointerPosition(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),s.transition(100),n.transition(100),i.setDragPosition(e),clearTimeout(t.scrollbar.dragTimeout),r.transition(0),a.hide&&r.css("opacity",1),t.emit("scrollbarDragStart",e)},onDragMove:function(e){var t=this.scrollbar,a=this.$wrapperEl,i=t.$el,s=t.$dragEl;this.scrollbar.isTouched&&(e.preventDefault?e.preventDefault():e.returnValue=!1,t.setDragPosition(e),a.transition(0),i.transition(0),s.transition(0),this.emit("scrollbarDragMove",e))},onDragEnd:function(e){var t=this,a=t.params.scrollbar,i=t.scrollbar.$el;t.scrollbar.isTouched&&(t.scrollbar.isTouched=!1,a.hide&&(clearTimeout(t.scrollbar.dragTimeout),t.scrollbar.dragTimeout=te.nextTick(function(){i.css("opacity",0),i.transition(400)},1e3)),t.emit("scrollbarDragEnd",e),a.snapOnRelease&&t.slideToClosest())},enableDraggable:function(){var e=this;if(e.params.scrollbar.el){var t=e.scrollbar,a=e.touchEventsTouch,i=e.touchEventsDesktop,s=e.params,r=t.$el[0],n=!(!ae.passiveListener||!s.passiveListeners)&&{passive:!1,capture:!1},o=!(!ae.passiveListener||!s.passiveListeners)&&{passive:!0,capture:!1};ae.touch?(r.addEventListener(a.start,e.scrollbar.onDragStart,n),r.addEventListener(a.move,e.scrollbar.onDragMove,n),r.addEventListener(a.end,e.scrollbar.onDragEnd,o)):(r.addEventListener(i.start,e.scrollbar.onDragStart,n),m.addEventListener(i.move,e.scrollbar.onDragMove,n),m.addEventListener(i.end,e.scrollbar.onDragEnd,o))}},disableDraggable:function(){var e=this;if(e.params.scrollbar.el){var t=e.scrollbar,a=e.touchEventsTouch,i=e.touchEventsDesktop,s=e.params,r=t.$el[0],n=!(!ae.passiveListener||!s.passiveListeners)&&{passive:!1,capture:!1},o=!(!ae.passiveListener||!s.passiveListeners)&&{passive:!0,capture:!1};ae.touch?(r.removeEventListener(a.start,e.scrollbar.onDragStart,n),r.removeEventListener(a.move,e.scrollbar.onDragMove,n),r.removeEventListener(a.end,e.scrollbar.onDragEnd,o)):(r.removeEventListener(i.start,e.scrollbar.onDragStart,n),m.removeEventListener(i.move,e.scrollbar.onDragMove,n),m.removeEventListener(i.end,e.scrollbar.onDragEnd,o))}},init:function(){var e=this;if(e.params.scrollbar.el){var t=e.scrollbar,a=e.$el,i=e.params.scrollbar,s=L(i.el);e.params.uniqueNavElements&&"string"==typeof i.el&&1<s.length&&1===a.find(i.el).length&&(s=a.find(i.el));var r=s.find("."+e.params.scrollbar.dragClass);0===r.length&&(r=L('<div class="'+e.params.scrollbar.dragClass+'"></div>'),s.append(r)),te.extend(t,{$el:s,el:s[0],$dragEl:r,dragEl:r[0]}),i.draggable&&t.enableDraggable()}},destroy:function(){this.scrollbar.disableDraggable()}},X={setTransform:function(e,t){var a=this.rtl,i=L(e),s=a?-1:1,r=i.attr("data-swiper-parallax")||"0",n=i.attr("data-swiper-parallax-x"),o=i.attr("data-swiper-parallax-y"),l=i.attr("data-swiper-parallax-scale"),d=i.attr("data-swiper-parallax-opacity");if(n||o?(n=n||"0",o=o||"0"):this.isHorizontal()?(n=r,o="0"):(o=r,n="0"),n=0<=n.indexOf("%")?parseInt(n,10)*t*s+"%":n*t*s+"px",o=0<=o.indexOf("%")?parseInt(o,10)*t+"%":o*t+"px",null!=d){var p=d-(d-1)*(1-Math.abs(t));i[0].style.opacity=p}if(null==l)i.transform("translate3d("+n+", "+o+", 0px)");else{var c=l-(l-1)*(1-Math.abs(t));i.transform("translate3d("+n+", "+o+", 0px) scale("+c+")")}},setTranslate:function(){var i=this,e=i.$el,t=i.slides,s=i.progress,r=i.snapGrid;e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(e,t){i.parallax.setTransform(t,s)}),t.each(function(e,t){var a=t.progress;1<i.params.slidesPerGroup&&"auto"!==i.params.slidesPerView&&(a+=Math.ceil(e/2)-s*(r.length-1)),a=Math.min(Math.max(a,-1),1),L(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(e,t){i.parallax.setTransform(t,a)})})},setTransition:function(s){void 0===s&&(s=this.params.speed);this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(e,t){var a=L(t),i=parseInt(a.attr("data-swiper-parallax-duration"),10)||s;0===s&&(i=0),a.transition(i)})}},V={getDistanceBetweenTouches:function(e){if(e.targetTouches.length<2)return 1;var t=e.targetTouches[0].pageX,a=e.targetTouches[0].pageY,i=e.targetTouches[1].pageX,s=e.targetTouches[1].pageY;return Math.sqrt(Math.pow(i-t,2)+Math.pow(s-a,2))},onGestureStart:function(e){var t=this,a=t.params.zoom,i=t.zoom,s=i.gesture;if(i.fakeGestureTouched=!1,i.fakeGestureMoved=!1,!ae.gestures){if("touchstart"!==e.type||"touchstart"===e.type&&e.targetTouches.length<2)return;i.fakeGestureTouched=!0,s.scaleStart=V.getDistanceBetweenTouches(e)}s.$slideEl&&s.$slideEl.length||(s.$slideEl=L(e.target).closest(".swiper-slide"),0===s.$slideEl.length&&(s.$slideEl=t.slides.eq(t.activeIndex)),s.$imageEl=s.$slideEl.find("img, svg, canvas"),s.$imageWrapEl=s.$imageEl.parent("."+a.containerClass),s.maxRatio=s.$imageWrapEl.attr("data-swiper-zoom")||a.maxRatio,0!==s.$imageWrapEl.length)?(s.$imageEl.transition(0),t.zoom.isScaling=!0):s.$imageEl=void 0},onGestureChange:function(e){var t=this.params.zoom,a=this.zoom,i=a.gesture;if(!ae.gestures){if("touchmove"!==e.type||"touchmove"===e.type&&e.targetTouches.length<2)return;a.fakeGestureMoved=!0,i.scaleMove=V.getDistanceBetweenTouches(e)}i.$imageEl&&0!==i.$imageEl.length&&(a.scale=ae.gestures?e.scale*a.currentScale:i.scaleMove/i.scaleStart*a.currentScale,a.scale>i.maxRatio&&(a.scale=i.maxRatio-1+Math.pow(a.scale-i.maxRatio+1,.5)),a.scale<t.minRatio&&(a.scale=t.minRatio+1-Math.pow(t.minRatio-a.scale+1,.5)),i.$imageEl.transform("translate3d(0,0,0) scale("+a.scale+")"))},onGestureEnd:function(e){var t=this.params.zoom,a=this.zoom,i=a.gesture;if(!ae.gestures){if(!a.fakeGestureTouched||!a.fakeGestureMoved)return;if("touchend"!==e.type||"touchend"===e.type&&e.changedTouches.length<2&&!g.android)return;a.fakeGestureTouched=!1,a.fakeGestureMoved=!1}i.$imageEl&&0!==i.$imageEl.length&&(a.scale=Math.max(Math.min(a.scale,i.maxRatio),t.minRatio),i.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale("+a.scale+")"),a.currentScale=a.scale,a.isScaling=!1,1===a.scale&&(i.$slideEl=void 0))},onTouchStart:function(e){var t=this.zoom,a=t.gesture,i=t.image;a.$imageEl&&0!==a.$imageEl.length&&(i.isTouched||(g.android&&e.preventDefault(),i.isTouched=!0,i.touchesStart.x="touchstart"===e.type?e.targetTouches[0].pageX:e.pageX,i.touchesStart.y="touchstart"===e.type?e.targetTouches[0].pageY:e.pageY))},onTouchMove:function(e){var t=this,a=t.zoom,i=a.gesture,s=a.image,r=a.velocity;if(i.$imageEl&&0!==i.$imageEl.length&&(t.allowClick=!1,s.isTouched&&i.$slideEl)){s.isMoved||(s.width=i.$imageEl[0].offsetWidth,s.height=i.$imageEl[0].offsetHeight,s.startX=te.getTranslate(i.$imageWrapEl[0],"x")||0,s.startY=te.getTranslate(i.$imageWrapEl[0],"y")||0,i.slideWidth=i.$slideEl[0].offsetWidth,i.slideHeight=i.$slideEl[0].offsetHeight,i.$imageWrapEl.transition(0),t.rtl&&(s.startX=-s.startX,s.startY=-s.startY));var n=s.width*a.scale,o=s.height*a.scale;if(!(n<i.slideWidth&&o<i.slideHeight)){if(s.minX=Math.min(i.slideWidth/2-n/2,0),s.maxX=-s.minX,s.minY=Math.min(i.slideHeight/2-o/2,0),s.maxY=-s.minY,s.touchesCurrent.x="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesCurrent.y="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,!s.isMoved&&!a.isScaling){if(t.isHorizontal()&&(Math.floor(s.minX)===Math.floor(s.startX)&&s.touchesCurrent.x<s.touchesStart.x||Math.floor(s.maxX)===Math.floor(s.startX)&&s.touchesCurrent.x>s.touchesStart.x))return void(s.isTouched=!1);if(!t.isHorizontal()&&(Math.floor(s.minY)===Math.floor(s.startY)&&s.touchesCurrent.y<s.touchesStart.y||Math.floor(s.maxY)===Math.floor(s.startY)&&s.touchesCurrent.y>s.touchesStart.y))return void(s.isTouched=!1)}e.preventDefault(),e.stopPropagation(),s.isMoved=!0,s.currentX=s.touchesCurrent.x-s.touchesStart.x+s.startX,s.currentY=s.touchesCurrent.y-s.touchesStart.y+s.startY,s.currentX<s.minX&&(s.currentX=s.minX+1-Math.pow(s.minX-s.currentX+1,.8)),s.currentX>s.maxX&&(s.currentX=s.maxX-1+Math.pow(s.currentX-s.maxX+1,.8)),s.currentY<s.minY&&(s.currentY=s.minY+1-Math.pow(s.minY-s.currentY+1,.8)),s.currentY>s.maxY&&(s.currentY=s.maxY-1+Math.pow(s.currentY-s.maxY+1,.8)),r.prevPositionX||(r.prevPositionX=s.touchesCurrent.x),r.prevPositionY||(r.prevPositionY=s.touchesCurrent.y),r.prevTime||(r.prevTime=Date.now()),r.x=(s.touchesCurrent.x-r.prevPositionX)/(Date.now()-r.prevTime)/2,r.y=(s.touchesCurrent.y-r.prevPositionY)/(Date.now()-r.prevTime)/2,Math.abs(s.touchesCurrent.x-r.prevPositionX)<2&&(r.x=0),Math.abs(s.touchesCurrent.y-r.prevPositionY)<2&&(r.y=0),r.prevPositionX=s.touchesCurrent.x,r.prevPositionY=s.touchesCurrent.y,r.prevTime=Date.now(),i.$imageWrapEl.transform("translate3d("+s.currentX+"px, "+s.currentY+"px,0)")}}},onTouchEnd:function(){var e=this.zoom,t=e.gesture,a=e.image,i=e.velocity;if(t.$imageEl&&0!==t.$imageEl.length){if(!a.isTouched||!a.isMoved)return a.isTouched=!1,void(a.isMoved=!1);a.isTouched=!1,a.isMoved=!1;var s=300,r=300,n=i.x*s,o=a.currentX+n,l=i.y*r,d=a.currentY+l;0!==i.x&&(s=Math.abs((o-a.currentX)/i.x)),0!==i.y&&(r=Math.abs((d-a.currentY)/i.y));var p=Math.max(s,r);a.currentX=o,a.currentY=d;var c=a.width*e.scale,u=a.height*e.scale;a.minX=Math.min(t.slideWidth/2-c/2,0),a.maxX=-a.minX,a.minY=Math.min(t.slideHeight/2-u/2,0),a.maxY=-a.minY,a.currentX=Math.max(Math.min(a.currentX,a.maxX),a.minX),a.currentY=Math.max(Math.min(a.currentY,a.maxY),a.minY),t.$imageWrapEl.transition(p).transform("translate3d("+a.currentX+"px, "+a.currentY+"px,0)")}},onTransitionEnd:function(){var e=this.zoom,t=e.gesture;t.$slideEl&&this.previousIndex!==this.activeIndex&&(t.$imageEl.transform("translate3d(0,0,0) scale(1)"),t.$imageWrapEl.transform("translate3d(0,0,0)"),e.scale=1,e.currentScale=1,t.$slideEl=void 0,t.$imageEl=void 0,t.$imageWrapEl=void 0)},toggle:function(e){var t=this.zoom;t.scale&&1!==t.scale?t.out():t.in(e)},in:function(e){var t,a,i,s,r,n,o,l,d,p,c,u,h,v,f,m,g=this,b=g.zoom,w=g.params.zoom,y=b.gesture,x=b.image;y.$slideEl||(y.$slideEl=g.clickedSlide?L(g.clickedSlide):g.slides.eq(g.activeIndex),y.$imageEl=y.$slideEl.find("img, svg, canvas"),y.$imageWrapEl=y.$imageEl.parent("."+w.containerClass)),y.$imageEl&&0!==y.$imageEl.length&&(y.$slideEl.addClass(""+w.zoomedSlideClass),a=void 0===x.touchesStart.x&&e?(t="touchend"===e.type?e.changedTouches[0].pageX:e.pageX,"touchend"===e.type?e.changedTouches[0].pageY:e.pageY):(t=x.touchesStart.x,x.touchesStart.y),b.scale=y.$imageWrapEl.attr("data-swiper-zoom")||w.maxRatio,b.currentScale=y.$imageWrapEl.attr("data-swiper-zoom")||w.maxRatio,e?(f=y.$slideEl[0].offsetWidth,m=y.$slideEl[0].offsetHeight,i=y.$slideEl.offset().left+f/2-t,s=y.$slideEl.offset().top+m/2-a,o=y.$imageEl[0].offsetWidth,l=y.$imageEl[0].offsetHeight,d=o*b.scale,p=l*b.scale,h=-(c=Math.min(f/2-d/2,0)),v=-(u=Math.min(m/2-p/2,0)),(r=i*b.scale)<c&&(r=c),h<r&&(r=h),(n=s*b.scale)<u&&(n=u),v<n&&(n=v)):n=r=0,y.$imageWrapEl.transition(300).transform("translate3d("+r+"px, "+n+"px,0)"),y.$imageEl.transition(300).transform("translate3d(0,0,0) scale("+b.scale+")"))},out:function(){var e=this,t=e.zoom,a=e.params.zoom,i=t.gesture;i.$slideEl||(i.$slideEl=e.clickedSlide?L(e.clickedSlide):e.slides.eq(e.activeIndex),i.$imageEl=i.$slideEl.find("img, svg, canvas"),i.$imageWrapEl=i.$imageEl.parent("."+a.containerClass)),i.$imageEl&&0!==i.$imageEl.length&&(t.scale=1,t.currentScale=1,i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),i.$slideEl.removeClass(""+a.zoomedSlideClass),i.$slideEl=void 0)},enable:function(){var e=this,t=e.zoom;if(!t.enabled){t.enabled=!0;var a=!("touchstart"!==e.touchEvents.start||!ae.passiveListener||!e.params.passiveListeners)&&{passive:!0,capture:!1};ae.gestures?(e.$wrapperEl.on("gesturestart",".swiper-slide",t.onGestureStart,a),e.$wrapperEl.on("gesturechange",".swiper-slide",t.onGestureChange,a),e.$wrapperEl.on("gestureend",".swiper-slide",t.onGestureEnd,a)):"touchstart"===e.touchEvents.start&&(e.$wrapperEl.on(e.touchEvents.start,".swiper-slide",t.onGestureStart,a),e.$wrapperEl.on(e.touchEvents.move,".swiper-slide",t.onGestureChange,a),e.$wrapperEl.on(e.touchEvents.end,".swiper-slide",t.onGestureEnd,a)),e.$wrapperEl.on(e.touchEvents.move,"."+e.params.zoom.containerClass,t.onTouchMove)}},disable:function(){var e=this,t=e.zoom;if(t.enabled){e.zoom.enabled=!1;var a=!("touchstart"!==e.touchEvents.start||!ae.passiveListener||!e.params.passiveListeners)&&{passive:!0,capture:!1};ae.gestures?(e.$wrapperEl.off("gesturestart",".swiper-slide",t.onGestureStart,a),e.$wrapperEl.off("gesturechange",".swiper-slide",t.onGestureChange,a),e.$wrapperEl.off("gestureend",".swiper-slide",t.onGestureEnd,a)):"touchstart"===e.touchEvents.start&&(e.$wrapperEl.off(e.touchEvents.start,".swiper-slide",t.onGestureStart,a),e.$wrapperEl.off(e.touchEvents.move,".swiper-slide",t.onGestureChange,a),e.$wrapperEl.off(e.touchEvents.end,".swiper-slide",t.onGestureEnd,a)),e.$wrapperEl.off(e.touchEvents.move,"."+e.params.zoom.containerClass,t.onTouchMove)}}},Y={loadInSlide:function(e,l){void 0===l&&(l=!0);var d=this,p=d.params.lazy;if(void 0!==e&&0!==d.slides.length){var c=d.virtual&&d.params.virtual.enabled?d.$wrapperEl.children("."+d.params.slideClass+'[data-swiper-slide-index="'+e+'"]'):d.slides.eq(e),t=c.find("."+p.elementClass+":not(."+p.loadedClass+"):not(."+p.loadingClass+")");!c.hasClass(p.elementClass)||c.hasClass(p.loadedClass)||c.hasClass(p.loadingClass)||(t=t.add(c[0])),0!==t.length&&t.each(function(e,t){var i=L(t);i.addClass(p.loadingClass);var s=i.attr("data-background"),r=i.attr("data-src"),n=i.attr("data-srcset"),o=i.attr("data-sizes");d.loadImage(i[0],r||s,n,o,!1,function(){if(null!=d&&d&&(!d||d.params)&&!d.destroyed){if(s?(i.css("background-image",'url("'+s+'")'),i.removeAttr("data-background")):(n&&(i.attr("srcset",n),i.removeAttr("data-srcset")),o&&(i.attr("sizes",o),i.removeAttr("data-sizes")),r&&(i.attr("src",r),i.removeAttr("data-src"))),i.addClass(p.loadedClass).removeClass(p.loadingClass),c.find("."+p.preloaderClass).remove(),d.params.loop&&l){var e=c.attr("data-swiper-slide-index");if(c.hasClass(d.params.slideDuplicateClass)){var t=d.$wrapperEl.children('[data-swiper-slide-index="'+e+'"]:not(.'+d.params.slideDuplicateClass+")");d.lazy.loadInSlide(t.index(),!1)}else{var a=d.$wrapperEl.children("."+d.params.slideDuplicateClass+'[data-swiper-slide-index="'+e+'"]');d.lazy.loadInSlide(a.index(),!1)}}d.emit("lazyImageReady",c[0],i[0])}}),d.emit("lazyImageLoad",c[0],i[0])})}},load:function(){var i=this,t=i.$wrapperEl,a=i.params,s=i.slides,e=i.activeIndex,r=i.virtual&&a.virtual.enabled,n=a.lazy,o=a.slidesPerView;function l(e){if(r){if(t.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]').length)return!0}else if(s[e])return!0;return!1}function d(e){return r?L(e).attr("data-swiper-slide-index"):L(e).index()}if("auto"===o&&(o=0),i.lazy.initialImageLoaded||(i.lazy.initialImageLoaded=!0),i.params.watchSlidesVisibility)t.children("."+a.slideVisibleClass).each(function(e,t){var a=r?L(t).attr("data-swiper-slide-index"):L(t).index();i.lazy.loadInSlide(a)});else if(1<o)for(var p=e;p<e+o;p+=1)l(p)&&i.lazy.loadInSlide(p);else i.lazy.loadInSlide(e);if(n.loadPrevNext)if(1<o||n.loadPrevNextAmount&&1<n.loadPrevNextAmount){for(var c=n.loadPrevNextAmount,u=o,h=Math.min(e+u+Math.max(c,u),s.length),v=Math.max(e-Math.max(u,c),0),f=e+o;f<h;f+=1)l(f)&&i.lazy.loadInSlide(f);for(var m=v;m<e;m+=1)l(m)&&i.lazy.loadInSlide(m)}else{var g=t.children("."+a.slideNextClass);0<g.length&&i.lazy.loadInSlide(d(g));var b=t.children("."+a.slidePrevClass);0<b.length&&i.lazy.loadInSlide(d(b))}}},F={LinearSpline:function(e,t){var a,i,s,r,n,o=function(e,t){for(i=-1,a=e.length;1<a-i;)e[s=a+i>>1]<=t?i=s:a=s;return a};return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(n=o(this.x,e),r=n-1,(e-this.x[r])*(this.y[n]-this.y[r])/(this.x[n]-this.x[r])+this.y[r]):0},this},getInterpolateFunction:function(e){var t=this;t.controller.spline||(t.controller.spline=t.params.loop?new F.LinearSpline(t.slidesGrid,e.slidesGrid):new F.LinearSpline(t.snapGrid,e.snapGrid))},setTranslate:function(e,t){var a,i,s=this,r=s.controller.control;function n(e){var t=s.rtlTranslate?-s.translate:s.translate;"slide"===s.params.controller.by&&(s.controller.getInterpolateFunction(e),i=-s.controller.spline.interpolate(-t)),i&&"container"!==s.params.controller.by||(a=(e.maxTranslate()-e.minTranslate())/(s.maxTranslate()-s.minTranslate()),i=(t-s.minTranslate())*a+e.minTranslate()),s.params.controller.inverse&&(i=e.maxTranslate()-i),e.updateProgress(i),e.setTranslate(i,s),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(r))for(var o=0;o<r.length;o+=1)r[o]!==t&&r[o]instanceof S&&n(r[o]);else r instanceof S&&t!==r&&n(r)},setTransition:function(t,e){var a,i=this,s=i.controller.control;function r(e){e.setTransition(t,i),0!==t&&(e.transitionStart(),e.params.autoHeight&&te.nextTick(function(){e.updateAutoHeight()}),e.$wrapperEl.transitionEnd(function(){s&&(e.params.loop&&"slide"===i.params.controller.by&&e.loopFix(),e.transitionEnd())}))}if(Array.isArray(s))for(a=0;a<s.length;a+=1)s[a]!==e&&s[a]instanceof S&&r(s[a]);else s instanceof S&&e!==s&&r(s)}},R={makeElFocusable:function(e){return e.attr("tabIndex","0"),e},addElRole:function(e,t){return e.attr("role",t),e},addElLabel:function(e,t){return e.attr("aria-label",t),e},disableEl:function(e){return e.attr("aria-disabled",!0),e},enableEl:function(e){return e.attr("aria-disabled",!1),e},onEnterKey:function(e){var t=this,a=t.params.a11y;if(13===e.keyCode){var i=L(e.target);t.navigation&&t.navigation.$nextEl&&i.is(t.navigation.$nextEl)&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?t.a11y.notify(a.lastSlideMessage):t.a11y.notify(a.nextSlideMessage)),t.navigation&&t.navigation.$prevEl&&i.is(t.navigation.$prevEl)&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?t.a11y.notify(a.firstSlideMessage):t.a11y.notify(a.prevSlideMessage)),t.pagination&&i.is("."+t.params.pagination.bulletClass)&&i[0].click()}},notify:function(e){var t=this.a11y.liveRegion;0!==t.length&&(t.html(""),t.html(e))},updateNavigation:function(){var e=this;if(!e.params.loop){var t=e.navigation,a=t.$nextEl,i=t.$prevEl;i&&0<i.length&&(e.isBeginning?e.a11y.disableEl(i):e.a11y.enableEl(i)),a&&0<a.length&&(e.isEnd?e.a11y.disableEl(a):e.a11y.enableEl(a))}},updatePagination:function(){var i=this,s=i.params.a11y;i.pagination&&i.params.pagination.clickable&&i.pagination.bullets&&i.pagination.bullets.length&&i.pagination.bullets.each(function(e,t){var a=L(t);i.a11y.makeElFocusable(a),i.a11y.addElRole(a,"button"),i.a11y.addElLabel(a,s.paginationBulletMessage.replace(/{{index}}/,a.index()+1))})},init:function(){var e=this;e.$el.append(e.a11y.liveRegion);var t,a,i=e.params.a11y;e.navigation&&e.navigation.$nextEl&&(t=e.navigation.$nextEl),e.navigation&&e.navigation.$prevEl&&(a=e.navigation.$prevEl),t&&(e.a11y.makeElFocusable(t),e.a11y.addElRole(t,"button"),e.a11y.addElLabel(t,i.nextSlideMessage),t.on("keydown",e.a11y.onEnterKey)),a&&(e.a11y.makeElFocusable(a),e.a11y.addElRole(a,"button"),e.a11y.addElLabel(a,i.prevSlideMessage),a.on("keydown",e.a11y.onEnterKey)),e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.$el.on("keydown","."+e.params.pagination.bulletClass,e.a11y.onEnterKey)},destroy:function(){var e,t,a=this;a.a11y.liveRegion&&0<a.a11y.liveRegion.length&&a.a11y.liveRegion.remove(),a.navigation&&a.navigation.$nextEl&&(e=a.navigation.$nextEl),a.navigation&&a.navigation.$prevEl&&(t=a.navigation.$prevEl),e&&e.off("keydown",a.a11y.onEnterKey),t&&t.off("keydown",a.a11y.onEnterKey),a.pagination&&a.params.pagination.clickable&&a.pagination.bullets&&a.pagination.bullets.length&&a.pagination.$el.off("keydown","."+a.params.pagination.bulletClass,a.a11y.onEnterKey)}},q={init:function(){var e=this;if(e.params.history){if(!ee.history||!ee.history.pushState)return e.params.history.enabled=!1,void(e.params.hashNavigation.enabled=!0);var t=e.history;t.initialized=!0,t.paths=q.getPathValues(),(t.paths.key||t.paths.value)&&(t.scrollToSlide(0,t.paths.value,e.params.runCallbacksOnInit),e.params.history.replaceState||ee.addEventListener("popstate",e.history.setHistoryPopState))}},destroy:function(){this.params.history.replaceState||ee.removeEventListener("popstate",this.history.setHistoryPopState)},setHistoryPopState:function(){this.history.paths=q.getPathValues(),this.history.scrollToSlide(this.params.speed,this.history.paths.value,!1)},getPathValues:function(){var e=ee.location.pathname.slice(1).split("/").filter(function(e){return""!==e}),t=e.length;return{key:e[t-2],value:e[t-1]}},setHistory:function(e,t){if(this.history.initialized&&this.params.history.enabled){var a=this.slides.eq(t),i=q.slugify(a.attr("data-history"));ee.location.pathname.includes(e)||(i=e+"/"+i);var s=ee.history.state;s&&s.value===i||(this.params.history.replaceState?ee.history.replaceState({value:i},null,i):ee.history.pushState({value:i},null,i))}},slugify:function(e){return e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,"")},scrollToSlide:function(e,t,a){var i=this;if(t)for(var s=0,r=i.slides.length;s<r;s+=1){var n=i.slides.eq(s);if(q.slugify(n.attr("data-history"))===t&&!n.hasClass(i.params.slideDuplicateClass)){var o=n.index();i.slideTo(o,e,a)}}else i.slideTo(0,e,a)}},W={onHashCange:function(){var e=this,t=m.location.hash.replace("#","");if(t!==e.slides.eq(e.activeIndex).attr("data-hash")){var a=e.$wrapperEl.children("."+e.params.slideClass+'[data-hash="'+t+'"]').index();if(void 0===a)return;e.slideTo(a)}},setHash:function(){var e=this;if(e.hashNavigation.initialized&&e.params.hashNavigation.enabled)if(e.params.hashNavigation.replaceState&&ee.history&&ee.history.replaceState)ee.history.replaceState(null,null,"#"+e.slides.eq(e.activeIndex).attr("data-hash")||"");else{var t=e.slides.eq(e.activeIndex),a=t.attr("data-hash")||t.attr("data-history");m.location.hash=a||""}},init:function(){var e=this;if(!(!e.params.hashNavigation.enabled||e.params.history&&e.params.history.enabled)){e.hashNavigation.initialized=!0;var t=m.location.hash.replace("#","");if(t)for(var a=0,i=e.slides.length;a<i;a+=1){var s=e.slides.eq(a);if((s.attr("data-hash")||s.attr("data-history"))===t&&!s.hasClass(e.params.slideDuplicateClass)){var r=s.index();e.slideTo(r,0,e.params.runCallbacksOnInit,!0)}}e.params.hashNavigation.watchState&&L(ee).on("hashchange",e.hashNavigation.onHashCange)}},destroy:function(){this.params.hashNavigation.watchState&&L(ee).off("hashchange",this.hashNavigation.onHashCange)}},j={run:function(){var e=this,t=e.slides.eq(e.activeIndex),a=e.params.autoplay.delay;t.attr("data-swiper-autoplay")&&(a=t.attr("data-swiper-autoplay")||e.params.autoplay.delay),clearTimeout(e.autoplay.timeout),e.autoplay.timeout=te.nextTick(function(){e.params.autoplay.reverseDirection?e.params.loop?(e.loopFix(),e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.isBeginning?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(e.slideTo(e.slides.length-1,e.params.speed,!0,!0),e.emit("autoplay")):(e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.params.loop?(e.loopFix(),e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")):e.isEnd?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(e.slideTo(0,e.params.speed,!0,!0),e.emit("autoplay")):(e.slideNext(e.params.speed,!0,!0),e.emit("autoplay"))},a)},start:function(){var e=this;return void 0===e.autoplay.timeout&&(!e.autoplay.running&&(e.autoplay.running=!0,e.emit("autoplayStart"),e.autoplay.run(),!0))},stop:function(){var e=this;return!!e.autoplay.running&&(void 0!==e.autoplay.timeout&&(e.autoplay.timeout&&(clearTimeout(e.autoplay.timeout),e.autoplay.timeout=void 0),e.autoplay.running=!1,e.emit("autoplayStop"),!0))},pause:function(e){var t=this;t.autoplay.running&&(t.autoplay.paused||(t.autoplay.timeout&&clearTimeout(t.autoplay.timeout),t.autoplay.paused=!0,0!==e&&t.params.autoplay.waitForTransition?(t.$wrapperEl[0].addEventListener("transitionend",t.autoplay.onTransitionEnd),t.$wrapperEl[0].addEventListener("webkitTransitionEnd",t.autoplay.onTransitionEnd)):(t.autoplay.paused=!1,t.autoplay.run())))}},U={setTranslate:function(){for(var e=this,t=e.slides,a=0;a<t.length;a+=1){var i=e.slides.eq(a),s=-i[0].swiperSlideOffset;e.params.virtualTranslate||(s-=e.translate);var r=0;e.isHorizontal()||(r=s,s=0);var n=e.params.fadeEffect.crossFade?Math.max(1-Math.abs(i[0].progress),0):1+Math.min(Math.max(i[0].progress,-1),0);i.css({opacity:n}).transform("translate3d("+s+"px, "+r+"px, 0px)")}},setTransition:function(e){var a=this,t=a.slides,i=a.$wrapperEl;if(t.transition(e),a.params.virtualTranslate&&0!==e){var s=!1;t.transitionEnd(function(){if(!s&&a&&!a.destroyed){s=!0,a.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],t=0;t<e.length;t+=1)i.trigger(e[t])}})}}},K={setTranslate:function(){var e,t=this,a=t.$el,i=t.$wrapperEl,s=t.slides,r=t.width,n=t.height,o=t.rtlTranslate,l=t.size,d=t.params.cubeEffect,p=t.isHorizontal(),c=t.virtual&&t.params.virtual.enabled,u=0;d.shadow&&(p?(0===(e=i.find(".swiper-cube-shadow")).length&&(e=L('<div class="swiper-cube-shadow"></div>'),i.append(e)),e.css({height:r+"px"})):0===(e=a.find(".swiper-cube-shadow")).length&&(e=L('<div class="swiper-cube-shadow"></div>'),a.append(e)));for(var h=0;h<s.length;h+=1){var v=s.eq(h),f=h;c&&(f=parseInt(v.attr("data-swiper-slide-index"),10));var m=90*f,g=Math.floor(m/360);o&&(m=-m,g=Math.floor(-m/360));var b=Math.max(Math.min(v[0].progress,1),-1),w=0,y=0,x=0;f%4==0?(w=4*-g*l,x=0):(f-1)%4==0?(w=0,x=4*-g*l):(f-2)%4==0?(w=l+4*g*l,x=l):(f-3)%4==0&&(w=-l,x=3*l+4*l*g),o&&(w=-w),p||(y=w,w=0);var T="rotateX("+(p?0:-m)+"deg) rotateY("+(p?m:0)+"deg) translate3d("+w+"px, "+y+"px, "+x+"px)";if(b<=1&&-1<b&&(u=90*f+90*b,o&&(u=90*-f-90*b)),v.transform(T),d.slideShadows){var E=p?v.find(".swiper-slide-shadow-left"):v.find(".swiper-slide-shadow-top"),S=p?v.find(".swiper-slide-shadow-right"):v.find(".swiper-slide-shadow-bottom");0===E.length&&(E=L('<div class="swiper-slide-shadow-'+(p?"left":"top")+'"></div>'),v.append(E)),0===S.length&&(S=L('<div class="swiper-slide-shadow-'+(p?"right":"bottom")+'"></div>'),v.append(S)),E.length&&(E[0].style.opacity=Math.max(-b,0)),S.length&&(S[0].style.opacity=Math.max(b,0))}}if(i.css({"-webkit-transform-origin":"50% 50% -"+l/2+"px","-moz-transform-origin":"50% 50% -"+l/2+"px","-ms-transform-origin":"50% 50% -"+l/2+"px","transform-origin":"50% 50% -"+l/2+"px"}),d.shadow)if(p)e.transform("translate3d(0px, "+(r/2+d.shadowOffset)+"px, "+-r/2+"px) rotateX(90deg) rotateZ(0deg) scale("+d.shadowScale+")");else{var C=Math.abs(u)-90*Math.floor(Math.abs(u)/90),M=1.5-(Math.sin(2*C*Math.PI/360)/2+Math.cos(2*C*Math.PI/360)/2),P=d.shadowScale,k=d.shadowScale/M,z=d.shadowOffset;e.transform("scale3d("+P+", 1, "+k+") translate3d(0px, "+(n/2+z)+"px, "+-n/2/k+"px) rotateX(-90deg)")}var $=ie.isSafari||ie.isUiWebView?-l/2:0;i.transform("translate3d(0px,0,"+$+"px) rotateX("+(t.isHorizontal()?0:u)+"deg) rotateY("+(t.isHorizontal()?-u:0)+"deg)")},setTransition:function(e){var t=this.$el;this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),this.params.cubeEffect.shadow&&!this.isHorizontal()&&t.find(".swiper-cube-shadow").transition(e)}},_={setTranslate:function(){for(var e=this,t=e.slides,a=e.rtlTranslate,i=0;i<t.length;i+=1){var s=t.eq(i),r=s[0].progress;e.params.flipEffect.limitRotation&&(r=Math.max(Math.min(s[0].progress,1),-1));var n=-180*r,o=0,l=-s[0].swiperSlideOffset,d=0;if(e.isHorizontal()?a&&(n=-n):(d=l,o=-n,n=l=0),s[0].style.zIndex=-Math.abs(Math.round(r))+t.length,e.params.flipEffect.slideShadows){var p=e.isHorizontal()?s.find(".swiper-slide-shadow-left"):s.find(".swiper-slide-shadow-top"),c=e.isHorizontal()?s.find(".swiper-slide-shadow-right"):s.find(".swiper-slide-shadow-bottom");0===p.length&&(p=L('<div class="swiper-slide-shadow-'+(e.isHorizontal()?"left":"top")+'"></div>'),s.append(p)),0===c.length&&(c=L('<div class="swiper-slide-shadow-'+(e.isHorizontal()?"right":"bottom")+'"></div>'),s.append(c)),p.length&&(p[0].style.opacity=Math.max(-r,0)),c.length&&(c[0].style.opacity=Math.max(r,0))}s.transform("translate3d("+l+"px, "+d+"px, 0px) rotateX("+o+"deg) rotateY("+n+"deg)")}},setTransition:function(e){var a=this,t=a.slides,i=a.activeIndex,s=a.$wrapperEl;if(t.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),a.params.virtualTranslate&&0!==e){var r=!1;t.eq(i).transitionEnd(function(){if(!r&&a&&!a.destroyed){r=!0,a.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],t=0;t<e.length;t+=1)s.trigger(e[t])}})}}},Z={setTranslate:function(){for(var e=this,t=e.width,a=e.height,i=e.slides,s=e.$wrapperEl,r=e.slidesSizesGrid,n=e.params.coverflowEffect,o=e.isHorizontal(),l=e.translate,d=o?t/2-l:a/2-l,p=o?n.rotate:-n.rotate,c=n.depth,u=0,h=i.length;u<h;u+=1){var v=i.eq(u),f=r[u],m=(d-v[0].swiperSlideOffset-f/2)/f*n.modifier,g=o?p*m:0,b=o?0:p*m,w=-c*Math.abs(m),y=o?0:n.stretch*m,x=o?n.stretch*m:0;Math.abs(x)<.001&&(x=0),Math.abs(y)<.001&&(y=0),Math.abs(w)<.001&&(w=0),Math.abs(g)<.001&&(g=0),Math.abs(b)<.001&&(b=0);var T="translate3d("+x+"px,"+y+"px,"+w+"px)  rotateX("+b+"deg) rotateY("+g+"deg)";if(v.transform(T),v[0].style.zIndex=1-Math.abs(Math.round(m)),n.slideShadows){var E=o?v.find(".swiper-slide-shadow-left"):v.find(".swiper-slide-shadow-top"),S=o?v.find(".swiper-slide-shadow-right"):v.find(".swiper-slide-shadow-bottom");0===E.length&&(E=L('<div class="swiper-slide-shadow-'+(o?"left":"top")+'"></div>'),v.append(E)),0===S.length&&(S=L('<div class="swiper-slide-shadow-'+(o?"right":"bottom")+'"></div>'),v.append(S)),E.length&&(E[0].style.opacity=0<m?m:0),S.length&&(S[0].style.opacity=0<-m?-m:0)}}(ae.pointerEvents||ae.prefixedPointerEvents)&&(s[0].style.perspectiveOrigin=d+"px 50%")},setTransition:function(e){this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)}},Q={init:function(){var e=this,t=e.params.thumbs,a=e.constructor;t.swiper instanceof a?(e.thumbs.swiper=t.swiper,te.extend(e.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),te.extend(e.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1})):te.isObject(t.swiper)&&(e.thumbs.swiper=new a(te.extend({},t.swiper,{watchSlidesVisibility:!0,watchSlidesProgress:!0,slideToClickedSlide:!1})),e.thumbs.swiperCreated=!0),e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),e.thumbs.swiper.on("tap",e.thumbs.onThumbClick)},onThumbClick:function(){var e=this,t=e.thumbs.swiper;if(t){var a=t.clickedIndex,i=t.clickedSlide;if(!(i&&L(i).hasClass(e.params.thumbs.slideThumbActiveClass)||null==a)){var s;if(s=t.params.loop?parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"),10):a,e.params.loop){var r=e.activeIndex;e.slides.eq(r).hasClass(e.params.slideDuplicateClass)&&(e.loopFix(),e._clientLeft=e.$wrapperEl[0].clientLeft,r=e.activeIndex);var n=e.slides.eq(r).prevAll('[data-swiper-slide-index="'+s+'"]').eq(0).index(),o=e.slides.eq(r).nextAll('[data-swiper-slide-index="'+s+'"]').eq(0).index();s=void 0===n?o:void 0===o?n:o-r<r-n?o:n}e.slideTo(s)}}},update:function(e){var t=this,a=t.thumbs.swiper;if(a){var i="auto"===a.params.slidesPerView?a.slidesPerViewDynamic():a.params.slidesPerView;if(t.realIndex!==a.realIndex){var s,r=a.activeIndex;if(a.params.loop){a.slides.eq(r).hasClass(a.params.slideDuplicateClass)&&(a.loopFix(),a._clientLeft=a.$wrapperEl[0].clientLeft,r=a.activeIndex);var n=a.slides.eq(r).prevAll('[data-swiper-slide-index="'+t.realIndex+'"]').eq(0).index(),o=a.slides.eq(r).nextAll('[data-swiper-slide-index="'+t.realIndex+'"]').eq(0).index();s=void 0===n?o:void 0===o?n:o-r==r-n?r:o-r<r-n?o:n}else s=t.realIndex;a.visibleSlidesIndexes&&a.visibleSlidesIndexes.indexOf(s)<0&&(a.params.centeredSlides?s=r<s?s-Math.floor(i/2)+1:s+Math.floor(i/2)-1:r<s&&(s=s-i+1),a.slideTo(s,e?0:void 0))}var l=1,d=t.params.thumbs.slideThumbActiveClass;if(1<t.params.slidesPerView&&!t.params.centeredSlides&&(l=t.params.slidesPerView),a.slides.removeClass(d),a.params.loop||a.params.virtual)for(var p=0;p<l;p+=1)a.$wrapperEl.children('[data-swiper-slide-index="'+(t.realIndex+p)+'"]').addClass(d);else for(var c=0;c<l;c+=1)a.slides.eq(t.realIndex+c).addClass(d)}}},J=[C,M,P,k,$,D,A,{name:"mousewheel",params:{mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarged:"container"}},create:function(){var e=this;te.extend(e,{mousewheel:{enabled:!1,enable:H.enable.bind(e),disable:H.disable.bind(e),handle:H.handle.bind(e),handleMouseEnter:H.handleMouseEnter.bind(e),handleMouseLeave:H.handleMouseLeave.bind(e),lastScrollTime:te.now()}})},on:{init:function(){this.params.mousewheel.enabled&&this.mousewheel.enable()},destroy:function(){this.mousewheel.enabled&&this.mousewheel.disable()}}},{name:"navigation",params:{navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock"}},create:function(){var e=this;te.extend(e,{navigation:{init:G.init.bind(e),update:G.update.bind(e),destroy:G.destroy.bind(e),onNextClick:G.onNextClick.bind(e),onPrevClick:G.onPrevClick.bind(e)}})},on:{init:function(){this.navigation.init(),this.navigation.update()},toEdge:function(){this.navigation.update()},fromEdge:function(){this.navigation.update()},destroy:function(){this.navigation.destroy()},click:function(e){var t,a=this,i=a.navigation,s=i.$nextEl,r=i.$prevEl;!a.params.navigation.hideOnClick||L(e.target).is(r)||L(e.target).is(s)||(s?t=s.hasClass(a.params.navigation.hiddenClass):r&&(t=r.hasClass(a.params.navigation.hiddenClass)),!0===t?a.emit("navigationShow",a):a.emit("navigationHide",a),s&&s.toggleClass(a.params.navigation.hiddenClass),r&&r.toggleClass(a.params.navigation.hiddenClass))}}},{name:"pagination",params:{pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:function(e){return e},formatFractionTotal:function(e){return e},bulletClass:"swiper-pagination-bullet",bulletActiveClass:"swiper-pagination-bullet-active",modifierClass:"swiper-pagination-",currentClass:"swiper-pagination-current",totalClass:"swiper-pagination-total",hiddenClass:"swiper-pagination-hidden",progressbarFillClass:"swiper-pagination-progressbar-fill",progressbarOppositeClass:"swiper-pagination-progressbar-opposite",clickableClass:"swiper-pagination-clickable",lockClass:"swiper-pagination-lock"}},create:function(){var e=this;te.extend(e,{pagination:{init:N.init.bind(e),render:N.render.bind(e),update:N.update.bind(e),destroy:N.destroy.bind(e),dynamicBulletIndex:0}})},on:{init:function(){this.pagination.init(),this.pagination.render(),this.pagination.update()},activeIndexChange:function(){this.params.loop?this.pagination.update():void 0===this.snapIndex&&this.pagination.update()},snapIndexChange:function(){this.params.loop||this.pagination.update()},slidesLengthChange:function(){this.params.loop&&(this.pagination.render(),this.pagination.update())},snapGridLengthChange:function(){this.params.loop||(this.pagination.render(),this.pagination.update())},destroy:function(){this.pagination.destroy()},click:function(e){var t=this;t.params.pagination.el&&t.params.pagination.hideOnClick&&0<t.pagination.$el.length&&!L(e.target).hasClass(t.params.pagination.bulletClass)&&(!0===t.pagination.$el.hasClass(t.params.pagination.hiddenClass)?t.emit("paginationShow",t):t.emit("paginationHide",t),t.pagination.$el.toggleClass(t.params.pagination.hiddenClass))}}},{name:"scrollbar",params:{scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag"}},create:function(){var e=this;te.extend(e,{scrollbar:{init:B.init.bind(e),destroy:B.destroy.bind(e),updateSize:B.updateSize.bind(e),setTranslate:B.setTranslate.bind(e),setTransition:B.setTransition.bind(e),enableDraggable:B.enableDraggable.bind(e),disableDraggable:B.disableDraggable.bind(e),setDragPosition:B.setDragPosition.bind(e),getPointerPosition:B.getPointerPosition.bind(e),onDragStart:B.onDragStart.bind(e),onDragMove:B.onDragMove.bind(e),onDragEnd:B.onDragEnd.bind(e),isTouched:!1,timeout:null,dragTimeout:null}})},on:{init:function(){this.scrollbar.init(),this.scrollbar.updateSize(),this.scrollbar.setTranslate()},update:function(){this.scrollbar.updateSize()},resize:function(){this.scrollbar.updateSize()},observerUpdate:function(){this.scrollbar.updateSize()},setTranslate:function(){this.scrollbar.setTranslate()},setTransition:function(e){this.scrollbar.setTransition(e)},destroy:function(){this.scrollbar.destroy()}}},{name:"parallax",params:{parallax:{enabled:!1}},create:function(){te.extend(this,{parallax:{setTransform:X.setTransform.bind(this),setTranslate:X.setTranslate.bind(this),setTransition:X.setTransition.bind(this)}})},on:{beforeInit:function(){this.params.parallax.enabled&&(this.params.watchSlidesProgress=!0,this.originalParams.watchSlidesProgress=!0)},init:function(){this.params.parallax.enabled&&this.parallax.setTranslate()},setTranslate:function(){this.params.parallax.enabled&&this.parallax.setTranslate()},setTransition:function(e){this.params.parallax.enabled&&this.parallax.setTransition(e)}}},{name:"zoom",params:{zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}},create:function(){var i=this,t={enabled:!1,scale:1,currentScale:1,isScaling:!1,gesture:{$slideEl:void 0,slideWidth:void 0,slideHeight:void 0,$imageEl:void 0,$imageWrapEl:void 0,maxRatio:3},image:{isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},velocity:{x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0}};"onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function(e){t[e]=V[e].bind(i)}),te.extend(i,{zoom:t});var s=1;Object.defineProperty(i.zoom,"scale",{get:function(){return s},set:function(e){if(s!==e){var t=i.zoom.gesture.$imageEl?i.zoom.gesture.$imageEl[0]:void 0,a=i.zoom.gesture.$slideEl?i.zoom.gesture.$slideEl[0]:void 0;i.emit("zoomChange",e,t,a)}s=e}})},on:{init:function(){this.params.zoom.enabled&&this.zoom.enable()},destroy:function(){this.zoom.disable()},touchStart:function(e){this.zoom.enabled&&this.zoom.onTouchStart(e)},touchEnd:function(e){this.zoom.enabled&&this.zoom.onTouchEnd(e)},doubleTap:function(e){this.params.zoom.enabled&&this.zoom.enabled&&this.params.zoom.toggle&&this.zoom.toggle(e)},transitionEnd:function(){this.zoom.enabled&&this.params.zoom.enabled&&this.zoom.onTransitionEnd()}}},{name:"lazy",params:{lazy:{enabled:!1,loadPrevNext:!1,loadPrevNextAmount:1,loadOnTransitionStart:!1,elementClass:"swiper-lazy",loadingClass:"swiper-lazy-loading",loadedClass:"swiper-lazy-loaded",preloaderClass:"swiper-lazy-preloader"}},create:function(){te.extend(this,{lazy:{initialImageLoaded:!1,load:Y.load.bind(this),loadInSlide:Y.loadInSlide.bind(this)}})},on:{beforeInit:function(){this.params.lazy.enabled&&this.params.preloadImages&&(this.params.preloadImages=!1)},init:function(){this.params.lazy.enabled&&!this.params.loop&&0===this.params.initialSlide&&this.lazy.load()},scroll:function(){this.params.freeMode&&!this.params.freeModeSticky&&this.lazy.load()},resize:function(){this.params.lazy.enabled&&this.lazy.load()},scrollbarDragMove:function(){this.params.lazy.enabled&&this.lazy.load()},transitionStart:function(){var e=this;e.params.lazy.enabled&&(!e.params.lazy.loadOnTransitionStart&&(e.params.lazy.loadOnTransitionStart||e.lazy.initialImageLoaded)||e.lazy.load())},transitionEnd:function(){this.params.lazy.enabled&&!this.params.lazy.loadOnTransitionStart&&this.lazy.load()}}},{name:"controller",params:{controller:{control:void 0,inverse:!1,by:"slide"}},create:function(){var e=this;te.extend(e,{controller:{control:e.params.controller.control,getInterpolateFunction:F.getInterpolateFunction.bind(e),setTranslate:F.setTranslate.bind(e),setTransition:F.setTransition.bind(e)}})},on:{update:function(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline)},resize:function(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline)},observerUpdate:function(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline)},setTranslate:function(e,t){this.controller.control&&this.controller.setTranslate(e,t)},setTransition:function(e,t){this.controller.control&&this.controller.setTransition(e,t)}}},{name:"a11y",params:{a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}"}},create:function(){var t=this;te.extend(t,{a11y:{liveRegion:L('<span class="'+t.params.a11y.notificationClass+'" aria-live="assertive" aria-atomic="true"></span>')}}),Object.keys(R).forEach(function(e){t.a11y[e]=R[e].bind(t)})},on:{init:function(){this.params.a11y.enabled&&(this.a11y.init(),this.a11y.updateNavigation())},toEdge:function(){this.params.a11y.enabled&&this.a11y.updateNavigation()},fromEdge:function(){this.params.a11y.enabled&&this.a11y.updateNavigation()},paginationUpdate:function(){this.params.a11y.enabled&&this.a11y.updatePagination()},destroy:function(){this.params.a11y.enabled&&this.a11y.destroy()}}},{name:"history",params:{history:{enabled:!1,replaceState:!1,key:"slides"}},create:function(){var e=this;te.extend(e,{history:{init:q.init.bind(e),setHistory:q.setHistory.bind(e),setHistoryPopState:q.setHistoryPopState.bind(e),scrollToSlide:q.scrollToSlide.bind(e),destroy:q.destroy.bind(e)}})},on:{init:function(){this.params.history.enabled&&this.history.init()},destroy:function(){this.params.history.enabled&&this.history.destroy()},transitionEnd:function(){this.history.initialized&&this.history.setHistory(this.params.history.key,this.activeIndex)}}},{name:"hash-navigation",params:{hashNavigation:{enabled:!1,replaceState:!1,watchState:!1}},create:function(){var e=this;te.extend(e,{hashNavigation:{initialized:!1,init:W.init.bind(e),destroy:W.destroy.bind(e),setHash:W.setHash.bind(e),onHashCange:W.onHashCange.bind(e)}})},on:{init:function(){this.params.hashNavigation.enabled&&this.hashNavigation.init()},destroy:function(){this.params.hashNavigation.enabled&&this.hashNavigation.destroy()},transitionEnd:function(){this.hashNavigation.initialized&&this.hashNavigation.setHash()}}},{name:"autoplay",params:{autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1}},create:function(){var t=this;te.extend(t,{autoplay:{running:!1,paused:!1,run:j.run.bind(t),start:j.start.bind(t),stop:j.stop.bind(t),pause:j.pause.bind(t),onTransitionEnd:function(e){t&&!t.destroyed&&t.$wrapperEl&&e.target===this&&(t.$wrapperEl[0].removeEventListener("transitionend",t.autoplay.onTransitionEnd),t.$wrapperEl[0].removeEventListener("webkitTransitionEnd",t.autoplay.onTransitionEnd),t.autoplay.paused=!1,t.autoplay.running?t.autoplay.run():t.autoplay.stop())}}})},on:{init:function(){this.params.autoplay.enabled&&this.autoplay.start()},beforeTransitionStart:function(e,t){this.autoplay.running&&(t||!this.params.autoplay.disableOnInteraction?this.autoplay.pause(e):this.autoplay.stop())},sliderFirstMove:function(){this.autoplay.running&&(this.params.autoplay.disableOnInteraction?this.autoplay.stop():this.autoplay.pause())},destroy:function(){this.autoplay.running&&this.autoplay.stop()}}},{name:"effect-fade",params:{fadeEffect:{crossFade:!1}},create:function(){te.extend(this,{fadeEffect:{setTranslate:U.setTranslate.bind(this),setTransition:U.setTransition.bind(this)}})},on:{beforeInit:function(){var e=this;if("fade"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"fade");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};te.extend(e.params,t),te.extend(e.originalParams,t)}},setTranslate:function(){"fade"===this.params.effect&&this.fadeEffect.setTranslate()},setTransition:function(e){"fade"===this.params.effect&&this.fadeEffect.setTransition(e)}}},{name:"effect-cube",params:{cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}},create:function(){te.extend(this,{cubeEffect:{setTranslate:K.setTranslate.bind(this),setTransition:K.setTransition.bind(this)}})},on:{beforeInit:function(){var e=this;if("cube"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"cube"),e.classNames.push(e.params.containerModifierClass+"3d");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0};te.extend(e.params,t),te.extend(e.originalParams,t)}},setTranslate:function(){"cube"===this.params.effect&&this.cubeEffect.setTranslate()},setTransition:function(e){"cube"===this.params.effect&&this.cubeEffect.setTransition(e)}}},{name:"effect-flip",params:{flipEffect:{slideShadows:!0,limitRotation:!0}},create:function(){te.extend(this,{flipEffect:{setTranslate:_.setTranslate.bind(this),setTransition:_.setTransition.bind(this)}})},on:{beforeInit:function(){var e=this;if("flip"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"flip"),e.classNames.push(e.params.containerModifierClass+"3d");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};te.extend(e.params,t),te.extend(e.originalParams,t)}},setTranslate:function(){"flip"===this.params.effect&&this.flipEffect.setTranslate()},setTransition:function(e){"flip"===this.params.effect&&this.flipEffect.setTransition(e)}}},{name:"effect-coverflow",params:{coverflowEffect:{rotate:50,stretch:0,depth:100,modifier:1,slideShadows:!0}},create:function(){te.extend(this,{coverflowEffect:{setTranslate:Z.setTranslate.bind(this),setTransition:Z.setTransition.bind(this)}})},on:{beforeInit:function(){var e=this;"coverflow"===e.params.effect&&(e.classNames.push(e.params.containerModifierClass+"coverflow"),e.classNames.push(e.params.containerModifierClass+"3d"),e.params.watchSlidesProgress=!0,e.originalParams.watchSlidesProgress=!0)},setTranslate:function(){"coverflow"===this.params.effect&&this.coverflowEffect.setTranslate()},setTransition:function(e){"coverflow"===this.params.effect&&this.coverflowEffect.setTransition(e)}}},{name:"thumbs",params:{thumbs:{swiper:null,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-container-thumbs"}},create:function(){te.extend(this,{thumbs:{swiper:null,init:Q.init.bind(this),update:Q.update.bind(this),onThumbClick:Q.onThumbClick.bind(this)}})},on:{beforeInit:function(){var e=this.params.thumbs;e&&e.swiper&&(this.thumbs.init(),this.thumbs.update(!0))},slideChange:function(){this.thumbs.swiper&&this.thumbs.update()},update:function(){this.thumbs.swiper&&this.thumbs.update()},resize:function(){this.thumbs.swiper&&this.thumbs.update()},observerUpdate:function(){this.thumbs.swiper&&this.thumbs.update()},setTransition:function(e){var t=this.thumbs.swiper;t&&t.setTransition(e)},beforeDestroy:function(){var e=this.thumbs.swiper;e&&this.thumbs.swiperCreated&&e&&e.destroy()}}}];return void 0===S.use&&(S.use=S.Class.use,S.installModule=S.Class.installModule),S.use(J),S});
//# sourceMappingURL=swiper.min.js.map
;(function(root, factory) { // eslint-disable-line no-extra-semi
  var deepDiff = factory(root);
  // eslint-disable-next-line no-undef
  if (typeof define === 'function' && define.amd) {
      // AMD
      define('DeepDiff', function() { // eslint-disable-line no-undef
          return deepDiff;
      });
  } else if (typeof exports === 'object' || typeof navigator === 'object' && navigator.product.match(/ReactNative/i)) {
      // Node.js or ReactNative
      module.exports = deepDiff;
  } else {
      // Browser globals
      var _deepdiff = root.DeepDiff;
      deepDiff.noConflict = function() {
          if (root.DeepDiff === deepDiff) {
              root.DeepDiff = _deepdiff;
          }
          return deepDiff;
      };
      root.DeepDiff = deepDiff;
  }
}(this, function(root) {
  var validKinds = ['N', 'E', 'A', 'D'];

  // nodejs compatible on server side and in the browser.
  function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  }

  function Diff(kind, path) {
    Object.defineProperty(this, 'kind', {
      value: kind,
      enumerable: true
    });
    if (path && path.length) {
      Object.defineProperty(this, 'path', {
        value: path,
        enumerable: true
      });
    }
  }

  function DiffEdit(path, origin, value) {
    DiffEdit.super_.call(this, 'E', path);
    Object.defineProperty(this, 'lhs', {
      value: origin,
      enumerable: true
    });
    Object.defineProperty(this, 'rhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffEdit, Diff);

  function DiffNew(path, value) {
    DiffNew.super_.call(this, 'N', path);
    Object.defineProperty(this, 'rhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffNew, Diff);

  function DiffDeleted(path, value) {
    DiffDeleted.super_.call(this, 'D', path);
    Object.defineProperty(this, 'lhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffDeleted, Diff);

  function DiffArray(path, index, item) {
    DiffArray.super_.call(this, 'A', path);
    Object.defineProperty(this, 'index', {
      value: index,
      enumerable: true
    });
    Object.defineProperty(this, 'item', {
      value: item,
      enumerable: true
    });
  }
  inherits(DiffArray, Diff);

  function arrayRemove(arr, from, to) {
    var rest = arr.slice((to || from) + 1 || arr.length);
    arr.length = from < 0 ? arr.length + from : from;
    arr.push.apply(arr, rest);
    return arr;
  }

  function realTypeOf(subject) {
    var type = typeof subject;
    if (type !== 'object') {
      return type;
    }

    if (subject === Math) {
      return 'math';
    } else if (subject === null) {
      return 'null';
    } else if (Array.isArray(subject)) {
      return 'array';
    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
      return 'date';
    } else if (typeof subject.toString === 'function' && /^\/.*\//.test(subject.toString())) {
      return 'regexp';
    }
    return 'object';
  }

  // http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
  function hashThisString(string) {
    var hash = 0;
    if (string.length === 0) { return hash; }
    for (var i = 0; i < string.length; i++) {
      var char = string.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  }

  // Gets a hash of the given object in an array order-independent fashion
  // also object key order independent (easier since they can be alphabetized)
  function getOrderIndependentHash(object) {
    var accum = 0;
    var type = realTypeOf(object);

    if (type === 'array') {
      object.forEach(function (item) {
        // Addition is commutative so this is order indep
        accum += getOrderIndependentHash(item);
      });

      var arrayString = '[type: array, hash: ' + accum + ']';
      return accum + hashThisString(arrayString);
    }

    if (type === 'object') {
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          var keyValueString = '[ type: object, key: ' + key + ', value hash: ' + getOrderIndependentHash(object[key]) + ']';
          accum += hashThisString(keyValueString);
        }
      }

      return accum;
    }

    // Non object, non array...should be good?
    var stringToHash = '[ type: ' + type + ' ; value: ' + object + ']';
    return accum + hashThisString(stringToHash);
  }

  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack, orderIndependent) {
    changes = changes || [];
    path = path || [];
    stack = stack || [];
    var currentPath = path.slice(0);
    if (typeof key !== 'undefined' && key !== null) {
      if (prefilter) {
        if (typeof (prefilter) === 'function' && prefilter(currentPath, key)) {
          return;
        } else if (typeof (prefilter) === 'object') {
          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) {
            return;
          }
          if (prefilter.normalize) {
            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
            if (alt) {
              lhs = alt[0];
              rhs = alt[1];
            }
          }
        }
      }
      currentPath.push(key);
    }

    // Use string comparison for regexes
    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
      lhs = lhs.toString();
      rhs = rhs.toString();
    }

    var ltype = typeof lhs;
    var rtype = typeof rhs;
    var i, j, k, other;

    var ldefined = ltype !== 'undefined' ||
      (stack && (stack.length > 0) && stack[stack.length - 1].lhs &&
        Object.getOwnPropertyDescriptor(stack[stack.length - 1].lhs, key));
    var rdefined = rtype !== 'undefined' ||
      (stack && (stack.length > 0) && stack[stack.length - 1].rhs &&
        Object.getOwnPropertyDescriptor(stack[stack.length - 1].rhs, key));

    if (!ldefined && rdefined) {
      changes.push(new DiffNew(currentPath, rhs));
    } else if (!rdefined && ldefined) {
      changes.push(new DiffDeleted(currentPath, lhs));
    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
      changes.push(new DiffEdit(currentPath, lhs, rhs));
    } else if (realTypeOf(lhs) === 'date' && (lhs - rhs) !== 0) {
      changes.push(new DiffEdit(currentPath, lhs, rhs));
    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
      for (i = stack.length - 1; i > -1; --i) {
        if (stack[i].lhs === lhs) {
          other = true;
          break;
        }
      }
      if (!other) {
        stack.push({ lhs: lhs, rhs: rhs });
        if (Array.isArray(lhs)) {
          // If order doesn't matter, we need to sort our arrays
          if (orderIndependent) {
            lhs.sort(function (a, b) {
              return getOrderIndependentHash(a) - getOrderIndependentHash(b);
            });

            rhs.sort(function (a, b) {
              return getOrderIndependentHash(a) - getOrderIndependentHash(b);
            });
          }
          i = rhs.length - 1;
          j = lhs.length - 1;
          while (i > j) {
            changes.push(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i--])));
          }
          while (j > i) {
            changes.push(new DiffArray(currentPath, j, new DiffDeleted(undefined, lhs[j--])));
          }
          for (; i >= 0; --i) {
            deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack, orderIndependent);
          }
        } else {
          var akeys = Object.keys(lhs).concat(Object.getOwnPropertySymbols(lhs));
          var pkeys = Object.keys(rhs).concat(Object.getOwnPropertySymbols(rhs));
          for (i = 0; i < akeys.length; ++i) {
            k = akeys[i];
            other = pkeys.indexOf(k);
            if (other >= 0) {
              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
              pkeys[other] = null;
            } else {
              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack, orderIndependent);
            }
          }
          for (i = 0; i < pkeys.length; ++i) {
            k = pkeys[i];
            if (k) {
              deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
            }
          }
        }
        stack.length = stack.length - 1;
      } else if (lhs !== rhs) {
        // lhs is contains a cycle at this element and it differs from rhs
        changes.push(new DiffEdit(currentPath, lhs, rhs));
      }
    } else if (lhs !== rhs) {
      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
        changes.push(new DiffEdit(currentPath, lhs, rhs));
      }
    }
  }

  function observableDiff(lhs, rhs, observer, prefilter, orderIndependent) {
    var changes = [];
    deepDiff(lhs, rhs, changes, prefilter, null, null, null, orderIndependent);
    if (observer) {
      for (var i = 0; i < changes.length; ++i) {
        observer(changes[i]);
      }
    }
    return changes;
  }

  function orderIndependentDeepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
    return deepDiff(lhs, rhs, changes, prefilter, path, key, stack, true);
  }

  function accumulateDiff(lhs, rhs, prefilter, accum) {
    var observer = (accum) ?
      function (difference) {
        if (difference) {
          accum.push(difference);
        }
      } : undefined;
    var changes = observableDiff(lhs, rhs, observer, prefilter);
    return (accum) ? accum : (changes.length) ? changes : undefined;
  }

  function accumulateOrderIndependentDiff(lhs, rhs, prefilter, accum) {
    var observer = (accum) ?
      function (difference) {
        if (difference) {
          accum.push(difference);
        }
      } : undefined;
    var changes = observableDiff(lhs, rhs, observer, prefilter, true);
    return (accum) ? accum : (changes.length) ? changes : undefined;
  }

  function applyArrayChange(arr, index, change) {
    if (change.path && change.path.length) {
      var it = arr[index],
        i, u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          applyArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          delete it[change.path[i]];
          break;
        case 'E':
        case 'N':
          it[change.path[i]] = change.rhs;
          break;
      }
    } else {
      switch (change.kind) {
        case 'A':
          applyArrayChange(arr[index], change.index, change.item);
          break;
        case 'D':
          arr = arrayRemove(arr, index);
          break;
        case 'E':
        case 'N':
          arr[index] = change.rhs;
          break;
      }
    }
    return arr;
  }

  function applyChange(target, source, change) {
    if (typeof change === 'undefined' && source && ~validKinds.indexOf(source.kind)) {
      change = source;
    }
    if (target && change && change.kind) {
      var it = target,
        i = -1,
        last = change.path ? change.path.length - 1 : 0;
      while (++i < last) {
        if (typeof it[change.path[i]] === 'undefined') {
          it[change.path[i]] = (typeof change.path[i + 1] !== 'undefined' && typeof change.path[i + 1] === 'number') ? [] : {};
        }
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          if (change.path && typeof it[change.path[i]] === 'undefined') {
            it[change.path[i]] = [];
          }
          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
          break;
        case 'D':
          delete it[change.path[i]];
          break;
        case 'E':
        case 'N':
          it[change.path[i]] = change.rhs;
          break;
      }
    }
  }

  function revertArrayChange(arr, index, change) {
    if (change.path && change.path.length) {
      // the structure of the object at the index has changed...
      var it = arr[index],
        i, u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          revertArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          it[change.path[i]] = change.lhs;
          break;
        case 'E':
          it[change.path[i]] = change.lhs;
          break;
        case 'N':
          delete it[change.path[i]];
          break;
      }
    } else {
      // the array item is different...
      switch (change.kind) {
        case 'A':
          revertArrayChange(arr[index], change.index, change.item);
          break;
        case 'D':
          arr[index] = change.lhs;
          break;
        case 'E':
          arr[index] = change.lhs;
          break;
        case 'N':
          arr = arrayRemove(arr, index);
          break;
      }
    }
    return arr;
  }

  function revertChange(target, source, change) {
    if (target && source && change && change.kind) {
      var it = target,
        i, u;
      u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        if (typeof it[change.path[i]] === 'undefined') {
          it[change.path[i]] = {};
        }
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          // Array was modified...
          // it will be an array...
          revertArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          // Item was deleted...
          it[change.path[i]] = change.lhs;
          break;
        case 'E':
          // Item was edited...
          it[change.path[i]] = change.lhs;
          break;
        case 'N':
          // Item is new...
          delete it[change.path[i]];
          break;
      }
    }
  }

  function applyDiff(target, source, filter) {
    if (target && source) {
      var onChange = function (change) {
        if (!filter || filter(target, source, change)) {
          applyChange(target, source, change);
        }
      };
      observableDiff(target, source, onChange);
    }
  }

  Object.defineProperties(accumulateDiff, {

    diff: {
      value: accumulateDiff,
      enumerable: true
    },
    orderIndependentDiff: {
      value: accumulateOrderIndependentDiff,
      enumerable: true
    },
    observableDiff: {
      value: observableDiff,
      enumerable: true
    },
    orderIndependentObservableDiff: {
      value: orderIndependentDeepDiff,
      enumerable: true
    },
    orderIndepHash: {
      value: getOrderIndependentHash,
      enumerable: true
    },
    applyDiff: {
      value: applyDiff,
      enumerable: true
    },
    applyChange: {
      value: applyChange,
      enumerable: true
    },
    revertChange: {
      value: revertChange,
      enumerable: true
    },
    isConflict: {
      value: function () {
        return typeof $conflict !== 'undefined';
      },
      enumerable: true
    }
  });

  // hackish...
  accumulateDiff.DeepDiff = accumulateDiff;
  // ...but works with:
  // import DeepDiff from 'deep-diff'
  // import { DeepDiff } from 'deep-diff'
  // const DeepDiff = require('deep-diff');
  // const { DeepDiff } = require('deep-diff');

  if (root) {
    root.DeepDiff = accumulateDiff;
  }

  return accumulateDiff;
}));

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MainCtrl
    * @description
    * # MainCtrl
    * Controller of the mhclientApp
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('MainCtrl', ["$scope", "$locale", "$uibModal", "$state", "$window", "$anchorScroll", "User", "$filter", "$rootScope", "$location", "user", "redirectUtils", "userFeatures", "SiteVarsUtils", "PrescUtils", "defaultMenu", "DefaultGrpFeatPerms", "alertUtils", "FeedUtils", "$http", "MhConfig", "UserCreation", "$stateParams", "TeleconsultationService", "EquipmentOnRent", "EquipmentCatalog", "SiteVar", function($scope, $locale, $uibModal, $state, $window, $anchorScroll, User, $filter, $rootScope, $location, user, redirectUtils, userFeatures, SiteVarsUtils, PrescUtils, defaultMenu, DefaultGrpFeatPerms, alertUtils, FeedUtils, $http, MhConfig, UserCreation, $stateParams, TeleconsultationService, EquipmentOnRent, EquipmentCatalog, SiteVar) {
    $scope.updateMenu = function(item, menu) {
      var index;
      index = _.indexOf(menu.newMenu.shortCuts, _.find(menu.newMenu.shortCuts, {
        name: item.name
      }));
      menu.newMenu.shortCuts.splice(index, 1);
      if (menu.isPatient) {
        $rootScope.user.config.patient_shortcuts = _.map(menu.newMenu.shortCuts, 'name');
      } else {
        $rootScope.user.config.user_shortcuts = _.map(menu.newMenu.shortCuts, 'name');
      }
      UserCreation.updateConfig({
        id: $rootScope.user.id
      }, {
        config: $rootScope.user.config
      });
      return true;
    };
    $scope.openExternalLink = function(feature) {
      var form, input, login, patientIpp, url;
      url = feature.metadata.url;
      if (url.includes('cyberlab')) {
        login = $rootScope.user.username;
        patientIpp = $rootScope.currentPatient.si_id;
        form = document.createElement('form');
        form.method = 'post';
        form.action = url;
        form.target = '_blank';
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'Class';
        input.value = 'Patient';
        form.appendChild(input);
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'Password';
        input.value = 'US';
        form.appendChild(input);
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'Object';
        input.value = patientIpp;
        form.appendChild(input);
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'LoginName';
        input.value = login;
        form.appendChild(input);
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'Method';
        input.value = 'ViewReport';
        form.appendChild(input);
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'OnClose';
        input.value = 'Login.jsp';
        form.appendChild(input);
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'Application';
        input.value = 'HTML_RESULTATS';
        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      } else {
        window.open(url, '_blank');
      }
      return true;
    };
    $scope.dndDropedMenu = function(item, menu, index, dropEffect) {
      var featureItem, oldIndex, ref, ref1;
      if (dropEffect === "move") {
        featureItem = _.find(menu.newMenu.shortCuts, {
          name: item.name
        });
        oldIndex = _.indexOf(menu.newMenu.shortCuts, featureItem);
        if (oldIndex < index) {
          menu.newMenu.shortCuts.splice(index, 0, featureItem);
          menu.newMenu.shortCuts.splice(oldIndex, 1);
        } else {
          menu.newMenu.shortCuts.splice(oldIndex, 1);
          menu.newMenu.shortCuts.splice(index, 0, featureItem);
        }
      } else {
        featureItem = _.find($rootScope.user.userFeatures, {
          name: item.name
        }) || item;
        if (menu.isPatient) {
          if (ref = featureItem.name, indexOf.call($rootScope.user.config.patient_shortcuts || [], ref) >= 0) {
            return false;
          }
        } else {
          if (ref1 = featureItem.name, indexOf.call($rootScope.user.config.user_shortcuts || [], ref1) >= 0) {
            return false;
          }
        }
        menu.newMenu.shortCuts.splice(index, 0, featureItem);
      }
      if (menu.isPatient) {
        $rootScope.user.config.patient_shortcuts = _.map(menu.newMenu.shortCuts, 'name');
      } else {
        $rootScope.user.config.user_shortcuts = _.map(menu.newMenu.shortCuts, 'name');
      }
      UserCreation.updateConfig({
        id: $rootScope.user.id
      }, {
        config: $rootScope.user.config
      });
      return true;
    };
    $scope.showMenu = function() {
      var modalMenu;
      return modalMenu = $uibModal.open({
        templateUrl: 'core/views/modal-menu.html',
        backdrop: 'true',
        controller: 'MenuModalCtrl',
        animation: false,
        windowClass: 'modal-menu',
        resolve: {
          updateMenu: function() {
            return $scope.updateMenu;
          },
          dndDropedMenu: function() {
            return $scope.dndDropedMenu;
          },
          openExternalLink: function() {
            return $scope.openExternalLink;
          }
        }
      });
    };
    $scope.user = user;
    $rootScope.user = user;
    $rootScope.user.userFeatures = userFeatures;
    $rootScope.menuOptions = {
      hideAlertDetails: false,
      hideInfoDetails: false
    };
    $rootScope.stayStatusOptions = [
      {
        name: $filter('translate')('PREAD'),
        value: 'PRE'
      }, {
        name: $filter('translate')('ACTIVE'),
        value: 'ADM'
      }, {
        name: $filter('translate')('INACTIVE'),
        value: 'I'
      }, {
        name: $filter('translate')('CLOSED'),
        value: 'CLOSE'
      }
    ];
    $rootScope.showHistory = function(presc) {
      return $uibModal.open({
        templateUrl: 'medication/views/presc-history_modal.html',
        controller: 'PrescriptionHistoryCtrl',
        scope: $scope,
        resolve: {
          prescription: presc
        }
      });
    };
    $rootScope.lockMenu = function(lock) {
      if ($rootScope.mh_config.platform === "mgapp") {
        return $window.mgapp.lock_menu(lock);
      }
    };
    $rootScope.checkPermissions = function(feature, method) {
      return indexOf.call($scope.group_feature_permissions[feature] || [], method) >= 0;
    };
    if ($rootScope.mh_config.platform === "mhsi") {
      SiteVar.getVersionInfo().$promise.then(function(versionInfo) {
        return $rootScope.versionInfo = versionInfo;
      });
      SiteVarsUtils.get("VISIO_SERVER", false).then(function(visioConfig) {
        if (visioConfig && visioConfig.value) {
          return TeleconsultationService.init("/mhlive/get_visio_token", visioConfig.value.endpoint).then(function(service) {
            $scope.visioReady = true;
          });
        }
      });
    }
    EquipmentCatalog.resetCache();
    PrescUtils.resetCache();
    FeedUtils.resetCache();
    SiteVarsUtils.get("ALLOW_SHOW_ALL_STAYS", true).then(function(allowShowAllStays) {
      return $rootScope.allowShowAllStays = allowShowAllStays.value;
    });
    SiteVarsUtils.get("COMPANY_INFO", true).then(function(companyInfo) {
      return $rootScope.companyInfo = companyInfo.value;
    });
    SiteVarsUtils.get("PAC_DATA_STRUCT", []).then(function(pac_data_struct) {
      var custom_fields_detail_values, field, field_dict, i, j, len, len1, ref, ref1, tab, tab_dict;
      custom_fields_detail_values = [];
      ref = pac_data_struct.value;
      for (i = 0, len = ref.length; i < len; i++) {
        tab = ref[i];
        tab_dict = {
          'id': tab.ID,
          'title': tab.LABEL,
          'fields': []
        };
        ref1 = tab.FIELDS;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          field = ref1[j];
          field_dict = {
            'id': field.ID,
            'type': field.TYPE,
            'label': field.LABEL,
            'warning': field.WARNING,
            'isPrescInfo': indexOf.call(field.FLAGS, 'SHOW_IN_PRESC') >= 0
          };
          if (field.TYPE === 'SELECT') {
            field_dict.data = field.DATA;
          }
          tab_dict.fields.push(field_dict);
        }
        if (tab_dict.fields) {
          custom_fields_detail_values.push(tab_dict);
        }
      }
      return $rootScope.custom_fields_detail_values = custom_fields_detail_values;
    });
    $scope.redirectToEvent = function(event) {
      return redirectUtils.redirectToAlert(event);
    };
    $scope.confirmAlert = function(event, container) {
      return alertUtils.confirmAlert(event, container);
    };
    $rootScope.busy = false;
    $rootScope.selectStay = function() {
      return $uibModal.open({
        templateUrl: 'stay/views/stay-select-template.html',
        controller: 'StayModalSelectCtrl',
        backdrop: 'static',
        resolve: {
          stays: function() {
            return $rootScope.currentPatientStays;
          },
          currentStay: function() {
            return $rootScope.currentStay;
          },
          patientNewEvents: function() {
            return $rootScope.patientNewEvents;
          }
        }
      });
    };
    $scope.base_iframe_url = $location.protocol() + '://' + $location.host() + ':' + $location.port();
    SiteVarsUtils.get("ALLOW_PATIENT_IDENTITY_CHECK", false).then(function(patientIdentityCheck) {
      return $rootScope.allowPatientIdentityCheck = patientIdentityCheck.value;
    });
    $locale.DATETIME_FORMATS.mhcareMedium = _.startsWith($locale.id, 'fr-') ? "d MMM y à HH:mm" : "d MMM y HH:mm:ss";
    $rootScope.DATETIME_FORMATS = angular.copy($locale.DATETIME_FORMATS);
    $rootScope.ORIGINAL_DATETIME_FORMATS = angular.copy($locale.DATETIME_FORMATS);
    $rootScope.DATETIME_FORMATS.DAY.push($locale.DATETIME_FORMATS.DAY[0]);
    $rootScope.DATETIME_FORMATS.DAY = $scope.DATETIME_FORMATS.DAY.splice(1, 7);
    $rootScope.utils = {
      keys: function(obj) {
        return Object.keys(obj);
      },
      days_from_today: function(date) {
        return moment().diff(moment(date), 'days');
      },
      date_from_string: function(date, dateFormat) {
        return moment(date).format(dateFormat);
      }
    };
    $scope.year = $filter('translate')('year');
    $scope.years = $filter('translate')('years');
    $rootScope.loadPatientInfo = function(patient) {
      var modalInstance;
      if (!$scope.user.user_profile.can_see_patient_info) {
        return;
      }
      return modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'patient/views/user-patient-detail.html',
        controller: 'PatientInfoCtrl',
        windowClass: 'patient-data-modal'
      });
    };
    $scope.clickLeftMenuItem = function() {
      return $scope.$broadcast('reduceSlideMenu');
    };
    $scope.group_feature_permissions = _.pick($scope.user.group.feature_permissions, _.map($rootScope.user.userFeatures, "name"));
    if (Object.keys($scope.group_feature_permissions).length === 0) {
      $scope.group_feature_permissions = DefaultGrpFeatPerms.get();
    }
    if ($rootScope.mh_config.platform === "mgapp") {
      window.mgappClose = window.mgapp.close_screen;
      window.mgappConfirmQuit = window.mgapp.quit_view;
    }
    $scope.ik_range = _.range(0, 110, 10);
    $scope.avq_range = _.range(6, 25);
    $rootScope.removeKey = function(item, key) {
      return delete item[key];
    };
    $rootScope.removeFromArray = function(array, item) {
      return array.splice(array.indexOf(item), 1);
    };
    $rootScope.find = function(array, query) {
      return _.find(array, query);
    };
    $rootScope.filter = function(array, query) {
      return _.filter(array, query);
    };
    $rootScope.range = function(size, offset) {
      return _.map(_.range(size), function(index) {
        return index + (offset || 0);
      });
    };
    $rootScope.reject = function(array, query) {
      return _.reject(array, query);
    };
    $rootScope.map = function(array, keys) {
      return _.map(array, keys);
    };
    $rootScope.cloneDeep = function(item) {
      return _.cloneDeep(item);
    };
    $rootScope.checkIn = function(array, item) {
      return indexOf.call(array, item) >= 0;
    };
    $rootScope.isEmpty = function(value) {
      return _.isEmpty(value);
    };
    $rootScope.get = function(item, key) {
      return _.get(item, key);
    };
    $rootScope.getValues = function(obj) {
      return _.values(obj);
    };
    $rootScope.isString = function(obj) {
      return typeof obj === 'string' || obj instanceof String;
    };
    $rootScope.getKeys = function(obj) {
      return Object.keys(obj);
    };
    $rootScope.moveIndex = function(array, index, offset) {
      return array.splice(index + offset, 0, array.splice(index, 1)[0]);
    };
    $rootScope.typeIsArray = function(value) {
      return value && typeof value === 'object' && value instanceof Array && typeof value.length === 'number' && typeof value.splice === 'function' && !(value.propertyIsEnumerable('length'));
    };
    $rootScope.gotToTop = function() {
      $location.hash('top');
      return $anchorScroll();
    };
    return $rootScope.countWatchers = function() {
      var f, root, watchers, watchersWithoutDuplicates;
      root = angular.element(document.getElementsByTagName('body'));
      watchers = [];
      f = function(element) {
        angular.forEach(['$scope', '$isolateScope'], function(scopeProperty) {
          if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
            angular.forEach(element.data()[scopeProperty].$$watchers, function(watcher) {
              watchers.push(watcher);
            });
          }
        });
        angular.forEach(element.children(), function(childElement) {
          f(angular.element(childElement));
        });
      };
      f(root);
      watchersWithoutDuplicates = [];
      angular.forEach(watchers, function(item) {
        if (watchersWithoutDuplicates.indexOf(item) < 0) {
          watchersWithoutDuplicates.push(item);
        }
      });
      console.log(watchersWithoutDuplicates.length);
      console.log(watchersWithoutDuplicates);
    };
  }]);

}).call(this);

//# sourceMappingURL=main.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:customDebounce
    * @description
    * #
    * Directive for custom debounce
   */
  angular.module('mhclientApp').directive('customDebounce', ["$timeout", function($timeout) {
    return {
      link: function(scope, element, attributes) {
        var timer;
        timer = false;
        angular.element(element).bind('mouseenter', function(event) {
          return timer = $timeout(function() {
            return scope.$eval(attributes.debounceMouseover);
          }, 200);
        });
        angular.element(element).bind('mouseleave', function(event) {
          return $timeout.cancel(timer);
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=custom-debounce-directive.js.map

(function() {
  'use strict';
  angular.module("mhclientApp").factory('cacheService', ["SiteVarsUtils", "PrescUtils", "UserUtils", "alertUtils", "Sector", "FeatureUtils", "FormTemplateUtils", "FeedUtils", "GroupUtils", "MedFormsUtils", "MedicalUnit", "EquipmentCatalog", "PatientMeasuresTypes", "BillingUnitUtils", function(SiteVarsUtils, PrescUtils, UserUtils, alertUtils, Sector, FeatureUtils, FormTemplateUtils, FeedUtils, GroupUtils, MedFormsUtils, MedicalUnit, EquipmentCatalog, PatientMeasuresTypes, BillingUnitUtils) {
    var resetCache, service;
    resetCache = function() {
      SiteVarsUtils.resetCache();
      PrescUtils.resetCache();
      UserUtils.cleanCache();
      alertUtils.resetCache();
      FeatureUtils.resetCache();
      FeedUtils.resetCache();
      FormTemplateUtils.resetCache();
      MedFormsUtils.resetCache();
      MedicalUnit.resetCache();
      EquipmentCatalog.resetCache();
      PatientMeasuresTypes.resetCache();
      Sector.resetCache();
      GroupUtils.resetCache();
      return BillingUnitUtils.resetCache();
    };
    service = {
      resetCache: resetCache
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=cache-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:printCtrl
    * @description
    * # printCtrl
    * Provider of printCtrl
   */
  angular.module("mhclientApp").controller('PrintCtrl', ["$scope", "$window", "$sce", "$timeout", function($scope, $window, $sce, $timeout) {
    var init;
    init = function() {
      var i, key, len, ref;
      ref = Object.keys($window.scope);
      for (i = 0, len = ref.length; i < len; i++) {
        key = ref[i];
        if (key.substring(0, 1) !== '$') {
          $scope[key] = $window.scope[key];
        }
      }
      $scope.currentVersion = $window.scope.currentVersion;
      return $scope.htmlPrint = $sce.trustAsHtml($scope.htmlContent);
    };
    init();
    return $timeout(function() {
      return $window.print();
    }, 200);
  }]);

}).call(this);

//# sourceMappingURL=print-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:BoxResource
    * @description
    * # BoxResource
    * Factory of BoxResource
   */
  angular.module("mhclientApp").factory('exportHTML', ["$q", "$filter", function($q, $filter) {
    var allConverted, ctrlScope, exportAsHTML, replaceCanvas, replaceInputs, replaceMHDatePicker, replaceSelects, replaceTextArea;
    ctrlScope = {};
    allConverted = [];
    replaceInputs = function(htmlElmt) {
      return htmlElmt.find('input').replaceWith(function() {
        var attr, i, input, len, model, modelValue, pr, ref, retStr, type, upperModelValue, value;
        pr = $q.defer();
        allConverted.push(pr.promise);
        input = $(this);
        type = input.prop('type');
        model = input.attr("ng-model");
        value = input.prop('value');
        modelValue = ctrlScope.$eval(model);
        retStr = '<input ';
        ref = input[0].attributes;
        for (i = 0, len = ref.length; i < len; i++) {
          attr = ref[i];
          retStr += attr.name;
          retStr += '="';
          retStr += attr.value + '" ';
        }
        switch (type) {
          case "radio":
            if (modelValue != null) {
              if (modelValue.toString() === value) {
                retStr += " checked";
              }
            }
            retStr += '/>';
            break;
          case "checkbox":
            if (modelValue != null) {
              upperModelValue = modelValue.toString().toUpperCase();
              if (upperModelValue === 'YES' || 'OUI' || 'TRUE' || '1') {
                input.prop('checked', true);
                retStr += " checked";
              } else {
                input.prop('checked', false);
              }
            } else {
              input.prop('checked', false);
            }
            retStr += '/>';
            break;
          case "text":
            if (modelValue === void 0) {
              modelValue = "";
            }
            retStr += 'value="' + modelValue + '"';
            retStr += '/>';
        }
        pr.resolve();
        return retStr;
      });
    };
    replaceSelects = function(htmlElmt) {
      return htmlElmt.find('select').replaceWith(function() {
        var attr, i, j, k, len, len1, len2, model, modelValue, opt, pr, ref, ref1, ref2, retStr, select, value;
        pr = $q.defer();
        allConverted.push(pr.promise);
        select = $(this);
        model = select.attr("ng-model");
        modelValue = ctrlScope.$eval(model);
        retStr = '<select ';
        ref = select[0].attributes;
        for (i = 0, len = ref.length; i < len; i++) {
          attr = ref[i];
          retStr += attr.name;
          retStr += '="';
          retStr += attr.value + '" ';
        }
        retStr += '>\n';
        ref1 = select[0];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          opt = ref1[j];
          retStr += '<option ';
          ref2 = opt.attributes;
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            attr = ref2[k];
            retStr += attr.name;
            retStr += '="';
            retStr += attr.value + '" ';
          }
          value = opt.value;
          if (value === modelValue) {
            retStr += 'selected';
          }
          retStr += '>';
          retStr += opt.innerHTML;
          retStr += '</option>';
        }
        retStr += '</select>';
        pr.resolve();
        return retStr;
      });
    };
    replaceTextArea = function(htmlElmt) {
      return htmlElmt.find('textarea').replaceWith(function() {
        var attr, i, len, model, modelValue, pr, ref, retStr, textarea;
        pr = $q.defer();
        allConverted.push(pr.promise);
        textarea = $(this);
        model = textarea.attr("ng-model");
        modelValue = ctrlScope.$eval(model);
        if (modelValue === void 0) {
          modelValue = "";
        }
        retStr = '<textarea ';
        ref = textarea[0].attributes;
        for (i = 0, len = ref.length; i < len; i++) {
          attr = ref[i];
          retStr += attr.name;
          retStr += '="';
          retStr += attr.value + '" ';
        }
        retStr += '>';
        retStr += modelValue;
        retStr += '</textarea>';
        pr.resolve();
        return retStr;
      });
    };
    replaceCanvas = function(htmlElmt) {
      return htmlElmt.find('canvas').replaceWith(function() {
        var attr, canvas, i, img, len, pr, ref, retStr;
        pr = $q.defer();
        allConverted.push(pr.promise);
        canvas = $(this);
        img = canvas[0].toDataURL("image/png");
        retStr = '<img src="' + img + '"';
        ref = canvas[0].attributes;
        for (i = 0, len = ref.length; i < len; i++) {
          attr = ref[i];
          retStr += attr.name;
          retStr += '="';
          retStr += attr.value + '" ';
        }
        retStr += '/>';
        pr.resolve();
        return retStr;
      });
    };
    replaceMHDatePicker = function(htmlElmt) {
      return htmlElmt.find('mh-datepicker').replaceWith(function() {
        var attr, datepicker, i, input, len, model, modelValue, pr, ref, retStr, value;
        pr = $q.defer();
        allConverted.push(pr.promise);
        datepicker = $(this);
        input = datepicker.find('input');
        model = datepicker.attr("ng-model");
        modelValue = ctrlScope.$eval(model);
        if (modelValue === void 0 || modelValue === null) {
          value = " ";
        } else {
          value = $filter('date')(modelValue, 'dd/MM/yyyy');
        }
        retStr = '<input ';
        ref = input[0].attributes;
        for (i = 0, len = ref.length; i < len; i++) {
          attr = ref[i];
          if (attr.name !== 'value') {
            retStr += attr.name;
            retStr += '="';
            retStr += attr.value + '" ';
          }
        }
        retStr += 'value="' + value + '"';
        retStr += '>';
        retStr += '</input>';
        pr.resolve();
        return retStr;
      });
    };
    exportAsHTML = function(jqueryElmt, scope) {
      var html;
      ctrlScope = scope;
      html = jqueryElmt;
      replaceInputs(html);
      replaceSelects(html);
      replaceTextArea(html);
      replaceMHDatePicker(html);
      replaceCanvas(html);
      return $q.all(allConverted).then(function() {
        return html[0].outerHTML;
      });
    };
    return {
      exportAsHTML: exportAsHTML
    };
  }]);

}).call(this);

//# sourceMappingURL=export-html.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:kinetic
    * @description
    * # Draw
    * Directive for position fixed top bar
   */
  angular.module('mhclientApp').directive('cuttingPage', ["$window", "$timeout", "PrescUtils", function($window, $timeout, PrescUtils) {
    return {
      link: function(scope, elem, attrs) {
        var adjustPrescriptionRect, canvasForeground, canvasForegroundDrawer, checkForRemovedPrescriptions, checkInside, checkZoomUpdated, drawRect, drawRects, drawbackground, focusLost, getMousePos, getPagePrescription, handleAbsoluteRect, img, isBottomLeftCorner, maxHeight, maxWidth, minHeight, minWidth, selectPrescription, thickness, updateAngle;
        thickness = 10;
        canvasForeground = elem[0];
        canvasForegroundDrawer = canvasForeground.getContext('2d');
        canvasForegroundDrawer.fillStyle = "rgba(225, 72, 32, 0.25)";
        canvasForegroundDrawer.strokeStyle = 'black';
        scope.documentPage.rotationAngle = 0;
        maxWidth = scope.maxWidth;
        maxHeight = scope.maxHeight;
        minWidth = 15;
        minHeight = 15;
        updateAngle = function(newVal, oldVal) {
          scope.documentPage.rotationAngle = newVal;
          return drawbackground(scope.documentPage.rotationAngle);
        };
        drawbackground = function(rotationAngle) {
          var c, canvasBackground, cut, i, imgHeight, imgWidth, len, new_ctx, ref, results, rotationAngleRadians, s, size;
          rotationAngleRadians = rotationAngle * Math.PI / 180;
          canvasBackground = document.getElementById("background_" + scope.documentPage.id);
          imgWidth = img.naturalWidth;
          imgHeight = img.naturalHeight;
          scope.documentPage.width = img.naturalWidth;
          scope.documentPage.height = img.naturalHeight;
          size = {
            width: imgWidth,
            height: imgHeight
          };
          c = Math.abs(Math.cos(-rotationAngleRadians));
          s = Math.abs(Math.sin(-rotationAngleRadians));
          size.width = imgHeight * s + imgWidth * c;
          size.height = imgHeight * c + imgWidth * s;
          scope.documentPage.center = {
            x: size.width / 2,
            y: size.height / 2
          };
          canvasBackground.width = elem.width();
          canvasBackground.height = size.height * (elem.width() / size.width);
          new_ctx = canvasBackground.getContext("2d");
          new_ctx.save();
          new_ctx.translate(canvasBackground.width / 2, canvasBackground.height / 2);
          new_ctx.rotate(-rotationAngleRadians);
          new_ctx.scale(elem.width() / size.width, elem.width() / size.width);
          new_ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
          new_ctx.restore();
          canvasForeground.width = canvasBackground.width;
          canvasForeground.height = canvasBackground.height;
          scope.conversionRatio = size.width / canvasForeground.width;
          drawRects(getPagePrescription(scope.prescriptions));
          ref = getPagePrescription(scope.prescriptions);
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            cut = ref[i];
            results.push(handleAbsoluteRect(cut));
          }
          return results;
        };
        angular.element($window).bind('resize', function() {
          return drawbackground(scope.documentPage.rotationAngle);
        });
        checkForRemovedPrescriptions = function(newData, oldData) {
          if (newData.length < oldData.length) {
            return drawRects(getPagePrescription(scope.prescriptions));
          }
        };
        checkZoomUpdated = function() {
          var cut, i, len, ref, results;
          ref = getPagePrescription(scope.prescriptions);
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            cut = ref[i];
            results.push(handleAbsoluteRect(cut));
          }
          return results;
        };
        getMousePos = function(canvas, evt) {
          var rect;
          rect = canvas.getBoundingClientRect();
          return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
          };
        };
        getPagePrescription = function(prescriptions) {
          var page_prescriptions;
          page_prescriptions = [];
          return _.filter(prescriptions, function(prescription) {
            return prescription.data.document_page.id === scope.documentPage.id;
          });
        };
        selectPrescription = function(prescription) {
          if (scope.currentPrescription) {
            scope.currentPrescription.selected = false;
          }
          scope.currentPrescription = prescription;
          return scope.currentPrescription.selected = true;
        };
        img = document.createElement("img");
        img.src = scope.documentPage.image_url;
        img.onload = function() {
          drawbackground(scope.documentPage.rotationAngle);
          return canvasForeground.onmousedown = function(ev) {
            var cut, i, len, position, ref;
            position = getMousePos(canvasForeground, ev);
            ref = getPagePrescription(scope.prescriptions);
            for (i = 0, len = ref.length; i < len; i++) {
              cut = ref[i];
              if (isBottomLeftCorner(position, cut)) {
                selectPrescription(cut);
                scope.currentPrescription.action = "RESIZING";
                scope.$apply();
                return;
              }
              if (checkInside(position, cut)) {
                selectPrescription(cut);
                scope.currentPrescription.action = "DEPLACE";
                scope.currentPrescription.previous_position = position;
                scope.$apply();
                return;
              }
            }
            selectPrescription(PrescUtils.setupCroppedPrescription(position, scope.documentPage));
            scope.currentPrescription.zoomFactor = 3.0;
            scope.currentPrescription.zoomSliderOptions = {
              step: 0.1,
              hideLimitLabels: true,
              enforceStep: false,
              "floor": 0.5,
              "ceil": 3.0,
              precision: 1,
              hidePointerLabels: true,
              translate: function(minutes) {
                return "";
              }
            };
            scope.prescriptions.push(scope.currentPrescription);
            handleAbsoluteRect(scope.currentPrescription);
            scope.$apply();
            return scope.reCalcViewDimensions();
          };
        };
        checkInside = function(point, rect) {
          return !(point.x < rect.x || point.x > rect.x + rect.width || point.y < rect.y || point.y > rect.y + rect.height);
        };
        isBottomLeftCorner = function(point, rect) {
          var distance;
          distance = Math.sqrt(Math.pow((rect.x + rect.width) - point.x, 2) + Math.pow((rect.y + rect.height) - point.y, 2));
          if (distance < 15) {
            return true;
          }
        };
        drawRects = function(cut_list) {
          var cut, i, len, ref, results;
          canvasForegroundDrawer.clearRect(0, 0, canvasForeground.width, canvasForeground.height);
          ref = getPagePrescription(scope.prescriptions);
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            cut = ref[i];
            results.push(drawRect(cut));
          }
          return results;
        };
        drawRect = function(cut) {
          var gradient;
          canvasForegroundDrawer.fillStyle = "rgba(225, 72, 32, 0.25)";
          canvasForegroundDrawer.beginPath();
          canvasForegroundDrawer.lineWidth = 3;
          canvasForegroundDrawer.lineCap = 'round';
          canvasForegroundDrawer.moveTo(cut.x, cut.y);
          canvasForegroundDrawer.lineTo(cut.x + cut.width, cut.y);
          canvasForegroundDrawer.lineTo(cut.x + cut.width, cut.y + cut.height);
          canvasForegroundDrawer.lineTo(cut.x, cut.y + cut.height);
          canvasForegroundDrawer.closePath();
          canvasForegroundDrawer.fill();
          canvasForegroundDrawer.stroke();
          if (!cut.action) {
            canvasForegroundDrawer.save();
            gradient = canvasForegroundDrawer.createLinearGradient(0, 0, 5, 0);
            gradient.addColorStop(0, 'green');
            gradient.addColorStop(1, 'white');
            canvasForegroundDrawer.strokeStyle = gradient;
            canvasForegroundDrawer.beginPath();
            canvasForegroundDrawer.moveTo(cut.x + cut.width, cut.y + cut.height - thickness);
            canvasForegroundDrawer.lineTo(cut.x + cut.width - thickness, cut.y + cut.height);
            canvasForegroundDrawer.lineTo(cut.x + cut.width, cut.y + cut.height);
            canvasForegroundDrawer.closePath();
            canvasForegroundDrawer.stroke();
            return canvasForegroundDrawer.restore();
          }
        };
        canvasForeground.onmousemove = function(ev) {
          var position;
          position = getMousePos(canvasForeground, ev);
          if (scope.currentPrescription && scope.currentPrescription.action) {
            if (scope.currentPrescription.action === "DEPLACE") {
              scope.currentPrescription.x -= scope.currentPrescription.previous_position.x - position.x;
              scope.currentPrescription.y -= scope.currentPrescription.previous_position.y - position.y;
              scope.currentPrescription.x = Math.min(Math.max(scope.currentPrescription.x, 0), canvasForeground.width - scope.currentPrescription.width);
              scope.currentPrescription.y = Math.min(Math.max(scope.currentPrescription.y, 0), canvasForeground.height - scope.currentPrescription.height);
              scope.currentPrescription.previous_position = position;
            } else {
              scope.currentPrescription.width = position.x - scope.currentPrescription.x;
              scope.currentPrescription.height = position.y - scope.currentPrescription.y;
            }
            drawRects(getPagePrescription(scope.prescriptions));
            handleAbsoluteRect(scope.currentPrescription);
            return scope.$apply();
          }
        };
        canvasForeground.onmouseup = function(ev) {
          return focusLost();
        };
        canvasForeground.onmouseout = function(ev) {
          return focusLost();
        };
        handleAbsoluteRect = function(prescription) {
          prescription.data.absolute.x = Math.floor(prescription.x * scope.conversionRatio);
          prescription.data.absolute.y = Math.floor(prescription.y * scope.conversionRatio);
          prescription.data.absolute.width = Math.floor(prescription.width * scope.conversionRatio);
          prescription.data.absolute.height = Math.floor(prescription.height * scope.conversionRatio);
          if (prescription.data.absolute.height < 0) {
            prescription.data.absolute.y += prescription.data.absolute.height;
            prescription.data.absolute.height = -prescription.data.absolute.height;
          }
          if (prescription.data.absolute.width < 0) {
            prescription.data.absolute.x += prescription.data.absolute.width;
            prescription.data.absolute.width = -prescription.data.absolute.width;
          }
          if (prescription.data.absolute.width * prescription.zoomFactor > maxWidth) {
            prescription.data.absolute.widthRatio = maxWidth / prescription.data.absolute.width;
          } else {
            prescription.data.absolute.widthRatio = prescription.zoomFactor;
          }
          if (maxHeight && prescription.data.absolute.height * prescription.zoomFactor > maxHeight) {
            return prescription.data.absolute.heightRatio = maxHeight / prescription.data.absolute.height;
          } else {
            return prescription.data.absolute.heightRatio = prescription.zoomFactor;
          }
        };
        focusLost = function() {
          if (scope.currentPrescription) {
            delete scope.currentPrescription.action;
            adjustPrescriptionRect(scope.currentPrescription);
            drawRects(getPagePrescription(scope.prescriptions));
            handleAbsoluteRect(scope.currentPrescription);
            return scope.$apply();
          }
        };
        adjustPrescriptionRect = function(prescription) {
          if (prescription.width < 0) {
            prescription.x += prescription.width;
            prescription.width = -prescription.width;
          }
          if (prescription.height < 0) {
            prescription.y += prescription.height;
            prescription.height = -prescription.height;
          }
          if (prescription.width < minWidth) {
            prescription.width = minWidth;
          }
          if (prescription.height < minHeight) {
            return prescription.height = minHeight;
          }
        };
        scope.$watch('documentPage.rotationAngle', updateAngle);
        scope.$watch('prescriptions', checkZoomUpdated, true);
        return scope.$watchCollection('prescriptions', checkForRemovedPrescriptions);
      },
      transclude: true,
      scope: {
        documentPage: "=",
        currentPrescription: "=",
        prescriptions: "=",
        reCalcViewDimensions: "=",
        maxHeight: "=?",
        maxWidth: "=?"
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=cutting-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:mhModalCtrl
    * @description
    * # mhModalCtrl
    * Provider of mhModalCtrl
   */
  angular.module("mhclientApp").controller('mhModalCtrl', ["$scope", "$uibModalInstance", "title", "text", "okButtonText", "noButtonText", "cancelButtonText", function($scope, $uibModalInstance, title, text, okButtonText, noButtonText, cancelButtonText) {
    $scope.text = text;
    $scope.title = title;
    $scope.cancelButtonText = cancelButtonText;
    $scope.okButtonText = okButtonText;
    $scope.noButtonText = noButtonText;
    $scope.reason = "";
    $scope.yes = function() {
      return $uibModalInstance.close(true);
    };
    $scope.no = function() {
      return $uibModalInstance.close(false);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss(false);
    };
  }]);

  angular.module("mhclientApp").controller('mhModalReasonCtrl', ["$scope", "$uibModalInstance", "title", "text", "okButtonText", "noButtonText", "cancelButtonText", "reasonLabel", "reasonRequired", function($scope, $uibModalInstance, title, text, okButtonText, noButtonText, cancelButtonText, reasonLabel, reasonRequired) {
    $scope.text = text;
    $scope.title = title;
    $scope.cancelButtonText = cancelButtonText;
    $scope.reasonRequired = reasonRequired;
    $scope.reasonLabel = reasonLabel;
    $scope.okButtonText = okButtonText;
    $scope.noButtonText = noButtonText;
    $scope.reason = "";
    $scope.yes = function() {
      return $uibModalInstance.close($scope.reason);
    };
    $scope.no = function() {
      return $uibModalInstance.close(false);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=mh-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:ModalSelectionCtrl
    * @description
    * # ModalSelectionCtrl
    * TODO: find an accurate description
   */
  angular.module("mhclientApp").controller('ModalSelectionCtrl', ["$scope", "$uibModalInstance", "label", "choices", "lookUpField", "$window", function($scope, $uibModalInstance, label, choices, lookUpField, $window) {
    $scope.label = label;
    $scope.choices = choices;
    $scope.lookUpField = lookUpField;
    $scope.search = {};
    return $scope.cancel = function(choice) {
      if ($window.mgapp != null) {
        $window.mgapp.close_keyboard();
      }
      return $uibModalInstance.close(choice);
    };
  }]);

}).call(this);

//# sourceMappingURL=modal-selection-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:mhModalCtrl
    * @description
    * # mhModalCtrl
    * Provider of mhModalKeyboardInputCtrl
   */
  angular.module("mhclientApp").controller('mhModalKeyboardInputCtrl', ["$scope", "$uibModalInstance", "enteredText", "okButtonText", "cancelButtonText", "labelText", "modalTitle", "noButtonText", function($scope, $uibModalInstance, enteredText, okButtonText, cancelButtonText, labelText, modalTitle, noButtonText) {
    $scope.enteredText = enteredText;
    $scope.okButtonText = okButtonText;
    $scope.cancelButtonText = cancelButtonText;
    $scope.labelText = labelText;
    $scope.modalTitle = modalTitle;
    $scope.noButtonText = noButtonText;
    $scope.yes = function() {
      return $uibModalInstance.close($scope.enteredText);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
  }]);

}).call(this);

//# sourceMappingURL=mh-modal-keyboard-input-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms:draw
    * @description
    * # Draw
    * Directive for drawing medical form
   */
  angular.module('mhclientApp').directive('waiter', ["MhConfig", function(MhConfig) {
    var link;
    link = function(scope, element, attrs) {
      var hide, show;
      show = function() {
        return scope.isVisible = true;
      };
      hide = function() {
        return scope.isVisible = false;
      };
      show();
      if (typeof scope.promise !== 'undefined') {
        show();
        return scope.promise["finally"](hide);
      }
    };
    return {
      link: link,
      restrict: 'E',
      template: '<div class="overlay waiter" ng-class="{\'open\': isVisible }"> <div ng-if="text.length > 0" class="waiter-text text-center">{{ text }}</div> <div class="waiter-image"></div> </div>',
      scope: {
        isVisible: '=?',
        promise: '=',
        htmlElement: '@',
        text: '@'
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=waiter-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:filter-string-number-input
    * @description
    * # Draw
    * Directive which test if the value is un number. If not value is set to undefined
   */
  angular.module('mhclientApp').directive('filterStringNumberInput', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$formatters.push(function(value) {
          if (typeof value !== "number") {
            return "";
          } else {
            return value;
          }
        });
      }
    };
  });

}).call(this);

//# sourceMappingURL=filter-string-number-input.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name core.mhMultiselect
    * @description
    * # Multi-select widget with typeahead
   */
  angular.module('mhclientApp').directive('mhMultiselect', ["$filter", "$http", "$rootScope", function($filter, $http, $rootScope) {
    var link;
    link = function(scope, element, attrs, ctrl, transclude) {
      if (scope.canModify == null) {
        scope.canModify = true;
      }
      if (attrs.style != null) {
        scope.style = attrs.style;
      } else {
        scope.style = "";
      }
      if (scope.onlyFromSource == null) {
        scope.onlyFromSource = true;
      }
      if (scope.attrToDisplay == null) {
        scope.attrToDisplay = "name";
      }
      scope.selectedList = scope.selectedList || [];
      scope.loading = false;
      scope.addItem = function(item) {
        var i, inList, len, ref, selectedItem;
        if (typeof item !== "string") {
          inList = false;
          ref = scope.selectedList;
          for (i = 0, len = ref.length; i < len; i++) {
            selectedItem = ref[i];
            if (selectedItem[scope.attrToDisplay] === item[scope.attrToDisplay]) {
              inList = true;
            }
          }
          if (!inList) {
            scope.selectedList.unshift(item);
          }
          return scope.currentItem = '';
        }
      };
      return scope.getValues = function(source, $viewValue) {
        var item, params, query, result, tempSource;
        if (typeof source === "undefined") {
          item = [
            {
              "name": $viewValue
            }
          ];
          return item;
        } else if (typeof source === "function") {
          params = {};
          if (scope.requestParams != null) {
            _.extend(params, scope.requestParams);
          }
          if (scope.limitTo != null) {
            params['limitTo'] = scope.limitTo;
          }
          params[scope.paramName] = $viewValue;
          scope.loading = true;
          return source(params).$promise.then(function(responses) {
            scope.loading = false;
            if (responses.length === 0 && scope.onlyFromSource === false) {
              item = {
                "name": $viewValue
              };
              item[scope.attrToDisplay] = $viewValue;
              return [item];
            } else {
              return responses;
            }
          });
        } else {
          if (scope.paramName) {
            query = {};
            query[scope.paramName] = $viewValue;
            if (scope.onlyFromSource === false) {
              tempSource = angular.copy(source);
              item = {
                "name": $viewValue
              };
              tempSource.push(item);
              result = $filter('filter')(tempSource, query);
              tempSource.length = 0;
            } else {
              result = $filter('filter')(source, query);
            }
          } else {
            result = $filter('filter')(source, $viewValue);
          }
          if (scope.limitTo != null) {
            result = $filter('limitTo')(result, parseInt(scope.limitTo));
          }
          return result;
        }
      };
    };
    return {
      scope: {
        source: "=",
        paramName: "@",
        selectedList: "=",
        minLength: "=",
        waitTime: "=",
        isRequired: "=",
        attrToDisplay: "@",
        singleChoice: "=",
        canModify: '=?',
        limitTo: '@?',
        onlyFromSource: '=?',
        placeHolder: "=",
        requestParams: "=?"
      },
      link: link,
      restrict: 'E',
      template: '<div class="mh-multiselect"> <div class="has-feedback"> <input ng-if="!singleChoice || selectedList.length === 0" type="text" typeahead-editable="!onlyFromSource" style="{{style}}" class="form-control" uib-typeahead="item as item[attrToDisplay] for item in getValues(source, $viewValue)" ng-model="currentItem" placeholder="{{:: (placeHolder || \'SEARCH\') | translate }}" typeahead-on-select="addItem(currentItem); currentItem=\'\'" typeahead-min-length="minLength" typeahead-wait-ms="waitTime" ng-required="(selectedList.length === 0) && isRequired" mgapp-keyboard ng-readonly="!canModify"> </input> <i class="form-control-feedback glyphicon glyphicon-refresh rotating" ng-show="loading"></i> <!-- <a class="btn btn-default" ng-if="!source" role="button" ng-click="addItem(currentItem)">{{ "MULTISELECT_ADD" | translate }}</a> --> </div> </div>'
    };
  }]);

}).call(this);

//# sourceMappingURL=mh-multiselect-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:DefaultGrpFeatPerms
    * @description
    * # DefaultGrpFeatPerms
    * Factory of DefaultGrpFeatPerms
   */
  angular.module("mhclientApp").factory('DefaultGrpFeatPerms', function() {
    var get, grp_feat_permissions;
    grp_feat_permissions = {
      LIA: ["CAN_WRITE"],
      MHC_CONTACTS: ["CAN_WRITE"],
      ORA_MEDICALFOLDER: ["CAN_WRITE"],
      MHC_DOCVIEWER: ["CAN_WRITE"],
      MHC_AGENDA: ["CAN_WRITE"],
      MHC_SOCIALINFO: ["CAN_WRITE"],
      MHC_MESSAGING: ["CAN_WRITE"],
      MHC_MEDICALINFO: ["CAN_WRITE"],
      MHC_COVERAGE: ["CAN_WRITE"],
      MHC_OBSERVATION: ["CAN_WRITE"],
      MHC_ORDERS: ["CAN_WRITE"],
      MHC_MULTI_PRESCCARTS: ["CAN_WRITE"],
      MHC_RELAY: ["CAN_WRITE"],
      MHC_IAS: ["CAN_WRITE"],
      NUM: ["CAN_WRITE"],
      MHC_PREAD: ["CAN_WRITE"],
      MHC_KIT_EDIT: ["CAN_WRITE"],
      MHC_TRANSMISSION: ["CAN_WRITE"],
      SVM: ["CAN_WRITE"],
      IMG: ["CAN_WRITE"],
      SVG: ["CAN_WRITE"],
      MHC_CARE_REALIZATION: ["CAN_WRITE"],
      MHC_MISSION_LETTER: ["CAN_WRITE"],
      SVA: ["CAN_WRITE"],
      MHC_CARE_CREATION: ["CAN_WRITE"],
      MHC_SOCIALPROJECT: ["CAN_WRITE"],
      MHC_DIARY: ["CAN_WRITE"],
      MHC_WORK_REPORT: ["CAN_WRITE"],
      MHC_MMSE: ["CAN_WRITE"],
      MHC_PSP: ["CAN_WRITE"],
      ORP: ["CAN_WRITE"],
      MHC_FORMS_MEDICALFOLDER: ["CAN_WRITE"],
      MHC_PSI: ["CAN_WRITE"],
      ORD: ["CAN_WRITE"],
      MHC_PREAD_FOLLOW_UP_WR: ["CAN_WRITE"],
      MHC_SANITARY_TRANSPORT: ["CAN_WRITE"],
      ORA: ["CAN_WRITE"],
      MHC_ORA: ["CAN_WRITE"],
      MHC_PATIENT: ["CAN_WRITE"]
    };
    get = function() {
      return grp_feat_permissions;
    };
    return {
      get: get
    };
  });

}).call(this);

//# sourceMappingURL=default-grp-feat-perm-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name core.mhMultiselect
    * @description
    * # Multi-select widget with typeahead
   */
  angular.module('mhclientApp').directive('mhOrderMultiselect', ["$filter", "$http", function($filter, $http) {
    var link;
    link = function(scope, element, attrs, ctrl, transclude) {
      scope.selectedList = scope.selectedList || [];
      scope.loading = false;
      scope.addItem = function(item) {
        var i, inList, len, ref, selectedItem;
        if (typeof item !== "string") {
          inList = false;
          ref = scope.selectedList;
          for (i = 0, len = ref.length; i < len; i++) {
            selectedItem = ref[i];
            if (selectedItem.name === item.name) {
              inList = true;
            }
          }
          if (!inList) {
            scope.selectedList.unshift(item);
          }
        }
        return scope.currentItem = '';
      };
      scope.changeSelect = function(catalog) {
        scope.srcVariable = scope.full;
        return scope.selectedList = scope.full;
      };
      return scope.getValues = function(source, $viewValue) {
        var item, params, promise, result;
        console.log(params);
        if (typeof source === "undefined") {
          item = [
            {
              "name": $viewValue
            }
          ];
          return item;
        } else if (typeof source === "string") {
          params = {};
          params[scope.paramName] = $viewValue;
          console.log(params);
          promise = $http.get(source, {
            params: params
          });
          scope.loading = true;
          return promise.then(function(response) {
            scope.loading = false;
            console.log(response);
            scope.srcVariable = response.data.results;
            scope.selectedList = response.data.results;
            return response.data.results;
          });
        } else {
          result = $filter('filter')(source, $viewValue);
          return $filter('limitTo')(result, 10);
        }
      };
    };
    return {
      scope: {
        source: "=",
        paramName: "@",
        minLength: "=",
        waitTime: "=",
        isRequired: "=",
        typeMultiSelect: "=",
        selectedList: "=",
        full: "=",
        srcVariable: "@"
      },
      link: link,
      restrict: 'E',
      template: '<div class="mh-multiselect"> <div> <input ng-show="scope.typeMultiSelect==undefined" type="text" ng-change="changeSelect(srcVariable)" class="form-control" typeahead-editable="false" uib-typeahead="item as item.designation for item in getValues(source, $viewValue)" typeahead-loading="loading" srcVariable="srcVariable" ng-model="currentItem" placeholder="{{ \'SEARCH\' | translate }}" typeahead-min-length="minLength" ng-data-bind="srcVariable" typeahead-wait-ms="waitTime" data-ng-bind="srcVariable"> </input> <select ng-show="scope.typeMultiSelect!=undefined" ng-change="changeSelect(catalog)" class="form-control" typeahead-editable="false" uib-typeahead="item as item.designation for item in getValues(source, $viewValue)" typeahead-loading="loading" ng-model="currentItem" placeholder="{{ \'SEARCH\' | translate }}" typeahead-min-length="minLength" ng-data-bind="catalog" typeahead-wait-ms="waitTime" data-ng-bind="catalog"> </select> <!-- <a class="btn btn-default" ng-if="!source" role="button" ng-click="addItem(currentItem)">{{ "MULTISELECT_ADD" | translate }}</a> --> </div> </div>'
    };
  }]);

}).call(this);

//# sourceMappingURL=mh-order-multiselect-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name core.mhDatepicker
    * @description
    * # Datepicker widget
    * <mh-datepicker> definition. Attributes:
    * ng-model (mandatory): var to set
    * format: date format - static - default: dd/MM/yyyy
    * mode: datepicker mode - static - default: day
    * min-date
    * max-date
    * ng-required
    * date-options
    * convertDate : default true
   #hideInput : default false
    *
   */
  angular.module('mhclientApp').controller('mhDatepickerCtrl', function() {
    return {};
  }).directive('mhDatepicker', ["$filter", function($filter) {
    var link;
    link = function(scope, element, attrs, mhDatepickerCtrl, transclude) {
      var tomorrow, updateInsideModel;
      scope.opened = false;
      scope.closeText = $filter('translate')("DATEPICKER_CLOSE");
      scope.todayText = $filter('translate')("DATEPICKER_TODAY");
      scope.clearText = $filter('translate')("DATEPICKER_CLEAR");
      updateInsideModel = function() {
        if (scope.ngModel) {
          return scope.model = moment(scope.ngModel).toDate();
        } else {
          return scope.model = null;
        }
      };
      updateInsideModel();
      scope.change = function() {
        mhDatepickerCtrl.$setViewValue(scope.model);
        if (scope.onChange) {
          return scope.onChange();
        }
      };
      mhDatepickerCtrl.$viewChangeListeners.push(function() {
        return scope.$eval(attrs.ngChange);
      });
      scope.$watch("ngModel", function(newValue, oldValue) {
        return updateInsideModel();
      });
      scope.open = function(event) {
        event.preventDefault();
        event.stopPropagation();
        return scope.opened = true;
      };
      scope.clear = function() {
        return scope.ngModel = void 0;
      };
      tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      scope.events = [
        {
          date: tomorrow,
          status: 'full'
        }
      ];
      return scope.getDayClass = function(date, mode) {
        var currentDay, dayToCheck, event, i, len, ref;
        if (mode === 'day') {
          dayToCheck = new Date(date).setHours(0, 0, 0, 0);
          ref = scope.events;
          for (i = 0, len = ref.length; i < len; i++) {
            event = ref[i];
            currentDay = new Date(event).setHours(0, 0, 0, 0);
            if (dayToCheck === currentDay) {
              return event.status;
            }
          }
        }
      };
    };
    return {
      require: 'ngModel',
      scope: {
        ngModel: "=",
        minDate: "=",
        maxDate: "=",
        mode: "=",
        label: "=",
        format: "=",
        dateOptions: "=?",
        showBtnBar: "=",
        customSpanCss: "=",
        ngRequired: "=",
        dNgRequired: "=",
        convertDate: "=",
        dNgReadonly: "=",
        formatDate: "=",
        hideInput: "=",
        appendToBody: "=",
        onChange: "&?"
      },
      controller: ["$rootScope", "$scope", function($rootScope, $scope) {
        if (!$scope.dateOptions) {
          $scope.dateOptions = {};
          $scope.dateOptions.minDate = $scope.minDate;
          $scope.dateOptions.maxDate = $scope.maxDate;
          $scope.$watch("maxDate", function(newValue, oldValue) {
            return $scope.dateOptions.maxDate = newValue;
          });
          return $scope.$watch("minDate", function(newValue, oldValue) {
            return $scope.dateOptions.minDate = newValue;
          });
        }
      }],
      link: link,
      restrict: 'E',
      compile: function(element, attrs) {
        if (attrs.mode == null) {
          attrs.mode = "'day'";
        }
        if (attrs.format == null) {
          attrs.format = "'dd/MM/yyyy'";
        }
        if (attrs.minDate == null) {
          attrs.minDate = "null";
        }
        if (attrs.maxDate == null) {
          attrs.maxDate = "null";
        }
        if (attrs.showBtnBar == null) {
          attrs.showBtnBar = "true";
        }
        if (attrs.customSpanCss == null) {
          attrs.customSpanCss = "'input-group-addon'";
        }
        if (attrs.ngRequired == null) {
          attrs.ngRequired = "false";
        }
        if (attrs.dNgRequired == null) {
          attrs.dNgRequired = "false";
        }
        if (attrs.dNgReadonly == null) {
          attrs.dNgReadonly = "false";
        }
        if (attrs.formatDate == null) {
          attrs.formatDate = "false";
        }
        if (attrs.hideInput == null) {
          attrs.hideInput = "false";
        }
        if (attrs.appendToBody == null) {
          attrs.appendToBody = "false";
        }
        return link;
      },
      template: '<div class="mh-datepicker"> <p  class="input-group"> <span ng-if="label" class="input-group-addon datepicker-label">{{label}}</span> <input ng-hide="hideInput" type="text" class="text-center form-control" uib-datepicker-popup="{{ format }}" ng-model="model" is-open="opened" min-date="minDate" max-date="maxDate" datepicker-options="dateOptions" ng-required="dNgRequired" datepicker-append-to-body="appendToBody" ng-click="!dNgReadonly && open($event)" datepicker-mode="mode" ng-change="change()" close-text="{{ closeText }}" clear-text="{{ clearText }}" current-text="{{ todayText }}" readonly="true"/> <span ng-show="!dNgReadonly" class="input-group-addon" ng-click="!dNgReadonly && open($event)"> <i class="glyphicon glyphicon-calendar"></i> </span> </p> </div>'
    };
  }]);

  angular.module('mhclientApp').directive('mhMultipleDatePicker', ["$filter", function($filter) {
    var link;
    link = function(scope, element, attrs, transclude) {
      scope.dates = _.map(scope.ngModel, function(date) {
        var d;
        d = moment(date, 'DD/MM/YYYY', true);
        if (d.isValid()) {
          return d;
        } else {
          return moment(date);
        }
      });
      return scope.$watch('dates', function(newValue, oldValue) {
        return scope.ngModel = _.map(newValue, function(date) {
          return moment(date).format('YYYY-MM-DD');
        });
      }, true);
    };
    return {
      require: 'ngModel',
      scope: {
        ngModel: "="
      },
      link: link,
      restrict: 'E',
      template: '<multiple-date-picker ng-model="dates"></multiple-date-picker>'
    };
  }]);

  angular.module('mhclientApp').directive('stringDatePicker', ["$filter", "$timeout", function($filter, $timeout) {
    var link;
    link = function(scope, element, attrs, transclude) {
      scope.opened = false;
      scope.open = function(event) {
        event.preventDefault();
        event.stopPropagation();
        return scope.opened = true;
      };
      scope.insideModel = scope.ngModel ? moment(scope.ngModel).toDate() : null;
      if ('minDate' in attrs) {
        scope.$watch('minDate', function(newValue, oldValue) {
          if (newValue) {
            scope.datepickerOptions.minDate = moment(newValue);
            if (scope.insideModel && moment(scope.insideModel) < scope.datepickerOptions.minDate) {
              return scope.insideModel = null;
            }
          } else {
            return delete scope.datepickerOptions.minDate;
          }
        });
      }
      return scope.$watch('insideModel', function(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue != null) {
            if (scope.setMinTime) {
              scope.ngModel = moment(newValue).format('YYYY-MM-DDT00:00:00.000[Z]');
            } else if (scope.setMaxTime) {
              scope.ngModel = moment(newValue).format('YYYY-MM-DDT23:59:59.999[Z]');
            } else {
              scope.ngModel = moment(newValue).format('YYYY-MM-DD');
            }
          } else {
            scope.ngModel = newValue;
          }
          if (scope.onChange) {
            return $timeout(function() {
              return scope.onChange();
            });
          }
        }
      }, true);
    };
    return {
      require: 'ngModel',
      scope: {
        ngModel: "=",
        setMinTime: "=",
        setMaxTime: "=",
        displayLabel: "@",
        format: "=",
        minDate: "=?",
        datepickerOptions: "=?",
        dNgRequired: "=",
        dNgReadonly: "=",
        formatDate: "=",
        hideInput: "=",
        appendToBody: "=",
        onChange: "&?"
      },
      link: link,
      restrict: 'E',
      compile: function(element, attrs) {
        if (attrs.format == null) {
          attrs.format = "'mediumDate'";
        }
        if (attrs.dNgRequired == null) {
          attrs.dNgRequired = "false";
        }
        if (attrs.dNgReadonly == null) {
          attrs.dNgReadonly = "false";
        }
        if (attrs.appendToBody == null) {
          attrs.appendToBody = "false";
        }
        if (attrs.datepickerOptions == null) {
          attrs.datepickerOptions = "{}";
        }
        return link;
      },
      template: '<div class="mh-datepicker"> <p class="input-group"> <span ng-if=":: displayLabel" class="input-group-addon datepicker-label">{{:: displayLabel | translate}}</span> <input ng-hide="hideInput" type="text" class="text-center form-control" uib-datepicker-popup="{{ format }}" ng-model="insideModel" is-open="opened" datepicker-options="datepickerOptions" ng-required="dNgRequired" datepicker-append-to-body="appendToBody" ng-click="!dNgReadonly && open($event)" ng-change="change()" close-text=\'{{:: "DATEPICKER_CLOSE" | translate }}\' clear-text=\' {{:: "DATEPICKER_CLEAR" | translate }}\'  current-text=\'{{:: "DATEPICKER_TODAY" | translate }}\' readonly="true"/> <span ng-show="!dNgReadonly" class="input-group-addon" ng-click="!dNgReadonly && open($event)"> <i class="glyphicon glyphicon-calendar"></i> </span> </p> </div>'
    };
  }]);

  angular.module('mhclientApp').directive('timeIntervalSlider', function() {
    return {
      restrict: 'E',
      template: '<rzslider rz-slider-model="model" rz-slider-high="high" rz-slider-options="intervalOptions"></rzslider>',
      scope: {
        model: "=",
        high: "=",
        options: "="
      },
      controller: ["$rootScope", "$scope", "$timeout", function($rootScope, $scope, $timeout) {
        var periodsInADay, startTimeMoment, stepsArray, timeElapsed, translateStepArray;
        $scope.model = $scope.model || '11:00';
        $scope.high = $scope.high || '13:00';
        periodsInADay = moment.duration(1, 'day').as("minutes");
        timeElapsed = 0;
        startTimeMoment = moment('00:00', 'hh:mm');
        stepsArray = [];
        while (timeElapsed < periodsInADay) {
          stepsArray.push(startTimeMoment.format('HH:mm'));
          timeElapsed += 15;
          startTimeMoment.add(15, "minutes");
        }
        stepsArray.push('23:59');
        translateStepArray = function(value, sliderId, label) {
          switch (label) {
            case 'model':
              return '<b>' + value + ' H</b>';
            case 'high':
              return '<b>' + value + ' H</b>';
            default:
              return value;
          }
        };
        $scope.intervalOptions = _.assign({
          stepsArray: stepsArray,
          translate: translateStepArray
        }, $scope.options);
        return $timeout(function() {
          return $scope.$broadcast('rzSliderForceRender');
        });
      }]
    };
  });

  angular.module('mhclientApp').directive('timeSlider', function() {
    return {
      restrict: 'E',
      template: '<rzslider rz-slider-model="model" rz-slider-options="intervalOptions"></rzslider>',
      scope: {
        model: "=",
        options: "="
      },
      controller: ["$rootScope", "$scope", "$timeout", function($rootScope, $scope, $timeout) {
        var periodsInADay, startTimeMoment, stepsArray, timeElapsed, translateStepArray;
        $scope.model = $scope.model || '11:00';
        periodsInADay = moment.duration(1, 'day').as("minutes");
        timeElapsed = 0;
        startTimeMoment = moment('00:00', 'hh:mm');
        stepsArray = [];
        while (timeElapsed < periodsInADay) {
          stepsArray.push(startTimeMoment.format('HH:mm'));
          timeElapsed += 15;
          startTimeMoment.add(15, "minutes");
        }
        stepsArray.push('23:59');
        translateStepArray = function(value, sliderId, label) {
          switch (label) {
            case 'model':
              return '<b>' + value + ' H</b>';
            case 'high':
              return '<b>' + value + ' H</b>';
            default:
              return value;
          }
        };
        $scope.intervalOptions = _.assign({
          stepsArray: stepsArray,
          translate: translateStepArray
        }, $scope.options);
        return $timeout(function() {
          return $scope.$broadcast('rzSliderForceRender');
        });
      }]
    };
  });

}).call(this);

//# sourceMappingURL=mh-datepicker-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name core.removeFromList
    * @description
    * # remove-from-list widget with remove button
   */
  angular.module('mhclientApp').directive('removeFromList', ["$filter", "$http", function($filter, $http) {
    var link;
    link = function(scope, element, attrs) {
      scope.removeFromList = scope.removeFromList || [];
      return scope.removeItem = function() {
        var item, pos;
        item = scope.itemToRemove;
        pos = scope.removeFromList.indexOf(item);
        if (pos >= 0) {
          return scope.removeFromList.splice(pos, 1);
        }
      };
    };
    return {
      link: link,
      restrict: 'EA',
      scope: {
        removeFromList: '=',
        itemToRemove: '='
      },
      transclude: true,
      template: '<ng-transclude></ng-transclude><span class="remove-from-list"> <a class="btn btn-default no-print" role="button" ng-click="removeItem()"><i class="glyphicon glyphicon-remove"></i> {{ "MULTISELECT_REMOVE" | translate }}</a> </span>'
    };
  }]);

}).call(this);

//# sourceMappingURL=remove-from-list-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:BoxResource
    * @description
    * # BoxResource
    * Factory of BoxResource
   */
  angular.module("mhclientApp").factory('BoxResource', ["MhConfig", "$q", "$timeout", function(MhConfig, $q, $timeout) {
    var generate, mhboxApiCall, objectToResource;
    objectToResource = function(object) {
      var result;
      result = {};
      result.$promise = $q.when(angular.fromJson(object));
      return result;
    };
    mhboxApiCall = function(manager, method, object) {
      var promise, result;
      result = {};
      promise = $q.defer();
      result.$promise = promise.promise;
      $timeout(function() {
        var toReturn;
        toReturn = manager[method](angular.toJson(object));
        if (toReturn === "") {
          toReturn = null;
        }
        return promise.resolve(angular.fromJson(toReturn));
      });
      return result;
    };
    generate = function(manager) {
      var api;
      return api = {
        "get": function(object) {
          return mhboxApiCall(manager, "get", object);
        },
        "query": function(object) {
          return mhboxApiCall(manager, "query", object);
        },
        "save": function(object) {
          return mhboxApiCall(manager, "save", object);
        },
        "update": function(objId, object) {
          if (object === void 0) {
            return mhboxApiCall(manager, "update", objId);
          } else {
            if ("id" in objId && !("id" in object)) {
              object.id = objId.id;
            }
            return mhboxApiCall(manager, "update", object);
          }
        },
        "delete": function(object) {
          return mhboxApiCall(manager, "delete", object);
        }
      };
    };
    return {
      generate: generate,
      objectToResource: objectToResource,
      mhboxApiCall: mhboxApiCall
    };
  }]);

}).call(this);

//# sourceMappingURL=box-resource-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:typeaheadFocus
    * @description
    * # typeaheadFocus
    * Provider of typeaheadFocus
   */
  angular.module('mhclientApp').directive('typeahead', ["$compile", function($compile) {
    return {
      priority: 1001,
      terminal: true,
      compile: function(el) {
        var fn, val;
        val = el.attr("typeahead");
        el.removeAttr('typeahead');
        el.attr("uib-typeahead", val);
        fn = $compile(el);
        return function(scope) {
          return fn(scope);
        };
      }
    };
  }]);

  angular.module('mhclientApp').directive('typeaheadFocus', ["$filter", "$http", function($filter, $http) {
    return {
      require: 'ngModel',
      link: function(scope, element, attr, ngModel) {

        /* trigger the popup on 'click' because 'focus'
         * is also triggered after the item selection.
         * also trigger when input is deleted via keyboard
         */
        var manipulateViewValue;
        manipulateViewValue = function(e) {

          /* we have to check to see if the arrow keys were in the input because if they were trying to select
           * a menu option in the typeahead, this may cause unexpected behavior if we were to execute the rest
           * of this function
           */
          var viewValue;
          if ([37, 38, 39, 40].indexOf(e.keyCode) >= 0) {
            return;
          }
          viewValue = ngModel.$viewValue;
          if (ngModel.$viewValue === ' ') {
            ngModel.$setViewValue(null);
          }
          ngModel.$setViewValue(' ');
          ngModel.$setViewValue(viewValue || ' ');
        };
        element.bind('click keyup', manipulateViewValue);
        scope.$emptyOrMatch = function(actual, expected) {
          if (expected === ' ') {
            return true;
          }
          if (actual) {
            return actual.toString().toLowerCase().indexOf(expected.toLowerCase()) > -1;
          } else {
            return false;
          }
        };
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=typeahead-focus-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.factory:Interceptors
    * @description
    * # Interceptors
    * Provider of Interceptors
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").controller('RestoreExpiredSessionCtrl', ["$scope", "$state", "$uibModalInstance", "user", "User", function($scope, $state, $uibModalInstance, user, User) {
    $scope.user = user;
    $scope.username = user.username;
    $scope.password = "";
    $scope.postError = false;
    $scope.loginDone = function(username, password) {
      return $uibModalInstance.close(true);
    };
    return $scope.cancel = function() {
      var grp, location, urlRex;
      location = window.location.href;
      urlRex = /https?:\/\/.*(\/mc\/[^\/]*\/#(.*))/;
      grp = location.match(urlRex);
      $uibModalInstance.close(false);
      if (grp != null) {
        return $state.go("login", {
          next: encodeURIComponent(grp[2])
        }, {
          reload: true
        });
      } else {
        return $state.go("login", {}, {
          reload: true
        });
      }
    };
  }]);

  angular.module("mhclientApp").run(["$templateCache", function($templateCache) {
    $templateCache.put('offline-interceptor-modal-window.internal', "<div class=\"modal-dialog mas{{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n");
  }]);

  angular.module("mhclientApp").factory('AllInterceptors', ["$q", "$rootScope", "$timeout", "$injector", function($q, $rootScope, $timeout, $injector) {
    var cleanCache, globalOnlinePromise, globalUsersPromise, handler, offlineDialog, onLogin, restoreExpiredSession;
    onLogin = false;
    offlineDialog = null;
    globalUsersPromise = $q.defer();
    globalOnlinePromise = $q.defer();
    cleanCache = function() {
      var cacheService;
      globalUsersPromise = $q.defer();
      cacheService = $injector.get('cacheService');
      return cacheService.resetCache();
    };
    restoreExpiredSession = function(user) {
      var $uibModal, loginDialog, loginDone;
      loginDone = $q.defer();
      $uibModal = $injector.get('$uibModal');
      loginDialog = $uibModal.open({
        templateUrl: 'user/views/user-restore-session-template.html',
        controller: 'RestoreExpiredSessionCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user: function() {
            return user;
          }
        }
      });
      loginDialog.result.then(function(result) {
        return loginDone.resolve(result);
      });
      return loginDone.promise;
    };
    handler = {
      'response': function(response) {
        if (offlineDialog && response.config.url !== "offline-interceptor-modal-window.internal") {
          offlineDialog.dismiss();
          offlineDialog = null;
        }
        return response;
      },
      'responseError': function(rejection) {
        var $http, $state, grp, i, location, notify, ref, results, translate, urlRex;
        switch (false) {
          case rejection.status !== -1:
            if ($rootScope.mh_config.platform === 'mhsi') {
              if (!offlineDialog) {
                offlineDialog = $injector.get('$uibModal').open({
                  animation: true,
                  backdrop: 'static',
                  keyboard: false,
                  windowClass: "vertical-align",
                  windowTemplateUrl: "offline-interceptor-modal-window.internal",
                  template: '<div class="modal-header"></div> <div class="modal-body text-center">{{:: "Missing connection dialog"| translate}}</div> <div class="modal-footer"></div>'
                });
              }
              return $timeout(function() {
                return $injector.get('$http')(rejection.config, 2000);
              });
            }
            break;
          case rejection.status !== 409:
            notify = $injector.get('notify');
            translate = $injector.get('$filter')('translate');
            notify({
              classes: ["alert-danger"],
              message: translate("CONFLICT ERROR")
            });
            break;
          case rejection.status !== 401:
            if ($rootScope.user) {
              $http = $injector.get('$http');
              if (!onLogin) {
                onLogin = true;
                restoreExpiredSession($rootScope.user).then((function(loginDone) {
                  onLogin = false;
                  if (loginDone) {
                    globalUsersPromise.resolve();
                  }
                  return cleanCache();
                }));
              }
              return globalUsersPromise.promise.then(function() {
                return $http(rejection.config);
              });
            } else {
              $state = $injector.get('$state');
              if ($state.current.name !== "login") {
                location = window.location.href;
                urlRex = /https?:\/\/.*(\/mc\/[^\/]*\/#(.*))/;
                grp = location.match(urlRex);
                if (grp != null) {
                  $state.go("login", {
                    next: encodeURIComponent(grp[2])
                  });
                } else {
                  $state.go("login");
                }
              }
            }
            break;
          case rejection.status !== 400:
            if (rejection.config.url !== "/authentication/2FA_login") {
              notify = $injector.get('notify');
              translate = $injector.get('$filter')('translate');
              notify({
                classes: ["alert-danger"],
                message: translate("BAD_REQUEST_ERROR")
              });
            }
            break;
          case ref = rejection.status, indexOf.call((function() {
              results = [];
              for (i = 500; i <= 600; i++){ results.push(i); }
              return results;
            }).apply(this), ref) < 0:
            notify = $injector.get('notify');
            translate = $injector.get('$filter')('translate');
            notify({
              classes: ["alert-danger"],
              message: translate("CONNECTION_ERROR")
            });
        }
        return $q.reject(rejection);
      }
    };
    return handler;
  }]);

}).call(this);

//# sourceMappingURL=interceptors-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:top-fixed
    * @description
    * # Draw
    * Directive for position fixed top bar
   */
  angular.module('mhclientApp').directive('iframeSyncronize', ["$window", "$timeout", function($window, $timeout) {
    return {
      scope: {
        onLoadCallback: '&',
        options: '=?',
        fullHeight: "=",
        disableLinks: "="
      },
      link: function(scope, elem, attrs) {
        var __check, iframe, options;
        options = scope.options || {};
        options.checkOrigin = false;
        options.warningTimeout = 0;
        iframe = iFrameResize(options, elem[0]);
        __check = function() {
          var error, error1, h;
          try {
            h = elem[0].contentWindow.document.body.scrollHeight;
            if (h !== scope.__height) {
              scope.__height = h;
              elem.height(elem[0].contentWindow.document.body.scrollHeight);
            }
          } catch (error1) {
            error = error1;
          }
        };
        elem[0].onload = function() {
          if (scope.fullHeight) {
            __check();
          }
          if (scope.disableLinks) {
            elem.contents().find("a[href]").hide();
          }
          return scope.onLoadCallback();
        };
        return scope.$on('$destroy', function() {
          if (elem[0].iFrameResizer != null) {
            return elem[0].iFrameResizer.close();
          }
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=iframe-syncro-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:exceptionLogging
    * @description
    * # exceptionLogging
    * Factory of exceptionLogging
   */
  angular.module("mhclientApp").factory('exceptionLogging', ["$window", "$injector", "$resource", "MhConfig", function($window, $injector, $resource, MhConfig) {
    var acceptHeader, portailAPI, send;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/logger', {
      id: this.id
    }, {
      'send': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      }
    });
    send = function(exception, cause) {
      var error;
      error = {
        url: $window.location.href,
        type: "exception",
        message: exception.message += ' (caused by "' + cause + '")',
        stack: exception.stack
      };
      switch (MhConfig.platform) {
        case 'mhsi':
          return portailAPI.send(error);
        case 'mgapp':
          return window.mgapp.log(angular.toJson(error));
      }
    };
    return {
      send: send
    };
  }]);

}).call(this);

//# sourceMappingURL=exception-logging-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:SiteVar
    * @description
    * # SiteVar
    * Provider of SiteVar
   */
  angular.module("mhclientApp").factory('SiteVar', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, customer_mgr, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/sitevars/:name/:route', {
      name: this.name
    }, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'get': {
        method: 'GET'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          name: '@name'
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'get_import_method': {
        method: 'GET',
        params: {
          route: 'get_import_method'
        }
      },
      'getVisioServer': {
        method: 'GET',
        params: {
          route: 'get_visio_server'
        }
      },
      'getDefaultLogo': {
        method: 'GET',
        params: {
          route: 'get_default_logo'
        },
        isArray: false
      },
      'getPasswordPolicy': {
        method: 'GET',
        params: {
          route: 'get_password_policy'
        }
      },
      'getVersionInfo': {
        method: 'GET',
        isArray: false,
        params: {
          route: 'get_mhcare_version_info'
        }
      },
      'getMobileSynchroProtocols': {
        method: 'GET',
        isArray: false,
        params: {
          route: 'get_mobile_synchro_protocols'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        customer_mgr = window.mgapp.get('customer_mgr').site_var();
        boxAPI = BoxResource.generate(customer_mgr);
        boxAPI.getDefaultLogo = function(object) {
          return BoxResource.mhboxApiCall(customer_mgr, "get_default_logo", object);
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('SiteVarsUtils', ["$q", "$window", "$rootScope", "SiteVar", "MhConfig", "Entity", "Sector", function($q, $window, $rootScope, SiteVar, MhConfig, Entity, Sector) {
    var cachedDefaultLogo, defaultCibleCategoriesLabel, getBySector, getCachedSiteVar, getDefaultLogo, getDefaultMenu, getDefaultPapTemplates, getImportMethod, getSiteVar, getValue, globalSiteVarsPromise, importMethod, resetCache, service, showAllStaysData, siteVarsCache;
    siteVarsCache = null;
    importMethod = null;
    cachedDefaultLogo = null;
    globalSiteVarsPromise = $q.defer();
    resetCache = function() {
      siteVarsCache = null;
      importMethod = null;
      cachedDefaultLogo = null;
      return globalSiteVarsPromise = $q.defer();
    };
    getDefaultLogo = function() {
      return $q.when(cachedDefaultLogo || SiteVar.getDefaultLogo().$promise).then(function(result) {
        cachedDefaultLogo = result;
        return cachedDefaultLogo.logo;
      });
    };
    getCachedSiteVar = function(name, default_value) {
      if (siteVarsCache[name] != null) {
        return siteVarsCache[name];
      } else {
        return $q.when(default_value).then(function(default_value) {
          return {
            value: default_value,
            name: name
          };
        });
      }
    };
    getDefaultMenu = function() {
      return getSiteVar("DEFAULT_MENU", "new-menu").then(function(sitevar) {
        return sitevar.value;
      });
    };
    getDefaultPapTemplates = function() {
      var DAFALGAN, DOLIPRANE, MORPHINE, NALOXONE, PARACETAMOL;
      MORPHINE = {
        "headers": [
          {
            "type": "label",
            "label": "<i class='glyphicon glyphicon-warning-sign'></i><span class='product-name warning'>MORPHINE 10MG/ML COOPER AMP10ML100</span>:"
          }, {
            "label": "mg",
            "type": "quantity"
          }
        ],
        "options": [
          {
            "label": "S/C à répéter au bout de 30 mn",
            "route": {
              "code": "A58",
              "label": "Voie sous-cutanée"
            }
          }, {
            "label": "IVD à répéter au bout de 5 mn jusqu'à disparition du symptôme douloureux (selon échelle de la douleur) puis toutes les 4h si besoin",
            "route": {
              "code": "A40",
              "label": "Voie intraveineuse"
            }
          }, {
            "label": "IVL dans 50 ml de sérum salé isotonique - à répéter au bout de 5 mn jusqu'à disparition du symptôme douloureux (selon échelle de la douleur) puis toutes les 4h si besoin",
            "route": {
              "code": "A58",
              "label": "Voie sous-cutanée"
            }
          }
        ],
        "taking_unit": {
          "code": 48,
          "label_plural": "mg",
          "label": "mg"
        },
        "bdm_data": {
          "name": "MORPHINE 10MG/ML COOPER AMP10ML100",
          "atc": "N02AA01",
          "is_stupefiant": 1,
          "inn": [
            {
              "cip": "8193903",
              "name": "Morphine chlorhydrate 10 mg/mL solution injectable"
            }
          ],
          "ucd": "9274791",
          "cip": "5669446"
        }
      };
      NALOXONE = {
        "quantity": 0.04,
        "headers": [
          {
            "type": "label",
            "label": "<span class='product-name'>NALOXONE 0,4MG/1ML MYLAN AMP 10</span>: 0.04 mg IVD - soit 1 ampoule de 1 ml à ajouter à 9 ml de sérum salé isotonique. Injecter 2 ml puis 1 ml / 1 ml toutes les 3 mn jusqu'à l'obtention d'une fréquence respiratoire supérieure à 10/mn"
          }
        ],
        "taking_unit": {
          "code": 48,
          "label_plural": "mg",
          "label": "mg"
        },
        "route": {
          "code": "A40",
          "label": "Voie intraveineuse"
        },
        "bdm_data": {
          "name": "NALOXONE 0,4MG/1ML MYLAN AMP 10",
          "atc": "V03AB15",
          "inn": [
            {
              "cip": "8165226",
              "name": "Naloxone chlorhydrate 0,4 mg/1 mL injectable IV/IM/SC"
            }
          ],
          "ucd": "9223109",
          "cip": "5630711"
        }
      };
      PARACETAMOL = {
        "headers": [
          {
            "type": "label",
            "label": "<span class='product-name'>PARACETAMOL B BRAUN 10 mg/ml S perf 10Fl/100ml</span>:"
          }, {
            "label": "flacon(s)",
            "type": "quantity"
          }, {
            "type": "label",
            "label": "(selon le poids) en Intraveineux sur 30 mn toutes les 6h"
          }
        ],
        "taking_unit": {
          "code": 26,
          "label_plural": "flacons",
          "label": "flacon"
        },
        "route": {
          "code": "A40",
          "label": "Voie intraveineuse"
        },
        "bdm_data": {
          "name": "PARACETAMOL B BRAUN 10 mg/ml S perf 10Fl/100ml",
          "atc": "N02BE01",
          "inn": [
            {
              "cip": "8151856",
              "name": "Paracétamol 1 g/100 mL ADULTE perfusion IV"
            }
          ],
          "ucd": "9387549",
          "cip": "5830812"
        }
      };
      DAFALGAN = {
        "quantity": 1,
        "headers": [
          {
            "type": "label",
            "label": "<span class='product-name'>DAFALGAN 600MG SUP 10</span>: 1 suppositoire(s) par voie rectale toutes les 6h"
          }
        ],
        "taking_unit": {
          "code": 39,
          "label_plural": "suppositoires",
          "label": "suppositoire"
        },
        "route": {
          "code": "A52",
          "label": "Voie rectale"
        },
        "bdm_data": {
          "name": "DAFALGAN 600MG SUP 10",
          "atc": "N02BE01",
          "inn": [
            {
              "cip": "8151715",
              "name": "Parac\u00e9tamol 600 mg suppositoire"
            }
          ],
          "ucd": "9104422",
          "cip": "3273655"
        }
      };
      DOLIPRANE = {
        "quantity": 1,
        "headers": [
          {
            "type": "label",
            "label": "<span class='product-name'>DOLIPRANE 1 000MG AD SUP 8</span>: 1 suppositoire(s) par voie rectale toutes les 6h"
          }
        ],
        "taking_unit": {
          "code": 39,
          "label_plural": "suppositoires",
          "label": "suppositoire"
        },
        "route": {
          "code": "A52",
          "label": "Voie rectale"
        },
        "bdm_data": {
          "name": "DOLIPRANE 1 000MG AD SUP 8",
          "atc": "N02BE01",
          "inn": [
            {
              "cip": "8151721",
              "name": "Parac\u00e9tamol 1 000 mg suppositoire"
            }
          ],
          "ucd": "9129770",
          "cip": "3304746"
        }
      };
      return [
        {
          "pap": "PAP 1",
          "name": "DOULEUR AIGUE, <br>Réfractaire au traitement existant",
          "order": 1,
          "entries": [MORPHINE]
        }, {
          "pap": "PAP 2",
          "order": 2,
          "name": "SURDOSAGE MORPHINIQUE <br>*Fréquence respiratoire < à 10 par minutes <br>*+ patient somnolent répondant à l'appel",
          "entries": [NALOXONE]
        }, {
          "pap": "PAP 3",
          "order": 3,
          "name": "DOULEUR AIGUE, Réfractaire au traitement existant",
          "entries": [PARACETAMOL, DAFALGAN, DOLIPRANE]
        }, {
          "pap": "PAP 4",
          "order": 4,
          "name": "DOULEUR AIGUE Réfractaire au traitement existant SYNDROME INFECTIEUX avec risque de choc SYNDROME INFLAMMATOIRE",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>METHYLPREDNISOLONE MYLAN 120 mg Pdr sol inj IM/IV Fl/10</span>:"
                }, {
                  "label": "mg",
                  "type": "quantity"
                }
              ],
              "options": [
                {
                  "label": "A diluer dans 50 ml de sérum salé isotonique et à perfuser en 30 mn en S/C",
                  "route": {
                    "code": "A58",
                    "label": "Voie sous-cutanée"
                  }
                }, {
                  "label": "A diluer dans 50 ml de sérum salé isotonique en IVD",
                  "route": {
                    "code": "A40",
                    "label": "Voie intraveineuse"
                  }
                }
              ],
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "bdm_data": {
                "name": "METHYLPREDNISOLONE MYLAN 120 mg Pdr sol inj IM/IV Fl/10",
                "atc": "H02AB04",
                "inn": [
                  {
                    "cip": "8175360",
                    "name": "Méthylprednisolone 120 mg injectable IM/IV"
                  }
                ],
                "ucd": "9226763",
                "cip": "3419136"
              }
            }
          ]
        }, {
          "pap": "PAP 5",
          "order": 5,
          "name": "ENCOMBREMENT MAJEUR avec hypersécrétions salivaires, pulmonaires ou digestives RALES AGONIQUES",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>SCOPODERM TTS 1 mg/72 h Disp transderm B/30</span>: 1 Patch(s) pour 72h (3 jours) à coller derrière l'oreille"
                }
              ],
              "taking_unit": {
                "code": 511,
                "label_plural": "patchs à appliquer",
                "label": "patch à appliquer"
              },
              "quantity": 1,
              "route": {
                "code": "A61",
                "label": "Voie transdermique"
              },
              "bdm_data": {
                "name": "SCOPODERM TTS 1 mg/72 h Disp transderm B/30",
                "atc": "A04AD01",
                "inn": [
                  {
                    "cip": "8173421",
                    "name": "Scopolamine 1 mg/72 h dispositif transdermique"
                  }
                ],
                "ucd": "9106823",
                "cip": "9106823"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>BROMHYDRATE DE SCOPOLAMINE RENAUDIN 0,025 % S inj 100Amp/2ml</span>: 0.5 mg à renouveler toutes les 3h si besoin. Maximum 4 à 6 injections / 24h"
                }
              ],
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "quantity": 0.5,
              "route": {
                "code": "A58",
                "label": "Voie sous-cutanée"
              },
              "bdm_data": {
                "name": "BROMHYDRATE DE SCOPOLAMINE RENAUDIN 0,025 % S inj 100Amp/2ml",
                "atc": "R07A",
                "inn": [
                  {
                    "cip": "8173438",
                    "name": "Scopolamine bromhydrate 0,025% injectable SC"
                  }
                ],
                "ucd": "9284619",
                "cip": "5659821"
              }
            }
          ]
        }, {
          "order": 6,
          "pap": "PAP 6",
          "name": "VOMISSEMENT OU HOCQUET AGITATION AIGUE - INSOMNIES DELIRE AIGU",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>HALDOL 5 mg/ml S inj 5Amp/1ml</span>:"
                }, {
                  "label": "Ampoule(s) S/C - A renouveler toutes les 4h. Maximum 20 mg/24h",
                  "type": "quantity"
                }
              ],
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "route": {
                "code": "A32",
                "label": "Voie intramusculaire"
              },
              "bdm_data": {
                "name": "HALDOL 5 mg/ml S inj 5Amp/1ml",
                "atc": "N05AD01",
                "inn": [
                  {
                    "cip": "8165210",
                    "name": "Halopéridol 5 mg/mL injectable IM/IV"
                  }
                ],
                "ucd": "9041472",
                "cip": "3047189"
              }
            }
          ]
        }, {
          "pap": "PAP 7",
          "order": 7,
          "name": "BACTERIEMIE AIGUE - RISQUE DE CHOC SEPTIQUE - FIEVRE MAJEURE non contrôlée par les antipyrétiques",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>CEFTRIAXONE PANPHARMA 1 g Pdr sol inj 25Fl</span>: 1 g"
                }
              ],
              "options": [
                {
                  "label": "S/C dilué dans 50 ml de sérum salé isotonique - 1g/24h",
                  "route": {
                    "code": "A58",
                    "label": "Voie sous-cutanée"
                  }
                }, {
                  "label": "IV dilué dans 50 ml de sérum salé isotonique et à perfuser en 30 mn - 1g/24h",
                  "route": {
                    "code": "A40",
                    "label": "Voie intraveineuse"
                  }
                }
              ],
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "quantity": 1,
              "bdm_data": {
                "name": "CEFTRIAXONE PANPHARMA 1 g Pdr sol inj 25Fl",
                "atc": "J01DD04",
                "inn": [
                  {
                    "cip": "8170782",
                    "name": "Ceftriaxone 1 g injectable IM/IV/SC"
                  }
                ],
                "ucd": "9239748",
                "cip": "3581836"
              }
            }
          ]
        }, {
          "pap": "PAP 8",
          "order": 8,
          "name": "ANGOISSE AIGUE - INSOMNIE REBELLE SYMPTOMES REBELLES",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<i class='glyphicon glyphicon-warning-sign'></i><span class='product-name warning'>MIDAZOLAM MYLAN 1 mg/ml S inj IM/IV ou rectale 10Amp/5ml</span>:"
                }, {
                  "label": "mg en",
                  "type": "quantity"
                }, {
                  "type": "hours",
                  "suffix": "H"
                }, {
                  "type": "minutes",
                  "suffix": "mn"
                }
              ],
              "options": [
                {
                  "label": "IV dilué dans 50 ml de sérum salé isotonique. Dose maximum 1.5 mg sur 1 heure",
                  "route": {
                    "code": "A40",
                    "label": "Voie intraveineuse"
                  }
                }, {
                  "label": "S/C dilué dans 5 ml de sérum salé isotonique. Dose maximum 1.5 mg sur 1 heure. (Usage Hors AMM)",
                  "route": {
                    "code": "A58",
                    "label": "Voie sous-cutanée"
                  }
                }
              ],
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "bdm_data": {
                "name": "MIDAZOLAM MYLAN 1 mg/ml S inj IM/IV ou rectale 10Amp/5ml",
                "atc": "J01DD04",
                "inn": [
                  {
                    "cip": "8163026",
                    "name": "Midazolam 1 mg/mL injectable IM/IV/rectale"
                  }
                ],
                "ucd": "9235911",
                "cip": "5627264"
              }
            }
          ]
        }, {
          "pap": "PAP 9",
          "order": 9,
          "name": "SEDATION",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<i class='glyphicon glyphicon-warning-sign'></i><span class='product-name warning'>MIDAZOLAM MYLAN 1 mg/ml S inj IM/IV ou rectale 10Amp/5ml</span>: 0.5mg"
                }
              ],
              "options": [
                {
                  "label": "IV dilué dans 50 ml de sérum salé isotonique. Faire une titration. Injecter lentement 0.5 mg toutes les 3 minutes jusqu'à apaisement du patient (score 4 de Rudkin). Faire ensuite un entretien de la sédation en perfusant 50% de la dose titrée par heure.",
                  "route": {
                    "code": "A40",
                    "label": "Voie intraveineuse"
                  }
                }, {
                  "label": "S/C directe, dilué dans 5 ml de sérum salé isotonique. Faire une titration. Injecter lentement 0.5 mg toutes les 3 minutes jusqu'à apaisement du patient (score 4 de Rudkin). Faire ensuite un entretien de la sédation en perfusant 50% de la dose titrée par heure. (Usage hors AMM)",
                  "route": {
                    "code": "A58",
                    "label": "Voie sous-cutanée"
                  }
                }
              ],
              "quantity": 0.5,
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "bdm_data": {
                "name": "MIDAZOLAM MYLAN 1 mg/ml S inj IM/IV ou rectale 10Amp/5ml",
                "atc": "J01DD04",
                "inn": [
                  {
                    "cip": "8163026",
                    "name": "Midazolam 1 mg/mL injectable IM/IV/rectale"
                  }
                ],
                "ucd": "9235911",
                "cip": "5627264"
              }
            }
          ]
        }, {
          "pap": "PAP 10",
          "order": 10,
          "name": "DETRESSE RESPIRATOIRE",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>OXYGENE ALR 200B BOUT ALU 2L+MAN</span>:"
                }, {
                  "label": "l/min ",
                  "type": "quantity"
                }, {
                  "prefix": "pendant",
                  "type": "hours",
                  "suffix": "H"
                }, {
                  "type": "minutes",
                  "suffix": "mn En mettant le patient en position demi-assise. Débit à réévaluer selon la saturation"
                }
              ],
              "route": {
                "code": "A73",
                "label": "Voie inhalée"
              },
              "taking_unit": {
                "code": 163,
                "label_plural": "litres",
                "label": "litre"
              },
              "bdm_data": {
                "name": "OXYGENE ALR 200B BOUT ALU 2L+MAN",
                "atc": "V03AN01",
                "ucd": "9275218",
                "cip": "3627774"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>FUROSEMIDE RENAUDIN 20 mg/2 ml S inj IM IV 100Amp/2ml</span>:"
                }, {
                  "label": "mg IVD",
                  "type": "quantity"
                }
              ],
              "route": {
                "code": "A40",
                "label": "Voie intraveineuse"
              },
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "bdm_data": {
                "name": "FUROSEMIDE RENAUDIN 20 mg/2 ml S inj IM IV 100Amp/2ml",
                "atc": "C03CA01",
                "inn": [
                  {
                    "cip": "8150874",
                    "name": "Furosémide 20 mg/2 mL injectable IM/IV"
                  }
                ],
                "ucd": "9208831",
                "cip": "5618911"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>METHYLPREDNISOLONE MYLAN 120 mg Pdr sol inj IM/IV Fl/10</span>:"
                }, {
                  "label": "mg IVD",
                  "type": "quantity"
                }
              ],
              "route": {
                "code": "A40",
                "label": "Voie intraveineuse"
              },
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "bdm_data": {
                "name": "METHYLPREDNISOLONE MYLAN 120 mg Pdr sol inj IM/IV Fl/10",
                "atc": "H02AB04",
                "inn": [
                  {
                    "cip": "8175360",
                    "name": "Méthylprednisolone 120 mg injectable IM/IV"
                  }
                ],
                "ucd": "9226763",
                "cip": "3419136"
              }
            }
          ]
        }, {
          "pap": "PAP 11",
          "order": 11,
          "name": "CONVULSIONS",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>VALIUM ROCHE 10 mg/2 ml S inj 6Amp/2ml</span>:"
                }, {
                  "label": "mg",
                  "type": "quantity"
                }
              ],
              "options": [
                {
                  "label": "IVD",
                  "route": {
                    "code": "A40",
                    "label": "Voie intraveineuse"
                  }
                }, {
                  "label": "S/C ",
                  "route": {
                    "code": "A58",
                    "label": "Voie sous-cutanée"
                  }
                }, {
                  "label": "Rectale ",
                  "route": {
                    "code": "A52",
                    "label": "Voie rectale"
                  }
                }
              ],
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "bdm_data": {
                "name": "VALIUM ROCHE 10 mg/2 ml S inj 6Amp/2ml",
                "atc": "N05BA01",
                "inn": [
                  {
                    "cip": "8168354",
                    "name": "Diazépam 5 mg/mL injectable IM/IV/rectale"
                  }
                ],
                "ucd": "9097254",
                "cip": "3111243"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<i class='glyphicon glyphicon-warning-sign'></i><span class='product-name warning'>RIVOTRIL 1 mg/1 ml S diluer inj en ampoule 6Amp/1ml</span>:"
                }, {
                  "label": "mg",
                  "type": "quantity"
                }
              ],
              "options": [
                {
                  "label": "IVD",
                  "route": {
                    "code": "A40",
                    "label": "Voie intraveineuse"
                  }
                }, {
                  "label": "S/C ",
                  "route": {
                    "code": "A58",
                    "label": "Voie sous-cutanée"
                  }
                }
              ],
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "bdm_data": {
                "name": "RIVOTRIL 1 mg/1 ml S diluer inj en ampoule 6Amp/1ml",
                "atc": "N03AE01",
                "inn": [
                  {
                    "cip": "8162038",
                    "name": "Clonazépam 1 mg/mL injectable IM/IV"
                  }
                ],
                "ucd": "9199658",
                "cip": "3442827"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>OXYGENE ALR 200B BOUT ALU 2L+MAN</span>:"
                }, {
                  "label": "l/min",
                  "type": "quantity"
                }, {
                  "prefix": "pendant",
                  "type": "hours",
                  "suffix": "H"
                }, {
                  "type": "minutes",
                  "suffix": "mn. Débit à réévaluer selon la saturation"
                }
              ],
              "route": {
                "code": "A73",
                "label": "Voie inhalée"
              },
              "taking_unit": {
                "code": 163,
                "label_plural": "litres",
                "label": "litre"
              },
              "bdm_data": {
                "name": "OXYGENE ALR 200B BOUT ALU 2L+MAN",
                "atc": "V03AN01",
                "ucd": "9275218",
                "cip": "3627774"
              }
            }
          ]
        }, {
          "pap": "PAP 12",
          "order": 12,
          "name": "SYNDROME OCCLUSIF",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>METHYLPREDNISOLONE MYLAN 120 mg Pdr sol inj IM/IV Fl/10</span>:"
                }, {
                  "label": "mg",
                  "type": "quantity"
                }
              ],
              "options": [
                {
                  "label": "IVD",
                  "route": {
                    "code": "A40",
                    "label": "Voie intraveineuse"
                  }
                }, {
                  "label": "S/C ",
                  "route": {
                    "code": "A58",
                    "label": "Voie sous-cutanée"
                  }
                }
              ],
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "bdm_data": {
                "name": "METHYLPREDNISOLONE MYLAN 120 mg Pdr sol inj IM/IV Fl/10",
                "atc": "H02AB04",
                "inn": [
                  {
                    "cip": "8175360",
                    "name": "Méthylprednisolone 120 mg injectable IM/IV"
                  }
                ],
                "ucd": "9226763",
                "cip": "3419136"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>DEBRIDAT Glé susp buv en sachet B/30</span>:"
                }, {
                  "label": "Sachet(s)",
                  "type": "quantity"
                }
              ],
              "route": {
                "code": "A46",
                "label": "Voie orale"
              },
              "taking_unit": {
                "code": 13,
                "label_plural": "Sachets",
                "label": "Sachet"
              },
              "bdm_data": {
                "name": "DEBRIDAT Glé susp buv en sachet B/30",
                "atc": "A03AA05",
                "inn": [
                  {
                    "cip": "8175176",
                    "name": "Trimébutine 74,4 mg granulé pour suspension buvable sachet"
                  }
                ],
                "ucd": "9163494",
                "cip": "3359569"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>PRIMPERAN 10 mg/2 ml S inj en ampoule 12Amp/2ml</span>:"
                }, {
                  "label": "Ampoule(s)",
                  "type": "quantity"
                }
              ],
              "options": [
                {
                  "label": "IV",
                  "route": {
                    "code": "A40",
                    "label": "Voie intraveineuse"
                  }
                }, {
                  "label": "S/C ",
                  "route": {
                    "code": "A58",
                    "label": "Voie sous-cutanée"
                  }
                }
              ],
              "taking_unit": {
                "code": 4,
                "label_plural": "Ampoules",
                "label": "Ampoule"
              },
              "bdm_data": {
                "name": "PRIMPERAN 10 mg/2 ml S inj en ampoule 12Amp/2ml",
                "atc": "A03FA01",
                "inn": [
                  {
                    "cip": "8169106",
                    "name": "Métoclopramide 5 mg/mL injectable IM/IV"
                  }
                ],
                "ucd": "9075258",
                "cip": "3086166"
              }
            }
          ]
        }, {
          "pap": "PAP 13",
          "order": 13,
          "name": "DIABETE",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>GLUCAGEN KIT 1 mg/ml Pdre/solv p sol inj en seringue préremplie Fl+Ser/1ml</span>: 1 mg S/C"
                }
              ],
              "route": {
                "code": "A58",
                "label": "Voie sous-cutanée"
              },
              "quantity": 1,
              "taking_unit": {
                "code": 48,
                "label_plural": "mg",
                "label": "mg"
              },
              "bdm_data": {
                "name": "GLUCAGEN KIT 1 mg/ml Pdre/solv p sol inj en seringue préremplie Fl+Ser/1ml",
                "atc": "H04AA01",
                "inn": [
                  {
                    "cip": "8174202",
                    "name": "Glucagon 1 mg/mL injectable IM/IV/SC"
                  }
                ],
                "ucd": "9189743",
                "cip": "3359049"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>GLUCOSE LAVOISIER 30 % S inj en ampoule IV 100Amp/10ml</span>: 1 Ampoule(s)"
                }
              ],
              "route": {
                "code": "A40",
                "label": "Voie intraveineuse"
              },
              "quantity": 1,
              "taking_unit": {
                "code": 4,
                "label_plural": "Ampoules",
                "label": "Ampoule"
              },
              "bdm_data": {
                "name": "GLUCOSE LAVOISIER 30 % S inj en ampoule IV 100Amp/10ml",
                "atc": "B05BA03",
                "inn": [
                  {
                    "cip": "8178499",
                    "name": "Glucose 30% perfusion IV"
                  }
                ],
                "ucd": "9272295",
                "cip": "5647781"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<i class='glyphicon glyphicon-warning-sign'></i><span class='product-name warning'>NOVORAPID FLEXPEN 100 U/mL Solution injectable Boîte de 5 Stylos préremplis de 3 ml</span>: 1 stylo S/C si hyperglycémie. Dose en sous-cutanée selon protocole ci-joint"
                }
              ],
              "route": {
                "code": "A58",
                "label": "Voie sous-cutanée"
              },
              "quantity": 1,
              "taking_unit": {
                "code": 768,
                "label": "stylo",
                "label_plural": "stylos"
              },
              "bdm_data": {
                "name": "NOVORAPID FLEXPEN 100 U/mL Solution injectable Boîte de 5 Stylos préremplis de 3 ml",
                "atc": "A10AB05",
                "ucd": "9240243",
                "cip": "3552740"
              }
            }, {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>GLUCOSE FRESENIUS 10 % Solution injectable pour perfusion IV Boîte de 10 Flacon (polyéthylène) de 500 ml</span>: 1 flacon(s) S/C"
                }
              ],
              "route": {
                "code": "A58",
                "label": "Voie sous-cutanée"
              },
              "quantity": 1,
              "taking_unit": {
                "code": 26,
                "label_plural": "flacons",
                "label": "flacon"
              },
              "bdm_data": {
                "name": "GLUCOSE FRESENIUS 10 % Solution injectable pour perfusion IV Boîte de 10 Flacon (polyéthylène) de 500 ml",
                "atc": "B05BA03",
                "inn": [
                  {
                    "cip": "8154234",
                    "name": "Glucose 10% perfusion IV"
                  }
                ],
                "ucd": "9308314",
                "cip": "3832149"
              }
            }
          ]
        }, {
          "pap": "PAP 14",
          "order": 14,
          "name": "SURDOSAGE EN ANTI-VITAMINE K",
          "entries": [
            {
              "headers": [
                {
                  "type": "label",
                  "label": "<span class='product-name'>VITAMINE K1 ROCHE 10 mg/1 mL S inj/buv 3 Amp/1 mL </span>: 1 Ampoule(s) En cas de surdosage asymptomatique ou hémorragie non grave : - si INR < 4 : il n’y a pas de modification de prise - si INR entre 4 et 6 : saut d’une prise. - si INR entre 6 et 10 : arrêt du traitement et apport de 1 à 2 mg de vitamine K per os - si INR > 10 : arrêt du traitement et apport de 5 mg de vitamine K per os et référer: avis spécialisé ou hospitalisation sont recommandés"
                }
              ],
              "quantity": 1,
              "route": {
                "code": "A40",
                "label": "Voie intraveineuse"
              },
              "taking_unit": {
                "code": 4,
                "label_plural": "Ampoules",
                "label": "Ampoule"
              },
              "bdm_data": {
                "name": "VITAMINE K1 ROCHE 10 mg/1 mL Solution injectable IM et buvable Boîte de 3 Ampoules (+ pipette doseuse) de 1 mL",
                "atc": "B02BA01",
                "inn": [
                  {
                    "cip": "8171698",
                    "name": "Phytoménadione 10 mg/1 mL buvable et injectable IM/IV"
                  }
                ],
                "ucd": "9209948",
                "cip": "3483022"
              }
            }
          ]
        }
      ];
    };
    showAllStaysData = function() {
      resetCache();
      if ($rootScope.mh_config.platform === "mhsi") {
        return getSiteVar("SHOW_ALL_STAYS", false).then(function(sitevar) {
          return sitevar.value;
        });
      } else {
        return $window.mgapp.show_all_stays();
      }
    };
    getValue = function(name, defaultValue, entityId) {
      var SiteVarsPromise;
      SiteVarsPromise = $q.defer();
      getSiteVar(name, defaultValue, entityId).then(function(siteVar) {
        return SiteVarsPromise.resolve(siteVar.value);
      });
      return SiteVarsPromise.promise;
    };
    getBySector = function(sectorId, name) {
      return Sector.getSectors().then(function(sectors) {
        var sector;
        sector = _.find(sectors, {
          id: sectorId
        });
        return sector.data[name];
      });
    };
    getSiteVar = function(name, default_value, entityId, ignoreEntity, sectorId) {
      var SiteVarsPromise;
      SiteVarsPromise = $q.defer();
      $q.when(sectorId ? getBySector(sectorId, name) : void 0).then(function(value) {
        var entity, ref;
        if (value !== void 0 && value !== "") {
          SiteVarsPromise.resolve({
            value: value
          });
          return;
        }
        if (((entityId != null) || ((ref = $rootScope.user) != null ? ref.entity : void 0)) && !ignoreEntity) {
          return Entity.getEntities().then(function(entities) {
            var entity, ref1;
            entity = _.find(entities, {
              id: entityId || ((ref1 = $rootScope.user) != null ? ref1.entity : void 0)
            });
            if ((entity != null) && (entity[name] != null)) {
              return SiteVarsPromise.resolve({
                value: entity[name]
              });
            } else if ((entity != null) && (entity.sitevars[name] != null)) {
              return SiteVarsPromise.resolve({
                value: entity.sitevars[name]
              });
            } else {
              return SiteVarsPromise.resolve(getSiteVar(name, default_value, null, true));
            }
          });
        } else {
          if ((typeof patient !== "undefined" && patient !== null) && (patient.entity != null)) {
            entity = patient.entity;
          }
          if ((entity != null) && (entity[name] != null)) {
            return SiteVarsPromise.resolve({
              value: entity[name]
            });
          } else if ((entity != null) && (entity.sitevars[name] != null)) {
            return SiteVarsPromise.resolve({
              value: entity.sitevars[name]
            });
          } else {
            if (!(siteVarsCache === null)) {
              return globalSiteVarsPromise.promise.then(function() {
                return SiteVarsPromise.resolve(getCachedSiteVar(name, default_value));
              });
            } else {
              siteVarsCache = {};
              return SiteVar.query().$promise.then(function(sitevars) {
                var i, len, sitevar;
                siteVarsCache = {};
                for (i = 0, len = sitevars.length; i < len; i++) {
                  sitevar = sitevars[i];
                  siteVarsCache[sitevar.name] = sitevar;
                }
                globalSiteVarsPromise.resolve();
                return SiteVarsPromise.resolve(getCachedSiteVar(name, default_value));
              });
            }
          }
        }
      });
      return SiteVarsPromise.promise;
    };
    getImportMethod = function() {
      var getImportMethodPromise;
      getImportMethodPromise = $q.defer();
      if (MhConfig.platform === "mgapp") {
        getImportMethodPromise.resolve({
          import_method: null
        });
      } else {
        if (importMethod != null) {
          getImportMethodPromise.resolve(importMethod);
        } else {
          SiteVar.get_import_method().$promise.then(function(import_method) {
            importMethod = import_method;
            return getImportMethodPromise.resolve(importMethod);
          });
        }
      }
      return getImportMethodPromise.promise;
    };
    defaultCibleCategoriesLabel = {
      "RESPIRATION": [
        {
          "label": "Angoisse",
          "need_input": false
        }, {
          "label": "Apn\u00e9e",
          "need_input": true
        }, {
          "label": "Arr\u00eat respiratoire",
          "need_input": false
        }, {
          "label": "Cyanose",
          "need_input": false
        }, {
          "label": "D\u00e9gagement inefficace des voies respiratoire",
          "need_input": false
        }, {
          "label": "D\u00e9tresse respiratoire",
          "need_input": false
        }, {
          "label": "Dyspn\u00e9e",
          "need_input": false
        }, {
          "label": "Echanges gazeux perturb\u00e9s",
          "need_input": true
        }, {
          "label": "Ecoulement nasal",
          "need_input": false
        }, {
          "label": "Encombrement bronchique",
          "need_input": false
        }, {
          "label": "Essoufflement",
          "need_input": false
        }, {
          "label": "H\u00e9moptysie",
          "need_input": false
        }, {
          "label": "Hyper secr\u00e9tions",
          "need_input": false
        }, {
          "label": "Impossibilit\u00e9 de maintenir une respiration spontan\u00e9e",
          "need_input": false
        }, {
          "label": "Inhalation d'un corps \u00e9tranger",
          "need_input": false
        }, {
          "label": "Intol\u00e9rance au sevrage de la ventilation assist\u00e9e",
          "need_input": false
        }, {
          "label": "Pause respiratoire",
          "need_input": true
        }, {
          "label": "Polypn\u00e9e",
          "need_input": true
        }, {
          "label": "R\u00e2le",
          "need_input": false
        }, {
          "label": "Respiration spontan\u00e9e alt\u00e9r\u00e9",
          "need_input": false
        }, {
          "label": "Risque de fausse route",
          "need_input": false
        }, {
          "label": "Risque d'inhalation ou d'aspiration",
          "need_input": false
        }, {
          "label": "Risque d'intoxication",
          "need_input": false
        }, {
          "label": "Risque \u00e9lev\u00e9 de suffocation (manque d'air)",
          "need_input": false
        }, {
          "label": "Signe de lutte",
          "need_input": false
        }, {
          "label": "Tirage intercostal",
          "need_input": false
        }, {
          "label": "Toux",
          "need_input": false
        }
      ],
      "SORTIE": [
        {
          "label": "D\u00e9c\u00e8s",
          "need_input": false
        }, {
          "label": "Demande de placement",
          "need_input": false
        }, {
          "label": "Fugue",
          "need_input": false
        }, {
          "label": "Permission de sortie",
          "need_input": false
        }, {
          "label": "Pr\u00e9paration de la sortie",
          "need_input": false
        }, {
          "label": "Sortie contre avis m\u00e9dical",
          "need_input": false
        }, {
          "label": "Sortie sans autorisation",
          "need_input": false
        }
      ],
      "GESTION DES RISQUES": [
        {
          "label": "Non-respect de ses limites",
          "need_input": false
        }, {
          "label": "Protection judiciaire",
          "need_input": false
        }, {
          "label": "Risque de provoquer un incendie",
          "need_input": false
        }, {
          "label": "Risque de violence envers les autres",
          "need_input": false
        }, {
          "label": "Risque de violence envers soi m\u00eame",
          "need_input": false
        }, {
          "label": "Sous surveillance judiciaire",
          "need_input": false
        }, {
          "label": "Non observance (prescription m\u00e9dical, traitement, r\u00e9gime, actes, suivi m\u00e9dica...)",
          "need_input": false
        }
      ],
      "SENTIMENTS / PERCEPTIONS": [
        {
          "label": "Ambivalence",
          "need_input": false
        }, {
          "label": "Alt\u00e9ration de l\u2019estime de soi",
          "need_input": false
        }, {
          "label": "Angoisse",
          "need_input": false
        }, {
          "label": "Anxi\u00e9t\u00e9",
          "need_input": false
        }, {
          "label": "Ennui",
          "need_input": false
        }, {
          "label": "Exaltation ou inhibition de l\u2019humeur",
          "need_input": false
        }, {
          "label": "Fausse reconnaissance",
          "need_input": false
        }, {
          "label": "Inqui\u00e9tude",
          "need_input": false
        }
      ],
      "GESTION DE LA SANTE": [
        {
          "label": "Alt\u00e9ration de l\u2019\u00e9tat g\u00e9n\u00e9ral",
          "need_input": false
        }, {
          "label": "Am\u00e9lioration de l'autonomie",
          "need_input": false
        }, {
          "label": "Conduite addictive (Alcool, Tabac, drogues, ...)",
          "need_input": false
        }, {
          "label": "D\u00e9ficit de soins personnels (soigner son apparence)",
          "need_input": true
        }, {
          "label": "D\u00e9nis de ...",
          "need_input": true
        }, {
          "label": "Incapacit\u00e9 partielle ou totale \u00e0 g\u00e9rer les actes de la vie quotidienne",
          "need_input": false
        }, {
          "label": "Non-Observance du traitement",
          "need_input": false
        }, {
          "label": "Refus des soins prescrits",
          "need_input": false
        }, {
          "label": "Refus des d'hygi\u00e8ne",
          "need_input": false
        }, {
          "label": "Refus du traitement",
          "need_input": false
        }, {
          "label": "Risque de stockage de m\u00e9dicament",
          "need_input": false
        }, {
          "label": "Pr\u00e9paration d'examen pr\u00e9ciser le protocole",
          "need_input": false
        }, {
          "label": "Tentative de suicide (durant l'hospitalisation)",
          "need_input": false
        }
      ],
      "CARDIO VASCULAIRES": [
        {
          "label": "Alt\u00e9ration du capital veineux",
          "need_input": false
        }, {
          "label": "Arr\u00eat cardiaque",
          "need_input": false
        }, {
          "label": "Bradycardie",
          "need_input": true
        }, {
          "label": "Crise convulsive",
          "need_input": false
        }, {
          "label": "D\u00e9bit cardiaque diminu\u00e9",
          "need_input": true
        }, {
          "label": "Epistaxis",
          "need_input": false
        }, {
          "label": "H\u00e9matome \u00e0 localiser",
          "need_input": false
        }, {
          "label": "H\u00e9morragie",
          "need_input": false
        }, {
          "label": "Hypertension",
          "need_input": true
        }, {
          "label": "Hypotension",
          "need_input": true
        }, {
          "label": "Malaise",
          "need_input": false
        }, {
          "label": "\u0152d\u00e8mes (localisation)",
          "need_input": false
        }, {
          "label": "R\u00e9action \u00e0 la transfusion",
          "need_input": false
        }, {
          "label": "Risque de saignement",
          "need_input": false
        }, {
          "label": "Risque d'h\u00e9morragie",
          "need_input": false
        }, {
          "label": "Risque thromboembolique",
          "need_input": false
        }, {
          "label": "Tachycardie",
          "need_input": true
        }
      ],
      "ALIMENTATION - HYDRATATION": [
        {
          "label": "Alimentation d\u00e9ficiente",
          "need_input": false
        }, {
          "label": "Alimentation excessive",
          "need_input": false
        }, {
          "label": "Anorexie",
          "need_input": false
        }, {
          "label": "D\u00e9ficit visuel",
          "need_input": false
        }, {
          "label": "D\u00e9go\u00fbt alimentaire",
          "need_input": false
        }, {
          "label": "D\u00e9ficit de volume liquidien",
          "need_input": false
        }, {
          "label": "D\u00e9nutrition",
          "need_input": false
        }, {
          "label": "D\u00e9shydratation",
          "need_input": false
        }, {
          "label": "Difficult\u00e9 \u00e0 s\u2019alimenter",
          "need_input": false
        }, {
          "label": "Douleurs (pr\u00e9ciser la localisation) dentaire, m\u00e2choire",
          "need_input": true
        }, {
          "label": "Exc\u00e8s alimentaire",
          "need_input": false
        }, {
          "label": "Exc\u00e8s de volume liquidien",
          "need_input": false
        }, {
          "label": "Fausse route",
          "need_input": false
        }, {
          "label": "H\u00e9mat\u00e9m\u00e8se",
          "need_input": false
        }, {
          "label": "Hypoglyc\u00e9mie",
          "need_input": true
        }, {
          "label": "Hyperglyc\u00e9mie",
          "need_input": true
        }, {
          "label": "Manque d\u2019app\u00e9tit",
          "need_input": false
        }, {
          "label": "Manque de coordination gestuelle",
          "need_input": false
        }, {
          "label": "Mauvaise hygi\u00e8ne buccale",
          "need_input": false
        }, {
          "label": "Naus\u00e9e",
          "need_input": false
        }, {
          "label": "Paralysie faciale",
          "need_input": false
        }, {
          "label": "Perte d\u2019app\u00e9tit",
          "need_input": false
        }, {
          "label": "Perte de poids",
          "need_input": false
        }, {
          "label": "Prise de poids",
          "need_input": false
        }, {
          "label": "Potomanie (besoin irr\u00e9pressible de boire)",
          "need_input": true
        }, {
          "label": "Refus de s\u2019alimenter",
          "need_input": false
        }, {
          "label": "R\u00e9gurgitations",
          "need_input": false
        }, {
          "label": "Risque de d\u00e9nutrition",
          "need_input": false
        }, {
          "label": "Risque de fausse route",
          "need_input": false
        }, {
          "label": "Risque de d\u00e9shydratation",
          "need_input": false
        }, {
          "label": "S\u00e9cheresse buccale",
          "need_input": false
        }, {
          "label": "Troubles de la d\u00e9glutition",
          "need_input": false
        }, {
          "label": "Vomissements",
          "need_input": false
        }
      ],
      "AUTRE": [
        {
          "label": "Autre",
          "need_input": true
        }
      ],
      "\u00c9LIMINATION SELLES": [
        {
          "label": "Absence de gaz",
          "need_input": false
        }, {
          "label": "Constipation",
          "need_input": true
        }, {
          "label": "Diarrh\u00e9e",
          "need_input": true
        }, {
          "label": "Exc\u00e8s de gaz",
          "need_input": false
        }, {
          "label": "H\u00e9morro\u00efdes",
          "need_input": false
        }, {
          "label": "Incontinence f\u00e9cale",
          "need_input": false
        }, {
          "label": "M\u00e9laena",
          "need_input": false
        }, {
          "label": "Risque de constipation",
          "need_input": false
        }, {
          "label": "Rectorragies",
          "need_input": false
        }, {
          "label": "Selles d\u00e9color\u00e9es",
          "need_input": true
        }, {
          "label": "Selles naus\u00e9abondes",
          "need_input": true
        }
      ],
      "PSYCHOLOGIQUE": [
        {
          "label": "Alt\u00e9ration de l\u2019image corporelle",
          "need_input": false
        }, {
          "label": "Automutilation",
          "need_input": false
        }, {
          "label": "Hallucinations",
          "need_input": false
        }, {
          "label": "Prise en charge efficace du programme th\u00e9rapeutique",
          "need_input": false
        }, {
          "label": "Prise en charge non efficace du programme th\u00e9rapeutique",
          "need_input": false
        }, {
          "label": "Risque d'accident",
          "need_input": false
        }, {
          "label": "Risque de sentiment de solitude",
          "need_input": false
        }, {
          "label": "Risque de suicide",
          "need_input": false
        }, {
          "label": "Risque d'automutilation",
          "need_input": false
        }, {
          "label": "Risque de violence",
          "need_input": false
        }, {
          "label": "Sensation de mal\u00eatre",
          "need_input": false
        }, {
          "label": "Sensation d'\u00e9touffement",
          "need_input": false
        }, {
          "label": "Sentiment de pers\u00e9cution",
          "need_input": false
        }, {
          "label": "Syndrome post-traumatique",
          "need_input": false
        }
      ],
      "DOULEUR": [
        {
          "label": "Douleur suivi de la localisation",
          "need_input": true
        }, {
          "label": "Douleur aigu\u00eb",
          "need_input": true
        }, {
          "label": "Douleur chronique",
          "need_input": true
        }
      ],
      "TEMPERATURE": [
        {
          "label": "Hyperthermie",
          "need_input": true
        }, {
          "label": "Hypothermie",
          "need_input": true
        }
      ],
      "FONCTIONS INTELLECTUELLES": [
        {
          "label": "Am\u00e9lioration de la compr\u00e9hension",
          "need_input": false
        }, {
          "label": "D\u00e9sorientation temporo-spatiale",
          "need_input": false
        }, {
          "label": "Difficult\u00e9s de concentration",
          "need_input": false
        }, {
          "label": "Difficult\u00e9s de compr\u00e9hension",
          "need_input": false
        }, {
          "label": "Diminution de la vigilance",
          "need_input": false
        }, {
          "label": "Ralentissement psychique (pr\u00e9ciser)",
          "need_input": true
        }, {
          "label": "Troubles de la m\u00e9moire",
          "need_input": false
        }
      ],
      "CROYANCES ET SES VALEURS": [
        {
          "label": "D\u00e9tresse spirituelle",
          "need_input": false
        }, {
          "label": "Perte d'\u00e9lan vital",
          "need_input": false
        }, {
          "label": "Perte d'espoir",
          "need_input": false
        }, {
          "label": "Sentiment d'impuissance",
          "need_input": false
        }
      ],
      "COMPORTEMENTS": [
        {
          "label": "Agitation",
          "need_input": false
        }, {
          "label": "Agressivit\u00e9",
          "need_input": false
        }, {
          "label": "Altercation (avec ...)",
          "need_input": false
        }, {
          "label": "Am\u00e9lioration de l'autonomie",
          "need_input": false
        }, {
          "label": "Angoisse",
          "need_input": false
        }, {
          "label": "Anxi\u00e9t\u00e9",
          "need_input": false
        }, {
          "label": "Apathie",
          "need_input": false
        }, {
          "label": "Attitude d'opposition",
          "need_input": false
        }, {
          "label": "Attitude mena\u00e7ante",
          "need_input": false
        }, {
          "label": "Chagrin",
          "need_input": false
        }, {
          "label": "Col\u00e8re",
          "need_input": false
        }, {
          "label": "Comportement inadapt\u00e9",
          "need_input": false
        }, {
          "label": "Confusion",
          "need_input": false
        }, {
          "label": "D\u00e9ambulation excessive",
          "need_input": false
        }, {
          "label": "D\u00e9ni",
          "need_input": false
        }, {
          "label": "Deuil",
          "need_input": false
        }, {
          "label": "Errance",
          "need_input": false
        }, {
          "label": "Exaltation de l'humeur",
          "need_input": false
        }, {
          "label": "Exhibitionnisme",
          "need_input": false
        }, {
          "label": "H\u00e9tero agressivit\u00e9",
          "need_input": false
        }, {
          "label": "Impatience",
          "need_input": false
        }, {
          "label": "Intol\u00e9rance \u00e0 la frustration",
          "need_input": false
        }, {
          "label": "Instabilit\u00e9 de l'humeur",
          "need_input": false
        }, {
          "label": "Irritabilit\u00e9",
          "need_input": false
        }, {
          "label": "Lev\u00e9e d'inhibition",
          "need_input": false
        }, {
          "label": "M\u00e9contentement",
          "need_input": false
        }, {
          "label": "Peur de ...",
          "need_input": false
        }, {
          "label": "Panique",
          "need_input": false
        }, {
          "label": "Prostration",
          "need_input": false
        }, {
          "label": "Provocation",
          "need_input": false
        }, {
          "label": "Rires immotiv\u00e9s",
          "need_input": false
        }, {
          "label": "Simulation",
          "need_input": false
        }, {
          "label": "Tristesse",
          "need_input": false
        }
      ],
      "PEAU / T\u00c9GUMENTS / MUQUEUSE": [
        {
          "label": "Abc\u00e8s",
          "need_input": false
        }, {
          "label": "Allergie",
          "need_input": false
        }, {
          "label": "Alt\u00e9ration de l\u2019\u00e9tat cutan\u00e9",
          "need_input": false
        }, {
          "label": "Atteinte de la muqueuse buccale",
          "need_input": false
        }, {
          "label": "Br\u00fblure",
          "need_input": false
        }, {
          "label": "D\u00e9mengeaisons",
          "need_input": false
        }, {
          "label": "Desquamation",
          "need_input": false
        }, {
          "label": "Ecoulement (pr\u00e9ciser le lieu)",
          "need_input": false
        }, {
          "label": "Eruptions cutan\u00e9es",
          "need_input": false
        }, {
          "label": "Escarres (pr\u00e9ciser le lieu et le stade)",
          "need_input": true
        }, {
          "label": "Leucorrh\u00e9e",
          "need_input": false
        }, {
          "label": "Plaie (pr\u00e9ciser le lieu)",
          "need_input": false
        }, {
          "label": "R\u00e9action cutan\u00e9e (pr\u00e9ciser le type)",
          "need_input": false
        }, {
          "label": "R\u00e9action allergique",
          "need_input": false
        }, {
          "label": "Risque d'atteinte \u00e0 l'int\u00e9grit\u00e9 de la peau",
          "need_input": false
        }, {
          "label": "Risque d'infection",
          "need_input": false
        }, {
          "label": "Eryth\u00e8me",
          "need_input": false
        }, {
          "label": "Saignement (pr\u00e9ciser le lieu)",
          "need_input": false
        }, {
          "label": "S\u00e9cheresse cutan\u00e9e",
          "need_input": false
        }
      ],
      "SPIRITUALITE-CROYANCES": [
        {
          "label": "Demande d\u2019assister \u00e0 un office religieux",
          "need_input": false
        }, {
          "label": "Demande d\u2019un repr\u00e9sentant du culte ",
          "need_input": false
        }
      ],
      "SOMMEIL / REPOS": [
        {
          "label": "Agitation nocturne",
          "need_input": false
        }, {
          "label": "Cauchemars",
          "need_input": false
        }, {
          "label": "Difficult\u00e9s d'endormissement",
          "need_input": false
        }, {
          "label": "Fatigue",
          "need_input": false
        }, {
          "label": "Habitudes de sommeil perturb\u00e9es",
          "need_input": false
        }, {
          "label": "Insomnie",
          "need_input": false
        }, {
          "label": "Privation de sommeil",
          "need_input": false
        }, {
          "label": "Refus de se coucher",
          "need_input": false
        }, {
          "label": "R\u00e9veil pr\u00e9coce",
          "need_input": false
        }, {
          "label": "Sommeil perturb\u00e9",
          "need_input": false
        }, {
          "label": "Somnolence",
          "need_input": false
        }
      ],
      "ENTOURAGE": [
        {
          "label": "Conflit d\u00e9cisionnel",
          "need_input": false
        }, {
          "label": "Conflit familial",
          "need_input": false
        }, {
          "label": "Dysfonctionnement de la dynamique familiale : ex alcoolisme",
          "need_input": false
        }, {
          "label": "Isolement social",
          "need_input": false
        }, {
          "label": "Perturbation dans les relations avec la famille l'entourage",
          "need_input": false
        }, {
          "label": "Perturbations de la dynamique familiale",
          "need_input": false
        }, {
          "label": "Probl\u00e9matique familiale",
          "need_input": false
        }, {
          "label": "Sentiment de solitude",
          "need_input": false
        }, {
          "label": "Strat\u00e9gies d'adaptation inefficaces",
          "need_input": false
        }, {
          "label": "Tension dans l'exercice du r\u00f4le de l'aidant naturel",
          "need_input": false
        }
      ],
      "COMMUNICATION/RELATION": [
        {
          "label": "Affabulation",
          "need_input": false
        }, {
          "label": "Alt\u00e9ration de la communication verbale",
          "need_input": false
        }, {
          "label": "Anxi\u00e9t\u00e9",
          "need_input": false
        }, {
          "label": "Alt\u00e9ration de la vision",
          "need_input": false
        }, {
          "label": "Aphasie",
          "need_input": false
        }, {
          "label": "Confusion",
          "need_input": false
        }, {
          "label": "Dysphonie",
          "need_input": false
        }, {
          "label": "G\u00e9missements",
          "need_input": false
        }, {
          "label": "Isolement social",
          "need_input": false
        }, {
          "label": "Logorrh\u00e9e",
          "need_input": false
        }, {
          "label": "Mal voyant",
          "need_input": false
        }, {
          "label": "Mutisme",
          "need_input": false
        }, {
          "label": "Non ma\u00eetrise de la langue",
          "need_input": false
        }, {
          "label": "Propos / Discours d\u00e9lirants",
          "need_input": false
        }, {
          "label": "Propos / Discours incoh\u00e9rents",
          "need_input": false
        }, {
          "label": "Peur",
          "need_input": false
        }, {
          "label": "Refus de communiquer",
          "need_input": false
        }, {
          "label": "Sollicitations accrues envers les professionnels",
          "need_input": false
        }, {
          "label": "Surdit\u00e9",
          "need_input": false
        }
      ],
      "LOISIRS": [
        {
          "label": "Activit\u00e9s de loisirs insuffisantes",
          "need_input": false
        }, {
          "label": "Perte d'inter\u00eat",
          "need_input": false
        }
      ],
      "MOBILISATION": [
        {
          "label": "Alt\u00e9ration de la mobilit\u00e9 physique",
          "need_input": false
        }, {
          "label": "Am\u00e9lioration de la marche",
          "need_input": false
        }, {
          "label": "Chute",
          "need_input": true
        }, {
          "label": "Contractures musculaires",
          "need_input": false
        }, {
          "label": "Difficult\u00e9 \u00e0 la marche",
          "need_input": false
        }, {
          "label": "Difficult\u00e9 lors d'un transfert",
          "need_input": false
        }, {
          "label": "Diminution de la mobilit\u00e9",
          "need_input": true
        }, {
          "label": "Luxation (\u00e0 pr\u00e9ciser)",
          "need_input": false
        }, {
          "label": "Perte de la mobilit\u00e9",
          "need_input": false
        }, {
          "label": "1er lever",
          "need_input": false
        }, {
          "label": "Risque de chute",
          "need_input": false
        }, {
          "label": "Risque de luxation",
          "need_input": false
        }, {
          "label": "Troubles de l\u2019\u00e9quilibre",
          "need_input": false
        }
      ],
      "\u00c9LIMINATION URINES": [
        {
          "label": "Anurie",
          "need_input": false
        }, {
          "label": "Brulures mictionnelles",
          "need_input": false
        }, {
          "label": "Dysurie",
          "need_input": false
        }, {
          "label": "\u00c9limination",
          "need_input": false
        }, {
          "label": "de lithiase",
          "need_input": false
        }, {
          "label": "Fuites urinaires \u00e0 l\u2019effort",
          "need_input": false
        }, {
          "label": "Fuites urinaires permanentes",
          "need_input": false
        }, {
          "label": "Globe v\u00e9sical",
          "need_input": false
        }, {
          "label": "H\u00e9maturie",
          "need_input": false
        }, {
          "label": "Incontinence urinaire",
          "need_input": false
        }, {
          "label": "Pollakiurie",
          "need_input": false
        }, {
          "label": "Polyurie",
          "need_input": false
        }, {
          "label": "R\u00e9tention urinaire",
          "need_input": false
        }
      ]
    };
    service = {
      get: getSiteVar,
      getValue: getValue,
      getDefaultLogo: getDefaultLogo,
      showAllStaysData: showAllStaysData,
      getDefaultMenu: getDefaultMenu,
      defaultCibleCategoriesLabel: defaultCibleCategoriesLabel,
      getImportMethod: getImportMethod,
      getDefaultPapTemplates: getDefaultPapTemplates,
      resetCache: resetCache
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=sitevar-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.configtool:onReadFile
    * @description
    * # onReadFile
    * Allow use of a function on the content of an imported file
   */
  angular.module('mhclientApp').directive('onReadFile', ["$parse", function($parse) {
    return {
      restrict: 'A',
      scope: {
        onReadFile: '&'
      },
      link: function(scope, element, attrs) {
        return element.on('change', function(e) {
          var reader;
          reader = new FileReader();
          return reader.onload = function(e) {
            scope.$apply(function() {
              return scope.onReadFile({
                $content: e.target.result
              });
            });
            return reader.readAsText((e.srcElement || e.target).files[0]);
          };
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=on-read-file-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.configtool:mgappKeyboard
    * @description
    * # mgappKeyboard
    * Allow use of a function on the content of an imported file
   */
  angular.module('mhclientApp').directive('mgappKeyboard', ["$rootScope", "$window", "$filter", "$uibModal", function($rootScope, $window, $filter, $uibModal) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        ngModel: '=',
        forceNative: "=?"
      },
      link: function(scope, element, attrs) {
        element.on('click', function() {
          var force_native, multiline, native_keyboard, numeric_only;
          if ($rootScope.mh_config.platform === "mgapp") {
            native_keyboard = $window.mgapp.native_keyboard();
            force_native = scope.forceNative || false;
            multiline = element[0].type === 'textarea';
            numeric_only = element[0].type === 'number';
            element[0].focus();
            $window.setCurrentInput = scope.setCurrentInputText;
            return $window.mgapp.open_keyboard(element.val(), multiline, force_native, numeric_only);
          }
        });
        return scope.setCurrentInputText = function(val) {
          scope.$apply(function() {
            element.controller('ngModel').$setViewValue(val);
            return element.controller('ngModel').$render();
          });
          if (scope.$parent.formStruct != null) {
            return scope.$parent.formStruct.$dirty = true;
          }
        };
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=mgapp-keyboard-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:draw
    * @description
    * # Draw
    * Directive for drawing medical form
   */
  angular.module('mhclientApp').directive('mhDraw2', ["$timeout", "debounce", "$state", function($timeout, debounce, $state) {
    var logicForDrawing;
    logicForDrawing = function(scope, element, attrs) {

      /* */

      /*  DRAWING IN CANVAS */

      /* */
      var capture, computePosition, currentPath, currentPosition, endOfDrawing, erase, formatPath, mouseDownFunction, mouseMoveFunction, mouseUpFunction, reduce, savePoints, saveText, startPosition, toDrawPath;
      scope.isDrawing = false;
      startPosition = {
        x: 0,
        y: 0
      };
      currentPosition = {
        x: 0,
        y: 0
      };
      currentPath = [];
      toDrawPath = [];
      endOfDrawing = function(data, start, step) {
        var fn, i, len, path, ref, stop;
        stop = window.Math.min(start + step, data.length);
        ref = data.slice(start, +stop + 1 || 9e9);
        for (i = 0, len = ref.length; i < len; i++) {
          path = ref[i];
          scope.drawPath(path, scope.config.smooth, scope.drawingCanvas.context);
        }
        if (start < stop) {
          fn = angular.bind(this, endOfDrawing, data, start + step, step);
          return $timeout(fn, 0);
        } else {
          toDrawPath = [];
          return scope.isBusy = false;
        }
      };
      scope.endOfDrawing = debounce(1000, function() {
        return endOfDrawing(toDrawPath, 0, 100);
      });
      mouseDownFunction = function(position, ev) {
        if (toDrawPath.length > 0) {
          scope.endOfDrawing.cancel();
        }
        $timeout(function() {
          return scope.$apply(scope.isBusy = true);
        }, 100);
        scope.isDrawing = true;
        currentPath = [];
        startPosition = computePosition(position);
        currentPath.push(startPosition);
        if (ev.which === 1) {
          switch (scope.config.action) {
            case 'draw':
              return capture(startPosition);
            case 'erase':
              return erase(startPosition);
          }
        }
      };
      scope.bufferCanvas.canvas.onmousedown = function(ev) {
        var position;
        position = {
          x: ev.offsetX != null ? ev.offsetX : ev.layerX,
          y: ev.offsetY != null ? ev.offsetY : ev.layerY
        };
        return mouseDownFunction(position, ev);
      };
      mouseMoveFunction = function(position) {
        if (scope.isDrawing && (scope.config.action === 'erase' || scope.config.action === 'draw') && !scope.config.readonly) {
          position = computePosition(position);
          if (scope.config.action === 'erase') {
            return erase(position);
          } else {
            return capture(position);
          }
        }
      };
      scope.bufferCanvas.canvas.onmousemove = function(ev) {
        var position;
        position = {
          x: ev.offsetX != null ? ev.offsetX : ev.layerX,
          y: ev.offsetY != null ? ev.offsetY : ev.layerY
        };
        return mouseMoveFunction(position);
      };
      mouseUpFunction = function() {
        var path;
        if ((scope.config.action === 'erase' || scope.config.action === 'draw') && !scope.config.readonly) {
          scope.isDrawing = false;
          path = formatPath(currentPath);
          savePoints(path);
          toDrawPath.push(path);
          return scope.endOfDrawing();
        }
      };
      scope.bufferCanvas.canvas.onmouseup = function(ev) {
        return mouseUpFunction();
      };
      scope.bufferCanvas.canvas.onmouseout = function(ev) {
        var path;
        if (scope.isDrawing && !scope.config.readonly) {
          path = formatPath(currentPath);
          toDrawPath.push(path);
          return savePoints(path);
        }
      };
      scope.bufferCanvas.canvas.onmouseenter = function(ev) {
        if (scope.isDrawing && !scope.config.readonly) {
          startPosition = {
            x: ev.offsetX != null ? ev.offsetX : ev.layerX,
            y: ev.offsetY != null ? ev.offsetY : ev.layerY
          };
          startPosition = computePosition(startPosition);
          scope.isDrawing = true;
          currentPath.push(startPosition);
          if (scope.config.action === 'erase') {
            return erase(startPosition);
          } else {
            return capture(startPosition);
          }
        }
      };
      capture = function(position) {
        if (scope.isDrawing && !scope.config.readonly) {
          currentPosition = position;
          currentPath.push(position);
          scope.bufferCanvas.context.beginPath();
          scope.bufferCanvas.context.moveTo(startPosition.x, startPosition.y);
          scope.bufferCanvas.context.lineTo(currentPosition.x, currentPosition.y);
          scope.bufferCanvas.context.stroke();
          scope.bufferCanvas.context.closePath();
          return startPosition = currentPosition;
        }
      };
      erase = function(position) {
        if (scope.isDrawing) {
          currentPosition = position;
          currentPath.push(position);
          scope.drawingCanvas.context.beginPath();
          scope.drawingCanvas.context.moveTo(startPosition.x, startPosition.y);
          scope.drawingCanvas.context.lineTo(currentPosition.x, currentPosition.y);
          scope.drawingCanvas.context.stroke();
          scope.drawingCanvas.context.closePath();
          return startPosition = currentPosition;
        }
      };
      computePosition = function(position) {
        var realPosition;
        realPosition = {
          x: position.x * scope.size.width / scope.canvasContainer.clientWidth,
          y: position.y * scope.size.height / scope.canvasContainer.clientHeight
        };
        return realPosition;
      };
      reduce = function(path) {
        var lastPoint, pathSimplified, pathWithoutLastPoint;
        pathWithoutLastPoint = path.slice(0, path.length - 1);
        lastPoint = [path[path.length - 1]];
        pathSimplified = simplify(pathWithoutLastPoint, scope.config.tolerance, false);
        pathSimplified = pathSimplified.concat(lastPoint);
        return pathSimplified;
      };
      savePoints = function(path) {
        var data;
        if (scope.config.readonly) {
          return;
        }
        data = {
          "action": scope.config.action,
          "color": scope.config.penColor,
          "smooth": scope.config.smooth,
          "points": path
        };
        return scope.data.push(data);
      };
      saveText = function(id, position, content) {
        var base64;
        if (scope.config.readonly) {
          return;
        }
        base64 = getBase64Image(content);
        return scope.$apply(function() {
          var data;
          data = {
            "id": id,
            "action": scope.config.action,
            "color": scope.config.penColor,
            "top": position.top,
            "left": position.left,
            "content": content,
            "image": base64
          };
          return scope.data.push(data);
        });
      };
      return formatPath = function(path) {
        var i, k, ref;
        path = reduce(path);
        for (k = i = 0, ref = path.length; i < ref; k = i += 1) {
          path[k].x = Math.round(path[k].x * 100) / 100;
          path[k].y = Math.round(path[k].y * 100) / 100;
        }
        return path;
      };
    };
    return {
      controller: "MhDrawCtrl",
      link: logicForDrawing,
      transclude: true,
      scope: {
        initialData: "=?",
        data: "=",
        size: "=",
        config: "=",
        isBusy: "=?",
        onReady: "=?"
      },
      template: '<div class="draw-with-image" ng-class="{readonly: config.readonly}"> <div ng-transclude></div> <canvas class="bufferCanvas" id="bufferCanvasId" ng-class="{ \'to-foreground\' : config.action !== \'text\'}"></canvas> <canvas class="drawingCanvas" id="drawingCanvasId"></canvas> <mh-note initial-data="initialData" data="data" size="size" config="config" on-ready="onReady" ng-if="config.withNotes"></mh-note> </div>'
    };
  }]);

}).call(this);

//# sourceMappingURL=draw-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.core:MedFormsMhDrawCtrl
    * @description
    * # MedFormsMhDrawCtrl
    * Controller for creation of medical forms
   */
  angular.module('mhclientApp').controller('MhDrawCtrl', ["$scope", "$timeout", "$state", "$element", "$q", function($scope, $timeout, $state, $element, $q) {

    /* */

    /*  INITIALIZATION */

    /* */
    var drawer, setContext, setSize, updateSize, zoomTo;
    $scope.coefficientForZoom = 1;
    $scope.canvasContainer = $element[0].firstChild;
    $scope.canvasContainer.style.width = $scope.size.width;
    $scope.canvasContainer.style.height = $scope.size.height;

    /* */

    /*  USEFUL FUNCTIONS */

    /* */
    $scope.clear = function(canvas) {
      var canvasHeight, canvasWidth;
      if (canvas == null) {
        canvas = 'all';
      }
      canvasWidth = $scope.bufferCanvas.canvas.width;
      canvasHeight = $scope.bufferCanvas.canvas.height;
      if (canvas !== 'all') {
        return canvas.context.clearRect(0, 0, canvasWidth, canvasHeight);
      } else {
        $scope.bufferCanvas.context.clearRect(0, 0, canvasWidth, canvasHeight);
        $scope.drawingCanvas.context.clearRect(0, 0, canvasWidth, canvasHeight);
        return $scope.data = [];
      }
    };
    $scope.drawPath = function(path, smoothness) {
      var DrawCanvasContext, i, j, k, l, ref, ref1, xc, yc;
      DrawCanvasContext = $scope.drawingCanvas.context;
      DrawCanvasContext.beginPath();
      if (path.length === 2 && path[0].x === path[1].x && path[0].y === path[1].y) {
        DrawCanvasContext.arc(path[0].x, path[0].y, 1, 0, 2 * Math.PI, false);
        DrawCanvasContext.fill();
      } else {
        DrawCanvasContext.moveTo(path[0].x, path[0].y);
        if (smoothness) {
          for (i = j = 0, ref = path.length - 1; j < ref; i = j += 1) {
            xc = (path[i].x + path[i + 1].x) / 2;
            yc = (path[i].y + path[i + 1].y) / 2;
            DrawCanvasContext.quadraticCurveTo(path[i].x, path[i].y, xc, yc);
          }
        } else {
          for (k = l = 0, ref1 = path.length; l < ref1; k = l += 1) {
            DrawCanvasContext.lineTo(path[k].x, path[k].y);
          }
        }
      }
      DrawCanvasContext.stroke();
      DrawCanvasContext.closePath();
      return $scope.clear($scope.bufferCanvas);
    };
    setSize = function(canvas) {
      canvas.style.width = "100%";
      canvas.style.height = "100%";
      canvas.width = $scope.size.width;
      return canvas.height = $scope.size.height;
    };
    setContext = function(context, operation, lineWidth, color, lineJoin) {
      context.lineCap = 'round';
      context.globalCompositeOperation = operation;
      context.lineWidth = lineWidth;
      context.strokeStyle = color;
      if (lineJoin != null) {
        return context.lineJoin = lineJoin;
      }
    };
    zoomTo = function(zoom) {
      var scaleString, zoomLevel;
      zoomLevel = parseFloat(zoom);
      $scope.coefficientForZoom = zoomLevel / 100;
      scaleString = 'scale(' + $scope.coefficientForZoom + ',' + $scope.coefficientForZoom + ')';
      $(".all-datas").css('transform-origin', '50% 0%');
      $(".all-datas").css('transform', scaleString);
      return false;
    };
    $scope.bufferCanvas = {
      canvas: $scope.canvasContainer.children[1],
      initConfig: function() {
        this.context = this.canvas.getContext('2d');
        setSize(this.canvas);
        return setContext(this.context, 'source-over', $scope.config.lineWidth, $scope.config.penColor);
      }
    };
    $scope.drawingCanvas = {
      canvas: $scope.canvasContainer.children[2],
      initConfig: function() {
        this.context = this.canvas.getContext('2d');
        setSize(this.canvas);
        return setContext(this.context, 'source-over', $scope.config.lineWidth, $scope.config.penColor, 'round');
      }
    };
    $scope.bufferCanvas.initConfig();
    $scope.drawingCanvas.initConfig();

    /* */

    /*  DRAWING INITIAL DATA */

    /* */
    drawer = function(start, step, data, promise) {
      var DrawCanvasContext, bufferCanvasContext, dr, graphicElement, j, len, ref, stop;
      if (data == null) {
        return;
      }
      stop = window.Math.min(start + step, data.length);
      DrawCanvasContext = $scope.drawingCanvas.context;
      ref = data.slice(start, +stop + 1 || 9e9);
      for (j = 0, len = ref.length; j < len; j++) {
        graphicElement = ref[j];
        setContext(DrawCanvasContext, 'source-over', $scope.config.lineWidth, graphicElement.color);
        switch (graphicElement.action) {
          case 'draw':
            $scope.drawPath(graphicElement.points, graphicElement.smooth);
            break;
          case 'erase':
            setContext(DrawCanvasContext, 'destination-out', 30, "rgb(0,0,0,1)");
            $scope.drawPath(graphicElement.points, graphicElement.smooth);
        }
      }
      if (start < stop) {
        dr = angular.bind(this, drawer, start + step, step, data, promise);
        return $timeout(dr, 0, true);
      } else {
        bufferCanvasContext = $scope.bufferCanvas.context;
        setContext(bufferCanvasContext, 'source-over', $scope.config.lineWidth, $scope.config.penColor, 'round');
        if (promise != null) {
          return promise.resolve();
        }
      }
    };
    if ($scope.initialData != null) {
      $q.when($scope.initialData).then(function(initialData) {
        return drawer(0, 100, initialData);
      });
    }
    if (!($scope.data instanceof Array)) {
      $scope.data = [];
    }
    drawer(0, 100, $scope.data);
    if ($scope.onReady != null) {
      $scope.onReady();
    }

    /* */

    /*  LIVE CONFIG */

    /* */
    $scope.$watch('config.action', (function(newConfig, oldConfig) {
      var canDo, res;
      canDo = $q.defer();
      res = $scope.endOfDrawing.flush();
      if (res && res.then instanceof Function) {
        res.then(function() {
          return canDo.resolve();
        });
      } else {
        canDo.resolve();
      }
      return canDo.promise.then(function() {
        var bufferCanvasContext, drawCanvasContext;
        bufferCanvasContext = $scope.bufferCanvas.context;
        drawCanvasContext = $scope.drawingCanvas.context;
        switch (newConfig) {
          case 'erase':
            setContext(bufferCanvasContext, 'destination-out', 30, "rgba(0,0,0,1)");
            return setContext(drawCanvasContext, 'destination-out', 30, "rgba(0,0,0,1)");
          case 'draw':
            setContext(bufferCanvasContext, 'source-over', $scope.config.lineWidth, $scope.config.penColor);
            return setContext(drawCanvasContext, 'source-over', $scope.config.lineWidth, $scope.config.penColor, 'round');
        }
      });
    }));
    updateSize = function() {
      $scope.bufferCanvas.initConfig();
      $scope.drawingCanvas.initConfig();
      $scope.canvasContainer.style.width = $scope.config.width + 'px';
      return $scope.canvasContainer.style.height = $scope.config.height + 'px';
    };
    $scope.$watch('config.width', function(newConfig, oldConfig) {
      updateSize();
      if (newConfig !== oldConfig) {
        drawer(0, 100, $scope.container.dataContent);
        return drawer(0, 100, $scope.container.newDataContent);
      }
    });
    $scope.$watch('config.height', function(newConfig, oldConfig) {
      updateSize();
      if (newConfig !== oldConfig) {
        drawer(0, 100, $scope.container.dataContent);
        return drawer(0, 100, $scope.container.newDataContent);
      }
    });
    $scope.$watch('config.penColor', (function(newConfig, oldConfig) {
      var canDo, res;
      canDo = $q.defer();
      res = $scope.endOfDrawing.flush();
      if (res && res.then instanceof Function) {
        res.then(function() {
          return canDo.resolve();
        });
      } else {
        canDo.resolve();
      }
      return canDo.promise.then(function() {
        var bufferCanvasContext, drawCanvasContext;
        bufferCanvasContext = $scope.bufferCanvas.context;
        drawCanvasContext = $scope.drawingCanvas.context;
        switch ($scope.config.action) {
          case 'erase':
            setContext(bufferCanvasContext, 'destination-out', 30, "rgba(0,0,0,1)");
            return setContext(drawCanvasContext, 'destination-out', 30, "rgba(0,0,0,1)");
          case 'draw':
            setContext(bufferCanvasContext, 'source-over', $scope.config.lineWidth, newConfig);
            return setContext(drawCanvasContext, 'source-over', $scope.config.lineWidth, newConfig, 'round');
        }
      });
    }));
    $scope.$watch('config.zoom', (function(newConfig, oldConfig) {
      var canDo, res;
      canDo = $q.defer();
      res = $scope.endOfDrawing.flush();
      if (res && res.then instanceof Function) {
        res.then(function() {
          return canDo.resolve();
        });
      } else {
        canDo.resolve();
      }
      return canDo.promise.then(function() {
        var bufferCanvasContext, drawCanvasContext;
        bufferCanvasContext = $scope.bufferCanvas.context;
        drawCanvasContext = $scope.drawingCanvas.context;
        if (newConfig !== oldConfig) {
          if (newConfig > 130 || newConfig < 60) {
            newConfig.zoom = oldConfig;
          }
          return zoomTo(newConfig);
        }
      });
    }));
    return $scope.$watch('size.height', (function(newSize, oldSize) {
      var canvasHeight, canvasWidth;
      $scope.bufferCanvas.initConfig();
      $scope.drawingCanvas.initConfig();
      $scope.canvasContainer.style.width = $scope.size.width + 'px';
      $scope.canvasContainer.style.height = $scope.size.height + 'px';
      canvasWidth = $scope.bufferCanvas.canvas.width;
      canvasHeight = $scope.bufferCanvas.canvas.height;
      $scope.bufferCanvas.context.clearRect(0, 0, canvasWidth, canvasHeight);
      $scope.drawingCanvas.context.clearRect(0, 0, canvasWidth, canvasHeight);
      return drawer(0, 100, $scope.data);
    }));
  }]);

}).call(this);

//# sourceMappingURL=draw-directive-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:note
    * @description
    * # Note
    * Directive for adding note on medical form
   */
  angular.module('mhclientApp').directive('mhNote', function() {

    /* */

    /*  CREATING NOTES */

    /* */
    var logicForDrawing;
    logicForDrawing = function(scope, element, attrs) {
      var applyLineBreaks, createCanvasNote, getBase64Image, getMaxWidth, saveText, updateNote;
      createCanvasNote = function(color, initialText) {
        var c_canvas, canvas, ctx, currentY, i, incrementY, len, line, ref, startX, startY;
        if (initialText == null) {
          initialText = '';
        }
        canvas = $('<canvas></canvas>');
        c_canvas = canvas[0];
        ctx = c_canvas.getContext("2d");
        ctx.font = "16px MhFont";
        ctx.fillStyle = color;
        startX = 5;
        startY = 15;
        incrementY = parseInt($('textarea.input_area').css('line-height'));
        currentY = startY;
        ref = initialText.split('\n');
        for (i = 0, len = ref.length; i < len; i++) {
          line = ref[i];
          ctx.fillText(line, startX, currentY);
          currentY = currentY + incrementY;
        }
        return c_canvas;
      };
      saveText = function(id, position, content) {
        var base64;
        if (scope.readonly) {
          return;
        }
        base64 = getBase64Image(content);
        return scope.$apply(function() {
          var data;
          data = {
            "id": id,
            "action": scope.config.action,
            "color": scope.config.penColor,
            "top": position.top,
            "left": position.left,
            "content": content,
            "image": base64
          };
          return scope.data.push(data);
        });
      };
      getMaxWidth = function(id) {
        var containerWidth, maxWidth, note, position;
        note = $('#note_' + id);
        position = note.position();
        containerWidth = angular.element(scope.notesDivCapture).width();
        maxWidth = containerWidth - (position.left / scope.coefficientForZoom);
        return maxWidth - 15;
      };
      applyLineBreaks = function(textarea) {
        var auxSpan, curChar, i, id, len, strRawValue, toreturn;
        id = $("#aux_span_" + textarea.attr('id'));
        if (id.val() !== void 0) {
          auxSpan = id;
        } else {
          auxSpan = $('<span class="aux_span" id="aux_span_' + textarea.attr('id') + '"></span>');
          $('.notes').append(auxSpan);
          auxSpan.css({
            'position': 'absolute',
            'font-weight': textarea.css('font-weight'),
            'font-family': textarea.css('font-family'),
            'font-size': textarea.css('font-size'),
            'line-height': textarea.css('line-height'),
            'color': 'transparent',
            'visibility': 'hidden'
          });
        }
        strRawValue = $(textarea).val();
        toreturn = "";
        auxSpan.html("");
        for (i = 0, len = strRawValue.length; i < len; i++) {
          curChar = strRawValue[i];
          if (curChar === "\n") {
            auxSpan.html(auxSpan.html() + "<br>");
          } else {
            auxSpan.html(auxSpan.html() + curChar);
          }
          if (auxSpan.width() > $(textarea).innerWidth()) {
            toreturn += "\n";
            auxSpan.html("");
          }
          toreturn += curChar;
        }
        return toreturn;
      };
      updateNote = function(id) {
        var base64, content, note, noteExists, position;
        note = $('#note_' + id);
        content = applyLineBreaks(note.find('.input_area'));
        position = note.position();
        noteExists = _.find(scope.data, function(n) {
          return n.id === id;
        });
        base64 = getBase64Image(content);
        console.log(position);
        if (noteExists != null) {
          noteExists.top = note.position().top;
          noteExists.left = note.position().left;
          noteExists.content = content;
          return noteExists.image = base64;
        } else {
          return saveText(id, position, content);
        }
      };
      getBase64Image = function(content) {
        var canvas, dataURL;
        canvas = createCanvasNote(scope.config.penColor, content);
        dataURL = canvas.toDataURL("image/png");
        return dataURL;
      };
      scope.addNote = function(position, initialText, id, color) {
        var divIcons, dragConfig, iconArrow, iconsClose, idNote, note, textarea, widgetCorner;
        if (initialText == null) {
          initialText = '';
        }
        if (scope.readonly) {
          return;
        }
        widgetCorner = {
          x: position.left,
          y: position.top
        };
        divIcons = $('<div class="icons"></div>');
        iconArrow = $("<span class='glyphicon glyphicon-move' style='cursor: move;'></span>").attr('moving', 'false');
        iconsClose = $("<span class='glyphicon glyphicon-remove' style='cursor: pointer;'></span>");
        divIcons.append(iconArrow);
        divIcons.append(iconsClose);
        textarea = $('<textarea cols="2000" class="input_area"></textarea>');
        color = color || scope.config.penColor;
        textarea.css({
          "color": color,
          "font-size": scope.fontSizeAccordingToZoom,
          "line-height": scope.lineHeightAccordingToZoom
        });
        textarea[0].value = initialText;
        idNote = id || Math.floor((Math.random() * 10000000) + 1);
        textarea.attr("id", "input_area_" + idNote);
        note = $("<div class='notes' id=note_" + idNote + "></div>");
        note.css({
          "left": widgetCorner.x,
          "top": widgetCorner.y,
          "font-size": scope.fontSizeAccordingToZoom,
          "line-height": scope.lineHeightAccordingToZoom,
          "position": 'absolute'
        });
        note.append(divIcons);
        note.append(textarea);
        dragConfig = {
          containment: scope.notesDivCapture,
          handle: iconArrow,
          cursor: "move",
          start: function(e, ui) {
            divIcons.show();

            /* OPTIONAL : DOESNT FIX TOTALLY BUGS */
            ui.position.left = 0;
            return ui.position.top = 0;

            /* OPTIONAL : DOESNT FIX TOTALLY BUGS */
          },
          stop: function(e, ui) {
            e.stopPropagation();
            divIcons.show();
            textarea.css("max-width", getMaxWidth(idNote));
            return updateNote(idNote);
          },
          drag: function(e, ui) {
            var changeLeft, changeTop, newLeft, newTop;
            divIcons.show();

            /* OPTIONAL : DOESNT FIX TOTALLY BUGS */
            changeLeft = (ui.position.left - ui.originalPosition.left) / scope.coefficientForZoom;
            newLeft = ui.originalPosition.left + changeLeft;
            changeTop = (ui.position.top - ui.originalPosition.top) / scope.coefficientForZoom;
            newTop = ui.originalPosition.top + changeTop;
            ui.position.left = newLeft;
            return ui.position.top = newTop;

            /* OPTIONAL : DOESNT FIX TOTALLY BUGS */
          }
        };
        note.draggable(dragConfig);
        note.click(function(e) {
          e.stopPropagation();
          return textarea.focus();
        });
        $(scope.notesDivCapture).append(note);
        textarea.css("max-width", getMaxWidth(idNote));
        $(textarea).autoGrow({
          extraLine: false
        });
        textarea.on('blur', function() {
          if (!$(textarea).val()) {
            return note.remove();
          } else {
            return updateNote(idNote);
          }
        });
        note.on('mouseenter', function() {
          return divIcons.show();
        });
        note.on('mouseleave', function() {
          return divIcons.hide();
        });
        iconsClose.on('click', function(e) {
          var graphicElement, i, indexToRemove, len, ref;
          note.remove();
          ref = scope.data;
          for (i = 0, len = ref.length; i < len; i++) {
            graphicElement = ref[i];
            if (graphicElement.id === idNote) {
              indexToRemove = scope.data.indexOf(graphicElement);
            }
          }
          scope.data.splice(indexToRemove, 1);
          return false;
        });
        return textarea.focus();
      };
      return scope.notesDivCapture.onclick = function(ev) {
        var startPosition;
        startPosition = {
          left: ev.offsetX != null ? ev.offsetX : ev.layerX,
          top: ev.offsetY != null ? ev.offsetY : ev.layerY
        };
        console.log('click : ', startPosition);
        return scope.addNote(startPosition);
      };
    };
    return {
      controller: "MhNoteCtrl",
      link: logicForDrawing,
      transclude: true,
      restrict: 'E',
      scope: {
        initialData: "=?",
        data: "=",
        size: "=",
        config: "=",
        onReady: "=?"
      },
      template: '<div class="draw-with-image" ng-class="{readonly: readonly}"> <div ng-transclude></div> <div class="drawingNotes {{container.page}}"></div> <div class="captureNotes" ng-class="{ \'to-foreground\' : config.action === \'text\'}"></div> </div>'
    };
  });

}).call(this);

//# sourceMappingURL=note-directive.js.map


/*
  * @ngdoc function
  * @name mhclientApp.core:MhNoteCtrl
  * @description
  * # MhNoteCtrl
  * Controller for note medical forms
 */

(function() {
  angular.module('mhclientApp').controller('MhNoteCtrl', ["$scope", "$timeout", "$state", "$element", "$q", function($scope, $timeout, $state, $element, $q) {
    var drawer, insertImageNote;
    $scope.notesDivCapture = angular.element($element[0].firstChild).children('.captureNotes')[0];
    $scope.notesDivCapture.style.width = $scope.size.width;
    $scope.notesDivCapture.style.height = $scope.size.height;
    console.log("WARNING: controller not functionnal: make sure config.withNotes is false for desactivate this mode");
    insertImageNote = function(id, position, imageBase64) {
      var img;
      img = $('<img id=' + id + '>');
      img.attr('src', imageBase64);
      img.attr('ng-src', imageBase64);
      img.css({
        "position": "absolute",
        "top": position.top,
        "left": position.left,
        "margin-left": 5,
        "margin-top": 2
      });
      return $('.drawingNotes.' + $scope.container.page).append(img);
    };
    drawer = function(start, step, data) {
      var dr, graphicElement, i, len, position, ref, stop;
      stop = window.Math.min(start + step, data.length);
      ref = data.slice(start, +stop + 1 || 9e9);
      for (i = 0, len = ref.length; i < len; i++) {
        graphicElement = ref[i];
        switch (graphicElement.action) {
          case 'text':
            position = {
              top: graphicElement.top,
              left: graphicElement.left
            };
            if (graphicElement.unsave) {
              $scope.addNote(position, graphicElement.content, graphicElement.id, graphicElement.color);
            } else {
              insertImageNote(graphicElement.id, position, graphicElement.image);
            }
        }
      }
      if (start < stop) {
        dr = angular.bind(this, drawer, start + step, step, data);
        return $timeout(dr, 0, true);
      } else {
        return setContext(DrawCanvasContext, 'source-over', $scope.config.lineWidth, $scope.config.penColor, 'round');
      }
    };

    /*$q.when($scope.data).then ()->
      drawer(0, 100, $scope.initialData)
      drawer(0, 100, $scope.container.newDataContent)
      $scope.onready()
     */
    if ($scope.initialData != null) {
      $q.when($scope.initialData).then(function(initialData) {
        return drawer(0, 100, initialData);
      });
    }
    if (!($scope.data instanceof Array)) {
      $scope.data = [];
    }
    drawer(0, 100, $scope.data);
    if ($scope.onReady != null) {
      return $scope.onReady();
    }
  }]);

}).call(this);

//# sourceMappingURL=note-directive-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp:signature
    * @description
    * # signature
    * Allow use of a function on the content of an imported file
   */
  angular.module('mhclientApp').directive('signature', ["$rootScope", function($rootScope) {
    return {
      link: function($scope, element, attrs) {
        element.on('click', function() {
          if ($rootScope.mh_config.platform === "mgapp" && $scope.signatureDraw.data.length > 0) {
            return $scope.$apply(function() {
              return $scope.signatureDraw.canvas = $scope.drawSignature($scope.signatureDraw.data[0].points, $scope.signatureDraw.config.smooth);
            });
          }
        });
        return $scope.drawSignature = function(path, smoothness) {
          var bufferCanvas, bufferCanvasContext, i, j, k, l, ref, ref1, xc, yc;
          bufferCanvas = document.getElementById('bufferCanvasId');
          bufferCanvasContext = bufferCanvas.getContext('2d');
          bufferCanvasContext.beginPath();
          if (path.length === 2 && path[0].x === path[1].x && path[0].y === path[1].y) {
            bufferCanvasContext.arc(path[0].x, path[0].y, 1, 0, 2 * Math.PI, false);
            bufferCanvasContext.fill();
          } else {
            bufferCanvasContext.moveTo(path[0].x, path[0].y);
            if (smoothness) {
              for (i = j = 0, ref = path.length - 1; j < ref; i = j += 1) {
                xc = (path[i].x + path[i + 1].x) / 2;
                yc = (path[i].y + path[i + 1].y) / 2;
                bufferCanvasContext.quadraticCurveTo(path[i].x, path[i].y, xc, yc);
              }
            } else {
              for (k = l = 0, ref1 = path.length; 0 <= ref1 ? l < ref1 : l > ref1; k = 0 <= ref1 ? ++l : --l) {
                bufferCanvasContext.lineTo(path[k].x, path[k].y);
              }
            }
          }
          bufferCanvasContext.stroke();
          bufferCanvasContext.closePath();
          return bufferCanvas;
        };
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=signature-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:top-fixed
    * @description
    * # Draw
    * Directive for position fixed top bar
   */
  angular.module('mhclientApp').directive('emHeightTarget', ["$rootScope", function($rootScope) {
    return {
      link: function(scope, elem, attrs) {
        return scope.$watch('__height', function(newHeight, oldHeight) {
          return elem.css('padding-top', newHeight + 'px');
        });
      }
    };
  }]);

  angular.module('mhclientApp').directive('fixedX', ["$rootScope", "$window", function($rootScope, $window) {
    return {
      link: function(scope, elem, attrs) {
        var __check;
        angular.element($window).bind('scroll', function() {
          return elem.css({
            top: -$(window).scrollTop() + parseInt(angular.element($("#content")).css('padding-top'))
          });
        });
        __check = function() {
          elem.css({
            top: -$(window).scrollTop() + parseInt(angular.element($("#content")).css('padding-top'))
          });
          return setTimeout(__check, 300);
        };
        return __check();
      }
    };
  }]);

  angular.module('mhclientApp').directive('resizer', ["$document", function($document) {
    return function($scope, $element, $attrs) {
      var lastSeenAt, mousemove, mouseup;
      lastSeenAt = null;
      mousemove = function(event) {
        var bottom;
        bottom = $(window).height() - $($attrs.resizerTop).offset().top - $($attrs.resizerTop).height();
        $($attrs.resizerTop).css({
          bottom: math.max(bottom - (event.clientY - lastSeenAt), parseInt($attrs.resizerMin || 5)) + 'px'
        });
        lastSeenAt = event.clientY;
      };
      if ($attrs.resizerInitial) {
        $($attrs.resizerTop).css({
          bottom: $attrs.resizerInitial + 'px'
        });
      }
      $scope.$on('$destroy', function() {
        return $($attrs.resizerTop).css({
          bottom: '0px'
        });
      });
      mouseup = function() {
        $document.unbind('mousemove', mousemove);
        $document.unbind('mouseup', mouseup);
      };
      $element.on('mousedown', function(event) {
        event.preventDefault();
        lastSeenAt = event.clientY;
        $document.on('mousemove', mousemove);
        $document.on('mouseup', mouseup);
      });
    };
  }]);

  angular.module('mhclientApp').directive('getScrollBarWidth', ["$window", "$timeout", function($window, $timeout) {
    return {
      link: function(scope, elem, attrs) {
        var __check;
        __check = function() {
          var inner, outer, w1, w2;
          inner = document.createElement('p');
          inner.style.width = '100%';
          inner.style.height = '200px';
          outer = document.createElement('div');
          outer.style.position = 'absolute';
          outer.style.top = '0px';
          outer.style.left = '0px';
          outer.style.visibility = 'hidden';
          outer.style.width = '200px';
          outer.style.height = '150px';
          outer.style.overflow = 'hidden';
          outer.appendChild(inner);
          document.body.appendChild(outer);
          w1 = inner.offsetWidth;
          outer.style.overflow = 'scroll';
          w2 = inner.offsetWidth;
          if (w1 === w2) {
            w2 = outer.clientWidth;
          }
          document.body.removeChild(outer);
          return w1 - w2;
        };
        scope[attrs.getScrollBarWidth] = __check();
        return angular.element($window).bind('resize', function() {
          return scope[attrs.getScrollBarWidth] = __check();
        });
      }
    };
  }]);

  angular.module('mhclientApp').directive('emHeightSource', ["$window", "$timeout", function($window, $timeout) {
    return {
      link: function(scope, elem, attrs) {
        var __check, previousHeight, timeout;
        timeout = null;
        elem.on('$destroy', function() {
          if (timeout) {
            return clearTimeout(timeout);
          }
        });
        previousHeight = null;
        __check = function() {
          var h;
          h = elem.outerHeight(true);
          if (h !== previousHeight) {
            scope.$evalAsync(function() {
              scope.__height = h;
              previousHeight = h;
              if (attrs.emHeightSource) {
                return scope[attrs.emHeightSource] = {
                  height: h
                };
              } else {
                return scope.topFixed = {
                  height: h
                };
              }
            });
            timeout = setTimeout(__check, 50);
          } else {
            timeout = setTimeout(__check, 150);
          }
        };
        __check();
        return angular.element($window).bind('resize', function() {
          scope.__height = elem.outerHeight(true);
          previousHeight = scope.__height;
          if (attrs.emHeightSource) {
            scope[attrs.emHeightSource] = {
              height: scope.__height
            };
          } else {
            scope.topFixed = {
              height: scope.__height
            };
          }
          return scope.$digest();
        });
      }
    };
  }]);

  angular.module('mhclientApp').directive('collapseDigest', function() {
    return {
      link: function(scope, elem, attrs) {
        var digest_parents;
        digest_parents = function() {
          var next_parent, results;
          next_parent = scope.$parent;
          results = [];
          while (next_parent != null) {
            next_parent.$digest();
            results.push(next_parent = next_parent.$parent);
          }
          return results;
        };
        elem.on('shown.bs.collapse', function() {
          return digest_parents();
        });
        return elem.on('hidden.bs.collapse', function() {
          return digest_parents();
        });
      }
    };
  });

}).call(this);

//# sourceMappingURL=top-fixed-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:focus-directive
    * @description
    * # Focus
    * Directive for auto focus elements
   */
  angular.module('mhclientApp').factory('focus', ["$timeout", "$window", function($timeout, $window) {
    return function(id) {
      $timeout(function() {
        var element;
        element = $window.document.getElementById(id);
        if (element) {
          element.focus();
        }
      });
    };
  }]);

  angular.module('mhclientApp').directive('eventFocus', ["focus", function(focus) {
    return function(scope, elem, attr) {
      elem.on(attr.eventFocus, function() {
        focus(attr.eventFocusId);
      });
      scope.$on('$destroy', function() {
        elem.off(attr.eventFocus);
      });
    };
  }]);

  angular.module('mhclientApp').directive('autofocus', ["$timeout", function($timeout) {
    return {
      restrict: 'A',
      link: function($scope, $element) {
        return $timeout(function() {
          return $element[0].focus();
        });
      }
    };
  }]);

  angular.module('mhclientApp').directive('focusOn', ["$timeout", function($timeout) {
    return {
      restrict: 'A',
      link: function($scope, $element, $attr) {
        return $scope.$watch($attr.focusOn, function(_focusVal) {
          return $timeout(function() {
            if (_focusVal) {
              $element[0].focus();
              return $element[0].click();
            }
          });
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=focus-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:file-input-directive
    * @description
    * # Draw
    * Directive for input type file preview
   */
  angular.module('mhclientApp').directive('fileinput', function() {
    return {
      scope: {
        fileinput: '=',
        filepreview: '='
      },
      link: function(scope, element, attributes) {
        element.bind('change', function(changeEvent) {
          var reader;
          scope.fileinput = changeEvent.target.files[0];
          reader = new FileReader;
          reader.onload = function(loadEvent) {
            scope.$apply(function() {
              scope.filepreview = loadEvent.target.result;
            });
          };
          reader.readAsDataURL(scope.fileinput);
        });
      }
    };
  });

}).call(this);

//# sourceMappingURL=file-input-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:kinetic
    * @description
    * # Draw
    * Directive for position fixed top bar
   */
  angular.module('mhclientApp').directive('msTouchMove', ["$window", "$timeout", "$rootScope", function($window, $timeout, $rootScope) {
    return {
      link: function(scope, elem, attrs) {
        var MaxIgnoredMouseMoves, __aceleration, aceleration, allowClick, gFriction, gMaxDecelerationSpeed, gTimerInterval, getScrollParent, ignoreNextClick, ignoredMouseMoves, isMoving, isPressed, lastMouseYPos, mouseDown, mouseMove, mouseUp, stopMotion, timestamp, toScroll, vertical_velocity;
        if ($rootScope.mh_config.platform === "mgapp") {
          isPressed = false;
          timestamp = null;
          isMoving = false;
          ignoredMouseMoves = 0;
          MaxIgnoredMouseMoves = 10;
          lastMouseYPos = null;
          aceleration = true;
          ignoreNextClick = false;
          stopMotion = false;
          gTimerInterval = 20;
          gMaxDecelerationSpeed = 20;
          gFriction = 1;
          toScroll = null;
          vertical_velocity = 0;
          __aceleration = function() {
            if (!isMoving) {
              return;
            }
            vertical_velocity = Math.max(Math.min(vertical_velocity, gMaxDecelerationSpeed), -gMaxDecelerationSpeed);
            if (Math.abs(vertical_velocity) < Math.abs(gFriction)) {
              vertical_velocity = 0;
            } else if (vertical_velocity > 0) {
              vertical_velocity = vertical_velocity - gFriction;
            } else if (vertical_velocity < 0) {
              vertical_velocity = vertical_velocity + gFriction;
            }
            if (vertical_velocity === 0) {
              isMoving = false;
              return;
            }
            toScroll.scrollTop = toScroll.scrollTop - vertical_velocity * 0.9;
            return setTimeout(__aceleration, gTimerInterval);
          };
          allowClick = function(event) {
            if (isMoving) {
              return event.stopPropagation();
            }
          };
          mouseDown = function(event) {
            isPressed = true;
            isMoving = false;
            return event.preventDefault();
          };
          mouseMove = function(event) {
            var now;
            if (isPressed) {
              if (!isMoving) {
                if (ignoredMouseMoves < MaxIgnoredMouseMoves) {
                  return ignoredMouseMoves += 1;
                } else {
                  ignoredMouseMoves = 0;
                  isMoving = true;
                  timestamp = Date.now();
                  vertical_velocity = 0;
                  return lastMouseYPos = event.clientY;
                }
              } else {
                toScroll.scrollTop = toScroll.scrollTop - (event.clientY - lastMouseYPos) * 1.5;
                if (aceleration) {
                  now = Date.now();
                  vertical_velocity = (event.clientY - lastMouseYPos) / ((now - timestamp) / 100);
                  timestamp = now;
                }
                return lastMouseYPos = event.clientY;
              }
            }
          };
          mouseUp = function(event) {
            isPressed = false;
            ignoredMouseMoves = 0;
            if (!aceleration) {
              return isMoving = false;
            } else if (isMoving) {
              return __aceleration();
            }
          };
          document.body.addEventListener('click', allowClick, true);
          document.body.addEventListener('mousemove', mouseMove, false);
          elem.bind('mousemovee', function(event) {
            var now;
            if (isPressed) {
              if (!isMoving) {
                if (ignoredMouseMoves < MaxIgnoredMouseMoves) {
                  return ignoredMouseMoves += 1;
                } else {
                  ignoredMouseMoves = 0;
                  isMoving = true;
                  timestamp = Date.now();
                  vertical_velocity = 0;
                  return lastMouseYPos = event.clientY;
                }
              } else {
                if (aceleration) {
                  now = Date.now();
                  vertical_velocity = (event.clientY - lastMouseYPos) / ((now - timestamp) / 100);
                  timestamp = now;
                }
                return lastMouseYPos = event.clientY;
              }
            }
          });
          elem.bind('mouseup', function() {
            isPressed = false;
            ignoredMouseMoves = 0;
            if (!aceleration) {
              return isMoving = false;
            } else if (isMoving) {
              return __aceleration();
            }
          });
          getScrollParent = function(node) {
            var isElement, isScrollable, overflowY;
            isElement = node instanceof HTMLElement;
            overflowY = isElement && window.getComputedStyle(node).overflowY;
            isScrollable = !(overflowY.includes('hidden') || overflowY.includes('visible'));
            if (!node) {
              return null;
            } else if (isScrollable && node.scrollHeight >= node.clientHeight) {
              return node;
            }
            return getScrollParent(node.parentNode) || document.scrollingElement || document.body;
          };
          return elem.bind('mousedown', function(event) {
            if (!event.offsetX > event.target.clientWidth || event.offsetY > event.target.clientHeight) {
              if (!(event.target.tagName === "SELECT" || angular.element(event.target).hasClass('sr-only') || angular.element(event.target).hasClass('glyphicon-chevron-left') || angular.element(event.target).hasClass('glyphicon-chevron-right') || angular.element(event.target).hasClass('dont-scroll') || angular.element(event.target).hasClass('bufferCanvas') || angular.element(event.target).hasClass('fc-bg'))) {
                if (!angular.element(event.target).closest(".dont-scroll").length) {
                  toScroll = getScrollParent(event.target);
                  isPressed = true;
                  isMoving = false;
                  return event.preventDefault();
                }
              }
            }
          });
        }
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=kinetic-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:catalog
    * @description
    * # Directive for catalog with custom headers
   */
  angular.module('mhclientApp').directive('catalog', function() {
    return {
      restrict: 'E',
      templateUrl: 'core/views/catalog.html',
      scope: {
        data: "=",
        groupName: "=",
        active: "=",
        headers: "=",
        groupNameKey: "=",
        onRowClick: "&?",
        selection: "=?",
        selectable: "=?",
        filterEquipments: "&?",
        onSelection: "&?",
        selectionValue: "="
      },
      link: function(scope, element, attributes) {
        scope.initEquipmentChecked = function(equipment) {
          if (scope.selection === void 0) {
            return;
          }
          equipment.checked = scope.selectionValue;
          if (equipment.checked === true) {
            return scope.selection.push(equipment);
          }
        };
        scope.toggleSelection = function(equipment) {
          var index;
          if (scope.selectable) {
            equipment.checked = !equipment.checked;
            index = scope.selection.indexOf(equipment);
            if (equipment.checked === true) {
              scope.selection.push(equipment);
            } else {
              scope.selection.splice(index, 1);
            }
            if (scope.onSelection) {
              return scope.onSelection(scope.selection);
            }
          }
        };
        return scope.filterEquipment = function(equipment) {
          if (scope.filterEquipments) {
            return scope.filterEquipments({
              equipment: equipment
            });
          }
          return true;
        };
      }
    };
  });

}).call(this);

//# sourceMappingURL=catalog-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:dnd-list-selector
    * @description
    * # Directive for multi-selection from a list by drag-and-drop
   */
  angular.module('mhclientApp').directive('dndListSelector', function() {
    return {
      restrict: 'E',
      templateUrl: 'core/views/dnd-list-selector.html',
      scope: {
        sourceList: "=",
        selectedList: "=",
        dndListSelectorForm: "=?",
        searchTextFunction: "&?"
      },
      link: function(scope, element, attributes, formCtrl) {
        scope.trash = [];
        scope.searchText = "";
        scope.dndDrop = function(item) {
          return _.omit(item, "options");
        };
        scope.getOptionsDict = function(item) {
          var options, ref, ref1;
          options = (ref = _.find(scope.sourceList, {
            id: item.id
          })) != null ? ref.options : void 0;
          if (!options) {
            options = (ref1 = _.find(scope.sourceList, {
              directive: item.directive
            })) != null ? ref1.options : void 0;
          }
          return options;
        };
        scope.getOptionBy = function(options, key, value) {
          return _.find(options, function(option) {
            return option[key] === value;
          });
        };
        return scope.filterItems = function(item) {
          var display;
          display = true;
          if (scope.searchText) {
            if (scope.searchTextFunction) {
              display = scope.searchTextFunction(item);
            } else {
              display = angular.uppercase(item.name).includes(angular.uppercase(scope.searchText));
            }
          }
          return display;
        };
      }
    };
  });

}).call(this);

//# sourceMappingURL=dnd-list-selector-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:patch
    * @description
    * # patch
    * allow to replace the element by another template if defined
   */
  angular.module('mhclientApp').directive('patch', ["$templateCache", "$http", "$timeout", function($templateCache, $http, $timeout) {
    return {
      restrict: 'EA',
      transclude: true,
      template: '<div ng-if="loaded">' + '<div ng-if="!missing">' + '<ng-include src="getTemplateUrl()"></ng-include>' + '</div>' + '<div ng-if="missing">' + '<ng-transclude></ng-transclude>' + '</div>' + '</div>',
      compile: function(element, attr) {
        var jsSrc, partSrc;
        partSrc = attr.patch || attr.part || attr.src;
        jsSrc = attr.loadJs;
        return function(scope, $element, $attr, ctrl, $transclude) {
          scope.missing = true;
          scope.loaded = false;
          return scope.$watch(partSrc, function(part) {
            if (part) {
              $http.get(part).then(function(data) {
                var js;
                js = scope.$eval(jsSrc);
                if (js) {
                  return $.getScript(js).done(function(data) {
                    $templateCache.put(part, data.data);
                    scope.missing = false;
                    scope.loaded = true;
                    return $timeout(function() {
                      return scope.$apply();
                    });
                  }).fail(function() {
                    console.log("Fail to load patch script '" + js + "'");
                    scope.missing = true;
                    scope.loaded = true;
                    return $timeout(function() {
                      return scope.$apply();
                    });
                  });
                } else {
                  $templateCache.put(part, data.data);
                  scope.missing = false;
                  scope.loaded = true;
                  return $timeout(function() {
                    return scope.$apply();
                  });
                }
              }, function() {
                scope.missing = true;
                return scope.loaded = true;
              });
            } else {
              scope.loaded = true;
            }
            return scope.getTemplateUrl = function() {
              if (scope.missing || !scope.loaded) {
                return "";
              }
              return part;
            };
          });
        };
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=patch-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:string-to-number
    * @description
    * # Draw
    * Directive for convert strin to number # patient medicaldata poids
   */
  angular.module('mhclientApp').directive('stringToNumber', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        if (!attrs.stringToNumber) {
          ngModel.$parsers.push(function(value) {
            return '' + value;
          });
        }
        ngModel.$formatters.push(function(value) {
          return parseFloat(value, 10);
        });
      }
    };
  });

}).call(this);

//# sourceMappingURL=string-to-number.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:shortcut
    * @description
    * # previewDisplay
    * Display shortcuts of registered words
   */
  angular.module('mhclientApp').filter('shortcut', function() {
    var shortcuts;
    shortcuts = {
      "cible": "C",
      "donnee": "D",
      "action": "A",
      "resultat": "R",
      "macro-cible": "MC",
      "item": "I",
      "note": "N",
      "maladie": "MAL",
      "therapeutique": "THE",
      "vecu": "VEC",
      "environnement": "ENV",
      "developpement": "DEV",
      "Voie orale": "O",
      "Soin": "So",
      "Voie transcutanée (patch)": "TC",
      "Nasale": "N",
      "Intraveineuse": "IV",
      "Sous cutanée": "SC",
      "Intramusculaire": "IM",
      "Intrarachidienne": "IR",
      "Autre": "A"
    };
    return function(word) {
      return shortcuts[word];
    };
  });

}).call(this);

//# sourceMappingURL=shortcut-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.core:patientListFilter
    * @description
    * # patientListFilter
    * filter a given list of patients
   */
  angular.module('mhclientApp').filter('patientListFilter', function() {
    return function(patients, search_text, status_active_filters, medicalunit_filter, sector_active_filters, entity_active_filters, nbShowItems) {
      var filtered, has_entity_filters, has_medicalunit_filters, has_search_text, has_sector_filters, has_status_filters, i, isOk, item, j, k, len, len1, len2, length, patient, regex, searchRegexList, searchTextList, searchVal, text;
      filtered = [];
      has_search_text = (search_text != null) && search_text.length > 0;
      if (has_search_text) {
        searchTextList = search_text.split("&&");
        searchRegexList = [];
        for (i = 0, len = searchTextList.length; i < len; i++) {
          text = searchTextList[i];
          length = text.length;
          if (length > 0) {
            searchVal = text.replace(/([()[{*+.$^\\|?])/g, '\\$1').replace(/[- ']/g, "[- ']?").replace(/[cç]/g, "[cç]{1}").replace(/[eéèêë]/g, "[eéèêë]{1}").replace(/[aàäâ]/g, "[aàâä]{1}").replace(/[iïî]/g, "[iïî]{1}").replace(/[uùüû]/g, "[uùüû]{1}").replace(/[oô]/g, "[oô]{1}");
            regex = new RegExp('' + searchVal, 'i');
            searchRegexList.push({
              "regex": regex,
              "length": length
            });
          }
        }
      }
      has_status_filters = (status_active_filters != null) && status_active_filters.length > 0;
      has_medicalunit_filters = (medicalunit_filter != null) && medicalunit_filter.length > 0;
      has_sector_filters = (sector_active_filters != null) && sector_active_filters.length > 0;
      has_entity_filters = (entity_active_filters != null) && entity_active_filters.length > 0;
      for (j = 0, len1 = patients.length; j < len1; j++) {
        patient = patients[j];
        if (has_search_text) {
          isOk = true;
          for (k = 0, len2 = searchRegexList.length; k < len2; k++) {
            item = searchRegexList[k];
            regex = item.regex;
            length = item.length;
            isOk = isOk && (regex.test(patient.full_name) || regex.test(stay.patient.data.first_name_atbirth) || regex.test(stay.patient.data.first_names_atbirth) || (length === 15 && regex.test(stay.patient.data.ins)) || regex.test(patient.si_id) || ((patient.linked_stay != null) && regex.test(patient.linked_stay.si_id)) || ((patient.twin_stay != null) && regex.test(patient.twin_stay.si_id)));
          }
          if (!isOk) {
            continue;
          }
        }
        if (has_status_filters && status_active_filters.indexOf(patient.state) === -1) {
          continue;
        }
        if (has_sector_filters && sector_active_filters.indexOf(patient.sector) === -1) {
          continue;
        }
        if (has_entity_filters && entity_active_filters.indexOf(patient.entity) === -1) {
          continue;
        }
        if (has_medicalunit_filters) {
          if (((patient.linked_stay == null) || medicalunit_filter.indexOf(patient.linked_stay.medical_unit) === -1) && ((patient.twin_stay == null) || medicalunit_filter.indexOf(patient.twin_stay.medical_unit) === -1)) {
            continue;
          }
        }
        filtered.push(patient);
        if (filtered.length === nbShowItems) {
          break;
        }
      }
      return filtered;
    };
  });

}).call(this);

//# sourceMappingURL=patient-list-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Feature
    * @description
    * # Feature
    * Provider of Feature
   */
  angular.module("mhclientApp").factory('Feature', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, feature, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/features/:id/:route', {
      id: this.id
    }, {
      'create': {
        method: 'POST'
      },
      'update': {
        method: 'PUT',
        params: {
          id: '@id'
        }
      },
      'availableConnectors': {
        method: 'GET',
        params: {
          route: 'contextual_call/connectors'
        },
        isArray: true
      },
      'call': {
        method: 'GET',
        params: {
          route: 'contextual_call/call',
          id: '@id'
        },
        isArray: false
      }
    });
    service = {};
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
        break;
      case 'mgapp':
        feature = window.mgapp.get('usr_mgr').feature();
        service.api = BoxResource.generate(feature);
    }
    return service;
  }]);

  angular.module("mhclientApp").factory('FeatureUtils', ["$q", "Feature", function($q, Feature) {
    var cachedFeatures, getAllFeatures, getFeature, getFeatures, globalFeaturesPromise, resetCache, service;
    cachedFeatures = null;
    globalFeaturesPromise = $q.defer();
    resetCache = function() {
      cachedFeatures = null;
      return globalFeaturesPromise = $q.defer();
    };
    getFeatures = function(promise, query) {
      cachedFeatures = {};
      return Feature.api.query().$promise.then(function(features) {
        cachedFeatures = features;
        globalFeaturesPromise.resolve();
        if (query) {
          return promise.resolve(angular.copy(_.find(cachedFeatures, query)));
        } else {
          return promise.resolve(angular.copy(cachedFeatures));
        }
      });
    };
    getFeature = function(query) {
      var featuresDone;
      featuresDone = $q.defer();
      if (cachedFeatures != null) {
        globalFeaturesPromise.promise.then(function() {
          return featuresDone.resolve(angular.copy(_.find(cachedFeatures, query)));
        });
      } else {
        getFeatures(featuresDone, query);
      }
      return featuresDone.promise;
    };
    getAllFeatures = function(dontCopy) {
      var featuresDone;
      featuresDone = $q.defer();
      if (cachedFeatures != null) {
        globalFeaturesPromise.promise.then(function() {
          return featuresDone.resolve(dontCopy ? cachedFeatures : angular.copy(cachedFeatures));
        });
      } else {
        getFeatures(featuresDone);
      }
      return featuresDone.promise;
    };
    service = {
      getFeature: getFeature,
      getAllFeatures: getAllFeatures,
      resetCache: resetCache
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=feature-service.js.map


/**
  * @ngdoc function
  * @name core.
  * @description slide menu
  * # Directive for slide menu
 */

(function() {
  angular.module('mhclientApp').directive('mhSlideMenu', function() {
    var link;
    link = function(scope, element, attrs, ctrl, transclude) {
      var overlay, showMenu, toggleMenuPromise;
      element.addClass('fixed-menu');
      angular.element(".mCustomScrollbar").css('height', '78%');
      showMenu = angular.element('#showMenu');
      overlay = angular.element('#outofmenu-overlay');
      showMenu.on('click', function() {
        element.toggleClass('fixed-menu-open');
        if (overlay.hasClass('transparent-overlay-active')) {
          return overlay.toggleClass('transparent-overlay-active');
        } else {
          return overlay.addClass('transparent-overlay-active');
        }
      });
      overlay.on('click', function() {
        element.toggleClass('fixed-menu-open');
        return overlay.toggleClass('transparent-overlay-active');
      });
      scope.$on('reduceSlideMenu', function(event, args) {
        element.removeClass('fixed-menu-open');
        return overlay.removeClass('transparent-overlay-active');
      });
      return toggleMenuPromise = null;
    };
    return {
      scope: {
        menuactive: "="
      },
      link: link,
      restrict: 'EA',
      transclude: true,
      template: '<ng-transclude></ng-transclude>'
    };
  });

}).call(this);

//# sourceMappingURL=mh-slide-menu-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MultiPatientCtrl
    * @description
    * # MultiPatientCtrl
    * Controller of the mhclientApp
   */
  angular.module('mhclientApp').controller('MultiPatientCtrl', ["$scope", "Patient", function($scope, Patient) {
    return $scope.patients_promise = Patient.query().$promise;
  }]);

}).call(this);

//# sourceMappingURL=multi-patient-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.configtool:mgappKeyboard
    * @description
    * # mgappKeyboard
    * Allow use of a function on the content of an imported file
   */
  angular.module('mhclientApp').directive('mgappIntegratedKeyboard', ["$rootScope", "$window", function($rootScope, $window) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        ngModel: '='
      },
      link: function(scope, element, attrs) {
        if ($rootScope.mh_config.platform === "mgapp") {
          element.on('click', function() {
            var multiline;
            multiline = element[0].type === 'textarea';
            $window.setCurrentInput = scope.setCurrentInputText;
            return $window.mgapp.open_integrated_keyboard(element.val(), multiline);
          });
          element.on('focusout', function() {
            return $window.mgapp.close_integrated_keyboard();
          });
        }
        return scope.setCurrentInputText = function(val) {
          scope.$apply(function() {
            scope.ngModel = val;
            element.controller('ngModel').$setViewValue(val);
            return element.controller('ngModel').$render();
          });
          if (scope.$parent.formStruct != null) {
            return scope.$parent.formStruct.$dirty = true;
          }
        };
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=mgapp-Integrated-keyboard-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:decode
    * @description
    * # decodeFilter
    * Parse \u00e9 things
   */
  angular.module('mhclientApp').filter('decode', function() {
    return function(word) {
      return JSON.parse('"' + word + '"');
    };
  });

}).call(this);

//# sourceMappingURL=decode-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:boolToYes
    * @description
    * Convert boolean to yes or no
   */
  angular.module('mhclientApp').filter('boolToYes', ["$filter", function($filter) {
    return function(input) {
      if (input) {
        return $filter('translate')('YES');
      }
      return $filter('translate')('NO');
    };
  }]);

}).call(this);

//# sourceMappingURL=bool-to-yes-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:range
    * @description
    * create a range
    * "n in [10] | makeRange">Do something 0..9
    * "n in [20, 29] | makeRange">Do something 20..29
   */
  angular.module('mhclientApp').filter('range', ["$filter", function($filter) {
    return function(input) {
      var highBound, i, lowBound, result, results;
      switch (input.length) {
        case 1:
          lowBound = 0;
          highBound = parseInt(input[0]) - 1;
          break;
        case 2:
          lowBound = parseInt(input[0]);
          highBound = parseInt(input[1]);
          break;
        default:
          return input;
      }
      result = (function() {
        results = [];
        for (var i = lowBound; lowBound <= highBound ? i <= highBound : i >= highBound; lowBound <= highBound ? i++ : i--){ results.push(i); }
        return results;
      }).apply(this);
      return result;
    };
  }]);

}).call(this);

//# sourceMappingURL=range-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:emptyToEnd
    * @description
    * To apply with orderBy filter, empty item at the end permit to order
   */
  angular.module('mhclientApp').filter("emptyToEnd", function() {
    return function(array, key) {
      var empty, present;
      if (!angular.isArray(array)) {
        return;
      }
      present = array.filter(function(item) {
        return item[key];
      });
      empty = array.filter(function(item) {
        return !item[key];
      });
      return present.concat(empty);
    };
  });

}).call(this);

//# sourceMappingURL=empty-to-end-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:age
    * @description
    * display age from date
   */
  angular.module('mhclientApp').filter('age', ["$filter", function($filter) {
    return function(birthday, format) {
      var short;
      short = format !== 'long';
      return moment(birthday).fromNow(short);
    };
  }]);

}).call(this);

//# sourceMappingURL=age-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:utcToLocal
    * @description
    * display local from date
   */
  angular.module('mhclientApp').filter('utcToLocal', ["$filter", function($filter) {
    return function(utcDateString, format) {
      if (!utcDateString) {
        return;
      }
      if (typeof utcDateString !== "string") {
        utcDateString = utcDateString.toISOString();
      }
      if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
        utcDateString += 'Z';
      }
      return $filter('date')(utcDateString, format);
    };
  }]);

}).call(this);

//# sourceMappingURL=utc-to-local-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Sector
    * @description
    * # Sector
    * Provider of Sector
   */
  angular.module("mhclientApp").factory('Sector', ["$resource", "$rootScope", "$q", "MhConfig", "BoxResource", function($resource, $rootScope, $q, MhConfig, BoxResource) {
    var acceptHeader, addSector, api, getSectors, globalSectorsPromise, modifySector, portailAPI, removeSector, resetCache, sector, sectorsCache;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/sectors/:id/:route', {}, {
      'get': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'delete': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'DELETE'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        sector = window.mgapp.get('pat_mgr').sector();
        api = BoxResource.generate(sector);
    }
    sectorsCache = null;
    globalSectorsPromise = $q.defer();
    resetCache = function() {
      sectorsCache = null;
      return globalSectorsPromise = $q.defer();
    };
    getSectors = function() {
      var SectorsPromise;
      SectorsPromise = $q.defer();
      if (sectorsCache != null) {
        globalSectorsPromise.promise.then(function() {
          return SectorsPromise.resolve(angular.copy(sectorsCache));
        });
      } else {
        sectorsCache = [];
        api.query().$promise.then(function(sectors) {
          sectorsCache = sectors;
          SectorsPromise.resolve(angular.copy(sectorsCache));
          return globalSectorsPromise.resolve();
        });
      }
      return SectorsPromise.promise;
    };
    removeSector = function(sector) {
      return api["delete"]({
        id: sector.id
      }).$promise.then(function(sector) {
        return _.remove(sectorsCache, sector);
      });
    };
    addSector = function(data) {
      return api.save(data).$promise.then(function(sector) {
        sectorsCache.push(sector);
        return sector;
      });
    };
    modifySector = function(sector) {
      return api.update({
        id: sector.id
      }, sector).$promise.then(function(sector) {
        return _.assign(_.find(sectorsCache, ['id', sector.id]), sector);
      });
    };
    return {
      api: api,
      getSectors: getSectors,
      addSector: addSector,
      modifySector: modifySector,
      removeSector: removeSector,
      resetCache: resetCache
    };
  }]);

}).call(this);

//# sourceMappingURL=sector-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:MedicalUnit
    * @description
    * # Sector
    * Provider of MedicalUnit
   */
  angular.module("mhclientApp").factory('MedicalUnit', ["$resource", "$rootScope", "$q", "MhConfig", "BoxResource", function($resource, $rootScope, $q, MhConfig, BoxResource) {
    var acceptHeader, getMedicalUnits, globalMedicalUnitsPromise, medicalUnitsCache, portailAPI, resetCache;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/medicalunit/:route', {}, {
      'get': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    medicalUnitsCache = null;
    globalMedicalUnitsPromise = $q.defer();
    resetCache = function() {
      medicalUnitsCache = null;
      return globalMedicalUnitsPromise = $q.defer();
    };
    getMedicalUnits = function() {
      var MedicalUnitsPromise;
      MedicalUnitsPromise = $q.defer();
      if ($rootScope.mh_config.platform === "mgapp") {
        MedicalUnitsPromise.resolve([]);
      } else {
        if (medicalUnitsCache != null) {
          globalMedicalUnitsPromise.promise.then(function() {
            return MedicalUnitsPromise.resolve(angular.copy(medicalUnitsCache));
          });
        } else {
          medicalUnitsCache = [];
          portailAPI.query().$promise.then(function(medicalUnits) {
            medicalUnitsCache = medicalUnits;
            MedicalUnitsPromise.resolve(angular.copy(medicalUnitsCache));
            return globalMedicalUnitsPromise.resolve();
          });
        }
      }
      return MedicalUnitsPromise.promise;
    };
    return {
      api: portailAPI,
      getMedicalUnits: getMedicalUnits,
      resetCache: resetCache
    };
  }]);

}).call(this);

//# sourceMappingURL=medicalunit-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:compareTo
    * @description
    * #
    * Directive for compare field (password confirmation)
   */
  angular.module('mhclientApp').directive('compareTo', function() {
    return {
      require: 'ngModel',
      scope: {
        otherModelValue: '=compareTo'
      },
      link: function(scope, element, attributes, ngModel) {
        ngModel.$validators.compareTo = function(modelValue) {
          return modelValue === scope.otherModelValue;
        };
        scope.$watch('otherModelValue', function() {
          ngModel.$validate();
        });
      }
    };
  });

  angular.module('mhclientApp').directive('compareToConfirmPassword', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attributes, ngModel) {
        ngModel.$validators.compareTo = function(modelValue) {
          return modelValue === scope.confirmPassword;
        };
        scope.$watch('confirmPassword', function() {
          ngModel.$validate();
        });
      }
    };
  });

  angular.module('mhclientApp').directive('diffToOldPassword', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attributes, ngModel) {
        ngModel.$validators.diffTo = function(modelValue) {
          return modelValue !== scope.oldPassword;
        };
        scope.$watch('oldPassword', function() {
          ngModel.$validate();
        });
      }
    };
  });

}).call(this);

//# sourceMappingURL=compare-to-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:NumericModalCtrl
    * @description
    * # NumericModalCtrl
    * NumericModalCtrl
   */
  angular.module("mhclientApp").controller('NumericModalCtrl', ["$scope", "$uibModalInstance", "title", "text", "okButtonText", "noButtonText", "cancelButtonText", "model", function($scope, $uibModalInstance, title, text, okButtonText, noButtonText, cancelButtonText, model) {
    var init;
    $scope.text = text;
    $scope.title = title;
    $scope.cancelButtonText = cancelButtonText;
    $scope.okButtonText = okButtonText;
    $scope.noButtonText = noButtonText;
    init = function() {
      $scope.model = '';
      $scope.validForm = false;
      $scope.disableZezo = false;
      $scope.emptyForm = true;
      return $scope.removeDigits = $scope.model.length > 0 ? true : false;
    };
    $scope.$watch('model', function(obj) {
      if (obj != null) {
        $scope.validForm = obj.length > 0 && obj !== "0" ? true : false;
        return $scope.disableZezo = obj.length > 0 && obj !== "0" ? true : false;
      }
    }, true);
    $scope.addDigit = function(digit) {
      digit = digit.toString();
      if ($scope.model != null) {
        if ($scope.model.length === "1" && digit === "0") {
          $scope.model = 1;
        } else {
          $scope.model = $scope.model + digit;
        }
      }
      return $scope.removeDigits = true;
    };
    $scope.removeDigit = function() {
      if ($scope.model != null) {
        $scope.model = $scope.model.substring(0, $scope.model.length - 1);
        if ($scope.model.length === 0) {
          return $scope.removeDigits = false;
        }
      } else {
        return $scope.removeDigits = true;
      }
    };
    $scope.clear = function() {
      $scope.model = '';
      return $scope.removeDigits = false;
    };
    $scope.yes = function() {
      return $uibModalInstance.close(parseInt($scope.model));
    };
    $scope.no = function() {
      return $uibModalInstance.close(false);
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss(false);
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=numeric-keyboard.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.directive:setClassWhenAtTop
    * @description
    * # setClassWhenAtTop
    * Fixed top menu
   */
  angular.module('mhclientApp').directive('setClassWhenAtTop', ["$window", function($window) {
    var $win;
    $win = angular.element($window);
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var offsetTop, topClass;
        topClass = attrs.setClassWhenAtTop;
        offsetTop = element.offset().top;
        $win.on('scroll', function(e) {
          if ($win.scrollTop() >= offsetTop - 41) {
            element.addClass(topClass);
            element[0].previousElementSibling.classList.add('margin-class');
          } else {
            element.removeClass(topClass);
            element[0].previousElementSibling.classList.remove('margin-class');
          }
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=setclasswhenattop-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.directive:mhClick
    * @description
    * # Mhclick
    * Allow to duplicate collapse and dropdown with fewer $watcher
   */
  angular.module('mhclientApp').directive('mhClick', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        return element.on('click', function(event) {
          element.siblings().filter("#" + attrs.mhClick).toggleClass("hidden");
          return element.parent().toggleClass("" + attrs.mhClickMoreClass);
        });
      }
    };
  });

}).call(this);

//# sourceMappingURL=mhClick-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.directive:mhClientInfiniteScroll
    * @description
    * # mhClientInfiniteScroll
    * Allow to increment scope.nbShowItems as we scroll
    * Use with ngrepeat |limitTo:nbShowItems
   */
  angular.module('mhclientApp').directive('mhClientInfiniteScroll', ["$window", "debounce", function($window, debounce) {
    var $win;
    $win = angular.element($window);
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var step;
        step = parseInt(scope.nbShowItems);
        if (attrs.mhClientInfiniteScrollFirst === "true") {
          scope.nbShowItems = 30;
        }
        return $win.on('scroll', function(e) {
          var offsetTop, windowTop;
          windowTop = $win.scrollTop() + $win.innerHeight() + 10;
          offsetTop = element.offset().top + element[0].scrollHeight;
          if (windowTop >= offsetTop && attrs.mhClientInfiniteScrollItems >= scope.nbShowItems) {
            scope.nbShowItems = parseInt(scope.nbShowItems) + step;
            return scope.$apply();
          }
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=mhClientInfiniteScroll-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.directive:mh-hightlight-on-click
    * @description
    * # mh-hightlight-on-click
    * Directive to add a class on click. The class can be specify with
    * mh-hightlight-on-click-class attr.
   */
  angular.module('mhclientApp').directive('mhHightlightOnClick', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var cssClass;
        cssClass = "active-link";
        if (attrs.mhHightlightOnClickClass != null) {
          cssClass = attrs.hightlightOnClickClass;
        }
        return element.children().on("click", function(event) {
          var el;
          el = element.siblings().find("." + cssClass)[0];
          if (el != null) {
            el.classList.toggle(cssClass);
          }
          return event.target.classList.toggle(cssClass);
        });
      }
    };
  });

}).call(this);

//# sourceMappingURL=mhhightlightOnClick-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.core.GenUiD
    * @description
    * # To generate an UID
    *
   */
  angular.module("mhclientApp").factory('GenUID', function() {
    var generate, getRandomArbitrary;
    generate = function(minLength) {
      var length, value;
      minLength = minLength | 7;
      length = getRandomArbitrary(minLength, 10);
      value = Math.random().toString(36).substr(2, 8) + Date.now().toString(36).substr(4, 10) + Math.random().toString(36).substr(2, 8);
      return (Math.random().toString(36).substr(2, 8) + Date.now().toString(36).substr(4, 10) + Math.random().toString(36).substr(2, 8)).substr(0, length);
    };
    getRandomArbitrary = function(min, max) {
      return Math.random() * (max - min) + min;
    };
    return {
      generate: generate
    };
  });

}).call(this);

//# sourceMappingURL=gen-uid.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name core.mhSelectTwoMultifields
    * @description
    * # Two Multiple fields selector widget
    * <mh-select-two-multifields> definition. Attributes:
    * all-elt-list (mandatory)
    * selected-elt-list (mandatory)
    * select-cb (mandatory)
    * unselect-cb (mandatory)
    * select-all-cb
    * unselect-all-cb
    *
   */
  angular.module('mhclientApp').controller('mhSelectTwoMultifieldsCtrl', function() {
    return {};
  }).directive('mhSelectTwoMultifields', function() {
    var link;
    link = function(scope, element, attrs, mhSelectTwoMultifieldsCtrl, transclude) {
      if (!scope.displayField) {
        scope.displayField = 'label';
      }
      if (!scope.order) {
        scope.order = scope.displayField;
      }
      scope.selectItem = function(item) {
        if (scope.selectCb != null) {
          return scope.selectCb(item);
        } else {
          if (!item.readonly) {
            scope.isDirty = true;
            _.remove(scope.allEltList, item);
            return scope.selectedEltList.push(item);
          }
        }
      };
      scope.unselectItem = function(item) {
        if (scope.unselectCb != null) {
          return scope.unselectCb(item);
        } else {
          if (!item.readonly) {
            scope.isDirty = true;
            _.remove(scope.selectedEltList, item);
            return scope.allEltList.push(item);
          }
        }
      };
      scope.selectAll = function() {
        scope.isDirty = true;
        if (typeof scope.selectAllCb === "function") {
          return scope.selectAllCb();
        } else {
          scope.selectedEltList = scope.selectedEltList.concat(_.filter(scope.allEltList, function(elem) {
            return !elem.readonly;
          }));
          return scope.allEltList = _.filter(scope.allEltList, "readonly");
        }
      };
      return scope.unselectAll = function() {
        scope.isDirty = true;
        if (typeof scope.unselectAllCb === "function") {
          return scope.unselectAllCb();
        } else {
          scope.allEltList = scope.allEltList.concat(_.filter(scope.selectedEltList, function(elem) {
            return !elem.readonly;
          }));
          return scope.selectedEltList = _.filter(scope.selectedEltList, "readonly");
        }
      };
    };
    return {
      scope: {
        allEltList: "=",
        selectedEltList: "=",
        selectCb: "=",
        unselectCb: "=",
        selectAllCb: "=",
        unselectAllCb: "=",
        filterBy: "=",
        order: "=?",
        displayField: "=?",
        isDirty: "=?"
      },
      link: link,
      restrict: 'E',
      compile: function(element, attrs) {
        return link;
      },
      templateUrl: 'core/views/mh-select-two-multifields.html'
    };
  });

}).call(this);

//# sourceMappingURL=mh-select-two-multifields.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name core.mhMultiSelectTable
    * @description
    * # table which permit to select one or more items in a list
    * <mh-multi-select-table> definition. Attributes:
    * items (mandatory)
    * change-item-selection-cb (mandatory)
    * select-all-cb (mandatory)
    * unselect-all-cb (mandatory)
    * has-search-field
    *
   */
  angular.module('mhclientApp').controller('mhMultiSelectTableCtrl', function() {
    return {};
  }).directive('mhMultiSelectTable', function() {
    var link;
    link = function(scope, element, attrs, mhMultiSelectTableCtrl, transclude) {
      scope.search = {};
      scope.changeItemSelection = function(item) {
        if (!item.readonly) {
          scope.isDirty = true;
          item.selected = !item.selected;
        }
        if (typeof scope.changeItemSelectionCb === "function") {
          return scope.changeItemSelectionCb(item);
        }
      };
      scope.selectAll = function() {
        _.map(scope.items, function(item) {
          if (!item.readonly) {
            item.selected = true;
            return scope.isDirty = true;
          }
        });
        if (typeof scope.selectAllCb === "function") {
          return scope.selectAllCb();
        }
      };
      return scope.unselectAll = function() {
        _.map(scope.items, function(item) {
          if (!item.readonly) {
            item.selected = false;
          }
          return scope.isDirty = true;
        });
        if (typeof scope.unselectAllCb === "function") {
          return scope.unselectAllCb();
        }
      };
    };
    return {
      scope: {
        items: "=",
        changeItemSelectionCb: "=",
        selectAllCb: "=",
        unselectAllCb: "=",
        hasSearchField: "=",
        isDirty: "=",
        displayField: "="
      },
      link: link,
      restrict: 'E',
      compile: function(element, attrs) {
        if (attrs.hasSearchField === void 0) {
          attrs.hasSearchField = "true";
        }
        return link;
      },
      templateUrl: 'core/views/mh-multi-select-table.html'
    };
  });

}).call(this);

//# sourceMappingURL=mh-multi-select-table.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name core.mhMonoSelectTable
    * @description
    * # table which permit to select one item in a list
    * <mh-mono-select-table> definition. Attributes:
    * items (mandatory)
    * change-item-selection-cb (mandatory)
    * has-search-field
    * default-value
    *
   */
  angular.module('mhclientApp').controller('mhMonoSelectTableCtrl', ["scope", function(scope) {
    return {};
  }]).directive('mhMonoSelectTable', function() {
    var link;
    link = function(scope, element, attrs, mhMonoSelectTableCtrl, transclude) {
      if (scope.defaultValue !== void 0) {
        scope.items.unshift({
          'id': -1,
          label: scope.defaultValue,
          "selected": _.findIndex(scope.items, function(item) {
            return item.selected;
          }) === -1
        });
      }
      scope.search = {};
      return scope.changeItemSelection = function(selectedItem) {
        _.map(scope.items, function(item) {
          return item.selected = item === selectedItem;
        });
        if (typeof scope.changeItemSelectionCb === "function") {
          return scope.changeItemSelectionCb(selectedItem);
        }
      };
    };
    return {
      scope: {
        items: "=",
        changeItemSelectionCb: "=",
        hasSearchField: "=",
        defaultValue: "=",
        displayLabel: "="
      },
      link: link,
      restrict: 'E',
      compile: function(element, attrs) {
        if (attrs.hasSearchField === void 0) {
          attrs.hasSearchField = "true";
        }
        return link;
      },
      templateUrl: 'core/views/mh-mono-select-table.html'
    };
  });

}).call(this);

//# sourceMappingURL=mh-mono-select-table.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:highLight
    * @description
    * #
    * filter for auto highLight
   */
  angular.module('mhclientApp').filter('highLightHtml', ["$sce", function($sce) {
    return function(str, query) {
      var regex;
      if (!query) {
        return str;
      } else if (!str) {
        return "";
      } else {
        regex = new RegExp('(' + query + ')(?![^<>]*>)', 'gi');
        return $sce.trustAsHtml(str.replace(regex, '<span class="highlight-match">$&</span>'));
      }
    };
  }]);

  angular.module('mhclientApp').filter('highLight', ["$sce", function($sce) {
    return function(str, query) {
      var regex, searchVal;
      if (!query) {
        return str;
      } else if (!str) {
        return "";
      } else {
        searchVal = query.replace(/([()[{*+.$^\\|?])/g, '\\$1');
        regex = new RegExp('(' + searchVal + ')', 'gi');
        return $sce.trustAsHtml(str.replace(regex, '<span class="highlight-match">$&</span>'));
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=highlight-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.directive:disableIfTrue
    * @description
    * # disableIfTrue
    * Allow to disable all childs textarea and input tag
    * when disableIfTrue attrs expression is true
   */
  angular.module('mhclientApp').directive('disableIfTrue', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var timeout;
        timeout = null;
        element.on('$destroy', function() {
          if (timeout) {
            return clearTimeout(timeout);
          }
        });
        return scope.$watch(attrs.disableIfTrue, function(val) {
          var __check;
          if (timeout) {
            clearTimeout(timeout);
          }
          __check = function() {
            var elem, i, j, k, l, len, len1, len2, len3, len4, len5, len6, m, n, o, ref, ref1, ref2, ref3, ref4, ref5, ref6;
            ref = element.find("textarea");
            for (i = 0, len = ref.length; i < len; i++) {
              elem = ref[i];
              elem.disabled = val;
            }
            ref1 = element.find("input");
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              elem = ref1[j];
              elem.disabled = val;
            }
            ref2 = element.find("div");
            for (k = 0, len2 = ref2.length; k < len2; k++) {
              elem = ref2[k];
              elem.disabled = val;
            }
            ref3 = element.find("form");
            for (l = 0, len3 = ref3.length; l < len3; l++) {
              elem = ref3[l];
              elem.disabled = val;
            }
            ref4 = element.find("button");
            for (m = 0, len4 = ref4.length; m < len4; m++) {
              elem = ref4[m];
              elem.disabled = val;
            }
            ref5 = element.find("select");
            for (n = 0, len5 = ref5.length; n < len5; n++) {
              elem = ref5[n];
              elem.disabled = val;
            }
            ref6 = element.find(".disabled-me");
            for (o = 0, len6 = ref6.length; o < len6; o++) {
              elem = ref6[o];
              if (val) {
                elem.setAttribute("disabled", val);
              } else {
                elem.removeAttribute("disabled", val);
              }
            }
            return timeout = setTimeout(__check, 150);
          };
          return __check();
        });
      }
    };
  });

}).call(this);

//# sourceMappingURL=disable-if-true-directive.js.map

(function() {
  'use strict';
  angular.module('mhclientApp').directive('ngConfirmClick', ["$uibModal", "$filter", function($uibModal, $filter) {
    return {
      scope: {
        stopPropagation: '=?',
        confirmedClick: "&",
        secondaryClick: "&?",
        preventDefault: "=?",
        secondaryText: "=",
        confirmedClickDisabled: "="
      },
      link: function(scope, element, attr) {
        var cancelText, confirmationText, confirmedClass, msg;
        msg = $filter('translate')(attr.ngConfirmClick || 'Are you sure?');
        confirmationText = $filter('translate')(attr.confirmationText || "Yes");
        confirmedClass = attr.confirmedClass || "btn-warning";
        cancelText = $filter('translate')(attr.cancelText || "No");
        return element.bind('click', function(event) {
          var confirm_dialog;
          if (scope.preventDefault) {
            event.preventDefault();
          }
          if (scope.stopPropagation) {
            event.stopPropagation();
          }
          if (scope.confirmedClickDisabled) {
            scope.confirmedClick();
            return;
          }
          return confirm_dialog = $uibModal.open({
            animation: true,
            windowClass: "vertical-align",
            template: '<div class="modal-header"> <button type="button" class="close" ng-click="$dismiss()"><span aria-hidden="true">×</span></button> </div> <div class="modal-body text-center">' + msg + '</div> <div class="modal-footer"> <button class="btn pull-right ' + confirmedClass + '" ng-click="$close(1)">' + confirmationText + '</button>' + (scope.secondaryText ? '<button style="margin-right:15px" class="btn pull-right ' + confirmedClass + '" ng-click="$close(2)">' + $filter('translate')(scope.secondaryText) + '</button>' : '') + '<button class="btn pull-left btn-warning " ng-click="$dismiss()">' + cancelText + '</button> </div>'
          }).result.then(function(result) {
            if (result === 1) {
              return scope.confirmedClick();
            } else if (result === 2) {
              return scope.secondaryClick();
            }
          });
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=confirm-click-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Utils
    * @description
    *
    * Factory of utility functions which can be use in all the application
    * -copyValues : function which copy values from one source (object,array,...) to one destination (object,array,...)
    *
   */
  angular.module("mhclientApp").factory('RecursionHelper', [
    '$compile', function($compile) {
      return {
        compile: function(element, link) {
          var compiledContents, contents;
          if (angular.isFunction(link)) {
            link = {
              post: link
            };
          }
          contents = element.contents().remove();
          compiledContents = void 0;
          return {
            pre: link && link.pre ? link.pre : null,
            post: function(scope, element) {
              if (!compiledContents) {
                compiledContents = $compile(contents);
              }
              compiledContents(scope, function(clone) {
                element.append(clone);
              });
              if (link && link.post) {
                link.post.apply(null, arguments);
              }
            }
          };
        }
      };
    }
  ]);

  angular.module("mhclientApp").factory('Utils', ["$filter", "$uibModal", "$rootScope", function($filter, $uibModal, $rootScope) {
    var copyValues, handleCloseRequested, newHandleCloseRequested;
    newHandleCloseRequested = function(isValid, saveCB, discardCB) {
      $rootScope.stateBlocked += 1;
      return $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("DOC_NOT_SAVED");
          },
          text: function() {
            if (isValid) {
              return $filter('translate')("GENERIC_CONFIRM_CLOSE_NOT_SAVED");
            } else {
              return $filter('translate')("CONFIRM_CLOSE_NOT_VALID");
            }
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return $filter('translate')("DONT_SAVE_BUTTON");
          },
          okButtonText: function() {
            var okButtonText;
            if (isValid) {
              return $filter('translate')("SAVE_BUTTON");
            } else {
              return okButtonText = null;
            }
          }
        }
      }).result.then(function(toSave) {
        if (toSave) {
          return (saveCB && saveCB()) || true;
        } else {
          return (discardCB && discardCB()) || true;
        }
      })["finally"](function() {
        $rootScope.stateBlocked -= 1;
      });
    };
    handleCloseRequested = function(event, isDirty, isValid, saveCB, discardCB) {
      if (event.defaultPrevented) {
        return;
      }
      if (isDirty) {
        event.preventDefault();
        return event.closePromise = $uibModal.open({
          animation: true,
          templateUrl: 'core/views/modal-template.html',
          size: "lg",
          controller: 'mhModalCtrl',
          resolve: {
            title: function() {
              return $filter('translate')("DOC_NOT_SAVED");
            },
            text: function() {
              if (isValid) {
                return $filter('translate')("GENERIC_CONFIRM_CLOSE_NOT_SAVED");
              } else {
                return $filter('translate')("CONFIRM_CLOSE_NOT_VALID");
              }
            },
            cancelButtonText: function() {
              return $filter('translate')("CANCEL_BUTTON");
            },
            noButtonText: function() {
              return $filter('translate')("DONT_SAVE_BUTTON");
            },
            okButtonText: function() {
              var okButtonText;
              if (isValid) {
                return $filter('translate')("SAVE_BUTTON");
              } else {
                return okButtonText = null;
              }
            }
          }
        }).result.then(function(toSave) {
          if (toSave) {
            return saveCB();
          } else {
            return (discardCB && discardCB()) || true;
          }
        });
      } else {
        return event.closePromise = true;
      }
    };
    copyValues = function(src, dest, reset) {
      var attr, i, item, j, k, l, len, len1, len2, ref, ref1;
      if (null === src || "object" !== typeof src) {
        return src;
      }
      if (src instanceof Date) {
        if (dest === void 0) {
          dest = new Date();
        }
        dest.setTime(src.getTime());
        return dest;
      }
      if (src instanceof Array) {
        if (dest === void 0) {
          dest = [];
        } else if (reset) {
          dest.length = 0;
        }
        i = 0;
        for (j = 0, len = src.length; j < len; j++) {
          item = src[j];
          dest[i] = copyValues(item);
          i++;
        }
        return dest;
      }
      if (src instanceof Object) {
        if (dest === void 0) {
          dest = {};
        } else if (reset) {
          ref = Object.keys(dest);
          for (k = 0, len1 = ref.length; k < len1; k++) {
            attr = ref[k];
            delete dest[attr];
          }
        }
        ref1 = Object.keys(src);
        for (l = 0, len2 = ref1.length; l < len2; l++) {
          attr = ref1[l];
          dest[attr] = copyValues(src[attr]);
        }
        return dest;
      }
      throw new Error("Unable to copy src! Its type isn't supported.");
    };
    return {
      handleCloseRequested: handleCloseRequested,
      copyValues: copyValues,
      newHandleCloseRequested: newHandleCloseRequested
    };
  }]);

}).call(this);

//# sourceMappingURL=utils.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:mhModalCtrl
    * @description
    * # mhModalCtrl
    * Provider of mhModalCtrl
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").controller('selectStayWidget', ["$scope", "$rootScope", "$uibModalInstance", "Stay", "patient", "states", function($scope, $rootScope, $uibModalInstance, Stay, patient, states) {
    $rootScope.busy = true;
    Stay.query({
      patient: patient.id
    }).$promise.then(function(stays) {
      if (states) {
        $scope.stays = _.filter(stays, function(stay) {
          var ref;
          return ref = stay.state, indexOf.call(states, ref) >= 0;
        });
      } else {
        $scope.stays = stays;
      }
      return $rootScope.busy = false;
    });
    $scope.selectStay = function(stay) {
      return $uibModalInstance.close(stay);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=select-stay-widget-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.equipments:referenceValidator
    * @description
    * # Directive checking if reference is already used from a list
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').directive('referenceValidator', ["$q", function($q) {
    return {
      restrict: 'A',
      require: "ngModel",
      scope: {
        references: "="
      },
      link: function(scope, elem, attrs, ngModel) {
        var validatorPromise;
        validatorPromise = $q.defer();
        return ngModel.$asyncValidators.invalidReference = function(modelValue, viewValue) {
          if (indexOf.call(scope.references, viewValue) >= 0) {
            return $q.reject();
          } else {
            return $q.resolve();
          }
        };
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=reference-validator-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.filter:checkInUid
    * @description
    * # checkInUid
    * Filter checking if item already in list by its uid
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').filter('checkInUid', function() {
    return function(items, viewValue, notInList) {
      var checkItem, filtered;
      checkItem = function(item, viewValue, notInList) {
        if ((notInList != null) && (notInList[item.uid] != null)) {
          return false;
        }
        return !viewValue || viewValue === " " || viewValue === null || item.name.toLowerCase().includes(viewValue.toLowerCase());
      };
      filtered = _.filter(items, function(item) {
        return checkItem(item, viewValue, notInList);
      });
      return filtered;
    };
  });

  angular.module('mhclientApp').filter('checkIn', function() {
    return function(items, inList, sourceProperty, targetProperty, emptyAll) {
      var filtered;
      if (!items || !inList) {
        return items;
      }
      if (!Array.isArray(inList)) {
        inList = Object.keys(inList);
      }
      if (emptyAll && inList.length === 0) {
        return items;
      }
      if (targetProperty) {
        inList = _.map(inList, targetProperty);
      }
      if (sourceProperty) {
        filtered = _.filter(items, function(item) {
          var ref;
          return ref = _.get(item, sourceProperty), indexOf.call(inList || [], ref) >= 0;
        });
      } else {
        filtered = _.filter(items, function(item) {
          return indexOf.call(inList || [], item) >= 0;
        });
      }
      return filtered;
    };
  });

  angular.module('mhclientApp').filter('checkNotIn', function() {
    return function(items, notInList, sourceProperty, targetProperty) {
      var filtered;
      if (notInList == null) {
        return items;
      }
      if (!Array.isArray(notInList)) {
        notInList = Object.keys(notInList);
      }
      if (targetProperty) {
        notInList = _.map(notInList, targetProperty);
      }
      if (sourceProperty) {
        filtered = _.filter(items, function(item) {
          var ref;
          return ref = item[sourceProperty], indexOf.call(notInList || [], ref) < 0;
        });
      } else {
        filtered = _.filter(items, function(item) {
          return indexOf.call(notInList || [], item) < 0;
        });
      }
      return filtered;
    };
  });

}).call(this);

//# sourceMappingURL=check-in-uid-filter.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:component from html
    * @description
    * Directive which allows to compile component from html string
   */
  angular.module('mhclientApp').directive('componentFromHtml', ["$compile", function($compile) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var value;
        value = scope.$eval(attrs.componentFromHtml);
        return scope.$watch(function(scope) {
          return scope.$eval(attrs.componentFromHtml);
        }, function(value) {
          element.html(value);
          return $compile(element.contents())(scope);
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=component-from-html-directive.js.map



angular.module("mhclientApp").component("jsonInput", {
template: '<span ng-form="jsonForm"><textarea class="form-control" ng-readonly="$ctrl.readOnly" name="json" rows="{{$ctrl.rows}}" ng-model="$ctrl.insideModel" ng-change="$ctrl.validateJSON($ctrl.insideModel, jsonForm.json)"></textarea></span>',
  controller: ["$q", "SiteVar", "SiteVarsUtils", function availableExternalSyncs($q, SiteVar, SiteVarsUtils) {
    var ctrl = this;
    ctrl.rows = ctrl.rows || 5
    try {
      ctrl.insideModel = JSON.stringify(ctrl.ngModel, null, 4)
    } catch (_error) {
      ctrl.insideModel  = "{}"
    }
    ctrl.validateJSON = function(value, availableExternalSyncsForm) {
      try {
        ctrl.ngModel = JSON.parse(value);
        availableExternalSyncsForm.$valid = true;
        availableExternalSyncsForm.$setValidity('pattern', true);
      } catch (_error) {
        availableExternalSyncsForm.$valid = false;
        availableExternalSyncsForm.$setValidity('pattern', false);
      }
    }

    return true;

  }],
  bindings: {ngModel: "=", readOnly: "<", rows:"@"},
});
'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.service:
* @description
* Pharmaceutical analysis stuff
* ********************************************** */

angular.module("mhclientApp").factory('AsyncFetchService', ["$q", "$http", "$timeout", function($q, $http, $timeout) {

  return {
   fetchFile: function(url, timeout) {
      var queryResults = $q.defer();
      var doQuery = function() {
        $http({method: 'GET',  url: url}).success(function(body) {
          queryResults.resolve(body);
        }).error(function() {
          $timeout(doQuery, timeout || 10000);
        });
      };
      doQuery();
      return queryResults.promise;
   },
  }
}]);
(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name core.inputRib
    * @description
    * # input rib with validation
   */
  angular.module('mhclientApp').directive('validateIban', ["$filter", function($filter) {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModelCtrl) {
        ngModelCtrl.$validators.validateIban = function(modelValue, viewValue) {
          var alphaMap, alphabet, iban, number, rearrange;
          if (!viewValue) {
            return true;
          }
          iban = viewValue.replace(/\s+/g, '').toUpperCase();
          if (iban.length < 27) {
            return false;
          }
          if (!iban.match(/^[A-Z0-9]+$/)) {
            return false;
          }
          rearrange = iban.substring(4, iban.length) + iban.substring(0, 4);
          alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
          alphaMap = {};
          number = [];
          $.each(alphabet, function(index, value) {
            return alphaMap[value] = index + 10;
          });
          $.each(rearrange.split(''), function(index, value) {
            return number[index] = alphaMap[value] || value;
          });
          return BigInt(number.join('').toString()) % BigInt(97) === BigInt(1);
        };
        ngModelCtrl.$parsers.push((function(viewValue) {
          var formattedIban, iban;
          if (viewValue === void 0) {
            return void 0;
          }
          iban = viewValue.replace(/[^A-Z0-9]/gi, '').toUpperCase();
          formattedIban = iban.replace(/(.{4})/g, '$1 ').trim();
          ngModelCtrl.$setViewValue(formattedIban);
          ngModelCtrl.$render();
          return iban;
        }));
        return ngModelCtrl.$formatters.push((function(modelValue) {
          var formattedIban, iban;
          if (modelValue === void 0) {
            return void 0;
          }
          iban = modelValue.replace(/\s+/g, '').toUpperCase();
          formattedIban = iban.replace(/(.{4})/g, '$1 ').trim();
          return formattedIban;
        }));
      }
    };
  }]);

  angular.module('mhclientApp').directive('inputRib', ["$filter", function($filter) {
    var link;
    link = function(scope, element, attrs, transclude) {
      if (attrs.style != null) {
        scope.style = attrs.style;
      } else {
        scope.style = "";
      }
      return scope.validateIBAN = function(iban) {
        var alphaMap, alphabet, number, rearrange, result;
        if (iban === void 0) {
          return true;
        }
        if (iban.length < 27) {
          scope.userAccountForm.$invalid = true;
          return false;
        }
        iban = iban.replace(/\s+/g, '');
        rearrange = iban.substring(4, iban.length) + iban.substring(0, 4);
        alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        alphaMap = {};
        number = [];
        $.each(alphabet, function(index, value) {
          return alphaMap[value] = index + 10;
        });
        $.each(rearrange.split(''), function(index, value) {
          return number[index] = alphaMap[value] || value;
        });
        result = BigInt(number.join('').toString()) % BigInt(97) === BigInt(1);
        if (!result) {
          scope.userAccountForm.$invalid = true;
        } else {
          scope.userAccountForm.$invalid = false;
          scope.ribData = iban;
        }
        return result;
      };
    };
    return {
      link: link,
      scope: {
        ribData: '=',
        userAccountForm: '='
      },
      restrict: 'E',
      template: '<div class="input-rib"> <div class="has-feedback"> <input type="text" style="{{style}}" class="form-control" ng-model="ribData" placeholder="XXXX XXXX XXXX XXXX XXXX XXXX XXX" ng-change="validateIBAN(ribData)" onkeydown="if (event.ctrlKey && (event.key === \'c\' || event.key === \'v\')) return true; return /[a-Z0-9 /\s]+/.test(event.key)" ></input> <span class="alert-danger" ng-show="!validateIBAN(ribData)">{{ "Invalid IBAN" | translate}}</span> </div> </div>'
    };
  }]);

  angular.module('mhclientApp').filter('formatSiret', function() {
    return function(siret) {
      var cleanSiret, formatted, parts;
      if (siret == null) {
        return siret;
      }
      cleanSiret = siret.replace(/\s+/g, '');
      parts = cleanSiret.match(/.{1,3}/g) || [];
      if (parts.length > 4) {
        formatted = parts.slice(0, 3).join(' ') + ' ' + parts.slice(3).join('');
      } else {
        formatted = parts.join(' ');
      }
      return formatted.trim();
    };
  }).directive('validateSiret', ["$filter", function($filter) {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModelCtrl) {
        ngModelCtrl.$validators.validateSiret = function(modelValue, viewValue) {
          var siret;
          if (viewValue == null) {
            return true;
          }
          siret = viewValue.replace(/\s+/g, '');
          return /^\d+$/.test(siret) && (siret.length === 14);
        };
        ngModelCtrl.$parsers.push(function(viewValue) {
          var siret;
          if (viewValue == null) {
            return void 0;
          }
          siret = viewValue.replace(/\s+/g, '');
          ngModelCtrl.$setViewValue($filter('formatSiret')(siret));
          ngModelCtrl.$render();
          return siret;
        });
        return ngModelCtrl.$formatters.push(function(modelValue) {
          if (modelValue == null) {
            return void 0;
          }
          return $filter('formatSiret')(modelValue.replace(/\s+/g, ''));
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=input-rib-directive.js.map

angular.module("mhclientApp").factory("FormDataUtils", FormDataUtilsController);

function FormDataUtilsController(dateFilter) {
  /**
   * Format a data object to a FormData
   * By default, Date will be formatted as ISOstring
   * @param {*} data
   * @returns
   */
  function mapDataToFormData(data) {
    var formData = new FormData();

    for (var key in data) {
      var value = data[key];

      if (Array.isArray(value)) {
        for (var i = 0; i < value.length; i++) {
          var formattedValue = formatValueToFormDataFormat(value[i]);
          formData.append(key, formattedValue);
        }
      } else if (value !== undefined) {
        var formattedValue = formatValueToFormDataFormat(value);
        formData.append(key, formattedValue);
      }
    }

    return formData;
  }

  function formatValueToFormDataFormat(value) {
    if (value instanceof Date) {
      return value.toISOString();
    }

    return value;
  }

  /**
   * Format a Date to a FormData readable format -> "yyyy-MM-dd"
   * @param value - Date object fo be formatted
   * @returns
   */
  function formatDate(value) {
    if (!value instanceof Date) {
      throw new Error("Should be a Date object");
    }

    return dateFilter(value, "yyyy-MM-dd");
  }

  /**
   * Format a DateTime to a FormData readable format -> "yyyy-MM-dd"
   * @param value - Date object fo be formatted
   * @returns
   */
  function formatDateTime(value) {
    if (!value instanceof Date) {
      throw new Error("Should be a Date object");
    }

    return moment(value).format();
  }

  return {
    mapDataToFormData: mapDataToFormData,
    formatDate: formatDate,
    formatDateTime: formatDateTime,
  };
}

angular.module("mhclientApp").factory("DownloadUtils", DownloadUtilsController);

function DownloadUtilsController($filter) {
  /**
   * Download a file from an URL
   * @param {*} url url from where to download
   * @param {*} fileName Name of the file downloaded
   */
  function downloadFromUrl(url, fileName) {
    if (fileName == null) {
      throw new Error("Filename undefined");
    }

    var link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  /**
   * Download a blob
   * @param {*} blob blob to download
   * @param {*} fileName Name of the file downloaded
   */
  function downloadBlob(blob, fileName) {
    if (fileName == null) {
      throw new Error("Filename undefined");
    }

    var url = URL.createObjectURL(blob);
    downloadFromUrl(url, fileName);
  }

  function getFilenameFromHttpResponse(httpResponse) {
    // Source - https://stackoverflow.com/a/64570823
    // Posted by maxime1992
    // Retrieved 2026-04-30, License - CC BY-SA 4.0
    var regExpFilename = /filename="(?<filename>.*)"/;
    return regExpFilename.exec(httpResponse.headers("Content-Disposition"))
      .groups.filename;
  }

  return {
    downloadFromUrl: downloadFromUrl,
    downloadBlob: downloadBlob,
    getFilenameFromHttpResponse: getFilenameFromHttpResponse,
  };
}

'use strict';




angular.module("mhclientApp").component("cdaDocuments", {
  templateUrl: "cda_documents/views/cda-documents.html",
  controller: ["$rootScope", "$filter", "Upload", "ExternalSync", "notify", function cdaDocuments($rootScope, $filter, Upload, ExternalSync, notify) {
    var ctrl = this;
    $rootScope.busy = true
    ExternalSync.query().$promise.then (function(externalSyncs){
      ctrl.externalSyncs = externalSyncs
      _.forEach(ctrl.externalSyncs, function(externalSync){
        if (externalSync.syncing){externalSync.computedState = "syncing"}
        else if (!externalSync.failed && !externalSync.syncing){ externalSync.computedState = "done"}
        else if (externalSync.failed) {externalSync.computedState = "fail"}
      })
      ctrl.availableTypes = _.map(_.uniqBy(externalSyncs, "sync_type"), function(externalSync){ return _.pick(externalSync, ["sync_type"])})
      ctrl.availableStates = [
        {label: $filter("translate")("In progress"), value: "syncing"},
        {label: $filter("translate")("Done"), value: "done"},
        {label: $filter("translate")("Failure"), value: "fail"}]
      $rootScope.busy = false
    })

    ctrl.exportCsv =  function(){
      var queryParams = {}
      if (ctrl.dateTo) {queryParams["date_to"] = moment(ctrl.dateTo).format("YYYY-MM-DD")}
      if (ctrl.dateFrom) {queryParams["date_from"] = moment(ctrl.dateFrom).format("YYYY-MM-DD")}
      $rootScope.busy = true
      ExternalSync.export_csv(queryParams).$promise.then (function(csv){
        var a = document.createElement("a")
        a.style = "display: none"
        a.target = '_blank'
        a.href = URL.createObjectURL(new Blob([csv.data], { type: 'application/csv'}))
        a.download = "external_sync_export_" + moment().toISOString() + (queryParams["date_from"] ?  "_from" + queryParams["date_from"]: "") + (queryParams["date_to"] ?  "_to" +queryParams["date_to"] : "") + ".csv"
        a.click()
        $rootScope.busy = false
      })

    }

    ctrl.retry = function(externalSync) {
        $rootScope.busy = true
        ExternalSync.retry({id:externalSync.id}).$promise.then (function (updatedExternalSync){
          _.assign(externalSync, updatedExternalSync)
          $rootScope.busy = false
        })
      }

    ctrl.newCdaDocument = function(file){
      if (file) {
        $rootScope.busy = true
        Upload.upload({url : "/api_rest/external_sync/update_cda", method : "POST", file : file}).then ( function(response){
          $rootScope.busy = false
          ctrl.externalSyncs.push(response.data)
        }, (function(resp){
          $rootScope.busy = false
          notify({classes : ["alert-warning"], duration: 2000, message : resp.statusText})
        })
        )
      }
      };
  }],
  bindings: {},
});

angular.module('mhclientApp').filter('externalSyncFilter', function() {
  return function(externalSyncs, query) {
    if (externalSyncs && query && query.length > 0){
      var regex = new RegExp('' + query, 'i');
      return _.filter(externalSyncs, function(externalSync){
        return regex.test(externalSync.data.patient_si_id) || regex.test(externalSync.data.stay_si_id) || regex.test(externalSync.data.ins)

      })
    }
    return externalSyncs

  };
});

(function() {
  'use strict';
  angular.module('mhclientApp').factory('BillingDateUtils', function() {
    var getWeeks;
    getWeeks = function(dates) {
      var day, endOfWeek, i, j, sortedDates, startOfWeek, week, weekDay, weeks;
      sortedDates = dates.sort();
      weeks = [];
      i = 0;
      while (i < sortedDates.length) {
        startOfWeek = moment(sortedDates[i]).startOf('isoWeek');
        week = [];
        for (weekDay = j = 0; j <= 6; weekDay = ++j) {
          day = moment(startOfWeek).add(weekDay, 'days');
          week.push(day.format('YYYY-MM-DD'));
        }
        weeks.push(week);
        endOfWeek = startOfWeek.endOf('isoWeek');
        while (i < sortedDates.length && moment(sortedDates[i]) < endOfWeek) {
          i = i + 1;
        }
      }
      return weeks;
    };
    return {
      getWeeks: getWeeks
    };
  });

}).call(this);

//# sourceMappingURL=billing-date-utils.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.service:BillingUnitUtils
    * @description
    * # BillingUnitUtils
    * Factory of BillingUnitUtils
   */
  angular.module("mhclientApp").factory('BillingUnitUtils', ["$q", "BillingUnit", "BillingUnitCategory", function($q, BillingUnit, BillingUnitCategory) {
    var filterEntries, getBillingUnitCategories, getBillingUnits, getBillingUnitsForCategories, getCareBillingUnits, globalBillingUnitCategoriesPromise, globalBillingUnitsPromise, resetCache;
    globalBillingUnitsPromise = $q.defer();
    globalBillingUnitCategoriesPromise = $q.defer();
    resetCache = function() {
      globalBillingUnitCategoriesPromise = $q.defer();
      return globalBillingUnitsPromise = $q.defer();
    };
    filterEntries = function(entries, query, many) {
      var result;
      if (query) {
        result = many ? _.filter(entries, query) : _.find(entries, query);
      } else {
        result = entries;
      }
      return result;
    };
    getBillingUnitsForCategories = function(query) {
      return getBillingUnitCategories(query, true).then(function(categories) {
        var categoriesIds;
        categoriesIds = _.map(categories, "id");
        return getBillingUnits().then(function(billingUnits) {
          return _.filter(billingUnits, function(unit) {
            return categoriesIds.indexOf(unit.category) > -1;
          });
        });
      });
    };
    getBillingUnitCategories = function(query, many) {
      if (!globalBillingUnitCategoriesPromise.promise.$$state.status) {
        globalBillingUnitCategoriesPromise.resolve(BillingUnitCategory.query().$promise);
      }
      return globalBillingUnitCategoriesPromise.promise.then(function(billingUnitCategories) {
        return filterEntries(billingUnitCategories, query, many);
      });
    };
    getBillingUnits = function(query, many) {
      if (!globalBillingUnitsPromise.promise.$$state.status) {
        globalBillingUnitsPromise.resolve(BillingUnit.query().$promise);
      }
      return globalBillingUnitsPromise.promise.then(function(billingUnits) {
        return filterEntries(billingUnits, query, many);
      });
    };
    getCareBillingUnits = function() {
      return getBillingUnitsForCategories({
        code: "CARE"
      });
    };
    return {
      getBillingUnitsForCategories: getBillingUnitsForCategories,
      getCareBillingUnits: getCareBillingUnits,
      getBillingUnits: getBillingUnits,
      resetCache: resetCache
    };
  }]);

}).call(this);

//# sourceMappingURL=billing-unit-utils.js.map

'use strict';

/**
 * @ngdoc function
 * @name mhclientApp.provider:SelectChoiceModalCtrl
 * @description
 * Controller for Select Choice Modal
 */
angular.module('mhclientApp').controller('SelectChoiceModalCtrl', ["$scope", "$uibModalInstance", "options", function($scope, $uibModalInstance, options) {
    $scope.options = options;
    $scope.selectedOption = null;
    $scope.searchText = '';

    // Function to split label into parts
    function splitLabel(label) {
        var s = label.split(" ");
        var r = s[0].split(".");
        if (s.length > 1) {
            r[r.length - 1] = r[r.length - 1] + " " + s.slice(1).join(" ");
        }
        return r;
    }

    // Function to get optgroups
    $scope.getOptGroups = function(options) {
        var groupedOptions = { children: {}, options: [] };
        options.forEach(function(option) {
            var pathParts = splitLabel(option.label);
            var group = groupedOptions;

            pathParts.forEach(function(part, index) {
                if (index === pathParts.length - 1) {
                    // Add option at the last level with label and short_label
                    group.options.push({
                        key: option.key,
                        label: option.label,          // For filtering
                        short_label: pathParts[index] // Last part of the label
                    });
                } else {
                    if (!group.children[part]) {
                        group.children[part] = { children: {}, options: [] };
                    }
                    group = group.children[part];
                }
            });
        });
        return groupedOptions;
    };

    // Generate optgroups
    $scope.optgroups = $scope.getOptGroups($scope.options);

    // Function to filter options
    $scope.isMatch = function(option) {
        return option === $scope.selectedOption || option.label.toLowerCase().includes($scope.searchText.toLowerCase());
    };

    $scope.isSelected = function(item) {
        return $scope.selectedOption === item; // Check if this item is selected
    };

    $scope.selectOption = function(item) {
        if ($scope.isSelected(item)) {
            $scope.selectedOption = null
        } else {
            $scope.selectedOption = item
        }
    };

    // Recursive function to check if any options or nested groups match the search text
    $scope.shouldDisplayOptgroup = function(group) {
        function hasMatchingOptions(g) {
            // Check if any options match
            if (g.options && g.options.some($scope.isMatch)) {
                return true;
            }
            // Recursively check children
            return Object.values(g.children).some(hasMatchingOptions);
        }
        return hasMatchingOptions(group);
    };

    // Recursive function to check if any options or nested groups match the search text
    $scope.shouldDisplayOther = function(g) {
        if (Object.keys(g.children).length == 0) {
            return false;
        }
        if (g.options && g.options.some($scope.isMatch)) {
            return true;
        }
        return false;
    };

    // Handle double-click detection
    $scope.handleDoubleClick = function(item) {
        $scope.selectedOption = item;
        $scope.confirm();
    };

    // Confirm selection and close modal
    $scope.confirm = function() {
        if ($scope.selectedOption) {
            $uibModalInstance.close($scope.selectedOption.key);
        }
    };

    // Cancel modal
    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}]);

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:FormFieldDetailCtrl
    * @description
    * # FormFieldDetailCtrl
    * Provider of FormFieldDetailCtrl
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").controller('FormFieldDetailCtrl', ["$scope", "$q", "$uibModalInstance", "field", "GroupUtils", "fields", "repriseOptions", "fieldTypes", "allowImportJson", "MedFormsUtils", "ThesaurusUtils", function($scope, $q, $uibModalInstance, field, GroupUtils, fields, repriseOptions, fieldTypes, allowImportJson, MedFormsUtils, ThesaurusUtils) {
    var baseFields, conditionalField, i, len, ref, ref1, style, typesWhitReprise, value;
    GroupUtils.getAllGroups().then(function(groups) {
      return $scope.groups = groups;
    });
    $scope.usersPickables = ["username", "email", "full_name", "sector", "ext_id", "id_nat", "finess", "pro_category", "phone", "occupation", "group.uid", "group.name", "group.is_med_traitant", "group.liberal", "group.short_name", "data.address_data.town", "data.address_data.address", "data.address_data.country", "data.address_data.zip_code", "data.fax"];
    $scope.isNewField = !field || field.type === "empty";
    if (!field) {
      field = {
        fields: []
      };
    }
    if (field.styles == null) {
      field.styles = {};
    } else {
      ref = field.styles;
      for (style in ref) {
        value = ref[style];
        field.styles[style] = JSON.stringify(value);
      }
    }
    $scope.field = field;
    $scope.genFieldOptions = {
      importingJson: false
    };
    $scope.conditionalFields = fields ? _.filter(fields, function(field) {
      var ref1;
      return (ref1 = field.type) === "select" || ref1 === "text" || ref1 === "radio" || ref1 === "checkbox";
    }) : null;
    if ($scope.conditionalFields) {
      $scope.conditionalFieldsByKey = {};
      ref1 = $scope.conditionalFields;
      for (i = 0, len = ref1.length; i < len; i++) {
        conditionalField = ref1[i];
        $scope.conditionalFieldsByKey[conditionalField.key] = conditionalField;
      }
    }
    $scope.allowImportJson = allowImportJson;
    $scope.checkValueInOptions = function(value, options) {
      if (_.find(options, {
        "value": value
      })) {
        return true;
      } else {
        return false;
      }
    };
    $scope.formEditorVersion2 = true;
    baseFields = ["text", "date", "number", "radio", "select", "section", "auto", "checkbox", "multiline", "html", "block", "text-area", "signature", "pageBreak"];
    if ($scope.formEditorVersion2) {
      baseFields.push("legend");
      baseFields.push("table");
      baseFields.push("medicaldbResource");
      baseFields.push("userSelection");
      baseFields.push("multiUserSelection");
      baseFields.push("dischargeOrdonnance");
      baseFields.push("insDataMatrix");
      baseFields.push("list");
      baseFields.push("newHtml");
      baseFields.push("logo");
    }
    $scope.fieldTypes = fieldTypes || baseFields;
    typesWhitReprise = ["text", "date", "number", "radio", "select", "checkbox", "text-area", "medicaldbResource", "userSelection", "signature", "multiUserSelection", "dischargeOrdonnance"];
    $scope.radioTypes = ["text", "boolean", "number"];
    $scope.getAutoFields = function() {
      var autoFields;
      autoFields = {};
      $q.when(MedFormsUtils.staticDataDefinition()).then(function(staticData) {
        return autoFields.results = _.concat(_.includes(['userSelection', 'multiUserSelection'], field.type) ? MedFormsUtils.userDataStaticFields("user", "SelectedUser") : [], _.orderBy([].concat.apply(staticData, _.map(_.filter(fields, "key"), function(staticField) {
          if (staticField.key === "referent" && window.location.href.split('/').pop() === 'mission-letter-editor') {
            return MedFormsUtils.userDataStaticFields("staticData.missionLetter." + staticField.key, "FORM." + (staticField.label || staticField.key));
          } else if (staticField.type === "medicaldbResource") {
            return [
              {
                key: "contentData." + staticField.key + "|JOIN:name,code",
                label: "FORM." + (staticField.label || staticField.key) + " (" + staticField.type + ")"
              }
            ];
          } else if (_.includes(['userSelection'], staticField.type)) {
            return MedFormsUtils.userDataStaticFields("contentData." + staticField.key, "FORM." + (staticField.label || staticField.key));
          } else {
            return [
              {
                key: "contentData." + staticField.key,
                label: "FORM." + (staticField.label || staticField.key) + " (" + staticField.type + ")"
              }
            ];
          }
        })), "label"));
      });
      return autoFields;
    };
    $scope.validateJSON = function(field, value) {
      var error, error1;
      try {
        JSON.parse(value);
        field.$valid = true;
        field.$setValidity('pattern', true);
      } catch (error1) {
        error = error1;
        field.$valid = false;
        field.$setValidity('pattern', false);
      }
      return true;
    };
    $scope.stylesByField = function(field) {
      var baseStyles;
      baseStyles = ['main_style', 'label_style', 'radio_options'];
      return {
        "text": [].concat.apply(baseStyles, ["input_style"]),
        "text-area": [].concat.apply(baseStyles, ["input_style"]),
        "number": [].concat.apply(baseStyles, ["input_style"]),
        "date": [].concat.apply(baseStyles, ["input_style"]),
        "radio": baseStyles,
        "select": baseStyles,
        "signature": baseStyles,
        "section": baseStyles,
        "list": baseStyles,
        "medicaldbResource": baseStyles,
        "userSelection": baseStyles,
        "multiUserSelection": baseStyles,
        "dischargeOrdonnance": baseStyles,
        "insDataMatrix": baseStyles,
        "newHtml": ['main_style'],
        "logo": baseStyles,
        "root": baseStyles,
        "header": baseStyles,
        "footer": baseStyles,
        "margin": baseStyles,
        "auto": baseStyles,
        "checkbox": baseStyles,
        "multiline": baseStyles,
        "html": baseStyles,
        "block": baseStyles,
        "legend": baseStyles,
        "table": baseStyles
      }[field.type];
    };
    $scope.repriseOptions = repriseOptions || null;
    $scope.initCustomCondition = function(condition) {
      return condition.custom_key_in_data = "condition_" + ThesaurusUtils.uuid();
    };
    $scope.initCondition = function(field) {
      if (!field.conditions) {
        return field.conditions = [{}];
      }
    };
    $scope.initReprise = function(field) {
      if (!field.reprises) {
        return field.reprises = [{}];
      }
    };
    $scope.repriseEnabled = function(type) {
      return indexOf.call(typesWhitReprise, type) >= 0;
    };
    $scope.initAuto = function(field) {
      if (!field.result_params) {
        return field.result_params = {};
      }
    };
    $scope.initSelect = function(field) {
      if (!field.options) {
        return field.options = [
          {
            "type": "text"
          }
        ];
      }
    };
    $scope.initRadio = function(field) {
      if (!field.radio_options) {
        return field.radio_options = [
          {
            "type": "boolean"
          }, {
            "type": "boolean"
          }
        ];
      }
    };
    $scope.initUsersSelection = function(field) {
      if (!field.queries) {
        field.queries = [];
      }
      if (!field.displayFields) {
        return field.displayFields = [];
      }
    };
    $scope.initSection = function(field) {
      if (!field.fields) {
        return field.fields = [];
      }
    };
    $scope.initTable = function(field) {
      if (!field.fields) {
        field.fields = [];
      }
      if (!field.col_count) {
        return field.col_count = 2;
      }
    };
    $scope.initAccordion = function(field) {
      if (!field.fields) {
        return field.fields = [];
      }
    };
    $scope.addOption = function(options) {
      return options.push({
        "type": "text"
      });
    };
    $scope.removeOption = function(options, option) {
      return options = _.remove(options, option);
    };
    $scope.importJson = function(text) {
      $scope.field = JSON.parse(text);
      if ($scope.field.type === "root") {
        $scope.field.type = "block";
        delete $scope.field.footer;
        delete $scope.field.header;
        delete $scope.field.left_margin;
        delete $scope.field.right_margin;
        delete $scope.field.disable_autofooter;
        delete $scope.field.disable_autoheader;
      }
      $scope.genFieldOptions.form.$setDirty();
      return $scope.accept();
    };
    $scope.addReprise = function(reprises) {
      return reprises.push({});
    };
    $scope.removeReprise = function(reprises, reprise) {
      return _.remove(reprises, reprise);
    };
    $scope.accept = function() {
      var ref2;
      if (!$scope.field.has_condition) {
        delete $scope.field.conditions;
      }
      if (!$scope.field.has_reprise || !$scope.repriseEnabled($scope.field.type)) {
        delete $scope.field.has_reprise;
        delete $scope.field.reprises;
      }
      ref2 = field.styles;
      for (style in ref2) {
        value = ref2[style];
        field.styles[style] = JSON.parse(value);
      }
      return $uibModalInstance.close($scope.field);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=form-field-editor-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:SynthesisCreationCtrl
    * @description
    * # SynthesisCreationCtrl
    * Provider of SynthesisCreationCtrl
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").controller('MultiFormSynthesisCtrl', ["$scope", "$rootScope", "$filter", "$uibModal", "$uibModalInstance", "templates", "group", "synthesis", function($scope, $rootScope, $filter, $uibModal, $uibModalInstance, templates, group, synthesis) {
    var i, len, ref, ref1, template;
    $scope.currentGroup = null;
    $scope.synthesis = _.cloneDeep(synthesis || {
      selected_fields: [],
      fields: [],
      type: "custom",
      custom_templates: [],
      version_ref: "custom_form",
      baseFields: {
        fields: []
      }
    });
    $scope.status = {
      currentMedForm: $scope.synthesis
    };
    $scope.currentGroup = group;
    $scope.selectedTemplates = [];
    $scope.availableTemplates = [];
    $scope.multiSyntheisTemplates = _.map(templates, _.cloneDeep);
    ref = $scope.multiSyntheisTemplates;
    for (i = 0, len = ref.length; i < len; i++) {
      template = ref[i];
      if (ref1 = template.uid, indexOf.call($scope.synthesis.custom_templates, ref1) >= 0) {
        $scope.selectedTemplates.push(template);
      } else {
        $scope.availableTemplates.push(template);
      }
    }
    $scope.addTemplate = function(template) {
      $scope.selectedTemplates.push(template);
      _.remove($scope.availableTemplates, template);
      return $scope.synthesis.custom_templates.push(template.uid);
    };
    $scope.removeTemplate = function(template, fields) {
      $scope.synthesis.custom_templates.splice($scope.synthesis.custom_templates.indexOf(template.uid), 1);
      $scope.availableTemplates.push(template);
      _.remove($scope.selectedTemplates, template);
      return $scope.removeTemplateFields(fields, template.uid);
    };
    $scope.toogleForm = function(template) {
      template.unfolded = true;
      if ($scope.status.currentTemplate === template) {
        return $scope.status.currentTemplate = null;
      } else {
        template.baseFields = {
          fields: $scope.extractFields(_.map(template.lastDynamicVersion.meta.containers[0].dynamicForm.fields, _.cloneDeep), [], template.uid)
        };
        return $scope.status.currentTemplate = template;
      }
    };
    $scope.$on('$medformsRemoveField', function(event, field) {
      var j, k, l, len1, len2, len3, newField, ref2, ref3, ref4, selected_uids, uid;
      $scope.currentGroup.dirty = true;
      selected_uids = $scope.status.currentMedForm.selected_fields;
      selected_uids.splice(selected_uids.indexOf(field.uid), 1);
      ref2 = $scope.extractUIDS(field.fields || []);
      for (j = 0, len1 = ref2.length; j < len1; j++) {
        uid = ref2[j];
        selected_uids.splice(selected_uids.indexOf(uid), 1);
      }
      ref3 = $scope.multiSyntheisTemplates;
      for (k = 0, len2 = ref3.length; k < len2; k++) {
        template = ref3[k];
        if (template.baseFields && template.baseFields.fields) {
          ref4 = $scope.filterFieldByTemplate([angular.copy(field)], template.uid);
          for (l = 0, len3 = ref4.length; l < len3; l++) {
            newField = ref4[l];
            template.baseFields.fields.unshift(newField);
          }
        }
      }
      return event.stopPropagation();
    });
    $scope.$on('$medformsAppendField', function(event, field) {
      var j, len1, ref2, selected_uids, uid;
      $scope.currentGroup.dirty = true;
      selected_uids = $scope.status.currentMedForm.selected_fields;
      selected_uids.push(field.uid);
      ref2 = $scope.extractUIDS(field.fields || []);
      for (j = 0, len1 = ref2.length; j < len1; j++) {
        uid = ref2[j];
        selected_uids.push(uid);
      }
      $scope.status.currentMedForm.fields.push(field);
      return event.stopPropagation();
    });
    $scope.accept = function() {
      return $uibModalInstance.close($scope.synthesis);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

  angular.module("mhclientApp").controller('SynthesisCreationCtrl', ["$q", "$scope", "$rootScope", "$filter", "$uibModal", "GroupUtils", "Group", "TemplateVersion", "MedFormsUtils", "FormTemplateUtils", "GenUID", function($q, $scope, $rootScope, $filter, $uibModal, GroupUtils, Group, TemplateVersion, MedFormsUtils, FormTemplateUtils, GenUID) {
    var initFieldsForTemplate, sanitizeFields;
    $scope.currentGroup = null;
    $scope.status = {};
    $scope.toogleForm = function(medformsSyntesis) {
      if (medformsSyntesis.type === "custom") {
        return $scope.addCustomSynthesis($scope.currentGroup, medformsSyntesis);
      } else {
        medformsSyntesis.unfolded = true;
        if ($scope.status.currentMedForm === medformsSyntesis) {
          return $scope.status.currentMedForm = null;
        } else {
          return $scope.status.currentMedForm = medformsSyntesis;
        }
      }
    };
    $scope.filterGroupByName = function(viewValue) {
      return function(item, index, array) {
        return !viewValue || viewValue === " " || viewValue === null || item.name.toLowerCase().indexOf(viewValue.toLowerCase()) >= 0;
      };
    };
    $scope.filterByDataUid = function(viewValue) {
      return function(item, index, array) {
        return !viewValue || viewValue === " " || viewValue === null || item.data.uid.toLowerCase().indexOf(viewValue.toLowerCase()) >= 0;
      };
    };
    GroupUtils.getAllGroups().then(function(groups) {
      return $scope.groups = groups;
    });
    sanitizeFields = function(fields, uids) {
      var field, i, len, ref, ref1, results;
      results = [];
      for (i = 0, len = fields.length; i < len; i++) {
        field = fields[i];
        if ((ref = field.type, indexOf.call(MedFormsUtils.formInputFields, ref) >= 0) && (ref1 = field.uid, indexOf.call(uids, ref1) < 0)) {
          field.synthesis_obsolete = true;
        }
        results.push(sanitizeFields(field.fields || [], uids));
      }
      return results;
    };
    $scope.extractUIDS = function(fields) {
      var field, i, len, uids;
      uids = [];
      for (i = 0, len = fields.length; i < len; i++) {
        field = fields[i];
        uids.push(field.uid);
        uids = _.concat(uids, $scope.extractUIDS(field.fields || []));
      }
      return uids;
    };
    $scope.extractFields = function(fields, selectedFields, templateUID) {
      var condition, enabledFields, field, i, j, len, len1, re, ref, ref1;
      enabledFields = [];
      for (i = 0, len = fields.length; i < len; i++) {
        field = fields[i];
        if (ref = field.uid, indexOf.call(selectedFields, ref) < 0) {
          field.template_uid = templateUID;
          field.key = templateUID + "_" + field.key;
          ref1 = field.conditions || [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            condition = ref1[j];
            condition.key = templateUID + "_" + condition.key;
          }
          if (field.type === "auto") {
            re = /(data).([a-zA-Z0-9_]+)/g;
            field.result = field.result.replace(re, "$1['" + templateUID + "_$2']");
          }
          enabledFields.push(field);
          field.fields = $scope.extractFields(field.fields || [], selectedFields, templateUID);
        } else {
          enabledFields = _.concat(enabledFields, $scope.extractFields(field.fields || [], selectedFields, templateUID));
        }
      }
      return enabledFields;
    };
    initFieldsForTemplate = function(template, selectedFields) {
      return $scope.extractFields(_.map(template.lastDynamicVersion.meta.containers[0].dynamicForm.fields, _.cloneDeep), selectedFields, template.uid);
    };
    $scope.removeTemplateFields = function(fields, templateUID) {
      var field, i, j, k, len, len1, len2, ref, removedField, removedFields, results;
      while (true) {
        removedFields = _.remove(fields, {
          template_uid: templateUID
        });
        for (i = 0, len = removedFields.length; i < len; i++) {
          removedField = removedFields[i];
          ref = removedField.fields || [];
          for (j = 0, len1 = ref.length; j < len1; j++) {
            field = ref[j];
            fields.push(field);
          }
        }
        if (removedFields.length === 0) {
          break;
        }
      }
      results = [];
      for (k = 0, len2 = fields.length; k < len2; k++) {
        field = fields[k];
        results.push($scope.removeTemplateFields(field.fields || [], templateUID));
      }
      return results;
    };
    $scope.addCustomSynthesis = function(group, synthesis) {
      var templateImportDialog;
      $scope.addingCustom = true;
      templateImportDialog = $uibModal.open({
        templateUrl: 'customer/medforms/views/multi-form-synthesis.html',
        controller: 'MultiFormSynthesisCtrl',
        windowClass: 'event-detail-modal',
        scope: $scope,
        backdrop: 'static',
        resolve: {
          templates: function() {
            return $scope.templates;
          },
          group: function() {
            return group;
          },
          synthesis: function() {
            return synthesis;
          }
        }
      });
      return templateImportDialog.result.then(function(data) {
        $scope.addingCustom = false;
        if (data) {
          data.name = data.tittle;
          data.uid = data.tittle;
          if (synthesis) {
            _.remove(group.synthesis.medforms, synthesis);
          }
          group.synthesis.medforms.push(data);
          return $scope.currentGroup.dirty = true;
        }
      });
    };
    $scope.removeTemplate = function(medformSynthesis, fields) {
      if (medformSynthesis === $scope.status.currentMedForm) {
        $scope.status.currentMedForm = null;
      }
      $scope.currentGroup.dirty = true;
      _.remove($scope.currentGroup.synthesis.medforms, medformSynthesis);
      if (!medformSynthesis.type === "custom") {
        $scope.currentGroup.otherTemplates.push(_.find($scope.templates, {
          data: {
            uid: medformSynthesis.uid
          }
        }));
        return $scope.removeTemplateFields(fields, medformSynthesis.uid);
      }
    };
    $scope.addTemplate = function(group, template, previousSynthesis) {
      _.remove($scope.currentGroup.otherTemplates, template);
      return $scope.currentGroup.synthesis.medforms.push({
        uid: template.uid,
        version_ref: template.lastDynamicVersion.data.ref,
        tittle: template.lastDynamicVersion.meta.containers[0].dynamicForm.tittle,
        name: template.lastDynamicVersion.data.name,
        fields: [],
        selected_fields: [],
        baseFields: {
          fields: initFieldsForTemplate(template, [])
        }
      });
    };
    $scope.copySynthesis = function(currentGroup, currentMedForm) {
      return GroupUtils.selectGroupModal($scope.groups).result.then(function(group) {
        var newFields, synthesisToCopy;
        if (group) {
          synthesisToCopy = _.find(group.synthesis.medforms, {
            uid: currentMedForm.uid
          });
          if (synthesisToCopy) {
            newFields = _.find(group.synthesis.medforms, {
              uid: currentMedForm.uid
            }).fields;
            currentMedForm.selected_fields = currentMedForm.selected_fields.concat($scope.extractUIDS(newFields));
            currentMedForm.fields = newFields.concat(currentMedForm.fields);
            return currentGroup.dirty = true;
          }
        }
      });
    };
    $scope.saveSynthesis = function(group) {
      var i, len, medform, ref, synthesis;
      $rootScope.busy = true;
      synthesis = {
        fields: group.synthesis.fields,
        selected_fields: group.synthesis.selected_fields,
        medforms: []
      };
      ref = group.synthesis.medforms;
      for (i = 0, len = ref.length; i < len; i++) {
        medform = ref[i];
        synthesis.medforms.push({
          uid: medform.uid,
          order: medform.order,
          version_ref: medform.version_ref,
          name: medform.name,
          type: medform.type,
          custom_templates: medform.custom_templates,
          tittle: medform.tittle,
          fields: medform.fields,
          selected_fields: medform.selected_fields
        });
      }
      return Group.update({
        id: group.id
      }, {
        synthesis: synthesis
      }).$promise.then(function() {
        $scope.currentGroup.dirty = false;
        return $rootScope.busy = false;
      });
    };
    $scope.selectGroup = function(group) {
      $scope.currentGroup = group;
      if ($scope.currentGroup.initDone == null) {
        $rootScope.busy = true;
        return Group.get({
          id: group.id
        }).$promise.then(function(groupDetail) {
          var i, len, medformsSynthesis, ref, refs, template, uids;
          $scope.currentGroup.synthesis = groupDetail.synthesis;
          $scope.currentGroup.initDone = true;
          if ($scope.currentGroup.synthesis.medforms == null) {
            $scope.currentGroup.synthesis.medforms = [];
          }
          if ($scope.currentGroup.synthesis.fields == null) {
            $scope.currentGroup.synthesis.fields = [];
          }
          if ($scope.currentGroup.synthesis.selected_fields == null) {
            $scope.currentGroup.synthesis.selected_fields = [];
          }
          if (!$scope.currentGroup.otherTemplates) {
            refs = _.map($scope.currentGroup.synthesis.medforms, 'uid');
            $scope.currentGroup.otherTemplates = _.filter($scope.templates, function(template) {
              var ref;
              return !(ref = template.uid, indexOf.call(refs, ref) >= 0);
            });
          }
          uids = [];
          ref = $scope.currentGroup.synthesis.medforms;
          for (i = 0, len = ref.length; i < len; i++) {
            medformsSynthesis = ref[i];
            if (medformsSynthesis.version_ref !== "custom_form") {
              template = _.find($scope.templates, {
                uid: medformsSynthesis.uid
              });
              medformsSynthesis.baseFields = {
                fields: initFieldsForTemplate(template, medformsSynthesis.selected_fields)
              };
              medformsSynthesis.version_ref = template.lastDynamicVersion.data.ref;
              medformsSynthesis.name = template.lastDynamicVersion.data.name;
              sanitizeFields(medformsSynthesis.fields, $scope.extractUIDS(template.lastDynamicVersion.meta.containers[0].dynamicForm.fields));
            } else {
              medformsSynthesis.baseFields = {
                fields: []
              };
            }
          }
          return $rootScope.busy = false;
        });
      }
    };
    $scope.filterFieldByTemplate = function(fields, templateUID) {
      var field, filterFields, i, len;
      filterFields = [];
      for (i = 0, len = fields.length; i < len; i++) {
        field = fields[i];
        if (field.template_uid === templateUID && !field.synthesis_obsolete) {
          field.fields = $scope.filterFieldByTemplate(field.fields, templateUID);
          filterFields.push(field);
        } else {
          filterFields = _.concat(filterFields, $scope.filterFieldByTemplate(field.fields, templateUID));
        }
      }
      return filterFields;
    };
    $scope.$on('getAllowedTypes', function(event) {
      event.data = ["section", "multiline", "block", "accordion", "next_intervention", "legend", "table"];
      return event.stopPropagation();
    });
    $scope.$on('medformsSetDirty', function(event) {
      $scope.currentGroup.dirty = true;
      return event.stopPropagation();
    });
    $scope.$on('$medformsRemoveField', function(event, field) {
      var i, j, k, len, len1, len2, medformsSynthesis, newField, ref, ref1, ref2, selected_uids, uid;
      if (!$scope.addingCustom) {
        $scope.currentGroup.dirty = true;
        selected_uids = $scope.status.currentMedForm.selected_fields;
        selected_uids.splice(selected_uids.indexOf(field.uid), 1);
        ref = $scope.extractUIDS(field.fields || []);
        for (i = 0, len = ref.length; i < len; i++) {
          uid = ref[i];
          selected_uids.splice(selected_uids.indexOf(uid), 1);
        }
        ref1 = $scope.currentGroup.synthesis.medforms;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          medformsSynthesis = ref1[j];
          ref2 = $scope.filterFieldByTemplate([angular.copy(field)], medformsSynthesis.uid);
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            newField = ref2[k];
            medformsSynthesis.baseFields.fields.unshift(newField);
          }
        }
        return event.stopPropagation();
      }
    });
    $scope.$on('$medformsAppendField', function(event, field) {
      var i, len, ref, selected_uids, uid;
      if (!$scope.addingCustom) {
        $scope.currentGroup.dirty = true;
        selected_uids = $scope.status.currentMedForm.selected_fields;
        selected_uids.push(field.uid);
        ref = $scope.extractUIDS(field.fields || []);
        for (i = 0, len = ref.length; i < len; i++) {
          uid = ref[i];
          selected_uids.push(uid);
        }
        $scope.status.currentMedForm.fields.push(field);
        return event.stopPropagation();
      }
    });
    $rootScope.busy = true;
    return MedFormsUtils.getStaticData().then(function(customScope) {
      return TemplateVersion.query({
        only_current: true,
        content_type: "STRUCTURED"
      }).$promise.then(function(versions) {
        return FormTemplateUtils.getTemplates().then(function(templates) {
          return $q.all(_.map(versions, function(version) {
            return MedFormsUtils.fetchTemplateVersionContainers(version);
          })).then(function() {
            $scope.customScope = customScope;
            _.forEach(templates, function(template) {
              template.lastDynamicVersion = _.find(versions, {
                template: template.id
              }) || null;
              return true;
            });
            $scope.templates = _.reject(templates, {
              lastDynamicVersion: null
            });
            return $rootScope.busy = false;
          });
        });
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=synthesis-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:CustomerMedicationCtrl
    * @description
    * # CustomerMedicationCtrl
    * Provider of CustomerMedicationCtrl
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").controller('CustomerMedicationCtrl', ["$scope", "$rootScope", "$q", "$filter", "$uibModal", "PrescUtils", "SiteVarsUtils", "PrescCategory", "PrescTimeSlot", "Certificate", function($scope, $rootScope, $q, $filter, $uibModal, PrescUtils, SiteVarsUtils, PrescCategory, PrescTimeSlot, Certificate) {
    var categoriesTemplates;
    $rootScope.busy = true;
    PrescUtils.getCategories().promise.then(function(categories) {
      return Certificate.query().$promise.then(function(certificates) {
        var existingCategoriesNames;
        $scope.pososCertificate = _.find(certificates, {
          cert_type: 'posos'
        }) || {
          obsolete: true,
          cert_type: 'posos',
          entity: null,
          sector: null
        };
        $scope.categories = _.filter(categories, function(cat) {
          return indexOf.call(cat.properties.resumption || [], "CREATE") >= 0;
        });
        existingCategoriesNames = _.map($scope.categories, "name");
        $scope.availableCategories = _.filter(categoriesTemplates, function(template) {
          var ref;
          return ref = template.name, indexOf.call(existingCategoriesNames, ref) < 0;
        });
        return PrescUtils.getTimeSlots().promise.then(function(timeSlots) {
          var i, interval, j, len, len1, ref, timeSlot;
          $scope.timeSlots = timeSlots;
          $scope.intervalsTimeSlots = [
            {
              id: "4",
              slots: []
            }, {
              id: "6",
              slots: []
            }, {
              id: "8",
              slots: []
            }, {
              id: "12",
              slots: []
            }
          ];
          for (i = 0, len = timeSlots.length; i < len; i++) {
            timeSlot = timeSlots[i];
            if (timeSlot.data.intervals == null) {
              timeSlot.data.intervals = [];
            }
            ref = timeSlot.data.intervals;
            for (j = 0, len1 = ref.length; j < len1; j++) {
              interval = ref[j];
              _.find($scope.intervalsTimeSlots, {
                id: interval
              }).slots.push(timeSlot);
            }
          }
          return $rootScope.busy = false;
        });
      });
    });
    $scope.handlePosos = function() {
      if (!$scope.pososCertificate.id) {
        $scope.editPososCert().result.then((function() {}), function() {});
        return $scope.pososCertificate.obsolete = true;
      } else {
        $rootScope.busy = true;
        return Certificate.update(_.pick($scope.pososCertificate, ["id", "obsolete"])).$promise.then(function() {
          return $rootScope.busy = false;
        });
      }
    };
    $scope.editPososCert = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: true,
        component: 'certEditCertModal',
        backdrop: 'static',
        windowClass: 'modal-fullscreen',
        resolve: {
          certificate: function() {
            return _.cloneDeep($scope.pososCertificate);
          },
          entities: function() {
            return [];
          },
          sectors: function() {
            return [];
          },
          certificates: function() {
            return [];
          },
          query: function() {
            return {};
          }
        }
      });
      modalInstance.result.then(function(editedCertificate) {
        return $scope.pososCertificate = editedCertificate;
      });
      return modalInstance;
    };
    $scope.modifyAdminCodes = function(category, categoryForm) {
      var modal;
      modal = $uibModal.open({
        templateUrl: 'customer/medication/views/category-codes.html',
        backdrop: 'true',
        controller: 'AdminCodesCtrl',
        animation: false,
        resolve: {
          category: function() {
            return category;
          }
        }
      });
      return modal.result.then(function() {
        return categoryForm.$setDirty();
      });
    };
    categoriesTemplates = [
      {
        "name": "BIOLOGIC",
        "gen_tasks": false,
        "show_in_admin": false,
        "dispensable": false,
        "color": "#2698d7",
        "properties": {
          "analyse_disabled": true
        }
      }, {
        "name": "LABORATORY",
        "gen_tasks": false,
        "show_in_admin": false,
        "dispensable": false,
        "color": "#2698d7",
        "properties": {
          "analyse_disabled": true
        }
      }, {
        "name": "NEW_CARE",
        "gen_tasks": false,
        "show_in_admin": false,
        "dispensable": false,
        "color": "orange",
        "not_selectable_for_print": true,
        "properties": {
          "analyse_disabled": true
        }
      }, {
        "name": "IMAGE",
        "gen_tasks": false,
        "show_in_admin": false,
        "dispensable": false,
        "color": "black",
        "properties": {
          "analyse_disabled": true
        }
      }, {
        "name": "FOND",
        "gen_tasks": true,
        "show_in_admin": true,
        "dispensable": true,
        "color": "#FFE58E",
        "properties": {}
      }, {
        "name": "OCC",
        "gen_tasks": true,
        "show_in_admin": true,
        "dispensable": true,
        "color": "#F5CE4C",
        "properties": {}
      }, {
        "name": "PAP",
        "gen_tasks": false,
        "show_in_admin": true,
        "dispensable": true,
        "color": "#C09E29",
        "properties": {}
      }, {
        "name": "PAP_TEMPLATE",
        "gen_tasks": false,
        "show_in_admin": true,
        "dispensable": true,
        "color": "#6542f4",
        "properties": {}
      }, {
        "name": "PCA",
        "gen_tasks": false,
        "show_in_admin": true,
        "dispensable": true,
        "color": "#FF6E00",
        "properties": {}
      }, {
        "name": "CHIMIO",
        "gen_tasks": true,
        "show_in_admin": true,
        "dispensable": true,
        "color": "#44AAFF",
        "properties": {}
      }
    ];
    $scope.modifyInterval = function(interval) {
      var modal;
      $scope.interval = interval;
      _.forEach($scope.timeSlots, function(ts) {
        return ts.selected = indexOf.call(interval.slots, ts) >= 0;
      });
      modal = $uibModal.open({
        templateUrl: 'customer/medication/views/interval-timeslot-editor.html',
        backdrop: 'static',
        scope: $scope
      });
      return modal.result.then(function() {
        var i, len, newTimeSlots, promises, ref, removedTimeSlots, timeSlot;
        newTimeSlots = [];
        removedTimeSlots = [];
        promises = [];
        $rootScope.busy = true;
        ref = $scope.timeSlots;
        for (i = 0, len = ref.length; i < len; i++) {
          timeSlot = ref[i];
          if (timeSlot.selected && indexOf.call(interval.slots, timeSlot) < 0) {
            interval.slots.push(timeSlot);
            timeSlot.data.intervals.push(interval.id);
            promises.push(PrescTimeSlot.update({
              id: timeSlot.id
            }, timeSlot).$promise);
          }
          if (!timeSlot.selected && indexOf.call(interval.slots, timeSlot) >= 0) {
            _.pull(timeSlot.data.intervals, interval.id);
            _.remove(interval.slots, timeSlot);
            promises.push(PrescTimeSlot.update({
              id: timeSlot.id
            }, timeSlot).$promise);
          }
        }
        return $q.all(promises).then(function() {
          return $rootScope.busy = false;
        });
      });
    };
    $scope.createCategory = function() {
      var modal;
      modal = $uibModal.open({
        templateUrl: 'core/views/modal-selection-template.html',
        backdrop: 'static',
        size: 'lg',
        controller: 'ModalSelectionCtrl',
        resolve: {
          label: function() {
            return "CATEGORY_SELECTION";
          },
          choices: function() {
            return $scope.availableCategories;
          },
          lookUpField: function() {
            return "name";
          }
        }
      });
      return modal.result.then(function(categoryTemplate) {
        var category;
        if (categoryTemplate) {
          category = _.cloneDeep(categoryTemplate);
          category.state = "ACT";
          category.properties.resumption = ["CREATE", "RENEW"];
          if (category.show_in_admin) {
            category.properties.administration_codes = PrescUtils.defaultAdminCodes;
          }
          return $scope.modifyCategory(category);
        }
      });
    };
    $scope.modifyTimeSlot = function(timeSlot) {
      var modal;
      $scope.timeSlot = _.cloneDeep(timeSlot);
      if ($scope.timeSlot.data.start_time) {
        $scope.timeSlot.currentHour = moment(timeSlot.data.start_time, "HH:mm");
      }
      modal = $uibModal.open({
        templateUrl: 'customer/medication/views/time-slot-editor.html',
        backdrop: 'static',
        scope: $scope
      });
      return modal.result.then(function(result) {
        if ($scope.timeSlot.currentHour) {
          $scope.timeSlot.data.start_time = moment($scope.timeSlot.currentHour).format("HH:mm");
        }
        _.merge(timeSlot, $scope.timeSlot);
        $rootScope.busy = true;
        return PrescTimeSlot.update({
          id: timeSlot.id
        }, timeSlot).$promise.then(function() {
          $rootScope.busy = false;
          return PrescUtils.resetCache();
        });
      });
    };
    return $scope.modifyCategory = function(category) {
      var modal;
      $scope.category = _.cloneDeep(category);
      modal = $uibModal.open({
        templateUrl: 'customer/medication/views/category-editor.html',
        backdrop: 'static',
        scope: $scope
      });
      return modal.result.then(function(result) {
        _.merge(category, $scope.category);
        category.properties = $scope.category.properties;
        $rootScope.busy = true;
        if (category.id != null) {
          return PrescCategory.update({
            id: category.id
          }, category).$promise.then(function(updatedCategory) {
            $rootScope.busy = false;
            return PrescUtils.resetCache();
          });
        } else {
          return PrescCategory.save(category).$promise.then(function(newCategory) {
            category.id = newCategory.id;
            _.remove($scope.availableCategories, {
              name: category.name
            });
            $scope.categories.push(category);
            PrescUtils.resetCache();
            return $rootScope.busy = false;
          });
        }
      });
    };
  }]);

  angular.module("mhclientApp").controller('AdminCodesCtrl', ["$scope", "$rootScope", "$uibModal", "$state", "$filter", "$uibModalInstance", "category", "PrescUtils", "SiteVarsUtils", function($scope, $rootScope, $uibModal, $state, $filter, $uibModalInstance, category, PrescUtils, SiteVarsUtils) {
    SiteVarsUtils.get("TASK_COLORS", {
      "NEW": {
        "background": "#406786",
        "color": "white"
      },
      "OK": {
        "background": "#CBEDB2",
        "color": "black"
      },
      "NOK": {
        "background": "#FF9898",
        "color": "black"
      },
      "prepared": {
        "background": "#FFFF98",
        "color": "black"
      }
    }).then(function(taskColors) {
      return $scope.taskColors = taskColors.value;
    });
    if ((category.properties.administration_codes == null) || category.properties.administration_codes.length === 0) {
      category.properties.administration_codes = PrescUtils.defaultAdminCodes;
    }
    $scope.administrationCodes = _.cloneDeep(category.properties.administration_codes);
    $scope.defaultAdminCode = category.properties.default_admin_code;
    $scope.handleDefaultCodes = function() {
      var availableCodes;
      availableCodes = [];
      _.map($scope.administrationCodes, function(administrationCode) {
        return _.map(administrationCode.codes, function(code) {
          return availableCodes.push({
            code: code.code,
            state: administrationCode.state,
            label: administrationCode.state + " - " + code.code
          });
        });
      });
      $scope.availableCodes = availableCodes;
      if ($scope.defaultAdminCode) {
        return $scope.defaultAdminCode = _.find($scope.availableCodes, {
          state: $scope.defaultAdminCode.state,
          code: $scope.defaultAdminCode.code
        });
      }
    };
    $scope.handleDefaultCodes();
    $scope.addCode = function(state) {
      return state.codes.push({
        code: "",
        label: ""
      });
    };
    $scope.preparationOptions = [
      {
        "label": $filter('translate')('DAYLY_PILLBOX_ACTION'),
        "option": "DAYLY_PILLBOX"
      }, {
        "label": $filter('translate')('WEEKLY_PILLBOX_ACTION'),
        "option": "WEEKLY_PILLBOX"
      }
    ];
    $scope.checkInState = function(activityState) {
      return _.find($scope.administrationCodes, {
        state: activityState
      });
    };
    $scope.hasEmptyCodes = function() {
      var administrationCode, i, len, ref;
      ref = $scope.administrationCodes;
      for (i = 0, len = ref.length; i < len; i++) {
        administrationCode = ref[i];
        if (administrationCode.codes.length === 0) {
          return true;
        }
      }
      return false;
    };
    $scope.addState = function(activityState) {
      var color;
      color = $scope.taskColors[activityState].background;
      return $scope.administrationCodes.push({
        state: activityState,
        codes: [],
        label: "",
        color: color
      });
    };
    return $scope.save = function() {
      category.properties.administration_codes = $scope.administrationCodes;
      if ($scope.defaultAdminCode) {
        category.properties.default_admin_code = $scope.defaultAdminCode;
      } else {
        delete category.properties.default_admin_code;
      }
      return $uibModalInstance.close(true);
    };
  }]);

}).call(this);

//# sourceMappingURL=customer-medication-controller.js.map

'use strict';


angular.module("mhclientApp").component("jsonSiteVar", {
  templateUrl: "customer/sitevars/views/json-site-var.html",
  controller: ["SiteVar", "SiteVarsUtils", "$rootScope", function siteVarsController(SiteVar, SiteVarsUtils, $rootScope) {
    var ctrl = this;
    ctrl.saveSiteVar = function() {
      return (ctrl.siteVar.id ? SiteVar.update : SiteVar.save)(ctrl.siteVar).$promise.then(function (updatedSiteVar) {
        ctrl.siteVarForm.$setPristine()
        _.assign(ctrl.siteVar, updatedSiteVar)
        SiteVarsUtils.resetCache()
      })
    }

    SiteVarsUtils.get(ctrl.name, ctrl.default || ctrl.jsonType == "list" ? [] : {}).then ( function(siteVar){
      ctrl.siteVar = siteVar
      ctrl.siteVar.name = ctrl.name
    })

  }],
  bindings: {jsonType: "@", name: "@", default: "<", label: "@"},
});

angular.module("mhclientApp").component("siteVars", {
  templateUrl: "customer/sitevars/views/site-vars.html",
  controller: ["SiteVar", "SiteVarsUtils", "$rootScope", function siteVarsController(SiteVar, SiteVarsUtils, $rootScope) {
    var ctrl = this;
    $rootScope.busy = true;

    ctrl.options = [
      // {"label": "holidays-config", "value": "holidays-config"},
      {"label": "available-external-syncs", "value": "available-external-syncs"},
      {"label": "icanopee-config", "value": "icanopee-config"},
      {"label": "2FA", "value": "two-f-a"}
    ]

    SiteVar.query().$promise.then( function(siteVars){
      ctrl.initDone = true;
      ctrl.sitevarByName = {};
      _.forEach(siteVars, function(siteVar) {ctrl.sitevarByName[siteVar.name] = siteVar})
      $rootScope.busy = false;

    ctrl.saveSiteVar = function(siteVar, siteVarForm) {
      return (siteVar.id ? SiteVar.update : SiteVar.save)(siteVar).$promise.then(function (updatedSiteVar) {
        if (siteVarForm) {siteVarForm.$setPristine()}
        _.assign(siteVar, updatedSiteVar);
        SiteVarsUtils.resetCache();
      })
    }
  })


  }],
  bindings: {singleChoice: "<", readOnly: "<", required: "<", field: "<", resourceType: "<", placeHolder: "<"},
});



angular.module("mhclientApp").component("availableExternalSyncs", {
  templateUrl: "customer/sitevars/views/available-external-syncs.html",
  controller: ["$q", "$filter", "SiteVar", "SiteVarsUtils", "FormTemplateUtils", "Patient", function availableExternalSyncs($q, $filter, SiteVar, SiteVarsUtils, FormTemplateUtils, Patient) {
    var ctrl = this;
    var newAutoAccept = []

    ctrl.siteVar = ctrl.siteVar || {"name":"availableExternalSyncs", "value": []};

    ctrl.handleAutoAcceptNeeded = function (externalSync) {
      if (externalSync.auto_accept) {newAutoAccept.push(externalSync.sync_type)}
      else newAutoAccept.splice(newAutoAccept.indexOf(externalSync.sync_type), 1)
    }
    ctrl.save = function(availableExternalSyncsForm){
      return ctrl.saveSiteVar({'siteVar': ctrl.siteVar, 'siteVarForm' : availableExternalSyncsForm}).then (function (){
        if (newAutoAccept.length > 0){newAutoAccept = []; return Patient.updateAutoAcceptExternalSyncs()}
      })
    }

    ctrl.availableSignals = [{value: "stay_state_change", label: "Stay state changed", }]

    ctrl.getAvailableDocuments = function (searchText, availableExternalSync) {
      return FormTemplateUtils.getTemplatesWithCurrent().then (function(allTemplates) {
        return $filter('filter')(_.reject(_.concat(
          _.map(allTemplates, function(template) {return {label: "medicalform." + template.uid + " (" + template.current.name+ ") ", value:"medicalform.formversion."+template.uid}}),
          [
            {label: "medicalform.all", value:"medicalform.formversion.__all__"},
            {label: "ordonnance.all", value:"careplan_mgr.ordonnance.__all__"},
            {label: "ordonnance.discharge_prescription", value:"careplan_mgr.ordonnance.discharge_prescription"}
          ])
        , function(docOption) {return Object.keys(availableExternalSync.documents).includes(docOption.value)}), { label: searchText})
      })
    }
  }],
  bindings: {siteVar: "=", saveSiteVar: "&"},
});


angular.module("mhclientApp").component("holidaysConfig", {
  templateUrl: "customer/sitevars/views/holidays-config.html",
  controller: ["$q", "$filter", "SiteVar", "SiteVarsUtils", "FormTemplateUtils", function availableExternalSyncs($q, $filter, SiteVar, SiteVarsUtils, FormTemplateUtils) {
    var ctrl = this;
    $q.when(ctrl.siteVar || SiteVarsUtils.getValue("HOLIDAYS_CONFIG", {})).then(function(data){
      ctrl.siteVar = data
      ctrl.initDone = true
    })

    ctrl.availablesCountries = {
      "France": [
        "Métropole",
        "Alsace-Moselle",
        "Guadeloupe",
        "Guyane",
        "Martinique",
        "Mayotte",
        "Nouvelle-Calédonie",
        "La Réunion",
        "Polynésie Française",
        "Saint-Barthélémy",
        "Saint-Martin",
        "Wallis-et-Futuna",
      ],
      "Spain": ["AN", "AR", "AS", "CB", "CE", "CL", "CM", "CN", "CT", "EX", "GA", "IB", "MC", "MD", "ML", "NC", "PV", "RI", "VC",]
    }
  }],
  bindings: {siteVar: "=", readOnly: "<"},
});

'use strict';


angular.module("mhclientApp").component("icanopeeConfig", {
  templateUrl: "customer/sitevars/views/icanopee-config.html",
  bindings: {siteVar: "=", saveSiteVar: "&"},
  controller: ["$q", "$uibModal", "SiteVar", "GroupUtils", "Entity", "Sector", "ConfigSecret", function availableExternalSyncs($q, $uibModal, SiteVar, GroupUtils, Entity, Sector, ConfigSecret) {
    var ctrl = this;

    ctrl.removePassword = function(key){
      ConfigSecret.delete(_.find(ctrl.secrets, {key:key})).$promise.then (function(){
        _.remove(ctrl.secrets, {key: key})
      })
    }

    ctrl.setPassword = function (key) {
        return $uibModal.open({
          animation  : true,
          component: 'passwordConfigModal',
          backdrop: 'static',
          windowClass: 'modal-fullscreen',
          resolve: {
              key: function(){return key},
            }
        }).result.then(function (passwordConfig) {
          if (passwordConfig) {
            _.remove(ctrl.secrets, {key: key})
            ctrl.secrets.push(passwordConfig)
          }
        })

    }


    Sector.getSectors().then (function(sectors){
      GroupUtils.getAllGroups().then (function(groups){
        Entity.getEntities().then  (function(entities){
          ConfigSecret.query().$promise.then  (function(secrets){
            ctrl.entities = entities
            ctrl.sectors = sectors
            ctrl.groups = groups
            ctrl.secrets = secrets
          })
        })
      })
    })


    ctrl.siteVar = ctrl.siteVar || {
      "name":"ICANOPEE_CONFIG",
      "value": {
        TEST: true,
        email_regexp: "^[A-Za-z0-9._%+-]+@mhcomm\.fr$",
        DMP: {
          "s_esId": "ES_499900023351003",
          "i_timeout": 90,
          "s_dmpUrl": "https://formation3.lps2.dmp.gouv.fr/si-dmp-server/v2/services/",
          "s_healthcareSetting": "SA05",
          "esID_by_entity": {


          },
        },
        MSS: {
          "s_esId": "ES_499700259593009",
          "i_timeout": 90,
          "s_dmpUrl": "https://formation3.lps2.dmp.gouv.fr/si-dmp-server/v2/services/",
          "s_healthcareSetting": "SA05",
          "esID_by_entity": {

          },
        },
        MEDIMAIL: {
          "active": false,
          "account": "mhapp@mhcomm.fr",
          "url": "https://medimail.mipih.fr/wsdl_mss?wsdl"
        },
        ENOVACOM: {
          "active": false,
          "host": "xxxx.fr",
          "port": "25",
          "bal": "xxxx@yyyy.fr"
        },

        EsUser: {
            "HP": {
                's_name': "mhcare",
                's_given': "pypeman",
                "s_codeProfession": "10",
                "s_professionOid": "1.2.250.1.71.1.2.7",
                "s_hpSpecialityDescription": "Médecin",
                's_internalId': "pypeman",
                'i_authenticationMode': 8,
                's_codeSpecialty': 'SM26',
            },
            "PracticeLocation": {
                "s_name": "MHCOMM",
                "s_activitySector": "SA43",
                "s_practiceSettings": "HAD"

            },
        },
        group_config: {}
      }
    }

    ctrl.getSpecialities = function(code){
      if (code == "10"){return ctrl.medicalSpecialities}
      if (code == "21"){return ctrl.pharmacySpecialities}

      return []
    }

    ctrl.availableGroupConfig = [
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "10", "s_hpSpecialityDescription": "Médecin"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "21", "s_hpSpecialityDescription": "Pharmacien"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "26", "s_hpSpecialityDescription": "Audioprothésiste"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "28", "s_hpSpecialityDescription": "Opticien-Lunetier"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "31", "s_hpSpecialityDescription": "Assistant dentaire"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "32", "s_hpSpecialityDescription": "Physicien médical"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "35", "s_hpSpecialityDescription": "Aide-soignant"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "36", "s_hpSpecialityDescription": "Ambulancier"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "37", "s_hpSpecialityDescription": "Auxiliaire de puériculture"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "38", "s_hpSpecialityDescription": "Préparateur en pharmacie hospitalière"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "39", "s_hpSpecialityDescription": "Préparateur en pharmacie (officine)"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "40", "s_hpSpecialityDescription": "Chirurgien-Dentiste"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "50", "s_hpSpecialityDescription": "Sage-Femme"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "60", "s_hpSpecialityDescription": "Infirmier"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "69", "s_hpSpecialityDescription": "Infirmier psychiatrique"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "70", "s_hpSpecialityDescription": "Masseur-Kinésithérapeute"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "80", "s_hpSpecialityDescription": "Pédicure-Podologue"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "81", "s_hpSpecialityDescription": "Orthoprothésiste"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "82", "s_hpSpecialityDescription": "Podo-Orthésiste"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "83", "s_hpSpecialityDescription": "Orthopédiste-Orthésiste"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "84", "s_hpSpecialityDescription": "Oculariste"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "85", "s_hpSpecialityDescription": "Epithésiste"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "86", "s_hpSpecialityDescription": "Technicien de laboratoire médical"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "91", "s_hpSpecialityDescription": "Orthophoniste"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "92", "s_hpSpecialityDescription": "Orthoptiste"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "94", "s_hpSpecialityDescription": "Ergothérapeute"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "95", "s_hpSpecialityDescription": "Diététicien"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "96", "s_hpSpecialityDescription": "Psychomotricien"},
      {"s_professionOid": "1.2.250.1.71.1.2.7", "s_codeProfession": "98", "s_hpSpecialityDescription": "Manipulateur ERM"},
      {"s_professionOid": "1.2.250.1.71.1.2.8", "s_codeProfession": "10", "s_hpSpecialityDescription": "Médecin en formation"},
      {"s_professionOid": "1.2.250.1.71.1.2.8", "s_codeProfession": "21", "s_hpSpecialityDescription": "Pharmacien en formation"},
      {"s_professionOid": "1.2.250.1.71.1.2.8", "s_codeProfession": "40", "s_hpSpecialityDescription": "Chirurgien-Dentiste en formation"},
      {"s_professionOid": "1.2.250.1.71.1.2.8", "s_codeProfession": "50", "s_hpSpecialityDescription": "Sage-Femme en formation"},
      {"s_professionOid": "1.2.250.1.213.1.1.4.6", "s_codeProfession": "ALIM_AM", "s_hpSpecialityDescription": "Alimentation automatique à partir du Système d'Information del'Assurance Maladie"},
      {"s_professionOid": "1.2.250.1.213.1.1.4.6", "s_codeProfession": "DISPOSITIF", "s_hpSpecialityDescription": "Dispositif médical"},
      {"s_professionOid": "1.2.250.1.213.1.1.4.6", "s_codeProfession": "EXP_PATIENT", "s_hpSpecialityDescription": "Expression personnelle du patient"},
      {"s_professionOid": "1.2.250.1.213.1.1.4.6", "s_codeProfession": "SECRETARIAT_MEDICAL", "s_hpSpecialityDescription": "Secrétariat médical"},
    ]

    ctrl.pharmacySpecialities = [
      {"code": "A", "label": "Pharmacien titulaire d'officine"},
      {"code": "B", "label": "Pharmacien d'entreprise - industrie"},
      {"code": "C", "label": "Pharmacien d'entreprise - distribution"},
      {"code": "D", "label": "Pharmacien adjoint, remplaçant ou gérant"},
      {"code": "DA", "label": "Pharmacien adjoint"},
      {"code": "DM", "label": "Pharmacien mutualiste ou minier"},
      {"code": "E", "label": "Pharmacien d'Outre-Mer"},
      {"code": "EA", "label": "Pharmacien titulaire d'officine - OM"},
      {"code": "EB", "label": "Pharmacien d'entreprise - industrie - OM"},
      {"code": "EC", "label": "Pharmacien d'entreprise - distribution - OM"},
      {"code": "ED", "label": "Pharmacien adjoint - OM"},
      {"code": "EG", "label": "Pharmacien biologiste - OM"},
      {"code": "EH", "label": "Pharmacien d'établissement de santé - OM"},
      {"code": "G", "label": "Pharmacien biologiste"},
      {"code": "H", "label": "Pharmacien d'établissement de santé"},
      {"code": "M", "label": "Pharmacien militaire"},
    ]

    ctrl.medicalSpecialities = [
        {"code": "SM01", "label": "Anatomie et cytologie pathologiques (SM)"},
        {"code": "SM02", "label": "Anesthésie-réanimation (SM)"},
        {"code": "SM03", "label": "Biologie médicale (SM)"},
        {"code": "SM04", "label": "Cardiologie et maladies vasculaires (SM)"},
        {"code": "SM05", "label": "Chirurgie générale (SM)"},
        {"code": "SM06", "label": "Chirurgie maxillo-faciale (SM)"},
        {"code": "SM07", "label": "Chirurgie maxillo-faciale et stomatologie (SM)"},
        {"code": "SM08", "label": "Chirurgie orthopédique et traumatologie (SM)"},
        {"code": "SM09", "label": "Chirurgie infantile (SM)"},
        {"code": "SM10", "label": "Chirurgie plastique reconstructrice et esthétique (SM)"},
        {"code": "SM11", "label": "Chirurgie thoracique et cardio-vasculaire (SM)"},
        {"code": "SM12", "label": "Chirurgie urologique (SM)"},
        {"code": "SM13", "label": "Chirurgie vasculaire (SM)"},
        {"code": "SM14", "label": "Chirurgie viscérale et digestive (SM)"},
        {"code": "SM15", "label": "Dermatologie et vénéréologie (SM)"},
        {"code": "SM16", "label": "Endocrinologie et métabolisme (SM)"},
        {"code": "SM17", "label": "Génétique médicale (SM)"},
        {"code": "SM18", "label": "Gériatrie (SM)"},
        {"code": "SM19", "label": "Gynécologie médicale (SM)"},
        {"code": "SM20", "label": "Gynécologie-obstétrique (SM)"},
        {"code": "SM21", "label": "Hématologie (SM)"},
        {"code": "SM22", "label": "Hématologie option Maladie du sang (SM)"},
        {"code":"SM23", "label": "Hématologie option Onco-hématologie (SM)"},
        {"code":"SM24", "label": "Gastro-entérologie et hépatologie (SM)"},
        {"code":"SM25", "label": "Médecine du travail (SM)"},
        {"code":"SM26", "label": "Qualifié en médecine générale (SM)"},
        {"code":"SM27", "label": "Médecine interne (SM)"},
        {"code":"SM28", "label": "Médecine nucléaire (SM)"},
        {"code":"SM29", "label": "Médecine physique et réadaptation (SM)"},
        {"code":"SM30", "label": "Néphrologie (SM)"},
        {"code":"SM31", "label": "Neuro-chirurgie (SM)"},
        {"code":"SM32", "label": "Neurologie (SM)"},
        {"code":"SM33", "label": "Neuro-psychiatrie (SM)"},
        {"code":"SM34", "label": "ORL et chirurgie cervico-faciale (SM)"},
        {"code":"SM35", "label": "Oncologie option onco-hématologie (SM)"},
        {"code":"SM36", "label": "Oncologie option médicale (SM)"},
        {"code":"SM37", "label": "Oncologie option radiothérapie (SM)"},
        {"code":"SM38", "label": "Ophtalmologie (SM)"},
        {"code":"SM39", "label": "Oto-rhino-laryngologie (SM)"},
        {"code":"SM40", "label": "Pédiatrie (SM)"},
        {"code":"SM41", "label": "Pneumologie (SM)"},
        {"code":"SM42", "label": "Psychiatrie (SM)"},
        {"code":"SM43", "label": "Psychiatrie option enfant et adolescent (SM)"},
        {"code":"SM44", "label": "Radiodiagnostic (SM)"},
        {"code":"SM45", "label": "Radiothérapie (SM)"},
        {"code":"SM46", "label": "Médecine intensive-réanimation (SM)"},
        {"code":"SM47", "label": "Recherche médicale (SM)"},
        {"code":"SM48", "label": "Rhumatologie (SM)"},
        {"code":"SM49", "label": "Santé publique et médecine sociale (SM)"},
        {"code":"SM50", "label": "Stomatologie (SM)"},
        {"code":"SM51", "label": "Gynéco-obstétrique et Gynéco médicale option Gynéco-obst. (SM)"},
        {"code":"SM52", "label": "Gynéco-obstétrique et Gynéco médicale option Gynéco-médicale (SM)"},
        {"code":"SM53", "label": "Spécialiste en médecine générale (SM)"},
        {"code":"SM54", "label": "Médecine générale (SM)"},
        {"code":"SM55", "label": "Radiodiagnostic et radiothérapie (SM)"},
        {"code":"SM56", "label": "Chirurgie orale (SM)"},
        {"code":"SM57", "label": "Allergologie (SM)"},
        {"code":"SM58", "label": "Maladies infectieuses et tropicales (SM)"},
        {"code":"SM59", "label": "Médecine d'urgence (SM)"},
        {"code":"SM60", "label": "Médecine légale et expertises médicales (SM)"},
        {"code":"SM61", "label": "Médecine vasculaire (SM)"},
        {"code":"SM62", "label": "Endocrinologie, diabétologie, nutrition (SM)"},
        {"code":"SM63", "label": "Biologie médicale option biologie générale (SM)"},
        {"code":"SM64", "label": "Biologie médicale option médecine moléculaire, génétique et pharmacologie (SM)"},
        {"code":"SM65", "label": "Biologie médicale option hématologie et immunologie (SM)"},
        {"code":"SM66", "label": "Biologie médicale option agents infectieux (SM)"},
        {"code":"SM67", "label": "Biologie médicale option biologie de la reproduction (SM)"},
        {"code":"SM68", "label": "Chirurgie maxillo-faciale (réforme 2017) (SM)"},
        {"code":"SM69", "label": "Chirurgie pédiatrique option chirurgie viscérale pédiatrique (SM)"},
        {"code":"SM70", "label": "Chirurgie pédiatrique option orthopédie pédiatrique (SM)"},
        {"code":"SM71", "label": "Hématologie (réforme 2017) (SM)"},
        {"code":"SM72", "label": "Médecine interne et immunologie clinique (SM)"},
        {"code":"SCH01", "label": "Anatomie et cytologie pathologiques (SCH)"},
        {"code":"SCH02", "label": "Anesthésie-réanimation (SCH)"},
        {"code":"SCH03", "label": "Bactériologie-virologie, hygiène hospitalière (SCH)"},
        {"code":"SCH04", "label": "Biochimie (SCH)"},
        {"code":"SCH05", "label": "Biologie cellulaire, histologie, biologie du développement et de la reproduction (SCH)"},
        {"code":"SCH06", "label": "Biologie médicale (SCH)"},
        {"code":"SCH07", "label": "Biophysique (SCH)"},
        {"code":"SCH08", "label": "Oncologie médicale (SCH)"},
        {"code":"SCH09", "label": "Cardiologie et maladies vasculaires (SCH)"},
        {"code":"SCH10", "label": "Chirurgie générale (SCH)"},
        {"code":"SCH11", "label": "Chirurgie viscérale et digestive (SCH)"},
        {"code":"SCH12", "label": "Chirurgie infantile (SCH)"},
        {"code":"SCH13", "label": "Chirurgie maxillo-faciale (SCH)"},
        {"code":"SCH14", "label": "Chirurgie orthopédique et traumatologique (SCH)"},
        {"code":"SCH15", "label": "Chirurgie plastique reconstructrice et esthétique (SCH)"},
        {"code":"SCH16", "label": "Chirurgie thoracique et cardio-vasculaire (SCH)"},
        {"code":"SCH17", "label": "Chirurgie urologique (SCH)"},
        {"code":"SCH18", "label": "Chirurgie vasculaire (SCH)"},
        {"code":"SCH19", "label": "Dermatologie et vénéréologie (SCH)"},
        {"code":"SCH20", "label": "Endocrinologie et métabolisme (SCH)"},
        {"code":"SCH21", "label": "Santé publique (SCH)"},
        {"code":"SCH22", "label": "Explorations fonctionnelles (SCH)"},
        {"code":"SCH23", "label": "Gastro-entérologie et hépatologie (SCH)"},
        {"code":"SCH24", "label": "Génétique (SCH)"},
        {"code":"SCH25", "label": "Génétique médicale (SCH)"},
        {"code":"SCH26", "label": "Gynécologie et obstétrique (SCH)"},
        {"code":"SCH27", "label": "Hématologie biologique (SCH)"},
        {"code":"SCH28", "label": "Hématologie clinique (SCH)"},
        {"code":"SCH29", "label": "Hémobiologie-transfusion (SCH)"},
        {"code":"SCH30", "label": "Hygiène hospitalière (SCH)"},
        {"code":"SCH31", "label": "Immunologie biologique (SCH)"},
        {"code":"SCH32", "label": "Immunologie clinique (SCH)"},
        {"code":"SCH33", "label": "Maladies infectieuses, maladies tropicales (SCH)"},
        {"code":"SCH34", "label": "Médecine de la reproduction et gynécologie médicale (SCH)"},
        {"code":"SCH35", "label": "Médecine du travail (SCH)"},
        {"code":"SCH36", "label": "Médecine d'urgence (SCH)"},
        {"code":"SCH37", "label": "Médecine générale (SCH)"},
        {"code":"SCH38", "label": "Gériatrie (SCH)"},
        {"code":"SCH39", "label": "Médecine interne (SCH)"},
        {"code":"SCH40", "label": "Médecine légale (SCH)"},
        {"code":"SCH41", "label": "Médecine nucléaire (SCH)"},
        {"code":"SCH42", "label": "Médecine physique et de réadaptation (SCH)"},
        {"code":"SCH43", "label": "Néphrologie (SCH)"},
        {"code":"SCH44", "label": "Neurochirurgie (SCH)"},
        {"code":"SCH45", "label": "Neurologie (SCH)"},
        {"code":"SCH46", "label": "Odontologie polyvalente (SCH)"},
        {"code":"SCH47", "label": "Ophtalmologie (SCH)"},
        {"code":"SCH48", "label": "Oto-rhino-laryngologie (SCH)"},
        {"code":"SCH49", "label": "Parasitologie (SCH)"},
        {"code":"SCH50", "label": "Pédiatrie (SCH)"},
        {"code":"SCH51", "label": "Pharmacie polyvalente et pharmacie hospitalière (SCH)"},
        {"code":"SCH52", "label": "Pharmacologie clinique et toxicologie (SCH)"},
        {"code":"SCH53", "label": "Pneumologie (SCH)"},
        {"code":"SCH54", "label": "Psychiatrie polyvalente (SCH)"},
        {"code":"SCH55", "label": "Radiologie (SCH)"},
        {"code":"SCH56", "label": "Oncologie radiothérapique (SCH)"},
        {"code":"SCH57", "label": "Réanimation médicale (SCH)"},
        {"code":"SCH58", "label": "Rhumatologie (SCH)"},
        {"code":"SCH59", "label": "Stomatologie (SCH)"},
        {"code":"SCH60", "label": "Toxicologie et pharmacologie (SCH)"},
        {"code":"PAC00", "label": "Qualifié Praticien Adjoint Contractuel (PAC)"},
        {"code":"C01", "label": "Anatomie et cytologie pathologiques humaines (C)"},
        {"code":"C03", "label": "Anesthésie-réanimation (C)"},
        {"code":"C05", "label": "Médecine appliquée aux sports (C)"},
        {"code":"C07", "label": "Cardiologie (C)"},
        {"code":"C09", "label": "Chirurgie plastique reconstructrice et esthétique (C)"},
        {"code":"C10", "label": "Chirurgie maxillo-faciale (C)"},
        {"code":"C11", "label": "Chirurgie thoracique (C)"},
        {"code":"C12", "label": "Chirurgie orthopédique (C)"},
        {"code":"C13", "label": "Urologie (C)"},
        {"code":"C15", "label": "Dermato-vénéréologie (C)"},
        {"code":"C20", "label": "Hémobiologie (C)"},
        {"code":"C23", "label": "Gynécologie médicale et obstétrique (C)"},
        {"code":"C25", "label": "Gynécologie médicale (C)"},
        {"code":"C27", "label": "Obstétrique (C)"},
        {"code":"C29", "label": "Maladies de l'appareil digestif (C)"},
        {"code":"C30", "label": "Néphrologie (C)"},
        {"code":"C31", "label": "Médecine exotique (C)"},
        {"code":"C33", "label": "Allergologie (C)"},
        {"code":"C34", "label": "Angéiologie (C)"},
        {"code":"C35", "label": "Cancérologie (C)"},
        {"code":"C36", "label": "Diabétologie-nutrition (C)"},
        {"code":"C37", "label": "Endocrinologie (C)"},
        {"code":"C38", "label": "Maladies du sang (C)"},
        {"code":"C39", "label": "Réanimation (C)"},
        {"code":"C40", "label": "Médecine légale (C)"},
        {"code":"C41", "label": "Médecine du travail (C)"},
        {"code":"C43", "label": "Neurologie (C)"},
        {"code":"C45", "label": "Neuro-chirurgie (C)"},
        {"code":"C47", "label": "Neuro-psychiatrie (C)"},
        {"code":"C51", "label": "Pédiatrie (C)"},
        {"code":"C52", "label": "Phoniatrie (C)"},
        {"code":"C54", "label": "Pneumologie (C)"},
        {"code":"C57", "label": "Psychiatrie (C)"},
        {"code":"C58", "label": "Psychiatrie option enfant et adolescent (C)"},
        {"code":"C60", "label": "Médecine physique et réadaptation (C)"},
        {"code":"C62", "label": "Rhumatologie (C)"},
        {"code":"C68", "label": "Chirurgie pédiatrique (C)"},
        {"code":"C69", "label": "Médecine nucléaire (C)"},
        {"code":"C71", "label": "Médecine thermale (C)"},
        {"code":"C72", "label": "Génétique médicale (C)"},
        {"code":"C75", "label": "Endocrinologie maladies métaboliques (C)"},
        {"code":"C76", "label": "Orthopédie dento-maxillo-faciale (C)"},
        {"code":"C83", "label": "Chirurgie de la face et du cou (C)"},
        {"code":"CEX22", "label": "Gynécologie médicale et obstétrique (CEX)"},
        {"code":"CEX24", "label": "Gynécologie médicale (CEX)"},
        {"code":"CEX26", "label": "Obstétrique (CEX)"},
        {"code":"CEX64", "label": "Urologie (CEX)"},
        {"code":"DSM200", "label": "Addictologie (DNQ)"},
        {"code":"DSM201", "label": "Allergologie et Immunologie clinique (DNQ)"},
        {"code":"DSM202", "label": "Andrologie (DNQ)"},
        {"code":"DSM203", "label": "Biochimie hormonale et métabolique (DNQ)"},
        {"code":"DSM204", "label": "Biologie des agents infectieux (DNQ)"},
        {"code":"DSM205", "label": "Biologie moléculaire (DNQ)"},
        {"code":"DSM206", "label": "Cancérologie (DNQ)"},
        {"code":"DSM207", "label": "Chirurgie de la face et du cou (DNQ)"},
        {"code":"DSM208", "label": "Chirurgie plastique et reconstructrice (DNQ)"},
        {"code":"DSM209", "label": "Chirurgie vasculaire (DNQ)"},
        {"code":"DSM210", "label": "Cytogénétique humaine (DNQ)"},
        {"code":"DSM211", "label": "Dermatopathologie (DNQ)"},
        {"code":"DSM212", "label": "Foetopathologie (DNQ)"},
        {"code":"DSM213", "label": "Gériatrie (DNQ)"},
        {"code":"DSM214", "label": "Hématologie biologique (DNQ)"},
        {"code":"DSM215", "label": "Hématologie maladies du sang (DNQ)"},
        {"code":"DSM216", "label": "Hémobiologie-transfusion (DNQ)"},
        {"code":"DSM217", "label": "Immunologie et Immunopathologie (DNQ)"},
        {"code":"DSM218", "label": "Médecine de la reproduction (DNQ)"},
        {"code":"DSM219", "label": "Médecine du sport (DNQ)"},
        {"code":"DSM220", "label": "Médecine d'urgence (DNQ)"},
        {"code":"DSM221", "label": "Médecine légale et Expertises médicales (DNQ)"},
        {"code":"DSM222", "label": "Médecine nucléaire (DNQ)"},
        {"code":"DSM223", "label": "Médecine vasculaire (DNQ)"},
        {"code":"DSM224", "label": "Néonatalogie (DNQ)"},
        {"code":"DSM225", "label": "Neuropathologie (DNQ)"},
        {"code":"DSM226", "label": "Nutrition (DNQ)"},
        {"code":"DSM227", "label": "Orthopédie dento-maxillo-faciale (DNQ)"},
        {"code":"DSM228", "label": "Pathologie infectieuse et tropicale, clinique et biologique (DNQ)"},
        {"code":"DSM229", "label": "Pharmacocinétique et Métabolisme des médicaments (DNQ)"},
        {"code":"DSM230", "label": "Pharmacologie clinique et Evaluation des thérapeutiques (DNQ)"},
        {"code":"DSM231", "label": "Psychiatrie de l'enfant et de l'adolescent (DNQ)"},
        {"code":"DSM232", "label": "Radiopharmacie et radiobiologie (DNQ)"},
        {"code":"DSM233", "label": "Réanimation médicale (DNQ)"},
        {"code":"DSM234", "label": "Toxicologie biologique (DNQ)"},
        {"code":"DSM235", "label": "Médecine de la douleur et Médecine palliative (DNQ)"},
        {"code":"DSM236", "label": "Cancérologie, option Traitements médicaux des cancers (DNQ)"},
        {"code":"DSM237", "label": "Cancérologie, option Chirurgie cancérologique (DNQ)"},
        {"code":"DSM238", "label": "Cancérologie, option Réseaux de cancérologie (DNQ)"},
        {"code":"DSM239", "label": "Cancérologie, option Biologie cancérologie (DNQ)"},
        {"code":"DSM240", "label": "Cancérologie, option Imagerie cancérologie (DNQ)"},
        {"code":"CAPA01", "label": "Addictologie clinique (CAPA)"},
        {"code":"CAPA02", "label": "Aide médicale urgente (CAPA)"},
        {"code":"CAPA03", "label": "Allergologie (CAPA)"},
        {"code":"CAPA04", "label": "Angéiologie (CAPA)"},
        {"code":"CAPA05", "label": "Evaluation et traitement de la douleur (CAPA)"},
        {"code":"CAPA06", "label": "Gérontologie (CAPA)"},
        {"code":"CAPA07", "label": "Hydrologie et climatologie médicales (CAPA)"},
        {"code":"CAPA08", "label": "Médecine aérospatiale (CAPA)"},
        {"code":"CAPA09", "label": "Médecine de catastrophe (CAPA)"},
        {"code":"CAPA10", "label": "Médecine et biologie du sport (CAPA)"},
        {"code":"CAPA11", "label": "Médecine de santé au travail et prévention des risques professionnels (CAPA)"},
        {"code":"CAPA12", "label": "Médecine pénitentiaire (CAPA)"},
        {"code":"CAPA13", "label": "Médecine tropicale (CAPA)"},
        {"code":"CAPA14", "label": "Pratiques médico-judiciaires (CAPA)"},
        {"code":"CAPA15", "label": "Technologie transfusionnelle (CAPA)"},
        {"code":"CAPA16", "label": "Toxicomanies et alcoologies (CAPA)"}
    ]
    ctrl.healthCareSettings = [
        {"oid": "1.2.250.1.213.1.1.4.6", "code": "EXP_PATIENT", "label": "Expression personnelle du patient"},
        {"oid": "1.2.250.1.213.2.2", "code": "03", "label": "Hospitalisation complète (non compris hospitalisation de semaine)"},
        {"oid": "1.2.250.1.213.2.2", "code": "04", "label": "Hospitalisation de jour"},
        {"oid": "1.2.250.1.213.2.2", "code": "05", "label": "Hospitalisation de nuit"},
        {"oid": "1.2.250.1.213.2.2", "code": "06", "label": "Hospitalisation à domicile"},
        {"oid": "1.2.250.1.213.2.2", "code": "07", "label": "Consultations, soins externes"},
        {"oid": "1.2.250.1.213.2.2", "code": "08", "label": "Bloc opératoire (y compris obstétrical et gynécologique)"},
        {"oid": "1.2.250.1.213.2.2", "code": "09", "label": "Autres unités médico-techniques (anesthésiologie, explor fonct, rééduc et réadapt fonct, pharmacie)"},
        {"oid": "1.2.250.1.213.2.2", "code": "10", "label": "Accueil des urgences"},
        {"oid": "1.2.250.1.213.2.2", "code": "11", "label": "Hébergement complet ou internat (non compris internat de semaine)"},
        {"oid": "1.2.250.1.213.2.2", "code": "13", "label": "Semi-internat"},
        {"oid": "1.2.250.1.213.2.2", "code": "14", "label": "Externat"},
        {"oid": "1.2.250.1.213.2.2", "code": "15", "label": "Placement en famille d'accueil (strictement social)"},
        {"oid": "1.2.250.1.213.2.2", "code": "16", "label": "Prestations sur le lieu de vie (non compris placement familial)"},
        {"oid": "1.2.250.1.213.2.2", "code": "17", "label": "Internat de semaine"},
        {"oid": "1.2.250.1.213.2.2", "code": "18", "label": "Hébergement de nuit en structure éclatée"},
        {"oid": "1.2.250.1.213.2.2", "code": "19", "label": "Traitements et cures ambulatoires"},
        {"oid": "1.2.250.1.213.2.2", "code": "20", "label": "Hospitalisation de semaine"},
        {"oid": "1.2.250.1.213.2.2", "code": "21", "label": "Accueil de Jour (sans distinction entre semi-internat et externat)"},
        {"oid": "1.2.250.1.213.2.2", "code": "22", "label": "Accueil de nuit"},
        {"oid": "1.2.250.1.213.2.2", "code": "23", "label": "Anesthésie ou chirurgie ambulatoires"},
        {"oid": "1.2.250.1.213.2.2", "code": "24", "label": "Accueil et prise en charge en service d'accueil familial thérapeutique psychiatrique"},
        {"oid": "1.2.250.1.213.2.2", "code": "25", "label": "Hébergement temporaire de week-end ou de vacances"},
        {"oid": "1.2.250.1.213.2.2", "code": "26", "label": "Analyses médicales biologiques"},
        {"oid": "1.2.250.1.213.2.2", "code": "27", "label": "Accueil modulable/séquentiel"},
        {"oid": "1.2.250.1.213.2.2", "code": "28", "label": "Consultations dentaires et soins dentaires"},
        {"oid": "1.2.250.1.213.2.2", "code": "32", "label": "Radiologie (radiodiagnostic et radiothérapie), imagerie médicale"},
        {"oid": "1.2.250.1.213.2.2", "code": "33", "label": "Recherche"},
        {"oid": "1.2.250.1.213.2.2", "code": "37", "label": "Accueil et prise en charge en appartement thérapeutique"},
        {"oid": "1.2.250.1.213.2.2", "code": "38", "label": "Accueil et prise en charge en centre de postcure"},
        {"oid": "1.2.250.1.213.2.2", "code": "39", "label": "Accueil et prise en charge en centre de crise psychiatrique"},
        {"oid": "1.2.250.1.213.2.2", "code": "40", "label": "Accueil temporaire avec hébergement"},
        {"oid": "1.2.250.1.213.2.2", "code": "42", "label": "Equipe mobile de rue"},
        {"oid": "1.2.250.1.213.2.2", "code": "43", "label": "Tous modes d'accueil avec hébergement"},
        {"oid": "1.2.250.1.213.2.2", "code": "44", "label": "Accueil temporaire de jour"},
        {"oid": "1.2.250.1.213.2.2", "code": "45", "label": "Accueil temporaire (avec et sans hébergement)"},
        {"oid": "1.2.250.1.213.2.2", "code": "46", "label": "Tous modes d'accueil (avec et sans hébergement)"},
        {"oid": "1.2.250.1.213.2.2", "code": "47", "label": "Accueil de jour et accompagnement en milieu ordinaire"},
        {"oid": "1.2.250.1.213.2.2", "code": "48", "label": "Tous modes d'accueil et d'accompagnement"},
        {"oid": "1.2.250.1.213.2.2", "code": "50", "label": "Protection juridique"},
        {"oid": "1.2.250.1.213.2.2", "code": "52", "label": "Accompagnement social personnalisé"},
        {"oid": "1.2.250.1.213.2.2", "code": "60", "label": "Consultations et actes"},
        {"oid": "1.2.250.1.213.2.2", "code": "97", "label": "Autre type d'activité"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA05", "label": "Centre de santé"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA06", "label": "Autre structure du Service de santé des armées"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA07", "label": "Cabinet individuel"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA08", "label": "Cabinet de groupe"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA09", "label": "Exercice en société"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA10", "label": "Transporteur sanitaire"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA11", "label": "Entreprise d'intérim"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA12", "label": "Etablissement de soins et prévention"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA13", "label": "Prévention et soins en entreprise"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA14", "label": "Etablissement scolaire ou universitaire"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA15", "label": "PMI et Planification familiale"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA16", "label": "Etablissement pour personnes handicapées"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA17", "label": "Etablissement pour personnes âgées"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA18", "label": "Etablissement aide à la famille"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA19", "label": "Etablissement d'enseignement"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA20", "label": "Etablissement pour la protection de l'enfance"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA21", "label": "Etablissement d'hébergement et de réadaptation"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA22", "label": "Recherche"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA23", "label": "Assurance privée"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA24", "label": "Organisme de sécurité sociale"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA25", "label": "Laboratoire de biologie médicale"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA26", "label": "Ministère ou Service déconcentré"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA27", "label": "Collectivité territoriale"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA28", "label": "Association ou organisme humanitaire"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA29", "label": "Laboratoire d'analyses et de biologie médicale"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA30", "label": "Autre établissement sanitaire"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA31", "label": "Répartition et Distribution de médicaments et dispositifs médicaux"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA32", "label": "Fabrication, Exploitation et Importation de médicaments et dispositifs médicaux"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA33", "label": "Pharmacie d'officine"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA34", "label": "Centre de dialyse"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA35", "label": "Para-pharmacie"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA36", "label": "Centre anti-cancer"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA37", "label": "Centre de transfusion sanguine"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA38", "label": "Pharmacie minière"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA39", "label": "Pharmacie mutualiste"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA40", "label": "Secteur privé, praticien hospitalier temps plein"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA41", "label": "Autre établissement du domaine social ou médico-social"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA42", "label": "Appareillage médical"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA43", "label": "Secteur non défini"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA44", "label": "Recrutement ou Gestion RH"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA45", "label": "Communication, Marketing, Consulting, Média"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA46", "label": "Fabrication, Exploitation, Importation, Répartition, Distribution médicaments et dispositifs médicaux"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA47", "label": "Incendie et secours"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA48", "label": "Entreprise industrielle et tertiaire hors industrie pharmaceutique"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA49", "label": "Entité Outre-Mer"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA50", "label": "Structure d'urgence hors établissement hospitalier"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA51", "label": "Structure de coopération avec autorisation de soins"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA52", "label": "Maison de santé ou Pôle de santé"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA53", "label": "Siège administratif d'un établissement de santé"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA54", "label": "Centre de dépistage et de prévention"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA55", "label": "Laboratoire pharmaceutique préparant et délivrant des allergènes"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA56", "label": "Propharmacie"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA57", "label": "Structure de coopération avec mission de coordination de soins"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA58", "label": "Entreprise de taxis"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA59", "label": "Laboratoire de biologie médicale hors catégorie standard"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA60", "label": "Centres médicaux SNCF"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA61", "label": "Structure Dispensatrice à domicile d'Oxygène à usage médical"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA62", "label": "Ordres des professionnels de santé"},
        {"oid": "1.2.250.1.71.4.2.4", "code": "SA63", "label": "Communauté Professionnelle Territoriale de Santé"}
    ]
    ctrl.practiceSettings = [
      {"code": "AMBULATOIRE", "label": "Ambulatoire"},
      {"code": "DEPISTAGE", "label": "Dépistage"},
      {"code": "MAD", "label": "Maintien à domicile"},
      {"code": "SAD", "label": "Soins à domicile"},
      {"code": "HAD", "label": "Hospitalisation à domicile"},
      {"code": "ETABLISSEMENT", "label": "Etablissement de santé"},
      {"code": "PALLIATIF", "label": "Soins palliatifs"},
      {"code": "SAMU_SMUR", "label": "SAMU/SMUR"},
      {"code": "AMO", "label": "Organisme d'assurance maladie obligatoire"},
    ]

  }],
});


'use strict';

angular.module("mhclientApp").component("passwordConfigModal", {
  templateUrl: "customer/sitevars/views/password-config-modal.html",
  bindings: {resolve: '<', dismiss: '&', modalInstance: "<"},
  controller: ["$rootScope", "$http", "ConfigSecret", function sendMailModalCtrl($rootScope, $http, ConfigSecret){
    var ctrl = this;

    ctrl.$onInit = function () {
      ConfigSecret.query().$promise.then(function (passwords){
        ctrl.password = _.find(passwords, {key: ctrl.resolve.key}) || {key: ctrl.resolve.key}
      })
    };

    ctrl.savePassword = function (){
      ctrl.busy = true;
      (ctrl.password.id ? ConfigSecret.update : ConfigSecret.save)(ctrl.password).$promise.then( function (password) {
        ctrl.busy = false;
        ctrl.modalInstance.close(password)
      })
    }
  }],
});

'use strict';


angular.module("mhclientApp").component("twoFA", {
  templateUrl: "customer/sitevars/views/two-f-a-config.html",
  bindings: {siteVar: "=", saveSiteVar: "&"},
  controller: ["$filter", "GroupUtils", function availableExternalSyncs($filter, GroupUtils) {
    var ctrl = this;
    ctrl.siteVar = ctrl.siteVar || {"name": "2FA"}
    ctrl.siteVar.only_for_staff = true
    ctrl.availableRegions = ['AC', 'AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GT', 'GU', 'GW', 'GY', 'HK', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TA', 'TC', 'TD', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'XK', 'YE', 'YT', 'ZA', 'ZM', 'ZW']
    ctrl.availableSmsBackends = [
      "mhcomm.sms.OvhBackend",
      "mhcomm.sms.OrangeApiLightBackend",
    ]

    GroupUtils.getAllGroups().then (function(groups){
      ctrl.groups = groups
    })

    ctrl.proCategories = [
      {value: "emp" , label: $filter('translate')("emp")},
      {value: "inde", label: $filter('translate')("inde")},
      {value: "", label: "----"}
      ]


  }],
});

'use strict';

// TODO
// number_of_forms_gte
// must_be_edited
// if checktype not allowed example form image, si camnio dinamicamente
// value-check ng-init
// continue


angular.module("mhclientApp").factory('IqssUtils', ["Entity", function(Entity) {

  return {"availabeRuleOutcomes": ['1_OUI', '2_NON', '99_NA', '9_CHK', '3_TRACE']}

}]);


angular.module("mhclientApp").factory('IqssConfig', ["$resource", "MhConfig", function($resource, MhConfig) {
  var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
  return $resource("/api_rest/iqss_config/:id/:route",
      {id: '@id', extra: '@extra',
      },
      {
        'get': {headers: {'Accept': acceptHeader},},
        'query': {headers: {'Accept': acceptHeader}, isArray: true,},
        'save': {headers: {'Accept': acceptHeader}, method: 'POST',},
        'update': {headers: {'Accept': acceptHeader}, method: 'PATCH', params: {name: '@id'}},
        'exportConfig': {headers: {'Accept': acceptHeader}, method: 'PUT', isArray: true, params: {id: '@id', route: 'export_config'}}
      }
  );
}]);


angular.module("mhclientApp").factory('IqssCategory', ["$resource", "MhConfig", function($resource, MhConfig) {
  var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
  return $resource("/api_rest/iqss_categories/:id/:route",
      {id: '@id', extra: '@extra',
      },
      {
        'get': {headers: {'Accept': acceptHeader},},
        'query': {headers: {'Accept': acceptHeader}, isArray: true,},
        'save': {headers: {'Accept': acceptHeader}, method: 'POST',},
      }
  );
}]);


angular.module("mhclientApp").component("iqssConfig", {
  templateUrl: "customer/iqss/views/iqss-config.html",
  controller: ["$q", "$rootScope", "$scope", "$uibModal", "$timeout", "$http", "FormTemplateUtils", "IqssConfig", "IqssCategory", "DocumentCategory", "MeasuresTypes", "IqssUtils", "PrescUtils", "FeedUtils", "FeatureUtils", "Upload", function iqssConfigCtrl($q, $rootScope, $scope, $uibModal, $timeout, $http, FormTemplateUtils, IqssConfig, IqssCategory, DocumentCategory, MeasuresTypes, IqssUtils, PrescUtils, FeedUtils, FeatureUtils, Upload) {
    // gen cid
    var ctrl = this;
    ctrl.availabeRuleOutcomes = IqssUtils.availabeRuleOutcomes
    ctrl.addRule = function(parameter, outCome){
      var newCid = String((parseInt((_.maxBy(parameter.rules, function(rule){ return parseInt(rule.condition.cid)}) || {condition: {cid: "0"}}).condition.cid)+1))
      parameter.rules.push({outcome:outCome, condition:{cid: newCid, type:"AND", of:[]}, continue :true})
    }


    var fixConditions = function(condition, parentCid, index){
      if (!condition.cid){condition.cid = parentCid +"."+index}
      if (condition.type == "NOT"){
        if (!_.includes(["AND", "OR"], condition.of.type)){
          condition.of = {"cid": "", "type":"AND", "of":[condition.of]}
          fixConditions(condition.of, condition.cid, 1)
        }
      }
      else if (_.includes(["AND", "OR"], condition.type)){_.forEach(condition.of, function(childCondition, childIndex){fixConditions(childCondition, condition.cid, childIndex+1)})}
    }

    ctrl.newCategory = function () {
        return $uibModal.open({
          animation  : true,
          component: 'iqssCategoryCreationModal',
          backdrop: 'static',
          size: "lg",
          resolve: {alreadyExistingUids: function(){return _.map(ctrl.iqssCategories, "uid")}}
        }).result.then(function (category) {
          if (category) {
            IqssCategory.save(category).$promise.then(function(newCategory){
              ctrl.iqssCategories = _.concat(ctrl.iqssCategories, [newCategory])
            })
          }
        })
    }

    ctrl.newConfig = function () {
        return $uibModal.open({
          animation  : true,
          component: 'iqssConfigCreationModal',
          backdrop: 'static',
          size: "lg",
          resolve: {categories: function(){return ctrl.iqssCategories}, configs: function(){return ctrl.iqssConfigs}}
        }).result.then(function (config) {
          if (config) {
            IqssConfig.save(config).$promise.then(function(newConfig){
              ctrl.iqssConfigs.push(newConfig)
              ctrl.availableYears = _.map(_.uniqBy(ctrl.iqssConfigs, "year"), "year")
              ctrl.selectedYear = newConfig.year
              ctrl.computeAvailableParameters()
            })
          }
        })
    }

    ctrl.saveConfig = function(){
      $q.all(_.map(_.filter(ctrl.iqssConfigs, "configFrom.$dirty"), function(param){
        return (param.id ? IqssConfig.update : IqssConfig.save)(_.omit(param, ["configFrom"])).$promise.then(function (updatedParam) {_.assign(param, updatedParam)})
      })).then( function() {
        ctrl.queryForm.$setPristine()
      })
    }

    ctrl.exportConfig = function(){
      $rootScope.busy = true
      IqssConfig.exportConfig().$promise.then(function(config){
        var a = document.createElement('a')
        var configJson = JSON.stringify(config)
        if (window.navigator.msSaveOrOpenBlob) {
          var blob = new Blob([ configJson ], {type: 'text/json;charset=utf-8;'})
          navigator.msSaveBlob(blob, 'iqss_config.json')
        } else {
          var dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(configJson)
          a.href = dataStr
          a.target = '_blank'
          a.download = 'iqss_config.json'
          document.body.appendChild(a)
          a.click()
        }
        $rootScope.busy = false
      })
    }

    ctrl.importConfig = function(newImportFile) {
      if (newImportFile) {
        $rootScope.busy = true
        return Upload.upload({url: '/api_rest/iqss_config/bulk_import', method : "POST", file: newImportFile}).then(function(response){
          $rootScope.busy = false
          ctrl.init()
          ctrl.queryForm.$setPristine()
          ctrl.importRequested = false
        })
      }
    }

    ctrl.computeAvailableParameters = function(){
      ctrl.availableParameters = _.filter(_.filter(ctrl.iqssConfigs, {year:ctrl.selectedYear}), function(parameter){return ctrl.categoriesFilter.length == 0 || _.includes(ctrl.categoriesFilter, parameter.category)})
    }

    ctrl.init = function(){
      $rootScope.busy = true
      IqssConfig.query().$promise.then(function(iqssConfigs){
        IqssCategory.query().$promise.then(function(iqssCategories){
          FormTemplateUtils.getTemplatesWithCurrent().then (function(templates){
            DocumentCategory.query().$promise.then( function(documentCategories){
              MeasuresTypes.api.query().$promise.then( function(measureTypes){
                PrescUtils.getCategories().promise.then( function(prescCategories){
                  FeedUtils.getFeeds().then( function(feeds){
                    FeatureUtils.getAllFeatures().then( function(features){
                      ctrl.categoriesFilter = []
                      ctrl.iqssConfigs = iqssConfigs
                      ctrl.iqssCategories = iqssCategories
                      ctrl.availableYears = _.map(_.uniqBy(ctrl.iqssConfigs, "year"), "year")
                      ctrl.selectedYear = _.max(ctrl.availableYears)
                      ctrl.computeAvailableParameters()
                      _.forEach(ctrl.iqssConfigs, function(parameter){
                        _.forEach(parameter.rules, function(rule, index){
                          if (!_.includes(["AND", "OR"], rule.condition.type)){
                            rule.condition = {"cid": "" + (index+1), "type":"AND", "of":[rule.condition]}
                          }
                          if (!rule.condition.cid){rule.condition.cid = "" + (index+1)}
                          _.forEach(rule.condition.of, function(condition, index){fixConditions(condition, rule.condition.cid, index+1)})

                        })
                      })
                      ctrl.measureTypes = measureTypes
                      ctrl.documentCategories = documentCategories
                      ctrl.templates = templates
                      ctrl.availableCategories = prescCategories
                      ctrl.availableFeedFeatures = _.map(_.uniqBy(feeds, "feature"), function(feed){ return _.find(features, {id:feed.feature})})
                      ctrl.initDone = true
                      $rootScope.busy = false
      })})})})})})})})
    }

    ctrl.init()
    $scope.$on('getDocumentCategories', function (event){event.data = _.map(ctrl.documentCategories, function(docCategory){return {label: docCategory.label, value: docCategory.uid}}); event.stopPropagation()})
    $scope.$on('getMeasures', function (event){event.data = _.map(ctrl.measureTypes, function(measure){ return {label: measure.metadata.LABEL, value: measure.uid}}); event.stopPropagation()})
    $scope.$on('getTemplates', function (event){event.data = _.map(ctrl.templates, function(template){return {label: template.uid, value: template.uid, current: template.current}}); event.stopPropagation()})
    $scope.$on('getIqssCriterions', function (event, sourceCriterion){event.data = _.map(_.filter(ctrl.iqssConfigs,  {year:ctrl.selectedYear}), function(IqssConfig){ return {label: IqssConfig.criterion, value: IqssConfig.criterion}}); event.stopPropagation()})
    $scope.$on('getAvailableCategories', function (event){event.data = _.map(ctrl.availableCategories, function(category){ return {label: category.label, value: category.name}}); event.stopPropagation()})
    $scope.$on('getAvailableFeedFeatures', function (event){event.data = _.map(ctrl.availableFeedFeatures, function(feed){ return {label: feed.description, value: feed.name}}); event.stopPropagation()})

  }],
});


angular.module("mhclientApp").component("iqssCondition", {
  templateUrl: "customer/iqss/views/iqss-condition.html",
  bindings: {condition: "=", isRoot: "<?", iqssConfig: "<?", configForm: "<"},
  controller: ["$scope", "$q", "$filter", "DocumentCategory", function iqssConditionCtrl($scope, $q, $filter, DocumentCategory) {
    var ctrl = this;

    var extractConditions = function(node, baseCid){
      if (_.includes(["AND", "OR"], node.type)){return [].concat.apply([node.cid], _.map(node.of, function(node) {return extractConditions(node, baseCid)}))}
      else if (node.type == "NOT") { return [node.cid, node.of.cid]}
      else {return [node.cid]}
    }

    ctrl.addCondition = function(conditionTpe){
        var newCid = ctrl.condition.cid + "." + (parseInt((_.last(ctrl.condition.of) || {cid: "0"}).cid.split(".").pop())+1)
        if (_.includes(["AND", "OR"], conditionTpe)){ctrl.condition.of.push({cid: newCid, type:conditionTpe, of:[]})}
        else if (conditionTpe == "NOT"){ctrl.condition.of.push({cid: newCid, type:conditionTpe, of:{cid: newCid +".1" ,type: "AND", of:[]}})}
        else{ctrl.condition.of.push({cid: newCid, type:conditionTpe})}
    }
    if (ctrl.isRoot){
      $scope.$on('getAvailableCriterions', function (event){
          event.data = _.pull($scope.$emit("getIqssCriterions", ctrl.iqssConfig.criterion).data, ctrl.iqssConfig.criterion);
          event.stopPropagation()
      })

      $scope.$on('getAvailableRefs', function (event, baseCid){
        var baseIds = baseCid.split('.');
        event.data = _.filter([].concat.apply([], _.map(ctrl.condition.of, function(child) {return extractConditions(child, baseCid)})), function(ref){
          var nodeIds = ref.split('.');
          for (var i = 0; i < _.max([nodeIds.length, baseIds.length]); i++) {
            if (parseInt(baseIds[i]) < parseInt(nodeIds[i])){return false}
            if (parseInt(baseIds[i]) > parseInt(nodeIds[i])){return true}
          }
          return false
        })
        event.stopPropagation()
      })
    }

    ctrl.computeChoice = function(value, choices){
      var choice = _.find(choices, {value:value})
      if (choice){return choice.label}
      else{
        ctrl.condition.choiceNotFound = true
        return ["<span class='text-danger'>", $filter('translate')('Not found'), value, "</span>"].join(" ")

      }

    }

    ctrl.availableConditions = [
      "DEFAULT", "AND", "OR", "NOT", "FORM", "STAY_DATA", "IMAGE_DOCUMENT", "MEASURE", "RELATIVE", "CHECKLIST" ,
      "STAY_DURATION", "MEDICAL_ENVIRONMENT", "SOCIAL_ENVIRONMENT", "PRESCRIPTION", "SEQUENCE", "PSP", "STAY_HISTORY", "MESSAGE"]

    ctrl.customFields = {
        "STAY_DATA":[
          {type: "dictCheck", key: "criterion"},],
        "MEASURE": [
          {type: "choices", key: "mtype_uid", placeholder: "Select measure", choices: function(){return $scope.$emit("getMeasures").data}},
          {type: "timeDelta", key: "time"},
          {type: "valueCheck", key: "value_criterion"},],
        "FORM": [
          {type: "choices", key: "template_uid", placeholder: "Select template", choices: function(){return $scope.$emit("getTemplates").data}},
          {type: "timeDelta", key: "time"},
          {type: "dictCheck", key: "data_criterion", relatedChoice: "template_uid"},
          {type: "integer", label: "number_of_forms_gte", key: "number_of_forms_gte", min: 1},],
        "IMAGE_DOCUMENT": [
          {type: "choices", key: "category_uid", placeholder: "Select category", choices: function(){return $scope.$emit("getDocumentCategories").data}},
          {type: "timeDelta", key: "time"},
          {type: "dictCheck", key: "criterion"},],
        "RELATIVE": [
          {type: "choices", key: "iqss_uid", placeholder: "Select criterion", choices: function(){return $scope.$emit("getAvailableCriterions").data}},
          {type: "iqssCheck", key: "iqss_value"},],
        "PRESCRIPTION": [
          {type: "choices", key: "category", placeholder: "Select category", choices: function(){return $scope.$emit("getAvailableCategories").data}},
          {type: "timeDelta", key: "time"},
          {type: "dictCheck", key: "criterion"},
          {type: "operatorSelector", key: "ordo_state", choices:['ANY', 'ACTIVE_NOW', 'ACTIVE_ANYTIME', 'DRAFT']},
          {type: "checkBox", key: "dispensable", label: "dispensable"},],
        "CHECKLIST": [
          {type: "text", required: true, key: "uid",},],
        "STAY_DURATION": [
          {type: "integer", required: true, key: "duration",},],
        "MEDICAL_ENVIRONMENT": [
          {type: "checkBox", key: "only_liberals", label: "only_liberals"},
          {type: "checkBox", key: "remove_auto_assigned", label: "remove_auto_assigned"},],
        "SOCIAL_ENVIRONMENT": [
          {type: "operatorSelector", key: "person_type", choices: ['TRUSTED_PERSON', 'NOTIFY_PERSON']},],
        "SEQUENCE": [
          {type: "timeDelta", key: "time"},
          {type: "dictCheck", key: "criterion"},],
        "PSP": [
          {type: "timeDelta", key: "time"},
          {type: "dictCheck", key: "criterion"},],
        "STAY_HISTORY": [
          {type: "timeDelta", key: "time"},
          {type: "dictCheck", key: "criterion"},],
        "MESSAGE": [
          {type: "choices", key: "feed_uid", placeholder: "Select feature", choices: function(){return $scope.$emit("getAvailableFeedFeatures").data}},
          {type: "timeDelta", key: "time"},
          {type: "dictCheck", key: "criterion"},],
      }[ctrl.condition.type] || []
  }],
});


angular.module("mhclientApp").component("iqssDictCheck", {
  templateUrl: "customer/iqss/views/iqss-dict-check.html",
  bindings: {dCheck: "=", conditionKey: "<", configForm: "<", conditionType: "@"},
  controller: ["$rootScope", "$scope", "MedFormsUtils", function iqssDictCheckCtrl($rootScope, $scope, MedFormsUtils) {
    var ctrl = this;
    var baseOperators = ["EXISTS", "NOT_EMPTY", "KEY", "AND", "OR", "NOT", "ANY", "ALL"]
    var operatorByBaseType = {
      "FORM": _.difference(baseOperators, ["NOT_EMPTY"]), // custom form IMAGE
      "STAY_DATA": _.difference(baseOperators, ["NOT_EMPTY", "EXISTS"]),
      "IMAGE_DOCUMENT": _.difference(baseOperators, ["NOT_EMPTY", "KEY"]),
      "MEASURE": _.difference(baseOperators, ["NOT_EMPTY", "KEY"]),
      "DEFAULT": baseOperators,
    }

    ctrl.operatorChange = function(operator){
     if (operator == "NOT"){ ctrl.dCheck.of = {}}
     if (_.includes(["AND", "OR"], operator)){ctrl.dCheck.of = []}
    }

    ctrl.$onChanges = function(changes) {
      if (changes.conditionKey) {
          ctrl.dCheck = ctrl.dCheck || {}
          ctrl.availableOperators = operatorByBaseType[ctrl.conditionType] || baseOperators
          if (ctrl.conditionType == "FORM"){
            var template = _.find($scope.$emit("getTemplates").data, {value: ctrl.conditionKey})
            if (!template){ ctrl.keyStructured = false; return }
            if (template.current.content_type == "STRUCTURED"){
                $rootScope.busy = true
                MedFormsUtils.extractVersionDynamicFields(template.current).then( function(availableKeysForCondition){
                    $rootScope.busy = false
                    ctrl.availableKeysForCondition = availableKeysForCondition
                    ctrl.keyStructured = true
                    if (!_.find(ctrl.availableKeysForCondition, {key: ctrl.dCheck.key_path})) {delete ctrl.dCheck.key_path}
                  })
            } else {
                ctrl.availableKeysForCondition = [];
                ctrl.keyStructured = false;
                if (template.current.content_type == "IMG") {ctrl.availableOperators = _.difference(baseOperators, ["KEY"]);}
            }
          }
          if (ctrl.conditionType == "STAY_DATA"){
            MedFormsUtils.staticDataDefinition().then (function(staticData){
                ctrl.keyStructured = true
                ctrl.availableKeysForCondition = _.concat(_.uniqBy(_.map(_.filter(staticData, function(field){return _.startsWith(field.key, "staticData.stay.")}), function(field){
                      return {key: field.key.replace(/^(staticData.stay.)+/, '').split('|')[0], label:field.label.replace(/^(Sejour.)+/, '')}
                  }), "key"),
                  []
                )
            })
          }
      }
    }
  }],
});

angular.module("mhclientApp").component("iqssTimeDelta", {
  templateUrl: "customer/iqss/views/iqss-time-delta.html",
  bindings: {timeDelta: "=", cid: "<", configForm: "<",},
  controller: function iqssDictCheckCtrl() {
    var ctrl = this;
    ctrl.availableValues = ["ALL_TIME", "BEFORE", "AFTER", "BETWEEN"]
  },
});

angular.module("mhclientApp").component("iqssICheck", {
  templateUrl: "customer/iqss/views/iqss-i-check.html",
  bindings: {check: "=", configForm: "<",},
  controller: ["IqssUtils", function iqssDictCheckCtrl(IqssUtils) {
    var ctrl = this;
    ctrl.availableTypes = ["VALUE", "NOT"]
    ctrl.availabeRuleOutcomes = IqssUtils.availabeRuleOutcomes
  }],
});

angular.module("mhclientApp").component("iqssTime", {
  templateUrl: "customer/iqss/views/iqss-time.html",
  bindings: {time: "=", cid: "<", configForm: "<",},
  controller: ["$scope", function iqssDictCheckCtrl($scope) {
    var ctrl = this;
    ctrl.availableValues = ["STAY_CREATION", "STAY_START", "STAY_END", "RELDATE"]
    ctrl.fetchConditions = function(){console.log($scope.$emit("getAvailableRefs", ctrl.cid).data); return $scope.$emit("getAvailableRefs", ctrl.cid).data}
  }],
});

angular.module("mhclientApp").component("iqssValueCheck", {
  templateUrl: "customer/iqss/views/iqss-value-check.html",
  bindings: {criterion: "=", configForm: "<",},
  controller: ["$uibModal", function iqssDictCheckCtrl($uibModal) {
    var ctrl = this;
    ctrl.availableValues = ["EXISTS", "NOT_EMPTY", "NOT", "IN", "SUPERIOR_TO", "CONTACT_PERSON_INFO"]
    ctrl.editValues = function () {
        return $uibModal.open({
          animation  : true,
          component: 'jsonListEditorModal',
          backdrop: 'static',
          resolve: {value: function(){return _.cloneDeep(ctrl.criterion.values)}}
        }).result.then(function (newValue) {ctrl.criterion.values = newValue; ctrl.configForm.$setDirty()})
    }
  }],
});


angular.module("mhclientApp").component("jsonListEditorModal", {
  templateUrl: "customer/iqss/views/json-list-editor-modal.html",
  bindings: {resolve: '<', dismiss: '&', close: "&", modalInstance: "<"},
  controller: ["$rootScope", "$http", "ConfigSecret", function sendMailModalCtrl($rootScope, $http, ConfigSecret){
    var ctrl = this;
    ctrl.$onInit = function () {ctrl.value = ctrl.resolve.value || []};
    ctrl.typeOf = function(value){ return value == null ? 'null' : typeof(value)}
  }],
});


angular.module("mhclientApp").component("iqssCategoryCreationModal", {
  templateUrl: "customer/iqss/views/iqss-category-creation-modal.html",
  bindings: {resolve: '<', dismiss: '&', close: '&'},
  controller: function iqssCategoryCreationModalCtrl(){
    var ctrl = this;
    ctrl.$onInit = function () {ctrl.alreadyExistingUids = ctrl.resolve.alreadyExistingUids};
  },
});

angular.module("mhclientApp").component("iqssConfigCreationModal", {
  templateUrl: "customer/iqss/views/iqss-config-creation-modal.html",
  bindings: {resolve: '<', dismiss: '&', close: '&'},
  controller: function iqssConfigCreationModalCtrl(){
    var ctrl = this;
    ctrl.$onInit = function () {
      ctrl.categories = ctrl.resolve.categories
      ctrl.alreadyExistingCriterions = _.map(ctrl.resolve.configs, "criterion")
    };
  },
});

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:MenuCtrl
    * @description
    * # MenuCtrl
    * Provider of MenuCtrl
   */
  angular.module("mhclientApp").controller('MenuModalCtrl', ["$scope", "$rootScope", "$state", "$filter", "$uibModalInstance", "dndDropedMenu", "updateMenu", "openExternalLink", function($scope, $rootScope, $state, $filter, $uibModalInstance, dndDropedMenu, updateMenu, openExternalLink) {
    $scope.year = $filter('translate')('year');
    $scope.years = $filter('translate')('years');
    $scope.modalMenu = true;
    $scope.dndDropedMenu = dndDropedMenu;
    $scope.updateMenu = updateMenu;
    $scope.openExternalLink = openExternalLink;
    return $scope.closeMenu = function() {
      return $uibModalInstance.close(false);
    };
  }]);

  angular.module("mhclientApp").controller('MenuCtrl', ["$scope", "$filter", "$window", "User", "$rootScope", "Patient", "MHboxSettings", "SiteVarsUtils", function($scope, $filter, $window, User, $rootScope, Patient, MHboxSettings, SiteVarsUtils) {
    $scope.current_screen = "features";
    $scope.default_screen = $scope.current_screen;
    $scope.init_box_info = function() {
      return MHboxSettings.get_status().$promise.then(function(data) {
        return $scope.box_data = data;
      });
    };
    $window.reload_box_info = $scope.init_box_info;
    $scope.handleConfigPassword = function(password) {
      if (password === "mmmmmm") {
        $window.mgapp.close_keyboard();
        return $scope.config_password = true;
      }
    };
    $scope.config_features = [
      {
        "metadata": {},
        "camera": false,
        "camera_category": null,
        "label": $filter('translate')('RESET_BOX'),
        "name": "reset"
      }, {
        "metadata": {},
        "camera": false,
        "camera_category": null,
        "label": $filter('translate')('NET_CONFIG'),
        "name": "SCR_NET_CONF"
      }, {
        "metadata": {},
        "camera": false,
        "camera_category": null,
        "label": $filter('translate')('WIFI_CONFIG'),
        "name": "SCR_WIFI_LIST"
      }
    ];
    $scope.logOut = function() {
      return window.mgapp.request_log_out();
    };
    $scope.goLogin = function() {
      return $scope.goTo({
        "metadata": {
          "route": "mhbox-login"
        },
        "camera": false,
        "camera_category": null
      });
    };
    $scope.goTo = function(feature) {
      return window.mgapp.go_to(angular.toJson(feature));
    };
    $scope.close = function() {
      return window.mgapp.quit_view();
    };
    $scope.switch_patient = function() {
      return window.mgapp.switch_patient();
    };
    if ($rootScope.currentPatient || $rootScope.user) {
      SiteVarsUtils.get('PDS_STAY_LIST', false).then(function(pdsStayList) {
        return $scope.showMedPlan = pdsStayList.value;
      });
      Patient.query().$promise.then(function(patients) {
        return $scope.patients_count = patients.length;
      });
      if ($scope.currentPatient) {
        $scope.current_screen = "features";
      } else {
        $scope.current_screen = "boxinfo";
      }
      $scope.default_screen = $scope.current_screen;
    } else {
      $scope.current_screen = "boxinfo";
      $scope.default_screen = $scope.current_screen;
    }
    $scope.initializeMenu = function(page) {
      if (page && page.length > 0) {
        $scope.current_screen = page;
      } else if ($rootScope.currentPatient) {
        $scope.current_screen = "features";
      }
      return $scope.$apply();
    };
    return $window.initialize_menu = $scope.initializeMenu;
  }]);

}).call(this);

//# sourceMappingURL=menu-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:MenuUtils
    * @description
    * # MenuUtils
    * Provider of MenuUtils
   */
  angular.module("mhclientApp").factory('MenuUtils', ["$q", "$rootScope", "$filter", "FeatureUtils", function($q, $rootScope, $filter, FeatureUtils) {
    var computeMenus, computePatientShortCuts, computeUserShortCuts, configFeature, dashboardFeature, faqFeature, formatMenuInColumns, getDefaultUserShortCuts, get_free_colum, monoPatFilter, multiPatFilter, orderChild, orderFeaturesByType, pdfFeature, service, stayListFeature;
    orderFeaturesByType = function(feature) {
      if (feature.feature_type === "S") {
        return 0;
      } else if (feature.feature_type === "L") {
        return 10000;
      } else if (feature.feature_type === "N") {
        return 1000;
      }
    };
    orderChild = function(feature) {
      return -feature.childs.length;
    };
    get_free_colum = function(formated_features) {
      var column, j, len, selected_column;
      selected_column = null;
      for (j = 0, len = formated_features.length; j < len; j++) {
        column = formated_features[j];
        if ((selected_column == null) || column.items < selected_column.items) {
          selected_column = column;
        }
      }
      return selected_column;
    };
    computePatientShortCuts = function(user, features) {
      var allFeatures, feature, featureName, j, len, ref, shortCuts;
      shortCuts = [];
      if (user.is_superuser || _.intersection(["SRV_usr", "SRV_grp", "SRV_mhb", "FORM_EDITOR"], user.group.features).length > 0) {
        allFeatures = features.concat([dashboardFeature, stayListFeature, configFeature, faqFeature, pdfFeature]);
      } else {
        allFeatures = features.concat([dashboardFeature, stayListFeature, faqFeature, pdfFeature]);
      }
      ref = _.uniq(user.config.patient_shortcuts || []);
      for (j = 0, len = ref.length; j < len; j++) {
        featureName = ref[j];
        feature = _.find(allFeatures, {
          name: featureName
        });
        if (feature) {
          shortCuts.push(feature);
        }
      }
      return shortCuts;
    };
    getDefaultUserShortCuts = function(userFeatures) {
      return _.filter(userFeatures, function(feature) {
        return (feature.metadata.FLAGS != null) && _.includes(feature.metadata.FLAGS, "MULTI_PAT") && (feature.metadata.route != null) && feature.metadata.route.indexOf("patient.stay.message") === -1;
      });
    };
    computeUserShortCuts = function(user, features) {
      var allFeatures, feature, featureName, j, len, ref, shortCuts;
      shortCuts = [];
      if (user.is_superuser || _.intersection(["SRV_usr", "SRV_grp", "SRV_mhb", "FORM_EDITOR"], user.group.features).length > 0) {
        allFeatures = features.concat([dashboardFeature, stayListFeature, configFeature, faqFeature, pdfFeature]);
      } else {
        allFeatures = features.concat([dashboardFeature, stayListFeature, faqFeature, pdfFeature]);
      }
      ref = _.uniq(user.config.user_shortcuts || []);
      for (j = 0, len = ref.length; j < len; j++) {
        featureName = ref[j];
        feature = _.find(allFeatures, {
          name: featureName
        });
        if (feature) {
          shortCuts.push(feature);
        }
      }
      return shortCuts;
    };
    multiPatFilter = function(feature) {
      if ((feature.metadata.FLAGS != null) && _.includes(feature.metadata.FLAGS, "MULTI_PAT")) {
        return true;
      }
      if ((feature.metadata.FLAGS != null) && _.includes(feature.metadata.FLAGS, "MULTI_AND_MONO_PAT")) {
        return true;
      }
      return false;
    };
    monoPatFilter = function(feature) {
      if ((feature.metadata.FLAGS != null) && _.includes(feature.metadata.FLAGS, "MULTI_PAT")) {
        return false;
      }
      return true;
    };
    formatMenuInColumns = function(menu, cols, featureFilter) {
      var childs, formatedFeatures, i, j, k, len, ref, ref1, root_feature, selected_column;
      formatedFeatures = [];
      for (i = j = 0, ref = cols; j < ref; i = j += 1) {
        formatedFeatures.push({
          features: [],
          items: 0
        });
      }
      ref1 = $filter('orderBy')(menu, orderChild);
      for (k = 0, len = ref1.length; k < len; k++) {
        root_feature = ref1[k];
        childs = root_feature.childs;
        if (featureFilter && childs) {
          childs = _.filter(childs, featureFilter);
        }
        if (childs && childs.length > 0) {
          selected_column = get_free_colum(formatedFeatures);
          selected_column.items += childs.length + 1;
          selected_column.features.push(root_feature);
        }
      }
      return formatedFeatures;
    };
    configFeature = {
      name: "CUSTOM_ADM",
      metadata: {
        route: "user.admin",
        "class": "glyphicon-cog"
      },
      label: "CONFIG_MENU"
    };
    dashboardFeature = {
      name: "CUSTOM_DASHBOARD",
      metadata: {
        route: "user.patient.stay.dashboard",
        "class": "glyphicon glyphicon-time"
      },
      label: "HISTORY"
    };
    stayListFeature = {
      name: "CUSTOM_STAY_LIST",
      metadata: {
        route: "user.stay-list",
        "class": "glyphicon-list-alt"
      },
      label: "PATIENT_LIST"
    };
    faqFeature = {
      name: "CUSTOM_FAQ",
      metadata: {
        route: "user.faq",
        iconname: "drawer"
      },
      label: "FAQ"
    };
    pdfFeature = {
      name: "CUSTOM_PDF_PRINT",
      metadata: {
        route: "user.export_pdf",
        "class": "glyphicon-print"
      },
      label: "PRINT_ARCHIVE"
    };
    computeMenus = function(user, userFeatures) {
      var customPatientFeatures, customUserFeatures, externalLinksFeatures, feature, groupedFeaturesByParent, j, k, len, len1, menus, multipatientFeatures, noParentFeatures, ref, userFeaturesById;
      userFeaturesById = {};
      userFeatures = $filter('orderBy')(userFeatures, [orderFeaturesByType, "weight", "feature_order"]);
      groupedFeaturesByParent = [];
      if ($rootScope.mh_config.platform === "mhsi") {
        if (user.is_superuser || _.intersection(["SRV_usr", "SRV_grp", "SRV_mhb", "FORM_EDITOR"], user.group.features).length > 0) {
          customPatientFeatures = [stayListFeature, configFeature];
          customUserFeatures = [stayListFeature, configFeature, faqFeature, pdfFeature];
        } else {
          customPatientFeatures = [stayListFeature];
          customUserFeatures = [stayListFeature, faqFeature, pdfFeature];
        }
        noParentFeatures = [dashboardFeature];
      } else {
        noParentFeatures = [];
        customUserFeatures = [];
        customPatientFeatures = [];
      }
      multipatientFeatures = [];
      externalLinksFeatures = [];
      for (j = 0, len = userFeatures.length; j < len; j++) {
        feature = userFeatures[j];
        if (feature.metadata.devices != null) {
          if ($rootScope.mh_config.platform === "mgapp" && !_.includes(feature.metadata.devices, "MHB")) {
            continue;
          } else if ($rootScope.mh_config.platform === "mhsi" && !_.includes(feature.metadata.devices, "MHP")) {
            continue;
          }
        }
        if (feature.name === "ADM") {
          user.configFeature = true;
          continue;
        }
        if (!user.entity && feature.metadata.disable_for_multientity_users) {
          continue;
        }
        if (_.includes(["L", "N"], feature.feature_type)) {
          if (!(feature.feature_type === "L" && (feature.metadata.route == null)) || ($rootScope.mh_config.platform === "mgapp" && ((ref = feature.name) === "SVM" || ref === "SVA"))) {
            feature.childs = [];
            userFeaturesById[feature.id] = feature;
          }
        }
      }
      for (k = 0, len1 = userFeatures.length; k < len1; k++) {
        feature = userFeatures[k];
        if (userFeaturesById[feature.id] != null) {
          if (feature.parent && (userFeaturesById[feature.parent] != null)) {
            userFeaturesById[feature.parent].childs.push(feature);
          } else {
            if ((feature.metadata.FLAGS != null) && _.includes(feature.metadata.FLAGS, "MULTI_PAT")) {
              multipatientFeatures.push(feature);
            } else {
              if (feature.metadata.route) {
                noParentFeatures.push(feature);
              } else if (feature.name.indexOf("MH_WEB_VIEWER") !== -1) {
                externalLinksFeatures.push(feature);
              } else if (feature.name.indexOf("MH_WEB_VIEWER_CYBERLAB") !== -1) {
                customPatientFeatures.push(feature);
              } else {
                groupedFeaturesByParent.push(feature);
              }
            }
          }
        }
      }
      menus = {
        patient: {
          groupedFeaturesByParent: groupedFeaturesByParent,
          alertCount: 0,
          isPatient: true,
          newMenu: {
            shortCuts: computePatientShortCuts(user, userFeatures),
            main: formatMenuInColumns(groupedFeaturesByParent, ($rootScope.mh_config.platform === "mgapp" ? 3 : 4), monoPatFilter),
            featureFilter: monoPatFilter,
            other: noParentFeatures.concat(customPatientFeatures.concat(externalLinksFeatures))
          },
          oldMenu: {
            topFeatures: noParentFeatures,
            main: groupedFeaturesByParent,
            globalFeatures: customUserFeatures.concat(externalLinksFeatures)
          }
        },
        user: {
          alertCount: 0,
          isPatient: false,
          newMenu: {
            shortCuts: computeUserShortCuts(user, userFeatures),
            main: formatMenuInColumns(groupedFeaturesByParent, ($rootScope.mh_config.platform === "mgapp" ? 3 : 4), multiPatFilter),
            featureFilter: multiPatFilter,
            other: multipatientFeatures.concat(customUserFeatures.concat(externalLinksFeatures))
          },
          oldMenu: {
            topFeatures: multipatientFeatures,
            globalFeatures: customUserFeatures.concat(externalLinksFeatures)
          }
        }
      };
      return menus;
    };
    service = {
      computeMenus: computeMenus,
      computePatientShortCuts: computePatientShortCuts,
      getDefaultUserShortCuts: getDefaultUserShortCuts
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=menu-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:AdminCtrl
    * @description
    * # AdminCtrl
    * Controller of admin interface
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('AdminCtrl', ["$scope", "$state", "$window", "$filter", function($scope, $state, $window, $filter) {
    $scope.tabs = [];
    if ($scope.user.is_superuser || indexOf.call($scope.user.group.features, "SRV_usr") >= 0) {
      $scope.tabs.push({
        sref: 'user.admin.users',
        label: "Users"
      });
    }
    if ($scope.user.is_superuser || indexOf.call($scope.user.group.features, "SRV_grp") >= 0) {
      $scope.tabs.push({
        sref: 'user.admin.groups',
        label: "GROUPS"
      });
      $scope.tabs.push({
        sref: 'user.notification-center.config',
        label: $filter('translate')("NOTIFICATION CENTER")
      });
    }
    if ($scope.user.is_superuser || indexOf.call($scope.user.group.features, "SRV_mhb") >= 0) {
      $scope.tabs.push({
        sref: 'user.admin.devices',
        label: "MHBOX"
      });
    }
    if (indexOf.call($scope.user.group.features, "FORM_EDITOR") >= 0) {
      $scope.tabs.push({
        sref: 'user.customer.medforms.form-editor',
        label: $filter('translate')("Form Editor")
      });
    }
    if ($scope.user.is_superuser) {
      $scope.tabs.push({
        sref: 'user.admin.django',
        label: $filter('translate')("DJANGO ADMIN")
      });
      $scope.tabs.push({
        sref: 'user.admin.debug',
        label: "DEBUG"
      });
      $scope.tabs.push({
        sref: 'user.cache-downloads-debug',
        label: $filter('translate')("MOBILE DEBUG")
      });
      $scope.tabs.push({
        sref: 'user.customer.synthesis-editor',
        label: "Synthesis"
      });
      $scope.tabs.push({
        sref: 'user.customer.site-vars',
        label: "Site vars"
      });
      $scope.tabs.push({
        sref: 'user.admin.medication',
        label: "Medication"
      });
      $scope.tabs.push({
        sref: 'user.admin.cda-documents',
        label: "External Sync"
      });
      $scope.tabs.push({
        sref: 'user.cert-list',
        label: "Certificates"
      });
      $scope.tabs.push({
        sref: 'user.admin.contextual-call-editor',
        label: $filter('translate')("Contextual calls")
      });
    }
    if (indexOf.call($scope.user.group.features, "PYPEMAN_DEBUG") >= 0) {
      $scope.tabs.push({
        sref: 'user.interface-interop',
        label: "Gestion des flux"
      });
    }
    if ($scope.user.group.features.indexOf("SRV_sec") !== -1) {
      $scope.tabs.push({
        sref: 'user.admin.entities',
        label: "ENTITIES"
      });
    }
    if ($scope.user.is_superuser || indexOf.call($scope.user.group.features, "SUPPORT_TOOLS") >= 0) {
      $scope.tabs.push({
        sref: 'user.support',
        label: $filter('translate')("Support Tools")
      });
    }
    $scope.tabs.forEach(function(item) {
      if ($state.includes(item.sref)) {
        $scope.activeTab = item.sref;
      }
    });
    $scope.mhsiGroupUrl = $scope.base_iframe_url + '/webfw/usr_mgr/groups/';
    $scope.mhsiDebugxUrl = $scope.base_iframe_url + "/debug/";
    return $scope.djangoAdmin = function() {
      return $window.location.href = "/webfw/admin/";
    };
  }]);

}).call(this);

//# sourceMappingURL=admin-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:ChangePasswordModalCtrl
    * @description
    * # ChangePasswordCtrl
    * Provider of ChangePasswordModalCtrl modal
   */
  angular.module("mhclientApp").controller('ChangePasswordModalCtrl', ["$scope", "$uibModalInstance", "user_detail", "User", "UserUtils", "SiteVarsUtils", "$filter", function($scope, $uibModalInstance, user_detail, User, UserUtils, SiteVarsUtils, $filter) {
    $scope.user_detail = user_detail;
    $scope.password = "";
    $scope.confirmPassword = "";
    SiteVarsUtils.get('PASSWORD_ALLOWED_PATTERN', "").then(function(sitevar) {
      return $scope.passwordPattern = sitevar.value;
    });
    SiteVarsUtils.get('PASSWORD_DEFAULT_PATTERN_INFO', $filter('translate')('PASSWORD_DEFAULT_PATTERN_INFO')).then(function(sitevar) {
      return $scope.passwordPatternInfo = sitevar.value;
    });
    $scope.generatePassword = function() {
      return UserUtils.generatePassword();
    };
    $scope.yes = function() {
      return User.changePassword({
        id: $scope.user_detail.id
      }, {
        password: $scope.password
      }).$promise.then(function() {
        return $uibModalInstance.close(true);
      });
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

  angular.module("mhclientApp").controller('ResetPasswordModalCtrl', ["$scope", "$uibModalInstance", "username", "header", "oldPassword", "UserUtils", "SiteVar", "$filter", function($scope, $uibModalInstance, username, header, oldPassword, UserUtils, SiteVar, $filter) {
    $scope.username = username;
    $scope.password = "";
    $scope.confirmPassword = "";
    $scope.oldPassword = oldPassword;
    $scope.header = header;
    SiteVar.getPasswordPolicy().$promise.then(function(data) {
      $scope.passwordPattern = data.PASSWORD_ALLOWED_PATTERN;
      return $scope.passwordPatternInfo = data.PASSWORD_DEFAULT_PATTERN_INFO;
    });
    $scope.generatePassword = function() {
      return UserUtils.generatePassword();
    };
    return $scope.submitChangePassword = function() {
      return $uibModalInstance.close({
        username: username,
        old_password: $scope.oldPassword,
        password: $scope.password
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=change-password-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:UserAdminCtrl
    * @description
    * # UserAdminCtrl
    * Controller of Users
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('UserAdminCtrl', ["$scope", "$filter", "User", "UserUtils", "SiteVarsUtils", "GroupUtils", "Sector", "Entity", "$uibModal", "$q", function($scope, $filter, User, UserUtils, SiteVarsUtils, GroupUtils, Sector, Entity, $uibModal, $q) {
    var already_init;
    $scope.nbShowItems = 20;
    $scope.incremental_items = 20;
    already_init = false;
    $scope.activityFilter = ['A'];
    $scope.siretFilters = [];
    $scope.addMoreItems = function() {
      if (($scope.users != null) && $scope.nbShowItems < $scope.users.length) {
        return $scope.nbShowItems = $scope.nbShowItems + $scope.incremental_items;
      }
    };
    GroupUtils.getAllGroups().then(function(groups) {
      if ($scope.user.is_superuser || $scope.user.group.short_name === 'ADM') {
        return $scope.groups = groups;
      } else {
        return $scope.groups = _.filter(groups, function(group) {
          return group.short_name !== 'ADM';
        });
      }
    });
    $scope.sectorActiveFilters = [];
    $scope.sectorFilterChange = function(sector) {
      if (sector.checked) {
        return $scope.sectorActiveFilters.push(sector.id);
      } else {
        return $scope.sectorActiveFilters.splice($scope.sectorActiveFilters.indexOf(sector.id), 1);
      }
    };
    $scope.groupActiveFilters = [];
    $scope.groupFilterChange = function(group) {
      if (group.checked) {
        return $scope.groupActiveFilters.push(group.id);
      } else {
        return $scope.groupActiveFilters.splice($scope.groupActiveFilters.indexOf(group.id), 1);
      }
    };
    $scope.activityFilterChange = function(activitychecker) {
      if (activitychecker) {
        return $scope.activityFilter = [];
      } else {
        return $scope.activityFilter = ['A'];
      }
    };
    $scope.entityActiveFilters = [];
    $scope.entityFilterChange = function(entity) {
      if (entity.checked) {
        $scope.entityActiveFilters.push(entity.id);
      } else {
        $scope.entityActiveFilters.splice($scope.entityActiveFilters.indexOf(entity.id), 1);
      }
      if ($scope.entityActiveFilters.length > 0) {
        return _.map($scope.sectors, function(sector) {
          if (_.includes($scope.entityActiveFilters, sector.entity)) {
            return sector.hidden = false;
          } else {
            sector.hidden = true;
            sector.checked = false;
            if (_.includes($scope.sectorActiveFilters, sector.id)) {
              return _.pull($scope.sectorActiveFilters, sector.id);
            }
          }
        });
      } else {
        return _.map($scope.sectors, function(sector) {
          return sector.hidden = false;
        });
      }
    };
    $scope.init = function() {
      var queries;
      if (already_init) {
        return;
      }
      already_init = true;
      SiteVarsUtils.get("ALLOW_USER_CREATION", false).then(function(allowUserCreation) {
        return $scope.canCreateUsers = allowUserCreation.value && ($scope.user.is_superuser || indexOf.call($scope.user.group.features, "SRV_usr") >= 0);
      });
      queries = [UserUtils.getUsers(true), Sector.getSectors()];
      if (!$scope.user.entity) {
        queries.push(Entity.getEntities());
      }
      return $q.all(queries).then(function(data) {
        var entities_dict, entity, i, j, k, l, len, len1, len2, len3, ref, ref1, ref2, ref3, sector, sector_dict, user;
        $scope.users = data[0];
        if ($scope.user.entity) {
          $scope.sectors = _.filter(data[1], function(sector) {
            return sector.entity === $scope.user.entity;
          });
        } else {
          $scope.sectors = data[1];
        }
        sector_dict = {};
        ref = $scope.sectors;
        for (i = 0, len = ref.length; i < len; i++) {
          sector = ref[i];
          sector_dict[sector.id] = sector;
        }
        ref1 = $scope.users;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          user = ref1[j];
          if (user.sector) {
            user.sector_name = sector_dict[user.sector].name;
          }
        }
        if (!$scope.user.entity) {
          $scope.entities = data[2];
          entities_dict = {};
          ref2 = $scope.entities;
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            entity = ref2[k];
            entities_dict[entity.id] = entity;
          }
          ref3 = $scope.users;
          for (l = 0, len3 = ref3.length; l < len3; l++) {
            user = ref3[l];
            if (user.entity in entities_dict) {
              user.entity_name = entities_dict[user.entity].sitevars.LABEL_TITLE;
            }
          }
        }
        return $scope.usersSirets = _.map(_.uniq(_.map($scope.users, function(user) {
          var ref4, ref5;
          return (ref4 = user.user_profile) != null ? (ref5 = ref4.data) != null ? ref5.siret : void 0 : void 0;
        })), function(siret) {
          return {
            siret_label: $filter("formatSiret")(siret),
            siret: siret
          };
        });
      });
    };
    $scope.changePassword = function(user) {
      return $uibModal.open({
        templateUrl: 'admin/views/change-password-template.html',
        controller: 'ChangePasswordModalCtrl',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user_detail: function() {
            return user;
          }
        }
      });
    };
    $scope.deactivateUser = function(user) {
      return User.deactivateUser({
        id: user.id
      }, {}).$promise.then(function() {
        user.state = 'D';
        return user.is_active = false;
      });
    };
    $scope.reactivateUser = function(user) {
      return User.reactivateUser({
        id: user.id
      }, {}).$promise.then(function() {
        user.state = 'A';
        return user.is_active = true;
      });
    };
    $scope.canModifyUser = UserUtils.canModifyUser;
    return $scope.init();
  }]);

}).call(this);

//# sourceMappingURL=user-admin-controller.js.map

angular.module("mhclientApp").component("contextualCallConfig", {
  templateUrl:
    "admin/components/contextual-call-editor/views/contextual-call-config.html",
  bindings: {
    schema: "<",
    config: "=",
  },
  controller: ContextualCallConfigCtrl,
});

function ContextualCallConfigCtrl($scope) {
  var ctrl = this;

  $scope.isRequired = isRequired;
  $scope.isObject = isObject;
  $scope.isEnum = isEnum;
  $scope.isInput = isInput;
  $scope.getInputTypeFromProperty = getInputTypeFromProperty;

  $scope.initConfigKey = initConfigKey;
  $scope.addPair = addPair;
  $scope.removePair = removePair;

  function isRequired(key) {
    return (ctrl.schema.required || []).indexOf(key) !== -1;
  }

  function isObject(prop) {
    return prop.type === "object";
  }

  function isEnum(prop) {
    return !!prop.enum;
  }

  function isInput(prop) {
    return !isObject(prop) && !isEnum(prop);
  }

  function getInputTypeFromProperty(prop) {
    if (prop.type === "boolean") return "checkbox";
    if (prop.type === "number" || prop.type === "integer") return "number";
    return "text";
  }

  function initConfigKey(field) {
    if (!ctrl.config[field]) {
      ctrl.config[field] = [];
    }
  }

  function addPair(field) {
    ctrl.config[field].push({ key: "", value: "" });
  }

  function removePair(field, index) {
    ctrl.config[field].splice(index, 1);
  }
}

angular.module("mhclientApp").component("contextualCallForm", {
  templateUrl:
    "admin/components/contextual-call-editor/views/contextual-call-form.html",
  bindings: {
    contextualCall: "<",
    parentFeatures: "<",
    availableConnectors: "<",
    onSubmit: "&",
    onAbort: "&",
  },
  controller: ContextualCallFormCtrl,
});

function ContextualCallFormCtrl($scope, GroupUtils) {
  var ctrl = this;

  ctrl.allGroups = [];

  $scope.remainingGroups = [];
  $scope.selectedGroups = [];
  $scope.scopes = ["MONO_PAT", "MULTI_PAT"];
  $scope.formData = {};
  $scope.contextualCallSchema = null;

  $scope.resetForm = resetForm;
  $scope.abortForm = abortForm;
  $scope.submitForm = submitForm;
  $scope.selectType = selectType;

  ctrl.$onInit = init;

  function init() {
    GroupUtils.getAllGroups().then(function (allGroups) {
      ctrl.allGroups = allGroups;
      resetForm();
    });
  };

  function selectType(type) {
    var connector = _.find(ctrl.availableConnectors, {"name": type});
    $scope.contextualCallSchema = connector.schema;
  }

  function resetForm() {
    $scope.formData = _.cloneDeep(ctrl.contextualCall);

    if (ctrl.contextualCall.contextualCallType) {
      selectType(ctrl.contextualCall.contextualCallType);
    }

    var groupPartition = _.partition(ctrl.allGroups, function (g) {
      return _.includes(ctrl.contextualCall.groups, g.id);
    });

    $scope.selectedGroups = groupPartition[0];
    $scope.remainingGroups = groupPartition[1];
  }

  function abortForm() {
    ctrl.onAbort();
  }

  function submitForm(form) {
    if (form.$invalid) {
      return;
    }
    var preprocessedData = _.cloneDeep($scope.formData);
    preprocessedData.config = _.pickBy(
      _.pick(
        preprocessedData.config,
        _.keys($scope.contextualCallSchema.properties)
      ),
      function (v) {
        return v !== undefined && v !== null && v !== "";
      }
    );
    preprocessedData.groups = _.map($scope.selectedGroups, "id");
    ctrl.onSubmit({ contextualCall: preprocessedData });
  }
}

angular.module("mhclientApp").component("contextualCallList", {
  templateUrl:
    "admin/components/contextual-call-editor/views/contextual-call-list.html",
  bindings: {
    contextualCalls: "<",
    parentFeaturesById: "<",
    onAdd: "&",
    onEdit: "&",
    onDelete: "&",
  },
  controller: ContextualCallListCtrl,
});

function ContextualCallListCtrl($scope) {
  var ctrl = this;

  $scope.deleteFeature = deleteFeature;
  $scope.editFeature = editFeature;
  $scope.addFeature = addFeature;
  $scope.getParentFeatureLabel = getParentFeatureLabel;

  function addFeature() {
    ctrl.onAdd();
  }

  function editFeature(feature) {
    ctrl.onEdit({ contextualCall: feature });
  }

  function deleteFeature(feature) {
    ctrl.onDelete({ contextualCall: feature });
  }

  function getParentFeatureLabel(feature) {
    if (feature.parent && ctrl.parentFeaturesById[feature.parent]) {
      return ctrl.parentFeaturesById[feature.parent].label;
    }
    return "-";
  }
}

angular.module("mhclientApp").component("contextualCallEditor", {
  templateUrl:
    "admin/components/contextual-call-editor/views/contextual-call-editor.html",
  bindings: {},
  controller: ContextualCallEditorCtrl,
});

function ContextualCallEditorCtrl($q, $scope, Feature, FeatureUtils) {
  var ctrl = this;

  var SERVER_FEATURE_CONTEXTUAL_CALL_COMMON_KEYS = [
    "id",
    "name",
    "description",
    "parent",
    "label",
    "short_label",
    "help_text",
    "active",
    "order",
    "groups",
  ];

  $scope.loading = true;
  $scope.nodeFeatures = [];
  $scope.contextualCallFeatures = [];
  $scope.availableConnectors = {};
  $scope.selectedFeature = null;

  $scope.setNewSelectedContextualCall = setNewSelectedContextualCall;
  $scope.resetSelectedContextualCall = resetSelectedContextualCall;
  $scope.deleteContextualCall = deleteContextualCall;
  $scope.selectContextualCall = selectContextualCall;
  $scope.submit = submit;

  ctrl.$onInit = init;

  function init() {
    $scope.loading = true;
    var promises = {
      allFeatures: Feature.api.query().$promise,
      availableConnectors: Feature.api.availableConnectors().$promise,
    };
    $q.all(promises)
      .then(function (responses) {
        $scope.nodeFeatures = _.filter(
          responses.allFeatures,
          activeNodeFeatureFilter
        );
        $scope.nodeFeaturesById = _.keyBy($scope.nodeFeatures, "id");
        $scope.contextualCallFeatures = _.map(
          _.filter(responses.allFeatures, { contextual_call: true }),
          serverFeatureToContextualCall
        );
        $scope.availableConnectors = responses.availableConnectors;
      })
      .finally(function () {
        $scope.loading = false;
      });
  }

  function activeNodeFeatureFilter(feature) {
    if (!feature.active) return false;
    return feature.feature_type == "N" || feature.feature_type == "S";
  }

  function newEmptyContextualCall() {
    return {
      name: undefined,
      description: "",
      parent: undefined,
      label: null,
      short_label: null,
      help_text: "",
      scope: undefined,
      active: true,
      order: 1000,
      contextualCallType: undefined,
      config: {}
    };
  }

  function setNewSelectedContextualCall() {
    $scope.selectedContextualCall = newEmptyContextualCall();
  }

  function objectToPairs(input) {
    return _.mapValues(input, function (value) {
      if (_.isPlainObject(value)) {
        return _.map(value, function (v, k) {
          return { key: k, value: v };
        });
      }

      return value;
    });
  }

  function pairsToObject(input) {
    return _.mapValues(input, function (value) {
      if (_.isArray(value)) {
        return _.reduce(
          value,
          function (acc, pair) {
            if (pair && pair.key && pair.value !== "") {
              acc[pair.key] = pair.value;
            }
            return acc;
          },
          {}
        );
      }
      return value;
    });
  }

  function serverFeatureToContextualCall(feature) {
    var contextualCall = _.pick(
      feature,
      SERVER_FEATURE_CONTEXTUAL_CALL_COMMON_KEYS
    );
    if (feature.metadata.FLAGS.indexOf("MULTI_PAT") != -1) {
      contextualCall.scope = "MULTI_PAT";
    } else {
      contextualCall.scope = "MONO_PAT";
    }
    contextualCall.contextualCallType = undefined;
    contextualCall.newTab = feature.metadata.newTab;
    contextualCall.config = {};
    if (feature.contextual_call_config) {
      contextualCall.contextualCallType = feature.contextual_call_config.type;
      contextualCall.config = objectToPairs(
        feature.contextual_call_config.config
      );
    }
    return contextualCall;
  }

  function getRouteForContextualCall(contextualCall) {
    if (contextualCall.scope == "MONO_PAT") {
      return "user.patient.stay.contextual-call-redirect({'featureName': '" +
        contextualCall.name +
        "', 'newTab': " + !!contextualCall.newTab + "})";
    }
    return "user.contextual-call-redirect({'featureName': '" + contextualCall.name + "', 'newTab': " + !!contextualCall.newTab + "})";
  }

  function contextualCallToServerFeature(contextualCall) {
    var feature = _.pick(
      contextualCall,
      SERVER_FEATURE_CONTEXTUAL_CALL_COMMON_KEYS
    );
    feature.feature_type = "L";
    feature.metadata = {
      devices: ["MHP"],
      iconname: "activite-internet"
    };
    feature.metadata.FLAGS = [contextualCall.scope];
    feature.metadata.newTab = !!contextualCall.newTab;
    var route = getRouteForContextualCall(contextualCall)
    feature.metadata.route = route;
    feature.metadata.angular_route = route;
    feature.contextual_call = true;
    feature.contextual_call_config = {
      type: contextualCall.contextualCallType,
      config: pairsToObject(contextualCall.config)
    };
    return feature;
  }

  function selectContextualCall(contextualCall) {
    $scope.selectedContextualCall = angular.copy(contextualCall);
  }

  function deleteContextualCall(contextualCall) {
    var feature = contextualCallToServerFeature(contextualCall);
    Feature.api.delete({ id: feature.id }).$promise.then(function () {
      FeatureUtils.resetCache();
      _.remove($scope.contextualCallFeatures, { id: feature.id });
    });
  }

  function resetSelectedContextualCall() {
    $scope.selectedContextualCall = null;
  }

  function submit(contextualCall) {
    var promise = null;
    var feature = contextualCallToServerFeature(contextualCall);
    if (feature.id) {
      promise = Feature.api.update(feature).$promise;
    } else {
      promise = Feature.api.create(feature).$promise;
    }
    promise.then(function (response) {
      FeatureUtils.resetCache();
      if (feature.id) {
        _.remove($scope.contextualCallFeatures, { id: feature.id });
      }
      $scope.contextualCallFeatures.push(
        serverFeatureToContextualCall(response)
      );
      $scope.selectedContextualCall = null;
    });
  }
}

angular.module("mhclientApp").component("contextualCallRedirect", {
  bindings: {
    featureName: "@?",
    newTab: "<?",
    context: "<?",
  },
  templateUrl:
    "admin/components/contextual-call-editor/views/contextual-call-redirect.html",
  controller: ContextualCallRedirectCtrl,
});

function ContextualCallRedirectCtrl(
  $filter,
  $rootScope,
  $stateParams,
  Feature,
  FeatureUtils
) {
  var ctrl = this;

  ctrl.$onInit = init;

  function init() {
    var context = {};

    ctrl.loading = true;

    context = ctrl.context || $stateParams;
    context = _.omit(context, ["featureName", "newTab"]);
    ctrl.newTab = ctrl.newTab || $stateParams.newTab == "true";
    ctrl.featureName = ctrl.featureName || $stateParams.featureName;

    if (!ctrl.featureName) {
      ctrl.errorMessage = $filter("translate")("MISSING_FEATURE_ERROR");
      ctrl.loading = false;
      return;
    }

    FeatureUtils.getAllFeatures().then(function (features) {
      var feature = _.find(features, { name: ctrl.featureName, contextual_call: true });

      if (!feature) {
        ctrl.errorMessage = $filter("translate")("FEATURE_NOT_FOUND_ERROR");
        ctrl.loading = false;
        return;
      }

      // Used in display message when contextual call is opened is a new tab.
      ctrl.featureLabel = feature.label

      context.id = feature.id;
      if ($rootScope.currentStay) {
        context.stay_id = $rootScope.currentStay.id;
      }

      Feature.api
        .call(context)
        .$promise.then(
          function (call) {
            executeCall(call, ctrl.newTab);
          },
          function () {
            ctrl.errorMessage = $filter("translate")("SERVER_RETURNED_ERROR");
          }
        )
        .finally(function () {
          ctrl.loading = false;
        });
    });
  }

  function executeCall(call, newTab) {
    var method = call.method.toUpperCase();
    var params = call.params || {};
    submitForm(call.target_url, method, params, newTab);
  }

  function submitForm(url, method, params, newTab) {
    var form = buildForm(url, method, params, newTab);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  function buildForm(url, method, params, newTab) {
    var form = document.createElement("form");
    form.method = method;
    form.action = url;
    form.style.display = "none";

    if (newTab) {
      form.target = "_blank";
    }

    angular.forEach(params, function (value, key) {
      form.appendChild(buildInput(key, value));
    });
    return form;
  }

  function buildInput(name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }
}

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MessageCtrl
    * @description
    * # MessageCtrl
    * Controller of Patient
   */
  angular.module('mhclientApp').controller('MessageCreateCtrl', ["$scope", "$rootScope", "$state", "$filter", "$window", "Patient", "Group", "Message", "Thread", "notify", "Upload", "Feed", "$q", "UserUtils", "StayUtils", "SiteVarsUtils", "$uibModal", function($scope, $rootScope, $state, $filter, $window, Patient, Group, Message, Thread, notify, Upload, Feed, $q, UserUtils, StayUtils, SiteVarsUtils, $uibModal) {
    var canSave, cropEmptySpace, init, ref, ref1, sendMessage, stay;
    stay = {};
    $scope.availableColors = ['black', 'blue', 'red', 'green'];
    $scope.canvasMaxHeight = 500;
    $scope.newThread = {};
    $scope.disabled = false;
    $scope.groupDataAreMandatory = false;
    $scope.params = {
      'feature': 'ORP'
    };
    $scope.selectStay = function(thread) {
      return StayUtils.selectStayByPatientModal().result.then(function(stay) {
        if (stay) {
          thread.stay = stay.id;
          return thread.patientFullName = stay.patient.full_name;
        }
      });
    };
    $scope.ressources = {
      group: Group.query,
      patient: Patient.query
    };
    $scope.grpResource = Group.query;
    $scope.mhDrawCreate = {
      'config': {
        'readonly': false,
        'action': 'draw',
        'penColor': 'black',
        'lineWidth': 1,
        'zoom': 100,
        'smooth': true,
        'tolerance': 1.00,
        'withNotes': false
      }
    };
    if ($scope.content == null) {
      $scope.content = {};
    }
    $scope.content.config = $scope.mhDrawCreate.config;
    $scope.previousState = $state.previous;
    init = function() {
      var defaultCategory, error, ref;
      if ($rootScope.currentStay) {
        stay = $rootScope.currentStay.id;
      } else {
        stay = void 0;
      }
      try {
        defaultCategory = Object.keys($scope.feature.metadata.message_categories)[0];
      } catch (error) {
        defaultCategory = "diary";
      }
      SiteVarsUtils.get('PDS_STAY_LIST', false).then(function(pdsStayList) {
        var ref;
        return $scope.groupDataAreMandatory = pdsStayList.value && ((ref = $scope.feature.name) === 'MHC_DIARY' || ref === 'MHC_MESSAGING');
      });
      $scope.newMessage = Message.resetMessage(stay, (ref = $state.params.category) != null ? ref : defaultCategory);
      $scope.initializeFeed.promise.then(function(feeds) {
        return $scope.newThread = Thread.resetThread($scope.current.feed, stay, $rootScope.currentPatient);
      });
      if ($scope.feature.name === 'MHC_TRANSMISSION' && $state.params.category === 'cible') {
        $scope.newMessage.targetNumberInput = '';
        return SiteVarsUtils.get('CIBLE_CATEGORIES_LABEL', SiteVarsUtils.defaultCibleCategoriesLabel).then(function(sitevar) {
          $scope.cibleCategories = sitevar.value;
          $scope.selectedCategory = Object.keys($scope.cibleCategories)[0];
          $scope.newMessage.targetLabel = $scope.cibleCategories[$scope.selectedCategory][0];
          return $scope.newMessage.content.data = $scope.newMessage.targetLabel.label;
        });
      }
    };
    $scope.canSave = function(message, node) {
      var notCanSave, threadId;
      if (!message) {
        return;
      } else if ($scope.groupDataAreMandatory && $scope.newThread.tmpGrpRecipients && $scope.newThread.tmpGrpRecipients.length === 0) {
        if (node) {
          threadId = node.thread instanceof Object ? node.thread.id : node.thread;
          if (!threadId) {
            return;
          }
        } else {
          return;
        }
      }
      notCanSave = (message.content.mode === "text" && (message.content.data == null)) || (message.content.mode === "text" && message.content.data === "") || (message.content.mode === "text" && typeof message.content.data !== "string") || (message.content.mode === "draw" && (message.content.data != null) && message.content.data.length === 0) || (message.content.mode === "draw" && typeof message.content.data === "string");
      return !notCanSave;
    };
    canSave = function(message) {
      var readyToSave;
      readyToSave = true;
      if ((message.content.data == null) || (message.content.data === '') || (message.content.data.length === 0)) {
        readyToSave = false;
        $scope.disabled = false;
        notify({
          classes: ["alert-warning"],
          message: $filter('translate')("EMPTY_MESSAGE")
        });
      }
      return readyToSave;
    };
    $scope.addSpace = function() {
      var height;
      height = parseInt(new String($scope.newMessage.content.size.height).split('px').shift());
      if (height < $scope.canvasMaxHeight) {
        height = height + 100;
        return $scope.newMessage.content.size.height = height;
      }
    };
    $scope.respondMessage = function(message, nodeParent) {
      var threadId;
      $scope.disabled = true;
      if (canSave(message)) {
        threadId = nodeParent.thread instanceof Object ? nodeParent.thread.id : nodeParent.thread;
        Message.setupMessage(message, threadId, nodeParent);
        if (message.category === void 0) {
          message.category = nodeParent.category;
        }
        return sendMessage(message).then(function(messageResponse) {
          var firstNode;
          if ($scope.$parent.collapsed) {
            $scope.getMessages(nodeParent);
          }
          if (nodeParent.thread instanceof Object) {
            nodeParent.thread.last_message_timestamp = messageResponse.timestamp;
          } else {
            firstNode = _.filter($scope.threads, function(node) {
              return node.parent === null && node.thread.id === threadId;
            })[0];
            firstNode.thread.last_message_timestamp = messageResponse.timestamp;
          }
          nodeParent.nodes.push(messageResponse);
          if (nodeParent.thread.messages_count != null) {
            nodeParent.thread.messages_count = nodeParent.thread.messages_count + 1;
          }
          $scope.$parent.collapsed = false;
          $scope.$parent.showCreationField = false;
          nodeParent.showCreationField = false;
          return $scope.disabled = false;
        });
      }
    };
    $scope.updateMessage = function(message, nodeParent) {
      if (!message || !nodeParent) {
        return;
      }
      nodeParent.data.eventEndDate = message.data.eventEndDate;
      return Message.api.update({
        'id': nodeParent.id
      }, {
        'data': nodeParent.data
      });
    };
    $scope.modifyMessage = function(message) {
      return Message.canBeModified(message).then(function(canBeModified) {
        var i18n, modifyModal;
        i18n = $filter('translate');
        if (!canBeModified) {
          return $uibModal.open({
            animation: true,
            templateUrl: 'core/views/modal-template.html',
            size: "lg",
            controller: 'mhModalCtrl',
            resolve: {
              title: function() {
                return i18n("MODIFICATION_DELAY_EXPIRED_TITLE");
              },
              text: function() {
                return i18n("MODIFICATION_DELAY_EXPIRED_TEXT");
              },
              cancelButtonText: function() {
                return i18n("CANCEL");
              },
              noButtonText: function() {
                return '';
              },
              okButtonText: function() {
                return '';
              }
            }
          });
        } else {
          modifyModal = $uibModal.open({
            animation: true,
            controller: 'MessageModifyModalCtrl',
            size: "lg",
            templateUrl: 'message/views/message-modify-modal.html',
            resolve: {
              title: function() {
                return i18n("MODIFY");
              },
              thisMessage: function() {
                return message;
              },
              updateButtonText: function() {
                return i18n("SAVE");
              },
              cancelButtonText: function() {
                return i18n("CANCEL");
              },
              feature: function() {
                return $state.params.featureName;
              }
            }
          });
          return modifyModal.result.then(function(result) {
            if (result) {
              message.data.data = message.content.data;
              message.data['state'] = 'MODIFIED';
              message.data['modified_timestamp'] = new Date().toISOString();
              message.data['modifying_author'] = $scope.user.full_name;
              return Message.api.update({
                'id': message.id
              }, {
                'data': message.data,
                'uid': message.uid
              });
            }
          });
        }
      });
    };
    $scope.lazyRespondMessage = function(message, nodeParent) {
      var messageDone, threadId;
      messageDone = $q.defer();
      $scope.disabled = true;
      if (canSave(message)) {
        threadId = nodeParent.thread instanceof Object ? nodeParent.thread.id : nodeParent.thread;
        Message.setupMessage(message, threadId, nodeParent);
        sendMessage(message).then(function(messageResponse) {
          nodeParent.nodes.push(messageResponse);
          if (nodeParent.thread.messages_count != null) {
            nodeParent.thread.messages_count = nodeParent.thread.messages_count + 1;
          }
          $scope.disabled = false;
          return messageDone.resolve();
        });
      } else {
        messageDone.resolve();
      }
      return messageDone.promise;
    };
    cropEmptySpace = function(message) {
      var graphicElement, i, j, len, len1, margin, maxY, point, ref, ref1;
      margin = 10;
      maxY = -1;
      ref = message.content.data;
      for (i = 0, len = ref.length; i < len; i++) {
        graphicElement = ref[i];
        ref1 = graphicElement.points;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          point = ref1[j];
          if (point.y > maxY) {
            maxY = point.y;
          }
        }
      }
      if (maxY > 0) {
        message.content.size.height = maxY + margin;
      }
      return message;
    };
    sendMessage = function(message) {
      if (message.content.mode === "draw") {
        cropEmptySpace(message);
      }
      if (message.attach != null) {
        return Upload.upload({
          url: "/api_rest/messages",
          method: "POST",
          file: message.attach,
          fields: message
        });
      } else {
        return Message.api.save(message).$promise.then(function(messageResponse) {
          var ref;
          if ($scope.readMessages) {
            $scope.readMessages.push(messageResponse.id);
          }
          messageResponse.nodes = [];
          messageResponse.content = message.content;
          $scope.newMessage = Message.resetMessage(stay, (ref = $state.params.category) != null ? ref : "diary");
          return $q.when(messageResponse);
        });
      }
    };
    $scope.sendThread = function(thread, message) {
      var group, user;
      if ($scope.feature.name === 'MHC_TRANSMISSION' && $state.params.category === 'cible' && message.targetNumberInput !== '') {
        $scope.newMessage.content.data = message.targetLabel.label + ": " + message.targetNumberInput;
      }
      $scope.disabled = true;
      if (canSave(message)) {
        thread.grp_recipients = (function() {
          var i, len, ref, results;
          ref = thread.tmpGrpRecipients;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            group = ref[i];
            results.push(group.id);
          }
          return results;
        })();
        thread.user_recipients = (function() {
          var i, len, ref, results;
          ref = thread.tmpUserRecipients;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            user = ref[i];
            results.push(user.id);
          }
          return results;
        })();
        Message.setupMessage(message, null, null);
        if (message.content.mode === "draw") {
          cropEmptySpace(message);
        }
        thread.first_message = message;
        return Thread.api.save(thread).$promise.then(function(threadResponse) {
          var attachementDonePromise, upload;
          if ($scope.readMessages) {
            $scope.readMessages.push(threadResponse.first_message.id);
          }
          attachementDonePromise = $q.defer();
          if (message.attach != null) {
            upload = Upload.upload({
              url: "/api_rest/messages/" + threadResponse.first_message.id + "/upload_image",
              method: "PUT",
              file: message.attach
            });
            upload.then(function(messageResponse) {
              return attachementDonePromise.resolve();
            });
          } else {
            attachementDonePromise.resolve();
          }
          return attachementDonePromise.promise.then(function() {
            $rootScope.busy = false;
            if ($state.previous != null) {
              $state.go($state.previous.name);
            } else {
              $state.go("^.hierarchic");
            }
            return $scope.initializeFeed.promise.then(function(feeds) {
              init();
              return $scope.disabled = false;
            });
          });
        });
      }
    };
    $scope.toggleColor = function(color) {
      $scope.mhDrawCreate.config.penColor = color;
      if ($scope.mhDrawCreate.config.action === 'erase') {
        $scope.mhDrawCreate.config.action = 'draw';
      }
      return true;
    };
    $scope.addObjective = function(data) {
      return data.objectives.push("");
    };
    $scope.removeObjective = function(index, data) {
      if (data.objectives.length > 1) {
        return data.objectives.splice(index, 1);
      }
    };
    if (($scope.feature == null) && ((ref = $state.current.name) === "user.multi.message.newThread" || ref === "user.patient.stay.message.newThread")) {
      return $state.go("^.hierarchic");
    } else {
      if ((ref1 = $scope.feature.name) === 'MHC_MESSAGING' || ref1 === 'MHC_COVERAGE') {
        if ($rootScope.currentPatient) {
          UserUtils.getUsersForPatient($rootScope.currentPatient.si_id).then(function(users) {
            return $scope.ressources.user = _.filter(users, {
              'is_active': true
            });
          });
        } else {
          UserUtils.getUsers().then(function(users) {
            return $scope.ressources.user = _.filter(users, {
              'is_active': true
            });
          });
        }
      }
      return init();
    }
  }]);

}).call(this);

//# sourceMappingURL=message-create-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MessageCtrl
    * @description
    * # MessageCtrl
    * Controller of Message
   */
  angular.module('mhclientApp').controller('MessageListCtrl', ["$rootScope", "$scope", "$state", "$filter", "$anchorScroll", "$location", "User", "Message", "FeedUtils", "$q", "FeatureUtils", "SiteVarsUtils", "$log", "$httpParamSerializer", function($rootScope, $scope, $state, $filter, $anchorScroll, $location, User, Message, FeedUtils, $q, FeatureUtils, SiteVarsUtils, $log, $httpParamSerializer) {
    var categories, getCategories, getFeed, gotoAnchor, init, mgappCloseRequest, paginationInfo;
    $scope.initializeFeed = $q.defer();
    if ($state.params.featureName === "MHC_TRANSMISSION") {
      if ($state.current.name === "user.patient.stay.message.hierarchic") {
        $state.go("user.patient.stay.transmissions");
        return;
      }
      if ($state.current.name === "user.multi.message.hierarchic") {
        $state.go("user.transmissions");
        return;
      }
    }
    if ($state.params.featureName === "MHC_WORK_REPORT") {
      $state.go("user.patient.stay.multi-work-reports");
      return;
    }
    $scope.noThread = $filter('translate')('NO_THREAD');
    $scope.oneThread = $filter('translate')('ONE_THREAD');
    $scope.severalThread = $filter('translate')('SEVERAL_THREAD');
    $scope.noThreadUnread = $filter('translate')('NO_THREAD_UNREAD');
    $scope.oneThreadUnread = $filter('translate')('ONE_THREAD_UNREAD');
    $scope.severalThreadUnread = $filter('translate')('SEVERAL_THREAD_UNREAD');
    $scope.noMessage = $filter('translate')('NO_MESSAGE');
    $scope.oneMessage = $filter('translate')('ONE_MESSAGE');
    $scope.severalMessage = $filter('translate')('SEVERAL_MESSAGES');
    $scope.noMessageUnread = $filter('translate')('NO_MESSAGE_UNREAD');
    $scope.oneMessageUnread = $filter('translate')('ONE_MESSAGE_UNREAD');
    $scope.severalMessageUnread = $filter('translate')('SEVERAL_MESSAGES_UNREAD');
    $scope.drawElement = {
      'config': {
        'readonly': true,
        'action': 'draw',
        'penColor': 'black',
        'lineWidth': 1,
        'zoom': 100,
        'smooth': true,
        'tolerance': 1.00,
        'withNotes': false
      }
    };
    paginationInfo = null;
    categories = null;
    $scope.current = {};
    init = function() {
      var feature, ref;
      if ($rootScope.mh_config.platform === "mgapp") {
        window.mgappClose = mgappCloseRequest;
      }
      feature = $state.params.featureName;
      $scope.canStillBeAltered = false;
      $scope.isActiveStay = $rootScope.currentStay && ((ref = $rootScope.currentStay.state) === 'PRE' || ref === 'ADM');
      $scope.feature_folder = $filter('lowercase')('message/views/' + feature + '/' + feature);
      SiteVarsUtils.get('CLOSED_STAY_ALTERATIONS_DELAY_IN_DAYS', 0).then(function(sitevar) {
        var dTo, ref1;
        if ($rootScope.currentStay && $rootScope.currentStay.d_to) {
          dTo = moment($rootScope.currentStay.d_to);
          return $scope.canStillBeAltered = (moment().diff(dTo, 'hours') <= sitevar.value * 24) && ((ref1 = $rootScope.currentStay.state) === "CLOSE" || ref1 === "I");
        }
      });
      SiteVarsUtils.get('CAN_MODIFY_MESSAGE', false).then(function(canModifyMessage) {
        return $scope.canModifyMessage = canModifyMessage.value;
      });
      return getCategories().then(getFeed);
    };
    getCategories = function() {
      return FeatureUtils.getFeature({
        name: $state.params.featureName
      }).then(function(feature) {
        $scope.feature = feature;
        $scope.filters = {
          archived: false,
          important: void 0,
          category: void 0
        };
        if ($rootScope.currentStay != null) {
          if ($scope.allStays || $scope.feature.name === "MHC_IAS") {
            $scope.filters.idPatient = $rootScope.currentPatient.id;
          } else {
            $scope.filters.stay = $rootScope.currentStay.id;
          }
        }
        categories = feature.metadata.message_categories;
        Message.initMessageCategory(categories);
        return feature;
      });
    };
    getFeed = function() {
      FeedUtils.getFeedsByName($state.params.featureName).then(function(feeds) {
        var params;
        params = {
          stay: $scope.filters.stay,
          feature: $scope.feature.id,
          id: $scope.user.id
        };
        if ($scope.feature.name === "MHC_IAS" || (($rootScope.currentStay != null) && $scope.allStays)) {
          delete params.stay;
          params.idPatient = $rootScope.currentPatient.id;
        }
        return User.getReadMessages(params).$promise.then(function(readMessages) {
          $scope.readMessages = readMessages;
          return $scope.initializeFeed.resolve(feeds);
        });
      });
      return $scope.initializeFeed.promise;
    };
    $scope.CenterCreationField = function(eltId) {
      $('html, body').animate({
        'scrollTop': $('#' + eltId).offset().top - 75
      }, 500);
      return true;
    };
    $scope.closeWaiter = function() {};
    $scope.gotToTop = function() {
      $location.hash('top');
      return $anchorScroll();
    };
    $scope.isLastCategory = function(category) {
      return categories[category] === category;
    };
    gotoAnchor = function(uid) {
      var newHash;
      newHash = 'response' + uid;
      if ($location.hash() !== newHash) {
        return $location.hash('response' + uid);
      } else {
        return $anchorScroll();
      }
    };
    mgappCloseRequest = function() {
      if ($scope.previousState != null) {
        return $state.go($scope.previousState.name);
      } else {
        switch ($state.current.name) {
          case "user.patient.stay.message.chronologic":
          case "user.patient.stay.message.hierarchic":
            return window.mgapp.close_screen();
          case "user.patient.stay.message.newThread":
            return $state.go("user.patient.stay.message.hierarchic");
        }
      }
    };
    $scope.printData = function(docType, allStays, patient, stay) {
      var params;
      params = $httpParamSerializer({
        archived: $scope.filters.archived,
        important: $scope.filters.important,
        category: $scope.filters.category
      });
      if (allStays) {
        window.open('/api_rest/patients/' + patient.id + '/print_data/' + docType + '?' + params, '_blank');
      } else {
        window.open('/api_rest/stays/' + stay.id + '/print_data/' + docType + '?' + params, '_blank');
      }
      return true;
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=message-list-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MessageCtrl
    * @description
    * # MessageCtrl
    * Controller of Patient
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('MessageHierarchicCtrl', ["$scope", "$rootScope", "$state", "$anchorScroll", "$location", "Message", "Thread", "notify", "Feed", "$q", "User", "TreeBuild", function($scope, $rootScope, $state, $anchorScroll, $location, Message, Thread, notify, Feed, $q, User, TreeBuild) {
    var addTree, getAllContent, getContent, getThreads, gotoAnchor, initHierarhicView, initTree, initVarDisplay, paginationInfoThread, paginationPromise, resetFilters, sendReadMessages, threadsPromise;
    paginationInfoThread = null;
    threadsPromise = $q.defer();
    paginationPromise = $q.defer();
    $rootScope.busy = true;
    initHierarhicView = function() {
      $scope.previousState = $state.previous;
      return $scope.initializeFeed.promise.then(function(feeds) {
        if ($state.params.tab != null) {
          $scope.current.feed = feeds[$state.params.tab];
        } else {
          $scope.current.feed = feeds[0];
        }
        $scope.feed = angular.copy($scope.current.feed);
        return initVarDisplay();
      });
    };
    initVarDisplay = function() {
      $rootScope.busy = true;
      return getThreads().then(initTree).then(getAllContent).then(function() {
        if ($scope.$parent) {
          $scope.$parent.lastThread = $scope.threads[0];
        }
        return $rootScope.busy = false;
      });
    };
    getThreads = function() {
      var params;
      params = angular.copy($scope.filters);
      params.feed = $scope.feed.id;
      params.page_size = 20;
      Thread.api.query(params).$promise.then(function(response) {
        $scope.nextThreadsURL = response.next;
        $scope.count = response.count;
        $scope.unread = response.unread;
        paginationInfoThread = response;
        paginationPromise.resolve(response.next);
        return threadsPromise.resolve(response.results);
      });
      return threadsPromise.promise;
    };
    initTree = function(threads) {
      $scope.threads = TreeBuild.initialize(threads);
      if ($scope.unread > 0 || _.filter(threads, {
        have_new_message: true
      }).length > 0) {
        sendReadMessages();
      }
      $scope.current.threads = _.map($scope.threads, _.clone);
      $scope.allArchived = _.map($scope.threads, 'archived').indexOf(false) < 0;
      return $q.when($scope.threads);
    };
    getAllContent = function(threads) {
      var defer;
      threads.forEach(function(message) {
        if (message.thread.have_new_message) {
          $scope.getMessages(message);
        }
        message.content = {};
        return getContent(message).promise.then(function(response) {
          return message.content = response.data;
        });
      });
      defer = $q.when(threads);
      return defer.promise;
    };
    sendReadMessages = function() {
      var params;
      if ($scope.feature.name !== 'MHC_MESSAGING') {
        params = angular.copy($scope.filters);
        params.feed = $scope.feed.id;
        params.id = $scope.user.id;
        return User.read_messages(params, {});
      }
    };
    getContent = function(message) {
      var content;
      if (message != null) {
        return content = Message.getMessageContent(message, $scope.readMessages);
      }
    };
    addTree = function(httpResponse) {
      var nextThreads;
      paginationInfoThread = httpResponse;
      nextThreads = TreeBuild.initialize(httpResponse.results);
      if (_.filter(httpResponse.results, {
        have_new_message: true
      }).length > 0) {
        sendReadMessages();
      }
      $scope.threads = $scope.threads.concat(nextThreads);
      paginationPromise.resolve(httpResponse.next);
      $scope.nextThreadsURL = httpResponse.next;
      return $q.when(nextThreads);
    };
    resetFilters = function() {
      $scope.filters.archived = false;
      $scope.filters.important = void 0;
      return $scope.filters.category = void 0;
    };
    $scope.applyFilter = function(viewFilters) {
      resetFilters();
      _.extend($scope.filters, viewFilters);
      threadsPromise = $q.defer();
      paginationPromise = $q.defer();
      $scope.filters.important = viewFilters.important === true ? true : void 0;
      $scope.filters.category = viewFilters.category === "null" ? void 0 : viewFilters.category;
      $scope.filters.unread = viewFilters.unread === true ? true : void 0;
      return initVarDisplay();
    };
    $scope.archive = function(thread) {
      thread.archived = true;
      if (thread.data == null) {
        thread.data = {};
      }
      thread.data.archivedDate = new Date();
      Thread.api.update({
        id: thread.id
      }, thread);
      $scope.count = $scope.count - 1;
      return $scope.allArchived = true;
    };
    $scope.unarchive = function(thread) {
      thread.archived = false;
      Thread.api.update({
        id: thread.id
      }, thread);
      return $scope.count = $scope.count + 1;
    };
    $scope.isImage = function(attachment) {
      var ref;
      if ((ref = attachment.split('.').pop()) === 'jpg' || ref === 'gif' || ref === 'jpeg' || ref === 'png') {
        return true;
      }
      return false;
    };
    $scope.getMessages = function(node) {
      var allContentPromises;
      allContentPromises = [];
      if (node.nodes.length === 0 && node.thread.messages_count > 1) {
        return Thread.api.get_messages({
          id: node.thread.id
        }).$promise.then(function(messages) {
          var tree;
          messages.forEach(function(message) {
            var promise, ref;
            message.read = (ref = message.id, indexOf.call($scope.readMessages, ref) >= 0);
            promise = getContent(message).promise;
            allContentPromises.push(promise);
            return promise.then(function(messageResponse) {
              return message.content = messageResponse.data;
            });
          });
          tree = TreeBuild.deepConstruct(messages, node.id);
          node.nodes = tree;
          return $q.all(allContentPromises).then(function() {
            return gotoAnchor(_.last(messages).uid);
          });
        });
      }
    };
    $scope.markAsRead = function(node) {
      var params;
      params = {
        id: $scope.user.id,
        messageId: node.id
      };
      $rootScope.busy = true;
      return User.read_one_message(params, {}).$promise.then(function(Response) {
        var child, i, len, ref;
        node.read = true;
        node.thread.have_new_message = false;
        ref = node.nodes;
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          child.read = true;
        }
        $scope.unread = $scope.unread - 1;
        return $rootScope.busy = false;
      });
    };
    $scope.addNextThreads = function() {
      if ($rootScope.busy) {
        return;
      }
      paginationPromise.promise.then(function(nextUrl) {
        $rootScope.busy = true;
        if (nextUrl === null) {
          return $rootScope.busy = true;
        }
        return Thread.getNext(nextUrl).then(addTree).then(getAllContent).then(function(promise) {
          return $rootScope.busy = false;
        });
      });
      return paginationPromise = $q.defer();
    };
    $scope.closeWaiter = function() {};
    $scope.gotToTop = function() {
      $location.hash('top');
      return $anchorScroll();
    };
    gotoAnchor = function(uid) {
      var newHash;
      newHash = 'response' + uid;
      if ($location.hash() !== newHash) {
        return $location.hash('response' + uid);
      } else {
        return $anchorScroll();
      }
    };
    return initHierarhicView();
  }]);

}).call(this);

//# sourceMappingURL=message-hierarchic-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MessageCtrl
    * @description
    * # MessageCtrl
    * Controller of Patient
   */
  angular.module('mhclientApp').controller('MessageChronologicCtrl', ["$scope", "$rootScope", "$state", "$filter", "$anchorScroll", "$location", "Message", "Thread", "notify", "Feed", "$q", "Feature", "User", "TreeBuild", "$http", function($scope, $rootScope, $state, $filter, $anchorScroll, $location, Message, Thread, notify, Feed, $q, Feature, User, TreeBuild, $http) {
    var addMessages, getAllContent, getContent, getMessages, gotoAnchor, init, initChronologicView, initOrderedMessagesList, paginationInfoMessage, paginationPromise, sendReadMessages;
    paginationInfoMessage = null;
    $rootScope.busy = true;
    paginationPromise = $q.defer();
    init = function() {
      return $scope.initializeFeed.promise.then(function(feeds) {
        if ($state.params.tab != null) {
          $scope.current.feed = feeds[$state.params.tab];
        } else {
          $scope.current.feed = feeds[0];
        }
        $scope.feed = angular.copy($scope.current.feed);
        return initChronologicView().then(function() {
          return $rootScope.busy = false;
        });
      });
    };
    initChronologicView = function() {
      var params;
      $scope.resetFilters();
      params = {
        feed: $scope.feed.id,
        stay: $scope.filters.stay,
        idPatient: $scope.filters.idPatient,
        archived: $scope.filters.archived,
        important: $scope.filters.important,
        page_size: 20
      };
      return getMessages(params);
    };
    getMessages = function(params) {
      return Message.api.query(params).$promise.then(function(response) {
        paginationInfoMessage = response;
        $scope.nextMessagesURL = response.next;
        $scope.messages_count = response.count;
        paginationPromise.resolve(response.next);
        $scope.messages_unread = response.unread;
        return initOrderedMessagesList(response.results);
      });
    };
    getAllContent = function(threads) {
      var defer;
      threads.forEach(function(message) {
        if (message.thread.have_new_message) {
          $scope.getMessages(message);
        }
        message.content = {};
        return getContent(message).promise.then(function(response) {
          return message.content = response.data;
        });
      });
      defer = $q.when(threads);
      return defer.promise;
    };
    initOrderedMessagesList = function(messages) {
      $scope.orderedMessagesList = messages;
      return getAllContent($scope.orderedMessagesList);
    };
    sendReadMessages = function() {
      var params;
      if ($scope.messages_unread > 0) {
        params = {
          feed: $scope.feed.id,
          id: $scope.user.id,
          stay: $scope.filters.stay,
          idPatient: $scope.filters.idPatient,
          archived: $scope.filters.archived,
          important: $scope.filters.important
        };
        return User.read_messages(params, {});
      }
    };
    getContent = function(message) {
      var content;
      if (message != null) {
        return content = Message.getMessageContent(message, $scope.readMessages);
      }
    };
    addMessages = function(httpResponse) {
      paginationInfoMessage = httpResponse;
      $scope.orderedMessagesList = $scope.orderedMessagesList.concat(httpResponse.results);
      paginationPromise.resolve(httpResponse.next);
      $scope.nextMessagesURL = httpResponse.next;
      return $q.when(httpResponse.results);
    };
    $scope.isImage = function(attachment) {
      var ref;
      if ((ref = attachment.split('.').pop()) === 'jpg' || ref === 'gif' || ref === 'jpeg' || ref === 'png') {
        return true;
      }
      return false;
    };
    $scope.getMessages = function(node) {
      var allContentPromises;
      allContentPromises = [];
      if (node.nodes.length === 0) {
        return Thread.api.get_messages({
          id: node.thread.id
        }).$promise.then(function(messages) {
          var tree;
          messages.forEach(function(message) {
            var promise;
            promise = getContent(message).promise;
            allContentPromises.push(promise);
            return promise.then(function(messageResponse) {
              return message.content = messageResponse.data;
            });
          });
          tree = TreeBuild.deepConstruct(messages, node.id);
          node.nodes = tree;
          return $q.all(allContentPromises).then(function() {
            return gotoAnchor(node.uid);
          });
        });
      }
    };
    $scope.resetFilters = function() {
      $scope.filters.archived = false;
      return $scope.filters.important = void 0;
    };
    $scope.fetchMessage = function(min_date, max_date) {
      var params;
      min_date = $filter('date')(min_date, "yyyy-MM-dd");
      max_date = $filter('date')(max_date, "yyyy-MM-dd");
      params = {
        feed: $scope.feed.id,
        stay: $scope.filters.stay,
        idPatient: $scope.filters.idPatient,
        start: min_date,
        stop: max_date,
        archived: $scope.filters.archived,
        important: $scope.filters.important
      };
      return getMessages(params);
    };
    $scope.addNextMessages = function() {
      if ($rootScope.busy) {
        return;
      }
      paginationPromise.promise.then(function(nextUrl) {
        if (nextUrl === null) {
          return;
        }
        $rootScope.busy = true;
        return Message.getNext(nextUrl).then(addMessages).then(getAllContent).then(function(promise) {
          return $rootScope.busy = false;
        });
      });
      return paginationPromise = $q.defer();
    };
    $scope.closeWaiter = function() {};
    $scope.gotToTop = function() {
      $location.hash('top');
      return $anchorScroll();
    };
    gotoAnchor = function(uid) {
      var newHash;
      newHash = 'response' + uid;
      if ($location.hash() !== newHash) {
        return $location.hash('response' + uid);
      } else {
        return $anchorScroll();
      }
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=message-chronologic-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:ObservationCreateCtrl
    * @description
    * # ObservationCreateCtrl
    * Controller for creation of new observation, very specific needs for the feature MHC_OBSERVATION
   */
  angular.module('mhclientApp').controller('ObservationCreateCtrl', ["$scope", "$filter", function($scope, $filter) {
    $scope.dateMax = new Date();
    $scope.defaultDate = new Date();
    return $scope.canWrite = $scope.checkPermissions('MHC_OBSERVATION', 'CAN_WRITE');
  }]);

}).call(this);

//# sourceMappingURL=observation-create-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:MessageModifyModalCtrl
    * @description
    * # MessageModifyModalCtrl
    * Provider of MessageModifyModalCtrl
   */
  angular.module("mhclientApp").controller('MessageModifyModalCtrl', ["$scope", "$uibModalInstance", "$filter", "title", "thisMessage", "updateButtonText", "cancelButtonText", "feature", function($scope, $uibModalInstance, $filter, title, thisMessage, updateButtonText, cancelButtonText, feature) {
    $scope.feature_folder = $filter('lowercase')('message/views/' + feature + '/' + feature);
    $scope.thisMessage = thisMessage;
    $scope.title = title;
    $scope.cancelButtonText = cancelButtonText;
    $scope.updateButtonText = updateButtonText;
    $scope.updateMessage = function() {
      return $uibModalInstance.close(true);
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss(false);
    };
    $scope.addObjective = function(data) {
      return data.objectives.push("");
    };
    return $scope.removeObjective = function(index, data) {
      if (data.objectives.length > 1) {
        return data.objectives.splice(index, 1);
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=message-modify-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:WorkReportCtrl
    * @description
    * # WorkReportCtrl
    * Controller of work report
   */
  angular.module('mhclientApp').controller('WorkReportMulti', ["$scope", "$rootScope", "$stateParams", "$state", "$filter", "Feature", function($scope, $rootScope, $stateParams, $state, $filter, Feature) {
    var userView;
    $scope.feeds = [];
    userView = null;
    return $scope.initializeFeed.promise.then(function(feeds) {
      var current_feed;
      $scope.feeds = feeds;
      feeds.forEach(function(feed, index) {
        feed.heading = $filter('translate')(feed.view);
        feed.route = "user.patient.stay.message.multi.tab";
        feed.params = angular.copy($state.params);
        feed.params.tab = index;
        feed.params.view = feed.view;
        if ($scope.user.group.data.work_report_view === feed.view) {
          userView = index;
        }
        return feed.readonly = $scope.user.group.data.work_report_view !== feed.view;
      });
      if ($stateParams.view != null) {
        current_feed = _.find($scope.feeds, {
          view: $stateParams.view
        });
      } else if (userView != null) {
        current_feed = feeds[userView];
      } else {
        current_feed = feeds[0];
      }
      $scope.current.feed = current_feed;
      current_feed.active = true;
      $rootScope.busy = false;
      return $state.go(current_feed.route, current_feed.params);
    });
  }]);

}).call(this);

//# sourceMappingURL=message-work-report-multi-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Message
    * @description
    * # Message
    * Factory of Message
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").factory('Message', ["$resource", "MhConfig", "$q", "BoxResource", "$http", "MessageCategory", "SiteVarsUtils", "moment", "$filter", function($resource, MhConfig, $q, BoxResource, $http, MessageCategory, SiteVarsUtils, moment, $filter) {
    var acceptHeader, api, boxAPI, canBeModified, cropEmptySpace, getDefaultDrawConfig, getMessageContent, getNext, getResponseForCategory, initMessageCategory, isContentValid, isMessageValid, message_mgr, portailAPI, resetMessage, service, setupMessage;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/messages/:id/:route', {
      id: this.id
    }, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: false
      },
      'update': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      },
      'patch': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        }
      },
      'extractCompteRenduMetier': {
        method: "PUT",
        params: {
          route: "extract_compte_rendu_metier",
          id: '@id'
        },
        headers: {
          "Accept": acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        message_mgr = window.mgapp.get('message_mgr').message();
        boxAPI = BoxResource.generate(message_mgr);
        api = boxAPI;
        break;
      default:
        return portailAPI;
    }
    cropEmptySpace = function(message) {
      var graphicElement, i, j, len, len1, margin, maxY, point, ref, ref1;
      margin = 10;
      maxY = -1;
      ref = message.content.data;
      for (i = 0, len = ref.length; i < len; i++) {
        graphicElement = ref[i];
        ref1 = graphicElement.points;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          point = ref1[j];
          if (point.y > maxY) {
            maxY = point.y;
          }
        }
      }
      if (maxY > 0) {
        message.content.size.height = maxY + margin;
      }
      return message;
    };
    setupMessage = function(message, threadId, parent) {
      message.timestamp = new Date().toISOString();
      message.from_platform = MhConfig.platform;
      message.thread = threadId;
      if (parent != null) {
        message.parent = parent.id;
        message.category = MessageCategory.getChildOf(parent.category);
      }
      if (message.content.mode === "draw") {
        cropEmptySpace(message);
      }
      return message;
    };
    getMessageContent = function(message, readMessages) {
      var promise;
      promise = $q.defer();
      SiteVarsUtils.get("MAX_TIME_UNREAD_MESSAGES", 30).then(function(sitevar) {
        var ref;
        message.read = moment().diff(moment(message.timestamp), 'days') >= sitevar.value || (ref = message.id, indexOf.call(readMessages || [], ref) >= 0);
        return $http.get(message.content_url).then(function(content) {
          return promise.resolve(content);
        });
      });
      return promise;
    };
    resetMessage = function(stay, category) {
      var message;
      message = {
        category: category,
        stay: stay,
        uid: 'yay',
        priority: 0,
        data: {},
        content: {
          data: [],
          mode: "text",
          size: {
            width: 900,
            height: 100
          }
        }
      };
      return message;
    };
    getDefaultDrawConfig = function() {
      return {
        'readonly': true,
        'action': 'draw',
        'penColor': 'black',
        'lineWidth': 1,
        'zoom': 100,
        'smooth': true,
        'tolerance': 1.00,
        'withNotes': false
      };
    };
    getResponseForCategory = function(category) {
      return {
        "macro-cible": "macro-cible",
        "note": "note",
        "resultat": "resultat",
        "action": "resultat",
        "cible": "donnee",
        "donnee": "action"
      }[category];
    };
    getNext = function(nextUrl) {
      var promise;
      switch (MhConfig.platform) {
        case 'mhsi':
          promise = $q.defer();
          $http.get(nextUrl).then(function(data) {
            return promise.resolve(data.data);
          });
          return promise.promise;
        case 'mgapp':
          return api.query(nextUrl).$promise;
      }
    };
    initMessageCategory = function(categoryList) {
      return MessageCategory.init(categoryList);
    };
    canBeModified = function(message) {
      var currentDate, promise;
      currentDate = moment();
      promise = $q.defer();
      SiteVarsUtils.get('MESSAGE_MODIFY_DELAY', 10).then(function(sitevar) {
        return promise.resolve(moment.utc(message.timestamp).add(sitevar.value, "minutes").isAfter(currentDate));
      });
      return promise.promise;
    };
    isMessageValid = function(message) {
      return isContentValid(message.content);
    };
    isContentValid = function(messagContent) {
      return !((messagContent.mode === "text" && (messagContent.data == null)) || (messagContent.mode === "text" && messagContent.data === "") || (messagContent.mode === "text" && typeof messagContent.data !== "string") || (messagContent.mode === "draw" && (messagContent.data != null) && messagContent.data.length === 0) || (messagContent.mode === "draw" && typeof messagContent.data === "string"));
    };
    service = {
      setupMessage: setupMessage,
      isContentValid: isContentValid,
      getMessageContent: getMessageContent,
      resetMessage: resetMessage,
      api: api,
      getNext: getNext,
      cropEmptySpace: cropEmptySpace,
      isMessageValid: isMessageValid,
      initMessageCategory: initMessageCategory,
      canBeModified: canBeModified,
      getDefaultDrawConfig: getDefaultDrawConfig,
      getResponseForCategory: getResponseForCategory
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=message-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Thread
    * @description
    * # Thread
    * Factory of Thread
   */
  angular.module("mhclientApp").factory('Thread', ["$resource", "MhConfig", "$q", "BoxResource", "$http", function($resource, MhConfig, $q, BoxResource, $http) {
    var acceptHeader, api, boxAPI, getNext, portailAPI, resetThread, service, thread;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/threads/:id/:route', {
      id: this.id
    }, {
      'save': {
        method: 'POST',
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        method: 'PUT',
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: false
      },
      'update_alert': {
        method: "PUT",
        params: {
          route: 'update_alert'
        },
        headers: {
          "Accept": acceptHeader
        }
      },
      'get_messages': {
        method: "GET",
        isArray: true,
        params: {
          route: 'get_messages'
        },
        headers: {
          "Accept": acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        thread = window.mgapp.get('message_mgr').thread();
        boxAPI = BoxResource.generate(thread);
        boxAPI.get_messages = function(object) {
          return BoxResource.mhboxApiCall(thread, "get_messages", object);
        };
        boxAPI.update_alert = function(object, thread_dict) {
          return BoxResource.mhboxApiCall(thread, "update_alert", thread_dict);
        };
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    resetThread = function(feed, stay, patient) {
      var newThread;
      return newThread = {
        archived: false,
        important: false,
        feed: feed.id,
        stay: stay,
        patient: patient != null ? patient.id : void 0,
        tmpGrpRecipients: [],
        tmpUserRecipients: []
      };
    };
    getNext = function(nextUrl) {
      var promise;
      switch (MhConfig.platform) {
        case 'mhsi':
          promise = $q.defer();
          $http.get(nextUrl).then(function(data) {
            return promise.resolve(data.data);
          });
          return promise.promise;
        case 'mgapp':
          return api.query(nextUrl).$promise;
      }
    };
    service = {
      api: api,
      resetThread: resetThread,
      getNext: getNext
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=thread-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Feed
    * @description
    * # Feed
    * Factory of Feed
   */
  angular.module("mhclientApp").factory('Feed', ["$resource", "MhConfig", "$q", "BoxResource", "$state", function($resource, MhConfig, $q, BoxResource, $state) {
    var acceptHeader, boxAPI, feed, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/feeds/:feature', {
      feature: this.feature
    }, {
      patch: {
        method: 'PATCH',
        url: '/api_rest/feeds/:id',
        headers: {
          Accept: acceptHeader
        }
      },
      post: {
        method: 'POST',
        url: '/api_rest/feeds',
        headers: {
          Accept: acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return {
          api: portailAPI
        };
      case 'mgapp':
        feed = window.mgapp.get('message_mgr').feed();
        boxAPI = BoxResource.generate(feed);
        return {
          api: boxAPI
        };
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('FeedUtils', ["$q", "Feed", function($q, Feed) {
    var fetchFeeds, filterEntries, getFeeds, getFeedsByName, globalFeedsPromise, resetCache, service;
    globalFeedsPromise = $q.defer();
    filterEntries = function(entries, query, many, dontCopy) {
      var result;
      if (query) {
        result = many ? _.filter(entries, query) : _.find(entries, query);
      } else {
        result = entries;
      }
      if (dontCopy) {
        return result;
      } else {
        if (result instanceof Array) {
          return _.map(result, _.cloneDeep);
        } else {
          return _.cloneDeep(result);
        }
      }
    };
    fetchFeeds = function() {
      if (!globalFeedsPromise.promise.$$state.status) {
        globalFeedsPromise.resolve(Feed.api.query().$promise);
      }
      return globalFeedsPromise.promise;
    };
    getFeeds = function(query, many, dontCopy) {
      return fetchFeeds().then(function(feeds) {
        return filterEntries(feeds, query, many, dontCopy);
      });
    };
    getFeedsByName = function(feature_name) {
      return fetchFeeds().then(function(feeds) {
        return angular.copy(_.filter(feeds, {
          feature_name: feature_name
        }));
      });
    };
    resetCache = function() {
      return globalFeedsPromise = $q.defer();
    };
    service = {
      getFeedsByName: getFeedsByName,
      resetCache: resetCache,
      getFeeds: getFeeds
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=feed-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:treeBuild
    * @description
    * # treeBuild
    * Factory of treeBuild
   */
  angular.module("mhclientApp").factory('TreeBuild', function() {
    var deepConstruct, initialize;
    initialize = function(threads) {
      var i, len, node, thread, uiTree;
      uiTree = [];
      for (i = 0, len = threads.length; i < len; i++) {
        thread = threads[i];
        if (thread.first_message != null) {
          node = angular.copy(thread.first_message);
          node.nodes = [];
          node.thread = thread;
          uiTree.push(node);
        }
      }
      threads = uiTree;
      return threads;
    };

    /*
    This is a recursive function : I am proud of it, please be careful.
     */
    deepConstruct = function(allObjects, rootId) {
      var addChildren, findChildren, tree;
      if (rootId == null) {
        rootId = null;
      }
      addChildren = function(nodes) {
        var i, len, node, results;
        results = [];
        for (i = 0, len = nodes.length; i < len; i++) {
          node = nodes[i];
          node.nodes = [];
          node.nodes = node.nodes.concat(findChildren(node.id));
          results.push(addChildren(node.nodes));
        }
        return results;
      };
      findChildren = function(id) {
        var children, i, len, obj;
        children = [];
        for (i = 0, len = allObjects.length; i < len; i++) {
          obj = allObjects[i];
          if (obj.parent === id) {
            children.push(obj);
          }
        }
        return children;
      };
      tree = findChildren(rootId);
      addChildren(tree);
      return tree;
    };
    return {
      initialize: initialize,
      deepConstruct: deepConstruct
    };
  });

}).call(this);

//# sourceMappingURL=tree-build-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:MessageCategory
    * @description
    * # MessageCategory
    * Factory of MessageCategory
   */
  angular.module("mhclientApp").factory('MessageCategory', function() {
    var childnodes, getChildOf, init;
    childnodes = {};
    init = function(categoryList) {
      return childnodes = categoryList;
    };
    getChildOf = function(parentCategory) {
      return childnodes[parentCategory];
    };
    return {
      getChildOf: getChildOf,
      init: init
    };
  });

}).call(this);

//# sourceMappingURL=category-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MessageCtrl
    * @description
    * # MessageCtrl
    * Controller for IAS old infections controller
   */
  angular.module('mhclientApp').controller('IASOldInfectionsCtrl', ["$scope", "$rootScope", "$state", "Message", "Thread", "$q", "TreeBuild", function($scope, $rootScope, $state, Message, Thread, $q, TreeBuild) {
    var alertsAPI, getAllContent, getArchivedThreads, getContent, initOldInfections, initTree;
    alertsAPI = {
      'drop': 'dropAlertRunning',
      'contact': 'contactAlertRunning',
      'air': 'airAlertRunning',
      'scabies': 'scabiesAlertRunning',
      'other': 'otherAlertRunning'
    };
    $scope.initializeFeed.promise.then(function(feed) {
      return initOldInfections();
    });
    initOldInfections = function() {
      return getArchivedThreads().then(initTree).then(getAllContent).then(function() {
        return $rootScope.busy = false;
      });
    };
    getArchivedThreads = function() {
      var params, threadsPromise;
      params = {
        feed: $scope.feed.id,
        idPatient: $state.params.idPatient,
        archived: true
      };
      threadsPromise = $q.defer();
      Thread.api.query(params).$promise.then(function(response) {
        var paginationInfoThread;
        $scope.nextThreadsURL = response.next;
        $scope.oldInfectionscount = response.count;
        $scope.unread = response.unread;
        paginationInfoThread = response;
        return threadsPromise.resolve(response.results);
      });
      return threadsPromise.promise;
    };
    initTree = function(threads) {
      $scope.oldInfections = TreeBuild.initialize(threads);
      return $q.when($scope.oldInfections);
    };
    getAllContent = function(threads) {
      var defer;
      threads.forEach(function(message) {
        if (message.thread.have_new_message) {
          $scope.getMessages(message);
        }
        message.content = {};
        return getContent(message).promise.then(function(response) {
          return message.content = response.data;
        });
      });
      defer = $q.when(threads);
      return defer.promise;
    };
    getContent = function(message) {
      var content;
      if (message != null) {
        return content = Message.getMessageContent(message, $scope.readMessages);
      }
    };
    $scope.getMessages = function(node) {
      var allContentPromises;
      allContentPromises = [];
      if (node.nodes.length === 0) {
        return Thread.api.get_messages({
          id: node.thread.id
        }).$promise.then(function(messages) {
          var tree;
          messages.forEach(function(message) {
            var promise;
            promise = getContent(message).promise;
            allContentPromises.push(promise);
            return promise.then(function(messageResponse) {
              return message.content = messageResponse.data;
            });
          });
          tree = TreeBuild.deepConstruct(messages, node.id);
          return node.nodes = tree;
        });
      }
    };
    $scope.endInfection = function(node) {
      var updatedThreadPromise;
      $rootScope.busy = true;
      delete node.thread.data['dropAlertRunning'];
      delete node.thread.data['contactAlertRunning'];
      delete node.thread.data['airAlertRunning'];
      delete node.thread.data['scabiesAlertRunning'];
      delete node.thread.data['otherAlertRunning'];
      node.thread.archived = true;
      if (node.thread.data == null) {
        node.thread.data = {};
      }
      node.thread.data.archivedDate = new Date();
      updatedThreadPromise = $q.defer();
      Thread.api.update_alert({
        id: node.thread.id
      }, node.thread).$promise.then(function(current_alerts) {
        var stoppedInfection;
        $rootScope.currentPatient.current_alerts = current_alerts;
        $scope.count = $scope.count - 1;
        stoppedInfection = [];
        stoppedInfection[0] = node;
        $scope.oldInfections = stoppedInfection.concat($scope.oldInfections);
        $scope.oldInfectionscount = $scope.oldInfectionscount + 1;
        $rootScope.busy = false;
        return updatedThreadPromise.resolve(node.thread);
      });
      return updatedThreadPromise;
    };
    $scope.switchAlert = function(thread, name) {
      $rootScope.busy = true;
      $scope.alertDisabled = true;
      if (thread.data[alertsAPI[name]] != null) {
        delete thread.data[alertsAPI[name]];
      } else {
        thread.data[alertsAPI[name]] = true;
      }
      thread.alert = alertsAPI[name];
      Thread.api.update_alert({
        id: thread.id,
        alert: alertsAPI[name]
      }, thread).$promise.then(function(curret_alerts) {
        $rootScope.currentPatient.current_alerts = curret_alerts;
        $scope.alertDisabled = false;
        return $rootScope.busy = false;
      });
      return thread;
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      return window.mgappConfirmQuit = window.mgapp.quit_view;
    }
  }]);

}).call(this);

//# sourceMappingURL=mhc_ias-old-infections-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MessageCtrl
    * @description
    * # MessageCtrl
    * Controller of Patient
   */
  angular.module('mhclientApp').controller('CoverageCreateCtrl', ["$scope", "$state", "Message", "$filter", "notify", "$uibModal", "Thread", function($scope, $state, Message, $filter, notify, $uibModal, Thread) {
    var initModal;
    $scope.dateMax = new Date();
    $scope.defaultDate = new Date();
    $scope.OnlyFromSource = false;
    $scope.canWriteCoverage = $scope.checkPermissions('MHC_COVERAGE', 'CAN_WRITE');
    $scope.showClosed = false;

    /*freezeCoverage = (thread) ->
      thread.data.readOnly = true
      Thread.api.update({ id: thread.id }, thread)
     */
    initModal = function() {
      var pr;
      pr = $uibModal.open({
        animation: true,
        templateUrl: 'message/views/mhc_coverage/mhc_coverage_modal.html',
        size: "lg",
        controller: 'coverageModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("INFORMATIONS_UPDATE");
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          okButtonText: function() {
            return $filter('translate')("SAVE_BUTTON");
          },
          model: function() {
            return $scope.threads[0].thread.data;
          }
        }
      });
      return pr;
    };
    $scope.createEvent = function(message, thread) {

      /*if message.category == 'report'
        freezeCoverage(thread)
       */
      return $scope.lazyRespondMessage(message, thread).then(function() {
        return $state.go("^.hierarchic");
      });
    };
    $scope.addObjective = function(node) {
      $scope.disabled = true;
      node.content.data.objectives.push($scope.newObjective);
      Message.api.patch({
        id: node.id
      }, {
        content: node.content
      });
      $scope.$parent.showCreationField = false;
      return $scope.disabled = false;
    };
    $scope.updateThreadData = function() {
      var modalWindow;
      modalWindow = initModal();
      return modalWindow.result.then(function(data) {
        var thread;
        if (data) {
          thread = $scope.threads[0].thread;
          thread.data = data;
          Thread.api.update({
            id: thread.id
          }, thread);
          return notify({
            classes: ['alert-info'],
            message: $filter('translate')("INFORMATIONS_UPDATE_COMPLETE")
          });
        }
      });
    };
    $scope.closePEC = function(node) {
      $scope.archive($scope.threads[0].thread);
      return $scope.allArchived = true;
    };
    return $scope.togglePEC = function(node) {
      if (node.show) {
        return node.show = !node.show;
      } else {
        return node.show = true;
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=coverage-create-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:coverageModalCtrl
    * @description
    * # coverageModalCtrl
    * Provider of coverageModalCtrl
   */
  angular.module("mhclientApp").controller('coverageModalCtrl', ["$scope", "$rootScope", "$uibModalInstance", "title", "okButtonText", "cancelButtonText", "model", "UserUtils", function($scope, $rootScope, $uibModalInstance, title, okButtonText, cancelButtonText, model, UserUtils) {
    $scope.ressources = {};
    UserUtils.getUsersForPatient($rootScope.currentPatient.si_id).then(function(users) {
      return $scope.ressources.user = users;
    });
    $scope.title = title;
    $scope.cancelButtonText = cancelButtonText;
    $scope.okButtonText = okButtonText;
    $scope.model = angular.copy(model);
    $scope.yes = function() {
      return $uibModalInstance.close($scope.model);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=coverage-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.message: booleanDisplayFilter
    * @description
    * # booleanDisplayFilter
    * Convert boolean to litteral value yes/no
   */
  angular.module('mhclientApp').filter('booleanDisplayFilter', ["$filter", function($filter) {
    var negative, positive;
    positive = $filter('translate')('YES');
    negative = $filter('translate')('NO');
    return function(bool) {
      var output;
      if (typeof bool === 'boolean') {
        if (bool) {
          output = positive;
        } else {
          output = negative;
        }
      } else {
        output = negative;
      }
      return output;
    };
  }]);

}).call(this);

//# sourceMappingURL=boolean-display-filter.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MessageCtrl
    * @description
    * # MessageCtrl
    * Controller of Patient
   */
  angular.module('mhclientApp').controller('MessageMultiCtrl', ["$scope", function($scope) {
    return $scope.patients_promise.then(function(patients) {
      return $scope.patients = patients;
    });
  }]);

}).call(this);

//# sourceMappingURL=message-multi-controller.js.map

'use strict';

/* **************************************************
* @ngdoc function
* @name mhclientApp.component
* @description
* MessageListComponent
* Component of message list.
*************************************************** */

var MessageListCtrl = function(
  $state,
  $rootScope,
  $filter,
  $anchorScroll,
  $location,
  User,
  Message,
  FeedUtils,
  $q,
  FeatureUtils,
  SiteVarsUtils,
  $log) {

  var ctrl = this;
  ctrl.initializeFeed = $q.defer();
  ctrl.currentStay = $rootScope.currentStay

  if ($state.params.featureName === "MHC_TRANSMISSION") {
    if ($state.current.name === "user.patient.stay.message.hierarchic") {
      $state.go("user.patient.stay.transmissions");
      return;
    }
    if ($state.current.name === "user.multi.message.hierarchic") {
      $state.go("user.transmissions");
      return;
    }
  }

  if ($state.params.featureName === "MHC_WORK_REPORT") {
    $state.go("user.patient.stay.multi-work-reports");
    return;
  }

  ctrl.noThread = $filter('translate')('NO_THREAD');

  ctrl.oneThread = $filter('translate')('ONE_THREAD');

  ctrl.severalThread = $filter('translate')('SEVERAL_THREAD');

  ctrl.noThreadUnread = $filter('translate')('NO_THREAD_UNREAD');

  ctrl.oneThreadUnread = $filter('translate')('ONE_THREAD_UNREAD');

  ctrl.severalThreadUnread = $filter('translate')('SEVERAL_THREAD_UNREAD');

  ctrl.noMessage = $filter('translate')('NO_MESSAGE');

  ctrl.oneMessage = $filter('translate')('ONE_MESSAGE');

  ctrl.severalMessage = $filter('translate')('SEVERAL_MESSAGES');

  ctrl.noMessageUnread = $filter('translate')('NO_MESSAGE_UNREAD');

  ctrl.oneMessageUnread = $filter('translate')('ONE_MESSAGE_UNREAD');

  ctrl.severalMessageUnread = $filter('translate')('SEVERAL_MESSAGES_UNREAD');

  ctrl.drawElement = {
    'config': {
      'readonly': true,
      'action': 'draw',
      'penColor': 'black',
      'lineWidth': 1,
      'zoom': 100,
      'smooth': true,
      'tolerance': 1.00,
      'withNotes': false
    }
  };

  var paginationInfo = null;

  var categories = null;

  ctrl.current = {};


  function init() {
    if (!ctrl.featureName) {
      ctrl.featureName = $state.params.featureName;
    }

    if ($rootScope.mh_config.platform === "mgapp") {
      window.mgappClose = mgappCloseRequest;
    }
    var feature = ctrl.featureName;
    ctrl.canStillBeAltered = false;
    ctrl.isActiveStay = ctrl.stay && ((ctrl.stay.state) === 'PRE' || ctrl.stay.state === 'ADM');
    ctrl.featureFolder = $filter('lowercase')('message/templates/' + feature + '/' + feature);
    SiteVarsUtils.get('CLOSED_STAY_ALTERATIONS_DELAY_IN_DAYS', 0).then(function(sitevar) {

      var dTo, ref1;
      if (ctrl.stay && ctrl.stay.d_to) {
        dTo = moment(ctrl.currentStay.d_to);
        ctrl.canStillBeAltered = (moment().diff(dTo, 'hours') <= sitevar.value * 24) && ((ref1 = ctrl.currentStay.state) === "CLOSE" || ref1 === "I");
      }
      return SiteVarsUtils.get('CAN_MODIFY_MESSAGE', false).then(function(canModifyMessage) {
        ctrl.canModifyMessage = canModifyMessage.value;
        return getCategories().then(getFeed);
        });

    });

  }

  var getCategories = function() {
    return FeatureUtils.getFeature({
      name: ctrl.featureName
    }).then(function(feature) {
      var categories;
      ctrl.feature = feature;
      ctrl.filters = {
        archived: false,
        important: undefined,
        category: undefined
      };
      if (ctrl.stay != null) {
        if (ctrl.allStays || ctrl.feature.name === "MHC_IAS") {
          ctrl.filters.idPatient = ctrl.patient.id;
        } else {
          ctrl.filters.stay = ctrl.stay.id;
        }
      }
      categories = feature.metadata.message_categories;
      Message.initMessageCategory(categories);
      return feature;
    });
  };

  var getFeed = function() {
    FeedUtils.getFeedsByName(ctrl.featureName).then(function(feeds) {
      var params;
      params = {
        stay: ctrl.filters.stay,
        feature: ctrl.feature.id,
        id: ctrl.user.id
      };
      if (ctrl.feature.name === "MHC_IAS" || ((ctrl.stay != null) && ctrl.allStays)) {
        delete params.stay;
        params.idPatient = ctrl.patient.id;
      }
      return User.getReadMessages(params).$promise.then(function(readMessages) {
        ctrl.readMessages = readMessages;
        return ctrl.initializeFeed.resolve(feeds);
      });
    });
    return ctrl.initializeFeed.promise;
  };

  ctrl.CenterCreationField = function(eltId) {
    $('html, body').animate({
      'scrollTop': $('#' + eltId).offset().top - 75
    }, 500);
    return true;
  };

  ctrl.closeWaiter = function() {};

  ctrl.gotToTop = function() {
    $location.hash('top');
    return $anchorScroll();
  };

  ctrl.isLastCategory = function(category) {
    return categories[category] === category;
  };

  var gotoAnchor = function(uid) {
    var newHash;
    newHash = 'response' + uid;
    if ($location.hash() !== newHash) {
      return $location.hash('response' + uid);
    } else {
      return $anchorScroll();
    }
  };

  var mgappCloseRequest = function() {
    if (ctrl.previousState != null) {
      return $state.go(ctrl.previousState.name);
    } else {
      switch ($state.current.name) {
        case "user.patient.stay.message.chronologic":
        case "user.patient.stay.message.hierarchic":
          return window.mgapp.close_screen();
        case "user.patient.stay.message.newThread":
          return $state.go("user.patient.stay.message.hierarchic");
      }
    }
  };

  init();
};
MessageListCtrl.$inject = ["$state", "$rootScope", "$filter", "$anchorScroll", "$location", "User", "Message", "FeedUtils", "$q", "FeatureUtils", "SiteVarsUtils", "$log"];


angular.module("mhclientApp")
  .component('messageList', {
    templateUrl: 'message/components/message-list-component/message-list-component.html',
    controller: MessageListCtrl,
    bindings: {
      patient: '<',
      stay: '<',
      user:'<',
      mode:'@',
      featureName: '@',
      displayHeader: '<',
      displayCount:'@',
      readOnly: '<'
    },
  });

'use strict';

/* **************************************************
* @ngdoc function
* @name mhclientApp.component
* @description
* MessageHierarchicListComponent
* Component of message hierarchic list.
*************************************************** */

var MessageHierarchicListCtrl = function(
    $rootScope,
    $state,
    $anchorScroll,
    $location,
    Message,
    Thread,
    notify,
    Feed,
    $q,
    User,
    TreeBuild) {

  var ctrl = this;

  var threadsPromise = $q.defer();

  var paginationPromise = $q.defer();

  $rootScope.busy = true;

  ctrl.current = {};

  var init = function () {
    ctrl.drawElement = {
      config: {
        readonly: true,
        action: "draw",
        penColor: "black",
        lineWidth: 1,
        zoom: 100,
        smooth: true,
        tolerance: 1.0,
        withNotes: false,
      },
    };
    ctrl.filters = {
      archived: false,
      important: undefined,
      category: undefined,
    };
    var params = {
      stay: ctrl.stay.id,
      feature: ctrl.feature.id,
      id: ctrl.user.id,
    };
    var promises = {
      feeds: ctrl.feedPromise.promise,
      readMessages: User.getReadMessages(params),
    };
    $q.all(promises).then(function (responses) {
      if ($state.params.tab != null) {
        ctrl.current.feed = responses.feeds[$state.params.tab];
      } else {
        ctrl.current.feed = responses.feeds[0];
      }
      ctrl.feed = angular.copy(ctrl.current.feed);

      ctrl.readMessages = responses.readMessages;

      return initVarDisplay();
    });
  };

  var initVarDisplay = function() {
    $rootScope.busy = true;
    return getThreads().then(initTree).then(getAllContent).then(function() {
      if (ctrl.$parent) {
        ctrl.$parent.lastThread = ctrl.threads[0];
      }
      return $rootScope.busy = false;
    });
  };

  var getThreads = function() {
    var params = angular.copy(ctrl.filters);

    if (ctrl.stay != null) {
      if (ctrl.allStays) {
        params.idPatient = ctrl.patient.id;
      } else {
        params.stay = ctrl.stay.id;
     }
    }

    params.feed = ctrl.feed.id;
    params.page_size = 20;
    Thread.api.query(params).$promise.then(function(response) {
      var paginationInfoThread;
      ctrl.nextThreadsURL = response.next;
      ctrl.count = response.count;
      ctrl.unread = response.unread;
      paginationInfoThread = response;
      paginationPromise.resolve(response.next);
      return threadsPromise.resolve(response.results);
    });
    return threadsPromise.promise;
  };

  var initTree = function(threads) {
    ctrl.threads = TreeBuild.initialize(threads);
    if (ctrl.unread > 0 || _.filter(threads, {
      have_new_message: true
    }).length > 0) {
      sendReadMessages();
    }
    ctrl.current.threads = _.map(ctrl.threads, _.clone);
    ctrl.allArchived = _.map(ctrl.threads, 'archived').indexOf(false) < 0;
    return $q.when(ctrl.threads);
  };

  var getAllContent = function(threads) {
    var defer;
    threads.forEach(function(message) {
      if (message.thread.have_new_message) {
        ctrl.getMessages(message);
      }
      message.content = {};
      return getContent(message).promise.then(function(response) {
        return message.content = response.data;
      });
    });
    defer = $q.when(threads);
    return defer.promise;
  };

  var sendReadMessages = function() {
    var params;
    if (ctrl.feature.name !== 'MHC_MESSAGING') {
      params = angular.copy(ctrl.filters);
      params.feed = ctrl.feed.id;
      params.id = ctrl.user.id;
      return User.read_messages(params, {});
    }
  };

  var getContent = function(message) {
    var content;
    if (message != null) {
      return content = Message.getMessageContent(message, ctrl.readMessages);
    }
  };

  var addTree = function(httpResponse) {
    var nextThreads, paginationInfoThread;
    paginationInfoThread = httpResponse;
    nextThreads = TreeBuild.initialize(httpResponse.results);
    if (_.filter(httpResponse.results, {
      have_new_message: true
    }).length > 0) {
      sendReadMessages();
    }
    ctrl.threads = ctrl.threads.concat(nextThreads);
    paginationPromise.resolve(httpResponse.next);
    ctrl.nextThreadsURL = httpResponse.next;
    return $q.when(nextThreads);
  };

  var resetFilters = function() {
    ctrl.filters.archived = false;
    ctrl.filters.important = void 0;
    return ctrl.filters.category = void 0;
  };

  ctrl.applyFilter = function(viewFilters) {
    var paginationPromise, threadsPromise;
    resetFilters();
    _.extend(ctrl.filters, viewFilters);
    threadsPromise = $q.defer();
    paginationPromise = $q.defer();
    ctrl.filters.important = viewFilters.important === true ? true : void 0;
    ctrl.filters.category = viewFilters.category === "null" ? void 0 : viewFilters.category;
    ctrl.filters.unread = viewFilters.unread === true ? true : void 0;
    return initVarDisplay();
  };

  ctrl.archive = function(thread) {
    thread.archived = true;
    if (thread.data == null) {
      thread.data = {};
    }
    thread.data.archivedDate = new Date();
    Thread.api.update({
      id: thread.id
    }, thread);
    ctrl.count = ctrl.count - 1;
    return ctrl.allArchived = true;
  };

  ctrl.unarchive = function(thread) {
    thread.archived = false;
    Thread.api.update({
      id: thread.id
    }, thread);
    return ctrl.count = ctrl.count + 1;
  };

  ctrl.isImage = function(attachment) {
    var ref;
    if ((ref = attachment.split('.').pop()) === 'jpg' || ref === 'gif' || ref === 'jpeg' || ref === 'png') {
      return true;
    }
    return false;
  };

  ctrl.getMessages = function(node) {
    var allContentPromises;
    allContentPromises = [];
    if (node.nodes.length === 0 && node.thread.messages_count > 1) {
      return Thread.api.get_messages({
        id: node.thread.id
      }).$promise.then(function(messages) {
        var tree;
        messages.forEach(function(message) {
          var promise, ref;
          message.read = _.indexOf(ctrl.readMessages, message.id) >= 0 ;
          promise = getContent(message).promise;
          allContentPromises.push(promise);
          return promise.then(function(messageResponse) {
            return message.content = messageResponse.data;
          });
        });
        tree = TreeBuild.deepConstruct(messages, node.id);
        node.nodes = tree;
        return $q.all(allContentPromises).then(function() {
          return gotoAnchor(_.last(messages).uid);
        });
      });
    }
  };

  ctrl.markAsRead = function(node) {
    var params;
    params = {
      id: ctrl.user.id,
      messageId: node.id
    };
    $rootScope.busy = true;
    return User.read_one_message(params, {}).$promise.then(function(Response) {
      var child, i, len, ref;
      node.read = true;
      node.thread.have_new_message = false;
      ref = node.nodes;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        child.read = true;
      }
      ctrl.unread = ctrl.unread - 1;
      return $rootScope.busy = false;
    });
  };

  ctrl.addNextThreads = function() {
    var paginationPromise = $q.defer();
    if ($rootScope.busy) {
      return;
    }
    paginationPromise.promise.then(function(nextUrl) {
      $rootScope.busy = true;
      if (nextUrl === null) {
        return $rootScope.busy = true;
      }
      return Thread.getNext(nextUrl).then(addTree).then(getAllContent).then(function(promise) {
        return $rootScope.busy = false;
      });
    });
  };

  ctrl.closeWaiter = function() {};

  ctrl.gotToTop = function() {
    $location.hash('top');
    return $anchorScroll();
  };

  var gotoAnchor = function(uid) {
    var newHash;
    newHash = 'response' + uid;
    if ($location.hash() !== newHash) {
      return $location.hash('response' + uid);
    } else {
      return $anchorScroll();
    }
  };


  init();
};
MessageHierarchicListCtrl.$inject = ["$rootScope", "$state", "$anchorScroll", "$location", "Message", "Thread", "notify", "Feed", "$q", "User", "TreeBuild"];


angular.module("mhclientApp")
  .component('messageHierarchicList', {
    templateUrl: 'message/components/message-hierarchic-list-component/message-hierarchic-list-component.html',
    controller: MessageHierarchicListCtrl,
    bindings: {
      patient: '<',
      stay: '<',
      feedPromise:'<',
      featureFolder: '<',
      displayHeader: '<',
      displayCount:'<',
      readOnly: '<',
      feature: '<',
      user: '<'
    },
  });

'use strict';


// TODO punctual_activities
// billing_activities
// cotation widget 3 fois semaine
// autocompletion referent, consignee and ${contentData.date|date}"


// def get_cotation(self, obj):
// # TODO find a better way to register cotations, it's not easily retrievable
// if "export_cotation" in obj.activity.data:
//     return obj.activity.data["export_cotation"]



angular.module("mhclientApp").component("missionLetterMajorationsDisplay", {
  templateUrl: "mission-letter/views/mission-letter-majorations-display.html",
  controller: ["$rootScope", "Sequence", "Activity", "BillingUnitUtils", "SiteVarsUtils", function missionLetterSequencesCtrl($rootScope, Sequence, Activity, BillingUnitUtils, SiteVarsUtils) {
    var ctrl = this;
  }],
  bindings: {missionLetter: "<", config: "<"},
});

angular.module("mhclientApp").component("missionLetterSequencesDisplay", {
  templateUrl: "mission-letter/views/mission-letter-sequences-display.html",
  controller: ["$rootScope", "SiteVarsUtils", function missionLetterSequencesCtrl($rootScope, SiteVarsUtils) {
    var ctrl = this;
    SiteVarsUtils.getValue("DISPLAY_COTATION_IN_MISSION_LETTER", false).then (function(displayCotation){
      ctrl.done = true
      ctrl.displayCotation = displayCotation
    })

  }],
  bindings: {missionLetter: "<",},
});


angular.module("mhclientApp").component("missionLetterSequenceEditor", {
  templateUrl: "mission-letter/views/mission-letter-sequence-editor.html",
  controller: ["$rootScope", "$q", "$filter", "BillingUnitUtils", "SiteVarsUtils", function missionLetterSequenceEditorCtrl($rootScope, $q, $filter, BillingUnitUtils, SiteVarsUtils) {

    var ctrl = this;
    ctrl.showDetails = false
    BillingUnitUtils.getCareBillingUnits().then (function(billingUnits){
      SiteVarsUtils.getValue('COTATION_STRATEGY', "NGAP").then (function(cotationStrategy){
        ctrl.done = true
        ctrl.cotationStrategy = cotationStrategy
      })
    })

    ctrl.$onChanges = function(changes) {
      if (changes.groupInvolved) {
        $rootScope.busy = true
        ctrl.sequence.is_selected = false
        _.forEach(ctrl.sequence.billing_activities, function(billingActivity) {billingActivity.is_selected = false})
        ctrl.toggleSequence()
        $q.when(changes.groupInvolved.currentValue ? BillingUnitUtils.getBillingUnitsForCategories({group: changes.groupInvolved.currentValue.id}) : []).then (function(billingUnits){
          ctrl.sequence.majorations = _.cloneDeep(_.reject(_.filter(billingUnits, function(bu){ return bu.data.display_scope == 'sequence'}), "obsolete"))
          $rootScope.busy = false
        })
      }
    }

    ctrl.toggleSequence = function(event){
      ctrl.showDetails = ctrl.showDetails || ctrl.sequence.is_selected
      if (event) {event.stopPropagation()}
      _.forEach($filter("missionLetterBillingActivityFilter")(ctrl.sequence.billing_activities, ctrl.groupInvolved), function(billingActivity) {billingActivity.is_selected = ctrl.sequence.is_selected})
    }

    ctrl.estimateSequencePrice = function () {
      try{
        var liberalBillingActivities = _.filter(ctrl.sequence.billing_activities, {is_selected: true, activity: {planning_data: {has_liberal: true}}})
        var standardBillingActivities =  _.reject(liberalBillingActivities, "activity.is_extra")
        _.forEach(liberalBillingActivities, function(billingActivity){billingActivity.estimatedPrice = (billingActivity.base_cost.current_value || 0) * billingActivity.quantity})
        if (!ctrl.sequence.customCotations){
          _.forEach(_.filter(liberalBillingActivities, "activity.is_extra"), function(billingActivity) {billingActivity.cotation = 1})
          if (ctrl.cotationStrategy == "NGAP"){
            _.forEach(_.orderBy(standardBillingActivities, ["estimatedPrice"], ["desc"]), function(billingActivity, index){
              if (index == 0){billingActivity.cotation = 1}
              else if (index == 1){billingActivity.cotation = 0.5}
              else {billingActivity.cotation = 0}
            })
          }
          else{
            _.forEach(standardBillingActivities, function(billingActivity){billingActivity.cotation = 1})
          }
        }
        ctrl.sequence.data.price = _.sum(_.map(liberalBillingActivities, function(billingActivity){
          var planning_data = billingActivity.activity.is_extra ? billingActivity.activity.planning_data : ctrl.sequence.planning_data
          var factor = 1
          if (planning_data.type == "dates"){ factor = (planning_data.dates || []).length }
          if (planning_data.type == "cycled" && planning_data.frequency_unit == "days" && planning_data.frequency){ factor = 7 / planning_data.frequency }
          if (planning_data.type == "cycled" && planning_data.frequency_unit == "weeks" && planning_data.frequency && planning_data.week_days){ factor = planning_data.week_days.length / planning_data.frequency }
          if (planning_data.type == "floating" && planning_data.quantity){ factor = planning_data.quantity }
          return billingActivity.cotation * billingActivity.estimatedPrice * factor
        })).toFixed(2)
        return ctrl.sequence.data.price

      } catch (_error) { console.log(_error)}

    }

  }],
  bindings: {sequence: "<", groupInvolved: "<"},
});


angular.module("mhclientApp").component("missionLetterDisplay", {
  template: "<medform-root-field class=\"ml-form\" ng-if=\"::$ctrl.done\" config=\"::{readOnly: true, mode: 'display'}\" root=\"::$ctrl.dynamicForm\" static-data=\"::$ctrl.staticData\" content-data=\"$ctrl.missionLetter.data\"></medform-root-field>",
  controller: ["$rootScope", "$scope", "$q", "BillingUnitUtils", "MissionLetter", "MissionLetterTemplate", "MedFormsUtils", "Sequence", "Activity", function missionLetterDisplayCtrl($rootScope, $scope, $q, BillingUnitUtils, MissionLetter, MissionLetterTemplate, MedFormsUtils, Sequence, Activity) {

    var ctrl = this;
    $rootScope.busy = true
    MedFormsUtils.getStaticData($rootScope.currentPatient, $rootScope.currentStay).then (function(customScope){
      MissionLetter.api.get({id:ctrl.missionLetter.id}).$promise.then (function(mlDetails){
        MissionLetterTemplate.get({id:ctrl.missionLetter.template}).$promise.then (function(missionLetterTemplate){
          BillingUnitUtils.getBillingUnitsForCategories({group: ctrl.missionLetter.group_involved}).then (function(billingUnits){
            BillingUnitUtils.getCareBillingUnits().then (function(careBillingUnits){
              Sequence.api.query({mission_letter: ctrl.missionLetter.id}).$promise.then (function(sequences) {
                Activity.api.query({mission_letter: ctrl.missionLetter.id}).$promise.then (function(activities) {
                  mlDetails.sequences = sequences
                  ctrl.dynamicForm = missionLetterTemplate.content
                  ctrl.staticData = customScope
                  ctrl.staticData.missionLetter = mlDetails
                  ctrl.missionLetter.author_full_name = mlDetails.author_full_name
                  var careBu = _.keyBy(careBillingUnits, 'id')
                  var globalBillingUnitById = _.keyBy(_.reject(billingUnits, {data : {display_scope: 'sequence'}}), 'id')
                  var sequenceBillingUnitById = _.keyBy(_.filter(billingUnits, {data : {display_scope: 'sequence'}}), 'id')
                  var billingActivitiesByActivity = _.keyBy(mlDetails.billing_activities, 'activity')
                  _.forEach(sequences, function(sequence){

                      sequence.billing_activities =
                        _.orderBy(
                          _.reject(
                            _.map(
                              _.filter(activities, {sequence: sequence.id}),
                              function(activity) {
                                return  _.assign(billingActivitiesByActivity[activity.id], {activity: activity, base_cost: careBu[billingActivitiesByActivity[activity.id].base_cost]})
                              }
                            ),
                          "punctual_activity"
                          ),
                          ['activity.is_extra', 'activity.id']
                        )
                      sequence.majorations = _.map(_.filter(_.filter(mlDetails.sequence_majorations, {sequence: sequence.id}), function(seqMajoration){return sequenceBillingUnitById[seqMajoration.majoration]}), function(seqMajoration){return _.assign(seqMajoration, sequenceBillingUnitById[seqMajoration.majoration])})
                  })
                  mlDetails.majorations = _.map(
                    _.filter(_.uniqBy(mlDetails.sequence_majorations, "majoration"), function(seqMajoration){ return globalBillingUnitById[seqMajoration.majoration]}),
                    function(seqMajoration){ return _.assign(seqMajoration, globalBillingUnitById[seqMajoration.majoration])
                  })
                  ctrl.done = true
                  $rootScope.busy = false
                })
              })
            })
          })
        })
      })
    })
  }],
  bindings: {missionLetter: "<"},
});


angular.module("mhclientApp").component("missionLetterMajorations", {
  templateUrl: "mission-letter/views/mission-letter-majorations.html",
  controller: ["$q", "$rootScope", "BillingUnitUtils", "MissionLetterTemplate", function missionLetterMajorationsCtrl($q, $rootScope, BillingUnitUtils, MissionLetterTemplate) {
    var ctrl = this;
    var currentGroup = null
    ctrl.$onChanges = function(changes) {
      if (changes.groupInvolved && changes.groupInvolved.currentValue != currentGroup) {
        currentGroup = changes.groupInvolved.currentValue
        $rootScope.busy = true
        BillingUnitUtils.getBillingUnitsForCategories({group: currentGroup.id}).then (function(billing_units){
          MissionLetterTemplate[currentGroup.current_mission_template ? "get": "getDefault"]({id: currentGroup.current_mission_template}).$promise.then (function(template){
            ctrl.missionLetter.template = template
            ctrl.missionLetter.majorations = _.cloneDeep(_.reject(_.filter(billing_units, function(bu){ return bu.data.display_scope != 'sequence'}), "obsolete"))
            ctrl.majorations = ctrl.missionLetter.majorations
            $rootScope.busy = false
          })
        })
      }
    }
  }],
  bindings: {missionLetter: "<", groupInvolved: "<?", config: "<"},
});



angular.module("mhclientApp").component("missionLetterReferents", {
  templateUrl: "mission-letter/views/mission-letter-referents.html",
  controller: ["$rootScope", "Group", function missionLetterReferentsCtrl($rootScope, Group) {

    var ctrl = this;
    ctrl.computeConsignee = function () {
      ctrl.missionLetter.data.consignee = _.map(ctrl.missionLetter.users, "full_name").join(', ')
      if (ctrl.missionLetter.referent){
        var address = _.compact(_.at(ctrl.missionLetter.referent.data.address_data, ['address', 'zip_code', 'town'])).join("<br>")
        if (address){ ctrl.missionLetter.data.consignee += ",<br>" + address}
      }
      return ctrl.missionLetter.data.consignee
    }

    ctrl.removeUser = function(user){
      $rootScope.removeFromArray(ctrl.missionLetter.users, user)
      if (ctrl.missionLetter.referent == user){ delete ctrl.missionLetter.referent;}
    }

    ctrl.selectUser = function(user) {
      ctrl.missionLetter.users.push(_.clone(user))
      if (ctrl.missionLetter.users.length == 1){
        ctrl.missionLetter.referent = ctrl.missionLetter.users[0]
      }
    }

    Group.query({"liberal": true}).$promise.then (function(liberalGroups){
      var availableGroupsUids = [].concat.apply([], _.map(ctrl.sequences, function(sequence) {return [].concat.apply([], _.map(sequence.billing_activities, function(billing_activity){ return _.keys(billing_activity.activity.planning_data.caregivers)}))}))
      ctrl.availableGroups = _.filter(liberalGroups, function(group) {return _.includes(availableGroupsUids, group.uid)})
    })

    ctrl.onGroupChange = function(){
      ctrl.missionLetter.users = []
      ctrl.missionLetter.referent = null
      _.forEach(ctrl.missionLetter.sequences, function(sequence){
        _.forEach(sequence.billing_activity, function(billing_activity){ billing_activity.is_selected = false; return})
        sequence.is_selected = false
        return
      })
      ctrl.missionLetter.sequences = []
    }

  }],
  bindings: {missionLetter: "<", stay: "<", patient: "<", sequences: "<"},
});


angular.module("mhclientApp").component('missionLetterPreviewModal', {
    templateUrl: "mission-letter/views/mission-letter-preview-modal.html",
    controller: ["MedFormsUtils", function missionLetterPreviewModalCtrl(MedFormsUtils){
      var ctrl = this;
      ctrl.$onInit = function () {
        ctrl.waiter =  true
        MedFormsUtils.getStaticData(ctrl.resolve.patient, ctrl.resolve.stay).then (function(customScope){
          ctrl.missionLetter = ctrl.resolve.missionLetter
          ctrl.dynamicForm = ctrl.missionLetter.template.content
          ctrl.staticData = customScope
          ctrl.staticData.missionLetter = ctrl.missionLetter
          ctrl.waiter = false
        })
      }
    }],
    bindings: {resolve: '<', modalInstance: "<", close: '&'},
});

'use strict';

angular.module("mhclientApp").component("missionLetterEditor", {
  templateUrl: "mission-letter/views/mission-letter-editor.html",
  controller: ["$scope", "$timeout", "$rootScope", "$q", "GroupUtils", "Group", "MissionLetterTemplate", "MedFormsUtils", function missionLetterEditorCtrl($scope, $timeout, $rootScope, $q, GroupUtils, Group, MissionLetterTemplate, MedFormsUtils) {

    var ctrl = this;

    $scope.$on('getFields', function (event){
      event.data = [
        {
          type: "userSelection",
          key: "referent",
        },
        {
          type: "text",
          key: "consignee",
        }
      ]
      event.stopPropagation()
    })

    ctrl.setGroupTemplate = function(group, missionTemplateId, value){
      $rootScope.busy = true;
      if (group === undefined) { return; }
      var currentMissionTemplateId = missionTemplateId;
      if (value === 'remove') {
        currentMissionTemplateId = null;
      }

      Group.update({id:group.id}, {current_mission_template: currentMissionTemplateId}).$promise.then (function(updatedGroup){
        group.current_mission_template = updatedGroup.current_mission_template;
        $rootScope.busy = false;
      })
    }

    ctrl.setNewDefault = function(){
      $rootScope.busy = true
      MissionLetterTemplate.setDefault({id:ctrl.currentVersion.id}).$promise.then (function(){$rootScope.busy = false})
    }

    ctrl.save = function(){
      $rootScope.busy = true
      MissionLetterTemplate.save(ctrl.currentVersion).$promise.then (function(newTemplate){
        _.forEach(ctrl.currentGroups, function(currentGroup) {ctrl.setGroupTemplate(_.find(ctrl.groups, {id: currentGroup.id}), newTemplate.id)})
        ctrl.templates.push(newTemplate)
        ctrl.currentVersion = newTemplate
        $rootScope.busy = false
      })
    }

    ctrl.selectTemplate = function(template){
      ctrl.currentGroups = _.filter(ctrl.groups, {current_mission_template: template.id})
    }

    ctrl.modifyTemplate = function(){
      ctrl.currentVersion = _.omit(ctrl.currentVersion, 'id')
    }

    ctrl.newTemplate = function(){
      ctrl.currentVersion = null
      ctrl.currentGroups = []
      $timeout(function() {
        ctrl.currentVersion = {
          "name": "",
          "content": {
            "type": "root",
            "fields": [
                {
                    "isProtected": true,
                    "type": "mission-majorations",
                    "uid": "majorations"
                },
                {
                    "isProtected": true,
                    "type": "mission-sequences",
                    "uid": "mission_sequences"
                },
                {
                    "isProtected": true,
                    "key": "comment",
                    "rich_text": true,
                    "type": "text",
                    "uid": "comment"
                },
            ],
          },
          "comment": "",
          "obsolete": false,
          "is_default": false,
        }
      })
    }

    MedFormsUtils.getStaticData().then (function(customScope){
      GroupUtils.getGroups().then(function(groups){
        MissionLetterTemplate.query().$promise.then ( function(templates){

          ctrl.groups = groups
	  ctrl.templates = templates.filter(function(t) {
            return !t.obsolete;
          });
          ctrl.currentVersionConfig = {
            editable: true,
            canAdd: true,  // $ctrl.version.is_draft,
            canDelete: true, //$ctrl.version.is_draft,
            showConditionHelper: true,
            availableFields: ["section", "multiline", "block", "accordion", "legend", "table", "pageBreak", "list", "newHtml"],
            allowedTypes: null,
            allowCopy: true,
            allowImportJson: true,
            canEdit: true, // $ctrl.version.is_draft
          }
          ctrl.customScope = customScope
          ctrl.contentData = {
                  "date": "2024-06-18T08:17:40.226Z",
                  "group": null,
                  "comment": "\n    Commentatario        ",
                  "consignee": "Mhcommm Mhadmin,<br>42 avenue du général de croutte<br>31100<br>Toulouse",
          }

          ctrl.customScope.missionLetter = {
              "referent": {
                      "data": {
                          "phone": "",
                          "fax_number": "0981481340",
                          "address_data": {
                              "town": "Toulouse",
                              "address": "42 avenue du général de croutte",
                              "country": "France",
                              "zip_code": "31100"
                          },
                          "company_name": "",
                          "occupation_category": ""
                      },
                      "email": "support@mhcomm.fr",
                      "group": {
                          "name": "Administrateur",
                      },
                      "phone": "0781481340",
                      "ext_id": null,
                      "finess": null,
                      "id_nat": "8100012345678",
                      "sector": null,
                      "username": "mhadmin",
                      "__display": "Mhcommm Mhadmin",
                      "full_name": "Mhcommm Mhadmin",
                      "occupation": "Support MHComm",
                      "pro_category": "emp"
                  },
              "sequences": [
                  {
                      "planning_data": {
                          "display_text": "Cosa rara fdffd. Tous les jours, entre 11:00 et 13:00, à partir du lundi 17 juin 2024 pour une durée indéterminée.",
                      },
                      "billing_activities": [
                          {
                              "quantity": "15.00",
                              "cotation": "1.00",
                              "activity": {
                                  "planning_data": {
                                      "caregivers": {
                                          "tSzhYovRWKqJZHLFcyIqDjUlvStwqrbYemtpvWJcvZYpoxSMgWoXgwGocmQGTIdSvZWQfIEcRJsLlBaZZSwPqMATwbSWVnpXGJutEZrmeSRthvzsgBmMJpnNcLcKgViM": {
                                              "count": 1,
                                              "liberal": true,
                                              "group_name": "Administrateur"
                                          }
                                      },
                                  },
                                  "data": {
                                      "label": "Forfait pour séance de perfusion d'une durée supérieure à une heure, avec organisation d'une surveillance",
                                      "comment": "Pas durent le repas",
                                  },
                              },
                              "base_cost": {"short_name": "AMI"}
                          },
                          {
                              "quantity": "10.00",
                              "cotation": "1.00",
                              "activity": {
                                  "planning_data": {
                                      "caregivers": {
                                          "tSzhYovRWKqJZHLFcyIqDjUlvStwqrbYemtpvWJcvZYpoxSMgWoXgwGocmQGTIdSvZWQfIEcRJsLlBaZZSwPqMATwbSWVnpXGJutEZrmeSRthvzsgBmMJpnNcLcKgViM": {
                                              "count": 1,
                                              "liberal": true,
                                              "group_name": "Administrateur"
                                          }
                                      },
                                      "display_text": "Forfait pour séance de perfusion courte, d'une durée inférieure ou égale à une heure, sous surveillance continue. Undefinedtrois fois par semaine, entre 11:00 et 13:00, à partir du lundi 17 juin 2024 pour une durée indéterminée.",
                                  },
                                  "data": {
                                      "label": "Forfait pour séance de perfusion courte, d'une durée inférieure ou égale à une heure, sous surveillance continue",
                                  },
                                  "is_extra": true,
                              },
                              "base_cost": {"short_name": "AMI"}
                          },
                          {
                              "quantity": "4.10",
                              "cotation": "0.50",
                              "activity": {
                                  "planning_data": {
                                      "caregivers": {
                                          "tSzhYovRWKqJZHLFcyIqDjUlvStwqrbYemtpvWJcvZYpoxSMgWoXgwGocmQGTIdSvZWQfIEcRJsLlBaZZSwPqMATwbSWVnpXGJutEZrmeSRthvzsgBmMJpnNcLcKgViM": {
                                              "count": 1,
                                              "liberal": true,
                                              "group_name": "Administrateur"
                                          }
                                      },
                                  },
                                  "data": {
                                      "label": "Changement de flacon(s) ou branchement en Y sur dispositif en place ou intervention pour débranchement ou déplacement du dispositif ou contrôle du débit, pour une perfusion sans surveillance continue, en dehors de la séance de pose",
                                  },
                                  "is_extra": false,
                              },
                              "base_cost": {"short_name": "AMI"}
                          }
                      ],
                      "majorations": [
                          {
                              "quantity": "1.00",
                              "short_name": "Majoration nuit de 23H à 05H",
                              "full_name": "Majoration nuit de 23H à 05H",
                          }
                      ]
                  }
              ],
              "majorations": [
                  {
                      "quantity": "1.00",
                      "short_name": "IFD",
                      "full_name": "Indemnité Forfaitaire de déplacement",
                  },
                  {
                      "quantity": "3.00",
                      "short_name": "IK Montagne",
                      "full_name": "IK Montagne",
                      "data": {
                          "quantity_unit": "km",
                          "custom_quantity": true
                      },
                  }
              ]
          }
        })
      })
    })

  }],
  bindings: {},
});

"use strict";

angular.module("mhclientApp").component("addUsersToMissionLetter", {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&"
  },
  templateUrl: "mission-letter/views/add-users-to-mission-letter.html",
  controller: Controller});

function Controller(
    $rootScope,
    $q,
    $filter,
    User,
    GroupUtils,
    MissionLetter,
    MedFormsUtils,
    MissionLetterTemplate
  ) {
  var ctrl = this;
  ctrl.busy = true;
  ctrl.newUsersInvolved = []
  ctrl.removeUser = removeUser
  ctrl.selectUser = selectUser
  ctrl.saveNewUsersInvolved = saveNewUsersInvolved
  function computeUsers() {
    ctrl.copiedLetter.data.consignee =
      ctrl.resolve.letter.data.consignee +
      "\n" +
      _.map(ctrl.newUsersInvolved, function (user) {
        return $filter("translate")("LETTER_USER_ADDED_ON", {name: user.full_name, date: $filter("date")(moment().toDate(), "mediumDate")})
      }).join("\n"); // to force medformRootField to compute data
    ctrl.allUsersInvolved = _.concat(
      ctrl.originalUsersInvolved,
      ctrl.newUsersInvolved
    );
  };

  function removeUser(user) {
    $rootScope.removeFromArray(ctrl.newUsersInvolved, user);
    computeUsers();
  };

  function selectUser(user) {
    ctrl.newUsersInvolved.push(user);
    computeUsers();
  };

  function saveNewUsersInvolved() {
    if (ctrl.newUsersInvolved.length === 0) {
      ctrl.close();
      return;
    }
    ctrl.busy = true;
    $rootScope.busy = true; // to avoid interaction if Esc pressed during action
    MissionLetter.api
      .update_involved_users(
        { id: ctrl.copiedLetter.id },
        {
          users_involved: _.map(ctrl.allUsersInvolved, "id"),
          data: ctrl.copiedLetter.data
        }
      )
      .$promise.then(function (mission_letter) {
        ctrl.resolve.letter.users_involved = mission_letter.users_involved;
        ctrl.resolve.letter.data = mission_letter.data;
        ctrl.resolve.letter.history = mission_letter.history
        ctrl.busy = false;
        $rootScope.busy = false;
        ctrl.close();
      });
  };

  ctrl.$onInit = function () {
    ctrl.copiedLetter = _.cloneDeep(ctrl.resolve.letter);
    $q.all([
      MedFormsUtils.getStaticData($rootScope.currentPatient, $rootScope.currentStay),
      MissionLetterTemplate.get({id:ctrl.copiedLetter.template}).$promise,
      GroupUtils.getGroup({ id: ctrl.copiedLetter.group_involved }),
      $q.all(_.map(ctrl.copiedLetter.users_involved, function (uId) {return User.get({ id: uId }).$promise}))
    ]).then(function(data) {
      ctrl.staticData = data[0]
      ctrl.missionLetterTemplate = data[1]
      ctrl.involvedGroupUid = data[2].uid;
      ctrl.originalUsersInvolved = data[3];
      ctrl.staticData.missionLetter = ctrl.copiedLetter
      ctrl.allUsersInvolved = ctrl.originalUsersInvolved; // to avoid proposition on userSelection component
      ctrl.busy = false
    })
  };
}


(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.mission-letter.mission-letter-users
    * @description
    * filter users which are already in collection
   */
  angular.module('mhclientApp').filter('missionLetterUsers', function() {
    return function(patientUsers, search_text, selectedUsers) {
      var filtered, has_search_text, i, len, regex, searchVal, user;
      has_search_text = (search_text != null) && search_text.length > 0;
      if (has_search_text) {
        searchVal = search_text.replace(/([()[{*+.$^\\|?])/g, '\\$1');
        regex = new RegExp('' + searchVal, 'i');
      }
      if (has_search_text) {
        filtered = [];
        for (i = 0, len = patientUsers.length; i < len; i++) {
          user = patientUsers[i];
          if (regex.test(user.full_name)) {
            filtered.push(user);
          }
        }
      } else {
        filtered = patientUsers;
      }
      return _.filter(filtered, function(user) {
        return _.find(selectedUsers, function(o) {
          return o.id === user.id;
        }) === void 0;
      });
    };
  });

}).call(this);

//# sourceMappingURL=mission-letter-users-filter.js.map


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:monographyModal
* @description
* Modal component which displays the drug monography
* **********************************************/

var monographyModalCtrl = function() {
  var ctrl = this;

  ctrl.close = function() {
    ctrl.onClose();
  };

};

angular.module("mhclientApp").component("monographyModal", {
  templateUrl: "medicaldb/components/monography-modal/monography-modal.html",
  controller: monographyModalCtrl,
  bindings: {
    monographyUrl: "<",
    platform: "<",
    onClose: "&",
  },
});

'use strict';


angular.module("mhclientApp").component("medicaldbCheckModal", {
    templateUrl: "medicaldb/components/medicaldb-check/medicaldb-check.html",
    controller: ["$rootScope", "$q", "$sce", "$location", "PrescUtils", "Patient", "Stay", function medicaldbCheckModalCtrl($rootScope, $q, $sce, $location, PrescUtils, Patient, Stay){


      var ctrl = this;
      ctrl.busy = true
      ctrl.getBCBPosologiesCodes = PrescUtils.getBCBPosologiesCodes
      ctrl.$onInit = function () {
        PrescUtils.getBCBVersion().promise.then (function(bcbVersion){
          ctrl.bcbVersion = bcbVersion;
          $q.when($rootScope.mh_config.platform == "mhsi" ? mhsiCheck() : mgAppCheck()).then (function(mdbCheck){
            ctrl.mdbCheck = mdbCheck
            ctrl.mdbCheck.stupefiantProducts = _.uniq(_.map(_.filter(_.reject(ctrl.resolve.prescriptions, {state: "STOPPED"}), {data: {bdm_data: {is_stupefiant: '1'}}}), "data.name"))
            ctrl.busy = false
          })
        })
      };

      var mgappCheck = function (patientId, ordonnanceId, cips) {
        return Patient.getCurrentCIPS({id:ctrl.resolve.patientId, cart:ctrl.resolve.ordonnanceId}).$promise.then ( function(cip_list) {
          return Medicaldb.check({drugs:cip_list}).$promise.then ( function(mdbCheck){ return mdbCheck})
        })
      }

      var mhsiCheck = function () {


        var cips = _.uniq(ctrl.resolve.cips)
        return Stay.getControlPharma({id:ctrl.resolve.stayId, cart:ctrl.resolve.ordonnanceId, cip: cips.length > 0 ? cips : null, substitution: ctrl.resolve.substitutions}).$promise.then (function (mdbCheck){
          mdbCheck.control_html = mdbCheck.control_html.replaceAll("href='#", "href='#" + $location.path() +"#").replaceAll('href="#', 'href="#' + $location.path() +'#');
          mdbCheck.control_html = $sce.trustAsHtml(mdbCheck.control_html)
          mdbCheck.printUrl = $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/api_rest/stays/'+ctrl.resolve.stayId+'/control_pdf?'
          if (cips.length > 0){
            mdbCheck.printUrl = mdbCheck.printUrl + 'cip='+ _.join(cips, '&cip=') + "&"
          }
          if (ctrl.resolve.ordonnanceId){
            mdbCheck.printUrl = mdbCheck.printUrl + 'cart='+ ctrl.resolve.ordonnanceId + "&"
          }
          if (ctrl.resolve.substitutions){
            mdbCheck.printUrl = mdbCheck.printUrl + 'substitution='+ _.join(ctrl.resolve.substitutions, '&substitution=') + "&"
          }
          return mdbCheck
       })
      }



    }],
    bindings: {resolve: '<', close: '&', dismiss: '&'},
  });
'use strict';


angular.module("mhclientApp").component("medicaldbResource", {
  templateUrl: "medicaldb/components/medicaldb-resource.html",
  controller: ["Medicaldb", function medicalDB(Medicaldb) {
    var ctrl = this;
    ctrl.items = ctrl.items || []
    ctrl.source = {
      "cim10": Medicaldb.getPathologies,
      "ccam": Medicaldb.getMedicalActs,
      "allergy": Medicaldb.getAllergies
    }[ctrl.resourceType]

  }],
  bindings: {singleChoice: "<", readOnly: "<", required: "<", field: "<", resourceType: "<", items: "=", placeHolder: "<"},
});

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Medicaldb
    * @description
    * # Medicaldb
    * Factory of Medicaldb
   */
  angular.module("mhclientApp").factory('Medicaldb', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, medicaldb, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/medicaldb/:id/:route', {}, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'get': {
        method: 'GET',
        params: {
          id: '@id'
        }
      },
      'check': {
        method: 'GET',
        params: {
          route: 'check',
          id: '@id'
        }
      },
      'version': {
        method: 'GET',
        params: {
          route: 'get_version_string'
        },
        isArray: false
      },
      'getBCBState': {
        method: 'GET',
        params: {
          route: 'get_bcb_state'
        },
        isArray: false
      },
      'getPathologies': {
        method: 'GET',
        params: {
          route: 'search_pathologies'
        },
        isArray: true
      },
      'getAllergies': {
        method: 'GET',
        params: {
          route: 'search_allergies'
        },
        isArray: true
      },
      'getMedicalActs': {
        method: 'GET',
        params: {
          route: 'search_medical_acts'
        },
        isArray: true
      },
      'getMonography': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_monography'
        }
      },
      'clearBook': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'clear_book'
        }
      },
      'getUcd': {
        method: 'GET',
        params: {
          route: 'get_ucd'
        }
      },
      'searchProducts': {
        method: 'GET',
        params: {
          route: 'search_products'
        },
        isArray: true
      },
      'searchAllDrugs': {
        method: 'GET',
        params: {
          route: 'search_all_drugs'
        }
      },
      'insertBulkBook': {
        method: 'GET',
        params: {
          route: 'insert_bulk_book'
        }
      },
      'searchInn': {
        method: 'GET',
        params: {
          route: 'search_inn'
        },
        isArray: true
      },
      'getProductsForDci': {
        method: 'GET',
        params: {
          route: 'get_products_for_dci'
        },
        isArray: false
      },
      'getTakingUnits': {
        method: 'GET',
        params: {
          route: 'get_taking_units'
        },
        isArray: true
      },
      'getNumberOfBox': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_number_of_box'
        }
      },
      'searchProductsByCis': {
        method: 'GET',
        params: {
          route: 'search_products_by_cis'
        },
        isArray: true
      },
      'searchEquivalentProducts': {
        method: 'GET',
        params: {
          route: 'search_equivalent_products'
        },
        isArray: true
      },
      'getSmr': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_smr'
        },
        isArray: true
      },
      'searchByPathology': {
        method: 'GET',
        params: {
          route: 'search_by_pathology'
        },
        isArray: true
      },
      'searchByComponent': {
        method: 'GET',
        params: {
          route: 'search_by_component'
        },
        isArray: true
      },
      'searchComponents': {
        method: 'GET',
        params: {
          route: 'search_components'
        },
        isArray: true
      },
      'getProductComponents': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_product_components'
        }
      },
      'getDocuments': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_documents'
        },
        isArray: true
      },
      'getDocumentContent': {
        method: 'GET',
        params: {
          route: 'get_document_content'
        }
      },
      'getPosologies': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_posologies'
        },
        isArray: true
      },
      'getAnatomicClassChildren': {
        method: 'GET',
        params: {
          route: 'get_anatomic_class_children'
        },
        isArray: true
      },
      'getTherapeuticClassChildren': {
        method: 'GET',
        params: {
          route: 'get_therapeutic_class_children'
        },
        isArray: true
      },
      'getDrugTypeChildren': {
        method: 'GET',
        params: {
          route: 'get_drug_type_children'
        },
        isArray: true
      },
      'searchAnatomicClass': {
        method: 'GET',
        params: {
          route: 'search_anatomic_class'
        },
        isArray: true
      },
      'searchTherapeuticClass': {
        method: 'GET',
        params: {
          route: 'search_therapeutic_class'
        },
        isArray: true
      },
      'searchDrugType': {
        method: 'GET',
        params: {
          route: 'search_drug_type'
        },
        isArray: true
      },
      'searchByAnatomicClass': {
        method: 'GET',
        params: {
          route: 'search_by_anatomic_class'
        },
        isArray: true
      },
      'searchByTherapeuticClass': {
        method: 'GET',
        params: {
          route: 'search_by_therapeutic_class'
        },
        isArray: true
      },
      'searchByDrugType': {
        method: 'GET',
        params: {
          route: 'search_by_drug_type'
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        medicaldb = window.mgapp.get('medical_db').medicaldb();
        boxAPI = BoxResource.generate(medicaldb);
        boxAPI.version = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "get_version_string", object);
        };
        boxAPI.getBCBState = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "get_bcb_state", object);
        };
        boxAPI.searchInn = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "search_inn", object);
        };
        boxAPI.searchProducts = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "search_products", object);
        };
        boxAPI.searchAllDrugs = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "search_all_drugs", object);
        };
        boxAPI.getTakingUnits = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "get_taking_units", object);
        };
        boxAPI.getProductsForDci = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "get_products_for_dci", object);
        };
        boxAPI.check = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "check", object);
        };
        boxAPI.getPathologies = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "get_pathologies", object);
        };
        boxAPI.getMedicalActs = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "get_medical_acts", object);
        };
        boxAPI.getMonography = function(object) {
          return BoxResource.mhboxApiCall(medicaldb, "get_monography", object);
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

}).call(this);

//# sourceMappingURL=medicaldb-service.js.map

angular.module("mhclientApp").factory("MedicalDbUtils", MedicalDbUtilsFactory);

function MedicalDbUtilsFactory($q, Medicaldb, SiteVarsUtils) {
  function getPopulatedDrugFromMedicalDb(cip7) {
    var promises = {
      medicalDbInfo: Medicaldb.get({ id: cip7 }).$promise,
      takingUnits: Medicaldb.getTakingUnits({ cip: cip7 }).$promise,
      highRiskDrugUcds: _getHighRiskDrugUcds(),
      atcRiskDrugs: SiteVarsUtils.getValue("ATC_RISK_DRUGS", []),
    };

    return $q.all(promises).then(function (responses) {
      return _createDrug(
        responses.medicalDbInfo,
        responses.takingUnits,
        responses.highRiskDrugUcds,
        responses.atcRiskDrugs
      );
    });
  }

  function _getHighRiskDrugUcds() {
    return SiteVarsUtils.getValue("HIGH_RISK_DRUGS", []).then(function (drugs) {
      return _.map(drugs, "ucd");
    });
  }
  function _createDrug(
    medicalDbInfo,
    takingUnits,
    highRiskDrugUcds,
    atcRiskDrugs
  ) {
    var drug = mapMedicalDbInfoToDrug(medicalDbInfo);

    drug.takingUnits = takingUnits;

    drug.isHighRisk =
      highRiskDrugUcds.indexOf(medicalDbInfo.ucd) > -1 ||
      _.some(atcRiskDrugs, function (atcRisk) {
        return _.startsWith(drug.atc || "", atcRisk);
      });

    return drug;
  }

  function mapMedicalDbInfoToDrug(medicalDbInfo) {
    var drug = angular.copy(medicalDbInfo);

    drug.cip = medicalDbInfo.cip;
    drug.cip7 = medicalDbInfo.cip;
    drug.cip13 = medicalDbInfo.cip13;
    drug.ucd7 = medicalDbInfo.ucd;
    drug.dci_mode = medicalDbInfo.is_dci;

    drug.name = medicalDbInfo.name;
    drug.routes = medicalDbInfo.routes;
    drug.atc = medicalDbInfo.atc;
    drug.marketing = medicalDbInfo.marketing;
    drug.inn = medicalDbInfo.inn;
    drug.high_cost = medicalDbInfo.high_cost;
    drug.number_of_ucd = medicalDbInfo.number_of_ucd;
    drug.ucd_label = medicalDbInfo.ucd_label;
    drug.is_stupefiant = medicalDbInfo.is_stupefiant;
    drug.name_in_text = medicalDbInfo.name_in_text;
    drug.comment_presc = medicalDbInfo.comment_presc;

    return drug;
  }

  function mapDrugToPrescriptionBdmData(drug) {
    var prescriptionBdmData = {};

    prescriptionBdmData.is_high_risk = drug.isHighRisk;
    prescriptionBdmData.taking_units = drug.takingUnits;
    prescriptionBdmData.marketing_name = drug.marketing;
    prescriptionBdmData.high_cost = null;
    if (drug.high_cost) {
      prescriptionBdmData.high_cost = {
        type: drug.high_cost.type,
      };
    }
    // cip is used for old prescriptions, thus using both cip and cip7
    prescriptionBdmData.cip = drug.cip || drug.cip7;
    prescriptionBdmData.cip7 = drug.cip || drug.cip7;
    prescriptionBdmData.cip13 = drug.cip13;
    prescriptionBdmData.ucd = drug.ucd;
    prescriptionBdmData.ucd7 = drug.ucd7;
    prescriptionBdmData.name = drug.name;
    prescriptionBdmData.routes = drug.routes;
    prescriptionBdmData.atc = drug.atc;
    prescriptionBdmData.inn = drug.inn;
    prescriptionBdmData.number_of_ucd = drug.number_of_ucd;
    prescriptionBdmData.ucd_label = drug.ucd_label;
    prescriptionBdmData.is_stupefiant = drug.is_stupefiant;
    prescriptionBdmData.name_in_text = drug.name_in_text;

    return prescriptionBdmData;
  }

  return {
    getPopulatedDrugFromMedicalDb: getPopulatedDrugFromMedicalDb,
    mapDrugToPrescriptionBdmData: mapDrugToPrescriptionBdmData,
  };
}

angular.module('mhclientApp')
  .component('mobileDeprecatedTable', {
    templateUrl: 'mobile/views/mobile-deprecated-table.html',
    controller: ['MobileDeprecatedVersion', function(MobileDeprecatedVersion) {
      var ctrl = this;

      ctrl.versions = [];
      ctrl.newVersion = {};
      ctrl.today = Date()

      ctrl.init = function() {
        ctrl.versions = MobileDeprecatedVersion.query();
      };

      ctrl.addVersion = function() {
        var payload = _.clone(ctrl.newVersion)
        payload.deprecation_date = moment(payload.deprecation_date).format("YYYY-MM-DD")
        payload.sunset_date = moment(payload.sunset_date).format("YYYY-MM-DD")
        MobileDeprecatedVersion.save(payload, function(response) {
          ctrl.versions.push(response);
          ctrl.newVersion = {};
        });
      };

      ctrl.updateVersion = function(version) {
        var payload = _.clone(version)
        payload.deprecation_date = moment(payload.deprecation_date).format("YYYY-MM-DD")
        payload.sunset_date = moment(payload.sunset_date).format("YYYY-MM-DD")
        MobileDeprecatedVersion.update({ id: version.id }, payload);
      };

      ctrl.deleteVersion = function(id) {
        MobileDeprecatedVersion.delete({ id: id }, function() {
          ctrl.init()
        });
      };

      ctrl.init()
    }]
  });

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CacheDownloadDebugCtrl
    * @description
    * # CacheDownloadDebugCtrl
    * Controller for debug devices
   */
  angular.module('mhclientApp').controller('CacheDownloadDebugCtrl', ["$scope", "$rootScope", "Device", "SiteVar", "SiteVarsUtils", "CacheDownload", "UserUtils", "User", "Patient", function($scope, $rootScope, Device, SiteVar, SiteVarsUtils, CacheDownload, UserUtils, User, Patient) {
    $scope.selectedTypes = [];
    $scope.selectedPatientTypes = [];
    $rootScope.busy = true;
    SiteVar.getMobileSynchroProtocols().$promise.then(function(protocols) {
      return SiteVarsUtils.getValue('MOBILE_FULL_OFFLINE', false).then(function(MOBILE_FULL_OFFLINE) {
        return Patient.query({
          stay_states: ["ADM", "PRE"]
        }).$promise.then(function(patients) {
          return UserUtils.getUsers().then(function(users) {
            return Device.query().$promise.then(function(devices) {
              $scope.patientTypes = _.uniqBy(_.concat(protocols["patient"], protocols["stay"]), "type");
              $scope.MOBILE_FULL_OFFLINE = MOBILE_FULL_OFFLINE;
              $scope.globalTypes = _.reject(protocols["config"], {
                "type": "PATIENT"
              });
              $scope.patients = patients;
              $scope.devices = devices;
              _.forEach($scope.patients, function(patient) {
                return patient.displayLabel = patient.full_name + " " + patient.si_id;
              });
              _.forEach($scope.devices, function(device) {
                var user;
                user = _.find(users, {
                  id: device.user
                }) || {};
                device.displayLabel = device.uid + " " + user.full_name;
              });
              $scope.selectedDevices = [];
              $scope.selectedPatients = [];
              return $rootScope.busy = false;
            });
          });
        });
      });
    });
    $scope.initCache = function() {
      $rootScope.busy = true;
      return CacheDownload.initCache().$promise.then(function() {
        return $rootScope.busy = false;
      });
    };
    $scope.setAutoSyncAll = function() {
      $rootScope.busy = true;
      return CacheDownload.setAutoSyncAll().$promise.then(function() {
        $scope.MOBILE_FULL_OFFLINE = true;
        return $rootScope.busy = false;
      });
    };
    $scope.genGlobalDownloads = function() {
      var postData;
      postData = {
        type: "GLOBAL",
        types: _.map(_.orderBy($scope.selectedTypes, ['order']), "type"),
        select_all: $scope.devices.length === 0,
        devices: _.map($scope.selectedDevices, "id")
      };
      $rootScope.busy = true;
      return CacheDownload.genDownloadsForDebug(postData).$promise.then(function(result) {
        return $rootScope.busy = false;
      });
    };
    return $scope.genPatientDownloads = function() {
      var postData;
      postData = {
        type: "PATIENT",
        types: _.map(_.orderBy($scope.selectedPatientTypes, ['order']), "type"),
        patients: _.map($scope.selectedPatients, "id")
      };
      $rootScope.busy = true;
      return CacheDownload.genDownloadsForDebug(postData).$promise.then(function(result) {
        return $rootScope.busy = false;
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=cache-downloads-debug-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Message
    * @description
    * # Message
    * Factory of Message
   */
  angular.module("mhclientApp").factory('Device', ["$resource", "MhConfig", "$q", function($resource, MhConfig, $q) {
    var acceptHeader, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/devices/:uid', {
      uid: this.uid
    }, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'update': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          uid: '@uid'
        }
      },
      'patch': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    return portailAPI;
  }]).factory('MobileDeprecatedVersion', ["$resource", "MhConfig", function($resource, MhConfig) {
    var acceptHeader, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/mobile_deprecated_versions/:id', {
      id: this.id
    }, {
      query: {
        method: 'GET',
        isArray: true,
        headers: {
          'Accept': acceptHeader
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        }
      },
      save: {
        method: 'POST',
        headers: {
          'Accept': acceptHeader
        }
      },
      update: {
        method: 'PUT',
        headers: {
          'Accept': acceptHeader
        }
      },
      "delete": {
        method: 'DELETE',
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    return portailAPI;
  }]).factory('CacheDownload', ["$resource", "MhConfig", "$q", function($resource, MhConfig, $q) {
    var acceptHeader, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/cache_downloads/:id/:route', {
      uid: this.uid
    }, {
      'genDownloadsForDebug': {
        method: "POST",
        isArray: false,
        params: {
          route: 'gen_downloads_for_debug'
        },
        headers: {
          "Accept": acceptHeader
        }
      },
      'initCache': {
        method: "POST",
        isArray: false,
        params: {
          route: 'init_cache'
        },
        headers: {
          "Accept": acceptHeader
        }
      },
      'setAutoSyncAll': {
        method: "POST",
        isArray: false,
        params: {
          route: 'set_auto_sync_all'
        },
        headers: {
          "Accept": acceptHeader
        }
      }
    });
    return portailAPI;
  }]);

}).call(this);

//# sourceMappingURL=mobile-services.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:NotificationConfigCtrl
    * @description
    * # NotificationConfigCtrl
    * Controller of Notifications
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('NotificationConfigCtrl', ["$scope", "$rootScope", "$window", "$uibModal", "$filter", "$q", "GroupUtils", "AlertConfig", "AlertCategory", "alertUtils", "Upload", "$state", "notify", function($scope, $rootScope, $window, $uibModal, $filter, $q, GroupUtils, AlertConfig, AlertCategory, alertUtils, Upload, $state, notify) {
    $scope.autoDoc = function() {
      var rows;
      $rootScope.busy = true;
      rows = [["Événement", "Event_name", "Condition", "Operators", "Display properties"].join(",")];
      return $q.all(_.map($scope.templates, function(template) {
        return $q.all(_.map(template.conditions, function(condition) {
          if (typeof condition === "function") {
            return condition();
          } else {
            return condition;
          }
        })).then(function(conditions) {
          if (conditions.length > 0) {
            rows.push([template.label, template.event_name, conditions[0].label + " (" + conditions[0].type + ")", "\"" + (conditions[0].availableOperators || []).join(" ") + "\"", template.available_properties.join(' | ')].join(','));
            return rows = rows.concat(_.map(conditions.slice(1), function(condition) {
              return [null, null, condition.label + " (" + condition.type + ")", "\"" + (condition.availableOperators || []).join(" ") + "\"", null].join(',');
            }));
          } else {
            rows.push([template.label, template.event_name, null, null, template.available_properties.join(' | ')].join(','));
          }
        });
      })).then(function(templates) {
        var a;
        a = document.createElement("a");
        a.style = "display: none";
        a.target = '_blank';
        a.href = URL.createObjectURL(new Blob([rows.join("\r\n")], {
          type: 'application/csv',
          name: 'bilan.csv'
        }));
        a.download = "notification-center-config.csv";
        a.click();
        return $rootScope.busy = false;
      });
    };
    $scope.notificationFilters = {
      groups: [],
      events: []
    };
    alertUtils.getEventTemplates(true).then(function(templates) {
      $scope.templates = templates;
      return GroupUtils.getAllGroups().then(function(groups) {
        $scope.groups = groups;
        return AlertCategory.api.query().$promise.then(function(categories) {
          return AlertConfig.api.query().$promise.then(function(configs) {
            var category, i, len;
            for (i = 0, len = categories.length; i < len; i++) {
              category = categories[i];
              category.configs = _.filter(configs, {
                category: category.id
              });
            }
            return $scope.categories = categories;
          });
        });
      });
    });
    $scope.dndDroped = function(item, category) {
      item.category = category.id;
      AlertConfig.api.update(item);
      return item;
    };
    $scope.dndMoved = function(recipient, index) {
      return recipient.splice(index, 1);
    };
    $scope.createOrUpdateCategory = function(category) {
      var createOrUpdateCategoryModal;
      createOrUpdateCategoryModal = $uibModal.open({
        templateUrl: 'notification_center/views/alert-category-detail.html',
        controller: "AlertCategoryDetailCtrl",
        size: "lg",
        scope: $scope,
        backdrop: 'static',
        resolve: {
          category: function() {
            return category;
          }
        }
      });
      return createOrUpdateCategoryModal.result.then(function(updateOrCreatedCategory) {
        if (updateOrCreatedCategory) {
          if (updateOrCreatedCategory.id) {
            if (updateOrCreatedCategory.requestDelete) {
              return AlertCategory.api["delete"]({
                id: updateOrCreatedCategory.id
              }).$promise.then(function() {
                return _.remove($scope.categories, category);
              });
            } else {
              return Upload.upload({
                url: "/api_rest/alert_categories/" + updateOrCreatedCategory.id,
                method: "PATCH",
                file: updateOrCreatedCategory.new_logo,
                fields: updateOrCreatedCategory
              }).then(function(response) {
                category.icon = response.data.icon;
                return category.name = response.data.name;
              });
            }
          } else {
            return Upload.upload({
              url: "/api_rest/alert_categories",
              method: "POST",
              file: updateOrCreatedCategory.new_logo,
              fields: updateOrCreatedCategory
            }).then(function(response) {
              updateOrCreatedCategory.icon = response.data.icon;
              updateOrCreatedCategory.new_logo = null;
              updateOrCreatedCategory.id = response.data.id;
              updateOrCreatedCategory.configs = [];
              return $scope.categories.push(updateOrCreatedCategory);
            });
          }
        }
      });
    };
    $scope.createOrUpdateConfig = function(alertConfig, initialCategory) {
      var createOrUpdateConfigModal;
      createOrUpdateConfigModal = $uibModal.open({
        templateUrl: 'notification_center/views/alert-config-detail.html',
        controller: "AlertConfigDetailCtrl",
        scope: $scope,
        backdrop: 'static',
        resolve: {
          alertConfig: function() {
            return alertConfig;
          },
          initialCategory: function() {
            return initialCategory;
          },
          categories: function() {
            return $scope.categories;
          }
        }
      });
      return createOrUpdateConfigModal.result.then(function(updateOrCreatedConfig) {
        var ref;
        if (((ref = updateOrCreatedConfig.display_message_template) != null ? ref.length : void 0) === 0) {
          updateOrCreatedConfig.display_message_template = updateOrCreatedConfig.description;
        }
        if (updateOrCreatedConfig) {
          if (updateOrCreatedConfig.id) {
            if (updateOrCreatedConfig.requestDelete) {
              return AlertConfig.api["delete"]({
                id: updateOrCreatedConfig.id
              }).$promise.then(function() {
                var category;
                category = _.find($scope.categories, {
                  id: alertConfig.category
                });
                return _.remove(category.configs, alertConfig);
              });
            } else {
              return AlertConfig.api.update(updateOrCreatedConfig).$promise.then(function() {
                var category;
                category = _.find($scope.categories, {
                  id: alertConfig.category
                });
                _.remove(category.configs, alertConfig);
                category = _.find($scope.categories, {
                  id: updateOrCreatedConfig.category
                });
                return category.configs.push(updateOrCreatedConfig);
              });
            }
          } else {
            return AlertConfig.api.save(updateOrCreatedConfig).$promise.then(function(newCongif) {
              var category;
              category = _.find($scope.categories, {
                id: newCongif.category
              });
              return category.configs.push(newCongif);
            });
          }
        }
      });
    };
    $scope.getEventTemplate = function(eventTemplateName) {
      return _.find($scope.templates, {
        event_name: eventTemplateName
      });
    };
    $scope.getGroupsNames = function(groupsIds) {
      return _.map(groupsIds, function(groupId) {
        return $scope.getGroup(groupId).name;
      });
    };
    $scope.getGroup = function(groupId) {
      return _.find($scope.groups, {
        id: groupId
      });
    };
    $scope.getAlertCategory = function(categoryId) {
      return _.find($scope.categories, {
        id: categoryId
      });
    };
    $scope.filterByProperty = function(viewValue, property) {
      return function(item, index, array) {
        return !viewValue || viewValue === " " || viewValue === null || item[property].toLowerCase().indexOf(viewValue.toLowerCase()) >= 0;
      };
    };
    AlertConfig.api.exportConfig().$promise.then(function(export_data) {
      return $scope.alertConfigToExport = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(export_data));
    });
    return $scope.importAlertConfigFile = function(file) {
      $rootScope.busy = true;
      return Upload.upload({
        url: "/api_rest/alert_config/import_config",
        method: "PUT",
        file: file
      }).then(function(response) {
        if (response.data.status !== 'OK') {
          notify({
            classes: ['alert-warning'],
            message: $filter('translate')("IMPORT_CONFIG_FAILED") + ":" + response.data.status
          });
        }
        $rootScope.busy = false;
        return $state.reload("user.notification-center.config");
      });
    };
  }]);

  angular.module('mhclientApp').filter('filterConfigs', function() {
    return function(items, notificationFilters) {
      var eventNames, filtered, groupsIds, i, item, len, ref, ref1;
      if ((notificationFilters.groups.length === (ref = notificationFilters.events.length) && ref === 0)) {
        return items;
      }
      filtered = [];
      groupsIds = _.map(notificationFilters.groups, 'id');
      eventNames = _.map(notificationFilters.events, 'event_name');
      for (i = 0, len = items.length; i < len; i++) {
        item = items[i];
        if (notificationFilters.groups.length > 0 && !_.some(item.groups, function(groupId) {
          return indexOf.call(groupsIds, groupId) >= 0;
        })) {
          continue;
        }
        if (notificationFilters.events.length > 0 && (ref1 = item.event_name, indexOf.call(eventNames, ref1) < 0)) {
          continue;
        }
        filtered.push(item);
      }
      return filtered;
    };
  });

}).call(this);

//# sourceMappingURL=notification-config-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:NotificationRedirectCtrl
    * @description
    * # NotificationRedirectCtrl
    * Controller of Redirect Notifications
   */
  angular.module('mhclientApp').controller('NotificationRedirectCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "Alert", "redirectUtils", function($scope, $rootScope, $state, $stateParams, Alert, redirectUtils) {
    $rootScope.busy = true;
    return Alert.api.get({
      id: $stateParams.alertId
    }).$promise.then((function(alertDetail) {
      return redirectUtils.redirectToAlert(alertDetail);
    }), (function(error) {
      $scope.error = true;
      return $rootScope.busy = false;
    }));
  }]);

}).call(this);

//# sourceMappingURL=redirect-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Medplan
    * @description
    * # Medplan
    * Factory of Medplan
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").factory('Alert', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, boxAPI, medplan, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/alerts/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        medplan = window.mgapp.get('taskplanner').medplan();
        boxAPI = BoxResource.generate(medplan);
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('AlertConfig', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, boxAPI, medplan, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/alert_config/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'delete': {
        method: 'DELETE',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'exportConfig': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'GET',
        params: {
          route: 'export_config'
        }
      },
      'importConfig': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'import_config'
        },
        method: 'put'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        medplan = window.mgapp.get('taskplanner').medplan();
        boxAPI = BoxResource.generate(medplan);
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('AlertCategory', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, boxAPI, medplan, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/alert_categories/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'delete': {
        method: 'DELETE',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        medplan = window.mgapp.get('taskplanner').medplan();
        boxAPI = BoxResource.generate(medplan);
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('MeasureType', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, api, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/measuretypes/:id', {
      id: this.id
    }, {
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('alertUtils', ["$rootScope", "$q", "$filter", "$translatePartialLoader", "$translate", "PrescUtils", "PharmaAnalysisUtils", "FormTemplateUtils", "FeatureUtils", "SiteVarsUtils", "DocumentCategory", "MeasureType", "GroupUtils", "AlertConfig", "AlertCategory", "MhConfig", "ThesaurusUtils", "Feed", "User", function($rootScope, $q, $filter, $translatePartialLoader, $translate, PrescUtils, PharmaAnalysisUtils, FormTemplateUtils, FeatureUtils, SiteVarsUtils, DocumentCategory, MeasureType, GroupUtils, AlertConfig, AlertCategory, MhConfig, ThesaurusUtils, Feed, User) {
    var GlobalCategories, GlobalConfigs, addCachedConfigsToAlerts, confirmAlert, filterEntries, filterEvents, formatEvents, getAlertCategories, getAlertConfigs, getEventTemplates, globalCategoriesPromise, globalConfigsPromise, groupEvents, resetCache, service;
    $translatePartialLoader.addPart("notification_center");
    getEventTemplates = function(onlyActives) {
      var templateDone;
      templateDone = $q.defer();
      FeatureUtils.getAllFeatures().then(function(features) {
        return $translate.refresh().then(function() {
          var PrescCount, careChoices, cartControledStatus, cartHasControl, cartNeedControl, daysWithoutAdministration, diaryCategory, dispAction, documentCategory, events, eventsWithFeature, getDeliveryTypeOptions, groupInvolvedChoices, hasAttachements, hasEmptyStock, hasPrescToDeliver, isDischargeOrdonnance, isHospital, isMessageImportant, isPaper, isStupefiant, isUrgentOrder, measureType, medicalFormName, messageCategoryDiary, messageCategoryPharma, messageCategoryTC, messageTypeChoices, orderState, ordoHasComments, patientState, pharmaCtrlStatus, pharmaInterventionChoice, pharmaProblemChoice, pharmaStatus, pharmacistStatusChoice, preparerStatusChoice, prescAdminStateCodeNEW, prescAdminStateCodeNOK, prescCategoryChoice, previousPharmacistStatusChoice, previousPreparerStatusChoice, pspCategories, realizedPreviousDay, resumptionStatus, routeChoices, stateChoices, stoppedType, subManualType, theasaurusCareCategoryChoices, workReportChoices;
          stoppedType = {
            check_property: "stopped_reason",
            label: $filter('translate')("stoppedType"),
            option_display: "label",
            type: "select",
            availableOperators: ["==", "!="],
            option_key: "value",
            options: [
              {
                label: $filter('translate')("STOPPED_BY_RENEW"),
                value: "STOPPED_BY_RENEW"
              }, {
                label: $filter('translate')("STOPPED_AUTOMATICALLY"),
                value: "STOPPED_AUTOMATICALLY"
              }, {
                label: $filter('translate')("STAY_CLOSED"),
                value: "STAY_CLOSED"
              }, {
                label: $filter('translate')("STOP MANUAL"),
                value: null
              }
            ]
          };
          stateChoices = {
            check_property: "state",
            label: $filter('translate')("STATUS"),
            option_display: "label",
            type: "select",
            availableOperators: ["==", "!="],
            option_key: "value",
            options: [
              {
                label: $filter('translate')("PREAD"),
                value: "PRE"
              }, {
                label: $filter('translate')("ADMIS"),
                value: "ADM"
              }, {
                label: $filter('translate')("INACTIVE"),
                value: "I"
              }, {
                label: $filter('translate')("DISCHARGED"),
                value: "CLOSE"
              }
            ]
          };
          subManualType = {
            check_property: "stop_reason",
            label: $filter('translate')("stoppedManualReason"),
            option_display: "label",
            availableOperators: ["==", "!="],
            type: "select",
            option_key: "code",
            options: [
              {
                code: null,
                label: $filter('translate')("No specified")
              }
            ].concat(PrescUtils.getStopAvailableReason())
          };
          isStupefiant = {
            check_property: "is_stupefiant",
            label: $filter('translate')("isStupefiant"),
            type: "checkbox"
          };
          hasEmptyStock = {
            check_property: "has_empty_stock",
            label: $filter('translate')("Has empty stock"),
            type: "checkbox"
          };
          isPaper = {
            check_property: "is_paper",
            label: $filter('translate')("is paper"),
            type: "checkbox"
          };
          realizedPreviousDay = {
            check_property: "realized_previous_day",
            label: $filter('translate')("Realized at D-1"),
            type: "checkbox"
          };
          isHospital = {
            check_property: "is_hospital",
            label: $filter('translate')("isHospitalOrdonnance"),
            type: "checkbox"
          };
          ordoHasComments = {
            check_property: "has_comments",
            label: $filter('translate')("WITH_COMMENTS"),
            type: "checkbox"
          };
          PrescCount = {
            check_property: "presc_count",
            label: $filter('translate')("PrescCount"),
            type: "text"
          };
          isDischargeOrdonnance = {
            check_property: "is_discharge",
            label: $filter('translate')("isDischargeOrdonnance"),
            type: "checkbox"
          };
          hasPrescToDeliver = {
            check_property: "is_dispensable",
            label: $filter('translate')("hasPrescToDeliver"),
            type: "checkbox"
          };
          messageCategoryPharma = {
            check_property: "view",
            label: $filter('translate')("messageCategoryPharma"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: [
              {
                label: "mess_pharma_preparer",
                value: "mess_pharma_preparer"
              }, {
                label: "mess_pharma_doctor",
                value: "mess_pharma_doctor"
              }
            ]
          };
          pharmaStatus = _.concat([
            {
              value: "",
              label: $filter('translate')("Initial")
            }
          ], _.map(Object.keys(PharmaAnalysisUtils.statusList), function(status) {
            return {
              value: status,
              label: $filter('translate')("pharma_status_" + status)
            };
          }));
          pharmaProblemChoice = {
            check_property: "comment_problem_type",
            label: $filter('translate')("pharma_comment_problem_type"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: _.map(PharmaAnalysisUtils.commentProblemList, function(problem) {
              return {
                value: problem.value,
                label: $filter('translate')(problem.value)
              };
            })
          };
          previousPharmacistStatusChoice = {
            check_property: "original_pharmacist_status",
            label: $filter('translate')("previousPharmacistStatusChoice"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: pharmaStatus
          };
          pharmacistStatusChoice = {
            check_property: "pharmacist_status",
            label: $filter('translate')("pharmacistStatusChoice"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: pharmaStatus
          };
          preparerStatusChoice = {
            check_property: "preparer_status",
            label: $filter('translate')("preparerStatusChoice"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: pharmaStatus
          };
          previousPreparerStatusChoice = {
            check_property: "original_preparer_status",
            label: $filter('translate')("previousPreparerStatusChoice"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: pharmaStatus
          };
          pharmaInterventionChoice = {
            check_property: "comment_intervention_type",
            label: $filter('translate')("pharma_comment_intervention_type"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: _.map(PharmaAnalysisUtils.commentInterventionList, function(intervention) {
              return {
                value: intervention,
                label: $filter('translate')(intervention)
              };
            })
          };
          messageCategoryTC = {
            check_property: "category",
            label: $filter('translate')("messageCategoryTC"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: [
              {
                label: "cible",
                value: "cible"
              }, {
                label: "macro-cible",
                value: "macro-cible"
              }, {
                label: "donnee",
                value: "donnee"
              }, {
                label: "action",
                value: "action"
              }, {
                label: "resultat",
                value: "resultat"
              }, {
                label: "note",
                value: "note"
              }
            ]
          };
          messageCategoryDiary = {
            check_property: "category",
            label: $filter('translate')("messageCategoryDiary"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: _.map((_.find(features, {
              name: "MHC_DIARY"
            }) || {
              "metadata": {}
            }).metadata.message_categories || [], function(cat) {
              return {
                "label": $filter('translate')(cat),
                "value": cat
              };
            })
          };
          isMessageImportant = {
            check_property: "is_important",
            label: $filter('translate')("isMessageImportant"),
            type: "checkbox"
          };
          hasAttachements = {
            check_property: "has_attachments",
            label: $filter('translate')("hasAttachements"),
            type: "checkbox"
          };
          daysWithoutAdministration = {
            check_property: "days_without_administration",
            label: $filter('translate')("daysWithoutAdministration"),
            type: "text"
          };
          patientState = {
            check_property: "state",
            label: $filter('translate')("patientState"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: [
              {
                label: 'Préadmission',
                value: 'PRE'
              }, {
                label: 'Actif',
                value: 'ADM'
              }, {
                label: 'Inactif',
                value: 'I'
              }, {
                label: 'Fermé',
                value: 'CLOSED'
              }
            ]
          };
          pspCategories = {
            check_property: "category",
            label: $filter('translate')("pspCategories"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: [
              {
                label: 'Initial',
                value: 'pspi'
              }, {
                label: 'Finale',
                value: 'pspf'
              }
            ]
          };
          orderState = {
            check_property: "state_display",
            label: $filter('translate')("orderState"),
            option_display: "label",
            type: "select",
            option_key: "value",
            options: [
              {
                value: 'PN',
                label: 'En cours'
              }, {
                value: 'VA',
                label: 'Validée'
              }, {
                value: 'PE',
                label: 'Précommande'
              }, {
                value: 'DL',
                label: 'Livrée'
              }, {
                value: 'CA',
                label: 'Annulée'
              }, {
                value: 'R',
                label: 'Supprimé'
              }, {
                value: 'DP',
                label: 'Livraison en cours'
              }
            ]
          };
          isUrgentOrder = {
            check_property: "is_urgent",
            label: $filter('translate')("URGENT_ORDER"),
            type: "checkbox"
          };
          prescCategoryChoice = function() {
            var donePromise;
            donePromise = $q.defer();
            PrescUtils.getCategories().promise.then(function(categories) {
              return donePromise.resolve({
                check_property: "category_name",
                options: categories,
                label: $filter('translate')("prescCategoryChoice"),
                option_display: "label",
                availableOperators: ["==", "!="],
                type: "select",
                option_key: "name"
              });
            });
            return donePromise.promise;
          };
          getDeliveryTypeOptions = function() {
            return PharmaAnalysisUtils.getDeliveryTypeOptions().then(function(deliveryTypeOptions) {
              return {
                check_property: "order_delivery_type",
                label: _.capitalize($filter('translate')("MEDICAL_DELIVERY_TYPE")),
                availableOperators: ["==", "!="],
                option_display: "label",
                type: "select",
                option_key: "name",
                options: deliveryTypeOptions
              };
            });
          };
          resumptionStatus = {
            check_property: "resumption",
            label: _.capitalize($filter('translate')("prescription_resumption_status")),
            availableOperators: ["==", "!="],
            option_display: "label",
            type: "select",
            option_key: "value",
            options: [
              {
                value: 'INITIAL',
                label: _.capitalize($filter('translate')("BY_RESUMPTION_INITIAL"))
              }, {
                value: 'RENEW',
                label: _.capitalize($filter('translate')("BY_RESUMPTION_RENEW"))
              }, {
                value: 'RENEW_MODIFY',
                label: _.capitalize($filter('translate')("BY_RESUMPTION_RENEW_MODIFY"))
              }
            ]
          };
          pharmaCtrlStatus = {
            check_property: "pharma_control_status",
            label: $filter('translate')("pharma_control_status"),
            availableOperators: ["==", "!="],
            option_display: "label",
            type: "select",
            option_key: "value",
            options: [
              {
                value: 'OK',
                label: $filter('translate')("Pharma_control_ok")
              }, {
                value: 'need info',
                label: $filter('translate')("Pharma_control_need_info")
              }, {
                value: 'NOK',
                label: $filter('translate')("Pharma_control_nok")
              }
            ]
          };
          routeChoices = {
            check_property: "route_code",
            label: $filter('translate')("PRESC_ROUTE"),
            option_display: "label",
            type: "select",
            option_key: "code",
            options: PrescUtils.routes
          };
          dispAction = function() {
            var actionOptions, donePromise;
            donePromise = $q.defer();
            actionOptions = [
              {
                "label": $filter('translate')("DISP_NOACTION"),
                "code": 'NOACTION'
              }, {
                "label": $filter('translate')("DISP_NOTDELIVER"),
                "code": 'NOTDELIVER'
              }, {
                "label": $filter('translate')("DISP_DELIVER"),
                "code": 'DELIVER'
              }, {
                "label": $filter('translate')("DISP_SUBSTITUTE"),
                "code": 'SUBSTITUTE'
              }, {
                "label": $filter('translate')("DISP_EXTERN"),
                "code": 'EXTERN'
              }, {
                "label": $filter('translate')("DISP_PROBLEM"),
                "code": 'PROBLEM'
              }
            ];
            SiteVarsUtils.get('CLASICAL_DISPENSATION', true).then(function(clasicalDispensation) {
              if (!clasicalDispensation.value) {
                actionOptions.push({
                  "label": $filter('translate')("DISP_VALIDATE"),
                  "code": 'VALIDATE'
                });
              }
              return donePromise.resolve({
                check_property: "action",
                label: $filter('translate')("DISP_ACTION"),
                option_display: "label",
                type: "select",
                option_key: "code",
                options: actionOptions
              });
            });
            return donePromise.promise;
          };
          theasaurusCareCategoryChoices = function() {
            var donePromise;
            donePromise = $q.defer();
            ThesaurusUtils.getThesaurusCategories({
              type: "care"
            }, true).then(function(thesaurusCategories) {
              return donePromise.resolve({
                check_property: "category_code",
                options: thesaurusCategories,
                label: $filter('translate')("theasaurusCategoryChoices"),
                option_display: "label",
                type: "select",
                option_key: "code"
              });
            });
            return donePromise.promise;
          };
          careChoices = {
            check_property: "thesaurus_uid",
            query: {
              type: "care"
            },
            startLevel: 1,
            availableOperators: ["in"],
            label: $filter('translate')("careChoices"),
            type: "thesaurus"
          };
          cartNeedControl = {
            check_property: "need_control",
            label: $filter('translate')("cartNeedControl"),
            type: "checkbox"
          };
          cartHasControl = {
            check_property: "has_control",
            label: $filter('translate')("cartHasControl"),
            type: "checkbox"
          };
          cartControledStatus = {
            check_property: "control_status",
            options: [
              {
                "label": $filter('translate')("CONTROL_OK"),
                "value": "OK"
              }, {
                "label": $filter('translate')("CONTROL_POK"),
                "value": "POK"
              }, {
                "label": $filter('translate')("CONTROL_NOK"),
                "value": "NOK"
              }
            ],
            label: $filter('translate')("Status"),
            option_display: "label",
            availableOperators: ["==", "!="],
            type: "select",
            option_key: "value"
          };
          workReportChoices = function() {
            var donePromise;
            donePromise = $q.defer();
            Feed.api.query().$promise.then(function(feeds) {
              var feed, feedsDict, i, len, ref;
              feedsDict = {
                check_property: "feed_uid",
                options: [],
                label: $filter('translate')("messageTypeChoices"),
                option_display: "label",
                type: "select",
                option_key: "uid"
              };
              ref = _.filter(feeds, {
                feature_name: "MHC_WORK_REPORT"
              });
              for (i = 0, len = ref.length; i < len; i++) {
                feed = ref[i];
                feedsDict.options.push({
                  label: feed.view,
                  uid: feed.uid
                });
              }
              return donePromise.resolve(feedsDict);
            });
            return donePromise.promise;
          };
          messageTypeChoices = function() {
            var donePromise;
            donePromise = $q.defer();
            Feed.api.query().$promise.then(function(feeds) {
              var feed, feedsDict, i, label, len;
              feedsDict = {
                check_property: "feed_uid",
                options: [],
                label: $filter('translate')("messageTypeChoices"),
                option_display: "label",
                type: "select",
                option_key: "uid"
              };
              for (i = 0, len = feeds.length; i < len; i++) {
                feed = feeds[i];
                if (feed.view && feed.view.length > 0) {
                  label = feed.feature_label + "/" + feed.view;
                } else {
                  label = feed.feature_label;
                }
                feedsDict.options.push({
                  label: label,
                  uid: feed.uid
                });
              }
              return donePromise.resolve(feedsDict);
            });
            return donePromise.promise;
          };
          medicalFormName = function() {
            var donePromise;
            donePromise = $q.defer();
            FormTemplateUtils.getTemplates().then(function(templates) {
              var templateDict;
              templateDict = {
                check_property: "template_uid",
                label: $filter('translate')("medicalFormName"),
                option_display: "uid",
                type: "select",
                option_key: "uid",
                options: templates
              };
              return donePromise.resolve(templateDict);
            });
            return donePromise.promise;
          };
          groupInvolvedChoices = function() {
            var donePromise;
            donePromise = $q.defer();
            GroupUtils.getAllGroups().then(function(groups) {
              var templateDict;
              templateDict = {
                check_property: "group_involved_uid",
                label: $filter('translate')("groupInvolvedChoices"),
                option_display: "name",
                type: "select",
                option_key: "uid",
                options: groups
              };
              return donePromise.resolve(templateDict);
            });
            return donePromise.promise;
          };
          prescAdminStateCodeNEW = function() {
            var donePromise;
            donePromise = $q.defer();
            PrescUtils.getCategories().promise.then(function(categories) {
              var codes;
              codes = [];
              _.map(categories, function(category) {
                return _.map(category.properties.administration_codes || [], function(administration_codes) {
                  return _.map(administration_codes.codes, function(administrationCode) {
                    var new_code;
                    if (administration_codes.state !== "NOK") {
                      new_code = {
                        code: administrationCode.code,
                        label: administrationCode.code + " - " + administrationCode.label
                      };
                      if (!_.find(codes, new_code)) {
                        return codes.push(new_code);
                      }
                    }
                  });
                });
              });
              return donePromise.resolve({
                check_property: "admin_code",
                options: codes,
                label: $filter('translate')("prescAdminStateCode"),
                option_display: "label",
                availableOperators: ["==", "!="],
                type: "select",
                option_key: "code"
              });
            });
            return donePromise.promise;
          };
          prescAdminStateCodeNOK = function() {
            var donePromise;
            donePromise = $q.defer();
            PrescUtils.getCategories().promise.then(function(categories) {
              var codes;
              codes = [];
              _.map(categories, function(category) {
                return _.map(category.properties.administration_codes || [], function(administration_codes) {
                  return _.map(administration_codes.codes, function(administrationCode) {
                    var new_code;
                    if (administration_codes.state === "NOK") {
                      new_code = {
                        code: administrationCode.code,
                        label: administrationCode.code + " - " + administrationCode.label
                      };
                      if (!_.find(codes, new_code)) {
                        return codes.push(new_code);
                      }
                    }
                  });
                });
              });
              return donePromise.resolve({
                check_property: "admin_code",
                options: codes,
                label: $filter('translate')("prescAdminStateCode"),
                option_display: "label",
                availableOperators: ["==", "!="],
                type: "select",
                option_key: "code"
              });
            });
            return donePromise.promise;
          };
          documentCategory = function() {
            var donePromise;
            donePromise = $q.defer();
            DocumentCategory.query().$promise.then(function(categories) {
              return donePromise.resolve({
                check_property: "category_uid",
                options: categories,
                label: $filter('translate')("documentCategory"),
                option_display: "label",
                type: "select",
                option_key: "uid"
              });
            });
            return donePromise.promise;
          };
          diaryCategory = {
            check_property: "category_name",
            options: [
              {
                "name": "OBSERVATION",
                "label": "Observation"
              }, {
                "name": "RESULTAT",
                "label": "Résultat"
              }, {
                "name": "DOCUMENT",
                "label": "Document"
              }
            ],
            label: $filter('translate')("documentCategory"),
            option_display: "label",
            type: "select",
            option_key: "name"
          };
          measureType = function() {
            var donePromise;
            donePromise = $q.defer();
            MeasureType.api.query().$promise.then(function(measureTypes) {
              var i, len, measureDict, mtype;
              measureDict = {
                check_property: "mtype_uid",
                options: [],
                label: $filter('translate')("measureType"),
                option_display: "label",
                type: "select",
                option_key: "value"
              };
              for (i = 0, len = measureTypes.length; i < len; i++) {
                mtype = measureTypes[i];
                measureDict.options.push({
                  label: mtype.metadata['LABEL'],
                  value: mtype.uid
                });
              }
              return donePromise.resolve(measureDict);
            });
            return donePromise.promise;
          };
          events = [
            {
              event_name: "MISSING_DRUG_STOCK",
              conditions: [],
              available_properties: [],
              route: "user.patient.stay.stock.list",
              feature: "STOCK",
              duration_before_event: "true"
            }, {
              event_name: "NEW_DRUG_STOCK",
              conditions: [hasEmptyStock, realizedPreviousDay, isPaper],
              available_properties: [],
              route: "user.patient.stay.stock.list",
              feature: "STOCK"
            }, {
              event_name: "PRESCRIPTION_NEW",
              conditions: [prescCategoryChoice, resumptionStatus, isStupefiant, isHospital, routeChoices],
              route: "user.patient.stay.medication.current",
              feature: "ORP",
              available_properties: ["category_label", "product_name"]
            }, {
              event_name: "PRESCRIPTION_CONTROL_PHARMA",
              conditions: [prescCategoryChoice, resumptionStatus, isStupefiant, isHospital, routeChoices, pharmaCtrlStatus],
              route: "user.patient.stay.medication.current",
              feature: "ORP",
              available_properties: ["category_label", "product_name", "pharma_control_label", "pharma_control_comment", "pharma_control_administration_comment", "pharma_control_user", "pharma_ctrl_datetime"]
            }, {
              event_name: "PRESCRIPTION_STOP",
              conditions: [prescCategoryChoice, resumptionStatus, isStupefiant, stoppedType, isHospital, routeChoices, subManualType],
              route: "user.patient.stay.medication.current",
              feature: "ORP",
              available_properties: ["category_label", "product_name"]
            }, {
              event_name: "PRESCRIPTION_CONFLICT",
              conditions: [prescCategoryChoice, resumptionStatus, isStupefiant, isHospital, routeChoices],
              available_properties: [],
              route: "user.patient.stay.medication.current",
              feature: "ORP"
            }, {
              event_name: "PRESCRIPTION_ABOUT_TO_EXPIRE",
              conditions: [prescCategoryChoice, resumptionStatus, isStupefiant, isHospital, routeChoices],
              available_properties: ["category_label", "product_name"],
              route: "user.patient.stay.medication.current",
              feature: "ORP",
              duration_before_event: "true"
            }, {
              event_name: "PRESCRIPTION_ANTIBIOTIC",
              conditions: [prescCategoryChoice, resumptionStatus],
              available_properties: ["category_label", "product_name"],
              route: "user.patient.stay.medication.current",
              feature: "ORP",
              duration_after_event: "true"
            }, {
              event_name: "ORDONNANCE_NEW",
              conditions: [isHospital, isDischargeOrdonnance, hasPrescToDeliver, ordoHasComments],
              available_properties: [],
              route: "user.patient.stay.medication.ordonnances",
              feature: "ORI"
            }, {
              event_name: "ORDONNANCE_NEED_PHARMA",
              conditions: [isHospital, ordoHasComments],
              available_properties: [],
              route: "user.patient.stay.pharmaceutical-analysis",
              feature: "PHARMA-ANALYSIS"
            }, {
              event_name: "ORDONNANCE_NEW_SAVED_DRAFT_CART",
              conditions: [isDischargeOrdonnance],
              available_properties: [],
              route: "user.patient.stay.medication.cart",
              feature: "ORI"
            }, {
              event_name: "ORDONNANCE_CART_NEED_CONTROL",
              conditions: [],
              available_properties: [],
              route: "user.patient.stay.medication.cart",
              feature: "PRESC_CART_CONTROL"
            }, {
              event_name: "ORDONNANCE_CART_CONTROLED",
              conditions: [cartControledStatus],
              available_properties: [],
              route: "user.patient.stay.medication.cart",
              feature: "PRESC_CART_CONTROL"
            }, {
              event_name: "VALIDATE_PRE",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.pread",
              feature: "MHC_PREAD"
            }, {
              event_name: "CANCEL_PRE",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.pread",
              feature: "MHC_PREAD"
            }, {
              event_name: "DRAFT_PRESCRIPTION_DELETED",
              available_properties: [],
              conditions: [prescCategoryChoice, resumptionStatus],
              route: "user.patient.stay.medication.current",
              feature: "ORP"
            }, {
              event_name: "ADMINISTRATION_NOK",
              available_properties: [],
              conditions: [prescCategoryChoice, prescAdminStateCodeNOK],
              route: "user.patient.stay.medication.administration.compact",
              feature: "ORA"
            }, {
              event_name: "DRAFT_ORDONNANCE_DELETED",
              available_properties: [],
              conditions: [isHospital, isDischargeOrdonnance],
              route: "user.patient.stay.medication.ordonnances",
              feature: "ORI"
            }, {
              event_name: "ADMINISTRATION_NEW",
              available_properties: [],
              conditions: [prescCategoryChoice, prescAdminStateCodeNEW],
              route: "user.patient.stay.medication.administration.compact",
              feature: "ORA"
            }, {
              event_name: "ADMINISTRATION_MISSING",
              available_properties: [],
              conditions: [prescCategoryChoice],
              route: "user.patient.stay.medication.administration.compact",
              feature: "ORA",
              duration_before_event: "true"
            }, {
              event_name: "DISPENSATION_NEW",
              available_properties: ["drug_name", "comment", "problem", "presc_category_label", "presc_product_name", "action_label"],
              conditions: [prescCategoryChoice, isStupefiant, isHospital, routeChoices, dispAction],
              route: "user.patient.stay.medication.ordonnances",
              feature: "ORD"
            }, {
              event_name: "DISPENSATION_NEED_VALIDATION",
              available_properties: ["drug_name", "comment", "problem", "presc_category_label", "presc_product_name", "action_label"],
              conditions: [prescCategoryChoice, isStupefiant, isHospital, routeChoices, dispAction],
              route: "user.patient.stay.medication.ordonnances",
              feature: "ORD"
            }, {
              event_name: "DELIVERY_NEW",
              available_properties: ["drug_name", "comment", "problem", "presc_category_label", "presc_product_name", "action_label"],
              conditions: [prescCategoryChoice, isStupefiant, isHospital, routeChoices, dispAction],
              route: "user.patient.stay.medication.ordonnances",
              feature: "ORD"
            }, {
              event_name: "DELIVERY_ABOUT_TO_EXPIRE",
              available_properties: [],
              conditions: [isHospital],
              route: "user.patient.stay.medication.ordonnances",
              feature: "ORD",
              duration_before_event: "true"
            }, {
              event_name: "DISPENSATION_ABOUT_TO_EXPIRE",
              available_properties: [],
              conditions: [isHospital],
              route: "user.patient.stay.medication.ordonnances",
              feature: "ORD",
              duration_before_event: "true"
            }, {
              event_name: "DIARY_NEW",
              available_properties: [],
              conditions: [isMessageImportant, diaryCategory, hasAttachements],
              route: "user.patient.stay.message.lia",
              feature: "LIA"
            }, {
              event_name: "SCAN_NEW",
              available_properties: ["category_label"],
              conditions: [documentCategory],
              route: "user.patient.stay.scan",
              feature: "NUM"
            }, {
              event_name: "PHOTO_NEW",
              available_properties: [],
              conditions: [documentCategory],
              route: "user.patient.stay.photo",
              feature: "IMG"
            }, {
              event_name: "PHOTO_MODIFICATION",
              available_properties: [],
              conditions: [documentCategory],
              route: "user.patient.stay.photo",
              feature: "IMG"
            }, {
              event_name: "FORM_VALIDATION_REQUESTED",
              available_properties: ["template_uid"],
              conditions: [medicalFormName],
              route: "user.patient.stay.form.template",
              feature: "MHC_FORMS",
              meta_params: ["idTemplate"]
            }, {
              event_name: "FORM_VALIDATED",
              available_properties: ["template_uid"],
              conditions: [medicalFormName],
              route: "user.patient.stay.form.template",
              feature: "MHC_FORMS",
              meta_params: ["idTemplate"]
            }, {
              event_name: "MHC_FORM_NEW",
              available_properties: ["template_uid"],
              conditions: [medicalFormName],
              route: "user.patient.stay.form.template",
              feature: "MHC_FORMS",
              meta_params: ["idTemplate"]
            }, {
              event_name: "MHC_FORM_MODIFICATION",
              conditions: [medicalFormName],
              available_properties: ["template_uid"],
              route: "user.patient.stay.form.template",
              feature: "MHC_FORMS",
              meta_params: ["idTemplate"]
            }, {
              event_name: "NEW_VITAL_DATA",
              available_properties: [],
              conditions: [measureType],
              route: "user.patient.stay.svg",
              feature: "SVG"
            }, {
              event_name: "ORDER_NEW",
              available_properties: [],
              conditions: [isUrgentOrder],
              route: "user.patient.stay.order.list",
              feature: "MHC_ORDERS"
            }, {
              event_name: "ORDER_TYPE_NEW",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.order.list",
              feature: "MHC_ORDERS"
            }, {
              event_name: "ORDER_REASSORT_NEW",
              available_properties: [],
              conditions: [isUrgentOrder],
              route: "user.patient.stay.order.list",
              feature: "MHC_ORDERS"
            }, {
              event_name: "ORDER_STATE_CHANGE",
              available_properties: [],
              conditions: [orderState, isUrgentOrder],
              route: "user.patient.stay.order.list",
              feature: "MHC_ORDERS"
            }, {
              event_name: "ORDER_CANCELED",
              available_properties: [],
              conditions: [isUrgentOrder],
              route: "user.patient.stay.order.list",
              feature: "MHC_ORDERS"
            }, {
              event_name: "MISSING_ORDER",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.order.list",
              feature: "MHC_ORDERS"
            }, {
              event_name: "ORDER_SHIPPED",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.order.list",
              feature: "MHC_ORDERS"
            }, {
              event_name: "ORDER_NEED_VALIDATION",
              available_properties: [],
              conditions: [isUrgentOrder],
              route: "user.patient.stay.order.list",
              feature: "MHC_ORDERS"
            }, {
              event_name: "TYPE_ORDER_NEEDS_CHANGE",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.order.list",
              feature: "MHC_ORDERS"
            }, {
              event_name: "PUNCTUAL_ACTIVITY",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.taskplanner.sequences",
              feature: "MHC_CARE_REALIZATION"
            }, {
              event_name: "NEW_CARE",
              available_properties: ["short_label", "date"],
              conditions: [theasaurusCareCategoryChoices, groupInvolvedChoices, careChoices],
              route: "user.patient.stay.taskplanner.sequences",
              feature: "MHC_CARE_CREATION",
              duration_before_event: "true"
            }, {
              event_name: "UNATTENDED_SEQUENCE",
              conditions: [],
              available_properties: ["sequence_label"],
              route: "user.patient.stay.taskplanner.sequences",
              feature: "MHC_CARE_CREATION",
              duration_after_event_in_hours: "true"
            }, {
              event_name: "UNATTENDED_CARE",
              available_properties: ["short_label", "date"],
              conditions: [theasaurusCareCategoryChoices, groupInvolvedChoices, careChoices],
              route: "user.patient.stay.taskplanner.sequences",
              feature: "MHC_CARE_CREATION",
              duration_after_event: "true"
            }, {
              event_name: "MHC_DIARY_NEW",
              available_properties: [],
              conditions: [messageCategoryDiary, isMessageImportant, hasAttachements],
              route: "user.patient.stay.message.hierarchic",
              feature: "MHC_DIARY",
              meta_params: ["featureName"]
            }, {
              event_name: "PHARMA_ANALYSIS_MESSAGE",
              available_properties: [],
              conditions: [messageCategoryPharma],
              route: "user.patient.stay.pharmaceutical-analysis",
              feature: "PHARMA-ANALYSIS"
            }, {
              event_name: "PHARMA_ANALYSIS_COMMENT",
              available_properties: ["comment_problem_text", "comment_intervention_text"],
              conditions: [pharmaProblemChoice, pharmaInterventionChoice],
              route: "user.patient.stay.pharmaceutical-analysis",
              feature: "PHARMA-ANALYSIS"
            }, {
              event_name: "PHARMA_PREPARER_STATUS_CHANGE",
              conditions: [prescCategoryChoice, isStupefiant, isHospital, preparerStatusChoice, previousPreparerStatusChoice],
              route: "user.patient.stay.pharmaceutical-analysis",
              feature: "PHARMA-ANALYSIS",
              available_properties: ["category_label", "product_name"]
            }, {
              event_name: "PHARMA_PHARMACIST_STATUS_CHANGE",
              conditions: [prescCategoryChoice, isStupefiant, isHospital, pharmacistStatusChoice, previousPharmacistStatusChoice],
              route: "user.patient.stay.pharmaceutical-analysis",
              feature: "PHARMA-ANALYSIS",
              available_properties: ["category_label", "product_name"]
            }, {
              event_name: "MHC_TRANSMISSION_NEW",
              available_properties: [],
              conditions: [messageCategoryTC, isMessageImportant, hasAttachements],
              feature: "MHC_TRANSMISSION",
              route: "user.patient.stay.transmissions"
            }, {
              event_name: "MHC_OBSERVATION_NEW",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.message.hierarchic",
              feature: "MHC_OBSERVATION",
              meta_params: ["featureName"]
            }, {
              event_name: "MHC_SOCIALPROJECT_NEW",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.message.hierarchic",
              feature: "MHC_SOCIALPROJECT",
              meta_params: ["featureName"]
            }, {
              event_name: "MHC_COVERAGE_NEW",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.message.hierarchic",
              feature: "MHC_COVERAGE",
              meta_params: ["featureName"]
            }, {
              event_name: "MHC_SANITARY_TRANSPORT_NEW",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.message.hierarchic",
              feature: "MHC_SANITARY_TRANSPORT",
              meta_params: ["featureName"]
            }, {
              event_name: "MHC_IAS_NEW",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.message.hierarchic",
              feature: "MHC_IAS",
              meta_params: ["featureName"]
            }, {
              event_name: "MHC_PSP_NON_REEVALUATED",
              available_properties: ['message_date', 'author_name'],
              conditions: [pspCategories],
              feature: "MHC_PSP",
              route: "user.patient.stay.message.hierarchic",
              meta_params: ["featureName"],
              duration_before_event: "true"
            }, {
              event_name: "MHC_PSP_NEW",
              available_properties: ['message_date', 'author_name'],
              conditions: [],
              feature: "MHC_PSP",
              route: "user.patient.stay.message.hierarchic",
              meta_params: ["featureName"]
            }, {
              event_name: "MHC_WORK_REPORT_NEW",
              conditions: [workReportChoices],
              available_properties: ['view'],
              feature: "MHC_WORK_REPORT",
              route: "user.patient.stay.multi-work-reports",
              meta_params: ["featureName", "view"],
              avoidFilterOnKeys: ["view"],
              customFilter: function(event) {
                var ref, ref1;
                return ref = (ref1 = event.data) != null ? ref1.meta_params.view : void 0, indexOf.call(_.concat($rootScope.user.group.readable_feeds_views, $rootScope.user.group.writable_feeds_views), ref) >= 0;
              }
            }, {
              event_name: "UPDATE_STAY_STATE",
              available_properties: ["state_display"],
              conditions: [stateChoices],
              featureLabel: $filter('translate')("STAY")
            }, {
              event_name: "UPDATE_STAY_DELIVERY_TYPE",
              available_properties: [],
              conditions: [getDeliveryTypeOptions],
              featureLabel: $filter('translate')("STAY")
            }, {
              event_name: "MHC_AGENDA_NEW_ACTIVITY",
              available_properties: ["thesaurus_entry_label", "start_date"],
              conditions: [],
              feature: "MHC_AGENDA",
              route: "user.patient.stay.agenda"
            }, {
              event_name: "MHC_AGENDA_UPDATED_EVENT",
              available_properties: ["short_label", "thesaurus_uid", "date"],
              conditions: [],
              feature: "MHC_AGENDA",
              route: "user.patient.stay.agenda"
            }, {
              event_name: "MHC_AGENDA_UPCOMING_EVENT",
              available_properties: ["short_label", "thesaurus_uid", "date"],
              conditions: [],
              feature: "MHC_AGENDA",
              route: "user.patient.stay.agenda",
              duration_before_event: "true"
            }, {
              event_name: "NEW_CARE_SEQUENCE",
              available_properties: ["sequence_label", "start_date"],
              conditions: [],
              route: "user.patient.stay.taskplanner.sequences",
              feature: "MHC_CARE_CREATION"
            }, {
              event_name: "CARE_SEQUENCE_UPDATED",
              available_properties: ["sequence_label", "start_date"],
              conditions: [],
              route: "user.patient.stay.taskplanner.sequences",
              feature: "MHC_CARE_CREATION"
            }, {
              event_name: "NEW_MISSION_LETTER",
              available_properties: ["author_name", "letter_date"],
              conditions: [],
              route: "user.patient.stay.taskplanner.mission_letter_list",
              feature: "MHC_MISSION_LETTER"
            }, {
              event_name: "NEW_MISSION_LETTER_NOTIFY_REFERENT",
              available_properties: ["author_name", "letter_date"],
              conditions: [],
              route: "user.my-missions",
              feature: "MHC_MISSION_LETTER"
            }, {
              event_name: "NEW_MISSION_LETTER_NOTIFY_USERS_INVOLVED",
              available_properties: ["author_name", "letter_date"],
              conditions: [],
              route: "user.my-missions",
              feature: "MHC_MISSION_LETTER"
            }, {
              event_name: "NEW_BILL",
              available_properties: [],
              conditions: [],
              route: "user.bills",
              feature: "BILL_DOCUMENTS"
            }, {
              event_name: "NEW_BILL_NOTIFY_BILLED",
              available_properties: [],
              conditions: [],
              route: "user.bills",
              feature: "BILL_DOCUMENTS"
            }, {
              event_name: "EQUIPMENT_ORDERED",
              available_properties: ["status"],
              conditions: [],
              route: "user.patient.stay.equipment-renting.list",
              feature: "EQUIPMENT_RENTING"
            }, {
              event_name: "EQUIPMENT_TO_BE_ORDERED",
              available_properties: ["status"],
              conditions: [],
              route: "user.patient.stay.equipment-renting.list",
              feature: "EQUIPMENT_RENTING"
            }, {
              event_name: "EQUIPMENT_INSTALLED",
              available_properties: ["status"],
              conditions: [],
              route: "user.patient.stay.equipment-renting.list",
              feature: "EQUIPMENT_RENTING"
            }, {
              event_name: "EQUIPMENT_SUSPENDED",
              available_properties: ["status"],
              conditions: [],
              route: "user.patient.stay.equipment-renting.list",
              feature: "EQUIPMENT_RENTING"
            }, {
              event_name: "EQUIPMENT_TO_BE_REMOVED",
              available_properties: ["status"],
              conditions: [],
              route: "user.patient.stay.equipment-renting.list",
              feature: "EQUIPMENT_RENTING"
            }, {
              event_name: "EQUIPMENT_DELETED",
              available_properties: ["status"],
              conditions: [],
              route: "user.patient.stay.equipment-renting.list",
              feature: "EQUIPMENT_RENTING"
            }, {
              event_name: "EQUIPMENT_REMOVED",
              available_properties: ["status"],
              conditions: [],
              route: "user.patient.stay.equipment-renting.list",
              feature: "EQUIPMENT_RENTING"
            }, {
              event_name: "EQUIPMENT_INVOICE_GENERATED",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.rental-invoices.list",
              feature: "EQUIPMENT_INVOICE"
            }, {
              event_name: "EQUIPMENT_WITHDRAWAL_INVOICE_GENERATED",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.rental-invoices.list",
              feature: "EQUIPMENT_INVOICE"
            }, {
              event_name: "EQUIPMENT_UNREFERENCED_ADDED",
              available_properties: [],
              conditions: [],
              route: "user.patient.stay.equipment-renting.list",
              feature: "EQUIPMENT_RENTING"
            }
          ];
          eventsWithFeature = [];
          SiteVarsUtils.get('RETRANSCRIPTIONS_NEEDS_CONTROL', false).then(function(sitevar) {
            var ORDONNANCE_NEW_SAVED_DRAFT_CART;
            if (sitevar.value) {
              ORDONNANCE_NEW_SAVED_DRAFT_CART = _.find(events, {
                event_name: "ORDONNANCE_NEW_SAVED_DRAFT_CART"
              });
              ORDONNANCE_NEW_SAVED_DRAFT_CART.conditions.push(cartHasControl);
              ORDONNANCE_NEW_SAVED_DRAFT_CART.conditions.push(cartNeedControl);
            }
            return SiteVarsUtils.get("ALERT_LABELS", {}).then(function(alertLabels) {
              var event, feature, i, len, results;
              results = [];
              for (i = 0, len = events.length; i < len; i++) {
                event = events[i];
                event.label = alertLabels.value[event.event_name] || $filter('translate')(event.event_name);
                if (event.feature) {
                  feature = _.find(features, {
                    name: event.feature
                  });
                  if (feature && (!onlyActives || feature.active)) {
                    if (feature.parent && (_.find(features, {
                      id: feature.parent
                    }).type = "N")) {
                      event.featureLabel = _.find(features, {
                        id: feature.parent
                      }).label;
                    } else {
                      event.featureLabel = feature.label;
                    }
                    results.push(eventsWithFeature.push(event));
                  } else {
                    results.push(void 0);
                  }
                } else {
                  results.push(eventsWithFeature.push(event));
                }
              }
              return results;
            });
          });
          return templateDone.resolve(eventsWithFeature);
        });
      });
      return templateDone.promise;
    };
    GlobalConfigs = null;
    globalConfigsPromise = $q.defer();
    GlobalCategories = null;
    globalCategoriesPromise = $q.defer();
    resetCache = function() {
      GlobalConfigs = null;
      GlobalCategories = null;
      globalConfigsPromise = $q.defer();
      return globalCategoriesPromise = $q.defer();
    };
    filterEntries = function(entries, query, many) {
      var result;
      if (query) {
        result = many ? _.filter(entries, query) : _.find(entries, query);
      } else {
        result = entries;
      }
      return result;
    };
    getAlertConfigs = function(query, many) {
      if (MhConfig.platform === "mgapp") {
        return [];
      }
      if (GlobalConfigs != null) {
        return globalConfigsPromise.promise.then(function() {
          return _.cloneDeep(filterEntries(GlobalConfigs, query, many));
        });
      } else {
        GlobalConfigs = {};
        return AlertConfig.api.query().$promise.then(function(groupConfig) {
          GlobalConfigs = groupConfig;
          globalConfigsPromise.resolve();
          return _.cloneDeep(filterEntries(GlobalConfigs, query, many));
        });
      }
    };
    getAlertCategories = function(query, many) {
      var CategoryPromise;
      CategoryPromise = $q.defer();
      if (MhConfig.platform === "mgapp") {
        return [];
      }
      if (GlobalCategories != null) {
        globalCategoriesPromise.promise.then(function() {
          return CategoryPromise.resolve(filterEntries(GlobalCategories, query, many));
        });
      } else {
        GlobalCategories = {};
        resetCache();
        AlertCategory.api.query().$promise.then(function(groupConfig) {
          GlobalCategories = groupConfig;
          globalCategoriesPromise.resolve();
          return CategoryPromise.resolve(filterEntries(GlobalCategories, query, many));
        });
      }
      return CategoryPromise.promise;
    };
    groupEvents = function(events) {
      var alertDict, category, categoryDict, config, date, event, formatedEvents, formattedDate, i, len;
      formatedEvents = [];
      for (i = 0, len = events.length; i < len; i++) {
        event = events[i];
        config = event.config;
        category = config.category;
        formattedDate = moment(event.timestamp).format('YYYY-MM-DD');
        date = _.find(formatedEvents, {
          date: formattedDate
        });
        if (!date) {
          date = {
            date: formattedDate,
            categories: []
          };
          formatedEvents.push(date);
        }
        categoryDict = _.find(date.categories, {
          id: category.id
        });
        if (!categoryDict) {
          categoryDict = {
            id: category.id,
            label: category.name,
            configs: [],
            icon: category.icon
          };
          date.categories.push(categoryDict);
        }
        alertDict = _.find(categoryDict.configs, {
          id: config.id
        });
        if (!alertDict) {
          alertDict = {
            id: config.id,
            events: [],
            grouped: config.grouped_by_day
          };
          categoryDict.configs.push(alertDict);
        }
        alertDict.events.push(event);
      }
      return $filter('orderBy')(formatedEvents, '-date');
    };
    formatEvents = function(events, stay, allStays) {
      if (!allStays && stay) {
        events = _.filter(events, {
          stay: stay.id
        });
      }
      return {
        "alerts": groupEvents(_.filter(events, {
          "config": {
            "level": "ALERT"
          }
        })),
        "infos": groupEvents(_.filter(events, {
          "config": {
            "level": "INFO"
          }
        }))
      };
    };
    filterEvents = function(events, stayId, allStays, eventNames, stateParams) {
      events = _.filter(events || [], function(event) {
        var ref;
        return (!stayId || event.stay === stayId || allStays) && (!eventNames || (ref = event.config.event_name, indexOf.call(eventNames, ref) >= 0));
      });
      events = _.filter(events || [], function(event) {
        var i, key, len, metaParams, ref, ref1, ref2, ref3, ref4;
        if ((((ref = event.config) != null ? (ref1 = ref.baseEvent) != null ? ref1.customFilter : void 0 : void 0) != null) && !event.config.baseEvent.customFilter(event)) {
          return false;
        }
        if (stateParams) {
          metaParams = ((ref2 = event.data) != null ? ref2.meta_params : void 0) || {};
          ref4 = _.pullAll(_.keys(metaParams), (ref3 = event.config.baseEvent) != null ? ref3.avoidFilterOnKeys : void 0);
          for (i = 0, len = ref4.length; i < len; i++) {
            key = ref4[i];
            if (stateParams[key] !== metaParams[key]) {
              return false;
            }
          }
        }
        return true;
      });
      return events;
    };
    confirmAlert = function(event, container, user_id) {
      var feature, i, len, ref, template, topFeature;
      User.confirmNotification({
        id: $rootScope.user.id
      }, {
        alerts: [event.id]
      });
      if ($rootScope.currentPatient) {
        _.remove($rootScope.patientNewEvents, event);
        _.remove($rootScope.stateEvents, event);
        template = _.find($rootScope.alertTemplates, {
          event_name: event.config.event_name
        });
        ref = $rootScope.menus.patient.groupedFeaturesByParent;
        for (i = 0, len = ref.length; i < len; i++) {
          topFeature = ref[i];
          feature = _.find(topFeature.childs, {
            name: template.feature
          });
          if (feature) {
            feature.alert_count -= 1;
            topFeature.alert_count -= 1;
            $rootScope.menus.patient.alertCount -= 1;
            break;
          }
        }
        $rootScope.formatedEvents = formatEvents($rootScope.stateEvents, $rootScope.currentStay, $rootScope.allStays);
      }
      if (container) {
        return _.remove(container, event);
      }
    };
    addCachedConfigsToAlerts = function(alerts) {
      _.forEach(alerts, function(alert) {
        alert.config = _.find($rootScope.alertConfigs, {
          id: alert.config
        });
        if (!alert.config) {
          return resetCache();
        }
      });
      return filterEvents(_.filter(alerts, "config"));
    };
    service = {
      addCachedConfigsToAlerts: addCachedConfigsToAlerts,
      getEventTemplates: getEventTemplates,
      getAlertConfigs: getAlertConfigs,
      getAlertCategories: getAlertCategories,
      filterEvents: filterEvents,
      formatEvents: formatEvents,
      confirmAlert: confirmAlert,
      resetCache: resetCache
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=alerts-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:AlertCategoryDetailCtrl
    * @description
    * # AlertCategoryDetailCtrl
   */
  angular.module("mhclientApp").controller('AlertCategoryDetailCtrl', ["$scope", "$uibModalInstance", "category", function($scope, $uibModalInstance, category) {
    if (category) {
      $scope.category = angular.copy(category);
    } else {
      $scope.category = {};
    }
    $scope.modify = function() {
      return $uibModalInstance.close($scope.category);
    };
    $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
    return $scope.remove = function() {
      $scope.category.requestDelete = true;
      return $uibModalInstance.close($scope.category);
    };
  }]);

}).call(this);

//# sourceMappingURL=alert-category-detail-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:AlertConfigDetailCtrl
    * @description
    * # AlertConfigDetailCtrl
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").controller('AlertConfigDetailCtrl', ["$scope", "$rootScope", "$q", "$uibModal", "$filter", "$uibModalInstance", "alertConfig", "initialCategory", "categories", function($scope, $rootScope, $q, $uibModal, $filter, $uibModalInstance, alertConfig, initialCategory, categories) {
    var ref;
    $scope.categories = categories;
    if (alertConfig) {
      $scope.alertConfig = angular.copy(alertConfig);
    } else {
      $scope.alertConfig = {
        groups: [],
        conditions: {},
        level: "ALERT",
        category: initialCategory.id,
        data: {
          force_group_notify: true
        },
        display_message_template: ""
      };
    }
    $scope.addConditionDialog = function() {
      var addConditionModal;
      addConditionModal = $uibModal.open({
        templateUrl: 'notification_center/views/alert-config-condition-detail.html',
        controller: "AlertConfigConditionDetailCtrl",
        size: "lg",
        scope: $scope,
        backdrop: 'static'
      });
      return addConditionModal.result.then(function(conditions) {
        if (conditions) {
          return $scope.alertConfig.conditions = conditions;
        }
      });
    };
    $scope.isEmptyObject = function(obj) {
      return angular.equals({}, obj);
    };
    $scope.setForm = function(form) {
      return $scope.form = form;
    };
    $scope.available_properties = _.map((ref = $scope.getEventTemplate($scope.alertConfig.event_name)) != null ? ref.available_properties : void 0, function(prop) {
      return {
        key: prop,
        value: prop
      };
    });
    $scope.modify = function() {
      var meta_params;
      if (!$scope.alertConfig.id) {
        meta_params = $scope.getEventTemplate($scope.alertConfig.event_name).meta_params;
        if (meta_params) {
          $scope.alertConfig.data.meta_params = $scope.getEventTemplate($scope.alertConfig.event_name).meta_params;
        }
      }
      return $uibModalInstance.close($scope.alertConfig);
    };
    $scope.addGroup = function(groupId) {
      $scope.form.$setDirty();
      return $scope.alertConfig.groups.push(groupId);
    };
    $scope.removeGroup = function(groupId) {
      $scope.form.$setDirty();
      return $scope.alertConfig.groups.splice($scope.alertConfig.groups.indexOf(groupId), 1);
    };
    $scope.checkInId = function(not_in_list) {
      return function(item, index, array) {
        var ref1;
        if ((not_in_list != null) && (ref1 = item.id, indexOf.call(not_in_list, ref1) >= 0)) {
          return false;
        }
        return true;
      };
    };
    $scope.remove = function() {
      var pr;
      pr = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("DOC_NOT_SAVED");
          },
          text: function() {
            return $filter('translate')("CONFIRM_CLOSE_NOT_SAVED");
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return null;
          },
          okButtonText: function() {
            return "Ok";
          }
        }
      });
      return pr.result.then((function(confirmation) {
        if (confirmation) {
          $scope.alertConfig.requestDelete = true;
          return $uibModalInstance.close($scope.alertConfig);
        }
      }));
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

  angular.module("mhclientApp").controller('AlertConfigConditionDetailCtrl', ["$scope", "$uibModal", "$q", "$filter", "$uibModalInstance", "ThesaurusUtils", function($scope, $uibModal, $q, $filter, $uibModalInstance, ThesaurusUtils) {
    var availableConditions, cleanCondition, condition, conditionsPromises, i, len, ref;
    availableConditions = $scope.getEventTemplate($scope.alertConfig.event_name).availableConditions || [];
    conditionsPromises = [];
    if (availableConditions.length === 0) {
      ref = $scope.getEventTemplate($scope.alertConfig.event_name).conditions;
      for (i = 0, len = ref.length; i < len; i++) {
        condition = ref[i];
        if (typeof condition === "function") {
          conditionsPromises.push(condition());
        } else {
          availableConditions.push(condition);
        }
      }
    }
    $q.all(conditionsPromises).then(function(conditions) {
      $scope.getEventTemplate($scope.alertConfig.event_name).availableConditions = conditions.concat(availableConditions);
      $scope.availableConditions = $scope.getEventTemplate($scope.alertConfig.event_name).availableConditions;
      return $scope.condition = {
        mode: "node",
        operator: "AND",
        childs: [
          {
            mode: "condition"
          }
        ]
      };
    });
    cleanCondition = function(condition) {
      var j, len1, ref1, results;
      delete condition.option_key;
      delete condition.option_display;
      delete condition.options;
      delete condition.availableOperators;
      ref1 = condition.childs || [];
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        condition = ref1[j];
        results.push(cleanCondition(condition));
      }
      return results;
    };
    $scope.acceptConditions = function() {
      $scope.form.$setDirty();
      cleanCondition($scope.condition);
      return $uibModalInstance.close($scope.condition);
    };
    $scope.addNode = function(condition, operator) {
      var newNode, otherNode;
      otherNode = {
        mode: "node",
        operator: "AND",
        childs: [
          {
            mode: "condition"
          }
        ]
      };
      if (condition.operator === operator) {
        return condition.childs.push(otherNode);
      } else {
        newNode = {
          mode: "node",
          operator: condition.operator,
          childs: condition.childs
        };
        condition.operator = operator;
        return condition.childs = [newNode].concat([otherNode]);
      }
    };
    $scope.addCondition = function(conditions) {
      return conditions.push({
        mode: "condition"
      });
    };
    $scope.initCondition = function(selectedCondition, condition) {
      var thesaurusModal;
      if (selectedCondition.type === "thesaurus") {
        thesaurusModal = $uibModal.open({
          animation: true,
          templateUrl: 'notification_center/views/sub-conditions-modal.html',
          controller: 'subConditionsModalCtrl',
          resolve: {
            title: function() {
              return $filter('translate')("CHOOSE_YOUR_CONDITIONS");
            },
            okButtonText: function() {
              return $filter('translate')("VALIDATE");
            },
            cancelButtonText: function() {
              return $filter('translate')("CANCEL");
            },
            condition: function() {
              return selectedCondition;
            }
          }
        });
        return thesaurusModal.result.then((function(selectedItems) {
          var item;
          if (selectedItems) {
            condition.availableOperators = selectedCondition.availableOperators || ["=="];
            condition.operator = (selectedCondition.availableOperators || ["=="])[0];
            condition.value = _.map(selectedItems, "uid");
            condition.label = selectedCondition.label;
            condition.check_property = selectedCondition.check_property;
            condition.type = selectedCondition.type;
            return condition.display_label = "[" + ((function() {
              var j, len1, results;
              results = [];
              for (j = 0, len1 = selectedItems.length; j < len1; j++) {
                item = selectedItems[j];
                results.push(item.short_name || item.label);
              }
              return results;
            })()).join(', ') + "]";
          }
        }));
      } else {
        condition.option_key = selectedCondition.option_key;
        condition.option_display = selectedCondition.option_display;
        condition.options = selectedCondition.options;
        condition.availableOperators = selectedCondition.availableOperators || ["=="];
        condition.operator = (selectedCondition.availableOperators || ["=="])[0];
        if (selectedCondition.type === "checkbox") {
          condition.value = true;
        } else {
          condition.value = "";
        }
        condition.label = selectedCondition.label;
        condition.check_property = selectedCondition.check_property;
        return condition.type = selectedCondition.type;
      }
    };
    return $scope.cancelConditions = function() {
      return $uibModalInstance.close(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=alert-config-detail-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:redirectUtils
    * @description
    * # redirectUtils
    * Factory of redirectUtils
   */
  angular.module("mhclientApp").factory('redirectUtils', ["$filter", "$rootScope", "$state", "$q", function($filter, $rootScope, $state, $q) {
    var redirectToAlert, service;
    redirectToAlert = function(alertDetail) {
      var params, ref, template;
      $rootScope.busy = true;
      template = _.find($rootScope.alertTemplates, {
        event_name: alertDetail.config.event_name
      });
      if (template.route) {
        params = ((ref = alertDetail.data) != null ? ref.meta_params : void 0) || {};
        params.idStay = alertDetail.stay;
        params.idPatient = alertDetail.patient;
        params.alertDetail = alertDetail;
        $rootScope.busy = false;
        return $state.go(template.route, params);
      } else {
        return $rootScope.busy = false;
      }
    };
    service = {
      redirectToAlert: redirectToAlert
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=redirect-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:subConditionsModalCtrl
    * @description
    * # subConditionsModalCtrl
    * Provider of subConditionsModalCtrl
   */
  angular.module("mhclientApp").controller('subConditionsModalCtrl', ["$scope", "$rootScope", "$uibModalInstance", "title", "okButtonText", "cancelButtonText", "condition", "ThesaurusUtils", function($scope, $rootScope, $uibModalInstance, title, okButtonText, cancelButtonText, condition, ThesaurusUtils) {
    var completeCategory, initThesaurus;
    $scope.title = title;
    $scope.cancelButtonText = cancelButtonText;
    $scope.okButtonText = okButtonText;
    $scope.selected_uids = [];
    $scope.eventThesaurusOptions = {
      start_level: condition.startLevel || 1,
      selectedCategory: null,
      thesaurusCategories: []
    };
    $scope.filterThesaurus = function(thesaurusEntries, filter, showObsolete) {
      return ThesaurusUtils.filter(thesaurusEntries, filter, showObsolete);
    };
    initThesaurus = function(thesaurusEntries, level, start_level) {
      var i, len, results, thesaurusEntry;
      results = [];
      for (i = 0, len = thesaurusEntries.length; i < len; i++) {
        thesaurusEntry = thesaurusEntries[i];
        thesaurusEntry.level = level;
        thesaurusEntry.active = level <= start_level;
        thesaurusEntry.hide = false;
        results.push(initThesaurus(thesaurusEntry.entries || [], level + 1, start_level));
      }
      return results;
    };
    completeCategory = function(thesaurusCategory) {
      return ThesaurusUtils.getThesaurusEntries({
        "category": thesaurusCategory.id
      }, true).then(function(thesaurusEntries) {
        var newOption;
        initThesaurus(thesaurusEntries, 0, $scope.eventThesaurusOptions.start_level);
        newOption = {
          label: thesaurusCategory.label,
          thesaurus_tree: thesaurusEntries
        };
        $scope.eventThesaurusOptions.thesaurusCategories.push(newOption);
        if (!$scope.eventThesaurusOptions.selectedCategory) {
          newOption.active = true;
          return $scope.eventThesaurusOptions.selectedCategory = newOption;
        }
      });
    };
    ThesaurusUtils.getThesaurusCategories(condition.query, true).then(function(thesaurusCategories) {
      var i, len, results, thesaurusCategory;
      results = [];
      for (i = 0, len = thesaurusCategories.length; i < len; i++) {
        thesaurusCategory = thesaurusCategories[i];
        results.push(completeCategory(thesaurusCategory));
      }
      return results;
    });
    $scope.yes = function() {
      return $uibModalInstance.close($scope.selected_uids);
    };
    $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
    return $scope.choiceChanged = function(careItem) {
      if (careItem.selected) {
        return $scope.selected_uids.push(careItem);
      } else {
        return _.remove($scope.selected_uids, careItem);
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=sub-conditions-modal-controller.js.map


'use strict';


angular.module("mhclientApp").factory('ExternalSync', ["$resource", "MhConfig", function($resource, MhConfig) {
  // Set API's version
  var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
  return $resource("/api_rest/external_sync/:id/:route",
      {
        id: '@id',
        extra: '@extra',
      },
      {
        'get': {
          headers: {'Accept': acceptHeader},
        },
        'query': {
          headers: {'Accept': acceptHeader},
          isArray: true,
        },
        'export_csv': {
          headers: {'Accept': acceptHeader},
          params: {route: 'export_csv'},
          responseType: 'arraybuffer',
          transformResponse: function(data, headersGetter) {
            return {
              data: data,
              headers: headersGetter
            }
          }
        },
        'save': {
          headers: {'Accept': acceptHeader},
          method: 'POST',
        },
        'getInitialRecipients': {
          headers: {'Accept': acceptHeader},
          params: {route: 'get_initial_recipients'},
          isArray: true
        },
        'getInitialMetadata': {
          headers: {'Accept': acceptHeader},
          params: {route: 'get_initial_metadata'},
          isArray: false
        },
        'getMssUsers': {
          headers: {'Accept': acceptHeader},
          params: {route: 'get_mss_users'},
          isArray: true
        },
        'updateConfig': {
          headers: {'Accept': acceptHeader},
          params: {route: 'update_config'},
          method: 'PATCH',
        },
        'sync': {
          headers: {'Accept': acceptHeader},
          params: {route: 'sync'},
          method: 'PATCH',
          isArray: false
        },
        'retry': {
          headers: {'Accept': acceptHeader},
          params: {route: 'retry'},
          method: 'PATCH',
          isArray: false
        },
        'unsync': {
          headers: {'Accept': acceptHeader},
          params: {route: 'unsync'},
          method: 'PATCH',
          isArray: false
        }

      }
  );
}]);


'use strict';


angular.module("mhclientApp").component("docBroadcastingModal", {
    templateUrl: "external_sync/views/doc-broadcasting-modal.html",
    controller: ["$rootScope", "ExternalSync", "$timeout", function DocBroadcastingCtrl($rootScope, ExternalSync, $timeout){
      var ctrl = this;
      ctrl.$onInit = function () {
        ctrl.patient = ctrl.resolve.patient;
        ctrl.externalSyncs = ctrl.resolve.externalSyncs
        ctrl.dirty = ctrl.resolve.dirty
      };
      ctrl.filterDirties = function (externalSyncs) { return _.map(_.filter(externalSyncs, "form.$dirty"), function(externalSync) { return _.omit(externalSync, ["form"])})}
      ctrl.toggle = function(externalSync){
        $timeout(function() {
          externalSync.to_sync = !externalSync.to_sync
          externalSync.form.$setDirty()
        })

      }

      ctrl.retry = function(externalSync) {
        $rootScope.busy = true
        ExternalSync.retry({id:externalSync.id}).$promise.then (function (updatedExternalSync){
          _.assign(externalSync, updatedExternalSync)
          $rootScope.busy = false
        })
      }
    }],
    bindings: {resolve: '<', close: '&', dismiss: '&'},
  });


angular.module("mhclientApp").component("externalSync", {
  templateUrl: "external_sync/views/external-sync.html",
  bindings: {preFetchExternalSyncs: "<?", contentType: "@", objectId: "@", docType: "@", stay: "<", patient: "<", dirty: "<"},
  controller:  ["$rootScope", "$scope", "$q", "$uibModal", "$timeout", "SiteVarsUtils", "ExternalSync", function ExternalsCtrl($rootScope, $scope, $q, $uibModal, $timeout, SiteVarsUtils, ExternalSync) {
    var ctrl = this;
    if ($rootScope.mh_config.platform == 'mhsi'){
      SiteVarsUtils.getValue("availableExternalSyncs", []).then (function(availableExternalSyncs){
        var externalSyncs = [];
        _.forEach(_.reject(availableExternalSyncs, "auto"), function(externalSync){
          if ((ctrl.patient.dmp_data[externalSync.sync_type] || {}).enabled){
            var type = externalSync["documents"][[ctrl.contentType, ctrl.docType].join(".")] || externalSync["documents"][[ctrl.contentType, '__all__'].join(".")] || false

            if (type){ externalSyncs.push(_.assign(type, {sync_type: externalSync.sync_type, sync_params: externalSync.params, sync_label: externalSync.label}))}
          }
          return
        })
        if (externalSyncs.length > 0){
          return $q.when(ctrl.preFetchExternalSyncs || ExternalSync.query({content_type_name: ctrl.contentType, object_id: ctrl.objectId}).$promise).then (function(existingExternalSyncs){
              ctrl.externalSyncs = _.map(externalSyncs, function(externalSync){
                  return _.assign(_.find(existingExternalSyncs, {sync_type: externalSync.sync_type}) || {
                    sync_type: externalSync.sync_type,
                    content_type: ctrl.contentType,
                    stay: ctrl.stay.id,
                    patient: ctrl.patient.id,
                    object_id: ctrl.objectId,
                    config: _.cloneDeep(externalSync.config || {})
                    }, _.pick(externalSync, ["sync_label", "sync_params"]))
              })
          })
        } else {ctrl.externalSyncs = []}
      })
    }

    ctrl.handleDocBroadcast = function(formVersion){
      if (ctrl.dirty) {return}
      return ExternalSync.getInitialMetadata({content_type: ctrl.contentType, object_id: ctrl.objectId}).$promise.then( function(initialMetadata){
        _.forEach(_.reject(ctrl.externalSyncs, "id"), function(externalSync){externalSync.metadata = _.merge({}, initialMetadata, externalSync.config)})
        return $uibModal.open({
          animation  : true,
          component: 'docBroadcastingModal',
          windowClass: 'modal-fullscreen',
          resolve: {
              patient: function(){return ctrl.patient},
              externalSyncs: function(){return _.cloneDeep(ctrl.externalSyncs)},
              dirty: ctrl.dirty,
          }
        }).result.then(function (updatedSyncs) {
          $rootScope.busy = true
          $q.all(_.map(updatedSyncs, function(updatedSync) {
            var method, originalSync;
            if (updatedSync.id || updatedSync.to_sync){
              originalSync = _.find(ctrl.externalSyncs,  {sync_type: updatedSync.sync_type})
              if (updatedSync.id){
                if (originalSync.to_sync != updatedSync.to_sync){ method = updatedSync.to_sync ?  ExternalSync.sync : ExternalSync.unsync}
                else { method = ExternalSync.updateConfig}
              }
              else { method = ExternalSync.save }
              return method(updatedSync).$promise.then (function(updatedExternalSync){
                _.assign(originalSync, updatedExternalSync);
              })
            }
            return
          })).then (function() {$rootScope.busy = false})
        })
      })
    }
  }],

});


'use strict';

angular.module('mhclientApp').filter('mssMailFilter', function() {
  return function(mssMessages, query, mssTypes) {

    var regex;
    if (mssTypes && mssTypes.length > 0) {
     mssMessages =  _.filter(mssMessages, function (message){return mssTypes.indexOf(message.sync_type) > -1})
    }

    if (!query || query.length == 0) {return mssMessages }
    regex = new RegExp('' + query.replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i');
    return _.filter(mssMessages, function (message){
      return (
        regex.test(message.data.perfomer_full_name) ||
        regex.test(message.metadata.message_content) ||
        regex.test(message.metadata.title) ||
        _.some(message.recipients, function(recipient) {return _.some(recipient.mss_address, function(address){return regex.test(address.value)})})
      )
    })
  };

});

angular.module("mhclientApp").component("externalSyncState", {
    templateUrl: "external_sync/views/external-sync-state.html",
    controller: ["$rootScope", "ExternalSync", function sendMailModalCtrl($rootScope, ExternalSync){
      var ctrl = this;
      ctrl.retry = function(externalSync) {
        $rootScope.busy = true
        ExternalSync.retry({id:externalSync.id}).$promise.then (function (updatedExternalSync){
          _.assign(externalSync, updatedExternalSync)
          $rootScope.busy = false
        })
      }

    }],
    bindings: {externalSync: "="},
  });

angular.module("mhclientApp").component("sendMailModal", {
    templateUrl: "external_sync/views/send-mail-modal.html",
    controller: ["$rootScope", "ExternalSync", "$timeout", function sendMailModalCtrl($rootScope, ExternalSync, $timeout){
      var ctrl = this;
      ctrl.$onInit = function () {
        ctrl.patient = ctrl.resolve.patient;
        ctrl.externalSync = ctrl.resolve.externalSync
        ctrl.dirty = ctrl.resolve.dirty
      };

    }],
    bindings: {resolve: '<', close: '&', dismiss: '&'},
  });


angular.module("mhclientApp").component("mssList", {
  templateUrl: "external_sync/views/mss-list.html",
  bindings: {patient: "<", stay: "<"},
  controller:  ["$rootScope", "$uibModal", "$filter", "ExternalSync", function stayMssCtrl($rootScope, $uibModal, $filter, ExternalSync) {
    var ctrl = this;

    ctrl.availableFilters = [
        {name:$filter('translate')('order_by_timestamp'), value:['-timestamp']},
      ]

    ctrl.mssTypes = [
      {name:$filter('translate')('MSS-C'), value:'MSS-C'},
      {name:$filter('translate')('MSS-P'), value:'MSS-P'},
    ]

    ctrl.currentFilter = ctrl.availableFilters[0]
    ctrl.extraFilter = {}

    var params = $rootScope.allStays ? {patient:ctrl.patient.id} : {stay:ctrl.stay.id}
    ExternalSync.query(_.merge({sync_type: "MSS-C"}, params)).$promise.then(function (mssC) {
      ExternalSync.query(_.merge({sync_type: "MSS-P"}, params)).$promise.then(function (mssP) {
        ctrl.mssMessages = _.concat(mssC, mssP)
        console.log(ctrl.mssMessages)
      })
    })

    ctrl.sendEmail = function () {
        return $uibModal.open({
          animation  : true,
          component: 'sendMailModal',
          windowClass: 'modal-fullscreen',
          resolve: {
              patient: function(){return ctrl.patient},
              externalSync: function(){return {
                sync_type: "MSS-C",
                stay: ctrl.stay.id,
                content_type: null,
                object_id: "",
                performer: $rootScope.user.id,
                patient: ctrl.patient.id,
                config: {},
                metadata: {},
                recipients: []
                }
              },
          }
        }).result.then(function (updatedSyncs) {
            return ExternalSync.save(updatedSyncs).$promise.then (function(updatedExternalSync){
              ctrl.mssMessages.push(updatedExternalSync)
            })
        })

    }

  }],

});




angular.module("mhclientApp").component("mssMail", {
  templateUrl: "external_sync/views/mss-mail.html",
  bindings: {externalSync: "<", patient: "<", readOnly: "<", showStatus: "<"},
  controller:  ["$q", "ExternalSync", "UserByUsername", function mssPBroadcastConfigCtrl($q, ExternalSync, UserByUsername) {

    var ctrl = this;

    ctrl.updateMssInfo = function (user) {
      ctrl.busy = true
      UserByUsername.updateMssInfoByIdNat({id:user.username}).$promise.then (function(mssAdress){
        user.mss_address = _.map(mssAdress, function(address) {address.selected = (_.find(user.mss_address, {"value": address.value}) || {"value": true}).selected; return address})
        ctrl.busy = false
      })
    }


    ctrl.download = function () {
      window.open('/api_rest/external_sync/'+ctrl.externalSync.id+'/to_pdf', '_blank')
    }

    ctrl.userSelection = function (user) {
      ctrl.externalSync.recipients.push(_.assign(
        _.pick(user, ["id_nat", "username", "type", "full_name"]),
        _.pick(user.data, "mss_address")
      ))
    }

    ctrl.getMssUsers = function(query) {
      return ExternalSync.getMssUsers({query:query}).$promise.then (function (users){
        users = _.reject(_.uniqBy(users, 's_mail'), function(user) {return _.isEmpty(user.s_mail)})
        return _.map(users, function(user){
          return {
            "id_nat": user.s_idNat,
            "username": user.s_mail,
            "type": "mss",
            "__display": user.s_commonName + " " + user.s_mail,
            "full_name": user.s_commonName,
            "data": {"mss_address": [{"value": user.s_mail,"selected": true}]}
          }
        })
      })
    }
    $q.when(ctrl.externalSync.recipients || (ctrl.externalSync.sync_type == "MSS-P" ? ExternalSync.getInitialRecipients(_.pick(ctrl.externalSync, ["object_id", "content_type"])).$promise : [])
    ).then (function(initialRecipients){
      ctrl.externalSync.recipients = initialRecipients
    })

  }],

});


(function() {
  'use strict';
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').directive('transmissionMessageCanvas', function() {
    return {
      restrict: 'A',
      transclude: true,
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'transmissions/views/transmission-message-canvas.html';
        }
      },
      scope: {
        content: '=',
        readOnly: "="
      },
      controller: ["$rootScope", "$scope", "$q", "SiteVarsUtils", "Group", "Message", "Thread", "Upload", function($rootScope, $scope, $q, SiteVarsUtils, Group, Message, Thread, Upload) {
        $scope.availableColors = ['black', 'blue', 'red', 'green'];
        $scope.canvasMaxHeight = 500;
        $scope.config = Message.getDefaultDrawConfig();
        $scope.config.readonly = $scope.readOnly;
        $scope.addSpace = function() {
          var height;
          height = parseInt(new String($scope.content.size.height).split('px').shift());
          if (height < $scope.canvasMaxHeight) {
            return $scope.content.size.height = height + 100;
          }
        };
        return $scope.toggleColor = function(color) {
          $scope.config.penColor = color;
          if ($scope.config.action === 'erase') {
            $scope.config.action = 'draw';
          }
          return true;
        };
      }]
    };
  });

  angular.module('mhclientApp').directive('transmissionNewResponse', function() {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'transmissions/views/transmission-new-response.html';
        }
      },
      scope: {
        parent: '=',
        saveCallBack: '=',
        thread: '='
      },
      controller: ["$rootScope", "$scope", "$q", "SiteVarsUtils", "Group", "Message", "Thread", "Upload", function($rootScope, $scope, $q, SiteVarsUtils, Group, Message, Thread, Upload) {
        $scope.cancel = function() {
          return $scope.cancelCallBack();
        };
        $scope.newMessage = {
          category: Message.getResponseForCategory($scope.parent.category),
          stay: $scope.thread.stay,
          priority: 0,
          data: {},
          content: {
            data: [],
            mode: "text",
            size: {
              width: 900,
              height: 100
            }
          },
          from_platform: $rootScope.mh_config.platform,
          timestamp: new Date().toISOString(),
          parent: $scope.parent.id,
          thread: $scope.thread.id
        };
        $scope.canSave = function() {
          return Message.isMessageValid($scope.newMessage);
        };
        return $scope.respondMessage = function() {
          if ($scope.newMessage.content.mode === "draw") {
            Message.cropEmptySpace($scope.newMessage);
          }
          $rootScope.busy = true;
          return Message.api.save($scope.newMessage).$promise.then(function(messageResponse) {
            $rootScope.busy = false;
            return $scope.saveCallBack(messageResponse);
          });
        };
      }]
    };
  });

  angular.module('mhclientApp').directive('transmissionNewThread', function() {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'transmissions/views/transmission-new-thread.html';
        }
      },
      scope: {
        category: '=',
        feed: "=",
        stay: "=",
        saveCallBack: "="
      },
      controller: ["$rootScope", "$scope", "$q", "SiteVarsUtils", "Group", "Message", "Thread", "Upload", function($rootScope, $scope, $q, SiteVarsUtils, Group, Message, Thread, Upload) {
        $scope.grpResource = Group.query;
        $scope.cancel = function() {
          return $scope.category = false;
        };
        $scope.newMessage = {
          category: $scope.category,
          stay: $scope.stay.id,
          priority: 0,
          data: {},
          content: {
            data: [],
            mode: "text",
            size: {
              width: 900,
              height: 100
            }
          },
          timestamp: new Date().toISOString(),
          from_platform: $rootScope.mh_config.platform
        };
        $scope.newThread = {
          first_message: $scope.newMessage,
          feed: $scope.feed.id,
          stay: $scope.stay.id,
          tmpGrpRecipients: [],
          tmpUserRecipients: []
        };
        if ($scope.category === 'cible') {
          $scope.newMessage.targetNumberInput = '';
          SiteVarsUtils.get('CIBLE_CATEGORIES_LABEL', SiteVarsUtils.defaultCibleCategoriesLabel).then(function(sitevar) {
            var key, ref, value;
            $scope.cibleCategories = [];
            ref = sitevar.value;
            for (key in ref) {
              value = ref[key];
              $scope.cibleCategories.push({
                category: key,
                messages: value
              });
            }
            $scope.cibleCategories = _.orderBy($scope.cibleCategories, "category");
            $scope.selectedCategory = $scope.cibleCategories[0];
            $scope.newMessage.targetLabel = $scope.selectedCategory.messages[0];
            return $scope.newMessage.content.data = $scope.newMessage.targetLabel.label;
          });
        }
        $scope.canSave = function() {
          return Message.isMessageValid($scope.newMessage);
        };
        return $scope.sendThread = function() {
          $rootScope.busy = true;
          if ($scope.newMessage.category === 'cible' && $scope.newMessage.targetNumberInput !== '') {
            $scope.newMessage.content.data = $scope.newMessage.targetLabel.label + ": " + $scope.newMessage.targetNumberInput;
          }
          $scope.newThread.grp_recipients = _.map($scope.newThread.tmpGrpRecipients, "id");
          $scope.newThread.user_recipients = _.map($scope.newThread.tmpUserRecipients, "id");
          if ($scope.newMessage.content.mode === "draw") {
            Message.cropEmptySpace($scope.newMessage);
          }
          return Thread.api.save($scope.newThread).$promise.then(function(threadResponse) {
            var attachementDonePromise;
            attachementDonePromise = $q.defer();
            if ($scope.newMessage.attach != null) {
              attachementDonePromise.resolve(Upload.upload({
                url: "/api_rest/messages/" + threadResponse.first_message.id + "/upload_image",
                method: "PUT",
                file: $scope.newMessage.attach
              }).then((function(resp) {
                return resp;
              }), (function(resp) {
                return false;
              })));
            } else {
              attachementDonePromise.resolve(false);
            }
            return attachementDonePromise.promise.then(function(response) {
              $rootScope.busy = false;
              threadResponse.first_message.attachments = response ? response.data : [];
              return $scope.saveCallBack(threadResponse);
            });
          });
        };
      }]
    };
  });

  angular.module('mhclientApp').directive('transmissionChronologicMessage', ["TransmissionMessage", function(TransmissionMessage) {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'transmissions/views/transmission-chronologic-message.html';
        }
      },
      scope: {
        message: '=',
        canEdit: '=',
        patient: "=",
        transmissionsFilters: "=",
        thread: "="
      },
      controller: ["$scope", "$http", function($scope, $http) {
        $scope.createResponse = function() {
          return $scope.creatingNewResponse = true;
        };
        TransmissionMessage.getDetails($scope.message);
        $scope.isImage = function(attachment) {
          var ref;
          return (ref = attachment.split('.').pop()) === 'jpg' || ref === 'gif' || ref === 'jpeg' || ref === 'png';
        };
        return $scope.saveCallBack = function(message) {
          message.read = true;
          $scope.creatingNewResponse = false;
          if ($scope.message.responses == null) {
            $scope.message.responses = [];
          }
          return $scope.message.responses.unshift(message);
        };
      }]
    };
  }]);

  angular.module('mhclientApp').directive('transmissionHierarchicMessage', ["RecursionHelper", function(RecursionHelper) {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'transmissions/views/transmission-hierarchic-message.html';
        }
      },
      scope: {
        message: '=',
        canEdit: '=',
        thread: "="
      },
      controller: ["$scope", "$http", "Message", function($scope, $http, Message) {
        $scope.createResponse = function() {
          return $scope.creatingNewResponse = true;
        };
        $http.get($scope.message.content_url).then(function(content) {
          return $scope.message.content = content.data;
        });
        return $scope.saveCallBack = function(message) {
          message.read = true;
          $scope.creatingNewResponse = false;
          if ($scope.message.responses == null) {
            $scope.message.responses = [];
          }
          return $scope.message.responses.unshift(message);
        };
      }],
      compile: function(element) {
        return RecursionHelper.compile(element);
      }
    };
  }]);

  angular.module('mhclientApp').directive('transmissionThread', function() {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'transmissions/views/transmission-thread.html';
        }
      },
      scope: {
        thread: '=',
        canEdit: "=",
        canArchive: "=",
        isActiveStay: "=",
        canStillBeAltered: "=",
        showPatientInfo: "="
      },
      controller: ["$rootScope", "$scope", "$http", "Thread", "TransmissionThread", function($rootScope, $scope, $http, Thread, TransmissionThread) {
        $scope.createResponse = function() {
          $scope.thread.showDetails = true;
          return $scope.creatingNewResponse = true;
        };
        $scope.saveCallBack = function(message) {
          message.read = true;
          $scope.creatingNewResponse = false;
          return $scope.thread.first_message.responses.unshift(message);
        };
        TransmissionThread.getDetails($scope.thread);
        $scope.archive = function(thread) {
          thread.data.archivedDate = new Date();
          $rootScope.busy = true;
          return Thread.api.update({
            id: thread.id
          }, {
            archived: true,
            data: thread.data,
            uid: thread.uid
          }).$promise.then(function() {
            thread.archived = true;
            return $rootScope.busy = false;
          });
        };
        $scope.isImage = function(attachment) {
          var ref;
          return (ref = attachment.split('.').pop()) === 'jpg' || ref === 'gif' || ref === 'jpeg' || ref === 'png';
        };
        return $scope.unArchive = function(thread) {
          $rootScope.busy = true;
          return Thread.api.update({
            id: thread.id
          }, {
            archived: false,
            uid: thread.uid
          }).$promise.then(function() {
            thread.archived = false;
            return $rootScope.busy = false;
          });
        };
      }]
    };
  });

  angular.module('mhclientApp').directive('transmissionList', function() {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'transmissions/views/transmission-list.html';
        }
      },
      scope: {
        patient: '=',
        stay: '=',
        allStays: "=",
        options: "=?",
        readOnly: "=?",
        infiniteScrollParent: "=",
        categories: "=?",
        pancarte: "=?"
      },
      controller: ["$rootScope", "$q", "$scope", "$filter", "TransmissionThread", "Sector", "TransmissionMessage", "SiteVarsUtils", "FeedUtils", "UserCreation", function($rootScope, $q, $scope, $filter, TransmissionThread, Sector, TransmissionMessage, SiteVarsUtils, FeedUtils, UserCreation) {
        var choices, currentFiler, initialLimitTo, limitToIncrement, messagesFilter, queryParams, transmissionsFilter;
        $scope.updateFilters = function() {
          $rootScope.busy = true;
          return UserCreation.updateFilters({
            id: $rootScope.user.id,
            filters: $rootScope.user.filters
          }).$promise.then(function() {
            $scope.filtersChanged = false;
            return $rootScope.busy = false;
          });
        };
        $scope.actions = {
          creatingNewThread: false
        };
        currentFiler = null;
        $scope.hasMore = false;
        choices = [
          {
            label: $filter('translate')("TARGET"),
            value: "cible"
          }, {
            label: $filter('translate')("MACRO_TARGET"),
            value: "macro-cible"
          }, {
            label: $filter('translate')("NOTE"),
            value: "note"
          }
        ];
        if ($scope.categories === void 0) {
          $scope.categories = ['cible', 'macro-cible', 'note'];
        }
        $scope.transmissionsFilters = {
          "categories": {
            "selected": [],
            "choices": _.filter(choices, function(choice) {
              var ref;
              return ref = choice.value, indexOf.call($scope.categories, ref) >= 0;
            })
          },
          "archived": false,
          "important": false,
          "text": "",
          "date_from": moment(new Date()).add(-30, "days").toDate()
        };
        $scope.messageParams = {
          "date_from": $scope.stay ? void 0 : moment(new Date()).add(-30, "days").toDate(),
          "date_to": $scope.stay ? void 0 : new Date()
        };
        initialLimitTo = 8;
        limitToIncrement = 8;
        $scope.limitTo = initialLimitTo;
        queryParams = $scope.stay ? ($scope.allStays ? {
          patient: $scope.patient.id
        } : {
          stay: $scope.stay.id
        }) : {};
        $scope.initHierarchic = function(filtersChanged) {
          var dateParams, filterParams;
          $scope.filtersChanged = $scope.filtersChanged || filtersChanged;
          dateParams = $scope.stay ? {} : {
            date_from: moment($scope.transmissionsFilters.date_from).format('YYYY-MM-DD')
          };
          filterParams = {};
          if ($scope.pancarte) {
            filterParams.pancarte = true;
            filterParams.categories = $scope.categories;
          }
          if (!$scope.patient) {
            if ($rootScope.user.filters.stayStates && $rootScope.user.filters.stayStates.length > 0) {
              filterParams.stay_states = $rootScope.user.filters.stayStates;
            }
            if ($rootScope.user.filters.sectors && $rootScope.user.filters.sectors.length > 0) {
              filterParams.sectors = $rootScope.user.filters.sectors;
            }
          }
          $scope.mode = "hierarchic";
          $rootScope.busy = true;
          currentFiler = transmissionsFilter;
          return TransmissionThread.api.query(_.merge({}, queryParams, dateParams, filterParams)).$promise.then(function(threads) {
            $scope.threads = _.orderBy(threads, ['last_message_timestamp'], ['desc']);
            $scope.handleFilters();
            return $rootScope.busy = false;
          });
        };
        $scope.initChronologic = function(filtersChanged) {
          var dateParams, filterParams;
          $scope.filtersChanged = $scope.filtersChanged || filtersChanged;
          dateParams = {};
          filterParams = {};
          if ($scope.messageParams.date_from) {
            dateParams.date_from = moment($scope.messageParams.date_from).format('YYYY-MM-DD');
          }
          if ($scope.messageParams.date_to) {
            dateParams.date_to = moment($scope.messageParams.date_to).format('YYYY-MM-DD');
          }
          if (!$scope.patient) {
            if ($rootScope.user.filters.stayStates && $rootScope.user.filters.stayStates.length > 0) {
              filterParams.stay_states = $rootScope.user.filters.stayStates;
            }
            if ($rootScope.user.filters.sectors && $rootScope.user.filters.sectors.length > 0) {
              filterParams.sectors = $rootScope.user.filters.sectors;
            }
          }
          $scope.mode = "chronologic";
          $rootScope.busy = true;
          currentFiler = messagesFilter;
          return TransmissionMessage.api.query(_.merge({}, queryParams, dateParams, filterParams)).$promise.then(function(messages) {
            $scope.messages = _.orderBy(messages, ['timestamp'], ['desc']);
            $scope.handleFilters();
            return $rootScope.busy = false;
          });
        };
        FeedUtils.getFeedsByName("MHC_TRANSMISSION").then(function(feeds) {
          var ref;
          $scope.feed = feeds[0];
          $scope.canStillBeAltered = $scope.stay && $rootScope.canStayBeAltered($scope.stay);
          $scope.canArchive = $scope.stay && $rootScope.checkPermissions("MHC_TRANSMISSION", 'CAN_WRITE') && !$scope.readOnly;
          $scope.canEdit = $scope.canArchive && (((ref = $scope.stay.state) === 'PRE' || ref === 'ADM') || $scope.canStillBeAltered);
          $scope.showPatientInfo = !$scope.stay;
          return $q.when(!$scope.stay ? Sector.getSectors() : void 0).then(function(sectors) {
            $scope.sectors = sectors;
            return $scope.initHierarchic();
          });
        });
        $scope.handleFilters = function() {
          return currentFiler(initialLimitTo);
        };
        $scope.infinteScroll = function() {
          return currentFiler($scope.limitTo + limitToIncrement);
        };
        transmissionsFilter = function(newLimitTo) {
          var result;
          $scope.limitTo = newLimitTo;
          $scope.hasMore = false;
          result = TransmissionThread.filterTransmissions($scope.threads, $scope.transmissionsFilters, $scope.limitTo);
          $scope.filteredThreads = result.transmissions;
          return $scope.hasMore = result.hasMore;
        };
        messagesFilter = function(newLimitTo) {
          $scope.limitTo = newLimitTo;
          return $scope.hasMore = $scope.messages && $scope.messages.length > $scope.limitTo;
        };
        $scope.saveCallBack = function(thread) {
          $scope.actions.creatingNewThread = false;
          if ($scope.mode === "hierarchic") {
            $scope.filteredThreads.unshift(thread);
            $scope.threads.unshift(thread);
          } else {
            $scope.messages.unshift(thread.first_message);
          }
          return $rootScope.gotToTop();
        };
        return $scope.printData = function(docType, allStays, patient, stay) {
          if ($rootScope.allStays) {
            window.open('/api_rest/patients/' + patient.id + '/print_data/' + docType, '_blank');
          } else {
            window.open('/api_rest/stays/' + stay.id + '/print_data/' + docType, '_blank');
          }
          return true;
        };
      }]
    };
  });

  angular.module('mhclientApp').directive('infiniteScroll', function() {
    return {
      restrict: 'A',
      transclude: false,
      priority: 2,
      link: {
        pre: function(scope, elem, attrs) {
          var __check, timeout;
          timeout = null;
          elem.on('$destroy', function() {
            if (timeout) {
              return clearTimeout(timeout);
            }
          });
          if (!scope.$eval(attrs.infiniteScrollParent)) {
            delete attrs.infiniteScrollParent;
          }
          __check = function() {
            if (!scope.$eval(attrs.infiniteScrollDisabled) && attrs.infiniteScrollListenForEvent) {
              scope.$emit(attrs.infiniteScrollListenForEvent);
            }
            return timeout = setTimeout(__check, 2000);
          };
          return timeout = setTimeout(__check, 1000);
        }
      }
    };
  });

  angular.module('mhclientApp').directive('setParentWidth', function() {
    return {
      restrict: 'A',
      transclude: false,
      link: function(scope, elem, attrs) {
        var __check, timeout;
        timeout = null;
        elem.on('$destroy', function() {
          if (timeout) {
            return clearTimeout(timeout);
          }
        });
        __check = function() {
          var check;
          check = elem.parent();
          while (!(check.width() > 0)) {
            check = check.parent();
          }
          if (check.width() > 0) {
            elem.width(check.width());
          }
          return timeout = setTimeout(__check, 200);
        };
        return __check();
      }
    };
  });

  angular.module('mhclientApp').directive('setParentHeight', function() {
    return {
      restrict: 'A',
      transclude: false,
      link: function(scope, elem, attrs) {
        var __check, timeout;
        timeout = null;
        elem.on('$destroy', function() {
          if (timeout) {
            return clearTimeout(timeout);
          }
        });
        __check = function() {
          var adjust, parentHeight;
          parentHeight = elem.parent().height();
          if (parentHeight > 0) {
            if (attrs.heightAdjust) {
              adjust = parseInt(attrs.heightAdjust);
            } else {
              adjust = 0;
            }
            elem.height(parentHeight + adjust);
          }
          return timeout = setTimeout(__check, 200);
        };
        return __check();
      }
    };
  });

}).call(this);

//# sourceMappingURL=transmission-directives.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Thread
    * @description
    * # Thread
    * Factory of Thread
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").factory('TransmissionThread', ["$resource", "MhConfig", "$q", "BoxResource", "$http", function($resource, MhConfig, $q, BoxResource, $http) {
    var acceptHeader, api, boxAPI, filterTransmissions, getDetails, portailAPI, service, thread;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/transmission_threads/:id/:route', {
      id: this.id
    }, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'getDetails': {
        method: "GET",
        isArray: false,
        params: {
          route: 'get_details'
        },
        headers: {
          "Accept": acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        thread = window.mgapp.get('transmission_mgr').thread();
        boxAPI = BoxResource.generate(thread);
        boxAPI.getDetails = function(object) {
          return BoxResource.mhboxApiCall(thread, "get_details", object);
        };
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    getDetails = function(thread) {
      if (!thread.content && !thread.initializing) {
        thread.initializing = true;
        return api.getDetails({
          id: thread.id
        }).$promise.then(function(threadDetails) {
          var i, len, message, messagesByIdDict, ref, ref1;
          _.extend(thread, threadDetails);
          messagesByIdDict = {};
          messagesByIdDict[thread.first_message.id] = thread.first_message;
          ref = _.orderBy(_.concat([thread.first_message], threadDetails.messages), [
            (function(message) {
              return message.parent || 0;
            }), "timestamp"
          ], ['asc', 'desc']);
          for (i = 0, len = ref.length; i < len; i++) {
            message = ref[i];
            message.responses = [];
            message.read = (ref1 = message.id, indexOf.call(threadDetails.unread_messages, ref1) < 0);
            message.content_url = thread.data_folder + "/" + message.uid + "/content.json?" + message.modified;
            messagesByIdDict[message.id] = message;
            if (message.parent) {
              messagesByIdDict[message.parent].responses.push(message);
            }
          }
          thread.showDetails = thread.showDetails || threadDetails.unread_messages.length > 0;
          return $http.get(thread.first_message.content_url).then(function(content) {
            thread.content = content.data;
            return thread.initializing = false;
          });
        });
      }
    };
    filterTransmissions = function(transmissions, transmissionsFilters, limitTo) {
      var filtered, hasMore, i, len, ref, selectedCategories, transmission;
      filtered = [];
      selectedCategories = _.map(transmissionsFilters.categories.selected, "value");
      selectedCategories = selectedCategories.length > 0 ? selectedCategories : false;
      hasMore = false;
      for (i = 0, len = transmissions.length; i < len; i++) {
        transmission = transmissions[i];
        if (selectedCategories && !(ref = transmission.category, indexOf.call(selectedCategories, ref) >= 0)) {
          continue;
        }
        if (transmissionsFilters.archived !== transmission.archived) {
          continue;
        }
        if (transmissionsFilters.important && !transmission.important) {
          continue;
        }
        filtered.push(transmission);
        if (limitTo && filtered.length === limitTo) {
          hasMore = transmissions.length !== limitTo;
          break;
        }
      }
      return {
        transmissions: filtered,
        hasMore: hasMore
      };
    };
    service = {
      api: api,
      filterTransmissions: filterTransmissions,
      getDetails: getDetails
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('TransmissionMessage', ["$resource", "MhConfig", "$q", "BoxResource", "$http", function($resource, MhConfig, $q, BoxResource, $http) {
    var acceptHeader, api, boxAPI, getDetails, message, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/transmission_messages/:id/:route', {
      id: this.id
    }, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'getDetails': {
        method: "GET",
        isArray: false,
        params: {
          route: 'get_details'
        },
        headers: {
          "Accept": acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        message = window.mgapp.get('transmission_mgr').message();
        boxAPI = BoxResource.generate(message);
        boxAPI.getDetails = function(object) {
          return BoxResource.mhboxApiCall(message, "get_details", object);
        };
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    getDetails = function(message) {
      if (!message.content && !message.initializing) {
        message.initializing = true;
        return api.getDetails({
          id: message.id
        }).$promise.then(function(messageDetails) {
          _.extend(message, messageDetails);
          message.content_url = message.thread.data_folder + "/" + message.uid + "/content.json?" + message.modified;
          return $http.get(message.content_url).then(function(content) {
            message.content = content.data;
            return message.initializing = false;
          });
        });
      }
    };
    service = {
      api: api,
      getDetails: getDetails
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=transmission-services.js.map

(function() {
  angular.module('mhclientApp').directive('printData', ["$timeout", function($timeout) {
    return {
      controller: "PrintDataController",
      transclude: true,
      scope: {
        data: "="
      }
    };
  }]);

  angular.module('mhclientApp').controller('PrintDataController', ["$scope", "$window", "$timeout", "$element", "$q", function($scope, $window, $timeout, $element, $q) {
    var boundingRect, draw, drawPath, drawer, graphicElement, j, len, margin, maxX, maxY, minX, minY, ref, setContext, xPoints, yPoints;
    drawPath = function(path, context, smoothness) {
      var i, j, k, l, ref, ref1, xc, yc;
      context.beginPath();
      if (path.length === 2 && path[0].x === path[1].x && path[0].y === path[1].y) {
        context.arc(path[0].x, path[0].y, 1, 0, 2 * Math.PI, false);
        context.fill();
      } else {
        context.moveTo(path[0].x, path[0].y);
        if (smoothness) {
          for (i = j = 0, ref = path.length - 1; j < ref; i = j += 1) {
            xc = (path[i].x + path[i + 1].x) / 2;
            yc = (path[i].y + path[i + 1].y) / 2;
            context.quadraticCurveTo(path[i].x, path[i].y, xc, yc);
          }
        } else {
          for (k = l = 0, ref1 = path.length; l < ref1; k = l += 1) {
            context.lineTo(path[k].x, path[k].y);
          }
        }
      }
      context.stroke();
      return context.closePath();
    };
    drawer = function(start, step, data, context, insertImage) {
      var graphicElement, j, len, ref, stop;
      stop = window.Math.min(start + step, data.length);
      ref = data.slice(start, +stop + 1 || 9e9);
      for (j = 0, len = ref.length; j < len; j++) {
        graphicElement = ref[j];
        switch (graphicElement.action) {
          case 'draw':
            setContext(context, 'source-over', 1, graphicElement.color);
            drawPath(graphicElement.points, context, graphicElement.smooth);
            break;
          case 'erase':
            setContext(context, 'destination-out', 30, "rgb(0,0,0,1)");
            drawPath(graphicElement.points, context, graphicElement.smooth);
        }
      }
      if (start < stop) {
        return drawer(stop, step, data, context, insertImage);
      }
    };
    setContext = function(context, operation, lineWidth, color, lineJoin) {
      context.lineCap = 'round';
      context.globalCompositeOperation = operation;
      context.lineWidth = lineWidth;
      context.strokeStyle = color;
      if (lineJoin != null) {
        return context.lineJoin = lineJoin;
      }
    };
    $scope.bufferCanvas = {
      canvas: angular.element($element)[0],
      initConfig: function() {
        return this.context = this.canvas.getContext('2d');
      }
    };
    draw = function(boundingRect) {
      var ratio;
      ratio = _.min([angular.element($element).parent().width() / boundingRect.width, 1]);
      $scope.bufferCanvas.canvas.width = boundingRect.width * ratio;
      $scope.bufferCanvas.canvas.height = boundingRect.height * ratio;
      $scope.bufferCanvas.context.transform(ratio, 0, 0, ratio, -boundingRect.left, -boundingRect.top);
      return drawer(0, 100, $scope.data, $scope.bufferCanvas.context);
    };
    $scope.bufferCanvas.initConfig();
    if ($scope.data.length > 0) {
      margin = 5;
      xPoints = [];
      yPoints = [];
      ref = $scope.data;
      for (j = 0, len = ref.length; j < len; j++) {
        graphicElement = ref[j];
        xPoints = _.concat(xPoints, _.map(graphicElement.points, "x"));
        yPoints = _.concat(yPoints, _.map(graphicElement.points, "y"));
      }
      maxX = _.max(xPoints) + margin;
      minX = _.min(xPoints) - margin;
      maxY = _.max(yPoints) + margin;
      minY = _.min(yPoints) - margin;
      boundingRect = {
        top: minY,
        left: minX,
        width: maxX - minX,
        height: maxY - minY
      };
      draw(boundingRect);
      return angular.element($window).bind('resize', function() {
        $scope.bufferCanvas.context.clearRect(0, 0, $scope.bufferCanvas.canvas.width, $scope.bufferCanvas.canvas.height);
        return draw(boundingRect);
      });
    }
  }]);

}).call(this);

//# sourceMappingURL=print-data-directive.js.map

'use strict';

/*
  * @ngdoc function
  * @name mhclientApp.service:MHDevice
  * @description
  * # MHDevice
  * Factory of MHDevice
  */
angular.module("mhclientApp").factory('MHDevice', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
  var acceptHeader, portailAPI;
  acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
  portailAPI = $resource('/api_rest/mhdevices/:id/:route', {}, {
    'query': {
      method: "GET",
      headers: {
        'Accept': acceptHeader
      },
      isArray: true
    },
    'getSectors': {
      headers: {'Accept': acceptHeader},
      method: 'GET',
      isArray: true,
      params: { route: 'get_sectors' }
    },
    'getDevicesPatientsLinks': {
      headers: {
        'Accept': acceptHeader
      },
      method: 'GET',
      isArray: true,
      params: {
        route: 'get_devices_patients_links'
      }
    },
    'getLastSynchroDates': {
      headers: {
        'Accept': acceptHeader
      },
      method: 'GET',
      isArray: true,
      params: {
        route: 'get_last_synchro_dates'
      }
    },
    'getNbPendingDownloads': {
      headers: {
        'Accept': acceptHeader
      },
      method: 'GET',
      isArray: true,
      params: {
        route: 'get_nb_pending_downloads'
      }
    },
    'get': {
      method: 'GET'
    },
    'update': {
      method: 'PUT',
      params: {
        id: '@id'
      }
    },
    'save': {
      headers: {
        'Accept': acceptHeader
      },
      method: 'POST'
    },
    'setDevicesMode': {
      headers: {
        'Accept': acceptHeader
      },
      method: 'PUT',
      params: {
        route: 'set_devices_mode'
      }
    }
  });
  return {
    api: portailAPI
  };
}]);

'use strict';

/*
 # @ngdoc function
 # @name mhclientApp.controller:MHDeviceController
 # @description
 # # MHDeviceController
 # Controller of MHDevices
*/

var app = angular.module('mhclientApp');
app.controller(
  'MHDeviceController',
  ["$scope", "$filter", "$rootScope", "MHDevice", "Entity", "Sector", function($scope, $filter, $rootScope, MHDevice, Entity, Sector){
    var init
    $scope.search_text = "";
    $scope.MHdevicesOrderBy = ['device.name'];
    init = function() {
      $rootScope.busy = true;
      Entity.getEntities().then(function(entities) {
        Sector.getSectors().then (function(sectors){
          MHDevice.api.getSectors().$promise.then(function(devicesSectors){
            MHDevice.api.getDevicesPatientsLinks().$promise.then(function(assoc_patients){
              MHDevice.api.getLastSynchroDates().$promise.then(function(last_synchro_dates){
                MHDevice.api.getNbPendingDownloads().$promise.then(function(nbdownloads_per_device){
                  MHDevice.api.query().$promise.then(function(devices) {
                    $scope.sectors = sectors
                    $scope.devicesForSectors = {}
                    _.forEach(devices, function(device) {
                      $scope.devicesForSectors[device.id] = {}
                      _.forEach(_.filter(devicesSectors, {mhdevice: device.id}), function(deviceSector) {$scope.devicesForSectors[device.id][deviceSector.sector] = true})
                      device.nb_downloads = 0;
                      device.last_synchro = (_.find(last_synchro_dates, {"mhdevice__name": device.name}) || {})["created"]
                      device.nb_downloads = (_.find(nbdownloads_per_device, {"device__name": device.name}) || {})["nb_downloads"] || 0
                      device.entity = _.find(entities, {"id": device.entity});
                      device.patients = _.filter(assoc_patients, {"mhdevice": device.id})
                    });
                    $scope.devices = devices;
                    $rootScope.busy = false;
                  });
                });
              });
            });
          });
        });
      });
    }

    init()
    $scope.submitDevices = function() {
      $rootScope.busy = true;
      $scope.MHDevicesForm.$setPristine();
      $scope.MHDevicesForm.$setUntouched();
      return MHDevice.api.setDevicesMode(_.map(_.filter($scope.devices, 'dirty'), function(device) {
        device.sectors = _.filter(Object.keys($scope.devicesForSectors[device.id]), function(sectorId) {return $scope.devicesForSectors[device.id][sectorId]})
        return device
      })).$promise.then(function() { init()});
    };

    $scope.exportToCSV = function(devices){

      function createcsvrow(data_ordered_list, separator){
        var csvrow = "";
        data_ordered_list.forEach(function(data_val){
          csvrow += data_val += separator;
        });
        csvrow += "\n";
        return csvrow;
      };
      var separator = ",";
      var csvString = "";
      var HEADERS_TITLES = [
        $filter('translate')("NAME"),
        $filter('translate')("VERSION"),
        $filter('translate')("PATIENTS"),
        $filter('translate')("IPP"),
        $filter('translate')("MULTIPATIENT"),
        $filter('translate')("AUTOMATIC_ASSIGN"),
        $filter('translate')("SYNC_DATE"),
        $filter('translate')("SIM"),
        $filter('translate')("PENDING_DOWNLOADS")
        ];
      csvString += createcsvrow(HEADERS_TITLES, separator);
      devices.forEach(function(device){
        var pat_names = "";
        var pat_ipps = "";
        if(device.patients.length === 1){
          pat_names = device.patients[0].patient__name + " " + device.patients[0].patient__last_name;
          pat_ipps = device.patients[0].patient__si_id;
        }
        else if(device.patients.length > 1){
          pat_names = "\"";
          pat_ipps = "\"";
          device.patients.forEach(function(patient){
            pat_names += patient.patient__name + " " + patient.patient__last_name + ",";
            pat_ipps += patient.patient__si_id + ",";
          });
          pat_names += "\"";
          pat_ipps += "\"";
        }
        var rowValues = [
          device.name,
          device.revision,
          pat_names, pat_ipps,
          device.data.is_multipatient,
          device.auto_assign_patients,
          $filter('date')(device.last_synchro, 'dd/MM/yyyy HH:mm:ss'),
          _.map(_.keys(device.cellular_info), function(key){return key + " " + $filter('date')(device.cellular_info[key], 'dd/MM/yyyy')}).join(' / '),
          device.nb_downloads];
        csvString += createcsvrow(rowValues, separator);
      });
      var a = $('<a/>', {
        style:'display:none',
        href:'data:text/csv;charset=utf-8,'+encodeURIComponent(csvString),
        download:'MHBoxExport.csv'
      }).appendTo('body')
      a[0].click()
      a.remove();
    };
  }]);

'use strict';

/*
    * @ngdoc function
    * @name mhclientApp.core:MHDeviceFilter
    * @description
    * # MHDeviceFilter
    * filter a given list of mhdevices
*/

angular.module('mhclientApp').filter(
  'MHDeviceFilter',
  function(){
    return function(devices, search_text){
      var filtered, regex, searchVal, _i, _len;
      filtered = [];
      var has_search_text = (search_text != null) && search_text.length > 0;
      if (has_search_text) {
        searchVal = search_text.replace(/([()[{*+.$^\\|?])/g, '\\$1');
        regex = new RegExp('' + searchVal, 'i');
        for (_i = 0, _len = devices.length; _i < _len; _i++) {
          var device = devices[_i];
          var device_to_show = false;
          if (regex.test(device.name)){
            device_to_show = true;
          }
          else if (_.some(_.keys(device.cellular_info), function(simId) {return regex.test(simId)}))
            device_to_show = true;
          else if (regex.test(device.revision)){
            device_to_show = true;
          }
          else if(device.patients && device.patients.length > 0){
            device.patients.forEach(function(patient){
              if (regex.test(patient.patient__name) || regex.test(patient.patient__last_name)){
                device_to_show = true;
              }
              else if (regex.test(patient.patient__si_id)){
                device_to_show = true;
              }
            });
          }
          if(device_to_show === true){
            filtered.push(device);
          }
        }
        return filtered;
      }
      else{
        return devices;
      }
  };
});
(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PatientCtrl
    * @description
    * # PatientCtrl
    * Controller of Patient
   */
  angular.module('mhclientApp').controller('PatientCtrl', ["$scope", "$rootScope", "$window", "$state", "User", "Patient", "Stay", "patientAlerts", "MedicalUnit", "closedStayAlterationDelay", function($scope, $rootScope, $window, $state, User, Patient, Stay, patientAlerts, MedicalUnit, closedStayAlterationDelay) {
    var reloadPatient, reloadStays;
    $rootScope.canStayBeAltered = function(stay) {
      if (stay.d_to) {
        return moment().diff(moment(stay.d_to), 'hours') <= closedStayAlterationDelay * 24;
      } else {
        return false;
      }
    };
    $scope.goTo = function(state, args) {
      return $state.go(state, args).then(function() {
        if ($scope.allStays !== $window.mgapp.show_all_stays()) {
          return $scope.toggleShowAllStays($window.mgapp.show_all_stays());
        }
      });
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      $window.go_to = $scope.goTo;
    }
    if ($rootScope.mh_config.platform === "mgapp") {
      window.mgapp.select_patient($rootScope.currentPatient.id);
    }
    $rootScope.subscribed = patientAlerts.subscribed;
    MedicalUnit.getMedicalUnits().then(function(medicalUnits) {
      var i, len, medicalUnit, ref, results, stay;
      ref = $rootScope.currentPatientStays;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        stay = ref[i];
        if (stay.medical_unit) {
          medicalUnit = _.find(medicalUnits, {
            id: stay.medical_unit
          });
          if (medicalUnit) {
            results.push(stay.medical_unit_name = medicalUnit.name);
          } else {
            results.push(void 0);
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    });
    reloadPatient = function() {
      return Patient.get({
        id: $rootScope.currentPatient.id
      }).$promise.then(function(patientDetail) {
        var key, results, value;
        results = [];
        for (key in patientDetail) {
          value = patientDetail[key];
          results.push($rootScope.currentPatient[key] = value);
        }
        return results;
      });
    };
    reloadStays = function() {
      return Stay.query({
        patient: $rootScope.currentPatient.id
      }).$promise.then(function(patientStays) {
        return $rootScope.currentPatientStays = patientStays;
      });
    };
    $window.reload_patient = reloadPatient;
    return $window.reload_stays = reloadStays;
  }]);

}).call(this);

//# sourceMappingURL=patient-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:PatientDetailCtrl
    * @description
    * # PatientDetailCtrl
    * Controller of patient details
   */
  angular.module('mhclientApp').controller('PatientDetailCtrl', ["$scope", "$state", "$rootScope", "$stateParams", function($scope, $state, $rootScope, $stateParams) {
    $scope.modelName = $stateParams.model;
    $scope.mgappCloseRequest = function() {
      if ($scope.previousState != null) {
        return $state.go($scope.previousState.name);
      } else {
        return window.mgapp.close_screen();
      }
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      return window.mgappClose = $scope.mgappCloseRequest;
    }
  }]);

}).call(this);

//# sourceMappingURL=patient-detail-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:PatientFactory
    * @description
    * # Patient
    * Factory of Patient
   */
  angular.module("mhclientApp").factory('Patient', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, boxAPI, patient, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v2";
    portailAPI = $resource('/api_rest/patients/:id/:route', {}, {
      'create': {
        method: 'POST'
      },
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'getByIns': {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_by_ins'
        }
      },
      'get': {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        }
      },
      'toggle_state': {
        method: 'POST',
        params: {
          id: '@id',
          route: 'toggle_state'
        }
      },
      'updateLinkedUsers': {
        method: 'POST',
        params: {
          id: '@id',
          route: 'update_linked_users'
        }
      },
      'updateLinkedMeasures': {
        method: 'POST',
        params: {
          id: '@id',
          route: 'update_linked_measures'
        }
      },
      'updateLinkedForms': {
        method: 'POST',
        params: {
          id: '@id',
          route: 'update_linked_forms'
        }
      },
      'linkToDevice': {
        method: 'POST',
        params: {
          id: '@id',
          route: 'link_to_device'
        }
      },
      'unlinkFromDevice': {
        method: 'POST',
        params: {
          id: '@id',
          route: 'unlink_from_device'
        }
      },
      'update': {
        method: 'PATCH',
        params: {
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'syncWithMHLink': {
        method: 'PUT',
        params: {
          id: '@id',
          route: 'sync_with_mhlink'
        }
      },
      'get_entourage': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_entourage'
        }
      },
      'create_contact': {
        method: 'PUT',
        params: {
          id: '@id',
          route: 'create_contact'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'update_contact': {
        method: 'PUT',
        params: {
          id: '@id',
          route: 'update_contact'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'transferStayData': {
        method: 'PUT',
        params: {
          id: '@id',
          route: 'transfer_stay_data'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'mergePatient': {
        method: 'PUT',
        params: {
          id: '@id',
          route: 'merge_patient'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'getAvailablePatients': {
        method: 'GET',
        params: {
          route: 'get_available_patients'
        },
        isArray: true
      },
      'updateAutoAcceptExternalSyncs': {
        method: 'PATCH',
        params: {
          route: 'update_auto_accept_external_syncs'
        }
      },
      'getLinkedForms': {
        method: 'GET',
        params: {
          route: 'get_linked_forms'
        },
        isArray: true
      },
      'dataMatrix': {
        method: 'GET',
        params: {
          route: 'data_matrix'
        },
        isArray: false
      },
      'getLinkedMeasures': {
        method: 'GET',
        params: {
          route: 'get_linked_measures'
        },
        isArray: true
      },
      'getAlerts': {
        method: 'get',
        params: {
          route: 'get_alerts'
        },
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        patient = window.mgapp.get('pat_mgr').patient();
        boxAPI = BoxResource.generate(patient);
        boxAPI.getCurrentCIPS = function(object) {
          return BoxResource.mhboxApiCall(patient, "get_current_cips", object);
        };
        boxAPI.getAlerts = function(object) {
          return BoxResource.objectToResource({
            alerts: []
          });
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('PatientByIpp', ["$resource", "MhConfig", "$q", "BoxResource", "TimeSlot", function($resource, MhConfig, $q, BoxResource, TimeSlot) {
    var acceptHeader;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    return $resource('/api_rest/patients_by_ipp/:si_id/:route', {
      si_id: this.si_id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        method: 'PUT',
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'delete': {
        method: 'DELETE',
        headers: {
          'Accept': acceptHeader
        }
      }
    });
  }]);

  angular.module("mhclientApp").factory('PatientUtils', ["$filter", function($filter) {
    var GENDER_SHORT_TRANSLATION_MAP, GENDER_TRANSLATION_MAP, service, translateGender, translateGenderShort;
    GENDER_TRANSLATION_MAP = {
      M: $filter('translate')('M_gender'),
      F: $filter('translate')('F_gender'),
      O: $filter('translate')('O_gender'),
      U: $filter('translate')('U_gender')
    };
    GENDER_SHORT_TRANSLATION_MAP = {
      M: $filter('translate')('M_gender_short'),
      F: $filter('translate')('F_gender_short'),
      O: $filter('translate')('O_gender_short'),
      U: $filter('translate')('U_gender_short')
    };
    translateGenderShort = function(gender) {
      return GENDER_SHORT_TRANSLATION_MAP[gender];
    };
    translateGender = function(gender) {
      return GENDER_TRANSLATION_MAP[gender];
    };
    service = {
      translateGenderShort: translateGenderShort,
      translateGender: translateGender
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=patient-service.js.map

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:patientDetailForm
* @description
* Modal component which displays form used to Medical Infos , pread, and social info
* **********************************************/
var PatientDetailFormCtrl = function(
    $scope,
    $state,
    $rootScope,
    $q,
    MhConfig,
    notify,
    $filter,
    Patient,
    Medicaldb,
    Stay,
    SiteVarsUtils,
    UserUtils,
    FeatureUtils) {

  var ctrl = this;

  function init() {
    $scope.pathologiesRessource = Medicaldb.getPathologies;
    $scope.allergiesRessource = Medicaldb.getAllergies;
    $scope.medactResource = Medicaldb.getMedicalActs;
    $scope.mh_config = MhConfig;
    $scope.previousState = $state.previous;
    $scope.part = '';
    $scope.isMedicalData = false;
    $scope.canStillBeAltered = false;
    $scope.can_modify = !ctrl.readOnly;
    $scope.defaultDate = new Date();

    Stay.get({id: $rootScope.currentStay.id}).$promise.then( function(stay) {
      $scope.stay = stay
      $scope.canWrite = $rootScope.checkPermissions("MHC_MEDICALINFO", "CAN_WRITE");
      if (ctrl.modelName === "pread") {
        console.log("pread");
        $scope.canWrite = $scope.canWrite || $rootScope.user.group.features.indexOf("SRV_pac") !== -1;
        $scope.previousState = $scope.previousState || {name: "user.patient.stay.pread"};
        $scope.can_modify = $scope.can_modify && !$rootScope.currentStay.preadmission.lock_pread_data;
        $scope.model = stay.pread_medical_data;

      } else if (ctrl.modelName == "medical_data") {
        $scope.isMedicalData = true;

        if ($rootScope.mh_config.platform === "mhsi") {
          $scope.part = '/st/mh/static/views/medical_info.html';
        } else {
          SiteVarsUtils.get("MEDICAL_INFO_TEMPLATE").then( function(medicalInfoTemplate) {
            $scope.part = medicalInfoTemplate.value;
          });
        }

        $scope.patient_detail = angular.copy($rootScope.currentPatient);
        $scope.model = stay.medical_data;
        $scope.patient_detail.data = {medical_data: $scope.model};

        // if current stay state is close state and delay allowing to modify close stay is not past
        SiteVarsUtils.get('CLOSED_STAY_ALTERATIONS_DELAY_IN_DAYS', 0).then( function(sitevar) {
          if ($rootScope.currentStay.d_to) {
            var dTo = moment($rootScope.currentStay.d_to);
            $scope.canStillBeAltered = (moment().diff(dTo, 'hours') <= sitevar.value*24) &&
            ["CLOSE", "I"].indexOf($rootScope.currentStay.state ) !== -1;
          }
        });

      } else {
        console.log("others -----");
        // $scope.can_modify = true
        $scope.canWrite = $rootScope.checkPermissions("MHC_SOCIALINFO", "CAN_WRITE");
        $scope.ressources = {};
        UserUtils.getUsersForPatient($rootScope.currentPatient.si_id).then( function(users) {
          $scope.ressources.user = users;
        });

        $scope.socialfeature = {'feature': 'MHC_ASOCIAL'};
        $scope.model = angular.copy($rootScope.currentPatient.social_data);
        $scope.dateMax = new Date();

        if (!$scope.model.living_conditions) {
          $scope.model.living_conditions={};
        }
        if (!$scope.model.help_types) {
          $scope.model.help_types = [];
        }
        if (!$scope.model.social_worker) {
          $scope.model.social_worker = [];
        }
        if (!$scope.model.help_beginning_date) {
          $scope.model.help_beginning_date = "";
        }
        if (!$scope.model.first_contact_date) {
          $scope.model.first_contact_date = "";
        }

        FeatureUtils.getFeature({name: 'MHC_ASOCIAL'}).then( function(feature) {
          $scope.helps = feature.metadata.help_types;
        });
      }
      // if current stay state is not an active state can_modify is false
      $scope.can_modify = $scope.can_modify && $rootScope.currentStayIsActive;

      SiteVarsUtils.get("PAC_DATA_STRUCT").then( function(pacDataStruct) {
        $scope.patient_fields = [];
        pacDataStruct.value.forEach(function(patientData) {
          if ('MEDICAL_DATA' == patientData.ID) {
            patientData.FIELDS.forEach( function(fieldElem) {
              if (ctrl.modelName !== "pread") {
                if (fieldElem.FLAGS.indexOf("PREAD_ONLY") === -1) {
                  $scope.patient_fields.push(fieldElem);
                }

              } else if (fieldElem.FLAGS.indexOf('PREAD') !== -1) {
                $scope.patient_fields.push(fieldElem);
              }
            });
          }
        });
        if (ctrl.modelName == "medical_data") {
          $scope.PEC_PRIMARY_DATA = $scope.getElemDataWithID('MODE_PEC_PRIMARY');
          $scope.PEC_LINKED_DATA = $scope.getElemDataWithID('MODE_PEC_LINKED');
        }
      });
    });
  };

  $scope.reset_first_contact_date = function() {
    $scope.model.first_contact_date = undefined;
  };

  $scope.reset_help_beginning_date = function() {
    $scope.model.help_beginning_date = undefined;
  };

  $scope.reset_selected_help_date = function(selected) {
    selected.date = undefined;
  };

  $scope.isRequired = function(elem) {
    return elem.FLAGS.indexOf('REQUIRED') > -1;
  };

  $scope.getPathologies = function(val) {
    return Medicaldb.getPathologies({query: val}).$promise.then( function(response) {
      return response.map( function(item) {
        return item.name + ' : ' + item.code;
      });
    });
  };

  $scope.getElemDataWithID = function(ID) {
    var element = _.find($scope.patient_fields, {'ID': ID});
    if (element != null) {
      return element.DATA;
    }
  };

  $scope.initPSPObjectives = function(objectivesModelName) {
    if ($scope.model[objectivesModelName] == undefined) {
      $scope.model[objectivesModelName] = ["", ""];
    }
  };

  $scope.addPSPObjective = function(objectivesModelName) {
    $scope.model[objectivesModelName].push("");
  };

  $scope.removePSPObjective = function(objectivesModelName, index) {
    if ($scope.model[objectivesModelName].length > 0) {
      $scope.model[objectivesModelName].splice(index, 1);
    }
  };

  $scope.printMedicalInfo = function() {
    if ($rootScope.allStays) {
      window.open('/api_rest/patients/'+$rootScope.currentPatient.id+'/print_data/'+'MHC_MEDICALINFO', '_blank');
    } else {
      window.open('/api_rest/stays/'+$rootScope.currentStay.id+'/print_data/'+'MHC_MEDICALINFO', '_blank');
    }
    return true;
  };

  $scope.setForm = function(form) {
    $scope.patientDetailForm = form;
  };

  $scope.update = function(data) {
    // if $stateParams.model is "pread"
    //   angular.extend(patient.data.medical_data, patient.data.pread.medical_data)
    if ($scope.patientDetailForm.$valid) {
      var updateDone = $q.defer();
      if (_.includes(["pread", "medical_data"], ctrl.modelName)) {
        if (ctrl.modelName === "pread") {
          var params = {pread_medical_data: data};
        } else { // ctrl.modelName == "medical_data"
          data.author = $rootScope.user.full_name;
          data.author_login = $rootScope.user.username;
          data.timestamp = new Date();
          var params = {medical_data: data};
        }
        Stay.update({id: $rootScope.currentStay.id}, params).$promise.then( function(stay) {
          _.merge($rootScope.currentStay, params);
          updateDone.resolve();
        });
      } else {
        var params = {social_data: data};
        $rootScope.currentPatient.social_data = data
        Patient.update({id: $rootScope.currentPatient.id}, params).$promise.then( function(patient) {
          _.merge($rootScope.currentPatient, params);
          updateDone.resolve();
        });
      }
      updateDone.promise.then( function() {
        notify({
          classes: ['alert-info'],
          message: $filter('translate')("PATIENT_SAVE"),
        });
        if ($state.previous && $state.previous.name) {
          $state.go($state.previous.name);
        }
      });
    } else {
      notify({
        classes: ['alert-danger'],
        message: $filter('translate')("INVALID_PATIENT_DETAIl_FORM"),
      });
    }
  };


  init();
};
PatientDetailFormCtrl.$inject = ["$scope", "$state", "$rootScope", "$q", "MhConfig", "notify", "$filter", "Patient", "Medicaldb", "Stay", "SiteVarsUtils", "UserUtils", "FeatureUtils"];


angular.module('mhclientApp').controller('PatientDetailFormCtrl', PatientDetailFormCtrl);

angular.module("mhclientApp").component("patientDetailForm", {
  templateUrl: "patient/components/patient-detail-form/patient-detail-form.html",
  controller: 'PatientDetailFormCtrl',
  bindings: {
    displayHeader: "<",
    readOnly: "<",
    modelName: "<",
  },
});

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Stay
    * @description
    * # Stay
    * Factory of Entourage
   */
  angular.module("mhclientApp").factory('Entourage', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, entourage, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/entourage/:id', {
      id: '@id'
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PUT'
      },
      'delete': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'DELETE'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        entourage = window.mgapp.get('pat_mgr').entourage();
        boxAPI = BoxResource.generate(entourage);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

}).call(this);

//# sourceMappingURL=entourage-service.js.map

(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('PatientInfoCtrl', ["$scope", "$rootScope", "Sector", "SiteVarsUtils", function($scope, $rootScope, Sector, SiteVarsUtils) {
    $scope.sectorList = [];
    $scope.sectorName = "";
    $scope.patient = $rootScope.currentPatient;
    $scope.canWrite = indexOf.call($rootScope.user.group.features, "SRV_pac") >= 0;
    $scope.canReadRestrictedInfos = false;
    if ($rootScope.mh_config.platform === "mhsi" && $rootScope.user.group.features.indexOf("RESTRICTED_SEGUR_INFOS") !== -1) {
      $scope.canReadRestrictedInfos = true;
    }
    return SiteVarsUtils.get('PDS_STAY_LIST', false).then(function(pdsStayList) {
      $scope.showMedPlan = pdsStayList.value;
      return Sector.getSectors().then(function(data) {
        var ref;
        $scope.sectorList = data;
        if ($scope.sectorList.length > 0 && ((ref = $rootScope.currentStay.sector) !== (void 0) && ref !== null)) {
          return $scope.sectorName = _.find($scope.sectorList, {
            'id': $rootScope.currentStay.sector
          }).name;
        }
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=patient-modal-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:EntourageCtrl
    * @description
    * # EntourageCtrl
    * Controller for Entourage Directive
   */
  angular.module('mhclientApp').controller('EntourageCtrl', ["$scope", "$rootScope", "$state", "notify", "$filter", "Entourage", "MhConfig", "$uibModal", function($scope, $rootScope, $state, notify, $filter, Entourage, MhConfig, $uibModal) {
    var init;
    $scope.mh_config = MhConfig;
    $scope.previousState = $state.previous;
    $scope.currentStay = $rootScope.currentStay;
    $scope.personTypeList = ["trusty_person", "person_to_contact"];
    $scope.contactsTypeList = ["friend", "family", "neighbour", "legal_representative", "protection_measures", "incapacity_to_designate", "other"];
    init = function() {
      return Entourage.get({
        id: $scope.patient.id
      }).$promise.then(function(response) {
        return $scope.contacts = response.entourage;
      });
    };
    $scope.checkContactType = function() {
      if ($scope.model.contact_type === 'family') {
        return $scope.model.family_relationship = null;
      }
    };
    $scope.openEditContactModal = function(contact) {
      contact = contact || {};
      return $uibModal.open({
        templateUrl: "patient/views/contact-modal.html",
        controller: "ContactModalCtrl",
        backdrop: 'static',
        resolve: {
          contact: function() {
            return angular.copy(contact);
          },
          personTypeList: function() {
            return $scope.personTypeList;
          },
          contactsTypeList: function() {
            return $scope.contactsTypeList;
          },
          createOrUpdateContact: function() {
            return $scope.createOrUpdateContact;
          }
        }
      });
    };
    $scope.createOrUpdateContact = function(contact) {
      contact.patientId = $scope.patient.id;
      $rootScope.busy = true;
      if (!contact.uuid) {
        return Entourage.save(contact, contact).$promise.then(function(newContact) {
          notify({
            classes: ['alert-info'],
            message: $filter('translate')("CONTACT_SAVE")
          });
          if ($scope.contacts[newContact.contact_type] == null) {
            $scope.contacts[newContact.contact_type] = {};
          }
          $scope.contacts[newContact.contact_type][newContact.uuid] = newContact;
          return $rootScope.busy = false;
        });
      } else {
        contact.id = contact.patientId;
        return Entourage.update(contact, contact).$promise.then(function(updatedContact) {
          var _, contacTypeContent, ref;
          notify({
            classes: ['alert-info'],
            message: $filter('translate')("UPDATE_CONTACT")
          });
          if ($scope.contacts[updatedContact.contact_type] == null) {
            $scope.contacts[updatedContact.contact_type] = {};
          }
          ref = $scope.contacts;
          for (_ in ref) {
            contacTypeContent = ref[_];
            if (contacTypeContent[updatedContact.uuid] != null) {
              delete contacTypeContent[updatedContact.uuid];
              break;
            }
          }
          $scope.contacts[updatedContact.contact_type][updatedContact.uuid] = updatedContact;
          return $rootScope.busy = false;
        });
      }
    };
    $scope.deleteContact = function(uuid, contact_type) {
      return Entourage["delete"]({
        patientId: $scope.patient.id,
        contact_type: contact_type,
        contact_uuid: uuid
      }).$promise.then(function(response) {
        notify({
          classes: ['alert-info'],
          message: $filter('translate')("DELETED_CONTACT")
        });
        return delete $scope.contacts[contact_type][uuid];
      });
    };
    $scope.isEmpty = function(object) {
      return _.isEmpty(object);
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      window.mgappConfirmQuit = window.mgapp.quit_view;
    }
    return init();
  }]);

}).call(this);

//# sourceMappingURL=entourage-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:patientEntourage
    * @description
    * Directive of patientEntourage
   */
  angular.module('mhclientApp').directive('patientEntourage', function() {
    return {
      restrict: 'E',
      templateUrl: 'patient/views/patient-entourage.html',
      scope: {
        patient: '='
      },
      controller: 'EntourageCtrl'
    };
  });

}).call(this);

//# sourceMappingURL=entourage-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:ContactModalCtrl
    * @description
    * # ContactModalCtrl
    * Controller of the modal which handles patient contact edition
   */
  angular.module("mhclientApp").controller('ContactModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "$uibModal", "contact", "personTypeList", "contactsTypeList", "createOrUpdateContact", function($scope, $rootScope, $filter, $uibModalInstance, $uibModal, contact, personTypeList, contactsTypeList, createOrUpdateContact) {
    var init;
    init = function() {
      $scope.contact = contact;
      $scope.personTypeList = personTypeList;
      return $scope.contactsTypeList = contactsTypeList;
    };
    $scope.validate = function() {
      return createOrUpdateContact($scope.contact).then(function() {
        return $uibModalInstance.close();
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=contact-modal-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:PatientCreateCtrl
    * @description
    * # PatientCreateCtrl
    * Controller of patient creation
   */
  angular.module('mhclientApp').controller('PatientCreateCtrl', ["$rootScope", "$q", "$scope", "$state", "Utils", "SiteVarsUtils", function($rootScope, $q, $scope, $state, Utils, SiteVarsUtils) {
    var setPrisitine;
    SiteVarsUtils.getValue('availableExternalSyncs', []).then(function(availableExternalSyncs) {
      $scope.newStay = {};
      $scope.newPatient = {
        "dmp_data": {}
      };
      return _.forEach(_.filter(availableExternalSyncs, "auto_accept"), function(externalSync) {
        $scope.newPatient.dmp_data[externalSync.sync_type] = {
          enabled: true
        };
        _.forEach(_.keys(externalSync.documents), function(docType) {
          $scope.newPatient.dmp_data[externalSync.sync_type][docType] = {
            auto: true
          };
        });
      });
    });
    $scope.createPatient = function(redirect) {
      $rootScope.busy = true;
      return $scope.$broadcast('createPatient').createPatientPromise.then(function(patientId) {
        $scope.newStay.patient = patientId;
        return $scope.$broadcast('createStay').createStayPromise.then(function(stayId) {
          $rootScope.busy = false;
          setPrisitine();
          if (redirect) {
            return $state.go("user.patient.stay.edit", {
              idStay: stayId,
              idPatient: patientId
            });
          } else {
            return true;
          }
        });
      });
    };
    setPrisitine = function() {
      return $scope.patientDataForm.$setPristine();
    };
    return $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      var dirty, valid;
      dirty = $scope.patientDataForm.$dirty;
      valid = !$scope.patientDataForm.$invalid;
      if (dirty) {
        return $q.when(Utils.handleCloseRequested(event, dirty, valid, $scope.createPatient, setPrisitine)).then(function(result) {
          if (result) {
            return $state.go(toState.name, toParams);
          }
        });
      }
    });
  }]);

}).call(this);

//# sourceMappingURL=patient-create-controller.js.map

angular.module("mhclientApp").component("patientNameCell", {
  templateUrl: "stay/views/patient-name-cell.html",
  controller: PatientNameCell,
  bindings: { stay: "<", onClick: "&" },
});

function PatientNameCell(
  $rootScope,
  $scope,
  $timeout,
  Alert,
  alertUtils,
  redirectUtils,
  SiteVarsUtils
) {
  var ctrl = this;

  $scope.canManagePatients = false;
  $scope.isPopoverOpen = false;
  $scope.popoverContent = null;

  $scope.onOpenPopover = onOpenPopover;
  $scope.onClosePopover = onClosePopover;
  $scope.redirectToAlertPage = redirectToAlertPage;
  $scope.handleOnClick = handleOnClick;
  $scope.handleOnMouseleavePopover = handleOnMouseleavePopover;
  $scope.handleOnMouseenterPopover = handleOnMouseenterPopover;
  $scope.handleOnMouseleave = handleOnMouseleave;

  ctrl.$onInit = init;

  var timer = undefined;
  var popoverDelay = 300;

  function handleOnMouseleave() {
    $timeout.cancel(timer);
    timer = $timeout(function () {
      onClosePopover();
    }, popoverDelay);
  }
  function handleOnMouseleavePopover() {
    $timeout.cancel(timer);
    timer = $timeout(function () {
      onClosePopover();
    }, popoverDelay);
  }
  function handleOnMouseenterPopover() {
    $timeout.cancel(timer);
  }

  function onOpenPopover() {
    $scope.isPopoverOpen = true;
    loadStayAlerts();
  }
  function loadStayAlerts() {
    Alert.api.query({ stay: ctrl.stay.id }).$promise.then(function (alerts) {
      $scope.popoverContent = getFormattedAlertsFromStay(alerts);
    });
  }
  function onClosePopover() {
    $scope.isPopoverOpen = false;
    $scope.popoverContent = null;
  }

  function handleOnClick(clickEvent) {
    ctrl.onClick({
      stayId: ctrl.stay.id,
      patientId: ctrl.stay.patient.id,
      state: ctrl.stay.state,
      event: clickEvent,
    });
  }

  function redirectToAlertPage(event) {
    redirectUtils.redirectToAlert(event);
  }

  function init() {
    initSiteVars();
    initCanManagePatient();
  }

  function getFormattedAlertsFromStay(alerts) {
    var alertsWithCachedConfigs = alertUtils.addCachedConfigsToAlerts(alerts);
    return alertUtils.formatEvents(alertsWithCachedConfigs, ctrl.stay);
  }

  function initSiteVars() {
    SiteVarsUtils.get("ALLOW_PATIENT_IDENTITY_CHECK", false).then(function (
      patientIdentityCheck
    ) {
      $scope.allowPatientIdentityCheck = patientIdentityCheck.value;
    });
  }

  function initCanManagePatient() {
    var isMhsiPlatform = $rootScope.mh_config.platform === "mhsi";
    if (isMhsiPlatform) {
      $scope.canManagePatients =
        $rootScope.user && (
          $rootScope.user.is_superuser ||
          $rootScope.user.group.features.indexOf("SRV_pac") !== -1
        );
    }
  }
}

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StayMovementsCtrl
    * @description
    * # StayMovementsCtrl
    * Controller of Stay movements list
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('StayCtrl', ["$scope", "$rootScope", "$window", "$state", "Stay", "MhConfig", "Medicaldb", "MedicalUnit", function($scope, $rootScope, $window, $state, Stay, MhConfig, Medicaldb, MedicalUnit) {
    var events, feature, featureTemplates, i, j, len, len1, ref, ref1, ref2, reloadStay, subFeature, subfeatureEvents, templatesEventsName;
    $scope.printData = function(docType, allStays, currentPatient, currentStay) {
      if (allStays) {
        window.open('/api_rest/patients/' + currentPatient.id + '/print_data/' + docType, '_blank');
      } else {
        window.open('/api_rest/stays/' + currentStay.id + '/print_data/' + docType, '_blank');
      }
      return true;
    };
    if ($rootScope.currentStay.medical_unit) {
      MedicalUnit.getMedicalUnits().then(function(medicalUnits) {
        var medicalUnit;
        medicalUnit = _.find(medicalUnits, {
          id: $rootScope.currentStay.medical_unit
        });
        if (medicalUnit) {
          return $rootScope.currentStay.medicalUnitName = medicalUnit.name;
        }
      });
    }
    $rootScope.currentStay.allergies_names = _.map($rootScope.currentStay.medical_data.ALLERGIES_LIST, 'name');
    $rootScope.currentStay.patho_primary_names = _.map($rootScope.currentStay.medical_data.PATHO_PRIMARY, 'name');
    $rootScope.currentStayIsActive = (ref = $rootScope.currentStay.state) === "ADM" || ref === "PRE";
    if ($rootScope.currentStay.patient !== $rootScope.currentPatient.id) {
      $state.go("user.stay-list");
    }
    $scope.switch_stay = function(stay_id) {
      return $state.go($state.current, {
        idStay: stay_id
      });
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      $window.switch_stay = $scope.switch_stay;
      window.mgapp.select_stay($rootScope.currentStay.id);
    }
    if ($scope.allStays) {
      events = $rootScope.patientNewEvents;
    } else {
      events = _.filter($rootScope.patientNewEvents, {
        stay: $rootScope.currentStay.id
      });
    }
    $rootScope.menus.patient.alertCount = 0;
    ref1 = $rootScope.menus.patient.groupedFeaturesByParent;
    for (i = 0, len = ref1.length; i < len; i++) {
      feature = ref1[i];
      feature.alert_count = 0;
      ref2 = feature.childs;
      for (j = 0, len1 = ref2.length; j < len1; j++) {
        subFeature = ref2[j];
        featureTemplates = _.filter($rootScope.alertTemplates, {
          feature: subFeature.name
        });
        templatesEventsName = _.map(featureTemplates, 'event_name');
        subfeatureEvents = _.filter(events, function(event) {
          var ref3;
          return ref3 = event.config.event_name, indexOf.call(templatesEventsName, ref3) >= 0;
        });
        subFeature.alert_count = subfeatureEvents.length;
        feature.alert_count += subFeature.alert_count;
        $rootScope.menus.patient.alertCount += subFeature.alert_count;
      }
    }
    reloadStay = function() {
      return Stay.get({
        id: $rootScope.currentStay.id
      }).$promise.then(function(currentStay) {
        var key, results, value;
        results = [];
        for (key in currentStay) {
          value = currentStay[key];
          results.push($rootScope.currentStay[key] = value);
        }
        return results;
      });
    };
    return $window.reload_current_stay = reloadStay;
  }]);

}).call(this);

//# sourceMappingURL=stay-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:mhModalCtrl
    * @description
    * # mhModalCtrl
    * Provider of mhModalCtrl
   */
  angular.module("mhclientApp").controller('StayModalSelectCtrl', ["$scope", "$rootScope", "$state", "$uibModalInstance", "stays", "currentStay", "patientNewEvents", "Sector", function($scope, $rootScope, $state, $uibModalInstance, stays, currentStay, patientNewEvents, Sector) {
    Sector.getSectors().then(function(sectors) {
      var i, len, ref, results, stay, stayEvent;
      $scope.stays = stays;
      $scope.sectors = sectors;
      ref = $scope.stays;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        stay = ref[i];
        stayEvent = _.filter(patientNewEvents, {
          stay: stay.id
        });
        stay.alert_count = stayEvent.length;
        results.push(stay.preadCheckedCnt = _.filter(stay.preadmission.checklist, function(checklistItem) {
          return checklistItem === true;
        }));
      }
      return results;
    });
    $scope.changeStay = function(stay) {
      if (stay.id !== currentStay.id) {
        $rootScope.reloadingState = true;
        $state.go($state.current, {
          idStay: stay.id
        }, {
          reload: true
        }).then((function() {
          return $rootScope.reloadingState = false;
        }), function() {
          return $rootScope.reloadingState = false;
        });
      }
      return $uibModalInstance.close();
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

  angular.module("mhclientApp").controller('StaySelectCtrl', ["$scope", "$rootScope", "$state", "Sector", function($scope, $rootScope, $state, Sector) {
    Sector.getSectors().then(function(sectors) {
      var i, len, ref, results, stay, stayEvent;
      $scope.sectors = sectors;
      $scope.stays = $rootScope.currentPatientStays;
      ref = $scope.stays;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        stay = ref[i];
        stayEvent = _.filter($rootScope.patientNewEvents, {
          stay: stay.id
        });
        results.push(stay.alert_count = stayEvent.length);
      }
      return results;
    });
    return $scope.changeStay = function(stay) {
      if ($rootScope.mh_config.platform === "mgapp") {
        return window.mgapp.switch_stay(stay.id);
      } else {
        if (stay.id !== $rootScope.currentPatientStays.id) {
          return $state.go($state.current, {
            idStay: stay.id
          });
        }
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=stay-select-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StayMovementsCtrl
    * @description
    * # StayMovementsCtrl
    * Controller of Stay movements list
   */
  angular.module('mhclientApp').controller('StayDashBoardCtrl', ["$scope", "$timeout", "$rootScope", "$q", "$filter", "User", "alertUtils", "FormTemplateUtils", function($scope, $timeout, $rootScope, $q, $filter, User, alertUtils, FormTemplateUtils) {
    $scope.hasSynthesis = true;
    $scope.synthesisDone = false;
    $rootScope.busy = true;
    $scope.dashboardOptions = {
      patient: $rootScope.currentPatient,
      stay: $rootScope.currentStay,
      allStays: $rootScope.allStays
    };
    $rootScope.busy = false;
    $scope.toggleSubscription = function() {
      $rootScope.subscribed = !$rootScope.subscribed;
      return User.updateSubscription({
        id: $scope.user.id
      }, {
        subscribed: $rootScope.subscribed,
        patient: $rootScope.currentPatient.id
      });
    };
    $scope.setSynthesisDone = function() {
      $scope.synthesisDone = true;
      return $rootScope.busy = false;
    };
    return $scope.setSynthesis = function(nbSynthesis) {
      $scope.hasSynthesis = nbSynthesis > 0;
      if (!$scope.hasSynthesis) {
        $rootScope.busy = false;
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=stay-dashboard-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name core.stayDataFormCtrl
    * @description
    * # stay dat form widget
    * <stay-data-form> definition. Attributes:
    * stay: (mandatory): var to set
    *
   */
  angular.module('mhclientApp').directive('stayEdition', function() {
    return {
      restrict: 'E',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'stay/views/stay-edit-directive.html';
        }
      },
      scope: {
        stay: "=",
        enableActions: "=",
        stayEditForm: "=?",
        otherStays: "<?"
      },
      controller: ["$rootScope", "$scope", "Stay", "SiteVarsUtils", "Entity", "Sector", "GenUID", "Utils", "PharmaAnalysisUtils", "UserUtils", function($rootScope, $scope, Stay, SiteVarsUtils, Entity, Sector, GenUID, Utils, PharmaAnalysisUtils, UserUtils) {
        var day, index;
        $scope.$on('closeRequested', function(event) {
          return Utils.handleCloseRequested(event, $scope.editing, !$scope.stayEditForm.$invalid, $scope.saveStay, $scope.cancelEdition);
        });
        $scope.editableStay = $scope.stay.id ? _.cloneDeep($scope.stay) : $scope.stay;
        $scope.cancelEdition = function() {
          $scope.editing = false;
          if (!$scope.editableStay.id) {
            $scope.$emit("removeStay", $scope.stay);
          } else {
            $scope.editableStay = _.cloneDeep($scope.stay);
          }
          return true;
        };
        $scope.$on('createStay', function(event) {
          return event.createStayPromise = $scope.saveStay();
        });
        $scope.getAvailableSectorByEntity = function(entityId) {
          return _.filter($scope.sectors, {
            entity: entityId
          });
        };
        $scope.entitySelected = function() {
          var previousStayByEntity;
          if (!$scope.editableStay.id) {
            previousStayByEntity = _.find(_.orderBy($scope.otherStays, ["id"], "desc"), {
              entity: $scope.editableStay.entity
            });
            if (previousStayByEntity) {
              return $scope.editableStay.identitovigilance.referents = _.cloneDeep(previousStayByEntity.identitovigilance.referents || []);
            }
          }
        };
        $scope.saveStay = function(setBusy) {
          var action, stayData;
          if (setBusy) {
            $rootScope.busy = true;
          }
          stayData = _.assign({
            "query_source": "mhclient"
          }, _.pick($scope.editableStay, _.concat(["patient", "si_id", "identitovigilance", "projected_start_date", "is_dormant", "projected_end_date", "order_data"], $scope.canCreate ? ["sector", "entity", "state", "d_from", "d_to"] : [])));
          action = $scope.editableStay.id ? "updateStay" : "newStay";
          return (action === "updateStay" ? Stay.update({
            id: $scope.editableStay.id
          }, stayData) : Stay.save(stayData)).$promise.then(function(stay) {
            _.assign($scope.stay, stay);
            $scope.editableStay = _.cloneDeep($scope.stay);
            $scope.editing = false;
            $scope.$emit(action, $scope.stay);
            if (setBusy) {
              $rootScope.busy = false;
            }
            return stay.id;
          });
        };
        $scope.editStay = function() {
          return $scope.editing = true;
        };
        Entity.getEntities().then(function(entities) {
          return Sector.getSectors().then(function(sectors) {
            return PharmaAnalysisUtils.getDeliveryTypeOptions().then(function(deliveryTypeOptions) {
              return SiteVarsUtils.getValue("ALLOW_PATIENT_IDENTITY_CHECK", false).then(function(allowPatientIdentityCheck) {
                return SiteVarsUtils.getValue('ALLOW_PATIENT_CREATION', false).then(function(canCreate) {
                  $scope.canCreate = canCreate;
                  $scope.entities = entities;
                  $scope.sectors = sectors;
                  $scope.deliveryTypeOptions = deliveryTypeOptions;
                  $scope.allowPatientIdentityCheck = allowPatientIdentityCheck;
                  if (!$scope.editableStay.id) {
                    $scope.editing = true;
                    if ($scope.entities.length === 1) {
                      $scope.editableStay.entity = $scope.entities[0].id;
                      $scope.entitySelected();
                    }
                  }
                  return $scope.initDone = true;
                });
              });
            });
          });
        });
        $scope.computeStayId = function() {
          $scope.stayEditForm.$setDirty();
          return $scope.editableStay.si_id = 'NDS' + GenUID.generate(7);
        };
        $scope.updateIdentitoInfo = function() {
          if ($scope.editableStay.identitovigilance.checked) {
            $scope.editableStay.identitovigilance.author_fullname = $rootScope.user.full_name;
            $scope.editableStay.identitovigilance.author_login = $rootScope.user.username;
            $scope.editableStay.identitovigilance.timestamp = moment();
            return $scope.editableStay.identitovigilance.which_day = moment().format('LLL');
          } else {
            return $scope.editableStay.identitovigilance = _.pick($scope.editableStay.identitovigilance, "referents");
          }
        };
        return $scope.weekdays = (function() {
          var i, len, ref, results;
          ref = $rootScope.DATETIME_FORMATS.DAY;
          results = [];
          for (index = i = 0, len = ref.length; i < len; index = ++i) {
            day = ref[index];
            results.push({
              "id": index + 1,
              "label": _.upperFirst(day)
            });
          }
          return results;
        })();
      }]
    };
  });

}).call(this);

//# sourceMappingURL=stay-edition-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:PatientEditInfosCtrl
    * @description
    * # PatientEditInfosCtrl
    * Controller of patient infos changes
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('PatientEditInfosCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "$q", "patient", "stays", "SiteVarsUtils", function($scope, $rootScope, $state, $stateParams, $q, patient, stays, SiteVarsUtils) {
    $scope.canModify = indexOf.call($rootScope.user.group.features, "SRV_pac") >= 0;
    SiteVarsUtils.get('ALLOW_PATIENT_CREATION', false).then(function(sitevar) {
      return $scope.canCreatePatient = sitevar.value;
    });
    $scope.patient = patient;
    $scope.stays = stays;
    $scope.createNewStay = function() {
      return $scope.newStay = {
        patient: patient.id,
        identitovigilance: {}
      };
    };
    $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      var closePromise;
      if (event.defaultPrevented) {
        return;
      }
      closePromise = $scope.$broadcast('closeRequested').closePromise;
      if (closePromise && angular.isFunction(closePromise.then)) {
        event.preventDefault();
        return $q.when(closePromise).then(function(result) {
          if (result) {
            return $state.go(toState.name, toParams);
          }
        });
      }
    });
    $scope.$on('newStay', function(event, stay) {
      $scope.stays.push(stay);
      $scope.newStay = null;
      return $state.go($state.current, {
        idStay: stay.id
      });
    });
    $scope.$on('removeStay', function(event, stay) {
      return delete $scope.newStay;
    });
    $scope.orderStays = function(stay) {
      if (!stay.id) {
        return 1;
      } else {
        if (stay.id === $stateParams.idStay) {
          return 2;
        } else {
          return 3;
        }
      }
    };
    return $scope.checkForm = function(event, selectedIndex) {
      if ($scope.currentTabIndex !== selectedIndex) {
        event.preventDefault();
        return $q.when($scope.$broadcast('closeRequested').closePromise).then(function(result) {
          if (result) {
            return $scope.currentTabIndex = selectedIndex;
          }
        });
      }
    };
  }]);

  angular.module('mhclientApp').directive('patientEdition', function() {
    return {
      restrict: 'E',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'patient/views/patient-editon-directive.html';
        }
      },
      scope: {
        patient: '=',
        stays: '=',
        enableActions: '=',
        options: "=",
        patientDataForm: "=?"
      },
      controller: ["$rootScope", "$scope", "Patient", "PatientByIpp", "Utils", "GenUID", "SiteVarsUtils", "FeedUtils", "AccessData", function($rootScope, $scope, Patient, PatientByIpp, Utils, GenUID, SiteVarsUtils, FeedUtils, AccessData) {
        $scope.canReadRestrictedInfos = false;
        SiteVarsUtils.get('ALLOW_PATIENT_CREATION', false).then(function(sitevar) {
          return $scope.canModifyPatient = sitevar.value;
        });
        if ($rootScope.mh_config.platform === "mhsi" && $rootScope.user.group.features.indexOf("RESTRICTED_SEGUR_INFOS") !== -1) {
          $scope.canReadRestrictedInfos = true;
          AccessData.newInsAccess();
        }
        $scope.computePatientId = function() {
          $scope.patientDataForm.$setDirty();
          return $scope.editablePatient.si_id = 'IPP' + GenUID.generate(7);
        };
        SiteVarsUtils.getValue('availableExternalSyncs', []).then(function(availableExternalSyncs) {
          return $scope.availableExternalSyncs = availableExternalSyncs;
        });
        SiteVarsUtils.get('SYNC_WITH_MHLINK', {
          "enabled": false
        }).then(function(sitevar) {
          return $scope.syncWithMHLinkConfig = sitevar.value;
        });
        $scope.syncWithMHLink = function() {
          $rootScope.busy = true;
          return Patient.syncWithMHLink({
            id: $scope.patient.id
          }).$promise.then(function() {
            $scope.patient.data.synchronized_with_mhlink = true;
            $scope.editablePatient.data.synchronized_with_mhlink = true;
            return $rootScope.busy = false;
          });
        };
        $scope.$on('closeRequested', function(event) {
          return Utils.handleCloseRequested(event, $scope.editing, !$scope.patientDataForm.$invalid, $scope.savePatient, $scope.cancelEdition);
        });
        $scope.$on('createPatient', function(event) {
          return event.createPatientPromise = $scope.savePatient();
        });
        $scope.editablePatient = _.cloneDeep($scope.patient);
        $scope.editPatient = function() {
          return $scope.editing = true;
        };
        if (!$scope.editablePatient.id) {
          $scope.editing = true;
        }
        $scope.cancelEdition = function() {
          $scope.editing = false;
          $scope.editablePatient = _.cloneDeep($scope.patient);
          return true;
        };
        return $scope.savePatient = function() {
          var patientData;
          patientData = _.pick($scope.editablePatient, ["si_id", "last_name", "maidenname", "name", "gender", "birthday", "data", "address_data", "dmp_data"]);
          patientData.birthday = moment(patientData.birthday).format("YYYY-MM-DD");
          return ($scope.editablePatient.id ? Patient.update({
            id: $scope.editablePatient.id
          }, patientData) : PatientByIpp.update({
            si_id: patientData.si_id
          }, patientData)).$promise.then(function(patient) {
            _.assign($scope.patient, patient);
            $scope.cancelEdition();
            return patient.id;
          });
        };
      }]
    };
  });

  angular.module('mhclientApp').directive('patientUsersEdition', function() {
    return {
      restrict: 'E',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'patient/views/patient-users-edition-directive.html';
        }
      },
      scope: {
        patient: '=',
        stays: '=',
        canModify: '=',
        options: "=",
        user: "="
      },
      controller: ["$rootScope", "$scope", "$q", "Entity", "Patient", "GroupUtils", "UserPatient", "User", "Utils", "SiteVarsUtils", function($rootScope, $scope, $q, Entity, Patient, GroupUtils, UserPatient, User, Utils, SiteVarsUtils) {
        $scope.state = {
          isDirty: false
        };
        $scope.$on('closeRequested', function(event) {
          return Utils.handleCloseRequested(event, $scope.state.isDirty, true, $scope.save, $scope.cancelEdition);
        });
        $scope.cancelEdition = function() {
          $scope.state.isDirty = false;
          return true;
        };
        $scope.save = function() {
          var selectedUsers;
          $rootScope.busy = true;
          selectedUsers = [];
          _.forEach($scope.usersByEntities, function(usersByEntity) {
            return _.forEach(["userInSecotors", "userInDrugstores", "otherUsers"], function(userType) {
              return selectedUsers = selectedUsers.concat(_.map(usersByEntity[userType].selected, "id"));
            });
          });
          return Patient.updateLinkedUsers({
            id: $scope.patient.id,
            users_to_link: _.difference(selectedUsers, $scope.initialPatienUsersIds),
            users_to_unlink: _.difference($scope.initialPatienUsersIds, selectedUsers)
          }).$promise.then(function() {
            $scope.initialPatienUsersIds = selectedUsers;
            $scope.state.isDirty = false;
            $rootScope.busy = false;
            return true;
          });
        };
        return $q.all([
          GroupUtils.getAllGroups(), User.getAvailableUsers({
            entities: _.uniq(_.map($scope.stays, "entity"))
          }).$promise, UserPatient.api.query({
            patient: $scope.patient.id
          }).$promise, Entity.getEntities(), SiteVarsUtils.getValue("AUTO_ASSIGN_ALL_ON_CREATION", false)
        ]).then(function(data) {
          var autoAssingEmp, feature, group, groupById, i, j, k, len, len1, len2, listToUse, patientUsers, ref, ref1, ref2, ref3, ref4, selectedEntity, user;
          autoAssingEmp = data[3];
          patientUsers = _.map(data[2], "user");
          $scope.initialPatienUsersIds = [];
          groupById = {};
          ref = data[0];
          for (i = 0, len = ref.length; i < len; i++) {
            group = ref[i];
            groupById[group.id] = group;
            ref1 = group.features;
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              feature = ref1[j];
              group.isDrugStore = group.isDrugStore || (feature === "ORD" || feature === "ORV");
              group.isSRVSel = group.isSRVSel || feature === "SRV_sel";
              group.isSRVPal = group.isSRVPal || feature === "SRV_pal";
            }
          }
          $scope.usersByEntities = _.map(_.uniq(_.map($scope.stays, "entity")), function(entityId) {
            return {
              entity: _.find(data[3], {
                id: entityId
              }),
              sectors: _.map(_.filter($scope.stays, function(stay) {
                return stay.sector && stay.entity === entityId;
              }), "sector")
            };
          });
          if ($scope.usersByEntities.length > 1) {
            $scope.usersByEntities.push({
              entity: {
                sitevars: {
                  LABEL_TITLE: "MultiEntity"
                }
              },
              sectors: []
            });
          }
          _.forEach($scope.usersByEntities, function(usersByEntity) {
            return _.merge(usersByEntity, {
              userInSecotors: {
                selected: [],
                available: []
              },
              userInDrugstores: {
                selected: [],
                available: []
              },
              otherUsers: {
                selected: [],
                available: []
              }
            });
          });
          ref2 = data[1];
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            user = ref2[k];
            selectedEntity = _.find($scope.usersByEntities, {
              "entity": {
                "id": user.entity
              }
            }) || $scope.usersByEntities[$scope.usersByEntities.length - 1];
            group = groupById[user.group];
            listToUse = selectedEntity[group.isDrugStore ? "userInDrugstores" : (group.isSRVSel || (ref3 = user.sector, indexOf.call(selectedEntity.sectors, ref3) >= 0) ? "userInSecotors" : "otherUsers")];
            user.fullName = user.last_name + " " + user.first_name + " (" + group.name + ")";
            if (ref4 = user.id, indexOf.call(patientUsers, ref4) >= 0) {
              user.readonly = group.isSRVPal || (autoAssingEmp && user.pro_category === 'emp') || !$scope.canModify;
              listToUse.selected.push(user);
              $scope.initialPatienUsersIds.push(user.id);
            } else {
              user.readonly = !$scope.canModify;
              listToUse.available.push(user);
            }
          }
          return $scope.ready = true;
        });
      }]
    };
  });

  angular.module('mhclientApp').directive('patientFormsEdition', function() {
    return {
      restrict: 'E',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'patient/views/patient-forms-edition-directive.html';
        }
      },
      scope: {
        patient: '=',
        stays: '=',
        canModify: '=',
        options: "="
      },
      controller: ["$rootScope", "$scope", "$filter", "Patient", "Utils", "FormGroup", "Template", "TemplateVersion", function($rootScope, $scope, $filter, Patient, Utils, FormGroup, Template, TemplateVersion) {
        $scope.state = {
          isDirty: false
        };
        $scope.$on('closeRequested', function(event) {
          return Utils.handleCloseRequested(event, $scope.state.isDirty, true, $scope.save, $scope.cancelEdition);
        });
        $scope.cancelEdition = function() {
          $scope.state.isDirty = false;
          return true;
        };
        $scope.save = function() {
          $rootScope.busy = true;
          return Patient.updateLinkedForms({
            id: $scope.patient.id,
            templates: _.map(_.filter($scope.templates, "selected"), "id")
          }).$promise.then(function() {
            $scope.state.isDirty = false;
            $rootScope.busy = false;
            return true;
          });
        };
        return Template.getAllTemplates().$promise.then(function(templates) {
          return TemplateVersion.query({
            only_current: true
          }).$promise.then(function(versions) {
            return FormGroup.query().$promise.then(function(formGroups) {
              return Patient.getLinkedForms({
                id: $scope.patient.id
              }).$promise.then(function(linkedForms) {
                var templatesByGroup;
                $scope.formGroups = formGroups;
                $scope.templates = _.filter(templates, "current");
                _.forEach($scope.templates, function(template) {
                  var ref;
                  template.selected = (ref = template.id, indexOf.call(linkedForms, ref) >= 0);
                  return true;
                });
                _.forEach($scope.templates, function(template) {
                  return template.label = _.find(versions, {
                    id: template.current
                  }).name;
                });
                templatesByGroup = _.groupBy($scope.templates, "group");
                _.forEach($scope.formGroups, function(group) {
                  return group.templates = templatesByGroup[group.id] || [];
                });
                $scope.formGroups.push({
                  "name": $filter('translate')("NO_NAME_GROUP"),
                  "templates": templatesByGroup[null] || []
                });
                return $scope.ready = true;
              });
            });
          });
        });
      }]
    };
  });

  angular.module('mhclientApp').directive('patientMeasuresEdition', function() {
    return {
      restrict: 'E',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'patient/views/patient-measures-edition-directive.html';
        }
      },
      scope: {
        patient: '=',
        stays: '=',
        canModify: '=',
        options: "="
      },
      controller: ["$rootScope", "$scope", "Patient", "Utils", "PatientMeasuresTypes", function($rootScope, $scope, Patient, Utils, PatientMeasuresTypes) {
        $scope.isDirty = false;
        $scope.$on('closeRequested', function(event) {
          return Utils.handleCloseRequested(event, $scope.isDirty, true, $scope.save, $scope.cancelEdition);
        });
        $scope.cancelEdition = function() {
          $scope.isDirty = false;
          return true;
        };
        $scope.save = function() {
          $rootScope.busy = true;
          return Patient.updateLinkedMeasures({
            id: $scope.patient.id,
            patient_measures: _.map($scope.selectedVitalSigns, "id")
          }).$promise.then(function() {
            $scope.isDirty = false;
            $rootScope.busy = false;
            return true;
          });
        };
        return PatientMeasuresTypes.api.query().$promise.then(function(patientMeasures) {
          return Patient.getLinkedMeasures({
            id: $scope.patient.id
          }).$promise.then(function(linkedMeasures) {
            $scope.vitalSigns = [];
            $scope.selectedVitalSigns = [];
            _.forEach(patientMeasures, function(patientMeasure) {
              var ref;
              patientMeasure.label = patientMeasure.metadata.LABEL || patientMeasure.uid;
              patientMeasure.readonly = !$scope.canModify;
              if (ref = patientMeasure.id, indexOf.call(linkedMeasures, ref) >= 0) {
                return $scope.selectedVitalSigns.push(patientMeasure);
              } else {
                return $scope.vitalSigns.push(patientMeasure);
              }
            });
            return $scope.ready = true;
          });
        });
      }]
    };
  });

  angular.module('mhclientApp').directive('patientDevicesEdition', function() {
    return {
      restrict: 'E',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'patient/views/patient-devices-edition-directive.html';
        }
      },
      scope: {
        patient: '=',
        stays: '=',
        canModify: '=',
        options: "="
      },
      controller: ["$rootScope", "$scope", "$filter", "$q", "Patient", "MHDevice", "Entity", "$uibModal", function($rootScope, $scope, $filter, $q, Patient, MHDevice, Entity, $uibModal) {
        var entitiesIds, genDeviceLabel, showConfirmationDialog;
        showConfirmationDialog = function() {
          return $uibModal.open({
            animation: true,
            templateUrl: 'core/views/modal-template.html',
            size: "lg",
            controller: 'mhModalCtrl',
            resolve: {
              title: function() {
                return $filter('translate')("DOC_NOT_SAVED");
              },
              text: function() {
                return $filter('translate')("GENERIC_CONFIRM_STEAL_BOX");
              },
              cancelButtonText: function() {
                return $filter('translate')("CANCEL_BUTTON");
              },
              noButtonText: function() {
                return null;
              },
              okButtonText: function() {
                return $filter('translate')("SAVE_BUTTON");
              }
            }
          }).result.then(function(toSave) {
            return toSave;
          });
        };
        genDeviceLabel = function(device) {
          var label;
          label = device.name;
          if (device.data.is_multipatient) {
            return label += " (" + $filter('translate')("Multipatient") + " " + device.patients.length + " " + $filter('translate')("Linked patients") + ")";
          } else {
            return label += " " + _.map(device.patients, function(patient) {
              return "(" + patient.patient__name + " " + patient.patient__last_name + ")";
            }).join(", ");
          }
        };
        $scope.disassociate = function(device) {
          $rootScope.busy = true;
          return Patient.unlinkFromDevice({
            id: $scope.patient.id,
            device: device.id
          }).$promise.then(function() {
            device.selected = false;
            _.remove(device.patients, {
              patient: $scope.patient.id
            });
            delete _.find($scope.entitiesConfig, {
              entity: {
                id: device.entity
              }
            }).currentDevice;
            device.label = genDeviceLabel(device);
            return $rootScope.busy = false;
          });
        };
        $scope.$on('closeRequested', function(event) {
          return event.closePromise = true;
        });
        $scope.selectMHB = function(selectedDevice) {
          selectedDevice.selected = false;
          return $q.when(selectedDevice.patients.length === 0 || selectedDevice.data.is_multipatient || showConfirmationDialog(selectedDevice)).then(function(result) {
            if (result) {
              $rootScope.busy = true;
              return Patient.linkToDevice({
                id: $scope.patient.id,
                device: selectedDevice.id
              }).$promise.then(function() {
                var patientDeviceDict;
                _.find($scope.entitiesConfig, {
                  entity: {
                    id: selectedDevice.entity
                  }
                }).currentDevice = selectedDevice;
                patientDeviceDict = {
                  patient: $scope.patient.id,
                  patient__name: $scope.patient.name,
                  patient__last_name: $scope.patient.last_name
                };
                if (selectedDevice.data.is_multipatient) {
                  selectedDevice.patients.push(patientDeviceDict);
                } else {
                  selectedDevice.patients = [patientDeviceDict];
                }
                selectedDevice.label = genDeviceLabel(selectedDevice);
                return $rootScope.busy = false;
              });
            }
          });
        };
        entitiesIds = _.uniq(_.map($scope.stays, "entity"));
        return Entity.getEntities().then(function(entities) {
          return MHDevice.api.query({
            entities: entitiesIds
          }).$promise.then(function(devices) {
            return MHDevice.api.getDevicesPatientsLinks({
              entities: entitiesIds,
              exclude_auto_assign_patients: true
            }).$promise.then(function(devicesPatients) {
              var currentPatientDevices, devicesGroupedByEntity, entityDevices, entityId, i, len;
              devices = _.filter(devices, function(device) {
                return !device.auto_assign_patients;
              });
              _.forEach(devices, function(device) {
                device.patients = _.filter(devicesPatients, {
                  mhdevice: device.id
                });
                return device.label = genDeviceLabel(device);
              });
              devicesGroupedByEntity = _.groupBy(devices, "entity");
              $scope.entitiesConfig = [];
              currentPatientDevices = _.map(_.filter(devicesPatients, {
                patient: $scope.patient.id
              }), "mhdevice");
              for (i = 0, len = entitiesIds.length; i < len; i++) {
                entityId = entitiesIds[i];
                entityDevices = devicesGroupedByEntity[entityId] || [];
                $scope.entitiesConfig.push({
                  entity: _.find(entities, {
                    id: entityId
                  }),
                  devices: entityDevices,
                  currentDevice: _.find(entityDevices, function(device) {
                    var ref;
                    return ref = device.id, indexOf.call(currentPatientDevices, ref) >= 0;
                  })
                });
              }
              return $scope.ready = true;
            });
          });
        });
      }]
    };
  });

}).call(this);

//# sourceMappingURL=patient-edit-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PspController
    * @description
    * # PspController
    * Controller of Customized care plan
   */
  angular.module('mhclientApp').controller('PspCtrl', ["$scope", "$rootScope", "$state", function($scope, $rootScope, $state) {
    $scope.patient = $rootScope.currentPatient;
    $scope.stay = $rootScope.currentStay;
    $scope.platform = $rootScope.mh_config.platform;
    return $scope.user = $rootScope.user;
  }]);

}).call(this);

//# sourceMappingURL=psp-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service: Psp / HealthIssue
    * @description
    * # PSP / HealthIssue
    * Factory of PSP and HealthIssue
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").factory("Psp", ["$resource", "MhConfig", "$q", "BoxResource", "$http", function($resource, MhConfig, $q, BoxResource, $http) {
    var acceptHeader, api, getReview, portailAPI, psps, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource("/api_rest/psp/:id/:route", {
      id: this.id
    }, {
      "save": {
        method: "POST",
        headers: {
          "Accept": acceptHeader
        }
      },
      "update": {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      },
      "query": {
        method: "GET",
        headers: {
          "Accept": acceptHeader
        },
        isArray: true
      },
      "stopPSP": {
        method: "PATCH",
        headers: {
          "Accept": acceptHeader
        },
        isArray: false,
        params: {
          route: "stop_psp",
          id: '@id'
        }
      },
      "getTasks": {
        method: "GET",
        headers: {
          "Accept": acceptHeader
        },
        isArray: true,
        params: {
          route: "get_tasks",
          id: '@id'
        }
      },
      "getActivities": {
        method: "GET",
        headers: {
          "Accept": acceptHeader
        },
        isArray: true,
        params: {
          route: "get_activities",
          id: '@id'
        }
      },
      "suspendTP": {
        method: "PATCH",
        headers: {
          "Accept": acceptHeader
        },
        isArray: false,
        params: {
          route: "suspend_tp",
          id: '@id'
        }
      },
      "resumeTP": {
        method: "PATCH",
        headers: {
          "Accept": acceptHeader
        },
        isArray: false,
        params: {
          route: "resume_tp",
          id: '@id'
        }
      },
      "delayTP": {
        method: "PATCH",
        headers: {
          "Accept": acceptHeader
        },
        isArray: false,
        params: {
          route: "delay_tp",
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case "mhsi":
        api = portailAPI;
        break;
      case "mgapp":
        psps = window.mgapp.get("psp_mgr").psp();
        api = BoxResource.generate(psps);
        api.getTasks = function(object) {
          return BoxResource.mhboxApiCall(psps, "get_tasks", object);
        };
        api.getActivities = function(object) {
          return BoxResource.mhboxApiCall(psps, "get_activities", object);
        };
        break;
      default:
        api = portailAPI;
    }
    getReview = function(review, healthIssues, psp) {
      var objList, selectedIssues, tpList;
      selectedIssues = _.filter(healthIssues, function(issue) {
        return issue.start_review <= review.id && (issue.end_review === null || (issue.end_review > review.id) || (review.status === "pspf" && issue.end_review === review.id));
      });
      tpList = angular.copy(psp.therapeutic_programs);
      objList = angular.copy(psp.objectives);
      _.forEach(tpList, function(tp) {
        var issues, issuesByObjective, objUidList;
        issues = _.filter(selectedIssues, {
          tp_uid: tp.thesaurus_uid
        });
        if (issues.length > 0) {
          tp.selected = true;
          issuesByObjective = _.groupBy(issues, "objective_uid");
          objUidList = Object.keys(issuesByObjective);
          tp.objectives = _.filter(objList, function(obj) {
            var ref;
            return ref = obj.thesaurus_uid, indexOf.call(objUidList, ref) >= 0;
          });
          _.forEach(tp.objectives, function(obj) {
            obj.selected = true;
            obj.healthIssues = issuesByObjective[obj.thesaurus_uid];
            return _.forEach(obj.healthIssues, function(issue) {
              return issue.selected = true;
            });
          });
        } else {
          tp.objectives = [];
          tp.selected = false;
        }
      });
      review.healthIssues = _.filter(selectedIssues, function(issue) {
        return !issue.tp_uid;
      });
      review.therapeuticPrograms = _.filter(tpList, function(tp) {
        return tp.selected;
      });
      return review;
    };
    service = {
      api: api,
      getReview: getReview
    };
    return service;
  }]);

  angular.module("mhclientApp").factory("HealthIssue", ["$resource", "MhConfig", "$q", "BoxResource", "$http", function($resource, MhConfig, $q, BoxResource, $http) {
    var acceptHeader, api, boxAPI, health_issues, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource("/api_rest/health_issue/:id/:route", {
      id: this.id
    }, {
      "query": {
        method: "GET",
        headers: {
          "Accept": acceptHeader
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case "mhsi":
        api = portailAPI;
        break;
      case "mgapp":
        health_issues = window.mgapp.get("psp_mgr").health_issues();
        boxAPI = BoxResource.generate(health_issues);
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=psp-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StopObjectiveCommentCtrl
    * @description
    * # StopObjectiveCommentCtrl
    * Controller of stop objective comment modal
   */
  angular.module('mhclientApp').controller('StopObjectiveCommentCtrl', ["$scope", "$uibModalInstance", "objectiveName", function($scope, $uibModalInstance, objectiveName) {
    var init;
    $scope.loaded = false;
    $scope.therapeuticProgramList = [];
    init = function() {
      $scope.objectiveName = objectiveName;
      return $scope.comment = "";
    };
    $scope.validComment = function() {
      return $uibModalInstance.close({
        "result": true,
        "comment": $scope.objectiveName + ": " + $scope.comment
      });
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss({
        "result": false
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=psp-stop-objective-comment-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:ReviewEditionCtrl
    * @description
    * # ReviewEditionCtrl
    * Controller of review edition modal
   */
  angular.module('mhclientApp').controller('ReviewEditionCtrl', ["$scope", "$uibModalInstance", "ThesaurusUtils", "review", "startDate", "colors", function($scope, $uibModalInstance, ThesaurusUtils, review, startDate, colors) {
    var init;
    $scope.loaded = false;
    $scope.therapeuticProgramList = [];
    init = function() {
      $scope.review = review;
      $scope.colors = colors;
      $scope.pspData = {
        "startDate": startDate
      };
      return ThesaurusUtils.getPT().then(function(result) {
        $scope.therapeuticProgramList = result;
        return $scope.loaded = true;
      });
    };
    $scope.updateMessage = function() {
      return $uibModalInstance.close({
        "result": true,
        "startDate": $scope.pspData.startDate
      });
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss({
        "result": false
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=psp-review-edition-modal-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:pspReviewContainer
    * @description
    * Directive displaying PSP buttons actions and containing review directive
   */
  angular.module('mhclientApp').directive('pspReviewContainer', function() {
    return {
      restrict: 'E',
      templateUrl: 'psp/psp-review-container/views/psp-review-container.html',
      scope: {
        user: "=",
        patient: "=",
        stay: "=",
        permissions: "=",
        platform: "=",
        displayHeader: '<',
        canModify: '<'
      },
      controller: 'PspReviewContainerCtrl'
    };
  });

}).call(this);

//# sourceMappingURL=psp-review-container-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PspReviewContainerCtrl
    * @description
    * # PspReviewContainerCtrl
    * Controller of the psp review container directive
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('PspReviewContainerCtrl', ["$scope", "$rootScope", "$q", "SiteVarsUtils", "ThesaurusUtils", "Psp", "HealthIssue", "$uibModal", function($scope, $rootScope, $q, SiteVarsUtils, ThesaurusUtils, Psp, HealthIssue, $uibModal) {
    var init;
    $scope.review = null;
    $scope.psp = null;
    $scope.newPsp = false;
    $scope.lastReviewId = -1;
    $scope.loaded = false;
    $scope.reviewList = [];
    $scope.availableStatusList = [];
    $scope.healthIssues = [];
    $scope.colors = {
      tpColor: "#000",
      objColor: "#000"
    };
    $scope.allStays = $rootScope.allStays;
    $scope.patient = $rootScope.currentPatient;
    init = function() {
      var promises;
      promises = [
        SiteVarsUtils.get('MESSAGE_MODIFY_DELAY', 10), SiteVarsUtils.get('CLOSED_STAY_ALTERATIONS_DELAY_IN_DAYS', 0), SiteVarsUtils.get('CAN_MODIFY_MESSAGE', false), Psp.api.query({
          "stay": $scope.stay.id
        }).$promise, ThesaurusUtils.getThesaurusCategories({
          code: "therapeutic_programs"
        })
      ];
      return $q.all(promises).then(function(data) {
        var canStillBeAltered, dTo, isActiveStay, ref, ref1;
        $scope.modifyDelay = data[0].value;
        $scope.canModifyReview = data[2].value;
        $scope.canWrite = $scope.permissions.indexOf('CAN_WRITE') !== -1 && $rootScope.mh_config.platform === "mhsi";
        isActiveStay = $scope.stay && ((ref = $scope.stay.state) === 'PRE' || ref === 'ADM');
        if ($scope.stay && $scope.stay.d_to) {
          dTo = moment($scope.stay.d_to);
          canStillBeAltered = (moment().diff(dTo, 'hours') <= data[1].value * 24) && ((ref1 = $scope.stay.state) === "CLOSE" || ref1 === "I");
        }
        $scope.canCreateReview = isActiveStay || canStillBeAltered;
        if (data[4] !== void 0) {
          $scope.colors = {
            tpColor: data[4].data.colors[0],
            objColor: data[4].data.colors[1]
          };
        }
        return $scope.computePspData(data[3]);
      });
    };
    $scope.computePspData = function(pspList) {
      var lastReviewIndex, nbPSP, reviewsInfos;
      nbPSP = pspList.length;
      $scope.selectedReviewId = -1;
      if (nbPSP === 0) {
        $scope.loaded = true;
        return;
      }
      $scope.psp = pspList[nbPSP - 1];
      lastReviewIndex = $scope.psp.reviews.length - 1;
      if (lastReviewIndex === -1) {
        $scope.loaded = true;
        return;
      }
      reviewsInfos = _.map($scope.psp.reviews, function(review) {
        return {
          id: review.id,
          status: review.status,
          timestamp: review.timestamp
        };
      });
      $scope.reviewList = _.groupBy(reviewsInfos, "status");
      $scope.availableStatusList = Object.keys($scope.reviewList);
      return HealthIssue.api.query({
        "psp": $scope.psp.id
      }).$promise.then(function(healthIssues) {
        $scope.healthIssues = healthIssues;
        $scope.review = $scope.psp.reviews[lastReviewIndex];
        $scope.lastReviewId = $scope.review.id;
        $scope.selectedReviewId = $scope.lastReviewId;
        $scope.computeSelectedReview($scope.review);
        return $scope.loaded = true;
      });
    };
    $scope.computeSelectedReview = function(review) {
      var objList, selectedIssues, tpList;
      selectedIssues = _.filter($scope.healthIssues, function(issue) {
        return issue.start_review <= review.id && (issue.end_review === null || (issue.end_review > review.id) || (review.status === "pspf" && issue.end_review === review.id));
      });
      tpList = angular.copy($scope.psp.therapeutic_programs);
      objList = angular.copy($scope.psp.objectives);
      _.forEach(tpList, function(tp) {
        var issues, issuesByObjective, objUidList;
        issues = _.filter(selectedIssues, {
          tp_uid: tp.thesaurus_uid
        });
        if (issues.length > 0) {
          tp.selected = true;
          issuesByObjective = _.groupBy(issues, "objective_uid");
          objUidList = Object.keys(issuesByObjective);
          tp.objectives = _.filter(objList, function(obj) {
            var ref;
            return ref = obj.thesaurus_uid, indexOf.call(objUidList, ref) >= 0;
          });
          return _.forEach(tp.objectives, function(obj) {
            obj.selected = true;
            obj.healthIssues = issuesByObjective[obj.thesaurus_uid];
            return _.forEach(obj.healthIssues, function(issue) {
              return issue.selected = true;
            });
          });
        } else {
          tp.objectives = [];
          tp.selected = false;
        }
      });
      review.healthIssues = _.filter(selectedIssues, function(issue) {
        return !issue.tp_uid;
      });
      review.therapeuticPrograms = _.filter(tpList, function(tp) {
        return tp.selected;
      });
      return $scope.ReviewCanBeModified();
    };
    $scope.ReviewCanBeModified = function() {
      var currentDate, delayNotExpired;
      currentDate = moment();
      delayNotExpired = moment.utc($scope.review.timestamp).add($scope.modifyDelay, "minutes").isAfter(currentDate);
      return $scope.canModify = $scope.review === $scope.psp.reviews[$scope.psp.reviews.length - 1] && $scope.canModifyReview && !($scope.review.freezone.mode === 'draw') && $scope.canWrite && delayNotExpired;
    };
    $scope.createInitalPsp = function() {
      var newReview;
      $scope.newPsp = true;
      newReview = {
        "id": 0,
        "therapeuticPrograms": [],
        "healthIssues": [],
        "status": "pspi",
        "patientExpectations": {},
        "freezone": {
          "mode": "text"
        },
        "professionalPresentComment": {
          "mode": "text"
        }
      };
      $scope.psp = {
        "stay": $scope.stay.id,
        "reviews": [],
        "therapeutic_programs": [],
        "objectives": [],
        "start_date": moment().format()
      };
      return $scope.editReview(newReview, true);
    };
    $scope.createNewReview = function() {
      var newReview;
      newReview = $scope.copyReview("reevaluation");
      return $scope.editReview(newReview, true);
    };
    $scope.createFinalReview = function() {
      var newReview;
      newReview = $scope.copyReview("pspf");
      return $scope.editReview(newReview, true);
    };
    $scope.modifyReview = function(review) {
      var newReview;
      newReview = angular.copy(review);
      return $scope.editReview(newReview, false);
    };
    $scope.copyReview = function(status) {
      return {
        "id": $scope.review.id + 1,
        "status": status,
        "therapeuticPrograms": angular.copy($scope.review.therapeuticPrograms),
        "healthIssues": angular.copy($scope.review.healthIssues),
        "freezone": angular.copy($scope.review.freezone),
        "professionalPresentComment": angular.copy($scope.review.professionalPresentComment),
        "patientExpectations": angular.copy($scope.review.patientExpectations),
        "objectivesComments": {}
      };
    };
    $scope.editReview = function(review, isNewReview) {
      var editReviewModal;
      editReviewModal = $uibModal.open({
        animation: true,
        windowClass: "modal-fullscreen",
        controller: "ReviewEditionCtrl",
        templateUrl: 'psp/views/psp-review-edition-modal.html',
        resolve: {
          review: function() {
            return review;
          },
          startDate: function() {
            return $scope.psp.start_date;
          },
          colors: function() {
            return $scope.colors;
          }
        }
      });
      return editReviewModal.result.then(function(data) {
        var issueLists, tpAndObjs;
        if (data.result) {
          tpAndObjs = $scope.getTPAndObjectives(review);
          issueLists = $scope.getIssueLists(review);
          $scope.psp.therapeutic_programs = _.unionBy($scope.psp.therapeutic_programs, tpAndObjs.tpList, "thesaurus_uid");
          $scope.psp.objectives = _.unionBy($scope.psp.objectives, tpAndObjs.objectiveList, "thesaurus_uid");
          if (isNewReview) {
            review.author = $scope.user.first_name + " " + $scope.user.last_name;
            review.timestamp = new Date().toISOString();
            $scope.psp.reviews.push(review);
          } else {
            review.modifying_author = $scope.user.first_name + " " + $scope.user.last_name;
            review.modified_timestamp = new Date().toISOString();
            $scope.psp.reviews.splice($scope.psp.reviews.length - 1, 1, review);
          }
          $scope.psp.issueLists = issueLists;
          if ($scope.newPsp) {
            $scope.psp.start_date = data.startDate;
          }
          if (review.status === "pspf") {
            return Psp.api.stopPSP($scope.psp).$promise.then(function(data) {
              return $scope.computePspData([data]);
            });
          } else if ($scope.psp.id) {
            return Psp.api.update($scope.psp).$promise.then(function(data) {
              return $scope.computePspData([data]);
            });
          } else {
            return Psp.api.save($scope.psp).$promise.then(function(data) {
              return $scope.computePspData([data]);
            });
          }
        }
      });
    };
    $scope.getTPAndObjectives = function(review) {
      var tpAndObjs;
      tpAndObjs = {
        "tpList": [],
        "objectiveList": []
      };
      _.forEach(review.therapeuticPrograms, function(tp) {
        if (tp.selected) {
          tpAndObjs.tpList.push({
            "thesaurus_uid": tp.thesaurus_uid,
            "label": tp.label
          });
          return _.forEach(tp.objectives, function(objective) {
            if (objective.selected) {
              return tpAndObjs.objectiveList.push({
                "thesaurus_uid": objective.thesaurus_uid,
                "label": objective.label
              });
            }
          });
        }
      });
      delete review.therapeuticPrograms;
      return tpAndObjs;
    };
    $scope.getIssueLists = function(review) {
      var issueLists;
      issueLists = {
        "added": review.addedIssues,
        "stopped": review.removedIssues,
        "modified": []
      };
      _.forEach(review.healthIssues, function(issue) {
        if (review.addedIssues.indexOf(issue) === -1 && review.removedIssues.indexOf(issue) === -1) {
          return issueLists.modified.push(issue);
        }
      });
      delete review.addedIssues;
      delete review.removedIssues;
      delete review.healthIssues;
      _.forEach(issueLists.added, function(issue) {
        return issue.start_review = review.id;
      });
      _.forEach(issueLists.stopped, function(issue) {
        return issue.end_review = review.id;
      });
      return issueLists;
    };
    $scope.selectedReviewChange = function(selectedReviewId) {
      var selectedId;
      selectedId = parseInt(selectedReviewId);
      $scope.review = _.find($scope.psp.reviews, function(review) {
        return selectedId === review.id;
      });
      if ($scope.review) {
        $scope.selectedReviewId = $scope.review.id;
        return $scope.computeSelectedReview($scope.review);
      }
    };
    $scope.printData = function(docType, allStays, patient, stay) {
      if (allStays) {
        window.open('/api_rest/patients/' + patient.id + '/print_data/' + docType, '_blank');
      } else {
        window.open('/api_rest/stays/' + stay.id + '/print_data/' + docType, '_blank');
      }
      return true;
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=psp-review-container-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:pspReview
    * @description
    * Directive displaying PSP review
   */
  angular.module('mhclientApp').directive('pspReview', function() {
    return {
      restrict: 'E',
      templateUrl: 'psp/psp-review/views/psp-review.html',
      scope: {
        review: "=",
        canModify: "=",
        colors: "=",
        onModify: "&"
      },
      controller: ["$scope", function($scope) {
        return $scope.modifyReview = function(review) {
          return $scope.onModify(review);
        };
      }]
    };
  });

}).call(this);

//# sourceMappingURL=psp-review-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:pspReviewEdit
    * @description
    * Directive editing a PSP review
   */
  angular.module('mhclientApp').directive('pspReviewEdit', function() {
    return {
      restrict: 'E',
      templateUrl: 'psp/psp-review-edit/views/psp-review-edit.html',
      scope: {
        review: "=",
        tpList: "=",
        canModify: "=",
        pspData: "=",
        colors: "="
      },
      controller: 'PspReviewEditCtrl'
    };
  });

}).call(this);

//# sourceMappingURL=psp-review-edit-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PspReviewEditCtrl
    * @description
    * # PspReviewEditCtrl
    * Controller of the psp review edit directive
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('PspReviewEditCtrl', ["$scope", "$uibModal", function($scope, $uibModal) {
    var init;
    $scope.therapeuticProgramList = [];
    $scope.newTherapeuticProgramsList = [];
    $scope.newObjetives = [];
    $scope.toggleObjectiveSelection = function(objective, tp) {
      var ref, ref1, ref2, stopObjectiveCommentModal;
      if (objective.selected) {
        if (indexOf.call($scope.newObjetives, objective) < 0 && !(ref = tp.thesaurus_uid, indexOf.call($scope.newTherapeuticProgramsList, ref) >= 0)) {
          stopObjectiveCommentModal = $uibModal.open({
            animation: true,
            controller: "StopObjectiveCommentCtrl",
            templateUrl: 'psp/views/stop-objective-comment-modal.html',
            resolve: {
              objectiveName: function() {
                return objective.label;
              }
            }
          });
          return stopObjectiveCommentModal.result.then(function(data) {
            if (data.result) {
              if (!$scope.review.objectivesComments[tp.thesaurus_uid]) {
                $scope.review.objectivesComments[tp.thesaurus_uid] = {};
              }
              $scope.review.objectivesComments[tp.thesaurus_uid][objective.thesaurus_uid] = data.comment;
              return $scope.unselectObjective(objective);
            }
          });
        } else {
          return $scope.unselectObjective(objective);
        }
      } else {
        if ((ref1 = $scope.review.objectivesComments) != null ? (ref2 = ref1[tp.thesaurus_uid]) != null ? ref2[objective.thesaurus_uid] : void 0 : void 0) {
          delete $scope.review.objectivesComments[tp.thesaurus_uid][objective.thesaurus_uid];
        } else if (indexOf.call($scope.newObjetives, objective) < 0) {
          $scope.newObjetives.push(objective);
        }
        return $scope.selectObjective(objective);
      }
    };
    $scope.unselectObjective = function(objective) {
      objective.healthIssues.forEach(function(issue) {
        if (issue.selected) {
          return $scope.unselectIssue(issue);
        }
      });
      return objective.selected = false;
    };
    $scope.selectObjective = function(objective) {
      objective.healthIssues.forEach(function(issue) {
        return $scope.selectIssue(issue);
      });
      return objective.selected = true;
    };
    $scope.toggleIssueSelection = function(issue) {
      if (issue.selected) {
        return $scope.unselectIssue(issue);
      } else {
        return $scope.selectIssue(issue);
      }
    };
    $scope.unselectIssue = function(issue) {
      var index;
      issue.selected = false;
      index = $scope.review.addedIssues.indexOf(issue);
      if (index !== -1) {
        return $scope.review.addedIssues.splice(index, 1);
      } else {
        return $scope.review.removedIssues.push(issue);
      }
    };
    $scope.selectIssue = function(issue) {
      var index;
      issue.selected = true;
      index = $scope.review.removedIssues.indexOf(issue);
      if (index !== -1) {
        return $scope.review.removedIssues.splice(index, 1);
      } else {
        return $scope.review.addedIssues.push(issue);
      }
    };
    $scope.removeComplementaryObjective = function(issue) {
      var index;
      index = $scope.review.healthIssues.indexOf(issue);
      if (index !== -1) {
        $scope.review.healthIssues.splice(index, 1);
      }
      return $scope.unselectIssue(issue);
    };
    $scope.addComplementaryObjective = function(issue) {
      var newIssue;
      newIssue = {
        "label": "",
        "start_review": $scope.review.id
      };
      $scope.review.healthIssues.push(newIssue);
      return $scope.selectIssue(newIssue);
    };
    $scope.toggleTpSelection = function(tp) {
      if (tp.selected) {
        return $scope.unselectTp(tp);
      } else {
        return $scope.selectTp(tp);
      }
    };
    $scope.unselectTp = function(tp) {
      tp.objectives.forEach(function(objective) {
        if (objective.selected) {
          return $scope.unselectObjective(objective);
        }
      });
      return tp.selected = false;
    };
    $scope.selectTp = function(tp) {
      tp.objectives.forEach(function(objective) {
        return $scope.selectObjective(objective);
      });
      return tp.selected = true;
    };
    $scope.addTp = function() {
      var tp;
      if ($scope.tpIndex !== void 0) {
        tp = angular.copy($scope.therapeuticProgramList[$scope.tpIndex]);
        $scope.review.therapeuticPrograms.push(tp);
        $scope.newTherapeuticProgramsList.push(tp.thesaurus_uid);
        $scope.therapeuticProgramList.splice($scope.tpIndex, 1);
        $scope.tpIndex = void 0;
        return $scope.selectTp(tp);
      }
    };
    init = function() {
      $scope.review.removedIssues = [];
      $scope.review.addedIssues = [];
      $scope.formatTherapeuticProgramData();
      return $scope.completeReviewTPList();
    };
    $scope.formatTherapeuticProgramData = function() {
      return _.forEach($scope.tpList, function(item) {
        var tp;
        if (!item.obsolete) {
          tp = {
            "thesaurus_uid": item.uid,
            "label": item.label,
            "selected": false,
            "objectives": []
          };
          _.forEach(item.objectives, function(obj) {
            var objective;
            if (obj !== void 0 && !obj.obsolete) {
              objective = {
                "thesaurus_uid": obj.uid,
                "label": obj.label,
                "selected": false,
                "healthIssues": []
              };
              _.forEach(obj.health_issues, function(issue) {
                if (issue !== void 0 && !issue.obsolete) {
                  return objective.healthIssues.push({
                    "thesaurus_uid": issue.uid,
                    "label": issue.label,
                    "tp_uid": item.uid,
                    "objective_uid": obj.uid,
                    "selected": false
                  });
                }
              });
              return tp.objectives.push(objective);
            }
          });
          return $scope.therapeuticProgramList.push(tp);
        }
      });
    };
    $scope.completeReviewTPList = function() {
      return _.forEach($scope.review.therapeuticPrograms, function(tp) {
        var index, thesaurusTp;
        thesaurusTp = _.find($scope.therapeuticProgramList, function(tTp) {
          return tTp.thesaurus_uid === tp.thesaurus_uid;
        });
        if (thesaurusTp !== void 0) {
          _.forEach(thesaurusTp.objectives, function(tObj) {
            var obj;
            obj = _.find(tp.objectives, function(objective) {
              return objective.thesaurus_uid === tObj.thesaurus_uid;
            });
            if (obj !== void 0) {
              return _.forEach(tObj.healthIssues, function(tIssue) {
                var issue;
                issue = _.find(obj.healthIssues, function(item) {
                  return item.thesaurus_uid === tIssue.thesaurus_uid;
                });
                if (issue === void 0) {
                  return obj.healthIssues.push(tIssue);
                }
              });
            } else {
              return tp.objectives.push(tObj);
            }
          });
          index = $scope.therapeuticProgramList.indexOf(thesaurusTp);
          if (index !== -1) {
            return $scope.therapeuticProgramList.splice(index, 1);
          }
        }
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=psp-review-edit-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StayListCtrl
    * @description
    * # StayListCtrl
    * Controller of Stay movements list
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('StayListCtrl', ["$scope", "$state", "$uibModal", "MhConfig", "Stay", "Patient", "$filter", "$window", "SiteVarsUtils", "Sector", "Medplan", "$q", "$rootScope", "MedicalUnit", "ThesaurusUtils", "SequenceRealization", "UserCreation", "Entity", "Alert", "alertUtils", "UserUtils", function($scope, $state, $uibModal, MhConfig, Stay, Patient, $filter, $window, SiteVarsUtils, Sector, Medplan, $q, $rootScope, MedicalUnit, ThesaurusUtils, SequenceRealization, UserCreation, Entity, Alert, alertUtils, UserUtils) {
    var alertsPromise, alreadyFetchedStatus, entities_dict, fetchStays, getPds, init, medPlanByStayId, medicalunits_dict, patientsById, queries, sector_dict;
    $scope.stayList = [];
    $scope.stayListOrdered = [];
    $scope.stayToPrintList = [];
    $scope.stayToArchiveList = [];
    $scope.staysOrderBy = ['-eventOrder', 'patient.full_name', 'd_from', 'si_id'];
    $scope.currentCustomFilter = null;
    $scope.orderType = "";
    $scope.initDone = false;
    $scope.filtersChanged = false;
    $rootScope.user.filters.stayStates = $rootScope.user.filters.stayStates || ["PRE", "ADM"];
    $rootScope.user.filters.sectors = $rootScope.user.filters.sectors || ($rootScope.user.sector ? [$rootScope.user.sector] : []);
    $scope.filterRefBySectors = function() {
      $scope.availableReferents = [];
      return UserUtils.getUsers(true).then(function(users) {
        var i, len, ref1, ref2, stay;
        ref1 = ($rootScope.user.filters.sectors.length === 0 ? $scope.stayList : _.filter($scope.stayList, function(stay) {
          return $rootScope.user.filters.sectors.indexOf(stay.sector) > -1;
        }));
        for (i = 0, len = ref1.length; i < len; i++) {
          stay = ref1[i];
          Array.prototype.push.apply($scope.availableReferents, ((ref2 = stay.identitovigilance) != null ? ref2.referents : void 0) || []);
        }
        return $scope.availableReferents = _.uniqBy($scope.availableReferents.filter(function(ref) {
          var user;
          user = users.find(function(u) {
            return u.username === ref.username;
          });
          return (user != null) && user.is_active;
        }), "username");
      });
    };
    $scope.availableConfigFilters = $scope.alertConfigs;
    $scope.setFiltersChanged = function() {
      return $scope.filtersChanged = true;
    };
    $scope.stateFilterChange = function(selectedItemsByProperty) {
      var statesToFetch;
      $scope.filtersChanged = true;
      statesToFetch = _.difference((selectedItemsByProperty.length > 0 ? selectedItemsByProperty : _.map($scope.stayStatusOptions, "value")), alreadyFetchedStatus);
      if (statesToFetch.length > 0) {
        return fetchStays(statesToFetch);
      }
    };
    $scope.alertCategoriesFilterChange = function(selectedCategories) {
      $scope.filtersChanged = true;
      if (selectedCategories.length > 0) {
        return $scope.availableConfigFilters = _.filter($scope.alertConfigs, function(config) {
          var ref1;
          return ref1 = config.category.id, indexOf.call(selectedCategories, ref1) >= 0;
        });
      } else {
        return $scope.availableConfigFilters = $scope.alertConfigs;
      }
    };
    $scope.updateFilters = function() {
      $rootScope.busy = true;
      return UserCreation.updateFilters({
        id: $rootScope.user.id,
        filters: $rootScope.user.filters
      }).$promise.then(function() {
        $scope.filtersChanged = false;
        return $rootScope.busy = false;
      });
    };
    $scope.recomputeOrderedList = function() {
      return $scope.stayListOrdered = $filter("orderBy")($scope.stayList, $scope.staysOrderBy, false);
    };
    $scope.debouncedRecomputeOrderedList = _.debounce(function() {
      return $scope.$apply(function() {
        return $scope.recomputeOrderedList();
      });
    }, 200);
    $scope.changeOrderBy = function(mainOrder) {
      if ($scope.currentCustomFilter === mainOrder) {
        if ($scope.staysOrderBy[0].substring(0, 1) === "-") {
          $scope.orderType = "+";
          $scope.staysOrderBy.splice(0, 1, mainOrder);
        } else {
          $scope.orderType = "-";
          $scope.staysOrderBy.splice(0, 1, "-" + mainOrder);
        }
      } else {
        if ($scope.currentCustomFilter) {
          $scope.staysOrderBy.splice(0, 1, mainOrder);
        } else {
          $scope.staysOrderBy.unshift(mainOrder);
        }
        $scope.orderType = "+";
      }
      $scope.currentCustomFilter = mainOrder;
      return $scope.debouncedRecomputeOrderedList();
    };
    patientsById = {};
    medPlanByStayId = {};
    $scope.nbShowItems = 80;
    $scope.incremental_items = 20;
    medicalunits_dict = {};
    sector_dict = {};
    entities_dict = {};
    alreadyFetchedStatus = [];
    if ($state.current.name === "user.export_pdf") {
      $scope.exportPdfMode = true;
    } else {
      $scope.exportPdfMode = false;
    }
    $scope.selectStay = function(stayId, patientId, state, event) {
      var goTo, hasPancarte, modal_done, params, url;
      hasPancarte = _.find($rootScope.user.userFeatures, {
        "name": "MHC_SUMMARY"
      });
      if ($rootScope.mh_config.platform === "mhsi") {
        params = {
          idStay: stayId,
          idPatient: patientId
        };
        if (state === "PRE" && _.find($rootScope.user.userFeatures, {
          "name": "MHC_PREAD"
        })) {
          goTo = 'user.patient.stay.pread';
        } else if ($rootScope.user.group.data.HISTORIC_HAS_DEFAULT || !hasPancarte) {
          goTo = 'user.patient.stay.dashboard';
        } else {
          goTo = 'user.patient.stay.summary';
        }
        if (event && event.ctrlKey) {
          url = $state.href(goTo, params);
          window.open(url, '_blank');
          return true;
        } else {
          return $state.go(goTo, params);
        }
      } else {
        modal_done = $q.defer();
        if (indexOf.call($scope.user.group.features, "SEQUENCE_REALIZATION_TIMESTAMP") < 0) {
          modal_done.resolve(true);
        } else {
          SequenceRealization.api.hasActiveSequenceRealization({
            'user': $scope.user.id
          }).$promise.then(function(data) {
            var modal_dialog;
            if (data.result) {
              return modal_done.resolve(true);
            } else {
              modal_dialog = $uibModal.open({
                templateUrl: 'mhbox/views/arrival-timestamp-modal.html',
                controller: 'arrivalTimestampModalCtrl',
                scope: $scope,
                size: "lg",
                backdrop: 'static',
                backdropClass: 'backdrop-modal'
              });
              return modal_dialog.result.then(function(arrivalData) {
                var newSeqRealization;
                if (arrivalData != null) {
                  newSeqRealization = {
                    'user': $scope.user.id,
                    'patient': patientId,
                    'arrival_timestamp': arrivalData.timestamp,
                    'grp': $scope.user.group.id,
                    'is_active': true,
                    'data': {
                      'arrival_comment': arrivalData.comment
                    }
                  };
                  return SequenceRealization.api.save(newSeqRealization).$promise.then(function() {
                    return modal_done.resolve(true);
                  }, function(reason) {
                    var notify, translate;
                    notify = $injector.get('notify');
                    translate = $injector.get("$filter")('translate');
                    return notify({
                      classes: ["alert-danger"]
                    });
                  }, function() {
                    return modal_done.resolve(true);
                  });
                } else {
                  return modal_done.resolve(false);
                }
              });
            }
          });
        }
        return modal_done.promise.then(function(goToMenu) {
          var preadEnabled;
          $window.mgapp.close_keyboard();
          if (goToMenu) {
            preadEnabled = _.find($rootScope.user.userFeatures, {
              "name": "MHC_PREAD"
            });
            if (state === 'PRE' && preadEnabled) {
              return $state.go('user.patient.stay.pread', {
                idStay: stayId,
                idPatient: patientId
              });
            } else {
              return $state.go('user.patient.stay.box-menu', {
                idStay: stayId,
                idPatient: patientId
              });
            }
          } else {
            return $state.go('mhbox-login', {});
          }
        });
      }
    };
    if ($rootScope.mh_config.platform === "mhsi") {
      if ($scope.user.is_superuser || $scope.user.group.features.indexOf("SRV_pac") !== -1) {
        $scope.canManagePatients = true;
      }
    }
    getPds = function() {
      var getPdsPromise;
      getPdsPromise = $q.defer();
      SiteVarsUtils.get('PDS_STAY_LIST', false).then(function(pdsStayList) {
        $scope.showMedPlan = pdsStayList.value;
        if ($scope.showMedPlan) {
          $scope.thesaurusFilters = {
            entries: [],
            events: []
          };
          $scope.thesaurusEntriesFilterChange = function() {
            var entry, i, len, ref1, results;
            _.forEach($scope.thesaurusFilters.events, function(obj) {
              return _.set(obj, 'checked', false);
            });
            $scope.thesaurusFilters.events = [];
            if ($scope.thesaurusFilters.entries.length > 0) {
              $scope.availableEventsFilters = [];
              ref1 = $scope.thesaurusFilters.entries;
              results = [];
              for (i = 0, len = ref1.length; i < len; i++) {
                entry = ref1[i];
                results.push($scope.availableEventsFilters = $scope.availableEventsFilters.concat(entry.entries));
              }
              return results;
            }
          };
          return ThesaurusUtils.getThesaurusCategories({
            code: "medplan_templates"
          }).then(function(thesaurusCategory) {
            return ThesaurusUtils.getThesaurusEntries({
              "category": thesaurusCategory.id
            }, true).then(function(thesaurusEntries) {
              $scope.thesaurusEntries = _.reject(thesaurusEntries, "obsolete");
              return getPdsPromise.resolve();
            });
          });
        } else {
          return getPdsPromise.resolve();
        }
      });
      return getPdsPromise.promise;
    };
    SiteVarsUtils.getImportMethod().then(function(response) {
      return $scope.importMethod = response.import_method;
    });
    SiteVarsUtils.get('ALLOW_PATIENT_CREATION', false).then(function(sitevar) {
      return $scope.canCreate = sitevar['value'];
    });
    SiteVarsUtils.get('ALLOW_PATIENT_IMPORT', false).then(function(sitevar) {
      return $scope.canImport = sitevar['value'];
    });
    $scope.search_text = "";
    $scope.addMoreItems = function() {
      if ($scope.nbShowItems < $scope.stayList.length) {
        return $scope.nbShowItems = $scope.nbShowItems + $scope.incremental_items;
      }
    };
    queries = [MedicalUnit.getMedicalUnits(), Sector.getSectors(), getPds()];
    if (!$scope.user.entity && $rootScope.mh_config.platform === "mhsi") {
      queries.push(Entity.getEntities());
    }
    init = function() {
      return SiteVarsUtils.get("ORDER_BY_WARNING", true).then(function(orderByWarning) {
        if (!orderByWarning.value) {
          $scope.changeOrderBy("patient.full_name");
        }
        return SiteVarsUtils.get("ALLOW_PATIENT_IDENTITY_CHECK", false).then(function(patientIdentityCheck) {
          $scope.allowPatientIdentityCheck = patientIdentityCheck.value;
          return $q.all(queries).then(function(data) {
            var entity, i, j, k, len, len1, len2, medicalunit, ref1, ref2, ref3, sector;
            ref1 = data[1];
            for (i = 0, len = ref1.length; i < len; i++) {
              sector = ref1[i];
              sector_dict[sector.id] = sector;
            }
            if ($rootScope.mh_config.platform === "mhsi") {
              if ($scope.user.entity) {
                $scope.sectors = _.filter(data[1], function(sector) {
                  return sector.entity === $scope.user.entity;
                });
              } else {
                $scope.entities = data[3];
                ref2 = $scope.entities;
                for (j = 0, len1 = ref2.length; j < len1; j++) {
                  entity = ref2[j];
                  entity.LABEL_TITLE = entity.sitevars.LABEL_TITLE;
                  entities_dict[entity.id] = entity;
                }
                $scope.sectors = data[1];
              }
            } else {
              $scope.sectors = data[1];
            }
            $scope.medicalunits = data[0];
            ref3 = $scope.medicalunits;
            for (k = 0, len2 = ref3.length; k < len2; k++) {
              medicalunit = ref3[k];
              medicalunits_dict[medicalunit.id] = medicalunit;
            }
            fetchStays($rootScope.user.filters.stayStates);
            return $scope.initDone = true;
          });
        });
      });
    };
    alertsPromise = $q.defer();
    if ($rootScope.mh_config.platform === "mhsi") {
      Alert.api.query().$promise.then(function(alerts) {
        return alertsPromise.resolve(alertUtils.addCachedConfigsToAlerts(alerts));
      });
    } else {
      alertsPromise.resolve([]);
    }
    fetchStays = function(states) {
      var medPlanByStayPromise, patientsByIdPromise, stayPromise;
      alreadyFetchedStatus = _.concat(alreadyFetchedStatus, states.length > 0 ? states : _.map($scope.stayStatusOptions, "value"));
      $rootScope.busy = true;
      patientsByIdPromise = $q.defer();
      stayPromise = $q.defer();
      medPlanByStayPromise = $q.defer();
      if ($scope.showMedPlan) {
        Medplan.api.query({
          stay_states: states
        }).$promise.then(function(medPlans) {
          var i, len, medPlan;
          for (i = 0, len = medPlans.length; i < len; i++) {
            medPlan = medPlans[i];
            if (medPlanByStayId[medPlan.stay] == null) {
              medPlanByStayId[medPlan.stay] = [];
            }
            medPlanByStayId[medPlan.stay].push(medPlan);
          }
          return medPlanByStayPromise.resolve();
        });
      } else {
        medPlanByStayPromise.resolve();
      }
      Stay.query({
        state: states,
        extra_fields: ["identitovigilance"]
      }).$promise.then(function(stayList) {
        return stayPromise.resolve(stayList);
      });
      Patient.query({
        stay_states: states,
        extra_fields: ["data", "current_alerts"]
      }).$promise.then(function(patients) {
        var i, len, patient;
        for (i = 0, len = patients.length; i < len; i++) {
          patient = patients[i];
          if (patientsById[patient.id] == null) {
            patientsById[patient.id] = patient;
          }
        }
        return patientsByIdPromise.resolve();
      });
      return stayPromise.promise.then(function(stayList) {
        return alertsPromise.promise.then(function(alerts) {
          return medPlanByStayPromise.promise.then(function() {
            return patientsByIdPromise.promise.then(function() {
              var alertsByStay, category, i, j, len, len1, ref1, stay, stayAlert, stayAlertByCategory;
              alertsByStay = _.groupBy(alerts, 'stay');
              for (i = 0, len = stayList.length; i < len; i++) {
                stay = stayList[i];
                stay.alertsByCategory = [];
                stay.alertConfigsIds = [];
                stay.events = alertsByStay[stay.id] || [];
                ref1 = stay.events;
                for (j = 0, len1 = ref1.length; j < len1; j++) {
                  stayAlert = ref1[j];
                  category = stayAlert.config.category;
                  stayAlertByCategory = _.find(stay.alertsByCategory, {
                    category: category.id
                  });
                  if (stayAlertByCategory) {
                    stayAlertByCategory.count += 1;
                  } else {
                    stay.alertsByCategory.push({
                      category: category.id,
                      count: 1,
                      icon: category.icon
                    });
                  }
                }
                stay.alertConfigsIds = _.uniq(_.map(_.map(stay.events, 'config'), 'id'));
                stay.alertCategoriesIds = _.map(stay.alertsByCategory, 'category');
                if (stay.alertsByCategory.length > 0) {
                  stay.eventOrder = 1;
                } else {
                  stay.eventOrder = 0;
                }
                if ($scope.showMedPlan) {
                  stay.medPlans = medPlanByStayId[stay.id] || [];
                  if (stay.medPlans.length > 0) {
                    stay.medical_unit = null;
                  }
                }
                stay.patient = patientsById[stay.patient];
                if (stay.sector) {
                  if (sector_dict[stay.sector] != null) {
                    stay.sector_name = sector_dict[stay.sector].name;
                  } else {
                    Sector.resetCache();
                  }
                }
                if (stay.medical_unit) {
                  if (medicalunits_dict[stay.medical_unit] != null) {
                    stay.medical_unit_name = medicalunits_dict[stay.medical_unit].name;
                  } else {
                    MedicalUnit.resetCache();
                  }
                }
                if (!$scope.user.entity && $rootScope.mh_config.platform === "mhsi") {
                  stay.entity_name = entities_dict[stay.entity].sitevars.LABEL_TITLE;
                }
              }
              $scope.stayList = $scope.stayList.concat(stayList);
              $scope.hasDormantPreadStays = _.find($scope.stayList, {
                state: "PRE",
                is_dormant: true
              });
              $scope.filterRefBySectors();
              $scope.recomputeOrderedList();
              return $rootScope.busy = false;
            });
          });
        });
      });
    };
    $scope.updateStayToPrintList = function(stay) {
      if (stay.toPrint) {
        return $scope.stayToPrintList.push(stay);
      } else {
        if ($scope.stayToPrintList.indexOf(stay) > -1) {
          return $scope.stayToPrintList.splice($scope.stayToPrintList.indexOf(stay), 1);
        }
      }
    };
    $scope.updateStayToArchiveList = function(stay) {
      if (stay.toArchive) {
        return $scope.stayToArchiveList.push(stay);
      } else {
        if ($scope.stayToArchiveList.indexOf(stay) > -1) {
          return $scope.stayToArchiveList.splice($scope.stayToArchiveList.indexOf(stay), 1);
        }
      }
    };
    $scope.printArchiveSelectedStays = function() {
      var i, j, len, len1, params, ref1, ref2, stay;
      if ($scope.stayToPrintList.length > -1) {
        params = {};
        if ($scope.stayToPrintList.length === 1) {
          params["print_now"] = true;
        }
        ref1 = $scope.stayToPrintList;
        for (i = 0, len = ref1.length; i < len; i++) {
          stay = ref1[i];
          Stay.printStay({
            id: stay.id,
            params: params
          }).$promise.then(function(data) {
            stay.printLaunched = true;
            return $scope.stayToPrintList.splice($scope.stayToPrintList.indexOf(stay), 1);
          });
        }
      }
      if ($scope.stayToArchiveList.length > -1) {
        ref2 = $scope.stayToArchiveList;
        for (j = 0, len1 = ref2.length; j < len1; j++) {
          stay = ref2[j];
          params = {};
          Stay.archiveStay({
            id: stay.id,
            params: params
          }).$promise.then(function(data) {
            stay.archiveLaunched = true;
            return $scope.stayToArchiveList.splice($scope.stayToArchiveList.indexOf(stay), 1);
          });
        }
      }
      return alert($filter('translate')("PRINT_ARCHIVE_LAUNCHED_FEEDBACK"));
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      return SiteVarsUtils.get('PDS_STAY_LIST', false).then(function(pdsStayList) {
        var showMedPlan;
        showMedPlan = pdsStayList.value;
        if (!showMedPlan) {
          return Stay.query({
            state: ['PRE', 'ADM']
          }).$promise.then(function(stayList) {
            var stay;
            if (stayList.length === 1) {
              stay = stayList[0];
              return $scope.selectStay(stay.id, stay.patient, stay.state);
            } else {
              init();
              return window.mgapp.on_stay_selection();
            }
          });
        } else {
          init();
          return window.mgapp.on_stay_selection();
        }
      });
    } else {
      return init();
    }
  }]);

}).call(this);

//# sourceMappingURL=stay-list-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StayMovementsCtrl
    * @description
    * # StayMovementsCtrl
    * Controller of Stay movements list
   */
  angular.module('mhclientApp').controller('StayMovementsCtrl', ["$scope", "$state", "$uibModal", "MhConfig", "Patient", "Stay", "$filter", "$window", "User", "SiteVarsUtils", "Sector", "$q", "MedicalUnit", "$rootScope", "Entity", function($scope, $state, $uibModal, MhConfig, Patient, Stay, $filter, $window, User, SiteVarsUtils, Sector, $q, MedicalUnit, $rootScope, Entity) {
    var fetchStays, queries;
    $scope.status = [
      {
        name: $filter('translate')('PREAD'),
        value: 'PRE',
        checked: true
      }, {
        name: $filter('translate')('ACTIVE'),
        value: 'ADM',
        checked: true
      }, {
        name: $filter('translate')('INACTIVE'),
        value: 'I',
        checked: false
      }, {
        name: $filter('translate')('CLOSED'),
        value: 'CLOSE',
        checked: false
      }
    ];
    $scope.nbShowItems = 20;
    $scope.incremental_items = 20;
    $scope.stats_count = null;
    $scope.filtered_stays = [];
    $scope.search_text = "";
    $scope.checkEntries = function() {
      $scope.mode = "entries";
      $scope.end_date = moment().format("YYYY-MM-DD");
      $scope.start_date = (moment().add(-2, 'd')).format("YYYY-MM-DD");
      return $scope.handleStats();
    };
    $scope.checkExits = function() {
      $scope.mode = "exits";
      $scope.end_date = moment().format("YYYY-MM-DD");
      $scope.start_date = (moment().add(-15, 'd')).format("YYYY-MM-DD");
      return $scope.handleStats();
    };
    $scope.addMoreItems = function() {
      if ($scope.nbShowItems < $scope.stay_list.length) {
        return $scope.nbShowItems = $scope.nbShowItems + $scope.incremental_items;
      }
    };
    queries = [MedicalUnit.getMedicalUnits(), Sector.getSectors()];
    if (!$scope.user.entity) {
      queries.push(Entity.getEntities());
    }
    $q.all(queries).then(function(data) {
      var entity, i, j, k, len, len1, len2, medicalunit, ref, ref1, ref2, sector;
      $scope.sector_dict = {};
      $scope.medicalunits_dict = {};
      $scope.entities_dict = {};
      ref = data[1];
      for (i = 0, len = ref.length; i < len; i++) {
        sector = ref[i];
        $scope.sector_dict[sector.id] = sector;
      }
      if ($scope.user.entity) {
        $scope.sectors = _.filter(data[1], function(sector) {
          return sector.entity === $scope.user.entity;
        });
      } else {
        $scope.entities = data[2];
        ref1 = $scope.entities;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          entity = ref1[j];
          $scope.entities_dict[entity.id] = entity;
        }
        $scope.sectors = data[1];
      }
      $scope.medicalunits = data[0];
      ref2 = $scope.medicalunits;
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        medicalunit = ref2[k];
        $scope.medicalunits_dict[medicalunit.id] = medicalunit;
      }
      return fetchStays();
    });
    $scope.entityActiveFilters = [];
    $scope.entityFilterChange = function(entity) {
      if (entity.checked) {
        $scope.entityActiveFilters.push(entity.id);
      } else {
        $scope.entityActiveFilters.splice($scope.entityActiveFilters.indexOf(entity.id), 1);
      }
      if ($scope.entityActiveFilters.length > 0) {
        _.map($scope.sectors, function(sector) {
          if (_.includes($scope.entityActiveFilters, sector.entity)) {
            return sector.hidden = false;
          } else {
            sector.hidden = true;
            sector.checked = false;
            if (_.includes($scope.sectorActiveFilters, sector.id)) {
              return _.pull($scope.sectorActiveFilters, sector.id);
            }
          }
        });
      } else {
        _.map($scope.sectors, function(sector) {
          return sector.hidden = false;
        });
      }
      return $scope.handleStats();
    };
    $scope.medicalunitActiveFilters = [];
    $scope.medicalUnitFilterChange = function(medical_unit) {
      if (medical_unit.checked) {
        $scope.medicalunitActiveFilters.push(medical_unit.id);
      } else {
        $scope.medicalunitActiveFilters.splice($scope.medicalunitActiveFilters.indexOf(medical_unit.id), 1);
      }
      return $scope.handleStats();
    };
    $scope.sectorActiveFilters = [];
    $scope.sectorFilterChange = function(sector) {
      if (sector.checked) {
        $scope.sectorActiveFilters.push(sector.id);
      } else {
        $scope.sectorActiveFilters.splice($scope.sectorActiveFilters.indexOf(sector.id), 1);
      }
      return $scope.handleStats();
    };
    fetchStays = function() {
      var patientsById, patientsByIdPromise;
      $rootScope.busy = true;
      patientsById = {};
      patientsByIdPromise = $q.defer();
      Patient.query().$promise.then(function(patients) {
        var i, len, patient;
        for (i = 0, len = patients.length; i < len; i++) {
          patient = patients[i];
          if (patientsById[patient.id] == null) {
            patientsById[patient.id] = patient;
          }
        }
        return patientsByIdPromise.resolve();
      });
      return Stay.query().$promise.then(function(stay_list) {
        return patientsByIdPromise.promise.then(function() {
          var i, len, patient, stay;
          for (i = 0, len = stay_list.length; i < len; i++) {
            stay = stay_list[i];
            patient = patientsById[stay.patient];
            stay.patient = patient;
            if (stay.patient.sector) {
              stay.sector_name = $scope.sector_dict[stay.patient.sector].name;
            }
            if (stay.medical_unit) {
              stay.medical_unit_name = $scope.medicalunits_dict[stay.medical_unit].name;
            }
            if (!$scope.user.entity) {
              stay.entity_name = $scope.entities_dict[stay.entity].sitevars.LABEL_TITLE;
            }
          }
          $scope.stay_list = $filter('orderBy')(stay_list, ['patient.name', 'si_id'], false);
          $rootScope.busy = false;
          $scope.checkEntries();
          return $scope.$watchGroup(['start_date', 'end_date', 'search_text'], function(value) {
            return $scope.handleStats();
          });
        });
      });
    };
    return $scope.handleStats = function() {
      var check_end_date, check_start_date, has_entity_filters, has_medicalunit_filters, has_sector_filters, i, len, ref, results, stay;
      check_start_date = moment($scope.start_date);
      check_end_date = moment($scope.end_date);
      $scope.stats = 0;
      has_medicalunit_filters = ($scope.medicalunitActiveFilters != null) && $scope.medicalunitActiveFilters.length > 0;
      has_sector_filters = ($scope.sectorActiveFilters != null) && $scope.sectorActiveFilters.length > 0;
      has_entity_filters = ($scope.entityActiveFilters != null) && $scope.entityActiveFilters.length > 0;
      ref = $scope.stay_list;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        stay = ref[i];
        if (has_sector_filters && $scope.sectorActiveFilters.indexOf(stay.patient.sector) === -1) {
          continue;
        }
        if (has_entity_filters && $scope.entityActiveFilters.indexOf(stay.patient.entity) === -1) {
          continue;
        }
        if (has_medicalunit_filters && $scope.medicalunitActiveFilters.indexOf(stay.medical_unit) === -1) {
          continue;
        }
        if ($scope.mode === "entries") {
          if (stay.d_from && (moment(stay.d_from) > check_start_date && moment(stay.d_from) < check_end_date)) {
            results.push($scope.stats += 1);
          } else {
            results.push(void 0);
          }
        } else {
          if (stay.d_to && (moment(stay.d_to) > check_start_date && moment(stay.d_to) < check_end_date)) {
            results.push($scope.stats += 1);
          } else {
            results.push(void 0);
          }
        }
      }
      return results;
    };
  }]);

}).call(this);

//# sourceMappingURL=stay-movements-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:orderEdit
    * @description
    * Directive displaying order edition form
   */
  angular.module("mhclientApp").controller('EditOrderModalCtrl', ["$scope", "$uibModalInstance", "$q", "order", "stay", "patient", "readOnly", "$rootScope", function($scope, $uibModalInstance, $q, order, stay, patient, readOnly, $rootScope) {
    $scope.order = order;
    $scope.stay = stay;
    $scope.patient = patient;
    $scope.readOnly = readOnly;
    $scope.validate = function() {
      var event;
      $rootScope.busy = true;
      event = $scope.$broadcast('validateRequest');
      return $q.all(event.validatePromises || []).then((function(orders) {
        $rootScope.busy = false;
        return $uibModalInstance.close(orders);
      }));
    };
    $scope.showOrder = function() {
      return $scope.$broadcast('$showOrder');
    };
    $scope.validatePendingOrder = function() {
      var event;
      event = $scope.$broadcast('validateRequest', {
        pending: true
      });
      $rootScope.busy = true;
      return $q.all(event.validatePromises || []).then((function(orders) {
        $rootScope.busy = false;
        return $uibModalInstance.close(orders);
      }));
    };
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
  }]);

  angular.module('mhclientApp').directive('orderEdit', function() {
    return {
      require: '^form',
      restrict: 'E',
      templateUrl: 'order/views/edit-order.html',
      scope: {
        order: "=?",
        isCatalogVisible: "=?",
        canBeSaved: '=?',
        stay: "=",
        readOnly: "=",
        patient: "="
      },
      controller: ["$scope", "$state", "$rootScope", "Order", "OrderedArticles", "$locale", "$filter", "MhConfig", "$uibModal", function($scope, $state, $rootScope, Order, OrderedArticles, $locale, $filter, MhConfig, $uibModal) {
        var groupOrderedArticles, isAnyArticleWithOrdonnanceRequired, isAnyKitWithOrdonnanceRequired, isKitNotValid, isOrdonnanceRequired, isValidationRequired, ref, sendOrder;
        $scope.entityId = $scope.stay.entity || ((ref = $scope.patient.entity) != null ? ref.id : void 0);
        $scope.sectorId = $scope.stay.sector;
        $scope.updatePrice = function() {
          $scope.isOrdonnanceRequired = isOrdonnanceRequired();
          $scope.order.totalPrice = Order.calculatePrice($scope.order, "quantity");
          if ($scope.order.is_reassort) {
            $scope.order.can_valid = !isValidationRequired(_.filter($scope.order.articles, "quantity"), _.filter($scope.order.kits, "quantity"));
          }
          if ($scope.order.is_initial) {
            return $scope.order.intialPrice = Order.calculatePrice($scope.order, "initialQuantity");
          }
        };
        isKitNotValid = function(kit) {
          var articlesQuantitiesBeenModified;
          articlesQuantitiesBeenModified = _.find(kit.kit_articles, function(article) {
            return article.quantity > article.originalQuantity;
          });
          return (kit.quantity > kit.originalQuantity) || articlesQuantitiesBeenModified;
        };
        isValidationRequired = function(articles, kits) {
          return _.some(articles, function(a) {
            return !a.isType;
          }) || _.some(kits, function(k) {
            return !k.isType;
          }) || _.some(articles, function(a) {
            return a.quantity > a.originalQuantity;
          }) || _.some(kits, isKitNotValid);
        };
        isAnyArticleWithOrdonnanceRequired = function(articles) {
          return _.some(articles, function(article) {
            return !article.article.deleted && article.article.need_ordonnance;
          });
        };
        isAnyKitWithOrdonnanceRequired = function(kits) {
          return _.some(kits, function(kit) {
            return isAnyArticleWithOrdonnanceRequired(_.filter(kit.kit_articles, "quantity"));
          });
        };
        isOrdonnanceRequired = function() {
          return isAnyArticleWithOrdonnanceRequired(_.filter($scope.order.articles, "quantity")) || isAnyArticleWithOrdonnanceRequired(_.filter($scope.order.articles, "initialQuantity")) || isAnyKitWithOrdonnanceRequired($scope.order.kits);
        };
        $scope.urgentModeChange = function() {
          return $scope.order.request_at = $scope.order.is_urgent ? null : Order.getNextDeliveryDate($scope.stay);
        };
        groupOrderedArticles = function() {
          if ($scope.order.is_reassort) {
            $scope.groupedTypeArticles = _.groupBy(_.filter($scope.order.articles, 'isType'), 'article.category');
            $scope.groupedTypeKits = _.groupBy(_.filter($scope.order.kits, 'isType'), 'category');
            $scope.groupedArticles = _.groupBy(_.filter($scope.order.articles, function(a) {
              return !a.isType;
            }), 'article.category');
            $scope.groupedKits = _.groupBy(_.filter($scope.order.kits, function(k) {
              return !k.isType;
            }), 'category');
            $scope.groupedTypeArticles = !Object.keys($scope.groupedTypeArticles).length ? null : $scope.groupedTypeArticles;
            $scope.groupedTypeKits = !Object.keys($scope.groupedTypeKits).length ? null : $scope.groupedTypeKits;
          } else {
            $scope.groupedArticles = _.groupBy($scope.order.articles, 'article.category');
            $scope.groupedKits = _.groupBy($scope.order.kits, 'category');
          }
          $scope.groupedArticles = !Object.keys($scope.groupedArticles).length ? null : $scope.groupedArticles;
          return $scope.groupedKits = !Object.keys($scope.groupedKits).length ? null : $scope.groupedKits;
        };
        $scope.$on('$articleUpdated', function(event, data) {
          return $scope.updatePrice();
        });
        $scope.$on('$kitUpdated', function(event, data) {
          return $scope.updatePrice();
        });
        $scope.$on('validateRequest', function(event, data) {
          return event.validatePromises = $scope.update(data != null ? data.pending : void 0);
        });
        sendOrder = function(order, pending, quantityField) {
          if (pending) {
            order.state = "PN";
          } else if (order.id) {
            order.state = "PE";
          }
          if (order.order_type) {
            delete order.request_at;
          } else if (order.request_at && typeof order.request_at !== 'string') {
            order.request_at.setHours(12);
          }
          order.articles = _.map(_.filter(order.articles, quantityField), function(a) {
            return {
              article: a.article.id,
              quantity: a[quantityField],
              comment: a.comment
            };
          });
          order.kits = _.map(_.filter(order.kits, quantityField), function(k) {
            return {
              kit: k.kit,
              quantity: k[quantityField],
              comment: k.comment,
              kit_articles: _.map(_.filter(k.kit_articles, "quantity"), function(a) {
                return {
                  article: a.article.id,
                  quantity: a.quantity
                };
              })
            };
          });
          order.kits = _.filter(order.kits, function(k) {
            return k.kit_articles.length;
          });
          if (order.id) {
            order.order = order.id;
            return OrderedArticles.api.update(order).$promise;
          } else {
            order.timestamp = new Date().toISOString();
            return OrderedArticles.api.save(order).$promise;
          }
        };
        $scope.update = function(pending) {
          var initialOrder, promises;
          delete $scope.order.ext_id;
          promises = [];
          if ($scope.order.is_initial && $scope.order.sendPuiSignal) {
            initialOrder = _.cloneDeep($scope.order);
            delete initialOrder.order_type;
            delete initialOrder.catalog;
            promises.push(sendOrder(initialOrder, pending, "initialQuantity"));
          }
          if ($scope.order.is_initial) {
            delete $scope.order.comment;
          }
          delete $scope.order.is_initial;
          promises.push(sendOrder($scope.order, pending, "quantity"));
          return promises;
        };
        $scope.showCatalog = function() {
          return $scope.isCatalogVisible = true;
        };
        $scope.$on('$showOrder', function(event) {
          $scope.isCatalogVisible = false;
          groupOrderedArticles();
          return $scope.updatePrice();
        });
        $scope.isCatalogVisible = !$scope.order.id && !$scope.order.is_reassort;
        if (!$scope.isCatalogVisible) {
          groupOrderedArticles();
          $scope.updatePrice();
        }
        return $scope.$watch(function() {
          var canSave;
          canSave = $scope.order && !!($scope.order.totalPrice || $scope.order.articles.length || $scope.order.kits.length);
          return $scope.canBeSaved = canSave && ($scope.createOrderForm != null) && $scope.createOrderForm.$valid;
        });
      }]
    };
  });

  angular.module('mhclientApp').directive('articlesEdit', function() {
    return {
      require: '^form',
      restrict: 'E',
      templateUrl: 'order/views/articles-edit.html',
      scope: {
        isReassort: "=?",
        groupedArticles: '=',
        isInitial: "=",
        readOnly: "="
      },
      controller: ["$rootScope", "$scope", "$q", "Group", "Message", "Thread", "Upload", function($rootScope, $scope, $q, Group, Message, Thread, Upload) {
        var actions, actions_reassort, comment, designation, i, initial_quantity, price, quantity, quantity_type, results, typed_quantity;
        $scope.resetQuantity = function(article) {
          article.quantity = article.originalQuantity;
          return $scope.$emit("$articleUpdated");
        };
        $scope.removeArticle = function(article) {
          article.quantity = 0;
          return $scope.$emit("$articleUpdated");
        };
        $scope.setInitialQuantity = function(article, quantity) {
          article.initialQuantity = quantity;
          return $scope.$emit("$articleUpdated");
        };
        $scope.setQuantity = function(article, quantity) {
          article.quantity = quantity;
          return $scope.$emit("$articleUpdated");
        };
        $scope.quantitiesRange = (function() {
          results = [];
          for (i = 0; i <= 28; i++){ results.push(i); }
          return results;
        }).apply(this);
        designation = {
          "label": "DESIGNATION",
          "type": "designation"
        };
        initial_quantity = {
          "label": "INITIAL_QUANTITY",
          "type": "initial_quantity"
        };
        typed_quantity = {
          "label": "SHORT_TYPE_QUANTITY",
          "type": "typed_quantity"
        };
        quantity = {
          "label": "QUANTITY",
          "type": "quantity"
        };
        quantity_type = {
          "label": "TYPE_QUANTITY",
          "type": "quantity"
        };
        price = {
          "label": "UNIT_PRICE",
          "type": "price"
        };
        comment = {
          "label": "COMMENT",
          "type": "comment"
        };
        actions = {
          "label": "",
          "type": "actions",
          "actions": [
            {
              "callBack": $scope.removeArticle,
              "class": "glyphicon glyphicon-remove-sign"
            }
          ]
        };
        actions_reassort = {
          "label": "",
          "type": "actions",
          "actions": [
            {
              "callBack": $scope.resetQuantity,
              "class": "glyphicon glyphicon-erase"
            }, {
              "callBack": $scope.removeArticle,
              "class": "glyphicon glyphicon-remove-sign"
            }
          ]
        };
        if ($scope.isInitial) {
          return $scope.cols = _.concat($scope.readOnly ? [designation, initial_quantity, typed_quantity, price] : [designation, initial_quantity, quantity_type, price], $scope.readOnly ? [] : [actions]);
        } else if ($scope.isReassort) {
          return $scope.cols = _.concat([designation, typed_quantity, quantity, comment], $scope.readOnly ? [] : [actions_reassort]);
        } else {
          return $scope.cols = _.concat([designation, quantity, price, comment], $scope.readOnly ? [] : [actions]);
        }
      }]
    };
  });

  angular.module('mhclientApp').directive('kitsEdit', function() {
    return {
      require: '^form',
      restrict: 'E',
      templateUrl: 'order/views/kits-edit.html',
      scope: {
        isReassort: "=?",
        groupedKits: '=',
        isInitial: "=",
        readOnly: "="
      },
      controller: ["$rootScope", "$scope", "$q", "Group", "Message", "Thread", "Upload", function($rootScope, $scope, $q, Group, Message, Thread, Upload) {
        var actions, actions_reassort, articleDesignation, designation, i, inKitQuantity, initial_quantity, price, quantity, quantity_type, results, total_initial_quantity, total_quantity, total_type_quantity, typed_quantity;
        $scope.resetKit = function(kit) {
          kit.quantity = kit.originalQuantity;
          return $scope.$emit("$kitUpdated");
        };
        $scope.removeKit = function(kit) {
          kit.quantity = 0;
          return $scope.$emit("$kitUpdated");
        };
        $scope.setInitialQuantity = function(kit, quantity) {
          kit.initialQuantity = quantity;
          return $scope.$emit("$kitUpdated");
        };
        $scope.setQuantity = function(item, quantity) {
          item.quantity = quantity;
          return $scope.$emit("$kitUpdated");
        };
        $scope.changeArticleChoice = function(article) {
          article.quantity = article.quantity > 0 ? 0 : article.originalQuantity;
          return $scope.$emit("$kitUpdated");
        };
        $scope.quantitiesRange = (function() {
          results = [];
          for (i = 0; i <= 28; i++){ results.push(i); }
          return results;
        }).apply(this);
        designation = {
          "label": "NAME",
          "type": "designation"
        };
        articleDesignation = {
          "label": "DESIGNATION",
          "type": "designation"
        };
        initial_quantity = {
          "label": "INITIAL_QUANTITY",
          "type": "initial_quantity"
        };
        typed_quantity = {
          "label": "SHORT_TYPE_QUANTITY",
          "type": "typed_quantity"
        };
        quantity = {
          "label": "QUANTITY",
          "type": "quantity"
        };
        inKitQuantity = {
          "label": "QUANTITY",
          "type": "inKitQuantity"
        };
        total_quantity = {
          "label": "TOTAL_QUANTITY",
          "type": "total_quantity"
        };
        quantity_type = {
          "label": "TYPE_QUANTITY",
          "type": "quantity"
        };
        total_initial_quantity = {
          "label": "TOTAL_INITIAL_QUANTITY",
          "type": "total_initial_quantity"
        };
        total_type_quantity = {
          "label": "TOTAL_TYPE_QUANTITY",
          "type": "total_quantity"
        };
        price = {
          "label": "UNIT_PRICE",
          "type": "price"
        };
        actions = {
          "label": "",
          "type": "actions",
          "actions": [
            {
              "callBack": $scope.removeKit,
              "class": "glyphicon glyphicon-remove-sign"
            }
          ]
        };
        actions_reassort = {
          "label": "",
          "type": "actions",
          "actions": [
            {
              "callBack": $scope.resetKit,
              "class": "glyphicon glyphicon-erase"
            }, {
              "callBack": $scope.removeKit,
              "class": "glyphicon glyphicon-remove-sign"
            }
          ]
        };
        if ($scope.isInitial) {
          $scope.cols = _.concat($scope.readOnly ? [designation, initial_quantity, typed_quantity, price] : [designation, initial_quantity, quantity_type, price], $scope.readOnly ? [] : [actions]);
          return $scope.articleCols = [articleDesignation, price, inKitQuantity, total_initial_quantity, total_type_quantity];
        } else if ($scope.isReassort) {
          $scope.cols = _.concat([designation, typed_quantity, quantity], $scope.readOnly ? [] : [actions_reassort]);
          return $scope.articleCols = [articleDesignation, quantity, total_quantity];
        } else {
          $scope.cols = _.concat([designation, quantity, price], $scope.readOnly ? [] : [actions]);
          return $scope.articleCols = [articleDesignation, price, quantity, total_quantity];
        }
      }]
    };
  });

}).call(this);

//# sourceMappingURL=order-edit-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:orderList
    * @description
    * Directive displaying the list of orders
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').directive('orderList', function() {
    return {
      restrict: 'E',
      templateUrl: 'order/views/orders-list.html',
      scope: {
        stay: '=',
        patient: '=',
        disableKitEditionRedirect: "="
      },
      controller: 'OrderListCtrl'
    };
  });

  angular.module('mhclientApp').controller('OrderListCtrl', ["$scope", "$q", "$rootScope", "Order", "Catalog", "SiteVar", "$locale", "$filter", "SiteVarsUtils", "$uibModal", "FeatureUtils", "notify", function($scope, $q, $rootScope, Order, Catalog, SiteVar, $locale, $filter, SiteVarsUtils, $uibModal, FeatureUtils, notify) {
    var appendOrders, fillReassort, getOrders, init, initArticles, initKits, initReassortOrder, refreshNextOrderToBeDelivered;
    $rootScope.removePatientMenu = false;
    $scope.canWrite = $rootScope.checkPermissions("MHC_ORDERS", "CAN_WRITE");
    FeatureUtils.getAllFeatures().then(function(features) {
      return SiteVarsUtils.get("CAN_LIBERAL_CREATE_CUSTOM_ORDER").then(function(sitevar) {
        var customOrderFeature;
        $scope.canCreateNonReassortOrder = !sitevar.value && !$rootScope.user.group.liberal || sitevar.value;
        if ($scope.canCreateNonReassortOrder) {
          customOrderFeature = _.find(_.filter(features, "active"), {
            "name": "NEW_CUSTOM_ORDER"
          });
          if (customOrderFeature) {
            return $scope.canCreateNonReassortOrder = indexOf.call($rootScope.user.group.features, "NEW_CUSTOM_ORDER") >= 0;
          }
        }
      });
    });
    init = function() {
      if (angular.isNumber(Order.getDeliveryDay($scope.stay))) {
        $scope.deliveryDay = $locale.DATETIME_FORMATS.DAY[Order.getDeliveryDay($scope.stay)];
      } else {
        $scope.deliveryDay = void 0;
      }
      $scope.max_size = 40;
      $scope.ordersList = [];
      $scope.canSeeMore = false;
      $scope.canValidate = indexOf.call($rootScope.user.group.features, "MHC_ORDERS_VALIDATE") >= 0;
      $scope.currentPage = 1;
      $scope.canEditKit = $rootScope.mh_config.platform === 'mhsi' && indexOf.call($rootScope.user.group.features, "MHC_KIT_EDIT") >= 0;
      $scope.canCreateOrderWithoutType = false;
      SiteVar.get({
        name: "ORDER_TYPE_REQUIRE"
      }).$promise.then(function(siteVar) {
        return $scope.canCreateOrderWithoutType = !siteVar.value;
      });
      Catalog.query({
        sector: $scope.stay.sector,
        entity: $scope.stay.entity
      }).$promise.then(function(catalogs) {
        return Order.api.query({
          order_type: true,
          serializer: "mediumSerializer",
          patient: $scope.patient.id,
          entity: $scope.stay.entity
        }).$promise.then(function(list) {
          var stayRelatedTypeOrders;
          $scope.catalogs = catalogs;
          $scope.allTypeOrders = list.results;
          stayRelatedTypeOrders = _.filter($scope.allTypeOrders, function(order) {
            order.catalog = _.find(catalogs, {
              id: order.catalog
            });
            return order.catalog;
          });
          if (stayRelatedTypeOrders.length > 0) {
            return $scope.orderType = stayRelatedTypeOrders[0];
          }
        });
      });
      return getOrders();
    };
    $scope.validateOrder = function(order) {
      $scope.isBusyRequesting = true;
      return Order.api.validate({
        id: order.id,
        route: 'validate'
      }).$promise.then(function() {
        return Order.api.get({
          id: order.id
        }).$promise.then(function(updatedOrder) {
          angular.copy(updatedOrder, order);
          return refreshNextOrderToBeDelivered();
        });
      })["finally"](function() {
        return $scope.isBusyRequesting = false;
      });
    };
    $scope.saveComment = function(order) {
      $scope.isBusyRequesting = true;
      return Order.api.saveComment({
        id: order.id,
        followup_comment: order.followup_comment,
        route: 'save_comment'
      }).$promise.then(function() {
        return Order.api.get({
          id: order.id
        }).$promise.then(function(updatedOrder) {
          angular.copy(updatedOrder, order);
          notify({
            classes: ['alert-info'],
            message: $filter('translate')("COMMENT_SAVED")
          });
          return $scope.isBusyRequesting = false;
        });
      });
    };
    $scope.cancelOrder = function(order) {
      $scope.isBusyRequesting = true;
      return Order.api.cancel({
        id: order.id,
        route: 'cancel'
      }).$promise.then(function() {
        return Order.api.get({
          id: order.id
        }).$promise.then(function(updatedOrder) {
          angular.copy(updatedOrder, order);
          return refreshNextOrderToBeDelivered();
        });
      })["finally"](function() {
        return $scope.isBusyRequesting = false;
      });
    };
    $scope.seeMore = function() {
      $scope.currentPage++;
      return getOrders();
    };
    getOrders = function() {
      var tmpIsBusyRequesting;
      $scope.isBusyRequesting = true;
      tmpIsBusyRequesting = true;
      Order.api.query({
        serializer: "mediumSerializer",
        patient: $scope.patient.id,
        page_size: $scope.max_size,
        page: $scope.currentPage,
        entity: $scope.stay.entity,
        order_type: false,
        state: "-PN"
      }).$promise.then(function(rslt) {
        appendOrders(rslt);
        if (tmpIsBusyRequesting) {
          return tmpIsBusyRequesting = false;
        } else {
          return $scope.isBusyRequesting = false;
        }
      });
      return Order.api.query({
        patient: $scope.patient.id,
        serializer: "mediumSerializer",
        entity: $scope.stay.entity,
        state: "PN"
      }).$promise.then(function(pendingOrders) {
        return $scope.pendingOrders = pendingOrders.results;
      })["finally"](function() {
        if (tmpIsBusyRequesting) {
          return tmpIsBusyRequesting = false;
        } else {
          return $scope.isBusyRequesting = false;
        }
      });
    };
    refreshNextOrderToBeDelivered = function() {
      $scope.nextOrderToBeDelivered = Order.getNextOrderToBeDelivered($scope.ordersList);
      return $scope.nextDeliveryDate = $scope.nextOrderToBeDelivered.delivery_at || $scope.nextOrderToBeDelivered.request_at;
    };
    appendOrders = function(orders) {
      $scope.canSeeMore = !!orders.next;
      $scope.ordersList = $scope.ordersList.concat(orders.results);
      return refreshNextOrderToBeDelivered();
    };
    initArticles = function(articles, initialQuantitiesNull, isType) {
      return _.forEach(articles, function(article) {
        article.isType = article.isType || isType || false;
        article.originalQuantity = article.originalQuantity || article.quantity;
        return article.quantity = initialQuantitiesNull || article.article.deleted ? 0 : article.quantity;
      });
    };
    initKits = function(kits, initialQuantitiesNull, isType) {
      return _.forEach(kits, function(kit) {
        kit.isType = kit.isType || isType || false;
        kit.originalQuantity = kit.originalQuantity || kit.quantity;
        kit.quantity = initialQuantitiesNull ? 0 : kit.quantity;
        kit.hasDeletedArticle = _.some(kit.kit_articles, 'article.deleted');
        kit.computed_price = 0;
        return _.forEach(kit.kit_articles, function(article) {
          kit.computed_price += article.quantity * article.article.unit_price;
          article.originalQuantity = article.originalQuantity || article.quantity;
          return article.quantity = initialQuantitiesNull || article.article.deleted ? 0 : article.quantity;
        });
      });
    };
    initReassortOrder = function(orderType) {
      return SiteVarsUtils.getValue("REASSORT_QUANTITY_NULL", false).then(function(initialQuantitiesNull) {
        return Order.api.get({
          id: orderType.id
        }).$promise.then(function(order) {
          delete order.id;
          delete order.order_type;
          delete order.state;
          delete order.catalog;
          order.stay = $scope.stay.id;
          order.is_reassort = true;
          order.request_at = Order.getNextDeliveryDate($scope.stay);
          initArticles(order.articles, initialQuantitiesNull, true);
          initKits(order.kits, initialQuantitiesNull, true);
          return order;
        });
      });
    };
    $scope.openNewOrderModal = function(orderMode) {
      $rootScope.busy = true;
      $rootScope.lockMenu(true);
      return $q.when({
        'orderType': function() {
          return {
            order_type: true,
            catalog: $scope.catalogs[0].id
          };
        },
        'initialAndType': function() {
          return {
            order_type: true,
            catalog: $scope.catalogs[0].id,
            is_initial: true,
            sendPuiSignal: true,
            deliveryDay: $scope.deliveryDay
          };
        },
        'reassort': initReassortOrder,
        'withoutType': function() {
          return {};
        }
      }[orderMode]($scope.orderType)).then(function(order) {
        var newOrderModal;
        $rootScope.busy = false;
        newOrderModal = $uibModal.open({
          templateUrl: 'order/views/edit-order-modal.html',
          controller: 'EditOrderModalCtrl',
          windowClass: 'modal-fullscreen',
          backdrop: 'static',
          resolve: {
            stay: $scope.stay,
            patient: $scope.patient,
            readOnly: false,
            order: _.extend({
              articles: [],
              kits: [],
              stay: $scope.stay.id,
              author: $rootScope.user.id
            }, order)
          }
        });
        newOrderModal.closed.then(function() {
          return $rootScope.lockMenu(false);
        });
        return newOrderModal.result.then(function(orders) {
          var i, len, results;
          results = [];
          for (i = 0, len = orders.length; i < len; i++) {
            order = orders[i];
            if (order.order_type) {
              $scope.orderType = order;
              results.push($scope.allTypeOrders.push(order));
            } else if (order.state === "PN") {
              results.push($scope.pendingOrders.push(order));
            } else {
              results.push($scope.ordersList.push(order));
            }
          }
          return results;
        });
      });
    };
    fillReassort = function(order, reasortOrder) {
      var searchArticles;
      searchArticles = function(source, origin) {
        return _.forEach(source, function(article) {
          var reassortArticle;
          reassortArticle = _.find(origin, {
            article: {
              id: article.article.id
            }
          });
          if (reassortArticle) {
            article.isType = true;
            return article.originalQuantity = reassortArticle.quantity;
          }
        });
      };
      searchArticles(order.articles, reasortOrder.articles);
      return _.forEach(order.kits, function(kit) {
        var reassortKit;
        reassortKit = _.find(reasortOrder.kits, {
          kit: kit.kit
        });
        if (reassortKit) {
          kit.isType = true;
          kit.originalQuantity = reassortKit.quantity;
          return searchArticles(kit.kit_articles, reassortKit.kit_articles);
        }
      });
    };
    $scope.openEditOrderModal = function(orderToModify, readOnly) {
      $rootScope.busy = true;
      $rootScope.lockMenu(true);
      return Order.api.get({
        id: orderToModify.id
      }).$promise.then(function(order) {
        return $q.all(order.is_reassort || order.is_initial ? _.map($scope.allTypeOrders, function(typeOrder) {
          return Order.api.get({
            id: typeOrder.id
          }).$promise;
        }) : []).then(function(typeOrders) {
          var editOrderModal;
          if (order.is_reassort || order.is_initial) {
            _.forEach(typeOrders, function(orderType) {
              return fillReassort(order, orderType);
            });
          }
          initArticles(order.articles);
          initKits(order.kits);
          $rootScope.busy = false;
          editOrderModal = $uibModal.open({
            templateUrl: 'order/views/edit-order-modal.html',
            controller: 'EditOrderModalCtrl',
            windowClass: 'modal-fullscreen',
            backdrop: 'static',
            resolve: {
              order: order,
              stay: $scope.stay,
              patient: $scope.patient,
              readOnly: readOnly || false
            }
          });
          editOrderModal.closed.then(function() {
            return $rootScope.lockMenu(false);
          });
          return editOrderModal.result.then(function(orders) {
            var oldState;
            oldState = orderToModify.state;
            _.assign(orderToModify, orders[0]);
            if (oldState === 'PN' && orderToModify.state !== 'PN') {
              _.remove($scope.pendingOrders, orderToModify);
              return $scope.ordersList.push(orderToModify);
            }
          });
        });
      });
    };
    $scope.openPreparationsOrderModal = function(order) {
      $rootScope.busy = true;
      return Order.api.get({
        id: order.id
      }).$promise.then(function(detailOrder) {
        var detailsOrderModal;
        $rootScope.busy = false;
        return detailsOrderModal = $uibModal.open({
          templateUrl: 'order/views/order-preparations-modal.html',
          controller: 'OrderPreparationsModalCtrl',
          windowClass: 'modal-fullscreen',
          backdrop: 'static',
          resolve: {
            order: function() {
              return detailOrder;
            }
          }
        });
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=order-list-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Order
    * @description
    * # Order
    * Order Service
   */
  angular.module("mhclientApp").factory('Order', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, calculatePrice, dateHelper, getDeliveryDay, getNextDeliveryDate, getNextOrderToBeDelivered, order, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/orders/:id/:route', {}, {
      query: {
        method: 'GET',
        params: {
          patient: '@patient',
          page: '@page',
          order_type: '@order_type'
        }
      },
      validate: {
        method: 'PUT',
        params: {
          id: '@id',
          route: '@route'
        }
      },
      saveComment: {
        method: 'PUT',
        params: {
          id: '@id',
          route: '@route'
        }
      },
      cancel: {
        method: 'PUT',
        params: {
          id: '@id',
          route: '@route'
        }
      },
      get: {
        method: 'get',
        params: {
          id: '@id',
          order_type: '@order_type'
        }
      },
      'getLastDelivered': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'GET',
        params: {
          route: 'get_last_delivered'
        }
      }
    });
    dateHelper = {
      dayCountBetween: function(initialDay, nextDay) {
        return (nextDay - initialDay + 6) % 7 + 1;
      },
      addDay: function(date, day) {
        return new Date(date.getTime() + day * 86400000);
      }
    };
    getNextOrderToBeDelivered = function(orders) {
      var ret, tmp;
      tmp = _.filter(orders, function(o) {
        return (o.state === 'VA' || o.state === 'DP') && (o.delivery_at || o.request_at);
      });
      ret = _.minBy(tmp, function(o) {
        var date;
        date = o.delivery_at || o.request_at;
        if (date) {
          return new Date(date).getTime();
        }
      });
      return ret || {};
    };
    calculatePrice = function(order, checkKey) {
      var article, i, j, k, kit, kit_total, len, len1, len2, ref, ref1, ref2, ref3, total, unit_price;
      total = 0;
      checkKey = checkKey || "quantity";
      ref = order.articles;
      for (i = 0, len = ref.length; i < len; i++) {
        article = ref[i];
        unit_price = article.unit_price;
        if (unit_price == null) {
          unit_price = ((ref1 = article.article) != null ? ref1.unit_price : void 0) || 0;
        }
        total += unit_price * article[checkKey];
      }
      ref2 = order.kits;
      for (j = 0, len1 = ref2.length; j < len1; j++) {
        kit = ref2[j];
        kit_total = 0;
        ref3 = kit.kit_articles;
        for (k = 0, len2 = ref3.length; k < len2; k++) {
          article = ref3[k];
          kit_total += article.article.unit_price * article.quantity;
        }
        total += kit_total * kit[checkKey];
      }
      return total;
    };
    getDeliveryDay = function(stay) {
      var order_data;
      order_data = stay.order_data;
      if (typeof order_data === 'undefined' || typeof order_data.delivery_day === 'undefined') {
        return "UNDEFINED";
      } else {
        return order_data.delivery_day;
      }
    };
    getNextDeliveryDate = function(stay) {
      var currentDate, currentDay, dayToAdd, deliveryDay;
      currentDate = new Date();
      currentDay = currentDate.getDay();
      deliveryDay = getDeliveryDay(stay);
      if (deliveryDay === "UNDEFINED") {
        deliveryDay = moment().add(1, 'days').day();
      }
      if (deliveryDay > 5 || deliveryDay === 0) {
        deliveryDay = 1;
      }
      dayToAdd = dateHelper.dayCountBetween(currentDay, deliveryDay);
      return dateHelper.addDay(currentDate, dayToAdd);
    };
    service = {
      calculatePrice: calculatePrice,
      dateHelper: dateHelper,
      getDeliveryDay: getDeliveryDay,
      getNextDeliveryDate: getNextDeliveryDate,
      getNextOrderToBeDelivered: getNextOrderToBeDelivered
    };
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
        break;
      case 'mgapp':
        order = window.mgapp.get('order_mgr').order();
        service.api = BoxResource.generate(order);
        service.api.getLastDelivered = function(object) {
          return BoxResource.mhboxApiCall(order, "get_last_delivered", object);
        };
    }
    return service;
  }]);

}).call(this);

//# sourceMappingURL=order-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:OrderedArticles
    * @description
    * # OrderedArticles
   */
  angular.module("mhclientApp").factory('OrderedArticles', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, orderedarticles, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ';version=v1';
    portailAPI = $resource('/api_rest/orderedarticles', {}, {
      save: {
        headers: {
          Accept: acceptHeader
        },
        method: 'POST'
      },
      update: {
        method: 'PUT',
        isArray: false
      }
    });
    service = {};
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
        break;
      case 'mgapp':
        orderedarticles = window.mgapp.get('order_mgr').ordered_article();
        service.api = BoxResource.generate(orderedarticles);
    }
    return service;
  }]);

}).call(this);

//# sourceMappingURL=ordered-articles-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:orderPreparations
    * @description
    * Directive displaying order preparations
   */
  angular.module("mhclientApp").controller('OrderPreparationsModalCtrl', ["$scope", "$uibModalInstance", "$q", "order", "$rootScope", function($scope, $uibModalInstance, $q, order, $rootScope) {
    $scope.order = angular.copy(order);
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
  }]);

  angular.module('mhclientApp').directive('orderPreparations', function() {
    return {
      restrict: 'E',
      templateUrl: 'order/views/order-preparations.html',
      scope: {
        order: "=",
        displayBackButton: "=?"
      },
      controller: 'OrderPreparationsCtrl'
    };
  });

  angular.module('mhclientApp').controller('OrderPreparationsCtrl', ["$rootScope", "$scope", "$stateParams", "Order", "$state", function($rootScope, $scope, $stateParams, Order, $state) {
    var init, mgappCloseRequest;
    $scope.canWrite = $rootScope.checkPermissions("MHC_ORDERS", "CAN_WRITE");
    init = function() {
      if ($rootScope.mh_config.platform === "mgapp") {
        window.mgappClose = mgappCloseRequest;
        return window.mgappConfirmQuit = window.mgapp.quit_view;
      }
    };
    mgappCloseRequest = function() {
      if ($scope.previousState != null) {
        return $state.go($scope.previousState.name);
      } else {
        return $state.go('user.patient.stay.order.list');
      }
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=order-preparations-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:CatalogCategory
    * @description
    * # CatalogCategory
    * Provider of CatalogCategory
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").factory('Catalog', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/catalogs', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        return BoxResource.generate(window.mgapp.get('order_mgr').catalog());
    }
  }]);

  angular.module("mhclientApp").factory('CatalogCategory', ["$resource", "MhConfig", "$q", "BoxResource", "SiteVarsUtils", "Articles", function($resource, MhConfig, $q, BoxResource, SiteVarsUtils, Articles) {
    var acceptHeader, api, category, getVisibleCategories, portailAPI, visible_categories;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/categories', {}, {
      query: {
        method: 'GET',
        params: {
          category: '@category'
        },
        headers: {
          Accept: acceptHeader
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        category = window.mgapp.get('order_mgr').category();
        api = BoxResource.generate(category);
    }
    visible_categories = null;
    getVisibleCategories = function() {
      var tmp_categories, visibleCategoriesPromise;
      visibleCategoriesPromise = $q.defer();
      if (visible_categories === null) {
        tmp_categories = [];
        SiteVarsUtils.get("CATALOG_HIDDEN_CATEGORIES", []).then(function(hidden_categories) {
          return api.query().$promise.then(function(categories) {
            var i, len, ref;
            ref = _.filter(categories, function(category) {
              var ref;
              return !(ref = category.name, indexOf.call(hidden_categories.value, ref) >= 0);
            });
            for (i = 0, len = ref.length; i < len; i++) {
              category = ref[i];
              tmp_categories.push(category.name);
            }
            visible_categories = tmp_categories;
            return visibleCategoriesPromise.resolve(visible_categories);
          });
        });
      } else {
        visibleCategoriesPromise.resolve(visible_categories);
      }
      return visibleCategoriesPromise.promise;
    };
    return {
      getVisibleCategories: getVisibleCategories,
      api: api
    };
  }]);

}).call(this);

//# sourceMappingURL=catalog-category-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CatalogCtrl
    * @description
    * # CatalogCtrl
    * Controller of Catalog
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('CatalogCtrl', ["$scope", "Articles", "Kits", "$filter", "$rootScope", "$q", "CatalogCategory", function($scope, Articles, Kits, $filter, $rootScope, $q, CatalogCategory) {
    var addAndSortCategory, appendArticles, appendKits, flushAndAppendArticles, flushAndAppendKits, getArticlesAnd, getCategories, getKitsAnd, handleNewArticles, handleNewKits, i, init, initializeArticleQuantity, initializeKitQuantity, results1;
    $scope.allCategories = $filter('translate')("ALL_CATEGORIES");
    $scope.canWrite = $rootScope.checkPermissions("MHC_ORDERS", "CAN_WRITE");
    $scope.quantitiesRange = (function() {
      results1 = [];
      for (i = 1; i <= 28; i++){ results1.push(i); }
      return results1;
    }).apply(this);
    $scope.user = $rootScope.user;
    $scope.hasData = function() {
      return $scope.catalog && Object.keys($scope.catalog).length || $scope.kits && Object.keys($scope.kits).length;
    };
    $scope.setArticleQuantity = function(item, quantity) {
      item.quantity = quantity;
      return $scope.addArticle(item);
    };
    $scope.addArticle = function(item) {
      if (!~$scope.order.articles.indexOf(item)) {
        item.article = _.pick(item, ['designation', 'deleted', 'need_ordonnance', 'unit_price', 'category', 'id']);
        item.originalQuantity = item.quantity;
        return $scope.order.articles.push(item);
      }
    };
    $scope.setKitQuantity = function(item, quantity) {
      item.quantity = quantity;
      return $scope.addKit(item);
    };
    $scope.addKit = function(item) {
      var article, j, len, ref;
      if (!~$scope.order.kits.indexOf(item)) {
        ref = item.kit_articles;
        for (j = 0, len = ref.length; j < len; j++) {
          article = ref[j];
          article.originalQuantity = article.quantity;
          article.quantity = article.article.deleted ? 0 : article.quantity;
        }
        item.kit = item.id;
        return $scope.order.kits.push(item);
      }
    };
    $scope.seeMore = function(category) {
      var promises;
      $scope.currentPage++;
      $scope.loadingItems = true;
      promises = [];
      if ($scope.canSeeMoreArticles[category]) {
        promises.push(getArticlesAnd(appendArticles, category));
      }
      if ($scope.canSeeMoreKits[category]) {
        promises.push(getKitsAnd(appendKits, category));
      }
      return $q.all(promises).then(function() {
        return $scope.loadingItems = false;
      });
    };
    handleNewArticles = function(articles, category) {
      return $scope.canSeeMoreArticles[category] = !!articles.next;
    };
    handleNewKits = function(kits, category) {
      return $scope.canSeeMoreKits[category] = !!kits.next;
    };
    initializeArticleQuantity = function(articles) {
      return _.map(articles, function(article) {
        var orderArticle;
        orderArticle = _.find($scope.order.articles, {
          article: {
            id: article.id
          }
        });
        if (orderArticle) {
          _.extend(orderArticle, _.pick(orderArticle.article, ['designation', 'deleted', 'need_ordonnance', 'unit_price', 'category']));
          return orderArticle;
        }
        article.quantity = 0;
        return article;
      });
    };
    initializeKitQuantity = function(kits) {
      return _.map(kits, function(kit) {
        var orderKit;
        orderKit = _.find($scope.order.kits, {
          kit: kit.id
        });
        if (orderKit) {
          return orderKit;
        }
        kit.quantity = 0;
        return kit;
      });
    };
    appendArticles = function(articles, category) {
      var article, articlesToAdd, j, len, ref;
      articlesToAdd = initializeArticleQuantity(articles.results);
      for (j = 0, len = articlesToAdd.length; j < len; j++) {
        article = articlesToAdd[j];
        if (category === $scope.allCategories) {
          $scope.catalog[category].push(article);
        } else {
          if ($scope.catalog[article.category] == null) {
            if (ref = article.category, indexOf.call($scope.categories, ref) < 0) {
              console.log('WARNING : we don\'t have to pass in this if statement ; take a look \n' + 'if not article.category in $scope.categories\n' + '$scope.categories(visibles categories)', $scope.categories, '\narticle.category not in categories to show : ', article.category);
              addAndSortCategory(article.category);
            }
            $scope.catalog[article.category] = [];
          }
          $scope.catalog[article.category].push(article);
        }
      }
      return handleNewArticles(articles, category);
    };
    appendKits = function(kits, category) {
      var j, kit, kitsToAdd, len, ref;
      kitsToAdd = initializeKitQuantity(kits.results);
      for (j = 0, len = kitsToAdd.length; j < len; j++) {
        kit = kitsToAdd[j];
        if ($scope.kits[kit.category] == null) {
          if (ref = kit.category, indexOf.call($scope.categories, ref) < 0) {
            console.log('WARNING : we don\'t have to pass in this if statement ; take a look \n' + 'if not kit.category in $scope.categories\n' + '$scope.categories(visibles categories)', $scope.categories, '\nkit.category not in categories to show : ', kit.category);
            addAndSortCategory(kit.category);
          }
          $scope.kits[kit.category] = [];
        }
        $scope.kits[kit.category].push(kit);
      }
      return handleNewKits(kits, category);
    };
    flushAndAppendArticles = function(articles) {
      $scope.catalog[$scope.currentCategory] = initializeArticleQuantity(articles.results);
      return handleNewArticles(articles, $scope.currentCategory);
    };
    flushAndAppendKits = function(kits) {
      $scope.kits[$scope.currentCategory] = initializeKitQuantity(kits.results);
      return handleNewKits(kits, $scope.currentCategory);
    };
    addAndSortCategory = function(category) {
      var categories, sorted_categories;
      categories = angular.copy($scope.categories);
      categories.splice(0, 1, category);
      sorted_categories = _.sortBy(categories, function(category) {
        return category;
      });
      return $scope.categories = [$scope.allCategories].concat(sorted_categories);
    };
    getCategories = function() {
      var ret;
      ret = $q.defer();
      if ($scope.categories.length > 0) {
        ret.resolve();
        return ret.promise;
      }
      CatalogCategory.getVisibleCategories().then(function(categories) {
        var sorted_categories;
        sorted_categories = _.sortBy(categories, [
          function(category) {
            return category;
          }
        ]);
        $scope.categories = [$scope.allCategories].concat(sorted_categories);
        return ret.resolve();
      });
      return ret.promise;
    };
    getArticlesAnd = function(onArticlesFound, category) {
      var getArticlesPromise, query;
      getArticlesPromise = $q.defer();
      query = {
        visible_reassort: $scope.visibleReassort,
        page_size: $scope.max_size,
        page: $scope.currentPage,
        search: $scope.searchArticlesValue
      };
      if ($scope.entityId) {
        query.entity = $scope.entityId;
      }
      if ($scope.sectorId) {
        query.sector = $scope.sectorId;
      }
      if ($scope.catalogId) {
        query.catalog = $scope.catalogId;
      }
      if (category == null) {
        return $scope.categories.forEach(function(categori) {
          query.category = categori;
          return Articles.api.query(query).$promise.then(function(results) {
            return onArticlesFound(results, categori);
          });
        });
      } else {
        if (category !== $scope.allCategories) {
          query.category = category;
        }
        Articles.api.query(query).$promise.then(function(results) {
          if (category === $scope.allCategories) {
            results.results = _.filter(results.results, function(article) {
              return $scope.categories.indexOf(article.category) > -1;
            });
          }
          onArticlesFound(results, category);
          return getArticlesPromise.resolve();
        });
        return getArticlesPromise.promise;
      }
    };
    getKitsAnd = function(onKitsFound, category) {
      var getKitsPromise, query;
      getKitsPromise = $q.defer();
      query = {
        page_size: $scope.max_size,
        page: $scope.currentPage,
        search: $scope.searchArticlesValue
      };
      if ($scope.entityId) {
        query.entity = $scope.entityId;
      }
      if ($scope.sectorId) {
        query.sector = $scope.sectorId;
      }
      if ($scope.catalogId) {
        query.catalog = $scope.catalogId;
      }
      if (category == null) {
        return $scope.categories.forEach(function(categori) {
          query.category = categori;
          return Kits.api.query(query).$promise.then(function(response) {
            var j, kit, len, ref;
            ref = response.results;
            for (j = 0, len = ref.length; j < len; j++) {
              kit = ref[j];
              Kits.checkIfHasDeletedArticle(kit);
            }
            return onKitsFound(response, categori);
          });
        });
      } else {
        if (category !== $scope.allCategories) {
          query.category = category;
        }
        Kits.api.query(query).$promise.then(function(response) {
          var j, kit, len, ref;
          getKitsPromise.resolve();
          if (category === $scope.allCategories) {
            response.results = _.filter(response.results, function(kit) {
              return $scope.categories.indexOf(kit.category) > -1;
            });
          }
          ref = response.results;
          for (j = 0, len = ref.length; j < len; j++) {
            kit = ref[j];
            Kits.checkIfHasDeletedArticle(kit);
          }
          return onKitsFound(response, category);
        });
        return getKitsPromise.promise;
      }
    };
    $scope.searchArticles = function() {
      $scope.currentPage = 1;
      getArticlesAnd(flushAndAppendArticles, $scope.currentCategory);
      return getKitsAnd(flushAndAppendKits, $scope.currentCategory);
    };
    $scope.currentTabChange = function(category) {
      $scope.currentCategory = category;
      $scope.searchArticlesValue = '';
      $scope.currentPage = 1;
      getArticlesAnd(flushAndAppendArticles, $scope.currentCategory);
      return getKitsAnd(flushAndAppendKits, $scope.currentCategory);
    };
    init = function() {
      $scope.loadingItems = false;
      $scope.searchArticlesValue = '';
      $scope.canSeeMoreArticles = {};
      $scope.canSeeMoreKits = {};
      $scope.currentPage = 1;
      $scope.catalog = {};
      $scope.kits = {};
      $scope.categories = [];
      $scope.max_size = 50;
      return getCategories();
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=catalog-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:orderCatalog
    * @description
    * Directive displaying articles and kits for order
   */
  angular.module('mhclientApp').directive('orderCatalog', function() {
    return {
      restrict: 'E',
      templateUrl: 'catalog/views/catalog.html',
      scope: {
        order: '=',
        entityId: '=?',
        sectorId: '=?',
        catalogId: '=?',
        visibleReassort: "="
      },
      controller: 'CatalogCtrl'
    };
  });

}).call(this);

//# sourceMappingURL=order-catalog-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CatalogCtrl
    * @description
    * # CatalogCtrl
    * Controller of Catalog
   */
  angular.module('mhclientApp').controller('KitCtrl', ["$scope", "$state", function($scope, $state) {
    var i, init, results;
    $scope.entityId = $scope.user.entity;
    $scope.canWrite = $scope.checkPermissions("MHC_KIT_EDIT", "CAN_WRITE");
    $scope.quantitiesRange = (function() {
      results = [];
      for (i = 1; i <= 28; i++){ results.push(i); }
      return results;
    }).apply(this);
    init = function() {
      if ($state.previous != null) {
        return $scope.previous = $state.previous;
      }
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=kit-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CatalogCtrl
    * @description
    * # CatalogCtrl
    * Controller of Catalog
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('KitListCtrl', ["$scope", "Kits", "$rootScope", "$q", "$state", "CatalogCategory", "Catalog", function($scope, Kits, $rootScope, $q, $state, CatalogCategory, Catalog) {
    var appendKits, flushAndAppendKits, getCategories, getKitsAnd, handleNewKits, init;
    $scope.deleteKit = function(kit) {
      $scope.isBusyRequesting = true;
      return Kits.api["delete"]({
        id: kit.id
      }, kit).$promise.then(function(rslt) {
        _.remove($scope.kits[rslt.category], function(value, index, array) {
          return value.id === rslt.id;
        });
        return $scope.isBusyRequesting = false;
      });
    };
    $scope.hasData = function() {
      return $scope.kits && Object.keys($scope.kits).length;
    };
    $scope.seeMore = function(category) {
      $scope.currentPage++;
      if ($scope.canSeeMoreKits[category]) {
        return getKitsAnd(appendKits, category);
      }
    };
    handleNewKits = function(kits, category) {
      return $scope.canSeeMoreKits[category] = !!kits.next;
    };
    appendKits = function(kits, category) {
      var i, kit, kitsToAdd, len, ref;
      kitsToAdd = kits.results;
      for (i = 0, len = kitsToAdd.length; i < len; i++) {
        kit = kitsToAdd[i];
        if ($scope.kits[kit.category] == null) {
          if (ref = !kit.category, indexOf.call($scope.categories, ref) >= 0) {
            console.log('WARNING : we don\'t have to pass in this if statement ; take a look \n' + 'if not kit.category in $scope.categories\n' + '$scope.categories(visibles categories)', $scope.categories, '\nkit.category not in categories to show : ', kit.category);
            $scope.categories.push(kit.category);
          }
          $scope.kits[kit.category] = [];
        }
        $scope.kits[kit.category].push(kit);
      }
      return handleNewKits(kits, category);
    };
    flushAndAppendKits = function(kits) {
      $scope.kits[$scope.currentCategory] = kits.results;
      return handleNewKits(kits, $scope.currentCategory);
    };
    getCategories = function() {
      var ret;
      $scope.isBusyRequesting = true;
      ret = $q.defer();
      CatalogCategory.getVisibleCategories().then(function(categories) {
        $scope.categories = categories;
        ret.resolve();
        return $scope.isBusyRequesting = false;
      });
      return ret.promise;
    };
    getKitsAnd = function(onKitsFound, category) {
      var query;
      $scope.isBusyRequesting = true;
      query = {
        page_size: $scope.max_size,
        page: $scope.currentPage,
        ext_id: '',
        search: $scope.searchArticlesValue
      };
      if ($rootScope.currentStay && $rootScope.currentStay.entity) {
        query.entity = $rootScope.currentStay.entity;
      } else if ($scope.user.entity) {
        query.entity = $scope.user.entity;
      }
      if (category == null) {
        return $scope.categories.forEach(function(categori) {
          query.category = categori;
          return Kits.api.query(query).$promise.then(function(results) {
            onKitsFound(results, categori);
            return $scope.isBusyRequesting = false;
          });
        });
      } else {
        query.category = category;
        return Kits.api.query(query).$promise.then(function(results) {
          onKitsFound(results, category);
          return $scope.isBusyRequesting = false;
        });
      }
    };
    $scope.searchArticles = function() {
      $scope.currentPage = 1;
      return getKitsAnd(flushAndAppendKits, $scope.currentCategory);
    };
    $scope.currentTabChange = function(category) {
      $scope.currentCategory = category;
      $scope.searchArticlesValue = '';
      $scope.currentPage = 1;
      return getKitsAnd(flushAndAppendKits, $scope.currentCategory);
    };
    init = function() {
      $scope.searchArticlesValue = '';
      $scope.canSeeMoreKits = {};
      $scope.currentPage = 1;
      $scope.kits = {};
      $scope.categories = [];
      $scope.max_size = 50;
      return getCategories().then(function() {
        return Catalog.query().$promise.then(function(catalogs) {
          return $scope.catalogs = catalogs;
        });
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=kit-list-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CatalogCtrl
    * @description
    * # CatalogCtrl
    * Controller of Catalog
   */
  angular.module('mhclientApp').controller('KitEditCtrl', ["$scope", "Kits", "$state", "CatalogCategory", "Catalog", function($scope, Kits, $state, CatalogCategory, Catalog) {
    var getCategories, getKit, hideCatalog, init, kitArticlesFactory, kitFactory;
    $scope.canSave = function() {
      return $scope.kitForm && $scope.kitForm.$valid && $scope.kit && $scope.kit.kit_articles && $scope.kit.kit_articles.length > 0;
    };
    $scope.saveArticles = function() {
      var article, articles, i, len, tmp;
      articles = $scope.tmpOrder.articles;
      for (i = 0, len = articles.length; i < len; i++) {
        article = articles[i];
        tmp = {
          quantity: article.quantity,
          article: article
        };
        article.quantity = 0;
        $scope.kit.kit_articles.push(tmp);
      }
      $scope.tmpOrder.articles = [];
      $scope.updatePrice();
      return hideCatalog();
    };
    $scope.updatePrice = function() {
      var article, i, len, ref, total;
      total = 0;
      ref = $scope.kit.kit_articles;
      for (i = 0, len = ref.length; i < len; i++) {
        article = ref[i];
        total += article.quantity * article.article.unit_price;
      }
      $scope.kit.computed_price = total;
      return total;
    };
    $scope.removeArticle = function(article) {
      article.quantity = 0;
      $scope.tmpOrder.articles.splice($scope.tmpOrder.articles.indexOf(article), 1);
      $scope.kit.kit_articles.splice($scope.kit.kit_articles.indexOf(article), 1);
      return $scope.updatePrice();
    };
    hideCatalog = function() {
      return $scope.isCatalogVisible = false;
    };
    $scope.showCatalog = function() {
      return $scope.isCatalogVisible = true;
    };
    getCategories = function() {
      return CatalogCategory.getVisibleCategories().then(function(categories) {
        $scope.categories = categories;
        return $scope.availableCategories = $scope.categories;
      });
    };
    getKit = function(idKit) {
      return Kits.api.get({
        id: idKit
      }).$promise.then(function(result) {
        $scope.kit = result;
        return $scope.catalogId = $scope.kit.catalog;
      });
    };
    kitArticlesFactory = function(kit) {
      var i, kitArticles, kit_article, len, ref;
      kitArticles = [];
      ref = kit.kit_articles;
      for (i = 0, len = ref.length; i < len; i++) {
        kit_article = ref[i];
        kitArticles.push({
          id: kit_article.id,
          quantity: kit_article.quantity,
          article: kit_article.article.id
        });
      }
      return kitArticles;
    };
    kitFactory = function(kit) {
      return {
        name: kit.name,
        id: kit.id,
        category: kit.category,
        status: 'V',
        catalog: kit.catalog,
        kit_articles: kitArticlesFactory(kit)
      };
    };
    $scope.saveKit = function() {
      var kitToSave;
      kitToSave = kitFactory($scope.kit);
      $scope.isBusyRequesting = true;
      if ($scope["new"]) {
        return Kits.api.save(kitToSave).$promise.then(function(rslt) {
          return $state.go('user.config.kit.list');
        })["finally"](function() {
          return $scope.isBusyRequesting = false;
        });
      } else {
        return Kits.api.update({
          id: kitToSave.id
        }, kitToSave).$promise.then(function(rslt) {
          return $state.go('user.config.kit.list');
        })["finally"](function() {
          return $scope.isBusyRequesting = false;
        });
      }
    };
    $scope.setCatalogId = function(catalogId) {
      return $scope.catalogId = catalogId;
    };
    init = function() {
      if ($state.current.name === "user.config.kit.edit") {
        $scope["new"] = false;
        $scope.readOnly = false;
      }
      if ($state.current.name === "user.config.kit.new") {
        $scope["new"] = true;
        $scope.readOnly = false;
      }
      if ($state.current.name === "user.config.kit.show") {
        $scope["new"] = false;
        $scope.readOnly = true;
      }
      return Catalog.query().$promise.then(function(catalogs) {
        $scope.catalogs = catalogs;
        $scope.availableCategories = [];
        $scope.tmpOrder = {
          kits: [],
          articles: []
        };
        $scope.order = $scope.tmpOrder;
        getCategories();
        if (!$scope["new"]) {
          return getKit($state.params.idKit);
        } else {
          $scope.kit = {
            catalog: $scope.catalogs.length === 1 ? $scope.catalogs[0].id : null,
            kit_articles: []
          };
          return $scope.setCatalogId($scope.kit.catalog);
        }
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=kit-edit-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Catalog
    * @description
    * # Catalog
    * Factory of Catalog
   */
  angular.module("mhclientApp").factory('Articles', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, article, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/articles/:id/:route', {}, {
      query: {
        method: 'GET',
        params: {
          catalog: '@catalog',
          category: '@category',
          search: '@search',
          page: '@page',
          visible_reassort: '@visible_reassort'
        },
        headers: {
          Accept: acceptHeader
        }
      },
      'importArticles': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST',
        params: {
          route: 'import_articles'
        }
      }
    });
    service = {};
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
        break;
      case 'mgapp':
        article = window.mgapp.get('order_mgr').article();
        service.api = BoxResource.generate(article);
    }
    return service;
  }]);

}).call(this);

//# sourceMappingURL=articles-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Catalog
    * @description
    * # Catalog
    * Factory of Catalog
   */
  angular.module("mhclientApp").factory('Kits', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, checkIfHasDeletedArticle, kit, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/kits/:id/:route', {
      id: this.id
    }, {
      query: {
        method: 'GET',
        params: {
          category: '@category',
          search: '@search',
          ext_id: '@ext_id',
          page: '@page'
        },
        headers: {
          Accept: acceptHeader
        }
      },
      save: {
        headers: {
          Accept: acceptHeader
        },
        method: 'POST'
      },
      update: {
        headers: {
          Accept: acceptHeader
        },
        method: 'PUT'
      },
      get: {
        method: 'GET',
        headers: {
          Accept: acceptHeader
        },
        array: false
      },
      "delete": {
        method: 'POST',
        headers: {
          Accept: acceptHeader
        },
        array: false,
        params: {
          route: 'delete'
        }
      }
    });
    checkIfHasDeletedArticle = function(kit) {
      return kit.hasDeletedArticle = _.some(kit.kit_articles, 'article.deleted');
    };
    service = {
      checkIfHasDeletedArticle: checkIfHasDeletedArticle
    };
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
        break;
      case 'mgapp':
        kit = window.mgapp.get('order_mgr').kit();
        service.api = BoxResource.generate(kit);
    }
    return service;
  }]);

}).call(this);

//# sourceMappingURL=kit-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Catalog
    * @description
    * # Catalog
    * Factory of Catalog
   */
  angular.module("mhclientApp").factory('ArticleCategories', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, article, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/categories', {}, {
      query: {
        method: 'GET',
        isArray: true,
        headers: {
          Accept: acceptHeader
        }
      }
    });
    service = {};
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
        break;
      case 'mgapp':
        article = window.mgapp.get('order_mgr').categories();
        service.api = BoxResource.generate(article);
    }
    return service;
  }]);

}).call(this);

//# sourceMappingURL=article-categories-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CurrentPrescriptionCtrl
    * @description
    * # CurrentPrescriptionCtrl
    * Controller of Patient current Prescriptions
   */
  angular.module('mhclientApp').controller('LiaCtrl', ["$scope", "$rootScope", function($scope, $rootScope) {
    $rootScope.busy = true;
    $scope.lia_iframe_url = $scope.base_iframe_url + '/webfw/diary_mgr/stay_' + $rootScope.currentStay.id;
    if ($scope.allStays) {
      $scope.lia_iframe_url = $scope.lia_iframe_url + "/pat_" + $rootScope.currentPatient.id;
    }
    $scope.lia_iframe_url = $scope.lia_iframe_url + '/browse_diary';
    $scope.iframeLoadCallback = function() {
      return $rootScope.$evalAsync(function() {
        return $rootScope.busy = false;
      });
    };
    return $scope.$on("$destroy", function() {
      return $rootScope.busy = false;
    });
  }]);

}).call(this);

//# sourceMappingURL=lia-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CurrentPrescriptionCtrl
    * @description
    * # CurrentPrescriptionCtrl
    * Controller of Patient current Prescriptions
   */
  angular.module('mhclientApp').controller('RodCtrl', ["$scope", "$rootScope", function($scope, $rootScope) {
    $rootScope.busy = true;
    $scope.rod_iframe_url = $scope.base_iframe_url + '/webfw/documents_mgr/pat_' + $rootScope.currentPatient.id + '/browse_rods';
    $scope.iframeLoadCallback = function() {
      return $rootScope.$evalAsync(function() {
        return $rootScope.busy = false;
      });
    };
    return $scope.$on("$destroy", function() {
      return $rootScope.busy = false;
    });
  }]);

}).call(this);

//# sourceMappingURL=rod-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:User
    * @description
    * # User
    * Factory of User
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").factory('UserORPCreation', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    return $resource('/api_rest/orp_create_user', {}, {});
  }]);

  angular.module("mhclientApp").factory('UserCreation', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, portailAPI, user;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/create_update_user/:id/:route', {
      id: this.id
    }, {
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'updateConfig': {
        method: 'PUT',
        params: {
          route: 'update_config',
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'updateFilters': {
        method: 'PUT',
        params: {
          route: 'update_filters',
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'checkUsername': {
        method: 'get',
        params: {
          route: 'check_username'
        },
        isArray: false,
        headers: {
          'Accept': acceptHeader
        }
      },
      'updateSignature': {
        method: 'PUT',
        params: {
          route: 'update_signature',
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        user = window.mgapp.get('usr_mgr').user();
        boxAPI = BoxResource.generate(user);
        boxAPI.updateFilters = function(obj) {
          return BoxResource.mhboxApiCall(user, "update_filters", obj);
        };
        return boxAPI;
    }
  }]);

  angular.module("mhclientApp").factory('UserByUsername', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/users_by_username/:id/:route', {
      id: this.id
    }, {
      'updateMssInfoByIdNat': {
        method: 'put',
        params: {
          route: 'update_mss_info_by_id_nat',
          id: '@id'
        },
        isArray: true,
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    return portailAPI;
  }]);

  angular.module("mhclientApp").factory('User', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, portailAPI, user;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/users/:id/:route', {
      id: this.id
    }, {
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'restoreExpiredSession': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'restore_expired_session'
        },
        method: 'POST'
      },
      'getMssInfo': {
        method: 'get',
        params: {
          route: 'get_mss_info'
        },
        isArray: false,
        headers: {
          'Accept': acceptHeader
        }
      },
      'updateSubscription': {
        method: 'PUT',
        params: {
          route: 'update_subscription'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'read_messages': {
        method: 'POST',
        params: {
          route: 'read_messages'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'getPIMSWebsiteSession': {
        method: 'get',
        params: {
          route: 'get_pims_website_session'
        },
        isArray: false,
        headers: {
          'Accept': acceptHeader
        }
      },
      'getConnectedUser': {
        method: 'get',
        params: {
          route: 'get_connected_user'
        },
        isArray: false,
        headers: {
          'Accept': acceptHeader
        }
      },
      'read_one_message': {
        method: 'POST',
        params: {
          route: 'read_one_message'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'confirmNotification': {
        method: 'POST',
        params: {
          route: 'confirm_notification'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'changePassword': {
        method: 'POST',
        params: {
          route: 'change_password'
        }
      },
      'renewPassword': {
        method: 'POST',
        params: {
          route: 'renew_password'
        }
      },
      'resetPassword': {
        method: 'POST',
        params: {
          route: 'reset_password'
        }
      },
      'reactivateUser': {
        method: 'POST',
        params: {
          route: 'reactivate'
        }
      },
      'deactivateUser': {
        method: 'POST',
        params: {
          route: 'deactivate'
        }
      },
      'getConnectedUserFeatures': {
        method: 'get',
        params: {
          route: 'get_connected_user_features'
        },
        isArray: true,
        headers: {
          'Accept': acceptHeader
        }
      },
      'getPatients': {
        method: 'get',
        isArray: true,
        params: {
          route: 'get_patients'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'getAvailableUsers': {
        method: 'GET',
        params: {
          route: 'get_available_users'
        },
        isArray: true
      },
      'getReadMessages': {
        method: 'get',
        isArray: true,
        params: {
          route: 'get_read_messages'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'exportUserLastLoginDetails': {
        method: "PUT",
        params: {
          route: "export_user_last_login_details",
          id: '@id'
        },
        headers: {
          "Accept": acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        user = window.mgapp.get('usr_mgr').user();
        boxAPI = BoxResource.generate(user);
        boxAPI.read_messages = function(ids) {
          return BoxResource.mhboxApiCall(user, "read_messages", ids);
        };
        boxAPI.getReadMessages = function(object) {
          return BoxResource.mhboxApiCall(user, "get_read_messages", object);
        };
        boxAPI.getConnectedUser = function() {
          return BoxResource.mhboxApiCall(user, "get_connected_user");
        };
        boxAPI.getConnectedUserFeatures = function() {
          return BoxResource.mhboxApiCall(user, "get_connected_user_features");
        };
        boxAPI.getAlerts = function() {
          return BoxResource.objectToResource({});
        };
        boxAPI.resetPassword = function(object) {
          return BoxResource.objectToResource(user.reset_password(object));
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('MandatoryUserField', ["$resource", "MhConfig", function($resource, MhConfig) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/mandatory_user_fields/:id/:route', {
      id: this.id
    }, {});
    service = {};
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
    }
    return service;
  }]);

  angular.module("mhclientApp").factory('MandatoryGroupField', ["$resource", "MhConfig", function($resource, MhConfig) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/mandatory_group_fields/:id/:route', {
      id: this.id
    }, {});
    service = {};
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
    }
    return service;
  }]);

  angular.module("mhclientApp").factory('UserPatient', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, portailAPI, service, users_patients;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/users_patients/:id/:route', {
      id: this.id
    }, {});
    service = {};
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
        break;
      case 'mgapp':
        users_patients = window.mgapp.get('usr_mgr').users_patients();
        service.api = BoxResource.generate(users_patients);
    }
    return service;
  }]);

  angular.module("mhclientApp").factory('UserProfile', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, feature, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/users_profile/:id/:route', {
      id: this.id
    }, {
      'getInitials': {
        method: 'get',
        params: {
          route: 'get_initials'
        },
        isArray: true,
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    service = {};
    switch (MhConfig.platform) {
      case 'mhsi':
        service.api = portailAPI;
        break;
      case 'mgapp':
        feature = window.mgapp.get('usr_mgr').feature();
        service.api = BoxResource.generate(feature);
    }
    return service;
  }]);

  angular.module("mhclientApp").controller('UserSelectCtrl', ["$scope", "$filter", "$uibModalInstance", "$q", "UserUtils", "groupId", "GroupUtils", "patientIpp", "users", "onlyActive", function($scope, $filter, $uibModalInstance, $q, UserUtils, groupId, GroupUtils, patientIpp, users, onlyActive) {
    var usersDone;
    $scope.query = "";
    $scope.searching = true;
    usersDone = $q.defer();
    if (users) {
      usersDone.resolve(users);
    } else if (patientIpp) {
      UserUtils.getUsersForPatient(patientIpp).then(function(users) {
        return usersDone.resolve(users);
      });
    } else {
      UserUtils.getUsers().then(function(users) {
        return usersDone.resolve(users);
      });
    }
    usersDone.promise.then(function(users) {
      if (onlyActive) {
        users = _.filter(users, function(user) {
          return user.is_active;
        });
      }
      if (groupId) {
        return GroupUtils.getGroup({
          id: groupId
        }).then(function(group) {
          $scope.group = group;
          $scope.users = $filter('filter')(users, {
            group: {
              id: groupId
            }
          });
          return $scope.searching = false;
        });
      } else {
        $scope.users = users;
        return $scope.searching = false;
      }
    });
    $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
    return $scope.selectUser = function(user) {
      return $uibModalInstance.close(user);
    };
  }]);

  angular.module("mhclientApp").factory('UserUtils', ["$resource", "$window", "$rootScope", "$filter", "$q", "$uibModal", "User", "UserProfile", "GroupUtils", "UserPatient", function($resource, $window, $rootScope, $filter, $q, $uibModal, User, UserProfile, GroupUtils, UserPatient) {
    var GlobalUsers, canModifyUser, cleanCache, generatePassword, getUsers, getUsersForPatient, globalUsersPromise, initialsGenerator, selectUserModal, service;
    canModifyUser = function(loggedUser, userLine) {
      if (loggedUser.is_superuser || loggedUser.id === userLine.id) {
        return true;
      }
      if (indexOf.call(loggedUser.group.features, "SRV_usr") >= 0) {
        if (!userLine.id) {
          return true;
        }
        if (userLine.is_superuser) {
          return false;
        }
        if (userLine.user_profile.data.is_technical) {
          return false;
        }
        if (["ADMIN", "ADM"].includes(loggedUser.group.short_name)) {
          return true;
        }
        if (["ADMIN", "ADM"].includes(userLine.group.short_name)) {
          return false;
        }
        return true;
      }
      return false;
    };
    generatePassword = function() {
      var lowerLetters, numbers, numbersGen, outCharacters, passwordArray, passwordLength, specialCharacters, symbolsGen, upperGen, upperLetters;
      passwordLength = 8;
      upperGen = true;
      numbersGen = true;
      symbolsGen = false;
      lowerLetters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
      upperLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      specialCharacters = ['!', '"', '"', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '@', '[', '\\', ']', '^', '_', '`', '{', '|', '}', '~'];
      outCharacters = lowerLetters;
      if (upperGen) {
        outCharacters = outCharacters.concat(upperLetters);
      }
      if (numbersGen) {
        outCharacters = outCharacters.concat(numbers);
      }
      if (symbolsGen) {
        outCharacters = outCharacters.concat(specialCharacters);
      }
      passwordArray = [];
      while (passwordArray.length < passwordLength) {
        passwordArray.push(outCharacters[Math.floor(Math.random() * outCharacters.length)]);
      }
      return passwordArray.join("");
    };
    selectUserModal = function(groupId, patientIpp, users, onlyActive) {
      return $uibModal.open({
        templateUrl: 'user/views/user-selection-template.html',
        controller: 'UserSelectCtrl',
        size: "lg",
        backdrop: 'static',
        resolve: {
          groupId: function() {
            return groupId;
          },
          patientIpp: function() {
            return patientIpp;
          },
          users: function() {
            return users;
          },
          onlyActive: function() {
            return onlyActive;
          }
        }
      });
    };
    GlobalUsers = null;
    globalUsersPromise = $q.defer();
    cleanCache = function() {
      GlobalUsers = null;
      return globalUsersPromise = $q.defer();
    };
    $window.clean_users_cache = cleanCache;
    getUsers = function(dontCopy) {
      var UsersPromise;
      if ($rootScope.mh_config.platform === "mhsi") {
        UsersPromise = $q.defer();
        if (GlobalUsers != null) {
          globalUsersPromise.promise.then(function() {
            if (dontCopy) {
              return UsersPromise.resolve(GlobalUsers);
            } else {
              return UsersPromise.resolve(_.map(GlobalUsers, _.clone));
            }
          });
        } else {
          GlobalUsers = [];
          $q.all([User.query({}).$promise, GroupUtils.getAllGroups(), UserProfile.api.query().$promise]).then(function(data) {
            var groups_by_id, j, len, profiles_by_auth_user, user;
            GlobalUsers = data[0];
            profiles_by_auth_user = {};
            groups_by_id = {};
            _.forEach(data[1], function(group) {
              return groups_by_id[group.id] = group;
            });
            _.forEach(data[2], function(user_profile) {
              return profiles_by_auth_user[user_profile.auth_user] = user_profile;
            });
            for (j = 0, len = GlobalUsers.length; j < len; j++) {
              user = GlobalUsers[j];
              user.group = groups_by_id[user.group];
              user.user_profile = profiles_by_auth_user[user.id];
            }
            if (dontCopy) {
              UsersPromise.resolve(GlobalUsers);
            } else {
              UsersPromise.resolve(_.map(GlobalUsers, _.clone));
            }
            return globalUsersPromise.resolve();
          });
        }
        return UsersPromise.promise;
      } else {
        UsersPromise = $q.defer();
        if (GlobalUsers != null) {
          globalUsersPromise.promise.then(function() {
            if (dontCopy) {
              return UsersPromise.resolve(GlobalUsers);
            } else {
              return UsersPromise.resolve(_.map(GlobalUsers, _.clone));
            }
          });
        } else {
          GlobalUsers = [];
          $q.all([User.query({}).$promise, GroupUtils.getAllGroups()]).then(function(data) {
            var j, len, user;
            GlobalUsers = data[0];
            for (j = 0, len = GlobalUsers.length; j < len; j++) {
              user = GlobalUsers[j];
              user.group = _.find(data[1], {
                id: user.group
              });
            }
            if (dontCopy) {
              UsersPromise.resolve(GlobalUsers);
            } else {
              UsersPromise.resolve(_.map(GlobalUsers, _.clone));
            }
            return globalUsersPromise.resolve();
          });
        }
        return UsersPromise.promise;
      }
    };
    getUsersForPatient = function(patientIpp, query) {
      var UsersForPatientPromise;
      UsersForPatientPromise = $q.defer();
      getUsers().then(function(users) {
        if ($rootScope.mh_config.platform === "mgapp") {
          users = _.filter(users, {
            state: "A"
          });
        } else {
          users = _.filter(users, {
            is_active: true
          });
        }
        return UserPatient.api.query(query || {
          patient_ipp: patientIpp
        }).$promise.then(function(patientUsers) {
          var usersIds;
          usersIds = _.map(patientUsers, 'user');
          return UsersForPatientPromise.resolve(_.filter(users, function(o) {
            var ref;
            return ref = o.id, indexOf.call(usersIds, ref) >= 0;
          }));
        });
      });
      return UsersForPatientPromise.promise;
    };
    initialsGenerator = function(firstName, lastName, count, alreadyTakenInitials) {
      var first_long, i, initials, j, k, l, m, n, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, s, same, second_long, suffix;
      alreadyTakenInitials = alreadyTakenInitials || [];
      count = count || 6;
      firstName = firstName.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
      lastName = lastName.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
      initials = [];
      for (i = j = 1; j < 3; i = j += 1) {
        same = firstName.slice(0, i) + lastName.slice(0, i);
        second_long = firstName.slice(0, i) + lastName.slice(0, i + 1);
        first_long = firstName.slice(0, i) + lastName.slice(0, i + 1);
        if (indexOf.call(alreadyTakenInitials, same) < 0) {
          initials.push(same);
          if (initials.length >= count) {
            return initials;
          }
        }
        if (indexOf.call(alreadyTakenInitials, second_long) < 0) {
          initials.push(second_long);
          if (initials.length >= count) {
            return initials;
          }
        }
        if (indexOf.call(alreadyTakenInitials, first_long) < 0) {
          initials.push(first_long);
          if (initials.length >= count) {
            return initials;
          }
        }
        for (suffix = k = 1; k < 100; suffix = k += 1) {
          if (ref = same + suffix, indexOf.call(alreadyTakenInitials, ref) < 0) {
            initials.push(same + suffix);
            if (initials.length >= count) {
              return initials;
            }
          }
        }
        if (second_long !== same) {
          for (suffix = l = 1; l < 10; suffix = l += 1) {
            if (ref1 = second_long + suffix, indexOf.call(alreadyTakenInitials, ref1) < 0) {
              initials.push(second_long + suffix);
              if (initials.length >= count) {
                return initials;
              }
            }
          }
        }
        if (first_long !== same && first_long !== second_long) {
          for (suffix = m = 1; m < 10; suffix = m += 1) {
            if (ref2 = first_long + suffix, indexOf.call(alreadyTakenInitials, ref2) < 0) {
              initials.push(first_long + suffix);
              if (initials.length >= count) {
                return initials;
              }
            }
          }
        }
        if (second_long !== same) {
          for (suffix = n = 10; n < 10; suffix = n += 1) {
            if (ref3 = second_long + suffix, indexOf.call(alreadyTakenInitials, ref3) < 0) {
              initials.push(second_long + suffix);
              if (initials.length >= count) {
                return initials;
              }
            }
          }
        }
        if (first_long !== same && first_long !== second_long) {
          for (suffix = p = 10; p < 10; suffix = p += 1) {
            if (ref4 = first_long + suffix, indexOf.call(alreadyTakenInitials, ref4) < 0) {
              initials.push(first_long + suffix);
              if (initials.length >= count) {
                return initials;
              }
            }
          }
        }
        if (same.length <= 3) {
          for (suffix = q = 100; q < 1000; suffix = q += 1) {
            if (ref5 = same + suffix, indexOf.call(alreadyTakenInitials, ref5) < 0) {
              initials.push(same + suffix);
              if (initials.length >= count) {
                return initials;
              }
            }
          }
        }
        if (second_long !== same && second_long.length <= 3) {
          for (suffix = r = 100; r < 1000; suffix = r += 1) {
            if (ref6 = second_long + suffix, indexOf.call(alreadyTakenInitials, ref6) < 0) {
              initials.push(second_long + suffix);
              if (initials.length >= count) {
                return initials;
              }
            }
          }
        }
        if (first_long !== same && first_long !== second_long && first_long.length <= 3) {
          for (suffix = s = 100; s < 1000; suffix = s += 1) {
            if (ref7 = first_long + suffix, indexOf.call(alreadyTakenInitials, ref7) < 0) {
              initials.push(first_long + suffix);
              if (initials.length >= count) {
                return initials;
              }
            }
          }
        }
      }
      return initials;
    };
    service = {
      getUsers: getUsers,
      getUsersForPatient: getUsersForPatient,
      canModifyUser: canModifyUser,
      selectUserModal: selectUserModal,
      generatePassword: generatePassword,
      initialsGenerator: initialsGenerator,
      cleanCache: cleanCache
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=user-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:User
    * @description
    * # User
    * Factory of User
   */
  angular.module("mhclientApp").factory('Group', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, boxAPI, group, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/groups/:id/:route', {
      id: this.id
    }, {
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'exportFeaturePermissions': {
        method: 'PUT',
        headers: {
          'Accept': acceptHeader
        },
        array: false,
        params: {
          id: '@id',
          route: 'export_feature_permissions'
        }
      },
      'updateGroups': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        isArray: false,
        params: {
          route: 'update_groups'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        group = window.mgapp.get('grp_mgr').group();
        boxAPI = BoxResource.generate(group);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").controller('GroupSelectCtrl', ["$scope", "$filter", "$uibModalInstance", "$q", "Group", "GroupUtils", "groups", function($scope, $filter, $uibModalInstance, $q, Group, GroupUtils, groups) {
    $scope.query = "";
    $scope.searching = true;
    if (groups) {
      $scope.groups = groups;
      $scope.searching = false;
    } else {
      GroupUtils.getAllGroups().then(function(groups) {
        $scope.groups = groups;
        return $scope.searching = false;
      });
    }
    $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
    return $scope.selectGroup = function(group) {
      return Group.get({
        id: group.id
      }).$promise.then(function(groupDetail) {
        return $uibModalInstance.close(groupDetail);
      });
    };
  }]);

  angular.module("mhclientApp").factory('GroupUtils', ["$resource", "$filter", "$q", "$uibModal", "Group", function($resource, $filter, $q, $uibModal, Group) {
    var filterEntries, getAllGroups, getGroup, getGroups, globalGroupsPromise, resetCache, selectGroupModal, service;
    globalGroupsPromise = $q.defer();
    resetCache = function() {
      return globalGroupsPromise = $q.defer();
    };
    selectGroupModal = function(groups) {
      return $uibModal.open({
        templateUrl: 'user/views/group-selection-template.html',
        controller: 'GroupSelectCtrl',
        backdrop: 'static',
        size: "lg",
        resolve: {
          groups: function() {
            return groups;
          }
        }
      });
    };
    getAllGroups = function() {
      return getGroup(false, true);
    };
    filterEntries = function(entries, query, many, dontCopy) {
      var result;
      if (query) {
        result = many ? _.filter(entries, query) : _.find(entries, query);
      } else {
        result = entries;
      }
      if (dontCopy) {
        return result;
      } else {
        return _.clone(result);
      }
    };
    getGroup = function(query, many, dontCopy) {
      if (!globalGroupsPromise.promise.$$state.status) {
        globalGroupsPromise.resolve(Group.query().$promise);
      }
      return globalGroupsPromise.promise.then(function(groups) {
        return filterEntries(groups, query, many, dontCopy);
      });
    };
    getGroups = function(query, dontCopy) {
      return getGroup(query, true, dontCopy);
    };
    service = {
      getAllGroups: getAllGroups,
      selectGroupModal: selectGroupModal,
      getGroups: getGroups,
      getGroup: getGroup,
      resetCache: resetCache
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=group-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:UserAccountCtrl
    * @description
    * # UserAccountCtrl
    * Controller of User account
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").controller('UserGuiConfigurationCtrl', ["$scope", "$rootScope", "$uibModalInstance", "userDetail", "User", "UserUtils", "SiteVarsUtils", "UserCreation", "FeatureUtils", "MenuUtils", function($scope, $rootScope, $uibModalInstance, userDetail, User, UserUtils, SiteVarsUtils, UserCreation, FeatureUtils, MenuUtils) {
    $scope.config = userDetail.config;
    $scope.oldConfig = angular.copy(userDetail.config);
    $scope.yes = function() {
      $rootScope.busy = true;
      return UserCreation.updateConfig({
        id: userDetail.id
      }, {
        config: $scope.config
      }).$promise.then(function() {
        if (userDetail.id === $rootScope.user.id) {
          $rootScope.user.config.menu_type = $scope.config.menu_type;
          $rootScope.user.config.menu_color = $scope.config.menu_color;
        }
        $rootScope.busy = false;
        return $uibModalInstance.close(false);
      });
    };
    return $scope.cancel = function() {
      userDetail.config = $scope.oldConfig;
      return $uibModalInstance.close(false);
    };
  }]);

  angular.module('mhclientApp').controller('UserAccountCtrl', ["$scope", "$rootScope", "$state", "$q", "notify", "$filter", "$uibModal", "$stateParams", "User", "UserCreation", "UserProfile", "UserUtils", "UserPatient", "MandatoryUserField", "GroupUtils", "MandatoryGroupField", "Sector", "Entity", "Upload", "SiteVarsUtils", "Patient", function($scope, $rootScope, $state, $q, notify, $filter, $uibModal, $stateParams, User, UserCreation, UserProfile, UserUtils, UserPatient, MandatoryUserField, GroupUtils, MandatoryGroupField, Sector, Entity, Upload, SiteVarsUtils, Patient) {
    var UserPromise, formatUser;
    $scope.showInactive = false;
    $scope.generatePassword = function() {
      return UserUtils.generatePassword();
    };
    $scope.usernameAlreadyExists = false;
    $scope.dirtyPatients = false;
    $scope.dirtyForm = false;
    $scope.signature = {
      preview: null,
      file: null
    };
    SiteVarsUtils.get('PASSWORD_ALLOWED_PATTERN', "").then(function(sitevar) {
      return $scope.passwordPattern = sitevar.value;
    });
    SiteVarsUtils.get('PASSWORD_DEFAULT_PATTERN_INFO', $filter('translate')('PASSWORD_DEFAULT_PATTERN_INFO')).then(function(sitevar) {
      return $scope.passwordPatternInfo = sitevar.value;
    });
    $scope.requiredFields = [];
    $scope.proposedInitials = [];
    $scope.editConfig = function(userToEdit) {
      return $uibModal.open({
        templateUrl: 'user/views/user-gui-configuration.html',
        controller: 'UserGuiConfigurationCtrl',
        size: "lg",
        backdrop: 'static',
        keyboard: false,
        resolve: {
          userDetail: function() {
            return userToEdit;
          }
        }
      });
    };
    $scope.isAdmin = $scope.user.is_superuser || indexOf.call($scope.user.group.features, "SRV_usr") >= 0;
    $scope.canModifyUser = UserUtils.canModifyUser;
    $scope.usernameChanged = function() {
      return $scope.usernameAlreadyExists = false;
    };
    $scope.genInitials = function(userToEdit) {
      $scope.proposedInitials = [];
      if ((userToEdit.first_name != null) && (userToEdit.last_name != null) && userToEdit.first_name.length > 0 && userToEdit.last_name.length > 0) {
        return $scope.proposedInitials = UserUtils.initialsGenerator(userToEdit.first_name, userToEdit.last_name, 6, $scope.alreadyTakenInitials);
      }
    };
    $scope.newSignature = function(file) {
      var url;
      $rootScope.busy = true;
      url = "/api_rest/create_update_user/" + $scope.userToEdit.id + "/update_signature";
      return Upload.upload({
        url: url,
        method: "PUT",
        file: file
      }).then(function(response) {
        $scope.dirtyForm = true;
        return $rootScope.busy = false;
      });
    };
    $scope.removeSignature = function() {
      $rootScope.busy = true;
      return UserCreation.updateSignature({
        id: $scope.userToEdit.id
      }, {}).$promise.then(function() {
        $scope.signature.preview = null;
        $scope.userToEdit.user_profile.signature = null;
        $scope.dirtyForm = true;
        return $rootScope.busy = false;
      });
    };
    $scope.selectUser = function(redirect) {
      return UserUtils.selectUserModal(null, null, null, true).result.then(function(selectedUser) {
        if (selectedUser) {
          redirect.user_id = selectedUser.id;
          return redirect.user_fullname = selectedUser.full_name;
        }
      });
    };
    $scope.addRedirect = function(userProfile) {
      return userProfile.redirect_to.push({});
    };
    $scope.removeRedirect = function(userProfile, redirect) {
      return _.remove(userProfile.redirect_to, redirect);
    };
    $scope.checkRequiredField = function(fieldName) {
      return indexOf.call($scope.requiredFields, fieldName) >= 0;
    };
    $scope.handleAutoAssign = function() {
      var hasSRVPal, mandatoryFieldsIds, noAAgroup;
      hasSRVPal = ($scope.userToEdit.group != null) && $scope.userToEdit.group.features.indexOf('SRV_pal') > -1;
      noAAgroup = ($scope.userToEdit.group != null) && $scope.userToEdit.group.data.DO_NOT_AUTO_ASSIGN_PATIENTS;
      $scope.autoAssingAll = !noAAgroup && (hasSRVPal || $scope.allStayForAllUsers || $scope.userToEdit.user_profile.data.is_technical || ($scope.autoAssingEmp && $scope.userToEdit.user_profile.pro_category === 'emp'));
      if ($scope.userToEdit.group != null) {
        $scope.requiredFields = [];
        mandatoryFieldsIds = _.map(_.filter($scope.mandatoryGroupFields, {
          group: $scope.userToEdit.group.id
        }), "mandatoryuserfield");
        return $scope.requiredFields = _.map(_.filter($scope.mandatoryUserFields, function(field) {
          var ref;
          return ref = field.id, indexOf.call(mandatoryFieldsIds, ref) >= 0;
        }), "field_name");
      } else {
        return $scope.requiredFields = [];
      }
    };
    $scope.selectGroup = function(group) {
      var currentSectorId, ref, sectorIsRequired;
      $scope.handleAutoAssign();
      if ($scope.userToEdit.entity != null) {
        currentSectorId = (ref = $scope.userToEdit.sector) != null ? ref.id : void 0;
        $scope.sectors = _.filter($scope.allSectors, {
          entity: $scope.userToEdit.entity.id
        });
        sectorIsRequired = $scope.checkRequiredField('sector');
        if ($scope.sectors.length > 0 && !sectorIsRequired) {
          $scope.sectors = [
            {
              id: null,
              name: "---"
            }
          ].concat(_.filter($scope.sectors, function(s) {
            return s.id !== null;
          }));
        }
        if (currentSectorId === null && sectorIsRequired) {
          return $scope.userToEdit.sector = null;
        }
      }
    };
    $scope.selectEntity = function(entity) {
      return $scope.handleUserPatients($scope.userToEdit).then(function() {
        $scope.sectors = _.filter($scope.allSectors, {
          entity: entity.id
        });
        if ($scope.sectors.length > 0 && !$scope.checkRequiredField('sector')) {
          $scope.sectors.unshift({
            id: null,
            name: "---"
          });
        }
        return $scope.userToEdit.sector = null;
      });
    };
    $scope.selectCategoryPro = function(category) {
      return $scope.handleAutoAssign();
    };
    $scope.toggleInactivePatients = function(userToEdit, showInactive) {
      if (showInactive) {
        $scope.filterBy = {};
        if (!$scope.inactivePatientsDone) {
          $rootScope.busy = true;
          return Patient.getAvailablePatients({
            entity: userToEdit.entity.id,
            stay_states: ["I", "CLOSE"]
          }).$promise.then(function(patients) {
            var i, len, patient, ref, ref1;
            patients = _.uniqBy(patients, 'id');
            for (i = 0, len = patients.length; i < len; i++) {
              patient = patients[i];
              patient.state = "INACTIVE";
              if (ref = patient.id, indexOf.call($scope.activePatientsIds, ref) < 0) {
                if (ref1 = patient.id, indexOf.call($scope.linkedPatientsId, ref1) >= 0) {
                  $scope.selectedPatients.push(patient);
                  $scope.selectedPatientsId.push(patient.id);
                } else {
                  $scope.allPatients.push(patient);
                }
              }
            }
            $scope.allPatients = $filter('orderBy')($scope.allPatients, 'full_name');
            $scope.inactivePatientsDone = true;
            return $rootScope.busy = false;
          });
        }
      } else {
        return $scope.filterBy = {
          state: "!INACTIVE"
        };
      }
    };
    $scope.handleUserPatients = function(userToEdit) {
      var handleUserPatientsDone;
      handleUserPatientsDone = $q.defer();
      $rootScope.busy = true;
      $scope.inactivePatientsDone = false;
      $scope.showInactive = false;
      $scope.filterBy = {};
      $scope.allPatients = [];
      $scope.activePatientsIds = [];
      $scope.selectedPatients = [];
      $scope.dirtyPatients = false;
      Patient.getAvailablePatients({
        entity: userToEdit.entity.id,
        stay_states: ["PRE", "ADM"]
      }).$promise.then(function(patients) {
        var userPatientsDefer;
        userPatientsDefer = $q.defer();
        if (userToEdit.id) {
          UserPatient.api.query({
            user: userToEdit.id
          }).$promise.then(function(userPatients) {
            return userPatientsDefer.resolve(userPatients);
          });
        } else {
          userPatientsDefer.resolve([]);
        }
        return userPatientsDefer.promise.then(function(userPatients) {
          var i, len, patient, ref;
          patients = _.uniqBy(patients, 'id');
          $scope.linkedPatientsId = _.map(userPatients, 'patient');
          for (i = 0, len = patients.length; i < len; i++) {
            patient = patients[i];
            if (ref = patient.id, indexOf.call($scope.linkedPatientsId, ref) >= 0) {
              $scope.selectedPatients.push(patient);
            } else {
              $scope.allPatients.push(patient);
            }
          }
          $scope.selectedPatients = $filter('orderBy')($scope.selectedPatients, 'full_name');
          $scope.allPatients = $filter('orderBy')($scope.allPatients, 'full_name');
          $scope.selectedPatientsId = _.map($scope.selectedPatients, "id");
          handleUserPatientsDone.resolve();
          $scope.activePatientsIds = _.map(patients, 'id');
          return $rootScope.busy = false;
        });
      });
      return handleUserPatientsDone.promise;
    };
    $scope.unselectPatient = function(item) {
      $scope.dirtyPatients = true;
      _.remove($scope.selectedPatients, item);
      return $scope.allPatients.push(item);
    };
    $scope.selectPatient = function(item) {
      $scope.dirtyPatients = true;
      _.remove($scope.allPatients, item);
      return $scope.selectedPatients.push(item);
    };
    $scope.selectAllPatients = function() {
      $scope.dirtyPatients = true;
      $scope.selectedPatients = $scope.selectedPatients.concat($scope.allPatients);
      return $scope.allPatients = [];
    };
    $scope.unselectAllpatients = function() {
      $scope.dirtyPatients = true;
      $scope.allPatients = $scope.allPatients.concat($scope.selectedPatients);
      return $scope.selectedPatients = [];
    };
    $rootScope.busy = true;
    UserPromise = $q.defer();
    $scope.proCategories = [
      {
        value: "emp",
        label: $filter('translate')("emp")
      }, {
        value: "inde",
        label: $filter('translate')("inde")
      }, {
        value: "",
        label: "---"
      }
    ];
    $q.all([MandatoryGroupField.api.query().$promise, MandatoryUserField.api.query().$promise, UserProfile.api.getInitials().$promise, SiteVarsUtils.getValue("MEDICAL_YEARBOOK_LINK", "https://annuaire.esante.gouv.fr/"), SiteVarsUtils.getValue("EDITABLE_EXT_ID", false)]).then(function(promises) {
      $scope.editableExtId = promises[4];
      $scope.medicalYearbookLink = promises[3];
      $scope.alreadyTakenInitials = promises[2];
      $scope.mandatoryUserFields = promises[1];
      $scope.mandatoryGroupFields = promises[0];
      return Sector.getSectors().then(function(sectors) {
        $scope.allSectors = sectors;
        return SiteVarsUtils.getValue('AUTO_ASSIGN_ALL_ON_CREATION', false).then(function(AUTO_ASSIGN_ALL_ON_CREATION) {
          return SiteVarsUtils.getValue('SHOW_ALL_STAYS_FOR_ALL_USERS', false).then(function(SHOW_ALL_STAYS_FOR_ALL_USERS) {
            $scope.autoAssingEmp = AUTO_ASSIGN_ALL_ON_CREATION;
            $scope.allStayForAllUsers = SHOW_ALL_STAYS_FOR_ALL_USERS;
            return Entity.api.query().$promise.then(function(entities) {
              var entity, i, len, ref;
              $scope.entities = entities;
              ref = $scope.entities;
              for (i = 0, len = ref.length; i < len; i++) {
                entity = ref[i];
                entity.label = entity.sitevars.LABEL_TITLE || "UNDEFINED";
              }
              if (!$scope.user.entity) {
                $scope.entities.push({
                  label: $filter('translate')("MULTIENTITY"),
                  id: null,
                  order: 1
                });
              }
              return GroupUtils.getAllGroups().then(function(groups) {
                $scope.groups = groups;
                if ($scope.user.is_superuser || $scope.user.group.short_name === 'ADM') {
                  $scope.groups = groups;
                } else {
                  $scope.groups = _.filter(groups, function(group) {
                    return group.short_name !== 'ADM';
                  });
                }
                if ($stateParams.userId) {
                  if ($stateParams.userId === $scope.user.id) {
                    return UserPromise.resolve($scope.user);
                  } else {
                    return User.get({
                      id: $stateParams.userId
                    }).$promise.then(function(user) {
                      return UserPromise.resolve(user);
                    });
                  }
                } else {
                  return UserPromise.resolve({
                    user_profile: {
                      pro_category: "",
                      data: {}
                    }
                  });
                }
              });
            });
          });
        });
      });
    });
    formatUser = function(userToEdit, ignoreUserPatient) {
      var directlyResolve, formatUserDone, i, len, redirect_to, ref;
      formatUserDone = $q.defer();
      directlyResolve = true;
      ref = userToEdit.user_profile.redirect_to || [];
      for (i = 0, len = ref.length; i < len; i++) {
        redirect_to = ref[i];
        redirect_to.holiday_from = new Date(redirect_to.holiday_from);
        redirect_to.holiday_to = new Date(redirect_to.holiday_to);
      }
      if ($scope.entities.length === 1) {
        $scope.userToEdit.entity = $scope.entities[0].id;
      }
      if ("entity" in $scope.userToEdit) {
        directlyResolve = false;
        $scope.userToEdit.entity = _.find($scope.entities, {
          id: $scope.userToEdit.entity
        });
        $scope.sectors = _.filter($scope.allSectors, {
          entity: $scope.userToEdit.entity.id
        });
        if ($scope.userToEdit.sector) {
          $scope.userToEdit.sector = _.find($scope.allSectors, {
            id: $scope.userToEdit.sector
          });
        }
        if (!ignoreUserPatient) {
          $scope.handleUserPatients($scope.userToEdit).then(function() {
            return formatUserDone.resolve();
          });
        } else {
          formatUserDone.resolve();
        }
      }
      if ($scope.userToEdit.group) {
        directlyResolve = false;
        $scope.userToEdit.group = _.find($scope.groups, {
          id: $scope.userToEdit.group.id
        });
        $scope.handleAutoAssign();
        formatUserDone.resolve();
      }
      if (directlyResolve) {
        formatUserDone.resolve();
      }
      return formatUserDone.promise;
    };
    UserPromise.promise.then(function(user) {
      $scope.userToEdit = _.cloneDeep(user);
      $scope.previousRib = $scope.userToEdit.user_profile.data.rib;
      return formatUser($scope.userToEdit).then(function() {
        return $rootScope.busy = false;
      });
    });
    $scope.changePassword = function(user) {
      return $uibModal.open({
        templateUrl: 'admin/views/change-password-template.html',
        controller: 'ChangePasswordModalCtrl',
        size: "lg",
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user_detail: function() {
            return user;
          }
        }
      });
    };
    $scope.synhcronizeToHealthDirectory = function(user) {
      $rootScope.busy = true;
      $scope.dirtyForm = true;
      return User.getMssInfo({
        id_nat: user.user_profile.id_nat
      }).$promise.then(function(result) {
        var healthDirectoryData, modal;
        if (result.status === "OK") {
          healthDirectoryData = result.data;
          modal = $uibModal.open({
            animation: true,
            template: '<health-directory-merge-modal filled-data="$ctrl.filledData" health-directory-data="$ctrl.healthDirectoryData" ' + 'on-dismiss="$dismiss()" on-close="$close(result)"></health-directory-merge-modal>',
            controller: function() {
              this.filledData = user;
              this.healthDirectoryData = healthDirectoryData;
            },
            controllerAs: '$ctrl'
          });
          return modal.result.then(function(result) {
            var address, addressFound, i, len, mss_adresses, ref;
            if (result) {
              user.first_name = healthDirectoryData.prenom_exercice;
              user.last_name = healthDirectoryData.nom_exercice;
              user.user_profile.occupation = healthDirectoryData.libelle_profession;
              if (!user.user_profile.data) {
                user.user_profile.data = {};
              }
              user.user_profile.data.speciality = healthDirectoryData.libelle_savoir;
              user.user_profile.data.occupation_category = healthDirectoryData.libelle_categorie_pro;
              mss_adresses = [];
              ref = healthDirectoryData.mss_address;
              for (i = 0, len = ref.length; i < len; i++) {
                address = ref[i];
                addressFound = _.find(user.user_profile.data.mss_address, function(add) {
                  return add.value === address;
                });
                mss_adresses.push({
                  value: address,
                  selected: addressFound ? addressFound.selected : true
                });
              }
              return user.user_profile.data.mss_address = mss_adresses;
            }
          });
        } else {
          return notify({
            classes: ['alert-warning'],
            message: $filter('translate')(result.many_users ? "MULTIPLE_CAREGIVER_FOUND" : "NO_CAREGIVER_FOUND")
          });
        }
      })["finally"](function() {
        return $rootScope.busy = false;
      });
    };
    return $scope.save = function(userAccountForm) {
      var ref, selectedPatients, toUpdate, userSaveDefer;
      $rootScope.busy = true;
      toUpdate = _.cloneDeep($scope.userToEdit);
      userSaveDefer = $q.defer();
      toUpdate.group = toUpdate.group.id;
      toUpdate.entity = toUpdate.entity.id;
      toUpdate.sector = toUpdate.sector ? toUpdate.sector.id : null;
      if ($scope.previousRib !== toUpdate.user_profile.data.rib) {
        toUpdate.user_profile.data.rib_modification_date = new Date();
      }
      if (((ref = $scope.userToEdit.user_profile.data) != null ? ref.siret_perm : void 0) == null) {
        toUpdate.user_profile.data.siret_perm = $scope.userToEdit.user_profile.data.siret;
      }
      if (!$scope.autoAssingAll && $scope.dirtyPatients) {
        selectedPatients = _.map($scope.selectedPatients, "id");
        toUpdate.new_patients = _.difference(selectedPatients, $scope.selectedPatientsId);
        toUpdate.remove_patients = _.difference($scope.selectedPatientsId, selectedPatients);
        $scope.dirtyPatients = false;
        $scope.selectedPatientsId = selectedPatients;
      }
      if (toUpdate.id) {
        UserCreation.update(toUpdate).$promise.then(function(user) {
          if (user.id === $scope.user.id) {
            $scope.user = user;
          }
          return userSaveDefer.resolve(user);
        });
      } else {
        UserCreation.checkUsername({
          username: toUpdate.username
        }).$promise.then(function(response) {
          if (response.exists) {
            $scope.usernameAlreadyExists = true;
            return userSaveDefer.resolve(false);
          } else {
            return UserCreation.save(toUpdate).$promise.then(function(user) {
              return userSaveDefer.resolve(user);
            });
          }
        });
      }
      return userSaveDefer.promise.then(function(user) {
        $rootScope.busy = false;
        if (user) {
          UserUtils.cleanCache();
          $scope.userToEdit = _.cloneDeep(user);
          $scope.previousRib = $scope.userToEdit.user_profile.data.rib;
          return formatUser($scope.userToEdit, true).then(function() {
            userAccountForm.$setPristine();
            return notify({
              classes: ['alert-succes'],
              message: $filter('translate')("USER_SAVED")
            });
          });
        }
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=account-controller.js.map

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:healthDirectoryMergeModal
* @description
* Modal component which allows user to merge data from Health Directory with data filled
* **********************************************/

var HealthDirectoryMergeModalCtrl = function() {
  var ctrl = this;

  var init = function() {
    ctrl.mss_address_labels = "";

    if (ctrl.filledData.user_profile.data && ctrl.filledData.user_profile.data.mss_address) {
      ctrl.mss_address_labels = _.map(ctrl.filledData.user_profile.data.mss_address, function(address){
        return address.value;
      }).join(", ");
    }
  };

  ctrl.save = function() {
    ctrl.onClose({result: true});
  };

  init();
};

angular.module("mhclientApp").component("healthDirectoryMergeModal", {
  templateUrl: "user/components/health-directory-merge-modal/health-directory-merge-modal.html",
  controller: HealthDirectoryMergeModalCtrl,
  bindings: {
    filledData: "<",
    healthDirectoryData: "<",
    onClose: "&",
    onDismiss: "&",
  },
});
'use strict';


angular.module("mhclientApp").component("userSelection", {
  templateUrl: "user/components/views/user-selection.html",
  controller: ["UserUtils", "$q", "$filter", "$rootScope", function userSelection(UserUtils, $q, $filter, $rootScope) {
    var ctrl = this;
    ctrl.displayFields =  (!ctrl.displayFields || ctrl.displayFields.length == 0) ? ["full_name"] : ctrl.displayFields
    ctrl.availableUsers = null
    ctrl.debounce = ctrl.debounce || 300
    ctrl.limitTo = ctrl.limitTo || 300
    ctrl.minLength = ctrl.minLength || (ctrl.minLength == 0 ? ctrl.minLength : 2)
    ctrl.selectUser = function(selectedUser){
      if (!selectedUser.__disabled){
        ctrl.user = _.clone(selectedUser)
        if (ctrl.callback) {ctrl.callback({user:ctrl.user})}
      }
    }

    ctrl.$onChanges = function(changes) {
      if (changes.groups) {ctrl.availableUsers = null}
    }

    ctrl.baseGetUsers = function(filter, autoSelectCount){
      $rootScope.busy = true
      return $q.when(ctrl.getUsers ?
        ctrl.getUsers({query: filter}) :
        ctrl.availableUsers ||((ctrl.patientId ||  ctrl.entityId)? UserUtils.getUsersForPatient(null, {patient:ctrl.patientId, entity: ctrl.entityId}): UserUtils.getUsers())
      ).then (function(users) {
        if (!ctrl.availableUsers && !ctrl.getUsers){
          users = _.filter(users, "is_active")
          if ((ctrl.groups || []).length > 0 ) {users = _.filter(users, function(user){ return _.includes(ctrl.groups, user.group.uid)})}
          users = _.map(users, function(user){ return _.assign(
              _.pick(user, ["username", "email", "full_name", "sector", ]),
              _.pick(user, ctrl.extraPick),
              _.pick(user.user_profile, ["ext_id", "id_nat", "finess", "data", "pro_category", "occupation", "phone"]),
              {"group": _.pick(user.group, ["uid", "name", "is_med_traitant", "liberal", "short_name"]),}
          )})
          if (ctrl.queries){ _.forEach(ctrl.queries, function(query) { users = _.filter(users, query)})}
          _.forEach(users, function(user){ user.__display = (_.map(ctrl.displayFields, function(field){return _.get(user, field)})).join(" ")})
        }
        ctrl.availableUsers = users
        var alreadySelected = _.map(ctrl.selectedUsers, "username")
        users = _.reject(users, function(user) { return _.includes(alreadySelected, user.username)})
        $rootScope.busy = false
        var filteredUsers = $filter('filter')(users, {"__display": filter})
        if (filteredUsers.length == 0){
          filteredUsers.push({"__display": $filter("translate")("No recipient found"), "__disabled": "true"})
        }

        filteredUsers = $filter("orderBy")(filteredUsers, "__display")
        if (autoSelectCount){_.forEach(filteredUsers.slice(0, autoSelectCount), ctrl.selectUser)}
        return filteredUsers
      })
    }

    if (ctrl.autoSelectCount && ctrl.autoSelectCount > 0){
      ctrl.baseGetUsers("", ctrl.autoSelectCount )

    }

  }],
  bindings: {user:"=?", queries: "<", getUsers: "&?", groups: "<", debounce: "<", callback: '&?', entityId: "<", placeHolder: "<", appendToBody: "<", displayFields: "<", singleChoice: "<", minLength: "<", readOnly: "<", required: "<", patientId: "<", limitTo: "<?", selectedUsers: "<", autoSelectCount: "<?", extraPick: "<?"},
});

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:SvgCtrl
    * @description
    * # SvgCtrl
    * Controller of Patient current measures
   */
  angular.module('mhclientApp').controller('SvgCtrl', ["$scope", "$rootScope", function($scope, $rootScope) {
    $rootScope.busy = true;
    $scope.svg_iframe_url = $scope.base_iframe_url + '/webfw/svg_mgr/stay_' + $rootScope.currentStay.id;
    if ($scope.allStays) {
      $scope.svg_iframe_url = $scope.svg_iframe_url + "/pat_" + $rootScope.currentPatient.id;
    }
    $scope.svg_iframe_url = $scope.svg_iframe_url + '/browse_sigs';
    $scope.iframeLoadCallback = function() {
      return $rootScope.$evalAsync(function() {
        return $rootScope.busy = false;
      });
    };
    return $scope.$on("$destroy", function() {
      return $rootScope.busy = false;
    });
  }]);

}).call(this);

//# sourceMappingURL=svg-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:takeMeasures
    * @description
    * Directive of takeMeasures
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').directive('takeMeasures', ["VKI_CONFIG", function(VKI_CONFIG) {
    return {
      restrict: 'E',
      compile: function(element, attrs) {
        if (attrs.isDirty == null) {
          attrs.isDirty = "false";
        }
        if (attrs.isInvalid == null) {
          return attrs.isInvalid = "false";
        }
      },
      templateUrl: 'measures/views/take-measures.html',
      scope: {
        stay: '=',
        isDirty: '=',
        isInvalid: "=",
        hideSaveButton: "="
      },
      controller: ["$scope", "$element", "$rootScope", "$q", "PatientMeasuresTypes", "Measures", "notify", "$filter", "$uibModal", function($scope, $element, $rootScope, $q, PatientMeasuresTypes, Measures, notify, $filter, $uibModal) {
        var confirmExitDialog;
        $scope.$watch(function() {
          $scope.isDirty = $scope.measuresForm && $scope.measuresForm.$dirty && _.some(_.map($scope.mtypes || [], "value"), Boolean);
          return $scope.isInvalid = $scope.measuresForm && $scope.measuresForm.$invalid;
        });
        $scope.enterSubmit = function() {
          return angular.element(document.activeElement).parent().next().find("input").focus();
        };
        $scope.canTakeMeasures = $rootScope.checkPermissions("SVG", "CAN_WRITE");
        PatientMeasuresTypes.getPatientMeasureTypes($scope.stay.patient).then(function(mtypes) {
          var cols, i, keys, len, mtype, params, ref, result;
          for (i = 0, len = mtypes.length; i < len; i++) {
            mtype = mtypes[i];
            mtype.vkey_name = "measure_" + mtype.uid;
            if (mtype.input_type === "s") {
              params = mtype.input.split("|");
              mtype.sliderOptions = {
                floor: parseInt(params[0]),
                ceil: parseInt(params[2]),
                step: parseInt(params[1]),
                hidePointerLabels: true,
                showTicks: true,
                floorLabel: mtype.metadata.text_min || params[0],
                ceilLabel: mtype.metadata.text_max || params[2],
                onChange: function() {
                  return $scope.measuresForm.$setDirty();
                },
                translate: function(value, slider, label) {
                  if (label === "floor") {
                    return this.options.floorLabel;
                  }
                  if (label === "ceil") {
                    return this.options.ceilLabel;
                  }
                  return "";
                }
              };
            }
            if (mtype.input_type === "n" && (ref = mtype.vkey_name, indexOf.call(VKI_CONFIG.layout, ref) < 0)) {
              result = mtype.input.split("|");
              cols = result[0] || 3;
              params = result[1];
              keys = [];
              _.forEach(result[1], function(key, index) {
                var col, row;
                row = Math.floor(index / cols);
                col = index % cols;
                if (row >= keys.length) {
                  keys.push([]);
                }
                if (key === "^") {

                } else if (key === "c") {
                  return keys[row][col] = [$filter('translate')('keyboard_Bksp'), "Bksp"];
                } else if (key === "v") {
                  if (col !== 0) {
                    return keys.push([[$filter('translate')('keyboard_Enter'), "Enter"]]);
                  } else {
                    return keys[row][col] = [$filter('translate')('keyboard_Enter'), "Enter"];
                  }
                } else if (key === "r") {

                } else {
                  return keys[row].push([key, key]);
                }
              });
              VKI_CONFIG.layout[mtype.vkey_name] = {
                'name': mtype.vkey_name,
                'keys': keys,
                'lang': ["custom-num"]
              };
            }
          }
          return $scope.mtypes = mtypes;
        });
        $scope.saveMeasures = function() {
          var measures;
          $rootScope.busy = true;
          measures = [];
          $scope.mtypes.forEach(function(mtype) {
            var values;
            if (mtype.value) {
              values = {
                mtype: mtype.id,
                value: mtype.metadata.TO_INTERNAL ? math.evaluate(mtype.metadata.TO_INTERNAL, {
                  SELF: mtype.value
                }) : mtype.value,
                stay: $scope.stay.id,
                author: $rootScope.user.id,
                timestamp: new Date()
              };
              return measures.push(values);
            }
          });
          return Measures.api.saveMeasures({
            'measures': measures,
            'stay': $scope.stay.id
          }).$promise.then(function() {
            return $rootScope.busy = false;
          });
        };
        confirmExitDialog = function() {
          return $uibModal.open({
            animation: true,
            templateUrl: 'core/views/modal-template.html',
            size: "lg",
            controller: 'mhModalCtrl',
            resolve: {
              title: function() {
                return $filter('translate')("DOC_NOT_SAVED");
              },
              text: function() {
                if (!$scope.isInvalid) {
                  return $filter('translate')("GENERIC_CONFIRM_CLOSE_NOT_SAVED");
                } else {
                  return $filter('translate')("CONFIRM_CLOSE_NOT_VALID");
                }
              },
              cancelButtonText: function() {
                return $filter('translate')("CANCEL_BUTTON");
              },
              noButtonText: function() {
                return $filter('translate')("DONT_SAVE_BUTTON");
              },
              okButtonText: function() {
                var okButtonText;
                if (!$scope.isInvalid) {
                  return $filter('translate')("SAVE_BUTTON");
                } else {
                  return okButtonText = null;
                }
              }
            }
          });
        };
        $scope.$on('validateRequest', function(event) {
          if ($scope.isDirty) {
            if (!event.validatePromises) {
              event.validatePromises = [];
            }
            return event.validatePromises.push($scope.saveMeasures());
          }
        });
        $scope.$on('closeRequested', function(event) {
          if ($scope.isDirty) {
            if (!event.closePromises) {
              event.closePromises = [];
            }
            return event.closePromises.push($scope.handleStateChangePromise());
          }
        });
        return $scope.handleStateChangePromise = function() {
          var stateChangePromise;
          $rootScope.busy = true;
          stateChangePromise = $q.defer();
          confirmExitDialog().result.then((function(toSave) {
            $rootScope.busy = false;
            if (toSave) {
              return $scope.saveMeasures().then(function() {
                return stateChangePromise.resolve(true);
              });
            } else {
              return stateChangePromise.resolve(_.forEach($scope.mtypes, function(mtype) {
                return delete mtype.value;
              }));
            }
          }), (function(e) {
            $rootScope.busy = false;
            return stateChangePromise.reject();
          }));
          return stateChangePromise.promise;
        };
      }]
    };
  }]);

}).call(this);

//# sourceMappingURL=take-measures-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Measures
    * @description
    * # Measures
    * Factory of Measures
   */
  angular.module("mhclientApp").factory('MeasuresTypes', ["$resource", "MhConfig", "BoxResource", "$q", "$rootScope", "$filter", function($resource, MhConfig, BoxResource, $q, $rootScope, $filter) {
    var acceptHeader, api, measuresTypes, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/measuretypes/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          Accept: acceptHeader
        },
        isArray: true
      },
      create: {
        method: 'POST'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        measuresTypes = window.mgapp.get('measure_mgr').measure_type();
        api = BoxResource.generate(measuresTypes);
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('PatientMeasuresTypes', ["$resource", "MhConfig", "BoxResource", "$q", "$rootScope", "$filter", "MeasuresTypes", function($resource, MhConfig, BoxResource, $q, $rootScope, $filter, MeasuresTypes) {
    var acceptHeader, api, getMeasureTypes, getPatientMeasureTypes, measureTypesCache, measuresTypes, portailAPI, resetCache, service;
    measureTypesCache = null;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/take_measures/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          Accept: acceptHeader
        },
        isArray: true
      },
      create: {
        method: 'POST'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        measuresTypes = window.mgapp.get('measure_mgr').patient_measure();
        api = BoxResource.generate(measuresTypes);
    }
    resetCache = function() {
      return measureTypesCache = null;
    };
    getMeasureTypes = function() {
      var measureTypesPromise;
      measureTypesPromise = $q.defer();
      if (!measureTypesCache) {
        MeasuresTypes.api.query().$promise.then(function(measureTypes) {
          measureTypesCache = measureTypes;
          return measureTypesPromise.resolve(measureTypes);
        });
      } else {
        measureTypesPromise.resolve(measureTypesCache);
      }
      return measureTypesPromise.promise;
    };
    getPatientMeasureTypes = function(patientId) {
      var mtypeList, params, patientMeasureTypesPromise;
      patientMeasureTypesPromise = $q.defer();
      params = {};
      params.patient = patientId;
      mtypeList = [];
      if (MhConfig.platform === 'mgapp') {
        MeasuresTypes.api.query().$promise.then(function(mtypes) {
          return patientMeasureTypesPromise.resolve(_.filter(mtypes, function(mt) {
            return !('FUNC' in mt.metadata);
          }));
        });
      } else {
        api.query(params).$promise.then(function(patientMeasureTypes) {
          return getMeasureTypes().then(function(mtypes) {
            _.forEach(patientMeasureTypes, function(patMeasType) {
              var input, mtype;
              mtype = _.find(mtypes, {
                id: patMeasType.measure_type
              });
              patMeasType.metadata = _.assign(angular.copy(mtype.metadata), patMeasType.metadata);
              if ('FUNC' in patMeasType.metadata) {
                return;
              }
              mtypeList.push(patMeasType);
              patMeasType.metadata.text_min = patMeasType.metadata.TEXT_MIN;
              patMeasType.metadata.text_max = patMeasType.metadata.TEXT_MAX;
              input = patMeasType.metadata.INPUT.split("|");
              patMeasType.input_type = input.shift();
              patMeasType.id = patMeasType.measure_type;
              return patMeasType.input = input.join("|");
            });
            return patientMeasureTypesPromise.resolve(mtypeList);
          });
        });
      }
      return patientMeasureTypesPromise.promise;
    };
    service = {
      api: api,
      getPatientMeasureTypes: getPatientMeasureTypes,
      getMeasureTypes: getMeasureTypes,
      resetCache: resetCache
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('Measures', ["$resource", "MhConfig", "BoxResource", "$q", "$rootScope", "$filter", function($resource, MhConfig, BoxResource, $q, $rootScope, $filter) {
    var acceptHeader, api, measures, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/measures/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          Accept: acceptHeader
        },
        isArray: true
      },
      create: {
        method: 'POST'
      },
      saveMeasures: {
        method: 'POST',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true,
        params: {
          route: 'save_measures'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        measures = window.mgapp.get('measure_mgr').measure();
        api = BoxResource.generate(measures);
        api.saveMeasures = function(object) {
          return BoxResource.mhboxApiCall(measures, "save_measures", object);
        };
    }
    service = {
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=measures-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms:MedFormsCtrl
    * @description
    * # MedFormsCtrl
    * Controller of MedFormsCtrl
   */
  angular.module('mhclientApp').controller('MedFormsCtrl', ["$scope", "$filter", "$sce", function($scope, $filter, $sce) {
    $scope.noForm = $filter('translate')('NO_FORM');
    $scope.oneForm = $filter('translate')('ONE_FORM');
    $scope.severalForm = $filter('translate')('SEVERAL_FORMS');
    $scope.trustAsHtml = function(html) {
      return $sce.trustAsHtml(html);
    };
    $scope.filterTemplates = function(search_text, allTemplates, groupedForms) {
      var group, has_search_text, i, j, len, len1, ref, regex, results, searchVal, template;
      has_search_text = (search_text != null) && search_text.length > 0;
      if (has_search_text) {
        searchVal = search_text.replace(/([()[{*+.$^\\|?])/g, '\\$1');
        regex = new RegExp('' + searchVal, 'i');
      }
      ref = allTemplates || [];
      for (i = 0, len = ref.length; i < len; i++) {
        template = ref[i];
        template.hidden = has_search_text && !(regex.test(template.current.name) || regex.test(template.current.ref) || (template.last_form_version_by_stay && regex.test(template.last_form_version_by_stay.author.full_name)));
      }
      results = [];
      for (j = 0, len1 = groupedForms.length; j < len1; j++) {
        group = groupedForms[j];
        results.push(group.hidden = !_.some(group.templates, ['hidden', false]));
      }
      return results;
    };
    return $scope.handleUserSelection = function(group) {
      group.preopen = !group.preopen;
      if ($scope.user.preopenFormGroups == null) {
        $scope.user.preopenFormGroups = [];
      }
      if (group.preopen) {
        return $scope.user.preopenFormGroups.push(group.id);
      } else {
        return _.remove($scope.user.preopenFormGroups, function(n) {
          return n === group.id;
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=medforms-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms:MedFormsCrhCtrl
    * @description
    * # MedFormsCrhCtrl
    * Controller of crh medical forms
   */
  angular.module('mhclientApp').controller('MedFormsCrhCtrl', ["$scope", "$rootScope", "$state", "FormTemplateUtils", function($scope, $rootScope, $state, FormTemplateUtils) {
    $rootScope.busy = true;
    $scope.utils = $rootScope.utils;
    return FormTemplateUtils.getCRH().then(function(crhTemplate) {
      $rootScope.busy = false;
      return $state.go("user.patient.stay.form.template", {
        'idTemplate': crhTemplate.id
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=medforms-crh-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms:MedFormsCrEntryCtrl
    * @description
    * # MedFormsCrEntryCtrl
    * Controller of crh medical forms
   */
  angular.module('mhclientApp').controller('MedFormsCrEntryCtrl', ["$scope", "$rootScope", "$state", "FormTemplateUtils", function($scope, $rootScope, $state, FormTemplateUtils) {
    $rootScope.busy = true;
    $scope.utils = $rootScope.utils;
    return FormTemplateUtils.getCREntry().then(function(crEntryTemplate) {
      $rootScope.busy = false;
      return $state.go("user.patient.stay.form.template", {
        'idTemplate': crEntryTemplate.id
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=medforms-cr-entry-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms:MedFormsRedirectCtrl
    * @description
    * # MedFormsRedirectCtrl
    * Controller of redirect for medicalform
   */
  angular.module('mhclientApp').controller('MedFormsRedirectCtrl', ["$scope", "$rootScope", "$state", "FormTemplateUtils", function($scope, $rootScope, $state, FormTemplateUtils) {
    $rootScope.busy = true;
    return FormTemplateUtils.getTemplates({
      uid: $state.params.templateUID
    }).then(function(template) {
      $rootScope.busy = false;
      return $state.go("user.patient.stay.form.template", {
        'idTemplate': template.id,
        'versionID': $state.params.versionID
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=medforms-redirect-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:medicalfrom utils
    * @description
    * # Template
   */
  angular.module("mhclientApp").factory('MedFormsUtils', ["$q", "$rootScope", "$templateCache", "$http", "$timeout", "taSanitize", "FormGroupConfig", "TemplateVersion", "$filter", "Entity", "SiteVarsUtils", "Sector", "MedicalUnit", "Feed", "Thread", "Message", "Psp", "HealthIssue", "PrescUtils", "Prescription", "$compile", function($q, $rootScope, $templateCache, $http, $timeout, taSanitize, FormGroupConfig, TemplateVersion, $filter, Entity, SiteVarsUtils, Sector, MedicalUnit, Feed, Thread, Message, Psp, HealthIssue, PrescUtils, Prescription, $compile) {
    var GlobalGroups, copyData, copyOtherData, copyPatientData, copyStayData, copyVitalSigns, extractFields, extractKeys, extractVersionDynamicFields, featureToHtmlText, fetchContainer, fetchData, fetchDynamicFields, fetchMonoThreads, fetchPrescriptions, fetchTemplateVersionContainers, filterEntries, formInputFields, genIASText, genMedicalObsText, genPSP2Text, genPSPText, genPrescText, getGroupsConfig, getPSP2, getStaticData, globalGroupsPromise, initVersion, resetCache, service, staticDataDefinition, urlToBase64, userDataStaticFields;
    GlobalGroups = null;
    globalGroupsPromise = $q.defer();
    userDataStaticFields = function(prefix, label) {
      return _.orderBy([
        {
          key: prefix + ".id_nat",
          label: label + "." + $filter('translate')("ID_NAT") + " (id_nat)"
        }, {
          key: prefix + ".phone",
          label: label + "." + $filter('translate')("PHONE_NUMBER") + " (data.PHONE_NUMBER)"
        }, {
          key: prefix + ".data.address_data.town",
          label: label + "." + $filter('translate')("TOWN") + " (data.address_data.town)"
        }, {
          key: prefix + ".data.address_data.address",
          label: label + "." + $filter('translate')("ADDRESS") + " (data.address_data.address)"
        }, {
          key: prefix + ".data.address_data.zip_code",
          label: label + "." + $filter('translate')("ZIP") + " (data.address_data.zip_code)"
        }, {
          key: prefix + ".data.address_data.country",
          label: label + "." + $filter('translate')("COUNTRY") + " (data.address_data.country)"
        }, {
          key: prefix + ".email",
          label: label + "." + $filter('translate')("email") + " (email)"
        }, {
          key: prefix + ".ext_id",
          label: label + "." + $filter('translate')("ext_id") + " (ext_id)"
        }, {
          key: prefix + ".finess",
          label: label + "." + $filter('translate')("finess") + " (finess)"
        }, {
          key: prefix + ".full_name",
          label: label + "." + $filter('translate')("full_name") + " (full_name)"
        }, {
          key: prefix + ".group.name",
          label: label + "." + $filter('translate')("group") + " (group.name)"
        }, {
          key: prefix + ".occupation",
          label: label + "." + $filter('translate')("occupation") + " (occupation)"
        }
      ], "label");
    };
    staticDataDefinition = function() {
      return SiteVarsUtils.getValue("PAC_DATA_STRUCT").then(function(pacDataStruct) {
        var filterByType;
        filterByType = {
          "CIM10": "|JOIN:name,code",
          "ALLERGIES": "|JOIN:name,code",
          "MULTI_CIM10": "|JOIN:name,code",
          "CCAM": "|JOIN:name,code"
        };
        return _.concat([
          {
            key: "staticData.today",
            label: "today"
          }, {
            key: "staticData.patient.si_id",
            label: "Patient." + $filter('translate')("PATIENT_ID") + " (si_id)"
          }, {
            key: "staticData.patient.address_data.town",
            label: "Patient." + $filter('translate')("TOWN") + " (address_data.town)"
          }, {
            key: "staticData.patient.address_data.phone",
            label: "Patient." + $filter('translate')("PHONE") + " (address_data.phone)"
          }, {
            key: "staticData.patient.address_data.mobil",
            label: "Patient." + $filter('translate')("MOBILE") + " (address_data.mobil)"
          }, {
            key: "staticData.patient.address_data.address",
            label: "Patient." + $filter('translate')("ADDRESS") + " (address_data.address)"
          }, {
            key: "staticData.patient.address_data.zip_code",
            label: "Patient." + $filter('translate')("ZIP") + " (address_data.zip_code)"
          }, {
            key: "staticData.patient.address_data.complementary_address",
            label: "Patient." + $filter('translate')("COMPLEMENTARY_ADDRESS") + " (address_data.complementary_address)"
          }, {
            key: "staticData.patient.data.ins",
            label: "Patient." + $filter('translate')("INS") + "(data.ins)"
          }, {
            key: "staticData.patient.data.ins_type",
            label: "Patient.INS." + $filter('translate')("INS_TYPE") + "(data.ins_type)"
          }, {
            key: "staticData.patient.data.place_of_birth",
            label: "Patient.INS." + $filter('translate')("BIRTH_PLACE_CODE") + "(data.place_of_birth)"
          }, {
            key: "staticData.patient.data.first_names_atbirth",
            label: "Patient.INS." + $filter('translate')("FIRST_NAMES") + "(data.first_names_atbirth)"
          }, {
            key: "staticData.patient.data.first_name_atbirth",
            label: "Patient.INS." + $filter('translate')("FIRST_FIRST_NAME") + "(data.first_name_atbirth)"
          }, {
            key: "staticData.patient.full_name",
            label: "Patient." + $filter('translate')("Full Name") + " (full_name)"
          }, {
            key: "staticData.patient.last_name",
            label: "Patient." + $filter('translate')("OFFICIAL_NAME") + " (last_name)"
          }, {
            key: "staticData.patient.name",
            label: "Patient." + $filter('translate')("USED_FIRST_NAME") + " (name)"
          }, {
            key: "staticData.patient.maidenname",
            label: "Patient." + $filter('translate')("MAIDEN_NAME") + " (maidenname)"
          }, {
            key: "staticData.patient.birthday|date",
            label: "Patient." + $filter('translate')("BIRTHDAY") + " (birthday)"
          }, {
            key: "staticData.patient.age",
            label: "Patient." + $filter('translate')("Age") + " (age)"
          }, {
            key: "staticData.patient.gender|genderDisplay",
            label: "Patient." + $filter('translate')("GENDER") + " (gender)"
          }, {
            key: "staticData.patient.gender|genderDisplay:short",
            label: "Patient." + $filter('translate')("GENDER") + "_short (gender)"
          }, {
            key: "staticData.stay.si_id",
            label: "Sejour." + $filter('translate')("Stay number") + " (si_id)"
          }, {
            key: "staticData.stay.d_from|date",
            label: "Sejour." + $filter('translate')("BEGIN_DATE") + " (d_from)"
          }, {
            key: "staticData.stay.d_to|date",
            label: "Sejour." + $filter('translate')("END_DATE") + " (d_to)"
          }, {
            key: "staticData.stay.sector_name",
            label: "Sejour." + $filter('translate')("SECTOR") + " (sector_name)"
          }, {
            key: "staticData.stay.medical_unit_name",
            label: "Sejour." + $filter('translate')("Medical unit") + " (medical_unit_name)"
          }
        ], _.map(_.find(pacDataStruct, {
          ID: "MEDICAL_DATA"
        }).FIELDS, function(field) {
          return {
            key: "staticData.stay.medical_data." + field.ID + (filterByType[field.TYPE] || ""),
            label: "Sejour.MEDICAL_DATA." + field.LABEL + " (" + field.TYPE + ")"
          };
        }), _.map(_.find(pacDataStruct, {
          ID: "MEDICAL_DATA"
        }).FIELDS, function(field) {
          return {
            key: "staticData.stay.pread_medical_data." + field.ID + (filterByType[field.TYPE] || ""),
            label: "Sejour.PREAD_MEDICAL_DATA." + field.LABEL + " (" + field.TYPE + ")"
          };
        }), _.map(_.concat(Entity.sectorFields, [
          {
            label: "site_id",
            key: "site_id"
          }
        ]), function(field) {
          return {
            key: "staticData.entityFields." + field.key,
            label: "entity." + $filter("translate")(field.label)
          };
        }));
      });
    };
    getStaticData = function(patient, stay) {
      var customScope;
      customScope = {
        "entityFields": {},
        "today": moment().format('YYYY-MM-DD'),
        "patientForTest": {
          "si_id": "si_id test",
          "id": 0,
          "data": {
            "ins": "test_ins",
            "place_of_birth": "18140",
            "first_name_atbirth": "LEO",
            "identity_valid_tag": "PROV",
            "first_names_atbirth": "LEO"
          },
          "social_data": {},
          "address_data": {
            "mobil": "000007711",
            "phone": "9887661234",
            "town": "town test ",
            "address": "address test",
            "zip_code": "zip_code test",
            "complementary_address": "complementary_address test"
          },
          "full_name": "full_name test",
          "last_name": "last_name test",
          "maidenname": "maidenname test",
          "name": "name test",
          "birthday": "2022-10-20",
          "age": 0,
          "gender": "M",
          "is_dead": false,
          "vital_signs_data": {}
        },
        "stayForTest": {
          "id": 0,
          "si_id": "stay test si_id",
          "d_from": "2022-10-19T07:44:41.780145",
          "d_to": "2022-10-19T07:44:41.780145",
          "medical_unit_name": "test medical unit",
          "order_data": {
            "delivery_day": 1
          },
          "medical_data": {
            "PATHO_PRIMARY": [
              {
                "name": "pato1",
                "code": "code1"
              }
            ],
            "PATHO_SECONDARY": [
              {
                "name": "pato2",
                "code": "code2"
              }
            ],
            "ALLERGIES_LIST": [
              {
                "name": "pato1",
                "code": "code1"
              }
            ],
            "MODE_PEC_PRIMARY": "00: 600",
            "MODE_PEC_LINKED": "01: 800"
          },
          "pread_medical_data": {},
          "state": "ADM",
          "patient": 1,
          "sector_name": "sector test name",
          "data": {},
          "preadmission": {},
          "care_organisation": {},
          "identitovigilance": {},
          "social_info": {}
        }
      };
      return $q.when($rootScope.mh_config.platform === "mgapp" ? [{}] : Entity.getEntities()).then(function(entities) {
        customScope.stayForTest.entity = entities[0].id;
        return $q.when(patient || customScope.patientForTest).then(function(patient) {
          customScope.patient = patient;
          return $q.when(stay || customScope.stayForTest).then(function(stay) {
            customScope.stay = stay;
            return $q.when(customScope.stay.medical_unit ? MedicalUnit.getMedicalUnits().then(function(medicalUnits) {
              return _.find(medicalUnits, {
                id: customScope.stay.medical_unit
              }).name;
            }) : customScope.stay.medical_unit_name).then(function(medical_unit_name) {
              customScope.stay.medical_unit_name = medical_unit_name;
              return $q.when(customScope.stay.sector ? Sector.getSectors().then(function(sectors) {
                return _.find(sectors, {
                  id: customScope.stay.sector
                }).name;
              }) : customScope.stay.sector_name).then(function(sector_name) {
                customScope.stay.sector_name = sector_name;
                return $q.all(_.map(_.map(_.concat(Entity.sectorFields, [
                  {
                    label: "site_id",
                    key: "site_id"
                  }
                ]), "key"), function(key) {
                  return SiteVarsUtils.get(key, null, customScope.stay.entity, false, customScope.stay.sector).then(function(siteVar) {
                    return customScope.entityFields[key] = siteVar.value;
                  });
                })).then(function() {
                  return customScope;
                });
              });
            });
          });
        });
      });
    };
    resetCache = function() {
      GlobalGroups = null;
      return globalGroupsPromise = $q.defer();
    };
    filterEntries = function(entries, query, many) {
      var result;
      if (query) {
        result = many ? _.filter(entries, query) : _.find(entries, query);
      } else {
        result = entries;
      }
      return result;
    };
    getGroupsConfig = function(query, many) {
      var groupConfigDone;
      groupConfigDone = $q.defer();
      if (GlobalGroups != null) {
        globalGroupsPromise.promise.then(function() {
          return groupConfigDone.resolve(filterEntries(GlobalGroups, query, many));
        });
      } else {
        GlobalGroups = {};
        FormGroupConfig.query().$promise.then(function(groupConfig) {
          GlobalGroups = groupConfig;
          globalGroupsPromise.resolve();
          return groupConfigDone.resolve(filterEntries(GlobalGroups, query, many));
        });
      }
      return groupConfigDone.promise;
    };
    urlToBase64 = function(url) {
      var done, request;
      done = $q.defer();
      request = new XMLHttpRequest();
      request.open('GET', url, true);
      request.responseType = 'blob';
      request.onload = function() {
        var reader;
        reader = new FileReader();
        reader.readAsDataURL(request.response);
        return reader.onload = function(e) {
          return done.resolve(e.target.result);
        };
      };
      request.send();
      return done.promise;
    };
    fetchTemplateVersionContainers = function(version) {
      return $q.all(_.map(version.meta.containers, function(container) {
        if (version.content_type === "STRUCTURED") {
          return $q.when(container.dynamicForm ? {
            data: container.dynamicForm
          } : (container.dynamic_form ? $http.get(container.dynamic_form + "?" + moment().toISOString()) : {
            data: {
              "fields": []
            }
          })).then(function(result) {
            return container.dynamicForm = result.data;
          });
        } else if (version.content_type === "HTML") {
          return $q.when(container.htmlContent ? {
            data: container.htmlContent
          } : (container.html ? $http.get(container.html + "?" + moment().toISOString()) : {
            data: ""
          })).then(function(result) {
            return container.htmlContent = result.data;
          });
        } else {
          return $q.when(container.backgroundContent ? container.backgroundContent : urlToBase64(container.background)).then(function(result) {
            container.backgroundContent = result;
            return $q.when(container.labelContent ? {
              data: container.labelContent
            } : (container.label ? $http.get(container.label + "?" + moment().toISOString()) : {
              data: ""
            })).then(function(result) {
              return container.labelContent = result.data;
            });
          });
        }
      }));
    };
    fetchContainer = function(container, disableCache) {
      return $q.when(container.dataContent ? {
        data: container.dataContent
      } : $http.get(container.dataUrl)).then(function(result) {
        container.dataContent = result.data;
        if (container.dynamic_form) {
          return $q.when(container.dynamicForm ? {
            data: container.dynamicForm
          } : $http.get(container.dynamic_form + (disableCache ? "?" + moment().toISOString() : ""))).then(function(result) {
            return container.dynamicForm = result.data;
          });
        } else {
          return $q.when(container.htmlContent ? {
            data: container.htmlContent
          } : $http.get(container.html + (disableCache ? "?" + moment().toISOString() : ""))).then(function(result) {
            return container.htmlContent = result.data;
          });
        }
      });
    };
    initVersion = function(newVersion, template, templateVersion, patient, stay, previousId, disableCache) {
      _.forEach(newVersion.containers, function(container) {
        return container.dataContent = newVersion.type_form === 'IMG' ? [] : {};
      });
      if (newVersion.type_form === "STRUCT") {
        return TemplateVersion.get_data_new_form_version({
          id: newVersion.template_version,
          'previous': previousId,
          'stay': stay.id
        }).$promise.then(function(data) {
          return $q.all(_.map(data.form_by_uid, function(url, formUid) {
            return $http.get(url).then(function(formData) {
              return data.form_by_uid[formUid] = formData.data;
            });
          })).then(function() {
            var container;
            container = newVersion.containers[0];
            return fetchContainer(container, disableCache).then(function() {
              _.forEach((templateVersion.meta.data_copy || {})["forms"] || [], function(form_copy) {
                return copyData(container.dataContent, form_copy, data.form_by_uid[form_copy.name === "self" ? template.uid : form_copy.name] || {});
              });
              copyOtherData(patient, stay, container.dataContent, templateVersion.meta.data_copy || {});
              if (container.dynamicForm != null) {
                return $q.all([fetchDynamicFields(container.dynamicForm.fields, container.dataContent, template, data.form_by_uid, patient, stay), fetchDynamicFields((container.dynamicForm.header || {}).fields, container.dataContent, template, data.form_by_uid, patient, stay), fetchDynamicFields((container.dynamicForm.footer || {}).fields, container.dataContent, template, data.form_by_uid, patient, stay), fetchDynamicFields((container.dynamicForm.left_margin || {}).fields, container.dataContent, template, data.form_by_uid, patient, stay), fetchDynamicFields((container.dynamicForm.right_margin || {}).fields, container.dataContent, template, data.form_by_uid, patient, stay)]).then(function() {
                  return newVersion;
                });
              } else {
                return newVersion;
              }
            });
          });
        });
      } else {
        return newVersion;
      }
    };
    extractKeys = function(root, inputs) {
      return _.concat(extractFields(root.fields, inputs), extractFields((root.header || {}).fields, inputs), extractFields((root.footer || {}).fields, inputs), extractFields((root.left_margin || {}).fields, inputs), extractFields((root.right_margin || {}).fields, inputs));
    };
    extractFields = function(fields, keys) {
      return [].concat.apply(_.map(_.filter(fields, function(field) {
        return !keys || keys.indexOf(field.type) >= 0;
      }), function(field) {
        return angular.copy(field);
      }), _.map(fields, function(field) {
        return extractFields(field.fields || [], keys);
      }));
    };
    extractVersionDynamicFields = function(version) {
      return fetchTemplateVersionContainers(version).then(function() {
        return extractKeys(version.meta.containers[0].dynamicForm, formInputFields);
      });
    };
    genPSPText = function(thread, content) {
      var category, fullText, index;
      category = $filter('translate')($filter('uppercase')(thread.first_message.category));
      fullText = "<p><strong>" + category + ":</strong> " + " - <u>";
      fullText += $filter("date")(thread.first_message.timestamp, "dd MMM yyyy") + " :</u> " + "<br/>";
      fullText += content.data.freeZone.split('\n').join('<br/>');
      fullText += '<br/>';
      index = 1;
      content.data.objectives.forEach(function(objective) {
        fullText += $filter('translate')("OBJECTIVE") + index;
        fullText += ": " + objective + '<br/>';
        return index = index + 1;
      });
      fullText += '</p>';
      return fullText;
    };
    genMedicalObsText = function(medicalObs, content) {
      var fullText;
      fullText = "<p><strong>" + medicalObs.first_message.data.subject + "</strong> - <u>";
      fullText += $filter("date")(medicalObs.first_message.data.eventDate, "dd MMM yyyy") + " : </u>";
      fullText += '<br/>';
      if (content.mode === "text") {
        fullText += _.escape(content.data).split('\n').join('<br/>');
      } else {
        fullText += $filter('translate')("IMPOSSIBLE_TO_SHOW_PSP_IMAGE");
      }
      fullText += '</p>';
      return fullText;
    };
    genIASText = function(IAS, content) {
      var fullText;
      fullText = "<p><u>" + $filter("date")(IAS.first_message.timestamp, "dd MMM yyyy") + " :</u> ";
      fullText += '<br/>';
      if (IAS.data.otherAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label other-alert mhicon mhico-thermometer"></span>' + $filter('translate')("OTHER_ALERT");
        fullText += '</span>';
      }
      if (IAS.data.contactAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label contact-alert mhicon mhico-hand"></span>' + $filter('translate')("CONTACT_ALERT");
        fullText += '</span>';
      }
      if (IAS.data.dropAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label droplet-alert mhicon mhico-medical-mask"></span>' + $filter('translate')("DROPS_ALERT");
        fullText += '</span>';
      }
      if (IAS.data.airAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label air-alert mhicon mhico-medical-mask-ffp2"></span>' + $filter('translate')("AIR_ALERT");
        fullText += '</span>';
      }
      if (IAS.data.scabiesAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label scabies-alert mhicon mhico-google"></span>' + $filter('translate')("SCABIES_ALERT");
        fullText += '</span>';
      }
      fullText += '<br/>';
      if (content.mode === "text") {
        if (content.data.diagnosis_date != null) {
          fullText += 'diagnostiqué le : ' + $filter('date')(content.data.diagnosis_date) + '<br/>';
        }
        fullText += 'BMR : ' + $filter('translate')($filter('boolToYes')(content.data.BMR)) + '<br/>';
        fullText += 'BHRe : ' + $filter('translate')($filter('boolToYes')(content.data.BHRe)) + '<br/>';
        fullText += 'traité : ' + $filter('translate')($filter('boolToYes')(content.data.treated)) + '<br/>';
        if (content.data.germ_name != null) {
          fullText += 'germe : ' + content.data.germ_name + '<br/>';
        }
        if (content.data.germ_origin != null) {
          fullText += 'provenance : ' + content.data.germ_origin + '<br/>';
        }
        if (content.data.infection_area != null) {
          fullText += 'site : ' + content.data.infection_area + '<br/>';
        }
        if (content.data.antibiotic != null) {
          fullText += 'antibiotique : ' + content.data.antibiotic + '<br/>';
        }
        if (content.data.action_plan != null) {
          fullText += 'dispositif : ' + content.data.action_plan + '<br/>';
        }
        if (content.data.complementary_step != null) {
          fullText += 'mesures complémentaires : ' + content.data.complementary_step + '<br/>';
        }
      } else {
        fullText += $filter('translate')("IMPOSSIBLE_TO_SHOW_PSP_IMAGE");
      }
      fullText += '</p>\n';
      return fullText;
    };
    genPSP2Text = function(review) {
      var fullText, ref, status;
      status = $filter('translate')($filter('uppercase')(review.status));
      fullText = "<p><strong>" + status + ":</strong> " + " - <u>";
      fullText += $filter("date")(review.timestamp, "dd MMM yyyy") + "</u> ";
      if (review.modified_timestamp != null) {
        fullText += "- <u>" + $filter('translate')("MODIFIED_ON") + $filter("date")(review.modified_timestamp, "dd MMM yyyy") + "</u>";
      }
      fullText += "</p>";
      fullText += "<p><u>" + $filter('translate')('PATIENT_EXPECTATIONS') + "</u></p>";
      if (((ref = review.patientExpectations) != null ? ref.text : void 0) != null) {
        fullText += "<p>" + review.patientExpectations.text.split('\n').join('<br/>') + "</p>";
      }
      if (review.freezone.mode === 'text' && (review.freezone.text != null)) {
        fullText += "<p><u>" + $filter('translate')('FREEZONE') + "</u></p>";
        fullText += "<p>" + review.freezone.text.split('\n').join('<br/>') + "</p>";
      }
      if (review.therapeuticPrograms != null) {
        fullText += "<p><u>" + $filter('translate')('THERAPEUTIC_PROJECTS') + "</u></p>";
        review.therapeuticPrograms.forEach(function(tp) {
          var comment, objectiveThesaurusUid, ref1;
          fullText += tp.label;
          if (review.objectivesComments && (review.objectivesComments[tp.thesaurus_uid] != null) && !$rootScope.isEmpty(review.objectivesComments[tp.thesaurus_uid])) {
            fullText += "<p><u>" + $filter('translate')('STOPPED_OBJECTIVES') + "</u></p>";
            fullText += "<ul>";
            ref1 = review.objectivesComments[tp.thesaurus_uid];
            for (objectiveThesaurusUid in ref1) {
              comment = ref1[objectiveThesaurusUid];
              fullText += "<li>" + comment + "</li>";
            }
            fullText += "</ul>";
          }
          return tp.objectives.forEach(function(objective) {
            fullText += "<ul>" + "<li>" + objective.label + "</li>";
            fullText += "<ul>";
            objective.healthIssues.forEach(function(issue) {
              return fullText += "<li>" + issue.label + "</li>";
            });
            return fullText += "</ul></ul>";
          });
        });
      }
      if (review.healthIssues != null) {
        fullText += "<u>" + $filter('translate')('OTHERS_OBJECTIVES') + "</u>";
        fullText += "<ul>";
        review.healthIssues.forEach(function(issue) {
          return fullText += "<li>" + issue.label + "</li>";
        });
        fullText += "</ul>";
      }
      fullText += '\n';
      return fullText;
    };
    featureToHtmlText = {
      "MHC_PSP": genPSPText,
      "MHC_IAS": genIASText,
      "MHC_OBSERVATION": genMedicalObsText
    };
    genPrescText = function(prescription, options) {
      return PrescUtils.getPrescriptionDetails(prescription, true, true).then(function() {
        return $http.get('medication/views/presc-history-content.html').then(function(response) {
          var compiledElement;
          compiledElement = $compile(response.data)(_.assign($rootScope.$new(true), _.assign({
            currentPrescription: prescription,
            disableValidation: true,
            dateFormat: "mediumDate"
          }, options)));
          return $timeout(function() {
            return "<li>" + _.map(compiledElement, "outerHTML").join("") + "</li>";
          });
        });
      });
    };
    fetchPrescriptions = function(options, stayId) {
      return Prescription.query({
        stay: stayId,
        current_prescriptions: true,
        exclude_discharge_prescs: true
      }).$promise.then(function(prescriptions) {
        if (options.only_with_stop_reason) {
          prescriptions = _.filter(prescriptions, "data.stop_reason");
        }
        if (options.only_active) {
          prescriptions = _.filter(prescriptions, function(prescription) {
            var ref;
            return !((ref = prescription.state) === 'STOPPED' || ref === 'EXPIRED');
          });
        }
        if (options.queries) {
          _.forEach(options.queries, function(query) {
            return prescriptions = _.filter(prescriptions, query);
          });
        }
        return $q.all(_.map(prescriptions, function(prescription) {
          return genPrescText(prescription, options);
        })).then(function(prescriptionsText) {
          return "<ul>" + taSanitize(prescriptionsText.join("").replace(/<\!--.*?-->/g, "")) + "</ul>";
        });
      });
    };
    fetchMonoThreads = function(feature__name, stayId, max_threads) {
      return Feed.api.query({
        feature__name: feature__name
      }).$promise.then(function(feeds) {
        return Thread.api.query({
          feed: feeds[0].id,
          stay: stayId,
          archived: false,
          page_size: max_threads || 1000
        }).$promise.then(function(threads) {
          return $q.all(_.map(_.orderBy(threads.results, ['first_message.timestamp'], ['desc']), function(thread) {
            return Message.getMessageContent(thread.first_message).promise.then(function(content) {
              return "<li>" + featureToHtmlText[feature__name](thread, content.data) + "</li>";
            });
          })).then(function(values) {
            return "<ul>" + values.join("") + "</ul>";
          });
        });
      });
    };
    getPSP2 = function(stayID) {
      return Psp.api.query({
        "stay": stayID
      }).$promise.then(function(psps) {
        return $q.all(_.map(psps, function(psp) {
          return HealthIssue.api.query({
            "psp": psp.id
          }).$promise.then(function(healthIssues) {
            return _.map(psp.reviews, function(review) {
              return "<li>" + genPSP2Text(Psp.getReview(review, healthIssues, psp)) + "</li>";
            });
          });
        })).then(function(values) {
          return "<ul>" + values.join("") + "</ul>";
        });
      });
    };
    fetchDynamicFields = function(fields, dataContent, template, formByUid, patient, stay) {
      return $q.all(_.map(fields, function(field) {
        var i, len, ref, ref1, reprise, value;
        if (field.has_reprise && (field.key || field.uid)) {
          ref = field.reprises || [];
          for (i = 0, len = ref.length; i < len; i++) {
            reprise = ref[i];
            if (reprise.type === "single_threads") {
              return fetchMonoThreads(reprise.feature__name, stay.id, reprise.max_threads).then(function(value) {
                return dataContent[field.key || field.uid] = value;
              });
            }
            if (reprise.type === "PSP2") {
              return getPSP2(stay.id).then(function(value) {
                return dataContent[field.key || field.uid] = value;
              });
            } else if (reprise.type === "patient") {
              value = _.get(patient, reprise.key, void 0);
              if (value && field.rich_text) {
                value = _.escape(value).replace(/[\r\n]+/g, "<br/>");
              }
            } else if (reprise.type === "stay") {
              value = _.get(stay, reprise.key, void 0);
              if (value && field.rich_text) {
                value = _.escape(value).replace(/[\r\n]+/g, "<br/>");
              }
            } else if (reprise.type === "self") {
              value = _.get(formByUid[template.uid] || {}, field.key || field.uid, void 0);
            } else if ((ref1 = reprise.type) === "forms" || ref1 === "old_forms") {
              value = _.get(formByUid[reprise.template] || {}, reprise.key, void 0);
            } else if (reprise.type === "vital_signs") {
              value = _.get((patient.vital_signs_data.last_values || {})[reprise.uid] || {}, reprise.value, void 0);
            } else if (reprise.type === "prescriptions") {
              return fetchPrescriptions(reprise, stay.id).then(function(value) {
                return dataContent[field.key || field.uid] = value;
              });
            }
            if (value !== void 0) {
              dataContent[field.key || field.uid] = value;
              return;
            }
          }
        } else {
          return fetchDynamicFields(field.fields || [], dataContent, template, formByUid, patient, stay);
        }
      }));
    };
    copyOtherData = function(patient, stay, datacontent, data) {
      if (data.patient_data && data.patient_data.length > 0) {
        copyPatientData(patient, datacontent, data.patient_data);
      }
      if (data.stay_data && data.stay_data.length > 0) {
        copyStayData(stay, datacontent, data.stay_data);
      }
      if (data.vital_signs && data.vital_signs.length > 0) {
        return copyVitalSigns(patient, datacontent, data.vital_signs);
      }
    };
    copyPatientData = function(patient, datacontent, fields) {
      var field, i, len, results;
      results = [];
      for (i = 0, len = fields.length; i < len; i++) {
        field = fields[i];
        if (field.updateData || datacontent[field.dest] === void 0) {
          results.push(datacontent[field.dest] = _.get(patient, field.origin, void 0));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };
    copyStayData = function(stay, datacontent, fields) {
      var field, i, len, results;
      results = [];
      for (i = 0, len = fields.length; i < len; i++) {
        field = fields[i];
        if (field.updateData || datacontent[field.dest] === void 0) {
          results.push(datacontent[field.dest] = _.get(stay, field.origin, void 0));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };
    copyVitalSigns = function(patient, datacontent, fields) {
      var field, i, len, results, vital_sign_value;
      results = [];
      for (i = 0, len = fields.length; i < len; i++) {
        field = fields[i];
        if (patient.vital_signs_data.last_values && field.uid in patient.vital_signs_data.last_values) {
          vital_sign_value = patient.vital_signs_data.last_values[field.uid][field.origin];
          results.push(datacontent[field.dest] = isNaN(vital_sign_value) ? vital_sign_value : Number(vital_sign_value));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };
    fetchData = function(url, fetchByUrl) {
      var fetchedData;
      fetchedData = $q.defer();
      fetchByUrl[url] = {};
      $http.get(url).then(function(result) {
        fetchByUrl[url] = result;
        return fetchedData.resolve();
      });
      return fetchedData.promise;
    };
    copyData = function(datacontent, copy_infos, data) {
      var field, i, j, key, len, len1, ref, ref1, results, results1;
      if (data) {
        if (copy_infos.all_data) {
          ref = Object.keys(data);
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            key = ref[i];
            if (!(_.includes(copy_infos.except_fields, key))) {
              results.push(datacontent[key] = data[key]);
            } else {
              results.push(void 0);
            }
          }
          return results;
        } else {
          ref1 = copy_infos.fields;
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            field = ref1[j];
            results1.push(datacontent[field.dest] = _.get(data, field.origin, void 0));
          }
          return results1;
        }
      }
    };
    formInputFields = ["auto", "checkbox", "text", "date", "number", "radio", "text-area", "select", "userSelection", "medicaldbResource", "multiUserSelection"];
    service = {
      getGroupsConfig: getGroupsConfig,
      initVersion: initVersion,
      fetchContainer: fetchContainer,
      extractVersionDynamicFields: extractVersionDynamicFields,
      resetCache: resetCache,
      fetchTemplateVersionContainers: fetchTemplateVersionContainers,
      userDataStaticFields: userDataStaticFields,
      getStaticData: getStaticData,
      staticDataDefinition: staticDataDefinition,
      formInputFields: formInputFields
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=medforms-utils.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms:draw
    * @description
    * # Draw
    * Directive for drawing medical form
   */
  angular.module('mhclientApp').directive('mhDrawInitialData', ["$rootScope", "$timeout", "$compile", function($rootScope, $timeout, $compile) {
    var logicForDrawing;
    logicForDrawing = function(scope, element, attrs) {

      /* */

      /*  DRAWING IN CANVAS */

      /* */
      var applyLineBreaks, capture, computePosition, createCanvasNote, currentPath, currentPosition, erase, formatPath, genDataurl, getBase64Image, getMaxWidth, mouseDownFunction, mouseMoveFunction, mouseUpFunction, reduce, savePoints, saveText, startPosition;
      scope.isDrawing = false;
      startPosition = {
        x: 0,
        y: 0
      };
      currentPosition = {
        x: 0,
        y: 0
      };
      currentPath = [];
      genDataurl = function() {
        var currentY, incrementY, j, l, len, len1, line, note, ref, ref1;
        scope.bufferCanvas.context.font = "16px MhFont";
        incrementY = parseInt($('textarea.input_area').css('line-height'));
        ref = _.filter(scope.container.newDataContent, {
          action: "text"
        });
        for (j = 0, len = ref.length; j < len; j++) {
          note = ref[j];
          scope.bufferCanvas.context.save();
          scope.bufferCanvas.context.translate(note.left, note.top);
          scope.bufferCanvas.context.fillStyle = note.color;
          currentY = 19;
          ref1 = note.content.split('\n');
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            line = ref1[l];
            scope.bufferCanvas.context.fillText(line, 0, currentY);
            currentY = currentY + incrementY;
          }
          scope.bufferCanvas.context.restore();
        }
        return scope.bufferCanvas.canvas.toDataURL('image/png', 1.0);
      };
      scope.$on('$canvasToImage', function(event) {
        return scope.baseImage.dataUrl = genDataurl();
      });
      scope.$on('$destroy', function() {
        var ref;
        if (scope.baseImage) {
          scope.baseImage.dataUrl = genDataurl();
        }
        if (((ref = scope.datapromise) != null ? ref.reject : void 0) != null) {
          return scope.datapromise.reject();
        }
      });
      if ($rootScope.mh_config.platform === "mgapp") {
        mouseDownFunction = function(position, ev) {
          startPosition = computePosition(position);
          currentPath = [startPosition];
          if (ev.which === 1) {
            scope.isDrawing = true;
            switch (scope.config.action) {
              case 'draw':
                return capture(startPosition);
              case 'erase':
                return erase(startPosition);
            }
          }
        };
        scope.bufferCanvas.canvas.onmousedown = function(ev) {
          var position;
          position = {
            x: ev.offsetX != null ? ev.offsetX : ev.layerX,
            y: ev.offsetY != null ? ev.offsetY : ev.layerY
          };
          return mouseDownFunction(position, ev);
        };
        mouseMoveFunction = function(position) {
          if (scope.isDrawing && (scope.config.action === 'erase' || scope.config.action === 'draw') && !scope.readonly) {
            position = computePosition(position);
            if (scope.config.action === 'erase') {
              return erase(position);
            } else {
              return capture(position);
            }
          }
        };
        scope.bufferCanvas.canvas.onmousemove = function(ev) {
          var position;
          position = {
            x: ev.offsetX != null ? ev.offsetX : ev.layerX,
            y: ev.offsetY != null ? ev.offsetY : ev.layerY
          };
          return mouseMoveFunction(position);
        };
        mouseUpFunction = function() {
          if ((scope.config.action === 'erase' || scope.config.action === 'draw') && !scope.readonly) {
            scope.isDrawing = false;
            return savePoints(formatPath(currentPath));
          }
        };
        scope.bufferCanvas.canvas.onmouseup = function(ev) {
          return mouseUpFunction();
        };
        scope.bufferCanvas.canvas.onmouseout = function(ev) {
          if (scope.isDrawing && !scope.readonly) {
            scope.isDrawing = false;
            return savePoints(formatPath(currentPath));
          }
        };
      } else {
        mouseUpFunction = function() {
          if ((scope.config.action === 'erase' || scope.config.action === 'draw') && !scope.readonly) {
            scope.isDrawing = false;
            return savePoints(formatPath(currentPath));
          }
        };
        mouseDownFunction = function(position) {
          startPosition = position;
          currentPath = [position];
          scope.isDrawing = true;
          switch (scope.config.action) {
            case 'draw':
              return capture(position);
            case 'erase':
              return erase(position);
          }
        };
        mouseMoveFunction = function(position) {
          if (scope.isDrawing && (scope.config.action === 'erase' || scope.config.action === 'draw') && !scope.readonly) {
            if (scope.config.action === 'erase') {
              return erase(position);
            } else {
              return capture(position);
            }
          }
        };
        scope.bufferCanvas.canvas.addEventListener("touchmove", function(ev) {
          var bcr, position;
          ev.preventDefault();
          bcr = ev.target.getBoundingClientRect();
          position = {
            x: (ev.targetTouches[0].clientX - bcr.x) / scope.container.coefficientForZoom,
            y: (ev.targetTouches[0].clientY - bcr.y) / scope.container.coefficientForZoom
          };
          return mouseMoveFunction(computePosition(position));
        });
        scope.bufferCanvas.canvas.addEventListener("touchstart", function(ev) {
          var bcr, position;
          ev.preventDefault();
          bcr = ev.target.getBoundingClientRect();
          position = {
            x: (ev.targetTouches[0].clientX - bcr.x) / scope.container.coefficientForZoom,
            y: (ev.targetTouches[0].clientY - bcr.y) / scope.container.coefficientForZoom
          };
          return mouseDownFunction(computePosition(position));
        });
        scope.bufferCanvas.canvas.addEventListener("touchend", function(ev) {
          return mouseUpFunction();
        });
        scope.bufferCanvas.canvas.onmousedown = function(ev) {
          var position;
          if (ev.which === 1) {
            position = {
              x: ev.offsetX != null ? ev.offsetX : ev.layerX,
              y: ev.offsetY != null ? ev.offsetY : ev.layerY
            };
            return mouseDownFunction(computePosition(position));
          }
        };
        scope.bufferCanvas.canvas.onmousemove = function(ev) {
          var position;
          position = {
            x: ev.offsetX != null ? ev.offsetX : ev.layerX,
            y: ev.offsetY != null ? ev.offsetY : ev.layerY
          };
          return mouseMoveFunction(computePosition(position));
        };
        scope.bufferCanvas.canvas.onmouseout = function(ev) {
          if (scope.isDrawing && !scope.readonly) {
            scope.isDrawing = false;
            return savePoints(formatPath(currentPath));
          }
        };
        scope.bufferCanvas.canvas.onmouseup = function(ev) {
          return mouseUpFunction();
        };
      }
      scope.bufferCanvas.canvas.onmouseenter = function(ev) {
        if (scope.isDrawing && !scope.readonly) {
          startPosition = {
            x: ev.offsetX != null ? ev.offsetX : ev.layerX,
            y: ev.offsetY != null ? ev.offsetY : ev.layerY
          };
          startPosition = computePosition(startPosition);
          currentPath.push(startPosition);
          if (scope.config.action === 'erase') {
            return erase(startPosition);
          } else {
            return capture(startPosition);
          }
        }
      };
      capture = function(position) {
        if (scope.isDrawing && !scope.readonly) {
          currentPosition = position;
          currentPath.push(position);
          scope.bufferCanvas.context.beginPath();
          scope.bufferCanvas.context.moveTo(startPosition.x, startPosition.y);
          scope.bufferCanvas.context.lineTo(currentPosition.x, currentPosition.y);
          scope.bufferCanvas.context.stroke();
          scope.bufferCanvas.context.closePath();
          return startPosition = currentPosition;
        }
      };
      erase = function(position) {
        if (scope.isDrawing) {
          currentPosition = position;
          currentPath.push(position);
          scope.bufferCanvas.context.beginPath();
          scope.bufferCanvas.context.moveTo(startPosition.x, startPosition.y);
          scope.bufferCanvas.context.lineTo(currentPosition.x, currentPosition.y);
          scope.bufferCanvas.context.stroke();
          scope.bufferCanvas.context.closePath();
          return startPosition = currentPosition;
        }
      };
      computePosition = function(position) {
        var realPosition;
        realPosition = {
          x: position.x * scope.container.config.width / scope.canvasContainer.clientWidth,
          y: position.y * scope.container.config.height / scope.canvasContainer.clientHeight
        };
        return realPosition;
      };
      savePoints = function(path) {
        var cropCanvas, ctx1, data, j, len, line, maxX, maxY, minX, minY, ref;
        if (scope.readonly) {
          return;
        }
        data = {
          "action": scope.config.action,
          "color": scope.config.penColor,
          "smooth": scope.config.smooth,
          "points": path
        };
        scope.$apply(scope.container.newDataContent.push(data));
        if (scope.resultImage != null) {
          minX = scope.bufferCanvas.canvas.width;
          minY = scope.bufferCanvas.canvas.height;
          maxX = 0;
          maxY = 0;
          ref = scope.container.newDataContent;
          for (j = 0, len = ref.length; j < len; j++) {
            line = ref[j];
            minX = _.min(_.concat(_.map(line.points, "x"), minX));
            minY = _.min(_.concat(_.map(line.points, "y"), minY));
            maxX = _.max(_.concat(_.map(line.points, "x"), maxX));
            maxY = _.max(_.concat(_.map(line.points, "y"), maxY));
          }
          minX = minX - 2;
          minY = minY - 2;
          cropCanvas = document.createElement('canvas');
          ctx1 = cropCanvas.getContext('2d');
          cropCanvas.width = maxX - minX + 30;
          cropCanvas.height = maxY - minY + 30;
          ctx1.drawImage(scope.bufferCanvas.canvas, minX, minY, cropCanvas.width, cropCanvas.height, 15, 15, cropCanvas.width, cropCanvas.height);
          scope.resultImage = cropCanvas.toDataURL("image/png");
          scope.$emit('$drawDataDirty');
          return scope.$apply();
        }
      };
      reduce = function(path) {
        var lastPoint, pathSimplified, pathWithoutLastPoint;
        pathWithoutLastPoint = path.slice(0, path.length - 1);
        lastPoint = [path[path.length - 1]];
        pathSimplified = simplify(pathWithoutLastPoint, scope.config.tolerance, false);
        pathSimplified = pathSimplified.concat(lastPoint);
        return pathSimplified;
      };
      formatPath = function(path) {
        var j, k, ref;
        path = reduce(path);
        for (k = j = 0, ref = path.length; j < ref; k = j += 1) {
          path[k].x = Math.round(path[k].x * 100) / 100;
          path[k].y = Math.round(path[k].y * 100) / 100;
        }
        return path;
      };

      /* */

      /*  CREATING NOTES */

      /* */
      scope.notesDivCapture.onclick = function(ev) {
        startPosition = {
          left: ev.offsetX != null ? ev.offsetX - 6 : ev.layerX - 6,
          top: ev.offsetY != null ? ev.offsetY - 1 : ev.layerY - 1
        };
        return scope.addNote(startPosition);
      };
      createCanvasNote = function(color, initialText) {
        var c_canvas, canvas, ctx, ctxTmp, currentY, incrementY, j, l, len, len1, line, maxLineWidth, ref, ref1, startX, startY, width;
        if (initialText == null) {
          initialText = '';
        }
        canvas = $('<canvas></canvas>');
        c_canvas = canvas[0];
        incrementY = parseInt($('textarea.input_area').css('line-height'));
        c_canvas.height = incrementY * initialText.split('\n').length;
        c_canvas.width = 1500;
        ctxTmp = c_canvas.getContext("2d");
        ctxTmp.font = "16px MhFont";
        maxLineWidth = 0;
        ref = initialText.split('\n');
        for (j = 0, len = ref.length; j < len; j++) {
          line = ref[j];
          width = ctxTmp.measureText(line).width;
          if (width > maxLineWidth) {
            maxLineWidth = width;
          }
        }
        c_canvas.width = maxLineWidth;
        ctx = c_canvas.getContext("2d");
        ctx.font = "16px MhFont";
        ctx.fillStyle = color;
        ctx.clearRect(0, 0, c_canvas.width, c_canvas.height);
        startX = 1;
        startY = 19;
        currentY = startY;
        ref1 = initialText.split('\n');
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          line = ref1[l];
          ctx.fillText(line, startX, currentY);
          currentY = currentY + incrementY;
        }
        return c_canvas;
      };
      getMaxWidth = function(id) {
        var containerWidth, maxWidth, note, position;
        note = $('#note_' + id);
        position = note.position();
        containerWidth = angular.element(scope.notesDivCapture).width();
        maxWidth = containerWidth - (position.left / scope.container.coefficientForZoom);
        return maxWidth;
      };
      applyLineBreaks = function(textarea) {
        var auxSpan, curChar, id, j, len, strRawValue, toreturn;
        id = $("#aux_span_" + textarea.attr('id'));
        if (id.val() !== void 0) {
          auxSpan = id;
        } else {
          auxSpan = $('<span class="aux_span" id="aux_span_' + textarea.attr('id') + '"></span>');
          $('.drawLabel').append(auxSpan);
          auxSpan.css({
            'position': 'absolute',
            'font-weight': textarea.css('font-weight'),
            'font-family': textarea.css('font-family'),
            'font-size': textarea.css('font-size'),
            'line-height': textarea.css('line-height'),
            'color': 'transparent',
            'visibility': 'hidden',
            'white-space': 'nowrap'
          });
        }
        strRawValue = $(textarea).val();
        toreturn = "";
        auxSpan.html("");
        for (j = 0, len = strRawValue.length; j < len; j++) {
          curChar = strRawValue[j];
          if (curChar === "\n") {
            auxSpan.html(auxSpan.html() + "<br>");
          } else {
            auxSpan.html(auxSpan.html() + curChar);
          }
          if (auxSpan.width() > $(textarea).innerWidth()) {
            toreturn += "\n";
            auxSpan.html("");
          }
          toreturn += curChar;
        }
        return toreturn;
      };
      scope.updateNote = function(id) {
        var content, note, noteExists;
        note = $('#note_' + id);
        content = applyLineBreaks(note.find('.input_area'));
        noteExists = _.find(scope.container.newDataContent, function(n) {
          return n.id === id;
        });
        if (noteExists != null) {
          noteExists.top = note.position().top / scope.container.coefficientForZoom;
          noteExists.left = note.position().left / scope.container.coefficientForZoom;
          noteExists.content = content;
          return noteExists.image = getBase64Image(content);
        } else {
          return saveText(id, note.position(), content);
        }
      };
      saveText = function(id, position, content) {
        var base64;
        if (scope.readonly) {
          return;
        }
        base64 = getBase64Image(content);
        return scope.$apply(function() {
          var data;
          data = {
            "id": id,
            "action": scope.config.action,
            "color": scope.config.penColor,
            "top": position.top / scope.container.coefficientForZoom,
            "left": position.left / scope.container.coefficientForZoom,
            "content": content,
            "image": base64
          };
          return scope.container.newDataContent.push(data);
        });
      };
      getBase64Image = function(content) {
        var canvas, dataURL;
        canvas = createCanvasNote(scope.config.penColor, content);
        dataURL = canvas.toDataURL("image/png");
        return dataURL;
      };
      return scope.addNote = function(position, initialText, id, color) {
        var divIcons, dragConfig, iconArrow, iconsClose, idNote, note, textarea, widgetCorner;
        if (initialText == null) {
          initialText = '';
        }
        if (scope.readonly) {
          return;
        }
        widgetCorner = {
          x: position.left,
          y: position.top
        };
        divIcons = $('<div class="icons"></div>');
        iconArrow = $("<span class='glyphicon glyphicon-move' style='cursor: move;'></span>").attr('moving', 'false');
        iconsClose = $("<span class='glyphicon glyphicon-remove' style='cursor: pointer;'></span>");
        divIcons.append(iconArrow);
        divIcons.append(iconsClose);
        if ($rootScope.mh_config.platform === 'mgapp') {
          textarea = $('<textarea cols="2000" class="input_area" ng-virtual-keyboard="{size:4, deadkeysOn:false}" ng-model="textarea"></textarea>');
        } else {
          textarea = $('<textarea cols="2000" class="input_area"></textarea>');
        }
        color = color || scope.config.penColor;
        textarea.css({
          "color": color,
          "font-size": scope.fontSizeAccordingToZoom,
          "line-height": scope.lineHeightAccordingToZoom
        });
        textarea[0].value = initialText;
        idNote = id || Math.floor((Math.random() * 10000000) + 1);
        textarea.attr("id", "input_area_" + idNote);
        note = $("<div class='drawLabel' id=note_" + idNote + "></div>");
        note.css({
          "left": widgetCorner.x,
          "top": widgetCorner.y,
          "font-size": scope.fontSizeAccordingToZoom,
          "line-height": scope.lineHeightAccordingToZoom,
          "position": 'absolute'
        });
        note.append(divIcons);
        note.append(textarea);
        dragConfig = {
          containment: scope.notesDivCapture,
          handle: iconArrow,
          cursor: "move",
          start: function(e, ui) {
            divIcons.show();

            /* OPTIONAL : DOESNT FIX TOTALLY BUGS */
            ui.position.left = 0;
            return ui.position.top = 0;

            /* OPTIONAL : DOESNT FIX TOTALLY BUGS */
          },
          stop: function(e, ui) {
            e.stopPropagation();
            divIcons.show();
            textarea.css("max-width", getMaxWidth(idNote));
            return scope.updateNote(idNote);
          },
          drag: function(e, ui) {
            var changeLeft, changeTop, newLeft, newTop;
            divIcons.show();

            /* OPTIONAL : DOESNT FIX TOTALLY BUGS */
            changeLeft = (ui.position.left - ui.originalPosition.left) / scope.container.coefficientForZoom;
            newLeft = ui.originalPosition.left + changeLeft;
            changeTop = (ui.position.top - ui.originalPosition.top) / scope.container.coefficientForZoom;
            newTop = ui.originalPosition.top + changeTop;
            ui.position.left = newLeft;
            return ui.position.top = newTop;

            /* OPTIONAL : DOESNT FIX TOTALLY BUGS */
          }
        };
        note.draggable(dragConfig);
        note.click(function(e) {
          e.stopPropagation();
          return textarea.focus();
        });
        $(scope.notesDivCapture).append($compile(note)(_.assign(scope.$new(true), {
          textarea: initialText
        })));
        textarea.css("max-width", getMaxWidth(idNote));
        $(textarea).autoGrow({
          extraLine: false
        });
        textarea.on('input propertychange', function() {
          if ($(textarea).val()) {
            return scope.updateNote(idNote);
          }
        });
        textarea.on('blur', function() {
          if ($(textarea).val()) {
            return scope.updateNote(idNote);
          }
        });
        note.on('mouseenter', function() {
          return divIcons.show();
        });
        note.on('mouseleave', function() {
          return divIcons.hide();
        });
        iconsClose.on('click', function(e) {
          var graphicElement, indexToRemove, j, len, ref;
          note.remove();
          ref = scope.container.newDataContent;
          for (j = 0, len = ref.length; j < len; j++) {
            graphicElement = ref[j];
            if (graphicElement.id === idNote) {
              indexToRemove = scope.container.newDataContent.indexOf(graphicElement);
            }
          }
          scope.container.newDataContent.splice(indexToRemove, 1);
          return false;
        });
        if ($rootScope.mh_config.platform === 'mgapp') {
          if (!id) {
            textarea.focus();
            return $timeout(function() {
              return textarea.click();
            });
          } else {
            return $timeout(function() {
              return textarea.css("max-width", getMaxWidth(idNote));
            });
          }
        } else {
          return textarea.focus();
        }
      };
    };
    return {
      controller: "MedFormsMhDrawInitialDataCtrl",
      link: logicForDrawing,
      transclude: true,
      scope: {
        container: "=",
        readonly: "=readonlyform",
        datapromise: "=",
        data: "=",
        config: "=",
        baseImage: "=?",
        resultImage: "=?",
        page: "=",
        onready: "="
      },
      template: '<div class="draw-with-image"> <div ng-transclude></div> <canvas class="drawingCanvas"></canvas> <canvas class="bufferCanvas" ng-class="{ \'to-foreground\' : config.action !== \'text\'}"></canvas> <div class="captureNotes" ng-class="{ \'to-foreground\' : config.action === \'text\'}"></div> <div class="initialNotes {{page}}"></div> </div>'
    };
  }]);


  /*
    * @ngdoc function
    * @name mhclientApp.medforms:MedFormsMhDrawCtrl
    * @description
    * # MedFormsMhDrawCtrl
    * Controller for creation of medical forms
   */

  angular.module('mhclientApp').controller('MedFormsMhDrawInitialDataCtrl', ["$scope", "$timeout", "$element", "$q", function($scope, $timeout, $element, $q) {
    var canvasContainer, createDrawingCanvas, drawInitial, drawer, drawingCanvas, drawingContext, initialNotes, insertImageNote, page, ref, setContext, setSize, zoomTo;
    canvasContainer = $element[0].firstChild;
    drawingCanvas = canvasContainer.children[1];
    drawingContext = drawingCanvas.getContext("2d");
    initialNotes = canvasContainer.children[2];
    $scope.canvasContainer = $element[0].firstChild;
    $scope.notesDivCapture = angular.element($scope.canvasContainer).children('.captureNotes')[0];
    page = $scope.page;
    setSize = function(canvas) {
      canvas.style.width = "100%";
      canvas.style.height = "100%";
      canvas.width = $scope.container.config.width;
      return canvas.height = $scope.container.config.height;
    };
    createDrawingCanvas = function() {
      var j, len, ref, results, subversionData, tmpCanvas, tmpContext;
      tmpCanvas = document.createElement('canvas');
      tmpContext = tmpCanvas.getContext('2d');
      setSize(tmpCanvas);
      ref = $scope.data;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        subversionData = ref[j];
        drawer(0, 100, subversionData, tmpContext, true);
        results.push(drawingContext.drawImage(tmpCanvas, 0, 0));
      }
      return results;
    };
    drawer = function(start, step, data, context, insertImage) {
      var graphicElement, j, len, position, ref, stop;
      stop = window.Math.min(start + step, data.length);
      ref = data.slice(start, +stop + 1 || 9e9);
      for (j = 0, len = ref.length; j < len; j++) {
        graphicElement = ref[j];
        switch (graphicElement.action) {
          case 'draw':
            setContext(context, 'source-over', $scope.config.lineWidth, graphicElement.color);
            $scope.drawPath(graphicElement.points, context, graphicElement.smooth);
            break;
          case 'erase':
            setContext(context, 'destination-out', 30, "rgb(0,0,0,1)");
            $scope.drawPath(graphicElement.points, context, graphicElement.smooth);
            break;
          case 'text':
            position = {
              top: graphicElement.top,
              left: graphicElement.left
            };
            if (insertImage) {
              insertImageNote(graphicElement.id, position, graphicElement.image);
            } else {
              setContext(context, 'source-over', $scope.config.lineWidth, graphicElement.color);
              $scope.addNote(position, graphicElement.content, graphicElement.id, graphicElement.color);
            }
        }
      }
      if (start < stop) {
        return drawer(stop, step, data, context, insertImage);
      }
    };
    setContext = function(context, operation, lineWidth, color, lineJoin) {
      context.lineCap = 'round';
      context.globalCompositeOperation = operation;
      context.lineWidth = lineWidth;
      context.strokeStyle = color;
      if (lineJoin != null) {
        return context.lineJoin = lineJoin;
      }
    };
    insertImageNote = function(id, position, imageBase64) {
      var img;
      img = $('<img id=' + id + '>');
      img.attr('src', imageBase64);
      img.css({
        "position": "absolute",
        "top": position.top,
        "left": position.left,
        "margin-left": 0,
        "margin-top": 0
      });
      return $('.initialNotes.' + $scope.page).append(img);
    };
    drawInitial = function() {
      var color, tool;
      canvasContainer.style.width = $scope.container.config.width + 'px';
      canvasContainer.style.height = $scope.container.config.height + 'px';
      setSize(drawingCanvas);
      createDrawingCanvas();
      $scope.bufferCanvas.initConfig();
      tool = $scope.config.action;
      color = $scope.config.penColor;
      $scope.config.action = tool;
      $scope.config.penColor = color;
      $scope.canvasContainer.style.width = $scope.container.config.width + 'px';
      $scope.canvasContainer.style.height = $scope.container.config.height + 'px';
      drawer(0, 100, $scope.container.newDataContent || [], $scope.bufferCanvas.context);
      return zoomTo($scope.config.coefficientForZoom, false);
    };
    $q.when(((ref = $scope.datapromise) != null ? ref.promise : void 0) != null ? $scope.datapromise.promise : $scope.datapromise).then(function() {
      drawInitial();
      $scope.container.needReload = false;
      switch ($scope.config.action) {
        case 'erase':
          setContext($scope.bufferCanvas.context, 'destination-out', 30, "rgba(0,0,0,1)");
          break;
        case 'draw':
          setContext($scope.bufferCanvas.context, 'source-over', $scope.config.lineWidth, $scope.config.penColor);
      }
      $scope.$watch('config.action', (function(newConfig, oldConfig) {
        var bufferCanvasContext;
        bufferCanvasContext = $scope.bufferCanvas.context;
        switch (newConfig) {
          case 'erase':
            return setContext(bufferCanvasContext, 'destination-out', 30, "rgba(0,0,0,1)");
          case 'draw':
            return setContext(bufferCanvasContext, 'source-over', $scope.config.lineWidth, $scope.config.penColor);
          case 'text':
            return $scope.isDrawing = false;
        }
      }));
      $scope.$watch('config.penColor', (function(newConfig, oldConfig) {
        var bufferCanvasContext;
        bufferCanvasContext = $scope.bufferCanvas.context;
        switch ($scope.config.action) {
          case 'erase':
            return setContext(bufferCanvasContext, 'destination-out', 30, "rgba(0,0,0,1)");
          case 'draw':
            return setContext(bufferCanvasContext, 'source-over', $scope.config.lineWidth, newConfig);
          case 'text':
            return $scope.isDrawing = false;
        }
      }));
      $scope.$watch('config.coefficientForZoom', (function(newConfig, oldConfig) {
        if (newConfig !== oldConfig) {
          return zoomTo(newConfig, true);
        }
      }));
      return $scope.$watch('container.needReload', function(needReload, previousNeedReload) {
        if (needReload) {
          $scope.bufferCanvas.context.clearRect(0, 0, $scope.bufferCanvas.canvas.width, $scope.bufferCanvas.height);
          $element.find(".captureNotes")[0].innerHTML = "";
          drawInitial();
          return $scope.container.needReload = false;
        }
      });
    });
    $scope.drawPath = function(path, context, smoothness) {
      var i, j, k, l, ref1, ref2, xc, yc;
      context.beginPath();
      if (path.length === 2 && path[0].x === path[1].x && path[0].y === path[1].y) {
        context.arc(path[0].x, path[0].y, 1, 0, 2 * Math.PI, false);
        context.fill();
      } else {
        context.moveTo(path[0].x, path[0].y);
        if (smoothness) {
          for (i = j = 0, ref1 = path.length - 1; j < ref1; i = j += 1) {
            xc = (path[i].x + path[i + 1].x) / 2;
            yc = (path[i].y + path[i + 1].y) / 2;
            context.quadraticCurveTo(path[i].x, path[i].y, xc, yc);
          }
        } else {
          for (k = l = 0, ref2 = path.length; l < ref2; k = l += 1) {
            context.lineTo(path[k].x, path[k].y);
          }
        }
      }
      context.stroke();
      return context.closePath();
    };
    zoomTo = function(zoom, updateNote) {
      var old_coefficient, scaleString, zoomLevel;
      zoomLevel = parseFloat(zoom);
      old_coefficient = $scope.container.coefficientForZoom;
      $scope.container.coefficientForZoom = zoom;
      scaleString = 'scale(' + $scope.container.coefficientForZoom + ',' + $scope.container.coefficientForZoom + ')';
      $(".all-containers").css('transform-origin', '0% 0%');
      return $(".all-containers").css('transform', scaleString);
    };

    /* */

    /*  DRAWING INITIAL DATA */

    /* */
    return $scope.bufferCanvas = {
      canvas: angular.element($scope.canvasContainer).children('.bufferCanvas')[0],
      initConfig: function() {
        this.context = this.canvas.getContext('2d');
        setSize(this.canvas);
        return setContext(this.context, 'source-over', $scope.config.lineWidth, $scope.config.penColor);
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=medforms-draw-initial-data-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:FormSubVersion
    * @description
    * # FormSubVersion
    * Factory of MedForms
   */
  angular.module("mhclientApp").factory('FormSubVersion', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, form_subversion, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/formsubversions/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        form_subversion = window.mgapp.get('medforms_mgr').form_subversion();
        boxAPI = BoxResource.generate(form_subversion);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

}).call(this);

//# sourceMappingURL=medforms-subversion-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:FormVersion
    * @description
    * # FormVersion
    * Factory of MedForms
   */
  angular.module("mhclientApp").factory('FormVersion', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, form_version, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/formversions/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'get_data': {
        method: 'get',
        params: {
          id: '@id',
          route: 'get_data'
        },
        isArray: true,
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'save_export_html': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id',
          route: 'save_export_html'
        }
      },
      'lastFormVersionByStay': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'GET',
        isArray: true,
        params: {
          route: 'get_last_form_version_by_stay'
        }
      },
      'syncDmp': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id',
          route: 'sync_dmp'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        form_version = window.mgapp.get('medforms_mgr').form_version();
        boxAPI = BoxResource.generate(form_version);
        boxAPI.lastFormVersionByStay = function(object) {
          return BoxResource.mhboxApiCall(form_version, "get_last_form_version_by_stay", object);
        };
        boxAPI.save_export_html = function(object) {
          return BoxResource.mhboxApiCall(form_version, "save_export_html", object);
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('DocumentToValidate', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    return $resource('/api_rest/documents_to_validate/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
  }]);

}).call(this);

//# sourceMappingURL=medforms-version-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:FormGroup
    * @description
    * # FormGroup
    * Factory of MedForms
   */
  angular.module("mhclientApp").factory('FormGroup', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, form_group, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/formgroups/:id', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        form_group = window.mgapp.get('medforms_mgr').form_group();
        boxAPI = BoxResource.generate(form_group);
        return boxAPI;
      default:
        return portailAPI;
    }
    return portailAPI;
  }]);

  angular.module("mhclientApp").factory('FormGroupConfig', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, form_group_config, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/formgroupsconfig/:id', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PUT',
        params: {
          id: '@id'
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        form_group_config = window.mgapp.get('medforms_mgr').form_group_config();
        boxAPI = BoxResource.generate(form_group_config);
        return boxAPI;
      default:
        return portailAPI;
    }
    return portailAPI;
  }]);

}).call(this);

//# sourceMappingURL=medforms-group-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Template
    * @description
    * # Template
    * Factory of MedForms
   */
  angular.module("mhclientApp").factory('Template', ["$resource", "MhConfig", "BoxResource", "$state", function($resource, MhConfig, BoxResource, $state) {
    var acceptHeader, boxAPI, form_template, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/formtemplates/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'getAllTemplates': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_all_templates'
        },
        isArray: true
      },
      'getCRH': {
        params: {
          route: 'get_crh'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PUT',
        params: {
          id: '@id'
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        form_template = window.mgapp.get('medforms_mgr').form_template();
        boxAPI = BoxResource.generate(form_template);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('TemplateVersion', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, form_template_version, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/formtemplateversions/:id/:route', {
      id: this.id
    }, {
      'get': {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'test_export_pdf': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id',
          route: 'test_export_pdf'
        },
        isArray: false
      },
      'get_data_new_form_version': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'GET',
        params: {
          route: 'get_data_new_form_version'
        }
      },
      'integrate': {
        method: 'POST',
        params: {
          route: 'integrate',
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        form_template_version = window.mgapp.get('medforms_mgr').form_template_version();
        boxAPI = BoxResource.generate(form_template_version);
        boxAPI.get_data_new_form_version = function(object) {
          return BoxResource.mhboxApiCall(form_template_version, "get_data_new_form_version", object);
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('FormTemplateUtils', ["$q", "Template", "TemplateVersion", function($q, Template, TemplateVersion) {
    var cachedCREntry, cachedCRH, cachedTemplates, filterEntries, getCREntry, getCRH, getTemplates, getTemplatesWithCurrent, globalCREntryPromise, globalCRHPromise, globalTemplatesDone, resetCache, service;
    cachedCRH = null;
    globalCRHPromise = $q.defer();
    cachedCREntry = null;
    globalCREntryPromise = $q.defer();
    cachedTemplates = null;
    globalTemplatesDone = $q.defer();
    resetCache = function() {
      cachedTemplates = null;
      cachedCREntry = null;
      cachedCRH = null;
      globalTemplatesDone = $q.defer();
      globalCREntryPromise = $q.defer();
      return globalCRHPromise = $q.defer();
    };
    getCRH = function() {
      var CRHPromise;
      CRHPromise = $q.defer();
      if (cachedCRH != null) {
        globalCRHPromise.promise.then(function() {
          return CRHPromise.resolve(angular.copy(cachedCRH));
        });
      } else {
        cachedCRH = {};
        Template.getCRH().$promise.then(function(crhTemplate) {
          cachedCRH = crhTemplate;
          CRHPromise.resolve(angular.copy(cachedCRH));
          return globalCRHPromise.resolve();
        });
      }
      return CRHPromise.promise;
    };
    getCREntry = function() {
      var CREntryPromise;
      CREntryPromise = $q.defer();
      if (cachedCREntry != null) {
        globalCREntryPromise.promise.then(function() {
          return CREntryPromise.resolve(angular.copy(cachedCREntry));
        });
      } else {
        cachedCREntry = {};
        Template.query({
          "uid": "cr_entry"
        }).$promise.then(function(crEntryTemplate) {
          cachedCREntry = crEntryTemplate[0];
          CREntryPromise.resolve(angular.copy(cachedCREntry));
          return globalCREntryPromise.resolve();
        });
      }
      return CREntryPromise.promise;
    };
    filterEntries = function(entries, query, many, dontCopy) {
      var result;
      if (query) {
        result = many ? _.filter(entries, query) : _.find(entries, query);
      } else {
        result = entries;
      }
      if (dontCopy) {
        return result;
      } else {
        return angular.copy(result);
      }
    };
    getTemplatesWithCurrent = function(query, many) {
      return getTemplates(query, true).then(function(templates) {
        templates = _.filter(templates, "current");
        return TemplateVersion.query({
          only_current: true
        }).$promise.then(function(versions) {
          _.forEach(templates, function(template) {
            return template.current = _.find(versions, {
              id: template.current
            });
          });
          return filterEntries(templates, query, many);
        });
      });
    };
    getTemplates = function(query, many, dontCopy) {
      var templatesDone;
      templatesDone = $q.defer();
      if (cachedTemplates != null) {
        globalTemplatesDone.promise.then(function() {
          return templatesDone.resolve(filterEntries(cachedTemplates, query, many, dontCopy));
        });
      } else {
        cachedTemplates = {};
        Template.query({
          fetch_all: true
        }).$promise.then(function(templates) {
          cachedTemplates = templates;
          globalTemplatesDone.resolve();
          return templatesDone.resolve(filterEntries(templates, query, many, dontCopy));
        });
      }
      return templatesDone.promise;
    };
    service = {
      getCRH: getCRH,
      getCREntry: getCREntry,
      getTemplates: getTemplates,
      resetCache: resetCache,
      getTemplatesWithCurrent: getTemplatesWithCurrent
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=medforms-template-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms:MedFormsTemplateCtrl
    * @description
    * # MedFormsTemplateCtrl
    * Controller of medical forms
   */
  angular.module('mhclientApp').controller('MedFormsTemplateCtrl', ["$scope", "$rootScope", "$filter", "$state", "MhConfig", "FormVersion", "FormGroup", "MedFormsUtils", "Template", "TemplateVersion", function($scope, $rootScope, $filter, $state, MhConfig, FormVersion, FormGroup, MedFormsUtils, Template, TemplateVersion) {
    $scope.mh_config = MhConfig;
    $rootScope.removePatientMenu = false;
    $rootScope.busy = true;
    return FormGroup.query().$promise.then(function(groups) {
      var group, i, len, many;
      for (i = 0, len = groups.length; i < len; i++) {
        group = groups[i];
        group.templates = [];
      }
      return MedFormsUtils.getGroupsConfig({
        group: $scope.user.group.id
      }, many = true).then(function(groupsConfig) {
        return Template.query({
          stay: $rootScope.currentStay.id
        }).$promise.then(function(templates) {
          return TemplateVersion.query({
            only_current: true
          }).$promise.then(function(templateVersions) {
            var params;
            if ($scope.allStays) {
              params = {
                patient: $rootScope.currentPatient.id
              };
            } else {
              params = {
                stay: $rootScope.currentStay.id
              };
            }
            return FormVersion.lastFormVersionByStay(params).$promise.then(function(lastestFormVersions) {
              var j, len1, ref, template;
              $scope.groupedForms = [];
              $scope.templatesWithoutGroup = [];
              $scope.allTemplates = _.filter(templates, "current");
              ref = $scope.allTemplates;
              for (j = 0, len1 = ref.length; j < len1; j++) {
                template = ref[j];
                template.current = _.find(templateVersions, {
                  id: template.current
                });
                template.last_form_version_by_stay = _.find(lastestFormVersions, {
                  template: template.id
                });
                template.config = _.find(groupsConfig, {
                  template: template.id
                });
                if (!template.group) {
                  $scope.templatesWithoutGroup.push(template);
                } else {
                  group = _.find(groups, {
                    id: template.group
                  });
                  group.templates.push(template);
                  if (group.alreadyIncluded == null) {
                    group.preopen = _.includes($scope.user.preopenFormGroups, group.id);
                    $scope.groupedForms.push(group);
                    group.alreadyIncluded = true;
                  }
                }
              }
              $rootScope.busy = false;
              return $scope.groupedForms = $filter('orderBy')($scope.groupedForms, "order");
            });
          });
        });
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=medforms-template-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms:MedFormsSyntesisCtrl
    * @description
    * # MedFormsSyntesisCtrl
    * Controller of medical forms synthesis
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('MedFormsSyntesisCtrl', ["$scope", "$rootScope", "$q", "$http", "Stay", "MedFormsUtils", function($scope, $rootScope, $q, $http, Stay, MedFormsUtils) {
    var getVersionData, nextTaskDone, promises;
    $scope.container = {
      dataContent: {}
    };
    $scope.toggleVersion = function(medformSynthesis, newIndex) {
      var newVersion;
      medformSynthesis.fold = false;
      newVersion = medformSynthesis.versions[medformSynthesis.versions.length - newIndex];
      medformSynthesis.versionIndex = newIndex;
      medformSynthesis.loadingData = true;
      medformSynthesis.author = newVersion.author.full_name;
      medformSynthesis.timestamp = newVersion.last_edit_timestamp;
      $scope.container.dataContent = {};
      return getVersionData(medformSynthesis.uid, newVersion.containers[0], $scope.container.dataContent).then(function() {
        return medformSynthesis.loadingData = false;
      });
    };
    getVersionData = function(templateUid, versionContainer, dataContent) {
      var versionDone;
      versionDone = $q.defer();
      $http.get(versionContainer.dataUrl).then(function(result) {
        var key, ref, value;
        ref = result.data;
        for (key in ref) {
          value = ref[key];
          dataContent[templateUid + "_" + key] = value;
        }
        return versionDone.resolve();
      });
      return versionDone.promise;
    };
    $scope.versions_uids = [];
    $scope.medformsSynthesis = [];
    promises = [];
    nextTaskDone = $q.defer();
    promises.push(nextTaskDone.promise);
    Stay.nextMedplanTaskDate({
      id: $rootScope.currentStay.id
    }).$promise.then(function(response) {
      $scope.container.dataContent.nextMedplanTaskDate = response.date;
      return nextTaskDone.resolve();
    });
    return Stay.medicalformSyntesis({
      id: $rootScope.currentStay.id
    }, {}).$promise.then(function(versionsByTemplate) {
      var customSynthesis, i, lastTimeStamp, len, medform, originalMedform, ref, ref1, ref2, templateUid, versionContainer, versions;
      ref = versionsByTemplate.templates;
      for (templateUid in ref) {
        versions = ref[templateUid];
        originalMedform = _.find($scope.user.group.synthesis.medforms, {
          uid: templateUid
        });
        if (originalMedform) {
          medform = {
            fields: originalMedform.fields,
            order: originalMedform.order,
            name: originalMedform.name,
            versions: versions,
            versionIndex: versions.length,
            uid: templateUid,
            author: versions[0].author.full_name,
            timestamp: versions[0].last_edit_timestamp,
            lastTimeStamp: versions[0].last_edit_timestamp
          };
          $scope.medformsSynthesis.push(medform);
        }
        versionContainer = versions[0].containers[0];
        $scope.versions_uids.push(templateUid);
        promises.push(getVersionData(templateUid, versionContainer, $scope.container.dataContent));
      }
      ref1 = _.filter($scope.user.group.synthesis.medforms, {
        type: "custom"
      });
      for (i = 0, len = ref1.length; i < len; i++) {
        customSynthesis = ref1[i];
        if (_.intersection(customSynthesis.custom_templates, $scope.versions_uids).length > 0) {
          lastTimeStamp = null;
          ref2 = versionsByTemplate.templates;
          for (templateUid in ref2) {
            versions = ref2[templateUid];
            if (indexOf.call(customSynthesis.custom_templates, templateUid) >= 0) {
              if (!lastTimeStamp || versions[0].last_edit_timestamp > lastTimeStamp) {
                lastTimeStamp = versions[0].last_edit_timestamp;
              }
            }
          }
          customSynthesis.lastTimeStamp = lastTimeStamp;
          customSynthesis.timestamp = lastTimeStamp;
          $scope.medformsSynthesis.push(customSynthesis);
        }
      }
      return $q.all(promises).then(function() {
        return MedFormsUtils.getStaticData($rootScope.currentPatient, $rootScope.currentStay).then(function(customScope) {
          $scope.customScope = customScope;
          return $scope.container.initDone = true;
        });
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=medforms-syntesis-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:OrderListCtrl
    * @description
    * # OrderCtrl
    * Controller of Order
   */
  angular.module('mhclientApp').controller('InventoryPatient', ["$scope", "$stateParams", "$state", "Order", "MhConfig", function($scope, $stateParams, $state, Order, MhConfig) {
    var getOrders, init, mgappCloseRequest;
    getOrders = function() {
      $scope.isBusyRequesting = true;
      return Order.api.query({
        patient: $state.params.idPatient,
        page_size: $scope.max_size,
        page: $scope.currentPage,
        order_type: false,
        state: "-PN"
      }).$promise.then(function(orders) {
        $scope.ordersList = orders.results;
        return _.forEach($scope.ordersList, function(order) {
          order.timestamp_aware = order.timestamp;
          _.forEach(order.articles, function(article) {
            article.designation = article.article.designation;
            article.article_uid = article.ordered_article_uid;
            return true;
          });
          return true;
        });
      })["finally"](function() {
        return $scope.isBusyRequesting = false;
      });
    };
    init = function() {
      $scope.isMgapp = MhConfig.platform === 'mgapp';
      if ($scope.isMgapp) {
        window.mgappClose = mgappCloseRequest;
        window.mgappConfirmQuit = window.mgapp.quit_view;
      }
      $scope.max_size = 40;
      $scope.ordersList = [];
      $scope.canSeeMore = false;
      $scope.currentPage = 1;
      return getOrders();
    };
    mgappCloseRequest = function() {
      if ($scope.previousState != null) {
        return $state.go($scope.previousState.name);
      } else {
        return window.mgapp.close_screen();
      }
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=patient-inventory-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms.specific:AggirStructCtrl
    * @description
    * # AggirStructCtrl
    * Controller of aggir forms
   */
  angular.module('mhclientApp').controller('AggirStructCtrl', ["$scope", "$filter", function($scope, $filter) {
    var computeGrpA, computeGrpB, computeGrpC, computeGrpD, computeGrpE, computeGrpF, computeGrpG, computeGrpH, conputeRank;
    $scope.GIR = 0;
    $scope.setForm = function(form, container) {
      if ($scope.version.formStruct && $scope.version.formStruct.$dirty) {
        form.$setDirty();
      }
      $scope.version.formStruct = form;
      $scope.formStruct = form;
      if (container.dataContent == null) {
        container.dataContent = {};
      }
      if (container.dataContent.toilet == null) {
        container.dataContent.toilet = {};
      }
      if (container.dataContent.dressing == null) {
        container.dataContent.dressing = {};
      }
      if (container.dataContent.food == null) {
        container.dataContent.food = {};
      }
      if (container.dataContent.elimination == null) {
        return container.dataContent.elimination = {};
      }
    };
    $scope.$watch('container.dataContent.toilet', (function(newV) {
      if (newV == null) {
        return;
      }
      if ((newV.top != null) && (newV.bottom != null)) {
        if (newV.top === "A" && newV.bottom === "A") {
          return newV.value = "A";
        } else if (newV.top === "C" && newV.bottom === "C") {
          return newV.value = "C";
        } else {
          return newV.value = "B";
        }
      }
    }), true);
    $scope.$watch('container.dataContent.dressing', (function(newV) {
      if (newV == null) {
        return;
      }
      if ((newV.top != null) && (newV.bottom != null) && (newV.average != null)) {
        if (newV.top === "A" && newV.bottom === "A" && newV.average === "A") {
          return newV.value = "A";
        } else if (newV.top === "C" && newV.bottom === "C" && newV.average === "C") {
          return newV.value = "C";
        } else {
          return newV.value = "B";
        }
      }
    }), true);
    $scope.$watch('container.dataContent.food', (function(newV) {
      if (newV == null) {
        return;
      }
      if ((newV.eat != null) && (newV.use != null)) {
        if (newV.eat === "A" && newV.use === "A") {
          return newV.value = "A";
        } else if (newV.eat === "C" && newV.use === "C") {
          return newV.value = "C";
        } else {
          return newV.value = "B";
        }
      }
    }), true);
    $scope.$watch('container.dataContent.elimination', (function(newV) {
      if (newV == null) {
        return;
      }
      if ((newV.urinary != null) && (newV.fecal != null)) {
        if (newV.urinary === "A" && newV.fecal === "A") {
          return newV.value = "A";
        } else if (newV.urinary === "C" && newV.fecal === "C") {
          return newV.value = "C";
        } else {
          return newV.value = "B";
        }
      }
    }), true);
    $scope.isFormFilled = function() {
      var dataContent;
      dataContent = $scope.container.dataContent;
      if (($scope.container != null) && ($scope.container.dataContent != null) && (dataContent.consistency != null) && (dataContent.orientation != null) && (dataContent.toilet.value != null) && (dataContent.dressing.value != null) && (dataContent.food.value != null) && (dataContent.elimination.value != null) && (dataContent.transfer != null) && (dataContent.moving_inside != null) && (dataContent.travel_outside != null) && (dataContent.remote_communication != null)) {
        return true;
      } else {
        return false;
      }
    };
    computeGrpA = function() {
      var dataContent, groupe;
      groupe = 0;
      dataContent = $scope.container.dataContent;
      if (!$scope.isFormFilled()) {
        return null;
      }
      if (dataContent.consistency === "C") {
        groupe += 2000;
      }
      if (dataContent.orientation === "C") {
        groupe += 1200;
      }
      if (dataContent.toilet.value === "C") {
        groupe += 40;
      }
      if (dataContent.dressing.value === "C") {
        groupe += 40;
      }
      if (dataContent.food.value === "C") {
        groupe += 60;
      }
      if (dataContent.elimination.value === "C") {
        groupe += 100;
      }
      if (dataContent.transfer === "C") {
        groupe += 800;
      }
      if (dataContent.moving_inside === "C") {
        groupe += 200;
      }
      if (dataContent.travel_outside === "C") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "C") {
        groupe += 0;
      }
      if (dataContent.consistency === "B") {
        groupe += 0;
      }
      if (dataContent.orientation === "B") {
        groupe += 0;
      }
      if (dataContent.toilet.value === "B") {
        groupe += 16;
      }
      if (dataContent.dressing.value === "B") {
        groupe += 16;
      }
      if (dataContent.food.value === "B") {
        groupe += 20;
      }
      if (dataContent.elimination.value === "B") {
        groupe += 16;
      }
      if (dataContent.transfer === "B") {
        groupe += 120;
      }
      if (dataContent.moving_inside === "B") {
        groupe += 32;
      }
      if (dataContent.travel_outside === "B") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "B") {
        groupe += 0;
      }
      return groupe;
    };
    computeGrpB = function() {
      var dataContent, groupe;
      groupe = 0;
      dataContent = $scope.container.dataContent;
      if (!$scope.isFormFilled()) {
        return null;
      }
      if (dataContent.consistency === "C") {
        groupe += 1500;
      }
      if (dataContent.orientation === "C") {
        groupe += 1200;
      }
      if (dataContent.toilet.value === "C") {
        groupe += 40;
      }
      if (dataContent.dressing.value === "C") {
        groupe += 40;
      }
      if (dataContent.food.value === "C") {
        groupe += 60;
      }
      if (dataContent.elimination.value === "C") {
        groupe += 100;
      }
      if (dataContent.transfer === "C") {
        groupe += 800;
      }
      if (dataContent.moving_inside === "C") {
        groupe += -80;
      }
      if (dataContent.travel_outside === "C") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "C") {
        groupe += 0;
      }
      if (dataContent.consistency === "B") {
        groupe += 320;
      }
      if (dataContent.orientation === "B") {
        groupe += 120;
      }
      if (dataContent.toilet.value === "B") {
        groupe += 16;
      }
      if (dataContent.dressing.value === "B") {
        groupe += 16;
      }
      if (dataContent.food.value === "B") {
        groupe += 0;
      }
      if (dataContent.elimination.value === "B") {
        groupe += 16;
      }
      if (dataContent.transfer === "B") {
        groupe += 120;
      }
      if (dataContent.moving_inside === "B") {
        groupe += -40;
      }
      if (dataContent.travel_outside === "B") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "B") {
        groupe += 0;
      }
      return groupe;
    };
    computeGrpC = function() {
      var dataContent, groupe;
      groupe = 0;
      dataContent = $scope.container.dataContent;
      if (!$scope.isFormFilled()) {
        return null;
      }
      if (dataContent.consistency === "C") {
        groupe += 0;
      }
      if (dataContent.orientation === "C") {
        groupe += 0;
      }
      if (dataContent.toilet.value === "C") {
        groupe += 40;
      }
      if (dataContent.dressing.value === "C") {
        groupe += 40;
      }
      if (dataContent.food.value === "C") {
        groupe += 60;
      }
      if (dataContent.elimination.value === "C") {
        groupe += 160;
      }
      if (dataContent.transfer === "C") {
        groupe += 1000;
      }
      if (dataContent.moving_inside === "C") {
        groupe += 400;
      }
      if (dataContent.travel_outside === "C") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "C") {
        groupe += 0;
      }
      if (dataContent.consistency === "B") {
        groupe += 0;
      }
      if (dataContent.orientation === "B") {
        groupe += 0;
      }
      if (dataContent.toilet.value === "B") {
        groupe += 16;
      }
      if (dataContent.dressing.value === "B") {
        groupe += 16;
      }
      if (dataContent.food.value === "B") {
        groupe += 20;
      }
      if (dataContent.elimination.value === "B") {
        groupe += 20;
      }
      if (dataContent.transfer === "B") {
        groupe += 200;
      }
      if (dataContent.moving_inside === "B") {
        groupe += 40;
      }
      if (dataContent.travel_outside === "B") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "B") {
        groupe += 0;
      }
      return groupe;
    };
    computeGrpD = function() {
      var dataContent, groupe;
      groupe = 0;
      dataContent = $scope.container.dataContent;
      if (!$scope.isFormFilled()) {
        return null;
      }
      if (dataContent.consistency === "C") {
        groupe += 0;
      }
      if (dataContent.orientation === "C") {
        groupe += 0;
      }
      if (dataContent.toilet.value === "C") {
        groupe += 0;
      }
      if (dataContent.dressing.value === "C") {
        groupe += 0;
      }
      if (dataContent.food.value === "C") {
        groupe += 2000;
      }
      if (dataContent.elimination.value === "C") {
        groupe += 400;
      }
      if (dataContent.transfer === "C") {
        groupe += 2000;
      }
      if (dataContent.moving_inside === "C") {
        groupe += 200;
      }
      if (dataContent.travel_outside === "C") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "C") {
        groupe += 0;
      }
      if (dataContent.consistency === "B") {
        groupe += 0;
      }
      if (dataContent.orientation === "B") {
        groupe += 0;
      }
      if (dataContent.toilet.value === "B") {
        groupe += 0;
      }
      if (dataContent.dressing.value === "B") {
        groupe += 0;
      }
      if (dataContent.food.value === "B") {
        groupe += 200;
      }
      if (dataContent.elimination.value === "B") {
        groupe += 200;
      }
      if (dataContent.transfer === "B") {
        groupe += 200;
      }
      if (dataContent.moving_inside === "B") {
        groupe += 0;
      }
      if (dataContent.travel_outside === "B") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "B") {
        groupe += 0;
      }
      return groupe;
    };
    computeGrpE = function() {
      var dataContent, groupe;
      groupe = 0;
      dataContent = $scope.container.dataContent;
      if (!$scope.isFormFilled()) {
        return null;
      }
      if (dataContent.consistency === "C") {
        groupe += 400;
      }
      if (dataContent.orientation === "C") {
        groupe += 400;
      }
      if (dataContent.toilet.value === "C") {
        groupe += 400;
      }
      if (dataContent.dressing.value === "C") {
        groupe += 400;
      }
      if (dataContent.food.value === "C") {
        groupe += 400;
      }
      if (dataContent.elimination.value === "C") {
        groupe += 800;
      }
      if (dataContent.transfer === "C") {
        groupe += 800;
      }
      if (dataContent.moving_inside === "C") {
        groupe += 200;
      }
      if (dataContent.travel_outside === "C") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "C") {
        groupe += 0;
      }
      if (dataContent.consistency === "B") {
        groupe += 0;
      }
      if (dataContent.orientation === "B") {
        groupe += 0;
      }
      if (dataContent.toilet.value === "B") {
        groupe += 100;
      }
      if (dataContent.dressing.value === "B") {
        groupe += 100;
      }
      if (dataContent.food.value === "B") {
        groupe += 100;
      }
      if (dataContent.elimination.value === "B") {
        groupe += 100;
      }
      if (dataContent.transfer === "B") {
        groupe += 100;
      }
      if (dataContent.moving_inside === "B") {
        groupe += 0;
      }
      if (dataContent.travel_outside === "B") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "B") {
        groupe += 0;
      }
      return groupe;
    };
    computeGrpF = function() {
      var dataContent, groupe;
      groupe = 0;
      dataContent = $scope.container.dataContent;
      if (!$scope.isFormFilled()) {
        return null;
      }
      if (dataContent.consistency === "C") {
        groupe += 200;
      }
      if (dataContent.orientation === "C") {
        groupe += 200;
      }
      if (dataContent.toilet.value === "C") {
        groupe += 500;
      }
      if (dataContent.dressing.value === "C") {
        groupe += 500;
      }
      if (dataContent.food.value === "C") {
        groupe += 500;
      }
      if (dataContent.elimination.value === "C") {
        groupe += 500;
      }
      if (dataContent.transfer === "C") {
        groupe += 500;
      }
      if (dataContent.moving_inside === "C") {
        groupe += 500;
      }
      if (dataContent.travel_outside === "C") {
        groupe += 200;
      }
      if (dataContent.remote_communication === "C") {
        groupe += 0;
      }
      if (dataContent.consistency === "B") {
        groupe += 0;
      }
      if (dataContent.orientation === "B") {
        groupe += 100;
      }
      if (dataContent.toilet.value === "B") {
        groupe += 100;
      }
      if (dataContent.dressing.value === "B") {
        groupe += 100;
      }
      if (dataContent.food.value === "B") {
        groupe += 100;
      }
      if (dataContent.elimination.value === "B") {
        groupe += 100;
      }
      if (dataContent.transfer === "B") {
        groupe += 100;
      }
      if (dataContent.moving_inside === "B") {
        groupe += 0;
      }
      if (dataContent.travel_outside === "B") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "B") {
        groupe += 0;
      }
      return groupe;
    };
    computeGrpG = function() {
      var dataContent, groupe;
      groupe = 0;
      dataContent = $scope.container.dataContent;
      if (!$scope.isFormFilled()) {
        return null;
      }
      if (dataContent.consistency === "C") {
        groupe += 150;
      }
      if (dataContent.orientation === "C") {
        groupe += 150;
      }
      if (dataContent.toilet.value === "C") {
        groupe += 300;
      }
      if (dataContent.dressing.value === "C") {
        groupe += 300;
      }
      if (dataContent.food.value === "C") {
        groupe += 500;
      }
      if (dataContent.elimination.value === "C") {
        groupe += 500;
      }
      if (dataContent.transfer === "C") {
        groupe += 400;
      }
      if (dataContent.moving_inside === "C") {
        groupe += 200;
      }
      if (dataContent.travel_outside === "C") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "C") {
        groupe += 0;
      }
      if (dataContent.consistency === "B") {
        groupe += 0;
      }
      if (dataContent.orientation === "B") {
        groupe += 0;
      }
      if (dataContent.toilet.value === "B") {
        groupe += 200;
      }
      if (dataContent.dressing.value === "B") {
        groupe += 200;
      }
      if (dataContent.food.value === "B") {
        groupe += 200;
      }
      if (dataContent.elimination.value === "B") {
        groupe += 200;
      }
      if (dataContent.transfer === "B") {
        groupe += 200;
      }
      if (dataContent.moving_inside === "B") {
        groupe += 100;
      }
      if (dataContent.travel_outside === "B") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "B") {
        groupe += 0;
      }
      return groupe;
    };
    computeGrpH = function() {
      var dataContent, groupe;
      groupe = 0;
      dataContent = $scope.container.dataContent;
      if (!$scope.isFormFilled()) {
        return null;
      }
      if (dataContent.consistency === "C") {
        groupe += 0;
      }
      if (dataContent.orientation === "C") {
        groupe += 0;
      }
      if (dataContent.toilet.value === "C") {
        groupe += 3000;
      }
      if (dataContent.dressing.value === "C") {
        groupe += 3000;
      }
      if (dataContent.food.value === "C") {
        groupe += 3000;
      }
      if (dataContent.elimination.value === "C") {
        groupe += 3000;
      }
      if (dataContent.transfer === "C") {
        groupe += 1000;
      }
      if (dataContent.moving_inside === "C") {
        groupe += 1000;
      }
      if (dataContent.travel_outside === "C") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "C") {
        groupe += 0;
      }
      if (dataContent.consistency === "B") {
        groupe += 0;
      }
      if (dataContent.orientation === "B") {
        groupe += 0;
      }
      if (dataContent.toilet.value === "B") {
        groupe += 2000;
      }
      if (dataContent.dressing.value === "B") {
        groupe += 2000;
      }
      if (dataContent.food.value === "B") {
        groupe += 2000;
      }
      if (dataContent.elimination.value === "B") {
        groupe += 2000;
      }
      if (dataContent.transfer === "B") {
        groupe += 2000;
      }
      if (dataContent.moving_inside === "B") {
        groupe += 1000;
      }
      if (dataContent.travel_outside === "B") {
        groupe += 0;
      }
      if (dataContent.remote_communication === "B") {
        groupe += 0;
      }
      return groupe;
    };
    conputeRank = function() {
      var rankValue;
      rankValue = computeGrpA();
      if (rankValue === null) {
        return null;
      }
      if (rankValue >= 4380) {
        $scope.rank = 1;
      } else if (rankValue < 4380 && rankValue >= 4140) {
        $scope.rank = 2;
      } else if (rankValue < 4140 && rankValue >= 3390) {
        $scope.rank = 3;
      } else {
        rankValue = computeGrpB();
        if (rankValue >= 2016) {
          $scope.rank = 4;
        } else {
          rankValue = computeGrpC();
          if (rankValue >= 1700) {
            $scope.rank = 5;
          } else if (rankValue < 1700 && rankValue >= 1432) {
            $scope.rank = 6;
          } else {
            rankValue = computeGrpD();
            if (rankValue >= 2400) {
              $scope.rank = 7;
            } else {
              rankValue = computeGrpE();
              if (rankValue >= 1200) {
                $scope.rank = 8;
              } else {
                rankValue = computeGrpF();
                if (rankValue >= 800) {
                  $scope.rank = 9;
                } else {
                  rankValue = computeGrpG();
                  if (rankValue >= 650) {
                    $scope.rank = 10;
                  } else {
                    rankValue = computeGrpH();
                    if (rankValue >= 4000) {
                      $scope.rank = 11;
                    } else if (rankValue < 4000 && rankValue >= 2000) {
                      $scope.rank = 12;
                    } else {
                      $scope.rank = 13;
                    }
                  }
                }
              }
            }
          }
        }
      }
      return $scope.rank;
    };
    $scope.computeGIR = function() {
      return $filter('translate')("UNFILL_FORM");
    };
    return $scope.computeGIR = function() {
      var rank;
      rank = conputeRank();
      if (rank === null) {
        $scope.GIR = $filter('translate')("UNFILL_FORM");
        return $scope.GIR;
      }
      if (rank === 1) {
        $scope.GIR = 1;
      } else if (rank >= 2 && rank <= 7) {
        $scope.GIR = 2;
      } else if (rank >= 8 && rank <= 9) {
        $scope.GIR = 3;
      } else if (rank >= 10 && rank <= 11) {
        $scope.GIR = 4;
      } else if (rank === 12) {
        $scope.GIR = 5;
      } else if (rank === 13) {
        $scope.GIR = 6;
      } else {
        $scope.GIR = "erreur";
      }
      return $scope.GIR;
    };
  }]);

}).call(this);

//# sourceMappingURL=aggir-struct-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:compte Rendu hospitalier struct form
    * @descriptions
    * # CrHospitFormCtrl
    * Controller of compte Rendu hospitalier struct form
   */
  angular.module('mhclientApp').controller('CrHospitFormCtrl', ["$scope", "$rootScope", "$filter", "$uibModal", "Message", "Feed", "Thread", "User", "UserUtils", "moment", "Prescription", "PrescUtils", "Ordonnance", "$q", "Psp", "HealthIssue", function($scope, $rootScope, $filter, $uibModal, Message, Feed, Thread, User, UserUtils, moment, Prescription, PrescUtils, Ordonnance, $q, Psp, HealthIssue) {
    var genIASText, genMedicalObsText, genPSP2Text, genPSPText, genPrescText, genUserAdressText, getAntecedents, getIAS, getMedicalObs, getOutOrdoDonePromise, getPSP, getPSP2, getStoppedPrescWithReason, groupByCategoryAndGroup, stopReasons;
    $scope.user = $rootScope.user;
    $scope.utils = $rootScope.utils;
    getAntecedents = function() {
      var txt;
      txt = '';
      if ($scope.stay.medical_data.ANT) {
        txt += _.escape($scope.stay.medical_data.ANT).replace(/[\r\n]+/g, "<br/>");
      } else if ($scope.stay.medical_data.ANTECEDENTS) {
        txt += _.escape($scope.stay.medical_data.ANTECEDENTS).replace(/[\r\n]+/g, "<br/>");
      }
      if ($scope.stay.medical_data.ANTM) {
        txt += "<br>Antécédents médicaux : " + _.escape($scope.stay.medical_data.ANTM).replace(/[\r\n]+/g, "<br/>");
      }
      if ($scope.stay.medical_data.ANTC) {
        txt += "<br>Antécédents chirurgicaux : " + _.escape($scope.stay.medical_data.ANTC).replace(/[\r\n]+/g, "<br/>");
      }
      return txt;
    };
    $scope.genAntecedents = function() {
      return $scope.container.dataContent.antecedents = getAntecedents();
    };
    $scope.genHISM = function() {
      return $scope.container.dataContent.HISM = _.escape($scope.stay.medical_data.HISM).replace(/[\r\n]+/g, "<br/>") || "";
    };
    genUserAdressText = function(user) {
      var addressTextFull, address_data;
      addressTextFull = "";
      address_data = user.user_profile.data.address_data;
      if (address_data && Object.keys(address_data).length) {
        addressTextFull += (address_data.address || '') + '\n';
        addressTextFull += (address_data.zip_code || '') + ' ';
        addressTextFull += (address_data.town || '') + '\n';
        addressTextFull += address_data.country || '';
      }
      return addressTextFull;
    };
    getPSP = function(page) {
      if (page == null) {
        page = 1;
      }
      return Feed.api.query({
        feature__name: "MHC_PSP"
      }).$promise.then(function(feeds) {
        var feed, params;
        feed = feeds[0];
        params = {
          feed: feed.id,
          stay: $scope.stay.id,
          archived: false,
          page: page
        };
        return Thread.api.query(params).$promise.then(function(threads) {
          if ($scope.PSPs == null) {
            $scope.PSPs = [];
          }
          $scope.PSPs = _.sortBy($scope.PSPs.concat(threads.results), "first_message.timestamp").reverse();
          $scope.PSPs.forEach(function(thread) {
            if (!_.find($scope.container.dataContent.PSPs, {
              id: thread.id
            })) {
              return Message.getMessageContent(thread.first_message).promise.then(function(content) {
                var _data;
                thread.first_message.content = content.data;
                _data = {
                  id: thread.id,
                  content: genPSPText(thread),
                  timestamp: thread.first_message.timestamp
                };
                return $scope.container.dataContent.PSPs.push(_data);
              });
            }
          });
          if (threads.next != null) {
            return getPSP(page + 1);
          }
        });
      });
    };
    $scope.genPSPText = function(id) {
      var contentThread, thread;
      contentThread = _.find($scope.container.dataContent.PSPs, function(thread) {
        return thread.id === id;
      });
      thread = _.find($scope.PSPs, function(thread) {
        return thread.id === id;
      });
      if (thread) {
        if (!angular.isObject(thread.first_message.content)) {
          return Message.getMessageContent(thread.first_message).promise.then(function(content) {
            thread.first_message.content = content.data;
            return contentThread.content = genPSPText(thread);
          });
        } else {
          return contentThread.content = genPSPText(thread);
        }
      } else {
        $rootScope.busy = true;
        return Thread.api.get({
          id: id
        }).$promise.then(function(thread) {
          return Message.api.get({
            id: thread.first_message
          }).$promise.then(function(message) {
            thread.first_message = message;
            return Message.getMessageContent(thread.first_message).promise.then(function(content) {
              thread.first_message.content = content.data;
              if ($scope.PSPs == null) {
                $scope.PSPs = [];
              }
              $scope.PSPs.push(thread);
              contentThread.content = genPSPText(thread);
              return $rootScope.busy = false;
            });
          });
        });
      }
    };
    genPSPText = function(thread) {
      var category, fullText, index;
      category = $filter('translate')($filter('uppercase')(thread.first_message.category));
      fullText = "<p><strong>" + category + ":</strong> " + " - <u>";
      fullText += $filter("date")(thread.first_message.timestamp, "dd MMM yyyy") + " :</u> " + "<br/>";
      fullText += thread.first_message.content.data.freeZone.split('\n').join('<br/>');
      fullText += '<br/>';
      index = 1;
      thread.first_message.content.data.objectives.forEach(function(objective) {
        fullText += $filter('translate')("OBJECTIVE") + index;
        fullText += ": " + objective + '<br/>';
        return index = index + 1;
      });
      fullText += '</p>';
      return fullText;
    };
    getPSP2 = function(page) {
      if (page == null) {
        page = 1;
      }
      if ($scope.PSPs == null) {
        $scope.PSP2s = [];
      }
      return Psp.api.query({
        "stay": $scope.stay.id
      }).$promise.then(function(psps) {
        $scope.PSP2s = psps;
        return $scope.PSP2s.forEach(function(psp) {
          var reviews;
          reviews = psp.reviews;
          return HealthIssue.api.query({
            "psp": psp.id
          }).$promise.then(function(healthIssues) {
            reviews.forEach(function(review) {
              var _data, computedReview;
              computedReview = Psp.getReview(review, healthIssues, psp);
              _data = {
                id: computedReview.id,
                pspId: psp.id,
                content: genPSP2Text(computedReview),
                timestamp: computedReview.timestamp
              };
              return $scope.container.dataContent.PSP2s.push(_data);
            });
            if (reviews.next != null) {
              return getPSP2(page + 1);
            }
          });
        });
      });
    };
    $scope.genPSP2Text = function(id, pspId) {
      var contentPSP2, psp, review;
      contentPSP2 = _.find($scope.container.dataContent.PSP2s, function(review) {
        return review.id === id;
      });
      psp = _.find($scope.PSP2s, function(psp) {
        return _.find(psp.reviews, function(review) {
          return review.id === id;
        });
      });
      if (psp) {
        review = _.find(psp.reviews, function(review) {
          return review.id === id;
        });
        return contentPSP2.content = genPSP2Text(review);
      } else {
        $rootScope.busy = true;
        return (pspId ? Psp.api.get({
          "id": pspId
        }) : Psp.api.query({
          "stay": $scope.stay.id
        })).$promise.then(function(psps) {
          psp = pspId ? psps : psps[0];
          if ($scope.PSP2s == null) {
            $scope.PSP2s = [];
          }
          $scope.PSP2s.push(psp);
          return HealthIssue.api.query({
            "psp": psp.id
          }).$promise.then(function(healthIssues) {
            review = _.find(psp.reviews, function(review) {
              return review.id === id;
            });
            contentPSP2.content = genPSP2Text(Psp.getReview(review, healthIssues, psp));
            return $rootScope.busy = false;
          });
        });
      }
    };
    genPSP2Text = function(review) {
      var fullText, ref, status;
      status = $filter('translate')($filter('uppercase')(review.status));
      fullText = "<p><strong>" + status + ":</strong> " + " - <u>";
      fullText += $filter("date")(review.timestamp, "dd MMM yyyy") + "</u> ";
      if (review.modified_timestamp != null) {
        fullText += "- <u>" + $filter('translate')("MODIFIED_ON") + $filter("date")(review.modified_timestamp, "dd MMM yyyy") + "</u>";
      }
      fullText += "</p>";
      fullText += "<p><u>" + $filter('translate')('PATIENT_EXPECTATIONS') + "</u></p>";
      if (((ref = review.patientExpectations) != null ? ref.text : void 0) != null) {
        fullText += "<p>" + review.patientExpectations.text.split('\n').join('<br/>') + "</p>";
      }
      if (review.freezone.mode === 'text' && (review.freezone.text != null)) {
        fullText += "<p><u>" + $filter('translate')('FREEZONE') + "</u></p>";
        fullText += "<p>" + review.freezone.text.split('\n').join('<br/>') + "</p>";
      }
      if (review.therapeuticPrograms != null) {
        fullText += "<p><u>" + $filter('translate')('THERAPEUTIC_PROJECTS') + "</u></p>";
        review.therapeuticPrograms.forEach(function(tp) {
          var comment, objectiveThesaurusUid, ref1;
          fullText += tp.label;
          if (review.objectivesComments && (review.objectivesComments[tp.thesaurus_uid] != null) && !$rootScope.isEmpty(review.objectivesComments[tp.thesaurus_uid])) {
            fullText += "<p><u>" + $filter('translate')('STOPPED_OBJECTIVES') + "</u></p>";
            fullText += "<ul>";
            ref1 = review.objectivesComments[tp.thesaurus_uid];
            for (objectiveThesaurusUid in ref1) {
              comment = ref1[objectiveThesaurusUid];
              fullText += "<li>" + comment + "</li>";
            }
            fullText += "</ul>";
          }
          return tp.objectives.forEach(function(objective) {
            fullText += "<ul>" + "<li>" + objective.label + "</li>";
            fullText += "<ul>";
            objective.healthIssues.forEach(function(issue) {
              return fullText += "<li>" + issue.label + "</li>";
            });
            return fullText += "</ul></ul>";
          });
        });
      }
      if (review.healthIssues != null) {
        fullText += "<u>" + $filter('translate')('OTHERS_OBJECTIVES') + "</u>";
        fullText += "<ul>";
        review.healthIssues.forEach(function(issue) {
          return fullText += "<li>" + issue.label + "</li>";
        });
        fullText += "</ul>";
      }
      fullText += '\n';
      return fullText;
    };
    getIAS = function(page) {
      if (page == null) {
        page = 1;
      }
      return Feed.api.query({
        feature__name: "MHC_IAS"
      }).$promise.then(function(feeds) {
        var feed, params;
        feed = feeds[0];
        params = {
          feed: feed.id,
          stay: $scope.stay.id,
          archived: false,
          page: page
        };
        return Thread.api.query(params).$promise.then(function(threads) {
          if ($scope.IASs == null) {
            $scope.IASs = [];
          }
          $scope.IASs = _.sortBy($scope.IASs.concat(threads.results), "first_message.timestamp").reverse();
          $scope.IASs.forEach(function(thread) {
            if (!_.find($scope.container.dataContent.IASs, {
              id: thread.id
            })) {
              return Message.getMessageContent(thread.first_message).promise.then(function(content) {
                var _data;
                thread.first_message.content = content.data;
                _data = {
                  id: thread.id,
                  content: genIASText(thread),
                  timestamp: thread.first_message.timestamp
                };
                return $scope.container.dataContent.IASs.push(_data);
              });
            }
          });
          if (threads.next != null) {
            return getIAS(page + 1);
          }
        });
      });
    };
    $scope.genIASText = function(id) {
      var contentThread, thread;
      contentThread = _.find($scope.container.dataContent.IASs, {
        id: id
      });
      thread = _.find($scope.IASs, {
        id: id
      });
      if (thread) {
        if ((thread.first_message == null) || (thread.first_message.content == null) || !angular.isObject(thread.first_message.content)) {
          return Message.getMessageContent(thread.first_message).promise.then(function(content) {
            thread.first_message.content = content.data;
            return contentThread.content = genIASText(thread);
          });
        } else {
          return contentThread.content = genIASText(thread);
        }
      } else {
        $rootScope.busy = true;
        return Thread.api.get({
          id: id
        }).$promise.then(function(thread) {
          return Message.api.get({
            id: thread.first_message
          }).$promise.then(function(message) {
            thread.first_message = message;
            return Message.getMessageContent(thread.first_message).promise.then(function(content) {
              thread.first_message.content = content.data;
              if ($scope.IASs == null) {
                $scope.IASs = [];
              }
              $scope.IASs.push(thread);
              contentThread.content = genIASText(thread);
              return $rootScope.busy = false;
            });
          });
        });
      }
    };
    genIASText = function(IAS) {
      var fullText;
      fullText = "<p><u>" + $filter("date")(IAS.first_message.timestamp, "dd MMM yyyy") + " :</u> ";
      fullText += '<br/>';
      if (IAS.data.otherAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label other-alert mhicon mhico-thermometer"></span>' + $filter('translate')("OTHER_ALERT");
        fullText += '</span>';
      }
      if (IAS.data.contactAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label contact-alert mhicon mhico-hand"></span>' + $filter('translate')("CONTACT_ALERT");
        fullText += '</span>';
      }
      if (IAS.data.dropAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label droplet-alert mhicon mhico-medical-mask"></span>' + $filter('translate')("DROPS_ALERT");
        fullText += '</span>';
      }
      if (IAS.data.airAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label air-alert mhicon mhico-medical-mask-ffp2"></span>' + $filter('translate')("AIR_ALERT");
        fullText += '</span>';
      }
      if (IAS.data.scabiesAlertRunning) {
        fullText += '<span class="ng-binding"><span class="alert-label scabies-alert mhicon mhico-google"></span>' + $filter('translate')("SCABIES_ALERT");
        fullText += '</span>';
      }
      fullText += '<br/>';
      if (IAS.first_message.content.mode === "text") {
        if (IAS.first_message.content.data.diagnosis_date != null) {
          fullText += 'diagnostiqué le : ' + $filter('date')(IAS.first_message.content.data.diagnosis_date) + '<br/>';
        }
        fullText += 'BMR : ' + $filter('translate')($filter('boolToYes')(IAS.first_message.content.data.BMR)) + '<br/>';
        fullText += 'BHRe : ' + $filter('translate')($filter('boolToYes')(IAS.first_message.content.data.BHRe)) + '<br/>';
        fullText += 'traité : ' + $filter('translate')($filter('boolToYes')(IAS.first_message.content.data.treated)) + '<br/>';
        if (IAS.first_message.content.data.germ_name != null) {
          fullText += 'germe : ' + IAS.first_message.content.data.germ_name + '<br/>';
        }
        if (IAS.first_message.content.data.germ_origin != null) {
          fullText += 'provenance : ' + IAS.first_message.content.data.germ_origin + '<br/>';
        }
        if (IAS.first_message.content.data.infection_area != null) {
          fullText += 'site : ' + IAS.first_message.content.data.infection_area + '<br/>';
        }
        if (IAS.first_message.content.data.antibiotic != null) {
          fullText += 'antibiotique : ' + IAS.first_message.content.data.antibiotic + '<br/>';
        }
        if (IAS.first_message.content.data.action_plan != null) {
          fullText += 'dispositif : ' + IAS.first_message.content.data.action_plan + '<br/>';
        }
        if (IAS.first_message.content.data.complementary_step != null) {
          fullText += 'mesures complémentaires : ' + IAS.first_message.content.data.complementary_step + '<br/>';
        }
      } else {
        fullText += $filter('translate')("IMPOSSIBLE_TO_SHOW_PSP_IMAGE");
      }
      fullText += '</p>\n';
      return fullText;
    };
    getMedicalObs = function(page) {
      if (page == null) {
        page = 1;
      }
      return Feed.api.query({
        feature__name: "MHC_OBSERVATION"
      }).$promise.then(function(feeds) {
        var feed, params;
        feed = feeds[0];
        params = {
          feed: feed.id,
          stay: $scope.stay.id,
          archived: false,
          page: page
        };
        return Thread.api.query(params).$promise.then(function(threads) {
          if ($scope.medicalObs == null) {
            $scope.medicalObs = [];
          }
          $scope.medicalObs = _.sortBy($scope.medicalObs.concat(threads.results), "first_message.timestamp").reverse();
          $scope.medicalObs.forEach(function(thread) {
            if (!_.find($scope.container.dataContent.medicalObs, {
              id: thread.id
            })) {
              return Message.getMessageContent(thread.first_message).promise.then(function(content) {
                var _data;
                thread.first_message.content = content.data;
                _data = {
                  id: thread.id,
                  content: genMedicalObsText(thread),
                  timestamp: thread.first_message.timestamp,
                  eventDate: thread.first_message.data.eventDate
                };
                return $scope.container.dataContent.medicalObs.push(_data);
              });
            }
          });
          if (threads.next != null) {
            return getMedicalObs(page + 1);
          }
        });
      });
    };
    $scope.stripFormat = function($html) {
      var pattern;
      pattern = /style=".+?"/gm;
      return $html.replace(pattern, '');
    };
    $scope.genMedicalObsText = function(id) {
      var contentThread, thread;
      contentThread = _.find($scope.container.dataContent.medicalObs, {
        id: id
      });
      thread = _.find($scope.medicalObs, {
        id: id
      });
      if (thread) {
        if (!angular.isObject(thread.first_message.content)) {
          return Message.getMessageContent(thread.first_message).promise.then(function(content) {
            thread.first_message.content = content.data;
            return contentThread.content = genMedicalObsText(thread);
          });
        } else {
          return contentThread.content = genMedicalObsText(thread);
        }
      } else {
        $rootScope.busy = true;
        return Thread.api.get({
          id: id
        }).$promise.then(function(thread) {
          return Message.api.get({
            id: thread.first_message
          }).$promise.then(function(message) {
            thread.first_message = message;
            return Message.getMessageContent(thread.first_message).promise.then(function(content) {
              thread.first_message.content = content.data;
              if ($scope.medicalObs == null) {
                $scope.medicalObs = [];
              }
              $scope.medicalObs.push(thread);
              contentThread.content = genMedicalObsText(thread);
              return $rootScope.busy = false;
            });
          });
        });
      }
    };
    genMedicalObsText = function(medicalObs) {
      var fullText;
      fullText = "<p><strong>" + medicalObs.first_message.data.subject + "</strong> - <u>";
      fullText += $filter("date")(medicalObs.first_message.data.eventDate, "dd MMM yyyy") + " : </u>";
      fullText += '<br/>';
      if (medicalObs.first_message.content.mode === "text") {
        fullText += _.escape(medicalObs.first_message.content.data).split('\n').join('<br/>');
      } else {
        fullText += $filter('translate')("IMPOSSIBLE_TO_SHOW_PSP_IMAGE");
      }
      fullText += '</p>';
      return fullText;
    };
    getStoppedPrescWithReason = function() {
      return Prescription.query({
        state: 'STOPPED',
        stay: $scope.stay.id,
        exclude_discharge_prescs: true
      }).$promise.then(function(result) {
        $scope.prescs = _.filter(result, function(presc) {
          return presc.data.stop_reason && presc.data.stop_reason !== '--';
        });
        return $scope.prescs.forEach(function(presc) {
          var _data;
          if (!_.find($scope.container.dataContent.prescs, {
            id: presc.id
          })) {
            _data = {
              id: presc.id,
              content: genPrescText(presc)
            };
            return $scope.container.dataContent.prescs.push(_data);
          }
        });
      });
    };
    $scope.genPrescText = function(id) {
      var contentPresc, presc;
      contentPresc = _.find($scope.container.dataContent.prescs, {
        id: id
      });
      presc = _.find($scope.prescs, {
        id: id
      });
      if (presc) {
        return contentPresc.content = genPrescText(presc);
      } else {
        $rootScope.busy = true;
        return Prescription.get({
          id: id
        }).$promise.then(function(presc) {
          if ($scope.prescs == null) {
            $scope.prescs = [];
          }
          $scope.prescs.push(presc);
          $rootScope.busy = false;
          return contentPresc.content = genPrescText(presc);
        });
      }
    };
    genPrescText = function(presc) {
      var fullText, reason;
      reason = _.find(stopReasons, {
        code: presc.data.stop_reason
      });
      fullText = '<p>' + presc.data.display_text + '</p>';
      fullText += "<p>Cette prescription a été arrêtée le ";
      fullText += $filter('date')(presc.expiration_time);
      if (reason) {
        fullText += " pour motif '";
        fullText += $filter('translate')(reason.label) + "'";
      }
      if (presc.data.stop_comment) {
        fullText += ", avec commentaire '";
        fullText += _.escape(presc.data.stop_comment) + "'";
      }
      fullText += "</p>";
      return fullText;
    };
    UserUtils.getUsersForPatient($scope.patient_detail.si_id).then(function(users) {
      var addressTextFull, allDetails, doc, medTraitants;
      medTraitants = _.chain(users).filter(function(user) {
        return user.is_active;
      }).filter(function(user) {
        return user.group.name.toLowerCase().indexOf("médecin traitant") >= 0;
      }).map(function(user) {
        return user;
      }).value();
      if (medTraitants.length > 0) {
        doc = medTraitants[0];
        addressTextFull = genUserAdressText(doc);
        allDetails = doc.full_name + '\n' + addressTextFull;
        return $scope.container.dataContent.medecinTraitant = {
          full_name: doc.full_name,
          address: addressTextFull,
          allDetails: allDetails
        };
      }
    });
    getOutOrdoDonePromise = $q.defer();
    $scope.getOutOrdo = function() {
      if ($scope.version.readonly) {
        if ($scope.container.dataContent.outOrdo == null) {
          return;
        }
        return getOutOrdoDonePromise.resolve($scope.container.dataContent.outOrdo);
      } else if (!$scope.container.dataContent.outOrdo.prescriptions) {
        return Ordonnance.query({
          stay: $scope.stay.id
        }).$promise.then(function(result) {
          $scope.container.dataContent.outOrdo = _.find(result, {
            discharge_prescription: true
          });
          if ($scope.container.dataContent.outOrdo == null) {
            return;
          }
          return getOutOrdoDonePromise.resolve($scope.container.dataContent.outOrdo);
        });
      } else {
        return getOutOrdoDonePromise.resolve($scope.container.dataContent.outOrdo);
      }
    };
    groupByCategoryAndGroup = function(prescriptions) {
      var categories_dict, i, len, prescriptionsByCategory, prescriptions_by_category;
      prescriptions_by_category = [];
      categories_dict = {};
      prescriptions.forEach(function(prescription) {
        var category;
        category = prescription.category;
        if (categories_dict[category.id] != null) {
          return categories_dict[category.id].prescriptions.push(prescription);
        } else {
          categories_dict[category.id] = {
            "label": category.label,
            "prescriptions": [prescription],
            "order": category.order
          };
          return prescriptions_by_category.push(categories_dict[category.id]);
        }
      });
      for (i = 0, len = prescriptions_by_category.length; i < len; i++) {
        prescriptionsByCategory = prescriptions_by_category[i];
        prescriptionsByCategory.groupedPrescriptions = PrescUtils.groupPrescriptions(prescriptionsByCategory.prescriptions);
      }
      return prescriptions_by_category;
    };
    getOutOrdoDonePromise.promise.then(function(outOrdo) {
      $scope.current_ordonnance = outOrdo;
      $scope.current_ordonnance.ald_prescriptions = [];
      $scope.current_ordonnance.non_ald_prescriptions = [];
      return Ordonnance.getPrescriptions({
        id: $scope.current_ordonnance.id
      }).$promise.then(function(prescriptions) {
        $scope.current_ordonnance.prescriptions = true;
        prescriptions.forEach(function(prescription) {
          if (prescription.data.ald) {
            return $scope.current_ordonnance.ald_prescriptions.push(prescription);
          } else {
            return $scope.current_ordonnance.non_ald_prescriptions.push(prescription);
          }
        });
        $scope.current_ordonnance.ald_prescriptions_by_category = groupByCategoryAndGroup($scope.current_ordonnance.ald_prescriptions);
        return $scope.current_ordonnance.non_ald_prescriptions_by_category = groupByCategoryAndGroup($scope.current_ordonnance.non_ald_prescriptions);
      });
    });
    $scope.initDoctorsRecipients = function(groupName, groupUid) {
      if (!$scope.container.dataContent.recipientDoctors || $scope.container.dataContent.recipientDoctors.length === 0) {
        return UserUtils.getUsersForPatient($scope.patient.si_id).then(function(users) {
          var _data, addressTextFull, i, len, query, results, user;
          if (groupUid) {
            query = {
              group: {
                uid: groupUid
              }
            };
          } else {
            query = {
              group: {
                name: groupName
              }
            };
          }
          users = _.filter(users, query);
          users = _.sortBy(users, 'last_name');
          $scope.container.dataContent.recipientDoctors = [];
          results = [];
          for (i = 0, len = users.length; i < len; i++) {
            user = users[i];
            addressTextFull = genUserAdressText(user);
            _data = {
              id: user.id,
              name: user.full_name,
              manualAddress: addressTextFull
            };
            results.push($scope.container.dataContent.recipientDoctors.push(_data));
          }
          return results;
        });
      }
    };
    $scope.initCaregiversRecipients = function() {
      if (!$scope.container.dataContent.recipientCaregivers || $scope.container.dataContent.recipientCaregivers.length === 0) {
        $scope.container.dataContent.recipientCaregivers = [];
        if (!$scope.container.dataContent.recipients) {
          $scope.container.dataContent.recipients = [];
        }
        return UserUtils.getUsersForPatient($scope.patient.si_id).then(function(users) {
          var _data, addressTextFull, caregiver, i, len, results;
          users = _.sortBy(users, 'last_name');
          results = [];
          for (i = 0, len = users.length; i < len; i++) {
            caregiver = users[i];
            if (caregiver.group.liberal) {
              addressTextFull = genUserAdressText(caregiver);
              _data = {
                id: caregiver.id,
                group_name: caregiver.group.name,
                occupation: caregiver.user_profile.occupation,
                name: caregiver.full_name,
                address: caregiver.user_profile.data.address_data,
                username: caregiver.username,
                addressTextFull: addressTextFull,
                id_nat: caregiver.user_profile.data.id_nat
              };
              $scope.container.dataContent.recipientCaregivers.push(_data);
              if (caregiver.group.name.toLowerCase().indexOf("médecin traitant") >= 0 && $scope.container.dataContent.recipients.length === 0) {
                results.push($scope.container.dataContent.recipients.push(_data));
              } else {
                results.push(void 0);
              }
            } else {
              results.push(void 0);
            }
          }
          return results;
        });
      }
    };
    $scope.initDoctorsSigns = function(groupName, groupUid) {
      if (!$scope.container.dataContent.signsDoctors || $scope.container.dataContent.signsDoctors.length === 0) {
        return UserUtils.getUsersForPatient($scope.patient.si_id).then(function(users) {
          var query;
          if (groupUid) {
            query = {
              group: {
                uid: groupUid
              }
            };
          } else {
            query = {
              group: {
                name: groupName
              }
            };
          }
          users = _.filter(users, query);
          users = _.sortBy(users, 'full_name');
          _.map(users, function(user) {
            return user.first_name = user.full_name;
          });
          return $scope.container.dataContent.signsDoctors = users;
        });
      }
    };
    $scope.getStayBeginDate = function() {
      if (!$scope.container.dataContent.linked_stay_begin_date && !$scope.version.readonly) {
        $scope.container.dataContent.linked_stay_begin_date = $filter('date')($scope.stay.d_from, "dd/MM/yyyy");
      }
      return $scope.container.dataContent.linked_stay_begin_date;
    };
    $scope.getStayEndDate = function() {
      if (!$scope.container.dataContent.linked_stay_end_date && !$scope.version.readonly) {
        $scope.container.dataContent.linked_stay_end_date = $filter('date')($scope.stay.d_to, "dd/MM/yyyy");
      }
      return $scope.container.dataContent.linked_stay_end_date;
    };
    $scope.showOutOrdoModal = function() {
      var i, len, modalContent, page, ref;
      modalContent = [];
      ref = $scope.container.dataContent.outOrdo.pages;
      for (i = 0, len = ref.length; i < len; i++) {
        page = ref[i];
        modalContent.push('<img width="100%" src="' + page.image_url + '" />');
      }
      return $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return "Ordonnance de sortie";
          },
          text: function() {
            return modalContent.join('<br>');
          },
          cancelButtonText: function() {
            return '';
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return 'Ok';
          }
        }
      });
    };
    stopReasons = PrescUtils.getStopAvailableReason();
    $scope.today = moment().format('DD/MM/YYYY');
    $scope.initShowInfo = function(showVar) {
      if (showVar === void 0) {
        showVar = true;
      }
      return showVar;
    };
    return $scope.InitDone.promise.then(function() {
      var custom_fields, dataContent, field, i, len, patientData, ref, results;
      dataContent = $scope.container.dataContent;
      if (dataContent.PSPs == null) {
        dataContent.PSPs = [];
        getPSP();
      }
      if (dataContent.PSP2s == null) {
        dataContent.PSP2s = [];
        getPSP2();
      }
      if (typeof patientData === "undefined" || patientData === null) {
        patientData = {};
      }
      dataContent.principalPECMotif = dataContent.principalPECMotif || $scope.stay.medical_data.MODE_PEC_PRIMARY;
      dataContent.MODE_PEC_LINKED = dataContent.MODE_PEC_LINKED || $scope.stay.medical_data.MODE_PEC_LINKED;
      dataContent.HISM = dataContent.HISM || _.escape($scope.stay.medical_data.HISM).replace(/[\r\n]+/g, "<br/>");
      if (!$scope.version.readonly) {
        $scope.getStayBeginDate();
        $scope.getStayEndDate();
      }
      if ($scope.formName && $scope.formName === 'lettre_liaison') {
        dataContent.MOTH = dataContent.MOTH || $scope.stay.medical_data.MOTH || $scope.stay.medical_data.MOTIF_ADMISSION;
        if (dataContent.IASs == null) {
          dataContent.IASs = [];
          getIAS();
        }
        if (dataContent.medicalObs == null) {
          dataContent.medicalObs = [];
          getMedicalObs();
        }
        if (dataContent.prescs == null) {
          dataContent.prescs = [];
          getStoppedPrescWithReason();
        }
        if (dataContent.followUp == null) {
          dataContent.followUp = {};
        }
        if (dataContent.outOrdo == null) {
          dataContent.outOrdo = {};
          $scope.getOutOrdo();
        } else {
          $scope.current_ordonnance = dataContent.outOrdo;
        }
        dataContent.antecedents = dataContent.antecedents || getAntecedents();
        ref = $rootScope.custom_fields_detail_values;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          custom_fields = ref[i];
          if (custom_fields.id === "MEDICAL_DATA") {
            results.push((function() {
              var j, len1, ref1, results1;
              ref1 = custom_fields.fields;
              results1 = [];
              for (j = 0, len1 = ref1.length; j < len1; j++) {
                field = ref1[j];
                if (field.id === 'MODE_PEC_PRIMARY') {
                  $scope.mode_pec_primary = field.data;
                }
                if (field.id === 'MODE_PEC_LINKED') {
                  results1.push($scope.mode_pec_linked = field.data);
                } else {
                  results1.push(void 0);
                }
              }
              return results1;
            })());
          } else {
            results.push(void 0);
          }
        }
        return results;
      }
    });
  }]);

}).call(this);

//# sourceMappingURL=cr-hospit-struct-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:compte Rendu entree struct form
    * @descriptions
    * # CrEntryFormCtrl
    * Controller of compte Rendu entree struct form
   */
  angular.module('mhclientApp').controller('CrEntryFormCtrl', ["$scope", "$rootScope", "$filter", "$uibModal", "Message", "Feed", "Thread", "User", "UserUtils", "moment", "Prescription", "PrescUtils", "Ordonnance", "$q", function($scope, $rootScope, $filter, $uibModal, Message, Feed, Thread, User, UserUtils, moment, Prescription, PrescUtils, Ordonnance, $q) {
    var genMedicalObsText, genPSPText, genPrescText, getAntecedents, getCurrentPrescs, getMedicalObs, getPSP;
    getAntecedents = function() {
      var txt;
      txt = '';
      if ($scope.stay.medical_data.ANT) {
        txt += "<br>Antécédents : " + _.escape($scope.stay.medical_data.ANT).replace(/[\r\n]+/g, "<br/>");
      } else if ($scope.stay.medical_data.ANTECEDENTS) {
        txt += "<br>Antécédents : " + _.escape($scope.stay.medical_data.ANTECEDENTS).replace(/[\r\n]+/g, "<br/>");
      }
      if ($scope.stay.medical_data.ANTM) {
        txt += "<br>Antécédents médicaux : " + _.escape($scope.stay.medical_data.ANTM).replace(/[\r\n]+/g, "<br/>");
      }
      if ($scope.stay.medical_data.ANTC) {
        txt += "<br>Antécédents chirurgicaux : " + _.escape($scope.stay.medical_data.ANTC).replace(/[\r\n]+/g, "<br/>");
      }
      return txt;
    };
    $scope.genAntecedents = function() {
      return $scope.container.dataContent.antecedents = getAntecedents();
    };
    $scope.genHISM = function() {
      return $scope.container.dataContent.HISM = _.escape($scope.stay.medical_data.HISM).replace(/[\r\n]+/g, "<br/>") || "";
    };
    $scope.genHealthStateConclusion = function() {
      return $scope.container.dataContent.eds_conclusion = _.escape($scope.stay.medical_data.CCL_EDS).replace(/[\r\n]+/g, "<br/>") || "";
    };
    $scope.genHealthState = function() {
      return $scope.container.dataContent.healthstate = _.escape($scope.stay.medical_data.HEALTH_STATE).replace(/[\r\n]+/g, "<br/>") || "";
    };
    $scope.genAllergiesComment = function() {
      return $scope.container.dataContent.allergies_comment = _.escape($scope.stay.medical_data.allergies).replace(/[\r\n]+/g, "<br/>") || "";
    };
    getPSP = function(page) {
      if (page == null) {
        page = 1;
      }
      return Feed.api.query({
        feature__name: "MHC_PSP"
      }).$promise.then(function(feeds) {
        var feed, params;
        feed = feeds[0];
        params = {
          feed: feed.id,
          stay: $scope.stay.id,
          archived: false,
          page: page
        };
        return Thread.api.query(params).$promise.then(function(threads) {
          if ($scope.PSPs == null) {
            $scope.PSPs = [];
          }
          $scope.PSPs = _.sortBy($scope.PSPs.concat(threads.results), "first_message.timestamp").reverse();
          $scope.PSPs.forEach(function(thread) {
            if (!_.find($scope.container.dataContent.PSPs, {
              id: thread.id
            })) {
              return Message.getMessageContent(thread.first_message).promise.then(function(content) {
                var _data;
                thread.first_message.content = content.data;
                _data = {
                  id: thread.id,
                  content: genPSPText(thread),
                  timestamp: thread.first_message.timestamp
                };
                return $scope.container.dataContent.PSPs.push(_data);
              });
            }
          });
          if (threads.next != null) {
            return getPSP(page + 1);
          }
        });
      });
    };
    $scope.genPSPText = function(id) {
      var contentThread, thread;
      contentThread = _.find($scope.container.dataContent.PSPs, function(thread) {
        return thread.id === id;
      });
      thread = _.find($scope.PSPs, function(thread) {
        return thread.id === id;
      });
      if (thread) {
        if (!angular.isObject(thread.first_message.content)) {
          return Message.getMessageContent(thread.first_message).promise.then(function(content) {
            thread.first_message.content = content.data;
            return contentThread.content = genPSPText(thread);
          });
        } else {
          return contentThread.content = genPSPText(thread);
        }
      } else {
        $rootScope.busy = true;
        return Thread.api.get({
          id: id
        }).$promise.then(function(thread) {
          return Message.api.get({
            id: thread.first_message
          }).$promise.then(function(message) {
            thread.first_message = message;
            return Message.getMessageContent(thread.first_message).promise.then(function(content) {
              thread.first_message.content = content.data;
              if ($scope.PSPs == null) {
                $scope.PSPs = [];
              }
              $scope.PSPs.push(thread);
              contentThread.content = genPSPText(thread);
              return $rootScope.busy = false;
            });
          });
        });
      }
    };
    genPSPText = function(thread) {
      var category, fullText, index;
      category = $filter('translate')($filter('uppercase')(thread.first_message.category));
      fullText = "<p><strong>" + category + ":</strong> " + " - <u>";
      fullText += $filter("date")(thread.first_message.timestamp, "dd MMM yyyy") + " :</u> " + "<br/>";
      fullText += _.escape(thread.first_message.content.data.freeZone).split('\n').join('<br/>');
      fullText += '<br/>';
      index = 1;
      thread.first_message.content.data.objectives.forEach(function(objective) {
        fullText += $filter('translate')("OBJECTIVE") + index;
        fullText += ": " + _.escape(objective) + '<br/>';
        return index = index + 1;
      });
      fullText += '</p>';
      return fullText;
    };
    getMedicalObs = function(page) {
      if (page == null) {
        page = 1;
      }
      return Feed.api.query({
        feature__name: "MHC_OBSERVATION"
      }).$promise.then(function(feeds) {
        var feed, params;
        feed = feeds[0];
        params = {
          feed: feed.id,
          stay: $scope.stay.id,
          archived: false,
          page: page
        };
        return Thread.api.query(params).$promise.then(function(threads) {
          if ($scope.medicalObs == null) {
            $scope.medicalObs = [];
          }
          $scope.medicalObs = _.sortBy($scope.medicalObs.concat(threads.results), "first_message.timestamp").reverse();
          $scope.medicalObs.forEach(function(thread) {
            if (!_.find($scope.container.dataContent.medicalObs, {
              id: thread.id
            })) {
              return Message.getMessageContent(thread.first_message).promise.then(function(content) {
                var _data;
                thread.first_message.content = content.data;
                _data = {
                  id: thread.id,
                  content: genMedicalObsText(thread),
                  timestamp: thread.first_message.timestamp
                };
                return $scope.container.dataContent.medicalObs.push(_data);
              });
            }
          });
          if (threads.next != null) {
            return getMedicalObs(page + 1);
          }
        });
      });
    };
    $scope.genMedicalObsText = function(id) {
      var contentThread, thread;
      contentThread = _.find($scope.container.dataContent.medicalObs, {
        id: id
      });
      thread = _.find($scope.medicalObs, {
        id: id
      });
      if (thread) {
        if (!angular.isObject(thread.first_message.content)) {
          return Message.getMessageContent(thread.first_message).promise.then(function(content) {
            thread.first_message.content = content.data;
            return contentThread.content = genMedicalObsText(thread);
          });
        } else {
          return contentThread.content = genMedicalObsText(thread);
        }
      } else {
        $rootScope.busy = true;
        return Thread.api.get({
          id: id
        }).$promise.then(function(thread) {
          return Message.api.get({
            id: thread.first_message
          }).$promise.then(function(message) {
            thread.first_message = message;
            return Message.getMessageContent(thread.first_message).promise.then(function(content) {
              thread.first_message.content = content.data;
              if ($scope.medicalObs == null) {
                $scope.medicalObs = [];
              }
              $scope.medicalObs.push(thread);
              contentThread.content = genMedicalObsText(thread);
              return $rootScope.busy = false;
            });
          });
        });
      }
    };
    genMedicalObsText = function(medicalObs) {
      var fullText;
      fullText = "<p><u>" + $filter("date")(medicalObs.first_message.data.eventDate, "dd MMM yyyy") + " :</u> ";
      fullText += '<br/>';
      if (medicalObs.first_message.content.mode === "text") {
        fullText += _.escape(medicalObs.first_message.content.data.split('\n').join('<br/>'));
      } else {
        fullText += $filter('translate')("IMPOSSIBLE_TO_SHOW_PSP_IMAGE");
      }
      fullText += '</p>';
      return fullText;
    };
    $scope.initDoctorsRecipients = function(groupName, groupUid) {
      if (!$scope.container.dataContent.recipientDoctors || $scope.container.dataContent.recipientDoctors.length === 0) {
        return UserUtils.getUsersForPatient($scope.patient.si_id).then(function(users) {
          var _data, addressTextFull, address_data, doc, i, len, query, results;
          if (groupUid) {
            query = {
              group: {
                uid: groupUid
              }
            };
          } else {
            query = {
              group: {
                name: groupName
              }
            };
          }
          users = _.filter(users, query);
          users = _.sortBy(users, 'last_name');
          $scope.container.dataContent.recipientDoctors = [];
          results = [];
          for (i = 0, len = users.length; i < len; i++) {
            doc = users[i];
            addressTextFull = "";
            address_data = doc.user_profile.data.address_data;
            if (address_data && Object.keys(address_data).length) {
              addressTextFull += (address_data.address || '') + '\n';
              addressTextFull += (address_data.zip_code || '') + ' ';
              addressTextFull += (address_data.town || '') + '\n';
              addressTextFull += address_data.country || '';
            }
            _data = {
              id: doc.id,
              name: doc.full_name,
              manualAddress: addressTextFull
            };
            results.push($scope.container.dataContent.recipientDoctors.push(_data));
          }
          return results;
        });
      }
    };
    $scope.initDoctorsSigns = function(groupName, groupUid) {
      if (!$scope.container.dataContent.signsDoctors || $scope.container.dataContent.signsDoctors.length === 0) {
        return UserUtils.getUsersForPatient($scope.patient.si_id).then(function(users) {
          var query;
          if (groupUid) {
            query = {
              group: {
                uid: groupUid
              }
            };
          } else {
            query = {
              group: {
                name: groupName
              }
            };
          }
          users = _.filter(users, query);
          users = _.sortBy(users, 'full_name');
          _.map(users, function(user) {
            return user.first_name = user.full_name;
          });
          return $scope.container.dataContent.signsDoctors = users;
        });
      }
    };
    getCurrentPrescs = function() {
      return Prescription.query({
        stay: $scope.stay.id,
        current_prescriptions: true,
        exclude_discharge_prescs: true
      }).$promise.then(function(result) {
        $scope.prescs = _.filter(result, function(presc) {
          var ref;
          return !((ref = presc.state) === 'STOPPED' || ref === 'EXPIRED') && !presc.data.is_cropped;
        });
        return $scope.prescs.forEach(function(presc) {
          var _data;
          if (!_.find($scope.container.dataContent.prescs, {
            id: presc.id
          })) {
            _data = {
              id: presc.id,
              content: genPrescText(presc)
            };
            return $scope.container.dataContent.prescs.push(_data);
          }
        });
      });
    };
    $scope.genPrescText = function(id) {
      var contentPresc, presc;
      contentPresc = _.find($scope.container.dataContent.prescs, {
        id: id
      });
      presc = _.find($scope.prescs, {
        id: id
      });
      if (presc) {
        return contentPresc.content = genPrescText(presc);
      } else {
        $rootScope.busy = true;
        return Prescription.get({
          id: id
        }).$promise.then(function(presc) {
          if ($scope.prescs == null) {
            $scope.prescs = [];
          }
          $scope.prescs.push(presc);
          $rootScope.busy = false;
          return contentPresc.content = genPrescText(presc);
        });
      }
    };
    genPrescText = function(presc) {
      var fullText;
      fullText = '<p>' + presc.data.display_text + '</p>';
      fullText += "</p>";
      return fullText;
    };
    $scope.getStayBeginDate = function() {
      if (!$scope.container.dataContent.linked_stay_begin_date && !$scope.version.readonly) {
        $scope.container.dataContent.linked_stay_begin_date = $filter('date')($scope.stay.d_from, "dd/MM/yyyy");
      }
      return $scope.container.dataContent.linked_stay_begin_date;
    };
    $scope.getStayEndDate = function() {
      if (!$scope.container.dataContent.linked_stay_end_date && !$scope.version.readonly) {
        $scope.container.dataContent.linked_stay_end_date = $filter('date')($scope.stay.d_to, "dd/MM/yyyy");
      }
      return $scope.container.dataContent.linked_stay_end_date;
    };
    $scope.today = moment().format('DD/MM/YYYY');
    return $scope.InitDone.promise.then(function() {
      var dataContent, patientData, ref;
      dataContent = $scope.container.dataContent;
      if (dataContent.PSPs == null) {
        dataContent.PSPs = [];
        getPSP();
      }
      if (typeof patientData === "undefined" || patientData === null) {
        patientData = {};
      }
      dataContent.HISM = dataContent.HISM || _.escape($scope.stay.medical_data.HISM).replace(/[\r\n]+/g, "<br/>");
      dataContent.eds_conclusion = dataContent.eds_conclusion || _.escape($scope.stay.medical_data.CCL_EDS).replace(/[\r\n]+/g, "<br/>");
      dataContent.healthstate = dataContent.healthstate || _.escape($scope.stay.medical_data.HEALTH_STATE).replace(/[\r\n]+/g, "<br/>");
      dataContent.allergies_comment = dataContent.allergies_comment || _.escape($scope.stay.medical_data.allergies).replace(/[\r\n]+/g, "<br/>");
      if (!$scope.version.readonly) {
        $scope.getStayBeginDate();
        $scope.getStayEndDate();
      }
      if ($scope.formName && ((ref = $scope.formName) === 'cr_entry' || ref === 'courrier_type')) {
        dataContent.MOTH = dataContent.MOTH || $scope.stay.medical_data.MOTH || $scope.stay.medical_data.MOTIF_ADMISSION;
        if (dataContent.medicalObs == null) {
          dataContent.medicalObs = [];
          getMedicalObs();
        }
        if (dataContent.prescs == null) {
          dataContent.prescs = [];
          getCurrentPrescs();
        }
        return dataContent.antecedents = dataContent.antecedents || getAntecedents();
      }
    });
  }]);

}).call(this);

//# sourceMappingURL=cr-entry-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:intervention diététique struct form
    * @descriptions
    * # DietInterController
    * Controller of intervention diététique struct form
   */
  angular.module('mhclientApp').controller('DietInterController', ["$scope", "UserUtils", "SiteVarsUtils", function($scope, UserUtils, SiteVarsUtils) {
    var init;
    init = function() {
      UserUtils.getUsers().then(function(users) {
        var query;
        query = {
          group: {
            short_name: "DIET"
          },
          is_active: true
        };
        _.map(users, function(user) {
          return user.first_name = user.full_name;
        });
        return $scope.dieteticians = _.filter(users, query);
      });
      SiteVarsUtils.get("COORDINATES", null, $scope.stay.entity).then(function(coordinates) {
        coordinates.value = _.split(coordinates.value, '|', '3');
        return $scope.coordinates = coordinates.value.join('\n');
      });
      return SiteVarsUtils.get("PHONE_NUMBER", null, $scope.stay.entity).then(function(phoneNumber) {
        return $scope.phoneNumber = phoneNumber;
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=diet-intervention-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CrNurseController
    * @descriptions
    * # CrNurseController
    * Controller of nurse cr form
   */
  angular.module('mhclientApp').controller('CrNurseController', ["$scope", "UserUtils", "SiteVarsUtils", function($scope, UserUtils, SiteVarsUtils) {
    var init;
    init = function() {
      UserUtils.getUsersForPatient($scope.patient_detail.si_id).then(function(users) {
        var queryIde_crds, queryIdecs, queryIdels;
        queryIdels = {
          group: {
            short_name: "IDEL"
          }
        };
        queryIdecs = {
          group: {
            short_name: "IDEC"
          }
        };
        queryIde_crds = {
          group: {
            short_name: "IDE_CRD"
          }
        };
        $scope.idels = _.filter(users, queryIdels);
        return $scope.idecs = _.concat(_.filter(users, queryIdecs), _.filter(users, queryIde_crds));
      });
      return SiteVarsUtils.get("COORDINATES", null, $scope.stay.entity).then(function(coordinates) {
        coordinates.value = _.split(coordinates.value, '|', '3');
        return $scope.coordinates = coordinates.value.join('\n');
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=cr-nurse-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:Projet therapeutique form
    * @descriptions
    * # PjTheraController
    * Controller of projet therapeutique form
   */
  angular.module('mhclientApp').controller('ProjetTherapeutiqueController', ["$scope", "UserUtils", "SiteVarsUtils", function($scope, UserUtils, SiteVarsUtils) {
    var computeDoctorData, filterUsers, init;
    init = function() {
      return UserUtils.getUsersForPatient($scope.patient_detail.si_id).then(function(users) {
        $scope.users = users;
        $scope.doctorList = filterUsers(users, "médecin");
        return $scope.treatingDoctorList = filterUsers(users, "médecin traitant");
      });
    };
    init();
    filterUsers = function(list, str) {
      return _.chain(list).filter(function(user) {
        return user.is_active;
      }).filter(function(user) {
        return user.group.name.toLowerCase().indexOf(str) >= 0;
      }).map(function(user) {
        return {
          'id': user.id,
          'full_name': user.full_name
        };
      }).value();
    };
    $scope.presDoctorChange = function(doctorId) {
      var infos, selectedDoctor;
      selectedDoctor = _.find($scope.users, function(user) {
        return user.id === $scope.container.dataContent.prescripteur_doctor_id;
      });
      infos = computeDoctorData(selectedDoctor);
      $scope.container.dataContent.prescripteur_doctor_name = infos.name;
      $scope.container.dataContent.prescripteur_doctor_address = infos.address;
      $scope.container.dataContent.prescripteur_doctor_zip_code = infos.zip_code;
      $scope.container.dataContent.prescripteur_doctor_town = infos.town;
      $scope.container.dataContent.prescripteur_doctor_fax = infos.fax;
      return $scope.container.dataContent.prescripteur_doctor_mail = infos.mail;
    };
    $scope.treatingDoctorChange = function(doctorId) {
      var infos, selectedDoctor;
      selectedDoctor = _.find($scope.users, function(user) {
        return user.id === $scope.container.dataContent.treating_doctor_id;
      });
      infos = computeDoctorData(selectedDoctor);
      $scope.container.dataContent.treating_doctor_name = infos.name;
      $scope.container.dataContent.treating_doctor_address = infos.address;
      $scope.container.dataContent.treating_doctor_zip_code = infos.zip_code;
      $scope.container.dataContent.treating_doctor_town = infos.town;
      $scope.container.dataContent.treating_doctor_fax = infos.fax;
      return $scope.container.dataContent.treating_doctor_mail = infos.mail;
    };
    return computeDoctorData = function(selectedDoctor) {
      var infos;
      infos = {
        "address": "",
        "zip_code": "",
        "town": "",
        "fax": "",
        "mail": ""
      };
      if (selectedDoctor) {
        infos.name = selectedDoctor.full_name;
        if (selectedDoctor.user_profile && selectedDoctor.user_profile.data) {
          if (selectedDoctor.user_profile.data.address_data) {
            infos.address = selectedDoctor.user_profile.data.address_data.address;
            infos.zip_code = selectedDoctor.user_profile.data.address_data.zip_code;
            infos.town = selectedDoctor.user_profile.data.address_data.town;
          }
          infos.fax = selectedDoctor.user_profile.data.fax_number;
        }
        infos.mail = selectedDoctor.email;
      }
      return infos;
    };
  }]);

}).call(this);

//# sourceMappingURL=projet-therapeutique-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:staff form
    * @descriptions
    * # StaffFormController
    * Controller of staff form
   */
  angular.module('mhclientApp').controller('StaffFormController', ["$scope", "$rootScope", "UserUtils", "Group", "$q", function($scope, $rootScope, UserUtils, Group, $q) {
    var init;
    init = function() {
      var promises;
      promises = [];
      $scope.patientUsers = {};
      $scope.utils = $rootScope.utils;
      return Group.query({}).$promise.then(function(liberal_groups) {
        var custom_fields, field, groups, i, len, ref, results;
        groups = liberal_groups;
        UserUtils.getUsersForPatient($scope.patient_detail.si_id).then(function(users) {
          var group, i, len, results, users_group;
          results = [];
          for (i = 0, len = groups.length; i < len; i++) {
            group = groups[i];
            users_group = _.filter(users, {
              group: {
                uid: group.uid
              }
            });
            if (users_group.length > 0) {
              $scope.patientUsers[group.name] = users_group;
            }
            $scope.choosableGroups = Object.keys($scope.patientUsers);
            results.push($scope.selectedGroup = $scope.choosableGroups[0]);
          }
          return results;
        });
        ref = $rootScope.custom_fields_detail_values;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          custom_fields = ref[i];
          if (custom_fields.id === "MEDICAL_DATA") {
            results.push((function() {
              var j, len1, ref1, results1;
              ref1 = custom_fields.fields;
              results1 = [];
              for (j = 0, len1 = ref1.length; j < len1; j++) {
                field = ref1[j];
                if (field.id === 'MODE_PEC_PRIMARY') {
                  $scope.mode_pec_primary = field.data;
                }
                if (field.id === 'MODE_PEC_LINKED') {
                  results1.push($scope.mode_pec_linked = field.data);
                } else {
                  results1.push(void 0);
                }
              }
              return results1;
            })());
          } else {
            results.push(void 0);
          }
        }
        return results;
      });
    };
    $scope.addUser = function(users) {
      $scope.selectedUser.selected = true;
      $scope.selectedUser.group = $scope.selectedGroup;
      return users.push($scope.selectedUser);
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=staff-form-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.medforms:medformsSelectStayWidgetCtrl
    * @description
    * # medformsSelectStayWidgetCtrl
    * controller for selection of active stay for form duplication
   */
  angular.module("mhclientApp").controller('medformsSelectStayWidgetCtrl', ["$scope", "$q", "$rootScope", "$uibModalInstance", "Stay", "patient", "template", "warningMessage", "FormGroup", function($scope, $q, $rootScope, $uibModalInstance, Stay, patient, template, warningMessage, FormGroup) {
    $rootScope.busy = true;
    $scope.warningMessage = warningMessage;
    Stay.query({
      patient: patient.id
    }).$promise.then(function(stays) {
      return $q.when(template.group ? FormGroup.get({
        id: template.group
      }).$promise : null).then(function(formGroup) {
        $scope.stays = _.filter(stays, function(stay) {
          var ref;
          return (ref = stay.state) === "PRE" || ref === "ADM";
        });
        $scope.preadTemplate = formGroup && _.includes(["PRÉADMISSION", "PREADMISSION"], formGroup.name.toUpperCase());
        return $rootScope.busy = false;
      });
    });
    $scope.selectStay = function(stay) {
      return Stay.get({
        id: stay.id
      }).$promise.then(function(selectedStay) {
        if ($scope.preadTemplate && selectedStay.preadmission && selectedStay.preadmission.lock_pread_data) {
          return $scope.hasWarning = true;
        } else {
          $scope.hasWarning = false;
          return $uibModalInstance.close(stay);
        }
      });
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=medforms-select-stay-widget-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.medforms:draw
    * @description
    * # Draw
    * Directive for drawing medical form
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').directive('medformImage', ["$timeout", function($timeout) {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'medforms/views/medforms-image-directive.html';
        }
      },
      scope: {
        patient: '=',
        stay: '=',
        version: '='
      },
      controller: ["$scope", "$attrs", "$q", "$rootScope", "$timeout", "$localStorage", "$http", "SiteVarsUtils", function($scope, $attrs, $q, $rootScope, $timeout, $localStorage, $http, SiteVarsUtils) {
        var address_data, dataLoaded, default_action, default_color, init, loadContainerData, mhcFormsFeature, patAddressTextFull, ref, ref1, ref2, ref3;
        $scope.availableColors = ['black', 'blue', 'red', 'green'];
        dataLoaded = $q.defer();
        $scope.zoomMax = 2;
        $scope.zoomMin = 0.6;
        $scope.mh_config = $rootScope.mh_config;
        $scope.patient_detail = angular.copy($scope.patient);
        $scope.patient_detail.linked_stay = angular.copy($scope.stay);
        $scope.patient_detail.si_id = $scope.patient_detail.linked_stay.si_id;
        $scope.patient_detail.ipp = $scope.patient_detail.linked_stay.si_id;
        $scope.mh_config = $rootScope.mh_config;
        $scope.utils = $rootScope.utils;
        patAddressTextFull = "";
        address_data = $scope.patient_detail.address_data;
        if (address_data && Object.keys(address_data).length) {
          patAddressTextFull += address_data.address + '\n';
          patAddressTextFull += address_data.zip_code + ' ';
          patAddressTextFull += address_data.town + '\n';
          patAddressTextFull += address_data.country;
        }
        $scope.patient_detail.fullAdress = patAddressTextFull;
        if (((ref = $localStorage['mhclient']) != null ? (ref1 = ref[$scope.patient.id]) != null ? (ref2 = ref1['fmc_mhclient']) != null ? ref2['last_used_tool'] : void 0 : void 0 : void 0) == null) {
          $localStorage['mhclient'] = {};
          $localStorage['mhclient'][$scope.patient.id] = {
            fmc_mhclient: {
              last_used_tool: {}
            }
          };
          default_color = 'black';
          if ($rootScope.mh_config.platform === 'mhsi') {
            default_action = 'text';
          } else {
            default_action = 'draw';
          }
          mhcFormsFeature = _.find($rootScope.user.userFeatures, {
            "name": "MHC_FORMS"
          });
          if (mhcFormsFeature != null) {
            if ((ref3 = mhcFormsFeature.pen_color) === "black" || ref3 === "blue" || ref3 === "red" || ref3 === "green") {
              default_color = mhcFormsFeature.pen_color;
            }
          }
        } else {
          default_action = $localStorage['mhclient'][$scope.patient.id]['fmc_mhclient']['last_used_tool']['tool'];
          default_color = $localStorage['mhclient'][$scope.patient.id]['fmc_mhclient']['last_used_tool']['color'];
        }
        $scope.drawElement = {
          'dataLoaded': dataLoaded,
          'config': {
            'readonly': false,
            'action': default_action,
            'penColor': default_color,
            'lineWidth': 2,
            'smooth': true,
            'tolerance': 1.00,
            'width': 1000,
            'height': 1000,
            'withNotes': true,
            'coefficientForZoom': 1
          }
        };
        $scope.$watch('version', function(newVersion, oldVersion) {
          if (newVersion !== oldVersion) {
            return init();
          }
        });
        loadContainerData = function(container) {
          var initDataPromise;
          container.config = angular.copy($scope.drawElement.config);
          container.action = default_action;
          container.coefficientForZoom = container.config.coefficientForZoom;
          container.penColor = default_color;
          container.lineWidth = 2;
          container.smooth = true;
          container.tolerance = 1.00;
          container.withNotes = true;
          container.dataLoaded = $q.defer();
          if (angular.isUndefined(container.newDataContent)) {
            container.newDataContent = [];
          }
          initDataPromise = $q.defer();
          if (container.dataContent == null) {
            if (container.dataUrl != null) {
              $http.get(container.dataUrl).then(function(result) {
                container.dataContent = result.data;
                return initDataPromise.resolve();
              });
            } else {
              container.dataContent = [];
              initDataPromise.resolve();
            }
          } else {
            initDataPromise.resolve();
          }
          initDataPromise.promise.then(function() {
            var img;
            img = new Image();
            img.src = container.background || container.backgroundContent;
            return img.onload = function() {
              var imgPromise;
              container.config.width = img.width;
              container.config.height = img.height;
              container.config.path = container.background || container.backgroundContent;
              imgPromise = $q.defer();
              return container.dataLoaded.resolve();
            };
          });
          return container.dataLoaded.promise;
        };

        /* INITIALISATION */
        init = function() {
          var promises;
          $scope.initDone = false;
          promises = [];
          $scope.version.containers.forEach(function(container, index) {
            if (container.background || container.backgroundContent) {
              return promises.push(loadContainerData(container));
            }
          });
          return $q.all(promises).then(function() {
            $scope.drawElement.config.width = $scope.version.containers[0].config.width;
            $scope.drawElement.config.height = $scope.version.containers[0].config.height;
            return SiteVarsUtils.get("LABEL_TITLE", null, $scope.stay.entity).then(function(label) {
              $scope.labelTitle = label;
              return $scope.initDone = true;
            });
          });
        };
        $scope.zoomIn = function() {
          if (parseFloat($scope.drawElement.config.coefficientForZoom, $scope.zoomMax) * 1.1 <= $scope.zoomMax) {
            return $scope.drawElement.config.coefficientForZoom = parseFloat($scope.drawElement.config.coefficientForZoom) * 1.1;
          }
        };
        $scope.zoomOut = function() {
          if (parseFloat($scope.drawElement.config.coefficientForZoom) / 1.1 >= $scope.zoomMin) {
            return $scope.drawElement.config.coefficientForZoom = parseFloat($scope.drawElement.config.coefficientForZoom) / 1.1;
          }
        };
        $scope.toggleColor = function(color) {
          $scope.drawElement.config.penColor = color;
          if ($scope.drawElement.config.action === 'erase') {
            $scope.drawElement.config.action = 'draw';
          }
          return true;
        };
        $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
          if (fromState === toState) {
            if ($localStorage['mhclient'][$scope.patient.id]['fmc_mhclient']['last_used_tool'] == null) {
              $localStorage['mhclient'][$scope.patient.id]['fmc_mhclient']['last_used_tool'] = {};
            }
            $localStorage['mhclient'][$scope.patient.id]['fmc_mhclient']['last_used_tool']['tool'] = $scope.drawElement.config.action;
            return $localStorage['mhclient'][$scope.patient.id]['fmc_mhclient']['last_used_tool']['color'] = $scope.drawElement.config.penColor;
          }
        });
        return init();
      }]
    };
  }]);

  angular.module('mhclientApp').directive('medformStruct', ["$timeout", function($timeout) {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'medforms/views/medform-struct-directive.html';
        }
      },
      scope: {
        version: '=',
        template: '=',
        patient: '=',
        stay: '='
      },
      controller: ["$scope", "$rootScope", "$http", "$q", "$attrs", "$timeout", "$filter", "$state", "SiteVarsUtils", "MedFormsUtils", "UserUtils", "TemplateVersion", function($scope, $rootScope, $http, $q, $attrs, $timeout, $filter, $state, SiteVarsUtils, MedFormsUtils, UserUtils, TemplateVersion) {
        var address_data, custom_fields, field, i, j, len, len1, patAddressTextFull, patAddressWithName, patientTitle, ref, ref1;
        $scope.result = 0;
        $scope.ignoreKeys = [];
        $scope.Math = window.Math;
        $scope.mh_config = $rootScope.mh_config;
        $scope.patient_detail = angular.copy($scope.patient);
        $scope.patient_detail.linked_stay = angular.copy($scope.stay);
        $scope.patient_detail.data["medical_data"] = $scope.patient_detail.linked_stay["medical_data"];
        $scope.user = $rootScope.user;
        patAddressTextFull = "";
        address_data = $scope.patient_detail.address_data;
        if (address_data && Object.keys(address_data).length) {
          patAddressTextFull += address_data.address + '\n';
          patAddressTextFull += address_data.zip_code + ' ';
          patAddressTextFull += address_data.town + '\n';
          patAddressTextFull += address_data.country;
        }
        $scope.patient_detail.fullAdress = patAddressTextFull;
        patientTitle = '';
        if ($scope.patient_detail.gender === 'M') {
          patientTitle = 'M ';
        } else if ($scope.patient_detail.gender === 'F') {
          patientTitle = 'Mme ';
        }
        patAddressWithName = "";
        if (patAddressTextFull) {
          patAddressWithName += patientTitle + $scope.patient_detail.last_name + " " + $scope.patient_detail.name + '\n';
          patAddressWithName += patAddressTextFull;
        }
        $scope.patient_detail.fullAdressWithName = patAddressWithName;
        $scope.ik_range = _.range(0, 110, 10);
        $scope.avq_range = _.range(6, 25);
        $scope.today = new Date();
        $scope.InitDone = $q.defer();
        $scope.InitDone.resolve();
        ref = $rootScope.custom_fields_detail_values;
        for (i = 0, len = ref.length; i < len; i++) {
          custom_fields = ref[i];
          if (custom_fields.id === "MEDICAL_DATA") {
            ref1 = custom_fields.fields;
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              field = ref1[j];
              if (field.id === 'MODE_PEC_PRIMARY') {
                $scope.mode_pec_primary = field.data;
              }
              if (field.id === 'MODE_PEC_LINKED') {
                $scope.mode_pec_linked = field.data;
              }
            }
          }
        }
        $scope.patient_detail.entity = {
          sitevars: {}
        };
        _.forEach(['COORDINATES', 'PHONE_NUMBER', 'FAX_NUMBER', 'EMAIL', 'WEBSITE', 'TOWN', 'LABEL_TITLE'], function(sitevarName) {
          return SiteVarsUtils.get(sitevarName, null, $scope.stay.entity, false, $scope.stay.sector).then(function(siteVar) {
            return $scope.patient_detail.entity.sitevars[sitevarName] = siteVar.value;
          });
        });
        $scope.fetchContainer = function(container) {
          return SiteVarsUtils.get("logo", null, $scope.stay.entity).then(function(sitevar) {
            return MedFormsUtils.getStaticData($scope.patient, $scope.stay).then(function(customScope) {
              $scope.customScope = customScope;
              $scope.custommer_logo = sitevar.value;
              return MedFormsUtils.fetchContainer(container);
            });
          });
        };
        $scope.$on('$drawDataDirty', function(event) {
          return $scope.version.formStruct.$setDirty();
        });
        $scope.setForm = function(form, container) {
          if ($scope.version.formStruct && $scope.version.formStruct.$dirty) {
            form.$setDirty();
          }
          return $scope.version.formStruct = form;
        };
        if ($scope.template.current) {
          TemplateVersion.get({
            id: $scope.template.current
          }).$promise.then(function(current) {
            var computeSubtotals;
            if (current.data.compute_subtotals === true) {
              computeSubtotals = function(obj) {
                var result;
                if (obj != null) {
                  result = 0;
                  _.forIn(obj, (function(value, key) {
                    if (typeof value === "object") {
                      result = parseFloat(result) + computeSubtotals(value);
                    }
                    if (key[0] !== "_" && !isNaN(parseFloat(value)) && !(indexOf.call($scope.ignoreKeys, key) >= 0)) {
                      return result = parseFloat(result) + parseFloat(value);
                    }
                  }));
                  obj._total = result;
                  return result;
                }
              };
              return $scope.$watch('version.containers', (function(containers) {
                return containers.forEach(function(container) {
                  return computeSubtotals(container.dataContent);
                });
              }), true);
            }
          });
        }
        $scope.getResult = function(container) {
          var result;
          if (container.dataContent != null) {
            result = 0;
            _.forIn(container.dataContent, (function(value, key) {
              if (key[0] !== "_" && !isNaN(parseFloat(value))) {
                return result = parseFloat(result) + parseFloat(value);
              }
            }));
            $scope.result = result;
            return $scope.result;
          }
        };
        $scope.isFormFilled = function() {
          return $scope.version.formStruct && $scope.version.formStruct.$valid;
        };
        return $scope.selectUser = function(container) {
          return UserUtils.selectUserModal(null, null, null, true).result.then(function(selectedUser) {
            if (selectedUser) {
              container.dataContent.user_name = selectedUser.full_name;
              return container.dataContent.group_name = selectedUser.group.name;
            }
          });
        };
      }],
      link: function(scope, element, attrs, $http, $q) {
        scope.$watch('version', (function(newValue, oldValue) {
          return _.forEach(scope.version.containers, function(container) {
            return scope.fetchContainer(container);
          });
        }));
        return scope.$on('$destroy', function() {
          if (scope.version.formStruct) {
            return scope.version.formStruct.customInvalid = scope.version.formStruct.$invalid;
          }
        });
      }
    };
  }]);

  angular.module('mhclientApp').directive('medformVersion', ["$timeout", function($timeout) {
    return {
      compile: function(element, attrs) {
        if (attrs.options == null) {
          attrs.options = "{}";
        }
        if (attrs.isDirty == null) {
          attrs.isDirty = "false";
        }
        if (attrs.isInvalid == null) {
          return attrs.isInvalid = "false";
        }
      },
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'medforms/views/medforms-version-directive.html';
        }
      },
      scope: {
        patient: '=',
        stay: '=',
        allStays: "=",
        template: "=",
        versionId: "=",
        createNewForm: "=",
        previousStateName: "=",
        closeCallBack: '&',
        isDirty: "=",
        isInvalid: "=",
        options: "="
      },
      controller: ["$scope", "$attrs", "$rootScope", "$timeout", "$filter", "FormSubVersion", "FormVersion", "FormGroup", "MedFormsUtils", "$q", "$state", "$uibModal", "TemplateVersion", "FormTemplateUtils", "SiteVarsUtils", "$localStorage", "notify", function($scope, $attrs, $rootScope, $timeout, $filter, FormSubVersion, FormVersion, FormGroup, MedFormsUtils, $q, $state, $uibModal, TemplateVersion, FormTemplateUtils, SiteVarsUtils, $localStorage, notify) {
        var confirmExitDialog, genNewVersion, saveVersion, selectStayModal, setPristine;
        selectStayModal = function(patient) {
          return $uibModal.open({
            animation: true,
            templateUrl: 'core/views/select-stay-widget-modal.html',
            size: "lg",
            controller: 'medformsSelectStayWidgetCtrl',
            resolve: {
              patient: function() {
                return patient;
              },
              template: function() {
                return $scope.template;
              },
              warningMessage: function() {
                return $filter('translate')("SELECTION_NOT_ALLOWED");
              }
            }
          });
        };
        $scope.needValidation = function(version) {
          var ref;
          return ((ref = version.current) != null ? ref.state : void 0) === "NEW";
        };
        $scope.hasNewVersion = function() {
          return _.find($scope.versions, function(version) {
            return !version.id;
          });
        };
        MedFormsUtils.getGroupsConfig({
          group: $rootScope.user.group.id,
          template: $scope.template.id
        }).then(function(config) {
          return $q.when($scope.template.group ? FormGroup.get({
            id: $scope.template.group
          }).$promise : null).then(function(formGroup) {
            var params, ref;
            $scope.template.config = config;
            $scope.preadLocked = formGroup && _.includes(["PRÉADMISSION", "PREADMISSION"], formGroup.name.toUpperCase()) && $scope.stay.preadmission.lock_pread_data;
            $scope.canCreateVersion = !$scope.preadLocked && config.can_write;
            $scope.isActiveStay = (ref = $scope.stay.state) === 'PRE' || ref === 'ADM';
            params = _.merge({
              template: $scope.template.id
            }, $scope.allStays ? {
              patient: $scope.patient.id
            } : {
              stay: $scope.stay.id
            });
            return FormVersion.query(params).$promise.then(function(versions) {
              return FormSubVersion.query(params).$promise.then(function(subVersions) {
                var i, len, ref1, version;
                $scope.versions = $filter('orderBy')(versions, "-last_edit_timestamp");
                if ($scope.versions.length > 0) {
                  if ($scope.versionId) {
                    $scope.currentVersion = _.find($scope.versions, {
                      id: parseInt($scope.versionId)
                    }) || $scope.versions[0];
                  } else {
                    $scope.currentVersion = $scope.versions[0];
                  }
                }
                ref1 = $scope.versions;
                for (i = 0, len = ref1.length; i < len; i++) {
                  version = ref1[i];
                  version.current = _.find(subVersions, {
                    id: version.current
                  });
                  version.hasSubversionConflict = version.uid && version.uid.indexOf('sv_conflict') > -1;
                  version.readonly = $scope.versions[0].id !== version.id || !config.can_write || $scope.preadLocked;
                  if (!version.readonly && $scope.template.lock_after_hours && $scope.template.lock_after_hours > 0) {
                    if (moment.utc().isAfter(moment.utc(version.last_edit_timestamp).add($scope.template.lock_after_hours, "hours"))) {
                      version.readonly = true;
                    }
                  }
                }
                $scope.$watch(function() {
                  $scope.hasVersionToValidate = $scope.template.need_validation && $scope.template.config.can_validate && _.some($scope.versions, $scope.needValidation);
                  $scope.isDirty = $scope.hasDirtyVersions();
                  $scope.disableSave = !($scope.isDirty || $scope.hasVersionToValidate);
                  return $scope.isInvalid = !$scope.canSave();
                });
                if (($scope.versions.length === 0 || $scope.createNewForm) && $scope.canCreateVersion) {
                  return $scope.createNewVersion($scope.template);
                }
              });
            });
          });
        });
        genNewVersion = function(templateId, tv, stayId) {
          return {
            state: "NEW",
            template_version: tv.id,
            template: templateId,
            stay: stayId,
            containers: tv.meta.containers,
            type_form: tv.type_form,
            readonly: false,
            author: $rootScope.user
          };
        };
        $scope.createNewVersion = function(template) {
          $rootScope.busy = true;
          return TemplateVersion.get({
            id: template.current
          }).$promise.then(function(templateVersion) {
            var newVersion, previousVersionId;
            newVersion = genNewVersion(template.id, templateVersion, $scope.stay.id);
            previousVersionId = $scope.versions.length >= 1 ? $scope.versions[0].id : null;
            return $q.when(MedFormsUtils.initVersion(newVersion, template, templateVersion, $scope.patient, $scope.stay, previousVersionId)).then(function() {
              $rootScope.busy = false;
              $scope.versions.unshift(newVersion);
              return $scope.currentVersion = newVersion;
            });
          });
        };
        $scope.copyInActiveStay = function(template) {
          return selectStayModal($scope.patient).result.then(function(stay) {
            if (stay) {
              return TemplateVersion.get({
                id: $scope.currentVersion.template_version
              }).$promise.then(function(templateVersion) {
                var container, data, dataArray, i, j, k, len, len1, len2, newVersion, ref, ref1;
                newVersion = genNewVersion(template.id, templateVersion, stay.id);
                newVersion.containers = _.cloneDeep($scope.currentVersion.containers);
                if (newVersion.type_form === 'IMG') {
                  ref = newVersion.containers;
                  for (i = 0, len = ref.length; i < len; i++) {
                    container = ref[i];
                    container["newDataContent"] = [];
                    ref1 = container["dataContent"];
                    for (j = 0, len1 = ref1.length; j < len1; j++) {
                      dataArray = ref1[j];
                      for (k = 0, len2 = dataArray.length; k < len2; k++) {
                        data = dataArray[k];
                        container["newDataContent"].push(data);
                      }
                    }
                    container["dataContent"] = [];
                  }
                }
                return saveVersion(newVersion).promise.then(function() {
                  return notify({
                    classes: ['alert-info'],
                    message: $filter('translate')("FORM_SAVE")
                  });
                });
              });
            }
          });
        };
        $scope.loadVersion = function(version) {
          $scope.currentVersion = null;
          return $timeout(function() {
            return $scope.currentVersion = version;
          });
        };
        $scope.genSubversion = function(version) {
          var ref, state;
          state = $scope.template.need_validation && $scope.template.config.can_validate ? "VALIDATED" : "NEW";
          _.forEach(version.containers, function(container) {
            if (!container.dataContent) {
              return container.dataContent = version.type_form === 'IMG' ? [] : {};
            }
          });
          return {
            timestamp: new Date().toISOString(),
            state: state,
            form_version: version.id,
            parent: (ref = version.current) != null ? ref.id : void 0,
            patient: version.patient,
            data: version.containers
          };
        };
        $scope.isVersionDirty = function(version, ignoreNew) {
          version.dirty = $scope.canCreateVersion && (!ignoreNew && !version.id) || ((version.formStruct && version.formStruct.$dirty) || _.some(version.containers, function(container) {
            return (container.newDataContent || []).length > 0;
          }));
          return version.dirty;
        };
        $scope.hasDirtyVersions = function(ignoreNew) {
          return _.some($scope.versions, function(version) {
            return $scope.isVersionDirty(version, ignoreNew);
          });
        };
        $scope.canSave = function() {
          return !_.some($scope.versions, function(version) {
            return version.formStruct && (!version.formStruct.$valid || version.formStruct.customInvalid);
          });
        };
        setPristine = function(version, handleReload) {
          var container, i, len, ref, results;
          version.dirty = false;
          if (version.formStruct) {
            if (version === $scope.currentVersion) {
              return version.formStruct.$setPristine();
            } else {
              return version.formStruct = null;
            }
          } else {
            ref = version.containers;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              container = ref[i];
              if (container.newDataContent) {
                container.dataContent.push(container.newDataContent);
                container.newDataContent = [];
                if (handleReload && version === $scope.currentVersion) {
                  results.push(container.needReload = true);
                } else {
                  results.push(void 0);
                }
              } else {
                results.push(void 0);
              }
            }
            return results;
          }
        };
        saveVersion = function(version) {
          var elem, element, export_html, i, j, len, len1, ref, ref1, subVersionPromise, versionPromise;
          version.last_edit_timestamp = new Date().toISOString();
          subVersionPromise = $q.defer();
          versionPromise = $q.defer();
          if (version.containers[0].dynamic_form == null) {
            element = angular.element("#medform-struct-container").clone();
            ref = element.find('input');
            for (i = 0, len = ref.length; i < len; i++) {
              elem = ref[i];
              if (elem.type === "radio") {
                if (elem.checked) {
                  angular.element(elem).attr("checked", "checked");
                }
              } else if (elem.type === "checkbox") {
                if (elem.checked) {
                  angular.element(elem).attr("checked", "checked");
                }
              } else {
                if (indexOf.call(elem, 'value') >= 0) {
                  elem.value = elem.value;
                } else if (indexOf.call(elem, 'innerText') >= 0) {
                  elem.innerText = elem.value;
                }
                angular.element(elem).attr("value", elem.value);
              }
            }
            ref1 = element.find('textarea');
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              elem = ref1[j];
              elem.innerText = elem.value;
            }
            export_html = element.html();
            if (export_html) {
              export_html = "<!DOCTYPE html>" + export_html.replace(/<!--[\s\S]*?-->/g, "");
            }
          }
          if (!version.id) {
            version.timestamp = new Date().toISOString();
            FormVersion.save(version).$promise.then(function(new_version) {
              version.id = new_version.id;
              version.modified = version.timestamp;
              if (export_html != null) {
                return FormVersion.save_export_html({
                  id: version.id,
                  template_version: version.template_version,
                  version: version,
                  export_html: export_html
                }).$promise.then(function() {
                  return versionPromise.resolve();
                });
              } else {
                return versionPromise.resolve();
              }
            });
          } else {
            if (export_html != null) {
              FormVersion.save_export_html({
                id: version.id,
                template_version: version.template_version,
                version: version,
                export_html: export_html
              }).$promise.then(function() {
                return versionPromise.resolve();
              });
            } else {
              versionPromise.resolve();
            }
          }
          versionPromise.promise.then(function() {
            return FormSubVersion.save($scope.genSubversion(version)).$promise.then(function(subversion) {
              version.current = subversion;
              version.author = $rootScope.user;
              setPristine(version, true);
              return subVersionPromise.resolve();
            });
          });
          return subVersionPromise;
        };
        $scope.saveAll = function() {
          $rootScope.busy = true;
          return $q.when($q.all(_.map(_.filter($scope.versions, function(version) {
            return $scope.isVersionDirty(version) || ($scope.template.need_validation && $scope.template.config.can_validate && $scope.needValidation(version));
          }), function(version) {
            return saveVersion(version).promise;
          })).then(function() {
            return $rootScope.busy = false;
          }));
        };
        confirmExitDialog = function() {
          var canSave;
          canSave = $scope.canSave();
          return $uibModal.open({
            animation: true,
            templateUrl: 'core/views/modal-template.html',
            size: "lg",
            controller: 'mhModalCtrl',
            resolve: {
              title: function() {
                return $filter('translate')("DOC_NOT_SAVED");
              },
              text: function() {
                if (canSave) {
                  return $filter('translate')("CONFIRM_CLOSE_NOT_SAVED");
                } else {
                  return $filter('translate')("CONFIRM_CLOSE_NOT_VALID");
                }
              },
              cancelButtonText: function() {
                return $filter('translate')("CANCEL_BUTTON");
              },
              noButtonText: function() {
                return $filter('translate')("DONT_SAVE_BUTTON");
              },
              okButtonText: function() {
                var okButtonText;
                if (canSave) {
                  return $filter('translate')("SAVE_BUTTON");
                } else {
                  return okButtonText = null;
                }
              }
            }
          });
        };
        $scope.print = function() {
          window.open("/api_rest/formversions/" + $scope.currentVersion.id + "/export_pdf", '_blank');
        };
        $scope.handleStateChangePromise = function() {
          var stateChangePromise;
          $rootScope.busy = true;
          stateChangePromise = $q.defer();
          confirmExitDialog().result.then((function(toSave) {
            $rootScope.busy = false;
            if (toSave) {
              return $scope.saveAll().then(function() {
                return stateChangePromise.resolve(true);
              });
            } else {
              return stateChangePromise.resolve(_.forEach($scope.versions, function(version) {
                return setPristine(version);
              }));
            }
          }), (function(e) {
            $rootScope.busy = false;
            return stateChangePromise.reject();
          }));
          return stateChangePromise.promise;
        };
        $scope.$on('$toggleShowAllStays', function(event) {
          if ($scope.hasDirtyVersions(true)) {
            if (!event.togglePromises) {
              event.togglePromises = [];
            }
            return event.togglePromises.push($scope.handleStateChangePromise());
          }
        });
        $scope.$on('validateRequest', function(event) {
          if (!event.validatePromises) {
            event.validatePromises = [];
          }
          return event.validatePromises.push($scope.saveAll());
        });
        $scope.$on('closeRequested', function(event) {
          if ($scope.hasDirtyVersions(true)) {
            if (!event.closePromises) {
              event.closePromises = [];
            }
            return event.closePromises.push($scope.handleStateChangePromise());
          }
        });
        return $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
          if (event.defaultPrevented) {
            return;
          }
          if ($scope.hasDirtyVersions(true)) {
            event.preventDefault();
            return $scope.handleStateChangePromise().then(function() {
              return $state.go(toState.name, toParams);
            });
          }
        });
      }]
    };
  }]);

}).call(this);

//# sourceMappingURL=medforms-version-directive.js.map

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:patientInfosHeader
* @description
* Modal component which displays patient infos header of a document
* **********************************************/

angular.module("mhclientApp").component("patientInfosHeader", {
    templateUrl: "medforms/components/patient-infos-header/patient-infos-header.html",
    controller: ["Entity", "SiteVarsUtils", function patientInfosHeaderController(Entity, SiteVarsUtils) {
      var ctrl = this;
      ctrl.entity = {sitevars : {}}
      _.forEach(["COORDINATES", "PHONE_NUMBER", "FAX_NUMBER", "EMAIL", "WEBSITE", "LABEL_TITLE"], function(sitevarName) {
        SiteVarsUtils.get(sitevarName, null, ctrl.stay.entity, false, ctrl.stay.sector).then(function(sitevar){
          ctrl.entity.sitevars[sitevarName] = sitevar.value
        })
      })
    }],
    bindings: { patient: "<", siret: "=", stay: "<", allData: "<"},
  });

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:recipientsPart
* @description
* Modal component which displays recipients of a document 
* **********************************************/

var RecipientsPartCtrl = function($uibModal, UserUtils, $rootScope) {
  var ctrl = this;
  if (ctrl.patient && ctrl.groupShortName) {
    $rootScope.busy = true
    UserUtils.getUsersForPatient(ctrl.patient.si_id).then(function (users) {
      var query = {group: {short_name: ctrl.groupShortName}};
      users = _.filter(users, query);
      users = _.sortBy(users, 'last_name');
      ctrl.caregivers = [];
      return function () {
        var result = [];
        for (var _i = 0, _Array$from = Array.from(users); _i < _Array$from.length; _i++) {
          var doc = _Array$from[_i];
          var addressTextFull = "";
          var address_data = doc.user_profile.data.address_data;
          if (address_data && Object.keys(address_data).length) {
            addressTextFull += address_data.address + '\n';
            addressTextFull += address_data.zip_code || " ";
            addressTextFull += address_data.town || "\n";
            addressTextFull += address_data.country || '';
          }
          var _data = {
            id: doc.id,
            name: doc.full_name,
            group_name: doc.group.name,
            occupation: doc.user_profile.occupation,
            address: address_data,
            addressTextFull: addressTextFull
          };
          result.push(ctrl.caregivers.push(_data));
        }
        $rootScope.busy = false
        return result;
      }();
    });
  }

  ctrl.modifyRecipients = function() {
    var modal = $uibModal.open({
      animation: true,
      size: "lg",
      backdrop: false,
      template: '<select-list-modal on-close="$close(selectedItems)" on-dismiss="$dismiss()"' +
      ' items="$ctrl.items" selected-items="$ctrl.selectedItems"></select-list-modal>',
      controller: function() {
        this.items = ctrl.caregivers;
        this.selectedItems = ctrl.recipients;
      },
      controllerAs: '$ctrl',
    });
    modal.result.then(function (selectedItems) {
      ctrl.isDirty = true;
      ctrl.recipients = selectedItems;
    });
  };
  
};
RecipientsPartCtrl.$inject = ["$uibModal", "UserUtils", "$rootScope"];

angular.module("mhclientApp").component("recipientsPart", {
    templateUrl: "medforms/components/recipients-part/recipients-part.html",
    controller: RecipientsPartCtrl,
    bindings: {
    recipients: "=",
    caregivers: "=?",
    isDirty: "=",
    userHeader: "=?",
    groupShortName: "=?",
    patient: "=?"
    },
  });


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:SelectListModal
* @description
* Modal component which allows to choose items in a list
* **********************************************/

var SelectListModalCtrl = function() {
  var ctrl = this;

  function init() {
    ctrl.isDirty = false;
    for(var i=0, len= ctrl.items.length; i <len; i++) {    
      var item = ctrl.items[i];
      item.selected = _.findIndex(ctrl.selectedItems, function (obj) { return obj.id === item.id}) !== -1;
    }
  }

  init();

  ctrl.save = function() {
    var selectedItems = _.filter(ctrl.items, function(obj) {return obj.selected;})
    ctrl.onClose({selectedItems: selectedItems});
  };
};

angular.module("mhclientApp").component("selectListModal", {
    templateUrl: "medforms/components/select-list-modal/select-list-modal.html",
    controller: SelectListModalCtrl,
    bindings: {
      items: "<",
      selectedItems: "<",
      onClose: "&",
      onDismiss: "&",
    },
  });
'use strict';


angular.module("mhclientApp").component("docToValidate", {
  templateUrl: "medforms/components/views/doc-to-validate.html",
  controller: docToValidateController
});


function docToValidateController(DocumentToValidate, $filter, $rootScope) {

    var ctrl = this
    ctrl.fetchData = fetchData

    ctrl.startDate = moment().subtract(60, 'days').format("YYYY-MM-DD")
    ctrl.endDate = null
    ctrl.filters = {
      status: [],
      sectors: [],
      authors: [],
      patients: [],
      availableStatus: [
        {id: "NEW", label: $filter("translate")("To validate")},
        {id: "VALIDATED", label: $filter("translate")("VALIDATED")}
      ]
    }

    function fetchData(){
      $rootScope.busy = true
      DocumentToValidate.query({start_date: ctrl.startDate, end_date: ctrl.endDate}).$promise.then (function(documentsToValidate){
        $rootScope.busy = false
        ctrl.documentsToValidate = documentsToValidate
        ctrl.filters.availableSectors = _.map(_.uniqBy(documentsToValidate, "sector"), function(doc) {return {"id":doc.sector, "label": doc.sector || "-"}})
        ctrl.filters.availableAuthors = _.map(_.uniqBy(documentsToValidate, "author"), function(doc) {return {"id":doc.author, "label": doc.author}})
        ctrl.filters.availablePatients = _.map(_.uniqBy(documentsToValidate, "patient"), function(doc) {return {"id":doc.patient, "label": doc.patient}})
      })
    }

    ctrl.$onInit = function () {
      ctrl.fetchData()
    };

  }

angular.module('mhclientApp').filter('docToValidateFilter', function() {
  return function(docs, filters) {

    var regex;
    // if (!query || query.length == 0) {return reject ? [] : deliveries }
    // regex = new RegExp('' + query.replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i');
    if (!filters) return docs

    return _.filter(docs, function (doc){
      return (
        (filters.authors.length == 0 || _.indexOf(filters.authors, doc.author) >= 0) &&
        (filters.sectors.length == 0 || _.indexOf(filters.sectors, doc.sector) >= 0) &&
        (filters.status.length == 0 || _.indexOf(filters.status, doc.state) >= 0) &&
        (filters.patients.length == 0 || _.indexOf(filters.patients, doc.patient) >= 0)
      )
    })
  };

});

'use strict';


// multiUserSelection check list reprise escapeHtml formInputFields
// Cher Confrère, ${staticData.stay.medical_data.ANT|escapeHtml} ${staticData.stay.medical_data.ANTM}

angular.module("mhclientApp").component("medformRootField", {
  template: '\
    <medform-base-field ng-if="$ctrl.root.disable_autoheader" root="$ctrl.root" config="$ctrl.config" content-data="$ctrl.contentData" field="$ctrl.root.header" static-data="$ctrl.staticData"></medform-base-field>\
    \
    <medform-base-field style="float: left;" ng-if="$ctrl.root.with_left_content" root="$ctrl.root" config="$ctrl.config" content-data="$ctrl.contentData" field="$ctrl.root.left_margin" static-data="$ctrl.staticData"></medform-base-field>\
    <medform-base-field style="float: right;" ng-if="$ctrl.root.with_right_content" root="$ctrl.root" config="$ctrl.config" content-data="$ctrl.contentData" field="$ctrl.root.right_margin" static-data="$ctrl.staticData"></medform-base-field>\
    <medform-base-field ng-style="\
        {\'margin-left\': ($ctrl.root.with_left_content ? $ctrl.root.left_margin.width: 0)+\'px\', \'margin-right\': ($ctrl.root.with_right_content ? $ctrl.root.right_margin.width: 0)+\'px\'}"\
      config="$ctrl.config" content-data="$ctrl.contentData" field="$ctrl.root" static-data="$ctrl.staticData"></medform-base-field>\
    \
    <medform-base-field em-height-source="footerHeight" ng-if="$ctrl.root.disable_autofooter" root="$ctrl.root" config="$ctrl.config" content-data="$ctrl.contentData" field="$ctrl.root.footer" static-data="$ctrl.staticData"></medform-base-field>\
  ',
  controller: ["$timeout", function medformRootFieldCtrl($timeout) {
    var ctrl = this;
    ctrl.$postLink = function() {
      $timeout(function() {ctrl.onCompileEnd && ctrl.onCompileEnd();});
    };

    ctrl.root.type = "root"
    ctrl.root.fields = ctrl.root.fields || []
    ctrl.root.header = ctrl.root.header || {fields: [], type:"header", height: 100}
    ctrl.root.footer = ctrl.root.footer || {fields: [], type:"footer", height: 100}
    ctrl.root.left_margin = ctrl.root.left_margin || {fields: [], type:"margin", width: 150}
    ctrl.root.right_margin = ctrl.root.right_margin || {fields: [], type:"margin", width: 150}
  }],
  bindings: {root:"<", contentData: "<", staticData: "<", config: "<", onCompileEnd: "&"},
});

angular.module("mhclientApp").component("medformMarginField", {
  templateUrl: "medforms/components/views/medforms/margin-field.html",
  bindings: {field: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});

angular.module("mhclientApp").component("medformHeaderField", {
  templateUrl: "medforms/components/views/medforms/header-field.html",
  bindings: {field: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});

angular.module("mhclientApp").component("medformFooterField", {
  templateUrl: "medforms/components/views/medforms/footer-field.html",
  bindings: {field: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});


angular.module("mhclientApp").component("medformBaseField", {
  templateUrl: "medforms/components/views/medforms/base-field.html",
  controller: ["$rootScope", "$q", "$scope", "$filter", "$uibModal", "GenUID", function medformBaseFieldCtrl($rootScope, $q, $scope, $filter, $uibModal, GenUID) {
    var ctrl = this;
    ctrl.isContainer = $rootScope.checkIn(["root", "header", "footer", "multiline", "table", "list", "section", "root", "block", "accordion", "margin"], ctrl.field.type)
    ctrl.isProtected = $rootScope.checkIn(["mission-sequences", "mission-majorations"], ctrl.field.type)

    var findIndex = function () {return _.findIndex(ctrl.parent.fields, ctrl.field)}
    ctrl.checkVisibility = function() {
        return !_.some(ctrl.field.conditions, function(condition){
            if (condition.custom) {
                try{
                ctrl.contentData[condition.custom_key_in_data] =  math.evaluate(
                  $filter("genMedformsDynamicDisplay")(condition.input, {contentData: ctrl.contentData, staticData: ctrl.staticData}),
                  {data: ctrl.contentData, staticData: ctrl.staticData});
                } catch (_error) { ctrl.contentData[condition.custom_key_in_data] = false;}
                return !ctrl.contentData[condition.custom_key_in_data]
            }
            else {return ctrl.contentData[condition.key] != condition.value}
        })
    }
    ctrl.dndMoved = function () {
      $scope.$emit("medformsSetDirty");
      if (ctrl.config.selectedFields){ // for synthesis purposes
        var item = ctrl.parent.fields.splice(findIndex(), 1)[0]
        _.indexOf(ctrl.config.selectedFields, item.uid) == -1 ? ctrl.config.selectedFields.push(item.uid) : $rootScope.removeFromArray(ctrl.config.selectedFields, item.uid)
      }
      else{
        ctrl.parent.fields.splice(findIndex(), 1)
      }
    }

    ctrl.toggleHighlightedField = function (field) {
      $scope.$emit("medformsSetDirty")
      field.highlighted = !field.highlighted
    }


    ctrl.appendField = function () {
      $scope.$emit("$medformsAppendField", ctrl.field)
      $rootScope.removeFromArray(ctrl.parent.fields, ctrl.field)
    }

    ctrl.removeSynthesisField = function () {
      $scope.$emit("$medformsRemoveField", ctrl.field)
      $rootScope.removeFromArray(ctrl.parent.fields, ctrl.field)
    }

    var fieldDetailModal = function (field) {
      return $q.when($scope.$emit("getFields").data).then (function(fields){
        return $q.when($scope.$emit("getFieldForReprise").data).then (function(fieldForReprise){
          return $uibModal.open({
            templateUrl: 'customer/medforms/views/form-field-detail.html',
            controller : 'FormFieldDetailCtrl',
            windowClass: 'event-detail-modal',
            backdrop: 'static',
            resolve: {
              field : function(){ return angular.copy(field) },
              fields: function(){ return fields},
              repriseOptions: function(){ return fieldForReprise},
              fieldTypes: function(){ return ctrl.config.availableFields || $scope.$emit("getAllowedTypes").data },
              allowImportJson: function(){ return ctrl.config.allowImportJson },
            }
          }).result
        })
      })
    }
    ctrl.removeField = function (fields, field) {
        $rootScope.removeFromArray(fields, field)
        $scope.$emit("medformsSetDirty")

    }

    ctrl.addField = function() {
      fieldDetailModal().then(function(newField) {
        if (newField){
          $scope.$emit("medformsSetDirty")
          _.forEach($rootScope.typeIsArray(newField) ? newField: [newField], function(singleField) {singleField.uid = GenUID.generate(12); ctrl.field.fields.push(singleField)})
        }
      })
    }

    ctrl.editField = function() {
      fieldDetailModal(ctrl.field).then(function(newField) {
        if (newField){
          $scope.$emit("medformsSetDirty")
          if (_.indexOf(["root", "footer", "header", "margin"], ctrl.field.type) != -1) {
            _.assign(ctrl.field, newField)
          } else {
            newField.uid = GenUID.generate(12); ctrl.parent.fields.splice(findIndex(), 1, newField)
          }
        }
      })
    }

  }],
  bindings: {field: "<", parent: "<", contentData: "<", staticData: "<", config: "<"},
});


angular.module("mhclientApp").component("medformTableField", {
  template:'\
    <tr ng-repeat="row in $ctrl.field.fields">\
        <td ng-repeat="cell in row.fields">\
            <medform-base-field config="$ctrl.config" content-data="$ctrl.contentData" parent="row" field="cell" static-data="$ctrl.staticData"></medform-base-field>\
        </td>\
    </tr>\
    <tr ng-if="::$ctrl.config.editable || false">\
        <td><span ng-if="$ctrl.config.canAdd || false" ng-click="$ctrl.addRow()" class="add-field glyphicon glyphicon-plus"></span></td>\
    </tr>\
  ',
  controller: function medformTableFieldCtrl() {
    var ctrl = this;
    ctrl.addRow = function() {ctrl.field.fields.push({fields:  Array(ctrl.field.col_count).fill().map(function(){ return {type:"empty"}})})}
  },
  bindings: {field: "<", parent: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});

angular.module("mhclientApp").component("medformMultiUserSelectionField", {
  templateUrl: "medforms/components/views/medforms/multi-user-selection-field.html",
  controller: ["$filter", function medformUserSelectionFieldCtrl($filter) {
    var ctrl = this;
    ctrl.computedAutoSelectCount = ctrl.field.key in ctrl.contentData ? undefined : ctrl.field.autoSelectCount
    ctrl.contentData[ctrl.field.key] = ctrl.contentData[ctrl.field.key] || []
    ctrl.selectUser = function(user) {
      user.__display = $filter("genMedformsDynamicDisplay")(ctrl.field.input, {contentData: ctrl.contentData, staticData: ctrl.staticData, user:user})
      ctrl.contentData[ctrl.field.key].push(_.clone(user))
    }
  }],
  bindings: {field: "<", parent: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});

angular.module("mhclientApp").component("medformUserSelectionField", {
  templateUrl: "medforms/components/views/medforms/user-selection-field.html",
  controller: ["$filter", function medformUserSelectionFieldCtrl($filter) {
    var ctrl = this;
    ctrl.computedAutoSelectCount = ctrl.field.key in ctrl.contentData ?  undefined : (ctrl.field.autoSelect ? 1 : 0)
    ctrl.genDisplay = function(user) {
      user.__display = $filter("genMedformsDynamicDisplay")(ctrl.field.input, {contentData: ctrl.contentData, staticData: ctrl.staticData, user:user})
    }
  }],
  bindings: {field: "<", parent: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});

angular.module("mhclientApp").component("medformMultilineField", {
  template: '\
  <span dnd-allowed-types="::$ctrl.config.allowedTypes" dnd-list="$ctrl.field.fields">\
      <medform-base-field class="inline-block padding-right-5" ng-repeat="lineField in $ctrl.field.fields" config="$ctrl.config" content-data="$ctrl.contentData" parent="$ctrl.field" field="lineField" static-data="$ctrl.staticData"></medform-base-field>\
      <span ng-if="::$ctrl.config.editable || false">\
        <span ng-if="$ctrl.config.canAdd || false" ng-click="$ctrl.addField()" class="pull-left add-field glyphicon glyphicon-plus"></span>\
      </span>\
  </span>\
  ',
  bindings: {field: "<", parent: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});

angular.module("mhclientApp").component("medformAccordionField", {
  templateUrl: "medforms/components/views/medforms/accordion-field.html",
  bindings: {field: "<", parent: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});

angular.module("mhclientApp").component("medformBlockField", {
  template: '\
    <span dnd-allowed-types="::$ctrl.config.allowedTypes" dnd-list="$ctrl.field.fields">\
        <medform-base-field ng-repeat="blockField in $ctrl.field.fields" config="$ctrl.config" content-data="$ctrl.contentData" parent="$ctrl.field" field="blockField" static-data="$ctrl.staticData"></medform-base-field>\
    </span>\
    <span ng-if="::$ctrl.config.editable || false">\
      <span ng-if="$ctrl.config.canAdd || false" ng-click="$ctrl.addField()" class="add-field glyphicon glyphicon-plus"></span>\
    </span\
  ',
  bindings: {field: "<", parent: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});


angular.module("mhclientApp").component("medformSectionField", {
  template: '\
  <label ng-style="::$ctrl.field.styles.label_style" ng-if="::$ctrl.field.label" class="section-tittle">{{::$ctrl.field.label}}</label>\
  <span dnd-allowed-types="::$ctrl.config.allowedTypes" dnd-list="$ctrl.field.fields">\
      <medform-base-field ng-repeat="sectionField in $ctrl.field.fields" config="$ctrl.config" content-data="$ctrl.contentData" parent="$ctrl.field" field="sectionField" static-data="$ctrl.staticData"></medform-base-field>\
  </span>\
  <span ng-if="::$ctrl.config.editable || false">\
    <span ng-if="$ctrl.config.canAdd || false" ng-click="$ctrl.addField()" class="add-field glyphicon glyphicon-plus"></span>\
  </span>\
  ',
  bindings: {field: "<", parent: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});


angular.module("mhclientApp").component("medformListField", {
  template: '\
    <ol dnd-allowed-types="::$ctrl.config.allowedTypes" dnd-list="$ctrl.field.fields" ng-if="::$ctrl.field.custom_type==\'ordered\'" ng-attr-start="{{::$ctrl.field.start}}">\
        <li ng-repeat="listField in $ctrl.field.fields">\
            <medform-base-field content-data="$ctrl.contentData" parent="$ctrl.field" config="$ctrl.config" field="listField" static-data="$ctrl.staticData"></medform-base-field>\
        </li>\
    </ol>\
    <ul dnd-allowed-types="::$ctrl.config.allowedTypes" dnd-list="$ctrl.field.fields" ng-if="::$ctrl.field.custom_type!=\'ordered\'">\
        <li ng-repeat="listField in $ctrl.field.fields">\
            <medform-base-field content-data="$ctrl.contentData" parent="$ctrl.field" config="$ctrl.config" field="listField" static-data="$ctrl.staticData"></medform-base-field>\
        </li>\
    </ul>\
    <span ng-if="::$ctrl.config.editable || false">\
      <span ng-if="$ctrl.config.canAdd || false" ng-click="$ctrl.addField()" class="add-field glyphicon glyphicon-plus"></span>\
    </span>\
  ',
  bindings: {field: "<", parent: "<", contentData: "<", staticData: "<", addField: '&', config: "<"},
});

angular.module("mhclientApp").component("medformLogoField", {
  templateUrl: "medforms/components/views/medforms/logo-field.html",
  controller: ["SiteVarsUtils", "$rootScope", function medformLogoFieldCtrl(SiteVarsUtils, $rootScope) {
    var ctrl = this;
    SiteVarsUtils.get("logo", SiteVarsUtils.getDefaultLogo(), $rootScope.currentStay ? $rootScope.currentStay.entity: null).then (function(sitevar){
      ctrl.logo = sitevar.value
    })
  }],
  bindings: {field: "<", contentData: "<"},
});


angular.module("mhclientApp").component("medformCheckboxField", {
  templateUrl: "medforms/components/views/medforms/checkbox-field.html",
  bindings: {field: "<", contentData: "<"},
});

angular.module("mhclientApp").component("medformTextField", {
  templateUrl: "medforms/components/views/medforms/text-field.html",
  bindings: {field: "<", contentData: "<", config: "<"},
});

angular.module("mhclientApp").component("medformSignatureField", {
  templateUrl: "medforms/components/views/medforms/signature-field.html",
  bindings: {field: "<", contentData: "<", staticData: "<",},
  controller: ["$rootScope", "$q", function medformNumberFieldCtrl($rootScope, $q) {
      var ctrl = this;
      ctrl.data = []
      if (!_.has(ctrl.contentData, ctrl.field.key)){
        if (ctrl.field.use_saved_signature && $rootScope.user.user_profile.signature){
          ctrl.drawing = false
          var img = new Image()
          img.src = $rootScope.user.user_profile.signature
          var imgPromise = $q.defer()
          img.onload = function(){
            var canvas = document.createElement("canvas")
            canvas.width = img.width
            canvas.height = img.height
            if (_.max([canvas.width, canvas.height]) > 200){
              var reduce_factor = _.max([canvas.width/200, canvas.height/200])
              canvas.width = Math.floor(canvas.width/reduce_factor)
              canvas.height = Math.floor(canvas.height/reduce_factor)

            }
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            imgPromise.resolve(canvas.toDataURL("image/png"))
          }
          imgPromise.promise.then( function(data){ ctrl.contentData[ctrl.field.key] = data})
        }
        else{
          ctrl.contentData[ctrl.field.key] = ""
          ctrl.drawing = true
        }
      } else {
          // Handle null/undefined before checking .length
          var value = ctrl.contentData[ctrl.field.key]
          ctrl.drawing = !value || value.length === 0
      }

      ctrl.container = {
        newDataContent: [],
        config:{
          'readonly'  : false,
          'action'    : 'draw',
          'penColor'  : 'black',
          'lineWidth' : 2,
          'smooth'    : true,
          'tolerance' : 1.00,
          'width'     : 300,
          'height'    : 300,
          'withNotes' : false,
        }
      }
  }],

});

angular.module("mhclientApp").component("medformInsDataMatrixField", {
  template: '\
    <span ng-if="::$ctrl.done">\
      <img ng-if="::!!$ctrl.datamatrix" ng-style=":: {\'max-width\': ($ctrl.field.size || 150)+\'px\', \'max-height\': ($ctrl.field.size || 150)+\'px\'}" ng-src="{{:: $ctrl.datamatrix}}">\
      <div class="text-center" ng-if="::!$ctrl.datamatrix" ng-style=":: {\'vertical-align\': \'middle\', display: \'table-cell\', border: \'2px solid black\', width: ($ctrl.field.size || 150)+\'px\', height: ($ctrl.field.size || 150)+\'px\'}">\
        {{:: "Missing info for Datamatrix" | translate}}\
      </div>\
    </span>\
  ',
  controller: ["$rootScope", "Patient", function medformDischargeOrdonnanceFieldCtrl($rootScope, Patient) {
    var ctrl = this;
    if ($rootScope.mh_config.platform == "mhsi" && (ctrl.staticData.patient || {}).id){
      Patient.dataMatrix({id:ctrl.staticData.patient.id}).$promise.then(function(result){
        ctrl.datamatrix = result.base64
        ctrl.done = true
      })
    } else { ctrl.done = true }
  }],
  bindings: {field: "<", contentData: "<", config: "<", staticData: "<"},
});

angular.module("mhclientApp").component("medformDischargeOrdonnanceField", {
  template: '\
    <span ng-if="::!$ctrl.config.editable">\
      <span ng-if="$ctrl.done">\
        <ordonnance-detail disable-actions="true" ordonnance="$ctrl.ordonnance" ordonnance-id="{{::$ctrl.contentData[$ctrl.field.uid]}}" ng-if="::!!$ctrl.contentData[$ctrl.field.uid]"></ordonnance-detail>\
      </span>\
    </span>\
    <span ng-if="::!!$ctrl.config.editable">\
      Ordonnance de sortie\
    </span>\
  ',
  controller: ["$rootScope", "Ordonnance", function medformDischargeOrdonnanceFieldCtrl($rootScope, Ordonnance) {
    var ctrl = this;
    if (!(ctrl.field.uid in ctrl.contentData) && $rootScope.currentStay){
      Ordonnance.query({stay:$rootScope.currentStay.id, state: "ACTIVE"}).$promise.then(function(result){
        ctrl.ordonnance = (_.find(result, {discharge_prescription:true}) || {})
        ctrl.contentData[ctrl.field.uid] = ctrl.ordonnance.id
        ctrl.done = true
      })
    } else { ctrl.done = true }
  }],
  bindings: {field: "<", contentData: "<", config: "<"},
});

angular.module("mhclientApp").component("medformLegendField", {
  templateUrl: "medforms/components/views/medforms/legend-field.html",
  bindings: {field: "<", contentData: "<"},
});

angular.module("mhclientApp").component("medformTextAreaField", {
  templateUrl: "medforms/components/views/medforms/text-area-field.html",
  bindings: {field: "<", contentData: "<"},
});

angular.module("mhclientApp").component("medformNumberField", {
  templateUrl: "medforms/components/views/medforms/number-field.html",
  controller: function medformNumberFieldCtrl() {
      var ctrl = this;
      // type="number" needs the model to be a real Number, but stored content
      // may arrive as a string. Coerce only when it parses to a number; leave
      // empty values empty (null) so NaN never lands in the model and breaks
      // ng-required validation.
      var parsed = parseFloat(ctrl.contentData[ctrl.field.key])
      ctrl.contentData[ctrl.field.key] = isNaN(parsed) ? null : parsed
  },
  bindings: {field: "<", contentData: "<"},
});

angular.module("mhclientApp").component("medformRadioField", {
  templateUrl: "medforms/components/views/medforms/radio-field.html",
  bindings: {field: "<", contentData: "<"},
});

angular.module("mhclientApp").component("medformNextInterventionField", {
  templateUrl: "medforms/components/views/medforms/next-intervention-field.html",
  bindings: {field: "<", contentData: "<"}
});


angular.module("mhclientApp").component("medformSelectField", {
  templateUrl: "medforms/components/views/medforms/select-field.html",
  controller: function medformSelectFieldCtrl() {
    var ctrl = this;
    if (ctrl.field.options.length == 1) {ctrl.contentData[ctrl.field.key] = ctrl.field.options[0]['value']}
  },
  bindings: {field: "<", contentData: "<"},
});

angular.module("mhclientApp").component("medformAutoField", {
  templateUrl: "medforms/components/views/medforms/auto-field.html",
  controller: ["$filter", function medformAutoFieldCtrl($filter) {
    var ctrl = this;
    ctrl.genValue = function() {
      var result;
      try {
        // compareText to compare strings
        result = math.evaluate(
          $filter("genMedformsDynamicDisplay")(ctrl.field.result, {contentData: ctrl.contentData, staticData: ctrl.staticData}),
          {data: ctrl.contentData, staticData: ctrl.staticData});
        if (ctrl.field.key) { ctrl.contentData[ctrl.field.key] = result}
        if (ctrl.field.result_params && ctrl.field.result_params.decimals) {result = parseFloat(result.toFixed(ctrl.field.result_params.decimals))}
        return result;
      } catch (_error) {return ""}
    };
  }],
  bindings: {field: "<", contentData: "<", staticData: "<", config: "<"},
});

angular.module("mhclientApp").component("medformDateField", {
  templateUrl: "medforms/components/views/medforms/date-field.html",
  controller: function medformDateFieldCtrl() {
    var ctrl = this;
    ctrl.contentData[ctrl.field.key] = ctrl.contentData[ctrl.field.key] ? moment(ctrl.contentData[ctrl.field.key]).toDate() : (ctrl.field.today ? new Date() : null)
  },
  bindings: {field: "<", contentData: "<"},
});


angular.module("mhclientApp").component("medformEmptyCellField", {
  templateUrl: "medforms/components/views/medforms/empty-cell-field.html",
  controller: ["$scope", function medformEmptyCellFieldCtrl($scope) {
    var ctrl = this;
    ctrl.dndDrop = function (item) { $scope.$emit("medformsSetDirty"); return ctrl.parent.fields.splice(_.indexOf(ctrl.parent.fields, ctrl.field), 1, item)}
  }],
  bindings: {field: "<", parent: "<"},
});


angular.module("mhclientApp").component("medformHtmlExtendedField", {
  template: '<pre ng-if="::!$ctrl.config.readOnly" ng-bind-html="$ctrl.genHTMLValue()"></pre><pre ng-if="::!!$ctrl.config.readOnly " ng-bind-html="$ctrl.contentData[$ctrl.field.uid]"></pre>',
  controller: ["$filter", function medformHtmlExtendedFieldCtrl($filter) {
    var ctrl = this;
    ctrl.genHTMLValue = function() {
      ctrl.contentData[ctrl.field.uid] = $filter("genMedformsDynamicDisplay")(ctrl.field.input, {contentData: ctrl.contentData, staticData: ctrl.staticData})
      return ctrl.contentData[ctrl.field.uid]
    }
  }],
  bindings: {field: "<", contentData: "<", staticData: "<", config: "<"},
});

angular.module('mhclientApp').filter('genMedformsDynamicDisplay', ["$filter", function($filter) {
  return function(input, scope) {
      try {
        return _.map(XRegExp.matchRecursive(input, "\\${", "}", "g", {valueNames: ['between', 'left', 'match', 'right']}), function(match){
          if (match.name == "between") {return match.value}
          if (match.name == "match") {
              match.value = $filter('genMedformsDynamicDisplay')(match.value, scope)
              var split, value, filter, filterParams, params;
              split = match.value.split('|')
              value = _.get(scope, split[0].trim(), "")
              while (split.length > 1){
                filterParams = _.map(split.splice(1,1)[0].split(':'), function(param){return param.trim()})
                filter = filterParams[0].trim()
                params = [value].concat(filterParams.splice(1))
                value = $filter(filter).apply(null, params)
              }
              return value
          }
          return ""
        }).join("")
      }catch (error) { return ""}
  };

}]);

angular.module('mhclientApp').filter('JOIN', ["$filter", function($filter) {
  return function(inputs, params) {
    return (params? _.map(inputs, function(input) { return _.map(params.split(","), function(param){return input[param]}).join(" ")}) : inputs).join(", ")
  };

}]);

angular.module('mhclientApp').filter('dateDiff', ["$filter", function($filter) {
  return function(input, param, delta) {
    return moment(input).diff(moment(param), "days") + (parseInt(delta || 0))
  };
}]);


angular.module('mhclientApp').filter('genderDisplay', ["$filter", function($filter) {
  return function(input, type) {
    if (type == "short"){
      return {
        "M": $filter("translate")("Male_short_gender"),
        "F": $filter("translate")("Female_short_gender"),
        "U": "",
        "O": "",
      }[input]
    }
    else{
      return {
        "M": $filter("translate")("Male_gender"),
        "F": $filter("translate")("Female_gender"),
        "U": "",
        "O": "",
      }[input]
    }

  };

}]);


'use strict';


angular.module("mhclientApp").component('genFormGroupModal', {
    templateUrl: "medforms/components/views/generator/medforms-gen-form-group-modal.html",
    bindings: {close: '&'},
});

angular.module("mhclientApp").component('formGlobalRepriseModal', {
    templateUrl: "medforms/components/views/generator/medforms-global-reprise-modal.html",
    controller: function formGlobalRepriseModalCtrl(){
      var ctrl = this;

      ctrl.$onInit = function () {
        ctrl.template = ctrl.resolve.template
        ctrl.version = ctrl.resolve.version
        ctrl.repriseOptions = ctrl.resolve.repriseOptions
        ctrl.dataCopy = (_.cloneDeep(ctrl.version.meta.data_copy) || {forms: [], patient_data: [], vital_signs: []})
        if (ctrl.version.content_type == 'STRUCTURED'){
          ctrl.dataCopy.forms = _.filter(ctrl.dataCopy.forms, "all_data")
        }
      }
    },
    bindings: {resolve: '<', modalInstance: "<", close: '&'},
});

angular.module("mhclientApp").component('genTemplateVersionModal', {
    templateUrl: "medforms/components/views/generator/gen-template-version-modal.html",
    controller: function genTemplateVersionModalCtrl(){
      var ctrl = this;
      ctrl.$onInit = function () {
        ctrl.template = ctrl.resolve.template
        if (ctrl.template.current && ctrl.template.current.content_type == "HTML"){ ctrl.availablecontentTypes = [ "HTML", "STRUCTURED"]}
        else { ctrl.availablecontentTypes = ["IMG", "HTML", "STRUCTURED"]}
      }

      ctrl.selectContenType = function (contentType) {
      var version = _.assign({template: ctrl.template.id, content_type: contentType, type_form: contentType == "IMG" ? "IMG" : "STRUCT", is_draft: true, editMode: true}, _.pick(ctrl.template.current || {data: {}}, ["ref", "name", "data"]))
        delete version.data.disable_new_pdf_export
        var computedMeta = {containers: contentType == "IMG" ? [] : [{}]}
        if (ctrl.template.current && contentType == ctrl.template.current.content_type) { computedMeta = _.cloneDeep(ctrl.template.current.meta) }
        else { if (ctrl.template.current && contentType == "HTML" && ctrl.template.current.meta.data_copy) { computedMeta.data_copy = ctrl.template.current.meta.data_copy}}
        // copy only data_copy between html, when we upgrade form html to structured avoid copy
        ctrl.modalInstance.close(_.assign(version, {meta: computedMeta}))
      }

    },
    bindings: {resolve: '<', modalInstance: "<", close: '&'},
});

angular.module("mhclientApp").component('editTemplateModal', {
    templateUrl: "medforms/components/views/generator/edit-template-modal.html",
    controller: ["$q", "MedFormsUtils", "GroupUtils", "FormGroupConfig", function editTemplateModalCtrl($q, MedFormsUtils, GroupUtils, FormGroupConfig){
      var ctrl = this;
      ctrl.setConfig = function(groups, newConfig){_.forEach(_.reject(_.map(groups, "config"), newConfig), function(config){ctrl.templateForm.$setDirty();config.dirty = true; _.assign(config, newConfig)})}
      ctrl.toggleLock = function() {ctrl.templateToEdit.lock_after_hours = ctrl.lockEnabled ? 4 : 0}

      ctrl.$onInit = function () {
        ctrl.waiter =  true
        ctrl.lockEnabled = ctrl.resolve.template.lock_after_hours > 0;
        GroupUtils.getAllGroups().then (function(groups){
          MedFormsUtils.getGroupsConfig({template:ctrl.resolve.template.id}, true).then (function(groupsConfig) {
            ctrl.groups = groups
            _.forEach(ctrl.groups, function(group){group.config = _.cloneDeep(_.find(groupsConfig, {group: group.id}) || {template: ctrl.resolve.template.id,group: group.id})})
            ctrl.templateToEdit = _.cloneDeep(_.omit(ctrl.resolve.template, ["versions", "currentVersion", "current"]))
            ctrl.formGroups = _.concat([{"name": "No Group", "id": null}], _.orderBy(ctrl.resolve.formGroups, "name"))
            ctrl.waiter =  false
          })
        })
      }
      ctrl.accept = function(){
        ctrl.waiter =  true
        $q.all(_.map(_.filter(ctrl.groups, {config: {dirty: true}}), function(group) {MedFormsUtils.resetCache(); return FormGroupConfig[group.config.id ? 'update' : 'save'](group.config).$promise})).then (function(){
          ctrl.waiter =  false
          ctrl.modalInstance.close(ctrl.templateToEdit)
        })

      }
    }],
    bindings: {resolve: '<', modalInstance: "<", close: '&'},
});


angular.module("mhclientApp").component("medformVersionEdition", {
  templateUrl: "medforms/components/views/generator/medform-version-edition.html",
  controller: ["$rootScope", "$scope", "$q", "$timeout", "$filter", "MedFormsUtils", function medformGeneratorCtrl($rootScope, $scope, $q, $timeout, $filter, MedFormsUtils) {
    var ctrl = this;
    MedFormsUtils.getStaticData().then (function(customScope){ctrl.customScope = customScope})

    ctrl.uploadFiles = function(files){
      if (!files) {return}
      $rootScope.busy = true
      $q.all(_.map(files, function(file) {
        var reader = new FileReader();
        var done = $q.defer()
        reader.readAsDataURL(file);
        reader.onload = function () {done.resolve(reader.result)};
        return done.promise
      })).then (function (bases64) {
        _.forEach(bases64, function(base64){ ctrl.version.meta.containers.push({backgroundContent: base64})})
        $rootScope.busy = false
        ctrl.version.dirty = true
      })
    }

    ctrl.changeImageMode = function(){if (!ctrl.version.editMode){setNewVersion(ctrl.version)}}

    var setNewVersion =  function(version){
        ctrl.version = undefined
        $rootScope.busy = true
        MedFormsUtils.fetchTemplateVersionContainers(version).then (function() {
          $rootScope.busy = false
          $timeout(function() {
            ctrl.version = version
            $scope.container = {dataContent: {}}  // for HTML specific controler purposes
            $scope.InitDone = $q.defer()
            $scope.InitDone.resolve()
            $scope.patient = ctrl.customScope.patient
            $scope.stay = ctrl.customScope.stay
            $scope.version = _.cloneDeep(ctrl.version)
            $scope.patient_detail = angular.copy($scope.patient)
            $scope.patient_detail.linked_stay = angular.copy($scope.stay)
            $scope.patient_detail.data["medical_data"] = $scope.patient_detail.linked_stay["medical_data"]
            ctrl.metaClone = $scope.version.meta // for image-directive

          })
        })
    }

    ctrl.$onChanges = function(changes) {
      if (changes.versionToEdit) {ctrl.version = undefined}
      if (changes.versionToEdit.currentValue){setNewVersion(changes.versionToEdit.currentValue)}
    }
  }],
  bindings: {"versionToEdit": "<"},
});


angular.module("mhclientApp").component("medformsGenerator", {
  templateUrl: "medforms/components/views/generator/medforms-generator.html",

  controller: ["$rootScope", "$scope", "$q", "$http", "$filter", "$timeout", "$uibModal", "$state", "MedFormsUtils", "TemplateVersion", "FormGroup", "Template", "FormTemplateUtils", "MeasuresTypes", "FeedUtils", "PrescUtils", function medformGeneratorCtrl($rootScope, $scope, $q, $http, $filter, $timeout, $uibModal, $state, MedFormsUtils, TemplateVersion, FormGroup, Template, FormTemplateUtils, MeasuresTypes, FeedUtils, PrescUtils) {

    var ctrl = this;
    // va checker header? fotter mg_app
    // quand on copy colle on perd le style de root
    // gender Filter
    // migrate customer version pas integres
    // change style root not visible

    ctrl.toggleNewPdfExport = function(customerVersion, active){
      if (customerVersion.id){
        $rootScope.busy = true
        TemplateVersion.update({id:customerVersion.id, data:customerVersion.data}).$promise.then (function(updatedVersion){$rootScope.busy = false})
      }
    }


    ctrl.save = function(template, version) {
      $rootScope.busy = true
      $q.when(template.id ? template : Template.save(_.pick(template, ["uid", ])).$promise).then (function(updatedTemplate){
        if (!template.id){FormTemplateUtils.resetCache()}
        _.assign(template, updatedTemplate)
        version.template = template.id;
        // remove content de img containers
        TemplateVersion[version.id ? 'update' : 'save'](version).$promise.then (function(updatedVersion){
          version.id = updatedVersion.id
          version.dirty = false
          $rootScope.busy = false
          ctrl.currentTemplateForm.$setPristine()
        })
      })
    }

    var extractKeys = function (root, inputs) {
      return _.concat(
          extractFields(root.fields, inputs),
          extractFields((root.header || {}).fields, inputs),
          extractFields((root.left_margin || {}).fields, inputs),
          extractFields((root.right_margin || {}).fields, inputs)
      )
    }

    var extractFields = function(fields, keys) {
      return [].concat.apply(
        _.map(_.filter(fields, function(field) {return !keys || keys.indexOf(field.type) >= 0}), function(field) {return angular.copy(field)}),
        _.map(fields, function(field) {return extractFields(field.fields || [], keys)}))
    }

    var handleRepriseOptions = function(templates) {
      return $q.all(_.map(_.sortBy(_.filter(templates || ctrl.templates, {current: {content_type: "STRUCTURED"}}), "uid"), function(template){
        return MedFormsUtils.fetchTemplateVersionContainers(template.current).then( function(){
          return {uid: template.uid, keys:  extractKeys(template.current.meta.containers[0].dynamicForm, MedFormsUtils.formInputFields)}
        })
      }))
    }

    $scope.$on('medformsSetDirty', function (event){
      ctrl.currentTemplate.currentVersion.dirty = true
      event.stopPropagation()
    })

    $scope.$on('getFields', function (event){
      event.data = MedFormsUtils.fetchTemplateVersionContainers(ctrl.currentTemplate.currentVersion).then( function(){
        return extractKeys(ctrl.currentTemplate.currentVersion.meta.containers[0].dynamicForm)
      })
      event.stopPropagation()
    })

    $scope.$on('getFieldForReprise', function (event){
      event.data = $q.when(handleRepriseOptions(_.reject(ctrl.templates, {uid: ctrl.currentTemplate.uid}))).then (function(structuredFormsReprise){
        return MeasuresTypes.api.query().$promise.then (function(measureTypes){
          return FeedUtils.getFeeds().then( function(feeds){
            return PrescUtils.getCategories().promise.then (function(categories){
              return MedFormsUtils.staticDataDefinition().then ( function(staticData){
                return {
                  single_threads: _.filter(feeds, function(feed) {return _.includes(["MHC_PSP", "MHC_IAS", "MHC_OBSERVATION"], feed.feature_name)}) , // feeds without response available
                  forms: structuredFormsReprise,
                  patient: {
                    options: _.map(_.filter(staticData, function(data) {return _.startsWith(data.key, "staticData.patient.")}), function(stayData){
                      return {
                        key: stayData.key.split("|")[0].slice("staticData.patient.".length),
                        label: stayData.label
                      }
                    })
                  },
                  stay: {
                    options: _.map(_.filter(staticData, function(data) {return _.startsWith(data.key, "staticData.stay.")}), function(stayData){
                      return {
                        key: stayData.key.split("|")[0].slice("staticData.stay.".length),
                        label: stayData.label
                      }
                    })
                  },
                  self: {},
                  old_forms: {"templates": _.map(_.filter(ctrl.templates, {current: {content_type: "HTML"}}), "uid")},
                  vital_signs: _.map(measureTypes, function(mType){return {uid:mType.uid, label: mType.metadata.LABEL}}),
                  PSP2: {},
                  prescriptions: {"categories": categories},
                }
              })
            })
          })
        })
      })
      event.stopPropagation()
    })

    ctrl.globalReprise = function(template, version){
      handleRepriseOptions().then (function(repriseOptions){
        $uibModal.open({
          component : 'formGlobalRepriseModal', windowClass: 'modal-fullscreen', backdrop: 'static', keyboard: false,
          resolve: {
            version: function(){return version},
            template: function(){return template},
            repriseOptions: function() {
              return _.concat(
                _.map(repriseOptions, function(repriseOption){ return _.assign(repriseOption, {content_type: "STRUCTURED"})}),
                _.map(_.filter(ctrl.templates, {current: {content_type: "HTML"}}), function(template) { return {uid: template.uid, content_type: "HTML"}})
            )}
          },
        }).result.then (function(repriseOptions){
          if (repriseOptions){
            version.dirty = true
            version.meta.data_copy = repriseOptions
          }

        })
      })

    }

    ctrl.handleTemplateConfig = function (customerTemplate) {
      $uibModal.open({
        component: 'editTemplateModal', windowClass: 'modal-fullscreen', backdrop: 'static',
        resolve: {template: function(){return customerTemplate}, formGroups: function(){return ctrl.formGroups}}
        }).result.then (function(editedTemplate){
          if (editedTemplate){
            $rootScope.busy = true
            Template.update(editedTemplate).$promise.then (function(updatedTemplate){
              $rootScope.busy = false
              _.assign(customerTemplate, _.omit(updatedTemplate, "current"))
            })
          }
        })
    }

    ctrl.integrateForm = function (customerTemplate) {
      $rootScope.busy = true
      TemplateVersion.integrate({id: customerTemplate.versions[0].id}).$promise.then (function(data){
        customerTemplate.current = customerTemplate.versions[0]
        customerTemplate.current.is_draft = false
        FormTemplateUtils.resetCache()
        $rootScope.busy = false
      })
    }


    ctrl.addVersion = function (template){
      return $q.when(template.current && template.current.content_type == "STRUCTURED" ?
        _.assign({template: template.id, content_type: "STRUCTURED", type_form: "STRUCT", is_draft: true}, _.pick(_.cloneDeep(template.current), ["ref", "name", "meta"])) :
        $uibModal.open({component: 'genTemplateVersionModal', size: "lg", resolve: {template: function(){return template}}}).result)
        .then(function (version) {
          if (version) {
            ctrl.versions.push(version)
            template.versions.unshift(version)
            ctrl.selectVersion(template, template.versions[0])
          }
          return version
      })
    }


    ctrl.selectVersion = function(template, version){ template.currentVersion = version}
    ctrl.hasGlobalReprise = function(templateVersion){
      var dataCopy = templateVersion.meta.data_copy || {}
      return (dataCopy.forms || []).length > 0 || (dataCopy.vital_signs || []).length > 0 || (dataCopy.patient_data || []).length > 0
    }

    ctrl.selectTemplate = function(template) {
      ctrl.currentTemplate = null
      $timeout(function() {ctrl.currentTemplate = template})
      if (template.versions.length > 0){template.currentVersion = template.versions[0]}
      else{ctrl.addVersion(template)}
    }

    ctrl.addTemplate = function() {
      var template = {"uid": "", "versions": [], "lock_after_hours": 4}
      ctrl.addVersion(template).then(function (version) {
        if (version){
          ctrl.templates.unshift(template)
          ctrl.currentTemplate = null
          $timeout(function() {ctrl.currentTemplate = template})
        }
      })
    }

    ctrl.addGroup = function(){
      $uibModal.open({component: 'genFormGroupModal', size: "lg"}).result.then (function(name) {
        if (name) {
          $rootScope.busy = true
          FormGroup.save({name:name}).$promise.then (function(formGroup) {
            ctrl.formGroups.push(formGroup)
            $rootScope.busy = false
          })
        }
      })
    }

    $rootScope.busy = false
    FormTemplateUtils.getTemplates().then (function (templates){
      TemplateVersion.query().$promise.then (function(versions){
        FormGroup.query().$promise.then (function(formGroups) {
          ctrl.container = {}
          ctrl.formGroups = formGroups
          ctrl.templates = templates
          ctrl.versions = versions
          _.forEach(ctrl.templates, function(template) {
            template.versions =  _.orderBy(_.filter(versions, {template:template.id}), "id", "desc")
            template.current = _.find(template.versions, {id:template.current})
          })
          $rootScope.busy = false
    })})})


    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
      if (event.defaultPrevented){return}
      if (_.find(ctrl.versions, "dirty")){
        event.preventDefault()
        $uibModal.open({
          animation : true,
          templateUrl: 'core/views/modal-template.html',
          size: "lg",
          controller: 'mhModalCtrl',
          resolve: {
            title: function(){return $filter('translate')("You have entries without saving")},
            text: function(){return ""},
            cancelButtonText: function(){return null},
            noButtonText: function(){return $filter('translate')("Continue anyway")},
            okButtonText: function(){return $filter('translate')("I will save before continuing")}
          }
        }).result.then (function(preventDefault){
          if (!preventDefault)  {
            _.map(ctrl.versions, function(version) {version.dirty = false});
            $state.go(toState.name, toParams)
          }
        })
      }
    })


  }],
  bindings: {},
});

angular.module("mhclientApp").component("medformTestVersion", {
  templateUrl: "medforms/components/views/generator/medform-test-version.html",
  controller: ["$rootScope", "$q", "$filter", "$scope", "TemplateVersion", "Template", "SiteVarsUtils", "StayUtils", "Stay", "Patient", "MedFormsUtils", "FormVersion", "SiteVar", function medformTestVersionCtrl($rootScope, $q, $filter, $scope, TemplateVersion, Template, SiteVarsUtils, StayUtils, Stay, Patient, MedFormsUtils, FormVersion, SiteVar) {
    var ctrl = this;
    $rootScope.busy = true

    ctrl.saveSiteVar = function() {
      (ctrl.siteVar.id ? SiteVar.update : SiteVar.save)(ctrl.siteVar).$promise.then(function (updatedSiteVar) {
        _.assign(ctrl.siteVar, updatedSiteVar)
        SiteVarsUtils.resetCache()
      })
    }

    ctrl.print = function(){
      //Prepare and save export html (which is used to print the form)
      var element = angular.element("#medform-struct-container")
      //Set value in mh-datepicker (because value is in a hidden input
      //and the one in database is ISO utc which makes it complicated to convert in Python)
      element.find("mh-datepicker").attr('value', element.find("mh-datepicker").find('input').val())
      var export_html = element.html()
      $rootScope.busy = true
      TemplateVersion.test_export_pdf({id:ctrl.versionId, stay: ctrl.stay.id, export_html:export_html, containers:ctrl.version.containers}).$promise.then (function(pdfUrl){
        $rootScope.busy = false
        window.open("/media/" + pdfUrl.url, '_blank')
      })
    }

    ctrl.init = function (forceReload) {
      SiteVarsUtils.get('DEFAULT_STAY_ID_TEST_FORMS', false).then (function(siteVar){
        ctrl.siteVar = siteVar
        ctrl.siteVar.name = "DEFAULT_STAY_ID_TEST_FORMS"
        $q.when(siteVar.value && !forceReload ? Stay.get({id:siteVar.value}).$promise : StayUtils.selectStayByPatientModal().result).then (function(stay){
          Stay.get({id: stay.id}).$promise.then (function(stay){
            ctrl.siteVar.value = stay.id
            Patient.get({id:stay.patient.id ? stay.patient.id : stay.patient}).$promise.then (function(patient){
              TemplateVersion.get({id:ctrl.versionId}).$promise.then (function(templateVersion){
                Template.get({id:templateVersion.template, fetch_all:true}).$promise.then (function(template){
                  FormVersion.query({template: template.id, stay:stay.id}).$promise.then (function(previousVersions){
                    $rootScope.busy = false
                    ctrl.stay = stay
                    ctrl.patient = patient
                    previousVersions = $filter('orderBy')(previousVersions, "-last_edit_timestamp")
                    $q.when(MedFormsUtils.initVersion({containers: templateVersion.meta.containers, type_form: templateVersion.type_form, stay: stay, template: template.id, template_version: templateVersion.id}, template, templateVersion, patient, stay, previousVersions.length > 0 ? previousVersions[0].id : null, true)).then (function(newVersion){
                      ctrl.version = newVersion
                      ctrl.template = template
                    })
                  })
                })
              })
            })
          })
        })
      })
    }

    ctrl.init()
  }],
  bindings: {versionId: "<"},
});

angular.module('mhclientApp').filter('formTemplateFilter', function() {
  return function(formTemplates, query) {
    if (formTemplates && query && query.length > 0){
      var regex = new RegExp('' + query, 'i');
      return _.filter(formTemplates, function(template){return regex.test(template.uid) || (template.versions.length > 0 && regex.test(template.versions[0].name))})
    }
    return formTemplates

  };
});

(function() {
  var loadJSScript,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  loadJSScript = function(url, callback) {
    var head, script;
    head = document.getElementByTagName('head')[0];
    script = document.createElement('script');
    script.type = 'text/javascript';
    script.url = url;
    script.onload = callback;
    script.onreadystatechange = callback;
    return head.appendChild(script);
  };

  window.posologySentenceGenerator = {
    language_code: 'fr',
    posologySentenceI18n: {
      fr: {
        "literal_float_separator": "virgule",
        "january": "janvier",
        "february": "février",
        "between": "entre",
        "march": "mars",
        "april": "avril",
        "may": "mai",
        "june": "juin",
        "july": "juillet",
        "august": "août",
        "september": "septembre",
        "october": "octobre",
        "november": "novembre",
        "december": "décembre",
        "day": "jour",
        "hour": "heure",
        "minute": "minute",
        " everyday": " tous les jours",
        "_DAY of _MONTH, _YEAR": "_DAY _MONTH _YEAR",
        "pl_monday": "le lundi",
        "pl_tuesday": "le mardi",
        "pl_wednesday": "le mercredi",
        "pl_thursday": "le jeudi",
        "pl_friday": "le vendredi",
        "pl_saturday": "le samedi",
        "pl_sunday": "le dimanche",
        " _QUANTITY _UNIT all_the _INTERVAL hours,": " _QUANTITY _UNIT toutes les _INTERVAL heures,",
        " _QUANTITY _UNIT on _TIMESLOT,": " _QUANTITY _UNIT _TIMESLOT,",
        " a total of _QUANTITY _UNIT per day": " soit un total de _QUANTITY _UNIT",
        " _QUANTITY _UNIT per day": " _QUANTITY _UNIT par jour",
        " _QUANTITY _UNIT/_INTERVAL": " _QUANTITY _UNIT/_INTERVAL",
        " on a drip to pass in _HOURS hour": " Perfusion à passer en _HOURS heure",
        " on a drip to pass in _HOURS hours": " Perfusion à passer en _HOURS heures",
        " and _MINUTES minute": " et _MINUTES minute ",
        " and _MINUTES minutes": " et _MINUTES minutes ",
        " with oxygen during _HOURS hour": " Oxygène pendant _HOURS heure",
        " with oxygen during _HOURS hours": " Oxygène pendant _HOURS heures",
        " and _MINUTES minute per day": " et _MINUTES minute par jour",
        " and _MINUTES minutes per day": " et _MINUTES minutes par jour",
        " each day": " par jour",
        " each _FREQUENCY days": " tous les _FREQUENCY jours",
        " before week days ": " les ",
        "week_day_separator": ", ",
        " each week": " chaque semaine",
        " each _FREQUENCY weeks": " tous les _FREQUENCY semaines",
        ", on this date ": "le ",
        ", on these dates ": "aux dates ",
        ", from _START_DATE": ", à partir du _START_DATE",
        "From ": "À partir du ",
        "from ": "à partir du ",
        " for an undetermined duration": " pour une durée indéterminée",
        " for _DURATION day": " durant _DURATION jour",
        " for _DURATION days": " durant _DURATION jours",
        " until _END_DATE": " jusqu'à _END_DATE",
        " only if ": " uniquement si ",
        ".": ".",
        " and": " et",
        " and renew ": " à renouveler ",
        " Proceed": " Procéder",
        " eventually _QUANTITY _UNIT": " éventuellement _QUANTITY _UNIT",
        " Do not take more than _QUANTITY(pl) _UNIT on a day.": " Ne pas dépasser _QUANTITY _UNIT par jour.",
        " Do not take more than _QUANTITY _UNIT on a day.": " Ne pas dépasser _QUANTITY _UNIT par jour.",
        " To renew if necessary after ": " À renouveler si besoin au bout de ",
        "The": "Le",
        "Any day ": "N'importe quel jour, ",
        "once a week": "une fois par semaine",
        "twice a week": "deux fois par semaine",
        "three times a week": "trois fois par semaine",
        "four times a week": "quatre fois par semaine",
        "five times a week": "cinq fois par semaine",
        "six times a week": "six fois par semaine",
        "seven times a week": "sept fois par semaine"
      },
      en: {
        "literal_float_separator": "dot",
        "january": "january",
        "february": "february",
        "march": "march",
        "april": "april",
        "may": "may",
        "june": "june",
        "july": "july",
        "august": "august",
        "september": "september",
        "october": "october",
        "november": "november",
        "december": "december",
        "_DAY of _MONTH, _YEAR": "_DAY of _MONTH, _YEAR",
        "pl_monday": "monday",
        "pl_tuesday": "tuesday",
        "pl_wednesday": "wednesday",
        "pl_thursday": "thursday",
        "pl_friday": "friday",
        "pl_saturday": "saturday",
        "pl_sunday": "sunday",
        " _QUANTITY _UNIT on _TIMESLOT,": " _QUANTITY _UNIT on _TIMESLOT,",
        " a total of _QUANTITY _UNIT per day": " a total of _QUANTITY _UNIT",
        " _QUANTITY _UNIT per day": " _QUANTITY _UNIT per day",
        " on a drip to pass in _HOURS hour": " on a drip to pass in _HOURS hour",
        " on a drip to pass in _HOURS hours": " on a drip to pass in _HOURS hours",
        " and _MINUTES minute": " and _MINUTES minute",
        " and _MINUTES minutes": " and _MINUTES minutes",
        " with oxygen during _HOURS hour": " with oxygen during _HOURS hour",
        " with oxygen during _HOURS hours": " with oxygen during _HOURS hours",
        " and _MINUTES minute per day": " and _MINUTES minute per day",
        " and _MINUTES minutes per day": " and _MINUTES minutes per day",
        " each day": " per day",
        " each _FREQUENCY days": " each _FREQUENCY days",
        " before week days ": " on ",
        "week_day_separator": ", ",
        " each week": " each week",
        " each _FREQUENCY weeks": " each _FREQUENCY weeks",
        ", on this date ": ", on this date ",
        ", on these dates ": ", on these dates ",
        ", from _START_DATE": ", from _START_DATE",
        " for an undetermined duration": " for an undetermined duration",
        " for _DURATION days": " for _DURATION days",
        " until _END_DATE": " until _END_DATE",
        " only if ": " only if ",
        ".": ".",
        " and": " and",
        " and renew ": " and renew ",
        " Proceed": " Proceed",
        " eventually _QUANTITY _UNIT": " eventually _QUANTITY _UNIT",
        " Do not take more than _QUANTITY(pl) _UNIT on a day.": " Do not take more than _QUANTITY _UNIT on a day.",
        " Do not take more than _QUANTITY _UNIT on a day.": " Do not take more than _QUANTITY _UNIT on a day.",
        "Any day ": "Any day, ",
        "once a week": "once a week",
        "twice a week": "twice a week",
        "three times a week": "three times a week",
        "four times a week": "four times a week",
        "five times a week": "five times a week",
        "six times a week": "six times a week",
        "seven times a week": "seven times a week"
      }
    },
    geti18n: function(str, lang) {
      var self;
      self = this;
      return self.posologySentenceI18n[lang][str];
    },
    formatInt: function(number, lang, useWrittenForm) {
      var self;
      self = this;
      if (!useWrittenForm) {
        return number.toLocaleString(lang);
      }
      return window.writtenNumber(number, {
        lang: lang
      });
    },
    formatFloat: function(number, lang, useWrittenForm, separator) {
      var decimals, decimalsString, floatNumber, floor, self, val;
      self = this;
      floatNumber = parseFloat(number);
      if (!useWrittenForm) {
        return floatNumber.toLocaleString(lang, {
          maximumFractionDigits: 10
        });
      }
      floor = Math.floor(floatNumber);
      if (floor === floatNumber) {
        val = window.writtenNumber(floatNumber, {
          lang: lang
        });
        return val;
      }
      if (!separator) {
        separator = self.geti18n('literal_float_separator', lang);
      }
      decimals = (floatNumber + "").split(".")[1];
      decimalsString = "";
      while (decimals[0] === "0") {
        decimals = decimals.substr(1);
        decimalsString += window.writtenNumber("0", {
          lang: lang
        }) + " ";
      }
      if (decimals.length > 0) {
        decimalsString += window.writtenNumber(decimals, {
          lang: lang
        });
        return '_FLOOR _SEP _DEC'.replace(/_FLOOR/g, window.writtenNumber(floor, {
          lang: lang
        })).replace(/_SEP/g, separator).replace(/_DEC/g, decimalsString);
      } else {
        return window.writtenNumber(floatNumber, {
          lang: lang
        });
      }
    },
    formatDate: function(inputDate, lang, useWrittenForm) {
      var date_format, day, formats, months, self;
      self = this;
      formats = {
        fr: 'DD/MM/YYYY',
        fr_BE: 'DD/MM/YYYY',
        en: 'MM/DD/YYYY',
        en_US: 'MM/DD/YYYY',
        en_UK: 'MM/DD/YYYY',
        es: 'DD/MM/YYYY'
      };
      date_format = 'YYYY-MM-DD';
      if (indexOf.call(Object.keys(formats), lang) >= 0) {
        date_format = formats[lang];
      }
      if (!useWrittenForm) {
        return inputDate.format(date_format);
      }
      months = {
        1: self.geti18n('january', lang),
        2: self.geti18n('february', lang),
        3: self.geti18n('march', lang),
        4: self.geti18n('april', lang),
        5: self.geti18n('may', lang),
        6: self.geti18n('june', lang),
        7: self.geti18n('july', lang),
        8: self.geti18n('august', lang),
        9: self.geti18n('september', lang),
        10: self.geti18n('october', lang),
        11: self.geti18n('november', lang),
        12: self.geti18n('december', lang)
      };
      day = window.writtenNumber(inputDate.date(), {
        lang: lang
      });
      if (day === 'un' && self.language_code === 'fr') {
        day = 'premier';
      }
      return self.geti18n('_DAY of _MONTH, _YEAR', lang).replace(/_DAY/g, day).replace(/_MONTH/g, months[inputDate.month() + 1]).replace(/_YEAR/g, window.writtenNumber(inputDate.year(), {
        lang: lang
      }));
    },
    formatString: function(inputStr) {
      if (!inputStr) {
        return '';
      }
      return inputStr;
    },
    capitalizeFirstLetter: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getIMAGESentence: function(prescription, quantity_rate, lang, written_numbers) {
      var examen, examens, i, len, ref, self, sentences;
      self = this;
      sentences = [];
      examens = [];
      ref = prescription.data.examens;
      for (i = 0, len = ref.length; i < len; i++) {
        examen = ref[i];
        examens.push("<b>" + examen.label + "</b>" + (examen.extra_label ? ": " + examen.extra_label : ""));
      }
      sentences.push(examens.join(", "));
      sentences.push("<b>Compléments</b>: " + self.capitalizeFirstLetter(prescription.data.complements));
      sentences.push("<b>Motif</b>: " + self.capitalizeFirstLetter(prescription.data.reason));
      if (prescription.start_date) {
        sentences.push("Le " + self.formatDate(moment(prescription.start_date), lang, written_numbers));
      }
      return {
        "display_text": sentences.join(".<br>")
      };
    },
    getProductName: function(prescription, quantity_rate, lang, written_numbers) {
      var extra_class, presc_name, ref, ref1, ref2, self, sentence;
      self = this;
      extra_class = "";
      if ((prescription.data.bdm_data != null) && (prescription.data.bdm_data.inn != null) && prescription.data.bdm_data.inn.length > 0) {
        extra_class = "has-dci-name";
      }
      presc_name = prescription.data.name;
      if (prescription.data.numbers_to_texts && prescription.data.bdm_data.name_in_text) {
        presc_name = prescription.data.bdm_data.name_in_text;
      }
      sentence = "<span class='product-name " + extra_class + "'><b>" + (presc_name || "()") + "</b>/<span class='route-label'>" + (prescription.data.route.label || "()") + "</span><br></span>";
      if (((ref = prescription.data.bdm_data) != null ? ref.is_stupefiant : void 0) === '1') {
        sentence = "<i class='glyphicon product-alert text-warning glyphicon-warning-sign'></i>" + sentence;
      }
      if ((ref1 = prescription.data.bdm_data) != null ? ref1.is_high_risk : void 0) {
        sentence = "<b class='color-red'><i class='glyphicon product-alert glyphicon-warning-sign'></i>(MR) </b>" + sentence;
      }
      if (extra_class) {
        sentence += "<span class='dci-name'><b>" + (presc_name || "()") + "</b>" + "/" + (prescription.data.route.label || "()") + "<br></span>";
      }
      if (((ref2 = prescription.data.bdm_data) != null ? ref2.is_stupefiant : void 0) === '1') {
        sentence += "(<b>" + prescription.data.name + ")</b><br>";
      }
      return sentence;
    },
    getProductNameDCI: function(prescription, quantity_rate, lang, written_numbers) {
      var dci_name, extra_class, i, inn, len, ref, self, sentence;
      self = this;
      extra_class = "";
      if ((prescription.data.bdm_data != null) && (prescription.data.bdm_data.inn != null) && prescription.data.bdm_data.inn.length > 0) {
        dci_name = "";
        ref = prescription.data.bdm_data.inn;
        for (i = 0, len = ref.length; i < len; i++) {
          inn = ref[i];
          if (inn.translationFailCode && inn.translationFailCode !== 0) {
            return self.getProductName(prescription, quantity_rate, lang, written_numbers);
          }
          dci_name += "<br>" + inn.name;
        }
        sentence = "<span class='product-name " + extra_class + "'><b>" + (dci_name || "()") + "</b>/<span class='route-label'>" + (prescription.data.route.label || "()") + "</span><br></span>";
        if (extra_class) {
          sentence += "<span class='dci-name'><b>" + (dci_name || "()") + "</b>" + "/" + (prescription.data.route.label || "()") + "<br></span>";
        }
        return sentence;
      } else {
        return self.getProductName(prescription, quantity_rate, lang, written_numbers);
      }
    },
    getPCASentence: function(prescription, quantity_rate, lang, written_numbers) {
      var data, ff, plural_duration, plural_unit, productName, productNameDCI, self, sentence, sep, single_unit, singular_duration;
      self = this;
      single_unit = prescription.data.taking_unit.label || "";
      plural_unit = prescription.data.taking_unit.label_plural || single_unit;
      if (prescription.data.only_if && prescription.data.only_if.length > 0) {
        productName = "<b>Seulement si " + _.escape(prescription.data.only_if) + "<br></b>";
      } else {
        productName = "";
      }
      productName += self.getProductName(prescription, quantity_rate, lang, written_numbers);
      productNameDCI = self.getProductNameDCI(prescription, quantity_rate, lang, written_numbers);
      if (prescription.start_date) {
        sentence = self.geti18n("from ", lang) + self.formatDate(moment(prescription.start_date), lang, written_numbers);
      } else {
        sentence = "";
      }
      if (prescription.data.end_mode === 'undefined') {
        sentence += self.geti18n(' for an undetermined duration', lang);
      } else if (prescription.data.end_mode === 'duration') {
        singular_duration = ' for _DURATION day';
        plural_duration = ' for _DURATION days';
        if (prescription.duration > 1) {
          sentence += self.geti18n(plural_duration, lang).replace(/_DURATION/g, self.formatInt(prescription.duration, lang, written_numbers));
        } else {
          sentence += self.geti18n(singular_duration, lang).replace(/_DURATION/g, self.formatInt(prescription.duration, lang, written_numbers));
        }
      } else if (prescription.data.end_mode === 'date') {
        sentence += self.geti18n(' until _END_DATE', lang).replace(/_END_DATE/g, self.formatDate(moment(prescription.end_date), lang, written_numbers));
      }
      sentence += self.geti18n('.', lang);
      if (prescription.data.reeval_date) {
        sentence += " " + self.formatDate(moment(prescription.data.reeval_date), lang, written_numbers);
        sentence += self.geti18n('.', lang);
      }
      data = prescription.data;
      ff = self.formatFloat;
      sep = self.geti18n('literal_float_separator', lang);
      sentence += "<span class='pca-display-content'><br>";
      sentence += "<span class='pca-programation'><span class='title'>Programmation</span>: Débit Continu <span class='warning'>" + (ff(data.deb_continue, lang, written_numbers, sep)) + " " + single_unit + "/h;</span>";
      sentence += " Dose / Bolus <span class='warning'>" + (ff(data.dose_bolus, lang, written_numbers, sep)) + " " + single_unit + "</span>;";
      sentence += " Nombre maximum de bolus <span class='warning'>" + (ff(data.limite_bolus, lang, written_numbers)) + " / " + (ff(data.on_hours, lang, written_numbers, sep)) + " heure(s)</span>;";
      sentence += " Verrou Bolus <span class='warning'>" + (ff(data.verrou_bolus, lang, written_numbers, sep)) + " minutes</span>;";
      sentence += " Dose maximale théorique/jour  " + (ff(data.max_by_day, lang, written_numbers, sep)) + " " + single_unit + "/jour</span>";
      if (!data.without_preparation) {
        sentence += "<span class='pca-preparation'><br><span class='title'>Préparation</span>: <span class='bold'>" + (data.bdm_data.marketing_name || data.name) + "</span> en ampoule de <span class='bold'>" + (ff(data.prepatation_mg, lang, written_numbers, sep)) + " " + single_unit + " / " + (ff(data.prepatation_ml, lang, written_numbers, sep)) + " ml</span>;";
        sentence += " Nombre d’ampoule(s) <span class='warning'>" + (ff(data.bulb_number, lang, written_numbers, sep)) + "</span>;";
        sentence += " Volume total en antalgique de la poche : " + (ff(data.total_volume_analgesic, lang, written_numbers, sep)) + " ml;";
        sentence += " Dilution avec sérum physiologique à 0,9% : <span class='warning'>" + (ff(data.dilution_with, lang, written_numbers, sep)) + " ml</span>;";
        sentence += " Volume total par poche : " + (ff(data.total_volume_by_pocket, lang, written_numbers, sep)) + " ml;";
        sentence += " Concentration après dilution : <span class='warning'>" + (ff(data.concentration_after_dilution, lang, written_numbers, sep)) + " " + single_unit + "/ml</span></span>";
      }
      sentence += "</span>";
      if (prescription.data.comment) {
        sentence += "<span class='title'>. Commentaires</span>:<span class='bold'>" + self.capitalizeFirstLetter(_.escape(prescription.data.comment)) + "</span>";
      }
      return {
        posology: sentence,
        display_text: "<span class='prescription-pca'>" + productName + sentence + "</span>",
        dci_display_text: "<span class='prescription-pca'>" + productNameDCI + sentence + "</span>"
      };
    },
    getBIOLOGICSentence: function(prescription, quantity_rate, lang, written_numbers) {
      var date_info, i, label, len, ref, self, sentences;
      self = this;
      sentences = [];
      ref = Object.keys(prescription.data.biologic_info).sort();
      for (i = 0, len = ref.length; i < len; i++) {
        label = ref[i];
        sentences.push("<b>" + label + "</b>: " + prescription.data.biologic_info[label].join(", "));
      }
      prescription.data.name = sentences.join(". ");
      if (prescription.start_date) {
        date_info = "Le " + self.formatDate(moment(prescription.start_date), lang, written_numbers) + ".";
      } else {
        date_info = "";
      }
      if (prescription.data.comment) {
        sentences.push(date_info + " " + self.capitalizeFirstLetter(_.escape(prescription.data.comment)));
      } else {
        sentences.push(date_info);
      }
      return {
        "display_text": sentences.join(".<br>")
      };
    },
    getLABORATORYSentence: function(prescription, quantity_rate, lang, written_numbers) {
      var genSentence, groupIn, groupedLabels, posology, self, sentences, the_txt;
      self = this;
      sentences = [];
      genSentence = function(groupLabel, level) {
        var label;
        label = groupLabel.label;
        if (level === 0) {
          label = "<b><u>" + groupLabel.label + "</u></b>:";
        } else if (level === 1) {
          label = "<b>" + groupLabel.label + "</b>";
        } else if (level === 2) {
          label = "&nbsp;&nbsp; -" + groupLabel.label;
        } else {
          label = "&nbsp;&nbsp;&nbsp;&nbsp; -" + groupLabel.label;
        }
        return _.concat([label], _.map(groupLabel.entries, function(entry) {
          return genSentence(entry, level + 1);
        })).join("<br>");
      };
      groupedLabels = [];
      groupIn = function(groupedLabels, labels) {
        var group;
        if (labels.length > 0) {
          group = _.find(groupedLabels, {
            label: labels[0]
          });
          if (!group) {
            group = {
              label: labels[0],
              entries: []
            };
            groupedLabels.push(group);
          }
          return groupIn(group.entries, labels.slice(1));
        }
      };
      _.forEach(_.map(prescription.data.laboratory_info, "labels"), function(labels) {
        return groupIn(groupedLabels, labels);
      });
      sentences = _.map(groupedLabels, function(groupLabel) {
        return genSentence(groupLabel, 0);
      });
      if (prescription.data.type != null) {
        posology = self.capitalizeFirstLetter(self.getPosologySentence(prescription, quantity_rate, lang, written_numbers).trim());
      } else {
        the_txt = self.geti18n("The", lang);
        posology = the_txt + " " + self.formatDate(moment(prescription.start_date), lang, written_numbers);
      }
      if (prescription.data.comment) {
        sentences.push(posology + ". " + self.capitalizeFirstLetter(_.escape(prescription.data.comment)));
      } else {
        sentences.push(posology);
      }
      prescription.data.name = _.map(prescription.data.laboratory_info, function(laboInfo) {
        return laboInfo.labels[laboInfo.labels.length - 1];
      }).join(", ");
      return {
        "display_text": sentences.join(".<br>")
      };
    },
    getCARESentence: function(prescription, quantity_rate, lang, written_numbers) {
      var label, posology, self, sentences;
      self = this;
      sentences = [];
      for (label in prescription.data.cares) {
        sentences.push("<b>" + label + "</b>: " + prescription.data.cares[label].join(", "));
      }
      if (prescription.data.type != null) {
        posology = self.capitalizeFirstLetter(self.getPosologySentence(prescription, quantity_rate, lang, written_numbers));
      } else {
        posology = "Le " + self.formatDate(moment(prescription.start_date), lang, written_numbers);
      }
      if (prescription.data.comment) {
        sentences.push(posology + ". " + self.capitalizeFirstLetter(_.escape(prescription.data.comment)));
      } else {
        sentences.push(posology);
      }
      return {
        "display_text": sentences.join(".<br>")
      };
    },
    getPAPSentence: function(prescription, timeSlots, quantity_rate, lang, written_numbers) {
      var self, sentence, sentence_dict, to_renew_if;
      self = this;
      sentence = "<b>Seulement si " + (_.escape(prescription.data.only_if || "()")) + "<br></b>";
      sentence_dict = self.getTraitementSentence(prescription, timeSlots, quantity_rate, lang, written_numbers);
      to_renew_if = "";
      if (prescription.data.renew_after) {
        to_renew_if += self.geti18n(' To renew if necessary after ', lang);
        to_renew_if += _.escape(prescription.data.renew_after) + ".";
      }
      return {
        posology: sentence_dict.posology,
        productName: sentence + sentence_dict.productName,
        display_text: sentence + sentence_dict.display_text + to_renew_if,
        dci_display_text: sentence + sentence_dict.dci_display_text + to_renew_if
      };
    },
    getPosologySentence: function(prescription, quantity_rate, lang, useWrittenForm) {
      var date, formattedDates, i, j, last, len, len1, plural_duration, ref, ref1, self, sentence, singular_duration, week_days, week_days_strings, weekday;
      self = this;
      sentence = "";
      week_days_strings = {
        0: self.geti18n('pl_monday', lang),
        1: self.geti18n('pl_tuesday', lang),
        2: self.geti18n('pl_wednesday', lang),
        3: self.geti18n('pl_thursday', lang),
        4: self.geti18n('pl_friday', lang),
        5: self.geti18n('pl_saturday', lang),
        6: self.geti18n('pl_sunday', lang)
      };
      week_days = [];
      if (prescription.data.week_days) {
        ref = prescription.data.week_days.sort();
        for (i = 0, len = ref.length; i < len; i++) {
          weekday = ref[i];
          week_days.push(week_days_strings[weekday]);
        }
      }
      if (prescription.data.type === 'cycled') {
        if (prescription.data.frequency_unit === 'days') {
          if (prescription.data.frequency === 1) {
            sentence += self.geti18n(' everyday', lang);
          } else {
            sentence += self.geti18n(' each _FREQUENCY days', lang).replace(/_FREQUENCY/g, self.formatInt(prescription.data.frequency, lang, useWrittenForm));
          }
        } else {
          sentence += ",";
          if (week_days.length > 1) {
            last = week_days.pop();
            sentence += " " + week_days.join(self.geti18n('week_day_separator', lang)) + self.geti18n(' and', lang) + " " + last;
          } else {
            sentence += " " + week_days.join(self.geti18n('week_day_separator', lang));
          }
          sentence += ",";
          if (prescription.data.frequency === 1) {
            sentence += self.geti18n(' each week', lang);
          } else {
            sentence += self.geti18n(' each _FREQUENCY weeks', lang).replace(/_FREQUENCY/g, self.formatInt(prescription.data.frequency, lang, useWrittenForm));
          }
        }
      }
      if (prescription.data.type === "dates") {
        if (prescription.data.dates) {
          if (prescription.data.dates.length < 2) {
            sentence += " " + self.geti18n(', on this date ', lang);
          } else {
            sentence += " " + self.geti18n(', on these dates ', lang);
          }
        }
        formattedDates = [];
        if (prescription.data.dates) {
          prescription.data.dates.sort(function(left, right) {
            return moment(left).diff(moment(right));
          });
          ref1 = prescription.data.dates;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            date = ref1[j];
            formattedDates.push(self.formatDate(moment(date), lang, useWrittenForm));
          }
        }
        sentence += formattedDates.join(', ');
      } else {
        if (prescription.start_date) {
          sentence += self.geti18n(', from _START_DATE', lang).replace(/_START_DATE/g, moment(prescription.start_date).format("dddd ll"));
        }
        if (prescription.data.end_mode === 'undefined') {
          sentence += self.geti18n(' for an undetermined duration', lang);
        } else if (prescription.data.end_mode === 'duration') {
          singular_duration = ' for _DURATION day';
          plural_duration = ' for _DURATION days';
          if (prescription.duration > 1) {
            sentence += self.geti18n(plural_duration, lang).replace(/_DURATION/g, self.formatInt(prescription.duration, lang, useWrittenForm));
          } else {
            sentence += self.geti18n(singular_duration, lang).replace(/_DURATION/g, self.formatInt(prescription.duration, lang, useWrittenForm));
          }
        } else if (prescription.data.end_mode === 'date') {
          sentence += self.geti18n(' until _END_DATE', lang).replace(/_END_DATE/g, moment(prescription.end_date).format("dddd ll"));
        }
      }
      return sentence;
    },
    getTraitementSentence: function(prescription, timeSlots, quantity_rate, lang, written_numbers) {
      var daily_quantity, default_label_timeslots, drip_hours, drip_minutes, i, key, len, max_quantity, oxygen_hours, oxygen_minutes, plural_unit, productName, productNameDCI, quantityRate, self, sentence, single_unit, timeSlot, time_slot, to_add, total_quantity, useWrittenForm, value, with_drip, with_oxygen;
      self = this;
      lang = lang || self.language_code;
      useWrittenForm = written_numbers || false;
      quantityRate = quantity_rate || 1.0;
      productName = self.getProductName(prescription, quantity_rate, lang, written_numbers);
      productNameDCI = self.getProductNameDCI(prescription, quantity_rate, lang, written_numbers);
      sentence = "";
      default_label_timeslots = {
        Mt: "le matin",
        M: "le midi",
        AM: "l'après midi",
        S: "le soir",
        C: "au coucher",
        N: "la nuit"
      };
      total_quantity = 0.0;
      single_unit = prescription.data.taking_unit.label || "";
      plural_unit = prescription.data.taking_unit.label_plural || single_unit;
      single_unit = "<span class='taking-unit'>" + single_unit + "</span>";
      plural_unit = "<span class='taking-unit'>" + plural_unit + "</span>";
      if (prescription.data.takes === "slots" || (prescription.data.takes == null)) {
        for (i = 0, len = timeSlots.length; i < len; i++) {
          timeSlot = timeSlots[i];
          key = timeSlot.short_label;
          if (prescription.data.quantity_by_timeslot[key] != null) {
            value = prescription.data.quantity_by_timeslot[key] * quantityRate;
            if (value > 0) {
              total_quantity += value;
              if (timeSlot.data.sentence_label && timeSlot.data.sentence_label.length > 0) {
                time_slot = self.formatString(timeSlot.data.sentence_label);
              } else {
                time_slot = self.formatString(default_label_timeslots[key]);
              }
              if ((prescription.data.custom_timeslots != null) && prescription.data.custom_timeslots[key]) {
                time_slot += " (" + prescription.data.custom_timeslots[key] + ")";
              }
              sentence += self.geti18n(' _QUANTITY _UNIT on _TIMESLOT,', lang).replace(/_QUANTITY/g, self.formatFloat(value, lang, useWrittenForm)).replace(/_UNIT/g, self.formatString(value > 1 ? plural_unit : single_unit)).replace(/_TIMESLOT/g, self.formatString(time_slot));
              if ((prescription.data.custom_timeslots != null) && prescription.data.custom_timeslots[key]) {
                sentence;
              }
            }
          }
        }
      } else if (prescription.data.takes === "intervals") {
        total_quantity = prescription.data.daily_quantity * quantityRate;
        sentence += self.geti18n(' _QUANTITY _UNIT all_the _INTERVAL hours,', lang).replace(/_QUANTITY/g, self.formatFloat(prescription.data.interval_quantity * quantityRate, lang, useWrittenForm)).replace(/_UNIT/g, self.formatString(prescription.data.interval_quantity * quantityRate > 1 ? plural_unit : single_unit)).replace(/_INTERVAL/g, self.formatFloat(prescription.data.interval));
      } else if (prescription.data.takes === "debit") {
        sentence += self.geti18n(' _QUANTITY _UNIT/_INTERVAL', lang).replace(/_QUANTITY/g, self.formatFloat(prescription.data.debit_unit * quantityRate, lang, useWrittenForm)).replace(/_UNIT/g, self.formatString(prescription.data.debit_unit * quantityRate > 1 ? plural_unit : single_unit)).replace(/_INTERVAL/g, self.geti18n(prescription.data.debit_interval, lang));
      } else {
        sentence += "";
      }
      if (total_quantity > 0) {
        sentence += self.geti18n(' a total of _QUANTITY _UNIT per day', lang).replace(/_QUANTITY/g, self.formatFloat(total_quantity, lang, useWrittenForm)).replace(/_UNIT/g, self.formatString(total_quantity > 1 ? plural_unit : single_unit));
      } else if (prescription.data.daily_quantity > 0) {
        daily_quantity = prescription.data.daily_quantity * quantityRate;
        sentence += self.geti18n(' _QUANTITY _UNIT per day', lang).replace(/_QUANTITY/g, self.formatFloat(daily_quantity, lang, useWrittenForm)).replace(/_UNIT/g, self.formatString(daily_quantity > 1 ? plural_unit : single_unit));
      }
      sentence += self.getPosologySentence(prescription, quantity_rate, lang, written_numbers);
      sentence += self.geti18n('.', lang);
      to_add = '';
      with_drip = prescription.data.with_drip && prescription.category.properties.with_drip;
      drip_hours = prescription.data["drip_hours"];
      drip_minutes = prescription.data["drip_minutes"];
      with_oxygen = prescription.data.with_oxygen && prescription.category.properties.with_oxygen;
      oxygen_hours = prescription.data["oxygen_hours"];
      oxygen_minutes = prescription.data["oxygen_minutes"];
      if (with_drip || with_oxygen) {
        if (with_drip) {
          if (drip_hours <= 1) {
            to_add = self.geti18n(' on a drip to pass in _HOURS hour', lang);
          } else {
            to_add = self.geti18n(' on a drip to pass in _HOURS hours', lang);
          }
          if (drip_minutes === 1) {
            to_add += self.geti18n(' and _MINUTES minute', lang);
          } else if (drip_minutes > 1) {
            to_add += self.geti18n(' and _MINUTES minutes', lang);
          }
          sentence += to_add.replace(/_HOURS/g, self.formatInt(drip_hours, lang, useWrittenForm)).replace(/_MINUTES/g, self.formatInt(drip_minutes, lang, useWrittenForm));
          to_add = '';
        }
        if (with_oxygen) {
          if (with_drip) {
            sentence += self.geti18n('.', lang);
          }
          if (oxygen_hours <= 1) {
            to_add = self.geti18n(' with oxygen during _HOURS hour', lang);
          } else {
            to_add = self.geti18n(' with oxygen during _HOURS hours', lang);
          }
          if (oxygen_minutes === 1) {
            to_add += self.geti18n(' and _MINUTES minute', lang);
          } else if (oxygen_minutes > 1) {
            to_add += self.geti18n(' and _MINUTES minutes', lang);
          }
          to_add += self.geti18n(' each day', lang);
          sentence += to_add.replace(/_HOURS/g, self.formatInt(oxygen_hours, lang, useWrittenForm)).replace(/_MINUTES/g, self.formatInt(oxygen_minutes, lang, useWrittenForm));
        }
        sentence += self.geti18n('.', lang);
      }
      if (prescription.data.takes !== "debit" && prescription.data.max_quantity > 0) {
        max_quantity = prescription.data.max_quantity * quantityRate;
        sentence += self.geti18n(' Do not take more than _QUANTITY(pl) _UNIT on a day.', lang).replace(/_QUANTITY/g, self.formatFloat(max_quantity, lang, useWrittenForm)).replace(/_UNIT/g, self.formatString(max_quantity > 1 ? plural_unit : single_unit));
      }
      if (prescription.data.comment) {
        sentence += "\n" + self.capitalizeFirstLetter(_.escape(prescription.data.comment));
      }
      return {
        posology: sentence,
        productName: productName,
        display_text: productName + sentence,
        dci_display_text: productNameDCI + sentence
      };
    },
    getSequenceSentence: function(prescription, lang) {
      var date, formattedDates, i, j, last, len, len1, plural_duration, ref, ref1, self, sentence, singular_duration, slotSentence, slots, times_a_week_strings, useWrittenForm, week_days, week_days_strings, weekday;
      self = this;
      useWrittenForm = false;
      sentence = "";
      week_days_strings = {
        0: self.geti18n('pl_monday', lang),
        1: self.geti18n('pl_tuesday', lang),
        2: self.geti18n('pl_wednesday', lang),
        3: self.geti18n('pl_thursday', lang),
        4: self.geti18n('pl_friday', lang),
        5: self.geti18n('pl_saturday', lang),
        6: self.geti18n('pl_sunday', lang)
      };
      times_a_week_strings = {
        1: self.geti18n("once a week", lang),
        2: self.geti18n("twice a week", lang),
        3: self.geti18n("three times a week", lang),
        4: self.geti18n("four times a week", lang),
        5: self.geti18n("five times a week", lang),
        6: self.geti18n("six times a week", lang),
        7: self.geti18n("seven times a week", lang)
      };
      week_days = [];
      if (prescription.planning_data.week_days) {
        ref = prescription.planning_data.week_days.sort();
        for (i = 0, len = ref.length; i < len; i++) {
          weekday = ref[i];
          week_days.push(week_days_strings[weekday]);
        }
      }
      if (prescription.planning_data.type === 'cycled') {
        if (prescription.planning_data.frequency_unit === 'days') {
          if (prescription.planning_data.frequency === 1) {
            sentence += self.geti18n(' everyday', lang);
          } else {
            sentence += self.geti18n(' each _FREQUENCY days', lang).replace(/_FREQUENCY/g, self.formatInt(prescription.planning_data.frequency, lang, useWrittenForm));
          }
        } else {
          if (week_days.length > 1) {
            last = week_days.pop();
            sentence += week_days.join(self.geti18n('week_day_separator', lang)) + self.geti18n(' and', lang) + " " + last;
          } else {
            sentence += week_days.join(self.geti18n('week_day_separator', lang));
          }
          sentence += ",";
          if (prescription.planning_data.frequency === 1) {
            sentence += self.geti18n(' each week', lang);
          } else {
            sentence += self.geti18n(' each _FREQUENCY weeks', lang).replace(/_FREQUENCY/g, self.formatInt(prescription.planning_data.frequency, lang, useWrittenForm));
          }
        }
      }
      if (prescription.planning_data.type === 'floating') {
        sentence += self.geti18n('Any day ', lang);
        sentence += times_a_week_strings[prescription.planning_data.quantity];
      }
      slots = prescription.planning_data.timeslots[0];
      if (slots.end_time === slots.start_time) {
        slotSentence = "à " + slots.start_time;
      } else {
        slotSentence = "entre " + slots.start_time + " et " + slots.end_time;
      }
      if (prescription.planning_data.type === "dates") {
        sentence += slotSentence;
        if (prescription.planning_data.dates) {
          if (prescription.planning_data.dates.length < 2) {
            sentence += " " + self.geti18n(', on this date ', lang);
          } else {
            sentence += " " + self.geti18n(', on these dates ', lang);
          }
        }
        formattedDates = [];
        if (prescription.planning_data.dates) {
          ref1 = prescription.planning_data.dates.sort();
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            date = ref1[j];
            formattedDates.push(moment(date).format("dddd ll"));
          }
        }
        sentence += formattedDates.join(', ');
      } else {
        sentence += ", " + slotSentence;
        if (prescription.planning_data.start_date) {
          sentence += self.geti18n(', from _START_DATE', lang).replace(/_START_DATE/g, moment(prescription.planning_data.start_date).format("dddd ll"));
        }
        if (prescription.planning_data.end_mode === 'undefined') {
          sentence += self.geti18n(' for an undetermined duration', lang);
        } else if (prescription.planning_data.end_mode === 'duration') {
          singular_duration = ' for _DURATION day';
          plural_duration = ' for _DURATION days';
          if (prescription.planning_data.duration > 1) {
            sentence += self.geti18n(plural_duration, lang).replace(/_DURATION/g, self.formatInt(prescription.planning_data.duration, lang, useWrittenForm));
          } else {
            sentence += self.geti18n(singular_duration, lang).replace(/_DURATION/g, self.formatInt(prescription.planning_data.duration, lang, useWrittenForm));
          }
        } else if (prescription.planning_data.end_mode === 'date') {
          sentence += self.geti18n(' until _END_DATE', lang).replace(/_END_DATE/g, moment(prescription.planning_data.end_date).format("dddd ll"));
        }
      }
      sentence += ".";
      if (prescription.data.comment) {
        sentence += "\n" + self.capitalizeFirstLetter(_.escape(prescription.data.comment));
      }
      return [self.capitalizeFirstLetter(prescription.data.name), self.capitalizeFirstLetter(sentence.trimStart())].join(". ");
    },
    croppedPrescriptionSentence: function(prescription, quantity_rate, lang, written_numbers) {
      var plural_duration, quantityRate, self, sentence, singular_duration, useWrittenForm;
      self = this;
      lang = lang || self.language_code;
      useWrittenForm = written_numbers || false;
      quantityRate = quantity_rate || 1.0;
      if (prescription.start_date) {
        sentence = self.geti18n("From ", lang) + self.formatDate(moment(prescription.start_date), lang, written_numbers);
        if (prescription.data.end_mode === 'duration' && prescription.duration) {
          singular_duration = ' for _DURATION day';
          plural_duration = ' for _DURATION days';
          if (prescription.duration > 1) {
            return sentence += self.geti18n(plural_duration, lang).replace(/_DURATION/g, prescription.duration);
          } else {
            return sentence += self.geti18n(singular_duration, lang).replace(/_DURATION/g, prescription.duration);
          }
        } else if (prescription.data.end_mode === 'undefined') {
          return sentence += self.geti18n(' for an undetermined duration', lang);
        } else if (prescription.data.end_mode === 'date' && prescription.end_date) {
          return sentence += self.geti18n(' until _END_DATE', lang).replace(/_END_DATE/g, moment(prescription.end_date).format("dddd D MMMM YYYY"));
        } else {
          return "";
        }
      } else {
        return "";
      }
    }
  };

  if (!window.writtenNumber) {
    1;
  }

  if (window.angular) {
    angular.module('mhclientApp').filter('croppedPrescriptionSentence', function() {
      return function(prescription, quantity_rate, lang, written_numbers) {
        return window.posologySentenceGenerator.croppedPrescriptionSentence(prescription, quantity_rate, lang, prescription.data.numbers_to_texts);
      };
    }).filter('PrescriptionDisplayText', function() {
      return function(prescription, timeSlots, quantity_rate, lang, written_numbers, dci) {
        if (!prescription.category) {
          return "";
        }
        lang = lang || 'fr';
        if (prescription.category.name === "BIOLOGIC") {
          return window.posologySentenceGenerator.getBIOLOGICSentence(prescription, quantity_rate, lang, prescription.data.numbers_to_texts);
        }
        if (prescription.category.name === "LABORATORY") {
          return window.posologySentenceGenerator.getLABORATORYSentence(prescription, quantity_rate, lang, prescription.data.numbers_to_texts);
        }
        if (prescription.category.name === "NEW_CARE") {
          return window.posologySentenceGenerator.getCARESentence(prescription, quantity_rate, lang, prescription.data.numbers_to_texts);
        }
        if (prescription.category.name === "IMAGE") {
          return window.posologySentenceGenerator.getIMAGESentence(prescription, quantity_rate, lang, prescription.data.numbers_to_texts);
        }
        if (prescription.category.name === "PCA") {
          return window.posologySentenceGenerator.getPCASentence(prescription, quantity_rate, lang, prescription.data.numbers_to_texts);
        }
        if (prescription.category.name === "PAP") {
          return window.posologySentenceGenerator.getPAPSentence(prescription, timeSlots, quantity_rate, lang, prescription.data.numbers_to_texts);
        } else {
          return window.posologySentenceGenerator.getTraitementSentence(prescription, timeSlots, quantity_rate, lang, prescription.data.numbers_to_texts);
        }
      };
    }).filter('SequenceDisplayText', function() {
      return function(sequence, lang) {
        lang = lang || 'fr';
        return window.posologySentenceGenerator.getSequenceSentence(sequence, lang);
      };
    }).controller('');
  }

}).call(this);

//# sourceMappingURL=generate-sentence.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider: AttachmentCtrl
    * @description
    * # AttachmentCtrl
    * TODO: find an accurate description
   */
  angular.module("mhclientApp").controller('AttachmentCtrl', ["$scope", "$filter", "$uibModalInstance", "ImageDocument", "imageDocument", "UserORPCreation", "UserUtils", "$rootScope", function($scope, $filter, $uibModalInstance, ImageDocument, imageDocument, UserORPCreation, UserUtils, $rootScope) {
    var keep_data, keep_stakeholder;
    $scope.imageDocument = imageDocument;
    $scope.creating_user = false;
    $scope.show_error = false;
    keep_stakeholder = $scope.imageDocument.stakeholder;
    keep_data = angular.copy($scope.imageDocument.data);
    $scope.getUsers = function(filter) {
      return UserUtils.getUsers().then(function(users) {
        var prescriptors;
        prescriptors = _.filter(users, function(user) {
          return user.group.features.indexOf("PRESC_CART_VALIDATION") !== -1;
        });
        return $filter('filter')(prescriptors, {
          "full_name": filter
        });
      });
    };
    $scope.yes = function() {
      return ImageDocument.api.update({
        id: $scope.imageDocument.id
      }, {
        id: $scope.imageDocument.id,
        stakeholder: $scope.imageDocument.stakeholder.id,
        data: imageDocument.data
      }).$promise.then(function() {
        return $uibModalInstance.close(true);
      });
    };
    $scope.genUser = function(last_name, first_name) {
      var new_user;
      new_user = {
        last_name: last_name,
        first_name: first_name,
        for_attachment: true,
        entity: $rootScope.currentStay.entity
      };
      return UserORPCreation.save(new_user).$promise.then((function(user) {
        $scope.imageDocument.stakeholder = user;
        $scope.creating_user = false;
        $scope.show_error = false;
        last_name = null;
        return first_name = null;
      }), function(error) {
        return $scope.show_error = true;
      });
    };
    $scope.formatUser = function(user) {
      var text;
      if (!user) {
        return '';
      }
      text = user.full_name;
      if (!user.is_active) {
        text += ' ⚠️ (' + $filter('translate')('INACTIVE') + ')';
      }
      return text;
    };
    return $scope.cancel = function() {
      $scope.imageDocument.stakeholder = keep_stakeholder;
      $scope.imageDocument.data = keep_data;
      return $uibModalInstance.close(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=attachment-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PrescriptionTemplatesCtrl
    * @description
    * # PrescriptionTemplatesCtrl
    * Controller to create new prescription from pre-saved templates
   */
  angular.module('mhclientApp').controller('PrescriptionTemplatesCtrl', ["$scope", "$rootScope", "$state", "MhConfig", "HighCostDrugsUtils", "PrescTemplate", "PrescTemplateCategory", "$q", "PrescUtils", "Ordonnance", "Prescription", "notify", "$filter", "GenUID", "moment", "Medicaldb", "$sce", "$uibModal", function($scope, $rootScope, $state, MhConfig, HighCostDrugsUtils, PrescTemplate, PrescTemplateCategory, $q, PrescUtils, Ordonnance, Prescription, notify, $filter, GenUID, moment, Medicaldb, $sce, $uibModal) {
    var formatTemplate, watchCallback;
    $scope.globalExpanded = false;
    $scope.toggleAll = function() {
      $scope.globalExpanded = !$scope.globalExpanded;
      return _.forEach($scope.prescriptionTemplateCategories, function(prescriptionTemplateCategory) {
        prescriptionTemplateCategory.expanded = $scope.globalExpanded;
      });
    };
    $scope.addUpdateCategory = function(category) {
      $scope.templateCategoryLabel = category ? category.label : "";
      $scope.templateCategoryOrder = category ? category.order : null;
      return $uibModal.open({
        animation: true,
        templateUrl: 'medication/views/modal-template-category.html',
        size: "lg",
        scope: $scope
      }).result.then(function(result) {
        $rootScope.busy = true;
        if (category) {
          category.label = result.label;
          category.order = result.order;
          return PrescTemplateCategory.api.update({
            id: category.id,
            label: category.label,
            order: category.order
          }).$promise.then(function() {
            return $rootScope.busy = false;
          });
        } else {
          return PrescTemplateCategory.api.save({
            label: result.label,
            order: result.order
          }).$promise.then(function(category) {
            category.prescriptions = [];
            category.groupedPrescriptions = [];
            $scope.prescriptionTemplateCategories.push(category);
            return $rootScope.busy = false;
          });
        }
      });
    };
    $scope.removeCategory = function(category) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "sm",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("CONFIRM_REMOVE");
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          }
        }
      });
      return confirm_dialog.result.then(function(result) {
        if (result) {
          return PrescTemplateCategory.api["delete"]({
            id: category.id
          }).$promise.then(function() {
            _.remove($scope.prescriptionTemplateCategories, category);
            return $rootScope.busy = false;
          });
        }
      });
    };
    $scope.removeTemplate = function(templatePrescription, category) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "sm",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("CONFIRM_REMOVE");
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          }
        }
      });
      return confirm_dialog.result.then(function(result) {
        if (result) {
          $rootScope.busy = true;
          return PrescTemplate.api["delete"]({
            id: templatePrescription.id
          }).$promise.then(function() {
            _.remove(category.prescriptions, templatePrescription);
            category.groupedPrescriptions = PrescUtils.groupPrescriptions(category.prescriptions);
            return $rootScope.busy = false;
          });
        }
      });
    };
    $scope.createTemplateCategory = function(template_category_label) {
      $rootScope.busy = true;
      return PrescTemplateCategory.api.save({
        label: template_category_label
      }).$promise.then(function(template_category) {
        template_category.displayedTemplates = [];
        $scope.presctemplatecategories.push(template_category);
        $scope.categories_dict[template_category.id] = template_category;
        return $rootScope.busy = false;
      });
    };
    $scope.selectedPrescriptions = [];
    $scope.groupedSelectedPrescriptions = [];
    $scope.removePrescTemplate = function(prescriptionTemplate) {
      var category;
      _.remove($scope.selectedPrescriptions, prescriptionTemplate);
      category = _.find($scope.prescriptionTemplateCategories, {
        id: prescriptionTemplate.template_category
      });
      if (category) {
        category.prescriptions.push(prescriptionTemplate.beforeModif);
        category.groupedPrescriptions = PrescUtils.groupPrescriptions(category.prescriptions);
      }
      return $scope.groupedSelectedPrescriptions = PrescUtils.groupPrescriptions($scope.selectedPrescriptions);
    };
    $scope.addCategory = function(category) {
      _.forEach(category.prescriptions, function(prescription) {
        $scope.selectedPrescriptions.push(prescription);
        prescription.beforeModif = _.cloneDeep(prescription);
        prescription.start_date = moment().format('YYYY-MM-DD');
        return prescription.quantityRate = 1;
      });
      category.prescriptions = [];
      category.groupedPrescriptions = PrescUtils.groupPrescriptions(category.prescriptions);
      return $scope.groupedSelectedPrescriptions = PrescUtils.groupPrescriptions($scope.selectedPrescriptions);
    };
    $scope.addPrescTemplates = function(prescriptions, category) {
      _.forEach(prescriptions, function(prescription) {
        _.remove(category.prescriptions, prescription);
        $scope.selectedPrescriptions.push(prescription);
        prescription.beforeModif = _.cloneDeep(prescription);
        prescription.start_date = moment().format('YYYY-MM-DD');
        prescription.quantityRate = 1;
        return prescription;
      });
      category.groupedPrescriptions = PrescUtils.groupPrescriptions(category.prescriptions);
      return $scope.groupedSelectedPrescriptions = PrescUtils.groupPrescriptions($scope.selectedPrescriptions);
    };
    formatTemplate = function(prescription) {
      var error, error1, prescriptionDisplayDict;
      if (prescription.data.end_mode === 'duration') {
        prescription.end_date = (moment(prescription.start_date).add(prescription.duration - 1, 'days')).format("YYYY-MM-DD");
      } else if (prescription.data.end_mode === 'date') {
        prescription.duration = Math.round(moment.duration(moment(prescription.end_date) - moment(prescription.start_date)).asDays() + 1);
        prescription.end_date = moment(prescription.end_date).format("YYYY-MM-DD");
      } else {
        prescription.end_date = null;
        prescription.duration = null;
      }
      try {
        prescriptionDisplayDict = $filter("PrescriptionDisplayText")(prescription, $scope.timeSlots, prescription.quantityRate);
        prescription.data.display_text = prescriptionDisplayDict.display_text;
        prescription.data.dci_display_text = prescriptionDisplayDict.dci_display_text;
        return prescription.data.posology = prescriptionDisplayDict.posology;
      } catch (error1) {
        error = error1;
        prescription.data.display_text = $filter('translate')("CANT GENERATE POSOLOGY SENTENCE, MISSING FIELDS");
        return prescription.data.dci_display_text = prescription.data.display_text;
      }
    };
    watchCallback = function(newVal, oldVal) {
      var error, error1, i, len, prescription, results;
      results = [];
      for (i = 0, len = newVal.length; i < len; i++) {
        prescription = newVal[i];
        try {
          results.push(formatTemplate(prescription));
        } catch (error1) {
          error = error1;
        }
      }
      return results;
    };
    $scope.$watch('selectedPrescriptions', watchCallback, true);
    $scope.validateModels = function() {
      $rootScope.busy = true;
      return PrescUtils.getOrCreateDraftOrdonnance($rootScope.currentStay.id, $scope.user.id).then(function(ordonnance) {
        var group, group_sequence, i, j, key, len, len1, prescription, prescriptionGroup, promises, ref, ref1, ref2, ref3, value;
        promises = [];
        ref = $scope.groupedSelectedPrescriptions;
        for (i = 0, len = ref.length; i < len; i++) {
          prescriptionGroup = ref[i];
          group = prescriptionGroup.groupId ? GenUID.generate(32) : null;
          group_sequence = group ? 1 : null;
          ref1 = prescriptionGroup.prescriptions;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            prescription = ref1[j];
            delete prescription.id;
            delete prescription.beforeModif;
            delete prescription.hasHighCostDrug;
            prescription.ordonnance = ordonnance;
            prescription.indication = prescription != null ? (ref2 = prescription.indication) != null ? ref2.id : void 0 : void 0;
            prescription.group = group;
            prescription.group_sequence = group_sequence;
            prescription.start_date = moment(prescription.start_date).format("YYYY-MM-DD");
            ref3 = prescription.data.quantity_by_timeslot;
            for (key in ref3) {
              value = ref3[key];
              if (value) {
                prescription.data.quantity_by_timeslot[key] = value * prescription.quantityRate;
              }
            }
            if (prescription.data.daily_quantity) {
              prescription.data.daily_quantity = prescription.data.daily_quantity * prescription.quantityRate;
            }
            if (prescription.data.debit_unit) {
              prescription.data.debit_unit = prescription.data.debit_unit * prescription.quantityRate;
            }
            promises.push(Prescription.save(prescription).$promise);
          }
        }
        return $q.all(promises).then(function() {
          $rootScope.busy = false;
          return $state.go('user.patient.stay.medication.cart');
        });
      });
    };
    $rootScope.busy = true;
    PrescTemplateCategory.api.query().$promise.then(function(categories) {
      var query;
      _.forEach(categories, function(category) {
        return category.prescriptions = [];
      });
      query = $rootScope.currentStay ? {
        for_entity: $rootScope.currentStay.entity.id
      } : null;
      return PrescTemplate.api.query(query).$promise.then(function(templates) {
        var i, len, prescription, template;
        for (i = 0, len = templates.length; i < len; i++) {
          template = templates[i];
          prescription = template.data;
          prescription.requiresIndication = HighCostDrugsUtils.requiresIndication(template.high_cost_drug_type);
          prescription.category = _.find($scope.prescCategories, {
            name: prescription.category.name
          });
          prescription.template_category = template.template_category;
          prescription.id = template.id;
          _.find(categories, {
            id: prescription.template_category
          }).prescriptions.push(prescription);
        }
        _.forEach(categories, function(category) {
          return category.groupedPrescriptions = PrescUtils.groupPrescriptions(category.prescriptions);
        });
        $scope.prescriptionTemplateCategories = _.filter(categories, function(cat) {
          return !$rootScope.currentStay || cat.prescriptions.length > 0;
        });
        return $rootScope.busy = false;
      });
    });
    $scope.handleOnSelectIndication = function(prescription, indication) {
      prescription.indication = indication;
      return prescription.indication_label = indication.label;
    };
    return $scope.handleOnClearIndication = function(prescription) {
      prescription.indication = void 0;
      return prescription.indication_label = void 0;
    };
  }]);

  angular.module('mhclientApp').controller('PrescriptionNewTemplateCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "PrescTemplate", "$q", "PrescUtils", "Ordonnance", "GenUID", function($scope, $rootScope, $state, $stateParams, PrescTemplate, $q, PrescUtils, Ordonnance, GenUID) {
    var prescriptionDone, prescriptionToDelete;
    $scope.isModelInterface = true;
    $scope.isTemplatePrescription = true;
    $scope.controlVars = {
      withSteps: false,
      category: null
    };
    prescriptionToDelete = [];
    $scope.removePrescription = function(prescription) {
      _.remove($scope.prescriptions, prescription);
      if (prescription.id) {
        return prescriptionToDelete.push(prescription);
      }
    };
    $scope.goTopreviousState = function() {
      return $state.go("user.medication.prescription-templates");
    };
    $scope.selectCategory = function(category) {
      $scope.controlVars.category = category;
      if (category.name === "PAP_TEMPLATE") {
        return $state.go('user.patient.stay.medication.pap', {
          ordonnanceId: $stateParams.ordonnanceId
        });
      } else {
        return _.forEach($scope.prescriptions, function(prescription) {
          prescription.category = category;
          if (category.name === "PAP") {
            return prescription.data.takes = "without";
          }
        });
      }
    };
    $rootScope.busy = true;
    prescriptionDone = $q.defer();
    if ($stateParams.prescriptionTemplate) {
      PrescTemplate.api.get({
        id: $stateParams.prescriptionTemplate
      }).$promise.then(function(prescription) {
        $scope.controlVars.category = _.find($scope.prescCategories, {
          name: prescription.data.category.name
        });
        prescription.data.category = $scope.controlVars.category;
        prescription.data.start_date = null;
        prescription.data.id = prescription.id;
        return prescriptionDone.resolve([prescription.data]);
      });
    } else if ($stateParams.prescriptionGroupToModify) {
      PrescTemplate.api.query({
        group: $stateParams.prescriptionGroupToModify
      }).$promise.then(function(prescriptions) {
        $scope.controlVars.category = _.find($scope.prescCategories, {
          name: prescriptions[0].data.category.name
        });
        $scope.controlVars.withSteps = true;
        $scope.controlVars.stepsTitle = prescriptions[0].data.data.group_title;
        $scope.blockSteps = true;
        return prescriptionDone.resolve(_.map(prescriptions, function(prescription) {
          prescription.data.start_date = null;
          prescription.data.category = $scope.controlVars.category;
          prescription.data.id = prescription.id;
          prescription.data.fold = true;
          return prescription.data;
        }));
      });
    } else {
      prescriptionDone.resolve([PrescUtils.setupPrescription($scope.isTemplatePrescription)]);
    }
    prescriptionDone.promise.then(function(prescriptions) {
      $scope.prescriptions = prescriptions;
      return $rootScope.busy = false;
    });

    /* Filter active (ACT) presc categories eligible for creation(CREATE) but exclude PAP_TEMPLATE */
    $scope.categories = _.filter($scope.prescCategories, function(category) {
      return category.name !== "PAP_TEMPLATE" && category.state === "ACT" && (category.properties != null) && (category.properties.resumption != null) && category.properties.resumption.indexOf("CREATE") !== -1;
    });
    return $scope.submitForm = function() {
      var group;
      $rootScope.busy = true;
      if ($stateParams.prescriptionGroupToModify) {
        group = $stateParams.prescriptionGroupToModify;
      } else {
        group = $scope.controlVars.withSteps ? GenUID.generate(32) : null;
      }
      return $q.all(_.map($scope.prescriptions, function(prescription) {
        $scope.formatPrescription(prescription);
        prescription.group = group;
        prescription.data.group_title = $scope.controlVars.stepsTitle;
        if (prescription.id) {
          return PrescTemplate.api.update({
            id: prescription.id,
            group: group,
            data: prescription
          }).$promise;
        } else {
          return PrescTemplate.api.save({
            template_category: $stateParams.templateCategory,
            group: group,
            data: prescription,
            entity: prescription.entity
          }).$promise;
        }
      })).then(function() {
        return $q.all(_.map(prescriptionToDelete, function(prescription) {
          return PrescTemplate.api["delete"]({
            id: prescription.id
          }).$promise;
        })).then(function() {
          $rootScope.busy = false;
          return $state.go("user.medication.prescription-templates");
        });
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=prescription-templates-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PrescCartCtrl
    * @description
    * # PrescFromTemplateCtrl
    * Controller to create new prescription from pre-saved templates
   */
  angular.module("mhclientApp").controller('modalCartCommentCtrl', ["$scope", "$uibModalInstance", "title", "okButtonText", "cancelButtonText", "required", function($scope, $uibModalInstance, title, okButtonText, cancelButtonText, required) {
    $scope.comment = "";
    $scope.title = title;
    $scope.cancelButtonText = cancelButtonText;
    $scope.okButtonText = okButtonText;
    $scope.required = required;
    $scope.save = function(comment) {
      return $uibModalInstance.close(comment);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss();
    };
  }]);

  angular.module("mhclientApp").controller('mhModalPrescCartCtrl', ["$scope", "$uibModalInstance", "title", "text", "saveButtonText", "validateButtonText", "cancelButtonText", function($scope, $uibModalInstance, title, text, saveButtonText, validateButtonText, cancelButtonText) {
    $scope.text = text;
    $scope.title = title;
    $scope.cancelButtonText = cancelButtonText;
    $scope.saveButtonText = saveButtonText;
    $scope.validateButtonText = validateButtonText;
    $scope.reason = "";
    $scope.save = function() {
      return $uibModalInstance.close("save");
    };
    $scope.validate = function() {
      return $uibModalInstance.close("validate");
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close("cancel");
    };
  }]);

  angular.module('mhclientApp').controller('PrescCartCtrl', ["$scope", "$rootScope", "$state", "$q", "$sce", "MhConfig", "Ordonnance", "Patient", "Medicaldb", "Prescription", "notify", "$filter", "PrescUtils", "ImageDocument", "$uibModal", "SiteVarsUtils", "Stay", "Certificate", function($scope, $rootScope, $state, $q, $sce, MhConfig, Ordonnance, Patient, Medicaldb, Prescription, notify, $filter, PrescUtils, ImageDocument, $uibModal, SiteVarsUtils, Stay, Certificate) {
    var canEdit, canValidateCart, categoriesByIdDict, cleanCart, getCartDetails, handleOrdonnanceStatus, removeCart, selectStayModal;
    $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      var confirm_dialog, i18n, msg, patient, ref, userCarts, validateButtonText;
      if (event.defaultPrevented) {
        return;
      }
      if ($scope.mdbCheck && toState.name !== "user.patient.stay.medication.cart") {
        event.preventDefault();
        $rootScope.busy = true;
        confirm_dialog = $uibModal.open({
          animation: true,
          templateUrl: 'medication/views/modal-template-presc-cart-quit.html',
          size: "lg",
          controller: 'mhModalPrescCartCtrl',
          resolve: {
            title: function() {
              return $filter('translate')("CART_DONT_HANDLED_TITLE");
            },
            text: function() {
              return $filter('translate')("CART_DONT_HANDLED_BODY");
            },
            cancelButtonText: function() {
              return $filter('translate')("CART_DONT_HANDLED_YES");
            },
            saveButtonText: function() {
              return '';
            },
            validateButtonText: function() {
              return $filter('translate')("CART_DONT_HANDLED_NO");
            }
          }
        });
        return confirm_dialog.result.then((function(result) {
          $rootScope.busy = false;
          if (result !== "cancel") {
            $scope.mdbCheck = false;
            return $state.go(toState.name, toParams);
          }
        }), (function(e) {
          return $rootScope.busy = false;
        }));
      } else {
        if ($scope.patients.length === 0 || !$scope.idPatient) {
          return;
        }
        patient = _.find($scope.patients, function(patient) {
          return patient.id === $scope.idPatient;
        });
        userCarts = _.filter(patient.carts, function(cart) {
          return cart.author.username === $scope.user.username && cart.state === "DRAFT";
        });
        if (userCarts.length === 0) {
          return;
        }
        if ((ref = toState.name) === 'user.patient.stay.medication.prescription-templates' || ref === 'user.patient.stay.medication.new_prescription' || ref === 'user.patient.stay.medication.pap' || ref === 'user.patient.stay.medication.cart' || ref === 'user.patient.stay.medication.current' || ref === 'user.patient.stay.posos') {
          return;
        }
        event.preventDefault();
        $rootScope.busy = true;
        i18n = $filter('translate');
        msg = userCarts.length + " " + i18n("CONFIRM_QUIT_HEADER") + $scope.user.full_name;
        validateButtonText = null;
        if (!_.some(userCarts, {
          'canBeValidate': false
        })) {
          validateButtonText = i18n("ACCEPT");
        }
        confirm_dialog = $uibModal.open({
          animation: true,
          size: "lg",
          templateUrl: 'medication/views/modal-template-presc-cart-quit.html',
          controller: 'mhModalPrescCartCtrl',
          resolve: {
            title: function() {
              return msg;
            },
            text: function() {
              return i18n("CONFIRM_QUIT_MESSAGE");
            },
            cancelButtonText: function() {
              return i18n("RETURN");
            },
            saveButtonText: function() {
              return i18n("SAVE");
            },
            validateButtonText: function() {
              return validateButtonText;
            }
          }
        });
        return confirm_dialog.result.then((function(result) {
          var cart, i, len, results;
          $rootScope.busy = false;
          if (result !== "cancel") {
            results = [];
            for (i = 0, len = userCarts.length; i < len; i++) {
              cart = userCarts[i];
              results.push($scope.checkCart(cart, patient, result));
            }
            return results;
          }
        }), (function(e) {
          return $rootScope.busy = false;
        }));
      }
    });
    categoriesByIdDict = {};
    $scope.mh_config = MhConfig;
    $scope.mdbCheck = null;
    $scope.canPrescribe = true;
    $scope.idPatient = $state.params.idPatient;
    $scope.mode = $state.params.mode;
    $scope.query = {};
    canEdit = $scope.checkPermissions("ORP", "CAN_WRITE");
    canValidateCart = $scope.user.group.features.indexOf("PRESC_CART_VALIDATION") !== -1;
    $scope.canControl = $scope.user.group.features.indexOf("PRESC_CART_CONTROL") !== -1;
    $scope.unlockCart = function(ordonnance) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("Déverrouiller le panier") + "?";
          },
          text: function() {
            return $filter('translate')("UNLOCK_CART_EXPLAIN");
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          }
        }
      });
      return confirm_dialog.result.then(function(result) {
        if (result) {
          ordonnance.unlocked = true;
          return handleOrdonnanceStatus(ordonnance);
        }
      });
    };
    handleOrdonnanceStatus = function(ordonnance) {
      var canControlDraft, canValidateSavedDraft, isSelfOrdonnance;
      ordonnance.needControl = ordonnance.attached_document && $scope.retranscriptionsNeedsControl && !(ordonnance.data.control && ordonnance.data.control.controled);
      isSelfOrdonnance = ordonnance.author.id === $scope.user.id;
      canValidateSavedDraft = !ordonnance.needControl && ordonnance.state === 'SAVED_DRAFT' && canValidateCart;
      canControlDraft = ordonnance.state === 'SAVED_DRAFT' && ordonnance.needControl && $scope.canControl;
      ordonnance.editable = canEdit && ((isSelfOrdonnance || canValidateSavedDraft || canControlDraft) || ordonnance.unlocked);
      ordonnance.canBeValidate = canValidateCart && (!ordonnance.needControl || ordonnance.unlocked);
      ordonnance.canBeSaved = ordonnance.state !== 'SAVED_DRAFT';
      ordonnance.canBeControled = ordonnance.needControl && $scope.canControl;
      return ordonnance.canUnblock = canValidateCart;
    };
    $scope.signatureDraw = {
      'config': {
        'readonly': false,
        'action': 'draw',
        'penColor': 'black',
        'lineWidth': 1,
        'zoom': 100,
        'smooth': true,
        'tolerance': 1.00,
        'withNotes': false,
        'size': {
          width: 276,
          height: 80
        },
        'data': {},
        'canvas': null
      }
    };
    $rootScope.busy = true;
    $scope.detachDocument = function(ordonnance) {
      $rootScope.busy = true;
      return Ordonnance.update({
        id: ordonnance.id
      }, {
        id: ordonnance.id,
        attached_document: null
      }).$promise.then(function() {
        ordonnance.attached_document = null;
        handleOrdonnanceStatus(ordonnance);
        return $rootScope.busy = false;
      });
    };
    $scope.showCurrent = function(patient) {
      patient.showCurrents = !patient.showCurrents;
      if (patient.showCurrents && (patient.currentGroupedPrescriptions == null)) {
        $rootScope.busy = true;
        return Prescription.query({
          patient: patient.id,
          only_active: true
        }).$promise.then(function(prescs) {
          prescs.forEach(function(prescription) {
            return prescription.category = categoriesByIdDict[prescription.category];
          });
          patient.currentGroupedPrescriptions = PrescUtils.groupPrescriptions(prescs);
          return $rootScope.busy = false;
        });
      }
    };
    $scope.toggleFold = function(cart) {
      $rootScope.busy = true;
      getCartDetails(cart).promise.then(function() {
        return $rootScope.busy = false;
      });
      cart.unfold = !cart.unfold;
      return cart.selecting_document = cart.selecting_document && cart.unfold;
    };
    $scope.setDischargePrescription = function(ordonnance) {
      $rootScope.busy = true;
      return Ordonnance.update({
        id: ordonnance.id
      }, {
        id: ordonnance.id,
        data: ordonnance.data,
        discharge_prescription: ordonnance.discharge_prescription
      }).$promise.then(function() {
        return $rootScope.busy = false;
      });
    };
    $scope.setDischargePrescriptionDuration = function(ordonnance) {
      var ordonnanceData;
      ordonnanceData = angular.copy(ordonnance.data);
      ordonnanceData.discharge_prescription_duration = ordonnance.data.discharge_prescription_duration;
      ordonnanceData.discharge_prescription_start_date = moment(ordonnance.data.discharge_prescription_start_date).format("DD/MM/YYYY");
      return Ordonnance.update({
        id: ordonnance.id
      }, {
        id: ordonnance.id,
        data: ordonnanceData,
        discharge_prescription: ordonnance.discharge_prescription
      });
    };
    $scope.setDischargePrescriptionStartDate = function(ordonnance) {
      var ordonnanceData;
      $rootScope.busy = true;
      ordonnanceData = angular.copy(ordonnance.data);
      ordonnanceData.discharge_prescription_start_date = moment(ordonnance.data.discharge_prescription_start_date).format("DD/MM/YYYY");
      return Ordonnance.update({
        id: ordonnance.id
      }, {
        id: ordonnance.id,
        data: ordonnanceData,
        discharge_prescription: ordonnance.discharge_prescription
      }).$promise.then(function() {
        return $rootScope.busy = false;
      });
    };
    getCartDetails = function(cart) {
      var cartDetailsPromise;
      cartDetailsPromise = $q.defer();
      if (!cart.has_details) {
        $rootScope.busy = true;
        Ordonnance.getPrescriptions({
          id: cart.id
        }).$promise.then(function(prescriptions) {
          prescriptions.forEach(function(prescription) {
            prescription.category = categoriesByIdDict[prescription.category];
            return prescription.ordonnance = cart;
          });
          cart.groupedPrescriptions = PrescUtils.groupPrescriptions(prescriptions);
          cart.prescriptions = prescriptions;
          if ((cart.attached_document != null) && typeof cart.attached_document === 'number') {
            return ImageDocument.api.get({
              id: cart.attached_document
            }).$promise.then(function(image_document) {
              cart.attached_document = image_document;
              $rootScope.busy = false;
              cartDetailsPromise.resolve();
              return cart.has_details = true;
            });
          } else {
            cartDetailsPromise.resolve();
            $rootScope.busy = false;
            return cart.has_details = true;
          }
        });
      } else {
        cartDetailsPromise.resolve();
      }
      return cartDetailsPromise;
    };
    SiteVarsUtils.get('RETRANSCRIPTIONS_NEEDS_CONTROL', false).then(function(sitevar) {
      var category, i, len, params, ref;
      $scope.retranscriptionsNeedsControl = sitevar.value;
      ref = $scope.prescCategories;
      for (i = 0, len = ref.length; i < len; i++) {
        category = ref[i];
        categoriesByIdDict[category.id] = category;
      }
      params = {
        states: ['SAVED_DRAFT', 'DRAFT']
      };
      if ($rootScope.currentPatient != null) {
        params.patient = $rootScope.currentPatient.id;
      }
      return Ordonnance.getOrdonnanceByPatient(params).$promise.then(function(patients) {
        var cart, date, j, k, len1, len2, patient, ref1;
        for (j = 0, len1 = patients.length; j < len1; j++) {
          patient = patients[j];
          ref1 = patient.carts;
          for (k = 0, len2 = ref1.length; k < len2; k++) {
            cart = ref1[k];
            date = cart.data.discharge_prescription_start_date;
            if (date && date.length > 0) {
              if ($rootScope.mh_config.platform === "mgapp") {
                cart.data.discharge_prescription_start_date = moment(date, "DD/MM/YYYY");
              } else {
                cart.data.discharge_prescription_start_date = moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
              }
            }
            handleOrdonnanceStatus(cart);
          }
        }
        $scope.patients = patients;
        if ($scope.patients.length > 0 && $scope.idPatient) {
          return $scope.toggleFold($scope.patients[0].carts[0]);
        } else {
          return $rootScope.busy = false;
        }
      });
    });
    selectStayModal = function(patient) {
      return $uibModal.open({
        animation: true,
        templateUrl: 'core/views/select-stay-widget-modal.html',
        controller: 'selectStayWidget',
        size: "lg",
        resolve: {
          patient: function() {
            return patient;
          },
          states: function() {
            return ["PRE", "ADM"];
          }
        }
      });
    };
    $scope.selectDocumentCallBack = function(imageDocument, ordonnance) {
      $rootScope.busy = true;
      return Certificate.query().$promise.then(function(certificates) {
        if (_.find(certificates, {
          obsolete: false,
          cert_type: 'posos'
        })) {
          $rootScope.busy = false;
          return $state.go('user.patient.stay.posos', {
            documentId: imageDocument.id,
            ordonnanceId: ordonnance ? ordonnance.id : null
          });
        } else {
          return Ordonnance.update({
            id: ordonnance.id
          }, {
            id: ordonnance.id,
            attached_document: imageDocument.id
          }).$promise.then(function() {
            ordonnance.attached_document = imageDocument;
            handleOrdonnanceStatus(ordonnance);
            return $rootScope.busy = false;
          });
        }
      });
    };
    $scope.checkCart = function(cart, patient, action) {
      var ref, staySelectionPromise;
      if (cart.discharge_prescription) {
        if (!cart.data.discharge_prescription_start_date) {
          return;
        }
      }
      staySelectionPromise = $q.defer();
      if (action === "validate") {
        if (cart.discharge_prescription) {
          staySelectionPromise.resolve();
        } else if ($rootScope.currentStay && ((ref = $rootScope.currentStay.state) === "PRE" || ref === "ADM")) {
          cart.stay = $rootScope.currentStay.id;
          staySelectionPromise.resolve();
        } else {
          Stay.get({
            id: cart.stay
          }).$promise.then(function(stay) {
            var ref1;
            if ((ref1 = stay.state) === "PRE" || ref1 === "ADM") {
              return staySelectionPromise.resolve();
            } else {
              return selectStayModal(patient).result.then(function(stay) {
                if (stay) {
                  cart.stay = stay.id;
                  return staySelectionPromise.resolve();
                } else {
                  return staySelectionPromise.reject();
                }
              });
            }
          });
        }
      } else {
        staySelectionPromise.resolve();
      }
      return staySelectionPromise.promise.then(function() {
        $scope.stupefiant_products = [];
        $rootScope.busy = true;
        return getCartDetails(cart).promise.then(function() {
          var i, len, presc, prescsToAnalyse, ref1;
          prescsToAnalyse = [];
          ref1 = cart.prescriptions;
          for (i = 0, len = ref1.length; i < len; i++) {
            presc = ref1[i];
            if (!presc.category.properties.analyse_disabled) {
              prescsToAnalyse.push(presc);
            }
            if ((presc.data.bdm_data != null) && presc.data.bdm_data.is_stupefiant === "1" && _.indexOf($scope.stupefiant_products, presc.data.name) === -1) {
              $scope.stupefiant_products.push(presc.data.name);
            }
          }
          if (prescsToAnalyse.length === 0) {
            $scope.mdbCheck = {
              patient: patient
            };
            $scope.mdbCheck.cart = cart;
            if (action === 'validate') {
              $scope.confirmValidateCart();
            } else if (action === 'save' || action === 'control') {
              $scope.confirmSaveCart($scope.mdbCheck.cart);
            }
            return $rootScope.busy = false;
          } else {
            if ($rootScope.mh_config.platform === "mgapp") {
              return Patient.getCurrentCIPS({
                id: patient.id,
                cart: cart.id
              }).$promise.then(function(cip_list) {
                return Medicaldb.check({
                  drugs: cip_list
                }).$promise.then(function(result) {
                  result.action = action;
                  result.cart = cart;
                  result.patient = patient;
                  $scope.mdbCheck = result;
                  return $rootScope.busy = false;
                });
              });
            } else {
              return Stay.getControlPharma({
                id: cart.stay,
                cart: cart.id
              }).$promise.then(function(result) {
                var j, len1, posologie, ref2;
                result.action = action;
                result.cart = cart;
                result.patient = patient;
                $scope.mdbCheck = result;
                $scope.mdbCheck.control_html = $sce.trustAsHtml(result.control_html);
                $scope.mdbCheck.url = $scope.base_iframe_url + '/api_rest/stays/' + cart.stay + '/control_html?cip=' + _.join(result.cips, '&cip=');
                ref2 = result.check_posologies;
                for (j = 0, len1 = ref2.length; j < len1; j++) {
                  posologie = ref2[j];
                  if (PrescUtils.getBCBPosologiesCodes[posologie.code] != null) {
                    posologie.error_code = PrescUtils.getBCBPosologiesCodes[posologie.code];
                  }
                }
                return $rootScope.busy = false;
              });
            }
          }
        });
      });
    };
    $scope.controlCartWhitComments = function(ordonnance, status) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'medication/views/modal-cart-comment.html',
        size: "lg",
        controller: 'modalCartCommentCtrl',
        resolve: {
          title: function() {
            return $filter('translate')($scope.controlStatus[status].label);
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          },
          required: status === "POK" || status === "NOK"
        }
      });
      return confirm_dialog.result.then(function(result) {
        return $scope.controlCart(ordonnance, status, result);
      });
    };
    $scope.validateWhitComments = function() {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'medication/views/modal-cart-comment.html',
        controller: 'modalCartCommentCtrl',
        size: "lg",
        resolve: {
          title: function() {
            return $filter('translate')("SAVE_WHIT_COMMENTS");
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          },
          required: true
        }
      });
      return confirm_dialog.result.then(function(result) {
        return $scope.confirmValidateCart(result);
      });
    };
    $scope.editControl = function(ordonnance) {
      var confirm_dialog;
      $scope.ordonnanceToEdit = ordonnance;
      $scope.currentOrdonnanceStatus = ordonnance.data.control.status;
      $scope.currentOrdonnanceComment = ordonnance.data.control.comment;
      confirm_dialog = $uibModal.open({
        animation: true,
        scope: $scope,
        templateUrl: 'medication/views/modal-control-edition.html'
      });
      return confirm_dialog.result.then(function(result) {
        return $scope.controlCart(ordonnance, result.status, result.comment);
      });
    };
    $scope.controlCart = function(ordonnance, status, comment) {
      var control;
      control = {
        status: status,
        comment: comment,
        controled: true,
        timestamp: moment()
      };
      return $scope.confirmSaveCart(ordonnance, control);
    };
    $scope.confirmValidateCart = function(comments) {
      var dataURL, params;
      $rootScope.busy = true;
      params = {};
      params['id'] = $scope.mdbCheck.cart.id;
      params['stay'] = $scope.mdbCheck.cart.stay;
      if (comments) {
        params["comments"] = comments;
      }
      if ($rootScope.mh_config.platform === 'mgapp' && $scope.signatureDraw.canvas) {
        dataURL = $scope.signatureDraw.canvas.toDataURL("image/png");
        params['signature_points'] = $scope.signatureDraw.data[0].points;
        params['signature_base64_img'] = dataURL;
      }
      return Ordonnance.activate(params).$promise.then(function() {
        var stay;
        if ($scope.idPatient) {
          $rootScope.busy = false;
          if (($scope.mdCheck != null) && ($scope.mdCheck.patient != null) && $scope.mdbCheck.patient.id === $scope.idPatient) {
            cleanCart($scope.mdbCheck.patient, $scope.mdbCheck.cart);
          }
          stay = $scope.mdbCheck.cart.stay;
          $scope.mdbCheck = null;
          return $state.go('user.patient.stay.medication.current', {
            idStay: stay
          });
        } else {
          cleanCart($scope.mdbCheck.patient, $scope.mdbCheck.cart);
          if (($scope.mdbCheck.patient.currentGroupedPrescriptions != null) && $scope.patients.indexOf($scope.mdbCheck.patient) !== -1) {
            return Prescription.query({
              patient: $scope.mdbCheck.patient.id,
              only_active: true
            }).$promise.then(function(prescs) {
              prescs.forEach(function(prescription) {
                return prescription.category = categoriesByIdDict[prescription.category];
              });
              $scope.mdbCheck.patient.currentGroupedPrescriptions = PrescUtils.groupPrescriptions(prescs);
              $scope.mdbCheck = null;
              return $rootScope.busy = false;
            });
          } else {
            $scope.mdbCheck = null;
            return $rootScope.busy = false;
          }
        }
      });
    };
    cleanCart = function(patient, cart) {
      if (patient.carts.length === 1) {
        return $scope.patients.splice($scope.patients.indexOf(patient), 1);
      } else {
        return patient.carts.splice(patient.carts.indexOf(cart), 1);
      }
    };
    $scope.confirmSaveCart = function(ordonnance, control) {
      $rootScope.busy = true;
      return Ordonnance.saveDraft({
        id: ordonnance.id,
        control: control || {}
      }).$promise.then(function(cart) {
        ordonnance.data = cart.data;
        ordonnance.author = cart.author;
        ordonnance.state = cart.state;
        ordonnance.timestamp = cart.timestamp;
        handleOrdonnanceStatus(ordonnance);
        $scope.mdbCheck = null;
        return $rootScope.busy = false;
      });
    };
    $scope.cancelMDBCheck = function() {
      $scope.mdbCheck = null;
      return $scope.checkedPosologies = [];
    };
    $scope.partialUpdatePrescription = function(presc, toPick) {
      $rootScope.busy = true;
      return Prescription.update({
        id: presc.id
      }, _.pick(presc, _.concat(["id"], toPick))).$promise.then(function(updatedPresc) {
        presc.display_html = updatedPresc.display_html;
        return $rootScope.busy = false;
      });
    };
    $scope.toggleAld = function(presc) {
      $rootScope.busy = true;
      return Prescription.update({
        id: presc.id
      }, {
        id: presc.id,
        data: presc.data
      }).$promise.then(function() {
        return $rootScope.busy = false;
      });
    };
    $scope.deletePresc = function(presc, cart, patient) {
      $rootScope.busy = true;
      return Prescription["delete"]({
        id: presc.id
      }).$promise.then(function() {
        _.remove(cart.prescriptions, presc);
        if (cart.prescriptions.length === 0) {
          return removeCart(cart, patient);
        } else {
          cart.groupedPrescriptions = PrescUtils.groupPrescriptions(cart.prescriptions);
          return $rootScope.busy = false;
        }
      });
    };
    removeCart = function(cart, patient) {
      $rootScope.busy = true;
      return Ordonnance["delete"]({
        id: cart.id
      }).$promise.then(function() {
        cleanCart(patient, cart);
        return $rootScope.busy = false;
      });
    };
    return $scope.clearCart = function(cart, patient) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("CONFIRM_REMOVE_CART");
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          }
        }
      });
      return confirm_dialog.result.then(function(result) {
        if (result) {
          return removeCart(cart, patient);
        }
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=presc-cart-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:MedicationCtrl
    * @description
    * # MedicationCtrl
    * TODO: write a true description
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('MedicationCtrl', ["$scope", "$sce", "$rootScope", "SiteVarsUtils", "$uibModal", "$q", "$state", "$filter", "Ordonnance", "Prescription", "Medicaldb", "Stay", "PrescUtils", "prescCategories", "timeSlots", function($scope, $sce, $rootScope, SiteVarsUtils, $uibModal, $q, $state, $filter, Ordonnance, Prescription, Medicaldb, Stay, PrescUtils, prescCategories, timeSlots) {
    $scope.timeSlots = timeSlots;
    $scope.prescCategories = prescCategories;
    $scope.controlStatus = {
      "OK": {
        "label": "CONTROL_OK",
        "class": "text-success"
      },
      "POK": {
        "label": "CONTROL_POK",
        "class": "text-warning"
      },
      "NOK": {
        "label": "CONTROL_NOK",
        "class": "text-danger"
      }
    };
    $scope.stopAvailableReasons = PrescUtils.getStopAvailableReason();
    $scope.canEditPrescriptions = $scope.checkPermissions("ORP", "CAN_WRITE");
    SiteVarsUtils.get('CLASICAL_DISPENSATION', true).then(function(sitevar) {
      return $scope.clasicalDispensation = sitevar.value;
    });
    SiteVarsUtils.get('ALLOW_END_MODE_UNDEFINED', true).then(function(sitevar) {
      return $scope.allowEndModeUndefined = sitevar.value;
    });
    SiteVarsUtils.get('ALLOW_HOSPITAL_TREATMENT', false).then(function(sitevar) {
      return $scope.allowHospitalTraitement = sitevar.value;
    });
    PrescUtils.getBCBVersion().promise.then(function(bcb_version) {
      return $scope.bcb_version = bcb_version;
    });
    $scope.bcb_enabled = true;
    if ($rootScope.mh_config.platform === "mgapp") {
      PrescUtils.getBCBState().promise.then(function(bcb_state) {
        $scope.bcb_enabled = bcb_state.state;
        if (!$scope.bcb_enabled) {
          return $scope.bcb_error = bcb_state.error;
        }
      });
    }
    $scope.prescriptionGroupsOrder = PrescUtils.prescriptionGroupsOrder;
    $rootScope.toggleDetail = function(presc) {
      return PrescUtils.getPrescriptionDetails(presc);
    };
    $scope.handleCanRenew = function(prescription, groupsInfo) {
      var canRenew, reason;
      canRenew = false;
      reason = "";
      if (!((prescription.category.properties.resumption != null) && (indexOf.call(prescription.category.properties.resumption, 'RENEW') >= 0)) || prescription.category.state !== "ACT") {
        reason = $filter('translate')("Cant renew presc of this category");
      } else if (prescription.child_prescription != null) {
        reason = $filter('translate')("Already renew");
      } else if (prescription.data.type === 'dates') {
        reason = $filter('translate')("Cant renew planning dates");
      } else if (prescription.data.is_cropped) {
        reason = $filter('translate')("Cant renew cropped prescriptions");
      } else if ((prescription.data.can_renew != null) && !prescription.data.can_renew) {
        if (prescription.data.is_posos) {
          reason = $filter('translate')("Cant renew POSOS prescription, you can modify");
        } else {
          reason = $filter('translate')("Cant renew old prescription, you can modify");
        }
      } else if (groupsInfo && prescription.group && groupsInfo[prescription.group].last_sequence !== prescription.group_sequence) {
        reason = $filter('translate')("Non-renewable step");
      } else {
        canRenew = true;
      }
      return {
        canRenew: canRenew,
        reason: reason
      };
    };
    $scope.moveItemInArray = function(array, index, delta) {
      var indexes, newIndex;
      newIndex = index + delta;
      if (newIndex < 0 || newIndex === array.length) {
        return;
      }
      indexes = [index, newIndex].sort(function(a, b) {
        return a - b;
      });
      return array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
    };
    $scope.addPrescriptionStep = function(prescriptions, category, isTemplatePrescription) {
      var prescription;
      _.forEach(prescriptions, function(presc) {
        return presc.fold = true;
      });
      prescription = PrescUtils.setupPrescription(isTemplatePrescription);
      prescription.category = category;
      if (category.name === "PAP") {
        prescription.data.takes = "without";
      }
      return prescriptions.push(prescription);
    };
    $scope.canValidatePrescriptions = function(prescriptions) {
      var i, len, prescription;
      for (i = 0, len = prescriptions.length; i < len; i++) {
        prescription = prescriptions[i];
        if (!prescription.category || (prescription.form && prescription.form.$invalid)) {
          return false;
        }
      }
      return true;
    };
    $scope.renewModifyPresc = function(presc) {
      if (!((presc.category.properties.resumption != null) && (indexOf.call(presc.category.properties.resumption, 'RENEW') >= 0)) || presc.category.state !== "ACT") {
        return $uibModal.open({
          animation: true,
          templateUrl: 'core/views/modal-template.html',
          size: "lg",
          controller: 'mhModalCtrl',
          resolve: {
            title: function() {
              return $filter('translate')('CANT_MODIFY_THIS_PRESCRIPTION');
            },
            text: function() {
              return $filter('translate')("Cant modify presc");
            },
            cancelButtonText: function() {
              return '';
            },
            noButtonText: function() {
              return '';
            },
            okButtonText: function() {
              return $filter('translate')("CONFIRM");
            }
          }
        });
      } else if (presc.category.name === "PAP_TEMPLATE") {
        return $state.go('user.patient.stay.medication.pap', {
          parentPrescriptionId: presc.id
        });
      } else {
        return $state.go('user.patient.stay.medication.new_prescription', {
          parentPrescriptionId: presc.id
        });
      }
    };
    $scope.editPrescriptionGroup = function(groupId, stayId, patientId, groupSequence) {
      return $state.go('user.patient.stay.medication.new_prescription', {
        prescriptionGroupToEdit: groupId,
        idStay: stayId,
        idPatient: patientId,
        prescriptionGroupSequence: groupSequence
      });
    };
    $scope.modifyPrescriptionGroup = function(groupId, stayId, patientId, groupSequence) {
      return $state.go('user.patient.stay.medication.new_prescription', {
        prescriptionGroupToModify: groupId,
        idStay: stayId,
        idPatient: patientId,
        prescriptionGroupSequence: groupSequence
      });
    };
    $scope.modifyCartPresc = function(presc, patient) {
      var idStay;
      idStay = $rootScope.currentStay ? $rootScope.currentStay.id : presc.ordonnance.stay;
      if (presc.category.name === "PAP_TEMPLATE") {
        return $state.go('user.patient.stay.medication.pap', {
          prescriptionId: presc.id,
          idStay: idStay,
          idPatient: patient.id
        });
      } else {
        return $state.go('user.patient.stay.medication.new_prescription', {
          prescriptionId: presc.id,
          idStay: idStay,
          idPatient: patient.id
        });
      }
    };
    $scope.analyzeCart = function(ordonnance) {
      $rootScope.busy = true;
      $scope.analyzedOrdonnance = ordonnance;
      return Stay.getControlPharma({
        id: ordonnance.stay,
        cart: ordonnance.id
      }).$promise.then(function(result) {
        var i, len, posologie, ref;
        $scope.ControlPharmaHtml = $sce.trustAsHtml(result.control_html);
        $scope.ControlPharmaUrl = $scope.base_iframe_url + '/api_rest/stays/' + ordonnance.stay + '/control_html?cip=' + _.join(result.cips, '&cip=');
        $scope.check_posologies = result.check_posologies;
        ref = result.check_posologies;
        for (i = 0, len = ref.length; i < len; i++) {
          posologie = ref[i];
          if (PrescUtils.getBCBPosologiesCodes[posologie.code] != null) {
            posologie.error_code = PrescUtils.getBCBPosologiesCodes[posologie.code];
          }
        }
        $rootScope.busy = false;
        return $uibModal.open({
          templateUrl: 'medication/views/modal-analyzed-ordonnance.html',
          scope: $scope,
          backdrop: 'static'
        });
      });
    };
    $scope.updatePrescription = function(prescription, timeSlots) {
      var data, error, error1, key, prescriptionDisplayDict, ref, time_slots_quantity, value;
      if (prescription.category && prescription.category.name === "IMAGE") {
        if (!prescription.data.examens) {
          prescription.data.examens = [];
        }
      }
      if (prescription.category != null) {
        if (prescription.data.takes === "intervals" && !prescription.category.properties.allow_intervals) {
          prescription.data.takes = "slots";
        }
        if (prescription.data.takes === "debit" && !prescription.category.properties.allow_debit) {
          prescription.data.takes = "slots";
        }
        if (prescription.data.takes === "without" && !(prescription.category.name === 'PAP' && prescription.category.properties.allow_no_takes)) {
          prescription.data.takes = "slots";
        }
      }
      if (prescription.data.takes === "slots") {
        time_slots_quantity = 0;
        ref = prescription.data.quantity_by_timeslot;
        for (key in ref) {
          value = ref[key];
          if (value) {
            time_slots_quantity += value;
          }
        }
        prescription.data.daily_quantity = parseFloat((time_slots_quantity || 0).toFixed(4));
      } else if (prescription.data.takes === "intervals") {
        if ((prescription.data.interval != null) && prescription.data.interval_quantity) {
          prescription.data.daily_quantity = parseFloat(((24 / prescription.data.interval) * prescription.data.interval_quantity).toFixed(4));
        } else {
          prescription.data.daily_quantity = 0;
        }
        prescription.data.quantity_by_timeslot = {};
      } else if (prescription.data.takes === "debit") {
        delete prescription.data.total_quantity;
        delete prescription.data.daily_quantity;
        prescription.data.quantity_by_timeslot = {};
      } else {
        prescription.data.quantity_by_timeslot = {};
      }
      if (prescription.pds_display) {
        prescription.pds_handled = false;
      }
      data = prescription.data;
      if (prescription.category && prescription.category.name === "PCA") {
        data.total_volume_analgesic = data.bulb_number * data.prepatation_ml;
        data.total_volume_by_pocket = data.total_volume_analgesic + data.dilution_with;
        data.concentration_after_dilution = (data.bulb_number * data.prepatation_mg) / data.total_volume_by_pocket;
        data.max_by_day = data.deb_continue * 24.0 + ((data.limite_bolus * 24.0) / data.on_hours) * data.dose_bolus;
        if (!isNaN(data.max_by_day)) {
          data.max_by_day = parseFloat(data.max_by_day.toFixed(5)).toString();
        }
        if (!isNaN(data.concentration_after_dilution)) {
          data.concentration_after_dilution = parseFloat(data.concentration_after_dilution.toFixed(5)).toString();
        }
      }
      if (prescription.end_date && moment(prescription.start_date) > moment(prescription.end_date)) {
        prescription.end_date = void 0;
      }
      try {
        prescriptionDisplayDict = $filter("PrescriptionDisplayText")(prescription, $scope.timeSlots);
        prescription.data.display_text = prescriptionDisplayDict.display_text;
        prescription.data.dci_display_text = prescriptionDisplayDict.dci_display_text;
        prescription.data.posology = prescriptionDisplayDict.posology;
      } catch (error1) {
        error = error1;
        prescription.data.display_text = $filter('translate')("CANT GENERATE POSOLOGY SENTENCE, MISSING FIELDS");
        prescription.data.dci_display_text = prescription.data.display_text;
      }
      if (data.taking_unit != null) {
        return data.taking_unit.label_plural = data.taking_unit.label_plural || data.taking_unit.label;
      }
    };
    $scope.formatPrescription = function(prescription) {
      var ref, ref1, ref2, ref3;
      if ((ref = prescription.category.name) === "BIOLOGIC" || ref === "IMAGE") {
        prescription.end_date = prescription.start_date;
        if (prescription.category.name === "IMAGE") {
          delete prescription.data.name;
        }
      } else {
        delete prescription.data.biologic_info;
      }
      if ((ref1 = prescription.category.name) === "IMAGE" || ref1 === "NEW_CARE" || ref1 === "BIOLOGIC" || ref1 === "LABORATORY") {
        delete prescription.data.is_hospital;
      }
      prescription.pds_display = ((ref2 = prescription.category.name) === "PCA" || ref2 === "BIOLOGIC" || ref2 === "LABORATORY" || ref2 === "IMAGE" || ref2 === "NEW_CARE") || (prescription.category.name === "FOND" && prescription.data.route && ((ref3 = prescription.data.route.code) === "A40" || ref3 === "A32" || ref3 === "A58"));
      if (!prescription.category.dispensable) {
        prescription.dispensable = false;
      }
      if (prescription.category.name === "PAP") {
        prescription.data.short_display_html = $filter('translate')("POSOLOGY_ONLY_IF") + " " + (prescription.data.only_if || "()") + "<br>" + prescription.data.name;
      }
      prescription.data.creation_author = $scope.user.full_name;
      prescription.data.creation_date = moment().format("YYYY-MM-DD");
      if (prescription.data.type === "dates") {
        prescription.data.dates.sort(function(left, right) {
          return moment(left).diff(moment(right));
        });
        prescription.start_date = moment(prescription.data.dates[0]).format("YYYY-MM-DD");
        prescription.end_date = moment(prescription.data.dates[prescription.data.dates.length - 1]).format("YYYY-MM-DD");
        prescription.duration = Math.round(moment.duration(moment(prescription.end_date) - moment(prescription.start_date)).asDays() + 1);
        prescription.data.dates = prescription.data.dates.map(function(date) {
          return moment(date).format("YYYY-MM-DD");
        });
      } else {
        if (prescription.data.end_mode === 'date') {
          prescription.duration = Math.round(moment.duration(moment(prescription.end_date) - moment(prescription.start_date)).asDays() + 1);
        } else if (prescription.data.end_mode === 'duration') {
          if (prescription.duration == null) {
            prescription.duration = 1;
          }
          prescription.end_date = (moment(prescription.start_date).add(prescription.duration - 1, 'days')).format("YYYY-MM-DD");
          prescription.start_date = moment(prescription.start_date).format("YYYY-MM-DD");
        } else {
          prescription.end_date = null;
          prescription.duration = null;
        }
      }
      if (prescription.data.reeval_date != null) {
        prescription.data.reeval_date = moment(prescription.data.reeval_date).format("YYYY-MM-DD");
      }
      prescription.start_date = moment(prescription.start_date).format("YYYY-MM-DD");
      return prescription.end_date = prescription.end_date ? moment(prescription.end_date).format("YYYY-MM-DD") : null;
    };
    $scope.selectStakeholder = function(imageDocument) {
      return $uibModal.open({
        templateUrl: 'medication/views/attachment-template.html',
        controller: 'AttachmentCtrl',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          imageDocument: function() {
            return imageDocument;
          }
        }
      });
    };
    $scope.selectDocument = function(patient, callBack, ordonnance, stay) {
      return $uibModal.open({
        animation: true,
        component: 'pososDocumentSelectionModal',
        backdrop: 'static',
        windowClass: 'modal-fullscreen',
        resolve: {
          stay: function() {
            return stay;
          }
        }
      }).result.then(function(imageDocument) {
        if (imageDocument && callBack) {
          return callBack(imageDocument, ordonnance);
        }
      });
    };
    $scope.selectWeekDay = function(week_days, week_day) {
      if (week_day.selected) {
        return week_days.push(week_day.code);
      } else {
        return week_days.splice(week_days.indexOf(week_day.code), 1);
      }
    };
    $scope.freeRouteSelection = function(prescription) {
      var modal;
      modal = $uibModal.open({
        templateUrl: 'core/views/modal-selection-template.html',
        backdrop: 'static',
        controller: 'ModalSelectionCtrl',
        resolve: {
          label: function() {
            return "ROUTE_SELECTION";
          },
          choices: function() {
            return PrescUtils.routes;
          },
          lookUpField: function() {
            return "label";
          }
        }
      });
      return modal.result.then(function(route) {
        if (route) {
          return prescription.data.route = route;
        }
      });
    };
    return $scope.freeTakingUnitSelection = function(prescription) {
      var modal;
      modal = $uibModal.open({
        templateUrl: 'core/views/modal-selection-template.html',
        backdrop: 'static',
        controller: 'ModalSelectionCtrl',
        resolve: {
          label: function() {
            return "TAKING_UNIT_SELECTION";
          },
          choices: function() {
            return PrescUtils.taking_units;
          },
          lookUpField: function() {
            return "label";
          }
        }
      });
      return modal.result.then(function(taking_unit) {
        if (taking_unit) {
          return prescription.data.taking_unit = taking_unit;
        }
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=medication-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:CuttingCtrl
    * @description
    * # CuttingCtrl
    * Provider of CuttingCtrl
   */
  angular.module("mhclientApp").controller('CuttingCtrl', ["$scope", "$rootScope", "$stateParams", "$q", "$state", "$filter", "PrescUtils", "Ordonnance", "Prescription", "SiteVarsUtils", function($scope, $rootScope, $stateParams, $q, $state, $filter, PrescUtils, Ordonnance, Prescription, SiteVarsUtils) {
    var initInterval, interval, updatePrescriptions;
    $scope.maxWidth = 920;
    $scope.prescriptions = [];
    $scope.currentPrescription = null;
    $rootScope.busy = false;
    SiteVarsUtils.get('CROPPED_MAX_HEIGHT', 163 - 26).then(function(sitevar) {
      return $scope.maxHeight = sitevar.value;
    });
    updatePrescriptions = function(newVal, oldVal) {
      var i, len, prescription, results;
      results = [];
      for (i = 0, len = newVal.length; i < len; i++) {
        prescription = newVal[i];
        results.push(prescription.data.cropped_info = $filter("croppedPrescriptionSentence")(prescription));
      }
      return results;
    };
    $scope.$watch('prescriptions', updatePrescriptions, true);
    $scope.categories = _.filter($scope.prescCategories, function(category) {
      if (category.state === "ACT" && (category.properties.resumption != null) && category.properties.resumption.indexOf("CREATE") !== -1) {
        if (category.name !== "PAP_TEMPLATE") {
          return true;
        }
      }
    });
    $scope.removePrescription = function(prescription) {
      return $scope.prescriptions.splice($scope.prescriptions.indexOf(prescription), 1);
    };
    $scope.selectDocumentCallBack = function(imageDocument) {
      return $scope.imageDocument = imageDocument;
    };
    $scope.selectDocument($rootScope.currentPatient, $scope.selectDocumentCallBack, null, $rootScope.currentStay);
    $scope.reCalcViewDimensions = function() {
      return setTimeout((function() {
        return $scope.$broadcast('rzSliderForceRender');
      }), 10);
    };
    $scope.submitForm = function() {
      if ($scope.prescriptions.length === 0) {
        return;
      }
      $rootScope.busy = true;
      return Ordonnance.save({
        stay: $rootScope.currentStay.id,
        state: "DRAFT",
        author: $scope.user.id,
        attached_document: $scope.imageDocument.id
      }).$promise.then(function(ordonnance) {
        var allPrescPromises, i, len, prescription, ref;
        allPrescPromises = [];
        ref = $scope.prescriptions;
        for (i = 0, len = ref.length; i < len; i++) {
          prescription = ref[i];
          $scope.formatPrescription(prescription);
          prescription.ordonnance = ordonnance.id;
          if (!prescription.category.dispensable) {
            prescription.dispensable = false;
          }
          allPrescPromises.push(Prescription.save(prescription).$promise);
        }
        return $q.all(allPrescPromises).then(function() {
          return Ordonnance.activate({
            id: ordonnance.id
          }).$promise.then(function() {
            $rootScope.busy = false;
            return $state.go('user.patient.stay.medication.current');
          });
        });
      });
    };
    interval = null;
    initInterval = function(diffVal, page) {
      page.rotationAngle = (((page.rotationAngle + diffVal) % 360) + 360) % 360;
      if (!interval) {
        return interval = setInterval((function() {
          return $scope.$apply(function() {
            return page.rotationAngle = (((page.rotationAngle + diffVal) % 360) + 360) % 360;
          });
        }), 100);
      }
    };
    $scope.rotate90 = function(direction, page) {
      return page.rotationAngle = (((page.rotationAngle + direction * 90) % 360) + 360) % 360;
    };
    $scope.rotateBy = function(diffVal, page) {
      return initInterval(diffVal, page);
    };
    return $scope.clearInterval = function() {
      if (interval) {
        window.clearInterval(interval);
        return interval = null;
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=cutting-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CurrentPrescriptionCtrl
    * @description
    * # CurrentPrescriptionCtrl
    * Controller of Patient current Prescriptions
   */
  angular.module('mhclientApp').controller('CurrentPrescriptionCtrl', ["$scope", "$rootScope", "$sce", "$q", "$uibModal", "SiteVarsUtils", "Prescription", "$filter", "Ordonnance", "Patient", "Stay", "Medicaldb", "PrescUtils", "$state", function($scope, $rootScope, $sce, $q, $uibModal, SiteVarsUtils, Prescription, $filter, Ordonnance, Patient, Stay, Medicaldb, PrescUtils, $state) {
    var categoriesByIdDict, category, draftOrdonnancesPromise, i, len, params, ref, stopped_categories_dict;
    $scope.hasPrescription = true;
    $scope.extraFilter = {
      reverse: false
    };
    $scope.mdbCheck = null;
    $rootScope.busy = true;
    $scope.availableFilters = PrescUtils.availableFilters();
    draftOrdonnancesPromise = $q.defer();
    Ordonnance.query({
      patient: $rootScope.currentPatient.id,
      'states': ['SAVED_DRAFT', 'DRAFT']
    }).$promise.then(function(carts) {
      var i, len, ordonnance, ref;
      $scope.draft_ordonnances = carts;
      ref = $scope.draft_ordonnances;
      for (i = 0, len = ref.length; i < len; i++) {
        ordonnance = ref[i];
        if (ordonnance.author.id === $scope.user.id && ordonnance.state === "DRAFT") {
          $scope.draft_ordonnance = ordonnance;
          break;
        }
      }
      return draftOrdonnancesPromise.resolve();
    });
    $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      var confirm_dialog, i18n, msg, ref, userCarts;
      if (event.defaultPrevented) {
        return;
      }
      if ((ref = toState.name) === 'user.patient.stay.medication.prescription-templates' || ref === 'user.patient.stay.medication.new_prescription' || ref === 'user.patient.stay.medication.pap' || ref === 'user.patient.stay.medication.current' || ref === 'user.patient.stay.medication.cart' || ref === 'user.patient.stay.medication.renew') {
        return;
      }
      userCarts = _.filter($scope.draft_ordonnances, function(cart) {
        return cart.author.username === $scope.user.username && cart.state === "DRAFT";
      });
      if (userCarts.length === 0) {
        return;
      }
      event.preventDefault();
      $rootScope.busy = true;
      i18n = $filter('translate');
      msg = userCarts.length + " " + i18n("CONFIRM_QUIT_HEADER") + $scope.user.full_name;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'medication/views/modal-template-presc-cart-quit.html',
        controller: 'mhModalPrescCartCtrl',
        size: "lg",
        resolve: {
          title: function() {
            return msg;
          },
          text: function() {
            return i18n("DO_YOU_WANT_TO_GO_TO_CART");
          },
          cancelButtonText: function() {
            return i18n("RETURN");
          },
          saveButtonText: function() {
            return i18n("CURRENT_CART_TITLE");
          },
          validateButtonText: function() {}
        }
      });
      confirm_dialog.result.then((function(result) {
        $rootScope.busy = false;
        if (result !== "cancel") {
          return $state.go('user.patient.stay.medication.cart');
        }
      }), (function(e) {
        return $rootScope.busy = false;
      }));
    });
    $scope.canEditGroup = function(prescriptionGroup) {
      return $scope.groupsInfo[prescriptionGroup.groupId].last_sequence === prescriptionGroup.lastSequence;
    };
    categoriesByIdDict = {};
    stopped_categories_dict = {};
    $scope.stopPrescription = function(presc) {
      $scope.prescriptionsToStop = [presc];
      $scope.prescriptionGroupToStop = null;
      $scope.stopInfo = {
        reason: null,
        comment: ""
      };
      return $uibModal.open({
        animation: true,
        templateUrl: 'medication/views/modal-stop-prescription.html',
        scope: $scope
      }).result.then(function(stopInfo) {
        var ref;
        presc.data.stop_comment = stopInfo.comment;
        if (stopInfo.reason) {
          presc.data.stop_reason = stopInfo.reason.code;
          presc.data.stop_label = stopInfo.reason.label;
        }
        $rootScope.busy = true;
        presc.state = 'STOPPED';
        if (presc.pds_display) {
          presc.pds_handled = !presc.pds_handled;
        }
        presc.data.stopped_author = $scope.user.full_name;
        if (presc.group) {
          presc.data.original_group = presc.group;
          presc.data.original_group_sequence = presc.group_sequence;
          presc.group = null;
          presc.group_sequence = null;
        }
        presc.expiration_time = moment();
        presc.indication = presc != null ? (ref = presc.indication) != null ? ref.id : void 0 : void 0;
        return Prescription.update({
          id: presc.id
        }, presc).$promise.then(function() {
          var category;
          category = _.find($scope.categories, {
            id: presc.category.id
          });
          _.remove(category.prescriptions, presc);
          category.stopped_prescriptions.push(presc);
          category.groupedPrescriptions = PrescUtils.groupPrescriptions(category.prescriptions);
          category.stoppedGroupedPrescriptions = PrescUtils.groupPrescriptions(category.stopped_prescriptions);
          presc.expiration_time = moment().format();
          $rootScope.busy = false;
          return presc.has_details = false;
        });
      });
    };
    $scope.stopPrescriptionGroup = function(prescriptionGroup) {
      $scope.prescriptionsToStop = _.filter($scope.prescriptions, {
        group: prescriptionGroup.groupId,
        group_sequence: prescriptionGroup.lastSequence
      });
      $scope.prescriptionGroupToStop = prescriptionGroup;
      $scope.stopInfo = {
        reason: null,
        comment: ""
      };
      return $uibModal.open({
        animation: true,
        templateUrl: 'medication/views/modal-stop-prescription.html',
        scope: $scope
      }).result.then(function(stopInfo) {
        var category, promises;
        $rootScope.busy = true;
        category = _.find($scope.categories, {
          id: $scope.prescriptionsToStop[0].category.id
        });
        promises = _.map($scope.prescriptionsToStop, function(presc) {
          presc.data.stop_comment = stopInfo.comment;
          if (stopInfo.reason) {
            presc.data.stop_reason = stopInfo.reason.code;
            presc.data.stop_label = stopInfo.reason.label;
          }
          presc.state = 'STOPPED';
          if (presc.pds_display) {
            presc.pds_handled = !presc.pds_handled;
          }
          presc.data.stopped_author = $scope.user.full_name;
          presc.expiration_time = moment();
          return Prescription.update({
            id: presc.id
          }, presc).$promise.then(function() {
            _.remove(category.prescriptions, presc);
            category.stopped_prescriptions.push(presc);
            presc.has_details = false;
            return presc.expiration_time = moment().format();
          });
        });
        return $q.all(promises).then(function() {
          category.groupedPrescriptions = PrescUtils.groupPrescriptions(category.prescriptions);
          category.stoppedGroupedPrescriptions = PrescUtils.groupPrescriptions(category.stopped_prescriptions);
          return $rootScope.busy = false;
        });
      });
    };
    ref = $scope.prescCategories;
    for (i = 0, len = ref.length; i < len; i++) {
      category = ref[i];
      categoriesByIdDict[category.id] = angular.copy(category);
      categoriesByIdDict[category.id].prescriptions = [];
      categoriesByIdDict[category.id].stopped_prescriptions = [];
      categoriesByIdDict[category.id].groupedPrescriptions = [];
    }
    params = {
      current_prescriptions: true,
      exclude_discharge_prescs: true
    };
    if ($scope.allStays) {
      params.patient = $rootScope.currentPatient.id;
    } else {
      params.stay = $rootScope.currentStay.id;
    }
    SiteVarsUtils.get("PRESCRIPTION_CURRENT_ORDER").then(function(defaultOrder) {
      if (defaultOrder.value) {
        if (_.find($scope.availableFilters, {
          value: defaultOrder.value.value
        })) {
          _.remove($scope.availableFilters, _.find($scope.availableFilters, {
            value: defaultOrder.value.value
          }));
        }
        $scope.availableFilters.push(defaultOrder.value);
        $scope.currentFilter = defaultOrder.value;
      } else {
        $scope.currentFilter = $scope.availableFilters[0];
      }
      return Prescription.query(params).$promise.then(function(prescriptions) {
        return Prescription.getGroupsInfo({
          patient: $rootScope.currentPatient.id
        }).$promise.then(function(groupsInfo) {
          var categories, j, len1, prescription;
          $scope.groupsInfo = groupsInfo;
          $scope.hasPrescription = prescriptions.length > 0;
          categories = [];
          $scope.prescriptions = prescriptions;
          for (j = 0, len1 = prescriptions.length; j < len1; j++) {
            prescription = prescriptions[j];
            category = categoriesByIdDict[prescription.category];
            prescription.category = _.find($scope.prescCategories, {
              id: prescription.category
            });
            if (prescription.state === "STOPPED") {
              if (prescription.hasAlert) {
                category.show_stopped = true;
              }
              category.stopped_prescriptions.push(prescription);
            } else {
              category.prescriptions.push(prescription);
            }
          }
          angular.forEach(categoriesByIdDict, function(category, key) {
            category.groupedPrescriptions = PrescUtils.groupPrescriptions(category.prescriptions);
            category.stoppedGroupedPrescriptions = PrescUtils.groupPrescriptions(category.stopped_prescriptions);
            return categories.push(category);
          });
          $rootScope.busy = false;
          return $scope.categories = $filter('orderBy')(categories, 'order');
        });
      });
    });
    $scope.cancelMDBCheck = function() {
      $scope.mdbCheck = null;
      return $scope.checkedPosologies = [];
    };
    $scope.checkMDB = function() {
      var j, len1, presc, ref1;
      $rootScope.busy = true;
      $scope.stupefiant_products = [];
      ref1 = $scope.prescriptions;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        presc = ref1[j];
        if (presc.state !== "STOPPED") {
          if ((presc.data.bdm_data != null) && presc.data.bdm_data.is_stupefiant === "1" && _.indexOf($scope.stupefiant_products, presc.data.name) === -1) {
            $scope.stupefiant_products.push(presc.data.name);
          }
        }
      }
      if ($rootScope.mh_config.platform === 'mhsi') {
        return Stay.getControlPharma({
          id: $rootScope.currentStay.id
        }).$promise.then(function(result) {
          var k, len2, posologie, ref2;
          $scope.mdbCheck = result;
          $scope.mdbCheck.control_html = $sce.trustAsHtml(result.control_html);
          $scope.mdbCheck.url = $scope.base_iframe_url + '/api_rest/stays/' + $rootScope.currentStay.id + '/control_html?cip=' + _.join(result.cips, '&cip=');
          ref2 = result.check_posologies;
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            posologie = ref2[k];
            if (PrescUtils.getBCBPosologiesCodes[posologie.code] != null) {
              posologie.error_code = PrescUtils.getBCBPosologiesCodes[posologie.code];
            }
          }
          return $rootScope.busy = false;
        });
      } else {
        return Patient.getCurrentCIPS({
          id: $rootScope.currentPatient.id
        }).$promise.then(function(cip_list) {
          return Medicaldb.check({
            drugs: cip_list
          }).$promise.then(function(result) {
            $scope.mdbCheck = result;
            return $rootScope.busy = false;
          });
        });
      }
    };
    $scope.renewPrescriptionGroup = function(prescriptionGroup) {
      var cantRenewReason, j, len1, prescription, prescriptionsToRenew;
      prescriptionsToRenew = _.filter($scope.prescriptions, {
        group: prescriptionGroup.groupId,
        group_sequence: prescriptionGroup.lastSequence
      });
      cantRenewReason = false;
      for (j = 0, len1 = prescriptionsToRenew.length; j < len1; j++) {
        prescription = prescriptionsToRenew[j];
        if (prescription.child_prescription != null) {
          cantRenewReason = $filter('translate')("Already renew");
          break;
        }
        if (prescription.data.type === 'dates') {
          cantRenewReason = $filter('translate')("Cant renew planning dates");
          break;
        }
      }
      if (cantRenewReason) {
        return $uibModal.open({
          animation: true,
          templateUrl: 'core/views/modal-template.html',
          size: "lg",
          controller: 'mhModalCtrl',
          resolve: {
            title: function() {
              return $filter('translate')('CANT RENEW THIS PRESCRIPTION');
            },
            text: function() {
              return cantRenewReason;
            },
            cancelButtonText: function() {
              return '';
            },
            noButtonText: function() {
              return '';
            },
            okButtonText: function() {
              return $filter('translate')("CONFIRM");
            }
          }
        });
      } else {
        $rootScope.busy = true;
        return draftOrdonnancesPromise.promise.then(function() {
          var draftOrdonnancePromise;
          draftOrdonnancePromise = $q.defer();
          if ($scope.draft_ordonnance != null) {
            draftOrdonnancePromise.resolve($scope.draft_ordonnance);
          } else {
            Ordonnance.save({
              stay: $rootScope.currentStay.id,
              state: "DRAFT",
              author: $scope.user.id
            }).$promise.then(function(ordonnance) {
              $scope.draft_ordonnances.push(ordonnance);
              $scope.draft_ordonnance = ordonnance;
              return draftOrdonnancePromise.resolve(ordonnance);
            });
          }
          return draftOrdonnancePromise.promise.then(function(ordonnance) {
            return $q.all(_.map(prescriptionsToRenew, function(prescription) {
              var newPrescription;
              newPrescription = PrescUtils.setupPrescriptionFromParent(prescription, $scope.timeSlots, "RENEW", ordonnance, $scope.user);
              newPrescription.group = prescriptionGroup.groupId;
              newPrescription.group_sequence = prescriptionGroup.lastSequence + 1;
              return Prescription.save(newPrescription).$promise;
            })).then(function(prescriptions) {
              var k, len2;
              for (k = 0, len2 = prescriptions.length; k < len2; k++) {
                prescription = prescriptions[k];
                _.find(prescriptionsToRenew, {
                  id: prescription.parent_prescription
                }).child_prescription = prescription.id;
              }
              $scope.groupsInfo[prescriptionGroup.groupId].last_sequence = prescriptionGroup.lastSequence + 1;
              return $rootScope.busy = false;
            });
          });
        });
      }
    };
    return $scope.renewPresc = function(presc) {
      var canRenewDict, cant_renew_reason;
      $rootScope.busy = true;
      cant_renew_reason = null;
      canRenewDict = $scope.handleCanRenew(presc);
      if (!canRenewDict.canRenew) {
        $rootScope.busy = false;
        return $uibModal.open({
          animation: true,
          templateUrl: 'core/views/modal-template.html',
          size: "lg",
          controller: 'mhModalCtrl',
          resolve: {
            title: function() {
              return $filter('translate')('CANT RENEW THIS PRESCRIPTION');
            },
            text: function() {
              return canRenewDict.reason;
            },
            cancelButtonText: function() {
              return '';
            },
            noButtonText: function() {
              return '';
            },
            okButtonText: function() {
              return $filter('translate')("CONFIRM");
            }
          }
        });
      } else {
        return draftOrdonnancesPromise.promise.then(function() {
          var draftOrdonnancePromise;
          draftOrdonnancePromise = $q.defer();
          if ($scope.draft_ordonnance != null) {
            draftOrdonnancePromise.resolve($scope.draft_ordonnance);
          } else {
            Ordonnance.save({
              stay: $rootScope.currentStay.id,
              state: "DRAFT",
              author: $scope.user.id
            }).$promise.then(function(ordonnance) {
              $scope.draft_ordonnances.push(ordonnance);
              $scope.draft_ordonnance = ordonnance;
              return draftOrdonnancePromise.resolve(ordonnance);
            });
          }
          return draftOrdonnancePromise.promise.then(function(ordonnance) {
            var ref1;
            presc.indication = presc != null ? (ref1 = presc.indication) != null ? ref1.id : void 0 : void 0;
            return Prescription.save(PrescUtils.setupPrescriptionFromParent(presc, $scope.timeSlots, "RENEW", ordonnance, $scope.user)).$promise.then(function(prescription) {
              presc.child_prescription = prescription.id;
              return $rootScope.busy = false;
            });
          });
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=current-prescription-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:mhModalCtrl
    * @description
    * # mhModalCtrl
    * Provider of mhModalCtrl
   */
  angular.module("mhclientApp").controller('PrescRenewAllCtrl', ["$scope", "$rootScope", "$q", "$filter", "$state", "Prescription", "PrescUtils", "SiteVarsUtils", function($scope, $rootScope, $q, $filter, $state, Prescription, PrescUtils, SiteVarsUtils) {
    var categoriesByIdDict;
    $rootScope.busy = true;
    $scope.getRenewCount = function() {
      var count;
      count = 0;
      if (typeof categoriesByIdDict !== "undefined" && categoriesByIdDict !== null) {
        angular.forEach(categoriesByIdDict, function(category, key) {
          var i, len, prescGroup, ref, results;
          ref = category.groupedPrescToRenew;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            prescGroup = ref[i];
            results.push(count += prescGroup.prescriptions.length);
          }
          return results;
        });
      }
      return count;
    };
    $scope.canRenewGroup = function(prescriptionGroup) {
      return _.find(prescriptionGroup.prescriptions, {
        can_renew: true
      });
    };
    $scope.addToRenew = function(prescGroup, categoryDict) {
      var group;
      _.remove(categoryDict.groupedOtherPresc, prescGroup);
      group = _.find(categoryDict.groupedPrescToRenew, {
        groupId: prescGroup.groupId
      });
      if (group) {
        return group.prescriptions = group.prescriptions.concat(prescGroup.prescriptions);
      } else {
        return categoryDict.groupedPrescToRenew.push(prescGroup);
      }
    };
    $scope.doNotRenew = function(prescGroup, categoryDict) {
      _.remove(categoryDict.groupedPrescToRenew, prescGroup);
      return categoryDict.groupedOtherPresc.push(prescGroup);
    };
    categoriesByIdDict = {};
    SiteVarsUtils.get('RENEW_ALL_EXPIRED_DELAY', 7).then(function(sitevar) {
      var category, expired_delay, i, len, params, ref;
      expired_delay = sitevar.value;
      $scope.prescOrder = ['data.template.order', 'data.name', 'timestamp', 'id'];
      ref = $scope.prescCategories;
      for (i = 0, len = ref.length; i < len; i++) {
        category = ref[i];
        categoriesByIdDict[category.id] = angular.copy(category);
        categoriesByIdDict[category.id].prescToRenew = [];
        categoriesByIdDict[category.id].otherPresc = [];
        categoriesByIdDict[category.id].groupedPrescToRenew = [];
      }
      params = {
        current_prescriptions: true,
        exclude_discharge_prescs: true
      };
      if ($scope.allStays) {
        params.patient = $rootScope.currentPatient.id;
      } else {
        params.stay = $rootScope.currentStay.id;
      }
      return Prescription.query(params).$promise.then(function(prescriptions) {
        return Prescription.getGroupsInfo({
          patient: $rootScope.currentPatient.id
        }).$promise.then(function(groupsInfo) {
          var canRenewDict, categories, j, len1, prescription;
          $scope.groupsInfo = groupsInfo;
          categories = [];
          $scope.prescriptions = prescriptions;
          for (j = 0, len1 = prescriptions.length; j < len1; j++) {
            prescription = prescriptions[j];
            category = categoriesByIdDict[prescription.category];
            prescription.category = _.find($scope.prescCategories, {
              id: prescription.category
            });
            canRenewDict = $scope.handleCanRenew(prescription, groupsInfo);
            if (canRenewDict.canRenew) {
              prescription.can_renew = true;
              if (prescription.state === "STOPPED") {
                if (prescription.data.stopped_reason !== "STAY_CLOSED" && (moment.duration(moment() - moment(prescription.expiration_time)).asDays() > expired_delay)) {
                  category.otherPresc.push(prescription);
                  prescription.cant_renew_reason = $filter('translate')("RENEW_ALL_EXPIRED_DELAY Exceded");
                  continue;
                }
              }
              category.prescToRenew.push(prescription);
            } else {
              category.otherPresc.push(prescription);
              prescription.cant_renew_reason = canRenewDict.reason;
              prescription.can_renew = false;
            }
          }
          angular.forEach(categoriesByIdDict, function(category, key) {
            category.groupedPrescToRenew = PrescUtils.groupPrescriptions(category.prescToRenew);
            category.groupedOtherPresc = PrescUtils.groupPrescriptions(category.otherPresc);
            return categories.push(category);
          });
          $rootScope.busy = false;
          return $scope.categories = $filter('orderBy')(categories, 'order');
        });
      });
    });
    return $scope.renew = function() {
      var prescriptions, promises;
      $rootScope.busy = true;
      prescriptions = [];
      promises = [];
      return PrescUtils.getOrCreateDraftOrdonnance($rootScope.currentStay.id, $scope.user.id).then(function(ordonnance) {
        angular.forEach(categoriesByIdDict, function(category, key) {
          var i, len, newPrescription, presc, prescGroup, ref, results;
          ref = category.groupedPrescToRenew;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            prescGroup = ref[i];
            results.push((function() {
              var j, len1, ref1, results1;
              ref1 = prescGroup.prescriptions;
              results1 = [];
              for (j = 0, len1 = ref1.length; j < len1; j++) {
                presc = ref1[j];
                newPrescription = PrescUtils.setupPrescriptionFromParent(presc, $scope.timeSlots, "RENEW", ordonnance, $scope.user);
                if (prescGroup.groupId) {
                  newPrescription.group = prescGroup.groupId;
                  newPrescription.group_sequence = prescGroup.lastSequence + 1;
                }
                results1.push(promises.push(Prescription.save(newPrescription).$promise));
              }
              return results1;
            })());
          }
          return results;
        });
        return $q.all(promises).then(function() {
          $rootScope.busy = false;
          return $state.go('user.patient.stay.medication.cart');
        });
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=renew-all-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PrescNewCtrl
    * @description
    * # PrescNewCtrl
    * Controller of Patient new Prescription
   */
  angular.module('mhclientApp').controller('PrescNewCtrl', ["$scope", "$rootScope", "$q", "$state", "$stateParams", "$filter", "Certificate", "SiteVarsUtils", "PrescUtils", "Prescription", "ImageDocument", "$uibModal", "ThesaurusUtils", "Ordonnance", "$window", "$location", "moment", "GenUID", function($scope, $rootScope, $q, $state, $stateParams, $filter, Certificate, SiteVarsUtils, PrescUtils, Prescription, ImageDocument, $uibModal, ThesaurusUtils, Ordonnance, $window, $location, moment, GenUID) {
    var imageDocumentDone, ordonnanceDone, prescriptionDone, prescriptionToDelete;
    $rootScope.busy = true;
    $scope.prescriptions = [];
    $scope.ordonnance = null;
    $scope.attachedDocument = null;
    $scope.controlVars = {
      withSteps: false,
      category: null
    };
    prescriptionToDelete = [];
    $scope.removePrescription = function(prescription) {
      _.remove($scope.prescriptions, prescription);
      if (prescription.id) {
        return prescriptionToDelete.push(prescription);
      }
    };
    $scope.previousState = $state.previous;
    $scope.goTopreviousState = function() {
      if ($scope.previousState) {
        return $state.go($scope.previousState.name);
      } else {
        return $state.go("user.patient.stay.medication.current");
      }
    };
    prescriptionDone = $q.defer();
    ordonnanceDone = $q.defer();
    imageDocumentDone = $q.defer();
    if ($stateParams.prescriptionId) {
      Prescription.get({
        id: $stateParams.prescriptionId
      }).$promise.then(function(prescription) {
        return Ordonnance.get({
          id: prescription.ordonnance
        }).$promise.then(function(ordonnance) {
          $scope.ordonnance = ordonnance;
          prescription.category = _.find($scope.prescCategories, {
            id: prescription.category
          });
          $scope.controlVars.category = prescription.category;
          return prescriptionDone.resolve([prescription]);
        });
      });
    } else if ($stateParams.parentPrescriptionId) {
      Prescription.get({
        id: $stateParams.parentPrescriptionId
      }).$promise.then(function(prescription) {
        prescription.category = _.find($scope.prescCategories, {
          id: prescription.category
        });
        $scope.controlVars.category = prescription.category;
        return prescriptionDone.resolve([PrescUtils.setupPrescriptionFromParent(prescription, $scope.timeSlots, "RENEW")]);
      });
    } else if ($stateParams.prescriptionGroupToModify) {
      if ($stateParams.prescriptionGroupSequence) {
        Prescription.query({
          group: $stateParams.prescriptionGroupToModify,
          patient: $rootScope.currentPatient.id,
          group_sequence: $stateParams.prescriptionGroupSequence
        }).$promise.then(function(prescriptions) {
          return Ordonnance.get({
            id: prescriptions[0].ordonnance
          }).$promise.then(function(ordonnance) {
            $scope.ordonnance = ordonnance;
            $scope.controlVars.category = _.find($scope.prescCategories, {
              id: prescriptions[0].category
            });
            $scope.controlVars.withSteps = true;
            $scope.controlVars.stepsTitle = prescriptions[0].data.group_title;
            $scope.blockSteps = true;
            _.forEach(prescriptions, function(presc) {
              presc.category = $scope.controlVars.category;
              return presc.fold = true;
            });
            return prescriptionDone.resolve($filter('orderBy')(prescriptions, 'data.group_order'));
          });
        });
      }
    } else if ($stateParams.prescriptionGroupToEdit) {
      if ($stateParams.prescriptionGroupSequence) {
        Prescription.query({
          group: $stateParams.prescriptionGroupToEdit,
          patient: $rootScope.currentPatient.id,
          group_sequence: $stateParams.prescriptionGroupSequence
        }).$promise.then(function(prescriptions) {
          var renewedPrescriptions;
          $scope.controlVars.category = _.find($scope.prescCategories, {
            id: prescriptions[0].category
          });
          $scope.controlVars.withSteps = true;
          $scope.controlVars.stepsTitle = prescriptions[0].data.group_title;
          $scope.blockSteps = true;
          renewedPrescriptions = [];
          _.forEach(prescriptions, function(presc) {
            var newPrescription;
            presc.category = $scope.controlVars.category;
            newPrescription = PrescUtils.setupPrescriptionFromParent(presc, $scope.timeSlots, "RENEW");
            newPrescription.fold = true;
            return renewedPrescriptions.push(newPrescription);
          });
          return prescriptionDone.resolve($filter('orderBy')(renewedPrescriptions, 'data.group_order'));
        });
      }
    } else {
      prescriptionDone.resolve([PrescUtils.setupPrescription()]);
    }
    prescriptionDone.promise.then(function() {
      if ($stateParams.ordonnanceId != null) {
        $scope.ordonnanceId = $stateParams.ordonnanceId;
        return Ordonnance.get({
          id: $stateParams.ordonnanceId
        }).$promise.then(function(ordonnance) {
          return ordonnanceDone.resolve(ordonnance);
        });
      } else if ($scope.ordonnance == null) {
        return Ordonnance.query({
          stay: $rootScope.currentStay.id,
          state: "DRAFT",
          author: $scope.user.id
        }).$promise.then(function(ordonnances) {
          if (ordonnances.length > 0) {
            return ordonnanceDone.resolve(ordonnances[0]);
          } else {
            return ordonnanceDone.resolve(null);
          }
        });
      } else {
        return ordonnanceDone.resolve($scope.ordonnance);
      }
    });
    ordonnanceDone.promise.then(function(ordonnance) {
      $scope.ordonnance = ordonnance;
      if (($scope.ordonnance != null) && ($scope.ordonnance.attached_document != null)) {
        return ImageDocument.api.get({
          id: $scope.ordonnance.attached_document
        }).$promise.then(function(image_document) {
          $scope.attachedDocument = image_document;
          return imageDocumentDone.resolve();
        });
      } else {
        return imageDocumentDone.resolve();
      }
    });
    $q.all([prescriptionDone.promise, ordonnanceDone.promise, imageDocumentDone.promise]).then(function(data) {
      var category, i, len, ref, selectable_categories;
      $scope.prescriptions = data[0];
      $scope.ordonnance = data[1];
      selectable_categories = [];
      ref = $scope.prescCategories;
      for (i = 0, len = ref.length; i < len; i++) {
        category = ref[i];
        if (category.state === "ACT" && (category.properties.resumption != null) && category.properties.resumption.indexOf("CREATE") !== -1) {
          if (!(($stateParams.prescriptionId || $stateParams.parentPrescriptionId) && category.name === "PAP_TEMPLATE")) {
            selectable_categories.push(category);
          }
        }
      }
      $scope.categories = selectable_categories;
      if ($rootScope.mh_config.platform === 'mhsi') {
        return Certificate.query().$promise.then(function(certificates) {
          $scope.hasPosos = _.find(certificates, {
            obsolete: false,
            cert_type: 'posos'
          });
          return $rootScope.busy = false;
        });
      } else {
        $scope.hasPosos = false;
        return $rootScope.busy = false;
      }
    });
    $scope.showOrdonnance = function(ordonnanceId) {
      $scope.modalParams = {
        ordonnanceId: ordonnanceId
      };
      return $uibModal.open({
        templateUrl: 'medication/views/pop-up-ordonnance.html',
        controller: 'OrdonnanceCtrl',
        scope: $scope,
        backdrop: 'true',
        animation: false
      });
    };
    $scope.selectCategory = function(category) {
      $scope.controlVars.category = category;
      if (category.name === "PAP_TEMPLATE") {
        return $state.go('user.patient.stay.medication.pap', {
          ordonnanceId: $stateParams.ordonnanceId
        });
      } else {
        return _.forEach($scope.prescriptions, function(prescription) {
          prescription.category = angular.copy(category);
          if (prescription.form) {
            prescription.form.$dirty = true;
          }
          if (category.name === "PAP") {
            return prescription.data.takes = "without";
          }
        });
      }
    };
    $scope.detachDocument = function() {
      $scope.attachedDocument = null;
      if ($scope.ordonnance) {
        $rootScope.busy = true;
        return Ordonnance.update({
          id: $scope.ordonnance.id
        }, {
          id: $scope.ordonnance.id,
          attached_document: null
        }).$promise.then(function() {
          $scope.ordonnance.attached_document = null;
          return $rootScope.busy = false;
        });
      }
    };
    $scope.selectDocumentCallBack = function(imageDocument, ordonnance) {
      if ($scope.hasPosos) {
        return $state.go('user.patient.stay.posos', {
          documentId: imageDocument.id,
          ordonnanceId: ordonnance ? ordonnance.id : null
        });
      } else {
        $scope.attachedDocument = imageDocument;
        if (ordonnance) {
          $rootScope.busy = true;
          return Ordonnance.update({
            id: ordonnance.id
          }, {
            id: ordonnance.id,
            attached_document: imageDocument.id
          }).$promise.then(function() {
            ordonnance.attached_document = imageDocument;
            return $rootScope.busy = false;
          });
        }
      }
    };
    return $scope.submitForm = function() {
      var ordonnance_promise, params;
      $rootScope.busy = true;
      ordonnance_promise = $q.defer();
      if ($scope.ordonnance) {
        ordonnance_promise.resolve($scope.ordonnance);
      } else {
        params = {
          stay: $rootScope.currentStay.id,
          state: "DRAFT",
          author: $scope.user.id
        };
        if ($scope.attachedDocument) {
          params.attached_document = $scope.attachedDocument.id;
        }
        Ordonnance.save(params).$promise.then(function(ordonnance) {
          return ordonnance_promise.resolve(ordonnance);
        });
      }
      return ordonnance_promise.promise.then(function(ordonnance) {
        var group, group_sequence, i, len, order, prescription, prescriptionsPromises, ref, ref1;
        prescriptionsPromises = [];
        if ($stateParams.prescriptionGroupToEdit) {
          group = $stateParams.prescriptionGroupToEdit;
          group_sequence = parseInt($stateParams.prescriptionGroupSequence) + 1;
        } else if ($stateParams.prescriptionGroupToModify) {
          group = $stateParams.prescriptionGroupToModify;
          group_sequence = parseInt($stateParams.prescriptionGroupSequence);
        } else {
          group = $scope.controlVars.withSteps ? GenUID.generate(32) : null;
          group_sequence = $scope.controlVars.withSteps ? 1 : null;
        }
        order = 0;
        ref = $scope.prescriptions;
        for (i = 0, len = ref.length; i < len; i++) {
          prescription = ref[i];
          prescription.group = group;
          prescription.ordonnance = ordonnance.id;
          prescription.indication = prescription != null ? (ref1 = prescription.indication) != null ? ref1.id : void 0 : void 0;
          prescription.data.group_title = $scope.controlVars.stepsTitle;
          if (group) {
            prescription.data.group_order = order;
            order = order + 1;
          }
          prescription.group_sequence = group_sequence;
          if (prescription.form && (prescription.data.resumption || null) === "RENEW" && prescription.form.$dirty) {
            prescription.data.resumption = "RENEW_MODIFY";
          }
          $scope.formatPrescription(prescription);
          if (!prescription.category.show_in_admin) {
            prescription.self_administration = false;
          }
          delete prescription.data.posos_default_posology;
          delete prescription.data.posos_structuration_reliability;
          delete prescription.data.is_posos_pristine;
          if (prescription.id != null) {
            prescription.data.draft_info = {
              "author": $scope.user.full_name,
              "timestamp": moment()
            };
            prescriptionsPromises.push(Prescription.update({
              id: prescription.id
            }, prescription).$promise);
          } else {
            prescriptionsPromises.push(Prescription.save(prescription).$promise);
          }
        }
        return $q.all(prescriptionsPromises).then(function() {
          return $q.all(_.map(prescriptionToDelete, function(prescription) {
            return Prescription["delete"]({
              id: prescription.id
            }).$promise;
          })).then(function() {
            $rootScope.busy = false;
            return $state.go("user.patient.stay.medication.cart");
          });
        });
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=new-prescription-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CurrentPrescriptionCtrl
    * @description
    * # CurrentPrescriptionCtrl
    * Controller of Patient current Prescriptions
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('OrdonnanceCtrl', ["$scope", "$rootScope", "$state", "$q", "$stateParams", "$uibModalInstance", "$anchorScroll", "$filter", "$location", "SiteVarsUtils", "PrescUtils", "Ordonnance", "Prescription", "ImageDocument", "Dispensation", "PharmaValidation", "PharmaDelivery", "CollectionPlanDelivery", function($scope, $rootScope, $state, $q, $stateParams, $uibModalInstance, $anchorScroll, $filter, $location, SiteVarsUtils, PrescUtils, Ordonnance, Prescription, ImageDocument, Dispensation, PharmaValidation, PharmaDelivery, CollectionPlanDelivery) {
    var collectionValidatedDeliveriesDonePromise, deliveryDataDonePromise, dispensationDonePromise, getCartDetails, getUserDispensationRol, groupByCategoryAndGroup, ordonnancesDonePromise, ordonnances_dict, prescriptionsById, prescriptionsDonePromise, validationDataDonePromise;
    $rootScope.busy = true;
    $scope.filters = {
      search_text: ""
    };
    $scope.show_draft = true;
    $scope.has_draft_ordonnances = false;
    $scope.has_discharge_ordonnances = false;
    $scope.need_action_ordonnances_count = 0;
    $scope.has_expired_soon_dispensations = false;
    $scope.has_expired_dispensations = false;
    prescriptionsById = {};
    ordonnances_dict = {};
    $scope.need_dispensation_validation = false;
    if ($uibModalInstance) {
      $stateParams.ordonnanceId = $scope.modalParams.ordonnanceId;
      $scope.isModal = true;
    }
    $scope.closeModal = function() {
      return $uibModalInstance.close(false);
    };
    $scope.filterOrdonnances = function() {
      return $scope.filteredOrdonnances = $filter('ordonnancesFilter')($scope.ordonnances, $scope.filters.search_text, $scope.show_draft);
    };
    getUserDispensationRol = function(user) {
      var hasORD, hasORV;
      hasORV = user.group.features.indexOf("ORV") !== -1;
      hasORD = user.group.features.indexOf("ORD") !== -1;
      if (!$rootScope.checkPermissions("ORD", "CAN_WRITE")) {
        return null;
      }
      if (hasORV && hasORD) {
        return "PHARMACIE";
      } else if (hasORV) {
        return "PHARMACIEN";
      } else if (hasORD) {
        return "PREPARATEUR";
      } else {
        return null;
      }
    };
    ordonnancesDonePromise = $q.defer();
    prescriptionsDonePromise = $q.defer();
    dispensationDonePromise = $q.defer();
    validationDataDonePromise = $q.defer();
    deliveryDataDonePromise = $q.defer();
    collectionValidatedDeliveriesDonePromise = $q.defer();
    $scope.prescriptionGroupsOrder = PrescUtils.prescriptionGroupsOrder;
    SiteVarsUtils.get('CLASICAL_DISPENSATION', true).then(function(sitevar) {
      $scope.clasicalDispensation = sitevar.value;
      return SiteVarsUtils.get('RETRANSCRIPTIONS_NEEDS_CONTROL', false).then(function(sitevar) {
        var categoriesByIdDict;
        $scope.retranscriptionsNeedsControl = sitevar.value;
        categoriesByIdDict = {};
        return PrescUtils.getCategories().promise.then(function(prescCategories) {
          var category, i, len, params;
          for (i = 0, len = prescCategories.length; i < len; i++) {
            category = prescCategories[i];
            categoriesByIdDict[category.id] = category;
          }
          if ($stateParams.ordonnanceId) {
            if ($rootScope.mh_config.platform === "mgapp") {
              $scope.hide_navigation = true;
            }
            Ordonnance.get({
              id: $stateParams.ordonnanceId
            }).$promise.then(function(ordonnance) {
              return ordonnancesDonePromise.resolve([ordonnance]);
            });
            Ordonnance.getPrescriptions({
              id: $stateParams.ordonnanceId
            }).$promise.then(function(prescriptions) {
              prescriptions.forEach(function(prescription) {
                return prescription.category = categoriesByIdDict[prescription.category];
              });
              return prescriptionsDonePromise.resolve(prescriptions);
            });
            Dispensation.query({
              ordonnance: $stateParams.ordonnanceId
            }).$promise.then(function(dispensations) {
              return dispensationDonePromise.resolve(dispensations);
            });
            PharmaValidation.query({
              ordonnance: $stateParams.ordonnanceId
            }).$promise.then(function(validationData) {
              return validationDataDonePromise.resolve(validationData);
            });
            PharmaDelivery.query({
              ordonnance: $stateParams.ordonnanceId
            }).$promise.then(function(deliveryData) {
              return deliveryDataDonePromise.resolve(deliveryData);
            });
            return CollectionPlanDelivery.query({
              state: "VALIDATED",
              ordonnance: $stateParams.ordonnanceId
            }).$promise.then(function(collectionPlanValidatedDeliveries) {
              return collectionValidatedDeliveriesDonePromise.resolve(collectionPlanValidatedDeliveries);
            });
          } else {
            if ($scope.allStays) {
              params = {
                patient: $rootScope.currentPatient.id
              };
            } else {
              params = {
                stay: $rootScope.currentStay.id
              };
            }
            Ordonnance.query(params).$promise.then(function(ordonnances) {
              return ordonnancesDonePromise.resolve(ordonnances);
            });
            Dispensation.query(params).$promise.then(function(dispensations) {
              return dispensationDonePromise.resolve(dispensations);
            });
            Prescription.query(params).$promise.then(function(prescriptions) {
              prescriptions.forEach(function(prescription) {
                return prescription.category = categoriesByIdDict[prescription.category];
              });
              return prescriptionsDonePromise.resolve(prescriptions);
            });
            PharmaValidation.query(params).$promise.then(function(validationData) {
              return validationDataDonePromise.resolve(validationData);
            });
            PharmaDelivery.query(params).$promise.then(function(deliveryData) {
              return deliveryDataDonePromise.resolve(deliveryData);
            });
            return CollectionPlanDelivery.query(_.assign({
              state: "VALIDATED"
            }, params)).$promise.then(function(collectionPlanValidatedDeliveries) {
              return collectionValidatedDeliveriesDonePromise.resolve(collectionPlanValidatedDeliveries);
            });
          }
        });
      });
    });
    ordonnancesDonePromise.promise.then(function(ordonnances) {
      $scope.ordonnances = $filter('orderBy')(ordonnances, '-timestamp');
      $scope.user_role = getUserDispensationRol($scope.user);
      $scope.ordonnances.forEach(function(ordonnance) {
        var ref;
        ordonnance.needControl = ordonnance.attached_document && $scope.retranscriptionsNeedsControl && !(ordonnance.data.control && ordonnance.data.control.controled);
        ordonnances_dict[ordonnance.id] = ordonnance;
        ordonnance.prescriptions = [];
        if (ordonnance.data.is_hospital) {
          $scope.has_hospital_ordonnances = true;
        }
        if ((ref = ordonnance.state) === 'SAVED_DRAFT' || ref === 'DRAFT') {
          ordonnance.is_draft = true;
          $scope.has_draft_ordonnances = true;
        }
        if (ordonnance.discharge_prescription) {
          $scope.has_discharge_ordonnances = true;
          ordonnance.ald_prescriptions = [];
          return ordonnance.non_ald_prescriptions = [];
        }
      });
      return prescriptionsDonePromise.promise.then(function(prescriptions) {
        var validationPharmaPromises;
        prescriptions.forEach(function(prescription) {
          var ordonnance;
          prescriptionsById[prescription.id] = prescription;
          ordonnance = ordonnances_dict[prescription.ordonnance];
          prescription.ordonnance = ordonnance;
          ordonnance.prescriptions.push(prescription);
          if (!prescription.data.dci_display_text) {
            prescription.data.dci_display_text = prescription.data.display_text;
          }
          if (ordonnance.discharge_prescription) {
            if (prescription.data.ald) {
              ordonnance.ald_prescriptions.push(prescription);
            } else {
              ordonnance.non_ald_prescriptions.push(prescription);
            }
          }
          return prescription.dispensations = [];
        });
        dispensationDonePromise.promise.then(function(dispensations) {
          var dispensation, drugDispensation, i, len, prescription, ref, results;
          ref = $filter('orderBy')(dispensations, '-timestamp');
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            dispensation = ref[i];
            results.push((function() {
              var j, len1, ref1, results1;
              ref1 = dispensation.drug_dispensations;
              results1 = [];
              for (j = 0, len1 = ref1.length; j < len1; j++) {
                drugDispensation = ref1[j];
                if (drugDispensation.prescription in prescriptionsById) {
                  prescription = prescriptionsById[drugDispensation.prescription];
                  if (!(prescription.dispensations.length > 0 && _.last(prescription.dispensations).id === dispensation.id)) {
                    prescription.dispensations.push({
                      id: dispensation.id,
                      timestamp: dispensation.timestamp,
                      drug_dispensations: [],
                      state: dispensation.state
                    });
                  }
                  results1.push(_.last(prescription.dispensations).drug_dispensations.push(drugDispensation));
                } else {
                  results1.push(void 0);
                }
              }
              return results1;
            })());
          }
          return results;
        });
        validationPharmaPromises = [validationDataDonePromise.promise, deliveryDataDonePromise.promise, collectionValidatedDeliveriesDonePromise.promise];
        return $q.all(validationPharmaPromises).then(function(validationPharmaData) {
          var i, len, pharmaValidation, ref;
          ref = validationPharmaData[0];
          for (i = 0, len = ref.length; i < len; i++) {
            pharmaValidation = ref[i];
            if (!(pharmaValidation.prescription in prescriptionsById)) {
              continue;
            }
            prescriptionsById[pharmaValidation.prescription].pharmaValidation = pharmaValidation;
            pharmaValidation.pharma_delivery = _.find(validationPharmaData[1], {
              prescription: pharmaValidation.prescription
            });
            if (pharmaValidation.pharma_delivery) {
              pharmaValidation.pharma_delivery.validated_collections = _.filter(validationPharmaData[2], {
                pharma_delivery: pharmaValidation.pharma_delivery.id
              });
            }
          }
          if (!$scope.isModal && $scope.user_role && !($rootScope.mh_config.platform === "mgapp")) {
            if ($scope.clasicalDispensation) {
              prescriptions.forEach(function(prescription) {
                var ddisp, j, len1, ref1, ref2, remaining_days, status;
                if (prescription.state !== "STOPPED" && prescription.dispensable && !((ref1 = prescription.ordonnance.state) === 'SAVED_DRAFT' || ref1 === 'DRAFT')) {
                  prescription.ordonnance.dispensable = true;
                  status = "INITIAL";
                  if (prescription.dispensations.length > 0) {
                    prescription.last_dispensation = prescription.dispensations[0];
                    prescription.ordonnance.has_dispensation = true;
                    if (prescription.last_dispensation.state === 'PE') {
                      status = "PREPARED";
                      prescription.ordonnance.has_dispensation_to_delivery = true;
                      prescription.ordonnance.dispensation_to_delivery_url = $scope.base_iframe_url + '/webfw/pat_mgr/export_ori_prep/' + prescription.ordonnance.id;
                    } else {
                      status = "DELIVERED";
                    }
                    ref2 = prescription.last_dispensation.drug_dispensations;
                    for (j = 0, len1 = ref2.length; j < len1; j++) {
                      ddisp = ref2[j];
                      if (ddisp.duration) {
                        remaining_days = ddisp.duration - moment().diff(moment(prescription.last_dispensation.timestamp), "days");
                        if (remaining_days < 0) {
                          $scope.has_expired_dispensations = true;
                          prescription.expired_dispensation = true;
                          prescription.ordonnance.has_expired_dispensation = true;
                          status = "EXPIRED";
                        } else if (remaining_days < 3) {
                          $scope.has_expired_soon_dispensations = true;
                          prescription.expired_soon_dispensation = true;
                          prescription.ordonnance.has_expired_soon = true;
                        }
                      }
                    }
                  }
                  if (($scope.user_role === "PREPARATEUR" && (status === "INITIAL" || status === "EXPIRED")) || ($scope.user_role === "PHARMACIEN" && (status === "PREPARED" || status === "EXPIRED")) || ($scope.user_role === "PHARMACIE" && (status === "PREPARED" || status === "INITIAL" || status === "EXPIRED"))) {
                    if (prescription.ordonnance.data.is_hospital || ((prescription.category.properties.flags != null) && indexOf.call(prescription.category.properties.flags, "hospital") >= 0)) {
                      prescription.ordonnance.data.is_hospital = true;
                      if (!(indexOf.call($scope.user.group.features, "DISP_HOSPITAL") >= 0)) {
                        return;
                      }
                    } else if (indexOf.call($scope.user.group.features, "DISP_HOSPITAL") >= 0) {
                      return;
                    }
                    if (!prescription.ordonnance.need_action) {
                      $scope.need_action_ordonnances_count += 1;
                    }
                    prescription.need_action = true;
                    return prescription.ordonnance.need_action = true;
                  }
                }
              });
            } else {
              prescriptions.forEach(function(prescription) {
                var ddisp, drug_ddisp_actions, j, len1, ref1, ref2, ref3, remaining_days;
                drug_ddisp_actions = [];
                if (prescription.state !== "STOPPED" && prescription.dispensable && !((ref1 = prescription.ordonnance.state) === 'SAVED_DRAFT' || ref1 === 'DRAFT')) {
                  prescription.ordonnance.dispensable = true;
                  $scope.need_dispensation_validation = false;
                  prescription.ordonnance.need_dispensation_validation = false;
                  prescription.need_dispensation_validation = false;
                  $scope.need_dispensation = false;
                  prescription.ordonnance.need_dispensation = false;
                  prescription.need_dispensation = false;
                  if (prescription.dispensations.length > 0) {
                    prescription.need_action = false;
                    prescription.ordonnance.need_action = false;
                    prescription.ordonnance.dispensation_delivered = true;
                    prescription.last_dispensation = prescription.dispensations[0];
                    ref2 = prescription.last_dispensation.drug_dispensations;
                    for (j = 0, len1 = ref2.length; j < len1; j++) {
                      ddisp = ref2[j];
                      drug_ddisp_actions.push(ddisp.data.action);
                      if (ddisp.duration) {
                        remaining_days = ddisp.duration - moment().diff(moment(prescription.last_dispensation.timestamp), "days");
                        if (remaining_days < 0) {
                          $scope.has_expired_dispensations = true;
                          prescription.expired_dispensation = true;
                          prescription.ordonnance.has_expired_dispensation = true;
                        } else if (remaining_days < 3) {
                          $scope.has_expired_soon_dispensations = true;
                          prescription.expired_soon_dispensation = true;
                          prescription.ordonnance.has_expired_soon = true;
                        }
                      }
                    }
                    if (drug_ddisp_actions.indexOf("DELIVER") < 0) {
                      prescription.need_dispensation = true;
                      prescription.ordonnance.need_dispensation = true;
                      $scope.need_dispensation = true;
                      prescription.ordonnance.dispensation_delivered = false;
                    }
                    if (drug_ddisp_actions.indexOf("VALIDATE") < 0) {
                      prescription.need_dispensation_validation = true;
                      prescription.ordonnance.need_dispensation_validation = true;
                      $scope.need_dispensation_validation = true;
                    }
                    if (drug_ddisp_actions.indexOf("NOACTION") > -1) {
                      $scope.need_dispensation_validation = true;
                      prescription.ordonnance.need_dispensation_validation = true;
                      prescription.need_dispensation_validation = true;
                      $scope.need_dispensation = true;
                      prescription.ordonnance.need_dispensation = true;
                      prescription.need_dispensation = true;
                    }
                    if (prescription.last_dispensation.state === 'VA') {
                      prescription.ordonnance.has_dispensation_to_delivery = true;
                      prescription.ordonnance.dispensation_to_delivery_url = $scope.base_iframe_url + '/webfw/pat_mgr/export_ori_prep/' + prescription.ordonnance.id;
                    } else {
                      prescription.ordonnance.dispensation_delivered = false;
                    }
                  } else {
                    $scope.need_dispensation_validation = true;
                    prescription.ordonnance.need_dispensation_validation = true;
                    prescription.need_dispensation_validation = true;
                    $scope.need_dispensation = true;
                    prescription.ordonnance.need_dispensation = true;
                    prescription.need_dispensation = true;
                    prescription.need_action = true;
                    prescription.ordonnance.need_action = true;
                  }
                  if ((ref3 = $scope.user_role) === "PREPARATEUR" || ref3 === "PHARMACIEN" || ref3 === "PHARMACIE") {
                    if (prescription.ordonnance.data.is_hospital || ((prescription.category.properties.flags != null) && indexOf.call(prescription.category.properties.flags, "hospital") >= 0)) {
                      prescription.ordonnance.data.is_hospital = true;
                      if (!(indexOf.call($scope.user.group.features, "DISP_HOSPITAL") >= 0)) {
                        return;
                      }
                    } else if (indexOf.call($scope.user.group.features, "DISP_HOSPITAL") >= 0) {
                      return;
                    }
                    if (prescription.ordonnance.need_action) {
                      $scope.need_action_ordonnances_count += 1;
                    }
                    if (!prescription.ordonnance.dispensation_delivered) {
                      prescription.need_action = true;
                      return prescription.ordonnance.need_action = true;
                    }
                  }
                }
              });
            }
          }
          $rootScope.busy = false;
          $scope.filteredOrdonnances = $scope.filterOrdonnances();
          if ($scope.filteredOrdonnances.length > 0) {
            return $scope.selectordonnance($scope.filteredOrdonnances[0]);
          }
        });
      });
    });
    groupByCategoryAndGroup = function(prescriptions) {
      var categories_dict, i, len, prescriptionsByCategory, prescriptions_by_category;
      prescriptions_by_category = [];
      categories_dict = {};
      prescriptions.forEach(function(prescription) {
        var category;
        category = prescription.category;
        if (categories_dict[category.id] != null) {
          return categories_dict[category.id].prescriptions.push(prescription);
        } else {
          categories_dict[category.id] = {
            "label": category.label,
            "prescriptions": [prescription],
            "order": category.order
          };
          return prescriptions_by_category.push(categories_dict[category.id]);
        }
      });
      for (i = 0, len = prescriptions_by_category.length; i < len; i++) {
        prescriptionsByCategory = prescriptions_by_category[i];
        prescriptionsByCategory.groupedPrescriptions = PrescUtils.groupPrescriptions(prescriptionsByCategory.prescriptions);
      }
      return prescriptions_by_category;
    };
    $scope.selectordonnance = function(ordonnance) {
      $rootScope.busy = true;
      if (!ordonnance.discharge_prescription && (ordonnance.prescriptions_by_category == null)) {
        ordonnance.prescriptions_by_category = groupByCategoryAndGroup(ordonnance.prescriptions);
      } else if (ordonnance.discharge_prescription && !((ordonnance.ald_prescriptions_by_category != null) || (ordonnance.non_ald_prescriptions_by_category != null))) {
        ordonnance.ald_prescriptions_by_category = groupByCategoryAndGroup(ordonnance.ald_prescriptions);
        ordonnance.non_ald_prescriptions_by_category = groupByCategoryAndGroup(ordonnance.non_ald_prescriptions);
      }
      getCartDetails(ordonnance).promise.then(function() {
        return $rootScope.busy = false;
      });
      $scope.current_ordonnance = ordonnance;
      $location.hash('top');
      return $anchorScroll();
    };
    return getCartDetails = function(cart) {
      var cartDetailsPromise;
      cartDetailsPromise = $q.defer();
      if (!cart.has_details) {
        if ((cart.attached_document != null) && typeof cart.attached_document === 'number') {
          ImageDocument.api.get({
            id: cart.attached_document
          }).$promise.then(function(image_document) {
            cart.attached_document = image_document;
            cartDetailsPromise.resolve();
            return cart.has_details = true;
          });
        } else {
          cartDetailsPromise.resolve();
          cart.has_details = true;
        }
      } else {
        cartDetailsPromise.resolve();
      }
      return cartDetailsPromise;
    };
  }]);

}).call(this);

//# sourceMappingURL=ordonnance-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:shortcut
    * @description
    * # previewDisplay
    * Display shortcuts of registered words
   */
  angular.module('mhclientApp').filter('ordonnancesFilter', function() {
    return function(ordonnances, search_text, show_draft) {
      var _check_dispensations, _check_drug_dispensations, _check_prescription, filtered, has_search_text, i, len, ordonnance, ref, regex, searchVal;
      if (ordonnances == null) {
        return [];
      }
      filtered = [];
      has_search_text = (search_text != null) && search_text.length > 0;
      if (has_search_text) {
        searchVal = search_text.replace(/([()[{*+.$^\\|?])/g, '\\$1');
        regex = new RegExp('' + searchVal, 'i');
      }
      _check_drug_dispensations = function(drug_dispensation) {
        return regex.test(drug_dispensation.data.display_extended_html);
      };
      _check_dispensations = function(dispensation) {
        return _.some(dispensation.drug_dispensations, _check_drug_dispensations);
      };
      _check_prescription = function(prescription) {
        return regex.test(prescription.data.display_text) || _.some(prescription.dispensations, _check_dispensations);
      };
      for (i = 0, len = ordonnances.length; i < len; i++) {
        ordonnance = ordonnances[i];
        if (has_search_text) {
          if (!(regex.test(ordonnance.author.full_name) || _.some(ordonnance.prescriptions, _check_prescription))) {
            ordonnance.hidden = true;
            continue;
          }
        }
        if (!show_draft && ((ref = ordonnance.state) === 'SAVED_DRAFT' || ref === 'DRAFT')) {
          ordonnance.hidden = true;
          continue;
        }
        ordonnance.hidden = false;
        filtered.push(ordonnance);
      }
      return filtered;
    };
  });

}).call(this);

//# sourceMappingURL=ordonnances-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:Dispensation
    * @description
    * # DispensationCtrl
    * Controller of Patient dispensation
   */
  angular.module('mhclientApp').controller('DispensationCtrl', ["$scope", "$rootScope", "$window", "$sce", "$stateParams", "$uibModal", "$filter", "Medicaldb", "PrescUtils", "Stay", function($scope, $rootScope, $window, $sce, $stateParams, $uibModal, $filter, Medicaldb, PrescUtils, Stay) {
    var dispensation_iframe_url;
    $rootScope.busy = true;
    $scope.mdbCheck = null;
    dispensation_iframe_url = $scope.base_iframe_url + '/webfw/careplan_mgr/stay_' + $rootScope.currentStay.id;
    if ($scope.allStays) {
      dispensation_iframe_url = dispensation_iframe_url + "/pat_" + $rootScope.currentPatient.id;
    }
    if ($stateParams.dispensationId != null) {
      dispensation_iframe_url = dispensation_iframe_url + '/ori_' + $stateParams.dispensationId;
    }
    $scope.dispensation_iframe_url = dispensation_iframe_url + '/ordonnance/dispensation/';
    $scope.options = {
      messageCallback: function(response) {
        var confirm_dialog, has_action_to_do, has_not_structured, text;
        if (response.message.type === "mhc_get_interaction_codes_response") {
          return $scope.checkInterContra("check", response.message.mdb_codes);
        } else if (response.message.type === "mhc_presend_response") {
          has_action_to_do = response.message.has_action_to_do;
          has_not_structured = response.message.has_not_structured;
          if (!has_action_to_do && !has_not_structured) {
            return $scope.checkInterContra("submit", response.message.mdb_codes);
          } else {
            text = [];
            if (has_action_to_do) {
              text.push($filter('translate')("You don't make action fo all the deliveries."));
            }
            if (has_not_structured) {
              text.push($filter('translate')('Not structured presc when calculating interactions.'));
            }
            text.push($filter('translate')('Are you sure to send the dispensations ?'));
            confirm_dialog = $uibModal.open({
              animation: true,
              templateUrl: 'core/views/modal-template.html',
              size: "lg",
              controller: 'mhModalCtrl',
              resolve: {
                title: function() {
                  return $filter('translate')('Warning when sending dispensation');
                },
                text: function() {
                  return text.join("\n");
                },
                cancelButtonText: function() {
                  return $filter('translate')("Return to screen");
                },
                noButtonText: function() {
                  return '';
                },
                okButtonText: function() {
                  return $filter('translate')(!has_action_to_do ? "CONFIRM" : 'Continue(i will make dispensation later)');
                }
              }
            });
            return confirm_dialog.result.then(function(result) {
              if (result) {
                return $scope.checkInterContra("submit", response.message.mdb_codes);
              }
            });
          }
        } else {
          $window.scrollTo(0, 0);
          $rootScope.busy = false;
          return $scope.$digest();
        }
      }
    };
    $scope.checkInterContra = function(type, drugs) {
      $rootScope.busy = true;
      return Stay.getControlPharma({
        id: $rootScope.currentStay.id,
        cip: _.uniq(_.map(drugs, 'cip'))
      }).$promise.then(function(result) {
        var i, len, posologie, ref;
        $scope.mdbCheck = result;
        $scope.mdbCheck.patientName = $rootScope.currentPatient.full_name;
        $scope.mdbCheck.type = type;
        $scope.mdbCheck.control_html = $sce.trustAsHtml(result.control_html);
        $scope.mdbCheck.url = $scope.base_iframe_url + '/api_rest/stays/' + $rootScope.currentStay.id + '/control_html?cip=' + _.join(result.cips, '&cip=');
        $scope.mdbCheck.printUrl = $scope.base_iframe_url + '/api_rest/stays/' + $rootScope.currentStay.id + '/control_pdf?cip=' + _.join(result.cips, '&cip=');
        ref = result.check_posologies;
        for (i = 0, len = ref.length; i < len; i++) {
          posologie = ref[i];
          if (PrescUtils.getBCBPosologiesCodes[posologie.code] != null) {
            posologie.error_code = PrescUtils.getBCBPosologiesCodes[posologie.code];
          }
        }
        return $rootScope.busy = false;
      });
    };
    $scope.confirmDispensation = function() {
      $rootScope.busy = true;
      $window.postMessage("mhc_submit", '*');
      $scope.mdbCheck = null;
      return $scope.checkedPosologies = null;
    };
    $scope.cancelDispensation = function() {
      $scope.mdbCheck = null;
      return $scope.checkedPosologies = null;
    };
    $scope.iframeLoadCallback = function() {
      return $rootScope.$evalAsync(function() {
        return $rootScope.busy = false;
      });
    };
    $scope.send = function() {
      return $window.postMessage("mhc_presend", '*');
    };
    $scope.showInteractions = function() {
      return $window.postMessage("mhc_get_interaction_codes", '*');
    };
    return $scope.$on("$destroy", function() {
      return $rootScope.busy = false;
    });
  }]);

}).call(this);

//# sourceMappingURL=dispensation-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:administration
    * @description
    * Directive drug administration
   */
  angular.module('mhclientApp').directive('administration', function() {
    return {
      restrict: 'E',
      templateUrl: 'medication/views/administration.html',
      compile: function(element, attrs) {
        if (attrs.isDirty == null) {
          attrs.isDirty = "false";
        }
        if (attrs.readOnly == null) {
          return attrs.readOnly = "false";
        }
      },
      scope: {
        patient: '=',
        stay: '=',
        allStays: '=',
        view: '@',
        hideSaveButton: "=",
        isDirty: "=",
        readOnly: "="
      },
      controller: 'AdministrationCtrl'
    };
  });

}).call(this);

//# sourceMappingURL=administration-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:AdministrationCtrl
    * @description
    * # AdministrationCtrl
    * Controller of drug Administration
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").controller('PillBoxCtrl', ["$scope", "$rootScope", "$sce", "$timeout", "$uibModal", "$state", "$filter", "$uibModalInstance", "task", "PrescUtils", "prescription", "status", "code", function($scope, $rootScope, $sce, $timeout, $uibModal, $state, $filter, $uibModalInstance, task, PrescUtils, prescription, status, code) {
    var days, i, j, newDate, ref, removeSlot, selecSlot, startDate, taskInfo;
    days = code.action === "DAYLY_PILLBOX" ? 1 : 7;
    $scope.task = task;
    $scope.prescription = prescription;
    $scope.pillBoxDates = [];
    $scope.code = code;
    startDate = moment(task.date).format($scope.dateFormat);
    taskInfo = $scope.getTaskInfo($scope.task);
    PrescUtils.getPrescriptionDetails($scope.prescription, true);
    $scope.genSelectedDisplay = function(pillBoxDate, timeSlot) {
      var display;
      task = _.find($scope.prescription.sequence.dates[pillBoxDate].timeSlots, {
        time_slot: timeSlot.id
      });
      display = [];
      if ($scope.choices.code) {
        display.push($scope.choices.code);
      }
      if ($scope.user.user_profile.initials) {
        display.push($scope.user.user_profile.initials);
      }
      if (task.state === "NEW") {
        display.push(task.displayQuantity + " " + task.displayTakingUnit);
      } else if ($scope.choices.quantity) {
        display.push($scope.choices.quantity + " " + $scope.choices.taking_unit_label);
      }
      return $sce.trustAsHtml(display.join("<br>"));
    };
    $scope.choices = {
      quantity: taskInfo.quantity,
      code: code.code,
      state: status.state,
      taking_unit_label: taskInfo.taking_unit_label,
      comment: task.data.comment,
      label: code.label,
      hasQuantity: status.has_quantity,
      needQuantity: status.need_quantity
    };
    $scope.selectedSlots = [
      {
        date: task.date,
        timeslot: task.time_slot
      }
    ];
    $scope.toggledTimeSlots = [];
    $scope.toggledDates = [];
    $scope.toggleDate = function(date) {
      if (indexOf.call($scope.toggledDates, date) >= 0) {
        _.pull($scope.toggledDates, date);
        return _.map($scope.timeSlots, function(timeSlot) {
          return removeSlot(date, timeSlot.id);
        });
      } else {
        $scope.toggledDates.push(date);
        return _.map($scope.timeSlots, function(timeSlot) {
          return selecSlot(date, timeSlot.id);
        });
      }
    };
    $scope.toggleTimeSlot = function(timeSlot) {
      if (indexOf.call($scope.toggledTimeSlots, timeSlot) >= 0) {
        _.remove($scope.toggledTimeSlots, timeSlot);
        return _.map($scope.pillBoxDates, function(date) {
          return removeSlot(date, timeSlot.id);
        });
      } else {
        $scope.toggledTimeSlots.push(timeSlot);
        return _.map($scope.pillBoxDates, function(date) {
          return selecSlot(date, timeSlot.id);
        });
      }
    };
    $scope.toggleSlot = function(date, timeSlotId) {
      if (!_.find($scope.selectedSlots, {
        date: date,
        timeslot: timeSlotId
      })) {
        return selecSlot(date, timeSlotId);
      } else {
        return removeSlot(date, timeSlotId);
      }
    };
    selecSlot = function(date, timeSlotId) {
      var ref;
      if (!$scope.prescription.sequence.dates[date] || !$scope.prescription.sequence.dates[date].editable) {
        return;
      }
      task = _.find($scope.prescription.sequence.dates[date].timeSlots, {
        time_slot: timeSlotId
      });
      if (task !== $scope.task && ((ref = task.state || "NEW") === "OK" || ref === "NOK")) {
        return;
      }
      if (!_.find($scope.selectedSlots, {
        date: date,
        timeslot: timeSlotId
      })) {
        return $scope.selectedSlots.push({
          date: date,
          timeslot: timeSlotId
        });
      }
    };
    removeSlot = function(date, timeSlotId) {
      var slotToRemove;
      slotToRemove = _.find($scope.selectedSlots, {
        date: date,
        timeslot: timeSlotId
      });
      if (slotToRemove) {
        return _.remove($scope.selectedSlots, slotToRemove);
      }
    };
    $scope.timeSlotSelected = function(date, timeSlotId) {
      return _.find($scope.selectedSlots, {
        date: date,
        timeslot: timeSlotId
      });
    };
    for (i = j = 0, ref = days; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      newDate = moment(startDate);
      newDate.add(i, "days");
      $scope.pillBoxDates.push(newDate.format($scope.dateFormat));
    }
    $rootScope.busy = true;
    $scope.fetchTasks($scope.pillBoxDates).then(function(familiesToShow) {
      return $rootScope.busy = false;
    });
    $scope.close = function() {
      return $uibModalInstance.close(false);
    };
    return $scope.save = function() {
      return $uibModalInstance.close({
        choices: $scope.choices,
        slots: $scope.selectedSlots
      });
    };
  }]);

  angular.module("mhclientApp").controller('EditTaskCtrl', ["$scope", "$rootScope", "$timeout", "$uibModal", "$state", "$filter", "$uibModalInstance", "PrescUtils", "category", "availableStatus", "task", "prescription", function($scope, $rootScope, $timeout, $uibModal, $state, $filter, $uibModalInstance, PrescUtils, category, availableStatus, task, prescription) {
    var code, status, taskInfo;
    $scope.freeTakingUnitSelection = function() {
      var modal;
      modal = $uibModal.open({
        templateUrl: 'core/views/modal-selection-template.html',
        backdrop: 'static',
        controller: 'ModalSelectionCtrl',
        resolve: {
          label: function() {
            return "TAKING_UNIT_SELECTION";
          },
          choices: function() {
            return PrescUtils.taking_units;
          },
          lookUpField: function() {
            return "label";
          }
        }
      });
      return modal.result.then(function(taking_unit) {
        if (taking_unit) {
          return $scope.choices.taking_unit_label = taking_unit.label;
        }
      });
    };
    $scope.task = task;
    taskInfo = $scope.getTaskInfo($scope.task);
    $scope.prescription = prescription;
    PrescUtils.getPrescriptionDetails($scope.prescription, true);
    $scope.defaultAdminCode = {};
    $scope.multipleAdminChecked = false;
    $scope.selectCode = function(status, code) {
      var ref;
      if ((ref = code.action) === "DAYLY_PILLBOX" || ref === "WEEKLY_PILLBOX") {
        $scope.showPillBox(status, code, task, prescription);
        return $scope.close();
      } else {
        $scope.choices.state = status.state;
        $scope.choices.code = code.code;
        $scope.choices.label = code.label;
        $scope.choices.hasQuantity = status.has_quantity;
        return $scope.choices.needQuantity = status.need_quantity;
      }
    };
    if ((availableStatus == null) || availableStatus.length === 0) {
      $scope.administrationCodes = PrescUtils.defaultAdminCodes;
    } else {
      $scope.administrationCodes = availableStatus;
    }
    $scope.choices = {
      quantity: taskInfo.quantity,
      code: task.code,
      state: task.state,
      taking_unit_label: taskInfo.taking_unit_label,
      comment: task.data.comment,
      label: task.label
    };
    status = _.find($scope.administrationCodes, {
      state: task.state
    });
    if (status) {
      $scope.choices.hasQuantity = status.has_quantity;
      $scope.choices.needQuantity = status.need_quantity;
    }
    $scope.undo = function() {
      return $uibModalInstance.close({
        action: "undo"
      });
    };
    $scope.save = function() {
      if ($scope.multipleAdminChecked) {
        $scope.defaultAdminCode.code = $scope.choices.code;
        $scope.defaultAdminCode.state = $scope.choices.state;
      }
      if ($scope.choices.state === "NOK") {
        delete $scope.choices.quantity;
        delete $scope.choices.taking_unit_label;
      }
      return $uibModalInstance.close({
        action: "save",
        choices: $scope.choices,
        defaultAdminCode: $scope.defaultAdminCode
      });
    };
    if (!task.state && category.properties.default_admin_code) {
      status = _.find($scope.administrationCodes, {
        state: category.properties.default_admin_code.state
      });
      if (status) {
        code = _.find(status.codes, {
          code: category.properties.default_admin_code.code
        });
        if (code) {
          $scope.selectCode(status, code);
        }
      }
    }
    return $scope.close = function() {
      return $uibModalInstance.close(false);
    };
  }]);

  angular.module('mhclientApp').controller('AdministrationCtrl', ["$scope", "$rootScope", "$timeout", "$sce", "$uibModal", "$filter", "$q", "$state", "Prescription", "Dispensation", "PrescUtils", "PrescTask", "PharmaValidation", "PharmaDelivery", "CollectionPlanDelivery", "SiteVarsUtils", function($scope, $rootScope, $timeout, $sce, $uibModal, $filter, $q, $state, Prescription, Dispensation, PrescUtils, PrescTask, PharmaValidation, PharmaDelivery, CollectionPlanDelivery, SiteVarsUtils) {
    var canWrite, datesDones, drugDispensationHandled, foundLastPrescOnInterval, foundPrescsOnInterval, getDrugDispensations, getTaskByDate, groupedPrescriptions, handleDates, isEditable, params, prescriptionsById, promises, rollBackTask, updateTask;
    $scope.tasksToUpdate = [];
    $scope.prescriptionsOrder = [];
    drugDispensationHandled = false;
    $scope.mh_config = $rootScope.mh_config;
    $scope.$watch(function() {
      return $scope.isDirty = $scope.tasksToUpdate.length > 0;
    });
    $scope.showHistory = function(presc) {
      return $uibModal.open({
        templateUrl: 'medication/views/presc-history_modal.html',
        controller: 'PrescriptionHistoryCtrl',
        resolve: {
          prescription: presc
        }
      });
    };
    prescriptionsById = {};
    $scope.userShowPosology = null;
    $scope.userInputs = {
      selectedCategories: []
    };
    $scope.user = $rootScope.user;
    canWrite = $rootScope.checkPermissions("ORA", "CAN_WRITE");
    $scope.availableFilters = [
      {
        name: $filter('translate')('order_by_category'),
        value: ['category.order', 'data.template.order', 'data.name', '-id']
      }, {
        name: $filter('translate')('order_by_route'),
        value: ['data.route.label', 'data.name', '-id']
      }, {
        name: $filter('translate')('order_by_product'),
        value: ['data.name', '-id']
      }, {
        name: $filter('translate')('order_by_timestamp'),
        value: ['timestamp', '-id']
      }, {
        name: $filter('translate')('order_by_start_date'),
        value: ['start_date', '-id']
      }, {
        name: $filter('translate')('order_by_end_date'),
        value: ['end_date', '-id']
      }
    ];
    $scope.showPillBox = function(status, code, task, prescription) {
      var modalMenu;
      modalMenu = $uibModal.open({
        templateUrl: 'medication/views/pill-box.html',
        backdrop: 'true',
        controller: 'PillBoxCtrl',
        animation: false,
        scope: $scope,
        resolve: {
          prescription: function() {
            return prescription;
          },
          task: function() {
            return task;
          },
          status: function() {
            return status;
          },
          code: function() {
            return code;
          }
        }
      });
      return modalMenu.result.then(function(result) {
        var choices, j, len, ref, results, selectedSlot;
        if (result) {
          ref = result.slots;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            selectedSlot = ref[j];
            task = _.find(prescription.sequence.dates[selectedSlot.date].timeSlots, {
              time_slot: selectedSlot.timeslot
            });
            if (task.state === "NEW") {
              choices = _.cloneDeep(result.choices);
              choices.quantity = task.displayQuantity;
              choices.taking_unit_label = task.displayTakingUnit;
              results.push(updateTask(task, choices));
            } else {
              results.push(updateTask(task, result.choices));
            }
          }
          return results;
        }
      });
    };
    $scope.prescriptionGroupsOrder = PrescUtils.prescriptionGroupsOrder;
    $scope.handleStateChangePromise = function() {
      var pr, taskPromise;
      $rootScope.busy = true;
      taskPromise = $q.defer();
      pr = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("ADMIN_MISSING_ACTION_TITLE");
          },
          text: function() {
            return $filter('translate')("ADMIN_MISSING_ACTION_TEXT");
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return $filter('translate')("DONT_SAVE_BUTTON");
          },
          okButtonText: function() {
            return $filter('translate')("SAVE_BUTTON");
          }
        }
      });
      pr.result.then((function(toSave) {
        $rootScope.busy = false;
        if (toSave) {
          return $scope.saveTasks(true).then(function() {
            return taskPromise.resolve(true);
          });
        } else {
          $scope.tasksToUpdate = [];
          return taskPromise.resolve();
        }
      }), (function(e) {
        $rootScope.busy = false;
        return taskPromise.reject();
      }));
      return taskPromise.promise;
    };
    $scope.$on('validateRequest', function(event) {
      if (!event.validatePromises) {
        event.validatePromises = [];
      }
      return event.validatePromises.push($scope.saveTasks(true));
    });
    $scope.$on('closeRequested', function(event) {
      if ($scope.tasksToUpdate.length > 0) {
        if (!event.closePromises) {
          event.closePromises = [];
        }
        return event.closePromises.push($scope.handleStateChangePromise());
      }
    });
    $scope.$on('$toggleShowAllStays', function(event) {
      if ($scope.tasksToUpdate.length > 0) {
        if (!event.togglePromises) {
          event.togglePromises = [];
        }
        return event.togglePromises.push($scope.handleStateChangePromise());
      }
    });
    $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      if (event.defaultPrevented) {
        return;
      }
      if ($scope.tasksToUpdate.length > 0) {
        event.preventDefault();
        return $scope.handleStateChangePromise().then(function() {
          return $state.go(toState.name, toParams);
        });
      }
    });
    $scope.saveTasks = function(avoidDates) {
      $rootScope.busy = true;
      return PrescTask.confirmMany($scope.tasksToUpdate).$promise.then(function(updatedTasks) {
        _.forEach($scope.tasksToUpdate, function(task) {
          var ref;
          task.endStep = (ref = task.state) === "OK" || ref === "NOK";
          delete task.dirty;
          delete task.previous;
          task.revision_number = _.find(updatedTasks, {
            prescription: task.prescription,
            date: task.date,
            time_slot: task.time_slot
          }).revision_number;
          task.id = _.find(updatedTasks, {
            prescription: task.prescription,
            date: task.date,
            time_slot: task.time_slot
          }).id;
          task["class"] = (task.endStep ? 'non-editable' : 'editable') + " " + task.state;
        });
        $scope.tasksToUpdate = [];
        $scope.defaultAdminCode = {};
        $scope.multipleAdminChecked = false;
        $rootScope.busy = false;
        if (!avoidDates) {
          return handleDates();
        }
      });
    };
    rollBackTask = function(task) {
      var timeSlots;
      if (task.previous) {
        task.state = task.previous.state;
        task.code = task.previous.code;
        task.label = task.previous.label;
        task["class"] = task.previous["class"];
        task.data.taking_unit_label = task.previous.data.taking_unit_label;
        task.data.quantity = task.previous.data.quantity;
        task.data.comment = task.previous.data.comment;
        task.data.author = task.previous.data.author;
        task.data.initials = task.previous.data.initials;
        delete task.dirty;
        delete task.previous;
      } else {
        delete task.state;
        delete task.code;
        task["class"] = "editable";
      }
      timeSlots = prescriptionsById[task.prescription].sequence.dates[task.date].timeSlots;
      timeSlots[timeSlots.indexOf(task)] = angular.copy(task);
      return _.remove($scope.tasksToUpdate, task);
    };
    $scope.cancelTasks = function() {
      return _.map(_.map($scope.tasksToUpdate), function(task) {
        return rollBackTask(task);
      });
    };
    $scope.printData = function(docType, allStays, patient, stay) {
      var params;
      params = "?start_date=" + $scope.startDate.format('YYYY-MM-DD') + "&end_date=" + $scope.endDate.format('YYYY-MM-DD');
      _.forEach($scope.userInputs.orderBy.value, function(key) {
        return params += "&order_by=" + encodeURIComponent(key);
      });
      _.forEach($scope.userInputs.selectedCategories, function(cat) {
        return params += "&prescription_categories=" + encodeURIComponent(cat.id);
      });
      if (allStays) {
        window.open('/api_rest/patients/' + patient.id + '/print_data/' + docType + params, '_blank');
      } else {
        window.open('/api_rest/stays/' + stay.id + '/print_data/' + docType + params, '_blank');
      }
      return true;
    };
    params = {
      no_draft: true,
      show_in_admin: true,
      exclude_discharge_prescs: true
    };
    if ($scope.allStays) {
      params.patient = $scope.patient.id;
    } else {
      params.stay = $scope.stay.id;
    }
    $scope.dateFormat = 'YYYY-MM-DD';
    $scope.currentDate = moment(new Date());
    $scope.today = moment(new Date()).format($scope.dateFormat);
    $scope.view = $scope.view || ($rootScope.mh_config.platform === 'mgapp' ? "day" : "week");
    $scope.categories = [];
    $scope.defaultAdminCode = {};
    groupedPrescriptions = [];
    updateTask = function(task, choices) {
      var newTask, timeSlots;
      if (task.id && !task.previous) {
        task.previous = _.cloneDeep(task);
      }
      task.state = choices.state;
      task.code = choices.code;
      task.label = choices.label;
      task.data.taking_unit_label = choices.taking_unit_label;
      task.taking_unit_label = choices.taking_unit_label;
      task.data.quantity = choices.quantity;
      task.quantity = choices.quantity === null ? void 0 : choices.quantity;
      task.data.author = $scope.user.full_name;
      task.data.initials = $scope.user.user_profile.initials || "-";
      task.data.comment = choices.comment;
      task.comment = choices.comment || void 0;
      task.timestamp = moment();
      task.self_administration = false;
      task.dirty = true;
      task["class"] = 'editable dirty ' + task.state;
      timeSlots = prescriptionsById[task.prescription].sequence.dates[task.date].timeSlots;
      newTask = angular.copy(task);
      timeSlots[timeSlots.indexOf(task)] = newTask;
      _.remove($scope.tasksToUpdate, task);
      return $scope.tasksToUpdate.push(newTask);
    };
    $scope.edit = function(task, currentDateDict, currentPrescription) {
      var availableStatus, category, choices, code, modalMenu, ref, status, taskInfo;
      if (!task || task.disabled || (!task.dirty && task.endStep) || task["class"].indexOf('non-editable') >= 0) {
        return;
      }
      category = currentPrescription.category;
      if (_.isEmpty($scope.defaultAdminCode)) {
        $scope.defaultAdminCode = category.properties.default_admin_code;
      }
      if (moment(moment().format($scope.dateFormat)).diff(moment(task.date), 'days') < 0) {
        availableStatus = _.filter(category.properties.administration_codes, {
          state: 'prepared'
        });
      } else {
        availableStatus = category.properties.administration_codes;
      }
      if ((!task.state || task.state === "NEW") && $scope.defaultAdminCode) {
        status = _.find(availableStatus, {
          state: $scope.defaultAdminCode.state
        });
        if (status) {
          code = _.find(status.codes, {
            code: $scope.defaultAdminCode.code
          });
          if (code) {
            if ((ref = code.action) === "DAYLY_PILLBOX" || ref === "WEEKLY_PILLBOX") {
              $scope.showPillBox(status, code, task, currentPrescription);
              return;
            } else {
              taskInfo = $scope.getTaskInfo(task);
              if (!status.has_quantity || !status.need_quantity || taskInfo.quantity) {
                choices = {
                  quantity: taskInfo.quantity,
                  code: code.code,
                  state: status.state,
                  taking_unit_label: taskInfo.taking_unit_label,
                  comment: task.data.comment,
                  label: code.label
                };
                updateTask(task, choices);
                return;
              }
            }
          }
        }
      }
      modalMenu = $uibModal.open({
        templateUrl: 'medication/views/task-edit.html',
        backdrop: 'true',
        controller: 'EditTaskCtrl',
        animation: false,
        scope: $scope,
        resolve: {
          category: function() {
            return category;
          },
          availableStatus: function() {
            return availableStatus;
          },
          prescription: function() {
            return currentPrescription;
          },
          task: function() {
            return task;
          }
        }
      });
      return modalMenu.result.then(function(result) {
        if (result) {
          if (result.action === "save") {
            $scope.defaultAdminCode = result.defaultAdminCode;
            updateTask(task, result.choices);
          }
          if (result.action === "undo") {
            return rollBackTask(task);
          }
        }
      });
    };
    foundLastPrescOnInterval = function(startDate, endDate, prescriptionGroup) {
      var end, j, len, prescription, ref;
      if (prescriptionGroup.startDate <= endDate && (!prescriptionGroup.endDate || prescriptionGroup.endDate >= startDate)) {
        ref = $filter('orderBy')(prescriptionGroup.prescriptions, '-id');
        for (j = 0, len = ref.length; j < len; j++) {
          prescription = ref[j];
          if (prescription.expiration_time && prescription.end_date) {
            end = moment.min(moment(prescription.expiration_time), moment(prescription.end_date));
          } else {
            end = moment(prescription.expiration_time || prescription.end_date);
          }
          if (moment(prescription.start_date) <= endDate && (!end.isValid() || end >= startDate)) {
            return prescription;
          }
        }
      }
      return false;
    };
    foundPrescsOnInterval = function(startDate, endDate, prescriptionGroup) {
      var end, j, len, prescription, prescsOnInterval, ref;
      if (prescriptionGroup.startDate <= endDate && (!prescriptionGroup.endDate || prescriptionGroup.endDate >= startDate)) {
        prescsOnInterval = [];
        ref = $filter('orderBy')(prescriptionGroup.prescriptions, '-id');
        for (j = 0, len = ref.length; j < len; j++) {
          prescription = ref[j];
          if (prescription.expiration_time && prescription.end_date) {
            end = moment.min(moment(prescription.expiration_time), moment(prescription.end_date));
          } else {
            end = moment(prescription.expiration_time || prescription.end_date);
          }
          if (moment(prescription.start_date) <= endDate && (!end.isValid() || end >= startDate)) {
            prescsOnInterval.push(prescription);
          }
        }
        return prescsOnInterval;
      }
      return false;
    };
    isEditable = function(prescription, date) {
      var administrationCodes;
      if (!canWrite || $scope.readOnly) {
        return false;
      }
      administrationCodes = prescription.category.properties.administration_codes || [];
      return prescription.state !== "STOPPED" && moment().startOf('day').diff(date, 'days') <= $scope.maxAdminDelay && (moment(moment().format($scope.dateFormat)).diff(moment(date), 'days') >= 0 || _.find(administrationCodes, {
        state: 'prepared'
      }));
    };
    $scope.userShowPosologyChange = function(hidePosology) {
      return $scope.userShowPosology = !hidePosology;
    };
    $scope.goToDate = function(currentDate) {
      $scope.currentDate = moment(currentDate);
      $rootScope.busy = true;
      return handleDates().then(function() {
        return $rootScope.busy = false;
      });
    };
    $scope.shiftDate = function(days) {
      $scope.currentDate.add(days, "days");
      $rootScope.busy = true;
      return handleDates().then(function() {
        return $rootScope.busy = false;
      });
    };
    $scope.changeView = function() {
      $scope.changingView = true;
      $rootScope.busy = true;
      $scope.changingView = true;
      if ($scope.view === "week") {
        $scope.view = "day";
      } else {
        $scope.view = "week";
      }
      return $timeout(function() {
        return handleDates().then(function() {
          $scope.changingView = false;
          $scope.changingView = false;
          return $rootScope.busy = false;
        });
      });
    };
    datesDones = [];
    getTaskByDate = function(dateStr) {
      var getTaskPromise;
      getTaskPromise = $q.defer();
      if (indexOf.call(datesDones, dateStr) < 0) {
        datesDones.push(dateStr);
        params = {
          start_date: dateStr,
          end_date: dateStr
        };
        if ($scope.allStays) {
          params.patient = $scope.patient.id;
        } else {
          params.stay = $scope.stay.id;
        }
        PrescTask.query(params).$promise.then(function(receivedTasks) {
          var date, editable, j, k, l, len, len1, len2, prescription, prescriptions, ref, ref1, sequence, task, timeSlot;
          date = moment(dateStr);
          for (j = 0, len = receivedTasks.length; j < len; j++) {
            task = receivedTasks[j];
            if (!(task.prescription in prescriptionsById)) {
              continue;
            }
            prescription = prescriptionsById[task.prescription];
            sequence = prescription.sequence;
            sequence.taskByTimeSlots = sequence.taskByTimeSlots || {};
            if (sequence.taskByTimeSlots[task.time_slot] && task.state === "NEW") {
              continue;
            }
            sequence.taskByTimeSlots[task.time_slot] = task;
            task.endStep = (ref = task.state) === "OK" || ref === "NOK";
          }
          for (k = 0, len1 = groupedPrescriptions.length; k < len1; k++) {
            sequence = groupedPrescriptions[k];
            sequence.dates[dateStr] = {
              visible: false
            };
            prescription = foundLastPrescOnInterval(date, date, sequence);
            if (!prescription) {
              continue;
            } else {
              prescriptions = [prescription];
            }
            editable = isEditable(prescription, date);
            sequence.dates[dateStr] = {
              visible: true,
              editable: editable,
              timeSlots: []
            };
            ref1 = $scope.timeSlots;
            for (l = 0, len2 = ref1.length; l < len2; l++) {
              timeSlot = ref1[l];
              if (sequence.taskByTimeSlots && timeSlot.id in sequence.taskByTimeSlots) {
                task = sequence.taskByTimeSlots[timeSlot.id];
                task["class"] = (!editable || task.endStep ? 'non-editable' : 'editable') + " " + task.state;
                task.data.comment = task.data.comment || "";
              } else if (editable) {
                task = {
                  date: dateStr,
                  data: {
                    comment: ""
                  },
                  time_slot: timeSlot.id,
                  prescription: prescription.id,
                  "class": "editable"
                };
              } else {
                task = {
                  disabled: true
                };
              }
              sequence.dates[dateStr].timeSlots.push(task);
            }
            delete sequence.taskByTimeSlots;
          }
          return getTaskPromise.resolve();
        });
      } else {
        getTaskPromise.resolve();
      }
      return getTaskPromise.promise;
    };
    $scope.getTaskInfo = function(task) {
      var prescription, quantity, taking_unit_label, timeSlot;
      timeSlot = _.find($scope.timeSlots, {
        id: task.time_slot
      });
      prescription = prescriptionsById[task.prescription];
      quantity = null;
      taking_unit_label = null;
      if (task.data.quantity) {
        quantity = task.data.quantity;
      } else if (task.state === "NEW") {
        if (timeSlot && prescription.data.quantity_by_timeslot) {
          quantity = prescription.data.quantity_by_timeslot[timeSlot.short_label] || null;
          if (prescription.data.substitution && quantity) {
            quantity = quantity * (prescription.data.substitution_ratio || 1);
          }
        }
      }
      if (task.data.taking_unit_label) {
        taking_unit_label = task.data.taking_unit_label;
      } else {
        if (prescription.data.substitution && prescription.data.substitution_label) {
          taking_unit_label = prescription.data.substitution_label;
        } else if (prescription.data.taking_unit) {
          taking_unit_label = prescription.data.taking_unit.label;
        }
      }
      return {
        quantity: quantity,
        taking_unit_label: taking_unit_label
      };
    };
    $scope.genDisplay = function(task, forceDetails) {
      var display, taskInfo;
      display = [];
      taskInfo = $scope.getTaskInfo(task);
      task.displayQuantity = taskInfo.quantity;
      task.displayTakingUnit = taskInfo.taking_unit_label;
      if ($scope.view === "week" && !forceDetails) {
        display = [task.code];
      } else {
        if (task.state) {
          if (task.state !== "NEW") {
            display = [];
            if (task.timestamp && !task.dirty) {
              display.push($filter("utcToLocal")(task.timestamp, "HH:mm"));
            } else if (task.code) {
              display.push(task.code);
            }
            if (task.data.initials && !task.dirty) {
              display.push(task.data.initials);
            }
            if (task.self_administration && !task.dirty) {
              display.push($filter("translate")("SELF_ADMINISTERED_LABEL"));
            }
            if (taskInfo.quantity) {
              display.push(taskInfo.quantity + " " + taskInfo.taking_unit_label);
            }
          } else {
            if (task["class"].indexOf('non-editable') === -1) {
              if (task.data.custom_hour) {
                display.push(task.data.custom_hour);
              }
              if (taskInfo.quantity) {
                display.push(taskInfo.quantity + " " + taskInfo.taking_unit_label);
              }
            }
          }
        }
      }
      return $sce.trustAsHtml(display.join("<br>"));
    };
    $scope.fetchTasks = function(dates) {
      var tasksDone;
      tasksDone = $q.defer();
      $q.all(_.map(dates, function(date) {
        return getTaskByDate(date);
      })).then(function() {
        var j, len, prescription, prescriptionGroup, prescriptions;
        prescriptions = [];
        for (j = 0, len = groupedPrescriptions.length; j < len; j++) {
          prescriptionGroup = groupedPrescriptions[j];
          prescription = foundLastPrescOnInterval($scope.startDate, $scope.endDate, prescriptionGroup);
          if (prescription) {
            prescriptions.push(prescription);
          }
        }
        return $timeout(function() {
          return tasksDone.resolve(prescriptions);
        });
      });
      return tasksDone.promise;
    };
    handleDates = function() {
      var currentDates, datesDone, dispensationDone, i, j, newDate, start;
      datesDone = $q.defer();
      currentDates = [];
      start = moment($scope.currentDate.format($scope.dateFormat));
      if ($scope.view === "week") {
        if ($scope.userShowPosology != null) {
          $scope.userInputs.hidePosology = !$scope.userShowPosology;
        } else {
          $scope.userInputs.hidePosology = true;
        }
        dispensationDone = $q.defer();
        dispensationDone.resolve();
        $scope.startDate = moment(moment(start.date(start.date() - 3)).format($scope.dateFormat));
        for (i = j = 0; j <= 6; i = ++j) {
          newDate = moment($scope.startDate);
          newDate.add(i, "days");
          currentDates.push(newDate.format($scope.dateFormat));
          $scope.endDate = newDate;
        }
      } else {
        if ($scope.userShowPosology != null) {
          $scope.userInputs.hidePosology = !$scope.userShowPosology;
        } else {
          $scope.userInputs.hidePosology = false;
        }
        $scope.startDate = start;
        currentDates.push(start.format($scope.dateFormat));
        $scope.endDate = start;
        dispensationDone = getDrugDispensations();
      }
      dispensationDone.promise.then(function() {
        return $scope.fetchTasks(currentDates).then(function(prescriptions) {
          $scope.groupedPrescriptions = PrescUtils.groupPrescriptions(prescriptions);
          datesDone.resolve();
          $scope.currentDates = currentDates;
          return $scope.currentDatesDict = _.map($scope.currentDates, function(dateStr) {
            return {
              date: dateStr
            };
          });
        });
      });
      return datesDone.promise;
    };
    getDrugDispensations = function() {
      var getDispensationsPromise;
      getDispensationsPromise = $q.defer();
      if (!drugDispensationHandled) {
        drugDispensationHandled = true;
        if ($scope.allStays) {
          params = {
            patient: $scope.patient.id
          };
        } else {
          params = {
            stay: $scope.stay.id
          };
        }
        PharmaValidation.query(params).$promise.then(function(pharmaValidations) {
          return PharmaDelivery.query(params).$promise.then(function(pharmaDeliveries) {
            return CollectionPlanDelivery.query(_.assign({
              state: "VALIDATED"
            }, params)).$promise.then(function(collectionPlanDeliveries) {
              return SiteVarsUtils.get('CLASICAL_DISPENSATION', true).then(function(sitevar) {
                var j, len, pharmaValidation;
                for (j = 0, len = pharmaValidations.length; j < len; j++) {
                  pharmaValidation = pharmaValidations[j];
                  if (!(pharmaValidation.prescription in prescriptionsById)) {
                    continue;
                  }
                  prescriptionsById[pharmaValidation.prescription].pharmaValidation = pharmaValidation;
                  pharmaValidation.pharma_delivery = _.find(pharmaDeliveries, {
                    prescription: pharmaValidation.prescription
                  });
                  if (pharmaValidation.pharma_delivery) {
                    pharmaValidation.pharma_delivery.validated_collections = _.filter(collectionPlanDeliveries, {
                      pharma_delivery: pharmaValidation.pharma_delivery.id
                    });
                  }
                }
                $scope.clasicalDispensation = sitevar.value;
                if ($scope.clasicalDispensation) {
                  params.state = "VA";
                }
                return Dispensation.query(params).$promise.then(function(dispensations) {
                  var dispensation, drugDispensation, k, l, len1, len2, prescription, ref, ref1;
                  ref = $filter('orderBy')(dispensations, '-timestamp');
                  for (k = 0, len1 = ref.length; k < len1; k++) {
                    dispensation = ref[k];
                    ref1 = dispensation.drug_dispensations;
                    for (l = 0, len2 = ref1.length; l < len2; l++) {
                      drugDispensation = ref1[l];
                      if (!(drugDispensation.prescription in prescriptionsById) || (!$scope.clasicalDispensation && drugDispensation.data.action !== 'VALIDATE')) {
                        continue;
                      }
                      prescription = prescriptionsById[drugDispensation.prescription];
                      if (!(prescription.dispensations.length > 0 && _.last(prescription.dispensations).id === dispensation.id)) {
                        prescription.dispensations.push({
                          id: dispensation.id,
                          timestamp: dispensation.timestamp,
                          drug_dispensations: []
                        });
                      }
                      _.last(prescription.dispensations).drug_dispensations.push(drugDispensation);
                    }
                  }
                  return getDispensationsPromise.resolve();
                });
              });
            });
          });
        });
      } else {
        getDispensationsPromise.resolve();
      }
      return getDispensationsPromise;
    };
    $rootScope.busy = true;
    promises = [SiteVarsUtils.get("MAX_ADMIN_DELAY", 1), PrescUtils.getCategories().promise, PrescUtils.getTimeSlots().promise, SiteVarsUtils.get("PRESCRIPTION_ADMINISRATION_ORDER")];
    return $q.all(promises).then(function(data) {
      var defaultOrder;
      $scope.maxAdminDelay = data[0].value;
      $scope.prescCategories = data[1];
      $scope.timeSlots = data[2];
      defaultOrder = data[3];
      if (defaultOrder.value) {
        if (_.find($scope.availableFilters, {
          value: defaultOrder.value.value
        })) {
          _.remove($scope.availableFilters, _.find($scope.availableFilters, {
            value: defaultOrder.value.value
          }));
        }
        $scope.availableFilters.push(defaultOrder.value);
        $scope.userInputs.orderBy = defaultOrder.value;
      } else {
        $scope.userInputs.orderBy = $scope.availableFilters[0];
      }
      return SiteVarsUtils.get("TASK_COLORS", {
        "NEW": {
          "background": "#406786",
          "color": "white"
        },
        "OK": {
          "background": "#CBEDB2",
          "color": "black"
        },
        "NOK": {
          "background": "#FF9898",
          "color": "black"
        },
        "prepared": {
          "background": "#FFFF98",
          "color": "black"
        }
      }).then(function(taskColors) {
        var categoriesByIdDict, category, j, len, ref;
        $scope.taskColors = taskColors.value;
        $scope.timeSlotsById = {};
        _.map($scope.timeSlots, function(timeSlot) {
          return $scope.timeSlotsById[timeSlot.id] = timeSlot;
        });
        $scope.slotWidth = 100 / $scope.timeSlots.length;
        categoriesByIdDict = {};
        ref = $scope.prescCategories;
        for (j = 0, len = ref.length; j < len; j++) {
          category = ref[j];
          categoriesByIdDict[category.id] = angular.copy(category);
          if (categoriesByIdDict[category.id].show_in_admin) {
            $scope.categories.push(categoriesByIdDict[category.id]);
          }
        }
        return Prescription.query(params).$promise.then(function(prescriptions) {
          var currentGroup, end, k, l, len1, len2, len3, m, prescription, prescriptionGroup, ref1, ref2;
          ref1 = $filter('orderBy')(prescriptions, 'id');
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            prescription = ref1[k];
            prescriptionsById[prescription.id] = prescription;
            prescription.dispensations = [];
            prescription.category = categoriesByIdDict[prescription.category];
            if (prescription.data.resumption === "RENEW") {
              currentGroup = _.find(groupedPrescriptions, {
                currentPrescriptionId: prescription.parent_prescription
              });
            } else {
              currentGroup = null;
            }
            if (!currentGroup) {
              currentGroup = {
                prescriptions: [],
                dates: {}
              };
              groupedPrescriptions.push(currentGroup);
            }
            prescription.sequence = currentGroup;
            currentGroup.prescriptions.push(prescription);
            currentGroup.currentPrescriptionId = prescription.id;
          }
          for (l = 0, len2 = groupedPrescriptions.length; l < len2; l++) {
            prescriptionGroup = groupedPrescriptions[l];
            prescriptionGroup.startDate = moment.min(_.map(prescriptionGroup.prescriptions, function(prescription) {
              return moment(prescription.start_date);
            }));
            ref2 = prescriptionGroup.prescriptions;
            for (m = 0, len3 = ref2.length; m < len3; m++) {
              prescription = ref2[m];
              if (!prescription.expiration_time && !prescription.end_date) {
                prescriptionGroup.endDate = null;
                break;
              }
              if (prescription.expiration_time && prescription.end_date) {
                end = moment.min(moment(prescription.expiration_time), moment(prescription.end_date));
              } else {
                end = moment(prescription.expiration_time || prescription.end_date);
              }
              if (!prescriptionGroup.endDate) {
                prescriptionGroup.endDate = end;
              } else {
                prescriptionGroup.endDate = moment.max(prescriptionGroup.endDate, end);
              }
            }
          }
          return handleDates().then(function() {
            return $rootScope.busy = false;
          });
        });
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=administration-controller.js.map

(function() {
  'use strict';
  angular.module("mhclientApp").factory('PrescTask', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, boxAPI, portailAPI, presc_task;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/presctasks/:id/:route', {
      id: this.id
    }, {
      get: {
        headers: {
          'Accept': acceptHeader
        }
      },
      query: {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      confirmMany: {
        method: 'PUT',
        isArray: true,
        params: {
          route: 'confirm'
        },
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        presc_task = window.mgapp.get('medication_mgr').presc_task();
        boxAPI = BoxResource.generate(presc_task);
        boxAPI.saveMany = function(obj) {
          return BoxResource.mhboxApiCall(presc_task, "save_many", obj);
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('PrescTemplate', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, api, portailAPI, presc_template;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/presctemplates/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'delete': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'DELETE'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      default:
        presc_template = window.mgapp.get('medication_mgr').presc_template();
        api = BoxResource.generate(presc_template);
    }
    return {
      api: api
    };
  }]);

  angular.module("mhclientApp").factory('PrescTemplateCategory', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, api, portailAPI, presc_template_category;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/presctemplatecategories/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'delete': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'DELETE'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      default:
        presc_template_category = window.mgapp.get('medication_mgr').presc_template_category();
        api = BoxResource.generate(presc_template_category);
    }
    return {
      api: api
    };
  }]);

  angular.module("mhclientApp").factory('PrescTimeSlot', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, boxAPI, portailAPI, presc_time_slot;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/presctimeslots/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        presc_time_slot = window.mgapp.get('medication_mgr').presc_time_slot();
        boxAPI = BoxResource.generate(presc_time_slot);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('Ordonnance', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, acceptHeaderV2, boxAPI, ordonnance, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    acceptHeaderV2 = MhConfig.baseAcceptHeader + ";version=v2";
    portailAPI = $resource('/api_rest/ordonnances/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'activate': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST',
        params: {
          route: 'activate',
          id: '@id'
        }
      },
      'saveDraft': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST',
        params: {
          route: 'save_draft',
          id: '@id'
        }
      },
      'getPrescriptions': {
        headers: {
          'Accept': acceptHeaderV2
        },
        params: {
          route: 'get_prescriptions'
        },
        isArray: true
      },
      'getDispensations': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_dispensations'
        },
        isArray: true
      },
      'getPages': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_pages'
        },
        isArray: true
      },
      'getOrdonnanceByPatient': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_ordonnance_by_patient'
        },
        isArray: true
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        ordonnance = window.mgapp.get('medication_mgr').ordonnance();
        boxAPI = BoxResource.generate(ordonnance);
        boxAPI.getOrdonnanceByPatient = function(object) {
          return BoxResource.mhboxApiCall(ordonnance, "get_ordonnance_by_patient", object);
        };
        boxAPI.getPrescriptions = function(object) {
          return BoxResource.mhboxApiCall(ordonnance, "get_prescriptions", object);
        };
        boxAPI.activate = function(object) {
          return BoxResource.mhboxApiCall(ordonnance, "activate", object);
        };
        boxAPI.saveDraft = function(object) {
          return BoxResource.mhboxApiCall(ordonnance, "save_draft", object);
        };
        boxAPI.getDispensations = function(object) {
          return BoxResource.mhboxApiCall(ordonnance, "get_dispensations", object);
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('Prescription', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, boxAPI, portailAPI, prescription;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v2";
    portailAPI = $resource('/api_rest/prescriptions/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'renew': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST',
        params: {
          route: 'renew'
        },
        isArray: true
      },
      'getDispensations': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_dispensations'
        },
        isArray: true
      },
      'getPharmaValidation': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_pharma_validation'
        }
      },
      'getPharmaDelivery': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_pharma_delivery'
        }
      },
      'getCollectionValidatedDeliveries': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_collection_validated_deliveries'
        },
        isArray: true
      },
      'getCollectionDeliverables': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_collection_deliverables'
        },
        isArray: true
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'make_substitution': {
        method: 'POST',
        params: {
          route: 'make_substitution',
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'getGroupsInfo': {
        method: 'GET',
        params: {
          route: 'get_groups_info'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'extractPatientPatMedicament': {
        method: "PUT",
        params: {
          route: "extract_patient_par_medicament",
          id: '@id'
        },
        headers: {
          "Accept": acceptHeader
        }
      },
      'getHighCostDrugs': {
        method: "GET",
        params: {
          route: "get_high_cost_drugs"
        },
        headers: {
          "Accept": acceptHeader
        }
      },
      'fichcomp': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'GET',
        params: {
          route: 'fichcomp'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        prescription = window.mgapp.get('medication_mgr').prescription();
        boxAPI = BoxResource.generate(prescription);
        boxAPI.getDispensations = function(object) {
          return BoxResource.mhboxApiCall(prescription, "get_dispensations", object);
        };
        boxAPI.getPharmaValidation = function(object) {
          return BoxResource.mhboxApiCall(prescription, "get_pharma_validation", object);
        };
        boxAPI.getPharmaDelivery = function(object) {
          return BoxResource.mhboxApiCall(prescription, "get_pharma_delivery", object);
        };
        boxAPI.getCollectionValidatedDeliveries = function(object) {
          return BoxResource.mhboxApiCall(prescription, "get_collection_validated_deliveries", object);
        };
        boxAPI.getGroupsInfo = function(object) {
          return BoxResource.mhboxApiCall(prescription, "get_groups_info", object);
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('PrescCategory', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, boxAPI, portailAPI, presc_category;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/presccategories/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        presc_category = window.mgapp.get('medication_mgr').presc_category();
        boxAPI = BoxResource.generate(presc_category);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('Dispensation', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, boxAPI, dispensation, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/dispensations/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        dispensation = window.mgapp.get('medication_mgr').dispensation();
        boxAPI = BoxResource.generate(dispensation);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('PrescUtils', ["$resource", "$filter", "$q", "$uibModal", "moment", "PrescTimeSlot", "Prescription", "PrescCategory", "Ordonnance", "MhConfig", "Medicaldb", "Stay", function($resource, $filter, $q, $uibModal, moment, PrescTimeSlot, Prescription, PrescCategory, Ordonnance, MhConfig, Medicaldb, Stay) {
    var BCBPosologiesCodes, GlobalCategories, GlobaltimeSlots, availableFilters, bcb_version, cachedOrdonnances, defaultAdminCodes, filterEntries, getBCBState, getBCBVersion, getCategories, getHightCostDrugs, getOrCreateDraftOrdonnance, getPAPCategory, getPharmaValidation, getPrescriptionDetails, getStopAvailableReason, getTimeSlots, globalCategoryPromise, globalTimeSlotsPromise, groupPrescriptions, prescriptionGroupsOrder, resetCache, routes, service, setupCroppedPrescription, setupPrescription, setupPrescriptionFromParent, showHistory, stopAvailableReasons, taking_units;
    stopAvailableReasons = [
      {
        code: "tr_incom",
        label: $filter('translate')("Traitement incompatible")
      }, {
        code: "tr_non_tol",
        label: $filter('translate')("Traitement non toléré par le patient")
      }, {
        code: "terminated",
        label: $filter('translate')("Traitement terminé")
      }, {
        code: "other",
        label: $filter('translate')("Other")
      }
    ];
    GlobalCategories = null;
    GlobaltimeSlots = null;
    globalCategoryPromise = $q.defer();
    globalTimeSlotsPromise = $q.defer();
    bcb_version = null;
    BCBPosologiesCodes = {
      "-1": "Produit inconnu.",
      "-1001": "Le poids n’est pas renseigné.",
      "-500": "Pas de données pour ce code posologie. Le calcul de surdosage n'a pas pu être effectué. (code BCB 500)",
      "-1000": "Unité de prise inconnue pour ce produit",
      "-600": "Unité de prise inconnue pour ce produit",
      "-2": "MedicamentVirtuel",
      "-1004": "Pas de données pour ce code posologie. Le calcul de surdosage n'a pas pu être effectué. (code BCB 1004)"
    };
    showHistory = function(presc) {
      return $uibModal.open({
        templateUrl: 'medication/views/presc-history_modal.html',
        controller: 'PrescriptionHistoryCtrl',
        resolve: {
          prescription: presc
        }
      });
    };
    resetCache = function() {
      GlobalCategories = null;
      GlobaltimeSlots = null;
      globalCategoryPromise = $q.defer();
      return globalTimeSlotsPromise = $q.defer();
    };
    getStopAvailableReason = function() {
      return stopAvailableReasons;
    };
    getTimeSlots = function(dontCopy) {
      var TimeSlotsPromise;
      TimeSlotsPromise = $q.defer();
      if (GlobaltimeSlots != null) {
        globalTimeSlotsPromise.promise.then(function() {
          if (dontCopy) {
            return TimeSlotsPromise.resolve(GlobaltimeSlots);
          } else {
            return TimeSlotsPromise.resolve(angular.copy(GlobaltimeSlots));
          }
        });
      } else {
        GlobaltimeSlots = [];
        PrescTimeSlot.query().$promise.then(function(timeSlots) {
          GlobaltimeSlots = $filter('orderBy')(timeSlots, 'order');
          if (dontCopy) {
            TimeSlotsPromise.resolve(GlobaltimeSlots);
          } else {
            TimeSlotsPromise.resolve(angular.copy(GlobaltimeSlots));
          }
          return globalTimeSlotsPromise.resolve();
        });
      }
      return TimeSlotsPromise;
    };
    availableFilters = function() {
      return [
        {
          name: $filter('translate')('order_by_product'),
          value: ['data.template.order', 'data.name', 'timestamp', 'id']
        }, {
          name: $filter('translate')('order_by_route'),
          value: ['data.template.order', 'data.route.label', 'timestamp', 'id']
        }, {
          name: $filter('translate')('order_by_taking_unit'),
          value: ['data.template.order', 'data.taking_unit.label', 'timestamp', 'id']
        }, {
          name: $filter('translate')('order_by_atc'),
          value: ['data.template.order', 'data.bdm_data.atc', 'timestamp', 'id']
        }, {
          name: $filter('translate')('order_by_timestamp'),
          value: ['data.template.order', 'timestamp', 'id']
        }, {
          name: $filter('translate')('order_by_start_date'),
          value: ['data.template.order', 'start_date', 'timestamp', 'id']
        }, {
          name: $filter('translate')('order_by_end_date'),
          value: ['data.template.order', 'end_date', 'timestamp', 'id']
        }, {
          name: $filter('translate')('Stop date'),
          value: ['data.template.order', 'expiration_time', 'end_date', 'timestamp', 'id']
        }
      ];
    };
    prescriptionGroupsOrder = function(predicates, reverse) {
      return function(prescriptionGroup) {
        var i, len, orders, predicate, use;
        orders = [];
        for (i = 0, len = predicates.length; i < len; i++) {
          predicate = predicates[i];
          use = reverse || (!reverse && _.startsWith(predicate, "-")) ? _.max : _.min;
          predicate = _.trimStart(predicate, "-");
          if (_.startsWith(predicate, "!")) {
            orders.push(use(_.map(prescriptionGroup.prescriptions, function(prescription) {
              return !_.get(prescription, _.trimStart(predicate, "!"));
            })));
          } else {
            orders.push(use(_.map(prescriptionGroup.prescriptions, predicate)));
          }
        }
        return orders;
      };
    };
    getCategories = function(query, many, dontCopy) {
      var CategoryPromise;
      CategoryPromise = $q.defer();
      if (GlobalCategories != null) {
        globalCategoryPromise.promise.then(function() {
          return CategoryPromise.resolve(filterEntries(GlobalCategories, query, many, dontCopy));
        });
      } else {
        GlobalCategories = [];
        PrescCategory.query().$promise.then(function(categories) {
          GlobalCategories = categories;
          CategoryPromise.resolve(filterEntries(GlobalCategories, query, many, dontCopy));
          return globalCategoryPromise.resolve();
        });
      }
      return CategoryPromise;
    };
    getHightCostDrugs = function(params, ucdList) {
      var hightCostPrescsPromise;
      hightCostPrescsPromise = $q.defer();
      Prescription.query(params).$promise.then(function(highCostPrescs) {
        var csvContent, prescs;
        prescs = _.filter(highCostPrescs, function(presc) {
          return presc.data.hasOwnProperty('bdm_data') && ucdList.indexOf(parseInt(presc.data.bdm_data.ucd)) > -1;
        });
        csvContent = "ID;Product;UCD;CIP;Timestamp;Start date;End date;Daily quantity;Duration" + "\r\n";
        _.forEach(prescs, function(presc) {
          var prescRelevantInfo;
          prescRelevantInfo = [presc.id, presc.data.bdm_data.name || presc.data.name, presc.data.bdm_data.ucd, presc.data.bdm_data.cip, presc.timestamp, presc.start_date, presc.end_date, presc.data.daily_quantity, presc.duration];
          return csvContent += prescRelevantInfo.join(";") + "\r\n";
        });
        return hightCostPrescsPromise.resolve(csvContent);
      });
      return hightCostPrescsPromise;
    };
    setupPrescriptionFromParent = function(parent_prescription, timeSlots, resumption, ordonnance, user) {
      var error, error1, presc, prescriptionDisplayDict;
      presc = angular.copy(parent_prescription);
      presc.ordonnance = ordonnance ? ordonnance.id : null;
      presc.parent_prescription = parent_prescription.id;
      presc.data.resumption = resumption;
      presc.data.source = MhConfig.platform;
      if (presc.data.takes == null) {
        presc.data.takes = "slots";
      }
      presc.start_date = moment().format("YYYY-MM-DD");
      presc.end_date = presc.duration != null ? (moment(presc.start_date).add(presc.duration - 1, 'days')).format("YYYY-MM-DD") : null;
      if (!presc.data.is_posos_pristine) {
        if (presc.category.name !== "PAP_TEMPLATE") {
          try {
            prescriptionDisplayDict = $filter("PrescriptionDisplayText")(presc, timeSlots);
            presc.data.display_text = prescriptionDisplayDict.display_text;
            presc.data.dci_display_text = prescriptionDisplayDict.dci_display_text;
            presc.data.posology = prescriptionDisplayDict.posology;
          } catch (error1) {
            error = error1;
            presc.data.display_text = $filter('translate')("CANT GENERATE POSOLOGY SENTENCE, MISSING FIELDS");
            presc.data.dci_display_text = presc.data.display_text;
          }
        }
      }
      if (presc.data.can_renew != null) {
        delete presc.data.can_renew;
      }
      if (presc.data.is_cropped != null) {
        delete presc.data.is_cropped;
      }
      delete presc.state;
      delete presc.id;
      delete presc.expiration_time;
      delete presc.timestamp;
      delete presc.control;
      delete presc.data.stop_reason;
      delete presc.data.is_posos;
      delete presc.data.manually_added;
      delete presc.data.posos_order;
      delete presc.data.stop_comment;
      delete presc.data.stop_label;
      delete presc.data.stopped_author;
      delete presc.data.stopped_reason;
      delete presc.data.cached_height;
      delete presc.data.substitution;
      delete presc.data.validation_author;
      delete presc.data.creation_author;
      delete presc.data.creation_date;
      delete presc.data.substitution_history;
      delete presc.data.short_display_html;
      delete presc.data.original_group;
      delete presc.data.original_group_sequence;
      delete presc.group;
      if (user) {
        presc.data.creation_author = user.full_name;
        presc.data.creation_date = moment().format("YYYY-MM-DD");
      }
      return presc;
    };
    filterEntries = function(entries, query, many, dontCopy) {
      var result;
      if (query) {
        result = many ? _.filter(entries, query) : _.find(entries, query);
      } else {
        result = entries;
      }
      if (dontCopy) {
        return result;
      } else {
        if (result instanceof Array) {
          return _.map(result, _.cloneDeep);
        } else {
          return _.cloneDeep(result);
        }
      }
    };
    getBCBVersion = function() {
      var BCBVersionPromise;
      BCBVersionPromise = $q.defer();
      if (!bcb_version) {
        Medicaldb.version().$promise.then(function(version_info) {
          bcb_version = version_info.version;
          return BCBVersionPromise.resolve(bcb_version);
        });
      } else {
        BCBVersionPromise.resolve(bcb_version);
      }
      return BCBVersionPromise;
    };
    getBCBState = function() {
      var BCBStatePromise;
      BCBStatePromise = $q.defer();
      Medicaldb.getBCBState().$promise.then(function(bcb_state) {
        return BCBStatePromise.resolve(bcb_state);
      });
      return BCBStatePromise;
    };
    getPAPCategory = function() {
      var PAPCategoryPromise;
      PAPCategoryPromise = $q.defer();
      getCategories().promise.then(function(categories) {
        return PAPCategoryPromise.resolve(_.find(categories, {
          name: "PAP_TEMPLATE"
        }));
      });
      return PAPCategoryPromise;
    };
    setupCroppedPrescription = function(position, documentPage) {
      return {
        x: position.x,
        y: position.y,
        width: 0,
        height: 0,
        action: "RESIZING",
        start_date: moment().format("YYYY-MM-DD"),
        data: {
          quantity_by_timeslot: {},
          taking_unit: {
            label: ""
          },
          type: "cropped",
          end_mode: "duration",
          is_cropped: true,
          can_renew: false,
          absolute: {},
          document_page: documentPage
        }
      };
    };
    setupPrescription = function(isTemplatePrescription, baseAssign, dataAssign) {
      var prescription;
      prescription = {};
      prescription.ordonnance = null;
      prescription.start_date = !isTemplatePrescription ? moment().format("YYYY-MM-DD") : null;
      prescription.data = {};
      prescription.data.resumption = 'INITIAL';
      prescription.data.type = 'cycled';
      prescription.data.frequency = 1;
      prescription.data.frequency_unit = "days";
      prescription.data.week_days = [];
      prescription.data.quantity_by_timeslot = {};
      prescription.data.end_mode = "duration";
      prescription.data.structured = true;
      prescription.data.source = MhConfig.platform;
      prescription.data.route = {};
      prescription.data.custom_timeslots = {};
      prescription.data.dates = [];
      prescription.data.takes = "slots";
      prescription.data.inn = {};
      _.assign(prescription, baseAssign);
      _.assign(prescription.data, dataAssign);
      return prescription;
    };
    getOrCreateDraftOrdonnance = function(stay_id, author_id) {
      var draftOrdonnancePromise;
      draftOrdonnancePromise = $q.defer();
      Ordonnance.query({
        stay: stay_id,
        state: "DRAFT",
        author: author_id
      }).$promise.then(function(ordonnances) {
        if (ordonnances.length > 0) {
          return draftOrdonnancePromise.resolve(ordonnances[0]);
        } else {
          return Ordonnance.save({
            stay: stay_id,
            state: "DRAFT",
            author: author_id
          }).$promise.then(function(ordonnance) {
            return draftOrdonnancePromise.resolve(ordonnance);
          });
        }
      });
      return draftOrdonnancePromise.promise;
    };
    defaultAdminCodes = [
      {
        "state": "OK",
        "label": "Administration",
        "codes": [
          {
            "code": "S",
            "label": "Administr\u00e9 seul ou par l'entourage"
          }, {
            "code": "AS",
            "label": "Administr\u00e9 par l'AS"
          }, {
            "code": "IDE",
            "label": "Administr\u00e9 par l'IDE"
          }, {
            "code": "PA",
            "label": "Pr\u00e9par\u00e9 et administr\u00e9"
          }
        ],
        "color": "#CBEDB2",
        "has_quantity": true,
        "required_quantity": false
      }, {
        "state": "NOK",
        "label": "Non-administration",
        "codes": [
          {
            "code": "R",
            "label": "Refus du patient"
          }, {
            "code": "AT",
            "label": "Absence de traitement"
          }, {
            "code": "M",
            "label": "Autre motif (Pr\u00e9cisez dans le commentaire)"
          }
        ],
        "color": "#FF9898",
        "has_quantity": true,
        "required_quantity": false
      }
    ];
    routes = [
      {
        "code": "A09",
        "label": "Voie péridurale"
      }, {
        "code": "A10",
        "label": "Voie intra-pariétale"
      }, {
        "code": "A12",
        "label": "Voie gastro-entérale"
      }, {
        "code": "A14",
        "label": "Voie intravasculaire en hémodialyse"
      }, {
        "code": "A20",
        "label": "Voie intra-artérielle"
      }, {
        "code": "A21",
        "label": "Voie intra-articulaire"
      }, {
        "code": "A22",
        "label": "Voie intrabursale"
      }, {
        "code": "A24",
        "label": "Voie intracaverneuse"
      }, {
        "code": "A25",
        "label": "Voie intracervicale"
      }, {
        "code": "A26",
        "label": "Voie intracoronaire"
      }, {
        "code": "A27",
        "label": "Voie intradermique"
      }, {
        "code": "A30",
        "label": "Voie intralymphatique"
      }, {
        "code": "A32",
        "label": "Voie intramusculaire"
      }, {
        "code": "A33",
        "label": "Voie intra-oculaire"
      }, {
        "code": "A34",
        "label": "Voie intrapéritonéale"
      }, {
        "code": "A35",
        "label": "Voie intrapleurale"
      }, {
        "code": "A38",
        "label": "Voie intrarachidienne"
      }, {
        "code": "A40",
        "label": "Voie intraveineuse"
      }, {
        "code": "A41",
        "label": "Voie intravésicale"
      }, {
        "code": "A42",
        "label": "Voie nasale"
      }, {
        "code": "A46",
        "label": "Voie orale"
      }, {
        "code": "A47",
        "label": "Voie buccale"
      }, {
        "code": "A49",
        "label": "Voie péri-articulaire"
      }, {
        "code": "A50",
        "label": "Voie périneurale"
      }, {
        "code": "A52",
        "label": "Voie rectale"
      }, {
        "code": "A58",
        "label": "Voie sous-cutanée"
      }, {
        "code": "A61",
        "label": "Voie transdermique"
      }, {
        "code": "A66",
        "label": "Voie intravasculaire"
      }, {
        "code": "A67",
        "label": "Voie parentérale"
      }, {
        "code": "A68",
        "label": "Voie intrabuccale"
      }, {
        "code": "A69",
        "label": "Voie intrapéricardique"
      }, {
        "code": "A73",
        "label": "Voie inhalée"
      }, {
        "code": "A74",
        "label": "Voie sublinguale"
      }, {
        "code": "A75",
        "label": "Voie endobuccale"
      }, {
        "code": "A76",
        "label": "Voie sous-arachnoïdienne"
      }, {
        "code": "A77",
        "label": "Voie endotrachéopulmonaire"
      }, {
        "code": "A78",
        "label": "Voie endonasale"
      }, {
        "code": "A79",
        "label": "Voie intravitréenne"
      }, {
        "code": "A81",
        "label": "Voie parodontale"
      }, {
        "code": "A82",
        "label": "Voie intramurale"
      }, {
        "code": "B01",
        "label": "Voie auriculaire"
      }, {
        "code": "B02",
        "label": "Voie intra-osseuse"
      }, {
        "code": "B03",
        "label": "Voie cutanée"
      }, {
        "code": "B04",
        "label": "Voie dentaire"
      }, {
        "code": "B07",
        "label": "Voie endosinusale"
      }, {
        "code": "B08",
        "label": "Voie endotrachéobronchique"
      }, {
        "code": "B13",
        "label": "Voie gingivale"
      }, {
        "code": "B29",
        "label": "Voie intralésionnelle"
      }, {
        "code": "B39",
        "label": "Voie intra-utérine"
      }, {
        "code": "B53",
        "label": "Voie respiratoire"
      }, {
        "code": "B62",
        "label": "Voie urétrale"
      }, {
        "code": "B63",
        "label": "Voie vaginale"
      }, {
        "code": "B64",
        "label": "Voie ophtalmique"
      }, {
        "code": "B65",
        "label": "Voie intrathécale"
      }, {
        "code": "B66",
        "label": "Voie intraventriculaire"
      }, {
        "code": "B67",
        "label": "Voie intracavitaire"
      }, {
        "code": "B68",
        "label": "Voie paravertébrale"
      }
    ];
    taking_units = [
      {
        "code": "792",
        "label": "%"
      }, {
        "code": "826",
        "label": "2 flacons + 2 flacons"
      }, {
        "code": "866",
        "label": "Assiette"
      }, {
        "code": "834",
        "label": "Bande"
      }, {
        "code": "835",
        "label": "Bande adhésive"
      }, {
        "code": "909",
        "label": "Bandelette"
      }, {
        "code": "867",
        "label": "Biscuit"
      }, {
        "code": "857",
        "label": "Bol"
      }, {
        "code": "859",
        "label": "Boîte métal"
      }, {
        "code": "957",
        "label": "Cadre"
      }, {
        "code": "829",
        "label": "Coffret"
      }, {
        "code": "903",
        "label": "Comprimé buccogingival muco-adhésif"
      }, {
        "code": "845",
        "label": "Comprimé effervescent"
      }, {
        "code": "839",
        "label": "Comprimé gastrorésistant"
      }, {
        "code": "801",
        "label": "Comprimé pelliculé"
      }, {
        "code": "861",
        "label": "Comprimé pelliculé sécable"
      }, {
        "code": "868",
        "label": "Comprimé pelliculé à libération prolongée"
      }, {
        "code": "782",
        "label": "Comprimé pour suspension buvable"
      }, {
        "code": "810",
        "label": "Comprimé sécable"
      }, {
        "code": "863",
        "label": "Comprimé sécable à libération modifiée"
      }, {
        "code": "840",
        "label": "Comprimé sécable à libération prolongée"
      }, {
        "code": "860",
        "label": "Coupelle"
      }, {
        "code": "836",
        "label": "Dispositif transdermique"
      }, {
        "code": "744",
        "label": "Dose (1 sachet A + 1 sachet B)"
      }, {
        "code": "838",
        "label": "Dose de 100 microgrammes"
      }, {
        "code": "778",
        "label": "Emplâtre médicamenteux"
      }, {
        "code": "856",
        "label": "Emulsion buvable et entérale"
      }, {
        "code": "858",
        "label": "Emulsion pour nutrition entérale"
      }, {
        "code": "816",
        "label": "Evaporateur"
      }, {
        "code": "843",
        "label": "Flacon (+ godet de 10 ml)"
      }, {
        "code": "771",
        "label": "Flacon (+ seringue + microperfuseur stérile)"
      }, {
        "code": "939",
        "label": "Flacon (+ seringue)"
      }, {
        "code": "794",
        "label": "Flacon de 10 doses (suspension)"
      }, {
        "code": "938",
        "label": "Flacon de 100 ml de solution + comprimé"
      }, {
        "code": "910",
        "label": "Flacon de 7,4 GBq"
      }, {
        "code": "769",
        "label": "Flacon multidose"
      }, {
        "code": "777",
        "label": "GBq"
      }, {
        "code": "853",
        "label": "Gelée orale"
      }, {
        "code": "844",
        "label": "Granulé pour solution buvable"
      }, {
        "code": "517",
        "label": "IR"
      }, {
        "code": "715",
        "label": "Kit de 3 jours (1 gélule 125 mg + 2 gélules 80 mg)"
      }, {
        "code": "916",
        "label": "Lancette"
      }, {
        "code": "591",
        "label": "MBq"
      }, {
        "code": "549",
        "label": "MBq à injecter"
      }, {
        "code": "713",
        "label": "MU"
      }, {
        "code": "520",
        "label": "MUI"
      }, {
        "code": "851",
        "label": "Nébuliseur"
      }, {
        "code": "865",
        "label": "Poche (PVC) avec embout T-OFF"
      }, {
        "code": "775",
        "label": "Poche (polyoléfine) MACOFLEX N suremballée"
      }, {
        "code": "833",
        "label": "Poche bicompartimentée"
      }, {
        "code": "896",
        "label": "Poche de suspension reconstituée"
      }, {
        "code": "799",
        "label": "Poche simple avec raccord Luer"
      }, {
        "code": "852",
        "label": "Poudre pour solution à diluer pour perfusion"
      }, {
        "code": "854",
        "label": "Poudre pour suspension buvable"
      }, {
        "code": "803",
        "label": "Récipient"
      }, {
        "code": "828",
        "label": "Savon"
      }, {
        "code": "895",
        "label": "Seringue remplie à 3 ml"
      }, {
        "code": "842",
        "label": "Solution buvable"
      }, {
        "code": "809",
        "label": "Solution injectable"
      }, {
        "code": "800",
        "label": "Solution pour dialyse péritonéale"
      }, {
        "code": "795",
        "label": "Solution pour perfusion"
      }, {
        "code": "802",
        "label": "Stick"
      }, {
        "code": "793",
        "label": "Suspension injectable"
      }, {
        "code": "534",
        "label": "U"
      }, {
        "code": "682",
        "label": "U.CEIP"
      }, {
        "code": "25",
        "label": "UI"
      }, {
        "code": "270",
        "label": "UI anti-Xa"
      }, {
        "code": "629",
        "label": "UI de facteur IX"
      }, {
        "code": "924",
        "label": "UI de facteur VIII"
      }, {
        "code": "655",
        "label": "UI de facteur Willebrand"
      }, {
        "code": "552",
        "label": "UIK"
      }, {
        "code": "702",
        "label": "UK"
      }, {
        "code": "841",
        "label": "Unité Anti-Héparine (U.A.H.)"
      }, {
        "code": "962",
        "label": "Unité speywood"
      }, {
        "code": "4",
        "label": "ampoule"
      }, {
        "code": "586",
        "label": "ampoule en nébulisation"
      }, {
        "code": "705",
        "label": "anneau vaginal"
      }, {
        "code": "846",
        "label": "applicateur à usage unique"
      }, {
        "code": "3",
        "label": "application"
      }, {
        "code": "269",
        "label": "application d'un compte-gouttes"
      }, {
        "code": "963",
        "label": "application d'un cordon de 1 cm de pommade"
      }, {
        "code": "683",
        "label": "application d'un ruban de 1,25 cm"
      }, {
        "code": "871",
        "label": "application de 0,2 g"
      }, {
        "code": "443",
        "label": "application de 0,5 g"
      }, {
        "code": "301",
        "label": "application de 1 g"
      }, {
        "code": "289",
        "label": "application de 10 à 20 g"
      }, {
        "code": "729",
        "label": "application de 2,5 g"
      }, {
        "code": "730",
        "label": "application de 4 g"
      }, {
        "code": "555",
        "label": "application de 5 ml"
      }, {
        "code": "381",
        "label": "application de 7 à 14 pulvérisations"
      }, {
        "code": "612",
        "label": "application de TISSUCOL KIT"
      }, {
        "code": "524",
        "label": "application de deux doses"
      }, {
        "code": "295",
        "label": "application vaginale"
      }, {
        "code": "382",
        "label": "application à l'aide d'un tampon"
      }, {
        "code": "124",
        "label": "badigeonnage"
      }, {
        "code": "460",
        "label": "badigeonnage local"
      }, {
        "code": "404",
        "label": "badigeonnage ou tamponnement"
      }, {
        "code": "344",
        "label": "bain d'oreille"
      }, {
        "code": "140",
        "label": "bain de bouche"
      }, {
        "code": "703",
        "label": "bain de bouche (1 c. à soupe dans un verre d'eau)"
      }, {
        "code": "252",
        "label": "bain de bouche ou gargarisme"
      }, {
        "code": "43",
        "label": "bouchon"
      }, {
        "code": "35",
        "label": "bouffée"
      }, {
        "code": "798",
        "label": "bouteille"
      }, {
        "code": "212",
        "label": "boîte"
      }, {
        "code": "814",
        "label": "boîte jumelée"
      }, {
        "code": "855",
        "label": "brique"
      }, {
        "code": "139",
        "label": "brossage"
      }, {
        "code": "391",
        "label": "brossage suivi d'un massage des gencives"
      }, {
        "code": "748",
        "label": "bâton"
      }, {
        "code": "584",
        "label": "bâton à 1000 µg"
      }, {
        "code": "582",
        "label": "bâton à 250 µg"
      }, {
        "code": "583",
        "label": "bâton à 500 µg"
      }, {
        "code": "2",
        "label": "capsule"
      }, {
        "code": "864",
        "label": "capsule molle"
      }, {
        "code": "173",
        "label": "capsule vaginale"
      }, {
        "code": "600",
        "label": "cartouche"
      }, {
        "code": "832",
        "label": "cartouche préremplie"
      }, {
        "code": "167",
        "label": "cataplasme"
      }, {
        "code": "546",
        "label": "cm de crème à appliquer"
      }, {
        "code": "947",
        "label": "cm de gel à appliquer"
      }, {
        "code": "940",
        "label": "cm²"
      }, {
        "code": "397",
        "label": "compresse à appliquer"
      }, {
        "code": "1",
        "label": "comprimé"
      }, {
        "code": "327",
        "label": "comprimé bleu à 50 µg"
      }, {
        "code": "752",
        "label": "comprimé buccal muco-adhésif à appliquer"
      }, {
        "code": "818",
        "label": "comprimé ou gélule"
      }, {
        "code": "588",
        "label": "comprimé par jour"
      }, {
        "code": "326",
        "label": "comprimé rose à 25 µg"
      }, {
        "code": "85",
        "label": "comprimé vaginal"
      }, {
        "code": "54",
        "label": "comprimé à croquer"
      }, {
        "code": "231",
        "label": "comprimé à croquer ou à sucer"
      }, {
        "code": "760",
        "label": "comprimé à mâcher"
      }, {
        "code": "205",
        "label": "comprimé à sucer"
      }, {
        "code": "848",
        "label": "creuset"
      }, {
        "code": "453",
        "label": "cuillère doseuse de 10 ml"
      }, {
        "code": "12",
        "label": "cuillère à café"
      }, {
        "code": "300",
        "label": "cuillère à café arasée"
      }, {
        "code": "213",
        "label": "cuillère à dessert"
      }, {
        "code": "11",
        "label": "cuillère à soupe"
      }, {
        "code": "751",
        "label": "cuillère à soupe ou mesure graduée (godet) à 15 ml"
      }, {
        "code": "8",
        "label": "cuillère-dose"
      }, {
        "code": "450",
        "label": "cuillère-doseuse"
      }, {
        "code": "29",
        "label": "cuillère-mesure"
      }, {
        "code": "886",
        "label": "cuillère-mesure (graduation à 1,25 ml)"
      }, {
        "code": "528",
        "label": "cuillère-mesure (graduation à 2,5 ml)"
      }, {
        "code": "931",
        "label": "cuillère-mesure (graduation à 5 ml)"
      }, {
        "code": "660",
        "label": "cuillère-mesure bleue"
      }, {
        "code": "217",
        "label": "cuillère-mesure de 2,5 ml"
      }, {
        "code": "899",
        "label": "cuillère-mesure de 3 g"
      }, {
        "code": "421",
        "label": "cuillère-mesure de 4 ml"
      }, {
        "code": "218",
        "label": "cuillère-mesure de 5 ml"
      }, {
        "code": "277",
        "label": "dispositif"
      }, {
        "code": "954",
        "label": "dispositif de mesure"
      }, {
        "code": "358",
        "label": "dispositif intra-utérin"
      }, {
        "code": "418",
        "label": "dispositif à appliquer"
      }, {
        "code": "797",
        "label": "disque"
      }, {
        "code": "817",
        "label": "distributeur diskus"
      }, {
        "code": "18",
        "label": "dose"
      }, {
        "code": "290",
        "label": "dose (1 ampoule + 1 gélule)"
      }, {
        "code": "393",
        "label": "dose (1 ampoule A + 1 ampoule B)"
      }, {
        "code": "533",
        "label": "dose (1 gélule verte + 1 gélule orange)"
      }, {
        "code": "815",
        "label": "dose (1 sachet n°1 + 1 sachet n°2)"
      }, {
        "code": "685",
        "label": "dose (1/4 ml)"
      }, {
        "code": "941",
        "label": "dose L"
      }, {
        "code": "658",
        "label": "dose de 0,05 ml"
      }, {
        "code": "659",
        "label": "dose de 0,1 ml"
      }, {
        "code": "732",
        "label": "dose de 0,25 ml"
      }, {
        "code": "686",
        "label": "dose de 0,3 ml"
      }, {
        "code": "362",
        "label": "dose de 0,5 ml"
      }, {
        "code": "837",
        "label": "dose de 0,6 mg"
      }, {
        "code": "935",
        "label": "dose de 0,65 ml"
      }, {
        "code": "346",
        "label": "dose de 1 ml"
      }, {
        "code": "877",
        "label": "dose de 1,2 mg"
      }, {
        "code": "878",
        "label": "dose de 1,8 mg"
      }, {
        "code": "299",
        "label": "dose de 10 ml"
      }, {
        "code": "764",
        "label": "dose de 10 µg"
      }, {
        "code": "322",
        "label": "dose de 15 ml"
      }, {
        "code": "519",
        "label": "dose de 2 comprimés"
      }, {
        "code": "699",
        "label": "dose de 2 ml"
      }, {
        "code": "879",
        "label": "dose de 2,25 g"
      }, {
        "code": "747",
        "label": "dose de 2,5 cm"
      }, {
        "code": "712",
        "label": "dose de 20 µg"
      }, {
        "code": "880",
        "label": "dose de 4,5 g"
      }, {
        "code": "547",
        "label": "dose de 5 g"
      }, {
        "code": "222",
        "label": "dose de 5 ml"
      }, {
        "code": "765",
        "label": "dose de 5 µg"
      }, {
        "code": "813",
        "label": "dose de deux gélules"
      }, {
        "code": "302",
        "label": "dose n°1"
      }, {
        "code": "942",
        "label": "dose n°2"
      }, {
        "code": "251",
        "label": "dose unitaire"
      }, {
        "code": "132",
        "label": "emplâtre"
      }, {
        "code": "825",
        "label": "ensemble de 3 flacons"
      }, {
        "code": "902",
        "label": "film orodispersible"
      }, {
        "code": "26",
        "label": "flacon"
      }, {
        "code": "827",
        "label": "flacon A + flacon B"
      }, {
        "code": "824",
        "label": "flacon n°1 + flacon n°2"
      }, {
        "code": "652",
        "label": "flacon reconstitué"
      }, {
        "code": "786",
        "label": "flacon à diluer"
      }, {
        "code": "152",
        "label": "friction"
      }, {
        "code": "819",
        "label": "fût"
      }, {
        "code": "9",
        "label": "g"
      }, {
        "code": "379",
        "label": "g d'acides aminés"
      }, {
        "code": "873",
        "label": "g d'amoxicilline"
      }, {
        "code": "585",
        "label": "g d'azote"
      }, {
        "code": "922",
        "label": "g d'estriol"
      }, {
        "code": "926",
        "label": "g d'émulsion"
      }, {
        "code": "621",
        "label": "g de N(2)-L-analyl-L-glutamine"
      }, {
        "code": "876",
        "label": "g de Ticarcilline"
      }, {
        "code": "965",
        "label": "g de benzoate de sodium"
      }, {
        "code": "925",
        "label": "g de crème"
      }, {
        "code": "949",
        "label": "g de diosmectite"
      }, {
        "code": "634",
        "label": "g de gel"
      }, {
        "code": "648",
        "label": "g de glucose"
      }, {
        "code": "966",
        "label": "g de granulés"
      }, {
        "code": "613",
        "label": "g de lipides"
      }, {
        "code": "930",
        "label": "g de lotion"
      }, {
        "code": "919",
        "label": "g de phénylbutyrate de sodium"
      }, {
        "code": "948",
        "label": "g de pommade"
      }, {
        "code": "911",
        "label": "g de potassium"
      }, {
        "code": "665",
        "label": "g de poudre"
      }, {
        "code": "929",
        "label": "g de shampooing"
      }, {
        "code": "875",
        "label": "g de sodium"
      }, {
        "code": "927",
        "label": "g de solution"
      }, {
        "code": "850",
        "label": "g de spray"
      }, {
        "code": "525",
        "label": "g de triglycérides"
      }, {
        "code": "928",
        "label": "g de vernis"
      }, {
        "code": "32",
        "label": "gobelet"
      }, {
        "code": "390",
        "label": "gobelet doseur de 10 ml"
      }, {
        "code": "396",
        "label": "gobelet doseur de 5 ml"
      }, {
        "code": "283",
        "label": "gobelet-doseur"
      }, {
        "code": "776",
        "label": "gobelet-doseur de 15 ml"
      }, {
        "code": "959",
        "label": "godet de 30 ml"
      }, {
        "code": "570",
        "label": "godet de 5 ml"
      }, {
        "code": "444",
        "label": "godet-doseur"
      }, {
        "code": "568",
        "label": "godet-doseur de 10 ml"
      }, {
        "code": "708",
        "label": "godet-doseur de 15 ml"
      }, {
        "code": "690",
        "label": "godet-doseur de 3,3 ml"
      }, {
        "code": "663",
        "label": "godet-doseur de 5 ml"
      }, {
        "code": "691",
        "label": "godet-doseur de 6,6 ml"
      }, {
        "code": "259",
        "label": "gomme"
      }, {
        "code": "24",
        "label": "goutte"
      }, {
        "code": "950",
        "label": "goutte dans chaque narine"
      }, {
        "code": "637",
        "label": "goutte à appliquer"
      }, {
        "code": "216",
        "label": "graduation"
      }, {
        "code": "882",
        "label": "graduation de 0,1 ml de la seringue orale"
      }, {
        "code": "904",
        "label": "graduation de 0,2 ml de la seringue orale"
      }, {
        "code": "872",
        "label": "graduation de 0,5 ml de la seringue orale"
      }, {
        "code": "881",
        "label": "graduation de 1 ml de la seringue orale"
      }, {
        "code": "890",
        "label": "graduation de 10 gouttes de la seringue orale"
      }, {
        "code": "918",
        "label": "graduation de 10 ml du bouchon doseur"
      }, {
        "code": "388",
        "label": "graduation de 10 ml du gobelet doseur"
      }, {
        "code": "869",
        "label": "graduation de 10 ml du godet-doseur"
      }, {
        "code": "912",
        "label": "graduation de 12 ml du godet-doseur"
      }, {
        "code": "531",
        "label": "graduation de 15 ml du godet-doseur"
      }, {
        "code": "901",
        "label": "graduation de 2,5 ml de la seringue orale"
      }, {
        "code": "862",
        "label": "graduation de 2,5 ml du godet-doseur"
      }, {
        "code": "888",
        "label": "graduation de 20 mg du godet-doseur"
      }, {
        "code": "892",
        "label": "graduation de 3 ml de la seringue"
      }, {
        "code": "893",
        "label": "graduation de 4 ml de la seringue"
      }, {
        "code": "894",
        "label": "graduation de 4,2 ml de la seringue"
      }, {
        "code": "884",
        "label": "graduation de 5 ml de la seringue orale"
      }, {
        "code": "359",
        "label": "graduation de 5 ml du gobelet doseur"
      }, {
        "code": "885",
        "label": "graduation de 5 ml du godet-doseur"
      }, {
        "code": "891",
        "label": "graduation de 50 gouttes de la seringue orale"
      }, {
        "code": "790",
        "label": "graduation du gobelet-doseur"
      }, {
        "code": "151",
        "label": "granule"
      }, {
        "code": "31",
        "label": "gélule"
      }, {
        "code": "532",
        "label": "gélule vaginale"
      }, {
        "code": "292",
        "label": "gélule à inhaler"
      }, {
        "code": "823",
        "label": "générateur"
      }, {
        "code": "94",
        "label": "implant"
      }, {
        "code": "578",
        "label": "implant oculaire"
      }, {
        "code": "136",
        "label": "infusion"
      }, {
        "code": "84",
        "label": "inhalation"
      }, {
        "code": "10",
        "label": "injection"
      }, {
        "code": "556",
        "label": "injection de 0,3 ml"
      }, {
        "code": "281",
        "label": "injection de 0,5 ml"
      }, {
        "code": "406",
        "label": "injection de 1 ml"
      }, {
        "code": "412",
        "label": "injection de 10 mg"
      }, {
        "code": "330",
        "label": "injection de 10 µg"
      }, {
        "code": "411",
        "label": "injection de 20 mg"
      }, {
        "code": "333",
        "label": "injection de 20 µg"
      }, {
        "code": "456",
        "label": "injection de 30 mg"
      }, {
        "code": "548",
        "label": "injection de 40 µg"
      }, {
        "code": "332",
        "label": "injection de 5 µg"
      }, {
        "code": "523",
        "label": "injection intrasinusienne de 5 ml"
      }, {
        "code": "207",
        "label": "injection vaginale"
      }, {
        "code": "165",
        "label": "insert"
      }, {
        "code": "554",
        "label": "insert ophtalmique"
      }, {
        "code": "680",
        "label": "inspiration par narine"
      }, {
        "code": "81",
        "label": "instillation"
      }, {
        "code": "597",
        "label": "instillation de 81 mg"
      }, {
        "code": "401",
        "label": "instillation vulvovaginale"
      }, {
        "code": "575",
        "label": "irrigation"
      }, {
        "code": "674",
        "label": "kBq"
      }, {
        "code": "400",
        "label": "kg-graduation"
      }, {
        "code": "611",
        "label": "kit"
      }, {
        "code": "117",
        "label": "lavage"
      }, {
        "code": "273",
        "label": "lavage oculaire"
      }, {
        "code": "255",
        "label": "lavage ou application"
      }, {
        "code": "276",
        "label": "lavage ou instillation"
      }, {
        "code": "89",
        "label": "lavement"
      }, {
        "code": "163",
        "label": "litre"
      }, {
        "code": "274",
        "label": "lyophilisat"
      }, {
        "code": "138",
        "label": "lyophilisat oral"
      }, {
        "code": "936",
        "label": "mL de solution initiale à 250 mg/mL"
      }, {
        "code": "148",
        "label": "massage"
      }, {
        "code": "944",
        "label": "matrice"
      }, {
        "code": "131",
        "label": "mesure"
      }, {
        "code": "228",
        "label": "mesure de 10 ml"
      }, {
        "code": "227",
        "label": "mesure de 15 ml"
      }, {
        "code": "377",
        "label": "mesure de 5 ml"
      }, {
        "code": "640",
        "label": "mesure de 7,5 ml"
      }, {
        "code": "304",
        "label": "mesure de chaque flacon"
      }, {
        "code": "508",
        "label": "mesure de la réglette"
      }, {
        "code": "384",
        "label": "mesure graduée à 10 ml"
      }, {
        "code": "383",
        "label": "mesure graduée à 5 ml"
      }, {
        "code": "162",
        "label": "mesurette"
      }, {
        "code": "618",
        "label": "mesurette de 20 ml"
      }, {
        "code": "48",
        "label": "mg"
      }, {
        "code": "571",
        "label": "mg d'EP"
      }, {
        "code": "619",
        "label": "mg d'acide clavulanique"
      }, {
        "code": "723",
        "label": "mg d'alginate de sodium"
      }, {
        "code": "917",
        "label": "mg d'amoxicilline"
      }, {
        "code": "687",
        "label": "mg d'ampicilline"
      }, {
        "code": "673",
        "label": "mg d'antimoine"
      }, {
        "code": "913",
        "label": "mg d'estriol"
      }, {
        "code": "574",
        "label": "mg d'hydroxyde de magnésium"
      }, {
        "code": "958",
        "label": "mg de bupivacaïne"
      }, {
        "code": "956",
        "label": "mg de calcium élément"
      }, {
        "code": "964",
        "label": "mg de ceftazidime"
      }, {
        "code": "960",
        "label": "mg de ceftolozane"
      }, {
        "code": "633",
        "label": "mg de chlorhydrate de lidocaïne"
      }, {
        "code": "741",
        "label": "mg de citrate de caféine"
      }, {
        "code": "849",
        "label": "mg de diclofénac sodique"
      }, {
        "code": "545",
        "label": "mg de fer métal"
      }, {
        "code": "914",
        "label": "mg de gel"
      }, {
        "code": "906",
        "label": "mg de lidocaïne"
      }, {
        "code": "718",
        "label": "mg de lopinavir"
      }, {
        "code": "721",
        "label": "mg de lévodopa"
      }, {
        "code": "887",
        "label": "mg de magnésium"
      }, {
        "code": "953",
        "label": "mg de miconazole"
      }, {
        "code": "905",
        "label": "mg de métronidazole base"
      }, {
        "code": "951",
        "label": "mg de paracétamol"
      }, {
        "code": "716",
        "label": "mg de pholcodine"
      }, {
        "code": "695",
        "label": "mg de phospholipides"
      }, {
        "code": "898",
        "label": "mg de phénylbutyrate de sodium"
      }, {
        "code": "946",
        "label": "mg de phényléphrine"
      }, {
        "code": "635",
        "label": "mg de pipéracilline"
      }, {
        "code": "807",
        "label": "mg de poudre"
      }, {
        "code": "722",
        "label": "mg de prednisolone"
      }, {
        "code": "952",
        "label": "mg de périndopril tosilate"
      }, {
        "code": "606",
        "label": "mg de rifampicine"
      }, {
        "code": "305",
        "label": "mg de sennosides"
      }, {
        "code": "874",
        "label": "mg de sodium"
      }, {
        "code": "615",
        "label": "mg de sulfaméthoxazole"
      }, {
        "code": "870",
        "label": "mg de ticarcilline"
      }, {
        "code": "961",
        "label": "mg de trifluridine"
      }, {
        "code": "667",
        "label": "mg de triméthoprime"
      }, {
        "code": "609",
        "label": "mg de tégafur"
      }, {
        "code": "915",
        "label": "mg de ténofovir disoproxil"
      }, {
        "code": "632",
        "label": "mg par nébulisation"
      }, {
        "code": "772",
        "label": "microgramme"
      }, {
        "code": "923",
        "label": "microgramme d'estriol"
      }, {
        "code": "766",
        "label": "microlitre"
      }, {
        "code": "93",
        "label": "million UI"
      }, {
        "code": "423",
        "label": "million d'UI"
      }, {
        "code": "27",
        "label": "ml"
      }, {
        "code": "649",
        "label": "ml d'infusion"
      }, {
        "code": "654",
        "label": "ml de dispersion liposomale à diluer"
      }, {
        "code": "653",
        "label": "ml de flacon reconstitué"
      }, {
        "code": "796",
        "label": "ml de solution"
      }, {
        "code": "720",
        "label": "ml de solution après dilution"
      }, {
        "code": "920",
        "label": "ml de solution concentrée à 10000 ng/ml"
      }, {
        "code": "932",
        "label": "ml de solution concentrée à 100000 ng/ml"
      }, {
        "code": "921",
        "label": "ml de solution concentrée à 30000 ng/ml"
      }, {
        "code": "933",
        "label": "ml de solution concentrée à 300000 ng/ml"
      }, {
        "code": "676",
        "label": "ml de solution d'imipénème à 5 mg/ml"
      }, {
        "code": "694",
        "label": "ml de solution de prémélange à 10 mg/ml"
      }, {
        "code": "596",
        "label": "ml de solution diluée"
      }, {
        "code": "734",
        "label": "ml de solution diluée au 1/10ème"
      }, {
        "code": "784",
        "label": "ml de solution diluée à 0,36 mg/ml"
      }, {
        "code": "780",
        "label": "ml de solution diluée à 20 µg/ml"
      }, {
        "code": "750",
        "label": "ml de solution dosée à 0,2 µg/ml"
      }, {
        "code": "754",
        "label": "ml de solution dosée à 0,25 mg/ml"
      }, {
        "code": "645",
        "label": "ml de solution dosée à 1 mg/ml"
      }, {
        "code": "761",
        "label": "ml de solution dosée à 1,5 µg/ml"
      }, {
        "code": "647",
        "label": "ml de solution dosée à 10 mg/ml"
      }, {
        "code": "670",
        "label": "ml de solution dosée à 100 mg/ml"
      }, {
        "code": "593",
        "label": "ml de solution dosée à 2 mg/ml"
      }, {
        "code": "749",
        "label": "ml de solution dosée à 2 µg/ml"
      }, {
        "code": "943",
        "label": "ml de solution dosée à 25 mg/ml"
      }, {
        "code": "671",
        "label": "ml de solution dosée à 3,3 mg/ml"
      }, {
        "code": "907",
        "label": "ml de solution dosée à 30 mg/ml"
      }, {
        "code": "592",
        "label": "ml de solution dosée à 5 mg/ml"
      }, {
        "code": "594",
        "label": "ml de solution dosée à 5 µg/ml"
      }, {
        "code": "651",
        "label": "ml de solution dosée à 7 mg/ml"
      }, {
        "code": "773",
        "label": "ml de solution finale à 5 mg/ml"
      }, {
        "code": "595",
        "label": "ml de solution initiale"
      }, {
        "code": "646",
        "label": "ml de solution initiale à 0,5 mg/ml"
      }, {
        "code": "641",
        "label": "ml de solution initiale à 1 g/20 ml"
      }, {
        "code": "675",
        "label": "ml de solution initiale à 1 mg/ml"
      }, {
        "code": "664",
        "label": "ml de solution initiale à 10 mg/ml"
      }, {
        "code": "724",
        "label": "ml de solution initiale à 100 mg/ml"
      }, {
        "code": "657",
        "label": "ml de solution initiale à 100 µg/ml"
      }, {
        "code": "700",
        "label": "ml de solution initiale à 12,5 mg/ml"
      }, {
        "code": "945",
        "label": "ml de solution initiale à 2 g/20 ml"
      }, {
        "code": "684",
        "label": "ml de solution initiale à 2 mg/ml"
      }, {
        "code": "607",
        "label": "ml de solution initiale à 20 mg/ml"
      }, {
        "code": "678",
        "label": "ml de solution initiale à 200 mg/ml"
      }, {
        "code": "770",
        "label": "ml de solution initiale à 25 mg/ml"
      }, {
        "code": "753",
        "label": "ml de solution initiale à 5 mg/ml"
      }, {
        "code": "620",
        "label": "ml de solution initiale à 50 mg/ml"
      }, {
        "code": "642",
        "label": "ml de solution initiale à 500 mg/10 ml"
      }, {
        "code": "733",
        "label": "ml de solution initiale à 6%"
      }, {
        "code": "756",
        "label": "ml de solution non diluée"
      }, {
        "code": "560",
        "label": "ml de solution reconstituée"
      }, {
        "code": "656",
        "label": "ml de solution reconstituée (1 + 2)"
      }, {
        "code": "763",
        "label": "ml de solution reconstituée à 0,05 mg/ml"
      }, {
        "code": "774",
        "label": "ml de solution reconstituée à 1 mg/ml"
      }, {
        "code": "737",
        "label": "ml de solution reconstituée à 10 mg/ml"
      }, {
        "code": "847",
        "label": "ml de solution reconstituée à 100 mg/ml"
      }, {
        "code": "725",
        "label": "ml de solution reconstituée à 2,5 mg/ml"
      }, {
        "code": "677",
        "label": "ml de solution reconstituée à 20 mg/ml"
      }, {
        "code": "711",
        "label": "ml de solution reconstituée à 25 mg/ml"
      }, {
        "code": "785",
        "label": "ml de solution reconstituée à 3,33 mg/ml à diluer"
      }, {
        "code": "783",
        "label": "ml de solution reconstituée à 38 mg/ml"
      }, {
        "code": "643",
        "label": "ml de solution reconstituée à 4 mg/ml"
      }, {
        "code": "779",
        "label": "ml de solution reconstituée à 40 mg/ml"
      }, {
        "code": "728",
        "label": "ml de solution reconstituée à 5 mg/ml"
      }, {
        "code": "897",
        "label": "ml de solution reconstituée à 80 mg/ml"
      }, {
        "code": "681",
        "label": "ml de solution reconstituée à 90 mg/ml"
      }, {
        "code": "625",
        "label": "ml de solution reconstituée à diluer"
      }, {
        "code": "661",
        "label": "ml de solution à 0,4 mg/ml"
      }, {
        "code": "710",
        "label": "ml de solution à 0,5 mg/ml"
      }, {
        "code": "955",
        "label": "ml de solution à 0,8 mg/ml"
      }, {
        "code": "791",
        "label": "ml de solution à 1 mg/ml"
      }, {
        "code": "714",
        "label": "ml de solution à 1,5 mg/ml"
      }, {
        "code": "788",
        "label": "ml de solution à 10 mg/ml"
      }, {
        "code": "601",
        "label": "ml de solution à 10%"
      }, {
        "code": "614",
        "label": "ml de solution à 100 mg/ml"
      }, {
        "code": "610",
        "label": "ml de solution à 2,5 mg/ml"
      }, {
        "code": "698",
        "label": "ml de solution à 2,5%"
      }, {
        "code": "787",
        "label": "ml de solution à 20 mg/ml"
      }, {
        "code": "598",
        "label": "ml de solution à 200 U/ml"
      }, {
        "code": "745",
        "label": "ml de solution à 200 mg/ml"
      }, {
        "code": "757",
        "label": "ml de solution à 300 UI/ml"
      }, {
        "code": "937",
        "label": "ml de solution à 4mg/ml"
      }, {
        "code": "900",
        "label": "ml de solution à 5 mg/ml"
      }, {
        "code": "781",
        "label": "ml de solution à 5,2 mg/ml"
      }, {
        "code": "742",
        "label": "ml de solution à 50 mg/ml"
      }, {
        "code": "599",
        "label": "ml de solution à 500 U/ml"
      }, {
        "code": "743",
        "label": "ml de solution à diluer"
      }, {
        "code": "553",
        "label": "ml de suspension diluée"
      }, {
        "code": "662",
        "label": "ml de suspension reconstituée"
      }, {
        "code": "934",
        "label": "ml de suspension à diluer"
      }, {
        "code": "697",
        "label": "ml du mélange"
      }, {
        "code": "551",
        "label": "ml par application"
      }, {
        "code": "631",
        "label": "ml par nébulisation"
      }, {
        "code": "789",
        "label": "ml à inhaler"
      }, {
        "code": "515",
        "label": "mmol"
      }, {
        "code": "738",
        "label": "mmol de calcium"
      }, {
        "code": "735",
        "label": "mmol de fer"
      }, {
        "code": "605",
        "label": "mmol de phosphore"
      }, {
        "code": "889",
        "label": "mmol de potassium"
      }, {
        "code": "746",
        "label": "mmol de sodium"
      }, {
        "code": "402",
        "label": "nettoyage"
      }, {
        "code": "608",
        "label": "ng"
      }, {
        "code": "123",
        "label": "nébulisation"
      }, {
        "code": "86",
        "label": "ovule"
      }, {
        "code": "830",
        "label": "pain"
      }, {
        "code": "812",
        "label": "pansement"
      }, {
        "code": "364",
        "label": "pansement à appliquer"
      }, {
        "code": "97",
        "label": "pastille"
      }, {
        "code": "96",
        "label": "pastille à sucer"
      }, {
        "code": "701",
        "label": "patch"
      }, {
        "code": "511",
        "label": "patch à appliquer"
      }, {
        "code": "811",
        "label": "pilule"
      }, {
        "code": "433",
        "label": "pipette"
      }, {
        "code": "230",
        "label": "poche"
      }, {
        "code": "415",
        "label": "pot"
      }, {
        "code": "129",
        "label": "poudrage"
      }, {
        "code": "7",
        "label": "pression"
      }, {
        "code": "395",
        "label": "pression à appliquer"
      }, {
        "code": "69",
        "label": "prise"
      }, {
        "code": "36",
        "label": "pulvérisation"
      }, {
        "code": "449",
        "label": "pulvérisation dans chaque narine"
      }, {
        "code": "235",
        "label": "pulvérisation nasale"
      }, {
        "code": "44",
        "label": "pâte"
      }, {
        "code": "204",
        "label": "pâte pectorale"
      }, {
        "code": "121",
        "label": "pâte à sucer"
      }, {
        "code": "352",
        "label": "ruban d'un demi-centimètre"
      }, {
        "code": "147",
        "label": "récipient unidose"
      }, {
        "code": "821",
        "label": "sac"
      }, {
        "code": "13",
        "label": "sachet"
      }, {
        "code": "158",
        "label": "sachet-dose"
      }, {
        "code": "514",
        "label": "sachet-dose par tasse"
      }, {
        "code": "416",
        "label": "savonnage"
      }, {
        "code": "199",
        "label": "seringue"
      }, {
        "code": "883",
        "label": "seringue orale de 5 ml"
      }, {
        "code": "101",
        "label": "seringue préremplie"
      }, {
        "code": "157",
        "label": "shampooing"
      }, {
        "code": "567",
        "label": "sinapisme"
      }, {
        "code": "768",
        "label": "stylo"
      }, {
        "code": "808",
        "label": "stylo prérempli"
      }, {
        "code": "39",
        "label": "suppositoire"
      }, {
        "code": "908",
        "label": "système de diffusion intra-utérin"
      }, {
        "code": "709",
        "label": "système de diffusion vaginal"
      }, {
        "code": "510",
        "label": "système à appliquer"
      }, {
        "code": "369",
        "label": "séance"
      }, {
        "code": "309",
        "label": "tablette à croquer"
      }, {
        "code": "428",
        "label": "tablette à mâcher"
      }, {
        "code": "183",
        "label": "tampon"
      }, {
        "code": "98",
        "label": "tasse"
      }, {
        "code": "831",
        "label": "trousse"
      }, {
        "code": "99",
        "label": "tube"
      }, {
        "code": "46",
        "label": "tube unidose"
      }, {
        "code": "202",
        "label": "tube-canule"
      }, {
        "code": "64",
        "label": "unidose"
      }, {
        "code": "604",
        "label": "unité"
      }, {
        "code": "767",
        "label": "unité DL50"
      }, {
        "code": "669",
        "label": "unité anti-Xa"
      }, {
        "code": "759",
        "label": "unité hebdomadaire"
      }, {
        "code": "119",
        "label": "utilisation"
      }, {
        "code": "142",
        "label": "vaporisation"
      }, {
        "code": "133",
        "label": "verre à Porto"
      }, {
        "code": "967",
        "label": "µL de solution"
      }, {
        "code": "42",
        "label": "µg"
      }, {
        "code": "590",
        "label": "µmol"
      }, {
        "code": "717",
        "label": "éponge"
      }, {
        "code": "820",
        "label": "évaporisateur"
      }
    ];
    cachedOrdonnances = {};
    getPharmaValidation = function(prescription) {
      return Prescription.getPharmaValidation({
        id: prescription.id
      }).$promise.then()["catch"](function(e) {
        if (e.status === 404) {
          return null;
        } else {
          return $q.reject(e);
        }
      }).then(function(pharmaValidation) {
        if (pharmaValidation) {
          return Prescription.getPharmaDelivery({
            id: prescription.id
          }).$promise.then()["catch"](function(e) {
            if (e.status === 404) {
              return null;
            } else {
              return $q.reject(e);
            }
          }).then(function(pharmaDelivery) {
            pharmaValidation.pharma_delivery = pharmaDelivery;
            if (pharmaDelivery) {
              return Prescription.getCollectionValidatedDeliveries({
                id: prescription.id
              }).$promise.then(function(validatedCollections) {
                pharmaDelivery.validated_collections = validatedCollections;
                return pharmaValidation;
              });
            } else {
              return pharmaValidation;
            }
          });
        }
      });
    };
    getPrescriptionDetails = function(presc, dontToggle, disableDispensations) {
      var detailDone, ordonnance_loaded;
      if (Object.keys(cachedOrdonnances).length > 200) {
        cachedOrdonnances = {};
      }
      detailDone = $q.defer();
      if (!presc.has_details) {
        presc.has_details = true;
        ordonnance_loaded = $q.defer();
        if (presc.data.stop_reason) {
          presc.stopped_info = _.find(stopAvailableReasons, {
            code: presc.data.stop_reason
          });
        }
        if (typeof presc.ordonnance === 'number') {
          if (cachedOrdonnances[presc.ordonnance] != null) {
            presc.ordonnance = cachedOrdonnances[presc.ordonnance];
            ordonnance_loaded.resolve();
          } else {
            Ordonnance.get({
              id: presc.ordonnance
            }).$promise.then(function(ordonnance) {
              cachedOrdonnances[presc.ordonnance] = ordonnance;
              presc.ordonnance = ordonnance;
              return ordonnance_loaded.resolve();
            });
          }
        } else {
          ordonnance_loaded.resolve();
        }
        ordonnance_loaded.promise.then(function() {
          if (disableDispensations) {
            if (!dontToggle) {
              presc.unfold = !presc.unfold;
            }
            return detailDone.resolve();
          } else {
            return Prescription.getDispensations({
              id: presc.id
            }).$promise.then(function(dispensations) {
              presc.dispensations = dispensations;
              if (!dontToggle) {
                presc.unfold = !presc.unfold;
              }
              return detailDone.resolve();
            });
          }
        });
      } else {
        if (!dontToggle) {
          presc.unfold = !presc.unfold;
        }
        detailDone.resolve();
      }
      return detailDone.promise;
    };
    groupPrescriptions = function(prescriptions) {
      var groupedPrescriptions;
      groupedPrescriptions = [];
      prescriptions.forEach(function(prescription) {
        var group;
        if (prescription.group) {
          group = _.find(groupedPrescriptions, {
            groupId: prescription.group
          });
          if (!group) {
            group = {
              groupId: prescription.group,
              prescriptions: [],
              title: prescription.data.group_title
            };
            groupedPrescriptions.push(group);
          }
          group.lastSequence = _.max([group.lastSequence || 0, prescription.group_sequence]);
          return group.prescriptions.push(prescription);
        } else {
          return groupedPrescriptions.push({
            prescriptions: [prescription]
          });
        }
      });
      return groupedPrescriptions;
    };
    service = {
      getStopAvailableReason: getStopAvailableReason,
      getCategories: getCategories,
      groupPrescriptions: groupPrescriptions,
      getTimeSlots: getTimeSlots,
      setupPrescriptionFromParent: setupPrescriptionFromParent,
      setupPrescription: setupPrescription,
      getOrCreateDraftOrdonnance: getOrCreateDraftOrdonnance,
      resetCache: resetCache,
      getPAPCategory: getPAPCategory,
      routes: routes,
      availableFilters: availableFilters,
      defaultAdminCodes: defaultAdminCodes,
      taking_units: taking_units,
      getBCBVersion: getBCBVersion,
      getBCBState: getBCBState,
      getBCBPosologiesCodes: BCBPosologiesCodes,
      setupCroppedPrescription: setupCroppedPrescription,
      getPrescriptionDetails: getPrescriptionDetails,
      getPharmaValidation: getPharmaValidation,
      prescriptionGroupsOrder: prescriptionGroupsOrder,
      showHistory: showHistory,
      getHightCostDrugs: getHightCostDrugs
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=medication-services.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CurrentPrescriptionCtrl
    * @description
    * # CurrentPrescriptionCtrl
    * Controller of Patient current Prescriptions
   */
  angular.module('mhclientApp').controller('MedicationPrintCtrl', ["$scope", "$rootScope", "$window", "$state", "$uibModal", function($scope, $rootScope, $window, $state, $uibModal) {
    $rootScope.busy = true;
    $scope.previousState = $state.previous;
    $scope.goTopreviousState = function() {
      return $state.go($scope.previousState.name);
    };
    $scope.handleHash = function() {
      return "?category=" + _.join(_.map(_.filter($scope.selectable_categories, ['selected', true]), 'id'), '&category=');
    };
    $scope.printCurrentTraitements = function() {
      var modal;
      modal = $uibModal.open({
        templateUrl: 'medication/views/print-current-category-selection-template.html',
        scope: $scope,
        backdrop: 'static'
      });
      return modal.result.then(function(result) {
        return $window.open("/webfw/careplan_mgr/stay_" + $rootScope.currentStay.id + "/current_prescriptions/to_pdf/" + $scope.handleHash());
      });
    };
    $scope.selectable_categories = _.filter($scope.prescCategories, function(cat) {
      return cat.state === "ACT" && cat.properties.not_selectable_for_print !== true;
    });
    $scope.selectable_categories.map(function(category) {
      return category.selected = true;
    });
    return $rootScope.busy = false;
  }]);

}).call(this);

//# sourceMappingURL=medication-print-controller.js.map

(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
    hasProp = {}.hasOwnProperty;

  angular.module('mhclientApp').controller('PrescFormCtrl', ["$scope", "$rootScope", "$q", "$state", "$stateParams", "$filter", "PrescUtils", "Prescription", "ImageDocument", "$uibModal", "Entity", "ThesaurusUtils", "Ordonnance", "$window", "$location", "moment", "DrugUtils", "HighCostDrugsUtils", "MonographyModal", "PrescriptionDataMappers", function($scope, $rootScope, $q, $state, $stateParams, $filter, PrescUtils, Prescription, ImageDocument, $uibModal, Entity, ThesaurusUtils, Ordonnance, $window, $location, moment, DrugUtils, HighCostDrugsUtils, MonographyModal, PrescriptionDataMappers) {
    var entityIdSelection, entitySelectionDeferredResult, extract_selectable_items, fetchCares, initThesaurus, loadSelectedDrugFromPrescription, removeIndication, updatePrescParams, updatePrescription;
    $scope.selectedIndication = void 0;
    $scope.thesaurus_make_columns = false;
    $scope.max_duration = 365;
    $scope.max_date = $scope.prescription.start_date ? moment($scope.prescription.start_date).add(365, 'days') : null;
    $scope.start_level = 0;
    entitySelectionDeferredResult = $q.defer();
    $scope.setForm = function(prescription, form) {
      if (prescription.form && prescription.form.$dirty) {
        form.$setDirty();
      }
      return prescription.form = form;
    };
    loadSelectedDrugFromPrescription = function(prescription) {
      return $scope.selectedDrug = PrescriptionDataMappers.mapPrescriptionToSelectedDrug(prescription);
    };
    $scope.init = function(prescription) {
      var catExamen, i, index, j, len, len1, prescription_examen, ref, ref1, ref2, ref3, week_day;
      $scope.prescription = prescription;
      if (prescription != null ? (ref = prescription.data) != null ? ref.bdm_data : void 0 : void 0) {
        loadSelectedDrugFromPrescription(prescription);
      }
      if ($scope.prescription.indication_label) {
        $scope.selectedIndication = {
          label: $scope.prescription.indication_label,
          code: prescription != null ? (ref1 = prescription.indication) != null ? ref1.code : void 0 : void 0
        };
      }
      $scope.week_days = [];
      if (prescription.data.dates) {
        prescription.data.dates = prescription.data.dates.map(function(date) {
          return moment(date);
        });
      }
      ref2 = $scope.DATETIME_FORMATS.DAY;
      for (index = i = 0, len = ref2.length; i < len; index = ++i) {
        week_day = ref2[index];
        $scope.week_days.push({
          code: index,
          label: week_day,
          selected: ($scope.prescription.data.week_days != null) && (indexOf.call($scope.prescription.data.week_days, index) >= 0)
        });
      }
      if ($scope.prescription.category && $scope.prescription.category.name === "IMAGE") {
        if (!$scope.prescription.data.examens) {
          $scope.prescription.data.examens = [];
        } else {
          ref3 = $scope.prescription.data.examens;
          for (j = 0, len1 = ref3.length; j < len1; j++) {
            prescription_examen = ref3[j];
            catExamen = _.find($scope.prescription.category.properties.examens, {
              "label": prescription_examen.label
            });
            if (catExamen) {
              catExamen.selected = true;
              catExamen.extra_label = prescription_examen.extra_label;
            } else {
              $scope.prescription.category.properties.examens.push(prescription_examen);
            }
          }
        }
      }
      updatePrescription();
      return $scope.$watch('prescription', updatePrescription, true);
    };
    $scope.customizeTimeSlot = function(prescription, timeSlot) {
      var customizeTimeSlotScope, defaultHours;
      prescription.data.custom_timeslots = prescription.data.custom_timeslots || {};
      customizeTimeSlotScope = $scope.$new(true);
      customizeTimeSlotScope.currentHour = prescription.data.custom_timeslots[timeSlot.short_label];
      customizeTimeSlotScope.hasPreviousValue = customizeTimeSlotScope.currentHour;
      customizeTimeSlotScope.timeSlot = timeSlot;
      defaultHours = {
        Mt: "08:00",
        M: "12:00",
        AM: "16:00",
        S: "20:00",
        C: "24:00",
        Nh: "04:00"
      };
      if (customizeTimeSlotScope.currentHour) {
        customizeTimeSlotScope.currentHour = moment(customizeTimeSlotScope.currentHour, "HH:mm");
      } else {
        if (timeSlot.data.start_time) {
          customizeTimeSlotScope.currentHour = moment(timeSlot.data.start_time, "HH:mm");
        } else if (timeSlot.short_label in defaultHours) {
          customizeTimeSlotScope.currentHour = moment(defaultHours[timeSlot.short_label], "HH:mm");
        }
      }
      return $uibModal.open({
        animation: true,
        templateUrl: 'medication/views/modal-customize-time-slot.html',
        size: "lg",
        scope: customizeTimeSlotScope
      }).result.then(function(result) {
        if (result) {
          return prescription.data.custom_timeslots[timeSlot.short_label] = moment(result).format("HH:mm");
        } else {
          return delete prescription.data.custom_timeslots[timeSlot.short_label];
        }
      });
    };
    $scope.selectExamen = function(examen) {
      if (examen.selected) {
        return $scope.prescription.data.examens.push(examen);
      } else {
        return $scope.prescription.data.examens.splice($scope.prescription.data.examens.indexOf(examen), 1);
      }
    };
    fetchCares = function(careItem, data, checkKey, careItemLabel) {
      var index, k;
      if (careItem.selected) {
        if (data[checkKey] == null) {
          data[checkKey] = {};
        }
        if (data[checkKey][careItem.thesaurus_entry.label] == null) {
          data[checkKey][careItem.thesaurus_entry.label] = [];
        }
        return data[checkKey][careItem.thesaurus_entry.label].push(_.escape(careItemLabel));
      } else {
        index = data[checkKey][careItem.thesaurus_entry.label].indexOf(careItemLabel);
        data[checkKey][careItem.thesaurus_entry.label].splice(index, 1);
        if (data[checkKey][careItem.thesaurus_entry.label].length === 0) {
          delete data[checkKey][careItem.thesaurus_entry.label];
          if (((function() {
            var ref, results;
            ref = data[checkKey];
            results = [];
            for (k in ref) {
              if (!hasProp.call(ref, k)) continue;
              results.push(k);
            }
            return results;
          })()).length === 0) {
            return delete data[checkKey];
          }
        }
      }
    };
    $scope.choiceChanged = function(care_item, auto_switch) {
      if (!auto_switch) {
        care_item.selected = !care_item.selected;
      }
      if ($scope.prescription.category.name === "BIOLOGIC") {
        return fetchCares(care_item, $scope.prescription.data, "biologic_info", care_item.name);
      } else if ($scope.prescription.category.name === "LABORATORY") {
        $scope.prescription.data.laboratory_info = $scope.prescription.data.laboratory_info || [];
        if (care_item.selected) {
          return $scope.prescription.data.laboratory_info.push({
            uid: care_item.uid,
            labels: _.map(care_item.labels, function(label) {
              return _.escape(label);
            })
          });
        } else {
          return _.remove($scope.prescription.data.laboratory_info, {
            uid: care_item.uid
          });
        }
      } else if ($scope.prescription.category.name === "NEW_CARE") {
        return fetchCares(care_item, $scope.prescription.data, "cares", care_item.name);
      }
    };
    $scope.activate_childs = function(item) {
      var child_item, i, len, ref, results;
      ref = item.entries || [];
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        child_item = ref[i];
        results.push(child_item.active = true);
      }
      return results;
    };
    extract_selectable_items = function(item, level, thesaurus_entry, already_selected_entries, item_to_check, labels) {
      var child_item, i, len, ref, results;
      item.level = level;
      item.selected = already_selected_entries.indexOf(item[item_to_check]) !== -1;
      item.thesaurus_entry = thesaurus_entry;
      item.active = level <= $scope.start_level;
      item.hide = false;
      if ((item.entries != null) && item.entries.length > 0) {
        item.not_selectable = true;
        item.entries = _.reject(item.entries, "obsolete");
        ref = item.entries;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          child_item = ref[i];
          results.push(extract_selectable_items(child_item, item.level + 1, thesaurus_entry, already_selected_entries, item_to_check, _.concat(labels, [child_item.label])));
        }
        return results;
      } else {
        return item.labels = labels;
      }
    };
    initThesaurus = function(thesaurus_entries, already_selected_entries, item_to_check) {
      var child_item, i, len, ref, results, thesaurus_entry;
      ref = _.reject(thesaurus_entries, "obsolete");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        thesaurus_entry = ref[i];
        thesaurus_entry.level = 0;
        thesaurus_entry.active = true;
        thesaurus_entry.hide = false;
        thesaurus_entry.entries = _.reject(thesaurus_entry.entries, "obsolete");
        results.push((function() {
          var j, len1, ref1, results1;
          ref1 = thesaurus_entry.entries;
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            child_item = ref1[j];
            results1.push(extract_selectable_items(child_item, thesaurus_entry.level + 1, thesaurus_entry, already_selected_entries, item_to_check, [thesaurus_entry.label, child_item.label]));
          }
          return results1;
        })());
      }
      return results;
    };
    updatePrescription = function(newVal, oldVal) {
      var prescription, thesaurus_category_done, thesaurus_done;
      prescription = $scope.prescription;
      thesaurus_done = $q.defer();
      if (prescription.category && prescription.category.name !== "LABORATORY") {
        delete prescription.entity;
      }
      if (prescription.category && prescription.category.name === "BIOLOGIC") {
        if ($scope.thesaurus_biologic_tree == null) {
          $rootScope.busy = true;
          ThesaurusUtils.getThesaurusCategories({
            code: "biologic"
          }).then(function(thesaurusCategory) {
            $scope.thesaurus_category = thesaurusCategory;
            return ThesaurusUtils.getThesaurusEntries({
              "category": $scope.thesaurus_category.id
            }, true).then(function(thesaurus_entries) {
              var already_selected_entries, label;
              already_selected_entries = [];
              if (prescription.data.biologic_info != null) {
                for (label in prescription.data.biologic_info) {
                  already_selected_entries = already_selected_entries.concat(prescription.data.biologic_info[label]);
                }
              }
              initThesaurus(thesaurus_entries, already_selected_entries, "label");
              $scope.thesaurus_biologic_tree = thesaurus_entries;
              $scope.thesaurus_tree = $scope.thesaurus_biologic_tree;
              thesaurus_done.resolve();
              return $rootScope.busy = false;
            });
          });
        } else {
          thesaurus_done.resolve();
          $scope.thesaurus_tree = $scope.thesaurus_biologic_tree;
        }
      } else if (prescription.category && prescription.category.name === "LABORATORY") {
        if ($scope.thesaurusLaboTree == null) {
          $rootScope.busy = true;
          thesaurus_category_done = $q.defer();
          ThesaurusUtils.getThesaurusCategories({
            code: "laboratory"
          }).then(function(thesaurusCategory) {
            var params;
            params = {};
            $scope.thesaurus_category = thesaurusCategory;
            params.category = $scope.thesaurus_category.id;
            return $q.when($rootScope.mh_config.platform === "mhsi" ? entityIdSelection(prescription) : null).then(function(entityId) {
              if (entityId) {
                params.entity = entityId;
                if (!$rootScope.currentStay) {
                  prescription.entity = entityId;
                }
              }
              return ThesaurusUtils.getThesaurusEntries(params, true).then(function(thesaurus_entries) {
                var already_selected_entries;
                already_selected_entries = _.map(prescription.data.laboratory_info, "uid");
                initThesaurus(thesaurus_entries, already_selected_entries, "uid");
                $scope.thesaurusLaboTree = thesaurus_entries;
                $scope.thesaurus_tree = $scope.thesaurusLaboTree;
                thesaurus_done.resolve();
                return $rootScope.busy = false;
              });
            });
          });
        } else {
          thesaurus_done.resolve();
          $scope.thesaurus_tree = $scope.thesaurusLaboTree;
        }
      } else if (prescription.category && prescription.category.name === "NEW_CARE") {
        if ($scope.thesaurus_care_tree == null) {
          $rootScope.busy = true;
          ThesaurusUtils.getThesaurusCategories({
            code: "care"
          }).then(function(thesaurusCategory) {
            $scope.thesaurus_category = thesaurusCategory;
            return ThesaurusUtils.getThesaurusEntries({
              "category": $scope.thesaurus_category.id
            }, true).then(function(thesaurus_entries) {
              var already_selected_entries, label;
              already_selected_entries = [];
              if (prescription.data.cares != null) {
                for (label in prescription.data.cares) {
                  already_selected_entries = already_selected_entries.concat(prescription.data.cares[label]);
                }
              }
              initThesaurus(thesaurus_entries, already_selected_entries, "name");
              $scope.thesaurus_care_tree = thesaurus_entries;
              $scope.thesaurus_tree = $scope.thesaurus_care_tree;
              thesaurus_done.resolve();
              return $rootScope.busy = false;
            });
          });
        } else {
          thesaurus_done.resolve();
          $scope.thesaurus_tree = $scope.thesaurus_care_tree;
        }
      } else {
        thesaurus_done.resolve();
      }
      updatePrescParams();
      return thesaurus_done.promise.then(function() {
        return $scope.updatePrescription(prescription, $scope.timeSlots);
      });
    };
    updatePrescParams = function() {
      var presc;
      presc = $scope.prescription;
      if (presc.data && (presc.data.bdm_data != null) && (presc.data.bdm_data.is_stupefiant != null)) {
        if (presc.data.bdm_data.is_stupefiant === '1') {
          $scope.max_duration = 28;
          if (presc.start_date) {
            $scope.max_date = moment(presc.start_date).add(27, 'days');
          }
          if (presc.data.numbers_to_texts === void 0) {
            return presc.data.numbers_to_texts = true;
          }
        } else {
          $scope.max_duration = 365;
          $scope.max_date = moment(presc.start_date).add(365, 'days');
          if (presc.start_date && presc.end_date && moment(presc.end_date) > $scope.max_date) {
            delete presc.end_date;
          }
          return presc.data.numbers_to_texts = false;
        }
      } else {
        return presc.data.numbers_to_texts = false;
      }
    };
    entityIdSelection = function(prescription) {
      if ($rootScope.currentStay) {
        return $rootScope.currentStay.entity;
      }
      if (prescription.entity) {
        return prescription.entity;
      }
      if (!entitySelectionDeferredResult.promise.$$state.status) {
        entitySelectionDeferredResult.resolve(Entity.selectEntityId($filter('translate')('SELECT_ENTITY_FOR_THESAURUS')).then(function(entityId) {
          return entityId;
        }));
      }
      return entitySelectionDeferredResult.promise;
    };
    $scope.showMonography = MonographyModal.showMonography;
    removeIndication = function() {
      $scope.selectedIndication = void 0;
      $scope.prescription.indication = void 0;
      return $scope.prescription.indication_label = void 0;
    };
    $scope.handleOnSelectDrug = function(result) {
      $scope.selectedDrug = DrugUtils.mapDrugSelectModalResultToDrug(result);
      PrescriptionDataMappers.addDrugSelectModalResultToPrescription($scope.prescription, result);
      removeIndication();
      if ($scope.prescription.form) {
        return $scope.prescription.form.$setDirty();
      }
    };
    $scope.requiresIndication = function(selectedDrug) {
      var ref;
      return HighCostDrugsUtils.requiresIndication(selectedDrug != null ? (ref = selectedDrug.high_cost) != null ? ref.type : void 0 : void 0);
    };
    $scope.handleOnSelectIndication = function(indication) {
      $scope.selectedIndication = indication;
      $scope.prescription.indication = indication;
      return $scope.prescription.indication_label = indication.label;
    };
    return $scope.handleOnClearIndication = function() {
      return removeIndication();
    };
  }]);

}).call(this);

//# sourceMappingURL=presc-form-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:PrescriptionHistoryCtrl
    * @description
    * # PrescriptionHistoryCtrl
    * Provider of PrescriptionHistoryCtrl
   */
  angular.module("mhclientApp").controller('PrescriptionHistoryCtrl', ["$scope", "$rootScope", "$q", "$uibModal", "prescription", "Medicaldb", "MonographyModal", "Prescription", "PrescUtils", "SiteVarsUtils", "PharmaDelivery", "PharmaValidation", function($scope, $rootScope, $q, $uibModal, prescription, Medicaldb, MonographyModal, Prescription, PrescUtils, SiteVarsUtils, PharmaDelivery, PharmaValidation) {
    var getPrescriptionById;
    $rootScope.busy = true;
    prescription = angular.copy(prescription);
    PrescUtils.getCategories().promise.then(function(prescCategories) {
      $scope.prescCategories = prescCategories;
      if (typeof prescription.category !== 'object') {
        prescription.category = _.find($scope.prescCategories, {
          id: prescription.category
        });
      }
      $scope.currentPrescription = prescription;
      return PrescUtils.getPrescriptionDetails($scope.currentPrescription).then(function() {
        return SiteVarsUtils.get('CLASICAL_DISPENSATION', true).then(function(sitevar) {
          $scope.clasicalDispensation = sitevar.value;
          return $rootScope.busy = false;
        });
      });
    });
    SiteVarsUtils.get("WITH_PHARMA_CONTROL", false).then(function(pharmaControlEnabled) {
      return $scope.pharmaControlEnabled = pharmaControlEnabled.value;
    });
    getPrescriptionById = function(prescId) {
      var done;
      done = $q.defer();
      Prescription.get({
        id: prescId
      }).$promise.then(function(prescription) {
        prescription.category = _.find($scope.prescCategories, {
          id: prescription.category
        });
        return PrescUtils.getPrescriptionDetails(prescription).then(function() {
          return done.resolve(prescription);
        });
      });
      return done.promise;
    };
    $scope.showMonography = MonographyModal.showMonography;
    $scope.showOrdonnance = function(ordonnanceId) {
      $scope.modalParams = {
        ordonnanceId: ordonnanceId
      };
      return $uibModal.open({
        templateUrl: 'medication/views/pop-up-ordonnance.html',
        controller: 'OrdonnanceCtrl',
        scope: $scope,
        backdrop: 'true',
        animation: false
      });
    };
    $scope.prev = function(prescription) {
      if (typeof prescription.parent_prescription === 'number') {
        $rootScope.busy = true;
        return getPrescriptionById(prescription.parent_prescription).then(function(parentPrescription) {
          prescription.parent_prescription = parentPrescription;
          parentPrescription.child_prescription = prescription;
          $scope.currentPrescription = parentPrescription;
          return $rootScope.busy = false;
        });
      } else {
        return $scope.currentPrescription = prescription.parent_prescription;
      }
    };
    return $scope.next = function(prescription) {
      if (typeof prescription.child_prescription === 'number') {
        $rootScope.busy = true;
        return getPrescriptionById(prescription.child_prescription).then(function(childPrescription) {
          prescription.child_prescription = childPrescription;
          childPrescription.parent_prescription = prescription;
          $scope.currentPrescription = childPrescription;
          return $rootScope.busy = false;
        });
      } else {
        return $scope.currentPrescription = prescription.child_prescription;
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=prescription-history-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PrescNewCtrl
    * @description
    * # PrescNewCtrl
    * Controller of Patient new Prescription
   */
  angular.module('mhclientApp').controller('PAPCtrl', ["$scope", "$rootScope", "$q", "$state", "$stateParams", "SiteVarsUtils", "$filter", "PrescUtils", "MhConfig", "Prescription", "Ordonnance", "moment", function($scope, $rootScope, $q, $state, $stateParams, SiteVarsUtils, $filter, PrescUtils, MhConfig, Prescription, Ordonnance, moment) {
    var checkDates, prescription_promise;
    SiteVarsUtils.get("PAP_TEMPLATES", SiteVarsUtils.getDefaultPapTemplates()).then(function(prescription_template_categories) {
      return $scope.prescription_template_categories = angular.copy(prescription_template_categories.value);
    });
    $scope.validate = function() {
      $rootScope.busy = true;
      return PrescUtils.getPAPCategory().promise.then(function(category) {
        var ordonnance_promise;
        ordonnance_promise = $q.defer();
        if ($scope.ordonnance != null) {
          ordonnance_promise.resolve($scope.ordonnance);
        } else {
          if ($stateParams.ordonnanceId) {
            ordonnance_promise.resolve(parseInt($stateParams.ordonnanceId, 10));
          } else {
            PrescUtils.getOrCreateDraftOrdonnance($rootScope.currentStay.id, $scope.user.id).then(function(ordonnance) {
              return ordonnance_promise.resolve(ordonnance);
            });
          }
        }
        return ordonnance_promise.promise.then(function(ordonnance) {
          var i, len, prescription, promises, ref, template;
          promises = [];
          if ($scope.end_mode === 'duration') {
            $scope.planning.end_date = (moment($scope.planning.start_date).add($scope.planning.duration - 1, 'days')).format("YYYY-MM-DD");
            $scope.planning.start_date = moment($scope.planning.start_date).format("YYYY-MM-DD");
          }
          $scope.planning.start_date = moment($scope.planning.start_date).format("YYYY-MM-DD");
          $scope.planning.end_date = $scope.planning.end_date ? moment($scope.planning.end_date).format("YYYY-MM-DD") : null;
          ref = $scope.selected_templates;
          for (i = 0, len = ref.length; i < len; i++) {
            template = ref[i];
            if (template.selected_option != null) {
              if (template.selected_option.route != null) {
                template.route = template.selected_option.route;
              }
              if (template.selected_option.taking_unit != null) {
                template.taking_unit = template.selected_option.taking_unit;
              }
              if (template.selected_option.bdm_data != null) {
                template.bdm_data = template.selected_option.bdm_data;
              }
              if (template.selected_option.quantity != null) {
                template.quantity = template.selected_option.quantity;
              }
            }
            $scope.gen_display_text(template);
            if ($scope.prescription) {
              prescription = $scope.prescription;
            } else {
              prescription = {
                data: {}
              };
            }
            if (!$scope.modify_mode) {
              prescription.data.resumption = "INITIAL";
            } else {
              prescription.data.resumption = "RENEW_MODIFY";
            }
            prescription.data.display_text = template.display_text;
            prescription.data.posology = template.posology;
            prescription.data.search_by = template.search_by || "product";
            prescription.data.bdm_data = template.bdm_data;
            prescription.data.name = template.bdm_data.name;
            prescription.data.route = template.route;
            prescription.data.end_mode = $scope.end_mode;
            prescription.data.structured = template.structured || true;
            prescription.data.source = MhConfig.platform;
            prescription.data.taking_unit = template.taking_unit;
            prescription.data.dci_mode = template.dci_mode || false;
            prescription.data.daily_quantity = template.quantity;
            prescription.data.quantity = template.quantity;
            prescription.data.hours = template.hours;
            prescription.data.minutes = template.minutes;
            prescription.data.template = template;
            prescription.ordonnance = ordonnance;
            prescription.data.creation_author = $scope.user.full_name;
            prescription.data.creation_date = moment().format("YYYY-MM-DD");
            prescription.start_date = $scope.planning.start_date;
            prescription.end_date = $scope.planning.end_date;
            prescription.duration = Math.round(moment.duration(moment(prescription.end_date) - moment(prescription.start_date)).asDays() + 1);
            prescription.category = category;
            if (prescription.id != null) {
              promises.push(Prescription.update({
                id: prescription.id
              }, prescription).$promise);
            } else {
              promises.push(Prescription.save(prescription).$promise);
            }
          }
          return $q.all(promises).then(function() {
            $rootScope.busy = false;
            return $state.go("user.patient.stay.medication.cart");
          });
        });
      });
    };
    $scope.goTopreviousState = function() {
      return $state.go("user.patient.stay.medication.current");
    };
    $scope.genPapValue = function(template, header) {
      var error, error1, result;
      try {
        result = eval(header.value);
        if (header.params && header.params.decimals) {
          result = result.toFixed(header.params.decimals);
        }
        return result;
      } catch (error1) {
        error = error1;
      }
    };
    $scope.selectTemplate = function(template, category) {
      if (template.selected) {
        template.pap = category.pap;
        template.name = category.name;
        template.order = category.order;
        $scope.selected_templates.push(template);
        if (!template.selected_option && template.options) {
          return template.selected_option = template.options[0];
        }
      } else {
        return $scope.selected_templates.splice($scope.selected_templates.indexOf(template), 1);
      }
    };
    $scope.gen_display_text = function(template) {
      var header, i, len, posology, ref;
      template.display_text = "<div class='pap-display-prescription'><div class='pap-number'>" + template.pap + "</div><div class='pap-name'>" + template.name + "</div><div class='pap-text'>";
      posology = "";
      ref = template.headers;
      for (i = 0, len = ref.length; i < len; i++) {
        header = ref[i];
        if (header.type === "label") {
          if (header.prefix) {
            posology += header.prefix;
          }
          posology += header.label;
          if (header.suffix) {
            posology += header.suffix;
          }
        } else if (header.type === "quantity") {
          posology += template.quantity + " " + header.label;
        } else if (header.type === "float") {
          posology += template[header.key] + " " + header.label;
        } else if (header.type === "minutes") {
          posology += (header.prefix || "") + " " + template.minutes + " " + (header.suffix || "");
        } else if (header.type === "hours") {
          posology += (header.prefix || "") + " " + template.hours + " " + (header.suffix || "");
        } else if (header.type === "auto") {
          posology += (header.prefix || "") + " " + $scope.genPapValue(template, header) + " " + (header.suffix || "");
        }
      }
      if (template.selected_option != null) {
        posology += " " + template.selected_option.label;
        if (template.selected_option.extra_quantity) {
          posology += template.selected_option.quantity + " " + template.selected_option.extra_quantity;
        }
      }
      template.posology = posology;
      return template.display_text += posology + "</div></div>";
    };
    if ($stateParams.parentPrescriptionId || $stateParams.prescriptionId) {
      $scope.modify_mode = true;
      prescription_promise = $q.defer();
      if ($stateParams.parentPrescriptionId) {
        Prescription.get({
          id: $stateParams.parentPrescriptionId
        }).$promise.then(function(prescription) {
          return PrescUtils.getPAPCategory().promise.then(function(category) {
            prescription.category = category;
            return prescription_promise.resolve(PrescUtils.setupPrescriptionFromParent(prescription, "RENEW_MODIFY"));
          });
        });
      } else {
        Prescription.get({
          id: $stateParams.prescriptionId
        }).$promise.then(function(prescription) {
          $scope.ordonnance = prescription_promise.ordonnance;
          return prescription_promise.resolve(prescription);
        });
      }
      prescription_promise.promise.then(function(prescription) {
        var current_presc, i, len, option, ref;
        $scope.prescription = prescription;
        $scope.end_mode = prescription.data.end_mode || "date";
        $scope.planning = {
          start_date: moment(prescription.start_date).format("YYYY-MM-DD"),
          end_date: moment(prescription.end_date).format("YYYY-MM-DD"),
          duration: prescription.duration
        };
        current_presc = {
          "pap": prescription.data.template.pap,
          "name": prescription.data.template.name,
          "entries": [prescription.data.template]
        };
        $scope.prescription_template_categories.splice(0, 0, current_presc);
        if (prescription.data.template.selected_option) {
          ref = prescription.data.template.options;
          for (i = 0, len = ref.length; i < len; i++) {
            option = ref[i];
            if (option.label === prescription.data.template.selected_option.label) {
              prescription.data.template.selected_option = option;
              break;
            }
          }
        }
        $scope.selected_templates = [prescription.data.template];
        return $scope.selectTemplate = function(new_template, category) {
          var j, len1, ref1, template;
          ref1 = $scope.selected_templates;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            template = ref1[j];
            template.selected = false;
          }
          new_template.pap = category.pap;
          new_template.name = category.name;
          new_template.order = category.order;
          if (!new_template.selected_option && new_template.options) {
            new_template.selected_option = new_template.options[0];
          }
          return $scope.selected_templates = [new_template];
        };
      });
    } else {
      $scope.end_mode = "duration";
      $scope.planning = {
        start_date: moment().format("YYYY-MM-DD"),
        end_date: null,
        duration: 28
      };
      $scope.selected_templates = [];
    }
    checkDates = function(newVal, oldVal) {
      if (newVal && $scope.planning.end_date) {
        if (moment(newVal) > moment($scope.planning.end_date) || moment($scope.planning.end_date) > (moment(newVal).add(28 - 1, 'days'))) {
          return $scope.planning.end_date = null;
        }
      }
    };
    return $scope.$watch('planning.start_date', checkDates);
  }]);

}).call(this);

//# sourceMappingURL=pap-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:shortcut
    * @description
    * # previewDisplay
    * Display shortcuts of registered words
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').filter('prescriptionGroupFilter', function() {
    return function(prescriptionGroups, query, userInputs) {
      var filtered, i, j, len, len1, prescription, prescriptionGroup, ref, regex, searchVal, selectedCategories;
      userInputs = userInputs || {};
      selectedCategories = userInputs.selectedCategories && userInputs.selectedCategories.length > 0;
      if (!selectedCategories && (!query || query.length === 0)) {
        return prescriptionGroups;
      }
      filtered = [];
      if (query && query.length > 0) {
        searchVal = query.replace(/([()[{*+.$^\\|?])/g, '\\$1');
        regex = new RegExp('' + searchVal, 'i');
      } else {
        regex = false;
      }
      for (i = 0, len = prescriptionGroups.length; i < len; i++) {
        prescriptionGroup = prescriptionGroups[i];
        if (selectedCategories && !_.some(prescriptionGroup.prescriptions, function(prescription) {
          var ref;
          return ref = prescription.category, indexOf.call(userInputs.selectedCategories, ref) >= 0;
        })) {
          continue;
        }
        if (!regex) {
          filtered.push(prescriptionGroup);
          continue;
        }
        ref = prescriptionGroup.prescriptions;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          prescription = ref[j];
          if (userInputs.hidePosology) {
            if (regex.test(prescription.data.name)) {
              filtered.push(prescriptionGroup);
              break;
            }
          } else {
            if (regex.test(prescription.data.display_text)) {
              filtered.push(prescriptionGroup);
              break;
            }
          }
        }
      }
      return filtered;
    };
  });

  angular.module('mhclientApp').filter('prescriptionFilter', function() {
    return function(prescriptions, query, userInputs) {
      var filtered, i, len, prescription, ref, regex, searchVal, selectedCategories;
      userInputs = userInputs || {};
      selectedCategories = userInputs.selectedCategories && userInputs.selectedCategories.length > 0;
      if (!selectedCategories && (!query || query.length === 0)) {
        return prescriptions;
      }
      filtered = [];
      if (query && query.length > 0) {
        searchVal = query.replace(/([()[{*+.$^\\|?])/g, '\\$1');
        regex = new RegExp('' + searchVal, 'i');
      } else {
        regex = false;
      }
      for (i = 0, len = prescriptions.length; i < len; i++) {
        prescription = prescriptions[i];
        if (selectedCategories && (ref = !prescription.category, indexOf.call(userInputs.selectedCategories, ref) >= 0)) {
          continue;
        }
        if (!regex) {
          filtered.push(prescription);
        } else {
          if (userInputs.hidePosology) {
            if (regex.test(prescription.data.name)) {
              filtered.push(prescription);
            }
          } else {
            if (regex.test(prescription.data.display_text)) {
              filtered.push(prescription);
            }
          }
        }
      }
      return filtered;
    };
  });

}).call(this);

//# sourceMappingURL=medication-filters.js.map

"use strict";

/* **********************************************
 * @ngdoc function
 * @name mhclientApp.component:DrugSelectModal
 * @description
 * Modal component which allows user to search a drug the BCB
 * **********************************************/

angular.module("mhclientApp").component("drugSelectModal", {
  templateUrl: "medication/components/drug-select-modal/drug-select-modal.html",
  controller: drugSelectModalCtrl,
  bindings: {
    structured: "<",
    prescText: "<",
    prescImage: "<",
    query: "<",
    entity: "<",
    sector: "<",
    onShowMonography: "&",
    close: "&",
  },
});

function drugSelectModalCtrl(
  $filter,
  $window,
  notify,
  Medicaldb,
  MedicalDbUtils,
  SiteVarsUtils
) {
  var ctrl = this;

  ctrl.allowFreePrescriptions = undefined;
  ctrl.inHousePharmacyCatalog = undefined;

  ctrl.selectProduct = selectProduct;

  ctrl.$onInit = init;

  function init() {
    ctrl.free_name = "";
    ctrl.minLengthQuery = 4;
    ctrl.busy = true;
    SiteVarsUtils.get("ALLOW_FREE_PRESCRIPTIONS", false).then(function (
      sitevar
    ) {
      ctrl.allowFreePrescriptions = sitevar.value;
      SiteVarsUtils.get("IN_HOUSE_PHARMACY_CATALOG", false).then(function (
        sitevar
      ) {
        ctrl.inHousePharmacyCatalog = sitevar.value;
        ctrl.busy = false;
        if (ctrl.query) {
          ctrl.searchDrug();
        }
      });
    });
  }

  function selectProduct(product, inMdbDrugs, inHousePharmacyCatalog) {
    if (product.cip == null) {
      if ($window.mgapp != null) {
        $window.mgapp.close_keyboard();
      }

      ctrl.close({
        result: mapProductToModalResult(
          product,
          inMdbDrugs,
          inHousePharmacyCatalog
        ),
      });
    } else {
      addDataFromMedicalDb(product, inMdbDrugs, inHousePharmacyCatalog).then(
        function (result) {
          if ($window.mgapp != null) {
            $window.mgapp.close_keyboard();
          }
          ctrl.close({ result: result });
        }
      );
    }
  }

  function addDataFromMedicalDb(product, inMdbDrugs, inHousePharmacyCatalog) {
    if (product.cip == null) {
      throw new Error("Cannot search in medical db without a CIP.");
    }

    ctrl.waiter = true;

    return MedicalDbUtils.getPopulatedDrugFromMedicalDb(product.cip)
      .then(function (drug) {
        // if the drug name is undefined or null, it means the drug is not
        // in the medical db (can happen if the cip is 'NULL' or other undetermined cip)
        // Thus we return the product without any additional data from the medical db
        if (drug.name == null) {
          return mapProductToModalResult(
            product,
            inMdbDrugs,
            inHousePharmacyCatalog
          );
        }

        var result = {
          drug: drug,
          route: drug.routes.length == 1 ? drug.routes[0] : null,
          takingUnit: drug.takingUnits.length == 1 ? drug.takingUnits[0] : null,
          name: product.name,
          name_in_text: drug.name_in_text,
          structured: ctrl.structured,
          isDci: product.is_dci,
          inn: product.inn,
          comment: product.comment,
          inMdbDrugs: inMdbDrugs,
          inHousePharmacyCatalog: inHousePharmacyCatalog,
        };

        return result;
      })
      .catch(function () {
        notify({
          classes: ["alert-danger"],
          duration: 5000,
          message: $filter("translate")("PRODUCT_NOT_FOUND_IN_MEDICAL_DB"),
        });
      })
      .finally(function () {
        ctrl.waiter = false;
      });
  }

  function mapProductToModalResult(
    product,
    inMdbDrugs,
    inHousePharmacyCatalog
  ) {
    var result = {
      drug: product,
      name: product.name,
      structured: ctrl.structured,
      isDci: product.is_dci,
      inn: product.inn,
      comment: product.comment,
      inMdbDrugs: inMdbDrugs,
      inHousePharmacyCatalog: inHousePharmacyCatalog,
    };

    return result;
  }

  ctrl.selectFree = function () {
    var result = {
      drug: { name: ctrl.free_name },
      inn: {},
      name: ctrl.free_name,
      structured: ctrl.structured,
      isDci: false,
    };

    if ($window.mgapp != null) {
      $window.mgapp.close_keyboard();
    }
    ctrl.close({ result: result });
  };

  ctrl.searchDrug = function () {
    ctrl.query = ctrl.query.trim();
    if (ctrl.query.length >= ctrl.minLengthQuery) {
      ctrl.busy = true;
      Medicaldb.searchAllDrugs({
        query: ctrl.query,
        entity: ctrl.entity,
        sector: ctrl.sector,
      }).$promise.then(function (allDrugs) {
        _.map(allDrugs.dci, function (element) {
          return _.extend(element, { is_dci: true });
        });
        ctrl.mdbDrugs = allDrugs.in_mdb;
        ctrl.stockDrugs = allDrugs.in_stock || [];
        ctrl.otherDrugs = allDrugs.products.concat(allDrugs.dci);
        ctrl.busy = false;
      });
    }
  };

  ctrl.cancel = function () {
    if ($window.mgapp != null) {
      $window.mgapp.close_keyboard();
    }
    ctrl.close({ result: false });
  };

  ctrl.showProductsForDCI = function (product) {
    if (!product.hasDetails) {
      product.hasDetails = true;
      Medicaldb.getProductsForDci({
        cip: product.cip,
        entity: ctrl.entity,
      }).$promise.then(function (products) {
        product.mdbDrugs = products.in_mdb;
        product.stockDrugs = products.in_stock || [];
        product.otherDrugs = products.products;
      });
    }
  };
}

angular.module("mhclientApp").component("highCostDrugIcon", {
  templateUrl: "medication/components/views/high-cost-drug-icon.html",
  controller: highCostDrugIconCtrl,
  bindings: {
    drug: "<",
  },
});

function highCostDrugIconCtrl($filter) {
  var ctrl = this;

  ctrl.getTooltip = getTooltip;

  function getTooltip() {
    if (
      ctrl.drug == null ||
      ctrl.drug.high_cost == null ||
      ctrl.drug.high_cost.type == null
    ) {
      return undefined;
    }

    return $filter("translate")(
      "HIGH_COST_DRUG_ICON_TOOLTIP_" + ctrl.drug.high_cost.type
    );
  }
}

angular.module("mhclientApp").component("ordonnanceDetail", {
  templateUrl: "medication/components/views/ordonnance-detail.html",
  controller: ["$q", "Ordonnance", "SiteVarsUtils", function ordonnanceCtrl($q, Ordonnance, SiteVarsUtils) {
    var ctrl = this;
    $q.when(ctrl.ordonnance || Ordonnance.get({id:ctrl.ordonnanceId}).$promise).then (function(ordonnance){
      $q.when(ctrl.clasicalDispensation || SiteVarsUtils.get('CLASICAL_DISPENSATION', true)).then(function (clasicalDispensation){
        $q.when(ordonnance.prescriptions || Ordonnance.getPrescriptions({id:ordonnance.id}).$promise).then(function(prescriptions){
            ctrl.ordonnance = ordonnance
            ctrl.ordonnance.prescriptions = prescriptions
            ctrl.clasicalDispensation = clasicalDispensation
            if (ordonnance.discharge_prescription){
                ordonnance.ald_prescriptions = _.filter(prescriptions, "data.ald")
                ordonnance.non_ald_prescriptions = _.reject(prescriptions, "data.ald")
            }
        })
      })
    })

  }],
  bindings: {ordonnanceId: "@?", clasicalDispensation: "<?", ordonnance: "<?", patient: "<?", disableActions: "<?"},
});
angular.module("mhclientApp").component("drugSelector", {
  templateUrl: "medication/components/drug-selector/drug-selector.html",
  controller: drugSelectorCtrl,
  bindings: {
    drug: "<",
    canTypeFreeText: "<",
    onSelectDrug: "&",
  },
});

function drugSelectorCtrl($rootScope, $uibModal, MonographyModal) {
  var ctrl = this;

  ctrl.handleOnFocus = handleOnFocus;
  ctrl.handleOnInfoIconClick = handleOnInfoIconClick;

  function handleOnFocus() {
    var modal = undefined;
    if (ctrl.drug != null) {
      modal = openDrugSelectorModal(ctrl.drug.name);
    } else {
      modal = openDrugSelectorModal();
    }

    modal.result.then(function (result) {
      if (!result) return;

      ctrl.medicalDbInfo = angular.copy(result.bdm_data);

      ctrl.onSelectDrug({ result: result });
    });
  }
  function openDrugSelectorModal(drugName) {
    return $uibModal.open({
      backdrop: "static",
      windowClass: "modal-fullscreen",
      template:
        '<drug-select-modal  close="$close(result)"' +
        ' structured="$ctrl.structured" sector="$ctrl.sector" query="$ctrl.query" entity="$ctrl.entity" on-show-monography="$ctrl.showMonography(cip)">' +
        "</drug-select-modal>",
      controllerAs: "$ctrl",
      controller: function () {
        this.structured = ctrl.canTypeFreeText || false;
        this.query = drugName || "";
        this.showMonography = MonographyModal.showMonography;

        if ($rootScope.currentStay) {
          this.sector = $rootScope.currentStay.sector;
          this.entity = $rootScope.currentStay.entity || $rootScope.user.entity;
        }
      },
    });
  }

  function handleOnInfoIconClick(event) {
    event.stopPropagation();

    MonographyModal.showMonography(ctrl.drug.cip7);
  }
}

angular.module("mhclientApp").component("prescriptionIndicationSelector", {
  templateUrl:
    "medication/components/indication-selector/indication-selector.html",
  controller: prescriptionIndicationSelectorCtrl,
  bindings: {
    selectedValue: "<",
    drug: "<",
    onSelect: "&",
    onClear: "&",
  },
});

function prescriptionIndicationSelectorCtrl($q, $scope, MedicalDbUtils) {
  var ctrl = this;

  var hasRefreshedIndications = false;

  $scope.mappedIndications = [];

  ctrl.refreshIndications = refreshIndications;
  ctrl.handleOnSelectIndication = handleOnSelectIndication;

  ctrl.$onChanges = onChanges;

  function onChanges(changes) {
    if (changes.drug) {
      hasRefreshedIndications = false;
    }
  }

  function handleOnSelectIndication(indication) {
    ctrl.onSelect({ indication: indication });
  }

  function refreshIndications() {
    // Keep same indication if same drug
    if (hasRefreshedIndications) {
      return $q.resolve($scope.mappedIndications);
    }

    hasRefreshedIndications = true;

    // If already in drug, no need to refetch it from the medical db
    if (ctrl.drug.high_cost && ctrl.drug.high_cost.indications) {
      var mappedIndications = mapIndicationsWithOneLabelEach(
        ctrl.drug.high_cost.indications
      );
      $scope.mappedIndications = mappedIndications;

      return $q.resolve(mappedIndications);
    }

    var cip7 = ctrl.drug.cip7;
    if (cip7 == null) {
      throw new Error(
        "Drug should have a cip7 to load the indications - " +
          JSON.stringify(ctrl.drug)
      );
    }

    return MedicalDbUtils.getPopulatedDrugFromMedicalDb(ctrl.drug.cip7).then(
      function (drug) {
        var mappedIndications = mapIndicationsWithOneLabelEach(
          drug.high_cost.indications
        );
        $scope.mappedIndications = mappedIndications;

        return mappedIndications;
      }
    );
  }
  function mapIndicationsWithOneLabelEach(indications) {
    var mappedIndications = [];
    _.forEach(indications, function (indication) {
      _.forEach(indication.labels, function (label) {
        mappedIndications.push({
          id: indication.id,
          code: indication.code,
          label: label,
        });
      });
    });

    return mappedIndications;
  }
}

angular.module("mhclientApp").factory("DrugUtils", DrugUtilsFactory);

function DrugUtilsFactory() {
  function mapDrugSelectModalResultToDrug(result) {
    var drug = angular.copy(result.drug);

    drug.inMdbDrugs = result.inMdbDrugs;
    drug.inHousePharmacyCatalog = result.inHousePharmacyCatalog;

    return drug;
  }

  return {
    mapDrugSelectModalResultToDrug: mapDrugSelectModalResultToDrug,
  };
}

angular
  .module("mhclientApp")
  .factory("HighCostDrugsUtils", HighCostDrugsUtilsFactory);

function HighCostDrugsUtilsFactory($rootScope, $uibModal, Medicaldb) {
  var HIGH_RISK_DRUG_TYPES = {
    LES: "les",
    AAP_AAC: "aap_aac",
    EXCLUDING_LES_AND_AAP_AAC: "excluding_les_and_aap_aac",
  };

  function requiresIndication(highCostType) {
    if (highCostType == null) return false;

    //  The 'excluding_les_and_aap_aac' high cost drugs do not have indication yet
    return ![HIGH_RISK_DRUG_TYPES.EXCLUDING_LES_AND_AAP_AAC].includes(
      highCostType
    );
  }

  return {
    HIGH_RISK_DRUG_TYPES: HIGH_RISK_DRUG_TYPES,
    requiresIndication: requiresIndication,
  };
}

angular
  .module("mhclientApp")
  .factory("MonographyModal", MonographyModalFactory);

function MonographyModalFactory($rootScope, $uibModal, Medicaldb) {
  function showMonography(cip) {
    if (cip == null) return;

    var url = null;
    if ($rootScope.mh_config.platform === "mhsi") {
      url = "/api_rest/medicaldb/" + cip + "/get_monography";

      openModal(url);
    } else {
      Medicaldb.getMonography({ id: cip }).$promise.then(function (data) {
        openModal(data.monography_html);
      });
    }
  }

  function openModal(url) {
    $uibModal.open({
      template:
        '<monography-modal on-close="$close()" monography-url="$ctrl.monographyUrl" platform="$ctrl.platform">' +
        "</monography-modal>",
      controllerAs: "$ctrl",
      controller: function () {
        this.monographyUrl = url;
        this.platform = $rootScope.mh_config.platform;
      },
    });
  }

  return {
    showMonography: showMonography,
  };
}

angular
  .module("mhclientApp")
  .factory("PrescriptionDataMappers", PrescriptionDataMappersFactory);

function PrescriptionDataMappersFactory(MedicalDbUtils) {
  function addDrugSelectModalResultToPrescription(prescription, modalResult) {
    prescription.data.bdm_data = MedicalDbUtils.mapDrugToPrescriptionBdmData(
      modalResult.drug
    );

    prescription.data.name = modalResult.name;
    prescription.data.name_in_text = modalResult.name_in_text;
    prescription.data.taking_unit = modalResult.takingUnit;
    prescription.data.route = modalResult.route;

    prescription.data.dci_mode = modalResult.isDci;
    prescription.data.inn = modalResult.inn;
    prescription.data.default_comment = modalResult.comment;
    prescription.data.structured = modalResult.structured;
    prescription.data.search_by = modalResult.search_by;

    //  Not sure if that s actually used in the back
    prescription.data.in_mdb_drugs = modalResult.inMdbDrugs;
    prescription.data.in_house_pharmacy_catalog =
      modalResult.inHousePharmacyCatalog;
  }

  function mapPrescriptionToSelectedDrug(prescription) {
    var drug = {};

    var prescriptionData = prescription.data;

    drug.inHousePharmacyCatalog = prescriptionData.in_house_pharmacy_catalog;
    drug.inMdbDrugs = prescriptionData.in_mdb_drugs;

    var prescriptionBdmData = prescription.data.bdm_data;

    drug.isHighRisk = prescriptionBdmData.is_high_risk;
    drug.takingUnits = prescriptionBdmData.taking_units;
    drug.marketing_name = prescriptionBdmData.marketing;

    drug.cip7 = prescriptionBdmData.cip7 || prescriptionBdmData.cip;
    drug.name = prescriptionBdmData.name;
    drug.cip13 = prescriptionBdmData.cip13;
    drug.ucd7 = prescriptionBdmData.ucd7;
    drug.ucd = prescriptionBdmData.ucd;
    drug.routes = prescriptionBdmData.routes;
    drug.atc = prescriptionBdmData.atc;
    drug.inn = prescriptionBdmData.inn;
    drug.high_cost = prescriptionBdmData.high_cost;
    drug.number_of_ucd = prescriptionBdmData.number_of_ucd;
    drug.ucd_label = prescriptionBdmData.ucd_label;
    drug.is_stupefiant = prescriptionBdmData.is_stupefiant;
    drug.name_in_text = prescriptionBdmData.name_in_text;
    drug.comment_presc = prescriptionBdmData.comment_presc;

    return drug;
  }

  return {
    addDrugSelectModalResultToPrescription:
      addDrugSelectModalResultToPrescription,
    mapPrescriptionToSelectedDrug: mapPrescriptionToSelectedDrug,
  };
}

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MedplanCtrl
    * @description
    * # MedplanCreateEventCtrl
    * Controller of medplan edition
   */
  angular.module('mhclientApp').controller('MedplanCreateEventCtrl', ["$scope", "$rootScope", "$state", "SiteVarsUtils", "ThesaurusUtils", "UserUtils", "StayUtils", "Activity", function($scope, $rootScope, $state, SiteVarsUtils, ThesaurusUtils, UserUtils, StayUtils, Activity) {
    $scope.start_level = 1;
    $scope.thesaurus_filter = "";
    $scope.usersForPatient = null;
    $scope.event = null;
    if ($rootScope.currentStay) {
      $scope.stay = $rootScope.currentStay;
      $scope.patientFullName = $rootScope.currentPatient.full_name;
    } else {
      $scope.stay = null;
    }
    $scope.selectStay = function() {
      return StayUtils.selectStayByPatientModal(true).result.then(function(stay) {
        if (stay) {
          $scope.stay = stay;
          return $scope.patientFullName = $scope.stay.patient.full_name;
        }
      });
    };
    $rootScope.busy = true;
    ThesaurusUtils.getThesaurusCategories({
      code: "medplan_events"
    }).then(function(thesaurusCategory) {
      return ThesaurusUtils.getThesaurusEntries({
        "category": thesaurusCategory.id
      }, true).then(function(thesaurusEntries) {
        $scope.initThesaurus(thesaurusEntries, 0, $scope.start_level);
        $scope.thesaurus_tree = thesaurusEntries;
        $scope.filterThesaurus($scope.thesaurus_tree, $scope.thesaurus_filter);
        return $rootScope.busy = false;
      });
    });
    $scope.choiceChanged = function(thesaurusItem, thesaurusEntry) {
      thesaurusItem.selected = false;
      thesaurusItem.thesaurusEntry = thesaurusEntry;
      return $scope.event = angular.copy(thesaurusItem);
    };
    $scope.editMedplan = function() {
      return $scope.event = null;
    };
    return $scope.validate = function() {
      var careDict, data, planningData;
      $rootScope.busy = true;
      planningData = {
        "type": "dates",
        "dates": [moment($scope.event.date).format("DD/MM/YYYY")],
        "timeslots": [
          {
            "start_time": moment($scope.event.planning_data.start_time).format("HH:mm")
          }
        ],
        "caregivers": $scope.event.planning_data.caregivers
      };
      data = {
        "duration": $scope.event.duration,
        "stay": $scope.stay.id,
        "event_duration": $scope.event.duration,
        "linked_function": $scope.event.linked_function,
        "linked_data": $scope.event.linked_data,
        "event_all_day": $scope.event.event_all_day,
        "label": $scope.event.label,
        "short_name": $scope.event.short_label,
        "uid": $scope.event.uid
      };
      careDict = {
        "planning_data": planningData,
        "data": data,
        "start_date": moment($scope.event.date).format("YYYY-MM-DD"),
        "end_date": moment($scope.event.date).format("YYYY-MM-DD"),
        "thesaurus_entry": $scope.event.thesaurusEntry.id,
        "stay": $scope.stay.id
      };
      return Activity.api.save(careDict).$promise.then(function(activity) {
        $rootScope.busy = false;
        if ($rootScope.currentStay) {
          return $state.go('user.patient.stay.agenda');
        } else {
          return $state.go('user.agenda');
        }
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=medplan-create-event-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MedplanTemplatesCtrl
    * @description
    * # MedplanTemplatesCtrl
    * Controller of medplan templates
   */
  angular.module('mhclientApp').controller('MedplanTemplatesCtrl', ["$scope", "$rootScope", "ThesaurusUtils", "ThesaurusEntry", function($scope, $rootScope, ThesaurusUtils, ThesaurusEntry) {
    $scope.templateThesaurusOptions = {
      filter: "",
      start_level: 1
    };
    $scope.eventThesaurusOptions = {
      filter: "",
      start_level: 1
    };
    $scope.colors = [["default", null], ["blue", "bg-info"], ["green", "bg-success"], ["yellow", "bg-warning"], ["red", "bg-danger"]];
    $scope.addDate = function(dates) {
      return dates.push({
        shift: ""
      });
    };
    $scope.cancelNewPds = function() {
      return $scope.newPds = null;
    };
    $scope.savePds = function(pds) {
      var index, thesaurusEntry;
      thesaurusEntry = pds.thesaurusEntry;
      _.forEach(pds.entries, function(event) {
        return event.customColor = $scope.newPds.customColor;
      });
      pds.name = pds.label;
      if (pds.isNewEvent) {
        thesaurusEntry.entries.push(pds);
      } else {
        index = _.findIndex(thesaurusEntry.entries, pds.original);
        delete pds.original;
        thesaurusEntry.entries.splice(index, 1, pds);
      }
      delete pds.thesaurusEntry;
      delete pds.isNewEvent;
      $rootScope.busy = true;
      return ThesaurusEntry.api.update(thesaurusEntry).$promise.then(function(updatedThesaurusEntry) {
        pds.active = true;
        pds.level = 1;
        $scope.templateThesaurusOptions.filter = "";
        $scope.filterThesaurus([thesaurusEntry], $scope.templateThesaurusOptions.filter, $scope.templateThesaurusOptions.showObsolete);
        ThesaurusUtils.updateThesaurusEntry(updatedThesaurusEntry);
        $scope.newPds = null;
        return $rootScope.busy = false;
      });
    };
    $scope.removeEvent = function(pds, event) {
      _.remove(pds.entries, event);
      if (pds.entries.length === 0) {
        return $scope.addEventToPds(pds);
      }
    };
    $scope.addEventToPds = function() {
      $scope.eventThesaurusOptions.addingEvent = true;
      $scope.eventThesaurusOptions.filter = "";
      if ($scope.thesaurus_tree == null) {
        $rootScope.busy = true;
        return ThesaurusUtils.getThesaurusCategories({
          code: "medplan_events"
        }).then(function(thesaurusCategory) {
          return ThesaurusUtils.getThesaurusEntries({
            "category": thesaurusCategory.id
          }, true).then(function(thesaurusEntries) {
            $scope.initThesaurus(thesaurusEntries, 0, $scope.eventThesaurusOptions.start_level);
            $scope.thesaurus_tree = thesaurusEntries;
            $scope.filterThesaurus($scope.thesaurus_tree, $scope.eventThesaurusOptions.filter);
            return $rootScope.busy = false;
          });
        });
      } else {
        return $scope.filterThesaurus($scope.thesaurus_tree, $scope.eventThesaurusOptions.filter);
      }
    };
    $scope.choiceChanged = function(event) {
      delete event.selected;
      event = angular.copy(event);
      event.planning_data.start_time = moment(event.planning_data.start_time).toDate();
      $scope.computeEndTime(event);
      $scope.newPds.entries.push(event);
      $scope.newPds.events.push(event.uid);
      return $scope.eventThesaurusOptions.addingEvent = false;
    };
    $scope.addPds = function(thesaurusEntry, thesaurusItem) {
      if (thesaurusItem) {
        $scope.newPds = angular.copy(thesaurusItem);
        $scope.newPds.thesaurusEntry = thesaurusEntry;
        return $scope.newPds.original = thesaurusItem;
      } else {
        $scope.newPds = {
          "uid": ThesaurusUtils.uuid(),
          "thesaurusEntry": thesaurusEntry,
          "chained": true,
          "label": "",
          "isNewEvent": true,
          "events": [],
          "entries": []
        };
        return $scope.addEventToPds($scope.newPds);
      }
    };
    return ThesaurusUtils.getThesaurusCategories({
      code: "medplan_templates"
    }).then(function(thesaurusCategory) {
      $scope.thesaurusCategory = thesaurusCategory;
      return ThesaurusUtils.getThesaurusEntries({
        "category": $scope.thesaurusCategory.id
      }, true).then(function(thesaurusEntries) {
        $scope.initThesaurus(thesaurusEntries, 0, $scope.templateThesaurusOptions.start_level);
        $scope.thesaurusCategory.thesaurusEntries = thesaurusEntries;
        $scope.filterThesaurus(thesaurusCategory.thesaurusEntries, "");
        return $rootScope.busy = false;
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=medplan-templates-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:MedplanEventsCtrl
    * @description
    * # MedplanEventsCtrl
    * Controller to edit medplan events
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('MedplanEventsCtrl', ["$scope", "$rootScope", "$q", "$filter", "$uibModal", "ThesaurusUtils", "FormTemplateUtils", "SiteVarsUtils", "ThesaurusEntry", function($scope, $rootScope, $q, $filter, $uibModal, ThesaurusUtils, FormTemplateUtils, SiteVarsUtils, ThesaurusEntry) {
    $scope.selectWeekDay = function(planning_data, week_day) {
      if (!planning_data.week_days) {
        planning_data.week_days = [];
      }
      if (week_day.selected) {
        return planning_data.week_days.push(week_day.code);
      } else {
        return planning_data.week_days.splice(planning_data.week_days.indexOf(week_day.code), 1);
      }
    };
    $scope.thesaurusOptions = {
      filter: "",
      startLevel: 0
    };
    $scope.hasDuplicateDates = function(dates, date) {
      var i, len;
      if (date) {
        return _.filter(dates, {
          shift: date.shift
        }).length > 1;
      } else {
        for (i = 0, len = dates.length; i < len; i++) {
          date = dates[i];
          if (_.filter(dates, {
            shift: date.shift
          }).length > 1) {
            return true;
          }
        }
      }
    };
    $scope.removeDate = function(dates, date) {
      return _.remove(dates, date);
    };
    $scope.repeatChange = function(planningData) {
      if (planningData.repeat === 0) {
        return planningData.frequency = 1;
      }
    };
    ThesaurusUtils.getThesaurusCategories({
      code: "medplan_events"
    }).then(function(thesaurusCategory) {
      $scope.currentCategory = thesaurusCategory;
      if ($scope.currentCategory.data.max_depth == null) {
        $scope.currentCategory.data.max_depth = $scope.currentCategory.type === 'care' ? 1 : 4;
      }
      if (!$scope.currentCategory.thesaurusEntries) {
        $rootScope.busy = true;
        return ThesaurusUtils.getThesaurusEntries({
          category: $scope.currentCategory.id
        }, true).then(function(thesaurusEntries) {
          $scope.currentCategory.thesaurusEntries = thesaurusEntries;
          $scope.initThesaurus(thesaurusEntries, 0, $scope.thesaurusOptions.startLevel);
          $scope.filterThesaurus(thesaurusEntries, $scope.thesaurusOptions.filter);
          return $rootScope.busy = false;
        });
      }
    });
    $scope.editLinkedFunction = function(thesaurusItem) {
      var formsOptions, linkedFunctionDone;
      linkedFunctionDone = $q.defer();
      if ($scope.linkedFunctionOptions == null) {
        $scope.linkedFunctionOptions = {};
        formsOptions = {
          "type": "medicalform",
          "label": $filter('translate')('FORM'),
          options: []
        };
        $rootScope.busy = true;
        FormTemplateUtils.getTemplatesWithCurrent().then(function(templates) {
          var i, len, template;
          for (i = 0, len = templates.length; i < len; i++) {
            template = templates[i];
            formsOptions.options.push({
              uid: template.uid,
              label: formsOptions.label + " " + template.current.name,
              type: formsOptions.type
            });
          }
          $scope.linkedFunctionOptions.options = [formsOptions];
          $rootScope.busy = false;
          return linkedFunctionDone.resolve();
        });
      } else {
        linkedFunctionDone.resolve();
      }
      return linkedFunctionDone.promise.then(function() {
        if (thesaurusItem.linked_function) {
          $scope.linkedFunctionOptions.selected = _.find($scope.linkedFunctionOptions.options, {
            type: thesaurusItem.linked_function.type
          });
        } else {
          if ($scope.linkedFunctionOptions.options.length === 1) {
            $scope.linkedFunctionOptions.selected = $scope.linkedFunctionOptions.options[0];
          } else {
            $scope.linkedFunctionOptions.selected = null;
          }
        }
        return $uibModal.open({
          templateUrl: 'thesaurus/views/medplan/linked-function-selection.html',
          scope: $scope,
          size: "lg",
          windowClass: 'medplan-event-edit',
          backdrop: 'static',
          keyboard: false
        }).result.then((function(option) {
          return thesaurusItem.linked_function = option;
        }));
      });
    };
    return $scope.editEvent = function(thesaurusEntry, thesaurusItem) {
      var i, index, len, ref, week_day;
      $scope.thesaurusEntry = thesaurusEntry;
      if (thesaurusItem) {
        $scope.thesaurusItem = angular.copy(thesaurusItem);
      } else {
        $scope.thesaurusItem = {
          label: "",
          uid: ThesaurusUtils.uuid(),
          event_all_day: true,
          planning_data: {
            repeat: 0,
            dates: [
              {
                shift: 0
              }
            ],
            frequency_unit: "days",
            week_days: [],
            start_time: new Date(),
            caregivers: {},
            frequency: 1,
            type: "cycled"
          }
        };
      }
      $scope.thesaurusItem.week_days = [];
      if ($scope.thesaurusItem.planning_data.dates == null) {
        $scope.thesaurusItem.planning_data.dates = [
          {
            shift: 0
          }
        ];
      }
      ref = $scope.DATETIME_FORMATS.DAY;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        week_day = ref[index];
        $scope.thesaurusItem.week_days.push({
          code: index,
          label: week_day,
          selected: ($scope.thesaurusItem.planning_data.week_days != null) && (indexOf.call($scope.thesaurusItem.planning_data.week_days, index) >= 0)
        });
      }
      $scope.computeEndTime($scope.thesaurusItem);
      return $uibModal.open({
        templateUrl: 'medplan/views/event-detail.html',
        scope: $scope,
        windowClass: 'medplan-event-edit',
        backdrop: 'static',
        keyboard: false
      }).result.then((function() {
        var updateThesaurusTemplatesPromises;
        $rootScope.busy = true;
        if (thesaurusItem) {
          index = _.findIndex(thesaurusEntry.entries, thesaurusItem);
          thesaurusEntry.entries.splice(index, 1, $scope.thesaurusItem);
        } else {
          thesaurusEntry.entries.push($scope.thesaurusItem);
        }
        $scope.thesaurusItem.active = true;
        $scope.thesaurusItem.level = 1;
        if (!$scope.thesaurusItem.multiple) {
          $scope.thesaurusItem.planning_data.repeat = 1;
          $scope.thesaurusItem.planning_data.frequency_unit = "days";
          $scope.thesaurusItem.planning_data.frequency = 1;
          $scope.thesaurusItem.planning_data.type = "cycled";
        }
        updateThesaurusTemplatesPromises = [];
        return ThesaurusEntry.api.update(thesaurusEntry).$promise.then(function(updatedThesaurusEntry) {
          ThesaurusUtils.updateThesaurusEntry(updatedThesaurusEntry);
          return ThesaurusUtils.getThesaurusCategories({
            code: "medplan_templates"
          }).then(function(thesaurusCategory) {
            return ThesaurusUtils.getThesaurusEntries({
              "category": thesaurusCategory.id
            }, true).then(function(thesaurusEntries) {
              var event, j, k, l, len1, len2, len3, needUpdate, ref1, ref2, templateThesaurusEntry;
              for (j = 0, len1 = thesaurusEntries.length; j < len1; j++) {
                templateThesaurusEntry = thesaurusEntries[j];
                needUpdate = false;
                ref1 = templateThesaurusEntry.entries;
                for (k = 0, len2 = ref1.length; k < len2; k++) {
                  thesaurusItem = ref1[k];
                  ref2 = _.filter(thesaurusItem.entries, {
                    uid: $scope.thesaurusItem.uid
                  });
                  for (l = 0, len3 = ref2.length; l < len3; l++) {
                    event = ref2[l];
                    needUpdate = true;
                    event.short_label = $scope.thesaurusItem.short_label;
                    event.label = $scope.thesaurusItem.label;
                    event.event_duration = $scope.thesaurusItem.event_duration;
                    event.multiple = $scope.thesaurusItem.multiple;
                    event.planning_data = $scope.thesaurusItem.planning_data;
                    event.event_all_day = $scope.thesaurusItem.event_all_day;
                    event.duration = $scope.thesaurusItem.duration;
                    event.end_time = $scope.thesaurusItem.end_time;
                    event.linked_function = $scope.thesaurusItem.linked_function;
                  }
                }
                if (needUpdate) {
                  updateThesaurusTemplatesPromises.push(ThesaurusEntry.api.update(templateThesaurusEntry));
                }
              }
              return $q.all(updateThesaurusTemplatesPromises).then(function(thesaurusEntries) {
                var len4, m;
                for (m = 0, len4 = thesaurusEntries.length; m < len4; m++) {
                  templateThesaurusEntry = thesaurusEntries[m];
                  ThesaurusUtils.updateThesaurusEntry(templateThesaurusEntry);
                }
                $scope.filterThesaurus([thesaurusEntry], $scope.thesaurusOptions.filter, $scope.thesaurusOptions.showObsolete);
                return $rootScope.busy = false;
              });
            });
          });
        });
      }));
    };
  }]);

}).call(this);

//# sourceMappingURL=medplan-events-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MedplanCtrl
    * @description
    * # MedplanCtrl
    * Controller of medplan
   */
  angular.module('mhclientApp').controller('MedplanCreateCtrl', ["$scope", "$rootScope", "$state", "Medplan", "ThesaurusUtils", "$uibModal", "$filter", "UserUtils", function($scope, $rootScope, $state, Medplan, ThesaurusUtils, $uibModal, $filter, UserUtils) {
    $scope.start_level = 0;
    $scope.thesaurus_filter = "";
    $scope.j0 = new Date();
    $scope.usersForPatient = null;
    $scope.handleToogleEvent = function() {
      var minEventByShift, minJ0Shift;
      minJ0Shift = _.minBy($scope.selectedMedplan.entries, "j0_shift").j0_shift;
      minEventByShift = _.minBy(_.filter($scope.selectedMedplan.entries, {
        enabled: true
      }), "j0_shift");
      if (minEventByShift && minEventByShift.j0_shift !== minJ0Shift) {
        if ($scope.currentShiftByDisabled !== minEventByShift.j0_shift) {
          $scope.currentShiftByDisabled = minEventByShift.j0_shift;
          _.map($scope.selectedMedplan.entries, function(entry) {
            return entry.shiftedByDisabled = $scope.currentShiftByDisabled;
          });
          return $scope.$broadcast('NewJ0');
        }
      } else if ($scope.currentShiftByDisabled !== 0) {
        $scope.currentShiftByDisabled = 0;
        _.map($scope.selectedMedplan.entries, function(entry) {
          return entry.shiftedByDisabled = $scope.currentShiftByDisabled;
        });
        return $scope.$broadcast('NewJ0');
      }
    };
    $rootScope.busy = true;
    ThesaurusUtils.getThesaurusCategories({
      code: "medplan_templates"
    }).then(function(thesaurusCategory) {
      return ThesaurusUtils.getThesaurusEntries({
        "category": thesaurusCategory.id
      }, true).then(function(thesaurusEntries) {
        $scope.initThesaurus(thesaurusEntries, 0, $scope.start_level);
        $scope.thesaurus_tree = thesaurusEntries;
        $scope.filterThesaurus($scope.thesaurus_tree, $scope.thesaurus_filter);
        return $rootScope.busy = false;
      });
    });
    $scope.editMedplan = function() {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("CHANGE_SELECTED_MEDPLAN");
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          }
        }
      });
      return confirm_dialog.result.then(function() {
        return $scope.selectedMedplan = null;
      });
    };
    $scope.choiceChanged = function(thesaurusItem, thesaurusEntry) {
      $scope.resetPlanningGroups();
      thesaurusItem.selected = false;
      thesaurusItem.thesaurusEntry = thesaurusEntry;
      if (!$scope.usersForPatient) {
        $rootScope.busy = true;
        return UserUtils.getUsersForPatient($rootScope.currentPatient.si_id).then(function(users) {
          $scope.usersForPatient = users;
          $scope.selectedMedplan = angular.copy(thesaurusItem);
          $scope.currentShiftByDisabled = 0;
          $rootScope.busy = false;
          return _.forEach($scope.selectedMedplan.entries, function(event) {
            event.enabled = true;
            return $scope.associateUSer(event, $scope.usersForPatient);
          });
        });
      } else {
        $scope.selectedMedplan = angular.copy(thesaurusItem);
        $scope.currentShiftByDisabled = 0;
        return _.forEach($scope.selectedMedplan.entries, function(event) {
          event.enabled = true;
          return $scope.associateUSer(event, $scope.usersForPatient);
        });
      }
    };
    $scope.selectUser = function(group, availableUsers) {
      return UserUtils.selectUserModal(null, null, availableUsers).result.then(function(selectedUser) {
        if (selectedUser) {
          return _.forEach($scope.selectedMedplan.entries, function(event) {
            var groupDict, groupUid, ref, results;
            ref = event.planning_data.caregivers;
            results = [];
            for (groupUid in ref) {
              groupDict = ref[groupUid];
              if (groupUid === group) {
                results.push(groupDict.users[0] = {
                  "username": selectedUser.username,
                  "full_name": selectedUser.full_name
                });
              } else {
                results.push(void 0);
              }
            }
            return results;
          });
        }
      });
    };
    return $scope.validate = function() {
      var entry, groupDict, groupUid, i, len, medPlan, ref, ref1;
      $rootScope.busy = true;
      medPlan = angular.copy($scope.selectedMedplan);
      medPlan.J0 = moment($scope.j0).format("YYYY-MM-DD");
      medPlan.stay = $rootScope.currentStay.id;
      medPlan.thesaurus = medPlan.thesaurusEntry.id;
      medPlan.thesaurus_template = medPlan.uid;
      delete medPlan.thesaurusEntry;
      medPlan.entries = _.filter(medPlan.entries, {
        enabled: true
      });
      ref = medPlan.entries;
      for (i = 0, len = ref.length; i < len; i++) {
        entry = ref[i];
        ref1 = entry.planning_data.caregivers;
        for (groupUid in ref1) {
          groupDict = ref1[groupUid];
          delete groupDict.availableUsers;
        }
        entry.date = moment(entry.date).format("YYYY-MM-DD");
        entry.planning_data.start_time = moment(entry.planning_data.start_time).format("HH:mm");
        entry.event_duration = entry.duration;
      }
      return Medplan.api.save(medPlan).$promise.then(function() {
        $rootScope.busy = false;
        return $state.go("user.patient.stay.agenda");
      });
    };
  }]);

  angular.module('mhclientApp').controller('MedplanEventCtrl', ["$scope", "UserUtils", function($scope, UserUtils) {
    var init;
    $scope.selectUser = function(user, availableUsers) {
      return UserUtils.selectUserModal(null, null, availableUsers).result.then(function(selectedUser) {
        if (selectedUser) {
          user.full_name = selectedUser.full_name;
          return user.username = selectedUser.username;
        }
      });
    };
    init = function() {
      var shift;
      shift = $scope.event.j0_shift - ($scope.event.shiftedByDisabled || 0);
      return $scope.event.date = moment($scope.j0).add(shift, "days").toDate();
    };
    init();
    return $scope.$on("NewJ0", init);
  }]);

  angular.module('mhclientApp').controller('MedplanListCtrl', ["$scope", "$rootScope", "$filter", "$uibModal", "$q", "Task", "Activity", "Medplan", "GroupUtils", "AgendaUtils", "AgendaTask", function($scope, $rootScope, $filter, $uibModal, $q, Task, Activity, Medplan, GroupUtils, AgendaUtils, AgendaTask) {
    var decorateEvent, init;
    init = function() {
      var params;
      params = {
        stay: $rootScope.currentStay.id
      };
      return GroupUtils.getAllGroups().then(function(groups) {
        $scope.groups = groups;
        return Medplan.api.query(params).$promise.then(function(medplans) {
          $scope.medplans = medplans;
          return $scope.hasStoppedMedplans = _.filter($scope.medplans, {
            status: "stopped"
          }).length > 0;
        });
      });
    };
    $scope.showStoppedSequences = false;
    init();
    decorateEvent = function(event) {
      var authors, groupInvolved, i, len, ref, task;
      ref = event.tasks;
      for (i = 0, len = ref.length; i < len; i++) {
        task = ref[i];
        if (task.group_involved) {
          if (task.id) {
            groupInvolved = _.find($scope.groups, {
              id: task.group_involved
            });
          } else {
            groupInvolved = _.find($scope.groups, {
              uid: task.group_involved
            });
          }
          task.group_label = groupInvolved.name;
          task.group_short_label = groupInvolved.short_name;
        }
      }
      authors = _.uniq(_.map(event.tasks, function(task) {
        return task.data.initials || task.data.user_involved_initials || task.group_short_label;
      }));
      event.authorsLabel = authors.join(' ');
      event.start = moment(event.start);
      return event.allDay = !event.end;
    };
    $scope.getInfos = function(medplan) {
      if (medplan.currentEvents == null) {
        $rootScope.busy = true;
        return Medplan.api.get({
          "id": medplan.id
        }).$promise.then(function(medplanInfos) {
          return AgendaUtils.groupTasksInEvents(medplanInfos.tasks).then(function(currentEvents) {
            var event, i, len, ref;
            medplan.currentEvents = currentEvents;
            medplan.next_tasks = medplanInfos.next_tasks;
            ref = medplan.currentEvents;
            for (i = 0, len = ref.length; i < len; i++) {
              event = ref[i];
              decorateEvent(event);
            }
            medplan.unfold = !medplan.unfold;
            return $rootScope.busy = false;
          });
        });
      } else {
        return medplan.unfold = !medplan.unfold;
      }
    };
    $scope.genMedplanEvent = function(tasks) {
      var event;
      event = AgendaUtils.genMedplanEvent(tasks);
      decorateEvent(event);
      return event;
    };
    $scope.openTask = function(medplan, event) {
      var confirm_dialog;
      if ($rootScope.mh_config.platform === "mgapp") {
        $window.mgapp.lock_menu(true);
      }
      $scope.currentEvent = event;
      confirm_dialog = $uibModal.open({
        templateUrl: 'agenda/views/event-medplan-detail.html',
        controller: "EventMedplanDetailCtrl",
        windowClass: 'event-detail-modal',
        scope: $scope,
        backdrop: 'static',
        resolve: {
          stays: function() {
            return $rootScope.currentPatientStays;
          },
          dirty: function() {
            return false;
          },
          resize: function() {
            return false;
          }
        }
      });
      return confirm_dialog.result.then(function(result) {
        var handleNextTask, newEvent, updatedTasks;
        if ($rootScope.mh_config.platform === "mgapp") {
          $window.mgapp.lock_menu(false);
        }
        if (result && result.action === "update") {
          $rootScope.busy = true;
          updatedTasks = result.tasks;
          newEvent = AgendaUtils.genMedplanEvent(updatedTasks);
          decorateEvent(newEvent);
          _.remove(medplan.currentEvents, event);
          medplan.currentEvents.push(newEvent);
          handleNextTask = $q.defer();
          if ($scope.currentEvent.chained && $scope.currentEvent.status === "PLANNED" && newEvent.status === "DONE") {
            Activity.api.createNextTask({
              id: newEvent.activity
            }).$promise.then(function(newTaks) {
              if (newTaks.length > 0) {
                return AgendaUtils.groupTasksInEvents(newTaks).then(function(events) {
                  var i, len;
                  for (i = 0, len = events.length; i < len; i++) {
                    event = events[i];
                    decorateEvent(event);
                    medplan.currentEvents.push(event);
                  }
                  return Medplan.api.get({
                    "id": medplan.id
                  }).$promise.then(function(medplanInfos) {
                    medplan.next_tasks = medplanInfos.next_tasks;
                    return handleNextTask.resolve();
                  });
                });
              } else {
                return handleNextTask.resolve();
              }
            });
          } else {
            handleNextTask.resolve();
          }
          return handleNextTask.promise.then(function() {
            var formatedUpdatedTask, i, len, ref, task;
            formatedUpdatedTask = [];
            ref = newEvent.tasks;
            for (i = 0, len = ref.length; i < len; i++) {
              task = ref[i];
              formatedUpdatedTask.push({
                id: task.id,
                date: task.date,
                user_involved: task.user_involved,
                data: task.data,
                status: task.status,
                author: task.author
              });
            }
            return AgendaTask.api.updateTasks(formatedUpdatedTask).$promise.then(function() {
              return $rootScope.busy = false;
            });
          });
        }
      });
    };
    $scope.deleteNextTask = function(medplan, task) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("CONFIRM_DELETE_TASK");
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          }
        }
      });
      return confirm_dialog.result.then(function() {
        _.pull(medplan.next_tasks, task);
        return Medplan.api.patch({
          "id": medplan.id
        }, {
          "next_tasks": medplan.next_tasks
        });
      });
    };
    return $scope.stopMedplan = function(medplan) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-reason-template.html',
        controller: 'mhModalReasonCtrl',
        size: "lg",
        resolve: {
          title: function() {
            return $filter('translate')("CONFIRM_DELETE_MEDPLAN");
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          },
          reasonLabel: function() {
            return $filter('translate')("STOP_REASON");
          },
          reasonRequired: function() {
            return false;
          }
        }
      });
      return confirm_dialog.result.then(function(stopReason) {
        $rootScope.busy = true;
        return Medplan.api.stop({
          id: medplan.id
        }, {
          stop_reason: stopReason
        }).$promise.then(function(data) {
          $rootScope.busy = false;
          medplan.data.stop_reason = stopReason;
          delete medplan.currentEvents;
          medplan.unfold = false;
          medplan.status = "stopped";
          return $scope.hasStoppedMedplans = true;
        });
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=medplan-association-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Medplan
    * @description
    * # Medplan
    * Factory of Medplan
   */
  angular.module("mhclientApp").factory('Medplan', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, boxAPI, medplan, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/medplans/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'patch': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH'
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'stop': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST',
        params: {
          route: "stop"
        },
        isArray: false
      },
      'getPPCUrl': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'GET',
        params: {
          route: "get_ppc_url"
        },
        isArray: false
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        medplan = window.mgapp.get('taskplanner').medplan();
        boxAPI = BoxResource.generate(medplan);
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    service = medplan = {
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=medplan-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MedplanCtrl
    * @description
    * # MedplanCtrl
    * Controller of medplan edition
   */
  angular.module('mhclientApp').controller('MedplanCtrl', ["$scope", "$rootScope", "$uibModal", "GroupUtils", "ThesaurusUtils", "ThesaurusEntry", function($scope, $rootScope, $uibModal, GroupUtils, ThesaurusUtils, ThesaurusEntry) {
    $scope.planning_groups = {};
    GroupUtils.getAllGroups().then(function(groups) {
      return $scope.group_selectable_list = groups;
    });
    $scope.resetPlanningGroups = function() {
      return $scope.planning_groups = {};
    };
    $scope.associateUSer = function(event, usersForPatient) {
      var groupDict, groupUid, ref, results, user, users;
      ref = event.planning_data.caregivers;
      results = [];
      for (groupUid in ref) {
        groupDict = ref[groupUid];
        if ($scope.planning_groups != null) {
          $scope.planning_groups[groupUid] = groupDict;
        }
        users = [];
        groupDict.availableUsers = _.filter(usersForPatient, {
          group: {
            uid: groupUid
          }
        });
        if (groupDict.availableUsers.length === 1) {
          user = groupDict.availableUsers[0];
          while (users.length !== groupDict.count) {
            users.push({
              username: user.username,
              full_name: user.full_name
            });
          }
        } else {
          while (users.length !== groupDict.count) {
            users.push({});
          }
        }
        results.push(event.planning_data.caregivers[groupUid].users = users);
      }
      return results;
    };
    $scope.activate_childs = function(item) {
      var child_item, i, len, ref, results;
      ref = item.entries || [];
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        child_item = ref[i];
        results.push(child_item.active = true);
      }
      return results;
    };
    $scope.initThesaurus = function(thesaurusEntries, level, start_level) {
      var i, len, results, thesaurusEntry;
      results = [];
      for (i = 0, len = thesaurusEntries.length; i < len; i++) {
        thesaurusEntry = thesaurusEntries[i];
        thesaurusEntry.level = level;
        thesaurusEntry.active = level <= start_level;
        thesaurusEntry.hide = false;
        results.push($scope.initThesaurus(thesaurusEntry.entries || [], level + 1, start_level));
      }
      return results;
    };
    $scope.filterThesaurus = function(thesaurusEntries, filter, showObsolete) {
      return ThesaurusUtils.filter(thesaurusEntries, filter, showObsolete);
    };
    $scope.isEmpty = function(object) {
      return (object == null) || Object.keys(object).length === 0;
    };
    $scope.checkInUid = function(viewValue, not_in_list) {
      return function(item, index, array) {
        if ((not_in_list != null) && (not_in_list[item.uid] != null)) {
          return false;
        }
        return !viewValue || viewValue === " " || viewValue === null || item.name.toLowerCase().indexOf(viewValue.toLowerCase()) >= 0;
      };
    };
    $scope.removeGroup = function(caregivers, groupUid, group_dict) {
      if (group_dict.count === 1) {
        return delete caregivers[groupUid];
      } else {
        return group_dict.count -= 1;
      }
    };
    $scope.addGroup = function(caregivers, groupUid, groupName) {
      if (caregivers[groupUid] != null) {
        return caregivers[groupUid].count += 1;
      } else {
        return caregivers[groupUid] = {
          count: 1,
          group_name: groupName
        };
      }
    };
    $scope.computeEndTime = function(thesaurusItem) {
      var start_time;
      if (thesaurusItem.planning_data.start_time && thesaurusItem.duration) {
        start_time = moment(thesaurusItem.planning_data.start_time).toDate();
        return thesaurusItem.end_time = new Date(start_time.getTime() + (thesaurusItem.duration * 60 * 1000));
      } else {
        return thesaurusItem.end_time = null;
      }
    };
    $scope.editEntry = function(thesaurusEntry, thesaurusOptions) {
      $scope.newEntry = {
        entries: thesaurusEntry.entries,
        category: thesaurusEntry.category,
        label: thesaurusEntry.label,
        obsolete: thesaurusEntry.obsolete,
        id: thesaurusEntry.id
      };
      return $uibModal.open({
        templateUrl: 'thesaurus/views/medplan/add-entry.html',
        scope: $scope,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      }).result.then((function() {
        $rootScope.busy = true;
        return ThesaurusEntry.api.update($scope.newEntry).$promise.then(function(newThesaurusEntry) {
          thesaurusEntry.label = $scope.newEntry.label;
          thesaurusEntry.obsolete = $scope.newEntry.obsolete;
          $scope.filterThesaurus([thesaurusEntry], thesaurusOptions.filter, thesaurusOptions.showObsolete);
          ThesaurusUtils.updateThesaurusEntry(newThesaurusEntry);
          return $rootScope.busy = false;
        });
      }));
    };
    return $scope.addEntry = function(currentCategory) {
      $scope.newEntry = {
        entries: [],
        category: currentCategory.id
      };
      return $uibModal.open({
        templateUrl: 'thesaurus/views/medplan/add-entry.html',
        scope: $scope,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      }).result.then((function() {
        $rootScope.busy = true;
        return ThesaurusEntry.api.save($scope.newEntry).$promise.then(function(thesaurusEntry) {
          thesaurusEntry.active = true;
          thesaurusEntry.level = 0;
          currentCategory.thesaurusEntries.push(thesaurusEntry);
          ThesaurusUtils.addThesaurusEntry(thesaurusEntry);
          return $rootScope.busy = false;
        });
      }));
    };
  }]);

}).call(this);

//# sourceMappingURL=medplan-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MedplanCtrl
    * @description
    * # MedplanCtrl
    * Controller of medplan edition
   */
  angular.module('mhclientApp').directive('ppcData', function() {
    return {
      restrict: 'E',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'medplan/views/ppc-data.html';
        }
      },
      scope: {
        patient: "=",
        stay: "="
      },
      controller: ["$rootScope", "$scope", "Medplan", "$sce", "$window", "SiteVarsUtils", function($rootScope, $scope, Medplan, $sce, $window, SiteVarsUtils) {
        $scope.computeUrl = function() {
          $rootScope.busy = true;
          return Medplan.api.getPPCUrl({
            stay_number: $scope.stay.si_id,
            d_from: moment($scope.dFrom).format("YYYY-MM-DD"),
            d_to: moment($scope.dTo).format("YYYY-MM-DD")
          }).$promise.then(function(ppcInfo) {
            $scope.ppcInfo = ppcInfo;
            $scope.ppcUrl = $sce.trustAsResourceUrl(ppcInfo.url);
            return $rootScope.busy = false;
          });
        };
        return SiteVarsUtils.getValue("PPC_DATA_INFO").then(function(ppcConfig) {
          $scope.dFrom = moment(new Date()).add(-((ppcConfig != null ? ppcConfig.from_delta : void 0) != null ? ppcConfig.from_delta : 30), "days").toDate();
          $scope.dTo = new Date();
          return $scope.computeUrl();
        });
      }]
    };
  });

}).call(this);

//# sourceMappingURL=ppc-data-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CurrentPrescriptionCtrl
    * @description
    * # CurrentPrescriptionCtrl
    * Controller of Patient current Prescriptions
   */
  angular.module('mhclientApp').controller('PhotoCtrl', ["$scope", "$rootScope", function($scope, $rootScope) {
    $rootScope.busy = true;
    $scope.photo_iframe_url = $scope.base_iframe_url + '/webfw/documents_mgr/stay_' + $rootScope.currentStay.id;
    if ($scope.allStays) {
      $scope.photo_iframe_url = $scope.photo_iframe_url + '/pat_' + $rootScope.currentPatient.id;
    }
    $scope.photo_iframe_url = $scope.photo_iframe_url + '/browse_photo';
    $scope.iframeLoadCallback = function() {
      return $rootScope.$evalAsync(function() {
        return $rootScope.busy = false;
      });
    };
    return $scope.$on("$destroy", function() {
      return $rootScope.busy = false;
    });
  }]);

}).call(this);

//# sourceMappingURL=photo-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MessageCtrl
    * @description
    * # MessageCtrl
    * Controller of Message
   */
  angular.module('mhclientApp').directive('photos', function() {
    return {
      restrict: 'A',
      compile: function(element, attrs) {
        if (attrs.isDirty == null) {
          return attrs.isDirty = "false";
        }
      },
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'photo/views/photos-directive.html';
        }
      },
      scope: {
        stay: '=',
        patient: '=',
        allStays: '=',
        isDirty: "=",
        hideSaveButton: "="
      },
      controller: ["$rootScope", "$filter", "$http", "$scope", "$q", "$uibModal", "$timeout", "$state", "Photo", "SiteVarsUtils", "Group", "Upload", function($rootScope, $filter, $http, $scope, $q, $uibModal, $timeout, $state, Photo, SiteVarsUtils, Group, Upload) {
        var launchCamera;
        $scope.dirtyPhotosCount = 0;
        $scope.$watch(function() {
          return $scope.isDirty = $scope.dirtyPhotosCount > 0;
        });
        $scope.config = {
          'readonly': false,
          'action': 'draw',
          'penColor': 'black',
          'lineWidth': 2,
          'smooth': true,
          'tolerance': 1.00,
          'withNotes': true,
          'coefficientForZoom': 1,
          'width': 826,
          'height': 1169
        };
        $scope.toggleColor = function(color) {
          $scope.config.penColor = color;
          if ($scope.config.action === 'erase') {
            return $scope.config.action = 'draw';
          }
        };
        $scope.updatingPhotos = true;
        $scope.photos = [];
        $scope.options = {
          photoIndex: 0
        };
        window.closeCamera = function(camera) {
          $scope.dirtyPhotosCount += camera.captures.length;
          $scope.photos = _.map(camera.captures, function(capture) {
            return {
              "dirty": true,
              "capture": capture,
              "config": $scope.config,
              'newDataContent': [],
              'data': [[]],
              'baseImage': {},
              "image": 'data:image/png;base64,' + capture,
              "preview": 'data:image/png;base64,' + capture
            };
          }).concat($scope.photos);
          $rootScope.busy = false;
          $scope.options.photoIndex = 0;
          $scope.updatingPhotos = true;
          $scope.$apply();
          return $timeout(function() {
            return $scope.updatingPhotos = false;
          });
        };
        Photo.api.query($scope.allStays ? {
          patient: $scope.patient.id
        } : {
          stay: $scope.stay.id
        }).$promise.then(function(photos) {
          $scope.photos = $filter('orderBy')(photos, '-timestamp');
          $scope.updatingPhotos = false;
          return $scope.options.photoIndex = 0;
        });
        $scope.removePhoto = function(photo) {
          var prevIndex;
          prevIndex = photo.index;
          _.remove($scope.photos, photo);
          $scope.dirtyPhotosCount -= 1;
          $scope.updatingPhotos = true;
          return $timeout(function() {
            return $scope.updatingPhotos = false;
          });
        };
        $scope.savePictures = function() {
          var currentPhoto, dirtyPhotos;
          $rootScope.busy = true;
          dirtyPhotos = _.filter($scope.photos, "dirty");
          currentPhoto = $scope.photos[$scope.options.photoIndex];
          if (currentPhoto.dirty) {
            $scope.$broadcast('$canvasToImage');
          }
          return Photo.api.save(_.map(dirtyPhotos, function(p) {
            return {
              "capture": p.capture,
              "foreground": (p.baseImage.dataUrl || "").split(',')[1]
            };
          })).$promise.then(function(photos) {
            $rootScope.busy = false;
            $scope.photos = photos.concat(_.filter($scope.photos, function(p) {
              return !p.dirty;
            }));
            $scope.updatingPhotos = true;
            $timeout(function() {
              return $scope.updatingPhotos = false;
            });
            return $scope.dirtyPhotosCount = 0;
          });
        };
        launchCamera = function() {
          return window.mgapp.take_picture({
            "kiko": "cuca"
          });
        };
        $scope.takePicture = function() {
          $rootScope.busy = true;
          return $timeout(launchCamera, 50);
        };
        $scope.rotate = function(photo, degrees) {
          var canvas, ctx, image;
          canvas = document.createElement('canvas');
          ctx = canvas.getContext("2d");
          ctx.imageSmoothingEnabled = false;
          image = new Image();
          photo.rotation = (photo.rotation || 0) + degrees;
          photo.original = photo.original || photo.image;
          $rootScope.busy = true;
          image.onload = function() {
            canvas.width = photo.rotation % 180 === 0 ? image.width : image.height;
            canvas.height = photo.rotation % 180 === 0 ? image.height : image.width;
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(photo.rotation * Math.PI / 180);
            ctx.drawImage(image, image.width / -2, image.height / -2);
            $rootScope.busy = false;
            photo.capture = canvas.toDataURL("image/jpeg", 1.0);
            photo.image = photo.capture;
            photo.preview = photo.capture;
            photo.capture = photo.capture.split(',')[1];
            return $scope.$apply();
          };
          return image.src = photo.original;
        };
        $scope.handleStateChangePromise = function() {
          var photoPromise, pr;
          photoPromise = $q.defer();
          pr = $uibModal.open({
            animation: true,
            templateUrl: 'core/views/modal-template.html',
            size: "lg",
            controller: 'mhModalCtrl',
            resolve: {
              title: function() {
                return $filter('translate')("PHOTO_MISSING_ACTION_TITLE");
              },
              text: function() {
                return $filter('translate')("PHOTO_MISSING_ACTION_TEXT");
              },
              cancelButtonText: function() {
                return $filter('translate')("CANCEL_BUTTON");
              },
              noButtonText: function() {
                return $filter('translate')("DONT_SAVE_BUTTON");
              },
              okButtonText: function() {
                return $filter('translate')("SAVE_BUTTON");
              }
            }
          });
          pr.result.then((function(toSave) {
            if (toSave) {
              return $scope.savePictures().then(function() {
                return photoPromise.resolve(true);
              });
            } else {
              $scope.dirtyPhotosCount = 0;
              return photoPromise.resolve();
            }
          }), (function(e) {
            $rootScope.busy = false;
            return photoPromise.reject();
          }));
          return photoPromise.promise;
        };
        $scope.$on('validateRequest', function(event) {
          if ($scope.dirtyPhotosCount > 0) {
            if (!event.validatePromises) {
              event.validatePromises = [];
            }
            return event.validatePromises.push($scope.savePictures());
          }
        });
        $scope.$on('closeRequested', function(event) {
          if ($scope.dirtyPhotosCount > 0) {
            if (!event.closePromises) {
              event.closePromises = [];
            }
            return event.closePromises.push($scope.handleStateChangePromise());
          }
        });
        $scope.$on('$toggleShowAllStays', function(event) {
          if ($scope.dirtyPhotosCount > 0) {
            if (!event.togglePromises) {
              event.togglePromises = [];
            }
            return event.togglePromises.push($scope.handleStateChangePromise());
          }
        });
        return $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
          if (event.defaultPrevented) {
            return;
          }
          if ($scope.dirtyPhotosCount > 0) {
            event.preventDefault();
            return $scope.handleStateChangePromise().then(function() {
              return $state.go(toState.name, toParams);
            });
          }
        });
      }]
    };
  });

}).call(this);

//# sourceMappingURL=photo-directives.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Thread
    * @description
    * # Thread
    * Factory of Thread
   */
  angular.module("mhclientApp").factory('Photo', ["$resource", "MhConfig", "$q", "BoxResource", "$http", function($resource, MhConfig, $q, BoxResource, $http) {
    var acceptHeader, api, photo, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/photos/:id/:route', {
      id: this.id
    }, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'getDetails': {
        method: "GET",
        isArray: false,
        params: {
          route: 'get_details'
        },
        headers: {
          "Accept": acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        photo = window.mgapp.get('photo_mgr').photo();
        api = BoxResource.generate(photo);
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=photo-services.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:MHBoxLogin
    * @description
    * # MHBoxLogin
    * Controller of Staff
   */
  angular.module('mhclientApp').controller('LoginBlockedCtrl', ["$scope", "$rootScope", "$state", "$timeout", "$stateParams", function($scope, $rootScope, $state, $timeout, $stateParams) {
    var failTime, handleCountDown;
    $scope.username = $stateParams.username;
    failTime = moment.utc($stateParams.fail_time);
    $scope.failedLogins = $stateParams.failed_logins;
    $scope.returnToLogin = function() {
      if ($rootScope.mh_config.platform === "mgapp") {
        return $state.go("mhbox-login");
      } else {
        return window.location = "/";
      }
    };
    handleCountDown = function() {
      var diff;
      diff = moment(failTime).add($stateParams.lockout_time, 'seconds').diff(moment.utc());
      if (diff > 0) {
        $scope.countDown = moment.utc(diff).format("HH[h]:mm[m]:ss[s]");
        return $timeout(handleCountDown, 1000);
      } else {
        return $scope.countDown = '00h:00m:00s';
      }
    };
    return handleCountDown();
  }]);

}).call(this);

//# sourceMappingURL=login-blocked-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CurrentPrescriptionCtrl
    * @description
    * # CurrentPrescriptionCtrl
    * Controller of Patient current Prescriptions
   */
  angular.module('mhclientApp').controller('ScanCtrl', ["$scope", "$rootScope", "$stateParams", "$state", function($scope, $rootScope, $stateParams, $state) {
    var previousFeature;
    $rootScope.busy = true;
    if ($state.previous) {
      previousFeature = $state.previous.name;
    }
    $scope.scan_iframe_url = $scope.base_iframe_url + '/webfw/documents_mgr/stay_' + $rootScope.currentStay.id;
    if ($scope.allStays) {
      $scope.scan_iframe_url = $scope.scan_iframe_url + '/pat_' + $rootScope.currentPatient.id;
    }
    if ($stateParams.uploadFile) {
      $scope.scan_iframe_url = $scope.scan_iframe_url + '/upld_file' + '?featureName=' + $stateParams.featureName + '&next=' + previousFeature;
    } else {
      $scope.scan_iframe_url = $scope.scan_iframe_url + '/browse_docs' + '?featureName=' + $stateParams.featureName;
    }
    $scope.iframeLoadCallback = function() {
      return $rootScope.$evalAsync(function() {
        return $rootScope.busy = false;
      });
    };
    return $scope.$on("$destroy", function() {
      return $rootScope.busy = false;
    });
  }]);

}).call(this);

//# sourceMappingURL=scan-controller.js.map

(function() {
  angular.module("mhclientApp").factory('ReplanUtils', ["ThesaurusUtils", "GroupUtils", function(ThesaurusUtils, GroupUtils) {
    var dateFormat, getStartDate, liberalCount, notEmpty, preselectActivities, reloadActivities, service, updateAllDates, updateLiberalGroups, updatePlanningDates, updateTemplateDates;
    dateFormat = 'YYYY-MM-DD';
    liberalCount = function(caregivers) {
      return _.sum(_.map(caregivers, function(groupDict, key) {
        if (groupDict.liberal) {
          return groupDict.count;
        } else {
          return 0;
        }
      }));
    };
    getStartDate = function(planning_data) {
      if (planning_data.type === "dates") {
        return planning_data.dates.sort()[0];
      }
      return planning_data.start_date;
    };
    updatePlanningDates = function(planning_data, delta) {
      if (planning_data.start_date) {
        planning_data.start_date = moment(planning_data.start_date).add(delta, 'days').format(dateFormat);
      }
      if (planning_data.end_date) {
        planning_data.end_date = moment(planning_data.end_date).add(delta, 'days').format(dateFormat);
      }
      if (planning_data.dates) {
        planning_data.dates = _.map(planning_data.dates, function(date) {
          return moment(date).add(delta, 'days').format(dateFormat);
        });
      }
    };
    updateAllDates = function(sequence, delta) {
      updatePlanningDates(sequence.planning_data, delta);
      _.forEach(sequence.activities, function(activity) {
        return updatePlanningDates(activity.planning_data, delta);
      });
    };
    updateTemplateDates = function(sequence, template) {
      var delta, new_start_date;
      new_start_date = getStartDate(sequence.planning_data);
      if (template.planning_data.start_date && template.planning_data.start_date !== new_start_date) {
        delta = moment(new_start_date).diff(moment(template.planning_data.start_date), 'days');
        updateAllDates(template, delta);
      } else {
        template.planning_data.start_date = new_start_date;
      }
    };
    notEmpty = function(tab) {
      if ((tab != null ? tab.length : void 0) > 0) {
        return tab;
      } else {
        return void 0;
      }
    };
    updateLiberalGroups = function(caregivers, groups) {
      return _.forEach(caregivers, function(value, grpUID) {
        var matchingGroup;
        matchingGroup = _.find(groups, function(group) {
          return group.uid === grpUID;
        });
        if (matchingGroup) {
          return value.liberal = matchingGroup.liberal;
        } else {
          return delete caregivers[grpUID];
        }
      });
    };
    preselectActivities = function(categories, new_sequence, groups) {
      var activities_dict, activity, category, entry, group_uid, i, j, k, l, len, len1, len2, len3, len4, len5, m, n, ref, ref1, ref2, ref3, ref4, results, thesaurus_entry;
      activities_dict = {};
      ref = new_sequence.activities;
      for (i = 0, len = ref.length; i < len; i++) {
        activity = ref[i];
        activity.selected = true;
        activity.found = false;
        if (!activities_dict[activity.thesaurus_entry]) {
          activities_dict[activity.thesaurus_entry] = {};
        }
        activities_dict[activity.thesaurus_entry][activity.data.uid] = activity;
      }
      for (j = 0, len1 = categories.length; j < len1; j++) {
        category = categories[j];
        ref1 = category.entries;
        for (k = 0, len2 = ref1.length; k < len2; k++) {
          thesaurus_entry = ref1[k];
          if (activities_dict[thesaurus_entry.id] != null) {
            ref2 = thesaurus_entry.entries;
            for (l = 0, len3 = ref2.length; l < len3; l++) {
              entry = ref2[l];
              if (activities_dict[thesaurus_entry.id][entry.uid] != null) {
                activity = activities_dict[thesaurus_entry.id][entry.uid];
                activity.replan_errors = {};
                activity.replan_warnings = {};
                activity.found = true;
                if (!category.active) {
                  activity.replan_warnings.thesaurus_category_obsolete = true;
                } else if (thesaurus_entry.obsolete) {
                  activity.replan_warnings.thesaurus_entry_obsolete = true;
                } else if (entry.obsolete) {
                  activity.replan_warnings.thesaurus_subentry_obsolete = true;
                }
                if (activity.data.label !== (entry.name || entry.label)) {
                  activity.replan_errors.label = true;
                }
                if (activity.data.duration !== entry.duration) {
                  activity.replan_errors.duration = true;
                }
                updateLiberalGroups(activity.planning_data.caregivers, groups);
                if (liberalCount(activity.planning_data.caregivers) > 0) {
                  if (activity.data.type !== entry.type) {
                    activity.replan_errors.type = true;
                  }
                  if (activity.data.quantity !== entry.quantity) {
                    activity.replan_errors.quantity = true;
                  }
                } else {
                  activity.data.type = entry.type;
                  activity.data.quantity = entry.quantity;
                }
                ref3 = Object.keys(activity.planning_data.caregivers);
                for (m = 0, len4 = ref3.length; m < len4; m++) {
                  group_uid = ref3[m];
                  if ((notEmpty(entry.available_groups) && !_.includes(entry.available_groups, group_uid)) || !_.some(category.groups, function(group) {
                    return group.uid === group_uid;
                  })) {
                    if (activity.replan_errors.groups === void 0) {
                      activity.replan_errors.groups = {};
                    }
                    activity.replan_errors.groups[group_uid] = true;
                  }
                }
                if (!_.isEqual(notEmpty(activity.data.selected_features), notEmpty(entry.selectedFeatures))) {
                  activity.replan_errors.selected_features = true;
                }
                if (!_.isEmpty(activity.replan_errors)) {
                  activity.replan_entry = {
                    label: entry.name || entry.label,
                    duration: entry.duration,
                    type: entry.type,
                    quantity: entry.quantity,
                    selected_features: entry.selectedFeatures,
                    caregivers: _.pick(activity.planning_data.caregivers, notEmpty(entry.available_groups) || _.map(category.groups, 'uid'))
                  };
                }
              }
            }
          }
        }
      }
      ref4 = new_sequence.activities;
      results = [];
      for (n = 0, len5 = ref4.length; n < len5; n++) {
        activity = ref4[n];
        if (!activity.found) {
          activity.replan_warnings = {
            not_found: true
          };
        }
        activity.has_replan_errors = activity.replan_errors && Object.keys(activity.replan_errors).length > 0;
        results.push(activity.has_replan_warnings = activity.replan_warnings && Object.keys(activity.replan_warnings).length > 0);
      }
      return results;
    };
    reloadActivities = function(sequence) {
      return ThesaurusUtils.getCareCategories().promise.then(function(care_categories) {
        return GroupUtils.getAllGroups().then(function(groups) {
          return preselectActivities(care_categories, sequence, groups);
        });
      });
    };
    service = {
      updateAllDates: updateAllDates,
      updateTemplateDates: updateTemplateDates,
      reloadActivities: reloadActivities
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=replanification-utils.js.map

(function() {
  'use strict';
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').directive('sequencesPlanification', function() {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'sequences/views/sequences-edition.html';
        }
      },
      scope: {
        stay: "=",
        patient: "=",
        allStays: "="
      },
      controller: ["$rootScope", "$filter", "$scope", "$state", "$timeout", "$uibModal", "Sequence", "Activity", "Prescription", "ReplanUtils", "BillingUnitUtils", "PrescUtils", "$q", function($rootScope, $filter, $scope, $state, $timeout, $uibModal, Sequence, Activity, Prescription, ReplanUtils, BillingUnitUtils, PrescUtils, $q) {
        var baseActions, baseParams, checkSeqOnDates, computeDateStateForSequence, computeRescheduleActivities, filterActivityGroup, formatSequence, genSentenceDisplay, getNeedMLCount, handleDates, missionLettersDict, ref, selectStayModal;
        $scope.dateFormat = 'YYYY-MM-DD';
        $scope.currentDate = moment(new Date());
        $scope.currentDates = [];
        $scope.today = new Date();
        $scope.todayStr = moment($scope.today).format($scope.dateFormat);
        $scope.view = "week";
        $scope.sequenceDatesDict = {};
        $scope.getDay = function(dayStr) {
          return moment(dayStr).isoWeekday();
        };
        $scope.canReadTaks = indexOf.call($rootScope.user.group.features, "MHC_CARE_REALIZATION") >= 0;
        $scope.canCreateSequences = $rootScope.checkPermissions("MHC_CARE_CREATION", "CAN_WRITE");
        $scope.canReadMissionLetter = indexOf.call($rootScope.user.group.features, "MHC_MISSION_LETTER") >= 0;
        $scope.canCreateMissionLetter = $rootScope.checkPermissions("MHC_MISSION_LETTER", "CAN_WRITE");
        $scope.isActiveStay = (ref = $scope.stay.state) === 'PRE' || ref === 'ADM';
        $rootScope.user.userInputs = $rootScope.user.userInputs || {};
        $rootScope.user.userInputs.sequencesPlanification = $rootScope.user.userInputs.sequencesPlanification || {
          hidePosology: true
        };
        $scope.selectedActivities = [];
        $scope.showDetails = {};
        missionLettersDict = {};
        baseActions = [
          {
            label: $filter('translate')("New sequence"),
            type: "new_sequence",
            order: 1
          }, {
            label: $filter('translate')("Not applicable"),
            type: "not_applicable",
            order: 2
          }
        ];
        BillingUnitUtils.getCareBillingUnits().then(function(billing_units) {
          return $scope.careBu = _.keyBy(billing_units, 'id');
        });
        $scope.goToDate = function(currentDate) {
          $scope.currentDate = moment(currentDate);
          return handleDates();
        };
        $scope.shiftDate = function(days) {
          $scope.currentDate.add(days, "days");
          return handleDates();
        };
        $scope.changeView = function() {
          $scope.view = ($scope.view === "week" ? "month" : "week");
          return handleDates();
        };
        $scope.needToBeStopped = Activity.needToBeStopped;
        $scope.hasActivityToStop = function(sequence) {
          return _.some(sequence.activities, Activity.needToBeStopped);
        };
        $scope.hasActiveIssues = function(sequence) {
          return _.some(_.reject(_.reject(sequence.activities, "data.issue_stopped"), "data.reschedule_requested"), "issue");
        };
        $scope.checkStayActive = function(stayId) {
          var ref1, stay;
          if ($rootScope.currentPatientStays) {
            stay = _.find($rootScope.currentPatientStays, {
              id: stayId
            });
            return stay && ((ref1 = stay.state) === 'PRE' || ref1 === 'ADM');
          }
          return false;
        };
        $scope.getSequenceMLCount = function(sequence) {
          return _.reject(_.filter(sequence.allActivities, 'need_mission_letter'), 'current_mission_letter').length;
        };
        $scope.computeSequenceStatus = function(sequence) {
          return sequence.data.state || (sequence.end_date && moment(sequence.end_date) < moment() ? "finished" : void 0);
        };
        getNeedMLCount = function() {
          return _.sum(_.map(_.reject($scope.allSequences, {
            data: {
              state: "stopped"
            }
          }), $scope.getSequenceMLCount));
        };
        $scope.printSequences = function() {
          var scope;
          scope = $rootScope.$new();
          scope.startDate = $scope.currentDates[0];
          scope.endDate = $scope.currentDates[$scope.currentDates.length - 1];
          scope.startDateRequired = true;
          scope.endDateRequired = true;
          scope.title = "Select printing interval";
          return $uibModal.open({
            templateUrl: 'core/views/modal-date-interval.html',
            scope: scope
          }).result.then(function(dates) {
            var base_export_url, export_url;
            base_export_url = "/webfw/pat_mgr/export_as_pdf_with_period/" + $scope.stay.id + "/MHC_CARE_REALIZATION/";
            export_url = base_export_url + moment(dates.start_date).format('YYYYMMDD') + "/" + moment(dates.end_date).format('YYYYMMDD') + "/";
            return window.open(export_url, '_blank');
          });
        };
        $scope.selectSequence = function(activities, selectedAction) {
          if (selectedAction.type === "not_applicable") {
            return $uibModal.open({
              templateUrl: 'core/views/modal-comment.html'
            }).result.then(function(comment) {
              $rootScope.busy = true;
              return Activity.api.setNotApplicable({
                activities: _.map(activities, "id"),
                comment: comment
              }).$promise.then(function() {
                $scope.notApplicableActivities = _.concat($scope.notApplicableActivities, activities);
                _.forEach(activities, function(a) {
                  a.data.not_applicable = true;
                  a.data.not_applicable_comment = comment;
                  _.remove($scope.toBePlannedActivities, a);
                  return _.remove($scope.toRescheduleActivities, a);
                });
                $scope.selectedActivities = [];
                return $rootScope.busy = false;
              });
            });
          } else if (selectedAction.type === "new_sequence") {
            return $scope.editSequence(null, null, activities);
          } else {
            return $scope.editSequence(selectedAction.sequence, "edit", activities);
          }
        };
        $scope.getActivityCreationDate = function(activity) {
          var activity_group;
          activity_group = activity.activity_group;
          if (activity_group !== null) {
            return activity_group.created;
          }
          return activity.created;
        };
        filterActivityGroup = function(activities) {
          var groupedActivities;
          _.forEach(activities, function(a) {
            return a.consolidated_activity_group = a.activity_group ? a.activity_group.id : a.id;
          });
          groupedActivities = _.groupBy(activities, "consolidated_activity_group");
          return _.map(_.values(groupedActivities), function(activities_in_group) {
            return _.maxBy(activities_in_group, 'id');
          });
        };
        formatSequence = function(sequence, activities) {
          $scope.sequenceDatesDict[sequence.id] = {};
          sequence.realizedPunctualActivities = _.remove(activities, {
            planning_data: {
              status: "punctual"
            }
          });
          sequence.allActivities = activities;
          if (sequence.data.state === "stopped") {
            sequence.activities = filterActivityGroup(_.filter(activities, function(a) {
              return moment(a.stopped_date).add(1, 'days') >= moment(sequence.end_date);
            }));
          } else {
            sequence.activities = _.reject(activities, function(a) {
              return a.data.state === "stopped" || (!a.is_extra && a.end_date && a.end_date < (sequence.end_date || $scope.todayStr));
            });
          }
          return sequence;
        };
        $rootScope.busy = true;
        baseParams = $scope.allStays ? {
          patient: $scope.patient.id
        } : {
          stay: $scope.stay.id
        };
        Sequence.api.query(baseParams).$promise.then(function(sequences) {
          return Activity.api.query(_.extend({
            sequences: true
          }, baseParams)).$promise.then(function(activities) {
            return Activity.api.query(_.extend({
              to_be_planned: true
            }, baseParams)).$promise.then(function(toBePlannedActivities) {
              return PrescUtils.getCategories().promise.then(function(prescCategories) {
                return Prescription.query(_.extend({
                  pds_integration: true
                }, baseParams)).$promise.then(function(prescriptions) {
                  missionLettersDict = _.groupBy(_.filter(_.filter(activities, 'current_mission_letter'), 'need_mission_letter'), 'current_mission_letter');
                  _.forEach(prescriptions, function(p) {
                    return p.category = _.find(prescCategories, {
                      id: p.category
                    });
                  });
                  $scope.deletedPrescList = _.remove(prescriptions, {
                    state: "STOPPED"
                  });
                  $scope.newPrescList = prescriptions;
                  $scope.notApplicableActivities = _.remove(toBePlannedActivities, 'data.not_applicable');
                  $scope.toRescheduleActivities = _.remove(toBePlannedActivities, 'data.rescheduled');
                  $scope.toBePlannedActivities = toBePlannedActivities;
                  $scope.toBeStoppedActivities = _.filter(activities, Activity.needToBeStopped);
                  _.forEach(sequences, function(s) {
                    var ref1, ref2, ref3;
                    if (((ref1 = s.planning_data.timeslots) != null ? (ref2 = ref1[0]) != null ? (ref3 = ref2.start_time) != null ? ref3.length : void 0 : void 0 : void 0) === 4) {
                      return s.planning_data.timeslots[0].start_time = "0" + s.planning_data.timeslots[0].start_time;
                    }
                  });
                  $scope.allSequences = _.map(sequences, function(s) {
                    return formatSequence(s, _.filter(activities, {
                      sequence: s.id
                    }));
                  });
                  handleDates();
                  return $rootScope.busy = false;
                });
              });
            });
          });
        });
        selectStayModal = function(patient) {
          return $uibModal.open({
            templateUrl: 'core/views/select-stay-widget-modal.html',
            controller: 'selectStayWidget',
            resolve: {
              patient: patient,
              states: function() {
                return ["PRE", "ADM"];
              }
            }
          });
        };
        computeDateStateForSequence = function(sequence, formatedDate, view) {
          var p_data, ref1, state;
          state = {};
          p_data = sequence.planning_data;
          if (p_data.start_date <= formatedDate && (!sequence.end_date || sequence.end_date >= formatedDate)) {
            state["class"] = "enabled";
            if (p_data.type === "cycled") {
              if (moment(formatedDate).diff(moment(p_data.start_date), p_data.frequency_unit === "days" ? 'days' : "weeks") % p_data.frequency === 0) {
                if (p_data.frequency_unit === "days" || (ref1 = moment(formatedDate).weekday(), indexOf.call(p_data.week_days, ref1) >= 0)) {
                  state.display = genSentenceDisplay(sequence, view);
                }
              }
            } else {
              if (indexOf.call(p_data.dates, formatedDate) >= 0) {
                state.display = genSentenceDisplay(sequence, view);
              }
            }
          } else {
            state["class"] = "disabled ";
          }
          return state;
        };
        genSentenceDisplay = function(sequence, view) {
          if (view === "month") {
            return $filter('limitTo')(sequence.planning_data.timeslots[0].start_time, 2) + '<br>' + $filter('limitTo')(sequence.planning_data.timeslots[0].end_time, 2);
          } else {
            return sequence.planning_data.timeslots[0].start_time + ' - ' + sequence.planning_data.timeslots[0].end_time;
          }
        };
        checkSeqOnDates = function(seq, dates) {
          var ref1, ref2;
          return seq.planning_data.start_date <= dates[dates.length - 1] && (!seq.end_date || (((seq.planning_data.start_date <= (ref1 = seq.end_date) && ref1 >= dates[0])) || ((seq.end_date < (ref2 = seq.planning_data.start_date) && ref2 >= dates[0]))));
        };
        handleDates = function() {
          var currentDates, formatedDate, i, j, newDate, ref1, start;
          currentDates = [];
          start = moment($scope.currentDate.format($scope.dateFormat));
          $scope.startDate = moment(moment(start.date(start.date() - ($scope.view === "week" ? 3 : 13))).format($scope.dateFormat));
          for (i = j = 0, ref1 = ($scope.view === "week" ? 6 : 27); 0 <= ref1 ? j <= ref1 : j >= ref1; i = 0 <= ref1 ? ++j : --j) {
            newDate = moment($scope.startDate);
            newDate.add(i, "days");
            formatedDate = newDate.format($scope.dateFormat);
            currentDates.push(formatedDate);
            $scope.endDate = newDate;
            _.forEach($scope.allSequences, function(s) {
              $scope.sequenceDatesDict[s.id][formatedDate] = computeDateStateForSequence(s, formatedDate, $scope.view);
            });
          }
          $scope.sequences = _.filter($scope.allSequences, function(seq) {
            return checkSeqOnDates(seq, currentDates);
          });
          $scope.inFuturSequencesCount = _.filter(_.reject($scope.allSequences, {
            data: {
              state: "stopped"
            }
          }), function(seq) {
            return seq.planning_data.start_date > currentDates[currentDates.length - 1];
          }).length;
          $scope.availableActions = _.map(_.reject($scope.sequences, {
            data: {
              state: "stopped"
            }
          }), function(s) {
            return {
              label: s.data.name,
              sequence: s,
              type: "sequence",
              order: 0
            };
          }).concat(baseActions);
          $scope.currentDates = currentDates;
          return $scope.needMLCount = getNeedMLCount();
        };
        $scope.updatePdsHandled = function() {
          _.forEach(_.remove($scope.newPrescList, {
            pds_handled: true
          }), function(presc) {
            return Prescription.update({
              id: presc.id
            }, {
              pds_handled: true
            });
          });
          return _.forEach(_.remove($scope.deletedPrescList, {
            pds_handled: true
          }), function(presc) {
            return Prescription.update({
              id: presc.id
            }, {
              pds_handled: true
            });
          });
        };
        computeRescheduleActivities = function() {
          return Activity.api.query(_.extend({
            to_be_planned: true
          }, baseParams)).$promise.then(function(activities) {
            var toRescheduleActivitiesCurrentIds;
            toRescheduleActivitiesCurrentIds = _.map($scope.toRescheduleActivities, "id");
            return $scope.toRescheduleActivities = $scope.toRescheduleActivities.concat(_.filter(_.filter(activities, "data.rescheduled"), function(a) {
              var ref1;
              return ref1 = a.id, indexOf.call(toRescheduleActivitiesCurrentIds, ref1) < 0;
            }));
          });
        };
        $scope.computeDisplayText = function(sequence) {
          if (_.startsWith(sequence.planning_data.display_text, sequence.data.name)) {
            return sequence.planning_data.display_text;
          } else {
            return [sequence.data.name, _.upperFirst(sequence.planning_data.display_text.trim())].join(". ");
          }
        };
        $scope.stopSequence = function(sequence, rescheduleIssues) {
          var reason;
          $rootScope.busy = true;
          reason = $filter('translate')("SEQUENCE_STOP_REASON_MANUALLY_BY_USER");
          return Sequence.api.stop({
            id: sequence.id,
            reason: reason,
            reschedule_issues: rescheduleIssues
          }).$promise.then(function(updatedSequence) {
            return Activity.api.query({
              sequence: sequence.id
            }).$promise.then(function(activities) {
              var missionLettersIds;
              _.remove($scope.toBeStoppedActivities, {
                sequence: sequence.id
              });
              missionLettersIds = _.map(_.filter(_.filter(sequence.allActivities, 'current_mission_letter'), 'need_mission_letter'), "current_mission_letter");
              _.forEach(missionLettersIds, function(mlId) {
                _.forEach(missionLettersDict[mlId], function(a) {
                  return a.current_mission_letter = null;
                });
                return delete missionLettersDict[mlId];
              });
              _.remove($scope.allSequences, sequence);
              $scope.allSequences.push(formatSequence(updatedSequence, activities));
              handleDates();
              return $q.when(rescheduleIssues ? computeRescheduleActivities() : true).then(function() {
                return $rootScope.busy = false;
              });
            });
          });
        };
        $scope.stopActivity = function(activity, rescheduleIssue) {
          $rootScope.busy = true;
          return Activity.api.stop({
            id: activity.id,
            reschedule_issue: rescheduleIssue
          }).$promise.then(function(updatedActivity) {
            var sequence;
            _.remove($scope.toBeStoppedActivities, {
              id: activity.id
            });
            sequence = _.find($scope.allSequences, {
              id: updatedActivity.sequence
            });
            _.remove($scope.allSequences, sequence);
            $scope.allSequences.push(formatSequence(angular.copy(sequence), _.concat(_.reject(sequence.activities, activity), [updatedActivity])));
            _.forEach(missionLettersDict[activity.current_mission_letter], function(a) {
              return a.current_mission_letter = null;
            });
            delete missionLettersDict[activity.current_mission_letter];
            handleDates();
            return $q.when(rescheduleIssue ? computeRescheduleActivities() : true).then(function() {
              return $rootScope.busy = false;
            });
          });
        };
        $scope.editSequence = function(sequenceOriginal, action, extraActivities) {
          var sequenceToEdit;
          if (sequenceOriginal) {
            sequenceToEdit = _.cloneDeep(sequenceOriginal);
            delete sequenceToEdit.data.state;
            if (action === "copy" || action === "replanOnActiveStay") {
              sequenceToEdit = _.omit(sequenceToEdit, "id", "historical");
              ReplanUtils.updateTemplateDates({
                planning_data: {
                  start_date: moment().format($scope.dateFormat)
                }
              }, sequenceToEdit);
            } else {
              sequenceToEdit.historical.push(_.cloneDeep(sequenceToEdit.planning_data));
            }
            sequenceToEdit.activities = _.map(sequenceToEdit.activities, function(a) {
              delete a.data.state;
              if (action === "copy" || action === "replanOnActiveStay") {
                delete a.data.issue_stopped;
                return _.omit(a, "id", "current_mission_letter", "start_date", "historical");
              } else {
                a.historical.push(_.cloneDeep(a.planning_data));
                return a;
              }
            });
          } else {
            sequenceToEdit = {
              use_default_template: true,
              stay: $scope.stay.id,
              data: {},
              planning_data: {
                start_date: moment().format($scope.dateFormat)
              },
              activities: []
            };
          }
          sequenceToEdit.activities = _.concat(sequenceToEdit.activities, _.cloneDeep(extraActivities) || []);
          return ReplanUtils.reloadActivities(sequenceToEdit).then(function() {
            return $q.when(action === "replanOnActiveStay" ? selectStayModal($scope.patient).result : {
              id: sequenceToEdit.stay
            }).then(function(stay) {
              if (!stay) {
                return;
              }
              sequenceToEdit.stay = stay.id;
              return $uibModal.open({
                templateUrl: 'sequences/views/sequence-edition.html',
                controller: 'sequenceEditionCtrl',
                resolve: {
                  sequenceToEdit: sequenceToEdit
                },
                windowClass: 'modal-fullscreen',
                keyboard: false,
                backdrop: 'static'
              }).result.then(function(editedSequence) {
                var keepActivitiesIds, originalActiveActivities;
                $rootScope.busy = true;
                if (action === 'edit') {
                  keepActivitiesIds = _.map(_.filter(editedSequence.activities, "id"), "id");
                  originalActiveActivities = _.reject(sequenceOriginal.activities, {
                    data: {
                      state: "stopped"
                    }
                  });
                  editedSequence.stopped_activities = _.map(_.filter(originalActiveActivities, function(a) {
                    var ref1;
                    return ref1 = a.id, indexOf.call(keepActivitiesIds, ref1) < 0;
                  }), function(a) {
                    return {
                      id: a.id
                    };
                  });
                }
                return $q.when((editedSequence.id != null ? Sequence.api.update({
                  id: editedSequence.id
                }, _.omit(editedSequence, "allActivities")).$promise : Sequence.api.save(editedSequence).$promise).then(function(sequence) {
                  var missionLettersIds;
                  if (extraActivities) {
                    $scope.selectedActivities = [];
                  }
                  if (action === 'edit') {
                    _.remove($scope.allSequences, sequenceOriginal);
                    missionLettersIds = _.map(_.filter(_.filter(sequenceOriginal.allActivities, 'current_mission_letter'), 'need_mission_letter'), "current_mission_letter");
                    _.forEach(missionLettersIds, function(mlId) {
                      _.forEach(missionLettersDict[mlId], function(a) {
                        return a.current_mission_letter = null;
                      });
                      return delete missionLettersDict[mlId];
                    });
                  }
                  if (sequence.stay === $scope.stay.id || $scope.allStays) {
                    $scope.allSequences.push(sequence);
                  }
                  return Activity.api.query({
                    sequence: sequence.id
                  }).$promise.then(function(activities) {
                    var activitiesIds;
                    _.remove($scope.toBeStoppedActivities, {
                      sequence: sequence.id
                    });
                    $scope.toBeStoppedActivities = _.concat($scope.toBeStoppedActivities, _.filter(activities, Activity.needToBeStopped));
                    activitiesIds = _.map(activities, "id");
                    _.remove($scope.toBePlannedActivities, function(a) {
                      var ref1;
                      return ref1 = a.id, indexOf.call(activitiesIds, ref1) >= 0;
                    });
                    _.remove($scope.toRescheduleActivities, function(a) {
                      var ref1;
                      return ref1 = a.id, indexOf.call(activitiesIds, ref1) >= 0;
                    });
                    _.remove($scope.notApplicableActivities, function(a) {
                      var ref1;
                      return ref1 = a.id, indexOf.call(activitiesIds, ref1) >= 0;
                    });
                    formatSequence(sequence, activities);
                    handleDates();
                    return $rootScope.busy = false;
                  });
                }));
              });
            });
          });
        };
        return $scope.genMissionLetter = function() {
          var inOtherStaysCount, sameStayCount, sequences;
          if (!$scope.allStays) {
            return $state.go("user.patient.stay.taskplanner.mission_letter_create");
          } else {
            sequences = _.reject($scope.allSequences, {
              data: {
                state: "stopped"
              }
            });
            inOtherStaysCount = _.sum(_.map(_.reject(sequences, {
              stay: $scope.stay.id
            }), $scope.getSequenceMLCount));
            sameStayCount = _.sum(_.map(_.filter(sequences, {
              stay: $scope.stay.id
            }), $scope.getSequenceMLCount));
            if (sameStayCount === 0) {
              return $uibModal.open({
                animation: true,
                templateUrl: 'core/views/modal-template.html',
                size: "lg",
                controller: 'mhModalCtrl',
                resolve: {
                  title: function() {
                    return $filter('translate')("SHOW MISSION LETTERS");
                  },
                  text: function() {
                    return $filter('translate')("OTHER STAYS NEED MISSION LETTERS");
                  },
                  cancelButtonText: function() {
                    return $filter('translate')("CANCEL_BUTTON");
                  },
                  okButtonText: function() {
                    return '';
                  },
                  noButtonText: function() {
                    return '';
                  }
                }
              });
            } else if (inOtherStaysCount) {
              return $uibModal.open({
                animation: true,
                templateUrl: 'core/views/modal-template.html',
                size: "lg",
                controller: 'mhModalCtrl',
                resolve: {
                  title: function() {
                    return $filter('translate')("SHOW MISSION LETTERS");
                  },
                  text: function() {
                    return $filter('translate')("DO NOT TAKE ACCOUNT OF OTHER STAYS SEQUENCES");
                  },
                  cancelButtonText: function() {
                    return '';
                  },
                  okButtonText: function() {
                    return $filter('translate')("CONFIRM");
                  },
                  noButtonText: function() {
                    return '';
                  }
                }
              }).result.then(function(result) {
                if (result) {
                  return $state.go("user.patient.stay.taskplanner.mission_letter_create");
                }
              });
            } else {
              return $state.go("user.patient.stay.taskplanner.mission_letter_create");
            }
          }
        };
      }]
    };
  });

  angular.module('mhclientApp').controller('sequenceEditionCtrl', ["$scope", "$timeout", "$q", "$rootScope", "$filter", "$uibModal", "$uibModalInstance", "GroupUtils", "ReplanUtils", "ThesaurusUtils", "BillingUnitUtils", "SequenceTemplate", "sequenceToEdit", function($scope, $timeout, $q, $rootScope, $filter, $uibModal, $uibModalInstance, GroupUtils, ReplanUtils, ThesaurusUtils, BillingUnitUtils, SequenceTemplate, sequenceToEdit) {
    $scope.today = new Date();
    $scope.replanSequenceInActiveStay = function(sequence) {
      var activeStayId, staySelectionPromise;
      $rootScope.busy = true;
      staySelectionPromise = $q.defer();
      activeStayId = void 0;
      return selectStayModal($rootScope.currentPatient).result.then(function(stay) {
        if (stay) {
          activeStayId = stay.id;
          return staySelectionPromise.resolve();
        } else {
          return staySelectionPromise.reject();
        }
      });
    };
    $scope.sequenceTemplates = [];
    $scope.showTemplates = false;
    $scope.showTemplatesExtra = false;
    $scope.template = {};
    $scope.doNotBlink = true;
    $scope.blink = function() {
      $scope.doNotBlink = false;
      return $timeout(function() {
        return $scope.doNotBlink = true;
      }, 0);
    };
    $scope.handleSliderChange = function(form) {
      $scope.updatePosologySentence();
      return form.$setDirty();
    };
    $scope.toggleShowTemplates = function() {
      var defaultTemplate;
      if ($scope.sequenceTemplates.length === 0) {
        defaultTemplate = {
          template_name: $filter('translate')("DEFAULT_TEMPLATE_NAME"),
          "default": true,
          data: {
            estimated_times: []
          },
          planning_data: {
            frequency_unit: "days",
            timeslots: [
              {
                start_time: "11:00",
                end_time: "13:00"
              }
            ],
            type: "cycled"
          },
          activities: []
        };
        SequenceTemplate.api.save(defaultTemplate).$promise.then(function(savedTemplate) {
          $scope.sequenceTemplates.push(savedTemplate);
          if (!$scope.sequence.id) {
            return $scope.loadTemplate(savedTemplate.id);
          }
        });
      }
      return $scope.showTemplates = !$scope.showTemplates;
    };
    $scope.toggleShowTemplatesExtra = function() {
      return $scope.showTemplatesExtra = !$scope.showTemplatesExtra;
    };
    $scope.filterActivitiesForTemplate = function(activities) {
      return _.map(activities, function(activity) {
        return _.pick(activity, ['start_date', 'end_date', 'is_extra', 'data', 'planning_data', 'thesaurus_entry']);
      });
    };
    $scope.loadTemplate = function(template_id) {
      var template;
      template = _.find($scope.sequenceTemplates, {
        id: template_id
      });
      if (template) {
        ReplanUtils.updateTemplateDates($scope.sequence, template);
        $scope.template = _.clone(template);
        $scope.sequence.data = _.cloneDeep(template.data);
        $scope.sequence.data.template = $scope.template.id;
        $scope.sequence.planning_data = _.cloneDeep(template.planning_data);
        $scope.updatePosologySentence();
        $scope.sequence.activities = $scope.filterActivitiesForTemplate(template.activities);
        ReplanUtils.reloadActivities($scope.sequence);
        $scope.selectedSequenceTemplate = template.id;
        return $scope.blink();
      }
    };
    $scope.updateTemplate = function(template_id, template_name) {
      return SequenceTemplate.api.update({
        id: template_id,
        template_name: template_name,
        data: $scope.sequence.data,
        planning_data: $scope.sequence.planning_data,
        activities: $scope.filterActivitiesForTemplate($scope.sequence.activities)
      }).$promise.then(function(savedTemplate) {
        _.remove($scope.sequenceTemplates, {
          id: template_id
        });
        return $scope.sequenceTemplates.push(savedTemplate);
      });
    };
    $scope.newTemplate = function(template_name) {
      return SequenceTemplate.api.save({
        template_name: template_name,
        data: $scope.sequence.data,
        planning_data: $scope.sequence.planning_data,
        activities: $scope.filterActivitiesForTemplate($scope.sequence.activities)
      }).$promise.then(function(savedTemplate) {
        $scope.sequenceTemplates.push(savedTemplate);
        return $scope.loadTemplate(savedTemplate.id);
      });
    };
    $scope.canEraseTemplate = function(template_id) {
      if (_.find($scope.sequenceTemplates, {
        id: template_id
      })["default"] && $scope.sequenceTemplates.length > 1) {
        return false;
      }
      return true;
    };
    $scope.deleteTemplate = function(template_id) {
      if (!$scope.canEraseTemplate(template_id)) {
        return;
      }
      return SequenceTemplate.api["delete"]({
        id: template_id
      }).$promise.then(function() {
        return _.remove($scope.sequenceTemplates, {
          id: template_id
        });
      });
    };
    $scope.hasReplanErrors = function() {
      return _.some($scope.sequence.activities, function(activity) {
        return activity.has_replan_errors;
      }) || _.some($scope.sequence.activities, function(activity) {
        return activity.has_replan_warnings;
      });
    };
    $scope.ignoreWarnings = function(activity) {
      delete activity.replan_warnings;
      return activity.has_replan_warnings = false;
    };
    $scope.keepActivity = function(activity) {
      delete activity.replan_entry;
      delete activity.replan_errors;
      return activity.has_replan_errors = false;
    };
    $scope.reloadActivity = function(activity) {
      activity.data.label = activity.replan_entry.label;
      activity.data.short_name = activity.replan_entry.label;
      activity.data.duration = activity.replan_entry.duration;
      activity.data.type = activity.replan_entry.type;
      activity.data.quantity = activity.replan_entry.quantity;
      activity.planning_data.caregivers = _.cloneDeep(activity.replan_entry.caregivers);
      activity.data.selected_features = _.cloneDeep(activity.replan_entry.selected_features);
      delete activity.replan_entry;
      delete activity.replan_errors;
      return activity.has_replan_errors = false;
    };
    $scope.updatePosologySentence = function() {
      var error, error1;
      try {
        return $scope.sequence.planning_data.display_text = $filter("SequenceDisplayText")($scope.sequence);
      } catch (error1) {
        error = error1;
        return $scope.sequence.planning_data.display_text = $filter('translate')("CANT GENERATE POSOLOGY SENTENCE, MISSING FIELDS");
      }
    };
    BillingUnitUtils.getCareBillingUnits().then(function(billing_units) {
      return $scope.careBu = _.keyBy(billing_units, 'id');
    });
    $scope.defaultColors = ['rgb(38, 38, 38)', 'rgb(107, 34, 180)', 'rgb(58, 58, 58)', 'rgb(68, 68, 68)'];
    GroupUtils.getAllGroups().then(function(groups) {
      return ThesaurusUtils.getThesaurusCategories({
        type: "care"
      }, true, true).then(function(careCategories) {
        var careCategoriesIds;
        careCategoriesIds = _.map(careCategories, "id");
        return ThesaurusUtils.getThesaurusEntries((function(e) {
          var ref;
          return ref = e.category, indexOf.call(careCategoriesIds, ref) >= 0;
        }), true, true).then(function(careEntries) {
          return SequenceTemplate.api.query().$promise.then(function(templates) {
            var default_template;
            $scope.sequenceTemplates = templates;
            $scope.entriesByCategory = _.groupBy(careEntries, 'category');
            $scope.careEntries = careEntries;
            $scope.careCategories = _.filter($filter('orderBy')(careCategories, "data.order"), "active");
            $scope.userInput = {
              selectedCategory: $scope.careCategories[0]
            };
            $scope.groups = groups;
            $scope.sequence = sequenceToEdit;
            $scope.updatePosologySentence();
            if ($scope.sequence.use_default_template) {
              default_template = _.find($scope.sequenceTemplates, {
                "default": true
              });
              if (default_template) {
                return $scope.loadTemplate(default_template.id);
              }
            }
          });
        });
      });
    });
    $scope.toggleActivity = function(thesaurusActivity, entry, category) {
      if ($scope.isSelected(thesaurusActivity.uid)) {
        return _.remove($scope.sequence.activities, {
          data: {
            uid: thesaurusActivity.uid
          }
        });
      } else {
        return $scope.sequence.activities.push({
          planning_data: {
            caregivers: {}
          },
          thesaurus_entry: entry.id,
          data: {
            label: thesaurusActivity.name || thesaurusActivity.label,
            short_name: thesaurusActivity.name || thesaurusActivity.label,
            duration: thesaurusActivity.duration,
            type: thesaurusActivity.type,
            quantity: thesaurusActivity.quantity,
            uid: thesaurusActivity.uid,
            selected_features: thesaurusActivity.selectedFeatures
          }
        });
      }
    };
    $scope.isSelected = function(uid) {
      return indexOf.call(_.map($scope.sequence.activities, "data.uid"), uid) >= 0;
    };
    $scope.globalSelectablGroups = function() {
      return _.uniq([].concat.apply([], _.map($scope.sequence.activities, function(a) {
        return $scope.computeAvailableGroups(a);
      })));
    };
    $scope.computeAvailableGroups = function(activity, filterLiberal) {
      var categoryGroups, groupsIds, itemGroupsUid, thesaurusEntry;
      thesaurusEntry = _.find($scope.careEntries, {
        id: activity.thesaurus_entry
      });
      groupsIds = _.find($scope.careCategories, {
        id: thesaurusEntry.category
      }).groups;
      categoryGroups = _.filter($scope.groups, function(g) {
        var ref;
        return (!filterLiberal || (!g.liberal || activity.data.type)) && (ref = g.id, indexOf.call(groupsIds, ref) >= 0);
      });
      itemGroupsUid = _.filter((_.find(thesaurusEntry.entries, {
        uid: activity.data.uid
      }) || {}).available_groups || [], function(uid) {
        return indexOf.call(_.map(categoryGroups, "uid"), uid) >= 0;
      });
      if (itemGroupsUid.length > 0) {
        return _.filter($scope.groups, function(g) {
          var ref;
          return ref = g.uid, indexOf.call(itemGroupsUid, ref) >= 0;
        });
      }
      return categoryGroups;
    };
    $scope.AddCares = function(sequence, mode) {
      return $uibModal.open({
        templateUrl: 'sequences/views/activity-selection-modal.html',
        scope: $scope,
        backdrop: 'static'
      });
    };
    $scope.liberalCount = function(caregivers) {
      return _.sum(_.map(caregivers, function(groupDict, key) {
        if (groupDict.liberal) {
          return groupDict.count;
        } else {
          return 0;
        }
      }));
    };
    $scope.getInvolvedGroups = function(s) {
      return _.map(_.uniq([].concat.apply([], _.map(s.activities, function(a) {
        return Object.keys(a.planning_data.caregivers);
      }))), function(grpUid) {
        return _.find($scope.groups, {
          uid: grpUid
        });
      });
    };
    $scope.selectGroupGlobal = function(group) {
      return _.forEach($scope.sequence.activities, function(a) {
        if (indexOf.call($scope.computeAvailableGroups(a, true), group) >= 0) {
          a.planning_data.caregivers[group.uid] = a.planning_data.caregivers[group.uid] || {
            count: 0,
            group_name: group.name,
            liberal: group.liberal
          };
          return a.planning_data.caregivers[group.uid].count += 1;
        }
      });
    };
    $scope.initExtraActivity = function(activity, sequence) {
      if (activity.is_extra && (activity.planning_data.type == null)) {
        return activity.planning_data = _.defaults({
          caregivers: activity.planning_data.caregivers
        }, sequence.planning_data);
      }
    };
    $scope.computeStartAndEndDate = function(p_data) {
      if (p_data.type === "dates") {
        p_data.start_date = p_data.dates.sort()[0];
      }
      if (p_data.type === "dates") {
        return p_data.end_date = p_data.dates.sort()[p_data.dates.length - 1];
      } else if (p_data.end_mode === "duration") {
        return p_data.end_date = moment(p_data.start_date).add(p_data.duration, 'day').format("YYYY-MM-DD");
      } else if (p_data.end_mode === "date") {
        return {};
      } else {
        return p_data.end_date = null;
      }
    };
    return $scope.acceptModifications = function() {
      var activity, error, error1, groupInfo, grpUid, i, j, k, l, len, len1, len2, m, p_data, programmedTimes, ref, ref1, ref2, ref3, sequence, start_day;
      p_data = $scope.sequence.planning_data;
      p_data.timestamp = new Date();
      $scope.computeStartAndEndDate(p_data);
      if (($scope.sequence.start_date == null) || $scope.sequence.start_date > p_data.start_date) {
        $scope.sequence.start_date = p_data.start_date;
      }
      $scope.sequence.end_date = p_data.end_date;
      programmedTimes = {};
      sequence = $scope.sequence;
      ref = $scope.sequence.activities;
      for (j = 0, len = ref.length; j < len; j++) {
        activity = ref[j];
        activity.data.timestamp = p_data.timestamp;
        activity.data.short_name = activity.data.label || activity.data.short_name;
        if (!activity.is_extra) {
          activity.planning_data = _.defaults({
            caregivers: activity.planning_data.caregivers
          }, p_data);
          activity.start_date = p_data.start_date;
          activity.end_date = p_data.end_date;
        } else {
          if (activity.planning_data.type === 'floating') {
            activity.planning_data.frequency_unit = "weeks";
            activity.planning_data.frequency = 1;
            start_day = (moment(activity.planning_data.start_date).day() + 6) % 7;
            activity.planning_data.week_days = [];
            for (i = k = 0, ref1 = activity.planning_data.quantity; 0 <= ref1 ? k < ref1 : k > ref1; i = 0 <= ref1 ? ++k : --k) {
              activity.planning_data.week_days.push((start_day + i) % 7);
            }
          }
          activity.planning_data.timeslots = p_data.timeslots;
          $scope.computeStartAndEndDate(activity.planning_data);
          activity.start_date = activity.planning_data.start_date;
          activity.end_date = activity.planning_data.end_date;
          if (!activity.data.name && activity.data.label) {
            activity.data.name = activity.data.label;
          }
          try {
            activity.planning_data.display_text = $filter("SequenceDisplayText")(activity);
          } catch (error1) {
            error = error1;
            activity.planning_data.display_text = $filter('translate')("CANT GENERATE POSOLOGY SENTENCE, MISSING FIELDS");
          }
        }
        activity.stay = sequence.stay;
        activity.planning_data.has_liberal = activity.need_mission_letter = _.some(activity.planning_data.caregivers, 'liberal');
        ref2 = Object.keys(activity.planning_data.caregivers);
        for (l = 0, len1 = ref2.length; l < len1; l++) {
          grpUid = ref2[l];
          if (programmedTimes[grpUid] === void 0) {
            programmedTimes[grpUid] = 0;
          }
          programmedTimes[grpUid] += activity.data.duration;
        }
      }
      ref3 = $scope.sequence.data.estimated_times;
      for (m = 0, len2 = ref3.length; m < len2; m++) {
        groupInfo = ref3[m];
        groupInfo['programmedValue'] = programmedTimes[groupInfo['grp_uid']];
      }
      return $uibModalInstance.close($scope.sequence);
    };
  }]);

  angular.module('mhclientApp').directive('sequenceActivity', function() {
    return {
      scope: {
        activity: "="
      },
      restrict: 'E',
      transclude: true,
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'sequences/views/sequence-activity.html';
        }
      },
      controller: ["$scope", "Activity", "BillingUnitUtils", function($scope, Activity, BillingUnitUtils) {
        $scope.needToBeStopped = Activity.needToBeStopped;
        return BillingUnitUtils.getCareBillingUnits().then(function(billing_units) {
          return $scope.careBu = _.keyBy(billing_units, 'id');
        });
      }]
    };
  });

  angular.module('mhclientApp').filter('sequenceActionsFilter', function() {
    return function(actions, selectedActivities) {
      return (_.find(selectedActivities, "data.not_applicable") ? _.reject(actions, {
        type: "not_applicable"
      }) : actions || []);
    };
  });

  angular.module('mhclientApp').filter('endWhitDot', function() {
    return function(text) {
      if (text.endsWith('.')) {
        return text;
      } else {
        return text + ".";
      }
    };
  });

  angular.module('mhclientApp').filter('genActivityDisplay', ["$filter", function($filter) {
    return function(activity) {
      var display, items, ref;
      if (activity.sequence) {
        items = ["<b>" + _.capitalize($filter("endWhitDot")(activity.data.label)) + "<b>"];
        if (((ref = activity.data.comment) != null ? ref.length : void 0) > 0) {
          items.push(_.capitalize($filter("endWhitDot")(activity.data.comment)));
        }
        return items.join(" ");
      } else {
        display = "<i> Début: " + ($filter('date')(activity.start_date, "shortDate")) + ". " + (activity.data.original_issue_event.posology || '') + "</i> <b>" + (_.capitalize(activity.data.label)) + ".</b> " + (activity.data.original_issue_event.comment || '');
        if (activity.data.not_applicable_comment) {
          display = display + " - " + _.capitalize(activity.data.not_applicable_comment);
        }
        return display;
      }
    };
  }]);

  angular.module('mhclientApp').filter('sequenceFilter', function() {
    return function(entries, searchText, showStopped) {
      var checkEntry, regex;
      if (!showStopped) {
        entries = _.reject(entries, {
          data: {
            state: "stopped"
          }
        });
      }
      regex = (searchText != null) && searchText.length > 0 ? new RegExp('' + searchText.replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i') : false;
      checkEntry = function(entry) {
        return !regex || regex.test(entry.data.name) || _.some(entry.activities, function(a) {
          return regex.test(a.data.short_name);
        });
      };
      return _.filter(entries, checkEntry);
    };
  });

  angular.module('mhclientApp').filter('activityFilter', function() {
    return function(entries, searchText) {
      var checkEntry, regex;
      if (!showStopped) {
        entries = _.reject(entries, {
          data: {
            state: "stopped"
          }
        });
      }
      regex = (searchText != null) && searchText.length > 0 ? new RegExp('' + searchText.replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i') : false;
      checkEntry = function(entry) {
        return !regex || regex.test(entry.data.name) || _.some(entry.activities, function(a) {
          return regex.test(a.data.short_name);
        });
      };
      return _.filter(entries, checkEntry);
    };
  });

  angular.module('mhclientApp').filter('moment', function() {
    return function(date, format) {
      if (date != null) {
        return moment(date).format(format);
      } else {
        return '';
      }
    };
  });

  angular.module('mhclientApp').filter('capitalize', function() {
    return function(text) {
      return _.upperFirst(text);
    };
  });

}).call(this);

//# sourceMappingURL=sequences-planification-directive.js.map

(function() {
  'use strict';
  angular.module('mhclientApp').directive('relatedFeatures', function() {
    return {
      scope: {
        activity: "="
      },
      controller: ["$rootScope", "$scope", "FeatureUtils", function($rootScope, $scope, FeatureUtils) {
        return $scope.fetchFeatures = function() {
          FeatureUtils.getAllFeatures(true).then(function(features) {
            return _.forEach($scope.activity.data.selected_features, function(action) {
              var ref;
              return action.iconname = (ref = _.find(features, {
                name: action.feature
              })) != null ? ref.metadata.iconname : void 0;
            });
          });
          return $scope.init = true;
        };
      }],
      restrict: 'E',
      template: '<script type="text/ng-template" id="related-features.html"> <div ng-init="init || fetchFeatures()"> <div ng-repeat="feature in activity.data.selected_features"> <span ng-if="::feature.iconname" class="mhico-{{::feature.iconname}}"></span> <b>{{:: feature.displayLabel || feature.name }}</b><span ng-if="::feature.selectedLabel">: {{::feature.selectedLabel}}</span> </div> </div> </script> <span uib-popover-template="\'related-features.html\'" role="button" popover-placement="auto" popover-append-to-body="true" popover-trigger="\'outsideClick mouseenter mouseleave\'" popover-title="{{\'Associated features\' | translate}}"  class="glyphicon glyphicon-folder-open"> </span>'
    };
  });

  angular.module('mhclientApp').directive('pspShortcut', ["$rootScope", "$q", "Psp", "HealthIssue", "Activity", "ThesaurusUtils", "$timeout", function($rootScope, $q, Psp, HealthIssue, Activity, ThesaurusUtils, $timeout) {
    return {
      scope: {
        activity: "=",
        issueId: "=?",
        issue: "=?",
        toBeStopped: "=?",
        placement: "@"
      },
      link: function(scope, element, attrs) {
        var leaved, timer;
        timer = false;
        leaved = false;
        scope.toBeStopped = Activity.needToBeStopped(scope.activity);
        element.on('mouseleave', function() {
          leaved = true;
          return $timeout.cancel(timer);
        });
        return element.on('mouseenter', function() {
          if ($rootScope.mh_config.platform !== 'mhsi' || scope.initOnce) {
            return;
          }
          scope.initOnce = true;
          scope.placement = scope.placement || "auto";
          return $q.when(scope.issue || HealthIssue.api.get({
            "id": scope.issueId
          }).$promise).then(function(issue) {
            return ThesaurusUtils.getThesaurusCategories({}, true, true).then(function(relatedCategories) {
              return Psp.api.get({
                "id": issue.psp
              }).$promise.then(function(psp) {
                return Activity.api.query({
                  "issue": issue.id
                }).$promise.then(function(activities) {
                  scope.objetive = _.find(psp.objectives, {
                    thesaurus_uid: issue.objective_uid
                  });
                  scope.pt = _.find(psp.therapeutic_programs, {
                    thesaurus_uid: issue.tp_uid
                  });
                  scope.issueLabel = issue.label;
                  scope.activities = activities;
                  _.forEach(activities, function(a) {
                    a.toBeStopped = Activity.needToBeStopped(a);
                  });
                  return timer = $timeout(function() {
                    if (!leaved) {
                      return element.find('#psp-shortcut').triggerHandler('mouseenter');
                    }
                  });
                });
              });
            });
          });
        });
      },
      restrict: 'E',
      template: '<script type="text/ng-template" id="psp-shortcut.html"> <div class="panel panel-default"> <div class="panel-heading">{{::pt.label}}</div> <div class="panel-body"> <div class="panel panel-default"> <div class="panel-heading">{{::objetive.label}}</div> <div class="panel-body"> <div class="panel panel-default"> <div class="panel-heading">{{::issueLabel}}</div> <div class="panel-body"> <div ng-class=":: [issueActivity.toBeStopped? \'text-danger\' : \'text-success\', issueActivity.id == activity.id ? \'font-bold\': \'\']" ng-repeat="issueActivity in ::activities" class="panel-heading"> <span ng-bind-html=":: issueActivity | genActivityDisplay"></span> </div> </div> </div> </div> </div> </div> </div> </script> <span role="button" id="psp-shortcut" uib-popover-template="\'psp-shortcut.html\'" popover-append-to-body="true" popover-enable="::pt" popover-class="psp-shortcut" popover-placement="{{::placement}}" class="glyphicon mhico-accessibility" ng-class=":: activity.data.reschedule_requested ? \'text-info\' : (toBeStopped? \'text-danger\' : \'text-success\')" popover-trigger="\'outsideClick mouseenter mouseleave\'" popover-title="{{:: toBeStopped? \'Personalized care plan to stop\' : \'Personalized care project\' | translate}}"> </span>'
    };
  }]);

}).call(this);

//# sourceMappingURL=related-features-directive.js.map

angular
  .module("mhclientApp")
  .controller(
    "PunctualActivityRefusalConfirmationModalCtrl",
    PunctualActivityRefusalConfirmationModalCtrl
  );

function PunctualActivityRefusalConfirmationModalCtrl(
  $scope,
  $uibModalInstance
) {
  $scope.reason = "";

  $scope.handleSubmit = handleSubmit;

  function handleSubmit() {
    $uibModalInstance.close($scope.reason);
  }
}

angular.module("mhclientApp").component("taskplannerTaskButton", {
  templateUrl: "taskplanner/views/task-button.html",
  controller: taskPlannerTaskButtonController,
  bindings: { task: "<", onClick: "&" },
});

function taskPlannerTaskButtonController($scope) {
  $scope.getClassFromStatus = getClassFromStatus;

  function getClassFromStatus(status) {
    if (status === "P") {
      return "task-todo";
    }
    if (status === "R") {
      return "task-good";
    }
    if (status === "N" || status === "refused") {
      return "task-bad";
    }
    if (status === "L") {
      return "task-locked";
    }
    if (status === "punctual") {
      return "task-punctual";
    }

    console.error("Status not supported", status);

    return undefined;
  }
}

(function() {
  'use strict';
  angular.module("mhclientApp").factory('Activity', ["$resource", "MhConfig", "BoxResource", "Task", "$filter", function($resource, MhConfig, BoxResource, Task, $filter) {
    var acceptHeader, activity_api, addGroup, api, format, needToBeStopped, portailAPI, removeGroup, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/activity/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'setNotApplicable': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'set_not_applicable'
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        method: 'PUT',
        headers: {
          'Accept': acceptHeader
        }
      },
      'stop': {
        method: 'POST',
        params: {
          route: 'stop_activity',
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'createNextTask': {
        method: 'POST',
        isArray: true,
        params: {
          route: 'create_next_task',
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        activity_api = window.mgapp.get('taskplanner').activity();
        api = BoxResource.generate(activity_api);
        api.stop = function(object) {
          return BoxResource.mhboxApiCall(activity_api, "stop_care", object);
        };
        api.createNextTask = function(object) {
          return BoxResource.mhboxApiCall(activity_api, "create_next_task", object);
        };
        break;
      default:
        api = portailAPI;
    }
    format = function(cares) {
      var care, i, len;
      for (i = 0, len = cares.length; i < len; i++) {
        care = cares[i];
        care.formatedTasks = Task.format(care.tasks);
        care.formatedStartDate = $filter('date')(care.start_date, 'shortDate');
      }
      return cares;
    };
    addGroup = function(care_item, group_id, group_name, liberal) {
      if (care_item.planning_data.caregivers[group_id] != null) {
        return care_item.planning_data.caregivers[group_id].count += 1;
      } else {
        care_item.planning_data.caregivers[group_id] = {
          count: 1,
          group_name: group_name,
          liberal: liberal
        };
        care_item.group_selected = null;
        care_item.validation_groups.push(group_id);
        return care_item.planning_data.has_liberal = _.some(care_item.planning_data.caregivers, ['liberal', true]);
      }
    };
    removeGroup = function(care_item, group_id, group_dict) {
      if (group_dict.count === 1) {
        delete care_item.planning_data.caregivers[group_id];
        care_item.validation_groups.splice(care_item.validation_groups.indexOf(group_id), 1);
        return care_item.planning_data.has_liberal = _.some(care_item.planning_data.caregivers, ['liberal', true]);
      } else {
        return group_dict.count -= 1;
      }
    };
    needToBeStopped = function(activity) {
      return activity.data.issue_stopped && activity.data.state !== 'stopped' && (!activity.end_date || moment(activity.end_date) > moment());
    };
    service = {
      api: api,
      format: format,
      addGroup: addGroup,
      removeGroup: removeGroup,
      needToBeStopped: needToBeStopped
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('MissionLetterTemplate', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    return $resource('/api_rest/mission_letter_templates/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'getDefault': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_default'
        }
      },
      'setDefault': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'set_default',
          id: '@id'
        }
      }
    });
  }]);

  angular.module("mhclientApp").factory('MissionLetter', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, mission_letter_api, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/mission_letters/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update_involved_users': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          route: 'update_involved_users',
          id: '@id'
        }
      },
      'archive': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST',
        params: {
          route: 'archive',
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        mission_letter_api = window.mgapp.get('taskplanner').mission_letter();
        api = BoxResource.generate(mission_letter_api);
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('Sequence', ["$resource", "MhConfig", "BoxResource", "$q", "$timeout", function($resource, MhConfig, BoxResource, $q, $timeout) {
    var acceptHeader, api, portailAPI, sequence_api, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/sequences/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'stop': {
        method: 'POST',
        params: {
          route: 'stop_sequence',
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'addPunctualActivity': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id',
          route: 'add_punctual_activity'
        }
      },
      'validatePunctualActivity': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id',
          route: 'punctual_activity/validate'
        }
      },
      'refusePunctualActivity': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id',
          route: 'punctual_activity/refuse'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        sequence_api = window.mgapp.get('taskplanner').sequence();
        api = BoxResource.generate(sequence_api);
        api.stop = function(object) {
          return BoxResource.mhboxApiCall(sequence_api, "stop_sequence", object);
        };
        api.addPunctualActivity = function(object, data) {
          var promise, result;
          result = {};
          promise = $q.defer();
          result.$promise = promise.promise;
          $timeout(function() {
            return promise.resolve(angular.fromJson(sequence_api["add_punctual_activity"](object.id, angular.toJson(data))));
          });
          return result;
        };
        api.validatePunctualActivity = function(object, data) {
          var promise, result;
          result = {};
          promise = $q.defer();
          result.$promise = promise.promise;
          $timeout(function() {
            return promise.resolve(angular.fromJson(sequence_api["validate_punctual_activity"](object.id, angular.toJson(data))));
          });
          return result;
        };
        api.refusePunctualActivity = function(object, data) {
          var promise, result;
          result = {};
          promise = $q.defer();
          result.$promise = promise.promise;
          $timeout(function() {
            return promise.resolve(angular.fromJson(sequence_api["refuse_punctual_activity"](object.id, angular.toJson(data))));
          });
          return result;
        };
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('AgendaTask', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, agenda_task, api, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/agenda_tasks/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'updateTasks': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'update_tasks'
        },
        method: 'PATCH',
        isArray: MhConfig.platform === 'mhsi' ? true : false
      },
      'deleteTasks': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'delete_tasks'
        },
        method: 'PATCH'
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        method: 'PUT',
        headers: {
          'Accept': acceptHeader
        }
      },
      'delete': {
        method: 'DELETE',
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        agenda_task = window.mgapp.get('taskplanner').agenda_task();
        api = BoxResource.generate(agenda_task);
        api.updateTasks = function(object) {
          return BoxResource.mhboxApiCall(agenda_task, "update_tasks", object);
        };
        api.deleteTasks = function(object) {
          return BoxResource.mhboxApiCall(agenda_task, "delete_tasks", object);
        };
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('SequencesUtils', ["$q", "Sequence", "Activity", "Task", "SiteVarsUtils", "DateUtils", "moment", function($q, Sequence, Activity, Task, SiteVarsUtils, DateUtils, moment) {
    var getSequences, service;
    getSequences = function(stay, user, groupInvolved, startDate, endDate, addPunctualActivities, selected_task_dict, patient) {
      var activities_dict, missingActivitiesPromises, missingSequencesPromises, sequencesPromise, sequences_dict;
      sequencesPromise = $q.defer();
      sequences_dict = {};
      activities_dict = {};
      missingActivitiesPromises = [];
      missingSequencesPromises = [];
      SiteVarsUtils.get("DELAY_BEFORE_TASKS_LOCKING").then(function(sitevar) {
        var activityParams, lockingDelay, sequenceParams, taskParams;
        lockingDelay = sitevar.value;
        sequenceParams = {
          start_date: startDate,
          end_date: endDate
        };
        activityParams = {
          start_date: startDate,
          end_date: endDate,
          sequences: true
        };
        taskParams = {
          start_date: startDate,
          end_date: endDate,
          sequences: true,
          group_involved: groupInvolved
        };
        if (patient) {
          sequenceParams.patient = patient.id;
          activityParams.patient = patient.id;
          taskParams.patient = patient.id;
        } else {
          sequenceParams.stay = stay.id;
          activityParams.stay = stay.id;
          taskParams.stay = stay.id;
        }
        return Sequence.api.query(sequenceParams).$promise.then(function(sequences) {
          return Activity.api.query(activityParams).$promise.then(function(activities) {
            return Task.api.query(taskParams).$promise.then(function(tasks) {
              var activity, i, j, k, len, len1, len2, sequence, task;
              for (i = 0, len = sequences.length; i < len; i++) {
                sequence = sequences[i];
                sequences_dict[sequence.id] = sequence;
                sequence.activities = [];
                sequence.dates = null;
              }
              for (j = 0, len1 = activities.length; j < len1; j++) {
                activity = activities[j];
                activities_dict[activity.id] = activity;
              }
              for (k = 0, len2 = tasks.length; k < len2; k++) {
                task = tasks[k];
                if (task.data.type === 'floating' && task.status === 'P' && DateUtils.isThisWeek(task.date)) {
                  task.date = moment().format('YYYY-MM-DD');
                }
                if (lockingDelay) {
                  if (task.data.type === 'floating') {
                    if (DateUtils.weeksBetween(task.date, moment().subtract(lockingDelay, 'days')) > 0) {
                      if (task.status === 'P') {
                        task.status = 'L';
                      }
                    }
                  } else {
                    if (moment(task.date) < moment().subtract(lockingDelay, 'days')) {
                      if (task.status === 'P') {
                        task.status = 'L';
                      }
                    }
                  }
                }
                if (!(task.activity in activities_dict)) {
                  missingActivitiesPromises.push(Activity.api.get({
                    id: task.activity
                  }).$promise);
                } else {
                  if (!(activities_dict[task.activity].sequence in sequences_dict)) {
                    missingSequencesPromises.push(Sequence.api.get({
                      id: activities_dict[task.activity].sequence
                    }).$promise);
                  }
                }
              }
              return $q.all(missingActivitiesPromises).then(function(missingActivities) {
                var l, len3;
                for (l = 0, len3 = missingActivities.length; l < len3; l++) {
                  activity = missingActivities[l];
                  activities_dict[activity.id] = activity;
                  activities.push(activity);
                  if (!(activity.sequence in sequences_dict)) {
                    missingSequencesPromises.push(Sequence.api.get({
                      id: activity.sequence
                    }).$promise);
                  }
                }
                return $q.all(missingSequencesPromises).then(function(missingSequences) {
                  var len4, len5, len6, len7, len8, m, n, o, p, punctual_activity_dict, q, ref, s, sequences_with_tasks;
                  for (m = 0, len4 = missingSequences.length; m < len4; m++) {
                    sequence = missingSequences[m];
                    sequences.push(sequence);
                    sequences_dict[sequence.id] = sequence;
                    sequence.activities = [];
                    sequence.dates = null;
                  }
                  for (n = 0, len5 = tasks.length; n < len5; n++) {
                    task = tasks[n];
                    if (selected_task_dict && (selected_task_dict[task.id] != null)) {
                      task = selected_task_dict[task.id];
                      if (!(typeof task.activity === 'number')) {
                        task.activity = task.activity.id;
                      }
                    }
                    sequence = sequences_dict[activities_dict[task.activity].sequence];
                    if (!sequence.dates) {
                      sequence.dates = {};
                    }
                    if (!sequence.dates[task.date]) {
                      sequence.dates[task.date] = {
                        "tasks": {},
                        "interval": task.data.start_time + "-" + task.data.end_time
                      };
                    }
                    if (!sequence.dates[task.date]["tasks"][task.activity]) {
                      sequence.dates[task.date]["tasks"][task.activity] = [];
                    }
                    sequence.dates[task.date]["tasks"][task.activity].push(task);
                    task.activity = activities_dict[task.activity];
                    task.activity.has_tasks = true;
                  }
                  if (addPunctualActivities) {
                    for (o = 0, len6 = sequences.length; o < len6; o++) {
                      sequence = sequences[o];
                      ref = sequence.punctual_activities;
                      for (p = 0, len7 = ref.length; p < len7; p++) {
                        punctual_activity_dict = ref[p];
                        addPunctualActivities(sequence, punctual_activity_dict);
                      }
                    }
                  }
                  for (q = 0, len8 = activities.length; q < len8; q++) {
                    activity = activities[q];
                    if (activity.has_tasks) {
                      sequences_dict[activity.sequence].activities.push(activity);
                    }
                  }
                  sequences_with_tasks = (function() {
                    var len9, r, results;
                    results = [];
                    for (r = 0, len9 = sequences.length; r < len9; r++) {
                      s = sequences[r];
                      if (s.dates) {
                        results.push(s);
                      }
                    }
                    return results;
                  })();
                  return sequencesPromise.resolve(sequences_with_tasks);
                });
              });
            });
          });
        });
      });
      return sequencesPromise.promise;
    };
    service = {
      getSequences: getSequences
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('SequenceRealization', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, portailAPI, sequence_realization, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/sequence_realization/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'hasActiveSequenceRealization': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'has_active_sequence_realization'
        },
        method: 'GET'
      },
      'closeSequenceRealization': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'close_sequence_realization'
        },
        method: 'POST'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        sequence_realization = window.mgapp.get('taskplanner').sequence_realization();
        api = BoxResource.generate(sequence_realization);
        api.hasActiveSequenceRealization = function(object) {
          return BoxResource.mhboxApiCall(sequence_realization, "has_active_sequence_realization", object);
        };
        api.closeSequenceRealization = function(object) {
          return BoxResource.mhboxApiCall(sequence_realization, "close_sequence_realization", object);
        };
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('SequenceTemplate', ["$resource", "MhConfig", function($resource, MhConfig) {
    var acceptHeader, api, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    api = $resource('/api_rest/sequence_templates/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'delete': {
        method: 'DELETE',
        params: {
          id: '@id'
        },
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    service = {
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=taskplanner-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:ActivityCtrl
    * @description
    * # ActivityCtrl
    * Controller of Activity
   */
  angular.module('mhclientApp').controller('ActivityCtrl', ["$scope", "$rootScope", "$state", "Activity", "ThesaurusUtils", "MhConfig", "GroupUtils", "$q", "$window", function($scope, $rootScope, $state, Activity, ThesaurusUtils, MhConfig, GroupUtils, $q, $window) {
    var displayConfirmModal, extract_selectable_items, i, index, init, len, ref, saveActivities, week_day;
    $scope.start_level = 0;
    $scope.selected_cares = [];
    $scope.time_slots = [];
    $scope.thesaurus_selectable_list = [];
    $scope.week_days = [];
    $scope.global_selected_groups = {};
    init = function() {
      $rootScope.busy = true;
      $scope.canWrite = $rootScope.checkPermissions("MHC_CARE_CREATION", "CAN_WRITE") && $rootScope.checkPermissions("MHC_CARE_REALIZATION", "CAN_WRITE");
      $scope.base_slider_option = {
        translate: function(minutes) {
          return $scope.time_str_from_minuts(minutes) + "H";
        },
        step: 15,
        hideLimitLabels: true,
        "floor": 0,
        "ceil": 1440
      };
      $scope.current_screen = "care_selection";
      $scope.addTimeSlot($scope.time_slots);
      $scope.changeThesaurusChoice('patient_agenda');
      $scope.agendaCategories = [];
      ThesaurusUtils.getAgendaCategories().promise.then(function(agendaCategories) {
        return $scope.agendaCategories = agendaCategories;
      });
      return $scope.placeOptions = ThesaurusUtils.getPlaceOptions();
    };
    $scope.changeThesaurusChoice = function(thesaurusCode) {
      $scope.thesaurusCode = thesaurusCode;
      $scope.selectedCategory = _.find($scope.agendaCategories, {
        code: thesaurusCode
      });
      return ThesaurusUtils.getThesaurusCategories({
        code: $scope.thesaurusCode
      }).then(function(thesaurus_category) {
        return GroupUtils.getAllGroups().then(function(groups) {
          $scope.thesaurus_category = thesaurus_category;
          $scope.global_selectable_groups = _.map($scope.thesaurus_category.groups, function(groupId) {
            return _.find(groups, {
              id: groupId
            });
          });
          if ($scope.thesaurus_category.code === "care") {
            $scope.next_state = MhConfig.platform === "mhsi" ? 'user.patient.stay.taskplanner.week' : 'user.patient.stay.taskplanner.today';
          } else if ($scope.thesaurus_category.code === "patient_agenda") {
            $scope.next_state = 'user.patient.stay.agenda';
          }
          $scope.planning_data = {
            frequency_unit: "days",
            week_days: [],
            end_mode: "duration",
            start_date: new Date(),
            type: $scope.thesaurus_category.code === "care" ? "cycled" : "dates",
            timeslots: [],
            dates: [],
            source: MhConfig.platform
          };
          $scope.$watch('planning_data.start_date', function(start_date) {
            if ($scope.planning_data.end_date && start_date >= $scope.planning_data.end_date) {
              return $scope.planning_data.end_date = null;
            }
          });
          return ThesaurusUtils.getThesaurusEntries({
            "category": $scope.thesaurus_category.id
          }, true).then(function(thesaurus_entries) {
            var already_in_selectable_groups, child_item, i, j, len, len1, ref, thesaurus_entry;
            already_in_selectable_groups = [];
            for (i = 0, len = thesaurus_entries.length; i < len; i++) {
              thesaurus_entry = thesaurus_entries[i];
              thesaurus_entry.level = 0;
              thesaurus_entry.active = true;
              thesaurus_entry.hide = false;
              thesaurus_entry.validation_groups = $scope.global_selectable_groups;
              ref = thesaurus_entry.entries;
              for (j = 0, len1 = ref.length; j < len1; j++) {
                child_item = ref[j];
                extract_selectable_items($scope.thesaurus_selectable_list, child_item, thesaurus_entry.level + 1, thesaurus_entry);
              }
            }
            $scope.thesaurus_tree = thesaurus_entries;
            $scope.entriesByCategory = _.groupBy(thesaurus_entries, 'category');
            return $rootScope.busy = false;
          });
        });
      });
    };
    $scope.filterThesaurus = function(thesaurus_filter) {
      return ThesaurusUtils.filter($scope.thesaurus_tree, thesaurus_filter);
    };
    $scope.goBack = function(dirty, next_state) {
      if ($state.previous != null) {
        $scope.return_state = $state.previous.name;
      } else {
        $scope.return_state = next_state;
      }
      if (dirty) {
        return displayConfirmModal().result.then(function(result) {
          if (result) {
            return $state.go($scope.return_state);
          }
        });
      } else {
        return $state.go($scope.return_state);
      }
    };
    displayConfirmModal = function() {
      return $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')('MODAL_ATTENTION');
          },
          text: function() {
            return $filter('translate')('CONFIRM_RETURN_PRESC_LIST');
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("RETURN_BUTTON");
          }
        }
      });
    };
    $scope.time_str_from_minuts = function(minutes, convert_midnight) {
      var duration, hours;
      duration = moment.duration(minutes, 'minutes');
      if (convert_midnight && duration.hours() === 0) {
        return "23:59";
      }
      hours = duration.hours();
      minutes = duration.minutes() < 10 ? "0" + duration.minutes() : duration.minutes();
      return hours + ":" + minutes;
    };
    $scope.addGroup = function(care_item, group_id, group_name, liberal) {
      return Activity.addGroup(care_item, group_id, group_name, liberal);
    };
    $scope.removeGroup = function(care_item, group_id, group_dict) {
      return Activity.removeGroup(care_item, group_id, group_dict);
    };
    $scope.goPlanning = function() {
      $window.scrollTo(0, 0);
      $scope.current_screen = "planning";
      return setTimeout((function() {
        return $scope.$broadcast('rzSliderForceRender');
      }), 10);
    };
    $scope.goCareSelection = function() {
      $window.scrollTo(0, 0);
      return $scope.current_screen = "care_selection";
    };
    ref = $rootScope.DATETIME_FORMATS.DAY;
    for (index = i = 0, len = ref.length; i < len; index = ++i) {
      week_day = ref[index];
      $scope.week_days.push({
        code: index,
        label: week_day,
        selected: false
      });
    }
    $scope.selectWeekDay = function(week_days, week_day) {
      if (week_day.selected) {
        return week_days.push(week_day.code);
      } else {
        return week_days.splice(week_days.indexOf(week_day.code), 1);
      }
    };
    $scope.addTimeSlot = function(time_slots) {
      return time_slots.push({
        "floor": 0,
        "ceil": 1440,
        options: angular.copy($scope.base_slider_option)
      });
    };
    $scope.$on('validateRequest', function(event) {
      if ($scope.careForm.$valid) {
        return event.validatePromises = saveActivities();
      } else {
        return $scope.$broadcast('closeRequest');
      }
    });
    $scope.$on('closeRequest', function(event) {
      if ($scope.careForm.$dirty) {
        return event.closePromises = displayConfirmModal();
      }
    });
    saveActivities = function() {
      var allCarePromises, care_detail, care_dict, j, len1, planning_data, ref1, timestamp;
      $rootScope.busy = true;
      timestamp = new Date();
      allCarePromises = [];
      $scope.format_dates($scope.planning_data, $scope.time_slots);
      ref1 = $scope.selected_cares;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        care_detail = ref1[j];
        planning_data = angular.copy($scope.planning_data);
        planning_data.caregivers = care_detail.planning_data.caregivers;
        planning_data.timestamp = timestamp;
        care_detail.data.timestamp = timestamp;
        care_detail.data.uid = care_detail.uid;
        care_dict = {
          "planning_data": planning_data,
          "start_date": planning_data.start_date,
          "end_date": planning_data.end_date,
          "thesaurus_entry": care_detail.thesaurus_entry.id,
          "internal_employees": care_detail.internal_employees,
          "stay": $scope.stay.id,
          "data": care_detail.data,
          "validation_groups": care_detail.validation_groups
        };
        allCarePromises.push(Activity.api.save(care_dict).$promise);
      }
      return allCarePromises;
    };
    $scope.submitForm = function() {
      return $q.all(saveActivities()).then(function() {
        $rootScope.busy = false;
        if ($state.previous != null) {
          return $state.go($state.previous.name);
        } else {
          return $state.go($scope.next_state);
        }
      });
    };
    $scope.choiceChanged = function(care_item, auto_switch) {
      var group_dict, group_id, ref1;
      if (!auto_switch) {
        care_item.selected = !care_item.selected;
      }
      console.log(care_item, "444");
      if (care_item.selected) {
        if (care_item.data == null) {
          care_item.data = {
            "label": care_item.name,
            "selected_features": care_item.selectedFeatures
          };
          care_item.planning_data = {
            caregivers: angular.copy($scope.global_selected_groups)
          };
        }
        care_item.validation_groups = [];
        ref1 = care_item.planning_data.caregivers;
        for (group_id in ref1) {
          group_dict = ref1[group_id];
          care_item.validation_groups.push(group_id);
        }
        if (care_item.internal_employees == null) {
          care_item.internal_employees = $scope.thesaurus_category.code === "care";
        }
        if (care_item.duration != null) {
          care_item.data.duration = care_item.duration;
        }
        $scope.selected_cares.push(care_item);
        if (!$scope.thesaurus_category.code === "care" && (care_item.data.at_home == null)) {
          return care_item.data.at_home = true;
        }
      } else {
        index = $scope.selected_cares.indexOf(care_item);
        return $scope.selected_cares.splice(index, 1);
      }
    };
    $scope.addGlobalGroup = function(group_id, group_name) {
      var care_item, j, len1, ref1, results;
      group_id = parseInt(group_id, 10);
      if ($scope.global_selected_groups[group_id] != null) {
        $scope.global_selected_groups[group_id].count += 1;
      } else {
        $scope.global_selected_groups[group_id] = {
          count: 1,
          group_name: group_name
        };
      }
      ref1 = $scope.selected_cares;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        care_item = ref1[j];
        results.push($scope.addGroup(care_item, group_id, group_name));
      }
      return results;
    };
    $scope.removeGlobalGroup = function(group_id, group_dict) {
      var care_item, j, len1, ref1, results;
      if (group_dict.count === 1) {
        delete $scope.global_selected_groups[group_id];
      } else {
        group_dict.count -= 1;
      }
      ref1 = $scope.selected_cares;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        care_item = ref1[j];
        if (care_item.planning_data.caregivers[group_id] != null) {
          results.push($scope.removeGroup(care_item, group_id, care_item.planning_data.caregivers[group_id]));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };
    $scope.activate_childs = function(item) {
      var child_item, j, len1, ref1, results;
      ref1 = item.entries || [];
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        child_item = ref1[j];
        results.push(child_item.active = true);
      }
      return results;
    };
    $scope.format_dates = function(data, selected_timeslots) {
      var j, len1, time_slot;
      data.timeslots = [];
      for (j = 0, len1 = selected_timeslots.length; j < len1; j++) {
        time_slot = selected_timeslots[j];
        data.timeslots.push({
          "start_time": $scope.time_str_from_minuts(time_slot.floor),
          "end_time": $scope.time_str_from_minuts(time_slot.ceil, true)
        });
      }
      if (data.type === "dates") {
        data.dates.sort(function(left, right) {
          return left.diff(right);
        });
        data.start_date = data.dates[0].format("YYYY-MM-DD");
        data.end_date = data.dates[data.dates.length - 1].format("YYYY-MM-DD");
        return data.dates = data.dates.map(function(date) {
          return date.format("DD/MM/YYYY");
        });
      } else {
        data.dates = [];
        data.start_date = moment(data.start_date).format("YYYY-MM-DD");
        if (data.end_mode === "duration") {
          data.end_date = moment(data.start_date);
          data.end_date.add(data.duration, 'day');
          return data.end_date = data.end_date.format("YYYY-MM-DD");
        } else if (data.end_mode === "date") {
          return data.end_date = moment(data.end_date).format("YYYY-MM-DD");
        } else {
          return data.end_date = null;
        }
      }
    };
    extract_selectable_items = function(selectable_list, item, level, thesaurus_entry) {
      var child_item, j, len1, ref1, results;
      selectable_list.push(item);
      item.level = level;
      item.thesaurus_entry = thesaurus_entry;
      item.active = level <= $scope.start_level;
      item.hide = false;
      if (item.entries != null) {
        ref1 = item.entries;
        results = [];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          child_item = ref1[j];
          results.push(extract_selectable_items(selectable_list, child_item, item.level + 1, thesaurus_entry));
        }
        return results;
      }
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=activity-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:activityCreate
    * @description
    * Directive of activity creation
   */
  angular.module('mhclientApp').directive('activityCreate', function() {
    return {
      restrict: 'E',
      require: '^form',
      templateUrl: 'taskplanner/views/care-creation-form.html',
      scope: {
        stay: '=',
        displayGoBackButton: '=',
        displayValidateButton: '='
      },
      controller: 'ActivityCtrl'
    };
  });

}).call(this);

//# sourceMappingURL=activity-create-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MissionLetterCtrl
    * @description
    * # MissionLetterCtrl
    * Controller of Mission Letter Creation
   */
  angular.module('mhclientApp').controller('MissionLetterCtrl', ["$scope", "$rootScope", "$uibModal", "$q", "$timeout", "Activity", "Sequence", "User", "$state", "MedFormsUtils", "SiteVarsUtils", "BillingUnitUtils", "$compile", "MissionLetter", function($scope, $rootScope, $uibModal, $q, $timeout, Activity, Sequence, User, $state, MedFormsUtils, SiteVarsUtils, BillingUnitUtils, $compile, MissionLetter) {
    var formatActivity, sequences_dict;
    $scope.today = new Date();
    $rootScope.busy = true;
    $scope.letterCreation = true;
    $scope.hadBeenPreviewed = false;
    $scope.canWrite = $scope.checkPermissions("MHC_MISSION_LETTER", "CAN_WRITE");
    $scope.missionLetter = {
      group_involved: null,
      majorations: [],
      data: {
        date: new Date()
      },
      sequences: [],
      users: []
    };
    MedFormsUtils.getStaticData($rootScope.currentPatient, $rootScope.currentStay).then(function(customScope) {
      return SiteVarsUtils.getValue('MISSION_LETTER_CONFIG', []).then(function(MISSION_LETTER_CONFIG) {
        $scope.staticData = customScope;
        return $scope.staticData.missionLetter = $scope.missionLetter;
      });
    });
    sequences_dict = {};
    Sequence.api.query({
      stay: $rootScope.currentStay.id
    }).$promise.then(function(sequences) {
      return Activity.api.query({
        sequences: true,
        stay: $rootScope.currentStay.id,
        without_mission_letter: true
      }).$promise.then(function(activities) {
        return BillingUnitUtils.getCareBillingUnits().then(function(careBillingUnits) {
          var activity, baseCost, careBu, i, j, len, len1, sequence;
          careBu = _.keyBy(careBillingUnits, 'id');
          for (i = 0, len = sequences.length; i < len; i++) {
            sequence = sequences[i];
            sequences_dict[sequence.id] = sequence;
            sequence.billing_activities = [];
            sequence.dates = null;
            if (sequence.end_date && sequence.end_date < moment($scope.today).format("YYYY-MM-DD")) {
              sequence.is_ended = true;
            }
          }
          for (j = 0, len1 = activities.length; j < len1; j++) {
            activity = activities[j];
            if (sequences_dict[activity.sequence]) {
              if (sequences_dict[activity.sequence].data.state !== "stopped") {
                baseCost = careBu[activity.data.type];
                if (baseCost) {
                  sequences_dict[activity.sequence].billing_activities.push({
                    "activity": activity,
                    "base_cost": baseCost,
                    "quantity": activity.data.quantity
                  });
                }
              }
            }
          }
          $scope.sequences = _.filter(sequences, function(sequence) {
            return sequence.billing_activities.length > 0;
          });
          return $rootScope.busy = false;
        });
      });
    });
    $scope.canSave = function() {
      return ($scope.missionLetter.users.length > 0) && _.some(_.map(_.filter($scope.sequences, "is_selected"), function(sequence) {
        return _.some(sequence.billing_activities, "is_selected");
      }));
    };
    $scope.previewMissionLetter = function() {
      var previewML;
      $rootScope.busy = true;
      $rootScope.busy = false;
      previewML = {
        users_involved: _.map($scope.missionLetter.users, "id"),
        author: $scope.user.id,
        sequences: _.map(_.filter($scope.sequences, "is_selected"), function(sequence) {
          return _.assign(_.clone(sequence), {
            billing_activities: _.filter(sequence.billing_activities, "is_selected"),
            majorations: _.filter(sequence.majorations, "selected")
          });
        }),
        start_date: $scope.mlStartDate(),
        end_date: $scope.mlEndDate(),
        stay: $rootScope.currentStay.id,
        data: $scope.missionLetter.data,
        template: $scope.missionLetter.template,
        group_involved: $scope.missionLetter.group_involved.id,
        majorations: _.filter($scope.missionLetter.majorations, "selected")
      };
      return $uibModal.open({
        component: 'missionLetterPreviewModal',
        windowClass: 'modal-fullscreen',
        backdrop: 'static',
        resolve: {
          missionLetter: function() {
            return previewML;
          },
          patient: function() {
            return $rootScope.currentPatient;
          },
          stay: function() {
            return $rootScope.currentStay;
          }
        }
      });
    };
    $scope.mlStartDate = function() {
      var start_dates;
      start_dates = [].concat.apply([], _.map(_.filter($scope.sequences, "is_selected"), function(sequence) {
        return _.map(_.filter(sequence.billing_activities, "is_selected"), function(ba) {
          return moment(ba.activity.start_date);
        });
      }));
      if (start_dates.length === 0) {
        return null;
      }
      return moment.min(start_dates).format("YYYY-MM-DD");
    };
    $scope.mlEndDate = function() {
      var end_dates;
      end_dates = [].concat.apply([], _.map(_.filter($scope.sequences, "is_selected"), function(sequence) {
        return _.map(_.filter(sequence.billing_activities, "is_selected"), function(ba) {
          var end_date;
          end_date = ba.activity.end_date;
          if (end_date === null) {
            return null;
          }
          return moment(end_date);
        });
      }));
      if (end_dates.length === 0) {
        return null;
      }
      if (_.includes(end_dates, null)) {
        return null;
      }
      return moment.max(end_dates).format("YYYY-MM-DD");
    };
    formatActivity = function(billingActivitiy) {
      return _.assign(_.clone(billingActivitiy), {
        activity: billingActivitiy.activity.id,
        base_cost: billingActivitiy.base_cost.id
      });
    };
    return $scope.saveMissionLetter = function() {
      var globalMajorations, mlPostData;
      $rootScope.busy = true;
      globalMajorations = _.filter($scope.missionLetter.majorations, {
        selected: true
      });
      mlPostData = {
        users_involved: _.map($scope.missionLetter.users, "id"),
        author: $scope.user.id,
        billing_activities: [].concat.apply([], _.map(_.filter($scope.sequences, "is_selected"), function(sequence) {
          return _.map(_.filter(sequence.billing_activities, "is_selected"), formatActivity);
        })),
        sequence_majorations: [].concat.apply([], _.map(_.filter($scope.sequences, "is_selected"), function(sequence) {
          return _.map(_.concat(globalMajorations, _.filter(sequence.majorations, "selected")), function(majoration) {
            return {
              "majoration": majoration.id,
              "sequence": sequence.id,
              "quantity": majoration.quantity || 1
            };
          });
        })),
        start_date: $scope.mlStartDate(),
        end_date: $scope.mlEndDate(),
        stay: $rootScope.currentStay.id,
        referent: $scope.missionLetter.referent.id,
        data: $scope.missionLetter.data,
        template: $scope.missionLetter.template.id,
        group_involved: $scope.missionLetter.group_involved.id
      };
      return MissionLetter.api.save(mlPostData).$promise.then(function(mission_letter) {
        $rootScope.busy = false;
        return $state.go("user.patient.stay.taskplanner.mission_letter_list");
      });
    };
  }]);

  angular.module('mhclientApp').filter('missionLetterSequencesFilter', ["$rootScope", function($rootScope) {
    return function(sequences, selectedGroup) {
      if (!selectedGroup) {
        return sequences;
      }
      return _.filter(sequences, function(sequence) {
        return _.some(sequence.billing_activities, function(billing_activity) {
          return _.includes(_.keys(billing_activity.activity.planning_data.caregivers), selectedGroup.uid);
        });
      });
    };
  }]);

  angular.module('mhclientApp').filter('missionLetterBillingActivityFilter', ["$rootScope", function($rootScope) {
    return function(billing_activities, selectedGroup) {
      if (!selectedGroup) {
        return billing_activities;
      }
      return _.filter(billing_activities, function(billing_activity) {
        return _.includes(_.keys(billing_activity.activity.planning_data.caregivers), selectedGroup.uid);
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=mission-letter-create-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:MissionLetterCtrl
    * @description
    * # MissionLetterCtrl
    * Controller of Mission Letter List Controller
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('MissionLetterListCtrl', ["$q", "$scope", "$rootScope", "$filter", "MissionLetter", "$timeout", "SiteVarsUtils", "BillingUnitUtils", "UserUtils", "$uibModal", function($q, $scope, $rootScope, $filter, MissionLetter, $timeout, SiteVarsUtils, BillingUnitUtils, UserUtils, $uibModal) {
    var init, print;
    $scope.params = {};
    $scope.can_read_taks = indexOf.call($scope.user.group.features, "MHC_CARE_REALIZATION") >= 0;
    $scope.can_create_sequences = $rootScope.checkPermissions("MHC_CARE_CREATION", "CAN_WRITE");
    $scope.applyFilter = function() {
      if ($scope.filters.archived === true) {
        delete $scope.params.archived;
      } else {
        $scope.params.archived = $scope.filters.archived;
      }
      return MissionLetter.api.query($scope.params).$promise.then(function(letters) {
        return $scope.missionLetters = letters;
      });
    };
    $scope.can_create_mission_letter = $scope.checkPermissions("MHC_MISSION_LETTER", "CAN_WRITE");
    $scope.setCareBu = function() {
      if ($rootScope.mh_config.platform === "mhsi") {
        return BillingUnitUtils.getCareBillingUnits().then(function(billing_units) {
          return $scope.careBu = _.keyBy(billing_units, 'id');
        });
      } else {
        return $scope.careBu = [];
      }
    };
    init = function() {
      var promises;
      $rootScope.busy = true;
      promises = [
        SiteVarsUtils.get("DISPLAY_COTATION_IN_MISSION_LETTER").then(function(display_cotation) {
          return $scope.showCotation = display_cotation.value;
        }), UserUtils.getUsers(true).then(function(users) {
          return $scope.users = _.keyBy(users, 'id');
        })
      ];
      if ($rootScope.mh_config.platform === "mhsi") {
        promises.push($scope.setCareBu());
      } else {
        $scope.careBu = [];
      }
      if ($scope.allStays) {
        $scope.params.patient = $rootScope.currentPatient.id;
      } else {
        $scope.params.stay = $rootScope.currentStay.id;
      }
      $scope.filters = {
        archived: !$scope.isActiveStay
      };
      promises.push($scope.applyFilter());
      return $q.all(promises).then(function() {
        return $rootScope.busy = false;
      });
    };
    $scope.addUser = function(letter, event) {
      event.stopPropagation();
      return $uibModal.open({
        component: 'addUsersToMissionLetter',
        windowClass: 'modal-fullscreen',
        backdrop: 'static',
        resolve: {
          letter: function() {
            return letter;
          }
        }
      });
    };
    $scope.openArchiveWarningModal = function(letter, event) {
      event.stopPropagation();
      return $uibModal.open({
        templateUrl: 'taskplanner/views/archive-warning-modal.html',
        controller: 'archiveWarningModal',
        size: 'lg',
        windowClass: 'modal-small',
        backdrop: 'static',
        resolve: {
          letter: function() {
            return letter;
          }
        }
      }).result.then(function(result) {
        if (result && result.archive) {
          return $scope.archiveLetter(letter);
        }
      });
    };
    $scope.archiveLetter = function(letter) {
      letter.archived = true;
      return MissionLetter.api.archive({
        id: letter.id,
        stop_sequences: true,
        reason: $filter('translate')("SEQUENCE_STOP_REASON_LDM_ARCHIVE")
      });
    };
    $scope.printLetter = function(letter) {
      $scope.toPrintId = letter.id;
      return $timeout(print, 100);
    };
    print = function() {
      return window.print();
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=mission-letters-list-controller.js.map

angular
  .module("mhclientApp")
  .controller(
    "PunctualActivityCareSelectorModalCtrl",
    PunctualActivityCareSelectorModalCtrl
  );

function PunctualActivityCareSelectorModalCtrl(
  $scope,
  $uibModalInstance,
  thesaurusCategories,
  ThesaurusUtils
) {
  $scope.thesaurusCategories = thesaurusCategories;
  $scope.selectedThesaurusCategory = thesaurusCategories[0];
  $scope.selectedCares = [];

  $scope.handleSubmit = handleSubmit;
  $scope.isThesaurusAvailable = isThesaurusAvailable;
  $scope.filterThesaurus = filterThesaurus;
  $scope.isThesaurusCategorySelected = isThesaurusCategorySelected;
  $scope.handleSelectThesaurusCategory = handleSelectThesaurusCategory;
  $scope.handleCheckCare = handleCheckCare;

  function handleSubmit() {
    $uibModalInstance.close($scope.selectedCares[0]);
  }

  function isThesaurusAvailable() {
    return thesaurusCategories != null;
  }

  function filterThesaurus(thesaurusTree, thesaurusFilter) {
    return ThesaurusUtils.filter(thesaurusTree, thesaurusFilter);
  }

  function isThesaurusCategorySelected(thesaurusCategory) {
    return $scope.selectedThesaurusCategory.id === thesaurusCategory.id;
  }

  function handleSelectThesaurusCategory(thesaurusCategory) {
    $scope.selectedThesaurusCategory = thesaurusCategory;
  }

  function handleCheckCare(care) {
    $scope.selectedCares = getUpdateSelectedCares(care);
  }

  function getUpdateSelectedCares(care) {
    if ($scope.selectedCares.length === 0) {
      return [care];
    }

    var currentCareUid = $scope.selectedCares[0].uid;
    if (currentCareUid !== care.uid) {
      return [care];
    }

    return [];
  }
}

"use strict";
/*
 * @ngdoc function
 * @name mhclientApp.provider: PunctualTaskValidationCtrl
 * @description
 * # PunctualTaskValidationCtrl
 * Provider of PunctualTaskValidationCtrl
 */
angular
  .module("mhclientApp")
  .controller("PunctualTaskValidationCtrl", PunctualTaskValidationCtrl);

function PunctualTaskValidationCtrl(
  $scope,
  $filter,
  $rootScope,
  $uibModal,
  $uibModalInstance,
  user,
  task,
  ThesaurusUtils,
  MissionLetter
) {
  $scope.start_level = 0;
  $scope.user = user;
  $scope.task = task;
  $scope.today = new Date();
  $scope.cotation = "1";
  $scope.hasSelectedCare = hasSelectedCare;
  $scope.care = undefined;

  $scope.filterThesaurus = filterThesaurus;
  $scope.onCancelCareChoice = onCancelCareChoice;
  $scope.choiceChanged = choiceChanged;
  $scope.canBill = canBill;
  $scope.canBillReason = canBillReason;
  $scope.submitValidatedActivity = submitValidatedActivity;
  $scope.submitRefusedActivity = submitRefusedActivity;

  init();
  initCare();

  function filterThesaurus(categoryEntries, filter) {
    return ThesaurusUtils.filter(categoryEntries, filter);
  }

  function hasSelectedCare() {
    return $scope.care != null;
  }

  function onCancelCareChoice() {
    return ($scope.care = void 0);
  }
  function choiceChanged(selectedCare) {
    $scope.care = angular.copy(selectedCare);
    delete $scope.care.entries;
    applyTaskPlanningData($scope.care);
    if (
      selectedCare.data.duration === void 0 ||
      selectedCare.data.duration === ""
    ) {
      return ($scope.care.data.duration = $scope.task.data.duration);
    }
  }

  function applyTaskPlanningData(care) {
    care.planning_data = $scope.task.planning_data;
  }

  function canBill() {
    return (
      $scope.task.mission_letter &&
      $scope.care.data.type &&
      $scope.care.data.quantity !== null &&
      $scope.cotation
    );
  }
  function canBillReason() {
    if (!$scope.task.mission_letter) {
      return $filter("translate")("MISSION_LETTER_MISSING");
    }
    if (!$scope.care.data.type) {
      return $filter("translate")("NO_TARIFICATION_FOR_SELECTED_CARE");
    }
    if ($scope.care.data.quantity === null) {
      return $filter("translate")("NO_QUANTITY_FOR_SELECTED_CARE");
    }
    if (!$scope.cotation) {
      return $filter("translate")("NO_COTATION_FOR_SELECTED_CARE");
    }
    return "";
  }

  function submitActivity(action) {
    populateCareBeforeSubmit();

    $uibModalInstance.close({
      action: action,
      data: $scope.care,
    });
  }
  function submitValidatedActivity() {
    submitActivity("validate");
  }
  function submitRefusedActivity() {
    var modal = $uibModal.open({
      templateUrl:
        "taskplanner/views/punctual-task-refusal-confirmation-modal.html",
      controller: "PunctualActivityRefusalConfirmationModalCtrl",
    });

    modal.result.then(function (refusalReason) {
      if (refusalReason === false) {
        return;
      }

      $scope.task.refusal_reason = refusalReason;
      submitActivity("refuse");
    });
  }

  function populateCareBeforeSubmit() {
    $scope.care.thesaurus_entry = $scope.care.thesaurus_entry.id;
    $scope.care.validation_groups = _.keys(
      $scope.care.planning_data.caregivers
    );

    $scope.care.planning_data = $scope.task.planning_data;
    $scope.care.planning_data.type = "dates";
    $scope.care.planning_data.status = "punctual";
    $scope.care.planning_data.dates = [$scope.task.date];
    $scope.care.planning_data.timestamp = $scope.today;
    $scope.care.planning_data.timeslots = $scope.task.planning_data.timeslots;
    $scope.care.planning_data.start_date = $scope.task.date;
    $scope.care.planning_data.end_date = $scope.task.date;
    $scope.care.planning_data.puncutal_timestamp = $scope.task.timestamp;

    $scope.care.start_date = $scope.task.date;
    $scope.care.end_date = $scope.task.date;
    $scope.care.punctual_activity_id = $scope.task.id;
    $scope.care.sequence = $scope.task.sequence.id;
    $scope.care.data.timestamp = $scope.today;
    $scope.care.patient = $rootScope.currentPatient.id;

    $scope.care.task = {
      id: $scope.task.id,
      date: $scope.task.date,
      author: $scope.task.username,
      mission_letter: $scope.task.mission_letter,
      group_involved: $scope.task.group_involved,
      refusal_reason: $scope.task.refusal_reason,
      data: {
        comment: $scope.task.data.comment,
        start_time: $scope.task.start_time,
        end_time: $scope.task.end_time,
        done_time: $scope.task.timestamp,
        user_full_name: $scope.task.user_full_name,
        initials: $scope.task.initials,
        duration: $scope.task.data.duration,
        user_id_nat: $scope.task.user_id_nat,
        user_ext_id: $scope.task.user_ext_id,
        selected_features: $scope.care.selectedFeatures,
      },
    };
    $scope.care.current_mission_letter = $scope.task.mission_letter;

    if ($scope.canBill()) {
      return ($scope.care.billing_activity = {
        mission_letter: $scope.care.current_mission_letter,
        base_cost: $scope.care.data.type,
        quantity: $scope.care.data.quantity,
        cotation: $scope.cotation,
      });
    }
  }

  function init() {
    MissionLetter.api
      .query({
        sequence: task.sequence.id,
        user_involved: task.username,
      })
      .$promise.then(function (availableMissionLetters) {
        $scope.availableMissionLetters = _.map(
          availableMissionLetters,
          function (missionLetter) {
            return {
              id: missionLetter.id,
              label:
                _.join(
                  [
                    $filter("translate")("MISSION_LETTER_FROM"),
                    $filter("date")(missionLetter.created, "mediumDate"),
                    missionLetter.author_full_name,
                  ],
                  " "
                ) +
                (missionLetter.archived
                  ? " " + $filter("translate")("ARCHIVED")
                  : ""),
            };
          }
        );
        $scope.availableMissionLetters.push({
          id: null,
          label: "------------------",
        });

        ThesaurusUtils.getCareCategories().promise.then(function (
          careCategories
        ) {
          $scope.thesaurusCategories = _.filter(careCategories, "active");
        });
      });
  }
  function initCare() {
    if (task.data.uid == null) return;

    ThesaurusUtils.getPunctualActivityCategories().then(function (categories) {
      $scope.care = findNestedEntryFromThesaurusCategories(
        categories,
        task.data.uid
      );
      if ($scope.care == null) {
        console.error(
          "The thesaurus nested entry was not found",
          task.data.uid
        );
        return;
      }
      applyTaskPlanningData($scope.care);
      $scope.care.data.duration = task.data.duration;
    });
  }
  function findNestedEntryFromThesaurusCategories(categories, nestedEntryUid) {
    var nestedEntry = null;
    for (var i = 0; i < categories.length; i++) {
      var entries = categories[i].entries;
      for (var j = 0; j < entries.length; j++) {
        var nestedEntries = entries[j].entries;
        for (var k = 0; k < nestedEntries.length; k++) {
          if (nestedEntries[k].uid === nestedEntryUid) {
            nestedEntry = nestedEntries[k];
          }
        }
      }
    }
    return nestedEntry;
  }
}

angular
  .module("mhclientApp")
  .controller("PunctualActivityCreationCtrl", PunctualActivityCreationCtrl);

function PunctualActivityCreationCtrl(
  $rootScope,
  $scope,
  $uibModal,
  $uibModalInstance,
  sequences,
  user,
  MhConfig,
  ThesaurusUtils
) {
  $scope.today = new Date();
  $scope.selectableSequences = _.filter(sequences, isSelectable);
  $scope.selectedSequence = null;
  $scope.selectedCare = null;
  $scope.maxDate = null;
  $scope.activity = initializeActivity();
  $scope.thesaurusCategories = initializeThesaurusCategories();
  $scope.isThesaurusAvailable = false;

  $scope.handleSelectSequence = handleSelectSequence;
  $scope.handleSelectCare = handleSelectCare;
  $scope.submitActivity = submitActivity;

  function isSelectable(sequence) {
    return (
      moment(sequence.start_date).format("YYYY-MM-DD") <=
      moment($scope.today).format("YYYY-MM-DD")
    );
  }

  function initializeActivity() {
    return {
      date: new Date(),
      data: {},
      planning_data: {
        timeslots: [],
      },
    };
  }

  function initializeThesaurusCategories() {
    $rootScope.busy = true;

    ThesaurusUtils.getPunctualActivityCategories()
      .then(function (thesaurusCategories) {
        $scope.thesaurusCategories = _.filter(
          thesaurusCategories,
          function (category) {
            return category.active;
          }
        );
      })
      .catch(function () {
        $scope.thesaurusCategories = [];
      })
      .finally(function () {
        $scope.isThesaurusAvailable = $scope.thesaurusCategories.length > 0;
        $rootScope.busy = false;
      });
  }

  function handleSelectSequence(sequence) {
    if (
      moment(sequence.end_date).format("YYYY-MM-DD") >
      moment($scope.today).format("YYYY-MM-DD")
    ) {
      $scope.maxDate = moment($scope.today);
    } else {
      $scope.maxDate = moment(sequence.end_date);
    }
    $scope.minDate = moment(sequence.start_date);

    if ($scope.activity.date != null) {
      var activityDate = moment($scope.activity.date).format("YYYY-MM-DD");
      if (
        activityDate < sequence.start_date ||
        activityDate > $scope.maxDate.format("YYYY-MM-DD")
      ) {
        $scope.activity.date = null;
      }
    }

    $scope.activity.start_time = sequence.planning_data.timeslots[0].start_time;
    $scope.activity.end_time = sequence.planning_data.timeslots[0].end_time;
    $scope.activity.planning_data.timeslots = sequence.planning_data.timeslots;

    $scope.selectedSequence = sequence;
  }

  function submitActivity() {
    $scope.activity = createActivity($scope.activity);

    $uibModalInstance.close({
      activity: $scope.activity,
      sequence: $scope.selectedSequence,
    });
  }

  function createActivity(activity) {
    var additionalFields = {
      id: "punctual_" + moment($scope.today).format("YYYY_MM_DD_HH_mm_ss"),
      status: "punctual",
      username: user.username,
      timestamp: $scope.today,
      source: MhConfig.platform,
      user_full_name: user.full_name,
      user_id_nat: user.user_profile.id_nat,
      user_ext_id: user.user_profile.ext_id,
      initials: user.user_profile.initials || "-",
    };

    var finalActivity = _.merge(additionalFields, activity);
    finalActivity.data = {
      uid: activity.data.uid,
      label: activity.data.label,
      duration: activity.data.duration,
      comment: activity.data.comment,
    };
    finalActivity.date = moment(activity.date).format("YYYY-MM-DD");

    return finalActivity;
  }

  function handleSelectCare() {
    openThesaurusCareSelector();
  }

  function openThesaurusCareSelector() {
    var modalInstance = $uibModal.open({
      templateUrl:
        "taskplanner/views/punctual-activity-cares-selector-modal.html",
      controller: "PunctualActivityCareSelectorModalCtrl",
      resolve: {
        thesaurusCategories: function () {
          return $scope.thesaurusCategories;
        },
      },
    });

    modalInstance.result.then(function (care) {
      if (!care) return;

      $scope.activity.data = care.data;
      $scope.activity.thesaurus_entry = care.thesaurus_entry.id;
      $scope.selectedCare = care;
    });
  }
}

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:SequenceCtrl
    * @description
    * # SequenceCtrl
    * Controller of list of Sequences
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('SequenceCtrl', ["$scope", "$rootScope", "$anchorScroll", "Sequence", "Activity", "ThesaurusUtils", "Prescription", "moment", "$q", "$state", "$filter", "$location", "$uibModal", function($scope, $rootScope, $anchorScroll, Sequence, Activity, ThesaurusUtils, Prescription, moment, $q, $state, $filter, $location, $uibModal) {
    var goTop, handleNeedMissionLettersCount, init, missionLettersDict, saveSequence, selectStayModal, stopActivity, stopSequence;
    $scope.noSelectedCare = $filter('translate')('SELECTED_CARE');
    $scope.oneSelectedCare = $filter('translate')('SELECTED_CARE');
    $scope.severalSelectedCares = $filter('translate')('SEVERAL_SELECTED_CARES');
    $scope.can_read_taks = indexOf.call($scope.user.group.features, "MHC_CARE_REALIZATION") >= 0;
    $scope.can_write_cares = $scope.checkPermissions("MHC_CARE_CREATION", "CAN_WRITE");
    $scope.can_read_mission_letter = indexOf.call($scope.user.group.features, "MHC_MISSION_LETTER") >= 0;
    $scope.can_create_mission_letter = $scope.checkPermissions("MHC_MISSION_LETTER", "CAN_WRITE");
    $scope.new_sequences = [];
    $scope.current_sequences = [];
    $scope.stopped_sequences = [];
    $scope.showStoppedSequences = false;
    $scope.submiting = false;
    $scope.start_level = 0;
    $scope.today = new Date();
    $scope.thesaurus_filter = "";
    $scope.sequencesFilter = "";
    missionLettersDict = {};
    $scope.punctual_activities_count = 0;
    $scope.show_new_presc = false;
    $scope.show_deleted_presc = false;
    $scope.new_presc_list = [];
    $scope.deleted_presc_list = [];
    selectStayModal = function(patient) {
      return $uibModal.open({
        animation: true,
        templateUrl: 'core/views/select-stay-widget-modal.html',
        size: "lg",
        controller: 'selectStayWidget',
        resolve: {
          patient: function() {
            return patient;
          },
          states: function() {
            return ["PRE", "ADM"];
          }
        }
      });
    };
    goTop = function() {
      $location.hash('top');
      return $anchorScroll();
    };
    $scope.filterSequence = function(sequence) {
      var _check, to_filter;
      if (!$scope.sequencesFilter) {
        return true;
      }
      to_filter = $scope.sequencesFilter.toLowerCase();
      _check = function(activity) {
        return _.includes(activity.data.label.toLowerCase(), to_filter);
      };
      return _.some(sequence.activities, _check);
    };
    $scope.checkLiberal = function(care) {
      return function(item, index, array) {
        if (item.liberal && !care.data.type) {
          return false;
        }
        return true;
      };
    };
    $scope.genMissionLetter = function() {
      var activity, confirm_dialog, i, inOtherStaysCount, j, len, len1, ref, ref1, sameStayCount, sequence;
      if (!$scope.allStays && $scope.isActiveStay) {
        return $state.go("user.patient.stay.taskplanner.mission_letter_create");
      } else {
        if (!$scope.isActiveStay) {
          return $uibModal.open({
            animation: true,
            templateUrl: 'core/views/modal-template.html',
            size: "lg",
            controller: 'mhModalCtrl',
            resolve: {
              title: function() {
                return $filter('translate')("SHOW MISSION LETTERS");
              },
              text: function() {
                return $filter('translate')("CAN CREATE MISSION LETTER FOR INACTIVE STAY");
              },
              cancelButtonText: function() {
                return $filter('translate')("CANCEL_BUTTON");
              },
              okButtonText: function() {
                return '';
              },
              noButtonText: function() {
                return '';
              }
            }
          });
        } else {
          inOtherStaysCount = 0;
          sameStayCount = 0;
          ref = $scope.current_sequences.concat(_.filter($scope.stopped_sequences, function(obj) {
            return obj.data.state !== "stopped";
          }));
          for (i = 0, len = ref.length; i < len; i++) {
            sequence = ref[i];
            ref1 = sequence.activities;
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              activity = ref1[j];
              if (activity.need_mission_letter && !activity.current_mission_letter) {
                if (activity.stay !== $rootScope.currentStay.id) {
                  inOtherStaysCount += 1;
                } else {
                  sameStayCount += 1;
                }
              }
            }
          }
          if (sameStayCount === 0) {
            return $uibModal.open({
              animation: true,
              templateUrl: 'core/views/modal-template.html',
              size: "lg",
              controller: 'mhModalCtrl',
              resolve: {
                title: function() {
                  return $filter('translate')("SHOW MISSION LETTERS");
                },
                text: function() {
                  return $filter('translate')("OTHER STAYS NEED MISSION LETTERS");
                },
                cancelButtonText: function() {
                  return $filter('translate')("CANCEL_BUTTON");
                },
                okButtonText: function() {
                  return '';
                },
                noButtonText: function() {
                  return '';
                }
              }
            });
          } else if (inOtherStaysCount) {
            confirm_dialog = $uibModal.open({
              animation: true,
              templateUrl: 'core/views/modal-template.html',
              size: "lg",
              controller: 'mhModalCtrl',
              resolve: {
                title: function() {
                  return $filter('translate')("SHOW MISSION LETTERS");
                },
                text: function() {
                  return $filter('translate')("DO NOT TAKE ACCOUNT OF OTHER STAYS SEQUENCES");
                },
                cancelButtonText: function() {
                  return '';
                },
                okButtonText: function() {
                  return $filter('translate')("CONFIRM");
                },
                noButtonText: function() {
                  return '';
                }
              }
            });
            return confirm_dialog.result.then(function(result) {
              if (result) {
                return $state.go("user.patient.stay.taskplanner.mission_letter_create");
              }
            });
          } else {
            return $state.go("user.patient.stay.taskplanner.mission_letter_create");
          }
        }
      }
    };
    $scope.checkStayActive = function(stayId) {
      var ref, stay;
      if ($rootScope.currentPatientStays) {
        stay = _.find($rootScope.currentPatientStays, {
          id: stayId
        });
        if (stay && ((ref = stay.state) === 'PRE' || ref === 'ADM')) {
          return true;
        }
      }
      return false;
    };
    $scope.replanSequenceInActiveStay = function(sequence) {
      var activeStayId, staySelectionPromise;
      $rootScope.busy = true;
      staySelectionPromise = $q.defer();
      activeStayId = void 0;
      selectStayModal($rootScope.currentPatient).result.then(function(stay) {
        if (stay) {
          activeStayId = stay.id;
          return staySelectionPromise.resolve();
        } else {
          return staySelectionPromise.reject();
        }
      });
      return staySelectionPromise.promise.then(function() {
        return ThesaurusUtils.replanSequence(sequence, $scope.dayLabel).then(function(new_sequence) {
          var activity, i, len, ref;
          new_sequence.unfold = true;
          new_sequence.stay = activeStayId;
          delete new_sequence.sequence_original;
          delete new_sequence.stopped_activities;
          delete new_sequence.start_date;
          delete new_sequence.id;
          new_sequence.historical = [];
          ref = new_sequence.activities;
          for (i = 0, len = ref.length; i < len; i++) {
            activity = ref[i];
            activity.stay = activeStayId;
            activity.historical = [];
            delete activity.current_mission_letter;
            delete activity.issue;
            delete activity.data.issue_stopped;
            delete activity.start_date;
            delete activity.id;
          }
          $scope.new_sequences.splice(0, 0, new_sequence);
          $rootScope.busy = false;
          return goTop();
        });
      });
    };
    $scope.duplicateSequence = function(sequence) {
      var new_sequence;
      $rootScope.busy = true;
      if (sequence.id) {
        return ThesaurusUtils.replanSequence(sequence, $scope.dayLabel).then(function(new_sequence) {
          var activity, care_item, category, group_id, i, j, k, l, len, len1, len2, len3, ref, ref1, ref2, ref3;
          $scope.selectedSequence = new_sequence;
          new_sequence.unfold = true;
          $scope.selectedSequence.selectableGroups = [];
          ref = $scope.selectedSequence.thesaurus_categories;
          for (i = 0, len = ref.length; i < len; i++) {
            category = ref[i];
            $scope.selectedSequence.selectableGroups = _.concat($scope.selectedSequence.selectableGroups, category.groups);
          }
          $scope.selectedSequence.selectableGroups = _.uniqBy($scope.selectedSequence.selectableGroups, 'name');
          delete new_sequence.sequence_original;
          delete new_sequence.stopped_activities;
          delete new_sequence.start_date;
          if (new_sequence.data.estimated_times == null) {
            new_sequence.data.estimated_times = [];
            ref1 = new_sequence.activities;
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              care_item = ref1[j];
              ref2 = Object.keys(care_item.planning_data.caregivers);
              for (k = 0, len2 = ref2.length; k < len2; k++) {
                group_id = ref2[k];
                $scope.createEstimatedTimeObject(new_sequence, group_id, care_item.planning_data.caregivers[group_id].group_name);
              }
            }
          }
          delete new_sequence.id;
          new_sequence.historical = [];
          ref3 = new_sequence.activities;
          for (l = 0, len3 = ref3.length; l < len3; l++) {
            activity = ref3[l];
            activity.historical = [];
            delete activity.current_mission_letter;
            delete activity.issue;
            delete activity.start_date;
            delete activity.data.issue_stopped;
            delete activity.id;
          }
          $scope.new_sequences.splice(0, 0, new_sequence);
          $rootScope.busy = false;
          return goTop();
        });
      } else {
        new_sequence = angular.copy(sequence);
        new_sequence.unfold = true;
        $scope.new_sequences.splice(0, 0, new_sequence);
        $rootScope.busy = false;
        return goTop();
      }
    };
    $scope.replanSequence = function(sequence) {
      $rootScope.busy = true;
      return ThesaurusUtils.replanSequence(sequence, $scope.dayLabel).then(function(new_sequence) {
        var care_item, category, group_id, i, j, k, len, len1, len2, ref, ref1, ref2;
        $scope.selectedSequence = new_sequence;
        if (new_sequence.data.estimated_times == null) {
          new_sequence.data.estimated_times = [];
          ref = new_sequence.activities;
          for (i = 0, len = ref.length; i < len; i++) {
            care_item = ref[i];
            ref1 = Object.keys(care_item.planning_data.caregivers);
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              group_id = ref1[j];
              $scope.createEstimatedTimeObject(new_sequence, group_id, care_item.planning_data.caregivers[group_id].group_name);
            }
          }
        }
        new_sequence.unfold = true;
        $scope.selectedSequence.selectableGroups = [];
        ref2 = $scope.selectedSequence.thesaurus_categories;
        for (k = 0, len2 = ref2.length; k < len2; k++) {
          category = ref2[k];
          $scope.selectedSequence.selectableGroups = _.concat($scope.selectedSequence.selectableGroups, category.groups);
        }
        $scope.selectedSequence.selectableGroups = _.uniqBy($scope.selectedSequence.selectableGroups, 'name');
        if (sequence.data.state === "stopped" || sequence.end_date < moment($scope.today).format("YYYY-MM-DD")) {
          $scope.stopped_sequences.splice($scope.stopped_sequences.indexOf(sequence), 1);
        } else {
          $scope.current_sequences.splice($scope.current_sequences.indexOf(sequence), 1);
        }
        $scope.new_sequences.splice(0, 0, new_sequence);
        $rootScope.busy = false;
        return goTop();
      });
    };
    $scope.removeNewSequence = function(sequence) {
      if (sequence.sequence_original != null) {
        if (sequence.sequence_original.data.state === "stopped" || sequence.sequence_original.end_date < moment($scope.today).format("YYYY-MM-DD")) {
          $scope.stopped_sequences.push(sequence.sequence_original);
        } else {
          $scope.current_sequences.push(sequence.sequence_original);
        }
      }
      return $scope.new_sequences.splice($scope.new_sequences.indexOf(sequence), 1);
    };
    $scope.choiceChanged = function(care_item, auto_switch, sequence) {
      sequence = sequence || $scope.selectedSequence;
      if (!auto_switch) {
        care_item.selected = !care_item.selected;
      }
      if (care_item.selected) {
        if (care_item.id != null) {
          sequence.stopped_activities.splice(sequence.stopped_activities.indexOf(care_item), 1);
        }
        return sequence.activities.push(care_item);
      } else {
        sequence.activities.splice(sequence.activities.indexOf(care_item), 1);
        if (care_item.id != null) {
          return sequence.stopped_activities.push(care_item);
        }
      }
    };
    $scope.addSequence = function() {
      var new_sequence;
      new_sequence = ThesaurusUtils.newSequenceForStay($rootScope.currentStay, $scope.dayLabel);
      $scope.new_sequences.splice(0, 0, new_sequence);
      return goTop();
    };
    $scope.confirmIntegratedNewSeq = function() {
      var i, len, newPrescList, presc, results;
      newPrescList = _.filter($scope.new_presc_list, {
        pds_handled: true
      });
      results = [];
      for (i = 0, len = newPrescList.length; i < len; i++) {
        presc = newPrescList[i];
        Prescription.update({
          id: presc.id
        }, {
          pds_handled: true
        });
        results.push(_.remove($scope.new_presc_list, function(prescToRemove) {
          return prescToRemove.id === presc.id;
        }));
      }
      return results;
    };
    $scope.confirmIntegratedDeletedSeq = function() {
      var DeletedPrescList, i, len, presc, results;
      DeletedPrescList = _.filter($scope.deleted_presc_list, {
        pds_handled: true
      });
      results = [];
      for (i = 0, len = DeletedPrescList.length; i < len; i++) {
        presc = DeletedPrescList[i];
        Prescription.update({
          id: presc.id
        }, {
          pds_handled: true
        });
        results.push(_.remove($scope.deleted_presc_list, function(prescToRemove) {
          return prescToRemove.id === presc.id;
        }));
      }
      return results;
    };
    init = function() {
      var params, prescParams;
      if ($scope.allStays) {
        params = {
          patient: $rootScope.currentPatient.id
        };
      } else {
        params = {
          stay: $rootScope.currentStay.id
        };
      }
      Sequence.api.query(params).$promise.then(function(sequences) {
        var activityParams, i, j, len, len1, sequence, sequence_dict;
        $rootScope.busy = true;
        for (i = 0, len = sequences.length; i < len; i++) {
          sequence = sequences[i];
          if (sequence.data.state === "stopped" || sequence.end_date < moment($scope.today).format("YYYY-MM-DD")) {
            $scope.stopped_sequences.push(sequence);
          } else {
            $scope.current_sequences.push(sequence);
          }
        }
        sequence_dict = {};
        for (j = 0, len1 = sequences.length; j < len1; j++) {
          sequence = sequences[j];
          sequence_dict[sequence.id] = sequence;
          sequence.activities = [];
          sequence.other_activities = [];
          sequence.realized_punctual_activities = [];
          sequence.unfold = true;
        }
        if ($scope.allStays) {
          activityParams = {
            patient: $rootScope.currentPatient.id,
            sequences: true
          };
        } else {
          activityParams = {
            stay: $rootScope.currentStay.id,
            sequences: true
          };
        }
        return ThesaurusUtils.fetchActivities(activityParams).then(function(activities) {
          var activity, current_sequence, k, len2;
          for (k = 0, len2 = activities.length; k < len2; k++) {
            activity = activities[k];
            if (activity.need_mission_letter && activity.current_mission_letter) {
              if (missionLettersDict[activity.current_mission_letter] == null) {
                missionLettersDict[activity.current_mission_letter] = [];
              }
              missionLettersDict[activity.current_mission_letter].push(activity);
            }
            current_sequence = sequence_dict[activity.sequence];
            if (activity.planning_data.status === "punctual") {
              current_sequence.realized_punctual_activities.push(activity);
            } else if ((activity.data.state == null) || !(activity.data.state === "stopped") || current_sequence.end_date === activity.end_date) {
              current_sequence.activities.push(activity);
            } else {
              current_sequence.other_activities.push(activity);
            }
          }
          handleNeedMissionLettersCount();
          return $rootScope.busy = false;
        });
      });
      if ($rootScope.mh_config.platform === "mhsi") {
        if ($scope.allStays) {
          prescParams = {
            patient: $rootScope.currentPatient.id,
            pds_integration: true
          };
        } else {
          prescParams = {
            stay: $rootScope.currentStay.id,
            pds_integration: true
          };
        }
        return Prescription.query(prescParams).$promise.then(function(prescs) {
          var i, len, presc, results;
          results = [];
          for (i = 0, len = prescs.length; i < len; i++) {
            presc = prescs[i];
            if (presc.state !== "STOPPED") {
              results.push($scope.new_presc_list.push(presc));
            } else {
              results.push($scope.deleted_presc_list.push(presc));
            }
          }
          return results;
        });
      }
    };
    handleNeedMissionLettersCount = function() {
      var activity, i, len, ref, results, sequence;
      $scope.need_mission_letter_count = 0;
      ref = $scope.current_sequences.concat(_.filter($scope.stopped_sequences, function(obj) {
        return obj.data.state !== "stopped";
      }));
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        sequence = ref[i];
        results.push((function() {
          var j, len1, ref1, results1;
          ref1 = sequence.activities;
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            activity = ref1[j];
            if (activity.need_mission_letter && !activity.current_mission_letter) {
              results1.push($scope.need_mission_letter_count += 1);
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      }
      return results;
    };
    saveSequence = function(sequence) {
      var get_details_promise, sequence_save_promise;
      sequence_save_promise = $q.defer();
      get_details_promise = $q.defer();
      if (sequence.id != null) {
        Sequence.api.update({
          id: sequence.id
        }, sequence).$promise.then(function(new_sequence) {
          var activity, i, j, len, len1, ref, ref1;
          ref = sequence.sequence_original.activities;
          for (i = 0, len = ref.length; i < len; i++) {
            activity = ref[i];
            if (activity.current_mission_letter) {
              ref1 = missionLettersDict[activity.current_mission_letter];
              for (j = 0, len1 = ref1.length; j < len1; j++) {
                activity = ref1[j];
                activity.current_mission_letter = null;
              }
              delete missionLettersDict[activity.current_mission_letter];
            }
          }
          return sequence_save_promise.resolve(new_sequence);
        });
      } else {
        Sequence.api.save(sequence).$promise.then(function(new_sequence) {
          return sequence_save_promise.resolve(new_sequence);
        });
      }
      sequence_save_promise.promise.then(function(new_sequence) {
        return Activity.api.query({
          sequence: new_sequence.id
        }).$promise.then(function(activities) {
          var activity, i, len;
          new_sequence.activities = [];
          new_sequence.realized_punctual_activities = [];
          for (i = 0, len = activities.length; i < len; i++) {
            activity = activities[i];
            if (activity.planning_data.status === "punctual") {
              new_sequence.realized_punctual_activities.push(activity);
            } else if ((activity.data.state == null) || !(activity.data.state === "stopped")) {
              new_sequence.activities.push(activity);
            }
          }
          new_sequence.unfold = true;
          if (new_sequence.stay === $rootScope.currentStay.id || $scope.allStays) {
            if (new_sequence.data.state === "stopped" || new_sequence.end_date < moment($scope.today).format("YYYY-MM-DD")) {
              $scope.stopped_sequences.push(new_sequence);
            } else {
              $scope.current_sequences.push(new_sequence);
            }
          }
          return get_details_promise.resolve();
        });
      });
      return get_details_promise;
    };
    $scope.submitForm = function() {
      var activity, allSequences, i, j, k, len, len1, len2, ref, ref1, ref2, saveSequences, sequence, sequence_item, timestamp;
      $rootScope.busy = true;
      timestamp = new Date();
      allSequences = [];
      ref = $scope.new_sequences;
      for (i = 0, len = ref.length; i < len; i++) {
        sequence_item = ref[i];
        sequence = angular.copy(sequence_item);
        sequence.planning_data.week_days = _.orderBy(sequence.planning_data.week_days);
        sequence.planning_data.timestamp = timestamp;
        $scope.format_dates(sequence.planning_data, sequence.time_slots);
        if ((sequence.start_date == null) || sequence.start_date > sequence.planning_data.start_date) {
          sequence.start_date = sequence.planning_data.start_date;
        }
        sequence.end_date = sequence.planning_data.end_date;
        sequence.planning_data.display_text = $filter("SequenceDisplayText")(sequence);
        ref1 = sequence.activities;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          activity = ref1[j];
          activity.data.timestamp = timestamp;
          activity.planning_data = _.defaults(activity.planning_data, sequence.planning_data);
          if ((activity.start_date == null) || activity.start_date > sequence.start_date) {
            activity.start_date = sequence.start_date;
          }
          activity.end_date = sequence.end_date;
          activity.stay = sequence.stay;
          activity.thesaurus_entry = activity.thesaurus_entry.id || activity.thesaurus_entry;
          activity.need_mission_letter = activity.planning_data.has_liberal;
          delete activity.entries;
        }
        if (sequence.id) {
          ref2 = sequence.stopped_activities;
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            activity = ref2[k];
            activity.data.timestamp = timestamp;
            activity.planning_data = _.defaults(activity.planning_data, sequence.planning_data);
            activity.end_date = sequence.end_date;
            activity.stay = sequence.stay;
            activity.thesaurus_entry = activity.thesaurus_entry.id || activity.thesaurus_entry;
            delete activity.entries;
          }
        }
        delete sequence.thesaurus_categories;
        allSequences.push(sequence);
      }
      saveSequences = function(sequences, allDonePromise) {
        if (sequences.length === 0) {
          allDonePromise.resolve();
        } else {
          saveSequence(sequences.shift()).promise.then(function() {
            return saveSequences(sequences, allDonePromise);
          });
        }
        return allDonePromise;
      };
      return saveSequences(allSequences, $q.defer()).promise.then(function() {
        $rootScope.busy = false;
        handleNeedMissionLettersCount();
        return $scope.new_sequences = [];
      });
    };
    $scope.AddCares = function(sequence, mode) {
      var thesaurus_promise;
      $scope.selectedSequence = sequence;
      $rootScope.busy = true;
      thesaurus_promise = $q.defer();
      if ($scope.selectedSequence.thesaurus_categories != null) {
        thesaurus_promise.resolve();
      } else {
        ThesaurusUtils.getCareCategories().promise.then(function(careCategories) {
          var category, i, len, ref;
          $scope.selectedSequence.thesaurus_categories = _.filter(careCategories, "active");
          $scope.selectedSequence.selectableGroups = [];
          ref = $scope.selectedSequence.thesaurus_categories;
          for (i = 0, len = ref.length; i < len; i++) {
            category = ref[i];
            $scope.selectedSequence.selectableGroups = _.concat($scope.selectedSequence.selectableGroups, category.groups);
          }
          $scope.selectedSequence.selectableGroups = _.uniqBy($scope.selectedSequence.selectableGroups, 'name');
          return thesaurus_promise.resolve();
        });
      }
      return thesaurus_promise.promise.then(function() {
        $rootScope.busy = false;
        return $scope.modalInstance = $uibModal.open({
          templateUrl: 'taskplanner/views/cares-choice-modal.html',
          scope: $scope
        });
      });
    };
    stopSequence = function(sequence) {
      var reason;
      $rootScope.busy = true;
      reason = $filter('translate')("SEQUENCE_STOP_REASON_MANUALLY_BY_USER");
      return Sequence.api.stop({
        id: sequence.id,
        reason: reason
      }).$promise.then(function() {
        var activity, i, j, k, len, len1, len2, ref, ref1, ref2;
        sequence.data.state = "stopped";
        if ($scope.current_sequences.indexOf(sequence) !== -1) {
          $scope.current_sequences.splice($scope.current_sequences.indexOf(sequence), 1);
          $scope.stopped_sequences.push(sequence);
        }
        ref = sequence.activities;
        for (i = 0, len = ref.length; i < len; i++) {
          activity = ref[i];
          activity.need_mission_letter = false;
          if (activity.current_mission_letter) {
            ref1 = missionLettersDict[activity.current_mission_letter];
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              activity = ref1[j];
              activity.current_mission_letter = null;
            }
            delete missionLettersDict[activity.current_mission_letter];
          }
        }
        ref2 = sequence.stopped_today_activities || [];
        for (k = 0, len2 = ref2.length; k < len2; k++) {
          activity = ref2[k];
          sequence.activities.push(activity);
        }
        sequence.stopped_today_activities = [];
        handleNeedMissionLettersCount();
        return $rootScope.busy = false;
      });
    };
    $scope.stopSequence = function(sequence) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("CONFIRM_REMOVE_SEQUENCE");
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          }
        }
      });
      return confirm_dialog.result.then(function(result) {
        if (result) {
          return stopSequence(sequence);
        }
      });
    };
    stopActivity = function(sequence, activity) {
      $rootScope.busy = true;
      return Activity.api.stop({
        id: activity.id
      }).$promise.then(function() {
        var i, len, ref;
        sequence.activities.splice(sequence.activities.indexOf(activity), 1);
        if (sequence.stopped_today_activities == null) {
          sequence.stopped_today_activities = [];
        }
        sequence.stopped_today_activities.push(activity);
        if (activity.current_mission_letter) {
          ref = missionLettersDict[activity.current_mission_letter];
          for (i = 0, len = ref.length; i < len; i++) {
            activity = ref[i];
            activity.current_mission_letter = null;
          }
          delete missionLettersDict[activity.current_mission_letter];
          handleNeedMissionLettersCount();
        }
        return $rootScope.busy = false;
      });
    };
    $scope.stopActivity = function(sequence, activity) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')("CONFIRM_REMOVE_CARE");
          },
          text: function() {
            return '';
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          }
        }
      });
      return confirm_dialog.result.then(function(result) {
        if (result) {
          return stopActivity(sequence, activity);
        }
      });
    };
    $scope.filterThesaurus = function(thesaurus_tree, thesaurus_filter) {
      return ThesaurusUtils.filter(thesaurus_tree, thesaurus_filter);
    };
    $scope.addGlobalGroupToSequence = function(group_uid, group_name, liberal, sequence) {
      var care_item, i, len, ref, results;
      $scope.createEstimatedTimeObject(sequence, group_uid, group_name);
      ref = sequence.activities;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        care_item = ref[i];
        results.push($scope.addGroup(care_item, group_uid, group_name, liberal));
      }
      return results;
    };
    $scope.addGroupToSequence = function(sequence, care_item, group_id, group_name, liberal) {
      $scope.createEstimatedTimeObject(sequence, group_id, group_name);
      return $scope.addGroup(care_item, group_id, group_name, liberal);
    };
    $scope.createEstimatedTimeObject = function(sequence, group_id, group_name) {
      if (!(_.find(sequence.data.estimated_times, function(item) {
        return item.grp_uid === group_id;
      }))) {
        return sequence.data.estimated_times.push({
          "grp_uid": group_id,
          "grp_name": group_name,
          "value": 0
        });
      }
    };
    $scope.removeGroupSequence = function(sequence, care_item, group_id, group_dict) {
      var i, len, ref, toBeRemoved;
      $scope.removeGroup(care_item, group_id, group_dict);
      if (group_dict.count === 1) {
        toBeRemoved = true;
        ref = sequence.activities;
        for (i = 0, len = ref.length; i < len; i++) {
          care_item = ref[i];
          if (care_item.planning_data.caregivers[group_id] != null) {
            toBeRemoved = false;
            break;
          }
        }
        if (toBeRemoved) {
          return _.remove(sequence.data.estimated_times, function(item) {
            return item.grp_uid === group_id;
          });
        }
      }
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=sequence-list-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider: TaskActionsCtrl
    * @description
    * # TaskActionsCtrl
    * Provider of TaskActionsCtrl
   */
  angular.module("mhclientApp").controller('TaskActionsCtrl', ["$scope", "$rootScope", "$sce", "$q", "$uibModal", "$uibModalInstance", "FormTemplateUtils", "FeatureUtils", "MhConfig", "$timeout", "Task", "event", "stay", "FeedUtils", "patient", "readonly", function($scope, $rootScope, $sce, $q, $uibModal, $uibModalInstance, FormTemplateUtils, FeatureUtils, MhConfig, $timeout, Task, event, stay, FeedUtils, patient, readonly) {
    var canModifyTask, init, initAction;
    canModifyTask = function(task) {
      return task.group_involved === $scope.user.group.id || true;
    };
    $scope.readonly = readonly;
    init = function() {
      var i, len, ref, task;
      $scope.stay = stay;
      $scope.patient = patient;
      $scope.event = event;
      $scope.canModify = false;
      if ($scope.event.tasks.length === 1) {
        $scope.task = $scope.event.tasks[0];
        $scope.canModify = true;
      } else {
        ref = $scope.event.tasks;
        for (i = 0, len = ref.length; i < len; i++) {
          task = ref[i];
          if (canModifyTask(task)) {
            $scope.canModify = true;
            $scope.task = task;
            break;
          }
        }
      }
      $scope.notPerformedLabel = "Care not performed";
      $scope.performedLabel = "Care performed";
      $scope.selectedTasksLabel = "SELECTED_CARES";
      $scope.titleModalValidationLabel = "CARE VALIDATION DETAILS";
      if ($scope.event.type === "coordination") {
        $scope.notPerformedLabel = "Task not performed";
        $scope.performedLabel = "Task performed";
        $scope.selectedTasksLabel = "SELECTED_TASK";
        $scope.titleModalValidationLabel = "TASK VALIDATION DETAILS";
      }
      return FeatureUtils.getAllFeatures().then(function(features) {
        $scope.actions = _.map($scope.task.data.selected_features, function(action) {
          var feature;
          feature = _.find(features, {
            name: action.feature
          });
          if (feature) {
            action.iconname = feature.metadata.iconname;
          }
          return _.cloneDeep(action);
        });
        return $scope.next();
      });
    };
    $scope.canValidateTask = function() {
      if (!$scope.actions) {
        return;
      }
      return _.every($scope.actions, function(action) {
        return action.done || action.skipped || !action.required;
      });
    };
    $scope.close = function() {
      event = $scope.$broadcast('closeRequested');
      return $q.all(event.closePromises || []).then((function() {
        return $uibModalInstance.close(false);
      }));
    };
    $scope.next = function(action) {
      if ($scope.actions.length > 1 || ($scope.currentAction == null)) {
        $scope.loading = true;
        return $timeout(function() {
          var index, ref;
          if (action) {
            index = _.indexOf($scope.actions, action);
          } else {
            index = ($scope.currentAction != null ? _.indexOf($scope.actions, $scope.currentAction) + 1 : 0) % $scope.actions.length;
          }
          $scope.currentAction = $scope.actions[index];
          if ((ref = $scope.currentAction.directive) === "transmission-list" || ref === "patient-entourage" || ref === "order-list" || ref === "work-report") {
            $scope.currentAction.dirty = true;
          }
          return $q.when(initAction($scope.currentAction)).then(function() {
            return $scope.loading = false;
          });
        });
      }
    };
    $scope.changeAction = function(action) {
      event = $scope.$broadcast('closeRequested');
      if (action !== $scope.currentAction) {
        return $q.all(event.closePromises || []).then((function(result) {
          if (result.length > 0 && _.every(result, Boolean)) {
            $scope.currentAction.done = true;
          } else if (!$scope.currentAction.done && !$scope.currentAction.required) {
            $scope.currentAction.skipped = true;
          }
          return $scope.next(action);
        }));
      }
    };
    $scope.validateTask = function(status) {
      $scope.status = status;
      $scope.data = {
        comment: $scope.task.data.comment,
        duration: $scope.task.data.duration
      };
      return $uibModal.open({
        templateUrl: 'taskplanner/views/task-actions-validation.html',
        backdrop: 'static',
        scope: $scope
      }).result.then(function(data) {
        var promises;
        if (data) {
          if (status === "R") {
            promises = $scope.$broadcast('validateRequest').validatePromises;
          } else {
            promises = $scope.$broadcast('closeRequested').closePromises;
          }
          return $q.all(promises || []).then(function() {
            var i, len, ref, task;
            if ($scope.event.type === "coordination") {
              ref = $scope.event.tasks;
              for (i = 0, len = ref.length; i < len; i++) {
                task = ref[i];
                $scope.formatTask(task, data, status);
              }
              return $uibModalInstance.close({
                "action": "update",
                "tasks": $scope.event.tasks
              });
            } else {
              $rootScope.busy = true;
              $scope.formatTask($scope.task, data, status);
              return Task.api.update({
                "id": $scope.task.id
              }, $scope.task).$promise.then(function() {
                $rootScope.busy = false;
                return $uibModalInstance.close(false);
              });
            }
          });
        }
      });
    };
    $scope.formatTask = function(task, data, status) {
      task.status = status;
      task.data = _.defaults(task.data, data);
      task.data.comment = data.comment;
      task.data.duration = data.duration;
      task.data.sub_status = data.sub_status;
      task.data.done_time = new Date();
      task.selected = false;
      task.author = $rootScope.user.id;
      task.data.user_full_name = $rootScope.user.first_name + " " + $rootScope.user.last_name;
      task.data.initials = $rootScope.user.user_profile.initials || "-";
      task.data.finess = $rootScope.user.user_profile.finess || "";
      return task.activity = task.activity.id;
    };
    $scope.validateAction = function(action) {
      if ($scope.actions.length === 1) {
        return $scope.validateTask("R");
      } else {
        event = $scope.$broadcast('validateRequest');
        return $q.all(event.validatePromises || []).then((function(data) {
          action.done = true;
          action.skipped = false;
          return $scope.next();
        }), (function(e) {}));
      }
    };
    initAction = function(actionDict) {
      if (actionDict.initialized) {
        return;
      }
      if (actionDict.directive === "transmission-list") {
        return true;
      } else if (actionDict.directive === "work-report") {
        return FeedUtils.getFeedsByName("MHC_WORK_REPORT").then(function(workReportFeeds) {
          actionDict.feed = _.find(workReportFeeds, {
            view: actionDict.selectedOption
          });
          return actionDict.initialized = true;
        });
      } else if (actionDict.directive === "medform-version") {
        return FormTemplateUtils.getTemplates({
          uid: actionDict.selectedOption
        }).then(function(formTemplate) {
          actionDict.formTemplate = formTemplate;
          actionDict.options = {
            "hideSave": true
          };
          return actionDict.initialized = true;
        });
      } else {
        return true;
      }
    };
    $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      return event.preventDefault();
    });
    $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=task-actions-controller.js.map

angular.module("mhclientApp").component("thesaurusEntryCollapsable", {
  templateUrl: "taskplanner/views/thesaurus-entry-collapsable.html",
  controller: ThesaurusEntryCollapsableCtrl,
  bindings: {
    firstLevelEntry: "<",
    checkedSecondLevelEntries: "<",
    onCheckEntry: "&",
  },
});

function ThesaurusEntryCollapsableCtrl($scope) {
  var ctrl = this;

  $scope.isCollapsed = true;

  $scope.toggleCollapsing = toggleCollapsing;
  $scope.isCareChecked = isCareChecked;

  function toggleCollapsing() {
    $scope.isCollapsed = !$scope.isCollapsed;
  }

  function isCareChecked(care) {
    var isChecked = _.some(ctrl.checkedSecondLevelEntries, function (_care) {
      return _care.uid === care.uid;
    });
    return isChecked;
  }
}

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:TherapeuticProgramsCtrl
    * @description
    * # TherapeuticProgramsCtrl
    * Controller of therapeutic programs HMI
   */
  angular.module('mhclientApp').controller('TherapeuticProgramsCtrl', ["$scope", "$rootScope", "$state", function($scope, $rootScope, $state) {
    $scope.patient = $rootScope.currentPatient;
    $scope.stay = $rootScope.currentStay;
    $scope.platform = $rootScope.mh_config.platform;
    return $scope.user = $rootScope.user;
  }]);

}).call(this);

//# sourceMappingURL=therapeutic-programs-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:TpListContainerCtrl
    * @description
    * TpListContainerCtrl
    * Controller of the therapeutic programs list container directive
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('TpListContainerCtrl', ["$scope", "$q", "$uibModal", "Psp", "HealthIssue", "GroupUtils", "AgendaUtils", "ThesaurusUtils", function($scope, $q, $uibModal, Psp, HealthIssue, GroupUtils, AgendaUtils, ThesaurusUtils) {
    var init;
    $scope.tpList = [];
    $scope.groups = {};
    $scope.loaded = false;
    $scope.psp = null;
    init = function() {
      var promises;
      promises = [
        GroupUtils.getAllGroups(), Psp.api.query({
          "stay": $scope.stay.id
        }).$promise
      ];
      return $q.all(promises).then(function(data) {
        _.forEach(data[0], function(item) {
          return $scope.groups[item.id] = item.name;
        });
        return $scope.computePspData(data[1]);
      });
    };
    $scope.computePspData = function(pspList) {
      var nbPSP;
      nbPSP = pspList.length;
      if (nbPSP === 0) {
        return;
      }
      $scope.psp = pspList[nbPSP - 1];
      $scope.tpList = angular.copy($scope.psp.therapeutic_programs);
      return $scope.computeTpList();
    };
    $scope.computeTpList = function() {
      var promises;
      promises = [
        HealthIssue.api.query({
          "psp": $scope.psp.id
        }).$promise, Psp.api.getTasks({
          id: $scope.psp.id
        }).$promise, Psp.api.getActivities({
          id: $scope.psp.id
        }).$promise
      ];
      return $q.all(promises).then(function(data) {
        return ThesaurusUtils.getThesaurusCategories({
          type: "care"
        }, true, true).then(function(cat) {
          var ids;
          ids = _.map(cat, "id");
          return ThesaurusUtils.getThesaurusEntries((function(entry) {
            var ref;
            return ref = entry.category, indexOf.call(ids, ref) >= 0;
          }), true, true).then(function(entries) {
            var entriesIds;
            entriesIds = _.map(entries, "id");
            _.forEach($scope.tpList, function(tp) {
              var toBePlanned, tpActivities, tpActivitiesIds, tpIssuesIds;
              tpIssuesIds = _.map(_.filter(data[0], {
                tp_uid: tp.thesaurus_uid
              }), "id");
              tp.stopped = _.filter(data[0], {
                tp_uid: tp.thesaurus_uid,
                end_review: null
              }).length === 0;
              tpActivities = _.filter(data[2], function(a) {
                var ref;
                return ref = a.issue, indexOf.call(tpIssuesIds, ref) >= 0;
              });
              tpActivitiesIds = _.map(tpActivities, "id");
              toBePlanned = _.filter(tpActivities, function(a) {
                var ref;
                return a.sequence === null && (ref = a.thesaurus_entry, indexOf.call(entriesIds, ref) >= 0);
              });
              return AgendaUtils.groupTasksInEvents(_.filter(data[1], function(t) {
                var ref;
                return ref = t.activity, indexOf.call(tpActivitiesIds, ref) >= 0;
              })).then(function(events) {
                tp.suspended = _.filter(events, {
                  status: "SUSPENDED"
                }).length > 0;
                tp.events = [];
                _.forEach(events, function(event) {
                  return tp.events.push($scope.formatEvent(event));
                });
                return _.forEach(toBePlanned, function(activity) {
                  return tp.events.push($scope.formatActivity(activity));
                });
              });
            });
            return $scope.loaded = true;
          });
        });
      });
    };
    $scope.formatEvent = function(event) {
      var groups, ref, ref1, ref2;
      if ((ref = event.data) != null ? ref.user_full_name : void 0) {
        groups = event.data.user_full_name;
      } else {
        groups = "";
        _.forEach(event.groups_involved, function(gp) {
          if (gp !== null) {
            if (groups !== "") {
              groups += ", ";
            }
            return groups += $scope.groups[gp];
          }
        });
      }
      return {
        tasks: event.tasks,
        label: event.shortLabel,
        date: event.start,
        completionDate: (ref1 = event.data) != null ? ref1.done_time : void 0,
        suspendedDate: (ref2 = event.data) != null ? ref2.suspended_date : void 0,
        groups: groups,
        status: event.status,
        type: event.type
      };
    };
    $scope.formatActivity = function(activity) {
      return {
        id: activity.id,
        uid: activity.uid,
        label: activity.data.label,
        date: "",
        groups: "",
        status: "TO_BE_PLANNED",
        type: "activity"
      };
    };
    $scope.suspend = function(tp) {
      return Psp.api.suspendTP({
        id: $scope.psp.id,
        tpUid: tp.thesaurus_uid
      }).$promise.then(function(data) {
        return $scope.computePspData([data]);
      });
    };
    $scope.delay = function(tp) {
      var delayModal;
      delayModal = $uibModal.open({
        templateUrl: 'therapeutic-programs/delay-modal/views/delay-modal.html',
        controller: 'TpDelayModalCtrl',
        backdrop: 'static',
        resolve: {
          tp: function() {
            return tp;
          }
        }
      });
      return delayModal.result.then(function(result) {
        if (result) {
          return Psp.api.delayTP({
            id: $scope.psp.id,
            tpUid: tp.thesaurus_uid,
            startDate: moment(result.startDate).format("YYYY-MM-DD"),
            delay: result.delay
          }).$promise.then(function(data) {
            return $scope.computePspData([data]);
          });
        }
      });
    };
    $scope.resume = function(tp) {
      var delay, startDate;
      startDate = moment(_.find(tp.events, {
        status: "SUSPENDED"
      }).suspendedDate, "YYYY-MM-DD");
      delay = moment().diff(startDate, "days");
      return Psp.api.resumeTP({
        id: $scope.psp.id,
        tpUid: tp.thesaurus_uid,
        delay: delay
      }).$promise.then(function(data) {
        return $scope.computePspData([data]);
      });
    };
    $scope.updateEventCb = function() {
      return $scope.computeTpList();
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=tp-list-container-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:tpListContainer
    * @description
    * Directive displaying therapeutic programs defined in a psp
   */
  angular.module('mhclientApp').directive('tpListContainer', function() {
    return {
      restrict: 'E',
      templateUrl: 'therapeutic-programs/tp-list-container/views/tp-list-container.html',
      scope: {
        user: "=",
        patient: "=",
        stay: "=",
        platform: "="
      },
      controller: 'TpListContainerCtrl'
    };
  });

}).call(this);

//# sourceMappingURL=tp-list-container-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:TpEventListCtrl
   @description
    * TpEventListCtrl
    * Controller of the event list container directive
   */
  angular.module('mhclientApp').controller('TpEventListCtrl', ["$scope", "$rootScope", "$uibModal", "$window", "AgendaUtils", "AgendaTask", function($scope, $rootScope, $uibModal, $window, AgendaUtils, AgendaTask) {
    return $scope.openEvent = function(event) {
      var ref, ref1, task;
      if (((ref = event.tasks) != null ? ref.length : void 0) > 0) {
        task = event.tasks[0];
        if (task.status === "P") {
          if ((ref1 = task.data.selected_features) != null ? ref1.length : void 0) {
            if ($scope.platform === "mgapp") {
              $window.mgapp.lock_menu(true);
            }
            return $uibModal.open({
              templateUrl: 'taskplanner/views/task-actions.html',
              controller: 'TaskActionsCtrl',
              windowClass: 'modal-fullscreen',
              backdrop: 'static',
              resolve: {
                event: function() {
                  return event;
                },
                stay: function() {
                  return $scope.stay;
                },
                patient: function() {
                  return $scope.patient;
                },
                readonly: function() {
                  return false;
                }
              }
            }).result.then(function(result) {
              var formatedUpdatedTask, i, len, ref2, updatedTasks;
              if ($scope.platform === "mgapp") {
                $window.mgapp.lock_menu(false);
              }
              if (result) {
                $rootScope.busy = true;
                updatedTasks = result.tasks;
                event = AgendaUtils.genCoordinationEvent(updatedTasks);
                formatedUpdatedTask = [];
                ref2 = event.tasks;
                for (i = 0, len = ref2.length; i < len; i++) {
                  task = ref2[i];
                  formatedUpdatedTask.push({
                    id: task.id,
                    date: task.date,
                    user_involved: task.user_involved,
                    data: task.data,
                    status: task.status,
                    author: task.author
                  });
                }
                return AgendaTask.api.updateTasks(formatedUpdatedTask).$promise.then(function() {
                  $rootScope.busy = false;
                  return $scope.onModify();
                });
              }
            });
          }
        }
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=tp-event-list-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:tpEventList
    * @description
    * Directive displaying  events defined in therapeutic program
   */
  angular.module('mhclientApp').directive('tpEventList', function() {
    return {
      restrict: 'E',
      templateUrl: 'therapeutic-programs/tp-event-list/views/tp-event-list.html',
      scope: {
        events: "=",
        user: "=",
        patient: "=",
        stay: "=",
        platform: "=",
        onModify: "&"
      },
      controller: 'TpEventListCtrl'
    };
  });

}).call(this);

//# sourceMappingURL=tp-event-list-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:TpDelayModalCtrl
    * @description
    * TpDelayModalCtrl
    * Controller of TP delay modal
   */
  angular.module('mhclientApp').controller('TpDelayModalCtrl', ["$scope", "$uibModalInstance", "tp", function($scope, $uibModalInstance, tp) {
    var init;
    init = function() {
      $scope.startDate = moment().format();
      $scope.delay = 1;
      return $scope.tp = tp;
    };
    $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
    $scope.validate = function() {
      return $uibModalInstance.close({
        "startDate": $scope.startDate,
        "delay": $scope.delay
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=delay-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:ThesaurusEditorController
    * @description
    * # ThesaurusEditorController
    * Controller to edit thesaurus
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('ThesaurusEditController', ["$scope", "$rootScope", "ThesaurusUtils", "ThesaurusCategory", "FeatureUtils", "GenUID", "GroupUtils", "$uibModal", "$filter", "Entity", "$q", function($scope, $rootScope, ThesaurusUtils, ThesaurusCategory, FeatureUtils, GenUID, GroupUtils, $uibModal, $filter, Entity, $q) {
    var computeOptions, genMissingCategories, staticCategories;
    $scope.supportedTypes = [
      {
        type: "agenda",
        label: $filter('translate')("TYPE_OPTION_AGENDA")
      }, {
        type: "care",
        label: $filter('translate')("TYPE_OPTION_CARE"),
        options: {
          enableLinkToFeatures: true
        },
        allowCreation: true
      }, {
        type: "coordination",
        label: $filter('translate')("TYPE_OPTION_COORDINATION"),
        options: {
          enableLinkToFeatures: true
        },
        allowCreation: true
      }, {
        type: "medication",
        label: $filter('translate')("TYPE_OPTION_MEDICATION")
      }, {
        type: "psp",
        label: $filter('translate')("TYPE_OPTION_PSP")
      }, {
        type: "punctual_activity",
        label: $filter('translate')("TYPE_OPTION_PUNCTUAL_ACTIVITY"),
        options: {
          enableLinkToFeatures: true
        },
        allowCreation: true
      }
    ];
    staticCategories = [
      {
        type: "psp",
        requestedFeature: "MHC_PSP",
        code: "therapeutic_programs",
        label: $filter('translate')("Therapeutic Programs"),
        data: {
          colors: ["rgb(91, 155, 213)", "rgb(237, 125, 49)"]
        },
        options: {
          selectableCategories: function(cat) {
            return cat.code === 'health_issues';
          },
          disableNodes: true
        }
      }, {
        type: "psp",
        requestedFeature: "MHC_PSP",
        code: "health_issues",
        label: $filter('translate')("Health issues"),
        data: {
          colors: ["rgb(232, 32, 165)", "rgb(112, 173, 71)"]
        },
        options: {
          selectableCategories: function(cat) {
            var ref;
            return (ref = cat.type) === 'care' || ref === 'coordination';
          },
          groupCategoriesBy: function(category) {
            return $filter('translate')(category.type === "care" ? "CARES" : "Coordination");
          },
          orderCategoriesBy: function(categories) {
            return $filter('orderBy')(categories, "name");
          }
        }
      }, {
        type: "medication",
        code: "care",
        label: $filter('translate')("Care"),
        options: {
          maxLevel: 1
        }
      }, {
        type: "medication",
        code: "laboratory",
        label: $filter('translate')("Laboratory"),
        options: {
          byEntity: true,
          maxLevel: 2
        }
      }, {
        type: "medication",
        code: "biologic",
        label: $filter('translate')("Biologic"),
        options: {
          maxLevel: 1
        }
      }
    ];
    $scope.initColors = function(size) {
      return new Array(size);
    };
    $scope.canBillConfig = $rootScope.user.is_superuser || indexOf.call($rootScope.user.group.features, "BILL_CONFIG") >= 0;
    $scope.groupCategoriesByType = function(choice) {
      return (_.find($scope.supportedTypes, {
        type: choice.category.type
      }) || {}).label || "";
    };
    $scope.orderCategoriesBy = function(categories) {
      return $filter('orderBy')(categories, "name");
    };
    $scope.choices = {};
    $scope.editCategory = function(category) {
      $scope.modifiedCategory = _.cloneDeep(category);
      return $uibModal.open({
        templateUrl: 'thesaurus/views/category-edition.html',
        scope: $scope,
        windowClass: 'modal-fullscreen'
      }).result.then(function(modifiedCategory) {
        return ThesaurusCategory.api.update(_.assign(category, modifiedCategory));
      });
    };
    $scope.newCategory = function() {
      $scope.modifiedCategory = {
        code: GenUID.generate(16)
      };
      return $uibModal.open({
        templateUrl: 'thesaurus/views/category-edition.html',
        scope: $scope,
        windowClass: 'modal-fullscreen'
      }).result.then(function(modifiedCategory) {
        return ThesaurusUtils.genCategory(modifiedCategory).then(function(category) {
          return $scope.categoryChoices.push({
            category: category,
            options: computeOptions(category)
          });
        });
      });
    };
    computeOptions = function(category) {
      return _.assign((_.find(staticCategories, {
        code: category.code
      }) || {}).options, (_.find($scope.supportedTypes, {
        type: category.type
      }) || {}).options);
    };
    genMissingCategories = function(existingCategories) {
      return FeatureUtils.getAllFeatures().then(function(features) {
        var activeFeaturesNames, availableCategories;
        activeFeaturesNames = _.map(_.filter(features, "active"), "name");
        availableCategories = _.filter(staticCategories, function(cat) {
          var ref;
          return !cat.requestedFeature || (ref = cat.requestedFeature, indexOf.call(activeFeaturesNames, ref) >= 0);
        });
        return $q.all(_.map($filter('checkNotIn')(availableCategories, existingCategories, 'code', 'code'), function(missingCategory) {
          return ThesaurusUtils.genCategory(_.pick(missingCategory, ["type", "label", "code", "data"]));
        }));
      });
    };
    $rootScope.busy = true;
    return Entity.getEntities().then(function(entities) {
      return GroupUtils.getAllGroups().then(function(groups) {
        return ThesaurusUtils.getThesaurusCategories((function(cat) {
          return _.find($scope.supportedTypes, {
            type: cat.type
          });
        }), true, true).then(function(categories) {
          return genMissingCategories(categories).then(function(createdCategories) {
            $scope.categoryChoices = _.map(_.concat(categories, createdCategories), function(cat) {
              return {
                category: cat,
                options: computeOptions(cat)
              };
            });
            $scope.entities = entities;
            $scope.filters = {
              searchText: "",
              showObsolete: false
            };
            $scope.groups = groups;
            return $rootScope.busy = false;
          });
        });
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=thesaurus-edit-controller.js.map

(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").factory('ThesaurusCategory', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, care_thesaurus_category, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/taskplanner/thesaurus_categories/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        method: 'PATCH',
        params: {
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        care_thesaurus_category = window.mgapp.get('taskplanner').thesaurus_category();
        api = BoxResource.generate(care_thesaurus_category);
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('ThesaurusEntry', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, care_thesaurus_category, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/taskplanner/thesaurus_entries/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        method: 'PATCH',
        params: {
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        care_thesaurus_category = window.mgapp.get('taskplanner').thesaurus_entry();
        api = BoxResource.generate(care_thesaurus_category);
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('ThesaurusUtils', ["$filter", "$rootScope", "$q", "Activity", "$uibModal", "ThesaurusCategory", "ThesaurusEntry", "FormTemplateUtils", "$http", "GroupUtils", "FeedUtils", "FeatureUtils", function($filter, $rootScope, $q, Activity, $uibModal, ThesaurusCategory, ThesaurusEntry, FormTemplateUtils, $http, GroupUtils, FeedUtils, FeatureUtils) {
    var addThesaurusCategory, addThesaurusEntry, agendaCategories, base_slider_option, cachedThesaurusCategories, cachedThesaurusEntries, careCategories, extract_selectable_items, fetchActivities, filterEntries, filterItem, filterThesaurus, formatThesaurusEntries, genCategory, getAgendaCategories, getCareCategories, getLinkableFeatures, getPT, getPlaceOptions, getPunctualActivityCategories, getThesaurusCategories, getThesaurusEntries, globalThesaurusCategoriesPromise, globalThesaurusEntriesPromise, globalcareCategoriesPromise, handlePrice, newFamily, newSequenceForStay, preselectActivities, punctualActivityCategories, replanSequence, service, time_str_from_minuts, updateThesaurusEntry, uuid;
    careCategories = null;
    agendaCategories = null;
    punctualActivityCategories = null;
    globalcareCategoriesPromise = $q.defer();
    base_slider_option = {
      translate: function(minutes) {
        return time_str_from_minuts(minutes) + "H";
      },
      step: 15,
      hideLimitLabels: true,
      "floor": 0,
      "ceil": 1440
    };
    time_str_from_minuts = function(minutes, convert_midnight) {
      var duration, hours;
      duration = moment.duration(minutes, 'minutes');
      if (convert_midnight && duration.hours() === 0) {
        return "23:59";
      }
      hours = duration.hours();
      minutes = duration.minutes() < 10 ? "0" + duration.minutes() : duration.minutes();
      return hours + ":" + minutes;
    };
    extract_selectable_items = function(item, level, thesaurus_entry, start_level, category) {
      var child_item, i, len, ref, results;
      item.level = level;
      item.thesaurus_entry = thesaurus_entry;
      item.active = level <= start_level;
      if (item.hide === void 0) {
        item.hide = false;
      }
      item.data = {
        label: item.name || item.label,
        hide: item.hide || item.obsolete,
        short_name: item.name || item.label,
        duration: item.duration,
        type: item.type,
        quantity: item.quantity,
        uid: item.uid,
        selected_features: item.selectedFeatures
      };
      item.planning_data = {
        caregivers: {}
      };
      item.validation_groups = [];
      if (item.entries != null) {
        ref = item.entries;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          child_item = ref[i];
          results.push(extract_selectable_items(child_item, item.level + 1, thesaurus_entry, start_level, category));
        }
        return results;
      }
    };
    formatThesaurusEntries = function(category, start_level) {
      var thesaurus_entries_promise;
      thesaurus_entries_promise = $q.defer();
      getThesaurusEntries({
        "category": category.id
      }, true).then(function(thesaurus_entries) {
        var child_item, i, j, len, len1, ref, thesaurus_entry;
        for (i = 0, len = thesaurus_entries.length; i < len; i++) {
          thesaurus_entry = thesaurus_entries[i];
          thesaurus_entry.level = 0;
          thesaurus_entry.active = true;
          thesaurus_entry.hide = thesaurus_entry.obsolete;
          thesaurus_entry.validation_groups = category.groups;
          ref = thesaurus_entry.entries;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            child_item = ref[j];
            extract_selectable_items(child_item, thesaurus_entry.level + 1, thesaurus_entry, start_level, category);
          }
        }
        category.entries = thesaurus_entries;
        return thesaurus_entries_promise.resolve();
      });
      return thesaurus_entries_promise.promise;
    };
    getCareCategories = function() {
      var CareCategoriesPromise;
      CareCategoriesPromise = $q.defer();
      if (careCategories != null) {
        globalcareCategoriesPromise.promise.then(function() {
          return CareCategoriesPromise.resolve(angular.copy(careCategories));
        });
      } else {
        careCategories = [];
        ThesaurusCategory.api.query({
          type: "care"
        }).$promise.then(function(thesaurus_categories) {
          return GroupUtils.getAllGroups().then(function(groups) {
            var category, i, len, promises;
            promises = [];
            for (i = 0, len = thesaurus_categories.length; i < len; i++) {
              category = thesaurus_categories[i];
              category.groups = _.map(category.groups, function(groupId) {
                return _.find(groups, {
                  id: groupId
                });
              });
              promises.push(formatThesaurusEntries(category, careCategories[category.label], 0));
            }
            careCategories = $filter('orderBy')(thesaurus_categories, "data.order");
            return $q.all(promises).then(function() {
              CareCategoriesPromise.resolve(angular.copy(careCategories));
              return globalcareCategoriesPromise.resolve();
            });
          });
        });
      }
      return CareCategoriesPromise;
    };
    getAgendaCategories = function() {
      var AgendaCategoriesPromise;
      AgendaCategoriesPromise = $q.defer();
      if (agendaCategories != null) {
        AgendaCategoriesPromise.resolve(angular.copy(agendaCategories));
      } else {
        agendaCategories = [];
        ThesaurusCategory.api.query({
          type: 'agenda'
        }).$promise.then(function(categories) {
          agendaCategories = categories;
          return ThesaurusCategory.api.query({
            type: 'coordination'
          }).$promise.then(function(coordCategories) {
            var category, i, len;
            for (i = 0, len = coordCategories.length; i < len; i++) {
              category = coordCategories[i];
              agendaCategories.push(category);
            }
            return AgendaCategoriesPromise.resolve(angular.copy(agendaCategories));
          });
        });
      }
      return AgendaCategoriesPromise;
    };
    getPunctualActivityCategories = function() {
      var deferred;
      deferred = $q.defer();
      if (punctualActivityCategories != null) {
        deferred.resolve(angular.copy(punctualActivityCategories));
      } else {
        punctualActivityCategories = [];
        ThesaurusCategory.api.query({
          type: 'punctual_activity'
        }).$promise.then(function(categories) {
          return GroupUtils.getAllGroups().then(function(groups) {
            var category, entriesPromises, i, len;
            entriesPromises = [];
            for (i = 0, len = categories.length; i < len; i++) {
              category = categories[i];
              category.groups = _.map(category.groups, function(groupId) {
                return _.find(groups, {
                  id: groupId
                });
              });
              entriesPromises.push(formatThesaurusEntries(category, 0));
            }
            return $q.all(entriesPromises).then(function(entries) {
              punctualActivityCategories = $filter('orderBy')(categories, ["data.order", "label"]);
              return deferred.resolve(angular.copy(punctualActivityCategories));
            });
          });
        });
      }
      return deferred.promise;
    };
    newFamily = function(thesaurusType) {
      return {
        groups: [],
        label: "",
        code: "",
        data: {
          order: ""
        },
        type: thesaurusType,
        show_in_agenda: true
      };
    };
    filterItem = function(item, force_visible, filter, showObsolete) {
      var child_found, child_item, i, item_found, len, ref;
      child_found = false;
      item_found = item.label.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      if (item.entries != null) {
        ref = item.entries;
        for (i = 0, len = ref.length; i < len; i++) {
          child_item = ref[i];
          child_found = filterItem(child_item, item_found || force_visible, filter, showObsolete) || child_found;
        }
      }
      if (item_found || force_visible || child_found) {
        item.hide = false || (item.obsolete && !showObsolete);
      } else {
        item.hide = true;
      }
      return !item.hide;
    };
    filterThesaurus = function(thesaurus_tree, filter, showObsolete) {
      var i, item, len, results;
      results = [];
      for (i = 0, len = thesaurus_tree.length; i < len; i++) {
        item = thesaurus_tree[i];
        results.push(filterItem(item, false, filter || '', showObsolete));
      }
      return results;
    };
    preselectActivities = function(categories, new_sequence) {
      var activities_dict, activity, category, entry, i, j, len, len1, ref, results, thesaurus_entry;
      activities_dict = {};
      ref = new_sequence.activities;
      for (i = 0, len = ref.length; i < len; i++) {
        activity = ref[i];
        activity.selected = true;
        if (!activities_dict[activity.thesaurus_entry.id]) {
          activities_dict[activity.thesaurus_entry.id] = {};
        }
        activities_dict[activity.thesaurus_entry.id][activity.data.uid] = activity;
      }
      results = [];
      for (j = 0, len1 = categories.length; j < len1; j++) {
        category = categories[j];
        results.push((function() {
          var k, len2, ref1, results1;
          ref1 = category.entries;
          results1 = [];
          for (k = 0, len2 = ref1.length; k < len2; k++) {
            thesaurus_entry = ref1[k];
            if (activities_dict[thesaurus_entry.id] != null) {
              results1.push((function() {
                var l, len3, ref2, results2;
                ref2 = thesaurus_entry.entries;
                results2 = [];
                for (l = 0, len3 = ref2.length; l < len3; l++) {
                  entry = ref2[l];
                  if (activities_dict[thesaurus_entry.id][entry.uid] != null) {
                    entry.planning_data = activities_dict[thesaurus_entry.id][entry.uid].planning_data;
                    entry.validation_groups = activities_dict[thesaurus_entry.id][entry.uid].validation_groups;
                    entry.data = activities_dict[thesaurus_entry.id][entry.uid].data;
                    entry = _.defaults(entry, activities_dict[thesaurus_entry.id][entry.uid]);
                    new_sequence.activities.splice(new_sequence.activities.indexOf(activities_dict[thesaurus_entry.id][entry.uid]), 1);
                    results2.push(new_sequence.activities.push(entry));
                  } else {
                    results2.push(void 0);
                  }
                }
                return results2;
              })());
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      }
      return results;
    };
    newSequenceForStay = function(stay, dayLabel) {
      var i, index, len, new_sequence, week_day;
      new_sequence = {
        time_slots: [
          {
            floor: 0,
            ceil: 1440,
            options: angular.copy(base_slider_option)
          }
        ],
        status: 'pending',
        activities: [],
        data: {
          estimated_times: []
        },
        planning_data: {
          dates: [],
          week_days: [],
          timeslots: [],
          type: "cycled",
          end_mode: "duration",
          frequency_unit: "days"
        },
        stay: stay.id,
        unfold: true,
        week_days: []
      };
      for (index = i = 0, len = dayLabel.length; i < len; index = ++i) {
        week_day = dayLabel[index];
        new_sequence.week_days.push({
          code: index,
          label: week_day,
          selected: false
        });
      }
      return new_sequence;
    };
    replanSequence = function(sequence, dayLabel) {
      var activity, i, index, j, k, len, len1, len2, new_sequence, ref, ref1, replan_sequence_promise, time_slot, week_day;
      replan_sequence_promise = $q.defer();
      new_sequence = angular.copy(sequence);
      new_sequence.sequence_original = sequence;
      new_sequence.time_slots = [];
      new_sequence.week_days = [];
      new_sequence.stopped_activities = [];
      new_sequence.historical.push(angular.copy(new_sequence.planning_data));
      new_sequence.planning_data.start_date = new Date();
      new_sequence.planning_data.end_date = null;
      new_sequence.validation_groups = [];
      if (new_sequence.data.state != null) {
        delete new_sequence.data.state;
      }
      if (new_sequence.planning_data.dates) {
        new_sequence.planning_data.dates = sequence.planning_data.dates.map(function(date) {
          return moment(date, "DD/MM/YYYY");
        });
      }
      ref = new_sequence.planning_data.timeslots;
      for (i = 0, len = ref.length; i < len; i++) {
        time_slot = ref[i];
        new_sequence.time_slots.push({
          floor: moment.duration(moment(time_slot.start_time, "HH:mm")).asMinutes(),
          ceil: moment.duration(moment(time_slot.end_time, "HH:mm")).asMinutes(),
          options: angular.copy(base_slider_option)
        });
      }
      ref1 = new_sequence.activities;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        activity = ref1[j];
        activity.historical.push(angular.copy(activity.planning_data));
        activity.planning_data = {
          caregivers: activity.planning_data.caregivers,
          has_liberal: activity.planning_data.has_liberal
        };
        activity.validation_groups = _.keys(activity.planning_data.caregivers);
        if (activity.data.state != null) {
          delete activity.data.state;
        }
      }
      for (index = k = 0, len2 = dayLabel.length; k < len2; index = ++k) {
        week_day = dayLabel[index];
        new_sequence.week_days.push({
          code: index,
          label: week_day,
          selected: indexOf.call(new_sequence.planning_data.week_days, index) >= 0
        });
      }
      getCareCategories().promise.then(function(care_categories) {
        new_sequence.thesaurus_categories = care_categories;
        preselectActivities(new_sequence.thesaurus_categories, new_sequence);
        return replan_sequence_promise.resolve(new_sequence);
      });
      return replan_sequence_promise.promise;
    };
    handlePrice = function(activities, planning_data) {
      var activity, i, len, one_day_price;
      return;
      one_day_price = 0;
      for (i = 0, len = activities.length; i < len; i++) {
        activity = activities[i];
        one_day_price += activity.data.type(activity.data.quantity);
      }
      if (planning_data.type === "dates") {
        planning_data.start_date;
        planning_data.end_date;
        planning_data.type;
        return planning_data.frequency_unit;
      }
    };
    filterEntries = function(entries, query, many, dontCopy) {
      var result;
      if (query) {
        result = many ? _.filter(entries, query) : _.find(entries, query);
      } else {
        result = entries;
      }
      if (dontCopy) {
        return result;
      } else {
        if (result instanceof Array) {
          return _.map(result, _.cloneDeep);
        } else {
          return _.cloneDeep(result);
        }
      }
    };
    cachedThesaurusCategories = null;
    globalThesaurusCategoriesPromise = $q.defer();
    cachedThesaurusEntries = null;
    globalThesaurusEntriesPromise = $q.defer();
    getThesaurusCategories = function(query, many, dontCopy) {
      var thesaurusCategoriesDone;
      thesaurusCategoriesDone = $q.defer();
      if (cachedThesaurusCategories != null) {
        globalThesaurusCategoriesPromise.promise.then(function() {
          return thesaurusCategoriesDone.resolve(filterEntries(cachedThesaurusCategories, query, many, dontCopy));
        });
      } else {
        cachedThesaurusCategories = {};
        ThesaurusCategory.api.query().$promise.then(function(thesaurusCategories) {
          cachedThesaurusCategories = thesaurusCategories;
          globalThesaurusCategoriesPromise.resolve();
          return thesaurusCategoriesDone.resolve(filterEntries(cachedThesaurusCategories, query, many, dontCopy));
        });
      }
      return thesaurusCategoriesDone.promise;
    };
    genCategory = function(category) {
      return ThesaurusCategory.api.save(category).$promise.then(function(category) {
        addThesaurusCategory(category);
        return category;
      });
    };
    addThesaurusEntry = function(entry) {
      if (cachedThesaurusEntries != null) {
        return cachedThesaurusEntries.push(entry);
      }
    };
    addThesaurusCategory = function(category) {
      if (cachedThesaurusCategories != null) {
        return cachedThesaurusCategories.push(category);
      }
    };
    fetchActivities = function(activityParams) {
      var activitiesDone;
      activitiesDone = $q.defer();
      getThesaurusEntries().then(function(thesaurusEntries) {
        return Activity.api.query(activityParams).$promise.then(function(activities) {
          _.forEach(activities, function(activity) {
            return activity.thesaurus_entry = _.find(thesaurusEntries, {
              id: activity.thesaurus_entry
            });
          });
          return activitiesDone.resolve(activities);
        });
      });
      return activitiesDone.promise;
    };
    updateThesaurusEntry = function(entry) {
      var index;
      index = _.findIndex(cachedThesaurusEntries, {
        id: entry.id
      });
      return cachedThesaurusEntries.splice(index, 1, entry);
    };
    getThesaurusEntries = function(query, many, dontCopy) {
      var thesaurusEntriesDone;
      thesaurusEntriesDone = $q.defer();
      if (cachedThesaurusEntries != null) {
        globalThesaurusEntriesPromise.promise.then(function() {
          return thesaurusEntriesDone.resolve(filterEntries(cachedThesaurusEntries, query, many, dontCopy));
        });
      } else {
        cachedThesaurusEntries = {};
        ThesaurusEntry.api.query().$promise.then(function(thesaurusEntries) {
          cachedThesaurusEntries = thesaurusEntries;
          globalThesaurusEntriesPromise.resolve();
          return thesaurusEntriesDone.resolve(filterEntries(cachedThesaurusEntries, query, many, dontCopy));
        });
      }
      return thesaurusEntriesDone.promise;
    };
    uuid = function() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r, v;
        r = Math.random() * 16 | 0;
        v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    };
    getPlaceOptions = function() {
      return ["Hospital", "Clinic", "Other"];
    };
    getLinkableFeatures = function() {
      return FormTemplateUtils.getTemplatesWithCurrent().then(function(formTemplates) {
        return FeedUtils.getFeedsByName("MHC_WORK_REPORT").then(function(workReportFeeds) {
          var linkableFeatures;
          linkableFeatures = [
            {
              "id": 1,
              "directive": "administration",
              "feature": "ORA"
            }, {
              "id": 2,
              "directive": "take-measures",
              "feature": "SVM"
            }, {
              "id": 3,
              "directive": "medform-version",
              "options": {
                options: _.forEach(formTemplates, function(t) {
                  return t.name = t.current.name;
                }),
                groupBy: "group_name",
                label: "name",
                key: "uid"
              },
              "feature": "MHC_FORMS"
            }, {
              "id": 4,
              "directive": "transmission-list",
              "feature": "MHC_TRANSMISSION"
            }, {
              "id": 5,
              "directive": "order-list",
              "feature": "MHC_ORDERS"
            }, {
              "id": 6,
              "directive": "patient-entourage",
              "feature": "MHC_CONTACTS"
            }, {
              "id": 7,
              "directive": "photo",
              "feature": "IMG"
            }, {
              "id": 8,
              "directive": "work-report",
              "options": {
                options: _.forEach(workReportFeeds, function(f) {
                  return f.name = $filter("translate")(f.view);
                }),
                label: "name",
                key: "view"
              },
              "feature": "MHC_WORK_REPORT"
            }
          ];
          return FeatureUtils.getAllFeatures().then(function(features) {
            return _.filter(linkableFeatures, function(lf) {
              var feature;
              feature = _.find(features, {
                "name": lf.feature
              });
              if (feature && feature.active) {
                lf.name = feature.short_label || feature.label;
                return true;
              } else {
                return false;
              }
            });
          });
        });
      });
    };
    getPT = function() {
      return getThesaurusCategories({}, true).then(function(categories) {
        return getThesaurusEntries({}, true).then(function(thesaurusEntries) {
          var issues, pts;
          pts = _.filter(thesaurusEntries, {
            category: _.find(categories, {
              code: "therapeutic_programs"
            }).id
          });
          issues = _.filter(thesaurusEntries, {
            category: _.find(categories, {
              code: "health_issues"
            }).id
          });
          return _.forEach(pts, function(pt) {
            pt.objectives = _.clone(pt.entries, true);
            delete pt.entries;
            return _.forEach(pt.objectives, function(objetiv) {
              return objetiv.health_issues = _.map(objetiv.entries, function(issue) {
                return _.find(issues, {
                  uid: issue.entry_uid
                });
              });
            });
          });
        });
      });
    };
    service = {
      getPT: getPT,
      getCareCategories: getCareCategories,
      getAgendaCategories: getAgendaCategories,
      getPunctualActivityCategories: getPunctualActivityCategories,
      addThesaurusEntry: addThesaurusEntry,
      updateThesaurusEntry: updateThesaurusEntry,
      filter: filterThesaurus,
      preselectActivities: preselectActivities,
      handlePrice: handlePrice,
      newSequenceForStay: newSequenceForStay,
      replanSequence: replanSequence,
      getThesaurusCategories: getThesaurusCategories,
      getThesaurusEntries: getThesaurusEntries,
      getPlaceOptions: getPlaceOptions,
      fetchActivities: fetchActivities,
      genCategory: genCategory,
      addThesaurusCategory: addThesaurusCategory,
      uuid: uuid,
      newFamily: newFamily,
      getLinkableFeatures: getLinkableFeatures
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=thesaurus-service.js.map

(function() {
  'use strict';
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').directive('thesaurusCategoryEdition', function() {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'thesaurus/views/category.html';
        }
      },
      scope: {
        category: "=thesaurusCategoryEdition",
        entityId: "=?",
        categoryOptions: "=",
        searchText: "=",
        showObsolete: "="
      },
      link: function(scope, elem, attrs) {
        return scope.$watch("category", function(newValue, oldValue) {
          return scope.render();
        });
      },
      controller: ["$rootScope", "$filter", "$scope", "$q", "$uibModal", "ThesaurusUtils", "ThesaurusCategory", "ThesaurusEntry", "GenUID", "GroupUtils", "BillingUnitUtils", function($rootScope, $filter, $scope, $q, $uibModal, ThesaurusUtils, ThesaurusCategory, ThesaurusEntry, GenUID, GroupUtils, BillingUnitUtils) {
        var handleObsolete;
        $scope.level = 0;
        $scope.defaultColors = ['rgb(38, 38, 38)', 'rgb(107, 34, 180)', 'rgb(58, 58, 58)', 'rgb(68, 68, 68)'];
        handleObsolete = function(entries) {
          return _.some(entries, function(entry) {
            return entry.obsolete || handleObsolete(entry.entries);
          });
        };
        $scope.render = function() {
          $rootScope.busy = true;
          return ThesaurusUtils.getThesaurusEntries({
            entity: $scope.entityId,
            category: $scope.category.id
          }, true, true).then(function(entries) {
            return ThesaurusUtils.getThesaurusCategories($scope.categoryOptions.selectableCategories || [], true, true).then(function(relatedCategories) {
              var relatedCategoriesIds;
              relatedCategoriesIds = _.map(relatedCategories, "id");
              return ThesaurusUtils.getThesaurusEntries((function(e) {
                var ref;
                return e.entity === $scope.entityId && (ref = e.category, indexOf.call(relatedCategoriesIds, ref) >= 0);
              }), true, true).then(function(relatedEntries) {
                $scope.relatedCategories = relatedCategories;
                $scope.relatedEntries = relatedEntries;
                $scope.entries = entries;
                $scope.hasObsoleteEntries = handleObsolete($scope.entries);
                return $rootScope.busy = false;
              });
            });
          });
        };
        $scope.newEntry = function() {
          $scope.modifiedEntry = {
            "category": $scope.category.id,
            "label": "",
            "entries": [],
            "entity": $scope.entityId
          };
          return $uibModal.open({
            templateUrl: 'thesaurus/views/entry-edition.html',
            scope: $scope
          }).result.then(function(modifiedEntry) {
            return ThesaurusEntry.api.save(modifiedEntry).$promise.then(function(entry) {
              ThesaurusUtils.addThesaurusEntry(entry);
              return $scope.entries.unshift(entry);
            });
          });
        };
        $scope.editEntry = function(sourceEntry) {
          $scope.modifiedEntry = _.cloneDeep(sourceEntry);
          return $uibModal.open({
            templateUrl: 'thesaurus/views/entry-edition.html',
            scope: $scope
          }).result.then(function(modifiedEntry) {
            return ThesaurusEntry.api.update(_.omit(_.assign(sourceEntry, modifiedEntry), "entries")).$promise.then(function() {
              return $scope.hasObsoleteEntries = handleObsolete($scope.entries);
            });
          });
        };
        $scope.editNode = function(entry, container, sourceNode) {
          $scope.modifiedNode = sourceNode ? _.cloneDeep(sourceNode) : {
            name: name,
            entries: []
          };
          $scope.sourceNode = sourceNode;
          return $uibModal.open({
            templateUrl: 'thesaurus/views/node-edition.html',
            scope: $scope
          }).result.then(function(modifiedNode) {
            if (sourceNode) {
              _.assign(sourceNode, modifiedNode);
            } else {
              container.entries.push(modifiedNode);
            }
            return ThesaurusEntry.api.update({
              id: entry.id
            }, {
              entries: entry.entries
            }).$promise.then(function() {
              return $scope.hasObsoleteEntries = handleObsolete($scope.entries);
            });
          });
        };
        return $scope.editItem = function(entry, container, sourceItem) {
          $rootScope.busy = true;
          return BillingUnitUtils.getCareBillingUnits().then(function(billing_units) {
            return ThesaurusUtils.getLinkableFeatures().then(function(linkableFeatures) {
              return GroupUtils.getAllGroups().then(function(groups) {
                var itemModal;
                $scope.selectableItems = [].concat.apply([], _.map($scope.relatedEntries, function(entry) {
                  var entryDict;
                  entryDict = {
                    entryUid: entry.uid,
                    entryLabel: entry.label,
                    entryObsolete: entry.obsolete,
                    categoryCode: _.find($scope.relatedCategories, {
                      id: entry.category
                    }).code
                  };
                  return _.map(entry.entries, function(item) {
                    return _.assign(item, entryDict);
                  });
                }));
                $scope.linkableFeatures = linkableFeatures;
                $scope.groups = groups;
                $scope.careBu = billing_units;
                $scope.entry = entry;
                $scope.modifiedItem = sourceItem ? _.cloneDeep(sourceItem) : {
                  uid: GenUID.generate(16)
                };
                $scope.sourceItem = sourceItem;
                $rootScope.busy = false;
                $scope.$watch('modifiedItem', function(newValue, oldValue) {
                  var error, error1;
                  try {
                    return $filter("CareThesaurusDisplayText")(newValue);
                  } catch (error1) {
                    error = error1;
                  }
                }, true);
                itemModal = $uibModal.open({
                  templateUrl: 'thesaurus/views/item-edition.html',
                  scope: $scope,
                  windowClass: 'modal-fullscreen'
                });
                return itemModal.result.then(function(modifiedItem) {
                  $rootScope.busy = true;
                  if (sourceItem) {
                    _.assign(sourceItem, modifiedItem);
                  } else {
                    container.entries.push(modifiedItem);
                  }
                  return ThesaurusEntry.api.update({
                    id: entry.id
                  }, {
                    entries: entry.entries
                  }).$promise.then(function() {
                    $scope.hasObsoleteEntries = handleObsolete($scope.entries);
                    return $rootScope.busy = false;
                  });
                });
              });
            });
          });
        };
      }]
    };
  });

  angular.module('mhclientApp').directive('thesaurusItem', ["RecursionHelper", function(RecursionHelper) {
    return {
      templateUrl: 'thesaurus/views/item.html',
      scope: {
        editItem: "=",
        editNode: "=",
        editEntry: "=",
        entries: "=",
        categoryOptions: "=",
        searchText: "=",
        showObsolete: "=",
        entry: "=",
        level: "=",
        defaultColors: "=",
        relatedCategories: "=",
        relatedEntries: "=",
        category: "="
      },
      compile: function(element) {
        return RecursionHelper.compile(element);
      }
    };
  }]);

  angular.module('mhclientApp').filter('thesaurusItemFilter', function() {
    return function(entries, searchText, showObsolete) {
      var checkEntry, regex;
      regex = (searchText != null) && searchText.length > 0 ? new RegExp('' + searchText.replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i') : false;
      checkEntry = function(entry) {
        return (showObsolete || !entry.obsolete) && (!regex || regex.test(entry.label) || _.some(entry.entries, function(item) {
          return checkEntry(item);
        }));
      };
      return _.filter(entries, checkEntry);
    };
  });

  angular.module('mhclientApp').filter('CareThesaurusDisplayText', function() {
    return function(item) {
      var d_shif_label, d_shift, duration, frequency, posology;
      if (item.related_entry.type !== 'care') {
        return "";
      }
      posology = "";
      if (item.planning_frequency_unit && item.planning_end_mode && item.planning_frequency) {
        frequency = item.planning_frequency > 1 ? item.planning_frequency + ' ' : '';
        if (item.planning_frequency_unit === "weeks") {
          posology += item.planning_weekly_frequency + " fois toutes les " + frequency + "semaines. ";
        } else {
          posology += "Tous les " + frequency + "jours. ";
        }
        if (item.planning_end_mode === "duration") {
          duration = moment.duration(item.planning_duration, item.planning_frequency_unit);
          posology += "Durant " + (humanizeDuration(duration, {
            language: "fr",
            units: [item.planning_frequency_unit[0]]
          })) + ". ";
        } else {
          posology += "Pour une durée indéterminée. ";
        }
      }
      if (item.j0_shift != null) {
        if (item.j0_shift < 0) {
          d_shift = humanizeDuration(moment.duration(Math.abs(item.j0_shift), "days"), {
            language: "fr",
            units: ["d"]
          });
          d_shif_label = d_shift + " en avance";
        } else {
          d_shift = humanizeDuration(moment.duration(item.j0_shift, "days"), {
            language: "fr",
            units: ["d"]
          });
          d_shif_label = "À " + d_shift + " d'écart";
        }
      }
      item.posology = posology;
      item.order = item.j0_shift;
      if (d_shif_label != null) {
        item.display_html = d_shif_label + ". <b>" + (_.escape(item.label)) + ".</b> <i>" + posology + "</i>";
      } else {
        item.display_html = "<b>" + (_.escape(item.label)) + ".</b> <i>" + posology + "</i>";
      }
      if (item.comment) {
        return item.display_html += _.capitalize(_.escape(item.comment)) + ".";
      }
    };
  });

}).call(this);

//# sourceMappingURL=category-edition-directive.js.map

'use strict';

angular.module("mhclientApp").component("productComment", {
  templateUrl: "posos/views/product-comment.html",
  bindings: {prescription: '<'},
});

angular.module("mhclientApp").component("productPeriod", {
  templateUrl: "posos/views/product-period.html",
  bindings: {prescription: '<', onlyDates: "<?"},
  controller: ["$rootScope", "PrescUtils", "$timeout", function productTakesCtrl($rootScope, PrescUtils, $timeout){
    var ctrl = this;

    ctrl.week_days = _.map($rootScope.DATETIME_FORMATS.DAY, function (week_day, index) {
      return {code: index, label: week_day, selected: _.includes(ctrl.prescription.data.week_days, index)}
    })

    ctrl.selectWeekDay = function(week_days, week_day) {
      if (week_day.selected) {
        return week_days.push(week_day.code);
      } else {
        return week_days.splice(week_days.indexOf(week_day.code), 1);
      }
    };


    ctrl.$doCheck = function() {
      if (ctrl.prescription.data.type === "dates") {
         $timeout(function() {
           ctrl.prescription.data.dates = angular.copy(ctrl.prescription.data.dates);
           ctrl.prescription.data.dates.sort(function(left, right) { return moment(left).diff(moment(right));});
           ctrl.prescription.start_date = moment(ctrl.prescription.data.dates[0]).format("YYYY-MM-DD");
           ctrl.prescription.end_date = moment(ctrl.prescription.data.dates[ctrl.prescription.data.dates.length - 1]).format("YYYY-MM-DD");
           ctrl.prescription.duration = Math.round(moment.duration(moment(ctrl.prescription.end_date) - moment(ctrl.prescription.start_date)).asDays() + 1);
           ctrl.prescription.data.dates = ctrl.prescription.data.dates.map(function(date) {return moment(date).format("YYYY-MM-DD");});
          }, 0);
      }
      else {
        if (ctrl.prescription.data.end_mode === 'date') {
          ctrl.prescription.duration = Math.round(moment.duration(moment(ctrl.prescription.end_date) - moment(ctrl.prescription.start_date)).asDays() + 1);
        }
        else if (ctrl.prescription.data.end_mode === 'duration') {
          if (ctrl.prescription.duration != null) {
          ctrl.prescription.end_date = (moment(ctrl.prescription.start_date).add(ctrl.prescription.duration - 1, 'days')).format("YYYY-MM-DD");
          ctrl.prescription.start_date = moment(ctrl.prescription.start_date).format("YYYY-MM-DD")
          }
        }
        else {
          ctrl.prescription.end_date = null;
          ctrl.prescription.duration = null;
        }
      }
      if (ctrl.prescription.data.reeval_date != null) {
        ctrl.prescription.data.reeval_date = moment(ctrl.prescription.data.reeval_date).format("YYYY-MM-DD");
      }

      ctrl.prescription.start_date = moment(ctrl.prescription.start_date).format("YYYY-MM-DD");
      ctrl.prescription.end_date = ctrl.prescription.end_date ? moment(ctrl.prescription.end_date).format("YYYY-MM-DD") : null;

      if (ctrl.prescription.end_date && moment(ctrl.prescription.start_date) > moment(ctrl.prescription.end_date)){ctrl.prescription.end_date = undefined}

    };

  }],
});


angular.module("mhclientApp").component("productTakes", {
  templateUrl: "posos/views/product-takes.html",
  bindings: {prescription: '<'},
  controller: ["$scope", "$uibModal", "$rootScope", "PrescUtils", function productTakesCtrl($scope, $uibModal, $rootScope, PrescUtils){
    var ctrl = this;
    PrescUtils.getTimeSlots().promise.then (function(timeSlots){
      ctrl.timeSlots = timeSlots
    })

    ctrl.customizeTimeSlot = function(timeSlot) {
      var customizeTimeSlotScope, defaultHours;
      ctrl.prescription.data.custom_timeslots = ctrl.prescription.data.custom_timeslots || {};
      customizeTimeSlotScope = $scope.$new(true);
      customizeTimeSlotScope.currentHour = ctrl.prescription.data.custom_timeslots[timeSlot.short_label];
      customizeTimeSlotScope.hasPreviousValue = customizeTimeSlotScope.currentHour;
      customizeTimeSlotScope.timeSlot = timeSlot;
      defaultHours = {Mt: "08:00", M: "12:00", AM: "16:00", S: "20:00", C: "24:00", Nh: "04:00"};
      if (customizeTimeSlotScope.currentHour) {
        customizeTimeSlotScope.currentHour = moment(customizeTimeSlotScope.currentHour, "HH:mm");
      } else {
        if (timeSlot.data.start_time) {
          customizeTimeSlotScope.currentHour = moment(timeSlot.data.start_time, "HH:mm");
        } else if (timeSlot.short_label in defaultHours) {
          customizeTimeSlotScope.currentHour = moment(defaultHours[timeSlot.short_label], "HH:mm");
        }
      }
      return $uibModal.open({
        animation: true,
        templateUrl: 'medication/views/modal-customize-time-slot.html',
        size: "lg",
        scope: customizeTimeSlotScope
      }).result.then(function(result) {
        if (result) {
          return ctrl.prescription.data.custom_timeslots[timeSlot.short_label] = moment(result).format("HH:mm");
        } else {
          return delete ctrl.prescription.data.custom_timeslots[timeSlot.short_label];
        }
      });
    };


    ctrl.$doCheck = function() {
      if (
        ctrl.prescription.category && (
        (ctrl.prescription.data.takes == "intervals" && !ctrl.prescription.category.properties.allow_intervals) ||
        (ctrl.prescription.data.takes == "debit" && !ctrl.prescription.category.properties.allow_debit) ||
        (ctrl.prescription.data.takes == "without" &&  !(ctrl.prescription.category.name == 'PAP' && ctrl.prescription.category.properties.allow_no_takes))
        )
      ){ctrl.prescription.data.takes = "slots"}

      if (ctrl.prescription.data.takes === "slots") {
        var time_slots_quantity = 0;
        _.forOwn(ctrl.prescription.data.quantity_by_timeslot, function(value, key) {
          time_slots_quantity += value || 0;
        })
        ctrl.prescription.data.daily_quantity = parseFloat((time_slots_quantity || 0).toFixed(4));
      } else if (ctrl.prescription.data.takes === "intervals") {
        if ((ctrl.prescription.data.interval != null) && ctrl.prescription.data.interval_quantity) {
          ctrl.prescription.data.daily_quantity = parseFloat(((24 / ctrl.prescription.data.interval) * ctrl.prescription.data.interval_quantity).toFixed(4));
        } else {
          ctrl.prescription.data.daily_quantity = 0;
        }
        ctrl.prescription.data.quantity_by_timeslot = {};
      } else if (ctrl.prescription.data.takes === "debit") {
        delete ctrl.prescription.data.total_quantity;
        delete ctrl.prescription.data.daily_quantity;
        ctrl.prescription.data.quantity_by_timeslot = {};
      } else {
        ctrl.prescription.data.quantity_by_timeslot = {};
      }
    };
  }],
});



angular.module("mhclientApp").component("takingRouteSelection", {
  templateUrl: "posos/views/taking-route-selection.html",
  bindings: {prescription: '<'},
  controller: ["$rootScope", "$q", "$uibModal", "PrescUtils", "ImageDocument", function takingRouteSelectionCtrl($rootScope, $q, $uibModal, PrescUtils, ImageDocument){
    var ctrl = this;
    ctrl.freeRouteSelection = function() {
      $uibModal.open({
        templateUrl: 'core/views/modal-selection-template.html',
        backdrop: 'static',
        controller: 'ModalSelectionCtrl',
        resolve: {
          label: function() {return "ROUTE_SELECTION";},
          choices: function() { return PrescUtils.routes;},
          lookUpField: function() { return "label";}
        }
      }).result.then(function(route) {
        if (route) { ctrl.prescription.data.route = route}
      });
    };

    ctrl.freeTakingUnitSelection = function() {
      $uibModal.open({
        templateUrl: 'core/views/modal-selection-template.html',
        backdrop: 'static',
        controller: 'ModalSelectionCtrl',
        resolve: {
          label: function() {return "TAKING_UNIT_SELECTION";},
          choices: function() {return PrescUtils.taking_units;},
          lookUpField: function() {return "label";}
        }
      }).result.then(function(taking_unit) {
        if (taking_unit) {ctrl.prescription.data.taking_unit = taking_unit;
        }
      });
    }
  }],
});

angular.module("mhclientApp").component("productSelection", {
  templateUrl: "posos/views/product-selection.html",
  bindings: { prescription: "=" },
  controller: ["$scope", "DrugUtils", "PrescriptionDataMappers", function productSelectionCtrl(
    $scope,
    DrugUtils,
    PrescriptionDataMappers
  ) {
    var ctrl = this;

    $scope.selectedDrug = undefined;

    $scope.handleOnSelectDrug = handleOnSelectDrug;

    ctrl.$onInit = onInit;

    function onInit() {
      if (
        ctrl.prescription &&
        ctrl.prescription.data &&
        ctrl.prescription.data.bdm_data
      ) {
        loadSelectedDrugFromPrescription(ctrl.prescription);
      }
    }

    function loadSelectedDrugFromPrescription(prescription) {
      $scope.selectedDrug =
        PrescriptionDataMappers.mapPrescriptionToSelectedDrug(prescription);
    }

    function handleOnSelectDrug(result) {
      $scope.selectedDrug = DrugUtils.mapDrugSelectModalResultToDrug(result);

      PrescriptionDataMappers.addDrugSelectModalResultToPrescription(
        ctrl.prescription,
        result
      );
    }
  }],
});

angular.module("mhclientApp").component("hospitalTraitement", {
  templateUrl: "posos/views/hopital-traitement.html",
  bindings: {prescription: '<'},
  controller: ["SiteVarsUtils", function hospitalTraitementCtrl(SiteVarsUtils){
    var ctrl = this;
    SiteVarsUtils.getValue("ALLOW_HOSPITAL_TREATMENT", false).then (function (ALLOW_HOSPITAL_TREATMENT){
      ctrl.allowHospitalTraitement = ALLOW_HOSPITAL_TREATMENT
    })
  }],
});


angular.module("mhclientApp").component("pososDocumentSelectionModal", {
  templateUrl: "posos/views/document-selection-modal.html",
  bindings: {resolve: '=', dismiss: '&', close: '&'},
  controller: ["$rootScope", "$q", "$http", "$uibModal", "SiteVarsUtils", "ImageDocument", function pososDocumentSelectionModal($rootScope, $q, $http, $uibModal, SiteVarsUtils, ImageDocument){
    var ctrl = this;
    SiteVarsUtils.getValue('WORK_REPORT_ATTACH_MAX_SIZE', "20MB").then( function(maxSize) {ctrl.maxSize = maxSize;})
    ctrl.$onInit = function () {
      ctrl.busy = true
      ctrl.stay = ctrl.resolve.stay
      ImageDocument.api.query({category_code: "PRESCRIPTION", patient: ctrl.stay.patient, for_presc_cart: true, entity: ctrl.stay.entity}).$promise.then (function(imageDocuments){
        ctrl.busy = false
        ctrl.availableImageDocuments = imageDocuments
      })
    };
    ctrl.selectStakeholder = function () {
      return $uibModal.open({
        templateUrl: 'medication/views/attachment-template.html',
        controller: 'AttachmentCtrl',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          imageDocument: function() {return ctrl.currentDocument;}
        }
      });
    }
    ctrl.uploadFiles = function(files){
      if (!files) {return}
      ctrl.busy = true
      var imageDocumentData = {stay: ctrl.stay.id, pages: [], category_uid: "PRESCRIPTION", author: $rootScope.user.id}
      $q.all(_.map(files, function(file) {
        var reader = new FileReader();
        var done = $q.defer()
        reader.readAsDataURL(file);
        reader.onload = function () {done.resolve(reader.result)};
        return done.promise
      })).then (function (bases64) {
        _.forEach(bases64, function(base64){
          var all = base64.split(/,(.*)/s)
          imageDocumentData.pages.push({"image": all[1], "contentType": all[0].split(";")[0].split(":")[1]})}
        )
        ImageDocument.api.save(imageDocumentData).$promise.then( function(response){
          ctrl.busy = false
          ctrl.currentDocument = response
          ctrl.availableImageDocuments.push(response)
        })
      })
    }
  }],
});



angular.module("mhclientApp").component("pososPrescriptionLine", {
  templateUrl: "posos/views/posos-prescription-line.html",
  bindings: {prescription: "=", container: "<?", editable: "<", index: "<?", removeCallback: "&"},
  controller: ["$filter", "PrescUtils", function pososPrescriptionFormCtrl($filter, PrescUtils){
    var ctrl = this;

    ctrl.$onInit = onInit;

    function onInit() {
      PrescUtils.getTimeSlots().promise.then(function (timeSlots) {
        ctrl.timeSlots = timeSlots;
      });
    }

    ctrl.customPosology = ctrl.prescription.data.posos_default_posology
    ctrl.$doCheck = function() {
      if (ctrl.prescription && ctrl.editable && ctrl.prescriptionForm && ctrl.timeSlots) {
        try{
          var prescriptionDisplayDict = $filter("PrescriptionDisplayText")(ctrl.prescription, ctrl.timeSlots)
          if (ctrl.prescriptionForm.$pristine && ctrl.prescription.data.is_posos && !ctrl.prescription.data.manually_added && ctrl.prescription.data.use_posos_posology != false){
            ctrl.prescHeader = prescriptionDisplayDict.productName
            ctrl.prescription.data.posology = ctrl.customPosology || ctrl.prescription.data.posos_default_posology
            ctrl.prescription.data.display_text = ctrl.prescHeader + ctrl.prescription.data.posology
          } else{
            if (ctrl.prescriptionForm.$dirty || ctrl.prescription.data.use_posos_posology == false){
              delete ctrl.prescription.data.is_posos_pristine
              if (ctrl.prescription.data.resumption == "RENEW") {ctrl.prescription.data.resumption = "RENEW_MODIFY"}
              ctrl.prescription.data.display_text = prescriptionDisplayDict.display_text
              ctrl.prescription.data.dci_display_text = prescriptionDisplayDict.dci_display_text
              ctrl.prescription.data.posology = prescriptionDisplayDict.posology
            }
          }
        } catch (_error) {
          ctrl.prescription.data.display_text = $filter('translate')("CANT GENERATE POSOLOGY SENTENCE, MISSING FIELDS")
        }
      }
    };

  }],
});

angular.module('mhclientApp').directive('noDirtyCheck', function() {
  // Interacting with input elements having this directive won't cause the
  // form to be marked dirty.
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl) {
      ctrl.$pristine = false;
    }
  }
});

angular.module('mhclientApp').directive('pososSwiper', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var swiper = new Swiper(element[0], {
              direction: 'vertical',
              slidesPerView: 5,
              observer: true,
              observeParents: true,
              parallax:true,
              spaceBetween: 10,
              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
              },
            });
        }
    };
});


angular.module("mhclientApp").component("pososPrescription", {
  templateUrl: "posos/views/posos-prescription.html",
  bindings: {container: "<?", prescriptionGroup: "=", index:"<?", removeCallback: "&"},
  controller: ["$rootScope", "$filter", "$q", "MhConfig", "PrescUtils", "PososUtils", "$uibModal", "Medicaldb", "SiteVarsUtils", "SiteVar", function pososPrescriptionFormCtrl($rootScope, $filter, $q, MhConfig, PrescUtils, PososUtils, $uibModal, Medicaldb, SiteVarsUtils, SiteVar){
    var ctrl = this;

    PrescUtils.getCategories().promise.then ( function(categories){
      ctrl.availableCategories = _.filter(categories, function(category){return _.includes(["FOND", "PAP", "OCC", "PCA"], category.name)})
      ctrl.blockSteps = ctrl.prescriptionGroup.prescriptions.length > 1
      _.forEach(ctrl.prescriptionGroup.prescriptions, function(prescription){prescription.category = _.find(categories, {id: prescription.category})})
      _.assign(ctrl.prescriptionGroup, {
        withSteps: ctrl.prescriptionGroup.prescriptions.length > 1,
        category: ctrl.prescriptionGroup.prescriptions[0].category,
        stepsTitle: ctrl.prescriptionGroup.title,
        prescriptionsToDelete: [],
      })
      ctrl.prescriptionGroup.editable = !ctrl.prescriptionGroup.category || !!_.find(ctrl.availableCategories, {id: ctrl.prescriptionGroup.category.id})
    })

    ctrl.addPrescriptionStep = function() {
      ctrl.prescriptionGroup.prescriptions.push(PrescUtils.setupPrescription(false, {category: ctrl.prescriptionGroup.category}, ctrl.prescriptionGroup.category.name == "PAP" ? {takes: "without"} : {}))
    }
    ctrl.selectCategory = function(category) {
      ctrl.prescriptionGroup.category = category
      _.forEach(ctrl.prescriptionGroup.prescriptions, function(prescription) {
        prescription.category = category
        if (category.name == "PAP") {prescription.data.takes = "without"} // Set without by default
      })
    }

    ctrl.removePrescription = function(prescription){
      _.remove(ctrl.prescriptionGroup.prescriptions, prescription)
       if (prescription.id){ctrl.prescriptionGroup.prescriptionsToDelete.push(prescription)}
    }

  }]
});


angular.module("mhclientApp").component("posos", {
  templateUrl: "posos/views/posos.html",
  bindings: {documentId: '@', ordonnanceId: '@', patient: '<', stay: '<', allStays: '<'},
  controller: ["$q", "$rootScope", "$uibModal", "$state", "$filter", "ImageDocument", "Ordonnance", "Prescription", "Medicaldb", "PrescUtils", "PososUtils", "GenUID", "notify", function pososCtrl($q, $rootScope, $uibModal, $state, $filter, ImageDocument, Ordonnance, Prescription, Medicaldb, PrescUtils, PososUtils, GenUID, notify) {

    // tooltip explicar score posologie

    var ctrl = this;
    ctrl.addPrescription = function (index) { ctrl.groupedPrescriptions.splice(index, 0, {prescriptions: [PrescUtils.setupPrescription(false, {}, {manually_added: true, is_posos: true})]})}
    ctrl.prescToRemove = []

    ctrl.removePrescriptionGroup = function(prescriptionGroup){
      _.remove(ctrl.groupedPrescriptions, prescriptionGroup)
      ctrl.prescToRemove = _.concat(ctrl.prescToRemove, prescriptionGroup.prescriptionsToDelete, _.filter(prescriptionGroup.prescriptions, "id"))
    }


    ctrl.sendOrdo = function (){
      $rootScope.busy = true;
      (ctrl.ordonnance.id ? Ordonnance.update : Ordonnance.save)(ctrl.ordonnance).$promise.then(function (ordonnance) {
          $q.all(_.map([].concat.apply([], _.map(ctrl.groupedPrescriptions, function(prescriptionGroup, index){

            var group = prescriptionGroup.withSteps ? (prescriptionGroup.groupId || GenUID.generate(32)): null
            var group_sequence = prescriptionGroup.withSteps ? (prescriptionGroup.lastSequence || 1): null
            _.forEach(prescriptionGroup.prescriptions, function(prescription, prescriptionOrderInGroup) {
              prescription.data.posos_order = index
              prescription.data.group_order = prescriptionOrderInGroup
              prescription.data.group_title = prescriptionGroup.stepsTitle
              prescription.group = group
              prescription.group_sequence = group_sequence
              if (prescription.id) { prescription.data.draft_info = {"author": $rootScope.user.full_name, "timestamp": moment()} }

            })
            return prescriptionGroup.prescriptions
          })), function(prescription){
            return (prescription.id ? Prescription.update : Prescription.save)(_.assign(prescription, {ordonnance: ordonnance.id})).$promise}
          )).then (function() {
            $q.all(_.map([].concat.apply(ctrl.prescToRemove, _.map(ctrl.groupedPrescriptions, "prescriptionsToDelete")), function(prescription) { return Prescription.delete({id: prescription.id}).$promise})).then (function(){
              $rootScope.busy = false
              $state.go('user.patient.stay.medication.cart')
            })
          })
      })
    }



    $rootScope.busy = true;
    $rootScope.spinnerText = $filter('translate')("Please wait, processing in progress")
    $q.when(ctrl.ordonnanceId ? Ordonnance.get({patient: ctrl.patient.id, entity: ctrl.stay.entity, id:ctrl.ordonnanceId}).$promise: {stay: ctrl.stay.id , state:"DRAFT", author: $rootScope.user.id}).then(function(ordonnance){
      $q.when(ordonnance.id ? Ordonnance.getPrescriptions({id:ordonnance.id}).$promise : [] ).then(function(previousPrescriptions){
        ImageDocument.api.get({id: ctrl.documentId, patient: ctrl.patient.id, entity: ctrl.stay.entity}).$promise.then(function(imageDocument) {
          Medicaldb.searchAllDrugs({only_catalog: true, entity: ctrl.stay.entity, sector: ctrl.stay.sector}).$promise.then( function(catalogDrugs){
            $q.all(_.map(imageDocument.pages, function(page){return PososUtils.getMeta(page)})).then (function(){
                ImageDocument.api.exportPosos({id: imageDocument.id}).$promise.then (function(pososResponse){
                // var pososResponse = {"fhirBundle":{"resourceType":"Bundle","identifier":{"use":"secondary","system":"https://terminology.posos.co/uuid","value":"74fdb56b-a13d-469a-9418-43a76400c06f"},"type":"transaction","timestamp":"2024-03-01T02:01:45.465+00:00","entry":[{"fullUrl":"urn:uuid:363d0403-b007-4c31-8145-72218c42ba9f","request":{"method":"POST","url":"Practitioner"},"resource":{"resourceType":"Practitioner","id":"363d0403-b007-4c31-8145-72218c42ba9f","identifier":[{"use":"secondary","system":"https://terminology.posos.co/uuid"}]}},{"fullUrl":"urn:uuid:dee13057-57b7-4cd0-935a-651f4f1e05af","request":{"method":"POST","url":"Patient"},"resource":{"resourceType":"Patient","id":"dee13057-57b7-4cd0-935a-651f4f1e05af","identifier":[{"use":"secondary","system":"https://terminology.posos.co/uuid","value":"5f056c03-dad1-4985-9407-ad0d7332516b"}]}},{"fullUrl":"urn:uuid:e0230aac-91c8-4c4d-b6c5-0050a48bc041","request":{"method":"POST","url":"RequestGroup"},"resource":{"resourceType":"RequestGroup","id":"e0230aac-91c8-4c4d-b6c5-0050a48bc041","status":"draft","intent":"order","subject":{"reference":"urn:uuid:dee13057-57b7-4cd0-935a-651f4f1e05af"},"author":{"reference":"urn:uuid:363d0403-b007-4c31-8145-72218c42ba9f"},"text":{"status":"generated","div":"<div xmlns=\"http://www.w3.org/1999/xhtml\">Prescription retranscrite par POSOS.</div>"},"contained":[{"resourceType":"Medication","id":"0f1f813a-7e79-4c83-9934-fa533bab386e","form":{"coding":[{"system":"https://terminology.posos.co/form","code":"Gélule","display":"Gélule"},{"system":"http://posos.on.fhir/form","code":"Gélule","display":"Gélule"}],"text":"Gélule"},"code":{"coding":[{"system":"https://base-donnees-publique.medicaments.gouv.fr/cis","code":"69141416","display":"UROREC 8 mg, gélule"},{"system":"http://www.whocc.no/atc","code":"G04CA04","display":"silodosine"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/ucd13","code":"3400893904978","display":"UROREC 8MG GELU ADP DFP"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/ucd7","code":"9390497","display":"UROREC 8MG GELU ADP DFP"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cip13","code":"3400937494250","display":"plaquette(s) thermoformée(s) PVC PVDC aluminium de 30 gélule(s)"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cip13","code":"3400949506491","display":"plaquette(s) thermoformée(s) PVC PVDC aluminium de 30 gélule(s)"},{"system":"http://bdpm/cis","code":"69141416","display":"UROREC 8 mg, gélule"},{"system":"http://bdpm/ucd","code":"3400893904978","display":"UROREC 8MG GELU ADP DFP"},{"system":"https://terminology.posos.co/dci","code":"silodosine","display":"silodosine"},{"system":"https://terminology.posos.co/inn","code":"silodosine","display":"silodosine"},{"system":"http://posos.on.fhir/shortname","code":"urorec","display":"urorec"},{"system":"https://terminology.posos.co/brandName","code":"urorec","display":"urorec"},{"system":"https://terminology.posos.co/clinicalDrugId","code":"MV00003523","display":"MV00003523"},{"system":"http://posos.on.fhir/dose","code":"8 mg","display":"8 mg"},{"system":"https://terminology.posos.co/labelledStrength","code":"8 mg","display":"8 mg"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cis","code":"69141416","display":"UROREC 8 mg, gélule"},{"system":"http://www.whocc.no/atc","code":"G04CA04","display":"silodosine"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/ucd13","code":"3400893904978","display":"UROREC 8MG GELU ADP DFP"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/ucd7","code":"9390497","display":"UROREC 8MG GELU ADP DFP"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cip13","code":"3400937494250","display":"plaquette(s) thermoformée(s) PVC PVDC aluminium de 30 gélule(s)"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cip13","code":"3400949506491","display":"plaquette(s) thermoformée(s) PVC PVDC aluminium de 30 gélule(s)"},{"system":"http://bdpm/cis","code":"69141416","display":"UROREC 8 mg, gélule"},{"system":"http://bdpm/ucd","code":"3400893904978","display":"UROREC 8MG GELU ADP DFP"},{"system":"https://terminology.posos.co/dci","code":"silodosine","display":"silodosine"},{"system":"https://terminology.posos.co/inn","code":"silodosine","display":"silodosine"},{"system":"http://posos.on.fhir/shortname","code":"urorec","display":"urorec"},{"system":"https://terminology.posos.co/brandName","code":"urorec","display":"urorec"},{"system":"https://terminology.posos.co/clinicalDrugId","code":"MV00003523","display":"MV00003523"},{"system":"http://posos.on.fhir/form","code":"Gélule","display":"Gélule"}],"text":"urorec"},"ingredient":[{"itemCodeableConcept":{"coding":[{"system":"https://terminology.posos.co/ingredient","code":"silodosine","display":"silodosine"},{"system":"http://posos.on.fhir/ingredient","code":"silodosine","display":"silodosine"}],"text":"silodosine"},"strength":{"numerator":{"value":8,"unit":"mg","code":"mg","system":"https://ucum.org"}}}],"extension":[{"url":"https://terminology.posos.co/fhir-extension/medication/isStrengthInMedicalDb","valueBoolean":true},{"url":"https://terminology.posos.co/fhir-extension/medication/isStrengthInBim","valueBoolean":true}]},{"resourceType":"MedicationRequest","id":"8a78e540-342c-48a2-bb8b-6e395d25bcca","status":"draft","intent":"order","medicationReference":{"reference":"#0f1f813a-7e79-4c83-9934-fa533bab386e"},"authoredOn":"2023-11-27T12:00:00.000+00:00","subject":{"reference":"urn:uuid:dee13057-57b7-4cd0-935a-651f4f1e05af"},"dosageInstruction":[{"timing":{"repeat":{"boundsDuration":{"system":"http://hl7.org/fhir/ValueSet/duration-units","unit":"day","value":30},"frequency":1,"period":1,"periodUnit":"d","when":["HS"]}},"asNeededBoolean":false,"site":{"coding":[{"system":"https://terminology.posos.co/pathway","code":"Voie orale","display":"Voie orale"},{"system":"http://posos.on.fhir/pathway","code":"Voie orale","display":"Voie orale"}]},"doseAndRate":[{"doseQuantity":{"unit":"Gélule(s) ou capsule(s) molle(s)","value":1,"system":"http://snomed.info/sct","code":"428641000"}}],"text":"1 gél la nuit. pdt 30 jours"}],"text":{"status":"generated","div":"<div xmlns=\"http://www.w3.org/1999/xhtml\">urorec - 1 gél la nuit. pdt 30 jours</div>"},"extension":[{"url":"https://terminology.posos.co/fhir-extension/medicationrequest/structurationReliability","valueCoding":{"system":"https://terminology.posos.co/dosageStructurationScore","code":"medium"}}]},{"resourceType":"Medication","id":"a1edd656-c0bb-4b78-80e0-97689b9a7d39","form":{"coding":[{"system":"https://terminology.posos.co/form","code":"Poudre pour suspension buvable","display":"Poudre pour suspension buvable"},{"system":"http://posos.on.fhir/form","code":"Poudre pour suspension buvable","display":"Poudre pour suspension buvable"}],"text":"Poudre pour suspension buvable"},"code":{"coding":[{"system":"https://base-donnees-publique.medicaments.gouv.fr/cis","code":"66053338","display":"AUGMENTIN 1 g / 125 mg, poudre pour suspension buvable en sachet-dose (rapport amoxicilline / acide clavulanique : 8 / 1)"},{"system":"http://www.whocc.no/atc","code":"J01CR02","display":"amoxicilline et inhibiteur de bêtalactamases"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/ucd13","code":"3400891983111","display":"AUGMENTIN 1G / 125MG PDR SACH"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/ucd7","code":"9198311","display":"AUGMENTIN 1G / 125MG PDR SACH"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cip13","code":"3400934450853","display":"8 sachet(s)-dose(s) papier aluminium polyéthylène de 1,566 g"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cip13","code":"3400934451164","display":"12 sachet(s)-dose(s) papier aluminium polyéthylène de 1,566 g"},{"system":"http://bdpm/cis","code":"66053338","display":"AUGMENTIN 1 g / 125 mg, poudre pour suspension buvable en sachet-dose (rapport amoxicilline / acide clavulanique : 8 / 1)"},{"system":"http://bdpm/ucd","code":"3400891983111","display":"AUGMENTIN 1G / 125MG PDR SACH"},{"system":"https://terminology.posos.co/dci","code":"acide clavulanique / amoxicilline","display":"acide clavulanique / amoxicilline"},{"system":"https://terminology.posos.co/inn","code":"acide clavulanique / amoxicilline","display":"acide clavulanique / amoxicilline"},{"system":"http://posos.on.fhir/shortname","code":"augmentin","display":"augmentin"},{"system":"https://terminology.posos.co/brandName","code":"augmentin","display":"augmentin"},{"system":"https://terminology.posos.co/clinicalDrugId","code":"MV00001510","display":"MV00001510"},{"system":"http://posos.on.fhir/dose","code":"1 g/125 mg","display":"1 g/125 mg"},{"system":"https://terminology.posos.co/labelledStrength","code":"1 g/125 mg","display":"1 g/125 mg"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cis","code":"66053338","display":"AUGMENTIN 1 g / 125 mg, poudre pour suspension buvable en sachet-dose (rapport amoxicilline / acide clavulanique : 8 / 1)"},{"system":"http://www.whocc.no/atc","code":"J01CR02","display":"amoxicilline et inhibiteur de bêtalactamases"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/ucd13","code":"3400891983111","display":"AUGMENTIN 1G / 125MG PDR SACH"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/ucd7","code":"9198311","display":"AUGMENTIN 1G / 125MG PDR SACH"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cip13","code":"3400934450853","display":"8 sachet(s)-dose(s) papier aluminium polyéthylène de 1,566 g"},{"system":"https://base-donnees-publique.medicaments.gouv.fr/cip13","code":"3400934451164","display":"12 sachet(s)-dose(s) papier aluminium polyéthylène de 1,566 g"},{"system":"http://bdpm/cis","code":"66053338","display":"AUGMENTIN 1 g / 125 mg, poudre pour suspension buvable en sachet-dose (rapport amoxicilline / acide clavulanique : 8 / 1)"},{"system":"http://bdpm/ucd","code":"3400891983111","display":"AUGMENTIN 1G / 125MG PDR SACH"},{"system":"https://terminology.posos.co/dci","code":"acide clavulanique / amoxicilline","display":"acide clavulanique / amoxicilline"},{"system":"https://terminology.posos.co/inn","code":"acide clavulanique / amoxicilline","display":"acide clavulanique / amoxicilline"},{"system":"http://posos.on.fhir/shortname","code":"augmentin","display":"augmentin"},{"system":"https://terminology.posos.co/brandName","code":"augmentin","display":"augmentin"},{"system":"https://terminology.posos.co/clinicalDrugId","code":"MV00001510","display":"MV00001510"},{"system":"http://posos.on.fhir/form","code":"Poudre pour suspension buvable","display":"Poudre pour suspension buvable"}],"text":"augmentin"},"ingredient":[{"itemCodeableConcept":{"coding":[{"system":"https://terminology.posos.co/ingredient","code":"amoxicilline","display":"amoxicilline"},{"system":"http://posos.on.fhir/ingredient","code":"amoxicilline","display":"amoxicilline"}],"text":"amoxicilline"},"strength":{"numerator":{"value":1,"unit":"g","code":"g","system":"https://ucum.org"}}},{"itemCodeableConcept":{"coding":[{"system":"https://terminology.posos.co/ingredient","code":"acide clavulanique","display":"acide clavulanique"},{"system":"http://posos.on.fhir/ingredient","code":"acide clavulanique","display":"acide clavulanique"}],"text":"acide clavulanique"},"strength":{"numerator":{"value":125,"unit":"mg","code":"mg","system":"https://ucum.org"}}}],"extension":[{"url":"https://terminology.posos.co/fhir-extension/medication/isStrengthInMedicalDb","valueBoolean":false},{"url":"https://terminology.posos.co/fhir-extension/medication/isStrengthInBim","valueBoolean":false}]},{"resourceType":"MedicationRequest","id":"590562dd-9aa2-4140-9e64-92eacf0f0ac3","status":"draft","intent":"order","medicationReference":{"reference":"#a1edd656-c0bb-4b78-80e0-97689b9a7d39"},"authoredOn":"2023-11-27T12:00:00.000+00:00","subject":{"reference":"urn:uuid:dee13057-57b7-4cd0-935a-651f4f1e05af"},"dosageInstruction":[{"timing":{"repeat":{"boundsDuration":{"system":"http://hl7.org/fhir/ValueSet/duration-units","unit":"day","value":7},"frequency":3,"period":1,"periodUnit":"d","when":["AFT","HS","MORN"]}},"asNeededBoolean":false,"site":{"coding":[{"system":"https://terminology.posos.co/pathway","code":"Voie orale","display":"Voie orale"},{"system":"http://posos.on.fhir/pathway","code":"Voie orale","display":"Voie orale"}]},"doseAndRate":[{"doseQuantity":{"unit":"sachet(s)","value":1,"system":"http://snomed.info/sct","code":"426148002"}}],"text":"1 sach le matin, 1 sach l'après-midi, 1 sach la nuit. pdt 7 jours"}],"text":{"status":"generated","div":"<div xmlns=\"http://www.w3.org/1999/xhtml\">augmentin - 1 sach le matin, 1 sach l'après-midi, 1 sach la nuit. pdt 7 jours</div>"},"extension":[{"url":"https://terminology.posos.co/fhir-extension/medicationrequest/structurationReliability","valueCoding":{"system":"https://terminology.posos.co/dosageStructurationScore","code":"low"}}]}],"action":[{"resource":{"reference":"#8a78e540-342c-48a2-bb8b-6e395d25bcca"}},{"resource":{"reference":"#590562dd-9aa2-4140-9e64-92eacf0f0ac3"}}]}}]}}
                var contained = _.find(pososResponse["fhirBundle"]["entry"], {resource: {resourceType: "RequestGroup"}})["resource"]["contained"]
                $q.all(_.flatMap(_.filter(contained, {resourceType: "MedicationRequest"}), function(fhirePrescription){
                    return PososUtils.fhireToCare(
                      fhirePrescription,
                      _.find(contained, {resourceType: "Medication", id: fhirePrescription.medicationReference.reference.substring(1)}),
                      imageDocument.data.original_date,
                      catalogDrugs)
                })).then (function(pososPrescriptions){
                  var pososPrescriptions = _.flatten(pososPrescriptions)
                  $rootScope.busy = false;
                  $rootScope.spinnerText = ""
                  ctrl.ordonnance = ordonnance
                  ctrl.selectedDocument = imageDocument
                  ctrl.options = {"images" : _.map(ctrl.selectedDocument.pages, function(page){
                    return {
                      large : page.image_url,
                      thumb : page.image_url,
                      medium: page.image_url,
                      naturalWidth: page.naturalWidth,
                      naturalHeight: page.naturalHeight
                    }
                   })
                  }
                  ctrl.index = 0
                  ctrl.ordonnance.attached_document = ctrl.selectedDocument.id
                  _.forEach(previousPrescriptions, function(prescription){prescription.fold = true; _.assign(prescription.data, {manually_added: true, is_posos: true})})
                  ctrl.groupedPrescriptions = PrescUtils.groupPrescriptions(_.concat(pososPrescriptions, previousPrescriptions))
                })
              }, function(response){
                console.log(response)
                notify({classes: ["alert-danger"], duration: 5000, message: response.status + " " + JSON.stringify(response.data || {})});
                ctrl.selectedDocument = null
                $rootScope.busy = false;
                $rootScope.spinnerText = ""
              })
            })
          })
        })
      })
    })


  }],
});

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.service:
* @description
* Pharmaceutical analysis stuff
* ********************************************** */

angular.module("mhclientApp").factory('PososUtils', ["$q", "$filter", "GenUID", "PrescUtils", "SiteVarsUtils", "Medicaldb", function($q, $filter, GenUID, PrescUtils, SiteVarsUtils, Medicaldb) {

  var durationUnitOptions = [
        {system: "http://hl7.org/fhir/ValueSet/duration-units", code: "ms", unit: "milliseconds"},
        {system: "http://hl7.org/fhir/ValueSet/duration-units", code: "s", unit: "seconds"},
        {system: "http://hl7.org/fhir/ValueSet/duration-units", code: "min", unit: "minutes"},
        {system: "http://hl7.org/fhir/ValueSet/duration-units", code: "h", unit: "hours"},
        {system: "http://hl7.org/fhir/ValueSet/duration-units", code: "d", unit: "days"},
        {system: "http://hl7.org/fhir/ValueSet/duration-units", code: "wk", unit: "weeks"},
        {system: "http://hl7.org/fhir/ValueSet/duration-units", code: "mo", unit: "months"},
        {system: "http://hl7.org/fhir/ValueSet/duration-units", code: "a", unit: "years"},
  ]

    // Mt, M, AM, S, C, N
  var EventTimingOptions = [
      {code: "MORN", mhcareCode: "Mt", display: "Morning", definition: "Event occurs during the morning. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "MORN.early", mhcareCode: "Mt", display: "Early Morning", definition: "Event occurs during the early morning. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "MORN.late", mhcareCode: "Mt", display: "Late Morning", definition: "Event occurs during the late morning. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "NOON", mhcareCode: "M", display: "Noon", definition: "Event occurs around 12:00pm. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "AFT",  mhcareCode: "AM", display: "Afternoon", definition: "Event occurs during the afternoon. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "AFT.early", mhcareCode: "AM", display: "Early Afternoon", definition: "Event occurs during the early afternoon. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "AFT.late", mhcareCode: "AM", display: "Late Afternoon", definition: "Event occurs during the late afternoon. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "EVE", mhcareCode: "S", display: "Evening", definition: "Event occurs during the evening. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "EVE.early", mhcareCode: "S", display: "Early Evening", definition: "Event occurs during the early evening. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "EVE.late", mhcareCode: "C", display: "Late Evening", definition: "Event occurs during the late evening. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "NIGHT", mhcareCode: "N", display: "Night", definition: "Event occurs during the night. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "PHS", mhcareCode: "N", display: "After Sleep", definition: "Event occurs [offset] after subject goes to sleep. The exact time is unspecified and established by institution convention or patient interpretation."},
      {code: "IMD", display: "Immediate", definition: "Event occurs a single time (with no repetitions) as soon as possible after the scheduled or actual start of the overall event."},
      {code: "AC", display: "Before the meal"},
      {code: "HS", display: "Before sleep",  mhcareCode: "C",},
      {code: "ACD", display: "Before lunch", mhcareCode: "AM"},
      {code: "ACM", display: "Before breakfast", mhcareCode: "Mt",},
      {code: "ACV", display: "Before dinner"},
      {code: "C", display: "During meals"},
      {code: "CD", display: "During lunch", mhcareCode: "AM"},
      {code: "CM", display: "During breakfast", mhcareCode: "Mt",},
      {code: "CV", display: "During dinner", mhcareCode: "S",},
      {code: "PC", display: "After the meal"},
      {code: "PCM", display: "After breakfast", mhcareCode: "Mt", definition: "event occurs [offset] after breakfast (from the Latin post cibus matutinus)"},
      {code: "PCD", display: "After lunch", mhcareCode: "AM", definition: "event occurs [offset] after lunch (from the Latin post cibus diurnus)"},
      {code: "PCV", display: "After dinner", mhcareCode: "S", definition: "event occurs [offset] after dinner (from the Latin post cibus vespertinus)"},
      {code: "WAKE", display: "Upon waking up", mhcareCode: "Mt", definition: "event occurs [offset] after waking"},
  ]

  var selectProduct = function(cip, inMdbDrugs, inHousePharmacyCatalog, catalogProduct) {
      return SiteVarsUtils.getValue("HIGH_RISK_DRUGS", []).then (function (highRiskDrugs){
        return SiteVarsUtils.getValue("ATC_RISK_DRUGS", []).then (function(ATC_RISK_DRUGS){
          return Medicaldb.getTakingUnits({cip: cip}).$promise.then( function(takingUnits) {
            return Medicaldb.get({id: cip}).$promise.then( function(product) {
              highRiskDrugs = _.map(highRiskDrugs, "ucd")
              _.assign(product, catalogProduct)
              product.taking_units = takingUnits;
              product.marketing_name = product.marketing;
              product.is_high_risk = highRiskDrugs.indexOf(product.ucd) > -1 || _.some(ATC_RISK_DRUGS, function(atcRisk){ return _.startsWith(product.atc || "", atcRisk)})
              // cip7 is used for new prescription
              product.cip7 = product.cip;
              product.ucd7 = product.ucd;
              return {
                bdm_data: product,
                name: product.name,
                numbers_to_texts: product.is_stupefiant == '1',
                name_in_text: product.name_in_text,
                structured: true,
                route: (product.routes.length == 1) ? product.routes[0] : null,
                taking_unit: (takingUnits.length == 1) ? takingUnits[0] : null,
                dci_mode: product.is_dci,
                inn: product.inn,
                default_comment: product.comment,
                in_house_pharmacy_catalog: inHousePharmacyCatalog,
                in_mdb_drugs: inMdbDrugs,
              };
            });
          });
        });
      })
    };

  var checkMV = function(product){
    if (product.inn && product.inn.length > 0){
      return Medicaldb.getProductsForDci({cip:product.inn[0].cip}).$promise.then( function(allProducts) {
        if (allProducts.in_mdb && allProducts.in_mdb.length > 0){
          return selectProduct(allProducts.in_mdb[0].cip, true, false, allProducts.in_mdb[0])
        }
        else if (allProducts.in_stock && allProducts.in_stock.length > 0){
          return selectProduct(allProducts.in_stock[0].cip, false, true, allProducts.in_stock[0])
        }
        else{ return product }
      })
    }

    return product

  }

  var ucumUnknown = [
    {"ucum_code": "bar", "code": "bar"},
    {"ucum_code": "mol", "code": "mol"},
    {"ucum_code": "[hp_X]", "code": "dh"},
    {"ucum_code": "[ppm]", "code": "[ppm]"},
  ]

  var ucumToBCB = [
    {"ucum_code": "%", "code": "792"},
    {"ucum_code": "ir", "code": "517"},
    {"ucum_code": "mu", "code": "713"},
    {"ucum_code": "M[IU]", "code": "520"},

    // {"ucum_code": "Bq", "code": "Bq"},
    {"ucum_code": "MBq", "code": "591"},
    {"ucum_code": "GBq", "code": "777"},
    {"ucum_code": "ug", "code": "772"},
    {"ucum_code": "mg", "code": "48"},
    {"ucum_code": "g", "code": "9"},
    {"ucum_code": "uL", "code": "766"},
    {"ucum_code": "mL", "code": "27"},
    {"ucum_code": "L", "code": "163"},
    {"ucum_code": "mmol", "code": "515"},
    {"ucum_code": "[IU]", "code": "25"},
  ]

  var ucumToCIO = [
    {"ucum_code": "Bq", "code": "bq"},
    {"ucum_code": "MBq", "code": "10*6.bq"},
    {"ucum_code": "GBq", "code": "10*9.bq"},
    {"ucum_code": "ug", "code": "ug"},
    {"ucum_code": "mg", "code": "mg"},
    {"ucum_code": "g", "code": "g"},
    {"ucum_code": "uL", "code": "uL"},
    {"ucum_code": "mL", "code": "mL"},
    {"ucum_code": "L", "code": "L"},
    {"ucum_code": "mmol", "code": "mmol"},
    {"ucum_code": "[IU]", "code": "iu"}
  ]

  var snomedToBCB = [
    {"snomed_label": "ampoule(s)", "snomed_code": "413516001", "code": "4"},
    {"snomed_label": "applicateur(s)", "snomed_code": "1641000175108", "code": "846"},
    {"snomed_label": "sac(s)", "snomed_code": "428672001", "code": "821"},
    // {"snomed_label": "cachet(s)", "snomed_code": "1701000175103", "code": "1701000175103"},
    {"snomed_label": "tampon(s)", "snomed_code": "700477004", "code": "183"},
    {"snomed_label": "bandelette(s)", "snomed_code": "1671000175104", "code": "909"},
    // {"snomed_label": "barre(s)", "snomed_code": "428003006", "code": "428003006"},
    // {"snomed_label": "canette(s)", "snomed_code": "429308001", "code": "429308001"},
    {"snomed_label": "disque(s)", "snomed_code": "427678004", "code": "797"},
    // {"snomed_label": "emballage(s)", "snomed_code": "1681000175101", "code": "1681000175101"},
    // {"snomed_label": "paquet(s)", "snomed_code": "419888008", "code": "419888008"},
    // {"snomed_label": "applicateur(s) plein(s)", "snomed_code": "1651000175105", "code": "1651000175105"},
    {"snomed_label": "inhalation(s)", "snomed_code": "422237004", "code": "84"},
    // 183 ? {"snomed_label": "tampon(s) imprégné(s)", "snomed_code": "421823004", "code": "421823004"},
    {"snomed_label": "trousse(s)", "snomed_code": "419179001", "code": "831"},
    // {"snomed_label": "boîtier(s)", "snomed_code": "413769002", "code": "413769002"},
    // {"snomed_label": "base(s)", "snomed_code": "418836005", "code": "418836005"},
    {"snomed_label": "compte-goutte", "snomed_code": "421954001", "code": "269"},
    // {"snomed_label": "écouvillon(s)", "snomed_code": "420401004", "code": "420401004"},
    // 744 ? {"snomed_label": "sachet(s) bidose(s)", "snomed_code": "426198001", "code": "426198001"},
    {"snomed_label": "tasse(s)", "snomed_code": "428178003", "code": "98"},
    // {"snomed_label": "capsule ou gélule rectale selon le cas", "snomed_code": "700480003", "code": "700480003"},
    // {"snomed_label": "capsule ou gélule vaginale selon le cas", "snomed_code": "700483001", "code": "700483001"},
    // {"snomed_label": "pompe(s)", "snomed_code": "2741000175105", "code": "2741000175105"},
    // {"snomed_label": "jet(s)", "snomed_code": "1661000175107", "code": "1661000175107"},
    // 218 ? {"snomed_label": "cuillérée(s) de 5 mL", "snomed_code": "514941000000109", "code": "514941000000109"},
    // {"snomed_label": "baguette(s)", "snomed_code": "3316811000001100", "code": "3316811000001100"},
    // {"snomed_label": "bandage(s)", "snomed_code": "8091811000001107", "code": "8091811000001107"},
    // {"snomed_label": "carton(s)", "snomed_code": "3317011000001109", "code": "3317011000001109"},
    // {"snomed_label": "cathéter(s)", "snomed_code": "3319911000001101", "code": "3319911000001101"},
    // {"snomed_label": "composant(s)", "snomed_code": "10368211000001101", "code": "10368211000001101"},
    {"snomed_label": "dispositif(s)", "snomed_code": "3318711000001107", "code": "277"},
    // {"snomed_label": "pas de dose", "snomed_code": "10697011000001101", "code": "10697011000001101"},
    // 277 ? {"snomed_label": "dispositif(s) élastomère(s)", "snomed_code": "10696111000001103", "code": "10696111000001103"},
    {"snomed_label": "générateur(s)", "snomed_code": "8091011000001101", "code": "823"},
    // {"snomed_label": "gant(s)", "snomed_code": "3321511000001100", "code": "3321511000001100"},
    // 916 ? {"snomed_label": "lancet(s)", "snomed_code": "3317611000001102", "code": "3317611000001102"},
    // {"snomed_label": "multipack(s)", "snomed_code": "3317911000001108", "code": "3317911000001108"},
    // {"snomed_label": "nébulisateur(s)", "snomed_code": "3318011000001105", "code": "3318011000001105"},
    // {"snomed_label": "aiguille(s)", "snomed_code": "3318111000001106", "code": "3318111000001106"},
    // {"snomed_label": "pack(s)", "snomed_code": "3318211000001100", "code": "3318211000001100"},
    // {"snomed_label": "morceau(x)", "snomed_code": "3321411000001104", "code": "3321411000001104"},
    // ???? {"snomed_label": "pizza(s)", "snomed_code": "3321311000001106", "code": "3321311000001106"},
    // 10 ? {"snomed_label": "injection(s) jetable(s) préremplie(s)", "snomed_code": "3318611000001103", "code": "3318611000001103"},
    // {"snomed_label": "rouleau(x)", "snomed_code": "3318811000001104", "code": "3318811000001104"},
    // {"snomed_label": "bas", "snomed_code": "3319011000001100", "code": "3319011000001100"},
    // {"snomed_label": "suture(s)", "snomed_code": "3320311000001101", "code": "3320311000001101"},
    // {"snomed_label": "bandage(s) herniaire(s)", "snomed_code": "3320411000001108", "code": "3320411000001108"},
    // {"snomed_label": "vaccin(s)", "snomed_code": "943299900010000003", "code": "943299900010000003"},
    // {"snomed_label": "capteur(s)", "snomed_code": "943299900010000004", "code": "943299900010000004"},
    {"snomed_label": "injection(s)", "snomed_code": "943299900010000005", "code": "10"},
    {"snomed_label": "pilule(s)", "snomed_code": "943299900010000006", "code": "811"},

    {"snomed_label": "application(s)", "snomed_code": "413568008", "code": "3"},
    {"snomed_label": "flacon(s)", "snomed_code": "415818006", "code": "26"},
    {"snomed_label": "tube(s)", "snomed_code": "418530008", "code": "99"},
    {"snomed_label": "comprimé(s)", "snomed_code": "428673006", "code": "1"},
    {"snomed_label": "suppositoire(s)", "snomed_code": "430293001", "code": "39"},
    // 748 ? {"snomed_label": "bâtonnet(s)", "snomed_code": "1691000175103", "code": "baton"},
    {"snomed_label": "bouteille(s)", "snomed_code": "419672006", "code": "798"},
    {"snomed_label": "boîte(s)", "snomed_code": "418445004", "code": "212"},
    // 864 ? {"snomed_label": "gélule(s) ou capsule(s) molle(s)", "snomed_code": "428641000", "code": "gel"},
    {"snomed_label": "implant(s)", "snomed_code": "428177008", "code": "94"},
    {"snomed_label": "insert(s)", "snomed_code": "428639001", "code": "165"},
    {"snomed_label": "pastille(s)", "snomed_code": "429587008", "code": "97"},
    {"snomed_label": "pâte à sucer", "snomed_code": "700473000", "code": "121"},
    {"snomed_label": "patch", "snomed_code": "419702001", "code": "701"},
    {"snomed_label": "granule(s)", "snomed_code": "428640004", "code": "151"},
    {"snomed_label": "bouffée(s)", "snomed_code": "415215001", "code": "35"},
    {"snomed_label": "sachet(s)", "snomed_code": "426148002", "code": "13"},
    // {"snomed_label": "cuillérée(s)", "snomed_code": "415505006", "code": "c_mes"},
    {"snomed_label": "goutte(s)", "snomed_code": "404218003", "code": "24"},
    {"snomed_label": "pulvérisation(s)", "snomed_code": "419694003", "code": "36"},
    {"snomed_label": "pansement(s)", "snomed_code": "700478009", "code": "812"},
    {"snomed_label": "lavement(s)", "snomed_code": "700476008", "code": "89"},
    {"snomed_label": "gomme", "snomed_code": "430281005", "code": "259"},
    {"snomed_label": "éponge(s)", "snomed_code": "429671000", "code": "717"},
    {"snomed_label": "cuillère(s) à café", "snomed_code": "415703001", "code": "12"},
    {"snomed_label": "cuillère(s) à soupe", "snomed_code": "415702006", "code": "11"},
    // {"snomed_label": "plaquette(s)", "snomed_code": "425565005", "code": "plaq"},
    // {"snomed_label": "suppositoire(s) vaginal(-aux)", "snomed_code": "700472005", "code": "suppo"},
    {"snomed_label": "comprimé(s) vaginal(-aux)", "snomed_code": "700482006", "code": "85"},
    {"snomed_label": "seringue(s) préremplie(s)", "snomed_code": "700474006", "code": "101"},
    // {"snomed_label": "comprimé(s) sublingual(-aux)", "snomed_code": "700479001", "code": "cpr"},
    // {"snomed_label": "comprimé(s) rectal(-aux)", "snomed_code": "700481004", "code": "cpr"},
    // {"snomed_label": "comprimé(s) buccal(-aux)", "snomed_code": "23541000087106", "code": "cpr"},
    {"snomed_label": "dose(s)", "snomed_code": "3317411000001100", "code": "18"},
    {"snomed_label": "instillation(s)", "snomed_code": "943299900010000001", "code": "81"},
    {"snomed_label": "pot(s)", "snomed_code": "3321111000001109", "code": "415"},
    {"snomed_label": "ovule(s)", "snomed_code": "943299900010000002", "code": "86"},
    {"snomed_label": "emplâtre(s)", "snomed_code": "943299900010000007", "code": "132"},
    {"snomed_label": "gélule(s)", "snomed_code": "943299900010000008", "code": "31"},
    {"snomed_label": "capsule(s) molle(s)", "snomed_code": "943299900010000009", "code": "864"},
    {"snomed_label": "capsule(s) vaginale(s)", "snomed_code": "9432999000100000010", "code": "173"},
    {"snomed_label": "gélule(s) vaginale(s)", "snomed_code": "9432999000100000011", "code": "532"},
    // {"snomed_label": "capsule(s) rectale(s)", "snomed_code": "9432999000100000012", "code": "caps"},
    // {"snomed_label": "gélule(s) rectale(s)", "snomed_code": "9432999000100000013", "code": "gel"}
  ]


  var snomedToCIO = [
    {"snomed_label": "application(s)", "snomed_code": "413568008", "cio_label": "appln"},
    {"snomed_label": "flacon(s)", "snomed_code": "415818006", "cio_label": "flac"},
    {"snomed_label": "tube(s)", "snomed_code": "418530008", "cio_label": "tube"},
    {"snomed_label": "comprimé(s)", "snomed_code": "428673006", "cio_label": "cpr"},
    {"snomed_label": "suppositoire(s)", "snomed_code": "430293001", "cio_label": "suppo"},
    {"snomed_label": "bâtonnet(s)", "snomed_code": "1691000175103", "cio_label": "baton"},
    {"snomed_label": "bouteille(s)", "snomed_code": "419672006", "cio_label": "btle"},
    {"snomed_label": "boîte(s)", "snomed_code": "418445004", "cio_label": "boite"},
    {"snomed_label": "gélule(s) ou capsule(s) molle(s)", "snomed_code": "428641000", "cio_label": "gel"},
    {"snomed_label": "implant(s)", "snomed_code": "428177008", "cio_label": "implant"},
    {"snomed_label": "insert(s)", "snomed_code": "428639001", "cio_label": "insert"},
    {"snomed_label": "pastille(s)", "snomed_code": "429587008", "cio_label": "past"},
    {"snomed_label": "pâte à sucer", "snomed_code": "700473000", "cio_label": "pâte"},
    {"snomed_label": "patch", "snomed_code": "419702001", "cio_label": "dtd"},
    {"snomed_label": "granule(s)", "snomed_code": "428640004", "cio_label": "granule"},
    {"snomed_label": "bouffée(s)", "snomed_code": "415215001", "cio_label": "bouffee"},
    {"snomed_label": "sachet(s)", "snomed_code": "426148002", "cio_label": "sachet"},
    {"snomed_label": "cuillérée(s)", "snomed_code": "415505006", "cio_label": "c_mes"},
    {"snomed_label": "goutte(s)", "snomed_code": "404218003", "cio_label": "gte"},
    {"snomed_label": "pulvérisation(s)", "snomed_code": "419694003", "cio_label": "pulv"},
    {"snomed_label": "pansement(s)", "snomed_code": "700478009", "cio_label": "pst"},
    {"snomed_label": "lavement(s)", "snomed_code": "700476008", "cio_label": "lavmt"},
    {"snomed_label": "gomme", "snomed_code": "430281005", "cio_label": "gomme"},
    {"snomed_label": "éponge(s)", "snomed_code": "429671000", "cio_label": "epmed"},
    {"snomed_label": "cuillère(s) à café", "snomed_code": "415703001", "cio_label": "c_a_c"},
    {"snomed_label": "cuillère(s) à soupe", "snomed_code": "415702006", "cio_label": "c_a_s"},
    {"snomed_label": "plaquette(s)", "snomed_code": "425565005", "cio_label": "plaq"},
    {"snomed_label": "suppositoire(s) vaginal(-aux)", "snomed_code": "700472005", "cio_label": "suppo"},
    {"snomed_label": "comprimé(s) vaginal(-aux)", "snomed_code": "700482006", "cio_label": "cpr"},
    {"snomed_label": "seringue(s) préremplie(s)", "snomed_code": "700474006", "cio_label": "ser_prr"},
    {"snomed_label": "comprimé(s) sublingual(-aux)", "snomed_code": "700479001", "cio_label": "cpr"},
    {"snomed_label": "comprimé(s) rectal(-aux)", "snomed_code": "700481004", "cio_label": "cpr"},
    {"snomed_label": "comprimé(s) buccal(-aux)", "snomed_code": "23541000087106", "cio_label": "cpr"},
    {"snomed_label": "dose(s)", "snomed_code": "3317411000001100", "cio_label": "dose"},
    {"snomed_label": "instillation(s)", "snomed_code": "943299900010000001", "cio_label": "inst"},
    {"snomed_label": "pot(s)", "snomed_code": "3321111000001109", "cio_label": "pot"},
    {"snomed_label": "ovule(s)", "snomed_code": "943299900010000002", "cio_label": "ovule"},
    {"snomed_label": "emplâtre(s)", "snomed_code": "943299900010000007", "cio_label": "empmed"},
    {"snomed_label": "gélule(s)", "snomed_code": "943299900010000008", "cio_label": "gel"},
    {"snomed_label": "capsule(s) molle(s)", "snomed_code": "943299900010000009", "cio_label": "caps"},
    {"snomed_label": "capsule(s) vaginale(s)", "snomed_code": "9432999000100000010", "cio_label": "caps"},
    {"snomed_label": "gélule(s) vaginale(s)", "snomed_code": "9432999000100000011", "cio_label": "gel"},
    {"snomed_label": "capsule(s) rectale(s)", "snomed_code": "9432999000100000012", "cio_label": "caps"},
    {"snomed_label": "gélule(s) rectale(s)", "snomed_code": "9432999000100000013", "cio_label": "gel"}
  ]

  var fhirDoseAndRateToTakingUnit = function(doseAndRate, bcbCodeOnly) {
  /**
   * Converts FHIR `doseQuantity` to a structured unit format.
   *
   * Input:
   *  - `doseQuantity` with unit, system (UCUM or SNOMED), and code.
   *
   * Output:
   *  - Returns:
   *    {
   *      "code": bcbCode or "-1",       // BCB code or "-1" if not found
   *      "cio_code": cioCode (optional) // CIO code if available
   *      "label": unit,                 // Unit label
   *      "label_plural": unit           // Plural unit label
   *    } or `null` if no mapping found.
   */
    var system = doseAndRate.doseQuantity.system;
    var code = doseAndRate.doseQuantity.code;

    // Helper function to find code from a list
    function findCodeFromList(list, key, value, targetField) {
      for (var i = 0; i < list.length; i++) {
        if (list[i][key] === value) {
          return list[i][targetField];
        }
      }
      return null;
    }

    var bcbCode = null;
    var cioCode = null;
    var label = doseAndRate.doseQuantity.unit;
    var label_plural = doseAndRate.doseQuantity.unit;

    if (_.includes(system, "ucum.org")) {
      // UCUM
      bcbCode = findCodeFromList(ucumToBCB, "ucum_code", code, "code");
      cioCode = findCodeFromList(ucumToCIO, "ucum_code", code, "code");
    } else if (_.includes(system, "snomed.info")) {
      // SNOMED
      label = label.replace("(s)", "")
      label_plural = label_plural.replace("(s)", "s")
      bcbCode = findCodeFromList(snomedToBCB, "snomed_code", code.toString(), "code");
      cioCode = findCodeFromList(snomedToCIO, "snomed_code", code.toString(), "cio_label");
    }

    if (!bcbCode && bcbCodeOnly) {
      return null;
    }

    if (!bcbCode && !cioCode) {
      return null;
    }

    var takingUnit = {
      "code": bcbCode ? bcbCode : "-1",
      "label": label,
      "label_plural": label_plural
    }
    if (cioCode) {
      takingUnit.cio_code = cioCode;
    }
    return takingUnit;
  }

  var routeCodeEDQMtoBCB = [
    {edqmCode: "ROA-20001000", pososLabel: "Voie auriculaire", bcbCode: "B01"},
    {edqmCode: "ROA-20003000", pososLabel: "Voie cutanée", bcbCode: "B03"},
    {edqmCode: "ROA-20004000", pososLabel: "Voie dentaire", bcbCode: "B04"},
    {edqmCode: "ROA-20007000", pososLabel: "Voie endosinusale", bcbCode: "B07"},
    {edqmCode: "ROA-20008000", pososLabel: "Voie endotrachéobronchique", bcbCode: "B08"},
    {edqmCode: "ROA-20009000", pososLabel: "Voie péridurale", bcbCode: "A09"},
    {edqmCode: "ROA-20010000", pososLabel: "Voie épilésionnelle", bcbCode: "X"},
    {edqmCode: "ROA-20011500", pososLabel: "Voie extracorporelle", bcbCode: "X"},
    {edqmCode: "ROA-20013000", pososLabel: "Voie gastro-entérale", bcbCode: "A12"},
    {edqmCode: "ROA-20013500", pososLabel: "Voie gastrique", bcbCode: "X"},
    {edqmCode: "ROA-20014000", pososLabel: "Voie gingivale", bcbCode: "B13"},
    {edqmCode: "ROA-20015000", pososLabel: "Hémodialyse", bcbCode: "A14"},
    {edqmCode: "ROA-20015500", pososLabel: "Implantation", bcbCode: "X"},
    {edqmCode: "ROA-20020000", pososLabel: "Voie inhalée", bcbCode: "A73"},
    {edqmCode: "ROA-20021000", pososLabel: "Voie intestinale", bcbCode: "X"},
    {edqmCode: "ROA-20023000", pososLabel: "Voie intraartérielle", bcbCode: "A20"},
    {edqmCode: "ROA-20024000", pososLabel: "Voie intraarticulaire", bcbCode: "A21"},
    {edqmCode: "ROA-20025000", pososLabel: "Voie intrabursale", bcbCode: "A22"},
    {edqmCode: "ROA-20025500", pososLabel: "Voie intracamérulaire", bcbCode: "X"},
    {edqmCode: "ROA-20027000", pososLabel: "Voie intracaverneuse", bcbCode: "A24"},
    {edqmCode: "ROA-20028000", pososLabel: "Voie intracervicale", bcbCode: "A25"},
    {edqmCode: "ROA-20028300", pososLabel: "Voie intracholangiopancréatique", bcbCode: "X"},
    {edqmCode: "ROA-20028500", pososLabel: "Voie intracisternale", bcbCode: "X"},
    {edqmCode: "ROA-20029000", pososLabel: "Voie intracoronaire", bcbCode: "A26"},
    {edqmCode: "ROA-20030000", pososLabel: "Voie intradermique", bcbCode: "A27"},
    {edqmCode: "ROA-20031700", pososLabel: "Voie intraglandulaire", bcbCode: "X"},
    {edqmCode: "ROA-20032000", pososLabel: "Voie intralésionnelle", bcbCode: "B29"},
    {edqmCode: "ROA-20033000", pososLabel: "Voie intralymphatique", bcbCode: "A30"},
    {edqmCode: "ROA-20035000", pososLabel: "Voie intramusculaire", bcbCode: "A32"},
    {edqmCode: "ROA-20036000", pososLabel: "Voie intraoculaire", bcbCode: "A33"},
    {edqmCode: "ROA-20036500", pososLabel: "Voie intraosseuse", bcbCode: "B02"},
    {edqmCode: "ROA-20037000", pososLabel: "Voie intrapéricardiaque", bcbCode: "X"},
    {edqmCode: "ROA-20038000", pososLabel: "Voie intrapéritonéale", bcbCode: "A34"},
    {edqmCode: "ROA-20039000", pososLabel: "Voie intrapleurale", bcbCode: "A35"},
    {edqmCode: "ROA-20042000", pososLabel: "Voie intrathécale", bcbCode: "B65"},
    {edqmCode: "ROA-20043000", pososLabel: "Voie intratumorale", bcbCode: "X"},
    {edqmCode: "ROA-20044000", pososLabel: "Voie intra-utérine", bcbCode: "B39"},
    {edqmCode: "ROA-20045000", pososLabel: "Voie intraveineuse", bcbCode: "A40"},
    {edqmCode: "ROA-20046000", pososLabel: "Voie intravésicale", bcbCode: "A41"},
    {edqmCode: "ROA-20047000", pososLabel: "Voie intravitréenne", bcbCode: "A79"},
    {edqmCode: "ROA-20049000", pososLabel: "Voie nasale", bcbCode: "A42"},
    {edqmCode: "ROA-20051000", pososLabel: "Voie ophtalmique", bcbCode: "B64"},
    {edqmCode: "ROA-20053000", pososLabel: "Voie orale", bcbCode: "A46"},
    {edqmCode: "ROA-20054000", pososLabel: "Voie buccale", bcbCode: "A47"},
    {edqmCode: "ROA-20055000", pososLabel: "Voie oropharyngée", bcbCode: "X"},
    {edqmCode: "ROA-20057000", pososLabel: "Voie périarticulaire", bcbCode: "A49"},
    {edqmCode: "ROA-20058000", pososLabel: "Voie périneurale", bcbCode: "A50"},
    {edqmCode: "ROA-20059000", pososLabel: "Voie périodontale", bcbCode: "A81"},
    {edqmCode: "ROA-20059400", pososLabel: "Voie péritumorale", bcbCode: "X"},
    {edqmCode: "ROA-20061000", pososLabel: "Voie rectale", bcbCode: "A52"},
    {edqmCode: "ROA-20065000", pososLabel: "Voie sous-conjonctivale", bcbCode: "X"},
    {edqmCode: "ROA-20066000", pososLabel: "Voie sous-cutanée", bcbCode: "A58"},
    {edqmCode: "ROA-20067000", pososLabel: "Voie sublinguale", bcbCode: "A74"},
    {edqmCode: "ROA-20067500", pososLabel: "Voie sous-muqueuse", bcbCode: "X"},
    {edqmCode: "ROA-20070000", pososLabel: "Voie transdermique", bcbCode: "A61"},
    {edqmCode: "ROA-20071000", pososLabel: "Voie urétrale", bcbCode: "B62"},
    {edqmCode: "ROA-20072000", pososLabel: "Voie vaginale", bcbCode: "B63"},
    {edqmCode: "ROA-20080000", pososLabel: "Voie intracérébroventriculaire", bcbCode: "X"},
    {edqmCode: "ROA-20081000", pososLabel: "Voie subrétinale", bcbCode: "X"}
  ]

  var fixRouteCode = function(route) {
    var bcb_routes = PrescUtils.routes;
    var edqm_routes = routeCodeEDQMtoBCB;
    var matchedDisplay = null;

    for (var i = 0; i < edqm_routes.length; i++) {
      if (route.code === edqm_routes[i].edqmCode) {
        route.code = edqm_routes[i].bcbCode;
      }
    }

    for (var i = 0; i < bcb_routes.length; i++) {
      if (route.code === bcb_routes[i].code) {
        return _.clone(bcb_routes[i]);
      }
      // in last resort try to match with labels
      if (route.label === bcb_routes[i].label) {
        matchedDisplay = _.clone(bcb_routes[i]);
      }
    }
    return matchedDisplay;
  };

  function convertToHoursMinutes(durationQuantity, durationCode) {
    // Return null for months and years (no approximations)
    if (durationCode === 'mo' || durationCode === 'a') {
      return {
        durationHours: null,
        durationMinutes: null
      };
    }

    var conversionToMinutes = {
      'ms': 1 / 60000,
      's': 1 / 60,
      'min': 1,
      'h': 60,
      'd': 24 * 60,
      'wk': 7 * 24 * 60,
    };

    var totalMinutes = Math.floor(durationQuantity * conversionToMinutes[durationCode]);
    var durationHours = Math.floor(totalMinutes / 60);
    var durationMinutes = totalMinutes % 60;

    return {
      durationHours: durationHours,
      durationMinutes: durationMinutes
    };
  }

  function groupAndReverseItemBySequence(list) {
    var sequenceGroups = {};
    var sequences = [];
    var itemsWithoutSequence = []; // Fixed typo: was "itemWithoutSequence"

    // Group items by sequence
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      if (item.sequence != null) {
        if (!sequenceGroups[item.sequence]) {
          sequenceGroups[item.sequence] = [];
          sequences.push(item.sequence);
        }
        sequenceGroups[item.sequence].push(item);
      } else {
        itemsWithoutSequence.push(item);
      }
    }

    for (var seq in sequenceGroups) {
      sequenceGroups[seq].reverse();
    }

    if (itemsWithoutSequence.length > 0) {
      itemsWithoutSequence.reverse();
      if (!sequenceGroups[0]) {
        sequences.push(0)
        sequenceGroups[0] = [];
      }
      sequenceGroups[0] = itemsWithoutSequence.concat(sequenceGroups[0]);
    }
    return _.sortBy(sequences).map(function(sequence_number) { return sequenceGroups[sequence_number] })
  }

  function parseFhirToCare(medicationRequest, startDate, bcbCodeOnly, prescCategories, mdbCheck) {
    var basePrescriptionFields = {
      category:(_.find(prescCategories, {name: "FOND"}) || {}).id,
    }
    var dataPrescriptionFields = {
      is_posos_pristine: true,
      is_posos: true,
    }

    var extensionDosageStructurationScore = _.find(medicationRequest.extension, {"valueCoding": {"system": "https://terminology.posos.co/dosageStructurationScore"}})
    if (extensionDosageStructurationScore) {
      dataPrescriptionFields.posos_structuration_reliability =  extensionDosageStructurationScore.valueCoding.code
    }
    _.assign(dataPrescriptionFields,
      _.pick(mdbCheck,
        ["bdm_data", "name", "in_mdb_drugs", "in_house_pharmacy_catalog", "dci_mode", "structured", "search_by", "numbers_to_texts", "route", "taking_unit"]
    ))
    basePrescriptionFields.defaultText = medicationRequest.text ? medicationRequest.text.div : "undefined"

    if (medicationRequest.note && medicationRequest.note.length > 0 && medicationRequest.note[0].text) {
      dataPrescriptionFields.comment = medicationRequest.note[0].text
    }

    var prescriptions = null

    if (medicationRequest.dosageInstruction) {
      var groupedDosageInstructions = groupAndReverseItemBySequence(medicationRequest.dosageInstruction)
      // call setupPrescriptionFromMultipleDosageInstructions for each sequenced prescription.
      prescriptions = _.map(groupedDosageInstructions, function(dosageInstructions) {
        return setupPrescriptionFromMultipleDosageInstructions(dosageInstructions, basePrescriptionFields, dataPrescriptionFields, prescCategories, bcbCodeOnly);
      })
    } else {
      prescriptions = [PrescUtils.setupPrescription(false, basePrescriptionFields, dataPrescriptionFields)]
    }

    setupPrescriptionsStartDates(prescriptions, startDate)

    if (prescriptions.length > 1) {
      createPrescriptionGroup(prescriptions)
    }

    return prescriptions;
  }

  function setupPrescriptionsStartDates(prescriptions, startDate) {
    if (prescriptions.length > 0) {
      prescriptions[0].start_date = moment(startDate).format("YYYY-MM-DD");
    }

    for (var i = 1; i < prescriptions.length; i++) {
      var prescription = prescriptions[i];
      var previousPrescription = prescriptions[i - 1];

      if (previousPrescription && previousPrescription.start_date && previousPrescription.duration) {
        prescription.start_date = moment(previousPrescription.start_date)
            .add(previousPrescription.duration, 'days')
            .format("YYYY-MM-DD");
      } else if (previousPrescription) {
        prescription.start_date = null
      }
    }
  }

  function createPrescriptionGroup(prescriptions) {
    var groupId = GenUID.generate(32)
    _.forEach(prescriptions, function (prescription) {
      prescription.group = groupId
      prescription.group_sequence = 1
      prescription.data.group_title = $filter("translate")("SEQUENTIAL_TAKE_OF", {prescription_name: prescription.data.name})
      prescription.data.use_posos_posology = false
    })
  }

  function parsePrescriptionCategoryFromDosageInstruction(dosageInstruction, prescCategories) {
    return (_.find(prescCategories, {name: (dosageInstruction.asNeededBoolean? "PAP": "FOND")}) || {}).id
  }

  function parseRouteCodeFromDosageInstruction(dosageInstruction) {
    if (dosageInstruction.route && dosageInstruction.route.coding && dosageInstruction.route.coding.length > 0) {
      // TODO: handle multiple different results.
      return fixRouteCode({
        "code": dosageInstruction.route.coding[0].code,
        "label": dosageInstruction.route.coding[0].display
      })
    } else if (dosageInstruction.site && dosageInstruction.site.coding && dosageInstruction.site.coding.length > 0) {
      // TODO: handle multiple different results.
      return fixRouteCode({
        "code": dosageInstruction.site.coding[0].code,
        "label": dosageInstruction.site.coding[0].display
      })
    }
  }

  function parseFrequencyUnitFromPeriodUnit(periodUnit) {
    return {d: "days", wk: "weeks"}[periodUnit]
  }

  function parseWeekDaysFromDayOfWeek(dayOfWeek) {
    return _.map(dayOfWeek, function(dayCode){return _.indexOf(["mon", "tue", "wed", "thu", "fri", "sat", "sun"], dayCode)})
  }

  function parseDurationIntoDrip(dosageInstructionTimingRepeat) {
    if (dosageInstructionTimingRepeat.duration && dosageInstructionTimingRepeat.durationUnit) {
      var durationHoursMinutes = convertToHoursMinutes(dosageInstructionTimingRepeat.duration, dosageInstructionTimingRepeat.durationUnit)
      return {
        with_drip: true,
        drip_hours: durationHoursMinutes.durationHours,
        drip_minutes: durationHoursMinutes.durationMinutes,
      }
    }
    return {}
  }

  function parseTimeslotsTakes(eventTimings, doseAndRate) {
    var quantity_by_timeslot = {};
    _.forEach(eventTimings, function(eventTimingCode) {
      var eventTiming = _.find(EventTimingOptions, {code: eventTimingCode})
      if (!eventTiming || !eventTiming.mhcareCode) {
        return {};
      } else {
        quantity_by_timeslot[eventTiming.mhcareCode] = doseAndRate.doseQuantity.value;
      }
    })
    return quantity_by_timeslot;
  }

  function parseFrequencyIntoIntervalOrDebit(frequency, doseAndRate) {
    if (_.includes([6, 4, 3, 2], frequency)) {
      return {
        takes: "intervals",
        interval: 24/frequency,
        interval_quantity: doseAndRate.doseQuantity.value
      }
    } else {
      return {
        takes: "debit",
        debit_interval: "day",
        debit_unit: doseAndRate.doseQuantity.value * frequency
      }
    }
  }

  function parseBoundsIntoDuration(dosageInstruction) {
    var boundsType = _.find(_.keys(dosageInstruction.timing.repeat), function(key) {return _.startsWith(key, "bounds")})
    if (boundsType) {
      if (boundsType === "boundsDuration"){
        return dosageInstruction.timing.repeat.boundsDuration.value * ({
          "month": 30, "week": 7
        }[dosageInstruction.timing.repeat.boundsDuration.unit] || 1)
      }
    }
  }

  function parseTimingFromDosageInstruction(dosageInstruction) {
    var timing = {}
    if (dosageInstruction.timing) {
      timing.frequency = dosageInstruction.timing.repeat.period
      timing.frequency_unit = parseFrequencyUnitFromPeriodUnit(dosageInstruction.timing.repeat.periodUnit)

      if (timing.frequency_unit === "weeks") {
        timing.week_days = parseWeekDaysFromDayOfWeek(dosageInstruction.timing.repeat.dayOfWeek)
      }

      if (dosageInstruction.timing.repeat.frequencyMax){
        timing.max_quantity = dosageInstruction.timing.repeat.frequencyMax
      }

      _.assign(timing, parseDurationIntoDrip(dosageInstruction.timing.repeat))

      if (dosageInstruction.timing.repeat.when) {
        timing.quantity_by_timeslot = parseTimeslotsTakes(dosageInstruction.timing.repeat.when, dosageInstruction.doseAndRate[0])
      } else if (dosageInstruction.timing.repeat.frequency && dosageInstruction.doseAndRate) {
        _.assign(timing, parseFrequencyIntoIntervalOrDebit(dosageInstruction.timing.repeat.frequency, dosageInstruction.doseAndRate[0]))
      }
    }
    return timing
  }

  function setupPrescriptionFromDosageInstruction(prescription, dosageInstruction, prescCategories, bcbCodeOnly) {
    prescription.category = parsePrescriptionCategoryFromDosageInstruction(dosageInstruction, prescCategories)

    if (dosageInstruction.doseAndRate && dosageInstruction.doseAndRate[0].doseQuantity.unit){
      // TODO: handle multiple different results.
      prescription.data.taking_unit = fhirDoseAndRateToTakingUnit(dosageInstruction.doseAndRate[0], bcbCodeOnly)
    }

    prescription.data.route = parseRouteCodeFromDosageInstruction(dosageInstruction)

    _.assign(prescription.data, parseTimingFromDosageInstruction(dosageInstruction))

    if (dosageInstruction.timing) {
      prescription.duration = parseBoundsIntoDuration(dosageInstruction)
    }

    prescription.data.posos_default_posology = dosageInstruction.text || prescription.data.posos_default_posology
  }

  function setupPrescriptionFromMultipleDosageInstructions(dosageInstructions, basePrescriptionFields, dataPrescriptionFields, prescCategories, bcbCodeOnly) {
    var prescription = PrescUtils.setupPrescription(false, basePrescriptionFields, dataPrescriptionFields)

    _.forEach(dosageInstructions, function(dosageInstruction) {
      setupPrescriptionFromDosageInstruction(prescription, dosageInstruction, prescCategories, bcbCodeOnly)
    })
    return prescription;
  }

  return {
    fixRouteCode: fixRouteCode,
    fhirDoseAndRateToTakingUnit: fhirDoseAndRateToTakingUnit,
    getMeta: function (page) {
      var img = new Image();
      var done = $q.defer()
      img.onload = function() {
        page.naturalWidth = img.naturalWidth
        page.naturalHeight = img.naturalHeight
        done.resolve()
      }
      img.src = page.image_url;
      return done
    },
    fhireToCare: function (medicationRequest, medication, startDate, catalogDrugs) {
      var cipCodes = _.map(_.filter(medication.code.coding, function(code) { return _.startsWith(code.system.split("/").pop(), "cip")}), "code")
      var inMdbDrugs = false
      var inHousePharmacyCatalog = false
      var cipCode = _.find(cipCodes, function(value) {return _.includes(_.map(catalogDrugs.in_mdb, "cip"), value.length == 7 ? value : value.slice(5, 12))})
      var catalogProduct = null
      if (cipCode){inMdbDrugs = true; catalogProduct = _.find(catalogDrugs.in_mdb, {cip: cipCode.length == 7 ? cipCode : cipCode.slice(5, 12)})}
      else{
        var cipCode = _.find(cipCodes, function(value) { return _.includes(_.map(catalogDrugs.in_stock, "cip"), value.length == 7 ? value.length : value.slice(5, 12))})
        if(cipCode){ inHousePharmacyCatalog = true; catalogProduct = _.find(catalogDrugs.in_stock, {cip: cipCode.length == 7 ? cipCode : cipCode.slice(5, 12)})}
        else if(cipCodes.length > 0) {cipCode = cipCodes[0]}
      }

      return SiteVarsUtils.getValue("POSOS_BCB_CODE_ONLY", false).then (function (bcbCodeOnly){
        return PrescUtils.getCategories().promise.then ( function(prescCategories){
          return $q.when(cipCodes.length > 0 ? selectProduct(cipCode, inMdbDrugs, inHousePharmacyCatalog, catalogProduct) : null).then (function(mdbCheck){
            return $q.when((mdbCheck && !inMdbDrugs && !inHousePharmacyCatalog) ? checkMV(mdbCheck) : mdbCheck).then (function(mdbCheck){
              return parseFhirToCare(medicationRequest, startDate, bcbCodeOnly, prescCategories, mdbCheck)
            })
          })
        })
      })
    },
  }
}]);

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PreadmissionCtrl
    * @description
    * # PreadmissionCtrl
    * Controller of Preadmission
   */
  angular.module('mhclientApp').controller('PreadmissionCtrl', ["$scope", "$rootScope", "$state", "$window", "Stay", "Template", "SiteVarsUtils", function($scope, $rootScope, $state, $window, Stay, Template, SiteVarsUtils) {
    var init;
    $scope.previousState = $state.previous;
    $rootScope.removePatientMenu = false;
    if ($rootScope.currentStay.preadmission.checklist == null) {
      $rootScope.currentStay.preadmission.checklist = {};
    }
    $scope.checkListData = $rootScope.currentStay.preadmission.checklist;
    init = function() {
      $scope.showAcceptRejectButton = false;
      $scope.canWrite = $scope.checkPermissions("MHC_PREAD", "CAN_WRITE");
      if ($rootScope.mh_config.platform === "mhsi") {
        $scope.checklist_url = '/st/mh_' + moment().toISOString() + '/static/views/checklist.html';
        return SiteVarsUtils.get("USE_PATIENT_BACKEND", false).then(function(usePatientBackend) {
          return $scope.showAcceptRejectButton = !usePatientBackend.value;
        });
      } else {
        return SiteVarsUtils.get("PREAD_CHECKLIST").then(function(check_list_url) {
          return $scope.checklist_url = check_list_url.value;
        });
      }
    };
    $scope.setCheckListForm = function(checkListForm) {
      return $scope.checkListForm = checkListForm;
    };
    $scope.checkItem = function(event, item) {
      var formTemplateUID, goingState, goingURL, mgappAction, params, ref;
      goingState = event.target.attributes['data-state'];
      goingURL = event.target.attributes['data-url'];
      formTemplateUID = event.target.attributes['form-uid'];
      params = event.target.attributes['params'];
      mgappAction = event.target.attributes['data-mgapp-action'];
      if ($rootScope.mh_config.platform === "mgapp" && (mgappAction != null) && (mgappAction.value != null)) {
        return window.mgapp.request_action(mgappAction.value);
      } else {
        if ((goingState != null) && (goingState.value != null)) {
          $state.statesStack.push($state.current);
          if ((formTemplateUID != null) && (formTemplateUID.value != null)) {
            Template.query({
              'uid': formTemplateUID.value
            }).$promise.then(function(templates) {
              return $state.go("user.patient.stay.form.template", {
                'idTemplate': templates[0].id
              });
            });
          } else if ((params != null) && (params.value != null)) {
            $state.go(goingState.value, JSON.parse(params.value), {
              reload: true
            });
          } else {
            if ((ref = goingState.value) === "user.patient.preadsocialinfo" || ref === "user.patient.contacts.list" || ref === "user.patient.details" || ref === "user.patient.care") {
              $state.go(goingState.value.replace(/.patient./, ".patient.stay."));
            } else {
              $state.go(goingState.value);
            }
          }
        }
        if ((goingURL != null) && (goingURL.value != null)) {
          if (_.includes(goingURL.value, "upld_file") && _.includes(goingURL.value, "documents_mgr")) {
            return $state.go("user.patient.stay.scan", {
              uploadFile: true
            });
          } else if (_.includes(goingURL.value, "feed/MHC_IAS")) {
            return $state.go("user.patient.stay.message.hierarchic", {
              featureName: "MHC_IAS"
            });
          } else {
            return $window.location = goingURL.value;
          }
        }
      }
    };
    $scope.updateCheckList = function() {
      $rootScope.currentStay.preadmission.checklist = $scope.checkListData;
      return Stay.update({
        id: $rootScope.currentStay.id
      }, {
        preadmission: $rootScope.currentStay.preadmission
      });
    };
    $scope.updateIsDormant = function() {
      $rootScope.busy = true;
      return Stay.update({
        id: $rootScope.currentStay.id
      }, {
        is_dormant: $rootScope.currentStay.is_dormant
      }).$promise.then(function() {
        return $rootScope.busy = false;
      });
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      window.mgappConfirmQuit = window.mgapp.quit_view;
    }
    return init();
  }]);

}).call(this);

//# sourceMappingURL=preadmission-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PreadmissionPatientCtrl
    * @description
    * # PreadmissionPatientCtrl
    * Controller of patient Preadmission
   */
  angular.module('mhclientApp').controller('PreadmissionPatientCtrl', ["$scope", "$rootScope", "$q", "$window", "$uibModal", "Patient", "Stay", "$state", "$filter", "SiteVarsUtils", function($scope, $rootScope, $q, $window, $uibModal, Patient, Stay, $state, $filter, SiteVarsUtils) {
    var changePatientInformationModal, initModal, reallyAcceptPatient;
    $scope.loading = false;
    $scope.current_ipp = $rootScope.currentPatient.si_id;
    $scope.current_stay_id = $rootScope.currentStay.si_id;
    $scope.canWrite = $scope.checkPermissions("MHC_PREAD", "CAN_WRITE");
    SiteVarsUtils.get("ALLOW_PATIENT_IPP_MODIFICATION_IN_PREAD", false).then(function(allowPatientModification) {
      return $scope.allow_patient_ipp_modification = allowPatientModification.value;
    });
    $scope.acceptPatient = function() {
      if ($scope.allow_patient_ipp_modification) {
        return changePatientInformationModal();
      } else {
        return reallyAcceptPatient(false);
      }
    };
    reallyAcceptPatient = function(toUpdate) {
      $rootScope.busy = true;
      return Stay.accept_pread({
        id: $rootScope.currentStay.id
      }).$promise.then(function(stay) {
        var promises;
        $rootScope.currentStay.d_from = stay.d_from;
        $rootScope.currentStay.state = stay.state;
        if (toUpdate) {
          promises = [];
          if ($rootScope.currentPatient.si_id !== $scope.current_ipp) {
            promises.push(Patient.update({
              id: $rootScope.currentPatient.id
            }, {
              si_id: $rootScope.currentPatient.si_id
            }).$promise);
          }
          if ($rootScope.currentStay.identitovigilance.checked) {
            promises.push(Stay.update({
              id: $rootScope.currentStay.id
            }, {
              identitovigilance: $rootScope.currentStay.identitovigilance
            }).$promise);
          }
          if ($rootScope.currentStay.si_id !== $scope.current_stay_id) {
            promises.push(Stay.update({
              id: $rootScope.currentStay.id
            }, {
              si_id: $rootScope.currentStay.si_id
            }).$promise);
          }
        }
        return $q.all(promises).then(function() {
          $rootScope.busy = false;
          return $scope.go_to_next();
        });
      });
    };
    initModal = function() {
      var pr;
      pr = $uibModal.open({
        animation: true,
        templateUrl: 'preadmission/views/modal-change-patient-id.html',
        controller: 'changePatientIdModalCtrl',
        size: "lg",
        resolve: {
          title: function() {
            return $filter('translate')("PATIENT_CHANGE_MODAL_TITLE");
          },
          text: function() {
            return $filter('translate')("WISH_TO_CHANGE_PATIENT_IDS");
          },
          okButtonText: function() {
            return $filter('translate')("VALIDATE");
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL");
          },
          user: function() {
            return $scope.user;
          }
        }
      });
      return pr;
    };
    changePatientInformationModal = function() {
      var pr;
      pr = initModal();
      return pr.result.then((function(toUpdate) {
        if (toUpdate) {
          return reallyAcceptPatient(true);
        }
      }));
    };
    $scope.togglePreadLock = function() {
      $rootScope.busy = true;
      $rootScope.currentStay.preadmission.lock_pread_data = !$rootScope.currentStay.preadmission.lock_pread_data;
      return Stay.update({
        id: $rootScope.currentStay.id
      }, {
        preadmission: $rootScope.currentStay.preadmission
      }).$promise.then(function(stay) {
        if ($rootScope.currentStay.preadmission.lock_pread_data) {
          $rootScope.currentStay.medical_data = stay.medical_data;
          angular.forEach(stay.pread_medical_data, function(value, key) {
            var ref;
            if (((ref = $rootScope.currentStay.medical_data[key]) === null || ref === (void 0)) || $rootScope.currentStay.medical_data[key].length === 0) {
              if (key === "POIDS" || key === "TAIL") {
                return $rootScope.currentStay.medical_data[key] = parseFloat(stay.pread_medical_data[key]);
              } else {
                return $rootScope.currentStay.medical_data[key] = stay.pread_medical_data[key];
              }
            }
          });
          Stay.update({
            id: $rootScope.currentStay.id
          }, {
            medical_data: $rootScope.currentStay.medical_data
          }).$promise.then(function() {
            return $rootScope.busy = false;
          });
        }
        return {
          "else": $rootScope.busy = false
        };
      });
    };
    $scope.go_to_next = function() {
      if ($rootScope.mh_config.platform === "mhsi") {
        return $state.go('user.stay-list');
      } else {
        return window.mgapp.close_screen();
      }
    };
    return $scope.rejectPatient = function() {
      var modalInstance, refusList;
      refusList = ["Autre orientation sanitaire ou sociale", "Charge en soins insuffisante", "Suivi IDE libéral suffisant", "Demande annulée par la famille ou le patient", "Non accord du médecin traitant", "Demande annulée par le service", "Décès", "Hors critère HAD", "Hors zone géographique", "Motif social", "Sortie reportée"];
      modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'preadmission/views/pread-refuse.html',
        controller: 'PreadRefuseCtrl',
        size: "lg",
        resolve: {
          items: function() {
            return refusList;
          },
          canWrite: function() {
            return $scope.canWrite;
          }
        }
      });
      return modalInstance.result.then(function(rejectedBy) {
        $rootScope.busy = true;
        $rootScope.currentStay.preadmission.rejected_by = rejectedBy;
        return Stay.reject_pread({
          id: $rootScope.currentStay.id,
          rejected_by: rejectedBy
        }).$promise.then(function(stay) {
          $rootScope.currentStay.state = stay.state;
          $rootScope.currentStay.d_from = stay.d_from;
          $rootScope.busy = false;
          return $scope.go_to_next();
        });
      });
    };
  }]);

  angular.module('mhclientApp').controller('PreadRefuseCtrl', ["$scope", "$uibModalInstance", "items", "canWrite", function($scope, $uibModalInstance, items, canWrite) {
    $scope.items = items;
    $scope.canWrite = canWrite;
    $scope.ok = function() {
      return $uibModalInstance.close($scope.choice);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss('cancel');
    };
  }]);

}).call(this);

//# sourceMappingURL=preadmission-patient-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CareOrgaCtrl
    * @description
    * # CareOrgaCtrl
    * Controller of Care organisation
   */
  angular.module('mhclientApp').controller('CareOrgaCtrl', ["$scope", "$rootScope", "$state", "Stay", "Group", "Medicaldb", function($scope, $rootScope, $state, Stay, Group, Medicaldb) {
    $scope.careResource = Medicaldb.getMedicalActs;
    $scope.canWrite = $scope.checkPermissions("MHC_PREAD", "CAN_WRITE");
    if (($state.statesStack[0] != null) && ($state.statesStack[0].name != null)) {
      $scope.previousState = $state.statesStack[0].name;
    } else {
      $scope.previousState = "user.patient.stay.pread";
    }
    Group.query({}).$promise.then(function(groups) {
      return $scope.availableGroups = groups;
    });
    $scope.careOrganisation = $rootScope.currentStay.care_organisation;
    if (!$scope.careOrganisation) {
      $scope.careOrganisation = {};
    }
    $scope.save = function() {
      $rootScope.busy = true;
      $scope.careOrganisation.timestamp = moment.utc().toISOString();
      $scope.careOrganisation.author = $rootScope.user.full_name;
      return Stay.update({
        id: $rootScope.currentStay.id
      }, {
        care_organisation: $scope.careOrganisation
      }).$promise.then(function() {
        $rootScope.currentStay.care_organisation = $scope.careOrganisation;
        return $rootScope.busy = false;
      });
    };
    $scope.mgappCloseRequest = function() {
      if ($scope.previousState != null) {
        return $state.go($scope.previousState);
      } else {
        return window.mgapp.close_screen();
      }
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      window.mgappConfirmQuit = window.mgapp.quit_view;
      return window.mgappClose = $scope.mgappCloseRequest;
    }
  }]);

}).call(this);

//# sourceMappingURL=care-organisation-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:PreadSocialInfoCtrl
    * @description
    * # CareOrgaCtrl
    * Controller of Pread Social Informations
   */
  angular.module('mhclientApp').controller('PreadSocialInfoCtrl', ["$scope", "$state", "$rootScope", "Stay", function($scope, $state, $rootScope, Stay) {
    $scope.canWrite = $scope.checkPermissions("MHC_PREAD", "CAN_WRITE");
    if (($state.statesStack[0] != null) && ($state.statesStack[0].name != null)) {
      $scope.previousState = $state.statesStack[0].name;
    } else {
      $scope.previousState = "user.patient.stay.pread";
    }
    $scope.model = $rootScope.currentStay.social_info;
    $scope.save = function() {
      $rootScope.busy = true;
      $rootScope.currentStay.social_info = $scope.model;
      return Stay.update({
        id: $rootScope.currentStay.id
      }, {
        social_info: $scope.model
      }).$promise.then(function() {
        $rootScope.busy = false;
        return $state.go($scope.previousState);
      });
    };
    $scope.mgappCloseRequest = function() {
      if ($scope.previousState != null) {
        return $state.go($scope.previousState);
      } else {
        return window.mgapp.close_screen();
      }
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      window.mgappConfirmQuit = window.mgapp.quit_view;
      return window.mgappClose = $scope.mgappCloseRequest;
    }
  }]);

}).call(this);

//# sourceMappingURL=pread-social-info-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:changePatientIdModalCtrl
    * @description
    * # changePatientIdModalCtrl
    * Provider of changePatientIdModalCtrl
   */
  angular.module("mhclientApp").controller('changePatientIdModalCtrl', ["$scope", "$rootScope", "$uibModalInstance", "title", "text", "okButtonText", "cancelButtonText", "user", "moment", function($scope, $rootScope, $uibModalInstance, title, text, okButtonText, cancelButtonText, user, moment) {
    $scope.text = text;
    $scope.title = title;
    $scope.patient_nds = $rootScope.currentStay.si_id;
    $scope.patient_ipp = $rootScope.currentPatient.si_id;
    $scope.identitovigilance_checked = $rootScope.currentStay.identitovigilance.checked;
    $scope.cancelButtonText = cancelButtonText;
    $scope.okButtonText = okButtonText;
    $scope.yes = function() {
      $rootScope.currentPatient.si_id = $scope.patient_ipp;
      $rootScope.currentStay.si_id = $scope.patient_nds;
      $rootScope.currentStay.identitovigilance.checked = $scope.identitovigilance_checked;
      if ($rootScope.currentStay.identitovigilance.checked) {
        $rootScope.currentStay.identitovigilance.author_fullname = user.full_name;
        $rootScope.currentStay.identitovigilance.author_login = user.username;
        $rootScope.currentStay.identitovigilance.timestamp = moment();
        $rootScope.currentStay.identitovigilance.which_day = moment().format('LLL');
      }
      return $uibModalInstance.close(true);
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=change-patient-id-modal-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:EntityCtrl
    * @description
    * # EntityCtrl
    * TODO: write a true description
   */
  angular.module('mhclientApp').controller('EntityCtrl', ["$scope", "Entity", "Upload", "Sector", "$uibModal", "$filter", function($scope, Entity, Upload, Sector, $uibModal, $filter) {
    var already_init;
    $scope.mode = "reading";
    $scope.entityFields = Entity.entityFields;
    $scope.entityBeforeModify = null;
    already_init = false;
    $scope.selectEntity = function(entity) {
      return $scope.current_entity = entity;
    };
    $scope.init = function() {
      if (already_init) {
        return;
      }
      already_init = true;
      return Entity.api.query().$promise.then(function(entities) {
        $scope.entities = entities;
        if ($scope.entities.length > 0) {
          return $scope.current_entity = $scope.entities[0];
        }
      });
    };
    $scope.modifyEntity = function() {
      $scope.mode = "edition";
      return $scope.entityBeforeModify = angular.copy($scope.current_entity);
    };
    $scope.submit = function() {
      var entity_data;
      $scope.current_entity.sitevars.COORDINATES = $scope.current_entity.sitevars.ADDRESS + " " + $scope.current_entity.sitevars.ZIP + " " + $scope.current_entity.sitevars.TOWN;
      if ($scope.mode === "edition") {
        entity_data = angular.copy($scope.current_entity);
        return Upload.upload({
          url: "/api_rest/entities/" + $scope.current_entity.id,
          method: "PATCH",
          file: $scope.current_entity.new_logo,
          fields: entity_data
        }).then(function(response) {
          $scope.mode = "reading";
          $scope.current_entity.logo = response.data.logo;
          return $scope.current_entity.new_logo = null;
        });
      } else {
        return Upload.upload({
          url: "/api_rest/entities",
          method: "POST",
          file: $scope.current_entity.new_logo,
          fields: $scope.current_entity
        }).then(function(response) {
          $scope.current_entity.logo = response.data.logo;
          $scope.current_entity.new_logo = null;
          $scope.mode = "reading";
          return $scope.current_entity.id = response.data.id;
        });
      }
    };
    $scope.createEntity = function() {
      $scope.mode = "creation";
      $scope.current_entity = {
        sitevars: {}
      };
      return $scope.entities.push($scope.current_entity);
    };
    $scope.cancel = function() {
      if ($scope.mode === "creation") {
        _.remove($scope.entities, $scope.current_entity);
        $scope.current_entity = null;
      } else {
        _.merge($scope.current_entity, $scope.entityBeforeModify);
      }
      return $scope.mode = "reading";
    };
    return $scope.init();
  }]);

}).call(this);

//# sourceMappingURL=entity-controller.js.map

(function() {
  'use strict';
  angular.module("mhclientApp").factory('Certificate', ["$resource", "MhConfig", "$q", "BoxResource", "Task", "$filter", "$uibModal", function($resource, MhConfig, $q, BoxResource, Task, $filter, $uibModal) {
    var acceptHeader;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    return $resource('/api_rest/certificates/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      }
    });
  }]);

  angular.module("mhclientApp").factory('ConfigSecret', ["$resource", "MhConfig", "$q", "BoxResource", "Task", "$filter", "$uibModal", function($resource, MhConfig, $q, BoxResource, Task, $filter, $uibModal) {
    var acceptHeader;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    return $resource('/api_rest/config_secret/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      }
    });
  }]);

  angular.module("mhclientApp").factory('Entity', ["$resource", "MhConfig", "$q", "BoxResource", "Task", "$filter", "$uibModal", function($resource, MhConfig, $q, BoxResource, Task, $filter, $uibModal) {
    var acceptHeader, entitiesCache, getEntities, globalEntitiesPromise, portailAPI, selectEntityId, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/entities/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    entitiesCache = null;
    globalEntitiesPromise = $q.defer();
    getEntities = function() {
      var EntitiesPromise;
      EntitiesPromise = $q.defer();
      if (entitiesCache != null) {
        globalEntitiesPromise.promise.then(function() {
          return EntitiesPromise.resolve(angular.copy(entitiesCache));
        });
      } else {
        entitiesCache = [];
        portailAPI.query().$promise.then(function(entities) {
          entitiesCache = entities;
          EntitiesPromise.resolve(angular.copy(entitiesCache));
          return globalEntitiesPromise.resolve();
        });
      }
      return EntitiesPromise.promise;
    };
    selectEntityId = function(title) {
      return getEntities().then(function(entities) {
        if (entities.length === 1) {
          return entities[0].id;
        }
        return $uibModal.open({
          templateUrl: 'site/views/select-entity-modal.html',
          controller: ["$scope", "entities", "title", function($scope, entities, title) {
            $scope.entities = entities;
            return $scope.title = title;
          }],
          backdrop: 'static',
          keyboard: false,
          resolve: {
            entities: function() {
              return entities;
            },
            title: function() {
              return title;
            }
          }
        }).result;
      });
    };
    service = {
      api: portailAPI,
      getEntities: getEntities,
      selectEntityId: selectEntityId,
      sectorFields: [
        {
          label: $filter('translate')('LABEL_TITLE'),
          key: "LABEL_TITLE"
        }, {
          label: $filter('translate')('Finess'),
          key: "finess"
        }, {
          label: $filter('translate')('ADDRESS'),
          key: "ADDRESS"
        }, {
          label: $filter('translate')('ZIP'),
          key: "ZIP"
        }, {
          label: $filter('translate')('TOWN'),
          key: "TOWN"
        }, {
          label: $filter('translate')('PHONE_NUMBER'),
          key: "PHONE_NUMBER"
        }, {
          label: $filter('translate')('FAX_NUMBER'),
          key: "FAX_NUMBER"
        }, {
          label: $filter('translate')('EMAIL'),
          key: "EMAIL"
        }
      ],
      entityFields: [
        {
          label: $filter('translate')('LABEL_TITLE'),
          key: "LABEL_TITLE",
          required: true
        }, {
          label: $filter('translate')('ADDRESS'),
          key: "ADDRESS"
        }, {
          label: $filter('translate')('ZIP'),
          key: "ZIP"
        }, {
          label: $filter('translate')('TOWN'),
          key: "TOWN"
        }, {
          label: $filter('translate')('PHONE_NUMBER'),
          key: "PHONE_NUMBER"
        }, {
          label: $filter('translate')('FAX_NUMBER'),
          key: "FAX_NUMBER"
        }, {
          label: $filter('translate')('EMAIL'),
          key: "EMAIL",
          type: "email"
        }, {
          label: $filter('translate')('WEBSITE'),
          key: "WEBSITE"
        }, {
          label: $filter('translate')('SIRET'),
          key: "SIRET"
        }, {
          label: $filter('translate')('TVA'),
          key: "TVA"
        }, {
          label: $filter('translate')('BILL_FOOTER'),
          key: "BILL_FOOTER",
          type: "textarea"
        }
      ]
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=site-service.js.map


'use strict';


angular.module("mhclientApp").component("sectorList", {
  templateUrl: "site/components/sector/sector-list.html",
  bindings: {entityId: "<?"},
  controller: ["$rootScope", "Sector", function sectorEditionCtrl($rootScope, Sector) {
    var ctrl;
    ctrl = this;
    ctrl.$onChanges = function(changes) {
      $rootScope.busy = true
      Sector.getSectors().then (function (sectors) {
        $rootScope.busy = false;
        ctrl.sectors = _.orderBy(ctrl.entityId ?  _.filter(sectors, {entity: ctrl.entityId}) : sectors, "name")
        ctrl.canManageSectors = $rootScope.user.group.features.indexOf("SRV_sec") != -1
      })
    }

    ctrl.$onInit = function() {
      ctrl.canManageSectors = $rootScope.user.group.features.indexOf("SRV_sec") != -1
      ctrl.removeSector = function (sector) { _.remove(ctrl.sectors, sector)}
      ctrl.addSector = function () {ctrl.sectors.push({name:name, entity: ctrl.entityId, data:{}})}
      ctrl.checkNameUnique = function(sector) {
          return !_.find(_.reject(ctrl.sectors, {id:sector.id}), {name: sector.name})
      }
      ctrl.checkCodeUnique = function(sector) {
          return !_.find(_.reject(ctrl.sectors, {id:sector.id}), {code: sector.code, entity: sector.entity})
      }
    }

  }],
});


angular.module("mhclientApp").component("sector", {
  templateUrl: "site/components/sector/sector.html",
  bindings: {sector: "<", removeCallBack: "&", checkNameUnique:"&", checkCodeUnique: "&"},
  controller: ["$rootScope", "Sector", "Entity", "$q", function sectorEditionCtrl($rootScope, Sector, Entity, $q) {
    var ctrl;
    ctrl = this;
    ctrl.$onInit = function() {
      ctrl.sectorFields = Entity.sectorFields
      ctrl.canManageSectors = $rootScope.user.group.features.indexOf("SRV_sec") != -1
      ctrl.modifySector = function() {ctrl.modifiedSector = _.cloneDeep(ctrl.sector)}
      if (!ctrl.sector.id) {ctrl.modifySector(ctrl.sector)}

      ctrl.submitSector = function () {
        $rootScope.busy = true
        ctrl.modifiedSector.data.COORDINATES = [ctrl.modifiedSector.data.ADDRESS, ctrl.modifiedSector.data.ZIP, ctrl.modifiedSector.data.TOWN].join(" ");
        (ctrl.sector.id ? Sector.modifySector : Sector.addSector)(ctrl.modifiedSector).then (function (sector) {
          _.assign(ctrl.sector, sector)
          $rootScope.busy = false
          ctrl.modifiedSector = null
        })
      }

      ctrl.removeSector = function() {
        $rootScope.busy = true
        $q.when(ctrl.sector.id ? Sector.removeSector(ctrl.sector).$promise : true).then (function (){
          $rootScope.busy = false
          ctrl.removeCallBack({sector:ctrl.sector})
        })
       }
     }
   }],
});


(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:FormTemplateCreateCtrl
    * @description
    * # FormTemplateCreateCtrl
    * Provider of FormTemplateCreateCtrl
   */
  angular.module("mhclientApp").controller('SupportCtrl', ["$q", "$rootScope", "$scope", "$state", "User", "Patient", function($q, $rootScope, $scope, $state, User, Patient) {
    var getCurrentTabRoute, getSplittedCurrentRoute, init;
    $scope.options = [
      {
        "label": "FICHCOMP (obsolète)",
        "template": "fichcomp.html"
      }, {
        "label": "Médicaments onéreux",
        "template": "medicaments-onereux.html"
      }, {
        "label": "Transfer Stay Data",
        "template": "transfer-stay-data.html"
      }, {
        "label": "Extraction Compte Rendu Metier",
        "template": "compte-rendu-metier.html"
      }, {
        "label": "Merge patient",
        "template": "merge-patients.html"
      }, {
        "label": "Extraction: Patients ayant une prescription de ce médicament",
        "template": "patient-par-medicament.html"
      }, {
        "label": "Extraction: Liste des intervenants avec la date de dernière connexion",
        "template": "users-last-login-details.html"
      }, {
        "label": "Catalog import",
        "template": "catalog-import.html"
      }, {
        "label": "Matrice des droits",
        "template": "matrice-des-droits.html"
      }, {
        "label": "Import users",
        "template": "users-import.html"
      }
    ];
    getSplittedCurrentRoute = function() {
      return $state.current.name.split(".");
    };
    getCurrentTabRoute = function() {
      var splittedCurrentRoute;
      splittedCurrentRoute = $state.current.name.split(".");
      return splittedCurrentRoute[2];
    };
    init = function() {
      if (getSplittedCurrentRoute().length === 2) {
        return;
      }
      return $scope.currentOption = _.find($scope.options, function(option) {
        return option.route === getCurrentTabRoute();
      });
    };
    init();
    $scope.selectOption = function(option) {
      var route;
      $scope.currentOption = option;
      route = option.route;
      if (!route) {
        $state.go('user.support');
        return;
      }
      if (getSplittedCurrentRoute().length === 2) {
        return $state.go('.' + option.route);
      }
    };
    $scope.getPatients = function() {
      var patientsDone;
      patientsDone = $q.defer();
      if (!$scope.patients) {
        $rootScope.busy = true;
        Patient.query().$promise.then(function(patients) {
          $scope.patients = patients;
          $rootScope.busy = false;
          return patientsDone.resolve($scope.patients);
        });
      } else {
        patientsDone.resolve($scope.patients);
      }
      return patientsDone.promise;
    };
    return $scope.filterByLabel = function(viewValue) {
      return function(item, index, array) {
        return !viewValue || viewValue === " " || viewValue === null || item.label.toLowerCase().indexOf(viewValue.toLowerCase()) >= 0;
      };
    };
  }]);

  angular.module("mhclientApp").controller('TransferStayData', ["$scope", "$rootScope", "$uibModal", "notify", "Patient", function($scope, $rootScope, $uibModal, notify, Patient) {
    var selectStayModal;
    selectStayModal = function(patient) {
      return $uibModal.open({
        animation: true,
        templateUrl: 'core/views/select-stay-widget-modal.html',
        controller: 'selectStayWidget',
        size: "lg",
        resolve: {
          patient: function() {
            return patient;
          },
          states: function() {
            return false;
          }
        }
      });
    };
    $scope.getPatients().then(function(patients) {
      return $scope.availablePatients = patients;
    });
    $scope.submit = function() {
      var params;
      $rootScope.busy = true;
      params = {
        "id": $scope.currentPatient.id,
        "source": $scope.source.id,
        "destination": $scope.destination.id,
        "start_date": $scope.start_date ? moment($scope.start_date).format("YYYY-MM-DD") : void 0,
        "end_date": $scope.end_date ? moment($scope.end_date).format("YYYY-MM-DD") : void 0
      };
      return Patient.transferStayData(params).$promise.then(function() {
        $scope.currentPatient = null;
        $scope.source = null;
        $scope.destination = null;
        $rootScope.busy = false;
        return notify({
          classes: ['alert-info'],
          message: "DONE"
        });
      });
    };
    $scope.selectStay = function(type) {
      return selectStayModal($scope.currentPatient).result.then(function(selectedStay) {
        if (selectedStay) {
          if (type === "source") {
            return $scope.source = selectedStay;
          } else {
            return $scope.destination = selectedStay;
          }
        }
      });
    };
    return $scope.selectPatient = function(patient) {
      $scope.currentPatient = patient;
      $scope.source = null;
      return $scope.destination = null;
    };
  }]);

  angular.module("mhclientApp").controller('MergePatients', ["$scope", "$rootScope", "$uibModal", "notify", "Patient", "Stay", function($scope, $rootScope, $uibModal, notify, Patient, Stay) {
    var selectStayModal;
    selectStayModal = function(patient) {
      return $uibModal.open({
        animation: true,
        templateUrl: 'core/views/select-stay-widget-modal.html',
        controller: 'selectStayWidget',
        size: "lg",
        resolve: {
          patient: function() {
            return patient;
          },
          states: function() {
            return false;
          }
        }
      });
    };
    $scope.getPatients().then(function(patients) {
      return $scope.availablePatients = patients;
    });
    $scope.getStays = function(patient) {
      return Stay.query({
        patient: patient.id
      }).$promise.then(function(stays) {
        return patient.stays = stays;
      });
    };
    return $scope.submit = function(masterId, slaveId) {
      $rootScope.busy = true;
      return Patient.mergePatient({
        id: masterId,
        slave_id: slaveId
      }).$promise.then(function() {
        $scope.masterPatient = null;
        $scope.slavePatient = null;
        $rootScope.busy = false;
        return notify({
          classes: ['alert-info'],
          message: "DONE"
        });
      });
    };
  }]);

  angular.module("mhclientApp").controller('ExtractCompteRenduMetier', ["$scope", "$rootScope", "notify", "Message", function($scope, $rootScope, notify, Message) {
    return $scope.submit = function() {
      var params;
      $rootScope.busy = true;
      params = {
        "id": 1,
        "start_date": $scope.start_date ? moment($scope.start_date).format("YYYY-MM-DD") : void 0,
        "end_date": $scope.end_date ? moment($scope.end_date).format("YYYY-MM-DD") : void 0
      };
      return Message.api.extractCompteRenduMetier(params).$promise.then(function() {
        $rootScope.busy = false;
        return notify({
          classes: ['alert-info'],
          message: "DONE"
        });
      });
    };
  }]);

  angular.module("mhclientApp").controller('ExtractPatientsParMedicament', ["$scope", "$rootScope", "notify", "Prescription", "$filter", function($scope, $rootScope, notify, Prescription, $filter) {
    $scope.medications = [];
    $scope.filteredMedications = [];
    Prescription.query().$promise.then(function(prescriptions) {
      var i, len, medicationSet, prescription, ref;
      medicationSet = new Set();
      for (i = 0, len = prescriptions.length; i < len; i++) {
        prescription = prescriptions[i];
        if ((ref = prescription.data) != null ? ref.name : void 0) {
          medicationSet.add(prescription.data.name);
        }
      }
      $scope.medications = Array.from(medicationSet).sort();
      return $scope.filteredMedications = $scope.medications;
    });
    $scope.filterMedications = function() {
      var searchText;
      if ($scope.drug_name) {
        searchText = $scope.drug_name.toLowerCase();
        return $scope.filteredMedications = $scope.medications.filter(function(med) {
          return med.toLowerCase().startsWith(searchText);
        });
      } else {
        return $scope.filteredMedications = $scope.medications;
      }
    };
    $scope.selectMedication = function(medication) {
      $scope.drug_name = medication;
      return $scope.showMedicationList = false;
    };
    return $scope.submit = function() {
      var params;
      $rootScope.busy = true;
      params = {
        "start_date": $scope.start_date ? moment($scope.start_date).format("YYYY-MM-DD") : void 0,
        "end_date": $scope.end_date ? moment($scope.end_date).format("YYYY-MM-DD") : void 0,
        "drug_name": $scope.drug_name
      };
      return Prescription.extractPatientPatMedicament(params).$promise.then(function(resp) {
        var message;
        if (resp.status === "OK") {
          message = $filter('translate')("PRINT_WILL_BE_SENT_VIA_EMAIL_TODAY");
        } else {
          message = $filter('translate')("PATIENT_WITHOUT_PRESCS");
        }
        return notify({
          classes: ['alert-info'],
          message: message
        });
      })["catch"](function(error) {
        return console.error(error);
      })["finally"](function() {
        return $rootScope.busy = false;
      });
    };
  }]);

  angular.module("mhclientApp").controller('UserLastLoginDetails', ["$scope", "$rootScope", "$uibModal", "notify", "User", function($scope, $rootScope, $uibModal, notify, User) {
    return $scope.submit = function() {
      var params;
      $rootScope.busy = true;
      params = {
        "id": 1,
        "start_date": $scope.start_date ? moment($scope.start_date).format("YYYY-MM-DD") : void 0,
        "end_date": $scope.end_date ? moment($scope.end_date).format("YYYY-MM-DD") : void 0
      };
      return User.exportUserLastLoginDetails(params).$promise.then(function(resp) {
        $rootScope.busy = false;
        return console.log(resp);
      });
    };
  }]);

  angular.module("mhclientApp").controller('MatriceDesDroits', ["$scope", "$rootScope", "Group", "GroupUtils", "$q", "$filter", "notify", function($scope, $rootScope, Group, GroupUtils, $q, $filter, notify) {
    $scope.requestType = null;
    $scope.newImportFile = null;
    $scope.submit = function() {
      var reader;
      $rootScope.busy = true;
      if ($scope.requestType === 'export') {
        Group.exportFeaturePermissions({
          "id": 1,
          "export": true
        }).$promise.then(function(permissions) {
          var a, blob;
          a = document.createElement('a');
          if (window.navigator.msSaveOrOpenBlob) {
            blob = new Blob([JSON.stringify(permissions)], {
              type: 'text/json;charset=utf-8;'
            });
            navigator.msSaveBlob(blob, 'matrice_des_droits.json');
          } else {
            a.href = 'data:attachment/json;charset=utf-8,' + JSON.stringify(permissions);
            a.target = '_blank';
            a.download = 'matrice_des_droits.json';
            document.body.appendChild(a);
            a.click();
          }
          return $rootScope.busy = false;
        });
      }
      if ($scope.requestType === 'import') {
        reader = new FileReader();
        reader.onloadend = function(evt) {
          if (evt.target.readyState === FileReader.DONE) {
            return $scope.$apply(function() {
              var groupsNotFound, permissionsToImport;
              permissionsToImport = JSON.parse(evt.target.result);
              groupsNotFound = [];
              return GroupUtils.getAllGroups().then(function(groups) {
                groups.forEach(function(group) {
                  var shortName;
                  shortName = group.short_name;
                  if (permissionsToImport.hasOwnProperty(shortName)) {
                    group.feature_permissions = JSON.stringify(permissionsToImport[shortName]['feature_permissions']);
                    group.features = permissionsToImport[shortName]['features'];
                    group.access_patient_info = permissionsToImport[shortName]['access_patient_info'];
                    group.liberal = permissionsToImport[shortName].liberal;
                    group.broken_orders_mail_recipient = permissionsToImport[shortName].broken_orders_recipient;
                    group.historic_as_default = permissionsToImport[shortName].historic_as_default;
                    group.dont_filter_agenda_events = permissionsToImport[shortName].dont_filter_agenda_events;
                    return group.for_default_prescriptor = permissionsToImport[shortName].for_default_prescriptor;
                  } else {
                    return groupsNotFound.push(shortName);
                  }
                });
                return Group.updateGroups({
                  groups: groups
                }).$promise.then(function() {
                  if (groupsNotFound.length > 0) {
                    notify({
                      classes: ['alert-info'],
                      message: $filter('translate')("GROUPS_SHORTNAME_NOT_FOUND_IN_IMPORT_FILE") + ": \n" + groupsNotFound.join(",\n")
                    });
                  }
                  return $rootScope.busy = false;
                });
              });
            });
          }
        };
        return reader.readAsText($scope.newImportFile);
      }
    };
    return $scope.onFileChange = function(fileEl) {
      var file, files;
      $rootScope.busy = true;
      files = fileEl.files;
      file = files[0];
      $scope.newImportFile = file;
      return $rootScope.busy = false;
    };
  }]);

  angular.module("mhclientApp").controller('UsersImport', ["$scope", "$q", "$timeout", "$http", "$rootScope", "$window", "Upload", function($scope, $q, $timeout, $http, $rootScope, $window, Upload) {
    var query;
    query = function(url) {
      var doQuery, queryResults;
      queryResults = $q.defer();
      doQuery = function() {
        $http({
          method: 'GET',
          url: url
        }).success(function(body) {
          queryResults.resolve(body);
        }).error(function() {
          $timeout(doQuery, 10000);
        });
      };
      doQuery();
      return queryResults.promise;
    };
    return $scope.submit = function(newImportFile) {
      if (newImportFile) {
        $rootScope.busy = true;
        return Upload.upload({
          url: '/api_rest/create_update_user/import_users',
          method: "POST",
          file: newImportFile
        }).then(function(response) {
          return query(response.data.result).then(function(response) {
            var a;
            a = document.createElement("a");
            a.style = "display: none";
            a.target = '_blank';
            a.href = URL.createObjectURL(new Blob([response]));
            a.download = newImportFile.name;
            a.click();
            return $rootScope.busy = false;
          });
        });
      }
    };
  }]);

  angular.module("mhclientApp").controller('catalogImport', ["$scope", "$q", "$timeout", "$http", "$rootScope", "$window", "Articles", "notify", function($scope, $q, $timeout, $http, $rootScope, $window, Articles, notify) {
    return $scope.submit = function(newImportFile) {
      var reader;
      if (newImportFile) {
        reader = new FileReader;
        $rootScope.busy = true;
        reader.onload = function(loadEvent) {
          return Articles.api.importArticles(JSON.parse(reader.result)).$promise.then(function(results) {
            $rootScope.busy = false;
            return notify({
              classes: ['alert-info'],
              message: "DONE"
            });
          });
        };
        return reader.readAsText(newImportFile);
      }
    };
  }]);

  angular.module("mhclientApp").controller('MedicamentsOnereux', ["$scope", "$rootScope", "PrescUtils", function($scope, $rootScope, PrescUtils) {
    $scope.newImportFile = null;
    $scope.submit = function() {
      var params, reader;
      $rootScope.busy = true;
      params = {
        "start_date": $scope.start_date ? moment($scope.start_date).format("YYYY-MM-DD") : void 0,
        "end_date": $scope.end_date ? moment($scope.end_date).format("YYYY-MM-DD") : void 0
      };
      reader = new FileReader();
      reader.onloadend = function(evt) {
        if (evt.target.readyState === FileReader.DONE) {
          return $scope.$apply(function() {
            var ucdList;
            ucdList = JSON.parse(evt.target.result);
            return PrescUtils.getHightCostDrugs(params, ucdList).promise.then(function(prescs) {
              var a, blob;
              if (window.navigator.msSaveOrOpenBlob) {
                blob = new Blob([encodeURI(prescs)], {
                  type: 'text/csv;charset=utf-8;'
                });
                navigator.msSaveBlob(blob, 'my_data.csv');
              } else {
                a = document.createElement('a');
                a.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(prescs);
                a.target = '_blank';
                a.download = 'medicaments_onereux' + '_' + moment($scope.start_date).format("YYYY-MM-DD") + '_' + moment($scope.end_date).format("YYYY-MM-DD") + '.csv';
                document.body.appendChild(a);
                a.click();
              }
              return $rootScope.busy = false;
            });
          });
        }
      };
      return reader.readAsText($scope.newImportFile);
    };
    return $scope.onFileChange = function(fileEl) {
      var file, files;
      $rootScope.busy = true;
      files = fileEl.files;
      file = files[0];
      $scope.newImportFile = file;
      return $rootScope.busy = false;
    };
  }]);

  angular.module("mhclientApp").controller('Fichcomp', ["$scope", "$rootScope", "SiteVar", "SiteVarsUtils", function($scope, $rootScope, SiteVar, SiteVarsUtils) {
    $scope.updateData = false;
    $scope.newImportFile = null;
    $scope.uploadAndUpdate = function() {
      var reader;
      $rootScope.busy = true;
      reader = new FileReader();
      reader.onloadend = function(evt) {
        if (evt.target.readyState === FileReader.DONE) {
          return $scope.$apply(function() {
            var params, sitevarName;
            sitevarName = $scope.searchType + "_DRUG_UCD_LIST";
            params = {
              "name": sitevarName,
              "var_type": "json",
              "value": evt.target.result
            };
            return SiteVarsUtils.get(sitevarName).then(function(sitevar) {
              if (sitevar.value) {
                params.id = sitevar.id;
                return SiteVar.update(params).$promise.then(function() {
                  return $rootScope.busy = false;
                });
              } else {
                return SiteVar.save(params).$promise.then(function() {
                  return $rootScope.busy = false;
                });
              }
            });
          });
        }
      };
      return reader.readAsText($scope.newImportFile);
    };
    $scope.generateResults = function() {
      var baseUrl, url;
      $rootScope.busy = true;
      $scope.start_date = moment($scope.start_date).format("YYYY-MM-DD");
      $scope.end_date = moment($scope.end_date).format("YYYY-MM-DD");
      baseUrl = $scope.base_iframe_url + "/api_rest/prescriptions/fichcomp";
      url = baseUrl + "?end_date=" + $scope.end_date + "&start_date=" + $scope.start_date + "&searchType=" + $scope.searchType;
      window.open(url, '_blank');
      return $rootScope.busy = false;
    };
    return $scope.onFileChange = function(fileEl) {
      var file, files;
      $rootScope.busy = true;
      files = fileEl.files;
      file = files[0];
      $scope.newImportFile = file;
      return $rootScope.busy = false;
    };
  }]);

}).call(this);

//# sourceMappingURL=support-controller.js.map

angular.module("mhclientApp").component("hcdDrugsTable", {
  templateUrl: "high-cost-drugs/components/views/drugs-table.html",
  controller: hcdDrugsTableCtrl,
  bindings: {
    type: "@",
  },
});

function hcdDrugsTableCtrl(
  $uibModal,
  HighCostDrugApi,
  HighCostDrugCache,
  SortingService
) {
  var ctrl = this;

  ctrl.isLoading = true;
  ctrl.currentPage = 1;
  ctrl.pageCount = undefined;
  ctrl.search = undefined;
  ctrl.sorting = {
    order: undefined,
    direction: undefined,
  };
  ctrl.drugs = [];

  ctrl.changePage = changePage;
  ctrl.handleSearchChange = handleSearchChange;
  ctrl.openExportModal = openExportModal;
  ctrl.openUpdateModal = openUpdateModal;
  ctrl.isExpired = isExpired;
  ctrl.handleSortingChange = handleSortingChange;

  ctrl.$onInit = init;

  function init() {
    loadDrugs();
  }

  function changePage() {
    loadDrugs();
  }

  function loadDrugs() {
    ctrl.isLoading = true;

    HighCostDrugApi.query({
      page: ctrl.currentPage,
      type: ctrl.type,
      search: ctrl.search,
      ordering: SortingService.getOrderingFromSorting(ctrl.sorting),
    })
      .$promise.then(function (paginatedDrugs) {
        ctrl.pageCount = paginatedDrugs.count;
        ctrl.drugs = formatHighCostDrugsWithOneIndicationLabelEach(
          paginatedDrugs.results
        );
      })
      .finally(function () {
        ctrl.isLoading = false;
      });
  }
  function formatHighCostDrugsWithOneIndicationLabelEach(drugs) {
    var result = [];

    for (var i in drugs) {
      var drug = drugs[i];
      if (drug.indication == null) {
        result.push(_.cloneDeep(drug));
      } else {
        for (var j in drug.indication.labels) {
          var copiedDrug = _.cloneDeep(drug);
          copiedDrug.indication.name = copiedDrug.indication.labels[j];
          result.push(copiedDrug);
        }
      }
    }

    return result;
  }

  function handleSearchChange() {
    resetPagination();

    loadDrugs();
  }

  function openExportModal() {
    $uibModal.open({
      component: "hcdExportDrugsModal",
      keyboard: true,
      size: "lg",
      resolve: {
        drugType: function () {
          return ctrl.type;
        },
      },
    });
  }

  function openUpdateModal() {
    var modal = $uibModal.open({
      animation: true,
      component: "hcdUpdateDrugsModal",
      resolve: {
        drugType: function () {
          return ctrl.type;
        },
      },
    });

    modal.result.then(function () {
      HighCostDrugCache.removeAll();

      loadDrugs();
    });
  }

  function isExpired(drug) {
    var today = moment();
    return (
      moment(drug.coverage_start).isAfter(today) ||
      moment(drug.coverage_end).isBefore(today)
    );
  }

  function handleSortingChange(order) {
    ctrl.sorting = SortingService.getNewSorting(ctrl.sorting, order);
    // Reset pagination after sorting change to keep sync
    resetPagination();

    loadDrugs();
  }

  function resetPagination() {
    ctrl.currentPage = 1;
  }
}

angular.module("mhclientApp").component("hcdExportCsvRowTable", {
  templateUrl: "high-cost-drugs/components/views/export-csv-row-table.html",
  controller: hcdExportCsvRowTableCtrl,
  bindings: {
    errorsPerRows: "<",
    errorType: "<",
  },
});

function hcdExportCsvRowTableCtrl($filter, $scope) {
  var ctrl = this;

  $scope.hasFieldIssue = hasFieldIssue;
  $scope.translateFields = translateFields;

  function hasFieldIssue(field, error) {
    if (error == undefined || error.fields == undefined) return false;

    return error.fields.includes(field);
  }

  function translateFields(fields) {
    if (fields == null) return [];

    return _.map(fields, function (field) {
      return $filter("translate")("HIGH_COST_DRUGS_IMPORT_FIELDS_" + field);
    });
  }
}

angular.module("mhclientApp").component("hcdExportDrugsErrorHandler", {
  templateUrl:
    "high-cost-drugs/components/views/export-drugs-error-handler.html",
  controller: hcdExportDrugsErrorHandlerCtrl,
  bindings: {
    error: "<",
  },
});

function hcdExportDrugsErrorHandlerCtrl($filter) {
  var ctrl = this;

  ctrl.errorType = undefined;
  ctrl.drugsWithErrors = [];
  ctrl.rowsWithErrors = [];

  ctrl.$onChanges = onChanges;

  function onChanges(changes) {
    if (changes.error != null && changes.error.currentValue != null) {
      handleError(ctrl.error);
      return;
    }

    ctrl.errorType = undefined;
  }

  function handleError(error) {
    if (error == null || error.data == null) return;

    if (error.status === 400) {
      handle400Error(error);
    }
  }

  function handle400Error(error) {
    var errorData = error.data;

    var errorDataKeys = Object.keys(errorData);
    if (errorDataKeys.length !== 1) {
      throw new Error(
        "Should have at one key to handle the error, got " +
          errorDataKeys.join(", ")
      );
    }

    var errorKey = errorDataKeys[0];

    if (errorKey === "missing_header") {
      ctrl.missingHeader = errorData.missing_header;
    }
    if (errorKey === "missing_drugs") {
      ctrl.drugsWithErrors = errorData.missing_drugs;
    }
    if (
      ["row_errors", "fields_row_errors", "acceptable_errors"].includes(
        errorKey
      )
    ) {
      ctrl.rowsWithErrors = errorData[errorKey];
    }

    ctrl.errorType = errorKey;
  }

  function mapMissingDrugsToDrugs(drugs) {
    var mappedDrugs = _.map(drugs, function (drug) {
      return {
        ucd13: drug.ucd_13,
        name: drug.name,
        indicationCode: drug.indication__code,
      };
    });
    return mappedDrugs;
  }
}

"use strict";

angular.module("mhclientApp").component("hcdExportDrugsModal", {
  templateUrl: "high-cost-drugs/components/views/export-drugs-modal.html",
  controller: hcdExportDrugsModalCtrl,
  bindings: { resolve: "<", dismiss: "&" },
});

function hcdExportDrugsModalCtrl(CSVUtils, FichCompApi) {
  var ctrl = this;

  ctrl.isLoading = false;
  ctrl.startDate = moment().subtract(1, "months").startOf("month").toDate();
  ctrl.endDate = moment().startOf("month").toDate();

  ctrl.downloadCsv = downloadCsv;

  ctrl.$onInit = onInit;

  function onInit() {
    ctrl.drugType = ctrl.resolve.drugType;
  }

  function downloadCsv() {
    ctrl.isLoading = true;

    FichCompApi.fetchCsv(ctrl.drugType, [ctrl.startDate, ctrl.endDate])
      .then(function (response) {
        CSVUtils.download(response.data, response.filename);

        ctrl.dismiss();
      })
      .finally(function () {
        ctrl.isLoading = false;
      });
  }
}

angular.module("mhclientApp").component("hcdExportShortDrugsTable", {
  templateUrl: "high-cost-drugs/components/views/export-short-drugs-table.html",
  controller: hcdExportShortDrugsTableCtrl,
  bindings: {
    drugs: "<",
  },
});

function hcdExportShortDrugsTableCtrl() {
  var ctrl = this;
}

"use strict";

angular.module("mhclientApp").component("hcdIndicators", {
  templateUrl: "high-cost-drugs/components/views/indicators.html",
  controller: hcdIndicatorsController,
  bindings: {
    isLoading: "<",
    isError: "<",
    indicators: "<",
  },
});

function hcdIndicatorsController($scope) {
  var ctrl = this;

  $scope.indicatorsParams = {
    totalCount: {
      value: 0,
      class: "bg-info",
      icon: "glyphicon glyphicon-tag",
      translationKey: "DRUG_MANAGEMENT_INDICATORS_TOTAL",
    },
    activeCount: {
      value: 0,
      class: "bg-success",
      icon: "glyphicon glyphicon-ok",
      translationKey: "DRUG_MANAGEMENT_INDICATORS_ACTIVE",
    },
    expiredCount: {
      value: 0,
      class: "bg-warning",
      icon: "glyphicon glyphicon-exclamation-sign",
      translationKey: "DRUG_MANAGEMENT_INDICATORS_EXPIRED",
    },
  };

  ctrl.$onChanges = onChanges;

  function onChanges(changes) {
    if (
      changes.isLoading != null &&
      changes.isLoading.currentValue === false &&
      ctrl.indicators != null
    ) {
      fillIndicatorsParams(ctrl.indicators);
    }
    if (changes.isError != null && changes.isError.currentValue === true) {
      fillIndicatorsParams({
        totalCount: "-",
        activeCount: "-",
        expiredCount: "-",
      });
    }
  }

  function fillIndicatorsParams(indicators) {
    var keys = Object.keys($scope.indicatorsParams);
    _.forEach(keys, function (key) {
      $scope.indicatorsParams[key].value = indicators[key];
    });
  }
}

angular.module("mhclientApp").component("hcdMain", {
  templateUrl: "high-cost-drugs/components/views/main.html",
  controller: hcdMainCtrl,
});

// inspired by https://odetocode.com/blogs/scott/archive/2014/04/14/deep-linking-a-tabbed-ui-with-angularjs.aspx
function hcdMainCtrl(
  $filter,
  $scope,
  $state,
  $timeout,
  HighCostDrugsIndicators
) {
  var ctrl = this;

  $scope.tabs = [
    {
      heading: $filter("translate")("DRUG_TYPE_AAP_LES"),
      route: "les",
    },
    {
      heading: $filter("translate")("DRUG_TYPE_AAP_AAC"),
      route: "aap-aac",
    },
    {
      heading: $filter("translate")("DRUG_TYPE_AAP_EXCLUDING_LES_AND_AAP_AAC"),
      route: "excluding-les-and-aap-aac",
    },
  ];

  $scope.activeTabIndex = 0;
  $scope.getIndicators = HighCostDrugsIndicators.getIndicators;
  $scope.isIndicatorsLoading = HighCostDrugsIndicators.isLoading;
  $scope.isIndicatorsError = HighCostDrugsIndicators.isError;

  $scope.goTo = goTo;

  ctrl.$onInit = onInit;

  function onInit() {
    loadIndicators();

    if (getLastChildRoute() === "high-cost-drugs") {
      $state.go("." + $scope.tabs[0].route);
    }
    // Tab not changed when setting the active index initially
    // https://stackoverflow.com/questions/36420035/setting-active-tab-on-dynamically-created-tabs-with-angular-ui-bootstrap
    $timeout(function () {
      _.forEach($scope.tabs, function (tab, index) {
        if (isActive(tab)) {
          $scope.activeTabIndex = index;
        }
      });
    });
  }

  function getLastChildRoute() {
    var splittedCurrentRoute = $state.current.name.split(".");
    return splittedCurrentRoute[splittedCurrentRoute.length - 1];
  }

  function isActive(tab) {
    return getLastChildRoute() === tab.route;
  }

  function goTo(tab) {
    if (isActive(tab)) return;

    $state.go("^." + tab.route);
  }

  function loadIndicators() {
    HighCostDrugsIndicators.init();
  }
}

"use strict";

angular.module("mhclientApp").component("hcdUpdateDrugsModal", {
  templateUrl: "high-cost-drugs/components/views/update-drugs-modal.html",
  controller: hcdUpdateDrugsModalCtrl,
  bindings: { resolve: "<", close: "&", dismiss: "&" },
});

function hcdUpdateDrugsModalCtrl(
  $filter,
  notify,
  DownloadUtils,
  HighCostDrugApi,
  HighCostDrugsIndicators
) {
  var ctrl = this;

  ctrl.isUploading = false;
  ctrl.error = undefined;
  ctrl.fileToUpload = undefined;
  ctrl.importInfos = undefined;

  ctrl.updateHighCostDrugs = updateHighCostDrugs;
  ctrl.canForceUpdate = canForceUpdate;
  ctrl.downloadLastImportFile = downloadLastImportFile;
  ctrl.getLastImportFilename = getLastImportFilename;
  ctrl.handleOnChangeFileToUpload = handleOnChangeFileToUpload;

  ctrl.$onInit = onInit;

  function onInit() {
    ctrl.drugType = ctrl.resolve.drugType;

    loadImportInfos();
  }

  function loadImportInfos() {
    return HighCostDrugApi.getImportInfos({
      drugType: ctrl.drugType,
    }).$promise.then(function (infos) {
      if (infos.last_update == null) return;

      ctrl.importInfos = infos;
    });
  }

  function updateHighCostDrugs(forceUpdate) {
    ctrl.isUploading = true;
    ctrl.error = undefined;

    if (!ctrl.fileToUpload) {
      throw new Error(ctrl.fileToUpload);
    }

    HighCostDrugApi.importFromFile(
      {
        drugType: ctrl.drugType,
      },
      { file: ctrl.fileToUpload, force_import: forceUpdate }
    )
      .$promise.then(function () {
        HighCostDrugsIndicators.init();

        loadImportInfos().finally(function () {
          ctrl.isUploading = false;
        });

        notify({
          message: $filter("translate")("HIGH_COST_DRUGS_IMPORT_SUCCESS"),
          classes: ["alert-success"],
          duration: 2000,
        });

        ctrl.close();
      })
      .catch(function (error) {
        ctrl.error = error;
        ctrl.isUploading = false;
      });
  }

  function canForceUpdate() {
    return (
      ctrl.error != null &&
      ctrl.error.status === 400 &&
      ctrl.error.data != null &&
      ctrl.error.data.acceptable_errors != null
    );
  }

  function downloadLastImportFile() {
    // Cannot download xlsx directly from href, thus using http request
    // https://impythonist.wordpress.com/2016/08/05/building-an-excel-file-dump-service-in-django/
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (xhttp.readyState === 4 && xhttp.status === 200) {
        var filename = ctrl.importInfos.last_import_file_url
          .split("/")
          .slice(-1)[0];
        DownloadUtils.downloadBlob(xhttp.response, filename);
      }
    };
    xhttp.open("GET", ctrl.importInfos.last_import_file_url, true);
    xhttp.setRequestHeader("Content-Type", "application/json");
    xhttp.responseType = "blob";
    xhttp.send();
  }

  function getLastImportFilename() {
    if (
      ctrl.importInfos == null ||
      ctrl.importInfos.last_import_file_url == null
    ) {
      return null;
    }

    var extension = ctrl.importInfos.last_import_file_url
      .split(".")
      .slice(-1)[0];
    return "import." + extension;
  }

  function handleOnChangeFileToUpload() {
    ctrl.error = undefined;
  }
}

angular.module("mhclientApp").factory("FichCompApi", FichCompApiFactory);

function FichCompApiFactory($http, $httpParamSerializer, DownloadUtils) {
  var base_url = "/api_rest/high_cost_drugs/fich_comp/";

  function fetchCsv(drugType, dateRange) {
    var params = $httpParamSerializer({
      start_date: moment(dateRange[0]).format("YYYY-MM-DD"),
      end_date: moment(dateRange[1]).format("YYYY-MM-DD"),
    });
    return $http({
      url: base_url + drugType + "/export?" + params,
      method: "GET",
      headers: { Accept: "text/csv" },
    }).then(function (response) {
      return {
        data: response.data,
        filename: DownloadUtils.getFilenameFromHttpResponse(response),
      };
    });
  }

  return {
    fetchCsv: fetchCsv,
  };
}

angular
  .module("mhclientApp")
  .factory("HighCostDrugApi", HighCostDrugApiFactory);

function HighCostDrugApiFactory(
  $resource,
  FormDataUtils,
  HighCostDrugCache,
  MhConfig
) {
  var headers = { Accept: MhConfig.baseAcceptHeader };

  var resource = $resource(
    "/api_rest/high_cost_drugs/:id/:drugType/:route",
    {},
    {
      query: {
        params: { page: "@page", search: "@search", ordering: "@ordering" },
        headers: headers,
        cache: HighCostDrugCache,
      },
      importFromFile: {
        method: "POST",
        headers: {
          Accept: MhConfig.baseAcceptHeader,
          "Content-Type": undefined,
        },
        params: {
          route: "import",
          drugType: "@drugType",
        },
        transformRequest: FormDataUtils.mapDataToFormData,
      },
      getImportInfos: {
        method: "GET",
        headers: headers,
        params: {
          route: "import_infos",
          drugType: "@drugType",
        },
      },
      getIndicators: {
        method: "GET",
        headers: headers,
        params: {
          route: "indicators",
        },
      },
    }
  );

  return resource;
}

angular
  .module("mhclientApp")
  .factory("HighCostDrugCache", HighCostDrugCacheFactory);

function HighCostDrugCacheFactory($cacheFactory) {
  var cache = $cacheFactory("highCostDrugCache");

  return cache;
}

angular
  .module("mhclientApp")
  .factory("HighCostDrugsIndicators", HighCostDrugsIndicatorsFactory);

function HighCostDrugsIndicatorsFactory(HighCostDrugApi) {
  var _indicators = undefined;
  var _isLoading = true;
  var _isError = false;

  function init() {
    return fetchIndicators().then(function (indicators) {
      _indicators = indicators;
    });
  }

  function fetchIndicators() {
    _isLoading = true;
    _isError = false;

    return HighCostDrugApi.getIndicators()
      .$promise.then(function (indicators) {
        return {
          totalCount: indicators.total_count,
          activeCount: indicators.active_count,
          expiredCount: indicators.expired_count,
        };
      })
      .catch(function () {
        _isError = true;
      })
      .finally(function () {
        _isLoading = false;
      });
  }

  function getIndicators() {
    return _indicators;
  }
  function isError() {
    return _isError;
  }
  function isLoading() {
    return _isLoading;
  }

  return {
    init: init,
    getIndicators: getIndicators,
    isLoading: isLoading,
    isError: isError,
  };
}

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:Dashboard
    * @description
    * # Dashboard
    * Controller of Patient
   */
  angular.module('mhclientApp').controller('dashboardCtrl', ["$scope", "user", "Group", "$state", "$filter", "$window", "Patient", "MhConfig", "dashboardFactory", "VitalSigns", "Prescription", "PrescTask", "PrescTimeSlot", "PrescCategory", "$rootScope", "eventsFactory", function($scope, user, Group, $state, $filter, $window, Patient, MhConfig, dashboardFactory, VitalSigns, Prescription, PrescTask, PrescTimeSlot, PrescCategory, $rootScope, eventsFactory) {
    var computeVitalSignWidget, dashboard, dataGraph, defineLayout, getDataEventWidget, getDataTraitmentWidget, getTraitments, i, j, len, len1, ref, res, widget, widgetList;
    $scope.docWidth = angular.element(document).width();
    $scope.winWidth = angular.element(window).width();
    $scope.showTable = false;
    $scope.emptyWidgets = true;
    $scope.emptySigns = true;
    $scope.widgets = [];
    $scope.layouts = [];
    dataGraph = {};
    computeVitalSignWidget = function(widget) {
      return VitalSigns.api.gen_graph({
        patient_id: $scope.patient_detail.id
      }).$promise.then(function(data) {
        var i, len, ref, res, timeformat;
        res = {};
        if (data.data != null) {
          ref = data.data;
          for (i = 0, len = ref.length; i < len; i++) {
            data = ref[i];
            data.options.xaxes[0].timeformat = timeformat = "%d/%m/%y";
            data.options.pan.interactive = false;
            data.series.forEach(function(series) {
              if (data.series.map(function(x) {
                return x.label;
              }).indexOf(series.label) === -1) {
                data.series[data.series.length] = series;
              }
              series.points.radius = 5;
              series.defaultYaxisPos = series.yaxis;
              series.isShow = true;
              if (series.bars.show === true) {
                series.isBar = true;
              } else {
                series.isBar = false;
              }
              return dataGraph = data;
            });
            if (widget.conf.uid_graph === data.id && data.series.length) {
              res.graph = dataGraph;
            } else if (res.table && res.table.series) {
              res.table.series = res.table.series.concat(data.series);
            } else {
              res.table = data;
            }
          }
          widget.data = res;
          return $scope.emptySigns = false;
        } else {
          $scope.emptySigns = true;
          return widget.data = {};
        }
      });
    };
    $scope.evtsConf = {};
    getDataEventWidget = function(config) {
      return eventsFactory.api.get().$promise.then(function(evts) {
        $scope.eventsWidget = evts;
        return $scope.eventsConfig = config;
      });
    };
    getDataTraitmentWidget = function(config) {
      var prescQueryParams;
      $scope.traitements = {
        prescriptions: [],
        timeslots: []
      };
      prescQueryParams = {
        patient_id: $scope.patient_detail.id,
        exclude_state: ['STOPPED', 'EXPIRED']
      };
      PrescTimeSlot.api.query().$promise.then(function(slots) {
        return $scope.traitements.timeslots = slots;
      });
      return Prescription.api.query(prescQueryParams).$promise.then(function(presc) {
        return getTraitments(presc);
      });
    };
    getTraitments = function(prescriptions) {
      var today;
      today = $filter('date')(new Date().getTime(), 'yyyy-MM-dd');
      if ((prescriptions != null ? prescriptions.length : void 0) > 0) {
        $scope.isEmpty = false;
        return prescriptions.forEach(function(presc) {
          var taskQueryParams;
          taskQueryParams = {
            planning_id: presc.planning.id,
            date: today
          };
          presc.task = [];
          PrescTask.api.query(taskQueryParams).$promise.then(function(tasks) {
            return presc.task = tasks;
          });
          return $scope.traitements.prescriptions.push(presc);
        });
      } else {
        return $scope.isEmpty = true;
      }
    };
    defineLayout = function(data) {
      var layouts;
      layouts = data.split('|');
      $scope.layouts = layouts;
      return $scope.noPanel = layouts.length === 0 ? true : false;
    };
    dashboard = user.group.data.dashboard;
    if ((dashboard != null) && dashboard.layout && dashboard.widgets) {
      $scope.emptyWidgets = false;
      defineLayout(dashboard.layout);
      ref = dashboard.widgets;
      for (i = 0, len = ref.length; i < len; i++) {
        widgetList = ref[i];
        res = [];
        for (j = 0, len1 = widgetList.length; j < len1; j++) {
          widget = widgetList[j];
          if (widget.widget === "VITAL_SIGN") {
            computeVitalSignWidget(widget);
          } else if (widget.widget === "EVENTS") {
            widget.data = getDataEventWidget(widget.conf);
          } else if (widget.widget === "TRAITMENTS") {
            widget.data = getDataTraitmentWidget(widget.conf);
          } else {
            continue;
          }
          res.push(widget);
        }
        $scope.widgets.push(res);
      }
    }
    $scope.go = function(state) {
      return $state.go(state);
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      return window.mgappConfirmQuit = window.mgapp.quit_view;
    }
  }]);

}).call(this);

//# sourceMappingURL=dashboard-controller.js.map

(function() {
  'use strict';

  /*
   @ngdoc function
   @name mhclientApp.service:dashboardFactory
   @description
   Factory of dashboardFactory
   */
  angular.module("mhclientApp").factory('dashboardFactory', ["$resource", "MhConfig", function($resource, MhConfig) {
    var acceptHeader, dashboard, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/dashboard', {}, {});
    dashboard = {};
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        return dashboard;
      default:
        return portailAPI;
    }
  }]);

}).call(this);

//# sourceMappingURL=dashboard-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.teleconsultation:TeleconsultationService
    * @description
    * # TeleconsultationService
    * Service for the teleconsultation report feature
   */
  var appModule;

  appModule = angular.module('mhclientApp');

  appModule.service('TeleconsultationService', ["$state", "$q", "$http", "$rootScope", function($state, $q, $http, $rootScope) {
    var notify, obsFunc, observers, savedData, visioService;
    savedData = {};
    observers = [];
    visioService = void 0;
    notify = function() {
      observers.forEach(function(observer) {
        observer();
      });
    };
    obsFunc = function(action, event) {
      var key, store;
      if (action === 'call_update' && event['status'] === 'ongoing') {
        savedData[parseInt(event['initiator'])] = {};
        store = savedData[event['initiator']];
        if (event['urgent'] === true) {
          $state.go('user.patient.stay.teleconsultation', {
            idPatient: event['initiator']
          });
        } else if (event['extra_data'] && event['extra_data']['idPatient'] && event['extra_data']['idStay']) {
          $state.go('user.patient.stay.teleconsultation', {
            idPatient: event['extra_data']['idPatient'],
            idStay: event['extra_data']['idStay']
          });
        } else {
          $state.go('user.patient.stay.teleconsultation');
        }
        store.showNewTeleconsultationField = true;
        store.startTime = new Date;
        store.startTime.setSeconds(0);
        store.startTime.setMilliseconds(0);
        delete store.endTime;
        for (key in event['participants']) {
          if (event['participants'].hasOwnProperty(key)) {
            savedData[key] = store;
          }
        }
        notify();
      }
      if (action === 'call_update' && event['status'] === 'terminated') {
        store = savedData[parseInt(event['initiator'])];
        if (store) {
          store.endTime = new Date;
          store.endTime.setSeconds(0);
          store.endTime.setMilliseconds(0);
          notify();
        }
      }
    };
    return {
      savedData: savedData,
      registerListener: function(func) {
        observers.push(func);
      },
      unregisterListener: function(func) {
        if (!observers.indexOf(func)) {
          return;
        }
        observers.splice(observers.indexOf(func), 1);
      },
      get: function(user) {
        if (!(user in savedData)) {
          savedData[user] = {};
        }
        return savedData[user];
      },
      clean: function(user) {
        if (user in savedData) {
          delete savedData[user];
          notify();
        }
      },
      init: function(token_endpoint, connect_endpoint) {
        if (!visioService && token_endpoint && connect_endpoint) {
          $http.get(token_endpoint).then(function(response) {
            MhliveService.createInstance(connect_endpoint, response.data.vid, false).then(function(service) {
              visioService = service;
              service.addObserver(obsFunc);
              service.addObserver(function(event, message) {
                if (event === 'connected_list') {
                  Object.keys(message).forEach(function(item) {
                    message[item].last_seen = new Date(message[item].last_seen);
                  });
                  $rootScope.$broadcast('mhlive:connectedListUpdate', message);
                  $rootScope.mhliveConnectedList = message;
                }
                if (event === 'status_change') {
                  $rootScope.mhliveStatus = message['status'];
                }
                $rootScope.$apply();
              });
            });
          });
        }
        return MhliveService.getInstance();
      },
      call: function(id, extra_data) {
        MhliveService.getInstance().then(function(service) {
          var timerResetInterval;
          $http.get('/webfw/visio_ongoing/').then(function(res) {});
          timerResetInterval = setInterval((function() {
            $http.get('/webfw/visio_ongoing/').then(function(res) {});
          }), 600000);
          service.addObserver(function(action, event) {
            if (action === 'call_update' && event['status'] === 'terminated') {
              clearInterval(timerResetInterval);
              service.removeObserver(this);
            }
          });
          service.call(id, extra_data);
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=teleconsultation-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.teleconsultation:PatientTeleconsultationCtrl
    * @description
    * # PatientTeleconsultationCtrl
    * Controler for the platform teleconsultation feature
   */
  angular.module('mhclientApp').controller('PatientTeleconsultationCtrl', ["$scope", "$rootScope", "$q", "$translate", "$translatePartialLoader", "TeleconsultationService", "Patient", "UserUtils", function($scope, $rootScope, $q, $translate, $translatePartialLoader, TeleconsultationService, Patient, UserUtils) {
    var formattedDate, formattedDateTime, init, listener, updateTeleconsultationList;
    init = function() {
      $scope.permissions = $scope.group_feature_permissions;
      updateTeleconsultationList();
    };
    formattedDate = function(date) {
      return moment(date).format('LL');
    };
    formattedDateTime = function(datetime) {
      if (datetime) {
        return moment(datetime).format('LL') + ' ' + moment(datetime).format('LT');
      }
    };
    updateTeleconsultationList = function() {
      $scope.teleconsultations = $rootScope.currentPatient.data.teleconsultations;
      if (!$scope.teleconsultations) {
        $scope.teleconsultations = [];
      }
      angular.forEach($scope.teleconsultations, function(teleconsultation) {
        teleconsultation.formattedDate = moment(teleconsultation.date).format('LLLL');
      });
    };
    listener = function() {
      $scope.persistentTeleconsultation = TeleconsultationService.get($scope.user.id);
    };
    $translatePartialLoader.addPart('teleconsultation');
    $translatePartialLoader.addPart('visio');
    $translate.refresh();
    $scope.persistentTeleconsultation = TeleconsultationService.get($scope.user.id);
    $scope.$on('$destroy', function() {
      TeleconsultationService.unregisterListener(listener);
    });
    TeleconsultationService.registerListener(listener);
    $scope.callUser = function(id) {
      if (id) {
        TeleconsultationService.call(id, {
          'idPatient': $scope.currentPatient.id,
          'idStay': $scope.currentStay.id
        });
      } else {
        TeleconsultationService.call($scope.currentPatient.si_id, {
          'idPatient': $scope.currentPatient.id,
          'idStay': $scope.currentStay.id
        });
      }
    };
    $scope.formattedDate = formattedDate;
    $scope.formattedDateTime = formattedDateTime;
    $scope.createNewTeleconsultation = function() {
      var newTeleconsultation;
      newTeleconsultation = {
        author: $scope.user.id,
        author_fullname: $scope.user.full_name,
        date: moment().toISOString(),
        value: {
          starttime: moment($scope.persistentTeleconsultation.startTime).toISOString(),
          endtime: moment($scope.persistentTeleconsultation.endTime).toISOString(),
          htmlText: $scope.persistentTeleconsultation.newTeleconsultationText
        }
      };
      if ($rootScope.currentPatient.data.teleconsultations === void 0) {
        $rootScope.currentPatient.data.teleconsultations = [];
      }
      $rootScope.currentPatient.data.teleconsultations.push(newTeleconsultation);
      Patient.update({
        id: $rootScope.currentPatient.id
      }, {
        data: $rootScope.currentPatient.data
      });
      TeleconsultationService.clean($scope.user.id);
      $scope.teleconsultationForm.$setPristine();
      $scope.persistentTeleconsultation = TeleconsultationService.get($scope.user.id);
      $scope.persistentTeleconsultation.showNewTeleconsultationField = false;
      updateTeleconsultationList();
    };
    $scope.printVisioForms = function() {
      window.open("/webfw/documents_mgr/stay_" + $rootScope.currentStay.id + "/mhc_teleconsultations/to_pdf/", "_blank");
      return true;
    };
    init();
  }]);

}).call(this);

//# sourceMappingURL=teleconsultation-patient-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name teleconsultation.visioUserpicker
    * @description
    * Select user for visio directive
   */
  angular.module('mhclientApp').directive('visioUserPicker', ["$filter", "$http", "$rootScope", "UserUtils", function($filter, $http, $rootScope, UserUtils) {
    var link;
    link = function(scope, element, attrs, ctrl, transclude) {
      var loggedUser, updateConnectedList;
      loggedUser = $rootScope.user;
      scope.userSelect = {};
      updateConnectedList = function(connectedList) {
        var id, user;
        scope.connectedUserToTablet = null;
        for (element in connectedList) {
          id = element;
          if (scope.patient && id === scope.patient.si_id) {
            if (connectedList[element].status === 'ready') {
              scope.connectedUserToTablet = element;
            }
          }
          user = _.find(scope.users, function(o) {
            return o.id === parseInt(id);
          });
          if (user) {
            user.status = connectedList[element].status;
            user.statusText = connectedList[element].status;
          }
        }
      };
      $rootScope.$watchCollection('mhliveConnectedList', function(newVal) {
        updateConnectedList(newVal);
      });
      scope.isWebRTCSupported = false;
      if (MhliveService) {
        scope.isWebRTCSupported = MhliveService.isWebRTCSupported;
      }
      if (scope.patient) {
        return UserUtils.getUsersForPatient(scope.patient.si_id).then(function(res) {
          scope.users = res.filter(function(item) {
            if (item.id !== loggedUser.id) {
              return item;
            }
          });
          scope.users = _.sortBy(scope.users, [
            function(o) {
              return o.full_name.split(' ')[1];
            }
          ]);
          scope.users.forEach(function(e) {
            e.statusText = 'disconnected';
          });
          if ($rootScope.mhliveConnectedList) {
            updateConnectedList($rootScope.mhliveConnectedList);
          }
        });
      } else {
        return UserUtils.getUsers().then(function(res) {
          scope.users = res.filter(function(item) {
            if (item.id !== loggedUser.id) {
              return item;
            }
          });
          scope.users = _.sortBy(scope.users, [
            function(o) {
              return o.full_name.split(' ')[1];
            }
          ]);
          scope.users.forEach(function(e) {
            e.status = 'disconnected';
          });
          if ($rootScope.mhliveConnectedList) {
            updateConnectedList($rootScope.mhliveConnectedList);
          }
        });
      }
    };
    return {
      scope: {
        patient: "=",
        callFunc: "=",
        toTablet: "=",
        selectedUser: "@"
      },
      link: link,
      restrict: 'E',
      templateUrl: 'teleconsultation/views/visio-user-picker-view.html'
    };
  }]);

}).call(this);

//# sourceMappingURL=visio-user-picker-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.visio:BoxVisioCtrl
    * @description
    * # BoxVisioCtrl
    * Controler for the visio feature on tablet
   */
  var appModule;

  appModule = angular.module('mhclientApp');

  appModule.controller('BoxVisioCtrl', ["UserUtils", "$injector", "$scope", "$stateParams", "$state", "$translate", "$translatePartialLoader", "$timeout", "$http", "User", "SiteVar", function(UserUtils, $injector, $scope, $stateParams, $state, $translate, $translatePartialLoader, $timeout, $http, User, SiteVar) {
    var connectToServiceStandard, connectToServiceUrgent, updateConnectedList;
    updateConnectedList = function(connectedList) {
      var element, id, user;
      $scope.connectedUserToTablet = null;
      for (element in connectedList) {
        id = element;
        user = _.find($scope.usersForPatient, function(o) {
          return o.id === parseInt(id);
        });
        if (user) {
          user.status = connectedList[element].status;
        }
      }
    };
    connectToServiceUrgent = function(ws_endpoint) {
      $scope.mode = 'urgent';
      MhliveService.createInstance(ws_endpoint, 'URGENT_' + $stateParams.token, true).then(function(service) {
        service.addObserver((function(action, message) {
          var callStatus;
          if (event === 'call_update') {
            $scope.aid = service.getAid();
            if (message['status'] === 'pending') {
              if (message['initiator'] !== $scope.aid) {
                service.answer(message['call_id'], true);
              } else {
                $scope.status = 'PENDING';
              }
            } else if (message['status'] === 'ongoing') {
              $scope.status = 'ONGOING';
              callStatus = 'ONGOING';
            } else if (message['status'] === 'terminated') {
              if (callStatus === 'ONGOING') {
                $scope.status = 'TERMINATED';
              } else {
                $scope.status = 'DIDNT_ANSWER';
              }
            }
          }
          if (event === 'urgent_call_fail') {
            $scope.status = 'NO_AVAILABLE_ON_CALL_STAFF';
          }
          if (action === 'auth') {
            if (message['result'] === 'fail') {
              $scope.errorMessage = 'VISIO_AUTHENTICATION_FAIL';
            } else if (message['result'] === 'success') {
              $scope.ready = true;
              service.urgent_call();
            }
          }
          $scope.$apply();
        }), true);
      });
    };
    connectToServiceStandard = function(token_endpoint, ws_endpoint) {
      $scope.mode = 'patient';
      $http({
        url: token_endpoint,
        method: 'GET',
        params: {
          box_token: true,
          patient_id: $stateParams.ipp,
          user_token: $stateParams.token
        }
      }).then(function(resp) {
        MhliveService.createInstance(ws_endpoint, resp.data.vid, true).then(function(service) {
          $scope.callUser = function(user) {
            service.call(user);
          };
          service.addObserver((function(action, message) {
            if (action === 'connected_list') {
              Object.keys(message).forEach(function(item) {
                message[item].last_seen = new Date(message[item].last_seen);
              });
              $scope.mhliveConnectedList = message;
            }
            if (action === 'status_change') {
              $scope.mhliveStatus = message['status'];
              if (message['status'] === 'disconnected') {
                $scope.ready = false;
                $scope.errorMessage = 'YOU_HAVE_BEEN_DISCONNECTED';
              }
            }
            if (action === 'auth') {
              if (message['result'] === 'fail') {
                $scope.errorMessage = 'VISIO_AUTHENTICATION_FAIL';
              } else if (message['result'] === 'success') {
                $scope.ready = true;
              }
            }
            $scope.$apply();
          }), true);
        });
      })["catch"](function(err) {
        $scope.errorMessage = 'VISIO_ERROR_TOKEN';
      });
    };
    $translatePartialLoader.addPart('visio');
    $translatePartialLoader.addPart('teleconsultation');
    $translate.refresh().then(function() {
      SiteVar.getVisioServer().$promise.then(function(visioConfig) {
        if ((visioConfig.endpoint != null) != null) {
          if ($stateParams.urgent) {
            connectToServiceUrgent(visioConfig.endpoint);
          } else if ($stateParams.ipp) {
            connectToServiceStandard(visioConfig.id, visioConfig.endpoint);
          }
        } else {
          $scope.errorMessage = 'VISIO_NOT_AVAILABLE';
        }
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=box-visio-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.visio:mhliveWrapper
    * @description
    * # mhliveWrapper
    * Directive for the visio window
   */
  angular.module('mhclientApp').directive('mhliveWrapper', ["$timeout", "$translate", "$translatePartialLoader", "$filter", "MhliveService", "$compile", function($timeout, $translate, $translatePartialLoader, $filter, MhliveService, $compile) {
    var link;
    link = function(scope, element, attributes) {
      var _closeWindow, basePosAndSize, dragMoveListener, main, saveHeight, saveTranslate, saveWidth, serviceEvent, updateCallback, visioService;
      dragMoveListener = function(event) {
        var target, x, y;
        if (scope.fullscreen || !scope.isVisioOn) {
          return;
        }
        target = event.target;
        x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
      };
      _closeWindow = function() {
        var elem;
        if (scope.ringtone) {
          scope.ringtone.pause();
        }
        if (scope.widget) {
          scope.widget.remove();
        }
        elem = angular.element('.visio');
        elem.css('opacity', '1.0');
        angular.element('.visio').css('width', basePosAndSize.width);
        angular.element('.visio').css('height', basePosAndSize.height);
        angular.element('.visio').css('transform', 'none');
        scope.fullscreen = false;
        scope.isVisioOn = false;
        scope.expanded = 0;
        scope.show = false;
      };
      serviceEvent = function(action, message) {
        var _compileWC, aid, callers;
        aid = String(visioService.getAid());
        _compileWC = function() {
          var wrapper;
          scope.token = message['tokens'][aid];
          scope.session = message['session'];
          scope.call_id = message['call_id'];
          scope.apikey = message['api_key'];
          wrapper = angular.element(element).find('.wrapper');
          scope.widget = $compile('<mhvisio-plugin call-id="' + scope.call_id + '" session="' + scope.session + '" token="' + scope.token + '" apikey="' + scope.apikey + '"></mhvisio-plugin>')(scope);
          wrapper.append(scope.widget);
        };
        if (action === 'call_restart') {
          scope.widget.remove();
          _compileWC();
        }
        if (action === 'call_update') {
          scope.call_id = message['call_id'];
          if (message['status'] === 'ongoing' && message['participants'][aid].status === 'active' && !scope.isVisioOn) {
            if (scope.ringtone) {
              scope.ringtone.pause();
            }
            if (scope.mode === 'patient' && !scope.fullscreen) {
              scope.toggleFullscreen();
            }
            scope.expanded = 1;
            delete scope.message;
            delete scope.submessage;
            scope.showAnswerButtons = false;
            scope.isVisioOn = true;
            scope.show = true;
            basePosAndSize.height = angular.element('.visio').css('height');
            basePosAndSize.width = angular.element('.visio').css('width');
            _compileWC();
          } else if (message['status'] === 'pending' && (message['participants'][aid].status === 'ringing' || message['initiator'] === aid) && !scope.show) {
            scope.show = true;
            scope.expanded = 0.4;
            if (message['initiator'] === aid) {
              scope.showAnswerButtons = false;
              scope.message = $filter('translate')('VISIO_RINGING');
            } else {
              callers = [];
              Object.keys(message['participants']).forEach(function(item) {
                if (item !== aid) {
                  callers.push(message['participants'][item].name);
                }
              });
              scope.ringtone = new Audio('visio/ringtone.mp3');
              scope.ringtone.loop = true;
              scope.ringtone.play();
              scope.showAnswerButtons = true;
              scope.call_id = message.call_id;
              if (!message['urgent']) {
                scope.message = callers.join(', ') + ' ' + $filter('translate')('IS_CALLING_YOU');
              } else {
                scope.message = $filter('translate')('URGENT_CALL_FROM') + ' ' + message['participants'][message['initiator']].name;
                if (callers.length >= 2) {
                  scope.submessage = callers.length - 1 + ' ' + $filter('translate')('OTHER_RESPONDERS_BEING_CALLED');
                }
              }
            }
          } else if (message['status'] === 'terminated' || message['participants'][aid].status === 'gone') {
            if (message['end_reason'] && !(message['end_reason'] === 'call_ended') && message['initiator'] === aid) {
              scope.message = $filter('translate')(message['end_reason'].toUpperCase());
              $timeout((function() {
                _closeWindow();
              }), 3000);
            } else {
              _closeWindow();
            }
          }
        }
      };
      updateCallback = function(error, expanded) {
        scope.error = error;
        scope.expanded = expanded;
      };
      scope.expanded = 0;
      scope.widget = void 0;
      visioService = void 0;
      basePosAndSize = {};
      main = document.querySelector('.first_scope_div');
      interact('.visio-draggable', {
        context: main
      }).draggable({
        onmove: dragMoveListener,
        ignoreFrom: 'button, span'
      }).resizable({
        edges: {
          left: true,
          right: true,
          bottom: true,
          top: true
        },
        restrictSize: {
          min: {
            width: 200,
            height: 200
          }
        },
        ignoreFrom: 'button, span',
        inertia: false
      }).on('resizemove', function(event) {
        var target, x, y;
        if (scope.fullscreen || !scope.isVisioOn) {
          return;
        }
        target = event.target;
        x = parseFloat(target.getAttribute('data-x')) || 0;
        y = parseFloat(target.getAttribute('data-y')) || 0;
        target.style.width = event.rect.width + 'px';
        target.style.height = event.rect.height + 'px';
        x += event.deltaRect.left;
        y += event.deltaRect.bottom;
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)';
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
      });
      window.dragMoveListener = dragMoveListener;
      saveWidth = void 0;
      saveHeight = void 0;
      saveTranslate = void 0;
      scope.toggleFullscreen = function() {
        var elem;
        elem = angular.element('.visio');
        if (!scope.fullscreen) {
          saveWidth = elem.css('width');
          saveHeight = elem.css('height');
          saveTranslate = elem.css('transform');
        }
        scope.fullscreen = !scope.fullscreen;
        if (!scope.fullscreen) {
          elem.css('width', saveWidth);
          elem.css('height', saveHeight);
          elem.css('transform', saveTranslate);
        }
      };
      scope.switchTransparent = function() {
        var elem;
        elem = angular.element('.visio');
        if (elem.css('opacity') === '0.5') {
          elem.css('opacity', '1');
        } else {
          elem.css('opacity', '0.5');
        }
      };
      scope.accept = function(value) {
        visioService.answer(scope.call_id, value);
      };
      scope.hangup = function() {
        visioService.hangup(scope.call_id);
        _closeWindow();
      };
      MhliveService.getInstance().then(function(service) {
        visioService = service;
        service.addObserver(function(action, message) {
          scope.$apply(function() {
            serviceEvent(action, message);
          });
        });
      });
      $translatePartialLoader.addPart('visio');
      $translatePartialLoader.addPart('teleconsultation');
      return $translate.refresh().then(function() {
        return updateCallback(false, 0.["return"]);
      });
    };
    return {
      restrict: 'E',
      scope: {
        mode: '@'
      },
      link: link,
      templateUrl: 'visio/views/visio.wrapper.html'
    };
  }]);

}).call(this);

//# sourceMappingURL=visio-wrapper-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.visio:mhliveManager
    * @description
    * # mhliveManager
    * Directive for the visio manager
   */
  angular.module('mhclientApp').directive('mhliveManager', ["$translate", "$translatePartialLoader", "$filter", "MhliveService", "$window", "$rootScope", function($translate, $translatePartialLoader, $filter, MhliveService, $window, $rootScope) {
    return {
      restrict: 'E',
      templateUrl: 'visio/views/visio.popup.html',
      scope: {},
      link: function(scope, element, attributes) {
        var popup, pushPopup, timeout;
        pushPopup = function(popup) {
          return scope.$apply(function() {
            var timeout;
            if (timeout) {
              clearTimeout(timeout);
              timeout = null;
            }
            if (scope.popup && scope.popup.blocking) {
              return;
            }
            scope.popup = popup;
            if (popup.timeout > 0) {
              timeout = setTimeout((function() {
                scope.dismiss();
                scope.$apply();
              }), popup.timeout * 1000);
            }
          });
        };
        $translatePartialLoader.addPart('visio');
        $translatePartialLoader.addPart('teleconsultation');
        $translate.refresh();
        timeout = null;
        scope.dismiss = function() {
          scope.popup = null;
        };
        scope.getPopupClass = function(popup) {
          if (popup) {
            return popup["class"];
          }
        };
        if (!MhliveService || !MhliveService.isWebRTCSupported) {
          popup = {};
          popup.timeout = 0;
          popup.dismissable = true;
          popup.blocking = true;
          popup["class"] = 'error';
          popup.message = 'VISIO_NOT_SUPPORTED';
          popup.actions = [
            {
              handler: 'DOWNLOAD_CHROME',
              action: function() {
                $window.open('https://www.google.com/chrome/', '_blank');
              }
            }
          ];
          pushPopup(popup);
          if (MhliveService) {
            MhliveService.getInstance().then(function(service) {
              service.close();
            });
          }
          return;
        }
        MhliveService.getInstance().then(function(service) {
          service.addObserver((function(event, message) {
            var aid;
            aid = String(service.getAid());
            popup = {};
            popup.timeout = 0;
            popup.dismissable = false;
            popup.blocking = false;
            if (event === 'auth') {
              if (message['result'] === 'fail') {
                popup["class"] = 'error';
                if (message['reason'] === 'already_connected') {
                  popup.blocking = true;
                  popup.message = 'VISIO_ALREADY_CONNECTED';
                } else {
                  popup.message = 'UNKNOWN_AUTH_ERROR';
                }
                popup.actions = [
                  {
                    handler: 'RECONNECT',
                    action: function() {
                      scope.dismiss();
                      service.force_connect();
                    }
                  }
                ];
                popup.isDisabled = function() {
                  $rootScope.mhliveStatus !== 'disconnected';
                };
              } else if (message['result'] === 'success') {
                popup["class"] = 'success';
                popup.message = 'CONNECTION_SUCCESSFUL';
                popup.dismissable = true;
                popup.blocking = false;
                popup.timeout = 5;
              }
            }
            if (event === 'status_change') {
              if (message['status'] === 'disconnected') {
                popup["class"] = 'error';
                popup.blocking = true;
                popup.dismissable = true;
                popup.message = 'YOU_HAVE_BEEN_DISCONNECTED';
                popup.actions = [
                  {
                    handler: 'RECONNECT',
                    action: function() {
                      scope.dismiss();
                      service.force_connect();
                    }
                  }
                ];
                popup.isDisabled = function() {
                  return $rootScope.mhliveStatus !== 'disconnected';
                };
              }
            }
            if (event === 'remove_disconnect') {
              popup["class"] = 'info';
              popup.message = 'VISIO_REMOTE_DISCONNECT';
              popup.dismissable = true;
              popup.blocking = true;
            }
            if (event === 'call_update' && message['status'] === 'terminated' && message['participants'][aid]['extra_status'] === 'ring_expired') {
              popup["class"] = 'error';
              popup.message = $filter('translate')('YOU_MISSED_A_CALL_FROM') + ' ' + message['participants'][message['initiator']]['name'];
              popup.dismissable = true;
              popup.blocking = false;
              popup.timeout = 0;
            }
            if (event === 'call_fail' && message['reason'] === 'callee_busy') {
              popup["class"] = 'error';
              popup.message = $filter('translate')('CALL_FAIL_IS_IN_ANOTHER_CALL');
              popup.dismissable = true;
              popup.blocking = false;
              popup.timeout = 0;
            }
            if (event === 'incoming_urgent_call') {
              popup["class"] = 'error';
              popup.actions = [
                {
                  handler: 'CALL_BACK_HANGUP',
                  action: function() {
                    service.hangup();
                    service.call(message['caller_id']);
                    scope.dismiss();
                  }
                }
              ];
              popup.message = message['caller_name'] + ' ' + $filter('translate')('STARTED_AN_URGENT_CALL');
              popup.dismissable = true;
              popup.blocking = false;
              popup.timeout = 0;
            }
            if (event === 'call_update' && message['status'] === 'terminated' && message['participants'][aid]['extra_status'] === 'ring_expired') {
              popup["class"] = 'error';
              if (message['urgent'] === true) {
                popup.message = $filter('translate')('YOU_MISSED_AN_URGENT_CALL_FROM') + ' ' + message['participants'][message['initiator']]['name'];
                popup.actions = [
                  {
                    handler: 'CALL_BACK',
                    action: function() {
                      service.call(message['initiator']);
                      scope.dismiss();
                    }
                  }
                ];
              } else {
                popup.message = $filter('translate')('YOU_MISSED_A_CALL_FROM') + ' ' + message['participants'][message['initiator']]['name'];
              }
              popup.dismissable = true;
              popup.blocking = false;
              popup.timeout = 0;
            }
            if (popup["class"]) {
              pushPopup(popup);
            }
          }), true);
        });
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=visio-manager-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:EquipmentCatalogCtrl
    * @description
    * # EquipmentCatalogCtrl
    * Controller of the Equipment Catalog
   */
  angular.module('mhclientApp').controller('EquipmentCatalogCtrl', ["$scope", "$rootScope", "EquipmentCatalog", "$q", "$uibModal", "EquipmentCategories", "$filter", "notify", function($scope, $rootScope, EquipmentCatalog, $q, $uibModal, EquipmentCategories, $filter, notify) {
    var createNewCategory, init, updateCategory, updateEquipment;
    $scope.data = [];
    $scope.toggleExportFilters = false;
    init = function() {
      $scope.filters = {
        inactive: false,
        suppliers: [],
        searchText: ""
      };
      $scope.groupNameKey = "category";
      $scope.categories = [];
      $rootScope.busy = true;
      EquipmentCatalog.getEquipmentByCategory().then(function(data) {
        $scope.dataPool = data;
        $scope.data = data;
        return EquipmentCatalog.getSuppliers().then(function(suppliers) {
          $scope.suppliers = suppliers;
          return $rootScope.busy = false;
        });
      });
      return $scope.headers = [
        {
          name: $filter('translate')("REFERENCE"),
          key: "reference"
        }, {
          name: $filter('translate')("DESIGNATION"),
          key: "designation"
        }, {
          name: $filter('translate')("DESCRIPTION"),
          key: "description"
        }, {
          name: $filter('translate')("SUPPLIER"),
          key: "supplier_name"
        }, {
          name: $filter('translate')("PRICE_PER_DAY"),
          key: "price"
        }
      ];
    };
    $scope.applyFilters = function() {
      return $scope.data = $filter('catalogFilter')($scope.dataPool, $scope.filters);
    };
    $scope.openCategoryManagementModal = function() {
      return EquipmentCatalog.getCategories().then(function(categories) {
        var categoriesDialog;
        $scope.categories = categories;
        return categoriesDialog = $uibModal.open({
          templateUrl: "equipment/views/category-management-modal.html",
          controller: "CategoryManagementModalCtrl",
          backdrop: 'static',
          resolve: {
            categories: function() {
              return $scope.categories;
            },
            createNewCategory: function() {
              return createNewCategory;
            },
            updateCategory: function() {
              return updateCategory;
            }
          }
        });
      });
    };
    createNewCategory = function(newCategoryName) {
      return EquipmentCategories.api.create({
        name: newCategoryName,
        active: true,
        entity: $scope.user.entity
      }).$promise.then(function(category) {
        $scope.categories.push(category);
        return EquipmentCatalog.initCategory($scope.dataPool, category);
      });
    };
    updateCategory = function(category) {
      return EquipmentCategories.api.update({
        id: category.id
      }, category).$promise.then(function(category) {
        var categoryToUpdate;
        categoryToUpdate = _.find($scope.categories, function(cat) {
          return cat.id === category.id;
        });
        categoryToUpdate.name = category.name;
        categoryToUpdate.active = category.active;
        return EquipmentCatalog.updateCategoryInDataStruct(category, $scope.dataPool);
      });
    };
    $scope.filterEquipment = function(equipment) {
      return EquipmentCatalog.filterEquipment(equipment, $scope.filters);
    };
    $scope.supplierFilterChange = function(supplier) {
      if (supplier.checked) {
        return $scope.filters.suppliers.push(supplier);
      } else {
        return $scope.filters.suppliers.splice($scope.filters.suppliers.indexOf(supplier), 1);
      }
    };
    $scope.openUpdateEquipmentModal = function(selectedEquipment) {
      if (!$scope.user.entity) {
        return notify({
          classes: ["alert-warning"],
          message: $filter('translate')("FORBIDDEN_TO_MULTIENTITY_USER")
        });
      } else {
        return EquipmentCatalog.getCategories().then(function(categories) {
          var updateDialog;
          return updateDialog = $uibModal.open({
            templateUrl: "equipment/views/update-equipment-modal.html",
            controller: "UpdateEquipmentModalCtrl",
            backdrop: 'static',
            resolve: {
              equipment: function() {
                return selectedEquipment;
              },
              categories: function() {
                return _.filter(categories, function(cat) {
                  return cat.active === true;
                });
              },
              updateEquipment: function() {
                return updateEquipment;
              }
            }
          });
        });
      }
    };
    updateEquipment = function(equipmentToUpdate, categoryChanged, oldCategory) {
      return EquipmentCatalog.api.update({
        id: equipmentToUpdate.id
      }, equipmentToUpdate).$promise.then(function(equipment) {
        if (categoryChanged) {
          return EquipmentCatalog.changeEquipmentCategory($scope.dataPool, equipmentToUpdate, oldCategory);
        }
      });
    };
    $scope.fullExportCsv = function(exportStartDate, exportEndDate) {
      var baseUrl, endDate, exportUrl, startDate;
      startDate = moment($scope.exportStartDate).format('YYYY-MM-DD');
      endDate = moment($scope.exportEndDate).format('YYYY-MM-DD');
      baseUrl = $scope.base_iframe_url + "/api_rest/equipments_on_rent/full_export_csv";
      exportUrl = baseUrl + "?endDate=" + endDate + "&startDate=" + startDate + "&api_ver=v2.1";
      window.open(exportUrl, '_blank');
      return true;
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=equipment-catalog-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:EquipmentCatalog
    * @description
    * # EquipmentCatalog
    * Factory of EquipmentCatalog
   */
  angular.module("mhclientApp").factory('EquipmentCategories', ["$resource", "MhConfig", "BoxResource", "$q", function($resource, MhConfig, BoxResource, $q) {
    var acceptHeader, api, equipment_categories, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/equipment_categories/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          Accept: acceptHeader
        },
        isArray: true
      },
      create: {
        method: 'POST'
      },
      update: {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        equipment_categories = window.mgapp.get('equipment_mgr').equipment_categories();
        api = BoxResource.generate(equipment_categories);
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('Suppliers', ["$resource", "MhConfig", "BoxResource", "$q", function($resource, MhConfig, BoxResource, $q) {
    var acceptHeader, api, portailAPI, service, suppliers;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/suppliers/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          Accept: acceptHeader
        },
        isArray: true
      },
      create: {
        method: 'POST'
      },
      update: {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        suppliers = window.mgapp.get('equipment_mgr').suppliers();
        api = BoxResource.generate(suppliers);
    }
    service = {
      api: api
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('EquipmentCatalog', ["$resource", "MhConfig", "BoxResource", "$q", "Suppliers", "EquipmentCategories", function($resource, MhConfig, BoxResource, $q, Suppliers, EquipmentCategories) {
    var acceptHeader, addEquipmentToCache, addNewEquipment, api, categoriesCache, changeEquipmentCategory, equipments, equipmentsCache, filterEquipment, getCategories, getEquipmentByCategory, getEquipmentBySupplier, getEquipments, getSuppliers, initCategory, initSupplier, portailAPI, resetCache, service, suppliersCache, updateCategoryInDataStruct, updateSupplierInDataStruct;
    categoriesCache = null;
    suppliersCache = null;
    equipmentsCache = null;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/equipments/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      create: {
        method: 'POST'
      },
      update: {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      },
      updateEquipments: {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true,
        params: {
          route: 'update_equipments'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        equipments = window.mgapp.get('equipment_mgr').equipments();
        api = BoxResource.generate(equipments);
    }
    resetCache = function() {
      categoriesCache = null;
      suppliersCache = null;
      return equipmentsCache = null;
    };
    getSuppliers = function() {
      var suppliersPromise;
      suppliersPromise = $q.defer();
      if (!suppliersCache) {
        Suppliers.api.query().$promise.then(function(suppliers) {
          suppliersCache = suppliers;
          return suppliersPromise.resolve(suppliers);
        });
      } else {
        suppliersPromise.resolve(suppliersCache);
      }
      return suppliersPromise.promise;
    };
    getCategories = function() {
      var categoriesPromise;
      categoriesPromise = $q.defer();
      if (!categoriesCache) {
        EquipmentCategories.api.query().$promise.then(function(categories) {
          categoriesCache = categories;
          return categoriesPromise.resolve(categories);
        });
      } else {
        categoriesPromise.resolve(categoriesCache);
      }
      return categoriesPromise.promise;
    };
    getEquipments = function() {
      var equipmentsPromise;
      equipmentsPromise = $q.defer();
      if (!equipmentsCache) {
        api.query().$promise.then(function(equipments) {
          equipmentsCache = equipments;
          return equipmentsPromise.resolve(equipments);
        });
      } else {
        equipmentsPromise.resolve(equipmentsCache);
      }
      return equipmentsPromise.promise;
    };
    getEquipmentByCategory = function() {
      var equipmentByCategoryPromise, structuredData;
      equipmentByCategoryPromise = $q.defer();
      structuredData = [];
      getEquipments().then(function(equipments) {
        return getSuppliers().then(function(suppliers) {
          var suppliersById;
          suppliersById = {};
          _.map(suppliers, function(supplier) {
            return suppliersById[supplier.id] = supplier;
          });
          return getCategories().then(function(categories) {
            var categoriesById, categoryId, categoryIndex, equipment, i, len;
            categoriesById = {};
            _.map(categories, function(category) {
              categoriesById[category.id] = category;
              return structuredData.push({
                category: category.name,
                active: category.active,
                id: category.id,
                equipments: []
              });
            });
            for (i = 0, len = equipments.length; i < len; i++) {
              equipment = equipments[i];
              equipment.supplier_name = suppliersById[equipment.supplier].name;
              equipment.price = equipment.price_history.current;
              categoryId = categoriesById[equipment.category].id;
              categoryIndex = _.findIndex(structuredData, function(category) {
                return category.id === categoryId;
              });
              structuredData[categoryIndex].equipments.push(equipment);
            }
            return equipmentByCategoryPromise.resolve(structuredData);
          });
        });
      });
      return equipmentByCategoryPromise.promise;
    };
    getEquipmentBySupplier = function() {
      var equipmentBySupplierPromise, structuredData;
      equipmentBySupplierPromise = $q.defer();
      structuredData = [];
      api.query().$promise.then(function(equipments) {
        return getCategories().then(function(categories) {
          var categoriesById;
          categoriesById = {};
          _.map(categories, function(category) {
            return categoriesById[category.id] = category;
          });
          return getSuppliers().then(function(suppliers) {
            var equipment, i, len, supplierId, supplierIndex, suppliersById;
            suppliersById = {};
            _.map(suppliers, function(supplier) {
              suppliersById[supplier.id] = supplier;
              return structuredData.push({
                supplier: supplier.name,
                active: supplier.active,
                id: supplier.id,
                equipments: []
              });
            });
            for (i = 0, len = equipments.length; i < len; i++) {
              equipment = equipments[i];
              equipment.category_name = categoriesById[equipment.category].name;
              equipment.price = equipment.price_history.current;
              supplierId = suppliersById[equipment.supplier].id;
              supplierIndex = _.findIndex(structuredData, function(supplier) {
                return supplier.id === supplierId;
              });
              structuredData[supplierIndex].equipments.push(equipment);
            }
            return equipmentBySupplierPromise.resolve(structuredData);
          });
        });
      });
      return equipmentBySupplierPromise.promise;
    };
    changeEquipmentCategory = function(data, equipment, oldCategory) {
      var categoriesById, newCategoryIndex, oldCategoryIndex;
      categoriesById = {};
      _.map(categoriesCache, function(category) {
        return categoriesById[category.id] = category;
      });
      newCategoryIndex = _.findIndex(data, function(category) {
        return category.category === categoriesById[equipment["category"]]["name"];
      });
      data[newCategoryIndex].equipments.push(equipment);
      oldCategoryIndex = _.findIndex(data, function(category) {
        return category.category === categoriesById[oldCategory]["name"];
      });
      return data = _.remove(data[oldCategoryIndex].equipments, function(equipmentToRemove) {
        return equipmentToRemove.id === equipment.id;
      });
    };
    updateCategoryInDataStruct = function(category, data) {
      var categoryToUpdate;
      categoryToUpdate = _.find(data, function(cat) {
        return cat.id === category.id;
      });
      categoryToUpdate.category = category.name;
      categoryToUpdate.active = category.active;
      if (category.active === false) {
        return _.map(categoryToUpdate.equipments, function(equipment) {
          return equipment.active = category.active;
        });
      }
    };
    addNewEquipment = function(data, equipment) {
      return getCategories().then(function(categories) {
        var categoriesById, supplierIndex;
        categoriesById = {};
        _.map(categories, function(category) {
          return categoriesById[category.id] = category;
        });
        equipment.category_name = categoriesById[equipment.category]["name"];
        equipment.price = equipment.price_history.current;
        supplierIndex = _.findIndex(data, function(supplier) {
          return supplier.id === equipment.supplier;
        });
        return data[supplierIndex].equipments.push(equipment);
      });
    };
    updateSupplierInDataStruct = function(supplier, data) {
      var supplierToUpdate;
      supplierToUpdate = _.find(data, function(sup) {
        return sup.id === supplier.id;
      });
      supplierToUpdate.supplier = supplier.name;
      supplierToUpdate.active = supplier.active;
      if (supplier.active === false) {
        return _.map(supplierToUpdate.equipments, function(equipment) {
          return equipment.active = supplier.active;
        });
      }
    };
    initCategory = function(data, category) {
      return data.push({
        category: category.name,
        active: category.active,
        id: category.id,
        equipments: []
      });
    };
    initSupplier = function(data, supplier) {
      data.push({
        supplier: supplier.name,
        active: supplier.active,
        id: supplier.id,
        equipments: []
      });
      return suppliersCache.push(supplier);
    };
    filterEquipment = function(equipment, filters) {
      var display;
      display = true;
      if (equipment.deleted === true) {
        display = false;
      } else if (filters.inactive) {
        display = true;
      } else {
        display = equipment.active === !filters.inactive;
      }
      if (filters.searchText && display) {
        display = angular.uppercase(equipment.description).includes(angular.uppercase(filters.searchText)) || angular.uppercase(equipment.designation).includes(angular.uppercase(filters.searchText)) || angular.uppercase(equipment.reference).includes(angular.uppercase(filters.searchText));
      }
      if (filters.suppliers && filters.suppliers.length > 0 && display) {
        display = _.find(filters.suppliers, function(supplier) {
          return supplier.id === equipment.supplier;
        }) !== void 0;
      }
      if (filters.categories && filters.categories.length > 0 && display) {
        display = _.find(filters.categories, function(category) {
          return category.id === equipment.category;
        }) !== void 0;
      }
      return display;
    };
    addEquipmentToCache = function(equipment) {
      return equipmentsCache.push(equipment);
    };
    service = {
      initCategory: initCategory,
      initSupplier: initSupplier,
      resetCache: resetCache,
      getSuppliers: getSuppliers,
      getCategories: getCategories,
      getEquipmentByCategory: getEquipmentByCategory,
      getEquipmentBySupplier: getEquipmentBySupplier,
      getEquipments: getEquipments,
      changeEquipmentCategory: changeEquipmentCategory,
      updateCategoryInDataStruct: updateCategoryInDataStruct,
      updateSupplierInDataStruct: updateSupplierInDataStruct,
      addNewEquipment: addNewEquipment,
      filterEquipment: filterEquipment,
      addEquipmentToCache: addEquipmentToCache,
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=equipment-catalog-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:EquipmentOnRent
    * @description
    * # EquipmentOnRent
    * Factory of EquipmentOnRent
   */
  angular.module("mhclientApp").factory('EquipmentOnRent', ["$resource", "MhConfig", "BoxResource", "$q", "EquipmentCatalog", "$rootScope", "$filter", function($resource, MhConfig, BoxResource, $q, EquipmentCatalog, $rootScope, $filter) {
    var acceptHeader, addEquipmentsOnRent, api, computeHistory, equipmentsOnRentCache, equipments_on_rent, generateEquipmentOnRent, getEquipmentsOnRent, getNestedEquipmentsOnRent, nestEquipmentsOnRent, portailAPI, service, updateEquipmentOnRentReference;
    equipmentsOnRentCache = null;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/equipments_on_rent/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          Accept: acceptHeader
        },
        isArray: true
      },
      create: {
        method: 'POST'
      },
      update: {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      },
      updateEquipmentsOnRent: {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true,
        params: {
          route: 'update_equipments_on_rent'
        }
      },
      addEquipmentsOnRent: {
        method: 'POST',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true,
        params: {
          route: 'add_equipments_on_rent'
        }
      },
      createUnreferenced: {
        method: 'POST',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'create_unreferenced'
        }
      },
      getHistory: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true,
        params: {
          route: 'get_history'
        }
      },
      'exportHistoryCSV': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'GET',
        params: {
          route: 'export_history_csv'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        equipments_on_rent = window.mgapp.get('equipment_mgr').equipments_on_rent();
        api = BoxResource.generate(equipments_on_rent);
        api.addEquipmentsOnRent = function(object) {
          return BoxResource.mhboxApiCall(equipments_on_rent, "add_equipments_on_rent", object);
        };
        api.createUnreferenced = function(object) {
          return BoxResource.mhboxApiCall(equipments_on_rent, "create_unreferenced", object);
        };
        api.updateEquipmentsOnRent = function(object) {
          return BoxResource.mhboxApiCall(equipments_on_rent, "update_equipments_on_rent", object);
        };
    }
    getEquipmentsOnRent = function() {
      var params;
      params = {};
      if ($rootScope.allStays) {
        params.patient = $rootScope.currentPatient.id;
      } else {
        params.stay = $rootScope.currentStay.id;
      }
      return api.query(params).$promise;
    };
    getNestedEquipmentsOnRent = function() {
      var equipmentsPromise;
      equipmentsPromise = $q.defer();
      getEquipmentsOnRent().then(function(equipmentsOnRent) {
        return nestEquipmentsOnRent(equipmentsOnRent).then(function(data) {
          return equipmentsPromise.resolve(data);
        });
      });
      return equipmentsPromise.promise;
    };
    addEquipmentsOnRent = function(data, equipmentsOnRent) {
      var equipmentsPromise;
      equipmentsPromise = $q.defer();
      nestEquipmentsOnRent(equipmentsOnRent).then(function(nestedEquipments) {
        data = data.concat(nestedEquipments);
        return equipmentsPromise.resolve(data);
      });
      return equipmentsPromise.promise;
    };
    nestEquipmentsOnRent = function(equipmentsOnRent) {
      var equipmentsById, equipmentsPromise, nestedEquipmentsOnRent, suppliersById;
      nestedEquipmentsOnRent = [];
      suppliersById = {};
      equipmentsById = {};
      equipmentsPromise = $q.defer();
      EquipmentCatalog.getSuppliers().then(function(suppliers) {
        return EquipmentCatalog.getEquipments().then(function(equipments) {
          _.map(suppliers, function(supplier) {
            return suppliersById[supplier.id] = supplier;
          });
          _.map(equipments, function(equip) {
            return equipmentsById[equip.id] = equip;
          });
          _.map(equipmentsOnRent, function(equipmentOnRent) {
            var nestedEquipment;
            nestedEquipment = angular.copy(equipmentOnRent);
            nestedEquipment.supplier = suppliersById[nestedEquipment.supplier];
            nestedEquipment.equipment = equipmentsById[nestedEquipment.equipment];
            return nestedEquipmentsOnRent.push(nestedEquipment);
          });
          return equipmentsPromise.resolve(nestedEquipmentsOnRent);
        });
      });
      return equipmentsPromise.promise;
    };
    generateEquipmentOnRent = function(status, stayId, quantity, supplierId, equipmentId) {
      var metadata, statusHistoryEntry, today;
      statusHistoryEntry = {};
      statusHistoryEntry.status = status;
      today = new Date();
      statusHistoryEntry.requested_date = moment(today).format("YYYY-MM-DD");
      statusHistoryEntry.created_date = today;
      metadata = {
        quantity: quantity
      };
      metadata.status_history = [];
      metadata.status_history.push(statusHistoryEntry);
      return {
        status: status,
        stay: stayId,
        metadata: metadata,
        supplier: supplierId,
        equipment: equipmentId
      };
    };
    updateEquipmentOnRentReference = function(equipmentOnRentList, referencedEquipmentOnRent) {
      var equipmentsById, suppliersById, updatePromise;
      suppliersById = {};
      equipmentsById = {};
      updatePromise = $q.defer();
      EquipmentCatalog.getSuppliers().then(function(suppliers) {
        return EquipmentCatalog.getEquipments().then(function(equipments) {
          var equipmentOnRentToUpdate;
          _.map(suppliers, function(supplier) {
            return suppliersById[supplier.id] = supplier;
          });
          _.map(equipments, function(equip) {
            return equipmentsById[equip.id] = equip;
          });
          equipmentOnRentToUpdate = _.find(equipmentOnRentList, function(equip) {
            return equip.id === referencedEquipmentOnRent.id;
          });
          equipmentOnRentToUpdate.supplier = suppliersById[referencedEquipmentOnRent.supplier];
          equipmentOnRentToUpdate.equipment = equipmentsById[referencedEquipmentOnRent.equipment];
          return updatePromise.resolve();
        });
      });
      return updatePromise.promise;
    };
    computeHistory = function(dateList, equipmentsOnRent) {
      var closestDate, d_date, date, delta, entry, equipmentOnRent, histDate, histDates, histDict, i, j, len, len1, minDelta, price, ref, results, status, timestamp;
      results = [];
      for (i = 0, len = equipmentsOnRent.length; i < len; i++) {
        equipmentOnRent = equipmentsOnRent[i];
        equipmentOnRent.computedHistory = [];
        equipmentOnRent.totalCost = 0;
        timestamp = moment($filter('date')(equipmentOnRent.timestamp, 'yyyy-MM-dd'), "YYYY-MM-DD");
        histDict = {};
        histDates = [];
        ref = equipmentOnRent.history;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          entry = ref[j];
          entry.displayDate = $filter('date')(entry.date, 'dd/MM/yyyy');
          histDate = moment(entry.date, "YYYY-MM-DD");
          histDict[histDate.format("YYYY-MM-DD")] = {
            status: entry.status,
            price: entry.price
          };
          histDates.push(histDate);
        }
        results.push((function() {
          var k, l, len2, len3, ref1, ref2, results1;
          results1 = [];
          for (k = 0, len2 = dateList.length; k < len2; k++) {
            date = dateList[k];
            d_date = moment(date);
            if (d_date.isBefore(timestamp)) {
              equipmentOnRent.computedHistory.push(null);
              continue;
            }
            closestDate = null;
            minDelta = null;
            for (l = 0, len3 = histDates.length; l < len3; l++) {
              histDate = histDates[l];
              delta = d_date.diff(histDate);
              if (delta >= 0 && (minDelta === null || delta < minDelta)) {
                minDelta = delta;
                closestDate = histDate;
              }
            }
            ref2 = (ref1 = histDict[closestDate != null ? closestDate.format('YYYY-MM-DD') : void 0]) != null ? ref1 : {
              status: "-",
              price: 0
            }, status = ref2.status, price = ref2.price;
            equipmentOnRent.computedHistory.push({
              status: status
            });
            if (status !== 'TO_BE_ORDERED' && status !== 'ORDERED' && status !== 'SUSPENDED' && status !== 'DELETED') {
              results1.push(equipmentOnRent.totalCost += price * equipmentOnRent.quantity);
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      }
      return results;
    };
    service = {
      api: api,
      getEquipmentsOnRent: getEquipmentsOnRent,
      getNestedEquipmentsOnRent: getNestedEquipmentsOnRent,
      generateEquipmentOnRent: generateEquipmentOnRent,
      addEquipmentsOnRent: addEquipmentsOnRent,
      updateEquipmentOnRentReference: updateEquipmentOnRentReference,
      computeHistory: computeHistory
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=equipment-on-rent-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:UpdateEquipmentModalCtrl
    * @description
    * # UpdateEquipmentModalCtrl
    * Controller of the modal which handles an equipment edition
   */
  angular.module("mhclientApp").controller('UpdateEquipmentModalCtrl', ["$scope", "$rootScope", "$filter", "$window", "$uibModalInstance", "equipment", "categories", "updateEquipment", function($scope, $rootScope, $filter, $window, $uibModalInstance, equipment, categories, updateEquipment) {
    $scope.equipment = angular.copy(equipment);
    $scope.categories = categories;
    $scope.oldCategory = equipment.category;
    $scope.validate = function() {
      return updateEquipment($scope.equipment, $scope.form.category.$dirty, $scope.oldCategory).then(equipment.reference = $scope.equipment.reference, equipment.description = $scope.equipment.description, equipment.designation = $scope.equipment.designation, equipment.category = $scope.equipment.category, equipment.active = $scope.equipment.active, equipment.deleted = $scope.equipment.deleted, $scope.equipment.deleted === true ? equipment.active = false : void 0, $uibModalInstance.close());
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    $scope.handleActiveStatus = function() {
      if ($scope.equipment.deleted === true) {
        return $scope.equipment.active = false;
      }
    };
    return $scope.handleDeletedStatus = function() {
      if ($scope.equipment.active === true) {
        return $scope.equipment.deleted = false;
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=update-equipment-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:CategoryManagementModalCtrl
    * @description
    * # CategoryManagementModalCtrl
    * Controller of the modal which handles category creation and update
   */
  angular.module("mhclientApp").controller('CategoryManagementModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "categories", "createNewCategory", "$uibModal", "updateCategory", function($scope, $rootScope, $filter, $uibModalInstance, categories, createNewCategory, $uibModal, updateCategory) {
    $scope.newCategoryPlaceholder = $filter('translate')("NEW_CATEGORY_PLACEHOLDER");
    $scope.okButtonText = $filter('translate')('VALIDATE');
    $scope.cancelButtonText = $filter('translate')('CANCEL');
    $scope.labelText = $filter('translate')('CATEGORY_EDIT_LABEL');
    $scope.editCategoryModalTitle = $filter('translate')('EDIT_CATEGORY_MODAL_TITLE');
    $scope.searchText = "";
    $scope.filters = {
      inactive: false
    };
    $scope.categories = categories;
    $scope.newCategoryName = "";
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    $scope.addNewCategory = function() {
      return createNewCategory($scope.newCategoryName).then(function() {
        return $scope.newCategoryName = "";
      });
    };
    $scope.openEditModal = function(category) {
      var categoryEditDialog;
      categoryEditDialog = $uibModal.open({
        templateUrl: "core/views/modal-input-template.html",
        controller: "mhModalKeyboardInputCtrl",
        backdrop: 'static',
        resolve: {
          enteredText: function() {
            return category.name;
          },
          okButtonText: function() {
            return $scope.okButtonText;
          },
          cancelButtonText: function() {
            return $scope.cancelButtonText;
          },
          labelText: function() {
            return $scope.labelText;
          },
          modalTitle: function() {
            return $scope.editCategoryModalTitle;
          },
          noButtonText: function() {
            return "";
          }
        }
      });
      return categoryEditDialog.result.then(function(newName) {
        var categoryCopy;
        categoryCopy = angular.copy(category);
        categoryCopy.name = newName;
        return updateCategory(categoryCopy);
      });
    };
    $scope.openDeactivateModal = function(category) {
      var confirmDialog;
      confirmDialog = $uibModal.open({
        templateUrl: "core/views/modal-template.html",
        controller: "mhModalCtrl",
        backdrop: 'static',
        resolve: {
          title: function() {
            return $filter('translate')("DEACTIVATE_CATEGORY_MODAL_TITLE");
          },
          text: function() {
            return $filter('translate')("DEACTIVATE_CATEGORY_WARNING_TEXT");
          },
          cancelButtonText: function() {
            return $scope.cancelButtonText;
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $scope.okButtonText;
          }
        }
      });
      return confirmDialog.result.then(function(result) {
        var categoryCopy;
        if (result) {
          categoryCopy = angular.copy(category);
          categoryCopy.active = false;
          return updateCategory(categoryCopy);
        }
      });
    };
    $scope.activate = function(category) {
      var categoryCopy;
      categoryCopy = angular.copy(category);
      categoryCopy.active = true;
      return updateCategory(categoryCopy);
    };
    return $scope.filterCategory = function(category) {
      var display;
      display = true;
      if ($scope.filters.inactive) {
        display = true;
      } else {
        display = category.active === !$scope.filters.inactive;
      }
      if ($scope.searchText && display) {
        display = angular.uppercase(category.name).startsWith(angular.uppercase($scope.searchText));
      }
      return display;
    };
  }]);

}).call(this);

//# sourceMappingURL=category-management-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:SuppliersCatalogCtrl
    * @description
    * # SuppliersCatalogCtrl
    * Controller of the Suppliers Equipment Catalog
   */
  angular.module('mhclientApp').controller('SuppliersCatalogCtrl', ["$scope", "$rootScope", "EquipmentCatalog", "$q", "$uibModal", "$filter", "Suppliers", function($scope, $rootScope, EquipmentCatalog, $q, $uibModal, $filter, Suppliers) {
    var createEquipment, createSupplier, init, updatePrices, updateSupplier;
    $scope.data = [];
    init = function() {
      $rootScope.busy = true;
      $scope.groupNameKey = "supplier";
      EquipmentCatalog.getEquipmentBySupplier().then(function(data) {
        $scope.data = data;
        return EquipmentCatalog.getCategories().then(function(categories) {
          $scope.categories = categories;
          return $rootScope.busy = false;
        });
      });
      $scope.filters = {
        inactive: false,
        categories: [],
        searchText: ""
      };
      return $scope.headers = [
        {
          name: $filter('translate')("REFERENCE"),
          key: "reference"
        }, {
          name: $filter('translate')("DESIGNATION"),
          key: "designation"
        }, {
          name: $filter('translate')("DESCRIPTION"),
          key: "description"
        }, {
          name: $filter('translate')("CATEGORY"),
          key: "category_name"
        }, {
          name: $filter('translate')("PRICE_PER_DAY"),
          key: "price"
        }
      ];
    };
    $scope.openNewEquipmentModal = function() {
      return EquipmentCatalog.getCategories().then(function(categories) {
        return EquipmentCatalog.getSuppliers().then(function(suppliers) {
          return EquipmentCatalog.getEquipments().then(function(equipments) {
            var updateDialog;
            return updateDialog = $uibModal.open({
              templateUrl: "equipment/views/create-equipment-modal.html",
              controller: "CreateEquipmentModalCtrl",
              backdrop: 'static',
              resolve: {
                categories: function() {
                  return _.filter(categories, "active");
                },
                suppliers: function() {
                  return _.filter(suppliers, "active");
                },
                equipments: function() {
                  return _.filter(equipments, "active");
                },
                createEquipment: function() {
                  return createEquipment;
                }
              }
            });
          });
        });
      });
    };
    $scope.openCreateSupplierModal = function() {
      var dialog;
      return dialog = $uibModal.open({
        templateUrl: "equipment/views/create-supplier-modal.html",
        controller: "CreateSupplierModalCtrl",
        backdrop: 'static',
        resolve: {
          createSupplier: function() {
            return createSupplier;
          }
        }
      });
    };
    $scope.openManageSupplierModal = function() {
      return EquipmentCatalog.getSuppliers().then(function(suppliers) {
        var dialog;
        return dialog = $uibModal.open({
          templateUrl: "equipment/views/supplier-management-modal.html",
          controller: "SupplierManagementModalCtrl",
          backdrop: 'static',
          resolve: {
            updateSupplier: function() {
              return updateSupplier;
            },
            suppliers: function() {
              return suppliers;
            }
          }
        });
      });
    };
    $scope.openManagePriceModal = function() {
      return EquipmentCatalog.getSuppliers().then(function(suppliers) {
        return EquipmentCatalog.getEquipments().then(function(equipments) {
          var dialog;
          return dialog = $uibModal.open({
            templateUrl: "equipment/views/price-management-modal.html",
            controller: "PriceManagementModalCtrl",
            backdrop: 'static',
            resolve: {
              suppliers: function() {
                return suppliers;
              },
              data: function() {
                return angular.copy($scope.data);
              },
              updatePrices: function() {
                return updatePrices;
              }
            }
          });
        });
      });
    };
    createEquipment = function(equipment) {
      return EquipmentCatalog.api.create(equipment).$promise.then(function(newEquipment) {
        return EquipmentCatalog.addNewEquipment($scope.data, newEquipment);
      });
    };
    createSupplier = function(supplier) {
      return Suppliers.api.create(supplier).$promise.then(function(newSupplier) {
        return EquipmentCatalog.initSupplier($scope.data, newSupplier);
      });
    };
    updateSupplier = function(supplier) {
      return Suppliers.api.update({
        id: supplier.id
      }, supplier).$promise.then(function(updatedSupplier) {
        return EquipmentCatalog.updateSupplierInDataStruct(updatedSupplier, $scope.data);
      });
    };
    updatePrices = function(equipments, applicationDate) {
      var updatePromise;
      updatePromise = $q.defer();
      return EquipmentCatalog.api.updateEquipments({
        equipments: equipments,
        apply_date: applicationDate
      }).$promise.then(function(updatedEquipments) {
        var supplierGroup;
        supplierGroup = _.find($scope.data, function(group) {
          return group.id === updatedEquipments[0].supplier;
        });
        return _.map(updatedEquipments, function(equip) {
          var equipmentToUpdate;
          equipmentToUpdate = _.find(supplierGroup.equipments, function(equipToUpdate) {
            return equipToUpdate.id === equip.id;
          });
          return equipmentToUpdate.price = equip.price_history.current;
        });
      });
    };
    $scope.filterEquipment = function(equipment) {
      return EquipmentCatalog.filterEquipment(equipment, $scope.filters);
    };
    $scope.categoryFilterChange = function(category) {
      if (category.checked) {
        return $scope.filters.categories.push(category);
      } else {
        return $scope.filters.categories.splice($scope.filters.categories.indexOf(category), 1);
      }
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=suppliers-catalog-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.equipment:catalogFilter
    * @description
    * # catalogFilter
    * Filter the data which is provided to the catalog
   */
  angular.module('mhclientApp').filter('catalogFilter', function() {
    return function(data, filters) {
      var filteredData;
      filteredData = angular.copy(data);
      if (filters.inactive !== void 0) {
        if (filters.inactive === false) {
          filteredData = _.filter(data, function(group) {
            return group.active === true;
          });
        }
      }
      return filteredData;
    };
  });

}).call(this);

//# sourceMappingURL=catalog-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:CreateEquipmentModalCtrl
    * @description
    * # CreateEquipmentModalCtrl
    * Controller of the modal which handle material creation
   */
  angular.module("mhclientApp").controller('CreateEquipmentModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "categories", "suppliers", "$uibModal", "createEquipment", "equipments", function($scope, $rootScope, $filter, $uibModalInstance, categories, suppliers, $uibModal, createEquipment, equipments) {
    var init;
    init = function() {
      $scope.designations = [];
      $scope.equipment = {
        supplier: suppliers[0].id
      };
      $scope.categories = categories;
      $scope.suppliers = suppliers;
      $scope.referencesBySupplier = {};
      _.map(suppliers, function(sup) {
        return $scope.referencesBySupplier[sup.id] = [];
      });
      _.map(equipments, function(equip) {
        return $scope.referencesBySupplier[equip.supplier].push(equip.reference);
      });
      $scope.designationsBySupplier = {};
      _.map(suppliers, function(sup) {
        return $scope.designationsBySupplier[sup.id] = [];
      });
      _.map(equipments, function(equip) {
        return $scope.designationsBySupplier[equip.supplier].push(equip.designation);
      });
      return $scope.resetEquipment();
    };
    $scope.validate = function() {
      return createEquipment($scope.equipment).then(function() {
        return $uibModalInstance.close();
      });
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    $scope.resetEquipment = function() {
      $scope.equipment.reference = "";
      if (!$scope.equipment.supplier) {
        return $scope.equipment.supplier = $scope.suppliers[0];
      }
    };
    $scope.filterByLabel = function(viewValue) {
      return function(item, index, array) {
        return !viewValue || viewValue === " " || viewValue === null || item.toLowerCase().indexOf(viewValue.toLowerCase()) >= 0;
      };
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=create-equipment-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:CreateSupplierModalCtrl
    * @description
    * # CreateSupplierModalCtrl
    * Controller of the modal which handles supplier creation
   */
  angular.module("mhclientApp").controller('CreateSupplierModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "$uibModal", "createSupplier", function($scope, $rootScope, $filter, $uibModalInstance, $uibModal, createSupplier) {
    $scope.supplier = {
      name: "",
      active: true,
      entity: $scope.user.entity,
      metadata: {
        companyName: "",
        address: "",
        phone: "",
        email: "",
        contact: ""
      }
    };
    $scope.okButtonText = $filter('translate')('VALIDATE');
    $scope.cancelButtonText = $filter('translate')('CANCEL');
    $scope.validate = function() {
      return createSupplier($scope.supplier).then(function() {
        return $uibModalInstance.close();
      });
    };
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
  }]);

}).call(this);

//# sourceMappingURL=create-supplier-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:SupplierManagementModalCtrl
    * @description
    * # SupplierManagementModalCtrl
    * Controller of the modal which handles supplier update
   */
  angular.module("mhclientApp").controller('SupplierManagementModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "$uibModal", "updateSupplier", "suppliers", function($scope, $rootScope, $filter, $uibModalInstance, $uibModal, updateSupplier, suppliers) {
    $scope.newCategoryPlaceholder = $filter('translate')("NEW_CATEGORY_PLACEHOLDER");
    $scope.okButtonText = $filter('translate')('VALIDATE');
    $scope.cancelButtonText = $filter('translate')('CANCEL');
    $scope.labelText = $filter('translate')('CATEGORY_EDIT_LABEL');
    $scope.editCategoryModalTitle = $filter('translate')('EDIT_CATEGORY_MODAL_TITLE');
    $scope.searchText = "";
    $scope.filters = {
      inactive: false
    };
    $scope.suppliers = suppliers;
    _.map($scope.suppliers, function(sup) {
      return sup.display = sup.active;
    });
    $scope.validate = function() {};
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    $scope.updateSupplier = function(supplier, form) {
      var confirmDialog;
      if (!supplier.active && form.active.$dirty) {
        confirmDialog = $uibModal.open({
          templateUrl: "core/views/modal-template.html",
          controller: "mhModalCtrl",
          backdrop: 'static',
          resolve: {
            title: function() {
              return $filter('translate')("DEACTIVATE_SUPPLIER_MODAL_TITLE");
            },
            text: function() {
              return $filter('translate')("DEACTIVATE_SUPPLIER_WARNING_TEXT");
            },
            cancelButtonText: function() {
              return $scope.cancelButtonText;
            },
            noButtonText: function() {
              return '';
            },
            okButtonText: function() {
              return $scope.okButtonText;
            }
          }
        });
        return confirmDialog.result.then(function(result) {
          $rootScope.busy = true;
          if (result) {
            return updateSupplier(supplier).then(function() {
              supplier.display = supplier.active;
              return $rootScope.busy = false;
            });
          }
        });
      } else {
        $rootScope.busy = true;
        return updateSupplier(supplier).then(function() {
          supplier.display = supplier.active;
          return $rootScope.busy = false;
        });
      }
    };
    return $scope.filterSupplier = function(supplier) {
      var display;
      display = true;
      if ($scope.filters.inactive) {
        display = true;
      } else {
        display = supplier.display === !$scope.filters.inactive;
      }
      if ($scope.searchText && display) {
        display = angular.uppercase(supplier.name).startsWith(angular.uppercase($scope.searchText));
      }
      return display;
    };
  }]);

}).call(this);

//# sourceMappingURL=supplier-management-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:PriceManagementModalCtrl
    * @description
    * # PriceManagementModalCtrl
    * Controller of the modal which handles equipment price update
   */
  angular.module("mhclientApp").controller('PriceManagementModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "$uibModal", "suppliers", "data", "updatePrices", function($scope, $rootScope, $filter, $uibModalInstance, $uibModal, suppliers, data, updatePrices) {
    var init;
    $scope.equipments = {};
    $scope.selectedSupplier = {};
    $scope.headers = [
      {
        name: $filter('translate')("REFERENCE"),
        key: "reference"
      }, {
        name: $filter('translate')("DESIGNATION"),
        key: "designation"
      }, {
        name: $filter('translate')("PRICE_PER_DAY"),
        key: "price",
        edit: true,
        required: true
      }
    ];
    init = function() {
      $scope.initEquipments();
      $scope.suppliers = _.filter(suppliers, function(supplier) {
        return $scope.equipments[supplier.name].equipments.length > 0;
      });
      $scope.selectedSupplier = $scope.suppliers[0];
      return $scope.minDate = new Date();
    };
    $scope.newCategoryPlaceholder = $filter('translate')("NEW_CATEGORY_PLACEHOLDER");
    $scope.okButtonText = $filter('translate')('VALIDATE');
    $scope.cancelButtonText = $filter('translate')('CANCEL');
    $scope.labelText = $filter('translate')('CATEGORY_EDIT_LABEL');
    $scope.editCategoryModalTitle = $filter('translate')('EDIT_CATEGORY_MODAL_TITLE');
    $scope.initEquipments = function() {
      return _.map(data, function(group) {
        return $scope.equipments[group.supplier] = {
          "equipments": angular.copy(_.filter(group.equipments, function(equip) {
            return equip.active;
          }))
        };
      });
    };
    $scope.validate = function(equipments) {
      return updatePrices(equipments, moment($scope.applicationDate).format("YYYY-MM-DD")).then(function() {
        return $uibModalInstance.close();
      });
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=price-management-modal-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:equipmentRentingList
    * @description
    * Directive of equipmentRentingList
   */
  angular.module('mhclientApp').directive('equipmentRentingList', function() {
    return {
      restrict: 'E',
      templateUrl: 'equipment/views/equipment-renting-list.html',
      scope: {
        stay: '='
      },
      controller: ["$scope", "$rootScope", "$q", "$uibModal", "$filter", "EquipmentOnRent", "EquipmentCatalog", "notify", "MhConfig", function($scope, $rootScope, $q, $uibModal, $filter, EquipmentOnRent, EquipmentCatalog, notify, MhConfig) {
        var addNonReferencedEquipment, addReferencedEquipments, associateEquipmentOnRent, init, referenceEquipmentOnRent, updateEquipmentOnRent;
        $scope.equipmentsOnRent = [];
        init = function() {
          $scope.filters = {
            deleted: false,
            searchText: ""
          };
          $scope.user = $rootScope.user;
          $scope.mhConfig = MhConfig;
          $scope.canCreateInvoice = $rootScope.checkPermissions("EQUIPMENT_INVOICE", "CAN_WRITE");
          $scope.headers = [$filter('translate')("DESIGNATION"), $filter('translate')("DESCRIPTION"), $filter('translate')("SUPPLIER"), $filter('translate')("QUANTITY"), $filter('translate')("STATUS")];
          $scope.toBeOrdered = $filter('translate')("TO_BE_ORDERED");
          $scope.ordered = $filter('translate')("ORDERED");
          $scope.installed = $filter('translate')("INSTALLED");
          $scope.toBeSuspended = $filter('translate')("TO_BE_SUSPENDED");
          $scope.suspended = $filter('translate')("SUSPENDED");
          $scope.toBeRemoved = $filter('translate')("TO_BE_REMOVED");
          $scope.removed = $filter('translate')("REMOVED");
          $scope.deleted = $filter('translate')("DELETED");
          $scope.availableStatus = {
            "TO_BE_ORDERED": [
              {
                value: "DELETED",
                name: $scope.deleted
              }, {
                value: "TO_BE_ORDERED",
                name: $scope.toBeOrdered
              }
            ],
            "ORDERED": [
              {
                value: "DELETED",
                name: $scope.deleted
              }, {
                value: "ORDERED",
                name: $scope.ordered
              }, {
                value: "INSTALLED",
                name: $scope.installed
              }
            ],
            "INSTALLED": [
              {
                value: "SUSPENDED",
                name: $scope.suspended
              }, {
                value: "TO_BE_SUSPENDED",
                name: $scope.toBeSuspended
              }, {
                value: "TO_BE_REMOVED",
                name: $scope.toBeRemoved
              }, {
                value: "INSTALLED",
                name: $scope.installed
              }
            ],
            "TO_BE_SUSPENDED": [
              {
                value: "SUSPENDED",
                name: $scope.suspended
              }, {
                value: "DELETED",
                name: $scope.deleted
              }, {
                value: "TO_BE_REMOVED",
                name: $scope.toBeRemoved
              }, {
                value: "INSTALLED",
                name: $scope.installed
              }, {
                value: "TO_BE_SUSPENDED",
                name: $scope.toBeSuspended
              }
            ],
            "SUSPENDED": [
              {
                value: "SUSPENDED",
                name: $scope.suspended
              }, {
                value: "TO_BE_REMOVED",
                name: $scope.toBeRemoved
              }, {
                value: "DELETED",
                name: $scope.deleted
              }, {
                value: "INSTALLED",
                name: $scope.installed
              }
            ],
            "TO_BE_REMOVED": [
              {
                value: "TO_BE_REMOVED",
                name: $scope.toBeRemoved
              }, {
                value: "DELETED",
                name: $scope.deleted
              }, {
                value: "REMOVED",
                name: $scope.removed
              }
            ],
            "REMOVED": [
              {
                value: "DELETED",
                name: $scope.deleted
              }, {
                value: "REMOVED",
                name: $scope.removed
              }
            ]
          };
          $scope.translate = {};
          $scope.translate['UNREFERENCED_EQUIPMENT_WARNING'] = $filter('translate')('UNREFERENCED_EQUIPMENT_WARNING');
          $scope.statusOrder = {
            TO_BE_ORDERED: 0,
            ORDERED: 1,
            INSTALLED: 2,
            SUSPENDED: 3,
            TO_BE_REMOVED: 4,
            REMOVED: 5,
            DELETED: 6,
            TO_BE_SUSPENDED: 7
          };
          return EquipmentOnRent.getNestedEquipmentsOnRent().then(function(equipmentsOnRent) {
            return $scope.equipmentsOnRent = equipmentsOnRent;
          });
        };
        $scope.openStatusEditModal = function(selectedEquipmentOnRent) {
          var curStatusList, statusHistoryList, updateDialog;
          if (selectedEquipmentOnRent.metadata.status_history) {
            statusHistoryList = selectedEquipmentOnRent.metadata.status_history;
            curStatusList = _.filter(statusHistoryList, function(statusHistory) {
              return selectedEquipmentOnRent.status === statusHistory.status;
            });
            if (curStatusList.length > 0) {
              selectedEquipmentOnRent.requestedDate = curStatusList[curStatusList.length - 1].requested_date;
            }
          }
          if (!$rootScope.user.entity && $rootScope.mh_config.platform === 'mhsi') {
            return notify({
              classes: ["alert-warning"],
              message: $filter('translate')("FORBIDDEN_TO_MULTIENTITY_USER")
            });
          } else {
            if (selectedEquipmentOnRent.equipment) {
              if (selectedEquipmentOnRent.status !== "DELETED") {
                return updateDialog = $uibModal.open({
                  templateUrl: "equipment/views/update-status-modal.html",
                  controller: "UpdateStatusModalCtrl",
                  backdrop: 'static',
                  resolve: {
                    selectedEquipmentOnRent: function() {
                      return selectedEquipmentOnRent;
                    },
                    updateEquipmentOnRent: function() {
                      return updateEquipmentOnRent;
                    },
                    availableStatus: function() {
                      return $scope.availableStatus;
                    }
                  }
                });
              }
            } else if ($rootScope.mh_config.platform === 'mhsi') {
              $rootScope.busy = true;
              return EquipmentCatalog.getEquipmentByCategory().then(function(data) {
                var referenceDialog;
                $rootScope.busy = false;
                return referenceDialog = $uibModal.open({
                  templateUrl: "equipment/views/equipment-on-rent-referencing-modal.html",
                  controller: "EquipmentOnRentReferencingModalCtrl",
                  backdrop: 'static',
                  resolve: {
                    unreferencedEquipmentOnRent: function() {
                      return selectedEquipmentOnRent;
                    },
                    equipmentsByCategory: function() {
                      return data;
                    },
                    associateEquipmentOnRent: function() {
                      return associateEquipmentOnRent;
                    },
                    referenceEquipmentOnRent: function() {
                      return referenceEquipmentOnRent;
                    }
                  }
                });
              });
            } else {
              return notify({
                classes: ["alert-warning"],
                message: $scope.translate['UNREFERENCED_EQUIPMENT_WARNING']
              });
            }
          }
        };
        updateEquipmentOnRent = function(selectedEquipmentOnRent, selectedDate) {
          var statusHistoryEntry;
          $rootScope.busy = true;
          statusHistoryEntry = {};
          statusHistoryEntry.status = selectedEquipmentOnRent.status;
          statusHistoryEntry.requested_date = moment(selectedDate).format("YYYY-MM-DD");
          statusHistoryEntry.created_date = new Date();
          if (!selectedEquipmentOnRent.metadata.status_history) {
            selectedEquipmentOnRent.metadata.status_history = [];
          }
          selectedEquipmentOnRent.metadata.status_history.push(statusHistoryEntry);
          return EquipmentOnRent.api.update({
            id: selectedEquipmentOnRent.id
          }, selectedEquipmentOnRent).$promise.then(function(equipment) {
            return $rootScope.busy = false;
          });
        };
        $scope.orderStatus = function(equipmentOnRent) {
          if (!equipmentOnRent.equipment) {
            return -1;
          }
          return $scope.statusOrder[equipmentOnRent.status];
        };
        $scope.orderDesignation = function(equipmentOnRent) {
          if (!equipmentOnRent.equipment) {
            return equipmentOnRent.metadata.designation;
          }
          return equipmentOnRent.equipment.designation;
        };
        $scope.openAddEquipmentModal = function() {
          EquipmentCatalog.resetCache();
          return EquipmentCatalog.getEquipmentByCategory().then(function(data) {
            var updateDialog;
            return updateDialog = $uibModal.open({
              templateUrl: "equipment/views/add-equipment-on-rent-modal.html",
              controller: "AddEquipmentOnRentModalCtrl",
              backdrop: 'static',
              resolve: {
                equipmentsByCategory: function() {
                  return data;
                },
                addReferencedEquipments: function() {
                  return addReferencedEquipments;
                },
                addNonReferencedEquipment: function() {
                  return addNonReferencedEquipment;
                }
              }
            });
          });
        };
        addReferencedEquipments = function(selection) {
          var newEquipmentsOnRent;
          $rootScope.busy = true;
          newEquipmentsOnRent = [];
          _.map(selection, function(entry) {
            return newEquipmentsOnRent.push(EquipmentOnRent.generateEquipmentOnRent("TO_BE_ORDERED", $scope.stay.id, entry.quantity, entry.equipment.supplier, entry.equipment.id));
          });
          return EquipmentOnRent.api.addEquipmentsOnRent({
            equipments: newEquipmentsOnRent
          }).$promise.then(function(newEquipmentsOnRent) {
            return EquipmentOnRent.addEquipmentsOnRent($scope.equipmentsOnRent, newEquipmentsOnRent).then(function(data) {
              $scope.equipmentsOnRent = data;
              return $rootScope.busy = false;
            });
          });
        };
        addNonReferencedEquipment = function(equipmentOnRent) {
          var statusHistoryEntry, today;
          statusHistoryEntry = {};
          statusHistoryEntry.status = equipmentOnRent.status;
          today = new Date();
          statusHistoryEntry.requested_date = moment(today).format("YYYY-MM-DD");
          statusHistoryEntry.created_date = today;
          if (!equipmentOnRent.metadata.status_history) {
            equipmentOnRent.metadata.status_history = [];
          }
          equipmentOnRent.metadata.status_history.push(statusHistoryEntry);
          return EquipmentOnRent.api.createUnreferenced({
            "equipmentOnRent": equipmentOnRent
          }).$promise.then(function(equipment) {
            return $scope.equipmentsOnRent.push(equipment);
          });
        };
        associateEquipmentOnRent = function(unreferencedEquipmentOnRent, equipment) {
          var equipmentToReference;
          $rootScope.busy = true;
          equipmentToReference = angular.copy(unreferencedEquipmentOnRent);
          equipmentToReference.equipment = equipment.id;
          equipmentToReference.supplier = equipment.supplier;
          return EquipmentOnRent.api.update({
            id: equipmentToReference.id
          }, equipmentToReference).$promise.then(function(equipmentOnRent) {
            return EquipmentOnRent.updateEquipmentOnRentReference($scope.equipmentsOnRent, equipmentOnRent).then(function() {
              return $rootScope.busy = false;
            });
          });
        };
        referenceEquipmentOnRent = function(unreferencedEquipmentOnRent, equipment) {
          $rootScope.busy = true;
          return EquipmentCatalog.api.create(equipment).$promise.then(function(newEquipment) {
            var equipmentToReference;
            EquipmentCatalog.addEquipmentToCache(newEquipment);
            equipmentToReference = angular.copy(unreferencedEquipmentOnRent);
            equipmentToReference.equipment = newEquipment.id;
            equipmentToReference.supplier = newEquipment.supplier;
            return EquipmentOnRent.api.update({
              id: equipmentToReference.id
            }, equipmentToReference).$promise.then(function(equipmentOnRent) {
              return EquipmentOnRent.updateEquipmentOnRentReference($scope.equipmentsOnRent, equipmentOnRent).then(function() {
                return $rootScope.busy = false;
              });
            });
          });
        };
        $scope.filterEquipmentsOnRent = function(equipmentOnRent) {
          var display, searchText;
          display = true;
          if ($scope.filters.deleted) {
            display = true;
          } else {
            display = equipmentOnRent.status !== "DELETED";
          }
          if ($scope.filters.searchText && display) {
            searchText = angular.uppercase($scope.filters.searchText);
            if (equipmentOnRent.equipment) {
              display = _.includes(angular.uppercase(equipmentOnRent.equipment.description), searchText) || _.includes(angular.uppercase(equipmentOnRent.equipment.designation), searchText) || _.includes(angular.uppercase(equipmentOnRent.equipment.reference), searchText);
            } else {
              display = _.includes(angular.uppercase(equipmentOnRent.metadata.designation), searchText);
            }
          }
          return display;
        };
        return init();
      }]
    };
  });

}).call(this);

//# sourceMappingURL=equipment-renting-list-directive.js.map


/*
  * @ngdoc function
  * @name mhclientApp.provider:UpdateStatusModalCtrl
  * @description
  * # UpdateStatusModalCtrl
  * Controller of the modal which handles an equipment on rent status
 */

(function() {
  angular.module("mhclientApp").controller('UpdateStatusModalCtrl', ["$scope", "$filter", "$uibModalInstance", "selectedEquipmentOnRent", "updateEquipmentOnRent", "availableStatus", function($scope, $filter, $uibModalInstance, selectedEquipmentOnRent, updateEquipmentOnRent, availableStatus) {
    $scope.selectedEquipmentOnRent = angular.copy(selectedEquipmentOnRent);
    $scope.status = selectedEquipmentOnRent.status;
    $scope.statusList = availableStatus[selectedEquipmentOnRent.status];
    $scope.today = new Date();
    $scope.resetDate = function() {
      var currentStatusInfo, status_history;
      if (!$scope.selectedEquipmentOnRent.metadata.status_history) {
        $scope.selectedEquipmentOnRent.metadata.status_history = [];
      }
      status_history = $scope.selectedEquipmentOnRent.metadata.status_history;
      currentStatusInfo = status_history[status_history.length - 1];
      if (currentStatusInfo && currentStatusInfo.status === $scope.selectedEquipmentOnRent.status) {
        return $scope.selectedDate = moment(currentStatusInfo.requested_date).toDate();
      } else {
        return $scope.selectedDate = new Date();
      }
    };
    $scope.validate = function() {
      $scope.selectedEquipmentOnRent.equipment = $scope.selectedEquipmentOnRent.equipment.id;
      $scope.selectedEquipmentOnRent.supplier = $scope.selectedEquipmentOnRent.supplier.id;
      return updateEquipmentOnRent($scope.selectedEquipmentOnRent, $scope.selectedDate).then(selectedEquipmentOnRent.status = $scope.selectedEquipmentOnRent.status, selectedEquipmentOnRent.metadata.quantity = $scope.selectedEquipmentOnRent.metadata.quantity, $uibModalInstance.close());
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    return $scope.resetDate();
  }]);

}).call(this);

//# sourceMappingURL=update-status-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:PriceManagementModalCtrl
    * @description
    * # AddEquipmentOnRentModalCtrl
    * Controller of the modal which handles equipment on rent creation
   */
  angular.module("mhclientApp").controller('AddEquipmentOnRentModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "$uibModal", "equipmentsByCategory", "addReferencedEquipments", "addNonReferencedEquipment", "$q", "FeatureUtils", function($scope, $rootScope, $filter, $uibModalInstance, $uibModal, equipmentsByCategory, addReferencedEquipments, addNonReferencedEquipment, $q, FeatureUtils) {
    var init, openQuantityModal;
    init = function() {
      $scope.equipmentsByCategory = equipmentsByCategory;
      $scope.selectionGroups = [];
      $scope.busy = false;
      $scope.searchText = "";
      FeatureUtils.getFeature({
        name: 'EQUIPMENT_CATALOG'
      }).then(function(feature) {
        if ((feature.metadata.FLAGS != null) && _.includes(feature.metadata.FLAGS, "disable_unreferenced")) {
          return $scope.disable_unreferenced = true;
        }
      });
      _.map($scope.equipmentsByCategory, function(category) {
        return $scope.selectionGroups.push([]);
      });
      $scope.groupNameKey = "category";
      return $scope.headers = [
        {
          name: $filter('translate')("REFERENCE"),
          key: "reference"
        }, {
          name: $filter('translate')("DESIGNATION"),
          key: "designation"
        }, {
          name: $filter('translate')("DESCRIPTION"),
          key: "description"
        }, {
          name: $filter('translate')("SUPPLIER"),
          key: "supplier_name"
        }
      ];
    };
    $scope.openAddNonReferencedMaterialModal = function() {
      var dialog;
      dialog = $uibModal.open({
        templateUrl: "equipment/views/add-non-referenced-equipment-modal.html",
        controller: "AddNonReferencedEquipmentModalCtrl",
        backdrop: 'static',
        resolve: {
          addNonReferencedEquipment: function() {
            return addNonReferencedEquipment;
          }
        }
      });
      return dialog.result.then(function() {
        return $uibModalInstance.close();
      });
    };
    openQuantityModal = function(equipments) {
      var modalPromise, quantityDialog;
      modalPromise = $q.defer();
      quantityDialog = $uibModal.open({
        templateUrl: "equipment/views/quantity-set-modal.html",
        controller: "QuantitySetModalCtrl",
        backdrop: 'static',
        resolve: {
          equipments: function() {
            return equipments;
          }
        }
      });
      return quantityDialog.result.then(function(selection) {
        if (selection) {
          modalPromise.resolve(selection);
        }
        return modalPromise.promise;
      });
    };
    $scope.filterActiveEquipment = function(equipment) {
      return equipment.active;
    };
    $scope.isDirty = function() {
      var flatSelectionGroups;
      flatSelectionGroups = _.flatten($scope.selectionGroups);
      return flatSelectionGroups.length > 0;
    };
    $scope.validate = function() {
      return openQuantityModal(_.flatten($scope.selectionGroups)).then(function(selection) {
        return addReferencedEquipments(selection).then(function() {
          $scope.busy = true;
          return $uibModalInstance.close();
        });
      });
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=add-equipment-on-rent-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:QuantitySetModalCtrl
    * @description
    * # QuantitySetModalCtrl
    * Controller of the modal which handles quantity of new equipment on rent
   */
  angular.module("mhclientApp").controller('QuantitySetModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "$uibModal", "equipments", function($scope, $rootScope, $filter, $uibModalInstance, $uibModal, equipments) {
    var init;
    init = function() {
      $scope.selection = [];
      return _.map(equipments, function(equip) {
        return $scope.selection.push({
          equipment: angular.copy(equip),
          quantity: 1
        });
      });
    };
    $scope.filterActiveEquipment = function(equipment) {
      return equipment.active;
    };
    $scope.validate = function() {
      return $uibModalInstance.close($scope.selection);
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=quantity-set-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:AddNonReferencedEquipmentModalCtrl
    * @description
    * # AddNonReferencedEquipmentModalCtrl
    * Controller of the modal which allow non referenced equipment on rent controller
   */
  angular.module("mhclientApp").controller('AddNonReferencedEquipmentModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "$uibModal", "EquipmentOnRent", "addNonReferencedEquipment", function($scope, $rootScope, $filter, $uibModalInstance, $uibModal, EquipmentOnRent, addNonReferencedEquipment) {
    var init;
    init = function() {
      return $scope.equipmentOnRent = {
        status: "TO_BE_ORDERED",
        stay: $rootScope.currentStay.id,
        metadata: {
          quantity: 1,
          designation: ""
        }
      };
    };
    $scope.validate = function() {
      return addNonReferencedEquipment($scope.equipmentOnRent).then(function(equipmentOnRent) {
        $scope.equipmentOnRent = equipmentOnRent;
        return $uibModalInstance.close();
      });
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=add-non-referenced-equipment-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:EquipmentOnRentReferencingModalCtrl
    * @description
    * # EquipmentOnRentReferencingModalCtrl
    * Controller of the modal which handles referencing of equipment
   */
  angular.module("mhclientApp").controller('EquipmentOnRentReferencingModalCtrl', ["$scope", "$rootScope", "$filter", "$uibModalInstance", "$uibModal", "equipmentsByCategory", "unreferencedEquipmentOnRent", "associateEquipmentOnRent", "EquipmentCatalog", "referenceEquipmentOnRent", "$q", function($scope, $rootScope, $filter, $uibModalInstance, $uibModal, equipmentsByCategory, unreferencedEquipmentOnRent, associateEquipmentOnRent, EquipmentCatalog, referenceEquipmentOnRent, $q) {
    var init, referenceEquipment;
    init = function() {
      $scope.equipmentsByCategory = equipmentsByCategory;
      $scope.unreferencedEquipmentOnRent = unreferencedEquipmentOnRent;
      $scope.groupNameKey = "category";
      $scope.okButtonText = $filter('translate')('VALIDATE');
      $scope.cancelButtonText = $filter('translate')('CANCEL');
      $scope.labelText = $filter('translate')('CATEGORY_EDIT_LABEL');
      return $scope.headers = [
        {
          name: $filter('translate')("REFERENCE"),
          key: "reference"
        }, {
          name: $filter('translate')("DESIGNATION"),
          key: "designation"
        }, {
          name: $filter('translate')("DESCRIPTION"),
          key: "description"
        }, {
          name: $filter('translate')("SUPPLIER"),
          key: "supplier_name"
        }
      ];
    };
    $scope.filterActiveEquipment = function(equipment) {
      return equipment.active;
    };
    $scope.openConfirmModal = function(equipment) {
      var confirmDialog;
      confirmDialog = $uibModal.open({
        templateUrl: "core/views/modal-template.html",
        controller: "mhModalCtrl",
        backdrop: 'static',
        resolve: {
          title: function() {
            return $filter('translate')("REFERENCING_CONFIRM_MODAL_TITLE");
          },
          text: function() {
            return $filter('translate')("REFERENCING_CONFIRM_TEXT") + ":" + equipment.reference + " - " + equipment.designation;
          },
          cancelButtonText: function() {
            return $scope.cancelButtonText;
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $scope.okButtonText;
          }
        }
      });
      return confirmDialog.result.then(function(result) {
        if (result) {
          $rootScope.busy = true;
          return associateEquipmentOnRent(unreferencedEquipmentOnRent, equipment).then(function() {
            $rootScope.busy = false;
            return $uibModalInstance.close();
          });
        }
      });
    };
    $scope.openNewEquipmentModal = function() {
      return EquipmentCatalog.getCategories().then(function(categories) {
        return EquipmentCatalog.getSuppliers().then(function(suppliers) {
          return EquipmentCatalog.getEquipments().then(function(equipments) {
            var updateDialog;
            return updateDialog = $uibModal.open({
              templateUrl: "equipment/views/create-equipment-modal.html",
              controller: "CreateEquipmentModalCtrl",
              backdrop: 'static',
              resolve: {
                categories: function() {
                  return _.filter(categories, function(cat) {
                    return cat.active === true;
                  });
                },
                suppliers: function() {
                  return _.filter(suppliers, function(supplier) {
                    return supplier.active === true;
                  });
                },
                equipments: function() {
                  return _.filter(equipments, function(equipment) {
                    return equipment.active === true;
                  });
                },
                createEquipment: function() {
                  return referenceEquipment;
                }
              }
            });
          });
        });
      });
    };
    referenceEquipment = function(equipment) {
      $rootScope.busy = true;
      return referenceEquipmentOnRent(unreferencedEquipmentOnRent, equipment).then(function() {
        $rootScope.busy = false;
        return $uibModalInstance.close();
      });
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=equipment-on-rent-referencing-modal-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:RentalInvoiceCreateCtrl
    * @description
    * # RentalInvoiceCreateCtrl
    * Controller of the rental invoice create form page
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('RentalInvoiceCreateCtrl', ["$scope", "$rootScope", "$q", "$filter", "RentalInvoice", "EquipmentCatalog", "Entity", "EquipmentOnRent", "$state", function($scope, $rootScope, $q, $filter, RentalInvoice, EquipmentCatalog, Entity, EquipmentOnRent, $state) {
    var init;
    $scope.equipmentsOnRentBySupplier = {};
    $scope.suppliers = [];
    $scope.suppliersById = [];
    $scope.selectedEquipmentsOnRent = [];
    $scope.totalCost = 0;
    $scope.slipType = $state.params.slipType;
    $scope.slipTypeStatus = {
      "bonDeCommande": "TO_BE_ORDERED",
      "bonDeRetraite": "TO_BE_REMOVED",
      "bonDeSuspension": "TO_BE_SUSPENDED"
    };
    init = function() {
      $rootScope.busy = true;
      $scope.today = new Date();
      $scope.minDate = new Date();
      if ($rootScope.currentPatient.vital_signs_data.last_values) {
        if ($rootScope.currentPatient.vital_signs_data.last_values.POIDS) {
          $scope.weight = $rootScope.currentPatient.vital_signs_data.last_values.POIDS.value;
          $scope.weight_label = $rootScope.currentPatient.vital_signs_data.last_values.POIDS.label;
        }
        if ($rootScope.currentPatient.vital_signs_data.last_values.TAIL) {
          $scope.height = $rootScope.currentPatient.vital_signs_data.last_values.TAIL.value;
          $scope.height_label = $rootScope.currentPatient.vital_signs_data.last_values.TAIL.label;
        } else if ($rootScope.currentPatient.vital_signs_data.last_values.TAILCM) {
          $scope.height = $rootScope.currentPatient.vital_signs_data.last_values.TAILCM.value;
          $scope.height_label = $rootScope.currentPatient.vital_signs_data.last_values.TAILCM.label;
        }
      } else {
        $scope.weight = "-";
        $scope.weight_label = $filter('translate')("WEIGHT");
        $scope.height = "-";
        $scope.height_label = $filter('translate')("HEIGHT");
      }
      $scope.metadata = {
        deliveryTime: "",
        withdrawalTime: "",
        suspensionTime: "",
        deliveryPoint: "",
        withdrawalPoint: "",
        suspensionPoint: "",
        deliveryPointInfo: "",
        contact: "",
        phone: "",
        access: "",
        comment: "",
        height: $scope.height,
        weight: $scope.weight,
        height_label: $scope.height_label,
        weight_label: $scope.weight_label
      };
      $scope.PUILabel = $filter('translate')("PUI");
      $scope.otherLabel = $filter('translate')("OTHER");
      $scope.deliveryPointList = [$filter('translate')("HAD"), $filter('translate')("PATIENT"), $scope.PUILabel, $scope.otherLabel];
      $scope.headers = [
        {
          name: $filter('translate')("REFERENCE"),
          key: "reference"
        }, {
          name: $filter('translate')("DESIGNATION"),
          key: "designation"
        }, {
          name: $filter('translate')("DESCRIPTION"),
          key: "description"
        }, {
          name: $filter('translate')("QUANTITY"),
          key: "quantity"
        }, {
          name: $filter('translate')("COST"),
          key: "cost"
        }, {
          name: $filter('translate')("COMMENT"),
          key: "comment",
          edit: true
        }
      ];
      $scope.bonDeRetraiteHeaders = [
        {
          name: $filter('translate')("REFERENCE"),
          key: "reference"
        }, {
          name: $filter('translate')("DESIGNATION"),
          key: "designation"
        }, {
          name: $filter('translate')("DESCRIPTION"),
          key: "description"
        }, {
          name: $filter('translate')("QUANTITY"),
          key: "quantity"
        }, {
          name: $filter('translate')("COMMENT"),
          key: "comment",
          edit: true
        }
      ];
      return RentalInvoice.getEquipmentsOnRentToOrderBySupplier($scope.slipTypeStatus[$scope.slipType]).then(function(equipmentsOnRentBySupplier) {
        return EquipmentCatalog.getSuppliers().then(function(suppliers) {
          $scope.suppliers = _.filter(suppliers, function(sup) {
            var ref;
            return ref = sup.id + "", indexOf.call(Object.keys(equipmentsOnRentBySupplier), ref) >= 0;
          });
          _.map(suppliers, function(supplier) {
            return $scope.suppliersById[supplier.id] = supplier;
          });
          $scope.equipmentsOnRentBySupplier = equipmentsOnRentBySupplier;
          if ($scope.suppliers.length > 0) {
            $scope.selectedSupplier = $scope.suppliers[0].id;
          }
          if ($rootScope.mh_config.platform === "mgapp") {
            return $rootScope.busy = false;
          } else {
            return Entity.getEntities().then(function(entities) {
              $scope.entity = _.find(entities, function(ent) {
                return ent.id === $scope.user.entity;
              });
              return $rootScope.busy = false;
            });
          }
        });
      });
    };
    $scope.computeTotalCost = function() {
      $scope.totalCost = 0;
      return _.map($scope.selectedEquipmentsOnRent, function(equipmentOnRent) {
        return $scope.totalCost = $scope.totalCost + equipmentOnRent.quantity * equipmentOnRent.price;
      });
    };
    $scope.resetSelection = function() {
      $scope.totalCost = 0;
      return $scope.selectedEquipmentsOnRent = [];
    };
    $scope.canSave = function() {
      if ($scope.form !== void 0) {
        return $scope.form.$valid && $scope.selectedEquipmentsOnRent.length > 0;
      }
    };
    $scope.saveRentalInvoice = function() {
      var rentalInvoice;
      $rootScope.busy = true;
      rentalInvoice = {
        stay: $rootScope.currentStay.id,
        comments: $scope.metadata.comment,
        supplier: $scope.selectedSupplier,
        author: $scope.user.id,
        slip_type: $scope.slipType,
        metadata: {
          deliveryDate: moment($scope.metadata.deliveryDate).format("YYYY-MM-DD"),
          deliveryTime: $scope.metadata.deliveryTime,
          deliveryPoint: $scope.metadata.deliveryPoint,
          withdrawalDate: moment($scope.metadata.withdrawalDate).format("YYYY-MM-DD"),
          withdrawalTime: $scope.metadata.withdrawalTime,
          withdrawalPoint: $scope.metadata.withdrawalPoint,
          suspensionDate: moment($scope.metadata.suspensionDate).format("YYYY-MM-DD"),
          suspensionTime: $scope.metadata.suspensionTime,
          suspensionPoint: $scope.metadata.suspensionPoint,
          deliveryPointInfo: $scope.metadata.deliveryPointInfo,
          contact: $scope.metadata.contact,
          phone: $scope.metadata.phone,
          access: $scope.metadata.access,
          totalCost: $scope.totalCost,
          equipmentsOnRent: $scope.selectedEquipmentsOnRent,
          height: $scope.height,
          height_label: $scope.height_label,
          weight: $scope.weight,
          weight_label: $scope.weight_label
        }
      };
      return RentalInvoice.api.create(rentalInvoice).$promise.then(function(newRentalInvoice) {
        var equipmentsOnRentToUpdate;
        equipmentsOnRentToUpdate = [];
        $scope.selectedEquipmentsOnRent.forEach(function(equipmentOnRent) {
          var equipmentOnRentToUpdate, selectedDate, statusHistoryEntry;
          equipmentOnRentToUpdate = {};
          equipmentOnRentToUpdate.rental_invoice = newRentalInvoice.id;
          equipmentOnRentToUpdate.id = equipmentOnRent.id;
          equipmentOnRentToUpdate.metadata = equipmentOnRent.metadata;
          statusHistoryEntry = {};
          if (newRentalInvoice.slip_type === 'bonDeRetraite') {
            selectedDate = newRentalInvoice.metadata.withdrawalDate;
            statusHistoryEntry.status = "REMOVED";
          } else if (newRentalInvoice.slip_type === 'bonDeSuspension') {
            selectedDate = newRentalInvoice.metadata.suspensionDate;
            statusHistoryEntry.status = "SUSPENDED";
          } else {
            selectedDate = newRentalInvoice.metadata.deliveryDate;
            statusHistoryEntry.status = "ORDERED";
          }
          statusHistoryEntry.requested_date = moment(selectedDate).format("YYYY-MM-DD");
          statusHistoryEntry.created_date = new Date();
          if (!equipmentOnRentToUpdate.metadata.status_history) {
            equipmentOnRentToUpdate.metadata.status_history = [];
          }
          equipmentOnRentToUpdate.metadata.status_history.push(statusHistoryEntry);
          return equipmentsOnRentToUpdate.push(equipmentOnRentToUpdate);
        });
        return EquipmentOnRent.api.updateEquipmentsOnRent({
          equipments: equipmentsOnRentToUpdate
        }).$promise.then(function(newEquipmentsOnRent) {
          return RentalInvoice.api.update(newRentalInvoice).$promise.then(function() {
            $rootScope.busy = false;
            return $state.go("user.patient.stay.rental-invoices.list");
          });
        });
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=rental-invoice-create-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:RentalInvoiceListCtrl
    * @description
    * # RentalInvoiceListCtrl
    * Controller of the rental invoice list page
   */
  angular.module('mhclientApp').controller('RentalInvoiceListCtrl', ["$scope", "$rootScope", "$q", "$filter", "RentalInvoice", "Entity", "EquipmentCatalog", "UserUtils", "moment", function($scope, $rootScope, $q, $filter, RentalInvoice, Entity, EquipmentCatalog, UserUtils, moment) {
    var init;
    $scope.suppliersById = {};
    $scope.usersById = {};
    $scope.data = [];
    $scope.displayType = 'all';
    init = function() {
      $scope.PUILabel = $filter('translate')("PUI");
      $scope.otherLabel = $filter('translate')("OTHER");
      $scope.headers = [
        {
          name: $filter('translate')("REFERENCE"),
          key: "reference"
        }, {
          name: $filter('translate')("DESIGNATION"),
          key: "designation"
        }, {
          name: $filter('translate')("DESCRIPTION"),
          key: "description"
        }, {
          name: $filter('translate')("QUANTITY"),
          key: "quantity"
        }, {
          name: $filter('translate')("COST"),
          key: "cost"
        }, {
          name: $filter('translate')("COMMENT"),
          key: "comment"
        }
      ];
      $scope.bonDeRetraiteHeaders = [
        {
          name: $filter('translate')("REFERENCE"),
          key: "reference"
        }, {
          name: $filter('translate')("DESIGNATION"),
          key: "designation"
        }, {
          name: $filter('translate')("DESCRIPTION"),
          key: "description"
        }, {
          name: $filter('translate')("QUANTITY"),
          key: "quantity"
        }, {
          name: $filter('translate')("COMMENT"),
          key: "comment"
        }
      ];
      RentalInvoice.getEquipmentInvoices().then(function(invoices) {
        $scope.rentalInvoices = {
          "bonDeCommande": _.filter(invoices, {
            slip_type: "bonDeCommande"
          }),
          "bonDeRetraite": _.filter(invoices, {
            slip_type: "bonDeRetraite"
          }),
          "bonDeSuspension": _.filter(invoices, {
            slip_type: "bonDeSuspension"
          })
        };
        $scope.rentalInvoicesTypes = _.keys($scope.rentalInvoices);
        $scope.rentalInvoicesTypes.push("all");
        return EquipmentCatalog.getSuppliers().then(function(suppliers) {
          _.map(suppliers, function(supplier) {
            return $scope.suppliersById[supplier.id] = supplier;
          });
          Entity.getEntities().then(function(entities) {
            return $scope.entity = _.find(entities, function(ent) {
              return ent.id === $scope.user.entity;
            });
          });
          return UserUtils.getUsers().then(function(users) {
            _.map(users, function(user) {
              return $scope.usersById[user.id] = user;
            });
            return $rootScope.busy = false;
          });
        });
      });
      return $scope.reloadList = function() {
        return $scope.slipType = $scope.displayType;
      };
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=rental-invoice-list-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:RentalInvoice
    * @description
    * # RentalInvoice
    * Factory of RentalInvoice
   */
  angular.module("mhclientApp").factory('RentalInvoice', ["$resource", "MhConfig", "BoxResource", "$q", "EquipmentCatalog", "$rootScope", "EquipmentOnRent", "$filter", function($resource, MhConfig, BoxResource, $q, EquipmentCatalog, $rootScope, EquipmentOnRent, $filter) {
    var acceptHeader, api, equipmentInvoicesCache, equipment_invoices, getEquipmentInvoices, getEquipmentsOnRentToOrderBySupplier, portailAPI, service;
    equipmentInvoicesCache = null;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/equipment_invoice/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          Accept: acceptHeader
        },
        isArray: true
      },
      create: {
        method: 'POST'
      },
      update: {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        equipment_invoices = window.mgapp.get('equipment_mgr').equipment_invoices();
        api = BoxResource.generate(equipment_invoices);
        api.create = function(object) {
          return BoxResource.mhboxApiCall(equipment_invoices, "save", object);
        };
    }
    getEquipmentsOnRentToOrderBySupplier = function(status) {
      var deferPromise, equipmentsOnRentBySupplier;
      deferPromise = $q.defer();
      equipmentsOnRentBySupplier = {};
      EquipmentOnRent.getNestedEquipmentsOnRent().then(function(equipmentsOnRent) {
        return EquipmentCatalog.getSuppliers().then(function(suppliers) {
          _.map(equipmentsOnRent, function(equip) {
            if (equip.equipment) {
              equip.reference = equip.equipment.reference;
              equip.designation = equip.equipment.designation;
              equip.description = equip.equipment.description;
              equip.price = equip.equipment.price_history.current;
              equip.quantity = equip.metadata.quantity;
              return equip.cost = $filter("number")(equip.quantity * equip.price, 2);
            }
          });
          _.map(suppliers, function(supplier) {
            var filteredEquipments;
            filteredEquipments = _.filter(equipmentsOnRent, function(equip) {
              if (equip.supplier) {
                return equip.supplier.id === supplier.id && equip.status === status;
              }
              return false;
            });
            if (filteredEquipments.length > 0) {
              return equipmentsOnRentBySupplier[supplier.id] = filteredEquipments;
            }
          });
          return deferPromise.resolve(equipmentsOnRentBySupplier);
        });
      });
      return deferPromise.promise;
    };
    getEquipmentInvoices = function() {
      var invoicesPromise, params;
      params = {};
      if ($rootScope.allStays) {
        params.patient = $rootScope.currentPatient.id;
      } else {
        params.stay = $rootScope.currentStay.id;
      }
      invoicesPromise = $q.defer();
      if (!equipmentInvoicesCache) {
        api.query(params).$promise.then(function(equipmentInvoices) {
          return invoicesPromise.resolve(equipmentInvoices);
        });
      } else {
        invoicesPromise.resolve(equipmentInvoicesCache);
      }
      return invoicesPromise.promise;
    };
    service = {
      getEquipmentsOnRentToOrderBySupplier: getEquipmentsOnRentToOrderBySupplier,
      getEquipmentInvoices: getEquipmentInvoices,
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=rental-invoice-service.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.core:rentalInvoice
    * @description
    * # Directive for rental invoice template
   */
  angular.module('mhclientApp').directive('rentalInvoice', function() {
    return {
      restrict: 'E',
      templateUrl: 'equipment/views/rental-invoice-directive.html',
      scope: {
        invoice: "=?",
        entity: "=",
        date: "=",
        supplier: "=",
        patient: "=",
        stay: "=",
        metadata: "=",
        deliveryPointList: "=",
        puiLabel: "=",
        otherLabel: "=",
        equipmentsOnRent: "=",
        headers: "=",
        totalCost: "=",
        comment: "=",
        selection: "=",
        onSelection: "&?",
        edit: "=?",
        slipType: "="
      },
      link: function(scope, element, attributes) {},
      controller: ["$scope", "RentalInvoice", "notify", "$filter", function($scope, RentalInvoice, notify, $filter) {
        $scope.minDate = new Date();
        $scope.canEdit = ["ADM", "PRE"].indexOf($scope.stay.state) > -1;
        return $scope.changeDate = function() {
          if ($scope.invoice == null) {
            return;
          }
          if ($scope.slipType === 'bonDeCommande') {
            $scope.invoice.metadata.deliveryDate = moment($scope.metadata.deliveryDate).format("YYYY-MM-DD");
          } else if ($scope.slipType === 'bonDeRetraite') {
            $scope.invoice.metadata.withdrawalDate = moment($scope.metadata.withdrawalDate).format("YYYY-MM-DD");
          } else if ($scope.slipType === 'bonDeSuspension') {
            $scope.invoice.metadata.suspensionDate = moment($scope.metadata.suspensionDate).format("YYYY-MM-DD");
          }
          return RentalInvoice.api.update($scope.invoice).$promise.then(function(newRentalInvoice) {
            notify({
              classes: ['alert-info'],
              message: $filter('translate')($scope.slipType) + " " + $filter('translate')("updated")
            });
          });
        };
      }]
    };
  });

}).call(this);

//# sourceMappingURL=rental-invoice-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:EquipmentCtrl
    * @description
    * # EquipmentCatalogCtrl
    * Controller of the Equipment states
   */
  angular.module('mhclientApp').controller('EquipmentCtrl', ["$scope", "$rootScope", "EquipmentCatalog", "$q", "$uibModal", "$filter", "notify", function($scope, $rootScope, EquipmentCatalog, $q, $uibModal, $filter, notify) {
    var init;
    $scope.data = [];
    init = function() {};
    return init();
  }]);

}).call(this);

//# sourceMappingURL=equipment-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:EquipmentRentingHistoryCtrl
    * @description
    * # EquipmentRentingHistoryCtrl
    * Controller of the EquipmentOnRent on History
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('EquipmentRentingHistoryCtrl', ["$scope", "$rootScope", "EquipmentCatalog", "$q", "EquipmentOnRent", "$filter", "$state", function($scope, $rootScope, EquipmentCatalog, $q, EquipmentOnRent, $filter, $state) {
    var init, params;
    $scope.totalCost = 0;
    $scope.suppliersById = {};
    $scope.equipmentsList = [];
    $scope.filters = {
      equipments: [],
      supplier: "all"
    };
    init = function() {
      return $rootScope.busy = true;
    };
    if (($state.statesStack[0] != null) && ($state.statesStack[0].name != null)) {
      $scope.previousState = $state.statesStack[0].name;
    } else {
      $scope.previousState = "user.patient.stay.equipment-renting.list";
      $scope.statusInitials = {
        TO_BE_ORDERED: $filter('translate')("TO_BE_ORDERED_SHORT"),
        ORDERED: $filter('translate')("ORDERED_SHORT"),
        INSTALLED: $filter('translate')("INSTALLED_SHORT"),
        TO_BE_SUSPENDED: $filter('translate')("TO_BE_SUSPENDED_SHORT"),
        SUSPENDED: $filter('translate')("SUSPENDED_SHORT"),
        TO_BE_REMOVED: $filter('translate')("TO_BE_REMOVED_SHORT"),
        REMOVED: $filter('translate')("REMOVED_SHORT"),
        DELETED: $filter('translate')("DELETED_SHORT")
      };
      params = {};
      if ($rootScope.allStays) {
        params.patient = $rootScope.currentPatient.id;
      } else {
        params.stay = $rootScope.currentStay.id;
      }
      EquipmentOnRent.api.getHistory(params).$promise.then(function(history) {
        return EquipmentCatalog.getSuppliers().then(function(suppliers) {
          var suppliersToDisplay, uniqueEquipmentDesignations;
          suppliersToDisplay = [];
          uniqueEquipmentDesignations = [];
          _.map(history, function(equip) {
            var ref, ref1, ref2;
            if (ref = equip.supplier, indexOf.call(suppliersToDisplay, ref) < 0) {
              suppliersToDisplay.push(equip.supplier);
            }
            equip.supplierName = ((ref1 = _.find(suppliers, {
              id: equip.supplier
            })) != null ? ref1.name : void 0) || '-';
            if (ref2 = equip.designation, indexOf.call(uniqueEquipmentDesignations, ref2) < 0) {
              uniqueEquipmentDesignations.push(equip.designation);
              return $scope.equipmentsList.push({
                "designation": equip.designation
              });
            }
          });
          suppliers = _.filter(suppliers, function(sup) {
            var ref;
            return ref = sup.id, indexOf.call(suppliersToDisplay, ref) >= 0;
          });
          suppliers.push({
            name: $filter('translate')("ALL"),
            id: "all"
          });
          $scope.suppliers = suppliers;
          $scope.history = history;
          $scope.today = new Date();
          $scope.dateTo = new Date();
          $scope.dateFrom = moment().subtract(10, 'days').toDate();
          $scope.computeHistory();
          return $rootScope.busy = false;
        });
      });
    }
    $scope.computeHistory = function() {
      var dateIteration, equipment, i, len, ref, results;
      $scope.displayDateList = [];
      $scope.dateList = [];
      dateIteration = $scope.dateFrom;
      while (dateIteration <= $scope.dateTo) {
        $scope.displayDateList.push($filter('date')(dateIteration, 'dd/MM/yyyy'));
        $scope.dateList.push(dateIteration);
        dateIteration = moment(dateIteration).add(1, "days").toDate();
      }
      $scope.updateExportCsvUrl();
      EquipmentOnRent.computeHistory($scope.dateList, $scope.history);
      $scope.totalCost = 0;
      ref = $scope.history;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        equipment = ref[i];
        results.push($scope.totalCost = $scope.totalCost + equipment.totalCost);
      }
      return results;
    };
    $scope.equipmentFilterChange = function(equipment) {
      if (equipment.checked) {
        return $scope.filters.equipments.push(equipment.designation);
      } else {
        return $scope.filters.equipments.splice($scope.filters.equipments.indexOf(equipment), 1);
      }
    };
    $scope.filterEquipment = function(equipment) {
      var display, ref;
      display = true;
      if ($scope.filters.supplier !== "all") {
        display = equipment.supplier === $scope.filters.supplier;
      }
      if ($scope.filters.equipments.length > 0) {
        display = (ref = equipment.designation, indexOf.call($scope.filters.equipments, ref) >= 0);
      }
      return display;
    };
    $scope.updateExportCsvUrl = function() {
      var baseUrl, endDate, startDate, stay_id, supplier;
      supplier = $scope.filters.supplier;
      startDate = moment($scope.dateFrom).format('YYYY-MM-DD');
      endDate = moment($scope.dateTo).format('YYYY-MM-DD');
      stay_id = $scope.currentStay.id;
      baseUrl = $scope.base_iframe_url + "/api_rest/equipments_on_rent/export_history_csv";
      $scope.equipmentRentalExportCSVUrl = baseUrl + "?endDate=" + endDate + "&startDate=" + startDate + "&stay=" + stay_id + "&supplier=" + supplier;
      if ($scope.filters.supplier !== "all") {
        return $scope.equipmentRentalExportCSVUrl += "&supplier=" + $scope.filters.supplier;
      }
    };
    $scope.updateExportCsvUrl();
    return init();
  }]);

}).call(this);

//# sourceMappingURL=equipment-on-rent-history-controller.js.map

'use strict';

/* **************************************************
* @ngdoc function
* @name mhclientApp.controller:AgendaDayViewCtrl
* @description
* AgendaDayViewCtrl
* Controller of agenda day view data component.
*************************************************** */

var AgendaDayViewCtrl = function(AgendaTask, AgendaUtils) {
  var ctrl = this;
  ctrl.maxDiffDay = 3;
  ctrl.minDiffDay = -1 * ctrl.maxDiffDay;

  function init() {
    ctrl.selectedDate = moment();
    ctrl.diffFromNow = 0;
    var params = {
      target: ctrl.patient.id,
      start_date: moment().add(ctrl.minDiffDay, "days").format('YYYY-MM-DD'),
      end_date: moment().add(ctrl.maxDiffDay, "days").format('YYYY-MM-DD'),
      without_sequences : true
    };
    AgendaTask.api.query(params).$promise.then( function(patientTasks) {
      AgendaUtils.groupTasksInEvents(patientTasks).then( function(events) {
        ctrl.events = _.map(events, function(evt) {
          return {
            label: evt.shortLabel,
            start: evt.start.toDate(),
            end: evt.end? evt.end.toDate() : '',
            allDay: evt.event_all_day,
          };
        });
        ctrl.filterEventsBySelecteDate();
      });
    });
  };

  // Change the selected ate and compute selected events
  ctrl.changeSelectedDay = function(offset) {
    ctrl.selectedDate = ctrl.selectedDate.add(offset, "days");
    ctrl.diffFromNow += offset;
    ctrl.filterEventsBySelecteDate();
  };

  // compute the events of the selected date
  ctrl.filterEventsBySelecteDate = function() {
    var filterEvents = _.filter(ctrl.events, function(evt) {
      return ctrl.selectedDate.isSame(evt.start, "day");
    });
    ctrl.selectedEvents = _.orderBy(filterEvents, ["start", "allDay"], ["asc", "desc"]);
  };

  init();
};
AgendaDayViewCtrl.$inject = ["AgendaTask", "AgendaUtils"];


angular.module("mhclientApp")
    .component('agendaDayView', {
      templateUrl: 'summary/components/agenda-day-view/agenda-day-view-component.html',
      controller: AgendaDayViewCtrl,
      bindings: {
        patient: '<',
      },
    });

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.controller:LastScanCtrl
* @description
* LastScanCtrl
* Controller of last scan data component.
* ***********************************************/

var LastScanCtrl = function(ImageDocument, $filter) {
  var ctrl = this;

  function init() {
    ImageDocument.api.query({stay: ctrl.stay.id, category_code: ctrl.category}).$promise.then( function(docs) {
      if (docs.length > 0) {
        ctrl.lastScanDate = $filter("orderBy")(docs, "-created")[0].created;
      }
    });
  };

  init();
};
LastScanCtrl.$inject = ["ImageDocument", "$filter"];

angular.module('mhclientApp')
    .component('lastScan', {
      templateUrl: 'summary/components/last-scan/last-scan-component.html',
      controller: LastScanCtrl,
      bindings: {
        stay: '<',
        category: '<',
      },
    });

'use strict';

/* **************************************************
* @ngdoc function
* @name mhclientApp.controller:MedformDataCtrl
* @description
* MedformDataCtrl
* Controller of medical form data component.
* ***************************************************/

var MedformDataCtrl = function(FormVersion, FormTemplateUtils, $filter, $http) {
  var ctrl = this;

  function init() {
    ctrl.medFormData = null;
    if (ctrl.displayType == null) {
      ctrl.displayType = 'value'
    }
    if (ctrl.formTemplate != null && ctrl.patient!= null && ctrl.field != null) {
      FormTemplateUtils.getTemplates({uid: ctrl.formTemplate}).then( function(template) {
        if (!template) {
            return
        }
        FormVersion.query({template: template.id, patient: ctrl.patient.id, stay: ctrl.stay.id}).$promise.then( function(versions) {
          var versions = $filter('orderBy')(versions, "-last_edit_timestamp");
          if (versions.length > 0) {
            var version = versions[0];
            if (version.containers != null && version.containers.length > 0) {
              var container = version.containers[0];
              if (container.dynamic_form) {
                $http.get(container.dynamic_form).then( function(dynamicForm) {
                  var fields = dynamicForm.data.fields.flatMap(function(item) { return item['fields']; });
                  var allFields = fields.concat(fields.flatMap(function(item) { return item['fields']; }));
                  var value = null
                  $http.get(container.dataUrl).then( function(result) {
                    value = result.data[ctrl.field];
                    if (value != null) {
                      var data = _.find(allFields, {key: ctrl.field});
                      if (!data) {
                        return
                      }
                      /* TODO: handle other data types: checkboxes etc. */
                      ctrl.dataType = data.type
                      if (data.type == 'radio') {
                        var output = _.find(data.radio_options, function(opt) { return opt.value == value; });
                        ctrl.medFormData = output[ctrl.displayType];
                      } else if (_.includes(['select', 'text', 'text-area'], data.type)) {
                        ctrl.medFormData = value;
                      }
                    }
                  });
                });
              }
            }
          }
        });
      });
    }
  };

  init();

};
MedformDataCtrl.$inject = ["FormVersion", "FormTemplateUtils", "$filter", "$http"];
angular.module('mhclientApp')
    .component('medformData', {
      templateUrl: 'summary/components/medform-data/medform-data-component.html',
      controller: MedformDataCtrl,
      bindings: {
        patient: '<',
        stay: '<',
        formTemplate: '<',
        field: '<',
        displayType: '<'
      },
    });

'use strict';


/* *************************************************************
* @ngdoc function
* @name mhclientApp.controller:ObjectDataCtrl
* @description
* # ObjectDataCtrl
* Controller of object data component. Allow to display data from an object
* *********************************************************** */

var ObjectDataCtrl = function() {
  var ctrl = this;

  var init = function() {
    ctrl.text = "";
    if (ctrl.object != undefined) {
      for (var i = 0, length = ctrl.fieldsToDisplay.length; i < length; i++) {
        var value = getFieldValue(ctrl.object, ctrl.fieldsToDisplay[i].split("."));
        if (value != "") {
          if (ctrl.text != "") {
            ctrl.text += " / ";
          }
          ctrl.text += value;
        }
      }
    }
  };

  function getFieldValue(obj, fieldLabelList) {
    var label = fieldLabelList.shift();
    var value = obj[label];
    if (value == undefined) {
      return "";
    }
    if (fieldLabelList.length > 0) {
      return getFieldValue(value, fieldLabelList);
    }
    return _.escape(value);
  };

  init();
};

angular.module('mhclientApp')
    .component('objectData', {
      templateUrl: 'summary/components/object-data/object-data-component.html',
      controller: ObjectDataCtrl,
      bindings: {
        object: '<',
        fieldsToDisplay: '<',
      },
    });

'use strict';

/**
  * @ngdoc function
  * @name mhclientApp.component:summaryGrid
  * @description
  * Component of summary grid
 */

var SummaryGridCtrl = function(SiteVarsUtils) {
  var ctrl = this;
  var init = function() {
    SiteVarsUtils.get("SUMMARY_SETTINGS", []).then( function(summarySettings) {
      ctrl.rows = summarySettings.value;
    });
  };
  ctrl.displayBlock = function(block) {
    // don't display hidden rows on mhbox
    if (block['mhbox-hiding'] && ctrl.platform === 'mgapp') {
      return false;
    }
    return true;
  };
  ctrl.displayRow = function(row) {
    // don't display hidden rows on mhbox
    if (row['mhbox-hiding'] && ctrl.platform === 'mgapp') {
      return false;
    }
    // don't display row if user does not have required features
    if (row['feature-requirements']) {
      var missingFeature = false;
      row['feature-requirements'].forEach(function(requiredFeature) {
        if (_.indexOf(ctrl.user.group.features, requiredFeature) < 0) {
          missingFeature = true;
        }
      });
      return !missingFeature;
    }
    return true;
  };
  init();
};
SummaryGridCtrl.$inject = ["SiteVarsUtils"];

angular.module('mhclientApp').component('summaryGrid', {
  templateUrl: 'summary/components/summary-grid/summary-grid.html',
  controller: SummaryGridCtrl,
  bindings: {
    patient: '<',
    stay: '<',
    platform: '<',
    user: '<',
  },
});

'use strict';

/* *************************************************************
* @ngdoc function
* @name mhclientApp.controller:VitalsignsTableCtrl
* @description
* VitalsignsTableCtrl
* Controller of vital signs table component.
* *********************************************************** */

var VitalsignsTableCtrl = function(PatientMeasuresTypes, Measures, $q) {
  var ctrl = this;

  function init() {
    var queries = [
      PatientMeasuresTypes.api.query({stay: ctrl.stay.id}).$promise,
      Measures.api.query({stay: ctrl.stay.id}).$promise,
    ];
    $q.all(queries).then( function(results) {
      ctrl.measures = {};
      // filter selected  patient measure data
      var patientMeasList = _.filter(results[0], function(patientMeas) {
        return ctrl.displayList.indexOf(patientMeas.uid) !== -1;
      });
      ctrl.patientMeasList = _.sortBy(patientMeasList, function(patientMeas)  { 
        return ctrl.displayList.indexOf(patientMeas.uid);
      });

      // get selected measure type
      var measTypeList = _.map(ctrl.patientMeasList, function(patientMeas) {
        return patientMeas.measure_type;
      });
      // filter mesaures by meaure_type
      var measures = _.filter(results[1], function(measure) {
        return measTypeList.indexOf(measure.mtype) !== -1;
      });
      // compute day difference between now and measure timestamp
      measures = _.map(measures, function(measure) {
        return {
          value: measure.value,
          diffDay: moment().diff(measure.timestamp, "days"),
          mtype: measure.mtype,
          timestamp: measure.timestamp,
        };
      });
      // order measures by timestamp
      measures = _.orderBy(measures, ["timestamp"], "desc");
      // group measures by measure type
      measures = _.groupBy(measures, "mtype");
      // compute measures to group it by measure type and date
      _.forEach(measures, function(meas, mtype) {
        meas = meas.slice(0,2); // keep only the most recent two values 
        var values = {};
        _.forEach(meas, function(measure) {
          if (!values[measure]) {
            values[measure] = [];
          }
          values[measure].push({'value': measure.value, 'timestamp': moment(measure.timestamp).format('DD/MM')});
        });
        ctrl.measures[mtype] = values
      });
    });
  };

  init();
};
VitalsignsTableCtrl.$inject = ["PatientMeasuresTypes", "Measures", "$q"];

angular.module("mhclientApp")
    .component("vitalsignsTable", {
      templateUrl: 'summary/components/vital-signs-table/vital-signs-table-component.html',
      controller: VitalsignsTableCtrl,
      bindings: {
        stay: '<',
        displayList: '<',
      },
    });

"use strict";

/* **************************************************
 * @ngdoc function
 * @name mhclientApp.controller:NotificationSummaryCtrl
 * @description
 * AgendaDayViewCtrl
 * Controller of notification summary component.
 *************************************************** */

var NotificationSummaryCtrl = function (
  Alert,
  alertUtils,
  redirectUtils,
  $rootScope
) {
  var ctrl = this;

  init();

  function init() {
    Alert.api.query({ stay: ctrl.stay.id }).$promise.then(function (alerts) {
      _.forEach(alerts, function (alert) {
        alert.config = _.cloneDeep(
          _.find($rootScope.alertConfigs, { id: alert.config })
        );
        if (alert.config) {
          alert.config.grouped_by_day = true;
        } else {
          alertUtils.resetCache();
        }
      });

      ctrl.formatedEvents = alertUtils.formatEvents(
        _.filter(alerts, "config"),
        ctrl.stay
      );
    });
  }

  ctrl.redirectToAlert = function (event) {
    redirectUtils.redirectToAlert(event);
  };

  ctrl.confirmAlert = function (event, container) {
    alertUtils.confirmAlert(event, container);
  };
};
NotificationSummaryCtrl.$inject = ["Alert", "alertUtils", "redirectUtils", "$rootScope"];

angular.module("mhclientApp").component("notificationSummary", {
  templateUrl:
    "summary/components/notification-summary/notification-summary-component.html",
  controller: NotificationSummaryCtrl,
  bindings: {
    stay: "<",
  },
});

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.controller:PrescriptionDataCtrl
* @description
* PrescriptionDataCtrl
* Controller of Prescription component.
* ***********************************************/

var PrescriptionDataCtrl = function(Prescription, PrescUtils, $filter) {
  var ctrl = this;
  function init() {
    var params = {};
    params = {current_prescriptions:true, exclude_discharge_prescs: true, stay: ctrl.stay.id};
    ctrl.prescByCategories = []
    PrescUtils.getCategories().promise.then( function(categories) {
      Prescription.query(params).$promise.then( function(prescs) {
        prescs = _.filter(prescs, function(presc) {
          return (('bdm_data' in presc.data) && (presc.state != 'STOPPED') && (presc.state != 'EXPIRED'));
        });
        prescs = _.map(prescs, function(presc) {
          var category;
          category = _.find(categories, function(cat) { 
            return cat.id == presc.category
          });

          return {
            name: presc.data.name,
            category: category.label,
            category_order: category.order,
            timestamp: presc.timestamp,
            presc_id: presc.id,
            category_id: category.id
          };
        });
        prescs = _.orderBy(prescs, ["category_order", "name"], "asc");
        prescs = _.groupBy(prescs, 'category');
        ctrl.prescByCategories = prescs
      });
    });
  }

  init();
};
PrescriptionDataCtrl.$inject = ["Prescription", "PrescUtils", "$filter"];

angular.module('mhclientApp')
    .component('prescriptionData', {
      templateUrl: 'summary/components/prescription-data/prescription-data-component.html',
      controller: PrescriptionDataCtrl,
      bindings: {
        stay: '<',
      },
    });

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.controller:EntourageDataCtrl
* @description
* EntourageDataCtrl
* Controller of last scan data component.
* ***********************************************/

var EntourageDataCtrl = function(Entourage, $filter) {
  var ctrl = this;

  function init() {
    ctrl.personToContact = [];
    Entourage.get({id:ctrl.patient.id}).$promise.then(function(response) {
      ctrl.contacts = response.entourage;
      _.forEach(ctrl.contacts, function(contactInfo) {
          _.forEach(contactInfo, function(contact) {
            if (contact.person_type === "person_to_contact") {
              ctrl.personToContact.push(contact);
            }
          });
        });
      });
    }
  init();
};
EntourageDataCtrl.$inject = ["Entourage", "$filter"];

angular.module('mhclientApp')
    .component('entourageData', {
      templateUrl: 'summary/components/entourage/entourage-data-component.html',
      controller: EntourageDataCtrl,
      bindings: {
        patient: '<'
      },
    });

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.controller:MedTraitantDataCtrl
* @description
* MedTraitantDataCtrl
* Controller of last scan data component.
* ***********************************************/

var MedTraitantDataCtrl = function(UserUtils, $filter) {
  var ctrl = this;

  function init() {
    ctrl.medTraitants = null
    // Get medecin traitant
    UserUtils.getUsersForPatient(ctrl.patient.si_id).then(function(users) {
      var medTraitants = _.filter(users, function(user) {
          return ((user.is_active) && (user.group.is_med_traitant));
        });
      if (medTraitants.length > 0) {
        ctrl.medTraitants = _.map(medTraitants, function(medTraitant) {
          var addressTextFull = "";
          var address_data = medTraitant.user_profile.data;
          if (address_data && Object.keys(address_data).length) {
            addressTextFull += address_data.address + '\n';
            addressTextFull += address_data.zip_code + ' ';
            addressTextFull += address_data.town + '\n';
            addressTextFull += address_data.country;
          }
          return { full_name: 'Docteur ' + medTraitant.full_name,
                   addressText: addressTextFull,
                   phone: medTraitant.user_profile.phone
          }
        });
        ctrl.medTraitantsNames = _.map(ctrl.medTraitants, 'full_name').join(', ');
      }
    });
  }
  init();
};
MedTraitantDataCtrl.$inject = ["UserUtils", "$filter"];

angular.module('mhclientApp')
    .component('medTraitantData', {
      templateUrl: 'summary/components/med-traitant/med-traitant-data-component.html',
      controller: MedTraitantDataCtrl,
      bindings: {
        patient: '<'
      },
    });


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:checkPrescModal
* @description
* Modal component which displays the scanned version of a prescription
* **********************************************/

var checkPrescModalCtrl = function(ImageDocument) {
  var ctrl = this;

  function init() {
    ImageDocument.api.get({id: ctrl.prescription.attachedDocument}).$promise.then( function(imageDocument) {
      ctrl.attachedDocument = imageDocument;
    });
  };

  ctrl.close = function() {
    ctrl.closeWindow();
  };

  init();
};
checkPrescModalCtrl.$inject = ["ImageDocument"];

angular.module("mhclientApp").component("checkPrescModal", {
  templateUrl: "pharmaceutical-analysis/components/check-presc-modal/check-presc-modal.html",
  controller: checkPrescModalCtrl,
  bindings: {
    prescription: "<",
    closeWindow: "&",
  },
});


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:commentModal
* @description
* Modal component which allows you to fill in a comment
* **********************************************/

var commentModalCtrl = function($filter, PharmaAnalysisUtils) {
  var ctrl = this;

  ctrl.problemList = PharmaAnalysisUtils.commentProblemList
  ctrl.interventionList = PharmaAnalysisUtils.commentInterventionList

  ctrl.cancel = function() {
    ctrl.dismiss();
  };

  ctrl.delete = function(){
    ctrl.close(null);

  }
  ctrl.save = function() {
    // add problem and intervention text
    ctrl.comment.problemText = $filter("translate")(ctrl.comment.problem) || "";
    ctrl.comment.interventionText = $filter("translate")(ctrl.comment.intervention) || "";
    ctrl.close({comment: ctrl.comment});
  };

};
commentModalCtrl.$inject = ["$filter", "PharmaAnalysisUtils"];

angular.module("mhclientApp").component("commentModal", {
  templateUrl: "pharmaceutical-analysis/components/comment-modal/comment-modal.html",
  controller: commentModalCtrl,
  bindings: {
    close: "&",
    dismiss: "&",
    comment: "<",
    mandatoryData: "<",
    readOnly: "<",
  },
});


'use strict';

/* ****************************************************************************************************
* @ngdoc function
* @name mhclientApp.component:DisplayPrescAndOrdo
* @description
* Modal component which displays the scanned version and the electronic version of a prescription
* *****************************************************************************************************/


angular.module("mhclientApp").component("displayPrescAndOrdo", {
  templateUrl: "pharmaceutical-analysis/components/display-presc-and-ordo/display-presc-and-ordo.html",
  bindings: {
    attachedDocument: "<",
    prescription: "<",
  },
});

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:doctorDialogList
* @description
* Modal component which displays a modal dialog with the doctor and pharmacist dialog list
* **********************************************/

var DoctorDialogListModalCtrl = function($uibModal, $q, $filter, Thread, FeedUtils, WorkReport, WorkReportsUtils) {
  var ctrl = this;

  function init() {
  };
  function init() {
    ctrl.currentAction = null;
    ctrl.loading = true;
    var promises = [
      FeedUtils.getFeeds({view: "mess_pharma_doctor"}, false),
      FeedUtils.getFeeds({view: "mess_pharma_preparer"}, false),
    ];

    $q.all(promises).then( function(results) {
      ctrl.medFeed = results[0];
      ctrl.preparerFeed = results[1];

      ctrl.medExtraOptions = WorkReportsUtils.extraOptions[ctrl.medFeed.view] || [];
      ctrl.preparerExtraOptions = WorkReportsUtils.extraOptions[ctrl.preparerFeed.view] || [];

      var showMedTab = ctrl.medFeed.readable_by.indexOf(ctrl.user.group.id) !== -1 ||
        ctrl.medFeed.writable_by.indexOf(ctrl.user.group.id) !== -1;
      var showPreparerTab = ctrl.preparerFeed.readable_by.indexOf(ctrl.user.group.id) !== -1 ||
        ctrl.preparerFeed.writable_by.indexOf(ctrl.user.group.id) !== -1;

      ctrl.canWriteMessage = ctrl.medFeed.writable_by.indexOf(ctrl.user.group.id) !== -1 ||
        ctrl.preparerFeed.writable_by.indexOf(ctrl.user.group.id) !== -1;

      ctrl.actions = [
        {
          name: "DOCTOR",
          directive: "doctor",
          show: showMedTab,
          feed: ctrl.medFeed,
        },
        {
          name: ctrl.isPharmacist ? "PREPARER" : "PHARMACIST",
          directive: "preparer",
          show: showPreparerTab,
          feed: ctrl.preparerFeed,
        },
      ];

      var dataPromises = [];
      if (showMedTab) {
        dataPromises.push(WorkReport.query(_.assign({feed: ctrl.medFeed.id}, {stay: ctrl.stay.id})).$promise);
      }
      if (showPreparerTab) {
        dataPromises.push(WorkReport.query(_.assign({feed: ctrl.preparerFeed.id}, {stay: ctrl.stay.id})).$promise);
      }

      $q.all(dataPromises).then( function(data) {
        var index = 0;
        if (showMedTab) {
          ctrl.medMessages = ctrl.sortReports(data[0]);
          index += 1;
        }
        if (showPreparerTab) {
          ctrl.preparerMessages = ctrl.sortReports(data[index]);
        }

        ctrl.changeAction();
      });
    });

  };

  /* *************** Modal Dialog buttons actions ********************* */
  ctrl.close = function() {
    ctrl.dismiss();
  };
  ctrl.changeAction = function(action) {
    if (action !== ctrl.currentAction) {
      ctrl.getCurrentAction(action);
    }
  };
  ctrl.getCurrentAction = function(action) {
    var length = ctrl.actions.length;
    if (length > 1 || ctrl.currentAction == null) {
      ctrl.loading = true;
      if (action != null) {
        var index = _.indexOf(ctrl.actions, action);
      } else {
        var index = (ctrl.currentAction ? _.indexOf(ctrl.actions, ctrl.currentAction) + 1:
                      0) % length;
      }
      ctrl.currentAction = ctrl.actions[index];
      ctrl.loading = false;
    }
  };

  /* ******************** SORT REPORTS BY DATE ************************ */
  ctrl.sortReports = function(reports) {
    return $filter('orderBy')(reports, "-timestamp");
  };

  ctrl.addNewMessage = function() {
    var dialog = $uibModal.open({
      animation: true,
      size: "lg",
      backdrop: false,
      template: '<doctor-dialog-modal dismiss="$dismiss()" close="$close(newReport)"' +
      ' stay="$ctrl.stay" platform="$ctrl.platform" user="$ctrl.user" default-recipient="$ctrl.recipient"' +
      '</doctor-dialog-modal>',
      controller: function() {
        this.stay = ctrl.stay;
        this.platform = ctrl.platform;
        this.user = ctrl.user;
        this.recipient = ctrl.currentAction.feed.view;
      },
      controllerAs: '$ctrl',
    });

    dialog.result.then( function(newReport) {
      Thread.api.save(newReport).$promise.then( function(report) {
        if (report.first_message.category === "mess_pharma_doctor") {
          ctrl.medMessages.push(report);
          ctrl.medMessages = ctrl.sortReports(ctrl.medMessages);
        } else {

          ctrl.preparerMessages.push(report);
          ctrl.preparerMessages = ctrl.sortReports(ctrl.preparerMessages);
        }
      });
    });
  };

  init();
};
DoctorDialogListModalCtrl.$inject = ["$uibModal", "$q", "$filter", "Thread", "FeedUtils", "WorkReport", "WorkReportsUtils"];

angular.module("mhclientApp").component("doctorDialogListModal", {
  templateUrl: "pharmaceutical-analysis/components/doctor-dialog-list-modal/doctor-dialog-list-modal.html",
  controller: DoctorDialogListModalCtrl,
  bindings: {
    stay: "<",
    platform: "<",
    user: "<",
    isPharmacist: "<",
    dismiss: "&",
  },
});


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:doctorDialogModal
* @description
* Modal component which displays the doctor dialog modal
* **********************************************/

var DoctorDialogModalCtrl = function($q, FeedUtils, WorkReportsUtils, PharmaAnalysisUtils) {
  var ctrl = this;
  ctrl.feedList = [];
  ctrl.loaded = false;
  ctrl.messageTypeList = PharmaAnalysisUtils.messageTypeList;

  function init() {
    var subject = ctrl.prescription != null ? ctrl.prescription.data.name : "";
    var promises = [
      FeedUtils.getFeeds({view: ctrl.messageTypeList.doctor}, false),
      FeedUtils.getFeeds({view: ctrl.messageTypeList.preparer}, false),
    ];
    $q.all(promises).then( function(feeds) {
      ctrl.feedList = feeds;
      ctrl.newReport = {
        stay: ctrl.stay.id,
        first_message: {
          category: ctrl.defaultRecipient,
          stay: ctrl.stay.id,
          priority: 0,
          data: {},
          content: {data: [], subject: subject},
          timestamp: new Date().toISOString(),
          from_platform: ctrl.platform,
        },
      };
      ctrl.feedChanged();
      ctrl.loaded = true;
    });

  };

  ctrl.save = function() {
    ctrl.close({newReport: ctrl.newReport});
  };

  ctrl.feedChanged = function() {
    var feed = _.find(ctrl.feedList, {view: ctrl.newReport.first_message.category});
    ctrl.newReport.feed = feed.id;
    ctrl.availableCreation = WorkReportsUtils.availableCreation[feed.view] || [{value: "NEW_WORK_REPORT"}];
    ctrl.extraOptions = WorkReportsUtils.extraOptions[feed.view] || [];
  };

  init();
};
DoctorDialogModalCtrl.$inject = ["$q", "FeedUtils", "WorkReportsUtils", "PharmaAnalysisUtils"];

angular.module("mhclientApp").component("doctorDialogModal", {
  templateUrl: "pharmaceutical-analysis/components/doctor-dialog-modal/doctor-dialog-modal.html",
  controller: DoctorDialogModalCtrl,
  bindings: {
    stay: "<",
    platform: "<",
    user: "<",
    prescription: "<",
    close: "&",
    dismiss: "&",
    defaultRecipient: "<",
  },
});

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:medicalHistoryModal
* @description
* Modal component which displays patient medical data
* **********************************************/

var MedicalHistoryModalCtrl = function($q, FeedUtils) {
  var ctrl = this;

  function init() {
    ctrl.currentAction = null;
    ctrl.isInitialized = false;
    ctrl.loading = true;
    FeedUtils.getFeedsByName("MHC_OBSERVATION").then( function(feeds) {
      var obsFeed = feeds[0];
      var showObsTab = obsFeed.readable_by.indexOf(ctrl.user.group.id) !== -1 ||
        obsFeed.writable_by.indexOf(ctrl.user.group.id) !== -1;
      ctrl.actions = [
        {
          name: "MEDICAL_INFO",
          directive: "medical_info",
          show: true,
        },
        {
          name: "MEDICAL_OBSERVATION",
          directive: "observations",
          show: showObsTab,
          feed: obsFeed,
        },
        {
          name: "ADMINISTRATION_PLAN",
          directive: "administration",
          show: true,
        },
        {
          name: "TRANSMISSIONS",
          directive: "transmission-list",
          show: true,

        },
      ];

      ctrl.changeAction();
      ctrl.isInitialized = true;
    });

  };

  ctrl.close = function() {
    ctrl.dismiss();
  };
  ctrl.changeAction = function(action) {
    if (action !== ctrl.currentAction) {
      ctrl.getCurrentAction(action);
    }
  };
  ctrl.getCurrentAction = function(action) {
    var length = ctrl.actions.length;
    if (length > 1 || ctrl.currentAction == null) {
      ctrl.loading = true;
      if (action != null) {
        var index = _.indexOf(ctrl.actions, action);
      } else {
        var index = (ctrl.currentAction ? _.indexOf(ctrl.actions, ctrl.currentAction) + 1:
                      0) % length;
      }
      ctrl.currentAction = ctrl.actions[index];
      ctrl.loading = false;
    }
  };

  init();
};
MedicalHistoryModalCtrl.$inject = ["$q", "FeedUtils"];

angular.module("mhclientApp").component("medicalHistoryModal", {
  templateUrl: "pharmaceutical-analysis/components/medical-history-modal/medical-history-modal.html",
  controller: MedicalHistoryModalCtrl,
  bindings: {
    patient: "<",
    stay: "<",
    platform: "<",
    user: "<",
    dismiss: "&",
  },
});


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:PharmaceuticalAnalysis
* @description
* Component which displays the Pharmaceutical analysis
* **********************************************/

var PharmaceuticalAnalysisCtrl = function(Prescription,
    Ordonnance,
    PharmaDelivery,
    PharmaValidation,
    PharmaAnalysisUtils,
    PrescUtils,
    FeedUtils,
    $q,
    $filter,
    orderByFilter,
    $uibModal,
    notify) {

  var ctrl = this;
  ctrl.initialized= false;
  ctrl.predicateValues = [];
  ctrl.searchText = "";
  ctrl.notValidPrescList = [];
  ctrl.allIsValid = true;
  ctrl.busy = false;

  /* ****** INIT DATA ************** */
  var init = function() {
    // TODO add a test on the permissions of the pharmacist and/or preparer user
    // to determine which lists of prescriptions are displayed.
    ctrl.isPharmacist = ctrl.user.group.features.indexOf("PHARMA-VALIDATION-PHARMACIST") !== -1;
    ctrl.isPreparer = ctrl.user.group.features.indexOf("PHARMA-DELIVERY-PREPARER") !== -1;
    ctrl.canModifyPharmaValidation = ctrl.isPharmacist || ctrl.isPreparer;
    ctrl.busy = true;

    ctrl.validatedCollapsed = true;
    ctrl.toBeValidatedCollapsed = false;

    var params = { current_prescriptions: true, exclude_discharge_prescs: true, stay: ctrl.stay.id};
    var promises = [
      PrescUtils.getCategories().promise,
      Prescription.query(params).$promise,
      Ordonnance.query({stay: ctrl.stay.id, state: "ACTIVE"}).$promise,
      PharmaValidation.query({stay: ctrl.stay.id}).$promise,
      PharmaDelivery.query({stay: ctrl.stay.id}).$promise,
      FeedUtils.getFeeds({view: PharmaAnalysisUtils.messageTypeList.doctor}, false),
      FeedUtils.getFeeds({view: PharmaAnalysisUtils.messageTypeList.preparer}, false),

    ];

    $q.all(promises).then( function(data) {
      ctrl.entity = ctrl.stay.entity ? ctrl.stay.entity : ctrl.user.entity;
      ctrl.reports = [];
      var ordonnances = {};
      var pharmaValidationList = data[3];
      var pharmaDeliveryList = data[4];
      var prescCategories = data[0];
      ctrl.prescriptions = data[1];
      ctrl.messDoctorFeed = data[5];
      ctrl.messPreparerFeed = data[6];

      // Pharmacist - doctor dialog stuff
      ctrl.canWriteMess = ctrl.messDoctorFeed.writable_by.indexOf(ctrl.user.group.id) !== -1 ||
        ctrl.messPreparerFeed.writable_by.indexOf(ctrl.user.group.id) !== -1;

      ctrl.canSeeMess = ctrl.messDoctorFeed.readable_by.indexOf(ctrl.user.group.id) !== -1 ||
        ctrl.messPreparerFeed.readable_by.indexOf(ctrl.user.group.id) !== -1 ||
        ctrl.canWriteMess;

      // get attached document associated with un ordonnance
      for (var i=0, length=data[2].length; i<length; i++) {
        var ordonnance = data[2][i];
        ordonnances[ordonnance.id] = {
          attachedDocument: ordonnance.attached_document,
          author: ordonnance.author.full_name,
          createdDate: ordonnance.timestamp,
        };
      }

      // Add some informations ( category, attachement document)
      for (var i=0, length = ctrl.prescriptions.length; i< length; i++) {
        var presc = ctrl.prescriptions[i];
        presc.category = _.find(prescCategories, {id: presc.category});
        presc.attachedDocument = ordonnances[presc.ordonnance] ? ordonnances[presc.ordonnance].attachedDocument: null;
        presc.author = ordonnances[presc.ordonnance] ? ordonnances[presc.ordonnance].author: "";
        presc.createdDate = ordonnances[presc.ordonnance] ? ordonnances[presc.ordonnance].createdDate: "";
        presc.validationData = _.find(pharmaValidationList, {prescription: presc.id}) || PharmaAnalysisUtils.createValidationData(presc)
        presc.deliveryData = _.find(pharmaDeliveryList, {prescription: presc.id}) || PharmaAnalysisUtils.createDeliveryData(presc, ctrl.stay.id)

      }

      // keep only prescriptions of the categories that are dispensable
      ctrl.prescriptions = _.filter(ctrl.prescriptions, "category.dispensable")
      ctrl.computePrescriptions();

      ctrl.initialized = true;
      ctrl.busy = false;
    });

  };

  /* **************************************************************** */
  /*                        TREATMENT FONCTIONS                       */
  /* **************************************************************** */

  /* ********************  FILTER AND CLASSIFY PRESCRIPTIONS *********** */
  ctrl.computePrescriptions = function() {
    var prescListByType = PharmaAnalysisUtils.computePrescriptions(ctrl.prescriptions, ctrl.isPharmacist, ctrl.isPreparer);

    // create an array of all validated prescriptions that can be displayed

    ctrl.validatedPrescList = prescListByType[0];
    // create an array of validated prescriptions to display
    ctrl.displayedValidatedPrescList = prescListByType[1];
    // create an array of all to be validated prescriptions that can be displayed
    ctrl.toBeValidatedPrescList = prescListByType[2];
    // create an array of to be validated prescriptions to display
    ctrl.displayedToBeValidatedPrescList = prescListByType[3];

  };

  /* **************************************************************** */
  /*                   TOOLBAR BUTTONS TREATMENTS                     */
  /* **************************************************************** */

  ctrl.analysePrescription = function() {

    var dirtySubstitutions = _.filter(_.filter(_.reject(ctrl.prescriptions, {state: "STOPPED"}), "pharmaValidationForm.$dirty"), function(prescription){
        return (prescription.validationData.pharmacist_status == "substituted" ||
        (prescription.validationData.preparer_status == "substituted" && prescription.validationData.pharmacist_status == "validated"))}
    )

    return $uibModal.open({
      animation  : true,
      component: 'medicaldbCheckModal',
      windowClass: 'modal-fullscreen',
      resolve: {
          stayId: function(){return ctrl.stay.id},
          patientId: function(){return ctrl.patient.id},
          substitutions: function(){ return _.map(dirtySubstitutions, function(prescription){ return _.join([prescription.id].concat(_.map(prescription.deliveryData.products, "bdmData.cip")), ',')})},
          prescriptions: function() { return _.reject(ctrl.prescriptions, {state: "STOPPED"})}
      }
    })
  };


  /* ******************* SAVE PHARMACEUTICAL ANALYSIS DATA  *********** */

  var saveManyWhitRecover = function(dirtyDeliveries) {
    PharmaDelivery.saveMany(_.reject(dirtyDeliveries, "id")).$promise.then( function(newDeliveries) {
      $q.all(_.map(_.filter(dirtyDeliveries, "id"), function(deliveryData){ return PharmaDelivery.update(deliveryData).$promise})).then (function(updatedDeliveries){
        _.forEach(_.concat(newDeliveries, updatedDeliveries), function(delivery){ _.find(ctrl.prescriptions, {id: delivery.prescription}).deliveryData = delivery})
        notify({classes: ['alert-succes'], message: $filter('translate')("DATA_SAVED")});
        ctrl.prescriptions = _.cloneDeep(ctrl.prescriptions)  // to avoid problems whit ng-form
        ctrl.pharmaAnalysisForm.$setPristine()
        ctrl.computePrescriptions();
        ctrl.busy = false;
      })
    }, function(error) {
      if (error.status == 400) { // handle race condition with collection plan creation
        PharmaDelivery.query({stay: ctrl.stay.id}).$promise.then (function (pharmaDeliveries) {
          var found = false
          _.forEach(_.reject(dirtyDeliveries, "id"), function(newDelivery){
            var delivery = _.find(pharmaDeliveries, {prescription: newDelivery.prescription})
            if (delivery) {found = true; newDelivery.id = delivery.id}
            return
          })
          if (found) {saveManyWhitRecover(dirtyDeliveries)}
        })
      }
    }
    )
  }

  ctrl.validatePrescriptions = function() {

    ctrl.busy = true;
    var dirtyValidations = _.map(_.filter(ctrl.prescriptions, "pharmaValidationForm.$dirty"), "validationData")
    var dirtyDeliveries = _.map(_.filter(ctrl.prescriptions, "pharmaDeliveryForm.$dirty"), "deliveryData")
    PharmaValidation.saveMany(_.reject(dirtyValidations, "id")).$promise.then( function(newValidations) {
      $q.all(_.map(_.filter(dirtyValidations, "id"), function(validationData){ return PharmaValidation.update(validationData).$promise})).then (function(updatedValidations){
        _.forEach(_.concat(updatedValidations, newValidations), function(validation){ _.find(ctrl.prescriptions, {id: validation.prescription}).validationData = validation})
        saveManyWhitRecover(dirtyDeliveries)
      })
    })
  };


  /* ****************** PRE VALIDATE ALL PRESCRIPTIONS ******************************************/
  ctrl.validateAllPresc = function() {
    // TODO 10 set dirty??
    var datetime = new Date();
    for ( var i=0, length=ctrl.prescriptions.length; i<length; i++) {
      var prescription = ctrl.prescriptions[i];

      if (prescription.state === "STOPPED") { // TODO 10 _.reject
        continue;
      }
      if (prescription.data.type === "cropped" && prescription.deliveryData.products.length == 0) { // TODO 10 _.reject
        continue;
      }
      prescription.pharmaValidationForm.$setDirty()
      // if user has preparer right
      if (prescription.dispensable && ctrl.isPreparer) {
        // if no preparer status is filled and pharmacist did not refused prescription
        if (prescription.validationData.preparer_status === "" &&
            prescription.validationData.pharmacist_status != PharmaAnalysisUtils.statusList.refused) {
          prescription.validationData.preparer_status = PharmaAnalysisUtils.statusList.validated;
          prescription.validationData.preparer = ctrl.user.id;
          prescription.validationData.data.preparerValidation = {
            timestamp: datetime.toISOString(),
            author: ctrl.user.id,
            authorFullname: ctrl.user.full_name,
          };
          // if pharmacist did not fill status
          if (prescription.validationData.data.prescStatus == null) {
            prescription.validationData.data.prescStatus = PharmaAnalysisUtils.statusList.validated;
          }
        }
      }
      // if user has preparer right and no pharmacist status is filled
      if ( ctrl.isPharmacist && prescription.validationData.pharmacist_status === "") {
        prescription.validationData.pharmacist_status = PharmaAnalysisUtils.statusList.validated;
        prescription.validationData.pharmacist = ctrl.user.id;
        prescription.validationData.data.pharmaValidation = {
          timestamp: datetime.toISOString(),
          author: ctrl.user.id,
          authorFullname: ctrl.user.full_name,
        };
        PharmaAnalysisUtils.computeDisplayHtml(prescription);
        prescription.validationData.data.prescStatus = PharmaAnalysisUtils.statusList.validated;
      }
    }
  };

  /* *************** DATA INITIALIZATION ************** */
  init();
};
PharmaceuticalAnalysisCtrl.$inject = ["Prescription", "Ordonnance", "PharmaDelivery", "PharmaValidation", "PharmaAnalysisUtils", "PrescUtils", "FeedUtils", "$q", "$filter", "orderByFilter", "$uibModal", "notify"];


angular.module("mhclientApp").component("pharmaceuticalAnalysis", {
  templateUrl: "pharmaceutical-analysis/components/pharmaceutical-analysis/pharmaceutical-analysis.html",
  controller: PharmaceuticalAnalysisCtrl,
  bindings: {
    patient: "<",
    stay: "<",
    platform: "<",
    user: "<",
  },
});


angular.module('mhclientApp').filter('pharmaPrescriptionGroupFilter', function() {
  return function(prescriptionGroups, query, stoppedPolicy) {
    var regex;
    var checkPrescVisible = function(prescription){
      if (!regex || regex.test(prescription.data.display_text)){
        if (stoppedPolicy){
          if (stoppedPolicy.type == "24" && moment().startOf('day').diff(moment(prescription.expiration_time), 'days') < 1){ return true}
          if (stoppedPolicy.type == "72" && moment().startOf('day').diff(moment(prescription.expiration_time), 'days') < 3){ return true}
          if (stoppedPolicy.type == "ALL") { return true }
        }
        return !(prescription.state == "STOPPED")
      }
      return false
    }

    if (query && query.length >  0) {regex = new RegExp('' + query.replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i');}
    _.forEach(prescriptionGroups, function(prescriptionGroup){
      prescriptionGroup.hidden = !_.some(prescriptionGroup.prescriptions, checkPrescVisible)
    })
    return prescriptionGroups
  };
});

angular.module('mhclientApp').filter('pharmaPrescriptionFilter', function() {
  return function(prescriptions, query, stoppedPolicy) {

    var regex;
    var checkPrescVisible = function(prescription){
      if (!regex || regex.test(prescription.data.display_text)){
        if (stoppedPolicy){
          if (stoppedPolicy.type == "24" && moment().startOf('day').diff(moment(prescription.expiration_time), 'days') < 1){ return true}
          if (stoppedPolicy.type == "72" && moment().startOf('day').diff(moment(prescription.expiration_time), 'days') < 3){ return true}
          if (stoppedPolicy.type == "ALL") { return true }
        }
        return !(prescription.state == "STOPPED")
      }
      return false
    }


    if (query && query.length >  0) {regex = new RegExp('' + query.replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i');}
    _.forEach(prescriptions, function(prescription){ prescription.hidden = !checkPrescVisible(prescription) })
    return prescriptions
  };

});

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:PharmaceuticalAnalysisToolbarCtrl
* @description
* Component which displays the Pharmaceutical analysis toolbar
* **********************************************/

var PharmaceuticalAnalysisToolbarCtrl = function($filter, SiteVarsUtils, PrescUtils, $uibModal, Thread) {
  var ctrl = this;

  var init = function() {
    ctrl.searchText= "";
    initFilters();
  };

  function initFilters() {
    ctrl.orderFilter = {extra: {}}
    ctrl.availableStoppedPolicies = [
      {name: $filter('translate')('All(f)(p)'), type: 'ALL'},
      {name: $filter('translate')("24 h"), type: "24"},
      {name: $filter('translate')("72 h"), type: "72"},
      {name: $filter('translate')('None(f)'), type: "NOTHING"},
    ]

    ctrl.stoppedPolicy = ctrl.stoppedPolicy || ctrl.availableStoppedPolicies[1]

    ctrl.availableFilters = PrescUtils.availableFilters()

    SiteVarsUtils.get("PRESCRIPTION_CURRENT_ORDER").then( function(defaultOrder) {
      if (defaultOrder.value) {
        if (_.find(ctrl.availableFilters, {value: defaultOrder.value.value})) {
          _.remove(ctrl.availableFilters, _.find(ctrl.availableFilters, {value: defaultOrder.value.value}));
        }
        ctrl.availableFilters.push(defaultOrder.value);
        ctrl.orderFilter.main = defaultOrder.value;
      } else {
        ctrl.orderFilter.main = ctrl.availableFilters[0];
      }
    });
  };

  /* **************** CTRL functions ******************** */

  ctrl.searchTextModified = function() {
    ctrl.onSearchTextModified({searchText: ctrl.searchText});
  };

  ctrl.showMessListDialog = function() {
    var dialog = $uibModal.open({
      animation: true,
      size: "lg",
      backdrop: false,
      template: '<doctor-dialog-list-modal dismiss="$dismiss()" is-pharmacist="$ctrl.isPharmacist"' +
      '  stay="$ctrl.stay" platform="$ctrl.platform" user="$ctrl.user">'+
      '</doctor-dialog-list-modal>',
      controller: function() {
        this.stay = ctrl.stay;
        this.platform = ctrl.platform;
        this.user = ctrl.user;
        this.isPharmacist = ctrl.isPharmacist
      },
      controllerAs: '$ctrl',
    });
  };

  ctrl.showMedicalHistory = function() {
    $uibModal.open({
      animation: true,
      size: "lg",
      windowClass: "medical-history-modal",
      backdrop: false,
      template: '<medical-history-modal dismiss="$dismiss()"' +
      '  stay="$ctrl.stay" platform="$ctrl.platform" user="$ctrl.user" patient="patient">'+
      '</medical-history-modal>',
      controller: function() {
        this.stay = ctrl.stay;
        this.platform = ctrl.platform;
        this.user = ctrl.user;
        this.patient = ctrl.patient;
      },
      controllerAs: '$ctrl',
    });
  };

  init();
};
PharmaceuticalAnalysisToolbarCtrl.$inject = ["$filter", "SiteVarsUtils", "PrescUtils", "$uibModal", "Thread"];


angular.module("mhclientApp").component("pharmaceuticalAnalysisToolbar", {
  templateUrl: "pharmaceutical-analysis/components/pharmaceutical-analysis-toolbar/pharma-analysis-toolbar.html",
  controller: PharmaceuticalAnalysisToolbarCtrl,
  bindings: {
    user: "<",
    allPrescsValid: "<",
    stay: "<",
    patient: "<",
    platform: "<",
    canSeeMessages: "<",
    canModifyPharmaValidation: "<",
    orderFilter: "=",
    searchText: "=",
    stoppedPolicy: "=",
    onAnalyse: "&",
    onValidate: "&",
    onValidateAll: "&",
    isPharmacist: "<",
  },
});


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:PrescriptionActions
* @description
* Component which displays the actions buttons container
* **********************************************/

var PrescriptionActionsCtrl = function($uibModal, $q, PharmaAnalysisUtils, Thread) {
  var ctrl = this;

  var init = function() {
    ctrl.oldComment = ctrl.prescription.validationData.data.comment;
    ctrl.olPrescStatus = ctrl.prescription.validationData.data.prescStatus;
    ctrl.pharmacistStatusFilled = ctrl.prescription.validationData.pharmacist_status;
    ctrl.preparerStatusFilled = ctrl.prescription.validationData.preparer_status;
    ctrl.computeStatusButtons();
  };

  /* *************************** PHARMACIST FUNCTIONS ************************ */
  ctrl.pharmacistQuestion = function() {
    var questionModal = ctrl.getQuestionModal(PharmaAnalysisUtils.messageTypeList.doctor);
    questionModal.result.then( function(newReport) {
      Thread.api.save(newReport).$promise.then( function() {
        ctrl.updatePharmacistData(PharmaAnalysisUtils.statusList.question);
      });
    });
  };


  ctrl.pharmacistValidation = function(validated) {
    // prescription is validated by pharmacist
    if (validated) {
      if (!ctrl.checkIfStatusSelected(PharmaAnalysisUtils.statusList.validated, true)) {
        if (ctrl.prescription.data.type === "cropped") {
          $q.when(ctrl.prescription.deliveryData.products.length > 0 ? ctrl.prescription.deliveryData.products : ctrl.getSubstitutionModal().result).then(function(drugs) {
            ctrl.updateProductList(drugs);
            ctrl.updatePharmacistData(PharmaAnalysisUtils.statusList.validated);
          })
        } else{
          ctrl.updatePharmacistData(PharmaAnalysisUtils.statusList.validated);
        }
    }
    } else {
      // if pharmacist remove refused status, the associated comment is also deleted
      if (ctrl.checkIfStatusSelected(PharmaAnalysisUtils.statusList.refused, true)) {
        ctrl.retrieveOldComment();
      } else {
        var commentModal = ctrl.getCommentModal(true);
        commentModal.result.then( function(comment) {
          ctrl.updatePharmacistData(PharmaAnalysisUtils.statusList.refused);
          ctrl.updateComment(comment);
        });
      }

    }
  };

  ctrl.pharmacistSubstitution = function() {
    if (ctrl.checkIfStatusSelected(PharmaAnalysisUtils.statusList.substituted, true)) {
      ctrl.retrieveOldProducts();
    } else {
      ctrl.getSubstitutionModal().result.then(function(drugs) {
        ctrl.updateProductList(drugs);
        ctrl.updatePharmacistData(PharmaAnalysisUtils.statusList.substituted);
      });
    }
  };

  ctrl.updatePharmacistData = function(status) {
    var datetime = new Date();
    // if old status is substitued and user chnage to another status, retrieve old  data
    if (ctrl.prescription.validationData.pharmacist_status === PharmaAnalysisUtils.statusList.substituted) {
      ctrl.retrieveOldProducts();
    } else if (ctrl.prescription.validationData.pharmacist_status === PharmaAnalysisUtils.statusList.refused) {
      ctrl.retrieveOldComment();
    }
    ctrl.prescription.validationData.pharmacist_status = status;
    ctrl.prescription.validationData.pharmacist = ctrl.user.id;
    ctrl.prescription.validationData.data.pharmaValidation = {
      timestamp: datetime.toISOString(),
      author: ctrl.user.id,
      authorFullname: ctrl.user.full_name,
    };
    PharmaAnalysisUtils.computeDisplayHtml(ctrl.prescription);
    ctrl.updatePrescStatus(status, true);
  };


  /* *************************** PREPARER FUNCTIONS ************************ */
  ctrl.preparerQuestion = function() {
    var questionModal = ctrl.getQuestionModal(PharmaAnalysisUtils.messageTypeList.preparer);
    questionModal.result.then( function(newReport) {
      Thread.api.save(newReport).$promise.then( function() {
        ctrl.updatePreparerData(PharmaAnalysisUtils.statusList.question);
      });
    });
  };

  ctrl.preparerValidation = function(validated) {
    if (validated) {
      var prescIsCropped = ctrl.prescription.data.type === "cropped";
      if (!ctrl.checkIfStatusSelected(PharmaAnalysisUtils.statusList.validated, false)) {
        // if prescription type is cropped, user must choose product
        if (prescIsCropped) {
          $q.when(ctrl.prescription.deliveryData.products.length > 0 ? ctrl.prescription.deliveryData.products : ctrl.getSubstitutionModal().result).then(function(drugs) {
            ctrl.CroppedPrescValidation = true;
            ctrl.updateProductList(drugs);
            ctrl.updatePreparerData(PharmaAnalysisUtils.statusList.validated);

          });
        // if prescription type is cropped, remove selected products
        } else {
          ctrl.updatePreparerData(PharmaAnalysisUtils.statusList.validated);
        }
      } else if (ctrl.CroppedPrescValidation) {
        ctrl.CroppedPrescValidation = false;
        ctrl.retrieveOldProducts();
      }
    } else {
      // if preparer remove notToDeliver status, the associated comment is also deleted
      if (!ctrl.checkIfStatusSelected(PharmaAnalysisUtils.statusList.notToDeliver, false)) {
        ctrl.updatePreparerData(PharmaAnalysisUtils.statusList.notToDeliver);
      }
    }
  };

  ctrl.preparerSubstitution = function() {
    if (ctrl.checkIfStatusSelected(PharmaAnalysisUtils.statusList.substituted, false)) {
      ctrl.retrieveOldProducts();
    } else {
      ctrl.getSubstitutionModal().result.then(function(drugs) {
        ctrl.updateProductList(drugs);
        ctrl.updatePreparerData(PharmaAnalysisUtils.statusList.substituted);
      });
    }
  };

  ctrl.updatePreparerData = function(status) {
    var datetime = new Date();
    // if old status is substitued and user chnage to another status, retrieve old  data
    if (ctrl.prescription.validationData.preparer_status === PharmaAnalysisUtils.statusList.substituted) {
      ctrl.retrieveOldProducts();
    }
    ctrl.prescription.validationData.preparer_status = status;
    ctrl.prescription.validationData.preparer = ctrl.user.id;
    ctrl.prescription.validationData.data.preparerValidation = {
      timestamp: datetime.toISOString(),
      author: ctrl.user.id,
      authorFullname: ctrl.user.full_name,
    };
    PharmaAnalysisUtils.computeDisplayHtml(ctrl.prescription);
    ctrl.updatePrescStatus(status, false);
  };


  /* *************************** COMMON FUNCTIONS ************************ */
  ctrl.updatePrescStatus = function(status, isPharmacistStatus) {
    if (isPharmacistStatus || ctrl.prescription.validationData.data.prescStatus == null) { //# TODO 10
      ctrl.prescription.validationData.data.prescStatus = status;
    }
    ctrl.prescription.pharmaValidationForm.$setDirty();
  };

  ctrl.showComment = function(editable) {
    ctrl.getCommentModal(false, !(ctrl.isPharmacist || ctrl.isPreparer) || ctrl.prescription.state == 'STOPPED').result.then( function(comment) {
      ctrl.updateComment(comment);
      ctrl.prescription.pharmaValidationForm.$setDirty();
    });
  };

  ctrl.updateComment = function(comment) {
    var date = new Date().toISOString();
    if (comment) {
      ctrl.prescription.validationData.data.comment = Object.assign(
          {
            author: ctrl.user.id,
            authorFullname: ctrl.user.full_name,
            createdDate: date,
          },
          comment,
          {
            modifiedDate: date, // must be after comment to update modified date if exists
          }
      );
    } else { delete ctrl.prescription.validationData.data.comment}
    PharmaAnalysisUtils.computeDisplayHtml(ctrl.prescription);
  };

  // check if user want to unselect a status new status === actual status
  ctrl.checkIfStatusSelected = function(newStatus, isPharmacistData) {
    if (isPharmacistData) {
      if (newStatus !== ctrl.prescription.validationData.pharmacist_status) {
        return false;
      }
      ctrl.prescription.validationData.pharmacist_status = '';
      ctrl.prescription.validationData.pharmacist = null;
      ctrl.prescription.validationData.data.pharmaValidation = null;
      ctrl.prescription.validationData.data.prescStatus = ctrl.olPrescStatus;
      ctrl.prescription.validationData.data.displayHtml = PharmaAnalysisUtils.computeDisplayHtml(ctrl.prescription);
    } else {
      if (newStatus !== ctrl.prescription.validationData.preparer_status) {
        return false;
      }
      ctrl.prescription.validationData.preparer_status = '';
      ctrl.prescription.validationData.preparer = null;
      ctrl.prescription.validationData.data.preparerValidation = null;
      ctrl.prescription.validationData.data.prescStatus = ctrl.olPrescStatus;
    }

    ctrl.prescription.pharmaValidationForm.$setDirty();
    return true;
  };

  // create the comment modal window
  ctrl.getCommentModal = function(dataMandatory, disabled) {
    return $uibModal.open({
      animation: true,
      size: "lg",
      backdrop: false,
      template: '<comment-modal dismiss="$dismiss()" close="$close(comment)"' +
      ' comment="$ctrl.comment" mandatory-data="$ctrl.dataMandatory" read-only="$ctrl.readOnly">'+
      '</comment-modal>',
      controller: function() {

        this.comment = _.cloneDeep(ctrl.prescription.validationData.data.comment || {});

        this.dataMandatory = dataMandatory;
        // TODO Alexis readonly is true if user has not pharmacist right
        this.readOnly = disabled || !(ctrl.isPreparer || ctrl.isPharmacist) || (this.comment.author != null && this.comment.author != ctrl.user.id);
      },
      controllerAs: '$ctrl',
    }
    );
  };

  // create the substitution modal window
  ctrl.getSubstitutionModal = function(dirty) {
    return $uibModal.open({
      animation: true,
      size: "lg",
      backdrop: false,
      template: '<substitution-modal dismiss="$dismiss()" close="$close(drugs)"' +
      ' prescription="$ctrl.prescription" is-dirty="$ctrl.isDirty" entity="$ctrl.entity" platform="$ctrl.platform">'+
      '</substitution-modal>',
      controller: function() {
        this.prescription = ctrl.prescription;
        this.entity = ctrl.entity;
        this.platform = ctrl.platform;
        this.isDirty = dirty;
      },
      controllerAs: '$ctrl',
    }
    );
  };

  // create the doctor dialog modal window
  ctrl.getQuestionModal = function(recipient) {
    return $uibModal.open({
      animation: true,
      size: "lg",
      backdrop: false,
      template: '<doctor-dialog-modal dismiss="$dismiss()" close="$close(newReport)"' +
      ' default-recipient="$ctrl.recipient"' +
      '  stay="$ctrl.stay" platform="$ctrl.platform" user="$ctrl.user" prescription="$ctrl.prescription">'+
      '</doctor-dialog-modal>',
      controller: function() {
        this.stay = ctrl.stay;
        this.platform = ctrl.platform;
        this.user = ctrl.user;
        this.prescription = ctrl.prescription;
        this.recipient = recipient;
      },
      controllerAs: '$ctrl',
    }
    );
  };


  ctrl.updateProductList = function(drugs) {
    var date = new Date();
    ctrl.prescription.deliveryData.history.push({
      date: date.toISOString(),
      products: ctrl.prescription.deliveryData.products.slice(),
    });
    ctrl.prescription.deliveryData.products = drugs;
  };

  ctrl.computeStatusButtons = function() {
    // buttons are disabled if pharmacist status is already filled or
    // user is not a pharmacist or
    // actions are readonly
    ctrl.pharmaButtonsDisabled = !ctrl.isPharmacist || ctrl.isReadonly;
    // PharmaAnalysisUtils.toBeValidatedAllowedStatus.indexOf(ctrl.pharmacistStatusFilled) === -1 ||


    // buttons are disabled if pharmacist status filled is refused or
    // if preparer status is already filled or
    // if user in not a preparer or
    // if prescription i not dispensable or
    // actions are readonly
    ctrl.preparerButtonsDisabled = !ctrl.isPreparer ||
    !ctrl.prescription.dispensable ||
    ctrl.pharmacistStatusFilled === PharmaAnalysisUtils.statusList.refused ||
    ctrl.isReadonly;
    // PharmaAnalysisUtils.toBeValidatedAllowedStatus.indexOf(ctrl.preparerStatusFilled) === -1 ||

  };

  ctrl.retrieveOldProducts = function() {
    var oldData = ctrl.prescription.deliveryData.history.pop();
    if (oldData) ctrl.prescription.deliveryData.products = oldData.products;
  };

  ctrl.retrieveOldComment = function() {
    ctrl.prescription.validationData.data.comment = ctrl.oldComment;
  };

  init();
};
PrescriptionActionsCtrl.$inject = ["$uibModal", "$q", "PharmaAnalysisUtils", "Thread"];

angular.module("mhclientApp").component("prescriptionActions", {
  templateUrl: "pharmaceutical-analysis/components/prescription-actions/prescription-actions.html",
  controller: PrescriptionActionsCtrl,
  bindings: {
    prescription: "<",
    user: "<",
    entity: "<",
    platform: "<",
    isReadonly: "<",
    isPharmacist: "<",
    isPreparer: "<",
    stay: "<",
    canAskQuestion: "<",
  },
});


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:PrescriptionActionButtons
* @description
* Component which displays the actions buttons which can modify prescription state
* **********************************************/

var PrescriptionActionButtonsCtrl = function(PharmaAnalysisUtils) {
  var ctrl = this;
  ctrl.statusList = PharmaAnalysisUtils.statusList;

  ctrl.validatePresc = function(validated) {
    ctrl.validate({validated: validated});
  };

};
PrescriptionActionButtonsCtrl.$inject = ["PharmaAnalysisUtils"];


angular.module("mhclientApp").component("prescriptionActionButtons", {
  templateUrl: "pharmaceutical-analysis/components/prescription-action-buttons/prescription-action-buttons.html",
  controller: PrescriptionActionButtonsCtrl,
  bindings: {
    title: "<",
    isValidation: "<",
    isDisabled: "<",
    isDispensable: "<",
    status: "<",
    canAskQuestion: "<",
    askQuestion: "&",
    validate: "&",
    substitute: "&",
  },
});


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:PrescriptionDesc
* @description
* Component which displays the description of a prescription
* **********************************************/

var prescriptionDescCtrl = function($uibModal) {
  var ctrl = this;

  ctrl.showOrdonnance = function() {
    $uibModal.open({
      animation: true,
      size: "lg",
      windowClass: "check-presc-modal",
      backdrop: false,
      template: '<check-presc-modal close-window="$dismiss()" prescription="$ctrl.prescription">'+
      '</check-presc-modal>',
      controller: function() {
        this.prescription = ctrl.prescription;
      },
      controllerAs: '$ctrl',
    }
    );
  };
};
prescriptionDescCtrl.$inject = ["$uibModal"];

angular.module("mhclientApp").component("prescriptionDesc", {
  templateUrl: "pharmaceutical-analysis/components/prescription-desc/prescription-desc.html",
  controller: prescriptionDescCtrl,
  bindings: {
    prescription: "<",
    displayInfo: "<",
    searchText: "<",
  },
});


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:PrescriptionList
* @description
* Component which displays the list of all prescription
* **********************************************/
var PrescriptionListCtrl = function($uibModal, PrescUtils, SiteVarsUtils) {
  var ctrl = this;
  SiteVarsUtils.getValue("PHARMA_OUT_CATALOG_WARNING", false).then (function(PHARMA_OUT_CATALOG_WARNING){
    ctrl.pharmaOutCatalogWarning = PHARMA_OUT_CATALOG_WARNING
  })
  ctrl.prescriptionGroupsOrder = PrescUtils.prescriptionGroupsOrder
  ctrl.showHistory = function(presc) {
    $uibModal.open({
      templateUrl: 'medication/views/presc-history_modal.html',
      backdrop: 'static',
      controller: 'PrescriptionHistoryCtrl',
      resolve:
      {
        prescription: function() {
          return presc;
        },
      },
    });
  };
};
PrescriptionListCtrl.$inject = ["$uibModal", "PrescUtils", "SiteVarsUtils"];


angular.module("mhclientApp").component("prescriptionList", {
  templateUrl: "pharmaceutical-analysis/components/prescription-list/prescription-list.html",
  controller: PrescriptionListCtrl,
  bindings: {
    groupedPrescriptions: "<",
    searchText: "<",
    stoppedPolicy: "<",
    displayText: "@",
    nbPresc: "@",
    user: "<",
    entity: "<",
    collapse: "<",
    platform: "<",
    orderFilter: "<",
    isReadonly: "<",
    isPharmacist: "<",
    isPreparer: "<",
    stay: "<",
    canAskQuestion: "<",
  },
});


'use strict';

/* ***************************************************************************************
* @ngdoc function
* @name mhclientApp.component:PrescriptionPosology
* @description
* Component which displays the posology of the prescription
* ****************************************************************************************/

var PrescriptionPosologyCtrl = function($filter, PrescUtils, $uibModal) {
  var ctrl = this;
  var otherUnits = {code: -99, label: $filter("translate")("OTHER_TAKING_UNITS")};

  var init = function() {
    ctrl.units = [];
    ctrl.isValid = null;
    ctrl.displayFrequency = ctrl.product.type != null &&  (ctrl.product.type === "cycled" || ctrl.product.type === "cropped");
    ctrl.setUnitList();
  };

  ctrl.setUnitList = function() {
    ctrl.units.length = 0;
    // sometime code is a string instead of an integer
    ctrl.selectedUnit = ctrl.product.takingUnit ?
                         parseInt(ctrl.product.takingUnit.code, 10): null;
    if (ctrl.product.bdmData && ctrl.product.bdmData.taking_units) {
      ctrl.units = ctrl.product.bdmData.taking_units.slice();
    }
    // test if selected unit is not in unit list
    if (ctrl.selectedUnit !== null && _.find(ctrl.units, {code: ctrl.selectedUnit}) === undefined) {
      ctrl.units.push(ctrl.product.takingUnit);
    }
    ctrl.units.push(otherUnits);
  };

  ctrl.changeSelectedUnit = function() {
    if (ctrl.selectedUnit != -99) {
      ctrl.product.takingUnit = _.find(ctrl.units, function(unit) {
        return unit.code == ctrl.selectedUnit;
      });
      ctrl.setUnitList();
      return;
    }
    var modal = $uibModal.open({
      templateUrl: 'core/views/modal-selection-template.html',
      backdrop: 'static',
      controller: 'ModalSelectionCtrl',
      resolve:
      {
        label: function() {
          return "TAKING_UNIT_SELECTION";
        },
        choices: function() {
          return PrescUtils.taking_units;
        },
        lookUpField: function() {
          return "label";
        },
      },
    });
    modal.result.then( function(takingUnit) {
      if (takingUnit) {
        ctrl.product.takingUnit = takingUnit;
      }
      ctrl.setUnitList();
    });
  };

  init();
};
PrescriptionPosologyCtrl.$inject = ["$filter", "PrescUtils", "$uibModal"];


angular.module("mhclientApp").component("prescriptionPosology", {
  templateUrl: "pharmaceutical-analysis/components/prescription-posology/prescription-posology.html",
  controller: PrescriptionPosologyCtrl,
  bindings: {
    product: "<",
    isReadonly: "<",
    prescription: "<",  // quantity will be required only if delivery form dirty, it allow handle when PAP_TEMPLATES has not data for initial delivery
  },
});


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:substitutionModal
* @description
* Modal component which allows you to choose drugs for substitution
* **********************************************/

var substitutionModalCtrl = function($uibModal, $rootScope, $filter, MedicalDbUtils, MonographyModal) {
  var ctrl = this;

  var init = function() {
    if (ctrl.prescription.deliveryData.history.length > 0) {
      // if history is not empty, products were already been substitued
      ctrl.drugs = ctrl.prescription.deliveryData.products.slice();
    } else {
      ctrl.drugs = [];
    }
  };

  ctrl.cancel = function() {
    ctrl.dismiss();
  };

  ctrl.save = function() {
    // add problem and intervention text
    ctrl.close({drugs: ctrl.drugs});
  };

  ctrl.removeDrug = function(drug) {
    var index = ctrl.drugs.indexOf(drug);
    if (index !== -1) {
      ctrl.drugs.splice(index, 1);
      ctrl.isDirty = true;
    }
  };

  ctrl.showMonography = MonographyModal.showMonography

  ctrl.searchDrug = function() {
    var modal = $uibModal.open({
      backdrop: 'static',
      windowClass: 'modal-fullscreen',
      template: '<drug-select-modal  close="$close(result)"' +
      ' structured="$ctrl.structured" sector="$ctrl.sector" query="$ctrl.query" entity="$ctrl.entity" presc-image="$ctrl.prescImage"' +
      ' on-show-monography="$ctrl.showMonography(cip)" presc-text="$ctrl.prescText">'+
      '</drug-select-modal>',
      controllerAs: '$ctrl',
      controller: function() {
        this.structured = true;
        this.query = "";
        this.entity = ctrl.entity;
        this.sector = $rootScope.currentStay ? $rootScope.currentStay.sector : null;
        this.showMonography = ctrl.showMonography;
        this.prescText = ctrl.prescription.display_html;
        this.prescImage = ctrl.prescription.image;
      },
    });
    modal.result.then(function(result) {
      if (result) {
        var bdmData = MedicalDbUtils.mapDrugToPrescriptionBdmData(
          result.drug
        )
        var drug = {
          posology_data: {
            category_name: ctrl.prescription.category.name,
            type: ctrl.prescription.data.type,
            takes: ctrl.prescription.data.takes,
            interval: ctrl.prescription.data.interval,
            interval_quantity: ctrl.prescription.data.interval_quantity,
            quantity_by_timeslot: ctrl.prescription.data.quantity_by_timeslot,
            frequency_unit: ctrl.prescription.data.frequency_unit,
            week_days: ctrl.prescription.data.week_days,
            frequency: ctrl.prescription.data.frequency,
            only_if: ctrl.prescription.data.only_if,
            debit_unit: ctrl.prescription.data.debit_unit,
            quantityByDay: (ctrl.prescription.data.daily_quantity * (ctrl.prescription.data.frequency_unit == "weeks" ? (ctrl.prescription.data.week_days || []).length / 7 : 1) / ctrl.prescription.data.frequency) ||  undefined,
            debit_interval: ctrl.prescription.data.debit_interval,
          },
          startDate: ctrl.prescription.start_date,
          endDate: ctrl.prescription.end_date,
          duration: ctrl.prescription.duration,
          name: result.name,
          type: ctrl.prescription.data.type,
          route: result.route,
          bdmData: bdmData,
          dciMode: result.isDci,
          endMode: ctrl.prescription.data.end_mode,
          template: ctrl.prescription.data.template,
          takingUnit: result.takingUnit,
          displayText: "",
          frequency: ctrl.prescription.data.frequency,
          frequencyUnit: ctrl.prescription.data.frequency_unit,
          inMDB: result.inMdbDrugs,
          structured: result.structured,
        }
        drug.posology_data.display_frequency = $filter("collectionPlanProductPosology")(drug)
        ctrl.drugs.push(drug);
        ctrl.isDirty = true;
      }

    });

  };

  init();
};
substitutionModalCtrl.$inject = ["$uibModal", "$rootScope", "$filter", "MedicalDbUtils", "MonographyModal"];

angular.module("mhclientApp").component("substitutionModal", {
  templateUrl: "pharmaceutical-analysis/components/substitution-modal/substitution-modal.html",
  controller: substitutionModalCtrl,
  bindings: {
    prescription: "<",
    platform: "<",
    entity: "<",
    isDirty: "<",
    close: "&",
    dismiss: "&",
  },
});

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.service:
* @description
* Pharmaceutical analysis stuff
* ********************************************** */

angular.module("mhclientApp").factory('PharmaAnalysisUtils', ["FeatureUtils", "$filter", "$locale", "PrescUtils", function(FeatureUtils, $filter, $locale, PrescUtils) {

  var utils = {};
  utils.statusList = {
    validated: "validated",
    refused: "refused",
    substituted: "substituted",
    question: "question",
    notToDeliver: "notToDeliver",
  };


  utils.commentProblemList =  [
    {value: "NON_COMPLIANCE"},
    {value: "UNTREATED_INDICATION"},
    {value: "UNDERDOSING"},
    {value: "OVERDOSE"},
    {value: "DRUG_NOT_INDICATED"},
    {value: "TAKEN_INTO_ACCOUNT", group: "INTERACTION"},
    {value: "PRECAUTION", group: "INTERACTION"},
    {value: "NOT_RECOMMENDED", group: "INTERACTION"},
    {value: "CONTRAINDICATED", group: "INTERACTION"},
    {value: "PUBLISHED", group: "INTERACTION"},
    {value: "ADVERSE_EFFECT"},
    {value: "INAPPROPRIATE_ROUTE"},
    {value: "TREATEMENT_NOT_RECEIVED"},
    {value: "MONITORING"},
  ];

  utils.commentInterventionList = [
    "ADD_INTERVENTION",
    "STOP_INTERVENTION",
    "SUBSTITUTION_EXCHANGE",
    "CHOICE_OF_ADMINISTRATION",
    "THERAPEUTIC_FOLLOW_UP",
    "ADMINISTRATION_METHODS",
    "DOSAGE_ADJUSTMENT",
  ];

  utils.messageTypeList = {
    doctor: "mess_pharma_doctor",
    preparer: "mess_pharma_preparer",
  };

  // list of status values for which prescription is not considered as validated
  utils.toBeValidatedAllowedStatus = ["", utils.statusList.question];
  utils.getDeliveryTypeOptions = function() {
    return FeatureUtils.getAllFeatures().then(function(features) {
      var pharmaCollectionValidationFeature;
      var defaultDeliveryTypes;
      pharmaCollectionValidationFeature = _.find(_.filter(features, "active"),
          {"name": "PHARMA-COLLECTION-VALIDATION"});

      defaultDeliveryTypes = [
        {"name": "direct", "label": $filter("translate")("Direct(f)")},
        {"name": "liberal", "label": $filter("translate")("Liberal")},
        {"name": "mixed", "label": $filter("translate")("Mixed")},
      ];
      return pharmaCollectionValidationFeature ?
        pharmaCollectionValidationFeature.metadata.delivery_types || defaultDeliveryTypes :
        [];
    });
  };

  // Filter and classify prescriptions by validation state
  utils.computePrescriptions = function(prescriptions, isPharmacist, isPreparer) {
    return classifyPrescriptions(isPharmacist, isPreparer, prescriptions);
  };

  // Create validation data of a prescription
  utils.createValidationData = function(presc) {
    return {
      prescription: presc.id,
      pharmacist_status: "",
      preparer_status: "",
      data: {},
      pharmacist: null,
      preparer: null,
    };
  };


  // Create delivery data of a prescription
  utils.createDeliveryData = function(presc, stayId) {

    if (presc.data.takes == 'debit'){
        var dailyQuantity = (presc.data.debit_unit * (presc.data.debit_interval == "day" ? 1 : (presc.data.debit_interval == "hour" ? 24 : 24 * 60 ))) ||  undefined
    }
    else{
        var dailyQuantity = (presc.data.daily_quantity * (presc.data.frequency_unit == "weeks" ? (presc.data.week_days || []).length : 1)) ||  undefined
    }
    var deliveryData = {
      prescription: presc.id,
      start_date: presc.start_date,
      end_date: presc.end_date,
      handled_date: null,
      stay: stayId,
      products: presc.data.type == "cropped" ? [] : [{
          posology_data: {
            category_name: presc.category.name,
            type: presc.data.type,
            takes: presc.data.takes,
            interval: presc.data.interval,
            interval_quantity: presc.data.interval_quantity,
            quantity_by_timeslot: presc.data.quantity_by_timeslot,
            frequency_unit: presc.data.frequency_unit,
            frequency: presc.data.frequency,
            week_days: presc.data.week_days,
            only_if: presc.data.only_if,
            debit_unit: presc.data.debit_unit,
            debit_interval: presc.data.debit_interval,
          },
          startDate: presc.start_date,
          endDate: presc.end_date,
          duration: presc.duration,
          name: presc.data.name,
          route: presc.data.route,
          bdmData: presc.data.bdm_data ? _.pick(presc.data.bdm_data, ["taking_units", "is_stupefiant", "catalog_ext_id", "catalog_ucd", "cip"]) : null,
          dciMode: presc.data.dci_mode,
          endMode: presc.data.end_mode,
          type: presc.data.type,
          takingUnit: presc.data.taking_unit,
          dailyQuantity: dailyQuantity,
          frequency: presc.data.frequency,
          frequencyUnit: presc.data.frequency_unit,
          inMDB: presc.data.in_mdb_drugs,
          structured: presc.data.structured,
          originalTakingUnit: presc.data.taking_unit,
        },
      ],
      history: [],
    };
    if (deliveryData.products.length > 0) {
      deliveryData.products[0].posology_data.display_frequency = $filter("collectionPlanProductPosology")(deliveryData.products[0])
    }
    return deliveryData
  };

  // create displayHtml data
  utils.computeDisplayHtml = function(prescription) {
    if (!prescription.validationData.pharmacist_status) {
      prescription.validationData.data.displayHtml = $filter("translate")("Awaiting pharmacist validation");
    } else {

      prescription.validationData.data.displayHtml = '<label class="pharma-control-label">' +
        $filter("translate")("Pharmaceutical control of") + ' ' +
        $filter('date')(prescription.validationData.data.pharmaValidation.timestamp,
            $locale.DATETIME_FORMATS.mhcareMedium) +
        ' ' + $filter("translate")("by") + ' ' +
        prescription.validationData.data.pharmaValidation.authorFullname + '</label>';
      prescription.validationData.data.displayHtml += '<label class="pharma-control-status">';
      switch (prescription.validationData.pharmacist_status) {
        case "validated":
          prescription.validationData.data.displayHtml += $filter("translate")("Pharma_control_ok");
          if (prescription.validationData.preparer_status == 'substituted'){
            prescription.validationData.data.displayHtml += "<br>"+$filter("translate")("Pharma_control_substituted") + ' ' +
              getSubstitutionlabels(prescription.deliveryData);
          }
          break;
        case "question":
          prescription.validationData.data.displayHtml += $filter("translate")("Pharma_control_need_info");
          break;
        case "refused":
          prescription.validationData.data.displayHtml += $filter("translate")("Pharma_control_nok");
          break;
        case "substituted":
          prescription.validationData.data.displayHtml += $filter("translate")("Pharma_control_substituted") + ' ' +
            getSubstitutionlabels(prescription.deliveryData);
          break;
      }

      prescription.validationData.data.displayHtml += '</label>';
      if (prescription.validationData.data.comment && prescription.validationData.data.comment.text) {
        prescription.validationData.data.displayHtml += '<label class="pharma-control-comment">' +
          "<span class='pharma-control-comment-label'>" + $filter("translate")("DELIVERY_COMMENTS") + ": </span>" +
          prescription.validationData.data.comment.text + '</label>';
      }
    }
  };

  /* ********************************* TREATMENT FUNCTIONS  ************************** */

  // Classify prescriptions by validation state
  // presc whose status is equal to "question" are not considered validated
  function classifyPrescriptions(isPharmacist, isPreparer, prescriptions) {
    // is pharmacist
    if (isPharmacist) {
      // some pharmacist can own preparer rights
      if (isPreparer) {
        var validatedPrescList = _.filter(prescriptions, function(presc) {
          return utils.toBeValidatedAllowedStatus.indexOf(presc.validationData.pharmacist_status) === -1 &&
            (utils.toBeValidatedAllowedStatus.indexOf(presc.validationData.preparer_status) === -1 ||
              presc.validationData.pharmacist_status === utils.statusList.refused ||
             !presc.dispensable);
        });
        var toBeValidatedPrescList = _.filter(prescriptions, function(presc) {
          return utils.toBeValidatedAllowedStatus.indexOf(presc.validationData.pharmacist_status) !== -1 ||
           (utils.toBeValidatedAllowedStatus.indexOf(presc.validationData.preparer_status) !== -1 &&
            presc.validationData.pharmacist_status !== utils.statusList.refused &&
            presc.dispensable);
        });
        // has only pharmacist right
      } else {
        var validatedPrescList = _.filter(prescriptions, function(presc) {
          return utils.toBeValidatedAllowedStatus.indexOf(presc.validationData.pharmacist_status) === -1;
        });
        var toBeValidatedPrescList = _.filter(prescriptions, function(presc) {
          return utils.toBeValidatedAllowedStatus.indexOf(presc.validationData.pharmacist_status) !== -1;
        });
      }
    // has only preparer right
    } else {
      var validatedPrescList = _.filter(prescriptions, function(presc) {
        return utils.toBeValidatedAllowedStatus.indexOf(presc.validationData.preparer_status) === -1 ||
          presc.validationData.pharmacist_status === utils.statusList.refused ||
          !presc.dispensable;
      });
      var toBeValidatedPrescList = _.filter(prescriptions, function(presc) {
        return utils.toBeValidatedAllowedStatus.indexOf(presc.validationData.preparer_status) !== -1 &&
          presc.validationData.pharmacist_status !== utils.statusList.refused &&
          presc.dispensable;
      });
    }
    return [validatedPrescList,
      PrescUtils.groupPrescriptions(validatedPrescList),
      toBeValidatedPrescList,
      PrescUtils.groupPrescriptions(toBeValidatedPrescList),
    ];
  };

  function getSubstitutionlabels(pharmaDelivery) {
    var productNames = _.map(pharmaDelivery.products, "name");
    var lastProduct = productNames.pop();
    return productNames.length == 0 ? lastProduct :
                                      productNames.join(", ") + ' ' + $filter("translate")("and") + ' ' + lastProduct;
  };

  return utils;
}]);


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.service:c
* @description
* Pharmaceutical analysis delivery data Api service
* **********************************************/

angular.module("mhclientApp").factory('CollectionPlan', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
  // Set API's version
  var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
  var portailAPI = $resource("/api_rest/collection_plan/:id/:route",
      {
        id: '@id',
        extra: '@extra',
      },
      {
        'get': {
          headers: {'Accept': acceptHeader},
        },
        'query': {
          headers: {'Accept': acceptHeader},
          isArray: true,
        },
        'save': {
          headers: {'Accept': acceptHeader},
          method: 'POST',
        },
        'update': {
          headers: {'Accept': acceptHeader},
          method: 'PUT',
        },
        'remove': {
          headers: {'Accept': acceptHeader},
          method: 'PUT',
          params: {route: 'remove', id: '@id'}
        },
        'getCollectionDeliveries': {
          isArray: true,
          headers: {'Accept': acceptHeader},
          params: {route: 'get_collection_deliveries', id: '@id'}
        },
        'getPharmaDeliveries': {
          isArray: true,
          headers: {'Accept': acceptHeader},
          params: {route: 'get_pharma_deliveries', id: '@id'}
        },
        'getPharmaValidations': {
          isArray: true,
          headers: {'Accept': acceptHeader},
          params: {route: 'get_pharma_validations', id: '@id'}
        },
        'getRelatedStays': {
          isArray: true,
          headers: {'Accept': acceptHeader},
          params: {route: 'get_related_stays', id: '@id'}
        },
        'getRelatedPatients': {
          isArray: true,
          headers: {'Accept': acceptHeader},
          params: {route: 'get_related_patients', id: '@id'}
        },
        'getPrescriptionForPharmaValidation': {
          headers: {'Accept': acceptHeader},
          params: {route: 'get_prescription_for_pharma_validation'}
        }
      }
  );

  switch (MhConfig.platform) {
    case ('mhsi'): {
      return portailAPI;
    }
    case ('mgapp'): {
      var stay = window.mgapp.get('pat_mgr').stay();
      var boxAPI = BoxResource.generate(stay);
      return boxAPI;
    }
    default:
      return portailAPI;
  };

}]);

angular.module("mhclientApp").factory('CollectionPlanDelivery', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
  // Set API's version
  var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
  var portailAPI = $resource("/api_rest/collection_plan_delivery/:id/:route",
      {
        id: '@id',
        extra: '@extra',
      },
      {
        'get': {
          headers: {'Accept': acceptHeader},
        },
        'query': {
          headers: {'Accept': acceptHeader},
          isArray: true,
        }
      }
  );

  switch (MhConfig.platform) {
    case ('mhsi'): {
      return portailAPI;
    }
    case ('mgapp'): {
      var collection_plan_delivery = window.mgapp.get('pharma').collection_plan_delivery();
      var boxAPI = BoxResource.generate(collection_plan_delivery);
      return boxAPI;
    }
    default:
      return portailAPI;
  };

}]);


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.service:c
* @description
* Pharmaceutical analysis delivery data Api service
* **********************************************/

angular.module("mhclientApp").factory('PharmaDelivery', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
  // Set API's version
  var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
  var portailAPI = $resource("/api_rest/pharma_delivery/:id/:route",
      {
        id: '@id',
        extra: '@extra',
      },
      {
        'get': {
          headers: {'Accept': acceptHeader},
        },
        'query': {
          headers: {'Accept': acceptHeader},
          isArray: true,
        },
        'save': {
          headers: {'Accept': acceptHeader},
          method: 'POST',
        },
        'saveMany': {
          headers: {'Accept': acceptHeader},
          method: 'POST',
          isArray: true,
        },
        'update': {
          headers: {'Accept': acceptHeader},
          method: 'PUT',
        },
      }
  );

  switch (MhConfig.platform) {
    case ('mhsi'): {
      return portailAPI;
    }
    case ('mgapp'): {
      var pharma_delivery = window.mgapp.get('pharma').pharma_delivery();
      var boxAPI = BoxResource.generate(pharma_delivery);
      return boxAPI;
    }
    default:
      return portailAPI;
  };

}]);


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.service:
* @description
* Pharmaceutical analysis validation data Api service
* **********************************************/

angular.module("mhclientApp").factory('PharmaValidation', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
  // Set API's version
  var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
  var portailAPI = $resource("/api_rest/pharma_validation/:id/:route",
      {
        id: '@id',
        extra: '@extra',
      },
      {
        'get': {
          headers: {'Accept': acceptHeader},
        },
        'query': {
          headers: {'Accept': acceptHeader},
          isArray: true,
        },
        'save': {
          headers: {'Accept': acceptHeader},
          method: 'POST',
        },
        'saveMany': {
          headers: {'Accept': acceptHeader},
          method: 'POST',
          isArray: true,
        },
        'update': {
          headers: {'Accept': acceptHeader},
          method: 'PUT',
        },
      }
  );

  switch (MhConfig.platform) {
    case ('mhsi'): {
      return portailAPI;
    }
    case ('mgapp'): {
      var pharma = window.mgapp.get('pharma').pharma_validation();
      var boxAPI = BoxResource.generate(pharma);
      return boxAPI;
    }
    default:
      return portailAPI;
  };

}]);


'use strict';

angular.module("mhclientApp").component("prescriptionPharmaValidationDisplay", {
  templateUrl: "pharmaceutical-analysis/prescription/views/prescription-pharma-validation-display.html",
  bindings: {prescription: "<", disableFetch: "<?", onlyLast: "<?"},
  controller: ["$timeout", "PrescUtils", "$q", "SiteVarsUtils", "FeatureUtils", "$filter", function prescriptionPharmaValidationDisplayCtrl(
      $timeout,
      PrescUtils,
      $q,
      SiteVarsUtils,
      FeatureUtils,
      $filter) {
    var ctrl;
    var productNames;
    var lastProduct;
    ctrl = this;
    ctrl.$onChanges = function() {
      ctrl.initDone = false;
      SiteVarsUtils.getValue("WITH_PHARMA_CONTROL", false).then(function(pharmaControlEnabled) {
        SiteVarsUtils.getValue('CLASICAL_DISPENSATION', true).then(function(clasicalDispensation) {
          FeatureUtils.getAllFeatures().then(function(features) {
            $q.when(typeof ctrl.prescription.category == 'number' ? PrescUtils.getCategories(
                {id: ctrl.prescription.category}).promise : ctrl.prescription.category).then( function(category) {
              ctrl.clasicalDispensation = clasicalDispensation;
              if (!!_.find(_.filter(features, "active"), {"name": "PHARMA-COLLECTION-VALIDATION"})) {
                ctrl.dispensationEnabled = false;
                ctrl.pharmaControlEnabled = false;
                if (category.dispensable) {
                  $q.when(ctrl.prescription.pharmaValidation ||
                          (!ctrl.disableFetch && PrescUtils.getPharmaValidation(ctrl.prescription))
                  ).then(function(pharmaValidation) {
                    ctrl.pharmaValidationEnabled = true;
                    if (pharmaValidation) {
                      ctrl.collectionValidatedDeliveries = $filter("orderBy")(
                          (pharmaValidation.pharma_delivery || {})["validated_collections"] || [], "-end_date");
                      if (ctrl.onlyLast) {
                        ctrl.collectionValidatedDeliveries = $filter("limitTo")(ctrl.collectionValidatedDeliveries, 1);
                      }
                    }
                    ctrl.pharmaValidation = pharmaValidation || false;
                    $timeout(function() {
                      ctrl.initDone = true;
                    });
                  });
                } else {
                  ctrl.pharmaValidationEnabled = false;
                  $timeout(function() {
                    ctrl.initDone = true;
                  });
                }
              } else {
                ctrl.pharmaControlEnabled = pharmaControlEnabled &&
                                            ctrl.prescription.dispensable &&
                                            !ctrl.prescription.control.disabled;
                ctrl.pharmaValidationEnabled = false;
                ctrl.dispensationEnabled = true;
                ctrl.dispensations = $filter("orderBy")(ctrl.prescription.dispensations || [], "-timestamp");
                if (ctrl.onlyLast) {
                  ctrl.dispensations = $filter("limitTo")(ctrl.dispensations, 1);
                }
                $timeout(function() {
                  ctrl.initDone = true;
                });
              }
            });
          });
        });
      });
    };

    ctrl.getSubstitutionlabels = function(pharmaDelivery) {
      productNames = _.map(pharmaDelivery.products, "name");
      lastProduct = productNames.pop();
      return productNames.length == 0 ? lastProduct :
                                        productNames.join(", ") + ' ' + $filter("translate")("and") + ' ' + lastProduct;
    };
  }],
});

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:PharmaceuticalAnalysis
* @description
* Component which displays the Pharmaceutical analysis
* **********************************************/


// TODO CHECK end_date
// allPrescsValid on pharma analysys for multi products
// collectionEndDate
// substitution after validation
// clean product.prepared_quantity
// No deliverys found ;)
// nothing to select info
// no stay related?? fix?? not found stay or patients?
// advertisement change  filter losse data
// PharmaDelivery.getMissing

angular.module("mhclientApp").component("collectionDeliveries", {
  templateUrl: "pharmaceutical-analysis/collection-plan/views/collection-deliveries.html",
  bindings: { deliveries: "<", groupByRoute: "=", mode:"<", readOnly: "<", collectionEndDate: "<", collectionStartDate: "<", pharmaOutCatalogWarning: "<"},
  controller: ["$rootScope", "Prescription", "Ordonnance", "Patient", "CollectionPlan", "Sector", "PrescUtils", "$q", "$filter", "$uibModal", function CollectionPlanStaysSelectionCtrl($rootScope, Prescription, Ordonnance, Patient, CollectionPlan, Sector, PrescUtils, $q, $filter, $uibModal) {
    var ctrl, handledDateMore1;
    ctrl = this;
    ctrl.txtQuery = ""
    ctrl.collectionDuration = moment(ctrl.collectionEndDate).diff(moment(ctrl.collectionStartDate), "days") + 1
    ctrl.$onChanges = function(changes) {
      if (changes.deliveries) { ctrl.deliveries = changes.deliveries.currentValue; }
      ctrl.updateDeliveries()
    }
    ctrl.prescDetail = function (planDelivery) {
      $rootScope.busy = true
      CollectionPlan.getPrescriptionForPharmaValidation({prescription: planDelivery.pharma_delivery.prescription}).$promise.then (function(prescription) {
       $rootScope.busy = false; PrescUtils.showHistory(prescription);
      })
    }

    ctrl.getStayDisplay = function (stay){ return [stay.patient.full_name, "/", $filter("translate")("PATIENT_ID"), stay.patient.si_id, "/", $filter("translate")("STAY"), ":", stay.si_id].join(" ") }
    ctrl.deliveriesByStay = function (deliveries) {return _.chain(deliveries).groupBy("pharma_delivery.stay.id").map(function(deliveries, stayId) { return { stay: deliveries[0].pharma_delivery.stay, deliveries: deliveries }}).value()}
    ctrl.prescriptionDuration = function (delivery)  {return delivery.pharma_delivery.end_date ? moment(delivery.pharma_delivery.end_date).diff(moment(delivery.pharma_delivery.start_date), "days") + 1 : "Undefined"}
    ctrl.updateDeliveries = function() {
      _.forEach(ctrl.deliveries, function(delivery) {
        delivery.duration = ("duration" in delivery) ? delivery.duration : (moment(delivery.end_date).diff(delivery.start_date, "days") + 1)
        if (!("missing_days" in delivery)) {
          handledDateMore1 = delivery.pharma_delivery.handled_date ? moment(delivery.pharma_delivery.handled_date).add(1, 'd').format("YYYY-MM-DD") : undefined
          delivery.missing_days = _.max([ 0, moment(delivery.start_date).diff(moment(_.max([handledDateMore1, delivery.pharma_delivery.start_date])), "days")])
        }
        return
      })

      ctrl.limitTo = 3
      var availableDeliveries = $filter("filterDeliveries")(ctrl.deliveries, ctrl.txtQuery)
      ctrl.rejectedDeliveries = $filter("filterDeliveries")(ctrl.deliveries, ctrl.txtQuery, true)
      if (ctrl.groupByRoute){
        ctrl.deliveriesByRoute = _.chain(availableDeliveries)
          .groupBy("products[0].route.label")
          .map(function(deliveries, routeLabel) { return {routeLabel: routeLabel, deliveriesByStay: ctrl.deliveriesByStay(deliveries) } })
          .value()
      }
      else{ ctrl.deliveriesByRoute = [{routeLabel: "__all__", deliveriesByStay: ctrl.deliveriesByStay(availableDeliveries)}]}

    };
  }]


});

angular.module("mhclientApp").component("collectionPlanDetail", {
  templateUrl: "pharmaceutical-analysis/collection-plan/views/collection-plan-detail.html",
  bindings: {collectionId: "<"},
  controller:  ["$rootScope", "$q", "$filter", "$state", "CollectionPlan", "PharmaDelivery", "Stay", "Patient", "Sector", "PrescUtils", "SiteVarsUtils", function CollectionPlanCtrl($rootScope, $q, $filter, $state, CollectionPlan, PharmaDelivery, Stay, Patient, Sector, PrescUtils, SiteVarsUtils) {
    var ctrl, collectionPlan;
    ctrl = this;
    $rootScope.busy = true
    SiteVarsUtils.getValue("PHARMA_OUT_CATALOG_WARNING", false).then (function(PHARMA_OUT_CATALOG_WARNING){
      CollectionPlan.get({id:ctrl.collectionId}).$promise.then (function(collectionPlan){
        CollectionPlan.getCollectionDeliveries({id:ctrl.collectionId}).$promise.then (function(collectionDeliveries){
          CollectionPlan.getPharmaValidations({id:ctrl.collectionId}).$promise.then (function(pharmaValidations){
            CollectionPlan.getPharmaDeliveries({id:ctrl.collectionId}).$promise.then (function(pharmaDeliveries){
              CollectionPlan.getRelatedStays({id:ctrl.collectionId}).$promise.then (function(relatedStays){
                CollectionPlan.getRelatedPatients({id:ctrl.collectionId}).$promise.then (function(relatedPatients){
                  ctrl.pharmaOutCatalogWarning = PHARMA_OUT_CATALOG_WARNING
                  ctrl.collectionPlan = collectionPlan
                  _.forEach(collectionDeliveries, function(delivery) {
                      delivery.pharma_delivery = _.find(pharmaDeliveries, {id:delivery.pharma_delivery})
                      delivery.pharma_validation = _.find(pharmaValidations, {prescription: delivery.pharma_delivery.prescription})
                    })
                  _.forEach(pharmaDeliveries, function(pharmaDelivery) {pharmaDelivery.stay = _.find(relatedStays, {id:pharmaDelivery.stay})})
                  _.forEach(relatedStays, function(stay) {stay.patient = _.find(relatedPatients, {id:stay.patient})})


                  ctrl.collectionPlan.deliveries = collectionDeliveries
                  ctrl.toPdf = '/api_rest/collection_plan/'+ ctrl.collectionId + '/to_pdf'

                  if (ctrl.collectionPlan.state == "PREPARED"){
                    ctrl.mode = $rootScope.checkPermissions('PHARMA-COLLECTION-VALIDATION', 'CAN_WRITE') ? "PREPARATION_VALIDATION" : "PREPARATION"
                    ctrl.readOnly = false
                    if (ctrl.mode == "PREPARATION_VALIDATION"){
                      _.forEach(collectionDeliveries, function(delivery){
                        _.forEach(delivery.products, function(product){
                            if (!("delivered_quantity" in product)){ product.delivered_quantity = product.prepared_quantity }
                          return
                        })
                        return
                      })
                    }
                  }
                  if (ctrl.collectionPlan.state == "VALIDATED"){
                    ctrl.mode = ctrl.collectionPlan.prepared_by ? "PREPARATION_VALIDATION" : "VALIDATION"
                    ctrl.readOnly = true
                  }
                  $rootScope.busy = false
                })
              })
            })
          })
        })
      })
    })

    ctrl.removeCollectionPlan = function () {
      $rootScope.busy = true;
      CollectionPlan.remove({id:ctrl.collectionPlan.id}).$promise.then (function() {$rootScope.busy = false; $state.go("^.collection-plan-list")})
    }

    ctrl.modifyCollectionPlan = function () {

      $rootScope.busy = true
      collectionPlan = _.cloneDeep(ctrl.collectionPlan)
      collectionPlan.data.modify_history = collectionPlan.data.modify_history || []
      collectionPlan.data.modify_history.push({
        by: $rootScope.user.full_name,
        username: $rootScope.user.username,
        timestamp: moment.utc().toISOString()
      })
      collectionPlan.prepared_by = $rootScope.user.id
      collectionPlan.data.display_html = $filter("genCollectionPlanPreparedDisplayHtml")(collectionPlan)
      collectionPlan.deliveries = _.map(collectionPlan.deliveries, function (delivery){return {
          id: delivery.id,
          end_date: moment(delivery.start_date).add(delivery.duration - 1, 'days').format('YYYY-MM-DD'),
          pharma_delivery_comment: delivery.pharma_delivery.collection_related_comment,
          display_html: $filter("genPlanDeliveryDisplayHtml")(delivery),
          products: _.map(delivery.products, function(product) { return _.pick(product, "prepared_quantity", "delivered_quantity")})}})

      CollectionPlan.update(collectionPlan).$promise.then (function() { $rootScope.busy = false; $state.go("^.collection-plan-list")})
    }


    ctrl.validateCollectionPlan = function () {
      $rootScope.busy = true
      collectionPlan = _.cloneDeep(ctrl.collectionPlan)
      collectionPlan.state = "VALIDATED"
      collectionPlan.validated_timestamp = moment.utc().toISOString()
      collectionPlan.data.validated_by_full_name = $rootScope.user.full_name
      collectionPlan.validated_by = $rootScope.user.id
      collectionPlan.data.display_html = $filter("genCollectionPlanDisplayHtml")(collectionPlan)
      collectionPlan.deliveries = _.map(collectionPlan.deliveries, function (delivery){return {
          id: delivery.id,
          end_date: moment(delivery.start_date).add(delivery.duration - 1, 'days').format('YYYY-MM-DD'),
          pharma_delivery_comment: delivery.pharma_delivery.collection_related_comment,
          display_html: $filter("genPlanDeliveryDisplayHtml")(delivery),
          products: _.map(delivery.products, function(product) {return _.pick(product, "prepared_quantity", "delivered_quantity")})}})
      CollectionPlan.update(collectionPlan).$promise.then (function() { $rootScope.busy = false; $state.go("^.collection-plan-list")})
    }

  }],
})

angular.module("mhclientApp").component("collectionPlanNew", {
  templateUrl: "pharmaceutical-analysis/collection-plan/views/collection-plan-new.html",
  bindings: {startDate: "<", endDate:"<", entityId: "<", stay: "<?", state: "<"},
  controller:  ["$rootScope", "$q", "$filter", "$state", "CollectionPlan", "PharmaDelivery", "PharmaValidation", "Stay", "Patient", "Sector", "PrescUtils", "PharmaAnalysisUtils", "Prescription", "SiteVarsUtils", function CollectionPlanCtrl($rootScope, $q, $filter, $state, CollectionPlan, PharmaDelivery, PharmaValidation, Stay, Patient, Sector, PrescUtils, PharmaAnalysisUtils, Prescription, SiteVarsUtils) {

    var ctrl, addPharmaDeliveries, initPlanDeliveryFromPharmaDelivery, genPharmaDeliveryFormPrescription, staysIdToRemove, pharmaDeliveriesForStay, filteredPharmaDeliveries, selectedRouteCodes, initialStay, availableStays, selectedDeliveryNames;
    ctrl = this;
    ctrl.availableRoutes = _.cloneDeep(PrescUtils.routes)
    ctrl.collectionDuration = moment(ctrl.collectionEndDate).diff(moment(ctrl.collectionStartDate), "days") + 1
    ctrl.staySelectionEnabled = true

    addPharmaDeliveries = function(pharmaDeliveries) {
      ctrl.collectionPlan.deliveries = _.concat(ctrl.collectionPlan.deliveries,  _.map(pharmaDeliveries, initPlanDeliveryFromPharmaDelivery))
      }
    genPharmaDeliveryFormPrescription = function (prescription) { return PharmaAnalysisUtils.createDeliveryData(prescription, prescription.stay)}

    initPlanDeliveryFromPharmaDelivery = function (pharmaDelivery) {
        var end_date, start_date, periodDuration, handledDateMore1;
        handledDateMore1 = pharmaDelivery.handled_date ? moment(pharmaDelivery.handled_date).add(1, 'd').format("YYYY-MM-DD") : undefined
        start_date = _.max([pharmaDelivery.start_date, handledDateMore1, ctrl.collectionPlan.start_date])
        var maxProductsFrequency = _.max(_.map(pharmaDelivery.products, function(product){
          if (product.frequencyUnit && product.frequency){return (product.frequencyUnit == "days" ? 1 : 7) * product.frequency}
          else {return 1}
        }))
        end_date = _.min([pharmaDelivery.end_date, _.max([ctrl.collectionPlan.end_date,  moment(pharmaDelivery.start_date).add(maxProductsFrequency -1, 'd').format("YYYY-MM-DD")])])
        periodDuration = moment(end_date).diff(start_date, "days") + 1
        return {
          end_date: end_date,
          start_date: start_date,
          duration: periodDuration,
          pharma_delivery: pharmaDelivery,
          pharma_validation: _.find(ctrl.pharmaValidations, {prescription: pharmaDelivery.prescription}),
          products: _.map(pharmaDelivery.products, function (product) {
            var expectedQuantity, catalogData, sub_ratio = 1 /* for substitution */;
            if (product.posology_data.quantityByDay){
              sub_ratio = (product.dailyQuantity / product.posology_data.frequency / (product.posology_data.frequency_unit == "weeks" ? 7 : 1) / product.posology_data.quantityByDay).toFixed(1)
           }
            expectedQuantity = Math.ceil((product.dailyQuantity * periodDuration) / ((product.frequencyUnit == "days" ? 1 : 7) * product.frequency) ) || null
            catalogData = _.pick()
            return _.assign(
              _.assign(
                _.pick(product.bdmData, ["catalog_ext_id", "catalog_ucd", "cip"]),
                 _.assign(
                  _.pick(product, ['name', 'takingUnit', 'originalTakingUnit', 'route', 'posology_data']),
                  {'expected_quantity': expectedQuantity, "sub_ratio": sub_ratio})
                ),
              ctrl.collectionPlan.state == "PREPARED" ? {"prepared_quantity": expectedQuantity} : {"delivered_quantity": expectedQuantity}
            )
          })
        }
    }

    ctrl.toggleSector = function (sector) {
      if (sector.checked) { addPharmaDeliveries([].concat.apply([], _.map(_.reject(sector.filteredStays, {selected: true}), function (stay) { return stay.filteredPharmaDeliveries})))}
      else { ctrl.collectionPlan.deliveries = _.reject(ctrl.collectionPlan.deliveries, {pharma_delivery: {stay : {sector: sector.id}}})}
      _.forEach(sector.filteredStays, function(stay) {stay.selected = sector.checked; return})
    }

    ctrl.toggleStay = function (stay) {
      if (stay.selected) {addPharmaDeliveries(_.reject(stay.filteredPharmaDeliveries, function(pharmaDelivery) { return _.find(ctrl.collectionPlan.deliveries, {pharma_delivery: { prescription: pharmaDelivery.prescription}})}))}
      else { ctrl.collectionPlan.deliveries = _.reject(ctrl.collectionPlan.deliveries, {pharma_delivery: {stay: {id:stay.id}}})}
    }

    ctrl.computeDeliveriesForStay = function () {
      filteredPharmaDeliveries = ctrl.availablePharmaDeliveries
      if (ctrl.collectionPlan.data.selectedRoutes && ctrl.collectionPlan.data.selectedRoutes.length > 0){
          selectedRouteCodes  = _.map(ctrl.collectionPlan.data.selectedRoutes, "code")
          filteredPharmaDeliveries = _.filter(filteredPharmaDeliveries, function (delivery) { return _.some(delivery.products, function (product) {return _.indexOf(selectedRouteCodes, (product.route || {}).code) >= 0})})
          ctrl.collectionPlan.deliveries = _.filter(ctrl.collectionPlan.deliveries, function (delivery) { return _.some(delivery.products, function (product) {return _.indexOf(selectedRouteCodes, (product.route || {}).code) >= 0})})
      }

      if (ctrl.collectionPlan.data.selectedDeliveryTypes && ctrl.collectionPlan.data.selectedDeliveryTypes.length > 0){
          selectedDeliveryNames  = _.map(ctrl.collectionPlan.data.selectedDeliveryTypes, "name")
          filteredPharmaDeliveries = _.filter(filteredPharmaDeliveries, function (delivery) { return _.indexOf(selectedDeliveryNames, delivery.stay.order_data.delivery_type) >= 0 })
          ctrl.collectionPlan.deliveries = _.filter(ctrl.collectionPlan.deliveries, function (delivery) { return _.indexOf(selectedDeliveryNames, delivery.pharma_delivery.stay.order_data.delivery_type) >= 0 })
      }

      availableStays = _.chain(filteredPharmaDeliveries).groupBy("stay.id").map(function (stayPharmaDeliveries, stayId) {
        stayPharmaDeliveries[0].stay.filteredPharmaDeliveries = stayPharmaDeliveries;
        if (stayPharmaDeliveries[0].stay.selected) { ctrl.toggleStay(stayPharmaDeliveries[0].stay)}
        return stayPharmaDeliveries[0].stay
      }).value()

      ctrl.noStaysFound = availableStays.length == 0
      _.forEach(ctrl.sectors, function(sector){ sector.filteredStays = _.filter(availableStays, {sector: sector.id}); if (sector.checked) {ctrl.toggleSector(sector)}})
    }


    ctrl.saveCollectionPlan = function () {
      $rootScope.busy = true
      if (ctrl.collectionPlan.state == "PREPARED") {
        ctrl.collectionPlan.prepared_timestamp = moment.utc().toISOString()
        ctrl.collectionPlan.data.prepared_by_full_name = $rootScope.user.full_name
        ctrl.collectionPlan.prepared_by = $rootScope.user.id
        ctrl.collectionPlan.data.display_html = $filter("genCollectionPlanPreparedDisplayHtml")(ctrl.collectionPlan)
      }
      else  { // VALIDATED
        ctrl.collectionPlan.validated_timestamp = moment.utc().toISOString()
        ctrl.collectionPlan.data.validated_by_full_name = $rootScope.user.full_name
        ctrl.collectionPlan.validated_by = $rootScope.user.id
        ctrl.collectionPlan.data.display_html = $filter("genCollectionPlanDisplayHtml")(ctrl.collectionPlan)
        _.forEach(ctrl.collectionPlan.deliveries, function (delivery){ delivery.display_html = $filter("genPlanDeliveryDisplayHtml")(delivery)})
      }
      _.forEach(ctrl.collectionPlan.deliveries, function (delivery){
        delivery.pharma_delivery_comment = delivery.pharma_delivery.collection_related_comment;
        if (delivery.pharma_delivery.id) {delivery.pharma_delivery = delivery.pharma_delivery.id}
        else {delivery.pharma_delivery.stay = delivery.pharma_delivery.stay.id} //need to be created
        delivery.end_date = moment(delivery.start_date).add(delivery.duration - 1, 'days').format('YYYY-MM-DD')
        delete delivery.collectionPlanForm
        delete delivery.pharma_validation
      })
      CollectionPlan.save(ctrl.collectionPlan).$promise.then (function() { $rootScope.busy = false; $state.go("^.collection-plan-list")})
    }

    $rootScope.busy = true
    PrescUtils.getCategories({}, true, true).promise.then (function(categories){

      // anotate collectionPlanDelivery whit PharmaDelivery whiout ID
      PharmaValidation.query({to_delivery: 1, start_date:ctrl.startDate, end_date:ctrl.endDate, entity: ctrl.entityId}).$promise.then( function(pharmaValidations) {
        PharmaDelivery.query({to_delivery: 1, start_date:ctrl.startDate, end_date:ctrl.endDate, entity: ctrl.entityId}).$promise.then( function(pharmaDeliveries) {
          Prescription.getCollectionDeliverables({start_date:ctrl.startDate, end_date:ctrl.endDate, entity: ctrl.entityId}).$promise.then( function(prescriptions) {
            SiteVarsUtils.getValue("PHARMA_OUT_CATALOG_WARNING", false).then (function(PHARMA_OUT_CATALOG_WARNING){
              ctrl.pharmaValidations = pharmaValidations
              ctrl.pharmaOutCatalogWarning = PHARMA_OUT_CATALOG_WARNING
              prescriptions = _.reject(_.reject(prescriptions, "data.is_cropped"), function(prescription) {return _.find(pharmaDeliveries, {prescription:prescription.id})})
              _.forEach(prescriptions, function(prescription) { prescription.category = _.find(categories, {id:prescription.category})})
              pharmaDeliveries = _.concat(pharmaDeliveries,  _.map(prescriptions, genPharmaDeliveryFormPrescription))
              Stay.query({state:['PRE', 'ADM',], extra_fields: ['order_data']}).$promise.then( function(stays) {
                Patient.query({stay_states:['PRE', 'ADM',]}).$promise.then ( function (patients) {
                  Sector.getSectors().then ( function(sectors) {
                    PharmaAnalysisUtils.getDeliveryTypeOptions().then ( function (deliveryTypeOptions) {

                      $q.all(_.map(_.uniq(_.map(pharmaDeliveries, 'stay')), function (stayId) {
                        return $q.when(_.find(stays, {id:stayId}) || Stay.get({id:stayId}).$promise).then( function (stay) {
                            return $q.when(_.find(patients, {id:stay.patient}) || Patient.get({id: stay.patient}).$promise).then (function (patient) {
                              stay.patient = patient
                              return stay
                            })
                        })
                      })).then( function(computedStays){
                        ctrl.sectors = _.cloneDeep(sectors)
                        ctrl.deliveryTypeOptions = _.concat(deliveryTypeOptions, [{"name": undefined, "label": $filter("translate")("No specified")}])
                        ctrl.sectors.push({"id": null, "name": $filter("translate")("Out of Sector")})
                        _.forEach(pharmaDeliveries, function (pharmaDelivery) { pharmaDelivery.stay = _.find(computedStays, {id: pharmaDelivery.stay})})
                        ctrl.collectionDuration = moment(ctrl.endDate).diff(moment(ctrl.startDate), "days") + 1
                        ctrl.collectionPlan = {
                          start_date: ctrl.startDate,
                          end_date: ctrl.endDate,
                          data: {selectedRoutes: [], selectedDeliveryTypes: []},
                          entity: ctrl.entityId,
                          deliveries: [],
                          state: ctrl.state
                        }

                        if (ctrl.stay) {
                          initialStay = _.find(computedStays, {id: ctrl.stay.id})
                          if (initialStay) {
                            initialStay.selected = true
                            _.find(ctrl.sectors, {id:initialStay.sector}).open = true
                            addPharmaDeliveries(_.filter(pharmaDeliveries, {stay: {id: initialStay.id}}))
                          }
                        }
                        ctrl.availablePharmaDeliveries = pharmaDeliveries
                        ctrl.computeDeliveriesForStay()
                        $rootScope.busy = false
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  }],
});

angular.module("mhclientApp").component("collectionPlanList", {
  templateUrl: "pharmaceutical-analysis/collection-plan/views/collection-plan-list.html",
  bindings: {stay: "<?"},
  controller:  ["$rootScope", "$state", "CollectionPlan", "Entity", function CollectionPlanCtrl($rootScope, $state, CollectionPlan, Entity) {

    var ctrl = this;
    ctrl.canValidate = $rootScope.checkPermissions('PHARMA-COLLECTION-VALIDATION', 'CAN_WRITE')
    ctrl.canPrepare = $rootScope.checkPermissions('PHARMA-COLLECTION-PREPARATION', 'CAN_WRITE')
    ctrl.collectionStartDate = moment().format("YYYY-MM-DD")
    ctrl.dFrom = moment().add(-60, "days").format("YYYY-MM-DD")
    ctrl.dTo = moment().format("YYYY-MM-DD")
    var params = {};
    if ($rootScope.allStays)
      { params.patient = ctrl.stay.patient; }
    else if (ctrl.stay)
      { params.stay = ctrl.stay.id;}

    ctrl.fetchCollections = function () {
      $rootScope.busy = true
      params.d_from = ctrl.dFrom
      params.d_to = ctrl.dTo
      return CollectionPlan.query(params).$promise.then (function(collections) { ctrl.collections = collections; $rootScope.busy = false})
    }

    ctrl.newCollectionPlan = function (state) {
      $state.go("^.collection-plan-new",  {
        endDate: moment(ctrl.collectionStartDate).add((ctrl.collectionDuration - 1), 'days').format("YYYY-MM-DD"),
        startDate: ctrl.collectionStartDate,
        entityId:ctrl.entityId,
        state: state
      })
    }

    $rootScope.busy = true
    Entity.getEntities().then (function (entities) {
      ctrl.entities = entities
      ctrl.entityId = ctrl.stay ? ctrl.stay.entity : $rootScope.user.entity
      ctrl.fetchCollections()
    })

  }],
});

angular.module("mhclientApp").component("collectionPlanLabel", {
  templateUrl: "pharmaceutical-analysis/collection-plan/views/collection-plan-label.html",
  bindings: {collectionPlan: "<?", showHistory: "<?", hideComment: "<?", hideTitle: "<?"},
  controller:  ["$rootScope", "$state", "CollectionPlan", "Entity", function CollectionPlanCtrl($rootScope, $state, CollectionPlan, Entity) {
    this.collectionPlan.duration = moment(this.collectionPlan.end_date).diff(moment(this.collectionPlan.start_date), "days") + 1
  }],

});


angular.module("mhclientApp").component("collectionPlanPharmaValidationStatus", {
  templateUrl: "pharmaceutical-analysis/collection-plan/views/collection-plan-pharma-validation-status.html",
  bindings: {status: "<",},
});


angular.module("mhclientApp").component("collectionPlanProductTakes", {
  templateUrl: "pharmaceutical-analysis/collection-plan/views/collection-plan-product-takes.html",
  bindings: {product: "<",},
  controller:  ["PrescUtils", function collectionPlanProductTakesCtrl(PrescUtils) {
    var baseQuantity;
    var ctrl = this;
    ctrl.displayByTimeSlotId = {}

    var checkSlot = function(timeSlot) {

      if (ctrl.product.posology_data.takes == "intervals"){
        if ((timeSlot.data.intervals || []).includes(ctrl.product.posology_data.interval)){
          return String(ctrl.product.posology_data.interval_quantity * (ctrl.product.sub_ratio || 1))
        }
      } else if ((ctrl.product.posology_data.takes || "slots") == "slots"){
        baseQuantity = ctrl.product.posology_data.quantity_by_timeslot[timeSlot.short_label]
        if (baseQuantity && baseQuantity != "0") { return String(baseQuantity * (ctrl.product.sub_ratio || 1))}
      }
      return ""
    }
    if (ctrl.product.posology_data && ["cycled", "dates"].includes(ctrl.product.posology_data.type)){
      PrescUtils.getCategories({name:ctrl.product.posology_data.category_name}, false, true).promise.then (function(category){
        if (category.gen_tasks || category.name == "PAP"){
          ctrl.hasPosology = true
          if (ctrl.product.posology_data.takes != "debit"){
            PrescUtils.getTimeSlots(true).promise.then (function(timeSlots){
              ctrl.timeSlots = timeSlots;
              _.forEach(timeSlots, function(timeSlot) {ctrl.displayByTimeSlotId[timeSlot.id] = checkSlot(timeSlot); return })
              ctrl.initDone = true
            })
          } else { ctrl.initDone = true}
        } else { ctrl.hasPosology = false; ctrl.initDone = true}
      })
    } else{ ctrl.hasPosology = false; ctrl.initDone = true }
  }],

});

angular.module('mhclientApp').filter('collectionPlanProductPosology', ["$filter", "$rootScope", function($filter, $rootScope) {

  return function(product) {

    var sentences, sentence, weekDays, lastWeekDay;
    if (!product.posology_data) {return}
    sentences = []
    if (["PAP", "PCA"].includes(product.posology_data.category_name) && product.posology_data.only_if && product.posology_data.only_if.length > 0){
      sentences.push([$filter("translate")("POSOLOGY_ONLY_IF"),_.escape(product.posology_data.only_if)].join(" "))
    }
    if (product.posology_data.category_name && !["BIOLOGIC", "IMAGE", "PCA"].includes(product.posology_data.category_name)){
      if (product.posology_data.type == 'cycled'){
        if (product.posology_data.frequency_unit == 'days'){
          if (product.posology_data.frequency == 1)
            sentence = $filter("translate")('everyday')
          else
            sentence = $filter("translate")('each _FREQUENCY days').replace(/_FREQUENCY/g, String(product.posology_data.frequency))

        } else {

          weekDays = _.map(product.posology_data.week_days.sort(), function(weekDay) {return $filter("translate")("the")+ " " + $rootScope.DATETIME_FORMATS.DAY[weekDay]})
          lastWeekDay = weekDays.pop()
          sentence = (weekDays.length == 0 ? lastWeekDay : (weekDays.join(", ") + ' ' + $filter("translate")("and") + ' ' + lastWeekDay))
          if (product.posology_data.frequency == 1)
            sentence += " " +$filter("translate")('each week')
          else
            sentence += " " + $filter("translate")('each _FREQUENCY weeks').replace(/_FREQUENCY/g, String(product.posology_data.frequency))


        }

        sentences.push( _.upperFirst(sentence))
      }
      else if (product.posology_data.type == 'dates'){
        sentences.push($filter("translate")('On fixed dates'))
      }
    }
    return sentences.join(". ")
  }
}]);

angular.module('mhclientApp').filter('genCollectionPlanDisplayHtml', ["$filter", function($filter) {
  return function(collectionPlan) {
    var duration = moment(collectionPlan.end_date).diff(moment(collectionPlan.start_date), "days") + 1
    return _.concat(
      [$filter("endWhitDot")([
          $filter("translate")("Validated delivery"),
          $filter("translate")("by"),
          collectionPlan.data.validated_by_full_name,
          $filter("translate")("the"),
          $filter("utcToLocal")(collectionPlan.validated_timestamp, "mhcareMedium"),
          $filter("translate")("for the"),
          '<span class="collection-start-date">' + $filter("date")(collectionPlan.start_date, "mediumDate") + '</span>',
          $filter("translate")("of a period of"),
          '<span class="collection-duration">'+ duration,
          $filter("translate")(duration > 1 ? "days": "day")
        ].join(" "))
      ],
      collectionPlan.prepared_timestamp ? [
          $filter("translate")("Collection plan"),
          $filter("translate")("prepared(f)"),
          $filter("translate")("the"),
          $filter("utcToLocal")(collectionPlan.prepared_timestamp, "mhcareMedium"),
          $filter("translate")("by"),
          collectionPlan.data.prepared_by_full_name,
          ] : []).join(" ")
  };
}]);

angular.module('mhclientApp').filter('genCollectionPlanPreparedDisplayHtml', ["$filter", function($filter) {
  return function(collectionPlan) {
    var duration = moment(collectionPlan.end_date).diff(moment(collectionPlan.start_date), "days") + 1
    return ([
          $filter("translate")("Collection plan"),
          $filter("translate")("prepared(f)"),
          $filter("translate")("the"),
          $filter("utcToLocal")(collectionPlan.prepared_timestamp, "mhcareMedium"),
          $filter("translate")("by"),
          collectionPlan.data.prepared_by_full_name,
          $filter("translate")("for the"),
          '<span class="collection-start-date">' + $filter("date")(collectionPlan.start_date, "mediumDate") + '</span>',
          $filter("translate")("of a period of"),
          '<span class="collection-duration">'+ duration,
          $filter("translate")(duration > 1 ? "days": "day")
          ]).join(" ")
  };
}]);

angular.module('mhclientApp').filter('genPlanDeliveryDisplayHtml', ["$filter", function($filter) {
  return function(planDelivery) {
    var lastProduct, products;

    products = _.map(planDelivery.products, function(product) {
      return [
        product.delivered_quantity,
        (product.delivered_quantity > 1 ? product.takingUnit.label_plural : product.takingUnit.label) || product.takingUnit.label,
        $filter("translate")("of"),
        product.name
      ].join(" ")
    })

    lastProduct = products.pop()
    return $filter("endWhitDot")([$filter("translate")("Delivered"), products.length == 0 ? lastProduct : products.join(", ") + ' ' + $filter("translate")("and") + ' ' + lastProduct].join(" "))

  };
}]);

angular.module('mhclientApp').filter('filterDeliveries', function() {
  return function(deliveries, query, reject) {

    var regex;
    if (!query || query.length == 0) {return reject ? [] : deliveries }
    regex = new RegExp('' + query.replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i');
    return (reject ? _.reject : _.filter)(deliveries, function (delivery){
      return (
        regex.test(delivery.pharma_delivery.stay.si_id) ||
        regex.test(delivery.pharma_delivery.stay.patient.si_id) ||
        regex.test(delivery.pharma_delivery.stay.patient.full_name) ||
        _.some(delivery.products, function(product) {return regex.test(product.name)})
      )
    })
  };

});


'use strict'

/* ********************************************
 # @ngdoc function
 # @name mhclientApp.service:AccessDataFactory
 # @description
 # # AccessData
 # Factory of AccessData
********************************************* */

angular.module("mhclientApp").factory('AccessData', ["$resource", "MhConfig", function($resource, MhConfig) {
  // Set API's version
  var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";

  var portailAPI = $resource('/api_rest/access_data/:id/:route',
      {
        id: '@id',
        extra: '@extra',
      },
      {
        'newInsAccess':
        {
          method: 'POST',
          headers: {'Accept': acceptHeader},
          params: {route: 'new_ins_access'},
        },
      }
  );

  // Only MH_SI
  return portailAPI;
}]);

(function() {
  'use strict';
  angular.module("mhclientApp").factory('ImageDocument', ["$resource", "MhConfig", "$q", "$http", "BoxResource", function($resource, MhConfig, $q, $http, BoxResource) {
    var acceptHeader, api, image_document, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/documents/:id', {
      id: this.id
    }, {
      'query': {
        method: 'get',
        isArray: true,
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        method: 'PUT',
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        image_document = window.mgapp.get('image_document_mgr').image_document();
        api = BoxResource.generate(image_document);
    }
    return api;
  }]);

  angular.module("mhclientApp").factory('DocumentCategory', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/documentcategories/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    return portailAPI;
  }]);

}).call(this);

//# sourceMappingURL=image-document-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Stay
    * @description
    * # Stay
    * Factory of Stay
   */
  angular.module("mhclientApp").factory('Stay', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, portailAPI, stay;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/stays/:id/:route/:extra', {
      id: '@id',
      extra: '@extra'
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'medicalformSyntesis': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'medicalform_for_syntesis'
        }
      },
      'nextMedplanTaskDate': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_next_medplan_task_date'
        }
      },
      'getControlPharma': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_control_pharma'
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH'
      },
      'accept_pread': {
        method: 'POST',
        params: {
          id: '@id',
          route: 'accept_pread'
        }
      },
      'reject_pread': {
        method: 'POST',
        params: {
          id: '@id',
          route: 'reject_pread'
        }
      },
      'archiveStay': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'archive_stay'
        },
        method: 'PUT'
      },
      'printData': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'print_data',
          extra: '@extra'
        }
      },
      'printStay': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'print_stay'
        },
        method: 'PUT'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        stay = window.mgapp.get('pat_mgr').stay();
        boxAPI = BoxResource.generate(stay);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").controller('StayByPatientSelectCtrl', ["$scope", "$window", "$q", "$uibModalInstance", "Patient", "Stay", "withMedplan", "Medplan", function($scope, $window, $q, $uibModalInstance, Patient, Stay, withMedplan, Medplan) {
    $scope.searching = false;
    $scope.query = "";
    $scope.withMedplan = withMedplan;
    $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
    $scope.selectPatient = function(patient) {
      if (patient.stays == null) {
        return Stay.query({
          patient: patient.id
        }).$promise.then(function(stays) {
          var handleMedplans, i, len, stay;
          if (stays.length === 1) {
            stays[0].patient = patient;
            return $uibModalInstance.close(stays[0]);
          } else {
            for (i = 0, len = stays.length; i < len; i++) {
              stay = stays[i];
              stay.patient = patient;
            }
            handleMedplans = $q.defer();
            if (withMedplan) {
              Medplan.api.query({
                patient: patient.id
              }).$promise.then(function(medplans) {
                var j, len1;
                for (j = 0, len1 = stays.length; j < len1; j++) {
                  stay = stays[j];
                  stay.medplans = _.map(_.filter(medplans, {
                    stay: stay.id
                  }), function(medplan) {
                    return medplan.data.short_name;
                  }).join(", ");
                }
                return handleMedplans.resolve();
              });
            } else {
              handleMedplans.resolve();
            }
            return handleMedplans.promise.then(function() {
              return patient.stays = stays;
            });
          }
        });
      }
    };
    $scope.selectStay = function(stay) {
      return $uibModalInstance.close(stay);
    };
    return $scope.searchPatient = function() {
      var params;
      $scope.query = $scope.query.trim();
      if ($scope.query.length > 2) {
        $scope.searching = true;
        params = {
          query: $scope.query
        };
        return Patient.query({
          full_name: $scope.query
        }).$promise.then(function(patients) {
          $scope.patients = patients;
          return $scope.searching = false;
        });
      }
    };
  }]);

  angular.module("mhclientApp").factory('StayUtils', ["$filter", "$uibModal", function($filter, $uibModal) {
    var STAY_STATE_TRANSLATION_MAP, selectStayByPatientModal, service, translateStayState;
    STAY_STATE_TRANSLATION_MAP = {
      PRE: $filter('translate')('STAY_PREAD_STATUS'),
      ADM: $filter('translate')('STAY_ADM_STATUS'),
      CLOSE: $filter('translate')('STAY_CLOSED_STATUS'),
      I: $filter('translate')('STAY_INACTIVE_STATUS')
    };
    translateStayState = function(state) {
      return STAY_STATE_TRANSLATION_MAP[state];
    };
    selectStayByPatientModal = function(withMedplan) {
      return $uibModal.open({
        templateUrl: 'stay/views/stay-selection-template.html',
        controller: 'StayByPatientSelectCtrl',
        backdrop: 'static',
        resolve: {
          withMedplan: function() {
            return withMedplan;
          }
        }
      });
    };
    service = {
      selectStayByPatientModal: selectStayByPatientModal,
      translateStayState: translateStayState
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=stay-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:shortcut
    * @description
    * # previewDisplay
    * Display shortcuts of registered words
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').filter('stayMovementsFilter', function() {
    return function(stays, search_text, medicalunit_filter, sector_active_filters, entity_active_filters, mode, start_date, end_date, nbShowItems) {
      var check_end_date, check_start_date, filtered, has_entity_filters, has_medicalunit_filters, has_search_text, has_sector_filters, i, isOk, item, j, k, len, len1, len2, length, ref, ref1, ref2, regex, searchRegexList, searchTextList, searchVal, stay, text;
      filtered = [];
      has_search_text = (search_text != null) && search_text.length > 0;
      if (has_search_text) {
        searchTextList = search_text.split("&&");
        searchRegexList = [];
        for (i = 0, len = searchTextList.length; i < len; i++) {
          text = searchTextList[i];
          length = text.length;
          if (length > 0) {
            searchVal = text.replace(/([()[{*+.$^\\|?])/g, '\\$1').replace(/[- ']/g, "[- ']?").replace(/[cç]/g, "[cç]{1}").replace(/[eéèêë]/g, "[eéèêë]{1}").replace(/[aàäâ]/g, "[aàâä]{1}").replace(/[iïî]/g, "[iïî]{1}").replace(/[uùüû]/g, "[uùüû]{1}").replace(/[oô]/g, "[oô]{1}");
            regex = new RegExp('' + searchVal, 'i');
            searchRegexList.push({
              "regex": regex,
              "length": length
            });
          }
        }
      }
      has_medicalunit_filters = (medicalunit_filter != null) && medicalunit_filter.length > 0;
      has_sector_filters = (sector_active_filters != null) && sector_active_filters.length > 0;
      has_entity_filters = (entity_active_filters != null) && entity_active_filters.length > 0;
      check_start_date = moment(start_date);
      check_end_date = moment(end_date);
      for (j = 0, len1 = stays.length; j < len1; j++) {
        stay = stays[j];
        if (has_search_text) {
          isOk = true;
          for (k = 0, len2 = searchRegexList.length; k < len2; k++) {
            item = searchRegexList[k];
            regex = item.regex;
            length = item.length;
            isOk = isOk && (regex.test(stay.patient.full_name) || regex.test((ref = stay.patient.data) != null ? ref.first_name_atbirth : void 0) || regex.test((ref1 = stay.patient.data) != null ? ref1.first_names_atbirth : void 0) || (length === 15 && regex.test((ref2 = stay.patient.data) != null ? ref2.ins : void 0)) || regex.test(stay.si_id) || regex.test(stay.patient.si_id) || regex.test(moment(stay.patient.birthday).calendar()));
          }
          if (!isOk) {
            continue;
          }
        }
        if (has_sector_filters && sector_active_filters.indexOf(stay.sector) === -1) {
          continue;
        }
        if (has_entity_filters && entity_active_filters.indexOf(stay.entity) === -1) {
          continue;
        }
        if (has_medicalunit_filters && medicalunit_filter.indexOf(stay.medical_unit) === -1) {
          continue;
        }
        if (mode === "entries") {
          if (stay.d_from && !(moment(stay.d_from) > check_start_date && moment(stay.d_from) < check_end_date)) {
            continue;
          }
        } else {
          if (!(stay.projected_end_date || stay.d_to)) {
            continue;
          } else if (stay.d_to && !(moment(stay.d_to) > check_start_date && moment(stay.d_to) < check_end_date)) {
            continue;
          }
        }
        filtered.push(stay);
        if (filtered.length === nbShowItems) {
          break;
        }
      }
      return filtered;
    };
  });

  angular.module('mhclientApp').filter('stayListFilter', ["$rootScope", function($rootScope) {
    return function(stays, search_text, status_active_filters, medicalUnitFilters, sector_active_filters, entity_active_filters, thesaurusFilters, referentFilters, alertCategoriesIds, alertConfigsIds, onlyDormant, nbShowItems) {
      var filtered, hasMedicalunitFilters, hasNoReferentsAttribute, hasReferentFilters, has_alert_categories_filters, has_alert_configs_filters, has_entity_filters, has_search_text, has_sector_filters, has_status_filters, has_thesaurus_entry, has_thesaurus_event, i, isOk, item, j, k, len, len1, len2, length, ref, ref1, ref2, ref3, ref4, ref5, ref6, regex, searchRegexList, searchTextList, searchVal, stay, text, thesaurusEntriesIds, thesaurusEventsUids;
      filtered = [];
      has_search_text = (search_text != null) && search_text.length > 0;
      if (has_search_text) {
        searchTextList = search_text.split("&&");
        searchRegexList = [];
        for (i = 0, len = searchTextList.length; i < len; i++) {
          text = searchTextList[i];
          length = text.length;
          if (length > 0) {
            searchVal = text.replace(/([()[{*+.$^\\|?])/g, '\\$1').replace(/[- ']/g, "[- ']?").replace(/[cç]/g, "[cç]{1}").replace(/[eéèêë]/g, "[eéèêë]{1}").replace(/[aàäâ]/g, "[aàâä]{1}").replace(/[iïî]/g, "[iïî]{1}").replace(/[uùüû]/g, "[uùüû]{1}").replace(/[oô]/g, "[oô]{1}");
            regex = new RegExp('' + searchVal, 'i');
            searchRegexList.push({
              "regex": regex,
              "length": length
            });
          }
        }
      }
      has_status_filters = (status_active_filters != null) && status_active_filters.length > 0;
      has_sector_filters = (sector_active_filters != null) && sector_active_filters.length > 0;
      has_entity_filters = $rootScope.mh_config.platform === "mhsi" && (entity_active_filters != null) && entity_active_filters.length > 0;
      has_thesaurus_entry = (thesaurusFilters != null) && thesaurusFilters.entries.length > 0;
      has_alert_categories_filters = $rootScope.mh_config.platform === "mhsi" && (alertCategoriesIds != null) && alertCategoriesIds.length > 0;
      has_alert_configs_filters = $rootScope.mh_config.platform === "mhsi" && (alertConfigsIds != null) && alertConfigsIds.length > 0;
      hasMedicalunitFilters = (medicalUnitFilters != null) && medicalUnitFilters.length > 0;
      hasReferentFilters = (referentFilters != null) && referentFilters.length > 0;
      hasNoReferentsAttribute = (referentFilters != null) && referentFilters.indexOf(null) !== -1;
      if (has_thesaurus_entry) {
        thesaurusEntriesIds = _.map(thesaurusFilters.entries, 'id');
      }
      has_thesaurus_event = (thesaurusFilters != null) && thesaurusFilters.events.length > 0;
      if (has_thesaurus_event) {
        thesaurusEventsUids = _.map(thesaurusFilters.events, 'uid');
      }
      for (j = 0, len1 = stays.length; j < len1; j++) {
        stay = stays[j];
        if (has_search_text) {
          isOk = true;
          for (k = 0, len2 = searchRegexList.length; k < len2; k++) {
            item = searchRegexList[k];
            regex = item.regex;
            length = item.length;
            isOk = isOk && (regex.test(stay.patient.full_name) || regex.test((ref = stay.patient.data) != null ? ref.first_name_atbirth : void 0) || regex.test((ref1 = stay.patient.data) != null ? ref1.first_names_atbirth : void 0) || (length === 15 && regex.test((ref2 = stay.patient.data) != null ? ref2.ins : void 0)) || regex.test(stay.si_id) || regex.test(stay.patient.si_id) || regex.test(moment(stay.patient.birthday).calendar()));
          }
          if (!isOk) {
            continue;
          }
        }
        if (has_status_filters && status_active_filters.indexOf(stay.state) === -1) {
          continue;
        }
        if (has_sector_filters && sector_active_filters.indexOf(stay.sector) === -1) {
          continue;
        }
        if (has_entity_filters && entity_active_filters.indexOf(stay.entity) === -1) {
          continue;
        }
        if (has_thesaurus_entry && !_.some(stay.medPlans, function(item) {
          var ref3;
          return ref3 = item.thesaurus, indexOf.call(thesaurusEntriesIds, ref3) >= 0;
        })) {
          continue;
        }
        if (has_thesaurus_event && !_.some(stay.medPlans, function(item) {
          var ref3;
          return ref3 = item.thesaurus_template, indexOf.call(thesaurusEventsUids, ref3) >= 0;
        })) {
          continue;
        }
        if (has_alert_categories_filters && !_.some(stay.alertCategoriesIds, function(item) {
          return indexOf.call(alertCategoriesIds, item) >= 0;
        })) {
          continue;
        }
        if (has_alert_categories_filters && has_alert_configs_filters && !_.some(stay.alertConfigsIds, function(item) {
          return indexOf.call(alertConfigsIds, item) >= 0;
        })) {
          continue;
        }
        if ($rootScope.mh_config.platform === "mhsi" && onlyDormant && (stay.state !== "PRE" || !stay.is_dormant)) {
          continue;
        }
        if (hasMedicalunitFilters && !(ref3 = stay.medical_unit, indexOf.call(medicalUnitFilters, ref3) >= 0)) {
          continue;
        }
        if (hasReferentFilters && _.intersection(_.map((ref4 = stay.identitovigilance) != null ? ref4.referents : void 0, "username"), referentFilters).length < 1) {
          if (!hasNoReferentsAttribute || ((ref5 = stay.identitovigilance) != null ? (ref6 = ref5.referents) != null ? ref6.length : void 0 : void 0) > 0) {
            continue;
          }
        }
        filtered.push(stay);
        if (filtered.length === nbShowItems) {
          break;
        }
      }
      return filtered;
    };
  }]);

}).call(this);

//# sourceMappingURL=stay-filters.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Stock
    * @description
    * # Stock
    * Factory of Stock
   */
  angular.module("mhclientApp").factory('DrugStock', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, boxAPI, drug_stock, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/drug_stocks/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        drug_stock = window.mgapp.get('stock_mgr').drug_stock();
        boxAPI = BoxResource.generate(drug_stock);
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=stock-services.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StockController
    * @description
    * # StockController
    * Controller of Stock
   */
  angular.module('mhclientApp').controller('StockController', ["$scope", "$rootScope", "$state", "$q", "$uibModal", "$filter", "Prescription", "PrescUtils", "SiteVarsUtils", "DrugStock", function($scope, $rootScope, $state, $q, $uibModal, $filter, Prescription, PrescUtils, SiteVarsUtils, DrugStock) {
    $scope.canWrite = $scope.checkPermissions("STOCK", "CAN_WRITE");
    $scope.showHistory = function(presc) {
      $rootScope.busy = true;
      $scope.presc = angular.copy(presc);
      $rootScope.busy = false;
      return $uibModal.open({
        templateUrl: 'medication/views/presc-history_modal.html',
        controller: 'PrescriptionHistoryCtrl',
        scope: $scope,
        backdrop: 'static',
        resolve: {
          prescription: angular.copy(presc)
        }
      });
    };
    return $scope.toggleDetail = function(presc) {
      return PrescUtils.getPrescriptionDetails(presc);
    };
  }]);

}).call(this);

//# sourceMappingURL=stock-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StockNewController
    * @description
    * # StockNewController
    * Controller of Stock
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('StockNewController', ["$scope", "$rootScope", "$state", "$q", "$uibModal", "$filter", "Prescription", "PrescUtils", "SiteVarsUtils", "DrugStock", "Order", function($scope, $rootScope, $state, $q, $uibModal, $filter, Prescription, PrescUtils, SiteVarsUtils, DrugStock, Order) {
    var computePrescriptionsStock, getCip, getPreviousStock, monthDiff;
    $scope.interfaceType = "NEW";
    $scope.options = {
      stockPAP: false,
      comment: ""
    };
    $scope.getNextDeliveryDay = function(weekDay) {
      var date, day;
      date = new Date();
      day = date.getDay();
      if (day >= weekDay) {
        return new Date().setDate(date.getDate() - (day - weekDay) + 7);
      } else {
        return new Date().setDate(date.getDate() - (day - weekDay));
      }
    };
    monthDiff = function(d1, d2) {
      var months;
      months = void 0;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth() + 1;
      months += d2.getMonth();
      if (months <= 0) {
        return 0;
      } else {
        return months;
      }
    };
    $scope.order_reverse = false;
    $scope.date = new Date();
    getCip = function(prescription) {
      if (prescription.data.bdm_data != null) {
        return prescription.data.bdm_data.cip;
      } else {
        return null;
      }
    };
    getPreviousStock = function(prescription, allPrescriptions, previousStocks) {
      var parent;
      if (prescription.uid in previousStocks) {
        return previousStocks[prescription.uid];
      } else {
        parent = _.find(allPrescriptions, {
          child_prescription: prescription.id
        });
        if (parent) {
          return getPreviousStock(parent, allPrescriptions, previousStocks);
        }
      }
      return null;
    };
    computePrescriptionsStock = function(stock, prescriptions, isStopped) {
      var i, len, prescription, results;
      results = [];
      for (i = 0, len = prescriptions.length; i < len; i++) {
        prescription = prescriptions[i];
        prescription.stock.is_stopped = isStopped;
        if (!isStopped && prescription.category.name === "PAP_TEMPLATE" && !$scope.options.stockPAP) {
          prescription.stock.modified = false;
          delete prescription.stock.quantity;
        } else {
          if (prescription.stock.quantity != null) {
            prescription.stock.stock_timestamp = $scope.date;
            prescription.stock.modified = true;
          } else {
            prescription.stock.modified = false;
          }
        }
        results.push(stock.prescriptions[prescription.uid] = prescription.stock);
      }
      return results;
    };
    $scope.save = function() {
      var category, i, j, k, len, len1, len2, ref, ref1, ref2, route, stock, user_id;
      $rootScope.busy = true;
      if ($scope.user.user_profile.pro_category === "inde") {
        user_id = $scope.user.username;
      } else {
        user_id = $scope.user.email;
      }
      stock = {
        stay: $rootScope.currentStay.id,
        stock_timestamp: $scope.date,
        author: $scope.user.id,
        metadata: {
          author: $scope.user.full_name,
          ipp: $rootScope.currentPatient.si_id,
          user_id: user_id,
          stop_delay: $scope.StockStoppedDelay,
          has_pap_stock: $scope.options.stockPAP,
          comment: $scope.options.comment
        },
        prescriptions: {}
      };
      if ($scope.options.stockPAP) {
        stock.metadata.last_pap_stock = $scope.date;
      } else if ($scope.previousStock) {
        stock.metadata.last_pap_stock = $scope.previousStock.metadata.last_pap_stock;
      }
      ref = $scope.stoppedPrescriptionByRoute;
      for (i = 0, len = ref.length; i < len; i++) {
        route = ref[i];
        computePrescriptionsStock(stock, route.prescriptions, true);
      }
      ref1 = $scope.categories;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        category = ref1[j];
        ref2 = category.routes;
        for (k = 0, len2 = ref2.length; k < len2; k++) {
          route = ref2[k];
          computePrescriptionsStock(stock, route.prescriptions, false);
        }
      }
      return DrugStock.api.save(stock).$promise.then(function(stock) {
        $rootScope.busy = false;
        return $state.go("user.patient.stay.stock.list");
      });
    };
    $scope.handleStock = function() {
      var prescriptions;
      $scope.categories = [];
      $scope.stoppedPrescriptionByRoute = [];
      $scope.hasPAPPrescriptions = false;
      prescriptions = [];
      return PrescUtils.getCategories().promise.then(function(categories) {
        return Prescription.query({
          stay: $rootScope.currentStay.id,
          current_prescriptions: true,
          exclude_discharge_prescs: true
        }).$promise.then(function(currentPrescriptions) {
          return Prescription.query({
            patient: $rootScope.currentPatient.id,
            no_draft: true
          }).$promise.then(function(allPrescriptions) {
            var category, categoryPrescriptions, dispensableCategoriesIds, i, j, k, l, last_pap_date, len, len1, len2, len3, prescription, previousPrescriptionStock, ref, ref1, route, stoppedPrescription, stoppedPrescriptions;
            dispensableCategoriesIds = _.map(_.filter(categories, {
              dispensable: true
            }), "id");
            ref = _.filter(currentPrescriptions, function(prescription) {
              var ref;
              return ref = prescription.category, indexOf.call(dispensableCategoriesIds, ref) >= 0;
            });
            for (i = 0, len = ref.length; i < len; i++) {
              prescription = ref[i];
              if (prescription.data.route == null) {
                prescription.data.route = {
                  "code": "IMAGE",
                  "label": $filter('translate')('NO_ROUTE_INFO')
                };
              }
              prescription.stock = {
                cip: getCip(prescription),
                name: prescription.data.name,
                route: prescription.data.route.code,
                category: _.find(categories, {
                  id: prescription.category
                }).name
              };
              prescriptions.push(prescription);
              if ($scope.previousStock) {
                previousPrescriptionStock = getPreviousStock(prescription, allPrescriptions, $scope.previousStock.prescriptions);
                if (previousPrescriptionStock != null) {
                  if (previousPrescriptionStock.lapsing) {
                    prescription.stock.lapsing = new Date(previousPrescriptionStock.lapsing);
                  }
                  if (previousPrescriptionStock.cip !== prescription.stock.cip) {
                    prescription.stock.new_cip = true;
                    prescription.stock.previous_quantity = 0;
                  }
                  if (!previousPrescriptionStock.modified) {
                    prescription.stock.previous_quantity = previousPrescriptionStock.previous_quantity;
                    prescription.stock.previous_stock_timestamp = previousPrescriptionStock.previous_stock_timestamp || previousPrescriptionStock.stock_timestamp;
                  } else {
                    prescription.stock.previous_quantity = previousPrescriptionStock.quantity;
                    prescription.stock.stock_timestamp = previousPrescriptionStock.stock_timestamp;
                  }
                  prescription.stock.dont_deliver = previousPrescriptionStock.dont_deliver;
                }
              }
            }
            last_pap_date = null;
            ref1 = _.filter(categories, {
              dispensable: true
            });
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              category = ref1[j];
              categoryPrescriptions = _.filter(_.filter(prescriptions, {
                category: category.id
              }), function(presc) {
                return presc.state !== "STOPPED";
              });
              if (categoryPrescriptions.length > 0) {
                if (category.name === "PAP_TEMPLATE") {
                  $scope.hasPAPPrescriptions = true;
                  last_pap_date = new Date(Math.max.apply(null, _.map(categoryPrescriptions, function(presc) {
                    return moment(presc.timestamp);
                  })));
                }
                $scope.categories.push(category);
                category.routes = [];
                for (k = 0, len2 = categoryPrescriptions.length; k < len2; k++) {
                  prescription = categoryPrescriptions[k];
                  prescription.category = category;
                  route = _.find(category.routes, {
                    code: prescription.data.route.code
                  });
                  if (route == null) {
                    route = prescription.data.route;
                    route.prescriptions = [];
                    category.routes.push(route);
                  }
                  if (prescription.stock.new_cip) {
                    prescription.stock.previous_quantity = 0;
                  }
                  route.prescriptions.push(prescription);
                }
              }
            }
            stoppedPrescriptions = _.filter(_.filter(prescriptions, {
              state: "STOPPED"
            }), function(presc) {
              return moment().diff(moment(presc.expiration_time), "days") < $scope.StockStoppedDelay;
            });
            for (l = 0, len3 = stoppedPrescriptions.length; l < len3; l++) {
              stoppedPrescription = stoppedPrescriptions[l];
              route = _.find($scope.stoppedPrescriptionByRoute, {
                code: prescription.data.route.code
              });
              if (route == null) {
                route = stoppedPrescription.data.route;
                route.prescriptions = [];
                $scope.stoppedPrescriptionByRoute.push(route);
              }
              route.prescriptions.push(stoppedPrescription);
            }
            $scope.options.comment = "";
            $scope.options.stockPAP = false;
            if ($scope.hasPAPPrescriptions) {
              if (!$scope.previousStock) {
                $scope.options.stockPAP = true;
              } else {
                if (!$scope.previousStock.metadata.last_pap_stock) {
                  $scope.options.stockPAP = true;
                } else if (moment().diff(moment($scope.previousStock.metadata.last_pap_stock), "months") >= 1) {
                  $scope.options.stockPAP = true;
                } else if (last_pap_date > moment($scope.previousStock.metadata.last_pap_stock)) {
                  $scope.options.stockPAP = true;
                }
              }
            }
            return $rootScope.busy = false;
          });
        });
      });
    };
    $rootScope.busy = true;
    return SiteVarsUtils.get('STOCK_STOPPED_DELAY', 7).then(function(sitevar) {
      $scope.StockStoppedDelay = sitevar.value;
      Order.api.getLastDelivered({
        stay: $rootScope.currentStay.id
      }).$promise.then(function(lastDeliveryOrder) {
        if (lastDeliveryOrder) {
          return $scope.previousDate = lastDeliveryOrder.timestamp;
        }
      });
      return DrugStock.api.query({
        stay: $rootScope.currentStay.id
      }).$promise.then(function(stocks) {
        if (stocks.length > 0) {
          $scope.previousStock = _.first($filter('orderBy')(stocks, '-stock_timestamp'));
        }
        return $scope.handleStock();
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=stock-new-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StockController
    * @description
    * # StockController
    * Controller of Stock
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('StockListController', ["$scope", "$rootScope", "$state", "$q", "$uibModal", "$filter", "Prescription", "PrescUtils", "SiteVarsUtils", "DrugStock", "ImageDocument", "alertUtils", function($scope, $rootScope, $state, $q, $uibModal, $filter, Prescription, PrescUtils, SiteVarsUtils, DrugStock, ImageDocument, alertUtils) {
    var documentParams, stockParams;
    $scope.interfaceType = "LIST";
    $scope.printStock = function(stock) {
      if (stock.type !== "STOCK") {
        return '/webfw/pat_mgr/print_nux/' + stock.id;
      } else {
        return '/api_rest/drug_stocks/' + stock.id + '/to_pdf';
      }
    };
    $scope.toggleStockDetail = function(stock) {
      var categories, category, i, len, prescUid, prescription, prescriptions, ref, route;
      if (!stock.has_details) {
        $rootScope.busy = true;
        stock.categories = [];
        stock.stoppedPrescriptionByRoute = [];
        categories = _.map($scope.categories, _.cloneDeep);
        prescriptions = _.map($scope.prescriptions, _.cloneDeep);
        ref = Object.keys(stock.prescriptions);
        for (i = 0, len = ref.length; i < len; i++) {
          prescUid = ref[i];
          prescription = _.find(prescriptions, {
            uid: prescUid
          });
          if (prescription.data.route == null) {
            prescription.data.route = {
              "code": "IMAGE",
              "label": $filter('translate')('NO_ROUTE_INFO')
            };
          }
          prescription.stock = stock.prescriptions[prescUid];
          if (prescription.stock.is_stopped) {
            route = _.find(stock.stoppedPrescriptionByRoute, {
              code: prescription.data.route.code
            });
            if (route == null) {
              route = prescription.data.route;
              route.prescriptions = [];
              stock.stoppedPrescriptionByRoute.push(route);
            }
            route.prescriptions.push(prescription);
          } else {
            category = _.find(categories, {
              id: prescription.category
            });
            if (indexOf.call(stock.categories, category) < 0) {
              category.routes = [];
              stock.categories.push(category);
            }
            route = _.find(category.routes, {
              code: prescription.data.route.code
            });
            if (route == null) {
              route = prescription.data.route;
              route.prescriptions = [];
              category.routes.push(route);
            }
            route.prescriptions.push(prescription);
          }
        }
        stock.has_details = true;
        return $rootScope.busy = false;
      }
    };
    $rootScope.busy = true;
    if ($scope.allStays) {
      stockParams = {
        patient: $rootScope.currentPatient.id
      };
      documentParams = {
        category_code: "DRUG_STOCK",
        patient: $rootScope.currentPatient.id
      };
    } else {
      stockParams = {
        stay: $rootScope.currentStay.id
      };
      documentParams = {
        category_code: "DRUG_STOCK",
        stay: $rootScope.currentStay.id
      };
    }
    return DrugStock.api.query(stockParams).$promise.then(function(stocks) {
      return ImageDocument.api.query(documentParams).$promise.then(function(drugStockDocuments) {
        var drugStockDocument, i, len;
        for (i = 0, len = drugStockDocuments.length; i < len; i++) {
          drugStockDocument = drugStockDocuments[i];
          drugStockDocument.stock_timestamp = drugStockDocument.ctime;
        }
        return PrescUtils.getCategories().promise.then(function(categories) {
          var papCategory;
          papCategory = _.find(categories, {
            name: "PAP_TEMPLATE"
          });
          if (papCategory) {
            $scope.papBackgroundColor = papCategory.color;
            $scope.papLabel = papCategory.label;
          }
          return Prescription.query({
            patient: $rootScope.currentPatient.id,
            no_draft: true
          }).$promise.then(function(allPrescriptions) {
            $scope.prescriptions = allPrescriptions;
            $scope.categories = categories;
            _.map(stocks, function(stock) {
              return stock.type = "STOCK";
            });
            stocks = stocks.concat(drugStockDocuments);
            $scope.stocks = $filter('orderBy')(stocks, '-stock_timestamp');
            return $rootScope.busy = false;
          });
        });
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=stock-list-controller.js.map

(function() {
  angular.module('mhclientApp').factory('DateUtils', function() {
    var getMonday, getSunday, isSameWeek, isThisWeek, service, weeksBetween;
    getMonday = function(date) {
      return moment(date).isoWeekday(1);
    };
    getSunday = function(date) {
      return moment(date).isoWeekday(7);
    };
    isSameWeek = function(date1, date2) {
      return getMonday(date1).isSame(getMonday(date2), 'day');
    };
    isThisWeek = function(date) {
      return isSameWeek(date, moment());
    };
    weeksBetween = function(startDate, endDate) {
      return getMonday(endDate).diff(getMonday(startDate), "weeks");
    };
    service = {
      getMonday: getMonday,
      getSunday: getSunday,
      isSameWeek: isSameWeek,
      isThisWeek: isThisWeek,
      weeksBetween: weeksBetween
    };
    return service;
  });

}).call(this);

//# sourceMappingURL=date-utils.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:TaskPlannerCtrl
    * @description
    * # TaskPlannerCtrl
    * Controller of Message
   */
  angular.module('mhclientApp').controller('TaskPlannerCtrl', ["$scope", "$uibModal", "$rootScope", "Activity", "ThesaurusUtils", "TimeSlot", "$filter", "Task", "$state", "moment", function($scope, $uibModal, $rootScope, Activity, ThesaurusUtils, TimeSlot, $filter, Task, $state, moment) {
    var dateFormat, displayModal, ref;
    dateFormat = "YYYY-MM-DD";
    $scope.placeOptions = ThesaurusUtils.getPlaceOptions();
    $scope.collapsed = false;
    $scope.collapsedDetail = true;
    $scope.taskSelected = false;
    $scope.timeslots = TimeSlot.timeslots;
    $scope.nbShowItems = 5;
    $scope.tasksToSave = [];
    $scope.isActiveStay = $rootScope.currentStay && ((ref = $rootScope.currentStay.state) === 'PRE' || ref === 'ADM');
    $scope.addGroup = function(care_item, group_id, group_name, liberal) {
      return Activity.addGroup(care_item, group_id, group_name, liberal);
    };
    $scope.removeGroup = function(care_item, group_id, group_dict) {
      return Activity.removeGroup(care_item, group_id, group_dict);
    };
    $scope.selectWeekDay = function(week_days, week_day) {
      if (week_day.selected) {
        return week_days.push(week_day.code);
      } else {
        return week_days.splice(week_days.indexOf(week_day.code), 1);
      }
    };
    $scope.checkInUid = function(viewValue, not_in_list) {
      return function(item, index, array) {
        if ((not_in_list != null) && (not_in_list[item.uid] != null)) {
          return false;
        }
        return !viewValue || viewValue === " " || viewValue === null || item.name.toLowerCase().indexOf(viewValue.toLowerCase()) >= 0;
      };
    };
    $scope.format_dates = function(data, selected_timeslots) {
      var i, len, time_slot;
      data.timeslots = [];
      for (i = 0, len = selected_timeslots.length; i < len; i++) {
        time_slot = selected_timeslots[i];
        data.timeslots.push({
          "start_time": $scope.time_str_from_minuts(time_slot.floor),
          "end_time": $scope.time_str_from_minuts(time_slot.ceil, true)
        });
      }
      if (data.type === "dates") {
        data.dates.sort(function(left, right) {
          return left.diff(right);
        });
        data.start_date = data.dates[0].format("YYYY-MM-DD");
        data.end_date = data.dates[data.dates.length - 1].format("YYYY-MM-DD");
        return data.dates = data.dates.map(function(date) {
          return date.format("DD/MM/YYYY");
        });
      } else {
        data.dates = [];
        data.start_date = moment(data.start_date).format("YYYY-MM-DD");
        if (data.end_mode === "duration") {
          data.end_date = moment(data.start_date);
          data.end_date.add(data.duration, 'day');
          return data.end_date = data.end_date.format("YYYY-MM-DD");
        } else if (data.end_mode === "date") {
          return data.end_date = moment(data.end_date).format("YYYY-MM-DD");
        } else {
          return data.end_date = null;
        }
      }
    };
    $scope.time_str_from_minuts = function(minutes, convert_midnight) {
      var duration, hours;
      duration = moment.duration(minutes, 'minutes');
      if (convert_midnight && duration.hours() === 0) {
        return "23:59";
      }
      hours = duration.hours();
      minutes = duration.minutes() < 10 ? "0" + duration.minutes() : duration.minutes();
      return hours + ":" + minutes;
    };
    displayModal = function() {
      return $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $filter('translate')('MODAL_ATTENTION');
          },
          text: function() {
            return $filter('translate')('CONFIRM_RETURN_PRESC_LIST');
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("RETURN_BUTTON");
          }
        }
      });
    };
    $scope.dayLabel = $scope.DATETIME_FORMATS.DAY;
    return $scope.isParticularCase = function(planning_data) {
      var displayWarningMessage, liberal_count;
      liberal_count = 0;
      displayWarningMessage = false;
      _.forEach(planning_data.caregivers, function(value, key) {
        if (value.liberal) {
          liberal_count += 1;
          if (value.count > 1) {
            displayWarningMessage = true;
          }
        }
        if (liberal_count > 1) {
          return displayWarningMessage = true;
        }
      });
      return displayWarningMessage;
    };
  }]);

}).call(this);

//# sourceMappingURL=taskplanner-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:FloatingTaskCtrl
    * @description
    * # FloatingTaskCtrl
    * Provider of FloatingTaskCtrl
   */
  angular.module("mhclientApp").controller('FloatingTaskCtrl', ["$scope", "$rootScope", "$uibModalInstance", "DateUtils", "GroupUtils", "task", "sequence", "$filter", function($scope, $rootScope, $uibModalInstance, DateUtils, GroupUtils, task, sequence, $filter) {
    $scope.user = $rootScope.user.id;
    $scope.sequence = sequence;
    $scope.task = task;
    $scope.selectedDate = new Date(task.date);
    $scope.minDate = DateUtils.getMonday(task.date).format('YYYY-MM-DD');
    $scope.maxDate = moment.min([DateUtils.getSunday(task.date), moment()]).add(1, "days").format('YYYY-MM-DD');
    $scope.isDateValid = true;
    $scope.errorMsg = '';
    GroupUtils.getAllGroups().then(function(groups) {
      var group;
      group = _.find(groups, {
        id: $scope.task.group_involved
      });
      return $scope.task.caregiversCount = $scope.task.activity.planning_data.caregivers[group.uid].count;
    });
    $scope.validateDate = function(date) {
      var filterTasks, ref, result, selectedDate, tasks;
      $scope.errorMsg = '';
      if (date) {
        selectedDate = moment(date).format('YYYY-MM-DD');
        if (selectedDate < $scope.minDate || selectedDate > $scope.maxDate) {
          $scope.isDateValid = false;
          $scope.errorMsg = $filter("translate")('RESPECT_THE_INTERVAL') + moment($scope.minDate).format('DD/MM/YYYY') + ' - ' + moment($scope.maxDate).format('DD/MM/YYYY');
          return;
        }
        tasks = ((ref = $scope.sequence.dates[selectedDate]) != null ? ref.tasks[$scope.task.activity.id] : void 0) || [];
        filterTasks = function(other_task, myself) {
          var ref1;
          if (other_task.id === $scope.task.id) {
            return false;
          }
          if (other_task.group_involved !== $scope.task.group_involved) {
            return false;
          }
          if (other_task.selected) {
            return true;
          }
          if (((ref1 = other_task.status) === 'R' || ref1 === 'N') && (!myself || other_task.author === $scope.user)) {
            return true;
          }
          return false;
        };
        result = !_.some(tasks, function(t) {
          return filterTasks(t, true);
        }) && (_.filter(tasks, function(t) {
          return filterTasks(t, false);
        })).length < ($scope.task.caregiversCount || 1);
        $scope.isDateValid = result;
        if (!result) {
          return $scope.errorMsg = $filter("translate")('FLOATING_TASK_ALREADY_THERE');
        }
      } else {
        $scope.errorMsg = $filter("translate")('SELECT_A_DATE');
        return $scope.isDateValid = false;
      }
    };
    $scope.$watch('selectedDate', function(newVal, oldVal) {
      return $scope.validateDate(newVal);
    });
    $scope.cancel = function() {
      return $uibModalInstance.dismiss('cancel');
    };
    return $scope.confirm = function(selectedDate) {
      return $uibModalInstance.close(moment(selectedDate).format('YYYY-MM-DD'));
    };
  }]);

}).call(this);

//# sourceMappingURL=floating-task-controller.js.map

(function() {
  'use strict';
  angular.module("mhclientApp").controller('archiveWarningModal', ["$scope", "$rootScope", "$uibModal", "$uibModalInstance", "Sequence", "letter", function($scope, $rootScope, $uibModal, $uibModalInstance, Sequence, letter) {
    var initializeSequences;
    initializeSequences = function() {};
    $scope.sequences = [];
    $scope.loadingSequences = true;
    Sequence.api.query({
      mission_letter: letter.id
    }).$promise.then(function(sequences) {
      $scope.loadingSequences = false;
      return $scope.sequences = sequences;
    })["catch"](function(error) {
      $scope.loadingSequences = false;
      return $scope.sequences = [];
    });
    $uibModalInstance.opened.then(function() {
      return initializeSequences();
    });
    return $scope.archive = function() {
      return $uibModalInstance.close({
        archive: true
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=archive-warning-modal-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:TaskSequencesCtrl
    * @description
    * # TaskSequencesCtrl
    * Controller of Sequence realization
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('TaskSequencesCtrl', ["$scope", "$rootScope", "$uibModal", "$filter", "$window", "$q", "SequencesUtils", "Sequence", "Task", "MissionLetter", "moment", "DateUtils", "MhConfig", function($scope, $rootScope, $uibModal, $filter, $window, $q, SequencesUtils, Sequence, Task, MissionLetter, moment, DateUtils, MhConfig) {
    var addPunctualActivity, cached_weeks, canRealizeAnyTaskInActivity, canRealizeAnyTaskInSequence, canRealizeTask, canSelectTask, dateFormat, handle_dates, init, mission_letters, selected_task_dict, setdefault, updateSequenceWithPunctualTask;
    cached_weeks = {};
    dateFormat = 'YYYY-MM-DD';
    mission_letters = {};
    $scope.current_date = moment(new Date());
    $scope.today = moment(new Date()).format(dateFormat);
    selected_task_dict = {};
    $scope.data = {
      'sub_status': 'REFUSED_BY_PATIENT'
    };
    $scope.select = {
      selected_date: new Date()
    };
    $scope.goToWeekView = function() {
      $scope.additionalDays = 6;
      cached_weeks = {};
      return handle_dates();
    };
    $scope.goToDayView = function() {
      $scope.additionalDays = 1;
      cached_weeks = {};
      return handle_dates();
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      $scope.additionalDays = 1;
    } else {
      $scope.additionalDays = 6;
    }
    $scope.selected_tasks = [];
    $scope.can_create_cares = $scope.checkPermissions("MHC_CARE_CREATION", "CAN_WRITE");
    $scope.can_create_sequences = indexOf.call($scope.user.group.features, "MHC_CARE_CREATION") >= 0;
    $scope.can_realize_cares = $scope.checkPermissions("MHC_CARE_REALIZATION", "CAN_WRITE");
    $scope.can_realize_all_cares = indexOf.call($scope.user.group.features, "ALL_GROUPS_CARE_REALIZATION") >= 0;
    init = function() {
      var mlParams;
      $rootScope.busy = true;
      if ($scope.allStays) {
        mlParams = {
          patient: $rootScope.currentPatient.id
        };
      } else {
        mlParams = {
          stay: $rootScope.currentStay.id
        };
      }
      return MissionLetter.api.query(mlParams).$promise.then(function(mls) {
        mission_letters = _.keyBy(mls, 'id');
        $rootScope.busy = false;
        return handle_dates();
      });
    };
    $scope.createPunctualActivity = function() {
      var modal_dialog;
      modal_dialog = $uibModal.open({
        templateUrl: 'taskplanner/views/punctual-activity-creation-modal.html',
        controller: 'PunctualActivityCreationCtrl',
        backdrop: 'static',
        size: "lg",
        resolve: {
          sequences: function() {
            return $scope.sequences;
          },
          user: function() {
            return $scope.user;
          }
        }
      });
      return modal_dialog.result.then(function(response) {
        var activity, sequence;
        if (!response) {
          return;
        }
        $rootScope.busy = true;
        sequence = response.sequence;
        activity = response.activity;
        return Sequence.api.addPunctualActivity({
          id: sequence.id
        }, activity).$promise.then(function(updatedActivity) {
          var sequenceToUpdate;
          sequenceToUpdate = _.find($scope.sequences, {
            id: sequence.id
          });
          return addPunctualActivity(sequenceToUpdate, updatedActivity);
        })["finally"](function() {
          return $rootScope.busy = false;
        });
      });
    };
    addPunctualActivity = function(sequence, activity) {
      if ($scope.can_create_cares || activity.group_involved === $scope.user.group.uid) {
        if ($scope.current_dates.indexOf(activity.date) !== -1) {
          if (!sequence.dates) {
            sequence.dates = {};
          }
          if (!sequence.dates[activity.date]) {
            sequence.dates[activity.date] = {
              "tasks": {},
              "interval": ""
            };
          }
          if (!sequence.dates[activity.date]["tasks"][activity.id]) {
            sequence.dates[activity.date]["tasks"][activity.id] = [];
          }
          activity.sequence = sequence;
          sequence.activities.push(activity);
          return sequence.dates[activity.date]["tasks"][activity.id].push(activity);
        }
      }
    };
    handle_dates = function() {
      var i, j, newDate, ref;
      $scope.current_dates = [];
      $scope.start_date = DateUtils.getMonday($scope.current_date);
      $scope.end_date = DateUtils.getSunday($scope.current_date);
      if ($scope.additionalDays > 1) {
        newDate = moment($scope.start_date);
        for (i = j = 0, ref = $scope.additionalDays; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
          $scope.current_dates.push(newDate.format(dateFormat));
          newDate.add(1, "days");
        }
      } else {
        $scope.current_dates = [moment($scope.current_date).format(dateFormat)];
      }
      if (cached_weeks[$scope.start_date + $scope.end_date] != null) {
        $scope.sequences = cached_weeks[$scope.start_date + $scope.end_date];
        if ($scope.additionalDays === 1) {
          return _.forEach($scope.sequences, function(sequence) {
            sequence.canRealize = canRealizeAnyTaskInSequence(sequence, $scope.current_dates);
            return _.forEach(sequence.activities, function(activity) {
              activity.canRealize = canRealizeAnyTaskInActivity(sequence, activity, $scope.current_dates);
              return {};
            });
          });
        }
      } else {
        $rootScope.busy = true;
        return SequencesUtils.getSequences($rootScope.currentStay, $scope.user, $scope.can_create_cares || $scope.additionalDays === 6 || $scope.can_realize_all_cares ? null : $scope.user.group.id, $scope.start_date.format(dateFormat), $scope.end_date.format(dateFormat), addPunctualActivity, selected_task_dict, $scope.allStays ? $rootScope.currentPatient : null).then(function(patient_cares) {
          cached_weeks[$scope.start_date + $scope.end_date] = patient_cares;
          $scope.sequences = cached_weeks[$scope.start_date + $scope.end_date];
          _.forEach($scope.sequences, function(sequence) {
            sequence.canRealize = canRealizeAnyTaskInSequence(sequence, $scope.current_dates);
            return _.forEach(sequence.activities, function(activity) {
              activity.canRealize = canRealizeAnyTaskInActivity(sequence, activity, $scope.current_dates);
              return {};
            });
          });
          return $rootScope.busy = false;
        });
      }
    };
    init();
    canSelectTask = function(task) {
      if (task.date > $scope.today) {
        return false;
      }
      return canRealizeTask(task);
    };
    canRealizeTask = function(task) {
      if ($scope.can_realize_all_cares) {
        return true;
      }
      if ((task.mission_letter != null) && !((mission_letters[task.mission_letter] != null) && _.includes(mission_letters[task.mission_letter].users_involved, $scope.user.id))) {
        return false;
      }
      return ($scope.can_realize_cares || $scope.can_create_sequences) && (task.group_involved === $scope.user.group.id);
    };
    canRealizeAnyTaskInSequence = function(sequence, current_dates) {
      return _.some(current_dates || [], function(date) {
        var ref;
        return _.some(_.values(((ref = sequence.dates[date]) != null ? ref.tasks : void 0) || {}), function(tasks) {
          return _.some(tasks, function(task) {
            return canRealizeTask(task);
          });
        });
      });
    };
    canRealizeAnyTaskInActivity = function(sequence, activity, current_dates) {
      return _.some(current_dates || [], function(date) {
        var ref;
        return _.some(((ref = sequence.dates[date]) != null ? ref.tasks[activity.id] : void 0) || [], function(task) {
          return canRealizeTask(task);
        });
      });
    };
    setdefault = function(obj, key, defaultValue) {
      if (!_.has(obj, key)) {
        obj[key] = defaultValue;
      }
      return obj[key];
    };
    updateSequenceWithPunctualTask = function(sequence, data) {
      var task, taskIndex;
      task = data.task;
      taskIndex = _.findIndex(sequence.activities, function(activity) {
        return activity.id === task.id;
      });
      sequence.activities.splice(taskIndex, 1);
      data.id = new Date();
      if (!sequence.dates[task.date]) {
        sequence.dates[task.date] = {
          "tasks": {},
          "interval": ""
        };
      }
      if (!sequence.dates[task.date]["tasks"][data.id]) {
        sequence.dates[task.date]["tasks"][data.id] = [];
      }
      sequence.dates[task.date]["tasks"][data.id] = [task];
      return sequence.activities.push(data);
    };
    $scope.toggleTask = function(task, sequence) {
      var modalQueue, modal_dialog, ref;
      if (task.status === "P") {
        if (canSelectTask(task)) {
          modalQueue = $q.resolve();
          if (task.data.type === "floating" && !task.selected) {
            modalQueue = $uibModal.open({
              templateUrl: 'taskplanner/views/floating-task-modal.html',
              controller: 'FloatingTaskCtrl',
              windowClass: 'modal-small',
              backdrop: 'static',
              resolve: {
                task: function() {
                  return task;
                },
                sequence: function() {
                  return sequence;
                }
              }
            }).result.then(function(result) {
              var old_date;
              old_date = task.date;
              if (old_date !== result) {
                task.date = result;
                setdefault(setdefault(sequence.dates, result, {
                  interval: sequence.dates[old_date].interval,
                  tasks: {}
                }).tasks, task.activity.id, []).push(task);
                _.remove(sequence.dates[old_date].tasks[task.activity.id], {
                  id: task.id
                });
                if (sequence.dates[old_date].tasks[task.activity.id].length === 0) {
                  delete sequence.dates[old_date].tasks[task.activity.id];
                }
                if (Object.keys(sequence.dates[old_date].tasks).length === 0) {
                  return delete sequence.dates[old_date];
                }
              }
            });
          }
          if ((ref = task.data.selected_features) != null ? ref.length : void 0) {
            return modalQueue = modalQueue.then(function() {
              var event;
              if ($rootScope.mh_config.platform === "mgapp") {
                $window.mgapp.lock_menu(true);
              }
              event = {
                tasks: [task]
              };
              return $uibModal.open({
                templateUrl: 'taskplanner/views/task-actions.html',
                controller: 'TaskActionsCtrl',
                windowClass: 'modal-fullscreen',
                backdrop: 'static',
                resolve: {
                  event: function() {
                    return event;
                  },
                  stay: function() {
                    return $rootScope.currentStay;
                  },
                  patient: function() {
                    return $rootScope.currentPatient;
                  },
                  readonly: function() {
                    return false;
                  }
                }
              }).result.then(function(result) {
                if ($rootScope.mh_config.platform === "mgapp") {
                  return $window.mgapp.lock_menu(false);
                }
              });
            });
          } else if (task.selected) {
            return modalQueue = modalQueue.then(function() {
              $scope.selected_tasks.splice($scope.selected_tasks.indexOf(task), 1);
              delete selected_task_dict[task.id];
              return task.selected = false;
            });
          } else {
            return modalQueue = modalQueue.then(function() {
              selected_task_dict[task.id] = task;
              $scope.selected_tasks.push(task);
              task.data.duration = task.activity.data.duration;
              return task.selected = true;
            });
          }
        }
      } else if ($scope.can_create_cares && (task.planning_data != null) && task.planning_data.status === "punctual") {
        modal_dialog = $uibModal.open({
          templateUrl: 'taskplanner/views/punctual-task-validation.html',
          controller: 'PunctualTaskValidationCtrl',
          backdrop: 'static',
          scope: $scope,
          resolve: {
            task: function() {
              return task;
            },
            user: function() {
              return $scope.user;
            }
          }
        });
        return modal_dialog.result.then(function(result) {
          var action, data;
          action = result.action;
          data = result.data;
          if (action === 'validate') {
            Sequence.api.validatePunctualActivity({
              id: data.sequence
            }, data).$promise.then(function() {
              data.task.status = "R";
              return updateSequenceWithPunctualTask(sequence, data);
            });
          }
          if (action === 'refuse') {
            return Sequence.api.refusePunctualActivity({
              id: data.sequence
            }, data).$promise.then(function() {
              data.task.status = "refused";
              return updateSequenceWithPunctualTask(sequence, data);
            });
          }
        });
      }
    };
    $scope.save = function(state, data, skip) {
      var modal_dialog, modal_done;
      if (data == null) {
        data = null;
      }
      modal_done = $q.defer();
      if (state === "R" && !skip) {
        modal_dialog = $uibModal.open({
          templateUrl: 'taskplanner/views/sequence-task-validation-form.html',
          scope: $scope,
          backdrop: 'static'
        });
        modal_dialog.result.then(function(result) {
          return modal_done.resolve(result);
        });
      } else {
        modal_done.resolve(true);
      }
      return modal_done.promise.then(function(result) {
        var j, len, promises, ref, stayId, task, tasks;
        if (result) {
          promises = [];
          $rootScope.busy = true;
          ref = _.groupBy($scope.selected_tasks, "activity.stay");
          for (stayId in ref) {
            tasks = ref[stayId];
            for (j = 0, len = tasks.length; j < len; j++) {
              task = tasks[j];
              task.status = state;
              task.data = _.defaults(task.data, data);
              if (data) {
                task.data.comment = data.comment;
              }
              task.data.done_time = new Date();
              task.selected = false;
              task.author = $scope.user.id;
              task.data.user_full_name = $scope.user.first_name + " " + $scope.user.last_name;
              task.data.initials = $scope.user.user_profile.initials || "-";
              task.data.finess = $scope.user.user_profile.finess || "";
              task.activity = task.activity.id;
            }
            promises.push(Task.api.updateManyForStay({
              "stay": stayId,
              tasks: tasks
            }).$promise);
          }
          return $q.all(promises).then(function() {
            $rootScope.busy = false;
            $scope.selected_tasks = [];
            selected_task_dict = {};
            return $scope.data = {
              "sub_status": "REFUSED_BY_PATIENT"
            };
          });
        }
      });
    };
    $scope.shiftDate = function(days) {
      $scope.current_date.add(days, "days");
      return handle_dates();
    };
    $scope.change_date = function() {
      $scope.current_date = moment($scope.select.selected_date);
      return handle_dates();
    };
    return $('#datepicker').datepicker({
      format: 'mm/dd/yyyy',
      startDate: '-3d'
    });
  }]);

}).call(this);

//# sourceMappingURL=sequence-realization-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name taskplanner.cotations-computing
    * @description
    * # cotations-computing widget wich determines cotations and prices of sequence activities
   */
  angular.module('mhclientApp').directive('cotationWidget', ["$filter", "BillingUnitUtils", "SiteVarsUtils", function($filter, BillingUnitUtils, SiteVarsUtils) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var computeCotations, estimateActivitiesPrice, getBaseCost;
        if (scope.$ctrl) {
          scope = scope.$ctrl;
        }
        BillingUnitUtils.getCareBillingUnits().then(function(billing_units) {
          return scope._careBu = _.keyBy(billing_units, 'id');
        });
        getBaseCost = function(activity) {
          if (!scope._careBu || !scope._careBu[activity.data.type] || !scope._careBu[activity.data.type].current_value) {
            return 0;
          }
          return scope._careBu[activity.data.type].current_value;
        };
        scope.cotationStrategy = null;
        SiteVarsUtils.get("COTATION_STRATEGY", "NGAP").then(function(sitevar) {
          return scope.cotationStrategy = sitevar.value;
        });
        computeCotations = function() {
          var activity, fMaxPriceActivity, i, j, k, l, len, len1, len2, len3, ref, ref1, ref2, ref3, results, results1, sMaxPriceActivity;
          if (!scope.sequence.customCotations) {
            if (scope.cotationStrategy === "NGAP" && scope._careBu) {
              fMaxPriceActivity = _.maxBy(_.filter(scope.sequence.activities, function(activity) {
                return activity.planning_data.has_liberal && !activity.is_extra;
              }), function(activity) {
                return getBaseCost(activity) * activity.data.quantity;
              });
              if (fMaxPriceActivity) {
                fMaxPriceActivity.data.cotation = "100%";
                fMaxPriceActivity.data.factor = 1;
                sMaxPriceActivity = _.maxBy(_.filter(scope.sequence.activities, function(activity) {
                  return activity !== fMaxPriceActivity && activity.planning_data.has_liberal && !activity.is_extra;
                }), function(activity) {
                  return getBaseCost(activity) * activity.data.quantity;
                });
              }
              if (sMaxPriceActivity) {
                sMaxPriceActivity.data.cotation = "50%";
                sMaxPriceActivity.data.factor = 0.5;
              }
              ref = _.filter(scope.sequence.activities, function(activity) {
                return activity !== fMaxPriceActivity && activity !== sMaxPriceActivity && activity.planning_data.has_liberal && !activity.is_extra;
              });
              for (i = 0, len = ref.length; i < len; i++) {
                activity = ref[i];
                activity.data.cotation = "0%";
                activity.data.factor = 0;
              }
              ref1 = _.filter(scope.sequence.activities, function(activity) {
                return activity.is_extra;
              });
              for (j = 0, len1 = ref1.length; j < len1; j++) {
                activity = ref1[j];
                activity.data.cotation = "100%";
                activity.data.factor = 1;
              }
            }
            if (scope.cotationStrategy === "ALL_100") {
              ref2 = _.filter(scope.sequence.activities, function(activity) {
                return activity.planning_data.has_liberal;
              });
              results = [];
              for (k = 0, len2 = ref2.length; k < len2; k++) {
                activity = ref2[k];
                activity.data.cotation = "100%";
                results.push(activity.data.factor = 1);
              }
              return results;
            }
          } else {
            ref3 = _.filter(scope.sequence.activities, function(activity) {
              return activity.planning_data.has_liberal;
            });
            results1 = [];
            for (l = 0, len3 = ref3.length; l < len3; l++) {
              activity = ref3[l];
              if (activity.data.cotation === "100%") {
                activity.data.factor = 1;
              }
              if (activity.data.cotation === "50%") {
                activity.data.factor = 0.5;
              }
              if (activity.data.cotation === "0%") {
                results1.push(activity.data.factor = 0);
              } else {
                results1.push(void 0);
              }
            }
            return results1;
          }
        };
        estimateActivitiesPrice = function(activities, planning_data) {
          var activities_daily_cost, activity, factor, i, len, total_price;
          activities_daily_cost = 0;
          total_price = 0;
          for (i = 0, len = activities.length; i < len; i++) {
            activity = activities[i];
            activities_daily_cost += activity.data.factor * activity.data.quantity * getBaseCost(activity);
          }
          if (planning_data.type === "dates") {
            total_price = activities_daily_cost * (planning_data.dates || []).length;
          }
          if (planning_data.type === "cycled") {
            if (planning_data.frequency_unit === "days" && planning_data.frequency) {
              total_price = activities_daily_cost * 7 / planning_data.frequency;
            }
            if (planning_data.frequency_unit === "weeks" && planning_data.frequency && planning_data.week_days) {
              total_price = activities_daily_cost * planning_data.week_days.length / planning_data.frequency;
            }
          }
          if (planning_data.type === "floating") {
            factor = 1;
            if (planning_data.quantity) {
              factor = planning_data.quantity;
            }
            total_price = factor * activities_daily_cost;
          }
          return total_price;
        };
        return scope.estimateSequencePrice = function() {
          var activity, i, len, ref;
          _.forEach(scope.sequence.activities, function(a) {
            a.planning_data.has_liberal = _.some(a.planning_data.caregivers, 'liberal');
          });
          computeCotations();
          scope.sequence.data.price = estimateActivitiesPrice(_.filter(scope.sequence.activities, function(activity) {
            return !activity.is_extra && activity.planning_data.has_liberal;
          }), scope.sequence.planning_data);
          ref = _.filter(scope.sequence.activities, function(activity) {
            return activity.is_extra && activity.planning_data.has_liberal;
          });
          for (i = 0, len = ref.length; i < len; i++) {
            activity = ref[i];
            scope.sequence.data.price += estimateActivitiesPrice([activity], activity.planning_data);
          }
          scope.sequence.data.price = $filter('number')(scope.sequence.data.price, 2);
          return scope.sequence.data.price;
        };
      }
    };
  }]);

}).call(this);

//# sourceMappingURL=cotations-computing-directive.js.map

(function() {
  'use strict';
  angular.module("mhclientApp").factory('Task', ["$resource", "MhConfig", "$q", "BoxResource", "TimeSlot", function($resource, MhConfig, $q, BoxResource, TimeSlot) {
    var acceptHeader, api, format, portailAPI, service, task;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/tasks/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        method: 'PUT',
        headers: {
          'Accept': acceptHeader
        }
      },
      'updateManyForStay': {
        method: 'PUT',
        isArray: true,
        params: {
          route: 'update_many_for_stay'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'delete': {
        method: 'DELETE',
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    format = function(tasksGrouped) {
      var date, formatedTasks, tasks;
      formatedTasks = {};
      for (date in tasksGrouped) {
        tasks = tasksGrouped[date];
        formatedTasks[date] = {};
        tasks.forEach(function(task) {
          var timeslot;
          timeslot = TimeSlot.getMoment(task.data);
          if (!formatedTasks[date][timeslot]) {
            formatedTasks[date][timeslot] = [];
          }
          return formatedTasks[date][timeslot].push(task);
        });
      }
      return formatedTasks;
    };
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        task = window.mgapp.get('taskplanner').task();
        api = BoxResource.generate(task);
        api.updateManyForStay = function(obj) {
          return BoxResource.mhboxApiCall(task, "update_many_for_stay", obj);
        };
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api,
      format: format
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=task-service.js.map

(function() {
  angular.module("mhclientApp").factory('TimeSlot', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, addTimeSlot, getMoment, service, timeslots;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    timeslots = [
      {
        "long": "Nuit",
        "short": "N",
        "interval": [0, 6]
      }, {
        "long": "Matin",
        "short": "Mt",
        "interval": [7, 11]
      }, {
        "long": "Midi",
        "short": "M",
        "interval": [12, 14]
      }, {
        "long": "Après-midi",
        "short": "AM",
        "interval": [15, 18]
      }, {
        "long": "Soir",
        "short": "S",
        "interval": [19, 23]
      }
    ];
    getMoment = function(data) {
      var first, i, interval, len, moment;
      first = parseInt(data.start_time.split("-")[0].split(":")[0]);
      for (i = 0, len = timeslots.length; i < len; i++) {
        moment = timeslots[i];
        interval = moment.interval;
        if ((interval[0] <= first && first <= interval[1])) {
          return moment.long;
        }
      }
    };
    addTimeSlot = function(time_slots) {
      return time_slots.push({
        "floor": 0,
        "ceil": 1440,
        options: angular.copy($scope.base_slider_option)
      });
    };
    service = {
      getMoment: getMoment,
      timeslots: timeslots,
      addTimeSlot: addTimeSlot
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=timeslots-service.js.map

/*
 (c) 2013, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
*/

(function () { 'use strict';

// to suit your point format, run search/replace for '.x' and '.y';
// for 3D version, see 3d branch (configurability would draw significant performance overhead)

// square distance between 2 points
function getSqDist(p1, p2) {

    var dx = p1.x - p2.x,
        dy = p1.y - p2.y;

    return dx * dx + dy * dy;
}

// square distance from a point to a segment
function getSqSegDist(p, p1, p2) {

    var x = p1.x,
        y = p1.y,
        dx = p2.x - x,
        dy = p2.y - y;

    if (dx !== 0 || dy !== 0) {

        var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);

        if (t > 1) {
            x = p2.x;
            y = p2.y;

        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }

    dx = p.x - x;
    dy = p.y - y;

    return dx * dx + dy * dy;
}
// rest of the code doesn't care about point format

// basic distance-based simplification
function simplifyRadialDist(points, sqTolerance) {

    var prevPoint = points[0],
        newPoints = [prevPoint],
        point;

    for (var i = 1, len = points.length; i < len; i++) {
        point = points[i];

        if (getSqDist(point, prevPoint) > sqTolerance) {
            newPoints.push(point);
            prevPoint = point;
        }
    }

    if (prevPoint !== point) newPoints.push(point);

    return newPoints;
}

function simplifyDPStep(points, first, last, sqTolerance, simplified) {
    var maxSqDist = sqTolerance,
        index;

    for (var i = first + 1; i < last; i++) {
        var sqDist = getSqSegDist(points[i], points[first], points[last]);

        if (sqDist > maxSqDist) {
            index = i;
            maxSqDist = sqDist;
        }
    }

    if (maxSqDist > sqTolerance) {
        if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
        simplified.push(points[index]);
        if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
    }
}

// simplification using Ramer-Douglas-Peucker algorithm
function simplifyDouglasPeucker(points, sqTolerance) {
    var last = points.length - 1;

    var simplified = [points[0]];
    simplifyDPStep(points, 0, last, sqTolerance, simplified);
    simplified.push(points[last]);

    return simplified;
}

// both algorithms combined for awesome performance
function simplify(points, tolerance, highestQuality) {

    if (points.length <= 2) return points;

    var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;

    points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
    points = simplifyDouglasPeucker(points, sqTolerance);

    return points;
}

// export as AMD module / Node module / browser or worker variable
if (typeof define === 'function' && define.amd) define(function() { return simplify; });
else if (typeof module !== 'undefined') module.exports = simplify;
else if (typeof self !== 'undefined') self.simplify = simplify;
else window.simplify = simplify;

})();

(function() {
  'use strict';
  angular.module('mhclientApp').controller('configtoolMainCtrl', ["$scope", "$filter", "$localStorage", "$sessionStorage", "$window", "$uibModal", "$sce", "keysComparator", "Datastruct", "$rootScope", function($scope, $filter, $localStorage, $sessionStorage, $window, $uibModal, $sce, keysComparator, Datastruct, $rootScope) {
    var datastruct;
    $scope.tab = 0;
    $scope.advanceMode = false;
    $scope.model = {};
    $scope.options = {};
    $scope.config = {};
    datastruct = Datastruct.get();
    $scope.initialModel = angular.copy(datastruct.model);
    $scope.model.data = $localStorage.model || angular.copy(datastruct.model);
    $scope.$watch('model', function(newValue) {
      $localStorage.model = newValue.data;
    }, true);
    $scope.fields = datastruct.globalfields;
    $scope.setTab = function(activeTab) {
      if (activeTab === $scope.fields.validationTabNum) {
        if ($scope.checkFormValidity()) {
          $scope.tab = activeTab;
          $scope.createConfigFile();
        }
      } else {
        $scope.tab = activeTab;
      }
    };
    $scope.nextTab = function() {
      if ($scope.tab === $scope.fields.validationTabNum - 1) {
        if ($scope.checkFormValidity()) {
          $scope.tab = $scope.tab + 1;
          $scope.createConfigFile();
        }
      } else {
        $scope.tab = $scope.tab + 1;
      }
    };
    $scope.previousTab = function() {
      if ($scope.tab === $scope.fields.validationTabNum + 1) {
        if ($scope.checkFormValidity()) {
          $scope.tab = $scope.tab - 1;
          $scope.createConfigFile();
        }
      } else {
        $scope.tab = $scope.tab - 1;
      }
    };
    $scope.checkFormValidity = function() {
      if (!$scope.Form.$valid) {
        alert("Le formulaire n'est pas valide, veuillez vérifier que vous avez bien rempli tous les champs correctement.");
      }
      return $scope.Form.$valid;
    };
    $scope.createConfigFile = function() {
      $scope.dataShaping();
      return $scope.generateJson();
    };
    $scope.dataShaping = function() {
      $scope.config = angular.copy($scope.model.data);
      delete $scope.config.advanceMode;
      if ($scope.config.NUX.CATEGORIES) {
        $scope.config.NUX.CATEGORIES = $scope.config.NUX.CATEGORIES.split("\n");
      }
      if ($scope.image) {
        return $scope.config.LOGO = angular.copy($scope.image);
      }
    };
    $scope.generateJson = function() {
      $scope.modifiedDate = $filter('date')(Date.now(), 'dd-MM-yyyy');
      $scope.fileName = $scope.model.data.LABEL_TITLE + $scope.modifiedDate;
      return $scope.dataDownload = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify($scope.config));
    };
    $scope.loadConfFile = function($fileContent) {
      var doc, docs, docsinString, i, importValidator, len, modalWindow;
      importValidator = false;
      $scope.file = {};
      $scope.file.content = $fileContent;
      $scope.file.content = JSON.parse($scope.file.content);
      if ($scope.file.content.NUX !== void 0 && $scope.file.content.NUX.CATEGORIES !== void 0) {
        docs = $scope.file.content.NUX.CATEGORIES;
        docsinString = '';
        for (i = 0, len = docs.length; i < len; i++) {
          doc = docs[i];
          docsinString = docsinString + doc + "\n";
        }
        $scope.file.content.NUX.CATEGORIES = docsinString;
        console.log("keysequality" + keysComparator.evaluate($scope.file.content, $scope.model.data));
      }
      if (keysComparator.evaluate($scope.file.content, $scope.model.data)) {
        return $scope.loadModel();
      } else {
        modalWindow = $scope.init_modal();
        return modalWindow.result.then(function(choice) {
          if (choice) {
            return $scope.loadModel();
          }
        });
      }
    };
    $scope.loadModel = function() {
      $scope.image = angular.copy($scope.file.content.LOGO);
      $scope.model.data = angular.copy($scope.file.content);
      return $window.location.reload();
    };
    $scope.printForm = function() {
      document.title = $scope.fileName;
      return window.print();
    };
    $scope.convertToString = function(jason) {
      return JSON.stringify(jason);
    };
    $scope.resetForm = function() {
      $scope.model.data = angular.copy($scope.initialModel);
      $scope.Form.$setPristine();
      $scope.setTab(0);
    };
    $scope.init_modal = function() {
      var pr;
      pr = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return $sce.trustAsHtml("Fichier importé généré à partir d'une version différente de l'application");
          },
          text: function() {
            return $sce.trustAsHtml("Le fichier que vous êtes sur le point d'importer a été généré à partir d'une autre version de l'application. Vous risquez de ne pas avoir accès à tous les paramètres.<br/>" + "Souhaitez-vous tout de même l'importer?");
          },
          cancelButtonText: function() {
            return $sce.trustAsHtml("Annuler");
          },
          noButtonText: function() {
            return $sce.trustAsHtml("Ne pas importer");
          },
          okButtonText: function() {
            return $sce.trustAsHtml("Importer");
          }
        }
      });
      return pr;
    };
    if ($rootScope.mh_config.platform === "mgapp") {
      return window.mgappConfirmQuit = window.mgapp.quit_view;
    }
  }]);

}).call(this);

//# sourceMappingURL=config-tool-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.configtool:previewDisplay
    * @description
    * # previewDisplay
    * Convert model data to user-friendly diplay for the summary
   */
  angular.module('mhclientApp').filter('previewDisplay', function() {
    return function(bool) {
      var output;
      if (typeof bool === 'boolean') {
        if (bool) {
          output = 'oui';
        } else {
          output = 'non';
        }
      } else {
        output = bool;
      }
      return output;
    };
  });

}).call(this);

//# sourceMappingURL=preview-display-filter.js.map

// angular-formly-templates-bootstrap version 6.0.0 built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us> (ó ì_í)=óò=(ì_í ò)

!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t(require("angular"),require("api-check"),require("angular-formly")):"function"==typeof define&&define.amd?define(["angular","api-check","angular-formly"],t):"object"==typeof exports?exports.ngFormlyTemplatesBootstrap=t(require("angular"),require("api-check"),require("angular-formly")):e.ngFormlyTemplatesBootstrap=t(e.angular,e.apiCheck,e.ngFormly)}(this,function(e,t,o){return function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){"use strict";e.exports=o(2)},function(e,t,o){"use strict";var n=o(20);n.version||(n=window.angular),e.exports=n},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="formlyBootstrap",r=o(1),i=r.module(n,[o(22)]);i.constant("formlyBootstrapApiCheck",o(21)({output:{prefix:"angular-formly-bootstrap"}})),i.constant("formlyBootstrapVersion","6.0.0"),o(13)(i),o(7)(i),o(5)(i),t["default"]=n,e.exports=t["default"]},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){
t.$inject = ["e", "t"];function t(e,t){var n=o(14),r=t.shape({"class":t.string.optional,text:t.string.optional,onClick:t.func.optional}).strict.optional,i=t.shape({templateOptions:t.shape({addonLeft:r,addonRight:r})});e.templateManipulators.preWrapper.push(function(e,o){return o.templateOptions.addonLeft||o.templateOptions.addonRight?(t.warn([i],[o]),n.replace("<formly-transclude></formly-transclude>",e)):e})}e.run(t),t.$inject=["formlyConfig","formlyBootstrapApiCheck"]},e.exports=t["default"]},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){
t.$inject = ["e"];function t(e){e.templateManipulators.preWrapper.push(function(e,t,o){if(angular.isDefined(t.templateOptions.description)){var n=document.createElement("div");n.appendChild(angular.element(e)[0]),n.appendChild(angular.element('<p id="'+o.id+'_description"class="help-block"ng-if="to.description">{{to.description}}</p>')[0]);var r=angular.element(n.querySelectorAll("[ng-model]"));return r&&r.attr("aria-describedby",o.id+"_description"),n.innerHTML}return e})}e.run(t),t.$inject=["formlyConfig"]},e.exports=t["default"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(t,"__esModule",{value:!0});var r=o(3),i=n(r),a=o(4),l=n(a);t["default"]=function(e){i["default"](e),l["default"](e)},e.exports=t["default"]},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){
t.$inject = ["e"];function t(e){e.setType({name:"checkbox",template:o(15),wrapper:["bootstrapHasError"],apiCheck:function(e){return{templateOptions:{label:e.string}}}})}e.config(t),t.$inject=["formlyConfigProvider"]},e.exports=t["default"]},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){o(6)(e),o(9)(e),o(8)(e),o(10)(e),o(11)(e),o(12)(e)},e.exports=t["default"]},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){
t.$inject = ["e"];function t(e){e.setType({name:"input",template:'<input class="form-control" ng-model="model[options.key]">',wrapper:["bootstrapLabel","bootstrapHasError"]})}e.config(t),t.$inject=["formlyConfigProvider"]},e.exports=t["default"]},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){
t.$inject = ["e"];function t(e){e.setType({name:"multiCheckbox",template:o(16),wrapper:["bootstrapLabel","bootstrapHasError"],apiCheck:function(e){return{templateOptions:{options:e.arrayOf(e.object),labelProp:e.string.optional,valueProp:e.string.optional}}},defaultOptions:{noFormControl:!1,ngModelAttrs:{required:{attribute:"",bound:""}}},controller:["$scope",function(e){function t(t){var o;e.to.required&&(o=angular.isArray(e.model[r.key])&&e.model[r.key].length>0&&t,e.fc.$setValidity("required",o))}function o(){e.model[r.key]=[],angular.forEach(e.multiCheckbox.checked,function(t,o){t&&e.model[r.key].push(n.options[o][n.valueProp||"value"])}),e.fc.$setTouched(),t(!0)}var n=e.to,r=e.options;if(e.multiCheckbox={checked:[],change:o},e.$watch("model",function(t){var o,i;Object.keys(t).length&&(o=t[r.key],e.$watch("to.options",function(t){if(t&&Array.isArray(t)&&Array.isArray(o)){i=n.valueProp||"value";for(var r=0;r<t.length;r++)e.multiCheckbox.checked[r]=-1!==o.indexOf(t[r][i])}}))},!0),r.expressionProperties&&r.expressionProperties["templateOptions.required"]&&e.$watch(function(){return e.to.required},function(e){t(e)}),e.to.required)var i=e.$watch("fc",function(e){e&&(t(!0),i())})}]})}e.config(t),t.$inject=["formlyConfigProvider"]},e.exports=t["default"]},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){
t.$inject = ["e"];function t(e){e.setType({name:"radio",template:o(17),wrapper:["bootstrapLabel","bootstrapHasError"],defaultOptions:{noFormControl:!1},apiCheck:function(e){return{templateOptions:{options:e.arrayOf(e.object),labelProp:e.string.optional,valueProp:e.string.optional}}}})}e.config(t),t.$inject=["formlyConfigProvider"]},e.exports=t["default"]},function(e,t,o){"use strict";function n(e,t,o){return Object.defineProperty(e,t,{value:o,enumerable:!0,configurable:!0,writable:!0})}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){function t(e){e.setType({name:"select",template:o,wrapper:["bootstrapLabel","bootstrapHasError"],defaultOptions:function(e){var t=e.templateOptions.ngOptions||"option[to.valueProp || 'value'] as option[to.labelProp || 'name'] group by option[to.groupProp || 'group'] for option in to.options";return{ngModelAttrs:n({},t,{value:"ng-options"})}},apiCheck:function(e){return{templateOptions:{options:e.arrayOf(e.object),labelProp:e.string.optional,valueProp:e.string.optional,groupProp:e.string.optional}}}})}e.config(t);var o='<select class="form-control" ng-model="model[options.key]"></select>';t.$inject=["formlyConfigProvider"]},e.exports=t["default"]},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){
t.$inject = ["e"];function t(e){e.setType({name:"textarea",template:'<textarea class="form-control" ng-model="model[options.key]"></textarea>',wrapper:["bootstrapLabel","bootstrapHasError"],defaultOptions:{ngModelAttrs:{rows:{attribute:"rows"},cols:{attribute:"cols"}}},apiCheck:function(e){return{templateOptions:{rows:e.number.optional,cols:e.number.optional}}}})}e.config(t),t.$inject=["formlyConfigProvider"]},e.exports=t["default"]},function(e,t,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){
t.$inject = ["e"];function t(e){e.setWrapper([{name:"bootstrapLabel",template:o(19),apiCheck:function(e){return{templateOptions:{label:e.string,required:e.bool.optional}}}},{name:"bootstrapHasError",template:o(18)}])}e.config(t),t.$inject=["formlyConfigProvider"]},e.exports=t["default"]},function(e,t,o){e.exports='<div ng-class="{\'input-group\': to.addonLeft || to.addonRight}">\n    <div class="input-group-addon"\n         ng-if="to.addonLeft"\n         ng-style="{cursor: to.addonLeft.onClick ? \'pointer\' : \'inherit\'}"\n         ng-click="to.addonLeft.onClick(options, this)">\n        <i class="{{to.addonLeft.class}}" ng-if="to.addonLeft.class"></i>\n        <span ng-if="to.addonLeft.text">{{to.addonLeft.text}}</span>\n    </div>\n    <formly-transclude></formly-transclude>\n    <div class="input-group-addon"\n         ng-if="to.addonRight"\n         ng-style="{cursor: to.addonRight.onClick ? \'pointer\' : \'inherit\'}"\n         ng-click="to.addonRight.onClick(options, this)">\n        <i class="{{to.addonRight.class}}" ng-if="to.addonRight.class"></i>\n        <span ng-if="to.addonRight.text">{{to.addonRight.text}}</span>\n    </div>\n</div>\n'},function(e,t,o){e.exports='<div class="checkbox">\n	<label>\n		<input type="checkbox"\n           class="formly-field-checkbox"\n		       ng-model="model[options.key]">\n		{{to.label}}\n		{{to.required ? \'*\' : \'\'}}\n	</label>\n</div>\n'},function(e,t,o){e.exports='<div class="radio-group">\n  <div ng-repeat="(key, option) in to.options" class="checkbox">\n    <label>\n      <input type="checkbox"\n             id="{{id + \'_\'+ $index}}"\n             ng-model="multiCheckbox.checked[$index]"\n             ng-change="multiCheckbox.change()">\n      {{option[to.labelProp || \'name\']}}\n    </label>\n  </div>\n</div>\n'},function(e,t,o){e.exports='<div class="radio-group">\n  <div ng-repeat="(key, option) in to.options" class="radio">\n    <label>\n      <input type="radio"\n             id="{{id + \'_\'+ $index}}"\n             tabindex="0"\n             ng-value="option[to.valueProp || \'value\']"\n             ng-model="model[options.key]">\n      {{option[to.labelProp || \'name\']}}\n    </label>\n  </div>\n</div>\n'},function(e,t,o){e.exports='<div class="form-group" ng-class="{\'has-error\': showError}">\n  <formly-transclude></formly-transclude>\n</div>\n'},function(e,t,o){e.exports='<div>\n  <label for="{{id}}" class="control-label" ng-if="to.label">\n    {{to.label}}\n    {{to.required ? \'*\' : \'\'}}\n  </label>\n  <formly-transclude></formly-transclude>\n</div>\n'},function(t,o,n){t.exports=e},function(e,o,n){e.exports=t},function(e,t,n){e.exports=o}])});
//# sourceMappingURL=angular-formly-templates-bootstrap.min.js.map
(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.configtool:function
    * @description
    * # keysComparator
    * Compare the keys of two Javascript Objets returns a boolean
   */
  angular.module('mhclientApp').factory('keysComparator', function() {
    return {
      evaluate: function(obj1, obj2) {
        return JSON.stringify(Object.keys(obj1).sort()) === JSON.stringify(Object.keys(obj2).sort());
      }
    };
  });

}).call(this);

//# sourceMappingURL=keys-comparator-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:datastruct
    * @description
    * # datastruct
    * Factory of datastruct for configtool
   */
  angular.module("mhclientApp").factory('Datastruct', function() {
    var Datastruct;
    Datastruct = {
      model: {
        coord: {}
      },
      globalfields: {
        validationTabNum: 5,
        tabNames: [
          {
            name: 'Coordonnées',
            advance: false
          }, {
            name: 'Général',
            advance: true
          }, {
            name: 'Plan de soin',
            advance: true
          }, {
            name: 'Docs numérisés',
            advance: false
          }, {
            name: 'Importer un logo',
            advance: false
          }, {
            name: 'Validation',
            advance: false
          }, {
            name: 'Importer une configuration',
            advance: false
          }, {
            name: 'Réinitialiser le formulaire',
            advance: false
          }
        ],
        schema: [
          [
            {
              key: 'LABEL_TITLE',
              type: 'horizontalInputWithLegend',
              id: 'LABEL_TITLE_input',
              templateOptions: {
                label: 'Nom du client:',
                type: 'text',
                placeholder: 'Nom du client',
                description: 'Ce nom apparaîtra à l\'écran d\'accueil du portail et sur certains documents.',
                required: true,
                legend: 'Coordonnées',
                preview: {
                  label: 'Nom du client:'
                }
              }
            }, {
              key: 'adresse',
              type: 'horizontalInput',
              id: 'adresse_input',
              model: 'model.coord',
              templateOptions: {
                label: 'Adresse:',
                type: 'text',
                placeholder: '2 rue des coquelicots',
                required: true,
                preview: {
                  label: 'Adresse:'
                }
              }
            }, {
              key: 'postCode',
              type: 'horizontalInput',
              id: 'postCode_input',
              model: 'model.coord',
              templateOptions: {
                label: 'Code postal:',
                type: 'text',
                placeholder: '31100',
                required: true,
                preview: {
                  label: 'Code postal:'
                }
              }
            }, {
              key: 'city',
              type: 'horizontalInput',
              model: 'model.coord',
              id: 'city_input',
              templateOptions: {
                label: 'Ville:',
                type: 'text',
                placeholder: 'Toulouse',
                required: true,
                preview: {
                  label: 'Ville:'
                }
              }
            }, {
              key: 'EMAIL',
              type: 'horizontalInput',
              id: 'EMAIL_input',
              templateOptions: {
                label: 'E-mail:',
                type: 'email',
                placeholder: 'nom.prenom@exemple.fr',
                required: true,
                preview: {
                  label: 'E-Mail:'
                }
              }
            }, {
              key: 'PHONE_NUMBER',
              type: 'horizontalInput',
              id: 'PHONE_NUMBER_input',
              templateOptions: {
                label: 'Téléphone:',
                type: 'text',
                placeholder: '0981481340',
                required: true,
                preview: {
                  label: 'Téléphone:'
                }
              }
            }, {
              key: 'FAX_NUMBER',
              type: 'horizontalInput',
              id: 'FAX_NUMBER_input',
              templateOptions: {
                label: 'Fax:',
                type: 'text',
                placeholder: '0981481340',
                preview: {
                  label: 'Fax:'
                }
              }
            }
          ], [
            {
              key: 'NB_ENTRIES_IN_LIST',
              type: 'horizontalSelectWithLegend',
              defaultValue: 20,
              templateOptions: {
                label: 'Nombre d\'éléments affichés par liste:',
                legend: 'Général',
                options: [
                  {
                    name: '10',
                    value: 10
                  }, {
                    name: '20',
                    value: 20
                  }, {
                    name: '50',
                    value: 50
                  }, {
                    name: '100',
                    value: 100
                  }
                ],
                preview: {
                  label: 'Nombre d\'éléments affichés par liste'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'NB_ENTRIES_IN_LIST',
              type: 'horizontalInputWithLegend',
              templateOptions: {
                label: 'Nombre d\'éléments affichés par liste:',
                legend: 'Général',
                type: 'number',
                preview: {
                  label: 'Nombre d\'éléments affichés par liste'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'MAX_MULTISELECT_DATA',
              type: 'horizontalInput',
              defaultValue: 10000,
              templateOptions: {
                label: 'Taille maximum du multi-select:',
                type: 'number',
                preview: {
                  label: 'Taille maximum du multi-select:'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'NEW_STYLE_SVC',
              type: 'horizontalCheckbox',
              defaultValue: false,
              hideExpression: '!model.advanceMode',
              templateOptions: {
                label: 'Envoi du nouveau protocole SVC',
                preview: {
                  label: 'Envoi du nouveau protocole SVC'
                }
              }
            }, {
              key: 'ANONYMOUS_GEN_OTP',
              type: 'horizontalCheckbox',
              defaultValue: false,
              hideExpression: '!model.advanceMode',
              templateOptions: {
                label: 'Autoriser la génération de mot de passe temporaire par un utilisateur anonyme',
                description: 'Dans le cas d\' une intervention au domicile du patient, les intervenants peuvent bénéficier d\'un accès temporaire accordé par un membre du personnel hospitalier.',
                preview: {
                  label: 'Autoriser la génération de mot de passe temporaire par un utilisateur anonyme'
                }
              }
            }, {
              key: 'OTP_INTERVAL',
              type: 'horizontalInput',
              defaultValue: 30,
              templateOptions: {
                label: 'Durée de validité du mot de passe temporaire en secondes:',
                type: 'number',
                preview: {
                  label: 'Durée de validité du mot de passe temporaire:',
                  suffix: 'secondes'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'CPS_ALLOWED',
              type: 'horizontalRadioWithLegend',
              defaultValue: false,
              templateOptions: {
                description: 'Si activé, les professionels de santé peuvent s\'identifier sur la MHBox avec leur carte CPS au lieu de leur mot de passe.',
                label: 'Autoriser l\'identification par carte CPS:',
                legend: 'Utilisateurs',
                options: [
                  {
                    name: 'oui',
                    value: true
                  }, {
                    name: 'non',
                    value: false
                  }
                ],
                preview: {
                  label: 'Autoriser l\'identification par carte CPS:'
                }
              }
            }, {
              key: 'LOGIN_DISPLAY_MODE',
              type: 'horizontalRadio',
              defaultValue: false,
              templateOptions: {
                description: 'Si activé, les identifiants des utilisateurs seront visibles sur le portail en plus de leur nom et leur prénom.',
                label: 'Voir les identifiants des utilisateurs sur le portail:',
                options: [
                  {
                    name: 'oui',
                    value: true
                  }, {
                    name: 'non',
                    value: false
                  }
                ],
                preview: {
                  label: 'Voir les logins utilisateurs sur le portail:'
                }
              }
            }, {
              key: 'FOLLOW_ALL_PATIENTS',
              type: 'horizontalRadioWithLegend',
              defaultValue: false,
              templateOptions: {
                description: 'Si activé, les utilisateurs sont automatiquement abonnés aux notifications des patients auxquels ils sont associés.',
                label: 'Abonnement automatique aux notifications des patients lors d\'une association:',
                legend: 'Patients',
                options: [
                  {
                    name: 'oui',
                    value: true
                  }, {
                    name: 'non',
                    value: false
                  }
                ],
                preview: {
                  label: 'Suivi automatique de tous les patients par les utilisateurs:'
                }
              }
            }, {
              key: 'SHOW_ALL_STAYS_FOR_ALL_USERS',
              type: 'horizontalRadio',
              defaultValue: false,
              templateOptions: {
                description: 'Si activé, les utilisateurs peuvent consulter les dossiers de tous les patients sans être abonnés.',
                label: 'Visibilité des patients par tous les utilisateurs:',
                options: [
                  {
                    name: 'oui',
                    value: true
                  }, {
                    name: 'non',
                    value: false
                  }
                ],
                preview: {
                  label: 'Visibilité des patients par tous les utilisateurs:'
                }
              }
            }, {
              key: 'DAYS_SHOWN_BEFORE_STAY',
              type: 'horizontalSelect',
              defaultValue: 7,
              templateOptions: {
                label: 'Voir les données du séjour précédent sur:',
                description: 'Détermine sur combien de jours du séjour précédent, les données médicales sont accessibles.',
                options: [
                  {
                    name: '7 jours',
                    value: 7
                  }, {
                    name: '15 jours',
                    value: 15
                  }, {
                    name: '30 jours',
                    value: 30
                  }, {
                    name: 'tout voir',
                    value: 30000
                  }
                ],
                preview: {
                  label: 'Voir les données du séjour précédent sur:',
                  suffix: 'jours'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'DAYS_SHOWN_BEFORE_STAY',
              type: 'horizontalInput',
              templateOptions: {
                label: 'Voir les données du séjour précédent sur combien de jours:',
                type: 'number',
                description: 'Détermine sur combien de jours du séjour précédent, les données médicales sont accessibles.',
                preview: {
                  label: 'Voir les données du séjour précédent sur:',
                  suffix: 'jours'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'LASTVISIT_DELAY',
              type: 'horizontalSelectWithLegend',
              defaultValue: 0,
              templateOptions: {
                label: 'Durée de visibilité des notifications après visionnage:',
                description: 'Après avoir cliqué sur le bouton "vu" d\'une notification, elle peut rester affichée quelques minutes.',
                legend: 'Notifications',
                options: [
                  {
                    name: 'jamais',
                    value: 0
                  }, {
                    name: '5 minutes',
                    value: 5
                  }, {
                    name: '10 minutes',
                    value: 10
                  }, {
                    name: '30 minutes',
                    value: 30
                  }
                ],
                preview: {
                  label: 'Durée de visibilité des notifications après visionnage:',
                  suffix: 'minutes'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'LASTVISIT_DELAY',
              type: 'horizontalInput',
              templateOptions: {
                label: 'Durée de visibilité des notifications après visionnage:',
                type: 'number',
                description: 'Après avoir cliqué sur le bouton "vu" d\'une notification, elle peut rester affichée quelques minutes.',
                preview: {
                  label: 'Durée de visibilité des notifications après visionnage:',
                  suffix: 'minutes'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'MAX_TIME_NEW_EVENTS',
              type: 'horizontalSelect',
              defaultValue: 7,
              templateOptions: {
                label: 'Délai de suppression des alertes et notifications non consultées:',
                options: [
                  {
                    name: '5 jours',
                    value: 5
                  }, {
                    name: '7 jours',
                    value: 7
                  }, {
                    name: '10 jours',
                    value: 10
                  }, {
                    name: '15 jours',
                    value: 15
                  }
                ],
                preview: {
                  label: 'Délai de suppression des alertes et notifications non consultées:',
                  suffix: 'jours'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'MAX_TIME_NEW_EVENTS',
              type: 'horizontalInput',
              templateOptions: {
                label: 'Délai de suppression, en jours, des alertes et notifications non consultées:',
                type: 'number',
                preview: {
                  label: 'Délai de suppression des alertes et notifications non consultées:',
                  suffix: 'jours'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'FORM_HISTORY_DEPTH',
              type: 'horizontalInput',
              defaultValue: 0,
              templateOptions: {
                label: 'Nombre maximum de formulaires affichés dans l\'historique:',
                type: 'number',
                preview: {
                  label: 'Nombre maximum de formulaires affichés dans l\'historique:'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'EXPIRATION_VISIBILITY_DELAY',
              type: 'horizontalSelectWithLegend',
              defaultValue: 2,
              templateOptions: {
                label: 'Durée de visibilité des prescriptions arrêtées sur MHbox:',
                legend: 'MHBox',
                options: [
                  {
                    name: '0 jour',
                    value: 0
                  }, {
                    name: '1 jour',
                    value: 1
                  }, {
                    name: '2 jours',
                    value: 2
                  }, {
                    name: '3 jours',
                    value: 3
                  }, {
                    name: '5 jours',
                    value: 5
                  }, {
                    name: '7 jours',
                    value: 7
                  }
                ],
                preview: {
                  label: 'Durée de visibilité des prescriptions arrêtées sur MHbox:',
                  suffix: 'jours'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'EXPIRATION_VISIBILITY_DELAY',
              type: 'horizontalInputWithLegend',
              templateOptions: {
                label: 'Durée de visibilité, en jours,  des prescriptions arrêtées sur MHbox:',
                type: 'number',
                legend: 'MHBox',
                preview: {
                  label: 'Durée de visibilité, en jours,  des prescriptions arrêtées sur MHbox:',
                  suffix: 'jours'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'IMPORT_METHOD',
              type: 'horizontalSelectWithLegend',
              defaultValue: 'default',
              templateOptions: {
                label: 'Méthode d\'importation:',
                legend: 'Importation',
                options: [
                  {
                    name: 'default',
                    value: 'default'
                  }
                ],
                preview: {
                  label: 'Méthode d\'importation:'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'DBIMP_MAP_GROUPS',
              type: 'horizontalCheckbox',
              defaultValue: true,
              templateOptions: {
                label: 'Utilisation d\'un mapping sur les noms des groupes lors de l\'importation',
                preview: {
                  label: 'Utilisation d\'un mapping sur les noms des groupes lors de l\'importation'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'DBIMP_REJECT_UNKNOWN_GROUPS',
              type: 'horizontalCheckbox',
              defaultValue: true,
              templateOptions: {
                label: 'Ignorer les utilisateurs de groupe inconnu lors de l\'importation',
                preview: {
                  label: 'Ignorer les utilisateurs de groupe inconnu lors de l\'importation'
                }
              },
              hideExpression: '!model.advanceMode'
            }
          ], [
            {
              key: 'NEW_STAY_EXPIRE_PRESCRIPTION',
              type: 'horizontalRadioWithLegend',
              defaultValue: false,
              templateOptions: {
                label: 'Arrêt automatique des prescriptions lors d\'un nouveau séjour:',
                description: 'Si activé, lors d\'un nouveau séjour les prescriptions de l\'ancien séjour sont automatiquement arrêtées.',
                legend: 'Prescriptions',
                options: [
                  {
                    name: 'oui',
                    value: true
                  }, {
                    name: 'non',
                    value: false
                  }
                ],
                preview: {
                  label: 'Arrêt automatique des prescriptions lors d\'un nouveau séjour:'
                }
              }
            }, {
              key: 'SHOW_EXPIRED_ORQ_DURATION',
              type: 'horizontalSelect',
              defaultValue: 7,
              templateOptions: {
                label: 'Durée de visibilité par l\'administrateur des prescriptions arrêtées sur le portail:',
                description: 'Lorsqu\'une prescription est arrêtée, elle est barrée en rouge et reste visible pendant un certain temps sur le portail.',
                options: [
                  {
                    name: '1 jours',
                    value: 1
                  }, {
                    name: '3 jours',
                    value: 3
                  }, {
                    name: '5 jours',
                    value: 5
                  }, {
                    name: '7 jours',
                    value: 7
                  }
                ],
                preview: {
                  label: 'Durée de visibilité des prescriptions arrêtées sur le portail:',
                  suffix: 'jours'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'SHOW_EXPIRED_ORQ_DURATION',
              type: 'horizontalInput',
              templateOptions: {
                label: 'Durée de visibilité, en jours,  des prescriptions arrêtées sur le portail:',
                type: 'number',
                description: 'Lorsqu\'une prescription est arrêtée, elle est barrée en rouge et reste visible pendant un certain temps sur le portail.',
                preview: {
                  label: 'Durée de visibilité des prescriptions arrêtées sur le portail:',
                  suffix: 'jours'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'RENEW_ALL_EXPIRED_DELAY',
              type: 'horizontalSelect',
              defaultValue: 7,
              templateOptions: {
                label: 'Renouvellement général appliqué aux prescriptions arrêtées il y a moins de:',
                description: 'Une fonction du portail permet de renouveller toutes les prescriptions arrêtées depuis un certain nombre de jours.',
                options: [
                  {
                    name: '1 jour',
                    value: 1
                  }, {
                    name: '3 jours',
                    value: 3
                  }, {
                    name: '5 jours',
                    value: 5
                  }, {
                    name: '7 jours',
                    value: 7
                  }
                ],
                preview: {
                  label: 'Renouvellement général des prescriptions arrêtées il y a moins de:',
                  suffix: 'jours'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'RENEW_ALL_EXPIRED_DELAY',
              type: 'horizontalInput',
              templateOptions: {
                label: 'Renouvellement général appliqué aux prescriptions arrêtées il y a moins de (jours):',
                type: 'number',
                description: 'Une fonction du portail permet de renouveller toutes les prescriptions arrêtées depuis un certain nombre de jours.',
                preview: {
                  label: 'Renouvellement général des prescriptions arrêtées il y a moins de:',
                  suffix: 'jours'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'TASK_CANCEL_DELAY',
              type: 'horizontalSelectWithLegend',
              defaultValue: 5,
              templateOptions: {
                label: 'Délai de suppression d\'une administration sur le portail:',
                description: 'Lorsque l\'administration d\'un médicament est réalisée sur le plan de soin elle peut être supprimée pendant quelques minutes, en cas d\'erreur  par exemple.',
                legend: 'Administrations',
                options: [
                  {
                    name: '5 minutes',
                    value: 5
                  }, {
                    name: '10 minutes',
                    value: 10
                  }, {
                    name: '15 minutes',
                    value: 15
                  }
                ],
                preview: {
                  label: 'Délai de suppression d\'une administration sur le portail:',
                  suffix: 'minutes'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'TASK_CANCEL_DELAY',
              type: 'horizontalInputWithLegend',
              templateOptions: {
                label: 'Délai, en minutes, de suppression d\'une administration sur le portail:',
                type: 'number',
                legend: 'Administrations',
                description: 'Lorsque l\'administration d\'un médicament est réalisée sur le plan de soin elle peut être supprimée pendant quelques minutes, en cas d\'erreur  par exemple.',
                preview: {
                  label: 'Délai de suppression d\'une administration sur le portail:',
                  suffix: 'minutes'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'TASK_REVALIDATE_MAX_DELAY',
              type: 'horizontalSelect',
              defaultValue: 24,
              templateOptions: {
                label: 'Délai, en heures, de modification d\'une administration sur le portail:',
                description: 'Lorsque l\'administration d\'un médicament est réalisée sur le plan de soin elle peut être modifiée pendant quelques minutes, en cas d\'erreur  par exemple.',
                options: [
                  {
                    name: '24 heures',
                    value: 24
                  }, {
                    name: '48 heures',
                    value: 48
                  }, {
                    name: 'jamais',
                    value: 0
                  }
                ],
                preview: {
                  label: 'Délai de modification d\'une administration sur le portail:',
                  suffix: 'heures'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'TASK_REVALIDATE_MAX_DELAY',
              type: 'horizontalInput',
              templateOptions: {
                label: 'Délai, en heures, de modification d\'une administration sur le portail:',
                type: 'number',
                description: 'Lorsque l\'administration d\'un médicament est réalisée sur le plan de soin elle peut être modifiée pendant quelques minutes, en cas d\'erreur  par exemple.',
                preview: {
                  label: 'Délai de modification d\'une administration sur le portail:',
                  suffix: 'heures'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'EXPIRE_DELAY',
              type: 'horizontalSelect',
              defaultValue: 7,
              templateOptions: {
                label: 'Avertissement des prescriptions expirant dans:',
                description: 'Un message d\'avertissement apparaît sur les prescriptions s\'arrêtant bientôt.',
                options: [
                  {
                    name: '1 jour',
                    value: 1
                  }, {
                    name: '3 jours',
                    value: 3
                  }, {
                    name: '5 jours',
                    value: 5
                  }, {
                    name: '7 jours',
                    value: 7
                  }
                ],
                preview: {
                  label: 'Avertissement des prescriptions expirant dans:',
                  suffix: 'jours'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'EXPIRE_DELAY',
              type: 'horizontalInput',
              templateOptions: {
                label: 'Avertissement des prescriptions expirant dans combien de jours:',
                type: 'number',
                description: 'Un message d\'avertissement apparaît sur les prescriptions s\'arrêtant bientôt.',
                preview: {
                  label: 'Avertissement des prescriptions expirant dans:',
                  suffix: 'jours'
                }
              },
              hideExpression: '!model.advanceMode'
            }, {
              key: 'DISPENSATION_ABOUT_TO_EXPIRED_BEFORE',
              type: 'horizontalSelectWithLegend',
              defaultValue: 2,
              templateOptions: {
                label: 'Avertissement des dispensations s\'arrêtant dans:',
                description: 'Un message d\'avertissement apparaît sur les dispensations s\'arrêtant bientôt.',
                legend: 'Dispensations',
                options: [
                  {
                    name: '1 jour',
                    value: 1
                  }, {
                    name: '2 jours',
                    value: 2
                  }, {
                    name: '5 jours',
                    value: 5
                  }, {
                    name: '7 jours',
                    value: 7
                  }
                ],
                preview: {
                  label: 'Avertissement des dispensations s\'arrêtant dans:',
                  suffix: 'jours'
                }
              },
              hideExpression: 'model.advanceMode'
            }, {
              key: 'DISPENSATION_ABOUT_TO_EXPIRED_BEFORE',
              type: 'horizontalInput',
              templateOptions: {
                label: 'Avertissement des dispensations s\'arrêtant dans combien de jours:',
                type: 'number',
                description: 'Un message d\'avertissement apparaît sur les dispensations s\'arrêtant bientôt.',
                legend: 'Dispensations',
                preview: {
                  label: 'Avertissement des dispensations s\'arrêtant dans:',
                  suffix: 'jours'
                }
              },
              hideExpression: '!model.advanceMode'
            }
          ], [
            {
              key: 'NUX',
              defaultValue: 'Ordonnance\nBilan morphologique\nBilan biologique\nAutre',
              type: 'horizontalTextareaWithLegend',
              templateOptions: {
                label: 'Liste des catégories:',
                description: 'Ensemble des catégories disponibles pour l\'envoi de documents numérisés. Renseigner une catégorie par ligne.',
                rows: 10,
                legend: 'Catégories de documents numérisés:',
                required: true,
                preview: {
                  label: 'Documents numérisés'
                }
              }
            }
          ]
        ]
      }
    };
    return {
      get: function() {
        return Datastruct;
      }
    };
  });

}).call(this);

//# sourceMappingURL=datastruct-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:MHboxSettings
    * @description
    * # MHboxSettings
    * Factory of MHboxSettings
   */
  angular.module("mhclientApp").factory('MHboxSettings', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, boxAPI, portailAPI, settings;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/mhbox/settings', {}, {});
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        settings = window.mgapp.get('mhbox_mgr').settings();
        boxAPI = BoxResource.generate(settings);
        boxAPI.get_status = function() {
          return BoxResource.mhboxApiCall(settings, "get_status");
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

}).call(this);

//# sourceMappingURL=mhbox-settings-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:MHboxSynchro
    * @description
    * # MHboxSynchro
    * Factory of MHboxSynchro
   */
  angular.module("mhclientApp").factory('MHboxSynchro', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, boxAPI, portailAPI, synchro;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/mhbox/synchro', {}, {});
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        synchro = window.mgapp.get('mhbox_mgr').synchro();
        boxAPI = BoxResource.generate(synchro);
        boxAPI.get_status = function() {
          return BoxResource.mhboxApiCall(synchro, "get_status");
        };
        boxAPI.synchronise = function() {
          return BoxResource.mhboxApiCall(synchro, "synchronise");
        };
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

}).call(this);

//# sourceMappingURL=mhbox-synchro-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:MhboxSynchroCtrl
    * @description
    * # MhboxSynchroCtrl
    * allow to display the mhbox sunchronisation
   */
  angular.module('mhclientApp').controller('MHboxSynchroCtrl', ["$scope", "$filter", "$rootScope", "$state", "$interval", "MHboxSynchro", "$translatePartialLoader", "$translate", function($scope, $filter, $rootScope, $state, $interval, MHboxSynchro, $translatePartialLoader, $translate) {
    $translatePartialLoader.addPart('mhbox');
    $translate.refresh();
    $scope.interval = null;
    $scope.init = function() {
      $scope.interval = $interval(function() {
        return $scope.refresh();
      }, 50, 0);
      return $scope.$on("$destroy", function() {
        return $interval.cancel($scope.interval);
      });
    };
    $scope.synchronise = function() {
      return MHboxSynchro.synchronise();
    };
    $scope.refresh = function() {
      return MHboxSynchro.get_status().$promise.then(function(data) {
        data.last_resfresh_date = data.last_resfresh_date.substring(1, data.last_resfresh_date.length - 1);
        data.resfresh_date = $filter('date')(data.last_resfresh_date, 'EEEE, dd MMMM yyyy');
        data.resfresh_hour = $filter('date')(data.last_resfresh_date, 'HH:mm');
        return $scope.state = data;
      });
    };
    $scope.mgappCloseRequest = function() {
      return $interval.cancel($scope.interval);
    };
    window.mgappClose = $scope.mgappCloseRequest;
    return window.mgappConfirmQuit = window.mgapp.quit_view;
  }]);

}).call(this);

//# sourceMappingURL=mhbox-synchro-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:MHBoxLogin
    * @description
    * # MHBoxLogin
    * Controller of Staff
   */
  angular.module('mhclientApp').controller('MHBoxLogin', ["$scope", "$window", "$state", "$q", "$rootScope", "User", "SiteVarsUtils", "GroupUtils", "$timeout", "$uibModal", "notify", "$filter", function($scope, $window, $state, $q, $rootScope, User, SiteVarsUtils, GroupUtils, $timeout, $uibModal, notify, $filter) {
    var computeUserList;
    $scope.page = "select_user";
    window.mgapp.log_out();
    $scope.nbShowItems = 20;
    $scope.incremental_items = 20;
    $scope.search_text = null;
    $scope.custommer_infos = [];
    $scope.invalid_password = false;
    $scope.addMoreItems = function() {
      if ($scope.usersList && $scope.nbShowItems < $scope.usersList.length) {
        return $scope.nbShowItems = $scope.nbShowItems + $scope.incremental_items;
      }
    };
    $scope.shutDown = function() {
      return $timeout(function() {
        return window.mgapp.shut_down();
      }, 0, false);
    };
    $scope.submitUser = function(user, password) {
      var loginStatus;
      loginStatus = window.mgapp.handle_login(user.username, password);
      $window.mgapp.close_keyboard();
      if (loginStatus.logged) {
        if (loginStatus.need_reset) {
          return $uibModal.open({
            templateUrl: 'admin/views/reset-password-template.html',
            controller: 'ResetPasswordModalCtrl',
            size: "lg",
            backdrop: 'static',
            keyboard: false,
            resolve: {
              username: function() {
                return user.username;
              },
              header: function() {
                return "Your current password has expired compared to Group Policy";
              },
              oldPassword: function() {
                return password;
              }
            }
          }).result.then((function(resetPasswordParams) {
            $window.mgapp.close_keyboard();
            $rootScope.busy = true;
            return User.resetPassword(resetPasswordParams).$promise.then((function(result) {
              $rootScope.busy = false;
              if (result) {
                notify({
                  classes: ["alert-succes"],
                  duration: 2000,
                  message: $filter('translate')('RESET PASSWORD SUCCES')
                });
                return $state.go("user.stay-list");
              } else {
                return notify({
                  classes: ["alert-danger"],
                  duration: 2000,
                  message: $filter('translate')('RESET PASSWORD FAIL')
                });
              }
            }));
          }), function() {
            $rootScope.busy = false;
            return $scope.page = "select_user";
          });
        } else {
          return $window.mgapp.go_to(angular.toJson({
            "metadata": {
              "route": "user.stay-list"
            }
          }));
        }
      } else {
        if (loginStatus.locked) {
          return $state.go("login-blocked", loginStatus.context);
        } else {
          $scope.focus_password = true;
          return $scope.invalid_password = true;
        }
      }
    };
    $scope.cancelLogin = function() {
      $scope.page = 'select_user';
      $scope.invalid_password = false;
      return $window.mgapp.close_keyboard();
    };
    $scope.handleLogin = function(user) {
      $scope.current_user = user;
      $scope.password = "";
      $scope.focus_password = true;
      return $scope.page = "type_password";
    };
    computeUserList = function() {
      return User.query().$promise.then(function(users) {
        return GroupUtils.getAllGroups().then(function(groups) {
          var i, len, user;
          for (i = 0, len = users.length; i < len; i++) {
            user = users[i];
            user.group = _.find(groups, {
              id: user.group
            });
          }
          return $scope.usersList = _.filter(users, "is_active");
        });
      });
    };
    computeUserList();
    return $window.users_rx = computeUserList;
  }]);

}).call(this);

//# sourceMappingURL=login-controller.js.map

(function() {
  angular.module('mhclientApp').controller('arrivalTimestampModalCtrl', ["$scope", "$uibModalInstance", "SiteVarsUtils", "$translatePartialLoader", "$translate", function($scope, $uibModalInstance, SiteVarsUtils, $translatePartialLoader, $translate) {
    var ONE_MINUT;
    $translatePartialLoader.addPart('mhbox');
    $translate.refresh();
    ONE_MINUT = 60000;
    SiteVarsUtils.get('SEQ_TIMESTAMP_OFFSET', 15).then(function(sitevar) {
      $scope.format = "dd/MM/yyyy HH:mm";
      $scope.timeOffset = sitevar.value;
      $scope.maxTime = new Date();
      $scope.arrivalTime = new Date();
      return $scope.minTime = new Date($scope.arrivalTime - $scope.timeOffset * ONE_MINUT);
    });
    $scope.decrementDate = function() {
      return $scope.arrivalTime = new Date($scope.arrivalTime.getTime() - ONE_MINUT);
    };
    $scope.incrementDate = function() {
      return $scope.arrivalTime = new Date($scope.arrivalTime.getTime() + ONE_MINUT);
    };
    return $scope.submitArrivalTimestamp = function() {
      return $uibModalInstance.close({
        'timestamp': $scope.arrivalTime,
        'comment': $scope.comment
      });
    };
  }]);

}).call(this);

//# sourceMappingURL=arrival-timestamp-modal-controller.js.map

(function() {
  angular.module('mhclientApp').controller('departureTimestampCtrl', ["$scope", function($scope) {
    return '';
  }]).directive('departureTimestamp', ["$translatePartialLoader", "$translate", "SequenceRealization", function($translatePartialLoader, $translate, SequenceRealization) {
    var link;
    link = function(scope, element, attrs, departureTimestampCtrl, transclude) {
      $translatePartialLoader.addPart('mhbox');
      $translate.refresh();
      scope.format = "dd/MM/yyyy HH:mm";
      scope.departureTime = new Date();
      scope.comment = "";
      return scope.submitDepartureTimestamp = function(comment) {
        var data;
        data = {
          'user': scope.user.id,
          'comment': comment,
          'departure_timestamp': scope.departureTime
        };
        return SequenceRealization.api.closeSequenceRealization(data).$promise.then(function(result) {
          var notify, translate;
          if (result.error) {
            notify = $injector.get('notify');
            translate = $injector.get("$filter")('translate');
            notify({
              classes: ["alert-danger"]
            });
          }
          return window.mgapp.request_log_out();
        });
      };
    };
    return {
      link: link,
      restrict: 'E',
      compile: function(element, attrs) {
        return link;
      },
      templateUrl: 'mhbox/views/departure-timestamp.html'
    };
  }]);

}).call(this);

//# sourceMappingURL=departure-timestamp-directive.js.map

(function() {
  'use strict';

  /*
    * @ngdoc funtion
    * @name mhclientApp.core:shortcut
    * @description
    * # previewDisplay
    * Display shortcuts of registered words
   */
  angular.module('mhclientApp').filter('userListFilter', function() {
    return function(users, search_text, nbShowItems, sectorActiveFilters, groupActiveFilters, entityActiveFilters, activityFilter, extraFilters) {
      var filtered, has_activity_filter, has_entity_filters, has_group_filters, has_search_text, has_sector_filters, has_siret_filter, i, len, ref, ref1, ref2, ref3, ref4, ref5, regex, searchVal, siretFilters, user;
      if (!users) {
        return [];
      }
      filtered = [];
      has_search_text = (search_text != null) && search_text.length > 0;
      if (has_search_text) {
        searchVal = search_text.replace(/([()[{*+.$^\\|?])/g, '\\$1');
        regex = new RegExp('' + searchVal, 'i');
      }
      has_sector_filters = (sectorActiveFilters != null) && sectorActiveFilters.length > 0;
      has_group_filters = (groupActiveFilters != null) && groupActiveFilters.length > 0;
      has_entity_filters = (entityActiveFilters != null) && entityActiveFilters.length > 0;
      has_activity_filter = (activityFilter != null) && activityFilter.length > 0;
      siretFilters = extraFilters != null ? extraFilters.siret : void 0;
      has_siret_filter = (siretFilters != null) && siretFilters.length > 0;
      for (i = 0, len = users.length; i < len; i++) {
        user = users[i];
        if (has_search_text) {
          if (!(regex.test(user.full_name) || regex.test(user.username))) {
            continue;
          }
        }
        if (has_sector_filters && sectorActiveFilters.indexOf(user.sector) === -1) {
          continue;
        }
        if (has_group_filters && groupActiveFilters.indexOf(user.group.id) === -1) {
          continue;
        }
        if (has_entity_filters && entityActiveFilters.indexOf(user.entity) === -1) {
          continue;
        }
        if (has_activity_filter && !user.is_active) {
          continue;
        }
        if (has_siret_filter && !((((ref = user.user_profile) != null ? (ref1 = ref.data) != null ? ref1.siret : void 0 : void 0) && siretFilters.includes((ref2 = user.user_profile) != null ? (ref3 = ref2.data) != null ? ref3.siret : void 0 : void 0)) || (!((ref4 = user.user_profile) != null ? (ref5 = ref4.data) != null ? ref5.siret : void 0 : void 0) && siretFilters.includes(null)))) {
          continue;
        }
        filtered.push(user);
        if (filtered.length === nbShowItems) {
          break;
        }
      }
      return filtered;
    };
  });

}).call(this);

//# sourceMappingURL=user-list-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StaffCtrl
    * @description
    * # StaffCtrl
    * Controller of Staff
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('StaffCtrl', ["$scope", "$rootScope", "$filter", "$state", "UserUtils", "FeatureUtils", "$q", "SiteVarsUtils", "GroupUtils", function($scope, $rootScope, $filter, $state, UserUtils, FeatureUtils, $q, SiteVarsUtils, GroupUtils) {
    var computedReferents, getVars, groupById;
    $scope.custommer_infos = {};
    computedReferents = {
      computed_referents: true,
      users: [],
      name: $filter("translate")("Referents HaH")
    };
    $scope.data = [computedReferents];
    $scope.searchText = "";
    $scope.sortingFn = function(user) {
      return user.full_name.toLowerCase();
    };
    getVars = ["LABEL_TITLE", "logo", "COORDINATES", "PHONE_NUMBER", "FAX_NUMBER", "EMAIL", "STAFF_INFOS"];
    getVars.forEach(function(sitevarName) {
      return SiteVarsUtils.get(sitevarName, null, $rootScope.currentStay.entity).then(function(sitevar) {
        if (sitevarName === "logo") {
          return $scope.custommer_logo = sitevar.value;
        } else {
          return $scope.custommer_infos[sitevarName] = sitevar.value;
        }
      });
    });
    groupById = {};
    return FeatureUtils.getFeature({
      name: 'MHC_STAFF'
    }).then(function(feature) {
      return GroupUtils.getAllGroups().then(function(groups) {
        return UserUtils.getUsersForPatient($rootScope.currentPatient.si_id).then(function(users) {
          var group, i, len, ref, ref1, referentsUsernames, staff_group;
          for (i = 0, len = groups.length; i < len; i++) {
            group = groups[i];
            if (ref = group.name, indexOf.call(feature.metadata.groups, ref) >= 0) {
              staff_group = _.clone(group);
              staff_group.users = [];
              groupById[staff_group.id] = staff_group;
              $scope.data.push(staff_group);
            }
          }
          referentsUsernames = _.map((ref1 = $rootScope.currentStay.identitovigilance) != null ? ref1.referents : void 0, "username");
          return _.forEach(users, function(user) {
            if (_.includes(referentsUsernames, user.username)) {
              computedReferents.users.push(user);
            }
            if (user.group.id in groupById) {
              return groupById[user.group.id].users.push(user);
            }
          });
        });
      });
    });
  }]);

}).call(this);

//# sourceMappingURL=staff-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:AgendaCtrl
    * @description
    * # AgendaCtrl
    * Controller of agenda
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').controller('AgendaCtrl', ["$scope", "$timeout", "$rootScope", "AgendaTask", "Patient", "Stay", "$uibModal", "uiCalendarConfig", "Activity", "$state", "$stateParams", "ThesaurusUtils", "SiteVarsUtils", "GroupUtils", "UserUtils", "UserCreation", "$q", "Sector", "$filter", "$window", "Task", "AgendaUtils", function($scope, $timeout, $rootScope, AgendaTask, Patient, Stay, $uibModal, uiCalendarConfig, Activity, $state, $stateParams, ThesaurusUtils, SiteVarsUtils, GroupUtils, UserUtils, UserCreation, $q, Sector, $filter, $window, Task, AgendaUtils) {
    var autoUpdate, cache_events, computeAlertDetail, decorateEvent, defaultView, editable, eventDetailDialog, eventsFn, genPopOver, getDateBlocks, handleFiltersChange, id, isEventVisibile, maxTime, minTime, newView, onEventClick, onEventDrop, onEventMouseover, onEventResize, ratio, startedViewRender;
    $scope.mh_config = $rootScope.mh_config;
    $scope.canCreateActivities = $rootScope.checkPermissions("MHC_AGENDA", "CAN_WRITE");
    $scope.displayNewCareButton = _.find($rootScope.user.userFeatures, {
      uid: "MHC_CARE_CREATION"
    });
    SiteVarsUtils.get('PDS_STAY_LIST', false).then(function(pdsStayList) {
      return $scope.showMedPlan = pdsStayList.value;
    });
    $scope.initDone = false;
    $scope.states = [
      {
        name: $filter('translate')('DONE'),
        value: 'DONE',
        checked: false
      }, {
        name: $filter('translate')('PLANNED'),
        value: 'PLANNED',
        checked: false
      }, {
        name: $filter('translate')('TO_BE_PLANNED'),
        value: 'TO_BE_PLANNED',
        checked: false
      }
    ];
    id = 0;
    $scope.fetchGroups = function() {
      var groupDone;
      groupDone = $q.defer();
      if (!$scope.groups) {
        $rootScope.busy = true;
        GroupUtils.getAllGroups().then(function(groups) {
          $scope.groups = groups;
          if (!("groups" in $rootScope.user.filters)) {
            if (!$rootScope.user.group.data.dont_filter_agenda_events) {
              $rootScope.user.filters.groups = [
                _.find(groups, {
                  id: $rootScope.user.group.id
                }).uid
              ];
            } else {
              $rootScope.user.filters.groups = [];
            }
          }
          $rootScope.busy = false;
          return groupDone.resolve();
        });
      } else {
        groupDone.resolve();
      }
      return groupDone.promise;
    };
    $scope.fetchUsers = function() {
      var userDone;
      userDone = $q.defer();
      if (!$scope.users) {
        $scope.fetchGroups().then(function() {
          $rootScope.busy = true;
          return UserUtils.getUsers().then(function(users) {
            $scope.users = users;
            if ($rootScope.user.filters.groups.length > 0) {
              $scope.availableUsers = _.filter($scope.users, function(user) {
                return $rootScope.user.filters.groups.indexOf(user.group.uid) > -1;
              });
            } else {
              $scope.availableUsers = $scope.users;
            }
            _.map(uiCalendarConfig.calendars.calendar.fullCalendar("clientEvents"), function(event) {
              var i, len, ref, results, task, user;
              event.users_username_involved = [];
              ref = event.tasks;
              results = [];
              for (i = 0, len = ref.length; i < len; i++) {
                task = ref[i];
                if (task.user_involved) {
                  user = _.find($scope.users, {
                    id: task.user_involved
                  });
                  if (user) {
                    event.users_username_involved.push(user.username);
                  }
                }
                if (task.author) {
                  user = _.find($scope.users, {
                    id: task.author
                  });
                  if (user) {
                    results.push(event.users_username_involved.push(user.username));
                  } else {
                    results.push(void 0);
                  }
                } else {
                  results.push(void 0);
                }
              }
              return results;
            });
            userDone.resolve();
            return $rootScope.busy = false;
          });
        });
      } else {
        userDone.resolve();
      }
      return userDone.promise;
    };
    $scope.fetchPatients = function() {
      $rootScope.busy = true;
      return $q.when($scope.patients ? $scope.patients : Patient.query().$promise).then(function(patients) {
        return $q.when($scope.stays ? $scope.stays : Stay.query().$promise).then(function(stays) {
          var patientIds;
          $scope.stays = stays;
          $scope.patients = patients;
          if ($rootScope.user.filters.sectors && $rootScope.user.filters.sectors.length > 0) {
            patientIds = _.uniq(_.map(_.filter($scope.stays, function(stay) {
              return $rootScope.user.filters.sectors.indexOf(stay.sector) > -1;
            }), "patient"));
            $scope.availablePatients = _.filter(patients, function(patient) {
              return patientIds.indexOf(patient.id) > -1;
            });
          } else {
            $scope.availablePatients = patients;
          }
          return $rootScope.busy = false;
        });
      });
    };
    $scope.thesaurusFilters = {
      query: "",
      category: null,
      typeEntries: [],
      events: [],
      patients: [],
      states: [],
      group: null,
      user: null
    };
    decorateEvent = function(event, options) {
      var author, authors, groupInvolved, i, j, len, len1, ref, results, task, user;
      event.groups_uid_involved = [];
      event.users_username_involved = [];
      event.className = [event.type, event.status, "agenda-event-decorator"];
      if ((event.customColor != null) && event.customColor !== "") {
        event.className.push(event.customColor);
      } else if (event.chained) {
        event.className.push("chained");
      }
      ref = event.tasks;
      for (i = 0, len = ref.length; i < len; i++) {
        task = ref[i];
        if (task.activity === $scope.selectedActivityByAlert || task.id === $scope.selectedTaskByAlert) {
          if ($scope.alertDetail.config.level === "ALERT") {
            event.className.push("alert-notification");
          } else {
            event.className.push("info-notification");
          }
        }
        if (task.group_involved) {
          groupInvolved = _.find($scope.groups, {
            id: task.group_involved
          });
          event.groups_uid_involved.push(groupInvolved.uid);
          task.group_label = groupInvolved.name;
          task.group_short_label = groupInvolved.short_name;
        }
        if ($scope.users) {
          if (task.user_involved) {
            user = _.find($scope.users, {
              id: task.user_involved
            });
            if (user) {
              event.users_username_involved.push(user.username);
            }
          }
          if (task.author) {
            user = _.find($scope.users, {
              id: task.author
            });
            if (user) {
              event.users_username_involved.push(user.username);
            }
          }
        }
      }
      event.textColor = "black";
      event.tooltip = "<div>" + event.longLabel + "</div><div>" + event.patientName + "</div>";
      event.title = "<small>" + (event.templateName ? "<div>" + event.templateName + "</div>" : "");
      event.title += "<div><b>" + event.shortLabel + "</b></div>";
      if (!$scope.patient) {
        event.title += "<div>" + event.patientInitials;
        if (options.showZipCode && event.zipCode) {
          event.title += "&nbsp<small>" + event.zipCode + " " + event.town + "</small>";
          event.tooltip += "<small>" + event.zipCode + " " + event.town + "</small>";
        }
        event.title += "</div>";
      }
      authors = _.uniq(_.map(event.tasks, function(task) {
        return task.data.initials || task.data.user_involved_initials || task.group_label;
      }));
      event.title += "<div>" + (authors.join(' ')) + "</div>";
      if (event.hasComments) {
        event.title += "<span class='whit-comments glyphicon glyphicon-comment'></div>";
      }
      event.title += "</small>";
      authors = _.uniq(_.map(event.tasks, function(task) {
        return task.data.user_full_name || task.data.user_involved_full_name || task.group_label || null;
      }));
      results = [];
      for (j = 0, len1 = authors.length; j < len1; j++) {
        author = authors[j];
        if (author) {
          results.push(event.tooltip += "<div>" + author + "</div>");
        } else {
          results.push(void 0);
        }
      }
      return results;
    };
    isEventVisibile = function(event) {
      var entry_code, found, i, j, len, len1, ref, ref1, ref2, regex, task_code;
      if ($scope.thesaurusFilters.states.length > 0) {
        if (!(_.find($scope.thesaurusFilters.states, {
          value: event.status
        }))) {
          return false;
        }
      }
      if ($rootScope.user.filters.users && $rootScope.user.filters.users.length > 0) {
        if (!(_.some($rootScope.user.filters.users, function(username) {
          return event.users_username_involved.indexOf(username) > -1;
        }))) {
          return false;
        }
      } else if ($rootScope.user.filters.groups && $rootScope.user.filters.groups.length > 0) {
        if (!(_.some($rootScope.user.filters.groups, function(groupUid) {
          return event.groups_uid_involved.indexOf(groupUid) > -1;
        }))) {
          return false;
        }
      }
      if ($rootScope.user.filters.patients && $rootScope.user.filters.patients.length > 0) {
        if ($rootScope.user.filters.patients.indexOf(event.patient_ipp) === -1) {
          return false;
        }
      }
      if ($scope.thesaurusFilters.category) {
        if (!(ref = $scope.thesaurusFilters.category.code, indexOf.call(event.category_codes, ref) >= 0)) {
          return false;
        }
        if ($scope.thesaurusFilters.typeEntries.length > 0) {
          found = false;
          ref1 = event.entry_codes;
          for (i = 0, len = ref1.length; i < len; i++) {
            entry_code = ref1[i];
            if (_.find($scope.thesaurusFilters.typeEntries, {
              uid: entry_code
            })) {
              found = true;
              break;
            }
          }
          if (!found) {
            return false;
          }
          if ($scope.thesaurusFilters.events.length > 0) {
            found = false;
            ref2 = event.task_codes;
            for (j = 0, len1 = ref2.length; j < len1; j++) {
              task_code = ref2[j];
              if (_.find($scope.thesaurusFilters.events, {
                uid: task_code
              })) {
                found = true;
                break;
              }
            }
            if (!found) {
              return false;
            }
          }
        }
      }
      if ($scope.thesaurusFilters.query.length > 0) {
        regex = new RegExp('(' + $scope.thesaurusFilters.query + ')(?<!<[^>]*)', 'gi');
        if (!(regex.test(event.title) || regex.test(event.tooltip))) {
          return false;
        }
      }
      return true;
    };
    $scope.queryChanged = function() {
      return handleFiltersChange();
    };
    handleFiltersChange = function() {
      _.map(uiCalendarConfig.calendars.calendar.fullCalendar("clientEvents"), function(event) {
        return event.hidden = !isEventVisibile(event);
      });
      return uiCalendarConfig.calendars.calendar.fullCalendar("rerenderEvents");
    };
    ThesaurusUtils.getThesaurusCategories().then(function(thesaurusCategories) {
      _.remove(thesaurusCategories, {
        show_in_agenda: false
      });
      if (thesaurusCategories.length > 1) {
        return $scope.thesaurusCategories = thesaurusCategories;
      } else {
        $scope.thesaurusFilters.category = thesaurusCategories[0];
        return $scope.thesaurusCategoriesFilterChange();
      }
    });
    $scope.GroupChange = function() {
      $scope.filtersChanged = true;
      if ($rootScope.user.filters.groups.length > 0) {
        $scope.availableUsers = _.filter($scope.users, function(user) {
          return $rootScope.user.filters.groups.indexOf(user.group.uid) > -1;
        });
      } else {
        $scope.availableUsers = $scope.users;
      }
      return handleFiltersChange();
    };
    $scope.updateFilters = function() {
      $rootScope.busy = true;
      return UserCreation.updateFilters({
        id: $rootScope.user.id,
        filters: $rootScope.user.filters
      }).$promise.then(function() {
        $scope.filtersChanged = false;
        return $rootScope.busy = false;
      });
    };
    $scope.UserChange = function() {
      $scope.filtersChanged = true;
      return handleFiltersChange();
    };
    $scope.statusFilterChange = function() {
      return handleFiltersChange();
    };
    $scope.thesaurusCategoriesFilterChange = function() {
      $scope.thesaurusFilters.typeEntries = [];
      $scope.thesaurusFilters.events = [];
      if ($scope.thesaurusFilters.category) {
        $rootScope.busy = true;
        ThesaurusUtils.getThesaurusEntries({
          category: $scope.thesaurusFilters.category.id
        }, true).then(function(thesaurusEntries) {
          $scope.thesaurusEntries = _.filter(thesaurusEntries, {
            obsolete: false
          });
          return $rootScope.busy = false;
        });
      }
      return handleFiltersChange();
    };
    $scope.openNewActivityModal = function() {
      var newActivityModal;
      $rootScope.lockMenu(true);
      newActivityModal = $uibModal.open({
        templateUrl: 'agenda/views/new-activity-modal.html',
        controller: 'NewActivityModalCtrl',
        backdrop: 'static',
        resolve: {
          stay: function() {
            return $scope.stay;
          }
        }
      });
      newActivityModal.closed.then(function() {
        return $rootScope.lockMenu(false);
      });
      return newActivityModal.result.then(function(result) {
        return uiCalendarConfig.calendars.calendar.fullCalendar("refetchEvents");
      });
    };
    $scope.PatientChange = function() {
      $scope.filtersChanged = true;
      return handleFiltersChange();
    };
    $scope.sectorChanged = function() {
      $scope.filtersChanged = true;
      return $q.when(!$scope.patient ? $scope.fetchPatients() : void 0).then(function() {
        $scope.initDone = false;
        return $timeout(function() {
          return $scope.initDone = true;
        });
      });
    };
    $scope.stateFilterChange = function() {
      $scope.filtersChanged = true;
      $scope.initDone = false;
      return $q.when($scope.fetchPatients()).then(function() {
        return $timeout(function() {
          return $scope.initDone = true;
        });
      });
    };
    $scope.thesaurusEntriesEventFilterChange = function() {
      return handleFiltersChange();
    };
    $scope.thesaurusEntriesFilterChange = function() {
      var i, len, ref, typeEntry;
      $scope.thesaurusFilters.events = [];
      if ($scope.thesaurusFilters.typeEntries.length > 0) {
        $scope.thesaurusEntryEvents = [];
        ref = $scope.thesaurusFilters.typeEntries;
        for (i = 0, len = ref.length; i < len; i++) {
          typeEntry = ref[i];
          $scope.thesaurusEntryEvents = $scope.thesaurusEntryEvents.concat(_.filter(typeEntry.entries, function(entry) {
            return !entry.obsolete;
          }));
        }
      }
      return handleFiltersChange();
    };
    defaultView = 'agendaWeek';
    minTime = '00:00:00';
    maxTime = '24:00:00';
    editable = true;
    ratio = 2;
    onEventClick = function(event, jsEvent, view) {
      return eventDetailDialog(event);
    };
    onEventMouseover = function(event, jsEvent, view) {
      genPopOver($(this), event);
      return $(this).popover('show');
    };
    onEventDrop = function(event, delta, revertFunc, jsEvent, ui, view) {
      return eventDetailDialog(event, revertFunc, true);
    };
    onEventResize = function(event, delta, revertFunc) {
      return eventDetailDialog(event, revertFunc, true, true);
    };
    genPopOver = function(element, event) {
      var extraClass;
      extraClass = "";
      if (event.type === "medplan") {
        extraClass = event.chained ? "chained" : "fixed";
      }
      return element.popover({
        html: true,
        content: event.tooltip,
        trigger: 'hover',
        placement: 'top',
        container: 'body'
      }).data('bs.popover').tip().css("border-color", event.borderColor).addClass(extraClass + ' agenda-event-decorator ' + event.status);
    };
    angular.element($window).bind('resize', function() {
      var height;
      if (uiCalendarConfig.calendars.calendar) {
        height = $window.innerHeight - $('#fixed-calendar-body').offset().top - parseInt($('#fixed-calendar-body').css('padding-top'));
        return uiCalendarConfig.calendars.calendar.fullCalendar("option", "height", height - 5);
      }
    });
    newView = true;
    startedViewRender = true;
    cache_events = null;
    computeAlertDetail = function(alertDetail) {
      switch (alertDetail.config.event_name) {
        case "MHC_AGENDA_NEW_ACTIVITY":
          return Activity.api.get({
            id: alertDetail.data.object_id
          }).$promise.then(function(activity) {
            $scope.defaultDate = activity.start_date;
            return $scope.selectedActivityByAlert = alertDetail.data.object_id;
          }, function(err) {
            if (!(err.status === 404)) {
              return $q.reject(err);
            }
          });
        case "MHC_AGENDA_UPCOMING_EVENT":
        case "MHC_AGENDA_UPDATED_EVENT":
          return Task.api.get({
            id: alertDetail.data.object_id
          }).$promise.then(function(task) {
            $scope.defaultDate = task.date;
            return $scope.selectedTaskByAlert = alertDetail.data.object_id;
          }, function(err) {
            if (!(err.status === 404)) {
              return $q.reject(err);
            }
          });
        default:
          return {};
      }
    };
    $timeout(function() {
      $scope.defaultDate = moment();
      return $q.when($scope.alertDetail ? computeAlertDetail($scope.alertDetail) : void 0).then(function() {
        $scope.uiConfig = {
          calendar: {
            height: 200,
            timeFormat: 'H:mm',
            minTime: minTime,
            maxTime: maxTime,
            viewRender: function(view) {
              return newView = true;
            },
            eventAfterAllRender: function(view) {
              if (newView) {
                newView = false;
                return $timeout(function() {
                  var height, renderedEvents;
                  height = $window.innerHeight - $('#fixed-calendar-body').offset().top - parseInt($('#fixed-calendar-body').css('padding-top'));
                  uiCalendarConfig.calendars.calendar.fullCalendar("option", "height", height - 5);
                  if ($('.fc-time-grid-event').length > 0) {
                    renderedEvents = $('div.fc-event-container a');
                    if (renderedEvents && renderedEvents.length > 0) {
                      return $('div.fc-scroller')[0].scrollTop = _.minBy(renderedEvents, "offsetTop").offsetTop;
                    }
                  }
                }, 100);
              }
            },
            views: {
              day: {
                displayEventTime: false,
                minTime: minTime,
                maxTime: maxTime,
                eventLimit: 4
              },
              week: {
                displayEventTime: false,
                eventLimit: 4
              }
            },
            lang: 'fr',
            defaultView: defaultView,
            defaultDate: $scope.defaultDate,
            editable: editable,
            allDaySlot: true,
            header: {
              left: 'title',
              center: 'agendaDay,agendaWeek,month',
              right: 'today prev,next'
            },
            eventClick: onEventClick,
            eventMouseover: onEventMouseover,
            eventDrop: onEventDrop,
            eventResize: onEventResize,
            eventRender: function(event, element, view) {
              if (event.hidden) {
                return false;
              }
              element.find('.fc-title').html(element.find('.fc-title').text());
              $('.popover').remove();
              genPopOver(element, event);
              return true;
            }
          }
        };
        return $scope.initDone = true;
      });
    }, 200);
    getDateBlocks = function(start, end, maxDays) {
      var e, result, s;
      result = [];
      s = new Date(start);
      while (s < end) {
        e = new Date(s.getFullYear(), s.getMonth(), s.getDate() + maxDays);
        result.push({
          start: new Date(s),
          end: e <= end ? e : new Date(end)
        });
        s.setDate(s.getDate() + maxDays + 1);
      }
      return result;
    };
    eventsFn = function(start, end, timezone, callback) {
      $rootScope.busy = true;
      $scope.startDate = moment(start).format('YYYY-MM-DD');
      $scope.endDate = moment(end).format('YYYY-MM-DD');
      return $scope.fetchGroups().then(function() {
        return $q.when($rootScope.user.filters.users && $rootScope.user.filters.users.length > 0 ? $scope.fetchUsers() : true).then(function() {
          var dateBlock, fetchDates, i, len, options, params, ref;
          options = {
            showZipCode: $scope.showZipCode
          };
          fetchDates = [];
          ref = getDateBlocks(start, end, 7);
          for (i = 0, len = ref.length; i < len; i++) {
            dateBlock = ref[i];
            params = {
              target: $scope.patient ? $scope.patient.id : null,
              start_date: moment(dateBlock.start).format('YYYY-MM-DD'),
              end_date: moment(dateBlock.end).format('YYYY-MM-DD')
            };
            if (!$scope.showCareInAgenda) {
              params.without_sequences = true;
            }
            if ($rootScope.user.filters.sectors && $rootScope.user.filters.sectors.length > 0) {
              params.sectors = $rootScope.user.filters.sectors;
            }
            if (!$scope.patient && $rootScope.user.filters.stayStates && $rootScope.user.filters.stayStates.length > 0) {
              params.stay_states = $rootScope.user.filters.stayStates;
            }
            fetchDates.push(AgendaTask.api.query(params).$promise);
          }
          return $q.all(fetchDates).then(function(patientTasksBlocks) {
            return AgendaUtils.groupTasksInEvents([].concat.apply([], patientTasksBlocks), $scope.groups).then(function(events) {
              var event, j, len1;
              for (j = 0, len1 = events.length; j < len1; j++) {
                event = events[j];
                decorateEvent(event, options);
                event.hidden = !isEventVisibile(event);
              }
              callback(events);
              return $rootScope.busy = false;
            });
          });
        });
      });
    };
    SiteVarsUtils.get('SHOW_CARE_IN_AGENDA', true).then(function(sitevar) {
      return SiteVarsUtils.getValue('SHOW_ZIP_CODE_IN_AGENDA', false).then(function(showZipCode) {
        return Sector.getSectors().then(function(sectors) {
          return $q.when(!$scope.patient && $rootScope.user.filters.sectors && $rootScope.user.filters.sectors.length > 0 ? $scope.fetchPatients() : void 0).then(function() {
            if ($rootScope.currentPatientStays) {
              $scope.sectors = _.filter(sectors, function(sector) {
                return _.map($rootScope.currentPatientStays, "sector").indexOf(sector.id) > -1;
              });
            } else {
              $scope.sectors = sectors;
            }
            $scope.showZipCode = showZipCode;
            $scope.showCareInAgenda = sitevar.value;
            $scope.canWriteCares = $scope.showCareInAgenda && $rootScope.checkPermissions("MHC_CARE_CREATION", "CAN_WRITE");
            return $scope.eventSources = [eventsFn];
          });
        });
      });
    });
    autoUpdate = function(event, move, resize) {
      if (event.type === "coordination" && (resize || move)) {
        return {
          "action": "update",
          "tasks": _.map(event.tasks, function(task) {
            var ref;
            task.date = moment(event.start).format("YYYY-MM-DD");
            task.data.start_time = moment(event.start).format("HH:mm");
            task.data.event_all_day = event.allDay;
            task.data.duration = ((ref = event.end) != null ? ref.diff(event.start, 'minutes') : void 0) || event.duration;
            return task;
          })
        };
      }
      return false;
    };
    eventDetailDialog = function(event, revertFunc, dirty, resize) {
      var controller, templateUrl;
      if ($rootScope.mh_config.platform === "mgapp") {
        $window.mgapp.lock_menu(true);
      }
      $scope.currentEvent = event;
      if (event.type === "coordination") {
        controller = "EventCoordinationDetailCtrl";
        templateUrl = 'agenda/views/event-coordination-detail.html';
      } else if (event.type === "medplan") {
        controller = "EventMedplanDetailCtrl";
        templateUrl = 'agenda/views/event-medplan-detail.html';
      } else if (event.type === "patient") {
        controller = "EventPatientDetailCtrl";
        templateUrl = 'agenda/views/event-patient-detail.html';
      } else {
        controller = "EventSequenceDetailCtrl";
        templateUrl = 'agenda/views/event-sequence-detail.html';
      }
      return $q.when(autoUpdate(event, dirty, resize) || $uibModal.open({
        templateUrl: templateUrl,
        controller: controller,
        windowClass: 'event-detail-modal',
        scope: $scope,
        backdrop: 'static',
        resolve: {
          stays: function() {
            return $rootScope.currentPatientStays;
          },
          dirty: function() {
            return dirty;
          },
          resize: function() {
            return resize;
          }
        }
      }).result).then((function(result) {
        var handleNextTask, newEvent, options, updatedTasks;
        if ($rootScope.mh_config.platform === "mgapp") {
          $window.mgapp.lock_menu(false);
        }
        if (result) {
          if (result.action === "update") {
            $rootScope.busy = true;
            updatedTasks = result.tasks;
            uiCalendarConfig.calendars.calendar.fullCalendar('removeEvents', [$scope.currentEvent._id]);
            if (event.type === "patient") {
              newEvent = AgendaUtils.genPatientEvent(updatedTasks, $scope.canCreateActivities);
            } else if (event.type === "care_sequence") {
              newEvent = AgendaUtils.genSequenceEvent(updatedTasks);
            } else if (event.type === "coordination") {
              newEvent = AgendaUtils.genCoordinationEvent(updatedTasks);
            } else {
              newEvent = AgendaUtils.genMedplanEvent(updatedTasks);
            }
            options = {
              showZipCode: $scope.showZipCode
            };
            handleNextTask = $q.defer();
            if ($scope.currentEvent.chained && $scope.currentEvent.status === "PLANNED" && newEvent.status === "DONE") {
              Activity.api.createNextTask({
                id: newEvent.activity
              }).$promise.then(function(newTaks) {
                if (newTaks.length > 0) {
                  return AgendaUtils.groupTasksInEvents(newTaks, $scope.groups).then(function(events) {
                    var i, len;
                    for (i = 0, len = events.length; i < len; i++) {
                      event = events[i];
                      decorateEvent(event, options);
                      event.hidden = !isEventVisibile(event);
                      uiCalendarConfig.calendars.calendar.fullCalendar('renderEvent', event);
                    }
                    return handleNextTask.resolve();
                  });
                } else {
                  return handleNextTask.resolve();
                }
              });
            } else {
              handleNextTask.resolve();
            }
            return handleNextTask.promise.then(function() {
              var formatedUpdatedTask, i, len, ref, task;
              formatedUpdatedTask = [];
              ref = newEvent.tasks;
              for (i = 0, len = ref.length; i < len; i++) {
                task = ref[i];
                formatedUpdatedTask.push({
                  id: task.id,
                  activity: task.activity,
                  revision_number: task.revision_number,
                  date: task.date,
                  user_involved: task.user_involved,
                  data: task.data,
                  status: task.status,
                  author: task.author
                });
              }
              return AgendaTask.api.updateTasks(formatedUpdatedTask).$promise.then(function(updatedTasks) {
                return AgendaUtils.groupTasksInEvents(updatedTasks, $scope.groups).then(function(events) {
                  var j, len1;
                  for (j = 0, len1 = events.length; j < len1; j++) {
                    event = events[j];
                    decorateEvent(event, options);
                    event.hidden = !isEventVisibile(event);
                    uiCalendarConfig.calendars.calendar.fullCalendar('renderEvent', event);
                  }
                  return $rootScope.busy = false;
                });
              });
            });
          } else if (result.action === "deleteEvent") {
            $rootScope.busy = true;
            uiCalendarConfig.calendars.calendar.fullCalendar('removeEvents', [$scope.currentEvent._id]);
            return AgendaTask.api.deleteTasks(_.map($scope.currentEvent.tasks, 'id')).$promise.then(function() {
              return $rootScope.busy = false;
            });
          } else if (result.action === "stopActivity") {
            $rootScope.busy = true;
            if (revertFunc) {
              revertFunc();
            }
            return Activity.api.stop({
              id: result.activity
            }).$promise.then(function() {
              uiCalendarConfig.calendars.calendar.fullCalendar("removeEvents", function(event) {
                return event.activity === result.activity && event.start.diff(moment(), 'days') >= 0;
              });
              return $rootScope.busy = false;
            });
          }
        } else if (revertFunc) {
          return revertFunc();
        }
      }));
    };
    return $scope.printData = function(docType, allStays, patient, stay) {
      var params;
      params = "?start_date=" + $scope.startDate + "&end_date=" + $scope.endDate;
      if ($rootScope.allStays) {
        window.open('/api_rest/patients/' + patient.id + '/print_data/' + docType + params, '_blank');
      } else {
        window.open('/api_rest/stays/' + stay.id + '/print_data/' + docType + params, '_blank');
      }
      return true;
    };
  }]);

}).call(this);

//# sourceMappingURL=agenda-controller.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.directive:agenda
    * @description
    * Directive of agenda
   */
  angular.module('mhclientApp').directive('agenda', function() {
    return {
      restrict: 'E',
      templateUrl: 'agenda/views/agenda-view.html',
      scope: {
        stay: '=?',
        patient: '=?',
        alertDetail: '=?'
      },
      controller: 'AgendaCtrl'
    };
  });

}).call(this);

//# sourceMappingURL=agenda-directive.js.map

(function() {
  'use strict';

  /**
    * @ngdoc function
    * @name mhclientApp.controller:AgendaUtils
    * @description
    * # AgendaUtils
    * Controller of AgendaUtils
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").factory('AgendaUtils', ["$rootScope", "ThesaurusUtils", function($rootScope, ThesaurusUtils) {
    var computeState, genBaseEvent, genCoordinationEvent, genMedplanEvent, genPatientEvent, genSequenceEvent, groupTasksInEvents, service;
    computeState = function(event) {
      if (_.filter(event.tasks, function(task) {
        var ref;
        return (ref = task.status) !== "R" && ref !== "N";
      }).length === 0) {
        event.status = "DONE";
        event.durationEditable = false;
        return event.startEditable = false;
      } else if (_.filter(event.tasks, {
        status: "P"
      }).length > 0) {
        return event.status = "PLANNED";
      } else if (_.filter(event.tasks, {
        status: "hidden"
      }).length > 0) {
        return event.status = "SUSPENDED";
      } else {
        return event.status = "TO_BE_PLANNED";
      }
    };
    genBaseEvent = function(type, tasks, displayDuration, shortLabel, longLabel, durationEditable, startEditable) {
      var end, event, referentTask, start, start_time;
      referentTask = tasks[0];
      if (referentTask.data.event_all_day) {
        start = moment(referentTask.date);
      } else {
        start = moment(referentTask.date);
        start_time = moment(referentTask.data.start_time || referentTask.data.start_interval, "HH:mm");
        start.hours(start_time.hours());
        start.minutes(start_time.minutes());
      }
      if (displayDuration) {
        end = moment(start).add(displayDuration, "minutes");
      } else {
        end = null;
      }
      event = {
        type: type,
        start: start,
        end: end,
        durationEditable: durationEditable,
        startEditable: startEditable,
        shortLabel: shortLabel || longLabel,
        longLabel: longLabel,
        patientInitials: referentTask.data.patient_initials,
        patientName: referentTask.data.patient,
        zipCode: referentTask.data.zip_code,
        town: referentTask.data.town,
        stay: referentTask.data.stay,
        revision_number: referentTask.revision_number,
        event_all_day: referentTask.data.event_all_day,
        allDay: referentTask.data.event_all_day,
        tasks: tasks,
        category_codes: _.map(tasks, 'category_code'),
        entry_codes: _.map(tasks, 'entry_code'),
        task_codes: _.map(tasks, 'data.uid'),
        hasComments: _.find(tasks, function(task) {
          return task.data.comment;
        }),
        patient_ipp: referentTask.data.patient_ipp,
        groups_involved: _.map(tasks, 'group_involved'),
        users_involved: _.map(tasks, 'user_involved').concat(_.map(tasks, 'author'))
      };
      computeState(event);
      return event;
    };
    genCoordinationEvent = function(tasks) {
      var baseEvent, displayDuration, referentTask;
      referentTask = tasks[0];
      if (referentTask.data.event_all_day) {
        displayDuration = null;
      } else {
        displayDuration = Math.max(referentTask.data.duration, 45);
      }
      baseEvent = genBaseEvent("coordination", tasks, displayDuration, referentTask.data.short_label, referentTask.data.label, true, true);
      baseEvent.data = referentTask.data;
      baseEvent.backgroundColor = "#fff";
      if (baseEvent.status === "DONE") {
        baseEvent.borderColor = "#6D8F28";
      } else if (baseEvent.start.isBefore(moment(new Date()), "day")) {
        baseEvent.borderColor = "#DB3618";
      } else {
        baseEvent.borderColor = "#4878DB";
      }
      baseEvent.activity = referentTask.activity;
      baseEvent.displayDuration = displayDuration;
      baseEvent.duration = referentTask.data.duration;
      computeState(baseEvent);
      return baseEvent;
    };
    genPatientEvent = function(tasks, canEditAgendaPatient) {
      var baseEvent, displayDuration, durationEditable, referentTask, startEditable;
      durationEditable = canEditAgendaPatient;
      startEditable = canEditAgendaPatient;
      referentTask = tasks[0];
      if (referentTask.data.end_time && referentTask.data.start_time) {
        displayDuration = moment.duration(moment(referentTask.data.end_time, "HH:mm").diff(moment(referentTask.data.start_time, "HH:mm"))).asMinutes();
      }
      if (!displayDuration) {
        displayDuration = Math.max(referentTask.data.duration, 45);
      }
      baseEvent = genBaseEvent("patient", tasks, displayDuration, referentTask.data.short_label, referentTask.data.label, durationEditable, startEditable);
      baseEvent.activity = referentTask.activity;
      return baseEvent;
    };
    genMedplanEvent = function(tasks) {
      var baseEvent, displayDuration, referentTask;
      referentTask = tasks[0];
      if (referentTask.data.event_all_day) {
        displayDuration = null;
      } else {
        displayDuration = referentTask.data.event_duration;
      }
      baseEvent = genBaseEvent("medplan", tasks, displayDuration, referentTask.data.short_label, referentTask.data.label, true, true);
      baseEvent.templateName = referentTask.data.template_name;
      baseEvent.linked_function = referentTask.data.linked_function;
      baseEvent.idPatient = referentTask.data.patient_id;
      baseEvent.chained = referentTask.data.chained;
      baseEvent.customColor = referentTask.data.customColor;
      baseEvent.duration = referentTask.data.event_duration;
      baseEvent.activity = referentTask.activity;
      computeState(baseEvent);
      return baseEvent;
    };
    genSequenceEvent = function(tasks) {
      var alreadyDoneActivity, baseEvent, displayDuration, duration, durationEditable, i, len, ref, referentTask, startEditable, task;
      durationEditable = false;
      startEditable = false;
      referentTask = tasks[0];
      alreadyDoneActivity = [];
      duration = 0;
      if (referentTask.data.end_time) {
        duration = moment(referentTask.data.end_time, "HH:mm").diff(moment(referentTask.data.start_time || referentTask.data.start_interval, "HH:mm"), "minutes");
      } else {
        for (i = 0, len = tasks.length; i < len; i++) {
          task = tasks[i];
          if (ref = task.activity, indexOf.call(alreadyDoneActivity, ref) < 0) {
            duration += task.data.duration;
            alreadyDoneActivity.push(task.activity);
          }
        }
      }
      displayDuration = Math.max(duration, 30);
      baseEvent = genBaseEvent("care_sequence", tasks, displayDuration, referentTask.data.sequence, referentTask.data.sequence, durationEditable, startEditable);
      if (baseEvent.status === "DONE") {
        baseEvent.borderColor = "green";
      } else if (_.find(tasks, function(t) {
        var ref1;
        return (ref1 = t.status) === "N" || ref1 === "R";
      })) {
        baseEvent.borderColor = "orange";
      } else if (baseEvent.start.isBefore(moment(new Date()), "day")) {
        baseEvent.borderColor = "red";
      } else {
        baseEvent.borderColor = "blue";
      }
      return baseEvent;
    };
    groupTasksInEvents = function(tasks) {
      return ThesaurusUtils.getThesaurusCategories(false, false, true).then(function(categories) {
        var coordinationTasks, coordination_codes, events, medplanTasks, patientTasks, sequenceTasks, task;
        coordination_codes = _.map(_.filter(categories, {
          type: "coordination"
        }), "code");
        events = [];
        sequenceTasks = _.remove(tasks, function(task) {
          return task.sequence_uid;
        });
        medplanTasks = _.remove(tasks, {
          category_code: "medplan_templates"
        });
        medplanTasks = medplanTasks.concat(_.remove(tasks, {
          category_code: "medplan_events"
        }));
        coordinationTasks = _.remove(tasks, function(task) {
          var ref;
          return ref = task.category_code, indexOf.call(coordination_codes, ref) >= 0;
        });
        patientTasks = tasks;
        while (sequenceTasks.length > 0) {
          task = sequenceTasks[0];
          events.push(genSequenceEvent(_.remove(sequenceTasks, {
            date: task.date,
            sequence_uid: task.sequence_uid,
            data: {
              start_time: task.data.start_time
            }
          })));
        }
        while (patientTasks.length > 0) {
          task = patientTasks[0];
          events.push(genPatientEvent(_.remove(patientTasks, {
            date: task.date,
            activity: task.activity,
            data: {
              start_time: task.data.start_time
            }
          }), $rootScope.checkPermissions("MHC_AGENDA", "CAN_WRITE")));
        }
        while (medplanTasks.length > 0) {
          task = medplanTasks[0];
          events.push(genMedplanEvent(_.remove(medplanTasks, {
            date: task.date,
            activity: task.activity,
            data: {
              start_time: task.data.start_time
            }
          })));
        }
        while (coordinationTasks.length > 0) {
          task = coordinationTasks[0];
          events.push(genCoordinationEvent(_.remove(coordinationTasks, {
            date: task.date,
            activity: task.activity
          })));
        }
        return events;
      });
    };
    service = {
      groupTasksInEvents: groupTasksInEvents,
      genSequenceEvent: genSequenceEvent,
      genCoordinationEvent: genCoordinationEvent,
      genPatientEvent: genPatientEvent,
      genMedplanEvent: genMedplanEvent
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=agenda-utils.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:EventDetailCtrl
    * @description
    * # EventDetailCtrl
    * TODO put a real description
   */
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module("mhclientApp").controller('EventMedplanDetailCtrl', ["$scope", "$rootScope", "$q", "Patient", "Stay", "$filter", "$uibModal", "$window", "$uibModalInstance", "UserUtils", "FormTemplateUtils", "Task", "dirty", "resize", function($scope, $rootScope, $q, Patient, Stay, $filter, $uibModal, $window, $uibModalInstance, UserUtils, FormTemplateUtils, Task, dirty, resize) {
    var activity, d, i, len, ref, ref1, task;
    $scope.event = angular.copy($scope.currentEvent);
    $scope.event.activities = [];
    $scope.accesData = function(event) {
      return $q.when($rootScope.currentPatient ? $rootScope.currentPatient : Patient.get({
        id: event.idPatient
      }).$promise).then(function(patient) {
        return $q.when($rootScope.currentStay ? $rootScope.currentStay : Stay.get({
          id: event.stay
        }).$promise).then(function(stay) {
          return FormTemplateUtils.getTemplates({
            uid: event.linked_function.uid
          }).then(function(formTemplate) {
            return $uibModal.open({
              templateUrl: 'agenda/views/pop-up-medforms-version.html',
              windowClass: 'modal-fullscreen',
              backdrop: 'static',
              controller: ["$scope", "patient", "stay", "formTemplate", "$uibModalInstance", function($scope, patient, stay, formTemplate, $uibModalInstance) {
                $scope.patient = patient;
                $scope.stay = stay;
                $scope.formTemplate = formTemplate;
                $scope.dirty = false;
                $scope.options = {
                  hideSave: true
                };
                $scope.close = function() {
                  event = $scope.$broadcast('closeRequested');
                  return $q.all(event.closePromises || []).then((function() {
                    return $uibModalInstance.close(false);
                  }));
                };
                return $scope.validateAction = function() {
                  event = $scope.$broadcast('validateRequest');
                  return $q.all(event.validatePromises || []).then((function() {
                    return $uibModalInstance.close(true);
                  }));
                };
              }],
              resolve: {
                patient: patient,
                stay: stay,
                formTemplate: formTemplate
              }
            });
          });
        });
      });
    };
    $scope.setForm = function(form) {
      $scope.form = form;
      if (dirty) {
        return $scope.form.$setDirty();
      }
    };
    ref = $scope.event.tasks;
    for (i = 0, len = ref.length; i < len; i++) {
      task = ref[i];
      task.blocked = (ref1 = task.status) === "N" || ref1 === "R";
      activity = _.find($scope.event.activities, {
        id: task.activity
      });
      if (!activity) {
        activity = {
          id: task.activity,
          label: task.data.label,
          tasks: []
        };
        $scope.event.activities.push(activity);
      }
      activity.tasks.push(task);
    }
    if (indexOf.call($scope.event.category_codes, "medplan_events") >= 0 && _.filter($scope.event.tasks, {
      blocked: true
    }).length === 0) {
      $scope.canDeleteEvent = true;
    }
    $scope.deleteEvent = function() {
      return $uibModalInstance.close({
        "action": "deleteEvent"
      });
    };
    $scope.date = $scope.event.start.toDate();
    d = new Date();
    d.setHours($scope.event.start.hours());
    d.setMinutes($scope.event.start.minutes());
    $scope.times = {
      startTime: d
    };
    $scope.selectUser = function(task, groupId, patientIpp) {
      return UserUtils.selectUserModal(groupId, patientIpp).result.then(function(user) {
        if (user) {
          $scope.form.$setDirty();
          task.data.user_involved_full_name = user.full_name;
          task.data.user_involved_initials = user.user_profile.initials;
          return task.user_involved = user.id;
        }
      });
    };
    if ($scope.event.end) {
      $scope.event.duration = $scope.event.end.diff($scope.event.start, 'minutes');
    } else {
      $scope.event.duration = $scope.event.duration;
    }
    $scope.computeEndTime = function() {
      if ($scope.times.startTime && $scope.event.duration) {
        return $scope.times.endTime = new Date($scope.times.startTime.getTime() + ($scope.event.duration * 60 * 1000));
      } else {
        return $scope.times.endTime = null;
      }
    };
    $scope.computeEndTime();
    $scope.tasksRealization = function(tasks, status) {
      var j, len1, results;
      $scope.form.$setDirty();
      results = [];
      for (j = 0, len1 = tasks.length; j < len1; j++) {
        task = tasks[j];
        if (status === task.status) {
          status = "P";
        }
        task.status = status;
        task.data.done_time = new Date();
        task.author = $rootScope.user.id;
        task.data.user_full_name = $rootScope.user.first_name + " " + $rootScope.user.last_name;
        task.data.initials = $rootScope.user.user_profile.initials || "-";
        results.push(task.data.finess = $rootScope.user.user_profile.finess || "");
      }
      return results;
    };
    $scope.setPlanned = function() {
      var j, len1, ref2;
      ref2 = $scope.event.tasks;
      for (j = 0, len1 = ref2.length; j < len1; j++) {
        task = ref2[j];
        task.status = "P";
      }
      return $scope.modify();
    };
    $scope.modify = function() {
      var j, len1, ref2, start;
      if ($scope.event.allDay) {
        start = moment($scope.date).format("YYYY-MM-DD");
      } else {
        start = moment($scope.date);
        start.hours($scope.times.startTime.getHours());
        start.minutes($scope.times.startTime.getMinutes());
        start.seconds(0);
        start = start.format("YYYY-MM-DDTHH:mm:SS");
      }
      ref2 = $scope.event.tasks;
      for (j = 0, len1 = ref2.length; j < len1; j++) {
        task = ref2[j];
        task.date = moment(start).format("YYYY-MM-DD");
        task.data.start_time = moment(start).format("HH:mm");
        task.data.event_all_day = $scope.event.allDay;
        task.data.event_duration = $scope.event.duration;
        delete task.data.end_time;
      }
      return $uibModalInstance.close({
        "action": "update",
        "tasks": $scope.event.tasks
      });
    };
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=event-medplan-detail-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:EventDetailCtrl
    * @description
    * # EventDetailCtrl
    * TODO put a real description
   */
  angular.module("mhclientApp").controller('EventCoordinationDetailCtrl', ["$timeout", "$scope", "$rootScope", "$q", "Patient", "Stay", "$filter", "$uibModal", "$window", "$uibModalInstance", "UserUtils", "FormTemplateUtils", "Task", "dirty", "resize", "Activity", function($timeout, $scope, $rootScope, $q, Patient, Stay, $filter, $uibModal, $window, $uibModalInstance, UserUtils, FormTemplateUtils, Task, dirty, resize, Activity) {
    var computeActionModal, ref;
    $scope.event = _.cloneDeep($scope.currentEvent);
    $scope.task = $scope.event.tasks[0];
    computeActionModal = function(event, patient, stay, readonly) {
      return $uibModal.open({
        templateUrl: 'taskplanner/views/task-actions.html',
        controller: 'TaskActionsCtrl',
        windowClass: 'modal-fullscreen',
        backdrop: 'static',
        resolve: {
          event: (function() {
            return event;
          }),
          stay: (function() {
            return stay;
          }),
          patient: (function() {
            return patient;
          }),
          readonly: (function() {
            return readonly;
          })
        }
      }).result.then(function(result) {
        return $uibModalInstance.close(result);
      });
    };
    $scope.computeActionModal = function(readonly) {
      if ($rootScope.currentPatient && $rootScope.currentStay) {
        return computeActionModal($scope.event, $rootScope.currentPatient, $rootScope.currentStay, readonly);
      } else {
        return Activity.api.get({
          id: $scope.event.activity
        }).$promise.then(function(activity) {
          return Stay.get({
            id: activity.stay
          }).$promise.then(function(stay) {
            return Patient.get({
              id: stay.patient
            }).$promise.then(function(patient) {
              return computeActionModal($scope.event, patient, stay, readonly);
            });
          });
        });
      }
    };
    $scope.modify = function(duration) {
      return $uibModalInstance.close({
        "action": "update",
        "tasks": $scope.event.tasks
      });
    };
    if ($scope.event.type === "coordination" && ((ref = $scope.event.tasks[0].data.selected_features) != null ? ref.length : void 0) > 0 && $scope.event.status !== 'DONE') {
      $scope.computeActionModal();
    }
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=event-coordination-detail-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:mhModalCtrl
    * @description
    * # mhModalCtrl
    * Provider of mhModalCtrl
   */
  angular.module("mhclientApp").controller('EventPatientDetailCtrl', ["$scope", "$rootScope", "$filter", "$uibModal", "$window", "$uibModalInstance", "dirty", "resize", "UserUtils", "FormTemplateUtils", "Task", "ThesaurusUtils", "GroupUtils", function($scope, $rootScope, $filter, $uibModal, $window, $uibModalInstance, dirty, resize, UserUtils, FormTemplateUtils, Task, ThesaurusUtils, GroupUtils) {
    var init, setDirtyForm, time_str_from_minuts;
    $scope.stopActivity = function(activityId) {
      return $uibModalInstance.close({
        "action": "stopActivity",
        "activity": $scope.event.activity
      });
    };
    $scope.deleteEvent = function(taskId) {
      return $uibModalInstance.close({
        "action": "deleteEvent"
      });
    };
    $scope.setForm = function(form) {
      $scope.form = form;
      if ($scope.dirty) {
        return $scope.form.$setDirty();
      }
    };
    time_str_from_minuts = function(minutes, convert_midnight) {
      var duration, hours;
      duration = moment.duration(minutes, 'minutes');
      if (convert_midnight && duration.hours() === 0) {
        return "23:59";
      }
      hours = duration.hours();
      minutes = duration.minutes() < 10 ? "0" + duration.minutes() : duration.minutes();
      return hours + ":" + minutes;
    };
    setDirtyForm = function() {
      return $scope.form.$setDirty();
    };
    init = function() {
      var base_slider_option, d, minutes, ms;
      $scope.event = angular.copy($scope.currentEvent);
      $scope.date = {
        selected: $scope.event.start.toDate()
      };
      $scope.placeOptions = ThesaurusUtils.getPlaceOptions();
      $scope.event.at_home = $scope.event.tasks[0].data.at_home;
      $scope.event.place = $scope.event.tasks[0].data.place;
      $scope.event.comment = $scope.event.tasks[0].data.comment;
      $scope.resize = resize;
      $scope.dirty = dirty;
      if ($scope.resize) {
        $scope.event.duration = $scope.event.end.diff($scope.event.start, 'minutes');
      } else {
        ms = moment($scope.event.tasks[0].data.end_time, "HH:mm").diff(moment($scope.event.tasks[0].data.start_time, "HH:mm"));
        d = moment.duration(ms);
        minutes = d.asMinutes();
        $scope.event.duration = minutes;
      }
      $scope.thesaurus_category = {
        code: 'patient_agenda'
      };
      GroupUtils.getAllGroups().then(function(groups) {
        var caregivers, i, len, ref, task;
        caregivers = {};
        ref = $scope.event.tasks;
        for (i = 0, len = ref.length; i < len; i++) {
          task = ref[i];
          if (task.group_involved) {
            if (!caregivers[task.group_involved]) {
              caregivers[task.group_involved] = {
                count: 0,
                group_name: _.find(groups, {
                  id: task.group_involved
                }).name
              };
            }
            caregivers[task.group_involved].count += 1;
          }
        }
        return $scope.care = {
          id: $scope.event.activity,
          disableGroupSelection: true,
          readOnly: !$scope.event.durationEditable && !$scope.event.startEditable,
          planning_data: {
            caregivers: caregivers
          },
          data: {
            label: $scope.event.longLabel,
            comment: $scope.event.tasks[0].data.comment,
            duration: $scope.event.tasks[0].data.duration,
            at_home: $scope.event.tasks[0].data.at_home,
            place: $scope.event.tasks[0].data.place
          }
        };
      });
      base_slider_option = {
        translate: function(minutes) {
          return time_str_from_minuts(minutes) + "H";
        },
        step: 15,
        hideLimitLabels: true,
        "floor": 0,
        "ceil": 1440,
        disabled: !$scope.event.durationEditable && !$scope.event.startEditable,
        onChange: function() {
          return $scope.form.$setDirty();
        }
      };
      $scope.time_slot = {
        floor: moment.duration(moment($scope.event.start)).asMinutes(),
        ceil: moment.duration(moment($scope.event.start)).asMinutes() + $scope.event.duration,
        options: angular.copy(base_slider_option)
      };
      return setTimeout((function() {
        return $scope.$broadcast('rzSliderForceRender');
      }), 10);
    };
    $scope.close = function() {
      return $uibModalInstance.close(false);
    };
    $scope.modify = function() {
      var end_time, hasComments, i, len, ref, start_time, task;
      if ($scope.event.allDay) {
        start_time = "";
        end_time = "";
      } else {
        start_time = time_str_from_minuts($scope.time_slot.floor);
        end_time = time_str_from_minuts($scope.time_slot.ceil, true);
      }
      hasComments = false;
      ref = $scope.event.tasks;
      for (i = 0, len = ref.length; i < len; i++) {
        task = ref[i];
        task.date = moment($scope.date.selected).format("YYYY-MM-DD");
        task.data.start_time = start_time;
        task.data.end_time = end_time;
        task.data.event_all_day = $scope.event.allDay;
        task.data.duration = $scope.care.data.duration;
        task.data.at_home = $scope.care.data.at_home;
        task.data.place = $scope.care.data.place;
        task.data.comment = $scope.care.data.comment;
      }
      return $uibModalInstance.close({
        "action": "update",
        "tasks": $scope.event.tasks
      });
    };
    $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=event-patient-detail-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:EventSequenceDetailCtrl
    * @description
    * # EventSequenceDetailCtrl
    * Provider of EventSequenceDetailCtrl
   */
  angular.module("mhclientApp").controller('EventSequenceDetailCtrl', ["$scope", "$rootScope", "$filter", "$uibModal", "$window", "$uibModalInstance", "UserUtils", "FormTemplateUtils", "Task", function($scope, $rootScope, $filter, $uibModal, $window, $uibModalInstance, UserUtils, FormTemplateUtils, Task) {
    var activity, d, i, len, ref, ref1, task;
    $scope.event = angular.copy($scope.currentEvent);
    $scope.event.activities = [];
    ref = $scope.event.tasks;
    for (i = 0, len = ref.length; i < len; i++) {
      task = ref[i];
      task.blocked = (ref1 = task.status) === "N" || ref1 === "R";
      activity = _.find($scope.event.activities, {
        id: task.activity
      });
      if (!activity) {
        activity = {
          id: task.activity,
          label: task.data.label,
          tasks: []
        };
        $scope.event.activities.push(activity);
      }
      activity.tasks.push(task);
    }
    $scope.date = $scope.event.start.toDate();
    d = new Date();
    d.setHours($scope.event.start.hours());
    d.setMinutes($scope.event.start.minutes());
    $scope.startTime = d;
    if ($scope.event.end) {
      $scope.event.duration = $scope.event.end.diff($scope.event.start, 'minutes');
    } else {
      $scope.event.duration = $scope.event.duration;
    }
    $scope.computeEndTime = function() {
      if ($scope.startTime && $scope.event.duration) {
        return $scope.endTime = new Date($scope.startTime.getTime() + ($scope.event.duration * 60 * 1000));
      } else {
        return $scope.endTime = null;
      }
    };
    $scope.computeEndTime();
    return $scope.cancel = function() {
      return $uibModalInstance.close(false);
    };
  }]);

}).call(this);

//# sourceMappingURL=event-sequence-detail-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.provider:CreateSupplierModalCtrl
    * @description
    * # NewActivityModalCtrl
    * Controller of the modal which handles activity creation
   */
  angular.module("mhclientApp").controller('NewActivityModalCtrl', ["$scope", "$uibModalInstance", "$q", "stay", "$rootScope", "ThesaurusUtils", function($scope, $uibModalInstance, $q, stay, $rootScope, ThesaurusUtils) {
    $scope.stay = stay;
    $scope.validate = function() {
      var event;
      event = $scope.$broadcast('validateRequest');
      return $q.all(event.validatePromises || []).then((function(newActivities) {
        $rootScope.busy = false;
        return $uibModalInstance.close(newActivities);
      }));
    };
    return $scope.cancel = function() {
      return $uibModalInstance.dismiss("cancel");
    };
  }]);

}).call(this);

//# sourceMappingURL=new-activity-modal-controller.js.map

(function() {
  'use strict';
  angular.module("mhclientApp").factory('ImageDocument', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, api, image_document, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/documents/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'update': {
        method: 'PATCH',
        headers: {
          'Accept': acceptHeader
        }
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'partial_update': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'PATCH',
        params: {
          id: '@id'
        }
      },
      'exportPosos': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'GET',
        params: {
          id: '@id',
          route: "export_posos"
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        image_document = window.mgapp.get('document_mgr').image_document();
        api = BoxResource.generate(image_document);
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=image-document-service.js.map

(function() {
  'use strict';
  angular.module("mhclientApp").factory('DocViewer', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var api, patient_care_task, portailAPI, service;
    portailAPI = $resource('/api_rest/docviewers/:id/:route', {
      id: this.id
    }, {
      'get_docs': {
        method: 'GET',
        params: {
          id: '@id',
          route: 'get_docs'
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        patient_care_task = window.mgapp.get('docviewer').patient_care_task();
        api = BoxResource.generate(patient_care_task);
        break;
      default:
        api = portailAPI;
    }
    service = {
      api: api
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=docviewer-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:CareCtrl
    * @description
    * # CareCtrl
    * Controller of Patient
   */
  angular.module('mhclientApp').controller('DocViewerCtrl', ["$scope", "$rootScope", "DocViewer", "$state", function($scope, $rootScope, DocViewer, $state) {
    var params;
    $scope.currentPage = 1;
    $scope.numPerPage = 5;
    $scope.collapsed = true;
    $scope.subCollapsed = true;
    params = {
      patient: $rootScope.currentPatient.id
    };

    /*DocViewer.api.query(params).$promise.then (docs) ->
      $scope.data = docs
     */
    DocViewer.api.get_docs(params).$promise.then(function(docs) {
      return $scope.data = docs;
    });
    return $scope.select = function(line) {
      $scope.current = line;
      return $state.go("user.patient.stay.docviewer.detail");
    };
  }]);

}).call(this);

//# sourceMappingURL=docviewer-controller.js.map

(function() {
  'use strict';
  angular.module("mhclientApp").factory('Faq', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, faq, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/faq/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        }
      },
      'save': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'delete': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'DELETE'
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        faq = window.mgapp.get('faq_mgr');
        boxAPI = BoxResource.generate(faq);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

  angular.module("mhclientApp").factory('FaqCategory', ["$resource", "MhConfig", "BoxResource", function($resource, MhConfig, BoxResource) {
    var acceptHeader, boxAPI, category, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/faqcategory/:id/:route', {
      id: this.id
    }, {
      'get': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'create': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      },
      'query': {
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'get_faqs': {
        headers: {
          'Accept': acceptHeader
        },
        params: {
          route: 'get_faqs'
        },
        isArray: true
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        return portailAPI;
      case 'mgapp':
        category = window.mgapp.get('faq_mgr').category();
        boxAPI = BoxResource.generate(category);
        return boxAPI;
      default:
        return portailAPI;
    }
  }]);

}).call(this);

//# sourceMappingURL=faq-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:FaqCtrl
    * @description
    * # FaqCtrl
    * Controller of FAQ
   */
  angular.module('mhclientApp').controller('FaqCtrl', ["$scope", "$q", "$anchorScroll", "Upload", "FaqCategory", "Faq", "$location", "$uibModal", "$filter", function($scope, $q, $anchorScroll, Upload, FaqCategory, Faq, $location, $uibModal, $filter) {
    var init;
    init = function() {
      var faqsInitPromise;
      $scope.newFaq = {};
      $scope.existing_categories = [];
      $scope.category_to_faqs = {};
      faqsInitPromise = $q.defer();
      return FaqCategory.query().$promise.then(function(existing_categories) {
        $scope.existing_categories = existing_categories;
        return $scope.existing_categories.forEach(function(category) {
          $scope.category_to_faqs[category.name] = category.faqs;
          return faqsInitPromise.resolve();
        });
      });
    };
    $scope.toggleNewFaq = function() {
      return $scope.newFaq["new"] = !$scope.newFaq["new"];
    };
    $scope.validate = function() {
      var category, category_name, faqCategoryPromise;
      category_name = $scope.newFaq.category;
      faqCategoryPromise = $q.defer();
      category = _.find($scope.existing_categories, {
        'name': category_name
      });
      if (category) {
        faqCategoryPromise.resolve(category);
      } else {
        FaqCategory.create({
          name: category_name
        }).$promise.then(function(category) {
          $scope.existing_categories.push(category);
          return faqCategoryPromise.resolve(category);
        });
      }
      return faqCategoryPromise.promise.then(function(category) {
        var faqsUploadedPromise, params;
        faqsUploadedPromise = $q.defer();
        $scope.toggleNewFaq();
        params = {};
        params["category"] = category.id;
        params["timestamp"] = new Date().toISOString();
        params["name"] = $scope.newFaq.title;
        params["ref"] = "UNKNOWN";
        params["orientation"] = "PORTRAIT";
        params["author"] = $scope.user.id;
        if ($scope.category_to_faqs[category.name] === void 0) {
          $scope.category_to_faqs[category.name] = [];
        }
        return Upload.upload({
          url: "/api_rest/faq",
          method: "POST",
          file: $scope.newFaq.doc[0],
          fields: params
        }).then(function(response) {
          $scope.current_faq = response.data;
          $scope.category_to_faqs[category.name].push($scope.current_faq);
          $scope.newFaq = {};
          return faqsUploadedPromise.resolve();
        });
      });
    };
    $scope.selectFaq = function(faq) {
      var newHash;
      $scope.current_faq = faq;
      newHash = 'response' + $scope.current_faq.uid;
      if ($location.hash() !== newHash) {
        $location.hash(newHash);
      } else {
        $location.hash('top');
      }
      return $anchorScroll();
    };
    $scope.removeFaq = function(faq) {
      var confirm_dialog;
      confirm_dialog = $uibModal.open({
        animation: true,
        templateUrl: 'core/views/modal-template.html',
        size: "lg",
        controller: 'mhModalCtrl',
        resolve: {
          title: function() {
            return null;
          },
          text: function() {
            return $filter('translate')("CONFIRM_REMOVE_FAQ");
          },
          cancelButtonText: function() {
            return $filter('translate')("CANCEL_BUTTON");
          },
          noButtonText: function() {
            return '';
          },
          okButtonText: function() {
            return $filter('translate')("CONFIRM");
          }
        }
      });
      return confirm_dialog.result.then(function(result) {
        if (result) {
          return Faq["delete"]({
            id: faq.id
          }).$promise.then(function() {
            return Object.keys($scope.category_to_faqs).forEach(function(category) {
              var faq_obj, remove_from_list;
              faq_obj = _.find($scope.category_to_faqs[category], {
                'id': faq.id
              });
              if (faq_obj) {
                remove_from_list = $scope.category_to_faqs[category];
                return remove_from_list.splice(remove_from_list.indexOf(faq_obj), 1);
              }
            });
          });
        }
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=faq-controller.js.map

(function() {
  'use strict';
  angular.module("mhclientApp").factory('ExportPdf', ["$resource", "MhConfig", function($resource, MhConfig) {
    var acceptHeader, portailAPI;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/export_pdf/:id/:route', {
      id: this.id
    }, {
      'post': {
        headers: {
          'Accept': acceptHeader
        },
        method: 'POST'
      }
    });
    return portailAPI;
  }]);

}).call(this);

//# sourceMappingURL=export-pdf-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:ExportPdfCtrl
    * @description
    * # ExportPdfCtrl
    * Controller of PDF export module
   */
  angular.module('mhclientApp').controller('ExportPdfCtrl', ["$scope", "$stateParams", "$filter", "FeatureUtils", "Stay", "$rootScope", function($scope, $stateParams, $filter, FeatureUtils, Stay, $rootScope) {
    var init;
    init = function() {
      $scope.printLaunched = false;
      FeatureUtils.getAllFeatures().then(function(features) {
        var activeFeatures, availableExport, availableExports, feature, i, len;
        availableExports = [
          {
            "name": "IMG",
            "feature": "IMG"
          }, {
            "name": "LIA",
            "feature": "LIA"
          }, {
            "name": "NUM",
            "feature": "NUM"
          }, {
            "name": "ORP_CUR",
            "feature": "ORP"
          }, {
            "name": "ORI",
            "feature": "ORI"
          }, {
            "name": "ORT",
            "feature": "ORT"
          }, {
            "name": "MHC_AGENDA",
            "feature": "MHC_AGENDA"
          }, {
            "name": "MHC_DIARY",
            "feature": "MHC_DIARY"
          }, {
            "name": "MHC_OBSERVATION",
            "feature": "MHC_OBSERVATION"
          }, {
            "name": "MHC_TRANSMISSION",
            "feature": "MHC_TRANSMISSION"
          }, {
            "name": "MHC_CARE_CREATION",
            "feature": "MHC_CARE_CREATION"
          }, {
            "name": "MHC_CARE_REALIZATION",
            "feature": "MHC_CARE_REALIZATION"
          }, {
            "name": "SVM",
            "feature": "SVM"
          }, {
            "name": "MHC_FORMS_TEMPLATES",
            "feature": "MHC_FORMS",
            "extraLabel": $filter('translate')("TEMPLATES")
          }, {
            "name": "MHC_FORMS_FILLED",
            "feature": "MHC_FORMS",
            "extraLabel": $filter('translate')("FILLED")
          }, {
            "name": "MHC_STAFF",
            "feature": "MHC_STAFF"
          }, {
            "name": "MHC_CONTACTS",
            "feature": "MHC_CONTACTS"
          }, {
            "name": "MHC_MISSION_LETTER",
            "feature": "MHC_MISSION_LETTER"
          }, {
            "name": "MHC_PREAD",
            "feature": "MHC_PREAD"
          }, {
            "name": "MHC_PREAD_FOLLOW_UP_WR",
            "feature": "MHC_PREAD_FOLLOW_UP_WR"
          }, {
            "name": "MHC_PSP",
            "feature": "MHC_PSP"
          }, {
            "name": "MHC_IAS",
            "feature": "MHC_IAS"
          }, {
            "name": "MHC_COVERAGE",
            "feature": "MHC_COVERAGE"
          }, {
            "name": "MHC_ORDERS",
            "feature": "MHC_ORDERS"
          }, {
            "name": "MHC_SANITARY_TRANSPORT",
            "feature": "MHC_SANITARY_TRANSPORT"
          }, {
            "name": "MHC_WORK_REPORT",
            "feature": "MHC_WORK_REPORT"
          }, {
            "name": "MHC_PSI",
            "feature": "MHC_PSI"
          }, {
            "name": "MHC_SOCIALINFO",
            "feature": "MHC_SOCIALINFO"
          }, {
            "name": "MHC_SOCIALPROJECT",
            "feature": "MHC_SOCIALPROJECT"
          }, {
            "name": "MHC_MEDICALINFO",
            "feature": "MHC_MEDICALINFO"
          }, {
            "name": "EQUIPMENT_INVOICE",
            "feature": "EQUIPMENT_INVOICE"
          }
        ];
        activeFeatures = _.filter(features, {
          active: true
        });
        $scope.canExportFeatures = [];
        for (i = 0, len = availableExports.length; i < len; i++) {
          availableExport = availableExports[i];
          feature = _.find(activeFeatures, {
            name: availableExport.feature
          });
          if (feature) {
            availableExport.label = feature.label;
            if (availableExport.extraLabel) {
              availableExport.label += " " + availableExport.extraLabel;
            }
            $scope.canExportFeatures.push(availableExport);
          }
        }
        return $scope.canExportFeaturesChunked = _.chunk($filter('orderBy')($scope.canExportFeatures, 'label'), 4);
      });
      $scope.selectedFeaturesToExport = [];
      $scope.base_export_url = "/webfw/pat_mgr/export_as_pdf_with_period/";
      return $scope.disableArchiveButton = false;
    };
    $scope.exportPdf = function(exportStartDate, exportEndDate) {
      var end_date, export_url, featureName, i, len, ref, start_date;
      if (exportStartDate) {
        start_date = moment(exportStartDate).format('YYYYMMDD');
      }
      if (exportEndDate) {
        end_date = moment(exportEndDate).format('YYYYMMDD');
      }
      ref = $scope.selectedFeaturesToExport;
      for (i = 0, len = ref.length; i < len; i++) {
        featureName = ref[i];
        export_url = $scope.base_export_url + $rootScope.currentStay.id + "/" + featureName + "/";
        if (start_date && end_date) {
          export_url = export_url + start_date + "/" + end_date + "/";
        }
        window.open(export_url, '_blank');
      }
      return true;
    };
    $scope.exportAll = function(exportStartDate, exportEndDate, selectedOnly) {
      var feature, featuresToExport, i, len, params, ref;
      featuresToExport = [];
      if (selectedOnly) {
        featuresToExport = $scope.selectedFeaturesToExport;
      } else {
        ref = $scope.canExportFeatures;
        for (i = 0, len = ref.length; i < len; i++) {
          feature = ref[i];
          featuresToExport.push(feature.name);
        }
      }
      params = {};
      params["user"] = $scope.user;
      params["list_doc_type"] = featuresToExport;
      params["start_date"] = exportStartDate;
      params["end_date"] = exportEndDate;
      params["print_now"] = true;
      if (featuresToExport.length === 1) {
        return $scope.exportPdf(exportStartDate, exportEndDate);
      } else {
        Stay.printStay({
          id: $stateParams.idStay,
          params: params
        }).$promise.then(function(data) {
          return $scope.printLaunched = true;
        });
        return alert($filter('translate')("PRINT_WILL_BE_SENT_VIA_EMAIL_TODAY"));
      }
    };
    $scope.toggleFeatureSelection = function(featureName, checked) {
      var index_of_feature;
      index_of_feature = $scope.selectedFeaturesToExport.indexOf(featureName);
      if (checked) {
        return $scope.selectedFeaturesToExport.push(featureName);
      } else if (index_of_feature > -1) {
        return $scope.selectedFeaturesToExport.splice(index_of_feature, 1);
      }
    };
    $scope.archiveStay = function() {
      var params;
      params = {};
      params["print_now"] = true;
      return Stay.archiveStay({
        id: $stateParams.idStay,
        params: params
      }).$promise.then(function(data) {
        $scope.disableArchiveButton = true;
        return alert($filter('translate')("ARCHIVE_WILL_BE_AVAILABLE_TOMM_AT"));
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=export-pdf-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:StatsCtrl
    * @description
    * # StatsCtrl
    * Controller to open stats
   */
  angular.module('mhclientApp').controller('StatsCtrl', ["$scope", "$rootScope", function($scope, $rootScope) {
    $rootScope.busy = true;
    $scope.stats_iframe_url = $scope.base_iframe_url + '/webfw/stats/content_page';
    $scope.iframeLoadCallback = function() {
      return $rootScope.$evalAsync(function() {
        return $rootScope.busy = false;
      });
    };
    return $scope.$on("$destroy", function() {
      return $rootScope.busy = false;
    });
  }]);

}).call(this);

//# sourceMappingURL=stats-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:SeqStatsCtrl
    * @description
    * # StatsCtrl
    * Controller to open sequence realization stats
   */
  angular.module('mhclientApp').controller('SeqStatsCtrl', ["$scope", "$rootScope", "$filter", "$q", "SequenceStats", "UserStats", "PatientStats", "SequenceRealizationStats", "GroupUtils", function($scope, $rootScope, $filter, $q, SequenceStats, UserStats, PatientStats, SequenceRealizationStats, GroupUtils) {
    var createCSVData, getCSVHeaders, getCSVRowsData, incrementalItems, init, seqRealizations;
    $scope.filters = {};
    $scope.nbShowItems = 80;
    incrementalItems = 20;
    seqRealizations = [];
    $scope.filteredSeqRealizations = [];
    $scope.addMoreItems = function() {
      if ($scope.nbShowItems < $scope.filteredSeqRealizations.length) {
        return $scope.nbShowItems = $scope.nbShowItems + incrementalItems;
      }
    };
    $scope.filter = function() {
      var filtered;
      if ($scope.filters.d_from || $scope.filters.d_to) {
        $scope.nbShowItems = 80;
        filtered = $filter("userFilter")(seqRealizations, $scope.filters.caregiver);
        filtered = $filter("patientFilter")(filtered, $scope.filters.patFirstName, $scope.filters.patLastName);
        filtered = $filter("periodFilter")(filtered, $scope.filters.d_from, $scope.filters.d_to);
        return $scope.filteredSeqRealizations = filtered;
      } else {
        return $scope.filteredSeqRealizations = [];
      }
    };
    document.title = $filter('translate')('SEQ_STATS');
    getCSVHeaders = function() {
      return _.map(['FIRST_NAME', 'LAST_NAME', 'IPP', 'TIMESTAMP', 'GROUP', 'NAMES', 'DATE', 'LABEL', 'ESTIMATED_DURATION', 'REAL_DURATION', 'GAP'], function(label) {
        return $filter('translate')(label);
      });
    };
    createCSVData = function(headers) {
      var csvContent, rows;
      rows = getCSVRowsData();
      rows.unshift(getCSVHeaders());
      csvContent = "";
      rows.forEach(function(rowArray) {
        var row;
        row = rowArray.join(",");
        return csvContent += row + "\r\n";
      });
      return csvContent;
    };
    $scope.exporCsv = function() {
      var a, blob;
      a = document.createElement('a');
      if (window.navigator.msSaveOrOpenBlob) {
        blob = new Blob([decodeURIComponent(encodeURI(createCSVData()))], {
          type: 'text/csv;charset=utf-8;'
        });
        return navigator.msSaveBlob(blob, 'my_data.csv');
      } else {
        a.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(createCSVData());
        a.target = '_blank';
        a.download = 'my_data.csv';
        document.body.appendChild(a);
        return a.click();
      }
    };
    getCSVRowsData = function() {
      var rows;
      rows = [];
      _.forEach($scope.filteredSeqRealizations, function(seqRealization) {
        return _.forEach(seqRealization.sequences, function(sequence) {
          var row;
          row = [];
          row.push(seqRealization.patient_infos.name);
          row.push(seqRealization.patient_infos.last_name);
          row.push(seqRealization.patient_infos.si_id);
          row.push(sequence.timeslot);
          row.push(seqRealization.user_infos.group);
          row.push(seqRealization.user_infos.first_name + " / " + seqRealization.user_infos.last_name);
          row.push(moment(seqRealization.arrival_timestamp).format("DD/MM/YYYY"));
          row.push(sequence.label);
          row.push(sequence.estimated_duration);
          row.push(sequence.real_duration);
          row.push(sequence.gap);
          return rows.push(row);
        });
      });
      return rows;
    };
    init = function() {
      var params;
      params = {
        for_sequence_realisation: true,
        entity: $scope.user.entity
      };
      return $q.all([SequenceRealizationStats.api.query(params).$promise, SequenceStats.api.query(params).$promise, UserStats.api.query(params).$promise, PatientStats.api.query(params).$promise, GroupUtils.getAllGroups()]).then(function(data) {
        var groupById, patientById, sequenceByUid, userById;
        userById = {};
        patientById = {};
        sequenceByUid = {};
        groupById = {};
        _.map(data[3], function(patient) {
          return patientById[patient.id] = patient;
        });
        _.map(data[4], function(group) {
          return groupById[group.id] = group;
        });
        _.map(data[1], function(sequence) {
          return sequenceByUid[sequence.uid] = sequence;
        });
        _.map(data[2], function(user) {
          userById[user.id] = user;
          return user.group = (groupById[user.group] || {
            name: user.group
          }).name;
        });
        _.forEach(data[0], function(seqRealization) {
          seqRealization.user_infos = userById[seqRealization.user];
          seqRealization.patient_infos = patientById[seqRealization.patient];
          seqRealization.sequences = [];
          _.forEach(seqRealization.data.estimated_times, function(estimatedTime) {
            var arrival_timestamp, departure_timestamp, real_duration, seq;
            if (!(estimatedTime.sequence_uid in sequenceByUid)) {
              return;
            }
            seq = sequenceByUid[estimatedTime.sequence_uid];
            arrival_timestamp = new Date(seqRealization.arrival_timestamp);
            departure_timestamp = new Date(seqRealization.departure_timestamp);
            real_duration = Math.abs(departure_timestamp.getTime() - arrival_timestamp.getTime());
            real_duration = Math.ceil(real_duration / (1000 * 60));
            return seqRealization.sequences.push({
              "estimated_duration": estimatedTime.duration,
              "label": seq.data.name,
              "timeslot": seq.planning_data.timeslots[0].start_time + " - " + seq.planning_data.timeslots[0].end_time,
              "real_duration": real_duration,
              "gap": real_duration - estimatedTime.duration
            });
          });
          if (seqRealization.sequences.length > 0) {
            return seqRealizations.push(seqRealization);
          }
        });
        return $scope.filter();
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=seq-stats-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:UsrConnCtrl
    * @description
    * # UsrConnCtrl
    * Controller to user connections stats
   */
  angular.module('mhclientApp').controller('UsrConnCtrl', ["$scope", "$rootScope", "$filter", "$q", "UserConn", function($scope, $rootScope, $filter, $q, UserConn) {
    var createCSVData, format_datetime_to_str, getCSVHeaders, getCSVRowsData, incrementalItems, user_connections;
    $scope.filters = {};
    $scope.nbShowItems = 80;
    incrementalItems = 20;
    user_connections = [];
    $scope.filtered_user_connections = [];
    $scope.nbShowItems = 80;
    incrementalItems = 20;
    $scope.addMoreItems = function() {
      if ($scope.nbShowItems < $scope.filtered_user_connections.length) {
        return $scope.nbShowItems = $scope.nbShowItems + incrementalItems;
      }
    };
    document.title = $filter('translate')('CONN_TRACE');
    $scope.get_usr_conn = function() {
      var params, tz_offset_in_hours, tz_offset_in_s;
      if ($scope.filters.d_from && $scope.filters.d_to) {
        tz_offset_in_s = -new Date().getTimezoneOffset();
        tz_offset_in_hours = tz_offset_in_s / 60;
        params = {
          for_sequence_realisation: true,
          entity: $scope.user.entity,
          d_from: moment($scope.filters.d_from).format("YYYY-MM-DD"),
          d_to: moment($scope.filters.d_to).format("YYYY-MM-DD"),
          tz: tz_offset_in_hours
        };
        return $q.all([UserConn.api.query(params).$promise]).then(function(data) {
          var duration, duration_hours, duration_minutes, duration_seconds, duration_str, i, len, session;
          user_connections = data[0];
          for (i = 0, len = user_connections.length; i < len; i++) {
            session = user_connections[i];
            session["connected"] = new Date(moment.utc(session["connected"]));
            session["disconnected"] = new Date(moment.utc(session["disconnected"]));
            duration = moment.duration(Math.round(session["duration"]), "seconds");
            duration_seconds = String(duration.get("seconds")).padStart(2, "0");
            duration_minutes = String(duration.get("minutes")).padStart(2, "0");
            duration_hours = String(Math.floor(duration.asHours())).padStart(2, "0");
            duration_str = "" + duration_hours + ":" + duration_minutes + ":" + duration_seconds;
            session["duration"] = duration_str;
          }
          user_connections.sort(function(a, b) {
            if (a.connected >= b.connected) {
              return 1;
            } else {
              return -1;
            }
          });
          $scope.filtered_user_connections = user_connections;
          return $scope.filters.user = "";
        });
      }
    };
    $scope.filter_by_usr = function() {
      var i, len, results, value;
      $scope.filtered_user_connections = [];
      results = [];
      for (i = 0, len = user_connections.length; i < len; i++) {
        value = user_connections[i];
        if (value["user"].includes($scope.filters.user)) {
          results.push($scope.filtered_user_connections.push(value));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };
    getCSVHeaders = function() {
      return _.map(['USERNAME', 'D_CONNECTION', 'D_DISCONNECTION', 'DURATION'], function(label) {
        return $filter('translate')(label);
      });
    };
    createCSVData = function(headers) {
      var csvContent, rows;
      rows = getCSVRowsData();
      rows.unshift(getCSVHeaders());
      csvContent = "";
      rows.forEach(function(rowArray) {
        var row;
        row = rowArray.join(",");
        return csvContent += row + "\r\n";
      });
      return csvContent;
    };
    $scope.exporCsv = function() {
      var a, blob;
      a = document.createElement('a');
      if (window.navigator.msSaveOrOpenBlob) {
        blob = new Blob([decodeURIComponent(encodeURI(createCSVData()))], {
          type: 'text/csv;charset=utf-8;'
        });
        return navigator.msSaveBlob(blob, 'my_data.csv');
      } else {
        a.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(createCSVData());
        a.target = '_blank';
        a.download = 'my_data.csv';
        document.body.appendChild(a);
        return a.click();
      }
    };
    getCSVRowsData = function() {
      var rows;
      rows = [];
      _.forEach($scope.filtered_user_connections, function(user_conn) {
        var row, user_conn_str, user_disconn_str;
        row = [];
        user_conn_str = format_datetime_to_str(user_conn.connected);
        user_disconn_str = format_datetime_to_str(user_conn.disconnected);
        row.push(user_conn.user);
        row.push(user_conn_str);
        row.push(user_disconn_str);
        row.push(user_conn.duration);
        return rows.push(row);
      });
      return rows;
    };
    return format_datetime_to_str = function(date) {
      var date_str, day, hours, minutes, month, seconds, time_offset, time_offset_str, year;
      time_offset = -date.getTimezoneOffset();
      if (time_offset >= 0) {
        time_offset_str = "GMT+" + time_offset / 60;
      } else {
        time_offset_str = "GMT" + time_offset / 60;
      }
      seconds = String(date.getSeconds()).padStart(2, "0");
      minutes = String(date.getMinutes()).padStart(2, "0");
      hours = String(date.getHours()).padStart(2, "0");
      day = String(date.getDate()).padStart(2, "0");
      month = String(date.getMonth() + 1).padStart(2, "0");
      year = date.getFullYear();
      date_str = day + "-" + month + "-" + year + " " + hours + ":" + minutes + ":" + seconds + " " + time_offset_str;
      return date_str;
    };
  }]);

}).call(this);

//# sourceMappingURL=usr-conn-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:UsrConnAttemptsCtrl
    * @description
    * # UsrConnAttemptsCtrl
    * Controller to user connection attempts stats
   */
  angular.module('mhclientApp').controller('UsrConnAttemptsCtrl', ["$scope", "CSVUtils", "$timeout", "$filter", "AuditLogs", function($scope, CSVUtils, $timeout, $filter, AuditLogs) {
    var createCSVData, debounceTimeout, format_datetime_to_str, getCSVHeaders, getCSVRowsData;
    $scope.logs = [];
    $scope.loading = false;
    $scope.noMoreItemsAvailable = false;
    $scope.queryFiltersChanged = true;
    $scope.now = moment();
    $scope.search = {
      user: '',
      d_from: '',
      d_to: '',
      status: ''
    };
    $scope.successFilter = function(item) {
      if ($scope.search.status === "SUCCESS" && !item.data.success === true) {
        return false;
      }
      if ($scope.search.status === "FAILURE" && item.data.success === true) {
        return false;
      }
      return true;
    };
    $scope.loadMore = function() {
      if (!$scope.loading) {
        $scope.loading = true;
        if ($scope.queryFiltersChanged) {
          $scope.queryFiltersChanged = false;
          $scope.logs = [];
          $scope.page = 1;
          $scope.params = {
            log_type: "login"
          };
          if ($scope.search.user) {
            $scope.params.username = $scope.search.user;
          }
          if ($scope.search.d_from) {
            $scope.params.start_date = moment($scope.search.d_from).startOf('day').toISOString();
          }
          if ($scope.search.d_to) {
            $scope.params.end_date = moment.min([$scope.now, moment($scope.search.d_to).endOf('day')]).toISOString();
          } else {
            $scope.params.end_date = $scope.now.toISOString();
          }
        }
        $scope.params.page = $scope.page;
        return AuditLogs.api.paged_query($scope.params).$promise.then(function(response) {
          if ($scope.loading) {
            $scope.logs = $scope.logs.concat(response.results);
            $scope.page += 1;
            $scope.loading = false;
            if (!response.next) {
              return $scope.noMoreItemsAvailable = true;
            }
          }
        });
      }
    };
    debounceTimeout = null;
    $scope.debounce = function(func, delay) {
      $timeout.cancel(debounceTimeout);
      return debounceTimeout = $timeout(func, delay);
    };
    $scope.filterLogs = function() {
      $scope.now = moment();
      $scope.loading = false;
      $scope.queryFiltersChanged = true;
      $scope.noMoreItemsAvailable = false;
      return $scope.loadMore();
    };
    $scope.filterLogs();
    document.title = $filter('translate')('CONN_TRACE_ATTEMPTS');
    getCSVHeaders = function() {
      return _.map(['USERNAME', 'DATE', 'STATUS', 'IP_ADDRESS'], function(label) {
        return $filter('translate')(label);
      });
    };
    createCSVData = function(rows, headers) {
      var csvContent;
      rows.unshift(headers);
      csvContent = "";
      rows.forEach(function(rowArray) {
        var row;
        row = rowArray.join(",");
        return csvContent += row + "\r\n";
      });
      return csvContent;
    };
    $scope.exportCsv = function() {
      if ($scope.search.user) {
        $scope.params.username = $scope.search.user;
      }
      if ($scope.search.d_from) {
        $scope.params.start_date = moment($scope.search.d_from).startOf('day').toISOString();
      }
      if ($scope.search.d_to) {
        $scope.params.end_date = moment.min([$scope.now, moment($scope.search.d_to).endOf('day')]).toISOString();
      }
      return AuditLogs.api.query($scope.params).$promise.then(function(results) {
        var headers, rows;
        rows = getCSVRowsData(results);
        headers = getCSVHeaders();
        return CSVUtils.exportCSV(createCSVData(rows, headers), "usrconn-attempts.csv");
      });
    };
    getCSVRowsData = function(results) {
      var rows;
      rows = [];
      _.forEach(_.filter(results, $scope.successFilter), function(log) {
        var datetime_str, row, success_str;
        if ($scope.successFilter(log)) {
          row = [];
          datetime_str = format_datetime_to_str(moment(log.datetime).toDate());
          success_str = '';
          if (log.data.success === true) {
            success_str = $filter('translate')("SUCCESS");
          }
          if (log.data.success === false) {
            success_str = $filter('translate')("FAILURE");
          }
          row.push(log.author);
          row.push(datetime_str);
          row.push(success_str);
          row.push(log.data.user_ip || '');
          return rows.push(row);
        }
      });
      return rows;
    };
    return format_datetime_to_str = function(date) {
      var date_str, day, hours, minutes, month, seconds, time_offset, time_offset_str, year;
      time_offset = -date.getTimezoneOffset();
      if (time_offset >= 0) {
        time_offset_str = "GMT+" + time_offset / 60;
      } else {
        time_offset_str = "GMT" + time_offset / 60;
      }
      seconds = String(date.getSeconds()).padStart(2, "0");
      minutes = String(date.getMinutes()).padStart(2, "0");
      hours = String(date.getHours()).padStart(2, "0");
      day = String(date.getDate()).padStart(2, "0");
      month = String(date.getMonth() + 1).padStart(2, "0");
      year = date.getFullYear();
      date_str = day + "-" + month + "-" + year + " " + hours + ":" + minutes + ":" + seconds + " " + time_offset_str;
      return date_str;
    };
  }]);

}).call(this);

//# sourceMappingURL=usr-conn-attempts-controller.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:StatsFactory
    * @description
    * # Patient
    * Factory of Stats
   */
  angular.module("mhclientApp").factory('MHCareStats', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    return $resource('/api_rest/mhcare_stats/:queryId/:route', {
      queryId: '@queryId'
    }, {
      'getQueries': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'postQuery': {
        method: "POST",
        headers: {
          'Accept': acceptHeader
        }
      },
      'patchQuery': {
        method: "PATCH",
        headers: {
          'Accept': acceptHeader
        }
      },
      'deleteQuery': {
        method: "DELETE",
        headers: {
          'Accept': acceptHeader
        }
      },
      'extractModels': {
        method: 'POST',
        params: {
          route: 'extract_models'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'testQuery': {
        method: 'POST',
        params: {
          route: 'test_query'
        },
        headers: {
          'Accept': acceptHeader
        }
      },
      'runQuery': {
        method: 'POST',
        params: {
          route: 'run_query'
        },
        headers: {
          'Accept': acceptHeader
        }
      }
    });
  }]);

  angular.module("mhclientApp").factory('SequenceRealizationStats', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/sequence_realization_stats/:route', {}, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    service = {
      api: portailAPI
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('SequenceStats', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/sequence_stats/:route', {}, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    service = {
      api: portailAPI
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('UserStats', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/user_stats/:route', {}, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    service = {
      api: portailAPI
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('PatientStats', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/patient_stats/:route', {}, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    service = {
      api: portailAPI
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('UserConn', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/user_conn/:route', {}, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    service = {
      api: portailAPI
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('IqssStats', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/iqss_results/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        }
      },
      bench: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        }
      },
      getIQSSResults: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    service = {
      api: portailAPI
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('IqssConfigs', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/iqss_config/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      get: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        }
      },
      by_year: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      }
    });
    service = {
      api: portailAPI
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('IqssCategories', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/iqss_categories/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      get: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        }
      }
    });
    service = {
      api: portailAPI
    };
    return service;
  }]);

  angular.module("mhclientApp").factory('AuditLogs', ["$resource", "MhConfig", "$q", "BoxResource", function($resource, MhConfig, $q, BoxResource) {
    var acceptHeader, portailAPI, service;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/audit_logs/:id/:route', {}, {
      query: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      paged_query: {
        method: 'GET',
        headers: {
          'Accept': acceptHeader
        },
        params: {
          page_size: 50
        }
      }
    });
    service = {
      api: portailAPI
    };
    return service;
  }]);

}).call(this);

//# sourceMappingURL=stats-service.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.filter
    * @description
    * # Patient
    * filters used in  Seq Stats
   */
  angular.module("mhclientApp").filter('userFilter', function() {
    return function(input, caregiver) {
      var output;
      output = [];
      if (caregiver && caregiver.length > 1) {
        angular.forEach(input, function(item) {
          if (_.includes(item.user_infos.first_name.toLowerCase(), caregiver.toLowerCase()) || _.includes(item.user_infos.last_name.toLowerCase(), caregiver.toLowerCase())) {
            return output.push(item);
          }
        });
      } else {
        output = input;
      }
      return output;
    };
  }).filter('patientFilter', function() {
    return function(input, first_name, last_name) {
      var output, output_first_name;
      output_first_name = [];
      output = [];
      if (first_name && first_name.length > 1) {
        angular.forEach(input, function(item) {
          if (_.includes(item.patient_infos.name.toLowerCase(), first_name.toLowerCase())) {
            return output_first_name.push(item);
          }
        });
      } else {
        output_first_name = input;
      }
      if (last_name && last_name.length > 1) {
        angular.forEach(output_first_name, function(item) {
          if (_.includes(item.patient_infos.last_name.toLowerCase(), last_name.toLowerCase())) {
            return output.push(item);
          }
        });
      } else {
        output = output_first_name;
      }
      return output;
    };
  }).filter('periodFilter', function() {
    return function(input, d_from, d_to) {
      var d_from_time, d_to_time, output, output_d_from;
      output_d_from = [];
      output = [];
      if (d_from) {
        d_from_time = moment(d_from);
        angular.forEach(input, function(item) {
          if (!d_from_time.isAfter(moment(item.arrival_timestamp), 'day')) {
            return output_d_from.push(item);
          }
        });
      } else {
        output_d_from = input;
      }
      if (d_to) {
        d_to_time = moment(d_to);
        angular.forEach(output_d_from, function(item) {
          if (!d_to_time.isBefore(moment(item.arrival_timestamp), 'day')) {
            return output.push(item);
          }
        });
      } else {
        output = output_d_from;
      }
      return output;
    };
  });

}).call(this);

//# sourceMappingURL=seq-stats-filter.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.controller:IqssResultsCtrl
    * @description
    * # IqssResultsCtrl
    * Controller to display IQSS results (Suivi IQSS)
   */
  angular.module('mhclientApp').controller('IqssResultsCtrl', ["$scope", "$rootScope", "$q", "$state", "$filter", "$http", "$timeout", "IqssStats", "IqssCategories", "IqssConfigs", "Stay", "Patient", "Entity", "MedicalUnit", "Sector", function($scope, $rootScope, $q, $state, $filter, $http, $timeout, IqssStats, IqssCategories, IqssConfigs, Stay, Patient, Entity, MedicalUnit, Sector) {
    var init, query, setHeaders;
    init = function() {
      var queries, stayPromise;
      $rootScope.busy = true;
      $scope.filters = {};
      $scope.filteredReport = [];
      $scope.stayResults = [];
      $scope.stay = null;
      $scope.calcResults = {};
      $scope.resultsHeaders = [];
      $scope.headers = {};
      setHeaders();
      stayPromise = $q.defer();
      queries = [MedicalUnit.getMedicalUnits(), Sector.getSectors(), Entity.getEntities()];
      $q.all(queries).then(function(data) {
        var entity, i, j, k, len, len1, len2, medicalunit, ref, ref1, ref2, results, sector;
        $scope.medicalunits = {};
        ref = data[0];
        for (i = 0, len = ref.length; i < len; i++) {
          medicalunit = ref[i];
          $scope.medicalunits[medicalunit.id] = medicalunit;
        }
        $scope.sectors = {};
        ref1 = data[1];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          sector = ref1[j];
          $scope.sectors[sector.id] = sector;
        }
        $scope.entities = {};
        ref2 = data[2];
        results = [];
        for (k = 0, len2 = ref2.length; k < len2; k++) {
          entity = ref2[k];
          entity.LABEL_TITLE = entity.sitevars.LABEL_TITLE;
          results.push($scope.entities[entity.id] = entity);
        }
        return results;
      });
      Stay.query().$promise.then(function(stayList) {
        return Patient.query().$promise.then(function(patientList) {
          return stayList.forEach(function(stay) {
            stay.patient = _.find(patientList, {
              id: stay.patient
            });
            return stayPromise.resolve(stayList);
          });
        });
      });
      return stayPromise.promise.then(function(stayList) {
        $scope.stayList = stayList;
        return $rootScope.busy = false;
      });
    };
    query = function(url) {
      var doQuery, queryResults;
      queryResults = $q.defer();
      doQuery = function() {
        $http.get(url).success(function(body) {
          if (!body) {
            $timeout(doQuery, 2000);
            return;
          }
          queryResults.resolve(body);
        }).error(function() {
          $timeout(doQuery, 2000);
        });
      };
      doQuery();
      return queryResults.promise;
    };
    setHeaders = function() {
      var headers, iqssCategoryPromise;
      iqssCategoryPromise = $q.defer();
      headers = {};
      IqssCategories.api.query().$promise.then(function(categories) {
        return IqssConfigs.api.by_year().$promise.then(function(configs) {
          _.forEach(categories, function(category) {
            return headers[category.uid] = _.filter(configs, function(config) {
              return config.category === category.id;
            });
          });
          return iqssCategoryPromise.resolve(headers);
        });
      });
      return iqssCategoryPromise.promise.then(function(headers) {
        return $scope.headers = headers;
      });
    };
    $scope.selectStay = function(stay) {
      $scope.currentStay = _.find($scope.stayList, {
        id: stay.id
      });
      return $scope.stayResults = [];
    };
    $scope.goToStay = function(stayId, patientId) {
      var url;
      url = $state.href('user.patient.stay.dashboard', {
        idStay: stayId,
        idPatient: patientId
      });
      window.open(url, '_blank');
      return true;
    };
    $scope.displayIqssResults = function() {
      var params;
      $rootScope.busy = true;
      params = {
        "from_date": moment($scope.filters.from_date).format("YYYY-MM-DD"),
        "to_date": moment($scope.filters.to_date).format("YYYY-MM-DD")
      };
      return IqssStats.api.query(params).$promise.then(function(iqssData) {
        return query(iqssData.result).then(function(data) {
          var groupedForCalc;
          $scope.calcResults = {};
          groupedForCalc = _.merge(_.groupBy(_.flatten(_.map(data, 'results')), 'category.uid'), _.groupBy(_.flatten(_.map(data, 'results')), 'criterion'));
          _.forEach(groupedForCalc, function(values, key) {
            return $scope.calcResults[key] = parseFloat(((_.filter(values, {
              outcome: "1_OUI"
            }).length / values.length) * 100).toFixed(2));
          });
          $scope.iqssData = data;
          $scope.computeTableRows();
          return $rootScope.busy = false;
        });
      });
    };
    $scope.displayIqssResultsDetailed = function() {
      $scope.stayResults = [];
      $rootScope.busy = true;
      return IqssStats.api.get({
        id: $scope.currentStay.id
      }).$promise.then(function(stayIqss) {
        $scope.stayResults = _.groupBy(stayIqss.results, "category.name");
        return $rootScope.busy = false;
      });
    };
    $scope.computeTableRows = function() {
      $scope.filteredReport = [];
      return _.forEach($scope.iqssData, function(data) {
        var line;
        line = {
          'si_id': data.stay_si_id,
          'stay': _.find($scope.stayList, {
            'si_id': data.stay_si_id
          }),
          'indicatorData': {},
          'statGroupbyCat': {}
        };
        _.forEach(data.results, function(result) {
          return line.indicatorData[result.criterion] = result.outcome;
        });
        line.statGroupbyCat = _.mapValues(_.groupBy(data.results, "category.uid"), function(grouped_results) {
          return (_.filter(grouped_results, {
            outcome: "1_OUI"
          }).length / grouped_results.length * 100).toFixed(2);
        });
        return $scope.filteredReport.push(line);
      });
    };
    return init();
  }]);

}).call(this);

//# sourceMappingURL=iqss-results-controller.js.map

'use strict';


// TODO
// EmailField
// Result column avoid conflict task_count
// _.reject(ctrl.availableQueries[ctrl.filter.model].fields, {"type":"JSONField"}),
// subquery Exists by default

// <input required ng-pattern="'^[a-zA-Z0-9_]+$'" type="text" ng-model="$ctrl.subquery.name"/>

angular.module("mhclientApp").component("mhcareStats", {
  templateUrl: "stats/components/views/mhcare-stats.html",
  controller: ["AsyncFetchService", "MHCareStats", "$timeout", "$filter", "SiteVar", "Entity", "SiteVarsUtils", "StatsUtils", "$rootScope", "$window", "notify", "$q", function mhcareStatsCtrl(AsyncFetchService, MHCareStats, $timeout, $filter, SiteVar, Entity, SiteVarsUtils, StatsUtils, $rootScope, $window, notify, $q) {
    var ctrl = this;

    ctrl.search = ''
    ctrl.isAdmin = $rootScope.user.is_superuser
    ctrl.isExpert = false;
    ctrl.toggleExpert = function () {
      ctrl.isExpert = !ctrl.isExpert
      ctrl.result = null
    }
    ctrl.loading = true

    ctrl.groupedQueries = {}
    ctrl.sortQueriesByGroup = function () {
      console.log
      var queries = ctrl.queries || []
      if (!queries) return {}
      var groupedQueries = {}
      _.forEach(queries, function (query) {
        var group = query.group || 'Autres'
        groupedQueries[group] = groupedQueries[group] || []
        groupedQueries[group].push(query)
      })

      // Sort the keys (group names) alphabetically, but put "Autres" at the end
      var sortedGroups = Object.keys(groupedQueries).sort(function (a, b) {
        if (a === 'Autres') return 1;
        if (b === 'Autres') return -1;
        return a.localeCompare(b);
      });

      var sortedGroupedQueries = {};
      sortedGroups.forEach(function (group) {
        sortedGroupedQueries[group] = groupedQueries[group];
      });

      ctrl.groupedQueries = sortedGroupedQueries
    }

    ctrl.groupQueries = function (item) { return item.value.group };

    MHCareStats.extractModels().$promise.then(function (extractedModels) {
      ctrl.availableQueries = extractedModels
      _.forEach(Object.keys(StatsUtils.extraFields), function (key) {
        if (key in ctrl.availableQueries) { ctrl.availableQueries[key].fields = _.concat(ctrl.availableQueries[key].fields, StatsUtils.extraFields[key]) }
      })

    })

    ctrl.getQueries = function () {
      $rootScope.busy = true
      MHCareStats.getQueries().$promise.then(function (queries) {
        ctrl.queries = queries;
        ctrl.sortQueriesByGroup();
        $rootScope.busy = false
        ctrl.loading = false
      });
    }

    ctrl.getQueries()

    ctrl.variableChilds = []

    ctrl.getVariables = function (childs, parentLabel) {
      _.forEach(childs, function (child) {
        if (child.isVariable) {
          child.parentLabel = parentLabel
          ctrl.variableChilds.push(child)
        }
        if ((child.childs || []).length) ctrl.getVariables(child.childs, child.label)
      })
    }

    ctrl.selectSavedQuery = function (selectedSavedQuery, expertMode) {
      if (selectedSavedQuery.id == (ctrl.query || {}).id) {
        if (expertMode) return
        return ctrl.query = null
      }
      ctrl.query = null
      ctrl.variableChilds = []

      $timeout(function () { ctrl.query = _.cloneDeep(selectedSavedQuery); ctrl.getVariables(((ctrl.query || {}).filters || {}).childs) })
    }



    ctrl.newQuery = function (query) {
      ctrl.query = null
      $timeout(function () {
        ctrl.query = {
          model: query.key,
          model_label: query.value.label,
          label: query.value.label,
          filters: { label: $filter('translate')("Filters"), model: query.key, type: "node" },
          results: { label: $filter('translate')("Resultats"), model: query.key, type: "node" }
        }
      })
    }


    ctrl.save = function () {
      $rootScope.busy = true
      if (ctrl.query.id) {
        MHCareStats.patchQuery(_.assign({ queryId: ctrl.query.id }, ctrl.query)).$promise.finally(function () {
          $rootScope.busy = false
          ctrl.queryForm.$setPristine()
          ctrl.getQueries()
        })
      } else {
        MHCareStats.postQuery(ctrl.query).$promise.finally(function () {
          $rootScope.busy = false
          ctrl.queryForm.$setPristine()
          ctrl.getQueries()
        })
      }

    }

    ctrl.clone = function () {
      ctrl.selectSavedQuery(angular.copy(_.omit(ctrl.query, ["uid"])))
      ctrl.queryForm.$setDirty()
    }

    ctrl.saveQueries = function (queries) {
      ctrl.query = null;

      var promises = queries.map(function (query) {
        return MHCareStats.postQuery(query).$promise
          .then(function (response) {
            return { status: 'fulfilled', value: response };
          })
          .catch(function (error) {
            console.error('Could not import query: ', error)
            return { status: 'rejected', reason: error };
          });
      });

      $q.all(promises)
        .then(function (results) {
          var fulfilled = results.filter(function (r) { return r.status === 'fulfilled' }).length;
          var rejected = results.filter(function (r) { return r.status === 'rejected' }).length;

          notify({ message: (fulfilled) + " requêtes importées.", classes: ["alert-success"], duration: 2000 })
          if (rejected > 0) notify({ message: (rejected) + " requêtes rejetées. (voir console pour les détails)", classes: ["alert-warning"], duration: 2000 })
        })
        .finally(function () {
          ctrl.getQueries();
        });
    };

    ctrl.export = function (query) {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([JSON.stringify(query ? [query] : ctrl.queries)], { type: 'application/json' }));
      a.setAttribute('download', 'requests.json');
      a.click();
    }

    ctrl.import = function () {
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'application/json';

      input.onchange = function (event) {
        var file = event.target.files[0];
        var reader = new FileReader();

        reader.onload = function () {
          var queries = JSON.parse(reader.result);
          if (!Array.isArray(queries)) return
          ctrl.saveQueries(queries)
        };
        reader.readAsText(file);
      };
      input.click();
    }

    ctrl.delete = function () {
      $rootScope.busy = true
      MHCareStats.deleteQuery({ queryId: ctrl.query.id }).$promise.finally(function () {
        ctrl.query = null
        $rootScope.busy = false
        ctrl.getQueries()
      })
    }


    ctrl.runQuery = function (resultType) {
      $rootScope.busy = true
      if (resultType != 'csv') ctrl.result = null
      ctrl.resultType = resultType

      var queryPromise;
      if (ctrl.isAdmin) {
        queryPromise = MHCareStats.testQuery(_.assign({ resultType: resultType }, ctrl.query)).$promise;
      } else {
        queryPromise = MHCareStats.runQuery(_.assign({ resultType: resultType, queryId: ctrl.query.id }, ctrl.query)).$promise;
      }

      queryPromise.then(function (response) {
        AsyncFetchService.fetchFile(response.result, 500).then(function (response) {
          if (resultType == 'csv') {
            var a = document.createElement('a');
            a.href = URL.createObjectURL(new Blob([response], { type: 'text/csv' }));
            a.setAttribute('download', 'query_result.csv');
            a.click();
          }
          else { ctrl.result = response }
          $rootScope.busy = false
        })
      })
    }

  }],
  bindings: {},
});

angular.module("mhclientApp").component("statsOperatorSelector", {
  templateUrl: "stats/components/views/stats-operator-selector.html",
  bindings: { node: "<", queryForm: "=", choices: "<", availableQueries: "<", callback: '&', mode: "@" },
  controller: ["$timeout", "StatsUtils", function operatorSelectorCtrl($timeout, StatsUtils) {
    var ctrl = this;



    // pas nester le subqueries

    ctrl.availableOperators = []
    var genOperators = function (keys) {
      ctrl.availableOperators = _.concat(ctrl.availableOperators, _.map(keys, function (key) { return _.assign({ operator_key: key }, StatsUtils.baseOperators[key]) }))
    }
    if (ctrl.mode == "filters") {
      if (["node", "subquery", "ManyToOneRel", "ForeignKey", "OneToOneRel", "OneToOneField", "ManyToManyRel", "ManyToManyField"].includes(ctrl.node.type)) {
        genOperators(["and", "or"])
        if ((ctrl.node.model || ctrl.node.fk) && ctrl.node.nullable) { genOperators(["exists", "not exists"]) }
      }

      if (ctrl.choices.length > 0) { genOperators(["in", "not in"]) }

      if (["CharField", "EmailField", "TextField"].includes(ctrl.node.type)) {
        if (ctrl.choices.length == 0) { ctrl.availableOperators = _.concat(ctrl.availableOperators, StatsUtils.stringOperators) }
        if (ctrl.node.nullable) { genOperators(["isnull", "notnull"]) }
      }
      if (["DateField", "DateTimeField"].includes(ctrl.node.type)) {
        if (ctrl.choices.length == 0) { ctrl.availableOperators = _.concat(ctrl.availableOperators, StatsUtils.dateOperators) }
        if (ctrl.node.nullable) { genOperators(["isnull", "notnull"]) }
      }

      if (["IntegerField", "AutoField", "FloatField", "DecimalField"].includes(ctrl.node.type)) {
        if (ctrl.choices.length == 0) { ctrl.availableOperators = _.concat(ctrl.availableOperators, StatsUtils.numberOperators) }
        if (ctrl.node.nullable) { genOperators(["isnull", "notnull"]) }
      }
      if (["BooleanField"].includes(ctrl.node.type)) {
        genOperators(["true", "false"])
        if (ctrl.node.nullable) { genOperators(["isnull", "notnull"]) }
      }
    }

    else {
      if (["node", "ForeignKey", "OneToOneRel", "OneToOneField"].includes(ctrl.node.type)) {
        genOperators(["results"])
      }
      if (["subquery"].includes(ctrl.node.type)) {
        genOperators(["and", "or"])
      }
    }

    ctrl.change = function (newOperator) {
      _.assign(ctrl.node, newOperator)
      if (ctrl.queryForm) { ctrl.queryForm.$setDirty() }
    }

    if (!ctrl.node.operator_key) { ctrl.change(ctrl.availableOperators[0]) }

  }],

});

angular.module("mhclientApp").component("statsFilter", {
  templateUrl: "stats/components/views/stats-filter.html",
  bindings: { node: '<', queryForm: '<', availableQueries: '<', mode: '@' },
  controller: ["$rootScope", "$q", "StatsUtils", "$scope", "$timeout", function statsFilterCtrl($rootScope, $q, StatsUtils, $scope, $timeout) {
    var ctrl = this;
    ctrl.selecCondition = function (condition) { ctrl.node.childs.push(JSON.parse(angular.toJson(condition))) }
    ctrl.node.childs = ctrl.node.childs || []
    ctrl.availableConditions = []
    ctrl.availableSubqueries = []
    ctrl.customName = ''
    ctrl.selectedChildInDialog = null
    if (ctrl.node.fk in StatsUtils.availableFkChoices) { $q.when(StatsUtils.availableFkChoices[ctrl.node.fk]()).then(function (choices) { ctrl.choices = choices; ctrl.ready = true }) }
    else if (["ManyToManyRel", "ManyToManyField"].includes(ctrl.node.type) && ctrl.node.model in StatsUtils.availableFkChoices) { $q.when(StatsUtils.availableFkChoices[ctrl.node.model]()).then(function (choices) { ctrl.choices = choices; ctrl.ready = true }) }
    else if ((ctrl.node.base_model + "_" + ctrl.node.field) in StatsUtils.availableExtraChoices) { $q.when(StatsUtils.availableExtraChoices[ctrl.node.base_model + "_" + ctrl.node.field]()).then(function (choices) { ctrl.choices = choices; ctrl.ready = true }) }
    else { ctrl.choices = _.map(ctrl.node.choices, function (choice) { return { "value": choice[0], "label": choice[1] } }); ctrl.ready = true }

    var extractSubQueries = function (parentField, alreadyVisitedModel, index, prefix, previousOutRef) {
      _.forEach(ctrl.availableQueries[parentField.model].fields, function (insideField) {
        if (insideField.model in ctrl.availableQueries && ["ManyToOneRel", "ManyToManyRel"].includes(insideField.type)) {
          var newPrefix = [prefix, insideField.field].join("__")
          var newOutRef = [insideField.outer_ref, previousOutRef].join("__")
          ctrl.availableSubqueries.push({
            model: insideField.model,
            outer_ref: newOutRef,
            nullable: insideField.nullable,
            field: parentField.field + "__" + insideField.field,
            type: "subquery",
            label: newPrefix + " (subquery " + index + ")",
            order: index
          })
          if (!alreadyVisitedModel.includes(insideField.model)) {
            extractSubQueries(insideField, _.concat(alreadyVisitedModel, insideField.model || insideField.fk), index + 1, newPrefix, newOutRef)
          }
        }
      })
    }

    ctrl.openDialog = function(child){
      ctrl.selectedChildInDialog = child
      var dialog = document.querySelector("dialog");
      dialog.showModal();
    }

    ctrl.rename = function(){
      ctrl.selectedChildInDialog.label = ctrl.customName
      ctrl.closeDialog()
    }

    ctrl.closeDialog = function(){
      var dialog = document.querySelector("dialog");
      dialog.close()
    }

    ctrl.toggleChildIsVariable = function (child) {
      child.isVariable = !child.isVariable
    }

    if (ctrl.node.model || ctrl.node.fk) {
      _.forEach(ctrl.availableQueries[ctrl.node.model || ctrl.node.fk].fields, function (field) {
        if (field.only_for_filter && ctrl.mode == "results") { return }
        if (!["BooleanField", "CharField", "EmailField", "TextField", "DateField", "DateTimeField", "IntegerField", "AutoField", "FloatField", "DecimalField", "ManyToOneRel", "ForeignKey", "OneToOneField", "ManyToManyRel", "ManyToManyField", "OneToOneRel"].includes(field.type)) { return }
        if (field.fk && !(field.fk in ctrl.availableQueries)) { return }
        if (field.model && !(field.model in ctrl.availableQueries)) { return }
        if (["ManyToOneRel", "ManyToManyRel", "ManyToManyField"].includes(field.type)) {
          if (field.outer_ref) {
            ctrl.availableSubqueries.push(_.assign(_.pick(field, ["model", "outer_ref", "nullable", "field"]), { type: "subquery", label: field.label + " (subquery)", order: 0 }))
            extractSubQueries(field, [field.model || field.fk], 1, field.field, field.outer_ref)
          }
          if (ctrl.mode == "results" && ctrl.node.type != 'subquery') { return }
        }
        ctrl.availableConditions.push(_.assign(field, { base_model: ctrl.node.model }))
      })
    }

    ctrl.availableIntegerConditions = [
      { "label": ">=", value: "gte" },
      { "label": ">", value: "gt" },
      { "label": "<", value: "lt" },
      { "label": "<=", value: "lte" },
      { "label": "=", value: "=" },
      { "label": "[ , ]", value: "interval" },
    ]

    ctrl.availableFunctions = {
      "Exists": { "needColumn": false },
      "Count": { "needColumn": false },
      "Sum": { "needColumn": true },
    }

    if (!(ctrl.node.type == 'subquery' && ctrl.mode == 'results')) {
      ctrl.availableFunctions["Not Exists"] = { "needColumn": false }
      ctrl.availableFunctions.Count.integerConditions = true
      ctrl.availableFunctions.Sum.integerConditions = true
    }

  }],
});

angular.module('mhclientApp').filter('filterNumberField', function () {
  return function (fields) {
    return _.filter(fields, function (field) { return ["IntegerField", "FloatField", "DecimalField", "AutoField"].includes(field.type) })
  };

});


angular.module("mhclientApp").component("operatorSelector", {
  templateUrl: "stats/components/views/operator-selector.html",
  controller: ["$timeout", function operatorSelectorCtrl($timeout) {
    var ctrl = this;
    ctrl.availableOperators = ctrl.availableOperators || ["==", "!="]
    if (!ctrl.operator) {
      ctrl.operator = ctrl.availableOperators.length > 0 ? ctrl.availableOperators[0] : null
      if (ctrl.callback) { ctrl.callback({ operator: ctrl.operator }) }
    }
    ctrl.change = function (newOperator) {
      if (ctrl.operator != newOperator) {
        ctrl.operator = newOperator
        if (ctrl.queryForm) { ctrl.queryForm.$setDirty() }
        if (ctrl.callback) { ctrl.callback({ operator: ctrl.operator }) }
      }
    }
  }],
  bindings: { operator: "=", availableOperators: "<", queryForm: "=", callback: '&' },
});

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.service:
* @description
* Pharmaceutical analysis stuff
* ********************************************** */

angular.module("mhclientApp").factory('StatsUtils', ["Entity", "FeatureUtils", "Sector", "PrescUtils", "MedicalUnit", "SiteVarsUtils", "FormTemplateUtils", "GroupUtils", function(Entity, FeatureUtils, Sector, PrescUtils, MedicalUnit, SiteVarsUtils, FormTemplateUtils, GroupUtils) {

  var availableFkChoices = {
    "usr_mgr_feature": function() { return FeatureUtils.getAllFeatures().then( function(features) {return _.map(features, function(feature) {return {label: feature.description, value:feature.id}})})},
    "pat_mgr_sector" : function (){return Sector.getSectors().then (function(sectors){return _.map(sectors, function(sector){return {label: sector.name, value: sector.id}})})},
    "pat_mgr_medicalunit" : function () {return MedicalUnit.getMedicalUnits().then (function(medicalUnits){return _.map(medicalUnits, function(medicalUnit){return {label: medicalUnit.name, value: medicalUnit.id}})})},
    "careplan_mgr_presccategory" : function (){return PrescUtils.getCategories().promise.then (function(categories){return _.map(categories, function(category){return {label: category.label, value: category.id}})})},
    "medicalform_formtemplate" : function () { return FormTemplateUtils.getTemplates().then (function(formTemplates) { return _.map(formTemplates, function(template){ return {label: template.uid, value: template.id}})})},
    "custom_user_group" : function() { return GroupUtils.getAllGroups().then( function(groups) {return _.map(groups, function(group) {return {label: group.name, value:group.id}})})},
  }

  var availableExtraChoices = {
    "pat_mgr_stay_MODE_PEC_PRIMARY" : function () { return SiteVarsUtils.getValue("PAC_DATA_STRUCT").then( function(pacDataStruct) {return _.map(_.find(_.find(pacDataStruct, {ID: "MEDICAL_DATA"}).FIELDS, {ID:"MODE_PEC_PRIMARY"}).DATA, function(MP){return {label: MP, value: MP}})})},
    "pat_mgr_stay_MODE_PEC_LINKED" : function () { return SiteVarsUtils.getValue("PAC_DATA_STRUCT").then( function(pacDataStruct) {return _.map(_.find(_.find(pacDataStruct, {ID: "MEDICAL_DATA"}).FIELDS, {ID:"MODE_PEC_LINKED"}).DATA, function(MP){return {label: MP, value: MP}})})},
    "external_externalsync_sync_type": function() { return SiteVarsUtils.getValue("availableExternalSyncs", []).then( function(availableExternalSyncs) {return _.map(availableExternalSyncs, function(externalSync) {return {label: externalSync.label, value:externalSync.sync_type}})})},
    "careplan_mgr_presctask_state": function() { return [{label: "planned", value: "NEW"}, {label: "NOT_REALIZED_TASKS", value: "NOK"}, {label: "REALIZED_TASKS", value: "OK"}, {label: "Préparé", value: "prepared"}]},
  }

    var stringOperators = [
      {operator: "string", operator_key: "=", operator_check: "", operator_value: "", operator_label: "="},
      {operator: "string", operator_key: "contains", operator_check: "__contains", operator_value: "", operator_label: "CONTAINS"},
      {operator: "string", operator_key: "icontains", operator_check: "__icontains", operator_value: "", operator_label: "ICONTAINS"},
      {operator: "string", operator_key: "startswith", operator_check: "__startswith", operator_value: "", operator_label: "STARTS_WITH"},
      {operator: "string", operator_key: "endswith", operator_check: "__endswith", operator_value: "", operator_label: "ENDS_WITH"},
      {operator: "string", operator_key: "!=", operator_check: "", operator_value: "~", operator_label: "!="},
      {operator: "string", operator_key: "!contains", operator_check: "__contains", operator_value: "~", operator_label: "NOT_CONTAINS"},
      {operator: "string", operator_key: "!icontains", operator_check: "__icontains", operator_value: "~", operator_label: "NOT_ICONTAINS"},
      {operator: "string", operator_key: "!startswith", operator_check: "__startswith", operator_value: "~", operator_label: "NOT_STARTS_WITH"},
      {operator: "string", operator_key: "!endswith", operator_check: "__endswith", operator_value: "~", operator_label: "NOT_ENDS_WITH"},
    ]

    var numberOperators = [
      {operator: "number", operator_key: "=", operator_check: "", operator_range: false, operator_value: "", operator_label: "="},
      {operator: "number", operator_key: ">=", operator_check: "__gte", operator_range: false, operator_value: "", operator_label: ">="},
      {operator: "number", operator_key: ">", operator_check: "__gt", operator_range: false, operator_value: "", operator_label: ">"},
      {operator: "number", operator_key: "<", operator_check: "__lt", operator_range: false, operator_value: "", operator_label: "<"},
      {operator: "number", operator_key: "<=", operator_check: "__lte", operator_range: false, operator_value: "", operator_label: "<="},
      {operator: "number", operator_key: "range", operator_check: "__range", operator_range: true, operator_value: "", operator_label: "IN_RANGE"},
      {operator: "number", operator_key: "not_range", operator_check: "__range", operator_type: "date", operator_value: "~", operator_range: true, operator_label: "NOT_IN_RANGE"},
    ]
    // ctrl.availableIntegerConditions = [
      // {"label": ">=", value: "gte"},
      // {"label": ">", value: "gt"},
      // {"label": "<", value: "lt"},
      // {"label": "<=", value: "lte"},
      // {"label": "=", value: "="},
      // {"label": "[ , ]", value:"interval"},
    // ]


    var dateOperators = [
      {operator: "date", operator_key: "=", operator_check: "", operator_type: "date", operator_range: false, operator_value: "", operator_label: "="},
      {operator: "date", operator_key: ">=", operator_check: "__gte", operator_type: "date", operator_range: false, operator_value: "", operator_label: ">="},
      {operator: "date", operator_key: ">", operator_check: "__gt", operator_type: "date", operator_range: false, operator_value: "", operator_label: ">"},
      {operator: "date", operator_key: "<", operator_check: "__lt", operator_type: "date", operator_range: false, operator_value: "", operator_label: "<"},
      {operator: "date", operator_key: "<=", operator_check: "__lte", operator_type: "date", operator_range: false, operator_value: "", operator_label: "<="},
      {operator: "date", operator_key: "range", operator_check: "__range", operator_type: "date", date_min: null, date_max: null, operator_range: true, operator_value: "", operator_label: "IN_RANGE"},
      {operator: "date", operator_key: "not_range", operator_check: "__range", operator_type: "date", date_min: null, date_max: null, operator_value: "~", operator_range: true, operator_label: "NOT_IN_RANGE"},

      {operator: "date", operator_key: "year_=", operator_check: "", operator_type: "year", operator_range: false, operator_value: "", operator_label: "YEAR_EQUAL", extra: {"function": "ExtractYear"}},
      {operator: "date", operator_key: "year_>=", operator_check: "__gte", operator_type: "year", operator_range: false, operator_value: "", operator_label: "YEAR_GREATER_OR_EQUAL", extra: {"function": "ExtractYear"}},
      {operator: "date", operator_key: "year_>", operator_check: "__gt", operator_type: "year", operator_range: false, operator_value: "", operator_label: "YEAR_GREATER", extra: {"function": "ExtractYear"}},
      {operator: "date", operator_key: "year_<", operator_check: "__lt", operator_type: "year", operator_range: false, operator_value: "", operator_label: "YEAR_LOWER", extra: {"function": "ExtractYear"}},
      {operator: "date", operator_key: "year_<=", operator_check: "__lte", operator_type: "year", operator_range: false, operator_value: "", operator_label: "YEAR_LOWER_OR_EQUAL", extra: {"function": "ExtractYear"}},
      {operator: "date", operator_key: "year_range", operator_check: "__range", operator_type: "year", date_min: 1900, date_max: 2050, operator_value: "", operator_range: true, operator_label: "YEAR_IN_RANGE", extra: {"function": "ExtractYear"}},
      {operator: "date", operator_key: "year_not_range", operator_check: "__range", operator_type: "year", date_min: 1900, date_max: 2050, operator_value: "~", operator_range: true, operator_label: "YEAR_NOT_IN_RANGE", extra: {"function": "ExtractYear"}},

    ]

    var baseOperators = {
      "and": {operator: "AND", operator_label: "AND"},
      "results": {operator: "RESULT", operator_label: ""},
      "or": {operator: "OR",  operator_label: "OR"},
      "in": {operator: "__in", operator_value: "", operator_label: "IN"},
      "not in": {operator: "__in", operator_value: "~", operator_label: "NOT_IN"},
      "exists": {operator: "__isnull", operator_value: false, operator_label: "EXIST"},
      "not exists": {operator: "__isnull", operator_value: true, operator_label: "NOT_EXIST"},
      "isnull": {operator: "__isnull", operator_value: true, operator_label: "NULL"},
      "notnull": {operator: "__isnull", operator_value: false, operator_label: "NOT_NULL"},
      "true": {operator: "check", operator_value: true, operator_label: "TRUE"},
      "false": {operator: "check", operator_value: false, operator_label: "FALSE"},
    }

  var extraFields = {
       "external_externalsync": [
          {field:"category", label:"category", type: "CharField", annotate: {base:"config", field: ["category"]}},

        ],
       "site_mgr_entity": _.map(Entity.entityFields, function(entityField) {return {type:"CharField", "field": entityField.key, "label": entityField.key, annotate: {base:"sitevars", field: [entityField.key]}}}),
       "pat_mgr_patient": [
          {field: "ins", label: "ins", nullable: true, type:"CharField", annotate: {base:"data", field: ["ins"]}},
        ],
        "pat_mgr_stay": [
          {field: "MODE_PEC_PRIMARY", label: "mpp", nullable: true, type: "CharField", annotate: {base:"medical_data", field: ["MODE_PEC_PRIMARY"]}},
          {field: "MODE_PEC_LINKED", label: "mpa", nullable: true, type: "CharField", annotate: {base:"medical_data", field: ["MODE_PEC_LINKED"]}},
          {field: "stay_duration", label: "stay duration", nullable: true, type: "IntegerField", extra: {"function": "DateDiff", "field": "d_to", "field_extra": "d_from"}},
          {field: "pread_duration", label: "pread duration", nullable: true, type: "IntegerField", extra: {"function": "DateDiff", "field": "d_from", "field_extra": "created"}},
          {custom_filter: "stay_state", only_for_filter: true, label: "state (relative)", type: "CharField", choices: [["PRE", "Préadmission"], ["ADM","Admission"], ["CLOSE", "Fermé"]]},
        ],
        "careplan_mgr_presctask": [
          {type:"FloatField", label: 'quantity', field: "quantity", nullable: true, annotate: {base:"data", field: ["quantity"]}},
          {type:"CharField", label: 'taking_unit', field: "taking_unit_label", nullable: true, annotate: {base:"data", field: ["taking_unit_label"]}},
        ],
        "taskplanner_sequence": [
          {type:"CharField", label: 'name', field: "name", nullable: true, annotate: {base:"data", field: ["name"]}},
          {type:"CharField", label: 'comment', field: "comment", nullable: true, annotate: {base:"data", field: ["comment"]}},
          {type:"CharField", label: 'last author name', field: "last_author_name", nullable: true, annotate: {base:"data", field: ["user_full_name"]}},
          {type:"CharField", label: 'last author username', field: "last_author_username", nullable: true, annotate: {base:"data", field: ["username"]}},
          {type:"CharField", label: 'state', field: "state", nullable: true, annotate: {base:"data", field: ["state"]}},
          {type:"CharField", label: 'planification type', field: "planification_type", nullable: true, annotate: {base:"planning_data", field: ["type"]}},
          {type:"CharField", label: 'display text', field: "display_text", nullable: true, annotate: {base:"planning_data", field: ["display_text"]}},
        ],
        "taskplanner_activity": [
          {type:"CharField", label: 'label', field: "label", nullable: true, annotate: {base:"data", field: ["label"]}},
          {type:"CharField", label: 'comment', field: "comment", nullable: true, annotate: {base:"data", field: ["comment"]}},
          {type:"CharField", label: 'last author name', field: "last_author_name", nullable: true, annotate: {base:"data", field: ["user_full_name"]}},
          {type:"CharField", label: 'last author username', field: "last_author_username", nullable: true, annotate: {base:"data", field: ["username"]}},
          {type:"CharField", label: 'state', field: "state", nullable: true, annotate: {base:"data", field: ["state"]}},
          {type:"CharField", label: 'planification type', field: "planification_type", nullable: true, annotate: {base:"planning_data", field: ["type"]}},
          {type:"CharField", label: 'display text', field: "display_text", nullable: true, annotate: {base:"planning_data", field: ["display_text"]}},
          {type:"BooleanField", label: 'has liberal', field: "has_liberal", nullable: true, annotate: {base:"planning_data", field: ["has_liberal"]}},
        ],
        "taskplanner_task": [
          {type:"IntegerField", label: 'Total time (RDV + trajet)', field: "total_time_minuts", nullable: true, extra: {"function": "TimeDiff", "field": "end_time", "field_extra": "start_time"}, annotate_many: [{base:"data", field: "start_time", type: "TimeField", path: ["start_time"]}, {base:"data", type: "TimeField", field: "end_time", path: ["end_time"]}]},
          {type:"CharField", label: 'start time', field: "start_time", nullable: true, annotate: {base:"data", field: ["start_time"]}},
          {type:"CharField", label: 'end time', field: "end_time", nullable: true, annotate: {base:"data", field: ["end_time"]}},
          {type:"IntegerField", label: 'Execution time', field: "execution_time", nullable: true, annotate: {base:"data", field: ["duration"]}},
        ],
        "careplan_mgr_prescription": [
          {type:"CharField", label: 'is_stupefiant', field: "is_stupefiant", choices: [["0", "False"], ["1", "True"]], annotate: {base:"data", field: ["bdm_data", "is_stupefiant"]}},
          {type:"CharField", label: 'product_name', field: "product_name", annotate: {base:"data", field: ["bdm_data", "name"]}},
          {type:"BooleanField", label: 'is_high_cost', field: "high_cost", annotate: {base:"data", field: ["bdm_data", "high_cost"]}},
          {type:"BooleanField", label: 'is_high_risk', field: "is_high_risk", annotate: {base:"data", field: ["bdm_data", "is_high_risk"]}},
          {type:"CharField", label: 'catalog_ext_id', field: "catalog_ext_id", annotate: {base:"data", field: ["bdm_data", "catalog_ext_id"]}},
          {type:"CharField", label: 'atc',  field: "atc", annotate: {base:"data", field: ["bdm_data", "atc"]}},
          {type:"CharField", label: 'ucd', field: "ucd", annotate: {base:"data", field: ["bdm_data", "ucd"]}},
          {type:"CharField", label: 'cip', field: "cip", annotate: {base:"data", field: ["bdm_data", "cip"]}},
          {type:"CharField", label: 'resumption', field: "resumption", choices: [["RENEW_MODIFY", "RENEW_MODIFY"], ["INITIAL", "INITIAL"], ["RENEW", "RENEW"]], annotate: {base:"data", field: ["resumption"]}},
        ],
        "usr_mgr_userprofile": [
          {type:"CharField", label: 'address', field: "address", nullable: true, annotate: {base:"data", field: ["address_data", "address"]}},
          {type:"CharField", label: 'zip_code', field: "zip_code", nullable: true, annotate: {base:"data", field: ["address_data", "zip_code"]}},
          {type:"CharField", label: 'town', field: "town", nullable: true, annotate: {base:"data", field: ["address_data", "town"]}},
          {type:"CharField", label: 'country', field: "country", nullable: true, annotate: {base:"data", field: ["address_data", "country"]}},
          {type:"CharField", label: 'siret', field: "siret", nullable: true, annotate: {base:"data", field: ["siret"]}},
          {type:"CharField", label: 'num fournisseur', field: "nfour", nullable: true, extra: {function: "Concat", values: [{value: "HD"}, {field: "siret"}]}},
          {type:"CharField", label: 'IBAN', field: "IBAN", nullable: true, annotate: {base:"data", field: ["rib"]}},
          {type:"DateTimeField", label: 'IBAN last modification', nullable: true, field: "rib_modification_date", annotate: {base:"data", field: ["rib_modification_date"]}},
        ],
        "custom_user_user": [
          {type:"CharField", label: 'full name', field: "full_name", extra: {function: "Concat", values: [{field: "first_name"}, {value: " "}, {field: "last_name"}]}},
        ]

    }

  return {
   availableFkChoices: availableFkChoices,
   extraFields: extraFields,
   availableExtraChoices: availableExtraChoices,
   baseOperators: baseOperators,
   stringOperators: stringOperators,
   dateOperators: dateOperators,
   numberOperators: numberOperators,

  }
}]);

(function() {
  angular.module('mhclientApp').controller('BillingConfigCategoryCtrl', ["$q", "$scope", "$rootScope", "$uibModal", "BillingUnitCategory", "BillingUnit", "GroupUtils", function($q, $scope, $rootScope, $uibModal, BillingUnitCategory, BillingUnit, GroupUtils) {
    var init;
    $scope.showObsolete = false;
    $scope.availableGroups = [];
    $scope.billingUnitCategories = [];
    $scope.openAddModal = function() {
      var modalInstance;
      if ($scope.availableGroups.length > 0) {
        modalInstance = $uibModal.open({
          templateUrl: 'billing/views/billing-category-creation-modal.html',
          controller: 'BillingConfigCategoryModalCtrl',
          controllerAs: '$ctrl',
          resolve: {
            availableGroups: function() {
              return $scope.availableGroups;
            }
          }
        });
        return modalInstance.result.then(function(newCategory) {
          $rootScope.busy = true;
          return BillingUnitCategory.save(newCategory).$promise.then(function(newCat) {
            var majorations;
            majorations = _.map(newCategory.selectedMajorations, function(maj) {
              maj.category = newCat.id;
              return maj;
            });
            return $q.all(_.map(majorations, function(maj) {
              return BillingUnit.save(maj).$promise;
            })).then(function() {
              init();
              return $rootScope.busy = false;
            });
          });
        }, function(error) {
          return {};
        });
      }
    };
    $scope.save = function(category) {
      var data;
      if (category.code === "CARE") {
        data = _.pick(category, ["id", "name"]);
      } else {
        data = _.pick(category, ["id", "name", "obsolete"]);
      }
      return BillingUnitCategory.update(data).$promise.then(function(newCat) {
        category.name = newCat.name;
        category.obsolete = newCat.obsolete;
        return category.isEditing = false;
      });
    };
    init = function() {
      return GroupUtils.getAllGroups().then(function(groups) {
        return BillingUnitCategory.query().$promise.then(function(categories) {
          var groupById, usedGroups;
          $scope.billingUnitCategories = categories;
          groupById = _.keyBy(groups, 'id');
          usedGroups = _.map(categories, 'group');
          _.forEach($scope.billingUnitCategories, function(category) {
            category.groupName = category.group ? groupById[category.group].name : "";
            category.isEditing = false;
            return {};
          });
          return $scope.availableGroups = _.filter(groups, function(group) {
            return group.liberal && !usedGroups.includes(group.id);
          });
        });
      });
    };
    return init();
  }]);

  angular.module('mhclientApp').controller('BillingConfigCategoryModalCtrl', ["$scope", "$uibModalInstance", "$filter", "availableGroups", "SiteVarsUtils", function($scope, $uibModalInstance, $filter, availableGroups, SiteVarsUtils) {
    var default_majorations;
    $scope.availableGroups = availableGroups;
    $scope.selectedMajorations = [];
    $scope.availableMajorations = [];
    $scope.newCategory = {
      name: '',
      group: null,
      code: '_MAJ',
      obsolete: false
    };
    $scope.updateName = function() {
      var group;
      if ($scope.newCategory.group) {
        group = _.find($scope.availableGroups, {
          id: $scope.newCategory.group
        });
        return $scope.newCategory.name = $filter('translate')('CATEGORY_AUTO_NAME', {
          groupName: group.name
        });
      }
    };
    default_majorations = [
      {
        "migration_name": "IFD",
        "short_name": "IFD",
        "full_name": "Indemnité Forfaitaire de déplacement",
        "data": {
          "display_scope": "global",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "IFD"
        }
      }, {
        "migration_name": "IFO",
        "short_name": "IFO",
        "full_name": "Indemnité Forfaitaire Orthopédique et rhumatologique",
        "data": {
          "display_scope": "global",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "IFO"
        }
      }, {
        "migration_name": "IFR",
        "short_name": "IFR",
        "full_name": "Indemnité Forfaitaire Rhumatismale",
        "data": {
          "display_scope": "global",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "IFR"
        }
      }, {
        "migration_name": "IFN",
        "short_name": "IFN",
        "full_name": "Indemnité Forfaitaire de Neurologie",
        "data": {
          "display_scope": "global",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "IFN"
        }
      }, {
        "migration_name": "IFP",
        "short_name": "IFP",
        "full_name": "Indemnité Forfaitaire de Pneumologie",
        "data": {
          "display_scope": "global",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "IFP"
        }
      }, {
        "migration_name": "IFS",
        "short_name": "IFS",
        "full_name": "Indemnité Forfaitaire de sortie",
        "data": {
          "display_scope": "global",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "IFS"
        }
      }, {
        "migration_name": "IK_PLAINE",
        "short_name": "IK plaine",
        "full_name": "IK plaine",
        "data": {
          "display_scope": "global",
          "custom_quantity": true,
          "quantity_unit": "km",
          "export_name": "IK_PLAINE"
        }
      }, {
        "migration_name": "IK_MONTAGNE",
        "short_name": "IK Montagne",
        "full_name": "IK Montagne",
        "data": {
          "display_scope": "global",
          "custom_quantity": true,
          "quantity_unit": "km",
          "export_name": "IK_MONTAGNE"
        }
      }, {
        "migration_name": "night_increase",
        "short_name": "Majoration nuit",
        "full_name": "Majoration nuit",
        "data": {
          "display_scope": "sequence",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "night_increase"
        }
      }, {
        "migration_name": "night_increase_more",
        "short_name": "Majoration nuit de 23H à 05H",
        "full_name": "Majoration nuit de 23H à 05H",
        "data": {
          "display_scope": "sequence",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "night_increase_more"
        }
      }, {
        "migration_name": "sunday_increase",
        "short_name": "Majoration Dimanche",
        "full_name": "Majoration Dimanche",
        "data": {
          "display_scope": "sequence",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "sunday_increase"
        },
        "rule": "H"
      }, {
        "migration_name": "sunday_increase_global",
        "short_name": "Majoration dimanche et JF",
        "full_name": "Majoration dimanche et JF",
        "data": {
          "display_scope": "global",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "sunday_increase_global"
        },
        "rule": "H"
      }, {
        "migration_name": "MAU",
        "short_name": "MAU",
        "full_name": "Majoration Acte Unique",
        "data": {
          "display_scope": "global",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "MAU"
        }
      }, {
        "migration_name": "MIE",
        "short_name": "MIE",
        "full_name": "Majoration enfant de moins de 7 ans",
        "data": {
          "display_scope": "global",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "MIE"
        }
      }, {
        "migration_name": "MCI",
        "short_name": "MCI",
        "full_name": "Majoration Coordination Infirmière",
        "data": {
          "display_scope": "sequence",
          "custom_quantity": false,
          "quantity_unit": null,
          "export_name": "MCI"
        }
      }
    ];
    SiteVarsUtils.get("BILLING_DEFAULT_MAJORATIONS", default_majorations).then(function(majorations) {
      return $scope.availableMajorations = majorations.value;
    });
    $scope.save = function() {
      $scope.newCategory.selectedMajorations = $scope.selectedMajorations;
      return $uibModalInstance.close($scope.newCategory);
    };
    return $scope.dismiss = function() {
      return $uibModalInstance.dismiss('cancel');
    };
  }]);

}).call(this);

//# sourceMappingURL=billing-config-category-controller.js.map

'use strict';

angular.module("mhclientApp").component("billingConfig", {
  templateUrl: "billing/views/billing-config.html",
  bindings: {dirty: "<"},
  controller: ["$rootScope", "$scope", "$q", "$uibModal", "BillingUnit", "BillingUnitCategory", "BillingUnitValue", "GroupUtils", "BillingUnitUtils", function BillingConfigCtrl($rootScope, $scope, $q, $uibModal, BillingUnit, BillingUnitCategory, BillingUnitValue, GroupUtils, BillingUnitUtils) {
    var ctrl = this;

    var reloadValues = function(buUnit) {
        BillingUnitValue.query({bu: buUnit.id}).$promise.then(function (buValues) {buUnit.values = buValues})
        BillingUnit.get({id: buUnit.id}).$promise.then(function (bu) {buUnit.current_value = bu.current_value})
    }

    var init = function() {
      $rootScope.busy = true
      ctrl.buData = [];
      $q.all([
        BillingUnitCategory.query().$promise,
        BillingUnit.query().$promise,
        BillingUnitValue.query().$promise,
        GroupUtils.getGroups()
      ]).then(function (results) {
        // # group-filter="orderCategoriesBy" group-by="groupCategoriesByType"
        ctrl.billingUnitCategories = results[0]
        var buUnits = results[1]
        var buValues = results[2]
        var valByBu = _.groupBy(buValues, 'bu_unit')
        _.forEach(buUnits, function(bu) {
          bu.values = valByBu[bu.id]
        })
        ctrl.billingUnitsByCategory = _.groupBy(buUnits, 'category')
        $rootScope.busy = false
      })
    }

    ctrl.editBillingUnit = function(category, billingUnit) {
        return $uibModal.open({
          animation  : true,
          component: 'billingUnitCreationModal',
          backdrop: 'static',
          windowClass: 'modal-fullscreen',
          resolve: { category: function(){return category}, billingUnit: function(){return _.cloneDeep(billingUnit || {category: category.id, rule: "A", data: {}})}}
        }).result.then(function (editedBillingUnit) {
          if (billingUnit){
            _.assign(billingUnit, editedBillingUnit)
          }
          else{
              ctrl.billingUnitsByCategory[category.id].push(editedBillingUnit)
          }
          BillingUnitUtils.resetCache()
        })
    }

    ctrl.addBillingUnitValue = function(buUnit) {
      var params = {}
      params.bu_unit = buUnit.id
      params.start_validity = moment(buUnit.new_start_validity).format('YYYY-MM-DD')
      params.value = buUnit.new_value
      BillingUnitValue.save(params).$promise.then(function (updatedBuValue) {
        buUnit.new_start_validity = null
        buUnit.new_value = null
        reloadValues(buUnit)
      })
    }

    ctrl.updateBillingUnitValue = function(buValue, buUnit) {
      var params = {}
      params.id = buValue.id
      params.bu_unit = buUnit.id
      params.value = buValue.value
      params.start_validity = moment(buValue.start_validity).format('YYYY-MM-DD')

      BillingUnitValue.update(params).$promise.then(function (updatedBuValue) {
        reloadValues(buUnit)
      })
    }

    ctrl.deleteBillingUnitValue = function(buValue, buUnit) {
      BillingUnitValue.delete({id: buValue.id}).$promise.then(function () {
        reloadValues(buUnit)
      })
    }

    init()

  }],
});

angular.module("mhclientApp").component("billingUnitCreationModal", {
  templateUrl: "billing/views/billing-unit-creation-modal.html",
  bindings: {resolve: '<', dismiss: '&', modalInstance: "<"},
  controller: ["$rootScope", "BillingUnit", "$filter", function billingUnitCreationModalCtrl($rootScope, BillingUnit, $filter){
    var ctrl = this;

    ctrl.ruleChoices = [
      {"value": "A", "label": $filter("translate")("BILLING_ALWAYS")},
      {"value": "H", "label": $filter("translate")("BILLING_HOLIDAYS")},
      // {"value": "U", "label": $filter("translate")("BILLING_UNIQUE")}, // Not yet implemented.
    ]

    ctrl.displayScopeChoices = [
      {"value": "sequence", "label": $filter("translate")("BILLING_SEQUENCE")},
      {"value": "global", "label": $filter("translate")("BILLING_GLOBAL")},

    ]
    ctrl.$onInit = function () {
      ctrl.category = ctrl.resolve.category
      ctrl.billingUnit = ctrl.resolve.billingUnit
    };

    ctrl.saveUnit = function (){
      ctrl.busy = true;
      BillingUnit[ctrl.billingUnit.id ? "update" : "save"](ctrl.billingUnit).$promise.then ( function(billingUnit){ctrl.busy = false; ctrl.modalInstance.close(billingUnit)})
    }
  }],
});

angular.module("mhclientApp").filter('momentAdd', function() {
    return function(date, amount, unit) {
      return moment(date).add(amount, unit).toDate();
    };
  });
"use strict";

angular
  .module("mhclientApp")
  .factory("BillingUnitValue", ["$resource", "MhConfig", function ($resource, MhConfig) {
    // Set API's version
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    var acceptHeaderV2 = MhConfig.baseAcceptHeader + ";version=v2";

    return $resource(
      "/api_rest/bu_value/:id/:route",
      {
        id: "@id",
      },
      {
        get: {
          headers: { Accept: acceptHeader },
          isArray: true,
        },
        query: {
          headers: { Accept: acceptHeader },
          isArray: true,
        },
        save: {
          headers: { Accept: acceptHeader },
          method: "POST",
        },
        update: {
          headers: { Accept: acceptHeader },
          method: "PUT",
          params: { name: "@id" },
        },
      }
    );
  }]);

angular
  .module("mhclientApp")
  .factory("BillingUnit", ["$resource", "MhConfig", function ($resource, MhConfig) {
    // Set API's version
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    var acceptHeaderV2 = MhConfig.baseAcceptHeader + ";version=v2";

    return $resource(
      "/api_rest/bu/:id/:route",
      {
        id: "@id",
        extra: "@extra",
      },
      {
        get: {
          headers: { Accept: acceptHeader },
        },
        query: {
          headers: { Accept: acceptHeader },
          isArray: true,
        },
        save: {
          headers: { Accept: acceptHeader },
          method: "POST",
        },
        update: {
          headers: { Accept: acceptHeader },
          method: "PUT",
          params: { id: "@id" },
        },
      }
    );
  }]);

angular
  .module("mhclientApp")
  .factory("BillingUnitCategory", ["$resource", "MhConfig", function ($resource, MhConfig) {
    // Set API's version
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    var acceptHeaderV2 = MhConfig.baseAcceptHeader + ";version=v2";

    return $resource(
      "/api_rest/bu_cat/:id/:route",
      {
        id: "@id",
        extra: "@extra",
      },
      {
        get: {
          headers: { Accept: acceptHeader },
        },
        query: {
          headers: { Accept: acceptHeader },
          isArray: true,
        },
        save: {
          headers: { Accept: acceptHeader },
          method: "POST",
        },
        update: {
          headers: { Accept: acceptHeader },
          method: "PATCH",
        },
      }
    );
  }]);

angular
  .module("mhclientApp")
  .controller(
    "BillingUserSelectionCtrl",
    ["$scope", "$uibModalInstance", "BillingService", function ($scope, $uibModalInstance, BillingService) {
      var ctrl = this;
      ctrl.loading = false;
      ctrl.selectedUsers = [];
      ctrl.selectedUser = null;
      ctrl.selectedUserBillable = null;
      ctrl.selectedUserBillableReason = null;

      ctrl.selectUserCallback = function (user) {
        ctrl.loading = true;
        BillingService.userBillable({ user: user.id }).$promise.then(function (
          result
        ) {
          ctrl.selectedUserBillable = result["user_billable"];
          ctrl.selectedUserBillableReason = result["user_billable_reason"];
          ctrl.selectedUser = user;
          ctrl.loading = false;
        });
      };

      // Close the modal with a result
      ctrl.validate = function () {
        if (ctrl.loading) {
          return;
        }
        $uibModalInstance.close({
          user: ctrl.selectedUser.id,
          userBillable: ctrl.selectedUserBillable,
        });
      };

      // Dismiss the modal
      ctrl.dismiss = function () {
        $uibModalInstance.dismiss();
      };
    }]
  );

"use strict";

angular.module("mhclientApp").component("billing", {
  templateUrl: "billing/views/billing.html",
  controller: ["$filter", "$q", "$rootScope", "$uibModal", "UserUtils", "GroupUtils", "StayUtils", "PatientUtils", "BillingService", "Stay", "Patient", "BillingSequenceService", "BillingSectorService", "BillingActivityService", "BillingDateUtils", "BillingUnitUtils", "$timeout", function BillingCtrl(
    $filter,
    $q,
    $rootScope,
    $uibModal,
    UserUtils,
    GroupUtils,
    StayUtils,
    PatientUtils,
    BillingService,
    Stay,
    Patient,
    BillingSequenceService,
    BillingSectorService,
    BillingActivityService,
    BillingDateUtils,
    BillingUnitUtils,
    $timeout
  ) {
    var ctrl = this;

    ctrl.loading = true;
    $rootScope.session = $rootScope.session || {};
    $rootScope.session.filters = $rootScope.session.filters || {};
    $rootScope.session.filters["BILLING_FILTERS"] = $rootScope.session.filters[
      "BILLING_FILTERS"
    ] || { selectedSector: "0", selectedGroup: "0" };
    ctrl.savedFilters = $rootScope.session.filters["BILLING_FILTERS"];
    ctrl.savedFilters = { selectedSector: "0", selectedGroup: "0" };
    ctrl.selectedSector = ctrl.savedFilters.selectedSector;
    ctrl.selectedGroup = ctrl.savedFilters.selectedGroup;
    ctrl.today = moment().format("YYYY-MM-DD");

    var VIEWS = { PRE: "PRE", REAL: "REAL" };
    ctrl.currentView = ctrl.savedFilters.currentView || VIEWS.REAL;
    var globalDataFetched = false;
    var realAndPreFetched = false;

    setDefaultDateInterval();

    // We start fetching global data instantly, while user selects the dates interval
    fetchGlobalData();

    // Define columns here for cleaner html
    var preColumns = [
      {
        label: $filter("translate")("CT_FULL_NAME"),
        sectorKey: "",
        stayKey: "fullName",
        rowKey: "userFullName",
      },
      {
        label: $filter("translate")("GENDER"),
        sectorKey: "",
        stayKey: "gender",
        rowKey: "",
      },
      {
        label: $filter("translate")("DDN"),
        sectorKey: "",
        stayKey: "birthday",
        rowKey: "",
      },
      {
        label: $filter("translate")("PATIENT_ID"),
        sectorKey: "",
        stayKey: "ipp",
        rowKey: "",
      },
      {
        label: $filter("translate")("STAY"),
        sectorKey: "",
        stayKey: "si_id",
        rowKey: "",
      },
      {
        label: $filter("translate")("STAY_START_DATE"),
        sectorKey: "",
        stayKey: "dFrom",
        rowKey: "",
      },
      {
        label: $filter("translate")("STAY_END_DATE"),
        sectorKey: "",
        stayKey: "dTo",
        rowKey: "",
      },
      {
        label: $filter("translate")("TRANSLATE_DURING_LABEL"),
        sectorKey: "",
        stayKey: "durationOverPeriod",
        rowKey: "",
      },
      {
        label: $filter("translate")("STATUS"),
        sectorKey: "",
        stayKey: "state",
        rowKey: "",
      },
      {
        label: $filter("translate")("Sector"),
        sectorKey: "name",
        stayKey: "sectorName",
        rowKey: "",
      },
      {
        label: $filter("translate")("GROUP"),
        sectorKey: "",
        stayKey: "",
        rowKey: "group",
      },
      {
        label: $filter("translate")("SEQUENCE"),
        sectorKey: "TOTAL",
        stayKey: "TOTAL",
        rowKey: "name",
        class: "bold",
      },
      {
        label: $filter("translate")("DAILY_COST"),
        sectorKey: "dailyCost",
        stayKey: "dailyCost",
        rowKey: "dailyCost",
        isPrice: true,
        class: "bold",
      },
      {
        label: $filter("translate")("WEEKLY_COST"),
        sectorKey: "weeklyCost",
        stayKey: "weeklyCost",
        rowKey: "weeklyCost",
        isPrice: true,
        class: "bold",
      },
      {
        label: $filter("translate")("PERIOD_COST"),
        sectorKey: "totalCost",
        stayKey: "totalCost",
        rowKey: "totalCost",
        isPrice: true,
        class: "bold",
      },
    ];

    var realColumns = [
      {
        label: $filter("translate")("CT_FULL_NAME"),
        sectorKey: "",
        stayKey: "fullName",
        rowKey: "userFullName",
      },
      {
        label: $filter("translate")("GENDER"),
        sectorKey: "",
        stayKey: "gender",
        rowKey: "",
      },
      {
        label: $filter("translate")("DDN"),
        sectorKey: "",
        stayKey: "birthday",
        rowKey: "",
      },
      {
        label: $filter("translate")("PATIENT_ID"),
        sectorKey: "",
        stayKey: "ipp",
        rowKey: "",
      },
      {
        label: $filter("translate")("STAY"),
        sectorKey: "",
        stayKey: "si_id",
        rowKey: "",
      },
      {
        label: $filter("translate")("Sector"),
        sectorKey: "name",
        stayKey: "sectorName",
        rowKey: "",
      },
      {
        label: $filter("translate")("GROUP"),
        sectorKey: "",
        stayKey: "",
        rowKey: "userGroup",
      },
      {
        label: $filter("translate")("PERIOD_COST"),
        sectorKey: "totalCost",
        stayKey: "totalCost",
        rowKey: "",
        isPrice: true,
        class: "bold",
      },
      {
        label: $filter("translate")("DUE_AMOUNT"),
        sectorKey: "amount",
        stayKey: "amount",
        rowKey: "amount",
        isPrice: true,
        class: "bold",
        headerClass: "green",
      },
      {
        label: $filter("translate")("STATUS"),
        sectorKey: "",
        stayKey: "",
        rowKey: "status",
        headerClass: "green",
        click: "$ctrl.openModal()",
      },
      {
        label: "",
        sectorKey: "",
        stayKey: "",
        rowKey: "",
        headerClass: "grey",
      },
    ];

    function fetchGlobalData() {
      var fetchPatients = Patient.query({
        extra_fields: ["gender"],
      }).$promise.then(function (response) {
        ctrl.allPatients = response;
      });
      var fetchStays = Stay.query().$promise.then(function (response) {
        ctrl.allStays = response;
      });
      var fetchSequences = BillingSequenceService.query().$promise.then(
        function (response) {
          ctrl.allSequences = response;
        }
      );
      var fetchSectors = BillingSectorService.query().$promise.then(function (
        response
      ) {
        ctrl.allSectors = response;
      });
      var fetchUsers = UserUtils.getUsers().then(function (users) {
        var usersById = {};
        for (var i = 0; i < users.length; i++) {
          var user = users[i];
          usersById[user.id] = {
            fullName: user.full_name,
            group: _.cloneDeep(user.group),
          };
        }
        ctrl.users = usersById;
      });
      var fetchGroups = GroupUtils.getAllGroups().then(function (groups) {
        ctrl.allGroups = _.filter(groups, { liberal: true });
      });

      $q.all([
        fetchPatients,
        fetchStays,
        fetchSequences,
        fetchSectors,
        fetchUsers,
        fetchGroups,
      ])
        .then(function () {
          ctrl.loading = true;
          globalDataFetched = true;
          checkIfEverythingFetched();
        })
        .catch(function (error) {
          console.error("Error fetching global data:", error);
        });
    }

    function fetchRealAndPrevisionalData(startDate, endDate) {
      ctrl.loading = true;
      ctrl.diff = moment(endDate).diff(moment(startDate), "days") + 1;
      var params = { start_date: startDate, end_date: endDate };
      $rootScope.currentStay && (params["stay"] = $rootScope.currentStay.id);

      var getReal = BillingService.getRealCost(params).$promise.then(function (
        response
      ) {
        ctrl.real = response;
      });
      var getPrevisional = BillingService.getPrevisionalCost(
        params
      ).$promise.then(function (response) {
        ctrl.previsional = response;
      });

      $q.all([getReal, getPrevisional])
        .then(function () {
          realAndPreFetched = true;
          checkIfEverythingFetched();
        })
        .catch(function (error) {
          console.error("Error fetching real or previsional data:", error);
        });
    }

    function getUniqueDates(tasks) {
      return Array.from(
        new Set(
          tasks.map(function (task) {
            return task.date;
          })
        )
      );
    }

    function createConflictActivity(
      task,
      tasksByActivity,
      activitiesBySequence
    ) {
      /*
      Hacking 101: Create artificially a new activity to make the task appear in the sequence.
      */
      var i = 1;
      var conflict_id = task.activity + "_" + "c" + i;
      tasksByActivity[conflict_id] = tasksByActivity[conflict_id] || {};
      while (tasksByActivity[conflict_id][task.date]) {
        i += 1;
        conflict_id = task.activity + "_c" + i;
        tasksByActivity[conflict_id] = tasksByActivity[conflict_id] || {};
      }
      task.activity = conflict_id;
      tasksByActivity[conflict_id][task.date] = task;
      activitiesBySequence[task.sequence] =
        activitiesBySequence[task.sequence] || [];
      activitiesBySequence[task.sequence].push(conflict_id);
    }

    function orderSequences(activitiesBySequence) {
      var sequences = [];

      _.forEach(activitiesBySequence, function (value, seq_id) {
        if (ctrl.rowsBySequence[seq_id]) {
          sequences.push(ctrl.rowsBySequence[seq_id]);
        } else {
          var sequenceInfos = ctrl.allSequences.find(function (sequence) {
            return sequence.id == seq_id;
          });
          sequences.push({
            id: seq_id,
            name:
              sequenceInfos && sequenceInfos.data
                ? sequenceInfos.data.name
                : null,
            timeslots:
              sequenceInfos && sequenceInfos.planning_data
                ? sequenceInfos.planning_data.timeslots
                : null, // used for ordering
          });
        }
      });
      return $filter("orderBy")(sequences, [
        "timeslots[0].start_time.length",
        "timeslots[0].start_time",
        "id",
      ]);
    }

    function orderTasksByActivity(tasksByActivity) {
      var sortedKeys = Object.keys(tasksByActivity).sort(function (a, b) {
        var regex = /(\d+)(?:_c(\d+))?/; // Match "123" or "123_c456"

        var matchA = a.match(regex);
        var matchB = b.match(regex);

        if (!matchA || !matchB) {
          return 0; // If no match, keep order
        }

        var numA1 = parseInt(matchA[1], 10); // First number
        var numA2 = matchA[2] ? parseInt(matchA[2], 10) : 0; // Optional second number

        var numB1 = parseInt(matchB[1], 10);
        var numB2 = matchB[2] ? parseInt(matchB[2], 10) : 0;

        // Sort by first number, then second number if needed
        if (numA1 !== numB1) {
          return numA1 - numB1;
        }
        return numA2 - numB2;
      });

      var orderedTasksByActivity = {};
      for (var i = 0; i < sortedKeys.length; i++) {
        var key = sortedKeys[i];
        orderedTasksByActivity[key] = tasksByActivity[key];
      }
      return orderedTasksByActivity;
    }

    function computeTasksForDisplay(tasks) {
      var tasksByActivity = {};
      var tasksConflicts = [];
      var activitiesBySequence = {};
      var mlBySequence = {};
      var mlConflictDates = [];
      tasks.forEach(function (task) {
        computeAmountFields(task);
        setBuTextOnTask(task);
        tasksByActivity[task.activity] = tasksByActivity[task.activity] || {};
        if (tasksByActivity[task.activity][task.date]) {
          // Conflict: 2 tasks of the same activity on the same date
          createConflictActivity(task, tasksByActivity, activitiesBySequence);
          tasksConflicts.push(task);
        } else {
          tasksByActivity[task.activity][task.date] = task;
          activitiesBySequence[task.sequence] =
            activitiesBySequence[task.sequence] || [];
          if (task.activity)
            activitiesBySequence[task.sequence].push(task.activity.toString());
        }
        mlBySequence[task.sequence] = mlBySequence[task.sequence] || {};
        if (mlBySequence[task.sequence][task.date] != null) {
          if (mlBySequence[task.sequence][task.date] != task.mission_letter) {
            mlConflictDates.push(task.date);
          }
        } else {
          mlBySequence[task.sequence][task.date] = task.mission_letter;
        }
      });
      ctrl.tasksConflicts = tasksConflicts;
      ctrl.tasksConflictDates = _.uniq(_.map(tasksConflicts, "date"));
      ctrl.mlConflictDates = _.uniq(mlConflictDates);
      ctrl.tasksByActivity = orderTasksByActivity(tasksByActivity);
      ctrl.orderedSequences = orderSequences(activitiesBySequence);
      ctrl.activitiesBySequence = activitiesBySequence;
    }

    function computeMajorationForDisplay(majorations) {
      var majorationsBySeqUnitDate = {};
      var buByMaj = {};
      majorations.forEach(function (majoration) {
        majoration["amount"] = parseFloat(majoration.amount.toFixed(2));
        computeAmountFields(majoration);
        var unit = majoration.majoration;
        var seq = majoration.sequence;
        var date = majoration.date;
        buByMaj[majoration.majoration] = majoration.billing_unit;
        majorationsBySeqUnitDate[seq] = majorationsBySeqUnitDate[seq] || {};
        majorationsBySeqUnitDate[seq][unit] =
          majorationsBySeqUnitDate[seq][unit] || {};
        if (majorationsBySeqUnitDate[seq][unit][date]) {
          throw new Error(
            "Duplicate majoration for the same date (" +
              unit +
              "," +
              date +
              "). If you see this, something is really wrong."
          );
        }
        majorationsBySeqUnitDate[seq][unit][date] = majoration;
      });
      ctrl.buByMaj = buByMaj;
      ctrl.majorationsBySeqUnitDate = majorationsBySeqUnitDate;
    }

    ctrl.stateMap = {
      R: {
        disable_button: "pay_button",
        pay_button: "VOK",
        not_pay_button: "VNOK",
      },
      N: {
        disable_button: "not_pay_button",
        pay_button: "VOK",
        not_pay_button: "VNOK",
      },
      refused: {
        disable_button: "not_pay_button",
        pay_button: "VOK",
        not_pay_button: "VNOK",
      },
      P: {
        pay_button: "VOK",
        not_pay_button: "VNOK",
      },
      PP: {
        pay_button: "VOK",
        not_pay_button: "VNOK",
        cancelable: true,
      },
      FUTURE: {
        locked: true,
      },
      VOK: {
        disable_button: "pay_button",
        pay_button: "VOK",
        not_pay_button: "VNOK",
      },
      VNOK: {
        disable_button: "not_pay_button",
        pay_button: "VOK",
        not_pay_button: "VNOK",
      },
      VCHG: {
        pay_button: "VOK",
        not_pay_button: "VNOK",
        cancelable: true,
      },
      C_BILLED_TO_ME_TRACED_BY_OTHER: {
        // "disable_button": "pay_button", // Would require additional states C_..._VOK, C_..._VNOK, C_..._VCHG for it to work. I don't want to overcomplexify an already edgy edge case.
        pay_button: "VOK",
        not_pay_button: "VNOK",
        cancelable: true,
        has_conflict: true,
      },
      C_BILLED_TO_OTHER_TRACED_BY_ME_LOCKED: {
        pay_button: "VOK",
        not_pay_button: "VNOK",
        cancelable: true,
        has_conflict: true,
        locked: true,
      },
      C_BILLED_TO_OTHER_TRACED_BY_ME_UNLOCKED: {
        disable_button: "not_pay_button",
        pay_button: "VOK",
        not_pay_button: "VNOK",
        cancelable: true,
        has_conflict: true,
      },
    };

    function computeAmountFields(task, statusChanged) {
      var requestedUser = ctrl.selectedParams.user;
      if (!statusChanged) {
        task.traced_status = task.status;
      }
      if (task.billing_status == "VALIDATED") {
        if (!statusChanged) {
          task.display_amount = task.billing_amount;
          task.sub_totals_amount = task.billing_amount;
          if (task.billing_amount == 0 && task.amount > 0) {
            task.status = "VNOK";
          } else if (task.billing_amount != task.amount) {
            task.status = "VCHG"; // maybe invent a new state and color for this particular case
          } else {
            task.status = "VOK";
          }
          if (task.author && task.author != task.billed_user) {
            if (task.billed_user == requestedUser) {
              task.status = "C_BILLED_TO_ME_TRACED_BY_OTHER";
            } else if (
              task.author == requestedUser &&
              task.billing_amount > 0
            ) {
              task.status = "C_BILLED_TO_OTHER_TRACED_BY_ME_LOCKED";
            } else {
              task.status = "C_BILLED_TO_OTHER_TRACED_BY_ME_UNLOCKED";
            }
            task.billedTo = ctrl.users[task.billed_user].fullName;
            task.tracedBy = ctrl.users[task.author].fullName;
            if (!ctrl.billingConflictDates.includes(task.date)) {
              ctrl.billingConflictDates.push(task.date);
            }
          }
        } else if (task.status == "VOK") {
          task.display_amount = task.amount;
          task.sub_totals_amount = task.amount;
        } else if (task.status == "VNOK") {
          task.display_amount = 0;
          task.sub_totals_amount = 0;
        } else if (task.status == "VCHG") {
          // Only on click on 'Cancel'
          task.display_amount = task.billing_amount;
          task.sub_totals_amount = task.billing_amount;
        }
      } else {
        if (task.status == "R" || task.status == "VOK") {
          task.display_amount = task.amount;
          task.sub_totals_amount = task.amount;
        } else if (
          task.status == "N" ||
          task.status == "refused" ||
          task.status == "VNOK"
        ) {
          task.display_amount = 0;
          task.sub_totals_amount = 0;
        } else if (task.status == "P" || task.status == "PP") {
          task.display_amount = task.amount;
          task.sub_totals_amount = 0;
        }
      }
      if (!statusChanged) {
        if (task.status == "PP" && moment(task.date) > moment()) {
          task.status = "FUTURE";
        }
        task.original_status = task.status;
      }
      return task;
    }

    function dailyCostBySequence() {
      ctrl.dailyCostBySequence = {};
      ctrl.tasks.forEach(function (task) {
        ctrl.dailyCostBySequence[task.sequence] =
          ctrl.dailyCostBySequence[task.sequence] || {};
        ctrl.dailyCostBySequence[task.sequence][task.date] =
          ctrl.dailyCostBySequence[task.sequence][task.date] || 0;
        ctrl.dailyCostBySequence[task.sequence][task.date] +=
          task.sub_totals_amount;
      });

      ctrl.majorations.forEach(function (maj) {
        ctrl.dailyCostBySequence[maj.sequence] =
          ctrl.dailyCostBySequence[maj.sequence] || {};
        ctrl.dailyCostBySequence[maj.sequence][maj.date] =
          ctrl.dailyCostBySequence[maj.sequence][maj.date] || 0;
        ctrl.dailyCostBySequence[maj.sequence][maj.date] +=
          maj.sub_totals_amount;
      });
    }

    ctrl.previousWeek = function () {
      if (ctrl.currentWeekIndex != 0) ctrl.currentWeekIndex -= 1;
    };
    ctrl.nextWeek = function () {
      if (ctrl.currentWeekIndex < ctrl.weeks.length - 1)
        ctrl.currentWeekIndex += 1;
    };

    ctrl.changeCellStatus = function (cell, newStatus) {
      if (cell.isMajoration) {
        ctrl.majorationsBySeqUnitDate[cell.sequence][cell.majId][
          cell.date
        ].status = newStatus;
        computeAmountFields(
          ctrl.majorationsBySeqUnitDate[cell.sequence][cell.majId][cell.date],
          true
        );
      } else {
        ctrl.tasksByActivity[cell.activity][cell.date].status = newStatus;
        computeAmountFields(
          ctrl.tasksByActivity[cell.activity][cell.date],
          true
        );
      }
      cell.currentStatus = newStatus;
    };

    ctrl.changeStatus = function (newStatus) {
      if (
        !ctrl.selectedCell.isMajoration &&
        ctrl.selectedCell.currentStatus == "PP" &&
        newStatus == "VOK"
      ) {
        // hook for custom rule specified in https://www.wrike.com/open.htm?id=1426013522
        _.forOwn(
          ctrl.majorationsBySeqUnitDate[ctrl.selectedCell.sequence],
          function (val, majId) {
            var cell = ctrl.majToCell(majId, ctrl.selectedCell.date);
            if (cell && cell.currentStatus == "PP") {
              ctrl.changeCellStatus(cell, "VOK");
            }
          }
        );
      }
      ctrl.changeCellStatus(ctrl.selectedCell, newStatus);
      dailyCostBySequence();
    };

    ctrl.taskToCell = function (taskId) {
      var task = ctrl.tasks.find(function (task) {
        return task.task == taskId;
      });
      if (!task) return;
      return {
        taskId: taskId,
        activity: task.activity,
        sequence: task.sequence,
        date: task.date,
        currentStatus: ctrl.tasksByActivity[task.activity][task.date].status,
        initialStatus: task.original_status,
        tracedStatus: task.traced_status,
        isMajoration: false,
        billedTo: task.billedTo,
        tracedBy: task.tracedBy,
        refusalReason: task.refusal_reason,
      };
    };

    ctrl.selectTask = function (taskId) {
      var cell = ctrl.taskToCell(taskId);
      if (!cell) return;
      ctrl.selectedCell = cell;
    };

    ctrl.majToCell = function (majId, date) {
      var maj = ctrl.majorations.find(function (maj) {
        return maj.majoration == majId && maj.date == date;
      });
      if (!maj) return;
      return {
        majId: majId,
        sequence: maj.sequence,
        unit: maj.billing_unit,
        date: maj.date,
        currentStatus:
          ctrl.majorationsBySeqUnitDate[maj.sequence][maj.majoration][maj.date]
            .status,
        initialStatus: maj.original_status,
        tracedStatus: maj.traced_status,
        isMajoration: true,
      };
    };

    ctrl.selectMajoration = function (majId, date) {
      var cell = ctrl.majToCell(majId, date);
      if (!cell) return;
      ctrl.selectedCell = cell;
    };

    ctrl.activityLabelById = {};
    function computeActivitiesForDisplay(tasks) {
      var ids = Array.from(
        new Set(
          tasks.map(function (task) {
            return task["activity"];
          })
        )
      );
      var conflict_ids = _.filter(ids, function (id) {
        return typeof id === "string" && id.includes("_");
      });
      ids = _.reject(ids, function (id) {
        return typeof id === "string" && id.includes("_");
      });
      var queries = ids
        .filter(function (id) {
          return id;
        })
        .map(function (id) {
          return BillingActivityService.get({ id: id }).$promise;
        });

      var activityLabelById = {};
      $q.all(queries).then(function (activities) {
        activities.forEach(function (activity) {
          var stringId = activity.id.toString();
          activityLabelById[stringId] = activity.data["label"];
        });
        conflict_ids.forEach(function (conflict_id) {
          var match = conflict_id.match(/(\d+)_c(\d+)/);
          var activity = match[1].toString();
          activityLabelById[conflict_id] =
            activityLabelById[activity] +
            " (" +
            $filter("translate")("CONFLICT") +
            ")";
        });
        ctrl.activityLabelById = activityLabelById;
      });
    }

    ctrl.unitLabelById = {};
    ctrl.unitInfoById = {};
    function getUnitInfoById() {
      var unitLabelById = {};
      var unitInfoById = {};
      return BillingUnitUtils.getBillingUnits().then(function (results) {
        results.forEach(function (result) {
          var stringId = result.id.toString();
          unitInfoById[stringId] = result;
          unitLabelById[stringId] = result["short_name"];
        });
        ctrl.unitLabelById = unitLabelById;
        return unitInfoById;
      });
    }

    // // TODO JL 20062024:
    // // We keep this commented code as we will go back to this strategy after
    // // we change the data model to put one line per (activity / mission letter)
    // // or change activity replanification strategy
    // ctrl.buTextByActivity = {}
    // function getBuTextByActivity() {
    //   ctrl.tasks.forEach(function (task) {
    //     // If we didnt already compute a bu text for this activity
    //     if (!ctrl.buTextByActivity[task.activity]) {
    //       var bu = ctrl.unitInfoById[task.billing_unit]
    //       var text = '(' + task.quantity + ' ' + bu.short_name
    //       if (task.cotation != 1) {
    //         text += ' (' + task.cotation * 100 + ' %)'
    //       }
    //       text += ')'
    //       ctrl.buTextByActivity[task.activity] = text
    //     }
    //   })
    // }

    ctrl.buTextByMajUnit = {};
    function getBuTextByMajUnit() {
      ctrl.majorations.forEach(function (maj) {
        var bu = ctrl.unitInfoById[maj.billing_unit];
        if (bu.data && bu.data.custom_quantity) {
          var text = "(" + maj.quantity + bu.data.quantity_unit + ")";
          ctrl.buTextByMajUnit[maj.majoration] = text;
        }
      });
    }

    function setBuTextOnTask(task) {
      var bu = ctrl.unitInfoById[task.billing_unit];
      var text = task.quantity + " " + bu.short_name;
      if (task.cotation !== 1) {
        text += " (" + task.cotation * 100 + " %)";
      }
      task.buText = text;
    }

    ctrl.loadingTasks = false;
    ctrl.fetchTasks = function (stayId, userId, userBillable) {
      ctrl.tasks = [];
      ctrl.majorations = [];
      ctrl.selectedCell = null;
      if (ctrl.stays[stayId] && ctrl.users[userId])
        ctrl.selectedUserStay = {
          stay: ctrl.stays[stayId].fullName,
          user: ctrl.users[userId].fullName,
        };
      ctrl.selectedParams = {
        start_date: ctrl.startDate,
        end_date: ctrl.endDate,
        stay: stayId,
        user: userId,
        userBillable: userBillable,
      };
      ctrl.loadingTasks = true;
      ctrl.billingConflictDates = [];
      ctrl.openModal();
      BillingService.getControlTower(ctrl.selectedParams).$promise.then(
        function (response) {
          if (!Array.isArray(response)) return;
          response.forEach(function (taskOrMajoration) {
            if (taskOrMajoration.type == "MAJORATION")
              ctrl.majorations.push(taskOrMajoration);
            else if (taskOrMajoration.type == "TASK")
              ctrl.tasks.push(taskOrMajoration);
          });
          ctrl.uniqueDates = getUniqueDates(response);
          ctrl.weeks = BillingDateUtils.getWeeks(ctrl.uniqueDates);
          ctrl.currentWeekIndex = ctrl.weeks.length ? 0 : ctrl.weeks.length - 1;
          getUnitInfoById()
            .then(function (unitInfoById) {
              ctrl.unitInfoById = unitInfoById;
            })
            .catch(function (error) {
              console.error("Error in getUnitInfoById:", error);
              ctrl.unitInfoById = {};
            })
            .finally(function () {
              computeTasksForDisplay(ctrl.tasks);
              computeMajorationForDisplay(ctrl.majorations);
              computeActivitiesForDisplay(ctrl.tasks);
              // getBuTextByActivity()
              getBuTextByMajUnit();
              dailyCostBySequence();
              ctrl.loadingTasks = false;
            });
        }
      );
    };

    ctrl.anyChangeOnDateInSequence = function (item) {
      if (
        _.some(ctrl.tasks, function (task) {
          return (
            task.date == item.date &&
            task.sequence == item.sequence &&
            task.original_status != task.status
          );
        })
      ) {
        return true;
      }
      if (
        _.some(ctrl.majorations, function (majoration) {
          return (
            majoration.date == item.date &&
            majoration.sequence == item.sequence &&
            majoration.original_status != majoration.status
          );
        })
      ) {
        return true;
      }
      return false;
    };

    ctrl.toBeSentFilter = function (task) {
      if (ctrl.stateMap[task.status].locked) return false;
      if (task.billing_status != "VALIDATED") {
        if (task.status == "PP") {
          return ctrl.anyChangeOnDateInSequence(task);
        }
        return true;
      } else if (task.original_status != task.status) return true;
      else return false;
    };

    ctrl.validate = function () {
      // Dont send already-validated tasks/majorations if they havent been modified.
      var tasksToSend = ctrl.tasks.filter(ctrl.toBeSentFilter);
      var majorationsToSend = ctrl.majorations.filter(ctrl.toBeSentFilter);

      tasksToSend.forEach(function (task) {
        task.amount =
          ctrl.tasksByActivity[task.activity][task.date].sub_totals_amount;
        task.validation_status = "VALIDATED";
        task.status = ctrl.tasksByActivity[task.activity][task.date].status;
      });
      majorationsToSend.forEach(function (maj) {
        maj.amount =
          ctrl.majorationsBySeqUnitDate[maj.sequence][maj.majoration][
            maj.date
          ].sub_totals_amount;
        maj.validation_status = "VALIDATED";
        maj.status =
          ctrl.majorationsBySeqUnitDate[maj.sequence][maj.majoration][
            maj.date
          ].status;
      });

      BillingService.processValidation(
        ctrl.selectedParams,
        tasksToSend.concat(majorationsToSend)
      ).$promise.then(function (response) {
        ctrl.closeModal();
        // Reload real cost for this user.
        BillingService.getRealCost(ctrl.selectedParams).$promise.then(function (
          new_real
        ) {
          _.assign(ctrl.rowsByUser, dataToRowsByUser(new_real));
        });
      });
    };

    // We start by fetching globalData. When user selects a date we then fetch real and previsional data
    // We need to wait for both to complete before trying to display anything
    function checkIfEverythingFetched() {
      if (!realAndPreFetched || !globalDataFetched) return;
      ctrl.rowsBySequence = dataToRowsBySequence(ctrl.previsional);
      ctrl.rowsByUser = dataToRowsByUser(ctrl.real);
      ctrl.stays = aggregateCostsByStay(ctrl.rowsBySequence, ctrl.rowsByUser);
      ctrl.sectors = orderStaysBySectors(ctrl.stays);
      if (ctrl.currentView == VIEWS.REAL) ctrl.switchToRealCostView();
      else ctrl.switchToPreCostView();
      ctrl.loading = false;
    }

    ctrl.switchToRealCostView = function () {
      ctrl.savedFilters.currentView = ctrl.currentView = VIEWS.REAL;
      ctrl.columns = realColumns;
    };

    ctrl.switchToPreCostView = function () {
      ctrl.savedFilters.currentView = ctrl.currentView = VIEWS.PRE;
      ctrl.columns = preColumns;
    };

    // Used for previsional view, one row = one sequence.
    function dataToRowsBySequence(data) {
      var rows = {};
      data.forEach(function (obj) {
        var id = obj.sequence;

        if (rows[id]) {
          rows[id]["totalCost"] += obj.total_cost;
        } else {
          var sequenceInfos = ctrl.allSequences.find(function (sequence) {
            return sequence.id == id;
          });
          if (ctrl.selectedGroup != "0" && ctrl.selectedGroup != obj.group)
            return;

          var group = ctrl.allGroups.find(function (group) {
            return group.id == obj.group;
          });
          var stayInfos = ctrl.allStays.find(function (s) {
            return s.id == obj.stay;
          });
          if (!stayInfos) return;
          var duration = ctrl.durationOverPeriod(
            stayInfos.d_from,
            stayInfos.d_to
          );

          rows[id] = {
            id: id,
            name: sequenceInfos.data.name,
            timeslots: sequenceInfos.planning_data.timeslots, // used for ordering
            stay: obj.stay,
            duration: duration,
            totalCost: obj.total_cost,
            group: group ? group.name : "-",
          };
        }
      });

      angular.forEach(rows, function (row, id) {
        rows[id]["dailyCost"] = rows[id]["totalCost"] / rows[id]["duration"];
        rows[id]["weeklyCost"] = rows[id]["dailyCost"] * 7;
      });
      return rows;
    }

    // Used for previsional view, one row = one user. Costs of this user's sequences are added up.
    function dataToRowsByUser(data) {
      var rows = {};
      data.forEach(function (obj) {
        var userId = obj.user_id;
        var stayId = obj.stay_id;
        var seqId = obj.sequence_id;
        // create a unique key for the user x stay couple
        var key = obj.user_id + "x" + stayId;

        if (
          ctrl.selectedGroup != "0" &&
          ctrl.selectedGroup != ctrl.users[userId].group.id
        )
          return;
        if (rows[key]) {
          rows[key]["amount"] += obj.amount;
        } else {
          rows[key] = {
            id: key,
            userId: userId,
            userGroup: ctrl.users[userId].group.name,
            userFullName: ctrl.users[userId].fullName,
            stay: stayId,
            amount: obj.amount,
            status: $filter("translate")(obj.validation_status),
            userBillable: obj.user_billable,
            userBillableReason: obj.user_billable_reason || "-",
          };
        }
      });
      return rows;
    }

    function aggregateCostsByStay(prevCostRowsBySequence, realCostRowsByUser) {
      var stays = {};

      // Aggregate previsional costs ('totalCost', 'dailyCost', 'weeklyCost' and 'listOfRowIdsPRE')
      angular.forEach(prevCostRowsBySequence, function (row, rowId) {
        var stayId = row.stay || "?";
        if (stays[stayId]) {
          stays[stayId]["totalCost"] += row.totalCost;
          stays[stayId]["dailyCost"] += row.dailyCost;
          stays[stayId]["weeklyCost"] += row.weeklyCost;
          stays[stayId]["listOfRowIdsPRE"].push(rowId);
        } else {
          var stayInfos =
            ctrl.allStays.find(function (s) {
              return s.id == stayId;
            }) || {};
          if (!stayInfos) {
            return;
          }
          var patientInfos =
            ctrl.allPatients.find(function (patient) {
              return patient.id == stayInfos.patient;
            }) || {};
          var sectorInfos =
            ctrl.allSectors.find(function (s) {
              return s.id == stayInfos.sector;
            }) || {};

          stays[stayId] = {
            id: stayId,
            si_id: stayInfos.si_id,
            gender: PatientUtils.translateGenderShort(patientInfos.gender),
            ipp: patientInfos.si_id,
            birthday: new Date(patientInfos.birthday).toLocaleDateString(),
            fullName: patientInfos.full_name,
            sector: stayInfos.sector || "-",
            dTo:
              stayInfos.d_to && new Date(stayInfos.d_to).toLocaleDateString(),
            dFrom:
              stayInfos.d_from &&
              new Date(stayInfos.d_from).toLocaleDateString(),
            initial_d_from: stayInfos.d_from && new Date(stayInfos.d_from),
            durationOverPeriod: ctrl.durationOverPeriod(
              stayInfos.d_from,
              stayInfos.d_to
            ),
            totalCost: row.totalCost,
            dailyCost: row.dailyCost,
            weeklyCost: row.weeklyCost,
            amount: 0,
            listOfRowIdsPRE: [rowId],
            listOfRowIdsREAL: [],
            sectorName: sectorInfos.name || "-",
            state: StayUtils.translateStayState(stayInfos.state),
          };
        }
      });

      // Aggregate real costs ('amount' and 'listOfRowIdsREAL')
      angular.forEach(realCostRowsByUser, function (row, rowId) {
        var stayId = row.stay || "?";
        if (stays[stayId]) {
          stays[stayId]["amount"] += row.amount;
          stays[stayId]["listOfRowIdsREAL"].push(rowId);
        } else {
          /*
            Fail-safe if a stay has a real cost but no previsional cost but it should never happen.
          */
          var stayInfos =
            ctrl.allStays.find(function (s) {
              return s.id == stayId;
            }) || {};
          if (!stayInfos) {
            return;
          }
          var patientInfos =
            ctrl.allPatients.find(function (patient) {
              return patient.id == stayInfos.patient;
            }) || {};
          var sectorInfos =
            ctrl.allSectors.find(function (s) {
              return s.id == stayInfos.sector;
            }) || {};

          stays[stayId] = {
            id: stayId,
            si_id: stayInfos.si_id,
            gender: PatientUtils.translateGenderShort(patientInfos.gender),
            ipp: patientInfos.si_id,
            birthday: new Date(patientInfos.birthday).toLocaleDateString(),
            fullName: patientInfos.full_name,
            sector: stayInfos.sector || "-",
            dTo:
              stayInfos.d_to && new Date(stayInfos.d_to).toLocaleDateString(),
            dFrom:
              stayInfos.d_from &&
              new Date(stayInfos.d_from).toLocaleDateString(),
            initial_d_from: stayInfos.d_from && new Date(stayInfos.d_from),
            durationOverPeriod: ctrl.durationOverPeriod(
              stayInfos.d_from,
              stayInfos.d_to
            ),
            totalCost: 0,
            dailyCost: 0,
            weeklyCost: 0,
            amount: row.amount,
            listOfRowIdsPRE: [],
            listOfRowIdsREAL: [rowId],
            sectorName: sectorInfos.name || "-",
            state: StayUtils.translateStayState(stayInfos.state),
          };
        }
      });

      return stays;
    }

    function orderStaysBySectors(stays) {
      var sectors = {};
      angular.forEach(stays, function (stay, stayId) {
        var sector = stay.sector;
        if (ctrl.selectedSector != 0 && ctrl.selectedSector != sector) return;
        if (sectors[sector]) {
          sectors[sector]["listOfStayIds"].push(stayId);
          sectors[sector]["totalCost"] += stay.totalCost;
          sectors[sector]["dailyCost"] += stay.dailyCost;
          sectors[sector]["weeklyCost"] += stay.weeklyCost;
          sectors[sector]["amount"] += stay.amount;
        } else {
          sectors[sector] = {
            id: sector || "-",
            name: stay.sectorName || "-",
            totalCost: stay.totalCost,
            dailyCost: stay.dailyCost,
            weeklyCost: stay.weeklyCost,
            amount: stay.amount,
            listOfStayIds: [stayId],
          };
        }
      });
      angular.forEach(sectors, function (sectorInfo, sector) {
        sectors[sector]["listOfStayIds"] = _.orderBy(
          sectors[sector]["listOfStayIds"],
          function (stayId) {
            return stays[stayId].initial_d_from;
          },
          ["desc"]
        );
      });

      return sectors;
    }

    ctrl.onSectorChange = function () {
      ctrl.savedFilters.selectedSector = ctrl.selectedSector;
      ctrl.sectors = orderStaysBySectors(ctrl.stays);
    };
    ctrl.onGroupChange = function () {
      ctrl.savedFilters.selectedGroup = ctrl.selectedGroup;
      checkIfEverythingFetched();
    };

    ctrl.handleDateSelected = function () {
      var startDate = document.getElementById("start").value;
      var endDate = document.getElementById("end").value;
      // api needs both.
      if (!startDate || !endDate) return;

      if (ctrl.startDate != startDate || ctrl.endDate != endDate) {
        ctrl.startDate = ctrl.savedFilters.startDate = new Date(startDate);
        ctrl.endDate = ctrl.savedFilters.endDate = new Date(endDate);
        fetchRealAndPrevisionalData(startDate, endDate);
      }
    };

    ctrl.durationOverPeriod = function (stay_start, stay_end) {
      stay_end = stay_end || ctrl.endDate;
      var start = moment.max(moment(stay_start), moment(ctrl.startDate));
      var end = moment.min(moment(stay_end), moment(ctrl.endDate));
      return Math.max(0, end.diff(start, "days") + 1);
    };

    function setDefaultDateInterval() {
      var startDate = ctrl.savedFilters.startDate || new Date();
      var endDate = ctrl.savedFilters.endDate || new Date();
      if (!ctrl.savedFilters.endDate || !ctrl.savedFilters.startDate) {
        startDate.setMonth(startDate.getMonth() - 1); // One month ago
      }
      ctrl.startDate = ctrl.savedFilters.startDate = startDate;
      ctrl.endDate = ctrl.savedFilters.endDate = endDate;
      document.getElementById("start").valueAsDate = startDate;
      document.getElementById("end").valueAsDate = endDate;
      fetchRealAndPrevisionalData(startDate, endDate);
    }

    ctrl.openModal = function () {
      // const dialog = document.querySelector("dialog");
      // dialog.showModal();
      ctrl.showValidation = true;
    };

    ctrl.closeModal = function () {
      ctrl.showValidation = false;

      var stayId = ctrl.selectedParams.stay;
      var userId = ctrl.selectedParams.user;
      var rowId = stayId + "x" + userId;
      // Find the element by id and scroll it into view
      $timeout(function () {
        var element = document.getElementById(rowId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    };

    ctrl.userOverride = function (stayId) {
      var modalInstance = $uibModal.open({
        templateUrl: "billing/views/billing-user-selection-modal.html", // Path to your modal template
        controller: "BillingUserSelectionCtrl", // Controller for the modal
        controllerAs: "$ctrl",
        size: "md",
      });
      modalInstance.result.then(function (result) {
        ctrl.fetchTasks(stayId, result.user, result.userBillable);
      });
    };

    ctrl.exportToCSV = function () {
      var csvContent = "data:text/csv;charset=utf-8,";
      var table = document.querySelector(".billing table");
      var rows = table.querySelectorAll("tr");

      rows.forEach(function (row) {
        var rowData = [];
        row.querySelectorAll("th, td").forEach(function (cell) {
          rowData.push(cell.innerText.replace(/,/g, "")); // Replace commas to avoid CSV formatting issues
        });
        csvContent += rowData.join(",") + "\n";
      });

      // Create a temporary anchor element to trigger the download
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "table.csv");
      document.body.appendChild(link);

      // Trigger the download
      link.click();
    };
  }],
});

angular.module("mhclientApp").filter("formatPrice", function () {
  return function (value, isPrice) {
    if (isPrice && angular.isNumber(value)) {
      return value.toFixed(2) + "€";
    }
    return value;
  };
});

angular.module("mhclientApp").filter("formatDate", function () {
  return function (value) {
    var date = new Date(value);
    var localeString = date.toLocaleDateString();
    var parts = localeString.split("/");
    // Reconstruct the date string without the year part
    return parts[0] + "/" + parts[1];
  };
});

"use strict";

angular
  .module("mhclientApp")
  .factory("BillingService", ["$resource", "MhConfig", function ($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v2";
    return $resource(
      "/api_rest/billing_control/:route",
      {
        start_date: "@start_Date",
        end_date: "@end_Date",
        stay: "@stay",
      },
      {
        getRealCost: {
          headers: { Accept: acceptHeader },
          method: "GET",
          params: {
            route: "real_cost",
            start_date: "@start_date",
            end_date: "@end_date",
            stay: "@stay",
          },
          isArray: true,
        },
        userBillable: {
          headers: { Accept: acceptHeader },
          method: "GET",
          params: {
            route: "user_billable",
            user: "@user",
          },
        },
        getPrevisionalCost: {
          headers: { Accept: acceptHeader },
          method: "GET",
          params: {
            route: "previsional_cost",
            start_date: "@start_date",
            end_date: "@end_date",
            stay: "@stay",
          },
          isArray: true,
        },
        getControlTower: {
          headers: { Accept: acceptHeader },
          method: "GET",
          params: {
            route: "control_tower",
            start_date: "@start_date",
            end_date: "@end_date",
            stay: "@stay",
            user: "@user",
          },
          isArray: true,
        },
        processValidation: {
          headers: { Accept: acceptHeader },
          method: "POST",
          params: {
            route: "process_validation",
            start_date: "@start_date",
            end_date: "@end_date",
            stay: "@stay",
            user: "@user",
          },
        },
        dailyExport: {
          headers: { Accept: acceptHeader },
          method: "GET",
          params: { route: "daily_export" },
          transformResponse: function (data) {
            return { data: data };
          },
        },
      }
    );
  }]);

angular
  .module("mhclientApp")
  .factory("BillingSequenceService", ["$resource", "MhConfig", function ($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v2";
    return $resource(
      "/api_rest/sequences",
      {},
      {
        query: {
          method: "GET",
          headers: { Accept: acceptHeader },
          isArray: true,
        },
      }
    );
  }]);
angular
  .module("mhclientApp")
  .factory("BillingSectorService", ["$resource", "MhConfig", function ($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v2";
    return $resource(
      "/api_rest/sectors",
      {},
      {
        query: {
          method: "GET",
          headers: { Accept: acceptHeader },
          isArray: true,
        },
      }
    );
  }]);

angular
  .module("mhclientApp")
  .factory("BillingActivityService", ["$resource", "MhConfig", function ($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v2";
    return $resource(
      "/api_rest/activity/:id",
      {
        id: "@id",
      },
      {
        get: {
          headers: { Accept: acceptHeader },
        },
        query: {
          method: "GET",
          headers: { Accept: acceptHeader },
          isArray: true,
        },
      }
    );
  }]);

angular.module("mhclientApp").component("billingTaskCell", {
  templateUrl: "billing/views/billing-task-cell.html",
  controller: billingTaskCellController,
  bindings: { task: "<" },
});

function billingTaskCellController($filter, $scope) {
  var ctrl = this;

  $scope.getTextFromBillingStatus = getTextFromBillingStatus;

  function getTextFromBillingStatus(status) {
    if (status === "VALIDATED") {
      return $filter("translate")("TOOLTIP_VALIDATED", {
        buText: ctrl.task.buText,
      });
    }

    return $filter("translate")("TOOLTIP_NOT_YET_VALIDATED", {
      buText: ctrl.task.buText,
    });
  }
}

'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:newReport
* @description
* Modal component which displays new report form
* **********************************************/

var NewReportCtrl = function(SiteVarsUtils) {
  var ctrl = this;

  var init = function() {
    SiteVarsUtils.getValue('WORK_REPORT_ATTACH_MAX_SIZE', "20MB").then( function(maxSize) {
      ctrl.maxSize = maxSize;
      ctrl.displayDefaultFields = ctrl.extraOptions.displayDefaultFields !== false;
    })
  };

  ctrl.cancelThread = function() {
    ctrl.cancel();
  };

  ctrl.createThread = function() {
    ctrl.create();
  };

  init();
};
NewReportCtrl.$inject = ["SiteVarsUtils"];

angular.module("mhclientApp").component("newReport", {
  templateUrl: "work-reports/components/new-report/new-report.html",
  controller: NewReportCtrl,
  bindings: {
    newReport: "<",
    platform: "<",
    extraOptions: "<",
    cancel: "&",
    create: "&",
  },
});



'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:workReports
* @description
* Modal component which displays work reports
* **********************************************/

var WorkReportCtrl = function($scope,
    $filter,
    $q,
    $rootScope,
    WorkReport,
    Message,
    Thread,
    Upload,
    SiteVarsUtils,
    WorkReportsUtils,
    $state,
    Utils) {
  var ctrl = this;
  $scope.$on('checkDirty', function(event) {
    event.isDirty = event.isDirty || ctrl.newReport;
  });

  $scope.$on('closeRequested', function(event) {
    if ($scope.$broadcast('checkDirty').isDirty) {
      if (!event.closePromises) {
        event.closePromises = [];
      }
      event.closePromises.push(Utils.newHandleCloseRequested(false));
    }
  });

  $scope.$on('$toggleShowAllStays', function(event) {
    if ($scope.$broadcast('checkDirty').isDirty) {
      if (!event.togglePromises) {
        event.togglePromises = [];
      }
      event.togglePromises.push(Utils.newHandleCloseRequested(false, null, ctrl.setCloseHandled));
    }
  });

  $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {
    if (event.defaultPrevented || ctrl.closeHandled) {
      return;
    }
    if ($scope.$broadcast('checkDirty').isDirty) {
      event.preventDefault();
      Utils.newHandleCloseRequested(false, null, ctrl.setCloseHandled).then( function(continueChange) {
        if (continueChange) {
          $state.go(toState.name, toParams, options);
        }
      });
    }
  });

  ctrl.setCloseHandled = function() {
    ctrl.closeHandled = true;
  };

  ctrl.reloadFilters = function() {
    ctrl.infiniteScroll(0);
  };

  ctrl.infiniteScroll = function(increment) {
    ctrl.limitTo += increment || ctrl.defaultIncrement;
    var filterReports = $filter('orderBy')(ctrl.reports, "-timestamp");
    if (ctrl.feedFilters.selectedCategories.length > 0) {
      var categories = _.map(ctrl.feedFilters.selectedCategories, "value");
      var filterReports = _.filter(filterReports, function(r) {
        return categories.indexOf(r.category) !== -1;
      });
    }
    ctrl.limitedOrderedReports = $filter('limitTo')(filterReports, ctrl.limitTo);
    ctrl.hasMore = ctrl.reports.length > ctrl.limitedOrderedReports.length;
  };

  ctrl.cancelThread = function() {
    ctrl.newReport = null;
  };

  ctrl.printFeed = function() {
    if (ctrl.allStays) {
      window.open("/webfw/documents_mgr/stay_" + ctrl.stay.id + "/pat_"+
                  ctrl.patient.id +"/feed_"+ ctrl.feed.id +"/mhc_work_report/to_pdf/", '_blank');
    } else {
      window.open("/webfw/documents_mgr/stay_" + ctrl.stay.id +
                  "/feed_"+ ctrl.feed.id +"/mhc_work_report/to_pdf/", '_blank');
    }
  };
  // $scope.takePicture = () ->
  //   $rootScope.busy = true
  //   $timeout(window.mgapp.take_picture({}), 50)

  ctrl.createNewReport = function(category) {
    ctrl.newReport = {
      feed: ctrl.feed.id,
      stay: ctrl.stay.id,
      first_message: {
        category: category,
        stay: ctrl.stay.id,
        priority: 0,
        data: {eventDate: new Date()},
        content: {data: []},
        timestamp: new Date().toISOString(),
        from_platform: ctrl.platform,
      },
    };
  };

  ctrl.sendThread = function() {
    var message = ctrl.newReport.first_message;
    if (ctrl.newReport.first_message.content.mode === "draw") {
      Message.cropEmptySpace(message);
    }
    $rootScope.busy = true
    Thread.api.save(ctrl.newReport).$promise.then( function(threadResponse) {
      $q.when( message.attach ?
        Upload.upload({
          url: "/api_rest/messages/"+ threadResponse.first_message.id + "/upload_image",
          method: "PUT", file: message.attach,
        }) :
        true).then( function() {
        ctrl.reports.push({
          id: threadResponse.id,
          timestamp: threadResponse.last_message_timestamp,
          category: threadResponse.first_message.category,
        });
        $rootScope.busy = false
        ctrl.infiniteScroll(1);
        ctrl.newReport = undefined;
      });
    });
  };

  var init = function() {
    ctrl.defaultIncrement = 8;
    ctrl.limitTo = 0;
    ctrl.searchText = "";
    ctrl.dateMax = new Date();
    ctrl.feedFilters = {selectedCategories: []};
    ctrl.availableCreation = WorkReportsUtils.availableCreation[ctrl.feed.view] || [{value: "NEW_WORK_REPORT"}];

    ctrl.extraOptions = WorkReportsUtils.extraOptions[ctrl.feed.view] || {fields: [], displayDefaultFields: true};
    ctrl.canWrite = ctrl.feed.writable_by.indexOf(ctrl.user.group.id) !== -1;

    if (ctrl.allStays) {
      var params = {patient: ctrl.patient.id};
    } else {
      var params = {stay: ctrl.stay.id};
    }
    $q.when(ctrl.initialReports ||
            WorkReport.query(_.assign({feed: ctrl.feed.id}, params)).$promise
    ).then( function(reports) {
      ctrl.reports = reports;
      ctrl.infiniteScroll(8); // initialLimitTo
    });
  };

  init();
};
WorkReportCtrl.$inject = ["$scope", "$filter", "$q", "$rootScope", "WorkReport", "Message", "Thread", "Upload", "SiteVarsUtils", "WorkReportsUtils", "$state", "Utils"];

angular.module("mhclientApp").component("workReports", {
  templateUrl: "work-reports/components/work-reports/work-reports.html",
  controller: WorkReportCtrl,
  bindings: {
    patient: "<",
    stay: "<",
    allStays: "<",
    initialReports: "<",
    feed: "<",
    platform: "<",
    user: "<",
    showHeaders: "<",
  },
});



'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.component:workReportsList
* @description
* Modal component which displays work reports list
* **********************************************/

angular.module("mhclientApp").component("workReportsList", {
  templateUrl: "work-reports/components/work-reports-list/work-reports-list.html",
  bindings: {
    workReports: "<",
    extraOptions: "<",
    searchText: "<",
    canWrite: "<",
  },
});

(function() {
  'use strict';
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('mhclientApp').directive('messageDisplay', ["RecursionHelper", function(RecursionHelper) {
    return {
      restrict: 'A',
      compile: function(element, attrs) {
        if (attrs.isCollapsed == null) {
          attrs.isCollapsed = "false";
        }
        return RecursionHelper.compile(element);
      },
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'work-reports/views/message-display.html';
        }
      },
      scope: {
        message: '=messageDisplay',
        canWrite: "=",
        thread: "=",
        depth: "=",
        searchText: "=",
        isCollapsed: "=",
        extraOptions: "="
      },
      controller: ["$scope", "$rootScope", "$q", "$http", "Message", function($scope, $rootScope, $q, $http, Message) {
        var checkEntry;
        $scope.$watch("searchText", function(newValue, oldValue) {
          return $scope.handleVisibility();
        });
        checkEntry = function(message, regex) {
          return message.content && (!regex || regex.test(message.content.data) || _.some(message.responses, function(item) {
            return checkEntry(item, regex);
          }));
        };
        $scope.handleVisibility = function() {
          return $scope.visible = checkEntry($scope.message, ($scope.searchText != null) && $scope.searchText.length > 0 ? new RegExp('' + $scope.searchText.replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i') : false);
        };
        $scope.$on('$fetchedMessage', function(event) {
          return $scope.handleVisibility();
        });
        $scope.toggleCollapse = function() {
          return $scope.isCollapsed = !$scope.isCollapsed;
        };
        $scope.$on('checkDirty', function(event) {
          return event.isDirty = event.isDirty || $scope.response;
        });
        if ($scope.message.content) {
          $scope.$emit('$fetchedMessage');
        } else {
          $http.get($scope.message.content_url).then(function(content) {
            content.data.data = _.escape(content.data.data);
            $scope.message.content = content.data;
            return $scope.$emit('$fetchedMessage');
          });
        }
        $scope.isImage = function(attachment) {
          var ref;
          return (ref = attachment.split('.').pop()) === 'jpg' || ref === 'gif' || ref === 'jpeg' || ref === 'png';
        };
        $scope.answerForCategory = {
          "objectif": {
            "label": "NEW_FOLLOW_UP",
            "value": "follow_up"
          },
          "follow_up": {
            "label": "NEW_BILAN",
            "value": "bilan"
          },
          "initial_assessment": {
            "label": "NEW_BILAN",
            "value": "informations"
          },
          "final_assessment": {
            "label": "NEW_BILAN",
            "value": "informations"
          },
          "intermediate_assessment": {
            "label": "NEW_BILAN",
            "value": "informations"
          },
          "mess_pharma_doctor": {
            "label": "Answer",
            "value": "response"
          },
          "mess_pharma_preparer": {
            "label": "Answer",
            "value": "response"
          },
          "response": {
            "label": "Answer",
            "value": "response"
          }
        };
        $scope.createRespond = function(category) {
          return $scope.response = {
            category: category || "response",
            stay: $scope.thread.stay,
            priority: 0,
            data: {},
            content: {
              data: []
            },
            from_platform: $rootScope.mh_config.platform,
            timestamp: new Date().toISOString(),
            parent: $scope.message.id,
            thread: $scope.thread.id
          };
        };
        $scope.cancelResponse = function() {
          return $scope.response = null;
        };
        return $scope.respondMessage = function() {
          if ($scope.response.content.mode === "draw") {
            Message.cropEmptySpace($scope.response);
          }
          return Message.api.save($scope.response).$promise.then(function(messageResponse) {
            messageResponse.responses = [];
            $scope.message.responses.unshift(messageResponse);
            return $scope.response = void 0;
          });
        };
      }]
    };
  }]);

  angular.module('mhclientApp').directive('fetchReport', function() {
    return {
      restrict: 'A',
      transclude: true,
      template: '<ng-transclude ng-if="::report.first_message"></ng-transclude>',
      scope: {
        report: '=fetchReport'
      },
      controller: ["$scope", "$q", "$http", "WorkReport", function($scope, $q, $http, WorkReport) {
        if ($scope.report.first_message == null) {
          return WorkReport.getDetails({
            id: $scope.report.id
          }).$promise.then(function(reportDetails) {
            var i, len, message, messagesByIdDict, ref, ref1, results;
            _.assign($scope.report, reportDetails);
            messagesByIdDict = {};
            messagesByIdDict[$scope.report.first_message.id] = $scope.report.first_message;
            ref = _.orderBy(_.concat([$scope.report.first_message], $scope.report.messages), [
              (function(message) {
                return message.parent || 0;
              }), "timestamp"
            ], ['asc', 'desc']);
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              message = ref[i];
              message.read = (ref1 = message.id, indexOf.call(reportDetails.unread_messages, ref1) < 0);
              message.responses = [];
              message.content_url = $scope.report.data_folder + "/" + message.uid + "/content.json?" + message.modified;
              messagesByIdDict[message.id] = message;
              if (message.parent) {
                results.push(messagesByIdDict[message.parent].responses.push(message));
              } else {
                results.push(void 0);
              }
            }
            return results;
          });
        }
      }]
    };
  });

  angular.module('mhclientApp').directive('multiWorkReports', function() {
    return {
      restrict: 'A',
      templateUrl: function(element, attr) {
        if (attr.templateUrl) {
          return attr.templateUrl;
        } else {
          return 'work-reports/views/multi-work-reports.html';
        }
      },
      scope: {
        patient: '=',
        stay: "=",
        allStays: "=",
        defaultView: "@"
      },
      controller: ["$rootScope", "$scope", "$filter", "$q", "FeedUtils", "WorkReport", "GroupUtils", "Utils", function($rootScope, $scope, $filter, $q, FeedUtils, WorkReport, GroupUtils, Utils) {
        $scope.checkForm = function(event, selectedIndex) {
          if ($scope.currentTabIndex !== selectedIndex) {
            event.preventDefault();
            return $q.all($scope.$broadcast('closeRequested').closePromises || []).then(function(result) {
              return $q.when(_.every(result, Boolean) || Utils.newHandleCloseRequested(false)).then(function(continueChange) {
                if (continueChange) {
                  return $scope.currentTabIndex = selectedIndex;
                }
              });
            });
          }
        };
        return FeedUtils.getFeedsByName("MHC_WORK_REPORT").then(function(feeds) {
          feeds = _.filter(feeds, function(feed) {
            var ref;
            return ref = $rootScope.user.group.id, indexOf.call(_.concat(feed.readable_by, feed.writable_by), ref) >= 0;
          });
          return GroupUtils.getAllGroups().then(function(groups) {
            return WorkReport.query(_.assign({
              feature_name: "MHC_WORK_REPORT"
            }, $scope.allStays ? {
              patient: $scope.patient.id
            } : {
              stay: $scope.stay.id
            })).$promise.then(function(workReports) {
              feeds = _.cloneDeep(feeds);
              _.forEach(feeds, function(feed) {
                feed.heading = $filter('translate')(feed.view || feed.feature_name);
                feed.reports = _.filter(workReports, {
                  feed: feed.id
                });
                if (feed.writable_by.length > 0) {
                  feed.icon = _.find(groups, {
                    id: feed.writable_by[0]
                  }).icon;
                }
              });
              $scope.feeds = $filter('orderBy')(feeds, "heading");
              return $scope.currentTabIndex = _.indexOf($scope.feeds, _.find($scope.feeds, function(feed) {
                var ref;
                return feed.view === $scope.defaultView || (ref = $rootScope.user.group.id, indexOf.call(feed.writable_by, ref) >= 0);
              }));
            });
          });
        });
      }]
    };
  });

  angular.module('mhclientApp').filter('capitalize', function() {
    return function(text) {
      return _.upperFirst(text);
    };
  });

}).call(this);

//# sourceMappingURL=work-reports-directives.js.map

(function() {
  'use strict';

  /*
    * @ngdoc function
    * @name mhclientApp.service:Thread
    * @description
    * # Thread
    * Factory of Thread
   */
  angular.module("mhclientApp").factory('WorkReport', ["$resource", "MhConfig", "$q", "BoxResource", "$http", function($resource, MhConfig, $q, BoxResource, $http) {
    var acceptHeader, api, boxAPI, portailAPI, thread;
    acceptHeader = MhConfig.baseAcceptHeader + ";version=v1";
    portailAPI = $resource('/api_rest/work_reports/:id/:route', {
      id: this.id
    }, {
      'query': {
        method: "GET",
        headers: {
          'Accept': acceptHeader
        },
        isArray: true
      },
      'getDetails': {
        method: "GET",
        isArray: false,
        params: {
          route: 'get_details'
        },
        headers: {
          "Accept": acceptHeader
        }
      }
    });
    switch (MhConfig.platform) {
      case 'mhsi':
        api = portailAPI;
        break;
      case 'mgapp':
        thread = window.mgapp.get('work_report_mgr').thread();
        boxAPI = BoxResource.generate(thread);
        boxAPI.getDetails = function(object) {
          return BoxResource.mhboxApiCall(thread, "get_details", object);
        };
        api = boxAPI;
        break;
      default:
        api = portailAPI;
    }
    return api;
  }]);

}).call(this);

//# sourceMappingURL=work-report-services.js.map


'use strict';

/* **********************************************
* @ngdoc function
* @name mhclientApp.service:
* @description
* Work Reports stuff
* ********************************************** */

angular.module("mhclientApp").factory('WorkReportsUtils', ["$filter", function($filter) {
  var utils = {};
  // available creations
  utils.availableCreation = {
    'nutrition': [
      {value: "objectif", creationLabel: "NEW_OBJECTIF", filterLabel: $filter("translate")("objectif")}],
    'IDE': [
      {value: "paramedic_observation",
        creationLabel: "NEW_PARAMEDIC_OBSERVATION",
        filterLabel: $filter("translate")("paramedic_observation"),
      },
      {value: "bandage", creationLabel: "NEW_BANDAGE", filterLabel: $filter("translate")("bandage")},
    ],
    "ortho": [
      {value: "initial_assessment", filterLabel: $filter("translate")("initial_assessment")},
      {value: "intermediate_assessment", filterLabel: $filter("translate")("intermediate_assessment")},
      {value: "final_assessment", filterLabel: $filter("translate")("final_assessment")},
    ],
  };

  utils.extraOptions = {
    nutrition: {
      fields: [{key: "weight", label: "WEIGHT", messageLocalization: "header", useInAnswer: true}],
      displayDefaultFields: true,
    },
    mess_pharma_doctor: {
      fields: [
        {key: "subject", label: "SUBJECT", type: "long-input", messageLocalization: "header", useInAnswer: false},
        {key: "message", label: "MESSAGE", type: "textarea", messageLocalization: "body", useInAnswer: true},
      ],
      displayDefaultFields: false,
    },
    mess_pharma_preparer: {
      fields: [
        {key: "subject", label: "SUBJECT", type: "long-input", messageLocalization: "header", useInAnswer: false},
        {key: "message", label: "MESSAGE", type: "textarea", messageLocalization: "body", useInAnswer: true},
      ],
      displayDefaultFields: false,
    },
  };


  return utils;
}]);

angular.module("mhclientApp").component("workReportsConfig", {
    templateUrl: "work-reports/views/work-reports-config.html",
    controller: ["Feed", "Group", "$q", "$http", "FeedUtils", "Feature", function workReportsConfig(Feed, Group, $q, $http, FeedUtils, Feature) {
        var ctrl = this;
        ctrl.title = "work reports";
        ctrl.feeds = [];
        ctrl.features = []
        ctrl.workReportFeature = null
        ctrl.showObsolete = false;
        ctrl.selectedFeed = null; // Track the currently selected feed for editing
        ctrl.editableRights = {
            readable: {},
            writable: {},
        };
        ctrl.view = ''
        ctrl.feedSearch = '';
        ctrl.groupSearch = '';

        ctrl.init = function () {
            var feedPromise = Feed.api.query({ feature__name: "MHC_WORK_REPORT" }).$promise;
            var groupPromise = Group.query().$promise;
            var featurePromise = Feature.api.query().$promise


            $q.all([feedPromise, groupPromise, featurePromise]).then(function (results) {
                ctrl.feeds = results[0];
                ctrl.groups = results[1];
                ctrl.features = results[2]

                ctrl.sortFeedsByView();
                ctrl.sortGroupsByName();
                ctrl.findWorkReportsFeature()
                ctrl.computeFeeds();
            });
        };

        ctrl.computeFeeds = function () {
            ctrl.feeds = ctrl.feeds.map(function (feed) {
                if (feed.writable_by.concat(feed.readable_by).length == 0) {
                    feed.obsolete = true;
                }

                feed = ctrl.addGroupNamesToFeed(feed)

                return feed;
            });
        };

        ctrl.addGroupNamesToFeed = function (feed) {
            feed.readable_names = feed.readable_by
                .map(function (id) {
                    var group = ctrl.groups.find(function (group) {
                        return group.id === id;
                    });
                    return group ? group.name : null;
                })
                .filter(Boolean)
                .join(", ");

            feed.writable_names = feed.writable_by
                .map(function (id) {
                    var group = ctrl.groups.find(function (group) {
                        return group.id === id;
                    });
                    return group ? group.name : null;
                })
                .filter(Boolean)
                .join(", ");

            return feed
        }


        ctrl.findWorkReportsFeature = function () {
            ctrl.workReportFeature = ctrl.features.find(function (feature) { return feature.name == "MHC_WORK_REPORT" })
        }

        ctrl.filterObsolete = function (feed) {
            return ctrl.showObsolete ? true : !feed.obsolete;
        };

        ctrl.markAsObsolete = function (feed) {
            feed.writable_by = []
            feed.readable_by = []
            ctrl.selectedFeed = null
            ctrl.updateFeed(feed);
        };

        ctrl.editFeed = function (feed) {
            if (ctrl.selectedFeed == feed) return ctrl.selectedFeed = null
            ctrl.selectedFeed = feed;
            ctrl.editableRights.readable = {};
            ctrl.editableRights.writable = {};
            ctrl.view = feed.view

            ctrl.groups.forEach(function (group) {
                ctrl.editableRights.readable[group.id] = feed.readable_by.includes(group.id);
                ctrl.editableRights.writable[group.id] = feed.writable_by.includes(group.id);
            });
        };

        ctrl.submit = function () {
            if (!ctrl.selectedFeed) return;

            var newReadableBy = [];
            var newWritableBy = [];

            ctrl.groups.forEach(function (group) {
                if (ctrl.editableRights.readable[group.id]) {
                    newReadableBy.push(group.id);
                }
                if (ctrl.editableRights.writable[group.id]) {
                    newWritableBy.push(group.id);
                    if (!newReadableBy.includes(group.id)) {
                        newReadableBy.push(group.id); // Automatically add to readable
                    }
                }
            });

            ctrl.selectedFeed.readable_by = newReadableBy;
            ctrl.selectedFeed.writable_by = newWritableBy;
            ctrl.selectedFeed.view = ctrl.view

            ctrl.updateFeed(ctrl.selectedFeed);
        };

        ctrl.updateFeed = function (feed) {
            var payload = {
                id: feed.id,
                readable_by: feed.readable_by,
                writable_by: feed.writable_by,
                view: feed.view
            };

            // this is a ui concern only
            if (feed.writable_by.concat(feed.readable_by).length == 0)
                feed.obsolete = true;
            else feed.obsolete = false


            Feed.api.patch({ id: feed.id }, payload).$promise
                .then(function (response) {
                    ctrl.addGroupNamesToFeed(feed)
                    FeedUtils.resetCache();
                })
                .catch(function (error) {
                    console.error("Error updating feed:", error);
                });
        };

        // Sort feeds by feed.view
        ctrl.sortFeedsByView = function () {
            ctrl.feeds.sort(function (a, b) {
                if (a.view.toLowerCase() < b.view.toLowerCase()) return -1;
                if (a.view.toLowerCase() > b.view.toLowerCase()) return 1;
                return 0;
            });
        };

        // Sort groups by group.name
        ctrl.sortGroupsByName = function () {
            ctrl.groups.sort(function (a, b) {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
        };

        ctrl.addFeed = function () {
            var emptyFeed = {
                view: 'nouvelle_vue',
                feature: ctrl.workReportFeature.id
            }

            Feed.api.post({}, emptyFeed).$promise
                .then(function (response) {
                    ctrl.feeds.unshift(response)
                    ctrl.editFeed(response)
                    FeedUtils.resetCache();
                })
                .catch(function (error) {
                    console.error("Error creating feed:", error);
                });
        }

        ctrl.syncWritableWithReadable = function (groupId) {
            if (ctrl.editableRights.writable[groupId]) {
                ctrl.editableRights.readable[groupId] = true;
            }
        };

        ctrl.init();
    }],
});

angular.module('mhclientApp').factory('MiniGed', ["$resource", "MhConfig", function($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader;

    var prepare_request = function(data) {
      var formData = new FormData();
      for (var key in data) {
        if (Array.isArray(data[key])) {
          // If data[key] is an array, iterate over its elements and append each one individually
          for (var i = 0; i < data[key].length; i++) {
              formData.append(key, data[key][i]);
          }
        } else {
          // If data[key] is not an array, append it directly
          formData.append(key, data[key]);
        }
      }
      return formData;
    }

    var resource = $resource("/api_rest/miniged/:id/:route",
    {
       id: '@id',
    },
    {
      'get': {
        headers: {'Accept': acceptHeader}
      },
      'query': {
        headers: {'Accept': acceptHeader},
        isArray: true,
      },
      'delete': {
        headers: {'Accept': acceptHeader},
        method: 'DELETE',
        params: {name: '@id'}
      },
      'get_content': {
        headers: {'Accept': acceptHeader},
        method: 'GET',
        params: {id: '@id', route: 'get_content'},
        responseType: 'arraybuffer',
        transformResponse: function(data) {
          return { data: data };
        }
      },
      save: {
        headers: {'Accept': acceptHeader, 'Content-Type': undefined},
        method: 'POST',
        transformRequest: prepare_request
      },
      update: {
        headers: {'Accept': acceptHeader, 'Content-Type': undefined},
        method: 'PATCH',
        transformRequest: prepare_request
      }
    });
    return resource;
}])

angular.module('mhclientApp').factory('MiniGedCategory', ["$resource", "MhConfig", function($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader;
    return $resource("/api_rest/miniged_category/:id/:route",
    {
       id: '@id',
    },
    {
       'get': {
           headers: {'Accept': acceptHeader}
       },
       'query': {
           headers: {'Accept': acceptHeader},
           isArray: true,
       },
       'save': {
           headers: {'Accept': acceptHeader},
           method: 'POST',
       },
       'update': {
           headers: {'Accept': acceptHeader},
           method: 'PUT',
           params: {name: '@id'}
       }
    }
  );
}])

angular.module('mhclientApp').factory('Bills', ["$resource", "MhConfig", function($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader;
    return $resource("/api_rest/bills/:id/:route",
    {
       id: '@id',
    },
    {
       'get': {
           headers: {'Accept': acceptHeader}
       },
       'query': {
           headers: {'Accept': acceptHeader},
           isArray: true,
        },
        'get_content': {
            headers: {'Accept': acceptHeader},
            method: 'GET',
            params: {id: '@id', route: 'get_content'},
            responseType: 'arraybuffer',
            transformResponse: function(data) {
              return { data: data };
            }
        },
        'get_pdf': {
            headers: {'Accept': acceptHeader},
            method: 'GET',
            params: {id: '@id', route: 'get_pdf'},
            responseType: 'arraybuffer',
            transformResponse: function(data) {
              return { data: data };
            }
        }
    }
  );
}])

angular.module('mhclientApp').factory('ReleaseNotes', ["$resource", "MhConfig", function($resource, MhConfig) {
  var acceptHeader = MhConfig.baseAcceptHeader;
  return $resource("/api_rest/release_notes/:id/:route",
  {
     id: '@id',
  },
  {
     'get': {
        headers: {'Accept': acceptHeader},
        method: 'GET',
        params: {id: '@id'},
        responseType: 'arraybuffer',
        transformResponse: function(data) {
          return { data: data };
        }
     },
     'query': {
        headers: {'Accept': acceptHeader},
        isArray: false,
      },
  }
);
}])
'use strict';

angular.module('mhclientApp')
  .component('miniged', {
    templateUrl: 'miniged/views/miniged.html',
    controller: ["$q", "$rootScope", "$sce", "$stateParams", "$filter", "GroupUtils", "MiniGed", "MiniGedCategory", "UserUtils", "$uibModal", function($q, $rootScope, $sce, $stateParams, $filter, GroupUtils, MiniGed, MiniGedCategory, UserUtils, $uibModal) {
      var ctrl = this;
      ctrl.categories = [];
      ctrl.mydocs = [];
      ctrl.shareddocs = [];
      ctrl.can_admin = !!($rootScope.user.is_superuser || $rootScope.user.group.features.indexOf("ADMIN_GED") != -1);
      ctrl.admin = !!($stateParams.admin && ctrl.can_admin);
      ctrl.selectedPDF = {};
      ctrl.pdfcache = {};
      ctrl.users = [];
      ctrl.authorFilter = [];
      ctrl.categoriesFilter = [];
      ctrl.orderByFields = ['-modified', '+categoryOrder', '+label']
      ctrl.orderByFieldsAuthor = ['-modified', '+categoryOrder', '+authorName', '+label']

      ctrl.showAuthors = ctrl.admin;
      ctrl.groupState = {
        myDocs: true,
        sharedDocs: true
      };

      ctrl.canAdminDoc = function(doc) {
        return ($rootScope.user.entity == null || ctrl.usersById[doc.author].entity == $rootScope.user.entity)
      }

      ctrl.findGroupById = function(groupId) {
        var group = ctrl.groups.find(function(group) {
          return group.id === groupId;
        });
        return group ? group.name : 'Unknown Group';
      };

      ctrl.switchAdmin = function () {
        ctrl.admin = ctrl.can_admin && !ctrl.admin;
        ctrl.showAuthors = ctrl.admin;
      }

      ctrl.fieldOrderGlyph = function (field) {
        var fields = (ctrl.showAuthors) ? ctrl.orderByFieldsAuthor : ctrl.orderByFields;
        if (fields[0].indexOf(field) == 1) {
          return fields[0][0];
        }
        return false;
      }

      ctrl.toggleOrder = function (field) {
        var toggleOrderArray = function (field, array) {
          var fieldIndex = Math.max(array.indexOf('-' + field), array.indexOf('+' + field));
          if (fieldIndex == 0) { // Change reverse sign
            array[0] = array[0].startsWith('+') ? '-' + field : '+' + field;
          } else if (fieldIndex > 0) { // Move to first
            array.unshift(array.splice(fieldIndex, 1)[0]);
          }
        }
        toggleOrderArray(field, ctrl.orderByFields);
        toggleOrderArray(field, ctrl.orderByFieldsAuthor);
      }

      ctrl.sharedTxt = function (doc) {
        var result = "<div>" + $filter('translate')('SHARED_TXT') + "<ul>";
        var groups = _.map(_.filter(ctrl.groups, function (group) {
          return _.includes(doc.shared_with_groups, group.id)
        }), "name").sort();
        return $sce.trustAsHtml(result + (_.map(groups, function (g) { return "<li>" + g + "</li>" }).join("\n")) + "</ul></div>")
      }

      ctrl.toggleGroup = function (group) {
        ctrl.groupState[group] = !ctrl.groupState[group];
      };

      ctrl.getPDFs = function () {
        MiniGed.query().$promise.then(function (doc) {
          ctrl.allDocuments = doc;
          for (var i = 0; i < ctrl.allDocuments.length; i++) {
            ctrl.allDocuments[i].authorName = ctrl.usersById[ctrl.allDocuments[i].author].full_name;
            ctrl.allDocuments[i].categoryLabel = ctrl.categoriesById[ctrl.allDocuments[i].category].label;
            ctrl.allDocuments[i].categoryOrder = ctrl.categoriesById[ctrl.allDocuments[i].category].order;
          }
        });
      };

      ctrl.openCategoryModal = function () {
        var modalInstance = $uibModal.open({
          templateUrl: 'miniged/views/category-modal.html',
          controller: 'CategoryModalCtrl as ctrl',
          resolve: {
            categories: function () { return ctrl.categories; }
          }
        });

        modalInstance.result.then(function () {
          MiniGedCategory.query().$promise.then(function (categories) {
            ctrl.categories = categories;
            ctrl.categoriesById = _.keyBy(ctrl.categories, 'id');
          });
        });
      };

      ctrl.openUploadModal = function () {
        var modalInstance = $uibModal.open({
          templateUrl: 'miniged/views/upload-modal.html',
          controller: 'UploadModalCtrl as ctrl',
          resolve: {
            categories: function () { return ctrl.categories; },
            groups: function () { return ctrl.groups; },
            editionMode: function () { return false; },
            admin: function () { return ctrl.admin; },
            document: function () { return null; }
          }
        });

        modalInstance.result.then(function () {
          ctrl.getPDFs();
        });
      };

      ctrl.openEditModal = function (document) {
        var modalInstance = $uibModal.open({
          templateUrl: 'miniged/views/upload-modal.html',
          controller: 'UploadModalCtrl as ctrl',
          resolve: {
            categories: function () { return ctrl.categories; },
            groups: function () { return ctrl.groups; },
            editionMode: function () { return true; },
            admin: function () { return ctrl.admin; },
            document: function () { return document; }
          }
        });

        modalInstance.result.then(function () {
          ctrl.getPDFs();
          delete ctrl.pdfcache[document.id];
        });
      };

      ctrl.toggleLock = function (document) {
        MiniGed.update({ id: document.id, locked: !document.locked }).$promise.then(function (ndocument) {
          document.locked = ndocument.locked
        })
      };

      ctrl.selectedPDF = null;

      ctrl.loadPDF = function (pdf) {
        if (ctrl.selectedPDF && ctrl.selectedPDF.id == pdf.id) {
          // toggle off
          ctrl.selectedPDF = {};
          return;
        }
        if (ctrl.pdfcache[pdf.id]) {
          ctrl.selectedPDF = ctrl.pdfcache[pdf.id];
        } else {
          MiniGed.get_content({ id: pdf.id }, { responseType: 'arraybuffer' }).$promise
            .then(function (response) {
              // Create a Blob object from the PDF data
              var blob = new Blob([response.data], { type: 'application/pdf' });

              // Create an object URL for the Blob
              var url = $sce.trustAsResourceUrl(URL.createObjectURL(blob));

              // Set the object URL as the source for the <iframe>
              ctrl.selectedPDF = ctrl.pdfcache[pdf.id] = { id: pdf.id, url: url };
            });
        }
      };

      ctrl.edit = function (document) {
        ctrl.openEditModal(document);
      };

      ctrl.delete = function (document) {
        MiniGed.delete({ id: document.id }).$promise.then(function () {
          ctrl.getPDFs();
        })
      };

      ctrl.init = function () {
        $rootScope.busy = true;
        var promises = [
          UserUtils.getUsers(),
          GroupUtils.getAllGroups(),
          MiniGedCategory.query().$promise
        ];
        $q.all(promises).then(function(result) {
          var users = result[0];
          var groups = result[1];
          var categories = result[2];
          ctrl.users = users;
          ctrl.usersById = _.keyBy(ctrl.users, 'id');
          ctrl.groups = groups;
          ctrl.categories = categories;
          ctrl.categoriesById = _.keyBy(ctrl.categories, 'id');
          ctrl.getPDFs();
          $rootScope.busy = false;
        })
      };

      ctrl.init();
    }]
  })

  .controller('UploadModalCtrl', ["$uibModalInstance", "$document", "MiniGed", "categories", "groups", "editionMode", "admin", "document", function ($uibModalInstance, $document, MiniGed, categories, groups, editionMode, admin, document) {
    var ctrl = this;
    ctrl.categories = categories;
    ctrl.groups = groups;
    ctrl.admin = admin;
    ctrl.editionMode = editionMode;
    if (ctrl.editionMode) {
      ctrl.file = null;
      ctrl.document = document;
    } else {
      ctrl.file = null;
      var category = _.find(ctrl.categories, { active: true, is_default: true });
      ctrl.document = {
        category: (category) ? category.id : null,
        label: '',
      }
      if (ctrl.admin) {
        ctrl.document.shared_with_groups = [];
      }
    }

    ctrl.categories = _.filter(ctrl.categories, function (cat) {
      return cat.active || cat.id == ctrl.document.category;
    })

    // The popover is manually showed by newFileSelected and any click should hide it.
    $document.on('click', function (ev) { $('.popover').each(function () { $(this).popover('hide'); }) });

    ctrl.newFileSelected = function () {
      if (ctrl.file) {
        if (ctrl.file.size === 0 || ctrl.file.name.slice(-4) != ".pdf") {
          $('[data-toggle="popover"]').popover('show');
          ctrl.file = null;
          return;
        }
        var filename = ctrl.file.name;
        var filenameWithoutExtension;
        if (filename.includes('.')) {
          filenameWithoutExtension = filename.split('.').slice(0, -1).join('.');
        } else {
          filenameWithoutExtension = filename;
        }
        ctrl.document.label = filenameWithoutExtension.substring(0, 50);
      }
    }

    ctrl.prepareData = function () {
      var data = _.clone(ctrl.document);
      delete data.file;
      if (ctrl.file) {
        data.file = ctrl.file;
      }
      return data;
    }

    ctrl.upload = function () {
      MiniGed.save(ctrl.prepareData()).$promise.then(
        function () {
          $uibModalInstance.close();
        });
    };

    ctrl.update = function () {
      MiniGed.update(ctrl.prepareData()).$promise.then(
        function () {
          $uibModalInstance.close();
        });
    };

    ctrl.submit = function () {
      if (ctrl.editionMode) {
        ctrl.update();
      } else {
        ctrl.upload();
      }
    }

    ctrl.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }])

  .controller('CategoryModalCtrl', ["$uibModalInstance", "MiniGedCategory", "categories", function ($uibModalInstance, MiniGedCategory, categories) {
    var ctrl = this;
    ctrl.categories = categories;
    ctrl.selectedCategory = '';
    ctrl.category = {
      label: '',
      active: true,
      order: 0,
      is_default: false,
      auto_locked: false
    };

    ctrl.selectCategory = function () {
      if (ctrl.selectedCategory) {
        ctrl.category = _.find(ctrl.categories, { id: ctrl.selectedCategory })
      } else {
        // Clear form fields for new category
        ctrl.category = {
          label: '',
          active: true,
          order: 0,
          is_default: false,
          auto_locked: false
        };
      }
    };

    ctrl.saveCategory = function () {
      var promise;
      if (ctrl.selectedCategory) {
        promise = MiniGedCategory.update(ctrl.category).$promise;
      } else {
        promise = MiniGedCategory.save(ctrl.category).$promise;
      }
      promise.then(function () {
        $uibModalInstance.close();
      })
    };

    ctrl.closeModal = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }])

angular.module('mhclientApp').filter('minigedDocumentFilter', ["$rootScope", function($rootScope) {
  return function(documents, ctrl, mode) {
    return _.filter(documents, function(doc) {
      if (mode === 'author' && doc.author !== $rootScope.user.id) {
        return false;
      }
      if (mode === 'shared' && doc.author === $rootScope.user.id) {
        return false;
      }
      if (!ctrl)
          return true;

      if (ctrl.categoriesFilter.length > 0 && !_.includes(ctrl.categoriesFilter, doc.category)) {
        return false;
      }
      if (ctrl.showAuthors && ctrl.authorFilter.length > 0 && !_.includes(ctrl.authorFilter, doc.author)) {
        return false;
      }
      if (ctrl.dateFrom || ctrl.dateTo) {
        var docDate = new Date(doc.modified);
        if (ctrl.dateFrom && docDate < ctrl.dateFrom) { return false; }
        if (ctrl.dateTo && docDate > ctrl.dateTo) { return false; }
      }
      return true;
    });
  };
}]);
angular.module("mhclientApp").factory("CSVUtils", CSVUtilsController);

function CSVUtilsController(DownloadUtils) {
  function generateCSVContent(data, keys, headerMap) {
    function escapeQuotes(str) {
      if (typeof str === "string") {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    }

    var header = keys
      .map(function (key) {
        return headerMap && headerMap[key]
          ? escapeQuotes(headerMap[key])
          : escapeQuotes(key);
      })
      .join(",");
    var rows = data.map(function (obj) {
      return keys
        .map(function (key) {
          return escapeQuotes(obj[key] || "");
        })
        .join(",");
    });
    return header + "\r\n" + rows.join("\r\n");
  }

  function exportCSV(csvContent, filename) {
    var filename = filename || "export.csv";
    var csvData = "\ufeff" + csvContent;
    var blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");
    var url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  /**
   * Download CSV
   * @param {*} csvContent CSV content to download
   * @param {*} fileName Name of the file downloaded
   */
  function download(csvContent, fileName) {
    var fileName = fileName || "export.csv";
    var csvData = "\ufeff" + csvContent;
    var blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    DownloadUtils.downloadBlob(blob, fileName);
  }

  return {
    download: download,
    exportCSV: exportCSV,
    generateCSVContent: generateCSVContent,
  };
}

'use strict';

angular.module('mhclientApp')
  .component('bills', {
    templateUrl: 'miniged/views/bills.html',
    controller: ["$q", "$rootScope", "$stateParams", "$sce", "$filter", "$scope", "GroupUtils", "UserUtils", "Stay", "Patient", "Bills", "CSVUtils", "BillingService", function ($q, $rootScope, $stateParams, $sce, $filter, $scope, GroupUtils, UserUtils, Stay, Patient, Bills, CSVUtils, BillingService) {
      var ctrl = this;
      ctrl.can_admin = ($rootScope.user.is_superuser || $rootScope.user.group.features.indexOf("BILL_DOCUMENTS") != -1);
      ctrl.admin = ($stateParams.admin) && (ctrl.can_admin);
      ctrl.selectedPDF = {};
      ctrl.pdfcache = {};
      ctrl.groupFilter = [];
      ctrl.caregiversInFilter = [];
      ctrl.authorFilter = [];
      ctrl.caregiverFilter = [];
      ctrl.patientFilter = [];
      ctrl.siretFilter = [];
      ctrl.gte = undefined;
      ctrl.lte = undefined;
      var orderByFields = ['-created', '+patientName', '-start_date', '+newly_due', '+bill_id'];
      var orderByFieldsAuthor = ['-created', '+caregiverGroup', '+caregiverName', '+patientName', '-start_date', '+authorName', '+newly_due', '+bill_id'];

      ctrl.allBills = []

      ctrl.visibleBillsCount = 80
      ctrl.rowPerPage = 20
      ctrl.nextBills = function () {
        if (ctrl.visibleBillsCount >= ctrl.allBills.length) return;

        ctrl.visibleBillsCount = ctrl.visibleBillsCount + ctrl.rowPerPage;
      }

      ctrl.getOrderByFields = function () {
        return (ctrl.admin) ? orderByFieldsAuthor : orderByFields;
      }

      function orderBills(bills) {
        return $filter('orderBy')(bills, ctrl.getOrderByFields());
      }

      ctrl.fieldOrderGlyph = function (field) {
        var fields = ctrl.getOrderByFields();
        if (fields[0].indexOf(field) == 1) {
          return fields[0][0];
        }
        return false;
      };

      ctrl.switchAdmin = function () {
        ctrl.admin = ctrl.can_admin && !ctrl.admin;
      };

      var debouncedOrderBills = _.debounce(function () {
        $scope.$apply(function () {
          ctrl.allBills = orderBills(ctrl.allBills);
        });
      }, 400);

      ctrl.toggleOrder = function (field) {
        var toggleOrderArray = function (field, array) {
          var fieldIndex = Math.max(array.indexOf('-' + field), array.indexOf('+' + field));
          if (fieldIndex == 0) { // Change reverse sign
            array[0] = array[0].startsWith('+') ? '-' + field : '+' + field;
          } else if (fieldIndex > 0) { // Move to first
            array.unshift(array.splice(fieldIndex, 1)[0]);
          }
        };
        toggleOrderArray(field, orderByFields);
        toggleOrderArray(field, orderByFieldsAuthor);

        debouncedOrderBills();
      };

      ctrl.documentFilter = function (doc) {
        if (ctrl.searchText &&
          !(
            (doc.bill_id && doc.bill_id.toString().toLowerCase().includes(ctrl.searchText.toLowerCase())) ||
            (doc.patientName && doc.patientName.toLowerCase().includes(ctrl.searchText.toLowerCase())) ||
            (ctrl.admin && doc.caregiverName && doc.caregiverName.toLowerCase().includes(ctrl.searchText.toLowerCase()))
          )
        ) {
          return false;
        }
        if (typeof ctrl.lte == 'number' && ctrl.lte < doc.newly_due) {
          return false;
        }
        if (typeof ctrl.gte == 'number' && ctrl.gte > doc.newly_due) {
          return false;
        }
        if (ctrl.patientFilter.length > 0 && !_.includes(ctrl.patientFilter, doc.patientId)) {
          return false;
        }
        if (ctrl.admin && ctrl.groupFilter.length > 0 && !_.includes(ctrl.groupFilter, doc.caregiverGroupId)) {
          return false;
        }
        if (ctrl.admin && ctrl.caregiverFilter.length > 0 && !_.includes(ctrl.caregiverFilter, doc.user)) {
          return false;
        }
        if (ctrl.admin && ctrl.authorFilter.length > 0 && !_.includes(ctrl.authorFilter, doc.author)) {
          return false;
        }
        if (ctrl.admin && ctrl.siretFilter.length > 0 && !_.includes(ctrl.siretFilter, doc.caregiverSiret)) {
          return false;
        }
        if (ctrl.dateFrom || ctrl.dateTo) {
          var docDate = new Date(doc.created);
          if (ctrl.dateFrom && docDate < ctrl.dateFrom) {
            return false;
          }
          if (ctrl.dateTo && docDate > ctrl.dateTo) {
            return false;
          }
        }
        if (ctrl.careDateFrom || ctrl.careDateTo) {
          var startDate = new Date(doc.start_date);
          var endDate = new Date(doc.end_date);

          if (ctrl.careDateFrom && endDate < ctrl.careDateFrom) {
            return false;
          }
          if (ctrl.careDateTo && startDate > ctrl.careDateTo) {
            return false;
          }
        }
        return true;
      };

      // TODO:
      // 1. Make stuff work
      // 1.bis Open modal instead of right-side view ?
      // 2. Filters for patient and users should only show possible patient and users.
      // 3. Export PDF
      // 4. Export CSV

      ctrl.groupFilterChange = function () {
        if (ctrl.groupFilter.length == 0) {
          ctrl.caregiversInFilter = ctrl.caregivers;
        } else {
          ctrl.caregiversInFilter = _.filter(ctrl.caregivers, function (cgv) {
            return _.includes(ctrl.groupFilter, cgv.group);
          });
        }
      };

      ctrl.selectedPDF = null;

      ctrl.loadPDF = function (pdf) {
        if (ctrl.selectedPDF && ctrl.selectedPDF.id == pdf.id) {
          // toggle off
          ctrl.selectedPDF = {};
          ctrl.downloadURL = "";
          return;
        }
        if (ctrl.pdfcache[pdf.id]) {
          ctrl.selectedPDF = ctrl.pdfcache[pdf.id];
          ctrl.downloadURL = "/api_rest/bills/" + pdf.id + "/get_pdf";
        } else {
          Bills.get_content({ id: pdf.id }, { responseType: 'arraybuffer' }).$promise
            .then(function (response) {
              // Create a Blob object from the PDF data
              var blob = new Blob([response.data], { type: 'text/html' });

              // Create an object URL for the Blob
              var url = $sce.trustAsResourceUrl(URL.createObjectURL(blob));

              // Set the object URL as the source for the <iframe>
              ctrl.selectedPDF = ctrl.pdfcache[pdf.id] = { id: pdf.id, url: url };
              ctrl.downloadURL = "/api_rest/bills/" + pdf.id + "/get_pdf";
            });
        }
      };


      ctrl.exportCSV = function () {
        // Get filtered and ordered data
        var filteredAndOrderedData = $filter('orderBy')(
          $filter('filter')(ctrl.allBills, ctrl.documentFilter), ctrl.getOrderByFields()
        );


        var keys;
        if (ctrl.admin) {
          keys = ['bill_id', 'created', 'caregiverName', 'caregiverGroup', 'patientName', 'start_date', 'end_date', 'authorName', 'newly_due'];
        } else {
          keys = ['bill_id', 'created', 'patientName', 'start_date', 'end_date', 'newly_due'];
        }

        var headerMap = {
          'bill_id': $filter('translate')("Bill number"),
          'created': $filter('translate')("Creation date"),
          'caregiverGroup': $filter('translate')("GROUP"),
          'caregiverName': $filter('translate')("CAREGIVER"),
          'patientName': $filter('translate')("PATIENT"),
          'start_date': $filter('translate')("CSV_CARE_START_DATE"),
          'end_date': $filter('translate')("CSV_CARE_END_DATE"),
          'authorName': $filter('translate')("AUTHOR"),
          'newly_due': $filter('translate')("Value"),
        };

        // Generate CSV content
        var csvContent = CSVUtils.generateCSVContent(filteredAndOrderedData, keys, headerMap);

        // Export CSV data
        CSVUtils.exportCSV(csvContent);
      };

      ctrl.dailyExport = function () {
        var params = {};
        if (ctrl.careDateFrom) {
          params.start_date = moment(ctrl.careDateFrom).format('YYYY-MM-DD');
        }
        if (ctrl.careDateTo) {
          params.end_date = moment(ctrl.careDateTo).format('YYYY-MM-DD');
        }
        BillingService.dailyExport(params).$promise.then(function (response) {
          CSVUtils.exportCSV(response.data);
        });
      };

      ctrl.init = function () {
        $rootScope.busy = true;
        var promises = [
          UserUtils.getUsers(),
          GroupUtils.getAllGroups(),
          Bills.query().$promise,
          Stay.query().$promise,
          Patient.query().$promise,
        ];
        $q.all(promises).then(function (result) {
          var users = result[0];
          var groups = result[1];
          var bills = result[2];
          var stays = result[3];
          var patients = result[4];


          ctrl.allBills = orderBills(bills);
          ctrl.usersById = _.keyBy(users, 'id');
          ctrl.staysById = _.keyBy(stays, 'id');
          ctrl.patientsById = _.keyBy(patients, 'id');
          ctrl.groupsById = _.keyBy(groups, 'id');

          ctrl.caregiversIds = _.uniq(_.map(bills, 'user'));
          ctrl.caregivers = _.map(ctrl.caregiversIds, function (id) {
            return {
              id: id,
              group: (ctrl.usersById[id] ? ctrl.usersById[id].group.id : null),
              full_name: (ctrl.usersById[id] ? ctrl.usersById[id].full_name : id),
            };
          });
          ctrl.caregiversInFilter = ctrl.caregivers;
          ctrl.caregiversGroupIds = _.uniq(_.map(ctrl.caregivers, 'group'));
          ctrl.caregiversGroups = _.map(ctrl.caregiversGroupIds, function (id) {
            return {
              id: id,
              name: (id == null) ? "UNKNOWN" : (ctrl.groupsById[id]) ? ctrl.groupsById[id].name : id,
            };
          });

          ctrl.authorsIds = _.uniq(_.map(bills, 'author'));
          ctrl.authors = _.map(ctrl.authorsIds, function (id) {
            return {
              id: id,
              full_name: (ctrl.usersById[id] ? ctrl.usersById[id].full_name : id),
            };
          });
          ctrl.stayIds = _.uniq(_.map(bills, 'stay'));
          ctrl.stayToPatient = {};
          ctrl.patients = [];
          _.forEach(ctrl.stayIds, function (stay_id) {
            if (ctrl.stayToPatient[stay_id] == null) {
              if (ctrl.staysById[stay_id] && ctrl.staysById[stay_id].patient && ctrl.patientsById[ctrl.staysById[stay_id].patient]) {
                ctrl.stayToPatient[stay_id] = { id: ctrl.staysById[stay_id].patient, full_name: ctrl.patientsById[ctrl.staysById[stay_id].patient].full_name };
                ctrl.patients.push(ctrl.stayToPatient[stay_id]);
              } else {
                ctrl.stayToPatient[stay_id] = { id: "STAY-" + stay_id, full_name: "Unknown (Stay " + stay_id + ")" };
                ctrl.patients.push(ctrl.stayToPatient[stay_id]);
              }
            }
          });

          _.forEach(ctrl.allBills, function (doc) {
            doc.bill_id = (doc.bill_id == null) ? doc.id : doc.bill_id;
            doc.caregiverName = ctrl.usersById[doc.user] ? ctrl.usersById[doc.user].full_name : doc.user;
            doc.caregiverGroupId = ctrl.usersById[doc.user] ? (ctrl.usersById[doc.user].group.id) : null;
            doc.caregiverGroup = (doc.caregiverGroupId == null) ? "UNKNOWN" : (ctrl.groupsById[doc.caregiverGroupId]) ? ctrl.groupsById[doc.caregiverGroupId].name : doc.caregiverGroupId;
            doc.caregiverSiret = ctrl.usersById[doc.user] ? $filter("formatSiret")(ctrl.usersById[doc.user].user_profile.data.siret) : null;
            doc.authorName = ctrl.usersById[doc.author] ? ctrl.usersById[doc.author].full_name : doc.author;
            doc.patientId = ctrl.stayToPatient[doc.stay].id;
            doc.patientName = ctrl.stayToPatient[doc.stay].full_name;
          });

          $rootScope.busy = false;
        });
      };

      ctrl.init();
    }],
  });

'use strict';

angular.module('mhclientApp')
  .component('myMissions', {
    templateUrl: 'miniged/views/my-missions.html',
    controller: ["$q", "$timeout", "$rootScope", "UserUtils", "Stay", "Patient", "MissionLetter", "CSVUtils", "SiteVarsUtils", "$filter", "BillingUnitUtils", function($q, $timeout, $rootScope, UserUtils, Stay, Patient, MissionLetter, CSVUtils, SiteVarsUtils, $filter, BillingUnitUtils) {
      var ctrl = this;
      ctrl.selectedPDF = {};
      ctrl.authorFilter = [];
      ctrl.patientFilter = [];
      ctrl.orderByFields = ['-created', '+patientName', '+authorName'];
      ctrl.archived = false;

      ctrl.fieldOrderGlyph = function (field) {
        var fields = ctrl.orderByFields;
        if (fields[0].indexOf(field) == 1) {
          return fields[0][0];
        }
        return false;
      }

      ctrl.toggleOrder = function (field) {
        var toggleOrderArray = function (field, array) {
          var fieldIndex = Math.max(array.indexOf('-' + field), array.indexOf('+' + field));
          if (fieldIndex == 0) { // Change reverse sign
            array[0] = array[0].startsWith('+') ? '-' + field : '+' + field;
          } else if (fieldIndex > 0) { // Move to first
            array.unshift(array.splice(fieldIndex, 1)[0]);
          }
        }
        toggleOrderArray(field, ctrl.orderByFields);
      }

      ctrl.documentFilter = function (doc) {
        if (ctrl.patientFilter.length > 0 && !_.includes(ctrl.patientFilter, doc.patientId)) {
          return false;
        }
        if (ctrl.authorFilter.length > 0 && !_.includes(ctrl.authorFilter, doc.author)) {
          return false;
        }
        if (!ctrl.archived && doc.archived) {
          return false;
        }
        if (ctrl.dateFrom || ctrl.dateTo) {
          var docDate = new Date(doc.created);
          if (ctrl.dateFrom && docDate < ctrl.dateFrom) { return false; }
          if (ctrl.dateTo && docDate > ctrl.dateTo) { return false; }
        }
        return true;
      }

      ctrl.selectedPDF = null;

      ctrl.loadPDF = function (pdf) {
        if (ctrl.selectedPDF && ctrl.selectedPDF.id == pdf.id) {
          // toggle off
          ctrl.selectedPDF = {};
          ctrl.downloadURL = "";
          return;
        }
        ctrl.selectedPDF = pdf;
        ctrl.downloadURL = "/webfw/documents_mgr/stay_" + pdf.stay + "/mhc_mission_letter/to_pdf/" + pdf.id
        ctrl.reloadComponent = true;
        $timeout(function() {ctrl.reloadComponent = false}, 0); // Schedule a re-render after digest cycle
      };

      ctrl.exportCSV = function () {
        // Get filtered and ordered data
        var filteredAndOrderedData = $filter('orderBy')(
          $filter('filter')(ctrl.allDocuments, ctrl.documentFilter), ctrl.orderByFields
        );

        var keys = ['id', 'created', 'patientName', 'authorName', 'archived'];

        var headerMap = {
          'id': $filter('translate')("id"),
          'created': $filter('translate')("Creation date"),
          'patientName': $filter('translate')("PATIENT"),
          'authorName': $filter('translate')("AUTHOR"),
          'archived': $filter('translate')("ARCHIVED")
        }

        // Generate CSV content
        var csvContent = CSVUtils.generateCSVContent(filteredAndOrderedData, keys, headerMap);

        // Export CSV data
        CSVUtils.exportCSV(csvContent);
      };

      ctrl.init = function () {
        $rootScope.busy = true;
        var promises = [
          BillingUnitUtils.getCareBillingUnits().then(function (billing_units) {
            ctrl.careBu = _.keyBy(billing_units, 'id')
          }),
          SiteVarsUtils.get("DISPLAY_COTATION_IN_MISSION_LETTER").then(function (display_cotation) {
            ctrl.showCotation = display_cotation.value
          }),
          UserUtils.getUsers(true).then(function (users) {
            ctrl.usersById = _.keyBy(users, 'id')
          }),
          Patient.query().$promise.then(function (patients) {
            ctrl.patientsById = _.keyBy(patients, 'id');
          }),
          Stay.query().$promise.then(function (stays) {
            ctrl.staysById = _.keyBy(stays, 'id');
          }),
          MissionLetter.api.query({user_involved: $rootScope.user.username}).$promise.then(function (docs) {
            ctrl.allDocuments = docs;
          })
        ];

        $q.all(promises).then(function() {
          ctrl.authorsIds = _.uniq(_.map(ctrl.allDocuments, 'author'));
          ctrl.authors = _.map(ctrl.authorsIds, function (id) {
            return {
              id: id,
              full_name: (ctrl.usersById[id] ? ctrl.usersById[id].full_name : id)
            }
          })
          ctrl.stayIds = _.uniq(_.map(ctrl.allDocuments, 'stay'));
          ctrl.stayToPatient = {}
          ctrl.patients = []
          _.forEach(ctrl.stayIds, function (stay_id) {
            if (ctrl.stayToPatient[stay_id] == null) {
              if (ctrl.staysById[stay_id] && ctrl.staysById[stay_id].patient && ctrl.patientsById[ctrl.staysById[stay_id].patient]) {
                ctrl.stayToPatient[stay_id] = { id: ctrl.staysById[stay_id].patient, full_name: ctrl.patientsById[ctrl.staysById[stay_id].patient].full_name };
                ctrl.patients.push(ctrl.stayToPatient[stay_id]);
              } else {
                ctrl.stayToPatient[stay_id] = { id: "STAY-" + stay_id, full_name: "Unknown (Stay " + stay_id + ")" };
                ctrl.patients.push(ctrl.stayToPatient[stay_id]);
              }
            }
          })

          _.forEach(ctrl.allDocuments, function (doc) {
            doc.authorName = ctrl.usersById[doc.author] ? ctrl.usersById[doc.author].full_name : (doc.author_full_name ? doc.author_full_name : doc.author);
            doc.patientId = ctrl.stayToPatient[doc.stay].id;
            doc.patientName = ctrl.stayToPatient[doc.stay].full_name;
          });
          $rootScope.busy = false;
        });
      }

      ctrl.init();
    }]
  })

'use strict';

angular.module('mhclientApp')
  .component('releaseNotes', {
    templateUrl: 'miniged/views/release-notes.html',
    controller: ["$rootScope", "$sce", "ReleaseNotes", function($rootScope, $sce, ReleaseNotes) {
      var ctrl = this;
      ctrl.category = "all";
      ctrl.searchText = "";
      ctrl.selectedPDF = {};
      ctrl.pdfcache = {};

      ctrl.current_version = null;
      ctrl.last_release = null;
      ctrl.future_releases = [];
      ctrl.past_releases = [];

      ctrl.loadPDF = function (version) {
        if (ctrl.selectedPDF && ctrl.selectedPDF.id == version) {
          // toggle off
          ctrl.selectedPDF = {};
          return;
        }
        if (ctrl.pdfcache[version]) {
          ctrl.selectedPDF = ctrl.pdfcache[version];
        } else {
          ReleaseNotes.get({ id: version }, { responseType: 'arraybuffer' }).$promise
            .then(function (response) {
              // Create a Blob object from the PDF data
              var blob = new Blob([response.data], { type: 'application/pdf' });

              // Create an object URL for the Blob
              var url = $sce.trustAsResourceUrl(URL.createObjectURL(blob));

              // Set the object URL as the source for the <iframe>
              ctrl.selectedPDF = ctrl.pdfcache[version] = { id: version, url: url };
            });
        }
      };

      ctrl.init = function () {
        $rootScope.busy = true;
        ReleaseNotes.query().$promise.then(function(result) {
          ctrl.current_version = result["current_version"]
          ctrl.past_releases = result["available_past"]
          ctrl.future_releases = result["available_future"]

          if (ctrl.past_releases.length > 0) {
            ctrl.last_release = ctrl.past_releases.shift();
          }
          $rootScope.busy = false;
        })
      };

      ctrl.init();
    }]
  })


angular.module("mhclientApp").component("interfaceInterop", {
  templateUrl: "interface-interop/views/interface-interop.html",
  controller: ["InterfaceInteropService", "$filter", function interop(InterfaceInteropService, $filter) {
    var ctrl = this;
    ctrl.title = 'interop-interface-plugin';
    ctrl.channels = [];
    ctrl.messages = [];
    ctrl.totalPages = 1;
    ctrl.startId = 1;
    ctrl.currentChannelName = '';
    ctrl.isLoading = false;
    ctrl.replayingMessageId = null

    // filters
    ctrl.perPage = 10;
    ctrl.startDate = '';
    ctrl.endDate = '';
    ctrl.startTime = '';
    ctrl.endTime = '';
    ctrl.textSearch = '';
    ctrl.regexTextSearch = '';

    ctrl.init = function () {
      InterfaceInteropService.getChannels().$promise.then(function (channels) {
        ctrl.channels = channels;
        if (ctrl.channels.length > 0) {
          ctrl.currentChannelName = ctrl.channels[0].name;
          ctrl.getChannelData();
        }
      });
    };

    ctrl.combineDateTime = function (date, time) {
      if (date) {
        var dateObj = new Date(date);

        if (time) {
          // weirdly, the time is also a date format
          var hours = time.getHours()
          var minutes = time.getMinutes()
          dateObj.setHours(hours);
          dateObj.setMinutes(minutes);
        } else {
          // If no time is provided, set to midnight
          dateObj.setHours(0, 0, 0, 0);
        }

        return dateObj.toISOString().slice(0, -1);
      }
      return '';
    }

    ctrl.getChannelData = function (pageHasChanged) {
      if (!ctrl.currentChannelName) return;
      if (!pageHasChanged) {
        ctrl.startId = ''
        ctrl.messages = []
      };
      ctrl.isLoading = true;

      InterfaceInteropService.getChannelData({
        channelName: ctrl.currentChannelName,
        start_id: ctrl.startId,
        count: ctrl.perPage,
        start_dt: ctrl.combineDateTime(ctrl.startDate, ctrl.startTime),
        end_dt: ctrl.combineDateTime(ctrl.endDate, ctrl.endTime),
        text: ctrl.textSearch,
        rtext: ctrl.regexTextSearch,
      }).$promise.then(function (result) {
        ctrl.messages = ctrl.messages.concat(result.messages);
        ctrl.isLoading = false;
      });
    };

    ctrl.onChannelSelect = function (channelName) {
      if (!channelName) return;
      ctrl.currentChannelName = channelName;
      ctrl.getChannelData();
    };

    ctrl.nextPage = function () {
      ctrl.startId = ctrl.messages[ctrl.messages.length - 1].id;
      ctrl.getChannelData(true);
    };

    ctrl.applyFilters = function () {
      ctrl.getChannelData();
    };

    ctrl.clearFilters = function () {
      ctrl.regexTextSearch = ''
      ctrl.textSearch = ''
      ctrl.endDate = ''
      ctrl.startDate = ''
      ctrl.endTime = ''
      ctrl.startTime = ''
      ctrl.getChannelData();
    }

    ctrl.onPerPageSelect = function () {
      ctrl.getChannelData()
    }

    ctrl.startChannel = function () {
      InterfaceInteropService.startChannel({ channelName: ctrl.currentChannelName }).$promise.then(function () {
        InterfaceInteropService.getChannels().$promise.then(function (channels) {
          ctrl.channels = channels;
        })
      });
    }

    ctrl.stopChannel = function () {
      InterfaceInteropService.stopChannel({ channelName: ctrl.currentChannelName }).$promise.then(function () {
        InterfaceInteropService.getChannels().$promise.then(function (channels) {
          ctrl.channels = channels;
        })
      });
    }

    ctrl.replayMessage = function (messageId) {
      ctrl.replayingMessageId = messageId
      InterfaceInteropService.replayMessage({ channelName: ctrl.currentChannelName, messageId: messageId }).$promise.then(function () {
        ctrl.replayingMessageId = null
      });
    }

    ctrl.replayMessages = function (messages) {
      messages.forEach(function (message) {
        ctrl.replayMessage(message.id)
      })
    }

    ctrl.previewMessage = function (messageId) {
      InterfaceInteropService.previewMessage({ channelName: ctrl.currentChannelName, messageId: messageId }).$promise.then(function (result) {
        ctrl.messageToPreview = result
        ctrl.openModal()
      });
    }

    ctrl.checkEnterKey = function (event) {
      if (event.which === 13) { // 13 is the Enter key code
        ctrl.applyFilters();
      }
    };

    ctrl.enforceMinMax = function () {
      if (ctrl.currentPage < 1) {
        ctrl.currentPage = 1;
      } else if (ctrl.currentPage > ctrl.totalPages) {
        ctrl.currentPage = ctrl.totalPages;
      }
    };

    ctrl.openModal = function () {
      var dialog = document.querySelector("dialog");
      dialog.showModal();
    }

    ctrl.closeModal = function () {
      var dialog = document.querySelector("dialog");
      dialog.close();
    }

    // Initialize the controller
    ctrl.init();
  }]
});


angular.module('mhclientApp').filter('interopValuesFormat', ["$filter", function ($filter) {
  return function (value, key) {
    switch (key) {
      case 'timestamp':
        var date = new Date(value)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
      case 'state':
        return $filter('translate')("INTEROP_" + value.toUpperCase())
      default:
        return value;
    }
  };
}]);

'use strict';

angular.module('mhclientApp').factory('InterfaceInteropService', ["$resource", "MhConfig", function ($resource, MhConfig) {
    var acceptHeader = MhConfig.baseAcceptHeader + ";version=v2";

    return $resource('/api_rest/pypeman/debug/channels/:channelName/:action', {
        start_dt:'@start_dt',
        end_dt:'@end_dt',
        count:'@count',
        start:'@start'
    }, {
        getChannels: {
            headers: { 'Accept': 'application/json' },
            method: 'GET',
            interceptor: {
                response: function (response) {
                    return JSON.parse(response.data)
                }
            }
        },

        getChannelData: {
            headers: { 'Accept': 'application/json' },
            method: 'GET',
            params: { action:"messages",  channelName: '@channelName' },
            interceptor: {
                response: function (response) {
                    return JSON.parse(response.data)
                }
            }
        },

        startChannel: {
            headers: { 'Accept': acceptHeader },
            method: 'GET',
            params: { action:"start",  channelName: '@channelName' },
            interceptor: {
                response: function (response) {
                    return JSON.parse(response.data)
                }
            }
        },

        stopChannel: {
            headers: { 'Accept': acceptHeader },
            method: 'GET',
            params: { action:"stop",  channelName: '@channelName' },
            interceptor: {
                response: function (response) {
                    return JSON.parse(response.data)
                }
            }
        },
        
        replayMessage: {
            headers: { 'Accept': acceptHeader },
            method: 'GET',
            params: { channelName: '@channelName', messageId: '@messageId' },
            interceptor: {
                response: function (response) {
                    return JSON.parse(response.data)
                }
            },
            url: '/api_rest/pypeman/debug/channels/:channelName/messages/:messageId/replay'
        },

        previewMessage: {
            headers: { 'Accept': acceptHeader },
            method: 'GET',
            params: { channelName: '@channelName', messageId: '@messageId' },
            interceptor: {
                response: function (response) {
                    return JSON.parse(response.data)
                }
            },
            url: '/api_rest/pypeman/debug/channels/:channelName/messages/:messageId/preview'
        },
    });
}]);

